var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["vendor"], {
        /***/ "./node_modules/@angular/animations/fesm2015/animations.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/@angular/animations/fesm2015/animations.js ***!
          \*****************************************************************/
        /*! exports provided: AnimationBuilder, AnimationFactory, AUTO_STYLE, animate, animateChild, animation, group, keyframes, query, sequence, stagger, state, style, transition, trigger, useAnimation, NoopAnimationPlayer, ɵAnimationGroupPlayer, ɵPRE_STYLE */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationBuilder", function () { return AnimationBuilder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationFactory", function () { return AnimationFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_STYLE", function () { return AUTO_STYLE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animate", function () { return animate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateChild", function () { return animateChild; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animation", function () { return animation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "group", function () { return group; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function () { return keyframes; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "query", function () { return query; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequence", function () { return sequence; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stagger", function () { return stagger; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function () { return state; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "style", function () { return style; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function () { return transition; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function () { return trigger; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useAnimation", function () { return useAnimation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoopAnimationPlayer", function () { return NoopAnimationPlayer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationGroupPlayer", function () { return AnimationGroupPlayer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPRE_STYLE", function () { return ɵPRE_STYLE; });
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An injectable service that produces an animation sequence programmatically within an
             * Angular component or directive.
             * Provided by the `BrowserAnimationsModule` or `NoopAnimationsModule`.
             *
             * \@usageNotes
             *
             * To use this service, add it to your component or directive as a dependency.
             * The service is instantiated along with your component.
             *
             * Apps do not typically need to create their own animation players, but if you
             * do need to, follow these steps:
             *
             * 1. Use the `build()` method to create a programmatic animation using the
             * `animate()` function. The method returns an `AnimationFactory` instance.
             *
             * 2. Use the factory object to create an `AnimationPlayer` and attach it to a DOM element.
             *
             * 3. Use the player object to control the animation programmatically.
             *
             * For example:
             *
             * ```ts
             * // import the service from BrowserAnimationsModule
             * import {AnimationBuilder} from '\@angular/animations';
             * // require the service as a dependency
             * class MyCmp {
             *   constructor(private _builder: AnimationBuilder) {}
             *
             *   makeAnimation(element: any) {
             *     // first define a reusable animation
             *     const myAnimation = this._builder.build([
             *       style({ width: 0 }),
             *       animate(1000, style({ width: '100px' }))
             *     ]);
             *
             *     // use the returned factory object to create a player
             *     const player = myAnimation.create(element);
             *
             *     player.play();
             *   }
             * }
             * ```
             *
             * \@publicApi
             * @abstract
             */
            var AnimationBuilder = /** @class */ (function () {
                function AnimationBuilder() {
                }
                return AnimationBuilder;
            }());
            if (false) { }
            /**
             * A factory object returned from the `AnimationBuilder`.`build()` method.
             *
             * \@publicApi
             * @abstract
             */
            var AnimationFactory = /** @class */ (function () {
                function AnimationFactory() {
                }
                return AnimationFactory;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Represents a set of CSS styles for use in an animation style.
             * @record
             */
            function ɵStyleData() { }
            /** @enum {number} */
            var AnimationMetadataType = {
                /**
                 * Associates a named animation state with a set of CSS styles.
                 * See `state()`
                 */
                State: 0,
                /**
                 * Data for a transition from one animation state to another.
                 * See `transition()`
                 */
                Transition: 1,
                /**
                 * Contains a set of animation steps.
                 * See `sequence()`
                 */
                Sequence: 2,
                /**
                 * Contains a set of animation steps.
                 * See `{@link animations/group group()}`
                 */
                Group: 3,
                /**
                 * Contains an animation step.
                 * See `animate()`
                 */
                Animate: 4,
                /**
                 * Contains a set of animation steps.
                 * See `keyframes()`
                 */
                Keyframes: 5,
                /**
                 * Contains a set of CSS property-value pairs into a named style.
                 * See `style()`
                 */
                Style: 6,
                /**
                 * Associates an animation with an entry trigger that can be attached to an element.
                 * See `trigger()`
                 */
                Trigger: 7,
                /**
                 * Contains a re-usable animation.
                 * See `animation()`
                 */
                Reference: 8,
                /**
                 * Contains data to use in executing child animations returned by a query.
                 * See `animateChild()`
                 */
                AnimateChild: 9,
                /**
                 * Contains animation parameters for a re-usable animation.
                 * See `useAnimation()`
                 */
                AnimateRef: 10,
                /**
                 * Contains child-animation query data.
                 * See `query()`
                 */
                Query: 11,
                /**
                 * Contains data for staggering an animation sequence.
                 * See `stagger()`
                 */
                Stagger: 12,
            };
            /**
             * Specifies automatic styling.
             *
             * \@publicApi
             * @type {?}
             */
            var AUTO_STYLE = '*';
            /**
             * Base for animation data structures.
             *
             * \@publicApi
             * @record
             */
            function AnimationMetadata() { }
            if (false) { }
            /**
             * Contains an animation trigger. Instantiated and returned by the
             * `trigger()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationTriggerMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation state by associating a state name with a set of CSS styles.
             * Instantiated and returned by the `state()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationStateMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation transition. Instantiated and returned by the
             * `transition()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationTransitionMetadata() { }
            if (false) { }
            /**
             * Encapsulates a reusable animation, which is a collection of individual animation steps.
             * Instantiated and returned by the `animation()` function, and
             * passed to the `useAnimation()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationReferenceMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation query. Instantiated and returned by
             * the `query()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationQueryMetadata() { }
            if (false) { }
            /**
             * Encapsulates a keyframes sequence. Instantiated and returned by
             * the `keyframes()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationKeyframesSequenceMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation style. Instantiated and returned by
             * the `style()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationStyleMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation step. Instantiated and returned by
             * the `animate()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationAnimateMetadata() { }
            if (false) { }
            /**
             * Encapsulates a child animation, that can be run explicitly when the parent is run.
             * Instantiated and returned by the `animateChild` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationAnimateChildMetadata() { }
            if (false) { }
            /**
             * Encapsulates a reusable animation.
             * Instantiated and returned by the `useAnimation()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationAnimateRefMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation sequence.
             * Instantiated and returned by the `sequence()` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationSequenceMetadata() { }
            if (false) { }
            /**
             * Encapsulates an animation group.
             * Instantiated and returned by the `{\@link animations/group group()}` function.
             *
             * \@publicApi
             * @record
             */
            function AnimationGroupMetadata() { }
            if (false) { }
            /**
             * Encapsulates parameters for staggering the start times of a set of animation steps.
             * Instantiated and returned by the `stagger()` function.
             *
             * \@publicApi
             *
             * @record
             */
            function AnimationStaggerMetadata() { }
            if (false) { }
            /**
             * Creates a named animation trigger, containing a  list of `state()`
             * and `transition()` entries to be evaluated when the expression
             * bound to the trigger changes.
             *
             * \@usageNotes
             * Define an animation trigger in the `animations` section of `\@Component` metadata.
             * In the template, reference the trigger by name and bind it to a trigger expression that
             * evaluates to a defined animation state, using the following format:
             *
             * `[\@triggerName]="expression"`
             *
             * Animation trigger bindings convert all values to strings, and then match the
             * previous and current values against any linked transitions.
             * Booleans can be specified as `1` or `true` and `0` or `false`.
             *
             * ### Usage Example
             *
             * The following example creates an animation trigger reference based on the provided
             * name value.
             * The provided animation value is expected to be an array consisting of state and
             * transition declarations.
             *
             * ```typescript
             * \@Component({
             *   selector: "my-component",
             *   templateUrl: "my-component-tpl.html",
             *   animations: [
             *     trigger("myAnimationTrigger", [
             *       state(...),
             *       state(...),
             *       transition(...),
             *       transition(...)
             *     ])
             *   ]
             * })
             * class MyComponent {
             *   myStatusExp = "something";
             * }
             * ```
             *
             * The template associated with this component makes use of the defined trigger
             * by binding to an element within its template code.
             *
             * ```html
             * <!-- somewhere inside of my-component-tpl.html -->
             * <div [\@myAnimationTrigger]="myStatusExp">...</div>
             * ```
             *
             * ### Using an inline function
             * The `transition` animation method also supports reading an inline function which can decide
             * if its associated animation should be run.
             *
             * ```typescript
             * // this method is run each time the `myAnimationTrigger` trigger value changes.
             * function myInlineMatcherFn(fromState: string, toState: string, element: any, params: {[key:
             * string]: any}): boolean {
             *   // notice that `element` and `params` are also available here
             *   return toState == 'yes-please-animate';
             * }
             *  /
             *   selector: 'my-component',
             *   templateUrl: 'my-component-tpl.html',
             *   animations: [
             *     trigger('myAnimationTrigger', [
             *       transition(myInlineMatcherFn, [
             *         // the animation sequence code
             *       ]),
             *     ])
             *   ]
             * })
             * class MyComponent {
             *   myStatusExp = "yes-please-animate";
             * }
             * ```
             *
             * ### Disabling Animations
             * When true, the special animation control binding `\@.disabled` binding prevents
             * all animations from rendering.
             * Place the  `\@.disabled` binding on an element to disable
             * animations on the element itself, as well as any inner animation triggers
             * within the element.
             *
             * The following example shows how to use this feature:
             *
             * ```typescript /
             *   selector: 'my-component',
             *   template: `
             *     <div [\@.disabled]="isDisabled">
             *       <div [\@childAnimation]="exp"></div>
             *     </div>
             *   `,
             *   animations: [
             *     trigger("childAnimation", [
             *       // ...
             *     ])
             *   ]
             * })
             * class MyComponent {
             *   isDisabled = true;
             *   exp = '...';
             * }
             * ```
             *
             * When `\@.disabled` is true, it prevents the `\@childAnimation` trigger from animating,
             * along with any inner animations.
             *
             * ### Disable animations application-wide
             * When an area of the template is set to have animations disabled,
             * **all** inner components have their animations disabled as well.
             * This means that you can disable all animations for an app
             * by placing a host binding set on `\@.disabled` on the topmost Angular component.
             *
             * ```typescript
             * import {Component, HostBinding} from '\@angular/core';
             *  /
             *   selector: 'app-component',
             *   templateUrl: 'app.component.html',
             * })
             * class AppComponent {
             * \@HostBinding('@.disabled')
             *   public animationsDisabled = true;
             * }
             * ```
             *
             * ### Overriding disablement of inner animations
             * Despite inner animations being disabled, a parent animation can `query()`
             * for inner elements located in disabled areas of the template and still animate
             * them if needed. This is also the case for when a sub animation is
             * queried by a parent and then later animated using `animateChild()`.
             *
             * ### Detecting when an animation is disabled
             * If a region of the DOM (or the entire application) has its animations disabled, the animation
             * trigger callbacks still fire, but for zero seconds. When the callback fires, it provides
             * an instance of an `AnimationEvent`. If animations are disabled,
             * the `.disabled` flag on the event is true.
             *
             * \@publicApi
             * @param {?} name An identifying string.
             * @param {?} definitions  An animation definition object, containing an array of `state()`
             * and `transition()` declarations.
             *
             * @return {?} An object that encapsulates the trigger data.
             *
             */
            function trigger(name, definitions) {
                return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
            }
            /**
             * Defines an animation step that combines styling information with timing information.
             *
             * \@usageNotes
             * Call within an animation `sequence()`, `{\@link animations/group group()}`, or
             * `transition()` call to specify an animation step
             * that applies given style data to the parent animation for a given amount of time.
             *
             * ### Syntax Examples
             * **Timing examples**
             *
             * The following examples show various `timings` specifications.
             * - `animate(500)` : Duration is 500 milliseconds.
             * - `animate("1s")` : Duration is 1000 milliseconds.
             * - `animate("100ms 0.5s")` : Duration is 100 milliseconds, delay is 500 milliseconds.
             * - `animate("5s ease-in")` : Duration is 5000 milliseconds, easing in.
             * - `animate("5s 10ms cubic-bezier(.17,.67,.88,.1)")` : Duration is 5000 milliseconds, delay is 10
             * milliseconds, easing according to a bezier curve.
             *
             * **Style examples**
             *
             * The following example calls `style()` to set a single CSS style.
             * ```typescript
             * animate(500, style({ background: "red" }))
             * ```
             * The following example calls `keyframes()` to set a CSS style
             * to different values for successive keyframes.
             * ```typescript
             * animate(500, keyframes(
             *  [
             *   style({ background: "blue" })),
             *   style({ background: "red" }))
             *  ])
             * ```
             *
             * \@publicApi
             * @param {?} timings Sets `AnimateTimings` for the parent animation.
             * A string in the format "duration [delay] [easing]".
             *  - Duration and delay are expressed as a number and optional time unit,
             * such as "1s" or "10ms" for one second and 10 milliseconds, respectively.
             * The default unit is milliseconds.
             *  - The easing value controls how the animation accelerates and decelerates
             * during its runtime. Value is one of  `ease`, `ease-in`, `ease-out`,
             * `ease-in-out`, or a `cubic-bezier()` function call.
             * If not supplied, no easing is applied.
             *
             * For example, the string "1s 100ms ease-out" specifies a duration of
             * 1000 milliseconds, and delay of 100 ms, and the "ease-out" easing style,
             * which decelerates near the end of the duration.
             * @param {?=} styles Sets AnimationStyles for the parent animation.
             * A function call to either `style()` or `keyframes()`
             * that returns a collection of CSS style entries to be applied to the parent animation.
             * When null, uses the styles from the destination state.
             * This is useful when describing an animation step that will complete an animation;
             * see "Animating to the final state" in `transitions()`.
             * @return {?} An object that encapsulates the animation step.
             *
             */
            function animate(timings, styles) {
                if (styles === void 0) { styles = null; }
                return { type: 4 /* Animate */, styles: styles, timings: timings };
            }
            /**
             * \@description Defines a list of animation steps to be run in parallel.
             *
             * \@usageNotes
             * Grouped animations are useful when a series of styles must be
             * animated at different starting times and closed off at different ending times.
             *
             * When called within a `sequence()` or a
             * `transition()` call, does not continue to the next
             * instruction until all of the inner animation steps have completed.
             *
             * \@publicApi
             * @param {?} steps An array of animation step objects.
             * - When steps are defined by `style()` or `animate()`
             * function calls, each call within the group is executed instantly.
             * - To specify offset styles to be applied at a later time, define steps with
             * `keyframes()`, or use `animate()` calls with a delay value.
             * For example:
             *
             * ```typescript
             * group([
             *   animate("1s", style({ background: "black" })),
             *   animate("2s", style({ color: "white" }))
             * ])
             * ```
             *
             * @param {?=} options An options object containing a delay and
             * developer-defined parameters that provide styling defaults and
             * can be overridden on invocation.
             *
             * @return {?} An object that encapsulates the group data.
             *
             */
            function group(steps, options) {
                if (options === void 0) { options = null; }
                return { type: 3 /* Group */, steps: steps, options: options };
            }
            /**
             * Defines a list of animation steps to be run sequentially, one by one.
             *
             * \@usageNotes
             * When you pass an array of steps to a
             * `transition()` call, the steps run sequentially by default.
             * Compare this to the `{\@link animations/group group()}` call, which runs animation steps in parallel.
             *
             * When a sequence is used within a `{\@link animations/group group()}` or a `transition()` call,
             * execution continues to the next instruction only after each of the inner animation
             * steps have completed.
             *
             * \@publicApi
             *
             * @param {?} steps An array of animation step objects.
             * - Steps defined by `style()` calls apply the styling data immediately.
             * - Steps defined by `animate()` calls apply the styling data over time
             *   as specified by the timing data.
             *
             * ```typescript
             * sequence([
             *   style({ opacity: 0 }),
             *   animate("1s", style({ opacity: 1 }))
             * ])
             * ```
             *
             * @param {?=} options An options object containing a delay and
             * developer-defined parameters that provide styling defaults and
             * can be overridden on invocation.
             *
             * @return {?} An object that encapsulates the sequence data.
             *
             */
            function sequence(steps, options) {
                if (options === void 0) { options = null; }
                return { type: 2 /* Sequence */, steps: steps, options: options };
            }
            /**
             * Declares a key/value object containing CSS properties/styles that
             * can then be used for an animation `state`, within an animation `sequence`,
             * or as styling data for calls to `animate()` and `keyframes()`.
             *
             * \@usageNotes
             * The following examples create animation styles that collect a set of
             * CSS property values:
             *
             * ```typescript
             * // string values for CSS properties
             * style({ background: "red", color: "blue" })
             *
             * // numerical pixel values
             * style({ width: 100, height: 0 })
             * ```
             *
             * The following example uses auto-styling to allow a component to animate from
             * a height of 0 up to the height of the parent element:
             *
             * ```
             * style({ height: 0 }),
             * animate("1s", style({ height: "*" }))
             * ```
             *
             * \@publicApi
             *
             * @param {?} tokens A set of CSS styles or HTML styles associated with an animation state.
             * The value can be any of the following:
             * - A key-value style pair associating a CSS property with a value.
             * - An array of key-value style pairs.
             * - An asterisk (*), to use auto-styling, where styles are derived from the element
             * being animated and applied to the animation when it starts.
             *
             * Auto-styling can be used to define a state that depends on layout or other
             * environmental factors.
             *
             * @return {?} An object that encapsulates the style data.
             *
             */
            function style(tokens) {
                return { type: 6 /* Style */, styles: tokens, offset: null };
            }
            /**
             * Declares an animation state within a trigger attached to an element.
             *
             * \@usageNotes
             * Use the `trigger()` function to register states to an animation trigger.
             * Use the `transition()` function to animate between states.
             * When a state is active within a component, its associated styles persist on the element,
             * even when the animation ends.
             *
             * \@publicApi
             *
             * @param {?} name One or more names for the defined state in a comma-separated string.
             * The following reserved state names can be supplied to define a style for specific use
             * cases:
             *
             * - `void` You can associate styles with this name to be used when
             * the element is detached from the application. For example, when an `ngIf` evaluates
             * to false, the state of the associated element is void.
             *  - `*` (asterisk) Indicates the default state. You can associate styles with this name
             * to be used as the fallback when the state that is being animated is not declared
             * within the trigger.
             *
             * @param {?} styles A set of CSS styles associated with this state, created using the
             * `style()` function.
             * This set of styles persists on the element once the state has been reached.
             * @param {?=} options Parameters that can be passed to the state when it is invoked.
             * 0 or more key-value pairs.
             * @return {?} An object that encapsulates the new state data.
             *
             */
            function state(name, styles, options) {
                return { type: 0 /* State */, name: name, styles: styles, options: options };
            }
            /**
             * Defines a set of animation styles, associating each style with an optional `offset` value.
             *
             * \@usageNotes
             * Use with the `animate()` call. Instead of applying animations
             * from the current state
             * to the destination state, keyframes describe how each style entry is applied and at what point
             * within the animation arc.
             * Compare [CSS Keyframe Animations](https://www.w3schools.com/css/css3_animations.asp).
             *
             * ### Usage
             *
             * In the following example, the offset values describe
             * when each `backgroundColor` value is applied. The color is red at the start, and changes to
             * blue when 20% of the total time has elapsed.
             *
             * ```typescript
             * // the provided offset values
             * animate("5s", keyframes([
             *   style({ backgroundColor: "red", offset: 0 }),
             *   style({ backgroundColor: "blue", offset: 0.2 }),
             *   style({ backgroundColor: "orange", offset: 0.3 }),
             *   style({ backgroundColor: "black", offset: 1 })
             * ]))
             * ```
             *
             * If there are no `offset` values specified in the style entries, the offsets
             * are calculated automatically.
             *
             * ```typescript
             * animate("5s", keyframes([
             *   style({ backgroundColor: "red" }) // offset = 0
             *   style({ backgroundColor: "blue" }) // offset = 0.33
             *   style({ backgroundColor: "orange" }) // offset = 0.66
             *   style({ backgroundColor: "black" }) // offset = 1
             * ]))
             * ```
             * \@publicApi
             * @param {?} steps A set of animation styles with optional offset data.
             * The optional `offset` value for a style specifies a percentage of the total animation
             * time at which that style is applied.
             * @return {?} An object that encapsulates the keyframes data.
             *
             */
            function keyframes(steps) {
                return { type: 5 /* Keyframes */, steps: steps };
            }
            /**
             * Declares an animation transition as a sequence of animation steps to run when a given
             * condition is satisfied. The condition is a Boolean expression or function that compares
             * the previous and current animation states, and returns true if this transition should occur.
             * When the state criteria of a defined transition are met, the associated animation is
             * triggered.
             *
             * \@usageNotes
             * The template associated with a component binds an animation trigger to an element.
             *
             * ```HTML
             * <!-- somewhere inside of my-component-tpl.html -->
             * <div [\@myAnimationTrigger]="myStatusExp">...</div>
             * ```
             *
             * All transitions are defined within an animation trigger,
             * along with named states that the transitions change to and from.
             *
             * ```typescript
             * trigger("myAnimationTrigger", [
             *  // define states
             *  state("on", style({ background: "green" })),
             *  state("off", style({ background: "grey" })),
             *  ...]
             * ```
             *
             * Note that when you call the `sequence()` function within a `{\@link animations/group group()}`
             * or a `transition()` call, execution does not continue to the next instruction
             * until each of the inner animation steps have completed.
             *
             * ### Syntax examples
             *
             * The following examples define transitions between the two defined states (and default states),
             * using various options:
             *
             * ```typescript
             * // Transition occurs when the state value
             * // bound to "myAnimationTrigger" changes from "on" to "off"
             * transition("on => off", animate(500))
             * // Run the same animation for both directions
             * transition("on <=> off", animate(500))
             * // Define multiple state-change pairs separated by commas
             * transition("on => off, off => void", animate(500))
             * ```
             *
             * ### Special values for state-change expressions
             *
             * - Catch-all state change for when an element is inserted into the page and the
             * destination state is unknown:
             *
             * ```typescript
             * transition("void => *", [
             *  style({ opacity: 0 }),
             *  animate(500)
             *  ])
             * ```
             *
             * - Capture a state change between any states:
             *
             *  `transition("* => *", animate("1s 0s"))`
             *
             * - Entry and exit transitions:
             *
             * ```typescript
             * transition(":enter", [
             *   style({ opacity: 0 }),
             *   animate(500, style({ opacity: 1 }))
             *   ]),
             * transition(":leave", [
             *   animate(500, style({ opacity: 0 }))
             *   ])
             * ```
             *
             * - Use `:increment` and `:decrement` to initiate transitions:
             *
             * ```typescript
             * transition(":increment", group([
             *  query(':enter', [
             *     style({ left: '100%' }),
             *     animate('0.5s ease-out', style('*'))
             *   ]),
             *  query(':leave', [
             *     animate('0.5s ease-out', style({ left: '-100%' }))
             *  ])
             * ]))
             *
             * transition(":decrement", group([
             *  query(':enter', [
             *     style({ left: '100%' }),
             *     animate('0.5s ease-out', style('*'))
             *   ]),
             *  query(':leave', [
             *     animate('0.5s ease-out', style({ left: '-100%' }))
             *  ])
             * ]))
             * ```
             *
             * ### State-change functions
             *
             * Here is an example of a `fromState` specified as a state-change function that invokes an
             * animation when true:
             *
             * ```typescript
             * transition((fromState, toState) =>
             *  {
             *   return fromState == "off" && toState == "on";
             *  },
             *  animate("1s 0s"))
             * ```
             *
             * ### Animating to the final state
             *
             * If the final step in a transition is a call to `animate()` that uses a timing value
             * with no style data, that step is automatically considered the final animation arc,
             * for the element to reach the final state. Angular automatically adds or removes
             * CSS styles to ensure that the element is in the correct final state.
             *
             * The following example defines a transition that starts by hiding the element,
             * then makes sure that it animates properly to whatever state is currently active for trigger:
             *
             * ```typescript
             * transition("void => *", [
             *   style({ opacity: 0 }),
             *   animate(500)
             *  ])
             * ```
             * ### Boolean value matching
             * If a trigger binding value is a Boolean, it can be matched using a transition expression
             * that compares true and false or 1 and 0. For example:
             *
             * ```
             * // in the template
             * <div [\@openClose]="open ? true : false">...</div>
             * // in the component metadata
             * trigger('openClose', [
             *   state('true', style({ height: '*' })),
             *   state('false', style({ height: '0px' })),
             *   transition('false <=> true', animate(500))
             * ])
             * ```
             *
             * \@publicApi
             *
             * @param {?} stateChangeExpr A Boolean expression or function that compares the previous and current
             * animation states, and returns true if this transition should occur. Note that  "true" and "false"
             * match 1 and 0, respectively. An expression is evaluated each time a state change occurs in the
             * animation trigger element.
             * The animation steps run when the expression evaluates to true.
             *
             * - A state-change string takes the form "state1 => state2", where each side is a defined animation
             * state, or an asterix (*) to refer to a dynamic start or end state.
             *   - The expression string can contain multiple comma-separated statements;
             * for example "state1 => state2, state3 => state4".
             *   - Special values `:enter` and `:leave` initiate a transition on the entry and exit states,
             * equivalent to  "void => *"  and "* => void".
             *   - Special values `:increment` and `:decrement` initiate a transition when a numeric value has
             * increased or decreased in value.
             * - A function is executed each time a state change occurs in the animation trigger element.
             * The animation steps run when the function returns true.
             *
             * @param {?} steps One or more animation objects, as returned by the `animate()` or
             * `sequence()` function, that form a transformation from one state to another.
             * A sequence is used by default when you pass an array.
             * @param {?=} options An options object that can contain a delay value for the start of the animation,
             * and additional developer-defined parameters. Provided values for additional parameters are used
             * as defaults, and override values can be passed to the caller on invocation.
             * @return {?} An object that encapsulates the transition data.
             *
             */
            function transition(stateChangeExpr, steps, options) {
                if (options === void 0) { options = null; }
                return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
            }
            /**
             * Produces a reusable animation that can be invoked in another animation or sequence,
             * by calling the `useAnimation()` function.
             *
             * \@usageNotes
             * The following example defines a reusable animation, providing some default parameter
             * values.
             *
             * ```typescript
             * var fadeAnimation = animation([
             *   style({ opacity: '{{ start }}' }),
             *   animate('{{ time }}',
             *   style({ opacity: '{{ end }}'}))
             *   ],
             *   { params: { time: '1000ms', start: 0, end: 1 }});
             * ```
             *
             * The following invokes the defined animation with a call to `useAnimation()`,
             * passing in override parameter values.
             *
             * ```js
             * useAnimation(fadeAnimation, {
             *   params: {
             *     time: '2s',
             *     start: 1,
             *     end: 0
             *   }
             * })
             * ```
             *
             * If any of the passed-in parameter values are missing from this call,
             * the default values are used. If one or more parameter values are missing before a step is
             * animated, `useAnimation()` throws an error.
             *
             * \@publicApi
             * @param {?} steps One or more animation objects, as returned by the `animate()`
             * or `sequence()` function, that form a transformation from one state to another.
             * A sequence is used by default when you pass an array.
             * @param {?=} options An options object that can contain a delay value for the start of the
             * animation, and additional developer-defined parameters.
             * Provided values for additional parameters are used as defaults,
             * and override values can be passed to the caller on invocation.
             * @return {?} An object that encapsulates the animation data.
             *
             */
            function animation(steps, options) {
                if (options === void 0) { options = null; }
                return { type: 8 /* Reference */, animation: steps, options: options };
            }
            /**
             * Executes a queried inner animation element within an animation sequence.
             *
             * \@usageNotes
             * Each time an animation is triggered in Angular, the parent animation
             * has priority and any child animations are blocked. In order
             * for a child animation to run, the parent animation must query each of the elements
             * containing child animations, and run them using this function.
             *
             * Note that this feature is designed to be used with `query()` and it will only work
             * with animations that are assigned using the Angular animation library. CSS keyframes
             * and transitions are not handled by this API.
             *
             * \@publicApi
             * @param {?=} options An options object that can contain a delay value for the start of the
             * animation, and additional override values for developer-defined parameters.
             * @return {?} An object that encapsulates the child animation data.
             *
             */
            function animateChild(options) {
                if (options === void 0) { options = null; }
                return { type: 9 /* AnimateChild */, options: options };
            }
            /**
             * Starts a reusable animation that is created using the `animation()` function.
             *
             * \@publicApi
             * @param {?} animation The reusable animation to start.
             * @param {?=} options An options object that can contain a delay value for the start of
             * the animation, and additional override values for developer-defined parameters.
             * @return {?} An object that contains the animation parameters.
             *
             */
            function useAnimation(animation, options) {
                if (options === void 0) { options = null; }
                return { type: 10 /* AnimateRef */, animation: animation, options: options };
            }
            /**
             * Finds one or more inner elements within the current element that is
             * being animated within a sequence. Use with `animate()`.
             *
             * \@usageNotes
             * Tokens can be merged into a combined query selector string. For example:
             *
             * ```typescript
             *  query(':self, .record:enter, .record:leave, \@subTrigger', [...])
             * ```
             *
             * The `query()` function collects multiple elements and works internally by using
             * `element.querySelectorAll`. Use the `limit` field of an options object to limit
             * the total number of items to be collected. For example:
             *
             * ```js
             * query('div', [
             *   animate(...),
             *   animate(...)
             * ], { limit: 1 })
             * ```
             *
             * By default, throws an error when zero items are found. Set the
             * `optional` flag to ignore this error. For example:
             *
             * ```js
             * query('.some-element-that-may-not-be-there', [
             *   animate(...),
             *   animate(...)
             * ], { optional: true })
             * ```
             *
             * ### Usage Example
             *
             * The following example queries for inner elements and animates them
             * individually using `animate()`.
             *
             * ```typescript
             * \@Component({
             *   selector: 'inner',
             *   template: `
             *     <div [\@queryAnimation]="exp">
             *       <h1>Title</h1>
             *       <div class="content">
             *         Blah blah blah
             *       </div>
             *     </div>
             *   `,
             *   animations: [
             *    trigger('queryAnimation', [
             *      transition('* => goAnimate', [
             *        // hide the inner elements
             *        query('h1', style({ opacity: 0 })),
             *        query('.content', style({ opacity: 0 })),
             *
             *        // animate the inner elements in, one by one
             *        query('h1', animate(1000, style({ opacity: 1 }))),
             *        query('.content', animate(1000, style({ opacity: 1 }))),
             *      ])
             *    ])
             *  ]
             * })
             * class Cmp {
             *   exp = '';
             *
             *   goAnimate() {
             *     this.exp = 'goAnimate';
             *   }
             * }
             * ```
             *
             * \@publicApi
             * @param {?} selector The element to query, or a set of elements that contain Angular-specific
             * characteristics, specified with one or more of the following tokens.
             *  - `query(":enter")` or `query(":leave")` : Query for newly inserted/removed elements.
             *  - `query(":animating")` : Query all currently animating elements.
             *  - `query("\@triggerName")` : Query elements that contain an animation trigger.
             *  - `query("\@*")` : Query all elements that contain an animation triggers.
             *  - `query(":self")` : Include the current element into the animation sequence.
             *
             * @param {?} animation One or more animation steps to apply to the queried element or elements.
             * An array is treated as an animation sequence.
             * @param {?=} options An options object. Use the 'limit' field to limit the total number of
             * items to collect.
             * @return {?} An object that encapsulates the query data.
             *
             */
            function query(selector, animation, options) {
                if (options === void 0) { options = null; }
                return { type: 11 /* Query */, selector: selector, animation: animation, options: options };
            }
            /**
             * Use within an animation `query()` call to issue a timing gap after
             * each queried item is animated.
             *
             * \@usageNotes
             * In the following example, a container element wraps a list of items stamped out
             * by an `ngFor`. The container element contains an animation trigger that will later be set
             * to query for each of the inner items.
             *
             * Each time items are added, the opacity fade-in animation runs,
             * and each removed item is faded out.
             * When either of these animations occur, the stagger effect is
             * applied after each item's animation is started.
             *
             * ```html
             * <!-- list.component.html -->
             * <button (click)="toggle()">Show / Hide Items</button>
             * <hr />
             * <div [\@listAnimation]="items.length">
             *   <div *ngFor="let item of items">
             *     {{ item }}
             *   </div>
             * </div>
             * ```
             *
             * Here is the component code:
             *
             * ```typescript
             * import {trigger, transition, style, animate, query, stagger} from '\@angular/animations';
             * \@Component({
             *   templateUrl: 'list.component.html',
             *   animations: [
             *     trigger('listAnimation', [
             *     ...
             *     ])
             *   ]
             * })
             * class ListComponent {
             *   items = [];
             *
             *   showItems() {
             *     this.items = [0,1,2,3,4];
             *   }
             *
             *   hideItems() {
             *     this.items = [];
             *   }
             *
             *   toggle() {
             *     this.items.length ? this.hideItems() : this.showItems();
             *    }
             *  }
             * ```
             *
             * Here is the animation trigger code:
             *
             * ```typescript
             * trigger('listAnimation', [
             *   transition('* => *', [ // each time the binding value changes
             *     query(':leave', [
             *       stagger(100, [
             *         animate('0.5s', style({ opacity: 0 }))
             *       ])
             *     ]),
             *     query(':enter', [
             *       style({ opacity: 0 }),
             *       stagger(100, [
             *         animate('0.5s', style({ opacity: 1 }))
             *       ])
             *     ])
             *   ])
             * ])
             * ```
             *
             * \@publicApi
             * @param {?} timings A delay value.
             * @param {?} animation One ore more animation steps.
             * @return {?} An object that encapsulates the stagger data.
             *
             */
            function stagger(timings, animation) {
                return { type: 12 /* Stagger */, timings: timings, animation: animation };
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             * @param {?} cb
             * @return {?}
             */
            function scheduleMicroTask(cb) {
                Promise.resolve(null).then(cb);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Provides programmatic control of a reusable animation sequence,
             * built using the `build()` method of `AnimationBuilder`. The `build()` method
             * returns a factory, whose `create()` method instantiates and initializes this interface.
             *
             * @see `AnimationBuilder`
             * @see `AnimationFactory`
             * @see `animate()`
             *
             * \@publicApi
             * @record
             */
            function AnimationPlayer() { }
            if (false) { }
            /**
             * An empty programmatic controller for reusable animations.
             * Used internally when animations are disabled, to avoid
             * checking for the null case when an animation player is expected.
             *
             * @see `animate()`
             * @see `AnimationPlayer`
             * @see `GroupPlayer`
             *
             * \@publicApi
             */
            var NoopAnimationPlayer = /** @class */ (function () {
                /**
                 * @param {?=} duration
                 * @param {?=} delay
                 */
                function NoopAnimationPlayer(duration, delay) {
                    if (duration === void 0) { duration = 0; }
                    if (delay === void 0) { delay = 0; }
                    this._onDoneFns = [];
                    this._onStartFns = [];
                    this._onDestroyFns = [];
                    this._started = false;
                    this._destroyed = false;
                    this._finished = false;
                    this.parentPlayer = null;
                    this.totalTime = duration + delay;
                }
                /**
                 * @private
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype._onFinish = function () {
                    if (!this._finished) {
                        this._finished = true;
                        this._onDoneFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onDoneFns = [];
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.hasStarted = function () { return this._started; };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.init = function () { };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.play = function () {
                    if (!this.hasStarted()) {
                        this._onStart();
                        this.triggerMicrotask();
                    }
                    this._started = true;
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.triggerMicrotask = function () {
                    var _this = this;
                    scheduleMicroTask(( /**
                     * @return {?}
                     */function () { return _this._onFinish(); }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype._onStart = function () {
                    this._onStartFns.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    this._onStartFns = [];
                };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.pause = function () { };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.restart = function () { };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.finish = function () { this._onFinish(); };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.destroy = function () {
                    if (!this._destroyed) {
                        this._destroyed = true;
                        if (!this.hasStarted()) {
                            this._onStart();
                        }
                        this.finish();
                        this._onDestroyFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onDestroyFns = [];
                    }
                };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.reset = function () { };
                /**
                 * @param {?} position
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.setPosition = function (position) { };
                /**
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.getPosition = function () { return 0; };
                /**
                 * \@internal
                 * @param {?} phaseName
                 * @return {?}
                 */
                NoopAnimationPlayer.prototype.triggerCallback = function (phaseName) {
                    /** @type {?} */
                    var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
                    methods.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    methods.length = 0;
                };
                return NoopAnimationPlayer;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A programmatic controller for a group of reusable animations.
             * Used internally to control animations.
             *
             * @see `AnimationPlayer`
             * @see `{\@link animations/group group()}`
             *
             */
            var AnimationGroupPlayer = /** @class */ (function () {
                /**
                 * @param {?} _players
                 */
                function AnimationGroupPlayer(_players) {
                    var _this = this;
                    this._onDoneFns = [];
                    this._onStartFns = [];
                    this._finished = false;
                    this._started = false;
                    this._destroyed = false;
                    this._onDestroyFns = [];
                    this.parentPlayer = null;
                    this.totalTime = 0;
                    this.players = _players;
                    /** @type {?} */
                    var doneCount = 0;
                    /** @type {?} */
                    var destroyCount = 0;
                    /** @type {?} */
                    var startCount = 0;
                    /** @type {?} */
                    var total = this.players.length;
                    if (total == 0) {
                        scheduleMicroTask(( /**
                         * @return {?}
                         */function () { return _this._onFinish(); }));
                    }
                    else {
                        this.players.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) {
                            player.onDone(( /**
                             * @return {?}
                             */function () {
                                if (++doneCount == total) {
                                    _this._onFinish();
                                }
                            }));
                            player.onDestroy(( /**
                             * @return {?}
                             */function () {
                                if (++destroyCount == total) {
                                    _this._onDestroy();
                                }
                            }));
                            player.onStart(( /**
                             * @return {?}
                             */function () {
                                if (++startCount == total) {
                                    _this._onStart();
                                }
                            }));
                        }));
                    }
                    this.totalTime = this.players.reduce(( /**
                     * @param {?} time
                     * @param {?} player
                     * @return {?}
                     */function (time, player) { return Math.max(time, player.totalTime); }), 0);
                }
                /**
                 * @private
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype._onFinish = function () {
                    if (!this._finished) {
                        this._finished = true;
                        this._onDoneFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onDoneFns = [];
                    }
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.init = function () {
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player.init(); }));
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
                /**
                 * @private
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype._onStart = function () {
                    if (!this.hasStarted()) {
                        this._started = true;
                        this._onStartFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onStartFns = [];
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.play = function () {
                    if (!this.parentPlayer) {
                        this.init();
                    }
                    this._onStart();
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player.play(); }));
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.pause = function () {
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player.pause(); }));
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.restart = function () {
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player.restart(); }));
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.finish = function () {
                    this._onFinish();
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player.finish(); }));
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.destroy = function () { this._onDestroy(); };
                /**
                 * @private
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype._onDestroy = function () {
                    if (!this._destroyed) {
                        this._destroyed = true;
                        this._onFinish();
                        this.players.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) { return player.destroy(); }));
                        this._onDestroyFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onDestroyFns = [];
                    }
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.reset = function () {
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player.reset(); }));
                    this._destroyed = false;
                    this._finished = false;
                    this._started = false;
                };
                /**
                 * @param {?} p
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.setPosition = function (p) {
                    /** @type {?} */
                    var timeAtPosition = p * this.totalTime;
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        /** @type {?} */
                        var position = player.totalTime ? Math.min(1, timeAtPosition / player.totalTime) : 1;
                        player.setPosition(position);
                    }));
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.getPosition = function () {
                    /** @type {?} */
                    var min = 0;
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        /** @type {?} */
                        var p = player.getPosition();
                        min = Math.min(p, min);
                    }));
                    return min;
                };
                /**
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.beforeDestroy = function () {
                    this.players.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        if (player.beforeDestroy) {
                            player.beforeDestroy();
                        }
                    }));
                };
                /**
                 * \@internal
                 * @param {?} phaseName
                 * @return {?}
                 */
                AnimationGroupPlayer.prototype.triggerCallback = function (phaseName) {
                    /** @type {?} */
                    var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
                    methods.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    methods.length = 0;
                };
                return AnimationGroupPlayer;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var ɵPRE_STYLE = '!';
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=animations.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/animations/fesm2015/browser.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/@angular/animations/fesm2015/browser.js ***!
          \**************************************************************/
        /*! exports provided: ɵangular_packages_animations_browser_browser_a, AnimationDriver, ɵAnimationDriver, ɵAnimation, ɵAnimationStyleNormalizer, ɵNoopAnimationStyleNormalizer, ɵWebAnimationsStyleNormalizer, ɵNoopAnimationDriver, ɵAnimationEngine, ɵCssKeyframesDriver, ɵCssKeyframesPlayer, ɵcontainsElement, ɵinvokeQuery, ɵmatchesElement, ɵvalidateStyleProperty, ɵWebAnimationsDriver, ɵsupportsWebAnimations, ɵWebAnimationsPlayer, ɵallowPreviousPlayerStylesMerge */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_animations_browser_browser_a", function () { return SpecialCasedStyles; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationDriver", function () { return AnimationDriver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationDriver", function () { return AnimationDriver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimation", function () { return Animation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationStyleNormalizer", function () { return AnimationStyleNormalizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNoopAnimationStyleNormalizer", function () { return NoopAnimationStyleNormalizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵWebAnimationsStyleNormalizer", function () { return WebAnimationsStyleNormalizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNoopAnimationDriver", function () { return NoopAnimationDriver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationEngine", function () { return AnimationEngine; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCssKeyframesDriver", function () { return CssKeyframesDriver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCssKeyframesPlayer", function () { return CssKeyframesPlayer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcontainsElement", function () { return containsElement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinvokeQuery", function () { return invokeQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmatchesElement", function () { return matchesElement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵvalidateStyleProperty", function () { return validateStyleProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵWebAnimationsDriver", function () { return WebAnimationsDriver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsupportsWebAnimations", function () { return supportsWebAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵWebAnimationsPlayer", function () { return WebAnimationsPlayer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵallowPreviousPlayerStylesMerge", function () { return allowPreviousPlayerStylesMerge; });
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @return {?}
             */
            function isBrowser() {
                return (typeof window !== 'undefined' && typeof window.document !== 'undefined');
            }
            /**
             * @return {?}
             */
            function isNode() {
                return (typeof process !== 'undefined');
            }
            /**
             * @param {?} players
             * @return {?}
             */
            function optimizeGroupPlayer(players) {
                switch (players.length) {
                    case 0:
                        return new _angular_animations__WEBPACK_IMPORTED_MODULE_0__["NoopAnimationPlayer"]();
                    case 1:
                        return players[0];
                    default:
                        return new _angular_animations__WEBPACK_IMPORTED_MODULE_0__["ɵAnimationGroupPlayer"](players);
                }
            }
            /**
             * @param {?} driver
             * @param {?} normalizer
             * @param {?} element
             * @param {?} keyframes
             * @param {?=} preStyles
             * @param {?=} postStyles
             * @return {?}
             */
            function normalizeKeyframes(driver, normalizer, element, keyframes, preStyles, postStyles) {
                if (preStyles === void 0) { preStyles = {}; }
                if (postStyles === void 0) { postStyles = {}; }
                /** @type {?} */
                var errors = [];
                /** @type {?} */
                var normalizedKeyframes = [];
                /** @type {?} */
                var previousOffset = -1;
                /** @type {?} */
                var previousKeyframe = null;
                keyframes.forEach(( /**
                 * @param {?} kf
                 * @return {?}
                 */function (/**
                 * @param {?} kf
                 * @return {?}
                 */ kf) {
                    /** @type {?} */
                    var offset = ( /** @type {?} */(kf['offset']));
                    /** @type {?} */
                    var isSameOffset = offset == previousOffset;
                    /** @type {?} */
                    var normalizedKeyframe = (isSameOffset && previousKeyframe) || {};
                    Object.keys(kf).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var normalizedProp = prop;
                        /** @type {?} */
                        var normalizedValue = kf[prop];
                        if (prop !== 'offset') {
                            normalizedProp = normalizer.normalizePropertyName(normalizedProp, errors);
                            switch (normalizedValue) {
                                case _angular_animations__WEBPACK_IMPORTED_MODULE_0__["ɵPRE_STYLE"]:
                                    normalizedValue = preStyles[prop];
                                    break;
                                case _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"]:
                                    normalizedValue = postStyles[prop];
                                    break;
                                default:
                                    normalizedValue =
                                        normalizer.normalizeStyleValue(prop, normalizedProp, normalizedValue, errors);
                                    break;
                            }
                        }
                        normalizedKeyframe[normalizedProp] = normalizedValue;
                    }));
                    if (!isSameOffset) {
                        normalizedKeyframes.push(normalizedKeyframe);
                    }
                    previousKeyframe = normalizedKeyframe;
                    previousOffset = offset;
                }));
                if (errors.length) {
                    /** @type {?} */
                    var LINE_START = '\n - ';
                    throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
                }
                return normalizedKeyframes;
            }
            /**
             * @param {?} player
             * @param {?} eventName
             * @param {?} event
             * @param {?} callback
             * @return {?}
             */
            function listenOnPlayer(player, eventName, event, callback) {
                switch (eventName) {
                    case 'start':
                        player.onStart(( /**
                         * @return {?}
                         */function () { return callback(event && copyAnimationEvent(event, 'start', player)); }));
                        break;
                    case 'done':
                        player.onDone(( /**
                         * @return {?}
                         */function () { return callback(event && copyAnimationEvent(event, 'done', player)); }));
                        break;
                    case 'destroy':
                        player.onDestroy(( /**
                         * @return {?}
                         */function () { return callback(event && copyAnimationEvent(event, 'destroy', player)); }));
                        break;
                }
            }
            /**
             * @param {?} e
             * @param {?} phaseName
             * @param {?} player
             * @return {?}
             */
            function copyAnimationEvent(e, phaseName, player) {
                /** @type {?} */
                var totalTime = player.totalTime;
                /** @type {?} */
                var disabled = (( /** @type {?} */(player))).disabled ? true : false;
                /** @type {?} */
                var event = makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, phaseName || e.phaseName, totalTime == undefined ? e.totalTime : totalTime, disabled);
                /** @type {?} */
                var data = (( /** @type {?} */(e)))['_data'];
                if (data != null) {
                    (( /** @type {?} */(event)))['_data'] = data;
                }
                return event;
            }
            /**
             * @param {?} element
             * @param {?} triggerName
             * @param {?} fromState
             * @param {?} toState
             * @param {?=} phaseName
             * @param {?=} totalTime
             * @param {?=} disabled
             * @return {?}
             */
            function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime, disabled) {
                if (phaseName === void 0) { phaseName = ''; }
                if (totalTime === void 0) { totalTime = 0; }
                return { element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime, disabled: !!disabled };
            }
            /**
             * @param {?} map
             * @param {?} key
             * @param {?} defaultValue
             * @return {?}
             */
            function getOrSetAsInMap(map, key, defaultValue) {
                /** @type {?} */
                var value;
                if (map instanceof Map) {
                    value = map.get(key);
                    if (!value) {
                        map.set(key, value = defaultValue);
                    }
                }
                else {
                    value = map[key];
                    if (!value) {
                        value = map[key] = defaultValue;
                    }
                }
                return value;
            }
            /**
             * @param {?} command
             * @return {?}
             */
            function parseTimelineCommand(command) {
                /** @type {?} */
                var separatorPos = command.indexOf(':');
                /** @type {?} */
                var id = command.substring(1, separatorPos);
                /** @type {?} */
                var action = command.substr(separatorPos + 1);
                return [id, action];
            }
            /** @type {?} */
            var _contains = ( /**
             * @param {?} elm1
             * @param {?} elm2
             * @return {?}
             */function (elm1, elm2) { return false; });
            var ɵ0 = _contains;
            /** @type {?} */
            var _matches = ( /**
             * @param {?} element
             * @param {?} selector
             * @return {?}
             */function (element, selector) { return false; });
            var ɵ1 = _matches;
            /** @type {?} */
            var _query = ( /**
             * @param {?} element
             * @param {?} selector
             * @param {?} multi
             * @return {?}
             */function (element, selector, multi) {
                return [];
            });
            var ɵ2 = _query;
            // Define utility methods for browsers and platform-server(domino) where Element
            // and utility methods exist.
            /** @type {?} */
            var _isNode = isNode();
            if (_isNode || typeof Element !== 'undefined') {
                // this is well supported in all browsers
                _contains = ( /**
                 * @param {?} elm1
                 * @param {?} elm2
                 * @return {?}
                 */function (elm1, elm2) { return ( /** @type {?} */(elm1.contains(elm2))); });
                _matches = (( /**
                 * @return {?}
                 */function () {
                    if (_isNode || Element.prototype.matches) {
                        return ( /**
                         * @param {?} element
                         * @param {?} selector
                         * @return {?}
                         */function (element, selector) { return element.matches(selector); });
                    }
                    else {
                        /** @type {?} */
                        var proto = ( /** @type {?} */(Element.prototype));
                        /** @type {?} */
                        var fn_1 = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector ||
                            proto.oMatchesSelector || proto.webkitMatchesSelector;
                        if (fn_1) {
                            return ( /**
                             * @param {?} element
                             * @param {?} selector
                             * @return {?}
                             */function (element, selector) { return fn_1.apply(element, [selector]); });
                        }
                        else {
                            return _matches;
                        }
                    }
                }))();
                _query = ( /**
                 * @param {?} element
                 * @param {?} selector
                 * @param {?} multi
                 * @return {?}
                 */function (element, selector, multi) {
                    /** @type {?} */
                    var results = [];
                    if (multi) {
                        results.push.apply(results, element.querySelectorAll(selector));
                    }
                    else {
                        /** @type {?} */
                        var elm = element.querySelector(selector);
                        if (elm) {
                            results.push(elm);
                        }
                    }
                    return results;
                });
            }
            /**
             * @param {?} prop
             * @return {?}
             */
            function containsVendorPrefix(prop) {
                // Webkit is the only real popular vendor prefix nowadays
                // cc: http://shouldiprefix.com/
                return prop.substring(1, 6) == 'ebkit'; // webkit or Webkit
            }
            /** @type {?} */
            var _CACHED_BODY = null;
            /** @type {?} */
            var _IS_WEBKIT = false;
            /**
             * @param {?} prop
             * @return {?}
             */
            function validateStyleProperty(prop) {
                if (!_CACHED_BODY) {
                    _CACHED_BODY = getBodyNode() || {};
                    _IS_WEBKIT = ( /** @type {?} */(_CACHED_BODY)).style ? ('WebkitAppearance' in ( /** @type {?} */(_CACHED_BODY)).style) : false;
                }
                /** @type {?} */
                var result = true;
                if (( /** @type {?} */(_CACHED_BODY)).style && !containsVendorPrefix(prop)) {
                    result = prop in ( /** @type {?} */(_CACHED_BODY)).style;
                    if (!result && _IS_WEBKIT) {
                        /** @type {?} */
                        var camelProp = 'Webkit' + prop.charAt(0).toUpperCase() + prop.substr(1);
                        result = camelProp in ( /** @type {?} */(_CACHED_BODY)).style;
                    }
                }
                return result;
            }
            /**
             * @return {?}
             */
            function getBodyNode() {
                if (typeof document != 'undefined') {
                    return document.body;
                }
                return null;
            }
            /** @type {?} */
            var matchesElement = _matches;
            /** @type {?} */
            var containsElement = _contains;
            /** @type {?} */
            var invokeQuery = _query;
            /**
             * @param {?} object
             * @return {?}
             */
            function hypenatePropsObject(object) {
                /** @type {?} */
                var newObj = {};
                Object.keys(object).forEach(( /**
                 * @param {?} prop
                 * @return {?}
                 */function (/**
                 * @param {?} prop
                 * @return {?}
                 */ prop) {
                    /** @type {?} */
                    var newProp = prop.replace(/([a-z])([A-Z])/g, '$1-$2');
                    newObj[newProp] = object[prop];
                }));
                return newObj;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             */
            var NoopAnimationDriver = /** @class */ (function () {
                function NoopAnimationDriver() {
                }
                /**
                 * @param {?} prop
                 * @return {?}
                 */
                NoopAnimationDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
                /**
                 * @param {?} element
                 * @param {?} selector
                 * @return {?}
                 */
                NoopAnimationDriver.prototype.matchesElement = function (element, selector) {
                    return matchesElement(element, selector);
                };
                /**
                 * @param {?} elm1
                 * @param {?} elm2
                 * @return {?}
                 */
                NoopAnimationDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
                /**
                 * @param {?} element
                 * @param {?} selector
                 * @param {?} multi
                 * @return {?}
                 */
                NoopAnimationDriver.prototype.query = function (element, selector, multi) {
                    return invokeQuery(element, selector, multi);
                };
                /**
                 * @param {?} element
                 * @param {?} prop
                 * @param {?=} defaultValue
                 * @return {?}
                 */
                NoopAnimationDriver.prototype.computeStyle = function (element, prop, defaultValue) {
                    return defaultValue || '';
                };
                /**
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} duration
                 * @param {?} delay
                 * @param {?} easing
                 * @param {?=} previousPlayers
                 * @param {?=} scrubberAccessRequested
                 * @return {?}
                 */
                NoopAnimationDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
                    if (previousPlayers === void 0) { previousPlayers = []; }
                    return new _angular_animations__WEBPACK_IMPORTED_MODULE_0__["NoopAnimationPlayer"](duration, delay);
                };
                return NoopAnimationDriver;
            }());
            NoopAnimationDriver.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /**
             * \@publicApi
             * @abstract
             */
            var AnimationDriver = /** @class */ (function () {
                function AnimationDriver() {
                }
                return AnimationDriver;
            }());
            AnimationDriver.NOOP = new NoopAnimationDriver();
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var ONE_SECOND = 1000;
            /** @type {?} */
            var SUBSTITUTION_EXPR_START = '{{';
            /** @type {?} */
            var SUBSTITUTION_EXPR_END = '}}';
            /** @type {?} */
            var ENTER_CLASSNAME = 'ng-enter';
            /** @type {?} */
            var LEAVE_CLASSNAME = 'ng-leave';
            /** @type {?} */
            var ENTER_SELECTOR = '.ng-enter';
            /** @type {?} */
            var LEAVE_SELECTOR = '.ng-leave';
            /** @type {?} */
            var NG_TRIGGER_CLASSNAME = 'ng-trigger';
            /** @type {?} */
            var NG_TRIGGER_SELECTOR = '.ng-trigger';
            /** @type {?} */
            var NG_ANIMATING_CLASSNAME = 'ng-animating';
            /** @type {?} */
            var NG_ANIMATING_SELECTOR = '.ng-animating';
            /**
             * @param {?} value
             * @return {?}
             */
            function resolveTimingValue(value) {
                if (typeof value == 'number')
                    return value;
                /** @type {?} */
                var matches = (( /** @type {?} */(value))).match(/^(-?[\.\d]+)(m?s)/);
                if (!matches || matches.length < 2)
                    return 0;
                return _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
            }
            /**
             * @param {?} value
             * @param {?} unit
             * @return {?}
             */
            function _convertTimeValueToMS(value, unit) {
                switch (unit) {
                    case 's':
                        return value * ONE_SECOND;
                    default: // ms or something else
                        return value;
                }
            }
            /**
             * @param {?} timings
             * @param {?} errors
             * @param {?=} allowNegativeValues
             * @return {?}
             */
            function resolveTiming(timings, errors, allowNegativeValues) {
                return timings.hasOwnProperty('duration') ?
                    ( /** @type {?} */(timings)) :
                    parseTimeExpression(( /** @type {?} */(timings)), errors, allowNegativeValues);
            }
            /**
             * @param {?} exp
             * @param {?} errors
             * @param {?=} allowNegativeValues
             * @return {?}
             */
            function parseTimeExpression(exp, errors, allowNegativeValues) {
                /** @type {?} */
                var regex = /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
                /** @type {?} */
                var duration;
                /** @type {?} */
                var delay = 0;
                /** @type {?} */
                var easing = '';
                if (typeof exp === 'string') {
                    /** @type {?} */
                    var matches = exp.match(regex);
                    if (matches === null) {
                        errors.push("The provided timing value \"" + exp + "\" is invalid.");
                        return { duration: 0, delay: 0, easing: '' };
                    }
                    duration = _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
                    /** @type {?} */
                    var delayMatch = matches[3];
                    if (delayMatch != null) {
                        delay = _convertTimeValueToMS(parseFloat(delayMatch), matches[4]);
                    }
                    /** @type {?} */
                    var easingVal = matches[5];
                    if (easingVal) {
                        easing = easingVal;
                    }
                }
                else {
                    duration = ( /** @type {?} */(exp));
                }
                if (!allowNegativeValues) {
                    /** @type {?} */
                    var containsErrors = false;
                    /** @type {?} */
                    var startIndex = errors.length;
                    if (duration < 0) {
                        errors.push("Duration values below 0 are not allowed for this animation step.");
                        containsErrors = true;
                    }
                    if (delay < 0) {
                        errors.push("Delay values below 0 are not allowed for this animation step.");
                        containsErrors = true;
                    }
                    if (containsErrors) {
                        errors.splice(startIndex, 0, "The provided timing value \"" + exp + "\" is invalid.");
                    }
                }
                return { duration: duration, delay: delay, easing: easing };
            }
            /**
             * @param {?} obj
             * @param {?=} destination
             * @return {?}
             */
            function copyObj(obj, destination) {
                if (destination === void 0) { destination = {}; }
                Object.keys(obj).forEach(( /**
                 * @param {?} prop
                 * @return {?}
                 */function (/**
                 * @param {?} prop
                 * @return {?}
                 */ prop) { destination[prop] = obj[prop]; }));
                return destination;
            }
            /**
             * @param {?} styles
             * @return {?}
             */
            function normalizeStyles(styles) {
                /** @type {?} */
                var normalizedStyles = {};
                if (Array.isArray(styles)) {
                    styles.forEach(( /**
                     * @param {?} data
                     * @return {?}
                     */function (/**
                     * @param {?} data
                     * @return {?}
                     */ data) { return copyStyles(data, false, normalizedStyles); }));
                }
                else {
                    copyStyles(styles, false, normalizedStyles);
                }
                return normalizedStyles;
            }
            /**
             * @param {?} styles
             * @param {?} readPrototype
             * @param {?=} destination
             * @return {?}
             */
            function copyStyles(styles, readPrototype, destination) {
                if (destination === void 0) { destination = {}; }
                if (readPrototype) {
                    // we make use of a for-in loop so that the
                    // prototypically inherited properties are
                    // revealed from the backFill map
                    for (var prop in styles) {
                        destination[prop] = styles[prop];
                    }
                }
                else {
                    copyObj(styles, destination);
                }
                return destination;
            }
            /**
             * @param {?} element
             * @param {?} key
             * @param {?} value
             * @return {?}
             */
            function getStyleAttributeString(element, key, value) {
                // Return the key-value pair string to be added to the style attribute for the
                // given CSS style key.
                if (value) {
                    return key + ':' + value + ';';
                }
                else {
                    return '';
                }
            }
            /**
             * @param {?} element
             * @return {?}
             */
            function writeStyleAttribute(element) {
                // Read the style property of the element and manually reflect it to the
                // style attribute. This is needed because Domino on platform-server doesn't
                // understand the full set of allowed CSS properties and doesn't reflect some
                // of them automatically.
                /** @type {?} */
                var styleAttrValue = '';
                for (var i = 0; i < element.style.length; i++) {
                    /** @type {?} */
                    var key = element.style.item(i);
                    styleAttrValue += getStyleAttributeString(element, key, element.style.getPropertyValue(key));
                }
                for (var key in element.style) {
                    // Skip internal Domino properties that don't need to be reflected.
                    if (!element.style.hasOwnProperty(key) || key.startsWith('_')) {
                        continue;
                    }
                    /** @type {?} */
                    var dashKey = camelCaseToDashCase(key);
                    styleAttrValue += getStyleAttributeString(element, dashKey, element.style[key]);
                }
                element.setAttribute('style', styleAttrValue);
            }
            /**
             * @param {?} element
             * @param {?} styles
             * @param {?=} formerStyles
             * @return {?}
             */
            function setStyles(element, styles, formerStyles) {
                if (element['style']) {
                    Object.keys(styles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var camelProp = dashCaseToCamelCase(prop);
                        if (formerStyles && !formerStyles.hasOwnProperty(prop)) {
                            formerStyles[prop] = element.style[camelProp];
                        }
                        element.style[camelProp] = styles[prop];
                    }));
                    // On the server set the 'style' attribute since it's not automatically reflected.
                    if (isNode()) {
                        writeStyleAttribute(element);
                    }
                }
            }
            /**
             * @param {?} element
             * @param {?} styles
             * @return {?}
             */
            function eraseStyles(element, styles) {
                if (element['style']) {
                    Object.keys(styles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var camelProp = dashCaseToCamelCase(prop);
                        element.style[camelProp] = '';
                    }));
                    // On the server set the 'style' attribute since it's not automatically reflected.
                    if (isNode()) {
                        writeStyleAttribute(element);
                    }
                }
            }
            /**
             * @param {?} steps
             * @return {?}
             */
            function normalizeAnimationEntry(steps) {
                if (Array.isArray(steps)) {
                    if (steps.length == 1)
                        return steps[0];
                    return Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["sequence"])(steps);
                }
                return ( /** @type {?} */(steps));
            }
            /**
             * @param {?} value
             * @param {?} options
             * @param {?} errors
             * @return {?}
             */
            function validateStyleParams(value, options, errors) {
                /** @type {?} */
                var params = options.params || {};
                /** @type {?} */
                var matches = extractStyleParams(value);
                if (matches.length) {
                    matches.forEach(( /**
                     * @param {?} varName
                     * @return {?}
                     */function (/**
                     * @param {?} varName
                     * @return {?}
                     */ varName) {
                        if (!params.hasOwnProperty(varName)) {
                            errors.push("Unable to resolve the local animation param " + varName + " in the given list of values");
                        }
                    }));
                }
            }
            /** @type {?} */
            var PARAM_REGEX = new RegExp(SUBSTITUTION_EXPR_START + "\\s*(.+?)\\s*" + SUBSTITUTION_EXPR_END, 'g');
            /**
             * @param {?} value
             * @return {?}
             */
            function extractStyleParams(value) {
                /** @type {?} */
                var params = [];
                if (typeof value === 'string') {
                    /** @type {?} */
                    var val = value.toString();
                    /** @type {?} */
                    var match = void 0;
                    while (match = PARAM_REGEX.exec(val)) {
                        params.push(( /** @type {?} */(match[1])));
                    }
                    PARAM_REGEX.lastIndex = 0;
                }
                return params;
            }
            /**
             * @param {?} value
             * @param {?} params
             * @param {?} errors
             * @return {?}
             */
            function interpolateParams(value, params, errors) {
                /** @type {?} */
                var original = value.toString();
                /** @type {?} */
                var str = original.replace(PARAM_REGEX, ( /**
                 * @param {?} _
                 * @param {?} varName
                 * @return {?}
                 */function (_, varName) {
                    /** @type {?} */
                    var localVal = params[varName];
                    // this means that the value was never overridden by the data passed in by the user
                    if (!params.hasOwnProperty(varName)) {
                        errors.push("Please provide a value for the animation param " + varName);
                        localVal = '';
                    }
                    return localVal.toString();
                }));
                // we do this to assert that numeric values stay as they are
                return str == original ? value : str;
            }
            /**
             * @param {?} iterator
             * @return {?}
             */
            function iteratorToArray(iterator) {
                /** @type {?} */
                var arr = [];
                /** @type {?} */
                var item = iterator.next();
                while (!item.done) {
                    arr.push(item.value);
                    item = iterator.next();
                }
                return arr;
            }
            /**
             * @param {?} source
             * @param {?} destination
             * @return {?}
             */
            function mergeAnimationOptions(source, destination) {
                if (source.params) {
                    /** @type {?} */
                    var p0_1 = source.params;
                    if (!destination.params) {
                        destination.params = {};
                    }
                    /** @type {?} */
                    var p1_1 = destination.params;
                    Object.keys(p0_1).forEach(( /**
                     * @param {?} param
                     * @return {?}
                     */function (/**
                     * @param {?} param
                     * @return {?}
                     */ param) {
                        if (!p1_1.hasOwnProperty(param)) {
                            p1_1[param] = p0_1[param];
                        }
                    }));
                }
                return destination;
            }
            /** @type {?} */
            var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
            /**
             * @param {?} input
             * @return {?}
             */
            function dashCaseToCamelCase(input) {
                return input.replace(DASH_CASE_REGEXP, ( /**
                 * @param {...?} m
                 * @return {?}
                 */function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    return m[1].toUpperCase();
                }));
            }
            /**
             * @param {?} input
             * @return {?}
             */
            function camelCaseToDashCase(input) {
                return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            }
            /**
             * @param {?} duration
             * @param {?} delay
             * @return {?}
             */
            function allowPreviousPlayerStylesMerge(duration, delay) {
                return duration === 0 || delay === 0;
            }
            /**
             * @param {?} element
             * @param {?} keyframes
             * @param {?} previousStyles
             * @return {?}
             */
            function balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles) {
                /** @type {?} */
                var previousStyleProps = Object.keys(previousStyles);
                if (previousStyleProps.length && keyframes.length) {
                    /** @type {?} */
                    var startingKeyframe_1 = keyframes[0];
                    /** @type {?} */
                    var missingStyleProps_1 = [];
                    previousStyleProps.forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        if (!startingKeyframe_1.hasOwnProperty(prop)) {
                            missingStyleProps_1.push(prop);
                        }
                        startingKeyframe_1[prop] = previousStyles[prop];
                    }));
                    if (missingStyleProps_1.length) {
                        var _loop_1 = function () {
                            /** @type {?} */
                            var kf = keyframes[i];
                            missingStyleProps_1.forEach(( /**
                             * @param {?} prop
                             * @return {?}
                             */function (prop) { kf[prop] = computeStyle(element, prop); }));
                        };
                        // tslint:disable-next-line
                        for (var i = 1; i < keyframes.length; i++) {
                            _loop_1();
                        }
                    }
                }
                return keyframes;
            }
            /**
             * @param {?} visitor
             * @param {?} node
             * @param {?} context
             * @return {?}
             */
            function visitDslNode(visitor, node, context) {
                switch (node.type) {
                    case 7 /* Trigger */:
                        return visitor.visitTrigger(node, context);
                    case 0 /* State */:
                        return visitor.visitState(node, context);
                    case 1 /* Transition */:
                        return visitor.visitTransition(node, context);
                    case 2 /* Sequence */:
                        return visitor.visitSequence(node, context);
                    case 3 /* Group */:
                        return visitor.visitGroup(node, context);
                    case 4 /* Animate */:
                        return visitor.visitAnimate(node, context);
                    case 5 /* Keyframes */:
                        return visitor.visitKeyframes(node, context);
                    case 6 /* Style */:
                        return visitor.visitStyle(node, context);
                    case 8 /* Reference */:
                        return visitor.visitReference(node, context);
                    case 9 /* AnimateChild */:
                        return visitor.visitAnimateChild(node, context);
                    case 10 /* AnimateRef */:
                        return visitor.visitAnimateRef(node, context);
                    case 11 /* Query */:
                        return visitor.visitQuery(node, context);
                    case 12 /* Stagger */:
                        return visitor.visitStagger(node, context);
                    default:
                        throw new Error("Unable to resolve animation metadata node #" + node.type);
                }
            }
            /**
             * @param {?} element
             * @param {?} prop
             * @return {?}
             */
            function computeStyle(element, prop) {
                return (( /** @type {?} */(window.getComputedStyle(element))))[prop];
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             * @type {?}
             */
            var ANY_STATE = '*';
            /**
             * @param {?} transitionValue
             * @param {?} errors
             * @return {?}
             */
            function parseTransitionExpr(transitionValue, errors) {
                /** @type {?} */
                var expressions = [];
                if (typeof transitionValue == 'string') {
                    (( /** @type {?} */(transitionValue)))
                        .split(/\s*,\s*/)
                        .forEach(( /**
                 * @param {?} str
                 * @return {?}
                 */function (/**
                 * @param {?} str
                 * @return {?}
                 */ str) { return parseInnerTransitionStr(str, expressions, errors); }));
                }
                else {
                    expressions.push(( /** @type {?} */(transitionValue)));
                }
                return expressions;
            }
            /**
             * @param {?} eventStr
             * @param {?} expressions
             * @param {?} errors
             * @return {?}
             */
            function parseInnerTransitionStr(eventStr, expressions, errors) {
                if (eventStr[0] == ':') {
                    /** @type {?} */
                    var result = parseAnimationAlias(eventStr, errors);
                    if (typeof result == 'function') {
                        expressions.push(result);
                        return;
                    }
                    eventStr = ( /** @type {?} */(result));
                }
                /** @type {?} */
                var match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
                if (match == null || match.length < 4) {
                    errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
                    return expressions;
                }
                /** @type {?} */
                var fromState = match[1];
                /** @type {?} */
                var separator = match[2];
                /** @type {?} */
                var toState = match[3];
                expressions.push(makeLambdaFromStates(fromState, toState));
                /** @type {?} */
                var isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
                if (separator[0] == '<' && !isFullAnyStateExpr) {
                    expressions.push(makeLambdaFromStates(toState, fromState));
                }
            }
            /**
             * @param {?} alias
             * @param {?} errors
             * @return {?}
             */
            function parseAnimationAlias(alias, errors) {
                switch (alias) {
                    case ':enter':
                        return 'void => *';
                    case ':leave':
                        return '* => void';
                    case ':increment':
                        return ( /**
                         * @param {?} fromState
                         * @param {?} toState
                         * @return {?}
                         */function (fromState, toState) { return parseFloat(toState) > parseFloat(fromState); });
                    case ':decrement':
                        return ( /**
                         * @param {?} fromState
                         * @param {?} toState
                         * @return {?}
                         */function (fromState, toState) { return parseFloat(toState) < parseFloat(fromState); });
                    default:
                        errors.push("The transition alias value \"" + alias + "\" is not supported");
                        return '* => *';
                }
            }
            // DO NOT REFACTOR ... keep the follow set instantiations
            // with the values intact (closure compiler for some reason
            // removes follow-up lines that add the values outside of
            // the constructor...
            /** @type {?} */
            var TRUE_BOOLEAN_VALUES = new Set(['true', '1']);
            /** @type {?} */
            var FALSE_BOOLEAN_VALUES = new Set(['false', '0']);
            /**
             * @param {?} lhs
             * @param {?} rhs
             * @return {?}
             */
            function makeLambdaFromStates(lhs, rhs) {
                /** @type {?} */
                var LHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(lhs) || FALSE_BOOLEAN_VALUES.has(lhs);
                /** @type {?} */
                var RHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(rhs) || FALSE_BOOLEAN_VALUES.has(rhs);
                return ( /**
                 * @param {?} fromState
                 * @param {?} toState
                 * @return {?}
                 */function (fromState, toState) {
                    /** @type {?} */
                    var lhsMatch = lhs == ANY_STATE || lhs == fromState;
                    /** @type {?} */
                    var rhsMatch = rhs == ANY_STATE || rhs == toState;
                    if (!lhsMatch && LHS_MATCH_BOOLEAN && typeof fromState === 'boolean') {
                        lhsMatch = fromState ? TRUE_BOOLEAN_VALUES.has(lhs) : FALSE_BOOLEAN_VALUES.has(lhs);
                    }
                    if (!rhsMatch && RHS_MATCH_BOOLEAN && typeof toState === 'boolean') {
                        rhsMatch = toState ? TRUE_BOOLEAN_VALUES.has(rhs) : FALSE_BOOLEAN_VALUES.has(rhs);
                    }
                    return lhsMatch && rhsMatch;
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var SELF_TOKEN = ':self';
            /** @type {?} */
            var SELF_TOKEN_REGEX = new RegExp("s*" + SELF_TOKEN + "s*,?", 'g');
            /*
             * [Validation]
             * The visitor code below will traverse the animation AST generated by the animation verb functions
             * (the output is a tree of objects) and attempt to perform a series of validations on the data. The
             * following corner-cases will be validated:
             *
             * 1. Overlap of animations
             * Given that a CSS property cannot be animated in more than one place at the same time, it's
             * important that this behavior is detected and validated. The way in which this occurs is that
             * each time a style property is examined, a string-map containing the property will be updated with
             * the start and end times for when the property is used within an animation step.
             *
             * If there are two or more parallel animations that are currently running (these are invoked by the
             * group()) on the same element then the validator will throw an error. Since the start/end timing
             * values are collected for each property then if the current animation step is animating the same
             * property and its timing values fall anywhere into the window of time that the property is
             * currently being animated within then this is what causes an error.
             *
             * 2. Timing values
             * The validator will validate to see if a timing value of `duration delay easing` or
             * `durationNumber` is valid or not.
             *
             * (note that upon validation the code below will replace the timing data with an object containing
             * {duration,delay,easing}.
             *
             * 3. Offset Validation
             * Each of the style() calls are allowed to have an offset value when placed inside of keyframes().
             * Offsets within keyframes() are considered valid when:
             *
             *   - No offsets are used at all
             *   - Each style() entry contains an offset value
             *   - Each offset is between 0 and 1
             *   - Each offset is greater to or equal than the previous one
             *
             * Otherwise an error will be thrown.
             */
            /**
             * @param {?} driver
             * @param {?} metadata
             * @param {?} errors
             * @return {?}
             */
            function buildAnimationAst(driver, metadata, errors) {
                return new AnimationAstBuilderVisitor(driver).build(metadata, errors);
            }
            /** @type {?} */
            var ROOT_SELECTOR = '';
            var AnimationAstBuilderVisitor = /** @class */ (function () {
                /**
                 * @param {?} _driver
                 */
                function AnimationAstBuilderVisitor(_driver) {
                    this._driver = _driver;
                }
                /**
                 * @param {?} metadata
                 * @param {?} errors
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.build = function (metadata, errors) {
                    /** @type {?} */
                    var context = new AnimationAstBuilderContext(errors);
                    this._resetContextStyleTimingState(context);
                    return ( /** @type {?} */(visitDslNode(this, normalizeAnimationEntry(metadata), context)));
                };
                /**
                 * @private
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype._resetContextStyleTimingState = function (context) {
                    context.currentQuerySelector = ROOT_SELECTOR;
                    context.collectedStyles = {};
                    context.collectedStyles[ROOT_SELECTOR] = {};
                    context.currentTime = 0;
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitTrigger = function (metadata, context) {
                    var _this = this;
                    /** @type {?} */
                    var queryCount = context.queryCount = 0;
                    /** @type {?} */
                    var depCount = context.depCount = 0;
                    /** @type {?} */
                    var states = [];
                    /** @type {?} */
                    var transitions = [];
                    if (metadata.name.charAt(0) == '@') {
                        context.errors.push('animation triggers cannot be prefixed with an `@` sign (e.g. trigger(\'@foo\', [...]))');
                    }
                    metadata.definitions.forEach(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) {
                        _this._resetContextStyleTimingState(context);
                        if (def.type == 0 /* State */) {
                            /** @type {?} */
                            var stateDef_1 = ( /** @type {?} */(def));
                            /** @type {?} */
                            var name = stateDef_1.name;
                            name.toString().split(/\s*,\s*/).forEach(( /**
                             * @param {?} n
                             * @return {?}
                             */function (/**
                             * @param {?} n
                             * @return {?}
                             */ n) {
                                stateDef_1.name = n;
                                states.push(_this.visitState(stateDef_1, context));
                            }));
                            stateDef_1.name = name;
                        }
                        else if (def.type == 1 /* Transition */) {
                            /** @type {?} */
                            var transition = _this.visitTransition(( /** @type {?} */(def)), context);
                            queryCount += transition.queryCount;
                            depCount += transition.depCount;
                            transitions.push(transition);
                        }
                        else {
                            context.errors.push('only state() and transition() definitions can sit inside of a trigger()');
                        }
                    }));
                    return {
                        type: 7 /* Trigger */,
                        name: metadata.name, states: states, transitions: transitions, queryCount: queryCount, depCount: depCount,
                        options: null
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitState = function (metadata, context) {
                    /** @type {?} */
                    var styleAst = this.visitStyle(metadata.styles, context);
                    /** @type {?} */
                    var astParams = (metadata.options && metadata.options.params) || null;
                    if (styleAst.containsDynamicStyles) {
                        /** @type {?} */
                        var missingSubs_1 = new Set();
                        /** @type {?} */
                        var params_1 = astParams || {};
                        styleAst.styles.forEach(( /**
                         * @param {?} value
                         * @return {?}
                         */function (/**
                         * @param {?} value
                         * @return {?}
                         */ value) {
                            if (isObject(value)) {
                                /** @type {?} */
                                var stylesObj_1 = ( /** @type {?} */(value));
                                Object.keys(stylesObj_1).forEach(( /**
                                 * @param {?} prop
                                 * @return {?}
                                 */function (/**
                                 * @param {?} prop
                                 * @return {?}
                                 */ prop) {
                                    extractStyleParams(stylesObj_1[prop]).forEach(( /**
                                     * @param {?} sub
                                     * @return {?}
                                     */function (/**
                                     * @param {?} sub
                                     * @return {?}
                                     */ sub) {
                                        if (!params_1.hasOwnProperty(sub)) {
                                            missingSubs_1.add(sub);
                                        }
                                    }));
                                }));
                            }
                        }));
                        if (missingSubs_1.size) {
                            /** @type {?} */
                            var missingSubsArr = iteratorToArray(missingSubs_1.values());
                            context.errors.push("state(\"" + metadata.name + "\", ...) must define default values for all the following style substitutions: " + missingSubsArr.join(', '));
                        }
                    }
                    return {
                        type: 0 /* State */,
                        name: metadata.name,
                        style: styleAst,
                        options: astParams ? { params: astParams } : null
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitTransition = function (metadata, context) {
                    context.queryCount = 0;
                    context.depCount = 0;
                    /** @type {?} */
                    var animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
                    /** @type {?} */
                    var matchers = parseTransitionExpr(metadata.expr, context.errors);
                    return {
                        type: 1 /* Transition */,
                        matchers: matchers,
                        animation: animation,
                        queryCount: context.queryCount,
                        depCount: context.depCount,
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitSequence = function (metadata, context) {
                    var _this = this;
                    return {
                        type: 2 /* Sequence */,
                        steps: metadata.steps.map(( /**
                         * @param {?} s
                         * @return {?}
                         */function (/**
                         * @param {?} s
                         * @return {?}
                         */ s) { return visitDslNode(_this, s, context); })),
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitGroup = function (metadata, context) {
                    var _this = this;
                    /** @type {?} */
                    var currentTime = context.currentTime;
                    /** @type {?} */
                    var furthestTime = 0;
                    /** @type {?} */
                    var steps = metadata.steps.map(( /**
                     * @param {?} step
                     * @return {?}
                     */function (/**
                     * @param {?} step
                     * @return {?}
                     */ step) {
                        context.currentTime = currentTime;
                        /** @type {?} */
                        var innerAst = visitDslNode(_this, step, context);
                        furthestTime = Math.max(furthestTime, context.currentTime);
                        return innerAst;
                    }));
                    context.currentTime = furthestTime;
                    return {
                        type: 3 /* Group */,
                        steps: steps,
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitAnimate = function (metadata, context) {
                    /** @type {?} */
                    var timingAst = constructTimingAst(metadata.timings, context.errors);
                    context.currentAnimateTimings = timingAst;
                    /** @type {?} */
                    var styleAst;
                    /** @type {?} */
                    var styleMetadata = metadata.styles ? metadata.styles : Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({});
                    if (styleMetadata.type == 5 /* Keyframes */) {
                        styleAst = this.visitKeyframes(( /** @type {?} */(styleMetadata)), context);
                    }
                    else {
                        /** @type {?} */
                        var styleMetadata_1 = ( /** @type {?} */(metadata.styles));
                        /** @type {?} */
                        var isEmpty = false;
                        if (!styleMetadata_1) {
                            isEmpty = true;
                            /** @type {?} */
                            var newStyleData = {};
                            if (timingAst.easing) {
                                newStyleData['easing'] = timingAst.easing;
                            }
                            styleMetadata_1 = Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])(newStyleData);
                        }
                        context.currentTime += timingAst.duration + timingAst.delay;
                        /** @type {?} */
                        var _styleAst = this.visitStyle(styleMetadata_1, context);
                        _styleAst.isEmptyStep = isEmpty;
                        styleAst = _styleAst;
                    }
                    context.currentAnimateTimings = null;
                    return {
                        type: 4 /* Animate */,
                        timings: timingAst,
                        style: styleAst,
                        options: null
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitStyle = function (metadata, context) {
                    /** @type {?} */
                    var ast = this._makeStyleAst(metadata, context);
                    this._validateStyleAst(ast, context);
                    return ast;
                };
                /**
                 * @private
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype._makeStyleAst = function (metadata, context) {
                    /** @type {?} */
                    var styles = [];
                    if (Array.isArray(metadata.styles)) {
                        (( /** @type {?} */(metadata.styles))).forEach(( /**
                         * @param {?} styleTuple
                         * @return {?}
                         */function (/**
                         * @param {?} styleTuple
                         * @return {?}
                         */ styleTuple) {
                            if (typeof styleTuple == 'string') {
                                if (styleTuple == _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"]) {
                                    styles.push(( /** @type {?} */(styleTuple)));
                                }
                                else {
                                    context.errors.push("The provided style string value " + styleTuple + " is not allowed.");
                                }
                            }
                            else {
                                styles.push(( /** @type {?} */(styleTuple)));
                            }
                        }));
                    }
                    else {
                        styles.push(metadata.styles);
                    }
                    /** @type {?} */
                    var containsDynamicStyles = false;
                    /** @type {?} */
                    var collectedEasing = null;
                    styles.forEach(( /**
                     * @param {?} styleData
                     * @return {?}
                     */function (/**
                     * @param {?} styleData
                     * @return {?}
                     */ styleData) {
                        if (isObject(styleData)) {
                            /** @type {?} */
                            var styleMap = ( /** @type {?} */(styleData));
                            /** @type {?} */
                            var easing = styleMap['easing'];
                            if (easing) {
                                collectedEasing = ( /** @type {?} */(easing));
                                delete styleMap['easing'];
                            }
                            if (!containsDynamicStyles) {
                                for (var prop in styleMap) {
                                    /** @type {?} */
                                    var value = styleMap[prop];
                                    if (value.toString().indexOf(SUBSTITUTION_EXPR_START) >= 0) {
                                        containsDynamicStyles = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }));
                    return {
                        type: 6 /* Style */,
                        styles: styles,
                        easing: collectedEasing,
                        offset: metadata.offset, containsDynamicStyles: containsDynamicStyles,
                        options: null
                    };
                };
                /**
                 * @private
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype._validateStyleAst = function (ast, context) {
                    var _this = this;
                    /** @type {?} */
                    var timings = context.currentAnimateTimings;
                    /** @type {?} */
                    var endTime = context.currentTime;
                    /** @type {?} */
                    var startTime = context.currentTime;
                    if (timings && startTime > 0) {
                        startTime -= timings.duration + timings.delay;
                    }
                    ast.styles.forEach(( /**
                     * @param {?} tuple
                     * @return {?}
                     */function (/**
                     * @param {?} tuple
                     * @return {?}
                     */ tuple) {
                        if (typeof tuple == 'string')
                            return;
                        Object.keys(tuple).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            if (!_this._driver.validateStyleProperty(prop)) {
                                context.errors.push("The provided animation property \"" + prop + "\" is not a supported CSS property for animations");
                                return;
                            }
                            /** @type {?} */
                            var collectedStyles = context.collectedStyles[( /** @type {?} */(context.currentQuerySelector))];
                            /** @type {?} */
                            var collectedEntry = collectedStyles[prop];
                            /** @type {?} */
                            var updateCollectedStyle = true;
                            if (collectedEntry) {
                                if (startTime != endTime && startTime >= collectedEntry.startTime &&
                                    endTime <= collectedEntry.endTime) {
                                    context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
                                    updateCollectedStyle = false;
                                }
                                // we always choose the smaller start time value since we
                                // want to have a record of the entire animation window where
                                // the style property is being animated in between
                                startTime = collectedEntry.startTime;
                            }
                            if (updateCollectedStyle) {
                                collectedStyles[prop] = { startTime: startTime, endTime: endTime };
                            }
                            if (context.options) {
                                validateStyleParams(tuple[prop], context.options, context.errors);
                            }
                        }));
                    }));
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitKeyframes = function (metadata, context) {
                    var _this = this;
                    /** @type {?} */
                    var ast = { type: 5 /* Keyframes */, styles: [], options: null };
                    if (!context.currentAnimateTimings) {
                        context.errors.push("keyframes() must be placed inside of a call to animate()");
                        return ast;
                    }
                    /** @type {?} */
                    var MAX_KEYFRAME_OFFSET = 1;
                    /** @type {?} */
                    var totalKeyframesWithOffsets = 0;
                    /** @type {?} */
                    var offsets = [];
                    /** @type {?} */
                    var offsetsOutOfOrder = false;
                    /** @type {?} */
                    var keyframesOutOfRange = false;
                    /** @type {?} */
                    var previousOffset = 0;
                    /** @type {?} */
                    var keyframes = metadata.steps.map(( /**
                     * @param {?} styles
                     * @return {?}
                     */function (/**
                     * @param {?} styles
                     * @return {?}
                     */ styles) {
                        /** @type {?} */
                        var style = _this._makeStyleAst(styles, context);
                        /** @type {?} */
                        var offsetVal = style.offset != null ? style.offset : consumeOffset(style.styles);
                        /** @type {?} */
                        var offset = 0;
                        if (offsetVal != null) {
                            totalKeyframesWithOffsets++;
                            offset = style.offset = offsetVal;
                        }
                        keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
                        offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
                        previousOffset = offset;
                        offsets.push(offset);
                        return style;
                    }));
                    if (keyframesOutOfRange) {
                        context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
                    }
                    if (offsetsOutOfOrder) {
                        context.errors.push("Please ensure that all keyframe offsets are in order");
                    }
                    /** @type {?} */
                    var length = metadata.steps.length;
                    /** @type {?} */
                    var generatedOffset = 0;
                    if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
                        context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
                    }
                    else if (totalKeyframesWithOffsets == 0) {
                        generatedOffset = MAX_KEYFRAME_OFFSET / (length - 1);
                    }
                    /** @type {?} */
                    var limit = length - 1;
                    /** @type {?} */
                    var currentTime = context.currentTime;
                    /** @type {?} */
                    var currentAnimateTimings = ( /** @type {?} */(context.currentAnimateTimings));
                    /** @type {?} */
                    var animateDuration = currentAnimateTimings.duration;
                    keyframes.forEach(( /**
                     * @param {?} kf
                     * @param {?} i
                     * @return {?}
                     */function (kf, i) {
                        /** @type {?} */
                        var offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
                        /** @type {?} */
                        var durationUpToThisFrame = offset * animateDuration;
                        context.currentTime = currentTime + currentAnimateTimings.delay + durationUpToThisFrame;
                        currentAnimateTimings.duration = durationUpToThisFrame;
                        _this._validateStyleAst(kf, context);
                        kf.offset = offset;
                        ast.styles.push(kf);
                    }));
                    return ast;
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitReference = function (metadata, context) {
                    return {
                        type: 8 /* Reference */,
                        animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context),
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitAnimateChild = function (metadata, context) {
                    context.depCount++;
                    return {
                        type: 9 /* AnimateChild */,
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitAnimateRef = function (metadata, context) {
                    return {
                        type: 10 /* AnimateRef */,
                        animation: this.visitReference(metadata.animation, context),
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitQuery = function (metadata, context) {
                    /** @type {?} */
                    var parentSelector = ( /** @type {?} */(context.currentQuerySelector));
                    /** @type {?} */
                    var options = ( /** @type {?} */((metadata.options || {})));
                    context.queryCount++;
                    context.currentQuery = metadata;
                    var _c = normalizeSelector(metadata.selector), selector = _c[0], includeSelf = _c[1];
                    context.currentQuerySelector =
                        parentSelector.length ? (parentSelector + ' ' + selector) : selector;
                    getOrSetAsInMap(context.collectedStyles, context.currentQuerySelector, {});
                    /** @type {?} */
                    var animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
                    context.currentQuery = null;
                    context.currentQuerySelector = parentSelector;
                    return {
                        type: 11 /* Query */,
                        selector: selector,
                        limit: options.limit || 0,
                        optional: !!options.optional, includeSelf: includeSelf, animation: animation,
                        originalSelector: metadata.selector,
                        options: normalizeAnimationOptions(metadata.options)
                    };
                };
                /**
                 * @param {?} metadata
                 * @param {?} context
                 * @return {?}
                 */
                AnimationAstBuilderVisitor.prototype.visitStagger = function (metadata, context) {
                    if (!context.currentQuery) {
                        context.errors.push("stagger() can only be used inside of query()");
                    }
                    /** @type {?} */
                    var timings = metadata.timings === 'full' ?
                        { duration: 0, delay: 0, easing: 'full' } :
                        resolveTiming(metadata.timings, context.errors, true);
                    return {
                        type: 12 /* Stagger */,
                        animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context), timings: timings,
                        options: null
                    };
                };
                return AnimationAstBuilderVisitor;
            }());
            if (false) { }
            /**
             * @param {?} selector
             * @return {?}
             */
            function normalizeSelector(selector) {
                /** @type {?} */
                var hasAmpersand = selector.split(/\s*,\s*/).find(( /**
                 * @param {?} token
                 * @return {?}
                 */function (/**
                 * @param {?} token
                 * @return {?}
                 */ token) { return token == SELF_TOKEN; })) ? true : false;
                if (hasAmpersand) {
                    selector = selector.replace(SELF_TOKEN_REGEX, '');
                }
                // the :enter and :leave selectors are filled in at runtime during timeline building
                selector = selector.replace(/@\*/g, NG_TRIGGER_SELECTOR)
                    .replace(/@\w+/g, ( /**
             * @param {?} match
             * @return {?}
             */function (/**
             * @param {?} match
             * @return {?}
             */ match) { return NG_TRIGGER_SELECTOR + '-' + match.substr(1); }))
                    .replace(/:animating/g, NG_ANIMATING_SELECTOR);
                return [selector, hasAmpersand];
            }
            /**
             * @param {?} obj
             * @return {?}
             */
            function normalizeParams(obj) {
                return obj ? copyObj(obj) : null;
            }
            var AnimationAstBuilderContext = /** @class */ (function () {
                /**
                 * @param {?} errors
                 */
                function AnimationAstBuilderContext(errors) {
                    this.errors = errors;
                    this.queryCount = 0;
                    this.depCount = 0;
                    this.currentTransition = null;
                    this.currentQuery = null;
                    this.currentQuerySelector = null;
                    this.currentAnimateTimings = null;
                    this.currentTime = 0;
                    this.collectedStyles = {};
                    this.options = null;
                }
                return AnimationAstBuilderContext;
            }());
            if (false) { }
            /**
             * @param {?} styles
             * @return {?}
             */
            function consumeOffset(styles) {
                if (typeof styles == 'string')
                    return null;
                /** @type {?} */
                var offset = null;
                if (Array.isArray(styles)) {
                    styles.forEach(( /**
                     * @param {?} styleTuple
                     * @return {?}
                     */function (/**
                     * @param {?} styleTuple
                     * @return {?}
                     */ styleTuple) {
                        if (isObject(styleTuple) && styleTuple.hasOwnProperty('offset')) {
                            /** @type {?} */
                            var obj = ( /** @type {?} */(styleTuple));
                            offset = parseFloat(( /** @type {?} */(obj['offset'])));
                            delete obj['offset'];
                        }
                    }));
                }
                else if (isObject(styles) && styles.hasOwnProperty('offset')) {
                    /** @type {?} */
                    var obj = ( /** @type {?} */(styles));
                    offset = parseFloat(( /** @type {?} */(obj['offset'])));
                    delete obj['offset'];
                }
                return offset;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isObject(value) {
                return !Array.isArray(value) && typeof value == 'object';
            }
            /**
             * @param {?} value
             * @param {?} errors
             * @return {?}
             */
            function constructTimingAst(value, errors) {
                /** @type {?} */
                var timings = null;
                if (value.hasOwnProperty('duration')) {
                    timings = ( /** @type {?} */(value));
                }
                else if (typeof value == 'number') {
                    /** @type {?} */
                    var duration = resolveTiming(( /** @type {?} */(value)), errors).duration;
                    return makeTimingAst(( /** @type {?} */(duration)), 0, '');
                }
                /** @type {?} */
                var strValue = ( /** @type {?} */(value));
                /** @type {?} */
                var isDynamic = strValue.split(/\s+/).some(( /**
                 * @param {?} v
                 * @return {?}
                 */function (/**
                 * @param {?} v
                 * @return {?}
                 */ v) { return v.charAt(0) == '{' && v.charAt(1) == '{'; }));
                if (isDynamic) {
                    /** @type {?} */
                    var ast = ( /** @type {?} */(makeTimingAst(0, 0, '')));
                    ast.dynamic = true;
                    ast.strValue = strValue;
                    return ( /** @type {?} */(ast));
                }
                timings = timings || resolveTiming(strValue, errors);
                return makeTimingAst(timings.duration, timings.delay, timings.easing);
            }
            /**
             * @param {?} options
             * @return {?}
             */
            function normalizeAnimationOptions(options) {
                if (options) {
                    options = copyObj(options);
                    if (options['params']) {
                        options['params'] = ( /** @type {?} */(normalizeParams(options['params'])));
                    }
                }
                else {
                    options = {};
                }
                return options;
            }
            /**
             * @param {?} duration
             * @param {?} delay
             * @param {?} easing
             * @return {?}
             */
            function makeTimingAst(duration, delay, easing) {
                return { duration: duration, delay: delay, easing: easing };
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function AnimationTimelineInstruction() { }
            if (false) { }
            /**
             * @param {?} element
             * @param {?} keyframes
             * @param {?} preStyleProps
             * @param {?} postStyleProps
             * @param {?} duration
             * @param {?} delay
             * @param {?=} easing
             * @param {?=} subTimeline
             * @return {?}
             */
            function createTimelineInstruction(element, keyframes, preStyleProps, postStyleProps, duration, delay, easing, subTimeline) {
                if (easing === void 0) { easing = null; }
                if (subTimeline === void 0) { subTimeline = false; }
                return {
                    type: 1 /* TimelineAnimation */,
                    element: element,
                    keyframes: keyframes,
                    preStyleProps: preStyleProps,
                    postStyleProps: postStyleProps,
                    duration: duration,
                    delay: delay,
                    totalTime: duration + delay, easing: easing, subTimeline: subTimeline
                };
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ElementInstructionMap = /** @class */ (function () {
                function ElementInstructionMap() {
                    this._map = new Map();
                }
                /**
                 * @param {?} element
                 * @return {?}
                 */
                ElementInstructionMap.prototype.consume = function (element) {
                    /** @type {?} */
                    var instructions = this._map.get(element);
                    if (instructions) {
                        this._map.delete(element);
                    }
                    else {
                        instructions = [];
                    }
                    return instructions;
                };
                /**
                 * @param {?} element
                 * @param {?} instructions
                 * @return {?}
                 */
                ElementInstructionMap.prototype.append = function (element, instructions) {
                    /** @type {?} */
                    var existingInstructions = this._map.get(element);
                    if (!existingInstructions) {
                        this._map.set(element, existingInstructions = []);
                    }
                    existingInstructions.push.apply(existingInstructions, instructions);
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                ElementInstructionMap.prototype.has = function (element) { return this._map.has(element); };
                /**
                 * @return {?}
                 */
                ElementInstructionMap.prototype.clear = function () { this._map.clear(); };
                return ElementInstructionMap;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var ONE_FRAME_IN_MILLISECONDS = 1;
            /** @type {?} */
            var ENTER_TOKEN = ':enter';
            /** @type {?} */
            var ENTER_TOKEN_REGEX = new RegExp(ENTER_TOKEN, 'g');
            /** @type {?} */
            var LEAVE_TOKEN = ':leave';
            /** @type {?} */
            var LEAVE_TOKEN_REGEX = new RegExp(LEAVE_TOKEN, 'g');
            /*
             * The code within this file aims to generate web-animations-compatible keyframes from Angular's
             * animation DSL code.
             *
             * The code below will be converted from:
             *
             * ```
             * sequence([
             *   style({ opacity: 0 }),
             *   animate(1000, style({ opacity: 0 }))
             * ])
             * ```
             *
             * To:
             * ```
             * keyframes = [{ opacity: 0, offset: 0 }, { opacity: 1, offset: 1 }]
             * duration = 1000
             * delay = 0
             * easing = ''
             * ```
             *
             * For this operation to cover the combination of animation verbs (style, animate, group, etc...) a
             * combination of prototypical inheritance, AST traversal and merge-sort-like algorithms are used.
             *
             * [AST Traversal]
             * Each of the animation verbs, when executed, will return an string-map object representing what
             * type of action it is (style, animate, group, etc...) and the data associated with it. This means
             * that when functional composition mix of these functions is evaluated (like in the example above)
             * then it will end up producing a tree of objects representing the animation itself.
             *
             * When this animation object tree is processed by the visitor code below it will visit each of the
             * verb statements within the visitor. And during each visit it will build the context of the
             * animation keyframes by interacting with the `TimelineBuilder`.
             *
             * [TimelineBuilder]
             * This class is responsible for tracking the styles and building a series of keyframe objects for a
             * timeline between a start and end time. The builder starts off with an initial timeline and each
             * time the AST comes across a `group()`, `keyframes()` or a combination of the two wihtin a
             * `sequence()` then it will generate a sub timeline for each step as well as a new one after
             * they are complete.
             *
             * As the AST is traversed, the timing state on each of the timelines will be incremented. If a sub
             * timeline was created (based on one of the cases above) then the parent timeline will attempt to
             * merge the styles used within the sub timelines into itself (only with group() this will happen).
             * This happens with a merge operation (much like how the merge works in mergesort) and it will only
             * copy the most recently used styles from the sub timelines into the parent timeline. This ensures
             * that if the styles are used later on in another phase of the animation then they will be the most
             * up-to-date values.
             *
             * [How Missing Styles Are Updated]
             * Each timeline has a `backFill` property which is responsible for filling in new styles into
             * already processed keyframes if a new style shows up later within the animation sequence.
             *
             * ```
             * sequence([
             *   style({ width: 0 }),
             *   animate(1000, style({ width: 100 })),
             *   animate(1000, style({ width: 200 })),
             *   animate(1000, style({ width: 300 }))
             *   animate(1000, style({ width: 400, height: 400 })) // notice how `height` doesn't exist anywhere
             * else
             * ])
             * ```
             *
             * What is happening here is that the `height` value is added later in the sequence, but is missing
             * from all previous animation steps. Therefore when a keyframe is created it would also be missing
             * from all previous keyframes up until where it is first used. For the timeline keyframe generation
             * to properly fill in the style it will place the previous value (the value from the parent
             * timeline) or a default value of `*` into the backFill object. Given that each of the keyframe
             * styles are objects that prototypically inhert from the backFill object, this means that if a
             * value is added into the backFill then it will automatically propagate any missing values to all
             * keyframes. Therefore the missing `height` value will be properly filled into the already
             * processed keyframes.
             *
             * When a sub-timeline is created it will have its own backFill property. This is done so that
             * styles present within the sub-timeline do not accidentally seep into the previous/future timeline
             * keyframes
             *
             * (For prototypically-inherited contents to be detected a `for(i in obj)` loop must be used.)
             *
             * [Validation]
             * The code in this file is not responsible for validation. That functionality happens with within
             * the `AnimationValidatorVisitor` code.
             */
            /**
             * @param {?} driver
             * @param {?} rootElement
             * @param {?} ast
             * @param {?} enterClassName
             * @param {?} leaveClassName
             * @param {?=} startingStyles
             * @param {?=} finalStyles
             * @param {?=} options
             * @param {?=} subInstructions
             * @param {?=} errors
             * @return {?}
             */
            function buildAnimationTimelines(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
                if (startingStyles === void 0) { startingStyles = {}; }
                if (finalStyles === void 0) { finalStyles = {}; }
                if (errors === void 0) { errors = []; }
                return new AnimationTimelineBuilderVisitor().buildKeyframes(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors);
            }
            var AnimationTimelineBuilderVisitor = /** @class */ (function () {
                function AnimationTimelineBuilderVisitor() {
                }
                /**
                 * @param {?} driver
                 * @param {?} rootElement
                 * @param {?} ast
                 * @param {?} enterClassName
                 * @param {?} leaveClassName
                 * @param {?} startingStyles
                 * @param {?} finalStyles
                 * @param {?} options
                 * @param {?=} subInstructions
                 * @param {?=} errors
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.buildKeyframes = function (driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
                    if (errors === void 0) { errors = []; }
                    subInstructions = subInstructions || new ElementInstructionMap();
                    /** @type {?} */
                    var context = new AnimationTimelineContext(driver, rootElement, subInstructions, enterClassName, leaveClassName, errors, []);
                    context.options = options;
                    context.currentTimeline.setStyles([startingStyles], null, context.errors, options);
                    visitDslNode(this, ast, context);
                    // this checks to see if an actual animation happened
                    /** @type {?} */
                    var timelines = context.timelines.filter(( /**
                     * @param {?} timeline
                     * @return {?}
                     */function (/**
                     * @param {?} timeline
                     * @return {?}
                     */ timeline) { return timeline.containsAnimation(); }));
                    if (timelines.length && Object.keys(finalStyles).length) {
                        /** @type {?} */
                        var tl = timelines[timelines.length - 1];
                        if (!tl.allowOnlyTimelineStyles()) {
                            tl.setStyles([finalStyles], null, context.errors, options);
                        }
                    }
                    return timelines.length ? timelines.map(( /**
                     * @param {?} timeline
                     * @return {?}
                     */function (/**
                     * @param {?} timeline
                     * @return {?}
                     */ timeline) { return timeline.buildKeyframes(); })) :
                        [createTimelineInstruction(rootElement, [], [], [], 0, 0, '', false)];
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitTrigger = function (ast, context) {
                    // these values are not visited in this AST
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitState = function (ast, context) {
                    // these values are not visited in this AST
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitTransition = function (ast, context) {
                    // these values are not visited in this AST
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitAnimateChild = function (ast, context) {
                    /** @type {?} */
                    var elementInstructions = context.subInstructions.consume(context.element);
                    if (elementInstructions) {
                        /** @type {?} */
                        var innerContext = context.createSubContext(ast.options);
                        /** @type {?} */
                        var startTime = context.currentTimeline.currentTime;
                        /** @type {?} */
                        var endTime = this._visitSubInstructions(elementInstructions, innerContext, ( /** @type {?} */(innerContext.options)));
                        if (startTime != endTime) {
                            // we do this on the upper context because we created a sub context for
                            // the sub child animations
                            context.transformIntoNewTimeline(endTime);
                        }
                    }
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitAnimateRef = function (ast, context) {
                    /** @type {?} */
                    var innerContext = context.createSubContext(ast.options);
                    innerContext.transformIntoNewTimeline();
                    this.visitReference(ast.animation, innerContext);
                    context.transformIntoNewTimeline(innerContext.currentTimeline.currentTime);
                    context.previousNode = ast;
                };
                /**
                 * @private
                 * @param {?} instructions
                 * @param {?} context
                 * @param {?} options
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype._visitSubInstructions = function (instructions, context, options) {
                    /** @type {?} */
                    var startTime = context.currentTimeline.currentTime;
                    /** @type {?} */
                    var furthestTime = startTime;
                    // this is a special-case for when a user wants to skip a sub
                    // animation from being fired entirely.
                    /** @type {?} */
                    var duration = options.duration != null ? resolveTimingValue(options.duration) : null;
                    /** @type {?} */
                    var delay = options.delay != null ? resolveTimingValue(options.delay) : null;
                    if (duration !== 0) {
                        instructions.forEach(( /**
                         * @param {?} instruction
                         * @return {?}
                         */function (/**
                         * @param {?} instruction
                         * @return {?}
                         */ instruction) {
                            /** @type {?} */
                            var instructionTimings = context.appendInstructionToTimeline(instruction, duration, delay);
                            furthestTime =
                                Math.max(furthestTime, instructionTimings.duration + instructionTimings.delay);
                        }));
                    }
                    return furthestTime;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitReference = function (ast, context) {
                    context.updateOptions(ast.options, true);
                    visitDslNode(this, ast.animation, context);
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitSequence = function (ast, context) {
                    var _this = this;
                    /** @type {?} */
                    var subContextCount = context.subContextCount;
                    /** @type {?} */
                    var ctx = context;
                    /** @type {?} */
                    var options = ast.options;
                    if (options && (options.params || options.delay)) {
                        ctx = context.createSubContext(options);
                        ctx.transformIntoNewTimeline();
                        if (options.delay != null) {
                            if (ctx.previousNode.type == 6 /* Style */) {
                                ctx.currentTimeline.snapshotCurrentStyles();
                                ctx.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                            }
                            /** @type {?} */
                            var delay = resolveTimingValue(options.delay);
                            ctx.delayNextStep(delay);
                        }
                    }
                    if (ast.steps.length) {
                        ast.steps.forEach(( /**
                         * @param {?} s
                         * @return {?}
                         */function (/**
                         * @param {?} s
                         * @return {?}
                         */ s) { return visitDslNode(_this, s, ctx); }));
                        // this is here just incase the inner steps only contain or end with a style() call
                        ctx.currentTimeline.applyStylesToKeyframe();
                        // this means that some animation function within the sequence
                        // ended up creating a sub timeline (which means the current
                        // timeline cannot overlap with the contents of the sequence)
                        if (ctx.subContextCount > subContextCount) {
                            ctx.transformIntoNewTimeline();
                        }
                    }
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitGroup = function (ast, context) {
                    var _this = this;
                    /** @type {?} */
                    var innerTimelines = [];
                    /** @type {?} */
                    var furthestTime = context.currentTimeline.currentTime;
                    /** @type {?} */
                    var delay = ast.options && ast.options.delay ? resolveTimingValue(ast.options.delay) : 0;
                    ast.steps.forEach(( /**
                     * @param {?} s
                     * @return {?}
                     */function (/**
                     * @param {?} s
                     * @return {?}
                     */ s) {
                        /** @type {?} */
                        var innerContext = context.createSubContext(ast.options);
                        if (delay) {
                            innerContext.delayNextStep(delay);
                        }
                        visitDslNode(_this, s, innerContext);
                        furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
                        innerTimelines.push(innerContext.currentTimeline);
                    }));
                    // this operation is run after the AST loop because otherwise
                    // if the parent timeline's collected styles were updated then
                    // it would pass in invalid data into the new-to-be forked items
                    innerTimelines.forEach(( /**
                     * @param {?} timeline
                     * @return {?}
                     */function (/**
                     * @param {?} timeline
                     * @return {?}
                     */ timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); }));
                    context.transformIntoNewTimeline(furthestTime);
                    context.previousNode = ast;
                };
                /**
                 * @private
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype._visitTiming = function (ast, context) {
                    if ((( /** @type {?} */(ast))).dynamic) {
                        /** @type {?} */
                        var strValue = (( /** @type {?} */(ast))).strValue;
                        /** @type {?} */
                        var timingValue = context.params ? interpolateParams(strValue, context.params, context.errors) : strValue;
                        return resolveTiming(timingValue, context.errors);
                    }
                    else {
                        return { duration: ast.duration, delay: ast.delay, easing: ast.easing };
                    }
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitAnimate = function (ast, context) {
                    /** @type {?} */
                    var timings = context.currentAnimateTimings = this._visitTiming(ast.timings, context);
                    /** @type {?} */
                    var timeline = context.currentTimeline;
                    if (timings.delay) {
                        context.incrementTime(timings.delay);
                        timeline.snapshotCurrentStyles();
                    }
                    /** @type {?} */
                    var style = ast.style;
                    if (style.type == 5 /* Keyframes */) {
                        this.visitKeyframes(style, context);
                    }
                    else {
                        context.incrementTime(timings.duration);
                        this.visitStyle(( /** @type {?} */(style)), context);
                        timeline.applyStylesToKeyframe();
                    }
                    context.currentAnimateTimings = null;
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitStyle = function (ast, context) {
                    /** @type {?} */
                    var timeline = context.currentTimeline;
                    /** @type {?} */
                    var timings = ( /** @type {?} */(context.currentAnimateTimings));
                    // this is a special case for when a style() call
                    // directly follows  an animate() call (but not inside of an animate() call)
                    if (!timings && timeline.getCurrentStyleProperties().length) {
                        timeline.forwardFrame();
                    }
                    /** @type {?} */
                    var easing = (timings && timings.easing) || ast.easing;
                    if (ast.isEmptyStep) {
                        timeline.applyEmptyStep(easing);
                    }
                    else {
                        timeline.setStyles(ast.styles, easing, context.errors, context.options);
                    }
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitKeyframes = function (ast, context) {
                    /** @type {?} */
                    var currentAnimateTimings = ( /** @type {?} */(context.currentAnimateTimings));
                    /** @type {?} */
                    var startTime = (( /** @type {?} */(context.currentTimeline))).duration;
                    /** @type {?} */
                    var duration = currentAnimateTimings.duration;
                    /** @type {?} */
                    var innerContext = context.createSubContext();
                    /** @type {?} */
                    var innerTimeline = innerContext.currentTimeline;
                    innerTimeline.easing = currentAnimateTimings.easing;
                    ast.styles.forEach(( /**
                     * @param {?} step
                     * @return {?}
                     */function (/**
                     * @param {?} step
                     * @return {?}
                     */ step) {
                        /** @type {?} */
                        var offset = step.offset || 0;
                        innerTimeline.forwardTime(offset * duration);
                        innerTimeline.setStyles(step.styles, step.easing, context.errors, context.options);
                        innerTimeline.applyStylesToKeyframe();
                    }));
                    // this will ensure that the parent timeline gets all the styles from
                    // the child even if the new timeline below is not used
                    context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
                    // we do this because the window between this timeline and the sub timeline
                    // should ensure that the styles within are exactly the same as they were before
                    context.transformIntoNewTimeline(startTime + duration);
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitQuery = function (ast, context) {
                    var _this = this;
                    // in the event that the first step before this is a style step we need
                    // to ensure the styles are applied before the children are animated
                    /** @type {?} */
                    var startTime = context.currentTimeline.currentTime;
                    /** @type {?} */
                    var options = ( /** @type {?} */((ast.options || {})));
                    /** @type {?} */
                    var delay = options.delay ? resolveTimingValue(options.delay) : 0;
                    if (delay && (context.previousNode.type === 6 /* Style */ ||
                        (startTime == 0 && context.currentTimeline.getCurrentStyleProperties().length))) {
                        context.currentTimeline.snapshotCurrentStyles();
                        context.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                    }
                    /** @type {?} */
                    var furthestTime = startTime;
                    /** @type {?} */
                    var elms = context.invokeQuery(ast.selector, ast.originalSelector, ast.limit, ast.includeSelf, options.optional ? true : false, context.errors);
                    context.currentQueryTotal = elms.length;
                    /** @type {?} */
                    var sameElementTimeline = null;
                    elms.forEach(( /**
                     * @param {?} element
                     * @param {?} i
                     * @return {?}
                     */function (element, i) {
                        context.currentQueryIndex = i;
                        /** @type {?} */
                        var innerContext = context.createSubContext(ast.options, element);
                        if (delay) {
                            innerContext.delayNextStep(delay);
                        }
                        if (element === context.element) {
                            sameElementTimeline = innerContext.currentTimeline;
                        }
                        visitDslNode(_this, ast.animation, innerContext);
                        // this is here just incase the inner steps only contain or end
                        // with a style() call (which is here to signal that this is a preparatory
                        // call to style an element before it is animated again)
                        innerContext.currentTimeline.applyStylesToKeyframe();
                        /** @type {?} */
                        var endTime = innerContext.currentTimeline.currentTime;
                        furthestTime = Math.max(furthestTime, endTime);
                    }));
                    context.currentQueryIndex = 0;
                    context.currentQueryTotal = 0;
                    context.transformIntoNewTimeline(furthestTime);
                    if (sameElementTimeline) {
                        context.currentTimeline.mergeTimelineCollectedStyles(sameElementTimeline);
                        context.currentTimeline.snapshotCurrentStyles();
                    }
                    context.previousNode = ast;
                };
                /**
                 * @param {?} ast
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTimelineBuilderVisitor.prototype.visitStagger = function (ast, context) {
                    /** @type {?} */
                    var parentContext = ( /** @type {?} */(context.parentContext));
                    /** @type {?} */
                    var tl = context.currentTimeline;
                    /** @type {?} */
                    var timings = ast.timings;
                    /** @type {?} */
                    var duration = Math.abs(timings.duration);
                    /** @type {?} */
                    var maxTime = duration * (context.currentQueryTotal - 1);
                    /** @type {?} */
                    var delay = duration * context.currentQueryIndex;
                    /** @type {?} */
                    var staggerTransformer = timings.duration < 0 ? 'reverse' : timings.easing;
                    switch (staggerTransformer) {
                        case 'reverse':
                            delay = maxTime - delay;
                            break;
                        case 'full':
                            delay = parentContext.currentStaggerTime;
                            break;
                    }
                    /** @type {?} */
                    var timeline = context.currentTimeline;
                    if (delay) {
                        timeline.delayNextStep(delay);
                    }
                    /** @type {?} */
                    var startingTime = timeline.currentTime;
                    visitDslNode(this, ast.animation, context);
                    context.previousNode = ast;
                    // time = duration + delay
                    // the reason why this computation is so complex is because
                    // the inner timeline may either have a delay value or a stretched
                    // keyframe depending on if a subtimeline is not used or is used.
                    parentContext.currentStaggerTime =
                        (tl.currentTime - startingTime) + (tl.startTime - parentContext.currentTimeline.startTime);
                };
                return AnimationTimelineBuilderVisitor;
            }());
            /** @type {?} */
            var DEFAULT_NOOP_PREVIOUS_NODE = ( /** @type {?} */({}));
            var AnimationTimelineContext = /** @class */ (function () {
                /**
                 * @param {?} _driver
                 * @param {?} element
                 * @param {?} subInstructions
                 * @param {?} _enterClassName
                 * @param {?} _leaveClassName
                 * @param {?} errors
                 * @param {?} timelines
                 * @param {?=} initialTimeline
                 */
                function AnimationTimelineContext(_driver, element, subInstructions, _enterClassName, _leaveClassName, errors, timelines, initialTimeline) {
                    this._driver = _driver;
                    this.element = element;
                    this.subInstructions = subInstructions;
                    this._enterClassName = _enterClassName;
                    this._leaveClassName = _leaveClassName;
                    this.errors = errors;
                    this.timelines = timelines;
                    this.parentContext = null;
                    this.currentAnimateTimings = null;
                    this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                    this.subContextCount = 0;
                    this.options = {};
                    this.currentQueryIndex = 0;
                    this.currentQueryTotal = 0;
                    this.currentStaggerTime = 0;
                    this.currentTimeline = initialTimeline || new TimelineBuilder(this._driver, element, 0);
                    timelines.push(this.currentTimeline);
                }
                Object.defineProperty(AnimationTimelineContext.prototype, "params", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.options.params; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} options
                 * @param {?=} skipIfExists
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.updateOptions = function (options, skipIfExists) {
                    var _this = this;
                    if (!options)
                        return;
                    /** @type {?} */
                    var newOptions = ( /** @type {?} */(options));
                    /** @type {?} */
                    var optionsToUpdate = this.options;
                    // NOTE: this will get patched up when other animation methods support duration overrides
                    if (newOptions.duration != null) {
                        (( /** @type {?} */(optionsToUpdate))).duration = resolveTimingValue(newOptions.duration);
                    }
                    if (newOptions.delay != null) {
                        optionsToUpdate.delay = resolveTimingValue(newOptions.delay);
                    }
                    /** @type {?} */
                    var newParams = newOptions.params;
                    if (newParams) {
                        /** @type {?} */
                        var paramsToUpdate_1 = ( /** @type {?} */(optionsToUpdate.params));
                        if (!paramsToUpdate_1) {
                            paramsToUpdate_1 = this.options.params = {};
                        }
                        Object.keys(newParams).forEach(( /**
                         * @param {?} name
                         * @return {?}
                         */function (/**
                         * @param {?} name
                         * @return {?}
                         */ name) {
                            if (!skipIfExists || !paramsToUpdate_1.hasOwnProperty(name)) {
                                paramsToUpdate_1[name] = interpolateParams(newParams[name], paramsToUpdate_1, _this.errors);
                            }
                        }));
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                AnimationTimelineContext.prototype._copyOptions = function () {
                    /** @type {?} */
                    var options = {};
                    if (this.options) {
                        /** @type {?} */
                        var oldParams_1 = this.options.params;
                        if (oldParams_1) {
                            /** @type {?} */
                            var params_2 = options['params'] = {};
                            Object.keys(oldParams_1).forEach(( /**
                             * @param {?} name
                             * @return {?}
                             */function (/**
                             * @param {?} name
                             * @return {?}
                             */ name) { params_2[name] = oldParams_1[name]; }));
                        }
                    }
                    return options;
                };
                /**
                 * @param {?=} options
                 * @param {?=} element
                 * @param {?=} newTime
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.createSubContext = function (options, element, newTime) {
                    if (options === void 0) { options = null; }
                    /** @type {?} */
                    var target = element || this.element;
                    /** @type {?} */
                    var context = new AnimationTimelineContext(this._driver, target, this.subInstructions, this._enterClassName, this._leaveClassName, this.errors, this.timelines, this.currentTimeline.fork(target, newTime || 0));
                    context.previousNode = this.previousNode;
                    context.currentAnimateTimings = this.currentAnimateTimings;
                    context.options = this._copyOptions();
                    context.updateOptions(options);
                    context.currentQueryIndex = this.currentQueryIndex;
                    context.currentQueryTotal = this.currentQueryTotal;
                    context.parentContext = this;
                    this.subContextCount++;
                    return context;
                };
                /**
                 * @param {?=} newTime
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.transformIntoNewTimeline = function (newTime) {
                    this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                    this.currentTimeline = this.currentTimeline.fork(this.element, newTime);
                    this.timelines.push(this.currentTimeline);
                    return this.currentTimeline;
                };
                /**
                 * @param {?} instruction
                 * @param {?} duration
                 * @param {?} delay
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.appendInstructionToTimeline = function (instruction, duration, delay) {
                    /** @type {?} */
                    var updatedTimings = {
                        duration: duration != null ? duration : instruction.duration,
                        delay: this.currentTimeline.currentTime + (delay != null ? delay : 0) + instruction.delay,
                        easing: ''
                    };
                    /** @type {?} */
                    var builder = new SubTimelineBuilder(this._driver, instruction.element, instruction.keyframes, instruction.preStyleProps, instruction.postStyleProps, updatedTimings, instruction.stretchStartingKeyframe);
                    this.timelines.push(builder);
                    return updatedTimings;
                };
                /**
                 * @param {?} time
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.incrementTime = function (time) {
                    this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
                };
                /**
                 * @param {?} delay
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.delayNextStep = function (delay) {
                    // negative delays are not yet supported
                    if (delay > 0) {
                        this.currentTimeline.delayNextStep(delay);
                    }
                };
                /**
                 * @param {?} selector
                 * @param {?} originalSelector
                 * @param {?} limit
                 * @param {?} includeSelf
                 * @param {?} optional
                 * @param {?} errors
                 * @return {?}
                 */
                AnimationTimelineContext.prototype.invokeQuery = function (selector, originalSelector, limit, includeSelf, optional, errors) {
                    /** @type {?} */
                    var results = [];
                    if (includeSelf) {
                        results.push(this.element);
                    }
                    if (selector.length > 0) { // if :self is only used then the selector is empty
                        selector = selector.replace(ENTER_TOKEN_REGEX, '.' + this._enterClassName);
                        selector = selector.replace(LEAVE_TOKEN_REGEX, '.' + this._leaveClassName);
                        /** @type {?} */
                        var multi = limit != 1;
                        /** @type {?} */
                        var elements = this._driver.query(this.element, selector, multi);
                        if (limit !== 0) {
                            elements = limit < 0 ? elements.slice(elements.length + limit, elements.length) :
                                elements.slice(0, limit);
                        }
                        results.push.apply(results, elements);
                    }
                    if (!optional && results.length == 0) {
                        errors.push("`query(\"" + originalSelector + "\")` returned zero elements. (Use `query(\"" + originalSelector + "\", { optional: true })` if you wish to allow this.)");
                    }
                    return results;
                };
                return AnimationTimelineContext;
            }());
            if (false) { }
            var TimelineBuilder = /** @class */ (function () {
                /**
                 * @param {?} _driver
                 * @param {?} element
                 * @param {?} startTime
                 * @param {?=} _elementTimelineStylesLookup
                 */
                function TimelineBuilder(_driver, element, startTime, _elementTimelineStylesLookup) {
                    this._driver = _driver;
                    this.element = element;
                    this.startTime = startTime;
                    this._elementTimelineStylesLookup = _elementTimelineStylesLookup;
                    this.duration = 0;
                    this._previousKeyframe = {};
                    this._currentKeyframe = {};
                    this._keyframes = new Map();
                    this._styleSummary = {};
                    this._pendingStyles = {};
                    this._backFill = {};
                    this._currentEmptyStepKeyframe = null;
                    if (!this._elementTimelineStylesLookup) {
                        this._elementTimelineStylesLookup = new Map();
                    }
                    this._localTimelineStyles = Object.create(this._backFill, {});
                    this._globalTimelineStyles = ( /** @type {?} */(this._elementTimelineStylesLookup.get(element)));
                    if (!this._globalTimelineStyles) {
                        this._globalTimelineStyles = this._localTimelineStyles;
                        this._elementTimelineStylesLookup.set(element, this._localTimelineStyles);
                    }
                    this._loadKeyframe();
                }
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.containsAnimation = function () {
                    switch (this._keyframes.size) {
                        case 0:
                            return false;
                        case 1:
                            return this.getCurrentStyleProperties().length > 0;
                        default:
                            return true;
                    }
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.getCurrentStyleProperties = function () { return Object.keys(this._currentKeyframe); };
                Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.startTime + this.duration; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} delay
                 * @return {?}
                 */
                TimelineBuilder.prototype.delayNextStep = function (delay) {
                    // in the event that a style() step is placed right before a stagger()
                    // and that style() step is the very first style() value in the animation
                    // then we need to make a copy of the keyframe [0, copy, 1] so that the delay
                    // properly applies the style() values to work with the stagger...
                    /** @type {?} */
                    var hasPreStyleStep = this._keyframes.size == 1 && Object.keys(this._pendingStyles).length;
                    if (this.duration || hasPreStyleStep) {
                        this.forwardTime(this.currentTime + delay);
                        if (hasPreStyleStep) {
                            this.snapshotCurrentStyles();
                        }
                    }
                    else {
                        this.startTime += delay;
                    }
                };
                /**
                 * @param {?} element
                 * @param {?=} currentTime
                 * @return {?}
                 */
                TimelineBuilder.prototype.fork = function (element, currentTime) {
                    this.applyStylesToKeyframe();
                    return new TimelineBuilder(this._driver, element, currentTime || this.currentTime, this._elementTimelineStylesLookup);
                };
                /**
                 * @private
                 * @return {?}
                 */
                TimelineBuilder.prototype._loadKeyframe = function () {
                    if (this._currentKeyframe) {
                        this._previousKeyframe = this._currentKeyframe;
                    }
                    this._currentKeyframe = ( /** @type {?} */(this._keyframes.get(this.duration)));
                    if (!this._currentKeyframe) {
                        this._currentKeyframe = Object.create(this._backFill, {});
                        this._keyframes.set(this.duration, this._currentKeyframe);
                    }
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.forwardFrame = function () {
                    this.duration += ONE_FRAME_IN_MILLISECONDS;
                    this._loadKeyframe();
                };
                /**
                 * @param {?} time
                 * @return {?}
                 */
                TimelineBuilder.prototype.forwardTime = function (time) {
                    this.applyStylesToKeyframe();
                    this.duration = time;
                    this._loadKeyframe();
                };
                /**
                 * @private
                 * @param {?} prop
                 * @param {?} value
                 * @return {?}
                 */
                TimelineBuilder.prototype._updateStyle = function (prop, value) {
                    this._localTimelineStyles[prop] = value;
                    this._globalTimelineStyles[prop] = value;
                    this._styleSummary[prop] = { time: this.currentTime, value: value };
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.allowOnlyTimelineStyles = function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
                /**
                 * @param {?} easing
                 * @return {?}
                 */
                TimelineBuilder.prototype.applyEmptyStep = function (easing) {
                    var _this = this;
                    if (easing) {
                        this._previousKeyframe['easing'] = easing;
                    }
                    // special case for animate(duration):
                    // all missing styles are filled with a `*` value then
                    // if any destination styles are filled in later on the same
                    // keyframe then they will override the overridden styles
                    // We use `_globalTimelineStyles` here because there may be
                    // styles in previous keyframes that are not present in this timeline
                    Object.keys(this._globalTimelineStyles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        _this._backFill[prop] = _this._globalTimelineStyles[prop] || _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"];
                        _this._currentKeyframe[prop] = _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"];
                    }));
                    this._currentEmptyStepKeyframe = this._currentKeyframe;
                };
                /**
                 * @param {?} input
                 * @param {?} easing
                 * @param {?} errors
                 * @param {?=} options
                 * @return {?}
                 */
                TimelineBuilder.prototype.setStyles = function (input, easing, errors, options) {
                    var _this = this;
                    if (easing) {
                        this._previousKeyframe['easing'] = easing;
                    }
                    /** @type {?} */
                    var params = (options && options.params) || {};
                    /** @type {?} */
                    var styles = flattenStyles(input, this._globalTimelineStyles);
                    Object.keys(styles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var val = interpolateParams(styles[prop], params, errors);
                        _this._pendingStyles[prop] = val;
                        if (!_this._localTimelineStyles.hasOwnProperty(prop)) {
                            _this._backFill[prop] = _this._globalTimelineStyles.hasOwnProperty(prop) ?
                                _this._globalTimelineStyles[prop] :
                                _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"];
                        }
                        _this._updateStyle(prop, val);
                    }));
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.applyStylesToKeyframe = function () {
                    var _this = this;
                    /** @type {?} */
                    var styles = this._pendingStyles;
                    /** @type {?} */
                    var props = Object.keys(styles);
                    if (props.length == 0)
                        return;
                    this._pendingStyles = {};
                    props.forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var val = styles[prop];
                        _this._currentKeyframe[prop] = val;
                    }));
                    Object.keys(this._localTimelineStyles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        if (!_this._currentKeyframe.hasOwnProperty(prop)) {
                            _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.snapshotCurrentStyles = function () {
                    var _this = this;
                    Object.keys(this._localTimelineStyles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var val = _this._localTimelineStyles[prop];
                        _this._pendingStyles[prop] = val;
                        _this._updateStyle(prop, val);
                    }));
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.getFinalKeyframe = function () { return this._keyframes.get(this.duration); };
                Object.defineProperty(TimelineBuilder.prototype, "properties", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var properties = [];
                        for (var prop in this._currentKeyframe) {
                            properties.push(prop);
                        }
                        return properties;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} timeline
                 * @return {?}
                 */
                TimelineBuilder.prototype.mergeTimelineCollectedStyles = function (timeline) {
                    var _this = this;
                    Object.keys(timeline._styleSummary).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var details0 = _this._styleSummary[prop];
                        /** @type {?} */
                        var details1 = timeline._styleSummary[prop];
                        if (!details0 || details1.time > details0.time) {
                            _this._updateStyle(prop, details1.value);
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                TimelineBuilder.prototype.buildKeyframes = function () {
                    var _this = this;
                    this.applyStylesToKeyframe();
                    /** @type {?} */
                    var preStyleProps = new Set();
                    /** @type {?} */
                    var postStyleProps = new Set();
                    /** @type {?} */
                    var isEmpty = this._keyframes.size === 1 && this.duration === 0;
                    /** @type {?} */
                    var finalKeyframes = [];
                    this._keyframes.forEach(( /**
                     * @param {?} keyframe
                     * @param {?} time
                     * @return {?}
                     */function (keyframe, time) {
                        /** @type {?} */
                        var finalKeyframe = copyStyles(keyframe, true);
                        Object.keys(finalKeyframe).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            /** @type {?} */
                            var value = finalKeyframe[prop];
                            if (value == _angular_animations__WEBPACK_IMPORTED_MODULE_0__["ɵPRE_STYLE"]) {
                                preStyleProps.add(prop);
                            }
                            else if (value == _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"]) {
                                postStyleProps.add(prop);
                            }
                        }));
                        if (!isEmpty) {
                            finalKeyframe['offset'] = time / _this.duration;
                        }
                        finalKeyframes.push(finalKeyframe);
                    }));
                    /** @type {?} */
                    var preProps = preStyleProps.size ? iteratorToArray(preStyleProps.values()) : [];
                    /** @type {?} */
                    var postProps = postStyleProps.size ? iteratorToArray(postStyleProps.values()) : [];
                    // special case for a 0-second animation (which is designed just to place styles onscreen)
                    if (isEmpty) {
                        /** @type {?} */
                        var kf0 = finalKeyframes[0];
                        /** @type {?} */
                        var kf1 = copyObj(kf0);
                        kf0['offset'] = 0;
                        kf1['offset'] = 1;
                        finalKeyframes = [kf0, kf1];
                    }
                    return createTimelineInstruction(this.element, finalKeyframes, preProps, postProps, this.duration, this.startTime, this.easing, false);
                };
                return TimelineBuilder;
            }());
            if (false) { }
            var SubTimelineBuilder = /** @class */ (function (_super_1) {
                __extends(SubTimelineBuilder, _super_1);
                /**
                 * @param {?} driver
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} preStyleProps
                 * @param {?} postStyleProps
                 * @param {?} timings
                 * @param {?=} _stretchStartingKeyframe
                 */
                function SubTimelineBuilder(driver, element, keyframes, preStyleProps, postStyleProps, timings, _stretchStartingKeyframe) {
                    if (_stretchStartingKeyframe === void 0) { _stretchStartingKeyframe = false; }
                    var _this = _super_1.call(this, driver, element, timings.delay) || this;
                    _this.element = element;
                    _this.keyframes = keyframes;
                    _this.preStyleProps = preStyleProps;
                    _this.postStyleProps = postStyleProps;
                    _this._stretchStartingKeyframe = _stretchStartingKeyframe;
                    _this.timings = { duration: timings.duration, delay: timings.delay, easing: timings.easing };
                    return _this;
                }
                /**
                 * @return {?}
                 */
                SubTimelineBuilder.prototype.containsAnimation = function () { return this.keyframes.length > 1; };
                /**
                 * @return {?}
                 */
                SubTimelineBuilder.prototype.buildKeyframes = function () {
                    /** @type {?} */
                    var keyframes = this.keyframes;
                    var _c = this.timings, delay = _c.delay, duration = _c.duration, easing = _c.easing;
                    if (this._stretchStartingKeyframe && delay) {
                        /** @type {?} */
                        var newKeyframes = [];
                        /** @type {?} */
                        var totalTime = duration + delay;
                        /** @type {?} */
                        var startingGap = delay / totalTime;
                        // the original starting keyframe now starts once the delay is done
                        /** @type {?} */
                        var newFirstKeyframe = copyStyles(keyframes[0], false);
                        newFirstKeyframe['offset'] = 0;
                        newKeyframes.push(newFirstKeyframe);
                        /** @type {?} */
                        var oldFirstKeyframe = copyStyles(keyframes[0], false);
                        oldFirstKeyframe['offset'] = roundOffset(startingGap);
                        newKeyframes.push(oldFirstKeyframe);
                        /*
                                When the keyframe is stretched then it means that the delay before the animation
                                starts is gone. Instead the first keyframe is placed at the start of the animation
                                and it is then copied to where it starts when the original delay is over. This basically
                                means nothing animates during that delay, but the styles are still renderered. For this
                                to work the original offset values that exist in the original keyframes must be "warped"
                                so that they can take the new keyframe + delay into account.
                        
                                delay=1000, duration=1000, keyframes = 0 .5 1
                        
                                turns into
                        
                                delay=0, duration=2000, keyframes = 0 .33 .66 1
                               */
                        // offsets between 1 ... n -1 are all warped by the keyframe stretch
                        /** @type {?} */
                        var limit = keyframes.length - 1;
                        for (var i = 1; i <= limit; i++) {
                            /** @type {?} */
                            var kf = copyStyles(keyframes[i], false);
                            /** @type {?} */
                            var oldOffset = ( /** @type {?} */(kf['offset']));
                            /** @type {?} */
                            var timeAtKeyframe = delay + oldOffset * duration;
                            kf['offset'] = roundOffset(timeAtKeyframe / totalTime);
                            newKeyframes.push(kf);
                        }
                        // the new starting keyframe should be added at the start
                        duration = totalTime;
                        delay = 0;
                        easing = '';
                        keyframes = newKeyframes;
                    }
                    return createTimelineInstruction(this.element, keyframes, this.preStyleProps, this.postStyleProps, duration, delay, easing, true);
                };
                return SubTimelineBuilder;
            }(TimelineBuilder));
            if (false) { }
            /**
             * @param {?} offset
             * @param {?=} decimalPoints
             * @return {?}
             */
            function roundOffset(offset, decimalPoints) {
                if (decimalPoints === void 0) { decimalPoints = 3; }
                /** @type {?} */
                var mult = Math.pow(10, decimalPoints - 1);
                return Math.round(offset * mult) / mult;
            }
            /**
             * @param {?} input
             * @param {?} allStyles
             * @return {?}
             */
            function flattenStyles(input, allStyles) {
                /** @type {?} */
                var styles = {};
                /** @type {?} */
                var allProperties;
                input.forEach(( /**
                 * @param {?} token
                 * @return {?}
                 */function (/**
                 * @param {?} token
                 * @return {?}
                 */ token) {
                    if (token === '*') {
                        allProperties = allProperties || Object.keys(allStyles);
                        allProperties.forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) { styles[prop] = _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"]; }));
                    }
                    else {
                        copyStyles(( /** @type {?} */(token)), false, styles);
                    }
                }));
                return styles;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var Animation = /** @class */ (function () {
                /**
                 * @param {?} _driver
                 * @param {?} input
                 */
                function Animation(_driver, input) {
                    this._driver = _driver;
                    /** @type {?} */
                    var errors = [];
                    /** @type {?} */
                    var ast = buildAnimationAst(_driver, input, errors);
                    if (errors.length) {
                        /** @type {?} */
                        var errorMessage = "animation validation failed:\n" + errors.join("\n");
                        throw new Error(errorMessage);
                    }
                    this._animationAst = ast;
                }
                /**
                 * @param {?} element
                 * @param {?} startingStyles
                 * @param {?} destinationStyles
                 * @param {?} options
                 * @param {?=} subInstructions
                 * @return {?}
                 */
                Animation.prototype.buildTimelines = function (element, startingStyles, destinationStyles, options, subInstructions) {
                    /** @type {?} */
                    var start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) :
                        ( /** @type {?} */(startingStyles));
                    /** @type {?} */
                    var dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) :
                        ( /** @type {?} */(destinationStyles));
                    /** @type {?} */
                    var errors = [];
                    subInstructions = subInstructions || new ElementInstructionMap();
                    /** @type {?} */
                    var result = buildAnimationTimelines(this._driver, element, this._animationAst, ENTER_CLASSNAME, LEAVE_CLASSNAME, start, dest, options, subInstructions, errors);
                    if (errors.length) {
                        /** @type {?} */
                        var errorMessage = "animation building failed:\n" + errors.join("\n");
                        throw new Error(errorMessage);
                    }
                    return result;
                };
                return Animation;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * \@publicApi
             * @abstract
             */
            var AnimationStyleNormalizer = /** @class */ (function () {
                function AnimationStyleNormalizer() {
                }
                return AnimationStyleNormalizer;
            }());
            if (false) { }
            /**
             * \@publicApi
             */
            var NoopAnimationStyleNormalizer = /** @class */ (function () {
                function NoopAnimationStyleNormalizer() {
                }
                /**
                 * @param {?} propertyName
                 * @param {?} errors
                 * @return {?}
                 */
                NoopAnimationStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) { return propertyName; };
                /**
                 * @param {?} userProvidedProperty
                 * @param {?} normalizedProperty
                 * @param {?} value
                 * @param {?} errors
                 * @return {?}
                 */
                NoopAnimationStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
                    return ( /** @type {?} */(value));
                };
                return NoopAnimationStyleNormalizer;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var WebAnimationsStyleNormalizer = /** @class */ (function (_super_1) {
                __extends(WebAnimationsStyleNormalizer, _super_1);
                function WebAnimationsStyleNormalizer() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @param {?} propertyName
                 * @param {?} errors
                 * @return {?}
                 */
                WebAnimationsStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) {
                    return dashCaseToCamelCase(propertyName);
                };
                /**
                 * @param {?} userProvidedProperty
                 * @param {?} normalizedProperty
                 * @param {?} value
                 * @param {?} errors
                 * @return {?}
                 */
                WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
                    /** @type {?} */
                    var unit = '';
                    /** @type {?} */
                    var strVal = value.toString().trim();
                    if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
                        if (typeof value === 'number') {
                            unit = 'px';
                        }
                        else {
                            /** @type {?} */
                            var valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
                            if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                                errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
                            }
                        }
                    }
                    return strVal + unit;
                };
                return WebAnimationsStyleNormalizer;
            }(AnimationStyleNormalizer));
            var ɵ0$1 = /**
             * @return {?}
             */ function () { return makeBooleanMap('width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
                .split(',')); };
            /** @type {?} */
            var DIMENSIONAL_PROP_MAP = ((ɵ0$1))();
            /**
             * @param {?} keys
             * @return {?}
             */
            function makeBooleanMap(keys) {
                /** @type {?} */
                var map = {};
                keys.forEach(( /**
                 * @param {?} key
                 * @return {?}
                 */function (/**
                 * @param {?} key
                 * @return {?}
                 */ key) { return map[key] = true; }));
                return map;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function AnimationTransitionInstruction() { }
            if (false) { }
            /**
             * @param {?} element
             * @param {?} triggerName
             * @param {?} fromState
             * @param {?} toState
             * @param {?} isRemovalTransition
             * @param {?} fromStyles
             * @param {?} toStyles
             * @param {?} timelines
             * @param {?} queriedElements
             * @param {?} preStyleProps
             * @param {?} postStyleProps
             * @param {?} totalTime
             * @param {?=} errors
             * @return {?}
             */
            function createTransitionInstruction(element, triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines, queriedElements, preStyleProps, postStyleProps, totalTime, errors) {
                return {
                    type: 0 /* TransitionAnimation */,
                    element: element,
                    triggerName: triggerName,
                    isRemovalTransition: isRemovalTransition,
                    fromState: fromState,
                    fromStyles: fromStyles,
                    toState: toState,
                    toStyles: toStyles,
                    timelines: timelines,
                    queriedElements: queriedElements,
                    preStyleProps: preStyleProps,
                    postStyleProps: postStyleProps,
                    totalTime: totalTime,
                    errors: errors
                };
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EMPTY_OBJECT = {};
            var AnimationTransitionFactory = /** @class */ (function () {
                /**
                 * @param {?} _triggerName
                 * @param {?} ast
                 * @param {?} _stateStyles
                 */
                function AnimationTransitionFactory(_triggerName, ast, _stateStyles) {
                    this._triggerName = _triggerName;
                    this.ast = ast;
                    this._stateStyles = _stateStyles;
                }
                /**
                 * @param {?} currentState
                 * @param {?} nextState
                 * @param {?} element
                 * @param {?} params
                 * @return {?}
                 */
                AnimationTransitionFactory.prototype.match = function (currentState, nextState, element, params) {
                    return oneOrMoreTransitionsMatch(this.ast.matchers, currentState, nextState, element, params);
                };
                /**
                 * @param {?} stateName
                 * @param {?} params
                 * @param {?} errors
                 * @return {?}
                 */
                AnimationTransitionFactory.prototype.buildStyles = function (stateName, params, errors) {
                    /** @type {?} */
                    var backupStateStyler = this._stateStyles['*'];
                    /** @type {?} */
                    var stateStyler = this._stateStyles[stateName];
                    /** @type {?} */
                    var backupStyles = backupStateStyler ? backupStateStyler.buildStyles(params, errors) : {};
                    return stateStyler ? stateStyler.buildStyles(params, errors) : backupStyles;
                };
                /**
                 * @param {?} driver
                 * @param {?} element
                 * @param {?} currentState
                 * @param {?} nextState
                 * @param {?} enterClassName
                 * @param {?} leaveClassName
                 * @param {?=} currentOptions
                 * @param {?=} nextOptions
                 * @param {?=} subInstructions
                 * @param {?=} skipAstBuild
                 * @return {?}
                 */
                AnimationTransitionFactory.prototype.build = function (driver, element, currentState, nextState, enterClassName, leaveClassName, currentOptions, nextOptions, subInstructions, skipAstBuild) {
                    /** @type {?} */
                    var errors = [];
                    /** @type {?} */
                    var transitionAnimationParams = this.ast.options && this.ast.options.params || EMPTY_OBJECT;
                    /** @type {?} */
                    var currentAnimationParams = currentOptions && currentOptions.params || EMPTY_OBJECT;
                    /** @type {?} */
                    var currentStateStyles = this.buildStyles(currentState, currentAnimationParams, errors);
                    /** @type {?} */
                    var nextAnimationParams = nextOptions && nextOptions.params || EMPTY_OBJECT;
                    /** @type {?} */
                    var nextStateStyles = this.buildStyles(nextState, nextAnimationParams, errors);
                    /** @type {?} */
                    var queriedElements = new Set();
                    /** @type {?} */
                    var preStyleMap = new Map();
                    /** @type {?} */
                    var postStyleMap = new Map();
                    /** @type {?} */
                    var isRemoval = nextState === 'void';
                    /** @type {?} */
                    var animationOptions = { params: Object.assign({}, transitionAnimationParams, nextAnimationParams) };
                    /** @type {?} */
                    var timelines = skipAstBuild ? [] : buildAnimationTimelines(driver, element, this.ast.animation, enterClassName, leaveClassName, currentStateStyles, nextStateStyles, animationOptions, subInstructions, errors);
                    /** @type {?} */
                    var totalTime = 0;
                    timelines.forEach(( /**
                     * @param {?} tl
                     * @return {?}
                     */function (/**
                     * @param {?} tl
                     * @return {?}
                     */ tl) { totalTime = Math.max(tl.duration + tl.delay, totalTime); }));
                    if (errors.length) {
                        return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, [], [], preStyleMap, postStyleMap, totalTime, errors);
                    }
                    timelines.forEach(( /**
                     * @param {?} tl
                     * @return {?}
                     */function (/**
                     * @param {?} tl
                     * @return {?}
                     */ tl) {
                        /** @type {?} */
                        var elm = tl.element;
                        /** @type {?} */
                        var preProps = getOrSetAsInMap(preStyleMap, elm, {});
                        tl.preStyleProps.forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) { return preProps[prop] = true; }));
                        /** @type {?} */
                        var postProps = getOrSetAsInMap(postStyleMap, elm, {});
                        tl.postStyleProps.forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) { return postProps[prop] = true; }));
                        if (elm !== element) {
                            queriedElements.add(elm);
                        }
                    }));
                    /** @type {?} */
                    var queriedElementsList = iteratorToArray(queriedElements.values());
                    return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, timelines, queriedElementsList, preStyleMap, postStyleMap, totalTime);
                };
                return AnimationTransitionFactory;
            }());
            if (false) { }
            /**
             * @param {?} matchFns
             * @param {?} currentState
             * @param {?} nextState
             * @param {?} element
             * @param {?} params
             * @return {?}
             */
            function oneOrMoreTransitionsMatch(matchFns, currentState, nextState, element, params) {
                return matchFns.some(( /**
                 * @param {?} fn
                 * @return {?}
                 */function (/**
                 * @param {?} fn
                 * @return {?}
                 */ fn) { return fn(currentState, nextState, element, params); }));
            }
            var AnimationStateStyles = /** @class */ (function () {
                /**
                 * @param {?} styles
                 * @param {?} defaultParams
                 */
                function AnimationStateStyles(styles, defaultParams) {
                    this.styles = styles;
                    this.defaultParams = defaultParams;
                }
                /**
                 * @param {?} params
                 * @param {?} errors
                 * @return {?}
                 */
                AnimationStateStyles.prototype.buildStyles = function (params, errors) {
                    /** @type {?} */
                    var finalStyles = {};
                    /** @type {?} */
                    var combinedParams = copyObj(this.defaultParams);
                    Object.keys(params).forEach(( /**
                     * @param {?} key
                     * @return {?}
                     */function (/**
                     * @param {?} key
                     * @return {?}
                     */ key) {
                        /** @type {?} */
                        var value = params[key];
                        if (value != null) {
                            combinedParams[key] = value;
                        }
                    }));
                    this.styles.styles.forEach(( /**
                     * @param {?} value
                     * @return {?}
                     */function (/**
                     * @param {?} value
                     * @return {?}
                     */ value) {
                        if (typeof value !== 'string') {
                            /** @type {?} */
                            var styleObj_1 = ( /** @type {?} */(value));
                            Object.keys(styleObj_1).forEach(( /**
                             * @param {?} prop
                             * @return {?}
                             */function (/**
                             * @param {?} prop
                             * @return {?}
                             */ prop) {
                                /** @type {?} */
                                var val = styleObj_1[prop];
                                if (val.length > 1) {
                                    val = interpolateParams(val, combinedParams, errors);
                                }
                                finalStyles[prop] = val;
                            }));
                        }
                    }));
                    return finalStyles;
                };
                return AnimationStateStyles;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @param {?} name
             * @param {?} ast
             * @return {?}
             */
            function buildTrigger(name, ast) {
                return new AnimationTrigger(name, ast);
            }
            /**
             * \@publicApi
             */
            var AnimationTrigger = /** @class */ (function () {
                /**
                 * @param {?} name
                 * @param {?} ast
                 */
                function AnimationTrigger(name, ast) {
                    var _this = this;
                    this.name = name;
                    this.ast = ast;
                    this.transitionFactories = [];
                    this.states = {};
                    ast.states.forEach(( /**
                     * @param {?} ast
                     * @return {?}
                     */function (/**
                     * @param {?} ast
                     * @return {?}
                     */ ast) {
                        /** @type {?} */
                        var defaultParams = (ast.options && ast.options.params) || {};
                        _this.states[ast.name] = new AnimationStateStyles(ast.style, defaultParams);
                    }));
                    balanceProperties(this.states, 'true', '1');
                    balanceProperties(this.states, 'false', '0');
                    ast.transitions.forEach(( /**
                     * @param {?} ast
                     * @return {?}
                     */function (/**
                     * @param {?} ast
                     * @return {?}
                     */ ast) {
                        _this.transitionFactories.push(new AnimationTransitionFactory(name, ast, _this.states));
                    }));
                    this.fallbackTransition = createFallbackTransition(name, this.states);
                }
                Object.defineProperty(AnimationTrigger.prototype, "containsQueries", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.ast.queryCount > 0; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} currentState
                 * @param {?} nextState
                 * @param {?} element
                 * @param {?} params
                 * @return {?}
                 */
                AnimationTrigger.prototype.matchTransition = function (currentState, nextState, element, params) {
                    /** @type {?} */
                    var entry = this.transitionFactories.find(( /**
                     * @param {?} f
                     * @return {?}
                     */function (/**
                     * @param {?} f
                     * @return {?}
                     */ f) { return f.match(currentState, nextState, element, params); }));
                    return entry || null;
                };
                /**
                 * @param {?} currentState
                 * @param {?} params
                 * @param {?} errors
                 * @return {?}
                 */
                AnimationTrigger.prototype.matchStyles = function (currentState, params, errors) {
                    return this.fallbackTransition.buildStyles(currentState, params, errors);
                };
                return AnimationTrigger;
            }());
            if (false) { }
            /**
             * @param {?} triggerName
             * @param {?} states
             * @return {?}
             */
            function createFallbackTransition(triggerName, states) {
                /** @type {?} */
                var matchers = [( /**
                         * @param {?} fromState
                         * @param {?} toState
                         * @return {?}
                         */function (fromState, toState) { return true; })];
                /** @type {?} */
                var animation = { type: 2 /* Sequence */, steps: [], options: null };
                /** @type {?} */
                var transition = {
                    type: 1 /* Transition */,
                    animation: animation,
                    matchers: matchers,
                    options: null,
                    queryCount: 0,
                    depCount: 0
                };
                return new AnimationTransitionFactory(triggerName, transition, states);
            }
            /**
             * @param {?} obj
             * @param {?} key1
             * @param {?} key2
             * @return {?}
             */
            function balanceProperties(obj, key1, key2) {
                if (obj.hasOwnProperty(key1)) {
                    if (!obj.hasOwnProperty(key2)) {
                        obj[key2] = obj[key1];
                    }
                }
                else if (obj.hasOwnProperty(key2)) {
                    obj[key1] = obj[key2];
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EMPTY_INSTRUCTION_MAP = new ElementInstructionMap();
            var TimelineAnimationEngine = /** @class */ (function () {
                /**
                 * @param {?} bodyNode
                 * @param {?} _driver
                 * @param {?} _normalizer
                 */
                function TimelineAnimationEngine(bodyNode, _driver, _normalizer) {
                    this.bodyNode = bodyNode;
                    this._driver = _driver;
                    this._normalizer = _normalizer;
                    this._animations = {};
                    this._playersById = {};
                    this.players = [];
                }
                /**
                 * @param {?} id
                 * @param {?} metadata
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype.register = function (id, metadata) {
                    /** @type {?} */
                    var errors = [];
                    /** @type {?} */
                    var ast = buildAnimationAst(this._driver, metadata, errors);
                    if (errors.length) {
                        throw new Error("Unable to build the animation due to the following errors: " + errors.join("\n"));
                    }
                    else {
                        this._animations[id] = ast;
                    }
                };
                /**
                 * @private
                 * @param {?} i
                 * @param {?} preStyles
                 * @param {?=} postStyles
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype._buildPlayer = function (i, preStyles, postStyles) {
                    /** @type {?} */
                    var element = i.element;
                    /** @type {?} */
                    var keyframes = normalizeKeyframes(this._driver, this._normalizer, element, i.keyframes, preStyles, postStyles);
                    return this._driver.animate(element, keyframes, i.duration, i.delay, i.easing, [], true);
                };
                /**
                 * @param {?} id
                 * @param {?} element
                 * @param {?=} options
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype.create = function (id, element, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    /** @type {?} */
                    var errors = [];
                    /** @type {?} */
                    var ast = this._animations[id];
                    /** @type {?} */
                    var instructions;
                    /** @type {?} */
                    var autoStylesMap = new Map();
                    if (ast) {
                        instructions = buildAnimationTimelines(this._driver, element, ast, ENTER_CLASSNAME, LEAVE_CLASSNAME, {}, {}, options, EMPTY_INSTRUCTION_MAP, errors);
                        instructions.forEach(( /**
                         * @param {?} inst
                         * @return {?}
                         */function (/**
                         * @param {?} inst
                         * @return {?}
                         */ inst) {
                            /** @type {?} */
                            var styles = getOrSetAsInMap(autoStylesMap, inst.element, {});
                            inst.postStyleProps.forEach(( /**
                             * @param {?} prop
                             * @return {?}
                             */function (/**
                             * @param {?} prop
                             * @return {?}
                             */ prop) { return styles[prop] = null; }));
                        }));
                    }
                    else {
                        errors.push('The requested animation doesn\'t exist or has already been destroyed');
                        instructions = [];
                    }
                    if (errors.length) {
                        throw new Error("Unable to create the animation due to the following errors: " + errors.join("\n"));
                    }
                    autoStylesMap.forEach(( /**
                     * @param {?} styles
                     * @param {?} element
                     * @return {?}
                     */function (styles, element) {
                        Object.keys(styles).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) { styles[prop] = _this._driver.computeStyle(element, prop, _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"]); }));
                    }));
                    /** @type {?} */
                    var players = instructions.map(( /**
                     * @param {?} i
                     * @return {?}
                     */function (/**
                     * @param {?} i
                     * @return {?}
                     */ i) {
                        /** @type {?} */
                        var styles = autoStylesMap.get(i.element);
                        return _this._buildPlayer(i, {}, styles);
                    }));
                    /** @type {?} */
                    var player = optimizeGroupPlayer(players);
                    this._playersById[id] = player;
                    player.onDestroy(( /**
                     * @return {?}
                     */function () { return _this.destroy(id); }));
                    this.players.push(player);
                    return player;
                };
                /**
                 * @param {?} id
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype.destroy = function (id) {
                    /** @type {?} */
                    var player = this._getPlayer(id);
                    player.destroy();
                    delete this._playersById[id];
                    /** @type {?} */
                    var index = this.players.indexOf(player);
                    if (index >= 0) {
                        this.players.splice(index, 1);
                    }
                };
                /**
                 * @private
                 * @param {?} id
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype._getPlayer = function (id) {
                    /** @type {?} */
                    var player = this._playersById[id];
                    if (!player) {
                        throw new Error("Unable to find the timeline player referenced by " + id);
                    }
                    return player;
                };
                /**
                 * @param {?} id
                 * @param {?} element
                 * @param {?} eventName
                 * @param {?} callback
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype.listen = function (id, element, eventName, callback) {
                    // triggerName, fromState, toState are all ignored for timeline animations
                    /** @type {?} */
                    var baseEvent = makeAnimationEvent(element, '', '', '');
                    listenOnPlayer(this._getPlayer(id), eventName, baseEvent, callback);
                    return ( /**
                     * @return {?}
                     */function () { });
                };
                /**
                 * @param {?} id
                 * @param {?} element
                 * @param {?} command
                 * @param {?} args
                 * @return {?}
                 */
                TimelineAnimationEngine.prototype.command = function (id, element, command, args) {
                    if (command == 'register') {
                        this.register(id, ( /** @type {?} */(args[0])));
                        return;
                    }
                    if (command == 'create') {
                        /** @type {?} */
                        var options = ( /** @type {?} */((args[0] || {})));
                        this.create(id, element, options);
                        return;
                    }
                    /** @type {?} */
                    var player = this._getPlayer(id);
                    switch (command) {
                        case 'play':
                            player.play();
                            break;
                        case 'pause':
                            player.pause();
                            break;
                        case 'reset':
                            player.reset();
                            break;
                        case 'restart':
                            player.restart();
                            break;
                        case 'finish':
                            player.finish();
                            break;
                        case 'init':
                            player.init();
                            break;
                        case 'setPosition':
                            player.setPosition(parseFloat(( /** @type {?} */(args[0]))));
                            break;
                        case 'destroy':
                            this.destroy(id);
                            break;
                    }
                };
                return TimelineAnimationEngine;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var QUEUED_CLASSNAME = 'ng-animate-queued';
            /** @type {?} */
            var QUEUED_SELECTOR = '.ng-animate-queued';
            /** @type {?} */
            var DISABLED_CLASSNAME = 'ng-animate-disabled';
            /** @type {?} */
            var DISABLED_SELECTOR = '.ng-animate-disabled';
            /** @type {?} */
            var STAR_CLASSNAME = 'ng-star-inserted';
            /** @type {?} */
            var STAR_SELECTOR = '.ng-star-inserted';
            /** @type {?} */
            var EMPTY_PLAYER_ARRAY = [];
            /** @type {?} */
            var NULL_REMOVAL_STATE = {
                namespaceId: '',
                setForRemoval: false,
                setForMove: false,
                hasAnimation: false,
                removedBeforeQueried: false
            };
            /** @type {?} */
            var NULL_REMOVED_QUERIED_STATE = {
                namespaceId: '',
                setForMove: false,
                setForRemoval: false,
                hasAnimation: false,
                removedBeforeQueried: true
            };
            /**
             * @record
             */
            function TriggerListener() { }
            if (false) { }
            /**
             * @record
             */
            function QueueInstruction() { }
            if (false) { }
            /** @type {?} */
            var REMOVAL_FLAG = '__ng_removed';
            /**
             * @record
             */
            function ElementAnimationState() { }
            if (false) { }
            var StateValue = /** @class */ (function () {
                /**
                 * @param {?} input
                 * @param {?=} namespaceId
                 */
                function StateValue(input, namespaceId) {
                    if (namespaceId === void 0) { namespaceId = ''; }
                    this.namespaceId = namespaceId;
                    /** @type {?} */
                    var isObj = input && input.hasOwnProperty('value');
                    /** @type {?} */
                    var value = isObj ? input['value'] : input;
                    this.value = normalizeTriggerValue(value);
                    if (isObj) {
                        /** @type {?} */
                        var options = copyObj(( /** @type {?} */(input)));
                        delete options['value'];
                        this.options = ( /** @type {?} */(options));
                    }
                    else {
                        this.options = {};
                    }
                    if (!this.options.params) {
                        this.options.params = {};
                    }
                }
                Object.defineProperty(StateValue.prototype, "params", {
                    /**
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(this.options.params)); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} options
                 * @return {?}
                 */
                StateValue.prototype.absorbOptions = function (options) {
                    /** @type {?} */
                    var newParams = options.params;
                    if (newParams) {
                        /** @type {?} */
                        var oldParams_2 = ( /** @type {?} */(this.options.params));
                        Object.keys(newParams).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            if (oldParams_2[prop] == null) {
                                oldParams_2[prop] = newParams[prop];
                            }
                        }));
                    }
                };
                return StateValue;
            }());
            if (false) { }
            /** @type {?} */
            var VOID_VALUE = 'void';
            /** @type {?} */
            var DEFAULT_STATE_VALUE = new StateValue(VOID_VALUE);
            var AnimationTransitionNamespace = /** @class */ (function () {
                /**
                 * @param {?} id
                 * @param {?} hostElement
                 * @param {?} _engine
                 */
                function AnimationTransitionNamespace(id, hostElement, _engine) {
                    this.id = id;
                    this.hostElement = hostElement;
                    this._engine = _engine;
                    this.players = [];
                    this._triggers = {};
                    this._queue = [];
                    this._elementListeners = new Map();
                    this._hostClassName = 'ng-tns-' + id;
                    addClass(hostElement, this._hostClassName);
                }
                /**
                 * @param {?} element
                 * @param {?} name
                 * @param {?} phase
                 * @param {?} callback
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.listen = function (element, name, phase, callback) {
                    var _this = this;
                    if (!this._triggers.hasOwnProperty(name)) {
                        throw new Error("Unable to listen on the animation trigger event \"" + phase + "\" because the animation trigger \"" + name + "\" doesn't exist!");
                    }
                    if (phase == null || phase.length == 0) {
                        throw new Error("Unable to listen on the animation trigger \"" + name + "\" because the provided event is undefined!");
                    }
                    if (!isTriggerEventValid(phase)) {
                        throw new Error("The provided animation trigger event \"" + phase + "\" for the animation trigger \"" + name + "\" is not supported!");
                    }
                    /** @type {?} */
                    var listeners = getOrSetAsInMap(this._elementListeners, element, []);
                    /** @type {?} */
                    var data = { name: name, phase: phase, callback: callback };
                    listeners.push(data);
                    /** @type {?} */
                    var triggersWithStates = getOrSetAsInMap(this._engine.statesByElement, element, {});
                    if (!triggersWithStates.hasOwnProperty(name)) {
                        addClass(element, NG_TRIGGER_CLASSNAME);
                        addClass(element, NG_TRIGGER_CLASSNAME + '-' + name);
                        triggersWithStates[name] = DEFAULT_STATE_VALUE;
                    }
                    return ( /**
                     * @return {?}
                     */function () {
                        // the event listener is removed AFTER the flush has occurred such
                        // that leave animations callbacks can fire (otherwise if the node
                        // is removed in between then the listeners would be deregistered)
                        _this._engine.afterFlush(( /**
                         * @return {?}
                         */function () {
                            /** @type {?} */
                            var index = listeners.indexOf(data);
                            if (index >= 0) {
                                listeners.splice(index, 1);
                            }
                            if (!_this._triggers[name]) {
                                delete triggersWithStates[name];
                            }
                        }));
                    });
                };
                /**
                 * @param {?} name
                 * @param {?} ast
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.register = function (name, ast) {
                    if (this._triggers[name]) {
                        // throw
                        return false;
                    }
                    else {
                        this._triggers[name] = ast;
                        return true;
                    }
                };
                /**
                 * @private
                 * @param {?} name
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype._getTrigger = function (name) {
                    /** @type {?} */
                    var trigger = this._triggers[name];
                    if (!trigger) {
                        throw new Error("The provided animation trigger \"" + name + "\" has not been registered!");
                    }
                    return trigger;
                };
                /**
                 * @param {?} element
                 * @param {?} triggerName
                 * @param {?} value
                 * @param {?=} defaultToFallback
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.trigger = function (element, triggerName, value, defaultToFallback) {
                    var _this = this;
                    if (defaultToFallback === void 0) { defaultToFallback = true; }
                    /** @type {?} */
                    var trigger = this._getTrigger(triggerName);
                    /** @type {?} */
                    var player = new TransitionAnimationPlayer(this.id, triggerName, element);
                    /** @type {?} */
                    var triggersWithStates = this._engine.statesByElement.get(element);
                    if (!triggersWithStates) {
                        addClass(element, NG_TRIGGER_CLASSNAME);
                        addClass(element, NG_TRIGGER_CLASSNAME + '-' + triggerName);
                        this._engine.statesByElement.set(element, triggersWithStates = {});
                    }
                    /** @type {?} */
                    var fromState = triggersWithStates[triggerName];
                    /** @type {?} */
                    var toState = new StateValue(value, this.id);
                    /** @type {?} */
                    var isObj = value && value.hasOwnProperty('value');
                    if (!isObj && fromState) {
                        toState.absorbOptions(fromState.options);
                    }
                    triggersWithStates[triggerName] = toState;
                    if (!fromState) {
                        fromState = DEFAULT_STATE_VALUE;
                    }
                    /** @type {?} */
                    var isRemoval = toState.value === VOID_VALUE;
                    // normally this isn't reached by here, however, if an object expression
                    // is passed in then it may be a new object each time. Comparing the value
                    // is important since that will stay the same despite there being a new object.
                    // The removal arc here is special cased because the same element is triggered
                    // twice in the event that it contains animations on the outer/inner portions
                    // of the host container
                    if (!isRemoval && fromState.value === toState.value) {
                        // this means that despite the value not changing, some inner params
                        // have changed which means that the animation final styles need to be applied
                        if (!objEquals(fromState.params, toState.params)) {
                            /** @type {?} */
                            var errors = [];
                            /** @type {?} */
                            var fromStyles_1 = trigger.matchStyles(fromState.value, fromState.params, errors);
                            /** @type {?} */
                            var toStyles_1 = trigger.matchStyles(toState.value, toState.params, errors);
                            if (errors.length) {
                                this._engine.reportError(errors);
                            }
                            else {
                                this._engine.afterFlush(( /**
                                 * @return {?}
                                 */function () {
                                    eraseStyles(element, fromStyles_1);
                                    setStyles(element, toStyles_1);
                                }));
                            }
                        }
                        return;
                    }
                    /** @type {?} */
                    var playersOnElement = getOrSetAsInMap(this._engine.playersByElement, element, []);
                    playersOnElement.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        // only remove the player if it is queued on the EXACT same trigger/namespace
                        // we only also deal with queued players here because if the animation has
                        // started then we want to keep the player alive until the flush happens
                        // (which is where the previousPlayers are passed into the new palyer)
                        if (player.namespaceId == _this.id && player.triggerName == triggerName && player.queued) {
                            player.destroy();
                        }
                    }));
                    /** @type {?} */
                    var transition = trigger.matchTransition(fromState.value, toState.value, element, toState.params);
                    /** @type {?} */
                    var isFallbackTransition = false;
                    if (!transition) {
                        if (!defaultToFallback)
                            return;
                        transition = trigger.fallbackTransition;
                        isFallbackTransition = true;
                    }
                    this._engine.totalQueuedPlayers++;
                    this._queue.push({ element: element, triggerName: triggerName, transition: transition, fromState: fromState, toState: toState, player: player, isFallbackTransition: isFallbackTransition });
                    if (!isFallbackTransition) {
                        addClass(element, QUEUED_CLASSNAME);
                        player.onStart(( /**
                         * @return {?}
                         */function () { removeClass(element, QUEUED_CLASSNAME); }));
                    }
                    player.onDone(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var index = _this.players.indexOf(player);
                        if (index >= 0) {
                            _this.players.splice(index, 1);
                        }
                        /** @type {?} */
                        var players = _this._engine.playersByElement.get(element);
                        if (players) {
                            /** @type {?} */
                            var index_1 = players.indexOf(player);
                            if (index_1 >= 0) {
                                players.splice(index_1, 1);
                            }
                        }
                    }));
                    this.players.push(player);
                    playersOnElement.push(player);
                    return player;
                };
                /**
                 * @param {?} name
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.deregister = function (name) {
                    var _this = this;
                    delete this._triggers[name];
                    this._engine.statesByElement.forEach(( /**
                     * @param {?} stateMap
                     * @param {?} element
                     * @return {?}
                     */function (stateMap, element) { delete stateMap[name]; }));
                    this._elementListeners.forEach(( /**
                     * @param {?} listeners
                     * @param {?} element
                     * @return {?}
                     */function (listeners, element) {
                        _this._elementListeners.set(element, listeners.filter(( /**
                         * @param {?} entry
                         * @return {?}
                         */function (/**
                         * @param {?} entry
                         * @return {?}
                         */ entry) { return entry.name != name; })));
                    }));
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.clearElementCache = function (element) {
                    this._engine.statesByElement.delete(element);
                    this._elementListeners.delete(element);
                    /** @type {?} */
                    var elementPlayers = this._engine.playersByElement.get(element);
                    if (elementPlayers) {
                        elementPlayers.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) { return player.destroy(); }));
                        this._engine.playersByElement.delete(element);
                    }
                };
                /**
                 * @private
                 * @param {?} rootElement
                 * @param {?} context
                 * @param {?=} animate
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype._signalRemovalForInnerTriggers = function (rootElement, context, animate) {
                    var _this = this;
                    if (animate === void 0) { animate = false; }
                    // emulate a leave animation for all inner nodes within this node.
                    // If there are no animations found for any of the nodes then clear the cache
                    // for the element.
                    this._engine.driver.query(rootElement, NG_TRIGGER_SELECTOR, true).forEach(( /**
                     * @param {?} elm
                     * @return {?}
                     */function (/**
                     * @param {?} elm
                     * @return {?}
                     */ elm) {
                        // this means that an inner remove() operation has already kicked off
                        // the animation on this element...
                        if (elm[REMOVAL_FLAG])
                            return;
                        /** @type {?} */
                        var namespaces = _this._engine.fetchNamespacesByElement(elm);
                        if (namespaces.size) {
                            namespaces.forEach(( /**
                             * @param {?} ns
                             * @return {?}
                             */function (/**
                             * @param {?} ns
                             * @return {?}
                             */ ns) { return ns.triggerLeaveAnimation(elm, context, false, true); }));
                        }
                        else {
                            _this.clearElementCache(elm);
                        }
                    }));
                };
                /**
                 * @param {?} element
                 * @param {?} context
                 * @param {?=} destroyAfterComplete
                 * @param {?=} defaultToFallback
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.triggerLeaveAnimation = function (element, context, destroyAfterComplete, defaultToFallback) {
                    var _this = this;
                    /** @type {?} */
                    var triggerStates = this._engine.statesByElement.get(element);
                    if (triggerStates) {
                        /** @type {?} */
                        var players_1 = [];
                        Object.keys(triggerStates).forEach(( /**
                         * @param {?} triggerName
                         * @return {?}
                         */function (/**
                         * @param {?} triggerName
                         * @return {?}
                         */ triggerName) {
                            // this check is here in the event that an element is removed
                            // twice (both on the host level and the component level)
                            if (_this._triggers[triggerName]) {
                                /** @type {?} */
                                var player = _this.trigger(element, triggerName, VOID_VALUE, defaultToFallback);
                                if (player) {
                                    players_1.push(player);
                                }
                            }
                        }));
                        if (players_1.length) {
                            this._engine.markElementAsRemoved(this.id, element, true, context);
                            if (destroyAfterComplete) {
                                optimizeGroupPlayer(players_1).onDone(( /**
                                 * @return {?}
                                 */function () { return _this._engine.processLeaveNode(element); }));
                            }
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.prepareLeaveAnimationListeners = function (element) {
                    var _this = this;
                    /** @type {?} */
                    var listeners = this._elementListeners.get(element);
                    if (listeners) {
                        /** @type {?} */
                        var visitedTriggers_1 = new Set();
                        listeners.forEach(( /**
                         * @param {?} listener
                         * @return {?}
                         */function (/**
                         * @param {?} listener
                         * @return {?}
                         */ listener) {
                            /** @type {?} */
                            var triggerName = listener.name;
                            if (visitedTriggers_1.has(triggerName))
                                return;
                            visitedTriggers_1.add(triggerName);
                            /** @type {?} */
                            var trigger = _this._triggers[triggerName];
                            /** @type {?} */
                            var transition = trigger.fallbackTransition;
                            /** @type {?} */
                            var elementStates = ( /** @type {?} */(_this._engine.statesByElement.get(element)));
                            /** @type {?} */
                            var fromState = elementStates[triggerName] || DEFAULT_STATE_VALUE;
                            /** @type {?} */
                            var toState = new StateValue(VOID_VALUE);
                            /** @type {?} */
                            var player = new TransitionAnimationPlayer(_this.id, triggerName, element);
                            _this._engine.totalQueuedPlayers++;
                            _this._queue.push({
                                element: element,
                                triggerName: triggerName,
                                transition: transition,
                                fromState: fromState,
                                toState: toState,
                                player: player,
                                isFallbackTransition: true
                            });
                        }));
                    }
                };
                /**
                 * @param {?} element
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.removeNode = function (element, context) {
                    var _this = this;
                    /** @type {?} */
                    var engine = this._engine;
                    if (element.childElementCount) {
                        this._signalRemovalForInnerTriggers(element, context, true);
                    }
                    // this means that a * => VOID animation was detected and kicked off
                    if (this.triggerLeaveAnimation(element, context, true))
                        return;
                    // find the player that is animating and make sure that the
                    // removal is delayed until that player has completed
                    /** @type {?} */
                    var containsPotentialParentTransition = false;
                    if (engine.totalAnimations) {
                        /** @type {?} */
                        var currentPlayers = engine.players.length ? engine.playersByQueriedElement.get(element) : [];
                        // when this `if statement` does not continue forward it means that
                        // a previous animation query has selected the current element and
                        // is animating it. In this situation want to continue forwards and
                        // allow the element to be queued up for animation later.
                        if (currentPlayers && currentPlayers.length) {
                            containsPotentialParentTransition = true;
                        }
                        else {
                            /** @type {?} */
                            var parent = element;
                            while (parent = parent.parentNode) {
                                /** @type {?} */
                                var triggers = engine.statesByElement.get(parent);
                                if (triggers) {
                                    containsPotentialParentTransition = true;
                                    break;
                                }
                            }
                        }
                    }
                    // at this stage we know that the element will either get removed
                    // during flush or will be picked up by a parent query. Either way
                    // we need to fire the listeners for this element when it DOES get
                    // removed (once the query parent animation is done or after flush)
                    this.prepareLeaveAnimationListeners(element);
                    // whether or not a parent has an animation we need to delay the deferral of the leave
                    // operation until we have more information (which we do after flush() has been called)
                    if (containsPotentialParentTransition) {
                        engine.markElementAsRemoved(this.id, element, false, context);
                    }
                    else {
                        // we do this after the flush has occurred such
                        // that the callbacks can be fired
                        engine.afterFlush(( /**
                         * @return {?}
                         */function () { return _this.clearElementCache(element); }));
                        engine.destroyInnerAnimations(element);
                        engine._onRemovalComplete(element, context);
                    }
                };
                /**
                 * @param {?} element
                 * @param {?} parent
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.insertNode = function (element, parent) { addClass(element, this._hostClassName); };
                /**
                 * @param {?} microtaskId
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.drainQueuedTransitions = function (microtaskId) {
                    var _this = this;
                    /** @type {?} */
                    var instructions = [];
                    this._queue.forEach(( /**
                     * @param {?} entry
                     * @return {?}
                     */function (/**
                     * @param {?} entry
                     * @return {?}
                     */ entry) {
                        /** @type {?} */
                        var player = entry.player;
                        if (player.destroyed)
                            return;
                        /** @type {?} */
                        var element = entry.element;
                        /** @type {?} */
                        var listeners = _this._elementListeners.get(element);
                        if (listeners) {
                            listeners.forEach(( /**
                             * @param {?} listener
                             * @return {?}
                             */function (listener) {
                                if (listener.name == entry.triggerName) {
                                    /** @type {?} */
                                    var baseEvent = makeAnimationEvent(element, entry.triggerName, entry.fromState.value, entry.toState.value);
                                    (( /** @type {?} */(baseEvent)))['_data'] = microtaskId;
                                    listenOnPlayer(entry.player, listener.phase, baseEvent, listener.callback);
                                }
                            }));
                        }
                        if (player.markedForDestroy) {
                            _this._engine.afterFlush(( /**
                             * @return {?}
                             */function () {
                                // now we can destroy the element properly since the event listeners have
                                // been bound to the player
                                player.destroy();
                            }));
                        }
                        else {
                            instructions.push(entry);
                        }
                    }));
                    this._queue = [];
                    return instructions.sort(( /**
                     * @param {?} a
                     * @param {?} b
                     * @return {?}
                     */function (a, b) {
                        // if depCount == 0 them move to front
                        // otherwise if a contains b then move back
                        /** @type {?} */
                        var d0 = a.transition.ast.depCount;
                        /** @type {?} */
                        var d1 = b.transition.ast.depCount;
                        if (d0 == 0 || d1 == 0) {
                            return d0 - d1;
                        }
                        return _this._engine.driver.containsElement(a.element, b.element) ? 1 : -1;
                    }));
                };
                /**
                 * @param {?} context
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.destroy = function (context) {
                    this.players.forEach(( /**
                     * @param {?} p
                     * @return {?}
                     */function (/**
                     * @param {?} p
                     * @return {?}
                     */ p) { return p.destroy(); }));
                    this._signalRemovalForInnerTriggers(this.hostElement, context);
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                AnimationTransitionNamespace.prototype.elementContainsData = function (element) {
                    /** @type {?} */
                    var containsData = false;
                    if (this._elementListeners.has(element))
                        containsData = true;
                    containsData =
                        (this._queue.find(( /**
                         * @param {?} entry
                         * @return {?}
                         */function (/**
                         * @param {?} entry
                         * @return {?}
                         */ entry) { return entry.element === element; })) ? true : false) || containsData;
                    return containsData;
                };
                return AnimationTransitionNamespace;
            }());
            if (false) { }
            /**
             * @record
             */
            function QueuedTransition() { }
            if (false) { }
            var TransitionAnimationEngine = /** @class */ (function () {
                /**
                 * @param {?} bodyNode
                 * @param {?} driver
                 * @param {?} _normalizer
                 */
                function TransitionAnimationEngine(bodyNode, driver, _normalizer) {
                    this.bodyNode = bodyNode;
                    this.driver = driver;
                    this._normalizer = _normalizer;
                    this.players = [];
                    this.newHostElements = new Map();
                    this.playersByElement = new Map();
                    this.playersByQueriedElement = new Map();
                    this.statesByElement = new Map();
                    this.disabledNodes = new Set();
                    this.totalAnimations = 0;
                    this.totalQueuedPlayers = 0;
                    this._namespaceLookup = {};
                    this._namespaceList = [];
                    this._flushFns = [];
                    this._whenQuietFns = [];
                    this.namespacesByHostElement = new Map();
                    this.collectedEnterElements = [];
                    this.collectedLeaveElements = [];
                    // this method is designed to be overridden by the code that uses this engine
                    this.onRemovalComplete = ( /**
                     * @param {?} element
                     * @param {?} context
                     * @return {?}
                     */function (element, context) { });
                }
                /**
                 * \@internal
                 * @param {?} element
                 * @param {?} context
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._onRemovalComplete = function (element, context) { this.onRemovalComplete(element, context); };
                Object.defineProperty(TransitionAnimationEngine.prototype, "queuedPlayers", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var players = [];
                        this._namespaceList.forEach(( /**
                         * @param {?} ns
                         * @return {?}
                         */function (/**
                         * @param {?} ns
                         * @return {?}
                         */ ns) {
                            ns.players.forEach(( /**
                             * @param {?} player
                             * @return {?}
                             */function (/**
                             * @param {?} player
                             * @return {?}
                             */ player) {
                                if (player.queued) {
                                    players.push(player);
                                }
                            }));
                        }));
                        return players;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} namespaceId
                 * @param {?} hostElement
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.createNamespace = function (namespaceId, hostElement) {
                    /** @type {?} */
                    var ns = new AnimationTransitionNamespace(namespaceId, hostElement, this);
                    if (hostElement.parentNode) {
                        this._balanceNamespaceList(ns, hostElement);
                    }
                    else {
                        // defer this later until flush during when the host element has
                        // been inserted so that we know exactly where to place it in
                        // the namespace list
                        this.newHostElements.set(hostElement, ns);
                        // given that this host element is apart of the animation code, it
                        // may or may not be inserted by a parent node that is an of an
                        // animation renderer type. If this happens then we can still have
                        // access to this item when we query for :enter nodes. If the parent
                        // is a renderer then the set data-structure will normalize the entry
                        this.collectEnterElement(hostElement);
                    }
                    return this._namespaceLookup[namespaceId] = ns;
                };
                /**
                 * @private
                 * @param {?} ns
                 * @param {?} hostElement
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._balanceNamespaceList = function (ns, hostElement) {
                    /** @type {?} */
                    var limit = this._namespaceList.length - 1;
                    if (limit >= 0) {
                        /** @type {?} */
                        var found = false;
                        for (var i = limit; i >= 0; i--) {
                            /** @type {?} */
                            var nextNamespace = this._namespaceList[i];
                            if (this.driver.containsElement(nextNamespace.hostElement, hostElement)) {
                                this._namespaceList.splice(i + 1, 0, ns);
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            this._namespaceList.splice(0, 0, ns);
                        }
                    }
                    else {
                        this._namespaceList.push(ns);
                    }
                    this.namespacesByHostElement.set(hostElement, ns);
                    return ns;
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} hostElement
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.register = function (namespaceId, hostElement) {
                    /** @type {?} */
                    var ns = this._namespaceLookup[namespaceId];
                    if (!ns) {
                        ns = this.createNamespace(namespaceId, hostElement);
                    }
                    return ns;
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} name
                 * @param {?} trigger
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.registerTrigger = function (namespaceId, name, trigger) {
                    /** @type {?} */
                    var ns = this._namespaceLookup[namespaceId];
                    if (ns && ns.register(name, trigger)) {
                        this.totalAnimations++;
                    }
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} context
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.destroy = function (namespaceId, context) {
                    var _this = this;
                    if (!namespaceId)
                        return;
                    /** @type {?} */
                    var ns = this._fetchNamespace(namespaceId);
                    this.afterFlush(( /**
                     * @return {?}
                     */function () {
                        _this.namespacesByHostElement.delete(ns.hostElement);
                        delete _this._namespaceLookup[namespaceId];
                        /** @type {?} */
                        var index = _this._namespaceList.indexOf(ns);
                        if (index >= 0) {
                            _this._namespaceList.splice(index, 1);
                        }
                    }));
                    this.afterFlushAnimationsDone(( /**
                     * @return {?}
                     */function () { return ns.destroy(context); }));
                };
                /**
                 * @private
                 * @param {?} id
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._fetchNamespace = function (id) { return this._namespaceLookup[id]; };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.fetchNamespacesByElement = function (element) {
                    // normally there should only be one namespace per element, however
                    // if @triggers are placed on both the component element and then
                    // its host element (within the component code) then there will be
                    // two namespaces returned. We use a set here to simply the dedupe
                    // of namespaces incase there are multiple triggers both the elm and host
                    /** @type {?} */
                    var namespaces = new Set();
                    /** @type {?} */
                    var elementStates = this.statesByElement.get(element);
                    if (elementStates) {
                        /** @type {?} */
                        var keys = Object.keys(elementStates);
                        for (var i = 0; i < keys.length; i++) {
                            /** @type {?} */
                            var nsId = elementStates[keys[i]].namespaceId;
                            if (nsId) {
                                /** @type {?} */
                                var ns = this._fetchNamespace(nsId);
                                if (ns) {
                                    namespaces.add(ns);
                                }
                            }
                        }
                    }
                    return namespaces;
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.trigger = function (namespaceId, element, name, value) {
                    if (isElementNode(element)) {
                        /** @type {?} */
                        var ns = this._fetchNamespace(namespaceId);
                        if (ns) {
                            ns.trigger(element, name, value);
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} parent
                 * @param {?} insertBefore
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.insertNode = function (namespaceId, element, parent, insertBefore) {
                    if (!isElementNode(element))
                        return;
                    // special case for when an element is removed and reinserted (move operation)
                    // when this occurs we do not want to use the element for deletion later
                    /** @type {?} */
                    var details = ( /** @type {?} */(element[REMOVAL_FLAG]));
                    if (details && details.setForRemoval) {
                        details.setForRemoval = false;
                        details.setForMove = true;
                        /** @type {?} */
                        var index = this.collectedLeaveElements.indexOf(element);
                        if (index >= 0) {
                            this.collectedLeaveElements.splice(index, 1);
                        }
                    }
                    // in the event that the namespaceId is blank then the caller
                    // code does not contain any animation code in it, but it is
                    // just being called so that the node is marked as being inserted
                    if (namespaceId) {
                        /** @type {?} */
                        var ns = this._fetchNamespace(namespaceId);
                        // This if-statement is a workaround for router issue #21947.
                        // The router sometimes hits a race condition where while a route
                        // is being instantiated a new navigation arrives, triggering leave
                        // animation of DOM that has not been fully initialized, until this
                        // is resolved, we need to handle the scenario when DOM is not in a
                        // consistent state during the animation.
                        if (ns) {
                            ns.insertNode(element, parent);
                        }
                    }
                    // only *directives and host elements are inserted before
                    if (insertBefore) {
                        this.collectEnterElement(element);
                    }
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.collectEnterElement = function (element) { this.collectedEnterElements.push(element); };
                /**
                 * @param {?} element
                 * @param {?} value
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.markElementAsDisabled = function (element, value) {
                    if (value) {
                        if (!this.disabledNodes.has(element)) {
                            this.disabledNodes.add(element);
                            addClass(element, DISABLED_CLASSNAME);
                        }
                    }
                    else if (this.disabledNodes.has(element)) {
                        this.disabledNodes.delete(element);
                        removeClass(element, DISABLED_CLASSNAME);
                    }
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} isHostElement
                 * @param {?} context
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.removeNode = function (namespaceId, element, isHostElement, context) {
                    if (isElementNode(element)) {
                        /** @type {?} */
                        var ns = namespaceId ? this._fetchNamespace(namespaceId) : null;
                        if (ns) {
                            ns.removeNode(element, context);
                        }
                        else {
                            this.markElementAsRemoved(namespaceId, element, false, context);
                        }
                        if (isHostElement) {
                            /** @type {?} */
                            var hostNS = this.namespacesByHostElement.get(element);
                            if (hostNS && hostNS.id !== namespaceId) {
                                hostNS.removeNode(element, context);
                            }
                        }
                    }
                    else {
                        this._onRemovalComplete(element, context);
                    }
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?=} hasAnimation
                 * @param {?=} context
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.markElementAsRemoved = function (namespaceId, element, hasAnimation, context) {
                    this.collectedLeaveElements.push(element);
                    element[REMOVAL_FLAG] = {
                        namespaceId: namespaceId,
                        setForRemoval: context, hasAnimation: hasAnimation,
                        removedBeforeQueried: false
                    };
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} name
                 * @param {?} phase
                 * @param {?} callback
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.listen = function (namespaceId, element, name, phase, callback) {
                    if (isElementNode(element)) {
                        return this._fetchNamespace(namespaceId).listen(element, name, phase, callback);
                    }
                    return ( /**
                     * @return {?}
                     */function () { });
                };
                /**
                 * @private
                 * @param {?} entry
                 * @param {?} subTimelines
                 * @param {?} enterClassName
                 * @param {?} leaveClassName
                 * @param {?=} skipBuildAst
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._buildInstruction = function (entry, subTimelines, enterClassName, leaveClassName, skipBuildAst) {
                    return entry.transition.build(this.driver, entry.element, entry.fromState.value, entry.toState.value, enterClassName, leaveClassName, entry.fromState.options, entry.toState.options, subTimelines, skipBuildAst);
                };
                /**
                 * @param {?} containerElement
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.destroyInnerAnimations = function (containerElement) {
                    var _this = this;
                    /** @type {?} */
                    var elements = this.driver.query(containerElement, NG_TRIGGER_SELECTOR, true);
                    elements.forEach(( /**
                     * @param {?} element
                     * @return {?}
                     */function (/**
                     * @param {?} element
                     * @return {?}
                     */ element) { return _this.destroyActiveAnimationsForElement(element); }));
                    if (this.playersByQueriedElement.size == 0)
                        return;
                    elements = this.driver.query(containerElement, NG_ANIMATING_SELECTOR, true);
                    elements.forEach(( /**
                     * @param {?} element
                     * @return {?}
                     */function (/**
                     * @param {?} element
                     * @return {?}
                     */ element) { return _this.finishActiveQueriedAnimationOnElement(element); }));
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.destroyActiveAnimationsForElement = function (element) {
                    /** @type {?} */
                    var players = this.playersByElement.get(element);
                    if (players) {
                        players.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) {
                            // special case for when an element is set for destruction, but hasn't started.
                            // in this situation we want to delay the destruction until the flush occurs
                            // so that any event listeners attached to the player are triggered.
                            if (player.queued) {
                                player.markedForDestroy = true;
                            }
                            else {
                                player.destroy();
                            }
                        }));
                    }
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.finishActiveQueriedAnimationOnElement = function (element) {
                    /** @type {?} */
                    var players = this.playersByQueriedElement.get(element);
                    if (players) {
                        players.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) { return player.finish(); }));
                    }
                };
                /**
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.whenRenderingDone = function () {
                    var _this = this;
                    return new Promise(( /**
                     * @param {?} resolve
                     * @return {?}
                     */function (/**
                     * @param {?} resolve
                     * @return {?}
                     */ resolve) {
                        if (_this.players.length) {
                            return optimizeGroupPlayer(_this.players).onDone(( /**
                             * @return {?}
                             */function () { return resolve(); }));
                        }
                        else {
                            resolve();
                        }
                    }));
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.processLeaveNode = function (element) {
                    var _this = this;
                    /** @type {?} */
                    var details = ( /** @type {?} */(element[REMOVAL_FLAG]));
                    if (details && details.setForRemoval) {
                        // this will prevent it from removing it twice
                        element[REMOVAL_FLAG] = NULL_REMOVAL_STATE;
                        if (details.namespaceId) {
                            this.destroyInnerAnimations(element);
                            /** @type {?} */
                            var ns = this._fetchNamespace(details.namespaceId);
                            if (ns) {
                                ns.clearElementCache(element);
                            }
                        }
                        this._onRemovalComplete(element, details.setForRemoval);
                    }
                    if (this.driver.matchesElement(element, DISABLED_SELECTOR)) {
                        this.markElementAsDisabled(element, false);
                    }
                    this.driver.query(element, DISABLED_SELECTOR, true).forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        _this.markElementAsDisabled(node, false);
                    }));
                };
                /**
                 * @param {?=} microtaskId
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.flush = function (microtaskId) {
                    var _this = this;
                    if (microtaskId === void 0) { microtaskId = -1; }
                    /** @type {?} */
                    var players = [];
                    if (this.newHostElements.size) {
                        this.newHostElements.forEach(( /**
                         * @param {?} ns
                         * @param {?} element
                         * @return {?}
                         */function (ns, element) { return _this._balanceNamespaceList(ns, element); }));
                        this.newHostElements.clear();
                    }
                    if (this.totalAnimations && this.collectedEnterElements.length) {
                        for (var i = 0; i < this.collectedEnterElements.length; i++) {
                            /** @type {?} */
                            var elm = this.collectedEnterElements[i];
                            addClass(elm, STAR_CLASSNAME);
                        }
                    }
                    if (this._namespaceList.length &&
                        (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
                        /** @type {?} */
                        var cleanupFns = [];
                        try {
                            players = this._flushAnimations(cleanupFns, microtaskId);
                        }
                        finally {
                            for (var i = 0; i < cleanupFns.length; i++) {
                                cleanupFns[i]();
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < this.collectedLeaveElements.length; i++) {
                            /** @type {?} */
                            var element = this.collectedLeaveElements[i];
                            this.processLeaveNode(element);
                        }
                    }
                    this.totalQueuedPlayers = 0;
                    this.collectedEnterElements.length = 0;
                    this.collectedLeaveElements.length = 0;
                    this._flushFns.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    this._flushFns = [];
                    if (this._whenQuietFns.length) {
                        // we move these over to a variable so that
                        // if any new callbacks are registered in another
                        // flush they do not populate the existing set
                        /** @type {?} */
                        var quietFns_1 = this._whenQuietFns;
                        this._whenQuietFns = [];
                        if (players.length) {
                            optimizeGroupPlayer(players).onDone(( /**
                             * @return {?}
                             */function () {
                                quietFns_1.forEach(( /**
                                 * @param {?} fn
                                 * @return {?}
                                 */function (/**
                                 * @param {?} fn
                                 * @return {?}
                                 */ fn) { return fn(); }));
                            }));
                        }
                        else {
                            quietFns_1.forEach(( /**
                             * @param {?} fn
                             * @return {?}
                             */function (/**
                             * @param {?} fn
                             * @return {?}
                             */ fn) { return fn(); }));
                        }
                    }
                };
                /**
                 * @param {?} errors
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.reportError = function (errors) {
                    throw new Error("Unable to process animations due to the following failed trigger transitions\n " + errors.join('\n'));
                };
                /**
                 * @private
                 * @param {?} cleanupFns
                 * @param {?} microtaskId
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._flushAnimations = function (cleanupFns, microtaskId) {
                    var _this = this;
                    /** @type {?} */
                    var subTimelines = new ElementInstructionMap();
                    /** @type {?} */
                    var skippedPlayers = [];
                    /** @type {?} */
                    var skippedPlayersMap = new Map();
                    /** @type {?} */
                    var queuedInstructions = [];
                    /** @type {?} */
                    var queriedElements = new Map();
                    /** @type {?} */
                    var allPreStyleElements = new Map();
                    /** @type {?} */
                    var allPostStyleElements = new Map();
                    /** @type {?} */
                    var disabledElementsSet = new Set();
                    this.disabledNodes.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        disabledElementsSet.add(node);
                        /** @type {?} */
                        var nodesThatAreDisabled = _this.driver.query(node, QUEUED_SELECTOR, true);
                        for (var i_1 = 0; i_1 < nodesThatAreDisabled.length; i_1++) {
                            disabledElementsSet.add(nodesThatAreDisabled[i_1]);
                        }
                    }));
                    /** @type {?} */
                    var bodyNode = this.bodyNode;
                    /** @type {?} */
                    var allTriggerElements = Array.from(this.statesByElement.keys());
                    /** @type {?} */
                    var enterNodeMap = buildRootMap(allTriggerElements, this.collectedEnterElements);
                    // this must occur before the instructions are built below such that
                    // the :enter queries match the elements (since the timeline queries
                    // are fired during instruction building).
                    /** @type {?} */
                    var enterNodeMapIds = new Map();
                    /** @type {?} */
                    var i = 0;
                    enterNodeMap.forEach(( /**
                     * @param {?} nodes
                     * @param {?} root
                     * @return {?}
                     */function (nodes, root) {
                        /** @type {?} */
                        var className = ENTER_CLASSNAME + i++;
                        enterNodeMapIds.set(root, className);
                        nodes.forEach(( /**
                         * @param {?} node
                         * @return {?}
                         */function (/**
                         * @param {?} node
                         * @return {?}
                         */ node) { return addClass(node, className); }));
                    }));
                    /** @type {?} */
                    var allLeaveNodes = [];
                    /** @type {?} */
                    var mergedLeaveNodes = new Set();
                    /** @type {?} */
                    var leaveNodesWithoutAnimations = new Set();
                    for (var i_2 = 0; i_2 < this.collectedLeaveElements.length; i_2++) {
                        /** @type {?} */
                        var element = this.collectedLeaveElements[i_2];
                        /** @type {?} */
                        var details = ( /** @type {?} */(element[REMOVAL_FLAG]));
                        if (details && details.setForRemoval) {
                            allLeaveNodes.push(element);
                            mergedLeaveNodes.add(element);
                            if (details.hasAnimation) {
                                this.driver.query(element, STAR_SELECTOR, true).forEach(( /**
                                 * @param {?} elm
                                 * @return {?}
                                 */function (/**
                                 * @param {?} elm
                                 * @return {?}
                                 */ elm) { return mergedLeaveNodes.add(elm); }));
                            }
                            else {
                                leaveNodesWithoutAnimations.add(element);
                            }
                        }
                    }
                    /** @type {?} */
                    var leaveNodeMapIds = new Map();
                    /** @type {?} */
                    var leaveNodeMap = buildRootMap(allTriggerElements, Array.from(mergedLeaveNodes));
                    leaveNodeMap.forEach(( /**
                     * @param {?} nodes
                     * @param {?} root
                     * @return {?}
                     */function (nodes, root) {
                        /** @type {?} */
                        var className = LEAVE_CLASSNAME + i++;
                        leaveNodeMapIds.set(root, className);
                        nodes.forEach(( /**
                         * @param {?} node
                         * @return {?}
                         */function (/**
                         * @param {?} node
                         * @return {?}
                         */ node) { return addClass(node, className); }));
                    }));
                    cleanupFns.push(( /**
                     * @return {?}
                     */function () {
                        enterNodeMap.forEach(( /**
                         * @param {?} nodes
                         * @param {?} root
                         * @return {?}
                         */function (nodes, root) {
                            /** @type {?} */
                            var className = ( /** @type {?} */(enterNodeMapIds.get(root)));
                            nodes.forEach(( /**
                             * @param {?} node
                             * @return {?}
                             */function (/**
                             * @param {?} node
                             * @return {?}
                             */ node) { return removeClass(node, className); }));
                        }));
                        leaveNodeMap.forEach(( /**
                         * @param {?} nodes
                         * @param {?} root
                         * @return {?}
                         */function (nodes, root) {
                            /** @type {?} */
                            var className = ( /** @type {?} */(leaveNodeMapIds.get(root)));
                            nodes.forEach(( /**
                             * @param {?} node
                             * @return {?}
                             */function (/**
                             * @param {?} node
                             * @return {?}
                             */ node) { return removeClass(node, className); }));
                        }));
                        allLeaveNodes.forEach(( /**
                         * @param {?} element
                         * @return {?}
                         */function (/**
                         * @param {?} element
                         * @return {?}
                         */ element) { _this.processLeaveNode(element); }));
                    }));
                    /** @type {?} */
                    var allPlayers = [];
                    /** @type {?} */
                    var erroneousTransitions = [];
                    for (var i_3 = this._namespaceList.length - 1; i_3 >= 0; i_3--) {
                        /** @type {?} */
                        var ns = this._namespaceList[i_3];
                        ns.drainQueuedTransitions(microtaskId).forEach(( /**
                         * @param {?} entry
                         * @return {?}
                         */function (/**
                         * @param {?} entry
                         * @return {?}
                         */ entry) {
                            /** @type {?} */
                            var player = entry.player;
                            /** @type {?} */
                            var element = entry.element;
                            allPlayers.push(player);
                            if (_this.collectedEnterElements.length) {
                                /** @type {?} */
                                var details = ( /** @type {?} */(element[REMOVAL_FLAG]));
                                // move animations are currently not supported...
                                if (details && details.setForMove) {
                                    player.destroy();
                                    return;
                                }
                            }
                            /** @type {?} */
                            var nodeIsOrphaned = !bodyNode || !_this.driver.containsElement(bodyNode, element);
                            /** @type {?} */
                            var leaveClassName = ( /** @type {?} */(leaveNodeMapIds.get(element)));
                            /** @type {?} */
                            var enterClassName = ( /** @type {?} */(enterNodeMapIds.get(element)));
                            /** @type {?} */
                            var instruction = ( /** @type {?} */(_this._buildInstruction(entry, subTimelines, enterClassName, leaveClassName, nodeIsOrphaned)));
                            if (instruction.errors && instruction.errors.length) {
                                erroneousTransitions.push(instruction);
                                return;
                            }
                            // even though the element may not be apart of the DOM, it may
                            // still be added at a later point (due to the mechanics of content
                            // projection and/or dynamic component insertion) therefore it's
                            // important we still style the element.
                            if (nodeIsOrphaned) {
                                player.onStart(( /**
                                 * @return {?}
                                 */function () { return eraseStyles(element, instruction.fromStyles); }));
                                player.onDestroy(( /**
                                 * @return {?}
                                 */function () { return setStyles(element, instruction.toStyles); }));
                                skippedPlayers.push(player);
                                return;
                            }
                            // if a unmatched transition is queued to go then it SHOULD NOT render
                            // an animation and cancel the previously running animations.
                            if (entry.isFallbackTransition) {
                                player.onStart(( /**
                                 * @return {?}
                                 */function () { return eraseStyles(element, instruction.fromStyles); }));
                                player.onDestroy(( /**
                                 * @return {?}
                                 */function () { return setStyles(element, instruction.toStyles); }));
                                skippedPlayers.push(player);
                                return;
                            }
                            // this means that if a parent animation uses this animation as a sub trigger
                            // then it will instruct the timeline builder to not add a player delay, but
                            // instead stretch the first keyframe gap up until the animation starts. The
                            // reason this is important is to prevent extra initialization styles from being
                            // required by the user in the animation.
                            instruction.timelines.forEach(( /**
                             * @param {?} tl
                             * @return {?}
                             */function (/**
                             * @param {?} tl
                             * @return {?}
                             */ tl) { return tl.stretchStartingKeyframe = true; }));
                            subTimelines.append(element, instruction.timelines);
                            /** @type {?} */
                            var tuple = { instruction: instruction, player: player, element: element };
                            queuedInstructions.push(tuple);
                            instruction.queriedElements.forEach(( /**
                             * @param {?} element
                             * @return {?}
                             */function (/**
                             * @param {?} element
                             * @return {?}
                             */ element) { return getOrSetAsInMap(queriedElements, element, []).push(player); }));
                            instruction.preStyleProps.forEach(( /**
                             * @param {?} stringMap
                             * @param {?} element
                             * @return {?}
                             */function (stringMap, element) {
                                /** @type {?} */
                                var props = Object.keys(stringMap);
                                if (props.length) {
                                    /** @type {?} */
                                    var setVal_1 = ( /** @type {?} */(allPreStyleElements.get(element)));
                                    if (!setVal_1) {
                                        allPreStyleElements.set(element, setVal_1 = new Set());
                                    }
                                    props.forEach(( /**
                                     * @param {?} prop
                                     * @return {?}
                                     */function (/**
                                     * @param {?} prop
                                     * @return {?}
                                     */ prop) { return setVal_1.add(prop); }));
                                }
                            }));
                            instruction.postStyleProps.forEach(( /**
                             * @param {?} stringMap
                             * @param {?} element
                             * @return {?}
                             */function (stringMap, element) {
                                /** @type {?} */
                                var props = Object.keys(stringMap);
                                /** @type {?} */
                                var setVal = ( /** @type {?} */(allPostStyleElements.get(element)));
                                if (!setVal) {
                                    allPostStyleElements.set(element, setVal = new Set());
                                }
                                props.forEach(( /**
                                 * @param {?} prop
                                 * @return {?}
                                 */function (/**
                                 * @param {?} prop
                                 * @return {?}
                                 */ prop) { return setVal.add(prop); }));
                            }));
                        }));
                    }
                    if (erroneousTransitions.length) {
                        /** @type {?} */
                        var errors_1 = [];
                        erroneousTransitions.forEach(( /**
                         * @param {?} instruction
                         * @return {?}
                         */function (/**
                         * @param {?} instruction
                         * @return {?}
                         */ instruction) {
                            errors_1.push("@" + instruction.triggerName + " has failed due to:\n");
                            ( /** @type {?} */(instruction.errors)).forEach(( /**
                             * @param {?} error
                             * @return {?}
                             */function (/**
                             * @param {?} error
                             * @return {?}
                             */ error) { return errors_1.push("- " + error + "\n"); }));
                        }));
                        allPlayers.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) { return player.destroy(); }));
                        this.reportError(errors_1);
                    }
                    /** @type {?} */
                    var allPreviousPlayersMap = new Map();
                    // this map works to tell which element in the DOM tree is contained by
                    // which animation. Further down below this map will get populated once
                    // the players are built and in doing so it can efficiently figure out
                    // if a sub player is skipped due to a parent player having priority.
                    /** @type {?} */
                    var animationElementMap = new Map();
                    queuedInstructions.forEach(( /**
                     * @param {?} entry
                     * @return {?}
                     */function (/**
                     * @param {?} entry
                     * @return {?}
                     */ entry) {
                        /** @type {?} */
                        var element = entry.element;
                        if (subTimelines.has(element)) {
                            animationElementMap.set(element, element);
                            _this._beforeAnimationBuild(entry.player.namespaceId, entry.instruction, allPreviousPlayersMap);
                        }
                    }));
                    skippedPlayers.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        /** @type {?} */
                        var element = player.element;
                        /** @type {?} */
                        var previousPlayers = _this._getPreviousPlayers(element, false, player.namespaceId, player.triggerName, null);
                        previousPlayers.forEach(( /**
                         * @param {?} prevPlayer
                         * @return {?}
                         */function (/**
                         * @param {?} prevPlayer
                         * @return {?}
                         */ prevPlayer) {
                            getOrSetAsInMap(allPreviousPlayersMap, element, []).push(prevPlayer);
                            prevPlayer.destroy();
                        }));
                    }));
                    // this is a special case for nodes that will be removed (either by)
                    // having their own leave animations or by being queried in a container
                    // that will be removed once a parent animation is complete. The idea
                    // here is that * styles must be identical to ! styles because of
                    // backwards compatibility (* is also filled in by default in many places).
                    // Otherwise * styles will return an empty value or auto since the element
                    // that is being getComputedStyle'd will not be visible (since * = destination)
                    /** @type {?} */
                    var replaceNodes = allLeaveNodes.filter(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        return replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements);
                    }));
                    // POST STAGE: fill the * styles
                    /** @type {?} */
                    var postStylesMap = new Map();
                    /** @type {?} */
                    var allLeaveQueriedNodes = cloakAndComputeStyles(postStylesMap, this.driver, leaveNodesWithoutAnimations, allPostStyleElements, _angular_animations__WEBPACK_IMPORTED_MODULE_0__["AUTO_STYLE"]);
                    allLeaveQueriedNodes.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        if (replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements)) {
                            replaceNodes.push(node);
                        }
                    }));
                    // PRE STAGE: fill the ! styles
                    /** @type {?} */
                    var preStylesMap = new Map();
                    enterNodeMap.forEach(( /**
                     * @param {?} nodes
                     * @param {?} root
                     * @return {?}
                     */function (nodes, root) {
                        cloakAndComputeStyles(preStylesMap, _this.driver, new Set(nodes), allPreStyleElements, _angular_animations__WEBPACK_IMPORTED_MODULE_0__["ɵPRE_STYLE"]);
                    }));
                    replaceNodes.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        /** @type {?} */
                        var post = postStylesMap.get(node);
                        /** @type {?} */
                        var pre = preStylesMap.get(node);
                        postStylesMap.set(node, ( /** @type {?} */(Object.assign({}, post, pre))));
                    }));
                    /** @type {?} */
                    var rootPlayers = [];
                    /** @type {?} */
                    var subPlayers = [];
                    /** @type {?} */
                    var NO_PARENT_ANIMATION_ELEMENT_DETECTED = {};
                    queuedInstructions.forEach(( /**
                     * @param {?} entry
                     * @return {?}
                     */function (/**
                     * @param {?} entry
                     * @return {?}
                     */ entry) {
                        var element = entry.element, player = entry.player, instruction = entry.instruction;
                        // this means that it was never consumed by a parent animation which
                        // means that it is independent and therefore should be set for animation
                        if (subTimelines.has(element)) {
                            if (disabledElementsSet.has(element)) {
                                player.onDestroy(( /**
                                 * @return {?}
                                 */function () { return setStyles(element, instruction.toStyles); }));
                                player.disabled = true;
                                player.overrideTotalTime(instruction.totalTime);
                                skippedPlayers.push(player);
                                return;
                            }
                            // this will flow up the DOM and query the map to figure out
                            // if a parent animation has priority over it. In the situation
                            // that a parent is detected then it will cancel the loop. If
                            // nothing is detected, or it takes a few hops to find a parent,
                            // then it will fill in the missing nodes and signal them as having
                            // a detected parent (or a NO_PARENT value via a special constant).
                            /** @type {?} */
                            var parentWithAnimation_1 = NO_PARENT_ANIMATION_ELEMENT_DETECTED;
                            if (animationElementMap.size > 1) {
                                /** @type {?} */
                                var elm = element;
                                /** @type {?} */
                                var parentsToAdd = [];
                                while (elm = elm.parentNode) {
                                    /** @type {?} */
                                    var detectedParent = animationElementMap.get(elm);
                                    if (detectedParent) {
                                        parentWithAnimation_1 = detectedParent;
                                        break;
                                    }
                                    parentsToAdd.push(elm);
                                }
                                parentsToAdd.forEach(( /**
                                 * @param {?} parent
                                 * @return {?}
                                 */function (/**
                                 * @param {?} parent
                                 * @return {?}
                                 */ parent) { return animationElementMap.set(parent, parentWithAnimation_1); }));
                            }
                            /** @type {?} */
                            var innerPlayer = _this._buildAnimation(player.namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap);
                            player.setRealPlayer(innerPlayer);
                            if (parentWithAnimation_1 === NO_PARENT_ANIMATION_ELEMENT_DETECTED) {
                                rootPlayers.push(player);
                            }
                            else {
                                /** @type {?} */
                                var parentPlayers = _this.playersByElement.get(parentWithAnimation_1);
                                if (parentPlayers && parentPlayers.length) {
                                    player.parentPlayer = optimizeGroupPlayer(parentPlayers);
                                }
                                skippedPlayers.push(player);
                            }
                        }
                        else {
                            eraseStyles(element, instruction.fromStyles);
                            player.onDestroy(( /**
                             * @return {?}
                             */function () { return setStyles(element, instruction.toStyles); }));
                            // there still might be a ancestor player animating this
                            // element therefore we will still add it as a sub player
                            // even if its animation may be disabled
                            subPlayers.push(player);
                            if (disabledElementsSet.has(element)) {
                                skippedPlayers.push(player);
                            }
                        }
                    }));
                    // find all of the sub players' corresponding inner animation player
                    subPlayers.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        // even if any players are not found for a sub animation then it
                        // will still complete itself after the next tick since it's Noop
                        /** @type {?} */
                        var playersForElement = skippedPlayersMap.get(player.element);
                        if (playersForElement && playersForElement.length) {
                            /** @type {?} */
                            var innerPlayer = optimizeGroupPlayer(playersForElement);
                            player.setRealPlayer(innerPlayer);
                        }
                    }));
                    // the reason why we don't actually play the animation is
                    // because all that a skipped player is designed to do is to
                    // fire the start/done transition callback events
                    skippedPlayers.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        if (player.parentPlayer) {
                            player.syncPlayerEvents(player.parentPlayer);
                        }
                        else {
                            player.destroy();
                        }
                    }));
                    // run through all of the queued removals and see if they
                    // were picked up by a query. If not then perform the removal
                    // operation right away unless a parent animation is ongoing.
                    for (var i_4 = 0; i_4 < allLeaveNodes.length; i_4++) {
                        /** @type {?} */
                        var element = allLeaveNodes[i_4];
                        /** @type {?} */
                        var details = ( /** @type {?} */(element[REMOVAL_FLAG]));
                        removeClass(element, LEAVE_CLASSNAME);
                        // this means the element has a removal animation that is being
                        // taken care of and therefore the inner elements will hang around
                        // until that animation is over (or the parent queried animation)
                        if (details && details.hasAnimation)
                            continue;
                        /** @type {?} */
                        var players = [];
                        // if this element is queried or if it contains queried children
                        // then we want for the element not to be removed from the page
                        // until the queried animations have finished
                        if (queriedElements.size) {
                            /** @type {?} */
                            var queriedPlayerResults = queriedElements.get(element);
                            if (queriedPlayerResults && queriedPlayerResults.length) {
                                players.push.apply(players, queriedPlayerResults);
                            }
                            /** @type {?} */
                            var queriedInnerElements = this.driver.query(element, NG_ANIMATING_SELECTOR, true);
                            for (var j = 0; j < queriedInnerElements.length; j++) {
                                /** @type {?} */
                                var queriedPlayers = queriedElements.get(queriedInnerElements[j]);
                                if (queriedPlayers && queriedPlayers.length) {
                                    players.push.apply(players, queriedPlayers);
                                }
                            }
                        }
                        /** @type {?} */
                        var activePlayers = players.filter(( /**
                         * @param {?} p
                         * @return {?}
                         */function (/**
                         * @param {?} p
                         * @return {?}
                         */ p) { return !p.destroyed; }));
                        if (activePlayers.length) {
                            removeNodesAfterAnimationDone(this, element, activePlayers);
                        }
                        else {
                            this.processLeaveNode(element);
                        }
                    }
                    // this is required so the cleanup method doesn't remove them
                    allLeaveNodes.length = 0;
                    rootPlayers.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        _this.players.push(player);
                        player.onDone(( /**
                         * @return {?}
                         */function () {
                            player.destroy();
                            /** @type {?} */
                            var index = _this.players.indexOf(player);
                            _this.players.splice(index, 1);
                        }));
                        player.play();
                    }));
                    return rootPlayers;
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.elementContainsData = function (namespaceId, element) {
                    /** @type {?} */
                    var containsData = false;
                    /** @type {?} */
                    var details = ( /** @type {?} */(element[REMOVAL_FLAG]));
                    if (details && details.setForRemoval)
                        containsData = true;
                    if (this.playersByElement.has(element))
                        containsData = true;
                    if (this.playersByQueriedElement.has(element))
                        containsData = true;
                    if (this.statesByElement.has(element))
                        containsData = true;
                    return this._fetchNamespace(namespaceId).elementContainsData(element) || containsData;
                };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.afterFlush = function (callback) { this._flushFns.push(callback); };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype.afterFlushAnimationsDone = function (callback) { this._whenQuietFns.push(callback); };
                /**
                 * @private
                 * @param {?} element
                 * @param {?} isQueriedElement
                 * @param {?=} namespaceId
                 * @param {?=} triggerName
                 * @param {?=} toStateValue
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._getPreviousPlayers = function (element, isQueriedElement, namespaceId, triggerName, toStateValue) {
                    /** @type {?} */
                    var players = [];
                    if (isQueriedElement) {
                        /** @type {?} */
                        var queriedElementPlayers = this.playersByQueriedElement.get(element);
                        if (queriedElementPlayers) {
                            players = queriedElementPlayers;
                        }
                    }
                    else {
                        /** @type {?} */
                        var elementPlayers = this.playersByElement.get(element);
                        if (elementPlayers) {
                            /** @type {?} */
                            var isRemovalAnimation_1 = !toStateValue || toStateValue == VOID_VALUE;
                            elementPlayers.forEach(( /**
                             * @param {?} player
                             * @return {?}
                             */function (/**
                             * @param {?} player
                             * @return {?}
                             */ player) {
                                if (player.queued)
                                    return;
                                if (!isRemovalAnimation_1 && player.triggerName != triggerName)
                                    return;
                                players.push(player);
                            }));
                        }
                    }
                    if (namespaceId || triggerName) {
                        players = players.filter(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) {
                            if (namespaceId && namespaceId != player.namespaceId)
                                return false;
                            if (triggerName && triggerName != player.triggerName)
                                return false;
                            return true;
                        }));
                    }
                    return players;
                };
                /**
                 * @private
                 * @param {?} namespaceId
                 * @param {?} instruction
                 * @param {?} allPreviousPlayersMap
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._beforeAnimationBuild = function (namespaceId, instruction, allPreviousPlayersMap) {
                    /** @type {?} */
                    var triggerName = instruction.triggerName;
                    /** @type {?} */
                    var rootElement = instruction.element;
                    // when a removal animation occurs, ALL previous players are collected
                    // and destroyed (even if they are outside of the current namespace)
                    /** @type {?} */
                    var targetNameSpaceId = instruction.isRemovalTransition ? undefined : namespaceId;
                    /** @type {?} */
                    var targetTriggerName = instruction.isRemovalTransition ? undefined : triggerName;
                    var _loop_2 = function (timelineInstruction) {
                        /** @type {?} */
                        var element = timelineInstruction.element;
                        /** @type {?} */
                        var isQueriedElement = element !== rootElement;
                        /** @type {?} */
                        var players = getOrSetAsInMap(allPreviousPlayersMap, element, []);
                        /** @type {?} */
                        var previousPlayers = this_1._getPreviousPlayers(element, isQueriedElement, targetNameSpaceId, targetTriggerName, instruction.toState);
                        previousPlayers.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) {
                            /** @type {?} */
                            var realPlayer = ( /** @type {?} */(player.getRealPlayer()));
                            if (realPlayer.beforeDestroy) {
                                realPlayer.beforeDestroy();
                            }
                            player.destroy();
                            players.push(player);
                        }));
                    };
                    var this_1 = this;
                    for (var _c = 0, _d = instruction.timelines; _c < _d.length; _c++) {
                        var timelineInstruction = _d[_c];
                        _loop_2(timelineInstruction);
                    }
                    // this needs to be done so that the PRE/POST styles can be
                    // computed properly without interfering with the previous animation
                    eraseStyles(rootElement, instruction.fromStyles);
                };
                /**
                 * @private
                 * @param {?} namespaceId
                 * @param {?} instruction
                 * @param {?} allPreviousPlayersMap
                 * @param {?} skippedPlayersMap
                 * @param {?} preStylesMap
                 * @param {?} postStylesMap
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._buildAnimation = function (namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap) {
                    var _this = this;
                    /** @type {?} */
                    var triggerName = instruction.triggerName;
                    /** @type {?} */
                    var rootElement = instruction.element;
                    // we first run this so that the previous animation player
                    // data can be passed into the successive animation players
                    /** @type {?} */
                    var allQueriedPlayers = [];
                    /** @type {?} */
                    var allConsumedElements = new Set();
                    /** @type {?} */
                    var allSubElements = new Set();
                    /** @type {?} */
                    var allNewPlayers = instruction.timelines.map(( /**
                     * @param {?} timelineInstruction
                     * @return {?}
                     */function (/**
                     * @param {?} timelineInstruction
                     * @return {?}
                     */ timelineInstruction) {
                        /** @type {?} */
                        var element = timelineInstruction.element;
                        allConsumedElements.add(element);
                        // FIXME (matsko): make sure to-be-removed animations are removed properly
                        /** @type {?} */
                        var details = element[REMOVAL_FLAG];
                        if (details && details.removedBeforeQueried)
                            return new _angular_animations__WEBPACK_IMPORTED_MODULE_0__["NoopAnimationPlayer"](timelineInstruction.duration, timelineInstruction.delay);
                        /** @type {?} */
                        var isQueriedElement = element !== rootElement;
                        /** @type {?} */
                        var previousPlayers = flattenGroupPlayers((allPreviousPlayersMap.get(element) || EMPTY_PLAYER_ARRAY)
                            .map(( /**
                     * @param {?} p
                     * @return {?}
                     */function (/**
                     * @param {?} p
                     * @return {?}
                     */ p) { return p.getRealPlayer(); })))
                            .filter(( /**
                     * @param {?} p
                     * @return {?}
                     */function (/**
                     * @param {?} p
                     * @return {?}
                     */ p) {
                            // the `element` is not apart of the AnimationPlayer definition, but
                            // Mock/WebAnimations
                            // use the element within their implementation. This will be added in Angular5 to
                            // AnimationPlayer
                            /** @type {?} */
                            var pp = ( /** @type {?} */(p));
                            return pp.element ? pp.element === element : false;
                        }));
                        /** @type {?} */
                        var preStyles = preStylesMap.get(element);
                        /** @type {?} */
                        var postStyles = postStylesMap.get(element);
                        /** @type {?} */
                        var keyframes = normalizeKeyframes(_this.driver, _this._normalizer, element, timelineInstruction.keyframes, preStyles, postStyles);
                        /** @type {?} */
                        var player = _this._buildPlayer(timelineInstruction, keyframes, previousPlayers);
                        // this means that this particular player belongs to a sub trigger. It is
                        // important that we match this player up with the corresponding (@trigger.listener)
                        if (timelineInstruction.subTimeline && skippedPlayersMap) {
                            allSubElements.add(element);
                        }
                        if (isQueriedElement) {
                            /** @type {?} */
                            var wrappedPlayer = new TransitionAnimationPlayer(namespaceId, triggerName, element);
                            wrappedPlayer.setRealPlayer(player);
                            allQueriedPlayers.push(wrappedPlayer);
                        }
                        return player;
                    }));
                    allQueriedPlayers.forEach(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) {
                        getOrSetAsInMap(_this.playersByQueriedElement, player.element, []).push(player);
                        player.onDone(( /**
                         * @return {?}
                         */function () { return deleteOrUnsetInMap(_this.playersByQueriedElement, player.element, player); }));
                    }));
                    allConsumedElements.forEach(( /**
                     * @param {?} element
                     * @return {?}
                     */function (/**
                     * @param {?} element
                     * @return {?}
                     */ element) { return addClass(element, NG_ANIMATING_CLASSNAME); }));
                    /** @type {?} */
                    var player = optimizeGroupPlayer(allNewPlayers);
                    player.onDestroy(( /**
                     * @return {?}
                     */function () {
                        allConsumedElements.forEach(( /**
                         * @param {?} element
                         * @return {?}
                         */function (/**
                         * @param {?} element
                         * @return {?}
                         */ element) { return removeClass(element, NG_ANIMATING_CLASSNAME); }));
                        setStyles(rootElement, instruction.toStyles);
                    }));
                    // this basically makes all of the callbacks for sub element animations
                    // be dependent on the upper players for when they finish
                    allSubElements.forEach(( /**
                     * @param {?} element
                     * @return {?}
                     */function (/**
                     * @param {?} element
                     * @return {?}
                     */ element) { getOrSetAsInMap(skippedPlayersMap, element, []).push(player); }));
                    return player;
                };
                /**
                 * @private
                 * @param {?} instruction
                 * @param {?} keyframes
                 * @param {?} previousPlayers
                 * @return {?}
                 */
                TransitionAnimationEngine.prototype._buildPlayer = function (instruction, keyframes, previousPlayers) {
                    if (keyframes.length > 0) {
                        return this.driver.animate(instruction.element, keyframes, instruction.duration, instruction.delay, instruction.easing, previousPlayers);
                    }
                    // special case for when an empty transition|definition is provided
                    // ... there is no point in rendering an empty animation
                    return new _angular_animations__WEBPACK_IMPORTED_MODULE_0__["NoopAnimationPlayer"](instruction.duration, instruction.delay);
                };
                return TransitionAnimationEngine;
            }());
            if (false) { }
            var TransitionAnimationPlayer = /** @class */ (function () {
                /**
                 * @param {?} namespaceId
                 * @param {?} triggerName
                 * @param {?} element
                 */
                function TransitionAnimationPlayer(namespaceId, triggerName, element) {
                    this.namespaceId = namespaceId;
                    this.triggerName = triggerName;
                    this.element = element;
                    this._player = new _angular_animations__WEBPACK_IMPORTED_MODULE_0__["NoopAnimationPlayer"]();
                    this._containsRealPlayer = false;
                    this._queuedCallbacks = {};
                    this.destroyed = false;
                    this.markedForDestroy = false;
                    this.disabled = false;
                    this.queued = true;
                    this.totalTime = 0;
                }
                /**
                 * @param {?} player
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.setRealPlayer = function (player) {
                    var _this = this;
                    if (this._containsRealPlayer)
                        return;
                    this._player = player;
                    Object.keys(this._queuedCallbacks).forEach(( /**
                     * @param {?} phase
                     * @return {?}
                     */function (/**
                     * @param {?} phase
                     * @return {?}
                     */ phase) {
                        _this._queuedCallbacks[phase].forEach(( /**
                         * @param {?} callback
                         * @return {?}
                         */function (/**
                         * @param {?} callback
                         * @return {?}
                         */ callback) { return listenOnPlayer(player, phase, undefined, callback); }));
                    }));
                    this._queuedCallbacks = {};
                    this._containsRealPlayer = true;
                    this.overrideTotalTime(player.totalTime);
                    (( /** @type {?} */(this))).queued = false;
                };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.getRealPlayer = function () { return this._player; };
                /**
                 * @param {?} totalTime
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.overrideTotalTime = function (totalTime) { (( /** @type {?} */(this))).totalTime = totalTime; };
                /**
                 * @param {?} player
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.syncPlayerEvents = function (player) {
                    var _this = this;
                    /** @type {?} */
                    var p = ( /** @type {?} */(this._player));
                    if (p.triggerCallback) {
                        player.onStart(( /**
                         * @return {?}
                         */function () { return ( /** @type {?} */(p.triggerCallback))('start'); }));
                    }
                    player.onDone(( /**
                     * @return {?}
                     */function () { return _this.finish(); }));
                    player.onDestroy(( /**
                     * @return {?}
                     */function () { return _this.destroy(); }));
                };
                /**
                 * @private
                 * @param {?} name
                 * @param {?} callback
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype._queueEvent = function (name, callback) {
                    getOrSetAsInMap(this._queuedCallbacks, name, []).push(callback);
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.onDone = function (fn) {
                    if (this.queued) {
                        this._queueEvent('done', fn);
                    }
                    this._player.onDone(fn);
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.onStart = function (fn) {
                    if (this.queued) {
                        this._queueEvent('start', fn);
                    }
                    this._player.onStart(fn);
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.onDestroy = function (fn) {
                    if (this.queued) {
                        this._queueEvent('destroy', fn);
                    }
                    this._player.onDestroy(fn);
                };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.init = function () { this._player.init(); };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.hasStarted = function () { return this.queued ? false : this._player.hasStarted(); };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.play = function () { !this.queued && this._player.play(); };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.pause = function () { !this.queued && this._player.pause(); };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.restart = function () { !this.queued && this._player.restart(); };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.finish = function () { this._player.finish(); };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.destroy = function () {
                    (( /** @type {?} */(this))).destroyed = true;
                    this._player.destroy();
                };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.reset = function () { !this.queued && this._player.reset(); };
                /**
                 * @param {?} p
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.setPosition = function (p) {
                    if (!this.queued) {
                        this._player.setPosition(p);
                    }
                };
                /**
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.getPosition = function () { return this.queued ? 0 : this._player.getPosition(); };
                /**
                 * \@internal
                 * @param {?} phaseName
                 * @return {?}
                 */
                TransitionAnimationPlayer.prototype.triggerCallback = function (phaseName) {
                    /** @type {?} */
                    var p = ( /** @type {?} */(this._player));
                    if (p.triggerCallback) {
                        p.triggerCallback(phaseName);
                    }
                };
                return TransitionAnimationPlayer;
            }());
            if (false) { }
            /**
             * @param {?} map
             * @param {?} key
             * @param {?} value
             * @return {?}
             */
            function deleteOrUnsetInMap(map, key, value) {
                /** @type {?} */
                var currentValues;
                if (map instanceof Map) {
                    currentValues = map.get(key);
                    if (currentValues) {
                        if (currentValues.length) {
                            /** @type {?} */
                            var index = currentValues.indexOf(value);
                            currentValues.splice(index, 1);
                        }
                        if (currentValues.length == 0) {
                            map.delete(key);
                        }
                    }
                }
                else {
                    currentValues = map[key];
                    if (currentValues) {
                        if (currentValues.length) {
                            /** @type {?} */
                            var index = currentValues.indexOf(value);
                            currentValues.splice(index, 1);
                        }
                        if (currentValues.length == 0) {
                            delete map[key];
                        }
                    }
                }
                return currentValues;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function normalizeTriggerValue(value) {
                // we use `!= null` here because it's the most simple
                // way to test against a "falsy" value without mixing
                // in empty strings or a zero value. DO NOT OPTIMIZE.
                return value != null ? value : null;
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function isElementNode(node) {
                return node && node['nodeType'] === 1;
            }
            /**
             * @param {?} eventName
             * @return {?}
             */
            function isTriggerEventValid(eventName) {
                return eventName == 'start' || eventName == 'done';
            }
            /**
             * @param {?} element
             * @param {?=} value
             * @return {?}
             */
            function cloakElement(element, value) {
                /** @type {?} */
                var oldValue = element.style.display;
                element.style.display = value != null ? value : 'none';
                return oldValue;
            }
            /**
             * @param {?} valuesMap
             * @param {?} driver
             * @param {?} elements
             * @param {?} elementPropsMap
             * @param {?} defaultStyle
             * @return {?}
             */
            function cloakAndComputeStyles(valuesMap, driver, elements, elementPropsMap, defaultStyle) {
                /** @type {?} */
                var cloakVals = [];
                elements.forEach(( /**
                 * @param {?} element
                 * @return {?}
                 */function (/**
                 * @param {?} element
                 * @return {?}
                 */ element) { return cloakVals.push(cloakElement(element)); }));
                /** @type {?} */
                var failedElements = [];
                elementPropsMap.forEach(( /**
                 * @param {?} props
                 * @param {?} element
                 * @return {?}
                 */function (props, element) {
                    /** @type {?} */
                    var styles = {};
                    props.forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var value = styles[prop] = driver.computeStyle(element, prop, defaultStyle);
                        // there is no easy way to detect this because a sub element could be removed
                        // by a parent animation element being detached.
                        if (!value || value.length == 0) {
                            element[REMOVAL_FLAG] = NULL_REMOVED_QUERIED_STATE;
                            failedElements.push(element);
                        }
                    }));
                    valuesMap.set(element, styles);
                }));
                // we use a index variable here since Set.forEach(a, i) does not return
                // an index value for the closure (but instead just the value)
                /** @type {?} */
                var i = 0;
                elements.forEach(( /**
                 * @param {?} element
                 * @return {?}
                 */function (/**
                 * @param {?} element
                 * @return {?}
                 */ element) { return cloakElement(element, cloakVals[i++]); }));
                return failedElements;
            }
            /*
            Since the Angular renderer code will return a collection of inserted
            nodes in all areas of a DOM tree, it's up to this algorithm to figure
            out which nodes are roots for each animation @trigger.
            
            By placing each inserted node into a Set and traversing upwards, it
            is possible to find the @trigger elements and well any direct *star
            insertion nodes, if a @trigger root is found then the enter element
            is placed into the Map[@trigger] spot.
             */
            /**
             * @param {?} roots
             * @param {?} nodes
             * @return {?}
             */
            function buildRootMap(roots, nodes) {
                /** @type {?} */
                var rootMap = new Map();
                roots.forEach(( /**
                 * @param {?} root
                 * @return {?}
                 */function (/**
                 * @param {?} root
                 * @return {?}
                 */ root) { return rootMap.set(root, []); }));
                if (nodes.length == 0)
                    return rootMap;
                /** @type {?} */
                var NULL_NODE = 1;
                /** @type {?} */
                var nodeSet = new Set(nodes);
                /** @type {?} */
                var localRootMap = new Map();
                /**
                 * @param {?} node
                 * @return {?}
                 */
                function getRoot(node) {
                    if (!node)
                        return NULL_NODE;
                    /** @type {?} */
                    var root = localRootMap.get(node);
                    if (root)
                        return root;
                    /** @type {?} */
                    var parent = node.parentNode;
                    if (rootMap.has(parent)) { // ngIf inside @trigger
                        root = parent;
                    }
                    else if (nodeSet.has(parent)) { // ngIf inside ngIf
                        root = NULL_NODE;
                    }
                    else { // recurse upwards
                        root = getRoot(parent);
                    }
                    localRootMap.set(node, root);
                    return root;
                }
                nodes.forEach(( /**
                 * @param {?} node
                 * @return {?}
                 */function (/**
                 * @param {?} node
                 * @return {?}
                 */ node) {
                    /** @type {?} */
                    var root = getRoot(node);
                    if (root !== NULL_NODE) {
                        ( /** @type {?} */(rootMap.get(root))).push(node);
                    }
                }));
                return rootMap;
            }
            /** @type {?} */
            var CLASSES_CACHE_KEY = '$$classes';
            /**
             * @param {?} element
             * @param {?} className
             * @return {?}
             */
            function containsClass(element, className) {
                if (element.classList) {
                    return element.classList.contains(className);
                }
                else {
                    /** @type {?} */
                    var classes = element[CLASSES_CACHE_KEY];
                    return classes && classes[className];
                }
            }
            /**
             * @param {?} element
             * @param {?} className
             * @return {?}
             */
            function addClass(element, className) {
                if (element.classList) {
                    element.classList.add(className);
                }
                else {
                    /** @type {?} */
                    var classes = element[CLASSES_CACHE_KEY];
                    if (!classes) {
                        classes = element[CLASSES_CACHE_KEY] = {};
                    }
                    classes[className] = true;
                }
            }
            /**
             * @param {?} element
             * @param {?} className
             * @return {?}
             */
            function removeClass(element, className) {
                if (element.classList) {
                    element.classList.remove(className);
                }
                else {
                    /** @type {?} */
                    var classes = element[CLASSES_CACHE_KEY];
                    if (classes) {
                        delete classes[className];
                    }
                }
            }
            /**
             * @param {?} engine
             * @param {?} element
             * @param {?} players
             * @return {?}
             */
            function removeNodesAfterAnimationDone(engine, element, players) {
                optimizeGroupPlayer(players).onDone(( /**
                 * @return {?}
                 */function () { return engine.processLeaveNode(element); }));
            }
            /**
             * @param {?} players
             * @return {?}
             */
            function flattenGroupPlayers(players) {
                /** @type {?} */
                var finalPlayers = [];
                _flattenGroupPlayersRecur(players, finalPlayers);
                return finalPlayers;
            }
            /**
             * @param {?} players
             * @param {?} finalPlayers
             * @return {?}
             */
            function _flattenGroupPlayersRecur(players, finalPlayers) {
                for (var i = 0; i < players.length; i++) {
                    /** @type {?} */
                    var player = players[i];
                    if (player instanceof _angular_animations__WEBPACK_IMPORTED_MODULE_0__["ɵAnimationGroupPlayer"]) {
                        _flattenGroupPlayersRecur(player.players, finalPlayers);
                    }
                    else {
                        finalPlayers.push(( /** @type {?} */(player)));
                    }
                }
            }
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function objEquals(a, b) {
                /** @type {?} */
                var k1 = Object.keys(a);
                /** @type {?} */
                var k2 = Object.keys(b);
                if (k1.length != k2.length)
                    return false;
                for (var i = 0; i < k1.length; i++) {
                    /** @type {?} */
                    var prop = k1[i];
                    if (!b.hasOwnProperty(prop) || a[prop] !== b[prop])
                        return false;
                }
                return true;
            }
            /**
             * @param {?} element
             * @param {?} allPreStyleElements
             * @param {?} allPostStyleElements
             * @return {?}
             */
            function replacePostStylesAsPre(element, allPreStyleElements, allPostStyleElements) {
                /** @type {?} */
                var postEntry = allPostStyleElements.get(element);
                if (!postEntry)
                    return false;
                /** @type {?} */
                var preEntry = allPreStyleElements.get(element);
                if (preEntry) {
                    postEntry.forEach(( /**
                     * @param {?} data
                     * @return {?}
                     */function (/**
                     * @param {?} data
                     * @return {?}
                     */ data) { return ( /** @type {?} */(preEntry)).add(data); }));
                }
                else {
                    allPreStyleElements.set(element, postEntry);
                }
                allPostStyleElements.delete(element);
                return true;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var AnimationEngine = /** @class */ (function () {
                /**
                 * @param {?} bodyNode
                 * @param {?} _driver
                 * @param {?} normalizer
                 */
                function AnimationEngine(bodyNode, _driver, normalizer) {
                    var _this = this;
                    this.bodyNode = bodyNode;
                    this._driver = _driver;
                    this._triggerCache = {};
                    // this method is designed to be overridden by the code that uses this engine
                    this.onRemovalComplete = ( /**
                     * @param {?} element
                     * @param {?} context
                     * @return {?}
                     */function (element, context) { });
                    this._transitionEngine = new TransitionAnimationEngine(bodyNode, _driver, normalizer);
                    this._timelineEngine = new TimelineAnimationEngine(bodyNode, _driver, normalizer);
                    this._transitionEngine.onRemovalComplete = ( /**
                     * @param {?} element
                     * @param {?} context
                     * @return {?}
                     */function (element, context) { return _this.onRemovalComplete(element, context); });
                }
                /**
                 * @param {?} componentId
                 * @param {?} namespaceId
                 * @param {?} hostElement
                 * @param {?} name
                 * @param {?} metadata
                 * @return {?}
                 */
                AnimationEngine.prototype.registerTrigger = function (componentId, namespaceId, hostElement, name, metadata) {
                    /** @type {?} */
                    var cacheKey = componentId + '-' + name;
                    /** @type {?} */
                    var trigger = this._triggerCache[cacheKey];
                    if (!trigger) {
                        /** @type {?} */
                        var errors = [];
                        /** @type {?} */
                        var ast = ( /** @type {?} */(buildAnimationAst(this._driver, ( /** @type {?} */(metadata)), errors)));
                        if (errors.length) {
                            throw new Error("The animation trigger \"" + name + "\" has failed to build due to the following errors:\n - " + errors.join("\n - "));
                        }
                        trigger = buildTrigger(name, ast);
                        this._triggerCache[cacheKey] = trigger;
                    }
                    this._transitionEngine.registerTrigger(namespaceId, name, trigger);
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} hostElement
                 * @return {?}
                 */
                AnimationEngine.prototype.register = function (namespaceId, hostElement) {
                    this._transitionEngine.register(namespaceId, hostElement);
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} context
                 * @return {?}
                 */
                AnimationEngine.prototype.destroy = function (namespaceId, context) {
                    this._transitionEngine.destroy(namespaceId, context);
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} parent
                 * @param {?} insertBefore
                 * @return {?}
                 */
                AnimationEngine.prototype.onInsert = function (namespaceId, element, parent, insertBefore) {
                    this._transitionEngine.insertNode(namespaceId, element, parent, insertBefore);
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} context
                 * @param {?=} isHostElement
                 * @return {?}
                 */
                AnimationEngine.prototype.onRemove = function (namespaceId, element, context, isHostElement) {
                    this._transitionEngine.removeNode(namespaceId, element, isHostElement || false, context);
                };
                /**
                 * @param {?} element
                 * @param {?} disable
                 * @return {?}
                 */
                AnimationEngine.prototype.disableAnimations = function (element, disable) {
                    this._transitionEngine.markElementAsDisabled(element, disable);
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} property
                 * @param {?} value
                 * @return {?}
                 */
                AnimationEngine.prototype.process = function (namespaceId, element, property, value) {
                    if (property.charAt(0) == '@') {
                        var _c = parseTimelineCommand(property), id = _c[0], action = _c[1];
                        /** @type {?} */
                        var args = ( /** @type {?} */(value));
                        this._timelineEngine.command(id, element, action, args);
                    }
                    else {
                        this._transitionEngine.trigger(namespaceId, element, property, value);
                    }
                };
                /**
                 * @param {?} namespaceId
                 * @param {?} element
                 * @param {?} eventName
                 * @param {?} eventPhase
                 * @param {?} callback
                 * @return {?}
                 */
                AnimationEngine.prototype.listen = function (namespaceId, element, eventName, eventPhase, callback) {
                    // @@listen
                    if (eventName.charAt(0) == '@') {
                        var _c = parseTimelineCommand(eventName), id = _c[0], action = _c[1];
                        return this._timelineEngine.listen(id, element, action, callback);
                    }
                    return this._transitionEngine.listen(namespaceId, element, eventName, eventPhase, callback);
                };
                /**
                 * @param {?=} microtaskId
                 * @return {?}
                 */
                AnimationEngine.prototype.flush = function (microtaskId) {
                    if (microtaskId === void 0) { microtaskId = -1; }
                    this._transitionEngine.flush(microtaskId);
                };
                Object.defineProperty(AnimationEngine.prototype, "players", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return (( /** @type {?} */(this._transitionEngine.players)))
                            .concat(( /** @type {?} */(this._timelineEngine.players)));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                AnimationEngine.prototype.whenRenderingDone = function () { return this._transitionEngine.whenRenderingDone(); };
                return AnimationEngine;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns an instance of `SpecialCasedStyles` if and when any special (non animateable) styles are
             * detected.
             *
             * In CSS there exist properties that cannot be animated within a keyframe animation
             * (whether it be via CSS keyframes or web-animations) and the animation implementation
             * will ignore them. This function is designed to detect those special cased styles and
             * return a container that will be executed at the start and end of the animation.
             *
             * @param {?} element
             * @param {?} styles
             * @return {?} an instance of `SpecialCasedStyles` if any special styles are detected otherwise `null`
             */
            function packageNonAnimatableStyles(element, styles) {
                /** @type {?} */
                var startStyles = null;
                /** @type {?} */
                var endStyles = null;
                if (Array.isArray(styles) && styles.length) {
                    startStyles = filterNonAnimatableStyles(styles[0]);
                    if (styles.length > 1) {
                        endStyles = filterNonAnimatableStyles(styles[styles.length - 1]);
                    }
                }
                else if (styles) {
                    startStyles = filterNonAnimatableStyles(styles);
                }
                return (startStyles || endStyles) ? new SpecialCasedStyles(element, startStyles, endStyles) :
                    null;
            }
            /**
             * Designed to be executed during a keyframe-based animation to apply any special-cased styles.
             *
             * When started (when the `start()` method is run) then the provided `startStyles`
             * will be applied. When finished (when the `finish()` method is called) the
             * `endStyles` will be applied as well any any starting styles. Finally when
             * `destroy()` is called then all styles will be removed.
             */
            var SpecialCasedStyles = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _startStyles
                 * @param {?} _endStyles
                 */
                function SpecialCasedStyles(_element, _startStyles, _endStyles) {
                    this._element = _element;
                    this._startStyles = _startStyles;
                    this._endStyles = _endStyles;
                    this._state = 0 /* Pending */;
                    /** @type {?} */
                    var initialStyles = SpecialCasedStyles.initialStylesByElement.get(_element);
                    if (!initialStyles) {
                        SpecialCasedStyles.initialStylesByElement.set(_element, initialStyles = {});
                    }
                    this._initialStyles = initialStyles;
                }
                /**
                 * @return {?}
                 */
                SpecialCasedStyles.prototype.start = function () {
                    if (this._state < 1 /* Started */) {
                        if (this._startStyles) {
                            setStyles(this._element, this._startStyles, this._initialStyles);
                        }
                        this._state = 1 /* Started */;
                    }
                };
                /**
                 * @return {?}
                 */
                SpecialCasedStyles.prototype.finish = function () {
                    this.start();
                    if (this._state < 2 /* Finished */) {
                        setStyles(this._element, this._initialStyles);
                        if (this._endStyles) {
                            setStyles(this._element, this._endStyles);
                            this._endStyles = null;
                        }
                        this._state = 1 /* Started */;
                    }
                };
                /**
                 * @return {?}
                 */
                SpecialCasedStyles.prototype.destroy = function () {
                    this.finish();
                    if (this._state < 3 /* Destroyed */) {
                        SpecialCasedStyles.initialStylesByElement.delete(this._element);
                        if (this._startStyles) {
                            eraseStyles(this._element, this._startStyles);
                            this._endStyles = null;
                        }
                        if (this._endStyles) {
                            eraseStyles(this._element, this._endStyles);
                            this._endStyles = null;
                        }
                        setStyles(this._element, this._initialStyles);
                        this._state = 3 /* Destroyed */;
                    }
                };
                return SpecialCasedStyles;
            }());
            SpecialCasedStyles.initialStylesByElement = new WeakMap();
            if (false) { }
            /** @enum {number} */
            var SpecialCasedStylesState = {
                Pending: 0,
                Started: 1,
                Finished: 2,
                Destroyed: 3,
            };
            /**
             * @param {?} styles
             * @return {?}
             */
            function filterNonAnimatableStyles(styles) {
                /** @type {?} */
                var result = null;
                /** @type {?} */
                var props = Object.keys(styles);
                for (var i = 0; i < props.length; i++) {
                    /** @type {?} */
                    var prop = props[i];
                    if (isNonAnimatableStyle(prop)) {
                        result = result || {};
                        result[prop] = styles[prop];
                    }
                }
                return result;
            }
            /**
             * @param {?} prop
             * @return {?}
             */
            function isNonAnimatableStyle(prop) {
                return prop === 'display' || prop === 'position';
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             * @type {?}
             */
            var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
            /** @type {?} */
            var ANIMATION_PROP = 'animation';
            /** @type {?} */
            var ANIMATIONEND_EVENT = 'animationend';
            /** @type {?} */
            var ONE_SECOND$1 = 1000;
            var ElementAnimationStyleHandler = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _name
                 * @param {?} _duration
                 * @param {?} _delay
                 * @param {?} _easing
                 * @param {?} _fillMode
                 * @param {?} _onDoneFn
                 */
                function ElementAnimationStyleHandler(_element, _name, _duration, _delay, _easing, _fillMode, _onDoneFn) {
                    var _this = this;
                    this._element = _element;
                    this._name = _name;
                    this._duration = _duration;
                    this._delay = _delay;
                    this._easing = _easing;
                    this._fillMode = _fillMode;
                    this._onDoneFn = _onDoneFn;
                    this._finished = false;
                    this._destroyed = false;
                    this._startTime = 0;
                    this._position = 0;
                    this._eventFn = ( /**
                     * @param {?} e
                     * @return {?}
                     */function (e) { return _this._handleCallback(e); });
                }
                /**
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.apply = function () {
                    applyKeyframeAnimation(this._element, this._duration + "ms " + this._easing + " " + this._delay + "ms 1 normal " + this._fillMode + " " + this._name);
                    addRemoveAnimationEvent(this._element, this._eventFn, false);
                    this._startTime = Date.now();
                };
                /**
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.pause = function () { playPauseAnimation(this._element, this._name, 'paused'); };
                /**
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.resume = function () { playPauseAnimation(this._element, this._name, 'running'); };
                /**
                 * @param {?} position
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.setPosition = function (position) {
                    /** @type {?} */
                    var index = findIndexForAnimation(this._element, this._name);
                    this._position = position * this._duration;
                    setAnimationStyle(this._element, 'Delay', "-" + this._position + "ms", index);
                };
                /**
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.getPosition = function () { return this._position; };
                /**
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype._handleCallback = function (event) {
                    /** @type {?} */
                    var timestamp = event._ngTestManualTimestamp || Date.now();
                    /** @type {?} */
                    var elapsedTime = parseFloat(event.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES)) * ONE_SECOND$1;
                    if (event.animationName == this._name &&
                        Math.max(timestamp - this._startTime, 0) >= this._delay && elapsedTime >= this._duration) {
                        this.finish();
                    }
                };
                /**
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.finish = function () {
                    if (this._finished)
                        return;
                    this._finished = true;
                    this._onDoneFn();
                    addRemoveAnimationEvent(this._element, this._eventFn, true);
                };
                /**
                 * @return {?}
                 */
                ElementAnimationStyleHandler.prototype.destroy = function () {
                    if (this._destroyed)
                        return;
                    this._destroyed = true;
                    this.finish();
                    removeKeyframeAnimation(this._element, this._name);
                };
                return ElementAnimationStyleHandler;
            }());
            if (false) { }
            /**
             * @param {?} element
             * @param {?} name
             * @param {?} status
             * @return {?}
             */
            function playPauseAnimation(element, name, status) {
                /** @type {?} */
                var index = findIndexForAnimation(element, name);
                setAnimationStyle(element, 'PlayState', status, index);
            }
            /**
             * @param {?} element
             * @param {?} value
             * @return {?}
             */
            function applyKeyframeAnimation(element, value) {
                /** @type {?} */
                var anim = getAnimationStyle(element, '').trim();
                /** @type {?} */
                var index = 0;
                if (anim.length) {
                    index = countChars(anim, ',') + 1;
                    value = anim + ", " + value;
                }
                setAnimationStyle(element, '', value);
                return index;
            }
            /**
             * @param {?} element
             * @param {?} name
             * @return {?}
             */
            function removeKeyframeAnimation(element, name) {
                /** @type {?} */
                var anim = getAnimationStyle(element, '');
                /** @type {?} */
                var tokens = anim.split(',');
                /** @type {?} */
                var index = findMatchingTokenIndex(tokens, name);
                if (index >= 0) {
                    tokens.splice(index, 1);
                    /** @type {?} */
                    var newValue = tokens.join(',');
                    setAnimationStyle(element, '', newValue);
                }
            }
            /**
             * @param {?} element
             * @param {?} value
             * @return {?}
             */
            function findIndexForAnimation(element, value) {
                /** @type {?} */
                var anim = getAnimationStyle(element, '');
                if (anim.indexOf(',') > 0) {
                    /** @type {?} */
                    var tokens = anim.split(',');
                    return findMatchingTokenIndex(tokens, value);
                }
                return findMatchingTokenIndex([anim], value);
            }
            /**
             * @param {?} tokens
             * @param {?} searchToken
             * @return {?}
             */
            function findMatchingTokenIndex(tokens, searchToken) {
                for (var i = 0; i < tokens.length; i++) {
                    if (tokens[i].indexOf(searchToken) >= 0) {
                        return i;
                    }
                }
                return -1;
            }
            /**
             * @param {?} element
             * @param {?} fn
             * @param {?} doRemove
             * @return {?}
             */
            function addRemoveAnimationEvent(element, fn, doRemove) {
                doRemove ? element.removeEventListener(ANIMATIONEND_EVENT, fn) :
                    element.addEventListener(ANIMATIONEND_EVENT, fn);
            }
            /**
             * @param {?} element
             * @param {?} name
             * @param {?} value
             * @param {?=} index
             * @return {?}
             */
            function setAnimationStyle(element, name, value, index) {
                /** @type {?} */
                var prop = ANIMATION_PROP + name;
                if (index != null) {
                    /** @type {?} */
                    var oldValue = element.style[prop];
                    if (oldValue.length) {
                        /** @type {?} */
                        var tokens = oldValue.split(',');
                        tokens[index] = value;
                        value = tokens.join(',');
                    }
                }
                element.style[prop] = value;
            }
            /**
             * @param {?} element
             * @param {?} name
             * @return {?}
             */
            function getAnimationStyle(element, name) {
                return element.style[ANIMATION_PROP + name];
            }
            /**
             * @param {?} value
             * @param {?} char
             * @return {?}
             */
            function countChars(value, char) {
                /** @type {?} */
                var count = 0;
                for (var i = 0; i < value.length; i++) {
                    /** @type {?} */
                    var c = value.charAt(i);
                    if (c === char)
                        count++;
                }
                return count;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var DEFAULT_FILL_MODE = 'forwards';
            /** @type {?} */
            var DEFAULT_EASING = 'linear';
            /** @enum {number} */
            var AnimatorControlState = {
                INITIALIZED: 1, STARTED: 2, FINISHED: 3, DESTROYED: 4,
            };
            var CssKeyframesPlayer = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} animationName
                 * @param {?} _duration
                 * @param {?} _delay
                 * @param {?} easing
                 * @param {?} _finalStyles
                 * @param {?=} _specialStyles
                 */
                function CssKeyframesPlayer(element, keyframes, animationName, _duration, _delay, easing, _finalStyles, _specialStyles) {
                    this.element = element;
                    this.keyframes = keyframes;
                    this.animationName = animationName;
                    this._duration = _duration;
                    this._delay = _delay;
                    this._finalStyles = _finalStyles;
                    this._specialStyles = _specialStyles;
                    this._onDoneFns = [];
                    this._onStartFns = [];
                    this._onDestroyFns = [];
                    this._started = false;
                    this.currentSnapshot = {};
                    this._state = 0;
                    this.easing = easing || DEFAULT_EASING;
                    this.totalTime = _duration + _delay;
                    this._buildStyler();
                }
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.destroy = function () {
                    this.init();
                    if (this._state >= 4 /* DESTROYED */)
                        return;
                    this._state = 4 /* DESTROYED */;
                    this._styler.destroy();
                    this._flushStartFns();
                    this._flushDoneFns();
                    if (this._specialStyles) {
                        this._specialStyles.destroy();
                    }
                    this._onDestroyFns.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    this._onDestroyFns = [];
                };
                /**
                 * @private
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype._flushDoneFns = function () {
                    this._onDoneFns.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    this._onDoneFns = [];
                };
                /**
                 * @private
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype._flushStartFns = function () {
                    this._onStartFns.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    this._onStartFns = [];
                };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.finish = function () {
                    this.init();
                    if (this._state >= 3 /* FINISHED */)
                        return;
                    this._state = 3 /* FINISHED */;
                    this._styler.finish();
                    this._flushStartFns();
                    if (this._specialStyles) {
                        this._specialStyles.finish();
                    }
                    this._flushDoneFns();
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.setPosition = function (value) { this._styler.setPosition(value); };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.getPosition = function () { return this._styler.getPosition(); };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.hasStarted = function () { return this._state >= 2 /* STARTED */; };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.init = function () {
                    if (this._state >= 1 /* INITIALIZED */)
                        return;
                    this._state = 1 /* INITIALIZED */;
                    /** @type {?} */
                    var elm = this.element;
                    this._styler.apply();
                    if (this._delay) {
                        this._styler.pause();
                    }
                };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.play = function () {
                    this.init();
                    if (!this.hasStarted()) {
                        this._flushStartFns();
                        this._state = 2 /* STARTED */;
                        if (this._specialStyles) {
                            this._specialStyles.start();
                        }
                    }
                    this._styler.resume();
                };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.pause = function () {
                    this.init();
                    this._styler.pause();
                };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.restart = function () {
                    this.reset();
                    this.play();
                };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.reset = function () {
                    this._styler.destroy();
                    this._buildStyler();
                    this._styler.apply();
                };
                /**
                 * @private
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype._buildStyler = function () {
                    var _this = this;
                    this._styler = new ElementAnimationStyleHandler(this.element, this.animationName, this._duration, this._delay, this.easing, DEFAULT_FILL_MODE, ( /**
                     * @return {?}
                     */function () { return _this.finish(); }));
                };
                /**
                 * \@internal
                 * @param {?} phaseName
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.triggerCallback = function (phaseName) {
                    /** @type {?} */
                    var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
                    methods.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    methods.length = 0;
                };
                /**
                 * @return {?}
                 */
                CssKeyframesPlayer.prototype.beforeDestroy = function () {
                    var _this = this;
                    this.init();
                    /** @type {?} */
                    var styles = {};
                    if (this.hasStarted()) {
                        /** @type {?} */
                        var finished_1 = this._state >= 3 /* FINISHED */;
                        Object.keys(this._finalStyles).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            if (prop != 'offset') {
                                styles[prop] = finished_1 ? _this._finalStyles[prop] : computeStyle(_this.element, prop);
                            }
                        }));
                    }
                    this.currentSnapshot = styles;
                };
                return CssKeyframesPlayer;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var DirectStylePlayer = /** @class */ (function (_super_1) {
                __extends(DirectStylePlayer, _super_1);
                /**
                 * @param {?} element
                 * @param {?} styles
                 */
                function DirectStylePlayer(element, styles) {
                    var _this = _super_1.call(this) || this;
                    _this.element = element;
                    _this._startingStyles = {};
                    _this.__initialized = false;
                    _this._styles = hypenatePropsObject(styles);
                    return _this;
                }
                /**
                 * @return {?}
                 */
                DirectStylePlayer.prototype.init = function () {
                    var _this = this;
                    if (this.__initialized || !this._startingStyles)
                        return;
                    this.__initialized = true;
                    Object.keys(this._styles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        ( /** @type {?} */(_this._startingStyles))[prop] = _this.element.style[prop];
                    }));
                    _super_1.prototype.init.call(this);
                };
                /**
                 * @return {?}
                 */
                DirectStylePlayer.prototype.play = function () {
                    var _this = this;
                    if (!this._startingStyles)
                        return;
                    this.init();
                    Object.keys(this._styles)
                        .forEach(( /**
                 * @param {?} prop
                 * @return {?}
                 */function (/**
                 * @param {?} prop
                 * @return {?}
                 */ prop) { return _this.element.style.setProperty(prop, _this._styles[prop]); }));
                    _super_1.prototype.play.call(this);
                };
                /**
                 * @return {?}
                 */
                DirectStylePlayer.prototype.destroy = function () {
                    var _this = this;
                    if (!this._startingStyles)
                        return;
                    Object.keys(this._startingStyles).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (/**
                     * @param {?} prop
                     * @return {?}
                     */ prop) {
                        /** @type {?} */
                        var value = ( /** @type {?} */(_this._startingStyles))[prop];
                        if (value) {
                            _this.element.style.setProperty(prop, value);
                        }
                        else {
                            _this.element.style.removeProperty(prop);
                        }
                    }));
                    this._startingStyles = null;
                    _super_1.prototype.destroy.call(this);
                };
                return DirectStylePlayer;
            }(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["NoopAnimationPlayer"]));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var KEYFRAMES_NAME_PREFIX = 'gen_css_kf_';
            /** @type {?} */
            var TAB_SPACE = ' ';
            var CssKeyframesDriver = /** @class */ (function () {
                function CssKeyframesDriver() {
                    this._count = 0;
                    this._head = document.querySelector('head');
                    this._warningIssued = false;
                }
                /**
                 * @param {?} prop
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
                /**
                 * @param {?} element
                 * @param {?} selector
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.matchesElement = function (element, selector) {
                    return matchesElement(element, selector);
                };
                /**
                 * @param {?} elm1
                 * @param {?} elm2
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
                /**
                 * @param {?} element
                 * @param {?} selector
                 * @param {?} multi
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.query = function (element, selector, multi) {
                    return invokeQuery(element, selector, multi);
                };
                /**
                 * @param {?} element
                 * @param {?} prop
                 * @param {?=} defaultValue
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.computeStyle = function (element, prop, defaultValue) {
                    return ( /** @type {?} */((( /** @type {?} */(window.getComputedStyle(element))))[prop]));
                };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @param {?} keyframes
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.buildKeyframeElement = function (element, name, keyframes) {
                    keyframes = keyframes.map(( /**
                     * @param {?} kf
                     * @return {?}
                     */function (/**
                     * @param {?} kf
                     * @return {?}
                     */ kf) { return hypenatePropsObject(kf); }));
                    /** @type {?} */
                    var keyframeStr = "@keyframes " + name + " {\n";
                    /** @type {?} */
                    var tab = '';
                    keyframes.forEach(( /**
                     * @param {?} kf
                     * @return {?}
                     */function (/**
                     * @param {?} kf
                     * @return {?}
                     */ kf) {
                        tab = TAB_SPACE;
                        /** @type {?} */
                        var offset = parseFloat(kf['offset']);
                        keyframeStr += "" + tab + offset * 100 + "% {\n";
                        tab += TAB_SPACE;
                        Object.keys(kf).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            /** @type {?} */
                            var value = kf[prop];
                            switch (prop) {
                                case 'offset':
                                    return;
                                case 'easing':
                                    if (value) {
                                        keyframeStr += tab + "animation-timing-function: " + value + ";\n";
                                    }
                                    return;
                                default:
                                    keyframeStr += "" + tab + prop + ": " + value + ";\n";
                                    return;
                            }
                        }));
                        keyframeStr += tab + "}\n";
                    }));
                    keyframeStr += "}\n";
                    /** @type {?} */
                    var kfElm = document.createElement('style');
                    kfElm.innerHTML = keyframeStr;
                    return kfElm;
                };
                /**
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} duration
                 * @param {?} delay
                 * @param {?} easing
                 * @param {?=} previousPlayers
                 * @param {?=} scrubberAccessRequested
                 * @return {?}
                 */
                CssKeyframesDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
                    if (previousPlayers === void 0) { previousPlayers = []; }
                    if (scrubberAccessRequested) {
                        this._notifyFaultyScrubber();
                    }
                    /** @type {?} */
                    var previousCssKeyframePlayers = ( /** @type {?} */(previousPlayers.filter(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player instanceof CssKeyframesPlayer; }))));
                    /** @type {?} */
                    var previousStyles = {};
                    if (allowPreviousPlayerStylesMerge(duration, delay)) {
                        previousCssKeyframePlayers.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) {
                            /** @type {?} */
                            var styles = player.currentSnapshot;
                            Object.keys(styles).forEach(( /**
                             * @param {?} prop
                             * @return {?}
                             */function (/**
                             * @param {?} prop
                             * @return {?}
                             */ prop) { return previousStyles[prop] = styles[prop]; }));
                        }));
                    }
                    keyframes = balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles);
                    /** @type {?} */
                    var finalStyles = flattenKeyframesIntoStyles(keyframes);
                    // if there is no animation then there is no point in applying
                    // styles and waiting for an event to get fired. This causes lag.
                    // It's better to just directly apply the styles to the element
                    // via the direct styling animation player.
                    if (duration == 0) {
                        return new DirectStylePlayer(element, finalStyles);
                    }
                    /** @type {?} */
                    var animationName = "" + KEYFRAMES_NAME_PREFIX + this._count++;
                    /** @type {?} */
                    var kfElm = this.buildKeyframeElement(element, animationName, keyframes);
                    ( /** @type {?} */(document.querySelector('head'))).appendChild(kfElm);
                    /** @type {?} */
                    var specialStyles = packageNonAnimatableStyles(element, keyframes);
                    /** @type {?} */
                    var player = new CssKeyframesPlayer(element, keyframes, animationName, duration, delay, easing, finalStyles, specialStyles);
                    player.onDestroy(( /**
                     * @return {?}
                     */function () { return removeElement(kfElm); }));
                    return player;
                };
                /**
                 * @private
                 * @return {?}
                 */
                CssKeyframesDriver.prototype._notifyFaultyScrubber = function () {
                    if (!this._warningIssued) {
                        console.warn('@angular/animations: please load the web-animations.js polyfill to allow programmatic access...\n', '  visit http://bit.ly/IWukam to learn more about using the web-animation-js polyfill.');
                        this._warningIssued = true;
                    }
                };
                return CssKeyframesDriver;
            }());
            if (false) { }
            /**
             * @param {?} keyframes
             * @return {?}
             */
            function flattenKeyframesIntoStyles(keyframes) {
                /** @type {?} */
                var flatKeyframes = {};
                if (keyframes) {
                    /** @type {?} */
                    var kfs = Array.isArray(keyframes) ? keyframes : [keyframes];
                    kfs.forEach(( /**
                     * @param {?} kf
                     * @return {?}
                     */function (/**
                     * @param {?} kf
                     * @return {?}
                     */ kf) {
                        Object.keys(kf).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            if (prop == 'offset' || prop == 'easing')
                                return;
                            flatKeyframes[prop] = kf[prop];
                        }));
                    }));
                }
                return flatKeyframes;
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function removeElement(node) {
                node.parentNode.removeChild(node);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var WebAnimationsPlayer = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} options
                 * @param {?=} _specialStyles
                 */
                function WebAnimationsPlayer(element, keyframes, options, _specialStyles) {
                    this.element = element;
                    this.keyframes = keyframes;
                    this.options = options;
                    this._specialStyles = _specialStyles;
                    this._onDoneFns = [];
                    this._onStartFns = [];
                    this._onDestroyFns = [];
                    this._initialized = false;
                    this._finished = false;
                    this._started = false;
                    this._destroyed = false;
                    this.time = 0;
                    this.parentPlayer = null;
                    this.currentSnapshot = {};
                    this._duration = ( /** @type {?} */(options['duration']));
                    this._delay = ( /** @type {?} */(options['delay'])) || 0;
                    this.time = this._duration + this._delay;
                }
                /**
                 * @private
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype._onFinish = function () {
                    if (!this._finished) {
                        this._finished = true;
                        this._onDoneFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onDoneFns = [];
                    }
                };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.init = function () {
                    this._buildPlayer();
                    this._preparePlayerBeforeStart();
                };
                /**
                 * @private
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype._buildPlayer = function () {
                    var _this = this;
                    if (this._initialized)
                        return;
                    this._initialized = true;
                    /** @type {?} */
                    var keyframes = this.keyframes;
                    (( /** @type {?} */(this))).domPlayer =
                        this._triggerWebAnimation(this.element, keyframes, this.options);
                    this._finalKeyframe = keyframes.length ? keyframes[keyframes.length - 1] : {};
                    this.domPlayer.addEventListener('finish', ( /**
                     * @return {?}
                     */function () { return _this._onFinish(); }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype._preparePlayerBeforeStart = function () {
                    // this is required so that the player doesn't start to animate right away
                    if (this._delay) {
                        this._resetDomPlayerState();
                    }
                    else {
                        this.domPlayer.pause();
                    }
                };
                /**
                 * \@internal
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} options
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype._triggerWebAnimation = function (element, keyframes, options) {
                    // jscompiler doesn't seem to know animate is a native property because it's not fully
                    // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
                    return ( /** @type {?} */(element['animate'](keyframes, options)));
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.play = function () {
                    this._buildPlayer();
                    if (!this.hasStarted()) {
                        this._onStartFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onStartFns = [];
                        this._started = true;
                        if (this._specialStyles) {
                            this._specialStyles.start();
                        }
                    }
                    this.domPlayer.play();
                };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.pause = function () {
                    this.init();
                    this.domPlayer.pause();
                };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.finish = function () {
                    this.init();
                    if (this._specialStyles) {
                        this._specialStyles.finish();
                    }
                    this._onFinish();
                    this.domPlayer.finish();
                };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.reset = function () {
                    this._resetDomPlayerState();
                    this._destroyed = false;
                    this._finished = false;
                    this._started = false;
                };
                /**
                 * @private
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype._resetDomPlayerState = function () {
                    if (this.domPlayer) {
                        this.domPlayer.cancel();
                    }
                };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.restart = function () {
                    this.reset();
                    this.play();
                };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.destroy = function () {
                    if (!this._destroyed) {
                        this._destroyed = true;
                        this._resetDomPlayerState();
                        this._onFinish();
                        if (this._specialStyles) {
                            this._specialStyles.destroy();
                        }
                        this._onDestroyFns.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this._onDestroyFns = [];
                    }
                };
                /**
                 * @param {?} p
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.setPosition = function (p) { this.domPlayer.currentTime = p * this.time; };
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.getPosition = function () { return this.domPlayer.currentTime / this.time; };
                Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._delay + this._duration; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.beforeDestroy = function () {
                    var _this = this;
                    /** @type {?} */
                    var styles = {};
                    if (this.hasStarted()) {
                        Object.keys(this._finalKeyframe).forEach(( /**
                         * @param {?} prop
                         * @return {?}
                         */function (/**
                         * @param {?} prop
                         * @return {?}
                         */ prop) {
                            if (prop != 'offset') {
                                styles[prop] =
                                    _this._finished ? _this._finalKeyframe[prop] : computeStyle(_this.element, prop);
                            }
                        }));
                    }
                    this.currentSnapshot = styles;
                };
                /**
                 * \@internal
                 * @param {?} phaseName
                 * @return {?}
                 */
                WebAnimationsPlayer.prototype.triggerCallback = function (phaseName) {
                    /** @type {?} */
                    var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
                    methods.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    methods.length = 0;
                };
                return WebAnimationsPlayer;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var WebAnimationsDriver = /** @class */ (function () {
                function WebAnimationsDriver() {
                    this._isNativeImpl = /\{\s*\[native\s+code\]\s*\}/.test(getElementAnimateFn().toString());
                    this._cssKeyframesDriver = new CssKeyframesDriver();
                }
                /**
                 * @param {?} prop
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
                /**
                 * @param {?} element
                 * @param {?} selector
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.matchesElement = function (element, selector) {
                    return matchesElement(element, selector);
                };
                /**
                 * @param {?} elm1
                 * @param {?} elm2
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
                /**
                 * @param {?} element
                 * @param {?} selector
                 * @param {?} multi
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.query = function (element, selector, multi) {
                    return invokeQuery(element, selector, multi);
                };
                /**
                 * @param {?} element
                 * @param {?} prop
                 * @param {?=} defaultValue
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.computeStyle = function (element, prop, defaultValue) {
                    return ( /** @type {?} */((( /** @type {?} */(window.getComputedStyle(element))))[prop]));
                };
                /**
                 * @param {?} supported
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.overrideWebAnimationsSupport = function (supported) { this._isNativeImpl = supported; };
                /**
                 * @param {?} element
                 * @param {?} keyframes
                 * @param {?} duration
                 * @param {?} delay
                 * @param {?} easing
                 * @param {?=} previousPlayers
                 * @param {?=} scrubberAccessRequested
                 * @return {?}
                 */
                WebAnimationsDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
                    if (previousPlayers === void 0) { previousPlayers = []; }
                    /** @type {?} */
                    var useKeyframes = !scrubberAccessRequested && !this._isNativeImpl;
                    if (useKeyframes) {
                        return this._cssKeyframesDriver.animate(element, keyframes, duration, delay, easing, previousPlayers);
                    }
                    /** @type {?} */
                    var fill = delay == 0 ? 'both' : 'forwards';
                    /** @type {?} */
                    var playerOptions = { duration: duration, delay: delay, fill: fill };
                    // we check for this to avoid having a null|undefined value be present
                    // for the easing (which results in an error for certain browsers #9752)
                    if (easing) {
                        playerOptions['easing'] = easing;
                    }
                    /** @type {?} */
                    var previousStyles = {};
                    /** @type {?} */
                    var previousWebAnimationPlayers = ( /** @type {?} */(previousPlayers.filter(( /**
                     * @param {?} player
                     * @return {?}
                     */function (/**
                     * @param {?} player
                     * @return {?}
                     */ player) { return player instanceof WebAnimationsPlayer; }))));
                    if (allowPreviousPlayerStylesMerge(duration, delay)) {
                        previousWebAnimationPlayers.forEach(( /**
                         * @param {?} player
                         * @return {?}
                         */function (/**
                         * @param {?} player
                         * @return {?}
                         */ player) {
                            /** @type {?} */
                            var styles = player.currentSnapshot;
                            Object.keys(styles).forEach(( /**
                             * @param {?} prop
                             * @return {?}
                             */function (/**
                             * @param {?} prop
                             * @return {?}
                             */ prop) { return previousStyles[prop] = styles[prop]; }));
                        }));
                    }
                    keyframes = keyframes.map(( /**
                     * @param {?} styles
                     * @return {?}
                     */function (/**
                     * @param {?} styles
                     * @return {?}
                     */ styles) { return copyStyles(styles, false); }));
                    keyframes = balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles);
                    /** @type {?} */
                    var specialStyles = packageNonAnimatableStyles(element, keyframes);
                    return new WebAnimationsPlayer(element, keyframes, playerOptions, specialStyles);
                };
                return WebAnimationsDriver;
            }());
            if (false) { }
            /**
             * @return {?}
             */
            function supportsWebAnimations() {
                return typeof getElementAnimateFn() === 'function';
            }
            /**
             * @return {?}
             */
            function getElementAnimateFn() {
                return (isBrowser() && (( /** @type {?} */(Element))).prototype['animate']) || {};
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=browser.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/a11y.js": 
        /*!***************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/a11y.js ***!
          \***************************************************/
        /*! exports provided: ARIA_DESCRIBER_PROVIDER_FACTORY, MESSAGES_CONTAINER_ID, CDK_DESCRIBEDBY_ID_PREFIX, CDK_DESCRIBEDBY_HOST_ATTRIBUTE, AriaDescriber, ARIA_DESCRIBER_PROVIDER, ActiveDescendantKeyManager, FocusKeyManager, ListKeyManager, FocusTrap, FocusTrapFactory, CdkTrapFocus, InteractivityChecker, LIVE_ANNOUNCER_PROVIDER_FACTORY, LiveAnnouncer, CdkAriaLive, LIVE_ANNOUNCER_PROVIDER, LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY, LIVE_ANNOUNCER_ELEMENT_TOKEN, LIVE_ANNOUNCER_DEFAULT_OPTIONS, FOCUS_MONITOR_PROVIDER_FACTORY, TOUCH_BUFFER_MS, FocusMonitor, CdkMonitorFocus, FOCUS_MONITOR_PROVIDER, isFakeMousedownFromScreenReader, A11yModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARIA_DESCRIBER_PROVIDER_FACTORY", function () { return ARIA_DESCRIBER_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MESSAGES_CONTAINER_ID", function () { return MESSAGES_CONTAINER_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DESCRIBEDBY_ID_PREFIX", function () { return CDK_DESCRIBEDBY_ID_PREFIX; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DESCRIBEDBY_HOST_ATTRIBUTE", function () { return CDK_DESCRIBEDBY_HOST_ATTRIBUTE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AriaDescriber", function () { return AriaDescriber; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARIA_DESCRIBER_PROVIDER", function () { return ARIA_DESCRIBER_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActiveDescendantKeyManager", function () { return ActiveDescendantKeyManager; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusKeyManager", function () { return FocusKeyManager; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListKeyManager", function () { return ListKeyManager; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusTrap", function () { return FocusTrap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusTrapFactory", function () { return FocusTrapFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTrapFocus", function () { return CdkTrapFocus; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractivityChecker", function () { return InteractivityChecker; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_PROVIDER_FACTORY", function () { return LIVE_ANNOUNCER_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiveAnnouncer", function () { return LiveAnnouncer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkAriaLive", function () { return CdkAriaLive; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_PROVIDER", function () { return LIVE_ANNOUNCER_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY", function () { return LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_ELEMENT_TOKEN", function () { return LIVE_ANNOUNCER_ELEMENT_TOKEN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_DEFAULT_OPTIONS", function () { return LIVE_ANNOUNCER_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_MONITOR_PROVIDER_FACTORY", function () { return FOCUS_MONITOR_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH_BUFFER_MS", function () { return TOUCH_BUFFER_MS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusMonitor", function () { return FocusMonitor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkMonitorFocus", function () { return CdkMonitorFocus; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_MONITOR_PROVIDER", function () { return FOCUS_MONITOR_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFakeMousedownFromScreenReader", function () { return isFakeMousedownFromScreenReader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A11yModule", function () { return A11yModule; });
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/observers */ "./node_modules/@angular/cdk/esm2015/observers.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * IDs are deliminated by an empty space, as per the spec.
             * @type {?}
             */
            var ID_DELIMINATOR = ' ';
            /**
             * Adds the given ID to the specified ARIA attribute on an element.
             * Used for attributes such as aria-labelledby, aria-owns, etc.
             * @param {?} el
             * @param {?} attr
             * @param {?} id
             * @return {?}
             */
            function addAriaReferencedId(el, attr, id) {
                /** @type {?} */
                var ids = getAriaReferenceIds(el, attr);
                if (ids.some(( /**
                 * @param {?} existingId
                 * @return {?}
                 */function (/**
                 * @param {?} existingId
                 * @return {?}
                 */ existingId) { return existingId.trim() == id.trim(); }))) {
                    return;
                }
                ids.push(id.trim());
                el.setAttribute(attr, ids.join(ID_DELIMINATOR));
            }
            /**
             * Removes the given ID from the specified ARIA attribute on an element.
             * Used for attributes such as aria-labelledby, aria-owns, etc.
             * @param {?} el
             * @param {?} attr
             * @param {?} id
             * @return {?}
             */
            function removeAriaReferencedId(el, attr, id) {
                /** @type {?} */
                var ids = getAriaReferenceIds(el, attr);
                /** @type {?} */
                var filteredIds = ids.filter(( /**
                 * @param {?} val
                 * @return {?}
                 */function (/**
                 * @param {?} val
                 * @return {?}
                 */ val) { return val != id.trim(); }));
                if (filteredIds.length) {
                    el.setAttribute(attr, filteredIds.join(ID_DELIMINATOR));
                }
                else {
                    el.removeAttribute(attr);
                }
            }
            /**
             * Gets the list of IDs referenced by the given ARIA attribute on an element.
             * Used for attributes such as aria-labelledby, aria-owns, etc.
             * @param {?} el
             * @param {?} attr
             * @return {?}
             */
            function getAriaReferenceIds(el, attr) {
                // Get string array of all individual ids (whitespace deliminated) in the attribute value
                return (el.getAttribute(attr) || '').match(/\S+/g) || [];
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * ID used for the body container where all messages are appended.
             * @type {?}
             */
            var MESSAGES_CONTAINER_ID = 'cdk-describedby-message-container';
            /**
             * ID prefix used for each created message element.
             * @type {?}
             */
            var CDK_DESCRIBEDBY_ID_PREFIX = 'cdk-describedby-message';
            /**
             * Attribute given to each host element that is described by a message element.
             * @type {?}
             */
            var CDK_DESCRIBEDBY_HOST_ATTRIBUTE = 'cdk-describedby-host';
            /**
             * Global incremental identifier for each registered message element.
             * @type {?}
             */
            var nextId = 0;
            /**
             * Global map of all registered message elements that have been placed into the document.
             * @type {?}
             */
            var messageRegistry = new Map();
            /**
             * Container for all registered messages.
             * @type {?}
             */
            var messagesContainer = null;
            /**
             * Utility that creates visually hidden elements with a message content. Useful for elements that
             * want to use aria-describedby to further describe themselves without adding additional visual
             * content.
             */
            var AriaDescriber = /** @class */ (function () {
                /**
                 * @param {?} _document
                 */
                function AriaDescriber(_document) {
                    this._document = _document;
                }
                /**
                 * Adds to the host element an aria-describedby reference to a hidden element that contains
                 * the message. If the same message has already been registered, then it will reuse the created
                 * message element.
                 * @param {?} hostElement
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype.describe = function (hostElement, message) {
                    if (!this._canBeDescribed(hostElement, message)) {
                        return;
                    }
                    if (typeof message !== 'string') {
                        // We need to ensure that the element has an ID.
                        this._setMessageId(message);
                        messageRegistry.set(message, { messageElement: message, referenceCount: 0 });
                    }
                    else if (!messageRegistry.has(message)) {
                        this._createMessageElement(message);
                    }
                    if (!this._isElementDescribedByMessage(hostElement, message)) {
                        this._addMessageReference(hostElement, message);
                    }
                };
                /**
                 * Removes the host element's aria-describedby reference to the message element.
                 * @param {?} hostElement
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype.removeDescription = function (hostElement, message) {
                    if (!this._isElementNode(hostElement)) {
                        return;
                    }
                    if (this._isElementDescribedByMessage(hostElement, message)) {
                        this._removeMessageReference(hostElement, message);
                    }
                    // If the message is a string, it means that it's one that we created for the
                    // consumer so we can remove it safely, otherwise we should leave it in place.
                    if (typeof message === 'string') {
                        /** @type {?} */
                        var registeredMessage = messageRegistry.get(message);
                        if (registeredMessage && registeredMessage.referenceCount === 0) {
                            this._deleteMessageElement(message);
                        }
                    }
                    if (messagesContainer && messagesContainer.childNodes.length === 0) {
                        this._deleteMessagesContainer();
                    }
                };
                /**
                 * Unregisters all created message elements and removes the message container.
                 * @return {?}
                 */
                AriaDescriber.prototype.ngOnDestroy = function () {
                    /** @type {?} */
                    var describedElements = this._document.querySelectorAll("[" + CDK_DESCRIBEDBY_HOST_ATTRIBUTE + "]");
                    for (var i = 0; i < describedElements.length; i++) {
                        this._removeCdkDescribedByReferenceIds(describedElements[i]);
                        describedElements[i].removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
                    }
                    if (messagesContainer) {
                        this._deleteMessagesContainer();
                    }
                    messageRegistry.clear();
                };
                /**
                 * Creates a new element in the visually hidden message container element with the message
                 * as its content and adds it to the message registry.
                 * @private
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype._createMessageElement = function (message) {
                    /** @type {?} */
                    var messageElement = this._document.createElement('div');
                    this._setMessageId(messageElement);
                    messageElement.textContent = message;
                    this._createMessagesContainer();
                    ( /** @type {?} */(messagesContainer)).appendChild(messageElement);
                    messageRegistry.set(message, { messageElement: messageElement, referenceCount: 0 });
                };
                /**
                 * Assigns a unique ID to an element, if it doesn't have one already.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                AriaDescriber.prototype._setMessageId = function (element) {
                    if (!element.id) {
                        element.id = CDK_DESCRIBEDBY_ID_PREFIX + "-" + nextId++;
                    }
                };
                /**
                 * Deletes the message element from the global messages container.
                 * @private
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype._deleteMessageElement = function (message) {
                    /** @type {?} */
                    var registeredMessage = messageRegistry.get(message);
                    /** @type {?} */
                    var messageElement = registeredMessage && registeredMessage.messageElement;
                    if (messagesContainer && messageElement) {
                        messagesContainer.removeChild(messageElement);
                    }
                    messageRegistry.delete(message);
                };
                /**
                 * Creates the global container for all aria-describedby messages.
                 * @private
                 * @return {?}
                 */
                AriaDescriber.prototype._createMessagesContainer = function () {
                    if (!messagesContainer) {
                        /** @type {?} */
                        var preExistingContainer = this._document.getElementById(MESSAGES_CONTAINER_ID);
                        // When going from the server to the client, we may end up in a situation where there's
                        // already a container on the page, but we don't have a reference to it. Clear the
                        // old container so we don't get duplicates. Doing this, instead of emptying the previous
                        // container, should be slightly faster.
                        if (preExistingContainer) {
                            ( /** @type {?} */(preExistingContainer.parentNode)).removeChild(preExistingContainer);
                        }
                        messagesContainer = this._document.createElement('div');
                        messagesContainer.id = MESSAGES_CONTAINER_ID;
                        messagesContainer.setAttribute('aria-hidden', 'true');
                        messagesContainer.style.display = 'none';
                        this._document.body.appendChild(messagesContainer);
                    }
                };
                /**
                 * Deletes the global messages container.
                 * @private
                 * @return {?}
                 */
                AriaDescriber.prototype._deleteMessagesContainer = function () {
                    if (messagesContainer && messagesContainer.parentNode) {
                        messagesContainer.parentNode.removeChild(messagesContainer);
                        messagesContainer = null;
                    }
                };
                /**
                 * Removes all cdk-describedby messages that are hosted through the element.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                AriaDescriber.prototype._removeCdkDescribedByReferenceIds = function (element) {
                    // Remove all aria-describedby reference IDs that are prefixed by CDK_DESCRIBEDBY_ID_PREFIX
                    /** @type {?} */
                    var originalReferenceIds = getAriaReferenceIds(element, 'aria-describedby')
                        .filter(( /**
                 * @param {?} id
                 * @return {?}
                 */function (/**
                 * @param {?} id
                 * @return {?}
                 */ id) { return id.indexOf(CDK_DESCRIBEDBY_ID_PREFIX) != 0; }));
                    element.setAttribute('aria-describedby', originalReferenceIds.join(' '));
                };
                /**
                 * Adds a message reference to the element using aria-describedby and increments the registered
                 * message's reference count.
                 * @private
                 * @param {?} element
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype._addMessageReference = function (element, message) {
                    /** @type {?} */
                    var registeredMessage = ( /** @type {?} */(messageRegistry.get(message)));
                    // Add the aria-describedby reference and set the
                    // describedby_host attribute to mark the element.
                    addAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
                    element.setAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE, '');
                    registeredMessage.referenceCount++;
                };
                /**
                 * Removes a message reference from the element using aria-describedby
                 * and decrements the registered message's reference count.
                 * @private
                 * @param {?} element
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype._removeMessageReference = function (element, message) {
                    /** @type {?} */
                    var registeredMessage = ( /** @type {?} */(messageRegistry.get(message)));
                    registeredMessage.referenceCount--;
                    removeAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
                    element.removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
                };
                /**
                 * Returns true if the element has been described by the provided message ID.
                 * @private
                 * @param {?} element
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype._isElementDescribedByMessage = function (element, message) {
                    /** @type {?} */
                    var referenceIds = getAriaReferenceIds(element, 'aria-describedby');
                    /** @type {?} */
                    var registeredMessage = messageRegistry.get(message);
                    /** @type {?} */
                    var messageId = registeredMessage && registeredMessage.messageElement.id;
                    return !!messageId && referenceIds.indexOf(messageId) != -1;
                };
                /**
                 * Determines whether a message can be described on a particular element.
                 * @private
                 * @param {?} element
                 * @param {?} message
                 * @return {?}
                 */
                AriaDescriber.prototype._canBeDescribed = function (element, message) {
                    if (!this._isElementNode(element)) {
                        return false;
                    }
                    if (message && typeof message === 'object') {
                        // We'd have to make some assumptions about the description element's text, if the consumer
                        // passed in an element. Assume that if an element is passed in, the consumer has verified
                        // that it can be used as a description.
                        return true;
                    }
                    /** @type {?} */
                    var trimmedMessage = message == null ? '' : ("" + message).trim();
                    /** @type {?} */
                    var ariaLabel = element.getAttribute('aria-label');
                    // We shouldn't set descriptions if they're exactly the same as the `aria-label` of the
                    // element, because screen readers will end up reading out the same text twice in a row.
                    return trimmedMessage ? (!ariaLabel || ariaLabel.trim() !== trimmedMessage) : false;
                };
                /**
                 * Checks whether a node is an Element node.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                AriaDescriber.prototype._isElementNode = function (element) {
                    return element.nodeType === this._document.ELEMENT_NODE;
                };
                return AriaDescriber;
            }());
            AriaDescriber.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            AriaDescriber.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ AriaDescriber.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function AriaDescriber_Factory() { return new AriaDescriber(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"])); }, token: AriaDescriber, providedIn: "root" });
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} parentDispatcher
             * @param {?} _document
             * @return {?}
             */
            function ARIA_DESCRIBER_PROVIDER_FACTORY(parentDispatcher, _document) {
                return parentDispatcher || new AriaDescriber(_document);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var ARIA_DESCRIBER_PROVIDER = {
                // If there is already an AriaDescriber available, use that. Otherwise, provide a new one.
                provide: AriaDescriber,
                deps: [
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"](), AriaDescriber],
                    ( /** @type {?} */(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]))
                ],
                useFactory: ARIA_DESCRIBER_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This class manages keyboard events for selectable lists. If you pass it a query list
             * of items, it will set the active item correctly when arrow events occur.
             * @template T
             */
            var ListKeyManager = /** @class */ (function () {
                /**
                 * @param {?} _items
                 */
                function ListKeyManager(_items) {
                    var _this = this;
                    this._items = _items;
                    this._activeItemIndex = -1;
                    this._activeItem = null;
                    this._wrap = false;
                    this._letterKeyStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    this._typeaheadSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    this._vertical = true;
                    this._allowedModifierKeys = [];
                    /**
                     * Predicate function that can be used to check whether an item should be skipped
                     * by the key manager. By default, disabled items are skipped.
                     */
                    this._skipPredicateFn = ( /**
                     * @param {?} item
                     * @return {?}
                     */function (item) { return item.disabled; });
                    // Buffer for the letters that the user has pressed when the typeahead option is turned on.
                    this._pressedLetters = [];
                    /**
                     * Stream that emits any time the TAB key is pressed, so components can react
                     * when focus is shifted off of the list.
                     */
                    this.tabOut = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Stream that emits whenever the active item of the list manager changes.
                     */
                    this.change = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    // We allow for the items to be an array because, in some cases, the consumer may
                    // not have access to a QueryList of the items they want to manage (e.g. when the
                    // items aren't being collected via `ViewChildren` or `ContentChildren`).
                    if (_items instanceof _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"]) {
                        _items.changes.subscribe(( /**
                         * @param {?} newItems
                         * @return {?}
                         */function (newItems) {
                            if (_this._activeItem) {
                                /** @type {?} */
                                var itemArray = newItems.toArray();
                                /** @type {?} */
                                var newIndex = itemArray.indexOf(_this._activeItem);
                                if (newIndex > -1 && newIndex !== _this._activeItemIndex) {
                                    _this._activeItemIndex = newIndex;
                                }
                            }
                        }));
                    }
                }
                /**
                 * Sets the predicate function that determines which items should be skipped by the
                 * list key manager.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} predicate Function that determines whether the given item should be skipped.
                 * @return {THIS}
                 */
                ListKeyManager.prototype.skipPredicate = function (predicate) {
                    ( /** @type {?} */(this))._skipPredicateFn = predicate;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Configures wrapping mode, which determines whether the active item will wrap to
                 * the other end of list when there are no more items in the given direction.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} shouldWrap Whether the list should wrap when reaching the end.
                 * @return {THIS}
                 */
                ListKeyManager.prototype.withWrap = function (shouldWrap) {
                    if (shouldWrap === void 0) { shouldWrap = true; }
                    ( /** @type {?} */(this))._wrap = shouldWrap;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Configures whether the key manager should be able to move the selection vertically.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} enabled Whether vertical selection should be enabled.
                 * @return {THIS}
                 */
                ListKeyManager.prototype.withVerticalOrientation = function (enabled) {
                    if (enabled === void 0) { enabled = true; }
                    ( /** @type {?} */(this))._vertical = enabled;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Configures the key manager to move the selection horizontally.
                 * Passing in `null` will disable horizontal movement.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} direction Direction in which the selection can be moved.
                 * @return {THIS}
                 */
                ListKeyManager.prototype.withHorizontalOrientation = function (direction) {
                    ( /** @type {?} */(this))._horizontal = direction;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Modifier keys which are allowed to be held down and whose default actions will be prevented
                 * as the user is pressing the arrow keys. Defaults to not allowing any modifier keys.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} keys
                 * @return {THIS}
                 */
                ListKeyManager.prototype.withAllowedModifierKeys = function (keys) {
                    ( /** @type {?} */(this))._allowedModifierKeys = keys;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Turns on typeahead mode which allows users to set the active item by typing.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
                 * @return {THIS}
                 */
                ListKeyManager.prototype.withTypeAhead = function (debounceInterval) {
                    var _this = this;
                    if (debounceInterval === void 0) { debounceInterval = 200; }
                    if (( /** @type {?} */(this))._items.length && ( /** @type {?} */(this))._items.some(( /**
                     * @param {?} item
                     * @return {?}
                     */function (/**
                     * @param {?} item
                     * @return {?}
                     */ item) { return typeof item.getLabel !== 'function'; }))) {
                        throw Error('ListKeyManager items in typeahead mode must implement the `getLabel` method.');
                    }
                    ( /** @type {?} */(this))._typeaheadSubscription.unsubscribe();
                    // Debounce the presses of non-navigational keys, collect the ones that correspond to letters
                    // and convert those letters back into a string. Afterwards find the first item that starts
                    // with that string and select it.
                    ( /** @type {?} */(this))._typeaheadSubscription = ( /** @type {?} */(this))._letterKeyStream.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(( /**
                     * @param {?} keyCode
                     * @return {?}
                     */function (/**
                     * @param {?} keyCode
                     * @return {?}
                     */ keyCode) { return ( /** @type {?} */(_this))._pressedLetters.push(keyCode); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["debounceTime"])(debounceInterval), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["filter"])(( /**
                     * @return {?}
                     */function () { return ( /** @type {?} */(_this))._pressedLetters.length > 0; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(( /**
                     * @return {?}
                     */function () { return ( /** @type {?} */(_this))._pressedLetters.join(''); }))).subscribe(( /**
                     * @param {?} inputString
                     * @return {?}
                     */function (/**
                     * @param {?} inputString
                     * @return {?}
                     */ inputString) {
                        /** @type {?} */
                        var items = ( /** @type {?} */(_this))._getItemsArray();
                        // Start at 1 because we want to start searching at the item immediately
                        // following the current active item.
                        for (var i = 1; i < items.length + 1; i++) {
                            /** @type {?} */
                            var index = (( /** @type {?} */(_this))._activeItemIndex + i) % items.length;
                            /** @type {?} */
                            var item = items[index];
                            if (!( /** @type {?} */(_this))._skipPredicateFn(item) &&
                                ( /** @type {?} */(item.getLabel))().toUpperCase().trim().indexOf(inputString) === 0) {
                                ( /** @type {?} */(_this)).setActiveItem(index);
                                break;
                            }
                        }
                        ( /** @type {?} */(_this))._pressedLetters = [];
                    }));
                    return ( /** @type {?} */(this));
                };
                /**
                 * @param {?} item
                 * @return {?}
                 */
                ListKeyManager.prototype.setActiveItem = function (item) {
                    /** @type {?} */
                    var previousIndex = this._activeItemIndex;
                    this.updateActiveItem(item);
                    if (this._activeItemIndex !== previousIndex) {
                        this.change.next(this._activeItemIndex);
                    }
                };
                /**
                 * Sets the active item depending on the key event passed in.
                 * @param {?} event Keyboard event to be used for determining which element should be active.
                 * @return {?}
                 */
                ListKeyManager.prototype.onKeydown = function (event) {
                    var _this = this;
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var modifiers = ['altKey', 'ctrlKey', 'metaKey', 'shiftKey'];
                    /** @type {?} */
                    var isModifierAllowed = modifiers.every(( /**
                     * @param {?} modifier
                     * @return {?}
                     */function (/**
                     * @param {?} modifier
                     * @return {?}
                     */ modifier) {
                        return !event[modifier] || _this._allowedModifierKeys.indexOf(modifier) > -1;
                    }));
                    switch (keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["TAB"]:
                            this.tabOut.next();
                            return;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["DOWN_ARROW"]:
                            if (this._vertical && isModifierAllowed) {
                                this.setNextItemActive();
                                break;
                            }
                            else {
                                return;
                            }
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["UP_ARROW"]:
                            if (this._vertical && isModifierAllowed) {
                                this.setPreviousItemActive();
                                break;
                            }
                            else {
                                return;
                            }
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["RIGHT_ARROW"]:
                            if (this._horizontal && isModifierAllowed) {
                                this._horizontal === 'rtl' ? this.setPreviousItemActive() : this.setNextItemActive();
                                break;
                            }
                            else {
                                return;
                            }
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["LEFT_ARROW"]:
                            if (this._horizontal && isModifierAllowed) {
                                this._horizontal === 'rtl' ? this.setNextItemActive() : this.setPreviousItemActive();
                                break;
                            }
                            else {
                                return;
                            }
                        default:
                            if (isModifierAllowed || Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["hasModifierKey"])(event, 'shiftKey')) {
                                // Attempt to use the `event.key` which also maps it to the user's keyboard language,
                                // otherwise fall back to resolving alphanumeric characters via the keyCode.
                                if (event.key && event.key.length === 1) {
                                    this._letterKeyStream.next(event.key.toLocaleUpperCase());
                                }
                                else if ((keyCode >= _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["A"] && keyCode <= _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["Z"]) || (keyCode >= _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["ZERO"] && keyCode <= _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["NINE"])) {
                                    this._letterKeyStream.next(String.fromCharCode(keyCode));
                                }
                            }
                            // Note that we return here, in order to avoid preventing
                            // the default action of non-navigational keys.
                            return;
                    }
                    this._pressedLetters = [];
                    event.preventDefault();
                };
                Object.defineProperty(ListKeyManager.prototype, "activeItemIndex", {
                    /**
                     * Index of the currently active item.
                     * @return {?}
                     */
                    get: function () {
                        return this._activeItemIndex;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ListKeyManager.prototype, "activeItem", {
                    /**
                     * The active item.
                     * @return {?}
                     */
                    get: function () {
                        return this._activeItem;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the active item to the first enabled item in the list.
                 * @return {?}
                 */
                ListKeyManager.prototype.setFirstItemActive = function () {
                    this._setActiveItemByIndex(0, 1);
                };
                /**
                 * Sets the active item to the last enabled item in the list.
                 * @return {?}
                 */
                ListKeyManager.prototype.setLastItemActive = function () {
                    this._setActiveItemByIndex(this._items.length - 1, -1);
                };
                /**
                 * Sets the active item to the next enabled item in the list.
                 * @return {?}
                 */
                ListKeyManager.prototype.setNextItemActive = function () {
                    this._activeItemIndex < 0 ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
                };
                /**
                 * Sets the active item to a previous enabled item in the list.
                 * @return {?}
                 */
                ListKeyManager.prototype.setPreviousItemActive = function () {
                    this._activeItemIndex < 0 && this._wrap ? this.setLastItemActive()
                        : this._setActiveItemByDelta(-1);
                };
                /**
                 * @param {?} item
                 * @return {?}
                 */
                ListKeyManager.prototype.updateActiveItem = function (item) {
                    /** @type {?} */
                    var itemArray = this._getItemsArray();
                    /** @type {?} */
                    var index = typeof item === 'number' ? item : itemArray.indexOf(item);
                    /** @type {?} */
                    var activeItem = itemArray[index];
                    // Explicitly check for `null` and `undefined` because other falsy values are valid.
                    this._activeItem = activeItem == null ? null : activeItem;
                    this._activeItemIndex = index;
                };
                /**
                 * Allows setting of the activeItemIndex without any other effects.
                 * @deprecated Use `updateActiveItem` instead.
                 * \@breaking-change 8.0.0
                 * @param {?} index The new activeItemIndex.
                 * @return {?}
                 */
                ListKeyManager.prototype.updateActiveItemIndex = function (index) {
                    this.updateActiveItem(index);
                };
                /**
                 * This method sets the active item, given a list of items and the delta between the
                 * currently active item and the new active item. It will calculate differently
                 * depending on whether wrap mode is turned on.
                 * @private
                 * @param {?} delta
                 * @return {?}
                 */
                ListKeyManager.prototype._setActiveItemByDelta = function (delta) {
                    this._wrap ? this._setActiveInWrapMode(delta) : this._setActiveInDefaultMode(delta);
                };
                /**
                 * Sets the active item properly given "wrap" mode. In other words, it will continue to move
                 * down the list until it finds an item that is not disabled, and it will wrap if it
                 * encounters either end of the list.
                 * @private
                 * @param {?} delta
                 * @return {?}
                 */
                ListKeyManager.prototype._setActiveInWrapMode = function (delta) {
                    /** @type {?} */
                    var items = this._getItemsArray();
                    for (var i = 1; i <= items.length; i++) {
                        /** @type {?} */
                        var index = (this._activeItemIndex + (delta * i) + items.length) % items.length;
                        /** @type {?} */
                        var item = items[index];
                        if (!this._skipPredicateFn(item)) {
                            this.setActiveItem(index);
                            return;
                        }
                    }
                };
                /**
                 * Sets the active item properly given the default mode. In other words, it will
                 * continue to move down the list until it finds an item that is not disabled. If
                 * it encounters either end of the list, it will stop and not wrap.
                 * @private
                 * @param {?} delta
                 * @return {?}
                 */
                ListKeyManager.prototype._setActiveInDefaultMode = function (delta) {
                    this._setActiveItemByIndex(this._activeItemIndex + delta, delta);
                };
                /**
                 * Sets the active item to the first enabled item starting at the index specified. If the
                 * item is disabled, it will move in the fallbackDelta direction until it either
                 * finds an enabled item or encounters the end of the list.
                 * @private
                 * @param {?} index
                 * @param {?} fallbackDelta
                 * @return {?}
                 */
                ListKeyManager.prototype._setActiveItemByIndex = function (index, fallbackDelta) {
                    /** @type {?} */
                    var items = this._getItemsArray();
                    if (!items[index]) {
                        return;
                    }
                    while (this._skipPredicateFn(items[index])) {
                        index += fallbackDelta;
                        if (!items[index]) {
                            return;
                        }
                    }
                    this.setActiveItem(index);
                };
                /**
                 * Returns the items as an array.
                 * @private
                 * @return {?}
                 */
                ListKeyManager.prototype._getItemsArray = function () {
                    return this._items instanceof _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"] ? this._items.toArray() : this._items;
                };
                return ListKeyManager;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @template T
             */
            var ActiveDescendantKeyManager = /** @class */ (function (_super_1) {
                __extends(ActiveDescendantKeyManager, _super_1);
                function ActiveDescendantKeyManager() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @param {?} index
                 * @return {?}
                 */
                ActiveDescendantKeyManager.prototype.setActiveItem = function (index) {
                    if (this.activeItem) {
                        this.activeItem.setInactiveStyles();
                    }
                    _super_1.prototype.setActiveItem.call(this, index);
                    if (this.activeItem) {
                        this.activeItem.setActiveStyles();
                    }
                };
                return ActiveDescendantKeyManager;
            }(ListKeyManager));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @template T
             */
            var FocusKeyManager = /** @class */ (function (_super_1) {
                __extends(FocusKeyManager, _super_1);
                function FocusKeyManager() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this._origin = 'program';
                    return _this;
                }
                /**
                 * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} origin Focus origin to be used when focusing items.
                 * @return {THIS}
                 */
                FocusKeyManager.prototype.setFocusOrigin = function (origin) {
                    ( /** @type {?} */(this))._origin = origin;
                    return ( /** @type {?} */(this));
                };
                /**
                 * @param {?} item
                 * @return {?}
                 */
                FocusKeyManager.prototype.setActiveItem = function (item) {
                    _super_1.prototype.setActiveItem.call(this, item);
                    if (this.activeItem) {
                        this.activeItem.focus(this._origin);
                    }
                };
                return FocusKeyManager;
            }(ListKeyManager));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // The InteractivityChecker leans heavily on the ally.js accessibility utilities.
            // Methods like `isTabbable` are only covering specific edge-cases for the browsers which are
            // supported.
            /**
             * Utility for checking the interactivity of an element, such as whether is is focusable or
             * tabbable.
             */
            var InteractivityChecker = /** @class */ (function () {
                /**
                 * @param {?} _platform
                 */
                function InteractivityChecker(_platform) {
                    this._platform = _platform;
                }
                /**
                 * Gets whether an element is disabled.
                 *
                 * @param {?} element Element to be checked.
                 * @return {?} Whether the element is disabled.
                 */
                InteractivityChecker.prototype.isDisabled = function (element) {
                    // This does not capture some cases, such as a non-form control with a disabled attribute or
                    // a form control inside of a disabled form, but should capture the most common cases.
                    return element.hasAttribute('disabled');
                };
                /**
                 * Gets whether an element is visible for the purposes of interactivity.
                 *
                 * This will capture states like `display: none` and `visibility: hidden`, but not things like
                 * being clipped by an `overflow: hidden` parent or being outside the viewport.
                 *
                 * @param {?} element
                 * @return {?} Whether the element is visible.
                 */
                InteractivityChecker.prototype.isVisible = function (element) {
                    return hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
                };
                /**
                 * Gets whether an element can be reached via Tab key.
                 * Assumes that the element has already been checked with isFocusable.
                 *
                 * @param {?} element Element to be checked.
                 * @return {?} Whether the element is tabbable.
                 */
                InteractivityChecker.prototype.isTabbable = function (element) {
                    // Nothing is tabbable on the server 😎
                    if (!this._platform.isBrowser) {
                        return false;
                    }
                    /** @type {?} */
                    var frameElement = getFrameElement(getWindow(element));
                    if (frameElement) {
                        /** @type {?} */
                        var frameType = frameElement && frameElement.nodeName.toLowerCase();
                        // Frame elements inherit their tabindex onto all child elements.
                        if (getTabIndexValue(frameElement) === -1) {
                            return false;
                        }
                        // Webkit and Blink consider anything inside of an <object> element as non-tabbable.
                        if ((this._platform.BLINK || this._platform.WEBKIT) && frameType === 'object') {
                            return false;
                        }
                        // Webkit and Blink disable tabbing to an element inside of an invisible frame.
                        if ((this._platform.BLINK || this._platform.WEBKIT) && !this.isVisible(frameElement)) {
                            return false;
                        }
                    }
                    /** @type {?} */
                    var nodeName = element.nodeName.toLowerCase();
                    /** @type {?} */
                    var tabIndexValue = getTabIndexValue(element);
                    if (element.hasAttribute('contenteditable')) {
                        return tabIndexValue !== -1;
                    }
                    if (nodeName === 'iframe') {
                        // The frames may be tabbable depending on content, but it's not possibly to reliably
                        // investigate the content of the frames.
                        return false;
                    }
                    if (nodeName === 'audio') {
                        if (!element.hasAttribute('controls')) {
                            // By default an <audio> element without the controls enabled is not tabbable.
                            return false;
                        }
                        else if (this._platform.BLINK) {
                            // In Blink <audio controls> elements are always tabbable.
                            return true;
                        }
                    }
                    if (nodeName === 'video') {
                        if (!element.hasAttribute('controls') && this._platform.TRIDENT) {
                            // In Trident a <video> element without the controls enabled is not tabbable.
                            return false;
                        }
                        else if (this._platform.BLINK || this._platform.FIREFOX) {
                            // In Chrome and Firefox <video controls> elements are always tabbable.
                            return true;
                        }
                    }
                    if (nodeName === 'object' && (this._platform.BLINK || this._platform.WEBKIT)) {
                        // In all Blink and WebKit based browsers <object> elements are never tabbable.
                        return false;
                    }
                    // In iOS the browser only considers some specific elements as tabbable.
                    if (this._platform.WEBKIT && this._platform.IOS && !isPotentiallyTabbableIOS(element)) {
                        return false;
                    }
                    return element.tabIndex >= 0;
                };
                /**
                 * Gets whether an element can be focused by the user.
                 *
                 * @param {?} element Element to be checked.
                 * @return {?} Whether the element is focusable.
                 */
                InteractivityChecker.prototype.isFocusable = function (element) {
                    // Perform checks in order of left to most expensive.
                    // Again, naive approach that does not capture many edge cases and browser quirks.
                    return isPotentiallyFocusable(element) && !this.isDisabled(element) && this.isVisible(element);
                };
                return InteractivityChecker;
            }());
            InteractivityChecker.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            InteractivityChecker.ctorParameters = function () { return [
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["Platform"] }
            ]; };
            /** @nocollapse */ InteractivityChecker.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function InteractivityChecker_Factory() { return new InteractivityChecker(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["Platform"])); }, token: InteractivityChecker, providedIn: "root" });
            /**
             * Returns the frame element from a window object. Since browsers like MS Edge throw errors if
             * the frameElement property is being accessed from a different host address, this property
             * should be accessed carefully.
             * @param {?} window
             * @return {?}
             */
            function getFrameElement(window) {
                try {
                    return ( /** @type {?} */(window.frameElement));
                }
                catch (_a) {
                    return null;
                }
            }
            /**
             * Checks whether the specified element has any geometry / rectangles.
             * @param {?} element
             * @return {?}
             */
            function hasGeometry(element) {
                // Use logic from jQuery to check for an invisible element.
                // See https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js#L12
                return !!(element.offsetWidth || element.offsetHeight ||
                    (typeof element.getClientRects === 'function' && element.getClientRects().length));
            }
            /**
             * Gets whether an element's
             * @param {?} element
             * @return {?}
             */
            function isNativeFormElement(element) {
                /** @type {?} */
                var nodeName = element.nodeName.toLowerCase();
                return nodeName === 'input' ||
                    nodeName === 'select' ||
                    nodeName === 'button' ||
                    nodeName === 'textarea';
            }
            /**
             * Gets whether an element is an `<input type="hidden">`.
             * @param {?} element
             * @return {?}
             */
            function isHiddenInput(element) {
                return isInputElement(element) && element.type == 'hidden';
            }
            /**
             * Gets whether an element is an anchor that has an href attribute.
             * @param {?} element
             * @return {?}
             */
            function isAnchorWithHref(element) {
                return isAnchorElement(element) && element.hasAttribute('href');
            }
            /**
             * Gets whether an element is an input element.
             * @param {?} element
             * @return {?}
             */
            function isInputElement(element) {
                return element.nodeName.toLowerCase() == 'input';
            }
            /**
             * Gets whether an element is an anchor element.
             * @param {?} element
             * @return {?}
             */
            function isAnchorElement(element) {
                return element.nodeName.toLowerCase() == 'a';
            }
            /**
             * Gets whether an element has a valid tabindex.
             * @param {?} element
             * @return {?}
             */
            function hasValidTabIndex(element) {
                if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
                    return false;
                }
                /** @type {?} */
                var tabIndex = element.getAttribute('tabindex');
                // IE11 parses tabindex="" as the value "-32768"
                if (tabIndex == '-32768') {
                    return false;
                }
                return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
            }
            /**
             * Returns the parsed tabindex from the element attributes instead of returning the
             * evaluated tabindex from the browsers defaults.
             * @param {?} element
             * @return {?}
             */
            function getTabIndexValue(element) {
                if (!hasValidTabIndex(element)) {
                    return null;
                }
                // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
                /** @type {?} */
                var tabIndex = parseInt(element.getAttribute('tabindex') || '', 10);
                return isNaN(tabIndex) ? -1 : tabIndex;
            }
            /**
             * Checks whether the specified element is potentially tabbable on iOS
             * @param {?} element
             * @return {?}
             */
            function isPotentiallyTabbableIOS(element) {
                /** @type {?} */
                var nodeName = element.nodeName.toLowerCase();
                /** @type {?} */
                var inputType = nodeName === 'input' && (( /** @type {?} */(element))).type;
                return inputType === 'text'
                    || inputType === 'password'
                    || nodeName === 'select'
                    || nodeName === 'textarea';
            }
            /**
             * Gets whether an element is potentially focusable without taking current visible/disabled state
             * into account.
             * @param {?} element
             * @return {?}
             */
            function isPotentiallyFocusable(element) {
                // Inputs are potentially focusable *unless* they're type="hidden".
                if (isHiddenInput(element)) {
                    return false;
                }
                return isNativeFormElement(element) ||
                    isAnchorWithHref(element) ||
                    element.hasAttribute('contenteditable') ||
                    hasValidTabIndex(element);
            }
            /**
             * Gets the parent window of a DOM node with regards of being inside of an iframe.
             * @param {?} node
             * @return {?}
             */
            function getWindow(node) {
                // ownerDocument is null if `node` itself *is* a document.
                return node.ownerDocument && node.ownerDocument.defaultView || window;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Class that allows for trapping focus within a DOM element.
             *
             * This class currently uses a relatively simple approach to focus trapping.
             * It assumes that the tab order is the same as DOM order, which is not necessarily true.
             * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause to two to misalign.
             */
            var FocusTrap = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _checker
                 * @param {?} _ngZone
                 * @param {?} _document
                 * @param {?=} deferAnchors
                 */
                function FocusTrap(_element, _checker, _ngZone, _document, deferAnchors) {
                    var _this = this;
                    if (deferAnchors === void 0) { deferAnchors = false; }
                    this._element = _element;
                    this._checker = _checker;
                    this._ngZone = _ngZone;
                    this._document = _document;
                    this._hasAttached = false;
                    // Event listeners for the anchors. Need to be regular functions so that we can unbind them later.
                    this.startAnchorListener = ( /**
                     * @return {?}
                     */function () { return _this.focusLastTabbableElement(); });
                    this.endAnchorListener = ( /**
                     * @return {?}
                     */function () { return _this.focusFirstTabbableElement(); });
                    this._enabled = true;
                    if (!deferAnchors) {
                        this.attachAnchors();
                    }
                }
                Object.defineProperty(FocusTrap.prototype, "enabled", {
                    /**
                     * Whether the focus trap is active.
                     * @return {?}
                     */
                    get: function () { return this._enabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._enabled = value;
                        if (this._startAnchor && this._endAnchor) {
                            this._toggleAnchorTabIndex(value, this._startAnchor);
                            this._toggleAnchorTabIndex(value, this._endAnchor);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Destroys the focus trap by cleaning up the anchors.
                 * @return {?}
                 */
                FocusTrap.prototype.destroy = function () {
                    /** @type {?} */
                    var startAnchor = this._startAnchor;
                    /** @type {?} */
                    var endAnchor = this._endAnchor;
                    if (startAnchor) {
                        startAnchor.removeEventListener('focus', this.startAnchorListener);
                        if (startAnchor.parentNode) {
                            startAnchor.parentNode.removeChild(startAnchor);
                        }
                    }
                    if (endAnchor) {
                        endAnchor.removeEventListener('focus', this.endAnchorListener);
                        if (endAnchor.parentNode) {
                            endAnchor.parentNode.removeChild(endAnchor);
                        }
                    }
                    this._startAnchor = this._endAnchor = null;
                };
                /**
                 * Inserts the anchors into the DOM. This is usually done automatically
                 * in the constructor, but can be deferred for cases like directives with `*ngIf`.
                 * @return {?} Whether the focus trap managed to attach successfuly. This may not be the case
                 * if the target element isn't currently in the DOM.
                 */
                FocusTrap.prototype.attachAnchors = function () {
                    var _this = this;
                    // If we're not on the browser, there can be no focus to trap.
                    if (this._hasAttached) {
                        return true;
                    }
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        if (!_this._startAnchor) {
                            _this._startAnchor = _this._createAnchor();
                            ( /** @type {?} */(_this._startAnchor)).addEventListener('focus', _this.startAnchorListener);
                        }
                        if (!_this._endAnchor) {
                            _this._endAnchor = _this._createAnchor();
                            ( /** @type {?} */(_this._endAnchor)).addEventListener('focus', _this.endAnchorListener);
                        }
                    }));
                    if (this._element.parentNode) {
                        this._element.parentNode.insertBefore(( /** @type {?} */(this._startAnchor)), this._element);
                        this._element.parentNode.insertBefore(( /** @type {?} */(this._endAnchor)), this._element.nextSibling);
                        this._hasAttached = true;
                    }
                    return this._hasAttached;
                };
                /**
                 * Waits for the zone to stabilize, then either focuses the first element that the
                 * user specified, or the first tabbable element.
                 * @return {?} Returns a promise that resolves with a boolean, depending
                 * on whether focus was moved successfuly.
                 */
                FocusTrap.prototype.focusInitialElementWhenReady = function () {
                    var _this = this;
                    return new Promise(( /**
                     * @param {?} resolve
                     * @return {?}
                     */function (/**
                     * @param {?} resolve
                     * @return {?}
                     */ resolve) {
                        _this._executeOnStable(( /**
                         * @return {?}
                         */function () { return resolve(_this.focusInitialElement()); }));
                    }));
                };
                /**
                 * Waits for the zone to stabilize, then focuses
                 * the first tabbable element within the focus trap region.
                 * @return {?} Returns a promise that resolves with a boolean, depending
                 * on whether focus was moved successfuly.
                 */
                FocusTrap.prototype.focusFirstTabbableElementWhenReady = function () {
                    var _this = this;
                    return new Promise(( /**
                     * @param {?} resolve
                     * @return {?}
                     */function (/**
                     * @param {?} resolve
                     * @return {?}
                     */ resolve) {
                        _this._executeOnStable(( /**
                         * @return {?}
                         */function () { return resolve(_this.focusFirstTabbableElement()); }));
                    }));
                };
                /**
                 * Waits for the zone to stabilize, then focuses
                 * the last tabbable element within the focus trap region.
                 * @return {?} Returns a promise that resolves with a boolean, depending
                 * on whether focus was moved successfuly.
                 */
                FocusTrap.prototype.focusLastTabbableElementWhenReady = function () {
                    var _this = this;
                    return new Promise(( /**
                     * @param {?} resolve
                     * @return {?}
                     */function (/**
                     * @param {?} resolve
                     * @return {?}
                     */ resolve) {
                        _this._executeOnStable(( /**
                         * @return {?}
                         */function () { return resolve(_this.focusLastTabbableElement()); }));
                    }));
                };
                /**
                 * Get the specified boundary element of the trapped region.
                 * @private
                 * @param {?} bound The boundary to get (start or end of trapped region).
                 * @return {?} The boundary element.
                 */
                FocusTrap.prototype._getRegionBoundary = function (bound) {
                    // Contains the deprecated version of selector, for temporary backwards comparability.
                    /** @type {?} */
                    var markers = ( /** @type {?} */(this._element.querySelectorAll("[cdk-focus-region-" + bound + "], " +
                        ("[cdkFocusRegion" + bound + "], ") +
                        ("[cdk-focus-" + bound + "]"))));
                    for (var i = 0; i < markers.length; i++) {
                        // @breaking-change 8.0.0
                        if (markers[i].hasAttribute("cdk-focus-" + bound)) {
                            console.warn("Found use of deprecated attribute 'cdk-focus-" + bound + "', " +
                                ("use 'cdkFocusRegion" + bound + "' instead. The deprecated ") +
                                "attribute will be removed in 8.0.0.", markers[i]);
                        }
                        else if (markers[i].hasAttribute("cdk-focus-region-" + bound)) {
                            console.warn("Found use of deprecated attribute 'cdk-focus-region-" + bound + "', " +
                                ("use 'cdkFocusRegion" + bound + "' instead. The deprecated attribute ") +
                                "will be removed in 8.0.0.", markers[i]);
                        }
                    }
                    if (bound == 'start') {
                        return markers.length ? markers[0] : this._getFirstTabbableElement(this._element);
                    }
                    return markers.length ?
                        markers[markers.length - 1] : this._getLastTabbableElement(this._element);
                };
                /**
                 * Focuses the element that should be focused when the focus trap is initialized.
                 * @return {?} Whether focus was moved successfuly.
                 */
                FocusTrap.prototype.focusInitialElement = function () {
                    // Contains the deprecated version of selector, for temporary backwards comparability.
                    /** @type {?} */
                    var redirectToElement = ( /** @type {?} */(this._element.querySelector("[cdk-focus-initial], " +
                        "[cdkFocusInitial]")));
                    if (redirectToElement) {
                        // @breaking-change 8.0.0
                        if (redirectToElement.hasAttribute("cdk-focus-initial")) {
                            console.warn("Found use of deprecated attribute 'cdk-focus-initial', " +
                                "use 'cdkFocusInitial' instead. The deprecated attribute " +
                                "will be removed in 8.0.0", redirectToElement);
                        }
                        // Warn the consumer if the element they've pointed to
                        // isn't focusable, when not in production mode.
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && !this._checker.isFocusable(redirectToElement)) {
                            console.warn("Element matching '[cdkFocusInitial]' is not focusable.", redirectToElement);
                        }
                        redirectToElement.focus();
                        return true;
                    }
                    return this.focusFirstTabbableElement();
                };
                /**
                 * Focuses the first tabbable element within the focus trap region.
                 * @return {?} Whether focus was moved successfuly.
                 */
                FocusTrap.prototype.focusFirstTabbableElement = function () {
                    /** @type {?} */
                    var redirectToElement = this._getRegionBoundary('start');
                    if (redirectToElement) {
                        redirectToElement.focus();
                    }
                    return !!redirectToElement;
                };
                /**
                 * Focuses the last tabbable element within the focus trap region.
                 * @return {?} Whether focus was moved successfuly.
                 */
                FocusTrap.prototype.focusLastTabbableElement = function () {
                    /** @type {?} */
                    var redirectToElement = this._getRegionBoundary('end');
                    if (redirectToElement) {
                        redirectToElement.focus();
                    }
                    return !!redirectToElement;
                };
                /**
                 * Checks whether the focus trap has successfuly been attached.
                 * @return {?}
                 */
                FocusTrap.prototype.hasAttached = function () {
                    return this._hasAttached;
                };
                /**
                 * Get the first tabbable element from a DOM subtree (inclusive).
                 * @private
                 * @param {?} root
                 * @return {?}
                 */
                FocusTrap.prototype._getFirstTabbableElement = function (root) {
                    if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
                        return root;
                    }
                    // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
                    // back to `childNodes` which includes text nodes, comments etc.
                    /** @type {?} */
                    var children = root.children || root.childNodes;
                    for (var i = 0; i < children.length; i++) {
                        /** @type {?} */
                        var tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
                            this._getFirstTabbableElement(( /** @type {?} */(children[i]))) :
                            null;
                        if (tabbableChild) {
                            return tabbableChild;
                        }
                    }
                    return null;
                };
                /**
                 * Get the last tabbable element from a DOM subtree (inclusive).
                 * @private
                 * @param {?} root
                 * @return {?}
                 */
                FocusTrap.prototype._getLastTabbableElement = function (root) {
                    if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
                        return root;
                    }
                    // Iterate in reverse DOM order.
                    /** @type {?} */
                    var children = root.children || root.childNodes;
                    for (var i = children.length - 1; i >= 0; i--) {
                        /** @type {?} */
                        var tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
                            this._getLastTabbableElement(( /** @type {?} */(children[i]))) :
                            null;
                        if (tabbableChild) {
                            return tabbableChild;
                        }
                    }
                    return null;
                };
                /**
                 * Creates an anchor element.
                 * @private
                 * @return {?}
                 */
                FocusTrap.prototype._createAnchor = function () {
                    /** @type {?} */
                    var anchor = this._document.createElement('div');
                    this._toggleAnchorTabIndex(this._enabled, anchor);
                    anchor.classList.add('cdk-visually-hidden');
                    anchor.classList.add('cdk-focus-trap-anchor');
                    anchor.setAttribute('aria-hidden', 'true');
                    return anchor;
                };
                /**
                 * Toggles the `tabindex` of an anchor, based on the enabled state of the focus trap.
                 * @private
                 * @param {?} isEnabled Whether the focus trap is enabled.
                 * @param {?} anchor Anchor on which to toggle the tabindex.
                 * @return {?}
                 */
                FocusTrap.prototype._toggleAnchorTabIndex = function (isEnabled, anchor) {
                    // Remove the tabindex completely, rather than setting it to -1, because if the
                    // element has a tabindex, the user might still hit it when navigating with the arrow keys.
                    isEnabled ? anchor.setAttribute('tabindex', '0') : anchor.removeAttribute('tabindex');
                };
                /**
                 * Executes a function when the zone is stable.
                 * @private
                 * @param {?} fn
                 * @return {?}
                 */
                FocusTrap.prototype._executeOnStable = function (fn) {
                    if (this._ngZone.isStable) {
                        fn();
                    }
                    else {
                        this._ngZone.onStable.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).subscribe(fn);
                    }
                };
                return FocusTrap;
            }());
            /**
             * Factory that allows easy instantiation of focus traps.
             */
            var FocusTrapFactory = /** @class */ (function () {
                /**
                 * @param {?} _checker
                 * @param {?} _ngZone
                 * @param {?} _document
                 */
                function FocusTrapFactory(_checker, _ngZone, _document) {
                    this._checker = _checker;
                    this._ngZone = _ngZone;
                    this._document = _document;
                }
                /**
                 * Creates a focus-trapped region around the given element.
                 * @param {?} element The element around which focus will be trapped.
                 * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
                 *     manually by the user.
                 * @return {?} The created focus trap instance.
                 */
                FocusTrapFactory.prototype.create = function (element, deferCaptureElements) {
                    if (deferCaptureElements === void 0) { deferCaptureElements = false; }
                    return new FocusTrap(element, this._checker, this._ngZone, this._document, deferCaptureElements);
                };
                return FocusTrapFactory;
            }());
            FocusTrapFactory.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            FocusTrapFactory.ctorParameters = function () { return [
                { type: InteractivityChecker },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ FocusTrapFactory.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function FocusTrapFactory_Factory() { return new FocusTrapFactory(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(InteractivityChecker), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"])); }, token: FocusTrapFactory, providedIn: "root" });
            /**
             * Directive for trapping focus within a region.
             */
            var CdkTrapFocus = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _focusTrapFactory
                 * @param {?} _document
                 */
                function CdkTrapFocus(_elementRef, _focusTrapFactory, _document) {
                    this._elementRef = _elementRef;
                    this._focusTrapFactory = _focusTrapFactory;
                    /**
                     * Previously focused element to restore focus to upon destroy when using autoCapture.
                     */
                    this._previouslyFocusedElement = null;
                    this._document = _document;
                    this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
                }
                Object.defineProperty(CdkTrapFocus.prototype, "enabled", {
                    /**
                     * Whether the focus trap is active.
                     * @return {?}
                     */
                    get: function () { return this.focusTrap.enabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this.focusTrap.enabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTrapFocus.prototype, "autoCapture", {
                    /**
                     * Whether the directive should automatially move focus into the trapped region upon
                     * initialization and return focus to the previous activeElement upon destruction.
                     * @return {?}
                     */
                    get: function () { return this._autoCapture; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._autoCapture = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkTrapFocus.prototype.ngOnDestroy = function () {
                    this.focusTrap.destroy();
                    // If we stored a previously focused element when using autoCapture, return focus to that
                    // element now that the trapped region is being destroyed.
                    if (this._previouslyFocusedElement) {
                        this._previouslyFocusedElement.focus();
                        this._previouslyFocusedElement = null;
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTrapFocus.prototype.ngAfterContentInit = function () {
                    this.focusTrap.attachAnchors();
                    if (this.autoCapture) {
                        this._previouslyFocusedElement = ( /** @type {?} */(this._document.activeElement));
                        this.focusTrap.focusInitialElementWhenReady();
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTrapFocus.prototype.ngDoCheck = function () {
                    if (!this.focusTrap.hasAttached()) {
                        this.focusTrap.attachAnchors();
                    }
                };
                return CdkTrapFocus;
            }());
            CdkTrapFocus.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkTrapFocus]',
                            exportAs: 'cdkTrapFocus',
                        },] },
            ];
            /** @nocollapse */
            CdkTrapFocus.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: FocusTrapFactory },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            CdkTrapFocus.propDecorators = {
                enabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkTrapFocus',] }],
                autoCapture: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkTrapFocusAutoCapture',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var LIVE_ANNOUNCER_ELEMENT_TOKEN = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('liveAnnouncerElement', {
                providedIn: 'root',
                factory: LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY() {
                return null;
            }
            /**
             * Injection token that can be used to configure the default options for the LiveAnnouncer.
             * @type {?}
             */
            var LIVE_ANNOUNCER_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('LIVE_ANNOUNCER_DEFAULT_OPTIONS');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var LiveAnnouncer = /** @class */ (function () {
                /**
                 * @param {?} elementToken
                 * @param {?} _ngZone
                 * @param {?} _document
                 * @param {?=} _defaultOptions
                 */
                function LiveAnnouncer(elementToken, _ngZone, _document, _defaultOptions) {
                    this._ngZone = _ngZone;
                    this._defaultOptions = _defaultOptions;
                    // We inject the live element and document as `any` because the constructor signature cannot
                    // reference browser globals (HTMLElement, Document) on non-browser environments, since having
                    // a class decorator causes TypeScript to preserve the constructor signature types.
                    this._document = _document;
                    this._liveElement = elementToken || this._createLiveElement();
                }
                /**
                 * @param {?} message
                 * @param {...?} args
                 * @return {?}
                 */
                LiveAnnouncer.prototype.announce = function (message) {
                    var _this = this;
                    var args = [];
                    for (var _c = 1; _c < arguments.length; _c++) {
                        args[_c - 1] = arguments[_c];
                    }
                    /** @type {?} */
                    var defaultOptions = this._defaultOptions;
                    /** @type {?} */
                    var politeness;
                    /** @type {?} */
                    var duration;
                    if (args.length === 1 && typeof args[0] === 'number') {
                        duration = args[0];
                    }
                    else {
                        politeness = args[0], duration = args[1];
                    }
                    this.clear();
                    clearTimeout(this._previousTimeout);
                    if (!politeness) {
                        politeness =
                            (defaultOptions && defaultOptions.politeness) ? defaultOptions.politeness : 'polite';
                    }
                    if (duration == null && defaultOptions) {
                        duration = defaultOptions.duration;
                    }
                    // TODO: ensure changing the politeness works on all environments we support.
                    this._liveElement.setAttribute('aria-live', politeness);
                    // This 100ms timeout is necessary for some browser + screen-reader combinations:
                    // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
                    // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
                    //   second time without clearing and then using a non-zero delay.
                    // (using JAWS 17 at time of this writing).
                    return this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        return new Promise(( /**
                         * @param {?} resolve
                         * @return {?}
                         */function (/**
                         * @param {?} resolve
                         * @return {?}
                         */ resolve) {
                            clearTimeout(_this._previousTimeout);
                            _this._previousTimeout = setTimeout(( /**
                             * @return {?}
                             */function () {
                                _this._liveElement.textContent = message;
                                resolve();
                                if (typeof duration === 'number') {
                                    _this._previousTimeout = setTimeout(( /**
                                     * @return {?}
                                     */function () { return _this.clear(); }), duration);
                                }
                            }), 100);
                        }));
                    }));
                };
                /**
                 * Clears the current text from the announcer element. Can be used to prevent
                 * screen readers from reading the text out again while the user is going
                 * through the page landmarks.
                 * @return {?}
                 */
                LiveAnnouncer.prototype.clear = function () {
                    if (this._liveElement) {
                        this._liveElement.textContent = '';
                    }
                };
                /**
                 * @return {?}
                 */
                LiveAnnouncer.prototype.ngOnDestroy = function () {
                    clearTimeout(this._previousTimeout);
                    if (this._liveElement && this._liveElement.parentNode) {
                        this._liveElement.parentNode.removeChild(this._liveElement);
                        this._liveElement = ( /** @type {?} */(null));
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                LiveAnnouncer.prototype._createLiveElement = function () {
                    /** @type {?} */
                    var elementClass = 'cdk-live-announcer-element';
                    /** @type {?} */
                    var previousElements = this._document.getElementsByClassName(elementClass);
                    /** @type {?} */
                    var liveEl = this._document.createElement('div');
                    // Remove any old containers. This can happen when coming in from a server-side-rendered page.
                    for (var i = 0; i < previousElements.length; i++) {
                        ( /** @type {?} */(previousElements[i].parentNode)).removeChild(previousElements[i]);
                    }
                    liveEl.classList.add(elementClass);
                    liveEl.classList.add('cdk-visually-hidden');
                    liveEl.setAttribute('aria-atomic', 'true');
                    liveEl.setAttribute('aria-live', 'polite');
                    this._document.body.appendChild(liveEl);
                    return liveEl;
                };
                return LiveAnnouncer;
            }());
            LiveAnnouncer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            LiveAnnouncer.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [LIVE_ANNOUNCER_ELEMENT_TOKEN,] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [LIVE_ANNOUNCER_DEFAULT_OPTIONS,] }] }
            ]; };
            /** @nocollapse */ LiveAnnouncer.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function LiveAnnouncer_Factory() { return new LiveAnnouncer(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(LIVE_ANNOUNCER_ELEMENT_TOKEN, 8), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(LIVE_ANNOUNCER_DEFAULT_OPTIONS, 8)); }, token: LiveAnnouncer, providedIn: "root" });
            /**
             * A directive that works similarly to aria-live, but uses the LiveAnnouncer to ensure compatibility
             * with a wider range of browsers and screen readers.
             */
            var CdkAriaLive = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _liveAnnouncer
                 * @param {?} _contentObserver
                 * @param {?} _ngZone
                 */
                function CdkAriaLive(_elementRef, _liveAnnouncer, _contentObserver, _ngZone) {
                    this._elementRef = _elementRef;
                    this._liveAnnouncer = _liveAnnouncer;
                    this._contentObserver = _contentObserver;
                    this._ngZone = _ngZone;
                    this._politeness = 'off';
                }
                Object.defineProperty(CdkAriaLive.prototype, "politeness", {
                    /**
                     * The aria-live politeness level to use when announcing messages.
                     * @return {?}
                     */
                    get: function () { return this._politeness; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        var _this = this;
                        this._politeness = value === 'polite' || value === 'assertive' ? value : 'off';
                        if (this._politeness === 'off') {
                            if (this._subscription) {
                                this._subscription.unsubscribe();
                                this._subscription = null;
                            }
                        }
                        else if (!this._subscription) {
                            this._subscription = this._ngZone.runOutsideAngular(( /**
                             * @return {?}
                             */function () {
                                return _this._contentObserver
                                    .observe(_this._elementRef)
                                    .subscribe(( /**
                             * @return {?}
                             */function () {
                                    // Note that we use textContent here, rather than innerText, in order to avoid a reflow.
                                    /** @type {?} */
                                    var elementText = _this._elementRef.nativeElement.textContent;
                                    // The `MutationObserver` fires also for attribute
                                    // changes which we don't want to announce.
                                    if (elementText !== _this._previousAnnouncedText) {
                                        _this._liveAnnouncer.announce(elementText, _this._politeness);
                                        _this._previousAnnouncedText = elementText;
                                    }
                                }));
                            }));
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkAriaLive.prototype.ngOnDestroy = function () {
                    if (this._subscription) {
                        this._subscription.unsubscribe();
                    }
                };
                return CdkAriaLive;
            }());
            CdkAriaLive.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkAriaLive]',
                            exportAs: 'cdkAriaLive',
                        },] },
            ];
            /** @nocollapse */
            CdkAriaLive.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: LiveAnnouncer },
                { type: _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_7__["ContentObserver"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
            ]; };
            CdkAriaLive.propDecorators = {
                politeness: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkAriaLive',] }]
            };
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} parentAnnouncer
             * @param {?} liveElement
             * @param {?} _document
             * @param {?} ngZone
             * @return {?}
             */
            function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentAnnouncer, liveElement, _document, ngZone) {
                return parentAnnouncer || new LiveAnnouncer(liveElement, ngZone, _document);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var LIVE_ANNOUNCER_PROVIDER = {
                // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
                provide: LiveAnnouncer,
                deps: [
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"](), LiveAnnouncer],
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"](LIVE_ANNOUNCER_ELEMENT_TOKEN)],
                    _angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],
                    _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"],
                ],
                useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // This is the value used by AngularJS Material. Through trial and error (on iPhone 6S) they found
            // that a value of around 650ms seems appropriate.
            /** @type {?} */
            var TOUCH_BUFFER_MS = 650;
            /**
             * Event listener options that enable capturing and also
             * mark the listener as passive if the browser supports it.
             * @type {?}
             */
            var captureEventListenerOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["normalizePassiveListenerOptions"])({
                passive: true,
                capture: true
            });
            /**
             * Monitors mouse and keyboard events to determine the cause of focus events.
             */
            var FocusMonitor = /** @class */ (function () {
                /**
                 * @param {?} _ngZone
                 * @param {?} _platform
                 */
                function FocusMonitor(_ngZone, _platform) {
                    var _this = this;
                    this._ngZone = _ngZone;
                    this._platform = _platform;
                    /**
                     * The focus origin that the next focus event is a result of.
                     */
                    this._origin = null;
                    /**
                     * Whether the window has just been focused.
                     */
                    this._windowFocused = false;
                    /**
                     * Map of elements being monitored to their info.
                     */
                    this._elementInfo = new Map();
                    /**
                     * The number of elements currently being monitored.
                     */
                    this._monitoredElementCount = 0;
                    /**
                     * Event listener for `keydown` events on the document.
                     * Needs to be an arrow function in order to preserve the context when it gets bound.
                     */
                    this._documentKeydownListener = ( /**
                     * @return {?}
                     */function () {
                        // On keydown record the origin and clear any touch event that may be in progress.
                        _this._lastTouchTarget = null;
                        _this._setOriginForCurrentEventQueue('keyboard');
                    });
                    /**
                     * Event listener for `mousedown` events on the document.
                     * Needs to be an arrow function in order to preserve the context when it gets bound.
                     */
                    this._documentMousedownListener = ( /**
                     * @return {?}
                     */function () {
                        // On mousedown record the origin only if there is not touch
                        // target, since a mousedown can happen as a result of a touch event.
                        if (!_this._lastTouchTarget) {
                            _this._setOriginForCurrentEventQueue('mouse');
                        }
                    });
                    /**
                     * Event listener for `touchstart` events on the document.
                     * Needs to be an arrow function in order to preserve the context when it gets bound.
                     */
                    this._documentTouchstartListener = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        // When the touchstart event fires the focus event is not yet in the event queue. This means
                        // we can't rely on the trick used above (setting timeout of 1ms). Instead we wait 650ms to
                        // see if a focus happens.
                        if (_this._touchTimeoutId != null) {
                            clearTimeout(_this._touchTimeoutId);
                        }
                        // Since this listener is bound on the `document` level, any events coming from the shadow DOM
                        // will have their `target` set to the shadow root. If available, use `composedPath` to
                        // figure out the event target.
                        _this._lastTouchTarget = event.composedPath ? event.composedPath()[0] : event.target;
                        _this._touchTimeoutId = setTimeout(( /**
                         * @return {?}
                         */function () { return _this._lastTouchTarget = null; }), TOUCH_BUFFER_MS);
                    });
                    /**
                     * Event listener for `focus` events on the window.
                     * Needs to be an arrow function in order to preserve the context when it gets bound.
                     */
                    this._windowFocusListener = ( /**
                     * @return {?}
                     */function () {
                        // Make a note of when the window regains focus, so we can
                        // restore the origin info for the focused element.
                        _this._windowFocused = true;
                        _this._windowFocusTimeoutId = setTimeout(( /**
                         * @return {?}
                         */function () { return _this._windowFocused = false; }));
                    });
                }
                /**
                 * @param {?} element
                 * @param {?=} checkChildren
                 * @return {?}
                 */
                FocusMonitor.prototype.monitor = function (element, checkChildren) {
                    var _this = this;
                    if (checkChildren === void 0) { checkChildren = false; }
                    // Do nothing if we're not on the browser platform.
                    if (!this._platform.isBrowser) {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null);
                    }
                    /** @type {?} */
                    var nativeElement = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__["coerceElement"])(element);
                    // Check if we're already monitoring this element.
                    if (this._elementInfo.has(nativeElement)) {
                        /** @type {?} */
                        var cachedInfo = this._elementInfo.get(nativeElement);
                        ( /** @type {?} */(cachedInfo)).checkChildren = checkChildren;
                        return ( /** @type {?} */(cachedInfo)).subject.asObservable();
                    }
                    // Create monitored element info.
                    /** @type {?} */
                    var info = {
                        unlisten: ( /**
                         * @return {?}
                         */function () { }),
                        checkChildren: checkChildren,
                        subject: new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]()
                    };
                    this._elementInfo.set(nativeElement, info);
                    this._incrementMonitoredElementCount();
                    // Start listening. We need to listen in capture phase since focus events don't bubble.
                    /** @type {?} */
                    var focusListener = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) { return _this._onFocus(event, nativeElement); });
                    /** @type {?} */
                    var blurListener = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) { return _this._onBlur(event, nativeElement); });
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        nativeElement.addEventListener('focus', focusListener, true);
                        nativeElement.addEventListener('blur', blurListener, true);
                    }));
                    // Create an unlisten function for later.
                    info.unlisten = ( /**
                     * @return {?}
                     */function () {
                        nativeElement.removeEventListener('focus', focusListener, true);
                        nativeElement.removeEventListener('blur', blurListener, true);
                    });
                    return info.subject.asObservable();
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                FocusMonitor.prototype.stopMonitoring = function (element) {
                    /** @type {?} */
                    var nativeElement = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__["coerceElement"])(element);
                    /** @type {?} */
                    var elementInfo = this._elementInfo.get(nativeElement);
                    if (elementInfo) {
                        elementInfo.unlisten();
                        elementInfo.subject.complete();
                        this._setClasses(nativeElement);
                        this._elementInfo.delete(nativeElement);
                        this._decrementMonitoredElementCount();
                    }
                };
                /**
                 * @param {?} element
                 * @param {?} origin
                 * @param {?=} options
                 * @return {?}
                 */
                FocusMonitor.prototype.focusVia = function (element, origin, options) {
                    /** @type {?} */
                    var nativeElement = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__["coerceElement"])(element);
                    this._setOriginForCurrentEventQueue(origin);
                    // `focus` isn't available on the server
                    if (typeof nativeElement.focus === 'function') {
                        // Cast the element to `any`, because the TS typings don't have the `options` parameter yet.
                        (( /** @type {?} */(nativeElement))).focus(options);
                    }
                };
                /**
                 * @return {?}
                 */
                FocusMonitor.prototype.ngOnDestroy = function () {
                    var _this = this;
                    this._elementInfo.forEach(( /**
                     * @param {?} _info
                     * @param {?} element
                     * @return {?}
                     */function (_info, element) { return _this.stopMonitoring(element); }));
                };
                /**
                 * @private
                 * @param {?} element
                 * @param {?} className
                 * @param {?} shouldSet
                 * @return {?}
                 */
                FocusMonitor.prototype._toggleClass = function (element, className, shouldSet) {
                    if (shouldSet) {
                        element.classList.add(className);
                    }
                    else {
                        element.classList.remove(className);
                    }
                };
                /**
                 * Sets the focus classes on the element based on the given focus origin.
                 * @private
                 * @param {?} element The element to update the classes on.
                 * @param {?=} origin The focus origin.
                 * @return {?}
                 */
                FocusMonitor.prototype._setClasses = function (element, origin) {
                    /** @type {?} */
                    var elementInfo = this._elementInfo.get(element);
                    if (elementInfo) {
                        this._toggleClass(element, 'cdk-focused', !!origin);
                        this._toggleClass(element, 'cdk-touch-focused', origin === 'touch');
                        this._toggleClass(element, 'cdk-keyboard-focused', origin === 'keyboard');
                        this._toggleClass(element, 'cdk-mouse-focused', origin === 'mouse');
                        this._toggleClass(element, 'cdk-program-focused', origin === 'program');
                    }
                };
                /**
                 * Sets the origin and schedules an async function to clear it at the end of the event queue.
                 * @private
                 * @param {?} origin The origin to set.
                 * @return {?}
                 */
                FocusMonitor.prototype._setOriginForCurrentEventQueue = function (origin) {
                    var _this = this;
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._origin = origin;
                        // Sometimes the focus origin won't be valid in Firefox because Firefox seems to focus *one*
                        // tick after the interaction event fired. To ensure the focus origin is always correct,
                        // the focus origin will be determined at the beginning of the next tick.
                        _this._originTimeoutId = setTimeout(( /**
                         * @return {?}
                         */function () { return _this._origin = null; }), 1);
                    }));
                };
                /**
                 * Checks whether the given focus event was caused by a touchstart event.
                 * @private
                 * @param {?} event The focus event to check.
                 * @return {?} Whether the event was caused by a touch.
                 */
                FocusMonitor.prototype._wasCausedByTouch = function (event) {
                    // Note(mmalerba): This implementation is not quite perfect, there is a small edge case.
                    // Consider the following dom structure:
                    //
                    // <div #parent tabindex="0" cdkFocusClasses>
                    //   <div #child (click)="#parent.focus()"></div>
                    // </div>
                    //
                    // If the user touches the #child element and the #parent is programmatically focused as a
                    // result, this code will still consider it to have been caused by the touch event and will
                    // apply the cdk-touch-focused class rather than the cdk-program-focused class. This is a
                    // relatively small edge-case that can be worked around by using
                    // focusVia(parentEl, 'program') to focus the parent element.
                    //
                    // If we decide that we absolutely must handle this case correctly, we can do so by listening
                    // for the first focus event after the touchstart, and then the first blur event after that
                    // focus event. When that blur event fires we know that whatever follows is not a result of the
                    // touchstart.
                    /** @type {?} */
                    var focusTarget = event.target;
                    return this._lastTouchTarget instanceof Node && focusTarget instanceof Node &&
                        (focusTarget === this._lastTouchTarget || focusTarget.contains(this._lastTouchTarget));
                };
                /**
                 * Handles focus events on a registered element.
                 * @private
                 * @param {?} event The focus event.
                 * @param {?} element The monitored element.
                 * @return {?}
                 */
                FocusMonitor.prototype._onFocus = function (event, element) {
                    // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
                    // focus event affecting the monitored element. If we want to use the origin of the first event
                    // instead we should check for the cdk-focused class here and return if the element already has
                    // it. (This only matters for elements that have includesChildren = true).
                    // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
                    // focus event affecting the monitored element. If we want to use the origin of the first event
                    // instead we should check for the cdk-focused class here and return if the element already has
                    // it. (This only matters for elements that have includesChildren = true).
                    // If we are not counting child-element-focus as focused, make sure that the event target is the
                    // monitored element itself.
                    /** @type {?} */
                    var elementInfo = this._elementInfo.get(element);
                    if (!elementInfo || (!elementInfo.checkChildren && element !== event.target)) {
                        return;
                    }
                    // If we couldn't detect a cause for the focus event, it's due to one of three reasons:
                    // 1) The window has just regained focus, in which case we want to restore the focused state of
                    //    the element from before the window blurred.
                    // 2) It was caused by a touch event, in which case we mark the origin as 'touch'.
                    // 3) The element was programmatically focused, in which case we should mark the origin as
                    //    'program'.
                    /** @type {?} */
                    var origin = this._origin;
                    if (!origin) {
                        if (this._windowFocused && this._lastFocusOrigin) {
                            origin = this._lastFocusOrigin;
                        }
                        else if (this._wasCausedByTouch(event)) {
                            origin = 'touch';
                        }
                        else {
                            origin = 'program';
                        }
                    }
                    this._setClasses(element, origin);
                    this._emitOrigin(elementInfo.subject, origin);
                    this._lastFocusOrigin = origin;
                };
                /**
                 * Handles blur events on a registered element.
                 * @param {?} event The blur event.
                 * @param {?} element The monitored element.
                 * @return {?}
                 */
                FocusMonitor.prototype._onBlur = function (event, element) {
                    // If we are counting child-element-focus as focused, make sure that we aren't just blurring in
                    // order to focus another child of the monitored element.
                    /** @type {?} */
                    var elementInfo = this._elementInfo.get(element);
                    if (!elementInfo || (elementInfo.checkChildren && event.relatedTarget instanceof Node &&
                        element.contains(event.relatedTarget))) {
                        return;
                    }
                    this._setClasses(element);
                    this._emitOrigin(elementInfo.subject, null);
                };
                /**
                 * @private
                 * @param {?} subject
                 * @param {?} origin
                 * @return {?}
                 */
                FocusMonitor.prototype._emitOrigin = function (subject, origin) {
                    this._ngZone.run(( /**
                     * @return {?}
                     */function () { return subject.next(origin); }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                FocusMonitor.prototype._incrementMonitoredElementCount = function () {
                    var _this = this;
                    // Register global listeners when first element is monitored.
                    if (++this._monitoredElementCount == 1 && this._platform.isBrowser) {
                        // Note: we listen to events in the capture phase so we
                        // can detect them even if the user stops propagation.
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            document.addEventListener('keydown', _this._documentKeydownListener, captureEventListenerOptions);
                            document.addEventListener('mousedown', _this._documentMousedownListener, captureEventListenerOptions);
                            document.addEventListener('touchstart', _this._documentTouchstartListener, captureEventListenerOptions);
                            window.addEventListener('focus', _this._windowFocusListener);
                        }));
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                FocusMonitor.prototype._decrementMonitoredElementCount = function () {
                    // Unregister global listeners when last element is unmonitored.
                    if (!--this._monitoredElementCount) {
                        document.removeEventListener('keydown', this._documentKeydownListener, captureEventListenerOptions);
                        document.removeEventListener('mousedown', this._documentMousedownListener, captureEventListenerOptions);
                        document.removeEventListener('touchstart', this._documentTouchstartListener, captureEventListenerOptions);
                        window.removeEventListener('focus', this._windowFocusListener);
                        // Clear timeouts for all potentially pending timeouts to prevent the leaks.
                        clearTimeout(this._windowFocusTimeoutId);
                        clearTimeout(this._touchTimeoutId);
                        clearTimeout(this._originTimeoutId);
                    }
                };
                return FocusMonitor;
            }());
            FocusMonitor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            FocusMonitor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["Platform"] }
            ]; };
            /** @nocollapse */ FocusMonitor.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function FocusMonitor_Factory() { return new FocusMonitor(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["Platform"])); }, token: FocusMonitor, providedIn: "root" });
            /**
             * Directive that determines how a particular element was focused (via keyboard, mouse, touch, or
             * programmatically) and adds corresponding classes to the element.
             *
             * There are two variants of this directive:
             * 1) cdkMonitorElementFocus: does not consider an element to be focused if one of its children is
             *    focused.
             * 2) cdkMonitorSubtreeFocus: considers an element focused if it or any of its children are focused.
             */
            var CdkMonitorFocus = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _focusMonitor
                 */
                function CdkMonitorFocus(_elementRef, _focusMonitor) {
                    var _this = this;
                    this._elementRef = _elementRef;
                    this._focusMonitor = _focusMonitor;
                    this.cdkFocusChange = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    this._monitorSubscription = this._focusMonitor.monitor(this._elementRef, this._elementRef.nativeElement.hasAttribute('cdkMonitorSubtreeFocus'))
                        .subscribe(( /**
                 * @param {?} origin
                 * @return {?}
                 */function (/**
                 * @param {?} origin
                 * @return {?}
                 */ origin) { return _this.cdkFocusChange.emit(origin); }));
                }
                /**
                 * @return {?}
                 */
                CdkMonitorFocus.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this._elementRef);
                    this._monitorSubscription.unsubscribe();
                };
                return CdkMonitorFocus;
            }());
            CdkMonitorFocus.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]',
                        },] },
            ];
            /** @nocollapse */
            CdkMonitorFocus.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: FocusMonitor }
            ]; };
            CdkMonitorFocus.propDecorators = {
                cdkFocusChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"] }]
            };
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} parentDispatcher
             * @param {?} ngZone
             * @param {?} platform
             * @return {?}
             */
            function FOCUS_MONITOR_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
                return parentDispatcher || new FocusMonitor(ngZone, platform);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var FOCUS_MONITOR_PROVIDER = {
                // If there is already a FocusMonitor available, use that. Otherwise, provide a new one.
                provide: FocusMonitor,
                deps: [[new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"](), FocusMonitor], _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"], _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["Platform"]],
                useFactory: FOCUS_MONITOR_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Screenreaders will often fire fake mousedown events when a focusable element
             * is activated using the keyboard. We can typically distinguish between these faked
             * mousedown events and real mousedown events using the "buttons" property. While
             * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
             * the left mouse button), faked mousedowns will usually set the property value to 0.
             * @param {?} event
             * @return {?}
             */
            function isFakeMousedownFromScreenReader(event) {
                return event.buttons === 0;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var A11yModule = /** @class */ (function () {
                function A11yModule() {
                }
                return A11yModule;
            }());
            A11yModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["CommonModule"], _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["PlatformModule"], _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_7__["ObserversModule"]],
                            declarations: [CdkAriaLive, CdkTrapFocus, CdkMonitorFocus],
                            exports: [CdkAriaLive, CdkTrapFocus, CdkMonitorFocus],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=a11y.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/accordion.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/accordion.js ***!
          \********************************************************/
        /*! exports provided: CdkAccordionItem, CdkAccordion, CdkAccordionModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkAccordionItem", function () { return CdkAccordionItem; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkAccordion", function () { return CdkAccordion; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkAccordionModule", function () { return CdkAccordionModule; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to generate unique ID for each accordion.
             * @type {?}
             */
            var nextId = 0;
            /**
             * Directive whose purpose is to manage the expanded state of CdkAccordionItem children.
             */
            var CdkAccordion = /** @class */ (function () {
                function CdkAccordion() {
                    /**
                     * Emits when the state of the accordion changes
                     */
                    this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Stream that emits true/false when openAll/closeAll is triggered.
                     */
                    this._openCloseAllActions = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * A readonly id value to use for unique selection coordination.
                     */
                    this.id = "cdk-accordion-" + nextId++;
                    this._multi = false;
                }
                Object.defineProperty(CdkAccordion.prototype, "multi", {
                    /**
                     * Whether the accordion should allow multiple expanded accordion items simultaneously.
                     * @return {?}
                     */
                    get: function () { return this._multi; },
                    /**
                     * @param {?} multi
                     * @return {?}
                     */
                    set: function (multi) { this._multi = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(multi); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Opens all enabled accordion items in an accordion where multi is enabled.
                 * @return {?}
                 */
                CdkAccordion.prototype.openAll = function () {
                    this._openCloseAll(true);
                };
                /**
                 * Closes all enabled accordion items in an accordion where multi is enabled.
                 * @return {?}
                 */
                CdkAccordion.prototype.closeAll = function () {
                    this._openCloseAll(false);
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                CdkAccordion.prototype.ngOnChanges = function (changes) {
                    this._stateChanges.next(changes);
                };
                /**
                 * @return {?}
                 */
                CdkAccordion.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                /**
                 * @private
                 * @param {?} expanded
                 * @return {?}
                 */
                CdkAccordion.prototype._openCloseAll = function (expanded) {
                    if (this.multi) {
                        this._openCloseAllActions.next(expanded);
                    }
                };
                return CdkAccordion;
            }());
            CdkAccordion.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'cdk-accordion, [cdkAccordion]',
                            exportAs: 'cdkAccordion',
                        },] },
            ];
            CdkAccordion.propDecorators = {
                multi: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to generate unique ID for each accordion item.
             * @type {?}
             */
            var nextId$1 = 0;
            var ɵ0 = undefined;
            /**
             * An basic directive expected to be extended and decorated as a component.  Sets up all
             * events and attributes needed to be managed by a CdkAccordion parent.
             */
            var CdkAccordionItem = /** @class */ (function () {
                /**
                 * @param {?} accordion
                 * @param {?} _changeDetectorRef
                 * @param {?} _expansionDispatcher
                 */
                function CdkAccordionItem(accordion, _changeDetectorRef, _expansionDispatcher) {
                    var _this = this;
                    this.accordion = accordion;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._expansionDispatcher = _expansionDispatcher;
                    /**
                     * Subscription to openAll/closeAll events.
                     */
                    this._openCloseAllSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    /**
                     * Event emitted every time the AccordionItem is closed.
                     */
                    this.closed = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    /**
                     * Event emitted every time the AccordionItem is opened.
                     */
                    this.opened = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    /**
                     * Event emitted when the AccordionItem is destroyed.
                     */
                    this.destroyed = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    /**
                     * Emits whenever the expanded state of the accordion changes.
                     * Primarily used to facilitate two-way binding.
                     * \@docs-private
                     */
                    this.expandedChange = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    /**
                     * The unique AccordionItem id.
                     */
                    this.id = "cdk-accordion-child-" + nextId$1++;
                    this._expanded = false;
                    this._disabled = false;
                    /**
                     * Unregister function for _expansionDispatcher.
                     */
                    this._removeUniqueSelectionListener = ( /**
                     * @return {?}
                     */function () { });
                    this._removeUniqueSelectionListener =
                        _expansionDispatcher.listen(( /**
                         * @param {?} id
                         * @param {?} accordionId
                         * @return {?}
                         */function (id, accordionId) {
                            if (_this.accordion && !_this.accordion.multi &&
                                _this.accordion.id === accordionId && _this.id !== id) {
                                _this.expanded = false;
                            }
                        }));
                    // When an accordion item is hosted in an accordion, subscribe to open/close events.
                    if (this.accordion) {
                        this._openCloseAllSubscription = this._subscribeToOpenCloseAllActions();
                    }
                }
                Object.defineProperty(CdkAccordionItem.prototype, "expanded", {
                    /**
                     * Whether the AccordionItem is expanded.
                     * @return {?}
                     */
                    get: function () { return this._expanded; },
                    /**
                     * @param {?} expanded
                     * @return {?}
                     */
                    set: function (expanded) {
                        expanded = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(expanded);
                        // Only emit events and update the internal value if the value changes.
                        if (this._expanded !== expanded) {
                            this._expanded = expanded;
                            this.expandedChange.emit(expanded);
                            if (expanded) {
                                this.opened.emit();
                                /**
                                 * In the unique selection dispatcher, the id parameter is the id of the CdkAccordionItem,
                                 * the name value is the id of the accordion.
                                 * @type {?}
                                 */
                                var accordionId = this.accordion ? this.accordion.id : this.id;
                                this._expansionDispatcher.notify(this.id, accordionId);
                            }
                            else {
                                this.closed.emit();
                            }
                            // Ensures that the animation will run when the value is set outside of an `@Input`.
                            // This includes cases like the open, close and toggle methods.
                            this._changeDetectorRef.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkAccordionItem.prototype, "disabled", {
                    /**
                     * Whether the AccordionItem is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} disabled
                     * @return {?}
                     */
                    set: function (disabled) { this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(disabled); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Emits an event for the accordion item being destroyed.
                 * @return {?}
                 */
                CdkAccordionItem.prototype.ngOnDestroy = function () {
                    this.opened.complete();
                    this.closed.complete();
                    this.destroyed.emit();
                    this.destroyed.complete();
                    this._removeUniqueSelectionListener();
                    this._openCloseAllSubscription.unsubscribe();
                };
                /**
                 * Toggles the expanded state of the accordion item.
                 * @return {?}
                 */
                CdkAccordionItem.prototype.toggle = function () {
                    if (!this.disabled) {
                        this.expanded = !this.expanded;
                    }
                };
                /**
                 * Sets the expanded state of the accordion item to false.
                 * @return {?}
                 */
                CdkAccordionItem.prototype.close = function () {
                    if (!this.disabled) {
                        this.expanded = false;
                    }
                };
                /**
                 * Sets the expanded state of the accordion item to true.
                 * @return {?}
                 */
                CdkAccordionItem.prototype.open = function () {
                    if (!this.disabled) {
                        this.expanded = true;
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                CdkAccordionItem.prototype._subscribeToOpenCloseAllActions = function () {
                    var _this = this;
                    return this.accordion._openCloseAllActions.subscribe(( /**
                     * @param {?} expanded
                     * @return {?}
                     */function (/**
                     * @param {?} expanded
                     * @return {?}
                     */ expanded) {
                        // Only change expanded state if item is enabled
                        if (!_this.disabled) {
                            _this.expanded = expanded;
                        }
                    }));
                };
                return CdkAccordionItem;
            }());
            CdkAccordionItem.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'cdk-accordion-item, [cdkAccordionItem]',
                            exportAs: 'cdkAccordionItem',
                            providers: [
                                // Provide CdkAccordion as undefined to prevent nested accordion items from registering
                                // to the same accordion.
                                { provide: CdkAccordion, useValue: ɵ0 },
                            ],
                        },] },
            ];
            /** @nocollapse */
            CdkAccordionItem.ctorParameters = function () { return [
                { type: CdkAccordion, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
                { type: _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["UniqueSelectionDispatcher"] }
            ]; };
            CdkAccordionItem.propDecorators = {
                closed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"] }],
                opened: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"] }],
                destroyed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"] }],
                expandedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"] }],
                expanded: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var CdkAccordionModule = /** @class */ (function () {
                function CdkAccordionModule() {
                }
                return CdkAccordionModule;
            }());
            CdkAccordionModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            exports: [CdkAccordion, CdkAccordionItem],
                            declarations: [CdkAccordion, CdkAccordionItem],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=accordion.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/bidi.js": 
        /*!***************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/bidi.js ***!
          \***************************************************/
        /*! exports provided: Directionality, DIR_DOCUMENT, Dir, BidiModule, ɵa */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Directionality", function () { return Directionality; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIR_DOCUMENT", function () { return DIR_DOCUMENT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dir", function () { return Dir; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BidiModule", function () { return BidiModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function () { return DIR_DOCUMENT_FACTORY; });
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token used to inject the document into Directionality.
             * This is used so that the value can be faked in tests.
             *
             * We can't use the real document in tests because changing the real `dir` causes geometry-based
             * tests in Safari to fail.
             *
             * We also can't re-provide the DOCUMENT token from platform-brower because the unit tests
             * themselves use things like `querySelector` in test code.
             *
             * This token is defined in a separate file from Directionality as a workaround for
             * https://github.com/angular/angular/issues/22559
             *
             * \@docs-private
             * @type {?}
             */
            var DIR_DOCUMENT = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('cdk-dir-doc', {
                providedIn: 'root',
                factory: DIR_DOCUMENT_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function DIR_DOCUMENT_FACTORY() {
                return Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The directionality (LTR / RTL) context for the application (or a subtree of it).
             * Exposes the current direction and a stream of direction changes.
             */
            var Directionality = /** @class */ (function () {
                /**
                 * @param {?=} _document
                 */
                function Directionality(_document) {
                    /**
                     * The current 'ltr' or 'rtl' value.
                     */
                    this.value = 'ltr';
                    /**
                     * Stream that emits whenever the 'ltr' / 'rtl' state changes.
                     */
                    this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    if (_document) {
                        // TODO: handle 'auto' value -
                        // We still need to account for dir="auto".
                        // It looks like HTMLElemenet.dir is also "auto" when that's set to the attribute,
                        // but getComputedStyle return either "ltr" or "rtl". avoiding getComputedStyle for now
                        /** @type {?} */
                        var bodyDir = _document.body ? _document.body.dir : null;
                        /** @type {?} */
                        var htmlDir = _document.documentElement ? _document.documentElement.dir : null;
                        /** @type {?} */
                        var value = bodyDir || htmlDir;
                        this.value = (value === 'ltr' || value === 'rtl') ? value : 'ltr';
                    }
                }
                /**
                 * @return {?}
                 */
                Directionality.prototype.ngOnDestroy = function () {
                    this.change.complete();
                };
                return Directionality;
            }());
            Directionality.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            Directionality.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [DIR_DOCUMENT,] }] }
            ]; };
            /** @nocollapse */ Directionality.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function Directionality_Factory() { return new Directionality(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(DIR_DOCUMENT, 8)); }, token: Directionality, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Directive to listen for changes of direction of part of the DOM.
             *
             * Provides itself as Directionality such that descendant directives only need to ever inject
             * Directionality to get the closest direction.
             */
            var Dir = /** @class */ (function () {
                function Dir() {
                    /**
                     * Normalized direction that accounts for invalid/unsupported values.
                     */
                    this._dir = 'ltr';
                    /**
                     * Whether the `value` has been set to its initial value.
                     */
                    this._isInitialized = false;
                    /**
                     * Event emitted when the direction changes.
                     */
                    this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                }
                Object.defineProperty(Dir.prototype, "dir", {
                    /**
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this._dir; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var old = this._dir;
                        /** @type {?} */
                        var normalizedValue = value ? value.toLowerCase() : value;
                        this._rawDir = value;
                        this._dir = (normalizedValue === 'ltr' || normalizedValue === 'rtl') ? normalizedValue : 'ltr';
                        if (old !== this._dir && this._isInitialized) {
                            this.change.emit(this._dir);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Dir.prototype, "value", {
                    /**
                     * Current layout direction of the element.
                     * @return {?}
                     */
                    get: function () { return this.dir; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Initialize once default value has been set.
                 * @return {?}
                 */
                Dir.prototype.ngAfterContentInit = function () {
                    this._isInitialized = true;
                };
                /**
                 * @return {?}
                 */
                Dir.prototype.ngOnDestroy = function () {
                    this.change.complete();
                };
                return Dir;
            }());
            Dir.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[dir]',
                            providers: [{ provide: Directionality, useExisting: Dir }],
                            host: { '[attr.dir]': '_rawDir' },
                            exportAs: 'dir',
                        },] },
            ];
            Dir.propDecorators = {
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['dirChange',] }],
                dir: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var BidiModule = /** @class */ (function () {
                function BidiModule() {
                }
                return BidiModule;
            }());
            BidiModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            exports: [Dir],
                            declarations: [Dir],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=bidi.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/cdk.js": 
        /*!**************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/cdk.js ***!
          \**************************************************/
        /*! exports provided: VERSION */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Current version of the Angular Component Development Kit.
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Version"]('8.2.3');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=cdk.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/coercion.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/coercion.js ***!
          \*******************************************************/
        /*! exports provided: coerceBooleanProperty, coerceNumberProperty, _isNumberValue, coerceArray, coerceCssPixelValue, coerceElement */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coerceBooleanProperty", function () { return coerceBooleanProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coerceNumberProperty", function () { return coerceNumberProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_isNumberValue", function () { return _isNumberValue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coerceArray", function () { return coerceArray; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coerceCssPixelValue", function () { return coerceCssPixelValue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coerceElement", function () { return coerceElement; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Coerces a data-bound value (typically a string) to a boolean.
             * @param {?} value
             * @return {?}
             */
            function coerceBooleanProperty(value) {
                return value != null && "" + value !== 'false';
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} value
             * @param {?=} fallbackValue
             * @return {?}
             */
            function coerceNumberProperty(value, fallbackValue) {
                if (fallbackValue === void 0) { fallbackValue = 0; }
                return _isNumberValue(value) ? Number(value) : fallbackValue;
            }
            /**
             * Whether the provided value is considered a number.
             * \@docs-private
             * @param {?} value
             * @return {?}
             */
            function _isNumberValue(value) {
                // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
                // and other non-number values as NaN, where Number just uses 0) but it considers the string
                // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
                return !isNaN(parseFloat(( /** @type {?} */(value)))) && !isNaN(Number(value));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Wraps the provided value in an array, unless the provided value is an array.
             * @template T
             * @param {?} value
             * @return {?}
             */
            function coerceArray(value) {
                return Array.isArray(value) ? value : [value];
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Coerces a value to a CSS pixel value.
             * @param {?} value
             * @return {?}
             */
            function coerceCssPixelValue(value) {
                if (value == null) {
                    return '';
                }
                return typeof value === 'string' ? value : value + "px";
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Coerces an ElementRef or an Element into an element.
             * Useful for APIs that can accept either a ref or the native element itself.
             * @template T
             * @param {?} elementOrRef
             * @return {?}
             */
            function coerceElement(elementOrRef) {
                return elementOrRef instanceof _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] ? elementOrRef.nativeElement : elementOrRef;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=coercion.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/collections.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/collections.js ***!
          \**********************************************************/
        /*! exports provided: UniqueSelectionDispatcher, ArrayDataSource, isDataSource, DataSource, getMultipleValuesInSingleSelectionError, SelectionModel */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniqueSelectionDispatcher", function () { return UniqueSelectionDispatcher; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayDataSource", function () { return ArrayDataSource; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDataSource", function () { return isDataSource; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataSource", function () { return DataSource; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMultipleValuesInSingleSelectionError", function () { return getMultipleValuesInSingleSelectionError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionModel", function () { return SelectionModel; });
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @abstract
             * @template T
             */
            var DataSource = /** @class */ (function () {
                function DataSource() {
                }
                return DataSource;
            }());
            /**
             * Checks whether an object is a data source.
             * @param {?} value
             * @return {?}
             */
            function isDataSource(value) {
                // Check if the value is a DataSource by observing if it has a connect function. Cannot
                // be checked as an `instanceof DataSource` since people could create their own sources
                // that match the interface, but don't extend DataSource.
                return value && typeof value.connect === 'function';
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * DataSource wrapper for a native array.
             * @template T
             */
            var ArrayDataSource = /** @class */ (function (_super_1) {
                __extends(ArrayDataSource, _super_1);
                /**
                 * @param {?} _data
                 */
                function ArrayDataSource(_data) {
                    var _this = _super_1.call(this) || this;
                    _this._data = _data;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                ArrayDataSource.prototype.connect = function () {
                    return this._data instanceof rxjs__WEBPACK_IMPORTED_MODULE_0__["Observable"] ? this._data : Object(rxjs__WEBPACK_IMPORTED_MODULE_0__["of"])(this._data);
                };
                /**
                 * @return {?}
                 */
                ArrayDataSource.prototype.disconnect = function () { };
                return ArrayDataSource;
            }(DataSource));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Class to be used to power selecting one or more options from a list.
             * @template T
             */
            var SelectionModel = /** @class */ (function () {
                /**
                 * @param {?=} _multiple
                 * @param {?=} initiallySelectedValues
                 * @param {?=} _emitChanges
                 */
                function SelectionModel(_multiple, initiallySelectedValues, _emitChanges) {
                    var _this = this;
                    if (_multiple === void 0) { _multiple = false; }
                    if (_emitChanges === void 0) { _emitChanges = true; }
                    this._multiple = _multiple;
                    this._emitChanges = _emitChanges;
                    /**
                     * Currently-selected values.
                     */
                    this._selection = new Set();
                    /**
                     * Keeps track of the deselected options that haven't been emitted by the change event.
                     */
                    this._deselectedToEmit = [];
                    /**
                     * Keeps track of the selected options that haven't been emitted by the change event.
                     */
                    this._selectedToEmit = [];
                    /**
                     * Event emitted when the value has changed.
                     */
                    this.changed = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    /**
                     * Event emitted when the value has changed.
                     * @deprecated Use `changed` instead.
                     * \@breaking-change 8.0.0 To be changed to `changed`
                     */
                    this.onChange = this.changed;
                    if (initiallySelectedValues && initiallySelectedValues.length) {
                        if (_multiple) {
                            initiallySelectedValues.forEach(( /**
                             * @param {?} value
                             * @return {?}
                             */function (/**
                             * @param {?} value
                             * @return {?}
                             */ value) { return _this._markSelected(value); }));
                        }
                        else {
                            this._markSelected(initiallySelectedValues[0]);
                        }
                        // Clear the array in order to avoid firing the change event for preselected values.
                        this._selectedToEmit.length = 0;
                    }
                }
                Object.defineProperty(SelectionModel.prototype, "selected", {
                    /**
                     * Selected values.
                     * @return {?}
                     */
                    get: function () {
                        if (!this._selected) {
                            this._selected = Array.from(this._selection.values());
                        }
                        return this._selected;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Selects a value or an array of values.
                 * @param {...?} values
                 * @return {?}
                 */
                SelectionModel.prototype.select = function () {
                    var _this = this;
                    var values = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        values[_c] = arguments[_c];
                    }
                    this._verifyValueAssignment(values);
                    values.forEach(( /**
                     * @param {?} value
                     * @return {?}
                     */function (/**
                     * @param {?} value
                     * @return {?}
                     */ value) { return _this._markSelected(value); }));
                    this._emitChangeEvent();
                };
                /**
                 * Deselects a value or an array of values.
                 * @param {...?} values
                 * @return {?}
                 */
                SelectionModel.prototype.deselect = function () {
                    var _this = this;
                    var values = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        values[_c] = arguments[_c];
                    }
                    this._verifyValueAssignment(values);
                    values.forEach(( /**
                     * @param {?} value
                     * @return {?}
                     */function (/**
                     * @param {?} value
                     * @return {?}
                     */ value) { return _this._unmarkSelected(value); }));
                    this._emitChangeEvent();
                };
                /**
                 * Toggles a value between selected and deselected.
                 * @param {?} value
                 * @return {?}
                 */
                SelectionModel.prototype.toggle = function (value) {
                    this.isSelected(value) ? this.deselect(value) : this.select(value);
                };
                /**
                 * Clears all of the selected values.
                 * @return {?}
                 */
                SelectionModel.prototype.clear = function () {
                    this._unmarkAll();
                    this._emitChangeEvent();
                };
                /**
                 * Determines whether a value is selected.
                 * @param {?} value
                 * @return {?}
                 */
                SelectionModel.prototype.isSelected = function (value) {
                    return this._selection.has(value);
                };
                /**
                 * Determines whether the model does not have a value.
                 * @return {?}
                 */
                SelectionModel.prototype.isEmpty = function () {
                    return this._selection.size === 0;
                };
                /**
                 * Determines whether the model has a value.
                 * @return {?}
                 */
                SelectionModel.prototype.hasValue = function () {
                    return !this.isEmpty();
                };
                /**
                 * Sorts the selected values based on a predicate function.
                 * @param {?=} predicate
                 * @return {?}
                 */
                SelectionModel.prototype.sort = function (predicate) {
                    if (this._multiple && this.selected) {
                        ( /** @type {?} */(this._selected)).sort(predicate);
                    }
                };
                /**
                 * Gets whether multiple values can be selected.
                 * @return {?}
                 */
                SelectionModel.prototype.isMultipleSelection = function () {
                    return this._multiple;
                };
                /**
                 * Emits a change event and clears the records of selected and deselected values.
                 * @private
                 * @return {?}
                 */
                SelectionModel.prototype._emitChangeEvent = function () {
                    // Clear the selected values so they can be re-cached.
                    this._selected = null;
                    if (this._selectedToEmit.length || this._deselectedToEmit.length) {
                        this.changed.next({
                            source: this,
                            added: this._selectedToEmit,
                            removed: this._deselectedToEmit
                        });
                        this._deselectedToEmit = [];
                        this._selectedToEmit = [];
                    }
                };
                /**
                 * Selects a value.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                SelectionModel.prototype._markSelected = function (value) {
                    if (!this.isSelected(value)) {
                        if (!this._multiple) {
                            this._unmarkAll();
                        }
                        this._selection.add(value);
                        if (this._emitChanges) {
                            this._selectedToEmit.push(value);
                        }
                    }
                };
                /**
                 * Deselects a value.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                SelectionModel.prototype._unmarkSelected = function (value) {
                    if (this.isSelected(value)) {
                        this._selection.delete(value);
                        if (this._emitChanges) {
                            this._deselectedToEmit.push(value);
                        }
                    }
                };
                /**
                 * Clears out the selected values.
                 * @private
                 * @return {?}
                 */
                SelectionModel.prototype._unmarkAll = function () {
                    var _this = this;
                    if (!this.isEmpty()) {
                        this._selection.forEach(( /**
                         * @param {?} value
                         * @return {?}
                         */function (/**
                         * @param {?} value
                         * @return {?}
                         */ value) { return _this._unmarkSelected(value); }));
                    }
                };
                /**
                 * Verifies the value assignment and throws an error if the specified value array is
                 * including multiple values while the selection model is not supporting multiple values.
                 * @private
                 * @param {?} values
                 * @return {?}
                 */
                SelectionModel.prototype._verifyValueAssignment = function (values) {
                    if (values.length > 1 && !this._multiple) {
                        throw getMultipleValuesInSingleSelectionError();
                    }
                };
                return SelectionModel;
            }());
            /**
             * Returns an error that reports that multiple values are passed into a selection model
             * with a single value.
             * \@docs-private
             * @return {?}
             */
            function getMultipleValuesInSingleSelectionError() {
                return Error('Cannot pass multiple values into SelectionModel with single-value mode.');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Class to coordinate unique selection based on name.
             * Intended to be consumed as an Angular service.
             * This service is needed because native radio change events are only fired on the item currently
             * being selected, and we still need to uncheck the previous selection.
             *
             * This service does not *store* any IDs and names because they may change at any time, so it is
             * less error-prone if they are simply passed through when the events occur.
             */
            var UniqueSelectionDispatcher = /** @class */ (function () {
                function UniqueSelectionDispatcher() {
                    this._listeners = [];
                }
                /**
                 * Notify other items that selection for the given name has been set.
                 * @param {?} id ID of the item.
                 * @param {?} name Name of the item.
                 * @return {?}
                 */
                UniqueSelectionDispatcher.prototype.notify = function (id, name) {
                    for (var _c = 0, _d = this._listeners; _c < _d.length; _c++) {
                        var listener = _d[_c];
                        listener(id, name);
                    }
                };
                /**
                 * Listen for future changes to item selection.
                 * @param {?} listener
                 * @return {?} Function used to deregister listener
                 */
                UniqueSelectionDispatcher.prototype.listen = function (listener) {
                    var _this = this;
                    this._listeners.push(listener);
                    return ( /**
                     * @return {?}
                     */function () {
                        _this._listeners = _this._listeners.filter(( /**
                         * @param {?} registered
                         * @return {?}
                         */function (registered) {
                            return listener !== registered;
                        }));
                    });
                };
                /**
                 * @return {?}
                 */
                UniqueSelectionDispatcher.prototype.ngOnDestroy = function () {
                    this._listeners = [];
                };
                return UniqueSelectionDispatcher;
            }());
            UniqueSelectionDispatcher.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ UniqueSelectionDispatcher.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function UniqueSelectionDispatcher_Factory() { return new UniqueSelectionDispatcher(); }, token: UniqueSelectionDispatcher, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=collections.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/drag-drop.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/drag-drop.js ***!
          \********************************************************/
        /*! exports provided: DragDrop, DragRef, DropListRef, CdkDropList, CDK_DROP_LIST, CDK_DROP_LIST_CONTAINER, moveItemInArray, transferArrayItem, copyArrayItem, DragDropModule, DragDropRegistry, CdkDropListGroup, CDK_DRAG_CONFIG_FACTORY, CDK_DRAG_CONFIG, CdkDrag, CdkDragHandle, CdkDragPreview, CdkDragPlaceholder, ɵb */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDrop", function () { return DragDrop; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragRef", function () { return DragRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropListRef", function () { return DropListRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkDropList", function () { return CdkDropList; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DROP_LIST", function () { return CDK_DROP_LIST; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DROP_LIST_CONTAINER", function () { return CDK_DROP_LIST_CONTAINER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moveItemInArray", function () { return moveItemInArray; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transferArrayItem", function () { return transferArrayItem; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyArrayItem", function () { return copyArrayItem; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropModule", function () { return DragDropModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropRegistry", function () { return DragDropRegistry; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkDropListGroup", function () { return CdkDropListGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DRAG_CONFIG_FACTORY", function () { return CDK_DRAG_CONFIG_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DRAG_CONFIG", function () { return CDK_DRAG_CONFIG; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkDrag", function () { return CdkDrag; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkDragHandle", function () { return CdkDragHandle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkDragPreview", function () { return CdkDragPreview; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkDragPlaceholder", function () { return CdkDragPlaceholder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function () { return CDK_DRAG_PARENT; });
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Shallow-extends a stylesheet object with another stylesheet object.
             * \@docs-private
             * @param {?} dest
             * @param {?} source
             * @return {?}
             */
            function extendStyles(dest, source) {
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        dest[key] = ( /** @type {?} */(source[key]));
                    }
                }
                return dest;
            }
            /**
             * Toggles whether the native drag interactions should be enabled for an element.
             * \@docs-private
             * @param {?} element Element on which to toggle the drag interactions.
             * @param {?} enable Whether the drag interactions should be enabled.
             * @return {?}
             */
            function toggleNativeDragInteractions(element, enable) {
                /** @type {?} */
                var userSelect = enable ? '' : 'none';
                extendStyles(element.style, {
                    touchAction: enable ? '' : 'none',
                    webkitUserDrag: enable ? '' : 'none',
                    webkitTapHighlightColor: enable ? '' : 'transparent',
                    userSelect: userSelect,
                    msUserSelect: userSelect,
                    webkitUserSelect: userSelect,
                    MozUserSelect: userSelect
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Parses a CSS time value to milliseconds.
             * @param {?} value
             * @return {?}
             */
            function parseCssTimeUnitsToMs(value) {
                // Some browsers will return it in seconds, whereas others will return milliseconds.
                /** @type {?} */
                var multiplier = value.toLowerCase().indexOf('ms') > -1 ? 1 : 1000;
                return parseFloat(value) * multiplier;
            }
            /**
             * Gets the transform transition duration, including the delay, of an element in milliseconds.
             * @param {?} element
             * @return {?}
             */
            function getTransformTransitionDurationInMs(element) {
                /** @type {?} */
                var computedStyle = getComputedStyle(element);
                /** @type {?} */
                var transitionedProperties = parseCssPropertyValue(computedStyle, 'transition-property');
                /** @type {?} */
                var property = transitionedProperties.find(( /**
                 * @param {?} prop
                 * @return {?}
                 */function (/**
                 * @param {?} prop
                 * @return {?}
                 */ prop) { return prop === 'transform' || prop === 'all'; }));
                // If there's no transition for `all` or `transform`, we shouldn't do anything.
                if (!property) {
                    return 0;
                }
                // Get the index of the property that we're interested in and match
                // it up to the same index in `transition-delay` and `transition-duration`.
                /** @type {?} */
                var propertyIndex = transitionedProperties.indexOf(property);
                /** @type {?} */
                var rawDurations = parseCssPropertyValue(computedStyle, 'transition-duration');
                /** @type {?} */
                var rawDelays = parseCssPropertyValue(computedStyle, 'transition-delay');
                return parseCssTimeUnitsToMs(rawDurations[propertyIndex]) +
                    parseCssTimeUnitsToMs(rawDelays[propertyIndex]);
            }
            /**
             * Parses out multiple values from a computed style into an array.
             * @param {?} computedStyle
             * @param {?} name
             * @return {?}
             */
            function parseCssPropertyValue(computedStyle, name) {
                /** @type {?} */
                var value = computedStyle.getPropertyValue(name);
                return value.split(',').map(( /**
                 * @param {?} part
                 * @return {?}
                 */function (/**
                 * @param {?} part
                 * @return {?}
                 */ part) { return part.trim(); }));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Options that can be used to bind a passive event listener.
             * @type {?}
             */
            var passiveEventListenerOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["normalizePassiveListenerOptions"])({ passive: true });
            /**
             * Options that can be used to bind an active event listener.
             * @type {?}
             */
            var activeEventListenerOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["normalizePassiveListenerOptions"])({ passive: false });
            /**
             * Time in milliseconds for which to ignore mouse events, after
             * receiving a touch event. Used to avoid doing double work for
             * touch devices where the browser fires fake mouse events, in
             * addition to touch events.
             * @type {?}
             */
            var MOUSE_EVENT_IGNORE_TIME = 800;
            /**
             * Reference to a draggable item. Used to manipulate or dispose of the item.
             * \@docs-private
             * @template T
             */
            var DragRef = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?} _config
                 * @param {?} _document
                 * @param {?} _ngZone
                 * @param {?} _viewportRuler
                 * @param {?} _dragDropRegistry
                 */
                function DragRef(element, _config, _document, _ngZone, _viewportRuler, _dragDropRegistry) {
                    var _this = this;
                    this._config = _config;
                    this._document = _document;
                    this._ngZone = _ngZone;
                    this._viewportRuler = _viewportRuler;
                    this._dragDropRegistry = _dragDropRegistry;
                    /**
                     * CSS `transform` applied to the element when it isn't being dragged. We need a
                     * passive transform in order for the dragged element to retain its new position
                     * after the user has stopped dragging and because we need to know the relative
                     * position in case they start dragging again. This corresponds to `element.style.transform`.
                     */
                    this._passiveTransform = { x: 0, y: 0 };
                    /**
                     * CSS `transform` that is applied to the element while it's being dragged.
                     */
                    this._activeTransform = { x: 0, y: 0 };
                    /**
                     * Emits when the item is being moved.
                     */
                    this._moveEvents = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Subscription to pointer movement events.
                     */
                    this._pointerMoveSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    /**
                     * Subscription to the event that is dispatched when the user lifts their pointer.
                     */
                    this._pointerUpSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    /**
                     * Subscription to the viewport being scrolled.
                     */
                    this._scrollSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    /**
                     * Subscription to the viewport being resized.
                     */
                    this._resizeSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    /**
                     * Cached reference to the boundary element.
                     */
                    this._boundaryElement = null;
                    /**
                     * Whether the native dragging interactions have been enabled on the root element.
                     */
                    this._nativeInteractionsEnabled = true;
                    /**
                     * Elements that can be used to drag the draggable item.
                     */
                    this._handles = [];
                    /**
                     * Registered handles that are currently disabled.
                     */
                    this._disabledHandles = new Set();
                    /**
                     * Layout direction of the item.
                     */
                    this._direction = 'ltr';
                    /**
                     * Amount of milliseconds to wait after the user has put their
                     * pointer down before starting to drag the element.
                     */
                    this.dragStartDelay = 0;
                    this._disabled = false;
                    /**
                     * Emits as the drag sequence is being prepared.
                     */
                    this.beforeStarted = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user starts dragging the item.
                     */
                    this.started = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user has released a drag item, before any animations have started.
                     */
                    this.released = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user stops dragging an item in the container.
                     */
                    this.ended = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user has moved the item into a new container.
                     */
                    this.entered = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user removes the item its container by dragging it into another container.
                     */
                    this.exited = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user drops the item inside a container.
                     */
                    this.dropped = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits as the user is dragging the item. Use with caution,
                     * because this event will fire for every pixel that the user has dragged.
                     */
                    this.moved = this._moveEvents.asObservable();
                    /**
                     * Handler for the `mousedown`/`touchstart` events.
                     */
                    this._pointerDown = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        _this.beforeStarted.next();
                        // Delegate the event based on whether it started from a handle or the element itself.
                        if (_this._handles.length) {
                            /** @type {?} */
                            var targetHandle = _this._handles.find(( /**
                             * @param {?} handle
                             * @return {?}
                             */function (/**
                             * @param {?} handle
                             * @return {?}
                             */ handle) {
                                /** @type {?} */
                                var target = event.target;
                                return !!target && (target === handle || handle.contains(( /** @type {?} */(target))));
                            }));
                            if (targetHandle && !_this._disabledHandles.has(targetHandle) && !_this.disabled) {
                                _this._initializeDragSequence(targetHandle, event);
                            }
                        }
                        else if (!_this.disabled) {
                            _this._initializeDragSequence(_this._rootElement, event);
                        }
                    });
                    /**
                     * Handler that is invoked when the user moves their pointer after they've initiated a drag.
                     */
                    this._pointerMove = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        if (!_this._hasStartedDragging) {
                            /** @type {?} */
                            var pointerPosition = _this._getPointerPositionOnPage(event);
                            /** @type {?} */
                            var distanceX = Math.abs(pointerPosition.x - _this._pickupPositionOnPage.x);
                            /** @type {?} */
                            var distanceY = Math.abs(pointerPosition.y - _this._pickupPositionOnPage.y);
                            /** @type {?} */
                            var isOverThreshold = distanceX + distanceY >= _this._config.dragStartThreshold;
                            // Only start dragging after the user has moved more than the minimum distance in either
                            // direction. Note that this is preferrable over doing something like `skip(minimumDistance)`
                            // in the `pointerMove` subscription, because we're not guaranteed to have one move event
                            // per pixel of movement (e.g. if the user moves their pointer quickly).
                            if (isOverThreshold) {
                                /** @type {?} */
                                var isDelayElapsed = Date.now() >= _this._dragStartTime + (_this.dragStartDelay || 0);
                                if (!isDelayElapsed) {
                                    _this._endDragSequence(event);
                                    return;
                                }
                                // Prevent other drag sequences from starting while something in the container is still
                                // being dragged. This can happen while we're waiting for the drop animation to finish
                                // and can cause errors, because some elements might still be moving around.
                                if (!_this._dropContainer || !_this._dropContainer.isDragging()) {
                                    _this._hasStartedDragging = true;
                                    _this._ngZone.run(( /**
                                     * @return {?}
                                     */function () { return _this._startDragSequence(event); }));
                                }
                            }
                            return;
                        }
                        // We only need the preview dimensions if we have a boundary element.
                        if (_this._boundaryElement) {
                            // Cache the preview element rect if we haven't cached it already or if
                            // we cached it too early before the element dimensions were computed.
                            if (!_this._previewRect || (!_this._previewRect.width && !_this._previewRect.height)) {
                                _this._previewRect = (_this._preview || _this._rootElement).getBoundingClientRect();
                            }
                        }
                        /** @type {?} */
                        var constrainedPointerPosition = _this._getConstrainedPointerPosition(event);
                        _this._hasMoved = true;
                        event.preventDefault();
                        _this._updatePointerDirectionDelta(constrainedPointerPosition);
                        if (_this._dropContainer) {
                            _this._updateActiveDropContainer(constrainedPointerPosition);
                        }
                        else {
                            /** @type {?} */
                            var activeTransform = _this._activeTransform;
                            activeTransform.x =
                                constrainedPointerPosition.x - _this._pickupPositionOnPage.x + _this._passiveTransform.x;
                            activeTransform.y =
                                constrainedPointerPosition.y - _this._pickupPositionOnPage.y + _this._passiveTransform.y;
                            _this._applyRootElementTransform(activeTransform.x, activeTransform.y);
                            // Apply transform as attribute if dragging and svg element to work for IE
                            if (typeof SVGElement !== 'undefined' && _this._rootElement instanceof SVGElement) {
                                /** @type {?} */
                                var appliedTransform = "translate(" + activeTransform.x + " " + activeTransform.y + ")";
                                _this._rootElement.setAttribute('transform', appliedTransform);
                            }
                        }
                        // Since this event gets fired for every pixel while dragging, we only
                        // want to fire it if the consumer opted into it. Also we have to
                        // re-enter the zone because we run all of the events on the outside.
                        if (_this._moveEvents.observers.length) {
                            _this._ngZone.run(( /**
                             * @return {?}
                             */function () {
                                _this._moveEvents.next({
                                    source: _this,
                                    pointerPosition: constrainedPointerPosition,
                                    event: event,
                                    distance: _this._getDragDistance(constrainedPointerPosition),
                                    delta: _this._pointerDirectionDelta
                                });
                            }));
                        }
                    });
                    /**
                     * Handler that is invoked when the user lifts their pointer up, after initiating a drag.
                     */
                    this._pointerUp = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        _this._endDragSequence(event);
                    });
                    this.withRootElement(element);
                    _dragDropRegistry.registerDragItem(this);
                }
                Object.defineProperty(DragRef.prototype, "disabled", {
                    /**
                     * Whether starting to drag this element is disabled.
                     * @return {?}
                     */
                    get: function () {
                        return this._disabled || !!(this._dropContainer && this._dropContainer.disabled);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        if (newValue !== this._disabled) {
                            this._disabled = newValue;
                            this._toggleNativeDragInteractions();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Returns the element that is being used as a placeholder
                 * while the current element is being dragged.
                 * @return {?}
                 */
                DragRef.prototype.getPlaceholderElement = function () {
                    return this._placeholder;
                };
                /**
                 * Returns the root draggable element.
                 * @return {?}
                 */
                DragRef.prototype.getRootElement = function () {
                    return this._rootElement;
                };
                /**
                 * Registers the handles that can be used to drag the element.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} handles
                 * @return {THIS}
                 */
                DragRef.prototype.withHandles = function (handles) {
                    ( /** @type {?} */(this))._handles = handles.map(( /**
                     * @param {?} handle
                     * @return {?}
                     */function (/**
                     * @param {?} handle
                     * @return {?}
                     */ handle) { return Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(handle); }));
                    ( /** @type {?} */(this))._handles.forEach(( /**
                     * @param {?} handle
                     * @return {?}
                     */function (/**
                     * @param {?} handle
                     * @return {?}
                     */ handle) { return toggleNativeDragInteractions(handle, false); }));
                    ( /** @type {?} */(this))._toggleNativeDragInteractions();
                    return ( /** @type {?} */(this));
                };
                /**
                 * Registers the template that should be used for the drag preview.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} template Template that from which to stamp out the preview.
                 * @return {THIS}
                 */
                DragRef.prototype.withPreviewTemplate = function (template) {
                    ( /** @type {?} */(this))._previewTemplate = template;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Registers the template that should be used for the drag placeholder.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} template Template that from which to stamp out the placeholder.
                 * @return {THIS}
                 */
                DragRef.prototype.withPlaceholderTemplate = function (template) {
                    ( /** @type {?} */(this))._placeholderTemplate = template;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets an alternate drag root element. The root element is the element that will be moved as
                 * the user is dragging. Passing an alternate root element is useful when trying to enable
                 * dragging on an element that you might not have access to.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} rootElement
                 * @return {THIS}
                 */
                DragRef.prototype.withRootElement = function (rootElement) {
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(rootElement);
                    if (element !== ( /** @type {?} */(this))._rootElement) {
                        if (( /** @type {?} */(this))._rootElement) {
                            ( /** @type {?} */(this))._removeRootElementListeners(( /** @type {?} */(this))._rootElement);
                        }
                        element.addEventListener('mousedown', ( /** @type {?} */(this))._pointerDown, activeEventListenerOptions);
                        element.addEventListener('touchstart', ( /** @type {?} */(this))._pointerDown, passiveEventListenerOptions);
                        ( /** @type {?} */(this))._initialTransform = undefined;
                        ( /** @type {?} */(this))._rootElement = element;
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Element to which the draggable's position will be constrained.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} boundaryElement
                 * @return {THIS}
                 */
                DragRef.prototype.withBoundaryElement = function (boundaryElement) {
                    var _this = this;
                    ( /** @type {?} */(this))._boundaryElement = boundaryElement ? Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(boundaryElement) : null;
                    ( /** @type {?} */(this))._resizeSubscription.unsubscribe();
                    if (boundaryElement) {
                        ( /** @type {?} */(this))._resizeSubscription = ( /** @type {?} */(this))._viewportRuler
                            .change(10)
                            .subscribe(( /**
                     * @return {?}
                     */function () { return ( /** @type {?} */(_this))._containInsideBoundaryOnResize(); }));
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Removes the dragging functionality from the DOM element.
                 * @return {?}
                 */
                DragRef.prototype.dispose = function () {
                    this._removeRootElementListeners(this._rootElement);
                    // Do this check before removing from the registry since it'll
                    // stop being considered as dragged once it is removed.
                    if (this.isDragging()) {
                        // Since we move out the element to the end of the body while it's being
                        // dragged, we have to make sure that it's removed if it gets destroyed.
                        removeElement(this._rootElement);
                    }
                    this._destroyPreview();
                    this._destroyPlaceholder();
                    this._dragDropRegistry.removeDragItem(this);
                    this._removeSubscriptions();
                    this.beforeStarted.complete();
                    this.started.complete();
                    this.released.complete();
                    this.ended.complete();
                    this.entered.complete();
                    this.exited.complete();
                    this.dropped.complete();
                    this._moveEvents.complete();
                    this._handles = [];
                    this._disabledHandles.clear();
                    this._dropContainer = undefined;
                    this._boundaryElement = this._rootElement = this._placeholderTemplate =
                        this._previewTemplate = this._nextSibling = ( /** @type {?} */(null));
                };
                /**
                 * Checks whether the element is currently being dragged.
                 * @return {?}
                 */
                DragRef.prototype.isDragging = function () {
                    return this._hasStartedDragging && this._dragDropRegistry.isDragging(this);
                };
                /**
                 * Resets a standalone drag item to its initial position.
                 * @return {?}
                 */
                DragRef.prototype.reset = function () {
                    this._rootElement.style.transform = this._initialTransform || '';
                    this._activeTransform = { x: 0, y: 0 };
                    this._passiveTransform = { x: 0, y: 0 };
                };
                /**
                 * Sets a handle as disabled. While a handle is disabled, it'll capture and interrupt dragging.
                 * @param {?} handle Handle element that should be disabled.
                 * @return {?}
                 */
                DragRef.prototype.disableHandle = function (handle) {
                    if (this._handles.indexOf(handle) > -1) {
                        this._disabledHandles.add(handle);
                    }
                };
                /**
                 * Enables a handle, if it has been disabled.
                 * @param {?} handle Handle element to be enabled.
                 * @return {?}
                 */
                DragRef.prototype.enableHandle = function (handle) {
                    this._disabledHandles.delete(handle);
                };
                /**
                 * Sets the layout direction of the draggable item.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} direction
                 * @return {THIS}
                 */
                DragRef.prototype.withDirection = function (direction) {
                    ( /** @type {?} */(this))._direction = direction;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the container that the item is part of.
                 * @param {?} container
                 * @return {?}
                 */
                DragRef.prototype._withDropContainer = function (container) {
                    this._dropContainer = container;
                };
                /**
                 * Gets the current position in pixels the draggable outside of a drop container.
                 * @return {?}
                 */
                DragRef.prototype.getFreeDragPosition = function () {
                    /** @type {?} */
                    var position = this.isDragging() ? this._activeTransform : this._passiveTransform;
                    return { x: position.x, y: position.y };
                };
                /**
                 * Sets the current position in pixels the draggable outside of a drop container.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} value New position to be set.
                 * @return {THIS}
                 */
                DragRef.prototype.setFreeDragPosition = function (value) {
                    ( /** @type {?} */(this))._activeTransform = { x: 0, y: 0 };
                    ( /** @type {?} */(this))._passiveTransform.x = value.x;
                    ( /** @type {?} */(this))._passiveTransform.y = value.y;
                    if (!( /** @type {?} */(this))._dropContainer) {
                        ( /** @type {?} */(this))._applyRootElementTransform(value.x, value.y);
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Updates the item's sort order based on the last-known pointer position.
                 * @return {?}
                 */
                DragRef.prototype._sortFromLastPointerPosition = function () {
                    /** @type {?} */
                    var position = this._pointerPositionAtLastDirectionChange;
                    if (position && this._dropContainer) {
                        this._updateActiveDropContainer(position);
                    }
                };
                /**
                 * Unsubscribes from the global subscriptions.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._removeSubscriptions = function () {
                    this._pointerMoveSubscription.unsubscribe();
                    this._pointerUpSubscription.unsubscribe();
                    this._scrollSubscription.unsubscribe();
                };
                /**
                 * Destroys the preview element and its ViewRef.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._destroyPreview = function () {
                    if (this._preview) {
                        removeElement(this._preview);
                    }
                    if (this._previewRef) {
                        this._previewRef.destroy();
                    }
                    this._preview = this._previewRef = ( /** @type {?} */(null));
                };
                /**
                 * Destroys the placeholder element and its ViewRef.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._destroyPlaceholder = function () {
                    if (this._placeholder) {
                        removeElement(this._placeholder);
                    }
                    if (this._placeholderRef) {
                        this._placeholderRef.destroy();
                    }
                    this._placeholder = this._placeholderRef = ( /** @type {?} */(null));
                };
                /**
                 * Clears subscriptions and stops the dragging sequence.
                 * @private
                 * @param {?} event Browser event object that ended the sequence.
                 * @return {?}
                 */
                DragRef.prototype._endDragSequence = function (event) {
                    var _this = this;
                    // Note that here we use `isDragging` from the service, rather than from `this`.
                    // The difference is that the one from the service reflects whether a dragging sequence
                    // has been initiated, whereas the one on `this` includes whether the user has passed
                    // the minimum dragging threshold.
                    if (!this._dragDropRegistry.isDragging(this)) {
                        return;
                    }
                    this._removeSubscriptions();
                    this._dragDropRegistry.stopDragging(this);
                    this._toggleNativeDragInteractions();
                    if (this._handles) {
                        this._rootElement.style.webkitTapHighlightColor = this._rootElementTapHighlight;
                    }
                    if (!this._hasStartedDragging) {
                        return;
                    }
                    this.released.next({ source: this });
                    if (this._dropContainer) {
                        // Stop scrolling immediately, instead of waiting for the animation to finish.
                        this._dropContainer._stopScrolling();
                        this._animatePreviewToPlaceholder().then(( /**
                         * @return {?}
                         */function () {
                            _this._cleanupDragArtifacts(event);
                            _this._cleanupCachedDimensions();
                            _this._dragDropRegistry.stopDragging(_this);
                        }));
                    }
                    else {
                        // Convert the active transform into a passive one. This means that next time
                        // the user starts dragging the item, its position will be calculated relatively
                        // to the new passive transform.
                        this._passiveTransform.x = this._activeTransform.x;
                        this._passiveTransform.y = this._activeTransform.y;
                        this._ngZone.run(( /**
                         * @return {?}
                         */function () {
                            _this.ended.next({
                                source: _this,
                                distance: _this._getDragDistance(_this._getPointerPositionOnPage(event))
                            });
                        }));
                        this._cleanupCachedDimensions();
                        this._dragDropRegistry.stopDragging(this);
                    }
                };
                /**
                 * Starts the dragging sequence.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                DragRef.prototype._startDragSequence = function (event) {
                    // Emit the event on the item before the one on the container.
                    this.started.next({ source: this });
                    if (isTouchEvent(event)) {
                        this._lastTouchEventTime = Date.now();
                    }
                    this._toggleNativeDragInteractions();
                    if (this._dropContainer) {
                        /** @type {?} */
                        var element = this._rootElement;
                        // Grab the `nextSibling` before the preview and placeholder
                        // have been created so we don't get the preview by accident.
                        this._nextSibling = element.nextSibling;
                        /** @type {?} */
                        var preview = this._preview = this._createPreviewElement();
                        /** @type {?} */
                        var placeholder = this._placeholder = this._createPlaceholderElement();
                        // We move the element out at the end of the body and we make it hidden, because keeping it in
                        // place will throw off the consumer's `:last-child` selectors. We can't remove the element
                        // from the DOM completely, because iOS will stop firing all subsequent events in the chain.
                        element.style.display = 'none';
                        this._document.body.appendChild(( /** @type {?} */(element.parentNode)).replaceChild(placeholder, element));
                        getPreviewInsertionPoint(this._document).appendChild(preview);
                        this._dropContainer.start();
                    }
                };
                /**
                 * Sets up the different variables and subscriptions
                 * that will be necessary for the dragging sequence.
                 * @private
                 * @param {?} referenceElement Element that started the drag sequence.
                 * @param {?} event Browser event object that started the sequence.
                 * @return {?}
                 */
                DragRef.prototype._initializeDragSequence = function (referenceElement, event) {
                    var _this = this;
                    // Always stop propagation for the event that initializes
                    // the dragging sequence, in order to prevent it from potentially
                    // starting another sequence for a draggable parent somewhere up the DOM tree.
                    event.stopPropagation();
                    /** @type {?} */
                    var isDragging = this.isDragging();
                    /** @type {?} */
                    var isTouchSequence = isTouchEvent(event);
                    /** @type {?} */
                    var isAuxiliaryMouseButton = !isTouchSequence && (( /** @type {?} */(event))).button !== 0;
                    /** @type {?} */
                    var rootElement = this._rootElement;
                    /** @type {?} */
                    var isSyntheticEvent = !isTouchSequence && this._lastTouchEventTime &&
                        this._lastTouchEventTime + MOUSE_EVENT_IGNORE_TIME > Date.now();
                    // If the event started from an element with the native HTML drag&drop, it'll interfere
                    // with our own dragging (e.g. `img` tags do it by default). Prevent the default action
                    // to stop it from happening. Note that preventing on `dragstart` also seems to work, but
                    // it's flaky and it fails if the user drags it away quickly. Also note that we only want
                    // to do this for `mousedown` since doing the same for `touchstart` will stop any `click`
                    // events from firing on touch devices.
                    if (event.target && (( /** @type {?} */(event.target))).draggable && event.type === 'mousedown') {
                        event.preventDefault();
                    }
                    // Abort if the user is already dragging or is using a mouse button other than the primary one.
                    if (isDragging || isAuxiliaryMouseButton || isSyntheticEvent) {
                        return;
                    }
                    // If we've got handles, we need to disable the tap highlight on the entire root element,
                    // otherwise iOS will still add it, even though all the drag interactions on the handle
                    // are disabled.
                    if (this._handles.length) {
                        this._rootElementTapHighlight = rootElement.style.webkitTapHighlightColor;
                        rootElement.style.webkitTapHighlightColor = 'transparent';
                    }
                    this._hasStartedDragging = this._hasMoved = false;
                    this._initialContainer = ( /** @type {?} */(this._dropContainer));
                    // Avoid multiple subscriptions and memory leaks when multi touch
                    // (isDragging check above isn't enough because of possible temporal and/or dimensional delays)
                    this._removeSubscriptions();
                    this._pointerMoveSubscription = this._dragDropRegistry.pointerMove.subscribe(this._pointerMove);
                    this._pointerUpSubscription = this._dragDropRegistry.pointerUp.subscribe(this._pointerUp);
                    this._scrollSubscription = this._dragDropRegistry.scroll.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(null)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._scrollPosition = _this._viewportRuler.getViewportScrollPosition();
                    }));
                    if (this._boundaryElement) {
                        this._boundaryRect = this._boundaryElement.getBoundingClientRect();
                    }
                    // If we have a custom preview template, the element won't be visible anyway so we avoid the
                    // extra `getBoundingClientRect` calls and just move the preview next to the cursor.
                    this._pickupPositionInElement = this._previewTemplate && this._previewTemplate.template ?
                        { x: 0, y: 0 } :
                        this._getPointerPositionInElement(referenceElement, event);
                    /** @type {?} */
                    var pointerPosition = this._pickupPositionOnPage = this._getPointerPositionOnPage(event);
                    this._pointerDirectionDelta = { x: 0, y: 0 };
                    this._pointerPositionAtLastDirectionChange = { x: pointerPosition.x, y: pointerPosition.y };
                    this._dragStartTime = Date.now();
                    this._dragDropRegistry.startDragging(this, event);
                };
                /**
                 * Cleans up the DOM artifacts that were added to facilitate the element being dragged.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                DragRef.prototype._cleanupDragArtifacts = function (event) {
                    var _this = this;
                    // Restore the element's visibility and insert it at its old position in the DOM.
                    // It's important that we maintain the position, because moving the element around in the DOM
                    // can throw off `NgFor` which does smart diffing and re-creates elements only when necessary,
                    // while moving the existing elements in all other cases.
                    this._rootElement.style.display = '';
                    if (this._nextSibling) {
                        ( /** @type {?} */(this._nextSibling.parentNode)).insertBefore(this._rootElement, this._nextSibling);
                    }
                    else {
                        Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this._initialContainer.element).appendChild(this._rootElement);
                    }
                    this._destroyPreview();
                    this._destroyPlaceholder();
                    this._boundaryRect = this._previewRect = undefined;
                    // Re-enter the NgZone since we bound `document` events on the outside.
                    this._ngZone.run(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var container = ( /** @type {?} */(_this._dropContainer));
                        /** @type {?} */
                        var currentIndex = container.getItemIndex(_this);
                        /** @type {?} */
                        var pointerPosition = _this._getPointerPositionOnPage(event);
                        /** @type {?} */
                        var distance = _this._getDragDistance(_this._getPointerPositionOnPage(event));
                        /** @type {?} */
                        var isPointerOverContainer = container._isOverContainer(pointerPosition.x, pointerPosition.y);
                        _this.ended.next({ source: _this, distance: distance });
                        _this.dropped.next({
                            item: _this,
                            currentIndex: currentIndex,
                            previousIndex: _this._initialContainer.getItemIndex(_this),
                            container: container,
                            previousContainer: _this._initialContainer,
                            isPointerOverContainer: isPointerOverContainer,
                            distance: distance
                        });
                        container.drop(_this, currentIndex, _this._initialContainer, isPointerOverContainer, distance);
                        _this._dropContainer = _this._initialContainer;
                    }));
                };
                /**
                 * Updates the item's position in its drop container, or moves it
                 * into a new one, depending on its current drag position.
                 * @private
                 * @param {?} __0
                 * @return {?}
                 */
                DragRef.prototype._updateActiveDropContainer = function (_c) {
                    var _this = this;
                    var x = _c.x, y = _c.y;
                    // Drop container that draggable has been moved into.
                    /** @type {?} */
                    var newContainer = this._initialContainer._getSiblingContainerFromPosition(this, x, y);
                    // If we couldn't find a new container to move the item into, and the item has left its
                    // initial container, check whether the it's over the initial container. This handles the
                    // case where two containers are connected one way and the user tries to undo dragging an
                    // item into a new container.
                    if (!newContainer && this._dropContainer !== this._initialContainer &&
                        this._initialContainer._isOverContainer(x, y)) {
                        newContainer = this._initialContainer;
                    }
                    if (newContainer && newContainer !== this._dropContainer) {
                        this._ngZone.run(( /**
                         * @return {?}
                         */function () {
                            // Notify the old container that the item has left.
                            _this.exited.next({ item: _this, container: ( /** @type {?} */(_this._dropContainer)) });
                            ( /** @type {?} */(_this._dropContainer)).exit(_this);
                            // Notify the new container that the item has entered.
                            _this._dropContainer = ( /** @type {?} */(newContainer));
                            _this._dropContainer.enter(_this, x, y);
                            _this.entered.next({
                                item: _this,
                                container: ( /** @type {?} */(newContainer)),
                                currentIndex: ( /** @type {?} */(newContainer)).getItemIndex(_this)
                            });
                        }));
                    }
                    ( /** @type {?} */(this._dropContainer))._startScrollingIfNecessary(x, y);
                    ( /** @type {?} */(this._dropContainer))._sortItem(this, x, y, this._pointerDirectionDelta);
                    this._preview.style.transform =
                        getTransform(x - this._pickupPositionInElement.x, y - this._pickupPositionInElement.y);
                };
                /**
                 * Creates the element that will be rendered next to the user's pointer
                 * and will be used as a preview of the element that is being dragged.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._createPreviewElement = function () {
                    /** @type {?} */
                    var previewConfig = this._previewTemplate;
                    /** @type {?} */
                    var previewTemplate = previewConfig ? previewConfig.template : null;
                    /** @type {?} */
                    var preview;
                    if (previewTemplate) {
                        /** @type {?} */
                        var viewRef = ( /** @type {?} */(previewConfig)).viewContainer.createEmbeddedView(previewTemplate, ( /** @type {?} */(previewConfig)).context);
                        preview = getRootNode(viewRef, this._document);
                        this._previewRef = viewRef;
                        preview.style.transform =
                            getTransform(this._pickupPositionOnPage.x, this._pickupPositionOnPage.y);
                    }
                    else {
                        /** @type {?} */
                        var element = this._rootElement;
                        /** @type {?} */
                        var elementRect = element.getBoundingClientRect();
                        preview = deepCloneNode(element);
                        preview.style.width = elementRect.width + "px";
                        preview.style.height = elementRect.height + "px";
                        preview.style.transform = getTransform(elementRect.left, elementRect.top);
                    }
                    extendStyles(preview.style, {
                        // It's important that we disable the pointer events on the preview, because
                        // it can throw off the `document.elementFromPoint` calls in the `CdkDropList`.
                        pointerEvents: 'none',
                        // We have to reset the margin, because can throw off positioning relative to the viewport.
                        margin: '0',
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        zIndex: '1000'
                    });
                    toggleNativeDragInteractions(preview, false);
                    preview.classList.add('cdk-drag-preview');
                    preview.setAttribute('dir', this._direction);
                    return preview;
                };
                /**
                 * Animates the preview element from its current position to the location of the drop placeholder.
                 * @private
                 * @return {?} Promise that resolves when the animation completes.
                 */
                DragRef.prototype._animatePreviewToPlaceholder = function () {
                    var _this = this;
                    // If the user hasn't moved yet, the transitionend event won't fire.
                    if (!this._hasMoved) {
                        return Promise.resolve();
                    }
                    /** @type {?} */
                    var placeholderRect = this._placeholder.getBoundingClientRect();
                    // Apply the class that adds a transition to the preview.
                    this._preview.classList.add('cdk-drag-animating');
                    // Move the preview to the placeholder position.
                    this._preview.style.transform = getTransform(placeholderRect.left, placeholderRect.top);
                    // If the element doesn't have a `transition`, the `transitionend` event won't fire. Since
                    // we need to trigger a style recalculation in order for the `cdk-drag-animating` class to
                    // apply its style, we take advantage of the available info to figure out whether we need to
                    // bind the event in the first place.
                    /** @type {?} */
                    var duration = getTransformTransitionDurationInMs(this._preview);
                    if (duration === 0) {
                        return Promise.resolve();
                    }
                    return this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        return new Promise(( /**
                         * @param {?} resolve
                         * @return {?}
                         */function (/**
                         * @param {?} resolve
                         * @return {?}
                         */ resolve) {
                            /** @type {?} */
                            var handler = ( /** @type {?} */((( /**
                             * @param {?} event
                             * @return {?}
                             */function (event) {
                                if (!event || (event.target === _this._preview && event.propertyName === 'transform')) {
                                    _this._preview.removeEventListener('transitionend', handler);
                                    resolve();
                                    clearTimeout(timeout);
                                }
                            }))));
                            // If a transition is short enough, the browser might not fire the `transitionend` event.
                            // Since we know how long it's supposed to take, add a timeout with a 50% buffer that'll
                            // fire if the transition hasn't completed when it was supposed to.
                            /** @type {?} */
                            var timeout = setTimeout(( /** @type {?} */(handler)), duration * 1.5);
                            _this._preview.addEventListener('transitionend', handler);
                        }));
                    }));
                };
                /**
                 * Creates an element that will be shown instead of the current element while dragging.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._createPlaceholderElement = function () {
                    /** @type {?} */
                    var placeholderConfig = this._placeholderTemplate;
                    /** @type {?} */
                    var placeholderTemplate = placeholderConfig ? placeholderConfig.template : null;
                    /** @type {?} */
                    var placeholder;
                    if (placeholderTemplate) {
                        this._placeholderRef = ( /** @type {?} */(placeholderConfig)).viewContainer.createEmbeddedView(placeholderTemplate, ( /** @type {?} */(placeholderConfig)).context);
                        placeholder = getRootNode(this._placeholderRef, this._document);
                    }
                    else {
                        placeholder = deepCloneNode(this._rootElement);
                    }
                    placeholder.classList.add('cdk-drag-placeholder');
                    return placeholder;
                };
                /**
                 * Figures out the coordinates at which an element was picked up.
                 * @private
                 * @param {?} referenceElement Element that initiated the dragging.
                 * @param {?} event Event that initiated the dragging.
                 * @return {?}
                 */
                DragRef.prototype._getPointerPositionInElement = function (referenceElement, event) {
                    /** @type {?} */
                    var elementRect = this._rootElement.getBoundingClientRect();
                    /** @type {?} */
                    var handleElement = referenceElement === this._rootElement ? null : referenceElement;
                    /** @type {?} */
                    var referenceRect = handleElement ? handleElement.getBoundingClientRect() : elementRect;
                    /** @type {?} */
                    var point = isTouchEvent(event) ? event.targetTouches[0] : event;
                    /** @type {?} */
                    var x = point.pageX - referenceRect.left - this._scrollPosition.left;
                    /** @type {?} */
                    var y = point.pageY - referenceRect.top - this._scrollPosition.top;
                    return {
                        x: referenceRect.left - elementRect.left + x,
                        y: referenceRect.top - elementRect.top + y
                    };
                };
                /**
                 * Determines the point of the page that was touched by the user.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                DragRef.prototype._getPointerPositionOnPage = function (event) {
                    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
                    /** @type {?} */
                    var point = isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
                    return {
                        x: point.pageX - this._scrollPosition.left,
                        y: point.pageY - this._scrollPosition.top
                    };
                };
                /**
                 * Gets the pointer position on the page, accounting for any position constraints.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                DragRef.prototype._getConstrainedPointerPosition = function (event) {
                    /** @type {?} */
                    var point = this._getPointerPositionOnPage(event);
                    /** @type {?} */
                    var constrainedPoint = this.constrainPosition ? this.constrainPosition(point, this) : point;
                    /** @type {?} */
                    var dropContainerLock = this._dropContainer ? this._dropContainer.lockAxis : null;
                    if (this.lockAxis === 'x' || dropContainerLock === 'x') {
                        constrainedPoint.y = this._pickupPositionOnPage.y;
                    }
                    else if (this.lockAxis === 'y' || dropContainerLock === 'y') {
                        constrainedPoint.x = this._pickupPositionOnPage.x;
                    }
                    if (this._boundaryRect) {
                        var _c = this._pickupPositionInElement, pickupX = _c.x, pickupY = _c.y;
                        /** @type {?} */
                        var boundaryRect = this._boundaryRect;
                        /** @type {?} */
                        var previewRect = ( /** @type {?} */(this._previewRect));
                        /** @type {?} */
                        var minY = boundaryRect.top + pickupY;
                        /** @type {?} */
                        var maxY = boundaryRect.bottom - (previewRect.height - pickupY);
                        /** @type {?} */
                        var minX = boundaryRect.left + pickupX;
                        /** @type {?} */
                        var maxX = boundaryRect.right - (previewRect.width - pickupX);
                        constrainedPoint.x = clamp(constrainedPoint.x, minX, maxX);
                        constrainedPoint.y = clamp(constrainedPoint.y, minY, maxY);
                    }
                    return constrainedPoint;
                };
                /**
                 * Updates the current drag delta, based on the user's current pointer position on the page.
                 * @private
                 * @param {?} pointerPositionOnPage
                 * @return {?}
                 */
                DragRef.prototype._updatePointerDirectionDelta = function (pointerPositionOnPage) {
                    var x = pointerPositionOnPage.x, y = pointerPositionOnPage.y;
                    /** @type {?} */
                    var delta = this._pointerDirectionDelta;
                    /** @type {?} */
                    var positionSinceLastChange = this._pointerPositionAtLastDirectionChange;
                    // Amount of pixels the user has dragged since the last time the direction changed.
                    /** @type {?} */
                    var changeX = Math.abs(x - positionSinceLastChange.x);
                    /** @type {?} */
                    var changeY = Math.abs(y - positionSinceLastChange.y);
                    // Because we handle pointer events on a per-pixel basis, we don't want the delta
                    // to change for every pixel, otherwise anything that depends on it can look erratic.
                    // To make the delta more consistent, we track how much the user has moved since the last
                    // delta change and we only update it after it has reached a certain threshold.
                    if (changeX > this._config.pointerDirectionChangeThreshold) {
                        delta.x = x > positionSinceLastChange.x ? 1 : -1;
                        positionSinceLastChange.x = x;
                    }
                    if (changeY > this._config.pointerDirectionChangeThreshold) {
                        delta.y = y > positionSinceLastChange.y ? 1 : -1;
                        positionSinceLastChange.y = y;
                    }
                    return delta;
                };
                /**
                 * Toggles the native drag interactions, based on how many handles are registered.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._toggleNativeDragInteractions = function () {
                    if (!this._rootElement || !this._handles) {
                        return;
                    }
                    /** @type {?} */
                    var shouldEnable = this._handles.length > 0 || !this.isDragging();
                    if (shouldEnable !== this._nativeInteractionsEnabled) {
                        this._nativeInteractionsEnabled = shouldEnable;
                        toggleNativeDragInteractions(this._rootElement, shouldEnable);
                    }
                };
                /**
                 * Removes the manually-added event listeners from the root element.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                DragRef.prototype._removeRootElementListeners = function (element) {
                    element.removeEventListener('mousedown', this._pointerDown, activeEventListenerOptions);
                    element.removeEventListener('touchstart', this._pointerDown, passiveEventListenerOptions);
                };
                /**
                 * Applies a `transform` to the root element, taking into account any existing transforms on it.
                 * @private
                 * @param {?} x New transform value along the X axis.
                 * @param {?} y New transform value along the Y axis.
                 * @return {?}
                 */
                DragRef.prototype._applyRootElementTransform = function (x, y) {
                    /** @type {?} */
                    var transform = getTransform(x, y);
                    // Cache the previous transform amount only after the first drag sequence, because
                    // we don't want our own transforms to stack on top of each other.
                    if (this._initialTransform == null) {
                        this._initialTransform = this._rootElement.style.transform || '';
                    }
                    // Preserve the previous `transform` value, if there was one. Note that we apply our own
                    // transform before the user's, because things like rotation can affect which direction
                    // the element will be translated towards.
                    this._rootElement.style.transform = this._initialTransform ?
                        transform + ' ' + this._initialTransform : transform;
                };
                /**
                 * Gets the distance that the user has dragged during the current drag sequence.
                 * @private
                 * @param {?} currentPosition Current position of the user's pointer.
                 * @return {?}
                 */
                DragRef.prototype._getDragDistance = function (currentPosition) {
                    /** @type {?} */
                    var pickupPosition = this._pickupPositionOnPage;
                    if (pickupPosition) {
                        return { x: currentPosition.x - pickupPosition.x, y: currentPosition.y - pickupPosition.y };
                    }
                    return { x: 0, y: 0 };
                };
                /**
                 * Cleans up any cached element dimensions that we don't need after dragging has stopped.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._cleanupCachedDimensions = function () {
                    this._boundaryRect = this._previewRect = undefined;
                };
                /**
                 * Checks whether the element is still inside its boundary after the viewport has been resized.
                 * If not, the position is adjusted so that the element fits again.
                 * @private
                 * @return {?}
                 */
                DragRef.prototype._containInsideBoundaryOnResize = function () {
                    var _c = this._passiveTransform, x = _c.x, y = _c.y;
                    if ((x === 0 && y === 0) || this.isDragging() || !this._boundaryElement) {
                        return;
                    }
                    /** @type {?} */
                    var boundaryRect = this._boundaryElement.getBoundingClientRect();
                    /** @type {?} */
                    var elementRect = this._rootElement.getBoundingClientRect();
                    /** @type {?} */
                    var leftOverflow = boundaryRect.left - elementRect.left;
                    /** @type {?} */
                    var rightOverflow = elementRect.right - boundaryRect.right;
                    /** @type {?} */
                    var topOverflow = boundaryRect.top - elementRect.top;
                    /** @type {?} */
                    var bottomOverflow = elementRect.bottom - boundaryRect.bottom;
                    // If the element has become wider than the boundary, we can't
                    // do much to make it fit so we just anchor it to the left.
                    if (boundaryRect.width > elementRect.width) {
                        if (leftOverflow > 0) {
                            x += leftOverflow;
                        }
                        if (rightOverflow > 0) {
                            x -= rightOverflow;
                        }
                    }
                    else {
                        x = 0;
                    }
                    // If the element has become taller than the boundary, we can't
                    // do much to make it fit so we just anchor it to the top.
                    if (boundaryRect.height > elementRect.height) {
                        if (topOverflow > 0) {
                            y += topOverflow;
                        }
                        if (bottomOverflow > 0) {
                            y -= bottomOverflow;
                        }
                    }
                    else {
                        y = 0;
                    }
                    if (x !== this._passiveTransform.x || y !== this._passiveTransform.y) {
                        this.setFreeDragPosition({ y: y, x: x });
                    }
                };
                return DragRef;
            }());
            /**
             * Gets a 3d `transform` that can be applied to an element.
             * @param {?} x Desired position of the element along the X axis.
             * @param {?} y Desired position of the element along the Y axis.
             * @return {?}
             */
            function getTransform(x, y) {
                // Round the transforms since some browsers will
                // blur the elements for sub-pixel transforms.
                return "translate3d(" + Math.round(x) + "px, " + Math.round(y) + "px, 0)";
            }
            /**
             * Creates a deep clone of an element.
             * @param {?} node
             * @return {?}
             */
            function deepCloneNode(node) {
                /** @type {?} */
                var clone = ( /** @type {?} */(node.cloneNode(true)));
                /** @type {?} */
                var descendantsWithId = clone.querySelectorAll('[id]');
                /** @type {?} */
                var descendantCanvases = node.querySelectorAll('canvas');
                // Remove the `id` to avoid having multiple elements with the same id on the page.
                clone.removeAttribute('id');
                for (var i = 0; i < descendantsWithId.length; i++) {
                    descendantsWithId[i].removeAttribute('id');
                }
                // `cloneNode` won't transfer the content of `canvas` elements so we have to do it ourselves.
                // We match up the cloned canvas to their sources using their index in the DOM.
                if (descendantCanvases.length) {
                    /** @type {?} */
                    var cloneCanvases = clone.querySelectorAll('canvas');
                    for (var i = 0; i < descendantCanvases.length; i++) {
                        /** @type {?} */
                        var correspondingCloneContext = cloneCanvases[i].getContext('2d');
                        if (correspondingCloneContext) {
                            correspondingCloneContext.drawImage(descendantCanvases[i], 0, 0);
                        }
                    }
                }
                return clone;
            }
            /**
             * Clamps a value between a minimum and a maximum.
             * @param {?} value
             * @param {?} min
             * @param {?} max
             * @return {?}
             */
            function clamp(value, min, max) {
                return Math.max(min, Math.min(max, value));
            }
            /**
             * Helper to remove an element from the DOM and to do all the necessary null checks.
             * @param {?} element Element to be removed.
             * @return {?}
             */
            function removeElement(element) {
                if (element && element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            }
            /**
             * Determines whether an event is a touch event.
             * @param {?} event
             * @return {?}
             */
            function isTouchEvent(event) {
                // This function is called for every pixel that the user has dragged so we need it to be
                // as fast as possible. Since we only bind mouse events and touch events, we can assume
                // that if the event's name starts with `t`, it's a touch event.
                return event.type[0] === 't';
            }
            /**
             * Gets the element into which the drag preview should be inserted.
             * @param {?} documentRef
             * @return {?}
             */
            function getPreviewInsertionPoint(documentRef) {
                // We can't use the body if the user is in fullscreen mode,
                // because the preview will render under the fullscreen element.
                // TODO(crisbeto): dedupe this with the `FullscreenOverlayContainer` eventually.
                return documentRef.fullscreenElement ||
                    documentRef.webkitFullscreenElement ||
                    documentRef.mozFullScreenElement ||
                    documentRef.msFullscreenElement ||
                    documentRef.body;
            }
            /**
             * Gets the root HTML element of an embedded view.
             * If the root is not an HTML element it gets wrapped in one.
             * @param {?} viewRef
             * @param {?} _document
             * @return {?}
             */
            function getRootNode(viewRef, _document) {
                /** @type {?} */
                var rootNode = viewRef.rootNodes[0];
                if (rootNode.nodeType !== _document.ELEMENT_NODE) {
                    /** @type {?} */
                    var wrapper = _document.createElement('div');
                    wrapper.appendChild(rootNode);
                    return wrapper;
                }
                return ( /** @type {?} */(rootNode));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Moves an item one index in an array to another.
             * @template T
             * @param {?} array Array in which to move the item.
             * @param {?} fromIndex Starting index of the item.
             * @param {?} toIndex Index to which the item should be moved.
             * @return {?}
             */
            function moveItemInArray(array, fromIndex, toIndex) {
                /** @type {?} */
                var from = clamp$1(fromIndex, array.length - 1);
                /** @type {?} */
                var to = clamp$1(toIndex, array.length - 1);
                if (from === to) {
                    return;
                }
                /** @type {?} */
                var target = array[from];
                /** @type {?} */
                var delta = to < from ? -1 : 1;
                for (var i = from; i !== to; i += delta) {
                    array[i] = array[i + delta];
                }
                array[to] = target;
            }
            /**
             * Moves an item from one array to another.
             * @template T
             * @param {?} currentArray Array from which to transfer the item.
             * @param {?} targetArray Array into which to put the item.
             * @param {?} currentIndex Index of the item in its current array.
             * @param {?} targetIndex Index at which to insert the item.
             * @return {?}
             */
            function transferArrayItem(currentArray, targetArray, currentIndex, targetIndex) {
                /** @type {?} */
                var from = clamp$1(currentIndex, currentArray.length - 1);
                /** @type {?} */
                var to = clamp$1(targetIndex, targetArray.length);
                if (currentArray.length) {
                    targetArray.splice(to, 0, currentArray.splice(from, 1)[0]);
                }
            }
            /**
             * Copies an item from one array to another, leaving it in its
             * original position in current array.
             * @template T
             * @param {?} currentArray Array from which to copy the item.
             * @param {?} targetArray Array into which is copy the item.
             * @param {?} currentIndex Index of the item in its current array.
             * @param {?} targetIndex Index at which to insert the item.
             *
             * @return {?}
             */
            function copyArrayItem(currentArray, targetArray, currentIndex, targetIndex) {
                /** @type {?} */
                var to = clamp$1(targetIndex, targetArray.length);
                if (currentArray.length) {
                    targetArray.splice(to, 0, currentArray[currentIndex]);
                }
            }
            /**
             * Clamps a number between zero and a maximum.
             * @param {?} value
             * @param {?} max
             * @return {?}
             */
            function clamp$1(value, max) {
                return Math.max(0, Math.min(max, value));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Counter used to generate unique ids for drop refs.
             * @type {?}
             */
            var _uniqueIdCounter = 0;
            /**
             * Proximity, as a ratio to width/height, at which a
             * dragged item will affect the drop container.
             * @type {?}
             */
            var DROP_PROXIMITY_THRESHOLD = 0.05;
            /**
             * Proximity, as a ratio to width/height at which to start auto-scrolling the drop list or the
             * viewport. The value comes from trying it out manually until it feels right.
             * @type {?}
             */
            var SCROLL_PROXIMITY_THRESHOLD = 0.05;
            /**
             * Number of pixels to scroll for each frame when auto-scrolling an element.
             * The value comes from trying it out manually until it feels right.
             * @type {?}
             */
            var AUTO_SCROLL_STEP = 2;
            /**
             * Reference to a drop list. Used to manipulate or dispose of the container.
             * \@docs-private
             * @template T
             */
            var DropListRef = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?} _dragDropRegistry
                 * @param {?} _document
                 * @param {?=} _ngZone
                 * @param {?=} _viewportRuler
                 */
                function DropListRef(element, _dragDropRegistry, _document, _ngZone, _viewportRuler) {
                    var _this = this;
                    this._dragDropRegistry = _dragDropRegistry;
                    this._ngZone = _ngZone;
                    this._viewportRuler = _viewportRuler;
                    /**
                     * Unique ID for the drop list.
                     * @deprecated No longer being used. To be removed.
                     * \@breaking-change 8.0.0
                     */
                    this.id = "cdk-drop-list-ref-" + _uniqueIdCounter++;
                    /**
                     * Whether starting a dragging sequence from this container is disabled.
                     */
                    this.disabled = false;
                    /**
                     * Whether sorting items within the list is disabled.
                     */
                    this.sortingDisabled = false;
                    /**
                     * Whether auto-scrolling the view when the user
                     * moves their pointer close to the edges is disabled.
                     */
                    this.autoScrollDisabled = false;
                    /**
                     * Function that is used to determine whether an item
                     * is allowed to be moved into a drop container.
                     */
                    this.enterPredicate = ( /**
                     * @return {?}
                     */function () { return true; });
                    /**
                     * Emits right before dragging has started.
                     */
                    this.beforeStarted = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user has moved a new drag item into this container.
                     */
                    this.entered = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user removes an item from the container
                     * by dragging it into another container.
                     */
                    this.exited = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the user drops an item inside the container.
                     */
                    this.dropped = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits as the user is swapping items while actively dragging.
                     */
                    this.sorted = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Whether an item in the list is being dragged.
                     */
                    this._isDragging = false;
                    /**
                     * Cache of the dimensions of all the items inside the container.
                     */
                    this._itemPositions = [];
                    /**
                     * Keeps track of the container's scroll position.
                     */
                    this._scrollPosition = { top: 0, left: 0 };
                    /**
                     * Keeps track of the scroll position of the viewport.
                     */
                    this._viewportScrollPosition = { top: 0, left: 0 };
                    /**
                     * Keeps track of the item that was last swapped with the dragged item, as
                     * well as what direction the pointer was moving in when the swap occured.
                     */
                    this._previousSwap = { drag: ( /** @type {?} */(null)), delta: 0 };
                    /**
                     * Drop lists that are connected to the current one.
                     */
                    this._siblings = [];
                    /**
                     * Direction in which the list is oriented.
                     */
                    this._orientation = 'vertical';
                    /**
                     * Connected siblings that currently have a dragged item.
                     */
                    this._activeSiblings = new Set();
                    /**
                     * Layout direction of the drop list.
                     */
                    this._direction = 'ltr';
                    /**
                     * Subscription to the window being scrolled.
                     */
                    this._viewportScrollSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    /**
                     * Vertical direction in which the list is currently scrolling.
                     */
                    this._verticalScrollDirection = 0 /* NONE */;
                    /**
                     * Horizontal direction in which the list is currently scrolling.
                     */
                    this._horizontalScrollDirection = 0 /* NONE */;
                    /**
                     * Used to signal to the current auto-scroll sequence when to stop.
                     */
                    this._stopScrollTimers = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Handles the container being scrolled. Has to be an arrow function to preserve the context.
                     */
                    this._handleScroll = ( /**
                     * @return {?}
                     */function () {
                        if (!_this.isDragging()) {
                            return;
                        }
                        /** @type {?} */
                        var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(_this.element);
                        _this._updateAfterScroll(_this._scrollPosition, element.scrollTop, element.scrollLeft);
                    });
                    /**
                     * Starts the interval that'll auto-scroll the element.
                     */
                    this._startScrollInterval = ( /**
                     * @return {?}
                     */function () {
                        _this._stopScrolling();
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["interval"])(0, rxjs__WEBPACK_IMPORTED_MODULE_2__["animationFrameScheduler"])
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(_this._stopScrollTimers))
                            .subscribe(( /**
                     * @return {?}
                     */function () {
                            /** @type {?} */
                            var node = _this._scrollNode;
                            if (_this._verticalScrollDirection === 1 /* UP */) {
                                incrementVerticalScroll(node, -AUTO_SCROLL_STEP);
                            }
                            else if (_this._verticalScrollDirection === 2 /* DOWN */) {
                                incrementVerticalScroll(node, AUTO_SCROLL_STEP);
                            }
                            if (_this._horizontalScrollDirection === 1 /* LEFT */) {
                                incrementHorizontalScroll(node, -AUTO_SCROLL_STEP);
                            }
                            else if (_this._horizontalScrollDirection === 2 /* RIGHT */) {
                                incrementHorizontalScroll(node, AUTO_SCROLL_STEP);
                            }
                        }));
                    });
                    /** @type {?} */
                    var nativeNode = this.element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(element);
                    this._shadowRoot = getShadowRoot(nativeNode) || _document;
                    _dragDropRegistry.registerDropContainer(this);
                }
                /**
                 * Removes the drop list functionality from the DOM element.
                 * @return {?}
                 */
                DropListRef.prototype.dispose = function () {
                    this._stopScrolling();
                    this._stopScrollTimers.complete();
                    this._removeListeners();
                    this.beforeStarted.complete();
                    this.entered.complete();
                    this.exited.complete();
                    this.dropped.complete();
                    this.sorted.complete();
                    this._activeSiblings.clear();
                    this._scrollNode = ( /** @type {?} */(null));
                    this._dragDropRegistry.removeDropContainer(this);
                };
                /**
                 * Whether an item from this list is currently being dragged.
                 * @return {?}
                 */
                DropListRef.prototype.isDragging = function () {
                    return this._isDragging;
                };
                /**
                 * Starts dragging an item.
                 * @return {?}
                 */
                DropListRef.prototype.start = function () {
                    var _this = this;
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this.element);
                    this.beforeStarted.next();
                    this._isDragging = true;
                    this._cacheItems();
                    this._siblings.forEach(( /**
                     * @param {?} sibling
                     * @return {?}
                     */function (/**
                     * @param {?} sibling
                     * @return {?}
                     */ sibling) { return sibling._startReceiving(_this); }));
                    this._removeListeners();
                    // @breaking-change 9.0.0 Remove check for _ngZone once it's marked as a required param.
                    if (this._ngZone) {
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return element.addEventListener('scroll', _this._handleScroll); }));
                    }
                    else {
                        element.addEventListener('scroll', this._handleScroll);
                    }
                    // @breaking-change 9.0.0 Remove check for _viewportRuler once it's marked as a required param.
                    if (this._viewportRuler) {
                        this._listenToScrollEvents();
                    }
                };
                /**
                 * Emits an event to indicate that the user moved an item into the container.
                 * @param {?} item Item that was moved into the container.
                 * @param {?} pointerX Position of the item along the X axis.
                 * @param {?} pointerY Position of the item along the Y axis.
                 * @return {?}
                 */
                DropListRef.prototype.enter = function (item, pointerX, pointerY) {
                    this.start();
                    // If sorting is disabled, we want the item to return to its starting
                    // position if the user is returning it to its initial container.
                    /** @type {?} */
                    var newIndex = this.sortingDisabled ? this._draggables.indexOf(item) : -1;
                    if (newIndex === -1) {
                        // We use the coordinates of where the item entered the drop
                        // zone to figure out at which index it should be inserted.
                        newIndex = this._getItemIndexFromPointerPosition(item, pointerX, pointerY);
                    }
                    /** @type {?} */
                    var activeDraggables = this._activeDraggables;
                    /** @type {?} */
                    var currentIndex = activeDraggables.indexOf(item);
                    /** @type {?} */
                    var placeholder = item.getPlaceholderElement();
                    /** @type {?} */
                    var newPositionReference = activeDraggables[newIndex];
                    // If the item at the new position is the same as the item that is being dragged,
                    // it means that we're trying to restore the item to its initial position. In this
                    // case we should use the next item from the list as the reference.
                    if (newPositionReference === item) {
                        newPositionReference = activeDraggables[newIndex + 1];
                    }
                    // Since the item may be in the `activeDraggables` already (e.g. if the user dragged it
                    // into another container and back again), we have to ensure that it isn't duplicated.
                    if (currentIndex > -1) {
                        activeDraggables.splice(currentIndex, 1);
                    }
                    // Don't use items that are being dragged as a reference, because
                    // their element has been moved down to the bottom of the body.
                    if (newPositionReference && !this._dragDropRegistry.isDragging(newPositionReference)) {
                        /** @type {?} */
                        var element = newPositionReference.getRootElement();
                        ( /** @type {?} */(element.parentElement)).insertBefore(placeholder, element);
                        activeDraggables.splice(newIndex, 0, item);
                    }
                    else {
                        Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this.element).appendChild(placeholder);
                        activeDraggables.push(item);
                    }
                    // The transform needs to be cleared so it doesn't throw off the measurements.
                    placeholder.style.transform = '';
                    // Note that the positions were already cached when we called `start` above,
                    // but we need to refresh them since the amount of items has changed.
                    this._cacheItemPositions();
                    this.entered.next({ item: item, container: this, currentIndex: this.getItemIndex(item) });
                };
                /**
                 * Removes an item from the container after it was dragged into another container by the user.
                 * @param {?} item Item that was dragged out.
                 * @return {?}
                 */
                DropListRef.prototype.exit = function (item) {
                    this._reset();
                    this.exited.next({ item: item, container: this });
                };
                /**
                 * Drops an item into this container.
                 * \@breaking-change 9.0.0 `distance` parameter to become required.
                 * @param {?} item Item being dropped into the container.
                 * @param {?} currentIndex Index at which the item should be inserted.
                 * @param {?} previousContainer Container from which the item got dragged in.
                 * @param {?} isPointerOverContainer Whether the user's pointer was over the
                 *    container when the item was dropped.
                 * @param {?=} distance Distance the user has dragged since the start of the dragging sequence.
                 * @return {?}
                 */
                DropListRef.prototype.drop = function (item, currentIndex, previousContainer, isPointerOverContainer, distance) {
                    if (distance === void 0) { distance = { x: 0, y: 0 }; }
                    this._reset();
                    this.dropped.next({
                        item: item,
                        currentIndex: currentIndex,
                        previousIndex: previousContainer.getItemIndex(item),
                        container: this,
                        previousContainer: previousContainer,
                        isPointerOverContainer: isPointerOverContainer,
                        distance: distance
                    });
                };
                /**
                 * Sets the draggable items that are a part of this list.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} items Items that are a part of this list.
                 * @return {THIS}
                 */
                DropListRef.prototype.withItems = function (items) {
                    var _this = this;
                    ( /** @type {?} */(this))._draggables = items;
                    items.forEach(( /**
                     * @param {?} item
                     * @return {?}
                     */function (/**
                     * @param {?} item
                     * @return {?}
                     */ item) { return item._withDropContainer(( /** @type {?} */(_this))); }));
                    if (( /** @type {?} */(this)).isDragging()) {
                        ( /** @type {?} */(this))._cacheItems();
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the layout direction of the drop list.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} direction
                 * @return {THIS}
                 */
                DropListRef.prototype.withDirection = function (direction) {
                    ( /** @type {?} */(this))._direction = direction;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the containers that are connected to this one. When two or more containers are
                 * connected, the user will be allowed to transfer items between them.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} connectedTo Other containers that the current containers should be connected to.
                 * @return {THIS}
                 */
                DropListRef.prototype.connectedTo = function (connectedTo) {
                    ( /** @type {?} */(this))._siblings = connectedTo.slice();
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the orientation of the container.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} orientation New orientation for the container.
                 * @return {THIS}
                 */
                DropListRef.prototype.withOrientation = function (orientation) {
                    ( /** @type {?} */(this))._orientation = orientation;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Figures out the index of an item in the container.
                 * @param {?} item Item whose index should be determined.
                 * @return {?}
                 */
                DropListRef.prototype.getItemIndex = function (item) {
                    if (!this._isDragging) {
                        return this._draggables.indexOf(item);
                    }
                    // Items are sorted always by top/left in the cache, however they flow differently in RTL.
                    // The rest of the logic still stands no matter what orientation we're in, however
                    // we need to invert the array when determining the index.
                    /** @type {?} */
                    var items = this._orientation === 'horizontal' && this._direction === 'rtl' ?
                        this._itemPositions.slice().reverse() : this._itemPositions;
                    return findIndex(items, ( /**
                     * @param {?} currentItem
                     * @return {?}
                     */function (/**
                     * @param {?} currentItem
                     * @return {?}
                     */ currentItem) { return currentItem.drag === item; }));
                };
                /**
                 * Whether the list is able to receive the item that
                 * is currently being dragged inside a connected drop list.
                 * @return {?}
                 */
                DropListRef.prototype.isReceiving = function () {
                    return this._activeSiblings.size > 0;
                };
                /**
                 * Sorts an item inside the container based on its position.
                 * @param {?} item Item to be sorted.
                 * @param {?} pointerX Position of the item along the X axis.
                 * @param {?} pointerY Position of the item along the Y axis.
                 * @param {?} pointerDelta Direction in which the pointer is moving along each axis.
                 * @return {?}
                 */
                DropListRef.prototype._sortItem = function (item, pointerX, pointerY, pointerDelta) {
                    // Don't sort the item if sorting is disabled or it's out of range.
                    if (this.sortingDisabled || !this._isPointerNearDropContainer(pointerX, pointerY)) {
                        return;
                    }
                    /** @type {?} */
                    var siblings = this._itemPositions;
                    /** @type {?} */
                    var newIndex = this._getItemIndexFromPointerPosition(item, pointerX, pointerY, pointerDelta);
                    if (newIndex === -1 && siblings.length > 0) {
                        return;
                    }
                    /** @type {?} */
                    var isHorizontal = this._orientation === 'horizontal';
                    /** @type {?} */
                    var currentIndex = findIndex(siblings, ( /**
                     * @param {?} currentItem
                     * @return {?}
                     */function (/**
                     * @param {?} currentItem
                     * @return {?}
                     */ currentItem) { return currentItem.drag === item; }));
                    /** @type {?} */
                    var siblingAtNewPosition = siblings[newIndex];
                    /** @type {?} */
                    var currentPosition = siblings[currentIndex].clientRect;
                    /** @type {?} */
                    var newPosition = siblingAtNewPosition.clientRect;
                    /** @type {?} */
                    var delta = currentIndex > newIndex ? 1 : -1;
                    this._previousSwap.drag = siblingAtNewPosition.drag;
                    this._previousSwap.delta = isHorizontal ? pointerDelta.x : pointerDelta.y;
                    // How many pixels the item's placeholder should be offset.
                    /** @type {?} */
                    var itemOffset = this._getItemOffsetPx(currentPosition, newPosition, delta);
                    // How many pixels all the other items should be offset.
                    /** @type {?} */
                    var siblingOffset = this._getSiblingOffsetPx(currentIndex, siblings, delta);
                    // Save the previous order of the items before moving the item to its new index.
                    // We use this to check whether an item has been moved as a result of the sorting.
                    /** @type {?} */
                    var oldOrder = siblings.slice();
                    // Shuffle the array in place.
                    moveItemInArray(siblings, currentIndex, newIndex);
                    this.sorted.next({
                        previousIndex: currentIndex,
                        currentIndex: newIndex,
                        container: this,
                        item: item
                    });
                    siblings.forEach(( /**
                     * @param {?} sibling
                     * @param {?} index
                     * @return {?}
                     */function (sibling, index) {
                        // Don't do anything if the position hasn't changed.
                        if (oldOrder[index] === sibling) {
                            return;
                        }
                        /** @type {?} */
                        var isDraggedItem = sibling.drag === item;
                        /** @type {?} */
                        var offset = isDraggedItem ? itemOffset : siblingOffset;
                        /** @type {?} */
                        var elementToOffset = isDraggedItem ? item.getPlaceholderElement() :
                            sibling.drag.getRootElement();
                        // Update the offset to reflect the new position.
                        sibling.offset += offset;
                        // Since we're moving the items with a `transform`, we need to adjust their cached
                        // client rects to reflect their new position, as well as swap their positions in the cache.
                        // Note that we shouldn't use `getBoundingClientRect` here to update the cache, because the
                        // elements may be mid-animation which will give us a wrong result.
                        if (isHorizontal) {
                            // Round the transforms since some browsers will
                            // blur the elements, for sub-pixel transforms.
                            elementToOffset.style.transform = "translate3d(" + Math.round(sibling.offset) + "px, 0, 0)";
                            adjustClientRect(sibling.clientRect, 0, offset);
                        }
                        else {
                            elementToOffset.style.transform = "translate3d(0, " + Math.round(sibling.offset) + "px, 0)";
                            adjustClientRect(sibling.clientRect, offset, 0);
                        }
                    }));
                };
                /**
                 * Checks whether the user's pointer is close to the edges of either the
                 * viewport or the drop list and starts the auto-scroll sequence.
                 * @param {?} pointerX User's pointer position along the x axis.
                 * @param {?} pointerY User's pointer position along the y axis.
                 * @return {?}
                 */
                DropListRef.prototype._startScrollingIfNecessary = function (pointerX, pointerY) {
                    var _c;
                    if (this.autoScrollDisabled) {
                        return;
                    }
                    /** @type {?} */
                    var scrollNode;
                    /** @type {?} */
                    var verticalScrollDirection = 0 /* NONE */;
                    /** @type {?} */
                    var horizontalScrollDirection = 0 /* NONE */;
                    // Check whether we should start scrolling the container.
                    if (this._isPointerNearDropContainer(pointerX, pointerY)) {
                        /** @type {?} */
                        var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this.element);
                        _c = getElementScrollDirections(element, this._clientRect, pointerX, pointerY), verticalScrollDirection = _c[0], horizontalScrollDirection = _c[1];
                        if (verticalScrollDirection || horizontalScrollDirection) {
                            scrollNode = element;
                        }
                    }
                    // @breaking-change 9.0.0 Remove null check for _viewportRuler once it's a required parameter.
                    // Otherwise check if we can start scrolling the viewport.
                    if (this._viewportRuler && !verticalScrollDirection && !horizontalScrollDirection) {
                        var _d = this._viewportRuler.getViewportSize(), width = _d.width, height = _d.height;
                        /** @type {?} */
                        var clientRect = { width: width, height: height, top: 0, right: width, bottom: height, left: 0 };
                        verticalScrollDirection = getVerticalScrollDirection(clientRect, pointerY);
                        horizontalScrollDirection = getHorizontalScrollDirection(clientRect, pointerX);
                        scrollNode = window;
                    }
                    if (scrollNode && (verticalScrollDirection !== this._verticalScrollDirection ||
                        horizontalScrollDirection !== this._horizontalScrollDirection ||
                        scrollNode !== this._scrollNode)) {
                        this._verticalScrollDirection = verticalScrollDirection;
                        this._horizontalScrollDirection = horizontalScrollDirection;
                        this._scrollNode = scrollNode;
                        if ((verticalScrollDirection || horizontalScrollDirection) && scrollNode) {
                            // @breaking-change 9.0.0 Remove null check for `_ngZone` once it is made required.
                            if (this._ngZone) {
                                this._ngZone.runOutsideAngular(this._startScrollInterval);
                            }
                            else {
                                this._startScrollInterval();
                            }
                        }
                        else {
                            this._stopScrolling();
                        }
                    }
                };
                /**
                 * Stops any currently-running auto-scroll sequences.
                 * @return {?}
                 */
                DropListRef.prototype._stopScrolling = function () {
                    this._stopScrollTimers.next();
                };
                /**
                 * Caches the position of the drop list.
                 * @private
                 * @return {?}
                 */
                DropListRef.prototype._cacheOwnPosition = function () {
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this.element);
                    this._clientRect = getMutableClientRect(element);
                    this._scrollPosition = { top: element.scrollTop, left: element.scrollLeft };
                };
                /**
                 * Refreshes the position cache of the items and sibling containers.
                 * @private
                 * @return {?}
                 */
                DropListRef.prototype._cacheItemPositions = function () {
                    var _this = this;
                    /** @type {?} */
                    var isHorizontal = this._orientation === 'horizontal';
                    this._itemPositions = this._activeDraggables.map(( /**
                     * @param {?} drag
                     * @return {?}
                     */function (/**
                     * @param {?} drag
                     * @return {?}
                     */ drag) {
                        /** @type {?} */
                        var elementToMeasure = _this._dragDropRegistry.isDragging(drag) ?
                            // If the element is being dragged, we have to measure the
                            // placeholder, because the element is hidden.
                            drag.getPlaceholderElement() :
                            drag.getRootElement();
                        return { drag: drag, offset: 0, clientRect: getMutableClientRect(elementToMeasure) };
                    })).sort(( /**
                     * @param {?} a
                     * @param {?} b
                     * @return {?}
                     */function (a, b) {
                        return isHorizontal ? a.clientRect.left - b.clientRect.left :
                            a.clientRect.top - b.clientRect.top;
                    }));
                };
                /**
                 * Resets the container to its initial state.
                 * @private
                 * @return {?}
                 */
                DropListRef.prototype._reset = function () {
                    var _this = this;
                    this._isDragging = false;
                    // TODO(crisbeto): may have to wait for the animations to finish.
                    this._activeDraggables.forEach(( /**
                     * @param {?} item
                     * @return {?}
                     */function (/**
                     * @param {?} item
                     * @return {?}
                     */ item) { return item.getRootElement().style.transform = ''; }));
                    this._siblings.forEach(( /**
                     * @param {?} sibling
                     * @return {?}
                     */function (/**
                     * @param {?} sibling
                     * @return {?}
                     */ sibling) { return sibling._stopReceiving(_this); }));
                    this._activeDraggables = [];
                    this._itemPositions = [];
                    this._previousSwap.drag = null;
                    this._previousSwap.delta = 0;
                    this._stopScrolling();
                    this._removeListeners();
                };
                /**
                 * Gets the offset in pixels by which the items that aren't being dragged should be moved.
                 * @private
                 * @param {?} currentIndex Index of the item currently being dragged.
                 * @param {?} siblings All of the items in the list.
                 * @param {?} delta Direction in which the user is moving.
                 * @return {?}
                 */
                DropListRef.prototype._getSiblingOffsetPx = function (currentIndex, siblings, delta) {
                    /** @type {?} */
                    var isHorizontal = this._orientation === 'horizontal';
                    /** @type {?} */
                    var currentPosition = siblings[currentIndex].clientRect;
                    /** @type {?} */
                    var immediateSibling = siblings[currentIndex + delta * -1];
                    /** @type {?} */
                    var siblingOffset = currentPosition[isHorizontal ? 'width' : 'height'] * delta;
                    if (immediateSibling) {
                        /** @type {?} */
                        var start = isHorizontal ? 'left' : 'top';
                        /** @type {?} */
                        var end = isHorizontal ? 'right' : 'bottom';
                        // Get the spacing between the start of the current item and the end of the one immediately
                        // after it in the direction in which the user is dragging, or vice versa. We add it to the
                        // offset in order to push the element to where it will be when it's inline and is influenced
                        // by the `margin` of its siblings.
                        if (delta === -1) {
                            siblingOffset -= immediateSibling.clientRect[start] - currentPosition[end];
                        }
                        else {
                            siblingOffset += currentPosition[start] - immediateSibling.clientRect[end];
                        }
                    }
                    return siblingOffset;
                };
                /**
                 * Checks whether the pointer coordinates are close to the drop container.
                 * @private
                 * @param {?} pointerX Coordinates along the X axis.
                 * @param {?} pointerY Coordinates along the Y axis.
                 * @return {?}
                 */
                DropListRef.prototype._isPointerNearDropContainer = function (pointerX, pointerY) {
                    var _c = this._clientRect, top = _c.top, right = _c.right, bottom = _c.bottom, left = _c.left, width = _c.width, height = _c.height;
                    /** @type {?} */
                    var xThreshold = width * DROP_PROXIMITY_THRESHOLD;
                    /** @type {?} */
                    var yThreshold = height * DROP_PROXIMITY_THRESHOLD;
                    return pointerY > top - yThreshold && pointerY < bottom + yThreshold &&
                        pointerX > left - xThreshold && pointerX < right + xThreshold;
                };
                /**
                 * Gets the offset in pixels by which the item that is being dragged should be moved.
                 * @private
                 * @param {?} currentPosition Current position of the item.
                 * @param {?} newPosition Position of the item where the current item should be moved.
                 * @param {?} delta Direction in which the user is moving.
                 * @return {?}
                 */
                DropListRef.prototype._getItemOffsetPx = function (currentPosition, newPosition, delta) {
                    /** @type {?} */
                    var isHorizontal = this._orientation === 'horizontal';
                    /** @type {?} */
                    var itemOffset = isHorizontal ? newPosition.left - currentPosition.left :
                        newPosition.top - currentPosition.top;
                    // Account for differences in the item width/height.
                    if (delta === -1) {
                        itemOffset += isHorizontal ? newPosition.width - currentPosition.width :
                            newPosition.height - currentPosition.height;
                    }
                    return itemOffset;
                };
                /**
                 * Gets the index of an item in the drop container, based on the position of the user's pointer.
                 * @private
                 * @param {?} item Item that is being sorted.
                 * @param {?} pointerX Position of the user's pointer along the X axis.
                 * @param {?} pointerY Position of the user's pointer along the Y axis.
                 * @param {?=} delta Direction in which the user is moving their pointer.
                 * @return {?}
                 */
                DropListRef.prototype._getItemIndexFromPointerPosition = function (item, pointerX, pointerY, delta) {
                    var _this = this;
                    /** @type {?} */
                    var isHorizontal = this._orientation === 'horizontal';
                    return findIndex(this._itemPositions, ( /**
                     * @param {?} __0
                     * @param {?} _
                     * @param {?} array
                     * @return {?}
                     */function (_c, _, array) {
                        var drag = _c.drag, clientRect = _c.clientRect;
                        if (drag === item) {
                            // If there's only one item left in the container, it must be
                            // the dragged item itself so we use it as a reference.
                            return array.length < 2;
                        }
                        if (delta) {
                            /** @type {?} */
                            var direction = isHorizontal ? delta.x : delta.y;
                            // If the user is still hovering over the same item as last time, and they didn't change
                            // the direction in which they're dragging, we don't consider it a direction swap.
                            if (drag === _this._previousSwap.drag && direction === _this._previousSwap.delta) {
                                return false;
                            }
                        }
                        return isHorizontal ?
                            // Round these down since most browsers report client rects with
                            // sub-pixel precision, whereas the pointer coordinates are rounded to pixels.
                            pointerX >= Math.floor(clientRect.left) && pointerX <= Math.floor(clientRect.right) :
                            pointerY >= Math.floor(clientRect.top) && pointerY <= Math.floor(clientRect.bottom);
                    }));
                };
                /**
                 * Caches the current items in the list and their positions.
                 * @private
                 * @return {?}
                 */
                DropListRef.prototype._cacheItems = function () {
                    this._activeDraggables = this._draggables.slice();
                    this._cacheItemPositions();
                    this._cacheOwnPosition();
                };
                /**
                 * Updates the internal state of the container after a scroll event has happened.
                 * @private
                 * @param {?} scrollPosition Object that is keeping track of the scroll position.
                 * @param {?} newTop New top scroll position.
                 * @param {?} newLeft New left scroll position.
                 * @param {?=} extraClientRect Extra `ClientRect` object that should be updated, in addition to the
                 *  ones of the drag items. Useful when the viewport has been scrolled and we also need to update
                 *  the `ClientRect` of the list.
                 * @return {?}
                 */
                DropListRef.prototype._updateAfterScroll = function (scrollPosition, newTop, newLeft, extraClientRect) {
                    var _this = this;
                    /** @type {?} */
                    var topDifference = scrollPosition.top - newTop;
                    /** @type {?} */
                    var leftDifference = scrollPosition.left - newLeft;
                    if (extraClientRect) {
                        adjustClientRect(extraClientRect, topDifference, leftDifference);
                    }
                    // Since we know the amount that the user has scrolled we can shift all of the client rectangles
                    // ourselves. This is cheaper than re-measuring everything and we can avoid inconsistent
                    // behavior where we might be measuring the element before its position has changed.
                    this._itemPositions.forEach(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var clientRect = _c.clientRect;
                        adjustClientRect(clientRect, topDifference, leftDifference);
                    }));
                    // We need two loops for this, because we want all of the cached
                    // positions to be up-to-date before we re-sort the item.
                    this._itemPositions.forEach(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var drag = _c.drag;
                        if (_this._dragDropRegistry.isDragging(drag)) {
                            // We need to re-sort the item manually, because the pointer move
                            // events won't be dispatched while the user is scrolling.
                            drag._sortFromLastPointerPosition();
                        }
                    }));
                    scrollPosition.top = newTop;
                    scrollPosition.left = newLeft;
                };
                /**
                 * Removes the event listeners associated with this drop list.
                 * @private
                 * @return {?}
                 */
                DropListRef.prototype._removeListeners = function () {
                    Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this.element).removeEventListener('scroll', this._handleScroll);
                    this._viewportScrollSubscription.unsubscribe();
                };
                /**
                 * Checks whether the user's pointer is positioned over the container.
                 * @param {?} x Pointer position along the X axis.
                 * @param {?} y Pointer position along the Y axis.
                 * @return {?}
                 */
                DropListRef.prototype._isOverContainer = function (x, y) {
                    return isInsideClientRect(this._clientRect, x, y);
                };
                /**
                 * Figures out whether an item should be moved into a sibling
                 * drop container, based on its current position.
                 * @param {?} item Drag item that is being moved.
                 * @param {?} x Position of the item along the X axis.
                 * @param {?} y Position of the item along the Y axis.
                 * @return {?}
                 */
                DropListRef.prototype._getSiblingContainerFromPosition = function (item, x, y) {
                    return this._siblings.find(( /**
                     * @param {?} sibling
                     * @return {?}
                     */function (/**
                     * @param {?} sibling
                     * @return {?}
                     */ sibling) { return sibling._canReceive(item, x, y); }));
                };
                /**
                 * Checks whether the drop list can receive the passed-in item.
                 * @param {?} item Item that is being dragged into the list.
                 * @param {?} x Position of the item along the X axis.
                 * @param {?} y Position of the item along the Y axis.
                 * @return {?}
                 */
                DropListRef.prototype._canReceive = function (item, x, y) {
                    if (!this.enterPredicate(item, this) || !isInsideClientRect(this._clientRect, x, y)) {
                        return false;
                    }
                    /** @type {?} */
                    var elementFromPoint = ( /** @type {?} */(this._shadowRoot.elementFromPoint(x, y)));
                    // If there's no element at the pointer position, then
                    // the client rect is probably scrolled out of the view.
                    if (!elementFromPoint) {
                        return false;
                    }
                    /** @type {?} */
                    var nativeElement = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(this.element);
                    // The `ClientRect`, that we're using to find the container over which the user is
                    // hovering, doesn't give us any information on whether the element has been scrolled
                    // out of the view or whether it's overlapping with other containers. This means that
                    // we could end up transferring the item into a container that's invisible or is positioned
                    // below another one. We use the result from `elementFromPoint` to get the top-most element
                    // at the pointer position and to find whether it's one of the intersecting drop containers.
                    return elementFromPoint === nativeElement || nativeElement.contains(elementFromPoint);
                };
                /**
                 * Called by one of the connected drop lists when a dragging sequence has started.
                 * @param {?} sibling Sibling in which dragging has started.
                 * @return {?}
                 */
                DropListRef.prototype._startReceiving = function (sibling) {
                    /** @type {?} */
                    var activeSiblings = this._activeSiblings;
                    if (!activeSiblings.has(sibling)) {
                        activeSiblings.add(sibling);
                        this._cacheOwnPosition();
                        this._listenToScrollEvents();
                    }
                };
                /**
                 * Called by a connected drop list when dragging has stopped.
                 * @param {?} sibling Sibling whose dragging has stopped.
                 * @return {?}
                 */
                DropListRef.prototype._stopReceiving = function (sibling) {
                    this._activeSiblings.delete(sibling);
                    this._viewportScrollSubscription.unsubscribe();
                };
                /**
                 * Starts listening to scroll events on the viewport.
                 * Used for updating the internal state of the list.
                 * @private
                 * @return {?}
                 */
                DropListRef.prototype._listenToScrollEvents = function () {
                    var _this = this;
                    this._viewportScrollPosition = ( /** @type {?} */(this._viewportRuler)).getViewportScrollPosition();
                    this._viewportScrollSubscription = this._dragDropRegistry.scroll.subscribe(( /**
                     * @return {?}
                     */function () {
                        if (_this.isDragging()) {
                            /** @type {?} */
                            var newPosition = ( /** @type {?} */(_this._viewportRuler)).getViewportScrollPosition();
                            _this._updateAfterScroll(_this._viewportScrollPosition, newPosition.top, newPosition.left, _this._clientRect);
                        }
                        else if (_this.isReceiving()) {
                            _this._cacheOwnPosition();
                        }
                    }));
                };
                return DropListRef;
            }());
            /**
             * Updates the top/left positions of a `ClientRect`, as well as their bottom/right counterparts.
             * @param {?} clientRect `ClientRect` that should be updated.
             * @param {?} top Amount to add to the `top` position.
             * @param {?} left Amount to add to the `left` position.
             * @return {?}
             */
            function adjustClientRect(clientRect, top, left) {
                clientRect.top += top;
                clientRect.bottom = clientRect.top + clientRect.height;
                clientRect.left += left;
                clientRect.right = clientRect.left + clientRect.width;
            }
            /**
             * Finds the index of an item that matches a predicate function. Used as an equivalent
             * of `Array.prototype.findIndex` which isn't part of the standard Google typings.
             * @template T
             * @param {?} array Array in which to look for matches.
             * @param {?} predicate Function used to determine whether an item is a match.
             * @return {?}
             */
            function findIndex(array, predicate) {
                for (var i = 0; i < array.length; i++) {
                    if (predicate(array[i], i, array)) {
                        return i;
                    }
                }
                return -1;
            }
            /**
             * Checks whether some coordinates are within a `ClientRect`.
             * @param {?} clientRect ClientRect that is being checked.
             * @param {?} x Coordinates along the X axis.
             * @param {?} y Coordinates along the Y axis.
             * @return {?}
             */
            function isInsideClientRect(clientRect, x, y) {
                var top = clientRect.top, bottom = clientRect.bottom, left = clientRect.left, right = clientRect.right;
                return y >= top && y <= bottom && x >= left && x <= right;
            }
            /**
             * Gets a mutable version of an element's bounding `ClientRect`.
             * @param {?} element
             * @return {?}
             */
            function getMutableClientRect(element) {
                /** @type {?} */
                var clientRect = element.getBoundingClientRect();
                // We need to clone the `clientRect` here, because all the values on it are readonly
                // and we need to be able to update them. Also we can't use a spread here, because
                // the values on a `ClientRect` aren't own properties. See:
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect#Notes
                return {
                    top: clientRect.top,
                    right: clientRect.right,
                    bottom: clientRect.bottom,
                    left: clientRect.left,
                    width: clientRect.width,
                    height: clientRect.height
                };
            }
            /**
             * Increments the vertical scroll position of a node.
             * @param {?} node Node whose scroll position should change.
             * @param {?} amount Amount of pixels that the `node` should be scrolled.
             * @return {?}
             */
            function incrementVerticalScroll(node, amount) {
                if (node === window) {
                    (( /** @type {?} */(node))).scrollBy(0, amount);
                }
                else {
                    // Ideally we could use `Element.scrollBy` here as well, but IE and Edge don't support it.
                    (( /** @type {?} */(node))).scrollTop += amount;
                }
            }
            /**
             * Increments the horizontal scroll position of a node.
             * @param {?} node Node whose scroll position should change.
             * @param {?} amount Amount of pixels that the `node` should be scrolled.
             * @return {?}
             */
            function incrementHorizontalScroll(node, amount) {
                if (node === window) {
                    (( /** @type {?} */(node))).scrollBy(amount, 0);
                }
                else {
                    // Ideally we could use `Element.scrollBy` here as well, but IE and Edge don't support it.
                    (( /** @type {?} */(node))).scrollLeft += amount;
                }
            }
            /**
             * Gets whether the vertical auto-scroll direction of a node.
             * @param {?} clientRect Dimensions of the node.
             * @param {?} pointerY Position of the user's pointer along the y axis.
             * @return {?}
             */
            function getVerticalScrollDirection(clientRect, pointerY) {
                var top = clientRect.top, bottom = clientRect.bottom, height = clientRect.height;
                /** @type {?} */
                var yThreshold = height * SCROLL_PROXIMITY_THRESHOLD;
                if (pointerY >= top - yThreshold && pointerY <= top + yThreshold) {
                    return 1 /* UP */;
                }
                else if (pointerY >= bottom - yThreshold && pointerY <= bottom + yThreshold) {
                    return 2 /* DOWN */;
                }
                return 0 /* NONE */;
            }
            /**
             * Gets whether the horizontal auto-scroll direction of a node.
             * @param {?} clientRect Dimensions of the node.
             * @param {?} pointerX Position of the user's pointer along the x axis.
             * @return {?}
             */
            function getHorizontalScrollDirection(clientRect, pointerX) {
                var left = clientRect.left, right = clientRect.right, width = clientRect.width;
                /** @type {?} */
                var xThreshold = width * SCROLL_PROXIMITY_THRESHOLD;
                if (pointerX >= left - xThreshold && pointerX <= left + xThreshold) {
                    return 1 /* LEFT */;
                }
                else if (pointerX >= right - xThreshold && pointerX <= right + xThreshold) {
                    return 2 /* RIGHT */;
                }
                return 0 /* NONE */;
            }
            /**
             * Gets the directions in which an element node should be scrolled,
             * assuming that the user's pointer is already within it scrollable region.
             * @param {?} element Element for which we should calculate the scroll direction.
             * @param {?} clientRect Bounding client rectangle of the element.
             * @param {?} pointerX Position of the user's pointer along the x axis.
             * @param {?} pointerY Position of the user's pointer along the y axis.
             * @return {?}
             */
            function getElementScrollDirections(element, clientRect, pointerX, pointerY) {
                /** @type {?} */
                var computedVertical = getVerticalScrollDirection(clientRect, pointerY);
                /** @type {?} */
                var computedHorizontal = getHorizontalScrollDirection(clientRect, pointerX);
                /** @type {?} */
                var verticalScrollDirection = 0 /* NONE */;
                /** @type {?} */
                var horizontalScrollDirection = 0 /* NONE */;
                // Note that we here we do some extra checks for whether the element is actually scrollable in
                // a certain direction and we only assign the scroll direction if it is. We do this so that we
                // can allow other elements to be scrolled, if the current element can't be scrolled anymore.
                // This allows us to handle cases where the scroll regions of two scrollable elements overlap.
                if (computedVertical) {
                    /** @type {?} */
                    var scrollTop = element.scrollTop;
                    if (computedVertical === 1 /* UP */) {
                        if (scrollTop > 0) {
                            verticalScrollDirection = 1 /* UP */;
                        }
                    }
                    else if (element.scrollHeight - scrollTop > element.clientHeight) {
                        verticalScrollDirection = 2 /* DOWN */;
                    }
                }
                if (computedHorizontal) {
                    /** @type {?} */
                    var scrollLeft = element.scrollLeft;
                    if (computedHorizontal === 1 /* LEFT */) {
                        if (scrollLeft > 0) {
                            horizontalScrollDirection = 1 /* LEFT */;
                        }
                    }
                    else if (element.scrollWidth - scrollLeft > element.clientWidth) {
                        horizontalScrollDirection = 2 /* RIGHT */;
                    }
                }
                return [verticalScrollDirection, horizontalScrollDirection];
            }
            /**
             * Gets the shadow root of an element, if any.
             * @param {?} element
             * @return {?}
             */
            function getShadowRoot(element) {
                if (Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["_supportsShadowDom"])()) {
                    /** @type {?} */
                    var rootNode = element.getRootNode ? element.getRootNode() : null;
                    if (rootNode instanceof ShadowRoot) {
                        return rootNode;
                    }
                }
                return null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Event options that can be used to bind an active, capturing event.
             * @type {?}
             */
            var activeCapturingEventOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["normalizePassiveListenerOptions"])({
                passive: false,
                capture: true
            });
            /**
             * Service that keeps track of all the drag item and drop container
             * instances, and manages global event listeners on the `document`.
             * \@docs-private
             * @template I, C
             */
            // Note: this class is generic, rather than referencing CdkDrag and CdkDropList directly, in order
            // to avoid circular imports. If we were to reference them here, importing the registry into the
            // classes that are registering themselves will introduce a circular import.
            var DragDropRegistry = /** @class */ (function () {
                /**
                 * @param {?} _ngZone
                 * @param {?} _document
                 */
                function DragDropRegistry(_ngZone, _document) {
                    var _this = this;
                    this._ngZone = _ngZone;
                    /**
                     * Registered drop container instances.
                     */
                    this._dropInstances = new Set();
                    /**
                     * Registered drag item instances.
                     */
                    this._dragInstances = new Set();
                    /**
                     * Drag item instances that are currently being dragged.
                     */
                    this._activeDragInstances = new Set();
                    /**
                     * Keeps track of the event listeners that we've bound to the `document`.
                     */
                    this._globalListeners = new Map();
                    /**
                     * Emits the `touchmove` or `mousemove` events that are dispatched
                     * while the user is dragging a drag item instance.
                     */
                    this.pointerMove = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits the `touchend` or `mouseup` events that are dispatched
                     * while the user is dragging a drag item instance.
                     */
                    this.pointerUp = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the viewport has been scrolled while the user is dragging an item.
                     */
                    this.scroll = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Event listener that will prevent the default browser action while the user is dragging.
                     * @param event Event whose default action should be prevented.
                     */
                    this._preventDefaultWhileDragging = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        if (_this._activeDragInstances.size) {
                            event.preventDefault();
                        }
                    });
                    this._document = _document;
                }
                /**
                 * Adds a drop container to the registry.
                 * @param {?} drop
                 * @return {?}
                 */
                DragDropRegistry.prototype.registerDropContainer = function (drop) {
                    if (!this._dropInstances.has(drop)) {
                        if (this.getDropContainer(drop.id)) {
                            throw Error("Drop instance with id \"" + drop.id + "\" has already been registered.");
                        }
                        this._dropInstances.add(drop);
                    }
                };
                /**
                 * Adds a drag item instance to the registry.
                 * @param {?} drag
                 * @return {?}
                 */
                DragDropRegistry.prototype.registerDragItem = function (drag) {
                    var _this = this;
                    this._dragInstances.add(drag);
                    // The `touchmove` event gets bound once, ahead of time, because WebKit
                    // won't preventDefault on a dynamically-added `touchmove` listener.
                    // See https://bugs.webkit.org/show_bug.cgi?id=184250.
                    if (this._dragInstances.size === 1) {
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            // The event handler has to be explicitly active,
                            // because newer browsers make it passive by default.
                            _this._document.addEventListener('touchmove', _this._preventDefaultWhileDragging, activeCapturingEventOptions);
                        }));
                    }
                };
                /**
                 * Removes a drop container from the registry.
                 * @param {?} drop
                 * @return {?}
                 */
                DragDropRegistry.prototype.removeDropContainer = function (drop) {
                    this._dropInstances.delete(drop);
                };
                /**
                 * Removes a drag item instance from the registry.
                 * @param {?} drag
                 * @return {?}
                 */
                DragDropRegistry.prototype.removeDragItem = function (drag) {
                    this._dragInstances.delete(drag);
                    this.stopDragging(drag);
                    if (this._dragInstances.size === 0) {
                        this._document.removeEventListener('touchmove', this._preventDefaultWhileDragging, activeCapturingEventOptions);
                    }
                };
                /**
                 * Starts the dragging sequence for a drag instance.
                 * @param {?} drag Drag instance which is being dragged.
                 * @param {?} event Event that initiated the dragging.
                 * @return {?}
                 */
                DragDropRegistry.prototype.startDragging = function (drag, event) {
                    var _this = this;
                    // Do not process the same drag twice to avoid memory leaks and redundant listeners
                    if (this._activeDragInstances.has(drag)) {
                        return;
                    }
                    this._activeDragInstances.add(drag);
                    if (this._activeDragInstances.size === 1) {
                        /** @type {?} */
                        var isTouchEvent_1 = event.type.startsWith('touch');
                        /** @type {?} */
                        var moveEvent = isTouchEvent_1 ? 'touchmove' : 'mousemove';
                        /** @type {?} */
                        var upEvent = isTouchEvent_1 ? 'touchend' : 'mouseup';
                        // We explicitly bind __active__ listeners here, because newer browsers will default to
                        // passive ones for `mousemove` and `touchmove`. The events need to be active, because we
                        // use `preventDefault` to prevent the page from scrolling while the user is dragging.
                        this._globalListeners
                            .set(moveEvent, {
                            handler: ( /**
                             * @param {?} e
                             * @return {?}
                             */function (e) { return _this.pointerMove.next(( /** @type {?} */(e))); }),
                            options: activeCapturingEventOptions
                        })
                            .set(upEvent, {
                            handler: ( /**
                             * @param {?} e
                             * @return {?}
                             */function (e) { return _this.pointerUp.next(( /** @type {?} */(e))); }),
                            options: true
                        })
                            .set('scroll', {
                            handler: ( /**
                             * @param {?} e
                             * @return {?}
                             */function (e) { return _this.scroll.next(e); }),
                            // Use capturing so that we pick up scroll changes in any scrollable nodes that aren't
                            // the document. See https://github.com/angular/components/issues/17144.
                            options: true
                        })
                            // Preventing the default action on `mousemove` isn't enough to disable text selection
                            // on Safari so we need to prevent the selection event as well. Alternatively this can
                            // be done by setting `user-select: none` on the `body`, however it has causes a style
                            // recalculation which can be expensive on pages with a lot of elements.
                            .set('selectstart', {
                            handler: this._preventDefaultWhileDragging,
                            options: activeCapturingEventOptions
                        });
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            _this._globalListeners.forEach(( /**
                             * @param {?} config
                             * @param {?} name
                             * @return {?}
                             */function (config, name) {
                                _this._document.addEventListener(name, config.handler, config.options);
                            }));
                        }));
                    }
                };
                /**
                 * Stops dragging a drag item instance.
                 * @param {?} drag
                 * @return {?}
                 */
                DragDropRegistry.prototype.stopDragging = function (drag) {
                    this._activeDragInstances.delete(drag);
                    if (this._activeDragInstances.size === 0) {
                        this._clearGlobalListeners();
                    }
                };
                /**
                 * Gets whether a drag item instance is currently being dragged.
                 * @param {?} drag
                 * @return {?}
                 */
                DragDropRegistry.prototype.isDragging = function (drag) {
                    return this._activeDragInstances.has(drag);
                };
                /**
                 * Gets a drop container by its id.
                 * @deprecated No longer being used. To be removed.
                 * \@breaking-change 8.0.0
                 * @param {?} id
                 * @return {?}
                 */
                DragDropRegistry.prototype.getDropContainer = function (id) {
                    return Array.from(this._dropInstances).find(( /**
                     * @param {?} instance
                     * @return {?}
                     */function (/**
                     * @param {?} instance
                     * @return {?}
                     */ instance) { return instance.id === id; }));
                };
                /**
                 * @return {?}
                 */
                DragDropRegistry.prototype.ngOnDestroy = function () {
                    var _this = this;
                    this._dragInstances.forEach(( /**
                     * @param {?} instance
                     * @return {?}
                     */function (/**
                     * @param {?} instance
                     * @return {?}
                     */ instance) { return _this.removeDragItem(instance); }));
                    this._dropInstances.forEach(( /**
                     * @param {?} instance
                     * @return {?}
                     */function (/**
                     * @param {?} instance
                     * @return {?}
                     */ instance) { return _this.removeDropContainer(instance); }));
                    this._clearGlobalListeners();
                    this.pointerMove.complete();
                    this.pointerUp.complete();
                };
                /**
                 * Clears out the global event listeners from the `document`.
                 * @private
                 * @return {?}
                 */
                DragDropRegistry.prototype._clearGlobalListeners = function () {
                    var _this = this;
                    this._globalListeners.forEach(( /**
                     * @param {?} config
                     * @param {?} name
                     * @return {?}
                     */function (config, name) {
                        _this._document.removeEventListener(name, config.handler, config.options);
                    }));
                    this._globalListeners.clear();
                };
                return DragDropRegistry;
            }());
            DragDropRegistry.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            DragDropRegistry.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ DragDropRegistry.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵdefineInjectable"])({ factory: function DragDropRegistry_Factory() { return new DragDropRegistry(Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_4__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"])); }, token: DragDropRegistry, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Default configuration to be used when creating a `DragRef`.
             * @type {?}
             */
            var DEFAULT_CONFIG = {
                dragStartThreshold: 5,
                pointerDirectionChangeThreshold: 5
            };
            /**
             * Service that allows for drag-and-drop functionality to be attached to DOM elements.
             */
            var DragDrop = /** @class */ (function () {
                /**
                 * @param {?} _document
                 * @param {?} _ngZone
                 * @param {?} _viewportRuler
                 * @param {?} _dragDropRegistry
                 */
                function DragDrop(_document, _ngZone, _viewportRuler, _dragDropRegistry) {
                    this._document = _document;
                    this._ngZone = _ngZone;
                    this._viewportRuler = _viewportRuler;
                    this._dragDropRegistry = _dragDropRegistry;
                }
                /**
                 * Turns an element into a draggable item.
                 * @template T
                 * @param {?} element Element to which to attach the dragging functionality.
                 * @param {?=} config Object used to configure the dragging behavior.
                 * @return {?}
                 */
                DragDrop.prototype.createDrag = function (element, config) {
                    if (config === void 0) { config = DEFAULT_CONFIG; }
                    return new DragRef(element, config, this._document, this._ngZone, this._viewportRuler, this._dragDropRegistry);
                };
                /**
                 * Turns an element into a drop list.
                 * @template T
                 * @param {?} element Element to which to attach the drop list functionality.
                 * @return {?}
                 */
                DragDrop.prototype.createDropList = function (element) {
                    return new DropListRef(element, this._dragDropRegistry, this._document, this._ngZone, this._viewportRuler);
                };
                return DragDrop;
            }());
            DragDrop.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            DragDrop.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["NgZone"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["ViewportRuler"] },
                { type: DragDropRegistry }
            ]; };
            /** @nocollapse */ DragDrop.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵdefineInjectable"])({ factory: function DragDrop_Factory() { return new DragDrop(Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_4__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵinject"])(_angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["ViewportRuler"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["ɵɵinject"])(DragDropRegistry)); }, token: DragDrop, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that is used to provide a CdkDropList instance to CdkDrag.
             * Used for avoiding circular imports.
             * @type {?}
             */
            var CDK_DROP_LIST = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["InjectionToken"]('CDK_DROP_LIST');
            /**
             * Injection token that is used to provide a CdkDropList instance to CdkDrag.
             * Used for avoiding circular imports.
             * @deprecated Use `CDK_DROP_LIST` instead.
             * \@breaking-change 8.0.0
             * @type {?}
             */
            var CDK_DROP_LIST_CONTAINER = CDK_DROP_LIST;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used for a `CdkDrag` to provide itself as a parent to the
             * drag-specific child directive (`CdkDragHandle`, `CdkDragPreview` etc.). Used primarily
             * to avoid circular imports.
             * \@docs-private
             * @type {?}
             */
            var CDK_DRAG_PARENT = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["InjectionToken"]('CDK_DRAG_PARENT');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Handle that can be used to drag and CdkDrag instance.
             */
            var CdkDragHandle = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?=} parentDrag
                 */
                function CdkDragHandle(element, parentDrag) {
                    this.element = element;
                    /**
                     * Emits when the state of the handle has changed.
                     */
                    this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    this._disabled = false;
                    this._parentDrag = parentDrag;
                    toggleNativeDragInteractions(element.nativeElement, false);
                }
                Object.defineProperty(CdkDragHandle.prototype, "disabled", {
                    /**
                     * Whether starting to drag through this handle is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        this._stateChanges.next(this);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkDragHandle.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                return CdkDragHandle;
            }());
            CdkDragHandle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Directive"], args: [{
                            selector: '[cdkDragHandle]',
                            host: {
                                'class': 'cdk-drag-handle'
                            }
                        },] },
            ];
            /** @nocollapse */
            CdkDragHandle.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [CDK_DRAG_PARENT,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }] }
            ]; };
            CdkDragHandle.propDecorators = {
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragHandleDisabled',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Element that will be used as a template for the placeholder of a CdkDrag when
             * it is being dragged. The placeholder is displayed in place of the element being dragged.
             * @template T
             */
            var CdkDragPlaceholder = /** @class */ (function () {
                /**
                 * @param {?} templateRef
                 */
                function CdkDragPlaceholder(templateRef) {
                    this.templateRef = templateRef;
                }
                return CdkDragPlaceholder;
            }());
            CdkDragPlaceholder.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Directive"], args: [{
                            selector: 'ng-template[cdkDragPlaceholder]'
                        },] },
            ];
            /** @nocollapse */
            CdkDragPlaceholder.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["TemplateRef"] }
            ]; };
            CdkDragPlaceholder.propDecorators = {
                data: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Element that will be used as a template for the preview
             * of a CdkDrag when it is being dragged.
             * @template T
             */
            var CdkDragPreview = /** @class */ (function () {
                /**
                 * @param {?} templateRef
                 */
                function CdkDragPreview(templateRef) {
                    this.templateRef = templateRef;
                }
                return CdkDragPreview;
            }());
            CdkDragPreview.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Directive"], args: [{
                            selector: 'ng-template[cdkDragPreview]'
                        },] },
            ];
            /** @nocollapse */
            CdkDragPreview.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["TemplateRef"] }
            ]; };
            CdkDragPreview.propDecorators = {
                data: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to configure the behavior of `CdkDrag`.
             * @type {?}
             */
            var CDK_DRAG_CONFIG = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["InjectionToken"]('CDK_DRAG_CONFIG', {
                providedIn: 'root',
                factory: CDK_DRAG_CONFIG_FACTORY
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function CDK_DRAG_CONFIG_FACTORY() {
                return { dragStartThreshold: 5, pointerDirectionChangeThreshold: 5 };
            }
            /**
             * Element that can be moved inside a CdkDropList container.
             * @template T
             */
            var CdkDrag = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?} dropContainer
                 * @param {?} _document
                 * @param {?} _ngZone
                 * @param {?} _viewContainerRef
                 * @param {?} config
                 * @param {?} _dir
                 * @param {?} dragDrop
                 * @param {?} _changeDetectorRef
                 */
                function CdkDrag(element, dropContainer, _document, _ngZone, _viewContainerRef, config, _dir, dragDrop, _changeDetectorRef) {
                    var _this = this;
                    this.element = element;
                    this.dropContainer = dropContainer;
                    this._document = _document;
                    this._ngZone = _ngZone;
                    this._viewContainerRef = _viewContainerRef;
                    this._dir = _dir;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Amount of milliseconds to wait after the user has put their
                     * pointer down before starting to drag the element.
                     */
                    this.dragStartDelay = 0;
                    this._disabled = false;
                    /**
                     * Emits when the user starts dragging the item.
                     */
                    this.started = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user has released a drag item, before any animations have started.
                     */
                    this.released = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user stops dragging an item in the container.
                     */
                    this.ended = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user has moved the item into a new container.
                     */
                    this.entered = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user removes the item its container by dragging it into another container.
                     */
                    this.exited = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user drops the item inside a container.
                     */
                    this.dropped = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits as the user is dragging the item. Use with caution,
                     * because this event will fire for every pixel that the user has dragged.
                     */
                    this.moved = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        /** @type {?} */
                        var subscription = _this._dragRef.moved.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} movedEvent
                         * @return {?}
                         */function (/**
                         * @param {?} movedEvent
                         * @return {?}
                         */ movedEvent) { return ({
                            source: _this,
                            pointerPosition: movedEvent.pointerPosition,
                            event: movedEvent.event,
                            delta: movedEvent.delta,
                            distance: movedEvent.distance
                        }); }))).subscribe(observer);
                        return ( /**
                         * @return {?}
                         */function () {
                            subscription.unsubscribe();
                        });
                    }));
                    this._dragRef = dragDrop.createDrag(element, config);
                    this._dragRef.data = this;
                    this._syncInputs(this._dragRef);
                    this._handleEvents(this._dragRef);
                }
                Object.defineProperty(CdkDrag.prototype, "boundaryElementSelector", {
                    /**
                     * Selector that will be used to determine the element to which the draggable's position will
                     * be constrained. Matching starts from the element's parent and goes up the DOM until a matching
                     * element has been found
                     * @deprecated Use `boundaryElement` instead.
                     * \@breaking-change 9.0.0
                     * @return {?}
                     */
                    get: function () {
                        return typeof this.boundaryElement === 'string' ? this.boundaryElement : ( /** @type {?} */(undefined));
                    },
                    /**
                     * @param {?} selector
                     * @return {?}
                     */
                    set: function (selector) {
                        this.boundaryElement = selector;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkDrag.prototype, "disabled", {
                    /**
                     * Whether starting to drag this element is disabled.
                     * @return {?}
                     */
                    get: function () {
                        return this._disabled || (this.dropContainer && this.dropContainer.disabled);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        this._dragRef.disabled = this._disabled;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Returns the element that is being used as a placeholder
                 * while the current element is being dragged.
                 * @return {?}
                 */
                CdkDrag.prototype.getPlaceholderElement = function () {
                    return this._dragRef.getPlaceholderElement();
                };
                /**
                 * Returns the root draggable element.
                 * @return {?}
                 */
                CdkDrag.prototype.getRootElement = function () {
                    return this._dragRef.getRootElement();
                };
                /**
                 * Resets a standalone drag item to its initial position.
                 * @return {?}
                 */
                CdkDrag.prototype.reset = function () {
                    this._dragRef.reset();
                };
                /**
                 * Gets the pixel coordinates of the draggable outside of a drop container.
                 * @return {?}
                 */
                CdkDrag.prototype.getFreeDragPosition = function () {
                    return this._dragRef.getFreeDragPosition();
                };
                /**
                 * @return {?}
                 */
                CdkDrag.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    // We need to wait for the zone to stabilize, in order for the reference
                    // element to be in the proper place in the DOM. This is mostly relevant
                    // for draggable elements inside portals since they get stamped out in
                    // their original DOM position and then they get transferred to the portal.
                    this._ngZone.onStable.asObservable()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._updateRootElement();
                        // Listen for any newly-added handles.
                        _this._handles.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(_this._handles), 
                        // Sync the new handles with the DragRef.
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                         * @param {?} handles
                         * @return {?}
                         */function (handles) {
                            /** @type {?} */
                            var childHandleElements = handles
                                .filter(( /**
                         * @param {?} handle
                         * @return {?}
                         */function (/**
                         * @param {?} handle
                         * @return {?}
                         */ handle) { return handle._parentDrag === _this; }))
                                .map(( /**
                         * @param {?} handle
                         * @return {?}
                         */function (/**
                         * @param {?} handle
                         * @return {?}
                         */ handle) { return handle.element; }));
                            _this._dragRef.withHandles(childHandleElements);
                        })), 
                        // Listen if the state of any of the handles changes.
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                         * @param {?} handles
                         * @return {?}
                         */function (handles) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["merge"]).apply(void 0, handles.map(( /**
                             * @param {?} item
                             * @return {?}
                             */function (/**
                             * @param {?} item
                             * @return {?}
                             */ item) { return item._stateChanges; })));
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(_this._destroyed)).subscribe(( /**
                         * @param {?} handleInstance
                         * @return {?}
                         */function (/**
                         * @param {?} handleInstance
                         * @return {?}
                         */ handleInstance) {
                            // Enabled/disable the handle that changed in the DragRef.
                            /** @type {?} */
                            var dragRef = _this._dragRef;
                            /** @type {?} */
                            var handle = handleInstance.element.nativeElement;
                            handleInstance.disabled ? dragRef.disableHandle(handle) : dragRef.enableHandle(handle);
                        }));
                        if (_this.freeDragPosition) {
                            _this._dragRef.setFreeDragPosition(_this.freeDragPosition);
                        }
                    }));
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                CdkDrag.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var rootSelectorChange = changes['rootElementSelector'];
                    /** @type {?} */
                    var positionChange = changes['freeDragPosition'];
                    // We don't have to react to the first change since it's being
                    // handled in `ngAfterViewInit` where it needs to be deferred.
                    if (rootSelectorChange && !rootSelectorChange.firstChange) {
                        this._updateRootElement();
                    }
                    // Skip the first change since it's being handled in `ngAfterViewInit`.
                    if (positionChange && !positionChange.firstChange && this.freeDragPosition) {
                        this._dragRef.setFreeDragPosition(this.freeDragPosition);
                    }
                };
                /**
                 * @return {?}
                 */
                CdkDrag.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                    this._dragRef.dispose();
                };
                /**
                 * Syncs the root element with the `DragRef`.
                 * @private
                 * @return {?}
                 */
                CdkDrag.prototype._updateRootElement = function () {
                    /** @type {?} */
                    var element = this.element.nativeElement;
                    /** @type {?} */
                    var rootElement = this.rootElementSelector ?
                        getClosestMatchingAncestor(element, this.rootElementSelector) : element;
                    if (rootElement && rootElement.nodeType !== this._document.ELEMENT_NODE) {
                        throw Error("cdkDrag must be attached to an element node. " +
                            ("Currently attached to \"" + rootElement.nodeName + "\"."));
                    }
                    this._dragRef.withRootElement(rootElement || element);
                };
                /**
                 * Gets the boundary element, based on the `boundaryElement` value.
                 * @private
                 * @return {?}
                 */
                CdkDrag.prototype._getBoundaryElement = function () {
                    /** @type {?} */
                    var boundary = this.boundaryElement;
                    if (!boundary) {
                        return null;
                    }
                    if (typeof boundary === 'string') {
                        return getClosestMatchingAncestor(this.element.nativeElement, boundary);
                    }
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceElement"])(boundary);
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["isDevMode"])() && !element.contains(this.element.nativeElement)) {
                        throw Error('Draggable element is not inside of the node passed into cdkDragBoundary.');
                    }
                    return element;
                };
                /**
                 * Syncs the inputs of the CdkDrag with the options of the underlying DragRef.
                 * @private
                 * @param {?} ref
                 * @return {?}
                 */
                CdkDrag.prototype._syncInputs = function (ref) {
                    var _this = this;
                    ref.beforeStarted.subscribe(( /**
                     * @return {?}
                     */function () {
                        if (!ref.isDragging()) {
                            /** @type {?} */
                            var dir = _this._dir;
                            /** @type {?} */
                            var placeholder = _this._placeholderTemplate ? {
                                template: _this._placeholderTemplate.templateRef,
                                context: _this._placeholderTemplate.data,
                                viewContainer: _this._viewContainerRef
                            } : null;
                            /** @type {?} */
                            var preview = _this._previewTemplate ? {
                                template: _this._previewTemplate.templateRef,
                                context: _this._previewTemplate.data,
                                viewContainer: _this._viewContainerRef
                            } : null;
                            ref.disabled = _this.disabled;
                            ref.lockAxis = _this.lockAxis;
                            ref.dragStartDelay = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceNumberProperty"])(_this.dragStartDelay);
                            ref.constrainPosition = _this.constrainPosition;
                            ref
                                .withBoundaryElement(_this._getBoundaryElement())
                                .withPlaceholderTemplate(placeholder)
                                .withPreviewTemplate(preview);
                            if (dir) {
                                ref.withDirection(dir.value);
                            }
                        }
                    }));
                };
                /**
                 * Handles the events from the underlying `DragRef`.
                 * @private
                 * @param {?} ref
                 * @return {?}
                 */
                CdkDrag.prototype._handleEvents = function (ref) {
                    var _this = this;
                    ref.started.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this.started.emit({ source: _this });
                        // Since all of these events run outside of change detection,
                        // we need to ensure that everything is marked correctly.
                        _this._changeDetectorRef.markForCheck();
                    }));
                    ref.released.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this.released.emit({ source: _this });
                    }));
                    ref.ended.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.ended.emit({ source: _this, distance: event.distance });
                        // Since all of these events run outside of change detection,
                        // we need to ensure that everything is marked correctly.
                        _this._changeDetectorRef.markForCheck();
                    }));
                    ref.entered.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.entered.emit({
                            container: event.container.data,
                            item: _this,
                            currentIndex: event.currentIndex
                        });
                    }));
                    ref.exited.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.exited.emit({
                            container: event.container.data,
                            item: _this
                        });
                    }));
                    ref.dropped.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.dropped.emit({
                            previousIndex: event.previousIndex,
                            currentIndex: event.currentIndex,
                            previousContainer: event.previousContainer.data,
                            container: event.container.data,
                            isPointerOverContainer: event.isPointerOverContainer,
                            item: _this,
                            distance: event.distance
                        });
                    }));
                };
                return CdkDrag;
            }());
            CdkDrag.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Directive"], args: [{
                            selector: '[cdkDrag]',
                            exportAs: 'cdkDrag',
                            host: {
                                'class': 'cdk-drag',
                                '[class.cdk-drag-disabled]': 'disabled',
                                '[class.cdk-drag-dragging]': '_dragRef.isDragging()',
                            },
                            providers: [{ provide: CDK_DRAG_PARENT, useExisting: CdkDrag }]
                        },] },
            ];
            /** @nocollapse */
            CdkDrag.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [CDK_DROP_LIST,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["SkipSelf"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [CDK_DRAG_CONFIG,] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }] },
                { type: DragDrop },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ChangeDetectorRef"] }
            ]; };
            CdkDrag.propDecorators = {
                _handles: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ContentChildren"], args: [CdkDragHandle, { descendants: true },] }],
                _previewTemplate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ContentChild"], args: [CdkDragPreview, { static: false },] }],
                _placeholderTemplate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ContentChild"], args: [CdkDragPlaceholder, { static: false },] }],
                data: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragData',] }],
                lockAxis: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragLockAxis',] }],
                rootElementSelector: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragRootElement',] }],
                boundaryElement: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragBoundary',] }],
                dragStartDelay: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragStartDelay',] }],
                freeDragPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragFreeDragPosition',] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragDisabled',] }],
                constrainPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDragConstrainPosition',] }],
                started: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragStarted',] }],
                released: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragReleased',] }],
                ended: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragEnded',] }],
                entered: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragEntered',] }],
                exited: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragExited',] }],
                dropped: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragDropped',] }],
                moved: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDragMoved',] }]
            };
            /**
             * Gets the closest ancestor of an element that matches a selector.
             * @param {?} element
             * @param {?} selector
             * @return {?}
             */
            function getClosestMatchingAncestor(element, selector) {
                /** @type {?} */
                var currentElement = ( /** @type {?} */(element.parentElement));
                while (currentElement) {
                    // IE doesn't support `matches` so we have to fall back to `msMatchesSelector`.
                    if (currentElement.matches ? currentElement.matches(selector) :
                        (( /** @type {?} */(currentElement))).msMatchesSelector(selector)) {
                        return currentElement;
                    }
                    currentElement = currentElement.parentElement;
                }
                return null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Declaratively connects sibling `cdkDropList` instances together. All of the `cdkDropList`
             * elements that are placed inside a `cdkDropListGroup` will be connected to each other
             * automatically. Can be used as an alternative to the `cdkDropListConnectedTo` input
             * from `cdkDropList`.
             * @template T
             */
            var CdkDropListGroup = /** @class */ (function () {
                function CdkDropListGroup() {
                    /**
                     * Drop lists registered inside the group.
                     */
                    this._items = new Set();
                    this._disabled = false;
                }
                Object.defineProperty(CdkDropListGroup.prototype, "disabled", {
                    /**
                     * Whether starting a dragging sequence from inside this group is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkDropListGroup.prototype.ngOnDestroy = function () {
                    this._items.clear();
                };
                return CdkDropListGroup;
            }());
            CdkDropListGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Directive"], args: [{
                            selector: '[cdkDropListGroup]',
                            exportAs: 'cdkDropListGroup',
                        },] },
            ];
            CdkDropListGroup.propDecorators = {
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListGroupDisabled',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Counter used to generate unique ids for drop zones.
             * @type {?}
             */
            var _uniqueIdCounter$1 = 0;
            var ɵ0 = undefined;
            // @breaking-change 8.0.0 `CdkDropList` implements `CdkDropListContainer` for backwards
            // compatiblity. The implements clause, as well as all the methods that it enforces can
            // be removed when `CdkDropListContainer` is deleted.
            /**
             * Container that wraps a set of draggable items.
             * @template T
             */
            var CdkDropList = /** @class */ (function () {
                /**
                 * @param {?} element
                 * @param {?} dragDrop
                 * @param {?} _changeDetectorRef
                 * @param {?=} _dir
                 * @param {?=} _group
                 */
                function CdkDropList(element, dragDrop, _changeDetectorRef, _dir, _group) {
                    var _this = this;
                    this.element = element;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._dir = _dir;
                    this._group = _group;
                    /**
                     * Emits when the list has been destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Other draggable containers that this container is connected to and into which the
                     * container's items can be transferred. Can either be references to other drop containers,
                     * or their unique IDs.
                     */
                    this.connectedTo = [];
                    /**
                     * Direction in which the list is oriented.
                     */
                    this.orientation = 'vertical';
                    /**
                     * Unique ID for the drop zone. Can be used as a reference
                     * in the `connectedTo` of another `CdkDropList`.
                     */
                    this.id = "cdk-drop-list-" + _uniqueIdCounter$1++;
                    this._disabled = false;
                    this._sortingDisabled = false;
                    /**
                     * Function that is used to determine whether an item
                     * is allowed to be moved into a drop container.
                     */
                    this.enterPredicate = ( /**
                     * @return {?}
                     */function () { return true; });
                    /**
                     * Whether to auto-scroll the view when the user moves their pointer close to the edges.
                     */
                    this.autoScrollDisabled = false;
                    /**
                     * Emits when the user drops an item inside the container.
                     */
                    this.dropped = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user has moved a new drag item into this container.
                     */
                    this.entered = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the user removes an item from the container
                     * by dragging it into another container.
                     */
                    this.exited = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits as the user is swapping items while actively dragging.
                     */
                    this.sorted = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    this._dropListRef = dragDrop.createDropList(element);
                    this._dropListRef.data = this;
                    this._dropListRef.enterPredicate = ( /**
                     * @param {?} drag
                     * @param {?} drop
                     * @return {?}
                     */function (drag, drop) {
                        return _this.enterPredicate(drag.data, drop.data);
                    });
                    this._syncInputs(this._dropListRef);
                    this._handleEvents(this._dropListRef);
                    CdkDropList._dropLists.push(this);
                    if (_group) {
                        _group._items.add(this);
                    }
                }
                Object.defineProperty(CdkDropList.prototype, "disabled", {
                    /**
                     * Whether starting a dragging sequence from this container is disabled.
                     * @return {?}
                     */
                    get: function () {
                        return this._disabled || (!!this._group && this._group.disabled);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkDropList.prototype, "sortingDisabled", {
                    /**
                     * Whether sorting within this drop list is disabled.
                     * @return {?}
                     */
                    get: function () { return this._sortingDisabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._sortingDisabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkDropList.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._draggables.changes
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(this._draggables), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @param {?} items
                 * @return {?}
                 */function (items) {
                        _this._dropListRef.withItems(items.map(( /**
                         * @param {?} drag
                         * @return {?}
                         */function (/**
                         * @param {?} drag
                         * @return {?}
                         */ drag) { return drag._dragRef; })));
                    }));
                };
                /**
                 * @return {?}
                 */
                CdkDropList.prototype.ngOnDestroy = function () {
                    /** @type {?} */
                    var index = CdkDropList._dropLists.indexOf(this);
                    if (index > -1) {
                        CdkDropList._dropLists.splice(index, 1);
                    }
                    if (this._group) {
                        this._group._items.delete(this);
                    }
                    this._dropListRef.dispose();
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Starts dragging an item.
                 * @return {?}
                 */
                CdkDropList.prototype.start = function () {
                    this._dropListRef.start();
                };
                /**
                 * Drops an item into this container.
                 * @param {?} item Item being dropped into the container.
                 * @param {?} currentIndex Index at which the item should be inserted.
                 * @param {?} previousContainer Container from which the item got dragged in.
                 * @param {?} isPointerOverContainer Whether the user's pointer was over the
                 *    container when the item was dropped.
                 * @return {?}
                 */
                CdkDropList.prototype.drop = function (item, currentIndex, previousContainer, isPointerOverContainer) {
                    this._dropListRef.drop(item._dragRef, currentIndex, (( /** @type {?} */(previousContainer)))._dropListRef, isPointerOverContainer);
                };
                /**
                 * Emits an event to indicate that the user moved an item into the container.
                 * @param {?} item Item that was moved into the container.
                 * @param {?} pointerX Position of the item along the X axis.
                 * @param {?} pointerY Position of the item along the Y axis.
                 * @return {?}
                 */
                CdkDropList.prototype.enter = function (item, pointerX, pointerY) {
                    this._dropListRef.enter(item._dragRef, pointerX, pointerY);
                };
                /**
                 * Removes an item from the container after it was dragged into another container by the user.
                 * @param {?} item Item that was dragged out.
                 * @return {?}
                 */
                CdkDropList.prototype.exit = function (item) {
                    this._dropListRef.exit(item._dragRef);
                };
                /**
                 * Figures out the index of an item in the container.
                 * @param {?} item Item whose index should be determined.
                 * @return {?}
                 */
                CdkDropList.prototype.getItemIndex = function (item) {
                    return this._dropListRef.getItemIndex(item._dragRef);
                };
                /**
                 * Sorts an item inside the container based on its position.
                 * @param {?} item Item to be sorted.
                 * @param {?} pointerX Position of the item along the X axis.
                 * @param {?} pointerY Position of the item along the Y axis.
                 * @param {?} pointerDelta Direction in which the pointer is moving along each axis.
                 * @return {?}
                 */
                CdkDropList.prototype._sortItem = function (item, pointerX, pointerY, pointerDelta) {
                    return this._dropListRef._sortItem(item._dragRef, pointerX, pointerY, pointerDelta);
                };
                /**
                 * Figures out whether an item should be moved into a sibling
                 * drop container, based on its current position.
                 * @param {?} item Drag item that is being moved.
                 * @param {?} x Position of the item along the X axis.
                 * @param {?} y Position of the item along the Y axis.
                 * @return {?}
                 */
                CdkDropList.prototype._getSiblingContainerFromPosition = function (item, x, y) {
                    /** @type {?} */
                    var result = this._dropListRef._getSiblingContainerFromPosition(item._dragRef, x, y);
                    return result ? result.data : null;
                };
                /**
                 * Checks whether the user's pointer is positioned over the container.
                 * @param {?} x Pointer position along the X axis.
                 * @param {?} y Pointer position along the Y axis.
                 * @return {?}
                 */
                CdkDropList.prototype._isOverContainer = function (x, y) {
                    return this._dropListRef._isOverContainer(x, y);
                };
                /**
                 * Syncs the inputs of the CdkDropList with the options of the underlying DropListRef.
                 * @private
                 * @param {?} ref
                 * @return {?}
                 */
                CdkDropList.prototype._syncInputs = function (ref) {
                    var _this = this;
                    if (this._dir) {
                        this._dir.change
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(this._dir.value), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this._destroyed))
                            .subscribe(( /**
                     * @param {?} value
                     * @return {?}
                     */function (/**
                     * @param {?} value
                     * @return {?}
                     */ value) { return ref.withDirection(value); }));
                    }
                    ref.beforeStarted.subscribe(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var siblings = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceArray"])(_this.connectedTo).map(( /**
                         * @param {?} drop
                         * @return {?}
                         */function (/**
                         * @param {?} drop
                         * @return {?}
                         */ drop) {
                            return typeof drop === 'string' ?
                                ( /** @type {?} */(CdkDropList._dropLists.find(( /**
                                 * @param {?} list
                                 * @return {?}
                                 */function (/**
                                 * @param {?} list
                                 * @return {?}
                                 */ list) { return list.id === drop; })))) : drop;
                        }));
                        if (_this._group) {
                            _this._group._items.forEach(( /**
                             * @param {?} drop
                             * @return {?}
                             */function (/**
                             * @param {?} drop
                             * @return {?}
                             */ drop) {
                                if (siblings.indexOf(drop) === -1) {
                                    siblings.push(drop);
                                }
                            }));
                        }
                        ref.disabled = _this.disabled;
                        ref.lockAxis = _this.lockAxis;
                        ref.sortingDisabled = _this.sortingDisabled;
                        ref.autoScrollDisabled = _this.autoScrollDisabled;
                        ref
                            .connectedTo(siblings.filter(( /**
                     * @param {?} drop
                     * @return {?}
                     */function (/**
                     * @param {?} drop
                     * @return {?}
                     */ drop) { return drop && drop !== _this; })).map(( /**
                         * @param {?} list
                         * @return {?}
                         */function (/**
                         * @param {?} list
                         * @return {?}
                         */ list) { return list._dropListRef; })))
                            .withOrientation(_this.orientation);
                    }));
                };
                /**
                 * Handles events from the underlying DropListRef.
                 * @private
                 * @param {?} ref
                 * @return {?}
                 */
                CdkDropList.prototype._handleEvents = function (ref) {
                    var _this = this;
                    ref.beforeStarted.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._changeDetectorRef.markForCheck();
                    }));
                    ref.entered.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.entered.emit({
                            container: _this,
                            item: event.item.data,
                            currentIndex: event.currentIndex
                        });
                    }));
                    ref.exited.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.exited.emit({
                            container: _this,
                            item: event.item.data
                        });
                        _this._changeDetectorRef.markForCheck();
                    }));
                    ref.sorted.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.sorted.emit({
                            previousIndex: event.previousIndex,
                            currentIndex: event.currentIndex,
                            container: _this,
                            item: event.item.data
                        });
                    }));
                    ref.dropped.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.dropped.emit({
                            previousIndex: event.previousIndex,
                            currentIndex: event.currentIndex,
                            previousContainer: event.previousContainer.data,
                            container: event.container.data,
                            item: event.item.data,
                            isPointerOverContainer: event.isPointerOverContainer,
                            distance: event.distance
                        });
                        // Mark for check since all of these events run outside of change
                        // detection and we're not guaranteed for something else to have triggered it.
                        _this._changeDetectorRef.markForCheck();
                    }));
                };
                return CdkDropList;
            }());
            /**
             * Keeps track of the drop lists that are currently on the page.
             */
            CdkDropList._dropLists = [];
            CdkDropList.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Directive"], args: [{
                            selector: '[cdkDropList], cdk-drop-list',
                            exportAs: 'cdkDropList',
                            providers: [
                                // Prevent child drop lists from picking up the same group as their parent.
                                { provide: CdkDropListGroup, useValue: ɵ0 },
                                { provide: CDK_DROP_LIST_CONTAINER, useExisting: CdkDropList },
                            ],
                            host: {
                                'class': 'cdk-drop-list',
                                '[id]': 'id',
                                '[class.cdk-drop-list-disabled]': 'disabled',
                                '[class.cdk-drop-list-dragging]': '_dropListRef.isDragging()',
                                '[class.cdk-drop-list-receiving]': '_dropListRef.isReceiving()',
                            }
                        },] },
            ];
            /** @nocollapse */
            CdkDropList.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ElementRef"] },
                { type: DragDrop },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ChangeDetectorRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }] },
                { type: CdkDropListGroup, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["SkipSelf"] }] }
            ]; };
            CdkDropList.propDecorators = {
                _draggables: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ContentChildren"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["forwardRef"])(( /**
                                         * @return {?}
                                         */function () { return CdkDrag; })), {
                                // Explicitly set to false since some of the logic below makes assumptions about it.
                                // The `.withItems` call below should be updated if we ever need to switch this to `true`.
                                descendants: false
                            },] }],
                connectedTo: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListConnectedTo',] }],
                data: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListData',] }],
                orientation: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListOrientation',] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                lockAxis: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListLockAxis',] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListDisabled',] }],
                sortingDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListSortingDisabled',] }],
                enterPredicate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListEnterPredicate',] }],
                autoScrollDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"], args: ['cdkDropListAutoScrollDisabled',] }],
                dropped: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDropListDropped',] }],
                entered: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDropListEntered',] }],
                exited: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDropListExited',] }],
                sorted: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"], args: ['cdkDropListSorted',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var DragDropModule = /** @class */ (function () {
                function DragDropModule() {
                }
                return DragDropModule;
            }());
            DragDropModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["NgModule"], args: [{
                            declarations: [
                                CdkDropList,
                                CdkDropListGroup,
                                CdkDrag,
                                CdkDragHandle,
                                CdkDragPreview,
                                CdkDragPlaceholder,
                            ],
                            exports: [
                                CdkDropList,
                                CdkDropListGroup,
                                CdkDrag,
                                CdkDragHandle,
                                CdkDragPreview,
                                CdkDragPlaceholder,
                            ],
                            providers: [
                                DragDrop,
                            ]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=drag-drop.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/keycodes.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/keycodes.js ***!
          \*******************************************************/
        /*! exports provided: MAC_ENTER, BACKSPACE, TAB, NUM_CENTER, ENTER, SHIFT, CONTROL, ALT, PAUSE, CAPS_LOCK, ESCAPE, SPACE, PAGE_UP, PAGE_DOWN, END, HOME, LEFT_ARROW, UP_ARROW, RIGHT_ARROW, DOWN_ARROW, PLUS_SIGN, PRINT_SCREEN, INSERT, DELETE, ZERO, ONE, TWO, THREE, FOUR, FIVE, SIX, SEVEN, EIGHT, NINE, FF_SEMICOLON, FF_EQUALS, QUESTION_MARK, AT_SIGN, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, META, MAC_WK_CMD_LEFT, MAC_WK_CMD_RIGHT, CONTEXT_MENU, NUMPAD_ZERO, NUMPAD_ONE, NUMPAD_TWO, NUMPAD_THREE, NUMPAD_FOUR, NUMPAD_FIVE, NUMPAD_SIX, NUMPAD_SEVEN, NUMPAD_EIGHT, NUMPAD_NINE, NUMPAD_MULTIPLY, NUMPAD_PLUS, NUMPAD_MINUS, NUMPAD_PERIOD, NUMPAD_DIVIDE, F1, F2, F3, F4, F5, F6, F7, F8, F9, F10, F11, F12, NUM_LOCK, SCROLL_LOCK, FIRST_MEDIA, FF_MINUS, MUTE, VOLUME_DOWN, VOLUME_UP, FF_MUTE, FF_VOLUME_DOWN, LAST_MEDIA, FF_VOLUME_UP, SEMICOLON, EQUALS, COMMA, DASH, SLASH, APOSTROPHE, TILDE, OPEN_SQUARE_BRACKET, BACKSLASH, CLOSE_SQUARE_BRACKET, SINGLE_QUOTE, MAC_META, hasModifierKey */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAC_ENTER", function () { return MAC_ENTER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKSPACE", function () { return BACKSPACE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB", function () { return TAB; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUM_CENTER", function () { return NUM_CENTER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER", function () { return ENTER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIFT", function () { return SHIFT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL", function () { return CONTROL; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALT", function () { return ALT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAUSE", function () { return PAUSE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAPS_LOCK", function () { return CAPS_LOCK; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ESCAPE", function () { return ESCAPE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPACE", function () { return SPACE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_UP", function () { return PAGE_UP; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_DOWN", function () { return PAGE_DOWN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END", function () { return END; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME", function () { return HOME; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEFT_ARROW", function () { return LEFT_ARROW; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UP_ARROW", function () { return UP_ARROW; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RIGHT_ARROW", function () { return RIGHT_ARROW; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWN_ARROW", function () { return DOWN_ARROW; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS_SIGN", function () { return PLUS_SIGN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRINT_SCREEN", function () { return PRINT_SCREEN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INSERT", function () { return INSERT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE", function () { return DELETE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZERO", function () { return ZERO; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONE", function () { return ONE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWO", function () { return TWO; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THREE", function () { return THREE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOUR", function () { return FOUR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIVE", function () { return FIVE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIX", function () { return SIX; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEVEN", function () { return SEVEN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EIGHT", function () { return EIGHT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NINE", function () { return NINE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FF_SEMICOLON", function () { return FF_SEMICOLON; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FF_EQUALS", function () { return FF_EQUALS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUESTION_MARK", function () { return QUESTION_MARK; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AT_SIGN", function () { return AT_SIGN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function () { return A; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function () { return B; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function () { return C; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function () { return D; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function () { return E; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function () { return F; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function () { return G; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function () { return H; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function () { return I; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function () { return J; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function () { return K; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function () { return L; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function () { return M; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function () { return N; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function () { return O; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function () { return P; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function () { return Q; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function () { return R; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function () { return S; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function () { return T; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function () { return U; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function () { return V; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function () { return W; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function () { return X; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function () { return Y; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function () { return Z; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "META", function () { return META; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAC_WK_CMD_LEFT", function () { return MAC_WK_CMD_LEFT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAC_WK_CMD_RIGHT", function () { return MAC_WK_CMD_RIGHT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_MENU", function () { return CONTEXT_MENU; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_ZERO", function () { return NUMPAD_ZERO; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_ONE", function () { return NUMPAD_ONE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_TWO", function () { return NUMPAD_TWO; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_THREE", function () { return NUMPAD_THREE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_FOUR", function () { return NUMPAD_FOUR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_FIVE", function () { return NUMPAD_FIVE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_SIX", function () { return NUMPAD_SIX; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_SEVEN", function () { return NUMPAD_SEVEN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_EIGHT", function () { return NUMPAD_EIGHT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_NINE", function () { return NUMPAD_NINE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_MULTIPLY", function () { return NUMPAD_MULTIPLY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_PLUS", function () { return NUMPAD_PLUS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_MINUS", function () { return NUMPAD_MINUS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_PERIOD", function () { return NUMPAD_PERIOD; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMPAD_DIVIDE", function () { return NUMPAD_DIVIDE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F1", function () { return F1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F2", function () { return F2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F3", function () { return F3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F4", function () { return F4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F5", function () { return F5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F6", function () { return F6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F7", function () { return F7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F8", function () { return F8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F9", function () { return F9; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F10", function () { return F10; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F11", function () { return F11; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F12", function () { return F12; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUM_LOCK", function () { return NUM_LOCK; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCROLL_LOCK", function () { return SCROLL_LOCK; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRST_MEDIA", function () { return FIRST_MEDIA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FF_MINUS", function () { return FF_MINUS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUTE", function () { return MUTE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOLUME_DOWN", function () { return VOLUME_DOWN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOLUME_UP", function () { return VOLUME_UP; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FF_MUTE", function () { return FF_MUTE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FF_VOLUME_DOWN", function () { return FF_VOLUME_DOWN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_MEDIA", function () { return LAST_MEDIA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FF_VOLUME_UP", function () { return FF_VOLUME_UP; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEMICOLON", function () { return SEMICOLON; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EQUALS", function () { return EQUALS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMA", function () { return COMMA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DASH", function () { return DASH; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLASH", function () { return SLASH; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APOSTROPHE", function () { return APOSTROPHE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TILDE", function () { return TILDE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPEN_SQUARE_BRACKET", function () { return OPEN_SQUARE_BRACKET; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKSLASH", function () { return BACKSLASH; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOSE_SQUARE_BRACKET", function () { return CLOSE_SQUARE_BRACKET; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SINGLE_QUOTE", function () { return SINGLE_QUOTE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAC_META", function () { return MAC_META; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasModifierKey", function () { return hasModifierKey; });
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAC_ENTER = 3;
            /** @type {?} */
            var BACKSPACE = 8;
            /** @type {?} */
            var TAB = 9;
            /** @type {?} */
            var NUM_CENTER = 12;
            /** @type {?} */
            var ENTER = 13;
            /** @type {?} */
            var SHIFT = 16;
            /** @type {?} */
            var CONTROL = 17;
            /** @type {?} */
            var ALT = 18;
            /** @type {?} */
            var PAUSE = 19;
            /** @type {?} */
            var CAPS_LOCK = 20;
            /** @type {?} */
            var ESCAPE = 27;
            /** @type {?} */
            var SPACE = 32;
            /** @type {?} */
            var PAGE_UP = 33;
            /** @type {?} */
            var PAGE_DOWN = 34;
            /** @type {?} */
            var END = 35;
            /** @type {?} */
            var HOME = 36;
            /** @type {?} */
            var LEFT_ARROW = 37;
            /** @type {?} */
            var UP_ARROW = 38;
            /** @type {?} */
            var RIGHT_ARROW = 39;
            /** @type {?} */
            var DOWN_ARROW = 40;
            /** @type {?} */
            var PLUS_SIGN = 43;
            /** @type {?} */
            var PRINT_SCREEN = 44;
            /** @type {?} */
            var INSERT = 45;
            /** @type {?} */
            var DELETE = 46;
            /** @type {?} */
            var ZERO = 48;
            /** @type {?} */
            var ONE = 49;
            /** @type {?} */
            var TWO = 50;
            /** @type {?} */
            var THREE = 51;
            /** @type {?} */
            var FOUR = 52;
            /** @type {?} */
            var FIVE = 53;
            /** @type {?} */
            var SIX = 54;
            /** @type {?} */
            var SEVEN = 55;
            /** @type {?} */
            var EIGHT = 56;
            /** @type {?} */
            var NINE = 57;
            /** @type {?} */
            var FF_SEMICOLON = 59;
            // Firefox (Gecko) fires this for semicolon instead of 186
            /** @type {?} */
            var FF_EQUALS = 61;
            // Firefox (Gecko) fires this for equals instead of 187
            /** @type {?} */
            var QUESTION_MARK = 63;
            /** @type {?} */
            var AT_SIGN = 64;
            /** @type {?} */
            var A = 65;
            /** @type {?} */
            var B = 66;
            /** @type {?} */
            var C = 67;
            /** @type {?} */
            var D = 68;
            /** @type {?} */
            var E = 69;
            /** @type {?} */
            var F = 70;
            /** @type {?} */
            var G = 71;
            /** @type {?} */
            var H = 72;
            /** @type {?} */
            var I = 73;
            /** @type {?} */
            var J = 74;
            /** @type {?} */
            var K = 75;
            /** @type {?} */
            var L = 76;
            /** @type {?} */
            var M = 77;
            /** @type {?} */
            var N = 78;
            /** @type {?} */
            var O = 79;
            /** @type {?} */
            var P = 80;
            /** @type {?} */
            var Q = 81;
            /** @type {?} */
            var R = 82;
            /** @type {?} */
            var S = 83;
            /** @type {?} */
            var T = 84;
            /** @type {?} */
            var U = 85;
            /** @type {?} */
            var V = 86;
            /** @type {?} */
            var W = 87;
            /** @type {?} */
            var X = 88;
            /** @type {?} */
            var Y = 89;
            /** @type {?} */
            var Z = 90;
            /** @type {?} */
            var META = 91;
            // WIN_KEY_LEFT
            /** @type {?} */
            var MAC_WK_CMD_LEFT = 91;
            /** @type {?} */
            var MAC_WK_CMD_RIGHT = 93;
            /** @type {?} */
            var CONTEXT_MENU = 93;
            /** @type {?} */
            var NUMPAD_ZERO = 96;
            /** @type {?} */
            var NUMPAD_ONE = 97;
            /** @type {?} */
            var NUMPAD_TWO = 98;
            /** @type {?} */
            var NUMPAD_THREE = 99;
            /** @type {?} */
            var NUMPAD_FOUR = 100;
            /** @type {?} */
            var NUMPAD_FIVE = 101;
            /** @type {?} */
            var NUMPAD_SIX = 102;
            /** @type {?} */
            var NUMPAD_SEVEN = 103;
            /** @type {?} */
            var NUMPAD_EIGHT = 104;
            /** @type {?} */
            var NUMPAD_NINE = 105;
            /** @type {?} */
            var NUMPAD_MULTIPLY = 106;
            /** @type {?} */
            var NUMPAD_PLUS = 107;
            /** @type {?} */
            var NUMPAD_MINUS = 109;
            /** @type {?} */
            var NUMPAD_PERIOD = 110;
            /** @type {?} */
            var NUMPAD_DIVIDE = 111;
            /** @type {?} */
            var F1 = 112;
            /** @type {?} */
            var F2 = 113;
            /** @type {?} */
            var F3 = 114;
            /** @type {?} */
            var F4 = 115;
            /** @type {?} */
            var F5 = 116;
            /** @type {?} */
            var F6 = 117;
            /** @type {?} */
            var F7 = 118;
            /** @type {?} */
            var F8 = 119;
            /** @type {?} */
            var F9 = 120;
            /** @type {?} */
            var F10 = 121;
            /** @type {?} */
            var F11 = 122;
            /** @type {?} */
            var F12 = 123;
            /** @type {?} */
            var NUM_LOCK = 144;
            /** @type {?} */
            var SCROLL_LOCK = 145;
            /** @type {?} */
            var FIRST_MEDIA = 166;
            /** @type {?} */
            var FF_MINUS = 173;
            /** @type {?} */
            var MUTE = 173;
            // Firefox (Gecko) fires 181 for MUTE
            /** @type {?} */
            var VOLUME_DOWN = 174;
            // Firefox (Gecko) fires 182 for VOLUME_DOWN
            /** @type {?} */
            var VOLUME_UP = 175;
            // Firefox (Gecko) fires 183 for VOLUME_UP
            /** @type {?} */
            var FF_MUTE = 181;
            /** @type {?} */
            var FF_VOLUME_DOWN = 182;
            /** @type {?} */
            var LAST_MEDIA = 183;
            /** @type {?} */
            var FF_VOLUME_UP = 183;
            /** @type {?} */
            var SEMICOLON = 186;
            // Firefox (Gecko) fires 59 for SEMICOLON
            /** @type {?} */
            var EQUALS = 187;
            // Firefox (Gecko) fires 61 for EQUALS
            /** @type {?} */
            var COMMA = 188;
            /** @type {?} */
            var DASH = 189;
            // Firefox (Gecko) fires 173 for DASH/MINUS
            /** @type {?} */
            var SLASH = 191;
            /** @type {?} */
            var APOSTROPHE = 192;
            /** @type {?} */
            var TILDE = 192;
            /** @type {?} */
            var OPEN_SQUARE_BRACKET = 219;
            /** @type {?} */
            var BACKSLASH = 220;
            /** @type {?} */
            var CLOSE_SQUARE_BRACKET = 221;
            /** @type {?} */
            var SINGLE_QUOTE = 222;
            /** @type {?} */
            var MAC_META = 224;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Checks whether a modifier key is pressed.
             * @param {?} event Event to be checked.
             * @param {...?} modifiers
             * @return {?}
             */
            function hasModifierKey(event) {
                var modifiers = [];
                for (var _c = 1; _c < arguments.length; _c++) {
                    modifiers[_c - 1] = arguments[_c];
                }
                if (modifiers.length) {
                    return modifiers.some(( /**
                     * @param {?} modifier
                     * @return {?}
                     */function (/**
                     * @param {?} modifier
                     * @return {?}
                     */ modifier) { return event[modifier]; }));
                }
                return event.altKey || event.shiftKey || event.ctrlKey || event.metaKey;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=keycodes.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/layout.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/layout.js ***!
          \*****************************************************/
        /*! exports provided: LayoutModule, BreakpointObserver, Breakpoints, MediaMatcher */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutModule", function () { return LayoutModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreakpointObserver", function () { return BreakpointObserver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Breakpoints", function () { return Breakpoints; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaMatcher", function () { return MediaMatcher; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var LayoutModule = /** @class */ (function () {
                function LayoutModule() {
                }
                return LayoutModule;
            }());
            LayoutModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{},] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Global registry for all dynamically-created, injected media queries.
             * @type {?}
             */
            var mediaQueriesForWebkitCompatibility = new Set();
            /**
             * Style tag that holds all of the dynamically-created media queries.
             * @type {?}
             */
            var mediaQueryStyleNode;
            /**
             * A utility for calling matchMedia queries.
             */
            var MediaMatcher = /** @class */ (function () {
                /**
                 * @param {?} _platform
                 */
                function MediaMatcher(_platform) {
                    this._platform = _platform;
                    this._matchMedia = this._platform.isBrowser && window.matchMedia ?
                        // matchMedia is bound to the window scope intentionally as it is an illegal invocation to
                        // call it from a different scope.
                        window.matchMedia.bind(window) :
                        noopMatchMedia;
                }
                /**
                 * Evaluates the given media query and returns the native MediaQueryList from which results
                 * can be retrieved.
                 * Confirms the layout engine will trigger for the selector query provided and returns the
                 * MediaQueryList for the query provided.
                 * @param {?} query
                 * @return {?}
                 */
                MediaMatcher.prototype.matchMedia = function (query) {
                    if (this._platform.WEBKIT) {
                        createEmptyStyleRule(query);
                    }
                    return this._matchMedia(query);
                };
                return MediaMatcher;
            }());
            MediaMatcher.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            MediaMatcher.ctorParameters = function () { return [
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_1__["Platform"] }
            ]; };
            /** @nocollapse */ MediaMatcher.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function MediaMatcher_Factory() { return new MediaMatcher(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_1__["Platform"])); }, token: MediaMatcher, providedIn: "root" });
            /**
             * For Webkit engines that only trigger the MediaQueryListListener when
             * there is at least one CSS selector for the respective media query.
             * @param {?} query
             * @return {?}
             */
            function createEmptyStyleRule(query) {
                if (mediaQueriesForWebkitCompatibility.has(query)) {
                    return;
                }
                try {
                    if (!mediaQueryStyleNode) {
                        mediaQueryStyleNode = document.createElement('style');
                        mediaQueryStyleNode.setAttribute('type', 'text/css');
                        ( /** @type {?} */(document.head)).appendChild(mediaQueryStyleNode);
                    }
                    if (mediaQueryStyleNode.sheet) {
                        (( /** @type {?} */(mediaQueryStyleNode.sheet)))
                            .insertRule("@media " + query + " {.fx-query-test{ }}", 0);
                        mediaQueriesForWebkitCompatibility.add(query);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            /**
             * No-op matchMedia replacement for non-browser platforms.
             * @param {?} query
             * @return {?}
             */
            function noopMatchMedia(query) {
                // Use `as any` here to avoid adding additional necessary properties for
                // the noop matcher.
                return ( /** @type {?} */({
                    matches: query === 'all' || query === '',
                    media: query,
                    addListener: ( /**
                     * @return {?}
                     */function () { }),
                    removeListener: ( /**
                     * @return {?}
                     */function () { })
                }));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Utility for checking the matching state of \@media queries.
             */
            var BreakpointObserver = /** @class */ (function () {
                /**
                 * @param {?} _mediaMatcher
                 * @param {?} _zone
                 */
                function BreakpointObserver(_mediaMatcher, _zone) {
                    this._mediaMatcher = _mediaMatcher;
                    this._zone = _zone;
                    /**
                     * A map of all media queries currently being listened for.
                     */
                    this._queries = new Map();
                    /**
                     * A subject for all other observables to takeUntil based on.
                     */
                    this._destroySubject = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                }
                /**
                 * Completes the active subject, signalling to all other observables to complete.
                 * @return {?}
                 */
                BreakpointObserver.prototype.ngOnDestroy = function () {
                    this._destroySubject.next();
                    this._destroySubject.complete();
                };
                /**
                 * Whether one or more media queries match the current viewport size.
                 * @param {?} value One or more media queries to check.
                 * @return {?} Whether any of the media queries match.
                 */
                BreakpointObserver.prototype.isMatched = function (value) {
                    var _this = this;
                    /** @type {?} */
                    var queries = splitQueries(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceArray"])(value));
                    return queries.some(( /**
                     * @param {?} mediaQuery
                     * @return {?}
                     */function (/**
                     * @param {?} mediaQuery
                     * @return {?}
                     */ mediaQuery) { return _this._registerQuery(mediaQuery).mql.matches; }));
                };
                /**
                 * Gets an observable of results for the given queries that will emit new results for any changes
                 * in matching of the given queries.
                 * @param {?} value One or more media queries to check.
                 * @return {?} A stream of matches for the given queries.
                 */
                BreakpointObserver.prototype.observe = function (value) {
                    var _this = this;
                    /** @type {?} */
                    var queries = splitQueries(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceArray"])(value));
                    /** @type {?} */
                    var observables = queries.map(( /**
                     * @param {?} query
                     * @return {?}
                     */function (/**
                     * @param {?} query
                     * @return {?}
                     */ query) { return _this._registerQuery(query).observable; }));
                    /** @type {?} */
                    var stateObservable = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["combineLatest"])(observables);
                    // Emit the first state immediately, and then debounce the subsequent emissions.
                    stateObservable = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["concat"])(stateObservable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["take"])(1)), stateObservable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["skip"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["debounceTime"])(0)));
                    return stateObservable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} breakpointStates
                     * @return {?}
                     */function (breakpointStates) {
                        /** @type {?} */
                        var response = {
                            matches: false,
                            breakpoints: {},
                        };
                        breakpointStates.forEach(( /**
                         * @param {?} state
                         * @return {?}
                         */function (state) {
                            response.matches = response.matches || state.matches;
                            response.breakpoints[state.query] = state.matches;
                        }));
                        return response;
                    })));
                };
                /**
                 * Registers a specific query to be listened for.
                 * @private
                 * @param {?} query
                 * @return {?}
                 */
                BreakpointObserver.prototype._registerQuery = function (query) {
                    var _this = this;
                    // Only set up a new MediaQueryList if it is not already being listened for.
                    if (this._queries.has(query)) {
                        return ( /** @type {?} */(this._queries.get(query)));
                    }
                    /** @type {?} */
                    var mql = this._mediaMatcher.matchMedia(query);
                    // Create callback for match changes and add it is as a listener.
                    /** @type {?} */
                    var queryObservable = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        // Listener callback methods are wrapped to be placed back in ngZone. Callbacks must be placed
                        // back into the zone because matchMedia is only included in Zone.js by loading the
                        // webapis-media-query.js file alongside the zone.js file.  Additionally, some browsers do not
                        // have MediaQueryList inherit from EventTarget, which causes inconsistencies in how Zone.js
                        // patches it.
                        /** @type {?} */
                        var handler = ( /**
                         * @param {?} e
                         * @return {?}
                         */function (e) { return _this._zone.run(( /**
                         * @return {?}
                         */function () { return observer.next(e); })); });
                        mql.addListener(handler);
                        return ( /**
                         * @return {?}
                         */function () {
                            mql.removeListener(handler);
                        });
                    })).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(mql), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} nextMql
                     * @return {?}
                     */function (nextMql) { return ({ query: query, matches: nextMql.matches }); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this._destroySubject));
                    // Add the MediaQueryList to the set of queries.
                    /** @type {?} */
                    var output = { observable: queryObservable, mql: mql };
                    this._queries.set(query, output);
                    return output;
                };
                return BreakpointObserver;
            }());
            BreakpointObserver.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            BreakpointObserver.ctorParameters = function () { return [
                { type: MediaMatcher },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] }
            ]; };
            /** @nocollapse */ BreakpointObserver.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function BreakpointObserver_Factory() { return new BreakpointObserver(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(MediaMatcher), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"])); }, token: BreakpointObserver, providedIn: "root" });
            /**
             * Split each query string into separate query strings if two queries are provided as comma
             * separated.
             * @param {?} queries
             * @return {?}
             */
            function splitQueries(queries) {
                return queries.map(( /**
                 * @param {?} query
                 * @return {?}
                 */function (query) { return query.split(','); }))
                    .reduce(( /**
             * @param {?} a1
             * @param {?} a2
             * @return {?}
             */function (a1, a2) { return a1.concat(a2); }))
                    .map(( /**
             * @param {?} query
             * @return {?}
             */function (/**
             * @param {?} query
             * @return {?}
             */ query) { return query.trim(); }));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // PascalCase is being used as Breakpoints is used like an enum.
            // tslint:disable-next-line:variable-name
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             * @type {?}
             */
            var Breakpoints = {
                XSmall: '(max-width: 599.99px)',
                Small: '(min-width: 600px) and (max-width: 959.99px)',
                Medium: '(min-width: 960px) and (max-width: 1279.99px)',
                Large: '(min-width: 1280px) and (max-width: 1919.99px)',
                XLarge: '(min-width: 1920px)',
                Handset: '(max-width: 599.99px) and (orientation: portrait), ' +
                    '(max-width: 959.99px) and (orientation: landscape)',
                Tablet: '(min-width: 600px) and (max-width: 839.99px) and (orientation: portrait), ' +
                    '(min-width: 960px) and (max-width: 1279.99px) and (orientation: landscape)',
                Web: '(min-width: 840px) and (orientation: portrait), ' +
                    '(min-width: 1280px) and (orientation: landscape)',
                HandsetPortrait: '(max-width: 599.99px) and (orientation: portrait)',
                TabletPortrait: '(min-width: 600px) and (max-width: 839.99px) and (orientation: portrait)',
                WebPortrait: '(min-width: 840px) and (orientation: portrait)',
                HandsetLandscape: '(max-width: 959.99px) and (orientation: landscape)',
                TabletLandscape: '(min-width: 960px) and (max-width: 1279.99px) and (orientation: landscape)',
                WebLandscape: '(min-width: 1280px) and (orientation: landscape)',
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=layout.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/observers.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/observers.js ***!
          \********************************************************/
        /*! exports provided: MutationObserverFactory, ContentObserver, CdkObserveContent, ObserversModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MutationObserverFactory", function () { return MutationObserverFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentObserver", function () { return ContentObserver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkObserveContent", function () { return CdkObserveContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserversModule", function () { return ObserversModule; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Factory that creates a new MutationObserver and allows us to stub it out in unit tests.
             * \@docs-private
             */
            var MutationObserverFactory = /** @class */ (function () {
                function MutationObserverFactory() {
                }
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                MutationObserverFactory.prototype.create = function (callback) {
                    return typeof MutationObserver === 'undefined' ? null : new MutationObserver(callback);
                };
                return MutationObserverFactory;
            }());
            MutationObserverFactory.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ MutationObserverFactory.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function MutationObserverFactory_Factory() { return new MutationObserverFactory(); }, token: MutationObserverFactory, providedIn: "root" });
            /**
             * An injectable service that allows watching elements for changes to their content.
             */
            var ContentObserver = /** @class */ (function () {
                /**
                 * @param {?} _mutationObserverFactory
                 */
                function ContentObserver(_mutationObserverFactory) {
                    this._mutationObserverFactory = _mutationObserverFactory;
                    /**
                     * Keeps track of the existing MutationObservers so they can be reused.
                     */
                    this._observedElements = new Map();
                }
                /**
                 * @return {?}
                 */
                ContentObserver.prototype.ngOnDestroy = function () {
                    var _this = this;
                    this._observedElements.forEach(( /**
                     * @param {?} _
                     * @param {?} element
                     * @return {?}
                     */function (_, element) { return _this._cleanupObserver(element); }));
                };
                /**
                 * @param {?} elementOrRef
                 * @return {?}
                 */
                ContentObserver.prototype.observe = function (elementOrRef) {
                    var _this = this;
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceElement"])(elementOrRef);
                    return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        /** @type {?} */
                        var stream = _this._observeElement(element);
                        /** @type {?} */
                        var subscription = stream.subscribe(observer);
                        return ( /**
                         * @return {?}
                         */function () {
                            subscription.unsubscribe();
                            _this._unobserveElement(element);
                        });
                    }));
                };
                /**
                 * Observes the given element by using the existing MutationObserver if available, or creating a
                 * new one if not.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                ContentObserver.prototype._observeElement = function (element) {
                    if (!this._observedElements.has(element)) {
                        /** @type {?} */
                        var stream_1 = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                        /** @type {?} */
                        var observer = this._mutationObserverFactory.create(( /**
                         * @param {?} mutations
                         * @return {?}
                         */function (/**
                         * @param {?} mutations
                         * @return {?}
                         */ mutations) { return stream_1.next(mutations); }));
                        if (observer) {
                            observer.observe(element, {
                                characterData: true,
                                childList: true,
                                subtree: true
                            });
                        }
                        this._observedElements.set(element, { observer: observer, stream: stream_1, count: 1 });
                    }
                    else {
                        ( /** @type {?} */(this._observedElements.get(element))).count++;
                    }
                    return ( /** @type {?} */(this._observedElements.get(element))).stream;
                };
                /**
                 * Un-observes the given element and cleans up the underlying MutationObserver if nobody else is
                 * observing this element.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                ContentObserver.prototype._unobserveElement = function (element) {
                    if (this._observedElements.has(element)) {
                        ( /** @type {?} */(this._observedElements.get(element))).count--;
                        if (!( /** @type {?} */(this._observedElements.get(element))).count) {
                            this._cleanupObserver(element);
                        }
                    }
                };
                /**
                 * Clean up the underlying MutationObserver for the specified element.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                ContentObserver.prototype._cleanupObserver = function (element) {
                    if (this._observedElements.has(element)) {
                        var _c = ( /** @type {?} */(this._observedElements.get(element))), observer = _c.observer, stream = _c.stream;
                        if (observer) {
                            observer.disconnect();
                        }
                        stream.complete();
                        this._observedElements.delete(element);
                    }
                };
                return ContentObserver;
            }());
            ContentObserver.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            ContentObserver.ctorParameters = function () { return [
                { type: MutationObserverFactory }
            ]; };
            /** @nocollapse */ ContentObserver.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function ContentObserver_Factory() { return new ContentObserver(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(MutationObserverFactory)); }, token: ContentObserver, providedIn: "root" });
            /**
             * Directive that triggers a callback whenever the content of
             * its associated element has changed.
             */
            var CdkObserveContent = /** @class */ (function () {
                /**
                 * @param {?} _contentObserver
                 * @param {?} _elementRef
                 * @param {?} _ngZone
                 */
                function CdkObserveContent(_contentObserver, _elementRef, _ngZone) {
                    this._contentObserver = _contentObserver;
                    this._elementRef = _elementRef;
                    this._ngZone = _ngZone;
                    /**
                     * Event emitted for each change in the element's content.
                     */
                    this.event = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    this._disabled = false;
                    this._currentSubscription = null;
                }
                Object.defineProperty(CdkObserveContent.prototype, "disabled", {
                    /**
                     * Whether observing content is disabled. This option can be used
                     * to disconnect the underlying MutationObserver until it is needed.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                        this._disabled ? this._unsubscribe() : this._subscribe();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkObserveContent.prototype, "debounce", {
                    /**
                     * Debounce interval for emitting the changes.
                     * @return {?}
                     */
                    get: function () { return this._debounce; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._debounce = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceNumberProperty"])(value);
                        this._subscribe();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkObserveContent.prototype.ngAfterContentInit = function () {
                    if (!this._currentSubscription && !this.disabled) {
                        this._subscribe();
                    }
                };
                /**
                 * @return {?}
                 */
                CdkObserveContent.prototype.ngOnDestroy = function () {
                    this._unsubscribe();
                };
                /**
                 * @private
                 * @return {?}
                 */
                CdkObserveContent.prototype._subscribe = function () {
                    var _this = this;
                    this._unsubscribe();
                    /** @type {?} */
                    var stream = this._contentObserver.observe(this._elementRef);
                    // TODO(mmalerba): We shouldn't be emitting on this @Output() outside the zone.
                    // Consider brining it back inside the zone next time we're making breaking changes.
                    // Bringing it back inside can cause things like infinite change detection loops and changed
                    // after checked errors if people's code isn't handling it properly.
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._currentSubscription =
                            (_this.debounce ? stream.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["debounceTime"])(_this.debounce)) : stream).subscribe(_this.event);
                    }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                CdkObserveContent.prototype._unsubscribe = function () {
                    if (this._currentSubscription) {
                        this._currentSubscription.unsubscribe();
                    }
                };
                return CdkObserveContent;
            }());
            CdkObserveContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkObserveContent]',
                            exportAs: 'cdkObserveContent',
                        },] },
            ];
            /** @nocollapse */
            CdkObserveContent.ctorParameters = function () { return [
                { type: ContentObserver },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
            ]; };
            CdkObserveContent.propDecorators = {
                event: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['cdkObserveContent',] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkObserveContentDisabled',] }],
                debounce: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            var ObserversModule = /** @class */ (function () {
                function ObserversModule() {
                }
                return ObserversModule;
            }());
            ObserversModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            exports: [CdkObserveContent],
                            declarations: [CdkObserveContent],
                            providers: [MutationObserverFactory]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=observers.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/overlay.js": 
        /*!******************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/overlay.js ***!
          \******************************************************/
        /*! exports provided: ViewportRuler, VIEWPORT_RULER_PROVIDER, CdkScrollable, ScrollDispatcher, Overlay, OverlayContainer, CdkOverlayOrigin, CdkConnectedOverlay, FullscreenOverlayContainer, OverlayRef, OverlayKeyboardDispatcher, OverlayPositionBuilder, GlobalPositionStrategy, ConnectedPositionStrategy, FlexibleConnectedPositionStrategy, OverlayConfig, validateVerticalPosition, validateHorizontalPosition, ConnectionPositionPair, ScrollingVisibility, ConnectedOverlayPositionChange, ScrollStrategyOptions, RepositionScrollStrategy, CloseScrollStrategy, NoopScrollStrategy, BlockScrollStrategy, OverlayModule, OVERLAY_PROVIDERS, ɵg, ɵf, ɵb, ɵa, ɵc, ɵe, ɵd */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Overlay", function () { return Overlay; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayContainer", function () { return OverlayContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkOverlayOrigin", function () { return CdkOverlayOrigin; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkConnectedOverlay", function () { return CdkConnectedOverlay; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FullscreenOverlayContainer", function () { return FullscreenOverlayContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayRef", function () { return OverlayRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayKeyboardDispatcher", function () { return OverlayKeyboardDispatcher; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayPositionBuilder", function () { return OverlayPositionBuilder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalPositionStrategy", function () { return GlobalPositionStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectedPositionStrategy", function () { return ConnectedPositionStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlexibleConnectedPositionStrategy", function () { return FlexibleConnectedPositionStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayConfig", function () { return OverlayConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateVerticalPosition", function () { return validateVerticalPosition; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateHorizontalPosition", function () { return validateHorizontalPosition; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectionPositionPair", function () { return ConnectionPositionPair; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollingVisibility", function () { return ScrollingVisibility; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectedOverlayPositionChange", function () { return ConnectedOverlayPositionChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollStrategyOptions", function () { return ScrollStrategyOptions; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RepositionScrollStrategy", function () { return RepositionScrollStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CloseScrollStrategy", function () { return CloseScrollStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoopScrollStrategy", function () { return NoopScrollStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BlockScrollStrategy", function () { return BlockScrollStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayModule", function () { return OverlayModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_PROVIDERS", function () { return OVERLAY_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function () { return OVERLAY_KEYBOARD_DISPATCHER_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function () { return OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function () { return OVERLAY_CONTAINER_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function () { return OVERLAY_CONTAINER_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function () { return CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function () { return CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function () { return CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ViewportRuler", function () { return _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ViewportRuler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VIEWPORT_RULER_PROVIDER", function () { return _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["VIEWPORT_RULER_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CdkScrollable", function () { return _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["CdkScrollable"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollDispatcher", function () { return _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ScrollDispatcher"]; });
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Strategy that will prevent the user from scrolling while the overlay is visible.
             */
            var BlockScrollStrategy = /** @class */ (function () {
                /**
                 * @param {?} _viewportRuler
                 * @param {?} document
                 */
                function BlockScrollStrategy(_viewportRuler, document) {
                    this._viewportRuler = _viewportRuler;
                    this._previousHTMLStyles = { top: '', left: '' };
                    this._isEnabled = false;
                    this._document = document;
                }
                /**
                 * Attaches this scroll strategy to an overlay.
                 * @return {?}
                 */
                BlockScrollStrategy.prototype.attach = function () { };
                /**
                 * Blocks page-level scroll while the attached overlay is open.
                 * @return {?}
                 */
                BlockScrollStrategy.prototype.enable = function () {
                    if (this._canBeEnabled()) {
                        /** @type {?} */
                        var root = ( /** @type {?} */(this._document.documentElement));
                        this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition();
                        // Cache the previous inline styles in case the user had set them.
                        this._previousHTMLStyles.left = root.style.left || '';
                        this._previousHTMLStyles.top = root.style.top || '';
                        // Note: we're using the `html` node, instead of the `body`, because the `body` may
                        // have the user agent margin, whereas the `html` is guaranteed not to have one.
                        root.style.left = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(-this._previousScrollPosition.left);
                        root.style.top = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(-this._previousScrollPosition.top);
                        root.classList.add('cdk-global-scrollblock');
                        this._isEnabled = true;
                    }
                };
                /**
                 * Unblocks page-level scroll while the attached overlay is open.
                 * @return {?}
                 */
                BlockScrollStrategy.prototype.disable = function () {
                    if (this._isEnabled) {
                        /** @type {?} */
                        var html = ( /** @type {?} */(this._document.documentElement));
                        /** @type {?} */
                        var body = ( /** @type {?} */(this._document.body));
                        /** @type {?} */
                        var htmlStyle = ( /** @type {?} */(html.style));
                        /** @type {?} */
                        var bodyStyle = ( /** @type {?} */(body.style));
                        /** @type {?} */
                        var previousHtmlScrollBehavior = htmlStyle.scrollBehavior || '';
                        /** @type {?} */
                        var previousBodyScrollBehavior = bodyStyle.scrollBehavior || '';
                        this._isEnabled = false;
                        htmlStyle.left = this._previousHTMLStyles.left;
                        htmlStyle.top = this._previousHTMLStyles.top;
                        html.classList.remove('cdk-global-scrollblock');
                        // Disable user-defined smooth scrolling temporarily while we restore the scroll position.
                        // See https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
                        htmlStyle.scrollBehavior = bodyStyle.scrollBehavior = 'auto';
                        window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top);
                        htmlStyle.scrollBehavior = previousHtmlScrollBehavior;
                        bodyStyle.scrollBehavior = previousBodyScrollBehavior;
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                BlockScrollStrategy.prototype._canBeEnabled = function () {
                    // Since the scroll strategies can't be singletons, we have to use a global CSS class
                    // (`cdk-global-scrollblock`) to make sure that we don't try to disable global
                    // scrolling multiple times.
                    /** @type {?} */
                    var html = ( /** @type {?} */(this._document.documentElement));
                    if (html.classList.contains('cdk-global-scrollblock') || this._isEnabled) {
                        return false;
                    }
                    /** @type {?} */
                    var body = this._document.body;
                    /** @type {?} */
                    var viewport = this._viewportRuler.getViewportSize();
                    return body.scrollHeight > viewport.height || body.scrollWidth > viewport.width;
                };
                return BlockScrollStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns an error to be thrown when attempting to attach an already-attached scroll strategy.
             * @return {?}
             */
            function getMatScrollStrategyAlreadyAttachedError() {
                return Error("Scroll strategy has already been attached.");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Strategy that will close the overlay as soon as the user starts scrolling.
             */
            var CloseScrollStrategy = /** @class */ (function () {
                /**
                 * @param {?} _scrollDispatcher
                 * @param {?} _ngZone
                 * @param {?} _viewportRuler
                 * @param {?=} _config
                 */
                function CloseScrollStrategy(_scrollDispatcher, _ngZone, _viewportRuler, _config) {
                    var _this = this;
                    this._scrollDispatcher = _scrollDispatcher;
                    this._ngZone = _ngZone;
                    this._viewportRuler = _viewportRuler;
                    this._config = _config;
                    this._scrollSubscription = null;
                    /**
                     * Detaches the overlay ref and disables the scroll strategy.
                     */
                    this._detach = ( /**
                     * @return {?}
                     */function () {
                        _this.disable();
                        if (_this._overlayRef.hasAttached()) {
                            _this._ngZone.run(( /**
                             * @return {?}
                             */function () { return _this._overlayRef.detach(); }));
                        }
                    });
                }
                /**
                 * Attaches this scroll strategy to an overlay.
                 * @param {?} overlayRef
                 * @return {?}
                 */
                CloseScrollStrategy.prototype.attach = function (overlayRef) {
                    if (this._overlayRef) {
                        throw getMatScrollStrategyAlreadyAttachedError();
                    }
                    this._overlayRef = overlayRef;
                };
                /**
                 * Enables the closing of the attached overlay on scroll.
                 * @return {?}
                 */
                CloseScrollStrategy.prototype.enable = function () {
                    var _this = this;
                    if (this._scrollSubscription) {
                        return;
                    }
                    /** @type {?} */
                    var stream = this._scrollDispatcher.scrolled(0);
                    if (this._config && this._config.threshold && this._config.threshold > 1) {
                        this._initialScrollPosition = this._viewportRuler.getViewportScrollPosition().top;
                        this._scrollSubscription = stream.subscribe(( /**
                         * @return {?}
                         */function () {
                            /** @type {?} */
                            var scrollPosition = _this._viewportRuler.getViewportScrollPosition().top;
                            if (Math.abs(scrollPosition - _this._initialScrollPosition) > ( /** @type {?} */(( /** @type {?} */(_this._config)).threshold))) {
                                _this._detach();
                            }
                            else {
                                _this._overlayRef.updatePosition();
                            }
                        }));
                    }
                    else {
                        this._scrollSubscription = stream.subscribe(this._detach);
                    }
                };
                /**
                 * Disables the closing the attached overlay on scroll.
                 * @return {?}
                 */
                CloseScrollStrategy.prototype.disable = function () {
                    if (this._scrollSubscription) {
                        this._scrollSubscription.unsubscribe();
                        this._scrollSubscription = null;
                    }
                };
                /**
                 * @return {?}
                 */
                CloseScrollStrategy.prototype.detach = function () {
                    this.disable();
                    this._overlayRef = ( /** @type {?} */(null));
                };
                return CloseScrollStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Scroll strategy that doesn't do anything.
             */
            var NoopScrollStrategy = /** @class */ (function () {
                function NoopScrollStrategy() {
                }
                /**
                 * Does nothing, as this scroll strategy is a no-op.
                 * @return {?}
                 */
                NoopScrollStrategy.prototype.enable = function () { };
                /**
                 * Does nothing, as this scroll strategy is a no-op.
                 * @return {?}
                 */
                NoopScrollStrategy.prototype.disable = function () { };
                /**
                 * Does nothing, as this scroll strategy is a no-op.
                 * @return {?}
                 */
                NoopScrollStrategy.prototype.attach = function () { };
                return NoopScrollStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO(jelbourn): move this to live with the rest of the scrolling code
            // TODO(jelbourn): someday replace this with IntersectionObservers
            /**
             * Gets whether an element is scrolled outside of view by any of its parent scrolling containers.
             * \@docs-private
             * @param {?} element Dimensions of the element (from getBoundingClientRect)
             * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
             * @return {?} Whether the element is scrolled out of view
             */
            function isElementScrolledOutsideView(element, scrollContainers) {
                return scrollContainers.some(( /**
                 * @param {?} containerBounds
                 * @return {?}
                 */function (/**
                 * @param {?} containerBounds
                 * @return {?}
                 */ containerBounds) {
                    /** @type {?} */
                    var outsideAbove = element.bottom < containerBounds.top;
                    /** @type {?} */
                    var outsideBelow = element.top > containerBounds.bottom;
                    /** @type {?} */
                    var outsideLeft = element.right < containerBounds.left;
                    /** @type {?} */
                    var outsideRight = element.left > containerBounds.right;
                    return outsideAbove || outsideBelow || outsideLeft || outsideRight;
                }));
            }
            /**
             * Gets whether an element is clipped by any of its scrolling containers.
             * \@docs-private
             * @param {?} element Dimensions of the element (from getBoundingClientRect)
             * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
             * @return {?} Whether the element is clipped
             */
            function isElementClippedByScrolling(element, scrollContainers) {
                return scrollContainers.some(( /**
                 * @param {?} scrollContainerRect
                 * @return {?}
                 */function (/**
                 * @param {?} scrollContainerRect
                 * @return {?}
                 */ scrollContainerRect) {
                    /** @type {?} */
                    var clippedAbove = element.top < scrollContainerRect.top;
                    /** @type {?} */
                    var clippedBelow = element.bottom > scrollContainerRect.bottom;
                    /** @type {?} */
                    var clippedLeft = element.left < scrollContainerRect.left;
                    /** @type {?} */
                    var clippedRight = element.right > scrollContainerRect.right;
                    return clippedAbove || clippedBelow || clippedLeft || clippedRight;
                }));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Strategy that will update the element position as the user is scrolling.
             */
            var RepositionScrollStrategy = /** @class */ (function () {
                /**
                 * @param {?} _scrollDispatcher
                 * @param {?} _viewportRuler
                 * @param {?} _ngZone
                 * @param {?=} _config
                 */
                function RepositionScrollStrategy(_scrollDispatcher, _viewportRuler, _ngZone, _config) {
                    this._scrollDispatcher = _scrollDispatcher;
                    this._viewportRuler = _viewportRuler;
                    this._ngZone = _ngZone;
                    this._config = _config;
                    this._scrollSubscription = null;
                }
                /**
                 * Attaches this scroll strategy to an overlay.
                 * @param {?} overlayRef
                 * @return {?}
                 */
                RepositionScrollStrategy.prototype.attach = function (overlayRef) {
                    if (this._overlayRef) {
                        throw getMatScrollStrategyAlreadyAttachedError();
                    }
                    this._overlayRef = overlayRef;
                };
                /**
                 * Enables repositioning of the attached overlay on scroll.
                 * @return {?}
                 */
                RepositionScrollStrategy.prototype.enable = function () {
                    var _this = this;
                    if (!this._scrollSubscription) {
                        /** @type {?} */
                        var throttle = this._config ? this._config.scrollThrottle : 0;
                        this._scrollSubscription = this._scrollDispatcher.scrolled(throttle).subscribe(( /**
                         * @return {?}
                         */function () {
                            _this._overlayRef.updatePosition();
                            // TODO(crisbeto): make `close` on by default once all components can handle it.
                            if (_this._config && _this._config.autoClose) {
                                /** @type {?} */
                                var overlayRect = _this._overlayRef.overlayElement.getBoundingClientRect();
                                var _c = _this._viewportRuler.getViewportSize(), width = _c.width, height = _c.height;
                                // TODO(crisbeto): include all ancestor scroll containers here once
                                // we have a way of exposing the trigger element to the scroll strategy.
                                /** @type {?} */
                                var parentRects = [{ width: width, height: height, bottom: height, right: width, top: 0, left: 0 }];
                                if (isElementScrolledOutsideView(overlayRect, parentRects)) {
                                    _this.disable();
                                    _this._ngZone.run(( /**
                                     * @return {?}
                                     */function () { return _this._overlayRef.detach(); }));
                                }
                            }
                        }));
                    }
                };
                /**
                 * Disables repositioning of the attached overlay on scroll.
                 * @return {?}
                 */
                RepositionScrollStrategy.prototype.disable = function () {
                    if (this._scrollSubscription) {
                        this._scrollSubscription.unsubscribe();
                        this._scrollSubscription = null;
                    }
                };
                /**
                 * @return {?}
                 */
                RepositionScrollStrategy.prototype.detach = function () {
                    this.disable();
                    this._overlayRef = ( /** @type {?} */(null));
                };
                return RepositionScrollStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Options for how an overlay will handle scrolling.
             *
             * Users can provide a custom value for `ScrollStrategyOptions` to replace the default
             * behaviors. This class primarily acts as a factory for ScrollStrategy instances.
             */
            var ScrollStrategyOptions = /** @class */ (function () {
                /**
                 * @param {?} _scrollDispatcher
                 * @param {?} _viewportRuler
                 * @param {?} _ngZone
                 * @param {?} document
                 */
                function ScrollStrategyOptions(_scrollDispatcher, _viewportRuler, _ngZone, document) {
                    var _this = this;
                    this._scrollDispatcher = _scrollDispatcher;
                    this._viewportRuler = _viewportRuler;
                    this._ngZone = _ngZone;
                    /**
                     * Do nothing on scroll.
                     */
                    this.noop = ( /**
                     * @return {?}
                     */function () { return new NoopScrollStrategy(); });
                    /**
                     * Close the overlay as soon as the user scrolls.
                     * @param config Configuration to be used inside the scroll strategy.
                     */
                    this.close = ( /**
                     * @param {?=} config
                     * @return {?}
                     */function (config) { return new CloseScrollStrategy(_this._scrollDispatcher, _this._ngZone, _this._viewportRuler, config); });
                    /**
                     * Block scrolling.
                     */
                    this.block = ( /**
                     * @return {?}
                     */function () { return new BlockScrollStrategy(_this._viewportRuler, _this._document); });
                    /**
                     * Update the overlay's position on scroll.
                     * @param config Configuration to be used inside the scroll strategy.
                     * Allows debouncing the reposition calls.
                     */
                    this.reposition = ( /**
                     * @param {?=} config
                     * @return {?}
                     */function (config) { return new RepositionScrollStrategy(_this._scrollDispatcher, _this._viewportRuler, _this._ngZone, config); });
                    this._document = document;
                }
                return ScrollStrategyOptions;
            }());
            ScrollStrategyOptions.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            ScrollStrategyOptions.ctorParameters = function () { return [
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ScrollDispatcher"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ViewportRuler"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ ScrollStrategyOptions.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵdefineInjectable"])({ factory: function ScrollStrategyOptions_Factory() { return new ScrollStrategyOptions(Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ScrollDispatcher"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ViewportRuler"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"])); }, token: ScrollStrategyOptions, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Initial configuration used when creating an overlay.
             */
            var OverlayConfig = /** @class */ (function () {
                /**
                 * @param {?=} config
                 */
                function OverlayConfig(config) {
                    /**
                     * Strategy to be used when handling scroll events while the overlay is open.
                     */
                    this.scrollStrategy = new NoopScrollStrategy();
                    /**
                     * Custom class to add to the overlay pane.
                     */
                    this.panelClass = '';
                    /**
                     * Whether the overlay has a backdrop.
                     */
                    this.hasBackdrop = false;
                    /**
                     * Custom class to add to the backdrop
                     */
                    this.backdropClass = 'cdk-overlay-dark-backdrop';
                    /**
                     * Whether the overlay should be disposed of when the user goes backwards/forwards in history.
                     * Note that this usually doesn't include clicking on links (unless the user is using
                     * the `HashLocationStrategy`).
                     */
                    this.disposeOnNavigation = false;
                    if (config) {
                        /** @type {?} */
                        var configKeys = ( /** @type {?} */(Object.keys(config)));
                        for (var _c = 0, configKeys_1 = configKeys; _c < configKeys_1.length; _c++) {
                            var key = configKeys_1[_c];
                            if (config[key] !== undefined) {
                                // TypeScript, as of version 3.5, sees the left-hand-side of this expression
                                // as "I don't know *which* key this is, so the only valid value is the intersection
                                // of all the posible values." In this case, that happens to be `undefined`. TypeScript
                                // is not smart enough to see that the right-hand-side is actually an access of the same
                                // exact type with the same exact key, meaning that the value type must be identical.
                                // So we use `any` to work around this.
                                this[key] = ( /** @type {?} */(config[key]));
                            }
                        }
                    }
                }
                return OverlayConfig;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The points of the origin element and the overlay element to connect.
             */
            var ConnectionPositionPair = /** @class */ (function () {
                /**
                 * @param {?} origin
                 * @param {?} overlay
                 * @param {?=} offsetX
                 * @param {?=} offsetY
                 * @param {?=} panelClass
                 */
                function ConnectionPositionPair(origin, overlay, offsetX, offsetY, panelClass) {
                    this.offsetX = offsetX;
                    this.offsetY = offsetY;
                    this.panelClass = panelClass;
                    this.originX = origin.originX;
                    this.originY = origin.originY;
                    this.overlayX = overlay.overlayX;
                    this.overlayY = overlay.overlayY;
                }
                return ConnectionPositionPair;
            }());
            /**
             * Set of properties regarding the position of the origin and overlay relative to the viewport
             * with respect to the containing Scrollable elements.
             *
             * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
             * bounds of any one of the strategy's Scrollable's bounding client rectangle.
             *
             * The overlay and origin are outside view if there is no overlap between their bounding client
             * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
             *
             *       -----------                    -----------
             *       | outside |                    | clipped |
             *       |  view   |              --------------------------
             *       |         |              |     |         |        |
             *       ----------               |     -----------        |
             *  --------------------------    |                        |
             *  |                        |    |      Scrollable        |
             *  |                        |    |                        |
             *  |                        |     --------------------------
             *  |      Scrollable        |
             *  |                        |
             *  --------------------------
             *
             * \@docs-private
             */
            var ScrollingVisibility = /** @class */ (function () {
                function ScrollingVisibility() {
                }
                return ScrollingVisibility;
            }());
            /**
             * The change event emitted by the strategy when a fallback position is used.
             */
            var ConnectedOverlayPositionChange = /** @class */ (function () {
                /**
                 * @param {?} connectionPair
                 * @param {?} scrollableViewProperties
                 */
                function ConnectedOverlayPositionChange(connectionPair, scrollableViewProperties) {
                    this.connectionPair = connectionPair;
                    this.scrollableViewProperties = scrollableViewProperties;
                }
                return ConnectedOverlayPositionChange;
            }());
            /** @nocollapse */
            ConnectedOverlayPositionChange.ctorParameters = function () { return [
                { type: ConnectionPositionPair },
                { type: ScrollingVisibility, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] }
            ]; };
            /**
             * Validates whether a vertical position property matches the expected values.
             * \@docs-private
             * @param {?} property Name of the property being validated.
             * @param {?} value Value of the property being validated.
             * @return {?}
             */
            function validateVerticalPosition(property, value) {
                if (value !== 'top' && value !== 'bottom' && value !== 'center') {
                    throw Error("ConnectedPosition: Invalid " + property + " \"" + value + "\". " +
                        "Expected \"top\", \"bottom\" or \"center\".");
                }
            }
            /**
             * Validates whether a horizontal position property matches the expected values.
             * \@docs-private
             * @param {?} property Name of the property being validated.
             * @param {?} value Value of the property being validated.
             * @return {?}
             */
            function validateHorizontalPosition(property, value) {
                if (value !== 'start' && value !== 'end' && value !== 'center') {
                    throw Error("ConnectedPosition: Invalid " + property + " \"" + value + "\". " +
                        "Expected \"start\", \"end\" or \"center\".");
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Service for dispatching keyboard events that land on the body to appropriate overlay ref,
             * if any. It maintains a list of attached overlays to determine best suited overlay based
             * on event target and order of overlay opens.
             */
            var OverlayKeyboardDispatcher = /** @class */ (function () {
                /**
                 * @param {?} document
                 */
                function OverlayKeyboardDispatcher(document) {
                    var _this = this;
                    /**
                     * Currently attached overlays in the order they were attached.
                     */
                    this._attachedOverlays = [];
                    /**
                     * Keyboard event listener that will be attached to the body.
                     */
                    this._keydownListener = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        /** @type {?} */
                        var overlays = _this._attachedOverlays;
                        for (var i = overlays.length - 1; i > -1; i--) {
                            // Dispatch the keydown event to the top overlay which has subscribers to its keydown events.
                            // We want to target the most recent overlay, rather than trying to match where the event came
                            // from, because some components might open an overlay, but keep focus on a trigger element
                            // (e.g. for select and autocomplete). We skip overlays without keydown event subscriptions,
                            // because we don't want overlays that don't handle keyboard events to block the ones below
                            // them that do.
                            if (overlays[i]._keydownEventSubscriptions > 0) {
                                overlays[i]._keydownEvents.next(event);
                                break;
                            }
                        }
                    });
                    this._document = document;
                }
                /**
                 * @return {?}
                 */
                OverlayKeyboardDispatcher.prototype.ngOnDestroy = function () {
                    this._detach();
                };
                /**
                 * Add a new overlay to the list of attached overlay refs.
                 * @param {?} overlayRef
                 * @return {?}
                 */
                OverlayKeyboardDispatcher.prototype.add = function (overlayRef) {
                    // Ensure that we don't get the same overlay multiple times.
                    this.remove(overlayRef);
                    // Lazily start dispatcher once first overlay is added
                    if (!this._isAttached) {
                        this._document.body.addEventListener('keydown', this._keydownListener);
                        this._isAttached = true;
                    }
                    this._attachedOverlays.push(overlayRef);
                };
                /**
                 * Remove an overlay from the list of attached overlay refs.
                 * @param {?} overlayRef
                 * @return {?}
                 */
                OverlayKeyboardDispatcher.prototype.remove = function (overlayRef) {
                    /** @type {?} */
                    var index = this._attachedOverlays.indexOf(overlayRef);
                    if (index > -1) {
                        this._attachedOverlays.splice(index, 1);
                    }
                    // Remove the global listener once there are no more overlays.
                    if (this._attachedOverlays.length === 0) {
                        this._detach();
                    }
                };
                /**
                 * Detaches the global keyboard event listener.
                 * @private
                 * @return {?}
                 */
                OverlayKeyboardDispatcher.prototype._detach = function () {
                    if (this._isAttached) {
                        this._document.body.removeEventListener('keydown', this._keydownListener);
                        this._isAttached = false;
                    }
                };
                return OverlayKeyboardDispatcher;
            }());
            OverlayKeyboardDispatcher.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            OverlayKeyboardDispatcher.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ OverlayKeyboardDispatcher.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵdefineInjectable"])({ factory: function OverlayKeyboardDispatcher_Factory() { return new OverlayKeyboardDispatcher(Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"])); }, token: OverlayKeyboardDispatcher, providedIn: "root" });
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} dispatcher
             * @param {?} _document
             * @return {?}
             */
            function OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY(dispatcher, _document) {
                return dispatcher || new OverlayKeyboardDispatcher(_document);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var OVERLAY_KEYBOARD_DISPATCHER_PROVIDER = {
                // If there is already an OverlayKeyboardDispatcher available, use that.
                // Otherwise, provide a new one.
                provide: OverlayKeyboardDispatcher,
                deps: [
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_3__["SkipSelf"](), OverlayKeyboardDispatcher],
                    ( /** @type {?} */(
                    // Coerce to `InjectionToken` so that the `deps` match the "shape"
                    // of the type expected by Angular
                    _angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"]))
                ],
                useFactory: OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Container inside which all overlays will render.
             */
            var OverlayContainer = /** @class */ (function () {
                /**
                 * @param {?} document
                 */
                function OverlayContainer(document) {
                    this._document = document;
                }
                /**
                 * @return {?}
                 */
                OverlayContainer.prototype.ngOnDestroy = function () {
                    if (this._containerElement && this._containerElement.parentNode) {
                        this._containerElement.parentNode.removeChild(this._containerElement);
                    }
                };
                /**
                 * This method returns the overlay container element. It will lazily
                 * create the element the first time  it is called to facilitate using
                 * the container in non-browser environments.
                 * @return {?} the container element
                 */
                OverlayContainer.prototype.getContainerElement = function () {
                    if (!this._containerElement) {
                        this._createContainer();
                    }
                    return this._containerElement;
                };
                /**
                 * Create the overlay container element, which is simply a div
                 * with the 'cdk-overlay-container' class on the document body.
                 * @protected
                 * @return {?}
                 */
                OverlayContainer.prototype._createContainer = function () {
                    /** @type {?} */
                    var containerClass = 'cdk-overlay-container';
                    /** @type {?} */
                    var previousContainers = this._document.getElementsByClassName(containerClass);
                    // Remove any old containers. This can happen when transitioning from the server to the client.
                    for (var i = 0; i < previousContainers.length; i++) {
                        ( /** @type {?} */(previousContainers[i].parentNode)).removeChild(previousContainers[i]);
                    }
                    /** @type {?} */
                    var container = this._document.createElement('div');
                    container.classList.add(containerClass);
                    this._document.body.appendChild(container);
                    this._containerElement = container;
                };
                return OverlayContainer;
            }());
            OverlayContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            OverlayContainer.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ OverlayContainer.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵdefineInjectable"])({ factory: function OverlayContainer_Factory() { return new OverlayContainer(Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"])); }, token: OverlayContainer, providedIn: "root" });
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} parentContainer
             * @param {?} _document
             * @return {?}
             */
            function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer, _document) {
                return parentContainer || new OverlayContainer(_document);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var OVERLAY_CONTAINER_PROVIDER = {
                // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
                provide: OverlayContainer,
                deps: [
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_3__["SkipSelf"](), OverlayContainer],
                    ( /** @type {?} */(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"]))
                ],
                useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Reference to an overlay that has been created with the Overlay service.
             * Used to manipulate or dispose of said overlay.
             */
            var OverlayRef = /** @class */ (function () {
                /**
                 * @param {?} _portalOutlet
                 * @param {?} _host
                 * @param {?} _pane
                 * @param {?} _config
                 * @param {?} _ngZone
                 * @param {?} _keyboardDispatcher
                 * @param {?} _document
                 * @param {?=} _location
                 */
                function OverlayRef(_portalOutlet, _host, _pane, _config, _ngZone, _keyboardDispatcher, _document, _location) {
                    var _this = this;
                    this._portalOutlet = _portalOutlet;
                    this._host = _host;
                    this._pane = _pane;
                    this._config = _config;
                    this._ngZone = _ngZone;
                    this._keyboardDispatcher = _keyboardDispatcher;
                    this._document = _document;
                    this._location = _location;
                    this._backdropElement = null;
                    this._backdropClick = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    this._attachments = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    this._detachments = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    this._locationChanges = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    this._backdropClickHandler = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) { return _this._backdropClick.next(event); });
                    this._keydownEventsObservable = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        /** @type {?} */
                        var subscription = _this._keydownEvents.subscribe(observer);
                        _this._keydownEventSubscriptions++;
                        return ( /**
                         * @return {?}
                         */function () {
                            subscription.unsubscribe();
                            _this._keydownEventSubscriptions--;
                        });
                    }));
                    /**
                     * Stream of keydown events dispatched to this overlay.
                     */
                    this._keydownEvents = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * Amount of subscriptions to the keydown events.
                     */
                    this._keydownEventSubscriptions = 0;
                    if (_config.scrollStrategy) {
                        this._scrollStrategy = _config.scrollStrategy;
                        this._scrollStrategy.attach(this);
                    }
                    this._positionStrategy = _config.positionStrategy;
                }
                Object.defineProperty(OverlayRef.prototype, "overlayElement", {
                    /**
                     * The overlay's HTML element
                     * @return {?}
                     */
                    get: function () {
                        return this._pane;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(OverlayRef.prototype, "backdropElement", {
                    /**
                     * The overlay's backdrop HTML element.
                     * @return {?}
                     */
                    get: function () {
                        return this._backdropElement;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(OverlayRef.prototype, "hostElement", {
                    /**
                     * Wrapper around the panel element. Can be used for advanced
                     * positioning where a wrapper with specific styling is
                     * required around the overlay pane.
                     * @return {?}
                     */
                    get: function () {
                        return this._host;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Attaches content, given via a Portal, to the overlay.
                 * If the overlay is configured to have a backdrop, it will be created.
                 *
                 * @param {?} portal Portal instance to which to attach the overlay.
                 * @return {?} The portal attachment result.
                 */
                OverlayRef.prototype.attach = function (portal) {
                    var _this = this;
                    /** @type {?} */
                    var attachResult = this._portalOutlet.attach(portal);
                    if (this._positionStrategy) {
                        this._positionStrategy.attach(this);
                    }
                    // Update the pane element with the given configuration.
                    if (!this._host.parentElement && this._previousHostParent) {
                        this._previousHostParent.appendChild(this._host);
                    }
                    this._updateStackingOrder();
                    this._updateElementSize();
                    this._updateElementDirection();
                    if (this._scrollStrategy) {
                        this._scrollStrategy.enable();
                    }
                    // Update the position once the zone is stable so that the overlay will be fully rendered
                    // before attempting to position it, as the position may depend on the size of the rendered
                    // content.
                    this._ngZone.onStable
                        .asObservable()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["take"])(1))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        // The overlay could've been detached before the zone has stabilized.
                        if (_this.hasAttached()) {
                            _this.updatePosition();
                        }
                    }));
                    // Enable pointer events for the overlay pane element.
                    this._togglePointerEvents(true);
                    if (this._config.hasBackdrop) {
                        this._attachBackdrop();
                    }
                    if (this._config.panelClass) {
                        this._toggleClasses(this._pane, this._config.panelClass, true);
                    }
                    // Only emit the `attachments` event once all other setup is done.
                    this._attachments.next();
                    // Track this overlay by the keyboard dispatcher
                    this._keyboardDispatcher.add(this);
                    // @breaking-change 8.0.0 remove the null check for `_location`
                    // once the constructor parameter is made required.
                    if (this._config.disposeOnNavigation && this._location) {
                        this._locationChanges = this._location.subscribe(( /**
                         * @return {?}
                         */function () { return _this.dispose(); }));
                    }
                    return attachResult;
                };
                /**
                 * Detaches an overlay from a portal.
                 * @return {?} The portal detachment result.
                 */
                OverlayRef.prototype.detach = function () {
                    if (!this.hasAttached()) {
                        return;
                    }
                    this.detachBackdrop();
                    // When the overlay is detached, the pane element should disable pointer events.
                    // This is necessary because otherwise the pane element will cover the page and disable
                    // pointer events therefore. Depends on the position strategy and the applied pane boundaries.
                    this._togglePointerEvents(false);
                    if (this._positionStrategy && this._positionStrategy.detach) {
                        this._positionStrategy.detach();
                    }
                    if (this._scrollStrategy) {
                        this._scrollStrategy.disable();
                    }
                    /** @type {?} */
                    var detachmentResult = this._portalOutlet.detach();
                    // Only emit after everything is detached.
                    this._detachments.next();
                    // Remove this overlay from keyboard dispatcher tracking.
                    this._keyboardDispatcher.remove(this);
                    // Keeping the host element in DOM the can cause scroll jank, because it still gets
                    // rendered, even though it's transparent and unclickable which is why we remove it.
                    this._detachContentWhenStable();
                    // Stop listening for location changes.
                    this._locationChanges.unsubscribe();
                    return detachmentResult;
                };
                /**
                 * Cleans up the overlay from the DOM.
                 * @return {?}
                 */
                OverlayRef.prototype.dispose = function () {
                    /** @type {?} */
                    var isAttached = this.hasAttached();
                    if (this._positionStrategy) {
                        this._positionStrategy.dispose();
                    }
                    this._disposeScrollStrategy();
                    this.detachBackdrop();
                    this._locationChanges.unsubscribe();
                    this._keyboardDispatcher.remove(this);
                    this._portalOutlet.dispose();
                    this._attachments.complete();
                    this._backdropClick.complete();
                    this._keydownEvents.complete();
                    if (this._host && this._host.parentNode) {
                        this._host.parentNode.removeChild(this._host);
                        this._host = ( /** @type {?} */(null));
                    }
                    this._previousHostParent = this._pane = ( /** @type {?} */(null));
                    if (isAttached) {
                        this._detachments.next();
                    }
                    this._detachments.complete();
                };
                /**
                 * Whether the overlay has attached content.
                 * @return {?}
                 */
                OverlayRef.prototype.hasAttached = function () {
                    return this._portalOutlet.hasAttached();
                };
                /**
                 * Gets an observable that emits when the backdrop has been clicked.
                 * @return {?}
                 */
                OverlayRef.prototype.backdropClick = function () {
                    return this._backdropClick.asObservable();
                };
                /**
                 * Gets an observable that emits when the overlay has been attached.
                 * @return {?}
                 */
                OverlayRef.prototype.attachments = function () {
                    return this._attachments.asObservable();
                };
                /**
                 * Gets an observable that emits when the overlay has been detached.
                 * @return {?}
                 */
                OverlayRef.prototype.detachments = function () {
                    return this._detachments.asObservable();
                };
                /**
                 * Gets an observable of keydown events targeted to this overlay.
                 * @return {?}
                 */
                OverlayRef.prototype.keydownEvents = function () {
                    return this._keydownEventsObservable;
                };
                /**
                 * Gets the current overlay configuration, which is immutable.
                 * @return {?}
                 */
                OverlayRef.prototype.getConfig = function () {
                    return this._config;
                };
                /**
                 * Updates the position of the overlay based on the position strategy.
                 * @return {?}
                 */
                OverlayRef.prototype.updatePosition = function () {
                    if (this._positionStrategy) {
                        this._positionStrategy.apply();
                    }
                };
                /**
                 * Switches to a new position strategy and updates the overlay position.
                 * @param {?} strategy
                 * @return {?}
                 */
                OverlayRef.prototype.updatePositionStrategy = function (strategy) {
                    if (strategy === this._positionStrategy) {
                        return;
                    }
                    if (this._positionStrategy) {
                        this._positionStrategy.dispose();
                    }
                    this._positionStrategy = strategy;
                    if (this.hasAttached()) {
                        strategy.attach(this);
                        this.updatePosition();
                    }
                };
                /**
                 * Update the size properties of the overlay.
                 * @param {?} sizeConfig
                 * @return {?}
                 */
                OverlayRef.prototype.updateSize = function (sizeConfig) {
                    this._config = Object.assign({}, this._config, sizeConfig);
                    this._updateElementSize();
                };
                /**
                 * Sets the LTR/RTL direction for the overlay.
                 * @param {?} dir
                 * @return {?}
                 */
                OverlayRef.prototype.setDirection = function (dir) {
                    this._config = Object.assign({}, this._config, { direction: dir });
                    this._updateElementDirection();
                };
                /**
                 * Add a CSS class or an array of classes to the overlay pane.
                 * @param {?} classes
                 * @return {?}
                 */
                OverlayRef.prototype.addPanelClass = function (classes) {
                    if (this._pane) {
                        this._toggleClasses(this._pane, classes, true);
                    }
                };
                /**
                 * Remove a CSS class or an array of classes from the overlay pane.
                 * @param {?} classes
                 * @return {?}
                 */
                OverlayRef.prototype.removePanelClass = function (classes) {
                    if (this._pane) {
                        this._toggleClasses(this._pane, classes, false);
                    }
                };
                /**
                 * Returns the layout direction of the overlay panel.
                 * @return {?}
                 */
                OverlayRef.prototype.getDirection = function () {
                    /** @type {?} */
                    var direction = this._config.direction;
                    if (!direction) {
                        return 'ltr';
                    }
                    return typeof direction === 'string' ? direction : direction.value;
                };
                /**
                 * Switches to a new scroll strategy.
                 * @param {?} strategy
                 * @return {?}
                 */
                OverlayRef.prototype.updateScrollStrategy = function (strategy) {
                    if (strategy === this._scrollStrategy) {
                        return;
                    }
                    this._disposeScrollStrategy();
                    this._scrollStrategy = strategy;
                    if (this.hasAttached()) {
                        strategy.attach(this);
                        strategy.enable();
                    }
                };
                /**
                 * Updates the text direction of the overlay panel.
                 * @private
                 * @return {?}
                 */
                OverlayRef.prototype._updateElementDirection = function () {
                    this._host.setAttribute('dir', this.getDirection());
                };
                /**
                 * Updates the size of the overlay element based on the overlay config.
                 * @private
                 * @return {?}
                 */
                OverlayRef.prototype._updateElementSize = function () {
                    if (!this._pane) {
                        return;
                    }
                    /** @type {?} */
                    var style = this._pane.style;
                    style.width = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(this._config.width);
                    style.height = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(this._config.height);
                    style.minWidth = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(this._config.minWidth);
                    style.minHeight = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(this._config.minHeight);
                    style.maxWidth = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(this._config.maxWidth);
                    style.maxHeight = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(this._config.maxHeight);
                };
                /**
                 * Toggles the pointer events for the overlay pane element.
                 * @private
                 * @param {?} enablePointer
                 * @return {?}
                 */
                OverlayRef.prototype._togglePointerEvents = function (enablePointer) {
                    this._pane.style.pointerEvents = enablePointer ? 'auto' : 'none';
                };
                /**
                 * Attaches a backdrop for this overlay.
                 * @private
                 * @return {?}
                 */
                OverlayRef.prototype._attachBackdrop = function () {
                    var _this = this;
                    /** @type {?} */
                    var showingClass = 'cdk-overlay-backdrop-showing';
                    this._backdropElement = this._document.createElement('div');
                    this._backdropElement.classList.add('cdk-overlay-backdrop');
                    if (this._config.backdropClass) {
                        this._toggleClasses(this._backdropElement, this._config.backdropClass, true);
                    }
                    // Insert the backdrop before the pane in the DOM order,
                    // in order to handle stacked overlays properly.
                    ( /** @type {?} */(this._host.parentElement)).insertBefore(this._backdropElement, this._host);
                    // Forward backdrop clicks such that the consumer of the overlay can perform whatever
                    // action desired when such a click occurs (usually closing the overlay).
                    this._backdropElement.addEventListener('click', this._backdropClickHandler);
                    // Add class to fade-in the backdrop after one frame.
                    if (typeof requestAnimationFrame !== 'undefined') {
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            requestAnimationFrame(( /**
                             * @return {?}
                             */function () {
                                if (_this._backdropElement) {
                                    _this._backdropElement.classList.add(showingClass);
                                }
                            }));
                        }));
                    }
                    else {
                        this._backdropElement.classList.add(showingClass);
                    }
                };
                /**
                 * Updates the stacking order of the element, moving it to the top if necessary.
                 * This is required in cases where one overlay was detached, while another one,
                 * that should be behind it, was destroyed. The next time both of them are opened,
                 * the stacking will be wrong, because the detached element's pane will still be
                 * in its original DOM position.
                 * @private
                 * @return {?}
                 */
                OverlayRef.prototype._updateStackingOrder = function () {
                    if (this._host.nextSibling) {
                        ( /** @type {?} */(this._host.parentNode)).appendChild(this._host);
                    }
                };
                /**
                 * Detaches the backdrop (if any) associated with the overlay.
                 * @return {?}
                 */
                OverlayRef.prototype.detachBackdrop = function () {
                    var _this = this;
                    /** @type {?} */
                    var backdropToDetach = this._backdropElement;
                    if (!backdropToDetach) {
                        return;
                    }
                    /** @type {?} */
                    var timeoutId;
                    /** @type {?} */
                    var finishDetach = ( /**
                     * @return {?}
                     */function () {
                        // It may not be attached to anything in certain cases (e.g. unit tests).
                        if (backdropToDetach) {
                            backdropToDetach.removeEventListener('click', _this._backdropClickHandler);
                            backdropToDetach.removeEventListener('transitionend', finishDetach);
                            if (backdropToDetach.parentNode) {
                                backdropToDetach.parentNode.removeChild(backdropToDetach);
                            }
                        }
                        // It is possible that a new portal has been attached to this overlay since we started
                        // removing the backdrop. If that is the case, only clear the backdrop reference if it
                        // is still the same instance that we started to remove.
                        if (_this._backdropElement == backdropToDetach) {
                            _this._backdropElement = null;
                        }
                        if (_this._config.backdropClass) {
                            _this._toggleClasses(( /** @type {?} */(backdropToDetach)), _this._config.backdropClass, false);
                        }
                        clearTimeout(timeoutId);
                    });
                    backdropToDetach.classList.remove('cdk-overlay-backdrop-showing');
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        ( /** @type {?} */(backdropToDetach)).addEventListener('transitionend', finishDetach);
                    }));
                    // If the backdrop doesn't have a transition, the `transitionend` event won't fire.
                    // In this case we make it unclickable and we try to remove it after a delay.
                    backdropToDetach.style.pointerEvents = 'none';
                    // Run this outside the Angular zone because there's nothing that Angular cares about.
                    // If it were to run inside the Angular zone, every test that used Overlay would have to be
                    // either async or fakeAsync.
                    timeoutId = this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () { return setTimeout(finishDetach, 500); }));
                };
                /**
                 * Toggles a single CSS class or an array of classes on an element.
                 * @private
                 * @param {?} element
                 * @param {?} cssClasses
                 * @param {?} isAdd
                 * @return {?}
                 */
                OverlayRef.prototype._toggleClasses = function (element, cssClasses, isAdd) {
                    /** @type {?} */
                    var classList = element.classList;
                    Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceArray"])(cssClasses).forEach(( /**
                     * @param {?} cssClass
                     * @return {?}
                     */function (/**
                     * @param {?} cssClass
                     * @return {?}
                     */ cssClass) {
                        // We can't do a spread here, because IE doesn't support setting multiple classes.
                        // Also trying to add an empty string to a DOMTokenList will throw.
                        if (cssClass) {
                            isAdd ? classList.add(cssClass) : classList.remove(cssClass);
                        }
                    }));
                };
                /**
                 * Detaches the overlay content next time the zone stabilizes.
                 * @private
                 * @return {?}
                 */
                OverlayRef.prototype._detachContentWhenStable = function () {
                    var _this = this;
                    // Normally we wouldn't have to explicitly run this outside the `NgZone`, however
                    // if the consumer is using `zone-patch-rxjs`, the `Subscription.unsubscribe` call will
                    // be patched to run inside the zone, which will throw us into an infinite loop.
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        // We can't remove the host here immediately, because the overlay pane's content
                        // might still be animating. This stream helps us avoid interrupting the animation
                        // by waiting for the pane to become empty.
                        /** @type {?} */
                        var subscription = _this._ngZone.onStable
                            .asObservable()
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["takeUntil"])(Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["merge"])(_this._attachments, _this._detachments)))
                            .subscribe(( /**
                     * @return {?}
                     */function () {
                            // Needs a couple of checks for the pane and host, because
                            // they may have been removed by the time the zone stabilizes.
                            if (!_this._pane || !_this._host || _this._pane.children.length === 0) {
                                if (_this._pane && _this._config.panelClass) {
                                    _this._toggleClasses(_this._pane, _this._config.panelClass, false);
                                }
                                if (_this._host && _this._host.parentElement) {
                                    _this._previousHostParent = _this._host.parentElement;
                                    _this._previousHostParent.removeChild(_this._host);
                                }
                                subscription.unsubscribe();
                            }
                        }));
                    }));
                };
                /**
                 * Disposes of a scroll strategy.
                 * @private
                 * @return {?}
                 */
                OverlayRef.prototype._disposeScrollStrategy = function () {
                    /** @type {?} */
                    var scrollStrategy = this._scrollStrategy;
                    if (scrollStrategy) {
                        scrollStrategy.disable();
                        if (scrollStrategy.detach) {
                            scrollStrategy.detach();
                        }
                    }
                };
                return OverlayRef;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO: refactor clipping detection into a separate thing (part of scrolling module)
            // TODO: doesn't handle both flexible width and height when it has to scroll along both axis.
            /**
             * Class to be added to the overlay bounding box.
             * @type {?}
             */
            var boundingBoxClass = 'cdk-overlay-connected-position-bounding-box';
            /**
             * A strategy for positioning overlays. Using this strategy, an overlay is given an
             * implicit position relative some origin element. The relative position is defined in terms of
             * a point on the origin element that is connected to a point on the overlay element. For example,
             * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
             * of the overlay.
             */
            var FlexibleConnectedPositionStrategy = /** @class */ (function () {
                /**
                 * @param {?} connectedTo
                 * @param {?} _viewportRuler
                 * @param {?} _document
                 * @param {?} _platform
                 * @param {?} _overlayContainer
                 */
                function FlexibleConnectedPositionStrategy(connectedTo, _viewportRuler, _document, _platform, _overlayContainer) {
                    this._viewportRuler = _viewportRuler;
                    this._document = _document;
                    this._platform = _platform;
                    this._overlayContainer = _overlayContainer;
                    /**
                     * Last size used for the bounding box. Used to avoid resizing the overlay after open.
                     */
                    this._lastBoundingBoxSize = { width: 0, height: 0 };
                    /**
                     * Whether the overlay was pushed in a previous positioning.
                     */
                    this._isPushed = false;
                    /**
                     * Whether the overlay can be pushed on-screen on the initial open.
                     */
                    this._canPush = true;
                    /**
                     * Whether the overlay can grow via flexible width/height after the initial open.
                     */
                    this._growAfterOpen = false;
                    /**
                     * Whether the overlay's width and height can be constrained to fit within the viewport.
                     */
                    this._hasFlexibleDimensions = true;
                    /**
                     * Whether the overlay position is locked.
                     */
                    this._positionLocked = false;
                    /**
                     * Amount of space that must be maintained between the overlay and the edge of the viewport.
                     */
                    this._viewportMargin = 0;
                    /**
                     * The Scrollable containers used to check scrollable view properties on position change.
                     */
                    this._scrollables = [];
                    /**
                     * Ordered list of preferred positions, from most to least desirable.
                     */
                    this._preferredPositions = [];
                    /**
                     * Subject that emits whenever the position changes.
                     */
                    this._positionChanges = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * Subscription to viewport size changes.
                     */
                    this._resizeSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Default offset for the overlay along the x axis.
                     */
                    this._offsetX = 0;
                    /**
                     * Default offset for the overlay along the y axis.
                     */
                    this._offsetY = 0;
                    /**
                     * Keeps track of the CSS classes that the position strategy has applied on the overlay panel.
                     */
                    this._appliedPanelClasses = [];
                    /**
                     * Observable sequence of position changes.
                     */
                    this.positionChanges = this._positionChanges.asObservable();
                    this.setOrigin(connectedTo);
                }
                Object.defineProperty(FlexibleConnectedPositionStrategy.prototype, "positions", {
                    /**
                     * Ordered list of preferred positions, from most to least desirable.
                     * @return {?}
                     */
                    get: function () {
                        return this._preferredPositions;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Attaches this position strategy to an overlay.
                 * @param {?} overlayRef
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype.attach = function (overlayRef) {
                    var _this = this;
                    if (this._overlayRef && overlayRef !== this._overlayRef) {
                        throw Error('This position strategy is already attached to an overlay');
                    }
                    this._validatePositions();
                    overlayRef.hostElement.classList.add(boundingBoxClass);
                    this._overlayRef = overlayRef;
                    this._boundingBox = overlayRef.hostElement;
                    this._pane = overlayRef.overlayElement;
                    this._isDisposed = false;
                    this._isInitialRender = true;
                    this._lastPosition = null;
                    this._resizeSubscription.unsubscribe();
                    this._resizeSubscription = this._viewportRuler.change().subscribe(( /**
                     * @return {?}
                     */function () {
                        // When the window is resized, we want to trigger the next reposition as if it
                        // was an initial render, in order for the strategy to pick a new optimal position,
                        // otherwise position locking will cause it to stay at the old one.
                        _this._isInitialRender = true;
                        _this.apply();
                    }));
                };
                /**
                 * Updates the position of the overlay element, using whichever preferred position relative
                 * to the origin best fits on-screen.
                 *
                 * The selection of a position goes as follows:
                 *  - If any positions fit completely within the viewport as-is,
                 *      choose the first position that does so.
                 *  - If flexible dimensions are enabled and at least one satifies the given minimum width/height,
                 *      choose the position with the greatest available size modified by the positions' weight.
                 *  - If pushing is enabled, take the position that went off-screen the least and push it
                 *      on-screen.
                 *  - If none of the previous criteria were met, use the position that goes off-screen the least.
                 * \@docs-private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype.apply = function () {
                    // We shouldn't do anything if the strategy was disposed or we're on the server.
                    if (this._isDisposed || !this._platform.isBrowser) {
                        return;
                    }
                    // If the position has been applied already (e.g. when the overlay was opened) and the
                    // consumer opted into locking in the position, re-use the old position, in order to
                    // prevent the overlay from jumping around.
                    if (!this._isInitialRender && this._positionLocked && this._lastPosition) {
                        this.reapplyLastPosition();
                        return;
                    }
                    this._clearPanelClasses();
                    this._resetOverlayElementStyles();
                    this._resetBoundingBoxStyles();
                    // We need the bounding rects for the origin and the overlay to determine how to position
                    // the overlay relative to the origin.
                    // We use the viewport rect to determine whether a position would go off-screen.
                    this._viewportRect = this._getNarrowedViewportRect();
                    this._originRect = this._getOriginRect();
                    this._overlayRect = this._pane.getBoundingClientRect();
                    /** @type {?} */
                    var originRect = this._originRect;
                    /** @type {?} */
                    var overlayRect = this._overlayRect;
                    /** @type {?} */
                    var viewportRect = this._viewportRect;
                    // Positions where the overlay will fit with flexible dimensions.
                    /** @type {?} */
                    var flexibleFits = [];
                    // Fallback if none of the preferred positions fit within the viewport.
                    /** @type {?} */
                    var fallback;
                    // Go through each of the preferred positions looking for a good fit.
                    // If a good fit is found, it will be applied immediately.
                    for (var _c = 0, _d = this._preferredPositions; _c < _d.length; _c++) {
                        var pos = _d[_c];
                        // Get the exact (x, y) coordinate for the point-of-origin on the origin element.
                        /** @type {?} */
                        var originPoint = this._getOriginPoint(originRect, pos);
                        // From that point-of-origin, get the exact (x, y) coordinate for the top-left corner of the
                        // overlay in this position. We use the top-left corner for calculations and later translate
                        // this into an appropriate (top, left, bottom, right) style.
                        /** @type {?} */
                        var overlayPoint = this._getOverlayPoint(originPoint, overlayRect, pos);
                        // Calculate how well the overlay would fit into the viewport with this point.
                        /** @type {?} */
                        var overlayFit = this._getOverlayFit(overlayPoint, overlayRect, viewportRect, pos);
                        // If the overlay, without any further work, fits into the viewport, use this position.
                        if (overlayFit.isCompletelyWithinViewport) {
                            this._isPushed = false;
                            this._applyPosition(pos, originPoint);
                            return;
                        }
                        // If the overlay has flexible dimensions, we can use this position
                        // so long as there's enough space for the minimum dimensions.
                        if (this._canFitWithFlexibleDimensions(overlayFit, overlayPoint, viewportRect)) {
                            // Save positions where the overlay will fit with flexible dimensions. We will use these
                            // if none of the positions fit *without* flexible dimensions.
                            flexibleFits.push({
                                position: pos,
                                origin: originPoint,
                                overlayRect: overlayRect,
                                boundingBoxRect: this._calculateBoundingBoxRect(originPoint, pos)
                            });
                            continue;
                        }
                        // If the current preferred position does not fit on the screen, remember the position
                        // if it has more visible area on-screen than we've seen and move onto the next preferred
                        // position.
                        if (!fallback || fallback.overlayFit.visibleArea < overlayFit.visibleArea) {
                            fallback = { overlayFit: overlayFit, overlayPoint: overlayPoint, originPoint: originPoint, position: pos, overlayRect: overlayRect };
                        }
                    }
                    // If there are any positions where the overlay would fit with flexible dimensions, choose the
                    // one that has the greatest area available modified by the position's weight
                    if (flexibleFits.length) {
                        /** @type {?} */
                        var bestFit = null;
                        /** @type {?} */
                        var bestScore = -1;
                        for (var _e = 0, flexibleFits_1 = flexibleFits; _e < flexibleFits_1.length; _e++) {
                            var fit = flexibleFits_1[_e];
                            /** @type {?} */
                            var score = fit.boundingBoxRect.width * fit.boundingBoxRect.height * (fit.position.weight || 1);
                            if (score > bestScore) {
                                bestScore = score;
                                bestFit = fit;
                            }
                        }
                        this._isPushed = false;
                        this._applyPosition(( /** @type {?} */(bestFit)).position, ( /** @type {?} */(bestFit)).origin);
                        return;
                    }
                    // When none of the preferred positions fit within the viewport, take the position
                    // that went off-screen the least and attempt to push it on-screen.
                    if (this._canPush) {
                        // TODO(jelbourn): after pushing, the opening "direction" of the overlay might not make sense.
                        this._isPushed = true;
                        this._applyPosition(( /** @type {?} */(fallback)).position, ( /** @type {?} */(fallback)).originPoint);
                        return;
                    }
                    // All options for getting the overlay within the viewport have been exhausted, so go with the
                    // position that went off-screen the least.
                    this._applyPosition(( /** @type {?} */(fallback)).position, ( /** @type {?} */(fallback)).originPoint);
                };
                /**
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype.detach = function () {
                    this._clearPanelClasses();
                    this._lastPosition = null;
                    this._previousPushAmount = null;
                    this._resizeSubscription.unsubscribe();
                };
                /**
                 * Cleanup after the element gets destroyed.
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype.dispose = function () {
                    if (this._isDisposed) {
                        return;
                    }
                    // We can't use `_resetBoundingBoxStyles` here, because it resets
                    // some properties to zero, rather than removing them.
                    if (this._boundingBox) {
                        extendStyles(this._boundingBox.style, ( /** @type {?} */({
                            top: '',
                            left: '',
                            right: '',
                            bottom: '',
                            height: '',
                            width: '',
                            alignItems: '',
                            justifyContent: '',
                        })));
                    }
                    if (this._pane) {
                        this._resetOverlayElementStyles();
                    }
                    if (this._overlayRef) {
                        this._overlayRef.hostElement.classList.remove(boundingBoxClass);
                    }
                    this.detach();
                    this._positionChanges.complete();
                    this._overlayRef = this._boundingBox = ( /** @type {?} */(null));
                    this._isDisposed = true;
                };
                /**
                 * This re-aligns the overlay element with the trigger in its last calculated position,
                 * even if a position higher in the "preferred positions" list would now fit. This
                 * allows one to re-align the panel without changing the orientation of the panel.
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype.reapplyLastPosition = function () {
                    if (!this._isDisposed && (!this._platform || this._platform.isBrowser)) {
                        this._originRect = this._getOriginRect();
                        this._overlayRect = this._pane.getBoundingClientRect();
                        this._viewportRect = this._getNarrowedViewportRect();
                        /** @type {?} */
                        var lastPosition = this._lastPosition || this._preferredPositions[0];
                        /** @type {?} */
                        var originPoint = this._getOriginPoint(this._originRect, lastPosition);
                        this._applyPosition(lastPosition, originPoint);
                    }
                };
                /**
                 * Sets the list of Scrollable containers that host the origin element so that
                 * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
                 * Scrollable must be an ancestor element of the strategy's origin element.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} scrollables
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withScrollableContainers = function (scrollables) {
                    ( /** @type {?} */(this))._scrollables = scrollables;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Adds new preferred positions.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} positions List of positions options for this overlay.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withPositions = function (positions) {
                    ( /** @type {?} */(this))._preferredPositions = positions;
                    // If the last calculated position object isn't part of the positions anymore, clear
                    // it in order to avoid it being picked up if the consumer tries to re-apply.
                    if (positions.indexOf(( /** @type {?} */(( /** @type {?} */(this))._lastPosition))) === -1) {
                        ( /** @type {?} */(this))._lastPosition = null;
                    }
                    ( /** @type {?} */(this))._validatePositions();
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets a minimum distance the overlay may be positioned to the edge of the viewport.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} margin Required margin between the overlay and the viewport edge in pixels.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withViewportMargin = function (margin) {
                    ( /** @type {?} */(this))._viewportMargin = margin;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets whether the overlay's width and height can be constrained to fit within the viewport.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} flexibleDimensions
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withFlexibleDimensions = function (flexibleDimensions) {
                    if (flexibleDimensions === void 0) { flexibleDimensions = true; }
                    ( /** @type {?} */(this))._hasFlexibleDimensions = flexibleDimensions;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets whether the overlay can grow after the initial open via flexible width/height.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} growAfterOpen
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withGrowAfterOpen = function (growAfterOpen) {
                    if (growAfterOpen === void 0) { growAfterOpen = true; }
                    ( /** @type {?} */(this))._growAfterOpen = growAfterOpen;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets whether the overlay can be pushed on-screen if none of the provided positions fit.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} canPush
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withPush = function (canPush) {
                    if (canPush === void 0) { canPush = true; }
                    ( /** @type {?} */(this))._canPush = canPush;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets whether the overlay's position should be locked in after it is positioned
                 * initially. When an overlay is locked in, it won't attempt to reposition itself
                 * when the position is re-applied (e.g. when the user scrolls away).
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} isLocked Whether the overlay should locked in.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withLockedPosition = function (isLocked) {
                    if (isLocked === void 0) { isLocked = true; }
                    ( /** @type {?} */(this))._positionLocked = isLocked;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the origin, relative to which to position the overlay.
                 * Using an element origin is useful for building components that need to be positioned
                 * relatively to a trigger (e.g. dropdown menus or tooltips), whereas using a point can be
                 * used for cases like contextual menus which open relative to the user's pointer.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} origin Reference to the new origin.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.setOrigin = function (origin) {
                    ( /** @type {?} */(this))._origin = origin;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the default offset for the overlay's connection point on the x-axis.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} offset New offset in the X axis.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withDefaultOffsetX = function (offset) {
                    ( /** @type {?} */(this))._offsetX = offset;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the default offset for the overlay's connection point on the y-axis.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} offset New offset in the Y axis.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withDefaultOffsetY = function (offset) {
                    ( /** @type {?} */(this))._offsetY = offset;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Configures that the position strategy should set a `transform-origin` on some elements
                 * inside the overlay, depending on the current position that is being applied. This is
                 * useful for the cases where the origin of an animation can change depending on the
                 * alignment of the overlay.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} selector CSS selector that will be used to find the target
                 *    elements onto which to set the transform origin.
                 * @return {THIS}
                 */
                FlexibleConnectedPositionStrategy.prototype.withTransformOriginOn = function (selector) {
                    ( /** @type {?} */(this))._transformOriginSelector = selector;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
                 * @private
                 * @param {?} originRect
                 * @param {?} pos
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getOriginPoint = function (originRect, pos) {
                    /** @type {?} */
                    var x;
                    if (pos.originX == 'center') {
                        // Note: when centering we should always use the `left`
                        // offset, otherwise the position will be wrong in RTL.
                        x = originRect.left + (originRect.width / 2);
                    }
                    else {
                        /** @type {?} */
                        var startX = this._isRtl() ? originRect.right : originRect.left;
                        /** @type {?} */
                        var endX = this._isRtl() ? originRect.left : originRect.right;
                        x = pos.originX == 'start' ? startX : endX;
                    }
                    /** @type {?} */
                    var y;
                    if (pos.originY == 'center') {
                        y = originRect.top + (originRect.height / 2);
                    }
                    else {
                        y = pos.originY == 'top' ? originRect.top : originRect.bottom;
                    }
                    return { x: x, y: y };
                };
                /**
                 * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
                 * origin point to which the overlay should be connected.
                 * @private
                 * @param {?} originPoint
                 * @param {?} overlayRect
                 * @param {?} pos
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getOverlayPoint = function (originPoint, overlayRect, pos) {
                    // Calculate the (overlayStartX, overlayStartY), the start of the
                    // potential overlay position relative to the origin point.
                    /** @type {?} */
                    var overlayStartX;
                    if (pos.overlayX == 'center') {
                        overlayStartX = -overlayRect.width / 2;
                    }
                    else if (pos.overlayX === 'start') {
                        overlayStartX = this._isRtl() ? -overlayRect.width : 0;
                    }
                    else {
                        overlayStartX = this._isRtl() ? 0 : -overlayRect.width;
                    }
                    /** @type {?} */
                    var overlayStartY;
                    if (pos.overlayY == 'center') {
                        overlayStartY = -overlayRect.height / 2;
                    }
                    else {
                        overlayStartY = pos.overlayY == 'top' ? 0 : -overlayRect.height;
                    }
                    // The (x, y) coordinates of the overlay.
                    return {
                        x: originPoint.x + overlayStartX,
                        y: originPoint.y + overlayStartY,
                    };
                };
                /**
                 * Gets how well an overlay at the given point will fit within the viewport.
                 * @private
                 * @param {?} point
                 * @param {?} overlay
                 * @param {?} viewport
                 * @param {?} position
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getOverlayFit = function (point, overlay, viewport, position) {
                    var x = point.x, y = point.y;
                    /** @type {?} */
                    var offsetX = this._getOffset(position, 'x');
                    /** @type {?} */
                    var offsetY = this._getOffset(position, 'y');
                    // Account for the offsets since they could push the overlay out of the viewport.
                    if (offsetX) {
                        x += offsetX;
                    }
                    if (offsetY) {
                        y += offsetY;
                    }
                    // How much the overlay would overflow at this position, on each side.
                    /** @type {?} */
                    var leftOverflow = 0 - x;
                    /** @type {?} */
                    var rightOverflow = (x + overlay.width) - viewport.width;
                    /** @type {?} */
                    var topOverflow = 0 - y;
                    /** @type {?} */
                    var bottomOverflow = (y + overlay.height) - viewport.height;
                    // Visible parts of the element on each axis.
                    /** @type {?} */
                    var visibleWidth = this._subtractOverflows(overlay.width, leftOverflow, rightOverflow);
                    /** @type {?} */
                    var visibleHeight = this._subtractOverflows(overlay.height, topOverflow, bottomOverflow);
                    /** @type {?} */
                    var visibleArea = visibleWidth * visibleHeight;
                    return {
                        visibleArea: visibleArea,
                        isCompletelyWithinViewport: (overlay.width * overlay.height) === visibleArea,
                        fitsInViewportVertically: visibleHeight === overlay.height,
                        fitsInViewportHorizontally: visibleWidth == overlay.width,
                    };
                };
                /**
                 * Whether the overlay can fit within the viewport when it may resize either its width or height.
                 * @private
                 * @param {?} fit How well the overlay fits in the viewport at some position.
                 * @param {?} point The (x, y) coordinates of the overlat at some position.
                 * @param {?} viewport The geometry of the viewport.
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._canFitWithFlexibleDimensions = function (fit, point, viewport) {
                    if (this._hasFlexibleDimensions) {
                        /** @type {?} */
                        var availableHeight = viewport.bottom - point.y;
                        /** @type {?} */
                        var availableWidth = viewport.right - point.x;
                        /** @type {?} */
                        var minHeight = this._overlayRef.getConfig().minHeight;
                        /** @type {?} */
                        var minWidth = this._overlayRef.getConfig().minWidth;
                        /** @type {?} */
                        var verticalFit = fit.fitsInViewportVertically ||
                            (minHeight != null && minHeight <= availableHeight);
                        /** @type {?} */
                        var horizontalFit = fit.fitsInViewportHorizontally ||
                            (minWidth != null && minWidth <= availableWidth);
                        return verticalFit && horizontalFit;
                    }
                    return false;
                };
                /**
                 * Gets the point at which the overlay can be "pushed" on-screen. If the overlay is larger than
                 * the viewport, the top-left corner will be pushed on-screen (with overflow occuring on the
                 * right and bottom).
                 *
                 * @private
                 * @param {?} start Starting point from which the overlay is pushed.
                 * @param {?} overlay Dimensions of the overlay.
                 * @param {?} scrollPosition Current viewport scroll position.
                 * @return {?} The point at which to position the overlay after pushing. This is effectively a new
                 *     originPoint.
                 */
                FlexibleConnectedPositionStrategy.prototype._pushOverlayOnScreen = function (start, overlay, scrollPosition) {
                    // If the position is locked and we've pushed the overlay already, reuse the previous push
                    // amount, rather than pushing it again. If we were to continue pushing, the element would
                    // remain in the viewport, which goes against the expectations when position locking is enabled.
                    if (this._previousPushAmount && this._positionLocked) {
                        return {
                            x: start.x + this._previousPushAmount.x,
                            y: start.y + this._previousPushAmount.y
                        };
                    }
                    /** @type {?} */
                    var viewport = this._viewportRect;
                    // Determine how much the overlay goes outside the viewport on each
                    // side, which we'll use to decide which direction to push it.
                    /** @type {?} */
                    var overflowRight = Math.max(start.x + overlay.width - viewport.right, 0);
                    /** @type {?} */
                    var overflowBottom = Math.max(start.y + overlay.height - viewport.bottom, 0);
                    /** @type {?} */
                    var overflowTop = Math.max(viewport.top - scrollPosition.top - start.y, 0);
                    /** @type {?} */
                    var overflowLeft = Math.max(viewport.left - scrollPosition.left - start.x, 0);
                    // Amount by which to push the overlay in each axis such that it remains on-screen.
                    /** @type {?} */
                    var pushX = 0;
                    /** @type {?} */
                    var pushY = 0;
                    // If the overlay fits completely within the bounds of the viewport, push it from whichever
                    // direction is goes off-screen. Otherwise, push the top-left corner such that its in the
                    // viewport and allow for the trailing end of the overlay to go out of bounds.
                    if (overlay.width <= viewport.width) {
                        pushX = overflowLeft || -overflowRight;
                    }
                    else {
                        pushX = start.x < this._viewportMargin ? (viewport.left - scrollPosition.left) - start.x : 0;
                    }
                    if (overlay.height <= viewport.height) {
                        pushY = overflowTop || -overflowBottom;
                    }
                    else {
                        pushY = start.y < this._viewportMargin ? (viewport.top - scrollPosition.top) - start.y : 0;
                    }
                    this._previousPushAmount = { x: pushX, y: pushY };
                    return {
                        x: start.x + pushX,
                        y: start.y + pushY,
                    };
                };
                /**
                 * Applies a computed position to the overlay and emits a position change.
                 * @private
                 * @param {?} position The position preference
                 * @param {?} originPoint The point on the origin element where the overlay is connected.
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._applyPosition = function (position, originPoint) {
                    this._setTransformOrigin(position);
                    this._setOverlayElementStyles(originPoint, position);
                    this._setBoundingBoxStyles(originPoint, position);
                    if (position.panelClass) {
                        this._addPanelClasses(position.panelClass);
                    }
                    // Save the last connected position in case the position needs to be re-calculated.
                    this._lastPosition = position;
                    // Notify that the position has been changed along with its change properties.
                    // We only emit if we've got any subscriptions, because the scroll visibility
                    // calculcations can be somewhat expensive.
                    if (this._positionChanges.observers.length) {
                        /** @type {?} */
                        var scrollableViewProperties = this._getScrollVisibility();
                        /** @type {?} */
                        var changeEvent = new ConnectedOverlayPositionChange(position, scrollableViewProperties);
                        this._positionChanges.next(changeEvent);
                    }
                    this._isInitialRender = false;
                };
                /**
                 * Sets the transform origin based on the configured selector and the passed-in position.
                 * @private
                 * @param {?} position
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._setTransformOrigin = function (position) {
                    if (!this._transformOriginSelector) {
                        return;
                    }
                    /** @type {?} */
                    var elements = ( /** @type {?} */(this._boundingBox)).querySelectorAll(this._transformOriginSelector);
                    /** @type {?} */
                    var xOrigin;
                    /** @type {?} */
                    var yOrigin = position.overlayY;
                    if (position.overlayX === 'center') {
                        xOrigin = 'center';
                    }
                    else if (this._isRtl()) {
                        xOrigin = position.overlayX === 'start' ? 'right' : 'left';
                    }
                    else {
                        xOrigin = position.overlayX === 'start' ? 'left' : 'right';
                    }
                    for (var i = 0; i < elements.length; i++) {
                        elements[i].style.transformOrigin = xOrigin + " " + yOrigin;
                    }
                };
                /**
                 * Gets the position and size of the overlay's sizing container.
                 *
                 * This method does no measuring and applies no styles so that we can cheaply compute the
                 * bounds for all positions and choose the best fit based on these results.
                 * @private
                 * @param {?} origin
                 * @param {?} position
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._calculateBoundingBoxRect = function (origin, position) {
                    /** @type {?} */
                    var viewport = this._viewportRect;
                    /** @type {?} */
                    var isRtl = this._isRtl();
                    /** @type {?} */
                    var height;
                    /** @type {?} */
                    var top;
                    /** @type {?} */
                    var bottom;
                    if (position.overlayY === 'top') {
                        // Overlay is opening "downward" and thus is bound by the bottom viewport edge.
                        top = origin.y;
                        height = viewport.height - top + this._viewportMargin;
                    }
                    else if (position.overlayY === 'bottom') {
                        // Overlay is opening "upward" and thus is bound by the top viewport edge. We need to add
                        // the viewport margin back in, because the viewport rect is narrowed down to remove the
                        // margin, whereas the `origin` position is calculated based on its `ClientRect`.
                        bottom = viewport.height - origin.y + this._viewportMargin * 2;
                        height = viewport.height - bottom + this._viewportMargin;
                    }
                    else {
                        // If neither top nor bottom, it means that the overlay is vertically centered on the
                        // origin point. Note that we want the position relative to the viewport, rather than
                        // the page, which is why we don't use something like `viewport.bottom - origin.y` and
                        // `origin.y - viewport.top`.
                        /** @type {?} */
                        var smallestDistanceToViewportEdge = Math.min(viewport.bottom - origin.y + viewport.top, origin.y);
                        /** @type {?} */
                        var previousHeight = this._lastBoundingBoxSize.height;
                        height = smallestDistanceToViewportEdge * 2;
                        top = origin.y - smallestDistanceToViewportEdge;
                        if (height > previousHeight && !this._isInitialRender && !this._growAfterOpen) {
                            top = origin.y - (previousHeight / 2);
                        }
                    }
                    // The overlay is opening 'right-ward' (the content flows to the right).
                    /** @type {?} */
                    var isBoundedByRightViewportEdge = (position.overlayX === 'start' && !isRtl) ||
                        (position.overlayX === 'end' && isRtl);
                    // The overlay is opening 'left-ward' (the content flows to the left).
                    /** @type {?} */
                    var isBoundedByLeftViewportEdge = (position.overlayX === 'end' && !isRtl) ||
                        (position.overlayX === 'start' && isRtl);
                    /** @type {?} */
                    var width;
                    /** @type {?} */
                    var left;
                    /** @type {?} */
                    var right;
                    if (isBoundedByLeftViewportEdge) {
                        right = viewport.width - origin.x + this._viewportMargin;
                        width = origin.x - this._viewportMargin;
                    }
                    else if (isBoundedByRightViewportEdge) {
                        left = origin.x;
                        width = viewport.right - origin.x;
                    }
                    else {
                        // If neither start nor end, it means that the overlay is horizontally centered on the
                        // origin point. Note that we want the position relative to the viewport, rather than
                        // the page, which is why we don't use something like `viewport.right - origin.x` and
                        // `origin.x - viewport.left`.
                        /** @type {?} */
                        var smallestDistanceToViewportEdge = Math.min(viewport.right - origin.x + viewport.left, origin.x);
                        /** @type {?} */
                        var previousWidth = this._lastBoundingBoxSize.width;
                        width = smallestDistanceToViewportEdge * 2;
                        left = origin.x - smallestDistanceToViewportEdge;
                        if (width > previousWidth && !this._isInitialRender && !this._growAfterOpen) {
                            left = origin.x - (previousWidth / 2);
                        }
                    }
                    return { top: ( /** @type {?} */(top)), left: ( /** @type {?} */(left)), bottom: ( /** @type {?} */(bottom)), right: ( /** @type {?} */(right)), width: width, height: height };
                };
                /**
                 * Sets the position and size of the overlay's sizing wrapper. The wrapper is positioned on the
                 * origin's connection point and stetches to the bounds of the viewport.
                 *
                 * @private
                 * @param {?} origin The point on the origin element where the overlay is connected.
                 * @param {?} position The position preference
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._setBoundingBoxStyles = function (origin, position) {
                    /** @type {?} */
                    var boundingBoxRect = this._calculateBoundingBoxRect(origin, position);
                    // It's weird if the overlay *grows* while scrolling, so we take the last size into account
                    // when applying a new size.
                    if (!this._isInitialRender && !this._growAfterOpen) {
                        boundingBoxRect.height = Math.min(boundingBoxRect.height, this._lastBoundingBoxSize.height);
                        boundingBoxRect.width = Math.min(boundingBoxRect.width, this._lastBoundingBoxSize.width);
                    }
                    /** @type {?} */
                    var styles = ( /** @type {?} */({}));
                    if (this._hasExactPosition()) {
                        styles.top = styles.left = '0';
                        styles.bottom = styles.right = '';
                        styles.width = styles.height = '100%';
                    }
                    else {
                        /** @type {?} */
                        var maxHeight = this._overlayRef.getConfig().maxHeight;
                        /** @type {?} */
                        var maxWidth = this._overlayRef.getConfig().maxWidth;
                        styles.height = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(boundingBoxRect.height);
                        styles.top = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(boundingBoxRect.top);
                        styles.bottom = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(boundingBoxRect.bottom);
                        styles.width = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(boundingBoxRect.width);
                        styles.left = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(boundingBoxRect.left);
                        styles.right = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(boundingBoxRect.right);
                        // Push the pane content towards the proper direction.
                        if (position.overlayX === 'center') {
                            styles.alignItems = 'center';
                        }
                        else {
                            styles.alignItems = position.overlayX === 'end' ? 'flex-end' : 'flex-start';
                        }
                        if (position.overlayY === 'center') {
                            styles.justifyContent = 'center';
                        }
                        else {
                            styles.justifyContent = position.overlayY === 'bottom' ? 'flex-end' : 'flex-start';
                        }
                        if (maxHeight) {
                            styles.maxHeight = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(maxHeight);
                        }
                        if (maxWidth) {
                            styles.maxWidth = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(maxWidth);
                        }
                    }
                    this._lastBoundingBoxSize = boundingBoxRect;
                    extendStyles(( /** @type {?} */(this._boundingBox)).style, styles);
                };
                /**
                 * Resets the styles for the bounding box so that a new positioning can be computed.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._resetBoundingBoxStyles = function () {
                    extendStyles(( /** @type {?} */(this._boundingBox)).style, ( /** @type {?} */({
                        top: '0',
                        left: '0',
                        right: '0',
                        bottom: '0',
                        height: '',
                        width: '',
                        alignItems: '',
                        justifyContent: '',
                    })));
                };
                /**
                 * Resets the styles for the overlay pane so that a new positioning can be computed.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._resetOverlayElementStyles = function () {
                    extendStyles(this._pane.style, ( /** @type {?} */({
                        top: '',
                        left: '',
                        bottom: '',
                        right: '',
                        position: '',
                        transform: '',
                    })));
                };
                /**
                 * Sets positioning styles to the overlay element.
                 * @private
                 * @param {?} originPoint
                 * @param {?} position
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._setOverlayElementStyles = function (originPoint, position) {
                    /** @type {?} */
                    var styles = ( /** @type {?} */({}));
                    if (this._hasExactPosition()) {
                        /** @type {?} */
                        var scrollPosition = this._viewportRuler.getViewportScrollPosition();
                        extendStyles(styles, this._getExactOverlayY(position, originPoint, scrollPosition));
                        extendStyles(styles, this._getExactOverlayX(position, originPoint, scrollPosition));
                    }
                    else {
                        styles.position = 'static';
                    }
                    // Use a transform to apply the offsets. We do this because the `center` positions rely on
                    // being in the normal flex flow and setting a `top` / `left` at all will completely throw
                    // off the position. We also can't use margins, because they won't have an effect in some
                    // cases where the element doesn't have anything to "push off of". Finally, this works
                    // better both with flexible and non-flexible positioning.
                    /** @type {?} */
                    var transformString = '';
                    /** @type {?} */
                    var offsetX = this._getOffset(position, 'x');
                    /** @type {?} */
                    var offsetY = this._getOffset(position, 'y');
                    if (offsetX) {
                        transformString += "translateX(" + offsetX + "px) ";
                    }
                    if (offsetY) {
                        transformString += "translateY(" + offsetY + "px)";
                    }
                    styles.transform = transformString.trim();
                    // If a maxWidth or maxHeight is specified on the overlay, we remove them. We do this because
                    // we need these values to both be set to "100%" for the automatic flexible sizing to work.
                    // The maxHeight and maxWidth are set on the boundingBox in order to enforce the constraint.
                    if (this._hasFlexibleDimensions && this._overlayRef.getConfig().maxHeight) {
                        styles.maxHeight = '';
                    }
                    if (this._hasFlexibleDimensions && this._overlayRef.getConfig().maxWidth) {
                        styles.maxWidth = '';
                    }
                    extendStyles(this._pane.style, styles);
                };
                /**
                 * Gets the exact top/bottom for the overlay when not using flexible sizing or when pushing.
                 * @private
                 * @param {?} position
                 * @param {?} originPoint
                 * @param {?} scrollPosition
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getExactOverlayY = function (position, originPoint, scrollPosition) {
                    // Reset any existing styles. This is necessary in case the
                    // preferred position has changed since the last `apply`.
                    /** @type {?} */
                    var styles = ( /** @type {?} */({ top: null, bottom: null }));
                    /** @type {?} */
                    var overlayPoint = this._getOverlayPoint(originPoint, this._overlayRect, position);
                    if (this._isPushed) {
                        overlayPoint = this._pushOverlayOnScreen(overlayPoint, this._overlayRect, scrollPosition);
                    }
                    /** @type {?} */
                    var virtualKeyboardOffset = this._overlayContainer.getContainerElement().getBoundingClientRect().top;
                    // Normally this would be zero, however when the overlay is attached to an input (e.g. in an
                    // autocomplete), mobile browsers will shift everything in order to put the input in the middle
                    // of the screen and to make space for the virtual keyboard. We need to account for this offset,
                    // otherwise our positioning will be thrown off.
                    overlayPoint.y -= virtualKeyboardOffset;
                    // We want to set either `top` or `bottom` based on whether the overlay wants to appear
                    // above or below the origin and the direction in which the element will expand.
                    if (position.overlayY === 'bottom') {
                        // When using `bottom`, we adjust the y position such that it is the distance
                        // from the bottom of the viewport rather than the top.
                        /** @type {?} */
                        var documentHeight = ( /** @type {?} */(this._document.documentElement)).clientHeight;
                        styles.bottom = documentHeight - (overlayPoint.y + this._overlayRect.height) + "px";
                    }
                    else {
                        styles.top = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(overlayPoint.y);
                    }
                    return styles;
                };
                /**
                 * Gets the exact left/right for the overlay when not using flexible sizing or when pushing.
                 * @private
                 * @param {?} position
                 * @param {?} originPoint
                 * @param {?} scrollPosition
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getExactOverlayX = function (position, originPoint, scrollPosition) {
                    // Reset any existing styles. This is necessary in case the preferred position has
                    // changed since the last `apply`.
                    /** @type {?} */
                    var styles = ( /** @type {?} */({ left: null, right: null }));
                    /** @type {?} */
                    var overlayPoint = this._getOverlayPoint(originPoint, this._overlayRect, position);
                    if (this._isPushed) {
                        overlayPoint = this._pushOverlayOnScreen(overlayPoint, this._overlayRect, scrollPosition);
                    }
                    // We want to set either `left` or `right` based on whether the overlay wants to appear "before"
                    // or "after" the origin, which determines the direction in which the element will expand.
                    // For the horizontal axis, the meaning of "before" and "after" change based on whether the
                    // page is in RTL or LTR.
                    /** @type {?} */
                    var horizontalStyleProperty;
                    if (this._isRtl()) {
                        horizontalStyleProperty = position.overlayX === 'end' ? 'left' : 'right';
                    }
                    else {
                        horizontalStyleProperty = position.overlayX === 'end' ? 'right' : 'left';
                    }
                    // When we're setting `right`, we adjust the x position such that it is the distance
                    // from the right edge of the viewport rather than the left edge.
                    if (horizontalStyleProperty === 'right') {
                        /** @type {?} */
                        var documentWidth = ( /** @type {?} */(this._document.documentElement)).clientWidth;
                        styles.right = documentWidth - (overlayPoint.x + this._overlayRect.width) + "px";
                    }
                    else {
                        styles.left = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceCssPixelValue"])(overlayPoint.x);
                    }
                    return styles;
                };
                /**
                 * Gets the view properties of the trigger and overlay, including whether they are clipped
                 * or completely outside the view of any of the strategy's scrollables.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getScrollVisibility = function () {
                    // Note: needs fresh rects since the position could've changed.
                    /** @type {?} */
                    var originBounds = this._getOriginRect();
                    /** @type {?} */
                    var overlayBounds = this._pane.getBoundingClientRect();
                    // TODO(jelbourn): instead of needing all of the client rects for these scrolling containers
                    // every time, we should be able to use the scrollTop of the containers if the size of those
                    // containers hasn't changed.
                    /** @type {?} */
                    var scrollContainerBounds = this._scrollables.map(( /**
                     * @param {?} scrollable
                     * @return {?}
                     */function (/**
                     * @param {?} scrollable
                     * @return {?}
                     */ scrollable) {
                        return scrollable.getElementRef().nativeElement.getBoundingClientRect();
                    }));
                    return {
                        isOriginClipped: isElementClippedByScrolling(originBounds, scrollContainerBounds),
                        isOriginOutsideView: isElementScrolledOutsideView(originBounds, scrollContainerBounds),
                        isOverlayClipped: isElementClippedByScrolling(overlayBounds, scrollContainerBounds),
                        isOverlayOutsideView: isElementScrolledOutsideView(overlayBounds, scrollContainerBounds),
                    };
                };
                /**
                 * Subtracts the amount that an element is overflowing on an axis from its length.
                 * @private
                 * @param {?} length
                 * @param {...?} overflows
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._subtractOverflows = function (length) {
                    var overflows = [];
                    for (var _c = 1; _c < arguments.length; _c++) {
                        overflows[_c - 1] = arguments[_c];
                    }
                    return overflows.reduce(( /**
                     * @param {?} currentValue
                     * @param {?} currentOverflow
                     * @return {?}
                     */function (currentValue, currentOverflow) {
                        return currentValue - Math.max(currentOverflow, 0);
                    }), length);
                };
                /**
                 * Narrows the given viewport rect by the current _viewportMargin.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getNarrowedViewportRect = function () {
                    // We recalculate the viewport rect here ourselves, rather than using the ViewportRuler,
                    // because we want to use the `clientWidth` and `clientHeight` as the base. The difference
                    // being that the client properties don't include the scrollbar, as opposed to `innerWidth`
                    // and `innerHeight` that do. This is necessary, because the overlay container uses
                    // 100% `width` and `height` which don't include the scrollbar either.
                    /** @type {?} */
                    var width = ( /** @type {?} */(this._document.documentElement)).clientWidth;
                    /** @type {?} */
                    var height = ( /** @type {?} */(this._document.documentElement)).clientHeight;
                    /** @type {?} */
                    var scrollPosition = this._viewportRuler.getViewportScrollPosition();
                    return {
                        top: scrollPosition.top + this._viewportMargin,
                        left: scrollPosition.left + this._viewportMargin,
                        right: scrollPosition.left + width - this._viewportMargin,
                        bottom: scrollPosition.top + height - this._viewportMargin,
                        width: width - (2 * this._viewportMargin),
                        height: height - (2 * this._viewportMargin),
                    };
                };
                /**
                 * Whether the we're dealing with an RTL context
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._isRtl = function () {
                    return this._overlayRef.getDirection() === 'rtl';
                };
                /**
                 * Determines whether the overlay uses exact or flexible positioning.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._hasExactPosition = function () {
                    return !this._hasFlexibleDimensions || this._isPushed;
                };
                /**
                 * Retrieves the offset of a position along the x or y axis.
                 * @private
                 * @param {?} position
                 * @param {?} axis
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getOffset = function (position, axis) {
                    if (axis === 'x') {
                        // We don't do something like `position['offset' + axis]` in
                        // order to avoid breking minifiers that rename properties.
                        return position.offsetX == null ? this._offsetX : position.offsetX;
                    }
                    return position.offsetY == null ? this._offsetY : position.offsetY;
                };
                /**
                 * Validates that the current position match the expected values.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._validatePositions = function () {
                    if (!this._preferredPositions.length) {
                        throw Error('FlexibleConnectedPositionStrategy: At least one position is required.');
                    }
                    // TODO(crisbeto): remove these once Angular's template type
                    // checking is advanced enough to catch these cases.
                    this._preferredPositions.forEach(( /**
                     * @param {?} pair
                     * @return {?}
                     */function (/**
                     * @param {?} pair
                     * @return {?}
                     */ pair) {
                        validateHorizontalPosition('originX', pair.originX);
                        validateVerticalPosition('originY', pair.originY);
                        validateHorizontalPosition('overlayX', pair.overlayX);
                        validateVerticalPosition('overlayY', pair.overlayY);
                    }));
                };
                /**
                 * Adds a single CSS class or an array of classes on the overlay panel.
                 * @private
                 * @param {?} cssClasses
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._addPanelClasses = function (cssClasses) {
                    var _this = this;
                    if (this._pane) {
                        Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceArray"])(cssClasses).forEach(( /**
                         * @param {?} cssClass
                         * @return {?}
                         */function (/**
                         * @param {?} cssClass
                         * @return {?}
                         */ cssClass) {
                            if (cssClass !== '' && _this._appliedPanelClasses.indexOf(cssClass) === -1) {
                                _this._appliedPanelClasses.push(cssClass);
                                _this._pane.classList.add(cssClass);
                            }
                        }));
                    }
                };
                /**
                 * Clears the classes that the position strategy has applied from the overlay panel.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._clearPanelClasses = function () {
                    var _this = this;
                    if (this._pane) {
                        this._appliedPanelClasses.forEach(( /**
                         * @param {?} cssClass
                         * @return {?}
                         */function (/**
                         * @param {?} cssClass
                         * @return {?}
                         */ cssClass) {
                            _this._pane.classList.remove(cssClass);
                        }));
                        this._appliedPanelClasses = [];
                    }
                };
                /**
                 * Returns the ClientRect of the current origin.
                 * @private
                 * @return {?}
                 */
                FlexibleConnectedPositionStrategy.prototype._getOriginRect = function () {
                    /** @type {?} */
                    var origin = this._origin;
                    if (origin instanceof _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"]) {
                        return origin.nativeElement.getBoundingClientRect();
                    }
                    if (origin instanceof HTMLElement) {
                        return origin.getBoundingClientRect();
                    }
                    /** @type {?} */
                    var width = origin.width || 0;
                    /** @type {?} */
                    var height = origin.height || 0;
                    // If the origin is a point, return a client rect as if it was a 0x0 element at the point.
                    return {
                        top: origin.y,
                        bottom: origin.y + height,
                        left: origin.x,
                        right: origin.x + width,
                        height: height,
                        width: width
                    };
                };
                return FlexibleConnectedPositionStrategy;
            }());
            /**
             * Shallow-extends a stylesheet object with another stylesheet object.
             * @param {?} dest
             * @param {?} source
             * @return {?}
             */
            function extendStyles(dest, source) {
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        dest[key] = source[key];
                    }
                }
                return dest;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A strategy for positioning overlays. Using this strategy, an overlay is given an
             * implicit position relative to some origin element. The relative position is defined in terms of
             * a point on the origin element that is connected to a point on the overlay element. For example,
             * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
             * of the overlay.
             * @deprecated Use `FlexibleConnectedPositionStrategy` instead.
             * \@breaking-change 8.0.0
             */
            var ConnectedPositionStrategy = /** @class */ (function () {
                /**
                 * @param {?} originPos
                 * @param {?} overlayPos
                 * @param {?} connectedTo
                 * @param {?} viewportRuler
                 * @param {?} document
                 * @param {?} platform
                 * @param {?} overlayContainer
                 */
                function ConnectedPositionStrategy(originPos, overlayPos, connectedTo, viewportRuler, document, platform, overlayContainer) {
                    /**
                     * Ordered list of preferred positions, from most to least desirable.
                     */
                    this._preferredPositions = [];
                    // Since the `ConnectedPositionStrategy` is deprecated and we don't want to maintain
                    // the extra logic, we create an instance of the positioning strategy that has some
                    // defaults that make it behave as the old position strategy and to which we'll
                    // proxy all of the API calls.
                    this._positionStrategy = new FlexibleConnectedPositionStrategy(connectedTo, viewportRuler, document, platform, overlayContainer)
                        .withFlexibleDimensions(false)
                        .withPush(false)
                        .withViewportMargin(0);
                    this.withFallbackPosition(originPos, overlayPos);
                }
                Object.defineProperty(ConnectedPositionStrategy.prototype, "_isRtl", {
                    /**
                     * Whether the we're dealing with an RTL context
                     * @return {?}
                     */
                    get: function () {
                        return this._overlayRef.getDirection() === 'rtl';
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ConnectedPositionStrategy.prototype, "onPositionChange", {
                    /**
                     * Emits an event when the connection point changes.
                     * @return {?}
                     */
                    get: function () {
                        return this._positionStrategy.positionChanges;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ConnectedPositionStrategy.prototype, "positions", {
                    /**
                     * Ordered list of preferred positions, from most to least desirable.
                     * @return {?}
                     */
                    get: function () {
                        return this._preferredPositions;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Attach this position strategy to an overlay.
                 * @param {?} overlayRef
                 * @return {?}
                 */
                ConnectedPositionStrategy.prototype.attach = function (overlayRef) {
                    this._overlayRef = overlayRef;
                    this._positionStrategy.attach(overlayRef);
                    if (this._direction) {
                        overlayRef.setDirection(this._direction);
                        this._direction = null;
                    }
                };
                /**
                 * Disposes all resources used by the position strategy.
                 * @return {?}
                 */
                ConnectedPositionStrategy.prototype.dispose = function () {
                    this._positionStrategy.dispose();
                };
                /**
                 * \@docs-private
                 * @return {?}
                 */
                ConnectedPositionStrategy.prototype.detach = function () {
                    this._positionStrategy.detach();
                };
                /**
                 * Updates the position of the overlay element, using whichever preferred position relative
                 * to the origin fits on-screen.
                 * \@docs-private
                 * @return {?}
                 */
                ConnectedPositionStrategy.prototype.apply = function () {
                    this._positionStrategy.apply();
                };
                /**
                 * Re-positions the overlay element with the trigger in its last calculated position,
                 * even if a position higher in the "preferred positions" list would now fit. This
                 * allows one to re-align the panel without changing the orientation of the panel.
                 * @return {?}
                 */
                ConnectedPositionStrategy.prototype.recalculateLastPosition = function () {
                    this._positionStrategy.reapplyLastPosition();
                };
                /**
                 * Sets the list of Scrollable containers that host the origin element so that
                 * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
                 * Scrollable must be an ancestor element of the strategy's origin element.
                 * @param {?} scrollables
                 * @return {?}
                 */
                ConnectedPositionStrategy.prototype.withScrollableContainers = function (scrollables) {
                    this._positionStrategy.withScrollableContainers(scrollables);
                };
                /**
                 * Adds a new preferred fallback position.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} originPos
                 * @param {?} overlayPos
                 * @param {?=} offsetX
                 * @param {?=} offsetY
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.withFallbackPosition = function (originPos, overlayPos, offsetX, offsetY) {
                    /** @type {?} */
                    var position = new ConnectionPositionPair(originPos, overlayPos, offsetX, offsetY);
                    ( /** @type {?} */(this))._preferredPositions.push(position);
                    ( /** @type {?} */(this))._positionStrategy.withPositions(( /** @type {?} */(this))._preferredPositions);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the layout direction so the overlay's position can be adjusted to match.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} dir New layout direction.
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.withDirection = function (dir) {
                    // Since the direction might be declared before the strategy is attached,
                    // we save the value in a temporary property and we'll transfer it to the
                    // overlay ref on attachment.
                    if (( /** @type {?} */(this))._overlayRef) {
                        ( /** @type {?} */(this))._overlayRef.setDirection(dir);
                    }
                    else {
                        ( /** @type {?} */(this))._direction = dir;
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets an offset for the overlay's connection point on the x-axis
                 * @template THIS
                 * @this {THIS}
                 * @param {?} offset New offset in the X axis.
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.withOffsetX = function (offset) {
                    ( /** @type {?} */(this))._positionStrategy.withDefaultOffsetX(offset);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets an offset for the overlay's connection point on the y-axis
                 * @template THIS
                 * @this {THIS}
                 * @param {?} offset New offset in the Y axis.
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.withOffsetY = function (offset) {
                    ( /** @type {?} */(this))._positionStrategy.withDefaultOffsetY(offset);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets whether the overlay's position should be locked in after it is positioned
                 * initially. When an overlay is locked in, it won't attempt to reposition itself
                 * when the position is re-applied (e.g. when the user scrolls away).
                 * @template THIS
                 * @this {THIS}
                 * @param {?} isLocked Whether the overlay should locked in.
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.withLockedPosition = function (isLocked) {
                    ( /** @type {?} */(this))._positionStrategy.withLockedPosition(isLocked);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Overwrites the current set of positions with an array of new ones.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} positions Position pairs to be set on the strategy.
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.withPositions = function (positions) {
                    ( /** @type {?} */(this))._preferredPositions = positions.slice();
                    ( /** @type {?} */(this))._positionStrategy.withPositions(( /** @type {?} */(this))._preferredPositions);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the origin element, relative to which to position the overlay.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} origin Reference to the new origin element.
                 * @return {THIS}
                 */
                ConnectedPositionStrategy.prototype.setOrigin = function (origin) {
                    ( /** @type {?} */(this))._positionStrategy.setOrigin(origin);
                    return ( /** @type {?} */(this));
                };
                return ConnectedPositionStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Class to be added to the overlay pane wrapper.
             * @type {?}
             */
            var wrapperClass = 'cdk-global-overlay-wrapper';
            /**
             * A strategy for positioning overlays. Using this strategy, an overlay is given an
             * explicit position relative to the browser's viewport. We use flexbox, instead of
             * transforms, in order to avoid issues with subpixel rendering which can cause the
             * element to become blurry.
             */
            var GlobalPositionStrategy = /** @class */ (function () {
                function GlobalPositionStrategy() {
                    this._cssPosition = 'static';
                    this._topOffset = '';
                    this._bottomOffset = '';
                    this._leftOffset = '';
                    this._rightOffset = '';
                    this._alignItems = '';
                    this._justifyContent = '';
                    this._width = '';
                    this._height = '';
                }
                /**
                 * @param {?} overlayRef
                 * @return {?}
                 */
                GlobalPositionStrategy.prototype.attach = function (overlayRef) {
                    /** @type {?} */
                    var config = overlayRef.getConfig();
                    this._overlayRef = overlayRef;
                    if (this._width && !config.width) {
                        overlayRef.updateSize({ width: this._width });
                    }
                    if (this._height && !config.height) {
                        overlayRef.updateSize({ height: this._height });
                    }
                    overlayRef.hostElement.classList.add(wrapperClass);
                    this._isDisposed = false;
                };
                /**
                 * Sets the top position of the overlay. Clears any previously set vertical position.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} value New top offset.
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.top = function (value) {
                    if (value === void 0) { value = ''; }
                    ( /** @type {?} */(this))._bottomOffset = '';
                    ( /** @type {?} */(this))._topOffset = value;
                    ( /** @type {?} */(this))._alignItems = 'flex-start';
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the left position of the overlay. Clears any previously set horizontal position.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} value New left offset.
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.left = function (value) {
                    if (value === void 0) { value = ''; }
                    ( /** @type {?} */(this))._rightOffset = '';
                    ( /** @type {?} */(this))._leftOffset = value;
                    ( /** @type {?} */(this))._justifyContent = 'flex-start';
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the bottom position of the overlay. Clears any previously set vertical position.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} value New bottom offset.
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.bottom = function (value) {
                    if (value === void 0) { value = ''; }
                    ( /** @type {?} */(this))._topOffset = '';
                    ( /** @type {?} */(this))._bottomOffset = value;
                    ( /** @type {?} */(this))._alignItems = 'flex-end';
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the right position of the overlay. Clears any previously set horizontal position.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} value New right offset.
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.right = function (value) {
                    if (value === void 0) { value = ''; }
                    ( /** @type {?} */(this))._leftOffset = '';
                    ( /** @type {?} */(this))._rightOffset = value;
                    ( /** @type {?} */(this))._justifyContent = 'flex-end';
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the overlay width and clears any previously set width.
                 * @deprecated Pass the `width` through the `OverlayConfig`.
                 * \@breaking-change 8.0.0
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} value New width for the overlay
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.width = function (value) {
                    if (value === void 0) { value = ''; }
                    if (( /** @type {?} */(this))._overlayRef) {
                        ( /** @type {?} */(this))._overlayRef.updateSize({ width: value });
                    }
                    else {
                        ( /** @type {?} */(this))._width = value;
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Sets the overlay height and clears any previously set height.
                 * @deprecated Pass the `height` through the `OverlayConfig`.
                 * \@breaking-change 8.0.0
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} value New height for the overlay
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.height = function (value) {
                    if (value === void 0) { value = ''; }
                    if (( /** @type {?} */(this))._overlayRef) {
                        ( /** @type {?} */(this))._overlayRef.updateSize({ height: value });
                    }
                    else {
                        ( /** @type {?} */(this))._height = value;
                    }
                    return ( /** @type {?} */(this));
                };
                /**
                 * Centers the overlay horizontally with an optional offset.
                 * Clears any previously set horizontal position.
                 *
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} offset Overlay offset from the horizontal center.
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.centerHorizontally = function (offset) {
                    if (offset === void 0) { offset = ''; }
                    ( /** @type {?} */(this)).left(offset);
                    ( /** @type {?} */(this))._justifyContent = 'center';
                    return ( /** @type {?} */(this));
                };
                /**
                 * Centers the overlay vertically with an optional offset.
                 * Clears any previously set vertical position.
                 *
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} offset Overlay offset from the vertical center.
                 * @return {THIS}
                 */
                GlobalPositionStrategy.prototype.centerVertically = function (offset) {
                    if (offset === void 0) { offset = ''; }
                    ( /** @type {?} */(this)).top(offset);
                    ( /** @type {?} */(this))._alignItems = 'center';
                    return ( /** @type {?} */(this));
                };
                /**
                 * Apply the position to the element.
                 * \@docs-private
                 * @return {?}
                 */
                GlobalPositionStrategy.prototype.apply = function () {
                    // Since the overlay ref applies the strategy asynchronously, it could
                    // have been disposed before it ends up being applied. If that is the
                    // case, we shouldn't do anything.
                    if (!this._overlayRef || !this._overlayRef.hasAttached()) {
                        return;
                    }
                    /** @type {?} */
                    var styles = this._overlayRef.overlayElement.style;
                    /** @type {?} */
                    var parentStyles = this._overlayRef.hostElement.style;
                    /** @type {?} */
                    var config = this._overlayRef.getConfig();
                    styles.position = this._cssPosition;
                    styles.marginLeft = config.width === '100%' ? '0' : this._leftOffset;
                    styles.marginTop = config.height === '100%' ? '0' : this._topOffset;
                    styles.marginBottom = this._bottomOffset;
                    styles.marginRight = this._rightOffset;
                    if (config.width === '100%') {
                        parentStyles.justifyContent = 'flex-start';
                    }
                    else if (this._justifyContent === 'center') {
                        parentStyles.justifyContent = 'center';
                    }
                    else if (this._overlayRef.getConfig().direction === 'rtl') {
                        // In RTL the browser will invert `flex-start` and `flex-end` automatically, but we
                        // don't want that because our positioning is explicitly `left` and `right`, hence
                        // why we do another inversion to ensure that the overlay stays in the same position.
                        // TODO: reconsider this if we add `start` and `end` methods.
                        if (this._justifyContent === 'flex-start') {
                            parentStyles.justifyContent = 'flex-end';
                        }
                        else if (this._justifyContent === 'flex-end') {
                            parentStyles.justifyContent = 'flex-start';
                        }
                    }
                    else {
                        parentStyles.justifyContent = this._justifyContent;
                    }
                    parentStyles.alignItems = config.height === '100%' ? 'flex-start' : this._alignItems;
                };
                /**
                 * Cleans up the DOM changes from the position strategy.
                 * \@docs-private
                 * @return {?}
                 */
                GlobalPositionStrategy.prototype.dispose = function () {
                    if (this._isDisposed || !this._overlayRef) {
                        return;
                    }
                    /** @type {?} */
                    var styles = this._overlayRef.overlayElement.style;
                    /** @type {?} */
                    var parent = this._overlayRef.hostElement;
                    /** @type {?} */
                    var parentStyles = parent.style;
                    parent.classList.remove(wrapperClass);
                    parentStyles.justifyContent = parentStyles.alignItems = styles.marginTop =
                        styles.marginBottom = styles.marginLeft = styles.marginRight = styles.position = '';
                    this._overlayRef = ( /** @type {?} */(null));
                    this._isDisposed = true;
                };
                return GlobalPositionStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Builder for overlay position strategy.
             */
            var OverlayPositionBuilder = /** @class */ (function () {
                /**
                 * @param {?} _viewportRuler
                 * @param {?} _document
                 * @param {?} _platform
                 * @param {?} _overlayContainer
                 */
                function OverlayPositionBuilder(_viewportRuler, _document, _platform, _overlayContainer) {
                    this._viewportRuler = _viewportRuler;
                    this._document = _document;
                    this._platform = _platform;
                    this._overlayContainer = _overlayContainer;
                }
                /**
                 * Creates a global position strategy.
                 * @return {?}
                 */
                OverlayPositionBuilder.prototype.global = function () {
                    return new GlobalPositionStrategy();
                };
                /**
                 * Creates a relative position strategy.
                 * @deprecated Use `flexibleConnectedTo` instead.
                 * \@breaking-change 8.0.0
                 * @param {?} elementRef
                 * @param {?} originPos
                 * @param {?} overlayPos
                 * @return {?}
                 */
                OverlayPositionBuilder.prototype.connectedTo = function (elementRef, originPos, overlayPos) {
                    return new ConnectedPositionStrategy(originPos, overlayPos, elementRef, this._viewportRuler, this._document, this._platform, this._overlayContainer);
                };
                /**
                 * Creates a flexible position strategy.
                 * @param {?} origin Origin relative to which to position the overlay.
                 * @return {?}
                 */
                OverlayPositionBuilder.prototype.flexibleConnectedTo = function (origin) {
                    return new FlexibleConnectedPositionStrategy(origin, this._viewportRuler, this._document, this._platform, this._overlayContainer);
                };
                return OverlayPositionBuilder;
            }());
            OverlayPositionBuilder.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            OverlayPositionBuilder.ctorParameters = function () { return [
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ViewportRuler"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["Platform"] },
                { type: OverlayContainer }
            ]; };
            /** @nocollapse */ OverlayPositionBuilder.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵdefineInjectable"])({ factory: function OverlayPositionBuilder_Factory() { return new OverlayPositionBuilder(Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ViewportRuler"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["Platform"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(OverlayContainer)); }, token: OverlayPositionBuilder, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Next overlay unique ID.
             * @type {?}
             */
            var nextUniqueId = 0;
            // Note that Overlay is *not* scoped to the app root because the ComponentFactoryResolver
            // it needs is different based on where OverlayModule is imported.
            /**
             * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
             * used as a low-level building block for other components. Dialogs, tooltips, menus,
             * selects, etc. can all be built using overlays. The service should primarily be used by authors
             * of re-usable components rather than developers building end-user applications.
             *
             * An overlay *is* a PortalOutlet, so any kind of Portal can be loaded into one.
             */
            var Overlay = /** @class */ (function () {
                /**
                 * @param {?} scrollStrategies
                 * @param {?} _overlayContainer
                 * @param {?} _componentFactoryResolver
                 * @param {?} _positionBuilder
                 * @param {?} _keyboardDispatcher
                 * @param {?} _injector
                 * @param {?} _ngZone
                 * @param {?} _document
                 * @param {?} _directionality
                 * @param {?=} _location
                 */
                function Overlay(scrollStrategies, _overlayContainer, _componentFactoryResolver, _positionBuilder, _keyboardDispatcher, _injector, _ngZone, _document, _directionality, _location) {
                    this.scrollStrategies = scrollStrategies;
                    this._overlayContainer = _overlayContainer;
                    this._componentFactoryResolver = _componentFactoryResolver;
                    this._positionBuilder = _positionBuilder;
                    this._keyboardDispatcher = _keyboardDispatcher;
                    this._injector = _injector;
                    this._ngZone = _ngZone;
                    this._document = _document;
                    this._directionality = _directionality;
                    this._location = _location;
                }
                /**
                 * Creates an overlay.
                 * @param {?=} config Configuration applied to the overlay.
                 * @return {?} Reference to the created overlay.
                 */
                Overlay.prototype.create = function (config) {
                    /** @type {?} */
                    var host = this._createHostElement();
                    /** @type {?} */
                    var pane = this._createPaneElement(host);
                    /** @type {?} */
                    var portalOutlet = this._createPortalOutlet(pane);
                    /** @type {?} */
                    var overlayConfig = new OverlayConfig(config);
                    overlayConfig.direction = overlayConfig.direction || this._directionality.value;
                    return new OverlayRef(portalOutlet, host, pane, overlayConfig, this._ngZone, this._keyboardDispatcher, this._document, this._location);
                };
                /**
                 * Gets a position builder that can be used, via fluent API,
                 * to construct and configure a position strategy.
                 * @return {?} An overlay position builder.
                 */
                Overlay.prototype.position = function () {
                    return this._positionBuilder;
                };
                /**
                 * Creates the DOM element for an overlay and appends it to the overlay container.
                 * @private
                 * @param {?} host
                 * @return {?} Newly-created pane element
                 */
                Overlay.prototype._createPaneElement = function (host) {
                    /** @type {?} */
                    var pane = this._document.createElement('div');
                    pane.id = "cdk-overlay-" + nextUniqueId++;
                    pane.classList.add('cdk-overlay-pane');
                    host.appendChild(pane);
                    return pane;
                };
                /**
                 * Creates the host element that wraps around an overlay
                 * and can be used for advanced positioning.
                 * @private
                 * @return {?} Newly-create host element.
                 */
                Overlay.prototype._createHostElement = function () {
                    /** @type {?} */
                    var host = this._document.createElement('div');
                    this._overlayContainer.getContainerElement().appendChild(host);
                    return host;
                };
                /**
                 * Create a DomPortalOutlet into which the overlay content can be loaded.
                 * @private
                 * @param {?} pane The DOM element to turn into a portal outlet.
                 * @return {?} A portal outlet for the given DOM element.
                 */
                Overlay.prototype._createPortalOutlet = function (pane) {
                    // We have to resolve the ApplicationRef later in order to allow people
                    // to use overlay-based providers during app initialization.
                    if (!this._appRef) {
                        this._appRef = this._injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ApplicationRef"]);
                    }
                    return new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__["DomPortalOutlet"](pane, this._componentFactoryResolver, this._appRef, this._injector);
                };
                return Overlay;
            }());
            Overlay.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"] },
            ];
            /** @nocollapse */
            Overlay.ctorParameters = function () { return [
                { type: ScrollStrategyOptions },
                { type: OverlayContainer },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ComponentFactoryResolver"] },
                { type: OverlayPositionBuilder },
                { type: OverlayKeyboardDispatcher },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injector"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__["Directionality"] },
                { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Default set of positions for the overlay. Follows the behavior of a dropdown.
             * @type {?}
             */
            var defaultPositionList = [
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top'
                },
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'bottom'
                },
                {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom'
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top'
                }
            ];
            /**
             * Injection token that determines the scroll handling while the connected overlay is open.
             * @type {?}
             */
            var CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('cdk-connected-overlay-scroll-strategy');
            /**
             * Directive applied to an element to make it usable as an origin for an Overlay using a
             * ConnectedPositionStrategy.
             */
            var CdkOverlayOrigin = /** @class */ (function () {
                /**
                 * @param {?} elementRef
                 */
                function CdkOverlayOrigin(elementRef) {
                    this.elementRef = elementRef;
                }
                return CdkOverlayOrigin;
            }());
            CdkOverlayOrigin.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: '[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]',
                            exportAs: 'cdkOverlayOrigin',
                        },] },
            ];
            /** @nocollapse */
            CdkOverlayOrigin.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] }
            ]; };
            /**
             * Directive to facilitate declarative creation of an
             * Overlay using a FlexibleConnectedPositionStrategy.
             */
            var CdkConnectedOverlay = /** @class */ (function () {
                // TODO(jelbourn): inputs for size, scroll behavior, animation, etc.
                /**
                 * @param {?} _overlay
                 * @param {?} templateRef
                 * @param {?} viewContainerRef
                 * @param {?} scrollStrategyFactory
                 * @param {?} _dir
                 */
                function CdkConnectedOverlay(_overlay, templateRef, viewContainerRef, scrollStrategyFactory, _dir) {
                    this._overlay = _overlay;
                    this._dir = _dir;
                    this._hasBackdrop = false;
                    this._lockPosition = false;
                    this._growAfterOpen = false;
                    this._flexibleDimensions = false;
                    this._push = false;
                    this._backdropSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Margin between the overlay and the viewport edges.
                     */
                    this.viewportMargin = 0;
                    /**
                     * Whether the overlay is open.
                     */
                    this.open = false;
                    /**
                     * Event emitted when the backdrop is clicked.
                     */
                    this.backdropClick = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the position has changed.
                     */
                    this.positionChange = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the overlay has been attached.
                     */
                    this.attach = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the overlay has been detached.
                     */
                    this.detach = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Emits when there are keyboard events that are targeted at the overlay.
                     */
                    this.overlayKeydown = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    this._templatePortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__["TemplatePortal"](templateRef, viewContainerRef);
                    this._scrollStrategyFactory = scrollStrategyFactory;
                    this.scrollStrategy = this._scrollStrategyFactory();
                }
                Object.defineProperty(CdkConnectedOverlay.prototype, "offsetX", {
                    /**
                     * The offset in pixels for the overlay connection point on the x-axis
                     * @return {?}
                     */
                    get: function () { return this._offsetX; },
                    /**
                     * @param {?} offsetX
                     * @return {?}
                     */
                    set: function (offsetX) {
                        this._offsetX = offsetX;
                        if (this._position) {
                            this._updatePositionStrategy(this._position);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "offsetY", {
                    /**
                     * The offset in pixels for the overlay connection point on the y-axis
                     * @return {?}
                     */
                    get: function () { return this._offsetY; },
                    /**
                     * @param {?} offsetY
                     * @return {?}
                     */
                    set: function (offsetY) {
                        this._offsetY = offsetY;
                        if (this._position) {
                            this._updatePositionStrategy(this._position);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "hasBackdrop", {
                    /**
                     * Whether or not the overlay should attach a backdrop.
                     * @return {?}
                     */
                    get: function () { return this._hasBackdrop; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._hasBackdrop = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "lockPosition", {
                    /**
                     * Whether or not the overlay should be locked when scrolling.
                     * @return {?}
                     */
                    get: function () { return this._lockPosition; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._lockPosition = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "flexibleDimensions", {
                    /**
                     * Whether the overlay's width and height can be constrained to fit within the viewport.
                     * @return {?}
                     */
                    get: function () { return this._flexibleDimensions; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._flexibleDimensions = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "growAfterOpen", {
                    /**
                     * Whether the overlay can grow after the initial open when flexible positioning is turned on.
                     * @return {?}
                     */
                    get: function () { return this._growAfterOpen; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._growAfterOpen = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "push", {
                    /**
                     * Whether the overlay can be pushed on-screen if none of the provided positions fit.
                     * @return {?}
                     */
                    get: function () { return this._push; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._push = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "overlayRef", {
                    /**
                     * The associated overlay reference.
                     * @return {?}
                     */
                    get: function () {
                        return this._overlayRef;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkConnectedOverlay.prototype, "dir", {
                    /**
                     * The element's layout direction.
                     * @return {?}
                     */
                    get: function () {
                        return this._dir ? this._dir.value : 'ltr';
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype.ngOnDestroy = function () {
                    if (this._overlayRef) {
                        this._overlayRef.dispose();
                    }
                    this._backdropSubscription.unsubscribe();
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype.ngOnChanges = function (changes) {
                    if (this._position) {
                        this._updatePositionStrategy(this._position);
                        this._overlayRef.updateSize({
                            width: this.width,
                            minWidth: this.minWidth,
                            height: this.height,
                            minHeight: this.minHeight,
                        });
                        if (changes['origin'] && this.open) {
                            this._position.apply();
                        }
                    }
                    if (changes['open']) {
                        this.open ? this._attachOverlay() : this._detachOverlay();
                    }
                };
                /**
                 * Creates an overlay
                 * @private
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype._createOverlay = function () {
                    var _this = this;
                    if (!this.positions || !this.positions.length) {
                        this.positions = defaultPositionList;
                    }
                    this._overlayRef = this._overlay.create(this._buildConfig());
                    this._overlayRef.keydownEvents().subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        _this.overlayKeydown.next(event);
                        if (event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_9__["ESCAPE"] && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_9__["hasModifierKey"])(event)) {
                            event.preventDefault();
                            _this._detachOverlay();
                        }
                    }));
                };
                /**
                 * Builds the overlay config based on the directive's inputs
                 * @private
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype._buildConfig = function () {
                    /** @type {?} */
                    var positionStrategy = this._position = this._createPositionStrategy();
                    /** @type {?} */
                    var overlayConfig = new OverlayConfig({
                        direction: this._dir,
                        positionStrategy: positionStrategy,
                        scrollStrategy: this.scrollStrategy,
                        hasBackdrop: this.hasBackdrop
                    });
                    if (this.width || this.width === 0) {
                        overlayConfig.width = this.width;
                    }
                    if (this.height || this.height === 0) {
                        overlayConfig.height = this.height;
                    }
                    if (this.minWidth || this.minWidth === 0) {
                        overlayConfig.minWidth = this.minWidth;
                    }
                    if (this.minHeight || this.minHeight === 0) {
                        overlayConfig.minHeight = this.minHeight;
                    }
                    if (this.backdropClass) {
                        overlayConfig.backdropClass = this.backdropClass;
                    }
                    if (this.panelClass) {
                        overlayConfig.panelClass = this.panelClass;
                    }
                    return overlayConfig;
                };
                /**
                 * Updates the state of a position strategy, based on the values of the directive inputs.
                 * @private
                 * @param {?} positionStrategy
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype._updatePositionStrategy = function (positionStrategy) {
                    var _this = this;
                    /** @type {?} */
                    var positions = this.positions.map(( /**
                     * @param {?} currentPosition
                     * @return {?}
                     */function (/**
                     * @param {?} currentPosition
                     * @return {?}
                     */ currentPosition) { return ({
                        originX: currentPosition.originX,
                        originY: currentPosition.originY,
                        overlayX: currentPosition.overlayX,
                        overlayY: currentPosition.overlayY,
                        offsetX: currentPosition.offsetX || _this.offsetX,
                        offsetY: currentPosition.offsetY || _this.offsetY,
                        panelClass: currentPosition.panelClass || undefined,
                    }); }));
                    return positionStrategy
                        .setOrigin(this.origin.elementRef)
                        .withPositions(positions)
                        .withFlexibleDimensions(this.flexibleDimensions)
                        .withPush(this.push)
                        .withGrowAfterOpen(this.growAfterOpen)
                        .withViewportMargin(this.viewportMargin)
                        .withLockedPosition(this.lockPosition);
                };
                /**
                 * Returns the position strategy of the overlay to be set on the overlay config
                 * @private
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype._createPositionStrategy = function () {
                    var _this = this;
                    /** @type {?} */
                    var strategy = this._overlay.position().flexibleConnectedTo(this.origin.elementRef);
                    this._updatePositionStrategy(strategy);
                    strategy.positionChanges.subscribe(( /**
                     * @param {?} p
                     * @return {?}
                     */function (/**
                     * @param {?} p
                     * @return {?}
                     */ p) { return _this.positionChange.emit(p); }));
                    return strategy;
                };
                /**
                 * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
                 * @private
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype._attachOverlay = function () {
                    var _this = this;
                    if (!this._overlayRef) {
                        this._createOverlay();
                    }
                    else {
                        // Update the overlay size, in case the directive's inputs have changed
                        this._overlayRef.getConfig().hasBackdrop = this.hasBackdrop;
                    }
                    if (!this._overlayRef.hasAttached()) {
                        this._overlayRef.attach(this._templatePortal);
                        this.attach.emit();
                    }
                    if (this.hasBackdrop) {
                        this._backdropSubscription = this._overlayRef.backdropClick().subscribe(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) {
                            _this.backdropClick.emit(event);
                        }));
                    }
                    else {
                        this._backdropSubscription.unsubscribe();
                    }
                };
                /**
                 * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
                 * @private
                 * @return {?}
                 */
                CdkConnectedOverlay.prototype._detachOverlay = function () {
                    if (this._overlayRef) {
                        this._overlayRef.detach();
                        this.detach.emit();
                    }
                    this._backdropSubscription.unsubscribe();
                };
                return CdkConnectedOverlay;
            }());
            CdkConnectedOverlay.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: '[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]',
                            exportAs: 'cdkConnectedOverlay'
                        },] },
            ];
            /** @nocollapse */
            CdkConnectedOverlay.ctorParameters = function () { return [
                { type: Overlay },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY,] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] }
            ]; };
            CdkConnectedOverlay.propDecorators = {
                origin: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayOrigin',] }],
                positions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayPositions',] }],
                offsetX: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayOffsetX',] }],
                offsetY: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayOffsetY',] }],
                width: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayWidth',] }],
                height: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayHeight',] }],
                minWidth: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayMinWidth',] }],
                minHeight: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayMinHeight',] }],
                backdropClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayBackdropClass',] }],
                panelClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayPanelClass',] }],
                viewportMargin: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayViewportMargin',] }],
                scrollStrategy: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayScrollStrategy',] }],
                open: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayOpen',] }],
                hasBackdrop: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayHasBackdrop',] }],
                lockPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayLockPosition',] }],
                flexibleDimensions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayFlexibleDimensions',] }],
                growAfterOpen: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayGrowAfterOpen',] }],
                push: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkConnectedOverlayPush',] }],
                backdropClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                positionChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                attach: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                detach: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                overlayKeydown: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }]
            };
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.reposition(); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER = {
                provide: CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY,
                deps: [Overlay],
                useFactory: CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY,
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var OverlayModule = /** @class */ (function () {
                function OverlayModule() {
                }
                return OverlayModule;
            }());
            OverlayModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            imports: [_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_7__["BidiModule"], _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__["PortalModule"], _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ScrollingModule"]],
                            exports: [CdkConnectedOverlay, CdkOverlayOrigin, _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["ScrollingModule"]],
                            declarations: [CdkConnectedOverlay, CdkOverlayOrigin],
                            providers: [
                                Overlay,
                                CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER,
                            ],
                        },] },
            ];
            /**
             * @deprecated Use `OverlayModule` instead.
             * \@breaking-change 8.0.0
             * \@docs-private
             * @type {?}
             */
            var OVERLAY_PROVIDERS = [
                Overlay,
                OverlayPositionBuilder,
                OVERLAY_KEYBOARD_DISPATCHER_PROVIDER,
                _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_1__["VIEWPORT_RULER_PROVIDER"],
                OVERLAY_CONTAINER_PROVIDER,
                CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER,
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Alternative to OverlayContainer that supports correct displaying of overlay elements in
             * Fullscreen mode
             * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
             *
             * Should be provided in the root component.
             */
            var FullscreenOverlayContainer = /** @class */ (function (_super_1) {
                __extends(FullscreenOverlayContainer, _super_1);
                /**
                 * @param {?} _document
                 */
                function FullscreenOverlayContainer(_document) {
                    return _super_1.call(this, _document) || this;
                }
                /**
                 * @return {?}
                 */
                FullscreenOverlayContainer.prototype.ngOnDestroy = function () {
                    _super_1.prototype.ngOnDestroy.call(this);
                    if (this._fullScreenEventName && this._fullScreenListener) {
                        this._document.removeEventListener(this._fullScreenEventName, this._fullScreenListener);
                    }
                };
                /**
                 * @protected
                 * @return {?}
                 */
                FullscreenOverlayContainer.prototype._createContainer = function () {
                    var _this = this;
                    _super_1.prototype._createContainer.call(this);
                    this._adjustParentForFullscreenChange();
                    this._addFullscreenChangeListener(( /**
                     * @return {?}
                     */function () { return _this._adjustParentForFullscreenChange(); }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                FullscreenOverlayContainer.prototype._adjustParentForFullscreenChange = function () {
                    if (!this._containerElement) {
                        return;
                    }
                    /** @type {?} */
                    var fullscreenElement = this.getFullscreenElement();
                    /** @type {?} */
                    var parent = fullscreenElement || this._document.body;
                    parent.appendChild(this._containerElement);
                };
                /**
                 * @private
                 * @param {?} fn
                 * @return {?}
                 */
                FullscreenOverlayContainer.prototype._addFullscreenChangeListener = function (fn) {
                    /** @type {?} */
                    var eventName = this._getEventName();
                    if (eventName) {
                        if (this._fullScreenListener) {
                            this._document.removeEventListener(eventName, this._fullScreenListener);
                        }
                        this._document.addEventListener(eventName, fn);
                        this._fullScreenListener = fn;
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                FullscreenOverlayContainer.prototype._getEventName = function () {
                    if (!this._fullScreenEventName) {
                        /** @type {?} */
                        var _document = ( /** @type {?} */(this._document));
                        if (_document.fullscreenEnabled) {
                            this._fullScreenEventName = 'fullscreenchange';
                        }
                        else if (_document.webkitFullscreenEnabled) {
                            this._fullScreenEventName = 'webkitfullscreenchange';
                        }
                        else if (_document.mozFullScreenEnabled) {
                            this._fullScreenEventName = 'mozfullscreenchange';
                        }
                        else if (_document.msFullscreenEnabled) {
                            this._fullScreenEventName = 'MSFullscreenChange';
                        }
                    }
                    return this._fullScreenEventName;
                };
                /**
                 * When the page is put into fullscreen mode, a specific element is specified.
                 * Only that element and its children are visible when in fullscreen mode.
                 * @return {?}
                 */
                FullscreenOverlayContainer.prototype.getFullscreenElement = function () {
                    /** @type {?} */
                    var _document = ( /** @type {?} */(this._document));
                    return _document.fullscreenElement ||
                        _document.webkitFullscreenElement ||
                        _document.mozFullScreenElement ||
                        _document.msFullscreenElement ||
                        null;
                };
                return FullscreenOverlayContainer;
            }(OverlayContainer));
            FullscreenOverlayContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            FullscreenOverlayContainer.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ FullscreenOverlayContainer.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵdefineInjectable"])({ factory: function FullscreenOverlayContainer_Factory() { return new FullscreenOverlayContainer(Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"])); }, token: FullscreenOverlayContainer, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=overlay.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/platform.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/platform.js ***!
          \*******************************************************/
        /*! exports provided: Platform, PlatformModule, getSupportedInputTypes, supportsPassiveEventListeners, normalizePassiveListenerOptions, supportsScrollBehavior, getRtlScrollAxisType, RtlScrollAxisType, _supportsShadowDom */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Platform", function () { return Platform; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformModule", function () { return PlatformModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSupportedInputTypes", function () { return getSupportedInputTypes; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "supportsPassiveEventListeners", function () { return supportsPassiveEventListeners; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizePassiveListenerOptions", function () { return normalizePassiveListenerOptions; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "supportsScrollBehavior", function () { return supportsScrollBehavior; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRtlScrollAxisType", function () { return getRtlScrollAxisType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RtlScrollAxisType", function () { return RtlScrollAxisType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_supportsShadowDom", function () { return _supportsShadowDom; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Whether the current platform supports the V8 Break Iterator. The V8 check
            // is necessary to detect all Blink based browsers.
            /** @type {?} */
            var hasV8BreakIterator;
            // We need a try/catch around the reference to `Intl`, because accessing it in some cases can
            // cause IE to throw. These cases are tied to particular versions of Windows and can happen if
            // the consumer is providing a polyfilled `Map`. See:
            // https://github.com/Microsoft/ChakraCore/issues/3189
            // https://github.com/angular/components/issues/15687
            try {
                hasV8BreakIterator = (typeof Intl !== 'undefined' && (( /** @type {?} */(Intl))).v8BreakIterator);
            }
            catch (_a) {
                hasV8BreakIterator = false;
            }
            /**
             * Service to detect the current platform by comparing the userAgent strings and
             * checking browser-specific global properties.
             */
            var Platform = /** @class */ (function () {
                /**
                 * \@breaking-change 8.0.0 remove optional decorator
                 * @param {?=} _platformId
                 */
                function Platform(_platformId) {
                    this._platformId = _platformId;
                    /**
                     * Whether the Angular application is being rendered in the browser.
                     * We want to use the Angular platform check because if the Document is shimmed
                     * without the navigator, the following checks will fail. This is preferred because
                     * sometimes the Document may be shimmed without the user's knowledge or intention
                     */
                    this.isBrowser = this._platformId ?
                        Object(_angular_common__WEBPACK_IMPORTED_MODULE_1__["isPlatformBrowser"])(this._platformId) : typeof document === 'object' && !!document;
                    /**
                     * Whether the current browser is Microsoft Edge.
                     */
                    this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
                    /**
                     * Whether the current rendering engine is Microsoft Trident.
                     */
                    this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
                    /**
                     * Whether the current rendering engine is Blink.
                     */
                    // EdgeHTML and Trident mock Blink specific things and need to be excluded from this check.
                    this.BLINK = this.isBrowser && (!!((( /** @type {?} */(window))).chrome || hasV8BreakIterator) &&
                        typeof CSS !== 'undefined' && !this.EDGE && !this.TRIDENT);
                    /**
                     * Whether the current rendering engine is WebKit.
                     */
                    // Webkit is part of the userAgent in EdgeHTML, Blink and Trident. Therefore we need to
                    // ensure that Webkit runs standalone and is not used as another engine's base.
                    this.WEBKIT = this.isBrowser &&
                        /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
                    /**
                     * Whether the current platform is Apple iOS.
                     */
                    this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                        !('MSStream' in window);
                    /**
                     * Whether the current browser is Firefox.
                     */
                    // It's difficult to detect the plain Gecko engine, because most of the browsers identify
                    // them self as Gecko-like browsers and modify the userAgent's according to that.
                    // Since we only cover one explicit Firefox case, we can simply check for Firefox
                    // instead of having an unstable check for Gecko.
                    this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
                    /**
                     * Whether the current platform is Android.
                     */
                    // Trident on mobile adds the android platform to the userAgent to trick detections.
                    this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
                    /**
                     * Whether the current browser is Safari.
                     */
                    // Safari browsers will include the Safari keyword in their userAgent. Some browsers may fake
                    // this and just place the Safari keyword in the userAgent. To be more safe about Safari every
                    // Safari browser should also use Webkit as its layout engine.
                    this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
                }
                return Platform;
            }());
            Platform.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            Platform.ctorParameters = function () { return [
                { type: Object, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["PLATFORM_ID"],] }] }
            ]; };
            /** @nocollapse */ Platform.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function Platform_Factory() { return new Platform(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["PLATFORM_ID"], 8)); }, token: Platform, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var PlatformModule = /** @class */ (function () {
                function PlatformModule() {
                }
                return PlatformModule;
            }());
            PlatformModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{},] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Cached result Set of input types support by the current browser.
             * @type {?}
             */
            var supportedInputTypes;
            /**
             * Types of `<input>` that *might* be supported.
             * @type {?}
             */
            var candidateInputTypes = [
                // `color` must come first. Chrome 56 shows a warning if we change the type to `color` after
                // first changing it to something else:
                // The specified value "" does not conform to the required format.
                // The format is "#rrggbb" where rr, gg, bb are two-digit hexadecimal numbers.
                'color',
                'button',
                'checkbox',
                'date',
                'datetime-local',
                'email',
                'file',
                'hidden',
                'image',
                'month',
                'number',
                'password',
                'radio',
                'range',
                'reset',
                'search',
                'submit',
                'tel',
                'text',
                'time',
                'url',
                'week',
            ];
            /**
             * @return {?} The input types supported by this browser.
             */
            function getSupportedInputTypes() {
                // Result is cached.
                if (supportedInputTypes) {
                    return supportedInputTypes;
                }
                // We can't check if an input type is not supported until we're on the browser, so say that
                // everything is supported when not on the browser. We don't use `Platform` here since it's
                // just a helper function and can't inject it.
                if (typeof document !== 'object' || !document) {
                    supportedInputTypes = new Set(candidateInputTypes);
                    return supportedInputTypes;
                }
                /** @type {?} */
                var featureTestInput = document.createElement('input');
                supportedInputTypes = new Set(candidateInputTypes.filter(( /**
                 * @param {?} value
                 * @return {?}
                 */function (/**
                 * @param {?} value
                 * @return {?}
                 */ value) {
                    featureTestInput.setAttribute('type', value);
                    return featureTestInput.type === value;
                })));
                return supportedInputTypes;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Cached result of whether the user's browser supports passive event listeners.
             * @type {?}
             */
            var supportsPassiveEvents;
            /**
             * Checks whether the user's browser supports passive event listeners.
             * See: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
             * @return {?}
             */
            function supportsPassiveEventListeners() {
                if (supportsPassiveEvents == null && typeof window !== 'undefined') {
                    try {
                        window.addEventListener('test', ( /** @type {?} */(null)), Object.defineProperty({}, 'passive', {
                            get: ( /**
                             * @return {?}
                             */function () { return supportsPassiveEvents = true; })
                        }));
                    }
                    finally {
                        supportsPassiveEvents = supportsPassiveEvents || false;
                    }
                }
                return supportsPassiveEvents;
            }
            /**
             * Normalizes an `AddEventListener` object to something that can be passed
             * to `addEventListener` on any browser, no matter whether it supports the
             * `options` parameter.
             * @param {?} options Object to be normalized.
             * @return {?}
             */
            function normalizePassiveListenerOptions(options) {
                return supportsPassiveEventListeners() ? options : !!options.capture;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @enum {number} */
            var RtlScrollAxisType = {
                /**
                 * scrollLeft is 0 when scrolled all the way left and (scrollWidth - clientWidth) when scrolled
                 * all the way right.
                 */
                NORMAL: 0,
                /**
                 * scrollLeft is -(scrollWidth - clientWidth) when scrolled all the way left and 0 when scrolled
                 * all the way right.
                 */
                NEGATED: 1,
                /**
                 * scrollLeft is (scrollWidth - clientWidth) when scrolled all the way left and 0 when scrolled
                 * all the way right.
                 */
                INVERTED: 2,
            };
            RtlScrollAxisType[RtlScrollAxisType.NORMAL] = 'NORMAL';
            RtlScrollAxisType[RtlScrollAxisType.NEGATED] = 'NEGATED';
            RtlScrollAxisType[RtlScrollAxisType.INVERTED] = 'INVERTED';
            /**
             * Cached result of the way the browser handles the horizontal scroll axis in RTL mode.
             * @type {?}
             */
            var rtlScrollAxisType;
            /**
             * Check whether the browser supports scroll behaviors.
             * @return {?}
             */
            function supportsScrollBehavior() {
                return !!(typeof document == 'object' && 'scrollBehavior' in ( /** @type {?} */(document.documentElement)).style);
            }
            /**
             * Checks the type of RTL scroll axis used by this browser. As of time of writing, Chrome is NORMAL,
             * Firefox & Safari are NEGATED, and IE & Edge are INVERTED.
             * @return {?}
             */
            function getRtlScrollAxisType() {
                // We can't check unless we're on the browser. Just assume 'normal' if we're not.
                if (typeof document !== 'object' || !document) {
                    return RtlScrollAxisType.NORMAL;
                }
                if (!rtlScrollAxisType) {
                    // Create a 1px wide scrolling container and a 2px wide content element.
                    /** @type {?} */
                    var scrollContainer = document.createElement('div');
                    /** @type {?} */
                    var containerStyle = scrollContainer.style;
                    scrollContainer.dir = 'rtl';
                    containerStyle.height = '1px';
                    containerStyle.width = '1px';
                    containerStyle.overflow = 'auto';
                    containerStyle.visibility = 'hidden';
                    containerStyle.pointerEvents = 'none';
                    containerStyle.position = 'absolute';
                    /** @type {?} */
                    var content = document.createElement('div');
                    /** @type {?} */
                    var contentStyle = content.style;
                    contentStyle.width = '2px';
                    contentStyle.height = '1px';
                    scrollContainer.appendChild(content);
                    document.body.appendChild(scrollContainer);
                    rtlScrollAxisType = RtlScrollAxisType.NORMAL;
                    // The viewport starts scrolled all the way to the right in RTL mode. If we are in a NORMAL
                    // browser this would mean that the scrollLeft should be 1. If it's zero instead we know we're
                    // dealing with one of the other two types of browsers.
                    if (scrollContainer.scrollLeft === 0) {
                        // In a NEGATED browser the scrollLeft is always somewhere in [-maxScrollAmount, 0]. For an
                        // INVERTED browser it is always somewhere in [0, maxScrollAmount]. We can determine which by
                        // setting to the scrollLeft to 1. This is past the max for a NEGATED browser, so it will
                        // return 0 when we read it again.
                        scrollContainer.scrollLeft = 1;
                        rtlScrollAxisType =
                            scrollContainer.scrollLeft === 0 ? RtlScrollAxisType.NEGATED : RtlScrollAxisType.INVERTED;
                    }
                    ( /** @type {?} */(scrollContainer.parentNode)).removeChild(scrollContainer);
                }
                return rtlScrollAxisType;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var shadowDomIsSupported;
            /**
             * Checks whether the user's browser support Shadow DOM.
             * @return {?}
             */
            function _supportsShadowDom() {
                if (shadowDomIsSupported == null) {
                    /** @type {?} */
                    var head = typeof document !== 'undefined' ? document.head : null;
                    shadowDomIsSupported = !!(head && ((( /** @type {?} */(head))).createShadowRoot || head.attachShadow));
                }
                return shadowDomIsSupported;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=platform.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/portal.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/portal.js ***!
          \*****************************************************/
        /*! exports provided: Portal, ComponentPortal, TemplatePortal, BasePortalOutlet, BasePortalHost, DomPortalOutlet, DomPortalHost, CdkPortal, TemplatePortalDirective, CdkPortalOutlet, PortalHostDirective, PortalModule, PortalInjector */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Portal", function () { return Portal; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentPortal", function () { return ComponentPortal; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplatePortal", function () { return TemplatePortal; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasePortalOutlet", function () { return BasePortalOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasePortalHost", function () { return BasePortalHost; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomPortalOutlet", function () { return DomPortalOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomPortalHost", function () { return DomPortalHost; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkPortal", function () { return CdkPortal; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplatePortalDirective", function () { return TemplatePortalDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkPortalOutlet", function () { return CdkPortalOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalHostDirective", function () { return PortalHostDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalModule", function () { return PortalModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalInjector", function () { return PortalInjector; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Throws an exception when attempting to attach a null portal to a host.
             * \@docs-private
             * @return {?}
             */
            function throwNullPortalError() {
                throw Error('Must provide a portal to attach');
            }
            /**
             * Throws an exception when attempting to attach a portal to a host that is already attached.
             * \@docs-private
             * @return {?}
             */
            function throwPortalAlreadyAttachedError() {
                throw Error('Host already has a portal attached');
            }
            /**
             * Throws an exception when attempting to attach a portal to an already-disposed host.
             * \@docs-private
             * @return {?}
             */
            function throwPortalOutletAlreadyDisposedError() {
                throw Error('This PortalOutlet has already been disposed');
            }
            /**
             * Throws an exception when attempting to attach an unknown portal type.
             * \@docs-private
             * @return {?}
             */
            function throwUnknownPortalTypeError() {
                throw Error('Attempting to attach an unknown Portal type. BasePortalOutlet accepts either ' +
                    'a ComponentPortal or a TemplatePortal.');
            }
            /**
             * Throws an exception when attempting to attach a portal to a null host.
             * \@docs-private
             * @return {?}
             */
            function throwNullPortalOutletError() {
                throw Error('Attempting to attach a portal to a null PortalOutlet');
            }
            /**
             * Throws an exception when attempting to detach a portal that is not attached.
             * \@docs-private
             * @return {?}
             */
            function throwNoPortalAttachedError() {
                throw Error('Attempting to detach a portal that is not attached to a host');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A `Portal` is something that you want to render somewhere else.
             * It can be attach to / detached from a `PortalOutlet`.
             * @abstract
             * @template T
             */
            var Portal = /** @class */ (function () {
                function Portal() {
                }
                /**
                 * Attach this portal to a host.
                 * @param {?} host
                 * @return {?}
                 */
                Portal.prototype.attach = function (host) {
                    if (host == null) {
                        throwNullPortalOutletError();
                    }
                    if (host.hasAttached()) {
                        throwPortalAlreadyAttachedError();
                    }
                    this._attachedHost = host;
                    return ( /** @type {?} */(host.attach(this)));
                };
                /**
                 * Detach this portal from its host
                 * @return {?}
                 */
                Portal.prototype.detach = function () {
                    /** @type {?} */
                    var host = this._attachedHost;
                    if (host == null) {
                        throwNoPortalAttachedError();
                    }
                    else {
                        this._attachedHost = null;
                        host.detach();
                    }
                };
                Object.defineProperty(Portal.prototype, "isAttached", {
                    /**
                     * Whether this portal is attached to a host.
                     * @return {?}
                     */
                    get: function () {
                        return this._attachedHost != null;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
                 * the PortalOutlet when it is performing an `attach()` or `detach()`.
                 * @param {?} host
                 * @return {?}
                 */
                Portal.prototype.setAttachedHost = function (host) {
                    this._attachedHost = host;
                };
                return Portal;
            }());
            /**
             * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
             * @template T
             */
            var ComponentPortal = /** @class */ (function (_super_1) {
                __extends(ComponentPortal, _super_1);
                /**
                 * @param {?} component
                 * @param {?=} viewContainerRef
                 * @param {?=} injector
                 * @param {?=} componentFactoryResolver
                 */
                function ComponentPortal(component, viewContainerRef, injector, componentFactoryResolver) {
                    var _this = _super_1.call(this) || this;
                    _this.component = component;
                    _this.viewContainerRef = viewContainerRef;
                    _this.injector = injector;
                    _this.componentFactoryResolver = componentFactoryResolver;
                    return _this;
                }
                return ComponentPortal;
            }(Portal));
            /**
             * A `TemplatePortal` is a portal that represents some embedded template (TemplateRef).
             * @template C
             */
            var TemplatePortal = /** @class */ (function (_super_1) {
                __extends(TemplatePortal, _super_1);
                /**
                 * @param {?} template
                 * @param {?} viewContainerRef
                 * @param {?=} context
                 */
                function TemplatePortal(template, viewContainerRef, context) {
                    var _this = _super_1.call(this) || this;
                    _this.templateRef = template;
                    _this.viewContainerRef = viewContainerRef;
                    _this.context = context;
                    return _this;
                }
                Object.defineProperty(TemplatePortal.prototype, "origin", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.templateRef.elementRef;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Attach the portal to the provided `PortalOutlet`.
                 * When a context is provided it will override the `context` property of the `TemplatePortal`
                 * instance.
                 * @param {?} host
                 * @param {?=} context
                 * @return {?}
                 */
                TemplatePortal.prototype.attach = function (host, context) {
                    if (context === void 0) { context = this.context; }
                    this.context = context;
                    return _super_1.prototype.attach.call(this, host);
                };
                /**
                 * @return {?}
                 */
                TemplatePortal.prototype.detach = function () {
                    this.context = undefined;
                    return _super_1.prototype.detach.call(this);
                };
                return TemplatePortal;
            }(Portal));
            /**
             * Partial implementation of PortalOutlet that handles attaching
             * ComponentPortal and TemplatePortal.
             * @abstract
             */
            var BasePortalOutlet = /** @class */ (function () {
                function BasePortalOutlet() {
                    /**
                     * Whether this host has already been permanently disposed.
                     */
                    this._isDisposed = false;
                }
                /**
                 * Whether this host has an attached portal.
                 * @return {?}
                 */
                BasePortalOutlet.prototype.hasAttached = function () {
                    return !!this._attachedPortal;
                };
                /**
                 * Attaches a portal.
                 * @param {?} portal
                 * @return {?}
                 */
                BasePortalOutlet.prototype.attach = function (portal) {
                    if (!portal) {
                        throwNullPortalError();
                    }
                    if (this.hasAttached()) {
                        throwPortalAlreadyAttachedError();
                    }
                    if (this._isDisposed) {
                        throwPortalOutletAlreadyDisposedError();
                    }
                    if (portal instanceof ComponentPortal) {
                        this._attachedPortal = portal;
                        return this.attachComponentPortal(portal);
                    }
                    else if (portal instanceof TemplatePortal) {
                        this._attachedPortal = portal;
                        return this.attachTemplatePortal(portal);
                    }
                    throwUnknownPortalTypeError();
                };
                /**
                 * Detaches a previously attached portal.
                 * @return {?}
                 */
                BasePortalOutlet.prototype.detach = function () {
                    if (this._attachedPortal) {
                        this._attachedPortal.setAttachedHost(null);
                        this._attachedPortal = null;
                    }
                    this._invokeDisposeFn();
                };
                /**
                 * Permanently dispose of this portal host.
                 * @return {?}
                 */
                BasePortalOutlet.prototype.dispose = function () {
                    if (this.hasAttached()) {
                        this.detach();
                    }
                    this._invokeDisposeFn();
                    this._isDisposed = true;
                };
                /**
                 * \@docs-private
                 * @param {?} fn
                 * @return {?}
                 */
                BasePortalOutlet.prototype.setDisposeFn = function (fn) {
                    this._disposeFn = fn;
                };
                /**
                 * @private
                 * @return {?}
                 */
                BasePortalOutlet.prototype._invokeDisposeFn = function () {
                    if (this._disposeFn) {
                        this._disposeFn();
                        this._disposeFn = null;
                    }
                };
                return BasePortalOutlet;
            }());
            /**
             * @deprecated Use `BasePortalOutlet` instead.
             * \@breaking-change 9.0.0
             * @abstract
             */
            var BasePortalHost = /** @class */ (function (_super_1) {
                __extends(BasePortalHost, _super_1);
                function BasePortalHost() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return BasePortalHost;
            }(BasePortalOutlet));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A PortalOutlet for attaching portals to an arbitrary DOM element outside of the Angular
             * application context.
             */
            var DomPortalOutlet = /** @class */ (function (_super_1) {
                __extends(DomPortalOutlet, _super_1);
                /**
                 * @param {?} outletElement
                 * @param {?} _componentFactoryResolver
                 * @param {?} _appRef
                 * @param {?} _defaultInjector
                 */
                function DomPortalOutlet(outletElement, _componentFactoryResolver, _appRef, _defaultInjector) {
                    var _this = _super_1.call(this) || this;
                    _this.outletElement = outletElement;
                    _this._componentFactoryResolver = _componentFactoryResolver;
                    _this._appRef = _appRef;
                    _this._defaultInjector = _defaultInjector;
                    return _this;
                }
                /**
                 * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
                 * @template T
                 * @param {?} portal Portal to be attached
                 * @return {?} Reference to the created component.
                 */
                DomPortalOutlet.prototype.attachComponentPortal = function (portal) {
                    var _this = this;
                    /** @type {?} */
                    var resolver = portal.componentFactoryResolver || this._componentFactoryResolver;
                    /** @type {?} */
                    var componentFactory = resolver.resolveComponentFactory(portal.component);
                    /** @type {?} */
                    var componentRef;
                    // If the portal specifies a ViewContainerRef, we will use that as the attachment point
                    // for the component (in terms of Angular's component tree, not rendering).
                    // When the ViewContainerRef is missing, we use the factory to create the component directly
                    // and then manually attach the view to the application.
                    if (portal.viewContainerRef) {
                        componentRef = portal.viewContainerRef.createComponent(componentFactory, portal.viewContainerRef.length, portal.injector || portal.viewContainerRef.injector);
                        this.setDisposeFn(( /**
                         * @return {?}
                         */function () { return componentRef.destroy(); }));
                    }
                    else {
                        componentRef = componentFactory.create(portal.injector || this._defaultInjector);
                        this._appRef.attachView(componentRef.hostView);
                        this.setDisposeFn(( /**
                         * @return {?}
                         */function () {
                            _this._appRef.detachView(componentRef.hostView);
                            componentRef.destroy();
                        }));
                    }
                    // At this point the component has been instantiated, so we move it to the location in the DOM
                    // where we want it to be rendered.
                    this.outletElement.appendChild(this._getComponentRootNode(componentRef));
                    return componentRef;
                };
                /**
                 * Attaches a template portal to the DOM as an embedded view.
                 * @template C
                 * @param {?} portal Portal to be attached.
                 * @return {?} Reference to the created embedded view.
                 */
                DomPortalOutlet.prototype.attachTemplatePortal = function (portal) {
                    var _this = this;
                    /** @type {?} */
                    var viewContainer = portal.viewContainerRef;
                    /** @type {?} */
                    var viewRef = viewContainer.createEmbeddedView(portal.templateRef, portal.context);
                    viewRef.detectChanges();
                    // The method `createEmbeddedView` will add the view as a child of the viewContainer.
                    // But for the DomPortalOutlet the view can be added everywhere in the DOM
                    // (e.g Overlay Container) To move the view to the specified host element. We just
                    // re-append the existing root nodes.
                    viewRef.rootNodes.forEach(( /**
                     * @param {?} rootNode
                     * @return {?}
                     */function (/**
                     * @param {?} rootNode
                     * @return {?}
                     */ rootNode) { return _this.outletElement.appendChild(rootNode); }));
                    this.setDisposeFn((( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var index = viewContainer.indexOf(viewRef);
                        if (index !== -1) {
                            viewContainer.remove(index);
                        }
                    })));
                    // TODO(jelbourn): Return locals from view.
                    return viewRef;
                };
                /**
                 * Clears out a portal from the DOM.
                 * @return {?}
                 */
                DomPortalOutlet.prototype.dispose = function () {
                    _super_1.prototype.dispose.call(this);
                    if (this.outletElement.parentNode != null) {
                        this.outletElement.parentNode.removeChild(this.outletElement);
                    }
                };
                /**
                 * Gets the root HTMLElement for an instantiated component.
                 * @private
                 * @param {?} componentRef
                 * @return {?}
                 */
                DomPortalOutlet.prototype._getComponentRootNode = function (componentRef) {
                    return ( /** @type {?} */((( /** @type {?} */(componentRef.hostView))).rootNodes[0]));
                };
                return DomPortalOutlet;
            }(BasePortalOutlet));
            /**
             * @deprecated Use `DomPortalOutlet` instead.
             * \@breaking-change 9.0.0
             */
            var DomPortalHost = /** @class */ (function (_super_1) {
                __extends(DomPortalHost, _super_1);
                function DomPortalHost() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return DomPortalHost;
            }(DomPortalOutlet));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Directive version of a `TemplatePortal`. Because the directive *is* a TemplatePortal,
             * the directive instance itself can be attached to a host, enabling declarative use of portals.
             */
            var CdkPortal = /** @class */ (function (_super_1) {
                __extends(CdkPortal, _super_1);
                /**
                 * @param {?} templateRef
                 * @param {?} viewContainerRef
                 */
                function CdkPortal(templateRef, viewContainerRef) {
                    return _super_1.call(this, templateRef, viewContainerRef) || this;
                }
                return CdkPortal;
            }(TemplatePortal));
            CdkPortal.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkPortal]',
                            exportAs: 'cdkPortal',
                        },] },
            ];
            /** @nocollapse */
            CdkPortal.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] }
            ]; };
            /**
             * @deprecated Use `CdkPortal` instead.
             * \@breaking-change 9.0.0
             */
            var TemplatePortalDirective = /** @class */ (function (_super_1) {
                __extends(TemplatePortalDirective, _super_1);
                function TemplatePortalDirective() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return TemplatePortalDirective;
            }(CdkPortal));
            TemplatePortalDirective.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdk-portal], [portal]',
                            exportAs: 'cdkPortal',
                            providers: [{
                                    provide: CdkPortal,
                                    useExisting: TemplatePortalDirective
                                }]
                        },] },
            ];
            /**
             * Directive version of a PortalOutlet. Because the directive *is* a PortalOutlet, portals can be
             * directly attached to it, enabling declarative use.
             *
             * Usage:
             * `<ng-template [cdkPortalOutlet]="greeting"></ng-template>`
             */
            var CdkPortalOutlet = /** @class */ (function (_super_1) {
                __extends(CdkPortalOutlet, _super_1);
                /**
                 * @param {?} _componentFactoryResolver
                 * @param {?} _viewContainerRef
                 */
                function CdkPortalOutlet(_componentFactoryResolver, _viewContainerRef) {
                    var _this = _super_1.call(this) || this;
                    _this._componentFactoryResolver = _componentFactoryResolver;
                    _this._viewContainerRef = _viewContainerRef;
                    /**
                     * Whether the portal component is initialized.
                     */
                    _this._isInitialized = false;
                    /**
                     * Emits when a portal is attached to the outlet.
                     */
                    _this.attached = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    return _this;
                }
                Object.defineProperty(CdkPortalOutlet.prototype, "portal", {
                    /**
                     * Portal associated with the Portal outlet.
                     * @return {?}
                     */
                    get: function () {
                        return this._attachedPortal;
                    },
                    /**
                     * @param {?} portal
                     * @return {?}
                     */
                    set: function (portal) {
                        // Ignore the cases where the `portal` is set to a falsy value before the lifecycle hooks have
                        // run. This handles the cases where the user might do something like `<div cdkPortalOutlet>`
                        // and attach a portal programmatically in the parent component. When Angular does the first CD
                        // round, it will fire the setter with empty string, causing the user's content to be cleared.
                        if (this.hasAttached() && !portal && !this._isInitialized) {
                            return;
                        }
                        if (this.hasAttached()) {
                            _super_1.prototype.detach.call(this);
                        }
                        if (portal) {
                            _super_1.prototype.attach.call(this, portal);
                        }
                        this._attachedPortal = portal;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkPortalOutlet.prototype, "attachedRef", {
                    /**
                     * Component or view reference that is attached to the portal.
                     * @return {?}
                     */
                    get: function () {
                        return this._attachedRef;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkPortalOutlet.prototype.ngOnInit = function () {
                    this._isInitialized = true;
                };
                /**
                 * @return {?}
                 */
                CdkPortalOutlet.prototype.ngOnDestroy = function () {
                    _super_1.prototype.dispose.call(this);
                    this._attachedPortal = null;
                    this._attachedRef = null;
                };
                /**
                 * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
                 *
                 * @template T
                 * @param {?} portal Portal to be attached to the portal outlet.
                 * @return {?} Reference to the created component.
                 */
                CdkPortalOutlet.prototype.attachComponentPortal = function (portal) {
                    portal.setAttachedHost(this);
                    // If the portal specifies an origin, use that as the logical location of the component
                    // in the application tree. Otherwise use the location of this PortalOutlet.
                    /** @type {?} */
                    var viewContainerRef = portal.viewContainerRef != null ?
                        portal.viewContainerRef :
                        this._viewContainerRef;
                    /** @type {?} */
                    var resolver = portal.componentFactoryResolver || this._componentFactoryResolver;
                    /** @type {?} */
                    var componentFactory = resolver.resolveComponentFactory(portal.component);
                    /** @type {?} */
                    var ref = viewContainerRef.createComponent(componentFactory, viewContainerRef.length, portal.injector || viewContainerRef.injector);
                    _super_1.prototype.setDisposeFn.call(this, ( /**
                     * @return {?}
                     */function () { return ref.destroy(); }));
                    this._attachedPortal = portal;
                    this._attachedRef = ref;
                    this.attached.emit(ref);
                    return ref;
                };
                /**
                 * Attach the given TemplatePortal to this PortlHost as an embedded View.
                 * @template C
                 * @param {?} portal Portal to be attached.
                 * @return {?} Reference to the created embedded view.
                 */
                CdkPortalOutlet.prototype.attachTemplatePortal = function (portal) {
                    var _this = this;
                    portal.setAttachedHost(this);
                    /** @type {?} */
                    var viewRef = this._viewContainerRef.createEmbeddedView(portal.templateRef, portal.context);
                    _super_1.prototype.setDisposeFn.call(this, ( /**
                     * @return {?}
                     */function () { return _this._viewContainerRef.clear(); }));
                    this._attachedPortal = portal;
                    this._attachedRef = viewRef;
                    this.attached.emit(viewRef);
                    return viewRef;
                };
                return CdkPortalOutlet;
            }(BasePortalOutlet));
            CdkPortalOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkPortalOutlet]',
                            exportAs: 'cdkPortalOutlet',
                            inputs: ['portal: cdkPortalOutlet']
                        },] },
            ];
            /** @nocollapse */
            CdkPortalOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ComponentFactoryResolver"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] }
            ]; };
            CdkPortalOutlet.propDecorators = {
                attached: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * @deprecated Use `CdkPortalOutlet` instead.
             * \@breaking-change 9.0.0
             */
            var PortalHostDirective = /** @class */ (function (_super_1) {
                __extends(PortalHostDirective, _super_1);
                function PortalHostDirective() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return PortalHostDirective;
            }(CdkPortalOutlet));
            PortalHostDirective.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkPortalHost], [portalHost]',
                            exportAs: 'cdkPortalHost',
                            inputs: ['portal: cdkPortalHost'],
                            providers: [{
                                    provide: CdkPortalOutlet,
                                    useExisting: PortalHostDirective
                                }]
                        },] },
            ];
            var PortalModule = /** @class */ (function () {
                function PortalModule() {
                }
                return PortalModule;
            }());
            PortalModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            exports: [CdkPortal, CdkPortalOutlet, TemplatePortalDirective, PortalHostDirective],
                            declarations: [CdkPortal, CdkPortalOutlet, TemplatePortalDirective, PortalHostDirective],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Custom injector to be used when providing custom
             * injection tokens to components inside a portal.
             * \@docs-private
             */
            var PortalInjector = /** @class */ (function () {
                /**
                 * @param {?} _parentInjector
                 * @param {?} _customTokens
                 */
                function PortalInjector(_parentInjector, _customTokens) {
                    this._parentInjector = _parentInjector;
                    this._customTokens = _customTokens;
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @return {?}
                 */
                PortalInjector.prototype.get = function (token, notFoundValue) {
                    /** @type {?} */
                    var value = this._customTokens.get(token);
                    if (typeof value !== 'undefined') {
                        return value;
                    }
                    return this._parentInjector.get(token, notFoundValue);
                };
                return PortalInjector;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=portal.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/scrolling.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/scrolling.js ***!
          \********************************************************/
        /*! exports provided: _fixedSizeVirtualScrollStrategyFactory, FixedSizeVirtualScrollStrategy, CdkFixedSizeVirtualScroll, SCROLL_DISPATCHER_PROVIDER_FACTORY, DEFAULT_SCROLL_TIME, ScrollDispatcher, SCROLL_DISPATCHER_PROVIDER, CdkScrollable, ScrollingModule, ScrollDispatchModule, VIEWPORT_RULER_PROVIDER_FACTORY, DEFAULT_RESIZE_TIME, ViewportRuler, VIEWPORT_RULER_PROVIDER, CdkVirtualForOf, VIRTUAL_SCROLL_STRATEGY, CdkVirtualScrollViewport */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_fixedSizeVirtualScrollStrategyFactory", function () { return _fixedSizeVirtualScrollStrategyFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedSizeVirtualScrollStrategy", function () { return FixedSizeVirtualScrollStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFixedSizeVirtualScroll", function () { return CdkFixedSizeVirtualScroll; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCROLL_DISPATCHER_PROVIDER_FACTORY", function () { return SCROLL_DISPATCHER_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_SCROLL_TIME", function () { return DEFAULT_SCROLL_TIME; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollDispatcher", function () { return ScrollDispatcher; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCROLL_DISPATCHER_PROVIDER", function () { return SCROLL_DISPATCHER_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkScrollable", function () { return CdkScrollable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollingModule", function () { return ScrollingModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollDispatchModule", function () { return ScrollDispatchModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIEWPORT_RULER_PROVIDER_FACTORY", function () { return VIEWPORT_RULER_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_RESIZE_TIME", function () { return DEFAULT_RESIZE_TIME; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportRuler", function () { return ViewportRuler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIEWPORT_RULER_PROVIDER", function () { return VIEWPORT_RULER_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkVirtualForOf", function () { return CdkVirtualForOf; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIRTUAL_SCROLL_STRATEGY", function () { return VIRTUAL_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkVirtualScrollViewport", function () { return CdkVirtualScrollViewport; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The injection token used to specify the virtual scrolling strategy.
             * @type {?}
             */
            var VIRTUAL_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('VIRTUAL_SCROLL_STRATEGY');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Virtual scrolling strategy for lists with items of known fixed size.
             */
            var FixedSizeVirtualScrollStrategy = /** @class */ (function () {
                /**
                 * @param {?} itemSize The size of the items in the virtually scrolling list.
                 * @param {?} minBufferPx The minimum amount of buffer (in pixels) before needing to render more
                 * @param {?} maxBufferPx The amount of buffer (in pixels) to render when rendering more.
                 */
                function FixedSizeVirtualScrollStrategy(itemSize, minBufferPx, maxBufferPx) {
                    this._scrolledIndexChange = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * \@docs-private Implemented as part of VirtualScrollStrategy.
                     */
                    this.scrolledIndexChange = this._scrolledIndexChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["distinctUntilChanged"])());
                    /**
                     * The attached viewport.
                     */
                    this._viewport = null;
                    this._itemSize = itemSize;
                    this._minBufferPx = minBufferPx;
                    this._maxBufferPx = maxBufferPx;
                }
                /**
                 * Attaches this scroll strategy to a viewport.
                 * @param {?} viewport The viewport to attach this strategy to.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.attach = function (viewport) {
                    this._viewport = viewport;
                    this._updateTotalContentSize();
                    this._updateRenderedRange();
                };
                /**
                 * Detaches this scroll strategy from the currently attached viewport.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.detach = function () {
                    this._scrolledIndexChange.complete();
                    this._viewport = null;
                };
                /**
                 * Update the item size and buffer size.
                 * @param {?} itemSize The size of the items in the virtually scrolling list.
                 * @param {?} minBufferPx The minimum amount of buffer (in pixels) before needing to render more
                 * @param {?} maxBufferPx The amount of buffer (in pixels) to render when rendering more.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.updateItemAndBufferSize = function (itemSize, minBufferPx, maxBufferPx) {
                    if (maxBufferPx < minBufferPx) {
                        throw Error('CDK virtual scroll: maxBufferPx must be greater than or equal to minBufferPx');
                    }
                    this._itemSize = itemSize;
                    this._minBufferPx = minBufferPx;
                    this._maxBufferPx = maxBufferPx;
                    this._updateTotalContentSize();
                    this._updateRenderedRange();
                };
                /**
                 * \@docs-private Implemented as part of VirtualScrollStrategy.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.onContentScrolled = function () {
                    this._updateRenderedRange();
                };
                /**
                 * \@docs-private Implemented as part of VirtualScrollStrategy.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.onDataLengthChanged = function () {
                    this._updateTotalContentSize();
                    this._updateRenderedRange();
                };
                /**
                 * \@docs-private Implemented as part of VirtualScrollStrategy.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.onContentRendered = function () { };
                /**
                 * \@docs-private Implemented as part of VirtualScrollStrategy.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.onRenderedOffsetChanged = function () { };
                /**
                 * Scroll to the offset for the given index.
                 * @param {?} index The index of the element to scroll to.
                 * @param {?} behavior The ScrollBehavior to use when scrolling.
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype.scrollToIndex = function (index, behavior) {
                    if (this._viewport) {
                        this._viewport.scrollToOffset(index * this._itemSize, behavior);
                    }
                };
                /**
                 * Update the viewport's total content size.
                 * @private
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype._updateTotalContentSize = function () {
                    if (!this._viewport) {
                        return;
                    }
                    this._viewport.setTotalContentSize(this._viewport.getDataLength() * this._itemSize);
                };
                /**
                 * Update the viewport's rendered range.
                 * @private
                 * @return {?}
                 */
                FixedSizeVirtualScrollStrategy.prototype._updateRenderedRange = function () {
                    if (!this._viewport) {
                        return;
                    }
                    /** @type {?} */
                    var scrollOffset = this._viewport.measureScrollOffset();
                    /** @type {?} */
                    var firstVisibleIndex = scrollOffset / this._itemSize;
                    /** @type {?} */
                    var renderedRange = this._viewport.getRenderedRange();
                    /** @type {?} */
                    var newRange = { start: renderedRange.start, end: renderedRange.end };
                    /** @type {?} */
                    var viewportSize = this._viewport.getViewportSize();
                    /** @type {?} */
                    var dataLength = this._viewport.getDataLength();
                    /** @type {?} */
                    var startBuffer = scrollOffset - newRange.start * this._itemSize;
                    if (startBuffer < this._minBufferPx && newRange.start != 0) {
                        /** @type {?} */
                        var expandStart = Math.ceil((this._maxBufferPx - startBuffer) / this._itemSize);
                        newRange.start = Math.max(0, newRange.start - expandStart);
                        newRange.end = Math.min(dataLength, Math.ceil(firstVisibleIndex + (viewportSize + this._minBufferPx) / this._itemSize));
                    }
                    else {
                        /** @type {?} */
                        var endBuffer = newRange.end * this._itemSize - (scrollOffset + viewportSize);
                        if (endBuffer < this._minBufferPx && newRange.end != dataLength) {
                            /** @type {?} */
                            var expandEnd = Math.ceil((this._maxBufferPx - endBuffer) / this._itemSize);
                            if (expandEnd > 0) {
                                newRange.end = Math.min(dataLength, newRange.end + expandEnd);
                                newRange.start = Math.max(0, Math.floor(firstVisibleIndex - this._minBufferPx / this._itemSize));
                            }
                        }
                    }
                    this._viewport.setRenderedRange(newRange);
                    this._viewport.setRenderedContentOffset(this._itemSize * newRange.start);
                    this._scrolledIndexChange.next(Math.floor(firstVisibleIndex));
                };
                return FixedSizeVirtualScrollStrategy;
            }());
            /**
             * Provider factory for `FixedSizeVirtualScrollStrategy` that simply extracts the already created
             * `FixedSizeVirtualScrollStrategy` from the given directive.
             * @param {?} fixedSizeDir The instance of `CdkFixedSizeVirtualScroll` to extract the
             *     `FixedSizeVirtualScrollStrategy` from.
             * @return {?}
             */
            function _fixedSizeVirtualScrollStrategyFactory(fixedSizeDir) {
                return fixedSizeDir._scrollStrategy;
            }
            /**
             * A virtual scroll strategy that supports fixed-size items.
             */
            var CdkFixedSizeVirtualScroll = /** @class */ (function () {
                function CdkFixedSizeVirtualScroll() {
                    this._itemSize = 20;
                    this._minBufferPx = 100;
                    this._maxBufferPx = 200;
                    /**
                     * The scroll strategy used by this directive.
                     */
                    this._scrollStrategy = new FixedSizeVirtualScrollStrategy(this.itemSize, this.minBufferPx, this.maxBufferPx);
                }
                Object.defineProperty(CdkFixedSizeVirtualScroll.prototype, "itemSize", {
                    /**
                     * The size of the items in the list (in pixels).
                     * @return {?}
                     */
                    get: function () { return this._itemSize; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._itemSize = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceNumberProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkFixedSizeVirtualScroll.prototype, "minBufferPx", {
                    /**
                     * The minimum amount of buffer rendered beyond the viewport (in pixels).
                     * If the amount of buffer dips below this number, more items will be rendered. Defaults to 100px.
                     * @return {?}
                     */
                    get: function () { return this._minBufferPx; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._minBufferPx = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceNumberProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkFixedSizeVirtualScroll.prototype, "maxBufferPx", {
                    /**
                     * The number of pixels worth of buffer to render for when rendering new items. Defaults to 200px.
                     * @return {?}
                     */
                    get: function () { return this._maxBufferPx; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._maxBufferPx = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceNumberProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkFixedSizeVirtualScroll.prototype.ngOnChanges = function () {
                    this._scrollStrategy.updateItemAndBufferSize(this.itemSize, this.minBufferPx, this.maxBufferPx);
                };
                return CdkFixedSizeVirtualScroll;
            }());
            CdkFixedSizeVirtualScroll.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'cdk-virtual-scroll-viewport[itemSize]',
                            providers: [{
                                    provide: VIRTUAL_SCROLL_STRATEGY,
                                    useFactory: _fixedSizeVirtualScrollStrategyFactory,
                                    deps: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                             * @return {?}
                                             */function () { return CdkFixedSizeVirtualScroll; }))],
                                }],
                        },] },
            ];
            CdkFixedSizeVirtualScroll.propDecorators = {
                itemSize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                minBufferPx: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                maxBufferPx: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Time in ms to throttle the scrolling events by default.
             * @type {?}
             */
            var DEFAULT_SCROLL_TIME = 20;
            /**
             * Service contained all registered Scrollable references and emits an event when any one of the
             * Scrollable references emit a scrolled event.
             */
            var ScrollDispatcher = /** @class */ (function () {
                /**
                 * @param {?} _ngZone
                 * @param {?} _platform
                 */
                function ScrollDispatcher(_ngZone, _platform) {
                    this._ngZone = _ngZone;
                    this._platform = _platform;
                    /**
                     * Subject for notifying that a registered scrollable reference element has been scrolled.
                     */
                    this._scrolled = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Keeps track of the global `scroll` and `resize` subscriptions.
                     */
                    this._globalSubscription = null;
                    /**
                     * Keeps track of the amount of subscriptions to `scrolled`. Used for cleaning up afterwards.
                     */
                    this._scrolledCount = 0;
                    /**
                     * Map of all the scrollable references that are registered with the service and their
                     * scroll event subscriptions.
                     */
                    this.scrollContainers = new Map();
                }
                /**
                 * Registers a scrollable instance with the service and listens for its scrolled events. When the
                 * scrollable is scrolled, the service emits the event to its scrolled observable.
                 * @param {?} scrollable Scrollable instance to be registered.
                 * @return {?}
                 */
                ScrollDispatcher.prototype.register = function (scrollable) {
                    var _this = this;
                    if (!this.scrollContainers.has(scrollable)) {
                        this.scrollContainers.set(scrollable, scrollable.elementScrolled()
                            .subscribe(( /**
                     * @return {?}
                     */function () { return _this._scrolled.next(scrollable); })));
                    }
                };
                /**
                 * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
                 * @param {?} scrollable Scrollable instance to be deregistered.
                 * @return {?}
                 */
                ScrollDispatcher.prototype.deregister = function (scrollable) {
                    /** @type {?} */
                    var scrollableReference = this.scrollContainers.get(scrollable);
                    if (scrollableReference) {
                        scrollableReference.unsubscribe();
                        this.scrollContainers.delete(scrollable);
                    }
                };
                /**
                 * Returns an observable that emits an event whenever any of the registered Scrollable
                 * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
                 * to override the default "throttle" time.
                 *
                 * **Note:** in order to avoid hitting change detection for every scroll event,
                 * all of the events emitted from this stream will be run outside the Angular zone.
                 * If you need to update any data bindings as a result of a scroll event, you have
                 * to run the callback using `NgZone.run`.
                 * @param {?=} auditTimeInMs
                 * @return {?}
                 */
                ScrollDispatcher.prototype.scrolled = function (auditTimeInMs) {
                    var _this = this;
                    if (auditTimeInMs === void 0) { auditTimeInMs = DEFAULT_SCROLL_TIME; }
                    if (!this._platform.isBrowser) {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])();
                    }
                    return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        if (!_this._globalSubscription) {
                            _this._addGlobalListener();
                        }
                        // In the case of a 0ms delay, use an observable without auditTime
                        // since it does add a perceptible delay in processing overhead.
                        /** @type {?} */
                        var subscription = auditTimeInMs > 0 ?
                            _this._scrolled.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["auditTime"])(auditTimeInMs)).subscribe(observer) :
                            _this._scrolled.subscribe(observer);
                        _this._scrolledCount++;
                        return ( /**
                         * @return {?}
                         */function () {
                            subscription.unsubscribe();
                            _this._scrolledCount--;
                            if (!_this._scrolledCount) {
                                _this._removeGlobalListener();
                            }
                        });
                    }));
                };
                /**
                 * @return {?}
                 */
                ScrollDispatcher.prototype.ngOnDestroy = function () {
                    var _this = this;
                    this._removeGlobalListener();
                    this.scrollContainers.forEach(( /**
                     * @param {?} _
                     * @param {?} container
                     * @return {?}
                     */function (_, container) { return _this.deregister(container); }));
                    this._scrolled.complete();
                };
                /**
                 * Returns an observable that emits whenever any of the
                 * scrollable ancestors of an element are scrolled.
                 * @param {?} elementRef Element whose ancestors to listen for.
                 * @param {?=} auditTimeInMs Time to throttle the scroll events.
                 * @return {?}
                 */
                ScrollDispatcher.prototype.ancestorScrolled = function (elementRef, auditTimeInMs) {
                    /** @type {?} */
                    var ancestors = this.getAncestorScrollContainers(elementRef);
                    return this.scrolled(auditTimeInMs).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(( /**
                     * @param {?} target
                     * @return {?}
                     */function (/**
                     * @param {?} target
                     * @return {?}
                     */ target) {
                        return !target || ancestors.indexOf(target) > -1;
                    })));
                };
                /**
                 * Returns all registered Scrollables that contain the provided element.
                 * @param {?} elementRef
                 * @return {?}
                 */
                ScrollDispatcher.prototype.getAncestorScrollContainers = function (elementRef) {
                    var _this = this;
                    /** @type {?} */
                    var scrollingContainers = [];
                    this.scrollContainers.forEach(( /**
                     * @param {?} _subscription
                     * @param {?} scrollable
                     * @return {?}
                     */function (_subscription, scrollable) {
                        if (_this._scrollableContainsElement(scrollable, elementRef)) {
                            scrollingContainers.push(scrollable);
                        }
                    }));
                    return scrollingContainers;
                };
                /**
                 * Returns true if the element is contained within the provided Scrollable.
                 * @private
                 * @param {?} scrollable
                 * @param {?} elementRef
                 * @return {?}
                 */
                ScrollDispatcher.prototype._scrollableContainsElement = function (scrollable, elementRef) {
                    /** @type {?} */
                    var element = elementRef.nativeElement;
                    /** @type {?} */
                    var scrollableElement = scrollable.getElementRef().nativeElement;
                    // Traverse through the element parents until we reach null, checking if any of the elements
                    // are the scrollable's element.
                    do {
                        if (element == scrollableElement) {
                            return true;
                        }
                    } while (element = ( /** @type {?} */(element)).parentElement);
                    return false;
                };
                /**
                 * Sets up the global scroll listeners.
                 * @private
                 * @return {?}
                 */
                ScrollDispatcher.prototype._addGlobalListener = function () {
                    var _this = this;
                    this._globalSubscription = this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["fromEvent"])(window.document, 'scroll').subscribe(( /**
                         * @return {?}
                         */function () { return _this._scrolled.next(); }));
                    }));
                };
                /**
                 * Cleans up the global scroll listener.
                 * @private
                 * @return {?}
                 */
                ScrollDispatcher.prototype._removeGlobalListener = function () {
                    if (this._globalSubscription) {
                        this._globalSubscription.unsubscribe();
                        this._globalSubscription = null;
                    }
                };
                return ScrollDispatcher;
            }());
            ScrollDispatcher.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            ScrollDispatcher.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"] }
            ]; };
            /** @nocollapse */ ScrollDispatcher.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function ScrollDispatcher_Factory() { return new ScrollDispatcher(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"])); }, token: ScrollDispatcher, providedIn: "root" });
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} parentDispatcher
             * @param {?} ngZone
             * @param {?} platform
             * @return {?}
             */
            function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
                return parentDispatcher || new ScrollDispatcher(ngZone, platform);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var SCROLL_DISPATCHER_PROVIDER = {
                // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
                provide: ScrollDispatcher,
                deps: [[new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"](), ScrollDispatcher], _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"], _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"]],
                useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Sends an event when the directive's element is scrolled. Registers itself with the
             * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
             * can be listened to through the service.
             */
            var CdkScrollable = /** @class */ (function () {
                /**
                 * @param {?} elementRef
                 * @param {?} scrollDispatcher
                 * @param {?} ngZone
                 * @param {?=} dir
                 */
                function CdkScrollable(elementRef, scrollDispatcher, ngZone, dir) {
                    var _this = this;
                    this.elementRef = elementRef;
                    this.scrollDispatcher = scrollDispatcher;
                    this.ngZone = ngZone;
                    this.dir = dir;
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    this._elementScrolled = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) { return _this.ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () { return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["fromEvent"])(_this.elementRef.nativeElement, 'scroll').pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(_this._destroyed))
                        .subscribe(observer); })); }));
                }
                /**
                 * @return {?}
                 */
                CdkScrollable.prototype.ngOnInit = function () {
                    this.scrollDispatcher.register(this);
                };
                /**
                 * @return {?}
                 */
                CdkScrollable.prototype.ngOnDestroy = function () {
                    this.scrollDispatcher.deregister(this);
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Returns observable that emits when a scroll event is fired on the host element.
                 * @return {?}
                 */
                CdkScrollable.prototype.elementScrolled = function () {
                    return this._elementScrolled;
                };
                /**
                 * Gets the ElementRef for the viewport.
                 * @return {?}
                 */
                CdkScrollable.prototype.getElementRef = function () {
                    return this.elementRef;
                };
                /**
                 * Scrolls to the specified offsets. This is a normalized version of the browser's native scrollTo
                 * method, since browsers are not consistent about what scrollLeft means in RTL. For this method
                 * left and right always refer to the left and right side of the scrolling container irrespective
                 * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
                 * in an RTL context.
                 * @param {?} options specified the offsets to scroll to.
                 * @return {?}
                 */
                CdkScrollable.prototype.scrollTo = function (options) {
                    /** @type {?} */
                    var el = this.elementRef.nativeElement;
                    /** @type {?} */
                    var isRtl = this.dir && this.dir.value == 'rtl';
                    // Rewrite start & end offsets as right or left offsets.
                    options.left = options.left == null ? (isRtl ? options.end : options.start) : options.left;
                    options.right = options.right == null ? (isRtl ? options.start : options.end) : options.right;
                    // Rewrite the bottom offset as a top offset.
                    if (options.bottom != null) {
                        (( /** @type {?} */(options))).top =
                            el.scrollHeight - el.clientHeight - options.bottom;
                    }
                    // Rewrite the right offset as a left offset.
                    if (isRtl && Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["getRtlScrollAxisType"])() != _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["RtlScrollAxisType"].NORMAL) {
                        if (options.left != null) {
                            (( /** @type {?} */(options))).right =
                                el.scrollWidth - el.clientWidth - options.left;
                        }
                        if (Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["getRtlScrollAxisType"])() == _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["RtlScrollAxisType"].INVERTED) {
                            options.left = options.right;
                        }
                        else if (Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["getRtlScrollAxisType"])() == _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["RtlScrollAxisType"].NEGATED) {
                            options.left = options.right ? -options.right : options.right;
                        }
                    }
                    else {
                        if (options.right != null) {
                            (( /** @type {?} */(options))).left =
                                el.scrollWidth - el.clientWidth - options.right;
                        }
                    }
                    this._applyScrollToOptions(options);
                };
                /**
                 * @private
                 * @param {?} options
                 * @return {?}
                 */
                CdkScrollable.prototype._applyScrollToOptions = function (options) {
                    /** @type {?} */
                    var el = this.elementRef.nativeElement;
                    if (Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["supportsScrollBehavior"])()) {
                        el.scrollTo(options);
                    }
                    else {
                        if (options.top != null) {
                            el.scrollTop = options.top;
                        }
                        if (options.left != null) {
                            el.scrollLeft = options.left;
                        }
                    }
                };
                /**
                 * Measures the scroll offset relative to the specified edge of the viewport. This method can be
                 * used instead of directly checking scrollLeft or scrollTop, since browsers are not consistent
                 * about what scrollLeft means in RTL. The values returned by this method are normalized such that
                 * left and right always refer to the left and right side of the scrolling container irrespective
                 * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
                 * in an RTL context.
                 * @param {?} from The edge to measure from.
                 * @return {?}
                 */
                CdkScrollable.prototype.measureScrollOffset = function (from) {
                    /** @type {?} */
                    var LEFT = 'left';
                    /** @type {?} */
                    var RIGHT = 'right';
                    /** @type {?} */
                    var el = this.elementRef.nativeElement;
                    if (from == 'top') {
                        return el.scrollTop;
                    }
                    if (from == 'bottom') {
                        return el.scrollHeight - el.clientHeight - el.scrollTop;
                    }
                    // Rewrite start & end as left or right offsets.
                    /** @type {?} */
                    var isRtl = this.dir && this.dir.value == 'rtl';
                    if (from == 'start') {
                        from = isRtl ? RIGHT : LEFT;
                    }
                    else if (from == 'end') {
                        from = isRtl ? LEFT : RIGHT;
                    }
                    if (isRtl && Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["getRtlScrollAxisType"])() == _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["RtlScrollAxisType"].INVERTED) {
                        // For INVERTED, scrollLeft is (scrollWidth - clientWidth) when scrolled all the way left and
                        // 0 when scrolled all the way right.
                        if (from == LEFT) {
                            return el.scrollWidth - el.clientWidth - el.scrollLeft;
                        }
                        else {
                            return el.scrollLeft;
                        }
                    }
                    else if (isRtl && Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["getRtlScrollAxisType"])() == _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["RtlScrollAxisType"].NEGATED) {
                        // For NEGATED, scrollLeft is -(scrollWidth - clientWidth) when scrolled all the way left and
                        // 0 when scrolled all the way right.
                        if (from == LEFT) {
                            return el.scrollLeft + el.scrollWidth - el.clientWidth;
                        }
                        else {
                            return -el.scrollLeft;
                        }
                    }
                    else {
                        // For NORMAL, as well as non-RTL contexts, scrollLeft is 0 when scrolled all the way left and
                        // (scrollWidth - clientWidth) when scrolled all the way right.
                        if (from == LEFT) {
                            return el.scrollLeft;
                        }
                        else {
                            return el.scrollWidth - el.clientWidth - el.scrollLeft;
                        }
                    }
                };
                return CdkScrollable;
            }());
            CdkScrollable.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdk-scrollable], [cdkScrollable]'
                        },] },
            ];
            /** @nocollapse */
            CdkScrollable.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: ScrollDispatcher },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Checks if the given ranges are equal.
             * @param {?} r1
             * @param {?} r2
             * @return {?}
             */
            function rangesEqual(r1, r2) {
                return r1.start == r2.start && r1.end == r2.end;
            }
            /**
             * Scheduler to be used for scroll events. Needs to fall back to
             * something that doesn't rely on requestAnimationFrame on environments
             * that don't support it (e.g. server-side rendering).
             * @type {?}
             */
            var SCROLL_SCHEDULER = typeof requestAnimationFrame !== 'undefined' ? rxjs__WEBPACK_IMPORTED_MODULE_2__["animationFrameScheduler"] : rxjs__WEBPACK_IMPORTED_MODULE_2__["asapScheduler"];
            /**
             * A viewport that virtualizes its scrolling with the help of `CdkVirtualForOf`.
             */
            var CdkVirtualScrollViewport = /** @class */ (function (_super_1) {
                __extends(CdkVirtualScrollViewport, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} ngZone
                 * @param {?} _scrollStrategy
                 * @param {?} dir
                 * @param {?} scrollDispatcher
                 */
                function CdkVirtualScrollViewport(elementRef, _changeDetectorRef, ngZone, _scrollStrategy, dir, scrollDispatcher) {
                    var _this = _super_1.call(this, elementRef, scrollDispatcher, ngZone, dir) || this;
                    _this.elementRef = elementRef;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._scrollStrategy = _scrollStrategy;
                    /**
                     * Emits when the viewport is detached from a CdkVirtualForOf.
                     */
                    _this._detachedSubject = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Emits when the rendered range changes.
                     */
                    _this._renderedRangeSubject = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    _this._orientation = 'vertical';
                    // Note: we don't use the typical EventEmitter here because we need to subscribe to the scroll
                    // strategy lazily (i.e. only if the user is actually listening to the events). We do this because
                    // depending on how the strategy calculates the scrolled index, it may come at a cost to
                    // performance.
                    /**
                     * Emits when the index of the first element visible in the viewport changes.
                     */
                    _this.scrolledIndexChange = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) { return _this._scrollStrategy.scrolledIndexChange.subscribe(( /**
                     * @param {?} index
                     * @return {?}
                     */function (/**
                     * @param {?} index
                     * @return {?}
                     */ index) { return Promise.resolve().then(( /**
                     * @return {?}
                     */function () { return _this.ngZone.run(( /**
                     * @return {?}
                     */function () { return observer.next(index); })); })); })); }));
                    /**
                     * A stream that emits whenever the rendered range changes.
                     */
                    _this.renderedRangeStream = _this._renderedRangeSubject.asObservable();
                    /**
                     * The total size of all content (in pixels), including content that is not currently rendered.
                     */
                    _this._totalContentSize = 0;
                    /**
                     * A string representing the `style.width` property value to be used for the spacer element.
                     */
                    _this._totalContentWidth = '';
                    /**
                     * A string representing the `style.height` property value to be used for the spacer element.
                     */
                    _this._totalContentHeight = '';
                    /**
                     * The currently rendered range of indices.
                     */
                    _this._renderedRange = { start: 0, end: 0 };
                    /**
                     * The length of the data bound to this viewport (in number of items).
                     */
                    _this._dataLength = 0;
                    /**
                     * The size of the viewport (in pixels).
                     */
                    _this._viewportSize = 0;
                    /**
                     * The last rendered content offset that was set.
                     */
                    _this._renderedContentOffset = 0;
                    /**
                     * Whether the last rendered content offset was to the end of the content (and therefore needs to
                     * be rewritten as an offset to the start of the content).
                     */
                    _this._renderedContentOffsetNeedsRewrite = false;
                    /**
                     * Whether there is a pending change detection cycle.
                     */
                    _this._isChangeDetectionPending = false;
                    /**
                     * A list of functions to run after the next change detection cycle.
                     */
                    _this._runAfterChangeDetection = [];
                    if (!_scrollStrategy) {
                        throw Error('Error: cdk-virtual-scroll-viewport requires the "itemSize" property to be set.');
                    }
                    return _this;
                }
                Object.defineProperty(CdkVirtualScrollViewport.prototype, "orientation", {
                    /**
                     * The direction the viewport scrolls.
                     * @return {?}
                     */
                    get: function () {
                        return this._orientation;
                    },
                    /**
                     * @param {?} orientation
                     * @return {?}
                     */
                    set: function (orientation) {
                        if (this._orientation !== orientation) {
                            this._orientation = orientation;
                            this._calculateSpacerSize();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.ngOnInit = function () {
                    var _this = this;
                    _super_1.prototype.ngOnInit.call(this);
                    // It's still too early to measure the viewport at this point. Deferring with a promise allows
                    // the Viewport to be rendered with the correct size before we measure. We run this outside the
                    // zone to avoid causing more change detection cycles. We handle the change detection loop
                    // ourselves instead.
                    this.ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () { return Promise.resolve().then(( /**
                     * @return {?}
                     */function () {
                        _this._measureViewportSize();
                        _this._scrollStrategy.attach(_this);
                        _this.elementScrolled()
                            .pipe(
                        // Start off with a fake scroll event so we properly detect our initial position.
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(( /** @type {?} */(null))), 
                        // Collect multiple events into one until the next animation frame. This way if
                        // there are multiple scroll events in the same frame we only need to recheck
                        // our layout once.
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["auditTime"])(0, SCROLL_SCHEDULER))
                            .subscribe(( /**
                     * @return {?}
                     */function () { return _this._scrollStrategy.onContentScrolled(); }));
                        _this._markChangeDetectionNeeded();
                    })); }));
                };
                /**
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.ngOnDestroy = function () {
                    this.detach();
                    this._scrollStrategy.detach();
                    // Complete all subjects
                    this._renderedRangeSubject.complete();
                    this._detachedSubject.complete();
                    _super_1.prototype.ngOnDestroy.call(this);
                };
                /**
                 * Attaches a `CdkVirtualForOf` to this viewport.
                 * @param {?} forOf
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.attach = function (forOf) {
                    var _this = this;
                    if (this._forOf) {
                        throw Error('CdkVirtualScrollViewport is already attached.');
                    }
                    // Subscribe to the data stream of the CdkVirtualForOf to keep track of when the data length
                    // changes. Run outside the zone to avoid triggering change detection, since we're managing the
                    // change detection loop ourselves.
                    this.ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._forOf = forOf;
                        _this._forOf.dataStream.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(_this._detachedSubject)).subscribe(( /**
                         * @param {?} data
                         * @return {?}
                         */function (/**
                         * @param {?} data
                         * @return {?}
                         */ data) {
                            /** @type {?} */
                            var newLength = data.length;
                            if (newLength !== _this._dataLength) {
                                _this._dataLength = newLength;
                                _this._scrollStrategy.onDataLengthChanged();
                            }
                            _this._doChangeDetection();
                        }));
                    }));
                };
                /**
                 * Detaches the current `CdkVirtualForOf`.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.detach = function () {
                    this._forOf = null;
                    this._detachedSubject.next();
                };
                /**
                 * Gets the length of the data bound to this viewport (in number of items).
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.getDataLength = function () {
                    return this._dataLength;
                };
                /**
                 * Gets the size of the viewport (in pixels).
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.getViewportSize = function () {
                    return this._viewportSize;
                };
                // TODO(mmalerba): This is technically out of sync with what's really rendered until a render
                // cycle happens. I'm being careful to only call it after the render cycle is complete and before
                // setting it to something else, but its error prone and should probably be split into
                // `pendingRange` and `renderedRange`, the latter reflecting whats actually in the DOM.
                /**
                 * Get the current rendered range of items.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.getRenderedRange = function () {
                    return this._renderedRange;
                };
                /**
                 * Sets the total size of all content (in pixels), including content that is not currently
                 * rendered.
                 * @param {?} size
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.setTotalContentSize = function (size) {
                    if (this._totalContentSize !== size) {
                        this._totalContentSize = size;
                        this._calculateSpacerSize();
                        this._markChangeDetectionNeeded();
                    }
                };
                /**
                 * Sets the currently rendered range of indices.
                 * @param {?} range
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.setRenderedRange = function (range) {
                    var _this = this;
                    if (!rangesEqual(this._renderedRange, range)) {
                        this._renderedRangeSubject.next(this._renderedRange = range);
                        this._markChangeDetectionNeeded(( /**
                         * @return {?}
                         */function () { return _this._scrollStrategy.onContentRendered(); }));
                    }
                };
                /**
                 * Gets the offset from the start of the viewport to the start of the rendered data (in pixels).
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.getOffsetToRenderedContentStart = function () {
                    return this._renderedContentOffsetNeedsRewrite ? null : this._renderedContentOffset;
                };
                /**
                 * Sets the offset from the start of the viewport to either the start or end of the rendered data
                 * (in pixels).
                 * @param {?} offset
                 * @param {?=} to
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.setRenderedContentOffset = function (offset, to) {
                    var _this = this;
                    if (to === void 0) { to = 'to-start'; }
                    // For a horizontal viewport in a right-to-left language we need to translate along the x-axis
                    // in the negative direction.
                    /** @type {?} */
                    var isRtl = this.dir && this.dir.value == 'rtl';
                    /** @type {?} */
                    var isHorizontal = this.orientation == 'horizontal';
                    /** @type {?} */
                    var axis = isHorizontal ? 'X' : 'Y';
                    /** @type {?} */
                    var axisDirection = isHorizontal && isRtl ? -1 : 1;
                    /** @type {?} */
                    var transform = "translate" + axis + "(" + Number(axisDirection * offset) + "px)";
                    this._renderedContentOffset = offset;
                    if (to === 'to-end') {
                        transform += " translate" + axis + "(-100%)";
                        // The viewport should rewrite this as a `to-start` offset on the next render cycle. Otherwise
                        // elements will appear to expand in the wrong direction (e.g. `mat-expansion-panel` would
                        // expand upward).
                        this._renderedContentOffsetNeedsRewrite = true;
                    }
                    if (this._renderedContentTransform != transform) {
                        // We know this value is safe because we parse `offset` with `Number()` before passing it
                        // into the string.
                        this._renderedContentTransform = transform;
                        this._markChangeDetectionNeeded(( /**
                         * @return {?}
                         */function () {
                            if (_this._renderedContentOffsetNeedsRewrite) {
                                _this._renderedContentOffset -= _this.measureRenderedContentSize();
                                _this._renderedContentOffsetNeedsRewrite = false;
                                _this.setRenderedContentOffset(_this._renderedContentOffset);
                            }
                            else {
                                _this._scrollStrategy.onRenderedOffsetChanged();
                            }
                        }));
                    }
                };
                /**
                 * Scrolls to the given offset from the start of the viewport. Please note that this is not always
                 * the same as setting `scrollTop` or `scrollLeft`. In a horizontal viewport with right-to-left
                 * direction, this would be the equivalent of setting a fictional `scrollRight` property.
                 * @param {?} offset The offset to scroll to.
                 * @param {?=} behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.scrollToOffset = function (offset, behavior) {
                    if (behavior === void 0) { behavior = 'auto'; }
                    /** @type {?} */
                    var options = { behavior: behavior };
                    if (this.orientation === 'horizontal') {
                        options.start = offset;
                    }
                    else {
                        options.top = offset;
                    }
                    this.scrollTo(options);
                };
                /**
                 * Scrolls to the offset for the given index.
                 * @param {?} index The index of the element to scroll to.
                 * @param {?=} behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.scrollToIndex = function (index, behavior) {
                    if (behavior === void 0) { behavior = 'auto'; }
                    this._scrollStrategy.scrollToIndex(index, behavior);
                };
                /**
                 * Gets the current scroll offset from the start of the viewport (in pixels).
                 * @param {?=} from The edge to measure the offset from. Defaults to 'top' in vertical mode and 'start'
                 *     in horizontal mode.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.measureScrollOffset = function (from) {
                    return _super_1.prototype.measureScrollOffset.call(this, from ? from : this.orientation === 'horizontal' ? 'start' : 'top');
                };
                /**
                 * Measure the combined size of all of the rendered items.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.measureRenderedContentSize = function () {
                    /** @type {?} */
                    var contentEl = this._contentWrapper.nativeElement;
                    return this.orientation === 'horizontal' ? contentEl.offsetWidth : contentEl.offsetHeight;
                };
                /**
                 * Measure the total combined size of the given range. Throws if the range includes items that are
                 * not rendered.
                 * @param {?} range
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.measureRangeSize = function (range) {
                    if (!this._forOf) {
                        return 0;
                    }
                    return this._forOf.measureRangeSize(range, this.orientation);
                };
                /**
                 * Update the viewport dimensions and re-render.
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype.checkViewportSize = function () {
                    // TODO: Cleanup later when add logic for handling content resize
                    this._measureViewportSize();
                    this._scrollStrategy.onDataLengthChanged();
                };
                /**
                 * Measure the viewport size.
                 * @private
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype._measureViewportSize = function () {
                    /** @type {?} */
                    var viewportEl = this.elementRef.nativeElement;
                    this._viewportSize = this.orientation === 'horizontal' ?
                        viewportEl.clientWidth : viewportEl.clientHeight;
                };
                /**
                 * Queue up change detection to run.
                 * @private
                 * @param {?=} runAfter
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype._markChangeDetectionNeeded = function (runAfter) {
                    var _this = this;
                    if (runAfter) {
                        this._runAfterChangeDetection.push(runAfter);
                    }
                    // Use a Promise to batch together calls to `_doChangeDetection`. This way if we set a bunch of
                    // properties sequentially we only have to run `_doChangeDetection` once at the end.
                    if (!this._isChangeDetectionPending) {
                        this._isChangeDetectionPending = true;
                        this.ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return Promise.resolve().then(( /**
                         * @return {?}
                         */function () {
                            _this._doChangeDetection();
                        })); }));
                    }
                };
                /**
                 * Run change detection.
                 * @private
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype._doChangeDetection = function () {
                    var _this = this;
                    this._isChangeDetectionPending = false;
                    // Apply changes to Angular bindings. Note: We must call `markForCheck` to run change detection
                    // from the root, since the repeated items are content projected in. Calling `detectChanges`
                    // instead does not properly check the projected content.
                    this.ngZone.run(( /**
                     * @return {?}
                     */function () { return _this._changeDetectorRef.markForCheck(); }));
                    // Apply the content transform. The transform can't be set via an Angular binding because
                    // bypassSecurityTrustStyle is banned in Google. However the value is safe, it's composed of
                    // string literals, a variable that can only be 'X' or 'Y', and user input that is run through
                    // the `Number` function first to coerce it to a numeric value.
                    this._contentWrapper.nativeElement.style.transform = this._renderedContentTransform;
                    /** @type {?} */
                    var runAfterChangeDetection = this._runAfterChangeDetection;
                    this._runAfterChangeDetection = [];
                    for (var _c = 0, runAfterChangeDetection_1 = runAfterChangeDetection; _c < runAfterChangeDetection_1.length; _c++) {
                        var fn = runAfterChangeDetection_1[_c];
                        fn();
                    }
                };
                /**
                 * Calculates the `style.width` and `style.height` for the spacer element.
                 * @private
                 * @return {?}
                 */
                CdkVirtualScrollViewport.prototype._calculateSpacerSize = function () {
                    this._totalContentHeight =
                        this.orientation === 'horizontal' ? '' : this._totalContentSize + "px";
                    this._totalContentWidth =
                        this.orientation === 'horizontal' ? this._totalContentSize + "px" : '';
                };
                return CdkVirtualScrollViewport;
            }(CdkScrollable));
            CdkVirtualScrollViewport.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'cdk-virtual-scroll-viewport',
                            template: "<div #contentWrapper class=\"cdk-virtual-scroll-content-wrapper\"><ng-content></ng-content></div><div class=\"cdk-virtual-scroll-spacer\" [style.width]=\"_totalContentWidth\" [style.height]=\"_totalContentHeight\"></div>",
                            styles: ["cdk-virtual-scroll-viewport{display:block;position:relative;overflow:auto;contain:strict;transform:translateZ(0);will-change:scroll-position;-webkit-overflow-scrolling:touch}.cdk-virtual-scroll-content-wrapper{position:absolute;top:0;left:0;contain:content}[dir=rtl] .cdk-virtual-scroll-content-wrapper{right:0;left:auto}.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper{min-height:100%}.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>dl:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>ol:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>table:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>ul:not([cdkVirtualFor]){padding-left:0;padding-right:0;margin-left:0;margin-right:0;border-left-width:0;border-right-width:0;outline:0}.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper{min-width:100%}.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>dl:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>ol:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>table:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>ul:not([cdkVirtualFor]){padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0;border-top-width:0;border-bottom-width:0;outline:0}.cdk-virtual-scroll-spacer{position:absolute;top:0;left:0;height:1px;width:1px;transform-origin:0 0}[dir=rtl] .cdk-virtual-scroll-spacer{right:0;left:auto;transform-origin:100% 0}"],
                            host: {
                                'class': 'cdk-virtual-scroll-viewport',
                                '[class.cdk-virtual-scroll-orientation-horizontal]': 'orientation === "horizontal"',
                                '[class.cdk-virtual-scroll-orientation-vertical]': 'orientation !== "horizontal"',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            providers: [{
                                    provide: CdkScrollable,
                                    useExisting: CdkVirtualScrollViewport,
                                }]
                        },] },
            ];
            /** @nocollapse */
            CdkVirtualScrollViewport.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [VIRTUAL_SCROLL_STRATEGY,] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: ScrollDispatcher }
            ]; };
            CdkVirtualScrollViewport.propDecorators = {
                orientation: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                scrolledIndexChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _contentWrapper: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['contentWrapper', { static: true },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Helper to extract size from a DOM Node.
             * @param {?} orientation
             * @param {?} node
             * @return {?}
             */
            function getSize(orientation, node) {
                /** @type {?} */
                var el = ( /** @type {?} */(node));
                if (!el.getBoundingClientRect) {
                    return 0;
                }
                /** @type {?} */
                var rect = el.getBoundingClientRect();
                return orientation == 'horizontal' ? rect.width : rect.height;
            }
            /**
             * A directive similar to `ngForOf` to be used for rendering data inside a virtual scrolling
             * container.
             * @template T
             */
            var CdkVirtualForOf = /** @class */ (function () {
                /**
                 * @param {?} _viewContainerRef
                 * @param {?} _template
                 * @param {?} _differs
                 * @param {?} _viewport
                 * @param {?} ngZone
                 */
                function CdkVirtualForOf(_viewContainerRef, _template, _differs, _viewport, ngZone) {
                    var _this = this;
                    this._viewContainerRef = _viewContainerRef;
                    this._template = _template;
                    this._differs = _differs;
                    this._viewport = _viewport;
                    /**
                     * Emits when the rendered view of the data changes.
                     */
                    this.viewChange = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Subject that emits when a new DataSource instance is given.
                     */
                    this._dataSourceChanges = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * The size of the cache used to store templates that are not being used for re-use later.
                     * Setting the cache size to `0` will disable caching. Defaults to 20 templates.
                     */
                    this.cdkVirtualForTemplateCacheSize = 20;
                    /**
                     * Emits whenever the data in the current DataSource changes.
                     */
                    this.dataStream = this._dataSourceChanges
                        .pipe(
                    // Start off with null `DataSource`.
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(( /** @type {?} */(null))), 
                    // Bundle up the previous and current data sources so we can work with both.
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["pairwise"])(), 
                    // Use `_changeDataSource` to disconnect from the previous data source and connect to the
                    // new one, passing back a stream of data changes which we run through `switchMap` to give
                    // us a data stream that emits the latest data from whatever the current `DataSource` is.
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var prev = _c[0], cur = _c[1];
                        return _this._changeDataSource(prev, cur);
                    })), 
                    // Replay the last emitted data when someone subscribes.
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["shareReplay"])(1));
                    /**
                     * The differ used to calculate changes to the data.
                     */
                    this._differ = null;
                    /**
                     * The template cache used to hold on ot template instancess that have been stamped out, but don't
                     * currently need to be rendered. These instances will be reused in the future rather than
                     * stamping out brand new ones.
                     */
                    this._templateCache = [];
                    /**
                     * Whether the rendered data should be updated during the next ngDoCheck cycle.
                     */
                    this._needsUpdate = false;
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    this.dataStream.subscribe(( /**
                     * @param {?} data
                     * @return {?}
                     */function (/**
                     * @param {?} data
                     * @return {?}
                     */ data) {
                        _this._data = data;
                        _this._onRenderedDataChange();
                    }));
                    this._viewport.renderedRangeStream.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @param {?} range
                     * @return {?}
                     */function (/**
                     * @param {?} range
                     * @return {?}
                     */ range) {
                        _this._renderedRange = range;
                        ngZone.run(( /**
                         * @return {?}
                         */function () { return _this.viewChange.next(_this._renderedRange); }));
                        _this._onRenderedDataChange();
                    }));
                    this._viewport.attach(this);
                }
                Object.defineProperty(CdkVirtualForOf.prototype, "cdkVirtualForOf", {
                    /**
                     * The DataSource to display.
                     * @return {?}
                     */
                    get: function () {
                        return this._cdkVirtualForOf;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._cdkVirtualForOf = value;
                        /** @type {?} */
                        var ds = Object(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_6__["isDataSource"])(value) ? value :
                            // Slice the value if its an NgIterable to ensure we're working with an array.
                            new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_6__["ArrayDataSource"](value instanceof rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"] ? value : Array.prototype.slice.call(value || []));
                        this._dataSourceChanges.next(ds);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkVirtualForOf.prototype, "cdkVirtualForTrackBy", {
                    /**
                     * The `TrackByFunction` to use for tracking changes. The `TrackByFunction` takes the index and
                     * the item and produces a value to be used as the item's identity when tracking changes.
                     * @return {?}
                     */
                    get: function () {
                        return this._cdkVirtualForTrackBy;
                    },
                    /**
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        var _this = this;
                        this._needsUpdate = true;
                        this._cdkVirtualForTrackBy = fn ?
                            ( /**
                             * @param {?} index
                             * @param {?} item
                             * @return {?}
                             */function (index, item) { return fn(index + (_this._renderedRange ? _this._renderedRange.start : 0), item); }) :
                            undefined;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkVirtualForOf.prototype, "cdkVirtualForTemplate", {
                    /**
                     * The template used to stamp out new elements.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value) {
                            this._needsUpdate = true;
                            this._template = value;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Measures the combined size (width for horizontal orientation, height for vertical) of all items
                 * in the specified range. Throws an error if the range includes items that are not currently
                 * rendered.
                 * @param {?} range
                 * @param {?} orientation
                 * @return {?}
                 */
                CdkVirtualForOf.prototype.measureRangeSize = function (range, orientation) {
                    if (range.start >= range.end) {
                        return 0;
                    }
                    if (range.start < this._renderedRange.start || range.end > this._renderedRange.end) {
                        throw Error("Error: attempted to measure an item that isn't rendered.");
                    }
                    // The index into the list of rendered views for the first item in the range.
                    /** @type {?} */
                    var renderedStartIndex = range.start - this._renderedRange.start;
                    // The length of the range we're measuring.
                    /** @type {?} */
                    var rangeLen = range.end - range.start;
                    // Loop over all root nodes for all items in the range and sum up their size.
                    /** @type {?} */
                    var totalSize = 0;
                    /** @type {?} */
                    var i = rangeLen;
                    while (i--) {
                        /** @type {?} */
                        var view = ( /** @type {?} */(this._viewContainerRef.get(i + renderedStartIndex)));
                        /** @type {?} */
                        var j = view ? view.rootNodes.length : 0;
                        while (j--) {
                            totalSize += getSize(orientation, ( /** @type {?} */(view)).rootNodes[j]);
                        }
                    }
                    return totalSize;
                };
                /**
                 * @return {?}
                 */
                CdkVirtualForOf.prototype.ngDoCheck = function () {
                    if (this._differ && this._needsUpdate) {
                        // TODO(mmalerba): We should differentiate needs update due to scrolling and a new portion of
                        // this list being rendered (can use simpler algorithm) vs needs update due to data actually
                        // changing (need to do this diff).
                        /** @type {?} */
                        var changes = this._differ.diff(this._renderedItems);
                        if (!changes) {
                            this._updateContext();
                        }
                        else {
                            this._applyChanges(changes);
                        }
                        this._needsUpdate = false;
                    }
                };
                /**
                 * @return {?}
                 */
                CdkVirtualForOf.prototype.ngOnDestroy = function () {
                    this._viewport.detach();
                    this._dataSourceChanges.next();
                    this._dataSourceChanges.complete();
                    this.viewChange.complete();
                    this._destroyed.next();
                    this._destroyed.complete();
                    for (var _c = 0, _d = this._templateCache; _c < _d.length; _c++) {
                        var view = _d[_c];
                        view.destroy();
                    }
                };
                /**
                 * React to scroll state changes in the viewport.
                 * @private
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._onRenderedDataChange = function () {
                    if (!this._renderedRange) {
                        return;
                    }
                    this._renderedItems = this._data.slice(this._renderedRange.start, this._renderedRange.end);
                    if (!this._differ) {
                        this._differ = this._differs.find(this._renderedItems).create(this.cdkVirtualForTrackBy);
                    }
                    this._needsUpdate = true;
                };
                /**
                 * Swap out one `DataSource` for another.
                 * @private
                 * @param {?} oldDs
                 * @param {?} newDs
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._changeDataSource = function (oldDs, newDs) {
                    if (oldDs) {
                        oldDs.disconnect(this);
                    }
                    this._needsUpdate = true;
                    return newDs ? newDs.connect(this) : Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])();
                };
                /**
                 * Update the `CdkVirtualForOfContext` for all views.
                 * @private
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._updateContext = function () {
                    /** @type {?} */
                    var count = this._data.length;
                    /** @type {?} */
                    var i = this._viewContainerRef.length;
                    while (i--) {
                        /** @type {?} */
                        var view = ( /** @type {?} */(this._viewContainerRef.get(i)));
                        view.context.index = this._renderedRange.start + i;
                        view.context.count = count;
                        this._updateComputedContextProperties(view.context);
                        view.detectChanges();
                    }
                };
                /**
                 * Apply changes to the DOM.
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._applyChanges = function (changes) {
                    var _this = this;
                    // Rearrange the views to put them in the right location.
                    changes.forEachOperation(( /**
                     * @param {?} record
                     * @param {?} adjustedPreviousIndex
                     * @param {?} currentIndex
                     * @return {?}
                     */function (record, adjustedPreviousIndex, currentIndex) {
                        if (record.previousIndex == null) { // Item added.
                            // Item added.
                            /** @type {?} */
                            var view = _this._insertViewForNewItem(( /** @type {?} */(currentIndex)));
                            view.context.$implicit = record.item;
                        }
                        else if (currentIndex == null) { // Item removed.
                            _this._cacheView(_this._detachView(( /** @type {?} */(adjustedPreviousIndex))));
                        }
                        else { // Item moved.
                            // Item moved.
                            /** @type {?} */
                            var view = ( /** @type {?} */(_this._viewContainerRef.get(( /** @type {?} */(adjustedPreviousIndex)))));
                            _this._viewContainerRef.move(view, currentIndex);
                            view.context.$implicit = record.item;
                        }
                    }));
                    // Update $implicit for any items that had an identity change.
                    changes.forEachIdentityChange(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) {
                        /** @type {?} */
                        var view = ( /** @type {?} */(_this._viewContainerRef.get(( /** @type {?} */(record.currentIndex)))));
                        view.context.$implicit = record.item;
                    }));
                    // Update the context variables on all items.
                    /** @type {?} */
                    var count = this._data.length;
                    /** @type {?} */
                    var i = this._viewContainerRef.length;
                    while (i--) {
                        /** @type {?} */
                        var view = ( /** @type {?} */(this._viewContainerRef.get(i)));
                        view.context.index = this._renderedRange.start + i;
                        view.context.count = count;
                        this._updateComputedContextProperties(view.context);
                    }
                };
                /**
                 * Cache the given detached view.
                 * @private
                 * @param {?} view
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._cacheView = function (view) {
                    if (this._templateCache.length < this.cdkVirtualForTemplateCacheSize) {
                        this._templateCache.push(view);
                    }
                    else {
                        /** @type {?} */
                        var index = this._viewContainerRef.indexOf(view);
                        // It's very unlikely that the index will ever be -1, but just in case,
                        // destroy the view on its own, otherwise destroy it through the
                        // container to ensure that all the references are removed.
                        if (index === -1) {
                            view.destroy();
                        }
                        else {
                            this._viewContainerRef.remove(index);
                        }
                    }
                };
                /**
                 * Inserts a view for a new item, either from the cache or by creating a new one.
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._insertViewForNewItem = function (index) {
                    return this._insertViewFromCache(index) || this._createEmbeddedViewAt(index);
                };
                /**
                 * Update the computed properties on the `CdkVirtualForOfContext`.
                 * @private
                 * @param {?} context
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._updateComputedContextProperties = function (context) {
                    context.first = context.index === 0;
                    context.last = context.index === context.count - 1;
                    context.even = context.index % 2 === 0;
                    context.odd = !context.even;
                };
                /**
                 * Creates a new embedded view and moves it to the given index
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._createEmbeddedViewAt = function (index) {
                    // Note that it's important that we insert the item directly at the proper index,
                    // rather than inserting it and the moving it in place, because if there's a directive
                    // on the same node that injects the `ViewContainerRef`, Angular will insert another
                    // comment node which can throw off the move when it's being repeated for all items.
                    return this._viewContainerRef.createEmbeddedView(this._template, {
                        $implicit: ( /** @type {?} */(null)),
                        cdkVirtualForOf: this._cdkVirtualForOf,
                        index: -1,
                        count: -1,
                        first: false,
                        last: false,
                        odd: false,
                        even: false
                    }, index);
                };
                /**
                 * Inserts a recycled view from the cache at the given index.
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._insertViewFromCache = function (index) {
                    /** @type {?} */
                    var cachedView = this._templateCache.pop();
                    if (cachedView) {
                        this._viewContainerRef.insert(cachedView, index);
                    }
                    return cachedView || null;
                };
                /**
                 * Detaches the embedded view at the given index.
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                CdkVirtualForOf.prototype._detachView = function (index) {
                    return ( /** @type {?} */(this._viewContainerRef.detach(index)));
                };
                return CdkVirtualForOf;
            }());
            CdkVirtualForOf.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkVirtualFor][cdkVirtualForOf]',
                        },] },
            ];
            /** @nocollapse */
            CdkVirtualForOf.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["IterableDiffers"] },
                { type: CdkVirtualScrollViewport, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] }
            ]; };
            CdkVirtualForOf.propDecorators = {
                cdkVirtualForOf: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                cdkVirtualForTrackBy: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                cdkVirtualForTemplate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                cdkVirtualForTemplateCacheSize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ScrollingModule = /** @class */ (function () {
                function ScrollingModule() {
                }
                return ScrollingModule;
            }());
            ScrollingModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["BidiModule"], _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["PlatformModule"]],
                            exports: [
                                _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["BidiModule"],
                                CdkFixedSizeVirtualScroll,
                                CdkScrollable,
                                CdkVirtualForOf,
                                CdkVirtualScrollViewport,
                            ],
                            declarations: [
                                CdkFixedSizeVirtualScroll,
                                CdkScrollable,
                                CdkVirtualForOf,
                                CdkVirtualScrollViewport,
                            ],
                        },] },
            ];
            /**
             * @deprecated ScrollDispatchModule has been renamed to ScrollingModule.
             * \@breaking-change 8.0.0 delete this alias
             */
            var ScrollDispatchModule = /** @class */ (function () {
                function ScrollDispatchModule() {
                }
                return ScrollDispatchModule;
            }());
            ScrollDispatchModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [ScrollingModule],
                            exports: [ScrollingModule],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Time in ms to throttle the resize events by default.
             * @type {?}
             */
            var DEFAULT_RESIZE_TIME = 20;
            /**
             * Simple utility for getting the bounds of the browser viewport.
             * \@docs-private
             */
            var ViewportRuler = /** @class */ (function () {
                /**
                 * @param {?} _platform
                 * @param {?} ngZone
                 */
                function ViewportRuler(_platform, ngZone) {
                    var _this = this;
                    this._platform = _platform;
                    ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._change = _platform.isBrowser ?
                            Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["merge"])(Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["fromEvent"])(window, 'resize'), Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["fromEvent"])(window, 'orientationchange')) :
                            Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])();
                        // Note that we need to do the subscription inside `runOutsideAngular`
                        // since subscribing is what causes the event listener to be added.
                        _this._invalidateCache = _this.change().subscribe(( /**
                         * @return {?}
                         */function () { return _this._updateViewportSize(); }));
                    }));
                }
                /**
                 * @return {?}
                 */
                ViewportRuler.prototype.ngOnDestroy = function () {
                    this._invalidateCache.unsubscribe();
                };
                /**
                 * Returns the viewport's width and height.
                 * @return {?}
                 */
                ViewportRuler.prototype.getViewportSize = function () {
                    if (!this._viewportSize) {
                        this._updateViewportSize();
                    }
                    /** @type {?} */
                    var output = { width: this._viewportSize.width, height: this._viewportSize.height };
                    // If we're not on a browser, don't cache the size since it'll be mocked out anyway.
                    if (!this._platform.isBrowser) {
                        this._viewportSize = ( /** @type {?} */(null));
                    }
                    return output;
                };
                /**
                 * Gets a ClientRect for the viewport's bounds.
                 * @return {?}
                 */
                ViewportRuler.prototype.getViewportRect = function () {
                    // Use the document element's bounding rect rather than the window scroll properties
                    // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
                    // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
                    // conceptual viewports. Under most circumstances these viewports are equivalent, but they
                    // can disagree when the page is pinch-zoomed (on devices that support touch).
                    // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
                    // We use the documentElement instead of the body because, by default (without a css reset)
                    // browsers typically give the document body an 8px margin, which is not included in
                    // getBoundingClientRect().
                    /** @type {?} */
                    var scrollPosition = this.getViewportScrollPosition();
                    var _c = this.getViewportSize(), width = _c.width, height = _c.height;
                    return {
                        top: scrollPosition.top,
                        left: scrollPosition.left,
                        bottom: scrollPosition.top + height,
                        right: scrollPosition.left + width,
                        height: height,
                        width: width,
                    };
                };
                /**
                 * Gets the (top, left) scroll position of the viewport.
                 * @return {?}
                 */
                ViewportRuler.prototype.getViewportScrollPosition = function () {
                    // While we can get a reference to the fake document
                    // during SSR, it doesn't have getBoundingClientRect.
                    if (!this._platform.isBrowser) {
                        return { top: 0, left: 0 };
                    }
                    // The top-left-corner of the viewport is determined by the scroll position of the document
                    // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
                    // whether `document.body` or `document.documentElement` is the scrolled element, so reading
                    // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
                    // `document.documentElement` works consistently, where the `top` and `left` values will
                    // equal negative the scroll position.
                    /** @type {?} */
                    var documentElement = ( /** @type {?} */(document.documentElement));
                    /** @type {?} */
                    var documentRect = documentElement.getBoundingClientRect();
                    /** @type {?} */
                    var top = -documentRect.top || document.body.scrollTop || window.scrollY ||
                        documentElement.scrollTop || 0;
                    /** @type {?} */
                    var left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
                        documentElement.scrollLeft || 0;
                    return { top: top, left: left };
                };
                /**
                 * Returns a stream that emits whenever the size of the viewport changes.
                 * @param {?=} throttleTime Time in milliseconds to throttle the stream.
                 * @return {?}
                 */
                ViewportRuler.prototype.change = function (throttleTime) {
                    if (throttleTime === void 0) { throttleTime = DEFAULT_RESIZE_TIME; }
                    return throttleTime > 0 ? this._change.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["auditTime"])(throttleTime)) : this._change;
                };
                /**
                 * Updates the cached viewport size.
                 * @private
                 * @return {?}
                 */
                ViewportRuler.prototype._updateViewportSize = function () {
                    this._viewportSize = this._platform.isBrowser ?
                        { width: window.innerWidth, height: window.innerHeight } :
                        { width: 0, height: 0 };
                };
                return ViewportRuler;
            }());
            ViewportRuler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            ViewportRuler.ctorParameters = function () { return [
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] }
            ]; };
            /** @nocollapse */ ViewportRuler.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function ViewportRuler_Factory() { return new ViewportRuler(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"])); }, token: ViewportRuler, providedIn: "root" });
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @param {?} parentRuler
             * @param {?} platform
             * @param {?} ngZone
             * @return {?}
             */
            function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, platform, ngZone) {
                return parentRuler || new ViewportRuler(platform, ngZone);
            }
            /**
             * \@docs-private \@deprecated \@breaking-change 8.0.0
             * @type {?}
             */
            var VIEWPORT_RULER_PROVIDER = {
                // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
                provide: ViewportRuler,
                deps: [[new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"](), ViewportRuler], _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"], _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"]],
                useFactory: VIEWPORT_RULER_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=scrolling.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/stepper.js": 
        /*!******************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/stepper.js ***!
          \******************************************************/
        /*! exports provided: StepperSelectionEvent, STEP_STATE, STEPPER_GLOBAL_OPTIONS, MAT_STEPPER_GLOBAL_OPTIONS, CdkStep, CdkStepper, CdkStepLabel, CdkStepperNext, CdkStepperPrevious, CdkStepperModule, CdkStepHeader */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StepperSelectionEvent", function () { return StepperSelectionEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STEP_STATE", function () { return STEP_STATE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STEPPER_GLOBAL_OPTIONS", function () { return STEPPER_GLOBAL_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_STEPPER_GLOBAL_OPTIONS", function () { return MAT_STEPPER_GLOBAL_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStep", function () { return CdkStep; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStepper", function () { return CdkStepper; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStepLabel", function () { return CdkStepLabel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStepperNext", function () { return CdkStepperNext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStepperPrevious", function () { return CdkStepperPrevious; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStepperModule", function () { return CdkStepperModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkStepHeader", function () { return CdkStepHeader; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var CdkStepHeader = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function CdkStepHeader(_elementRef) {
                    this._elementRef = _elementRef;
                }
                /**
                 * Focuses the step header.
                 * @return {?}
                 */
                CdkStepHeader.prototype.focus = function () {
                    this._elementRef.nativeElement.focus();
                };
                return CdkStepHeader;
            }());
            CdkStepHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkStepHeader]',
                            host: {
                                'role': 'tab',
                            },
                        },] },
            ];
            /** @nocollapse */
            CdkStepHeader.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var CdkStepLabel = /** @class */ (function () {
                /**
                 * @param {?} template
                 */
                function CdkStepLabel(/** @docs-private */ template) {
                    this.template = template;
                }
                return CdkStepLabel;
            }());
            CdkStepLabel.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkStepLabel]',
                        },] },
            ];
            /** @nocollapse */
            CdkStepLabel.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to generate unique ID for each stepper component.
             * @type {?}
             */
            var nextId = 0;
            /**
             * Change event emitted on selection changes.
             */
            var StepperSelectionEvent = /** @class */ (function () {
                function StepperSelectionEvent() {
                }
                return StepperSelectionEvent;
            }());
            /**
             * Enum to represent the different states of the steps.
             * @type {?}
             */
            var STEP_STATE = {
                NUMBER: 'number',
                EDIT: 'edit',
                DONE: 'done',
                ERROR: 'error'
            };
            /**
             * InjectionToken that can be used to specify the global stepper options.
             * @type {?}
             */
            var STEPPER_GLOBAL_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('STEPPER_GLOBAL_OPTIONS');
            /**
             * InjectionToken that can be used to specify the global stepper options.
             * @deprecated Use `STEPPER_GLOBAL_OPTIONS` instead.
             * \@breaking-change 8.0.0.
             * @type {?}
             */
            var MAT_STEPPER_GLOBAL_OPTIONS = STEPPER_GLOBAL_OPTIONS;
            var CdkStep = /** @class */ (function () {
                /**
                 * \@breaking-change 8.0.0 remove the `?` after `stepperOptions`
                 * @param {?} _stepper
                 * @param {?=} stepperOptions
                 */
                function CdkStep(_stepper, stepperOptions) {
                    this._stepper = _stepper;
                    /**
                     * Whether user has seen the expanded step content or not.
                     */
                    this.interacted = false;
                    this._editable = true;
                    this._optional = false;
                    this._completedOverride = null;
                    this._customError = null;
                    this._stepperOptions = stepperOptions ? stepperOptions : {};
                    this._displayDefaultIndicatorType = this._stepperOptions.displayDefaultIndicatorType !== false;
                    this._showError = !!this._stepperOptions.showError;
                }
                Object.defineProperty(CdkStep.prototype, "editable", {
                    /**
                     * Whether the user can return to this step once it has been marked as completed.
                     * @return {?}
                     */
                    get: function () {
                        return this._editable;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._editable = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkStep.prototype, "optional", {
                    /**
                     * Whether the completion of step is optional.
                     * @return {?}
                     */
                    get: function () {
                        return this._optional;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._optional = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkStep.prototype, "completed", {
                    /**
                     * Whether step is marked as completed.
                     * @return {?}
                     */
                    get: function () {
                        return this._completedOverride == null ? this._getDefaultCompleted() : this._completedOverride;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._completedOverride = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @return {?}
                 */
                CdkStep.prototype._getDefaultCompleted = function () {
                    return this.stepControl ? this.stepControl.valid && this.interacted : this.interacted;
                };
                Object.defineProperty(CdkStep.prototype, "hasError", {
                    /**
                     * Whether step has an error.
                     * @return {?}
                     */
                    get: function () {
                        return this._customError == null ? this._getDefaultError() : this._customError;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._customError = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @return {?}
                 */
                CdkStep.prototype._getDefaultError = function () {
                    return this.stepControl && this.stepControl.invalid && this.interacted;
                };
                /**
                 * Selects this step component.
                 * @return {?}
                 */
                CdkStep.prototype.select = function () {
                    this._stepper.selected = this;
                };
                /**
                 * Resets the step to its initial state. Note that this includes resetting form data.
                 * @return {?}
                 */
                CdkStep.prototype.reset = function () {
                    this.interacted = false;
                    if (this._completedOverride != null) {
                        this._completedOverride = false;
                    }
                    if (this._customError != null) {
                        this._customError = false;
                    }
                    if (this.stepControl) {
                        this.stepControl.reset();
                    }
                };
                /**
                 * @return {?}
                 */
                CdkStep.prototype.ngOnChanges = function () {
                    // Since basically all inputs of the MatStep get proxied through the view down to the
                    // underlying MatStepHeader, we have to make sure that change detection runs correctly.
                    this._stepper._stateChanged();
                };
                return CdkStep;
            }());
            CdkStep.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'cdk-step',
                            exportAs: 'cdkStep',
                            template: '<ng-template><ng-content></ng-content></ng-template>',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            CdkStep.ctorParameters = function () { return [
                { type: CdkStepper, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return CdkStepper; })),] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [STEPPER_GLOBAL_OPTIONS,] }] }
            ]; };
            CdkStep.propDecorators = {
                stepLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [CdkStepLabel, { static: false },] }],
                content: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"], { static: true },] }],
                stepControl: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                label: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                errorMessage: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-labelledby',] }],
                state: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                editable: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                optional: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                completed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                hasError: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            var CdkStepper = /** @class */ (function () {
                /**
                 * @param {?} _dir
                 * @param {?} _changeDetectorRef
                 * @param {?=} _elementRef
                 * @param {?=} _document
                 */
                function CdkStepper(_dir, _changeDetectorRef, _elementRef, _document) {
                    this._dir = _dir;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._elementRef = _elementRef;
                    /**
                     * Emits when the component is destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    this._linear = false;
                    this._selectedIndex = 0;
                    /**
                     * Event emitted when the selected step has changed.
                     */
                    this.selectionChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this._orientation = 'horizontal';
                    this._groupId = nextId++;
                    this._document = _document;
                }
                Object.defineProperty(CdkStepper.prototype, "steps", {
                    /**
                     * The list of step components that the stepper is holding.
                     * @return {?}
                     */
                    get: function () {
                        return this._steps;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkStepper.prototype, "linear", {
                    /**
                     * Whether the validity of previous steps should be checked or not.
                     * @return {?}
                     */
                    get: function () {
                        return this._linear;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._linear = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkStepper.prototype, "selectedIndex", {
                    /**
                     * The index of the selected step.
                     * @return {?}
                     */
                    get: function () {
                        return this._selectedIndex;
                    },
                    /**
                     * @param {?} index
                     * @return {?}
                     */
                    set: function (index) {
                        /** @type {?} */
                        var newIndex = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceNumberProperty"])(index);
                        if (this.steps) {
                            // Ensure that the index can't be out of bounds.
                            if (newIndex < 0 || newIndex > this.steps.length - 1) {
                                throw Error('cdkStepper: Cannot assign out-of-bounds value to `selectedIndex`.');
                            }
                            if (this._selectedIndex != newIndex && !this._anyControlsInvalidOrPending(newIndex) &&
                                (newIndex >= this._selectedIndex || this.steps.toArray()[newIndex].editable)) {
                                this._updateSelectedItemIndex(index);
                            }
                        }
                        else {
                            this._selectedIndex = newIndex;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkStepper.prototype, "selected", {
                    /**
                     * The step that is selected.
                     * @return {?}
                     */
                    get: function () {
                        // @breaking-change 8.0.0 Change return type to `CdkStep | undefined`.
                        return this.steps ? this.steps.toArray()[this.selectedIndex] : ( /** @type {?} */(undefined));
                    },
                    /**
                     * @param {?} step
                     * @return {?}
                     */
                    set: function (step) {
                        this.selectedIndex = this.steps ? this.steps.toArray().indexOf(step) : -1;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkStepper.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    // Note that while the step headers are content children by default, any components that
                    // extend this one might have them as view chidren. We initialize the keyboard handling in
                    // AfterViewInit so we're guaranteed for both view and content children to be defined.
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["FocusKeyManager"](this._stepHeader)
                        .withWrap()
                        .withVerticalOrientation(this._orientation === 'vertical');
                    (this._dir ? (( /** @type {?} */(this._dir.change))) : Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["of"])())
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(this._layoutDirection()), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @param {?} direction
                 * @return {?}
                 */function (/**
                 * @param {?} direction
                 * @return {?}
                 */ direction) { return _this._keyManager.withHorizontalOrientation(direction); }));
                    this._keyManager.updateActiveItemIndex(this._selectedIndex);
                    this.steps.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () {
                        if (!_this.selected) {
                            _this._selectedIndex = Math.max(_this._selectedIndex - 1, 0);
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                CdkStepper.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Selects and focuses the next step in list.
                 * @return {?}
                 */
                CdkStepper.prototype.next = function () {
                    this.selectedIndex = Math.min(this._selectedIndex + 1, this.steps.length - 1);
                };
                /**
                 * Selects and focuses the previous step in list.
                 * @return {?}
                 */
                CdkStepper.prototype.previous = function () {
                    this.selectedIndex = Math.max(this._selectedIndex - 1, 0);
                };
                /**
                 * Resets the stepper to its initial state. Note that this includes clearing form data.
                 * @return {?}
                 */
                CdkStepper.prototype.reset = function () {
                    this._updateSelectedItemIndex(0);
                    this.steps.forEach(( /**
                     * @param {?} step
                     * @return {?}
                     */function (/**
                     * @param {?} step
                     * @return {?}
                     */ step) { return step.reset(); }));
                    this._stateChanged();
                };
                /**
                 * Returns a unique id for each step label element.
                 * @param {?} i
                 * @return {?}
                 */
                CdkStepper.prototype._getStepLabelId = function (i) {
                    return "cdk-step-label-" + this._groupId + "-" + i;
                };
                /**
                 * Returns unique id for each step content element.
                 * @param {?} i
                 * @return {?}
                 */
                CdkStepper.prototype._getStepContentId = function (i) {
                    return "cdk-step-content-" + this._groupId + "-" + i;
                };
                /**
                 * Marks the component to be change detected.
                 * @return {?}
                 */
                CdkStepper.prototype._stateChanged = function () {
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Returns position state of the step with the given index.
                 * @param {?} index
                 * @return {?}
                 */
                CdkStepper.prototype._getAnimationDirection = function (index) {
                    /** @type {?} */
                    var position = index - this._selectedIndex;
                    if (position < 0) {
                        return this._layoutDirection() === 'rtl' ? 'next' : 'previous';
                    }
                    else if (position > 0) {
                        return this._layoutDirection() === 'rtl' ? 'previous' : 'next';
                    }
                    return 'current';
                };
                /**
                 * Returns the type of icon to be displayed.
                 * @param {?} index
                 * @param {?=} state
                 * @return {?}
                 */
                CdkStepper.prototype._getIndicatorType = function (index, state) {
                    if (state === void 0) { state = STEP_STATE.NUMBER; }
                    /** @type {?} */
                    var step = this.steps.toArray()[index];
                    /** @type {?} */
                    var isCurrentStep = this._isCurrentStep(index);
                    return step._displayDefaultIndicatorType ? this._getDefaultIndicatorLogic(step, isCurrentStep) :
                        this._getGuidelineLogic(step, isCurrentStep, state);
                };
                /**
                 * @private
                 * @param {?} step
                 * @param {?} isCurrentStep
                 * @return {?}
                 */
                CdkStepper.prototype._getDefaultIndicatorLogic = function (step, isCurrentStep) {
                    if (step._showError && step.hasError && !isCurrentStep) {
                        return STEP_STATE.ERROR;
                    }
                    else if (!step.completed || isCurrentStep) {
                        return STEP_STATE.NUMBER;
                    }
                    else {
                        return step.editable ? STEP_STATE.EDIT : STEP_STATE.DONE;
                    }
                };
                /**
                 * @private
                 * @param {?} step
                 * @param {?} isCurrentStep
                 * @param {?=} state
                 * @return {?}
                 */
                CdkStepper.prototype._getGuidelineLogic = function (step, isCurrentStep, state) {
                    if (state === void 0) { state = STEP_STATE.NUMBER; }
                    if (step._showError && step.hasError && !isCurrentStep) {
                        return STEP_STATE.ERROR;
                    }
                    else if (step.completed && !isCurrentStep) {
                        return STEP_STATE.DONE;
                    }
                    else if (step.completed && isCurrentStep) {
                        return state;
                    }
                    else if (step.editable && isCurrentStep) {
                        return STEP_STATE.EDIT;
                    }
                    else {
                        return state;
                    }
                };
                /**
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                CdkStepper.prototype._isCurrentStep = function (index) {
                    return this._selectedIndex === index;
                };
                /**
                 * Returns the index of the currently-focused step header.
                 * @return {?}
                 */
                CdkStepper.prototype._getFocusIndex = function () {
                    return this._keyManager ? this._keyManager.activeItemIndex : this._selectedIndex;
                };
                /**
                 * @private
                 * @param {?} newIndex
                 * @return {?}
                 */
                CdkStepper.prototype._updateSelectedItemIndex = function (newIndex) {
                    /** @type {?} */
                    var stepsArray = this.steps.toArray();
                    this.selectionChange.emit({
                        selectedIndex: newIndex,
                        previouslySelectedIndex: this._selectedIndex,
                        selectedStep: stepsArray[newIndex],
                        previouslySelectedStep: stepsArray[this._selectedIndex],
                    });
                    // If focus is inside the stepper, move it to the next header, otherwise it may become
                    // lost when the active step content is hidden. We can't be more granular with the check
                    // (e.g. checking whether focus is inside the active step), because we don't have a
                    // reference to the elements that are rendering out the content.
                    this._containsFocus() ? this._keyManager.setActiveItem(newIndex) :
                        this._keyManager.updateActiveItemIndex(newIndex);
                    this._selectedIndex = newIndex;
                    this._stateChanged();
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                CdkStepper.prototype._onKeydown = function (event) {
                    /** @type {?} */
                    var hasModifier = Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["hasModifierKey"])(event);
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var manager = this._keyManager;
                    if (manager.activeItemIndex != null && !hasModifier &&
                        (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["SPACE"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["ENTER"])) {
                        this.selectedIndex = manager.activeItemIndex;
                        event.preventDefault();
                    }
                    else if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["HOME"]) {
                        manager.setFirstItemActive();
                        event.preventDefault();
                    }
                    else if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["END"]) {
                        manager.setLastItemActive();
                        event.preventDefault();
                    }
                    else {
                        manager.onKeydown(event);
                    }
                };
                /**
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                CdkStepper.prototype._anyControlsInvalidOrPending = function (index) {
                    /** @type {?} */
                    var steps = this.steps.toArray();
                    steps[this._selectedIndex].interacted = true;
                    if (this._linear && index >= 0) {
                        return steps.slice(0, index).some(( /**
                         * @param {?} step
                         * @return {?}
                         */function (/**
                         * @param {?} step
                         * @return {?}
                         */ step) {
                            /** @type {?} */
                            var control = step.stepControl;
                            /** @type {?} */
                            var isIncomplete = control ? (control.invalid || control.pending || !step.interacted) : !step.completed;
                            return isIncomplete && !step.optional && !step._completedOverride;
                        }));
                    }
                    return false;
                };
                /**
                 * @private
                 * @return {?}
                 */
                CdkStepper.prototype._layoutDirection = function () {
                    return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
                };
                /**
                 * Checks whether the stepper contains the focused element.
                 * @private
                 * @return {?}
                 */
                CdkStepper.prototype._containsFocus = function () {
                    if (!this._document || !this._elementRef) {
                        return false;
                    }
                    /** @type {?} */
                    var stepperElement = this._elementRef.nativeElement;
                    /** @type {?} */
                    var focusedElement = this._document.activeElement;
                    return stepperElement === focusedElement || stepperElement.contains(focusedElement);
                };
                return CdkStepper;
            }());
            CdkStepper.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[cdkStepper]',
                            exportAs: 'cdkStepper',
                        },] },
            ];
            /** @nocollapse */
            CdkStepper.ctorParameters = function () { return [
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"],] }] }
            ]; };
            CdkStepper.propDecorators = {
                _steps: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [CdkStep,] }],
                _stepHeader: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [CdkStepHeader,] }],
                linear: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectionChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Button that moves to the next step in a stepper workflow.
             */
            var CdkStepperNext = /** @class */ (function () {
                /**
                 * @param {?} _stepper
                 */
                function CdkStepperNext(_stepper) {
                    this._stepper = _stepper;
                    /**
                     * Type of the next button. Defaults to "submit" if not specified.
                     */
                    this.type = 'submit';
                }
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                /**
                 * @return {?}
                 */
                CdkStepperNext.prototype._handleClick = function () {
                    this._stepper.next();
                };
                return CdkStepperNext;
            }());
            CdkStepperNext.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'button[cdkStepperNext]',
                            host: {
                                '[type]': 'type',
                            }
                        },] },
            ];
            /** @nocollapse */
            CdkStepperNext.ctorParameters = function () { return [
                { type: CdkStepper }
            ]; };
            CdkStepperNext.propDecorators = {
                type: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                _handleClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"], args: ['click',] }]
            };
            /**
             * Button that moves to the previous step in a stepper workflow.
             */
            var CdkStepperPrevious = /** @class */ (function () {
                /**
                 * @param {?} _stepper
                 */
                function CdkStepperPrevious(_stepper) {
                    this._stepper = _stepper;
                    /**
                     * Type of the previous button. Defaults to "button" if not specified.
                     */
                    this.type = 'button';
                }
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                /**
                 * @return {?}
                 */
                CdkStepperPrevious.prototype._handleClick = function () {
                    this._stepper.previous();
                };
                return CdkStepperPrevious;
            }());
            CdkStepperPrevious.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'button[cdkStepperPrevious]',
                            host: {
                                '[type]': 'type',
                            }
                        },] },
            ];
            /** @nocollapse */
            CdkStepperPrevious.ctorParameters = function () { return [
                { type: CdkStepper }
            ]; };
            CdkStepperPrevious.propDecorators = {
                type: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                _handleClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"], args: ['click',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var CdkStepperModule = /** @class */ (function () {
                function CdkStepperModule() {
                }
                return CdkStepperModule;
            }());
            CdkStepperModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["BidiModule"], _angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"]],
                            exports: [
                                CdkStep,
                                CdkStepper,
                                CdkStepHeader,
                                CdkStepLabel,
                                CdkStepperNext,
                                CdkStepperPrevious,
                            ],
                            declarations: [
                                CdkStep,
                                CdkStepper,
                                CdkStepHeader,
                                CdkStepLabel,
                                CdkStepperNext,
                                CdkStepperPrevious,
                            ]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=stepper.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/table.js": 
        /*!****************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/table.js ***!
          \****************************************************/
        /*! exports provided: DataSource, DataRowOutlet, HeaderRowOutlet, FooterRowOutlet, CDK_TABLE_TEMPLATE, CdkTable, CdkCellDef, CdkHeaderCellDef, CdkFooterCellDef, CdkColumnDef, BaseCdkCell, CdkHeaderCell, CdkFooterCell, CdkCell, CDK_ROW_TEMPLATE, BaseRowDef, CdkHeaderRowDef, CdkFooterRowDef, CdkRowDef, CdkCellOutlet, CdkHeaderRow, CdkFooterRow, CdkRow, CdkTableModule, STICKY_DIRECTIONS, StickyStyler, mixinHasStickyInput, TEXT_COLUMN_OPTIONS, CdkTextColumn */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataRowOutlet", function () { return DataRowOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderRowOutlet", function () { return HeaderRowOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterRowOutlet", function () { return FooterRowOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_TABLE_TEMPLATE", function () { return CDK_TABLE_TEMPLATE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTable", function () { return CdkTable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkCellDef", function () { return CdkCellDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderCellDef", function () { return CdkHeaderCellDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterCellDef", function () { return CdkFooterCellDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkColumnDef", function () { return CdkColumnDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseCdkCell", function () { return BaseCdkCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderCell", function () { return CdkHeaderCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterCell", function () { return CdkFooterCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkCell", function () { return CdkCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_ROW_TEMPLATE", function () { return CDK_ROW_TEMPLATE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseRowDef", function () { return BaseRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderRowDef", function () { return CdkHeaderRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterRowDef", function () { return CdkFooterRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkRowDef", function () { return CdkRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkCellOutlet", function () { return CdkCellOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderRow", function () { return CdkHeaderRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterRow", function () { return CdkFooterRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkRow", function () { return CdkRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTableModule", function () { return CdkTableModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STICKY_DIRECTIONS", function () { return STICKY_DIRECTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StickyStyler", function () { return StickyStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinHasStickyInput", function () { return mixinHasStickyInput; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_COLUMN_OPTIONS", function () { return TEXT_COLUMN_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTextColumn", function () { return CdkTextColumn; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataSource", function () { return _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["DataSource"]; });
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to provide a directive with a function that checks if the sticky input has been
             * changed since the last time the function was called. Essentially adds a dirty-check to the
             * sticky value.
             * \@docs-private
             * @template T
             * @param {?} base
             * @return {?}
             */
            function mixinHasStickyInput(base) {
                return /** @class */ (function (_super_1) {
                    __extends(class_1, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_1() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        _this._sticky = false;
                        /**
                         * Whether the sticky input has changed since it was last checked.
                         */
                        _this._hasStickyChanged = false;
                        return _this;
                    }
                    Object.defineProperty(class_1.prototype, "sticky", {
                        /**
                         * Whether sticky positioning should be applied.
                         * @return {?}
                         */
                        get: function () { return this._sticky; },
                        /**
                         * @param {?} v
                         * @return {?}
                         */
                        set: function (v) {
                            /** @type {?} */
                            var prevValue = this._sticky;
                            this._sticky = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(v);
                            this._hasStickyChanged = prevValue !== this._sticky;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    /**
                     * Whether the sticky value has changed since this was last called.
                     * @return {?}
                     */
                    class_1.prototype.hasStickyChanged = function () {
                        /** @type {?} */
                        var hasStickyChanged = this._hasStickyChanged;
                        this._hasStickyChanged = false;
                        return hasStickyChanged;
                    };
                    /**
                     * Resets the dirty check for cases where the sticky state has been used without checking.
                     * @return {?}
                     */
                    class_1.prototype.resetStickyChanged = function () {
                        this._hasStickyChanged = false;
                    };
                    return class_1;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Cell definition for a CDK table.
             * Captures the template of a column's data row cell as well as cell-specific properties.
             */
            var CdkCellDef = /** @class */ (function () {
                /**
                 * @param {?} template
                 */
                function CdkCellDef(/** @docs-private */ template) {
                    this.template = template;
                }
                return CdkCellDef;
            }());
            CdkCellDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[cdkCellDef]' },] },
            ];
            /** @nocollapse */
            CdkCellDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"] }
            ]; };
            /**
             * Header cell definition for a CDK table.
             * Captures the template of a column's header cell and as well as cell-specific properties.
             */
            var CdkHeaderCellDef = /** @class */ (function () {
                /**
                 * @param {?} template
                 */
                function CdkHeaderCellDef(/** @docs-private */ template) {
                    this.template = template;
                }
                return CdkHeaderCellDef;
            }());
            CdkHeaderCellDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[cdkHeaderCellDef]' },] },
            ];
            /** @nocollapse */
            CdkHeaderCellDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"] }
            ]; };
            /**
             * Footer cell definition for a CDK table.
             * Captures the template of a column's footer cell and as well as cell-specific properties.
             */
            var CdkFooterCellDef = /** @class */ (function () {
                /**
                 * @param {?} template
                 */
                function CdkFooterCellDef(/** @docs-private */ template) {
                    this.template = template;
                }
                return CdkFooterCellDef;
            }());
            CdkFooterCellDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[cdkFooterCellDef]' },] },
            ];
            /** @nocollapse */
            CdkFooterCellDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"] }
            ]; };
            // Boilerplate for applying mixins to CdkColumnDef.
            /**
             * \@docs-private
             */
            var CdkColumnDefBase = /** @class */ (function () {
                function CdkColumnDefBase() {
                }
                return CdkColumnDefBase;
            }());
            /** @type {?} */
            var _CdkColumnDefBase = mixinHasStickyInput(CdkColumnDefBase);
            /**
             * Column definition for the CDK table.
             * Defines a set of cells available for a table column.
             */
            var CdkColumnDef = /** @class */ (function (_super_1) {
                __extends(CdkColumnDef, _super_1);
                function CdkColumnDef() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this._stickyEnd = false;
                    return _this;
                }
                Object.defineProperty(CdkColumnDef.prototype, "name", {
                    /**
                     * Unique name for this column.
                     * @return {?}
                     */
                    get: function () {
                        return this._name;
                    },
                    /**
                     * @param {?} name
                     * @return {?}
                     */
                    set: function (name) {
                        // If the directive is set without a name (updated programatically), then this setter will
                        // trigger with an empty string and should not overwrite the programatically set value.
                        if (!name) {
                            return;
                        }
                        this._name = name;
                        this.cssClassFriendlyName = name.replace(/[^a-z0-9_-]/ig, '-');
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkColumnDef.prototype, "stickyEnd", {
                    /**
                     * Whether this column should be sticky positioned on the end of the row. Should make sure
                     * that it mimics the `CanStick` mixin such that `_hasStickyChanged` is set to true if the value
                     * has been changed.
                     * @return {?}
                     */
                    get: function () {
                        return this._stickyEnd;
                    },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        /** @type {?} */
                        var prevValue = this._stickyEnd;
                        this._stickyEnd = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(v);
                        this._hasStickyChanged = prevValue !== this._stickyEnd;
                    },
                    enumerable: true,
                    configurable: true
                });
                return CdkColumnDef;
            }(_CdkColumnDefBase));
            CdkColumnDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkColumnDef]',
                            inputs: ['sticky'],
                            providers: [{ provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: CdkColumnDef }],
                        },] },
            ];
            CdkColumnDef.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkColumnDef',] }],
                stickyEnd: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['stickyEnd',] }],
                cell: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChild"], args: [CdkCellDef, { static: false },] }],
                headerCell: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChild"], args: [CdkHeaderCellDef, { static: false },] }],
                footerCell: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChild"], args: [CdkFooterCellDef, { static: false },] }]
            };
            /**
             * Base class for the cells. Adds a CSS classname that identifies the column it renders in.
             */
            var BaseCdkCell = /** @class */ (function () {
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function BaseCdkCell(columnDef, elementRef) {
                    /** @type {?} */
                    var columnClassName = "cdk-column-" + columnDef.cssClassFriendlyName;
                    elementRef.nativeElement.classList.add(columnClassName);
                }
                return BaseCdkCell;
            }());
            /**
             * Header cell template container that adds the right classes and role.
             */
            var CdkHeaderCell = /** @class */ (function (_super_1) {
                __extends(CdkHeaderCell, _super_1);
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function CdkHeaderCell(columnDef, elementRef) {
                    return _super_1.call(this, columnDef, elementRef) || this;
                }
                return CdkHeaderCell;
            }(BaseCdkCell));
            CdkHeaderCell.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'cdk-header-cell, th[cdk-header-cell]',
                            host: {
                                'class': 'cdk-header-cell',
                                'role': 'columnheader',
                            },
                        },] },
            ];
            /** @nocollapse */
            CdkHeaderCell.ctorParameters = function () { return [
                { type: CdkColumnDef },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * Footer cell template container that adds the right classes and role.
             */
            var CdkFooterCell = /** @class */ (function (_super_1) {
                __extends(CdkFooterCell, _super_1);
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function CdkFooterCell(columnDef, elementRef) {
                    return _super_1.call(this, columnDef, elementRef) || this;
                }
                return CdkFooterCell;
            }(BaseCdkCell));
            CdkFooterCell.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'cdk-footer-cell, td[cdk-footer-cell]',
                            host: {
                                'class': 'cdk-footer-cell',
                                'role': 'gridcell',
                            },
                        },] },
            ];
            /** @nocollapse */
            CdkFooterCell.ctorParameters = function () { return [
                { type: CdkColumnDef },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * Cell template container that adds the right classes and role.
             */
            var CdkCell = /** @class */ (function (_super_1) {
                __extends(CdkCell, _super_1);
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function CdkCell(columnDef, elementRef) {
                    return _super_1.call(this, columnDef, elementRef) || this;
                }
                return CdkCell;
            }(BaseCdkCell));
            CdkCell.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'cdk-cell, td[cdk-cell]',
                            host: {
                                'class': 'cdk-cell',
                                'role': 'gridcell',
                            },
                        },] },
            ];
            /** @nocollapse */
            CdkCell.ctorParameters = function () { return [
                { type: CdkColumnDef },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The row template that can be used by the mat-table. Should not be used outside of the
             * material library.
             * @type {?}
             */
            var CDK_ROW_TEMPLATE = "<ng-container cdkCellOutlet></ng-container>";
            /**
             * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
             * for changes and notifying the table.
             * @abstract
             */
            var BaseRowDef = /** @class */ (function () {
                /**
                 * @param {?} template
                 * @param {?} _differs
                 */
                function BaseRowDef(template, _differs) {
                    this.template = template;
                    this._differs = _differs;
                }
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                BaseRowDef.prototype.ngOnChanges = function (changes) {
                    // Create a new columns differ if one does not yet exist. Initialize it based on initial value
                    // of the columns property or an empty array if none is provided.
                    if (!this._columnsDiffer) {
                        /** @type {?} */
                        var columns = (changes['columns'] && changes['columns'].currentValue) || [];
                        this._columnsDiffer = this._differs.find(columns).create();
                        this._columnsDiffer.diff(columns);
                    }
                };
                /**
                 * Returns the difference between the current columns and the columns from the last diff, or null
                 * if there is no difference.
                 * @return {?}
                 */
                BaseRowDef.prototype.getColumnsDiff = function () {
                    return this._columnsDiffer.diff(this.columns);
                };
                /**
                 * Gets this row def's relevant cell template from the provided column def.
                 * @param {?} column
                 * @return {?}
                 */
                BaseRowDef.prototype.extractCellTemplate = function (column) {
                    if (this instanceof CdkHeaderRowDef) {
                        return column.headerCell.template;
                    }
                    if (this instanceof CdkFooterRowDef) {
                        return column.footerCell.template;
                    }
                    else {
                        return column.cell.template;
                    }
                };
                return BaseRowDef;
            }());
            // Boilerplate for applying mixins to CdkHeaderRowDef.
            /**
             * \@docs-private
             */
            var CdkHeaderRowDefBase = /** @class */ (function (_super_1) {
                __extends(CdkHeaderRowDefBase, _super_1);
                function CdkHeaderRowDefBase() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return CdkHeaderRowDefBase;
            }(BaseRowDef));
            /** @type {?} */
            var _CdkHeaderRowDefBase = mixinHasStickyInput(CdkHeaderRowDefBase);
            /**
             * Header row definition for the CDK table.
             * Captures the header row's template and other header properties such as the columns to display.
             */
            var CdkHeaderRowDef = /** @class */ (function (_super_1) {
                __extends(CdkHeaderRowDef, _super_1);
                /**
                 * @param {?} template
                 * @param {?} _differs
                 */
                function CdkHeaderRowDef(template, _differs) {
                    return _super_1.call(this, template, _differs) || this;
                }
                // Prerender fails to recognize that ngOnChanges in a part of this class through inheritance.
                // Explicitly define it so that the method is called as part of the Angular lifecycle.
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                CdkHeaderRowDef.prototype.ngOnChanges = function (changes) {
                    _super_1.prototype.ngOnChanges.call(this, changes);
                };
                return CdkHeaderRowDef;
            }(_CdkHeaderRowDefBase));
            CdkHeaderRowDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkHeaderRowDef]',
                            inputs: ['columns: cdkHeaderRowDef', 'sticky: cdkHeaderRowDefSticky'],
                        },] },
            ];
            /** @nocollapse */
            CdkHeaderRowDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["IterableDiffers"] }
            ]; };
            // Boilerplate for applying mixins to CdkFooterRowDef.
            /**
             * \@docs-private
             */
            var CdkFooterRowDefBase = /** @class */ (function (_super_1) {
                __extends(CdkFooterRowDefBase, _super_1);
                function CdkFooterRowDefBase() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return CdkFooterRowDefBase;
            }(BaseRowDef));
            /** @type {?} */
            var _CdkFooterRowDefBase = mixinHasStickyInput(CdkFooterRowDefBase);
            /**
             * Footer row definition for the CDK table.
             * Captures the footer row's template and other footer properties such as the columns to display.
             */
            var CdkFooterRowDef = /** @class */ (function (_super_1) {
                __extends(CdkFooterRowDef, _super_1);
                /**
                 * @param {?} template
                 * @param {?} _differs
                 */
                function CdkFooterRowDef(template, _differs) {
                    return _super_1.call(this, template, _differs) || this;
                }
                // Prerender fails to recognize that ngOnChanges in a part of this class through inheritance.
                // Explicitly define it so that the method is called as part of the Angular lifecycle.
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                CdkFooterRowDef.prototype.ngOnChanges = function (changes) {
                    _super_1.prototype.ngOnChanges.call(this, changes);
                };
                return CdkFooterRowDef;
            }(_CdkFooterRowDefBase));
            CdkFooterRowDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkFooterRowDef]',
                            inputs: ['columns: cdkFooterRowDef', 'sticky: cdkFooterRowDefSticky'],
                        },] },
            ];
            /** @nocollapse */
            CdkFooterRowDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["IterableDiffers"] }
            ]; };
            /**
             * Data row definition for the CDK table.
             * Captures the header row's template and other row properties such as the columns to display and
             * a when predicate that describes when this row should be used.
             * @template T
             */
            var CdkRowDef = /** @class */ (function (_super_1) {
                __extends(CdkRowDef, _super_1);
                // TODO(andrewseguin): Add an input for providing a switch function to determine
                //   if this template should be used.
                /**
                 * @param {?} template
                 * @param {?} _differs
                 */
                function CdkRowDef(template, _differs) {
                    return _super_1.call(this, template, _differs) || this;
                }
                return CdkRowDef;
            }(BaseRowDef));
            CdkRowDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkRowDef]',
                            inputs: ['columns: cdkRowDefColumns', 'when: cdkRowDefWhen'],
                        },] },
            ];
            /** @nocollapse */
            CdkRowDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["IterableDiffers"] }
            ]; };
            /**
             * Outlet for rendering cells inside of a row or header row.
             * \@docs-private
             */
            var CdkCellOutlet = /** @class */ (function () {
                /**
                 * @param {?} _viewContainer
                 */
                function CdkCellOutlet(_viewContainer) {
                    this._viewContainer = _viewContainer;
                    CdkCellOutlet.mostRecentCellOutlet = this;
                }
                /**
                 * @return {?}
                 */
                CdkCellOutlet.prototype.ngOnDestroy = function () {
                    // If this was the last outlet being rendered in the view, remove the reference
                    // from the static property after it has been destroyed to avoid leaking memory.
                    if (CdkCellOutlet.mostRecentCellOutlet === this) {
                        CdkCellOutlet.mostRecentCellOutlet = null;
                    }
                };
                return CdkCellOutlet;
            }());
            /**
             * Static property containing the latest constructed instance of this class.
             * Used by the CDK table when each CdkHeaderRow and CdkRow component is created using
             * createEmbeddedView. After one of these components are created, this property will provide
             * a handle to provide that component's cells and context. After init, the CdkCellOutlet will
             * construct the cells with the provided context.
             */
            CdkCellOutlet.mostRecentCellOutlet = null;
            CdkCellOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[cdkCellOutlet]' },] },
            ];
            /** @nocollapse */
            CdkCellOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"] }
            ]; };
            /**
             * Header template container that contains the cell outlet. Adds the right class and role.
             */
            var CdkHeaderRow = /** @class */ (function () {
                function CdkHeaderRow() {
                }
                return CdkHeaderRow;
            }());
            CdkHeaderRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'cdk-header-row, tr[cdk-header-row]',
                            template: CDK_ROW_TEMPLATE,
                            host: {
                                'class': 'cdk-header-row',
                                'role': 'row',
                            },
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                        },] },
            ];
            /**
             * Footer template container that contains the cell outlet. Adds the right class and role.
             */
            var CdkFooterRow = /** @class */ (function () {
                function CdkFooterRow() {
                }
                return CdkFooterRow;
            }());
            CdkFooterRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'cdk-footer-row, tr[cdk-footer-row]',
                            template: CDK_ROW_TEMPLATE,
                            host: {
                                'class': 'cdk-footer-row',
                                'role': 'row',
                            },
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                        },] },
            ];
            /**
             * Data row template container that contains the cell outlet. Adds the right class and role.
             */
            var CdkRow = /** @class */ (function () {
                function CdkRow() {
                }
                return CdkRow;
            }());
            CdkRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'cdk-row, tr[cdk-row]',
                            template: CDK_ROW_TEMPLATE,
                            host: {
                                'class': 'cdk-row',
                                'role': 'row',
                            },
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * List of all possible directions that can be used for sticky positioning.
             * \@docs-private
             * @type {?}
             */
            var STICKY_DIRECTIONS = ['top', 'bottom', 'left', 'right'];
            /**
             * Applies and removes sticky positioning styles to the `CdkTable` rows and columns cells.
             * \@docs-private
             */
            var StickyStyler = /** @class */ (function () {
                /**
                 * @param {?} _isNativeHtmlTable Whether the sticky logic should be based on a table
                 *     that uses the native `<table>` element.
                 * @param {?} _stickCellCss The CSS class that will be applied to every row/cell that has
                 *     sticky positioning applied.
                 * @param {?} direction The directionality context of the table (ltr/rtl); affects column positioning
                 *     by reversing left/right positions.
                 * @param {?=} _isBrowser Whether the table is currently being rendered on the server or the client.
                 */
                function StickyStyler(_isNativeHtmlTable, _stickCellCss, direction, _isBrowser) {
                    if (_isBrowser === void 0) { _isBrowser = true; }
                    this._isNativeHtmlTable = _isNativeHtmlTable;
                    this._stickCellCss = _stickCellCss;
                    this.direction = direction;
                    this._isBrowser = _isBrowser;
                }
                /**
                 * Clears the sticky positioning styles from the row and its cells by resetting the `position`
                 * style, setting the zIndex to 0, and unsetting each provided sticky direction.
                 * @param {?} rows The list of rows that should be cleared from sticking in the provided directions
                 * @param {?} stickyDirections The directions that should no longer be set as sticky on the rows.
                 * @return {?}
                 */
                StickyStyler.prototype.clearStickyPositioning = function (rows, stickyDirections) {
                    for (var _c = 0, rows_1 = rows; _c < rows_1.length; _c++) {
                        var row = rows_1[_c];
                        // If the row isn't an element (e.g. if it's an `ng-container`),
                        // it won't have inline styles or `children` so we skip it.
                        if (row.nodeType !== row.ELEMENT_NODE) {
                            continue;
                        }
                        this._removeStickyStyle(row, stickyDirections);
                        for (var i = 0; i < row.children.length; i++) {
                            /** @type {?} */
                            var cell = ( /** @type {?} */(row.children[i]));
                            this._removeStickyStyle(cell, stickyDirections);
                        }
                    }
                };
                /**
                 * Applies sticky left and right positions to the cells of each row according to the sticky
                 * states of the rendered column definitions.
                 * @param {?} rows The rows that should have its set of cells stuck according to the sticky states.
                 * @param {?} stickyStartStates A list of boolean states where each state represents whether the cell
                 *     in this index position should be stuck to the start of the row.
                 * @param {?} stickyEndStates A list of boolean states where each state represents whether the cell
                 *     in this index position should be stuck to the end of the row.
                 * @return {?}
                 */
                StickyStyler.prototype.updateStickyColumns = function (rows, stickyStartStates, stickyEndStates) {
                    /** @type {?} */
                    var hasStickyColumns = stickyStartStates.some(( /**
                     * @param {?} state
                     * @return {?}
                     */function (/**
                     * @param {?} state
                     * @return {?}
                     */ state) { return state; })) || stickyEndStates.some(( /**
                     * @param {?} state
                     * @return {?}
                     */function (/**
                     * @param {?} state
                     * @return {?}
                     */ state) { return state; }));
                    if (!rows.length || !hasStickyColumns || !this._isBrowser) {
                        return;
                    }
                    /** @type {?} */
                    var firstRow = rows[0];
                    /** @type {?} */
                    var numCells = firstRow.children.length;
                    /** @type {?} */
                    var cellWidths = this._getCellWidths(firstRow);
                    /** @type {?} */
                    var startPositions = this._getStickyStartColumnPositions(cellWidths, stickyStartStates);
                    /** @type {?} */
                    var endPositions = this._getStickyEndColumnPositions(cellWidths, stickyEndStates);
                    /** @type {?} */
                    var isRtl = this.direction === 'rtl';
                    for (var _c = 0, rows_2 = rows; _c < rows_2.length; _c++) {
                        var row = rows_2[_c];
                        for (var i = 0; i < numCells; i++) {
                            /** @type {?} */
                            var cell = ( /** @type {?} */(row.children[i]));
                            if (stickyStartStates[i]) {
                                this._addStickyStyle(cell, isRtl ? 'right' : 'left', startPositions[i]);
                            }
                            if (stickyEndStates[i]) {
                                this._addStickyStyle(cell, isRtl ? 'left' : 'right', endPositions[i]);
                            }
                        }
                    }
                };
                /**
                 * Applies sticky positioning to the row's cells if using the native table layout, and to the
                 * row itself otherwise.
                 * @param {?} rowsToStick The list of rows that should be stuck according to their corresponding
                 *     sticky state and to the provided top or bottom position.
                 * @param {?} stickyStates A list of boolean states where each state represents whether the row
                 *     should be stuck in the particular top or bottom position.
                 * @param {?} position The position direction in which the row should be stuck if that row should be
                 *     sticky.
                 *
                 * @return {?}
                 */
                StickyStyler.prototype.stickRows = function (rowsToStick, stickyStates, position) {
                    // Since we can't measure the rows on the server, we can't stick the rows properly.
                    if (!this._isBrowser) {
                        return;
                    }
                    // If positioning the rows to the bottom, reverse their order when evaluating the sticky
                    // position such that the last row stuck will be "bottom: 0px" and so on.
                    /** @type {?} */
                    var rows = position === 'bottom' ? rowsToStick.reverse() : rowsToStick;
                    /** @type {?} */
                    var stickyHeight = 0;
                    for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                        if (!stickyStates[rowIndex]) {
                            continue;
                        }
                        /** @type {?} */
                        var row = rows[rowIndex];
                        if (this._isNativeHtmlTable) {
                            for (var j = 0; j < row.children.length; j++) {
                                /** @type {?} */
                                var cell = ( /** @type {?} */(row.children[j]));
                                this._addStickyStyle(cell, position, stickyHeight);
                            }
                        }
                        else {
                            // Flex does not respect the stick positioning on the cells, needs to be applied to the row.
                            // If this is applied on a native table, Safari causes the header to fly in wrong direction.
                            this._addStickyStyle(row, position, stickyHeight);
                        }
                        if (rowIndex === rows.length - 1) {
                            // prevent unnecessary reflow from getBoundingClientRect()
                            return;
                        }
                        stickyHeight += row.getBoundingClientRect().height;
                    }
                };
                /**
                 * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
                 * footer rows is to apply sticky styling to the tfoot container. This should only be done if
                 * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
                 * the tfoot element.
                 * @param {?} tableElement
                 * @param {?} stickyStates
                 * @return {?}
                 */
                StickyStyler.prototype.updateStickyFooterContainer = function (tableElement, stickyStates) {
                    if (!this._isNativeHtmlTable) {
                        return;
                    }
                    /** @type {?} */
                    var tfoot = ( /** @type {?} */(tableElement.querySelector('tfoot')));
                    if (stickyStates.some(( /**
                     * @param {?} state
                     * @return {?}
                     */function (/**
                     * @param {?} state
                     * @return {?}
                     */ state) { return !state; }))) {
                        this._removeStickyStyle(tfoot, ['bottom']);
                    }
                    else {
                        this._addStickyStyle(tfoot, 'bottom', 0);
                    }
                };
                /**
                 * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
                 * the zIndex, removing each of the provided sticky directions, and removing the
                 * sticky position if there are no more directions.
                 * @param {?} element
                 * @param {?} stickyDirections
                 * @return {?}
                 */
                StickyStyler.prototype._removeStickyStyle = function (element, stickyDirections) {
                    for (var _c = 0, stickyDirections_1 = stickyDirections; _c < stickyDirections_1.length; _c++) {
                        var dir = stickyDirections_1[_c];
                        element.style[dir] = '';
                    }
                    element.style.zIndex = this._getCalculatedZIndex(element);
                    // If the element no longer has any more sticky directions, remove sticky positioning and
                    // the sticky CSS class.
                    /** @type {?} */
                    var hasDirection = STICKY_DIRECTIONS.some(( /**
                     * @param {?} dir
                     * @return {?}
                     */function (/**
                     * @param {?} dir
                     * @return {?}
                     */ dir) { return !!element.style[dir]; }));
                    if (!hasDirection) {
                        element.style.position = '';
                        element.classList.remove(this._stickCellCss);
                    }
                };
                /**
                 * Adds the sticky styling to the element by adding the sticky style class, changing position
                 * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
                 * direction and value.
                 * @param {?} element
                 * @param {?} dir
                 * @param {?} dirValue
                 * @return {?}
                 */
                StickyStyler.prototype._addStickyStyle = function (element, dir, dirValue) {
                    element.classList.add(this._stickCellCss);
                    element.style[dir] = dirValue + "px";
                    element.style.cssText += 'position: -webkit-sticky; position: sticky; ';
                    element.style.zIndex = this._getCalculatedZIndex(element);
                };
                /**
                 * Calculate what the z-index should be for the element, depending on what directions (top,
                 * bottom, left, right) have been set. It should be true that elements with a top direction
                 * should have the highest index since these are elements like a table header. If any of those
                 * elements are also sticky in another direction, then they should appear above other elements
                 * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
                 * (e.g. footer rows) should then be next in the ordering such that they are below the header
                 * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
                 * should minimally increment so that they are above non-sticky elements but below top and bottom
                 * elements.
                 * @param {?} element
                 * @return {?}
                 */
                StickyStyler.prototype._getCalculatedZIndex = function (element) {
                    /** @type {?} */
                    var zIndexIncrements = {
                        top: 100,
                        bottom: 10,
                        left: 1,
                        right: 1,
                    };
                    /** @type {?} */
                    var zIndex = 0;
                    for (var _c = 0, STICKY_DIRECTIONS_1 = STICKY_DIRECTIONS; _c < STICKY_DIRECTIONS_1.length; _c++) {
                        var dir = STICKY_DIRECTIONS_1[_c];
                        if (element.style[dir]) {
                            zIndex += zIndexIncrements[dir];
                        }
                    }
                    return zIndex ? "" + zIndex : '';
                };
                /**
                 * Gets the widths for each cell in the provided row.
                 * @param {?} row
                 * @return {?}
                 */
                StickyStyler.prototype._getCellWidths = function (row) {
                    /** @type {?} */
                    var cellWidths = [];
                    /** @type {?} */
                    var firstRowCells = row.children;
                    for (var i = 0; i < firstRowCells.length; i++) {
                        /** @type {?} */
                        var cell = ( /** @type {?} */(firstRowCells[i]));
                        cellWidths.push(cell.getBoundingClientRect().width);
                    }
                    return cellWidths;
                };
                /**
                 * Determines the left and right positions of each sticky column cell, which will be the
                 * accumulation of all sticky column cell widths to the left and right, respectively.
                 * Non-sticky cells do not need to have a value set since their positions will not be applied.
                 * @param {?} widths
                 * @param {?} stickyStates
                 * @return {?}
                 */
                StickyStyler.prototype._getStickyStartColumnPositions = function (widths, stickyStates) {
                    /** @type {?} */
                    var positions = [];
                    /** @type {?} */
                    var nextPosition = 0;
                    for (var i = 0; i < widths.length; i++) {
                        if (stickyStates[i]) {
                            positions[i] = nextPosition;
                            nextPosition += widths[i];
                        }
                    }
                    return positions;
                };
                /**
                 * Determines the left and right positions of each sticky column cell, which will be the
                 * accumulation of all sticky column cell widths to the left and right, respectively.
                 * Non-sticky cells do not need to have a value set since their positions will not be applied.
                 * @param {?} widths
                 * @param {?} stickyStates
                 * @return {?}
                 */
                StickyStyler.prototype._getStickyEndColumnPositions = function (widths, stickyStates) {
                    /** @type {?} */
                    var positions = [];
                    /** @type {?} */
                    var nextPosition = 0;
                    for (var i = widths.length; i > 0; i--) {
                        if (stickyStates[i]) {
                            positions[i] = nextPosition;
                            nextPosition += widths[i];
                        }
                    }
                    return positions;
                };
                return StickyStyler;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns an error to be thrown when attempting to find an unexisting column.
             * \@docs-private
             * @param {?} id Id whose lookup failed.
             * @return {?}
             */
            function getTableUnknownColumnError(id) {
                return Error("Could not find column with id \"" + id + "\".");
            }
            /**
             * Returns an error to be thrown when two column definitions have the same name.
             * \@docs-private
             * @param {?} name
             * @return {?}
             */
            function getTableDuplicateColumnNameError(name) {
                return Error("Duplicate column definition name provided: \"" + name + "\".");
            }
            /**
             * Returns an error to be thrown when there are multiple rows that are missing a when function.
             * \@docs-private
             * @return {?}
             */
            function getTableMultipleDefaultRowDefsError() {
                return Error("There can only be one default row without a when predicate function.");
            }
            /**
             * Returns an error to be thrown when there are no matching row defs for a particular set of data.
             * \@docs-private
             * @param {?} data
             * @return {?}
             */
            function getTableMissingMatchingRowDefError(data) {
                return Error("Could not find a matching row definition for the" +
                    ("provided row data: " + JSON.stringify(data)));
            }
            /**
             * Returns an error to be thrown when there is no row definitions present in the content.
             * \@docs-private
             * @return {?}
             */
            function getTableMissingRowDefsError() {
                return Error('Missing definitions for header, footer, and row; ' +
                    'cannot determine which columns should be rendered.');
            }
            /**
             * Returns an error to be thrown when the data source does not match the compatible types.
             * \@docs-private
             * @return {?}
             */
            function getTableUnknownDataSourceError() {
                return Error("Provided data source did not match an array, Observable, or DataSource");
            }
            /**
             * Returns an error to be thrown when the text column cannot find a parent table to inject.
             * \@docs-private
             * @return {?}
             */
            function getTableTextColumnMissingParentTableError() {
                return Error("Text column could not find a parent table for registration.");
            }
            /**
             * Returns an error to be thrown when a table text column doesn't have a name.
             * \@docs-private
             * @return {?}
             */
            function getTableTextColumnMissingNameError() {
                return Error("Table text column must have a name.");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Provides a handle for the table to grab the view container's ng-container to insert data rows.
             * \@docs-private
             */
            var DataRowOutlet = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?} elementRef
                 */
                function DataRowOutlet(viewContainer, elementRef) {
                    this.viewContainer = viewContainer;
                    this.elementRef = elementRef;
                }
                return DataRowOutlet;
            }());
            DataRowOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[rowOutlet]' },] },
            ];
            /** @nocollapse */
            DataRowOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * Provides a handle for the table to grab the view container's ng-container to insert the header.
             * \@docs-private
             */
            var HeaderRowOutlet = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?} elementRef
                 */
                function HeaderRowOutlet(viewContainer, elementRef) {
                    this.viewContainer = viewContainer;
                    this.elementRef = elementRef;
                }
                return HeaderRowOutlet;
            }());
            HeaderRowOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[headerRowOutlet]' },] },
            ];
            /** @nocollapse */
            HeaderRowOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * Provides a handle for the table to grab the view container's ng-container to insert the footer.
             * \@docs-private
             */
            var FooterRowOutlet = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?} elementRef
                 */
                function FooterRowOutlet(viewContainer, elementRef) {
                    this.viewContainer = viewContainer;
                    this.elementRef = elementRef;
                }
                return FooterRowOutlet;
            }());
            FooterRowOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: '[footerRowOutlet]' },] },
            ];
            /** @nocollapse */
            FooterRowOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * The table template that can be used by the mat-table. Should not be used outside of the
             * material library.
             * \@docs-private
             * @type {?}
             */
            var CDK_TABLE_TEMPLATE = 
            // Note that according to MDN, the `caption` element has to be projected as the **first**
            // element in the table. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/caption
            "\n  <ng-content select=\"caption\"></ng-content>\n  <ng-container headerRowOutlet></ng-container>\n  <ng-container rowOutlet></ng-container>\n  <ng-container footerRowOutlet></ng-container>\n";
            /**
             * A data table that can render a header row, data rows, and a footer row.
             * Uses the dataSource input to determine the data to be rendered. The data can be provided either
             * as a data array, an Observable stream that emits the data array to render, or a DataSource with a
             * connect function that will return an Observable stream that emits the data array to render.
             * @template T
             */
            var CdkTable = /** @class */ (function () {
                /**
                 * @param {?} _differs
                 * @param {?} _changeDetectorRef
                 * @param {?} _elementRef
                 * @param {?} role
                 * @param {?} _dir
                 * @param {?} _document
                 * @param {?} _platform
                 */
                function CdkTable(_differs, _changeDetectorRef, _elementRef, role, _dir, _document, _platform) {
                    this._differs = _differs;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._elementRef = _elementRef;
                    this._dir = _dir;
                    this._platform = _platform;
                    /**
                     * Subject that emits when the component has been destroyed.
                     */
                    this._onDestroy = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    /**
                     * Map of all the user's defined columns (header, data, and footer cell template) identified by
                     * name. Collection populated by the column definitions gathered by `ContentChildren` as well as
                     * any custom column definitions added to `_customColumnDefs`.
                     */
                    this._columnDefsByName = new Map();
                    /**
                     * Column definitions that were defined outside of the direct content children of the table.
                     * These will be defined when, e.g., creating a wrapper around the cdkTable that has
                     * column definitions as *its* content child.
                     */
                    this._customColumnDefs = new Set();
                    /**
                     * Data row definitions that were defined outside of the direct content children of the table.
                     * These will be defined when, e.g., creating a wrapper around the cdkTable that has
                     * built-in data rows as *its* content child.
                     */
                    this._customRowDefs = new Set();
                    /**
                     * Header row definitions that were defined outside of the direct content children of the table.
                     * These will be defined when, e.g., creating a wrapper around the cdkTable that has
                     * built-in header rows as *its* content child.
                     */
                    this._customHeaderRowDefs = new Set();
                    /**
                     * Footer row definitions that were defined outside of the direct content children of the table.
                     * These will be defined when, e.g., creating a wrapper around the cdkTable that has a
                     * built-in footer row as *its* content child.
                     */
                    this._customFooterRowDefs = new Set();
                    /**
                     * Whether the header row definition has been changed. Triggers an update to the header row after
                     * content is checked. Initialized as true so that the table renders the initial set of rows.
                     */
                    this._headerRowDefChanged = true;
                    /**
                     * Whether the footer row definition has been changed. Triggers an update to the footer row after
                     * content is checked. Initialized as true so that the table renders the initial set of rows.
                     */
                    this._footerRowDefChanged = true;
                    /**
                     * Cache of the latest rendered `RenderRow` objects as a map for easy retrieval when constructing
                     * a new list of `RenderRow` objects for rendering rows. Since the new list is constructed with
                     * the cached `RenderRow` objects when possible, the row identity is preserved when the data
                     * and row template matches, which allows the `IterableDiffer` to check rows by reference
                     * and understand which rows are added/moved/removed.
                     *
                     * Implemented as a map of maps where the first key is the `data: T` object and the second is the
                     * `CdkRowDef<T>` object. With the two keys, the cache points to a `RenderRow<T>` object that
                     * contains an array of created pairs. The array is necessary to handle cases where the data
                     * array contains multiple duplicate data objects and each instantiated `RenderRow` must be
                     * stored.
                     */
                    this._cachedRenderRowsMap = new Map();
                    /**
                     * CSS class added to any row or cell that has sticky positioning applied. May be overriden by
                     * table subclasses.
                     */
                    this.stickyCssClass = 'cdk-table-sticky';
                    this._multiTemplateDataRows = false;
                    // TODO(andrewseguin): Remove max value as the end index
                    //   and instead calculate the view on init and scroll.
                    /**
                     * Stream containing the latest information on what rows are being displayed on screen.
                     * Can be used by the data source to as a heuristic of what data should be provided.
                     *
                     * \@docs-private
                     */
                    this.viewChange = new rxjs__WEBPACK_IMPORTED_MODULE_6__["BehaviorSubject"]({ start: 0, end: Number.MAX_VALUE });
                    if (!role) {
                        this._elementRef.nativeElement.setAttribute('role', 'grid');
                    }
                    this._document = _document;
                    this._isNativeHtmlTable = this._elementRef.nativeElement.nodeName === 'TABLE';
                }
                Object.defineProperty(CdkTable.prototype, "trackBy", {
                    /**
                     * Tracking function that will be used to check the differences in data changes. Used similarly
                     * to `ngFor` `trackBy` function. Optimize row operations by identifying a row based on its data
                     * relative to the function to know if a row should be added/removed/moved.
                     * Accepts a function that takes two parameters, `index` and `item`.
                     * @return {?}
                     */
                    get: function () {
                        return this._trackByFn;
                    },
                    /**
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && fn != null && typeof fn !== 'function' && ( /** @type {?} */(console)) &&
                            ( /** @type {?} */(console.warn))) {
                            console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ".");
                        }
                        this._trackByFn = fn;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTable.prototype, "dataSource", {
                    /**
                     * The table's source of data, which can be provided in three ways (in order of complexity):
                     *   - Simple data array (each object represents one table row)
                     *   - Stream that emits a data array each time the array changes
                     *   - `DataSource` object that implements the connect/disconnect interface.
                     *
                     * If a data array is provided, the table must be notified when the array's objects are
                     * added, removed, or moved. This can be done by calling the `renderRows()` function which will
                     * render the diff since the last table render. If the data array reference is changed, the table
                     * will automatically trigger an update to the rows.
                     *
                     * When providing an Observable stream, the table will trigger an update automatically when the
                     * stream emits a new array of data.
                     *
                     * Finally, when providing a `DataSource` object, the table will use the Observable stream
                     * provided by the connect function and trigger updates when that stream emits new data array
                     * values. During the table's ngOnDestroy or when the data source is removed from the table, the
                     * table will call the DataSource's `disconnect` function (may be useful for cleaning up any
                     * subscriptions registered during the connect process).
                     * @return {?}
                     */
                    get: function () {
                        return this._dataSource;
                    },
                    /**
                     * @param {?} dataSource
                     * @return {?}
                     */
                    set: function (dataSource) {
                        if (this._dataSource !== dataSource) {
                            this._switchDataSource(dataSource);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTable.prototype, "multiTemplateDataRows", {
                    /**
                     * Whether to allow multiple rows per data object by evaluating which rows evaluate their 'when'
                     * predicate to true. If `multiTemplateDataRows` is false, which is the default value, then each
                     * dataobject will render the first row that evaluates its when predicate to true, in the order
                     * defined in the table, or otherwise the default row which does not have a when predicate.
                     * @return {?}
                     */
                    get: function () {
                        return this._multiTemplateDataRows;
                    },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this._multiTemplateDataRows = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(v);
                        // In Ivy if this value is set via a static attribute (e.g. <table multiTemplateDataRows>),
                        // this setter will be invoked before the row outlet has been defined hence the null check.
                        if (this._rowOutlet && this._rowOutlet.viewContainer.length) {
                            this._forceRenderDataRows();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkTable.prototype.ngOnInit = function () {
                    var _this = this;
                    this._setupStickyStyler();
                    if (this._isNativeHtmlTable) {
                        this._applyNativeTableSections();
                    }
                    // Set up the trackBy function so that it uses the `RenderRow` as its identity by default. If
                    // the user has provided a custom trackBy, return the result of that function as evaluated
                    // with the values of the `RenderRow`'s data and index.
                    this._dataDiffer = this._differs.find([]).create(( /**
                     * @param {?} _i
                     * @param {?} dataRow
                     * @return {?}
                     */function (_i, dataRow) {
                        return _this.trackBy ? _this.trackBy(dataRow.dataIndex, dataRow.data) : dataRow;
                    }));
                };
                /**
                 * @return {?}
                 */
                CdkTable.prototype.ngAfterContentChecked = function () {
                    // Cache the row and column definitions gathered by ContentChildren and programmatic injection.
                    this._cacheRowDefs();
                    this._cacheColumnDefs();
                    // Make sure that the user has at least added header, footer, or data row def.
                    if (!this._headerRowDefs.length && !this._footerRowDefs.length && !this._rowDefs.length) {
                        throw getTableMissingRowDefsError();
                    }
                    // Render updates if the list of columns have been changed for the header, row, or footer defs.
                    this._renderUpdatedColumns();
                    // If the header row definition has been changed, trigger a render to the header row.
                    if (this._headerRowDefChanged) {
                        this._forceRenderHeaderRows();
                        this._headerRowDefChanged = false;
                    }
                    // If the footer row definition has been changed, trigger a render to the footer row.
                    if (this._footerRowDefChanged) {
                        this._forceRenderFooterRows();
                        this._footerRowDefChanged = false;
                    }
                    // If there is a data source and row definitions, connect to the data source unless a
                    // connection has already been made.
                    if (this.dataSource && this._rowDefs.length > 0 && !this._renderChangeSubscription) {
                        this._observeRenderChanges();
                    }
                    this._checkStickyStates();
                };
                /**
                 * @return {?}
                 */
                CdkTable.prototype.ngOnDestroy = function () {
                    this._rowOutlet.viewContainer.clear();
                    this._headerRowOutlet.viewContainer.clear();
                    this._footerRowOutlet.viewContainer.clear();
                    this._cachedRenderRowsMap.clear();
                    this._onDestroy.next();
                    this._onDestroy.complete();
                    if (Object(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["isDataSource"])(this.dataSource)) {
                        this.dataSource.disconnect(this);
                    }
                };
                /**
                 * Renders rows based on the table's latest set of data, which was either provided directly as an
                 * input or retrieved through an Observable stream (directly or from a DataSource).
                 * Checks for differences in the data since the last diff to perform only the necessary
                 * changes (add/remove/move rows).
                 *
                 * If the table's data source is a DataSource or Observable, this will be invoked automatically
                 * each time the provided Observable stream emits a new data array. Otherwise if your data is
                 * an array, this function will need to be called to render any changes.
                 * @return {?}
                 */
                CdkTable.prototype.renderRows = function () {
                    var _this = this;
                    this._renderRows = this._getAllRenderRows();
                    /** @type {?} */
                    var changes = this._dataDiffer.diff(this._renderRows);
                    if (!changes) {
                        return;
                    }
                    /** @type {?} */
                    var viewContainer = this._rowOutlet.viewContainer;
                    changes.forEachOperation(( /**
                     * @param {?} record
                     * @param {?} prevIndex
                     * @param {?} currentIndex
                     * @return {?}
                     */function (record, prevIndex, currentIndex) {
                        if (record.previousIndex == null) {
                            _this._insertRow(record.item, ( /** @type {?} */(currentIndex)));
                        }
                        else if (currentIndex == null) {
                            viewContainer.remove(( /** @type {?} */(prevIndex)));
                        }
                        else {
                            /** @type {?} */
                            var view = ( /** @type {?} */(viewContainer.get(( /** @type {?} */(prevIndex)))));
                            viewContainer.move(( /** @type {?} */(view)), currentIndex);
                        }
                    }));
                    // Update the meta context of a row's context data (index, count, first, last, ...)
                    this._updateRowIndexContext();
                    // Update rows that did not get added/removed/moved but may have had their identity changed,
                    // e.g. if trackBy matched data on some property but the actual data reference changed.
                    changes.forEachIdentityChange(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) {
                        /** @type {?} */
                        var rowView = ( /** @type {?} */(viewContainer.get(( /** @type {?} */(record.currentIndex)))));
                        rowView.context.$implicit = record.item.data;
                    }));
                    this.updateStickyColumnStyles();
                };
                /**
                 * Sets the header row definition to be used. Overrides the header row definition gathered by
                 * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
                 * table's content is checked.
                 * \@docs-private
                 * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
                 * \@breaking-change 8.0.0
                 * @param {?} headerRowDef
                 * @return {?}
                 */
                CdkTable.prototype.setHeaderRowDef = function (headerRowDef) {
                    this._customHeaderRowDefs = new Set([headerRowDef]);
                    this._headerRowDefChanged = true;
                };
                /**
                 * Sets the footer row definition to be used. Overrides the footer row definition gathered by
                 * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
                 * table's content is checked.
                 * \@docs-private
                 * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
                 * \@breaking-change 8.0.0
                 * @param {?} footerRowDef
                 * @return {?}
                 */
                CdkTable.prototype.setFooterRowDef = function (footerRowDef) {
                    this._customFooterRowDefs = new Set([footerRowDef]);
                    this._footerRowDefChanged = true;
                };
                /**
                 * Adds a column definition that was not included as part of the content children.
                 * @param {?} columnDef
                 * @return {?}
                 */
                CdkTable.prototype.addColumnDef = function (columnDef) {
                    this._customColumnDefs.add(columnDef);
                };
                /**
                 * Removes a column definition that was not included as part of the content children.
                 * @param {?} columnDef
                 * @return {?}
                 */
                CdkTable.prototype.removeColumnDef = function (columnDef) {
                    this._customColumnDefs.delete(columnDef);
                };
                /**
                 * Adds a row definition that was not included as part of the content children.
                 * @param {?} rowDef
                 * @return {?}
                 */
                CdkTable.prototype.addRowDef = function (rowDef) {
                    this._customRowDefs.add(rowDef);
                };
                /**
                 * Removes a row definition that was not included as part of the content children.
                 * @param {?} rowDef
                 * @return {?}
                 */
                CdkTable.prototype.removeRowDef = function (rowDef) {
                    this._customRowDefs.delete(rowDef);
                };
                /**
                 * Adds a header row definition that was not included as part of the content children.
                 * @param {?} headerRowDef
                 * @return {?}
                 */
                CdkTable.prototype.addHeaderRowDef = function (headerRowDef) {
                    this._customHeaderRowDefs.add(headerRowDef);
                    this._headerRowDefChanged = true;
                };
                /**
                 * Removes a header row definition that was not included as part of the content children.
                 * @param {?} headerRowDef
                 * @return {?}
                 */
                CdkTable.prototype.removeHeaderRowDef = function (headerRowDef) {
                    this._customHeaderRowDefs.delete(headerRowDef);
                    this._headerRowDefChanged = true;
                };
                /**
                 * Adds a footer row definition that was not included as part of the content children.
                 * @param {?} footerRowDef
                 * @return {?}
                 */
                CdkTable.prototype.addFooterRowDef = function (footerRowDef) {
                    this._customFooterRowDefs.add(footerRowDef);
                    this._footerRowDefChanged = true;
                };
                /**
                 * Removes a footer row definition that was not included as part of the content children.
                 * @param {?} footerRowDef
                 * @return {?}
                 */
                CdkTable.prototype.removeFooterRowDef = function (footerRowDef) {
                    this._customFooterRowDefs.delete(footerRowDef);
                    this._footerRowDefChanged = true;
                };
                /**
                 * Updates the header sticky styles. First resets all applied styles with respect to the cells
                 * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
                 * automatically called when the header row changes its displayed set of columns, or if its
                 * sticky input changes. May be called manually for cases where the cell content changes outside
                 * of these events.
                 * @return {?}
                 */
                CdkTable.prototype.updateStickyHeaderRowStyles = function () {
                    /** @type {?} */
                    var headerRows = this._getRenderedRows(this._headerRowOutlet);
                    /** @type {?} */
                    var tableElement = ( /** @type {?} */(this._elementRef.nativeElement));
                    // Hide the thead element if there are no header rows. This is necessary to satisfy
                    // overzealous a11y checkers that fail because the `rowgroup` element does not contain
                    // required child `row`.
                    /** @type {?} */
                    var thead = tableElement.querySelector('thead');
                    if (thead) {
                        thead.style.display = headerRows.length ? '' : 'none';
                    }
                    /** @type {?} */
                    var stickyStates = this._headerRowDefs.map(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return def.sticky; }));
                    this._stickyStyler.clearStickyPositioning(headerRows, ['top']);
                    this._stickyStyler.stickRows(headerRows, stickyStates, 'top');
                    // Reset the dirty state of the sticky input change since it has been used.
                    this._headerRowDefs.forEach(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return def.resetStickyChanged(); }));
                };
                /**
                 * Updates the footer sticky styles. First resets all applied styles with respect to the cells
                 * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
                 * automatically called when the footer row changes its displayed set of columns, or if its
                 * sticky input changes. May be called manually for cases where the cell content changes outside
                 * of these events.
                 * @return {?}
                 */
                CdkTable.prototype.updateStickyFooterRowStyles = function () {
                    /** @type {?} */
                    var footerRows = this._getRenderedRows(this._footerRowOutlet);
                    /** @type {?} */
                    var tableElement = ( /** @type {?} */(this._elementRef.nativeElement));
                    // Hide the tfoot element if there are no footer rows. This is necessary to satisfy
                    // overzealous a11y checkers that fail because the `rowgroup` element does not contain
                    // required child `row`.
                    /** @type {?} */
                    var tfoot = tableElement.querySelector('tfoot');
                    if (tfoot) {
                        tfoot.style.display = footerRows.length ? '' : 'none';
                    }
                    /** @type {?} */
                    var stickyStates = this._footerRowDefs.map(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return def.sticky; }));
                    this._stickyStyler.clearStickyPositioning(footerRows, ['bottom']);
                    this._stickyStyler.stickRows(footerRows, stickyStates, 'bottom');
                    this._stickyStyler.updateStickyFooterContainer(this._elementRef.nativeElement, stickyStates);
                    // Reset the dirty state of the sticky input change since it has been used.
                    this._footerRowDefs.forEach(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return def.resetStickyChanged(); }));
                };
                /**
                 * Updates the column sticky styles. First resets all applied styles with respect to the cells
                 * sticking to the left and right. Then sticky styles are added for the left and right according
                 * to the column definitions for each cell in each row. This is automatically called when
                 * the data source provides a new set of data or when a column definition changes its sticky
                 * input. May be called manually for cases where the cell content changes outside of these events.
                 * @return {?}
                 */
                CdkTable.prototype.updateStickyColumnStyles = function () {
                    var _this = this;
                    /** @type {?} */
                    var headerRows = this._getRenderedRows(this._headerRowOutlet);
                    /** @type {?} */
                    var dataRows = this._getRenderedRows(this._rowOutlet);
                    /** @type {?} */
                    var footerRows = this._getRenderedRows(this._footerRowOutlet);
                    // Clear the left and right positioning from all columns in the table across all rows since
                    // sticky columns span across all table sections (header, data, footer)
                    this._stickyStyler.clearStickyPositioning(headerRows.concat(dataRows, footerRows), ['left', 'right']);
                    // Update the sticky styles for each header row depending on the def's sticky state
                    headerRows.forEach(( /**
                     * @param {?} headerRow
                     * @param {?} i
                     * @return {?}
                     */function (headerRow, i) {
                        _this._addStickyColumnStyles([headerRow], _this._headerRowDefs[i]);
                    }));
                    // Update the sticky styles for each data row depending on its def's sticky state
                    this._rowDefs.forEach(( /**
                     * @param {?} rowDef
                     * @return {?}
                     */function (/**
                     * @param {?} rowDef
                     * @return {?}
                     */ rowDef) {
                        // Collect all the rows rendered with this row definition.
                        /** @type {?} */
                        var rows = [];
                        for (var i = 0; i < dataRows.length; i++) {
                            if (_this._renderRows[i].rowDef === rowDef) {
                                rows.push(dataRows[i]);
                            }
                        }
                        _this._addStickyColumnStyles(rows, rowDef);
                    }));
                    // Update the sticky styles for each footer row depending on the def's sticky state
                    footerRows.forEach(( /**
                     * @param {?} footerRow
                     * @param {?} i
                     * @return {?}
                     */function (footerRow, i) {
                        _this._addStickyColumnStyles([footerRow], _this._footerRowDefs[i]);
                    }));
                    // Reset the dirty state of the sticky input change since it has been used.
                    Array.from(this._columnDefsByName.values()).forEach(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return def.resetStickyChanged(); }));
                };
                /**
                 * Get the list of RenderRow objects to render according to the current list of data and defined
                 * row definitions. If the previous list already contained a particular pair, it should be reused
                 * so that the differ equates their references.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._getAllRenderRows = function () {
                    /** @type {?} */
                    var renderRows = [];
                    // Store the cache and create a new one. Any re-used RenderRow objects will be moved into the
                    // new cache while unused ones can be picked up by garbage collection.
                    /** @type {?} */
                    var prevCachedRenderRows = this._cachedRenderRowsMap;
                    this._cachedRenderRowsMap = new Map();
                    // For each data object, get the list of rows that should be rendered, represented by the
                    // respective `RenderRow` object which is the pair of `data` and `CdkRowDef`.
                    for (var i = 0; i < this._data.length; i++) {
                        /** @type {?} */
                        var data = this._data[i];
                        /** @type {?} */
                        var renderRowsForData = this._getRenderRowsForData(data, i, prevCachedRenderRows.get(data));
                        if (!this._cachedRenderRowsMap.has(data)) {
                            this._cachedRenderRowsMap.set(data, new WeakMap());
                        }
                        for (var j = 0; j < renderRowsForData.length; j++) {
                            /** @type {?} */
                            var renderRow = renderRowsForData[j];
                            /** @type {?} */
                            var cache = ( /** @type {?} */(this._cachedRenderRowsMap.get(renderRow.data)));
                            if (cache.has(renderRow.rowDef)) {
                                ( /** @type {?} */(cache.get(renderRow.rowDef))).push(renderRow);
                            }
                            else {
                                cache.set(renderRow.rowDef, [renderRow]);
                            }
                            renderRows.push(renderRow);
                        }
                    }
                    return renderRows;
                };
                /**
                 * Gets a list of `RenderRow<T>` for the provided data object and any `CdkRowDef` objects that
                 * should be rendered for this data. Reuses the cached RenderRow objects if they match the same
                 * `(T, CdkRowDef)` pair.
                 * @private
                 * @param {?} data
                 * @param {?} dataIndex
                 * @param {?=} cache
                 * @return {?}
                 */
                CdkTable.prototype._getRenderRowsForData = function (data, dataIndex, cache) {
                    /** @type {?} */
                    var rowDefs = this._getRowDefs(data, dataIndex);
                    return rowDefs.map(( /**
                     * @param {?} rowDef
                     * @return {?}
                     */function (/**
                     * @param {?} rowDef
                     * @return {?}
                     */ rowDef) {
                        /** @type {?} */
                        var cachedRenderRows = (cache && cache.has(rowDef)) ? ( /** @type {?} */(cache.get(rowDef))) : [];
                        if (cachedRenderRows.length) {
                            /** @type {?} */
                            var dataRow = ( /** @type {?} */(cachedRenderRows.shift()));
                            dataRow.dataIndex = dataIndex;
                            return dataRow;
                        }
                        else {
                            return { data: data, rowDef: rowDef, dataIndex: dataIndex };
                        }
                    }));
                };
                /**
                 * Update the map containing the content's column definitions.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._cacheColumnDefs = function () {
                    var _this = this;
                    this._columnDefsByName.clear();
                    /** @type {?} */
                    var columnDefs = mergeQueryListAndSet(this._contentColumnDefs, this._customColumnDefs);
                    columnDefs.forEach(( /**
                     * @param {?} columnDef
                     * @return {?}
                     */function (/**
                     * @param {?} columnDef
                     * @return {?}
                     */ columnDef) {
                        if (_this._columnDefsByName.has(columnDef.name)) {
                            throw getTableDuplicateColumnNameError(columnDef.name);
                        }
                        _this._columnDefsByName.set(columnDef.name, columnDef);
                    }));
                };
                /**
                 * Update the list of all available row definitions that can be used.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._cacheRowDefs = function () {
                    this._headerRowDefs =
                        mergeQueryListAndSet(this._contentHeaderRowDefs, this._customHeaderRowDefs);
                    this._footerRowDefs =
                        mergeQueryListAndSet(this._contentFooterRowDefs, this._customFooterRowDefs);
                    this._rowDefs = mergeQueryListAndSet(this._contentRowDefs, this._customRowDefs);
                    // After all row definitions are determined, find the row definition to be considered default.
                    /** @type {?} */
                    var defaultRowDefs = this._rowDefs.filter(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return !def.when; }));
                    if (!this.multiTemplateDataRows && defaultRowDefs.length > 1) {
                        throw getTableMultipleDefaultRowDefsError();
                    }
                    this._defaultRowDef = defaultRowDefs[0];
                };
                /**
                 * Check if the header, data, or footer rows have changed what columns they want to display or
                 * whether the sticky states have changed for the header or footer. If there is a diff, then
                 * re-render that section.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._renderUpdatedColumns = function () {
                    /** @type {?} */
                    var columnsDiffReducer = ( /**
                     * @param {?} acc
                     * @param {?} def
                     * @return {?}
                     */function (acc, def) { return acc || !!def.getColumnsDiff(); });
                    // Force re-render data rows if the list of column definitions have changed.
                    if (this._rowDefs.reduce(columnsDiffReducer, false)) {
                        this._forceRenderDataRows();
                    }
                    // Force re-render header/footer rows if the list of column definitions have changed..
                    if (this._headerRowDefs.reduce(columnsDiffReducer, false)) {
                        this._forceRenderHeaderRows();
                    }
                    if (this._footerRowDefs.reduce(columnsDiffReducer, false)) {
                        this._forceRenderFooterRows();
                    }
                };
                /**
                 * Switch to the provided data source by resetting the data and unsubscribing from the current
                 * render change subscription if one exists. If the data source is null, interpret this by
                 * clearing the row outlet. Otherwise start listening for new data.
                 * @private
                 * @param {?} dataSource
                 * @return {?}
                 */
                CdkTable.prototype._switchDataSource = function (dataSource) {
                    this._data = [];
                    if (Object(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["isDataSource"])(this.dataSource)) {
                        this.dataSource.disconnect(this);
                    }
                    // Stop listening for data from the previous data source.
                    if (this._renderChangeSubscription) {
                        this._renderChangeSubscription.unsubscribe();
                        this._renderChangeSubscription = null;
                    }
                    if (!dataSource) {
                        if (this._dataDiffer) {
                            this._dataDiffer.diff([]);
                        }
                        this._rowOutlet.viewContainer.clear();
                    }
                    this._dataSource = dataSource;
                };
                /**
                 * Set up a subscription for the data provided by the data source.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._observeRenderChanges = function () {
                    var _this = this;
                    // If no data source has been set, there is nothing to observe for changes.
                    if (!this.dataSource) {
                        return;
                    }
                    /** @type {?} */
                    var dataStream;
                    if (Object(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["isDataSource"])(this.dataSource)) {
                        dataStream = this.dataSource.connect(this);
                    }
                    else if (this.dataSource instanceof rxjs__WEBPACK_IMPORTED_MODULE_6__["Observable"]) {
                        dataStream = this.dataSource;
                    }
                    else if (Array.isArray(this.dataSource)) {
                        dataStream = Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["of"])(this.dataSource);
                    }
                    if (dataStream === undefined) {
                        throw getTableUnknownDataSourceError();
                    }
                    this._renderChangeSubscription = dataStream.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._onDestroy)).subscribe(( /**
                     * @param {?} data
                     * @return {?}
                     */function (/**
                     * @param {?} data
                     * @return {?}
                     */ data) {
                        _this._data = data || [];
                        _this.renderRows();
                    }));
                };
                /**
                 * Clears any existing content in the header row outlet and creates a new embedded view
                 * in the outlet using the header row definition.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._forceRenderHeaderRows = function () {
                    var _this = this;
                    // Clear the header row outlet if any content exists.
                    if (this._headerRowOutlet.viewContainer.length > 0) {
                        this._headerRowOutlet.viewContainer.clear();
                    }
                    this._headerRowDefs.forEach(( /**
                     * @param {?} def
                     * @param {?} i
                     * @return {?}
                     */function (def, i) { return _this._renderRow(_this._headerRowOutlet, def, i); }));
                    this.updateStickyHeaderRowStyles();
                    this.updateStickyColumnStyles();
                };
                /**
                 * Clears any existing content in the footer row outlet and creates a new embedded view
                 * in the outlet using the footer row definition.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._forceRenderFooterRows = function () {
                    var _this = this;
                    // Clear the footer row outlet if any content exists.
                    if (this._footerRowOutlet.viewContainer.length > 0) {
                        this._footerRowOutlet.viewContainer.clear();
                    }
                    this._footerRowDefs.forEach(( /**
                     * @param {?} def
                     * @param {?} i
                     * @return {?}
                     */function (def, i) { return _this._renderRow(_this._footerRowOutlet, def, i); }));
                    this.updateStickyFooterRowStyles();
                    this.updateStickyColumnStyles();
                };
                /**
                 * Adds the sticky column styles for the rows according to the columns' stick states.
                 * @private
                 * @param {?} rows
                 * @param {?} rowDef
                 * @return {?}
                 */
                CdkTable.prototype._addStickyColumnStyles = function (rows, rowDef) {
                    var _this = this;
                    /** @type {?} */
                    var columnDefs = Array.from(rowDef.columns || []).map(( /**
                     * @param {?} columnName
                     * @return {?}
                     */function (/**
                     * @param {?} columnName
                     * @return {?}
                     */ columnName) {
                        /** @type {?} */
                        var columnDef = _this._columnDefsByName.get(columnName);
                        if (!columnDef) {
                            throw getTableUnknownColumnError(columnName);
                        }
                        return ( /** @type {?} */(columnDef));
                    }));
                    /** @type {?} */
                    var stickyStartStates = columnDefs.map(( /**
                     * @param {?} columnDef
                     * @return {?}
                     */function (/**
                     * @param {?} columnDef
                     * @return {?}
                     */ columnDef) { return columnDef.sticky; }));
                    /** @type {?} */
                    var stickyEndStates = columnDefs.map(( /**
                     * @param {?} columnDef
                     * @return {?}
                     */function (/**
                     * @param {?} columnDef
                     * @return {?}
                     */ columnDef) { return columnDef.stickyEnd; }));
                    this._stickyStyler.updateStickyColumns(rows, stickyStartStates, stickyEndStates);
                };
                /**
                 * Gets the list of rows that have been rendered in the row outlet.
                 * @param {?} rowOutlet
                 * @return {?}
                 */
                CdkTable.prototype._getRenderedRows = function (rowOutlet) {
                    /** @type {?} */
                    var renderedRows = [];
                    for (var i = 0; i < rowOutlet.viewContainer.length; i++) {
                        /** @type {?} */
                        var viewRef = (( /** @type {?} */(( /** @type {?} */(rowOutlet.viewContainer.get(i))))));
                        renderedRows.push(viewRef.rootNodes[0]);
                    }
                    return renderedRows;
                };
                /**
                 * Get the matching row definitions that should be used for this row data. If there is only
                 * one row definition, it is returned. Otherwise, find the row definitions that has a when
                 * predicate that returns true with the data. If none return true, return the default row
                 * definition.
                 * @param {?} data
                 * @param {?} dataIndex
                 * @return {?}
                 */
                CdkTable.prototype._getRowDefs = function (data, dataIndex) {
                    if (this._rowDefs.length == 1) {
                        return [this._rowDefs[0]];
                    }
                    /** @type {?} */
                    var rowDefs = [];
                    if (this.multiTemplateDataRows) {
                        rowDefs = this._rowDefs.filter(( /**
                         * @param {?} def
                         * @return {?}
                         */function (/**
                         * @param {?} def
                         * @return {?}
                         */ def) { return !def.when || def.when(dataIndex, data); }));
                    }
                    else {
                        /** @type {?} */
                        var rowDef = this._rowDefs.find(( /**
                         * @param {?} def
                         * @return {?}
                         */function (/**
                         * @param {?} def
                         * @return {?}
                         */ def) { return def.when && def.when(dataIndex, data); })) || this._defaultRowDef;
                        if (rowDef) {
                            rowDefs.push(rowDef);
                        }
                    }
                    if (!rowDefs.length) {
                        throw getTableMissingMatchingRowDefError(data);
                    }
                    return rowDefs;
                };
                /**
                 * Create the embedded view for the data row template and place it in the correct index location
                 * within the data row view container.
                 * @private
                 * @param {?} renderRow
                 * @param {?} renderIndex
                 * @return {?}
                 */
                CdkTable.prototype._insertRow = function (renderRow, renderIndex) {
                    /** @type {?} */
                    var rowDef = renderRow.rowDef;
                    /** @type {?} */
                    var context = { $implicit: renderRow.data };
                    this._renderRow(this._rowOutlet, rowDef, renderIndex, context);
                };
                /**
                 * Creates a new row template in the outlet and fills it with the set of cell templates.
                 * Optionally takes a context to provide to the row and cells, as well as an optional index
                 * of where to place the new row template in the outlet.
                 * @private
                 * @param {?} outlet
                 * @param {?} rowDef
                 * @param {?} index
                 * @param {?=} context
                 * @return {?}
                 */
                CdkTable.prototype._renderRow = function (outlet, rowDef, index, context) {
                    if (context === void 0) { context = {}; }
                    // TODO(andrewseguin): enforce that one outlet was instantiated from createEmbeddedView
                    outlet.viewContainer.createEmbeddedView(rowDef.template, context, index);
                    for (var _c = 0, _d = this._getCellTemplates(rowDef); _c < _d.length; _c++) {
                        var cellTemplate = _d[_c];
                        if (CdkCellOutlet.mostRecentCellOutlet) {
                            CdkCellOutlet.mostRecentCellOutlet._viewContainer.createEmbeddedView(cellTemplate, context);
                        }
                    }
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Updates the index-related context for each row to reflect any changes in the index of the rows,
                 * e.g. first/last/even/odd.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._updateRowIndexContext = function () {
                    /** @type {?} */
                    var viewContainer = this._rowOutlet.viewContainer;
                    for (var renderIndex = 0, count = viewContainer.length; renderIndex < count; renderIndex++) {
                        /** @type {?} */
                        var viewRef = ( /** @type {?} */(viewContainer.get(renderIndex)));
                        /** @type {?} */
                        var context = ( /** @type {?} */(viewRef.context));
                        context.count = count;
                        context.first = renderIndex === 0;
                        context.last = renderIndex === count - 1;
                        context.even = renderIndex % 2 === 0;
                        context.odd = !context.even;
                        if (this.multiTemplateDataRows) {
                            context.dataIndex = this._renderRows[renderIndex].dataIndex;
                            context.renderIndex = renderIndex;
                        }
                        else {
                            context.index = this._renderRows[renderIndex].dataIndex;
                        }
                    }
                };
                /**
                 * Gets the column definitions for the provided row def.
                 * @private
                 * @param {?} rowDef
                 * @return {?}
                 */
                CdkTable.prototype._getCellTemplates = function (rowDef) {
                    var _this = this;
                    if (!rowDef || !rowDef.columns) {
                        return [];
                    }
                    return Array.from(rowDef.columns, ( /**
                     * @param {?} columnId
                     * @return {?}
                     */function (/**
                     * @param {?} columnId
                     * @return {?}
                     */ columnId) {
                        /** @type {?} */
                        var column = _this._columnDefsByName.get(columnId);
                        if (!column) {
                            throw getTableUnknownColumnError(columnId);
                        }
                        return rowDef.extractCellTemplate(column);
                    }));
                };
                /**
                 * Adds native table sections (e.g. tbody) and moves the row outlets into them.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._applyNativeTableSections = function () {
                    /** @type {?} */
                    var documentFragment = this._document.createDocumentFragment();
                    /** @type {?} */
                    var sections = [
                        { tag: 'thead', outlet: this._headerRowOutlet },
                        { tag: 'tbody', outlet: this._rowOutlet },
                        { tag: 'tfoot', outlet: this._footerRowOutlet },
                    ];
                    for (var _c = 0, sections_1 = sections; _c < sections_1.length; _c++) {
                        var section = sections_1[_c];
                        /** @type {?} */
                        var element = this._document.createElement(section.tag);
                        element.setAttribute('role', 'rowgroup');
                        element.appendChild(section.outlet.elementRef.nativeElement);
                        documentFragment.appendChild(element);
                    }
                    // Use a DocumentFragment so we don't hit the DOM on each iteration.
                    this._elementRef.nativeElement.appendChild(documentFragment);
                };
                /**
                 * Forces a re-render of the data rows. Should be called in cases where there has been an input
                 * change that affects the evaluation of which rows should be rendered, e.g. toggling
                 * `multiTemplateDataRows` or adding/removing row definitions.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._forceRenderDataRows = function () {
                    this._dataDiffer.diff([]);
                    this._rowOutlet.viewContainer.clear();
                    this.renderRows();
                    this.updateStickyColumnStyles();
                };
                /**
                 * Checks if there has been a change in sticky states since last check and applies the correct
                 * sticky styles. Since checking resets the "dirty" state, this should only be performed once
                 * during a change detection and after the inputs are settled (after content check).
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._checkStickyStates = function () {
                    /** @type {?} */
                    var stickyCheckReducer = ( /**
                     * @param {?} acc
                     * @param {?} d
                     * @return {?}
                     */function (acc, d) {
                        return acc || d.hasStickyChanged();
                    });
                    // Note that the check needs to occur for every definition since it notifies the definition
                    // that it can reset its dirty state. Using another operator like `some` may short-circuit
                    // remaining definitions and leave them in an unchecked state.
                    if (this._headerRowDefs.reduce(stickyCheckReducer, false)) {
                        this.updateStickyHeaderRowStyles();
                    }
                    if (this._footerRowDefs.reduce(stickyCheckReducer, false)) {
                        this.updateStickyFooterRowStyles();
                    }
                    if (Array.from(this._columnDefsByName.values()).reduce(stickyCheckReducer, false)) {
                        this.updateStickyColumnStyles();
                    }
                };
                /**
                 * Creates the sticky styler that will be used for sticky rows and columns. Listens
                 * for directionality changes and provides the latest direction to the styler. Re-applies column
                 * stickiness when directionality changes.
                 * @private
                 * @return {?}
                 */
                CdkTable.prototype._setupStickyStyler = function () {
                    var _this = this;
                    /** @type {?} */
                    var direction = this._dir ? this._dir.value : 'ltr';
                    this._stickyStyler = new StickyStyler(this._isNativeHtmlTable, this.stickyCssClass, direction, this._platform.isBrowser);
                    (this._dir ? this._dir.change : Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["of"])())
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._onDestroy))
                        .subscribe(( /**
                 * @param {?} value
                 * @return {?}
                 */function (/**
                 * @param {?} value
                 * @return {?}
                 */ value) {
                        _this._stickyStyler.direction = value;
                        _this.updateStickyColumnStyles();
                    }));
                };
                return CdkTable;
            }());
            CdkTable.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'cdk-table, table[cdk-table]',
                            exportAs: 'cdkTable',
                            template: CDK_TABLE_TEMPLATE,
                            host: {
                                'class': 'cdk-table',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            // The "OnPush" status for the `MatTable` component is effectively a noop, so we are removing it.
                            // The view for `MatTable` consists entirely of templates declared in other views. As they are
                            // declared elsewhere, they are checked when their declaration points are checked.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                        },] },
            ];
            /** @nocollapse */
            CdkTable.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["IterableDiffers"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Attribute"], args: ['role',] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"],] }] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_4__["Platform"] }
            ]; };
            CdkTable.propDecorators = {
                trackBy: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                dataSource: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                multiTemplateDataRows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                _rowOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [DataRowOutlet, { static: true },] }],
                _headerRowOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [HeaderRowOutlet, { static: true },] }],
                _footerRowOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [FooterRowOutlet, { static: true },] }],
                _contentColumnDefs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChildren"], args: [CdkColumnDef,] }],
                _contentRowDefs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChildren"], args: [CdkRowDef,] }],
                _contentHeaderRowDefs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChildren"], args: [CdkHeaderRowDef,] }],
                _contentFooterRowDefs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChildren"], args: [CdkFooterRowDef,] }]
            };
            /**
             * Utility function that gets a merged list of the entries in a QueryList and values of a Set.
             * @template T
             * @param {?} queryList
             * @param {?} set
             * @return {?}
             */
            function mergeQueryListAndSet(queryList, set) {
                return queryList.toArray().concat(Array.from(set));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to specify the text column options.
             * @type {?}
             */
            var TEXT_COLUMN_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('text-column-options');
            /**
             * Column that simply shows text content for the header and row cells. Assumes that the table
             * is using the native table implementation (`<table>`).
             *
             * By default, the name of this column will be the header text and data property accessor.
             * The header text can be overridden with the `headerText` input. Cell values can be overridden with
             * the `dataAccessor` input. Change the text justification to the start or end using the `justify`
             * input.
             * @template T
             */
            var CdkTextColumn = /** @class */ (function () {
                /**
                 * @param {?} _table
                 * @param {?} _options
                 */
                function CdkTextColumn(_table, _options) {
                    this._table = _table;
                    this._options = _options;
                    /**
                     * Alignment of the cell values.
                     */
                    this.justify = 'start';
                    this._options = _options || {};
                }
                Object.defineProperty(CdkTextColumn.prototype, "name", {
                    /**
                     * Column name that should be used to reference this column.
                     * @return {?}
                     */
                    get: function () {
                        return this._name;
                    },
                    /**
                     * @param {?} name
                     * @return {?}
                     */
                    set: function (name) {
                        this._name = name;
                        // With Ivy, inputs can be initialized before static query results are
                        // available. In that case, we defer the synchronization until "ngOnInit" fires.
                        this._syncColumnDefName();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkTextColumn.prototype.ngOnInit = function () {
                    this._syncColumnDefName();
                    if (this.headerText === undefined) {
                        this.headerText = this._createDefaultHeaderText();
                    }
                    if (!this.dataAccessor) {
                        this.dataAccessor =
                            this._options.defaultDataAccessor || (( /**
                             * @param {?} data
                             * @param {?} name
                             * @return {?}
                             */function (data, name) { return (( /** @type {?} */(data)))[name]; }));
                    }
                    if (this._table) {
                        // Provide the cell and headerCell directly to the table with the static `ViewChild` query,
                        // since the columnDef will not pick up its content by the time the table finishes checking
                        // its content and initializing the rows.
                        this.columnDef.cell = this.cell;
                        this.columnDef.headerCell = this.headerCell;
                        this._table.addColumnDef(this.columnDef);
                    }
                    else {
                        throw getTableTextColumnMissingParentTableError();
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTextColumn.prototype.ngOnDestroy = function () {
                    if (this._table) {
                        this._table.removeColumnDef(this.columnDef);
                    }
                };
                /**
                 * Creates a default header text. Use the options' header text transformation function if one
                 * has been provided. Otherwise simply capitalize the column name.
                 * @return {?}
                 */
                CdkTextColumn.prototype._createDefaultHeaderText = function () {
                    /** @type {?} */
                    var name = this.name;
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && !name) {
                        throw getTableTextColumnMissingNameError();
                    }
                    if (this._options && this._options.defaultHeaderTextTransform) {
                        return this._options.defaultHeaderTextTransform(name);
                    }
                    return name[0].toUpperCase() + name.slice(1);
                };
                /**
                 * Synchronizes the column definition name with the text column name.
                 * @private
                 * @return {?}
                 */
                CdkTextColumn.prototype._syncColumnDefName = function () {
                    if (this.columnDef) {
                        this.columnDef.name = this.name;
                    }
                };
                return CdkTextColumn;
            }());
            CdkTextColumn.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'cdk-text-column',
                            template: "\n    <ng-container cdkColumnDef>\n      <th cdk-header-cell *cdkHeaderCellDef [style.text-align]=\"justify\">\n        {{headerText}}\n      </th>\n      <td cdk-cell *cdkCellDef=\"let data\" [style.text-align]=\"justify\">\n        {{dataAccessor(data, name)}}\n      </td>\n    </ng-container>\n  ",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            // Change detection is intentionally not set to OnPush. This component's template will be provided
                            // to the table to be inserted into its view. This is problematic when change detection runs since
                            // the bindings in this template will be evaluated _after_ the table's view is evaluated, which
                            // mean's the template in the table's view will not have the updated value (and in fact will cause
                            // an ExpressionChangedAfterItHasBeenCheckedError).
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                        },] },
            ];
            /** @nocollapse */
            CdkTextColumn.ctorParameters = function () { return [
                { type: CdkTable, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [TEXT_COLUMN_OPTIONS,] }] }
            ]; };
            CdkTextColumn.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                headerText: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                dataAccessor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                justify: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                columnDef: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [CdkColumnDef, { static: true },] }],
                cell: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [CdkCellDef, { static: true },] }],
                headerCell: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [CdkHeaderCellDef, { static: true },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EXPORTED_DECLARATIONS = [
                CdkTable,
                CdkRowDef,
                CdkCellDef,
                CdkCellOutlet,
                CdkHeaderCellDef,
                CdkFooterCellDef,
                CdkColumnDef,
                CdkCell,
                CdkRow,
                CdkHeaderCell,
                CdkFooterCell,
                CdkHeaderRow,
                CdkHeaderRowDef,
                CdkFooterRow,
                CdkFooterRowDef,
                DataRowOutlet,
                HeaderRowOutlet,
                FooterRowOutlet,
                CdkTextColumn,
            ];
            var CdkTableModule = /** @class */ (function () {
                function CdkTableModule() {
                }
                return CdkTableModule;
            }());
            CdkTableModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"]],
                            exports: EXPORTED_DECLARATIONS,
                            declarations: EXPORTED_DECLARATIONS
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=table.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/text-field.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/text-field.js ***!
          \*********************************************************/
        /*! exports provided: AutofillMonitor, CdkAutofill, CdkTextareaAutosize, TextFieldModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutofillMonitor", function () { return AutofillMonitor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkAutofill", function () { return CdkAutofill; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTextareaAutosize", function () { return CdkTextareaAutosize; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextFieldModule", function () { return TextFieldModule; });
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Options to pass to the animationstart listener.
             * @type {?}
             */
            var listenerOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["normalizePassiveListenerOptions"])({ passive: true });
            /**
             * An injectable service that can be used to monitor the autofill state of an input.
             * Based on the following blog post:
             * https://medium.com/\@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7
             */
            var AutofillMonitor = /** @class */ (function () {
                /**
                 * @param {?} _platform
                 * @param {?} _ngZone
                 */
                function AutofillMonitor(_platform, _ngZone) {
                    this._platform = _platform;
                    this._ngZone = _ngZone;
                    this._monitoredElements = new Map();
                }
                /**
                 * @param {?} elementOrRef
                 * @return {?}
                 */
                AutofillMonitor.prototype.monitor = function (elementOrRef) {
                    var _this = this;
                    if (!this._platform.isBrowser) {
                        return rxjs__WEBPACK_IMPORTED_MODULE_3__["EMPTY"];
                    }
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceElement"])(elementOrRef);
                    /** @type {?} */
                    var info = this._monitoredElements.get(element);
                    if (info) {
                        return info.subject.asObservable();
                    }
                    /** @type {?} */
                    var result = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
                    /** @type {?} */
                    var cssClass = 'cdk-text-field-autofilled';
                    /** @type {?} */
                    var listener = ( /** @type {?} */((( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        // Animation events fire on initial element render, we check for the presence of the autofill
                        // CSS class to make sure this is a real change in state, not just the initial render before
                        // we fire off events.
                        if (event.animationName === 'cdk-text-field-autofill-start' &&
                            !element.classList.contains(cssClass)) {
                            element.classList.add(cssClass);
                            _this._ngZone.run(( /**
                             * @return {?}
                             */function () { return result.next({ target: ( /** @type {?} */(event.target)), isAutofilled: true }); }));
                        }
                        else if (event.animationName === 'cdk-text-field-autofill-end' &&
                            element.classList.contains(cssClass)) {
                            element.classList.remove(cssClass);
                            _this._ngZone.run(( /**
                             * @return {?}
                             */function () { return result.next({ target: ( /** @type {?} */(event.target)), isAutofilled: false }); }));
                        }
                    }))));
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        element.addEventListener('animationstart', listener, listenerOptions);
                        element.classList.add('cdk-text-field-autofill-monitored');
                    }));
                    this._monitoredElements.set(element, {
                        subject: result,
                        unlisten: ( /**
                         * @return {?}
                         */function () {
                            element.removeEventListener('animationstart', listener, listenerOptions);
                        })
                    });
                    return result.asObservable();
                };
                /**
                 * @param {?} elementOrRef
                 * @return {?}
                 */
                AutofillMonitor.prototype.stopMonitoring = function (elementOrRef) {
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceElement"])(elementOrRef);
                    /** @type {?} */
                    var info = this._monitoredElements.get(element);
                    if (info) {
                        info.unlisten();
                        info.subject.complete();
                        element.classList.remove('cdk-text-field-autofill-monitored');
                        element.classList.remove('cdk-text-field-autofilled');
                        this._monitoredElements.delete(element);
                    }
                };
                /**
                 * @return {?}
                 */
                AutofillMonitor.prototype.ngOnDestroy = function () {
                    var _this = this;
                    this._monitoredElements.forEach(( /**
                     * @param {?} _info
                     * @param {?} element
                     * @return {?}
                     */function (_info, element) { return _this.stopMonitoring(element); }));
                };
                return AutofillMonitor;
            }());
            AutofillMonitor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            AutofillMonitor.ctorParameters = function () { return [
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["Platform"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
            ]; };
            /** @nocollapse */ AutofillMonitor.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function AutofillMonitor_Factory() { return new AutofillMonitor(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["Platform"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"])); }, token: AutofillMonitor, providedIn: "root" });
            /**
             * A directive that can be used to monitor the autofill state of an input.
             */
            var CdkAutofill = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _autofillMonitor
                 */
                function CdkAutofill(_elementRef, _autofillMonitor) {
                    this._elementRef = _elementRef;
                    this._autofillMonitor = _autofillMonitor;
                    /**
                     * Emits when the autofill state of the element changes.
                     */
                    this.cdkAutofill = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                CdkAutofill.prototype.ngOnInit = function () {
                    var _this = this;
                    this._autofillMonitor
                        .monitor(this._elementRef)
                        .subscribe(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) { return _this.cdkAutofill.emit(event); }));
                };
                /**
                 * @return {?}
                 */
                CdkAutofill.prototype.ngOnDestroy = function () {
                    this._autofillMonitor.stopMonitoring(this._elementRef);
                };
                return CdkAutofill;
            }());
            CdkAutofill.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[cdkAutofill]',
                        },] },
            ];
            /** @nocollapse */
            CdkAutofill.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: AutofillMonitor }
            ]; };
            CdkAutofill.propDecorators = {
                cdkAutofill: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Directive to automatically resize a textarea to fit its content.
             */
            var CdkTextareaAutosize = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _platform
                 * @param {?} _ngZone
                 */
                function CdkTextareaAutosize(_elementRef, _platform, _ngZone) {
                    this._elementRef = _elementRef;
                    this._platform = _platform;
                    this._ngZone = _ngZone;
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
                    this._enabled = true;
                    /**
                     * Value of minRows as of last resize. If the minRows has decreased, the
                     * height of the textarea needs to be recomputed to reflect the new minimum. The maxHeight
                     * does not have the same problem because it does not affect the textarea's scrollHeight.
                     */
                    this._previousMinRows = -1;
                    this._textareaElement = ( /** @type {?} */(this._elementRef.nativeElement));
                }
                Object.defineProperty(CdkTextareaAutosize.prototype, "minRows", {
                    /**
                     * Minimum amount of rows in the textarea.
                     * @return {?}
                     */
                    get: function () { return this._minRows; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._minRows = value;
                        this._setMinHeight();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTextareaAutosize.prototype, "maxRows", {
                    /**
                     * Maximum amount of rows in the textarea.
                     * @return {?}
                     */
                    get: function () { return this._maxRows; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._maxRows = value;
                        this._setMaxHeight();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTextareaAutosize.prototype, "enabled", {
                    /**
                     * Whether autosizing is enabled or not
                     * @return {?}
                     */
                    get: function () { return this._enabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        value = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                        // Only act if the actual value changed. This specifically helps to not run
                        // resizeToFitContent too early (i.e. before ngAfterViewInit)
                        if (this._enabled !== value) {
                            (this._enabled = value) ? this.resizeToFitContent(true) : this.reset();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the minimum height of the textarea as determined by minRows.
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype._setMinHeight = function () {
                    /** @type {?} */
                    var minHeight = this.minRows && this._cachedLineHeight ?
                        this.minRows * this._cachedLineHeight + "px" : null;
                    if (minHeight) {
                        this._textareaElement.style.minHeight = minHeight;
                    }
                };
                /**
                 * Sets the maximum height of the textarea as determined by maxRows.
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype._setMaxHeight = function () {
                    /** @type {?} */
                    var maxHeight = this.maxRows && this._cachedLineHeight ?
                        this.maxRows * this._cachedLineHeight + "px" : null;
                    if (maxHeight) {
                        this._textareaElement.style.maxHeight = maxHeight;
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    if (this._platform.isBrowser) {
                        // Remember the height which we started with in case autosizing is disabled
                        this._initialHeight = this._textareaElement.style.height;
                        this.resizeToFitContent();
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["fromEvent"])(window, 'resize')
                                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["auditTime"])(16), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["takeUntil"])(_this._destroyed))
                                .subscribe(( /**
                         * @return {?}
                         */function () { return _this.resizeToFitContent(true); }));
                        }));
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Cache the height of a single-row textarea if it has not already been cached.
                 *
                 * We need to know how large a single "row" of a textarea is in order to apply minRows and
                 * maxRows. For the initial version, we will assume that the height of a single line in the
                 * textarea does not ever change.
                 * @private
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype._cacheTextareaLineHeight = function () {
                    if (this._cachedLineHeight) {
                        return;
                    }
                    // Use a clone element because we have to override some styles.
                    /** @type {?} */
                    var textareaClone = ( /** @type {?} */(this._textareaElement.cloneNode(false)));
                    textareaClone.rows = 1;
                    // Use `position: absolute` so that this doesn't cause a browser layout and use
                    // `visibility: hidden` so that nothing is rendered. Clear any other styles that
                    // would affect the height.
                    textareaClone.style.position = 'absolute';
                    textareaClone.style.visibility = 'hidden';
                    textareaClone.style.border = 'none';
                    textareaClone.style.padding = '0';
                    textareaClone.style.height = '';
                    textareaClone.style.minHeight = '';
                    textareaClone.style.maxHeight = '';
                    // In Firefox it happens that textarea elements are always bigger than the specified amount
                    // of rows. This is because Firefox tries to add extra space for the horizontal scrollbar.
                    // As a workaround that removes the extra space for the scrollbar, we can just set overflow
                    // to hidden. This ensures that there is no invalid calculation of the line height.
                    // See Firefox bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=33654
                    textareaClone.style.overflow = 'hidden';
                    ( /** @type {?} */(this._textareaElement.parentNode)).appendChild(textareaClone);
                    this._cachedLineHeight = textareaClone.clientHeight;
                    ( /** @type {?} */(this._textareaElement.parentNode)).removeChild(textareaClone);
                    // Min and max heights have to be re-calculated if the cached line height changes
                    this._setMinHeight();
                    this._setMaxHeight();
                };
                /**
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype.ngDoCheck = function () {
                    if (this._platform.isBrowser) {
                        this.resizeToFitContent();
                    }
                };
                /**
                 * Resize the textarea to fit its content.
                 * @param {?=} force Whether to force a height recalculation. By default the height will be
                 *    recalculated only if the value changed since the last call.
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype.resizeToFitContent = function (force) {
                    var _this = this;
                    if (force === void 0) { force = false; }
                    // If autosizing is disabled, just skip everything else
                    if (!this._enabled) {
                        return;
                    }
                    this._cacheTextareaLineHeight();
                    // If we haven't determined the line-height yet, we know we're still hidden and there's no point
                    // in checking the height of the textarea.
                    if (!this._cachedLineHeight) {
                        return;
                    }
                    /** @type {?} */
                    var textarea = ( /** @type {?} */(this._elementRef.nativeElement));
                    /** @type {?} */
                    var value = textarea.value;
                    // Only resize if the value or minRows have changed since these calculations can be expensive.
                    if (!force && this._minRows === this._previousMinRows && value === this._previousValue) {
                        return;
                    }
                    /** @type {?} */
                    var placeholderText = textarea.placeholder;
                    // Reset the textarea height to auto in order to shrink back to its default size.
                    // Also temporarily force overflow:hidden, so scroll bars do not interfere with calculations.
                    // Long placeholders that are wider than the textarea width may lead to a bigger scrollHeight
                    // value. To ensure that the scrollHeight is not bigger than the content, the placeholders
                    // need to be removed temporarily.
                    textarea.classList.add('cdk-textarea-autosize-measuring');
                    textarea.placeholder = '';
                    // The cdk-textarea-autosize-measuring class includes a 2px padding to workaround an issue with
                    // Chrome, so we account for that extra space here by subtracting 4 (2px top + 2px bottom).
                    /** @type {?} */
                    var height = textarea.scrollHeight - 4;
                    // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
                    textarea.style.height = height + "px";
                    textarea.classList.remove('cdk-textarea-autosize-measuring');
                    textarea.placeholder = placeholderText;
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        if (typeof requestAnimationFrame !== 'undefined') {
                            requestAnimationFrame(( /**
                             * @return {?}
                             */function () { return _this._scrollToCaretPosition(textarea); }));
                        }
                        else {
                            setTimeout(( /**
                             * @return {?}
                             */function () { return _this._scrollToCaretPosition(textarea); }));
                        }
                    }));
                    this._previousValue = value;
                    this._previousMinRows = this._minRows;
                };
                /**
                 * Resets the textarea to its original size
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype.reset = function () {
                    // Do not try to change the textarea, if the initialHeight has not been determined yet
                    // This might potentially remove styles when reset() is called before ngAfterViewInit
                    if (this._initialHeight === undefined) {
                        return;
                    }
                    this._textareaElement.style.height = this._initialHeight;
                };
                /**
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype._noopInputHandler = function () {
                    // no-op handler that ensures we're running change detection on input events.
                };
                /**
                 * Scrolls a textarea to the caret position. On Firefox resizing the textarea will
                 * prevent it from scrolling to the caret position. We need to re-set the selection
                 * in order for it to scroll to the proper position.
                 * @private
                 * @param {?} textarea
                 * @return {?}
                 */
                CdkTextareaAutosize.prototype._scrollToCaretPosition = function (textarea) {
                    var selectionStart = textarea.selectionStart, selectionEnd = textarea.selectionEnd;
                    // IE will throw an "Unspecified error" if we try to set the selection range after the
                    // element has been removed from the DOM. Assert that the directive hasn't been destroyed
                    // between the time we requested the animation frame and when it was executed.
                    // Also note that we have to assert that the textarea is focused before we set the
                    // selection range. Setting the selection range on a non-focused textarea will cause
                    // it to receive focus on IE and Edge.
                    if (!this._destroyed.isStopped && document.activeElement === textarea) {
                        textarea.setSelectionRange(selectionStart, selectionEnd);
                    }
                };
                return CdkTextareaAutosize;
            }());
            CdkTextareaAutosize.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'textarea[cdkTextareaAutosize]',
                            exportAs: 'cdkTextareaAutosize',
                            host: {
                                'class': 'cdk-textarea-autosize',
                                // Textarea elements that have the directive applied should have a single row by default.
                                // Browsers normally show two rows by default and therefore this limits the minRows binding.
                                'rows': '1',
                                '(input)': '_noopInputHandler()',
                            },
                        },] },
            ];
            /** @nocollapse */
            CdkTextareaAutosize.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["Platform"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
            ]; };
            CdkTextareaAutosize.propDecorators = {
                minRows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkAutosizeMinRows',] }],
                maxRows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkAutosizeMaxRows',] }],
                enabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['cdkTextareaAutosize',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var TextFieldModule = /** @class */ (function () {
                function TextFieldModule() {
                }
                return TextFieldModule;
            }());
            TextFieldModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            declarations: [CdkAutofill, CdkTextareaAutosize],
                            imports: [_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["PlatformModule"]],
                            exports: [CdkAutofill, CdkTextareaAutosize],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=text-field.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/cdk/esm2015/tree.js": 
        /*!***************************************************!*\
          !*** ./node_modules/@angular/cdk/esm2015/tree.js ***!
          \***************************************************/
        /*! exports provided: BaseTreeControl, FlatTreeControl, NestedTreeControl, CdkNestedTreeNode, CdkTreeNodeOutletContext, CdkTreeNodeDef, CdkTreeNodePadding, CDK_TREE_NODE_OUTLET_NODE, CdkTreeNodeOutlet, CdkTree, CdkTreeNode, getTreeNoValidDataSourceError, getTreeMultipleDefaultNodeDefsError, getTreeMissingMatchingNodeDefError, getTreeControlMissingError, getTreeControlFunctionsMissingError, CdkTreeModule, CdkTreeNodeToggle */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseTreeControl", function () { return BaseTreeControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlatTreeControl", function () { return FlatTreeControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NestedTreeControl", function () { return NestedTreeControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkNestedTreeNode", function () { return CdkNestedTreeNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeNodeOutletContext", function () { return CdkTreeNodeOutletContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeNodeDef", function () { return CdkTreeNodeDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeNodePadding", function () { return CdkTreeNodePadding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_TREE_NODE_OUTLET_NODE", function () { return CDK_TREE_NODE_OUTLET_NODE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeNodeOutlet", function () { return CdkTreeNodeOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTree", function () { return CdkTree; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeNode", function () { return CdkTreeNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTreeNoValidDataSourceError", function () { return getTreeNoValidDataSourceError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTreeMultipleDefaultNodeDefsError", function () { return getTreeMultipleDefaultNodeDefsError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTreeMissingMatchingNodeDefError", function () { return getTreeMissingMatchingNodeDefError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTreeControlMissingError", function () { return getTreeControlMissingError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTreeControlFunctionsMissingError", function () { return getTreeControlFunctionsMissingError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeModule", function () { return CdkTreeModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTreeNodeToggle", function () { return CdkTreeNodeToggle; });
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Base tree control. It has basic toggle/expand/collapse operations on a single data node.
             * @abstract
             * @template T
             */
            var BaseTreeControl = /** @class */ (function () {
                function BaseTreeControl() {
                    /**
                     * A selection model with multi-selection to track expansion status.
                     */
                    this.expansionModel = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_0__["SelectionModel"](true);
                }
                /**
                 * Toggles one single data node's expanded/collapsed state.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.toggle = function (dataNode) {
                    this.expansionModel.toggle(dataNode);
                };
                /**
                 * Expands one single data node.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.expand = function (dataNode) {
                    this.expansionModel.select(dataNode);
                };
                /**
                 * Collapses one single data node.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.collapse = function (dataNode) {
                    this.expansionModel.deselect(dataNode);
                };
                /**
                 * Whether a given data node is expanded or not. Returns true if the data node is expanded.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.isExpanded = function (dataNode) {
                    return this.expansionModel.isSelected(dataNode);
                };
                /**
                 * Toggles a subtree rooted at `node` recursively.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.toggleDescendants = function (dataNode) {
                    this.expansionModel.isSelected(dataNode)
                        ? this.collapseDescendants(dataNode)
                        : this.expandDescendants(dataNode);
                };
                /**
                 * Collapse all dataNodes in the tree.
                 * @return {?}
                 */
                BaseTreeControl.prototype.collapseAll = function () {
                    this.expansionModel.clear();
                };
                /**
                 * Expands a subtree rooted at given data node recursively.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.expandDescendants = function (dataNode) {
                    var _c;
                    /** @type {?} */
                    var toBeProcessed = [dataNode];
                    toBeProcessed.push.apply(toBeProcessed, this.getDescendants(dataNode));
                    (_c = this.expansionModel).select.apply(_c, toBeProcessed);
                };
                /**
                 * Collapses a subtree rooted at given data node recursively.
                 * @param {?} dataNode
                 * @return {?}
                 */
                BaseTreeControl.prototype.collapseDescendants = function (dataNode) {
                    var _c;
                    /** @type {?} */
                    var toBeProcessed = [dataNode];
                    toBeProcessed.push.apply(toBeProcessed, this.getDescendants(dataNode));
                    (_c = this.expansionModel).deselect.apply(_c, toBeProcessed);
                };
                return BaseTreeControl;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Flat tree control. Able to expand/collapse a subtree recursively for flattened tree.
             * @template T
             */
            var FlatTreeControl = /** @class */ (function (_super_1) {
                __extends(FlatTreeControl, _super_1);
                /**
                 * Construct with flat tree data node functions getLevel and isExpandable.
                 * @param {?} getLevel
                 * @param {?} isExpandable
                 */
                function FlatTreeControl(getLevel, isExpandable) {
                    var _this = _super_1.call(this) || this;
                    _this.getLevel = getLevel;
                    _this.isExpandable = isExpandable;
                    return _this;
                }
                /**
                 * Gets a list of the data node's subtree of descendent data nodes.
                 *
                 * To make this working, the `dataNodes` of the TreeControl must be flattened tree nodes
                 * with correct levels.
                 * @param {?} dataNode
                 * @return {?}
                 */
                FlatTreeControl.prototype.getDescendants = function (dataNode) {
                    /** @type {?} */
                    var startIndex = this.dataNodes.indexOf(dataNode);
                    /** @type {?} */
                    var results = [];
                    // Goes through flattened tree nodes in the `dataNodes` array, and get all descendants.
                    // The level of descendants of a tree node must be greater than the level of the given
                    // tree node.
                    // If we reach a node whose level is equal to the level of the tree node, we hit a sibling.
                    // If we reach a node whose level is greater than the level of the tree node, we hit a
                    // sibling of an ancestor.
                    for (var i = startIndex + 1; i < this.dataNodes.length && this.getLevel(dataNode) < this.getLevel(this.dataNodes[i]); i++) {
                        results.push(this.dataNodes[i]);
                    }
                    return results;
                };
                /**
                 * Expands all data nodes in the tree.
                 *
                 * To make this working, the `dataNodes` variable of the TreeControl must be set to all flattened
                 * data nodes of the tree.
                 * @return {?}
                 */
                FlatTreeControl.prototype.expandAll = function () {
                    var _c;
                    (_c = this.expansionModel).select.apply(_c, this.dataNodes);
                };
                return FlatTreeControl;
            }(BaseTreeControl));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Nested tree control. Able to expand/collapse a subtree recursively for NestedNode type.
             * @template T
             */
            var NestedTreeControl = /** @class */ (function (_super_1) {
                __extends(NestedTreeControl, _super_1);
                /**
                 * Construct with nested tree function getChildren.
                 * @param {?} getChildren
                 */
                function NestedTreeControl(getChildren) {
                    var _this = _super_1.call(this) || this;
                    _this.getChildren = getChildren;
                    return _this;
                }
                /**
                 * Expands all dataNodes in the tree.
                 *
                 * To make this working, the `dataNodes` variable of the TreeControl must be set to all root level
                 * data nodes of the tree.
                 * @return {?}
                 */
                NestedTreeControl.prototype.expandAll = function () {
                    var _c;
                    var _this = this;
                    this.expansionModel.clear();
                    /** @type {?} */
                    var allNodes = this.dataNodes.reduce(( /**
                     * @param {?} accumulator
                     * @param {?} dataNode
                     * @return {?}
                     */function (accumulator, dataNode) { return accumulator.concat(_this.getDescendants(dataNode), [dataNode]); }), []);
                    (_c = this.expansionModel).select.apply(_c, allNodes);
                };
                /**
                 * Gets a list of descendant dataNodes of a subtree rooted at given data node recursively.
                 * @param {?} dataNode
                 * @return {?}
                 */
                NestedTreeControl.prototype.getDescendants = function (dataNode) {
                    /** @type {?} */
                    var descendants = [];
                    this._getDescendants(descendants, dataNode);
                    // Remove the node itself
                    return descendants.splice(1);
                };
                /**
                 * A helper function to get descendants recursively.
                 * @protected
                 * @param {?} descendants
                 * @param {?} dataNode
                 * @return {?}
                 */
                NestedTreeControl.prototype._getDescendants = function (descendants, dataNode) {
                    var _this = this;
                    descendants.push(dataNode);
                    /** @type {?} */
                    var childrenNodes = this.getChildren(dataNode);
                    if (Array.isArray(childrenNodes)) {
                        childrenNodes.forEach(( /**
                         * @param {?} child
                         * @return {?}
                         */function (child) { return _this._getDescendants(descendants, child); }));
                    }
                    else if (childrenNodes instanceof rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"]) {
                        // TypeScript as of version 3.5 doesn't seem to treat `Boolean` like a function that
                        // returns a `boolean` specifically in the context of `filter`, so we manually clarify that.
                        childrenNodes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["filter"])(( /** @type {?} */(Boolean))))
                            .subscribe(( /**
                     * @param {?} children
                     * @return {?}
                     */function (/**
                     * @param {?} children
                     * @return {?}
                     */ children) {
                            for (var _c = 0, children_1 = children; _c < children_1.length; _c++) {
                                var child = children_1[_c];
                                _this._getDescendants(descendants, child);
                            }
                        }));
                    }
                };
                return NestedTreeControl;
            }(BaseTreeControl));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token used to provide a `CdkTreeNode` to its outlet.
             * Used primarily to avoid circular imports.
             * \@docs-private
             * @type {?}
             */
            var CDK_TREE_NODE_OUTLET_NODE = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('CDK_TREE_NODE_OUTLET_NODE');
            /**
             * Outlet for nested CdkNode. Put `[cdkTreeNodeOutlet]` on a tag to place children dataNodes
             * inside the outlet.
             */
            var CdkTreeNodeOutlet = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?=} _node
                 */
                function CdkTreeNodeOutlet(viewContainer, _node) {
                    this.viewContainer = viewContainer;
                    this._node = _node;
                }
                return CdkTreeNodeOutlet;
            }());
            CdkTreeNodeOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: '[cdkTreeNodeOutlet]'
                        },] },
            ];
            /** @nocollapse */
            CdkTreeNodeOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [CDK_TREE_NODE_OUTLET_NODE,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Context provided to the tree node component.
             * @template T
             */
            var CdkTreeNodeOutletContext = /** @class */ (function () {
                /**
                 * @param {?} data
                 */
                function CdkTreeNodeOutletContext(data) {
                    this.$implicit = data;
                }
                return CdkTreeNodeOutletContext;
            }());
            /**
             * Data node definition for the CdkTree.
             * Captures the node's template and a when predicate that describes when this node should be used.
             * @template T
             */
            var CdkTreeNodeDef = /** @class */ (function () {
                /**
                 * \@docs-private
                 * @param {?} template
                 */
                function CdkTreeNodeDef(template) {
                    this.template = template;
                }
                return CdkTreeNodeDef;
            }());
            CdkTreeNodeDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: '[cdkTreeNodeDef]',
                            inputs: [
                                'when: cdkTreeNodeDefWhen'
                            ],
                        },] },
            ];
            /** @nocollapse */
            CdkTreeNodeDef.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["TemplateRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns an error to be thrown when there is no usable data.
             * \@docs-private
             * @return {?}
             */
            function getTreeNoValidDataSourceError() {
                return Error("A valid data source must be provided.");
            }
            /**
             * Returns an error to be thrown when there are multiple nodes that are missing a when function.
             * \@docs-private
             * @return {?}
             */
            function getTreeMultipleDefaultNodeDefsError() {
                return Error("There can only be one default row without a when predicate function.");
            }
            /**
             * Returns an error to be thrown when there are no matching node defs for a particular set of data.
             * \@docs-private
             * @return {?}
             */
            function getTreeMissingMatchingNodeDefError() {
                return Error("Could not find a matching node definition for the provided node data.");
            }
            /**
             * Returns an error to be thrown when there are tree control.
             * \@docs-private
             * @return {?}
             */
            function getTreeControlMissingError() {
                return Error("Could not find a tree control for the tree.");
            }
            /**
             * Returns an error to be thrown when tree control did not implement functions for flat/nested node.
             * \@docs-private
             * @return {?}
             */
            function getTreeControlFunctionsMissingError() {
                return Error("Could not find functions for nested/flat tree in tree control.");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * CDK tree component that connects with a data source to retrieve data of type `T` and renders
             * dataNodes with hierarchy. Updates the dataNodes when new data is provided by the data source.
             * @template T
             */
            var CdkTree = /** @class */ (function () {
                /**
                 * @param {?} _differs
                 * @param {?} _changeDetectorRef
                 */
                function CdkTree(_differs, _changeDetectorRef) {
                    this._differs = _differs;
                    this._changeDetectorRef = _changeDetectorRef;
                    /**
                     * Subject that emits when the component has been destroyed.
                     */
                    this._onDestroy = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * Level of nodes
                     */
                    this._levels = new Map();
                    // TODO(tinayuangao): Setup a listener for scrolling, emit the calculated view to viewChange.
                    //     Remove the MAX_VALUE in viewChange
                    /**
                     * Stream containing the latest information on what rows are being displayed on screen.
                     * Can be used by the data source to as a heuristic of what data should be provided.
                     */
                    this.viewChange = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"]({ start: 0, end: Number.MAX_VALUE });
                }
                Object.defineProperty(CdkTree.prototype, "dataSource", {
                    /**
                     * Provides a stream containing the latest data array to render. Influenced by the tree's
                     * stream of view window (what dataNodes are currently on screen).
                     * Data source can be an observable of data array, or a data array to render.
                     * @return {?}
                     */
                    get: function () { return this._dataSource; },
                    /**
                     * @param {?} dataSource
                     * @return {?}
                     */
                    set: function (dataSource) {
                        if (this._dataSource !== dataSource) {
                            this._switchDataSource(dataSource);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkTree.prototype.ngOnInit = function () {
                    this._dataDiffer = this._differs.find([]).create(this.trackBy);
                    if (!this.treeControl) {
                        throw getTreeControlMissingError();
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTree.prototype.ngOnDestroy = function () {
                    this._nodeOutlet.viewContainer.clear();
                    this._onDestroy.next();
                    this._onDestroy.complete();
                    if (this._dataSource && typeof (( /** @type {?} */(this._dataSource))).disconnect === 'function') {
                        (( /** @type {?} */(this.dataSource))).disconnect(this);
                    }
                    if (this._dataSubscription) {
                        this._dataSubscription.unsubscribe();
                        this._dataSubscription = null;
                    }
                };
                /**
                 * @return {?}
                 */
                CdkTree.prototype.ngAfterContentChecked = function () {
                    /** @type {?} */
                    var defaultNodeDefs = this._nodeDefs.filter(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return !def.when; }));
                    if (defaultNodeDefs.length > 1) {
                        throw getTreeMultipleDefaultNodeDefsError();
                    }
                    this._defaultNodeDef = defaultNodeDefs[0];
                    if (this.dataSource && this._nodeDefs && !this._dataSubscription) {
                        this._observeRenderChanges();
                    }
                };
                // TODO(tinayuangao): Work on keyboard traversal and actions, make sure it's working for RTL
                //     and nested trees.
                /**
                 * Switch to the provided data source by resetting the data and unsubscribing from the current
                 * render change subscription if one exists. If the data source is null, interpret this by
                 * clearing the node outlet. Otherwise start listening for new data.
                 * @private
                 * @param {?} dataSource
                 * @return {?}
                 */
                CdkTree.prototype._switchDataSource = function (dataSource) {
                    if (this._dataSource && typeof (( /** @type {?} */(this._dataSource))).disconnect === 'function') {
                        (( /** @type {?} */(this.dataSource))).disconnect(this);
                    }
                    if (this._dataSubscription) {
                        this._dataSubscription.unsubscribe();
                        this._dataSubscription = null;
                    }
                    // Remove the all dataNodes if there is now no data source
                    if (!dataSource) {
                        this._nodeOutlet.viewContainer.clear();
                    }
                    this._dataSource = dataSource;
                    if (this._nodeDefs) {
                        this._observeRenderChanges();
                    }
                };
                /**
                 * Set up a subscription for the data provided by the data source.
                 * @private
                 * @return {?}
                 */
                CdkTree.prototype._observeRenderChanges = function () {
                    var _this = this;
                    /** @type {?} */
                    var dataStream;
                    if (Object(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_0__["isDataSource"])(this._dataSource)) {
                        dataStream = this._dataSource.connect(this);
                    }
                    else if (this._dataSource instanceof rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"]) {
                        dataStream = this._dataSource;
                    }
                    else if (Array.isArray(this._dataSource)) {
                        dataStream = Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["of"])(this._dataSource);
                    }
                    if (dataStream) {
                        this._dataSubscription = dataStream.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["takeUntil"])(this._onDestroy))
                            .subscribe(( /**
                     * @param {?} data
                     * @return {?}
                     */function (/**
                     * @param {?} data
                     * @return {?}
                     */ data) { return _this.renderNodeChanges(data); }));
                    }
                    else {
                        throw getTreeNoValidDataSourceError();
                    }
                };
                /**
                 * Check for changes made in the data and render each change (node added/removed/moved).
                 * @param {?} data
                 * @param {?=} dataDiffer
                 * @param {?=} viewContainer
                 * @param {?=} parentData
                 * @return {?}
                 */
                CdkTree.prototype.renderNodeChanges = function (data, dataDiffer, viewContainer, parentData) {
                    var _this = this;
                    if (dataDiffer === void 0) { dataDiffer = this._dataDiffer; }
                    if (viewContainer === void 0) { viewContainer = this._nodeOutlet.viewContainer; }
                    /** @type {?} */
                    var changes = dataDiffer.diff(data);
                    if (!changes) {
                        return;
                    }
                    changes.forEachOperation(( /**
                     * @param {?} item
                     * @param {?} adjustedPreviousIndex
                     * @param {?} currentIndex
                     * @return {?}
                     */function (item, adjustedPreviousIndex, currentIndex) {
                        if (item.previousIndex == null) {
                            _this.insertNode(data[( /** @type {?} */(currentIndex))], ( /** @type {?} */(currentIndex)), viewContainer, parentData);
                        }
                        else if (currentIndex == null) {
                            viewContainer.remove(( /** @type {?} */(adjustedPreviousIndex)));
                            _this._levels.delete(item.item);
                        }
                        else {
                            /** @type {?} */
                            var view = viewContainer.get(( /** @type {?} */(adjustedPreviousIndex)));
                            viewContainer.move(( /** @type {?} */(view)), currentIndex);
                        }
                    }));
                    this._changeDetectorRef.detectChanges();
                };
                /**
                 * Finds the matching node definition that should be used for this node data. If there is only
                 * one node definition, it is returned. Otherwise, find the node definition that has a when
                 * predicate that returns true with the data. If none return true, return the default node
                 * definition.
                 * @param {?} data
                 * @param {?} i
                 * @return {?}
                 */
                CdkTree.prototype._getNodeDef = function (data, i) {
                    if (this._nodeDefs.length === 1) {
                        return this._nodeDefs.first;
                    }
                    /** @type {?} */
                    var nodeDef = this._nodeDefs.find(( /**
                     * @param {?} def
                     * @return {?}
                     */function (/**
                     * @param {?} def
                     * @return {?}
                     */ def) { return def.when && def.when(i, data); })) || this._defaultNodeDef;
                    if (!nodeDef) {
                        throw getTreeMissingMatchingNodeDefError();
                    }
                    return nodeDef;
                };
                /**
                 * Create the embedded view for the data node template and place it in the correct index location
                 * within the data node view container.
                 * @param {?} nodeData
                 * @param {?} index
                 * @param {?=} viewContainer
                 * @param {?=} parentData
                 * @return {?}
                 */
                CdkTree.prototype.insertNode = function (nodeData, index, viewContainer, parentData) {
                    /** @type {?} */
                    var node = this._getNodeDef(nodeData, index);
                    // Node context that will be provided to created embedded view
                    /** @type {?} */
                    var context = new CdkTreeNodeOutletContext(nodeData);
                    // If the tree is flat tree, then use the `getLevel` function in flat tree control
                    // Otherwise, use the level of parent node.
                    if (this.treeControl.getLevel) {
                        context.level = this.treeControl.getLevel(nodeData);
                    }
                    else if (typeof parentData !== 'undefined' && this._levels.has(parentData)) {
                        context.level = ( /** @type {?} */(this._levels.get(parentData))) + 1;
                    }
                    else {
                        context.level = 0;
                    }
                    this._levels.set(nodeData, context.level);
                    // Use default tree nodeOutlet, or nested node's nodeOutlet
                    /** @type {?} */
                    var container = viewContainer ? viewContainer : this._nodeOutlet.viewContainer;
                    container.createEmbeddedView(node.template, context, index);
                    // Set the data to just created `CdkTreeNode`.
                    // The `CdkTreeNode` created from `createEmbeddedView` will be saved in static variable
                    //     `mostRecentTreeNode`. We get it from static variable and pass the node data to it.
                    if (CdkTreeNode.mostRecentTreeNode) {
                        CdkTreeNode.mostRecentTreeNode.data = nodeData;
                    }
                };
                return CdkTree;
            }());
            CdkTree.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'cdk-tree',
                            exportAs: 'cdkTree',
                            template: "<ng-container cdkTreeNodeOutlet></ng-container>",
                            host: {
                                'class': 'cdk-tree',
                                'role': 'tree',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                            // The "OnPush" status for the `CdkTree` component is effectively a noop, so we are removing it.
                            // The view for `CdkTree` consists entirely of templates declared in other views. As they are
                            // declared elsewhere, they are checked when their declaration points are checked.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].Default
                        },] },
            ];
            /** @nocollapse */
            CdkTree.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["IterableDiffers"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] }
            ]; };
            CdkTree.propDecorators = {
                dataSource: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                treeControl: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                trackBy: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                _nodeOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"], args: [CdkTreeNodeOutlet, { static: true },] }],
                _nodeDefs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [CdkTreeNodeDef,] }]
            };
            /**
             * Tree node for CdkTree. It contains the data in the tree node.
             * @template T
             */
            var CdkTreeNode = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _tree
                 */
                function CdkTreeNode(_elementRef, _tree) {
                    this._elementRef = _elementRef;
                    this._tree = _tree;
                    /**
                     * Subject that emits when the component has been destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * Emits when the node's data has changed.
                     */
                    this._dataChanges = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * The role of the node should be 'group' if it's an internal node,
                     * and 'treeitem' if it's a leaf node.
                     */
                    this.role = 'treeitem';
                    CdkTreeNode.mostRecentTreeNode = ( /** @type {?} */(this));
                }
                Object.defineProperty(CdkTreeNode.prototype, "data", {
                    /**
                     * The tree node's data.
                     * @return {?}
                     */
                    get: function () { return this._data; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== this._data) {
                            this._data = value;
                            this._setRoleFromData();
                            this._dataChanges.next();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTreeNode.prototype, "isExpanded", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._tree.treeControl.isExpanded(this._data);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTreeNode.prototype, "level", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._tree.treeControl.getLevel ? this._tree.treeControl.getLevel(this._data) : 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkTreeNode.prototype.ngOnDestroy = function () {
                    // If this is the last tree node being destroyed,
                    // clear out the reference to avoid leaking memory.
                    if (CdkTreeNode.mostRecentTreeNode === this) {
                        CdkTreeNode.mostRecentTreeNode = null;
                    }
                    this._dataChanges.complete();
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Focuses the menu item. Implements for FocusableOption.
                 * @return {?}
                 */
                CdkTreeNode.prototype.focus = function () {
                    this._elementRef.nativeElement.focus();
                };
                /**
                 * @protected
                 * @return {?}
                 */
                CdkTreeNode.prototype._setRoleFromData = function () {
                    var _this = this;
                    if (this._tree.treeControl.isExpandable) {
                        this.role = this._tree.treeControl.isExpandable(this._data) ? 'group' : 'treeitem';
                    }
                    else {
                        if (!this._tree.treeControl.getChildren) {
                            throw getTreeControlFunctionsMissingError();
                        }
                        /** @type {?} */
                        var childrenNodes = this._tree.treeControl.getChildren(this._data);
                        if (Array.isArray(childrenNodes)) {
                            this._setRoleFromChildren(( /** @type {?} */(childrenNodes)));
                        }
                        else if (childrenNodes instanceof rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"]) {
                            childrenNodes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["takeUntil"])(this._destroyed))
                                .subscribe(( /**
                         * @param {?} children
                         * @return {?}
                         */function (/**
                         * @param {?} children
                         * @return {?}
                         */ children) { return _this._setRoleFromChildren(children); }));
                        }
                    }
                };
                /**
                 * @protected
                 * @param {?} children
                 * @return {?}
                 */
                CdkTreeNode.prototype._setRoleFromChildren = function (children) {
                    this.role = children && children.length ? 'group' : 'treeitem';
                };
                return CdkTreeNode;
            }());
            /**
             * The most recently created `CdkTreeNode`. We save it in static variable so we can retrieve it
             * in `CdkTree` and set the data to it.
             */
            CdkTreeNode.mostRecentTreeNode = null;
            CdkTreeNode.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'cdk-tree-node',
                            exportAs: 'cdkTreeNode',
                            host: {
                                '[attr.aria-expanded]': 'isExpanded',
                                '[attr.aria-level]': 'role === "treeitem" ? level : null',
                                '[attr.role]': 'role',
                                'class': 'cdk-tree-node',
                            },
                        },] },
            ];
            /** @nocollapse */
            CdkTreeNode.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: CdkTree }
            ]; };
            CdkTreeNode.propDecorators = {
                role: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Nested node is a child of `<cdk-tree>`. It works with nested tree.
             * By using `cdk-nested-tree-node` component in tree node template, children of the parent node will
             * be added in the `cdkTreeNodeOutlet` in tree node template.
             * For example:
             *   ```html
             *   <cdk-nested-tree-node>
             *     {{node.name}}
             *     <ng-template cdkTreeNodeOutlet></ng-template>
             *   </cdk-nested-tree-node>
             *   ```
             * The children of node will be automatically added to `cdkTreeNodeOutlet`, the result dom will be
             * like this:
             *   ```html
             *   <cdk-nested-tree-node>
             *     {{node.name}}
             *      <cdk-nested-tree-node>{{child1.name}}</cdk-nested-tree-node>
             *      <cdk-nested-tree-node>{{child2.name}}</cdk-nested-tree-node>
             *   </cdk-nested-tree-node>
             *   ```
             * @template T
             */
            var CdkNestedTreeNode = /** @class */ (function (_super_1) {
                __extends(CdkNestedTreeNode, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _tree
                 * @param {?} _differs
                 */
                function CdkNestedTreeNode(_elementRef, _tree, _differs) {
                    var _this = _super_1.call(this, _elementRef, _tree) || this;
                    _this._elementRef = _elementRef;
                    _this._tree = _tree;
                    _this._differs = _differs;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                CdkNestedTreeNode.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._dataDiffer = this._differs.find([]).create(this._tree.trackBy);
                    if (!this._tree.treeControl.getChildren) {
                        throw getTreeControlFunctionsMissingError();
                    }
                    /** @type {?} */
                    var childrenNodes = this._tree.treeControl.getChildren(this.data);
                    if (Array.isArray(childrenNodes)) {
                        this.updateChildrenNodes(( /** @type {?} */(childrenNodes)));
                    }
                    else if (childrenNodes instanceof rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"]) {
                        childrenNodes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["takeUntil"])(this._destroyed))
                            .subscribe(( /**
                     * @param {?} result
                     * @return {?}
                     */function (/**
                     * @param {?} result
                     * @return {?}
                     */ result) { return _this.updateChildrenNodes(result); }));
                    }
                    this.nodeOutlet.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () { return _this.updateChildrenNodes(); }));
                };
                /**
                 * @return {?}
                 */
                CdkNestedTreeNode.prototype.ngOnDestroy = function () {
                    this._clear();
                    _super_1.prototype.ngOnDestroy.call(this);
                };
                /**
                 * Add children dataNodes to the NodeOutlet
                 * @protected
                 * @param {?=} children
                 * @return {?}
                 */
                CdkNestedTreeNode.prototype.updateChildrenNodes = function (children) {
                    /** @type {?} */
                    var outlet = this._getNodeOutlet();
                    if (children) {
                        this._children = children;
                    }
                    if (outlet && this._children) {
                        /** @type {?} */
                        var viewContainer = outlet.viewContainer;
                        this._tree.renderNodeChanges(this._children, this._dataDiffer, viewContainer, this._data);
                    }
                    else {
                        // Reset the data differ if there's no children nodes displayed
                        this._dataDiffer.diff([]);
                    }
                };
                /**
                 * Clear the children dataNodes.
                 * @protected
                 * @return {?}
                 */
                CdkNestedTreeNode.prototype._clear = function () {
                    /** @type {?} */
                    var outlet = this._getNodeOutlet();
                    if (outlet) {
                        outlet.viewContainer.clear();
                        this._dataDiffer.diff([]);
                    }
                };
                /**
                 * Gets the outlet for the current node.
                 * @private
                 * @return {?}
                 */
                CdkNestedTreeNode.prototype._getNodeOutlet = function () {
                    var _this = this;
                    /** @type {?} */
                    var outlets = this.nodeOutlet;
                    // Note that since we use `descendants: true` on the query, we have to ensure
                    // that we don't pick up the outlet of a child node by accident.
                    return outlets && outlets.find(( /**
                     * @param {?} outlet
                     * @return {?}
                     */function (/**
                     * @param {?} outlet
                     * @return {?}
                     */ outlet) { return !outlet._node || outlet._node === _this; }));
                };
                return CdkNestedTreeNode;
            }(CdkTreeNode));
            CdkNestedTreeNode.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'cdk-nested-tree-node',
                            exportAs: 'cdkNestedTreeNode',
                            host: {
                                '[attr.aria-expanded]': 'isExpanded',
                                '[attr.role]': 'role',
                                'class': 'cdk-tree-node cdk-nested-tree-node',
                            },
                            providers: [
                                { provide: CdkTreeNode, useExisting: CdkNestedTreeNode },
                                { provide: CDK_TREE_NODE_OUTLET_NODE, useExisting: CdkNestedTreeNode }
                            ]
                        },] },
            ];
            /** @nocollapse */
            CdkNestedTreeNode.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: CdkTree },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["IterableDiffers"] }
            ]; };
            CdkNestedTreeNode.propDecorators = {
                nodeOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [CdkTreeNodeOutlet, {
                                // We need to use `descendants: true`, because Ivy will no longer match
                                // indirect descendants if it's left as false.
                                descendants: true
                            },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Regex used to split a string on its CSS units.
             * @type {?}
             */
            var cssUnitPattern = /([A-Za-z%]+)$/;
            /**
             * Indent for the children tree dataNodes.
             * This directive will add left-padding to the node to show hierarchy.
             * @template T
             */
            var CdkTreeNodePadding = /** @class */ (function () {
                /**
                 * @param {?} _treeNode
                 * @param {?} _tree
                 * @param {?} _renderer
                 * @param {?} _element
                 * @param {?} _dir
                 */
                function CdkTreeNodePadding(_treeNode, _tree, _renderer, _element, _dir) {
                    var _this = this;
                    this._treeNode = _treeNode;
                    this._tree = _tree;
                    this._renderer = _renderer;
                    this._element = _element;
                    this._dir = _dir;
                    /**
                     * Subject that emits when the component has been destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * CSS units used for the indentation value.
                     */
                    this.indentUnits = 'px';
                    this._indent = 40;
                    this._setPadding();
                    if (_dir) {
                        _dir.change.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["takeUntil"])(this._destroyed)).subscribe(( /**
                         * @return {?}
                         */function () { return _this._setPadding(true); }));
                    }
                    // In Ivy the indentation binding might be set before the tree node's data has been added,
                    // which means that we'll miss the first render. We have to subscribe to changes in the
                    // data to ensure that everything is up to date.
                    _treeNode._dataChanges.subscribe(( /**
                     * @return {?}
                     */function () { return _this._setPadding(); }));
                }
                Object.defineProperty(CdkTreeNodePadding.prototype, "level", {
                    /**
                     * The level of depth of the tree node. The padding will be `level * indent` pixels.
                     * @return {?}
                     */
                    get: function () { return this._level; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        // Set to null as the fallback value so that _setPadding can fall back to the node level if the
                        // consumer set the directive as `cdkTreeNodePadding=""`. We still want to take this value if
                        // they set 0 explicitly.
                        this._level = ( /** @type {?} */(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__["coerceNumberProperty"])(value, null)));
                        this._setPadding();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(CdkTreeNodePadding.prototype, "indent", {
                    /**
                     * The indent for each level. Can be a number or a CSS string.
                     * Default number 40px from material design menu sub-menu spec.
                     * @return {?}
                     */
                    get: function () { return this._indent; },
                    /**
                     * @param {?} indent
                     * @return {?}
                     */
                    set: function (indent) {
                        /** @type {?} */
                        var value = indent;
                        /** @type {?} */
                        var units = 'px';
                        if (typeof indent === 'string') {
                            /** @type {?} */
                            var parts = indent.split(cssUnitPattern);
                            value = parts[0];
                            units = parts[1] || units;
                        }
                        this.indentUnits = units;
                        this._indent = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__["coerceNumberProperty"])(value);
                        this._setPadding();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                CdkTreeNodePadding.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * The padding indent value for the tree node. Returns a string with px numbers if not null.
                 * @return {?}
                 */
                CdkTreeNodePadding.prototype._paddingIndent = function () {
                    /** @type {?} */
                    var nodeLevel = (this._treeNode.data && this._tree.treeControl.getLevel)
                        ? this._tree.treeControl.getLevel(this._treeNode.data)
                        : null;
                    /** @type {?} */
                    var level = this._level == null ? nodeLevel : this._level;
                    return typeof level === 'number' ? "" + level * this._indent + this.indentUnits : null;
                };
                /**
                 * @param {?=} forceChange
                 * @return {?}
                 */
                CdkTreeNodePadding.prototype._setPadding = function (forceChange) {
                    if (forceChange === void 0) { forceChange = false; }
                    /** @type {?} */
                    var padding = this._paddingIndent();
                    if (padding !== this._currentPadding || forceChange) {
                        /** @type {?} */
                        var element = this._element.nativeElement;
                        /** @type {?} */
                        var paddingProp = this._dir && this._dir.value === 'rtl' ? 'paddingRight' : 'paddingLeft';
                        /** @type {?} */
                        var resetProp = paddingProp === 'paddingLeft' ? 'paddingRight' : 'paddingLeft';
                        this._renderer.setStyle(element, paddingProp, padding);
                        this._renderer.setStyle(element, resetProp, null);
                        this._currentPadding = padding;
                    }
                };
                return CdkTreeNodePadding;
            }());
            CdkTreeNodePadding.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: '[cdkTreeNodePadding]',
                        },] },
            ];
            /** @nocollapse */
            CdkTreeNodePadding.ctorParameters = function () { return [
                { type: CdkTreeNode },
                { type: CdkTree },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_4__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] }
            ]; };
            CdkTreeNodePadding.propDecorators = {
                level: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkTreeNodePadding',] }],
                indent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkTreeNodePaddingIndent',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Node toggle to expand/collapse the node.
             * @template T
             */
            var CdkTreeNodeToggle = /** @class */ (function () {
                /**
                 * @param {?} _tree
                 * @param {?} _treeNode
                 */
                function CdkTreeNodeToggle(_tree, _treeNode) {
                    this._tree = _tree;
                    this._treeNode = _treeNode;
                    this._recursive = false;
                }
                Object.defineProperty(CdkTreeNodeToggle.prototype, "recursive", {
                    /**
                     * Whether expand/collapse the node recursively.
                     * @return {?}
                     */
                    get: function () { return this._recursive; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._recursive = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                /**
                 * @param {?} event
                 * @return {?}
                 */
                CdkTreeNodeToggle.prototype._toggle = function (event) {
                    this.recursive
                        ? this._tree.treeControl.toggleDescendants(this._treeNode.data)
                        : this._tree.treeControl.toggle(this._treeNode.data);
                    event.stopPropagation();
                };
                return CdkTreeNodeToggle;
            }());
            CdkTreeNodeToggle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{ selector: '[cdkTreeNodeToggle]' },] },
            ];
            /** @nocollapse */
            CdkTreeNodeToggle.ctorParameters = function () { return [
                { type: CdkTree },
                { type: CdkTreeNode }
            ]; };
            CdkTreeNodeToggle.propDecorators = {
                recursive: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['cdkTreeNodeToggleRecursive',] }],
                _toggle: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["HostListener"], args: ['click', ['$event'],] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EXPORTED_DECLARATIONS = [
                CdkNestedTreeNode,
                CdkTreeNodeDef,
                CdkTreeNodePadding,
                CdkTreeNodeToggle,
                CdkTree,
                CdkTreeNode,
                CdkTreeNodeOutlet,
            ];
            var CdkTreeModule = /** @class */ (function () {
                function CdkTreeModule() {
                }
                return CdkTreeModule;
            }());
            CdkTreeModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_7__["CommonModule"]],
                            exports: EXPORTED_DECLARATIONS,
                            declarations: EXPORTED_DECLARATIONS,
                            providers: [_angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_6__["FocusMonitor"], CdkTreeNodeDef]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=tree.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/common/fesm2015/common.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/common/fesm2015/common.js ***!
          \*********************************************************/
        /*! exports provided: ɵangular_packages_common_common_c, ɵangular_packages_common_common_h, ɵangular_packages_common_common_g, ɵangular_packages_common_common_f, ɵangular_packages_common_common_k, ɵangular_packages_common_common_j, ɵangular_packages_common_common_i, ɵangular_packages_common_common_a, ɵangular_packages_common_common_b, ɵangular_packages_common_common_e, ɵangular_packages_common_common_d, ɵregisterLocaleData, registerLocaleData, formatDate, formatCurrency, formatNumber, formatPercent, NgLocaleLocalization, NgLocalization, Plural, NumberFormatStyle, FormStyle, TranslationWidth, FormatWidth, NumberSymbol, WeekDay, getNumberOfCurrencyDigits, getCurrencySymbol, getLocaleDayPeriods, getLocaleDayNames, getLocaleMonthNames, getLocaleId, getLocaleEraNames, getLocaleWeekEndRange, getLocaleFirstDayOfWeek, getLocaleDateFormat, getLocaleDateTimeFormat, getLocaleExtraDayPeriodRules, getLocaleExtraDayPeriods, getLocalePluralCase, getLocaleTimeFormat, getLocaleNumberSymbol, getLocaleNumberFormat, getLocaleCurrencyName, getLocaleCurrencySymbol, ɵparseCookieValue, CommonModule, DeprecatedI18NPipesModule, NgClass, NgClassBase, NgForOf, NgForOfContext, NgIf, NgIfContext, NgPlural, NgPluralCase, NgStyle, NgStyleBase, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet, NgComponentOutlet, DOCUMENT, AsyncPipe, DatePipe, I18nPluralPipe, I18nSelectPipe, JsonPipe, LowerCasePipe, CurrencyPipe, DecimalPipe, PercentPipe, SlicePipe, UpperCasePipe, TitleCasePipe, KeyValuePipe, DeprecatedDatePipe, DeprecatedCurrencyPipe, DeprecatedDecimalPipe, DeprecatedPercentPipe, ɵPLATFORM_BROWSER_ID, ɵPLATFORM_SERVER_ID, ɵPLATFORM_WORKER_APP_ID, ɵPLATFORM_WORKER_UI_ID, isPlatformBrowser, isPlatformServer, isPlatformWorkerApp, isPlatformWorkerUi, VERSION, ViewportScroller, ɵNullViewportScroller, ɵNgClassImplProvider__POST_R3__, ɵNgClassR2Impl, ɵNgClassImpl, ɵNgStyleImplProvider__POST_R3__, ɵNgStyleR2Impl, ɵNgStyleImpl, ɵngStyleDirectiveDef__POST_R3__, ɵngClassDirectiveDef__POST_R3__, PlatformLocation, LOCATION_INITIALIZED, LocationStrategy, APP_BASE_HREF, HashLocationStrategy, PathLocationStrategy, Location */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_c", function () { return COMMON_DIRECTIVES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_h", function () { return NgClassImplProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_g", function () { return NgClassImplProvider__PRE_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_f", function () { return NgClassR3Impl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_k", function () { return NgStyleImplProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_j", function () { return NgStyleImplProvider__PRE_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_i", function () { return NgStyleR3Impl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_a", function () { return DEPRECATED_PLURAL_FN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_b", function () { return getPluralCase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_e", function () { return COMMON_DEPRECATED_I18N_PIPES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_d", function () { return COMMON_PIPES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵregisterLocaleData", function () { return registerLocaleData; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerLocaleData", function () { return registerLocaleData; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDate", function () { return formatDate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatCurrency", function () { return formatCurrency; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatNumber", function () { return formatNumber; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatPercent", function () { return formatPercent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgLocaleLocalization", function () { return NgLocaleLocalization; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgLocalization", function () { return NgLocalization; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Plural", function () { return Plural; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberFormatStyle", function () { return NumberFormatStyle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormStyle", function () { return FormStyle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TranslationWidth", function () { return TranslationWidth; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatWidth", function () { return FormatWidth; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberSymbol", function () { return NumberSymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeekDay", function () { return WeekDay; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNumberOfCurrencyDigits", function () { return getNumberOfCurrencyDigits; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrencySymbol", function () { return getCurrencySymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDayPeriods", function () { return getLocaleDayPeriods; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDayNames", function () { return getLocaleDayNames; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleMonthNames", function () { return getLocaleMonthNames; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleId", function () { return getLocaleId; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleEraNames", function () { return getLocaleEraNames; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleWeekEndRange", function () { return getLocaleWeekEndRange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleFirstDayOfWeek", function () { return getLocaleFirstDayOfWeek; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDateFormat", function () { return getLocaleDateFormat; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDateTimeFormat", function () { return getLocaleDateTimeFormat; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleExtraDayPeriodRules", function () { return getLocaleExtraDayPeriodRules; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleExtraDayPeriods", function () { return getLocaleExtraDayPeriods; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocalePluralCase", function () { return getLocalePluralCase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleTimeFormat", function () { return getLocaleTimeFormat; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleNumberSymbol", function () { return getLocaleNumberSymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleNumberFormat", function () { return getLocaleNumberFormat; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleCurrencyName", function () { return getLocaleCurrencyName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleCurrencySymbol", function () { return getLocaleCurrencySymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵparseCookieValue", function () { return parseCookieValue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommonModule", function () { return CommonModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedI18NPipesModule", function () { return DeprecatedI18NPipesModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgClass", function () { return NgClass; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgClassBase", function () { return NgClassBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForOf", function () { return NgForOf; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForOfContext", function () { return NgForOfContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgIf", function () { return NgIf; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgIfContext", function () { return NgIfContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgPlural", function () { return NgPlural; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgPluralCase", function () { return NgPluralCase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgStyle", function () { return NgStyle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgStyleBase", function () { return NgStyleBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitch", function () { return NgSwitch; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitchCase", function () { return NgSwitchCase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitchDefault", function () { return NgSwitchDefault; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgTemplateOutlet", function () { return NgTemplateOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgComponentOutlet", function () { return NgComponentOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOCUMENT", function () { return DOCUMENT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncPipe", function () { return AsyncPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePipe", function () { return DatePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18nPluralPipe", function () { return I18nPluralPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18nSelectPipe", function () { return I18nSelectPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonPipe", function () { return JsonPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LowerCasePipe", function () { return LowerCasePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrencyPipe", function () { return CurrencyPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DecimalPipe", function () { return DecimalPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PercentPipe", function () { return PercentPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlicePipe", function () { return SlicePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpperCasePipe", function () { return UpperCasePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleCasePipe", function () { return TitleCasePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyValuePipe", function () { return KeyValuePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedDatePipe", function () { return DeprecatedDatePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedCurrencyPipe", function () { return DeprecatedCurrencyPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedDecimalPipe", function () { return DeprecatedDecimalPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedPercentPipe", function () { return DeprecatedPercentPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_BROWSER_ID", function () { return PLATFORM_BROWSER_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_SERVER_ID", function () { return PLATFORM_SERVER_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_WORKER_APP_ID", function () { return PLATFORM_WORKER_APP_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_WORKER_UI_ID", function () { return PLATFORM_WORKER_UI_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformBrowser", function () { return isPlatformBrowser; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformServer", function () { return isPlatformServer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformWorkerApp", function () { return isPlatformWorkerApp; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformWorkerUi", function () { return isPlatformWorkerUi; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportScroller", function () { return ViewportScroller; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNullViewportScroller", function () { return NullViewportScroller; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgClassImplProvider__POST_R3__", function () { return NgClassImplProvider__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgClassR2Impl", function () { return NgClassR2Impl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgClassImpl", function () { return NgClassImpl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgStyleImplProvider__POST_R3__", function () { return NgStyleImplProvider__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgStyleR2Impl", function () { return NgStyleR2Impl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgStyleImpl", function () { return NgStyleImpl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵngStyleDirectiveDef__POST_R3__", function () { return ngStyleDirectiveDef__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵngClassDirectiveDef__POST_R3__", function () { return ngClassDirectiveDef__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformLocation", function () { return PlatformLocation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_INITIALIZED", function () { return LOCATION_INITIALIZED; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationStrategy", function () { return LocationStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_BASE_HREF", function () { return APP_BASE_HREF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashLocationStrategy", function () { return HashLocationStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PathLocationStrategy", function () { return PathLocationStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Location", function () { return Location; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This class should not be used directly by an application developer. Instead, use
             * {\@link Location}.
             *
             * `PlatformLocation` encapsulates all calls to DOM apis, which allows the Router to be platform
             * agnostic.
             * This means that we can have different implementation of `PlatformLocation` for the different
             * platforms that angular supports. For example, `\@angular/platform-browser` provides an
             * implementation specific to the browser environment, while `\@angular/platform-webworker` provides
             * one suitable for use with web workers.
             *
             * The `PlatformLocation` class is used directly by all implementations of {\@link LocationStrategy}
             * when they need to interact with the DOM apis like pushState, popState, etc...
             *
             * {\@link LocationStrategy} in turn is used by the {\@link Location} service which is used directly
             * by the {\@link Router} in order to navigate between routes. Since all interactions between {\@link
             * Router} /
             * {\@link Location} / {\@link LocationStrategy} and DOM apis flow through the `PlatformLocation`
             * class they are all platform independent.
             *
             * \@publicApi
             * @abstract
             */
            var PlatformLocation = /** @class */ (function () {
                function PlatformLocation() {
                }
                return PlatformLocation;
            }());
            if (false) { }
            /**
             * \@description
             * Indicates when a location is initialized.
             *
             * \@publicApi
             * @type {?}
             */
            var LOCATION_INITIALIZED = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('Location Initialized');
            /**
             * \@description
             * A serializable version of the event from `onPopState` or `onHashChange`
             *
             * \@publicApi
             * @record
             */
            function LocationChangeEvent() { }
            if (false) { }
            /**
             * \@publicApi
             * @record
             */
            function LocationChangeListener() { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Enables the `Location` service to read route state from the browser's URL.
             * Angular provides two strategies:
             * `HashLocationStrategy` and `PathLocationStrategy`.
             *
             * Applications should use the `Router` or `Location` services to
             * interact with application route state.
             *
             * For instance, `HashLocationStrategy` produces URLs like
             * <code class="no-auto-link">http://example.com#/foo</code>,
             * and `PathLocationStrategy` produces
             * <code class="no-auto-link">http://example.com/foo</code> as an equivalent URL.
             *
             * See these two classes for more.
             *
             * \@publicApi
             * @abstract
             */
            var LocationStrategy = /** @class */ (function () {
                function LocationStrategy() {
                }
                return LocationStrategy;
            }());
            if (false) { }
            /**
             * A predefined [DI token](guide/glossary#di-token) for the base href
             * to be used with the `PathLocationStrategy`.
             * The base href is the URL prefix that should be preserved when generating
             * and recognizing URLs.
             *
             * \@usageNotes
             *
             * The following example shows how to use this token to configure the root app injector
             * with a base href value, so that the DI framework can supply the dependency anywhere in the app.
             *
             * ```typescript
             * import {Component, NgModule} from '\@angular/core';
             * import {APP_BASE_HREF} from '\@angular/common';
             *
             * \@NgModule({
             *   providers: [{provide: APP_BASE_HREF, useValue: '/my/app'}]
             * })
             * class AppModule {}
             * ```
             *
             * \@publicApi
             * @type {?}
             */
            var APP_BASE_HREF = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('appBaseHref');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @record
             */
            function PopStateEvent() { }
            if (false) { }
            /**
             * \@description
             *
             * A service that applications can use to interact with a browser's URL.
             *
             * Depending on the `LocationStrategy` used, `Location` persists
             * to the URL's path or the URL's hash segment.
             *
             * \@usageNotes
             *
             * It's better to use the `Router#navigate` service to trigger route changes. Use
             * `Location` only if you need to interact with or create normalized URLs outside of
             * routing.
             *
             * `Location` is responsible for normalizing the URL against the application's base href.
             * A normalized URL is absolute from the URL host, includes the application's base href, and has no
             * trailing slash:
             * - `/my/app/user/123` is normalized
             * - `my/app/user/123` **is not** normalized
             * - `/my/app/user/123/` **is not** normalized
             *
             * ### Example
             *
             * <code-example path='common/location/ts/path_location_component.ts'
             * region='LocationComponent'></code-example>
             *
             * \@publicApi
             */
            var Location = /** @class */ (function () {
                /**
                 * @param {?} platformStrategy
                 * @param {?} platformLocation
                 */
                function Location(platformStrategy, platformLocation) {
                    var _this = this;
                    /**
                     * \@internal
                     */
                    this._subject = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * \@internal
                     */
                    this._urlChangeListeners = [];
                    this._platformStrategy = platformStrategy;
                    /** @type {?} */
                    var browserBaseHref = this._platformStrategy.getBaseHref();
                    this._platformLocation = platformLocation;
                    this._baseHref = Location.stripTrailingSlash(_stripIndexHtml(browserBaseHref));
                    this._platformStrategy.onPopState(( /**
                     * @param {?} ev
                     * @return {?}
                     */function (ev) {
                        _this._subject.emit({
                            'url': _this.path(true),
                            'pop': true,
                            'state': ev.state,
                            'type': ev.type,
                        });
                    }));
                }
                /**
                 * Normalizes the URL path for this location.
                 *
                 * @param {?=} includeHash True to include an anchor fragment in the path.
                 *
                 * @return {?} The normalized URL path.
                 */
                // TODO: vsavkin. Remove the boolean flag and always include hash once the deprecated router is
                // removed.
                Location.prototype.path = function (includeHash) {
                    if (includeHash === void 0) { includeHash = false; }
                    return this.normalize(this._platformStrategy.path(includeHash));
                };
                /**
                 * Reports the current state of the location history.
                 * @return {?} The current value of the `history.state` object.
                 */
                Location.prototype.getState = function () { return this._platformLocation.getState(); };
                /**
                 * Normalizes the given path and compares to the current normalized path.
                 *
                 * @param {?} path The given URL path.
                 * @param {?=} query Query parameters.
                 *
                 * @return {?} True if the given URL path is equal to the current normalized path, false
                 * otherwise.
                 */
                Location.prototype.isCurrentPathEqualTo = function (path, query) {
                    if (query === void 0) { query = ''; }
                    return this.path() == this.normalize(path + Location.normalizeQueryParams(query));
                };
                /**
                 * Normalizes a URL path by stripping any trailing slashes.
                 *
                 * @param {?} url String representing a URL.
                 *
                 * @return {?} The normalized URL string.
                 */
                Location.prototype.normalize = function (url) {
                    return Location.stripTrailingSlash(_stripBaseHref(this._baseHref, _stripIndexHtml(url)));
                };
                /**
                 * Normalizes an external URL path.
                 * If the given URL doesn't begin with a leading slash (`'/'`), adds one
                 * before normalizing. Adds a hash if `HashLocationStrategy` is
                 * in use, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
                 *
                 * @param {?} url String representing a URL.
                 *
                 * @return {?} A normalized platform-specific URL.
                 */
                Location.prototype.prepareExternalUrl = function (url) {
                    if (url && url[0] !== '/') {
                        url = '/' + url;
                    }
                    return this._platformStrategy.prepareExternalUrl(url);
                };
                // TODO: rename this method to pushState
                /**
                 * Changes the browser's URL to a normalized version of a given URL, and pushes a
                 * new item onto the platform's history.
                 *
                 * @param {?} path  URL path to normalize.
                 * @param {?=} query Query parameters.
                 * @param {?=} state Location history state.
                 *
                 * @return {?}
                 */
                Location.prototype.go = function (path, query, state) {
                    if (query === void 0) { query = ''; }
                    if (state === void 0) { state = null; }
                    this._platformStrategy.pushState(state, '', path, query);
                    this._notifyUrlChangeListeners(this.prepareExternalUrl(path + Location.normalizeQueryParams(query)), state);
                };
                /**
                 * Changes the browser's URL to a normalized version of the given URL, and replaces
                 * the top item on the platform's history stack.
                 *
                 * @param {?} path  URL path to normalize.
                 * @param {?=} query Query parameters.
                 * @param {?=} state Location history state.
                 * @return {?}
                 */
                Location.prototype.replaceState = function (path, query, state) {
                    if (query === void 0) { query = ''; }
                    if (state === void 0) { state = null; }
                    this._platformStrategy.replaceState(state, '', path, query);
                    this._notifyUrlChangeListeners(this.prepareExternalUrl(path + Location.normalizeQueryParams(query)), state);
                };
                /**
                 * Navigates forward in the platform's history.
                 * @return {?}
                 */
                Location.prototype.forward = function () { this._platformStrategy.forward(); };
                /**
                 * Navigates back in the platform's history.
                 * @return {?}
                 */
                Location.prototype.back = function () { this._platformStrategy.back(); };
                /**
                 * Registers a URL change listener. Use to catch updates performed by the Angular
                 * framework that are not detectible through "popstate" or "hashchange" events.
                 *
                 * @param {?} fn The change handler function, which take a URL and a location history state.
                 * @return {?}
                 */
                Location.prototype.onUrlChange = function (fn) {
                    var _this = this;
                    this._urlChangeListeners.push(fn);
                    this.subscribe(( /**
                     * @param {?} v
                     * @return {?}
                     */function (/**
                     * @param {?} v
                     * @return {?}
                     */ v) { _this._notifyUrlChangeListeners(v.url, v.state); }));
                };
                /**
                 * \@internal
                 * @param {?=} url
                 * @param {?=} state
                 * @return {?}
                 */
                Location.prototype._notifyUrlChangeListeners = function (url, state) {
                    if (url === void 0) { url = ''; }
                    this._urlChangeListeners.forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(url, state); }));
                };
                /**
                 * Subscribes to the platform's `popState` events.
                 *
                 * @param {?} onNext
                 * @param {?=} onThrow
                 * @param {?=} onReturn
                 * @return {?} Subscribed events.
                 */
                Location.prototype.subscribe = function (onNext, onThrow, onReturn) {
                    return this._subject.subscribe({ next: onNext, error: onThrow, complete: onReturn });
                };
                /**
                 * Normalizes URL parameters by prepending with `?` if needed.
                 *
                 * @param {?} params String of URL parameters.
                 *
                 * @return {?} The normalized URL parameters string.
                 */
                Location.normalizeQueryParams = function (params) {
                    return params && params[0] !== '?' ? '?' + params : params;
                };
                /**
                 * Joins two parts of a URL with a slash if needed.
                 *
                 * @param {?} start  URL string
                 * @param {?} end    URL string
                 *
                 *
                 * @return {?} The joined URL string.
                 */
                Location.joinWithSlash = function (start, end) {
                    if (start.length == 0) {
                        return end;
                    }
                    if (end.length == 0) {
                        return start;
                    }
                    /** @type {?} */
                    var slashes = 0;
                    if (start.endsWith('/')) {
                        slashes++;
                    }
                    if (end.startsWith('/')) {
                        slashes++;
                    }
                    if (slashes == 2) {
                        return start + end.substring(1);
                    }
                    if (slashes == 1) {
                        return start + end;
                    }
                    return start + '/' + end;
                };
                /**
                 * Removes a trailing slash from a URL string if needed.
                 * Looks for the first occurrence of either `#`, `?`, or the end of the
                 * line as `/` characters and removes the trailing slash if one exists.
                 *
                 * @param {?} url URL string.
                 *
                 * @return {?} The URL string, modified if needed.
                 */
                Location.stripTrailingSlash = function (url) {
                    /** @type {?} */
                    var match = url.match(/#|\?|$/);
                    /** @type {?} */
                    var pathEndIdx = match && match.index || url.length;
                    /** @type {?} */
                    var droppedSlashIdx = pathEndIdx - (url[pathEndIdx - 1] === '/' ? 1 : 0);
                    return url.slice(0, droppedSlashIdx) + url.slice(pathEndIdx);
                };
                return Location;
            }());
            Location.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            Location.ctorParameters = function () { return [
                { type: LocationStrategy },
                { type: PlatformLocation }
            ]; };
            if (false) { }
            /**
             * @param {?} baseHref
             * @param {?} url
             * @return {?}
             */
            function _stripBaseHref(baseHref, url) {
                return baseHref && url.startsWith(baseHref) ? url.substring(baseHref.length) : url;
            }
            /**
             * @param {?} url
             * @return {?}
             */
            function _stripIndexHtml(url) {
                return url.replace(/\/index.html$/, '');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * A {\@link LocationStrategy} used to configure the {\@link Location} service to
             * represent its state in the
             * [hash fragment](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax)
             * of the browser's URL.
             *
             * For instance, if you call `location.go('/foo')`, the browser's URL will become
             * `example.com#/foo`.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/location/ts/hash_location_component.ts region='LocationComponent'}
             *
             * \@publicApi
             */
            var HashLocationStrategy = /** @class */ (function (_super_1) {
                __extends(HashLocationStrategy, _super_1);
                /**
                 * @param {?} _platformLocation
                 * @param {?=} _baseHref
                 */
                function HashLocationStrategy(_platformLocation, _baseHref) {
                    var _this = _super_1.call(this) || this;
                    _this._platformLocation = _platformLocation;
                    _this._baseHref = '';
                    if (_baseHref != null) {
                        _this._baseHref = _baseHref;
                    }
                    return _this;
                }
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                HashLocationStrategy.prototype.onPopState = function (fn) {
                    this._platformLocation.onPopState(fn);
                    this._platformLocation.onHashChange(fn);
                };
                /**
                 * @return {?}
                 */
                HashLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
                /**
                 * @param {?=} includeHash
                 * @return {?}
                 */
                HashLocationStrategy.prototype.path = function (includeHash) {
                    if (includeHash === void 0) { includeHash = false; }
                    // the hash value is always prefixed with a `#`
                    // and if it is empty then it will stay empty
                    /** @type {?} */
                    var path = this._platformLocation.hash;
                    if (path == null)
                        path = '#';
                    return path.length > 0 ? path.substring(1) : path;
                };
                /**
                 * @param {?} internal
                 * @return {?}
                 */
                HashLocationStrategy.prototype.prepareExternalUrl = function (internal) {
                    /** @type {?} */
                    var url = Location.joinWithSlash(this._baseHref, internal);
                    return url.length > 0 ? ('#' + url) : url;
                };
                /**
                 * @param {?} state
                 * @param {?} title
                 * @param {?} path
                 * @param {?} queryParams
                 * @return {?}
                 */
                HashLocationStrategy.prototype.pushState = function (state, title, path, queryParams) {
                    /** @type {?} */
                    var url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
                    if (url.length == 0) {
                        url = this._platformLocation.pathname;
                    }
                    this._platformLocation.pushState(state, title, url);
                };
                /**
                 * @param {?} state
                 * @param {?} title
                 * @param {?} path
                 * @param {?} queryParams
                 * @return {?}
                 */
                HashLocationStrategy.prototype.replaceState = function (state, title, path, queryParams) {
                    /** @type {?} */
                    var url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
                    if (url.length == 0) {
                        url = this._platformLocation.pathname;
                    }
                    this._platformLocation.replaceState(state, title, url);
                };
                /**
                 * @return {?}
                 */
                HashLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
                /**
                 * @return {?}
                 */
                HashLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
                return HashLocationStrategy;
            }(LocationStrategy));
            HashLocationStrategy.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            HashLocationStrategy.ctorParameters = function () { return [
                { type: PlatformLocation },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [APP_BASE_HREF,] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * A {\@link LocationStrategy} used to configure the {\@link Location} service to
             * represent its state in the
             * [path](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax) of the
             * browser's URL.
             *
             * If you're using `PathLocationStrategy`, you must provide a {\@link APP_BASE_HREF}
             * or add a base element to the document. This URL prefix that will be preserved
             * when generating and recognizing URLs.
             *
             * For instance, if you provide an `APP_BASE_HREF` of `'/my/app'` and call
             * `location.go('/foo')`, the browser's URL will become
             * `example.com/my/app/foo`.
             *
             * Similarly, if you add `<base href='/my/app'/>` to the document and call
             * `location.go('/foo')`, the browser's URL will become
             * `example.com/my/app/foo`.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/location/ts/path_location_component.ts region='LocationComponent'}
             *
             * \@publicApi
             */
            var PathLocationStrategy = /** @class */ (function (_super_1) {
                __extends(PathLocationStrategy, _super_1);
                /**
                 * @param {?} _platformLocation
                 * @param {?=} href
                 */
                function PathLocationStrategy(_platformLocation, href) {
                    var _this = _super_1.call(this) || this;
                    _this._platformLocation = _platformLocation;
                    if (href == null) {
                        href = _this._platformLocation.getBaseHrefFromDOM();
                    }
                    if (href == null) {
                        throw new Error("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
                    }
                    _this._baseHref = href;
                    return _this;
                }
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                PathLocationStrategy.prototype.onPopState = function (fn) {
                    this._platformLocation.onPopState(fn);
                    this._platformLocation.onHashChange(fn);
                };
                /**
                 * @return {?}
                 */
                PathLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
                /**
                 * @param {?} internal
                 * @return {?}
                 */
                PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
                    return Location.joinWithSlash(this._baseHref, internal);
                };
                /**
                 * @param {?=} includeHash
                 * @return {?}
                 */
                PathLocationStrategy.prototype.path = function (includeHash) {
                    if (includeHash === void 0) { includeHash = false; }
                    /** @type {?} */
                    var pathname = this._platformLocation.pathname +
                        Location.normalizeQueryParams(this._platformLocation.search);
                    /** @type {?} */
                    var hash = this._platformLocation.hash;
                    return hash && includeHash ? "" + pathname + hash : pathname;
                };
                /**
                 * @param {?} state
                 * @param {?} title
                 * @param {?} url
                 * @param {?} queryParams
                 * @return {?}
                 */
                PathLocationStrategy.prototype.pushState = function (state, title, url, queryParams) {
                    /** @type {?} */
                    var externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
                    this._platformLocation.pushState(state, title, externalUrl);
                };
                /**
                 * @param {?} state
                 * @param {?} title
                 * @param {?} url
                 * @param {?} queryParams
                 * @return {?}
                 */
                PathLocationStrategy.prototype.replaceState = function (state, title, url, queryParams) {
                    /** @type {?} */
                    var externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
                    this._platformLocation.replaceState(state, title, externalUrl);
                };
                /**
                 * @return {?}
                 */
                PathLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
                /**
                 * @return {?}
                 */
                PathLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
                return PathLocationStrategy;
            }(LocationStrategy));
            PathLocationStrategy.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            PathLocationStrategy.ctorParameters = function () { return [
                { type: PlatformLocation },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [APP_BASE_HREF,] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // THIS CODE IS GENERATED - DO NOT MODIFY
            // See angular/tools/gulp-tasks/cldr/extract.js
            /**
             * \@internal
             * @type {?}
             */
            var CURRENCIES_EN = {
                'ADP': [undefined, undefined, 0],
                'AFN': [undefined, undefined, 0],
                'ALL': [undefined, undefined, 0],
                'AMD': [undefined, undefined, 0],
                'AOA': [undefined, 'Kz'],
                'ARS': [undefined, '$'],
                'AUD': ['A$', '$'],
                'BAM': [undefined, 'KM'],
                'BBD': [undefined, '$'],
                'BDT': [undefined, '৳'],
                'BHD': [undefined, undefined, 3],
                'BIF': [undefined, undefined, 0],
                'BMD': [undefined, '$'],
                'BND': [undefined, '$'],
                'BOB': [undefined, 'Bs'],
                'BRL': ['R$'],
                'BSD': [undefined, '$'],
                'BWP': [undefined, 'P'],
                'BYN': [undefined, 'р.', 2],
                'BYR': [undefined, undefined, 0],
                'BZD': [undefined, '$'],
                'CAD': ['CA$', '$', 2],
                'CHF': [undefined, undefined, 2],
                'CLF': [undefined, undefined, 4],
                'CLP': [undefined, '$', 0],
                'CNY': ['CN¥', '¥'],
                'COP': [undefined, '$', 0],
                'CRC': [undefined, '₡', 2],
                'CUC': [undefined, '$'],
                'CUP': [undefined, '$'],
                'CZK': [undefined, 'Kč', 2],
                'DJF': [undefined, undefined, 0],
                'DKK': [undefined, 'kr', 2],
                'DOP': [undefined, '$'],
                'EGP': [undefined, 'E£'],
                'ESP': [undefined, '₧', 0],
                'EUR': ['€'],
                'FJD': [undefined, '$'],
                'FKP': [undefined, '£'],
                'GBP': ['£'],
                'GEL': [undefined, '₾'],
                'GIP': [undefined, '£'],
                'GNF': [undefined, 'FG', 0],
                'GTQ': [undefined, 'Q'],
                'GYD': [undefined, '$', 0],
                'HKD': ['HK$', '$'],
                'HNL': [undefined, 'L'],
                'HRK': [undefined, 'kn'],
                'HUF': [undefined, 'Ft', 2],
                'IDR': [undefined, 'Rp', 0],
                'ILS': ['₪'],
                'INR': ['₹'],
                'IQD': [undefined, undefined, 0],
                'IRR': [undefined, undefined, 0],
                'ISK': [undefined, 'kr', 0],
                'ITL': [undefined, undefined, 0],
                'JMD': [undefined, '$'],
                'JOD': [undefined, undefined, 3],
                'JPY': ['¥', undefined, 0],
                'KHR': [undefined, '៛'],
                'KMF': [undefined, 'CF', 0],
                'KPW': [undefined, '₩', 0],
                'KRW': ['₩', undefined, 0],
                'KWD': [undefined, undefined, 3],
                'KYD': [undefined, '$'],
                'KZT': [undefined, '₸'],
                'LAK': [undefined, '₭', 0],
                'LBP': [undefined, 'L£', 0],
                'LKR': [undefined, 'Rs'],
                'LRD': [undefined, '$'],
                'LTL': [undefined, 'Lt'],
                'LUF': [undefined, undefined, 0],
                'LVL': [undefined, 'Ls'],
                'LYD': [undefined, undefined, 3],
                'MGA': [undefined, 'Ar', 0],
                'MGF': [undefined, undefined, 0],
                'MMK': [undefined, 'K', 0],
                'MNT': [undefined, '₮', 0],
                'MRO': [undefined, undefined, 0],
                'MUR': [undefined, 'Rs', 0],
                'MXN': ['MX$', '$'],
                'MYR': [undefined, 'RM'],
                'NAD': [undefined, '$'],
                'NGN': [undefined, '₦'],
                'NIO': [undefined, 'C$'],
                'NOK': [undefined, 'kr', 2],
                'NPR': [undefined, 'Rs'],
                'NZD': ['NZ$', '$'],
                'OMR': [undefined, undefined, 3],
                'PHP': [undefined, '₱'],
                'PKR': [undefined, 'Rs', 0],
                'PLN': [undefined, 'zł'],
                'PYG': [undefined, '₲', 0],
                'RON': [undefined, 'lei'],
                'RSD': [undefined, undefined, 0],
                'RUB': [undefined, '₽'],
                'RUR': [undefined, 'р.'],
                'RWF': [undefined, 'RF', 0],
                'SBD': [undefined, '$'],
                'SEK': [undefined, 'kr', 2],
                'SGD': [undefined, '$'],
                'SHP': [undefined, '£'],
                'SLL': [undefined, undefined, 0],
                'SOS': [undefined, undefined, 0],
                'SRD': [undefined, '$'],
                'SSP': [undefined, '£'],
                'STD': [undefined, undefined, 0],
                'STN': [undefined, 'Db'],
                'SYP': [undefined, '£', 0],
                'THB': [undefined, '฿'],
                'TMM': [undefined, undefined, 0],
                'TND': [undefined, undefined, 3],
                'TOP': [undefined, 'T$'],
                'TRL': [undefined, undefined, 0],
                'TRY': [undefined, '₺'],
                'TTD': [undefined, '$'],
                'TWD': ['NT$', '$', 2],
                'TZS': [undefined, undefined, 0],
                'UAH': [undefined, '₴'],
                'UGX': [undefined, undefined, 0],
                'USD': ['$'],
                'UYI': [undefined, undefined, 0],
                'UYU': [undefined, '$'],
                'UZS': [undefined, undefined, 0],
                'VEF': [undefined, 'Bs'],
                'VND': ['₫', undefined, 0],
                'VUV': [undefined, undefined, 0],
                'XAF': ['FCFA', undefined, 0],
                'XCD': ['EC$', '$'],
                'XOF': ['CFA', undefined, 0],
                'XPF': ['CFPF', undefined, 0],
                'YER': [undefined, undefined, 0],
                'ZAR': [undefined, 'R'],
                'ZMK': [undefined, undefined, 0],
                'ZMW': [undefined, 'ZK'],
                'ZWD': [undefined, undefined, 0]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @enum {number} */
            var NumberFormatStyle = {
                Decimal: 0,
                Percent: 1,
                Currency: 2,
                Scientific: 3,
            };
            NumberFormatStyle[NumberFormatStyle.Decimal] = 'Decimal';
            NumberFormatStyle[NumberFormatStyle.Percent] = 'Percent';
            NumberFormatStyle[NumberFormatStyle.Currency] = 'Currency';
            NumberFormatStyle[NumberFormatStyle.Scientific] = 'Scientific';
            /** @enum {number} */
            var Plural = {
                Zero: 0,
                One: 1,
                Two: 2,
                Few: 3,
                Many: 4,
                Other: 5,
            };
            Plural[Plural.Zero] = 'Zero';
            Plural[Plural.One] = 'One';
            Plural[Plural.Two] = 'Two';
            Plural[Plural.Few] = 'Few';
            Plural[Plural.Many] = 'Many';
            Plural[Plural.Other] = 'Other';
            /** @enum {number} */
            var FormStyle = {
                Format: 0,
                Standalone: 1,
            };
            FormStyle[FormStyle.Format] = 'Format';
            FormStyle[FormStyle.Standalone] = 'Standalone';
            /** @enum {number} */
            var TranslationWidth = {
                /** 1 character for `en-US`. For example: 'S' */
                Narrow: 0,
                /** 3 characters for `en-US`. For example: 'Sun' */
                Abbreviated: 1,
                /** Full length for `en-US`. For example: "Sunday" */
                Wide: 2,
                /** 2 characters for `en-US`, For example: "Su" */
                Short: 3,
            };
            TranslationWidth[TranslationWidth.Narrow] = 'Narrow';
            TranslationWidth[TranslationWidth.Abbreviated] = 'Abbreviated';
            TranslationWidth[TranslationWidth.Wide] = 'Wide';
            TranslationWidth[TranslationWidth.Short] = 'Short';
            /** @enum {number} */
            var FormatWidth = {
                /**
                 * For `en-US`, 'M/d/yy, h:mm a'`
                 * (Example: `6/15/15, 9:03 AM`)
                 */
                Short: 0,
                /**
                 * For `en-US`, `'MMM d, y, h:mm:ss a'`
                 * (Example: `Jun 15, 2015, 9:03:01 AM`)
                 */
                Medium: 1,
                /**
                 * For `en-US`, `'MMMM d, y, h:mm:ss a z'`
                 * (Example: `June 15, 2015 at 9:03:01 AM GMT+1`)
                 */
                Long: 2,
                /**
                 * For `en-US`, `'EEEE, MMMM d, y, h:mm:ss a zzzz'`
                 * (Example: `Monday, June 15, 2015 at 9:03:01 AM GMT+01:00`)
                 */
                Full: 3,
            };
            FormatWidth[FormatWidth.Short] = 'Short';
            FormatWidth[FormatWidth.Medium] = 'Medium';
            FormatWidth[FormatWidth.Long] = 'Long';
            FormatWidth[FormatWidth.Full] = 'Full';
            /** @enum {number} */
            var NumberSymbol = {
                /**
                 * Decimal separator.
                 * For `en-US`, the dot character.
                 * Example : 2,345`.`67
                 */
                Decimal: 0,
                /**
                 * Grouping separator, typically for thousands.
                 * For `en-US`, the comma character.
                 * Example: 2`,`345.67
                 */
                Group: 1,
                /**
                 * List-item separator.
                 * Example: "one, two, and three"
                 */
                List: 2,
                /**
                 * Sign for percentage (out of 100).
                 * Example: 23.4%
                 */
                PercentSign: 3,
                /**
                 * Sign for positive numbers.
                 * Example: +23
                 */
                PlusSign: 4,
                /**
                 * Sign for negative numbers.
                 * Example: -23
                 */
                MinusSign: 5,
                /**
                 * Computer notation for exponential value (n times a power of 10).
                 * Example: 1.2E3
                 */
                Exponential: 6,
                /**
                 * Human-readable format of exponential.
                 * Example: 1.2x103
                 */
                SuperscriptingExponent: 7,
                /**
                 * Sign for permille (out of 1000).
                 * Example: 23.4‰
                 */
                PerMille: 8,
                /**
                 * Infinity, can be used with plus and minus.
                 * Example: ∞, +∞, -∞
                 */
                Infinity: 9,
                /**
                 * Not a number.
                 * Example: NaN
                 */
                NaN: 10,
                /**
                 * Symbol used between time units.
                 * Example: 10:52
                 */
                TimeSeparator: 11,
                /**
                 * Decimal separator for currency values (fallback to `Decimal`).
                 * Example: $2,345.67
                 */
                CurrencyDecimal: 12,
                /**
                 * Group separator for currency values (fallback to `Group`).
                 * Example: $2,345.67
                 */
                CurrencyGroup: 13,
            };
            NumberSymbol[NumberSymbol.Decimal] = 'Decimal';
            NumberSymbol[NumberSymbol.Group] = 'Group';
            NumberSymbol[NumberSymbol.List] = 'List';
            NumberSymbol[NumberSymbol.PercentSign] = 'PercentSign';
            NumberSymbol[NumberSymbol.PlusSign] = 'PlusSign';
            NumberSymbol[NumberSymbol.MinusSign] = 'MinusSign';
            NumberSymbol[NumberSymbol.Exponential] = 'Exponential';
            NumberSymbol[NumberSymbol.SuperscriptingExponent] = 'SuperscriptingExponent';
            NumberSymbol[NumberSymbol.PerMille] = 'PerMille';
            NumberSymbol[NumberSymbol.Infinity] = 'Infinity';
            NumberSymbol[NumberSymbol.NaN] = 'NaN';
            NumberSymbol[NumberSymbol.TimeSeparator] = 'TimeSeparator';
            NumberSymbol[NumberSymbol.CurrencyDecimal] = 'CurrencyDecimal';
            NumberSymbol[NumberSymbol.CurrencyGroup] = 'CurrencyGroup';
            /** @enum {number} */
            var WeekDay = {
                Sunday: 0,
                Monday: 1,
                Tuesday: 2,
                Wednesday: 3,
                Thursday: 4,
                Friday: 5,
                Saturday: 6,
            };
            WeekDay[WeekDay.Sunday] = 'Sunday';
            WeekDay[WeekDay.Monday] = 'Monday';
            WeekDay[WeekDay.Tuesday] = 'Tuesday';
            WeekDay[WeekDay.Wednesday] = 'Wednesday';
            WeekDay[WeekDay.Thursday] = 'Thursday';
            WeekDay[WeekDay.Friday] = 'Friday';
            WeekDay[WeekDay.Saturday] = 'Saturday';
            /**
             * Retrieves the locale ID from the currently loaded locale.
             * The loaded locale could be, for example, a global one rather than a regional one.
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code, such as `fr-FR`.
             * @return {?} The locale code. For example, `fr`.
             */
            function getLocaleId(locale) {
                return Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale)[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].LocaleId];
            }
            /**
             * Retrieves day period strings for the given locale.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} formStyle The required grammatical form.
             * @param {?} width The required character width.
             * @return {?} An array of localized period strings. For example, `[AM, PM]` for `en-US`.
             */
            function getLocaleDayPeriods(locale, formStyle, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                /** @type {?} */
                var amPmData = ( /** @type {?} */([data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].DayPeriodsFormat], data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].DayPeriodsStandalone]]));
                /** @type {?} */
                var amPm = getLastDefinedValue(amPmData, formStyle);
                return getLastDefinedValue(amPm, width);
            }
            /**
             * Retrieves days of the week for the given locale, using the Gregorian calendar.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} formStyle The required grammatical form.
             * @param {?} width The required character width.
             * @return {?} An array of localized name strings.
             * For example,`[Sunday, Monday, ... Saturday]` for `en-US`.
             */
            function getLocaleDayNames(locale, formStyle, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                /** @type {?} */
                var daysData = ( /** @type {?} */([data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].DaysFormat], data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].DaysStandalone]]));
                /** @type {?} */
                var days = getLastDefinedValue(daysData, formStyle);
                return getLastDefinedValue(days, width);
            }
            /**
             * Retrieves months of the year for the given locale, using the Gregorian calendar.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} formStyle The required grammatical form.
             * @param {?} width The required character width.
             * @return {?} An array of localized name strings.
             * For example,  `[January, February, ...]` for `en-US`.
             */
            function getLocaleMonthNames(locale, formStyle, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                /** @type {?} */
                var monthsData = ( /** @type {?} */([data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].MonthsFormat], data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].MonthsStandalone]]));
                /** @type {?} */
                var months = getLastDefinedValue(monthsData, formStyle);
                return getLastDefinedValue(months, width);
            }
            /**
             * Retrieves Gregorian-calendar eras for the given locale.
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} width The required character width.
             * @return {?} An array of localized era strings.
             * For example, `[AD, BC]` for `en-US`.
             */
            function getLocaleEraNames(locale, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                /** @type {?} */
                var erasData = ( /** @type {?} */(data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].Eras]));
                return getLastDefinedValue(erasData, width);
            }
            /**
             * Retrieves the first day of the week for the given locale.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} A day index number, using the 0-based week-day index for `en-US`
             * (Sunday = 0, Monday = 1, ...).
             * For example, for `fr-FR`, returns 1 to indicate that the first day is Monday.
             */
            function getLocaleFirstDayOfWeek(locale) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].FirstDayOfWeek];
            }
            /**
             * Range of week days that are considered the week-end for the given locale.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} The range of day values, `[startDay, endDay]`.
             */
            function getLocaleWeekEndRange(locale) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].WeekendRange];
            }
            /**
             * Retrieves a localized date-value formating string.
             *
             * @see `FormatWidth` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} width The format type.
             * @return {?} The localized formating string.
             */
            function getLocaleDateFormat(locale, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return getLastDefinedValue(data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].DateFormat], width);
            }
            /**
             * Retrieves a localized time-value formatting string.
             *
             * @see `FormatWidth` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} width The format type.
             * @return {?} The localized formatting string.
             */
            function getLocaleTimeFormat(locale, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return getLastDefinedValue(data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].TimeFormat], width);
            }
            /**
             * Retrieves a localized date-time formatting string.
             *
             * @see `FormatWidth` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} width The format type.
             * @return {?} The localized formatting string.
             */
            function getLocaleDateTimeFormat(locale, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                /** @type {?} */
                var dateTimeFormatData = ( /** @type {?} */(data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].DateTimeFormat]));
                return getLastDefinedValue(dateTimeFormatData, width);
            }
            /**
             * Retrieves a localized number symbol that can be used to replace placeholders in number formats.
             * @see `NumberSymbol` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale The locale code.
             * @param {?} symbol The symbol to localize.
             * @return {?} The character for the localized symbol.
             */
            function getLocaleNumberSymbol(locale, symbol) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                /** @type {?} */
                var res = data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].NumberSymbols][symbol];
                if (typeof res === 'undefined') {
                    if (symbol === NumberSymbol.CurrencyDecimal) {
                        return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].NumberSymbols][NumberSymbol.Decimal];
                    }
                    else if (symbol === NumberSymbol.CurrencyGroup) {
                        return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].NumberSymbols][NumberSymbol.Group];
                    }
                }
                return res;
            }
            /**
             * Retrieves a number format for a given locale.
             *
             * Numbers are formatted using patterns, like `#,###.00`. For example, the pattern `#,###.00`
             * when used to format the number 12345.678 could result in "12'345,678". That would happen if the
             * grouping separator for your language is an apostrophe, and the decimal separator is a comma.
             *
             * <b>Important:</b> The characters `.` `,` `0` `#` (and others below) are special placeholders
             * that stand for the decimal separator, and so on, and are NOT real characters.
             * You must NOT "translate" the placeholders. For example, don't change `.` to `,` even though in
             * your language the decimal point is written with a comma. The symbols should be replaced by the
             * local equivalents, using the appropriate `NumberSymbol` for your language.
             *
             * Here are the special characters used in number patterns:
             *
             * | Symbol | Meaning |
             * |--------|---------|
             * | . | Replaced automatically by the character used for the decimal point. |
             * | , | Replaced by the "grouping" (thousands) separator. |
             * | 0 | Replaced by a digit (or zero if there aren't enough digits). |
             * | # | Replaced by a digit (or nothing if there aren't enough). |
             * | ¤ | Replaced by a currency symbol, such as $ or USD. |
             * | % | Marks a percent format. The % symbol may change position, but must be retained. |
             * | E | Marks a scientific format. The E symbol may change position, but must be retained. |
             * | ' | Special characters used as literal characters are quoted with ASCII single quotes. |
             *
             * @see `NumberFormatStyle` / [CLDR website](http://cldr.unicode.org/translation/number-patterns) / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} type The type of numeric value to be formatted (such as `Decimal` or `Currency`.)
             * @return {?} The localized format string.
             */
            function getLocaleNumberFormat(locale, type) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].NumberFormats][type];
            }
            /**
             * Retrieves the symbol used to represent the currency for the main country
             * corresponding to a given locale. For example, '$' for `en-US`.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} The localized symbol character,
             * or `null` if the main country cannot be determined.
             */
            function getLocaleCurrencySymbol(locale) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].CurrencySymbol] || null;
            }
            /**
             * Retrieves the name of the currency for the main country corresponding
             * to a given locale. For example, 'US Dollar' for `en-US`.
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} The currency name,
             * or `null` if the main country cannot be determined.
             */
            function getLocaleCurrencyName(locale) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].CurrencyName] || null;
            }
            /**
             * Retrieves the currency values for a given locale.
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} The currency values.
             */
            function getLocaleCurrencies(locale) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                return data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].Currencies];
            }
            /**
             * \@alias core/ɵgetLocalePluralCase
             * \@publicApi
             * @type {?}
             */
            var getLocalePluralCase = _angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵgetLocalePluralCase"];
            /**
             * @param {?} data
             * @return {?}
             */
            function checkFullData(data) {
                if (!data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].ExtraData]) {
                    throw new Error("Missing extra locale data for the locale \"" + data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].LocaleId] + "\". Use \"registerLocaleData\" to load new data. See the \"I18n guide\" on angular.io to know more.");
                }
            }
            /**
             * Retrieves locale-specific rules used to determine which day period to use
             * when more than one period is defined for a locale.
             *
             * There is a rule for each defined day period. The
             * first rule is applied to the first day period and so on.
             * Fall back to AM/PM when no rules are available.
             *
             * A rule can specify a period as time range, or as a single time value.
             *
             * This functionality is only available when you have loaded the full locale data.
             * See the ["I18n guide"](guide/i18n#i18n-pipes).
             *
             * @see `getLocaleExtraDayPeriods()` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} The rules for the locale, a single time value or array of *from-time, to-time*,
             * or null if no periods are available.
             *
             */
            function getLocaleExtraDayPeriodRules(locale) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                checkFullData(data);
                /** @type {?} */
                var rules = data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].ExtraData][2 /* ExtraDayPeriodsRules */] || [];
                return rules.map(( /**
                 * @param {?} rule
                 * @return {?}
                 */function (rule) {
                    if (typeof rule === 'string') {
                        return extractTime(rule);
                    }
                    return [extractTime(rule[0]), extractTime(rule[1])];
                }));
            }
            /**
             * Retrieves locale-specific day periods, which indicate roughly how a day is broken up
             * in different languages.
             * For example, for `en-US`, periods are morning, noon, afternoon, evening, and midnight.
             *
             * This functionality is only available when you have loaded the full locale data.
             * See the ["I18n guide"](guide/i18n#i18n-pipes).
             *
             * @see `getLocaleExtraDayPeriodRules()` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} formStyle The required grammatical form.
             * @param {?} width The required character width.
             * @return {?} The translated day-period strings.
             */
            function getLocaleExtraDayPeriods(locale, formStyle, width) {
                /** @type {?} */
                var data = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵfindLocaleData"])(locale);
                checkFullData(data);
                /** @type {?} */
                var dayPeriodsData = ( /** @type {?} */([
                    data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].ExtraData][0 /* ExtraDayPeriodFormats */],
                    data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].ExtraData][1 /* ExtraDayPeriodStandalone */]
                ]));
                /** @type {?} */
                var dayPeriods = getLastDefinedValue(dayPeriodsData, formStyle) || [];
                return getLastDefinedValue(dayPeriods, width) || [];
            }
            /**
             * Retrieves the first value that is defined in an array, going backwards from an index position.
             *
             * To avoid repeating the same data (as when the "format" and "standalone" forms are the same)
             * add the first value to the locale data arrays, and add other values only if they are different.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @template T
             * @param {?} data The data array to retrieve from.
             * @param {?} index A 0-based index into the array to start from.
             * @return {?} The value immediately before the given index position.
             */
            function getLastDefinedValue(data, index) {
                for (var i = index; i > -1; i--) {
                    if (typeof data[i] !== 'undefined') {
                        return data[i];
                    }
                }
                throw new Error('Locale data API: locale data undefined');
            }
            /**
             * Extracts the hours and minutes from a string like "15:45"
             * @param {?} time
             * @return {?}
             */
            function extractTime(time) {
                var _c = time.split(':'), h = _c[0], m = _c[1];
                return { hours: +h, minutes: +m };
            }
            /**
             * Retrieves the currency symbol for a given currency code.
             *
             * For example, for the default `en-US` locale, the code `USD` can
             * be represented by the narrow symbol `$` or the wide symbol `US$`.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} code The currency code.
             * @param {?} format The format, `wide` or `narrow`.
             * @param {?=} locale A locale code for the locale format rules to use.
             *
             * @return {?} The symbol, or the currency code if no symbol is available.0
             */
            function getCurrencySymbol(code, format, locale) {
                if (locale === void 0) { locale = 'en'; }
                /** @type {?} */
                var currency = getLocaleCurrencies(locale)[code] || CURRENCIES_EN[code] || [];
                /** @type {?} */
                var symbolNarrow = currency[1 /* SymbolNarrow */];
                if (format === 'narrow' && typeof symbolNarrow === 'string') {
                    return symbolNarrow;
                }
                return currency[0 /* Symbol */] || code;
            }
            // Most currencies have cents, that's why the default is 2
            /** @type {?} */
            var DEFAULT_NB_OF_CURRENCY_DIGITS = 2;
            /**
             * Reports the number of decimal digits for a given currency.
             * The value depends upon the presence of cents in that particular currency.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} code The currency code.
             * @return {?} The number of decimal digits, typically 0 or 2.
             */
            function getNumberOfCurrencyDigits(code) {
                /** @type {?} */
                var digits;
                /** @type {?} */
                var currency = CURRENCIES_EN[code];
                if (currency) {
                    digits = currency[2 /* NbOfDigits */];
                }
                return typeof digits === 'number' ? digits : DEFAULT_NB_OF_CURRENCY_DIGITS;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var ISO8601_DATE_REGEX = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
            //    1        2       3         4          5          6          7          8  9     10      11
            /** @type {?} */
            var NAMED_FORMATS = {};
            /** @type {?} */
            var DATE_FORMATS_SPLIT = /((?:[^GyMLwWdEabBhHmsSzZO']+)|(?:'(?:[^']|'')*')|(?:G{1,5}|y{1,4}|M{1,5}|L{1,5}|w{1,2}|W{1}|d{1,2}|E{1,6}|a{1,5}|b{1,5}|B{1,5}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|O{1,4}))([\s\S]*)/;
            /** @enum {number} */
            var ZoneWidth = {
                Short: 0,
                ShortGMT: 1,
                Long: 2,
                Extended: 3,
            };
            ZoneWidth[ZoneWidth.Short] = 'Short';
            ZoneWidth[ZoneWidth.ShortGMT] = 'ShortGMT';
            ZoneWidth[ZoneWidth.Long] = 'Long';
            ZoneWidth[ZoneWidth.Extended] = 'Extended';
            /** @enum {number} */
            var DateType = {
                FullYear: 0,
                Month: 1,
                Date: 2,
                Hours: 3,
                Minutes: 4,
                Seconds: 5,
                FractionalSeconds: 6,
                Day: 7,
            };
            DateType[DateType.FullYear] = 'FullYear';
            DateType[DateType.Month] = 'Month';
            DateType[DateType.Date] = 'Date';
            DateType[DateType.Hours] = 'Hours';
            DateType[DateType.Minutes] = 'Minutes';
            DateType[DateType.Seconds] = 'Seconds';
            DateType[DateType.FractionalSeconds] = 'FractionalSeconds';
            DateType[DateType.Day] = 'Day';
            /** @enum {number} */
            var TranslationType = {
                DayPeriods: 0,
                Days: 1,
                Months: 2,
                Eras: 3,
            };
            TranslationType[TranslationType.DayPeriods] = 'DayPeriods';
            TranslationType[TranslationType.Days] = 'Days';
            TranslationType[TranslationType.Months] = 'Months';
            TranslationType[TranslationType.Eras] = 'Eras';
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a date according to locale rules.
             *
             * @see `DatePipe` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} value The date to format, as a Date, or a number (milliseconds since UTC epoch)
             * or an [ISO date-time string](https://www.w3.org/TR/NOTE-datetime).
             * @param {?} format The date-time components to include. See `DatePipe` for details.
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?=} timezone The time zone. A time zone offset from GMT (such as `'+0430'`),
             * or a standard UTC/GMT or continental US time zone abbreviation.
             * If not specified, uses host system settings.
             *
             * @return {?} The formatted date string.
             *
             */
            function formatDate(value, format, locale, timezone) {
                /** @type {?} */
                var date = toDate(value);
                /** @type {?} */
                var namedFormat = getNamedFormat(locale, format);
                format = namedFormat || format;
                /** @type {?} */
                var parts = [];
                /** @type {?} */
                var match;
                while (format) {
                    match = DATE_FORMATS_SPLIT.exec(format);
                    if (match) {
                        parts = parts.concat(match.slice(1));
                        /** @type {?} */
                        var part = parts.pop();
                        if (!part) {
                            break;
                        }
                        format = part;
                    }
                    else {
                        parts.push(format);
                        break;
                    }
                }
                /** @type {?} */
                var dateTimezoneOffset = date.getTimezoneOffset();
                if (timezone) {
                    dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
                    date = convertTimezoneToLocal(date, timezone, true);
                }
                /** @type {?} */
                var text = '';
                parts.forEach(( /**
                 * @param {?} value
                 * @return {?}
                 */function (/**
                 * @param {?} value
                 * @return {?}
                 */ value) {
                    /** @type {?} */
                    var dateFormatter = getDateFormatter(value);
                    text += dateFormatter ?
                        dateFormatter(date, locale, dateTimezoneOffset) :
                        value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
                }));
                return text;
            }
            /**
             * @param {?} locale
             * @param {?} format
             * @return {?}
             */
            function getNamedFormat(locale, format) {
                /** @type {?} */
                var localeId = getLocaleId(locale);
                NAMED_FORMATS[localeId] = NAMED_FORMATS[localeId] || {};
                if (NAMED_FORMATS[localeId][format]) {
                    return NAMED_FORMATS[localeId][format];
                }
                /** @type {?} */
                var formatValue = '';
                switch (format) {
                    case 'shortDate':
                        formatValue = getLocaleDateFormat(locale, FormatWidth.Short);
                        break;
                    case 'mediumDate':
                        formatValue = getLocaleDateFormat(locale, FormatWidth.Medium);
                        break;
                    case 'longDate':
                        formatValue = getLocaleDateFormat(locale, FormatWidth.Long);
                        break;
                    case 'fullDate':
                        formatValue = getLocaleDateFormat(locale, FormatWidth.Full);
                        break;
                    case 'shortTime':
                        formatValue = getLocaleTimeFormat(locale, FormatWidth.Short);
                        break;
                    case 'mediumTime':
                        formatValue = getLocaleTimeFormat(locale, FormatWidth.Medium);
                        break;
                    case 'longTime':
                        formatValue = getLocaleTimeFormat(locale, FormatWidth.Long);
                        break;
                    case 'fullTime':
                        formatValue = getLocaleTimeFormat(locale, FormatWidth.Full);
                        break;
                    case 'short':
                        /** @type {?} */
                        var shortTime = getNamedFormat(locale, 'shortTime');
                        /** @type {?} */
                        var shortDate = getNamedFormat(locale, 'shortDate');
                        formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Short), [shortTime, shortDate]);
                        break;
                    case 'medium':
                        /** @type {?} */
                        var mediumTime = getNamedFormat(locale, 'mediumTime');
                        /** @type {?} */
                        var mediumDate = getNamedFormat(locale, 'mediumDate');
                        formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Medium), [mediumTime, mediumDate]);
                        break;
                    case 'long':
                        /** @type {?} */
                        var longTime = getNamedFormat(locale, 'longTime');
                        /** @type {?} */
                        var longDate = getNamedFormat(locale, 'longDate');
                        formatValue =
                            formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Long), [longTime, longDate]);
                        break;
                    case 'full':
                        /** @type {?} */
                        var fullTime = getNamedFormat(locale, 'fullTime');
                        /** @type {?} */
                        var fullDate = getNamedFormat(locale, 'fullDate');
                        formatValue =
                            formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Full), [fullTime, fullDate]);
                        break;
                }
                if (formatValue) {
                    NAMED_FORMATS[localeId][format] = formatValue;
                }
                return formatValue;
            }
            /**
             * @param {?} str
             * @param {?} opt_values
             * @return {?}
             */
            function formatDateTime(str, opt_values) {
                if (opt_values) {
                    str = str.replace(/\{([^}]+)}/g, ( /**
                     * @param {?} match
                     * @param {?} key
                     * @return {?}
                     */function (match, key) {
                        return (opt_values != null && key in opt_values) ? opt_values[key] : match;
                    }));
                }
                return str;
            }
            /**
             * @param {?} num
             * @param {?} digits
             * @param {?=} minusSign
             * @param {?=} trim
             * @param {?=} negWrap
             * @return {?}
             */
            function padNumber(num, digits, minusSign, trim, negWrap) {
                if (minusSign === void 0) { minusSign = '-'; }
                /** @type {?} */
                var neg = '';
                if (num < 0 || (negWrap && num <= 0)) {
                    if (negWrap) {
                        num = -num + 1;
                    }
                    else {
                        num = -num;
                        neg = minusSign;
                    }
                }
                /** @type {?} */
                var strNum = String(num);
                while (strNum.length < digits) {
                    strNum = '0' + strNum;
                }
                if (trim) {
                    strNum = strNum.substr(strNum.length - digits);
                }
                return neg + strNum;
            }
            /**
             * @param {?} milliseconds
             * @param {?} digits
             * @return {?}
             */
            function formatFractionalSeconds(milliseconds, digits) {
                /** @type {?} */
                var strMs = padNumber(milliseconds, 3);
                return strMs.substr(0, digits);
            }
            /**
             * Returns a date formatter that transforms a date into its locale digit representation
             * @param {?} name
             * @param {?} size
             * @param {?=} offset
             * @param {?=} trim
             * @param {?=} negWrap
             * @return {?}
             */
            function dateGetter(name, size, offset, trim, negWrap) {
                if (offset === void 0) { offset = 0; }
                if (trim === void 0) { trim = false; }
                if (negWrap === void 0) { negWrap = false; }
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) {
                    /** @type {?} */
                    var part = getDatePart(name, date);
                    if (offset > 0 || part > -offset) {
                        part += offset;
                    }
                    if (name === DateType.Hours) {
                        if (part === 0 && offset === -12) {
                            part = 12;
                        }
                    }
                    else if (name === DateType.FractionalSeconds) {
                        return formatFractionalSeconds(part, size);
                    }
                    /** @type {?} */
                    var localeMinus = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
                    return padNumber(part, size, localeMinus, trim, negWrap);
                });
            }
            /**
             * @param {?} part
             * @param {?} date
             * @return {?}
             */
            function getDatePart(part, date) {
                switch (part) {
                    case DateType.FullYear:
                        return date.getFullYear();
                    case DateType.Month:
                        return date.getMonth();
                    case DateType.Date:
                        return date.getDate();
                    case DateType.Hours:
                        return date.getHours();
                    case DateType.Minutes:
                        return date.getMinutes();
                    case DateType.Seconds:
                        return date.getSeconds();
                    case DateType.FractionalSeconds:
                        return date.getMilliseconds();
                    case DateType.Day:
                        return date.getDay();
                    default:
                        throw new Error("Unknown DateType value \"" + part + "\".");
                }
            }
            /**
             * Returns a date formatter that transforms a date into its locale string representation
             * @param {?} name
             * @param {?} width
             * @param {?=} form
             * @param {?=} extended
             * @return {?}
             */
            function dateStrGetter(name, width, form, extended) {
                if (form === void 0) { form = FormStyle.Format; }
                if (extended === void 0) { extended = false; }
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) {
                    return getDateTranslation(date, locale, name, width, form, extended);
                });
            }
            /**
             * Returns the locale translation of a date for a given form, type and width
             * @param {?} date
             * @param {?} locale
             * @param {?} name
             * @param {?} width
             * @param {?} form
             * @param {?} extended
             * @return {?}
             */
            function getDateTranslation(date, locale, name, width, form, extended) {
                switch (name) {
                    case TranslationType.Months:
                        return getLocaleMonthNames(locale, form, width)[date.getMonth()];
                    case TranslationType.Days:
                        return getLocaleDayNames(locale, form, width)[date.getDay()];
                    case TranslationType.DayPeriods:
                        /** @type {?} */
                        var currentHours_1 = date.getHours();
                        /** @type {?} */
                        var currentMinutes_1 = date.getMinutes();
                        if (extended) {
                            /** @type {?} */
                            var rules = getLocaleExtraDayPeriodRules(locale);
                            /** @type {?} */
                            var dayPeriods_1 = getLocaleExtraDayPeriods(locale, form, width);
                            /** @type {?} */
                            var result_1;
                            rules.forEach(( /**
                             * @param {?} rule
                             * @param {?} index
                             * @return {?}
                             */function (rule, index) {
                                if (Array.isArray(rule)) {
                                    // morning, afternoon, evening, night
                                    var _c = rule[0], hoursFrom = _c.hours, minutesFrom = _c.minutes;
                                    var _d = rule[1], hoursTo = _d.hours, minutesTo = _d.minutes;
                                    if (currentHours_1 >= hoursFrom && currentMinutes_1 >= minutesFrom &&
                                        (currentHours_1 < hoursTo ||
                                            (currentHours_1 === hoursTo && currentMinutes_1 < minutesTo))) {
                                        result_1 = dayPeriods_1[index];
                                    }
                                }
                                else { // noon or midnight
                                    // noon or midnight
                                    var hours = rule.hours, minutes = rule.minutes;
                                    if (hours === currentHours_1 && minutes === currentMinutes_1) {
                                        result_1 = dayPeriods_1[index];
                                    }
                                }
                            }));
                            if (result_1) {
                                return result_1;
                            }
                        }
                        // if no rules for the day periods, we use am/pm by default
                        return getLocaleDayPeriods(locale, form, ( /** @type {?} */(width)))[currentHours_1 < 12 ? 0 : 1];
                    case TranslationType.Eras:
                        return getLocaleEraNames(locale, ( /** @type {?} */(width)))[date.getFullYear() <= 0 ? 0 : 1];
                    default:
                        // This default case is not needed by TypeScript compiler, as the switch is exhaustive.
                        // However Closure Compiler does not understand that and reports an error in typed mode.
                        // The `throw new Error` below works around the problem, and the unexpected: never variable
                        // makes sure tsc still checks this code is unreachable.
                        /** @type {?} */
                        var unexpected = name;
                        throw new Error("unexpected translation type " + unexpected);
                }
            }
            /**
             * Returns a date formatter that transforms a date and an offset into a timezone with ISO8601 or
             * GMT format depending on the width (eg: short = +0430, short:GMT = GMT+4, long = GMT+04:30,
             * extended = +04:30)
             * @param {?} width
             * @return {?}
             */
            function timeZoneGetter(width) {
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @param {?} offset
                 * @return {?}
                 */function (date, locale, offset) {
                    /** @type {?} */
                    var zone = -1 * offset;
                    /** @type {?} */
                    var minusSign = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
                    /** @type {?} */
                    var hours = zone > 0 ? Math.floor(zone / 60) : Math.ceil(zone / 60);
                    switch (width) {
                        case ZoneWidth.Short:
                            return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) +
                                padNumber(Math.abs(zone % 60), 2, minusSign);
                        case ZoneWidth.ShortGMT:
                            return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 1, minusSign);
                        case ZoneWidth.Long:
                            return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
                                padNumber(Math.abs(zone % 60), 2, minusSign);
                        case ZoneWidth.Extended:
                            if (offset === 0) {
                                return 'Z';
                            }
                            else {
                                return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
                                    padNumber(Math.abs(zone % 60), 2, minusSign);
                            }
                        default:
                            throw new Error("Unknown zone width \"" + width + "\"");
                    }
                });
            }
            /** @type {?} */
            var JANUARY = 0;
            /** @type {?} */
            var THURSDAY = 4;
            /**
             * @param {?} year
             * @return {?}
             */
            function getFirstThursdayOfYear(year) {
                /** @type {?} */
                var firstDayOfYear = (new Date(year, JANUARY, 1)).getDay();
                return new Date(year, 0, 1 + ((firstDayOfYear <= THURSDAY) ? THURSDAY : THURSDAY + 7) - firstDayOfYear);
            }
            /**
             * @param {?} datetime
             * @return {?}
             */
            function getThursdayThisWeek(datetime) {
                return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate() + (THURSDAY - datetime.getDay()));
            }
            /**
             * @param {?} size
             * @param {?=} monthBased
             * @return {?}
             */
            function weekGetter(size, monthBased) {
                if (monthBased === void 0) { monthBased = false; }
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) {
                    /** @type {?} */
                    var result;
                    if (monthBased) {
                        /** @type {?} */
                        var nbDaysBefore1stDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay() - 1;
                        /** @type {?} */
                        var today = date.getDate();
                        result = 1 + Math.floor((today + nbDaysBefore1stDayOfMonth) / 7);
                    }
                    else {
                        /** @type {?} */
                        var firstThurs = getFirstThursdayOfYear(date.getFullYear());
                        /** @type {?} */
                        var thisThurs = getThursdayThisWeek(date);
                        /** @type {?} */
                        var diff = thisThurs.getTime() - firstThurs.getTime();
                        result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
                    }
                    return padNumber(result, size, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
                });
            }
            /** @type {?} */
            var DATE_FORMATS = {};
            // Based on CLDR formats:
            // See complete list: http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
            // See also explanations: http://cldr.unicode.org/translation/date-time
            // TODO(ocombe): support all missing cldr formats: Y, U, Q, D, F, e, c, j, J, C, A, v, V, X, x
            /**
             * @param {?} format
             * @return {?}
             */
            function getDateFormatter(format) {
                if (DATE_FORMATS[format]) {
                    return DATE_FORMATS[format];
                }
                /** @type {?} */
                var formatter;
                switch (format) {
                    // Era name (AD/BC)
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Abbreviated);
                        break;
                    case 'GGGG':
                        formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Wide);
                        break;
                    case 'GGGGG':
                        formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Narrow);
                        break;
                    // 1 digit representation of the year, e.g. (AD 1 => 1, AD 199 => 199)
                    case 'y':
                        formatter = dateGetter(DateType.FullYear, 1, 0, false, true);
                        break;
                    // 2 digit representation of the year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
                    case 'yy':
                        formatter = dateGetter(DateType.FullYear, 2, 0, true, true);
                        break;
                    // 3 digit representation of the year, padded (000-999). (e.g. AD 2001 => 01, AD 2010 => 10)
                    case 'yyy':
                        formatter = dateGetter(DateType.FullYear, 3, 0, false, true);
                        break;
                    // 4 digit representation of the year (e.g. AD 1 => 0001, AD 2010 => 2010)
                    case 'yyyy':
                        formatter = dateGetter(DateType.FullYear, 4, 0, false, true);
                        break;
                    // Month of the year (1-12), numeric
                    case 'M':
                    case 'L':
                        formatter = dateGetter(DateType.Month, 1, 1);
                        break;
                    case 'MM':
                    case 'LL':
                        formatter = dateGetter(DateType.Month, 2, 1);
                        break;
                    // Month of the year (January, ...), string, format
                    case 'MMM':
                        formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated);
                        break;
                    case 'MMMM':
                        formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Wide);
                        break;
                    case 'MMMMM':
                        formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Narrow);
                        break;
                    // Month of the year (January, ...), string, standalone
                    case 'LLL':
                        formatter =
                            dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated, FormStyle.Standalone);
                        break;
                    case 'LLLL':
                        formatter =
                            dateStrGetter(TranslationType.Months, TranslationWidth.Wide, FormStyle.Standalone);
                        break;
                    case 'LLLLL':
                        formatter =
                            dateStrGetter(TranslationType.Months, TranslationWidth.Narrow, FormStyle.Standalone);
                        break;
                    // Week of the year (1, ... 52)
                    case 'w':
                        formatter = weekGetter(1);
                        break;
                    case 'ww':
                        formatter = weekGetter(2);
                        break;
                    // Week of the month (1, ...)
                    case 'W':
                        formatter = weekGetter(1, true);
                        break;
                    // Day of the month (1-31)
                    case 'd':
                        formatter = dateGetter(DateType.Date, 1);
                        break;
                    case 'dd':
                        formatter = dateGetter(DateType.Date, 2);
                        break;
                    // Day of the Week
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Abbreviated);
                        break;
                    case 'EEEE':
                        formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Wide);
                        break;
                    case 'EEEEE':
                        formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Narrow);
                        break;
                    case 'EEEEEE':
                        formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Short);
                        break;
                    // Generic period of the day (am-pm)
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated);
                        break;
                    case 'aaaa':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide);
                        break;
                    case 'aaaaa':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow);
                        break;
                    // Extended period of the day (midnight, at night, ...), standalone
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Standalone, true);
                        break;
                    case 'bbbb':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Standalone, true);
                        break;
                    case 'bbbbb':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Standalone, true);
                        break;
                    // Extended period of the day (midnight, night, ...), standalone
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Format, true);
                        break;
                    case 'BBBB':
                        formatter =
                            dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Format, true);
                        break;
                    case 'BBBBB':
                        formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Format, true);
                        break;
                    // Hour in AM/PM, (1-12)
                    case 'h':
                        formatter = dateGetter(DateType.Hours, 1, -12);
                        break;
                    case 'hh':
                        formatter = dateGetter(DateType.Hours, 2, -12);
                        break;
                    // Hour of the day (0-23)
                    case 'H':
                        formatter = dateGetter(DateType.Hours, 1);
                        break;
                    // Hour in day, padded (00-23)
                    case 'HH':
                        formatter = dateGetter(DateType.Hours, 2);
                        break;
                    // Minute of the hour (0-59)
                    case 'm':
                        formatter = dateGetter(DateType.Minutes, 1);
                        break;
                    case 'mm':
                        formatter = dateGetter(DateType.Minutes, 2);
                        break;
                    // Second of the minute (0-59)
                    case 's':
                        formatter = dateGetter(DateType.Seconds, 1);
                        break;
                    case 'ss':
                        formatter = dateGetter(DateType.Seconds, 2);
                        break;
                    // Fractional second
                    case 'S':
                        formatter = dateGetter(DateType.FractionalSeconds, 1);
                        break;
                    case 'SS':
                        formatter = dateGetter(DateType.FractionalSeconds, 2);
                        break;
                    case 'SSS':
                        formatter = dateGetter(DateType.FractionalSeconds, 3);
                        break;
                    // Timezone ISO8601 short format (-0430)
                    case 'Z':
                    case 'ZZ':
                    case 'ZZZ':
                        formatter = timeZoneGetter(ZoneWidth.Short);
                        break;
                    // Timezone ISO8601 extended format (-04:30)
                    case 'ZZZZZ':
                        formatter = timeZoneGetter(ZoneWidth.Extended);
                        break;
                    // Timezone GMT short format (GMT+4)
                    case 'O':
                    case 'OO':
                    case 'OOO':
                    // Should be location, but fallback to format O instead because we don't have the data yet
                    case 'z':
                    case 'zz':
                    case 'zzz':
                        formatter = timeZoneGetter(ZoneWidth.ShortGMT);
                        break;
                    // Timezone GMT long format (GMT+0430)
                    case 'OOOO':
                    case 'ZZZZ':
                    // Should be location, but fallback to format O instead because we don't have the data yet
                    case 'zzzz':
                        formatter = timeZoneGetter(ZoneWidth.Long);
                        break;
                    default:
                        return null;
                }
                DATE_FORMATS[format] = formatter;
                return formatter;
            }
            /**
             * @param {?} timezone
             * @param {?} fallback
             * @return {?}
             */
            function timezoneToOffset(timezone, fallback) {
                // Support: IE 9-11 only, Edge 13-15+
                // IE/Edge do not "understand" colon (`:`) in timezone
                timezone = timezone.replace(/:/g, '');
                /** @type {?} */
                var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
                return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
            }
            /**
             * @param {?} date
             * @param {?} minutes
             * @return {?}
             */
            function addDateMinutes(date, minutes) {
                date = new Date(date.getTime());
                date.setMinutes(date.getMinutes() + minutes);
                return date;
            }
            /**
             * @param {?} date
             * @param {?} timezone
             * @param {?} reverse
             * @return {?}
             */
            function convertTimezoneToLocal(date, timezone, reverse) {
                /** @type {?} */
                var reverseValue = reverse ? -1 : 1;
                /** @type {?} */
                var dateTimezoneOffset = date.getTimezoneOffset();
                /** @type {?} */
                var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
                return addDateMinutes(date, reverseValue * (timezoneOffset - dateTimezoneOffset));
            }
            /**
             * Converts a value to date.
             *
             * Supported input formats:
             * - `Date`
             * - number: timestamp
             * - string: numeric (e.g. "1234"), ISO and date strings in a format supported by
             *   [Date.parse()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse).
             *   Note: ISO strings without time return a date without timeoffset.
             *
             * Throws if unable to convert to a date.
             * @param {?} value
             * @return {?}
             */
            function toDate(value) {
                if (isDate(value)) {
                    return value;
                }
                if (typeof value === 'number' && !isNaN(value)) {
                    return new Date(value);
                }
                if (typeof value === 'string') {
                    value = value.trim();
                    /** @type {?} */
                    var parsedNb = parseFloat(value);
                    // any string that only contains numbers, like "1234" but not like "1234hello"
                    if (!isNaN(( /** @type {?} */(value)) - parsedNb)) {
                        return new Date(parsedNb);
                    }
                    if (/^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
                        /* For ISO Strings without time the day, month and year must be extracted from the ISO String
                              before Date creation to avoid time offset and errors in the new Date.
                              If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
                              date, some browsers (e.g. IE 9) will throw an invalid Date error.
                              If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
                              is applied.
                              Note: ISO months are 0 for January, 1 for February, ... */
                        var _c = value.split('-').map(( /**
                         * @param {?} val
                         * @return {?}
                         */function (val) { return +val; })), y = _c[0], m = _c[1], d = _c[2];
                        return new Date(y, m - 1, d);
                    }
                    /** @type {?} */
                    var match = void 0;
                    if (match = value.match(ISO8601_DATE_REGEX)) {
                        return isoStringToDate(match);
                    }
                }
                /** @type {?} */
                var date = new Date(( /** @type {?} */(value)));
                if (!isDate(date)) {
                    throw new Error("Unable to convert \"" + value + "\" into a date");
                }
                return date;
            }
            /**
             * Converts a date in ISO8601 to a Date.
             * Used instead of `Date.parse` because of browser discrepancies.
             * @param {?} match
             * @return {?}
             */
            function isoStringToDate(match) {
                /** @type {?} */
                var date = new Date(0);
                /** @type {?} */
                var tzHour = 0;
                /** @type {?} */
                var tzMin = 0;
                // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
                /** @type {?} */
                var dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
                /** @type {?} */
                var timeSetter = match[8] ? date.setUTCHours : date.setHours;
                // if there is a timezone defined like "+01:00" or "+0100"
                if (match[9]) {
                    tzHour = Number(match[9] + match[10]);
                    tzMin = Number(match[9] + match[11]);
                }
                dateSetter.call(date, Number(match[1]), Number(match[2]) - 1, Number(match[3]));
                /** @type {?} */
                var h = Number(match[4] || 0) - tzHour;
                /** @type {?} */
                var m = Number(match[5] || 0) - tzMin;
                /** @type {?} */
                var s = Number(match[6] || 0);
                /** @type {?} */
                var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
                timeSetter.call(date, h, m, s, ms);
                return date;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isDate(value) {
                return value instanceof Date && !isNaN(value.valueOf());
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
            /** @type {?} */
            var MAX_DIGITS = 22;
            /** @type {?} */
            var DECIMAL_SEP = '.';
            /** @type {?} */
            var ZERO_CHAR = '0';
            /** @type {?} */
            var PATTERN_SEP = ';';
            /** @type {?} */
            var GROUP_SEP = ',';
            /** @type {?} */
            var DIGIT_CHAR = '#';
            /** @type {?} */
            var CURRENCY_CHAR = '¤';
            /** @type {?} */
            var PERCENT_CHAR = '%';
            /**
             * Transforms a number to a locale string based on a style and a format.
             * @param {?} value
             * @param {?} pattern
             * @param {?} locale
             * @param {?} groupSymbol
             * @param {?} decimalSymbol
             * @param {?=} digitsInfo
             * @param {?=} isPercent
             * @return {?}
             */
            function formatNumberToLocaleString(value, pattern, locale, groupSymbol, decimalSymbol, digitsInfo, isPercent) {
                if (isPercent === void 0) { isPercent = false; }
                /** @type {?} */
                var formattedText = '';
                /** @type {?} */
                var isZero = false;
                if (!isFinite(value)) {
                    formattedText = getLocaleNumberSymbol(locale, NumberSymbol.Infinity);
                }
                else {
                    /** @type {?} */
                    var parsedNumber = parseNumber(value);
                    if (isPercent) {
                        parsedNumber = toPercent(parsedNumber);
                    }
                    /** @type {?} */
                    var minInt = pattern.minInt;
                    /** @type {?} */
                    var minFraction = pattern.minFrac;
                    /** @type {?} */
                    var maxFraction = pattern.maxFrac;
                    if (digitsInfo) {
                        /** @type {?} */
                        var parts = digitsInfo.match(NUMBER_FORMAT_REGEXP);
                        if (parts === null) {
                            throw new Error(digitsInfo + " is not a valid digit info");
                        }
                        /** @type {?} */
                        var minIntPart = parts[1];
                        /** @type {?} */
                        var minFractionPart = parts[3];
                        /** @type {?} */
                        var maxFractionPart = parts[5];
                        if (minIntPart != null) {
                            minInt = parseIntAutoRadix(minIntPart);
                        }
                        if (minFractionPart != null) {
                            minFraction = parseIntAutoRadix(minFractionPart);
                        }
                        if (maxFractionPart != null) {
                            maxFraction = parseIntAutoRadix(maxFractionPart);
                        }
                        else if (minFractionPart != null && minFraction > maxFraction) {
                            maxFraction = minFraction;
                        }
                    }
                    roundNumber(parsedNumber, minFraction, maxFraction);
                    /** @type {?} */
                    var digits = parsedNumber.digits;
                    /** @type {?} */
                    var integerLen = parsedNumber.integerLen;
                    /** @type {?} */
                    var exponent = parsedNumber.exponent;
                    /** @type {?} */
                    var decimals = [];
                    isZero = digits.every(( /**
                     * @param {?} d
                     * @return {?}
                     */function (/**
                     * @param {?} d
                     * @return {?}
                     */ d) { return !d; }));
                    // pad zeros for small numbers
                    for (; integerLen < minInt; integerLen++) {
                        digits.unshift(0);
                    }
                    // pad zeros for small numbers
                    for (; integerLen < 0; integerLen++) {
                        digits.unshift(0);
                    }
                    // extract decimals digits
                    if (integerLen > 0) {
                        decimals = digits.splice(integerLen, digits.length);
                    }
                    else {
                        decimals = digits;
                        digits = [0];
                    }
                    // format the integer digits with grouping separators
                    /** @type {?} */
                    var groups = [];
                    if (digits.length >= pattern.lgSize) {
                        groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
                    }
                    while (digits.length > pattern.gSize) {
                        groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
                    }
                    if (digits.length) {
                        groups.unshift(digits.join(''));
                    }
                    formattedText = groups.join(getLocaleNumberSymbol(locale, groupSymbol));
                    // append the decimal digits
                    if (decimals.length) {
                        formattedText += getLocaleNumberSymbol(locale, decimalSymbol) + decimals.join('');
                    }
                    if (exponent) {
                        formattedText += getLocaleNumberSymbol(locale, NumberSymbol.Exponential) + '+' + exponent;
                    }
                }
                if (value < 0 && !isZero) {
                    formattedText = pattern.negPre + formattedText + pattern.negSuf;
                }
                else {
                    formattedText = pattern.posPre + formattedText + pattern.posSuf;
                }
                return formattedText;
            }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a number as currency using locale rules.
             *
             * @see `formatNumber()` / `DecimalPipe` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} value The number to format.
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?} currency A string containing the currency symbol or its name,
             * such as "$" or "Canadian Dollar". Used in output string, but does not affect the operation
             * of the function.
             * @param {?=} currencyCode The [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217)
             * currency code, such as `USD` for the US dollar and `EUR` for the euro.
             * Used to determine the number of digits in the decimal part.
             * @param {?=} digitsInfo
             * @return {?} The formatted currency value.
             *
             */
            function formatCurrency(value, locale, currency, currencyCode, digitsInfo) {
                /** @type {?} */
                var format = getLocaleNumberFormat(locale, NumberFormatStyle.Currency);
                /** @type {?} */
                var pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
                pattern.minFrac = getNumberOfCurrencyDigits(( /** @type {?} */(currencyCode)));
                pattern.maxFrac = pattern.minFrac;
                /** @type {?} */
                var res = formatNumberToLocaleString(value, pattern, locale, NumberSymbol.CurrencyGroup, NumberSymbol.CurrencyDecimal, digitsInfo);
                return res
                    .replace(CURRENCY_CHAR, currency)
                    // if we have 2 time the currency character, the second one is ignored
                    .replace(CURRENCY_CHAR, '');
            }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a number as a percentage according to locale rules.
             *
             * @see `formatNumber()` / `DecimalPipe` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             * \@publicApi
             *
             * @param {?} value The number to format.
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?=} digitsInfo
             * @return {?} The formatted percentage value.
             *
             */
            function formatPercent(value, locale, digitsInfo) {
                /** @type {?} */
                var format = getLocaleNumberFormat(locale, NumberFormatStyle.Percent);
                /** @type {?} */
                var pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
                /** @type {?} */
                var res = formatNumberToLocaleString(value, pattern, locale, NumberSymbol.Group, NumberSymbol.Decimal, digitsInfo, true);
                return res.replace(new RegExp(PERCENT_CHAR, 'g'), getLocaleNumberSymbol(locale, NumberSymbol.PercentSign));
            }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a number as text, with group sizing, separator, and other
             * parameters based on the locale.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             *
             * \@publicApi
             * @param {?} value The number to format.
             * @param {?} locale A locale code for the locale format rules to use.
             * @param {?=} digitsInfo
             * @return {?} The formatted text string.
             */
            function formatNumber(value, locale, digitsInfo) {
                /** @type {?} */
                var format = getLocaleNumberFormat(locale, NumberFormatStyle.Decimal);
                /** @type {?} */
                var pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
                return formatNumberToLocaleString(value, pattern, locale, NumberSymbol.Group, NumberSymbol.Decimal, digitsInfo);
            }
            /**
             * @record
             */
            function ParsedNumberFormat() { }
            if (false) { }
            /**
             * @param {?} format
             * @param {?=} minusSign
             * @return {?}
             */
            function parseNumberFormat(format, minusSign) {
                if (minusSign === void 0) { minusSign = '-'; }
                /** @type {?} */
                var p = {
                    minInt: 1,
                    minFrac: 0,
                    maxFrac: 0,
                    posPre: '',
                    posSuf: '',
                    negPre: '',
                    negSuf: '',
                    gSize: 0,
                    lgSize: 0
                };
                /** @type {?} */
                var patternParts = format.split(PATTERN_SEP);
                /** @type {?} */
                var positive = patternParts[0];
                /** @type {?} */
                var negative = patternParts[1];
                /** @type {?} */
                var positiveParts = positive.indexOf(DECIMAL_SEP) !== -1 ?
                    positive.split(DECIMAL_SEP) :
                    [
                        positive.substring(0, positive.lastIndexOf(ZERO_CHAR) + 1),
                        positive.substring(positive.lastIndexOf(ZERO_CHAR) + 1)
                    ];
                /** @type {?} */
                var integer = positiveParts[0];
                /** @type {?} */
                var fraction = positiveParts[1] || '';
                p.posPre = integer.substr(0, integer.indexOf(DIGIT_CHAR));
                for (var i = 0; i < fraction.length; i++) {
                    /** @type {?} */
                    var ch = fraction.charAt(i);
                    if (ch === ZERO_CHAR) {
                        p.minFrac = p.maxFrac = i + 1;
                    }
                    else if (ch === DIGIT_CHAR) {
                        p.maxFrac = i + 1;
                    }
                    else {
                        p.posSuf += ch;
                    }
                }
                /** @type {?} */
                var groups = integer.split(GROUP_SEP);
                p.gSize = groups[1] ? groups[1].length : 0;
                p.lgSize = (groups[2] || groups[1]) ? (groups[2] || groups[1]).length : 0;
                if (negative) {
                    /** @type {?} */
                    var trunkLen = positive.length - p.posPre.length - p.posSuf.length;
                    /** @type {?} */
                    var pos = negative.indexOf(DIGIT_CHAR);
                    p.negPre = negative.substr(0, pos).replace(/'/g, '');
                    p.negSuf = negative.substr(pos + trunkLen).replace(/'/g, '');
                }
                else {
                    p.negPre = minusSign + p.posPre;
                    p.negSuf = p.posSuf;
                }
                return p;
            }
            /**
             * @record
             */
            function ParsedNumber() { }
            if (false) { }
            // Transforms a parsed number into a percentage by multiplying it by 100
            /**
             * @param {?} parsedNumber
             * @return {?}
             */
            function toPercent(parsedNumber) {
                // if the number is 0, don't do anything
                if (parsedNumber.digits[0] === 0) {
                    return parsedNumber;
                }
                // Getting the current number of decimals
                /** @type {?} */
                var fractionLen = parsedNumber.digits.length - parsedNumber.integerLen;
                if (parsedNumber.exponent) {
                    parsedNumber.exponent += 2;
                }
                else {
                    if (fractionLen === 0) {
                        parsedNumber.digits.push(0, 0);
                    }
                    else if (fractionLen === 1) {
                        parsedNumber.digits.push(0);
                    }
                    parsedNumber.integerLen += 2;
                }
                return parsedNumber;
            }
            /**
             * Parses a number.
             * Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/
             * @param {?} num
             * @return {?}
             */
            function parseNumber(num) {
                /** @type {?} */
                var numStr = Math.abs(num) + '';
                /** @type {?} */
                var exponent = 0;
                /** @type {?} */
                var digits;
                /** @type {?} */
                var integerLen;
                /** @type {?} */
                var i;
                /** @type {?} */
                var j;
                /** @type {?} */
                var zeros;
                // Decimal point?
                if ((integerLen = numStr.indexOf(DECIMAL_SEP)) > -1) {
                    numStr = numStr.replace(DECIMAL_SEP, '');
                }
                // Exponential form?
                if ((i = numStr.search(/e/i)) > 0) {
                    // Work out the exponent.
                    if (integerLen < 0)
                        integerLen = i;
                    integerLen += +numStr.slice(i + 1);
                    numStr = numStr.substring(0, i);
                }
                else if (integerLen < 0) {
                    // There was no decimal point or exponent so it is an integer.
                    integerLen = numStr.length;
                }
                // Count the number of leading zeros.
                for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */
                }
                if (i === (zeros = numStr.length)) {
                    // The digits are all zero.
                    digits = [0];
                    integerLen = 1;
                }
                else {
                    // Count the number of trailing zeros
                    zeros--;
                    while (numStr.charAt(zeros) === ZERO_CHAR)
                        zeros--;
                    // Trailing zeros are insignificant so ignore them
                    integerLen -= i;
                    digits = [];
                    // Convert string to array of digits without leading/trailing zeros.
                    for (j = 0; i <= zeros; i++, j++) {
                        digits[j] = Number(numStr.charAt(i));
                    }
                }
                // If the number overflows the maximum allowed digits then use an exponent.
                if (integerLen > MAX_DIGITS) {
                    digits = digits.splice(0, MAX_DIGITS - 1);
                    exponent = integerLen - 1;
                    integerLen = 1;
                }
                return { digits: digits, exponent: exponent, integerLen: integerLen };
            }
            /**
             * Round the parsed number to the specified number of decimal places
             * This function changes the parsedNumber in-place
             * @param {?} parsedNumber
             * @param {?} minFrac
             * @param {?} maxFrac
             * @return {?}
             */
            function roundNumber(parsedNumber, minFrac, maxFrac) {
                if (minFrac > maxFrac) {
                    throw new Error("The minimum number of digits after fraction (" + minFrac + ") is higher than the maximum (" + maxFrac + ").");
                }
                /** @type {?} */
                var digits = parsedNumber.digits;
                /** @type {?} */
                var fractionLen = digits.length - parsedNumber.integerLen;
                /** @type {?} */
                var fractionSize = Math.min(Math.max(minFrac, fractionLen), maxFrac);
                // The index of the digit to where rounding is to occur
                /** @type {?} */
                var roundAt = fractionSize + parsedNumber.integerLen;
                /** @type {?} */
                var digit = digits[roundAt];
                if (roundAt > 0) {
                    // Drop fractional digits beyond `roundAt`
                    digits.splice(Math.max(parsedNumber.integerLen, roundAt));
                    // Set non-fractional digits beyond `roundAt` to 0
                    for (var j = roundAt; j < digits.length; j++) {
                        digits[j] = 0;
                    }
                }
                else {
                    // We rounded to zero so reset the parsedNumber
                    fractionLen = Math.max(0, fractionLen);
                    parsedNumber.integerLen = 1;
                    digits.length = Math.max(1, roundAt = fractionSize + 1);
                    digits[0] = 0;
                    for (var i = 1; i < roundAt; i++)
                        digits[i] = 0;
                }
                if (digit >= 5) {
                    if (roundAt - 1 < 0) {
                        for (var k = 0; k > roundAt; k--) {
                            digits.unshift(0);
                            parsedNumber.integerLen++;
                        }
                        digits.unshift(1);
                        parsedNumber.integerLen++;
                    }
                    else {
                        digits[roundAt - 1]++;
                    }
                }
                // Pad out with zeros to get the required fraction length
                for (; fractionLen < Math.max(0, fractionSize); fractionLen++)
                    digits.push(0);
                /** @type {?} */
                var dropTrailingZeros = fractionSize !== 0;
                // Minimal length = nb of decimals required + current nb of integers
                // Any number besides that is optional and can be removed if it's a trailing 0
                /** @type {?} */
                var minLen = minFrac + parsedNumber.integerLen;
                // Do any carrying, e.g. a digit was rounded up to 10
                /** @type {?} */
                var carry = digits.reduceRight(( /**
                 * @param {?} carry
                 * @param {?} d
                 * @param {?} i
                 * @param {?} digits
                 * @return {?}
                 */function (carry, d, i, digits) {
                    d = d + carry;
                    digits[i] = d < 10 ? d : d - 10; // d % 10
                    if (dropTrailingZeros) {
                        // Do not keep meaningless fractional trailing zeros (e.g. 15.52000 --> 15.52)
                        if (digits[i] === 0 && i >= minLen) {
                            digits.pop();
                        }
                        else {
                            dropTrailingZeros = false;
                        }
                    }
                    return d >= 10 ? 1 : 0; // Math.floor(d / 10);
                }), 0);
                if (carry) {
                    digits.unshift(carry);
                    parsedNumber.integerLen++;
                }
            }
            /**
             * @param {?} text
             * @return {?}
             */
            function parseIntAutoRadix(text) {
                /** @type {?} */
                var result = parseInt(text);
                if (isNaN(result)) {
                    throw new Error('Invalid integer literal when parsing ' + text);
                }
                return result;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @deprecated from v5
             * @type {?}
             */
            var DEPRECATED_PLURAL_FN = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('UseV4Plurals');
            /**
             * \@publicApi
             * @abstract
             */
            var NgLocalization = /** @class */ (function () {
                function NgLocalization() {
                }
                return NgLocalization;
            }());
            if (false) { }
            /**
             * Returns the plural category for a given value.
             * - "=value" when the case exists,
             * - the plural category otherwise
             * @param {?} value
             * @param {?} cases
             * @param {?} ngLocalization
             * @param {?=} locale
             * @return {?}
             */
            function getPluralCategory(value, cases, ngLocalization, locale) {
                /** @type {?} */
                var key = "=" + value;
                if (cases.indexOf(key) > -1) {
                    return key;
                }
                key = ngLocalization.getPluralCategory(value, locale);
                if (cases.indexOf(key) > -1) {
                    return key;
                }
                if (cases.indexOf('other') > -1) {
                    return 'other';
                }
                throw new Error("No plural message found for value \"" + value + "\"");
            }
            /**
             * Returns the plural case based on the locale
             *
             * \@publicApi
             */
            var NgLocaleLocalization = /** @class */ (function (_super_1) {
                __extends(NgLocaleLocalization, _super_1);
                /**
                 * @param {?} locale
                 * @param {?=} deprecatedPluralFn
                 */
                function NgLocaleLocalization(locale, deprecatedPluralFn) {
                    var _this = _super_1.call(this) || this;
                    _this.locale = locale;
                    _this.deprecatedPluralFn = deprecatedPluralFn;
                    return _this;
                }
                /**
                 * @param {?} value
                 * @param {?=} locale
                 * @return {?}
                 */
                NgLocaleLocalization.prototype.getPluralCategory = function (value, locale) {
                    /** @type {?} */
                    var plural = this.deprecatedPluralFn ? this.deprecatedPluralFn(locale || this.locale, value) :
                        getLocalePluralCase(locale || this.locale)(value);
                    switch (plural) {
                        case Plural.Zero:
                            return 'zero';
                        case Plural.One:
                            return 'one';
                        case Plural.Two:
                            return 'two';
                        case Plural.Few:
                            return 'few';
                        case Plural.Many:
                            return 'many';
                        default:
                            return 'other';
                    }
                };
                return NgLocaleLocalization;
            }(NgLocalization));
            NgLocaleLocalization.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            NgLocaleLocalization.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [DEPRECATED_PLURAL_FN,] }] }
            ]; };
            if (false) { }
            /**
             * Returns the plural case based on the locale
             *
             * @deprecated from v5 the plural case function is in locale data files common/locales/*.ts
             * \@publicApi
             * @param {?} locale
             * @param {?} nLike
             * @return {?}
             */
            function getPluralCase(locale, nLike) {
                // TODO(vicb): lazy compute
                if (typeof nLike === 'string') {
                    nLike = parseInt(( /** @type {?} */(nLike)), 10);
                }
                /** @type {?} */
                var n = ( /** @type {?} */(nLike));
                /** @type {?} */
                var nDecimal = n.toString().replace(/^[^.]*\.?/, '');
                /** @type {?} */
                var i = Math.floor(Math.abs(n));
                /** @type {?} */
                var v = nDecimal.length;
                /** @type {?} */
                var f = parseInt(nDecimal, 10);
                /** @type {?} */
                var t = parseInt(n.toString().replace(/^[^.]*\.?|0+$/g, ''), 10) || 0;
                /** @type {?} */
                var lang = locale.split('-')[0].toLowerCase();
                switch (lang) {
                    case 'af':
                    case 'asa':
                    case 'az':
                    case 'bem':
                    case 'bez':
                    case 'bg':
                    case 'brx':
                    case 'ce':
                    case 'cgg':
                    case 'chr':
                    case 'ckb':
                    case 'ee':
                    case 'el':
                    case 'eo':
                    case 'es':
                    case 'eu':
                    case 'fo':
                    case 'fur':
                    case 'gsw':
                    case 'ha':
                    case 'haw':
                    case 'hu':
                    case 'jgo':
                    case 'jmc':
                    case 'ka':
                    case 'kk':
                    case 'kkj':
                    case 'kl':
                    case 'ks':
                    case 'ksb':
                    case 'ky':
                    case 'lb':
                    case 'lg':
                    case 'mas':
                    case 'mgo':
                    case 'ml':
                    case 'mn':
                    case 'nb':
                    case 'nd':
                    case 'ne':
                    case 'nn':
                    case 'nnh':
                    case 'nyn':
                    case 'om':
                    case 'or':
                    case 'os':
                    case 'ps':
                    case 'rm':
                    case 'rof':
                    case 'rwk':
                    case 'saq':
                    case 'seh':
                    case 'sn':
                    case 'so':
                    case 'sq':
                    case 'ta':
                    case 'te':
                    case 'teo':
                    case 'tk':
                    case 'tr':
                    case 'ug':
                    case 'uz':
                    case 'vo':
                    case 'vun':
                    case 'wae':
                    case 'xog':
                        if (n === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'ak':
                    case 'ln':
                    case 'mg':
                    case 'pa':
                    case 'ti':
                        if (n === Math.floor(n) && n >= 0 && n <= 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'am':
                    case 'as':
                    case 'bn':
                    case 'fa':
                    case 'gu':
                    case 'hi':
                    case 'kn':
                    case 'mr':
                    case 'zu':
                        if (i === 0 || n === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'ar':
                        if (n === 0)
                            return Plural.Zero;
                        if (n === 1)
                            return Plural.One;
                        if (n === 2)
                            return Plural.Two;
                        if (n % 100 === Math.floor(n % 100) && n % 100 >= 3 && n % 100 <= 10)
                            return Plural.Few;
                        if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 99)
                            return Plural.Many;
                        return Plural.Other;
                    case 'ast':
                    case 'ca':
                    case 'de':
                    case 'en':
                    case 'et':
                    case 'fi':
                    case 'fy':
                    case 'gl':
                    case 'it':
                    case 'nl':
                    case 'sv':
                    case 'sw':
                    case 'ur':
                    case 'yi':
                        if (i === 1 && v === 0)
                            return Plural.One;
                        return Plural.Other;
                    case 'be':
                        if (n % 10 === 1 && !(n % 100 === 11))
                            return Plural.One;
                        if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 4 &&
                            !(n % 100 >= 12 && n % 100 <= 14))
                            return Plural.Few;
                        if (n % 10 === 0 || n % 10 === Math.floor(n % 10) && n % 10 >= 5 && n % 10 <= 9 ||
                            n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 14)
                            return Plural.Many;
                        return Plural.Other;
                    case 'br':
                        if (n % 10 === 1 && !(n % 100 === 11 || n % 100 === 71 || n % 100 === 91))
                            return Plural.One;
                        if (n % 10 === 2 && !(n % 100 === 12 || n % 100 === 72 || n % 100 === 92))
                            return Plural.Two;
                        if (n % 10 === Math.floor(n % 10) && (n % 10 >= 3 && n % 10 <= 4 || n % 10 === 9) &&
                            !(n % 100 >= 10 && n % 100 <= 19 || n % 100 >= 70 && n % 100 <= 79 ||
                                n % 100 >= 90 && n % 100 <= 99))
                            return Plural.Few;
                        if (!(n === 0) && n % 1e6 === 0)
                            return Plural.Many;
                        return Plural.Other;
                    case 'bs':
                    case 'hr':
                    case 'sr':
                        if (v === 0 && i % 10 === 1 && !(i % 100 === 11) || f % 10 === 1 && !(f % 100 === 11))
                            return Plural.One;
                        if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                            !(i % 100 >= 12 && i % 100 <= 14) ||
                            f % 10 === Math.floor(f % 10) && f % 10 >= 2 && f % 10 <= 4 &&
                                !(f % 100 >= 12 && f % 100 <= 14))
                            return Plural.Few;
                        return Plural.Other;
                    case 'cs':
                    case 'sk':
                        if (i === 1 && v === 0)
                            return Plural.One;
                        if (i === Math.floor(i) && i >= 2 && i <= 4 && v === 0)
                            return Plural.Few;
                        if (!(v === 0))
                            return Plural.Many;
                        return Plural.Other;
                    case 'cy':
                        if (n === 0)
                            return Plural.Zero;
                        if (n === 1)
                            return Plural.One;
                        if (n === 2)
                            return Plural.Two;
                        if (n === 3)
                            return Plural.Few;
                        if (n === 6)
                            return Plural.Many;
                        return Plural.Other;
                    case 'da':
                        if (n === 1 || !(t === 0) && (i === 0 || i === 1))
                            return Plural.One;
                        return Plural.Other;
                    case 'dsb':
                    case 'hsb':
                        if (v === 0 && i % 100 === 1 || f % 100 === 1)
                            return Plural.One;
                        if (v === 0 && i % 100 === 2 || f % 100 === 2)
                            return Plural.Two;
                        if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 ||
                            f % 100 === Math.floor(f % 100) && f % 100 >= 3 && f % 100 <= 4)
                            return Plural.Few;
                        return Plural.Other;
                    case 'ff':
                    case 'fr':
                    case 'hy':
                    case 'kab':
                        if (i === 0 || i === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'fil':
                        if (v === 0 && (i === 1 || i === 2 || i === 3) ||
                            v === 0 && !(i % 10 === 4 || i % 10 === 6 || i % 10 === 9) ||
                            !(v === 0) && !(f % 10 === 4 || f % 10 === 6 || f % 10 === 9))
                            return Plural.One;
                        return Plural.Other;
                    case 'ga':
                        if (n === 1)
                            return Plural.One;
                        if (n === 2)
                            return Plural.Two;
                        if (n === Math.floor(n) && n >= 3 && n <= 6)
                            return Plural.Few;
                        if (n === Math.floor(n) && n >= 7 && n <= 10)
                            return Plural.Many;
                        return Plural.Other;
                    case 'gd':
                        if (n === 1 || n === 11)
                            return Plural.One;
                        if (n === 2 || n === 12)
                            return Plural.Two;
                        if (n === Math.floor(n) && (n >= 3 && n <= 10 || n >= 13 && n <= 19))
                            return Plural.Few;
                        return Plural.Other;
                    case 'gv':
                        if (v === 0 && i % 10 === 1)
                            return Plural.One;
                        if (v === 0 && i % 10 === 2)
                            return Plural.Two;
                        if (v === 0 &&
                            (i % 100 === 0 || i % 100 === 20 || i % 100 === 40 || i % 100 === 60 || i % 100 === 80))
                            return Plural.Few;
                        if (!(v === 0))
                            return Plural.Many;
                        return Plural.Other;
                    case 'he':
                        if (i === 1 && v === 0)
                            return Plural.One;
                        if (i === 2 && v === 0)
                            return Plural.Two;
                        if (v === 0 && !(n >= 0 && n <= 10) && n % 10 === 0)
                            return Plural.Many;
                        return Plural.Other;
                    case 'is':
                        if (t === 0 && i % 10 === 1 && !(i % 100 === 11) || !(t === 0))
                            return Plural.One;
                        return Plural.Other;
                    case 'ksh':
                        if (n === 0)
                            return Plural.Zero;
                        if (n === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'kw':
                    case 'naq':
                    case 'se':
                    case 'smn':
                        if (n === 1)
                            return Plural.One;
                        if (n === 2)
                            return Plural.Two;
                        return Plural.Other;
                    case 'lag':
                        if (n === 0)
                            return Plural.Zero;
                        if ((i === 0 || i === 1) && !(n === 0))
                            return Plural.One;
                        return Plural.Other;
                    case 'lt':
                        if (n % 10 === 1 && !(n % 100 >= 11 && n % 100 <= 19))
                            return Plural.One;
                        if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 9 &&
                            !(n % 100 >= 11 && n % 100 <= 19))
                            return Plural.Few;
                        if (!(f === 0))
                            return Plural.Many;
                        return Plural.Other;
                    case 'lv':
                    case 'prg':
                        if (n % 10 === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19 ||
                            v === 2 && f % 100 === Math.floor(f % 100) && f % 100 >= 11 && f % 100 <= 19)
                            return Plural.Zero;
                        if (n % 10 === 1 && !(n % 100 === 11) || v === 2 && f % 10 === 1 && !(f % 100 === 11) ||
                            !(v === 2) && f % 10 === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'mk':
                        if (v === 0 && i % 10 === 1 || f % 10 === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'mt':
                        if (n === 1)
                            return Plural.One;
                        if (n === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 2 && n % 100 <= 10)
                            return Plural.Few;
                        if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19)
                            return Plural.Many;
                        return Plural.Other;
                    case 'pl':
                        if (i === 1 && v === 0)
                            return Plural.One;
                        if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                            !(i % 100 >= 12 && i % 100 <= 14))
                            return Plural.Few;
                        if (v === 0 && !(i === 1) && i % 10 === Math.floor(i % 10) && i % 10 >= 0 && i % 10 <= 1 ||
                            v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                            v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 12 && i % 100 <= 14)
                            return Plural.Many;
                        return Plural.Other;
                    case 'pt':
                        if (n === Math.floor(n) && n >= 0 && n <= 2 && !(n === 2))
                            return Plural.One;
                        return Plural.Other;
                    case 'ro':
                        if (i === 1 && v === 0)
                            return Plural.One;
                        if (!(v === 0) || n === 0 ||
                            !(n === 1) && n % 100 === Math.floor(n % 100) && n % 100 >= 1 && n % 100 <= 19)
                            return Plural.Few;
                        return Plural.Other;
                    case 'ru':
                    case 'uk':
                        if (v === 0 && i % 10 === 1 && !(i % 100 === 11))
                            return Plural.One;
                        if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                            !(i % 100 >= 12 && i % 100 <= 14))
                            return Plural.Few;
                        if (v === 0 && i % 10 === 0 ||
                            v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                            v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 11 && i % 100 <= 14)
                            return Plural.Many;
                        return Plural.Other;
                    case 'shi':
                        if (i === 0 || n === 1)
                            return Plural.One;
                        if (n === Math.floor(n) && n >= 2 && n <= 10)
                            return Plural.Few;
                        return Plural.Other;
                    case 'si':
                        if (n === 0 || n === 1 || i === 0 && f === 1)
                            return Plural.One;
                        return Plural.Other;
                    case 'sl':
                        if (v === 0 && i % 100 === 1)
                            return Plural.One;
                        if (v === 0 && i % 100 === 2)
                            return Plural.Two;
                        if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 || !(v === 0))
                            return Plural.Few;
                        return Plural.Other;
                    case 'tzm':
                        if (n === Math.floor(n) && n >= 0 && n <= 1 || n === Math.floor(n) && n >= 11 && n <= 99)
                            return Plural.One;
                        return Plural.Other;
                    // When there is no specification, the default is always "other"
                    // Spec: http://cldr.unicode.org/index/cldr-spec/plural-rules
                    // > other (required—general plural form — also used if the language only has a single form)
                    default:
                        return Plural.Other;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Register global data to be used internally by Angular. See the
             * ["I18n guide"](guide/i18n#i18n-pipes) to know how to import additional locale data.
             *
             * \@publicApi
             * @param {?} data
             * @param {?=} localeId
             * @param {?=} extraData
             * @return {?}
             */
            // The signature registerLocaleData(data: any, extraData?: any) is deprecated since v5.1
            function registerLocaleData(data, localeId, extraData) {
                if (typeof localeId !== 'string') {
                    extraData = localeId;
                    localeId = data[_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].LocaleId];
                }
                localeId = localeId.toLowerCase().replace(/_/g, '-');
                _angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLOCALE_DATA"][localeId] = data;
                if (extraData) {
                    _angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLOCALE_DATA"][localeId][_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵLocaleDataIndex"].ExtraData] = extraData;
                }
            }
            /** @enum {number} */
            var ExtraLocaleDataIndex = {
                ExtraDayPeriodFormats: 0,
                ExtraDayPeriodStandalone: 1,
                ExtraDayPeriodsRules: 2,
            };
            /** @enum {number} */
            var CurrencyIndex = {
                Symbol: 0, SymbolNarrow: 1, NbOfDigits: 2,
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @param {?} cookieStr
             * @param {?} name
             * @return {?}
             */
            function parseCookieValue(cookieStr, name) {
                name = encodeURIComponent(name);
                for (var _c = 0, _d = cookieStr.split(';'); _c < _d.length; _c++) {
                    var cookie = _d[_c];
                    /** @type {?} */
                    var eqIndex = cookie.indexOf('=');
                    var _e = eqIndex == -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)], cookieName = _e[0], cookieValue = _e[1];
                    if (cookieName.trim() === name) {
                        return decodeURIComponent(cookieValue);
                    }
                }
                return null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Used to diff and convert ngStyle/ngClass instructions into [style] and [class] bindings.
             *
             * ngStyle and ngClass both accept various forms of input and behave differently than that
             * of how [style] and [class] behave in Angular.
             *
             * The differences are:
             *  - ngStyle and ngClass both **watch** their binding values for changes each time CD runs
             *    while [style] and [class] bindings do not (they check for identity changes)
             *  - ngStyle allows for unit-based keys (e.g. `{'max-width.px':value}`) and [style] does not
             *  - ngClass supports arrays of class values and [class] only accepts map and string values
             *  - ngClass allows for multiple className keys (space-separated) within an array or map
             *     (as the * key) while [class] only accepts a simple key/value map object
             *
             * Having Angular understand and adapt to all the different forms of behavior is complicated
             * and unnecessary. Instead, ngClass and ngStyle should have their input values be converted
             * into something that the core-level [style] and [class] bindings understand.
             *
             * This [StylingDiffer] class handles this conversion by creating a new input value each time
             * the inner representation of the binding value have changed.
             *
             * ## Why do we care about ngStyle/ngClass?
             * The styling algorithm code (documented inside of `render3/interfaces/styling.ts`) needs to
             * respect and understand the styling values emitted through ngStyle and ngClass (when they
             * are present and used in a template).
             *
             * Instead of having these directives manage styling on their own, they should be included
             * into the Angular styling algorithm that exists for [style] and [class] bindings.
             *
             * Here's why:
             *
             * - If ngStyle/ngClass is used in combination with [style]/[class] bindings then the
             *   styles and classes would fall out of sync and be applied and updated at
             *   inconsistent times
             * - Both ngClass/ngStyle do not respect [class.name] and [style.prop] bindings
             *   (they will write over them given the right combination of events)
             *
             *   ```
             *   <!-- if `w1` is updated then it will always override `w2`
             *        if `w2` is updated then it will always override `w1`
             *        if both are updated at the same time then `w1` wins -->
             *   <div [ngStyle]="{width:w1}" [style.width]="w2">...</div>
             *
             *   <!-- if `w1` is updated then it will always lose to `w2`
             *        if `w2` is updated then it will always override `w1`
             *        if both are updated at the same time then `w2` wins -->
             *   <div [style]="{width:w1}" [style.width]="w2">...</div>
             *   ```
             * - ngClass/ngStyle were written as a directives and made use of maps, closures and other
             *   expensive data structures which were evaluated each time CD runs
             * @template T
             */
            var StylingDiffer = /** @class */ (function () {
                /**
                 * @param {?} _name
                 * @param {?} _options
                 */
                function StylingDiffer(_name, _options) {
                    this._name = _name;
                    this._options = _options;
                    this.value = null;
                    this._lastSetValue = null;
                    this._lastSetValueType = 0 /* Null */;
                    this._lastSetValueIdentityChange = false;
                }
                /**
                 * Sets (updates) the styling value within the differ.
                 *
                 * Only when `hasValueChanged` is called then this new value will be evaluted
                 * and checked against the previous value.
                 *
                 * @param {?} value the new styling value provided from the ngClass/ngStyle binding
                 * @return {?}
                 */
                StylingDiffer.prototype.setValue = function (value) {
                    if (Array.isArray(value)) {
                        this._lastSetValueType = 4 /* Array */;
                    }
                    else if (value instanceof Set) {
                        this._lastSetValueType = 8 /* Set */;
                    }
                    else if (value && typeof value === 'string') {
                        if (!(this._options & 4 /* AllowStringValue */)) {
                            throw new Error(this._name + ' string values are not allowed');
                        }
                        this._lastSetValueType = 1 /* String */;
                    }
                    else {
                        this._lastSetValueType = value ? 2 /* Map */ : 0 /* Null */;
                    }
                    this._lastSetValueIdentityChange = true;
                    this._lastSetValue = value || null;
                };
                /**
                 * Determines whether or not the value has changed.
                 *
                 * This function can be called right after `setValue()` is called, but it can also be
                 * called incase the existing value (if it's a collection) changes internally. If the
                 * value is indeed a collection it will do the necessary diffing work and produce a
                 * new object value as assign that to `value`.
                 *
                 * @return {?} whether or not the value has changed in some way.
                 */
                StylingDiffer.prototype.hasValueChanged = function () {
                    /** @type {?} */
                    var valueHasChanged = this._lastSetValueIdentityChange;
                    if (!valueHasChanged && !(this._lastSetValueType & 14 /* Collection */))
                        return false;
                    /** @type {?} */
                    var finalValue = null;
                    /** @type {?} */
                    var trimValues = (this._options & 1 /* TrimProperties */) ? true : false;
                    /** @type {?} */
                    var parseOutUnits = (this._options & 8 /* AllowUnits */) ? true : false;
                    /** @type {?} */
                    var allowSubKeys = (this._options & 2 /* AllowSubKeys */) ? true : false;
                    switch (this._lastSetValueType) {
                        // case 1: [input]="string"
                        case 1 /* String */:
                            /** @type {?} */
                            var tokens = (( /** @type {?} */(this._lastSetValue))).split(/\s+/g);
                            if (this._options & 16 /* ForceAsMap */) {
                                finalValue = {};
                                tokens.forEach(( /**
                                 * @param {?} token
                                 * @param {?} i
                                 * @return {?}
                                 */function (token, i) { return (( /** @type {?} */(finalValue)))[token] = true; }));
                            }
                            else {
                                finalValue = tokens.reduce(( /**
                                 * @param {?} str
                                 * @param {?} token
                                 * @param {?} i
                                 * @return {?}
                                 */function (str, token, i) { return str + (i ? ' ' : '') + token; }));
                            }
                            break;
                        // case 2: [input]="{key:value}"
                        case 2 /* Map */:
                            /** @type {?} */
                            var map = ( /** @type {?} */(this._lastSetValue));
                            /** @type {?} */
                            var keys = Object.keys(map);
                            if (!valueHasChanged) {
                                if (this.value) {
                                    // we know that the classExp value exists and that it is
                                    // a map (otherwise an identity change would have occurred)
                                    valueHasChanged = mapHasChanged(keys, ( /** @type {?} */(this.value)), map);
                                }
                                else {
                                    valueHasChanged = true;
                                }
                            }
                            if (valueHasChanged) {
                                finalValue =
                                    bulidMapFromValues(this._name, trimValues, parseOutUnits, allowSubKeys, map, keys);
                            }
                            break;
                        // case 3a: [input]="[str1, str2, ...]"
                        // case 3b: [input]="Set"
                        case 4 /* Array */:
                        case 8 /* Set */:
                            /** @type {?} */
                            var values = Array.from(( /** @type {?} */(this._lastSetValue)));
                            if (!valueHasChanged) {
                                /** @type {?} */
                                var keys_1 = Object.keys(( /** @type {?} */(this.value)));
                                valueHasChanged = !arrayEqualsArray(keys_1, values);
                            }
                            if (valueHasChanged) {
                                finalValue =
                                    bulidMapFromValues(this._name, trimValues, parseOutUnits, allowSubKeys, values);
                            }
                            break;
                        // case 4: [input]="null|undefined"
                        default:
                            finalValue = null;
                            break;
                    }
                    if (valueHasChanged) {
                        (( /** @type {?} */(this))).value = ( /** @type {?} */(finalValue));
                    }
                    return valueHasChanged;
                };
                return StylingDiffer;
            }());
            if (false) { }
            /** @enum {number} */
            var StylingDifferOptions = {
                None: 0,
                TrimProperties: 1,
                AllowSubKeys: 2,
                AllowStringValue: 4,
                AllowUnits: 8,
                ForceAsMap: 16,
            };
            /** @enum {number} */
            var StylingDifferValueTypes = {
                Null: 0,
                String: 1,
                Map: 2,
                Array: 4,
                Set: 8,
                Collection: 14,
            };
            /**
             * builds and returns a map based on the values input value
             *
             * If the `keys` param is provided then the `values` param is treated as a
             * string map. Otherwise `values` is treated as a string array.
             * @param {?} errorPrefix
             * @param {?} trim
             * @param {?} parseOutUnits
             * @param {?} allowSubKeys
             * @param {?} values
             * @param {?=} keys
             * @return {?}
             */
            function bulidMapFromValues(errorPrefix, trim, parseOutUnits, allowSubKeys, values, keys) {
                /** @type {?} */
                var map = {};
                if (keys) {
                    // case 1: map
                    for (var i = 0; i < keys.length; i++) {
                        /** @type {?} */
                        var key = keys[i];
                        key = trim ? key.trim() : key;
                        /** @type {?} */
                        var value = (( /** @type {?} */(values)))[key];
                        setMapValues(map, key, value, parseOutUnits, allowSubKeys);
                    }
                }
                else {
                    // case 2: array
                    for (var i = 0; i < values.length; i++) {
                        /** @type {?} */
                        var value = (( /** @type {?} */(values)))[i];
                        assertValidValue(errorPrefix, value);
                        value = trim ? value.trim() : value;
                        setMapValues(map, value, true, false, allowSubKeys);
                    }
                }
                return map;
            }
            /**
             * @param {?} errorPrefix
             * @param {?} value
             * @return {?}
             */
            function assertValidValue(errorPrefix, value) {
                if (typeof value !== 'string') {
                    throw new Error(errorPrefix + " can only toggle CSS classes expressed as strings, got " + value);
                }
            }
            /**
             * @param {?} map
             * @param {?} key
             * @param {?} value
             * @param {?} parseOutUnits
             * @param {?} allowSubKeys
             * @return {?}
             */
            function setMapValues(map, key, value, parseOutUnits, allowSubKeys) {
                if (allowSubKeys && key.indexOf(' ') > 0) {
                    /** @type {?} */
                    var innerKeys = key.split(/\s+/g);
                    for (var j = 0; j < innerKeys.length; j++) {
                        setIndividualMapValue(map, innerKeys[j], value, parseOutUnits);
                    }
                }
                else {
                    setIndividualMapValue(map, key, value, parseOutUnits);
                }
            }
            /**
             * @param {?} map
             * @param {?} key
             * @param {?} value
             * @param {?} parseOutUnits
             * @return {?}
             */
            function setIndividualMapValue(map, key, value, parseOutUnits) {
                if (parseOutUnits) {
                    /** @type {?} */
                    var values = normalizeStyleKeyAndValue(key, value);
                    value = values.value;
                    key = values.key;
                }
                map[key] = value;
            }
            /**
             * @param {?} key
             * @param {?} value
             * @return {?}
             */
            function normalizeStyleKeyAndValue(key, value) {
                /** @type {?} */
                var index = key.indexOf('.');
                if (index > 0) {
                    /** @type {?} */
                    var unit = key.substr(index + 1);
                    key = key.substring(0, index);
                    if (value != null) { // we should not convert null values to string
                        value += unit;
                    }
                }
                return { key: key, value: value };
            }
            /**
             * @param {?} keys
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function mapHasChanged(keys, a, b) {
                /** @type {?} */
                var oldKeys = Object.keys(a);
                /** @type {?} */
                var newKeys = keys;
                // the keys are different which means the map changed
                if (!arrayEqualsArray(oldKeys, newKeys)) {
                    return true;
                }
                for (var i = 0; i < newKeys.length; i++) {
                    /** @type {?} */
                    var key = newKeys[i];
                    if (a[key] !== b[key]) {
                        return true;
                    }
                }
                return false;
            }
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function arrayEqualsArray(a, b) {
                if (a && b) {
                    if (a.length !== b.length)
                        return false;
                    for (var i = 0; i < a.length; i++) {
                        if (b.indexOf(a[i]) === -1)
                            return false;
                    }
                    return true;
                }
                return false;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used as a token for an injected service within the NgClass directive.
             *
             * NgClass behaves differenly whether or not VE is being used or not. If
             * present then the legacy ngClass diffing algorithm will be used as an
             * injected service. Otherwise the new diffing algorithm (which delegates
             * to the `[class]` binding) will be used. This toggle behavior is done so
             * via the ivy_switch mechanism.
             * @abstract
             */
            var NgClassImpl = /** @class */ (function () {
                function NgClassImpl() {
                }
                return NgClassImpl;
            }());
            if (false) { }
            var NgClassR2Impl = /** @class */ (function () {
                /**
                 * @param {?} _iterableDiffers
                 * @param {?} _keyValueDiffers
                 * @param {?} _ngEl
                 * @param {?} _renderer
                 */
                function NgClassR2Impl(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
                    this._iterableDiffers = _iterableDiffers;
                    this._keyValueDiffers = _keyValueDiffers;
                    this._ngEl = _ngEl;
                    this._renderer = _renderer;
                    this._initialClasses = [];
                }
                /**
                 * @return {?}
                 */
                NgClassR2Impl.prototype.getValue = function () { return null; };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NgClassR2Impl.prototype.setClass = function (value) {
                    this._removeClasses(this._initialClasses);
                    this._initialClasses = typeof value === 'string' ? value.split(/\s+/) : [];
                    this._applyClasses(this._initialClasses);
                    this._applyClasses(this._rawClass);
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NgClassR2Impl.prototype.setNgClass = function (value) {
                    this._removeClasses(this._rawClass);
                    this._applyClasses(this._initialClasses);
                    this._iterableDiffer = null;
                    this._keyValueDiffer = null;
                    this._rawClass = typeof value === 'string' ? value.split(/\s+/) : value;
                    if (this._rawClass) {
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵisListLikeIterable"])(this._rawClass)) {
                            this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create();
                        }
                        else {
                            this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                NgClassR2Impl.prototype.applyChanges = function () {
                    if (this._iterableDiffer) {
                        /** @type {?} */
                        var iterableChanges = this._iterableDiffer.diff(( /** @type {?} */(this._rawClass)));
                        if (iterableChanges) {
                            this._applyIterableChanges(iterableChanges);
                        }
                    }
                    else if (this._keyValueDiffer) {
                        /** @type {?} */
                        var keyValueChanges = this._keyValueDiffer.diff(( /** @type {?} */(this._rawClass)));
                        if (keyValueChanges) {
                            this._applyKeyValueChanges(keyValueChanges);
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                NgClassR2Impl.prototype._applyKeyValueChanges = function (changes) {
                    var _this = this;
                    changes.forEachAddedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) { return _this._toggleClass(record.key, record.currentValue); }));
                    changes.forEachChangedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) { return _this._toggleClass(record.key, record.currentValue); }));
                    changes.forEachRemovedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) {
                        if (record.previousValue) {
                            _this._toggleClass(record.key, false);
                        }
                    }));
                };
                /**
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                NgClassR2Impl.prototype._applyIterableChanges = function (changes) {
                    var _this = this;
                    changes.forEachAddedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) {
                        if (typeof record.item === 'string') {
                            _this._toggleClass(record.item, true);
                        }
                        else {
                            throw new Error("NgClass can only toggle CSS classes expressed as strings, got " + Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵstringify"])(record.item));
                        }
                    }));
                    changes.forEachRemovedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) { return _this._toggleClass(record.item, false); }));
                };
                /**
                 * Applies a collection of CSS classes to the DOM element.
                 *
                 * For argument of type Set and Array CSS class names contained in those collections are always
                 * added.
                 * For argument of type Map CSS class name in the map's key is toggled based on the value (added
                 * for truthy and removed for falsy).
                 * @private
                 * @param {?} rawClassVal
                 * @return {?}
                 */
                NgClassR2Impl.prototype._applyClasses = function (rawClassVal) {
                    var _this = this;
                    if (rawClassVal) {
                        if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
                            (( /** @type {?} */(rawClassVal))).forEach(( /**
                             * @param {?} klass
                             * @return {?}
                             */function (klass) { return _this._toggleClass(klass, true); }));
                        }
                        else {
                            Object.keys(rawClassVal).forEach(( /**
                             * @param {?} klass
                             * @return {?}
                             */function (/**
                             * @param {?} klass
                             * @return {?}
                             */ klass) { return _this._toggleClass(klass, !!rawClassVal[klass]); }));
                        }
                    }
                };
                /**
                 * Removes a collection of CSS classes from the DOM element. This is mostly useful for cleanup
                 * purposes.
                 * @private
                 * @param {?} rawClassVal
                 * @return {?}
                 */
                NgClassR2Impl.prototype._removeClasses = function (rawClassVal) {
                    var _this = this;
                    if (rawClassVal) {
                        if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
                            (( /** @type {?} */(rawClassVal))).forEach(( /**
                             * @param {?} klass
                             * @return {?}
                             */function (klass) { return _this._toggleClass(klass, false); }));
                        }
                        else {
                            Object.keys(rawClassVal).forEach(( /**
                             * @param {?} klass
                             * @return {?}
                             */function (/**
                             * @param {?} klass
                             * @return {?}
                             */ klass) { return _this._toggleClass(klass, false); }));
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} klass
                 * @param {?} enabled
                 * @return {?}
                 */
                NgClassR2Impl.prototype._toggleClass = function (klass, enabled) {
                    var _this = this;
                    klass = klass.trim();
                    if (klass) {
                        klass.split(/\s+/g).forEach(( /**
                         * @param {?} klass
                         * @return {?}
                         */function (/**
                         * @param {?} klass
                         * @return {?}
                         */ klass) {
                            if (enabled) {
                                _this._renderer.addClass(_this._ngEl.nativeElement, klass);
                            }
                            else {
                                _this._renderer.removeClass(_this._ngEl.nativeElement, klass);
                            }
                        }));
                    }
                };
                return NgClassR2Impl;
            }());
            NgClassR2Impl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            NgClassR2Impl.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["IterableDiffers"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["KeyValueDiffers"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] }
            ]; };
            if (false) { }
            var NgClassR3Impl = /** @class */ (function () {
                function NgClassR3Impl() {
                    this._value = null;
                    this._ngClassDiffer = new StylingDiffer('NgClass', 1 /* TrimProperties */ |
                        2 /* AllowSubKeys */ |
                        4 /* AllowStringValue */ | 16 /* ForceAsMap */);
                    this._classStringDiffer = null;
                }
                /**
                 * @return {?}
                 */
                NgClassR3Impl.prototype.getValue = function () { return this._value; };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NgClassR3Impl.prototype.setClass = function (value) {
                    // early exit incase the binding gets emitted as an empty value which
                    // means there is no reason to instantiate and diff the values...
                    if (!value && !this._classStringDiffer)
                        return;
                    this._classStringDiffer = this._classStringDiffer ||
                        new StylingDiffer('class', 4 /* AllowStringValue */ | 16 /* ForceAsMap */);
                    this._classStringDiffer.setValue(value);
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NgClassR3Impl.prototype.setNgClass = function (value) {
                    this._ngClassDiffer.setValue(value);
                };
                /**
                 * @return {?}
                 */
                NgClassR3Impl.prototype.applyChanges = function () {
                    /** @type {?} */
                    var classChanged = this._classStringDiffer ? this._classStringDiffer.hasValueChanged() : false;
                    /** @type {?} */
                    var ngClassChanged = this._ngClassDiffer.hasValueChanged();
                    if (classChanged || ngClassChanged) {
                        /** @type {?} */
                        var value = this._ngClassDiffer.value;
                        if (this._classStringDiffer) {
                            /** @type {?} */
                            var classValue = this._classStringDiffer.value;
                            if (classValue) {
                                value = value ? Object.assign({}, classValue, value) : classValue;
                            }
                        }
                        this._value = value;
                    }
                };
                return NgClassR3Impl;
            }());
            NgClassR3Impl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            if (false) { }
            // the implementation for both NgStyleR2Impl and NgStyleR3Impl are
            // not ivy_switch'd away, instead they are only hooked up into the
            // DI via NgStyle's directive's provider property.
            /** @type {?} */
            var NgClassImplProvider__PRE_R3__ = {
                provide: NgClassImpl,
                useClass: NgClassR2Impl
            };
            /** @type {?} */
            var NgClassImplProvider__POST_R3__ = {
                provide: NgClassImpl,
                useClass: NgClassR3Impl
            };
            /** @type {?} */
            var NgClassImplProvider = NgClassImplProvider__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /*
             * NgClass (as well as NgStyle) behaves differently when loaded in the VE and when not.
             *
             * If the VE is present (which is for older versions of Angular) then NgClass will inject
             * the legacy diffing algorithm as a service and delegate all styling changes to that.
             *
             * If the VE is not present then NgStyle will normalize (through the injected service) and
             * then write all styling changes to the `[style]` binding directly (through a host binding).
             * Then Angular will notice the host binding change and treat the changes as styling
             * changes and apply them via the core styling instructions that exist within Angular.
             */
            // used when the VE is present
            /** @type {?} */
            var ngClassDirectiveDef__PRE_R3__ = undefined;
            // used when the VE is not present (note the directive will
            // never be instantiated normally because it is apart of a
            // base class)
            var ɵ0 = /**
             * @return {?}
             */ function () { }, ɵ1 = /**
             * @return {?}
             */ function () { }, ɵ2 = /**
             * @param {?} rf
             * @param {?} ctx
             * @param {?} elIndex
             * @return {?}
             */ function (rf, ctx, elIndex) {
                if (rf & 1 /* Create */) {
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵallocHostVars"])(1);
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵstyling"])();
                }
                if (rf & 2 /* Update */) {
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵclassMap"])(ctx.getValue());
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵstylingApply"])();
                }
            };
            /** @type {?} */
            var ngClassDirectiveDef__POST_R3__ = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineDirective"])({
                type: ( /** @type {?} */((ɵ0))),
                selectors: ( /** @type {?} */(null)),
                factory: (ɵ1),
                hostBindings: (ɵ2)
            });
            /** @type {?} */
            var ngClassDirectiveDef = ngClassDirectiveDef__PRE_R3__;
            /**
             * Serves as the base non-VE container for NgClass.
             *
             * While this is a base class that NgClass extends from, the
             * class itself acts as a container for non-VE code to setup
             * a link to the `[class]` host binding (via the static
             * `ngDirectiveDef` property on the class).
             *
             * Note that the `ngDirectiveDef` property's code is switched
             * depending if VE is present or not (this allows for the
             * binding code to be set only for newer versions of Angular).
             *
             * \@publicApi
             */
            var NgClassBase = /** @class */ (function () {
                /**
                 * @param {?} _delegate
                 */
                function NgClassBase(_delegate) {
                    this._delegate = _delegate;
                }
                /**
                 * @return {?}
                 */
                NgClassBase.prototype.getValue = function () { return this._delegate.getValue(); };
                return NgClassBase;
            }());
            /** @nocollapse */ NgClassBase.ngDirectiveDef = ngClassDirectiveDef;
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@usageNotes
             * ```
             *     <some-element [ngClass]="'first second'">...</some-element>
             *
             *     <some-element [ngClass]="['first', 'second']">...</some-element>
             *
             *     <some-element [ngClass]="{'first': true, 'second': true, 'third': false}">...</some-element>
             *
             *     <some-element [ngClass]="stringExp|arrayExp|objExp">...</some-element>
             *
             *     <some-element [ngClass]="{'class1 class2 class3' : true}">...</some-element>
             * ```
             *
             * \@description
             *
             * Adds and removes CSS classes on an HTML element.
             *
             * The CSS classes are updated as follows, depending on the type of the expression evaluation:
             * - `string` - the CSS classes listed in the string (space delimited) are added,
             * - `Array` - the CSS classes declared as Array elements are added,
             * - `Object` - keys are CSS classes that get added when the expression given in the value
             *              evaluates to a truthy value, otherwise they are removed.
             *
             * \@publicApi
             */
            var NgClass = /** @class */ (function (_super_1) {
                __extends(NgClass, _super_1);
                /**
                 * @param {?} delegate
                 */
                function NgClass(delegate) {
                    return _super_1.call(this, delegate) || this;
                }
                Object.defineProperty(NgClass.prototype, "klass", {
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._delegate.setClass(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgClass.prototype, "ngClass", {
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._delegate.setNgClass(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                NgClass.prototype.ngDoCheck = function () { this._delegate.applyChanges(); };
                return NgClass;
            }(NgClassBase));
            NgClass.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngClass]', providers: [NgClassImplProvider] },] }
            ];
            /** @nocollapse */
            NgClass.ctorParameters = function () { return [
                { type: NgClassImpl }
            ]; };
            NgClass.propDecorators = {
                klass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['class',] }],
                ngClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngClass',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Instantiates a single {\@link Component} type and inserts its Host View into current View.
             * `NgComponentOutlet` provides a declarative approach for dynamic component creation.
             *
             * `NgComponentOutlet` requires a component type, if a falsy value is set the view will clear and
             * any existing component will get destroyed.
             *
             * \@usageNotes
             *
             * ### Fine tune control
             *
             * You can control the component creation process by using the following optional attributes:
             *
             * * `ngComponentOutletInjector`: Optional custom {\@link Injector} that will be used as parent for
             * the Component. Defaults to the injector of the current view container.
             *
             * * `ngComponentOutletContent`: Optional list of projectable nodes to insert into the content
             * section of the component, if exists.
             *
             * * `ngComponentOutletNgModuleFactory`: Optional module factory to allow dynamically loading other
             * module, then load a component from that module.
             *
             * ### Syntax
             *
             * Simple
             * ```
             * <ng-container *ngComponentOutlet="componentTypeExpression"></ng-container>
             * ```
             *
             * Customized injector/content
             * ```
             * <ng-container *ngComponentOutlet="componentTypeExpression;
             *                                   injector: injectorExpression;
             *                                   content: contentNodesExpression;">
             * </ng-container>
             * ```
             *
             * Customized ngModuleFactory
             * ```
             * <ng-container *ngComponentOutlet="componentTypeExpression;
             *                                   ngModuleFactory: moduleFactory;">
             * </ng-container>
             * ```
             *
             * ### A simple example
             *
             * {\@example common/ngComponentOutlet/ts/module.ts region='SimpleExample'}
             *
             * A more complete example with additional options:
             *
             * {\@example common/ngComponentOutlet/ts/module.ts region='CompleteExample'}
             *
             * \@publicApi
             * \@ngModule CommonModule
             */
            var NgComponentOutlet = /** @class */ (function () {
                /**
                 * @param {?} _viewContainerRef
                 */
                function NgComponentOutlet(_viewContainerRef) {
                    this._viewContainerRef = _viewContainerRef;
                    this._componentRef = null;
                    this._moduleRef = null;
                }
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                NgComponentOutlet.prototype.ngOnChanges = function (changes) {
                    this._viewContainerRef.clear();
                    this._componentRef = null;
                    if (this.ngComponentOutlet) {
                        /** @type {?} */
                        var elInjector = this.ngComponentOutletInjector || this._viewContainerRef.parentInjector;
                        if (changes['ngComponentOutletNgModuleFactory']) {
                            if (this._moduleRef)
                                this._moduleRef.destroy();
                            if (this.ngComponentOutletNgModuleFactory) {
                                /** @type {?} */
                                var parentModule = elInjector.get(_angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModuleRef"]);
                                this._moduleRef = this.ngComponentOutletNgModuleFactory.create(parentModule.injector);
                            }
                            else {
                                this._moduleRef = null;
                            }
                        }
                        /** @type {?} */
                        var componentFactoryResolver = this._moduleRef ? this._moduleRef.componentFactoryResolver :
                            elInjector.get(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ComponentFactoryResolver"]);
                        /** @type {?} */
                        var componentFactory = componentFactoryResolver.resolveComponentFactory(this.ngComponentOutlet);
                        this._componentRef = this._viewContainerRef.createComponent(componentFactory, this._viewContainerRef.length, elInjector, this.ngComponentOutletContent);
                    }
                };
                /**
                 * @return {?}
                 */
                NgComponentOutlet.prototype.ngOnDestroy = function () {
                    if (this._moduleRef)
                        this._moduleRef.destroy();
                };
                return NgComponentOutlet;
            }());
            NgComponentOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngComponentOutlet]' },] }
            ];
            /** @nocollapse */
            NgComponentOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] }
            ]; };
            NgComponentOutlet.propDecorators = {
                ngComponentOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngComponentOutletInjector: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngComponentOutletContent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngComponentOutletNgModuleFactory: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @template T
             */
            var NgForOfContext = /** @class */ (function () {
                /**
                 * @param {?} $implicit
                 * @param {?} ngForOf
                 * @param {?} index
                 * @param {?} count
                 */
                function NgForOfContext($implicit, ngForOf, index, count) {
                    this.$implicit = $implicit;
                    this.ngForOf = ngForOf;
                    this.index = index;
                    this.count = count;
                }
                Object.defineProperty(NgForOfContext.prototype, "first", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.index === 0; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForOfContext.prototype, "last", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.index === this.count - 1; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForOfContext.prototype, "even", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.index % 2 === 0; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForOfContext.prototype, "odd", {
                    /**
                     * @return {?}
                     */
                    get: function () { return !this.even; },
                    enumerable: true,
                    configurable: true
                });
                return NgForOfContext;
            }());
            if (false) { }
            /**
             * A [structural directive](guide/structural-directives) that renders
             * a template for each item in a collection.
             * The directive is placed on an element, which becomes the parent
             * of the cloned templates.
             *
             * The `ngForOf` directive is generally used in the
             * [shorthand form](guide/structural-directives#the-asterisk--prefix) `*ngFor`.
             * In this form, the template to be rendered for each iteration is the content
             * of an anchor element containing the directive.
             *
             * The following example shows the shorthand syntax with some options,
             * contained in an `<li>` element.
             *
             * ```
             * <li *ngFor="let item of items; index as i; trackBy: trackByFn">...</li>
             * ```
             *
             * The shorthand form expands into a long form that uses the `ngForOf` selector
             * on an `<ng-template>` element.
             * The content of the `<ng-template>` element is the `<li>` element that held the
             * short-form directive.
             *
             * Here is the expanded version of the short-form example.
             *
             * ```
             * <ng-template ngFor let-item [ngForOf]="items" let-i="index" [ngForTrackBy]="trackByFn">
             *   <li>...</li>
             * </ng-template>
             * ```
             *
             * Angular automatically expands the shorthand syntax as it compiles the template.
             * The context for each embedded view is logically merged to the current component
             * context according to its lexical position.
             *
             * When using the shorthand syntax, Angular allows only [one structural directive
             * on an element](guide/structural-directives#one-structural-directive-per-host-element).
             * If you want to iterate conditionally, for example,
             * put the `*ngIf` on a container element that wraps the `*ngFor` element.
             * For futher discussion, see
             * [Structural Directives](guide/structural-directives#one-per-element).
             *
             * \@usageNotes
             *
             * ### Local variables
             *
             * `NgForOf` provides exported values that can be aliased to local variables.
             * For example:
             *
             *  ```
             * <li *ngFor="let user of userObservable | async as users; index as i; first as isFirst">
             *    {{i}}/{{users.length}}. {{user}} <span *ngIf="isFirst">default</span>
             * </li>
             * ```
             *
             * The following exported values can be aliased to local variables:
             *
             * - `$implicit: T`: The value of the individual items in the iterable (`ngForOf`).
             * - `ngForOf: NgIterable<T>`: The value of the iterable expression. Useful when the expression is
             * more complex then a property access, for example when using the async pipe (`userStreams |
             * async`).
             * - `index: number`: The index of the current item in the iterable.
             * - `first: boolean`: True when the item is the first item in the iterable.
             * - `last: boolean`: True when the item is the last item in the iterable.
             * - `even: boolean`: True when the item has an even index in the iterable.
             * - `odd: boolean`: True when the item has an odd index in the iterable.
             *
             * ### Change propagation
             *
             * When the contents of the iterator changes, `NgForOf` makes the corresponding changes to the DOM:
             *
             * * When an item is added, a new instance of the template is added to the DOM.
             * * When an item is removed, its template instance is removed from the DOM.
             * * When items are reordered, their respective templates are reordered in the DOM.
             *
             * Angular uses object identity to track insertions and deletions within the iterator and reproduce
             * those changes in the DOM. This has important implications for animations and any stateful
             * controls that are present, such as `<input>` elements that accept user input. Inserted rows can
             * be animated in, deleted rows can be animated out, and unchanged rows retain any unsaved state
             * such as user input.
             * For more on animations, see [Transitions and Triggers](guide/transition-and-triggers).
             *
             * The identities of elements in the iterator can change while the data does not.
             * This can happen, for example, if the iterator is produced from an RPC to the server, and that
             * RPC is re-run. Even if the data hasn't changed, the second response produces objects with
             * different identities, and Angular must tear down the entire DOM and rebuild it (as if all old
             * elements were deleted and all new elements inserted).
             *
             * To avoid this expensive operation, you can customize the default tracking algorithm.
             * by supplying the `trackBy` option to `NgForOf`.
             * `trackBy` takes a function that has two arguments: `index` and `item`.
             * If `trackBy` is given, Angular tracks changes by the return value of the function.
             *
             * @see [Structural Directives](guide/structural-directives)
             * \@ngModule CommonModule
             * \@publicApi
             * @template T
             */
            var NgForOf = /** @class */ (function () {
                /**
                 * @param {?} _viewContainer
                 * @param {?} _template
                 * @param {?} _differs
                 */
                function NgForOf(_viewContainer, _template, _differs) {
                    this._viewContainer = _viewContainer;
                    this._template = _template;
                    this._differs = _differs;
                    this._ngForOfDirty = true;
                    this._differ = null;
                }
                Object.defineProperty(NgForOf.prototype, "ngForOf", {
                    /**
                     * The value of the iterable expression, which can be used as a
                     * [template input variable](guide/structural-directives#template-input-variable).
                     * @param {?} ngForOf
                     * @return {?}
                     */
                    set: function (ngForOf) {
                        this._ngForOf = ngForOf;
                        this._ngForOfDirty = true;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForOf.prototype, "ngForTrackBy", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._trackByFn; },
                    /**
                     * A function that defines how to track changes for items in the iterable.
                     *
                     * When items are added, moved, or removed in the iterable,
                     * the directive must re-render the appropriate DOM nodes.
                     * To minimize churn in the DOM, only nodes that have changed
                     * are re-rendered.
                     *
                     * By default, the change detector assumes that
                     * the object instance identifies the node in the iterable.
                     * When this function is supplied, the directive uses
                     * the result of calling this function to identify the item node,
                     * rather than the identity of the object itself.
                     *
                     * The function receives two inputs,
                     * the iteration index and the node object ID.
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["isDevMode"])() && fn != null && typeof fn !== 'function') {
                            // TODO(vicb): use a log service once there is a public one available
                            if (( /** @type {?} */(console)) && ( /** @type {?} */(console.warn))) {
                                console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ". " +
                                    "See https://angular.io/docs/ts/latest/api/common/index/NgFor-directive.html#!#change-propagation for more information.");
                            }
                        }
                        this._trackByFn = fn;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForOf.prototype, "ngForTemplate", {
                    /**
                     * A reference to the template that is stamped out for each item in the iterable.
                     * @see [template reference variable](guide/template-syntax#template-reference-variables--var-)
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        // TODO(TS2.1): make TemplateRef<Partial<NgForRowOf<T>>> once we move to TS v2.1
                        // The current type is too restrictive; a template that just uses index, for example,
                        // should be acceptable.
                        if (value) {
                            this._template = value;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Applies the changes when needed.
                 * @return {?}
                 */
                NgForOf.prototype.ngDoCheck = function () {
                    if (this._ngForOfDirty) {
                        this._ngForOfDirty = false;
                        // React on ngForOf changes only once all inputs have been initialized
                        /** @type {?} */
                        var value = this._ngForOf;
                        if (!this._differ && value) {
                            try {
                                this._differ = this._differs.find(value).create(this.ngForTrackBy);
                            }
                            catch (_a) {
                                throw new Error("Cannot find a differ supporting object '" + value + "' of type '" + getTypeName(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
                            }
                        }
                    }
                    if (this._differ) {
                        /** @type {?} */
                        var changes = this._differ.diff(this._ngForOf);
                        if (changes)
                            this._applyChanges(changes);
                    }
                };
                /**
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                NgForOf.prototype._applyChanges = function (changes) {
                    var _this = this;
                    /** @type {?} */
                    var insertTuples = [];
                    changes.forEachOperation(( /**
                     * @param {?} item
                     * @param {?} adjustedPreviousIndex
                     * @param {?} currentIndex
                     * @return {?}
                     */function (item, adjustedPreviousIndex, currentIndex) {
                        if (item.previousIndex == null) {
                            /** @type {?} */
                            var view = _this._viewContainer.createEmbeddedView(_this._template, new NgForOfContext(( /** @type {?} */(null)), _this._ngForOf, -1, -1), currentIndex === null ? undefined : currentIndex);
                            /** @type {?} */
                            var tuple = new RecordViewTuple(item, view);
                            insertTuples.push(tuple);
                        }
                        else if (currentIndex == null) {
                            _this._viewContainer.remove(adjustedPreviousIndex === null ? undefined : adjustedPreviousIndex);
                        }
                        else if (adjustedPreviousIndex !== null) {
                            /** @type {?} */
                            var view = ( /** @type {?} */(_this._viewContainer.get(adjustedPreviousIndex)));
                            _this._viewContainer.move(view, currentIndex);
                            /** @type {?} */
                            var tuple = new RecordViewTuple(item, ( /** @type {?} */(view)));
                            insertTuples.push(tuple);
                        }
                    }));
                    for (var i = 0; i < insertTuples.length; i++) {
                        this._perViewChange(insertTuples[i].view, insertTuples[i].record);
                    }
                    for (var i = 0, ilen = this._viewContainer.length; i < ilen; i++) {
                        /** @type {?} */
                        var viewRef = ( /** @type {?} */(this._viewContainer.get(i)));
                        viewRef.context.index = i;
                        viewRef.context.count = ilen;
                        viewRef.context.ngForOf = this._ngForOf;
                    }
                    changes.forEachIdentityChange(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) {
                        /** @type {?} */
                        var viewRef = ( /** @type {?} */(_this._viewContainer.get(record.currentIndex)));
                        viewRef.context.$implicit = record.item;
                    }));
                };
                /**
                 * @private
                 * @param {?} view
                 * @param {?} record
                 * @return {?}
                 */
                NgForOf.prototype._perViewChange = function (view, record) {
                    view.context.$implicit = record.item;
                };
                /**
                 * Asserts the correct type of the context for the template that `NgForOf` will render.
                 *
                 * The presence of this method is a signal to the Ivy template type-check compiler that the
                 * `NgForOf` structural directive renders its template with a specific context type.
                 * @template T
                 * @param {?} dir
                 * @param {?} ctx
                 * @return {?}
                 */
                NgForOf.ngTemplateContextGuard = function (dir, ctx) {
                    return true;
                };
                return NgForOf;
            }());
            NgForOf.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngFor][ngForOf]' },] }
            ];
            /** @nocollapse */
            NgForOf.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["IterableDiffers"] }
            ]; };
            NgForOf.propDecorators = {
                ngForOf: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngForTrackBy: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngForTemplate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @template T
             */
            var RecordViewTuple = /** @class */ (function () {
                /**
                 * @param {?} record
                 * @param {?} view
                 */
                function RecordViewTuple(record, view) {
                    this.record = record;
                    this.view = view;
                }
                return RecordViewTuple;
            }());
            if (false) { }
            /**
             * @param {?} type
             * @return {?}
             */
            function getTypeName(type) {
                return type['name'] || typeof type;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A structural directive that conditionally includes a template based on the value of
             * an expression coerced to Boolean.
             * When the expression evaluates to true, Angular renders the template
             * provided in a `then` clause, and when  false or null,
             * Angular renders the template provided in an optional `else` clause. The default
             * template for the `else` clause is blank.
             *
             * A [shorthand form](guide/structural-directives#the-asterisk--prefix) of the directive,
             * `*ngIf="condition"`, is generally used, provided
             * as an attribute of the anchor element for the inserted template.
             * Angular expands this into a more explicit version, in which the anchor element
             * is contained in an `<ng-template>` element.
             *
             * Simple form with shorthand syntax:
             *
             * ```
             * <div *ngIf="condition">Content to render when condition is true.</div>
             * ```
             *
             * Simple form with expanded syntax:
             *
             * ```
             * <ng-template [ngIf]="condition"><div>Content to render when condition is
             * true.</div></ng-template>
             * ```
             *
             * Form with an "else" block:
             *
             * ```
             * <div *ngIf="condition; else elseBlock">Content to render when condition is true.</div>
             * <ng-template #elseBlock>Content to render when condition is false.</ng-template>
             * ```
             *
             * Shorthand form with "then" and "else" blocks:
             *
             * ```
             * <div *ngIf="condition; then thenBlock else elseBlock"></div>
             * <ng-template #thenBlock>Content to render when condition is true.</ng-template>
             * <ng-template #elseBlock>Content to render when condition is false.</ng-template>
             * ```
             *
             * Form with storing the value locally:
             *
             * ```
             * <div *ngIf="condition as value; else elseBlock">{{value}}</div>
             * <ng-template #elseBlock>Content to render when value is null.</ng-template>
             * ```
             *
             * \@usageNotes
             *
             * The `*ngIf` directive is most commonly used to conditionally show an inline template,
             * as seen in the following  example.
             * The default `else` template is blank.
             *
             * {\@example common/ngIf/ts/module.ts region='NgIfSimple'}
             *
             * ### Showing an alternative template using `else`
             *
             * To display a template when `expression` evaluates to false, use an `else` template
             * binding as shown in the following example.
             * The `else` binding points to an `<ng-template>`  element labeled `#elseBlock`.
             * The template can be defined anywhere in the component view, but is typically placed right after
             * `ngIf` for readability.
             *
             * {\@example common/ngIf/ts/module.ts region='NgIfElse'}
             *
             * ### Using an external `then` template
             *
             * In the previous example, the then-clause template is specified inline, as the content of the
             * tag that contains the `ngIf` directive. You can also specify a template that is defined
             * externally, by referencing a labeled `<ng-template>` element. When you do this, you can
             * change which template to use at runtime, as shown in the following example.
             *
             * {\@example common/ngIf/ts/module.ts region='NgIfThenElse'}
             *
             * ### Storing a conditional result in a variable
             *
             * You might want to show a set of properties from the same object. If you are waiting
             * for asynchronous data, the object can be undefined.
             * In this case, you can use `ngIf` and store the result of the condition in a local
             * variable as shown in the the following example.
             *
             * {\@example common/ngIf/ts/module.ts region='NgIfAs'}
             *
             * This code uses only one `AsyncPipe`, so only one subscription is created.
             * The conditional statement stores the result of `userStream|async` in the local variable `user`.
             * You can then bind the local `user` repeatedly.
             *
             * The conditional displays the data only if `userStream` returns a value,
             * so you don't need to use the
             * [safe-navigation-operator](guide/template-syntax#safe-navigation-operator) (`?.`)
             * to guard against null values when accessing properties.
             * You can display an alternative template while waiting for the data.
             *
             * ### Shorthand syntax
             *
             * The shorthand syntax `*ngIf` expands into two separate template specifications
             * for the "then" and "else" clauses. For example, consider the following shorthand statement,
             * that is meant to show a loading page while waiting for data to be loaded.
             *
             * ```
             * <div class="hero-list" *ngIf="heroes else loading">
             *  ...
             * </div>
             *
             * <ng-template #loading>
             *  <div>Loading...</div>
             * </ng-template>
             * ```
             *
             * You can see that the "else" clause references the `<ng-template>`
             * with the `#loading` label, and the template for the "then" clause
             * is provided as the content of the anchor element.
             *
             * However, when Angular expands the shorthand syntax, it creates
             * another `<ng-template>` tag, with `ngIf` and `ngIfElse` directives.
             * The anchor element containing the template for the "then" clause becomes
             * the content of this unlabeled `<ng-template>` tag.
             *
             * ```
             * <ng-template [ngIf]="hero-list" [ngIfElse]="loading">
             *  <div class="hero-list">
             *   ...
             *  </div>
             * </ng-template>
             *
             * <ng-template #loading>
             *  <div>Loading...</div>
             * </ng-template>
             * ```
             *
             * The presence of the implicit template object has implications for the nesting of
             * structural directives. For more on this subject, see
             * [Structural Directives](https://angular.io/guide/structural-directives#one-per-element).
             *
             * \@ngModule CommonModule
             * \@publicApi
             */
            var NgIf = /** @class */ (function () {
                /**
                 * @param {?} _viewContainer
                 * @param {?} templateRef
                 */
                function NgIf(_viewContainer, templateRef) {
                    this._viewContainer = _viewContainer;
                    this._context = new NgIfContext();
                    this._thenTemplateRef = null;
                    this._elseTemplateRef = null;
                    this._thenViewRef = null;
                    this._elseViewRef = null;
                    this._thenTemplateRef = templateRef;
                }
                Object.defineProperty(NgIf.prototype, "ngIf", {
                    /**
                     * The Boolean expression to evaluate as the condition for showing a template.
                     * @param {?} condition
                     * @return {?}
                     */
                    set: function (condition) {
                        this._context.$implicit = this._context.ngIf = condition;
                        this._updateView();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgIf.prototype, "ngIfThen", {
                    /**
                     * A template to show if the condition expression evaluates to true.
                     * @param {?} templateRef
                     * @return {?}
                     */
                    set: function (templateRef) {
                        assertTemplate('ngIfThen', templateRef);
                        this._thenTemplateRef = templateRef;
                        this._thenViewRef = null; // clear previous view if any.
                        this._updateView();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgIf.prototype, "ngIfElse", {
                    /**
                     * A template to show if the condition expression evaluates to false.
                     * @param {?} templateRef
                     * @return {?}
                     */
                    set: function (templateRef) {
                        assertTemplate('ngIfElse', templateRef);
                        this._elseTemplateRef = templateRef;
                        this._elseViewRef = null; // clear previous view if any.
                        this._updateView();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @return {?}
                 */
                NgIf.prototype._updateView = function () {
                    if (this._context.$implicit) {
                        if (!this._thenViewRef) {
                            this._viewContainer.clear();
                            this._elseViewRef = null;
                            if (this._thenTemplateRef) {
                                this._thenViewRef =
                                    this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context);
                            }
                        }
                    }
                    else {
                        if (!this._elseViewRef) {
                            this._viewContainer.clear();
                            this._thenViewRef = null;
                            if (this._elseTemplateRef) {
                                this._elseViewRef =
                                    this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context);
                            }
                        }
                    }
                };
                return NgIf;
            }());
            NgIf.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngIf]' },] }
            ];
            /** @nocollapse */
            NgIf.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] }
            ]; };
            NgIf.propDecorators = {
                ngIf: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngIfThen: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngIfElse: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@publicApi
             */
            var NgIfContext = /** @class */ (function () {
                function NgIfContext() {
                    this.$implicit = null;
                    this.ngIf = null;
                }
                return NgIfContext;
            }());
            if (false) { }
            /**
             * @param {?} property
             * @param {?} templateRef
             * @return {?}
             */
            function assertTemplate(property, templateRef) {
                /** @type {?} */
                var isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
                if (!isTemplateRefOrNull) {
                    throw new Error(property + " must be a TemplateRef, but received '" + Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵstringify"])(templateRef) + "'.");
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var SwitchView = /** @class */ (function () {
                /**
                 * @param {?} _viewContainerRef
                 * @param {?} _templateRef
                 */
                function SwitchView(_viewContainerRef, _templateRef) {
                    this._viewContainerRef = _viewContainerRef;
                    this._templateRef = _templateRef;
                    this._created = false;
                }
                /**
                 * @return {?}
                 */
                SwitchView.prototype.create = function () {
                    this._created = true;
                    this._viewContainerRef.createEmbeddedView(this._templateRef);
                };
                /**
                 * @return {?}
                 */
                SwitchView.prototype.destroy = function () {
                    this._created = false;
                    this._viewContainerRef.clear();
                };
                /**
                 * @param {?} created
                 * @return {?}
                 */
                SwitchView.prototype.enforceState = function (created) {
                    if (created && !this._created) {
                        this.create();
                    }
                    else if (!created && this._created) {
                        this.destroy();
                    }
                };
                return SwitchView;
            }());
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@description A structural directive that adds or removes templates (displaying or hiding views)
             * when the next match expression matches the switch expression.
             *
             * The `[ngSwitch]` directive on a container specifies an expression to match against.
             * The expressions to match are provided by `ngSwitchCase` directives on views within the container.
             * - Every view that matches is rendered.
             * - If there are no matches, a view with the `ngSwitchDefault` directive is rendered.
             * - Elements within the `[NgSwitch]` statement but outside of any `NgSwitchCase`
             * or `ngSwitchDefault` directive are preserved at the location.
             *
             * \@usageNotes
             * Define a container element for the directive, and specify the switch expression
             * to match against as an attribute:
             *
             * ```
             * <container-element [ngSwitch]="switch_expression">
             * ```
             *
             * Within the container, `*ngSwitchCase` statements specify the match expressions
             * as attributes. Include `*ngSwitchDefault` as the final case.
             *
             * ```
             * <container-element [ngSwitch]="switch_expression">
             *    <some-element *ngSwitchCase="match_expression_1">...</some-element>
             * ...
             *    <some-element *ngSwitchDefault>...</some-element>
             * </container-element>
             * ```
             *
             * ### Usage Examples
             *
             * The following example shows how to use more than one case to display the same view:
             *
             * ```
             * <container-element [ngSwitch]="switch_expression">
             *   <!-- the same view can be shown in more than one case -->
             *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
             *   <some-element *ngSwitchCase="match_expression_2">...</some-element>
             *   <some-other-element *ngSwitchCase="match_expression_3">...</some-other-element>
             *   <!--default case when there are no matches -->
             *   <some-element *ngSwitchDefault>...</some-element>
             * </container-element>
             * ```
             *
             * The following example shows how cases can be nested:
             * ```
             * <container-element [ngSwitch]="switch_expression">
             *       <some-element *ngSwitchCase="match_expression_1">...</some-element>
             *       <some-element *ngSwitchCase="match_expression_2">...</some-element>
             *       <some-other-element *ngSwitchCase="match_expression_3">...</some-other-element>
             *       <ng-container *ngSwitchCase="match_expression_3">
             *         <!-- use a ng-container to group multiple root nodes -->
             *         <inner-element></inner-element>
             *         <inner-other-element></inner-other-element>
             *       </ng-container>
             *       <some-element *ngSwitchDefault>...</some-element>
             *     </container-element>
             * ```
             *
             * \@publicApi
             * @see `NgSwitchCase`
             * @see `NgSwitchDefault`
             * @see [Structural Directives](guide/structural-directives)
             *
             */
            var NgSwitch = /** @class */ (function () {
                function NgSwitch() {
                    this._defaultUsed = false;
                    this._caseCount = 0;
                    this._lastCaseCheckIndex = 0;
                    this._lastCasesMatched = false;
                }
                Object.defineProperty(NgSwitch.prototype, "ngSwitch", {
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) {
                        this._ngSwitch = newValue;
                        if (this._caseCount === 0) {
                            this._updateDefaultCases(true);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@internal
                 * @return {?}
                 */
                NgSwitch.prototype._addCase = function () { return this._caseCount++; };
                /**
                 * \@internal
                 * @param {?} view
                 * @return {?}
                 */
                NgSwitch.prototype._addDefault = function (view) {
                    if (!this._defaultViews) {
                        this._defaultViews = [];
                    }
                    this._defaultViews.push(view);
                };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                NgSwitch.prototype._matchCase = function (value) {
                    /** @type {?} */
                    var matched = value == this._ngSwitch;
                    this._lastCasesMatched = this._lastCasesMatched || matched;
                    this._lastCaseCheckIndex++;
                    if (this._lastCaseCheckIndex === this._caseCount) {
                        this._updateDefaultCases(!this._lastCasesMatched);
                        this._lastCaseCheckIndex = 0;
                        this._lastCasesMatched = false;
                    }
                    return matched;
                };
                /**
                 * @private
                 * @param {?} useDefault
                 * @return {?}
                 */
                NgSwitch.prototype._updateDefaultCases = function (useDefault) {
                    if (this._defaultViews && useDefault !== this._defaultUsed) {
                        this._defaultUsed = useDefault;
                        for (var i = 0; i < this._defaultViews.length; i++) {
                            /** @type {?} */
                            var defaultView = this._defaultViews[i];
                            defaultView.enforceState(useDefault);
                        }
                    }
                };
                return NgSwitch;
            }());
            NgSwitch.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngSwitch]' },] }
            ];
            NgSwitch.propDecorators = {
                ngSwitch: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@description
             * Provides a switch case expression to match against an enclosing `ngSwitch` expression.
             * When the expressions match, the given `NgSwitchCase` template is rendered.
             * If multiple match expressions match the switch expression value, all of them are displayed.
             *
             * \@usageNotes
             *
             * Within a switch container, `*ngSwitchCase` statements specify the match expressions
             * as attributes. Include `*ngSwitchDefault` as the final case.
             *
             * ```
             * <container-element [ngSwitch]="switch_expression">
             *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
             *   ...
             *   <some-element *ngSwitchDefault>...</some-element>
             * </container-element>
             * ```
             *
             * Each switch-case statement contains an in-line HTML template or template reference
             * that defines the subtree to be selected if the value of the match expression
             * matches the value of the switch expression.
             *
             * Unlike JavaScript, which uses strict equality, Angular uses loose equality.
             * This means that the empty string, `""` matches 0.
             *
             * \@publicApi
             * @see `NgSwitch`
             * @see `NgSwitchDefault`
             *
             */
            var NgSwitchCase = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?} templateRef
                 * @param {?} ngSwitch
                 */
                function NgSwitchCase(viewContainer, templateRef, ngSwitch) {
                    this.ngSwitch = ngSwitch;
                    ngSwitch._addCase();
                    this._view = new SwitchView(viewContainer, templateRef);
                }
                /**
                 * Performs case matching. For internal use only.
                 * @return {?}
                 */
                NgSwitchCase.prototype.ngDoCheck = function () { this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase)); };
                return NgSwitchCase;
            }());
            NgSwitchCase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngSwitchCase]' },] }
            ];
            /** @nocollapse */
            NgSwitchCase.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] },
                { type: NgSwitch, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] }
            ]; };
            NgSwitchCase.propDecorators = {
                ngSwitchCase: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@description
             *
             * Creates a view that is rendered when no `NgSwitchCase` expressions
             * match the `NgSwitch` expression.
             * This statement should be the final case in an `NgSwitch`.
             *
             * \@publicApi
             * @see `NgSwitch`
             * @see `NgSwitchCase`
             *
             */
            var NgSwitchDefault = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?} templateRef
                 * @param {?} ngSwitch
                 */
                function NgSwitchDefault(viewContainer, templateRef, ngSwitch) {
                    ngSwitch._addDefault(new SwitchView(viewContainer, templateRef));
                }
                return NgSwitchDefault;
            }());
            NgSwitchDefault.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngSwitchDefault]' },] }
            ];
            /** @nocollapse */
            NgSwitchDefault.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] },
                { type: NgSwitch, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             *
             * \@usageNotes
             * ```
             * <some-element [ngPlural]="value">
             *   <ng-template ngPluralCase="=0">there is nothing</ng-template>
             *   <ng-template ngPluralCase="=1">there is one</ng-template>
             *   <ng-template ngPluralCase="few">there are a few</ng-template>
             * </some-element>
             * ```
             *
             * \@description
             *
             * Adds / removes DOM sub-trees based on a numeric value. Tailored for pluralization.
             *
             * Displays DOM sub-trees that match the switch expression value, or failing that, DOM sub-trees
             * that match the switch expression's pluralization category.
             *
             * To use this directive you must provide a container element that sets the `[ngPlural]` attribute
             * to a switch expression. Inner elements with a `[ngPluralCase]` will display based on their
             * expression:
             * - if `[ngPluralCase]` is set to a value starting with `=`, it will only display if the value
             *   matches the switch expression exactly,
             * - otherwise, the view will be treated as a "category match", and will only display if exact
             *   value matches aren't found and the value maps to its category for the defined locale.
             *
             * See http://cldr.unicode.org/index/cldr-spec/plural-rules
             *
             * \@publicApi
             */
            var NgPlural = /** @class */ (function () {
                /**
                 * @param {?} _localization
                 */
                function NgPlural(_localization) {
                    this._localization = _localization;
                    this._caseViews = {};
                }
                Object.defineProperty(NgPlural.prototype, "ngPlural", {
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._switchValue = value;
                        this._updateView();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} value
                 * @param {?} switchView
                 * @return {?}
                 */
                NgPlural.prototype.addCase = function (value, switchView) { this._caseViews[value] = switchView; };
                /**
                 * @private
                 * @return {?}
                 */
                NgPlural.prototype._updateView = function () {
                    this._clearViews();
                    /** @type {?} */
                    var cases = Object.keys(this._caseViews);
                    /** @type {?} */
                    var key = getPluralCategory(this._switchValue, cases, this._localization);
                    this._activateView(this._caseViews[key]);
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgPlural.prototype._clearViews = function () {
                    if (this._activeView)
                        this._activeView.destroy();
                };
                /**
                 * @private
                 * @param {?} view
                 * @return {?}
                 */
                NgPlural.prototype._activateView = function (view) {
                    if (view) {
                        this._activeView = view;
                        this._activeView.create();
                    }
                };
                return NgPlural;
            }());
            NgPlural.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngPlural]' },] }
            ];
            /** @nocollapse */
            NgPlural.ctorParameters = function () { return [
                { type: NgLocalization }
            ]; };
            NgPlural.propDecorators = {
                ngPlural: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@description
             *
             * Creates a view that will be added/removed from the parent {\@link NgPlural} when the
             * given expression matches the plural expression according to CLDR rules.
             *
             * \@usageNotes
             * ```
             * <some-element [ngPlural]="value">
             *   <ng-template ngPluralCase="=0">...</ng-template>
             *   <ng-template ngPluralCase="other">...</ng-template>
             * </some-element>
             * ```
             *
             * See {\@link NgPlural} for more details and example.
             *
             * \@publicApi
             */
            var NgPluralCase = /** @class */ (function () {
                /**
                 * @param {?} value
                 * @param {?} template
                 * @param {?} viewContainer
                 * @param {?} ngPlural
                 */
                function NgPluralCase(value, template, viewContainer, ngPlural) {
                    this.value = value;
                    /** @type {?} */
                    var isANumber = !isNaN(Number(value));
                    ngPlural.addCase(isANumber ? "=" + value : value, new SwitchView(viewContainer, template));
                }
                return NgPluralCase;
            }());
            NgPluralCase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngPluralCase]' },] }
            ];
            /** @nocollapse */
            NgPluralCase.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['ngPluralCase',] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: NgPlural, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used as a token for an injected service within the NgStyle directive.
             *
             * NgStyle behaves differenly whether or not VE is being used or not. If
             * present then the legacy ngClass diffing algorithm will be used as an
             * injected service. Otherwise the new diffing algorithm (which delegates
             * to the `[style]` binding) will be used. This toggle behavior is done so
             * via the ivy_switch mechanism.
             * @abstract
             */
            var NgStyleImpl = /** @class */ (function () {
                function NgStyleImpl() {
                }
                return NgStyleImpl;
            }());
            if (false) { }
            var NgStyleR2Impl = /** @class */ (function () {
                /**
                 * @param {?} _ngEl
                 * @param {?} _differs
                 * @param {?} _renderer
                 */
                function NgStyleR2Impl(_ngEl, _differs, _renderer) {
                    this._ngEl = _ngEl;
                    this._differs = _differs;
                    this._renderer = _renderer;
                }
                /**
                 * @return {?}
                 */
                NgStyleR2Impl.prototype.getValue = function () { return null; };
                /**
                 * A map of style properties, specified as colon-separated
                 * key-value pairs.
                 * * The key is a style name, with an optional `.<unit>` suffix
                 *    (such as 'top.px', 'font-style.em').
                 * * The value is an expression to be evaluated.
                 * @param {?} values
                 * @return {?}
                 */
                NgStyleR2Impl.prototype.setNgStyle = function (values) {
                    this._ngStyle = values;
                    if (!this._differ && values) {
                        this._differ = this._differs.find(values).create();
                    }
                };
                /**
                 * Applies the new styles if needed.
                 * @return {?}
                 */
                NgStyleR2Impl.prototype.applyChanges = function () {
                    if (this._differ) {
                        /** @type {?} */
                        var changes = this._differ.diff(this._ngStyle);
                        if (changes) {
                            this._applyChanges(changes);
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                NgStyleR2Impl.prototype._applyChanges = function (changes) {
                    var _this = this;
                    changes.forEachRemovedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) { return _this._setStyle(record.key, null); }));
                    changes.forEachAddedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) { return _this._setStyle(record.key, record.currentValue); }));
                    changes.forEachChangedItem(( /**
                     * @param {?} record
                     * @return {?}
                     */function (record) { return _this._setStyle(record.key, record.currentValue); }));
                };
                /**
                 * @private
                 * @param {?} nameAndUnit
                 * @param {?} value
                 * @return {?}
                 */
                NgStyleR2Impl.prototype._setStyle = function (nameAndUnit, value) {
                    var _c = nameAndUnit.split('.'), name = _c[0], unit = _c[1];
                    value = value != null && unit ? "" + value + unit : value;
                    if (value != null) {
                        this._renderer.setStyle(this._ngEl.nativeElement, name, ( /** @type {?} */(value)));
                    }
                    else {
                        this._renderer.removeStyle(this._ngEl.nativeElement, name);
                    }
                };
                return NgStyleR2Impl;
            }());
            NgStyleR2Impl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            NgStyleR2Impl.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["KeyValueDiffers"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] }
            ]; };
            if (false) { }
            var NgStyleR3Impl = /** @class */ (function () {
                function NgStyleR3Impl() {
                    this._differ = new StylingDiffer('NgStyle', 8 /* AllowUnits */);
                    this._value = null;
                }
                /**
                 * @return {?}
                 */
                NgStyleR3Impl.prototype.getValue = function () { return this._value; };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NgStyleR3Impl.prototype.setNgStyle = function (value) { this._differ.setValue(value); };
                /**
                 * @return {?}
                 */
                NgStyleR3Impl.prototype.applyChanges = function () {
                    if (this._differ.hasValueChanged()) {
                        this._value = this._differ.value;
                    }
                };
                return NgStyleR3Impl;
            }());
            NgStyleR3Impl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            if (false) { }
            // the implementation for both NgClassR2Impl and NgClassR3Impl are
            // not ivy_switch'd away, instead they are only hooked up into the
            // DI via NgStyle's directive's provider property.
            /** @type {?} */
            var NgStyleImplProvider__PRE_R3__ = {
                provide: NgStyleImpl,
                useClass: NgStyleR2Impl
            };
            /** @type {?} */
            var NgStyleImplProvider__POST_R3__ = {
                provide: NgStyleImpl,
                useClass: NgStyleR3Impl
            };
            /** @type {?} */
            var NgStyleImplProvider = NgStyleImplProvider__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /*
             * NgStyle (as well as NgClass) behaves differently when loaded in the VE and when not.
             *
             * If the VE is present (which is for older versions of Angular) then NgStyle will inject
             * the legacy diffing algorithm as a service and delegate all styling changes to that.
             *
             * If the VE is not present then NgStyle will normalize (through the injected service) and
             * then write all styling changes to the `[style]` binding directly (through a host binding).
             * Then Angular will notice the host binding change and treat the changes as styling
             * changes and apply them via the core styling instructions that exist within Angular.
             */
            // used when the VE is present
            /** @type {?} */
            var ngStyleDirectiveDef__PRE_R3__ = undefined;
            // used when the VE is not present (note the directive will
            // never be instantiated normally because it is apart of a
            // base class)
            var ɵ0$1 = /**
             * @return {?}
             */ function () { }, ɵ1$1 = /**
             * @return {?}
             */ function () { }, ɵ2$1 = /**
             * @param {?} rf
             * @param {?} ctx
             * @param {?} elIndex
             * @return {?}
             */ function (rf, ctx, elIndex) {
                if (rf & 1 /* Create */) {
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵstyling"])();
                }
                if (rf & 2 /* Update */) {
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵstyleMap"])(ctx.getValue());
                    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵstylingApply"])();
                }
            };
            /** @type {?} */
            var ngStyleDirectiveDef__POST_R3__ = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineDirective"])({
                type: ( /** @type {?} */((ɵ0$1))),
                selectors: ( /** @type {?} */(null)),
                factory: (ɵ1$1),
                hostBindings: (ɵ2$1)
            });
            /** @type {?} */
            var ngStyleDirectiveDef = ngStyleDirectiveDef__PRE_R3__;
            /**
             * Serves as the base non-VE container for NgStyle.
             *
             * While this is a base class that NgStyle extends from, the
             * class itself acts as a container for non-VE code to setup
             * a link to the `[style]` host binding (via the static
             * `ngDirectiveDef` property on the class).
             *
             * Note that the `ngDirectiveDef` property's code is switched
             * depending if VE is present or not (this allows for the
             * binding code to be set only for newer versions of Angular).
             *
             * \@publicApi
             */
            var NgStyleBase = /** @class */ (function () {
                /**
                 * @param {?} _delegate
                 */
                function NgStyleBase(_delegate) {
                    this._delegate = _delegate;
                }
                /**
                 * @return {?}
                 */
                NgStyleBase.prototype.getValue = function () { return this._delegate.getValue(); };
                return NgStyleBase;
            }());
            /** @nocollapse */ NgStyleBase.ngDirectiveDef = ngStyleDirectiveDef;
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@usageNotes
             *
             * Set the font of the containing element to the result of an expression.
             *
             * ```
             * <some-element [ngStyle]="{'font-style': styleExp}">...</some-element>
             * ```
             *
             * Set the width of the containing element to a pixel value returned by an expression.
             *
             * ```
             * <some-element [ngStyle]="{'max-width.px': widthExp}">...</some-element>
             * ```
             *
             * Set a collection of style values using an expression that returns key-value pairs.
             *
             * ```
             * <some-element [ngStyle]="objExp">...</some-element>
             * ```
             *
             * \@description
             *
             * An attribute directive that updates styles for the containing HTML element.
             * Sets one or more style properties, specified as colon-separated key-value pairs.
             * The key is a style name, with an optional `.<unit>` suffix
             * (such as 'top.px', 'font-style.em').
             * The value is an expression to be evaluated.
             * The resulting non-null value, expressed in the given unit,
             * is assigned to the given style property.
             * If the result of evaluation is null, the corresponding style is removed.
             *
             * \@publicApi
             */
            var NgStyle = /** @class */ (function (_super_1) {
                __extends(NgStyle, _super_1);
                /**
                 * @param {?} delegate
                 */
                function NgStyle(delegate) {
                    return _super_1.call(this, delegate) || this;
                }
                Object.defineProperty(NgStyle.prototype, "ngStyle", {
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._delegate.setNgStyle(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                NgStyle.prototype.ngDoCheck = function () { this._delegate.applyChanges(); };
                return NgStyle;
            }(NgStyleBase));
            NgStyle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngStyle]', providers: [NgStyleImplProvider] },] }
            ];
            /** @nocollapse */
            NgStyle.ctorParameters = function () { return [
                { type: NgStyleImpl }
            ]; };
            NgStyle.propDecorators = {
                ngStyle: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngStyle',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             *
             * \@description
             *
             * Inserts an embedded view from a prepared `TemplateRef`.
             *
             * You can attach a context object to the `EmbeddedViewRef` by setting `[ngTemplateOutletContext]`.
             * `[ngTemplateOutletContext]` should be an object, the object's keys will be available for binding
             * by the local template `let` declarations.
             *
             * \@usageNotes
             * ```
             * <ng-container *ngTemplateOutlet="templateRefExp; context: contextExp"></ng-container>
             * ```
             *
             * Using the key `$implicit` in the context object will set its value as default.
             *
             * ### Example
             *
             * {\@example common/ngTemplateOutlet/ts/module.ts region='NgTemplateOutlet'}
             *
             * \@publicApi
             */
            var NgTemplateOutlet = /** @class */ (function () {
                /**
                 * @param {?} _viewContainerRef
                 */
                function NgTemplateOutlet(_viewContainerRef) {
                    this._viewContainerRef = _viewContainerRef;
                    this._viewRef = null;
                    /**
                     * A context object to attach to the {\@link EmbeddedViewRef}. This should be an
                     * object, the object's keys will be available for binding by the local template `let`
                     * declarations.
                     * Using the key `$implicit` in the context object will set its value as default.
                     */
                    this.ngTemplateOutletContext = null;
                    /**
                     * A string defining the template reference and optionally the context object for the template.
                     */
                    this.ngTemplateOutlet = null;
                }
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                NgTemplateOutlet.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var recreateView = this._shouldRecreateView(changes);
                    if (recreateView) {
                        if (this._viewRef) {
                            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
                        }
                        if (this.ngTemplateOutlet) {
                            this._viewRef = this._viewContainerRef.createEmbeddedView(this.ngTemplateOutlet, this.ngTemplateOutletContext);
                        }
                    }
                    else {
                        if (this._viewRef && this.ngTemplateOutletContext) {
                            this._updateExistingContext(this.ngTemplateOutletContext);
                        }
                    }
                };
                /**
                 * We need to re-create existing embedded view if:
                 * - templateRef has changed
                 * - context has changes
                 *
                 * We mark context object as changed when the corresponding object
                 * shape changes (new properties are added or existing properties are removed).
                 * In other words we consider context with the same properties as "the same" even
                 * if object reference changes (see https://github.com/angular/angular/issues/13407).
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                NgTemplateOutlet.prototype._shouldRecreateView = function (changes) {
                    /** @type {?} */
                    var ctxChange = changes['ngTemplateOutletContext'];
                    return !!changes['ngTemplateOutlet'] || (ctxChange && this._hasContextShapeChanged(ctxChange));
                };
                /**
                 * @private
                 * @param {?} ctxChange
                 * @return {?}
                 */
                NgTemplateOutlet.prototype._hasContextShapeChanged = function (ctxChange) {
                    /** @type {?} */
                    var prevCtxKeys = Object.keys(ctxChange.previousValue || {});
                    /** @type {?} */
                    var currCtxKeys = Object.keys(ctxChange.currentValue || {});
                    if (prevCtxKeys.length === currCtxKeys.length) {
                        for (var _c = 0, currCtxKeys_1 = currCtxKeys; _c < currCtxKeys_1.length; _c++) {
                            var propName = currCtxKeys_1[_c];
                            if (prevCtxKeys.indexOf(propName) === -1) {
                                return true;
                            }
                        }
                        return false;
                    }
                    else {
                        return true;
                    }
                };
                /**
                 * @private
                 * @param {?} ctx
                 * @return {?}
                 */
                NgTemplateOutlet.prototype._updateExistingContext = function (ctx) {
                    for (var _c = 0, _d = Object.keys(ctx); _c < _d.length; _c++) {
                        var propName = _d[_c];
                        (( /** @type {?} */(( /** @type {?} */(this._viewRef)).context)))[propName] = (( /** @type {?} */(this.ngTemplateOutletContext)))[propName];
                    }
                };
                return NgTemplateOutlet;
            }());
            NgTemplateOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngTemplateOutlet]' },] }
            ];
            /** @nocollapse */
            NgTemplateOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] }
            ]; };
            NgTemplateOutlet.propDecorators = {
                ngTemplateOutletContext: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ngTemplateOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A collection of Angular directives that are likely to be used in each and every Angular
             * application.
             * @type {?}
             */
            var COMMON_DIRECTIVES = [
                NgClass,
                NgComponentOutlet,
                NgForOf,
                NgIf,
                NgTemplateOutlet,
                NgStyle,
                NgSwitch,
                NgSwitchCase,
                NgSwitchDefault,
                NgPlural,
                NgPluralCase,
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} type
             * @param {?} value
             * @return {?}
             */
            function invalidPipeArgumentError(type, value) {
                return Error("InvalidPipeArgument: '" + value + "' for pipe '" + Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵstringify"])(type) + "'");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NumberFormatter = /** @class */ (function () {
                function NumberFormatter() {
                }
                /**
                 * @param {?} num
                 * @param {?} locale
                 * @param {?} style
                 * @param {?=} opts
                 * @return {?}
                 */
                NumberFormatter.format = function (num, locale, style, opts) {
                    if (opts === void 0) { opts = {}; }
                    var minimumIntegerDigits = opts.minimumIntegerDigits, minimumFractionDigits = opts.minimumFractionDigits, maximumFractionDigits = opts.maximumFractionDigits, currency = opts.currency, _c = opts.currencyAsSymbol, currencyAsSymbol = _c === void 0 ? false : _c;
                    /** @type {?} */
                    var options = {
                        minimumIntegerDigits: minimumIntegerDigits,
                        minimumFractionDigits: minimumFractionDigits,
                        maximumFractionDigits: maximumFractionDigits,
                        style: NumberFormatStyle[style].toLowerCase()
                    };
                    if (style == NumberFormatStyle.Currency) {
                        options.currency = typeof currency == 'string' ? currency : undefined;
                        options.currencyDisplay = currencyAsSymbol ? 'symbol' : 'code';
                    }
                    return new Intl.NumberFormat(locale, options).format(num);
                };
                return NumberFormatter;
            }());
            /** @type {?} */
            var DATE_FORMATS_SPLIT$1 = /((?:[^yMLdHhmsazZEwGjJ']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|J+|j+|m+|s+|a|z|Z|G+|w+))(.*)/;
            /** @type {?} */
            var PATTERN_ALIASES = {
                // Keys are quoted so they do not get renamed during closure compilation.
                'yMMMdjms': datePartGetterFactory(combine([
                    digitCondition('year', 1),
                    nameCondition('month', 3),
                    digitCondition('day', 1),
                    digitCondition('hour', 1),
                    digitCondition('minute', 1),
                    digitCondition('second', 1),
                ])),
                'yMdjm': datePartGetterFactory(combine([
                    digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1),
                    digitCondition('hour', 1), digitCondition('minute', 1)
                ])),
                'yMMMMEEEEd': datePartGetterFactory(combine([
                    digitCondition('year', 1), nameCondition('month', 4), nameCondition('weekday', 4),
                    digitCondition('day', 1)
                ])),
                'yMMMMd': datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 4), digitCondition('day', 1)])),
                'yMMMd': datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 3), digitCondition('day', 1)])),
                'yMd': datePartGetterFactory(combine([digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1)])),
                'jms': datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('second', 1), digitCondition('minute', 1)])),
                'jm': datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('minute', 1)]))
            };
            /** @type {?} */
            var DATE_FORMATS$1 = {
                // Keys are quoted so they do not get renamed.
                'yyyy': datePartGetterFactory(digitCondition('year', 4)),
                'yy': datePartGetterFactory(digitCondition('year', 2)),
                'y': datePartGetterFactory(digitCondition('year', 1)),
                'MMMM': datePartGetterFactory(nameCondition('month', 4)),
                'MMM': datePartGetterFactory(nameCondition('month', 3)),
                'MM': datePartGetterFactory(digitCondition('month', 2)),
                'M': datePartGetterFactory(digitCondition('month', 1)),
                'LLLL': datePartGetterFactory(nameCondition('month', 4)),
                'L': datePartGetterFactory(nameCondition('month', 1)),
                'dd': datePartGetterFactory(digitCondition('day', 2)),
                'd': datePartGetterFactory(digitCondition('day', 1)),
                'HH': digitModifier(hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), false)))),
                'H': hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), false))),
                'hh': digitModifier(hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), true)))),
                'h': hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
                'jj': datePartGetterFactory(digitCondition('hour', 2)),
                'j': datePartGetterFactory(digitCondition('hour', 1)),
                'mm': digitModifier(datePartGetterFactory(digitCondition('minute', 2))),
                'm': datePartGetterFactory(digitCondition('minute', 1)),
                'ss': digitModifier(datePartGetterFactory(digitCondition('second', 2))),
                's': datePartGetterFactory(digitCondition('second', 1)),
                // while ISO 8601 requires fractions to be prefixed with `.` or `,`
                // we can be just safely rely on using `sss` since we currently don't support single or two digit
                // fractions
                'sss': datePartGetterFactory(digitCondition('second', 3)),
                'EEEE': datePartGetterFactory(nameCondition('weekday', 4)),
                'EEE': datePartGetterFactory(nameCondition('weekday', 3)),
                'EE': datePartGetterFactory(nameCondition('weekday', 2)),
                'E': datePartGetterFactory(nameCondition('weekday', 1)),
                'a': hourClockExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
                'Z': timeZoneGetter$1('short'),
                'z': timeZoneGetter$1('long'),
                'ww': datePartGetterFactory({}),
                // Week of year, padded (00-53). Week 01 is the week with the
                // first Thursday of the year. not support ?
                'w': datePartGetterFactory({}),
                // Week of year (0-53). Week 1 is the week with the first Thursday
                // of the year not support ?
                'G': datePartGetterFactory(nameCondition('era', 1)),
                'GG': datePartGetterFactory(nameCondition('era', 2)),
                'GGG': datePartGetterFactory(nameCondition('era', 3)),
                'GGGG': datePartGetterFactory(nameCondition('era', 4))
            };
            /**
             * @param {?} inner
             * @return {?}
             */
            function digitModifier(inner) {
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) {
                    /** @type {?} */
                    var result = inner(date, locale);
                    return result.length == 1 ? '0' + result : result;
                });
            }
            /**
             * @param {?} inner
             * @return {?}
             */
            function hourClockExtractor(inner) {
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) { return inner(date, locale).split(' ')[1]; });
            }
            /**
             * @param {?} inner
             * @return {?}
             */
            function hourExtractor(inner) {
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) { return inner(date, locale).split(' ')[0]; });
            }
            /**
             * @param {?} date
             * @param {?} locale
             * @param {?} options
             * @return {?}
             */
            function intlDateFormat(date, locale, options) {
                return new Intl.DateTimeFormat(locale, options).format(date).replace(/[\u200e\u200f]/g, '');
            }
            /**
             * @param {?} timezone
             * @return {?}
             */
            function timeZoneGetter$1(timezone) {
                // To workaround `Intl` API restriction for single timezone let format with 24 hours
                /** @type {?} */
                var options = { hour: '2-digit', hour12: false, timeZoneName: timezone };
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) {
                    /** @type {?} */
                    var result = intlDateFormat(date, locale, options);
                    // Then extract first 3 letters that related to hours
                    return result ? result.substring(3) : '';
                });
            }
            /**
             * @param {?} options
             * @param {?} value
             * @return {?}
             */
            function hour12Modify(options, value) {
                options.hour12 = value;
                return options;
            }
            /**
             * @param {?} prop
             * @param {?} len
             * @return {?}
             */
            function digitCondition(prop, len) {
                /** @type {?} */
                var result = {};
                result[prop] = len === 2 ? '2-digit' : 'numeric';
                return result;
            }
            /**
             * @param {?} prop
             * @param {?} len
             * @return {?}
             */
            function nameCondition(prop, len) {
                /** @type {?} */
                var result = {};
                if (len < 4) {
                    result[prop] = len > 1 ? 'short' : 'narrow';
                }
                else {
                    result[prop] = 'long';
                }
                return result;
            }
            /**
             * @param {?} options
             * @return {?}
             */
            function combine(options) {
                return options.reduce(( /**
                 * @param {?} merged
                 * @param {?} opt
                 * @return {?}
                 */function (merged, opt) { return (Object.assign({}, merged, opt)); }), {});
            }
            /**
             * @param {?} ret
             * @return {?}
             */
            function datePartGetterFactory(ret) {
                return ( /**
                 * @param {?} date
                 * @param {?} locale
                 * @return {?}
                 */function (date, locale) { return intlDateFormat(date, locale, ret); });
            }
            /** @type {?} */
            var DATE_FORMATTER_CACHE = new Map();
            /**
             * @param {?} format
             * @param {?} date
             * @param {?} locale
             * @return {?}
             */
            function dateFormatter(format, date, locale) {
                /** @type {?} */
                var fn = PATTERN_ALIASES[format];
                if (fn)
                    return fn(date, locale);
                /** @type {?} */
                var cacheKey = format;
                /** @type {?} */
                var parts = DATE_FORMATTER_CACHE.get(cacheKey);
                if (!parts) {
                    parts = [];
                    /** @type {?} */
                    var match = void 0;
                    DATE_FORMATS_SPLIT$1.exec(format);
                    /** @type {?} */
                    var _format = format;
                    while (_format) {
                        match = DATE_FORMATS_SPLIT$1.exec(_format);
                        if (match) {
                            parts = parts.concat(match.slice(1));
                            _format = ( /** @type {?} */(parts.pop()));
                        }
                        else {
                            parts.push(_format);
                            _format = null;
                        }
                    }
                    DATE_FORMATTER_CACHE.set(cacheKey, parts);
                }
                return parts.reduce(( /**
                 * @param {?} text
                 * @param {?} part
                 * @return {?}
                 */function (text, part) {
                    /** @type {?} */
                    var fn = DATE_FORMATS$1[part];
                    return text + (fn ? fn(date, locale) : partToTime(part));
                }), '');
            }
            /**
             * @param {?} part
             * @return {?}
             */
            function partToTime(part) {
                return part === '\'\'' ? '\'' : part.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
            }
            var DateFormatter = /** @class */ (function () {
                function DateFormatter() {
                }
                /**
                 * @param {?} date
                 * @param {?} locale
                 * @param {?} pattern
                 * @return {?}
                 */
                DateFormatter.format = function (date, locale, pattern) {
                    return dateFormatter(pattern, date, locale);
                };
                return DateFormatter;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a date according to locale rules.
             *
             * Where:
             * - `expression` is a date object or a number (milliseconds since UTC epoch) or an ISO string
             * (https://www.w3.org/TR/NOTE-datetime).
             * - `format` indicates which date/time components to include. The format can be predefined as
             *   shown below or custom as shown in the table.
             *   - `'medium'`: equivalent to `'yMMMdjms'` (e.g. `Sep 3, 2010, 12:05:08 PM` for `en-US`)
             *   - `'short'`: equivalent to `'yMdjm'` (e.g. `9/3/2010, 12:05 PM` for `en-US`)
             *   - `'fullDate'`: equivalent to `'yMMMMEEEEd'` (e.g. `Friday, September 3, 2010` for `en-US`)
             *   - `'longDate'`: equivalent to `'yMMMMd'` (e.g. `September 3, 2010` for `en-US`)
             *   - `'mediumDate'`: equivalent to `'yMMMd'` (e.g. `Sep 3, 2010` for `en-US`)
             *   - `'shortDate'`: equivalent to `'yMd'` (e.g. `9/3/2010` for `en-US`)
             *   - `'mediumTime'`: equivalent to `'jms'` (e.g. `12:05:08 PM` for `en-US`)
             *   - `'shortTime'`: equivalent to `'jm'` (e.g. `12:05 PM` for `en-US`)
             *
             *
             *  | Component | Symbol | Narrow | Short Form   | Long Form         | Numeric   | 2-digit   |
             *  |-----------|:------:|--------|--------------|-------------------|-----------|-----------|
             *  | era       |   G    | G (A)  | GGG (AD)     | GGGG (Anno Domini)| -         | -         |
             *  | year      |   y    | -      | -            | -                 | y (2015)  | yy (15)   |
             *  | month     |   M    | L (S)  | MMM (Sep)    | MMMM (September)  | M (9)     | MM (09)   |
             *  | day       |   d    | -      | -            | -                 | d (3)     | dd (03)   |
             *  | weekday   |   E    | E (S)  | EEE (Sun)    | EEEE (Sunday)     | -         | -         |
             *  | hour      |   j    | -      | -            | -                 | j (13)    | jj (13)   |
             *  | hour12    |   h    | -      | -            | -                 | h (1 PM)  | hh (01 PM)|
             *  | hour24    |   H    | -      | -            | -                 | H (13)    | HH (13)   |
             *  | minute    |   m    | -      | -            | -                 | m (5)     | mm (05)   |
             *  | second    |   s    | -      | -            | -                 | s (9)     | ss (09)   |
             *  | timezone  |   z    | -      | -            | z (Pacific Standard Time)| -  | -         |
             *  | timezone  |   Z    | -      | Z (GMT-8:00) | -                 | -         | -         |
             *  | timezone  |   a    | -      | a (PM)       | -                 | -         | -         |
             *
             * In javascript, only the components specified will be respected (not the ordering,
             * punctuations, ...) and details of the formatting will be dependent on the locale.
             *
             * Timezone of the formatted text will be the local system timezone of the end-user's machine.
             *
             * When the expression is a ISO string without time (e.g. 2016-09-19) the time zone offset is not
             * applied and the formatted text will have the same day, month and year of the expression.
             *
             * WARNINGS:
             * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
             *   Instead users should treat the date as an immutable object and change the reference when the
             *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
             *   which would be an expensive operation).
             * - this pipe uses the Internationalization API. Therefore it is only reliable in Chrome and Opera
             *   browsers.
             *
             * \@usageNotes
             *
             * ### Examples
             *
             * Assuming `dateObj` is (year: 2010, month: 9, day: 3, hour: 12 PM, minute: 05, second: 08)
             * in the _local_ time and locale is 'en-US':
             *
             * {\@example common/pipes/ts/date_pipe.ts region='DeprecatedDatePipe'}
             *
             * \@publicApi
             */
            var DeprecatedDatePipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function DeprecatedDatePipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 * @param {?} value
                 * @param {?=} pattern
                 * @return {?}
                 */
                DeprecatedDatePipe.prototype.transform = function (value, pattern) {
                    if (pattern === void 0) { pattern = 'mediumDate'; }
                    if (value == null || value === '' || value !== value)
                        return null;
                    /** @type {?} */
                    var date;
                    if (typeof value === 'string') {
                        value = value.trim();
                    }
                    if (isDate$1(value)) {
                        date = value;
                    }
                    else if (!isNaN(value - parseFloat(value))) {
                        date = new Date(parseFloat(value));
                    }
                    else if (typeof value === 'string' && /^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
                        /**
                         * For ISO Strings without time the day, month and year must be extracted from the ISO String
                         * before Date creation to avoid time offset and errors in the new Date.
                         * If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
                         * date, some browsers (e.g. IE 9) will throw an invalid Date error
                         * If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the
                         * timeoffset
                         * is applied
                         * Note: ISO months are 0 for January, 1 for February, ...
                         */
                        var _c = value.split('-').map(( /**
                         * @param {?} val
                         * @return {?}
                         */function (val) { return parseInt(val, 10); })), y = _c[0], m = _c[1], d = _c[2];
                        date = new Date(y, m - 1, d);
                    }
                    else {
                        date = new Date(value);
                    }
                    if (!isDate$1(date)) {
                        /** @type {?} */
                        var match = void 0;
                        if ((typeof value === 'string') && (match = value.match(ISO8601_DATE_REGEX))) {
                            date = isoStringToDate(match);
                        }
                        else {
                            throw invalidPipeArgumentError(DeprecatedDatePipe, value);
                        }
                    }
                    return DateFormatter.format(date, this._locale, DeprecatedDatePipe._ALIASES[pattern] || pattern);
                };
                return DeprecatedDatePipe;
            }());
            /**
             * \@internal
             */
            DeprecatedDatePipe._ALIASES = {
                'medium': 'yMMMdjms',
                'short': 'yMdjm',
                'fullDate': 'yMMMMEEEEd',
                'longDate': 'yMMMMd',
                'mediumDate': 'yMMMd',
                'shortDate': 'yMd',
                'mediumTime': 'jms',
                'shortTime': 'jm'
            };
            DeprecatedDatePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'date', pure: true },] }
            ];
            /** @nocollapse */
            DeprecatedDatePipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * @param {?} value
             * @return {?}
             */
            function isDate$1(value) {
                return value instanceof Date && !isNaN(value.valueOf());
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} pipe
             * @param {?} locale
             * @param {?} value
             * @param {?} style
             * @param {?=} digits
             * @param {?=} currency
             * @param {?=} currencyAsSymbol
             * @return {?}
             */
            function formatNumber$1(pipe, locale, value, style, digits, currency, currencyAsSymbol) {
                if (currency === void 0) { currency = null; }
                if (currencyAsSymbol === void 0) { currencyAsSymbol = false; }
                if (value == null)
                    return null;
                // Convert strings to numbers
                value = typeof value === 'string' && !isNaN(+value - parseFloat(value)) ? +value : value;
                if (typeof value !== 'number') {
                    throw invalidPipeArgumentError(pipe, value);
                }
                /** @type {?} */
                var minInt;
                /** @type {?} */
                var minFraction;
                /** @type {?} */
                var maxFraction;
                if (style !== NumberFormatStyle.Currency) {
                    // rely on Intl default for currency
                    minInt = 1;
                    minFraction = 0;
                    maxFraction = 3;
                }
                if (digits) {
                    /** @type {?} */
                    var parts = digits.match(NUMBER_FORMAT_REGEXP);
                    if (parts === null) {
                        throw new Error(digits + " is not a valid digit info for number pipes");
                    }
                    if (parts[1] != null) { // min integer digits
                        minInt = parseIntAutoRadix(parts[1]);
                    }
                    if (parts[3] != null) { // min fraction digits
                        minFraction = parseIntAutoRadix(parts[3]);
                    }
                    if (parts[5] != null) { // max fraction digits
                        maxFraction = parseIntAutoRadix(parts[5]);
                    }
                }
                return NumberFormatter.format(( /** @type {?} */(value)), locale, style, {
                    minimumIntegerDigits: minInt,
                    minimumFractionDigits: minFraction,
                    maximumFractionDigits: maxFraction,
                    currency: currency,
                    currencyAsSymbol: currencyAsSymbol,
                });
            }
            /**
             * Formats a number as text. Group sizing and separator and other locale-specific
             * configurations are based on the active locale.
             *
             * where `expression` is a number:
             *  - `digitInfo` is a `string` which has a following format: <br>
             *     <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
             *   - `minIntegerDigits` is the minimum number of integer digits to use. Defaults to `1`.
             *   - `minFractionDigits` is the minimum number of digits after fraction. Defaults to `0`.
             *   - `maxFractionDigits` is the maximum number of digits after fraction. Defaults to `3`.
             *
             * For more information on the acceptable range for each of these numbers and other
             * details see your native internationalization library.
             *
             * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
             * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/pipes/ts/number_pipe.ts region='DeprecatedNumberPipe'}
             *
             * \@ngModule CommonModule
             * \@publicApi
             */
            var DeprecatedDecimalPipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function DeprecatedDecimalPipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 * @param {?} value
                 * @param {?=} digits
                 * @return {?}
                 */
                DeprecatedDecimalPipe.prototype.transform = function (value, digits) {
                    return formatNumber$1(DeprecatedDecimalPipe, this._locale, value, NumberFormatStyle.Decimal, digits);
                };
                return DeprecatedDecimalPipe;
            }());
            DeprecatedDecimalPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'number' },] }
            ];
            /** @nocollapse */
            DeprecatedDecimalPipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * \@ngModule CommonModule
             *
             * \@description
             *
             * Formats a number as percentage according to locale rules.
             *
             * - `digitInfo` See {\@link DecimalPipe} for detailed description.
             *
             * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
             * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/pipes/ts/percent_pipe.ts region='DeprecatedPercentPipe'}
             *
             * \@publicApi
             */
            var DeprecatedPercentPipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function DeprecatedPercentPipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 * @param {?} value
                 * @param {?=} digits
                 * @return {?}
                 */
                DeprecatedPercentPipe.prototype.transform = function (value, digits) {
                    return formatNumber$1(DeprecatedPercentPipe, this._locale, value, NumberFormatStyle.Percent, digits);
                };
                return DeprecatedPercentPipe;
            }());
            DeprecatedPercentPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'percent' },] }
            ];
            /** @nocollapse */
            DeprecatedPercentPipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a number as currency using locale rules.
             *
             * Use `currency` to format a number as currency.
             *
             * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
             *    as `USD` for the US dollar and `EUR` for the euro.
             * - `symbolDisplay` is a boolean indicating whether to use the currency symbol or code.
             *   - `true`: use symbol (e.g. `$`).
             *   - `false`(default): use code (e.g. `USD`).
             * - `digitInfo` See {\@link DecimalPipe} for detailed description.
             *
             * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
             * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/pipes/ts/currency_pipe.ts region='DeprecatedCurrencyPipe'}
             *
             * \@publicApi
             */
            var DeprecatedCurrencyPipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function DeprecatedCurrencyPipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 * @param {?} value
                 * @param {?=} currencyCode
                 * @param {?=} symbolDisplay
                 * @param {?=} digits
                 * @return {?}
                 */
                DeprecatedCurrencyPipe.prototype.transform = function (value, currencyCode, symbolDisplay, digits) {
                    if (currencyCode === void 0) { currencyCode = 'USD'; }
                    if (symbolDisplay === void 0) { symbolDisplay = false; }
                    return formatNumber$1(DeprecatedCurrencyPipe, this._locale, value, NumberFormatStyle.Currency, digits, currencyCode, symbolDisplay);
                };
                return DeprecatedCurrencyPipe;
            }());
            DeprecatedCurrencyPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'currency' },] }
            ];
            /** @nocollapse */
            DeprecatedCurrencyPipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A collection of deprecated i18n pipes that require intl api
             *
             * @deprecated from v5
             * @type {?}
             */
            var COMMON_DEPRECATED_I18N_PIPES = [DeprecatedDecimalPipe, DeprecatedPercentPipe, DeprecatedCurrencyPipe, DeprecatedDatePipe];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function SubscriptionStrategy() { }
            if (false) { }
            var ObservableStrategy = /** @class */ (function () {
                function ObservableStrategy() {
                }
                /**
                 * @param {?} async
                 * @param {?} updateLatestValue
                 * @return {?}
                 */
                ObservableStrategy.prototype.createSubscription = function (async, updateLatestValue) {
                    return async.subscribe({ next: updateLatestValue, error: ( /**
                             * @param {?} e
                             * @return {?}
                             */function (e) { throw e; }) });
                };
                /**
                 * @param {?} subscription
                 * @return {?}
                 */
                ObservableStrategy.prototype.dispose = function (subscription) { subscription.unsubscribe(); };
                /**
                 * @param {?} subscription
                 * @return {?}
                 */
                ObservableStrategy.prototype.onDestroy = function (subscription) { subscription.unsubscribe(); };
                return ObservableStrategy;
            }());
            var PromiseStrategy = /** @class */ (function () {
                function PromiseStrategy() {
                }
                /**
                 * @param {?} async
                 * @param {?} updateLatestValue
                 * @return {?}
                 */
                PromiseStrategy.prototype.createSubscription = function (async, updateLatestValue) {
                    return async.then(updateLatestValue, ( /**
                     * @param {?} e
                     * @return {?}
                     */function (/**
                     * @param {?} e
                     * @return {?}
                     */ e) { throw e; }));
                };
                /**
                 * @param {?} subscription
                 * @return {?}
                 */
                PromiseStrategy.prototype.dispose = function (subscription) { };
                /**
                 * @param {?} subscription
                 * @return {?}
                 */
                PromiseStrategy.prototype.onDestroy = function (subscription) { };
                return PromiseStrategy;
            }());
            /** @type {?} */
            var _promiseStrategy = new PromiseStrategy();
            /** @type {?} */
            var _observableStrategy = new ObservableStrategy();
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Unwraps a value from an asynchronous primitive.
             *
             * The `async` pipe subscribes to an `Observable` or `Promise` and returns the latest value it has
             * emitted. When a new value is emitted, the `async` pipe marks the component to be checked for
             * changes. When the component gets destroyed, the `async` pipe unsubscribes automatically to avoid
             * potential memory leaks.
             *
             * \@usageNotes
             *
             * ### Examples
             *
             * This example binds a `Promise` to the view. Clicking the `Resolve` button resolves the
             * promise.
             *
             * {\@example common/pipes/ts/async_pipe.ts region='AsyncPipePromise'}
             *
             * It's also possible to use `async` with Observables. The example below binds the `time` Observable
             * to the view. The Observable continuously updates the view with the current time.
             *
             * {\@example common/pipes/ts/async_pipe.ts region='AsyncPipeObservable'}
             *
             * \@publicApi
             */
            var AsyncPipe = /** @class */ (function () {
                /**
                 * @param {?} _ref
                 */
                function AsyncPipe(_ref) {
                    this._ref = _ref;
                    this._latestValue = null;
                    this._latestReturnedValue = null;
                    this._subscription = null;
                    this._obj = null;
                    this._strategy = ( /** @type {?} */(null));
                }
                /**
                 * @return {?}
                 */
                AsyncPipe.prototype.ngOnDestroy = function () {
                    if (this._subscription) {
                        this._dispose();
                    }
                };
                /**
                 * @param {?} obj
                 * @return {?}
                 */
                AsyncPipe.prototype.transform = function (obj) {
                    if (!this._obj) {
                        if (obj) {
                            this._subscribe(obj);
                        }
                        this._latestReturnedValue = this._latestValue;
                        return this._latestValue;
                    }
                    if (obj !== this._obj) {
                        this._dispose();
                        return this.transform(( /** @type {?} */(obj)));
                    }
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵlooseIdentical"])(this._latestValue, this._latestReturnedValue)) {
                        return this._latestReturnedValue;
                    }
                    this._latestReturnedValue = this._latestValue;
                    return _angular_core__WEBPACK_IMPORTED_MODULE_0__["WrappedValue"].wrap(this._latestValue);
                };
                /**
                 * @private
                 * @param {?} obj
                 * @return {?}
                 */
                AsyncPipe.prototype._subscribe = function (obj) {
                    var _this = this;
                    this._obj = obj;
                    this._strategy = this._selectStrategy(obj);
                    this._subscription = this._strategy.createSubscription(obj, ( /**
                     * @param {?} value
                     * @return {?}
                     */function (value) { return _this._updateLatestValue(obj, value); }));
                };
                /**
                 * @private
                 * @param {?} obj
                 * @return {?}
                 */
                AsyncPipe.prototype._selectStrategy = function (obj) {
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵisPromise"])(obj)) {
                        return _promiseStrategy;
                    }
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵisObservable"])(obj)) {
                        return _observableStrategy;
                    }
                    throw invalidPipeArgumentError(AsyncPipe, obj);
                };
                /**
                 * @private
                 * @return {?}
                 */
                AsyncPipe.prototype._dispose = function () {
                    this._strategy.dispose(( /** @type {?} */(this._subscription)));
                    this._latestValue = null;
                    this._latestReturnedValue = null;
                    this._subscription = null;
                    this._obj = null;
                };
                /**
                 * @private
                 * @param {?} async
                 * @param {?} value
                 * @return {?}
                 */
                AsyncPipe.prototype._updateLatestValue = function (async, value) {
                    if (async === this._obj) {
                        this._latestValue = value;
                        this._ref.markForCheck();
                    }
                };
                return AsyncPipe;
            }());
            AsyncPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'async', pure: false },] }
            ];
            /** @nocollapse */
            AsyncPipe.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Transforms text to all lower case.
             *
             * @see `UpperCasePipe`
             * @see `TitleCasePipe`
             * \@usageNotes
             *
             * The following example defines a view that allows the user to enter
             * text, and then uses the pipe to convert the input text to all lower case.
             *
             * <code-example path="common/pipes/ts/lowerupper_pipe.ts" region='LowerUpperPipe'></code-example>
             *
             * \@ngModule CommonModule
             * \@publicApi
             */
            var LowerCasePipe = /** @class */ (function () {
                function LowerCasePipe() {
                }
                /**
                 * @param {?} value The string to transform to lower case.
                 * @return {?}
                 */
                LowerCasePipe.prototype.transform = function (value) {
                    if (!value)
                        return value;
                    if (typeof value !== 'string') {
                        throw invalidPipeArgumentError(LowerCasePipe, value);
                    }
                    return value.toLowerCase();
                };
                return LowerCasePipe;
            }());
            LowerCasePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'lowercase' },] }
            ];
            //
            // Regex below matches any Unicode word and compatible with ES5. In ES2018 the same result
            // can be achieved by using /\p{L}\S*/gu and also known as Unicode Property Escapes
            // (http://2ality.com/2017/07/regexp-unicode-property-escapes.html). Since there is no
            // transpilation of this functionality down to ES5 without external tool, the only solution is
            // to use already transpiled form. Example can be found here -
            // https://mothereff.in/regexpu#input=var+regex+%3D+/%5Cp%7BL%7D/u%3B&unicodePropertyEscape=1
            //
            /** @type {?} */
            var unicodeWordMatch = /(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D])\S*/g;
            /**
             * Transforms text to title case.
             * Capitalizes the first letter of each word, and transforms the
             * rest of the word to lower case.
             * Words are delimited by any whitespace character, such as a space, tab, or line-feed character.
             *
             * @see `LowerCasePipe`
             * @see `UpperCasePipe`
             *
             * \@usageNotes
             * The following example shows the result of transforming various strings into title case.
             *
             * <code-example path="common/pipes/ts/titlecase_pipe.ts" region='TitleCasePipe'></code-example>
             *
             * \@ngModule CommonModule
             * \@publicApi
             */
            var TitleCasePipe = /** @class */ (function () {
                function TitleCasePipe() {
                }
                /**
                 * @param {?} value The string to transform to title case.
                 * @return {?}
                 */
                TitleCasePipe.prototype.transform = function (value) {
                    if (!value)
                        return value;
                    if (typeof value !== 'string') {
                        throw invalidPipeArgumentError(TitleCasePipe, value);
                    }
                    return value.replace(unicodeWordMatch, (( /**
                     * @param {?} txt
                     * @return {?}
                     */function (/**
                     * @param {?} txt
                     * @return {?}
                     */ txt) { return txt[0].toUpperCase() + txt.substr(1).toLowerCase(); })));
                };
                return TitleCasePipe;
            }());
            TitleCasePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'titlecase' },] }
            ];
            /**
             * Transforms text to all upper case.
             * @see `LowerCasePipe`
             * @see `TitleCasePipe`
             *
             * \@ngModule CommonModule
             * \@publicApi
             */
            var UpperCasePipe = /** @class */ (function () {
                function UpperCasePipe() {
                }
                /**
                 * @param {?} value The string to transform to upper case.
                 * @return {?}
                 */
                UpperCasePipe.prototype.transform = function (value) {
                    if (!value)
                        return value;
                    if (typeof value !== 'string') {
                        throw invalidPipeArgumentError(UpperCasePipe, value);
                    }
                    return value.toUpperCase();
                };
                return UpperCasePipe;
            }());
            UpperCasePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'uppercase' },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // clang-format off
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Formats a date value according to locale rules.
             *
             * Only the `en-US` locale data comes with Angular. To localize dates
             * in another language, you must import the corresponding locale data.
             * See the [I18n guide](guide/i18n#i18n-pipes) for more information.
             *
             * @see `formatDate()`
             *
             *
             * \@usageNotes
             *
             * The result of this pipe is not reevaluated when the input is mutated. To avoid the need to
             * reformat the date on every change-detection cycle, treat the date as an immutable object
             * and change the reference when the pipe needs to run again.
             *
             * ### Pre-defined format options
             *
             * Examples are given in `en-US` locale.
             *
             * - `'short'`: equivalent to `'M/d/yy, h:mm a'` (`6/15/15, 9:03 AM`).
             * - `'medium'`: equivalent to `'MMM d, y, h:mm:ss a'` (`Jun 15, 2015, 9:03:01 AM`).
             * - `'long'`: equivalent to `'MMMM d, y, h:mm:ss a z'` (`June 15, 2015 at 9:03:01 AM
             * GMT+1`).
             * - `'full'`: equivalent to `'EEEE, MMMM d, y, h:mm:ss a zzzz'` (`Monday, June 15, 2015 at
             * 9:03:01 AM GMT+01:00`).
             * - `'shortDate'`: equivalent to `'M/d/yy'` (`6/15/15`).
             * - `'mediumDate'`: equivalent to `'MMM d, y'` (`Jun 15, 2015`).
             * - `'longDate'`: equivalent to `'MMMM d, y'` (`June 15, 2015`).
             * - `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` (`Monday, June 15, 2015`).
             * - `'shortTime'`: equivalent to `'h:mm a'` (`9:03 AM`).
             * - `'mediumTime'`: equivalent to `'h:mm:ss a'` (`9:03:01 AM`).
             * - `'longTime'`: equivalent to `'h:mm:ss a z'` (`9:03:01 AM GMT+1`).
             * - `'fullTime'`: equivalent to `'h:mm:ss a zzzz'` (`9:03:01 AM GMT+01:00`).
             *
             * ### Custom format options
             *
             * You can construct a format string using symbols to specify the components
             * of a date-time value, as described in the following table.
             * Format details depend on the locale.
             * Fields marked with (*) are only available in the extra data set for the given locale.
             *
             *  | Field type         | Format      | Description                                                   | Example Value                                              |
             *  |--------------------|-------------|---------------------------------------------------------------|------------------------------------------------------------|
             *  | Era                | G, GG & GGG | Abbreviated                                                   | AD                                                         |
             *  |                    | GGGG        | Wide                                                          | Anno Domini                                                |
             *  |                    | GGGGG       | Narrow                                                        | A                                                          |
             *  | Year               | y           | Numeric: minimum digits                                       | 2, 20, 201, 2017, 20173                                    |
             *  |                    | yy          | Numeric: 2 digits + zero padded                               | 02, 20, 01, 17, 73                                         |
             *  |                    | yyy         | Numeric: 3 digits + zero padded                               | 002, 020, 201, 2017, 20173                                 |
             *  |                    | yyyy        | Numeric: 4 digits or more + zero padded                       | 0002, 0020, 0201, 2017, 20173                              |
             *  | Month              | M           | Numeric: 1 digit                                              | 9, 12                                                      |
             *  |                    | MM          | Numeric: 2 digits + zero padded                               | 09, 12                                                     |
             *  |                    | MMM         | Abbreviated                                                   | Sep                                                        |
             *  |                    | MMMM        | Wide                                                          | September                                                  |
             *  |                    | MMMMM       | Narrow                                                        | S                                                          |
             *  | Month standalone   | L           | Numeric: 1 digit                                              | 9, 12                                                      |
             *  |                    | LL          | Numeric: 2 digits + zero padded                               | 09, 12                                                     |
             *  |                    | LLL         | Abbreviated                                                   | Sep                                                        |
             *  |                    | LLLL        | Wide                                                          | September                                                  |
             *  |                    | LLLLL       | Narrow                                                        | S                                                          |
             *  | Week of year       | w           | Numeric: minimum digits                                       | 1... 53                                                    |
             *  |                    | ww          | Numeric: 2 digits + zero padded                               | 01... 53                                                   |
             *  | Week of month      | W           | Numeric: 1 digit                                              | 1... 5                                                     |
             *  | Day of month       | d           | Numeric: minimum digits                                       | 1                                                          |
             *  |                    | dd          | Numeric: 2 digits + zero padded                               | 01                                                          |
             *  | Week day           | E, EE & EEE | Abbreviated                                                   | Tue                                                        |
             *  |                    | EEEE        | Wide                                                          | Tuesday                                                    |
             *  |                    | EEEEE       | Narrow                                                        | T                                                          |
             *  |                    | EEEEEE      | Short                                                         | Tu                                                         |
             *  | Period             | a, aa & aaa | Abbreviated                                                   | am/pm or AM/PM                                             |
             *  |                    | aaaa        | Wide (fallback to `a` when missing)                           | ante meridiem/post meridiem                                |
             *  |                    | aaaaa       | Narrow                                                        | a/p                                                        |
             *  | Period*            | B, BB & BBB | Abbreviated                                                   | mid.                                                       |
             *  |                    | BBBB        | Wide                                                          | am, pm, midnight, noon, morning, afternoon, evening, night |
             *  |                    | BBBBB       | Narrow                                                        | md                                                         |
             *  | Period standalone* | b, bb & bbb | Abbreviated                                                   | mid.                                                       |
             *  |                    | bbbb        | Wide                                                          | am, pm, midnight, noon, morning, afternoon, evening, night |
             *  |                    | bbbbb       | Narrow                                                        | md                                                         |
             *  | Hour 1-12          | h           | Numeric: minimum digits                                       | 1, 12                                                      |
             *  |                    | hh          | Numeric: 2 digits + zero padded                               | 01, 12                                                     |
             *  | Hour 0-23          | H           | Numeric: minimum digits                                       | 0, 23                                                      |
             *  |                    | HH          | Numeric: 2 digits + zero padded                               | 00, 23                                                     |
             *  | Minute             | m           | Numeric: minimum digits                                       | 8, 59                                                      |
             *  |                    | mm          | Numeric: 2 digits + zero padded                               | 08, 59                                                     |
             *  | Second             | s           | Numeric: minimum digits                                       | 0... 59                                                    |
             *  |                    | ss          | Numeric: 2 digits + zero padded                               | 00... 59                                                   |
             *  | Fractional seconds | S           | Numeric: 1 digit                                              | 0... 9                                                     |
             *  |                    | SS          | Numeric: 2 digits + zero padded                               | 00... 99                                                   |
             *  |                    | SSS         | Numeric: 3 digits + zero padded (= milliseconds)              | 000... 999                                                 |
             *  | Zone               | z, zz & zzz | Short specific non location format (fallback to O)            | GMT-8                                                      |
             *  |                    | zzzz        | Long specific non location format (fallback to OOOO)          | GMT-08:00                                                  |
             *  |                    | Z, ZZ & ZZZ | ISO8601 basic format                                          | -0800                                                      |
             *  |                    | ZZZZ        | Long localized GMT format                                     | GMT-8:00                                                   |
             *  |                    | ZZZZZ       | ISO8601 extended format + Z indicator for offset 0 (= XXXXX)  | -08:00                                                     |
             *  |                    | O, OO & OOO | Short localized GMT format                                    | GMT-8                                                      |
             *  |                    | OOOO        | Long localized GMT format                                     | GMT-08:00                                                  |
             *
             * Note that timezone correction is not applied to an ISO string that has no time component, such as "2016-09-19"
             *
             * ### Format examples
             *
             * These examples transform a date into various formats,
             * assuming that `dateObj` is a JavaScript `Date` object for
             * year: 2015, month: 6, day: 15, hour: 21, minute: 43, second: 11,
             * given in the local time for the `en-US` locale.
             *
             * ```
             * {{ dateObj | date }}               // output is 'Jun 15, 2015'
             * {{ dateObj | date:'medium' }}      // output is 'Jun 15, 2015, 9:43:11 PM'
             * {{ dateObj | date:'shortTime' }}   // output is '9:43 PM'
             * {{ dateObj | date:'mm:ss' }}       // output is '43:11'
             * ```
             *
             * ### Usage example
             *
             * The following component uses a date pipe to display the current date in different formats.
             *
             * ```
             * \@Component({
             *  selector: 'date-pipe',
             *  template: `<div>
             *    <p>Today is {{today | date}}</p>
             *    <p>Or if you prefer, {{today | date:'fullDate'}}</p>
             *    <p>The time is {{today | date:'h:mm a z'}}</p>
             *  </div>`
             * })
             * // Get the current date and time as a date-time value.
             * export class DatePipeComponent {
             *   today: number = Date.now();
             * }
             * ```
             *
             * \@publicApi
             */
            // clang-format on
            var DatePipe = /** @class */ (function () {
                /**
                 * @param {?} locale
                 */
                function DatePipe(locale) {
                    this.locale = locale;
                }
                /**
                 * @param {?} value The date expression: a `Date` object,  a number
                 * (milliseconds since UTC epoch), or an ISO string (https://www.w3.org/TR/NOTE-datetime).
                 * @param {?=} format The date/time components to include, using predefined options or a
                 * custom format string.
                 * @param {?=} timezone A timezone offset (such as `'+0430'`), or a standard
                 * UTC/GMT or continental US timezone abbreviation.
                 * When not supplied, uses the end-user's local system timezone.
                 * @param {?=} locale A locale code for the locale format rules to use.
                 * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
                 * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
                 * @return {?} A date string in the desired format.
                 */
                DatePipe.prototype.transform = function (value, format, timezone, locale) {
                    if (format === void 0) { format = 'mediumDate'; }
                    if (value == null || value === '' || value !== value)
                        return null;
                    try {
                        return formatDate(value, format, locale || this.locale, timezone);
                    }
                    catch (error) {
                        throw invalidPipeArgumentError(DatePipe, error.message);
                    }
                };
                return DatePipe;
            }());
            DatePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'date', pure: true },] }
            ];
            /** @nocollapse */
            DatePipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _INTERPOLATION_REGEXP = /#/g;
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Maps a value to a string that pluralizes the value according to locale rules.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/pipes/ts/i18n_pipe.ts region='I18nPluralPipeComponent'}
             *
             * \@publicApi
             */
            var I18nPluralPipe = /** @class */ (function () {
                /**
                 * @param {?} _localization
                 */
                function I18nPluralPipe(_localization) {
                    this._localization = _localization;
                }
                /**
                 * @param {?} value the number to be formatted
                 * @param {?} pluralMap an object that mimics the ICU format, see
                 * http://userguide.icu-project.org/formatparse/messages.
                 * @param {?=} locale a `string` defining the locale to use (uses the current {\@link LOCALE_ID} by
                 * default).
                 * @return {?}
                 */
                I18nPluralPipe.prototype.transform = function (value, pluralMap, locale) {
                    if (value == null)
                        return '';
                    if (typeof pluralMap !== 'object' || pluralMap === null) {
                        throw invalidPipeArgumentError(I18nPluralPipe, pluralMap);
                    }
                    /** @type {?} */
                    var key = getPluralCategory(value, Object.keys(pluralMap), this._localization, locale);
                    return pluralMap[key].replace(_INTERPOLATION_REGEXP, value.toString());
                };
                return I18nPluralPipe;
            }());
            I18nPluralPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'i18nPlural', pure: true },] }
            ];
            /** @nocollapse */
            I18nPluralPipe.ctorParameters = function () { return [
                { type: NgLocalization }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Generic selector that displays the string that matches the current value.
             *
             * If none of the keys of the `mapping` match the `value`, then the content
             * of the `other` key is returned when present, otherwise an empty string is returned.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example common/pipes/ts/i18n_pipe.ts region='I18nSelectPipeComponent'}
             *
             * \@publicApi
             */
            var I18nSelectPipe = /** @class */ (function () {
                function I18nSelectPipe() {
                }
                /**
                 * @param {?} value a string to be internationalized.
                 * @param {?} mapping an object that indicates the text that should be displayed
                 * for different values of the provided `value`.
                 * @return {?}
                 */
                I18nSelectPipe.prototype.transform = function (value, mapping) {
                    if (value == null)
                        return '';
                    if (typeof mapping !== 'object' || typeof value !== 'string') {
                        throw invalidPipeArgumentError(I18nSelectPipe, mapping);
                    }
                    if (mapping.hasOwnProperty(value)) {
                        return mapping[value];
                    }
                    if (mapping.hasOwnProperty('other')) {
                        return mapping['other'];
                    }
                    return '';
                };
                return I18nSelectPipe;
            }());
            I18nSelectPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'i18nSelect', pure: true },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Converts a value into its JSON-format representation.  Useful for debugging.
             *
             * \@usageNotes
             *
             * The following component uses a JSON pipe to convert an object
             * to JSON format, and displays the string in both formats for comparison.
             *
             * {\@example common/pipes/ts/json_pipe.ts region='JsonPipe'}
             *
             * \@publicApi
             */
            var JsonPipe = /** @class */ (function () {
                function JsonPipe() {
                }
                /**
                 * @param {?} value A value of any type to convert into a JSON-format string.
                 * @return {?}
                 */
                JsonPipe.prototype.transform = function (value) { return JSON.stringify(value, null, 2); };
                return JsonPipe;
            }());
            JsonPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'json', pure: false },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @template K, V
             * @param {?} key
             * @param {?} value
             * @return {?}
             */
            function makeKeyValuePair(key, value) {
                return { key: key, value: value };
            }
            /**
             * A key value pair.
             * Usually used to represent the key value pairs from a Map or Object.
             *
             * \@publicApi
             * @record
             * @template K, V
             */
            function KeyValue() { }
            if (false) { }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Transforms Object or Map into an array of key value pairs.
             *
             * The output array will be ordered by keys.
             * By default the comparator will be by Unicode point value.
             * You can optionally pass a compareFn if your keys are complex types.
             *
             * \@usageNotes
             * ### Examples
             *
             * This examples show how an Object or a Map can be iterated by ngFor with the use of this keyvalue
             * pipe.
             *
             * {\@example common/pipes/ts/keyvalue_pipe.ts region='KeyValuePipe'}
             *
             * \@publicApi
             */
            var KeyValuePipe = /** @class */ (function () {
                /**
                 * @param {?} differs
                 */
                function KeyValuePipe(differs) {
                    this.differs = differs;
                    this.keyValues = [];
                }
                /**
                 * @template K, V
                 * @param {?} input
                 * @param {?=} compareFn
                 * @return {?}
                 */
                KeyValuePipe.prototype.transform = function (input, compareFn) {
                    var _this = this;
                    if (compareFn === void 0) { compareFn = defaultComparator; }
                    if (!input || (!(input instanceof Map) && typeof input !== 'object')) {
                        return null;
                    }
                    if (!this.differ) {
                        // make a differ for whatever type we've been passed in
                        this.differ = this.differs.find(input).create();
                    }
                    /** @type {?} */
                    var differChanges = this.differ.diff(( /** @type {?} */(input)));
                    if (differChanges) {
                        this.keyValues = [];
                        differChanges.forEachItem(( /**
                         * @param {?} r
                         * @return {?}
                         */function (r) {
                            _this.keyValues.push(makeKeyValuePair(r.key, ( /** @type {?} */(r.currentValue))));
                        }));
                        this.keyValues.sort(compareFn);
                    }
                    return this.keyValues;
                };
                return KeyValuePipe;
            }());
            KeyValuePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'keyvalue', pure: false },] }
            ];
            /** @nocollapse */
            KeyValuePipe.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["KeyValueDiffers"] }
            ]; };
            if (false) { }
            /**
             * @template K, V
             * @param {?} keyValueA
             * @param {?} keyValueB
             * @return {?}
             */
            function defaultComparator(keyValueA, keyValueB) {
                /** @type {?} */
                var a = keyValueA.key;
                /** @type {?} */
                var b = keyValueB.key;
                // if same exit with 0;
                if (a === b)
                    return 0;
                // make sure that undefined are at the end of the sort.
                if (a === undefined)
                    return 1;
                if (b === undefined)
                    return -1;
                // make sure that nulls are at the end of the sort.
                if (a === null)
                    return 1;
                if (b === null)
                    return -1;
                if (typeof a == 'string' && typeof b == 'string') {
                    return a < b ? -1 : 1;
                }
                if (typeof a == 'number' && typeof b == 'number') {
                    return a - b;
                }
                if (typeof a == 'boolean' && typeof b == 'boolean') {
                    return a < b ? -1 : 1;
                }
                // `a` and `b` are of different types. Compare their string values.
                /** @type {?} */
                var aString = String(a);
                /** @type {?} */
                var bString = String(b);
                return aString == bString ? 0 : aString < bString ? -1 : 1;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Transforms a number into a string,
             * formatted according to locale rules that determine group sizing and
             * separator, decimal-point character, and other locale-specific
             * configurations.
             *
             * If no parameters are specified, the function rounds off to the nearest value using this
             * [rounding method](https://en.wikibooks.org/wiki/Arithmetic/Rounding).
             * The behavior differs from that of the JavaScript ```Math.round()``` function.
             * In the following case for example, the pipe rounds down where
             * ```Math.round()``` rounds up:
             *
             * ```html
             * -2.5 | number:'1.0-0'
             * > -3
             * Math.round(-2.5)
             * > -2
             * ```
             *
             * @see `formatNumber()`
             *
             * \@usageNotes
             * The following code shows how the pipe transforms numbers
             * into text strings, according to various format specifications,
             * where the caller's default locale is `en-US`.
             *
             * ### Example
             *
             * <code-example path="common/pipes/ts/number_pipe.ts" region='NumberPipe'></code-example>
             *
             * \@publicApi
             */
            var DecimalPipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function DecimalPipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 * @param {?} value The number to be formatted.
                 * @param {?=} digitsInfo Decimal representation options, specified by a string
                 * in the following format:<br>
                 * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
                 *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
                 * Default is `1`.
                 *   - `minFractionDigits`: The minimum number of digits after the decimal point.
                 * Default is `0`.
                 *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
                 * Default is `3`.
                 * @param {?=} locale A locale code for the locale format rules to use.
                 * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
                 * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
                 * @return {?}
                 */
                DecimalPipe.prototype.transform = function (value, digitsInfo, locale) {
                    if (isEmpty(value))
                        return null;
                    locale = locale || this._locale;
                    try {
                        /** @type {?} */
                        var num = strToNumber(value);
                        return formatNumber(num, locale, digitsInfo);
                    }
                    catch (error) {
                        throw invalidPipeArgumentError(DecimalPipe, error.message);
                    }
                };
                return DecimalPipe;
            }());
            DecimalPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'number' },] }
            ];
            /** @nocollapse */
            DecimalPipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Transforms a number to a percentage
             * string, formatted according to locale rules that determine group sizing and
             * separator, decimal-point character, and other locale-specific
             * configurations.
             *
             * @see `formatPercent()`
             *
             * \@usageNotes
             * The following code shows how the pipe transforms numbers
             * into text strings, according to various format specifications,
             * where the caller's default locale is `en-US`.
             *
             * <code-example path="common/pipes/ts/percent_pipe.ts" region='PercentPipe'></code-example>
             *
             * \@publicApi
             */
            var PercentPipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function PercentPipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 *
                 * @param {?} value The number to be formatted as a percentage.
                 * @param {?=} digitsInfo Decimal representation options, specified by a string
                 * in the following format:<br>
                 * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
                 *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
                 * Default is `1`.
                 *   - `minFractionDigits`: The minimum number of digits after the decimal point.
                 * Default is `0`.
                 *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
                 * Default is `0`.
                 * @param {?=} locale A locale code for the locale format rules to use.
                 * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
                 * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
                 * @return {?}
                 */
                PercentPipe.prototype.transform = function (value, digitsInfo, locale) {
                    if (isEmpty(value))
                        return null;
                    locale = locale || this._locale;
                    try {
                        /** @type {?} */
                        var num = strToNumber(value);
                        return formatPercent(num, locale, digitsInfo);
                    }
                    catch (error) {
                        throw invalidPipeArgumentError(PercentPipe, error.message);
                    }
                };
                return PercentPipe;
            }());
            PercentPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'percent' },] }
            ];
            /** @nocollapse */
            PercentPipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Transforms a number to a currency string, formatted according to locale rules
             * that determine group sizing and separator, decimal-point character,
             * and other locale-specific configurations.
             *
             * @see `getCurrencySymbol()`
             * @see `formatCurrency()`
             *
             * \@usageNotes
             * The following code shows how the pipe transforms numbers
             * into text strings, according to various format specifications,
             * where the caller's default locale is `en-US`.
             *
             * <code-example path="common/pipes/ts/currency_pipe.ts" region='CurrencyPipe'></code-example>
             *
             * \@publicApi
             */
            var CurrencyPipe = /** @class */ (function () {
                /**
                 * @param {?} _locale
                 */
                function CurrencyPipe(_locale) {
                    this._locale = _locale;
                }
                /**
                 *
                 * @param {?} value The number to be formatted as currency.
                 * @param {?=} currencyCode The [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code,
                 * such as `USD` for the US dollar and `EUR` for the euro.
                 * @param {?=} display The format for the currency indicator. One of the following:
                 *   - `code`: Show the code (such as `USD`).
                 *   - `symbol`(default): Show the symbol (such as `$`).
                 *   - `symbol-narrow`: Use the narrow symbol for locales that have two symbols for their
                 * currency.
                 * For example, the Canadian dollar CAD has the symbol `CA$` and the symbol-narrow `$`. If the
                 * locale has no narrow symbol, uses the standard symbol for the locale.
                 *   - String: Use the given string value instead of a code or a symbol.
                 * For example, an empty string will suppress the currency & symbol.
                 *   - Boolean (marked deprecated in v5): `true` for symbol and false for `code`.
                 *
                 * @param {?=} digitsInfo Decimal representation options, specified by a string
                 * in the following format:<br>
                 * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
                 *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
                 * Default is `1`.
                 *   - `minFractionDigits`: The minimum number of digits after the decimal point.
                 * Default is `2`.
                 *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
                 * Default is `2`.
                 * If not provided, the number will be formatted with the proper amount of digits,
                 * depending on what the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) specifies.
                 * For example, the Canadian dollar has 2 digits, whereas the Chilean peso has none.
                 * @param {?=} locale A locale code for the locale format rules to use.
                 * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
                 * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
                 * @return {?}
                 */
                CurrencyPipe.prototype.transform = function (value, currencyCode, display, digitsInfo, locale) {
                    if (display === void 0) { display = 'symbol'; }
                    if (isEmpty(value))
                        return null;
                    locale = locale || this._locale;
                    if (typeof display === 'boolean') {
                        if (( /** @type {?} */(console)) && ( /** @type {?} */(console.warn))) {
                            console.warn("Warning: the currency pipe has been changed in Angular v5. The symbolDisplay option (third parameter) is now a string instead of a boolean. The accepted values are \"code\", \"symbol\" or \"symbol-narrow\".");
                        }
                        display = display ? 'symbol' : 'code';
                    }
                    /** @type {?} */
                    var currency = currencyCode || 'USD';
                    if (display !== 'code') {
                        if (display === 'symbol' || display === 'symbol-narrow') {
                            currency = getCurrencySymbol(currency, display === 'symbol' ? 'wide' : 'narrow', locale);
                        }
                        else {
                            currency = display;
                        }
                    }
                    try {
                        /** @type {?} */
                        var num = strToNumber(value);
                        return formatCurrency(num, locale, currency, currencyCode, digitsInfo);
                    }
                    catch (error) {
                        throw invalidPipeArgumentError(CurrencyPipe, error.message);
                    }
                };
                return CurrencyPipe;
            }());
            CurrencyPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'currency' },] }
            ];
            /** @nocollapse */
            CurrencyPipe.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * @param {?} value
             * @return {?}
             */
            function isEmpty(value) {
                return value == null || value === '' || value !== value;
            }
            /**
             * Transforms a string into a number (if needed).
             * @param {?} value
             * @return {?}
             */
            function strToNumber(value) {
                // Convert strings to numbers
                if (typeof value === 'string' && !isNaN(Number(value) - parseFloat(value))) {
                    return Number(value);
                }
                if (typeof value !== 'number') {
                    throw new Error(value + " is not a number");
                }
                return value;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@ngModule CommonModule
             * \@description
             *
             * Creates a new `Array` or `String` containing a subset (slice) of the elements.
             *
             * \@usageNotes
             *
             * All behavior is based on the expected behavior of the JavaScript API `Array.prototype.slice()`
             * and `String.prototype.slice()`.
             *
             * When operating on an `Array`, the returned `Array` is always a copy even when all
             * the elements are being returned.
             *
             * When operating on a blank value, the pipe returns the blank value.
             *
             * ### List Example
             *
             * This `ngFor` example:
             *
             * {\@example common/pipes/ts/slice_pipe.ts region='SlicePipe_list'}
             *
             * produces the following:
             *
             * ```html
             * <li>b</li>
             * <li>c</li>
             * ```
             *
             * ### String Examples
             *
             * {\@example common/pipes/ts/slice_pipe.ts region='SlicePipe_string'}
             *
             * \@publicApi
             */
            var SlicePipe = /** @class */ (function () {
                function SlicePipe() {
                }
                /**
                 * @param {?} value
                 * @param {?} start
                 * @param {?=} end
                 * @return {?}
                 */
                SlicePipe.prototype.transform = function (value, start, end) {
                    if (value == null)
                        return value;
                    if (!this.supports(value)) {
                        throw invalidPipeArgumentError(SlicePipe, value);
                    }
                    return value.slice(start, end);
                };
                /**
                 * @private
                 * @param {?} obj
                 * @return {?}
                 */
                SlicePipe.prototype.supports = function (obj) { return typeof obj === 'string' || Array.isArray(obj); };
                return SlicePipe;
            }());
            SlicePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{ name: 'slice', pure: false },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A collection of Angular pipes that are likely to be used in each and every application.
             * @type {?}
             */
            var COMMON_PIPES = [
                AsyncPipe,
                UpperCasePipe,
                LowerCasePipe,
                JsonPipe,
                SlicePipe,
                DecimalPipe,
                PercentPipe,
                TitleCasePipe,
                CurrencyPipe,
                DatePipe,
                I18nPluralPipe,
                I18nSelectPipe,
                KeyValuePipe,
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Note: This does not contain the location providers,
            // as they need some platform specific implementations to work.
            /**
             * Exports all the basic Angular directives and pipes,
             * such as `NgIf`, `NgForOf`, `DecimalPipe`, and so on.
             * Re-exported by `BrowserModule`, which is included automatically in the root
             * `AppModule` when you create a new app with the CLI `new` command.
             *
             * * The `providers` options configure the NgModule's injector to provide
             * localization dependencies to members.
             * * The `exports` options make the declared directives and pipes available for import
             * by other NgModules.
             *
             * \@publicApi
             */
            var CommonModule = /** @class */ (function () {
                function CommonModule() {
                }
                return CommonModule;
            }());
            CommonModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: [COMMON_DIRECTIVES, COMMON_PIPES],
                            exports: [COMMON_DIRECTIVES, COMMON_PIPES],
                            providers: [
                                { provide: NgLocalization, useClass: NgLocaleLocalization },
                            ],
                        },] }
            ];
            var ɵ0$2 = getPluralCase;
            /**
             * A module that contains the deprecated i18n pipes.
             *
             * @deprecated from v5
             * \@publicApi
             */
            var DeprecatedI18NPipesModule = /** @class */ (function () {
                function DeprecatedI18NPipesModule() {
                }
                return DeprecatedI18NPipesModule;
            }());
            DeprecatedI18NPipesModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: [COMMON_DEPRECATED_I18N_PIPES],
                            exports: [COMMON_DEPRECATED_I18N_PIPES],
                            providers: [{ provide: DEPRECATED_PLURAL_FN, useValue: ɵ0$2 }],
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A DI Token representing the main rendering context. In a browser this is the DOM Document.
             *
             * Note: Document might not be available in the Application Context when Application and Rendering
             * Contexts are not the same (e.g. when running the application in a Web Worker).
             *
             * \@publicApi
             * @type {?}
             */
            var DOCUMENT = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('DocumentToken');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var PLATFORM_BROWSER_ID = 'browser';
            /** @type {?} */
            var PLATFORM_SERVER_ID = 'server';
            /** @type {?} */
            var PLATFORM_WORKER_APP_ID = 'browserWorkerApp';
            /** @type {?} */
            var PLATFORM_WORKER_UI_ID = 'browserWorkerUi';
            /**
             * Returns whether a platform id represents a browser platform.
             * \@publicApi
             * @param {?} platformId
             * @return {?}
             */
            function isPlatformBrowser(platformId) {
                return platformId === PLATFORM_BROWSER_ID;
            }
            /**
             * Returns whether a platform id represents a server platform.
             * \@publicApi
             * @param {?} platformId
             * @return {?}
             */
            function isPlatformServer(platformId) {
                return platformId === PLATFORM_SERVER_ID;
            }
            /**
             * Returns whether a platform id represents a web worker app platform.
             * \@publicApi
             * @param {?} platformId
             * @return {?}
             */
            function isPlatformWorkerApp(platformId) {
                return platformId === PLATFORM_WORKER_APP_ID;
            }
            /**
             * Returns whether a platform id represents a web worker UI platform.
             * \@publicApi
             * @param {?} platformId
             * @return {?}
             */
            function isPlatformWorkerUi(platformId) {
                return platformId === PLATFORM_WORKER_UI_ID;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Version"]('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Defines a scroll position manager. Implemented by `BrowserViewportScroller`.
             *
             * \@publicApi
             * @abstract
             */
            var ViewportScroller = /** @class */ (function () {
                function ViewportScroller() {
                }
                return ViewportScroller;
            }());
            // De-sugared tree-shakable injection
            // See #23917
            /** @nocollapse */
            /** @nocollapse */ ViewportScroller.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({
                token: ViewportScroller,
                providedIn: 'root',
                factory: ( /**
                 * @nocollapse @return {?}
                 */function () { return new BrowserViewportScroller(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(DOCUMENT), window, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ErrorHandler"])); })
            });
            if (false) { }
            /**
             * Manages the scroll position for a browser window.
             */
            var BrowserViewportScroller = /** @class */ (function () {
                /**
                 * @param {?} document
                 * @param {?} window
                 * @param {?} errorHandler
                 */
                function BrowserViewportScroller(document, window, errorHandler) {
                    this.document = document;
                    this.window = window;
                    this.errorHandler = errorHandler;
                    this.offset = ( /**
                     * @return {?}
                     */function () { return [0, 0]; });
                }
                /**
                 * Configures the top offset used when scrolling to an anchor.
                 * @param {?} offset A position in screen coordinates (a tuple with x and y values)
                 * or a function that returns the top offset position.
                 *
                 * @return {?}
                 */
                BrowserViewportScroller.prototype.setOffset = function (offset) {
                    if (Array.isArray(offset)) {
                        this.offset = ( /**
                         * @return {?}
                         */function () { return offset; });
                    }
                    else {
                        this.offset = offset;
                    }
                };
                /**
                 * Retrieves the current scroll position.
                 * @return {?} The position in screen coordinates.
                 */
                BrowserViewportScroller.prototype.getScrollPosition = function () {
                    if (this.supportScrollRestoration()) {
                        return [this.window.scrollX, this.window.scrollY];
                    }
                    else {
                        return [0, 0];
                    }
                };
                /**
                 * Sets the scroll position.
                 * @param {?} position The new position in screen coordinates.
                 * @return {?}
                 */
                BrowserViewportScroller.prototype.scrollToPosition = function (position) {
                    if (this.supportScrollRestoration()) {
                        this.window.scrollTo(position[0], position[1]);
                    }
                };
                /**
                 * Scrolls to an anchor element.
                 * @param {?} anchor The ID of the anchor element.
                 * @return {?}
                 */
                BrowserViewportScroller.prototype.scrollToAnchor = function (anchor) {
                    if (this.supportScrollRestoration()) {
                        // Escape anything passed to `querySelector` as it can throw errors and stop the application
                        // from working if invalid values are passed.
                        if (this.window.CSS && this.window.CSS.escape) {
                            anchor = this.window.CSS.escape(anchor);
                        }
                        else {
                            anchor = anchor.replace(/(\"|\'\ |:|\.|\[|\]|,|=)/g, '\\$1');
                        }
                        try {
                            /** @type {?} */
                            var elSelectedById = this.document.querySelector("#" + anchor);
                            if (elSelectedById) {
                                this.scrollToElement(elSelectedById);
                                return;
                            }
                            /** @type {?} */
                            var elSelectedByName = this.document.querySelector("[name='" + anchor + "']");
                            if (elSelectedByName) {
                                this.scrollToElement(elSelectedByName);
                                return;
                            }
                        }
                        catch (e) {
                            this.errorHandler.handleError(e);
                        }
                    }
                };
                /**
                 * Disables automatic scroll restoration provided by the browser.
                 * @param {?} scrollRestoration
                 * @return {?}
                 */
                BrowserViewportScroller.prototype.setHistoryScrollRestoration = function (scrollRestoration) {
                    if (this.supportScrollRestoration()) {
                        /** @type {?} */
                        var history = this.window.history;
                        if (history && history.scrollRestoration) {
                            history.scrollRestoration = scrollRestoration;
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} el
                 * @return {?}
                 */
                BrowserViewportScroller.prototype.scrollToElement = function (el) {
                    /** @type {?} */
                    var rect = el.getBoundingClientRect();
                    /** @type {?} */
                    var left = rect.left + this.window.pageXOffset;
                    /** @type {?} */
                    var top = rect.top + this.window.pageYOffset;
                    /** @type {?} */
                    var offset = this.offset();
                    this.window.scrollTo(left - offset[0], top - offset[1]);
                };
                /**
                 * We only support scroll restoration when we can get a hold of window.
                 * This means that we do not support this behavior when running in a web worker.
                 *
                 * Lifting this restriction right now would require more changes in the dom adapter.
                 * Since webworkers aren't widely used, we will lift it once RouterScroller is
                 * battle-tested.
                 * @private
                 * @return {?}
                 */
                BrowserViewportScroller.prototype.supportScrollRestoration = function () {
                    try {
                        return !!this.window && !!this.window.scrollTo;
                    }
                    catch (_a) {
                        return false;
                    }
                };
                return BrowserViewportScroller;
            }());
            if (false) { }
            /**
             * Provides an empty implementation of the viewport scroller. This will
             * live in \@angular/common as it will be used by both platform-server and platform-webworker.
             */
            var NullViewportScroller = /** @class */ (function () {
                function NullViewportScroller() {
                }
                /**
                 * Empty implementation
                 * @param {?} offset
                 * @return {?}
                 */
                NullViewportScroller.prototype.setOffset = function (offset) { };
                /**
                 * Empty implementation
                 * @return {?}
                 */
                NullViewportScroller.prototype.getScrollPosition = function () { return [0, 0]; };
                /**
                 * Empty implementation
                 * @param {?} position
                 * @return {?}
                 */
                NullViewportScroller.prototype.scrollToPosition = function (position) { };
                /**
                 * Empty implementation
                 * @param {?} anchor
                 * @return {?}
                 */
                NullViewportScroller.prototype.scrollToAnchor = function (anchor) { };
                /**
                 * Empty implementation
                 * @param {?} scrollRestoration
                 * @return {?}
                 */
                NullViewportScroller.prototype.setHistoryScrollRestoration = function (scrollRestoration) { };
                return NullViewportScroller;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=common.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/common/fesm2015/http.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/@angular/common/fesm2015/http.js ***!
          \*******************************************************/
        /*! exports provided: ɵangular_packages_common_http_http_a, ɵangular_packages_common_http_http_b, ɵangular_packages_common_http_http_c, ɵangular_packages_common_http_http_d, ɵangular_packages_common_http_http_g, ɵangular_packages_common_http_http_h, ɵangular_packages_common_http_http_e, ɵangular_packages_common_http_http_f, HttpBackend, HttpHandler, HttpClient, HttpHeaders, HTTP_INTERCEPTORS, JsonpClientBackend, JsonpInterceptor, HttpClientJsonpModule, HttpClientModule, HttpClientXsrfModule, ɵHttpInterceptingHandler, HttpParams, HttpUrlEncodingCodec, HttpRequest, HttpErrorResponse, HttpEventType, HttpHeaderResponse, HttpResponse, HttpResponseBase, HttpXhrBackend, XhrFactory, HttpXsrfTokenExtractor */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_a", function () { return NoopInterceptor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_b", function () { return JsonpCallbackContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_c", function () { return jsonpCallbackContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_d", function () { return BrowserXhr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_g", function () { return HttpXsrfCookieExtractor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_h", function () { return HttpXsrfInterceptor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_e", function () { return XSRF_COOKIE_NAME; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_http_http_f", function () { return XSRF_HEADER_NAME; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpBackend", function () { return HttpBackend; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHandler", function () { return HttpHandler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClient", function () { return HttpClient; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHeaders", function () { return HttpHeaders; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTTP_INTERCEPTORS", function () { return HTTP_INTERCEPTORS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpClientBackend", function () { return JsonpClientBackend; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpInterceptor", function () { return JsonpInterceptor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientJsonpModule", function () { return HttpClientJsonpModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientModule", function () { return HttpClientModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientXsrfModule", function () { return HttpClientXsrfModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵHttpInterceptingHandler", function () { return HttpInterceptingHandler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpParams", function () { return HttpParams; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpUrlEncodingCodec", function () { return HttpUrlEncodingCodec; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpRequest", function () { return HttpRequest; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpErrorResponse", function () { return HttpErrorResponse; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpEventType", function () { return HttpEventType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHeaderResponse", function () { return HttpHeaderResponse; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function () { return HttpResponse; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponseBase", function () { return HttpResponseBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpXhrBackend", function () { return HttpXhrBackend; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrFactory", function () { return XhrFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpXsrfTokenExtractor", function () { return HttpXsrfTokenExtractor; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
             * `HttpResponse`.
             *
             * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
             * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
             * `HttpBackend`.
             *
             * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
             *
             * \@publicApi
             * @abstract
             */
            var HttpHandler = /** @class */ (function () {
                function HttpHandler() {
                }
                return HttpHandler;
            }());
            if (false) { }
            /**
             * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
             *
             * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
             *
             * When injected, `HttpBackend` dispatches requests directly to the backend, without going
             * through the interceptor chain.
             *
             * \@publicApi
             * @abstract
             */
            var HttpBackend = /** @class */ (function () {
                function HttpBackend() {
                }
                return HttpBackend;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @record
             */
            function Update() { }
            if (false) { }
            /**
             * Represents the header configuration options for an HTTP request.
             * Instances are immutable. Modifying methods return a cloned
             * instance with the change. The original object is never changed.
             *
             * \@publicApi
             */
            var HttpHeaders = /** @class */ (function () {
                /**
                 * Constructs a new HTTP header object with the given values.
                 * @param {?=} headers
                 */
                function HttpHeaders(headers) {
                    var _this = this;
                    /**
                     * Internal map of lowercased header names to the normalized
                     * form of the name (the form seen first).
                     */
                    this.normalizedNames = new Map();
                    /**
                     * Queued updates to be materialized the next initialization.
                     */
                    this.lazyUpdate = null;
                    if (!headers) {
                        this.headers = new Map();
                    }
                    else if (typeof headers === 'string') {
                        this.lazyInit = ( /**
                         * @return {?}
                         */function () {
                            _this.headers = new Map();
                            headers.split('\n').forEach(( /**
                             * @param {?} line
                             * @return {?}
                             */function (/**
                             * @param {?} line
                             * @return {?}
                             */ line) {
                                /** @type {?} */
                                var index = line.indexOf(':');
                                if (index > 0) {
                                    /** @type {?} */
                                    var name = line.slice(0, index);
                                    /** @type {?} */
                                    var key = name.toLowerCase();
                                    /** @type {?} */
                                    var value = line.slice(index + 1).trim();
                                    _this.maybeSetNormalizedName(name, key);
                                    if (_this.headers.has(key)) {
                                        ( /** @type {?} */(_this.headers.get(key))).push(value);
                                    }
                                    else {
                                        _this.headers.set(key, [value]);
                                    }
                                }
                            }));
                        });
                    }
                    else {
                        this.lazyInit = ( /**
                         * @return {?}
                         */function () {
                            _this.headers = new Map();
                            Object.keys(headers).forEach(( /**
                             * @param {?} name
                             * @return {?}
                             */function (/**
                             * @param {?} name
                             * @return {?}
                             */ name) {
                                /** @type {?} */
                                var values = headers[name];
                                /** @type {?} */
                                var key = name.toLowerCase();
                                if (typeof values === 'string') {
                                    values = [values];
                                }
                                if (values.length > 0) {
                                    _this.headers.set(key, values);
                                    _this.maybeSetNormalizedName(name, key);
                                }
                            }));
                        });
                    }
                }
                /**
                 * Checks for existence of a given header.
                 *
                 * @param {?} name The header name to check for existence.
                 *
                 * @return {?} True if the header exists, false otherwise.
                 */
                HttpHeaders.prototype.has = function (name) {
                    this.init();
                    return this.headers.has(name.toLowerCase());
                };
                /**
                 * Retrieves the first value of a given header.
                 *
                 * @param {?} name The header name.
                 *
                 * @return {?} The value string if the header exists, null otherwise
                 */
                HttpHeaders.prototype.get = function (name) {
                    this.init();
                    /** @type {?} */
                    var values = this.headers.get(name.toLowerCase());
                    return values && values.length > 0 ? values[0] : null;
                };
                /**
                 * Retrieves the names of the headers.
                 *
                 * @return {?} A list of header names.
                 */
                HttpHeaders.prototype.keys = function () {
                    this.init();
                    return Array.from(this.normalizedNames.values());
                };
                /**
                 * Retrieves a list of values for a given header.
                 *
                 * @param {?} name The header name from which to retrieve values.
                 *
                 * @return {?} A string of values if the header exists, null otherwise.
                 */
                HttpHeaders.prototype.getAll = function (name) {
                    this.init();
                    return this.headers.get(name.toLowerCase()) || null;
                };
                /**
                 * Appends a new value to the existing set of values for a header
                 * and returns them in a clone of the original instance.
                 *
                 * @param {?} name The header name for which to append the value or values.
                 * @param {?} value The new value or array of values.
                 *
                 * @return {?} A clone of the HTTP headers object with the value appended to the given header.
                 */
                HttpHeaders.prototype.append = function (name, value) {
                    return this.clone({ name: name, value: value, op: 'a' });
                };
                /**
                 * Sets or modifies a value for a given header in a clone of the original instance.
                 * If the header already exists, its value is replaced with the given value
                 * in the returned object.
                 *
                 * @param {?} name The header name.
                 * @param {?} value The value or values to set or overide for the given header.
                 *
                 * @return {?} A clone of the HTTP headers object with the newly set header value.
                 */
                HttpHeaders.prototype.set = function (name, value) {
                    return this.clone({ name: name, value: value, op: 's' });
                };
                /**
                 * Deletes values for a given header in a clone of the original instance.
                 *
                 * @param {?} name The header name.
                 * @param {?=} value The value or values to delete for the given header.
                 *
                 * @return {?} A clone of the HTTP headers object with the given value deleted.
                 */
                HttpHeaders.prototype.delete = function (name, value) {
                    return this.clone({ name: name, value: value, op: 'd' });
                };
                /**
                 * @private
                 * @param {?} name
                 * @param {?} lcName
                 * @return {?}
                 */
                HttpHeaders.prototype.maybeSetNormalizedName = function (name, lcName) {
                    if (!this.normalizedNames.has(lcName)) {
                        this.normalizedNames.set(lcName, name);
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                HttpHeaders.prototype.init = function () {
                    var _this = this;
                    if (!!this.lazyInit) {
                        if (this.lazyInit instanceof HttpHeaders) {
                            this.copyFrom(this.lazyInit);
                        }
                        else {
                            this.lazyInit();
                        }
                        this.lazyInit = null;
                        if (!!this.lazyUpdate) {
                            this.lazyUpdate.forEach(( /**
                             * @param {?} update
                             * @return {?}
                             */function (/**
                             * @param {?} update
                             * @return {?}
                             */ update) { return _this.applyUpdate(update); }));
                            this.lazyUpdate = null;
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} other
                 * @return {?}
                 */
                HttpHeaders.prototype.copyFrom = function (other) {
                    var _this = this;
                    other.init();
                    Array.from(other.headers.keys()).forEach(( /**
                     * @param {?} key
                     * @return {?}
                     */function (/**
                     * @param {?} key
                     * @return {?}
                     */ key) {
                        _this.headers.set(key, ( /** @type {?} */(other.headers.get(key))));
                        _this.normalizedNames.set(key, ( /** @type {?} */(other.normalizedNames.get(key))));
                    }));
                };
                /**
                 * @private
                 * @param {?} update
                 * @return {?}
                 */
                HttpHeaders.prototype.clone = function (update) {
                    /** @type {?} */
                    var clone = new HttpHeaders();
                    clone.lazyInit =
                        (!!this.lazyInit && this.lazyInit instanceof HttpHeaders) ? this.lazyInit : this;
                    clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
                    return clone;
                };
                /**
                 * @private
                 * @param {?} update
                 * @return {?}
                 */
                HttpHeaders.prototype.applyUpdate = function (update) {
                    /** @type {?} */
                    var key = update.name.toLowerCase();
                    switch (update.op) {
                        case 'a':
                        case 's':
                            /** @type {?} */
                            var value = ( /** @type {?} */(update.value));
                            if (typeof value === 'string') {
                                value = [value];
                            }
                            if (value.length === 0) {
                                return;
                            }
                            this.maybeSetNormalizedName(update.name, key);
                            /** @type {?} */
                            var base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
                            base.push.apply(base, value);
                            this.headers.set(key, base);
                            break;
                        case 'd':
                            /** @type {?} */
                            var toDelete_1 = ( /** @type {?} */(update.value));
                            if (!toDelete_1) {
                                this.headers.delete(key);
                                this.normalizedNames.delete(key);
                            }
                            else {
                                /** @type {?} */
                                var existing = this.headers.get(key);
                                if (!existing) {
                                    return;
                                }
                                existing = existing.filter(( /**
                                 * @param {?} value
                                 * @return {?}
                                 */function (/**
                                 * @param {?} value
                                 * @return {?}
                                 */ value) { return toDelete_1.indexOf(value) === -1; }));
                                if (existing.length === 0) {
                                    this.headers.delete(key);
                                    this.normalizedNames.delete(key);
                                }
                                else {
                                    this.headers.set(key, existing);
                                }
                            }
                            break;
                    }
                };
                /**
                 * \@internal
                 * @param {?} fn
                 * @return {?}
                 */
                HttpHeaders.prototype.forEach = function (fn) {
                    var _this = this;
                    this.init();
                    Array.from(this.normalizedNames.keys())
                        .forEach(( /**
                 * @param {?} key
                 * @return {?}
                 */function (/**
                 * @param {?} key
                 * @return {?}
                 */ key) { return fn(( /** @type {?} */(_this.normalizedNames.get(key))), ( /** @type {?} */(_this.headers.get(key)))); }));
                };
                return HttpHeaders;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A codec for encoding and decoding parameters in URLs.
             *
             * Used by `HttpParams`.
             *
             * \@publicApi
             *
             * @record
             */
            function HttpParameterCodec() { }
            if (false) { }
            /**
             * Provides encoding and decoding of URL parameter and query-string values.
             *
             * Serializes and parses URL parameter keys and values to encode and decode them.
             * If you pass URL query parameters without encoding,
             * the query parameters can be misinterpreted at the receiving end.
             *
             *
             * \@publicApi
             */
            var HttpUrlEncodingCodec = /** @class */ (function () {
                function HttpUrlEncodingCodec() {
                }
                /**
                 * Encodes a key name for a URL parameter or query-string.
                 * @param {?} key The key name.
                 * @return {?} The encoded key name.
                 */
                HttpUrlEncodingCodec.prototype.encodeKey = function (key) { return standardEncoding(key); };
                /**
                 * Encodes the value of a URL parameter or query-string.
                 * @param {?} value The value.
                 * @return {?} The encoded value.
                 */
                HttpUrlEncodingCodec.prototype.encodeValue = function (value) { return standardEncoding(value); };
                /**
                 * Decodes an encoded URL parameter or query-string key.
                 * @param {?} key The encoded key name.
                 * @return {?} The decoded key name.
                 */
                HttpUrlEncodingCodec.prototype.decodeKey = function (key) { return decodeURIComponent(key); };
                /**
                 * Decodes an encoded URL parameter or query-string value.
                 * @param {?} value The encoded value.
                 * @return {?} The decoded value.
                 */
                HttpUrlEncodingCodec.prototype.decodeValue = function (value) { return decodeURIComponent(value); };
                return HttpUrlEncodingCodec;
            }());
            /**
             * @param {?} rawParams
             * @param {?} codec
             * @return {?}
             */
            function paramParser(rawParams, codec) {
                /** @type {?} */
                var map = new Map();
                if (rawParams.length > 0) {
                    /** @type {?} */
                    var params = rawParams.split('&');
                    params.forEach(( /**
                     * @param {?} param
                     * @return {?}
                     */function (param) {
                        /** @type {?} */
                        var eqIdx = param.indexOf('=');
                        var _c = eqIdx == -1 ?
                            [codec.decodeKey(param), ''] :
                            [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))], key = _c[0], val = _c[1];
                        /** @type {?} */
                        var list = map.get(key) || [];
                        list.push(val);
                        map.set(key, list);
                    }));
                }
                return map;
            }
            /**
             * @param {?} v
             * @return {?}
             */
            function standardEncoding(v) {
                return encodeURIComponent(v)
                    .replace(/%40/gi, '@')
                    .replace(/%3A/gi, ':')
                    .replace(/%24/gi, '$')
                    .replace(/%2C/gi, ',')
                    .replace(/%3B/gi, ';')
                    .replace(/%2B/gi, '+')
                    .replace(/%3D/gi, '=')
                    .replace(/%3F/gi, '?')
                    .replace(/%2F/gi, '/');
            }
            /**
             * @record
             */
            function Update$1() { }
            if (false) { }
            /**
             * Options used to construct an `HttpParams` instance.
             *
             * \@publicApi
             * @record
             */
            function HttpParamsOptions() { }
            if (false) { }
            /**
             * An HTTP request/response body that represents serialized parameters,
             * per the MIME type `application/x-www-form-urlencoded`.
             *
             * This class is immutable; all mutation operations return a new instance.
             *
             * \@publicApi
             */
            var HttpParams = /** @class */ (function () {
                /**
                 * @param {?=} options
                 */
                function HttpParams(options) {
                    var _this = this;
                    if (options === void 0) { options = ( /** @type {?} */({})); }
                    this.updates = null;
                    this.cloneFrom = null;
                    this.encoder = options.encoder || new HttpUrlEncodingCodec();
                    if (!!options.fromString) {
                        if (!!options.fromObject) {
                            throw new Error("Cannot specify both fromString and fromObject.");
                        }
                        this.map = paramParser(options.fromString, this.encoder);
                    }
                    else if (!!options.fromObject) {
                        this.map = new Map();
                        Object.keys(options.fromObject).forEach(( /**
                         * @param {?} key
                         * @return {?}
                         */function (/**
                         * @param {?} key
                         * @return {?}
                         */ key) {
                            /** @type {?} */
                            var value = (( /** @type {?} */(options.fromObject)))[key];
                            ( /** @type {?} */(_this.map)).set(key, Array.isArray(value) ? value : [value]);
                        }));
                    }
                    else {
                        this.map = null;
                    }
                }
                /**
                 * Reports whether the body includes one or more values for a given parameter.
                 * @param {?} param The parameter name.
                 * @return {?} True if the parameter has one or more values,
                 * false if it has no value or is not present.
                 */
                HttpParams.prototype.has = function (param) {
                    this.init();
                    return ( /** @type {?} */(this.map)).has(param);
                };
                /**
                 * Retrieves the first value for a parameter.
                 * @param {?} param The parameter name.
                 * @return {?} The first value of the given parameter,
                 * or `null` if the parameter is not present.
                 */
                HttpParams.prototype.get = function (param) {
                    this.init();
                    /** @type {?} */
                    var res = ( /** @type {?} */(this.map)).get(param);
                    return !!res ? res[0] : null;
                };
                /**
                 * Retrieves all values for a  parameter.
                 * @param {?} param The parameter name.
                 * @return {?} All values in a string array,
                 * or `null` if the parameter not present.
                 */
                HttpParams.prototype.getAll = function (param) {
                    this.init();
                    return ( /** @type {?} */(this.map)).get(param) || null;
                };
                /**
                 * Retrieves all the parameters for this body.
                 * @return {?} The parameter names in a string array.
                 */
                HttpParams.prototype.keys = function () {
                    this.init();
                    return Array.from(( /** @type {?} */(this.map)).keys());
                };
                /**
                 * Appends a new value to existing values for a parameter.
                 * @param {?} param The parameter name.
                 * @param {?} value The new value to add.
                 * @return {?} A new body with the appended value.
                 */
                HttpParams.prototype.append = function (param, value) { return this.clone({ param: param, value: value, op: 'a' }); };
                /**
                 * Replaces the value for a parameter.
                 * @param {?} param The parameter name.
                 * @param {?} value The new value.
                 * @return {?} A new body with the new value.
                 */
                HttpParams.prototype.set = function (param, value) { return this.clone({ param: param, value: value, op: 's' }); };
                /**
                 * Removes a given value or all values from a parameter.
                 * @param {?} param The parameter name.
                 * @param {?=} value The value to remove, if provided.
                 * @return {?} A new body with the given value removed, or with all values
                 * removed if no value is specified.
                 */
                HttpParams.prototype.delete = function (param, value) { return this.clone({ param: param, value: value, op: 'd' }); };
                /**
                 * Serializes the body to an encoded string, where key-value pairs (separated by `=`) are
                 * separated by `&`s.
                 * @return {?}
                 */
                HttpParams.prototype.toString = function () {
                    var _this = this;
                    this.init();
                    return this.keys()
                        .map(( /**
                 * @param {?} key
                 * @return {?}
                 */function (/**
                 * @param {?} key
                 * @return {?}
                 */ key) {
                        /** @type {?} */
                        var eKey = _this.encoder.encodeKey(key);
                        return ( /** @type {?} */(( /** @type {?} */(_this.map)).get(key))).map(( /**
                         * @param {?} value
                         * @return {?}
                         */function (/**
                         * @param {?} value
                         * @return {?}
                         */ value) { return eKey + '=' + _this.encoder.encodeValue(value); }))
                            .join('&');
                    }))
                        .join('&');
                };
                /**
                 * @private
                 * @param {?} update
                 * @return {?}
                 */
                HttpParams.prototype.clone = function (update) {
                    /** @type {?} */
                    var clone = new HttpParams(( /** @type {?} */({ encoder: this.encoder })));
                    clone.cloneFrom = this.cloneFrom || this;
                    clone.updates = (this.updates || []).concat([update]);
                    return clone;
                };
                /**
                 * @private
                 * @return {?}
                 */
                HttpParams.prototype.init = function () {
                    var _this = this;
                    if (this.map === null) {
                        this.map = new Map();
                    }
                    if (this.cloneFrom !== null) {
                        this.cloneFrom.init();
                        this.cloneFrom.keys().forEach(( /**
                         * @param {?} key
                         * @return {?}
                         */function (/**
                         * @param {?} key
                         * @return {?}
                         */ key) { return ( /** @type {?} */(_this.map)).set(key, ( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(_this.cloneFrom)).map)).get(key)))); }));
                        ( /** @type {?} */(this.updates)).forEach(( /**
                         * @param {?} update
                         * @return {?}
                         */function (/**
                         * @param {?} update
                         * @return {?}
                         */ update) {
                            switch (update.op) {
                                case 'a':
                                case 's':
                                    /** @type {?} */
                                    var base = (update.op === 'a' ? ( /** @type {?} */(_this.map)).get(update.param) : undefined) || [];
                                    base.push(( /** @type {?} */(update.value)));
                                    ( /** @type {?} */(_this.map)).set(update.param, base);
                                    break;
                                case 'd':
                                    if (update.value !== undefined) {
                                        /** @type {?} */
                                        var base_1 = ( /** @type {?} */(_this.map)).get(update.param) || [];
                                        /** @type {?} */
                                        var idx = base_1.indexOf(update.value);
                                        if (idx !== -1) {
                                            base_1.splice(idx, 1);
                                        }
                                        if (base_1.length > 0) {
                                            ( /** @type {?} */(_this.map)).set(update.param, base_1);
                                        }
                                        else {
                                            ( /** @type {?} */(_this.map)).delete(update.param);
                                        }
                                    }
                                    else {
                                        ( /** @type {?} */(_this.map)).delete(update.param);
                                        break;
                                    }
                            }
                        }));
                        this.cloneFrom = this.updates = null;
                    }
                };
                return HttpParams;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Construction interface for `HttpRequest`s.
             *
             * All values are optional and will override default values if provided.
             * @record
             */
            function HttpRequestInit() { }
            if (false) { }
            /**
             * Determine whether the given HTTP method may include a body.
             * @param {?} method
             * @return {?}
             */
            function mightHaveBody(method) {
                switch (method) {
                    case 'DELETE':
                    case 'GET':
                    case 'HEAD':
                    case 'OPTIONS':
                    case 'JSONP':
                        return false;
                    default:
                        return true;
                }
            }
            /**
             * Safely assert whether the given value is an ArrayBuffer.
             *
             * In some execution environments ArrayBuffer is not defined.
             * @param {?} value
             * @return {?}
             */
            function isArrayBuffer(value) {
                return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
            }
            /**
             * Safely assert whether the given value is a Blob.
             *
             * In some execution environments Blob is not defined.
             * @param {?} value
             * @return {?}
             */
            function isBlob(value) {
                return typeof Blob !== 'undefined' && value instanceof Blob;
            }
            /**
             * Safely assert whether the given value is a FormData instance.
             *
             * In some execution environments FormData is not defined.
             * @param {?} value
             * @return {?}
             */
            function isFormData(value) {
                return typeof FormData !== 'undefined' && value instanceof FormData;
            }
            /**
             * An outgoing HTTP request with an optional typed body.
             *
             * `HttpRequest` represents an outgoing request, including URL, method,
             * headers, body, and other request configuration options. Instances should be
             * assumed to be immutable. To modify a `HttpRequest`, the `clone`
             * method should be used.
             *
             * \@publicApi
             * @template T
             */
            var HttpRequest = /** @class */ (function () {
                /**
                 * @param {?} method
                 * @param {?} url
                 * @param {?=} third
                 * @param {?=} fourth
                 */
                function HttpRequest(method, url, third, fourth) {
                    this.url = url;
                    /**
                     * The request body, or `null` if one isn't set.
                     *
                     * Bodies are not enforced to be immutable, as they can include a reference to any
                     * user-defined data type. However, interceptors should take care to preserve
                     * idempotence by treating them as such.
                     */
                    this.body = null;
                    /**
                     * Whether this request should be made in a way that exposes progress events.
                     *
                     * Progress events are expensive (change detection runs on each event) and so
                     * they should only be requested if the consumer intends to monitor them.
                     */
                    this.reportProgress = false;
                    /**
                     * Whether this request should be sent with outgoing credentials (cookies).
                     */
                    this.withCredentials = false;
                    /**
                     * The expected response type of the server.
                     *
                     * This is used to parse the response appropriately before returning it to
                     * the requestee.
                     */
                    this.responseType = 'json';
                    this.method = method.toUpperCase();
                    // Next, need to figure out which argument holds the HttpRequestInit
                    // options, if any.
                    /** @type {?} */
                    var options;
                    // Check whether a body argument is expected. The only valid way to omit
                    // the body argument is to use a known no-body method like GET.
                    if (mightHaveBody(this.method) || !!fourth) {
                        // Body is the third argument, options are the fourth.
                        this.body = (third !== undefined) ? ( /** @type {?} */(third)) : null;
                        options = fourth;
                    }
                    else {
                        // No body required, options are the third argument. The body stays null.
                        options = ( /** @type {?} */(third));
                    }
                    // If options have been passed, interpret them.
                    if (options) {
                        // Normalize reportProgress and withCredentials.
                        this.reportProgress = !!options.reportProgress;
                        this.withCredentials = !!options.withCredentials;
                        // Override default response type of 'json' if one is provided.
                        if (!!options.responseType) {
                            this.responseType = options.responseType;
                        }
                        // Override headers if they're provided.
                        if (!!options.headers) {
                            this.headers = options.headers;
                        }
                        if (!!options.params) {
                            this.params = options.params;
                        }
                    }
                    // If no headers have been passed in, construct a new HttpHeaders instance.
                    if (!this.headers) {
                        this.headers = new HttpHeaders();
                    }
                    // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
                    if (!this.params) {
                        this.params = new HttpParams();
                        this.urlWithParams = url;
                    }
                    else {
                        // Encode the parameters to a string in preparation for inclusion in the URL.
                        /** @type {?} */
                        var params = this.params.toString();
                        if (params.length === 0) {
                            // No parameters, the visible URL is just the URL given at creation time.
                            this.urlWithParams = url;
                        }
                        else {
                            // Does the URL already have query parameters? Look for '?'.
                            /** @type {?} */
                            var qIdx = url.indexOf('?');
                            // There are 3 cases to handle:
                            // 1) No existing parameters -> append '?' followed by params.
                            // 2) '?' exists and is followed by existing query string ->
                            //    append '&' followed by params.
                            // 3) '?' exists at the end of the url -> append params directly.
                            // This basically amounts to determining the character, if any, with
                            // which to join the URL and parameters.
                            /** @type {?} */
                            var sep = qIdx === -1 ? '?' : (qIdx < url.length - 1 ? '&' : '');
                            this.urlWithParams = url + sep + params;
                        }
                    }
                }
                /**
                 * Transform the free-form body into a serialized format suitable for
                 * transmission to the server.
                 * @return {?}
                 */
                HttpRequest.prototype.serializeBody = function () {
                    // If no body is present, no need to serialize it.
                    if (this.body === null) {
                        return null;
                    }
                    // Check whether the body is already in a serialized form. If so,
                    // it can just be returned directly.
                    if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) ||
                        typeof this.body === 'string') {
                        return this.body;
                    }
                    // Check whether the body is an instance of HttpUrlEncodedParams.
                    if (this.body instanceof HttpParams) {
                        return this.body.toString();
                    }
                    // Check whether the body is an object or array, and serialize with JSON if so.
                    if (typeof this.body === 'object' || typeof this.body === 'boolean' ||
                        Array.isArray(this.body)) {
                        return JSON.stringify(this.body);
                    }
                    // Fall back on toString() for everything else.
                    return (( /** @type {?} */(this.body))).toString();
                };
                /**
                 * Examine the body and attempt to infer an appropriate MIME type
                 * for it.
                 *
                 * If no such type can be inferred, this method will return `null`.
                 * @return {?}
                 */
                HttpRequest.prototype.detectContentTypeHeader = function () {
                    // An empty body has no content type.
                    if (this.body === null) {
                        return null;
                    }
                    // FormData bodies rely on the browser's content type assignment.
                    if (isFormData(this.body)) {
                        return null;
                    }
                    // Blobs usually have their own content type. If it doesn't, then
                    // no type can be inferred.
                    if (isBlob(this.body)) {
                        return this.body.type || null;
                    }
                    // Array buffers have unknown contents and thus no type can be inferred.
                    if (isArrayBuffer(this.body)) {
                        return null;
                    }
                    // Technically, strings could be a form of JSON data, but it's safe enough
                    // to assume they're plain strings.
                    if (typeof this.body === 'string') {
                        return 'text/plain';
                    }
                    // `HttpUrlEncodedParams` has its own content-type.
                    if (this.body instanceof HttpParams) {
                        return 'application/x-www-form-urlencoded;charset=UTF-8';
                    }
                    // Arrays, objects, and numbers will be encoded as JSON.
                    if (typeof this.body === 'object' || typeof this.body === 'number' ||
                        Array.isArray(this.body)) {
                        return 'application/json';
                    }
                    // No type could be inferred.
                    return null;
                };
                /**
                 * @param {?=} update
                 * @return {?}
                 */
                HttpRequest.prototype.clone = function (update) {
                    if (update === void 0) { update = {}; }
                    // For method, url, and responseType, take the current value unless
                    // it is overridden in the update hash.
                    /** @type {?} */
                    var method = update.method || this.method;
                    /** @type {?} */
                    var url = update.url || this.url;
                    /** @type {?} */
                    var responseType = update.responseType || this.responseType;
                    // The body is somewhat special - a `null` value in update.body means
                    // whatever current body is present is being overridden with an empty
                    // body, whereas an `undefined` value in update.body implies no
                    // override.
                    /** @type {?} */
                    var body = (update.body !== undefined) ? update.body : this.body;
                    // Carefully handle the boolean options to differentiate between
                    // `false` and `undefined` in the update args.
                    /** @type {?} */
                    var withCredentials = (update.withCredentials !== undefined) ? update.withCredentials : this.withCredentials;
                    /** @type {?} */
                    var reportProgress = (update.reportProgress !== undefined) ? update.reportProgress : this.reportProgress;
                    // Headers and params may be appended to if `setHeaders` or
                    // `setParams` are used.
                    /** @type {?} */
                    var headers = update.headers || this.headers;
                    /** @type {?} */
                    var params = update.params || this.params;
                    // Check whether the caller has asked to add headers.
                    if (update.setHeaders !== undefined) {
                        // Set every requested header.
                        headers =
                            Object.keys(update.setHeaders)
                                .reduce(( /**
                         * @param {?} headers
                         * @param {?} name
                         * @return {?}
                         */function (headers, name) { return headers.set(name, ( /** @type {?} */(update.setHeaders))[name]); }), headers);
                    }
                    // Check whether the caller has asked to set params.
                    if (update.setParams) {
                        // Set every requested param.
                        params = Object.keys(update.setParams)
                            .reduce(( /**
                     * @param {?} params
                     * @param {?} param
                     * @return {?}
                     */function (params, param) { return params.set(param, ( /** @type {?} */(update.setParams))[param]); }), params);
                    }
                    // Finally, construct the new HttpRequest using the pieces from above.
                    return new HttpRequest(method, url, body, {
                        params: params, headers: headers, reportProgress: reportProgress, responseType: responseType, withCredentials: withCredentials,
                    });
                };
                return HttpRequest;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @enum {number} */
            var HttpEventType = {
                /**
                 * The request was sent out over the wire.
                 */
                Sent: 0,
                /**
                 * An upload progress event was received.
                 */
                UploadProgress: 1,
                /**
                 * The response status code and headers were received.
                 */
                ResponseHeader: 2,
                /**
                 * A download progress event was received.
                 */
                DownloadProgress: 3,
                /**
                 * The full response including the body was received.
                 */
                Response: 4,
                /**
                 * A custom event from an interceptor or a backend.
                 */
                User: 5,
            };
            HttpEventType[HttpEventType.Sent] = 'Sent';
            HttpEventType[HttpEventType.UploadProgress] = 'UploadProgress';
            HttpEventType[HttpEventType.ResponseHeader] = 'ResponseHeader';
            HttpEventType[HttpEventType.DownloadProgress] = 'DownloadProgress';
            HttpEventType[HttpEventType.Response] = 'Response';
            HttpEventType[HttpEventType.User] = 'User';
            /**
             * Base interface for progress events.
             *
             * \@publicApi
             * @record
             */
            function HttpProgressEvent() { }
            if (false) { }
            /**
             * A download progress event.
             *
             * \@publicApi
             * @record
             */
            function HttpDownloadProgressEvent() { }
            if (false) { }
            /**
             * An upload progress event.
             *
             * \@publicApi
             * @record
             */
            function HttpUploadProgressEvent() { }
            if (false) { }
            /**
             * An event indicating that the request was sent to the server. Useful
             * when a request may be retried multiple times, to distinguish between
             * retries on the final event stream.
             *
             * \@publicApi
             * @record
             */
            function HttpSentEvent() { }
            if (false) { }
            /**
             * A user-defined event.
             *
             * Grouping all custom events under this type ensures they will be handled
             * and forwarded by all implementations of interceptors.
             *
             * \@publicApi
             * @record
             * @template T
             */
            function HttpUserEvent() { }
            if (false) { }
            /**
             * An error that represents a failed attempt to JSON.parse text coming back
             * from the server.
             *
             * It bundles the Error object with the actual response body that failed to parse.
             *
             *
             * @record
             */
            function HttpJsonParseError() { }
            if (false) { }
            /**
             * Base class for both `HttpResponse` and `HttpHeaderResponse`.
             *
             * \@publicApi
             * @abstract
             */
            var HttpResponseBase = /** @class */ (function () {
                /**
                 * Super-constructor for all responses.
                 *
                 * The single parameter accepted is an initialization hash. Any properties
                 * of the response passed there will override the default values.
                 * @param {?} init
                 * @param {?=} defaultStatus
                 * @param {?=} defaultStatusText
                 */
                function HttpResponseBase(init, defaultStatus, defaultStatusText) {
                    if (defaultStatus === void 0) { defaultStatus = 200; }
                    if (defaultStatusText === void 0) { defaultStatusText = 'OK'; }
                    // If the hash has values passed, use them to initialize the response.
                    // Otherwise use the default values.
                    this.headers = init.headers || new HttpHeaders();
                    this.status = init.status !== undefined ? init.status : defaultStatus;
                    this.statusText = init.statusText || defaultStatusText;
                    this.url = init.url || null;
                    // Cache the ok value to avoid defining a getter.
                    this.ok = this.status >= 200 && this.status < 300;
                }
                return HttpResponseBase;
            }());
            if (false) { }
            /**
             * A partial HTTP response which only includes the status and header data,
             * but no response body.
             *
             * `HttpHeaderResponse` is a `HttpEvent` available on the response
             * event stream, only when progress events are requested.
             *
             * \@publicApi
             */
            var HttpHeaderResponse = /** @class */ (function (_super_1) {
                __extends(HttpHeaderResponse, _super_1);
                /**
                 * Create a new `HttpHeaderResponse` with the given parameters.
                 * @param {?=} init
                 */
                function HttpHeaderResponse(init) {
                    if (init === void 0) { init = {}; }
                    var _this = _super_1.call(this, init) || this;
                    _this.type = HttpEventType.ResponseHeader;
                    return _this;
                }
                /**
                 * Copy this `HttpHeaderResponse`, overriding its contents with the
                 * given parameter hash.
                 * @param {?=} update
                 * @return {?}
                 */
                HttpHeaderResponse.prototype.clone = function (update) {
                    if (update === void 0) { update = {}; }
                    // Perform a straightforward initialization of the new HttpHeaderResponse,
                    // overriding the current parameters with new ones if given.
                    return new HttpHeaderResponse({
                        headers: update.headers || this.headers,
                        status: update.status !== undefined ? update.status : this.status,
                        statusText: update.statusText || this.statusText,
                        url: update.url || this.url || undefined,
                    });
                };
                return HttpHeaderResponse;
            }(HttpResponseBase));
            if (false) { }
            /**
             * A full HTTP response, including a typed response body (which may be `null`
             * if one was not returned).
             *
             * `HttpResponse` is a `HttpEvent` available on the response event
             * stream.
             *
             * \@publicApi
             * @template T
             */
            var HttpResponse = /** @class */ (function (_super_1) {
                __extends(HttpResponse, _super_1);
                /**
                 * Construct a new `HttpResponse`.
                 * @param {?=} init
                 */
                function HttpResponse(init) {
                    if (init === void 0) { init = {}; }
                    var _this = _super_1.call(this, init) || this;
                    _this.type = HttpEventType.Response;
                    _this.body = init.body !== undefined ? init.body : null;
                    return _this;
                }
                /**
                 * @param {?=} update
                 * @return {?}
                 */
                HttpResponse.prototype.clone = function (update) {
                    if (update === void 0) { update = {}; }
                    return new HttpResponse({
                        body: (update.body !== undefined) ? update.body : this.body,
                        headers: update.headers || this.headers,
                        status: (update.status !== undefined) ? update.status : this.status,
                        statusText: update.statusText || this.statusText,
                        url: update.url || this.url || undefined,
                    });
                };
                return HttpResponse;
            }(HttpResponseBase));
            if (false) { }
            /**
             * A response that represents an error or failure, either from a
             * non-successful HTTP status, an error while executing the request,
             * or some other failure which occurred during the parsing of the response.
             *
             * Any error returned on the `Observable` response stream will be
             * wrapped in an `HttpErrorResponse` to provide additional context about
             * the state of the HTTP layer when the error occurred. The error property
             * will contain either a wrapped Error object or the error response returned
             * from the server.
             *
             * \@publicApi
             */
            var HttpErrorResponse = /** @class */ (function (_super_1) {
                __extends(HttpErrorResponse, _super_1);
                /**
                 * @param {?} init
                 */
                function HttpErrorResponse(init) {
                    var _this = 
                    // Initialize with a default status of 0 / Unknown Error.
                    _super_1.call(this, init, 0, 'Unknown Error') || this;
                    _this.name = 'HttpErrorResponse';
                    /**
                     * Errors are never okay, even when the status code is in the 2xx success range.
                     */
                    _this.ok = false;
                    // If the response was successful, then this was a parse error. Otherwise, it was
                    // a protocol-level failure of some sort. Either the request failed in transit
                    // or the server returned an unsuccessful status code.
                    if (_this.status >= 200 && _this.status < 300) {
                        _this.message = "Http failure during parsing for " + (init.url || '(unknown url)');
                    }
                    else {
                        _this.message =
                            "Http failure response for " + (init.url || '(unknown url)') + ": " + init.status + " " + init.statusText;
                    }
                    _this.error = init.error || null;
                    return _this;
                }
                return HttpErrorResponse;
            }(HttpResponseBase));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Constructs an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
             * the given `body`. This function clones the object and adds the body.
             *
             * Note that the `responseType` *options* value is a String that identifies the
             * single data type of the response.
             * A single overload version of the method handles each response type.
             * The value of `responseType` cannot be a union, as the combined signature could imply.
             *
             * @template T
             * @param {?} options
             * @param {?} body
             * @return {?}
             */
            function addBody(options, body) {
                return {
                    body: body,
                    headers: options.headers,
                    observe: options.observe,
                    params: options.params,
                    reportProgress: options.reportProgress,
                    responseType: options.responseType,
                    withCredentials: options.withCredentials,
                };
            }
            /**
             * Performs HTTP requests.
             * This service is available as an injectable class, with methods to perform HTTP requests.
             * Each request method has multiple signatures, and the return type varies based on
             * the signature that is called (mainly the values of `observe` and `responseType`).
             *
             * Note that the `responseType` *options* value is a String that identifies the
             * single data type of the response.
             * A single overload version of the method handles each response type.
             * The value of `responseType` cannot be a union, as the combined signature could imply.
             *
             * \@usageNotes
             * Sample HTTP requests for the [Tour of Heroes](/tutorial/toh-pt0) application.
             *
             * ### HTTP Request Example
             *
             * ```
             *  // GET heroes whose name contains search term
             * searchHeroes(term: string): observable<Hero[]>{
             *
             *  const params = new HttpParams({fromString: 'name=term'});
             *    return this.httpClient.request('GET', this.heroesUrl, {responseType:'json', params});
             * }
             * ```
             * ### JSONP Example
             * ```
             * requestJsonp(url, callback = 'callback') {
             *  return this.httpClient.jsonp(this.heroesURL, callback);
             * }
             * ```
             *
             * ### PATCH Example
             * ```
             * // PATCH one of the heroes' name
             * patchHero (id: number, heroName: string): Observable<{}> {
             * const url = `${this.heroesUrl}/${id}`;   // PATCH api/heroes/42
             *  return this.httpClient.patch(url, {name: heroName}, httpOptions)
             *    .pipe(catchError(this.handleError('patchHero')));
             * }
             * ```
             *
             * @see [HTTP Guide](guide/http)
             *
             * \@publicApi
             */
            var HttpClient = /** @class */ (function () {
                /**
                 * @param {?} handler
                 */
                function HttpClient(handler) {
                    this.handler = handler;
                }
                /**
                 * Constructs an observable for a generic HTTP request that, when subscribed,
                 * fires the request through the chain of registered interceptors and on to the
                 * server.
                 *
                 * You can pass an `HttpRequest` directly as the only parameter. In this case,
                 * the call returns an observable of the raw `HttpEvent` stream.
                 *
                 * Alternatively you can pass an HTTP method as the first parameter,
                 * a URL string as the second, and an options hash containing the request body as the third.
                 * See `addBody()`. In this case, the specified `responseType` and `observe` options determine the
                 * type of returned observable.
                 *   * The `responseType` value determines how a successful response body is parsed.
                 *   * If `responseType` is the default `json`, you can pass a type interface for the resulting
                 * object as a type parameter to the call.
                 *
                 * The `observe` value determines the return type, according to what you are interested in
                 * observing.
                 *   * An `observe` value of events returns an observable of the raw `HttpEvent` stream, including
                 * progress events by default.
                 *   * An `observe` value of response returns an observable of `HttpResponse<T>`,
                 * where the `T` parameter depends on the `responseType` and any optionally provided type
                 * parameter.
                 *   * An `observe` value of body returns an observable of `<T>` with the same `T` body type.
                 *
                 * @param {?} first
                 * @param {?=} url
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.request = function (first, url, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    /** @type {?} */
                    var req;
                    // First, check whether the primary argument is an instance of `HttpRequest`.
                    if (first instanceof HttpRequest) {
                        // It is. The other arguments must be undefined (per the signatures) and can be
                        // ignored.
                        req = ( /** @type {?} */(first));
                    }
                    else {
                        // It's a string, so it represents a URL. Construct a request based on it,
                        // and incorporate the remaining arguments (assuming `GET` unless a method is
                        // provided.
                        // Figure out the headers.
                        /** @type {?} */
                        var headers = undefined;
                        if (options.headers instanceof HttpHeaders) {
                            headers = options.headers;
                        }
                        else {
                            headers = new HttpHeaders(options.headers);
                        }
                        // Sort out parameters.
                        /** @type {?} */
                        var params = undefined;
                        if (!!options.params) {
                            if (options.params instanceof HttpParams) {
                                params = options.params;
                            }
                            else {
                                params = new HttpParams(( /** @type {?} */({ fromObject: options.params })));
                            }
                        }
                        // Construct the request.
                        req = new HttpRequest(first, ( /** @type {?} */(url)), (options.body !== undefined ? options.body : null), {
                            headers: headers,
                            params: params,
                            reportProgress: options.reportProgress,
                            // By default, JSON is assumed to be returned for all calls.
                            responseType: options.responseType || 'json',
                            withCredentials: options.withCredentials,
                        });
                    }
                    // Start with an Observable.of() the initial request, and run the handler (which
                    // includes all interceptors) inside a concatMap(). This way, the handler runs
                    // inside an Observable chain, which causes interceptors to be re-run on every
                    // subscription (this also makes retries re-run the handler, including interceptors).
                    /** @type {?} */
                    var events$ = Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["of"])(req).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["concatMap"])(( /**
                     * @param {?} req
                     * @return {?}
                     */function (req) { return _this.handler.handle(req); })));
                    // If coming via the API signature which accepts a previously constructed HttpRequest,
                    // the only option is to get the event stream. Otherwise, return the event stream if
                    // that is what was requested.
                    if (first instanceof HttpRequest || options.observe === 'events') {
                        return events$;
                    }
                    // The requested stream contains either the full response or the body. In either
                    // case, the first step is to filter the event stream to extract a stream of
                    // responses(s).
                    /** @type {?} */
                    var res$ = ( /** @type {?} */(events$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) { return event instanceof HttpResponse; })))));
                    // Decide which stream to return.
                    switch (options.observe || 'body') {
                        case 'body':
                            // The requested stream is the body. Map the response stream to the response
                            // body. This could be done more simply, but a misbehaving interceptor might
                            // transform the response body into a different format and ignore the requested
                            // responseType. Guard against this by validating that the response is of the
                            // requested type.
                            switch (req.responseType) {
                                case 'arraybuffer':
                                    return res$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(( /**
                                     * @param {?} res
                                     * @return {?}
                                     */function (res) {
                                        // Validate that the body is an ArrayBuffer.
                                        if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
                                            throw new Error('Response is not an ArrayBuffer.');
                                        }
                                        return res.body;
                                    })));
                                case 'blob':
                                    return res$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(( /**
                                     * @param {?} res
                                     * @return {?}
                                     */function (res) {
                                        // Validate that the body is a Blob.
                                        if (res.body !== null && !(res.body instanceof Blob)) {
                                            throw new Error('Response is not a Blob.');
                                        }
                                        return res.body;
                                    })));
                                case 'text':
                                    return res$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(( /**
                                     * @param {?} res
                                     * @return {?}
                                     */function (res) {
                                        // Validate that the body is a string.
                                        if (res.body !== null && typeof res.body !== 'string') {
                                            throw new Error('Response is not a string.');
                                        }
                                        return res.body;
                                    })));
                                case 'json':
                                default:
                                    // No validation needed for JSON responses, as they can be of any type.
                                    return res$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(( /**
                                     * @param {?} res
                                     * @return {?}
                                     */function (res) { return res.body; })));
                            }
                        case 'response':
                            // The response stream was requested directly, so return it.
                            return res$;
                        default:
                            // Guard against new future observe types being added.
                            throw new Error("Unreachable: unhandled observe type " + options.observe + "}");
                    }
                };
                /**
                 * Constructs an observable that, when subscribed, causes the configured
                 * `DELETE` request to execute on the server. See the individual overloads for
                 * details on the return type.
                 *
                 * @param {?} url     The endpoint URL.
                 * @param {?=} options The HTTP options to send with the request.
                 *
                 * @return {?}
                 */
                HttpClient.prototype.delete = function (url, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('DELETE', url, ( /** @type {?} */(options)));
                };
                /**
                 * Constructs an observable that, when subscribed, causes the configured
                 * `GET` request to execute on the server. See the individual overloads for
                 * details on the return type.
                 * @param {?} url
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.get = function (url, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('GET', url, ( /** @type {?} */(options)));
                };
                /**
                 * Constructs an observable that, when subscribed, causes the configured
                 * `HEAD` request to execute on the server. The `HEAD` method returns
                 * meta information about the resource without transferring the
                 * resource itself. See the individual overloads for
                 * details on the return type.
                 * @param {?} url
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.head = function (url, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('HEAD', url, ( /** @type {?} */(options)));
                };
                /**
                 * Constructs an `Observable` that, when subscribed, causes a request with the special method
                 * `JSONP` to be dispatched via the interceptor pipeline.
                 * The [JSONP pattern](https://en.wikipedia.org/wiki/JSONP) works around limitations of certain
                 * API endpoints that don't support newer,
                 * and preferable [CORS](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) protocol.
                 * JSONP treats the endpoint API as a JavaScript file and tricks the browser to process the
                 * requests even if the API endpoint is not located on the same domain (origin) as the client-side
                 * application making the request.
                 * The endpoint API must support JSONP callback for JSONP requests to work.
                 * The resource API returns the JSON response wrapped in a callback function.
                 * You can pass the callback function name as one of the query parameters.
                 * Note that JSONP requests can only be used with `GET` requests.
                 *
                 * @template T
                 * @param {?} url The resource URL.
                 * @param {?} callbackParam The callback function name.
                 *
                 * @return {?}
                 */
                HttpClient.prototype.jsonp = function (url, callbackParam) {
                    return this.request('JSONP', url, {
                        params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
                        observe: 'body',
                        responseType: 'json',
                    });
                };
                /**
                 * Constructs an `Observable` that, when subscribed, causes the configured
                 * `OPTIONS` request to execute on the server. This method allows the client
                 * to determine the supported HTTP methods and other capabilites of an endpoint,
                 * without implying a resource action. See the individual overloads for
                 * details on the return type.
                 * @param {?} url
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.options = function (url, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('OPTIONS', url, ( /** @type {?} */(options)));
                };
                /**
                 * Constructs an observable that, when subscribed, causes the configured
                 * `PATCH` request to execute on the server. See the individual overloads for
                 * details on the return type.
                 * @param {?} url
                 * @param {?} body
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.patch = function (url, body, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('PATCH', url, addBody(options, body));
                };
                /**
                 * Constructs an observable that, when subscribed, causes the configured
                 * `POST` request to execute on the server. The server responds with the location of
                 * the replaced resource. See the individual overloads for
                 * details on the return type.
                 * @param {?} url
                 * @param {?} body
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.post = function (url, body, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('POST', url, addBody(options, body));
                };
                /**
                 * Constructs an observable that, when subscribed, causes the configured
                 * `PUT` request to execute on the server. The `PUT` method replaces an existing resource
                 * with a new set of values.
                 * See the individual overloads for details on the return type.
                 * @param {?} url
                 * @param {?} body
                 * @param {?=} options
                 * @return {?}
                 */
                HttpClient.prototype.put = function (url, body, options) {
                    if (options === void 0) { options = {}; }
                    return this.request('PUT', url, addBody(options, body));
                };
                return HttpClient;
            }());
            HttpClient.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            HttpClient.ctorParameters = function () { return [
                { type: HttpHandler }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Intercepts and handles an `HttpRequest` or `HttpResponse`.
             *
             * Most interceptors transform the outgoing request before passing it to the
             * next interceptor in the chain, by calling `next.handle(transformedReq)`.
             * An interceptor may transform the
             * response event stream as well, by applying additional RxJS operators on the stream
             * returned by `next.handle()`.
             *
             * More rarely, an interceptor may handle the request entirely,
             * and compose a new event stream instead of invoking `next.handle()`. This is an
             * acceptable behavior, but keep in mind that further interceptors will be skipped entirely.
             *
             * It is also rare but valid for an interceptor to return multiple responses on the
             * event stream for a single request.
             *
             * \@publicApi
             *
             * @see [HTTP Guide](guide/http#intercepting-requests-and-responses)
             *
             * \@usageNotes
             *
             * To use the same instance of `HttpInterceptors` for the entire app, import the `HttpClientModule`
             * only in your `AppModule`, and add the interceptors to the root application injector .
             * If you import `HttpClientModule` multiple times across different modules (for example, in lazy
             * loading modules), each import creates a new copy of the `HttpClientModule`, which overwrites the interceptors
             * provided in the root module.
             *
             * @record
             */
            function HttpInterceptor() { }
            if (false) { }
            /**
             * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
             *
             *
             */
            var HttpInterceptorHandler = /** @class */ (function () {
                /**
                 * @param {?} next
                 * @param {?} interceptor
                 */
                function HttpInterceptorHandler(next, interceptor) {
                    this.next = next;
                    this.interceptor = interceptor;
                }
                /**
                 * @param {?} req
                 * @return {?}
                 */
                HttpInterceptorHandler.prototype.handle = function (req) {
                    return this.interceptor.intercept(req, this.next);
                };
                return HttpInterceptorHandler;
            }());
            if (false) { }
            /**
             * A multi-provider token that represents the array of registered
             * `HttpInterceptor` objects.
             *
             * \@publicApi
             * @type {?}
             */
            var HTTP_INTERCEPTORS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('HTTP_INTERCEPTORS');
            var NoopInterceptor = /** @class */ (function () {
                function NoopInterceptor() {
                }
                /**
                 * @param {?} req
                 * @param {?} next
                 * @return {?}
                 */
                NoopInterceptor.prototype.intercept = function (req, next) {
                    return next.handle(req);
                };
                return NoopInterceptor;
            }());
            NoopInterceptor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Every request made through JSONP needs a callback name that's unique across the
            // whole page. Each request is assigned an id and the callback name is constructed
            // from that. The next id to be assigned is tracked in a global variable here that
            // is shared among all applications on the page.
            /** @type {?} */
            var nextRequestId = 0;
            // Error text given when a JSONP script is injected, but doesn't invoke the callback
            // passed in its URL.
            /** @type {?} */
            var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
            // Error text given when a request is passed to the JsonpClientBackend that doesn't
            // have a request method JSONP.
            /** @type {?} */
            var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use JSONP request method.';
            /** @type {?} */
            var JSONP_ERR_WRONG_RESPONSE_TYPE = 'JSONP requests must use Json response type.';
            /**
             * DI token/abstract type representing a map of JSONP callbacks.
             *
             * In the browser, this should always be the `window` object.
             *
             *
             * @abstract
             */
            var JsonpCallbackContext = /** @class */ (function () {
                function JsonpCallbackContext() {
                }
                return JsonpCallbackContext;
            }());
            /**
             * Processes an `HttpRequest` with the JSONP method,
             * by performing JSONP style requests.
             * @see `HttpHandler`
             * @see `HttpXhrBackend`
             *
             * \@publicApi
             */
            var JsonpClientBackend = /** @class */ (function () {
                /**
                 * @param {?} callbackMap
                 * @param {?} document
                 */
                function JsonpClientBackend(callbackMap, document) {
                    this.callbackMap = callbackMap;
                    this.document = document;
                }
                /**
                 * Get the name of the next callback method, by incrementing the global `nextRequestId`.
                 * @private
                 * @return {?}
                 */
                JsonpClientBackend.prototype.nextCallback = function () { return "ng_jsonp_callback_" + nextRequestId++; };
                /**
                 * Processes a JSONP request and returns an event stream of the results.
                 * @param {?} req The request object.
                 * @return {?} An observable of the response events.
                 *
                 */
                JsonpClientBackend.prototype.handle = function (req) {
                    var _this = this;
                    // Firstly, check both the method and response type. If either doesn't match
                    // then the request was improperly routed here and cannot be handled.
                    if (req.method !== 'JSONP') {
                        throw new Error(JSONP_ERR_WRONG_METHOD);
                    }
                    else if (req.responseType !== 'json') {
                        throw new Error(JSONP_ERR_WRONG_RESPONSE_TYPE);
                    }
                    // Everything else happens inside the Observable boundary.
                    return new rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        // The first step to make a request is to generate the callback name, and replace the
                        // callback placeholder in the URL with the name. Care has to be taken here to ensure
                        // a trailing &, if matched, gets inserted back into the URL in the correct place.
                        /** @type {?} */
                        var callback = _this.nextCallback();
                        /** @type {?} */
                        var url = req.urlWithParams.replace(/=JSONP_CALLBACK(&|$)/, "=" + callback + "$1");
                        // Construct the <script> tag and point it at the URL.
                        /** @type {?} */
                        var node = _this.document.createElement('script');
                        node.src = url;
                        // A JSONP request requires waiting for multiple callbacks. These variables
                        // are closed over and track state across those callbacks.
                        // The response object, if one has been received, or null otherwise.
                        /** @type {?} */
                        var body = null;
                        // Whether the response callback has been called.
                        /** @type {?} */
                        var finished = false;
                        // Whether the request has been cancelled (and thus any other callbacks)
                        // should be ignored.
                        /** @type {?} */
                        var cancelled = false;
                        // Set the response callback in this.callbackMap (which will be the window
                        // object in the browser. The script being loaded via the <script> tag will
                        // eventually call this callback.
                        _this.callbackMap[callback] = ( /**
                         * @param {?=} data
                         * @return {?}
                         */function (data) {
                            // Data has been received from the JSONP script. Firstly, delete this callback.
                            delete _this.callbackMap[callback];
                            // Next, make sure the request wasn't cancelled in the meantime.
                            if (cancelled) {
                                return;
                            }
                            // Set state to indicate data was received.
                            body = data;
                            finished = true;
                        });
                        // cleanup() is a utility closure that removes the <script> from the page and
                        // the response callback from the window. This logic is used in both the
                        // success, error, and cancellation paths, so it's extracted out for convenience.
                        /** @type {?} */
                        var cleanup = ( /**
                         * @return {?}
                         */function () {
                            // Remove the <script> tag if it's still on the page.
                            if (node.parentNode) {
                                node.parentNode.removeChild(node);
                            }
                            // Remove the response callback from the callbackMap (window object in the
                            // browser).
                            delete _this.callbackMap[callback];
                        });
                        // onLoad() is the success callback which runs after the response callback
                        // if the JSONP script loads successfully. The event itself is unimportant.
                        // If something went wrong, onLoad() may run without the response callback
                        // having been invoked.
                        /** @type {?} */
                        var onLoad = ( /**
                         * @param {?} event
                         * @return {?}
                         */function (event) {
                            // Do nothing if the request has been cancelled.
                            if (cancelled) {
                                return;
                            }
                            // Cleanup the page.
                            cleanup();
                            // Check whether the response callback has run.
                            if (!finished) {
                                // It hasn't, something went wrong with the request. Return an error via
                                // the Observable error path. All JSONP errors have status 0.
                                observer.error(new HttpErrorResponse({
                                    url: url,
                                    status: 0,
                                    statusText: 'JSONP Error',
                                    error: new Error(JSONP_ERR_NO_CALLBACK),
                                }));
                                return;
                            }
                            // Success. body either contains the response body or null if none was
                            // returned.
                            observer.next(new HttpResponse({
                                body: body,
                                status: 200,
                                statusText: 'OK', url: url,
                            }));
                            // Complete the stream, the response is over.
                            observer.complete();
                        });
                        // onError() is the error callback, which runs if the script returned generates
                        // a Javascript error. It emits the error via the Observable error channel as
                        // a HttpErrorResponse.
                        /** @type {?} */
                        var onError = ( /**
                         * @param {?} error
                         * @return {?}
                         */function (error) {
                            // If the request was already cancelled, no need to emit anything.
                            if (cancelled) {
                                return;
                            }
                            cleanup();
                            // Wrap the error in a HttpErrorResponse.
                            observer.error(new HttpErrorResponse({
                                error: error,
                                status: 0,
                                statusText: 'JSONP Error', url: url,
                            }));
                        });
                        // Subscribe to both the success (load) and error events on the <script> tag,
                        // and add it to the page.
                        node.addEventListener('load', onLoad);
                        node.addEventListener('error', onError);
                        _this.document.body.appendChild(node);
                        // The request has now been successfully sent.
                        observer.next({ type: HttpEventType.Sent });
                        // Cancellation handler.
                        return ( /**
                         * @return {?}
                         */function () {
                            // Track the cancellation so event listeners won't do anything even if already scheduled.
                            cancelled = true;
                            // Remove the event listeners so they won't run if the events later fire.
                            node.removeEventListener('load', onLoad);
                            node.removeEventListener('error', onError);
                            // And finally, clean up the page.
                            cleanup();
                        });
                    }));
                };
                return JsonpClientBackend;
            }());
            JsonpClientBackend.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            JsonpClientBackend.ctorParameters = function () { return [
                { type: JsonpCallbackContext },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_3__["DOCUMENT"],] }] }
            ]; };
            if (false) { }
            /**
             * Identifies requests with the method JSONP and
             * shifts them to the `JsonpClientBackend`.
             *
             * @see `HttpInterceptor`
             *
             * \@publicApi
             */
            var JsonpInterceptor = /** @class */ (function () {
                /**
                 * @param {?} jsonp
                 */
                function JsonpInterceptor(jsonp) {
                    this.jsonp = jsonp;
                }
                /**
                 * Identifies and handles a given JSONP request.
                 * @param {?} req The outgoing request object to handle.
                 * @param {?} next The next interceptor in the chain, or the backend
                 * if no interceptors remain in the chain.
                 * @return {?} An observable of the event stream.
                 */
                JsonpInterceptor.prototype.intercept = function (req, next) {
                    if (req.method === 'JSONP') {
                        return this.jsonp.handle(( /** @type {?} */(req)));
                    }
                    // Fall through for normal HTTP requests.
                    return next.handle(req);
                };
                return JsonpInterceptor;
            }());
            JsonpInterceptor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            JsonpInterceptor.ctorParameters = function () { return [
                { type: JsonpClientBackend }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var XSSI_PREFIX = /^\)\]\}',?\n/;
            /**
             * Determine an appropriate URL for the response, by checking either
             * XMLHttpRequest.responseURL or the X-Request-URL header.
             * @param {?} xhr
             * @return {?}
             */
            function getResponseUrl(xhr) {
                if ('responseURL' in xhr && xhr.responseURL) {
                    return xhr.responseURL;
                }
                if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
                    return xhr.getResponseHeader('X-Request-URL');
                }
                return null;
            }
            /**
             * A wrapper around the `XMLHttpRequest` constructor.
             *
             * \@publicApi
             * @abstract
             */
            var XhrFactory = /** @class */ (function () {
                function XhrFactory() {
                }
                return XhrFactory;
            }());
            if (false) { }
            /**
             * A factory for `HttpXhrBackend` that uses the `XMLHttpRequest` browser API.
             *
             */
            var BrowserXhr = /** @class */ (function () {
                function BrowserXhr() {
                }
                /**
                 * @return {?}
                 */
                BrowserXhr.prototype.build = function () { return ( /** @type {?} */((new XMLHttpRequest()))); };
                return BrowserXhr;
            }());
            BrowserXhr.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            BrowserXhr.ctorParameters = function () { return []; };
            /**
             * Tracks a response from the server that does not yet have a body.
             * @record
             */
            function PartialResponse() { }
            if (false) { }
            /**
             * Uses `XMLHttpRequest` to send requests to a backend server.
             * @see `HttpHandler`
             * @see `JsonpClientBackend`
             *
             * \@publicApi
             */
            var HttpXhrBackend = /** @class */ (function () {
                /**
                 * @param {?} xhrFactory
                 */
                function HttpXhrBackend(xhrFactory) {
                    this.xhrFactory = xhrFactory;
                }
                /**
                 * Processes a request and returns a stream of response events.
                 * @param {?} req The request object.
                 * @return {?} An observable of the response events.
                 */
                HttpXhrBackend.prototype.handle = function (req) {
                    var _this = this;
                    // Quick check to give a better error message when a user attempts to use
                    // HttpClient.jsonp() without installing the JsonpClientModule
                    if (req.method === 'JSONP') {
                        throw new Error("Attempted to construct Jsonp request without JsonpClientModule installed.");
                    }
                    // Everything happens on Observable subscription.
                    return new rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        // Start by setting up the XHR object with request method, URL, and withCredentials flag.
                        /** @type {?} */
                        var xhr = _this.xhrFactory.build();
                        xhr.open(req.method, req.urlWithParams);
                        if (!!req.withCredentials) {
                            xhr.withCredentials = true;
                        }
                        // Add all the requested headers.
                        req.headers.forEach(( /**
                         * @param {?} name
                         * @param {?} values
                         * @return {?}
                         */function (name, values) { return xhr.setRequestHeader(name, values.join(',')); }));
                        // Add an Accept header if one isn't present already.
                        if (!req.headers.has('Accept')) {
                            xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
                        }
                        // Auto-detect the Content-Type header if one isn't present already.
                        if (!req.headers.has('Content-Type')) {
                            /** @type {?} */
                            var detectedType = req.detectContentTypeHeader();
                            // Sometimes Content-Type detection fails.
                            if (detectedType !== null) {
                                xhr.setRequestHeader('Content-Type', detectedType);
                            }
                        }
                        // Set the responseType if one was requested.
                        if (req.responseType) {
                            /** @type {?} */
                            var responseType = req.responseType.toLowerCase();
                            // JSON responses need to be processed as text. This is because if the server
                            // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
                            // xhr.response will be null, and xhr.responseText cannot be accessed to
                            // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
                            // is parsed by first requesting text and then applying JSON.parse.
                            xhr.responseType = ( /** @type {?} */(((responseType !== 'json') ? responseType : 'text')));
                        }
                        // Serialize the request body if one is present. If not, this will be set to null.
                        /** @type {?} */
                        var reqBody = req.serializeBody();
                        // If progress events are enabled, response headers will be delivered
                        // in two events - the HttpHeaderResponse event and the full HttpResponse
                        // event. However, since response headers don't change in between these
                        // two events, it doesn't make sense to parse them twice. So headerResponse
                        // caches the data extracted from the response whenever it's first parsed,
                        // to ensure parsing isn't duplicated.
                        /** @type {?} */
                        var headerResponse = null;
                        // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
                        // state, and memoizes it into headerResponse.
                        /** @type {?} */
                        var partialFromXhr = ( /**
                         * @return {?}
                         */function () {
                            if (headerResponse !== null) {
                                return headerResponse;
                            }
                            // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
                            /** @type {?} */
                            var status = xhr.status === 1223 ? 204 : xhr.status;
                            /** @type {?} */
                            var statusText = xhr.statusText || 'OK';
                            // Parse headers from XMLHttpRequest - this step is lazy.
                            /** @type {?} */
                            var headers = new HttpHeaders(xhr.getAllResponseHeaders());
                            // Read the response URL from the XMLHttpResponse instance and fall back on the
                            // request URL.
                            /** @type {?} */
                            var url = getResponseUrl(xhr) || req.url;
                            // Construct the HttpHeaderResponse and memoize it.
                            headerResponse = new HttpHeaderResponse({ headers: headers, status: status, statusText: statusText, url: url });
                            return headerResponse;
                        });
                        // Next, a few closures are defined for the various events which XMLHttpRequest can
                        // emit. This allows them to be unregistered as event listeners later.
                        // First up is the load event, which represents a response being fully available.
                        /** @type {?} */
                        var onLoad = ( /**
                         * @return {?}
                         */function () {
                            // Read response state from the memoized partial data.
                            var _c = partialFromXhr(), headers = _c.headers, status = _c.status, statusText = _c.statusText, url = _c.url;
                            // The body will be read out if present.
                            /** @type {?} */
                            var body = null;
                            if (status !== 204) {
                                // Use XMLHttpRequest.response if set, responseText otherwise.
                                body = (typeof xhr.response === 'undefined') ? xhr.responseText : xhr.response;
                            }
                            // Normalize another potential bug (this one comes from CORS).
                            if (status === 0) {
                                status = !!body ? 200 : 0;
                            }
                            // ok determines whether the response will be transmitted on the event or
                            // error channel. Unsuccessful status codes (not 2xx) will always be errors,
                            // but a successful status code can still result in an error if the user
                            // asked for JSON data and the body cannot be parsed as such.
                            /** @type {?} */
                            var ok = status >= 200 && status < 300;
                            // Check whether the body needs to be parsed as JSON (in many cases the browser
                            // will have done that already).
                            if (req.responseType === 'json' && typeof body === 'string') {
                                // Save the original body, before attempting XSSI prefix stripping.
                                /** @type {?} */
                                var originalBody = body;
                                body = body.replace(XSSI_PREFIX, '');
                                try {
                                    // Attempt the parse. If it fails, a parse error should be delivered to the user.
                                    body = body !== '' ? JSON.parse(body) : null;
                                }
                                catch (error) {
                                    // Since the JSON.parse failed, it's reasonable to assume this might not have been a
                                    // JSON response. Restore the original body (including any XSSI prefix) to deliver
                                    // a better error response.
                                    body = originalBody;
                                    // If this was an error request to begin with, leave it as a string, it probably
                                    // just isn't JSON. Otherwise, deliver the parsing error to the user.
                                    if (ok) {
                                        // Even though the response status was 2xx, this is still an error.
                                        ok = false;
                                        // The parse error contains the text of the body that failed to parse.
                                        body = ( /** @type {?} */({ error: error, text: body }));
                                    }
                                }
                            }
                            if (ok) {
                                // A successful response is delivered on the event stream.
                                observer.next(new HttpResponse({
                                    body: body,
                                    headers: headers,
                                    status: status,
                                    statusText: statusText,
                                    url: url || undefined,
                                }));
                                // The full body has been received and delivered, no further events
                                // are possible. This request is complete.
                                observer.complete();
                            }
                            else {
                                // An unsuccessful request is delivered on the error channel.
                                observer.error(new HttpErrorResponse({
                                    // The error in this case is the response body (error from the server).
                                    error: body,
                                    headers: headers,
                                    status: status,
                                    statusText: statusText,
                                    url: url || undefined,
                                }));
                            }
                        });
                        // The onError callback is called when something goes wrong at the network level.
                        // Connection timeout, DNS error, offline, etc. These are actual errors, and are
                        // transmitted on the error channel.
                        /** @type {?} */
                        var onError = ( /**
                         * @param {?} error
                         * @return {?}
                         */function (error) {
                            var url = partialFromXhr().url;
                            /** @type {?} */
                            var res = new HttpErrorResponse({
                                error: error,
                                status: xhr.status || 0,
                                statusText: xhr.statusText || 'Unknown Error',
                                url: url || undefined,
                            });
                            observer.error(res);
                        });
                        // The sentHeaders flag tracks whether the HttpResponseHeaders event
                        // has been sent on the stream. This is necessary to track if progress
                        // is enabled since the event will be sent on only the first download
                        // progerss event.
                        /** @type {?} */
                        var sentHeaders = false;
                        // The download progress event handler, which is only registered if
                        // progress events are enabled.
                        /** @type {?} */
                        var onDownProgress = ( /**
                         * @param {?} event
                         * @return {?}
                         */function (event) {
                            // Send the HttpResponseHeaders event if it hasn't been sent already.
                            if (!sentHeaders) {
                                observer.next(partialFromXhr());
                                sentHeaders = true;
                            }
                            // Start building the download progress event to deliver on the response
                            // event stream.
                            /** @type {?} */
                            var progressEvent = {
                                type: HttpEventType.DownloadProgress,
                                loaded: event.loaded,
                            };
                            // Set the total number of bytes in the event if it's available.
                            if (event.lengthComputable) {
                                progressEvent.total = event.total;
                            }
                            // If the request was for text content and a partial response is
                            // available on XMLHttpRequest, include it in the progress event
                            // to allow for streaming reads.
                            if (req.responseType === 'text' && !!xhr.responseText) {
                                progressEvent.partialText = xhr.responseText;
                            }
                            // Finally, fire the event.
                            observer.next(progressEvent);
                        });
                        // The upload progress event handler, which is only registered if
                        // progress events are enabled.
                        /** @type {?} */
                        var onUpProgress = ( /**
                         * @param {?} event
                         * @return {?}
                         */function (event) {
                            // Upload progress events are simpler. Begin building the progress
                            // event.
                            /** @type {?} */
                            var progress = {
                                type: HttpEventType.UploadProgress,
                                loaded: event.loaded,
                            };
                            // If the total number of bytes being uploaded is available, include
                            // it.
                            if (event.lengthComputable) {
                                progress.total = event.total;
                            }
                            // Send the event.
                            observer.next(progress);
                        });
                        // By default, register for load and error events.
                        xhr.addEventListener('load', onLoad);
                        xhr.addEventListener('error', onError);
                        // Progress events are only enabled if requested.
                        if (req.reportProgress) {
                            // Download progress is always enabled if requested.
                            xhr.addEventListener('progress', onDownProgress);
                            // Upload progress depends on whether there is a body to upload.
                            if (reqBody !== null && xhr.upload) {
                                xhr.upload.addEventListener('progress', onUpProgress);
                            }
                        }
                        // Fire the request, and notify the event stream that it was fired.
                        xhr.send(( /** @type {?} */(reqBody)));
                        observer.next({ type: HttpEventType.Sent });
                        // This is the return from the Observable function, which is the
                        // request cancellation handler.
                        return ( /**
                         * @return {?}
                         */function () {
                            // On a cancellation, remove all registered event listeners.
                            xhr.removeEventListener('error', onError);
                            xhr.removeEventListener('load', onLoad);
                            if (req.reportProgress) {
                                xhr.removeEventListener('progress', onDownProgress);
                                if (reqBody !== null && xhr.upload) {
                                    xhr.upload.removeEventListener('progress', onUpProgress);
                                }
                            }
                            // Finally, abort the in-flight request.
                            xhr.abort();
                        });
                    }));
                };
                return HttpXhrBackend;
            }());
            HttpXhrBackend.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            HttpXhrBackend.ctorParameters = function () { return [
                { type: XhrFactory }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var XSRF_COOKIE_NAME = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('XSRF_COOKIE_NAME');
            /** @type {?} */
            var XSRF_HEADER_NAME = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('XSRF_HEADER_NAME');
            /**
             * Retrieves the current XSRF token to use with the next outgoing request.
             *
             * \@publicApi
             * @abstract
             */
            var HttpXsrfTokenExtractor = /** @class */ (function () {
                function HttpXsrfTokenExtractor() {
                }
                return HttpXsrfTokenExtractor;
            }());
            if (false) { }
            /**
             * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
             */
            var HttpXsrfCookieExtractor = /** @class */ (function () {
                /**
                 * @param {?} doc
                 * @param {?} platform
                 * @param {?} cookieName
                 */
                function HttpXsrfCookieExtractor(doc, platform, cookieName) {
                    this.doc = doc;
                    this.platform = platform;
                    this.cookieName = cookieName;
                    this.lastCookieString = '';
                    this.lastToken = null;
                    /**
                     * \@internal for testing
                     */
                    this.parseCount = 0;
                }
                /**
                 * @return {?}
                 */
                HttpXsrfCookieExtractor.prototype.getToken = function () {
                    if (this.platform === 'server') {
                        return null;
                    }
                    /** @type {?} */
                    var cookieString = this.doc.cookie || '';
                    if (cookieString !== this.lastCookieString) {
                        this.parseCount++;
                        this.lastToken = Object(_angular_common__WEBPACK_IMPORTED_MODULE_3__["ɵparseCookieValue"])(cookieString, this.cookieName);
                        this.lastCookieString = cookieString;
                    }
                    return this.lastToken;
                };
                return HttpXsrfCookieExtractor;
            }());
            HttpXsrfCookieExtractor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            HttpXsrfCookieExtractor.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_3__["DOCUMENT"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["PLATFORM_ID"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [XSRF_COOKIE_NAME,] }] }
            ]; };
            if (false) { }
            /**
             * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
             */
            var HttpXsrfInterceptor = /** @class */ (function () {
                /**
                 * @param {?} tokenService
                 * @param {?} headerName
                 */
                function HttpXsrfInterceptor(tokenService, headerName) {
                    this.tokenService = tokenService;
                    this.headerName = headerName;
                }
                /**
                 * @param {?} req
                 * @param {?} next
                 * @return {?}
                 */
                HttpXsrfInterceptor.prototype.intercept = function (req, next) {
                    /** @type {?} */
                    var lcUrl = req.url.toLowerCase();
                    // Skip both non-mutating requests and absolute URLs.
                    // Non-mutating requests don't require a token, and absolute URLs require special handling
                    // anyway as the cookie set
                    // on our origin is not the same as the token expected by another origin.
                    if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') ||
                        lcUrl.startsWith('https://')) {
                        return next.handle(req);
                    }
                    /** @type {?} */
                    var token = this.tokenService.getToken();
                    // Be careful not to overwrite an existing header of the same name.
                    if (token !== null && !req.headers.has(this.headerName)) {
                        req = req.clone({ headers: req.headers.set(this.headerName, token) });
                    }
                    return next.handle(req);
                };
                return HttpXsrfInterceptor;
            }());
            HttpXsrfInterceptor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            HttpXsrfInterceptor.ctorParameters = function () { return [
                { type: HttpXsrfTokenExtractor },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [XSRF_HEADER_NAME,] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An injectable `HttpHandler` that applies multiple interceptors
             * to a request before passing it to the given `HttpBackend`.
             *
             * The interceptors are loaded lazily from the injector, to allow
             * interceptors to themselves inject classes depending indirectly
             * on `HttpInterceptingHandler` itself.
             * @see `HttpInterceptor`
             */
            var HttpInterceptingHandler = /** @class */ (function () {
                /**
                 * @param {?} backend
                 * @param {?} injector
                 */
                function HttpInterceptingHandler(backend, injector) {
                    this.backend = backend;
                    this.injector = injector;
                    this.chain = null;
                }
                /**
                 * @param {?} req
                 * @return {?}
                 */
                HttpInterceptingHandler.prototype.handle = function (req) {
                    if (this.chain === null) {
                        /** @type {?} */
                        var interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
                        this.chain = interceptors.reduceRight(( /**
                         * @param {?} next
                         * @param {?} interceptor
                         * @return {?}
                         */function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }), this.backend);
                    }
                    return this.chain.handle(req);
                };
                return HttpInterceptingHandler;
            }());
            HttpInterceptingHandler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            HttpInterceptingHandler.ctorParameters = function () { return [
                { type: HttpBackend },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injector"] }
            ]; };
            if (false) { }
            /**
             * Constructs an `HttpHandler` that applies interceptors
             * to a request before passing it to the given `HttpBackend`.
             *
             * Use as a factory function within `HttpClientModule`.
             *
             *
             * @param {?} backend
             * @param {?=} interceptors
             * @return {?}
             */
            function interceptingHandler(backend, interceptors) {
                if (interceptors === void 0) { interceptors = []; }
                if (!interceptors) {
                    return backend;
                }
                return interceptors.reduceRight(( /**
                 * @param {?} next
                 * @param {?} interceptor
                 * @return {?}
                 */function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }), backend);
            }
            /**
             * Factory function that determines where to store JSONP callbacks.
             *
             * Ordinarily JSONP callbacks are stored on the `window` object, but this may not exist
             * in test environments. In that case, callbacks are stored on an anonymous object instead.
             *
             *
             * @return {?}
             */
            function jsonpCallbackContext() {
                if (typeof window === 'object') {
                    return window;
                }
                return {};
            }
            /**
             * Configures XSRF protection support for outgoing requests.
             *
             * For a server that supports a cookie-based XSRF protection system,
             * use directly to configure XSRF protection with the correct
             * cookie and header names.
             *
             * If no names are supplied, the default cookie name is `XSRF-TOKEN`
             * and the default header name is `X-XSRF-TOKEN`.
             *
             * \@publicApi
             */
            var HttpClientXsrfModule = /** @class */ (function () {
                function HttpClientXsrfModule() {
                }
                /**
                 * Disable the default XSRF protection.
                 * @return {?}
                 */
                HttpClientXsrfModule.disable = function () {
                    return {
                        ngModule: HttpClientXsrfModule,
                        providers: [
                            { provide: HttpXsrfInterceptor, useClass: NoopInterceptor },
                        ],
                    };
                };
                /**
                 * Configure XSRF protection.
                 * @param {?=} options An object that can specify either or both
                 * cookie name or header name.
                 * - Cookie name default is `XSRF-TOKEN`.
                 * - Header name default is `X-XSRF-TOKEN`.
                 *
                 * @return {?}
                 */
                HttpClientXsrfModule.withOptions = function (options) {
                    if (options === void 0) { options = {}; }
                    return {
                        ngModule: HttpClientXsrfModule,
                        providers: [
                            options.cookieName ? { provide: XSRF_COOKIE_NAME, useValue: options.cookieName } : [],
                            options.headerName ? { provide: XSRF_HEADER_NAME, useValue: options.headerName } : [],
                        ],
                    };
                };
                return HttpClientXsrfModule;
            }());
            HttpClientXsrfModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            providers: [
                                HttpXsrfInterceptor,
                                { provide: HTTP_INTERCEPTORS, useExisting: HttpXsrfInterceptor, multi: true },
                                { provide: HttpXsrfTokenExtractor, useClass: HttpXsrfCookieExtractor },
                                { provide: XSRF_COOKIE_NAME, useValue: 'XSRF-TOKEN' },
                                { provide: XSRF_HEADER_NAME, useValue: 'X-XSRF-TOKEN' },
                            ],
                        },] }
            ];
            /**
             * Configures the [dependency injector](guide/glossary#injector) for `HttpClient`
             * with supporting services for XSRF. Automatically imported by `HttpClientModule`.
             *
             * You can add interceptors to the chain behind `HttpClient` by binding them to the
             * multiprovider for built-in [DI token](guide/glossary#di-token) `HTTP_INTERCEPTORS`.
             *
             * \@publicApi
             */
            var HttpClientModule = /** @class */ (function () {
                function HttpClientModule() {
                }
                return HttpClientModule;
            }());
            HttpClientModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            /**
                             * Optional configuration for XSRF protection.
                             */
                            imports: [
                                HttpClientXsrfModule.withOptions({
                                    cookieName: 'XSRF-TOKEN',
                                    headerName: 'X-XSRF-TOKEN',
                                }),
                            ],
                            /**
                             * Configures the [dependency injector](guide/glossary#injector) where it is imported
                             * with supporting services for HTTP communications.
                             */
                            providers: [
                                HttpClient,
                                { provide: HttpHandler, useClass: HttpInterceptingHandler },
                                HttpXhrBackend,
                                { provide: HttpBackend, useExisting: HttpXhrBackend },
                                BrowserXhr,
                                { provide: XhrFactory, useExisting: BrowserXhr },
                            ],
                        },] }
            ];
            /**
             * Configures the [dependency injector](guide/glossary#injector) for `HttpClient`
             * with supporting services for JSONP.
             * Without this module, Jsonp requests reach the backend
             * with method JSONP, where they are rejected.
             *
             * You can add interceptors to the chain behind `HttpClient` by binding them to the
             * multiprovider for built-in [DI token](guide/glossary#di-token) `HTTP_INTERCEPTORS`.
             *
             * \@publicApi
             */
            var HttpClientJsonpModule = /** @class */ (function () {
                function HttpClientJsonpModule() {
                }
                return HttpClientJsonpModule;
            }());
            HttpClientJsonpModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            providers: [
                                JsonpClientBackend,
                                { provide: JsonpCallbackContext, useFactory: jsonpCallbackContext },
                                { provide: HTTP_INTERCEPTORS, useClass: JsonpInterceptor, multi: true },
                            ],
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=http.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/compiler/fesm2015/compiler.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/@angular/compiler/fesm2015/compiler.js ***!
          \*************************************************************/
        /*! exports provided: core, CompilerConfig, preserveWhitespacesDefault, isLoweredSymbol, createLoweredSymbol, Identifiers, JitCompiler, ConstantPool, DirectiveResolver, PipeResolver, NgModuleResolver, DEFAULT_INTERPOLATION_CONFIG, InterpolationConfig, NgModuleCompiler, ArrayType, AssertNotNull, DYNAMIC_TYPE, BinaryOperator, BinaryOperatorExpr, BuiltinMethod, BuiltinType, BuiltinTypeName, BuiltinVar, CastExpr, ClassField, ClassMethod, ClassStmt, CommaExpr, CommentStmt, ConditionalExpr, DeclareFunctionStmt, DeclareVarStmt, Expression, ExpressionStatement, ExpressionType, ExternalExpr, ExternalReference, literalMap, FunctionExpr, IfStmt, InstantiateExpr, InvokeFunctionExpr, InvokeMethodExpr, JSDocCommentStmt, LiteralArrayExpr, LiteralExpr, LiteralMapExpr, MapType, NotExpr, ReadKeyExpr, ReadPropExpr, ReadVarExpr, ReturnStatement, ThrowStmt, TryCatchStmt, Type, WrappedNodeExpr, WriteKeyExpr, WritePropExpr, WriteVarExpr, StmtModifier, Statement, STRING_TYPE, TypeofExpr, collectExternalReferences, EmitterVisitorContext, JitEvaluator, ViewCompiler, findStaticQueryIds, staticViewQueryIds, getParseErrors, isSyntaxError, syntaxError, Version, TmplAstBoundAttribute, TmplAstBoundEvent, TmplAstBoundText, TmplAstContent, TmplAstElement, TmplAstRecursiveVisitor, TmplAstReference, TmplAstTemplate, TmplAstText, TmplAstTextAttribute, TmplAstVariable, R3Identifiers, R3ResolvedDependencyType, compileInjector, compileNgModule, compilePipeFromMetadata, makeBindingParser, parseTemplate, compileBaseDefFromMetadata, compileComponentFromMetadata, compileDirectiveFromMetadata, parseHostBindings, verifyHostBindings, publishFacade, VERSION, TextAst, BoundTextAst, AttrAst, BoundElementPropertyAst, BoundEventAst, ReferenceAst, VariableAst, ElementAst, EmbeddedTemplateAst, BoundDirectivePropertyAst, DirectiveAst, ProviderAst, ProviderAstType, NgContentAst, NullTemplateVisitor, RecursiveTemplateAstVisitor, templateVisitAll, sanitizeIdentifier, identifierName, identifierModuleUrl, viewClassName, rendererTypeName, hostViewClassName, componentFactoryName, CompileSummaryKind, tokenName, tokenReference, CompileStylesheetMetadata, CompileTemplateMetadata, CompileDirectiveMetadata, CompilePipeMetadata, CompileShallowModuleMetadata, CompileNgModuleMetadata, TransitiveCompileNgModuleMetadata, ProviderMeta, flatten, templateSourceUrl, sharedStylesheetJitUrl, ngModuleJitUrl, templateJitUrl, createAotUrlResolver, createAotCompiler, AotCompiler, analyzeNgModules, analyzeAndValidateNgModules, analyzeFile, analyzeFileForInjectables, mergeAnalyzedFiles, GeneratedFile, toTypeScript, formattedError, isFormattedError, StaticReflector, StaticSymbol, StaticSymbolCache, ResolvedStaticSymbol, StaticSymbolResolver, unescapeIdentifier, unwrapResolvedMetadata, AotSummaryResolver, AstPath, SummaryResolver, JitSummaryResolver, CompileReflector, createUrlResolverWithoutPackagePrefix, createOfflineCompileUrlResolver, UrlResolver, getUrlScheme, ResourceLoader, ElementSchemaRegistry, Extractor, I18NHtmlParser, MessageBundle, Serializer, Xliff, Xliff2, Xmb, Xtb, DirectiveNormalizer, ParserError, ParseSpan, AST, Quote, EmptyExpr, ImplicitReceiver, Chain, Conditional, PropertyRead, PropertyWrite, SafePropertyRead, KeyedRead, KeyedWrite, BindingPipe, LiteralPrimitive, LiteralArray, LiteralMap, Interpolation, Binary, PrefixNot, NonNullAssert, MethodCall, SafeMethodCall, FunctionCall, AbsoluteSourceSpan, ASTWithSource, TemplateBinding, NullAstVisitor, RecursiveAstVisitor, AstTransformer, AstMemoryEfficientTransformer, visitAstChildren, ParsedProperty, ParsedPropertyType, ParsedEvent, ParsedVariable, BoundElementProperty, TokenType, Lexer, Token, EOF, isIdentifier, isQuote, SplitInterpolation, TemplateBindingParseResult, Parser, _ParseAST, ERROR_COMPONENT_TYPE, CompileMetadataResolver, Text, Expansion, ExpansionCase, Attribute, Element, Comment, visitAll, RecursiveVisitor, findNode, HtmlParser, ParseTreeResult, TreeError, HtmlTagDefinition, getHtmlTagDefinition, TagContentType, splitNsName, isNgContainer, isNgContent, isNgTemplate, getNsPrefix, mergeNsAndName, NAMED_ENTITIES, NGSP_UNICODE, debugOutputAstAsTypeScript, TypeScriptEmitter, ParseLocation, ParseSourceFile, ParseSourceSpan, EMPTY_PARSE_LOCATION, EMPTY_SOURCE_SPAN, ParseErrorLevel, ParseError, typeSourceSpan, r3JitTypeSourceSpan, DomElementSchemaRegistry, CssSelector, SelectorMatcher, SelectorListContext, SelectorContext, HOST_ATTR, CONTENT_ATTR, StylesCompileDependency, CompiledStylesheet, StyleCompiler, TemplateParseError, TemplateParseResult, TemplateParser, splitClasses, createElementCssSelector, removeSummaryDuplicates, isEmptyExpression, compileInjectable, R3TargetBinder, R3BoundTarget */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var _c;
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "core", function () { return core; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompilerConfig", function () { return CompilerConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preserveWhitespacesDefault", function () { return preserveWhitespacesDefault; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoweredSymbol", function () { return isLoweredSymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLoweredSymbol", function () { return createLoweredSymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Identifiers", function () { return Identifiers; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JitCompiler", function () { return JitCompiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstantPool", function () { return ConstantPool; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectiveResolver", function () { return DirectiveResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PipeResolver", function () { return PipeResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleResolver", function () { return NgModuleResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_INTERPOLATION_CONFIG", function () { return DEFAULT_INTERPOLATION_CONFIG; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterpolationConfig", function () { return InterpolationConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleCompiler", function () { return NgModuleCompiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayType", function () { return ArrayType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssertNotNull", function () { return AssertNotNull; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DYNAMIC_TYPE", function () { return DYNAMIC_TYPE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BinaryOperator", function () { return BinaryOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BinaryOperatorExpr", function () { return BinaryOperatorExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltinMethod", function () { return BuiltinMethod; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltinType", function () { return BuiltinType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltinTypeName", function () { return BuiltinTypeName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltinVar", function () { return BuiltinVar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CastExpr", function () { return CastExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassField", function () { return ClassField; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassMethod", function () { return ClassMethod; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassStmt", function () { return ClassStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommaExpr", function () { return CommaExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommentStmt", function () { return CommentStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionalExpr", function () { return ConditionalExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeclareFunctionStmt", function () { return DeclareFunctionStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeclareVarStmt", function () { return DeclareVarStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Expression", function () { return Expression; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionStatement", function () { return ExpressionStatement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionType", function () { return ExpressionType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExternalExpr", function () { return ExternalExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExternalReference", function () { return ExternalReference; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "literalMap", function () { return literalMap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionExpr", function () { return FunctionExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IfStmt", function () { return IfStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InstantiateExpr", function () { return InstantiateExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvokeFunctionExpr", function () { return InvokeFunctionExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvokeMethodExpr", function () { return InvokeMethodExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JSDocCommentStmt", function () { return JSDocCommentStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralArrayExpr", function () { return LiteralArrayExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralExpr", function () { return LiteralExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralMapExpr", function () { return LiteralMapExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MapType", function () { return MapType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotExpr", function () { return NotExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadKeyExpr", function () { return ReadKeyExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadPropExpr", function () { return ReadPropExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadVarExpr", function () { return ReadVarExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReturnStatement", function () { return ReturnStatement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThrowStmt", function () { return ThrowStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatchStmt", function () { return TryCatchStmt; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Type", function () { return Type$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WrappedNodeExpr", function () { return WrappedNodeExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteKeyExpr", function () { return WriteKeyExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WritePropExpr", function () { return WritePropExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteVarExpr", function () { return WriteVarExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StmtModifier", function () { return StmtModifier; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Statement", function () { return Statement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRING_TYPE", function () { return STRING_TYPE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TypeofExpr", function () { return TypeofExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "collectExternalReferences", function () { return collectExternalReferences; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmitterVisitorContext", function () { return EmitterVisitorContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JitEvaluator", function () { return JitEvaluator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewCompiler", function () { return ViewCompiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findStaticQueryIds", function () { return findStaticQueryIds; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticViewQueryIds", function () { return staticViewQueryIds; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getParseErrors", function () { return getParseErrors; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSyntaxError", function () { return isSyntaxError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "syntaxError", function () { return syntaxError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Version", function () { return Version; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstBoundAttribute", function () { return BoundAttribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstBoundEvent", function () { return BoundEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstBoundText", function () { return BoundText; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstContent", function () { return Content; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstElement", function () { return Element; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstRecursiveVisitor", function () { return RecursiveVisitor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstReference", function () { return Reference; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstTemplate", function () { return Template; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstText", function () { return Text; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstTextAttribute", function () { return TextAttribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TmplAstVariable", function () { return Variable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R3Identifiers", function () { return Identifiers$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R3ResolvedDependencyType", function () { return R3ResolvedDependencyType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compileInjector", function () { return compileInjector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compileNgModule", function () { return compileNgModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compilePipeFromMetadata", function () { return compilePipeFromMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeBindingParser", function () { return makeBindingParser; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseTemplate", function () { return parseTemplate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compileBaseDefFromMetadata", function () { return compileBaseDefFromMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compileComponentFromMetadata", function () { return compileComponentFromMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compileDirectiveFromMetadata", function () { return compileDirectiveFromMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseHostBindings", function () { return parseHostBindings; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "verifyHostBindings", function () { return verifyHostBindings; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishFacade", function () { return publishFacade; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextAst", function () { return TextAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundTextAst", function () { return BoundTextAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AttrAst", function () { return AttrAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundElementPropertyAst", function () { return BoundElementPropertyAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundEventAst", function () { return BoundEventAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceAst", function () { return ReferenceAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableAst", function () { return VariableAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementAst", function () { return ElementAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmbeddedTemplateAst", function () { return EmbeddedTemplateAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundDirectivePropertyAst", function () { return BoundDirectivePropertyAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectiveAst", function () { return DirectiveAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProviderAst", function () { return ProviderAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProviderAstType", function () { return ProviderAstType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgContentAst", function () { return NgContentAst; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NullTemplateVisitor", function () { return NullTemplateVisitor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecursiveTemplateAstVisitor", function () { return RecursiveTemplateAstVisitor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templateVisitAll", function () { return templateVisitAll; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sanitizeIdentifier", function () { return sanitizeIdentifier; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identifierName", function () { return identifierName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identifierModuleUrl", function () { return identifierModuleUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viewClassName", function () { return viewClassName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rendererTypeName", function () { return rendererTypeName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hostViewClassName", function () { return hostViewClassName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFactoryName", function () { return componentFactoryName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileSummaryKind", function () { return CompileSummaryKind; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tokenName", function () { return tokenName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tokenReference", function () { return tokenReference; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileStylesheetMetadata", function () { return CompileStylesheetMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileTemplateMetadata", function () { return CompileTemplateMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileDirectiveMetadata", function () { return CompileDirectiveMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompilePipeMetadata", function () { return CompilePipeMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileShallowModuleMetadata", function () { return CompileShallowModuleMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileNgModuleMetadata", function () { return CompileNgModuleMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransitiveCompileNgModuleMetadata", function () { return TransitiveCompileNgModuleMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProviderMeta", function () { return ProviderMeta; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function () { return flatten; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templateSourceUrl", function () { return templateSourceUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharedStylesheetJitUrl", function () { return sharedStylesheetJitUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ngModuleJitUrl", function () { return ngModuleJitUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templateJitUrl", function () { return templateJitUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAotUrlResolver", function () { return createAotUrlResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAotCompiler", function () { return createAotCompiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AotCompiler", function () { return AotCompiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analyzeNgModules", function () { return analyzeNgModules; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analyzeAndValidateNgModules", function () { return analyzeAndValidateNgModules; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analyzeFile", function () { return analyzeFile; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analyzeFileForInjectables", function () { return analyzeFileForInjectables; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeAnalyzedFiles", function () { return mergeAnalyzedFiles; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GeneratedFile", function () { return GeneratedFile; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toTypeScript", function () { return toTypeScript; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formattedError", function () { return formattedError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFormattedError", function () { return isFormattedError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StaticReflector", function () { return StaticReflector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StaticSymbol", function () { return StaticSymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StaticSymbolCache", function () { return StaticSymbolCache; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolvedStaticSymbol", function () { return ResolvedStaticSymbol; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StaticSymbolResolver", function () { return StaticSymbolResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unescapeIdentifier", function () { return unescapeIdentifier; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unwrapResolvedMetadata", function () { return unwrapResolvedMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AotSummaryResolver", function () { return AotSummaryResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AstPath", function () { return AstPath; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SummaryResolver", function () { return SummaryResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JitSummaryResolver", function () { return JitSummaryResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileReflector", function () { return CompileReflector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUrlResolverWithoutPackagePrefix", function () { return createUrlResolverWithoutPackagePrefix; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOfflineCompileUrlResolver", function () { return createOfflineCompileUrlResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlResolver", function () { return UrlResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlScheme", function () { return getUrlScheme; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceLoader", function () { return ResourceLoader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSchemaRegistry", function () { return ElementSchemaRegistry; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Extractor", function () { return Extractor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18NHtmlParser", function () { return I18NHtmlParser; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessageBundle", function () { return MessageBundle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Serializer", function () { return Serializer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Xliff", function () { return Xliff; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Xliff2", function () { return Xliff2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Xmb", function () { return Xmb; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Xtb", function () { return Xtb; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectiveNormalizer", function () { return DirectiveNormalizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParserError", function () { return ParserError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseSpan", function () { return ParseSpan; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AST", function () { return AST; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Quote", function () { return Quote; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyExpr", function () { return EmptyExpr; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImplicitReceiver", function () { return ImplicitReceiver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Chain", function () { return Chain; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Conditional", function () { return Conditional; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropertyRead", function () { return PropertyRead; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropertyWrite", function () { return PropertyWrite; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SafePropertyRead", function () { return SafePropertyRead; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyedRead", function () { return KeyedRead; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyedWrite", function () { return KeyedWrite; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BindingPipe", function () { return BindingPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralPrimitive", function () { return LiteralPrimitive; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralArray", function () { return LiteralArray; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralMap", function () { return LiteralMap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Interpolation", function () { return Interpolation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Binary", function () { return Binary; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrefixNot", function () { return PrefixNot; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NonNullAssert", function () { return NonNullAssert; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MethodCall", function () { return MethodCall; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SafeMethodCall", function () { return SafeMethodCall; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionCall", function () { return FunctionCall; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbsoluteSourceSpan", function () { return AbsoluteSourceSpan; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASTWithSource", function () { return ASTWithSource; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateBinding", function () { return TemplateBinding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NullAstVisitor", function () { return NullAstVisitor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecursiveAstVisitor", function () { return RecursiveAstVisitor$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AstTransformer", function () { return AstTransformer$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AstMemoryEfficientTransformer", function () { return AstMemoryEfficientTransformer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visitAstChildren", function () { return visitAstChildren; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsedProperty", function () { return ParsedProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsedPropertyType", function () { return ParsedPropertyType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsedEvent", function () { return ParsedEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsedVariable", function () { return ParsedVariable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundElementProperty", function () { return BoundElementProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TokenType", function () { return TokenType$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lexer", function () { return Lexer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Token", function () { return Token$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EOF", function () { return EOF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIdentifier", function () { return isIdentifier; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isQuote", function () { return isQuote; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SplitInterpolation", function () { return SplitInterpolation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateBindingParseResult", function () { return TemplateBindingParseResult; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Parser", function () { return Parser$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_ParseAST", function () { return _ParseAST; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_COMPONENT_TYPE", function () { return ERROR_COMPONENT_TYPE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompileMetadataResolver", function () { return CompileMetadataResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function () { return Text$3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Expansion", function () { return Expansion; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpansionCase", function () { return ExpansionCase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Attribute", function () { return Attribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Element", function () { return Element$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Comment", function () { return Comment; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visitAll", function () { return visitAll$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecursiveVisitor", function () { return RecursiveVisitor$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findNode", function () { return findNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HtmlParser", function () { return HtmlParser; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseTreeResult", function () { return ParseTreeResult; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TreeError", function () { return TreeError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HtmlTagDefinition", function () { return HtmlTagDefinition; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHtmlTagDefinition", function () { return getHtmlTagDefinition; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TagContentType", function () { return TagContentType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitNsName", function () { return splitNsName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNgContainer", function () { return isNgContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNgContent", function () { return isNgContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNgTemplate", function () { return isNgTemplate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNsPrefix", function () { return getNsPrefix; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeNsAndName", function () { return mergeNsAndName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAMED_ENTITIES", function () { return NAMED_ENTITIES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NGSP_UNICODE", function () { return NGSP_UNICODE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debugOutputAstAsTypeScript", function () { return debugOutputAstAsTypeScript; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TypeScriptEmitter", function () { return TypeScriptEmitter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseLocation", function () { return ParseLocation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseSourceFile", function () { return ParseSourceFile; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseSourceSpan", function () { return ParseSourceSpan; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY_PARSE_LOCATION", function () { return EMPTY_PARSE_LOCATION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY_SOURCE_SPAN", function () { return EMPTY_SOURCE_SPAN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseErrorLevel", function () { return ParseErrorLevel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseError", function () { return ParseError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeSourceSpan", function () { return typeSourceSpan; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r3JitTypeSourceSpan", function () { return r3JitTypeSourceSpan; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomElementSchemaRegistry", function () { return DomElementSchemaRegistry; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CssSelector", function () { return CssSelector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectorMatcher", function () { return SelectorMatcher; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectorListContext", function () { return SelectorListContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectorContext", function () { return SelectorContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOST_ATTR", function () { return HOST_ATTR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTENT_ATTR", function () { return CONTENT_ATTR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StylesCompileDependency", function () { return StylesCompileDependency; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompiledStylesheet", function () { return CompiledStylesheet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleCompiler", function () { return StyleCompiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateParseError", function () { return TemplateParseError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateParseResult", function () { return TemplateParseResult; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateParser", function () { return TemplateParser; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitClasses", function () { return splitClasses; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementCssSelector", function () { return createElementCssSelector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSummaryDuplicates", function () { return removeSummaryDuplicates; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyExpression", function () { return isEmptyExpression; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compileInjectable", function () { return compileInjectable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R3TargetBinder", function () { return R3TargetBinder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R3BoundTarget", function () { return R3BoundTarget; });
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TagContentType;
            (function (TagContentType) {
                TagContentType[TagContentType["RAW_TEXT"] = 0] = "RAW_TEXT";
                TagContentType[TagContentType["ESCAPABLE_RAW_TEXT"] = 1] = "ESCAPABLE_RAW_TEXT";
                TagContentType[TagContentType["PARSABLE_DATA"] = 2] = "PARSABLE_DATA";
            })(TagContentType || (TagContentType = {}));
            function splitNsName(elementName) {
                if (elementName[0] != ':') {
                    return [null, elementName];
                }
                var colonIndex = elementName.indexOf(':', 1);
                if (colonIndex == -1) {
                    throw new Error("Unsupported format \"" + elementName + "\" expecting \":namespace:name\"");
                }
                return [elementName.slice(1, colonIndex), elementName.slice(colonIndex + 1)];
            }
            // `<ng-container>` tags work the same regardless the namespace
            function isNgContainer(tagName) {
                return splitNsName(tagName)[1] === 'ng-container';
            }
            // `<ng-content>` tags work the same regardless the namespace
            function isNgContent(tagName) {
                return splitNsName(tagName)[1] === 'ng-content';
            }
            // `<ng-template>` tags work the same regardless the namespace
            function isNgTemplate(tagName) {
                return splitNsName(tagName)[1] === 'ng-template';
            }
            function getNsPrefix(fullName) {
                return fullName === null ? null : splitNsName(fullName)[0];
            }
            function mergeNsAndName(prefix, localName) {
                return prefix ? ":" + prefix + ":" + localName : localName;
            }
            // see http://www.w3.org/TR/html51/syntax.html#named-character-references
            // see https://html.spec.whatwg.org/multipage/entities.json
            // This list is not exhaustive to keep the compiler footprint low.
            // The `&#123;` / `&#x1ab;` syntax should be used when the named character reference does not
            // exist.
            var NAMED_ENTITIES = {
                'Aacute': '\u00C1',
                'aacute': '\u00E1',
                'Acirc': '\u00C2',
                'acirc': '\u00E2',
                'acute': '\u00B4',
                'AElig': '\u00C6',
                'aelig': '\u00E6',
                'Agrave': '\u00C0',
                'agrave': '\u00E0',
                'alefsym': '\u2135',
                'Alpha': '\u0391',
                'alpha': '\u03B1',
                'amp': '&',
                'and': '\u2227',
                'ang': '\u2220',
                'apos': '\u0027',
                'Aring': '\u00C5',
                'aring': '\u00E5',
                'asymp': '\u2248',
                'Atilde': '\u00C3',
                'atilde': '\u00E3',
                'Auml': '\u00C4',
                'auml': '\u00E4',
                'bdquo': '\u201E',
                'Beta': '\u0392',
                'beta': '\u03B2',
                'brvbar': '\u00A6',
                'bull': '\u2022',
                'cap': '\u2229',
                'Ccedil': '\u00C7',
                'ccedil': '\u00E7',
                'cedil': '\u00B8',
                'cent': '\u00A2',
                'Chi': '\u03A7',
                'chi': '\u03C7',
                'circ': '\u02C6',
                'clubs': '\u2663',
                'cong': '\u2245',
                'copy': '\u00A9',
                'crarr': '\u21B5',
                'cup': '\u222A',
                'curren': '\u00A4',
                'dagger': '\u2020',
                'Dagger': '\u2021',
                'darr': '\u2193',
                'dArr': '\u21D3',
                'deg': '\u00B0',
                'Delta': '\u0394',
                'delta': '\u03B4',
                'diams': '\u2666',
                'divide': '\u00F7',
                'Eacute': '\u00C9',
                'eacute': '\u00E9',
                'Ecirc': '\u00CA',
                'ecirc': '\u00EA',
                'Egrave': '\u00C8',
                'egrave': '\u00E8',
                'empty': '\u2205',
                'emsp': '\u2003',
                'ensp': '\u2002',
                'Epsilon': '\u0395',
                'epsilon': '\u03B5',
                'equiv': '\u2261',
                'Eta': '\u0397',
                'eta': '\u03B7',
                'ETH': '\u00D0',
                'eth': '\u00F0',
                'Euml': '\u00CB',
                'euml': '\u00EB',
                'euro': '\u20AC',
                'exist': '\u2203',
                'fnof': '\u0192',
                'forall': '\u2200',
                'frac12': '\u00BD',
                'frac14': '\u00BC',
                'frac34': '\u00BE',
                'frasl': '\u2044',
                'Gamma': '\u0393',
                'gamma': '\u03B3',
                'ge': '\u2265',
                'gt': '>',
                'harr': '\u2194',
                'hArr': '\u21D4',
                'hearts': '\u2665',
                'hellip': '\u2026',
                'Iacute': '\u00CD',
                'iacute': '\u00ED',
                'Icirc': '\u00CE',
                'icirc': '\u00EE',
                'iexcl': '\u00A1',
                'Igrave': '\u00CC',
                'igrave': '\u00EC',
                'image': '\u2111',
                'infin': '\u221E',
                'int': '\u222B',
                'Iota': '\u0399',
                'iota': '\u03B9',
                'iquest': '\u00BF',
                'isin': '\u2208',
                'Iuml': '\u00CF',
                'iuml': '\u00EF',
                'Kappa': '\u039A',
                'kappa': '\u03BA',
                'Lambda': '\u039B',
                'lambda': '\u03BB',
                'lang': '\u27E8',
                'laquo': '\u00AB',
                'larr': '\u2190',
                'lArr': '\u21D0',
                'lceil': '\u2308',
                'ldquo': '\u201C',
                'le': '\u2264',
                'lfloor': '\u230A',
                'lowast': '\u2217',
                'loz': '\u25CA',
                'lrm': '\u200E',
                'lsaquo': '\u2039',
                'lsquo': '\u2018',
                'lt': '<',
                'macr': '\u00AF',
                'mdash': '\u2014',
                'micro': '\u00B5',
                'middot': '\u00B7',
                'minus': '\u2212',
                'Mu': '\u039C',
                'mu': '\u03BC',
                'nabla': '\u2207',
                'nbsp': '\u00A0',
                'ndash': '\u2013',
                'ne': '\u2260',
                'ni': '\u220B',
                'not': '\u00AC',
                'notin': '\u2209',
                'nsub': '\u2284',
                'Ntilde': '\u00D1',
                'ntilde': '\u00F1',
                'Nu': '\u039D',
                'nu': '\u03BD',
                'Oacute': '\u00D3',
                'oacute': '\u00F3',
                'Ocirc': '\u00D4',
                'ocirc': '\u00F4',
                'OElig': '\u0152',
                'oelig': '\u0153',
                'Ograve': '\u00D2',
                'ograve': '\u00F2',
                'oline': '\u203E',
                'Omega': '\u03A9',
                'omega': '\u03C9',
                'Omicron': '\u039F',
                'omicron': '\u03BF',
                'oplus': '\u2295',
                'or': '\u2228',
                'ordf': '\u00AA',
                'ordm': '\u00BA',
                'Oslash': '\u00D8',
                'oslash': '\u00F8',
                'Otilde': '\u00D5',
                'otilde': '\u00F5',
                'otimes': '\u2297',
                'Ouml': '\u00D6',
                'ouml': '\u00F6',
                'para': '\u00B6',
                'permil': '\u2030',
                'perp': '\u22A5',
                'Phi': '\u03A6',
                'phi': '\u03C6',
                'Pi': '\u03A0',
                'pi': '\u03C0',
                'piv': '\u03D6',
                'plusmn': '\u00B1',
                'pound': '\u00A3',
                'prime': '\u2032',
                'Prime': '\u2033',
                'prod': '\u220F',
                'prop': '\u221D',
                'Psi': '\u03A8',
                'psi': '\u03C8',
                'quot': '\u0022',
                'radic': '\u221A',
                'rang': '\u27E9',
                'raquo': '\u00BB',
                'rarr': '\u2192',
                'rArr': '\u21D2',
                'rceil': '\u2309',
                'rdquo': '\u201D',
                'real': '\u211C',
                'reg': '\u00AE',
                'rfloor': '\u230B',
                'Rho': '\u03A1',
                'rho': '\u03C1',
                'rlm': '\u200F',
                'rsaquo': '\u203A',
                'rsquo': '\u2019',
                'sbquo': '\u201A',
                'Scaron': '\u0160',
                'scaron': '\u0161',
                'sdot': '\u22C5',
                'sect': '\u00A7',
                'shy': '\u00AD',
                'Sigma': '\u03A3',
                'sigma': '\u03C3',
                'sigmaf': '\u03C2',
                'sim': '\u223C',
                'spades': '\u2660',
                'sub': '\u2282',
                'sube': '\u2286',
                'sum': '\u2211',
                'sup': '\u2283',
                'sup1': '\u00B9',
                'sup2': '\u00B2',
                'sup3': '\u00B3',
                'supe': '\u2287',
                'szlig': '\u00DF',
                'Tau': '\u03A4',
                'tau': '\u03C4',
                'there4': '\u2234',
                'Theta': '\u0398',
                'theta': '\u03B8',
                'thetasym': '\u03D1',
                'thinsp': '\u2009',
                'THORN': '\u00DE',
                'thorn': '\u00FE',
                'tilde': '\u02DC',
                'times': '\u00D7',
                'trade': '\u2122',
                'Uacute': '\u00DA',
                'uacute': '\u00FA',
                'uarr': '\u2191',
                'uArr': '\u21D1',
                'Ucirc': '\u00DB',
                'ucirc': '\u00FB',
                'Ugrave': '\u00D9',
                'ugrave': '\u00F9',
                'uml': '\u00A8',
                'upsih': '\u03D2',
                'Upsilon': '\u03A5',
                'upsilon': '\u03C5',
                'Uuml': '\u00DC',
                'uuml': '\u00FC',
                'weierp': '\u2118',
                'Xi': '\u039E',
                'xi': '\u03BE',
                'Yacute': '\u00DD',
                'yacute': '\u00FD',
                'yen': '\u00A5',
                'yuml': '\u00FF',
                'Yuml': '\u0178',
                'Zeta': '\u0396',
                'zeta': '\u03B6',
                'zwj': '\u200D',
                'zwnj': '\u200C',
            };
            // The &ngsp; pseudo-entity is denoting a space. see:
            // https://github.com/dart-lang/angular/blob/0bb611387d29d65b5af7f9d2515ab571fd3fbee4/_tests/test/compiler/preserve_whitespace_test.dart
            var NGSP_UNICODE = '\uE500';
            NAMED_ENTITIES['ngsp'] = NGSP_UNICODE;
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var HtmlTagDefinition = /** @class */ (function () {
                function HtmlTagDefinition(_c) {
                    var _this = this;
                    var _d = _c === void 0 ? {} : _c, closedByChildren = _d.closedByChildren, implicitNamespacePrefix = _d.implicitNamespacePrefix, _e = _d.contentType, contentType = _e === void 0 ? TagContentType.PARSABLE_DATA : _e, _f = _d.closedByParent, closedByParent = _f === void 0 ? false : _f, _g = _d.isVoid, isVoid = _g === void 0 ? false : _g, _h = _d.ignoreFirstLf, ignoreFirstLf = _h === void 0 ? false : _h;
                    this.closedByChildren = {};
                    this.closedByParent = false;
                    this.canSelfClose = false;
                    if (closedByChildren && closedByChildren.length > 0) {
                        closedByChildren.forEach(function (tagName) { return _this.closedByChildren[tagName] = true; });
                    }
                    this.isVoid = isVoid;
                    this.closedByParent = closedByParent || isVoid;
                    this.implicitNamespacePrefix = implicitNamespacePrefix || null;
                    this.contentType = contentType;
                    this.ignoreFirstLf = ignoreFirstLf;
                }
                HtmlTagDefinition.prototype.isClosedByChild = function (name) {
                    return this.isVoid || name.toLowerCase() in this.closedByChildren;
                };
                return HtmlTagDefinition;
            }());
            var _DEFAULT_TAG_DEFINITION;
            // see http://www.w3.org/TR/html51/syntax.html#optional-tags
            // This implementation does not fully conform to the HTML5 spec.
            var TAG_DEFINITIONS;
            function getHtmlTagDefinition(tagName) {
                if (!TAG_DEFINITIONS) {
                    _DEFAULT_TAG_DEFINITION = new HtmlTagDefinition();
                    TAG_DEFINITIONS = {
                        'base': new HtmlTagDefinition({ isVoid: true }),
                        'meta': new HtmlTagDefinition({ isVoid: true }),
                        'area': new HtmlTagDefinition({ isVoid: true }),
                        'embed': new HtmlTagDefinition({ isVoid: true }),
                        'link': new HtmlTagDefinition({ isVoid: true }),
                        'img': new HtmlTagDefinition({ isVoid: true }),
                        'input': new HtmlTagDefinition({ isVoid: true }),
                        'param': new HtmlTagDefinition({ isVoid: true }),
                        'hr': new HtmlTagDefinition({ isVoid: true }),
                        'br': new HtmlTagDefinition({ isVoid: true }),
                        'source': new HtmlTagDefinition({ isVoid: true }),
                        'track': new HtmlTagDefinition({ isVoid: true }),
                        'wbr': new HtmlTagDefinition({ isVoid: true }),
                        'p': new HtmlTagDefinition({
                            closedByChildren: [
                                'address', 'article', 'aside', 'blockquote', 'div', 'dl', 'fieldset',
                                'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5',
                                'h6', 'header', 'hgroup', 'hr', 'main', 'nav', 'ol',
                                'p', 'pre', 'section', 'table', 'ul'
                            ],
                            closedByParent: true
                        }),
                        'thead': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'] }),
                        'tbody': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'], closedByParent: true }),
                        'tfoot': new HtmlTagDefinition({ closedByChildren: ['tbody'], closedByParent: true }),
                        'tr': new HtmlTagDefinition({ closedByChildren: ['tr'], closedByParent: true }),
                        'td': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
                        'th': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
                        'col': new HtmlTagDefinition({ isVoid: true }),
                        'svg': new HtmlTagDefinition({ implicitNamespacePrefix: 'svg' }),
                        'math': new HtmlTagDefinition({ implicitNamespacePrefix: 'math' }),
                        'li': new HtmlTagDefinition({ closedByChildren: ['li'], closedByParent: true }),
                        'dt': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'] }),
                        'dd': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'], closedByParent: true }),
                        'rb': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
                        'rt': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
                        'rtc': new HtmlTagDefinition({ closedByChildren: ['rb', 'rtc', 'rp'], closedByParent: true }),
                        'rp': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
                        'optgroup': new HtmlTagDefinition({ closedByChildren: ['optgroup'], closedByParent: true }),
                        'option': new HtmlTagDefinition({ closedByChildren: ['option', 'optgroup'], closedByParent: true }),
                        'pre': new HtmlTagDefinition({ ignoreFirstLf: true }),
                        'listing': new HtmlTagDefinition({ ignoreFirstLf: true }),
                        'style': new HtmlTagDefinition({ contentType: TagContentType.RAW_TEXT }),
                        'script': new HtmlTagDefinition({ contentType: TagContentType.RAW_TEXT }),
                        'title': new HtmlTagDefinition({ contentType: TagContentType.ESCAPABLE_RAW_TEXT }),
                        'textarea': new HtmlTagDefinition({ contentType: TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }),
                    };
                }
                return TAG_DEFINITIONS[tagName.toLowerCase()] || _DEFAULT_TAG_DEFINITION;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _SELECTOR_REGEXP = new RegExp('(\\:not\\()|' + //":not("
                '([-\\w]+)|' + // "tag"
                '(?:\\.([-\\w]+))|' + // ".class"
                // "-" should appear first in the regexp below as FF31 parses "[.-\w]" as a range
                '(?:\\[([-.\\w*]+)(?:=([\"\']?)([^\\]\"\']*)\\5)?\\])|' + // "[name]", "[name=value]",
                // "[name="value"]",
                // "[name='value']"
                '(\\))|' + // ")"
                '(\\s*,\\s*)', // ","
            'g');
            /**
             * A css selector contains an element name,
             * css classes and attribute/value pairs with the purpose
             * of selecting subsets out of them.
             */
            var CssSelector = /** @class */ (function () {
                function CssSelector() {
                    this.element = null;
                    this.classNames = [];
                    /**
                     * The selectors are encoded in pairs where:
                     * - even locations are attribute names
                     * - odd locations are attribute values.
                     *
                     * Example:
                     * Selector: `[key1=value1][key2]` would parse to:
                     * ```
                     * ['key1', 'value1', 'key2', '']
                     * ```
                     */
                    this.attrs = [];
                    this.notSelectors = [];
                }
                CssSelector.parse = function (selector) {
                    var results = [];
                    var _addResult = function (res, cssSel) {
                        if (cssSel.notSelectors.length > 0 && !cssSel.element && cssSel.classNames.length == 0 &&
                            cssSel.attrs.length == 0) {
                            cssSel.element = '*';
                        }
                        res.push(cssSel);
                    };
                    var cssSelector = new CssSelector();
                    var match;
                    var current = cssSelector;
                    var inNot = false;
                    _SELECTOR_REGEXP.lastIndex = 0;
                    while (match = _SELECTOR_REGEXP.exec(selector)) {
                        if (match[1]) {
                            if (inNot) {
                                throw new Error('Nesting :not is not allowed in a selector');
                            }
                            inNot = true;
                            current = new CssSelector();
                            cssSelector.notSelectors.push(current);
                        }
                        if (match[2]) {
                            current.setElement(match[2]);
                        }
                        if (match[3]) {
                            current.addClassName(match[3]);
                        }
                        if (match[4]) {
                            current.addAttribute(match[4], match[6]);
                        }
                        if (match[7]) {
                            inNot = false;
                            current = cssSelector;
                        }
                        if (match[8]) {
                            if (inNot) {
                                throw new Error('Multiple selectors in :not are not supported');
                            }
                            _addResult(results, cssSelector);
                            cssSelector = current = new CssSelector();
                        }
                    }
                    _addResult(results, cssSelector);
                    return results;
                };
                CssSelector.prototype.isElementSelector = function () {
                    return this.hasElementSelector() && this.classNames.length == 0 && this.attrs.length == 0 &&
                        this.notSelectors.length === 0;
                };
                CssSelector.prototype.hasElementSelector = function () { return !!this.element; };
                CssSelector.prototype.setElement = function (element) {
                    if (element === void 0) { element = null; }
                    this.element = element;
                };
                /** Gets a template string for an element that matches the selector. */
                CssSelector.prototype.getMatchingElementTemplate = function () {
                    var tagName = this.element || 'div';
                    var classAttr = this.classNames.length > 0 ? " class=\"" + this.classNames.join(' ') + "\"" : '';
                    var attrs = '';
                    for (var i = 0; i < this.attrs.length; i += 2) {
                        var attrName = this.attrs[i];
                        var attrValue = this.attrs[i + 1] !== '' ? "=\"" + this.attrs[i + 1] + "\"" : '';
                        attrs += " " + attrName + attrValue;
                    }
                    return getHtmlTagDefinition(tagName).isVoid ? "<" + tagName + classAttr + attrs + "/>" :
                        "<" + tagName + classAttr + attrs + "></" + tagName + ">";
                };
                CssSelector.prototype.getAttrs = function () {
                    var result = [];
                    if (this.classNames.length > 0) {
                        result.push('class', this.classNames.join(' '));
                    }
                    return result.concat(this.attrs);
                };
                CssSelector.prototype.addAttribute = function (name, value) {
                    if (value === void 0) { value = ''; }
                    this.attrs.push(name, value && value.toLowerCase() || '');
                };
                CssSelector.prototype.addClassName = function (name) { this.classNames.push(name.toLowerCase()); };
                CssSelector.prototype.toString = function () {
                    var res = this.element || '';
                    if (this.classNames) {
                        this.classNames.forEach(function (klass) { return res += "." + klass; });
                    }
                    if (this.attrs) {
                        for (var i = 0; i < this.attrs.length; i += 2) {
                            var name = this.attrs[i];
                            var value = this.attrs[i + 1];
                            res += "[" + name + (value ? '=' + value : '') + "]";
                        }
                    }
                    this.notSelectors.forEach(function (notSelector) { return res += ":not(" + notSelector + ")"; });
                    return res;
                };
                return CssSelector;
            }());
            /**
             * Reads a list of CssSelectors and allows to calculate which ones
             * are contained in a given CssSelector.
             */
            var SelectorMatcher = /** @class */ (function () {
                function SelectorMatcher() {
                    this._elementMap = new Map();
                    this._elementPartialMap = new Map();
                    this._classMap = new Map();
                    this._classPartialMap = new Map();
                    this._attrValueMap = new Map();
                    this._attrValuePartialMap = new Map();
                    this._listContexts = [];
                }
                SelectorMatcher.createNotMatcher = function (notSelectors) {
                    var notMatcher = new SelectorMatcher();
                    notMatcher.addSelectables(notSelectors, null);
                    return notMatcher;
                };
                SelectorMatcher.prototype.addSelectables = function (cssSelectors, callbackCtxt) {
                    var listContext = null;
                    if (cssSelectors.length > 1) {
                        listContext = new SelectorListContext(cssSelectors);
                        this._listContexts.push(listContext);
                    }
                    for (var i = 0; i < cssSelectors.length; i++) {
                        this._addSelectable(cssSelectors[i], callbackCtxt, listContext);
                    }
                };
                /**
                 * Add an object that can be found later on by calling `match`.
                 * @param cssSelector A css selector
                 * @param callbackCtxt An opaque object that will be given to the callback of the `match` function
                 */
                SelectorMatcher.prototype._addSelectable = function (cssSelector, callbackCtxt, listContext) {
                    var matcher = this;
                    var element = cssSelector.element;
                    var classNames = cssSelector.classNames;
                    var attrs = cssSelector.attrs;
                    var selectable = new SelectorContext(cssSelector, callbackCtxt, listContext);
                    if (element) {
                        var isTerminal = attrs.length === 0 && classNames.length === 0;
                        if (isTerminal) {
                            this._addTerminal(matcher._elementMap, element, selectable);
                        }
                        else {
                            matcher = this._addPartial(matcher._elementPartialMap, element);
                        }
                    }
                    if (classNames) {
                        for (var i = 0; i < classNames.length; i++) {
                            var isTerminal = attrs.length === 0 && i === classNames.length - 1;
                            var className = classNames[i];
                            if (isTerminal) {
                                this._addTerminal(matcher._classMap, className, selectable);
                            }
                            else {
                                matcher = this._addPartial(matcher._classPartialMap, className);
                            }
                        }
                    }
                    if (attrs) {
                        for (var i = 0; i < attrs.length; i += 2) {
                            var isTerminal = i === attrs.length - 2;
                            var name = attrs[i];
                            var value = attrs[i + 1];
                            if (isTerminal) {
                                var terminalMap = matcher._attrValueMap;
                                var terminalValuesMap = terminalMap.get(name);
                                if (!terminalValuesMap) {
                                    terminalValuesMap = new Map();
                                    terminalMap.set(name, terminalValuesMap);
                                }
                                this._addTerminal(terminalValuesMap, value, selectable);
                            }
                            else {
                                var partialMap = matcher._attrValuePartialMap;
                                var partialValuesMap = partialMap.get(name);
                                if (!partialValuesMap) {
                                    partialValuesMap = new Map();
                                    partialMap.set(name, partialValuesMap);
                                }
                                matcher = this._addPartial(partialValuesMap, value);
                            }
                        }
                    }
                };
                SelectorMatcher.prototype._addTerminal = function (map, name, selectable) {
                    var terminalList = map.get(name);
                    if (!terminalList) {
                        terminalList = [];
                        map.set(name, terminalList);
                    }
                    terminalList.push(selectable);
                };
                SelectorMatcher.prototype._addPartial = function (map, name) {
                    var matcher = map.get(name);
                    if (!matcher) {
                        matcher = new SelectorMatcher();
                        map.set(name, matcher);
                    }
                    return matcher;
                };
                /**
                 * Find the objects that have been added via `addSelectable`
                 * whose css selector is contained in the given css selector.
                 * @param cssSelector A css selector
                 * @param matchedCallback This callback will be called with the object handed into `addSelectable`
                 * @return boolean true if a match was found
                */
                SelectorMatcher.prototype.match = function (cssSelector, matchedCallback) {
                    var result = false;
                    var element = cssSelector.element;
                    var classNames = cssSelector.classNames;
                    var attrs = cssSelector.attrs;
                    for (var i = 0; i < this._listContexts.length; i++) {
                        this._listContexts[i].alreadyMatched = false;
                    }
                    result = this._matchTerminal(this._elementMap, element, cssSelector, matchedCallback) || result;
                    result = this._matchPartial(this._elementPartialMap, element, cssSelector, matchedCallback) ||
                        result;
                    if (classNames) {
                        for (var i = 0; i < classNames.length; i++) {
                            var className = classNames[i];
                            result =
                                this._matchTerminal(this._classMap, className, cssSelector, matchedCallback) || result;
                            result =
                                this._matchPartial(this._classPartialMap, className, cssSelector, matchedCallback) ||
                                    result;
                        }
                    }
                    if (attrs) {
                        for (var i = 0; i < attrs.length; i += 2) {
                            var name = attrs[i];
                            var value = attrs[i + 1];
                            var terminalValuesMap = this._attrValueMap.get(name);
                            if (value) {
                                result =
                                    this._matchTerminal(terminalValuesMap, '', cssSelector, matchedCallback) || result;
                            }
                            result =
                                this._matchTerminal(terminalValuesMap, value, cssSelector, matchedCallback) || result;
                            var partialValuesMap = this._attrValuePartialMap.get(name);
                            if (value) {
                                result = this._matchPartial(partialValuesMap, '', cssSelector, matchedCallback) || result;
                            }
                            result =
                                this._matchPartial(partialValuesMap, value, cssSelector, matchedCallback) || result;
                        }
                    }
                    return result;
                };
                /** @internal */
                SelectorMatcher.prototype._matchTerminal = function (map, name, cssSelector, matchedCallback) {
                    if (!map || typeof name !== 'string') {
                        return false;
                    }
                    var selectables = map.get(name) || [];
                    var starSelectables = map.get('*');
                    if (starSelectables) {
                        selectables = selectables.concat(starSelectables);
                    }
                    if (selectables.length === 0) {
                        return false;
                    }
                    var selectable;
                    var result = false;
                    for (var i = 0; i < selectables.length; i++) {
                        selectable = selectables[i];
                        result = selectable.finalize(cssSelector, matchedCallback) || result;
                    }
                    return result;
                };
                /** @internal */
                SelectorMatcher.prototype._matchPartial = function (map, name, cssSelector, matchedCallback) {
                    if (!map || typeof name !== 'string') {
                        return false;
                    }
                    var nestedSelector = map.get(name);
                    if (!nestedSelector) {
                        return false;
                    }
                    // TODO(perf): get rid of recursion and measure again
                    // TODO(perf): don't pass the whole selector into the recursion,
                    // but only the not processed parts
                    return nestedSelector.match(cssSelector, matchedCallback);
                };
                return SelectorMatcher;
            }());
            var SelectorListContext = /** @class */ (function () {
                function SelectorListContext(selectors) {
                    this.selectors = selectors;
                    this.alreadyMatched = false;
                }
                return SelectorListContext;
            }());
            // Store context to pass back selector and context when a selector is matched
            var SelectorContext = /** @class */ (function () {
                function SelectorContext(selector, cbContext, listContext) {
                    this.selector = selector;
                    this.cbContext = cbContext;
                    this.listContext = listContext;
                    this.notSelectors = selector.notSelectors;
                }
                SelectorContext.prototype.finalize = function (cssSelector, callback) {
                    var result = true;
                    if (this.notSelectors.length > 0 && (!this.listContext || !this.listContext.alreadyMatched)) {
                        var notMatcher = SelectorMatcher.createNotMatcher(this.notSelectors);
                        result = !notMatcher.match(cssSelector, null);
                    }
                    if (result && callback && (!this.listContext || !this.listContext.alreadyMatched)) {
                        if (this.listContext) {
                            this.listContext.alreadyMatched = true;
                        }
                        callback(this.selector, this.cbContext);
                    }
                    return result;
                };
                return SelectorContext;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var createInject = makeMetadataFactory('Inject', function (token) { return ({ token: token }); });
            var createInjectionToken = makeMetadataFactory('InjectionToken', function (desc) { return ({ _desc: desc, ngInjectableDef: undefined }); });
            var createAttribute = makeMetadataFactory('Attribute', function (attributeName) { return ({ attributeName: attributeName }); });
            var createContentChildren = makeMetadataFactory('ContentChildren', function (selector, data) {
                if (data === void 0) { data = {}; }
                return (Object.assign({ selector: selector, first: false, isViewQuery: false, descendants: false }, data));
            });
            var createContentChild = makeMetadataFactory('ContentChild', function (selector, data) {
                if (data === void 0) { data = {}; }
                return (Object.assign({ selector: selector, first: true, isViewQuery: false, descendants: true }, data));
            });
            var createViewChildren = makeMetadataFactory('ViewChildren', function (selector, data) {
                if (data === void 0) { data = {}; }
                return (Object.assign({ selector: selector, first: false, isViewQuery: true, descendants: true }, data));
            });
            var createViewChild = makeMetadataFactory('ViewChild', function (selector, data) { return (Object.assign({ selector: selector, first: true, isViewQuery: true, descendants: true }, data)); });
            var createDirective = makeMetadataFactory('Directive', function (dir) {
                if (dir === void 0) { dir = {}; }
                return dir;
            });
            var ViewEncapsulation;
            (function (ViewEncapsulation) {
                ViewEncapsulation[ViewEncapsulation["Emulated"] = 0] = "Emulated";
                ViewEncapsulation[ViewEncapsulation["Native"] = 1] = "Native";
                ViewEncapsulation[ViewEncapsulation["None"] = 2] = "None";
                ViewEncapsulation[ViewEncapsulation["ShadowDom"] = 3] = "ShadowDom";
            })(ViewEncapsulation || (ViewEncapsulation = {}));
            var ChangeDetectionStrategy;
            (function (ChangeDetectionStrategy) {
                ChangeDetectionStrategy[ChangeDetectionStrategy["OnPush"] = 0] = "OnPush";
                ChangeDetectionStrategy[ChangeDetectionStrategy["Default"] = 1] = "Default";
            })(ChangeDetectionStrategy || (ChangeDetectionStrategy = {}));
            var createComponent = makeMetadataFactory('Component', function (c) {
                if (c === void 0) { c = {}; }
                return (Object.assign({ changeDetection: ChangeDetectionStrategy.Default }, c));
            });
            var createPipe = makeMetadataFactory('Pipe', function (p) { return (Object.assign({ pure: true }, p)); });
            var createInput = makeMetadataFactory('Input', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
            var createOutput = makeMetadataFactory('Output', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
            var createHostBinding = makeMetadataFactory('HostBinding', function (hostPropertyName) { return ({ hostPropertyName: hostPropertyName }); });
            var createHostListener = makeMetadataFactory('HostListener', function (eventName, args) { return ({ eventName: eventName, args: args }); });
            var createNgModule = makeMetadataFactory('NgModule', function (ngModule) { return ngModule; });
            var createInjectable = makeMetadataFactory('Injectable', function (injectable) {
                if (injectable === void 0) { injectable = {}; }
                return injectable;
            });
            var CUSTOM_ELEMENTS_SCHEMA = {
                name: 'custom-elements'
            };
            var NO_ERRORS_SCHEMA = {
                name: 'no-errors-schema'
            };
            var createOptional = makeMetadataFactory('Optional');
            var createSelf = makeMetadataFactory('Self');
            var createSkipSelf = makeMetadataFactory('SkipSelf');
            var createHost = makeMetadataFactory('Host');
            var Type = Function;
            var SecurityContext;
            (function (SecurityContext) {
                SecurityContext[SecurityContext["NONE"] = 0] = "NONE";
                SecurityContext[SecurityContext["HTML"] = 1] = "HTML";
                SecurityContext[SecurityContext["STYLE"] = 2] = "STYLE";
                SecurityContext[SecurityContext["SCRIPT"] = 3] = "SCRIPT";
                SecurityContext[SecurityContext["URL"] = 4] = "URL";
                SecurityContext[SecurityContext["RESOURCE_URL"] = 5] = "RESOURCE_URL";
            })(SecurityContext || (SecurityContext = {}));
            var MissingTranslationStrategy;
            (function (MissingTranslationStrategy) {
                MissingTranslationStrategy[MissingTranslationStrategy["Error"] = 0] = "Error";
                MissingTranslationStrategy[MissingTranslationStrategy["Warning"] = 1] = "Warning";
                MissingTranslationStrategy[MissingTranslationStrategy["Ignore"] = 2] = "Ignore";
            })(MissingTranslationStrategy || (MissingTranslationStrategy = {}));
            function makeMetadataFactory(name, props) {
                // This must be declared as a function, not a fat arrow, so that ES2015 devmode produces code
                // that works with the static_reflector.ts in the ViewEngine compiler.
                // In particular, `_registerDecoratorOrConstructor` assumes that the value returned here can be
                // new'ed.
                function factory() {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    var values = props ? props.apply(void 0, args) : {};
                    return Object.assign({ ngMetadataName: name }, values);
                }
                factory.isTypeOf = function (obj) { return obj && obj.ngMetadataName === name; };
                factory.ngMetadataName = name;
                return factory;
            }
            function parserSelectorToSimpleSelector(selector) {
                var classes = selector.classNames && selector.classNames.length ? [8 /* CLASS */].concat(selector.classNames) :
                    [];
                var elementName = selector.element && selector.element !== '*' ? selector.element : '';
                return [elementName].concat(selector.attrs, classes);
            }
            function parserSelectorToNegativeSelector(selector) {
                var classes = selector.classNames && selector.classNames.length ? [8 /* CLASS */].concat(selector.classNames) :
                    [];
                if (selector.element) {
                    return [
                        1 /* NOT */ | 4 /* ELEMENT */, selector.element
                    ].concat(selector.attrs, classes);
                }
                else if (selector.attrs.length) {
                    return [1 /* NOT */ | 2 /* ATTRIBUTE */].concat(selector.attrs, classes);
                }
                else {
                    return selector.classNames && selector.classNames.length ? [1 /* NOT */ | 8 /* CLASS */].concat(selector.classNames) :
                        [];
                }
            }
            function parserSelectorToR3Selector(selector) {
                var positive = parserSelectorToSimpleSelector(selector);
                var negative = selector.notSelectors && selector.notSelectors.length ?
                    selector.notSelectors.map(function (notSelector) { return parserSelectorToNegativeSelector(notSelector); }) :
                    [];
                return positive.concat.apply(positive, negative);
            }
            function parseSelectorToR3Selector(selector) {
                return selector ? CssSelector.parse(selector).map(parserSelectorToR3Selector) : [];
            }
            var core = /*#__PURE__*/ Object.freeze({
                createInject: createInject,
                createInjectionToken: createInjectionToken,
                createAttribute: createAttribute,
                createContentChildren: createContentChildren,
                createContentChild: createContentChild,
                createViewChildren: createViewChildren,
                createViewChild: createViewChild,
                createDirective: createDirective,
                get ViewEncapsulation() { return ViewEncapsulation; },
                get ChangeDetectionStrategy() { return ChangeDetectionStrategy; },
                createComponent: createComponent,
                createPipe: createPipe,
                createInput: createInput,
                createOutput: createOutput,
                createHostBinding: createHostBinding,
                createHostListener: createHostListener,
                createNgModule: createNgModule,
                createInjectable: createInjectable,
                CUSTOM_ELEMENTS_SCHEMA: CUSTOM_ELEMENTS_SCHEMA,
                NO_ERRORS_SCHEMA: NO_ERRORS_SCHEMA,
                createOptional: createOptional,
                createSelf: createSelf,
                createSkipSelf: createSkipSelf,
                createHost: createHost,
                Type: Type,
                get SecurityContext() { return SecurityContext; },
                get MissingTranslationStrategy() { return MissingTranslationStrategy; },
                parseSelectorToR3Selector: parseSelectorToR3Selector
            });
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            //// Types
            var TypeModifier;
            (function (TypeModifier) {
                TypeModifier[TypeModifier["Const"] = 0] = "Const";
            })(TypeModifier || (TypeModifier = {}));
            var Type$1 = /** @class */ (function () {
                function Type$1(modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    this.modifiers = modifiers;
                    if (!modifiers) {
                        this.modifiers = [];
                    }
                }
                Type$1.prototype.hasModifier = function (modifier) { return this.modifiers.indexOf(modifier) !== -1; };
                return Type$1;
            }());
            var BuiltinTypeName;
            (function (BuiltinTypeName) {
                BuiltinTypeName[BuiltinTypeName["Dynamic"] = 0] = "Dynamic";
                BuiltinTypeName[BuiltinTypeName["Bool"] = 1] = "Bool";
                BuiltinTypeName[BuiltinTypeName["String"] = 2] = "String";
                BuiltinTypeName[BuiltinTypeName["Int"] = 3] = "Int";
                BuiltinTypeName[BuiltinTypeName["Number"] = 4] = "Number";
                BuiltinTypeName[BuiltinTypeName["Function"] = 5] = "Function";
                BuiltinTypeName[BuiltinTypeName["Inferred"] = 6] = "Inferred";
                BuiltinTypeName[BuiltinTypeName["None"] = 7] = "None";
            })(BuiltinTypeName || (BuiltinTypeName = {}));
            var BuiltinType = /** @class */ (function (_super_1) {
                __extends(BuiltinType, _super_1);
                function BuiltinType(name, modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, modifiers) || this;
                    _this.name = name;
                    return _this;
                }
                BuiltinType.prototype.visitType = function (visitor, context) {
                    return visitor.visitBuiltinType(this, context);
                };
                return BuiltinType;
            }(Type$1));
            var ExpressionType = /** @class */ (function (_super_1) {
                __extends(ExpressionType, _super_1);
                function ExpressionType(value, modifiers, typeParams) {
                    if (modifiers === void 0) { modifiers = null; }
                    if (typeParams === void 0) { typeParams = null; }
                    var _this = _super_1.call(this, modifiers) || this;
                    _this.value = value;
                    _this.typeParams = typeParams;
                    return _this;
                }
                ExpressionType.prototype.visitType = function (visitor, context) {
                    return visitor.visitExpressionType(this, context);
                };
                return ExpressionType;
            }(Type$1));
            var ArrayType = /** @class */ (function (_super_1) {
                __extends(ArrayType, _super_1);
                function ArrayType(of, modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, modifiers) || this;
                    _this.of = of;
                    return _this;
                }
                ArrayType.prototype.visitType = function (visitor, context) {
                    return visitor.visitArrayType(this, context);
                };
                return ArrayType;
            }(Type$1));
            var MapType = /** @class */ (function (_super_1) {
                __extends(MapType, _super_1);
                function MapType(valueType, modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, modifiers) || this;
                    _this.valueType = valueType || null;
                    return _this;
                }
                MapType.prototype.visitType = function (visitor, context) { return visitor.visitMapType(this, context); };
                return MapType;
            }(Type$1));
            var DYNAMIC_TYPE = new BuiltinType(BuiltinTypeName.Dynamic);
            var INFERRED_TYPE = new BuiltinType(BuiltinTypeName.Inferred);
            var BOOL_TYPE = new BuiltinType(BuiltinTypeName.Bool);
            var INT_TYPE = new BuiltinType(BuiltinTypeName.Int);
            var NUMBER_TYPE = new BuiltinType(BuiltinTypeName.Number);
            var STRING_TYPE = new BuiltinType(BuiltinTypeName.String);
            var FUNCTION_TYPE = new BuiltinType(BuiltinTypeName.Function);
            var NONE_TYPE = new BuiltinType(BuiltinTypeName.None);
            ///// Expressions
            var BinaryOperator;
            (function (BinaryOperator) {
                BinaryOperator[BinaryOperator["Equals"] = 0] = "Equals";
                BinaryOperator[BinaryOperator["NotEquals"] = 1] = "NotEquals";
                BinaryOperator[BinaryOperator["Identical"] = 2] = "Identical";
                BinaryOperator[BinaryOperator["NotIdentical"] = 3] = "NotIdentical";
                BinaryOperator[BinaryOperator["Minus"] = 4] = "Minus";
                BinaryOperator[BinaryOperator["Plus"] = 5] = "Plus";
                BinaryOperator[BinaryOperator["Divide"] = 6] = "Divide";
                BinaryOperator[BinaryOperator["Multiply"] = 7] = "Multiply";
                BinaryOperator[BinaryOperator["Modulo"] = 8] = "Modulo";
                BinaryOperator[BinaryOperator["And"] = 9] = "And";
                BinaryOperator[BinaryOperator["Or"] = 10] = "Or";
                BinaryOperator[BinaryOperator["BitwiseAnd"] = 11] = "BitwiseAnd";
                BinaryOperator[BinaryOperator["Lower"] = 12] = "Lower";
                BinaryOperator[BinaryOperator["LowerEquals"] = 13] = "LowerEquals";
                BinaryOperator[BinaryOperator["Bigger"] = 14] = "Bigger";
                BinaryOperator[BinaryOperator["BiggerEquals"] = 15] = "BiggerEquals";
            })(BinaryOperator || (BinaryOperator = {}));
            function nullSafeIsEquivalent(base, other) {
                if (base == null || other == null) {
                    return base == other;
                }
                return base.isEquivalent(other);
            }
            function areAllEquivalent(base, other) {
                var len = base.length;
                if (len !== other.length) {
                    return false;
                }
                for (var i = 0; i < len; i++) {
                    if (!base[i].isEquivalent(other[i])) {
                        return false;
                    }
                }
                return true;
            }
            var Expression = /** @class */ (function () {
                function Expression(type, sourceSpan) {
                    this.type = type || null;
                    this.sourceSpan = sourceSpan || null;
                }
                Expression.prototype.prop = function (name, sourceSpan) {
                    return new ReadPropExpr(this, name, null, sourceSpan);
                };
                Expression.prototype.key = function (index, type, sourceSpan) {
                    return new ReadKeyExpr(this, index, type, sourceSpan);
                };
                Expression.prototype.callMethod = function (name, params, sourceSpan) {
                    return new InvokeMethodExpr(this, name, params, null, sourceSpan);
                };
                Expression.prototype.callFn = function (params, sourceSpan) {
                    return new InvokeFunctionExpr(this, params, null, sourceSpan);
                };
                Expression.prototype.instantiate = function (params, type, sourceSpan) {
                    return new InstantiateExpr(this, params, type, sourceSpan);
                };
                Expression.prototype.conditional = function (trueCase, falseCase, sourceSpan) {
                    if (falseCase === void 0) { falseCase = null; }
                    return new ConditionalExpr(this, trueCase, falseCase, null, sourceSpan);
                };
                Expression.prototype.equals = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Equals, this, rhs, null, sourceSpan);
                };
                Expression.prototype.notEquals = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.NotEquals, this, rhs, null, sourceSpan);
                };
                Expression.prototype.identical = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Identical, this, rhs, null, sourceSpan);
                };
                Expression.prototype.notIdentical = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.NotIdentical, this, rhs, null, sourceSpan);
                };
                Expression.prototype.minus = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Minus, this, rhs, null, sourceSpan);
                };
                Expression.prototype.plus = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Plus, this, rhs, null, sourceSpan);
                };
                Expression.prototype.divide = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Divide, this, rhs, null, sourceSpan);
                };
                Expression.prototype.multiply = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Multiply, this, rhs, null, sourceSpan);
                };
                Expression.prototype.modulo = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Modulo, this, rhs, null, sourceSpan);
                };
                Expression.prototype.and = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.And, this, rhs, null, sourceSpan);
                };
                Expression.prototype.bitwiseAnd = function (rhs, sourceSpan, parens) {
                    if (parens === void 0) { parens = true; }
                    return new BinaryOperatorExpr(BinaryOperator.BitwiseAnd, this, rhs, null, sourceSpan, parens);
                };
                Expression.prototype.or = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Or, this, rhs, null, sourceSpan);
                };
                Expression.prototype.lower = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Lower, this, rhs, null, sourceSpan);
                };
                Expression.prototype.lowerEquals = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.LowerEquals, this, rhs, null, sourceSpan);
                };
                Expression.prototype.bigger = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.Bigger, this, rhs, null, sourceSpan);
                };
                Expression.prototype.biggerEquals = function (rhs, sourceSpan) {
                    return new BinaryOperatorExpr(BinaryOperator.BiggerEquals, this, rhs, null, sourceSpan);
                };
                Expression.prototype.isBlank = function (sourceSpan) {
                    // Note: We use equals by purpose here to compare to null and undefined in JS.
                    // We use the typed null to allow strictNullChecks to narrow types.
                    return this.equals(TYPED_NULL_EXPR, sourceSpan);
                };
                Expression.prototype.cast = function (type, sourceSpan) {
                    return new CastExpr(this, type, sourceSpan);
                };
                Expression.prototype.toStmt = function () { return new ExpressionStatement(this, null); };
                return Expression;
            }());
            var BuiltinVar;
            (function (BuiltinVar) {
                BuiltinVar[BuiltinVar["This"] = 0] = "This";
                BuiltinVar[BuiltinVar["Super"] = 1] = "Super";
                BuiltinVar[BuiltinVar["CatchError"] = 2] = "CatchError";
                BuiltinVar[BuiltinVar["CatchStack"] = 3] = "CatchStack";
            })(BuiltinVar || (BuiltinVar = {}));
            var ReadVarExpr = /** @class */ (function (_super_1) {
                __extends(ReadVarExpr, _super_1);
                function ReadVarExpr(name, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    if (typeof name === 'string') {
                        _this.name = name;
                        _this.builtin = null;
                    }
                    else {
                        _this.name = null;
                        _this.builtin = name;
                    }
                    return _this;
                }
                ReadVarExpr.prototype.isEquivalent = function (e) {
                    return e instanceof ReadVarExpr && this.name === e.name && this.builtin === e.builtin;
                };
                ReadVarExpr.prototype.isConstant = function () { return false; };
                ReadVarExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitReadVarExpr(this, context);
                };
                ReadVarExpr.prototype.set = function (value) {
                    if (!this.name) {
                        throw new Error("Built in variable " + this.builtin + " can not be assigned to.");
                    }
                    return new WriteVarExpr(this.name, value, null, this.sourceSpan);
                };
                return ReadVarExpr;
            }(Expression));
            var TypeofExpr = /** @class */ (function (_super_1) {
                __extends(TypeofExpr, _super_1);
                function TypeofExpr(expr, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.expr = expr;
                    return _this;
                }
                TypeofExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitTypeofExpr(this, context);
                };
                TypeofExpr.prototype.isEquivalent = function (e) {
                    return e instanceof TypeofExpr && e.expr.isEquivalent(this.expr);
                };
                TypeofExpr.prototype.isConstant = function () { return this.expr.isConstant(); };
                return TypeofExpr;
            }(Expression));
            var WrappedNodeExpr = /** @class */ (function (_super_1) {
                __extends(WrappedNodeExpr, _super_1);
                function WrappedNodeExpr(node, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.node = node;
                    return _this;
                }
                WrappedNodeExpr.prototype.isEquivalent = function (e) {
                    return e instanceof WrappedNodeExpr && this.node === e.node;
                };
                WrappedNodeExpr.prototype.isConstant = function () { return false; };
                WrappedNodeExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitWrappedNodeExpr(this, context);
                };
                return WrappedNodeExpr;
            }(Expression));
            var WriteVarExpr = /** @class */ (function (_super_1) {
                __extends(WriteVarExpr, _super_1);
                function WriteVarExpr(name, value, type, sourceSpan) {
                    var _this = _super_1.call(this, type || value.type, sourceSpan) || this;
                    _this.name = name;
                    _this.value = value;
                    return _this;
                }
                WriteVarExpr.prototype.isEquivalent = function (e) {
                    return e instanceof WriteVarExpr && this.name === e.name && this.value.isEquivalent(e.value);
                };
                WriteVarExpr.prototype.isConstant = function () { return false; };
                WriteVarExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitWriteVarExpr(this, context);
                };
                WriteVarExpr.prototype.toDeclStmt = function (type, modifiers) {
                    return new DeclareVarStmt(this.name, this.value, type, modifiers, this.sourceSpan);
                };
                WriteVarExpr.prototype.toConstDecl = function () { return this.toDeclStmt(INFERRED_TYPE, [StmtModifier.Final]); };
                return WriteVarExpr;
            }(Expression));
            var WriteKeyExpr = /** @class */ (function (_super_1) {
                __extends(WriteKeyExpr, _super_1);
                function WriteKeyExpr(receiver, index, value, type, sourceSpan) {
                    var _this = _super_1.call(this, type || value.type, sourceSpan) || this;
                    _this.receiver = receiver;
                    _this.index = index;
                    _this.value = value;
                    return _this;
                }
                WriteKeyExpr.prototype.isEquivalent = function (e) {
                    return e instanceof WriteKeyExpr && this.receiver.isEquivalent(e.receiver) &&
                        this.index.isEquivalent(e.index) && this.value.isEquivalent(e.value);
                };
                WriteKeyExpr.prototype.isConstant = function () { return false; };
                WriteKeyExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitWriteKeyExpr(this, context);
                };
                return WriteKeyExpr;
            }(Expression));
            var WritePropExpr = /** @class */ (function (_super_1) {
                __extends(WritePropExpr, _super_1);
                function WritePropExpr(receiver, name, value, type, sourceSpan) {
                    var _this = _super_1.call(this, type || value.type, sourceSpan) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    _this.value = value;
                    return _this;
                }
                WritePropExpr.prototype.isEquivalent = function (e) {
                    return e instanceof WritePropExpr && this.receiver.isEquivalent(e.receiver) &&
                        this.name === e.name && this.value.isEquivalent(e.value);
                };
                WritePropExpr.prototype.isConstant = function () { return false; };
                WritePropExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitWritePropExpr(this, context);
                };
                return WritePropExpr;
            }(Expression));
            var BuiltinMethod;
            (function (BuiltinMethod) {
                BuiltinMethod[BuiltinMethod["ConcatArray"] = 0] = "ConcatArray";
                BuiltinMethod[BuiltinMethod["SubscribeObservable"] = 1] = "SubscribeObservable";
                BuiltinMethod[BuiltinMethod["Bind"] = 2] = "Bind";
            })(BuiltinMethod || (BuiltinMethod = {}));
            var InvokeMethodExpr = /** @class */ (function (_super_1) {
                __extends(InvokeMethodExpr, _super_1);
                function InvokeMethodExpr(receiver, method, args, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.receiver = receiver;
                    _this.args = args;
                    if (typeof method === 'string') {
                        _this.name = method;
                        _this.builtin = null;
                    }
                    else {
                        _this.name = null;
                        _this.builtin = method;
                    }
                    return _this;
                }
                InvokeMethodExpr.prototype.isEquivalent = function (e) {
                    return e instanceof InvokeMethodExpr && this.receiver.isEquivalent(e.receiver) &&
                        this.name === e.name && this.builtin === e.builtin && areAllEquivalent(this.args, e.args);
                };
                InvokeMethodExpr.prototype.isConstant = function () { return false; };
                InvokeMethodExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitInvokeMethodExpr(this, context);
                };
                return InvokeMethodExpr;
            }(Expression));
            var InvokeFunctionExpr = /** @class */ (function (_super_1) {
                __extends(InvokeFunctionExpr, _super_1);
                function InvokeFunctionExpr(fn, args, type, sourceSpan, pure) {
                    if (pure === void 0) { pure = false; }
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.fn = fn;
                    _this.args = args;
                    _this.pure = pure;
                    return _this;
                }
                InvokeFunctionExpr.prototype.isEquivalent = function (e) {
                    return e instanceof InvokeFunctionExpr && this.fn.isEquivalent(e.fn) &&
                        areAllEquivalent(this.args, e.args) && this.pure === e.pure;
                };
                InvokeFunctionExpr.prototype.isConstant = function () { return false; };
                InvokeFunctionExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitInvokeFunctionExpr(this, context);
                };
                return InvokeFunctionExpr;
            }(Expression));
            var InstantiateExpr = /** @class */ (function (_super_1) {
                __extends(InstantiateExpr, _super_1);
                function InstantiateExpr(classExpr, args, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.classExpr = classExpr;
                    _this.args = args;
                    return _this;
                }
                InstantiateExpr.prototype.isEquivalent = function (e) {
                    return e instanceof InstantiateExpr && this.classExpr.isEquivalent(e.classExpr) &&
                        areAllEquivalent(this.args, e.args);
                };
                InstantiateExpr.prototype.isConstant = function () { return false; };
                InstantiateExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitInstantiateExpr(this, context);
                };
                return InstantiateExpr;
            }(Expression));
            var LiteralExpr = /** @class */ (function (_super_1) {
                __extends(LiteralExpr, _super_1);
                function LiteralExpr(value, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.value = value;
                    return _this;
                }
                LiteralExpr.prototype.isEquivalent = function (e) {
                    return e instanceof LiteralExpr && this.value === e.value;
                };
                LiteralExpr.prototype.isConstant = function () { return true; };
                LiteralExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitLiteralExpr(this, context);
                };
                return LiteralExpr;
            }(Expression));
            var ExternalExpr = /** @class */ (function (_super_1) {
                __extends(ExternalExpr, _super_1);
                function ExternalExpr(value, type, typeParams, sourceSpan) {
                    if (typeParams === void 0) { typeParams = null; }
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.value = value;
                    _this.typeParams = typeParams;
                    return _this;
                }
                ExternalExpr.prototype.isEquivalent = function (e) {
                    return e instanceof ExternalExpr && this.value.name === e.value.name &&
                        this.value.moduleName === e.value.moduleName && this.value.runtime === e.value.runtime;
                };
                ExternalExpr.prototype.isConstant = function () { return false; };
                ExternalExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitExternalExpr(this, context);
                };
                return ExternalExpr;
            }(Expression));
            var ExternalReference = /** @class */ (function () {
                function ExternalReference(moduleName, name, runtime) {
                    this.moduleName = moduleName;
                    this.name = name;
                    this.runtime = runtime;
                }
                return ExternalReference;
            }());
            var ConditionalExpr = /** @class */ (function (_super_1) {
                __extends(ConditionalExpr, _super_1);
                function ConditionalExpr(condition, trueCase, falseCase, type, sourceSpan) {
                    if (falseCase === void 0) { falseCase = null; }
                    var _this = _super_1.call(this, type || trueCase.type, sourceSpan) || this;
                    _this.condition = condition;
                    _this.falseCase = falseCase;
                    _this.trueCase = trueCase;
                    return _this;
                }
                ConditionalExpr.prototype.isEquivalent = function (e) {
                    return e instanceof ConditionalExpr && this.condition.isEquivalent(e.condition) &&
                        this.trueCase.isEquivalent(e.trueCase) && nullSafeIsEquivalent(this.falseCase, e.falseCase);
                };
                ConditionalExpr.prototype.isConstant = function () { return false; };
                ConditionalExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitConditionalExpr(this, context);
                };
                return ConditionalExpr;
            }(Expression));
            var NotExpr = /** @class */ (function (_super_1) {
                __extends(NotExpr, _super_1);
                function NotExpr(condition, sourceSpan) {
                    var _this = _super_1.call(this, BOOL_TYPE, sourceSpan) || this;
                    _this.condition = condition;
                    return _this;
                }
                NotExpr.prototype.isEquivalent = function (e) {
                    return e instanceof NotExpr && this.condition.isEquivalent(e.condition);
                };
                NotExpr.prototype.isConstant = function () { return false; };
                NotExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitNotExpr(this, context);
                };
                return NotExpr;
            }(Expression));
            var AssertNotNull = /** @class */ (function (_super_1) {
                __extends(AssertNotNull, _super_1);
                function AssertNotNull(condition, sourceSpan) {
                    var _this = _super_1.call(this, condition.type, sourceSpan) || this;
                    _this.condition = condition;
                    return _this;
                }
                AssertNotNull.prototype.isEquivalent = function (e) {
                    return e instanceof AssertNotNull && this.condition.isEquivalent(e.condition);
                };
                AssertNotNull.prototype.isConstant = function () { return false; };
                AssertNotNull.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitAssertNotNullExpr(this, context);
                };
                return AssertNotNull;
            }(Expression));
            var CastExpr = /** @class */ (function (_super_1) {
                __extends(CastExpr, _super_1);
                function CastExpr(value, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.value = value;
                    return _this;
                }
                CastExpr.prototype.isEquivalent = function (e) {
                    return e instanceof CastExpr && this.value.isEquivalent(e.value);
                };
                CastExpr.prototype.isConstant = function () { return false; };
                CastExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitCastExpr(this, context);
                };
                return CastExpr;
            }(Expression));
            var FnParam = /** @class */ (function () {
                function FnParam(name, type) {
                    if (type === void 0) { type = null; }
                    this.name = name;
                    this.type = type;
                }
                FnParam.prototype.isEquivalent = function (param) { return this.name === param.name; };
                return FnParam;
            }());
            var FunctionExpr = /** @class */ (function (_super_1) {
                __extends(FunctionExpr, _super_1);
                function FunctionExpr(params, statements, type, sourceSpan, name) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.params = params;
                    _this.statements = statements;
                    _this.name = name;
                    return _this;
                }
                FunctionExpr.prototype.isEquivalent = function (e) {
                    return e instanceof FunctionExpr && areAllEquivalent(this.params, e.params) &&
                        areAllEquivalent(this.statements, e.statements);
                };
                FunctionExpr.prototype.isConstant = function () { return false; };
                FunctionExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitFunctionExpr(this, context);
                };
                FunctionExpr.prototype.toDeclStmt = function (name, modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    return new DeclareFunctionStmt(name, this.params, this.statements, this.type, modifiers, this.sourceSpan);
                };
                return FunctionExpr;
            }(Expression));
            var BinaryOperatorExpr = /** @class */ (function (_super_1) {
                __extends(BinaryOperatorExpr, _super_1);
                function BinaryOperatorExpr(operator, lhs, rhs, type, sourceSpan, parens) {
                    if (parens === void 0) { parens = true; }
                    var _this = _super_1.call(this, type || lhs.type, sourceSpan) || this;
                    _this.operator = operator;
                    _this.rhs = rhs;
                    _this.parens = parens;
                    _this.lhs = lhs;
                    return _this;
                }
                BinaryOperatorExpr.prototype.isEquivalent = function (e) {
                    return e instanceof BinaryOperatorExpr && this.operator === e.operator &&
                        this.lhs.isEquivalent(e.lhs) && this.rhs.isEquivalent(e.rhs);
                };
                BinaryOperatorExpr.prototype.isConstant = function () { return false; };
                BinaryOperatorExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitBinaryOperatorExpr(this, context);
                };
                return BinaryOperatorExpr;
            }(Expression));
            var ReadPropExpr = /** @class */ (function (_super_1) {
                __extends(ReadPropExpr, _super_1);
                function ReadPropExpr(receiver, name, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    return _this;
                }
                ReadPropExpr.prototype.isEquivalent = function (e) {
                    return e instanceof ReadPropExpr && this.receiver.isEquivalent(e.receiver) &&
                        this.name === e.name;
                };
                ReadPropExpr.prototype.isConstant = function () { return false; };
                ReadPropExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitReadPropExpr(this, context);
                };
                ReadPropExpr.prototype.set = function (value) {
                    return new WritePropExpr(this.receiver, this.name, value, null, this.sourceSpan);
                };
                return ReadPropExpr;
            }(Expression));
            var ReadKeyExpr = /** @class */ (function (_super_1) {
                __extends(ReadKeyExpr, _super_1);
                function ReadKeyExpr(receiver, index, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.receiver = receiver;
                    _this.index = index;
                    return _this;
                }
                ReadKeyExpr.prototype.isEquivalent = function (e) {
                    return e instanceof ReadKeyExpr && this.receiver.isEquivalent(e.receiver) &&
                        this.index.isEquivalent(e.index);
                };
                ReadKeyExpr.prototype.isConstant = function () { return false; };
                ReadKeyExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitReadKeyExpr(this, context);
                };
                ReadKeyExpr.prototype.set = function (value) {
                    return new WriteKeyExpr(this.receiver, this.index, value, null, this.sourceSpan);
                };
                return ReadKeyExpr;
            }(Expression));
            var LiteralArrayExpr = /** @class */ (function (_super_1) {
                __extends(LiteralArrayExpr, _super_1);
                function LiteralArrayExpr(entries, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.entries = entries;
                    return _this;
                }
                LiteralArrayExpr.prototype.isConstant = function () { return this.entries.every(function (e) { return e.isConstant(); }); };
                LiteralArrayExpr.prototype.isEquivalent = function (e) {
                    return e instanceof LiteralArrayExpr && areAllEquivalent(this.entries, e.entries);
                };
                LiteralArrayExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitLiteralArrayExpr(this, context);
                };
                return LiteralArrayExpr;
            }(Expression));
            var LiteralMapEntry = /** @class */ (function () {
                function LiteralMapEntry(key, value, quoted) {
                    this.key = key;
                    this.value = value;
                    this.quoted = quoted;
                }
                LiteralMapEntry.prototype.isEquivalent = function (e) {
                    return this.key === e.key && this.value.isEquivalent(e.value);
                };
                return LiteralMapEntry;
            }());
            var LiteralMapExpr = /** @class */ (function (_super_1) {
                __extends(LiteralMapExpr, _super_1);
                function LiteralMapExpr(entries, type, sourceSpan) {
                    var _this = _super_1.call(this, type, sourceSpan) || this;
                    _this.entries = entries;
                    _this.valueType = null;
                    if (type) {
                        _this.valueType = type.valueType;
                    }
                    return _this;
                }
                LiteralMapExpr.prototype.isEquivalent = function (e) {
                    return e instanceof LiteralMapExpr && areAllEquivalent(this.entries, e.entries);
                };
                LiteralMapExpr.prototype.isConstant = function () { return this.entries.every(function (e) { return e.value.isConstant(); }); };
                LiteralMapExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitLiteralMapExpr(this, context);
                };
                return LiteralMapExpr;
            }(Expression));
            var CommaExpr = /** @class */ (function (_super_1) {
                __extends(CommaExpr, _super_1);
                function CommaExpr(parts, sourceSpan) {
                    var _this = _super_1.call(this, parts[parts.length - 1].type, sourceSpan) || this;
                    _this.parts = parts;
                    return _this;
                }
                CommaExpr.prototype.isEquivalent = function (e) {
                    return e instanceof CommaExpr && areAllEquivalent(this.parts, e.parts);
                };
                CommaExpr.prototype.isConstant = function () { return false; };
                CommaExpr.prototype.visitExpression = function (visitor, context) {
                    return visitor.visitCommaExpr(this, context);
                };
                return CommaExpr;
            }(Expression));
            var THIS_EXPR = new ReadVarExpr(BuiltinVar.This, null, null);
            var SUPER_EXPR = new ReadVarExpr(BuiltinVar.Super, null, null);
            var CATCH_ERROR_VAR = new ReadVarExpr(BuiltinVar.CatchError, null, null);
            var CATCH_STACK_VAR = new ReadVarExpr(BuiltinVar.CatchStack, null, null);
            var NULL_EXPR = new LiteralExpr(null, null, null);
            var TYPED_NULL_EXPR = new LiteralExpr(null, INFERRED_TYPE, null);
            //// Statements
            var StmtModifier;
            (function (StmtModifier) {
                StmtModifier[StmtModifier["Final"] = 0] = "Final";
                StmtModifier[StmtModifier["Private"] = 1] = "Private";
                StmtModifier[StmtModifier["Exported"] = 2] = "Exported";
                StmtModifier[StmtModifier["Static"] = 3] = "Static";
            })(StmtModifier || (StmtModifier = {}));
            var Statement = /** @class */ (function () {
                function Statement(modifiers, sourceSpan) {
                    this.modifiers = modifiers || [];
                    this.sourceSpan = sourceSpan || null;
                }
                Statement.prototype.hasModifier = function (modifier) { return this.modifiers.indexOf(modifier) !== -1; };
                return Statement;
            }());
            var DeclareVarStmt = /** @class */ (function (_super_1) {
                __extends(DeclareVarStmt, _super_1);
                function DeclareVarStmt(name, value, type, modifiers, sourceSpan) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, modifiers, sourceSpan) || this;
                    _this.name = name;
                    _this.value = value;
                    _this.type = type || (value && value.type) || null;
                    return _this;
                }
                DeclareVarStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof DeclareVarStmt && this.name === stmt.name &&
                        (this.value ? !!stmt.value && this.value.isEquivalent(stmt.value) : !stmt.value);
                };
                DeclareVarStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitDeclareVarStmt(this, context);
                };
                return DeclareVarStmt;
            }(Statement));
            var DeclareFunctionStmt = /** @class */ (function (_super_1) {
                __extends(DeclareFunctionStmt, _super_1);
                function DeclareFunctionStmt(name, params, statements, type, modifiers, sourceSpan) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, modifiers, sourceSpan) || this;
                    _this.name = name;
                    _this.params = params;
                    _this.statements = statements;
                    _this.type = type || null;
                    return _this;
                }
                DeclareFunctionStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof DeclareFunctionStmt && areAllEquivalent(this.params, stmt.params) &&
                        areAllEquivalent(this.statements, stmt.statements);
                };
                DeclareFunctionStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitDeclareFunctionStmt(this, context);
                };
                return DeclareFunctionStmt;
            }(Statement));
            var ExpressionStatement = /** @class */ (function (_super_1) {
                __extends(ExpressionStatement, _super_1);
                function ExpressionStatement(expr, sourceSpan) {
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.expr = expr;
                    return _this;
                }
                ExpressionStatement.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof ExpressionStatement && this.expr.isEquivalent(stmt.expr);
                };
                ExpressionStatement.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitExpressionStmt(this, context);
                };
                return ExpressionStatement;
            }(Statement));
            var ReturnStatement = /** @class */ (function (_super_1) {
                __extends(ReturnStatement, _super_1);
                function ReturnStatement(value, sourceSpan) {
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.value = value;
                    return _this;
                }
                ReturnStatement.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof ReturnStatement && this.value.isEquivalent(stmt.value);
                };
                ReturnStatement.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitReturnStmt(this, context);
                };
                return ReturnStatement;
            }(Statement));
            var AbstractClassPart = /** @class */ (function () {
                function AbstractClassPart(type, modifiers) {
                    this.modifiers = modifiers;
                    if (!modifiers) {
                        this.modifiers = [];
                    }
                    this.type = type || null;
                }
                AbstractClassPart.prototype.hasModifier = function (modifier) { return this.modifiers.indexOf(modifier) !== -1; };
                return AbstractClassPart;
            }());
            var ClassField = /** @class */ (function (_super_1) {
                __extends(ClassField, _super_1);
                function ClassField(name, type, modifiers, initializer) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, type, modifiers) || this;
                    _this.name = name;
                    _this.initializer = initializer;
                    return _this;
                }
                ClassField.prototype.isEquivalent = function (f) { return this.name === f.name; };
                return ClassField;
            }(AbstractClassPart));
            var ClassMethod = /** @class */ (function (_super_1) {
                __extends(ClassMethod, _super_1);
                function ClassMethod(name, params, body, type, modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, type, modifiers) || this;
                    _this.name = name;
                    _this.params = params;
                    _this.body = body;
                    return _this;
                }
                ClassMethod.prototype.isEquivalent = function (m) {
                    return this.name === m.name && areAllEquivalent(this.body, m.body);
                };
                return ClassMethod;
            }(AbstractClassPart));
            var ClassGetter = /** @class */ (function (_super_1) {
                __extends(ClassGetter, _super_1);
                function ClassGetter(name, body, type, modifiers) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, type, modifiers) || this;
                    _this.name = name;
                    _this.body = body;
                    return _this;
                }
                ClassGetter.prototype.isEquivalent = function (m) {
                    return this.name === m.name && areAllEquivalent(this.body, m.body);
                };
                return ClassGetter;
            }(AbstractClassPart));
            var ClassStmt = /** @class */ (function (_super_1) {
                __extends(ClassStmt, _super_1);
                function ClassStmt(name, parent, fields, getters, constructorMethod, methods, modifiers, sourceSpan) {
                    if (modifiers === void 0) { modifiers = null; }
                    var _this = _super_1.call(this, modifiers, sourceSpan) || this;
                    _this.name = name;
                    _this.parent = parent;
                    _this.fields = fields;
                    _this.getters = getters;
                    _this.constructorMethod = constructorMethod;
                    _this.methods = methods;
                    return _this;
                }
                ClassStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof ClassStmt && this.name === stmt.name &&
                        nullSafeIsEquivalent(this.parent, stmt.parent) &&
                        areAllEquivalent(this.fields, stmt.fields) &&
                        areAllEquivalent(this.getters, stmt.getters) &&
                        this.constructorMethod.isEquivalent(stmt.constructorMethod) &&
                        areAllEquivalent(this.methods, stmt.methods);
                };
                ClassStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitDeclareClassStmt(this, context);
                };
                return ClassStmt;
            }(Statement));
            var IfStmt = /** @class */ (function (_super_1) {
                __extends(IfStmt, _super_1);
                function IfStmt(condition, trueCase, falseCase, sourceSpan) {
                    if (falseCase === void 0) { falseCase = []; }
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.condition = condition;
                    _this.trueCase = trueCase;
                    _this.falseCase = falseCase;
                    return _this;
                }
                IfStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof IfStmt && this.condition.isEquivalent(stmt.condition) &&
                        areAllEquivalent(this.trueCase, stmt.trueCase) &&
                        areAllEquivalent(this.falseCase, stmt.falseCase);
                };
                IfStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitIfStmt(this, context);
                };
                return IfStmt;
            }(Statement));
            var CommentStmt = /** @class */ (function (_super_1) {
                __extends(CommentStmt, _super_1);
                function CommentStmt(comment, multiline, sourceSpan) {
                    if (multiline === void 0) { multiline = false; }
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.comment = comment;
                    _this.multiline = multiline;
                    return _this;
                }
                CommentStmt.prototype.isEquivalent = function (stmt) { return stmt instanceof CommentStmt; };
                CommentStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitCommentStmt(this, context);
                };
                return CommentStmt;
            }(Statement));
            var JSDocCommentStmt = /** @class */ (function (_super_1) {
                __extends(JSDocCommentStmt, _super_1);
                function JSDocCommentStmt(tags, sourceSpan) {
                    if (tags === void 0) { tags = []; }
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.tags = tags;
                    return _this;
                }
                JSDocCommentStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof JSDocCommentStmt && this.toString() === stmt.toString();
                };
                JSDocCommentStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitJSDocCommentStmt(this, context);
                };
                JSDocCommentStmt.prototype.toString = function () { return serializeTags(this.tags); };
                return JSDocCommentStmt;
            }(Statement));
            var TryCatchStmt = /** @class */ (function (_super_1) {
                __extends(TryCatchStmt, _super_1);
                function TryCatchStmt(bodyStmts, catchStmts, sourceSpan) {
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.bodyStmts = bodyStmts;
                    _this.catchStmts = catchStmts;
                    return _this;
                }
                TryCatchStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof TryCatchStmt && areAllEquivalent(this.bodyStmts, stmt.bodyStmts) &&
                        areAllEquivalent(this.catchStmts, stmt.catchStmts);
                };
                TryCatchStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitTryCatchStmt(this, context);
                };
                return TryCatchStmt;
            }(Statement));
            var ThrowStmt = /** @class */ (function (_super_1) {
                __extends(ThrowStmt, _super_1);
                function ThrowStmt(error, sourceSpan) {
                    var _this = _super_1.call(this, null, sourceSpan) || this;
                    _this.error = error;
                    return _this;
                }
                ThrowStmt.prototype.isEquivalent = function (stmt) {
                    return stmt instanceof TryCatchStmt && this.error.isEquivalent(stmt.error);
                };
                ThrowStmt.prototype.visitStatement = function (visitor, context) {
                    return visitor.visitThrowStmt(this, context);
                };
                return ThrowStmt;
            }(Statement));
            var AstTransformer = /** @class */ (function () {
                function AstTransformer() {
                }
                AstTransformer.prototype.transformExpr = function (expr, context) { return expr; };
                AstTransformer.prototype.transformStmt = function (stmt, context) { return stmt; };
                AstTransformer.prototype.visitReadVarExpr = function (ast, context) { return this.transformExpr(ast, context); };
                AstTransformer.prototype.visitWrappedNodeExpr = function (ast, context) {
                    return this.transformExpr(ast, context);
                };
                AstTransformer.prototype.visitTypeofExpr = function (expr, context) {
                    return this.transformExpr(new TypeofExpr(expr.expr.visitExpression(this, context), expr.type, expr.sourceSpan), context);
                };
                AstTransformer.prototype.visitWriteVarExpr = function (expr, context) {
                    return this.transformExpr(new WriteVarExpr(expr.name, expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
                };
                AstTransformer.prototype.visitWriteKeyExpr = function (expr, context) {
                    return this.transformExpr(new WriteKeyExpr(expr.receiver.visitExpression(this, context), expr.index.visitExpression(this, context), expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
                };
                AstTransformer.prototype.visitWritePropExpr = function (expr, context) {
                    return this.transformExpr(new WritePropExpr(expr.receiver.visitExpression(this, context), expr.name, expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
                };
                AstTransformer.prototype.visitInvokeMethodExpr = function (ast, context) {
                    var method = ast.builtin || ast.name;
                    return this.transformExpr(new InvokeMethodExpr(ast.receiver.visitExpression(this, context), method, this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitInvokeFunctionExpr = function (ast, context) {
                    return this.transformExpr(new InvokeFunctionExpr(ast.fn.visitExpression(this, context), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitInstantiateExpr = function (ast, context) {
                    return this.transformExpr(new InstantiateExpr(ast.classExpr.visitExpression(this, context), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitLiteralExpr = function (ast, context) { return this.transformExpr(ast, context); };
                AstTransformer.prototype.visitExternalExpr = function (ast, context) {
                    return this.transformExpr(ast, context);
                };
                AstTransformer.prototype.visitConditionalExpr = function (ast, context) {
                    return this.transformExpr(new ConditionalExpr(ast.condition.visitExpression(this, context), ast.trueCase.visitExpression(this, context), ast.falseCase.visitExpression(this, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitNotExpr = function (ast, context) {
                    return this.transformExpr(new NotExpr(ast.condition.visitExpression(this, context), ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitAssertNotNullExpr = function (ast, context) {
                    return this.transformExpr(new AssertNotNull(ast.condition.visitExpression(this, context), ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitCastExpr = function (ast, context) {
                    return this.transformExpr(new CastExpr(ast.value.visitExpression(this, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitFunctionExpr = function (ast, context) {
                    return this.transformExpr(new FunctionExpr(ast.params, this.visitAllStatements(ast.statements, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitBinaryOperatorExpr = function (ast, context) {
                    return this.transformExpr(new BinaryOperatorExpr(ast.operator, ast.lhs.visitExpression(this, context), ast.rhs.visitExpression(this, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitReadPropExpr = function (ast, context) {
                    return this.transformExpr(new ReadPropExpr(ast.receiver.visitExpression(this, context), ast.name, ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitReadKeyExpr = function (ast, context) {
                    return this.transformExpr(new ReadKeyExpr(ast.receiver.visitExpression(this, context), ast.index.visitExpression(this, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitLiteralArrayExpr = function (ast, context) {
                    return this.transformExpr(new LiteralArrayExpr(this.visitAllExpressions(ast.entries, context), ast.type, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitLiteralMapExpr = function (ast, context) {
                    var _this = this;
                    var entries = ast.entries.map(function (entry) { return new LiteralMapEntry(entry.key, entry.value.visitExpression(_this, context), entry.quoted); });
                    var mapType = new MapType(ast.valueType, null);
                    return this.transformExpr(new LiteralMapExpr(entries, mapType, ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitCommaExpr = function (ast, context) {
                    return this.transformExpr(new CommaExpr(this.visitAllExpressions(ast.parts, context), ast.sourceSpan), context);
                };
                AstTransformer.prototype.visitAllExpressions = function (exprs, context) {
                    var _this = this;
                    return exprs.map(function (expr) { return expr.visitExpression(_this, context); });
                };
                AstTransformer.prototype.visitDeclareVarStmt = function (stmt, context) {
                    var value = stmt.value && stmt.value.visitExpression(this, context);
                    return this.transformStmt(new DeclareVarStmt(stmt.name, value, stmt.type, stmt.modifiers, stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitDeclareFunctionStmt = function (stmt, context) {
                    return this.transformStmt(new DeclareFunctionStmt(stmt.name, stmt.params, this.visitAllStatements(stmt.statements, context), stmt.type, stmt.modifiers, stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitExpressionStmt = function (stmt, context) {
                    return this.transformStmt(new ExpressionStatement(stmt.expr.visitExpression(this, context), stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitReturnStmt = function (stmt, context) {
                    return this.transformStmt(new ReturnStatement(stmt.value.visitExpression(this, context), stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitDeclareClassStmt = function (stmt, context) {
                    var _this = this;
                    var parent = stmt.parent.visitExpression(this, context);
                    var getters = stmt.getters.map(function (getter) { return new ClassGetter(getter.name, _this.visitAllStatements(getter.body, context), getter.type, getter.modifiers); });
                    var ctorMethod = stmt.constructorMethod &&
                        new ClassMethod(stmt.constructorMethod.name, stmt.constructorMethod.params, this.visitAllStatements(stmt.constructorMethod.body, context), stmt.constructorMethod.type, stmt.constructorMethod.modifiers);
                    var methods = stmt.methods.map(function (method) { return new ClassMethod(method.name, method.params, _this.visitAllStatements(method.body, context), method.type, method.modifiers); });
                    return this.transformStmt(new ClassStmt(stmt.name, parent, stmt.fields, getters, ctorMethod, methods, stmt.modifiers, stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitIfStmt = function (stmt, context) {
                    return this.transformStmt(new IfStmt(stmt.condition.visitExpression(this, context), this.visitAllStatements(stmt.trueCase, context), this.visitAllStatements(stmt.falseCase, context), stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitTryCatchStmt = function (stmt, context) {
                    return this.transformStmt(new TryCatchStmt(this.visitAllStatements(stmt.bodyStmts, context), this.visitAllStatements(stmt.catchStmts, context), stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitThrowStmt = function (stmt, context) {
                    return this.transformStmt(new ThrowStmt(stmt.error.visitExpression(this, context), stmt.sourceSpan), context);
                };
                AstTransformer.prototype.visitCommentStmt = function (stmt, context) {
                    return this.transformStmt(stmt, context);
                };
                AstTransformer.prototype.visitJSDocCommentStmt = function (stmt, context) {
                    return this.transformStmt(stmt, context);
                };
                AstTransformer.prototype.visitAllStatements = function (stmts, context) {
                    var _this = this;
                    return stmts.map(function (stmt) { return stmt.visitStatement(_this, context); });
                };
                return AstTransformer;
            }());
            var RecursiveAstVisitor = /** @class */ (function () {
                function RecursiveAstVisitor() {
                }
                RecursiveAstVisitor.prototype.visitType = function (ast, context) { return ast; };
                RecursiveAstVisitor.prototype.visitExpression = function (ast, context) {
                    if (ast.type) {
                        ast.type.visitType(this, context);
                    }
                    return ast;
                };
                RecursiveAstVisitor.prototype.visitBuiltinType = function (type, context) { return this.visitType(type, context); };
                RecursiveAstVisitor.prototype.visitExpressionType = function (type, context) {
                    var _this = this;
                    type.value.visitExpression(this, context);
                    if (type.typeParams !== null) {
                        type.typeParams.forEach(function (param) { return _this.visitType(param, context); });
                    }
                    return this.visitType(type, context);
                };
                RecursiveAstVisitor.prototype.visitArrayType = function (type, context) { return this.visitType(type, context); };
                RecursiveAstVisitor.prototype.visitMapType = function (type, context) { return this.visitType(type, context); };
                RecursiveAstVisitor.prototype.visitWrappedNodeExpr = function (ast, context) { return ast; };
                RecursiveAstVisitor.prototype.visitTypeofExpr = function (ast, context) { return this.visitExpression(ast, context); };
                RecursiveAstVisitor.prototype.visitReadVarExpr = function (ast, context) {
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitWriteVarExpr = function (ast, context) {
                    ast.value.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitWriteKeyExpr = function (ast, context) {
                    ast.receiver.visitExpression(this, context);
                    ast.index.visitExpression(this, context);
                    ast.value.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitWritePropExpr = function (ast, context) {
                    ast.receiver.visitExpression(this, context);
                    ast.value.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitInvokeMethodExpr = function (ast, context) {
                    ast.receiver.visitExpression(this, context);
                    this.visitAllExpressions(ast.args, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitInvokeFunctionExpr = function (ast, context) {
                    ast.fn.visitExpression(this, context);
                    this.visitAllExpressions(ast.args, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitInstantiateExpr = function (ast, context) {
                    ast.classExpr.visitExpression(this, context);
                    this.visitAllExpressions(ast.args, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitLiteralExpr = function (ast, context) {
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitExternalExpr = function (ast, context) {
                    var _this = this;
                    if (ast.typeParams) {
                        ast.typeParams.forEach(function (type) { return type.visitType(_this, context); });
                    }
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitConditionalExpr = function (ast, context) {
                    ast.condition.visitExpression(this, context);
                    ast.trueCase.visitExpression(this, context);
                    ast.falseCase.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitNotExpr = function (ast, context) {
                    ast.condition.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitAssertNotNullExpr = function (ast, context) {
                    ast.condition.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitCastExpr = function (ast, context) {
                    ast.value.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitFunctionExpr = function (ast, context) {
                    this.visitAllStatements(ast.statements, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitBinaryOperatorExpr = function (ast, context) {
                    ast.lhs.visitExpression(this, context);
                    ast.rhs.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitReadPropExpr = function (ast, context) {
                    ast.receiver.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitReadKeyExpr = function (ast, context) {
                    ast.receiver.visitExpression(this, context);
                    ast.index.visitExpression(this, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitLiteralArrayExpr = function (ast, context) {
                    this.visitAllExpressions(ast.entries, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitLiteralMapExpr = function (ast, context) {
                    var _this = this;
                    ast.entries.forEach(function (entry) { return entry.value.visitExpression(_this, context); });
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitCommaExpr = function (ast, context) {
                    this.visitAllExpressions(ast.parts, context);
                    return this.visitExpression(ast, context);
                };
                RecursiveAstVisitor.prototype.visitAllExpressions = function (exprs, context) {
                    var _this = this;
                    exprs.forEach(function (expr) { return expr.visitExpression(_this, context); });
                };
                RecursiveAstVisitor.prototype.visitDeclareVarStmt = function (stmt, context) {
                    if (stmt.value) {
                        stmt.value.visitExpression(this, context);
                    }
                    if (stmt.type) {
                        stmt.type.visitType(this, context);
                    }
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitDeclareFunctionStmt = function (stmt, context) {
                    this.visitAllStatements(stmt.statements, context);
                    if (stmt.type) {
                        stmt.type.visitType(this, context);
                    }
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitExpressionStmt = function (stmt, context) {
                    stmt.expr.visitExpression(this, context);
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitReturnStmt = function (stmt, context) {
                    stmt.value.visitExpression(this, context);
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitDeclareClassStmt = function (stmt, context) {
                    var _this = this;
                    stmt.parent.visitExpression(this, context);
                    stmt.getters.forEach(function (getter) { return _this.visitAllStatements(getter.body, context); });
                    if (stmt.constructorMethod) {
                        this.visitAllStatements(stmt.constructorMethod.body, context);
                    }
                    stmt.methods.forEach(function (method) { return _this.visitAllStatements(method.body, context); });
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitIfStmt = function (stmt, context) {
                    stmt.condition.visitExpression(this, context);
                    this.visitAllStatements(stmt.trueCase, context);
                    this.visitAllStatements(stmt.falseCase, context);
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitTryCatchStmt = function (stmt, context) {
                    this.visitAllStatements(stmt.bodyStmts, context);
                    this.visitAllStatements(stmt.catchStmts, context);
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitThrowStmt = function (stmt, context) {
                    stmt.error.visitExpression(this, context);
                    return stmt;
                };
                RecursiveAstVisitor.prototype.visitCommentStmt = function (stmt, context) { return stmt; };
                RecursiveAstVisitor.prototype.visitJSDocCommentStmt = function (stmt, context) { return stmt; };
                RecursiveAstVisitor.prototype.visitAllStatements = function (stmts, context) {
                    var _this = this;
                    stmts.forEach(function (stmt) { return stmt.visitStatement(_this, context); });
                };
                return RecursiveAstVisitor;
            }());
            function findReadVarNames(stmts) {
                var visitor = new _ReadVarVisitor();
                visitor.visitAllStatements(stmts, null);
                return visitor.varNames;
            }
            var _ReadVarVisitor = /** @class */ (function (_super_1) {
                __extends(_ReadVarVisitor, _super_1);
                function _ReadVarVisitor() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this.varNames = new Set();
                    return _this;
                }
                _ReadVarVisitor.prototype.visitDeclareFunctionStmt = function (stmt, context) {
                    // Don't descend into nested functions
                    return stmt;
                };
                _ReadVarVisitor.prototype.visitDeclareClassStmt = function (stmt, context) {
                    // Don't descend into nested classes
                    return stmt;
                };
                _ReadVarVisitor.prototype.visitReadVarExpr = function (ast, context) {
                    if (ast.name) {
                        this.varNames.add(ast.name);
                    }
                    return null;
                };
                return _ReadVarVisitor;
            }(RecursiveAstVisitor));
            function collectExternalReferences(stmts) {
                var visitor = new _FindExternalReferencesVisitor();
                visitor.visitAllStatements(stmts, null);
                return visitor.externalReferences;
            }
            var _FindExternalReferencesVisitor = /** @class */ (function (_super_1) {
                __extends(_FindExternalReferencesVisitor, _super_1);
                function _FindExternalReferencesVisitor() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this.externalReferences = [];
                    return _this;
                }
                _FindExternalReferencesVisitor.prototype.visitExternalExpr = function (e, context) {
                    this.externalReferences.push(e.value);
                    return _super_1.prototype.visitExternalExpr.call(this, e, context);
                };
                return _FindExternalReferencesVisitor;
            }(RecursiveAstVisitor));
            function applySourceSpanToStatementIfNeeded(stmt, sourceSpan) {
                if (!sourceSpan) {
                    return stmt;
                }
                var transformer = new _ApplySourceSpanTransformer(sourceSpan);
                return stmt.visitStatement(transformer, null);
            }
            function applySourceSpanToExpressionIfNeeded(expr, sourceSpan) {
                if (!sourceSpan) {
                    return expr;
                }
                var transformer = new _ApplySourceSpanTransformer(sourceSpan);
                return expr.visitExpression(transformer, null);
            }
            var _ApplySourceSpanTransformer = /** @class */ (function (_super_1) {
                __extends(_ApplySourceSpanTransformer, _super_1);
                function _ApplySourceSpanTransformer(sourceSpan) {
                    var _this = _super_1.call(this) || this;
                    _this.sourceSpan = sourceSpan;
                    return _this;
                }
                _ApplySourceSpanTransformer.prototype._clone = function (obj) {
                    var clone = Object.create(obj.constructor.prototype);
                    for (var _c = 0, _d = Object.keys(obj); _c < _d.length; _c++) {
                        var prop = _d[_c];
                        clone[prop] = obj[prop];
                    }
                    return clone;
                };
                _ApplySourceSpanTransformer.prototype.transformExpr = function (expr, context) {
                    if (!expr.sourceSpan) {
                        expr = this._clone(expr);
                        expr.sourceSpan = this.sourceSpan;
                    }
                    return expr;
                };
                _ApplySourceSpanTransformer.prototype.transformStmt = function (stmt, context) {
                    if (!stmt.sourceSpan) {
                        stmt = this._clone(stmt);
                        stmt.sourceSpan = this.sourceSpan;
                    }
                    return stmt;
                };
                return _ApplySourceSpanTransformer;
            }(AstTransformer));
            function variable(name, type, sourceSpan) {
                return new ReadVarExpr(name, type, sourceSpan);
            }
            function importExpr(id, typeParams, sourceSpan) {
                if (typeParams === void 0) { typeParams = null; }
                return new ExternalExpr(id, null, typeParams, sourceSpan);
            }
            function importType(id, typeParams, typeModifiers) {
                if (typeParams === void 0) { typeParams = null; }
                if (typeModifiers === void 0) { typeModifiers = null; }
                return id != null ? expressionType(importExpr(id, typeParams, null), typeModifiers) : null;
            }
            function expressionType(expr, typeModifiers, typeParams) {
                if (typeModifiers === void 0) { typeModifiers = null; }
                if (typeParams === void 0) { typeParams = null; }
                return new ExpressionType(expr, typeModifiers, typeParams);
            }
            function typeofExpr(expr) {
                return new TypeofExpr(expr);
            }
            function literalArr(values, type, sourceSpan) {
                return new LiteralArrayExpr(values, type, sourceSpan);
            }
            function literalMap(values, type) {
                if (type === void 0) { type = null; }
                return new LiteralMapExpr(values.map(function (e) { return new LiteralMapEntry(e.key, e.value, e.quoted); }), type, null);
            }
            function not(expr, sourceSpan) {
                return new NotExpr(expr, sourceSpan);
            }
            function assertNotNull(expr, sourceSpan) {
                return new AssertNotNull(expr, sourceSpan);
            }
            function fn(params, body, type, sourceSpan, name) {
                return new FunctionExpr(params, body, type, sourceSpan, name);
            }
            function ifStmt(condition, thenClause, elseClause) {
                return new IfStmt(condition, thenClause, elseClause);
            }
            function literal(value, type, sourceSpan) {
                return new LiteralExpr(value, type, sourceSpan);
            }
            function isNull(exp) {
                return exp instanceof LiteralExpr && exp.value === null;
            }
            /*
             * Serializes a `Tag` into a string.
             * Returns a string like " @foo {bar} baz" (note the leading whitespace before `@foo`).
             */
            function tagToString(tag) {
                var out = '';
                if (tag.tagName) {
                    out += " @" + tag.tagName;
                }
                if (tag.text) {
                    if (tag.text.match(/\/\*|\*\//)) {
                        throw new Error('JSDoc text cannot contain "/*" and "*/"');
                    }
                    out += ' ' + tag.text.replace(/@/g, '\\@');
                }
                return out;
            }
            function serializeTags(tags) {
                if (tags.length === 0)
                    return '';
                var out = '*\n';
                for (var _c = 0, tags_1 = tags; _c < tags_1.length; _c++) {
                    var tag = tags_1[_c];
                    out += ' *';
                    // If the tagToString is multi-line, insert " * " prefixes on subsequent lines.
                    out += tagToString(tag).replace(/\n/g, '\n * ');
                    out += '\n';
                }
                out += ' ';
                return out;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
            function dashCaseToCamelCase(input) {
                return input.replace(DASH_CASE_REGEXP, function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    return m[1].toUpperCase();
                });
            }
            function splitAtColon(input, defaultValues) {
                return _splitAt(input, ':', defaultValues);
            }
            function splitAtPeriod(input, defaultValues) {
                return _splitAt(input, '.', defaultValues);
            }
            function _splitAt(input, character, defaultValues) {
                var characterIndex = input.indexOf(character);
                if (characterIndex == -1)
                    return defaultValues;
                return [input.slice(0, characterIndex).trim(), input.slice(characterIndex + 1).trim()];
            }
            function visitValue(value, visitor, context) {
                if (Array.isArray(value)) {
                    return visitor.visitArray(value, context);
                }
                if (isStrictStringMap(value)) {
                    return visitor.visitStringMap(value, context);
                }
                if (value == null || typeof value == 'string' || typeof value == 'number' ||
                    typeof value == 'boolean') {
                    return visitor.visitPrimitive(value, context);
                }
                return visitor.visitOther(value, context);
            }
            function isDefined(val) {
                return val !== null && val !== undefined;
            }
            function noUndefined(val) {
                return val === undefined ? null : val;
            }
            var ValueTransformer = /** @class */ (function () {
                function ValueTransformer() {
                }
                ValueTransformer.prototype.visitArray = function (arr, context) {
                    var _this = this;
                    return arr.map(function (value) { return visitValue(value, _this, context); });
                };
                ValueTransformer.prototype.visitStringMap = function (map, context) {
                    var _this = this;
                    var result = {};
                    Object.keys(map).forEach(function (key) { result[key] = visitValue(map[key], _this, context); });
                    return result;
                };
                ValueTransformer.prototype.visitPrimitive = function (value, context) { return value; };
                ValueTransformer.prototype.visitOther = function (value, context) { return value; };
                return ValueTransformer;
            }());
            var SyncAsync = {
                assertSync: function (value) {
                    if (isPromise(value)) {
                        throw new Error("Illegal state: value cannot be a promise");
                    }
                    return value;
                },
                then: function (value, cb) { return isPromise(value) ? value.then(cb) : cb(value); },
                all: function (syncAsyncValues) {
                    return syncAsyncValues.some(isPromise) ? Promise.all(syncAsyncValues) : syncAsyncValues;
                }
            };
            function error(msg) {
                throw new Error("Internal Error: " + msg);
            }
            function syntaxError(msg, parseErrors) {
                var error = Error(msg);
                error[ERROR_SYNTAX_ERROR] = true;
                if (parseErrors)
                    error[ERROR_PARSE_ERRORS] = parseErrors;
                return error;
            }
            var ERROR_SYNTAX_ERROR = 'ngSyntaxError';
            var ERROR_PARSE_ERRORS = 'ngParseErrors';
            function isSyntaxError(error) {
                return error[ERROR_SYNTAX_ERROR];
            }
            function getParseErrors(error) {
                return error[ERROR_PARSE_ERRORS] || [];
            }
            // Escape characters that have a special meaning in Regular Expressions
            function escapeRegExp(s) {
                return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
            }
            var STRING_MAP_PROTO = Object.getPrototypeOf({});
            function isStrictStringMap(obj) {
                return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
            }
            function utf8Encode(str) {
                var encoded = '';
                for (var index = 0; index < str.length; index++) {
                    var codePoint = str.charCodeAt(index);
                    // decode surrogate
                    // see https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    if (codePoint >= 0xd800 && codePoint <= 0xdbff && str.length > (index + 1)) {
                        var low = str.charCodeAt(index + 1);
                        if (low >= 0xdc00 && low <= 0xdfff) {
                            index++;
                            codePoint = ((codePoint - 0xd800) << 10) + low - 0xdc00 + 0x10000;
                        }
                    }
                    if (codePoint <= 0x7f) {
                        encoded += String.fromCharCode(codePoint);
                    }
                    else if (codePoint <= 0x7ff) {
                        encoded += String.fromCharCode(((codePoint >> 6) & 0x1F) | 0xc0, (codePoint & 0x3f) | 0x80);
                    }
                    else if (codePoint <= 0xffff) {
                        encoded += String.fromCharCode((codePoint >> 12) | 0xe0, ((codePoint >> 6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
                    }
                    else if (codePoint <= 0x1fffff) {
                        encoded += String.fromCharCode(((codePoint >> 18) & 0x07) | 0xf0, ((codePoint >> 12) & 0x3f) | 0x80, ((codePoint >> 6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
                    }
                }
                return encoded;
            }
            function stringify(token) {
                if (typeof token === 'string') {
                    return token;
                }
                if (token instanceof Array) {
                    return '[' + token.map(stringify).join(', ') + ']';
                }
                if (token == null) {
                    return '' + token;
                }
                if (token.overriddenName) {
                    return "" + token.overriddenName;
                }
                if (token.name) {
                    return "" + token.name;
                }
                if (!token.toString) {
                    return 'object';
                }
                // WARNING: do not try to `JSON.stringify(token)` here
                // see https://github.com/angular/angular/issues/23440
                var res = token.toString();
                if (res == null) {
                    return '' + res;
                }
                var newLineIndex = res.indexOf('\n');
                return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
            }
            /**
             * Lazily retrieves the reference value from a forwardRef.
             */
            function resolveForwardRef(type) {
                if (typeof type === 'function' && type.hasOwnProperty('__forward_ref__')) {
                    return type();
                }
                else {
                    return type;
                }
            }
            /**
             * Determine if the argument is shaped like a Promise
             */
            function isPromise(obj) {
                // allow any Promise/A+ compliant thenable.
                // It's up to the caller to ensure that obj.then conforms to the spec
                return !!obj && typeof obj.then === 'function';
            }
            var Version = /** @class */ (function () {
                function Version(full) {
                    this.full = full;
                    var splits = full.split('.');
                    this.major = splits[0];
                    this.minor = splits[1];
                    this.patch = splits.slice(2).join('.');
                }
                return Version;
            }());
            var __window = typeof window !== 'undefined' && window;
            var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
                self instanceof WorkerGlobalScope && self;
            var __global = typeof global !== 'undefined' && global;
            // Check __global first, because in Node tests both __global and __window may be defined and _global
            // should be __global in that case.
            var _global = __global || __window || __self;
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var CONSTANT_PREFIX = '_c';
            /**
             * Context to use when producing a key.
             *
             * This ensures we see the constant not the reference variable when producing
             * a key.
             */
            var KEY_CONTEXT = {};
            /**
             * A node that is a place-holder that allows the node to be replaced when the actual
             * node is known.
             *
             * This allows the constant pool to change an expression from a direct reference to
             * a constant to a shared constant. It returns a fix-up node that is later allowed to
             * change the referenced expression.
             */
            var FixupExpression = /** @class */ (function (_super_1) {
                __extends(FixupExpression, _super_1);
                function FixupExpression(resolved) {
                    var _this = _super_1.call(this, resolved.type) || this;
                    _this.resolved = resolved;
                    _this.original = resolved;
                    return _this;
                }
                FixupExpression.prototype.visitExpression = function (visitor, context) {
                    if (context === KEY_CONTEXT) {
                        // When producing a key we want to traverse the constant not the
                        // variable used to refer to it.
                        return this.original.visitExpression(visitor, context);
                    }
                    else {
                        return this.resolved.visitExpression(visitor, context);
                    }
                };
                FixupExpression.prototype.isEquivalent = function (e) {
                    return e instanceof FixupExpression && this.resolved.isEquivalent(e.resolved);
                };
                FixupExpression.prototype.isConstant = function () { return true; };
                FixupExpression.prototype.fixup = function (expression) {
                    this.resolved = expression;
                    this.shared = true;
                };
                return FixupExpression;
            }(Expression));
            /**
             * A constant pool allows a code emitter to share constant in an output context.
             *
             * The constant pool also supports sharing access to ivy definitions references.
             */
            var ConstantPool = /** @class */ (function () {
                function ConstantPool() {
                    this.statements = [];
                    this.literals = new Map();
                    this.literalFactories = new Map();
                    this.injectorDefinitions = new Map();
                    this.directiveDefinitions = new Map();
                    this.componentDefinitions = new Map();
                    this.pipeDefinitions = new Map();
                    this.nextNameIndex = 0;
                }
                ConstantPool.prototype.getConstLiteral = function (literal, forceShared) {
                    if (literal instanceof LiteralExpr || literal instanceof FixupExpression) {
                        // Do no put simple literals into the constant pool or try to produce a constant for a
                        // reference to a constant.
                        return literal;
                    }
                    var key = this.keyOf(literal);
                    var fixup = this.literals.get(key);
                    var newValue = false;
                    if (!fixup) {
                        fixup = new FixupExpression(literal);
                        this.literals.set(key, fixup);
                        newValue = true;
                    }
                    if ((!newValue && !fixup.shared) || (newValue && forceShared)) {
                        // Replace the expression with a variable
                        var name = this.freshName();
                        this.statements.push(variable(name).set(literal).toDeclStmt(INFERRED_TYPE, [StmtModifier.Final]));
                        fixup.fixup(variable(name));
                    }
                    return fixup;
                };
                ConstantPool.prototype.getDefinition = function (type, kind, ctx, forceShared) {
                    if (forceShared === void 0) { forceShared = false; }
                    var definitions = this.definitionsOf(kind);
                    var fixup = definitions.get(type);
                    var newValue = false;
                    if (!fixup) {
                        var property = this.propertyNameOf(kind);
                        fixup = new FixupExpression(ctx.importExpr(type).prop(property));
                        definitions.set(type, fixup);
                        newValue = true;
                    }
                    if ((!newValue && !fixup.shared) || (newValue && forceShared)) {
                        var name = this.freshName();
                        this.statements.push(variable(name).set(fixup.resolved).toDeclStmt(INFERRED_TYPE, [StmtModifier.Final]));
                        fixup.fixup(variable(name));
                    }
                    return fixup;
                };
                ConstantPool.prototype.getLiteralFactory = function (literal$1) {
                    // Create a pure function that builds an array of a mix of constant  and variable expressions
                    if (literal$1 instanceof LiteralArrayExpr) {
                        var argumentsForKey = literal$1.entries.map(function (e) { return e.isConstant() ? e : literal(null); });
                        var key = this.keyOf(literalArr(argumentsForKey));
                        return this._getLiteralFactory(key, literal$1.entries, function (entries) { return literalArr(entries); });
                    }
                    else {
                        var expressionForKey = literalMap(literal$1.entries.map(function (e) { return ({
                            key: e.key,
                            value: e.value.isConstant() ? e.value : literal(null),
                            quoted: e.quoted
                        }); }));
                        var key = this.keyOf(expressionForKey);
                        return this._getLiteralFactory(key, literal$1.entries.map(function (e) { return e.value; }), function (entries) { return literalMap(entries.map(function (value, index) { return ({
                            key: literal$1.entries[index].key,
                            value: value,
                            quoted: literal$1.entries[index].quoted
                        }); })); });
                    }
                };
                ConstantPool.prototype._getLiteralFactory = function (key, values, resultMap) {
                    var _this = this;
                    var literalFactory = this.literalFactories.get(key);
                    var literalFactoryArguments = values.filter((function (e) { return !e.isConstant(); }));
                    if (!literalFactory) {
                        var resultExpressions = values.map(function (e, index) { return e.isConstant() ? _this.getConstLiteral(e, true) : variable("a" + index); });
                        var parameters = resultExpressions.filter(isVariable).map(function (e) { return new FnParam(e.name, DYNAMIC_TYPE); });
                        var pureFunctionDeclaration = fn(parameters, [new ReturnStatement(resultMap(resultExpressions))], INFERRED_TYPE);
                        var name = this.freshName();
                        this.statements.push(variable(name).set(pureFunctionDeclaration).toDeclStmt(INFERRED_TYPE, [
                            StmtModifier.Final
                        ]));
                        literalFactory = variable(name);
                        this.literalFactories.set(key, literalFactory);
                    }
                    return { literalFactory: literalFactory, literalFactoryArguments: literalFactoryArguments };
                };
                /**
                 * Produce a unique name.
                 *
                 * The name might be unique among different prefixes if any of the prefixes end in
                 * a digit so the prefix should be a constant string (not based on user input) and
                 * must not end in a digit.
                 */
                ConstantPool.prototype.uniqueName = function (prefix) { return "" + prefix + this.nextNameIndex++; };
                ConstantPool.prototype.definitionsOf = function (kind) {
                    switch (kind) {
                        case 2 /* Component */:
                            return this.componentDefinitions;
                        case 1 /* Directive */:
                            return this.directiveDefinitions;
                        case 0 /* Injector */:
                            return this.injectorDefinitions;
                        case 3 /* Pipe */:
                            return this.pipeDefinitions;
                    }
                    error("Unknown definition kind " + kind);
                    return this.componentDefinitions;
                };
                ConstantPool.prototype.propertyNameOf = function (kind) {
                    switch (kind) {
                        case 2 /* Component */:
                            return 'ngComponentDef';
                        case 1 /* Directive */:
                            return 'ngDirectiveDef';
                        case 0 /* Injector */:
                            return 'ngInjectorDef';
                        case 3 /* Pipe */:
                            return 'ngPipeDef';
                    }
                    error("Unknown definition kind " + kind);
                    return '<unknown>';
                };
                ConstantPool.prototype.freshName = function () { return this.uniqueName(CONSTANT_PREFIX); };
                ConstantPool.prototype.keyOf = function (expression) {
                    return expression.visitExpression(new KeyVisitor(), KEY_CONTEXT);
                };
                return ConstantPool;
            }());
            /**
             * Visitor used to determine if 2 expressions are equivalent and can be shared in the
             * `ConstantPool`.
             *
             * When the id (string) generated by the visitor is equal, expressions are considered equivalent.
             */
            var KeyVisitor = /** @class */ (function () {
                function KeyVisitor() {
                    this.visitWrappedNodeExpr = invalid;
                    this.visitWriteVarExpr = invalid;
                    this.visitWriteKeyExpr = invalid;
                    this.visitWritePropExpr = invalid;
                    this.visitInvokeMethodExpr = invalid;
                    this.visitInvokeFunctionExpr = invalid;
                    this.visitInstantiateExpr = invalid;
                    this.visitConditionalExpr = invalid;
                    this.visitNotExpr = invalid;
                    this.visitAssertNotNullExpr = invalid;
                    this.visitCastExpr = invalid;
                    this.visitFunctionExpr = invalid;
                    this.visitBinaryOperatorExpr = invalid;
                    this.visitReadPropExpr = invalid;
                    this.visitReadKeyExpr = invalid;
                    this.visitCommaExpr = invalid;
                }
                KeyVisitor.prototype.visitLiteralExpr = function (ast) {
                    return "" + (typeof ast.value === 'string' ? '"' + ast.value + '"' : ast.value);
                };
                KeyVisitor.prototype.visitLiteralArrayExpr = function (ast, context) {
                    var _this = this;
                    return "[" + ast.entries.map(function (entry) { return entry.visitExpression(_this, context); }).join(',') + "]";
                };
                KeyVisitor.prototype.visitLiteralMapExpr = function (ast, context) {
                    var _this = this;
                    var mapKey = function (entry) {
                        var quote = entry.quoted ? '"' : '';
                        return "" + quote + entry.key + quote;
                    };
                    var mapEntry = function (entry) { return mapKey(entry) + ":" + entry.value.visitExpression(_this, context); };
                    return "{" + ast.entries.map(mapEntry).join(',');
                };
                KeyVisitor.prototype.visitExternalExpr = function (ast) {
                    return ast.value.moduleName ? "EX:" + ast.value.moduleName + ":" + ast.value.name :
                        "EX:" + ast.value.runtime.name;
                };
                KeyVisitor.prototype.visitReadVarExpr = function (node) { return "VAR:" + node.name; };
                KeyVisitor.prototype.visitTypeofExpr = function (node, context) {
                    return "TYPEOF:" + node.expr.visitExpression(this, context);
                };
                return KeyVisitor;
            }());
            function invalid(arg) {
                throw new Error("Invalid state: Visitor " + this.constructor.name + " doesn't handle " + arg.constructor.name);
            }
            function isVariable(e) {
                return e instanceof ReadVarExpr;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var CORE = '@angular/core';
            var Identifiers = /** @class */ (function () {
                function Identifiers() {
                }
                return Identifiers;
            }());
            Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS = {
                name: 'ANALYZE_FOR_ENTRY_COMPONENTS',
                moduleName: CORE,
            };
            Identifiers.ElementRef = { name: 'ElementRef', moduleName: CORE };
            Identifiers.NgModuleRef = { name: 'NgModuleRef', moduleName: CORE };
            Identifiers.ViewContainerRef = { name: 'ViewContainerRef', moduleName: CORE };
            Identifiers.ChangeDetectorRef = {
                name: 'ChangeDetectorRef',
                moduleName: CORE,
            };
            Identifiers.QueryList = { name: 'QueryList', moduleName: CORE };
            Identifiers.TemplateRef = { name: 'TemplateRef', moduleName: CORE };
            Identifiers.Renderer2 = { name: 'Renderer2', moduleName: CORE };
            Identifiers.CodegenComponentFactoryResolver = {
                name: 'ɵCodegenComponentFactoryResolver',
                moduleName: CORE,
            };
            Identifiers.ComponentFactoryResolver = {
                name: 'ComponentFactoryResolver',
                moduleName: CORE,
            };
            Identifiers.ComponentFactory = { name: 'ComponentFactory', moduleName: CORE };
            Identifiers.ComponentRef = { name: 'ComponentRef', moduleName: CORE };
            Identifiers.NgModuleFactory = { name: 'NgModuleFactory', moduleName: CORE };
            Identifiers.createModuleFactory = {
                name: 'ɵcmf',
                moduleName: CORE,
            };
            Identifiers.moduleDef = {
                name: 'ɵmod',
                moduleName: CORE,
            };
            Identifiers.moduleProviderDef = {
                name: 'ɵmpd',
                moduleName: CORE,
            };
            Identifiers.RegisterModuleFactoryFn = {
                name: 'ɵregisterModuleFactory',
                moduleName: CORE,
            };
            Identifiers.inject = { name: 'ɵɵinject', moduleName: CORE };
            Identifiers.INJECTOR = { name: 'INJECTOR', moduleName: CORE };
            Identifiers.Injector = { name: 'Injector', moduleName: CORE };
            Identifiers.ɵɵdefineInjectable = { name: 'ɵɵdefineInjectable', moduleName: CORE };
            Identifiers.InjectableDef = { name: 'ɵɵInjectableDef', moduleName: CORE };
            Identifiers.ViewEncapsulation = {
                name: 'ViewEncapsulation',
                moduleName: CORE,
            };
            Identifiers.ChangeDetectionStrategy = {
                name: 'ChangeDetectionStrategy',
                moduleName: CORE,
            };
            Identifiers.SecurityContext = {
                name: 'SecurityContext',
                moduleName: CORE,
            };
            Identifiers.LOCALE_ID = { name: 'LOCALE_ID', moduleName: CORE };
            Identifiers.TRANSLATIONS_FORMAT = {
                name: 'TRANSLATIONS_FORMAT',
                moduleName: CORE,
            };
            Identifiers.inlineInterpolate = {
                name: 'ɵinlineInterpolate',
                moduleName: CORE,
            };
            Identifiers.interpolate = { name: 'ɵinterpolate', moduleName: CORE };
            Identifiers.EMPTY_ARRAY = { name: 'ɵEMPTY_ARRAY', moduleName: CORE };
            Identifiers.EMPTY_MAP = { name: 'ɵEMPTY_MAP', moduleName: CORE };
            Identifiers.Renderer = { name: 'Renderer', moduleName: CORE };
            Identifiers.viewDef = { name: 'ɵvid', moduleName: CORE };
            Identifiers.elementDef = { name: 'ɵeld', moduleName: CORE };
            Identifiers.anchorDef = { name: 'ɵand', moduleName: CORE };
            Identifiers.textDef = { name: 'ɵted', moduleName: CORE };
            Identifiers.directiveDef = { name: 'ɵdid', moduleName: CORE };
            Identifiers.providerDef = { name: 'ɵprd', moduleName: CORE };
            Identifiers.queryDef = { name: 'ɵqud', moduleName: CORE };
            Identifiers.pureArrayDef = { name: 'ɵpad', moduleName: CORE };
            Identifiers.pureObjectDef = { name: 'ɵpod', moduleName: CORE };
            Identifiers.purePipeDef = { name: 'ɵppd', moduleName: CORE };
            Identifiers.pipeDef = { name: 'ɵpid', moduleName: CORE };
            Identifiers.nodeValue = { name: 'ɵnov', moduleName: CORE };
            Identifiers.ngContentDef = { name: 'ɵncd', moduleName: CORE };
            Identifiers.unwrapValue = { name: 'ɵunv', moduleName: CORE };
            Identifiers.createRendererType2 = { name: 'ɵcrt', moduleName: CORE };
            // type only
            Identifiers.RendererType2 = {
                name: 'RendererType2',
                moduleName: CORE,
            };
            // type only
            Identifiers.ViewDefinition = {
                name: 'ɵViewDefinition',
                moduleName: CORE,
            };
            Identifiers.createComponentFactory = { name: 'ɵccf', moduleName: CORE };
            Identifiers.setClassMetadata = { name: 'ɵsetClassMetadata', moduleName: CORE };
            function createTokenForReference(reference) {
                return { identifier: { reference: reference } };
            }
            function createTokenForExternalReference(reflector, reference) {
                return createTokenForReference(reflector.resolveExternalReference(reference));
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A token representing the a reference to a static type.
             *
             * This token is unique for a filePath and name and can be used as a hash table key.
             */
            var StaticSymbol = /** @class */ (function () {
                function StaticSymbol(filePath, name, members) {
                    this.filePath = filePath;
                    this.name = name;
                    this.members = members;
                }
                StaticSymbol.prototype.assertNoMembers = function () {
                    if (this.members.length) {
                        throw new Error("Illegal state: symbol without members expected, but got " + JSON.stringify(this) + ".");
                    }
                };
                return StaticSymbol;
            }());
            /**
             * A cache of static symbol used by the StaticReflector to return the same symbol for the
             * same symbol values.
             */
            var StaticSymbolCache = /** @class */ (function () {
                function StaticSymbolCache() {
                    this.cache = new Map();
                }
                StaticSymbolCache.prototype.get = function (declarationFile, name, members) {
                    members = members || [];
                    var memberSuffix = members.length ? "." + members.join('.') : '';
                    var key = "\"" + declarationFile + "\"." + name + memberSuffix;
                    var result = this.cache.get(key);
                    if (!result) {
                        result = new StaticSymbol(declarationFile, name, members);
                        this.cache.set(key, result);
                    }
                    return result;
                };
                return StaticSymbolCache;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // group 0: "[prop] or (event) or @trigger"
            // group 1: "prop" from "[prop]"
            // group 2: "event" from "(event)"
            // group 3: "@trigger" from "@trigger"
            var HOST_REG_EXP = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function sanitizeIdentifier(name) {
                return name.replace(/\W/g, '_');
            }
            var _anonymousTypeIndex = 0;
            function identifierName(compileIdentifier) {
                if (!compileIdentifier || !compileIdentifier.reference) {
                    return null;
                }
                var ref = compileIdentifier.reference;
                if (ref instanceof StaticSymbol) {
                    return ref.name;
                }
                if (ref['__anonymousType']) {
                    return ref['__anonymousType'];
                }
                var identifier = stringify(ref);
                if (identifier.indexOf('(') >= 0) {
                    // case: anonymous functions!
                    identifier = "anonymous_" + _anonymousTypeIndex++;
                    ref['__anonymousType'] = identifier;
                }
                else {
                    identifier = sanitizeIdentifier(identifier);
                }
                return identifier;
            }
            function identifierModuleUrl(compileIdentifier) {
                var ref = compileIdentifier.reference;
                if (ref instanceof StaticSymbol) {
                    return ref.filePath;
                }
                // Runtime type
                return "./" + stringify(ref);
            }
            function viewClassName(compType, embeddedTemplateIndex) {
                return "View_" + identifierName({ reference: compType }) + "_" + embeddedTemplateIndex;
            }
            function rendererTypeName(compType) {
                return "RenderType_" + identifierName({ reference: compType });
            }
            function hostViewClassName(compType) {
                return "HostView_" + identifierName({ reference: compType });
            }
            function componentFactoryName(compType) {
                return identifierName({ reference: compType }) + "NgFactory";
            }
            var CompileSummaryKind;
            (function (CompileSummaryKind) {
                CompileSummaryKind[CompileSummaryKind["Pipe"] = 0] = "Pipe";
                CompileSummaryKind[CompileSummaryKind["Directive"] = 1] = "Directive";
                CompileSummaryKind[CompileSummaryKind["NgModule"] = 2] = "NgModule";
                CompileSummaryKind[CompileSummaryKind["Injectable"] = 3] = "Injectable";
            })(CompileSummaryKind || (CompileSummaryKind = {}));
            function tokenName(token) {
                return token.value != null ? sanitizeIdentifier(token.value) : identifierName(token.identifier);
            }
            function tokenReference(token) {
                if (token.identifier != null) {
                    return token.identifier.reference;
                }
                else {
                    return token.value;
                }
            }
            /**
             * Metadata about a stylesheet
             */
            var CompileStylesheetMetadata = /** @class */ (function () {
                function CompileStylesheetMetadata(_c) {
                    var _d = _c === void 0 ? {} : _c, moduleUrl = _d.moduleUrl, styles = _d.styles, styleUrls = _d.styleUrls;
                    this.moduleUrl = moduleUrl || null;
                    this.styles = _normalizeArray(styles);
                    this.styleUrls = _normalizeArray(styleUrls);
                }
                return CompileStylesheetMetadata;
            }());
            /**
             * Metadata regarding compilation of a template.
             */
            var CompileTemplateMetadata = /** @class */ (function () {
                function CompileTemplateMetadata(_c) {
                    var encapsulation = _c.encapsulation, template = _c.template, templateUrl = _c.templateUrl, htmlAst = _c.htmlAst, styles = _c.styles, styleUrls = _c.styleUrls, externalStylesheets = _c.externalStylesheets, animations = _c.animations, ngContentSelectors = _c.ngContentSelectors, interpolation = _c.interpolation, isInline = _c.isInline, preserveWhitespaces = _c.preserveWhitespaces;
                    this.encapsulation = encapsulation;
                    this.template = template;
                    this.templateUrl = templateUrl;
                    this.htmlAst = htmlAst;
                    this.styles = _normalizeArray(styles);
                    this.styleUrls = _normalizeArray(styleUrls);
                    this.externalStylesheets = _normalizeArray(externalStylesheets);
                    this.animations = animations ? flatten(animations) : [];
                    this.ngContentSelectors = ngContentSelectors || [];
                    if (interpolation && interpolation.length != 2) {
                        throw new Error("'interpolation' should have a start and an end symbol.");
                    }
                    this.interpolation = interpolation;
                    this.isInline = isInline;
                    this.preserveWhitespaces = preserveWhitespaces;
                }
                CompileTemplateMetadata.prototype.toSummary = function () {
                    return {
                        ngContentSelectors: this.ngContentSelectors,
                        encapsulation: this.encapsulation,
                        styles: this.styles,
                        animations: this.animations
                    };
                };
                return CompileTemplateMetadata;
            }());
            /**
             * Metadata regarding compilation of a directive.
             */
            var CompileDirectiveMetadata = /** @class */ (function () {
                function CompileDirectiveMetadata(_c) {
                    var isHost = _c.isHost, type = _c.type, isComponent = _c.isComponent, selector = _c.selector, exportAs = _c.exportAs, changeDetection = _c.changeDetection, inputs = _c.inputs, outputs = _c.outputs, hostListeners = _c.hostListeners, hostProperties = _c.hostProperties, hostAttributes = _c.hostAttributes, providers = _c.providers, viewProviders = _c.viewProviders, queries = _c.queries, guards = _c.guards, viewQueries = _c.viewQueries, entryComponents = _c.entryComponents, template = _c.template, componentViewType = _c.componentViewType, rendererType = _c.rendererType, componentFactory = _c.componentFactory;
                    this.isHost = !!isHost;
                    this.type = type;
                    this.isComponent = isComponent;
                    this.selector = selector;
                    this.exportAs = exportAs;
                    this.changeDetection = changeDetection;
                    this.inputs = inputs;
                    this.outputs = outputs;
                    this.hostListeners = hostListeners;
                    this.hostProperties = hostProperties;
                    this.hostAttributes = hostAttributes;
                    this.providers = _normalizeArray(providers);
                    this.viewProviders = _normalizeArray(viewProviders);
                    this.queries = _normalizeArray(queries);
                    this.guards = guards;
                    this.viewQueries = _normalizeArray(viewQueries);
                    this.entryComponents = _normalizeArray(entryComponents);
                    this.template = template;
                    this.componentViewType = componentViewType;
                    this.rendererType = rendererType;
                    this.componentFactory = componentFactory;
                }
                CompileDirectiveMetadata.create = function (_c) {
                    var isHost = _c.isHost, type = _c.type, isComponent = _c.isComponent, selector = _c.selector, exportAs = _c.exportAs, changeDetection = _c.changeDetection, inputs = _c.inputs, outputs = _c.outputs, host = _c.host, providers = _c.providers, viewProviders = _c.viewProviders, queries = _c.queries, guards = _c.guards, viewQueries = _c.viewQueries, entryComponents = _c.entryComponents, template = _c.template, componentViewType = _c.componentViewType, rendererType = _c.rendererType, componentFactory = _c.componentFactory;
                    var hostListeners = {};
                    var hostProperties = {};
                    var hostAttributes = {};
                    if (host != null) {
                        Object.keys(host).forEach(function (key) {
                            var value = host[key];
                            var matches = key.match(HOST_REG_EXP);
                            if (matches === null) {
                                hostAttributes[key] = value;
                            }
                            else if (matches[1] != null) {
                                hostProperties[matches[1]] = value;
                            }
                            else if (matches[2] != null) {
                                hostListeners[matches[2]] = value;
                            }
                        });
                    }
                    var inputsMap = {};
                    if (inputs != null) {
                        inputs.forEach(function (bindConfig) {
                            // canonical syntax: `dirProp: elProp`
                            // if there is no `:`, use dirProp = elProp
                            var parts = splitAtColon(bindConfig, [bindConfig, bindConfig]);
                            inputsMap[parts[0]] = parts[1];
                        });
                    }
                    var outputsMap = {};
                    if (outputs != null) {
                        outputs.forEach(function (bindConfig) {
                            // canonical syntax: `dirProp: elProp`
                            // if there is no `:`, use dirProp = elProp
                            var parts = splitAtColon(bindConfig, [bindConfig, bindConfig]);
                            outputsMap[parts[0]] = parts[1];
                        });
                    }
                    return new CompileDirectiveMetadata({
                        isHost: isHost,
                        type: type,
                        isComponent: !!isComponent, selector: selector, exportAs: exportAs, changeDetection: changeDetection,
                        inputs: inputsMap,
                        outputs: outputsMap,
                        hostListeners: hostListeners,
                        hostProperties: hostProperties,
                        hostAttributes: hostAttributes,
                        providers: providers,
                        viewProviders: viewProviders,
                        queries: queries,
                        guards: guards,
                        viewQueries: viewQueries,
                        entryComponents: entryComponents,
                        template: template,
                        componentViewType: componentViewType,
                        rendererType: rendererType,
                        componentFactory: componentFactory,
                    });
                };
                CompileDirectiveMetadata.prototype.toSummary = function () {
                    return {
                        summaryKind: CompileSummaryKind.Directive,
                        type: this.type,
                        isComponent: this.isComponent,
                        selector: this.selector,
                        exportAs: this.exportAs,
                        inputs: this.inputs,
                        outputs: this.outputs,
                        hostListeners: this.hostListeners,
                        hostProperties: this.hostProperties,
                        hostAttributes: this.hostAttributes,
                        providers: this.providers,
                        viewProviders: this.viewProviders,
                        queries: this.queries,
                        guards: this.guards,
                        viewQueries: this.viewQueries,
                        entryComponents: this.entryComponents,
                        changeDetection: this.changeDetection,
                        template: this.template && this.template.toSummary(),
                        componentViewType: this.componentViewType,
                        rendererType: this.rendererType,
                        componentFactory: this.componentFactory
                    };
                };
                return CompileDirectiveMetadata;
            }());
            var CompilePipeMetadata = /** @class */ (function () {
                function CompilePipeMetadata(_c) {
                    var type = _c.type, name = _c.name, pure = _c.pure;
                    this.type = type;
                    this.name = name;
                    this.pure = !!pure;
                }
                CompilePipeMetadata.prototype.toSummary = function () {
                    return {
                        summaryKind: CompileSummaryKind.Pipe,
                        type: this.type,
                        name: this.name,
                        pure: this.pure
                    };
                };
                return CompilePipeMetadata;
            }());
            var CompileShallowModuleMetadata = /** @class */ (function () {
                function CompileShallowModuleMetadata() {
                }
                return CompileShallowModuleMetadata;
            }());
            /**
             * Metadata regarding compilation of a module.
             */
            var CompileNgModuleMetadata = /** @class */ (function () {
                function CompileNgModuleMetadata(_c) {
                    var type = _c.type, providers = _c.providers, declaredDirectives = _c.declaredDirectives, exportedDirectives = _c.exportedDirectives, declaredPipes = _c.declaredPipes, exportedPipes = _c.exportedPipes, entryComponents = _c.entryComponents, bootstrapComponents = _c.bootstrapComponents, importedModules = _c.importedModules, exportedModules = _c.exportedModules, schemas = _c.schemas, transitiveModule = _c.transitiveModule, id = _c.id;
                    this.type = type || null;
                    this.declaredDirectives = _normalizeArray(declaredDirectives);
                    this.exportedDirectives = _normalizeArray(exportedDirectives);
                    this.declaredPipes = _normalizeArray(declaredPipes);
                    this.exportedPipes = _normalizeArray(exportedPipes);
                    this.providers = _normalizeArray(providers);
                    this.entryComponents = _normalizeArray(entryComponents);
                    this.bootstrapComponents = _normalizeArray(bootstrapComponents);
                    this.importedModules = _normalizeArray(importedModules);
                    this.exportedModules = _normalizeArray(exportedModules);
                    this.schemas = _normalizeArray(schemas);
                    this.id = id || null;
                    this.transitiveModule = transitiveModule || null;
                }
                CompileNgModuleMetadata.prototype.toSummary = function () {
                    var module = this.transitiveModule;
                    return {
                        summaryKind: CompileSummaryKind.NgModule,
                        type: this.type,
                        entryComponents: module.entryComponents,
                        providers: module.providers,
                        modules: module.modules,
                        exportedDirectives: module.exportedDirectives,
                        exportedPipes: module.exportedPipes
                    };
                };
                return CompileNgModuleMetadata;
            }());
            var TransitiveCompileNgModuleMetadata = /** @class */ (function () {
                function TransitiveCompileNgModuleMetadata() {
                    this.directivesSet = new Set();
                    this.directives = [];
                    this.exportedDirectivesSet = new Set();
                    this.exportedDirectives = [];
                    this.pipesSet = new Set();
                    this.pipes = [];
                    this.exportedPipesSet = new Set();
                    this.exportedPipes = [];
                    this.modulesSet = new Set();
                    this.modules = [];
                    this.entryComponentsSet = new Set();
                    this.entryComponents = [];
                    this.providers = [];
                }
                TransitiveCompileNgModuleMetadata.prototype.addProvider = function (provider, module) {
                    this.providers.push({ provider: provider, module: module });
                };
                TransitiveCompileNgModuleMetadata.prototype.addDirective = function (id) {
                    if (!this.directivesSet.has(id.reference)) {
                        this.directivesSet.add(id.reference);
                        this.directives.push(id);
                    }
                };
                TransitiveCompileNgModuleMetadata.prototype.addExportedDirective = function (id) {
                    if (!this.exportedDirectivesSet.has(id.reference)) {
                        this.exportedDirectivesSet.add(id.reference);
                        this.exportedDirectives.push(id);
                    }
                };
                TransitiveCompileNgModuleMetadata.prototype.addPipe = function (id) {
                    if (!this.pipesSet.has(id.reference)) {
                        this.pipesSet.add(id.reference);
                        this.pipes.push(id);
                    }
                };
                TransitiveCompileNgModuleMetadata.prototype.addExportedPipe = function (id) {
                    if (!this.exportedPipesSet.has(id.reference)) {
                        this.exportedPipesSet.add(id.reference);
                        this.exportedPipes.push(id);
                    }
                };
                TransitiveCompileNgModuleMetadata.prototype.addModule = function (id) {
                    if (!this.modulesSet.has(id.reference)) {
                        this.modulesSet.add(id.reference);
                        this.modules.push(id);
                    }
                };
                TransitiveCompileNgModuleMetadata.prototype.addEntryComponent = function (ec) {
                    if (!this.entryComponentsSet.has(ec.componentType)) {
                        this.entryComponentsSet.add(ec.componentType);
                        this.entryComponents.push(ec);
                    }
                };
                return TransitiveCompileNgModuleMetadata;
            }());
            function _normalizeArray(obj) {
                return obj || [];
            }
            var ProviderMeta = /** @class */ (function () {
                function ProviderMeta(token, _c) {
                    var useClass = _c.useClass, useValue = _c.useValue, useExisting = _c.useExisting, useFactory = _c.useFactory, deps = _c.deps, multi = _c.multi;
                    this.token = token;
                    this.useClass = useClass || null;
                    this.useValue = useValue;
                    this.useExisting = useExisting;
                    this.useFactory = useFactory || null;
                    this.dependencies = deps || null;
                    this.multi = !!multi;
                }
                return ProviderMeta;
            }());
            function flatten(list) {
                return list.reduce(function (flat, item) {
                    var flatItem = Array.isArray(item) ? flatten(item) : item;
                    return flat.concat(flatItem);
                }, []);
            }
            function jitSourceUrl(url) {
                // Note: We need 3 "/" so that ng shows up as a separate domain
                // in the chrome dev tools.
                return url.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, 'ng:///');
            }
            function templateSourceUrl(ngModuleType, compMeta, templateMeta) {
                var url;
                if (templateMeta.isInline) {
                    if (compMeta.type.reference instanceof StaticSymbol) {
                        // Note: a .ts file might contain multiple components with inline templates,
                        // so we need to give them unique urls, as these will be used for sourcemaps.
                        url = compMeta.type.reference.filePath + "." + compMeta.type.reference.name + ".html";
                    }
                    else {
                        url = identifierName(ngModuleType) + "/" + identifierName(compMeta.type) + ".html";
                    }
                }
                else {
                    url = templateMeta.templateUrl;
                }
                return compMeta.type.reference instanceof StaticSymbol ? url : jitSourceUrl(url);
            }
            function sharedStylesheetJitUrl(meta, id) {
                var pathParts = meta.moduleUrl.split(/\/\\/g);
                var baseName = pathParts[pathParts.length - 1];
                return jitSourceUrl("css/" + id + baseName + ".ngstyle.js");
            }
            function ngModuleJitUrl(moduleMeta) {
                return jitSourceUrl(identifierName(moduleMeta.type) + "/module.ngfactory.js");
            }
            function templateJitUrl(ngModuleType, compMeta) {
                return jitSourceUrl(identifierName(ngModuleType) + "/" + identifierName(compMeta.type) + ".ngfactory.js");
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var CORE$1 = '@angular/core';
            var Identifiers$1 = /** @class */ (function () {
                function Identifiers$1() {
                }
                return Identifiers$1;
            }());
            /* Methods */
            Identifiers$1.NEW_METHOD = 'factory';
            Identifiers$1.TRANSFORM_METHOD = 'transform';
            Identifiers$1.PATCH_DEPS = 'patchedDeps';
            /* Instructions */
            Identifiers$1.namespaceHTML = { name: 'ɵɵnamespaceHTML', moduleName: CORE$1 };
            Identifiers$1.namespaceMathML = { name: 'ɵɵnamespaceMathML', moduleName: CORE$1 };
            Identifiers$1.namespaceSVG = { name: 'ɵɵnamespaceSVG', moduleName: CORE$1 };
            Identifiers$1.element = { name: 'ɵɵelement', moduleName: CORE$1 };
            Identifiers$1.elementStart = { name: 'ɵɵelementStart', moduleName: CORE$1 };
            Identifiers$1.elementEnd = { name: 'ɵɵelementEnd', moduleName: CORE$1 };
            Identifiers$1.select = { name: 'ɵɵselect', moduleName: CORE$1 };
            Identifiers$1.updateSyntheticHostBinding = { name: 'ɵɵupdateSyntheticHostBinding', moduleName: CORE$1 };
            Identifiers$1.componentHostSyntheticListener = { name: 'ɵɵcomponentHostSyntheticListener', moduleName: CORE$1 };
            Identifiers$1.attribute = { name: 'ɵɵattribute', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate1 = { name: 'ɵɵattributeInterpolate1', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate2 = { name: 'ɵɵattributeInterpolate2', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate3 = { name: 'ɵɵattributeInterpolate3', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate4 = { name: 'ɵɵattributeInterpolate4', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate5 = { name: 'ɵɵattributeInterpolate5', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate6 = { name: 'ɵɵattributeInterpolate6', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate7 = { name: 'ɵɵattributeInterpolate7', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolate8 = { name: 'ɵɵattributeInterpolate8', moduleName: CORE$1 };
            Identifiers$1.attributeInterpolateV = { name: 'ɵɵattributeInterpolateV', moduleName: CORE$1 };
            Identifiers$1.classProp = { name: 'ɵɵclassProp', moduleName: CORE$1 };
            Identifiers$1.elementContainerStart = { name: 'ɵɵelementContainerStart', moduleName: CORE$1 };
            Identifiers$1.elementContainerEnd = { name: 'ɵɵelementContainerEnd', moduleName: CORE$1 };
            Identifiers$1.elementContainer = { name: 'ɵɵelementContainer', moduleName: CORE$1 };
            Identifiers$1.styling = { name: 'ɵɵstyling', moduleName: CORE$1 };
            Identifiers$1.styleMap = { name: 'ɵɵstyleMap', moduleName: CORE$1 };
            Identifiers$1.classMap = { name: 'ɵɵclassMap', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate1 = { name: 'ɵɵclassMapInterpolate1', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate2 = { name: 'ɵɵclassMapInterpolate2', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate3 = { name: 'ɵɵclassMapInterpolate3', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate4 = { name: 'ɵɵclassMapInterpolate4', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate5 = { name: 'ɵɵclassMapInterpolate5', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate6 = { name: 'ɵɵclassMapInterpolate6', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate7 = { name: 'ɵɵclassMapInterpolate7', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolate8 = { name: 'ɵɵclassMapInterpolate8', moduleName: CORE$1 };
            Identifiers$1.classMapInterpolateV = { name: 'ɵɵclassMapInterpolateV', moduleName: CORE$1 };
            Identifiers$1.styleProp = { name: 'ɵɵstyleProp', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate1 = { name: 'ɵɵstylePropInterpolate1', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate2 = { name: 'ɵɵstylePropInterpolate2', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate3 = { name: 'ɵɵstylePropInterpolate3', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate4 = { name: 'ɵɵstylePropInterpolate4', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate5 = { name: 'ɵɵstylePropInterpolate5', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate6 = { name: 'ɵɵstylePropInterpolate6', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate7 = { name: 'ɵɵstylePropInterpolate7', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolate8 = { name: 'ɵɵstylePropInterpolate8', moduleName: CORE$1 };
            Identifiers$1.stylePropInterpolateV = { name: 'ɵɵstylePropInterpolateV', moduleName: CORE$1 };
            Identifiers$1.stylingApply = { name: 'ɵɵstylingApply', moduleName: CORE$1 };
            Identifiers$1.styleSanitizer = { name: 'ɵɵstyleSanitizer', moduleName: CORE$1 };
            Identifiers$1.elementHostAttrs = { name: 'ɵɵelementHostAttrs', moduleName: CORE$1 };
            Identifiers$1.containerCreate = { name: 'ɵɵcontainer', moduleName: CORE$1 };
            Identifiers$1.nextContext = { name: 'ɵɵnextContext', moduleName: CORE$1 };
            Identifiers$1.templateCreate = { name: 'ɵɵtemplate', moduleName: CORE$1 };
            Identifiers$1.text = { name: 'ɵɵtext', moduleName: CORE$1 };
            Identifiers$1.textBinding = { name: 'ɵɵtextBinding', moduleName: CORE$1 };
            Identifiers$1.enableBindings = { name: 'ɵɵenableBindings', moduleName: CORE$1 };
            Identifiers$1.disableBindings = { name: 'ɵɵdisableBindings', moduleName: CORE$1 };
            Identifiers$1.allocHostVars = { name: 'ɵɵallocHostVars', moduleName: CORE$1 };
            Identifiers$1.getCurrentView = { name: 'ɵɵgetCurrentView', moduleName: CORE$1 };
            Identifiers$1.textInterpolate = { name: 'ɵɵtextInterpolate', moduleName: CORE$1 };
            Identifiers$1.textInterpolate1 = { name: 'ɵɵtextInterpolate1', moduleName: CORE$1 };
            Identifiers$1.textInterpolate2 = { name: 'ɵɵtextInterpolate2', moduleName: CORE$1 };
            Identifiers$1.textInterpolate3 = { name: 'ɵɵtextInterpolate3', moduleName: CORE$1 };
            Identifiers$1.textInterpolate4 = { name: 'ɵɵtextInterpolate4', moduleName: CORE$1 };
            Identifiers$1.textInterpolate5 = { name: 'ɵɵtextInterpolate5', moduleName: CORE$1 };
            Identifiers$1.textInterpolate6 = { name: 'ɵɵtextInterpolate6', moduleName: CORE$1 };
            Identifiers$1.textInterpolate7 = { name: 'ɵɵtextInterpolate7', moduleName: CORE$1 };
            Identifiers$1.textInterpolate8 = { name: 'ɵɵtextInterpolate8', moduleName: CORE$1 };
            Identifiers$1.textInterpolateV = { name: 'ɵɵtextInterpolateV', moduleName: CORE$1 };
            Identifiers$1.restoreView = { name: 'ɵɵrestoreView', moduleName: CORE$1 };
            Identifiers$1.pureFunction0 = { name: 'ɵɵpureFunction0', moduleName: CORE$1 };
            Identifiers$1.pureFunction1 = { name: 'ɵɵpureFunction1', moduleName: CORE$1 };
            Identifiers$1.pureFunction2 = { name: 'ɵɵpureFunction2', moduleName: CORE$1 };
            Identifiers$1.pureFunction3 = { name: 'ɵɵpureFunction3', moduleName: CORE$1 };
            Identifiers$1.pureFunction4 = { name: 'ɵɵpureFunction4', moduleName: CORE$1 };
            Identifiers$1.pureFunction5 = { name: 'ɵɵpureFunction5', moduleName: CORE$1 };
            Identifiers$1.pureFunction6 = { name: 'ɵɵpureFunction6', moduleName: CORE$1 };
            Identifiers$1.pureFunction7 = { name: 'ɵɵpureFunction7', moduleName: CORE$1 };
            Identifiers$1.pureFunction8 = { name: 'ɵɵpureFunction8', moduleName: CORE$1 };
            Identifiers$1.pureFunctionV = { name: 'ɵɵpureFunctionV', moduleName: CORE$1 };
            Identifiers$1.pipeBind1 = { name: 'ɵɵpipeBind1', moduleName: CORE$1 };
            Identifiers$1.pipeBind2 = { name: 'ɵɵpipeBind2', moduleName: CORE$1 };
            Identifiers$1.pipeBind3 = { name: 'ɵɵpipeBind3', moduleName: CORE$1 };
            Identifiers$1.pipeBind4 = { name: 'ɵɵpipeBind4', moduleName: CORE$1 };
            Identifiers$1.pipeBindV = { name: 'ɵɵpipeBindV', moduleName: CORE$1 };
            Identifiers$1.hostProperty = { name: 'ɵɵhostProperty', moduleName: CORE$1 };
            Identifiers$1.property = { name: 'ɵɵproperty', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate = { name: 'ɵɵpropertyInterpolate', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate1 = { name: 'ɵɵpropertyInterpolate1', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate2 = { name: 'ɵɵpropertyInterpolate2', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate3 = { name: 'ɵɵpropertyInterpolate3', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate4 = { name: 'ɵɵpropertyInterpolate4', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate5 = { name: 'ɵɵpropertyInterpolate5', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate6 = { name: 'ɵɵpropertyInterpolate6', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate7 = { name: 'ɵɵpropertyInterpolate7', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolate8 = { name: 'ɵɵpropertyInterpolate8', moduleName: CORE$1 };
            Identifiers$1.propertyInterpolateV = { name: 'ɵɵpropertyInterpolateV', moduleName: CORE$1 };
            Identifiers$1.i18n = { name: 'ɵɵi18n', moduleName: CORE$1 };
            Identifiers$1.i18nAttributes = { name: 'ɵɵi18nAttributes', moduleName: CORE$1 };
            Identifiers$1.i18nExp = { name: 'ɵɵi18nExp', moduleName: CORE$1 };
            Identifiers$1.i18nStart = { name: 'ɵɵi18nStart', moduleName: CORE$1 };
            Identifiers$1.i18nEnd = { name: 'ɵɵi18nEnd', moduleName: CORE$1 };
            Identifiers$1.i18nApply = { name: 'ɵɵi18nApply', moduleName: CORE$1 };
            Identifiers$1.i18nPostprocess = { name: 'ɵɵi18nPostprocess', moduleName: CORE$1 };
            Identifiers$1.i18nLocalize = { name: 'ɵɵi18nLocalize', moduleName: CORE$1 };
            Identifiers$1.load = { name: 'ɵɵload', moduleName: CORE$1 };
            Identifiers$1.pipe = { name: 'ɵɵpipe', moduleName: CORE$1 };
            Identifiers$1.projection = { name: 'ɵɵprojection', moduleName: CORE$1 };
            Identifiers$1.projectionDef = { name: 'ɵɵprojectionDef', moduleName: CORE$1 };
            Identifiers$1.reference = { name: 'ɵɵreference', moduleName: CORE$1 };
            Identifiers$1.inject = { name: 'ɵɵinject', moduleName: CORE$1 };
            Identifiers$1.injectAttribute = { name: 'ɵɵinjectAttribute', moduleName: CORE$1 };
            Identifiers$1.injectPipeChangeDetectorRef = { name: 'ɵɵinjectPipeChangeDetectorRef', moduleName: CORE$1 };
            Identifiers$1.directiveInject = { name: 'ɵɵdirectiveInject', moduleName: CORE$1 };
            Identifiers$1.templateRefExtractor = { name: 'ɵɵtemplateRefExtractor', moduleName: CORE$1 };
            Identifiers$1.resolveWindow = { name: 'ɵɵresolveWindow', moduleName: CORE$1 };
            Identifiers$1.resolveDocument = { name: 'ɵɵresolveDocument', moduleName: CORE$1 };
            Identifiers$1.resolveBody = { name: 'ɵɵresolveBody', moduleName: CORE$1 };
            Identifiers$1.defineBase = { name: 'ɵɵdefineBase', moduleName: CORE$1 };
            Identifiers$1.BaseDef = {
                name: 'ɵɵBaseDef',
                moduleName: CORE$1,
            };
            Identifiers$1.defineComponent = { name: 'ɵɵdefineComponent', moduleName: CORE$1 };
            Identifiers$1.setComponentScope = { name: 'ɵɵsetComponentScope', moduleName: CORE$1 };
            Identifiers$1.ComponentDefWithMeta = {
                name: 'ɵɵComponentDefWithMeta',
                moduleName: CORE$1,
            };
            Identifiers$1.defineDirective = {
                name: 'ɵɵdefineDirective',
                moduleName: CORE$1,
            };
            Identifiers$1.DirectiveDefWithMeta = {
                name: 'ɵɵDirectiveDefWithMeta',
                moduleName: CORE$1,
            };
            Identifiers$1.InjectorDef = {
                name: 'ɵɵInjectorDef',
                moduleName: CORE$1,
            };
            Identifiers$1.defineInjector = {
                name: 'ɵɵdefineInjector',
                moduleName: CORE$1,
            };
            Identifiers$1.NgModuleDefWithMeta = {
                name: 'ɵɵNgModuleDefWithMeta',
                moduleName: CORE$1,
            };
            Identifiers$1.defineNgModule = { name: 'ɵɵdefineNgModule', moduleName: CORE$1 };
            Identifiers$1.setNgModuleScope = { name: 'ɵɵsetNgModuleScope', moduleName: CORE$1 };
            Identifiers$1.PipeDefWithMeta = { name: 'ɵɵPipeDefWithMeta', moduleName: CORE$1 };
            Identifiers$1.definePipe = { name: 'ɵɵdefinePipe', moduleName: CORE$1 };
            Identifiers$1.queryRefresh = { name: 'ɵɵqueryRefresh', moduleName: CORE$1 };
            Identifiers$1.viewQuery = { name: 'ɵɵviewQuery', moduleName: CORE$1 };
            Identifiers$1.staticViewQuery = { name: 'ɵɵstaticViewQuery', moduleName: CORE$1 };
            Identifiers$1.staticContentQuery = { name: 'ɵɵstaticContentQuery', moduleName: CORE$1 };
            Identifiers$1.loadViewQuery = { name: 'ɵɵloadViewQuery', moduleName: CORE$1 };
            Identifiers$1.contentQuery = { name: 'ɵɵcontentQuery', moduleName: CORE$1 };
            Identifiers$1.loadContentQuery = { name: 'ɵɵloadContentQuery', moduleName: CORE$1 };
            Identifiers$1.NgOnChangesFeature = { name: 'ɵɵNgOnChangesFeature', moduleName: CORE$1 };
            Identifiers$1.InheritDefinitionFeature = { name: 'ɵɵInheritDefinitionFeature', moduleName: CORE$1 };
            Identifiers$1.ProvidersFeature = { name: 'ɵɵProvidersFeature', moduleName: CORE$1 };
            Identifiers$1.listener = { name: 'ɵɵlistener', moduleName: CORE$1 };
            Identifiers$1.getFactoryOf = {
                name: 'ɵɵgetFactoryOf',
                moduleName: CORE$1,
            };
            Identifiers$1.getInheritedFactory = {
                name: 'ɵɵgetInheritedFactory',
                moduleName: CORE$1,
            };
            // sanitization-related functions
            Identifiers$1.sanitizeHtml = { name: 'ɵɵsanitizeHtml', moduleName: CORE$1 };
            Identifiers$1.sanitizeStyle = { name: 'ɵɵsanitizeStyle', moduleName: CORE$1 };
            Identifiers$1.defaultStyleSanitizer = { name: 'ɵɵdefaultStyleSanitizer', moduleName: CORE$1 };
            Identifiers$1.sanitizeResourceUrl = { name: 'ɵɵsanitizeResourceUrl', moduleName: CORE$1 };
            Identifiers$1.sanitizeScript = { name: 'ɵɵsanitizeScript', moduleName: CORE$1 };
            Identifiers$1.sanitizeUrl = { name: 'ɵɵsanitizeUrl', moduleName: CORE$1 };
            Identifiers$1.sanitizeUrlOrResourceUrl = { name: 'ɵɵsanitizeUrlOrResourceUrl', moduleName: CORE$1 };
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var $EOF = 0;
            var $BSPACE = 8;
            var $TAB = 9;
            var $LF = 10;
            var $VTAB = 11;
            var $FF = 12;
            var $CR = 13;
            var $SPACE = 32;
            var $BANG = 33;
            var $DQ = 34;
            var $HASH = 35;
            var $$ = 36;
            var $PERCENT = 37;
            var $AMPERSAND = 38;
            var $SQ = 39;
            var $LPAREN = 40;
            var $RPAREN = 41;
            var $STAR = 42;
            var $PLUS = 43;
            var $COMMA = 44;
            var $MINUS = 45;
            var $PERIOD = 46;
            var $SLASH = 47;
            var $COLON = 58;
            var $SEMICOLON = 59;
            var $LT = 60;
            var $EQ = 61;
            var $GT = 62;
            var $QUESTION = 63;
            var $0 = 48;
            var $7 = 55;
            var $9 = 57;
            var $A = 65;
            var $E = 69;
            var $F = 70;
            var $X = 88;
            var $Z = 90;
            var $LBRACKET = 91;
            var $BACKSLASH = 92;
            var $RBRACKET = 93;
            var $CARET = 94;
            var $_ = 95;
            var $a = 97;
            var $b = 98;
            var $e = 101;
            var $f = 102;
            var $n = 110;
            var $r = 114;
            var $t = 116;
            var $u = 117;
            var $v = 118;
            var $x = 120;
            var $z = 122;
            var $LBRACE = 123;
            var $BAR = 124;
            var $RBRACE = 125;
            var $NBSP = 160;
            var $PIPE = 124;
            var $TILDA = 126;
            var $AT = 64;
            var $BT = 96;
            function isWhitespace(code) {
                return (code >= $TAB && code <= $SPACE) || (code == $NBSP);
            }
            function isDigit(code) {
                return $0 <= code && code <= $9;
            }
            function isAsciiLetter(code) {
                return code >= $a && code <= $z || code >= $A && code <= $Z;
            }
            function isAsciiHexDigit(code) {
                return code >= $a && code <= $f || code >= $A && code <= $F || isDigit(code);
            }
            function isNewLine(code) {
                return code === $LF || code === $CR;
            }
            function isOctalDigit(code) {
                return $0 <= code && code <= $7;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ParseLocation = /** @class */ (function () {
                function ParseLocation(file, offset, line, col) {
                    this.file = file;
                    this.offset = offset;
                    this.line = line;
                    this.col = col;
                }
                ParseLocation.prototype.toString = function () {
                    return this.offset != null ? this.file.url + "@" + this.line + ":" + this.col : this.file.url;
                };
                ParseLocation.prototype.moveBy = function (delta) {
                    var source = this.file.content;
                    var len = source.length;
                    var offset = this.offset;
                    var line = this.line;
                    var col = this.col;
                    while (offset > 0 && delta < 0) {
                        offset--;
                        delta++;
                        var ch = source.charCodeAt(offset);
                        if (ch == $LF) {
                            line--;
                            var priorLine = source.substr(0, offset - 1).lastIndexOf(String.fromCharCode($LF));
                            col = priorLine > 0 ? offset - priorLine : offset;
                        }
                        else {
                            col--;
                        }
                    }
                    while (offset < len && delta > 0) {
                        var ch = source.charCodeAt(offset);
                        offset++;
                        delta--;
                        if (ch == $LF) {
                            line++;
                            col = 0;
                        }
                        else {
                            col++;
                        }
                    }
                    return new ParseLocation(this.file, offset, line, col);
                };
                // Return the source around the location
                // Up to `maxChars` or `maxLines` on each side of the location
                ParseLocation.prototype.getContext = function (maxChars, maxLines) {
                    var content = this.file.content;
                    var startOffset = this.offset;
                    if (startOffset != null) {
                        if (startOffset > content.length - 1) {
                            startOffset = content.length - 1;
                        }
                        var endOffset = startOffset;
                        var ctxChars = 0;
                        var ctxLines = 0;
                        while (ctxChars < maxChars && startOffset > 0) {
                            startOffset--;
                            ctxChars++;
                            if (content[startOffset] == '\n') {
                                if (++ctxLines == maxLines) {
                                    break;
                                }
                            }
                        }
                        ctxChars = 0;
                        ctxLines = 0;
                        while (ctxChars < maxChars && endOffset < content.length - 1) {
                            endOffset++;
                            ctxChars++;
                            if (content[endOffset] == '\n') {
                                if (++ctxLines == maxLines) {
                                    break;
                                }
                            }
                        }
                        return {
                            before: content.substring(startOffset, this.offset),
                            after: content.substring(this.offset, endOffset + 1),
                        };
                    }
                    return null;
                };
                return ParseLocation;
            }());
            var ParseSourceFile = /** @class */ (function () {
                function ParseSourceFile(content, url) {
                    this.content = content;
                    this.url = url;
                }
                return ParseSourceFile;
            }());
            var ParseSourceSpan = /** @class */ (function () {
                function ParseSourceSpan(start, end, details) {
                    if (details === void 0) { details = null; }
                    this.start = start;
                    this.end = end;
                    this.details = details;
                }
                ParseSourceSpan.prototype.toString = function () {
                    return this.start.file.content.substring(this.start.offset, this.end.offset);
                };
                return ParseSourceSpan;
            }());
            var EMPTY_PARSE_LOCATION = new ParseLocation(new ParseSourceFile('', ''), 0, 0, 0);
            var EMPTY_SOURCE_SPAN = new ParseSourceSpan(EMPTY_PARSE_LOCATION, EMPTY_PARSE_LOCATION);
            var ParseErrorLevel;
            (function (ParseErrorLevel) {
                ParseErrorLevel[ParseErrorLevel["WARNING"] = 0] = "WARNING";
                ParseErrorLevel[ParseErrorLevel["ERROR"] = 1] = "ERROR";
            })(ParseErrorLevel || (ParseErrorLevel = {}));
            var ParseError = /** @class */ (function () {
                function ParseError(span, msg, level) {
                    if (level === void 0) { level = ParseErrorLevel.ERROR; }
                    this.span = span;
                    this.msg = msg;
                    this.level = level;
                }
                ParseError.prototype.contextualMessage = function () {
                    var ctx = this.span.start.getContext(100, 3);
                    return ctx ? this.msg + " (\"" + ctx.before + "[" + ParseErrorLevel[this.level] + " ->]" + ctx.after + "\")" :
                        this.msg;
                };
                ParseError.prototype.toString = function () {
                    var details = this.span.details ? ", " + this.span.details : '';
                    return this.contextualMessage() + ": " + this.span.start + details;
                };
                return ParseError;
            }());
            function typeSourceSpan(kind, type) {
                var moduleUrl = identifierModuleUrl(type);
                var sourceFileName = moduleUrl != null ? "in " + kind + " " + identifierName(type) + " in " + moduleUrl :
                    "in " + kind + " " + identifierName(type);
                var sourceFile = new ParseSourceFile('', sourceFileName);
                return new ParseSourceSpan(new ParseLocation(sourceFile, -1, -1, -1), new ParseLocation(sourceFile, -1, -1, -1));
            }
            /**
             * Generates Source Span object for a given R3 Type for JIT mode.
             *
             * @param kind Component or Directive.
             * @param typeName name of the Component or Directive.
             * @param sourceUrl reference to Component or Directive source.
             * @returns instance of ParseSourceSpan that represent a given Component or Directive.
             */
            function r3JitTypeSourceSpan(kind, typeName, sourceUrl) {
                var sourceFileName = "in " + kind + " " + typeName + " in " + sourceUrl;
                var sourceFile = new ParseSourceFile('', sourceFileName);
                return new ParseSourceSpan(new ParseLocation(sourceFile, -1, -1, -1), new ParseLocation(sourceFile, -1, -1, -1));
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var Text = /** @class */ (function () {
                function Text(value, sourceSpan) {
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                Text.prototype.visit = function (visitor) { return visitor.visitText(this); };
                return Text;
            }());
            var BoundText = /** @class */ (function () {
                function BoundText(value, sourceSpan, i18n) {
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                    this.i18n = i18n;
                }
                BoundText.prototype.visit = function (visitor) { return visitor.visitBoundText(this); };
                return BoundText;
            }());
            var TextAttribute = /** @class */ (function () {
                function TextAttribute(name, value, sourceSpan, valueSpan, i18n) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                    this.i18n = i18n;
                }
                TextAttribute.prototype.visit = function (visitor) { return visitor.visitTextAttribute(this); };
                return TextAttribute;
            }());
            var BoundAttribute = /** @class */ (function () {
                function BoundAttribute(name, type, securityContext, value, unit, sourceSpan, valueSpan, i18n) {
                    this.name = name;
                    this.type = type;
                    this.securityContext = securityContext;
                    this.value = value;
                    this.unit = unit;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                    this.i18n = i18n;
                }
                BoundAttribute.fromBoundElementProperty = function (prop, i18n) {
                    return new BoundAttribute(prop.name, prop.type, prop.securityContext, prop.value, prop.unit, prop.sourceSpan, prop.valueSpan, i18n);
                };
                BoundAttribute.prototype.visit = function (visitor) { return visitor.visitBoundAttribute(this); };
                return BoundAttribute;
            }());
            var BoundEvent = /** @class */ (function () {
                function BoundEvent(name, type, handler, target, phase, sourceSpan, handlerSpan) {
                    this.name = name;
                    this.type = type;
                    this.handler = handler;
                    this.target = target;
                    this.phase = phase;
                    this.sourceSpan = sourceSpan;
                    this.handlerSpan = handlerSpan;
                }
                BoundEvent.fromParsedEvent = function (event) {
                    var target = event.type === 0 /* Regular */ ? event.targetOrPhase : null;
                    var phase = event.type === 1 /* Animation */ ? event.targetOrPhase : null;
                    return new BoundEvent(event.name, event.type, event.handler, target, phase, event.sourceSpan, event.handlerSpan);
                };
                BoundEvent.prototype.visit = function (visitor) { return visitor.visitBoundEvent(this); };
                return BoundEvent;
            }());
            var Element = /** @class */ (function () {
                function Element(name, attributes, inputs, outputs, children, references, sourceSpan, startSourceSpan, endSourceSpan, i18n) {
                    this.name = name;
                    this.attributes = attributes;
                    this.inputs = inputs;
                    this.outputs = outputs;
                    this.children = children;
                    this.references = references;
                    this.sourceSpan = sourceSpan;
                    this.startSourceSpan = startSourceSpan;
                    this.endSourceSpan = endSourceSpan;
                    this.i18n = i18n;
                    // If the element is empty then the source span should include any closing tag
                    if (children.length === 0 && startSourceSpan && endSourceSpan) {
                        this.sourceSpan = new ParseSourceSpan(sourceSpan.start, endSourceSpan.end);
                    }
                }
                Element.prototype.visit = function (visitor) { return visitor.visitElement(this); };
                return Element;
            }());
            var Template = /** @class */ (function () {
                function Template(tagName, attributes, inputs, outputs, templateAttrs, children, references, variables, sourceSpan, startSourceSpan, endSourceSpan, i18n) {
                    this.tagName = tagName;
                    this.attributes = attributes;
                    this.inputs = inputs;
                    this.outputs = outputs;
                    this.templateAttrs = templateAttrs;
                    this.children = children;
                    this.references = references;
                    this.variables = variables;
                    this.sourceSpan = sourceSpan;
                    this.startSourceSpan = startSourceSpan;
                    this.endSourceSpan = endSourceSpan;
                    this.i18n = i18n;
                }
                Template.prototype.visit = function (visitor) { return visitor.visitTemplate(this); };
                return Template;
            }());
            var Content = /** @class */ (function () {
                function Content(selector, attributes, sourceSpan, i18n) {
                    this.selector = selector;
                    this.attributes = attributes;
                    this.sourceSpan = sourceSpan;
                    this.i18n = i18n;
                }
                Content.prototype.visit = function (visitor) { return visitor.visitContent(this); };
                return Content;
            }());
            var Variable = /** @class */ (function () {
                function Variable(name, value, sourceSpan, valueSpan) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                }
                Variable.prototype.visit = function (visitor) { return visitor.visitVariable(this); };
                return Variable;
            }());
            var Reference = /** @class */ (function () {
                function Reference(name, value, sourceSpan, valueSpan) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                }
                Reference.prototype.visit = function (visitor) { return visitor.visitReference(this); };
                return Reference;
            }());
            var Icu = /** @class */ (function () {
                function Icu(vars, placeholders, sourceSpan, i18n) {
                    this.vars = vars;
                    this.placeholders = placeholders;
                    this.sourceSpan = sourceSpan;
                    this.i18n = i18n;
                }
                Icu.prototype.visit = function (visitor) { return visitor.visitIcu(this); };
                return Icu;
            }());
            var NullVisitor = /** @class */ (function () {
                function NullVisitor() {
                }
                NullVisitor.prototype.visitElement = function (element) { };
                NullVisitor.prototype.visitTemplate = function (template) { };
                NullVisitor.prototype.visitContent = function (content) { };
                NullVisitor.prototype.visitVariable = function (variable) { };
                NullVisitor.prototype.visitReference = function (reference) { };
                NullVisitor.prototype.visitTextAttribute = function (attribute) { };
                NullVisitor.prototype.visitBoundAttribute = function (attribute) { };
                NullVisitor.prototype.visitBoundEvent = function (attribute) { };
                NullVisitor.prototype.visitText = function (text) { };
                NullVisitor.prototype.visitBoundText = function (text) { };
                NullVisitor.prototype.visitIcu = function (icu) { };
                return NullVisitor;
            }());
            var RecursiveVisitor = /** @class */ (function () {
                function RecursiveVisitor() {
                }
                RecursiveVisitor.prototype.visitElement = function (element) {
                    visitAll(this, element.attributes);
                    visitAll(this, element.children);
                    visitAll(this, element.references);
                };
                RecursiveVisitor.prototype.visitTemplate = function (template) {
                    visitAll(this, template.attributes);
                    visitAll(this, template.children);
                    visitAll(this, template.references);
                    visitAll(this, template.variables);
                };
                RecursiveVisitor.prototype.visitContent = function (content) { };
                RecursiveVisitor.prototype.visitVariable = function (variable) { };
                RecursiveVisitor.prototype.visitReference = function (reference) { };
                RecursiveVisitor.prototype.visitTextAttribute = function (attribute) { };
                RecursiveVisitor.prototype.visitBoundAttribute = function (attribute) { };
                RecursiveVisitor.prototype.visitBoundEvent = function (attribute) { };
                RecursiveVisitor.prototype.visitText = function (text) { };
                RecursiveVisitor.prototype.visitBoundText = function (text) { };
                RecursiveVisitor.prototype.visitIcu = function (icu) { };
                return RecursiveVisitor;
            }());
            var TransformVisitor = /** @class */ (function () {
                function TransformVisitor() {
                }
                TransformVisitor.prototype.visitElement = function (element) {
                    var newAttributes = transformAll(this, element.attributes);
                    var newInputs = transformAll(this, element.inputs);
                    var newOutputs = transformAll(this, element.outputs);
                    var newChildren = transformAll(this, element.children);
                    var newReferences = transformAll(this, element.references);
                    if (newAttributes != element.attributes || newInputs != element.inputs ||
                        newOutputs != element.outputs || newChildren != element.children ||
                        newReferences != element.references) {
                        return new Element(element.name, newAttributes, newInputs, newOutputs, newChildren, newReferences, element.sourceSpan, element.startSourceSpan, element.endSourceSpan);
                    }
                    return element;
                };
                TransformVisitor.prototype.visitTemplate = function (template) {
                    var newAttributes = transformAll(this, template.attributes);
                    var newInputs = transformAll(this, template.inputs);
                    var newOutputs = transformAll(this, template.outputs);
                    var newTemplateAttrs = transformAll(this, template.templateAttrs);
                    var newChildren = transformAll(this, template.children);
                    var newReferences = transformAll(this, template.references);
                    var newVariables = transformAll(this, template.variables);
                    if (newAttributes != template.attributes || newInputs != template.inputs ||
                        newOutputs != template.outputs || newTemplateAttrs != template.templateAttrs ||
                        newChildren != template.children || newReferences != template.references ||
                        newVariables != template.variables) {
                        return new Template(template.tagName, newAttributes, newInputs, newOutputs, newTemplateAttrs, newChildren, newReferences, newVariables, template.sourceSpan, template.startSourceSpan, template.endSourceSpan);
                    }
                    return template;
                };
                TransformVisitor.prototype.visitContent = function (content) { return content; };
                TransformVisitor.prototype.visitVariable = function (variable) { return variable; };
                TransformVisitor.prototype.visitReference = function (reference) { return reference; };
                TransformVisitor.prototype.visitTextAttribute = function (attribute) { return attribute; };
                TransformVisitor.prototype.visitBoundAttribute = function (attribute) { return attribute; };
                TransformVisitor.prototype.visitBoundEvent = function (attribute) { return attribute; };
                TransformVisitor.prototype.visitText = function (text) { return text; };
                TransformVisitor.prototype.visitBoundText = function (text) { return text; };
                TransformVisitor.prototype.visitIcu = function (icu) { return icu; };
                return TransformVisitor;
            }());
            function visitAll(visitor, nodes) {
                var result = [];
                if (visitor.visit) {
                    for (var _c = 0, nodes_1 = nodes; _c < nodes_1.length; _c++) {
                        var node = nodes_1[_c];
                        var newNode = visitor.visit(node) || node.visit(visitor);
                    }
                }
                else {
                    for (var _d = 0, nodes_2 = nodes; _d < nodes_2.length; _d++) {
                        var node = nodes_2[_d];
                        var newNode = node.visit(visitor);
                        if (newNode) {
                            result.push(newNode);
                        }
                    }
                }
                return result;
            }
            function transformAll(visitor, nodes) {
                var result = [];
                var changed = false;
                for (var _c = 0, nodes_3 = nodes; _c < nodes_3.length; _c++) {
                    var node = nodes_3[_c];
                    var newNode = node.visit(visitor);
                    if (newNode) {
                        result.push(newNode);
                    }
                    changed = changed || newNode != node;
                }
                return changed ? result : nodes;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var Message = /** @class */ (function () {
                /**
                 * @param nodes message AST
                 * @param placeholders maps placeholder names to static content
                 * @param placeholderToMessage maps placeholder names to messages (used for nested ICU messages)
                 * @param meaning
                 * @param description
                 * @param id
                 */
                function Message(nodes, placeholders, placeholderToMessage, meaning, description, id) {
                    this.nodes = nodes;
                    this.placeholders = placeholders;
                    this.placeholderToMessage = placeholderToMessage;
                    this.meaning = meaning;
                    this.description = description;
                    this.id = id;
                    if (nodes.length) {
                        this.sources = [{
                                filePath: nodes[0].sourceSpan.start.file.url,
                                startLine: nodes[0].sourceSpan.start.line + 1,
                                startCol: nodes[0].sourceSpan.start.col + 1,
                                endLine: nodes[nodes.length - 1].sourceSpan.end.line + 1,
                                endCol: nodes[0].sourceSpan.start.col + 1
                            }];
                    }
                    else {
                        this.sources = [];
                    }
                }
                return Message;
            }());
            var Text$1 = /** @class */ (function () {
                function Text$1(value, sourceSpan) {
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                Text$1.prototype.visit = function (visitor, context) { return visitor.visitText(this, context); };
                return Text$1;
            }());
            // TODO(vicb): do we really need this node (vs an array) ?
            var Container = /** @class */ (function () {
                function Container(children, sourceSpan) {
                    this.children = children;
                    this.sourceSpan = sourceSpan;
                }
                Container.prototype.visit = function (visitor, context) { return visitor.visitContainer(this, context); };
                return Container;
            }());
            var Icu$1 = /** @class */ (function () {
                function Icu$1(expression, type, cases, sourceSpan) {
                    this.expression = expression;
                    this.type = type;
                    this.cases = cases;
                    this.sourceSpan = sourceSpan;
                }
                Icu$1.prototype.visit = function (visitor, context) { return visitor.visitIcu(this, context); };
                return Icu$1;
            }());
            var TagPlaceholder = /** @class */ (function () {
                function TagPlaceholder(tag, attrs, startName, closeName, children, isVoid, sourceSpan) {
                    this.tag = tag;
                    this.attrs = attrs;
                    this.startName = startName;
                    this.closeName = closeName;
                    this.children = children;
                    this.isVoid = isVoid;
                    this.sourceSpan = sourceSpan;
                }
                TagPlaceholder.prototype.visit = function (visitor, context) { return visitor.visitTagPlaceholder(this, context); };
                return TagPlaceholder;
            }());
            var Placeholder = /** @class */ (function () {
                function Placeholder(value, name, sourceSpan) {
                    this.value = value;
                    this.name = name;
                    this.sourceSpan = sourceSpan;
                }
                Placeholder.prototype.visit = function (visitor, context) { return visitor.visitPlaceholder(this, context); };
                return Placeholder;
            }());
            var IcuPlaceholder = /** @class */ (function () {
                function IcuPlaceholder(value, name, sourceSpan) {
                    this.value = value;
                    this.name = name;
                    this.sourceSpan = sourceSpan;
                }
                IcuPlaceholder.prototype.visit = function (visitor, context) { return visitor.visitIcuPlaceholder(this, context); };
                return IcuPlaceholder;
            }());
            // Clone the AST
            var CloneVisitor = /** @class */ (function () {
                function CloneVisitor() {
                }
                CloneVisitor.prototype.visitText = function (text, context) { return new Text$1(text.value, text.sourceSpan); };
                CloneVisitor.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    var children = container.children.map(function (n) { return n.visit(_this, context); });
                    return new Container(children, container.sourceSpan);
                };
                CloneVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var cases = {};
                    Object.keys(icu.cases).forEach(function (key) { return cases[key] = icu.cases[key].visit(_this, context); });
                    var msg = new Icu$1(icu.expression, icu.type, cases, icu.sourceSpan);
                    msg.expressionPlaceholder = icu.expressionPlaceholder;
                    return msg;
                };
                CloneVisitor.prototype.visitTagPlaceholder = function (ph, context) {
                    var _this = this;
                    var children = ph.children.map(function (n) { return n.visit(_this, context); });
                    return new TagPlaceholder(ph.tag, ph.attrs, ph.startName, ph.closeName, children, ph.isVoid, ph.sourceSpan);
                };
                CloneVisitor.prototype.visitPlaceholder = function (ph, context) {
                    return new Placeholder(ph.value, ph.name, ph.sourceSpan);
                };
                CloneVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
                    return new IcuPlaceholder(ph.value, ph.name, ph.sourceSpan);
                };
                return CloneVisitor;
            }());
            // Visit all the nodes recursively
            var RecurseVisitor = /** @class */ (function () {
                function RecurseVisitor() {
                }
                RecurseVisitor.prototype.visitText = function (text, context) { };
                RecurseVisitor.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    container.children.forEach(function (child) { return child.visit(_this); });
                };
                RecurseVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    Object.keys(icu.cases).forEach(function (k) { icu.cases[k].visit(_this); });
                };
                RecurseVisitor.prototype.visitTagPlaceholder = function (ph, context) {
                    var _this = this;
                    ph.children.forEach(function (child) { return child.visit(_this); });
                };
                RecurseVisitor.prototype.visitPlaceholder = function (ph, context) { };
                RecurseVisitor.prototype.visitIcuPlaceholder = function (ph, context) { };
                return RecurseVisitor;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function digest(message) {
                return message.id || sha1(serializeNodes(message.nodes).join('') + ("[" + message.meaning + "]"));
            }
            function decimalDigest(message) {
                if (message.id) {
                    return message.id;
                }
                var visitor = new _SerializerIgnoreIcuExpVisitor();
                var parts = message.nodes.map(function (a) { return a.visit(visitor, null); });
                return computeMsgId(parts.join(''), message.meaning);
            }
            /**
             * Serialize the i18n ast to something xml-like in order to generate an UID.
             *
             * The visitor is also used in the i18n parser tests
             *
             * @internal
             */
            var _SerializerVisitor = /** @class */ (function () {
                function _SerializerVisitor() {
                }
                _SerializerVisitor.prototype.visitText = function (text, context) { return text.value; };
                _SerializerVisitor.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    return "[" + container.children.map(function (child) { return child.visit(_this); }).join(', ') + "]";
                };
                _SerializerVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
                    return "{" + icu.expression + ", " + icu.type + ", " + strCases.join(', ') + "}";
                };
                _SerializerVisitor.prototype.visitTagPlaceholder = function (ph, context) {
                    var _this = this;
                    return ph.isVoid ?
                        "<ph tag name=\"" + ph.startName + "\"/>" :
                        "<ph tag name=\"" + ph.startName + "\">" + ph.children.map(function (child) { return child.visit(_this); }).join(', ') + "</ph name=\"" + ph.closeName + "\">";
                };
                _SerializerVisitor.prototype.visitPlaceholder = function (ph, context) {
                    return ph.value ? "<ph name=\"" + ph.name + "\">" + ph.value + "</ph>" : "<ph name=\"" + ph.name + "\"/>";
                };
                _SerializerVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
                    return "<ph icu name=\"" + ph.name + "\">" + ph.value.visit(this) + "</ph>";
                };
                return _SerializerVisitor;
            }());
            var serializerVisitor = new _SerializerVisitor();
            function serializeNodes(nodes) {
                return nodes.map(function (a) { return a.visit(serializerVisitor, null); });
            }
            /**
             * Serialize the i18n ast to something xml-like in order to generate an UID.
             *
             * Ignore the ICU expressions so that message IDs stays identical if only the expression changes.
             *
             * @internal
             */
            var _SerializerIgnoreIcuExpVisitor = /** @class */ (function (_super_1) {
                __extends(_SerializerIgnoreIcuExpVisitor, _super_1);
                function _SerializerIgnoreIcuExpVisitor() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                _SerializerIgnoreIcuExpVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
                    // Do not take the expression into account
                    return "{" + icu.type + ", " + strCases.join(', ') + "}";
                };
                return _SerializerIgnoreIcuExpVisitor;
            }(_SerializerVisitor));
            /**
             * Compute the SHA1 of the given string
             *
             * see http://csrc.nist.gov/publications/fips/fips180-4/fips-180-4.pdf
             *
             * WARNING: this function has not been designed not tested with security in mind.
             *          DO NOT USE IT IN A SECURITY SENSITIVE CONTEXT.
             */
            function sha1(str) {
                var _c, _d;
                var utf8 = utf8Encode(str);
                var words32 = stringToWords32(utf8, Endian.Big);
                var len = utf8.length * 8;
                var w = new Array(80);
                var _e = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0], a = _e[0], b = _e[1], c = _e[2], d = _e[3], e = _e[4];
                words32[len >> 5] |= 0x80 << (24 - len % 32);
                words32[((len + 64 >> 9) << 4) + 15] = len;
                for (var i = 0; i < words32.length; i += 16) {
                    var _f = [a, b, c, d, e], h0 = _f[0], h1 = _f[1], h2 = _f[2], h3 = _f[3], h4 = _f[4];
                    for (var j = 0; j < 80; j++) {
                        if (j < 16) {
                            w[j] = words32[i + j];
                        }
                        else {
                            w[j] = rol32(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
                        }
                        var _g = fk(j, b, c, d), f = _g[0], k = _g[1];
                        var temp = [rol32(a, 5), f, e, k, w[j]].reduce(add32);
                        _c = [d, c, rol32(b, 30), a, temp], e = _c[0], d = _c[1], c = _c[2], b = _c[3], a = _c[4];
                    }
                    _d = [add32(a, h0), add32(b, h1), add32(c, h2), add32(d, h3), add32(e, h4)], a = _d[0], b = _d[1], c = _d[2], d = _d[3], e = _d[4];
                }
                return byteStringToHexString(words32ToByteString([a, b, c, d, e]));
            }
            function fk(index, b, c, d) {
                if (index < 20) {
                    return [(b & c) | (~b & d), 0x5a827999];
                }
                if (index < 40) {
                    return [b ^ c ^ d, 0x6ed9eba1];
                }
                if (index < 60) {
                    return [(b & c) | (b & d) | (c & d), 0x8f1bbcdc];
                }
                return [b ^ c ^ d, 0xca62c1d6];
            }
            /**
             * Compute the fingerprint of the given string
             *
             * The output is 64 bit number encoded as a decimal string
             *
             * based on:
             * https://github.com/google/closure-compiler/blob/master/src/com/google/javascript/jscomp/GoogleJsMessageIdGenerator.java
             */
            function fingerprint(str) {
                var utf8 = utf8Encode(str);
                var _c = [hash32(utf8, 0), hash32(utf8, 102072)], hi = _c[0], lo = _c[1];
                if (hi == 0 && (lo == 0 || lo == 1)) {
                    hi = hi ^ 0x130f9bef;
                    lo = lo ^ -0x6b5f56d8;
                }
                return [hi, lo];
            }
            function computeMsgId(msg, meaning) {
                var _c;
                var _d = fingerprint(msg), hi = _d[0], lo = _d[1];
                if (meaning) {
                    var _e = fingerprint(meaning), him = _e[0], lom = _e[1];
                    _c = add64(rol64([hi, lo], 1), [him, lom]), hi = _c[0], lo = _c[1];
                }
                return byteStringToDecString(words32ToByteString([hi & 0x7fffffff, lo]));
            }
            function hash32(str, c) {
                var _c;
                var _d = [0x9e3779b9, 0x9e3779b9], a = _d[0], b = _d[1];
                var i;
                var len = str.length;
                for (i = 0; i + 12 <= len; i += 12) {
                    a = add32(a, wordAt(str, i, Endian.Little));
                    b = add32(b, wordAt(str, i + 4, Endian.Little));
                    c = add32(c, wordAt(str, i + 8, Endian.Little));
                    _c = mix([a, b, c]), a = _c[0], b = _c[1], c = _c[2];
                }
                a = add32(a, wordAt(str, i, Endian.Little));
                b = add32(b, wordAt(str, i + 4, Endian.Little));
                // the first byte of c is reserved for the length
                c = add32(c, len);
                c = add32(c, wordAt(str, i + 8, Endian.Little) << 8);
                return mix([a, b, c])[2];
            }
            // clang-format off
            function mix(_c) {
                var a = _c[0], b = _c[1], c = _c[2];
                a = sub32(a, b);
                a = sub32(a, c);
                a ^= c >>> 13;
                b = sub32(b, c);
                b = sub32(b, a);
                b ^= a << 8;
                c = sub32(c, a);
                c = sub32(c, b);
                c ^= b >>> 13;
                a = sub32(a, b);
                a = sub32(a, c);
                a ^= c >>> 12;
                b = sub32(b, c);
                b = sub32(b, a);
                b ^= a << 16;
                c = sub32(c, a);
                c = sub32(c, b);
                c ^= b >>> 5;
                a = sub32(a, b);
                a = sub32(a, c);
                a ^= c >>> 3;
                b = sub32(b, c);
                b = sub32(b, a);
                b ^= a << 10;
                c = sub32(c, a);
                c = sub32(c, b);
                c ^= b >>> 15;
                return [a, b, c];
            }
            // clang-format on
            // Utils
            var Endian;
            (function (Endian) {
                Endian[Endian["Little"] = 0] = "Little";
                Endian[Endian["Big"] = 1] = "Big";
            })(Endian || (Endian = {}));
            function add32(a, b) {
                return add32to64(a, b)[1];
            }
            function add32to64(a, b) {
                var low = (a & 0xffff) + (b & 0xffff);
                var high = (a >>> 16) + (b >>> 16) + (low >>> 16);
                return [high >>> 16, (high << 16) | (low & 0xffff)];
            }
            function add64(_c, _d) {
                var ah = _c[0], al = _c[1];
                var bh = _d[0], bl = _d[1];
                var _e = add32to64(al, bl), carry = _e[0], l = _e[1];
                var h = add32(add32(ah, bh), carry);
                return [h, l];
            }
            function sub32(a, b) {
                var low = (a & 0xffff) - (b & 0xffff);
                var high = (a >> 16) - (b >> 16) + (low >> 16);
                return (high << 16) | (low & 0xffff);
            }
            // Rotate a 32b number left `count` position
            function rol32(a, count) {
                return (a << count) | (a >>> (32 - count));
            }
            // Rotate a 64b number left `count` position
            function rol64(_c, count) {
                var hi = _c[0], lo = _c[1];
                var h = (hi << count) | (lo >>> (32 - count));
                var l = (lo << count) | (hi >>> (32 - count));
                return [h, l];
            }
            function stringToWords32(str, endian) {
                var words32 = Array((str.length + 3) >>> 2);
                for (var i = 0; i < words32.length; i++) {
                    words32[i] = wordAt(str, i * 4, endian);
                }
                return words32;
            }
            function byteAt(str, index) {
                return index >= str.length ? 0 : str.charCodeAt(index) & 0xff;
            }
            function wordAt(str, index, endian) {
                var word = 0;
                if (endian === Endian.Big) {
                    for (var i = 0; i < 4; i++) {
                        word += byteAt(str, index + i) << (24 - 8 * i);
                    }
                }
                else {
                    for (var i = 0; i < 4; i++) {
                        word += byteAt(str, index + i) << 8 * i;
                    }
                }
                return word;
            }
            function words32ToByteString(words32) {
                return words32.reduce(function (str, word) { return str + word32ToByteString(word); }, '');
            }
            function word32ToByteString(word) {
                var str = '';
                for (var i = 0; i < 4; i++) {
                    str += String.fromCharCode((word >>> 8 * (3 - i)) & 0xff);
                }
                return str;
            }
            function byteStringToHexString(str) {
                var hex = '';
                for (var i = 0; i < str.length; i++) {
                    var b = byteAt(str, i);
                    hex += (b >>> 4).toString(16) + (b & 0x0f).toString(16);
                }
                return hex.toLowerCase();
            }
            // based on http://www.danvk.org/hex2dec.html (JS can not handle more than 56b)
            function byteStringToDecString(str) {
                var decimal = '';
                var toThePower = '1';
                for (var i = str.length - 1; i >= 0; i--) {
                    decimal = addBigInt(decimal, numberTimesBigInt(byteAt(str, i), toThePower));
                    toThePower = numberTimesBigInt(256, toThePower);
                }
                return decimal.split('').reverse().join('');
            }
            // x and y decimal, lowest significant digit first
            function addBigInt(x, y) {
                var sum = '';
                var len = Math.max(x.length, y.length);
                for (var i = 0, carry = 0; i < len || carry; i++) {
                    var tmpSum = carry + +(x[i] || 0) + +(y[i] || 0);
                    if (tmpSum >= 10) {
                        carry = 1;
                        sum += tmpSum - 10;
                    }
                    else {
                        carry = 0;
                        sum += tmpSum;
                    }
                }
                return sum;
            }
            function numberTimesBigInt(num, b) {
                var product = '';
                var bToThePower = b;
                for (; num !== 0; num = num >>> 1) {
                    if (num & 1)
                        product = addBigInt(product, bToThePower);
                    bToThePower = addBigInt(bToThePower, bToThePower);
                }
                return product;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var Serializer = /** @class */ (function () {
                function Serializer() {
                }
                // Creates a name mapper, see `PlaceholderMapper`
                // Returning `null` means that no name mapping is used.
                Serializer.prototype.createNameMapper = function (message) { return null; };
                return Serializer;
            }());
            /**
             * A simple mapper that take a function to transform an internal name to a public name
             */
            var SimplePlaceholderMapper = /** @class */ (function (_super_1) {
                __extends(SimplePlaceholderMapper, _super_1);
                // create a mapping from the message
                function SimplePlaceholderMapper(message, mapName) {
                    var _this = _super_1.call(this) || this;
                    _this.mapName = mapName;
                    _this.internalToPublic = {};
                    _this.publicToNextId = {};
                    _this.publicToInternal = {};
                    message.nodes.forEach(function (node) { return node.visit(_this); });
                    return _this;
                }
                SimplePlaceholderMapper.prototype.toPublicName = function (internalName) {
                    return this.internalToPublic.hasOwnProperty(internalName) ?
                        this.internalToPublic[internalName] :
                        null;
                };
                SimplePlaceholderMapper.prototype.toInternalName = function (publicName) {
                    return this.publicToInternal.hasOwnProperty(publicName) ? this.publicToInternal[publicName] :
                        null;
                };
                SimplePlaceholderMapper.prototype.visitText = function (text, context) { return null; };
                SimplePlaceholderMapper.prototype.visitTagPlaceholder = function (ph, context) {
                    this.visitPlaceholderName(ph.startName);
                    _super_1.prototype.visitTagPlaceholder.call(this, ph, context);
                    this.visitPlaceholderName(ph.closeName);
                };
                SimplePlaceholderMapper.prototype.visitPlaceholder = function (ph, context) { this.visitPlaceholderName(ph.name); };
                SimplePlaceholderMapper.prototype.visitIcuPlaceholder = function (ph, context) {
                    this.visitPlaceholderName(ph.name);
                };
                // XMB placeholders could only contains A-Z, 0-9 and _
                SimplePlaceholderMapper.prototype.visitPlaceholderName = function (internalName) {
                    if (!internalName || this.internalToPublic.hasOwnProperty(internalName)) {
                        return;
                    }
                    var publicName = this.mapName(internalName);
                    if (this.publicToInternal.hasOwnProperty(publicName)) {
                        // Create a new XMB when it has already been used
                        var nextId = this.publicToNextId[publicName];
                        this.publicToNextId[publicName] = nextId + 1;
                        publicName = publicName + "_" + nextId;
                    }
                    else {
                        this.publicToNextId[publicName] = 1;
                    }
                    this.internalToPublic[internalName] = publicName;
                    this.publicToInternal[publicName] = internalName;
                };
                return SimplePlaceholderMapper;
            }(RecurseVisitor));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _Visitor = /** @class */ (function () {
                function _Visitor() {
                }
                _Visitor.prototype.visitTag = function (tag) {
                    var _this = this;
                    var strAttrs = this._serializeAttributes(tag.attrs);
                    if (tag.children.length == 0) {
                        return "<" + tag.name + strAttrs + "/>";
                    }
                    var strChildren = tag.children.map(function (node) { return node.visit(_this); });
                    return "<" + tag.name + strAttrs + ">" + strChildren.join('') + "</" + tag.name + ">";
                };
                _Visitor.prototype.visitText = function (text) { return text.value; };
                _Visitor.prototype.visitDeclaration = function (decl) {
                    return "<?xml" + this._serializeAttributes(decl.attrs) + " ?>";
                };
                _Visitor.prototype._serializeAttributes = function (attrs) {
                    var strAttrs = Object.keys(attrs).map(function (name) { return name + "=\"" + attrs[name] + "\""; }).join(' ');
                    return strAttrs.length > 0 ? ' ' + strAttrs : '';
                };
                _Visitor.prototype.visitDoctype = function (doctype) {
                    return "<!DOCTYPE " + doctype.rootTag + " [\n" + doctype.dtd + "\n]>";
                };
                return _Visitor;
            }());
            var _visitor = new _Visitor();
            function serialize(nodes) {
                return nodes.map(function (node) { return node.visit(_visitor); }).join('');
            }
            var Declaration = /** @class */ (function () {
                function Declaration(unescapedAttrs) {
                    var _this = this;
                    this.attrs = {};
                    Object.keys(unescapedAttrs).forEach(function (k) {
                        _this.attrs[k] = escapeXml(unescapedAttrs[k]);
                    });
                }
                Declaration.prototype.visit = function (visitor) { return visitor.visitDeclaration(this); };
                return Declaration;
            }());
            var Doctype = /** @class */ (function () {
                function Doctype(rootTag, dtd) {
                    this.rootTag = rootTag;
                    this.dtd = dtd;
                }
                Doctype.prototype.visit = function (visitor) { return visitor.visitDoctype(this); };
                return Doctype;
            }());
            var Tag = /** @class */ (function () {
                function Tag(name, unescapedAttrs, children) {
                    var _this = this;
                    if (unescapedAttrs === void 0) { unescapedAttrs = {}; }
                    if (children === void 0) { children = []; }
                    this.name = name;
                    this.children = children;
                    this.attrs = {};
                    Object.keys(unescapedAttrs).forEach(function (k) {
                        _this.attrs[k] = escapeXml(unescapedAttrs[k]);
                    });
                }
                Tag.prototype.visit = function (visitor) { return visitor.visitTag(this); };
                return Tag;
            }());
            var Text$2 = /** @class */ (function () {
                function Text$2(unescapedValue) {
                    this.value = escapeXml(unescapedValue);
                }
                Text$2.prototype.visit = function (visitor) { return visitor.visitText(this); };
                return Text$2;
            }());
            var CR = /** @class */ (function (_super_1) {
                __extends(CR, _super_1);
                function CR(ws) {
                    if (ws === void 0) { ws = 0; }
                    return _super_1.call(this, "\n" + new Array(ws + 1).join(' ')) || this;
                }
                return CR;
            }(Text$2));
            var _ESCAPED_CHARS = [
                [/&/g, '&amp;'],
                [/"/g, '&quot;'],
                [/'/g, '&apos;'],
                [/</g, '&lt;'],
                [/>/g, '&gt;'],
            ];
            // Escape `_ESCAPED_CHARS` characters in the given text with encoded entities
            function escapeXml(text) {
                return _ESCAPED_CHARS.reduce(function (text, entry) { return text.replace(entry[0], entry[1]); }, text);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _MESSAGES_TAG = 'messagebundle';
            var _MESSAGE_TAG = 'msg';
            var _PLACEHOLDER_TAG = 'ph';
            var _EXAMPLE_TAG = 'ex';
            var _SOURCE_TAG = 'source';
            var _DOCTYPE = "<!ELEMENT messagebundle (msg)*>\n<!ATTLIST messagebundle class CDATA #IMPLIED>\n\n<!ELEMENT msg (#PCDATA|ph|source)*>\n<!ATTLIST msg id CDATA #IMPLIED>\n<!ATTLIST msg seq CDATA #IMPLIED>\n<!ATTLIST msg name CDATA #IMPLIED>\n<!ATTLIST msg desc CDATA #IMPLIED>\n<!ATTLIST msg meaning CDATA #IMPLIED>\n<!ATTLIST msg obsolete (obsolete) #IMPLIED>\n<!ATTLIST msg xml:space (default|preserve) \"default\">\n<!ATTLIST msg is_hidden CDATA #IMPLIED>\n\n<!ELEMENT source (#PCDATA)>\n\n<!ELEMENT ph (#PCDATA|ex)*>\n<!ATTLIST ph name CDATA #REQUIRED>\n\n<!ELEMENT ex (#PCDATA)>";
            var Xmb = /** @class */ (function (_super_1) {
                __extends(Xmb, _super_1);
                function Xmb() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                Xmb.prototype.write = function (messages, locale) {
                    var exampleVisitor = new ExampleVisitor();
                    var visitor = new _Visitor$1();
                    var rootNode = new Tag(_MESSAGES_TAG);
                    messages.forEach(function (message) {
                        var attrs = { id: message.id };
                        if (message.description) {
                            attrs['desc'] = message.description;
                        }
                        if (message.meaning) {
                            attrs['meaning'] = message.meaning;
                        }
                        var sourceTags = [];
                        message.sources.forEach(function (source) {
                            sourceTags.push(new Tag(_SOURCE_TAG, {}, [
                                new Text$2(source.filePath + ":" + source.startLine + (source.endLine !== source.startLine ? ',' + source.endLine : ''))
                            ]));
                        });
                        rootNode.children.push(new CR(2), new Tag(_MESSAGE_TAG, attrs, sourceTags.concat(visitor.serialize(message.nodes))));
                    });
                    rootNode.children.push(new CR());
                    return serialize([
                        new Declaration({ version: '1.0', encoding: 'UTF-8' }),
                        new CR(),
                        new Doctype(_MESSAGES_TAG, _DOCTYPE),
                        new CR(),
                        exampleVisitor.addDefaultExamples(rootNode),
                        new CR(),
                    ]);
                };
                Xmb.prototype.load = function (content, url) {
                    throw new Error('Unsupported');
                };
                Xmb.prototype.digest = function (message) { return digest$1(message); };
                Xmb.prototype.createNameMapper = function (message) {
                    return new SimplePlaceholderMapper(message, toPublicName);
                };
                return Xmb;
            }(Serializer));
            var _Visitor$1 = /** @class */ (function () {
                function _Visitor$1() {
                }
                _Visitor$1.prototype.visitText = function (text, context) { return [new Text$2(text.value)]; };
                _Visitor$1.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    var nodes = [];
                    container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
                    return nodes;
                };
                _Visitor$1.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
                    Object.keys(icu.cases).forEach(function (c) {
                        nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
                    });
                    nodes.push(new Text$2("}"));
                    return nodes;
                };
                _Visitor$1.prototype.visitTagPlaceholder = function (ph, context) {
                    var startTagAsText = new Text$2("<" + ph.tag + ">");
                    var startEx = new Tag(_EXAMPLE_TAG, {}, [startTagAsText]);
                    // TC requires PH to have a non empty EX, and uses the text node to show the "original" value.
                    var startTagPh = new Tag(_PLACEHOLDER_TAG, { name: ph.startName }, [startEx, startTagAsText]);
                    if (ph.isVoid) {
                        // void tags have no children nor closing tags
                        return [startTagPh];
                    }
                    var closeTagAsText = new Text$2("</" + ph.tag + ">");
                    var closeEx = new Tag(_EXAMPLE_TAG, {}, [closeTagAsText]);
                    // TC requires PH to have a non empty EX, and uses the text node to show the "original" value.
                    var closeTagPh = new Tag(_PLACEHOLDER_TAG, { name: ph.closeName }, [closeEx, closeTagAsText]);
                    return [startTagPh].concat(this.serialize(ph.children), [closeTagPh]);
                };
                _Visitor$1.prototype.visitPlaceholder = function (ph, context) {
                    var interpolationAsText = new Text$2("{{" + ph.value + "}}");
                    // Example tag needs to be not-empty for TC.
                    var exTag = new Tag(_EXAMPLE_TAG, {}, [interpolationAsText]);
                    return [
                        // TC requires PH to have a non empty EX, and uses the text node to show the "original" value.
                        new Tag(_PLACEHOLDER_TAG, { name: ph.name }, [exTag, interpolationAsText])
                    ];
                };
                _Visitor$1.prototype.visitIcuPlaceholder = function (ph, context) {
                    var icuExpression = ph.value.expression;
                    var icuType = ph.value.type;
                    var icuCases = Object.keys(ph.value.cases).map(function (value) { return value + ' {...}'; }).join(' ');
                    var icuAsText = new Text$2("{" + icuExpression + ", " + icuType + ", " + icuCases + "}");
                    var exTag = new Tag(_EXAMPLE_TAG, {}, [icuAsText]);
                    return [
                        // TC requires PH to have a non empty EX, and uses the text node to show the "original" value.
                        new Tag(_PLACEHOLDER_TAG, { name: ph.name }, [exTag, icuAsText])
                    ];
                };
                _Visitor$1.prototype.serialize = function (nodes) {
                    var _this = this;
                    return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
                };
                return _Visitor$1;
            }());
            function digest$1(message) {
                return decimalDigest(message);
            }
            // TC requires at least one non-empty example on placeholders
            var ExampleVisitor = /** @class */ (function () {
                function ExampleVisitor() {
                }
                ExampleVisitor.prototype.addDefaultExamples = function (node) {
                    node.visit(this);
                    return node;
                };
                ExampleVisitor.prototype.visitTag = function (tag) {
                    var _this = this;
                    if (tag.name === _PLACEHOLDER_TAG) {
                        if (!tag.children || tag.children.length == 0) {
                            var exText = new Text$2(tag.attrs['name'] || '...');
                            tag.children = [new Tag(_EXAMPLE_TAG, {}, [exText])];
                        }
                    }
                    else if (tag.children) {
                        tag.children.forEach(function (node) { return node.visit(_this); });
                    }
                };
                ExampleVisitor.prototype.visitText = function (text) { };
                ExampleVisitor.prototype.visitDeclaration = function (decl) { };
                ExampleVisitor.prototype.visitDoctype = function (doctype) { };
                return ExampleVisitor;
            }());
            // XMB/XTB placeholders can only contain A-Z, 0-9 and _
            function toPublicName(internalName) {
                return internalName.toUpperCase().replace(/[^A-Z0-9_]/g, '_');
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function mapEntry(key, value) {
                return { key: key, value: value, quoted: false };
            }
            function mapLiteral(obj, quoted) {
                if (quoted === void 0) { quoted = false; }
                return literalMap(Object.keys(obj).map(function (key) { return ({
                    key: key,
                    quoted: quoted,
                    value: obj[key],
                }); }));
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /* Closure variables holding messages must be named `MSG_[A-Z0-9]+` */
            var CLOSURE_TRANSLATION_PREFIX = 'MSG_';
            /* Prefix for non-`goog.getMsg` i18n-related vars */
            var TRANSLATION_PREFIX = 'I18N_';
            /** Closure uses `goog.getMsg(message)` to lookup translations */
            var GOOG_GET_MSG = 'goog.getMsg';
            /** Name of the global variable that is used to determine if we use Closure translations or not */
            var NG_I18N_CLOSURE_MODE = 'ngI18nClosureMode';
            /** I18n separators for metadata **/
            var I18N_MEANING_SEPARATOR = '|';
            var I18N_ID_SEPARATOR = '@@';
            /** Name of the i18n attributes **/
            var I18N_ATTR = 'i18n';
            var I18N_ATTR_PREFIX = 'i18n-';
            /** Prefix of var expressions used in ICUs */
            var I18N_ICU_VAR_PREFIX = 'VAR_';
            /** Prefix of ICU expressions for post processing */
            var I18N_ICU_MAPPING_PREFIX = 'I18N_EXP_';
            /** Placeholder wrapper for i18n expressions **/
            var I18N_PLACEHOLDER_SYMBOL = '�';
            function i18nTranslationToDeclStmt(variable$1, closureVar, message, meta, params) {
                var statements = [];
                // var I18N_X;
                statements.push(new DeclareVarStmt(variable$1.name, undefined, INFERRED_TYPE, null, variable$1.sourceSpan));
                var args = [literal(message)];
                if (params && Object.keys(params).length) {
                    args.push(mapLiteral(params, true));
                }
                // Closure JSDoc comments
                var docStatements = i18nMetaToDocStmt(meta);
                var thenStatements = docStatements ? [docStatements] : [];
                var googFnCall = variable(GOOG_GET_MSG).callFn(args);
                // const MSG_... = goog.getMsg(..);
                thenStatements.push(closureVar.set(googFnCall).toConstDecl());
                // I18N_X = MSG_...;
                thenStatements.push(new ExpressionStatement(variable$1.set(closureVar)));
                var localizeFnCall = importExpr(Identifiers$1.i18nLocalize).callFn(args);
                // I18N_X = i18nLocalize(...);
                var elseStatements = [new ExpressionStatement(variable$1.set(localizeFnCall))];
                // if(ngI18nClosureMode) { ... } else { ... }
                statements.push(ifStmt(variable(NG_I18N_CLOSURE_MODE), thenStatements, elseStatements));
                return statements;
            }
            // Converts i18n meta information for a message (id, description, meaning)
            // to a JsDoc statement formatted as expected by the Closure compiler.
            function i18nMetaToDocStmt(meta) {
                var tags = [];
                if (meta.description) {
                    tags.push({ tagName: "desc" /* Desc */, text: meta.description });
                }
                if (meta.meaning) {
                    tags.push({ tagName: "meaning" /* Meaning */, text: meta.meaning });
                }
                return tags.length == 0 ? null : new JSDocCommentStmt(tags);
            }
            function isI18nAttribute(name) {
                return name === I18N_ATTR || name.startsWith(I18N_ATTR_PREFIX);
            }
            function isI18nRootNode(meta) {
                return meta instanceof Message;
            }
            function isSingleI18nIcu(meta) {
                return isI18nRootNode(meta) && meta.nodes.length === 1 && meta.nodes[0] instanceof Icu$1;
            }
            function hasI18nAttrs(element) {
                return element.attrs.some(function (attr) { return isI18nAttribute(attr.name); });
            }
            function metaFromI18nMessage(message, id) {
                if (id === void 0) { id = null; }
                return {
                    id: typeof id === 'string' ? id : message.id || '',
                    meaning: message.meaning || '',
                    description: message.description || ''
                };
            }
            function icuFromI18nMessage(message) {
                return message.nodes[0];
            }
            function wrapI18nPlaceholder(content, contextId) {
                if (contextId === void 0) { contextId = 0; }
                var blockId = contextId > 0 ? ":" + contextId : '';
                return "" + I18N_PLACEHOLDER_SYMBOL + content + blockId + I18N_PLACEHOLDER_SYMBOL;
            }
            function assembleI18nBoundString(strings, bindingStartIndex, contextId) {
                if (bindingStartIndex === void 0) { bindingStartIndex = 0; }
                if (contextId === void 0) { contextId = 0; }
                if (!strings.length)
                    return '';
                var acc = '';
                var lastIdx = strings.length - 1;
                for (var i = 0; i < lastIdx; i++) {
                    acc += "" + strings[i] + wrapI18nPlaceholder(bindingStartIndex + i, contextId);
                }
                acc += strings[lastIdx];
                return acc;
            }
            function getSeqNumberGenerator(startsAt) {
                if (startsAt === void 0) { startsAt = 0; }
                var current = startsAt;
                return function () { return current++; };
            }
            function placeholdersToParams(placeholders) {
                var params = {};
                placeholders.forEach(function (values, key) {
                    params[key] = literal(values.length > 1 ? "[" + values.join('|') + "]" : values[0]);
                });
                return params;
            }
            function updatePlaceholderMap(map, name) {
                var values = [];
                for (var _c = 2; _c < arguments.length; _c++) {
                    values[_c - 2] = arguments[_c];
                }
                var current = map.get(name) || [];
                current.push.apply(current, values);
                map.set(name, current);
            }
            function assembleBoundTextPlaceholders(meta, bindingStartIndex, contextId) {
                if (bindingStartIndex === void 0) { bindingStartIndex = 0; }
                if (contextId === void 0) { contextId = 0; }
                var startIdx = bindingStartIndex;
                var placeholders = new Map();
                var node = meta instanceof Message ? meta.nodes.find(function (node) { return node instanceof Container; }) : meta;
                if (node) {
                    node
                        .children
                        .filter(function (child) { return child instanceof Placeholder; })
                        .forEach(function (child, idx) {
                        var content = wrapI18nPlaceholder(startIdx + idx, contextId);
                        updatePlaceholderMap(placeholders, child.name, content);
                    });
                }
                return placeholders;
            }
            function findIndex(items, callback) {
                for (var i = 0; i < items.length; i++) {
                    if (callback(items[i])) {
                        return i;
                    }
                }
                return -1;
            }
            /**
             * Parses i18n metas like:
             *  - "@@id",
             *  - "description[@@id]",
             *  - "meaning|description[@@id]"
             * and returns an object with parsed output.
             *
             * @param meta String that represents i18n meta
             * @returns Object with id, meaning and description fields
             */
            function parseI18nMeta(meta) {
                var _c, _d;
                var id;
                var meaning;
                var description;
                if (meta) {
                    var idIndex = meta.indexOf(I18N_ID_SEPARATOR);
                    var descIndex = meta.indexOf(I18N_MEANING_SEPARATOR);
                    var meaningAndDesc = void 0;
                    _c = (idIndex > -1) ? [meta.slice(0, idIndex), meta.slice(idIndex + 2)] : [meta, ''], meaningAndDesc = _c[0], id = _c[1];
                    _d = (descIndex > -1) ?
                        [meaningAndDesc.slice(0, descIndex), meaningAndDesc.slice(descIndex + 1)] :
                        ['', meaningAndDesc], meaning = _d[0], description = _d[1];
                }
                return { id: id, meaning: meaning, description: description };
            }
            /**
             * Converts internal placeholder names to public-facing format
             * (for example to use in goog.getMsg call).
             * Example: `START_TAG_DIV_1` is converted to `startTagDiv_1`.
             *
             * @param name The placeholder name that should be formatted
             * @returns Formatted placeholder name
             */
            function formatI18nPlaceholderName(name, useCamelCase) {
                if (useCamelCase === void 0) { useCamelCase = true; }
                var publicName = toPublicName(name);
                if (!useCamelCase) {
                    return publicName;
                }
                var chunks = publicName.split('_');
                if (chunks.length === 1) {
                    // if no "_" found - just lowercase the value
                    return name.toLowerCase();
                }
                var postfix;
                // eject last element if it's a number
                if (/^\d+$/.test(chunks[chunks.length - 1])) {
                    postfix = chunks.pop();
                }
                var raw = chunks.shift().toLowerCase();
                if (chunks.length) {
                    raw += chunks.map(function (c) { return c.charAt(0).toUpperCase() + c.slice(1).toLowerCase(); }).join('');
                }
                return postfix ? raw + "_" + postfix : raw;
            }
            /**
             * Generates a prefix for translation const name.
             *
             * @param extra Additional local prefix that should be injected into translation var name
             * @returns Complete translation const prefix
             */
            function getTranslationConstPrefix(extra) {
                return ("" + CLOSURE_TRANSLATION_PREFIX + extra).toUpperCase();
            }
            /**
             * Generates translation declaration statements.
             *
             * @param variable Translation value reference
             * @param closureVar Variable for Closure `goog.getMsg` calls
             * @param message Text message to be translated
             * @param meta Object that contains meta information (id, meaning and description)
             * @param params Object with placeholders key-value pairs
             * @param transformFn Optional transformation (post processing) function reference
             * @returns Array of Statements that represent a given translation
             */
            function getTranslationDeclStmts(variable, closureVar, message, meta, params, transformFn) {
                if (params === void 0) { params = {}; }
                var statements = [];
                statements.push.apply(statements, i18nTranslationToDeclStmt(variable, closureVar, message, meta, params));
                if (transformFn) {
                    statements.push(new ExpressionStatement(variable.set(transformFn(variable))));
                }
                return statements;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Checks whether an object key contains potentially unsafe chars, thus the key should be wrapped in
             * quotes. Note: we do not wrap all keys into quotes, as it may have impact on minification and may
             * bot work in some cases when object keys are mangled by minifier.
             *
             * TODO(FW-1136): this is a temporary solution, we need to come up with a better way of working with
             * inputs that contain potentially unsafe chars.
             */
            var UNSAFE_OBJECT_KEY_NAME_REGEXP = /[-.]/;
            /** Name of the temporary to use during data binding */
            var TEMPORARY_NAME = '_t';
            /** Name of the context parameter passed into a template function */
            var CONTEXT_NAME = 'ctx';
            /** Name of the RenderFlag passed into a template function */
            var RENDER_FLAGS = 'rf';
            /** The prefix reference variables */
            var REFERENCE_PREFIX = '_r';
            /** The name of the implicit context reference */
            var IMPLICIT_REFERENCE = '$implicit';
            /** Non bindable attribute name **/
            var NON_BINDABLE_ATTR = 'ngNonBindable';
            /**
             * Creates an allocator for a temporary variable.
             *
             * A variable declaration is added to the statements the first time the allocator is invoked.
             */
            function temporaryAllocator(statements, name) {
                var temp = null;
                return function () {
                    if (!temp) {
                        statements.push(new DeclareVarStmt(TEMPORARY_NAME, undefined, DYNAMIC_TYPE));
                        temp = variable(name);
                    }
                    return temp;
                };
            }
            function unsupported(feature) {
                if (this) {
                    throw new Error("Builder " + this.constructor.name + " doesn't support " + feature + " yet");
                }
                throw new Error("Feature " + feature + " is not supported yet");
            }
            function invalid$1(arg) {
                throw new Error("Invalid state: Visitor " + this.constructor.name + " doesn't handle " + arg.constructor.name);
            }
            function asLiteral(value) {
                if (Array.isArray(value)) {
                    return literalArr(value.map(asLiteral));
                }
                return literal(value, INFERRED_TYPE);
            }
            function conditionallyCreateMapObjectLiteral(keys, keepDeclared) {
                if (Object.getOwnPropertyNames(keys).length > 0) {
                    return mapToExpression(keys, keepDeclared);
                }
                return null;
            }
            function mapToExpression(map, keepDeclared) {
                return literalMap(Object.getOwnPropertyNames(map).map(function (key) {
                    var _c;
                    // canonical syntax: `dirProp: publicProp`
                    // if there is no `:`, use dirProp = elProp
                    var value = map[key];
                    var declaredName;
                    var publicName;
                    var minifiedName;
                    if (Array.isArray(value)) {
                        publicName = value[0], declaredName = value[1];
                    }
                    else {
                        _c = splitAtColon(key, [key, value]), declaredName = _c[0], publicName = _c[1];
                    }
                    minifiedName = declaredName;
                    return {
                        key: minifiedName,
                        // put quotes around keys that contain potentially unsafe characters
                        quoted: UNSAFE_OBJECT_KEY_NAME_REGEXP.test(minifiedName),
                        value: (keepDeclared && publicName !== declaredName) ?
                            literalArr([asLiteral(publicName), asLiteral(declaredName)]) :
                            asLiteral(publicName)
                    };
                }));
            }
            /**
             *  Remove trailing null nodes as they are implied.
             */
            function trimTrailingNulls(parameters) {
                while (isNull(parameters[parameters.length - 1])) {
                    parameters.pop();
                }
                return parameters;
            }
            function getQueryPredicate(query, constantPool) {
                if (Array.isArray(query.predicate)) {
                    var predicate_1 = [];
                    query.predicate.forEach(function (selector) {
                        // Each item in predicates array may contain strings with comma-separated refs
                        // (for ex. 'ref, ref1, ..., refN'), thus we extract individual refs and store them
                        // as separate array entities
                        var selectors = selector.split(',').map(function (token) { return literal(token.trim()); });
                        predicate_1.push.apply(predicate_1, selectors);
                    });
                    return constantPool.getConstLiteral(literalArr(predicate_1), true);
                }
                else {
                    return query.predicate;
                }
            }
            function noop() { }
            var DefinitionMap = /** @class */ (function () {
                function DefinitionMap() {
                    this.values = [];
                }
                DefinitionMap.prototype.set = function (key, value) {
                    if (value) {
                        this.values.push({ key: key, value: value, quoted: false });
                    }
                };
                DefinitionMap.prototype.toLiteralMap = function () { return literalMap(this.values); };
                return DefinitionMap;
            }());
            /**
             * Extract a map of properties to values for a given element or template node, which can be used
             * by the directive matching machinery.
             *
             * @param elOrTpl the element or template in question
             * @return an object set up for directive matching. For attributes on the element/template, this
             * object maps a property name to its (static) value. For any bindings, this map simply maps the
             * property name to an empty string.
             */
            function getAttrsForDirectiveMatching(elOrTpl) {
                var attributesMap = {};
                if (elOrTpl instanceof Template && elOrTpl.tagName !== 'ng-template') {
                    elOrTpl.templateAttrs.forEach(function (a) { return attributesMap[a.name] = ''; });
                }
                else {
                    elOrTpl.attributes.forEach(function (a) {
                        if (!isI18nAttribute(a.name)) {
                            attributesMap[a.name] = a.value;
                        }
                    });
                    elOrTpl.inputs.forEach(function (i) { attributesMap[i.name] = ''; });
                    elOrTpl.outputs.forEach(function (o) { attributesMap[o.name] = ''; });
                }
                return attributesMap;
            }
            /** Returns a call expression to a chained instruction, e.g. `property(params[0])(params[1])`. */
            function chainedInstruction(reference, calls, span) {
                var expression = importExpr(reference, null, span);
                if (calls.length > 0) {
                    for (var i = 0; i < calls.length; i++) {
                        expression = expression.callFn(calls[i], span);
                    }
                }
                else {
                    // Add a blank invocation, in case the `calls` array is empty.
                    expression = expression.callFn([], span);
                }
                return expression;
            }
            /**
             * Gets the number of arguments expected to be passed to a generated instruction in the case of
             * interpolation instructions.
             * @param interpolation An interpolation ast
             */
            function getInterpolationArgsLength(interpolation) {
                var expressions = interpolation.expressions, strings = interpolation.strings;
                if (expressions.length === 1 && strings.length === 2 && strings[0] === '' && strings[1] === '') {
                    // If the interpolation has one interpolated value, but the prefix and suffix are both empty
                    // strings, we only pass one argument, to a special instruction like `propertyInterpolate` or
                    // `textInterpolate`.
                    return 1;
                }
                else {
                    return expressions.length + strings.length;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var R3FactoryDelegateType;
            (function (R3FactoryDelegateType) {
                R3FactoryDelegateType[R3FactoryDelegateType["Class"] = 0] = "Class";
                R3FactoryDelegateType[R3FactoryDelegateType["Function"] = 1] = "Function";
                R3FactoryDelegateType[R3FactoryDelegateType["Factory"] = 2] = "Factory";
            })(R3FactoryDelegateType || (R3FactoryDelegateType = {}));
            /**
             * Resolved type of a dependency.
             *
             * Occasionally, dependencies will have special significance which is known statically. In that
             * case the `R3ResolvedDependencyType` informs the factory generator that a particular dependency
             * should be generated specially (usually by calling a special injection function instead of the
             * standard one).
             */
            var R3ResolvedDependencyType;
            (function (R3ResolvedDependencyType) {
                /**
                 * A normal token dependency.
                 */
                R3ResolvedDependencyType[R3ResolvedDependencyType["Token"] = 0] = "Token";
                /**
                 * The dependency is for an attribute.
                 *
                 * The token expression is a string representing the attribute name.
                 */
                R3ResolvedDependencyType[R3ResolvedDependencyType["Attribute"] = 1] = "Attribute";
                /**
                 * Injecting the `ChangeDetectorRef` token. Needs special handling when injected into a pipe.
                 */
                R3ResolvedDependencyType[R3ResolvedDependencyType["ChangeDetectorRef"] = 2] = "ChangeDetectorRef";
            })(R3ResolvedDependencyType || (R3ResolvedDependencyType = {}));
            /**
             * Construct a factory function expression for the given `R3FactoryMetadata`.
             */
            function compileFactoryFunction(meta, isPipe) {
                if (isPipe === void 0) { isPipe = false; }
                var t = variable('t');
                var statements = [];
                // The type to instantiate via constructor invocation. If there is no delegated factory, meaning
                // this type is always created by constructor invocation, then this is the type-to-create
                // parameter provided by the user (t) if specified, or the current type if not. If there is a
                // delegated factory (which is used to create the current type) then this is only the type-to-
                // create parameter (t).
                var typeForCtor = !isDelegatedMetadata(meta) ? new BinaryOperatorExpr(BinaryOperator.Or, t, meta.type) : t;
                var ctorExpr = null;
                if (meta.deps !== null) {
                    // There is a constructor (either explicitly or implicitly defined).
                    if (meta.deps !== 'invalid') {
                        ctorExpr =
                            new InstantiateExpr(typeForCtor, injectDependencies(meta.deps, meta.injectFn, isPipe));
                    }
                }
                else {
                    var baseFactory = variable("\u0275" + meta.name + "_BaseFactory");
                    var getInheritedFactory = importExpr(Identifiers$1.getInheritedFactory);
                    var baseFactoryStmt = baseFactory.set(getInheritedFactory.callFn([meta.type])).toDeclStmt(INFERRED_TYPE, [
                        StmtModifier.Exported, StmtModifier.Final
                    ]);
                    statements.push(baseFactoryStmt);
                    // There is no constructor, use the base class' factory to construct typeForCtor.
                    ctorExpr = baseFactory.callFn([typeForCtor]);
                }
                var ctorExprFinal = ctorExpr;
                var body = [];
                var retExpr = null;
                function makeConditionalFactory(nonCtorExpr) {
                    var r = variable('r');
                    body.push(r.set(NULL_EXPR).toDeclStmt());
                    var ctorStmt = null;
                    if (ctorExprFinal !== null) {
                        ctorStmt = r.set(ctorExprFinal).toStmt();
                    }
                    else {
                        ctorStmt = makeErrorStmt(meta.name);
                    }
                    body.push(ifStmt(t, [ctorStmt], [r.set(nonCtorExpr).toStmt()]));
                    return r;
                }
                if (isDelegatedMetadata(meta) && meta.delegateType === R3FactoryDelegateType.Factory) {
                    var delegateFactory = variable("\u0275" + meta.name + "_BaseFactory");
                    var getFactoryOf = importExpr(Identifiers$1.getFactoryOf);
                    if (meta.delegate.isEquivalent(meta.type)) {
                        throw new Error("Illegal state: compiling factory that delegates to itself");
                    }
                    var delegateFactoryStmt = delegateFactory.set(getFactoryOf.callFn([meta.delegate])).toDeclStmt(INFERRED_TYPE, [
                        StmtModifier.Exported, StmtModifier.Final
                    ]);
                    statements.push(delegateFactoryStmt);
                    retExpr = makeConditionalFactory(delegateFactory.callFn([]));
                }
                else if (isDelegatedMetadata(meta)) {
                    // This type is created with a delegated factory. If a type parameter is not specified, call
                    // the factory instead.
                    var delegateArgs = injectDependencies(meta.delegateDeps, meta.injectFn, isPipe);
                    // Either call `new delegate(...)` or `delegate(...)` depending on meta.useNewForDelegate.
                    var factoryExpr = new (meta.delegateType === R3FactoryDelegateType.Class ?
                        InstantiateExpr :
                        InvokeFunctionExpr)(meta.delegate, delegateArgs);
                    retExpr = makeConditionalFactory(factoryExpr);
                }
                else if (isExpressionFactoryMetadata(meta)) {
                    // TODO(alxhub): decide whether to lower the value here or in the caller
                    retExpr = makeConditionalFactory(meta.expression);
                }
                else {
                    retExpr = ctorExpr;
                }
                if (retExpr !== null) {
                    body.push(new ReturnStatement(retExpr));
                }
                else {
                    body.push(makeErrorStmt(meta.name));
                }
                return {
                    factory: fn([new FnParam('t', DYNAMIC_TYPE)], body, INFERRED_TYPE, undefined, meta.name + "_Factory"),
                    statements: statements,
                };
            }
            function injectDependencies(deps, injectFn, isPipe) {
                return deps.map(function (dep) { return compileInjectDependency(dep, injectFn, isPipe); });
            }
            function compileInjectDependency(dep, injectFn, isPipe) {
                // Interpret the dependency according to its resolved type.
                switch (dep.resolved) {
                    case R3ResolvedDependencyType.Token:
                    case R3ResolvedDependencyType.ChangeDetectorRef:
                        // Build up the injection flags according to the metadata.
                        var flags = 0 /* Default */ | (dep.self ? 2 /* Self */ : 0) |
                            (dep.skipSelf ? 4 /* SkipSelf */ : 0) | (dep.host ? 1 /* Host */ : 0) |
                            (dep.optional ? 8 /* Optional */ : 0);
                        // If this dependency is optional or otherwise has non-default flags, then additional
                        // parameters describing how to inject the dependency must be passed to the inject function
                        // that's being used.
                        var flagsParam = (flags !== 0 /* Default */ || dep.optional) ? literal(flags) : null;
                        // We have a separate instruction for injecting ChangeDetectorRef into a pipe.
                        if (isPipe && dep.resolved === R3ResolvedDependencyType.ChangeDetectorRef) {
                            return importExpr(Identifiers$1.injectPipeChangeDetectorRef).callFn(flagsParam ? [flagsParam] : []);
                        }
                        // Build up the arguments to the injectFn call.
                        var injectArgs = [dep.token];
                        if (flagsParam) {
                            injectArgs.push(flagsParam);
                        }
                        return importExpr(injectFn).callFn(injectArgs);
                    case R3ResolvedDependencyType.Attribute:
                        // In the case of attributes, the attribute name in question is given as the token.
                        return importExpr(Identifiers$1.injectAttribute).callFn([dep.token]);
                    default:
                        return unsupported("Unknown R3ResolvedDependencyType: " + R3ResolvedDependencyType[dep.resolved]);
                }
            }
            /**
             * A helper function useful for extracting `R3DependencyMetadata` from a Render2
             * `CompileTypeMetadata` instance.
             */
            function dependenciesFromGlobalMetadata(type, outputCtx, reflector) {
                // Use the `CompileReflector` to look up references to some well-known Angular types. These will
                // be compared with the token to statically determine whether the token has significance to
                // Angular, and set the correct `R3ResolvedDependencyType` as a result.
                var injectorRef = reflector.resolveExternalReference(Identifiers.Injector);
                // Iterate through the type's DI dependencies and produce `R3DependencyMetadata` for each of them.
                var deps = [];
                for (var _c = 0, _d = type.diDeps; _c < _d.length; _c++) {
                    var dependency = _d[_c];
                    if (dependency.token) {
                        var tokenRef = tokenReference(dependency.token);
                        var resolved = dependency.isAttribute ?
                            R3ResolvedDependencyType.Attribute :
                            R3ResolvedDependencyType.Token;
                        // In the case of most dependencies, the token will be a reference to a type. Sometimes,
                        // however, it can be a string, in the case of older Angular code or @Attribute injection.
                        var token = tokenRef instanceof StaticSymbol ? outputCtx.importExpr(tokenRef) : literal(tokenRef);
                        // Construct the dependency.
                        deps.push({
                            token: token,
                            resolved: resolved,
                            host: !!dependency.isHost,
                            optional: !!dependency.isOptional,
                            self: !!dependency.isSelf,
                            skipSelf: !!dependency.isSkipSelf,
                        });
                    }
                    else {
                        unsupported('dependency without a token');
                    }
                }
                return deps;
            }
            function makeErrorStmt(name) {
                return new ThrowStmt(new InstantiateExpr(new ReadVarExpr('Error'), [
                    literal(name + " has a constructor which is not compatible with Dependency Injection. It should probably not be @Injectable().")
                ]));
            }
            function isDelegatedMetadata(meta) {
                return meta.delegateType !== undefined;
            }
            function isExpressionFactoryMetadata(meta) {
                return meta.expression !== undefined;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Convert an object map with `Expression` values into a `LiteralMapExpr`.
             */
            function mapToMapExpression(map) {
                var result = Object.keys(map).map(function (key) { return ({ key: key, value: map[key], quoted: false }); });
                return literalMap(result);
            }
            /**
             * Convert metadata into an `Expression` in the given `OutputContext`.
             *
             * This operation will handle arrays, references to symbols, or literal `null` or `undefined`.
             */
            function convertMetaToOutput(meta, ctx) {
                if (Array.isArray(meta)) {
                    return literalArr(meta.map(function (entry) { return convertMetaToOutput(entry, ctx); }));
                }
                if (meta instanceof StaticSymbol) {
                    return ctx.importExpr(meta);
                }
                if (meta == null) {
                    return literal(meta);
                }
                throw new Error("Internal error: Unsupported or unknown metadata: " + meta);
            }
            function typeWithParameters(type, numParams) {
                var params = null;
                if (numParams > 0) {
                    params = [];
                    for (var i = 0; i < numParams; i++) {
                        params.push(DYNAMIC_TYPE);
                    }
                }
                return expressionType(type, null, params);
            }
            var ANIMATE_SYMBOL_PREFIX = '@';
            function prepareSyntheticPropertyName(name) {
                return "" + ANIMATE_SYMBOL_PREFIX + name;
            }
            function prepareSyntheticListenerName(name, phase) {
                return "" + ANIMATE_SYMBOL_PREFIX + name + "." + phase;
            }
            function isSyntheticPropertyOrListener(name) {
                return name.charAt(0) == ANIMATE_SYMBOL_PREFIX;
            }
            function getSyntheticPropertyName(name) {
                // this will strip out listener phase values...
                // @foo.start => @foo
                var i = name.indexOf('.');
                name = i > 0 ? name.substring(0, i) : name;
                if (name.charAt(0) !== ANIMATE_SYMBOL_PREFIX) {
                    name = ANIMATE_SYMBOL_PREFIX + name;
                }
                return name;
            }
            function prepareSyntheticListenerFunctionName(name, phase) {
                return "animation_" + name + "_" + phase;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function compileInjectable(meta) {
                var result = null;
                var factoryMeta = {
                    name: meta.name,
                    type: meta.type,
                    deps: meta.ctorDeps,
                    injectFn: Identifiers.inject,
                };
                if (meta.useClass !== undefined) {
                    // meta.useClass has two modes of operation. Either deps are specified, in which case `new` is
                    // used to instantiate the class with dependencies injected, or deps are not specified and
                    // the factory of the class is used to instantiate it.
                    //
                    // A special case exists for useClass: Type where Type is the injectable type itself and no
                    // deps are specified, in which case 'useClass' is effectively ignored.
                    var useClassOnSelf = meta.useClass.isEquivalent(meta.type);
                    var deps = undefined;
                    if (meta.userDeps !== undefined) {
                        deps = meta.userDeps;
                    }
                    if (deps !== undefined) {
                        // factory: () => new meta.useClass(...deps)
                        result = compileFactoryFunction(Object.assign({}, factoryMeta, { delegate: meta.useClass, delegateDeps: deps, delegateType: R3FactoryDelegateType.Class }));
                    }
                    else if (useClassOnSelf) {
                        result = compileFactoryFunction(factoryMeta);
                    }
                    else {
                        result = compileFactoryFunction(Object.assign({}, factoryMeta, { delegate: meta.useClass, delegateType: R3FactoryDelegateType.Factory }));
                    }
                }
                else if (meta.useFactory !== undefined) {
                    result = compileFactoryFunction(Object.assign({}, factoryMeta, { delegate: meta.useFactory, delegateDeps: meta.userDeps || [], delegateType: R3FactoryDelegateType.Function }));
                }
                else if (meta.useValue !== undefined) {
                    // Note: it's safe to use `meta.useValue` instead of the `USE_VALUE in meta` check used for
                    // client code because meta.useValue is an Expression which will be defined even if the actual
                    // value is undefined.
                    result = compileFactoryFunction(Object.assign({}, factoryMeta, { expression: meta.useValue }));
                }
                else if (meta.useExisting !== undefined) {
                    // useExisting is an `inject` call on the existing token.
                    result = compileFactoryFunction(Object.assign({}, factoryMeta, { expression: importExpr(Identifiers.inject).callFn([meta.useExisting]) }));
                }
                else {
                    result = compileFactoryFunction(factoryMeta);
                }
                var token = meta.type;
                var providedIn = meta.providedIn;
                var expression = importExpr(Identifiers.ɵɵdefineInjectable).callFn([mapToMapExpression({ token: token, factory: result.factory, providedIn: providedIn })]);
                var type = new ExpressionType(importExpr(Identifiers.InjectableDef, [typeWithParameters(meta.type, meta.typeArgumentCount)]));
                return {
                    expression: expression,
                    type: type,
                    statements: result.statements,
                };
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function assertArrayOfStrings(identifier, value) {
                if (value == null) {
                    return;
                }
                if (!Array.isArray(value)) {
                    throw new Error("Expected '" + identifier + "' to be an array of strings.");
                }
                for (var i = 0; i < value.length; i += 1) {
                    if (typeof value[i] !== 'string') {
                        throw new Error("Expected '" + identifier + "' to be an array of strings.");
                    }
                }
            }
            var UNUSABLE_INTERPOLATION_REGEXPS = [
                /^\s*$/,
                /[<>]/,
                /^[{}]$/,
                /&(#|[a-z])/i,
                /^\/\//,
            ];
            function assertInterpolationSymbols(identifier, value) {
                if (value != null && !(Array.isArray(value) && value.length == 2)) {
                    throw new Error("Expected '" + identifier + "' to be an array, [start, end].");
                }
                else if (value != null) {
                    var start_1 = value[0];
                    var end_1 = value[1];
                    // Check for unusable interpolation symbols
                    UNUSABLE_INTERPOLATION_REGEXPS.forEach(function (regexp) {
                        if (regexp.test(start_1) || regexp.test(end_1)) {
                            throw new Error("['" + start_1 + "', '" + end_1 + "'] contains unusable interpolation symbol.");
                        }
                    });
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var InterpolationConfig = /** @class */ (function () {
                function InterpolationConfig(start, end) {
                    this.start = start;
                    this.end = end;
                }
                InterpolationConfig.fromArray = function (markers) {
                    if (!markers) {
                        return DEFAULT_INTERPOLATION_CONFIG;
                    }
                    assertInterpolationSymbols('interpolation', markers);
                    return new InterpolationConfig(markers[0], markers[1]);
                };
                return InterpolationConfig;
            }());
            var DEFAULT_INTERPOLATION_CONFIG = new InterpolationConfig('{{', '}}');
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit
            var VERSION = 3;
            var JS_B64_PREFIX = '# sourceMappingURL=data:application/json;base64,';
            var SourceMapGenerator = /** @class */ (function () {
                function SourceMapGenerator(file) {
                    if (file === void 0) { file = null; }
                    this.file = file;
                    this.sourcesContent = new Map();
                    this.lines = [];
                    this.lastCol0 = 0;
                    this.hasMappings = false;
                }
                // The content is `null` when the content is expected to be loaded using the URL
                SourceMapGenerator.prototype.addSource = function (url, content) {
                    if (content === void 0) { content = null; }
                    if (!this.sourcesContent.has(url)) {
                        this.sourcesContent.set(url, content);
                    }
                    return this;
                };
                SourceMapGenerator.prototype.addLine = function () {
                    this.lines.push([]);
                    this.lastCol0 = 0;
                    return this;
                };
                SourceMapGenerator.prototype.addMapping = function (col0, sourceUrl, sourceLine0, sourceCol0) {
                    if (!this.currentLine) {
                        throw new Error("A line must be added before mappings can be added");
                    }
                    if (sourceUrl != null && !this.sourcesContent.has(sourceUrl)) {
                        throw new Error("Unknown source file \"" + sourceUrl + "\"");
                    }
                    if (col0 == null) {
                        throw new Error("The column in the generated code must be provided");
                    }
                    if (col0 < this.lastCol0) {
                        throw new Error("Mapping should be added in output order");
                    }
                    if (sourceUrl && (sourceLine0 == null || sourceCol0 == null)) {
                        throw new Error("The source location must be provided when a source url is provided");
                    }
                    this.hasMappings = true;
                    this.lastCol0 = col0;
                    this.currentLine.push({ col0: col0, sourceUrl: sourceUrl, sourceLine0: sourceLine0, sourceCol0: sourceCol0 });
                    return this;
                };
                Object.defineProperty(SourceMapGenerator.prototype, "currentLine", {
                    get: function () { return this.lines.slice(-1)[0]; },
                    enumerable: true,
                    configurable: true
                });
                SourceMapGenerator.prototype.toJSON = function () {
                    var _this = this;
                    if (!this.hasMappings) {
                        return null;
                    }
                    var sourcesIndex = new Map();
                    var sources = [];
                    var sourcesContent = [];
                    Array.from(this.sourcesContent.keys()).forEach(function (url, i) {
                        sourcesIndex.set(url, i);
                        sources.push(url);
                        sourcesContent.push(_this.sourcesContent.get(url) || null);
                    });
                    var mappings = '';
                    var lastCol0 = 0;
                    var lastSourceIndex = 0;
                    var lastSourceLine0 = 0;
                    var lastSourceCol0 = 0;
                    this.lines.forEach(function (segments) {
                        lastCol0 = 0;
                        mappings += segments
                            .map(function (segment) {
                            // zero-based starting column of the line in the generated code
                            var segAsStr = toBase64VLQ(segment.col0 - lastCol0);
                            lastCol0 = segment.col0;
                            if (segment.sourceUrl != null) {
                                // zero-based index into the “sources” list
                                segAsStr +=
                                    toBase64VLQ(sourcesIndex.get(segment.sourceUrl) - lastSourceIndex);
                                lastSourceIndex = sourcesIndex.get(segment.sourceUrl);
                                // the zero-based starting line in the original source
                                segAsStr += toBase64VLQ(segment.sourceLine0 - lastSourceLine0);
                                lastSourceLine0 = segment.sourceLine0;
                                // the zero-based starting column in the original source
                                segAsStr += toBase64VLQ(segment.sourceCol0 - lastSourceCol0);
                                lastSourceCol0 = segment.sourceCol0;
                            }
                            return segAsStr;
                        })
                            .join(',');
                        mappings += ';';
                    });
                    mappings = mappings.slice(0, -1);
                    return {
                        'file': this.file || '',
                        'version': VERSION,
                        'sourceRoot': '',
                        'sources': sources,
                        'sourcesContent': sourcesContent,
                        'mappings': mappings,
                    };
                };
                SourceMapGenerator.prototype.toJsComment = function () {
                    return this.hasMappings ? '//' + JS_B64_PREFIX + toBase64String(JSON.stringify(this, null, 0)) :
                        '';
                };
                return SourceMapGenerator;
            }());
            function toBase64String(value) {
                var b64 = '';
                value = utf8Encode(value);
                for (var i = 0; i < value.length;) {
                    var i1 = value.charCodeAt(i++);
                    var i2 = value.charCodeAt(i++);
                    var i3 = value.charCodeAt(i++);
                    b64 += toBase64Digit(i1 >> 2);
                    b64 += toBase64Digit(((i1 & 3) << 4) | (isNaN(i2) ? 0 : i2 >> 4));
                    b64 += isNaN(i2) ? '=' : toBase64Digit(((i2 & 15) << 2) | (i3 >> 6));
                    b64 += isNaN(i2) || isNaN(i3) ? '=' : toBase64Digit(i3 & 63);
                }
                return b64;
            }
            function toBase64VLQ(value) {
                value = value < 0 ? ((-value) << 1) + 1 : value << 1;
                var out = '';
                do {
                    var digit = value & 31;
                    value = value >> 5;
                    if (value > 0) {
                        digit = digit | 32;
                    }
                    out += toBase64Digit(digit);
                } while (value > 0);
                return out;
            }
            var B64_DIGITS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            function toBase64Digit(value) {
                if (value < 0 || value >= 64) {
                    throw new Error("Can only encode value in the range [0, 63]");
                }
                return B64_DIGITS[value];
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _SINGLE_QUOTE_ESCAPE_STRING_RE = /'|\\|\n|\r|\$/g;
            var _LEGAL_IDENTIFIER_RE = /^[$A-Z_][0-9A-Z_$]*$/i;
            var _INDENT_WITH = '  ';
            var CATCH_ERROR_VAR$1 = variable('error', null, null);
            var CATCH_STACK_VAR$1 = variable('stack', null, null);
            var _EmittedLine = /** @class */ (function () {
                function _EmittedLine(indent) {
                    this.indent = indent;
                    this.partsLength = 0;
                    this.parts = [];
                    this.srcSpans = [];
                }
                return _EmittedLine;
            }());
            var EmitterVisitorContext = /** @class */ (function () {
                function EmitterVisitorContext(_indent) {
                    this._indent = _indent;
                    this._classes = [];
                    this._preambleLineCount = 0;
                    this._lines = [new _EmittedLine(_indent)];
                }
                EmitterVisitorContext.createRoot = function () { return new EmitterVisitorContext(0); };
                Object.defineProperty(EmitterVisitorContext.prototype, "_currentLine", {
                    get: function () { return this._lines[this._lines.length - 1]; },
                    enumerable: true,
                    configurable: true
                });
                EmitterVisitorContext.prototype.println = function (from, lastPart) {
                    if (lastPart === void 0) { lastPart = ''; }
                    this.print(from || null, lastPart, true);
                };
                EmitterVisitorContext.prototype.lineIsEmpty = function () { return this._currentLine.parts.length === 0; };
                EmitterVisitorContext.prototype.lineLength = function () {
                    return this._currentLine.indent * _INDENT_WITH.length + this._currentLine.partsLength;
                };
                EmitterVisitorContext.prototype.print = function (from, part, newLine) {
                    if (newLine === void 0) { newLine = false; }
                    if (part.length > 0) {
                        this._currentLine.parts.push(part);
                        this._currentLine.partsLength += part.length;
                        this._currentLine.srcSpans.push(from && from.sourceSpan || null);
                    }
                    if (newLine) {
                        this._lines.push(new _EmittedLine(this._indent));
                    }
                };
                EmitterVisitorContext.prototype.removeEmptyLastLine = function () {
                    if (this.lineIsEmpty()) {
                        this._lines.pop();
                    }
                };
                EmitterVisitorContext.prototype.incIndent = function () {
                    this._indent++;
                    if (this.lineIsEmpty()) {
                        this._currentLine.indent = this._indent;
                    }
                };
                EmitterVisitorContext.prototype.decIndent = function () {
                    this._indent--;
                    if (this.lineIsEmpty()) {
                        this._currentLine.indent = this._indent;
                    }
                };
                EmitterVisitorContext.prototype.pushClass = function (clazz) { this._classes.push(clazz); };
                EmitterVisitorContext.prototype.popClass = function () { return this._classes.pop(); };
                Object.defineProperty(EmitterVisitorContext.prototype, "currentClass", {
                    get: function () {
                        return this._classes.length > 0 ? this._classes[this._classes.length - 1] : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                EmitterVisitorContext.prototype.toSource = function () {
                    return this.sourceLines
                        .map(function (l) { return l.parts.length > 0 ? _createIndent(l.indent) + l.parts.join('') : ''; })
                        .join('\n');
                };
                EmitterVisitorContext.prototype.toSourceMapGenerator = function (genFilePath, startsAtLine) {
                    if (startsAtLine === void 0) { startsAtLine = 0; }
                    var map = new SourceMapGenerator(genFilePath);
                    var firstOffsetMapped = false;
                    var mapFirstOffsetIfNeeded = function () {
                        if (!firstOffsetMapped) {
                            // Add a single space so that tools won't try to load the file from disk.
                            // Note: We are using virtual urls like `ng:///`, so we have to
                            // provide a content here.
                            map.addSource(genFilePath, ' ').addMapping(0, genFilePath, 0, 0);
                            firstOffsetMapped = true;
                        }
                    };
                    for (var i = 0; i < startsAtLine; i++) {
                        map.addLine();
                        mapFirstOffsetIfNeeded();
                    }
                    this.sourceLines.forEach(function (line, lineIdx) {
                        map.addLine();
                        var spans = line.srcSpans;
                        var parts = line.parts;
                        var col0 = line.indent * _INDENT_WITH.length;
                        var spanIdx = 0;
                        // skip leading parts without source spans
                        while (spanIdx < spans.length && !spans[spanIdx]) {
                            col0 += parts[spanIdx].length;
                            spanIdx++;
                        }
                        if (spanIdx < spans.length && lineIdx === 0 && col0 === 0) {
                            firstOffsetMapped = true;
                        }
                        else {
                            mapFirstOffsetIfNeeded();
                        }
                        while (spanIdx < spans.length) {
                            var span = spans[spanIdx];
                            var source = span.start.file;
                            var sourceLine = span.start.line;
                            var sourceCol = span.start.col;
                            map.addSource(source.url, source.content)
                                .addMapping(col0, source.url, sourceLine, sourceCol);
                            col0 += parts[spanIdx].length;
                            spanIdx++;
                            // assign parts without span or the same span to the previous segment
                            while (spanIdx < spans.length && (span === spans[spanIdx] || !spans[spanIdx])) {
                                col0 += parts[spanIdx].length;
                                spanIdx++;
                            }
                        }
                    });
                    return map;
                };
                EmitterVisitorContext.prototype.setPreambleLineCount = function (count) { return this._preambleLineCount = count; };
                EmitterVisitorContext.prototype.spanOf = function (line, column) {
                    var emittedLine = this._lines[line - this._preambleLineCount];
                    if (emittedLine) {
                        var columnsLeft = column - _createIndent(emittedLine.indent).length;
                        for (var partIndex = 0; partIndex < emittedLine.parts.length; partIndex++) {
                            var part = emittedLine.parts[partIndex];
                            if (part.length > columnsLeft) {
                                return emittedLine.srcSpans[partIndex];
                            }
                            columnsLeft -= part.length;
                        }
                    }
                    return null;
                };
                Object.defineProperty(EmitterVisitorContext.prototype, "sourceLines", {
                    get: function () {
                        if (this._lines.length && this._lines[this._lines.length - 1].parts.length === 0) {
                            return this._lines.slice(0, -1);
                        }
                        return this._lines;
                    },
                    enumerable: true,
                    configurable: true
                });
                return EmitterVisitorContext;
            }());
            var AbstractEmitterVisitor = /** @class */ (function () {
                function AbstractEmitterVisitor(_escapeDollarInStrings) {
                    this._escapeDollarInStrings = _escapeDollarInStrings;
                }
                AbstractEmitterVisitor.prototype.visitExpressionStmt = function (stmt, ctx) {
                    stmt.expr.visitExpression(this, ctx);
                    ctx.println(stmt, ';');
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitReturnStmt = function (stmt, ctx) {
                    ctx.print(stmt, "return ");
                    stmt.value.visitExpression(this, ctx);
                    ctx.println(stmt, ';');
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitIfStmt = function (stmt, ctx) {
                    ctx.print(stmt, "if (");
                    stmt.condition.visitExpression(this, ctx);
                    ctx.print(stmt, ") {");
                    var hasElseCase = stmt.falseCase != null && stmt.falseCase.length > 0;
                    if (stmt.trueCase.length <= 1 && !hasElseCase) {
                        ctx.print(stmt, " ");
                        this.visitAllStatements(stmt.trueCase, ctx);
                        ctx.removeEmptyLastLine();
                        ctx.print(stmt, " ");
                    }
                    else {
                        ctx.println();
                        ctx.incIndent();
                        this.visitAllStatements(stmt.trueCase, ctx);
                        ctx.decIndent();
                        if (hasElseCase) {
                            ctx.println(stmt, "} else {");
                            ctx.incIndent();
                            this.visitAllStatements(stmt.falseCase, ctx);
                            ctx.decIndent();
                        }
                    }
                    ctx.println(stmt, "}");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitThrowStmt = function (stmt, ctx) {
                    ctx.print(stmt, "throw ");
                    stmt.error.visitExpression(this, ctx);
                    ctx.println(stmt, ";");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitCommentStmt = function (stmt, ctx) {
                    if (stmt.multiline) {
                        ctx.println(stmt, "/* " + stmt.comment + " */");
                    }
                    else {
                        stmt.comment.split('\n').forEach(function (line) { ctx.println(stmt, "// " + line); });
                    }
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitJSDocCommentStmt = function (stmt, ctx) {
                    ctx.println(stmt, "/*" + stmt.toString() + "*/");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitWriteVarExpr = function (expr, ctx) {
                    var lineWasEmpty = ctx.lineIsEmpty();
                    if (!lineWasEmpty) {
                        ctx.print(expr, '(');
                    }
                    ctx.print(expr, expr.name + " = ");
                    expr.value.visitExpression(this, ctx);
                    if (!lineWasEmpty) {
                        ctx.print(expr, ')');
                    }
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitWriteKeyExpr = function (expr, ctx) {
                    var lineWasEmpty = ctx.lineIsEmpty();
                    if (!lineWasEmpty) {
                        ctx.print(expr, '(');
                    }
                    expr.receiver.visitExpression(this, ctx);
                    ctx.print(expr, "[");
                    expr.index.visitExpression(this, ctx);
                    ctx.print(expr, "] = ");
                    expr.value.visitExpression(this, ctx);
                    if (!lineWasEmpty) {
                        ctx.print(expr, ')');
                    }
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitWritePropExpr = function (expr, ctx) {
                    var lineWasEmpty = ctx.lineIsEmpty();
                    if (!lineWasEmpty) {
                        ctx.print(expr, '(');
                    }
                    expr.receiver.visitExpression(this, ctx);
                    ctx.print(expr, "." + expr.name + " = ");
                    expr.value.visitExpression(this, ctx);
                    if (!lineWasEmpty) {
                        ctx.print(expr, ')');
                    }
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitInvokeMethodExpr = function (expr, ctx) {
                    expr.receiver.visitExpression(this, ctx);
                    var name = expr.name;
                    if (expr.builtin != null) {
                        name = this.getBuiltinMethodName(expr.builtin);
                        if (name == null) {
                            // some builtins just mean to skip the call.
                            return null;
                        }
                    }
                    ctx.print(expr, "." + name + "(");
                    this.visitAllExpressions(expr.args, ctx, ",");
                    ctx.print(expr, ")");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitInvokeFunctionExpr = function (expr, ctx) {
                    expr.fn.visitExpression(this, ctx);
                    ctx.print(expr, "(");
                    this.visitAllExpressions(expr.args, ctx, ',');
                    ctx.print(expr, ")");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitWrappedNodeExpr = function (ast, ctx) {
                    throw new Error('Abstract emitter cannot visit WrappedNodeExpr.');
                };
                AbstractEmitterVisitor.prototype.visitTypeofExpr = function (expr, ctx) {
                    ctx.print(expr, 'typeof ');
                    expr.expr.visitExpression(this, ctx);
                };
                AbstractEmitterVisitor.prototype.visitReadVarExpr = function (ast, ctx) {
                    var varName = ast.name;
                    if (ast.builtin != null) {
                        switch (ast.builtin) {
                            case BuiltinVar.Super:
                                varName = 'super';
                                break;
                            case BuiltinVar.This:
                                varName = 'this';
                                break;
                            case BuiltinVar.CatchError:
                                varName = CATCH_ERROR_VAR$1.name;
                                break;
                            case BuiltinVar.CatchStack:
                                varName = CATCH_STACK_VAR$1.name;
                                break;
                            default:
                                throw new Error("Unknown builtin variable " + ast.builtin);
                        }
                    }
                    ctx.print(ast, varName);
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitInstantiateExpr = function (ast, ctx) {
                    ctx.print(ast, "new ");
                    ast.classExpr.visitExpression(this, ctx);
                    ctx.print(ast, "(");
                    this.visitAllExpressions(ast.args, ctx, ',');
                    ctx.print(ast, ")");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitLiteralExpr = function (ast, ctx) {
                    var value = ast.value;
                    if (typeof value === 'string') {
                        ctx.print(ast, escapeIdentifier(value, this._escapeDollarInStrings));
                    }
                    else {
                        ctx.print(ast, "" + value);
                    }
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitConditionalExpr = function (ast, ctx) {
                    ctx.print(ast, "(");
                    ast.condition.visitExpression(this, ctx);
                    ctx.print(ast, '? ');
                    ast.trueCase.visitExpression(this, ctx);
                    ctx.print(ast, ': ');
                    ast.falseCase.visitExpression(this, ctx);
                    ctx.print(ast, ")");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitNotExpr = function (ast, ctx) {
                    ctx.print(ast, '!');
                    ast.condition.visitExpression(this, ctx);
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitAssertNotNullExpr = function (ast, ctx) {
                    ast.condition.visitExpression(this, ctx);
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitBinaryOperatorExpr = function (ast, ctx) {
                    var opStr;
                    switch (ast.operator) {
                        case BinaryOperator.Equals:
                            opStr = '==';
                            break;
                        case BinaryOperator.Identical:
                            opStr = '===';
                            break;
                        case BinaryOperator.NotEquals:
                            opStr = '!=';
                            break;
                        case BinaryOperator.NotIdentical:
                            opStr = '!==';
                            break;
                        case BinaryOperator.And:
                            opStr = '&&';
                            break;
                        case BinaryOperator.BitwiseAnd:
                            opStr = '&';
                            break;
                        case BinaryOperator.Or:
                            opStr = '||';
                            break;
                        case BinaryOperator.Plus:
                            opStr = '+';
                            break;
                        case BinaryOperator.Minus:
                            opStr = '-';
                            break;
                        case BinaryOperator.Divide:
                            opStr = '/';
                            break;
                        case BinaryOperator.Multiply:
                            opStr = '*';
                            break;
                        case BinaryOperator.Modulo:
                            opStr = '%';
                            break;
                        case BinaryOperator.Lower:
                            opStr = '<';
                            break;
                        case BinaryOperator.LowerEquals:
                            opStr = '<=';
                            break;
                        case BinaryOperator.Bigger:
                            opStr = '>';
                            break;
                        case BinaryOperator.BiggerEquals:
                            opStr = '>=';
                            break;
                        default:
                            throw new Error("Unknown operator " + ast.operator);
                    }
                    if (ast.parens)
                        ctx.print(ast, "(");
                    ast.lhs.visitExpression(this, ctx);
                    ctx.print(ast, " " + opStr + " ");
                    ast.rhs.visitExpression(this, ctx);
                    if (ast.parens)
                        ctx.print(ast, ")");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitReadPropExpr = function (ast, ctx) {
                    ast.receiver.visitExpression(this, ctx);
                    ctx.print(ast, ".");
                    ctx.print(ast, ast.name);
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitReadKeyExpr = function (ast, ctx) {
                    ast.receiver.visitExpression(this, ctx);
                    ctx.print(ast, "[");
                    ast.index.visitExpression(this, ctx);
                    ctx.print(ast, "]");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitLiteralArrayExpr = function (ast, ctx) {
                    ctx.print(ast, "[");
                    this.visitAllExpressions(ast.entries, ctx, ',');
                    ctx.print(ast, "]");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitLiteralMapExpr = function (ast, ctx) {
                    var _this = this;
                    ctx.print(ast, "{");
                    this.visitAllObjects(function (entry) {
                        ctx.print(ast, escapeIdentifier(entry.key, _this._escapeDollarInStrings, entry.quoted) + ":");
                        entry.value.visitExpression(_this, ctx);
                    }, ast.entries, ctx, ',');
                    ctx.print(ast, "}");
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitCommaExpr = function (ast, ctx) {
                    ctx.print(ast, '(');
                    this.visitAllExpressions(ast.parts, ctx, ',');
                    ctx.print(ast, ')');
                    return null;
                };
                AbstractEmitterVisitor.prototype.visitAllExpressions = function (expressions, ctx, separator) {
                    var _this = this;
                    this.visitAllObjects(function (expr) { return expr.visitExpression(_this, ctx); }, expressions, ctx, separator);
                };
                AbstractEmitterVisitor.prototype.visitAllObjects = function (handler, expressions, ctx, separator) {
                    var incrementedIndent = false;
                    for (var i = 0; i < expressions.length; i++) {
                        if (i > 0) {
                            if (ctx.lineLength() > 80) {
                                ctx.print(null, separator, true);
                                if (!incrementedIndent) {
                                    // continuation are marked with double indent.
                                    ctx.incIndent();
                                    ctx.incIndent();
                                    incrementedIndent = true;
                                }
                            }
                            else {
                                ctx.print(null, separator, false);
                            }
                        }
                        handler(expressions[i]);
                    }
                    if (incrementedIndent) {
                        // continuation are marked with double indent.
                        ctx.decIndent();
                        ctx.decIndent();
                    }
                };
                AbstractEmitterVisitor.prototype.visitAllStatements = function (statements, ctx) {
                    var _this = this;
                    statements.forEach(function (stmt) { return stmt.visitStatement(_this, ctx); });
                };
                return AbstractEmitterVisitor;
            }());
            function escapeIdentifier(input, escapeDollar, alwaysQuote) {
                if (alwaysQuote === void 0) { alwaysQuote = true; }
                if (input == null) {
                    return null;
                }
                var body = input.replace(_SINGLE_QUOTE_ESCAPE_STRING_RE, function () {
                    var match = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        match[_c] = arguments[_c];
                    }
                    if (match[0] == '$') {
                        return escapeDollar ? '\\$' : '$';
                    }
                    else if (match[0] == '\n') {
                        return '\\n';
                    }
                    else if (match[0] == '\r') {
                        return '\\r';
                    }
                    else {
                        return "\\" + match[0];
                    }
                });
                var requiresQuotes = alwaysQuote || !_LEGAL_IDENTIFIER_RE.test(body);
                return requiresQuotes ? "'" + body + "'" : body;
            }
            function _createIndent(count) {
                var res = '';
                for (var i = 0; i < count; i++) {
                    res += _INDENT_WITH;
                }
                return res;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var AbstractJsEmitterVisitor = /** @class */ (function (_super_1) {
                __extends(AbstractJsEmitterVisitor, _super_1);
                function AbstractJsEmitterVisitor() {
                    return _super_1.call(this, false) || this;
                }
                AbstractJsEmitterVisitor.prototype.visitDeclareClassStmt = function (stmt, ctx) {
                    var _this = this;
                    ctx.pushClass(stmt);
                    this._visitClassConstructor(stmt, ctx);
                    if (stmt.parent != null) {
                        ctx.print(stmt, stmt.name + ".prototype = Object.create(");
                        stmt.parent.visitExpression(this, ctx);
                        ctx.println(stmt, ".prototype);");
                    }
                    stmt.getters.forEach(function (getter) { return _this._visitClassGetter(stmt, getter, ctx); });
                    stmt.methods.forEach(function (method) { return _this._visitClassMethod(stmt, method, ctx); });
                    ctx.popClass();
                    return null;
                };
                AbstractJsEmitterVisitor.prototype._visitClassConstructor = function (stmt, ctx) {
                    ctx.print(stmt, "function " + stmt.name + "(");
                    if (stmt.constructorMethod != null) {
                        this._visitParams(stmt.constructorMethod.params, ctx);
                    }
                    ctx.println(stmt, ") {");
                    ctx.incIndent();
                    if (stmt.constructorMethod != null) {
                        if (stmt.constructorMethod.body.length > 0) {
                            ctx.println(stmt, "var self = this;");
                            this.visitAllStatements(stmt.constructorMethod.body, ctx);
                        }
                    }
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                };
                AbstractJsEmitterVisitor.prototype._visitClassGetter = function (stmt, getter, ctx) {
                    ctx.println(stmt, "Object.defineProperty(" + stmt.name + ".prototype, '" + getter.name + "', { get: function() {");
                    ctx.incIndent();
                    if (getter.body.length > 0) {
                        ctx.println(stmt, "var self = this;");
                        this.visitAllStatements(getter.body, ctx);
                    }
                    ctx.decIndent();
                    ctx.println(stmt, "}});");
                };
                AbstractJsEmitterVisitor.prototype._visitClassMethod = function (stmt, method, ctx) {
                    ctx.print(stmt, stmt.name + ".prototype." + method.name + " = function(");
                    this._visitParams(method.params, ctx);
                    ctx.println(stmt, ") {");
                    ctx.incIndent();
                    if (method.body.length > 0) {
                        ctx.println(stmt, "var self = this;");
                        this.visitAllStatements(method.body, ctx);
                    }
                    ctx.decIndent();
                    ctx.println(stmt, "};");
                };
                AbstractJsEmitterVisitor.prototype.visitWrappedNodeExpr = function (ast, ctx) {
                    throw new Error('Cannot emit a WrappedNodeExpr in Javascript.');
                };
                AbstractJsEmitterVisitor.prototype.visitReadVarExpr = function (ast, ctx) {
                    if (ast.builtin === BuiltinVar.This) {
                        ctx.print(ast, 'self');
                    }
                    else if (ast.builtin === BuiltinVar.Super) {
                        throw new Error("'super' needs to be handled at a parent ast node, not at the variable level!");
                    }
                    else {
                        _super_1.prototype.visitReadVarExpr.call(this, ast, ctx);
                    }
                    return null;
                };
                AbstractJsEmitterVisitor.prototype.visitDeclareVarStmt = function (stmt, ctx) {
                    ctx.print(stmt, "var " + stmt.name);
                    if (stmt.value) {
                        ctx.print(stmt, ' = ');
                        stmt.value.visitExpression(this, ctx);
                    }
                    ctx.println(stmt, ";");
                    return null;
                };
                AbstractJsEmitterVisitor.prototype.visitCastExpr = function (ast, ctx) {
                    ast.value.visitExpression(this, ctx);
                    return null;
                };
                AbstractJsEmitterVisitor.prototype.visitInvokeFunctionExpr = function (expr, ctx) {
                    var fnExpr = expr.fn;
                    if (fnExpr instanceof ReadVarExpr && fnExpr.builtin === BuiltinVar.Super) {
                        ctx.currentClass.parent.visitExpression(this, ctx);
                        ctx.print(expr, ".call(this");
                        if (expr.args.length > 0) {
                            ctx.print(expr, ", ");
                            this.visitAllExpressions(expr.args, ctx, ',');
                        }
                        ctx.print(expr, ")");
                    }
                    else {
                        _super_1.prototype.visitInvokeFunctionExpr.call(this, expr, ctx);
                    }
                    return null;
                };
                AbstractJsEmitterVisitor.prototype.visitFunctionExpr = function (ast, ctx) {
                    ctx.print(ast, "function" + (ast.name ? ' ' + ast.name : '') + "(");
                    this._visitParams(ast.params, ctx);
                    ctx.println(ast, ") {");
                    ctx.incIndent();
                    this.visitAllStatements(ast.statements, ctx);
                    ctx.decIndent();
                    ctx.print(ast, "}");
                    return null;
                };
                AbstractJsEmitterVisitor.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
                    ctx.print(stmt, "function " + stmt.name + "(");
                    this._visitParams(stmt.params, ctx);
                    ctx.println(stmt, ") {");
                    ctx.incIndent();
                    this.visitAllStatements(stmt.statements, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                    return null;
                };
                AbstractJsEmitterVisitor.prototype.visitTryCatchStmt = function (stmt, ctx) {
                    ctx.println(stmt, "try {");
                    ctx.incIndent();
                    this.visitAllStatements(stmt.bodyStmts, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "} catch (" + CATCH_ERROR_VAR$1.name + ") {");
                    ctx.incIndent();
                    var catchStmts = [CATCH_STACK_VAR$1.set(CATCH_ERROR_VAR$1.prop('stack')).toDeclStmt(null, [
                            StmtModifier.Final
                        ])].concat(stmt.catchStmts);
                    this.visitAllStatements(catchStmts, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                    return null;
                };
                AbstractJsEmitterVisitor.prototype._visitParams = function (params, ctx) {
                    this.visitAllObjects(function (param) { return ctx.print(null, param.name); }, params, ctx, ',');
                };
                AbstractJsEmitterVisitor.prototype.getBuiltinMethodName = function (method) {
                    var name;
                    switch (method) {
                        case BuiltinMethod.ConcatArray:
                            name = 'concat';
                            break;
                        case BuiltinMethod.SubscribeObservable:
                            name = 'subscribe';
                            break;
                        case BuiltinMethod.Bind:
                            name = 'bind';
                            break;
                        default:
                            throw new Error("Unknown builtin method: " + method);
                    }
                    return name;
                };
                return AbstractJsEmitterVisitor;
            }(AbstractEmitterVisitor));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A helper class to manage the evaluation of JIT generated code.
             */
            var JitEvaluator = /** @class */ (function () {
                function JitEvaluator() {
                }
                /**
                 *
                 * @param sourceUrl The URL of the generated code.
                 * @param statements An array of Angular statement AST nodes to be evaluated.
                 * @param reflector A helper used when converting the statements to executable code.
                 * @param createSourceMaps If true then create a source-map for the generated code and include it
                 * inline as a source-map comment.
                 * @returns A map of all the variables in the generated code.
                 */
                JitEvaluator.prototype.evaluateStatements = function (sourceUrl, statements, reflector, createSourceMaps) {
                    var converter = new JitEmitterVisitor(reflector);
                    var ctx = EmitterVisitorContext.createRoot();
                    // Ensure generated code is in strict mode
                    if (statements.length > 0 && !isUseStrictStatement(statements[0])) {
                        statements = [
                            literal('use strict').toStmt()
                        ].concat(statements);
                    }
                    converter.visitAllStatements(statements, ctx);
                    converter.createReturnStmt(ctx);
                    return this.evaluateCode(sourceUrl, ctx, converter.getArgs(), createSourceMaps);
                };
                /**
                 * Evaluate a piece of JIT generated code.
                 * @param sourceUrl The URL of this generated code.
                 * @param ctx A context object that contains an AST of the code to be evaluated.
                 * @param vars A map containing the names and values of variables that the evaluated code might
                 * reference.
                 * @param createSourceMap If true then create a source-map for the generated code and include it
                 * inline as a source-map comment.
                 * @returns The result of evaluating the code.
                 */
                JitEvaluator.prototype.evaluateCode = function (sourceUrl, ctx, vars, createSourceMap) {
                    var fnBody = "\"use strict\";" + ctx.toSource() + "\n//# sourceURL=" + sourceUrl;
                    var fnArgNames = [];
                    var fnArgValues = [];
                    for (var argName in vars) {
                        fnArgValues.push(vars[argName]);
                        fnArgNames.push(argName);
                    }
                    if (createSourceMap) {
                        // using `new Function(...)` generates a header, 1 line of no arguments, 2 lines otherwise
                        // E.g. ```
                        // function anonymous(a,b,c
                        // /**/) { ... }```
                        // We don't want to hard code this fact, so we auto detect it via an empty function first.
                        var emptyFn = new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat('return null;'))))().toString();
                        var headerLines = emptyFn.slice(0, emptyFn.indexOf('return null;')).split('\n').length - 1;
                        fnBody += "\n" + ctx.toSourceMapGenerator(sourceUrl, headerLines).toJsComment();
                    }
                    var fn = new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat(fnBody))))();
                    return this.executeFunction(fn, fnArgValues);
                };
                /**
                 * Execute a JIT generated function by calling it.
                 *
                 * This method can be overridden in tests to capture the functions that are generated
                 * by this `JitEvaluator` class.
                 *
                 * @param fn A function to execute.
                 * @param args The arguments to pass to the function being executed.
                 * @returns The return value of the executed function.
                 */
                JitEvaluator.prototype.executeFunction = function (fn, args) { return fn.apply(void 0, args); };
                return JitEvaluator;
            }());
            /**
             * An Angular AST visitor that converts AST nodes into executable JavaScript code.
             */
            var JitEmitterVisitor = /** @class */ (function (_super_1) {
                __extends(JitEmitterVisitor, _super_1);
                function JitEmitterVisitor(reflector) {
                    var _this = _super_1.call(this) || this;
                    _this.reflector = reflector;
                    _this._evalArgNames = [];
                    _this._evalArgValues = [];
                    _this._evalExportedVars = [];
                    return _this;
                }
                JitEmitterVisitor.prototype.createReturnStmt = function (ctx) {
                    var stmt = new ReturnStatement(new LiteralMapExpr(this._evalExportedVars.map(function (resultVar) { return new LiteralMapEntry(resultVar, variable(resultVar), false); })));
                    stmt.visitStatement(this, ctx);
                };
                JitEmitterVisitor.prototype.getArgs = function () {
                    var result = {};
                    for (var i = 0; i < this._evalArgNames.length; i++) {
                        result[this._evalArgNames[i]] = this._evalArgValues[i];
                    }
                    return result;
                };
                JitEmitterVisitor.prototype.visitExternalExpr = function (ast, ctx) {
                    this._emitReferenceToExternal(ast, this.reflector.resolveExternalReference(ast.value), ctx);
                    return null;
                };
                JitEmitterVisitor.prototype.visitWrappedNodeExpr = function (ast, ctx) {
                    this._emitReferenceToExternal(ast, ast.node, ctx);
                    return null;
                };
                JitEmitterVisitor.prototype.visitDeclareVarStmt = function (stmt, ctx) {
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        this._evalExportedVars.push(stmt.name);
                    }
                    return _super_1.prototype.visitDeclareVarStmt.call(this, stmt, ctx);
                };
                JitEmitterVisitor.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        this._evalExportedVars.push(stmt.name);
                    }
                    return _super_1.prototype.visitDeclareFunctionStmt.call(this, stmt, ctx);
                };
                JitEmitterVisitor.prototype.visitDeclareClassStmt = function (stmt, ctx) {
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        this._evalExportedVars.push(stmt.name);
                    }
                    return _super_1.prototype.visitDeclareClassStmt.call(this, stmt, ctx);
                };
                JitEmitterVisitor.prototype._emitReferenceToExternal = function (ast, value, ctx) {
                    var id = this._evalArgValues.indexOf(value);
                    if (id === -1) {
                        id = this._evalArgValues.length;
                        this._evalArgValues.push(value);
                        var name = identifierName({ reference: value }) || 'val';
                        this._evalArgNames.push("jit_" + name + "_" + id);
                    }
                    ctx.print(ast, this._evalArgNames[id]);
                };
                return JitEmitterVisitor;
            }(AbstractJsEmitterVisitor));
            function isUseStrictStatement(statement) {
                return statement.isEquivalent(literal('use strict').toStmt());
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Implementation of `CompileReflector` which resolves references to @angular/core
             * symbols at runtime, according to a consumer-provided mapping.
             *
             * Only supports `resolveExternalReference`, all other methods throw.
             */
            var R3JitReflector = /** @class */ (function () {
                function R3JitReflector(context) {
                    this.context = context;
                }
                R3JitReflector.prototype.resolveExternalReference = function (ref) {
                    // This reflector only handles @angular/core imports.
                    if (ref.moduleName !== '@angular/core') {
                        throw new Error("Cannot resolve external reference to " + ref.moduleName + ", only references to @angular/core are supported.");
                    }
                    if (!this.context.hasOwnProperty(ref.name)) {
                        throw new Error("No value provided for @angular/core symbol '" + ref.name + "'.");
                    }
                    return this.context[ref.name];
                };
                R3JitReflector.prototype.parameters = function (typeOrFunc) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.annotations = function (typeOrFunc) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.shallowAnnotations = function (typeOrFunc) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.tryAnnotations = function (typeOrFunc) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.propMetadata = function (typeOrFunc) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.hasLifecycleHook = function (type, lcProperty) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.guards = function (typeOrFunc) { throw new Error('Not implemented.'); };
                R3JitReflector.prototype.componentModuleUrl = function (type, cmpMetadata) { throw new Error('Not implemented.'); };
                return R3JitReflector;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Construct an `R3NgModuleDef` for the given `R3NgModuleMetadata`.
             */
            function compileNgModule(meta) {
                var moduleType = meta.type, bootstrap = meta.bootstrap, declarations = meta.declarations, imports = meta.imports, exports = meta.exports, schemas = meta.schemas, containsForwardDecls = meta.containsForwardDecls, emitInline = meta.emitInline, id = meta.id;
                var additionalStatements = [];
                var definitionMap = {
                    type: moduleType
                };
                // Only generate the keys in the metadata if the arrays have values.
                if (bootstrap.length) {
                    definitionMap.bootstrap = refsToArray(bootstrap, containsForwardDecls);
                }
                // If requested to emit scope information inline, pass the declarations, imports and exports to
                // the `ɵɵdefineNgModule` call. The JIT compilation uses this.
                if (emitInline) {
                    if (declarations.length) {
                        definitionMap.declarations = refsToArray(declarations, containsForwardDecls);
                    }
                    if (imports.length) {
                        definitionMap.imports = refsToArray(imports, containsForwardDecls);
                    }
                    if (exports.length) {
                        definitionMap.exports = refsToArray(exports, containsForwardDecls);
                    }
                }
                // If not emitting inline, the scope information is not passed into `ɵɵdefineNgModule` as it would
                // prevent tree-shaking of the declarations, imports and exports references.
                else {
                    var setNgModuleScopeCall = generateSetNgModuleScopeCall(meta);
                    if (setNgModuleScopeCall !== null) {
                        additionalStatements.push(setNgModuleScopeCall);
                    }
                }
                if (schemas && schemas.length) {
                    definitionMap.schemas = literalArr(schemas.map(function (ref) { return ref.value; }));
                }
                if (id) {
                    definitionMap.id = id;
                }
                var expression = importExpr(Identifiers$1.defineNgModule).callFn([mapToMapExpression(definitionMap)]);
                var type = new ExpressionType(importExpr(Identifiers$1.NgModuleDefWithMeta, [
                    new ExpressionType(moduleType), tupleTypeOf(declarations), tupleTypeOf(imports),
                    tupleTypeOf(exports)
                ]));
                return { expression: expression, type: type, additionalStatements: additionalStatements };
            }
            /**
             * Generates a function call to `ɵɵsetNgModuleScope` with all necessary information so that the
             * transitive module scope can be computed during runtime in JIT mode. This call is marked pure
             * such that the references to declarations, imports and exports may be elided causing these
             * symbols to become tree-shakeable.
             */
            function generateSetNgModuleScopeCall(meta) {
                var moduleType = meta.type, declarations = meta.declarations, imports = meta.imports, exports = meta.exports, containsForwardDecls = meta.containsForwardDecls;
                var scopeMap = {};
                if (declarations.length) {
                    scopeMap.declarations = refsToArray(declarations, containsForwardDecls);
                }
                if (imports.length) {
                    scopeMap.imports = refsToArray(imports, containsForwardDecls);
                }
                if (exports.length) {
                    scopeMap.exports = refsToArray(exports, containsForwardDecls);
                }
                if (Object.keys(scopeMap).length === 0) {
                    return null;
                }
                var fnCall = new InvokeFunctionExpr(
                /* fn */ importExpr(Identifiers$1.setNgModuleScope), 
                /* args */ [moduleType, mapToMapExpression(scopeMap)], 
                /* type */ undefined, 
                /* sourceSpan */ undefined, 
                /* pure */ true);
                return fnCall.toStmt();
            }
            function compileInjector(meta) {
                var result = compileFactoryFunction({
                    name: meta.name,
                    type: meta.type,
                    deps: meta.deps,
                    injectFn: Identifiers$1.inject,
                });
                var definitionMap = {
                    factory: result.factory,
                };
                if (meta.providers !== null) {
                    definitionMap.providers = meta.providers;
                }
                if (meta.imports.length > 0) {
                    definitionMap.imports = literalArr(meta.imports);
                }
                var expression = importExpr(Identifiers$1.defineInjector).callFn([mapToMapExpression(definitionMap)]);
                var type = new ExpressionType(importExpr(Identifiers$1.InjectorDef, [new ExpressionType(meta.type)]));
                return { expression: expression, type: type, statements: result.statements };
            }
            // TODO(alxhub): integrate this with `compileNgModule`. Currently the two are separate operations.
            function compileNgModuleFromRender2(ctx, ngModule, injectableCompiler) {
                var className = identifierName(ngModule.type);
                var rawImports = ngModule.rawImports ? [ngModule.rawImports] : [];
                var rawExports = ngModule.rawExports ? [ngModule.rawExports] : [];
                var injectorDefArg = mapLiteral({
                    'factory': injectableCompiler.factoryFor({ type: ngModule.type, symbol: ngModule.type.reference }, ctx),
                    'providers': convertMetaToOutput(ngModule.rawProviders, ctx),
                    'imports': convertMetaToOutput(rawImports.concat(rawExports), ctx),
                });
                var injectorDef = importExpr(Identifiers$1.defineInjector).callFn([injectorDefArg]);
                ctx.statements.push(new ClassStmt(
                /* name */ className, 
                /* parent */ null, 
                /* fields */ [new ClassField(
                    /* name */ 'ngInjectorDef', 
                    /* type */ INFERRED_TYPE, 
                    /* modifiers */ [StmtModifier.Static], 
                    /* initializer */ injectorDef)], 
                /* getters */ [], 
                /* constructorMethod */ new ClassMethod(null, [], []), 
                /* methods */ []));
            }
            function accessExportScope(module) {
                var selectorScope = new ReadPropExpr(module, 'ngModuleDef');
                return new ReadPropExpr(selectorScope, 'exported');
            }
            function tupleTypeOf(exp) {
                var types = exp.map(function (ref) { return typeofExpr(ref.type); });
                return exp.length > 0 ? expressionType(literalArr(types)) : NONE_TYPE;
            }
            function refsToArray(refs, shouldForwardDeclare) {
                var values = literalArr(refs.map(function (ref) { return ref.value; }));
                return shouldForwardDeclare ? fn([], [new ReturnStatement(values)]) : values;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function compilePipeFromMetadata(metadata) {
                var definitionMapValues = [];
                // e.g. `name: 'myPipe'`
                definitionMapValues.push({ key: 'name', value: literal(metadata.pipeName), quoted: false });
                // e.g. `type: MyPipe`
                definitionMapValues.push({ key: 'type', value: metadata.type, quoted: false });
                var templateFactory = compileFactoryFunction({
                    name: metadata.name,
                    type: metadata.type,
                    deps: metadata.deps,
                    injectFn: Identifiers$1.directiveInject,
                }, true);
                definitionMapValues.push({ key: 'factory', value: templateFactory.factory, quoted: false });
                // e.g. `pure: true`
                definitionMapValues.push({ key: 'pure', value: literal(metadata.pure), quoted: false });
                var expression = importExpr(Identifiers$1.definePipe).callFn([literalMap(definitionMapValues)]);
                var type = new ExpressionType(importExpr(Identifiers$1.PipeDefWithMeta, [
                    typeWithParameters(metadata.type, metadata.typeArgumentCount),
                    new ExpressionType(new LiteralExpr(metadata.pipeName)),
                ]));
                return { expression: expression, type: type, statements: templateFactory.statements };
            }
            /**
             * Write a pipe definition to the output context.
             */
            function compilePipeFromRender2(outputCtx, pipe, reflector) {
                var definitionMapValues = [];
                var name = identifierName(pipe.type);
                if (!name) {
                    return error("Cannot resolve the name of " + pipe.type);
                }
                var metadata = {
                    name: name,
                    pipeName: pipe.name,
                    type: outputCtx.importExpr(pipe.type.reference),
                    typeArgumentCount: 0,
                    deps: dependenciesFromGlobalMetadata(pipe.type, outputCtx, reflector),
                    pure: pipe.pure,
                };
                var res = compilePipeFromMetadata(metadata);
                var definitionField = outputCtx.constantPool.propertyNameOf(3 /* Pipe */);
                outputCtx.statements.push(new ClassStmt(
                /* name */ name, 
                /* parent */ null, 
                /* fields */ [new ClassField(
                    /* name */ definitionField, 
                    /* type */ INFERRED_TYPE, 
                    /* modifiers */ [StmtModifier.Static], 
                    /* initializer */ res.expression)], 
                /* getters */ [], 
                /* constructorMethod */ new ClassMethod(null, [], []), 
                /* methods */ []));
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ParserError = /** @class */ (function () {
                function ParserError(message, input, errLocation, ctxLocation) {
                    this.input = input;
                    this.errLocation = errLocation;
                    this.ctxLocation = ctxLocation;
                    this.message = "Parser Error: " + message + " " + errLocation + " [" + input + "] in " + ctxLocation;
                }
                return ParserError;
            }());
            var ParseSpan = /** @class */ (function () {
                function ParseSpan(start, end) {
                    this.start = start;
                    this.end = end;
                }
                return ParseSpan;
            }());
            var AST = /** @class */ (function () {
                function AST(span) {
                    this.span = span;
                }
                AST.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return null;
                };
                AST.prototype.toString = function () { return 'AST'; };
                return AST;
            }());
            /**
             * Represents a quoted expression of the form:
             *
             * quote = prefix `:` uninterpretedExpression
             * prefix = identifier
             * uninterpretedExpression = arbitrary string
             *
             * A quoted expression is meant to be pre-processed by an AST transformer that
             * converts it into another AST that no longer contains quoted expressions.
             * It is meant to allow third-party developers to extend Angular template
             * expression language. The `uninterpretedExpression` part of the quote is
             * therefore not interpreted by the Angular's own expression parser.
             */
            var Quote = /** @class */ (function (_super_1) {
                __extends(Quote, _super_1);
                function Quote(span, prefix, uninterpretedExpression, location) {
                    var _this = _super_1.call(this, span) || this;
                    _this.prefix = prefix;
                    _this.uninterpretedExpression = uninterpretedExpression;
                    _this.location = location;
                    return _this;
                }
                Quote.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitQuote(this, context);
                };
                Quote.prototype.toString = function () { return 'Quote'; };
                return Quote;
            }(AST));
            var EmptyExpr = /** @class */ (function (_super_1) {
                __extends(EmptyExpr, _super_1);
                function EmptyExpr() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                EmptyExpr.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    // do nothing
                };
                return EmptyExpr;
            }(AST));
            var ImplicitReceiver = /** @class */ (function (_super_1) {
                __extends(ImplicitReceiver, _super_1);
                function ImplicitReceiver() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                ImplicitReceiver.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitImplicitReceiver(this, context);
                };
                return ImplicitReceiver;
            }(AST));
            /**
             * Multiple expressions separated by a semicolon.
             */
            var Chain = /** @class */ (function (_super_1) {
                __extends(Chain, _super_1);
                function Chain(span, expressions) {
                    var _this = _super_1.call(this, span) || this;
                    _this.expressions = expressions;
                    return _this;
                }
                Chain.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitChain(this, context);
                };
                return Chain;
            }(AST));
            var Conditional = /** @class */ (function (_super_1) {
                __extends(Conditional, _super_1);
                function Conditional(span, condition, trueExp, falseExp) {
                    var _this = _super_1.call(this, span) || this;
                    _this.condition = condition;
                    _this.trueExp = trueExp;
                    _this.falseExp = falseExp;
                    return _this;
                }
                Conditional.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitConditional(this, context);
                };
                return Conditional;
            }(AST));
            var PropertyRead = /** @class */ (function (_super_1) {
                __extends(PropertyRead, _super_1);
                function PropertyRead(span, receiver, name) {
                    var _this = _super_1.call(this, span) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    return _this;
                }
                PropertyRead.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitPropertyRead(this, context);
                };
                return PropertyRead;
            }(AST));
            var PropertyWrite = /** @class */ (function (_super_1) {
                __extends(PropertyWrite, _super_1);
                function PropertyWrite(span, receiver, name, value) {
                    var _this = _super_1.call(this, span) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    _this.value = value;
                    return _this;
                }
                PropertyWrite.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitPropertyWrite(this, context);
                };
                return PropertyWrite;
            }(AST));
            var SafePropertyRead = /** @class */ (function (_super_1) {
                __extends(SafePropertyRead, _super_1);
                function SafePropertyRead(span, receiver, name) {
                    var _this = _super_1.call(this, span) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    return _this;
                }
                SafePropertyRead.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitSafePropertyRead(this, context);
                };
                return SafePropertyRead;
            }(AST));
            var KeyedRead = /** @class */ (function (_super_1) {
                __extends(KeyedRead, _super_1);
                function KeyedRead(span, obj, key) {
                    var _this = _super_1.call(this, span) || this;
                    _this.obj = obj;
                    _this.key = key;
                    return _this;
                }
                KeyedRead.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitKeyedRead(this, context);
                };
                return KeyedRead;
            }(AST));
            var KeyedWrite = /** @class */ (function (_super_1) {
                __extends(KeyedWrite, _super_1);
                function KeyedWrite(span, obj, key, value) {
                    var _this = _super_1.call(this, span) || this;
                    _this.obj = obj;
                    _this.key = key;
                    _this.value = value;
                    return _this;
                }
                KeyedWrite.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitKeyedWrite(this, context);
                };
                return KeyedWrite;
            }(AST));
            var BindingPipe = /** @class */ (function (_super_1) {
                __extends(BindingPipe, _super_1);
                function BindingPipe(span, exp, name, args) {
                    var _this = _super_1.call(this, span) || this;
                    _this.exp = exp;
                    _this.name = name;
                    _this.args = args;
                    return _this;
                }
                BindingPipe.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitPipe(this, context);
                };
                return BindingPipe;
            }(AST));
            var LiteralPrimitive = /** @class */ (function (_super_1) {
                __extends(LiteralPrimitive, _super_1);
                function LiteralPrimitive(span, value) {
                    var _this = _super_1.call(this, span) || this;
                    _this.value = value;
                    return _this;
                }
                LiteralPrimitive.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitLiteralPrimitive(this, context);
                };
                return LiteralPrimitive;
            }(AST));
            var LiteralArray = /** @class */ (function (_super_1) {
                __extends(LiteralArray, _super_1);
                function LiteralArray(span, expressions) {
                    var _this = _super_1.call(this, span) || this;
                    _this.expressions = expressions;
                    return _this;
                }
                LiteralArray.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitLiteralArray(this, context);
                };
                return LiteralArray;
            }(AST));
            var LiteralMap = /** @class */ (function (_super_1) {
                __extends(LiteralMap, _super_1);
                function LiteralMap(span, keys, values) {
                    var _this = _super_1.call(this, span) || this;
                    _this.keys = keys;
                    _this.values = values;
                    return _this;
                }
                LiteralMap.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitLiteralMap(this, context);
                };
                return LiteralMap;
            }(AST));
            var Interpolation = /** @class */ (function (_super_1) {
                __extends(Interpolation, _super_1);
                function Interpolation(span, strings, expressions) {
                    var _this = _super_1.call(this, span) || this;
                    _this.strings = strings;
                    _this.expressions = expressions;
                    return _this;
                }
                Interpolation.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitInterpolation(this, context);
                };
                return Interpolation;
            }(AST));
            var Binary = /** @class */ (function (_super_1) {
                __extends(Binary, _super_1);
                function Binary(span, operation, left, right) {
                    var _this = _super_1.call(this, span) || this;
                    _this.operation = operation;
                    _this.left = left;
                    _this.right = right;
                    return _this;
                }
                Binary.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitBinary(this, context);
                };
                return Binary;
            }(AST));
            var PrefixNot = /** @class */ (function (_super_1) {
                __extends(PrefixNot, _super_1);
                function PrefixNot(span, expression) {
                    var _this = _super_1.call(this, span) || this;
                    _this.expression = expression;
                    return _this;
                }
                PrefixNot.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitPrefixNot(this, context);
                };
                return PrefixNot;
            }(AST));
            var NonNullAssert = /** @class */ (function (_super_1) {
                __extends(NonNullAssert, _super_1);
                function NonNullAssert(span, expression) {
                    var _this = _super_1.call(this, span) || this;
                    _this.expression = expression;
                    return _this;
                }
                NonNullAssert.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitNonNullAssert(this, context);
                };
                return NonNullAssert;
            }(AST));
            var MethodCall = /** @class */ (function (_super_1) {
                __extends(MethodCall, _super_1);
                function MethodCall(span, receiver, name, args) {
                    var _this = _super_1.call(this, span) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    _this.args = args;
                    return _this;
                }
                MethodCall.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitMethodCall(this, context);
                };
                return MethodCall;
            }(AST));
            var SafeMethodCall = /** @class */ (function (_super_1) {
                __extends(SafeMethodCall, _super_1);
                function SafeMethodCall(span, receiver, name, args) {
                    var _this = _super_1.call(this, span) || this;
                    _this.receiver = receiver;
                    _this.name = name;
                    _this.args = args;
                    return _this;
                }
                SafeMethodCall.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitSafeMethodCall(this, context);
                };
                return SafeMethodCall;
            }(AST));
            var FunctionCall = /** @class */ (function (_super_1) {
                __extends(FunctionCall, _super_1);
                function FunctionCall(span, target, args) {
                    var _this = _super_1.call(this, span) || this;
                    _this.target = target;
                    _this.args = args;
                    return _this;
                }
                FunctionCall.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    return visitor.visitFunctionCall(this, context);
                };
                return FunctionCall;
            }(AST));
            /**
             * Records the absolute position of a text span in a source file, where `start` and `end` are the
             * starting and ending byte offsets, respectively, of the text span in a source file.
             */
            var AbsoluteSourceSpan = /** @class */ (function () {
                function AbsoluteSourceSpan(start, end) {
                    this.start = start;
                    this.end = end;
                }
                return AbsoluteSourceSpan;
            }());
            var ASTWithSource = /** @class */ (function (_super_1) {
                __extends(ASTWithSource, _super_1);
                function ASTWithSource(ast, source, location, absoluteOffset, errors) {
                    var _this = _super_1.call(this, new ParseSpan(0, source == null ? 0 : source.length)) || this;
                    _this.ast = ast;
                    _this.source = source;
                    _this.location = location;
                    _this.errors = errors;
                    _this.sourceSpan = new AbsoluteSourceSpan(absoluteOffset, absoluteOffset + _this.span.end);
                    return _this;
                }
                ASTWithSource.prototype.visit = function (visitor, context) {
                    if (context === void 0) { context = null; }
                    if (visitor.visitASTWithSource) {
                        return visitor.visitASTWithSource(this, context);
                    }
                    return this.ast.visit(visitor, context);
                };
                ASTWithSource.prototype.toString = function () { return this.source + " in " + this.location; };
                return ASTWithSource;
            }(AST));
            var TemplateBinding = /** @class */ (function () {
                function TemplateBinding(span, key, keyIsVar, name, expression) {
                    this.span = span;
                    this.key = key;
                    this.keyIsVar = keyIsVar;
                    this.name = name;
                    this.expression = expression;
                }
                return TemplateBinding;
            }());
            var NullAstVisitor = /** @class */ (function () {
                function NullAstVisitor() {
                }
                NullAstVisitor.prototype.visitBinary = function (ast, context) { };
                NullAstVisitor.prototype.visitChain = function (ast, context) { };
                NullAstVisitor.prototype.visitConditional = function (ast, context) { };
                NullAstVisitor.prototype.visitFunctionCall = function (ast, context) { };
                NullAstVisitor.prototype.visitImplicitReceiver = function (ast, context) { };
                NullAstVisitor.prototype.visitInterpolation = function (ast, context) { };
                NullAstVisitor.prototype.visitKeyedRead = function (ast, context) { };
                NullAstVisitor.prototype.visitKeyedWrite = function (ast, context) { };
                NullAstVisitor.prototype.visitLiteralArray = function (ast, context) { };
                NullAstVisitor.prototype.visitLiteralMap = function (ast, context) { };
                NullAstVisitor.prototype.visitLiteralPrimitive = function (ast, context) { };
                NullAstVisitor.prototype.visitMethodCall = function (ast, context) { };
                NullAstVisitor.prototype.visitPipe = function (ast, context) { };
                NullAstVisitor.prototype.visitPrefixNot = function (ast, context) { };
                NullAstVisitor.prototype.visitNonNullAssert = function (ast, context) { };
                NullAstVisitor.prototype.visitPropertyRead = function (ast, context) { };
                NullAstVisitor.prototype.visitPropertyWrite = function (ast, context) { };
                NullAstVisitor.prototype.visitQuote = function (ast, context) { };
                NullAstVisitor.prototype.visitSafeMethodCall = function (ast, context) { };
                NullAstVisitor.prototype.visitSafePropertyRead = function (ast, context) { };
                return NullAstVisitor;
            }());
            var RecursiveAstVisitor$1 = /** @class */ (function () {
                function RecursiveAstVisitor$1() {
                }
                RecursiveAstVisitor$1.prototype.visitBinary = function (ast, context) {
                    ast.left.visit(this, context);
                    ast.right.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitChain = function (ast, context) { return this.visitAll(ast.expressions, context); };
                RecursiveAstVisitor$1.prototype.visitConditional = function (ast, context) {
                    ast.condition.visit(this, context);
                    ast.trueExp.visit(this, context);
                    ast.falseExp.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitPipe = function (ast, context) {
                    ast.exp.visit(this, context);
                    this.visitAll(ast.args, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitFunctionCall = function (ast, context) {
                    ast.target.visit(this, context);
                    this.visitAll(ast.args, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitImplicitReceiver = function (ast, context) { return null; };
                RecursiveAstVisitor$1.prototype.visitInterpolation = function (ast, context) {
                    return this.visitAll(ast.expressions, context);
                };
                RecursiveAstVisitor$1.prototype.visitKeyedRead = function (ast, context) {
                    ast.obj.visit(this, context);
                    ast.key.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitKeyedWrite = function (ast, context) {
                    ast.obj.visit(this, context);
                    ast.key.visit(this, context);
                    ast.value.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitLiteralArray = function (ast, context) {
                    return this.visitAll(ast.expressions, context);
                };
                RecursiveAstVisitor$1.prototype.visitLiteralMap = function (ast, context) { return this.visitAll(ast.values, context); };
                RecursiveAstVisitor$1.prototype.visitLiteralPrimitive = function (ast, context) { return null; };
                RecursiveAstVisitor$1.prototype.visitMethodCall = function (ast, context) {
                    ast.receiver.visit(this, context);
                    return this.visitAll(ast.args, context);
                };
                RecursiveAstVisitor$1.prototype.visitPrefixNot = function (ast, context) {
                    ast.expression.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitNonNullAssert = function (ast, context) {
                    ast.expression.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitPropertyRead = function (ast, context) {
                    ast.receiver.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitPropertyWrite = function (ast, context) {
                    ast.receiver.visit(this, context);
                    ast.value.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitSafePropertyRead = function (ast, context) {
                    ast.receiver.visit(this, context);
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitSafeMethodCall = function (ast, context) {
                    ast.receiver.visit(this, context);
                    return this.visitAll(ast.args, context);
                };
                RecursiveAstVisitor$1.prototype.visitAll = function (asts, context) {
                    var _this = this;
                    asts.forEach(function (ast) { return ast.visit(_this, context); });
                    return null;
                };
                RecursiveAstVisitor$1.prototype.visitQuote = function (ast, context) { return null; };
                return RecursiveAstVisitor$1;
            }());
            var AstTransformer$1 = /** @class */ (function () {
                function AstTransformer$1() {
                }
                AstTransformer$1.prototype.visitImplicitReceiver = function (ast, context) { return ast; };
                AstTransformer$1.prototype.visitInterpolation = function (ast, context) {
                    return new Interpolation(ast.span, ast.strings, this.visitAll(ast.expressions));
                };
                AstTransformer$1.prototype.visitLiteralPrimitive = function (ast, context) {
                    return new LiteralPrimitive(ast.span, ast.value);
                };
                AstTransformer$1.prototype.visitPropertyRead = function (ast, context) {
                    return new PropertyRead(ast.span, ast.receiver.visit(this), ast.name);
                };
                AstTransformer$1.prototype.visitPropertyWrite = function (ast, context) {
                    return new PropertyWrite(ast.span, ast.receiver.visit(this), ast.name, ast.value.visit(this));
                };
                AstTransformer$1.prototype.visitSafePropertyRead = function (ast, context) {
                    return new SafePropertyRead(ast.span, ast.receiver.visit(this), ast.name);
                };
                AstTransformer$1.prototype.visitMethodCall = function (ast, context) {
                    return new MethodCall(ast.span, ast.receiver.visit(this), ast.name, this.visitAll(ast.args));
                };
                AstTransformer$1.prototype.visitSafeMethodCall = function (ast, context) {
                    return new SafeMethodCall(ast.span, ast.receiver.visit(this), ast.name, this.visitAll(ast.args));
                };
                AstTransformer$1.prototype.visitFunctionCall = function (ast, context) {
                    return new FunctionCall(ast.span, ast.target.visit(this), this.visitAll(ast.args));
                };
                AstTransformer$1.prototype.visitLiteralArray = function (ast, context) {
                    return new LiteralArray(ast.span, this.visitAll(ast.expressions));
                };
                AstTransformer$1.prototype.visitLiteralMap = function (ast, context) {
                    return new LiteralMap(ast.span, ast.keys, this.visitAll(ast.values));
                };
                AstTransformer$1.prototype.visitBinary = function (ast, context) {
                    return new Binary(ast.span, ast.operation, ast.left.visit(this), ast.right.visit(this));
                };
                AstTransformer$1.prototype.visitPrefixNot = function (ast, context) {
                    return new PrefixNot(ast.span, ast.expression.visit(this));
                };
                AstTransformer$1.prototype.visitNonNullAssert = function (ast, context) {
                    return new NonNullAssert(ast.span, ast.expression.visit(this));
                };
                AstTransformer$1.prototype.visitConditional = function (ast, context) {
                    return new Conditional(ast.span, ast.condition.visit(this), ast.trueExp.visit(this), ast.falseExp.visit(this));
                };
                AstTransformer$1.prototype.visitPipe = function (ast, context) {
                    return new BindingPipe(ast.span, ast.exp.visit(this), ast.name, this.visitAll(ast.args));
                };
                AstTransformer$1.prototype.visitKeyedRead = function (ast, context) {
                    return new KeyedRead(ast.span, ast.obj.visit(this), ast.key.visit(this));
                };
                AstTransformer$1.prototype.visitKeyedWrite = function (ast, context) {
                    return new KeyedWrite(ast.span, ast.obj.visit(this), ast.key.visit(this), ast.value.visit(this));
                };
                AstTransformer$1.prototype.visitAll = function (asts) {
                    var res = new Array(asts.length);
                    for (var i = 0; i < asts.length; ++i) {
                        res[i] = asts[i].visit(this);
                    }
                    return res;
                };
                AstTransformer$1.prototype.visitChain = function (ast, context) {
                    return new Chain(ast.span, this.visitAll(ast.expressions));
                };
                AstTransformer$1.prototype.visitQuote = function (ast, context) {
                    return new Quote(ast.span, ast.prefix, ast.uninterpretedExpression, ast.location);
                };
                return AstTransformer$1;
            }());
            // A transformer that only creates new nodes if the transformer makes a change or
            // a change is made a child node.
            var AstMemoryEfficientTransformer = /** @class */ (function () {
                function AstMemoryEfficientTransformer() {
                }
                AstMemoryEfficientTransformer.prototype.visitImplicitReceiver = function (ast, context) { return ast; };
                AstMemoryEfficientTransformer.prototype.visitInterpolation = function (ast, context) {
                    var expressions = this.visitAll(ast.expressions);
                    if (expressions !== ast.expressions)
                        return new Interpolation(ast.span, ast.strings, expressions);
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitLiteralPrimitive = function (ast, context) { return ast; };
                AstMemoryEfficientTransformer.prototype.visitPropertyRead = function (ast, context) {
                    var receiver = ast.receiver.visit(this);
                    if (receiver !== ast.receiver) {
                        return new PropertyRead(ast.span, receiver, ast.name);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitPropertyWrite = function (ast, context) {
                    var receiver = ast.receiver.visit(this);
                    var value = ast.value.visit(this);
                    if (receiver !== ast.receiver || value !== ast.value) {
                        return new PropertyWrite(ast.span, receiver, ast.name, value);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitSafePropertyRead = function (ast, context) {
                    var receiver = ast.receiver.visit(this);
                    if (receiver !== ast.receiver) {
                        return new SafePropertyRead(ast.span, receiver, ast.name);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitMethodCall = function (ast, context) {
                    var receiver = ast.receiver.visit(this);
                    var args = this.visitAll(ast.args);
                    if (receiver !== ast.receiver || args !== ast.args) {
                        return new MethodCall(ast.span, receiver, ast.name, args);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitSafeMethodCall = function (ast, context) {
                    var receiver = ast.receiver.visit(this);
                    var args = this.visitAll(ast.args);
                    if (receiver !== ast.receiver || args !== ast.args) {
                        return new SafeMethodCall(ast.span, receiver, ast.name, args);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitFunctionCall = function (ast, context) {
                    var target = ast.target && ast.target.visit(this);
                    var args = this.visitAll(ast.args);
                    if (target !== ast.target || args !== ast.args) {
                        return new FunctionCall(ast.span, target, args);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitLiteralArray = function (ast, context) {
                    var expressions = this.visitAll(ast.expressions);
                    if (expressions !== ast.expressions) {
                        return new LiteralArray(ast.span, expressions);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitLiteralMap = function (ast, context) {
                    var values = this.visitAll(ast.values);
                    if (values !== ast.values) {
                        return new LiteralMap(ast.span, ast.keys, values);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitBinary = function (ast, context) {
                    var left = ast.left.visit(this);
                    var right = ast.right.visit(this);
                    if (left !== ast.left || right !== ast.right) {
                        return new Binary(ast.span, ast.operation, left, right);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitPrefixNot = function (ast, context) {
                    var expression = ast.expression.visit(this);
                    if (expression !== ast.expression) {
                        return new PrefixNot(ast.span, expression);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitNonNullAssert = function (ast, context) {
                    var expression = ast.expression.visit(this);
                    if (expression !== ast.expression) {
                        return new NonNullAssert(ast.span, expression);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitConditional = function (ast, context) {
                    var condition = ast.condition.visit(this);
                    var trueExp = ast.trueExp.visit(this);
                    var falseExp = ast.falseExp.visit(this);
                    if (condition !== ast.condition || trueExp !== ast.trueExp || falseExp !== ast.falseExp) {
                        return new Conditional(ast.span, condition, trueExp, falseExp);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitPipe = function (ast, context) {
                    var exp = ast.exp.visit(this);
                    var args = this.visitAll(ast.args);
                    if (exp !== ast.exp || args !== ast.args) {
                        return new BindingPipe(ast.span, exp, ast.name, args);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitKeyedRead = function (ast, context) {
                    var obj = ast.obj.visit(this);
                    var key = ast.key.visit(this);
                    if (obj !== ast.obj || key !== ast.key) {
                        return new KeyedRead(ast.span, obj, key);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitKeyedWrite = function (ast, context) {
                    var obj = ast.obj.visit(this);
                    var key = ast.key.visit(this);
                    var value = ast.value.visit(this);
                    if (obj !== ast.obj || key !== ast.key || value !== ast.value) {
                        return new KeyedWrite(ast.span, obj, key, value);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitAll = function (asts) {
                    var res = new Array(asts.length);
                    var modified = false;
                    for (var i = 0; i < asts.length; ++i) {
                        var original = asts[i];
                        var value = original.visit(this);
                        res[i] = value;
                        modified = modified || value !== original;
                    }
                    return modified ? res : asts;
                };
                AstMemoryEfficientTransformer.prototype.visitChain = function (ast, context) {
                    var expressions = this.visitAll(ast.expressions);
                    if (expressions !== ast.expressions) {
                        return new Chain(ast.span, expressions);
                    }
                    return ast;
                };
                AstMemoryEfficientTransformer.prototype.visitQuote = function (ast, context) { return ast; };
                return AstMemoryEfficientTransformer;
            }());
            function visitAstChildren(ast, visitor, context) {
                function visit(ast) {
                    visitor.visit && visitor.visit(ast, context) || ast.visit(visitor, context);
                }
                function visitAll(asts) { asts.forEach(visit); }
                ast.visit({
                    visitBinary: function (ast) {
                        visit(ast.left);
                        visit(ast.right);
                    },
                    visitChain: function (ast) { visitAll(ast.expressions); },
                    visitConditional: function (ast) {
                        visit(ast.condition);
                        visit(ast.trueExp);
                        visit(ast.falseExp);
                    },
                    visitFunctionCall: function (ast) {
                        if (ast.target) {
                            visit(ast.target);
                        }
                        visitAll(ast.args);
                    },
                    visitImplicitReceiver: function (ast) { },
                    visitInterpolation: function (ast) { visitAll(ast.expressions); },
                    visitKeyedRead: function (ast) {
                        visit(ast.obj);
                        visit(ast.key);
                    },
                    visitKeyedWrite: function (ast) {
                        visit(ast.obj);
                        visit(ast.key);
                        visit(ast.obj);
                    },
                    visitLiteralArray: function (ast) { visitAll(ast.expressions); },
                    visitLiteralMap: function (ast) { },
                    visitLiteralPrimitive: function (ast) { },
                    visitMethodCall: function (ast) {
                        visit(ast.receiver);
                        visitAll(ast.args);
                    },
                    visitPipe: function (ast) {
                        visit(ast.exp);
                        visitAll(ast.args);
                    },
                    visitPrefixNot: function (ast) { visit(ast.expression); },
                    visitNonNullAssert: function (ast) { visit(ast.expression); },
                    visitPropertyRead: function (ast) { visit(ast.receiver); },
                    visitPropertyWrite: function (ast) {
                        visit(ast.receiver);
                        visit(ast.value);
                    },
                    visitQuote: function (ast) { },
                    visitSafeMethodCall: function (ast) {
                        visit(ast.receiver);
                        visitAll(ast.args);
                    },
                    visitSafePropertyRead: function (ast) { visit(ast.receiver); },
                });
            }
            // Bindings
            var ParsedProperty = /** @class */ (function () {
                function ParsedProperty(name, expression, type, sourceSpan, valueSpan) {
                    this.name = name;
                    this.expression = expression;
                    this.type = type;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                    this.isLiteral = this.type === ParsedPropertyType.LITERAL_ATTR;
                    this.isAnimation = this.type === ParsedPropertyType.ANIMATION;
                }
                return ParsedProperty;
            }());
            var ParsedPropertyType;
            (function (ParsedPropertyType) {
                ParsedPropertyType[ParsedPropertyType["DEFAULT"] = 0] = "DEFAULT";
                ParsedPropertyType[ParsedPropertyType["LITERAL_ATTR"] = 1] = "LITERAL_ATTR";
                ParsedPropertyType[ParsedPropertyType["ANIMATION"] = 2] = "ANIMATION";
            })(ParsedPropertyType || (ParsedPropertyType = {}));
            var ParsedEvent = /** @class */ (function () {
                // Regular events have a target
                // Animation events have a phase
                function ParsedEvent(name, targetOrPhase, type, handler, sourceSpan, handlerSpan) {
                    this.name = name;
                    this.targetOrPhase = targetOrPhase;
                    this.type = type;
                    this.handler = handler;
                    this.sourceSpan = sourceSpan;
                    this.handlerSpan = handlerSpan;
                }
                return ParsedEvent;
            }());
            var ParsedVariable = /** @class */ (function () {
                function ParsedVariable(name, value, sourceSpan) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                return ParsedVariable;
            }());
            var BoundElementProperty = /** @class */ (function () {
                function BoundElementProperty(name, type, securityContext, value, unit, sourceSpan, valueSpan) {
                    this.name = name;
                    this.type = type;
                    this.securityContext = securityContext;
                    this.value = value;
                    this.unit = unit;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                }
                return BoundElementProperty;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var EventHandlerVars = /** @class */ (function () {
                function EventHandlerVars() {
                }
                return EventHandlerVars;
            }());
            EventHandlerVars.event = variable('$event');
            var ConvertActionBindingResult = /** @class */ (function () {
                function ConvertActionBindingResult(
                /**
                 * Render2 compatible statements,
                 */
                stmts, 
                /**
                 * Variable name used with render2 compatible statements.
                 */
                allowDefault) {
                    this.stmts = stmts;
                    this.allowDefault = allowDefault;
                    /**
                     * This is bit of a hack. It converts statements which render2 expects to statements which are
                     * expected by render3.
                     *
                     * Example: `<div click="doSomething($event)">` will generate:
                     *
                     * Render3:
                     * ```
                     * const pd_b:any = ((<any>ctx.doSomething($event)) !== false);
                     * return pd_b;
                     * ```
                     *
                     * but render2 expects:
                     * ```
                     * return ctx.doSomething($event);
                     * ```
                     */
                    // TODO(misko): remove this hack once we no longer support ViewEngine.
                    this.render3Stmts = stmts.map(function (statement) {
                        if (statement instanceof DeclareVarStmt && statement.name == allowDefault.name &&
                            statement.value instanceof BinaryOperatorExpr) {
                            var lhs = statement.value.lhs;
                            return new ReturnStatement(lhs.value);
                        }
                        return statement;
                    });
                }
                return ConvertActionBindingResult;
            }());
            /**
             * Converts the given expression AST into an executable output AST, assuming the expression is
             * used in an action binding (e.g. an event handler).
             */
            function convertActionBinding(localResolver, implicitReceiver, action, bindingId, interpolationFunction, baseSourceSpan) {
                if (!localResolver) {
                    localResolver = new DefaultLocalResolver();
                }
                var actionWithoutBuiltins = convertPropertyBindingBuiltins({
                    createLiteralArrayConverter: function (argCount) {
                        // Note: no caching for literal arrays in actions.
                        return function (args) { return literalArr(args); };
                    },
                    createLiteralMapConverter: function (keys) {
                        // Note: no caching for literal maps in actions.
                        return function (values) {
                            var entries = keys.map(function (k, i) { return ({
                                key: k.key,
                                value: values[i],
                                quoted: k.quoted,
                            }); });
                            return literalMap(entries);
                        };
                    },
                    createPipeConverter: function (name) {
                        throw new Error("Illegal State: Actions are not allowed to contain pipes. Pipe: " + name);
                    }
                }, action);
                var visitor = new _AstToIrVisitor(localResolver, implicitReceiver, bindingId, interpolationFunction, baseSourceSpan);
                var actionStmts = [];
                flattenStatements(actionWithoutBuiltins.visit(visitor, _Mode.Statement), actionStmts);
                prependTemporaryDecls(visitor.temporaryCount, bindingId, actionStmts);
                if (visitor.usesImplicitReceiver) {
                    localResolver.notifyImplicitReceiverUse();
                }
                var lastIndex = actionStmts.length - 1;
                var preventDefaultVar = null;
                if (lastIndex >= 0) {
                    var lastStatement = actionStmts[lastIndex];
                    var returnExpr = convertStmtIntoExpression(lastStatement);
                    if (returnExpr) {
                        // Note: We need to cast the result of the method call to dynamic,
                        // as it might be a void method!
                        preventDefaultVar = createPreventDefaultVar(bindingId);
                        actionStmts[lastIndex] =
                            preventDefaultVar.set(returnExpr.cast(DYNAMIC_TYPE).notIdentical(literal(false)))
                                .toDeclStmt(null, [StmtModifier.Final]);
                    }
                }
                return new ConvertActionBindingResult(actionStmts, preventDefaultVar);
            }
            function convertPropertyBindingBuiltins(converterFactory, ast) {
                return convertBuiltins(converterFactory, ast);
            }
            var ConvertPropertyBindingResult = /** @class */ (function () {
                function ConvertPropertyBindingResult(stmts, currValExpr) {
                    this.stmts = stmts;
                    this.currValExpr = currValExpr;
                }
                return ConvertPropertyBindingResult;
            }());
            var BindingForm;
            (function (BindingForm) {
                // The general form of binding expression, supports all expressions.
                BindingForm[BindingForm["General"] = 0] = "General";
                // Try to generate a simple binding (no temporaries or statements)
                // otherwise generate a general binding
                BindingForm[BindingForm["TrySimple"] = 1] = "TrySimple";
            })(BindingForm || (BindingForm = {}));
            /**
             * Converts the given expression AST into an executable output AST, assuming the expression
             * is used in property binding. The expression has to be preprocessed via
             * `convertPropertyBindingBuiltins`.
             */
            function convertPropertyBinding(localResolver, implicitReceiver, expressionWithoutBuiltins, bindingId, form, interpolationFunction) {
                if (!localResolver) {
                    localResolver = new DefaultLocalResolver();
                }
                var currValExpr = createCurrValueExpr(bindingId);
                var visitor = new _AstToIrVisitor(localResolver, implicitReceiver, bindingId, interpolationFunction);
                var outputExpr = expressionWithoutBuiltins.visit(visitor, _Mode.Expression);
                var stmts = getStatementsFromVisitor(visitor, bindingId);
                if (visitor.usesImplicitReceiver) {
                    localResolver.notifyImplicitReceiverUse();
                }
                if (visitor.temporaryCount === 0 && form == BindingForm.TrySimple) {
                    return new ConvertPropertyBindingResult([], outputExpr);
                }
                stmts.push(currValExpr.set(outputExpr).toDeclStmt(DYNAMIC_TYPE, [StmtModifier.Final]));
                return new ConvertPropertyBindingResult(stmts, currValExpr);
            }
            /**
             * Given some expression, such as a binding or interpolation expression, and a context expression to
             * look values up on, visit each facet of the given expression resolving values from the context
             * expression such that a list of arguments can be derived from the found values that can be used as
             * arguments to an external update instruction.
             *
             * @param localResolver The resolver to use to look up expressions by name appropriately
             * @param contextVariableExpression The expression representing the context variable used to create
             * the final argument expressions
             * @param expressionWithArgumentsToExtract The expression to visit to figure out what values need to
             * be resolved and what arguments list to build.
             * @param bindingId A name prefix used to create temporary variable names if they're needed for the
             * arguments generated
             * @returns An array of expressions that can be passed as arguments to instruction expressions like
             * `o.importExpr(R3.propertyInterpolate).callFn(result)`
             */
            function convertUpdateArguments(localResolver, contextVariableExpression, expressionWithArgumentsToExtract, bindingId) {
                var visitor = new _AstToIrVisitor(localResolver, contextVariableExpression, bindingId, undefined);
                var outputExpr = expressionWithArgumentsToExtract.visit(visitor, _Mode.Expression);
                if (visitor.usesImplicitReceiver) {
                    localResolver.notifyImplicitReceiverUse();
                }
                var stmts = getStatementsFromVisitor(visitor, bindingId);
                // Removing the first argument, because it was a length for ViewEngine, not Ivy.
                var args = outputExpr.args.slice(1);
                if (expressionWithArgumentsToExtract instanceof Interpolation) {
                    // If we're dealing with an interpolation of 1 value with an empty prefix and suffix, reduce the
                    // args returned to just the value, because we're going to pass it to a special instruction.
                    var strings = expressionWithArgumentsToExtract.strings;
                    if (args.length === 3 && strings[0] === '' && strings[1] === '') {
                        // Single argument interpolate instructions.
                        args = [args[1]];
                    }
                    else if (args.length >= 19) {
                        // 19 or more arguments must be passed to the `interpolateV`-style instructions, which accept
                        // an array of arguments
                        args = [literalArr(args)];
                    }
                }
                return { stmts: stmts, args: args };
            }
            function getStatementsFromVisitor(visitor, bindingId) {
                var stmts = [];
                for (var i = 0; i < visitor.temporaryCount; i++) {
                    stmts.push(temporaryDeclaration(bindingId, i));
                }
                return stmts;
            }
            function convertBuiltins(converterFactory, ast) {
                var visitor = new _BuiltinAstConverter(converterFactory);
                return ast.visit(visitor);
            }
            function temporaryName(bindingId, temporaryNumber) {
                return "tmp_" + bindingId + "_" + temporaryNumber;
            }
            function temporaryDeclaration(bindingId, temporaryNumber) {
                return new DeclareVarStmt(temporaryName(bindingId, temporaryNumber), NULL_EXPR);
            }
            function prependTemporaryDecls(temporaryCount, bindingId, statements) {
                for (var i = temporaryCount - 1; i >= 0; i--) {
                    statements.unshift(temporaryDeclaration(bindingId, i));
                }
            }
            var _Mode;
            (function (_Mode) {
                _Mode[_Mode["Statement"] = 0] = "Statement";
                _Mode[_Mode["Expression"] = 1] = "Expression";
            })(_Mode || (_Mode = {}));
            function ensureStatementMode(mode, ast) {
                if (mode !== _Mode.Statement) {
                    throw new Error("Expected a statement, but saw " + ast);
                }
            }
            function ensureExpressionMode(mode, ast) {
                if (mode !== _Mode.Expression) {
                    throw new Error("Expected an expression, but saw " + ast);
                }
            }
            function convertToStatementIfNeeded(mode, expr) {
                if (mode === _Mode.Statement) {
                    return expr.toStmt();
                }
                else {
                    return expr;
                }
            }
            var _BuiltinAstConverter = /** @class */ (function (_super_1) {
                __extends(_BuiltinAstConverter, _super_1);
                function _BuiltinAstConverter(_converterFactory) {
                    var _this = _super_1.call(this) || this;
                    _this._converterFactory = _converterFactory;
                    return _this;
                }
                _BuiltinAstConverter.prototype.visitPipe = function (ast, context) {
                    var _this = this;
                    var args = [ast.exp].concat(ast.args).map(function (ast) { return ast.visit(_this, context); });
                    return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createPipeConverter(ast.name, args.length));
                };
                _BuiltinAstConverter.prototype.visitLiteralArray = function (ast, context) {
                    var _this = this;
                    var args = ast.expressions.map(function (ast) { return ast.visit(_this, context); });
                    return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createLiteralArrayConverter(ast.expressions.length));
                };
                _BuiltinAstConverter.prototype.visitLiteralMap = function (ast, context) {
                    var _this = this;
                    var args = ast.values.map(function (ast) { return ast.visit(_this, context); });
                    return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createLiteralMapConverter(ast.keys));
                };
                return _BuiltinAstConverter;
            }(AstTransformer$1));
            var _AstToIrVisitor = /** @class */ (function () {
                function _AstToIrVisitor(_localResolver, _implicitReceiver, bindingId, interpolationFunction, baseSourceSpan) {
                    this._localResolver = _localResolver;
                    this._implicitReceiver = _implicitReceiver;
                    this.bindingId = bindingId;
                    this.interpolationFunction = interpolationFunction;
                    this.baseSourceSpan = baseSourceSpan;
                    this._nodeMap = new Map();
                    this._resultMap = new Map();
                    this._currentTemporary = 0;
                    this.temporaryCount = 0;
                    this.usesImplicitReceiver = false;
                }
                _AstToIrVisitor.prototype.visitBinary = function (ast, mode) {
                    var op;
                    switch (ast.operation) {
                        case '+':
                            op = BinaryOperator.Plus;
                            break;
                        case '-':
                            op = BinaryOperator.Minus;
                            break;
                        case '*':
                            op = BinaryOperator.Multiply;
                            break;
                        case '/':
                            op = BinaryOperator.Divide;
                            break;
                        case '%':
                            op = BinaryOperator.Modulo;
                            break;
                        case '&&':
                            op = BinaryOperator.And;
                            break;
                        case '||':
                            op = BinaryOperator.Or;
                            break;
                        case '==':
                            op = BinaryOperator.Equals;
                            break;
                        case '!=':
                            op = BinaryOperator.NotEquals;
                            break;
                        case '===':
                            op = BinaryOperator.Identical;
                            break;
                        case '!==':
                            op = BinaryOperator.NotIdentical;
                            break;
                        case '<':
                            op = BinaryOperator.Lower;
                            break;
                        case '>':
                            op = BinaryOperator.Bigger;
                            break;
                        case '<=':
                            op = BinaryOperator.LowerEquals;
                            break;
                        case '>=':
                            op = BinaryOperator.BiggerEquals;
                            break;
                        default:
                            throw new Error("Unsupported operation " + ast.operation);
                    }
                    return convertToStatementIfNeeded(mode, new BinaryOperatorExpr(op, this._visit(ast.left, _Mode.Expression), this._visit(ast.right, _Mode.Expression), undefined, this.convertSourceSpan(ast.span)));
                };
                _AstToIrVisitor.prototype.visitChain = function (ast, mode) {
                    ensureStatementMode(mode, ast);
                    return this.visitAll(ast.expressions, mode);
                };
                _AstToIrVisitor.prototype.visitConditional = function (ast, mode) {
                    var value = this._visit(ast.condition, _Mode.Expression);
                    return convertToStatementIfNeeded(mode, value.conditional(this._visit(ast.trueExp, _Mode.Expression), this._visit(ast.falseExp, _Mode.Expression), this.convertSourceSpan(ast.span)));
                };
                _AstToIrVisitor.prototype.visitPipe = function (ast, mode) {
                    throw new Error("Illegal state: Pipes should have been converted into functions. Pipe: " + ast.name);
                };
                _AstToIrVisitor.prototype.visitFunctionCall = function (ast, mode) {
                    var convertedArgs = this.visitAll(ast.args, _Mode.Expression);
                    var fnResult;
                    if (ast instanceof BuiltinFunctionCall) {
                        fnResult = ast.converter(convertedArgs);
                    }
                    else {
                        fnResult = this._visit(ast.target, _Mode.Expression)
                            .callFn(convertedArgs, this.convertSourceSpan(ast.span));
                    }
                    return convertToStatementIfNeeded(mode, fnResult);
                };
                _AstToIrVisitor.prototype.visitImplicitReceiver = function (ast, mode) {
                    ensureExpressionMode(mode, ast);
                    this.usesImplicitReceiver = true;
                    return this._implicitReceiver;
                };
                _AstToIrVisitor.prototype.visitInterpolation = function (ast, mode) {
                    ensureExpressionMode(mode, ast);
                    var args = [literal(ast.expressions.length)];
                    for (var i = 0; i < ast.strings.length - 1; i++) {
                        args.push(literal(ast.strings[i]));
                        args.push(this._visit(ast.expressions[i], _Mode.Expression));
                    }
                    args.push(literal(ast.strings[ast.strings.length - 1]));
                    if (this.interpolationFunction) {
                        return this.interpolationFunction(args);
                    }
                    return ast.expressions.length <= 9 ?
                        importExpr(Identifiers.inlineInterpolate).callFn(args) :
                        importExpr(Identifiers.interpolate).callFn([
                            args[0], literalArr(args.slice(1), undefined, this.convertSourceSpan(ast.span))
                        ]);
                };
                _AstToIrVisitor.prototype.visitKeyedRead = function (ast, mode) {
                    var leftMostSafe = this.leftMostSafeNode(ast);
                    if (leftMostSafe) {
                        return this.convertSafeAccess(ast, leftMostSafe, mode);
                    }
                    else {
                        return convertToStatementIfNeeded(mode, this._visit(ast.obj, _Mode.Expression).key(this._visit(ast.key, _Mode.Expression)));
                    }
                };
                _AstToIrVisitor.prototype.visitKeyedWrite = function (ast, mode) {
                    var obj = this._visit(ast.obj, _Mode.Expression);
                    var key = this._visit(ast.key, _Mode.Expression);
                    var value = this._visit(ast.value, _Mode.Expression);
                    return convertToStatementIfNeeded(mode, obj.key(key).set(value));
                };
                _AstToIrVisitor.prototype.visitLiteralArray = function (ast, mode) {
                    throw new Error("Illegal State: literal arrays should have been converted into functions");
                };
                _AstToIrVisitor.prototype.visitLiteralMap = function (ast, mode) {
                    throw new Error("Illegal State: literal maps should have been converted into functions");
                };
                _AstToIrVisitor.prototype.visitLiteralPrimitive = function (ast, mode) {
                    // For literal values of null, undefined, true, or false allow type interference
                    // to infer the type.
                    var type = ast.value === null || ast.value === undefined || ast.value === true || ast.value === true ?
                        INFERRED_TYPE :
                        undefined;
                    return convertToStatementIfNeeded(mode, literal(ast.value, type, this.convertSourceSpan(ast.span)));
                };
                _AstToIrVisitor.prototype._getLocal = function (name) { return this._localResolver.getLocal(name); };
                _AstToIrVisitor.prototype.visitMethodCall = function (ast, mode) {
                    if (ast.receiver instanceof ImplicitReceiver && ast.name == '$any') {
                        var args = this.visitAll(ast.args, _Mode.Expression);
                        if (args.length != 1) {
                            throw new Error("Invalid call to $any, expected 1 argument but received " + (args.length || 'none'));
                        }
                        return args[0].cast(DYNAMIC_TYPE, this.convertSourceSpan(ast.span));
                    }
                    var leftMostSafe = this.leftMostSafeNode(ast);
                    if (leftMostSafe) {
                        return this.convertSafeAccess(ast, leftMostSafe, mode);
                    }
                    else {
                        var args = this.visitAll(ast.args, _Mode.Expression);
                        var prevUsesImplicitReceiver = this.usesImplicitReceiver;
                        var result = null;
                        var receiver = this._visit(ast.receiver, _Mode.Expression);
                        if (receiver === this._implicitReceiver) {
                            var varExpr = this._getLocal(ast.name);
                            if (varExpr) {
                                // Restore the previous "usesImplicitReceiver" state since the implicit
                                // receiver has been replaced with a resolved local expression.
                                this.usesImplicitReceiver = prevUsesImplicitReceiver;
                                result = varExpr.callFn(args);
                            }
                        }
                        if (result == null) {
                            result = receiver.callMethod(ast.name, args, this.convertSourceSpan(ast.span));
                        }
                        return convertToStatementIfNeeded(mode, result);
                    }
                };
                _AstToIrVisitor.prototype.visitPrefixNot = function (ast, mode) {
                    return convertToStatementIfNeeded(mode, not(this._visit(ast.expression, _Mode.Expression)));
                };
                _AstToIrVisitor.prototype.visitNonNullAssert = function (ast, mode) {
                    return convertToStatementIfNeeded(mode, assertNotNull(this._visit(ast.expression, _Mode.Expression)));
                };
                _AstToIrVisitor.prototype.visitPropertyRead = function (ast, mode) {
                    var leftMostSafe = this.leftMostSafeNode(ast);
                    if (leftMostSafe) {
                        return this.convertSafeAccess(ast, leftMostSafe, mode);
                    }
                    else {
                        var result = null;
                        var prevUsesImplicitReceiver = this.usesImplicitReceiver;
                        var receiver = this._visit(ast.receiver, _Mode.Expression);
                        if (receiver === this._implicitReceiver) {
                            result = this._getLocal(ast.name);
                            if (result) {
                                // Restore the previous "usesImplicitReceiver" state since the implicit
                                // receiver has been replaced with a resolved local expression.
                                this.usesImplicitReceiver = prevUsesImplicitReceiver;
                            }
                        }
                        if (result == null) {
                            result = receiver.prop(ast.name);
                        }
                        return convertToStatementIfNeeded(mode, result);
                    }
                };
                _AstToIrVisitor.prototype.visitPropertyWrite = function (ast, mode) {
                    var receiver = this._visit(ast.receiver, _Mode.Expression);
                    var prevUsesImplicitReceiver = this.usesImplicitReceiver;
                    var varExpr = null;
                    if (receiver === this._implicitReceiver) {
                        var localExpr = this._getLocal(ast.name);
                        if (localExpr) {
                            if (localExpr instanceof ReadPropExpr) {
                                // If the local variable is a property read expression, it's a reference
                                // to a 'context.property' value and will be used as the target of the
                                // write expression.
                                varExpr = localExpr;
                                // Restore the previous "usesImplicitReceiver" state since the implicit
                                // receiver has been replaced with a resolved local expression.
                                this.usesImplicitReceiver = prevUsesImplicitReceiver;
                            }
                            else {
                                // Otherwise it's an error.
                                throw new Error('Cannot assign to a reference or variable!');
                            }
                        }
                    }
                    // If no local expression could be produced, use the original receiver's
                    // property as the target.
                    if (varExpr === null) {
                        varExpr = receiver.prop(ast.name);
                    }
                    return convertToStatementIfNeeded(mode, varExpr.set(this._visit(ast.value, _Mode.Expression)));
                };
                _AstToIrVisitor.prototype.visitSafePropertyRead = function (ast, mode) {
                    return this.convertSafeAccess(ast, this.leftMostSafeNode(ast), mode);
                };
                _AstToIrVisitor.prototype.visitSafeMethodCall = function (ast, mode) {
                    return this.convertSafeAccess(ast, this.leftMostSafeNode(ast), mode);
                };
                _AstToIrVisitor.prototype.visitAll = function (asts, mode) {
                    var _this = this;
                    return asts.map(function (ast) { return _this._visit(ast, mode); });
                };
                _AstToIrVisitor.prototype.visitQuote = function (ast, mode) {
                    throw new Error("Quotes are not supported for evaluation!\n        Statement: " + ast.uninterpretedExpression + " located at " + ast.location);
                };
                _AstToIrVisitor.prototype._visit = function (ast, mode) {
                    var result = this._resultMap.get(ast);
                    if (result)
                        return result;
                    return (this._nodeMap.get(ast) || ast).visit(this, mode);
                };
                _AstToIrVisitor.prototype.convertSafeAccess = function (ast, leftMostSafe, mode) {
                    // If the expression contains a safe access node on the left it needs to be converted to
                    // an expression that guards the access to the member by checking the receiver for blank. As
                    // execution proceeds from left to right, the left most part of the expression must be guarded
                    // first but, because member access is left associative, the right side of the expression is at
                    // the top of the AST. The desired result requires lifting a copy of the the left part of the
                    // expression up to test it for blank before generating the unguarded version.
                    // Consider, for example the following expression: a?.b.c?.d.e
                    // This results in the ast:
                    //         .
                    //        / \
                    //       ?.   e
                    //      /  \
                    //     .    d
                    //    / \
                    //   ?.  c
                    //  /  \
                    // a    b
                    // The following tree should be generated:
                    //
                    //        /---- ? ----\
                    //       /      |      \
                    //     a   /--- ? ---\  null
                    //        /     |     \
                    //       .      .     null
                    //      / \    / \
                    //     .  c   .   e
                    //    / \    / \
                    //   a   b  .   d
                    //         / \
                    //        .   c
                    //       / \
                    //      a   b
                    //
                    // Notice that the first guard condition is the left hand of the left most safe access node
                    // which comes in as leftMostSafe to this routine.
                    var guardedExpression = this._visit(leftMostSafe.receiver, _Mode.Expression);
                    var temporary = undefined;
                    if (this.needsTemporary(leftMostSafe.receiver)) {
                        // If the expression has method calls or pipes then we need to save the result into a
                        // temporary variable to avoid calling stateful or impure code more than once.
                        temporary = this.allocateTemporary();
                        // Preserve the result in the temporary variable
                        guardedExpression = temporary.set(guardedExpression);
                        // Ensure all further references to the guarded expression refer to the temporary instead.
                        this._resultMap.set(leftMostSafe.receiver, temporary);
                    }
                    var condition = guardedExpression.isBlank();
                    // Convert the ast to an unguarded access to the receiver's member. The map will substitute
                    // leftMostNode with its unguarded version in the call to `this.visit()`.
                    if (leftMostSafe instanceof SafeMethodCall) {
                        this._nodeMap.set(leftMostSafe, new MethodCall(leftMostSafe.span, leftMostSafe.receiver, leftMostSafe.name, leftMostSafe.args));
                    }
                    else {
                        this._nodeMap.set(leftMostSafe, new PropertyRead(leftMostSafe.span, leftMostSafe.receiver, leftMostSafe.name));
                    }
                    // Recursively convert the node now without the guarded member access.
                    var access = this._visit(ast, _Mode.Expression);
                    // Remove the mapping. This is not strictly required as the converter only traverses each node
                    // once but is safer if the conversion is changed to traverse the nodes more than once.
                    this._nodeMap.delete(leftMostSafe);
                    // If we allocated a temporary, release it.
                    if (temporary) {
                        this.releaseTemporary(temporary);
                    }
                    // Produce the conditional
                    return convertToStatementIfNeeded(mode, condition.conditional(literal(null), access));
                };
                // Given a expression of the form a?.b.c?.d.e the the left most safe node is
                // the (a?.b). The . and ?. are left associative thus can be rewritten as:
                // ((((a?.c).b).c)?.d).e. This returns the most deeply nested safe read or
                // safe method call as this needs be transform initially to:
                //   a == null ? null : a.c.b.c?.d.e
                // then to:
                //   a == null ? null : a.b.c == null ? null : a.b.c.d.e
                _AstToIrVisitor.prototype.leftMostSafeNode = function (ast) {
                    var _this = this;
                    var visit = function (visitor, ast) {
                        return (_this._nodeMap.get(ast) || ast).visit(visitor);
                    };
                    return ast.visit({
                        visitBinary: function (ast) { return null; },
                        visitChain: function (ast) { return null; },
                        visitConditional: function (ast) { return null; },
                        visitFunctionCall: function (ast) { return null; },
                        visitImplicitReceiver: function (ast) { return null; },
                        visitInterpolation: function (ast) { return null; },
                        visitKeyedRead: function (ast) { return visit(this, ast.obj); },
                        visitKeyedWrite: function (ast) { return null; },
                        visitLiteralArray: function (ast) { return null; },
                        visitLiteralMap: function (ast) { return null; },
                        visitLiteralPrimitive: function (ast) { return null; },
                        visitMethodCall: function (ast) { return visit(this, ast.receiver); },
                        visitPipe: function (ast) { return null; },
                        visitPrefixNot: function (ast) { return null; },
                        visitNonNullAssert: function (ast) { return null; },
                        visitPropertyRead: function (ast) { return visit(this, ast.receiver); },
                        visitPropertyWrite: function (ast) { return null; },
                        visitQuote: function (ast) { return null; },
                        visitSafeMethodCall: function (ast) { return visit(this, ast.receiver) || ast; },
                        visitSafePropertyRead: function (ast) {
                            return visit(this, ast.receiver) || ast;
                        }
                    });
                };
                // Returns true of the AST includes a method or a pipe indicating that, if the
                // expression is used as the target of a safe property or method access then
                // the expression should be stored into a temporary variable.
                _AstToIrVisitor.prototype.needsTemporary = function (ast) {
                    var _this = this;
                    var visit = function (visitor, ast) {
                        return ast && (_this._nodeMap.get(ast) || ast).visit(visitor);
                    };
                    var visitSome = function (visitor, ast) {
                        return ast.some(function (ast) { return visit(visitor, ast); });
                    };
                    return ast.visit({
                        visitBinary: function (ast) { return visit(this, ast.left) || visit(this, ast.right); },
                        visitChain: function (ast) { return false; },
                        visitConditional: function (ast) {
                            return visit(this, ast.condition) || visit(this, ast.trueExp) ||
                                visit(this, ast.falseExp);
                        },
                        visitFunctionCall: function (ast) { return true; },
                        visitImplicitReceiver: function (ast) { return false; },
                        visitInterpolation: function (ast) { return visitSome(this, ast.expressions); },
                        visitKeyedRead: function (ast) { return false; },
                        visitKeyedWrite: function (ast) { return false; },
                        visitLiteralArray: function (ast) { return true; },
                        visitLiteralMap: function (ast) { return true; },
                        visitLiteralPrimitive: function (ast) { return false; },
                        visitMethodCall: function (ast) { return true; },
                        visitPipe: function (ast) { return true; },
                        visitPrefixNot: function (ast) { return visit(this, ast.expression); },
                        visitNonNullAssert: function (ast) { return visit(this, ast.expression); },
                        visitPropertyRead: function (ast) { return false; },
                        visitPropertyWrite: function (ast) { return false; },
                        visitQuote: function (ast) { return false; },
                        visitSafeMethodCall: function (ast) { return true; },
                        visitSafePropertyRead: function (ast) { return false; }
                    });
                };
                _AstToIrVisitor.prototype.allocateTemporary = function () {
                    var tempNumber = this._currentTemporary++;
                    this.temporaryCount = Math.max(this._currentTemporary, this.temporaryCount);
                    return new ReadVarExpr(temporaryName(this.bindingId, tempNumber));
                };
                _AstToIrVisitor.prototype.releaseTemporary = function (temporary) {
                    this._currentTemporary--;
                    if (temporary.name != temporaryName(this.bindingId, this._currentTemporary)) {
                        throw new Error("Temporary " + temporary.name + " released out of order");
                    }
                };
                /**
                 * Creates an absolute `ParseSourceSpan` from the relative `ParseSpan`.
                 *
                 * `ParseSpan` objects are relative to the start of the expression.
                 * This method converts these to full `ParseSourceSpan` objects that
                 * show where the span is within the overall source file.
                 *
                 * @param span the relative span to convert.
                 * @returns a `ParseSourceSpan` for the the given span or null if no
                 * `baseSourceSpan` was provided to this class.
                 */
                _AstToIrVisitor.prototype.convertSourceSpan = function (span) {
                    if (this.baseSourceSpan) {
                        var start = this.baseSourceSpan.start.moveBy(span.start);
                        var end = this.baseSourceSpan.start.moveBy(span.end);
                        return new ParseSourceSpan(start, end);
                    }
                    else {
                        return null;
                    }
                };
                return _AstToIrVisitor;
            }());
            function flattenStatements(arg, output) {
                if (Array.isArray(arg)) {
                    arg.forEach(function (entry) { return flattenStatements(entry, output); });
                }
                else {
                    output.push(arg);
                }
            }
            var DefaultLocalResolver = /** @class */ (function () {
                function DefaultLocalResolver() {
                }
                DefaultLocalResolver.prototype.notifyImplicitReceiverUse = function () { };
                DefaultLocalResolver.prototype.getLocal = function (name) {
                    if (name === EventHandlerVars.event.name) {
                        return EventHandlerVars.event;
                    }
                    return null;
                };
                return DefaultLocalResolver;
            }());
            function createCurrValueExpr(bindingId) {
                return variable("currVal_" + bindingId); // fix syntax highlighting: `
            }
            function createPreventDefaultVar(bindingId) {
                return variable("pd_" + bindingId);
            }
            function convertStmtIntoExpression(stmt) {
                if (stmt instanceof ExpressionStatement) {
                    return stmt.expr;
                }
                else if (stmt instanceof ReturnStatement) {
                    return stmt.value;
                }
                return null;
            }
            var BuiltinFunctionCall = /** @class */ (function (_super_1) {
                __extends(BuiltinFunctionCall, _super_1);
                function BuiltinFunctionCall(span, args, converter) {
                    var _this = _super_1.call(this, span, null, args) || this;
                    _this.args = args;
                    _this.converter = converter;
                    return _this;
                }
                return BuiltinFunctionCall;
            }(FunctionCall));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * This file is a port of shadowCSS from webcomponents.js to TypeScript.
             *
             * Please make sure to keep to edits in sync with the source file.
             *
             * Source:
             * https://github.com/webcomponents/webcomponentsjs/blob/4efecd7e0e/src/ShadowCSS/ShadowCSS.js
             *
             * The original file level comment is reproduced below
             */
            /*
              This is a limited shim for ShadowDOM css styling.
              https://dvcs.w3.org/hg/webcomponents/raw-file/tip/spec/shadow/index.html#styles
            
              The intention here is to support only the styling features which can be
              relatively simply implemented. The goal is to allow users to avoid the
              most obvious pitfalls and do so without compromising performance significantly.
              For ShadowDOM styling that's not covered here, a set of best practices
              can be provided that should allow users to accomplish more complex styling.
            
              The following is a list of specific ShadowDOM styling features and a brief
              discussion of the approach used to shim.
            
              Shimmed features:
            
              * :host, :host-context: ShadowDOM allows styling of the shadowRoot's host
              element using the :host rule. To shim this feature, the :host styles are
              reformatted and prefixed with a given scope name and promoted to a
              document level stylesheet.
              For example, given a scope name of .foo, a rule like this:
            
                :host {
                    background: red;
                  }
                }
            
              becomes:
            
                .foo {
                  background: red;
                }
            
              * encapsulation: Styles defined within ShadowDOM, apply only to
              dom inside the ShadowDOM. Polymer uses one of two techniques to implement
              this feature.
            
              By default, rules are prefixed with the host element tag name
              as a descendant selector. This ensures styling does not leak out of the 'top'
              of the element's ShadowDOM. For example,
            
              div {
                  font-weight: bold;
                }
            
              becomes:
            
              x-foo div {
                  font-weight: bold;
                }
            
              becomes:
            
            
              Alternatively, if WebComponents.ShadowCSS.strictStyling is set to true then
              selectors are scoped by adding an attribute selector suffix to each
              simple selector that contains the host element tag name. Each element
              in the element's ShadowDOM template is also given the scope attribute.
              Thus, these rules match only elements that have the scope attribute.
              For example, given a scope name of x-foo, a rule like this:
            
                div {
                  font-weight: bold;
                }
            
              becomes:
            
                div[x-foo] {
                  font-weight: bold;
                }
            
              Note that elements that are dynamically added to a scope must have the scope
              selector added to them manually.
            
              * upper/lower bound encapsulation: Styles which are defined outside a
              shadowRoot should not cross the ShadowDOM boundary and should not apply
              inside a shadowRoot.
            
              This styling behavior is not emulated. Some possible ways to do this that
              were rejected due to complexity and/or performance concerns include: (1) reset
              every possible property for every possible selector for a given scope name;
              (2) re-implement css in javascript.
            
              As an alternative, users should make sure to use selectors
              specific to the scope in which they are working.
            
              * ::distributed: This behavior is not emulated. It's often not necessary
              to style the contents of a specific insertion point and instead, descendants
              of the host element can be styled selectively. Users can also create an
              extra node around an insertion point and style that node's contents
              via descendent selectors. For example, with a shadowRoot like this:
            
                <style>
                  ::content(div) {
                    background: red;
                  }
                </style>
                <content></content>
            
              could become:
            
                <style>
                  / *@polyfill .content-container div * /
                  ::content(div) {
                    background: red;
                  }
                </style>
                <div class="content-container">
                  <content></content>
                </div>
            
              Note the use of @polyfill in the comment above a ShadowDOM specific style
              declaration. This is a directive to the styling shim to use the selector
              in comments in lieu of the next selector when running under polyfill.
            */
            var ShadowCss = /** @class */ (function () {
                function ShadowCss() {
                    this.strictStyling = true;
                }
                /*
                * Shim some cssText with the given selector. Returns cssText that can
                * be included in the document via WebComponents.ShadowCSS.addCssToDocument(css).
                *
                * When strictStyling is true:
                * - selector is the attribute added to all elements inside the host,
                * - hostSelector is the attribute added to the host itself.
                */
                ShadowCss.prototype.shimCssText = function (cssText, selector, hostSelector) {
                    if (hostSelector === void 0) { hostSelector = ''; }
                    var commentsWithHash = extractCommentsWithHash(cssText);
                    cssText = stripComments(cssText);
                    cssText = this._insertDirectives(cssText);
                    var scopedCssText = this._scopeCssText(cssText, selector, hostSelector);
                    return [scopedCssText].concat(commentsWithHash).join('\n');
                };
                ShadowCss.prototype._insertDirectives = function (cssText) {
                    cssText = this._insertPolyfillDirectivesInCssText(cssText);
                    return this._insertPolyfillRulesInCssText(cssText);
                };
                /*
                 * Process styles to convert native ShadowDOM rules that will trip
                 * up the css parser; we rely on decorating the stylesheet with inert rules.
                 *
                 * For example, we convert this rule:
                 *
                 * polyfill-next-selector { content: ':host menu-item'; }
                 * ::content menu-item {
                 *
                 * to this:
                 *
                 * scopeName menu-item {
                 *
                **/
                ShadowCss.prototype._insertPolyfillDirectivesInCssText = function (cssText) {
                    // Difference with webcomponents.js: does not handle comments
                    return cssText.replace(_cssContentNextSelectorRe, function () {
                        var m = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            m[_c] = arguments[_c];
                        }
                        return m[2] + '{';
                    });
                };
                /*
                 * Process styles to add rules which will only apply under the polyfill
                 *
                 * For example, we convert this rule:
                 *
                 * polyfill-rule {
                 *   content: ':host menu-item';
                 * ...
                 * }
                 *
                 * to this:
                 *
                 * scopeName menu-item {...}
                 *
                **/
                ShadowCss.prototype._insertPolyfillRulesInCssText = function (cssText) {
                    // Difference with webcomponents.js: does not handle comments
                    return cssText.replace(_cssContentRuleRe, function () {
                        var m = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            m[_c] = arguments[_c];
                        }
                        var rule = m[0].replace(m[1], '').replace(m[2], '');
                        return m[4] + rule;
                    });
                };
                /* Ensure styles are scoped. Pseudo-scoping takes a rule like:
                 *
                 *  .foo {... }
                 *
                 *  and converts this to
                 *
                 *  scopeName .foo { ... }
                */
                ShadowCss.prototype._scopeCssText = function (cssText, scopeSelector, hostSelector) {
                    var unscopedRules = this._extractUnscopedRulesFromCssText(cssText);
                    // replace :host and :host-context -shadowcsshost and -shadowcsshost respectively
                    cssText = this._insertPolyfillHostInCssText(cssText);
                    cssText = this._convertColonHost(cssText);
                    cssText = this._convertColonHostContext(cssText);
                    cssText = this._convertShadowDOMSelectors(cssText);
                    if (scopeSelector) {
                        cssText = this._scopeSelectors(cssText, scopeSelector, hostSelector);
                    }
                    cssText = cssText + '\n' + unscopedRules;
                    return cssText.trim();
                };
                /*
                 * Process styles to add rules which will only apply under the polyfill
                 * and do not process via CSSOM. (CSSOM is destructive to rules on rare
                 * occasions, e.g. -webkit-calc on Safari.)
                 * For example, we convert this rule:
                 *
                 * @polyfill-unscoped-rule {
                 *   content: 'menu-item';
                 * ... }
                 *
                 * to this:
                 *
                 * menu-item {...}
                 *
                **/
                ShadowCss.prototype._extractUnscopedRulesFromCssText = function (cssText) {
                    // Difference with webcomponents.js: does not handle comments
                    var r = '';
                    var m;
                    _cssContentUnscopedRuleRe.lastIndex = 0;
                    while ((m = _cssContentUnscopedRuleRe.exec(cssText)) !== null) {
                        var rule = m[0].replace(m[2], '').replace(m[1], m[4]);
                        r += rule + '\n\n';
                    }
                    return r;
                };
                /*
                 * convert a rule like :host(.foo) > .bar { }
                 *
                 * to
                 *
                 * .foo<scopeName> > .bar
                */
                ShadowCss.prototype._convertColonHost = function (cssText) {
                    return this._convertColonRule(cssText, _cssColonHostRe, this._colonHostPartReplacer);
                };
                /*
                 * convert a rule like :host-context(.foo) > .bar { }
                 *
                 * to
                 *
                 * .foo<scopeName> > .bar, .foo scopeName > .bar { }
                 *
                 * and
                 *
                 * :host-context(.foo:host) .bar { ... }
                 *
                 * to
                 *
                 * .foo<scopeName> .bar { ... }
                */
                ShadowCss.prototype._convertColonHostContext = function (cssText) {
                    return this._convertColonRule(cssText, _cssColonHostContextRe, this._colonHostContextPartReplacer);
                };
                ShadowCss.prototype._convertColonRule = function (cssText, regExp, partReplacer) {
                    // m[1] = :host(-context), m[2] = contents of (), m[3] rest of rule
                    return cssText.replace(regExp, function () {
                        var m = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            m[_c] = arguments[_c];
                        }
                        if (m[2]) {
                            var parts = m[2].split(',');
                            var r = [];
                            for (var i = 0; i < parts.length; i++) {
                                var p = parts[i].trim();
                                if (!p)
                                    break;
                                r.push(partReplacer(_polyfillHostNoCombinator, p, m[3]));
                            }
                            return r.join(',');
                        }
                        else {
                            return _polyfillHostNoCombinator + m[3];
                        }
                    });
                };
                ShadowCss.prototype._colonHostContextPartReplacer = function (host, part, suffix) {
                    if (part.indexOf(_polyfillHost) > -1) {
                        return this._colonHostPartReplacer(host, part, suffix);
                    }
                    else {
                        return host + part + suffix + ', ' + part + ' ' + host + suffix;
                    }
                };
                ShadowCss.prototype._colonHostPartReplacer = function (host, part, suffix) {
                    return host + part.replace(_polyfillHost, '') + suffix;
                };
                /*
                 * Convert combinators like ::shadow and pseudo-elements like ::content
                 * by replacing with space.
                */
                ShadowCss.prototype._convertShadowDOMSelectors = function (cssText) {
                    return _shadowDOMSelectorsRe.reduce(function (result, pattern) { return result.replace(pattern, ' '); }, cssText);
                };
                // change a selector like 'div' to 'name div'
                ShadowCss.prototype._scopeSelectors = function (cssText, scopeSelector, hostSelector) {
                    var _this = this;
                    return processRules(cssText, function (rule) {
                        var selector = rule.selector;
                        var content = rule.content;
                        if (rule.selector[0] != '@') {
                            selector =
                                _this._scopeSelector(rule.selector, scopeSelector, hostSelector, _this.strictStyling);
                        }
                        else if (rule.selector.startsWith('@media') || rule.selector.startsWith('@supports') ||
                            rule.selector.startsWith('@page') || rule.selector.startsWith('@document')) {
                            content = _this._scopeSelectors(rule.content, scopeSelector, hostSelector);
                        }
                        return new CssRule(selector, content);
                    });
                };
                ShadowCss.prototype._scopeSelector = function (selector, scopeSelector, hostSelector, strict) {
                    var _this = this;
                    return selector.split(',')
                        .map(function (part) { return part.trim().split(_shadowDeepSelectors); })
                        .map(function (deepParts) {
                        var shallowPart = deepParts[0], otherParts = deepParts.slice(1);
                        var applyScope = function (shallowPart) {
                            if (_this._selectorNeedsScoping(shallowPart, scopeSelector)) {
                                return strict ?
                                    _this._applyStrictSelectorScope(shallowPart, scopeSelector, hostSelector) :
                                    _this._applySelectorScope(shallowPart, scopeSelector, hostSelector);
                            }
                            else {
                                return shallowPart;
                            }
                        };
                        return [applyScope(shallowPart)].concat(otherParts).join(' ');
                    })
                        .join(', ');
                };
                ShadowCss.prototype._selectorNeedsScoping = function (selector, scopeSelector) {
                    var re = this._makeScopeMatcher(scopeSelector);
                    return !re.test(selector);
                };
                ShadowCss.prototype._makeScopeMatcher = function (scopeSelector) {
                    var lre = /\[/g;
                    var rre = /\]/g;
                    scopeSelector = scopeSelector.replace(lre, '\\[').replace(rre, '\\]');
                    return new RegExp('^(' + scopeSelector + ')' + _selectorReSuffix, 'm');
                };
                ShadowCss.prototype._applySelectorScope = function (selector, scopeSelector, hostSelector) {
                    // Difference from webcomponents.js: scopeSelector could not be an array
                    return this._applySimpleSelectorScope(selector, scopeSelector, hostSelector);
                };
                // scope via name and [is=name]
                ShadowCss.prototype._applySimpleSelectorScope = function (selector, scopeSelector, hostSelector) {
                    // In Android browser, the lastIndex is not reset when the regex is used in String.replace()
                    _polyfillHostRe.lastIndex = 0;
                    if (_polyfillHostRe.test(selector)) {
                        var replaceBy_1 = this.strictStyling ? "[" + hostSelector + "]" : scopeSelector;
                        return selector
                            .replace(_polyfillHostNoCombinatorRe, function (hnc, selector) {
                            return selector.replace(/([^:]*)(:*)(.*)/, function (_, before, colon, after) {
                                return before + replaceBy_1 + colon + after;
                            });
                        })
                            .replace(_polyfillHostRe, replaceBy_1 + ' ');
                    }
                    return scopeSelector + ' ' + selector;
                };
                // return a selector with [name] suffix on each simple selector
                // e.g. .foo.bar > .zot becomes .foo[name].bar[name] > .zot[name]  /** @internal */
                ShadowCss.prototype._applyStrictSelectorScope = function (selector, scopeSelector, hostSelector) {
                    var _this = this;
                    var isRe = /\[is=([^\]]*)\]/g;
                    scopeSelector = scopeSelector.replace(isRe, function (_) {
                        var parts = [];
                        for (var _c = 1; _c < arguments.length; _c++) {
                            parts[_c - 1] = arguments[_c];
                        }
                        return parts[0];
                    });
                    var attrName = '[' + scopeSelector + ']';
                    var _scopeSelectorPart = function (p) {
                        var scopedP = p.trim();
                        if (!scopedP) {
                            return '';
                        }
                        if (p.indexOf(_polyfillHostNoCombinator) > -1) {
                            scopedP = _this._applySimpleSelectorScope(p, scopeSelector, hostSelector);
                        }
                        else {
                            // remove :host since it should be unnecessary
                            var t = p.replace(_polyfillHostRe, '');
                            if (t.length > 0) {
                                var matches = t.match(/([^:]*)(:*)(.*)/);
                                if (matches) {
                                    scopedP = matches[1] + attrName + matches[2] + matches[3];
                                }
                            }
                        }
                        return scopedP;
                    };
                    var safeContent = new SafeSelector(selector);
                    selector = safeContent.content();
                    var scopedSelector = '';
                    var startIndex = 0;
                    var res;
                    var sep = /( |>|\+|~(?!=))\s*/g;
                    // If a selector appears before :host it should not be shimmed as it
                    // matches on ancestor elements and not on elements in the host's shadow
                    // `:host-context(div)` is transformed to
                    // `-shadowcsshost-no-combinatordiv, div -shadowcsshost-no-combinator`
                    // the `div` is not part of the component in the 2nd selectors and should not be scoped.
                    // Historically `component-tag:host` was matching the component so we also want to preserve
                    // this behavior to avoid breaking legacy apps (it should not match).
                    // The behavior should be:
                    // - `tag:host` -> `tag[h]` (this is to avoid breaking legacy apps, should not match anything)
                    // - `tag :host` -> `tag [h]` (`tag` is not scoped because it's considered part of a
                    //   `:host-context(tag)`)
                    var hasHost = selector.indexOf(_polyfillHostNoCombinator) > -1;
                    // Only scope parts after the first `-shadowcsshost-no-combinator` when it is present
                    var shouldScope = !hasHost;
                    while ((res = sep.exec(selector)) !== null) {
                        var separator = res[1];
                        var part_1 = selector.slice(startIndex, res.index).trim();
                        shouldScope = shouldScope || part_1.indexOf(_polyfillHostNoCombinator) > -1;
                        var scopedPart = shouldScope ? _scopeSelectorPart(part_1) : part_1;
                        scopedSelector += scopedPart + " " + separator + " ";
                        startIndex = sep.lastIndex;
                    }
                    var part = selector.substring(startIndex);
                    shouldScope = shouldScope || part.indexOf(_polyfillHostNoCombinator) > -1;
                    scopedSelector += shouldScope ? _scopeSelectorPart(part) : part;
                    // replace the placeholders with their original values
                    return safeContent.restore(scopedSelector);
                };
                ShadowCss.prototype._insertPolyfillHostInCssText = function (selector) {
                    return selector.replace(_colonHostContextRe, _polyfillHostContext)
                        .replace(_colonHostRe, _polyfillHost);
                };
                return ShadowCss;
            }());
            var SafeSelector = /** @class */ (function () {
                function SafeSelector(selector) {
                    var _this = this;
                    this.placeholders = [];
                    this.index = 0;
                    // Replaces attribute selectors with placeholders.
                    // The WS in [attr="va lue"] would otherwise be interpreted as a selector separator.
                    selector = selector.replace(/(\[[^\]]*\])/g, function (_, keep) {
                        var replaceBy = "__ph-" + _this.index + "__";
                        _this.placeholders.push(keep);
                        _this.index++;
                        return replaceBy;
                    });
                    // Replaces the expression in `:nth-child(2n + 1)` with a placeholder.
                    // WS and "+" would otherwise be interpreted as selector separators.
                    this._content = selector.replace(/(:nth-[-\w]+)(\([^)]+\))/g, function (_, pseudo, exp) {
                        var replaceBy = "__ph-" + _this.index + "__";
                        _this.placeholders.push(exp);
                        _this.index++;
                        return pseudo + replaceBy;
                    });
                }
                SafeSelector.prototype.restore = function (content) {
                    var _this = this;
                    return content.replace(/__ph-(\d+)__/g, function (ph, index) { return _this.placeholders[+index]; });
                };
                SafeSelector.prototype.content = function () { return this._content; };
                return SafeSelector;
            }());
            var _cssContentNextSelectorRe = /polyfill-next-selector[^}]*content:[\s]*?(['"])(.*?)\1[;\s]*}([^{]*?){/gim;
            var _cssContentRuleRe = /(polyfill-rule)[^}]*(content:[\s]*(['"])(.*?)\3)[;\s]*[^}]*}/gim;
            var _cssContentUnscopedRuleRe = /(polyfill-unscoped-rule)[^}]*(content:[\s]*(['"])(.*?)\3)[;\s]*[^}]*}/gim;
            var _polyfillHost = '-shadowcsshost';
            // note: :host-context pre-processed to -shadowcsshostcontext.
            var _polyfillHostContext = '-shadowcsscontext';
            var _parenSuffix = ')(?:\\((' +
                '(?:\\([^)(]*\\)|[^)(]*)+?' +
                ')\\))?([^,{]*)';
            var _cssColonHostRe = new RegExp('(' + _polyfillHost + _parenSuffix, 'gim');
            var _cssColonHostContextRe = new RegExp('(' + _polyfillHostContext + _parenSuffix, 'gim');
            var _polyfillHostNoCombinator = _polyfillHost + '-no-combinator';
            var _polyfillHostNoCombinatorRe = /-shadowcsshost-no-combinator([^\s]*)/;
            var _shadowDOMSelectorsRe = [
                /::shadow/g,
                /::content/g,
                // Deprecated selectors
                /\/shadow-deep\//g,
                /\/shadow\//g,
            ];
            // The deep combinator is deprecated in the CSS spec
            // Support for `>>>`, `deep`, `::ng-deep` is then also deprecated and will be removed in the future.
            // see https://github.com/angular/angular/pull/17677
            var _shadowDeepSelectors = /(?:>>>)|(?:\/deep\/)|(?:::ng-deep)/g;
            var _selectorReSuffix = '([>\\s~+\[.,{:][\\s\\S]*)?$';
            var _polyfillHostRe = /-shadowcsshost/gim;
            var _colonHostRe = /:host/gim;
            var _colonHostContextRe = /:host-context/gim;
            var _commentRe = /\/\*\s*[\s\S]*?\*\//g;
            function stripComments(input) {
                return input.replace(_commentRe, '');
            }
            var _commentWithHashRe = /\/\*\s*#\s*source(Mapping)?URL=[\s\S]+?\*\//g;
            function extractCommentsWithHash(input) {
                return input.match(_commentWithHashRe) || [];
            }
            var _ruleRe = /(\s*)([^;\{\}]+?)(\s*)((?:{%BLOCK%}?\s*;?)|(?:\s*;))/g;
            var _curlyRe = /([{}])/g;
            var OPEN_CURLY = '{';
            var CLOSE_CURLY = '}';
            var BLOCK_PLACEHOLDER = '%BLOCK%';
            var CssRule = /** @class */ (function () {
                function CssRule(selector, content) {
                    this.selector = selector;
                    this.content = content;
                }
                return CssRule;
            }());
            function processRules(input, ruleCallback) {
                var inputWithEscapedBlocks = escapeBlocks(input);
                var nextBlockIndex = 0;
                return inputWithEscapedBlocks.escapedString.replace(_ruleRe, function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    var selector = m[2];
                    var content = '';
                    var suffix = m[4];
                    var contentPrefix = '';
                    if (suffix && suffix.startsWith('{' + BLOCK_PLACEHOLDER)) {
                        content = inputWithEscapedBlocks.blocks[nextBlockIndex++];
                        suffix = suffix.substring(BLOCK_PLACEHOLDER.length + 1);
                        contentPrefix = '{';
                    }
                    var rule = ruleCallback(new CssRule(selector, content));
                    return "" + m[1] + rule.selector + m[3] + contentPrefix + rule.content + suffix;
                });
            }
            var StringWithEscapedBlocks = /** @class */ (function () {
                function StringWithEscapedBlocks(escapedString, blocks) {
                    this.escapedString = escapedString;
                    this.blocks = blocks;
                }
                return StringWithEscapedBlocks;
            }());
            function escapeBlocks(input) {
                var inputParts = input.split(_curlyRe);
                var resultParts = [];
                var escapedBlocks = [];
                var bracketCount = 0;
                var currentBlockParts = [];
                for (var partIndex = 0; partIndex < inputParts.length; partIndex++) {
                    var part = inputParts[partIndex];
                    if (part == CLOSE_CURLY) {
                        bracketCount--;
                    }
                    if (bracketCount > 0) {
                        currentBlockParts.push(part);
                    }
                    else {
                        if (currentBlockParts.length > 0) {
                            escapedBlocks.push(currentBlockParts.join(''));
                            resultParts.push(BLOCK_PLACEHOLDER);
                            currentBlockParts = [];
                        }
                        resultParts.push(part);
                    }
                    if (part == OPEN_CURLY) {
                        bracketCount++;
                    }
                }
                if (currentBlockParts.length > 0) {
                    escapedBlocks.push(currentBlockParts.join(''));
                    resultParts.push(BLOCK_PLACEHOLDER);
                }
                return new StringWithEscapedBlocks(resultParts.join(''), escapedBlocks);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var COMPONENT_VARIABLE = '%COMP%';
            var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
            var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
            var StylesCompileDependency = /** @class */ (function () {
                function StylesCompileDependency(name, moduleUrl, setValue) {
                    this.name = name;
                    this.moduleUrl = moduleUrl;
                    this.setValue = setValue;
                }
                return StylesCompileDependency;
            }());
            var CompiledStylesheet = /** @class */ (function () {
                function CompiledStylesheet(outputCtx, stylesVar, dependencies, isShimmed, meta) {
                    this.outputCtx = outputCtx;
                    this.stylesVar = stylesVar;
                    this.dependencies = dependencies;
                    this.isShimmed = isShimmed;
                    this.meta = meta;
                }
                return CompiledStylesheet;
            }());
            var StyleCompiler = /** @class */ (function () {
                function StyleCompiler(_urlResolver) {
                    this._urlResolver = _urlResolver;
                    this._shadowCss = new ShadowCss();
                }
                StyleCompiler.prototype.compileComponent = function (outputCtx, comp) {
                    var template = comp.template;
                    return this._compileStyles(outputCtx, comp, new CompileStylesheetMetadata({
                        styles: template.styles,
                        styleUrls: template.styleUrls,
                        moduleUrl: identifierModuleUrl(comp.type)
                    }), this.needsStyleShim(comp), true);
                };
                StyleCompiler.prototype.compileStyles = function (outputCtx, comp, stylesheet, shim) {
                    if (shim === void 0) { shim = this.needsStyleShim(comp); }
                    return this._compileStyles(outputCtx, comp, stylesheet, shim, false);
                };
                StyleCompiler.prototype.needsStyleShim = function (comp) {
                    return comp.template.encapsulation === ViewEncapsulation.Emulated;
                };
                StyleCompiler.prototype._compileStyles = function (outputCtx, comp, stylesheet, shim, isComponentStylesheet) {
                    var _this = this;
                    var styleExpressions = stylesheet.styles.map(function (plainStyle) { return literal(_this._shimIfNeeded(plainStyle, shim)); });
                    var dependencies = [];
                    stylesheet.styleUrls.forEach(function (styleUrl) {
                        var exprIndex = styleExpressions.length;
                        // Note: This placeholder will be filled later.
                        styleExpressions.push(null);
                        dependencies.push(new StylesCompileDependency(getStylesVarName(null), styleUrl, function (value) { return styleExpressions[exprIndex] = outputCtx.importExpr(value); }));
                    });
                    // styles variable contains plain strings and arrays of other styles arrays (recursive),
                    // so we set its type to dynamic.
                    var stylesVar = getStylesVarName(isComponentStylesheet ? comp : null);
                    var stmt = variable(stylesVar)
                        .set(literalArr(styleExpressions, new ArrayType(DYNAMIC_TYPE, [TypeModifier.Const])))
                        .toDeclStmt(null, isComponentStylesheet ? [StmtModifier.Final] : [
                        StmtModifier.Final, StmtModifier.Exported
                    ]);
                    outputCtx.statements.push(stmt);
                    return new CompiledStylesheet(outputCtx, stylesVar, dependencies, shim, stylesheet);
                };
                StyleCompiler.prototype._shimIfNeeded = function (style, shim) {
                    return shim ? this._shadowCss.shimCssText(style, CONTENT_ATTR, HOST_ATTR) : style;
                };
                return StyleCompiler;
            }());
            function getStylesVarName(component) {
                var result = "styles";
                if (component) {
                    result += "_" + identifierName(component.type);
                }
                return result;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A path is an ordered set of elements. Typically a path is to  a
             * particular offset in a source file. The head of the list is the top
             * most node. The tail is the node that contains the offset directly.
             *
             * For example, the expression `a + b + c` might have an ast that looks
             * like:
             *     +
             *    / \
             *   a   +
             *      / \
             *     b   c
             *
             * The path to the node at offset 9 would be `['+' at 1-10, '+' at 7-10,
             * 'c' at 9-10]` and the path the node at offset 1 would be
             * `['+' at 1-10, 'a' at 1-2]`.
             */
            var AstPath = /** @class */ (function () {
                function AstPath(path, position) {
                    if (position === void 0) { position = -1; }
                    this.path = path;
                    this.position = position;
                }
                Object.defineProperty(AstPath.prototype, "empty", {
                    get: function () { return !this.path || !this.path.length; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AstPath.prototype, "head", {
                    get: function () { return this.path[0]; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AstPath.prototype, "tail", {
                    get: function () { return this.path[this.path.length - 1]; },
                    enumerable: true,
                    configurable: true
                });
                AstPath.prototype.parentOf = function (node) {
                    return node && this.path[this.path.indexOf(node) - 1];
                };
                AstPath.prototype.childOf = function (node) { return this.path[this.path.indexOf(node) + 1]; };
                AstPath.prototype.first = function (ctor) {
                    for (var i = this.path.length - 1; i >= 0; i--) {
                        var item = this.path[i];
                        if (item instanceof ctor)
                            return item;
                    }
                };
                AstPath.prototype.push = function (node) { this.path.push(node); };
                AstPath.prototype.pop = function () { return this.path.pop(); };
                return AstPath;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var Text$3 = /** @class */ (function () {
                function Text$3(value, sourceSpan, i18n) {
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                    this.i18n = i18n;
                }
                Text$3.prototype.visit = function (visitor, context) { return visitor.visitText(this, context); };
                return Text$3;
            }());
            var Expansion = /** @class */ (function () {
                function Expansion(switchValue, type, cases, sourceSpan, switchValueSourceSpan, i18n) {
                    this.switchValue = switchValue;
                    this.type = type;
                    this.cases = cases;
                    this.sourceSpan = sourceSpan;
                    this.switchValueSourceSpan = switchValueSourceSpan;
                    this.i18n = i18n;
                }
                Expansion.prototype.visit = function (visitor, context) { return visitor.visitExpansion(this, context); };
                return Expansion;
            }());
            var ExpansionCase = /** @class */ (function () {
                function ExpansionCase(value, expression, sourceSpan, valueSourceSpan, expSourceSpan) {
                    this.value = value;
                    this.expression = expression;
                    this.sourceSpan = sourceSpan;
                    this.valueSourceSpan = valueSourceSpan;
                    this.expSourceSpan = expSourceSpan;
                }
                ExpansionCase.prototype.visit = function (visitor, context) { return visitor.visitExpansionCase(this, context); };
                return ExpansionCase;
            }());
            var Attribute = /** @class */ (function () {
                function Attribute(name, value, sourceSpan, valueSpan, i18n) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                    this.valueSpan = valueSpan;
                    this.i18n = i18n;
                }
                Attribute.prototype.visit = function (visitor, context) { return visitor.visitAttribute(this, context); };
                return Attribute;
            }());
            var Element$1 = /** @class */ (function () {
                function Element$1(name, attrs, children, sourceSpan, startSourceSpan, endSourceSpan, i18n) {
                    if (startSourceSpan === void 0) { startSourceSpan = null; }
                    if (endSourceSpan === void 0) { endSourceSpan = null; }
                    this.name = name;
                    this.attrs = attrs;
                    this.children = children;
                    this.sourceSpan = sourceSpan;
                    this.startSourceSpan = startSourceSpan;
                    this.endSourceSpan = endSourceSpan;
                    this.i18n = i18n;
                }
                Element$1.prototype.visit = function (visitor, context) { return visitor.visitElement(this, context); };
                return Element$1;
            }());
            var Comment = /** @class */ (function () {
                function Comment(value, sourceSpan) {
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                Comment.prototype.visit = function (visitor, context) { return visitor.visitComment(this, context); };
                return Comment;
            }());
            function visitAll$1(visitor, nodes, context) {
                if (context === void 0) { context = null; }
                var result = [];
                var visit = visitor.visit ?
                    function (ast) { return visitor.visit(ast, context) || ast.visit(visitor, context); } :
                    function (ast) { return ast.visit(visitor, context); };
                nodes.forEach(function (ast) {
                    var astResult = visit(ast);
                    if (astResult) {
                        result.push(astResult);
                    }
                });
                return result;
            }
            var RecursiveVisitor$1 = /** @class */ (function () {
                function RecursiveVisitor$1() {
                }
                RecursiveVisitor$1.prototype.visitElement = function (ast, context) {
                    this.visitChildren(context, function (visit) {
                        visit(ast.attrs);
                        visit(ast.children);
                    });
                };
                RecursiveVisitor$1.prototype.visitAttribute = function (ast, context) { };
                RecursiveVisitor$1.prototype.visitText = function (ast, context) { };
                RecursiveVisitor$1.prototype.visitComment = function (ast, context) { };
                RecursiveVisitor$1.prototype.visitExpansion = function (ast, context) {
                    return this.visitChildren(context, function (visit) { visit(ast.cases); });
                };
                RecursiveVisitor$1.prototype.visitExpansionCase = function (ast, context) { };
                RecursiveVisitor$1.prototype.visitChildren = function (context, cb) {
                    var results = [];
                    var t = this;
                    function visit(children) {
                        if (children)
                            results.push(visitAll$1(t, children, context));
                    }
                    cb(visit);
                    return Array.prototype.concat.apply([], results);
                };
                return RecursiveVisitor$1;
            }());
            function spanOf(ast) {
                var start = ast.sourceSpan.start.offset;
                var end = ast.sourceSpan.end.offset;
                if (ast instanceof Element$1) {
                    if (ast.endSourceSpan) {
                        end = ast.endSourceSpan.end.offset;
                    }
                    else if (ast.children && ast.children.length) {
                        end = spanOf(ast.children[ast.children.length - 1]).end;
                    }
                }
                return { start: start, end: end };
            }
            function findNode(nodes, position) {
                var path = [];
                var visitor = new /** @class */ (function (_super_1) {
                    __extends(class_2, _super_1);
                    function class_2() {
                        return _super_1 !== null && _super_1.apply(this, arguments) || this;
                    }
                    class_2.prototype.visit = function (ast, context) {
                        var span = spanOf(ast);
                        if (span.start <= position && position < span.end) {
                            path.push(ast);
                        }
                        else {
                            // Returning a value here will result in the children being skipped.
                            return true;
                        }
                    };
                    return class_2;
                }(RecursiveVisitor$1));
                visitAll$1(visitor, nodes);
                return new AstPath(path, position);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TokenType;
            (function (TokenType) {
                TokenType[TokenType["TAG_OPEN_START"] = 0] = "TAG_OPEN_START";
                TokenType[TokenType["TAG_OPEN_END"] = 1] = "TAG_OPEN_END";
                TokenType[TokenType["TAG_OPEN_END_VOID"] = 2] = "TAG_OPEN_END_VOID";
                TokenType[TokenType["TAG_CLOSE"] = 3] = "TAG_CLOSE";
                TokenType[TokenType["TEXT"] = 4] = "TEXT";
                TokenType[TokenType["ESCAPABLE_RAW_TEXT"] = 5] = "ESCAPABLE_RAW_TEXT";
                TokenType[TokenType["RAW_TEXT"] = 6] = "RAW_TEXT";
                TokenType[TokenType["COMMENT_START"] = 7] = "COMMENT_START";
                TokenType[TokenType["COMMENT_END"] = 8] = "COMMENT_END";
                TokenType[TokenType["CDATA_START"] = 9] = "CDATA_START";
                TokenType[TokenType["CDATA_END"] = 10] = "CDATA_END";
                TokenType[TokenType["ATTR_NAME"] = 11] = "ATTR_NAME";
                TokenType[TokenType["ATTR_QUOTE"] = 12] = "ATTR_QUOTE";
                TokenType[TokenType["ATTR_VALUE"] = 13] = "ATTR_VALUE";
                TokenType[TokenType["DOC_TYPE"] = 14] = "DOC_TYPE";
                TokenType[TokenType["EXPANSION_FORM_START"] = 15] = "EXPANSION_FORM_START";
                TokenType[TokenType["EXPANSION_CASE_VALUE"] = 16] = "EXPANSION_CASE_VALUE";
                TokenType[TokenType["EXPANSION_CASE_EXP_START"] = 17] = "EXPANSION_CASE_EXP_START";
                TokenType[TokenType["EXPANSION_CASE_EXP_END"] = 18] = "EXPANSION_CASE_EXP_END";
                TokenType[TokenType["EXPANSION_FORM_END"] = 19] = "EXPANSION_FORM_END";
                TokenType[TokenType["EOF"] = 20] = "EOF";
            })(TokenType || (TokenType = {}));
            var Token = /** @class */ (function () {
                function Token(type, parts, sourceSpan) {
                    this.type = type;
                    this.parts = parts;
                    this.sourceSpan = sourceSpan;
                }
                return Token;
            }());
            var TokenError = /** @class */ (function (_super_1) {
                __extends(TokenError, _super_1);
                function TokenError(errorMsg, tokenType, span) {
                    var _this = _super_1.call(this, span, errorMsg) || this;
                    _this.tokenType = tokenType;
                    return _this;
                }
                return TokenError;
            }(ParseError));
            var TokenizeResult = /** @class */ (function () {
                function TokenizeResult(tokens, errors) {
                    this.tokens = tokens;
                    this.errors = errors;
                }
                return TokenizeResult;
            }());
            function tokenize(source, url, getTagDefinition, options) {
                if (options === void 0) { options = {}; }
                return new _Tokenizer(new ParseSourceFile(source, url), getTagDefinition, options).tokenize();
            }
            var _CR_OR_CRLF_REGEXP = /\r\n?/g;
            function _unexpectedCharacterErrorMsg(charCode) {
                var char = charCode === $EOF ? 'EOF' : String.fromCharCode(charCode);
                return "Unexpected character \"" + char + "\"";
            }
            function _unknownEntityErrorMsg(entitySrc) {
                return "Unknown entity \"" + entitySrc + "\" - use the \"&#<decimal>;\" or  \"&#x<hex>;\" syntax";
            }
            var _ControlFlowError = /** @class */ (function () {
                function _ControlFlowError(error) {
                    this.error = error;
                }
                return _ControlFlowError;
            }());
            // See http://www.w3.org/TR/html51/syntax.html#writing
            var _Tokenizer = /** @class */ (function () {
                /**
                 * @param _file The html source file being tokenized.
                 * @param _getTagDefinition A function that will retrieve a tag definition for a given tag name.
                 * @param options Configuration of the tokenization.
                 */
                function _Tokenizer(_file, _getTagDefinition, options) {
                    this._getTagDefinition = _getTagDefinition;
                    this._currentTokenStart = null;
                    this._currentTokenType = null;
                    this._expansionCaseStack = [];
                    this._inInterpolation = false;
                    this.tokens = [];
                    this.errors = [];
                    this._tokenizeIcu = options.tokenizeExpansionForms || false;
                    this._interpolationConfig = options.interpolationConfig || DEFAULT_INTERPOLATION_CONFIG;
                    this._leadingTriviaCodePoints =
                        options.leadingTriviaChars && options.leadingTriviaChars.map(function (c) { return c.codePointAt(0) || 0; });
                    var range = options.range || { endPos: _file.content.length, startPos: 0, startLine: 0, startCol: 0 };
                    this._cursor = options.escapedString ? new EscapedCharacterCursor(_file, range) :
                        new PlainCharacterCursor(_file, range);
                    try {
                        this._cursor.init();
                    }
                    catch (e) {
                        this.handleError(e);
                    }
                }
                _Tokenizer.prototype._processCarriageReturns = function (content) {
                    // http://www.w3.org/TR/html5/syntax.html#preprocessing-the-input-stream
                    // In order to keep the original position in the source, we can not
                    // pre-process it.
                    // Instead CRs are processed right before instantiating the tokens.
                    return content.replace(_CR_OR_CRLF_REGEXP, '\n');
                };
                _Tokenizer.prototype.tokenize = function () {
                    while (this._cursor.peek() !== $EOF) {
                        var start = this._cursor.clone();
                        try {
                            if (this._attemptCharCode($LT)) {
                                if (this._attemptCharCode($BANG)) {
                                    if (this._attemptCharCode($LBRACKET)) {
                                        this._consumeCdata(start);
                                    }
                                    else if (this._attemptCharCode($MINUS)) {
                                        this._consumeComment(start);
                                    }
                                    else {
                                        this._consumeDocType(start);
                                    }
                                }
                                else if (this._attemptCharCode($SLASH)) {
                                    this._consumeTagClose(start);
                                }
                                else {
                                    this._consumeTagOpen(start);
                                }
                            }
                            else if (!(this._tokenizeIcu && this._tokenizeExpansionForm())) {
                                this._consumeText();
                            }
                        }
                        catch (e) {
                            this.handleError(e);
                        }
                    }
                    this._beginToken(TokenType.EOF);
                    this._endToken([]);
                    return new TokenizeResult(mergeTextTokens(this.tokens), this.errors);
                };
                /**
                 * @returns whether an ICU token has been created
                 * @internal
                 */
                _Tokenizer.prototype._tokenizeExpansionForm = function () {
                    if (this.isExpansionFormStart()) {
                        this._consumeExpansionFormStart();
                        return true;
                    }
                    if (isExpansionCaseStart(this._cursor.peek()) && this._isInExpansionForm()) {
                        this._consumeExpansionCaseStart();
                        return true;
                    }
                    if (this._cursor.peek() === $RBRACE) {
                        if (this._isInExpansionCase()) {
                            this._consumeExpansionCaseEnd();
                            return true;
                        }
                        if (this._isInExpansionForm()) {
                            this._consumeExpansionFormEnd();
                            return true;
                        }
                    }
                    return false;
                };
                _Tokenizer.prototype._beginToken = function (type, start) {
                    if (start === void 0) { start = this._cursor.clone(); }
                    this._currentTokenStart = start;
                    this._currentTokenType = type;
                };
                _Tokenizer.prototype._endToken = function (parts, end) {
                    if (end === void 0) { end = this._cursor.clone(); }
                    if (this._currentTokenStart === null) {
                        throw new TokenError('Programming error - attempted to end a token when there was no start to the token', this._currentTokenType, this._cursor.getSpan(end));
                    }
                    if (this._currentTokenType === null) {
                        throw new TokenError('Programming error - attempted to end a token which has no token type', null, this._cursor.getSpan(this._currentTokenStart));
                    }
                    var token = new Token(this._currentTokenType, parts, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
                    this.tokens.push(token);
                    this._currentTokenStart = null;
                    this._currentTokenType = null;
                    return token;
                };
                _Tokenizer.prototype._createError = function (msg, span) {
                    if (this._isInExpansionForm()) {
                        msg += " (Do you have an unescaped \"{\" in your template? Use \"{{ '{' }}\") to escape it.)";
                    }
                    var error = new TokenError(msg, this._currentTokenType, span);
                    this._currentTokenStart = null;
                    this._currentTokenType = null;
                    return new _ControlFlowError(error);
                };
                _Tokenizer.prototype.handleError = function (e) {
                    if (e instanceof CursorError) {
                        e = this._createError(e.msg, this._cursor.getSpan(e.cursor));
                    }
                    if (e instanceof _ControlFlowError) {
                        this.errors.push(e.error);
                    }
                    else {
                        throw e;
                    }
                };
                _Tokenizer.prototype._attemptCharCode = function (charCode) {
                    if (this._cursor.peek() === charCode) {
                        this._cursor.advance();
                        return true;
                    }
                    return false;
                };
                _Tokenizer.prototype._attemptCharCodeCaseInsensitive = function (charCode) {
                    if (compareCharCodeCaseInsensitive(this._cursor.peek(), charCode)) {
                        this._cursor.advance();
                        return true;
                    }
                    return false;
                };
                _Tokenizer.prototype._requireCharCode = function (charCode) {
                    var location = this._cursor.clone();
                    if (!this._attemptCharCode(charCode)) {
                        throw this._createError(_unexpectedCharacterErrorMsg(this._cursor.peek()), this._cursor.getSpan(location));
                    }
                };
                _Tokenizer.prototype._attemptStr = function (chars) {
                    var len = chars.length;
                    if (this._cursor.charsLeft() < len) {
                        return false;
                    }
                    var initialPosition = this._cursor.clone();
                    for (var i = 0; i < len; i++) {
                        if (!this._attemptCharCode(chars.charCodeAt(i))) {
                            // If attempting to parse the string fails, we want to reset the parser
                            // to where it was before the attempt
                            this._cursor = initialPosition;
                            return false;
                        }
                    }
                    return true;
                };
                _Tokenizer.prototype._attemptStrCaseInsensitive = function (chars) {
                    for (var i = 0; i < chars.length; i++) {
                        if (!this._attemptCharCodeCaseInsensitive(chars.charCodeAt(i))) {
                            return false;
                        }
                    }
                    return true;
                };
                _Tokenizer.prototype._requireStr = function (chars) {
                    var location = this._cursor.clone();
                    if (!this._attemptStr(chars)) {
                        throw this._createError(_unexpectedCharacterErrorMsg(this._cursor.peek()), this._cursor.getSpan(location));
                    }
                };
                _Tokenizer.prototype._attemptCharCodeUntilFn = function (predicate) {
                    while (!predicate(this._cursor.peek())) {
                        this._cursor.advance();
                    }
                };
                _Tokenizer.prototype._requireCharCodeUntilFn = function (predicate, len) {
                    var start = this._cursor.clone();
                    this._attemptCharCodeUntilFn(predicate);
                    var end = this._cursor.clone();
                    if (end.diff(start) < len) {
                        throw this._createError(_unexpectedCharacterErrorMsg(this._cursor.peek()), this._cursor.getSpan(start));
                    }
                };
                _Tokenizer.prototype._attemptUntilChar = function (char) {
                    while (this._cursor.peek() !== char) {
                        this._cursor.advance();
                    }
                };
                _Tokenizer.prototype._readChar = function (decodeEntities) {
                    if (decodeEntities && this._cursor.peek() === $AMPERSAND) {
                        return this._decodeEntity();
                    }
                    else {
                        // Don't rely upon reading directly from `_input` as the actual char value
                        // may have been generated from an escape sequence.
                        var char = String.fromCodePoint(this._cursor.peek());
                        this._cursor.advance();
                        return char;
                    }
                };
                _Tokenizer.prototype._decodeEntity = function () {
                    var start = this._cursor.clone();
                    this._cursor.advance();
                    if (this._attemptCharCode($HASH)) {
                        var isHex = this._attemptCharCode($x) || this._attemptCharCode($X);
                        var codeStart = this._cursor.clone();
                        this._attemptCharCodeUntilFn(isDigitEntityEnd);
                        if (this._cursor.peek() != $SEMICOLON) {
                            throw this._createError(_unexpectedCharacterErrorMsg(this._cursor.peek()), this._cursor.getSpan());
                        }
                        var strNum = this._cursor.getChars(codeStart);
                        this._cursor.advance();
                        try {
                            var charCode = parseInt(strNum, isHex ? 16 : 10);
                            return String.fromCharCode(charCode);
                        }
                        catch (_a) {
                            throw this._createError(_unknownEntityErrorMsg(this._cursor.getChars(start)), this._cursor.getSpan());
                        }
                    }
                    else {
                        var nameStart = this._cursor.clone();
                        this._attemptCharCodeUntilFn(isNamedEntityEnd);
                        if (this._cursor.peek() != $SEMICOLON) {
                            this._cursor = nameStart;
                            return '&';
                        }
                        var name = this._cursor.getChars(nameStart);
                        this._cursor.advance();
                        var char = NAMED_ENTITIES[name];
                        if (!char) {
                            throw this._createError(_unknownEntityErrorMsg(name), this._cursor.getSpan(start));
                        }
                        return char;
                    }
                };
                _Tokenizer.prototype._consumeRawText = function (decodeEntities, endMarkerPredicate) {
                    this._beginToken(decodeEntities ? TokenType.ESCAPABLE_RAW_TEXT : TokenType.RAW_TEXT);
                    var parts = [];
                    while (true) {
                        var tagCloseStart = this._cursor.clone();
                        var foundEndMarker = endMarkerPredicate();
                        this._cursor = tagCloseStart;
                        if (foundEndMarker) {
                            break;
                        }
                        parts.push(this._readChar(decodeEntities));
                    }
                    return this._endToken([this._processCarriageReturns(parts.join(''))]);
                };
                _Tokenizer.prototype._consumeComment = function (start) {
                    var _this = this;
                    this._beginToken(TokenType.COMMENT_START, start);
                    this._requireCharCode($MINUS);
                    this._endToken([]);
                    this._consumeRawText(false, function () { return _this._attemptStr('-->'); });
                    this._beginToken(TokenType.COMMENT_END);
                    this._requireStr('-->');
                    this._endToken([]);
                };
                _Tokenizer.prototype._consumeCdata = function (start) {
                    var _this = this;
                    this._beginToken(TokenType.CDATA_START, start);
                    this._requireStr('CDATA[');
                    this._endToken([]);
                    this._consumeRawText(false, function () { return _this._attemptStr(']]>'); });
                    this._beginToken(TokenType.CDATA_END);
                    this._requireStr(']]>');
                    this._endToken([]);
                };
                _Tokenizer.prototype._consumeDocType = function (start) {
                    this._beginToken(TokenType.DOC_TYPE, start);
                    var contentStart = this._cursor.clone();
                    this._attemptUntilChar($GT);
                    var content = this._cursor.getChars(contentStart);
                    this._cursor.advance();
                    this._endToken([content]);
                };
                _Tokenizer.prototype._consumePrefixAndName = function () {
                    var nameOrPrefixStart = this._cursor.clone();
                    var prefix = '';
                    while (this._cursor.peek() !== $COLON && !isPrefixEnd(this._cursor.peek())) {
                        this._cursor.advance();
                    }
                    var nameStart;
                    if (this._cursor.peek() === $COLON) {
                        prefix = this._cursor.getChars(nameOrPrefixStart);
                        this._cursor.advance();
                        nameStart = this._cursor.clone();
                    }
                    else {
                        nameStart = nameOrPrefixStart;
                    }
                    this._requireCharCodeUntilFn(isNameEnd, prefix === '' ? 0 : 1);
                    var name = this._cursor.getChars(nameStart);
                    return [prefix, name];
                };
                _Tokenizer.prototype._consumeTagOpen = function (start) {
                    var tagName;
                    var prefix;
                    var openTagToken;
                    var tokensBeforeTagOpen = this.tokens.length;
                    var innerStart = this._cursor.clone();
                    try {
                        if (!isAsciiLetter(this._cursor.peek())) {
                            throw this._createError(_unexpectedCharacterErrorMsg(this._cursor.peek()), this._cursor.getSpan(start));
                        }
                        openTagToken = this._consumeTagOpenStart(start);
                        prefix = openTagToken.parts[0];
                        tagName = openTagToken.parts[1];
                        this._attemptCharCodeUntilFn(isNotWhitespace);
                        while (this._cursor.peek() !== $SLASH && this._cursor.peek() !== $GT) {
                            this._consumeAttributeName();
                            this._attemptCharCodeUntilFn(isNotWhitespace);
                            if (this._attemptCharCode($EQ)) {
                                this._attemptCharCodeUntilFn(isNotWhitespace);
                                this._consumeAttributeValue();
                            }
                            this._attemptCharCodeUntilFn(isNotWhitespace);
                        }
                        this._consumeTagOpenEnd();
                    }
                    catch (e) {
                        if (e instanceof _ControlFlowError) {
                            // When the start tag is invalid (including invalid "attributes"), assume we want a "<"
                            this._cursor = innerStart;
                            if (openTagToken) {
                                this.tokens.length = tokensBeforeTagOpen;
                            }
                            // Back to back text tokens are merged at the end
                            this._beginToken(TokenType.TEXT, start);
                            this._endToken(['<']);
                            return;
                        }
                        throw e;
                    }
                    var contentTokenType = this._getTagDefinition(tagName).contentType;
                    if (contentTokenType === TagContentType.RAW_TEXT) {
                        this._consumeRawTextWithTagClose(prefix, tagName, false);
                    }
                    else if (contentTokenType === TagContentType.ESCAPABLE_RAW_TEXT) {
                        this._consumeRawTextWithTagClose(prefix, tagName, true);
                    }
                };
                _Tokenizer.prototype._consumeRawTextWithTagClose = function (prefix, tagName, decodeEntities) {
                    var _this = this;
                    var textToken = this._consumeRawText(decodeEntities, function () {
                        if (!_this._attemptCharCode($LT))
                            return false;
                        if (!_this._attemptCharCode($SLASH))
                            return false;
                        _this._attemptCharCodeUntilFn(isNotWhitespace);
                        if (!_this._attemptStrCaseInsensitive(tagName))
                            return false;
                        _this._attemptCharCodeUntilFn(isNotWhitespace);
                        return _this._attemptCharCode($GT);
                    });
                    this._beginToken(TokenType.TAG_CLOSE);
                    this._requireCharCodeUntilFn(function (code) { return code === $GT; }, 3);
                    this._cursor.advance(); // Consume the `>`
                    this._endToken([prefix, tagName]);
                };
                _Tokenizer.prototype._consumeTagOpenStart = function (start) {
                    this._beginToken(TokenType.TAG_OPEN_START, start);
                    var parts = this._consumePrefixAndName();
                    return this._endToken(parts);
                };
                _Tokenizer.prototype._consumeAttributeName = function () {
                    var attrNameStart = this._cursor.peek();
                    if (attrNameStart === $SQ || attrNameStart === $DQ) {
                        throw this._createError(_unexpectedCharacterErrorMsg(attrNameStart), this._cursor.getSpan());
                    }
                    this._beginToken(TokenType.ATTR_NAME);
                    var prefixAndName = this._consumePrefixAndName();
                    this._endToken(prefixAndName);
                };
                _Tokenizer.prototype._consumeAttributeValue = function () {
                    var value;
                    if (this._cursor.peek() === $SQ || this._cursor.peek() === $DQ) {
                        this._beginToken(TokenType.ATTR_QUOTE);
                        var quoteChar = this._cursor.peek();
                        this._cursor.advance();
                        this._endToken([String.fromCodePoint(quoteChar)]);
                        this._beginToken(TokenType.ATTR_VALUE);
                        var parts = [];
                        while (this._cursor.peek() !== quoteChar) {
                            parts.push(this._readChar(true));
                        }
                        value = parts.join('');
                        this._endToken([this._processCarriageReturns(value)]);
                        this._beginToken(TokenType.ATTR_QUOTE);
                        this._cursor.advance();
                        this._endToken([String.fromCodePoint(quoteChar)]);
                    }
                    else {
                        this._beginToken(TokenType.ATTR_VALUE);
                        var valueStart = this._cursor.clone();
                        this._requireCharCodeUntilFn(isNameEnd, 1);
                        value = this._cursor.getChars(valueStart);
                        this._endToken([this._processCarriageReturns(value)]);
                    }
                };
                _Tokenizer.prototype._consumeTagOpenEnd = function () {
                    var tokenType = this._attemptCharCode($SLASH) ? TokenType.TAG_OPEN_END_VOID : TokenType.TAG_OPEN_END;
                    this._beginToken(tokenType);
                    this._requireCharCode($GT);
                    this._endToken([]);
                };
                _Tokenizer.prototype._consumeTagClose = function (start) {
                    this._beginToken(TokenType.TAG_CLOSE, start);
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    var prefixAndName = this._consumePrefixAndName();
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    this._requireCharCode($GT);
                    this._endToken(prefixAndName);
                };
                _Tokenizer.prototype._consumeExpansionFormStart = function () {
                    this._beginToken(TokenType.EXPANSION_FORM_START);
                    this._requireCharCode($LBRACE);
                    this._endToken([]);
                    this._expansionCaseStack.push(TokenType.EXPANSION_FORM_START);
                    this._beginToken(TokenType.RAW_TEXT);
                    var condition = this._readUntil($COMMA);
                    this._endToken([condition]);
                    this._requireCharCode($COMMA);
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    this._beginToken(TokenType.RAW_TEXT);
                    var type = this._readUntil($COMMA);
                    this._endToken([type]);
                    this._requireCharCode($COMMA);
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                };
                _Tokenizer.prototype._consumeExpansionCaseStart = function () {
                    this._beginToken(TokenType.EXPANSION_CASE_VALUE);
                    var value = this._readUntil($LBRACE).trim();
                    this._endToken([value]);
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    this._beginToken(TokenType.EXPANSION_CASE_EXP_START);
                    this._requireCharCode($LBRACE);
                    this._endToken([]);
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    this._expansionCaseStack.push(TokenType.EXPANSION_CASE_EXP_START);
                };
                _Tokenizer.prototype._consumeExpansionCaseEnd = function () {
                    this._beginToken(TokenType.EXPANSION_CASE_EXP_END);
                    this._requireCharCode($RBRACE);
                    this._endToken([]);
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    this._expansionCaseStack.pop();
                };
                _Tokenizer.prototype._consumeExpansionFormEnd = function () {
                    this._beginToken(TokenType.EXPANSION_FORM_END);
                    this._requireCharCode($RBRACE);
                    this._endToken([]);
                    this._expansionCaseStack.pop();
                };
                _Tokenizer.prototype._consumeText = function () {
                    var start = this._cursor.clone();
                    this._beginToken(TokenType.TEXT, start);
                    var parts = [];
                    do {
                        if (this._interpolationConfig && this._attemptStr(this._interpolationConfig.start)) {
                            parts.push(this._interpolationConfig.start);
                            this._inInterpolation = true;
                        }
                        else if (this._interpolationConfig && this._inInterpolation &&
                            this._attemptStr(this._interpolationConfig.end)) {
                            parts.push(this._interpolationConfig.end);
                            this._inInterpolation = false;
                        }
                        else {
                            parts.push(this._readChar(true));
                        }
                    } while (!this._isTextEnd());
                    this._endToken([this._processCarriageReturns(parts.join(''))]);
                };
                _Tokenizer.prototype._isTextEnd = function () {
                    if (this._cursor.peek() === $LT || this._cursor.peek() === $EOF) {
                        return true;
                    }
                    if (this._tokenizeIcu && !this._inInterpolation) {
                        if (this.isExpansionFormStart()) {
                            // start of an expansion form
                            return true;
                        }
                        if (this._cursor.peek() === $RBRACE && this._isInExpansionCase()) {
                            // end of and expansion case
                            return true;
                        }
                    }
                    return false;
                };
                _Tokenizer.prototype._readUntil = function (char) {
                    var start = this._cursor.clone();
                    this._attemptUntilChar(char);
                    return this._cursor.getChars(start);
                };
                _Tokenizer.prototype._isInExpansionCase = function () {
                    return this._expansionCaseStack.length > 0 &&
                        this._expansionCaseStack[this._expansionCaseStack.length - 1] ===
                            TokenType.EXPANSION_CASE_EXP_START;
                };
                _Tokenizer.prototype._isInExpansionForm = function () {
                    return this._expansionCaseStack.length > 0 &&
                        this._expansionCaseStack[this._expansionCaseStack.length - 1] ===
                            TokenType.EXPANSION_FORM_START;
                };
                _Tokenizer.prototype.isExpansionFormStart = function () {
                    if (this._cursor.peek() !== $LBRACE) {
                        return false;
                    }
                    if (this._interpolationConfig) {
                        var start = this._cursor.clone();
                        var isInterpolation = this._attemptStr(this._interpolationConfig.start);
                        this._cursor = start;
                        return !isInterpolation;
                    }
                    return true;
                };
                return _Tokenizer;
            }());
            function isNotWhitespace(code) {
                return !isWhitespace(code) || code === $EOF;
            }
            function isNameEnd(code) {
                return isWhitespace(code) || code === $GT || code === $SLASH ||
                    code === $SQ || code === $DQ || code === $EQ;
            }
            function isPrefixEnd(code) {
                return (code < $a || $z < code) && (code < $A || $Z < code) &&
                    (code < $0 || code > $9);
            }
            function isDigitEntityEnd(code) {
                return code == $SEMICOLON || code == $EOF || !isAsciiHexDigit(code);
            }
            function isNamedEntityEnd(code) {
                return code == $SEMICOLON || code == $EOF || !isAsciiLetter(code);
            }
            function isExpansionCaseStart(peek) {
                return peek === $EQ || isAsciiLetter(peek) || isDigit(peek);
            }
            function compareCharCodeCaseInsensitive(code1, code2) {
                return toUpperCaseCharCode(code1) == toUpperCaseCharCode(code2);
            }
            function toUpperCaseCharCode(code) {
                return code >= $a && code <= $z ? code - $a + $A : code;
            }
            function mergeTextTokens(srcTokens) {
                var dstTokens = [];
                var lastDstToken = undefined;
                for (var i = 0; i < srcTokens.length; i++) {
                    var token = srcTokens[i];
                    if (lastDstToken && lastDstToken.type == TokenType.TEXT && token.type == TokenType.TEXT) {
                        lastDstToken.parts[0] += token.parts[0];
                        lastDstToken.sourceSpan.end = token.sourceSpan.end;
                    }
                    else {
                        lastDstToken = token;
                        dstTokens.push(lastDstToken);
                    }
                }
                return dstTokens;
            }
            var PlainCharacterCursor = /** @class */ (function () {
                function PlainCharacterCursor(fileOrCursor, range) {
                    if (fileOrCursor instanceof PlainCharacterCursor) {
                        this.file = fileOrCursor.file;
                        this.input = fileOrCursor.input;
                        this.end = fileOrCursor.end;
                        this.state = Object.assign({}, fileOrCursor.state);
                    }
                    else {
                        if (!range) {
                            throw new Error('Programming error: the range argument must be provided with a file argument.');
                        }
                        this.file = fileOrCursor;
                        this.input = fileOrCursor.content;
                        this.end = range.endPos;
                        this.state = {
                            peek: -1,
                            offset: range.startPos,
                            line: range.startLine,
                            column: range.startCol,
                        };
                    }
                }
                PlainCharacterCursor.prototype.clone = function () { return new PlainCharacterCursor(this); };
                PlainCharacterCursor.prototype.peek = function () { return this.state.peek; };
                PlainCharacterCursor.prototype.charsLeft = function () { return this.end - this.state.offset; };
                PlainCharacterCursor.prototype.diff = function (other) { return this.state.offset - other.state.offset; };
                PlainCharacterCursor.prototype.advance = function () { this.advanceState(this.state); };
                PlainCharacterCursor.prototype.init = function () { this.updatePeek(this.state); };
                PlainCharacterCursor.prototype.getSpan = function (start, leadingTriviaCodePoints) {
                    start = start || this;
                    if (leadingTriviaCodePoints) {
                        start = start.clone();
                        while (this.diff(start) > 0 && leadingTriviaCodePoints.indexOf(start.peek()) !== -1) {
                            start.advance();
                        }
                    }
                    return new ParseSourceSpan(new ParseLocation(start.file, start.state.offset, start.state.line, start.state.column), new ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
                };
                PlainCharacterCursor.prototype.getChars = function (start) {
                    return this.input.substring(start.state.offset, this.state.offset);
                };
                PlainCharacterCursor.prototype.charAt = function (pos) { return this.input.charCodeAt(pos); };
                PlainCharacterCursor.prototype.advanceState = function (state) {
                    if (state.offset >= this.end) {
                        this.state = state;
                        throw new CursorError('Unexpected character "EOF"', this);
                    }
                    var currentChar = this.charAt(state.offset);
                    if (currentChar === $LF) {
                        state.line++;
                        state.column = 0;
                    }
                    else if (!isNewLine(currentChar)) {
                        state.column++;
                    }
                    state.offset++;
                    this.updatePeek(state);
                };
                PlainCharacterCursor.prototype.updatePeek = function (state) {
                    state.peek = state.offset >= this.end ? $EOF : this.charAt(state.offset);
                };
                return PlainCharacterCursor;
            }());
            var EscapedCharacterCursor = /** @class */ (function (_super_1) {
                __extends(EscapedCharacterCursor, _super_1);
                function EscapedCharacterCursor(fileOrCursor, range) {
                    var _this = this;
                    if (fileOrCursor instanceof EscapedCharacterCursor) {
                        _this = _super_1.call(this, fileOrCursor) || this;
                        _this.internalState = Object.assign({}, fileOrCursor.internalState);
                    }
                    else {
                        _this = _super_1.call(this, fileOrCursor, range) || this;
                        _this.internalState = _this.state;
                    }
                    return _this;
                }
                EscapedCharacterCursor.prototype.advance = function () {
                    this.state = this.internalState;
                    _super_1.prototype.advance.call(this);
                    this.processEscapeSequence();
                };
                EscapedCharacterCursor.prototype.init = function () {
                    _super_1.prototype.init.call(this);
                    this.processEscapeSequence();
                };
                EscapedCharacterCursor.prototype.clone = function () { return new EscapedCharacterCursor(this); };
                EscapedCharacterCursor.prototype.getChars = function (start) {
                    var cursor = start.clone();
                    var chars = '';
                    while (cursor.internalState.offset < this.internalState.offset) {
                        chars += String.fromCodePoint(cursor.peek());
                        cursor.advance();
                    }
                    return chars;
                };
                /**
                 * Process the escape sequence that starts at the current position in the text.
                 *
                 * This method is called to ensure that `peek` has the unescaped value of escape sequences.
                 */
                EscapedCharacterCursor.prototype.processEscapeSequence = function () {
                    var _this = this;
                    var peek = function () { return _this.internalState.peek; };
                    if (peek() === $BACKSLASH) {
                        // We have hit an escape sequence so we need the internal state to become independent
                        // of the external state.
                        this.internalState = Object.assign({}, this.state);
                        // Move past the backslash
                        this.advanceState(this.internalState);
                        // First check for standard control char sequences
                        if (peek() === $n) {
                            this.state.peek = $LF;
                        }
                        else if (peek() === $r) {
                            this.state.peek = $CR;
                        }
                        else if (peek() === $v) {
                            this.state.peek = $VTAB;
                        }
                        else if (peek() === $t) {
                            this.state.peek = $TAB;
                        }
                        else if (peek() === $b) {
                            this.state.peek = $BSPACE;
                        }
                        else if (peek() === $f) {
                            this.state.peek = $FF;
                        }
                        // Now consider more complex sequences
                        else if (peek() === $u) {
                            // Unicode code-point sequence
                            this.advanceState(this.internalState); // advance past the `u` char
                            if (peek() === $LBRACE) {
                                // Variable length Unicode, e.g. `\x{123}`
                                this.advanceState(this.internalState); // advance past the `{` char
                                // Advance past the variable number of hex digits until we hit a `}` char
                                var digitStart = this.clone();
                                var length = 0;
                                while (peek() !== $RBRACE) {
                                    this.advanceState(this.internalState);
                                    length++;
                                }
                                this.state.peek = this.decodeHexDigits(digitStart, length);
                            }
                            else {
                                // Fixed length Unicode, e.g. `\u1234`
                                var digitStart = this.clone();
                                this.advanceState(this.internalState);
                                this.advanceState(this.internalState);
                                this.advanceState(this.internalState);
                                this.state.peek = this.decodeHexDigits(digitStart, 4);
                            }
                        }
                        else if (peek() === $x) {
                            // Hex char code, e.g. `\x2F`
                            this.advanceState(this.internalState); // advance past the `x` char
                            var digitStart = this.clone();
                            this.advanceState(this.internalState);
                            this.state.peek = this.decodeHexDigits(digitStart, 2);
                        }
                        else if (isOctalDigit(peek())) {
                            // Octal char code, e.g. `\012`,
                            var octal = '';
                            var length = 0;
                            var previous = this.clone();
                            while (isOctalDigit(peek()) && length < 3) {
                                previous = this.clone();
                                octal += String.fromCodePoint(peek());
                                this.advanceState(this.internalState);
                                length++;
                            }
                            this.state.peek = parseInt(octal, 8);
                            // Backup one char
                            this.internalState = previous.internalState;
                        }
                        else if (isNewLine(this.internalState.peek)) {
                            // Line continuation `\` followed by a new line
                            this.advanceState(this.internalState); // advance over the newline
                            this.state = this.internalState;
                        }
                        else {
                            // If none of the `if` blocks were executed then we just have an escaped normal character.
                            // In that case we just, effectively, skip the backslash from the character.
                            this.state.peek = this.internalState.peek;
                        }
                    }
                };
                EscapedCharacterCursor.prototype.decodeHexDigits = function (start, length) {
                    var hex = this.input.substr(start.internalState.offset, length);
                    var charCode = parseInt(hex, 16);
                    if (!isNaN(charCode)) {
                        return charCode;
                    }
                    else {
                        start.state = start.internalState;
                        throw new CursorError('Invalid hexadecimal escape sequence', start);
                    }
                };
                return EscapedCharacterCursor;
            }(PlainCharacterCursor));
            var CursorError = /** @class */ (function () {
                function CursorError(msg, cursor) {
                    this.msg = msg;
                    this.cursor = cursor;
                }
                return CursorError;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TreeError = /** @class */ (function (_super_1) {
                __extends(TreeError, _super_1);
                function TreeError(elementName, span, msg) {
                    var _this = _super_1.call(this, span, msg) || this;
                    _this.elementName = elementName;
                    return _this;
                }
                TreeError.create = function (elementName, span, msg) {
                    return new TreeError(elementName, span, msg);
                };
                return TreeError;
            }(ParseError));
            var ParseTreeResult = /** @class */ (function () {
                function ParseTreeResult(rootNodes, errors) {
                    this.rootNodes = rootNodes;
                    this.errors = errors;
                }
                return ParseTreeResult;
            }());
            var Parser = /** @class */ (function () {
                function Parser(getTagDefinition) {
                    this.getTagDefinition = getTagDefinition;
                }
                Parser.prototype.parse = function (source, url, options) {
                    var tokensAndErrors = tokenize(source, url, this.getTagDefinition, options);
                    var treeAndErrors = new _TreeBuilder(tokensAndErrors.tokens, this.getTagDefinition).build();
                    return new ParseTreeResult(treeAndErrors.rootNodes, tokensAndErrors.errors.concat(treeAndErrors.errors));
                };
                return Parser;
            }());
            var _TreeBuilder = /** @class */ (function () {
                function _TreeBuilder(tokens, getTagDefinition) {
                    this.tokens = tokens;
                    this.getTagDefinition = getTagDefinition;
                    this._index = -1;
                    this._rootNodes = [];
                    this._errors = [];
                    this._elementStack = [];
                    this._advance();
                }
                _TreeBuilder.prototype.build = function () {
                    while (this._peek.type !== TokenType.EOF) {
                        if (this._peek.type === TokenType.TAG_OPEN_START) {
                            this._consumeStartTag(this._advance());
                        }
                        else if (this._peek.type === TokenType.TAG_CLOSE) {
                            this._consumeEndTag(this._advance());
                        }
                        else if (this._peek.type === TokenType.CDATA_START) {
                            this._closeVoidElement();
                            this._consumeCdata(this._advance());
                        }
                        else if (this._peek.type === TokenType.COMMENT_START) {
                            this._closeVoidElement();
                            this._consumeComment(this._advance());
                        }
                        else if (this._peek.type === TokenType.TEXT || this._peek.type === TokenType.RAW_TEXT ||
                            this._peek.type === TokenType.ESCAPABLE_RAW_TEXT) {
                            this._closeVoidElement();
                            this._consumeText(this._advance());
                        }
                        else if (this._peek.type === TokenType.EXPANSION_FORM_START) {
                            this._consumeExpansion(this._advance());
                        }
                        else {
                            // Skip all other tokens...
                            this._advance();
                        }
                    }
                    return new ParseTreeResult(this._rootNodes, this._errors);
                };
                _TreeBuilder.prototype._advance = function () {
                    var prev = this._peek;
                    if (this._index < this.tokens.length - 1) {
                        // Note: there is always an EOF token at the end
                        this._index++;
                    }
                    this._peek = this.tokens[this._index];
                    return prev;
                };
                _TreeBuilder.prototype._advanceIf = function (type) {
                    if (this._peek.type === type) {
                        return this._advance();
                    }
                    return null;
                };
                _TreeBuilder.prototype._consumeCdata = function (startToken) {
                    this._consumeText(this._advance());
                    this._advanceIf(TokenType.CDATA_END);
                };
                _TreeBuilder.prototype._consumeComment = function (token) {
                    var text = this._advanceIf(TokenType.RAW_TEXT);
                    this._advanceIf(TokenType.COMMENT_END);
                    var value = text != null ? text.parts[0].trim() : null;
                    this._addToParent(new Comment(value, token.sourceSpan));
                };
                _TreeBuilder.prototype._consumeExpansion = function (token) {
                    var switchValue = this._advance();
                    var type = this._advance();
                    var cases = [];
                    // read =
                    while (this._peek.type === TokenType.EXPANSION_CASE_VALUE) {
                        var expCase = this._parseExpansionCase();
                        if (!expCase)
                            return; // error
                        cases.push(expCase);
                    }
                    // read the final }
                    if (this._peek.type !== TokenType.EXPANSION_FORM_END) {
                        this._errors.push(TreeError.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
                        return;
                    }
                    var sourceSpan = new ParseSourceSpan(token.sourceSpan.start, this._peek.sourceSpan.end);
                    this._addToParent(new Expansion(switchValue.parts[0], type.parts[0], cases, sourceSpan, switchValue.sourceSpan));
                    this._advance();
                };
                _TreeBuilder.prototype._parseExpansionCase = function () {
                    var value = this._advance();
                    // read {
                    if (this._peek.type !== TokenType.EXPANSION_CASE_EXP_START) {
                        this._errors.push(TreeError.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'."));
                        return null;
                    }
                    // read until }
                    var start = this._advance();
                    var exp = this._collectExpansionExpTokens(start);
                    if (!exp)
                        return null;
                    var end = this._advance();
                    exp.push(new Token(TokenType.EOF, [], end.sourceSpan));
                    // parse everything in between { and }
                    var parsedExp = new _TreeBuilder(exp, this.getTagDefinition).build();
                    if (parsedExp.errors.length > 0) {
                        this._errors = this._errors.concat(parsedExp.errors);
                        return null;
                    }
                    var sourceSpan = new ParseSourceSpan(value.sourceSpan.start, end.sourceSpan.end);
                    var expSourceSpan = new ParseSourceSpan(start.sourceSpan.start, end.sourceSpan.end);
                    return new ExpansionCase(value.parts[0], parsedExp.rootNodes, sourceSpan, value.sourceSpan, expSourceSpan);
                };
                _TreeBuilder.prototype._collectExpansionExpTokens = function (start) {
                    var exp = [];
                    var expansionFormStack = [TokenType.EXPANSION_CASE_EXP_START];
                    while (true) {
                        if (this._peek.type === TokenType.EXPANSION_FORM_START ||
                            this._peek.type === TokenType.EXPANSION_CASE_EXP_START) {
                            expansionFormStack.push(this._peek.type);
                        }
                        if (this._peek.type === TokenType.EXPANSION_CASE_EXP_END) {
                            if (lastOnStack(expansionFormStack, TokenType.EXPANSION_CASE_EXP_START)) {
                                expansionFormStack.pop();
                                if (expansionFormStack.length == 0)
                                    return exp;
                            }
                            else {
                                this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
                                return null;
                            }
                        }
                        if (this._peek.type === TokenType.EXPANSION_FORM_END) {
                            if (lastOnStack(expansionFormStack, TokenType.EXPANSION_FORM_START)) {
                                expansionFormStack.pop();
                            }
                            else {
                                this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
                                return null;
                            }
                        }
                        if (this._peek.type === TokenType.EOF) {
                            this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
                            return null;
                        }
                        exp.push(this._advance());
                    }
                };
                _TreeBuilder.prototype._consumeText = function (token) {
                    var text = token.parts[0];
                    if (text.length > 0 && text[0] == '\n') {
                        var parent = this._getParentElement();
                        if (parent != null && parent.children.length == 0 &&
                            this.getTagDefinition(parent.name).ignoreFirstLf) {
                            text = text.substring(1);
                        }
                    }
                    if (text.length > 0) {
                        this._addToParent(new Text$3(text, token.sourceSpan));
                    }
                };
                _TreeBuilder.prototype._closeVoidElement = function () {
                    var el = this._getParentElement();
                    if (el && this.getTagDefinition(el.name).isVoid) {
                        this._elementStack.pop();
                    }
                };
                _TreeBuilder.prototype._consumeStartTag = function (startTagToken) {
                    var prefix = startTagToken.parts[0];
                    var name = startTagToken.parts[1];
                    var attrs = [];
                    while (this._peek.type === TokenType.ATTR_NAME) {
                        attrs.push(this._consumeAttr(this._advance()));
                    }
                    var fullName = this._getElementFullName(prefix, name, this._getParentElement());
                    var selfClosing = false;
                    // Note: There could have been a tokenizer error
                    // so that we don't get a token for the end tag...
                    if (this._peek.type === TokenType.TAG_OPEN_END_VOID) {
                        this._advance();
                        selfClosing = true;
                        var tagDef = this.getTagDefinition(fullName);
                        if (!(tagDef.canSelfClose || getNsPrefix(fullName) !== null || tagDef.isVoid)) {
                            this._errors.push(TreeError.create(fullName, startTagToken.sourceSpan, "Only void and foreign elements can be self closed \"" + startTagToken.parts[1] + "\""));
                        }
                    }
                    else if (this._peek.type === TokenType.TAG_OPEN_END) {
                        this._advance();
                        selfClosing = false;
                    }
                    var end = this._peek.sourceSpan.start;
                    var span = new ParseSourceSpan(startTagToken.sourceSpan.start, end);
                    var el = new Element$1(fullName, attrs, [], span, span, undefined);
                    this._pushElement(el);
                    if (selfClosing) {
                        this._popElement(fullName);
                        el.endSourceSpan = span;
                    }
                };
                _TreeBuilder.prototype._pushElement = function (el) {
                    var parentEl = this._getParentElement();
                    if (parentEl && this.getTagDefinition(parentEl.name).isClosedByChild(el.name)) {
                        this._elementStack.pop();
                    }
                    this._addToParent(el);
                    this._elementStack.push(el);
                };
                _TreeBuilder.prototype._consumeEndTag = function (endTagToken) {
                    var fullName = this._getElementFullName(endTagToken.parts[0], endTagToken.parts[1], this._getParentElement());
                    if (this._getParentElement()) {
                        this._getParentElement().endSourceSpan = endTagToken.sourceSpan;
                    }
                    if (this.getTagDefinition(fullName).isVoid) {
                        this._errors.push(TreeError.create(fullName, endTagToken.sourceSpan, "Void elements do not have end tags \"" + endTagToken.parts[1] + "\""));
                    }
                    else if (!this._popElement(fullName)) {
                        var errMsg = "Unexpected closing tag \"" + fullName + "\". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags";
                        this._errors.push(TreeError.create(fullName, endTagToken.sourceSpan, errMsg));
                    }
                };
                _TreeBuilder.prototype._popElement = function (fullName) {
                    for (var stackIndex = this._elementStack.length - 1; stackIndex >= 0; stackIndex--) {
                        var el = this._elementStack[stackIndex];
                        if (el.name == fullName) {
                            this._elementStack.splice(stackIndex, this._elementStack.length - stackIndex);
                            return true;
                        }
                        if (!this.getTagDefinition(el.name).closedByParent) {
                            return false;
                        }
                    }
                    return false;
                };
                _TreeBuilder.prototype._consumeAttr = function (attrName) {
                    var fullName = mergeNsAndName(attrName.parts[0], attrName.parts[1]);
                    var end = attrName.sourceSpan.end;
                    var value = '';
                    var valueSpan = undefined;
                    if (this._peek.type === TokenType.ATTR_QUOTE) {
                        this._advance();
                    }
                    if (this._peek.type === TokenType.ATTR_VALUE) {
                        var valueToken = this._advance();
                        value = valueToken.parts[0];
                        end = valueToken.sourceSpan.end;
                        valueSpan = valueToken.sourceSpan;
                    }
                    if (this._peek.type === TokenType.ATTR_QUOTE) {
                        var quoteToken = this._advance();
                        end = quoteToken.sourceSpan.end;
                    }
                    return new Attribute(fullName, value, new ParseSourceSpan(attrName.sourceSpan.start, end), valueSpan);
                };
                _TreeBuilder.prototype._getParentElement = function () {
                    return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
                };
                /**
                 * Returns the parent in the DOM and the container.
                 *
                 * `<ng-container>` elements are skipped as they are not rendered as DOM element.
                 */
                _TreeBuilder.prototype._getParentElementSkippingContainers = function () {
                    var container = null;
                    for (var i = this._elementStack.length - 1; i >= 0; i--) {
                        if (!isNgContainer(this._elementStack[i].name)) {
                            return { parent: this._elementStack[i], container: container };
                        }
                        container = this._elementStack[i];
                    }
                    return { parent: null, container: container };
                };
                _TreeBuilder.prototype._addToParent = function (node) {
                    var parent = this._getParentElement();
                    if (parent != null) {
                        parent.children.push(node);
                    }
                    else {
                        this._rootNodes.push(node);
                    }
                };
                /**
                 * Insert a node between the parent and the container.
                 * When no container is given, the node is appended as a child of the parent.
                 * Also updates the element stack accordingly.
                 *
                 * @internal
                 */
                _TreeBuilder.prototype._insertBeforeContainer = function (parent, container, node) {
                    if (!container) {
                        this._addToParent(node);
                        this._elementStack.push(node);
                    }
                    else {
                        if (parent) {
                            // replace the container with the new node in the children
                            var index = parent.children.indexOf(container);
                            parent.children[index] = node;
                        }
                        else {
                            this._rootNodes.push(node);
                        }
                        node.children.push(container);
                        this._elementStack.splice(this._elementStack.indexOf(container), 0, node);
                    }
                };
                _TreeBuilder.prototype._getElementFullName = function (prefix, localName, parentElement) {
                    if (prefix === '') {
                        prefix = this.getTagDefinition(localName).implicitNamespacePrefix || '';
                        if (prefix === '' && parentElement != null) {
                            prefix = getNsPrefix(parentElement.name);
                        }
                    }
                    return mergeNsAndName(prefix, localName);
                };
                return _TreeBuilder;
            }());
            function lastOnStack(stack, element) {
                return stack.length > 0 && stack[stack.length - 1] === element;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var HtmlParser = /** @class */ (function (_super_1) {
                __extends(HtmlParser, _super_1);
                function HtmlParser() {
                    return _super_1.call(this, getHtmlTagDefinition) || this;
                }
                HtmlParser.prototype.parse = function (source, url, options) {
                    return _super_1.prototype.parse.call(this, source, url, options);
                };
                return HtmlParser;
            }(Parser));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var PRESERVE_WS_ATTR_NAME = 'ngPreserveWhitespaces';
            var SKIP_WS_TRIM_TAGS = new Set(['pre', 'template', 'textarea', 'script', 'style']);
            // Equivalent to \s with \u00a0 (non-breaking space) excluded.
            // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp
            var WS_CHARS = ' \f\n\r\t\v\u1680\u180e\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff';
            var NO_WS_REGEXP = new RegExp("[^" + WS_CHARS + "]");
            var WS_REPLACE_REGEXP = new RegExp("[" + WS_CHARS + "]{2,}", 'g');
            function hasPreserveWhitespacesAttr(attrs) {
                return attrs.some(function (attr) { return attr.name === PRESERVE_WS_ATTR_NAME; });
            }
            /**
             * Angular Dart introduced &ngsp; as a placeholder for non-removable space, see:
             * https://github.com/dart-lang/angular/blob/0bb611387d29d65b5af7f9d2515ab571fd3fbee4/_tests/test/compiler/preserve_whitespace_test.dart#L25-L32
             * In Angular Dart &ngsp; is converted to the 0xE500 PUA (Private Use Areas) unicode character
             * and later on replaced by a space. We are re-implementing the same idea here.
             */
            function replaceNgsp(value) {
                // lexer is replacing the &ngsp; pseudo-entity with NGSP_UNICODE
                return value.replace(new RegExp(NGSP_UNICODE, 'g'), ' ');
            }
            /**
             * This visitor can walk HTML parse tree and remove / trim text nodes using the following rules:
             * - consider spaces, tabs and new lines as whitespace characters;
             * - drop text nodes consisting of whitespace characters only;
             * - for all other text nodes replace consecutive whitespace characters with one space;
             * - convert &ngsp; pseudo-entity to a single space;
             *
             * Removal and trimming of whitespaces have positive performance impact (less code to generate
             * while compiling templates, faster view creation). At the same time it can be "destructive"
             * in some cases (whitespaces can influence layout). Because of the potential of breaking layout
             * this visitor is not activated by default in Angular 5 and people need to explicitly opt-in for
             * whitespace removal. The default option for whitespace removal will be revisited in Angular 6
             * and might be changed to "on" by default.
             */
            var WhitespaceVisitor = /** @class */ (function () {
                function WhitespaceVisitor() {
                }
                WhitespaceVisitor.prototype.visitElement = function (element, context) {
                    if (SKIP_WS_TRIM_TAGS.has(element.name) || hasPreserveWhitespacesAttr(element.attrs)) {
                        // don't descent into elements where we need to preserve whitespaces
                        // but still visit all attributes to eliminate one used as a market to preserve WS
                        return new Element$1(element.name, visitAll$1(this, element.attrs), element.children, element.sourceSpan, element.startSourceSpan, element.endSourceSpan, element.i18n);
                    }
                    return new Element$1(element.name, element.attrs, visitAll$1(this, element.children), element.sourceSpan, element.startSourceSpan, element.endSourceSpan, element.i18n);
                };
                WhitespaceVisitor.prototype.visitAttribute = function (attribute, context) {
                    return attribute.name !== PRESERVE_WS_ATTR_NAME ? attribute : null;
                };
                WhitespaceVisitor.prototype.visitText = function (text, context) {
                    var isNotBlank = text.value.match(NO_WS_REGEXP);
                    if (isNotBlank) {
                        return new Text$3(replaceNgsp(text.value).replace(WS_REPLACE_REGEXP, ' '), text.sourceSpan, text.i18n);
                    }
                    return null;
                };
                WhitespaceVisitor.prototype.visitComment = function (comment, context) { return comment; };
                WhitespaceVisitor.prototype.visitExpansion = function (expansion, context) { return expansion; };
                WhitespaceVisitor.prototype.visitExpansionCase = function (expansionCase, context) { return expansionCase; };
                return WhitespaceVisitor;
            }());
            function removeWhitespaces(htmlAstWithErrors) {
                return new ParseTreeResult(visitAll$1(new WhitespaceVisitor(), htmlAstWithErrors.rootNodes), htmlAstWithErrors.errors);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // http://cldr.unicode.org/index/cldr-spec/plural-rules
            var PLURAL_CASES = ['zero', 'one', 'two', 'few', 'many', 'other'];
            /**
             * Expands special forms into elements.
             *
             * For example,
             *
             * ```
             * { messages.length, plural,
             *   =0 {zero}
             *   =1 {one}
             *   other {more than one}
             * }
             * ```
             *
             * will be expanded into
             *
             * ```
             * <ng-container [ngPlural]="messages.length">
             *   <ng-template ngPluralCase="=0">zero</ng-template>
             *   <ng-template ngPluralCase="=1">one</ng-template>
             *   <ng-template ngPluralCase="other">more than one</ng-template>
             * </ng-container>
             * ```
             */
            function expandNodes(nodes) {
                var expander = new _Expander();
                return new ExpansionResult(visitAll$1(expander, nodes), expander.isExpanded, expander.errors);
            }
            var ExpansionResult = /** @class */ (function () {
                function ExpansionResult(nodes, expanded, errors) {
                    this.nodes = nodes;
                    this.expanded = expanded;
                    this.errors = errors;
                }
                return ExpansionResult;
            }());
            var ExpansionError = /** @class */ (function (_super_1) {
                __extends(ExpansionError, _super_1);
                function ExpansionError(span, errorMsg) {
                    return _super_1.call(this, span, errorMsg) || this;
                }
                return ExpansionError;
            }(ParseError));
            /**
             * Expand expansion forms (plural, select) to directives
             *
             * @internal
             */
            var _Expander = /** @class */ (function () {
                function _Expander() {
                    this.isExpanded = false;
                    this.errors = [];
                }
                _Expander.prototype.visitElement = function (element, context) {
                    return new Element$1(element.name, element.attrs, visitAll$1(this, element.children), element.sourceSpan, element.startSourceSpan, element.endSourceSpan);
                };
                _Expander.prototype.visitAttribute = function (attribute, context) { return attribute; };
                _Expander.prototype.visitText = function (text, context) { return text; };
                _Expander.prototype.visitComment = function (comment, context) { return comment; };
                _Expander.prototype.visitExpansion = function (icu, context) {
                    this.isExpanded = true;
                    return icu.type == 'plural' ? _expandPluralForm(icu, this.errors) :
                        _expandDefaultForm(icu, this.errors);
                };
                _Expander.prototype.visitExpansionCase = function (icuCase, context) {
                    throw new Error('Should not be reached');
                };
                return _Expander;
            }());
            // Plural forms are expanded to `NgPlural` and `NgPluralCase`s
            function _expandPluralForm(ast, errors) {
                var children = ast.cases.map(function (c) {
                    if (PLURAL_CASES.indexOf(c.value) == -1 && !c.value.match(/^=\d+$/)) {
                        errors.push(new ExpansionError(c.valueSourceSpan, "Plural cases should be \"=<number>\" or one of " + PLURAL_CASES.join(", ")));
                    }
                    var expansionResult = expandNodes(c.expression);
                    errors.push.apply(errors, expansionResult.errors);
                    return new Element$1("ng-template", [new Attribute('ngPluralCase', "" + c.value, c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
                });
                var switchAttr = new Attribute('[ngPlural]', ast.switchValue, ast.switchValueSourceSpan);
                return new Element$1('ng-container', [switchAttr], children, ast.sourceSpan, ast.sourceSpan, ast.sourceSpan);
            }
            // ICU messages (excluding plural form) are expanded to `NgSwitch`  and `NgSwitchCase`s
            function _expandDefaultForm(ast, errors) {
                var children = ast.cases.map(function (c) {
                    var expansionResult = expandNodes(c.expression);
                    errors.push.apply(errors, expansionResult.errors);
                    if (c.value === 'other') {
                        // other is the default case when no values match
                        return new Element$1("ng-template", [new Attribute('ngSwitchDefault', '', c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
                    }
                    return new Element$1("ng-template", [new Attribute('ngSwitchCase', "" + c.value, c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
                });
                var switchAttr = new Attribute('[ngSwitch]', ast.switchValue, ast.switchValueSourceSpan);
                return new Element$1('ng-container', [switchAttr], children, ast.sourceSpan, ast.sourceSpan, ast.sourceSpan);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A segment of text within the template.
             */
            var TextAst = /** @class */ (function () {
                function TextAst(value, ngContentIndex, sourceSpan) {
                    this.value = value;
                    this.ngContentIndex = ngContentIndex;
                    this.sourceSpan = sourceSpan;
                }
                TextAst.prototype.visit = function (visitor, context) { return visitor.visitText(this, context); };
                return TextAst;
            }());
            /**
             * A bound expression within the text of a template.
             */
            var BoundTextAst = /** @class */ (function () {
                function BoundTextAst(value, ngContentIndex, sourceSpan) {
                    this.value = value;
                    this.ngContentIndex = ngContentIndex;
                    this.sourceSpan = sourceSpan;
                }
                BoundTextAst.prototype.visit = function (visitor, context) {
                    return visitor.visitBoundText(this, context);
                };
                return BoundTextAst;
            }());
            /**
             * A plain attribute on an element.
             */
            var AttrAst = /** @class */ (function () {
                function AttrAst(name, value, sourceSpan) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                AttrAst.prototype.visit = function (visitor, context) { return visitor.visitAttr(this, context); };
                return AttrAst;
            }());
            var BoundPropertyMapping = (_c = {},
                _c[4 /* Animation */] = 4 /* Animation */,
                _c[1 /* Attribute */] = 1 /* Attribute */,
                _c[2 /* Class */] = 2 /* Class */,
                _c[0 /* Property */] = 0 /* Property */,
                _c[3 /* Style */] = 3 /* Style */,
                _c);
            /**
             * A binding for an element property (e.g. `[property]="expression"`) or an animation trigger (e.g.
             * `[@trigger]="stateExp"`)
             */
            var BoundElementPropertyAst = /** @class */ (function () {
                function BoundElementPropertyAst(name, type, securityContext, value, unit, sourceSpan) {
                    this.name = name;
                    this.type = type;
                    this.securityContext = securityContext;
                    this.value = value;
                    this.unit = unit;
                    this.sourceSpan = sourceSpan;
                    this.isAnimation = this.type === 4 /* Animation */;
                }
                BoundElementPropertyAst.fromBoundProperty = function (prop) {
                    var type = BoundPropertyMapping[prop.type];
                    return new BoundElementPropertyAst(prop.name, type, prop.securityContext, prop.value, prop.unit, prop.sourceSpan);
                };
                BoundElementPropertyAst.prototype.visit = function (visitor, context) {
                    return visitor.visitElementProperty(this, context);
                };
                return BoundElementPropertyAst;
            }());
            /**
             * A binding for an element event (e.g. `(event)="handler()"`) or an animation trigger event (e.g.
             * `(@trigger.phase)="callback($event)"`).
             */
            var BoundEventAst = /** @class */ (function () {
                function BoundEventAst(name, target, phase, handler, sourceSpan, handlerSpan) {
                    this.name = name;
                    this.target = target;
                    this.phase = phase;
                    this.handler = handler;
                    this.sourceSpan = sourceSpan;
                    this.handlerSpan = handlerSpan;
                    this.fullName = BoundEventAst.calcFullName(this.name, this.target, this.phase);
                    this.isAnimation = !!this.phase;
                }
                BoundEventAst.calcFullName = function (name, target, phase) {
                    if (target) {
                        return target + ":" + name;
                    }
                    if (phase) {
                        return "@" + name + "." + phase;
                    }
                    return name;
                };
                BoundEventAst.fromParsedEvent = function (event) {
                    var target = event.type === 0 /* Regular */ ? event.targetOrPhase : null;
                    var phase = event.type === 1 /* Animation */ ? event.targetOrPhase : null;
                    return new BoundEventAst(event.name, target, phase, event.handler, event.sourceSpan, event.handlerSpan);
                };
                BoundEventAst.prototype.visit = function (visitor, context) {
                    return visitor.visitEvent(this, context);
                };
                return BoundEventAst;
            }());
            /**
             * A reference declaration on an element (e.g. `let someName="expression"`).
             */
            var ReferenceAst = /** @class */ (function () {
                function ReferenceAst(name, value, originalValue, sourceSpan) {
                    this.name = name;
                    this.value = value;
                    this.originalValue = originalValue;
                    this.sourceSpan = sourceSpan;
                }
                ReferenceAst.prototype.visit = function (visitor, context) {
                    return visitor.visitReference(this, context);
                };
                return ReferenceAst;
            }());
            /**
             * A variable declaration on a <ng-template> (e.g. `var-someName="someLocalName"`).
             */
            var VariableAst = /** @class */ (function () {
                function VariableAst(name, value, sourceSpan) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                VariableAst.fromParsedVariable = function (v) {
                    return new VariableAst(v.name, v.value, v.sourceSpan);
                };
                VariableAst.prototype.visit = function (visitor, context) {
                    return visitor.visitVariable(this, context);
                };
                return VariableAst;
            }());
            /**
             * An element declaration in a template.
             */
            var ElementAst = /** @class */ (function () {
                function ElementAst(name, attrs, inputs, outputs, references, directives, providers, hasViewContainer, queryMatches, children, ngContentIndex, sourceSpan, endSourceSpan) {
                    this.name = name;
                    this.attrs = attrs;
                    this.inputs = inputs;
                    this.outputs = outputs;
                    this.references = references;
                    this.directives = directives;
                    this.providers = providers;
                    this.hasViewContainer = hasViewContainer;
                    this.queryMatches = queryMatches;
                    this.children = children;
                    this.ngContentIndex = ngContentIndex;
                    this.sourceSpan = sourceSpan;
                    this.endSourceSpan = endSourceSpan;
                }
                ElementAst.prototype.visit = function (visitor, context) {
                    return visitor.visitElement(this, context);
                };
                return ElementAst;
            }());
            /**
             * A `<ng-template>` element included in an Angular template.
             */
            var EmbeddedTemplateAst = /** @class */ (function () {
                function EmbeddedTemplateAst(attrs, outputs, references, variables, directives, providers, hasViewContainer, queryMatches, children, ngContentIndex, sourceSpan) {
                    this.attrs = attrs;
                    this.outputs = outputs;
                    this.references = references;
                    this.variables = variables;
                    this.directives = directives;
                    this.providers = providers;
                    this.hasViewContainer = hasViewContainer;
                    this.queryMatches = queryMatches;
                    this.children = children;
                    this.ngContentIndex = ngContentIndex;
                    this.sourceSpan = sourceSpan;
                }
                EmbeddedTemplateAst.prototype.visit = function (visitor, context) {
                    return visitor.visitEmbeddedTemplate(this, context);
                };
                return EmbeddedTemplateAst;
            }());
            /**
             * A directive property with a bound value (e.g. `*ngIf="condition").
             */
            var BoundDirectivePropertyAst = /** @class */ (function () {
                function BoundDirectivePropertyAst(directiveName, templateName, value, sourceSpan) {
                    this.directiveName = directiveName;
                    this.templateName = templateName;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                BoundDirectivePropertyAst.prototype.visit = function (visitor, context) {
                    return visitor.visitDirectiveProperty(this, context);
                };
                return BoundDirectivePropertyAst;
            }());
            /**
             * A directive declared on an element.
             */
            var DirectiveAst = /** @class */ (function () {
                function DirectiveAst(directive, inputs, hostProperties, hostEvents, contentQueryStartId, sourceSpan) {
                    this.directive = directive;
                    this.inputs = inputs;
                    this.hostProperties = hostProperties;
                    this.hostEvents = hostEvents;
                    this.contentQueryStartId = contentQueryStartId;
                    this.sourceSpan = sourceSpan;
                }
                DirectiveAst.prototype.visit = function (visitor, context) {
                    return visitor.visitDirective(this, context);
                };
                return DirectiveAst;
            }());
            /**
             * A provider declared on an element
             */
            var ProviderAst = /** @class */ (function () {
                function ProviderAst(token, multiProvider, eager, providers, providerType, lifecycleHooks, sourceSpan, isModule) {
                    this.token = token;
                    this.multiProvider = multiProvider;
                    this.eager = eager;
                    this.providers = providers;
                    this.providerType = providerType;
                    this.lifecycleHooks = lifecycleHooks;
                    this.sourceSpan = sourceSpan;
                    this.isModule = isModule;
                }
                ProviderAst.prototype.visit = function (visitor, context) {
                    // No visit method in the visitor for now...
                    return null;
                };
                return ProviderAst;
            }());
            var ProviderAstType;
            (function (ProviderAstType) {
                ProviderAstType[ProviderAstType["PublicService"] = 0] = "PublicService";
                ProviderAstType[ProviderAstType["PrivateService"] = 1] = "PrivateService";
                ProviderAstType[ProviderAstType["Component"] = 2] = "Component";
                ProviderAstType[ProviderAstType["Directive"] = 3] = "Directive";
                ProviderAstType[ProviderAstType["Builtin"] = 4] = "Builtin";
            })(ProviderAstType || (ProviderAstType = {}));
            /**
             * Position where content is to be projected (instance of `<ng-content>` in a template).
             */
            var NgContentAst = /** @class */ (function () {
                function NgContentAst(index, ngContentIndex, sourceSpan) {
                    this.index = index;
                    this.ngContentIndex = ngContentIndex;
                    this.sourceSpan = sourceSpan;
                }
                NgContentAst.prototype.visit = function (visitor, context) {
                    return visitor.visitNgContent(this, context);
                };
                return NgContentAst;
            }());
            /**
             * A visitor that accepts each node but doesn't do anything. It is intended to be used
             * as the base class for a visitor that is only interested in a subset of the node types.
             */
            var NullTemplateVisitor = /** @class */ (function () {
                function NullTemplateVisitor() {
                }
                NullTemplateVisitor.prototype.visitNgContent = function (ast, context) { };
                NullTemplateVisitor.prototype.visitEmbeddedTemplate = function (ast, context) { };
                NullTemplateVisitor.prototype.visitElement = function (ast, context) { };
                NullTemplateVisitor.prototype.visitReference = function (ast, context) { };
                NullTemplateVisitor.prototype.visitVariable = function (ast, context) { };
                NullTemplateVisitor.prototype.visitEvent = function (ast, context) { };
                NullTemplateVisitor.prototype.visitElementProperty = function (ast, context) { };
                NullTemplateVisitor.prototype.visitAttr = function (ast, context) { };
                NullTemplateVisitor.prototype.visitBoundText = function (ast, context) { };
                NullTemplateVisitor.prototype.visitText = function (ast, context) { };
                NullTemplateVisitor.prototype.visitDirective = function (ast, context) { };
                NullTemplateVisitor.prototype.visitDirectiveProperty = function (ast, context) { };
                return NullTemplateVisitor;
            }());
            /**
             * Base class that can be used to build a visitor that visits each node
             * in an template ast recursively.
             */
            var RecursiveTemplateAstVisitor = /** @class */ (function (_super_1) {
                __extends(RecursiveTemplateAstVisitor, _super_1);
                function RecursiveTemplateAstVisitor() {
                    return _super_1.call(this) || this;
                }
                // Nodes with children
                RecursiveTemplateAstVisitor.prototype.visitEmbeddedTemplate = function (ast, context) {
                    return this.visitChildren(context, function (visit) {
                        visit(ast.attrs);
                        visit(ast.references);
                        visit(ast.variables);
                        visit(ast.directives);
                        visit(ast.providers);
                        visit(ast.children);
                    });
                };
                RecursiveTemplateAstVisitor.prototype.visitElement = function (ast, context) {
                    return this.visitChildren(context, function (visit) {
                        visit(ast.attrs);
                        visit(ast.inputs);
                        visit(ast.outputs);
                        visit(ast.references);
                        visit(ast.directives);
                        visit(ast.providers);
                        visit(ast.children);
                    });
                };
                RecursiveTemplateAstVisitor.prototype.visitDirective = function (ast, context) {
                    return this.visitChildren(context, function (visit) {
                        visit(ast.inputs);
                        visit(ast.hostProperties);
                        visit(ast.hostEvents);
                    });
                };
                RecursiveTemplateAstVisitor.prototype.visitChildren = function (context, cb) {
                    var results = [];
                    var t = this;
                    function visit(children) {
                        if (children && children.length)
                            results.push(templateVisitAll(t, children, context));
                    }
                    cb(visit);
                    return Array.prototype.concat.apply([], results);
                };
                return RecursiveTemplateAstVisitor;
            }(NullTemplateVisitor));
            /**
             * Visit every node in a list of {@link TemplateAst}s with the given {@link TemplateAstVisitor}.
             */
            function templateVisitAll(visitor, asts, context) {
                if (context === void 0) { context = null; }
                var result = [];
                var visit = visitor.visit ?
                    function (ast) { return visitor.visit(ast, context) || ast.visit(visitor, context); } :
                    function (ast) { return ast.visit(visitor, context); };
                asts.forEach(function (ast) {
                    var astResult = visit(ast);
                    if (astResult) {
                        result.push(astResult);
                    }
                });
                return result;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ProviderError = /** @class */ (function (_super_1) {
                __extends(ProviderError, _super_1);
                function ProviderError(message, span) {
                    return _super_1.call(this, span, message) || this;
                }
                return ProviderError;
            }(ParseError));
            var ProviderViewContext = /** @class */ (function () {
                function ProviderViewContext(reflector, component) {
                    var _this = this;
                    this.reflector = reflector;
                    this.component = component;
                    this.errors = [];
                    this.viewQueries = _getViewQueries(component);
                    this.viewProviders = new Map();
                    component.viewProviders.forEach(function (provider) {
                        if (_this.viewProviders.get(tokenReference(provider.token)) == null) {
                            _this.viewProviders.set(tokenReference(provider.token), true);
                        }
                    });
                }
                return ProviderViewContext;
            }());
            var ProviderElementContext = /** @class */ (function () {
                function ProviderElementContext(viewContext, _parent, _isViewRoot, _directiveAsts, attrs, refs, isTemplate, contentQueryStartId, _sourceSpan) {
                    var _this = this;
                    this.viewContext = viewContext;
                    this._parent = _parent;
                    this._isViewRoot = _isViewRoot;
                    this._directiveAsts = _directiveAsts;
                    this._sourceSpan = _sourceSpan;
                    this._transformedProviders = new Map();
                    this._seenProviders = new Map();
                    this._queriedTokens = new Map();
                    this.transformedHasViewContainer = false;
                    this._attrs = {};
                    attrs.forEach(function (attrAst) { return _this._attrs[attrAst.name] = attrAst.value; });
                    var directivesMeta = _directiveAsts.map(function (directiveAst) { return directiveAst.directive; });
                    this._allProviders =
                        _resolveProvidersFromDirectives(directivesMeta, _sourceSpan, viewContext.errors);
                    this._contentQueries = _getContentQueries(contentQueryStartId, directivesMeta);
                    Array.from(this._allProviders.values()).forEach(function (provider) {
                        _this._addQueryReadsTo(provider.token, provider.token, _this._queriedTokens);
                    });
                    if (isTemplate) {
                        var templateRefId = createTokenForExternalReference(this.viewContext.reflector, Identifiers.TemplateRef);
                        this._addQueryReadsTo(templateRefId, templateRefId, this._queriedTokens);
                    }
                    refs.forEach(function (refAst) {
                        var defaultQueryValue = refAst.value ||
                            createTokenForExternalReference(_this.viewContext.reflector, Identifiers.ElementRef);
                        _this._addQueryReadsTo({ value: refAst.name }, defaultQueryValue, _this._queriedTokens);
                    });
                    if (this._queriedTokens.get(this.viewContext.reflector.resolveExternalReference(Identifiers.ViewContainerRef))) {
                        this.transformedHasViewContainer = true;
                    }
                    // create the providers that we know are eager first
                    Array.from(this._allProviders.values()).forEach(function (provider) {
                        var eager = provider.eager || _this._queriedTokens.get(tokenReference(provider.token));
                        if (eager) {
                            _this._getOrCreateLocalProvider(provider.providerType, provider.token, true);
                        }
                    });
                }
                ProviderElementContext.prototype.afterElement = function () {
                    var _this = this;
                    // collect lazy providers
                    Array.from(this._allProviders.values()).forEach(function (provider) {
                        _this._getOrCreateLocalProvider(provider.providerType, provider.token, false);
                    });
                };
                Object.defineProperty(ProviderElementContext.prototype, "transformProviders", {
                    get: function () {
                        // Note: Maps keep their insertion order.
                        var lazyProviders = [];
                        var eagerProviders = [];
                        this._transformedProviders.forEach(function (provider) {
                            if (provider.eager) {
                                eagerProviders.push(provider);
                            }
                            else {
                                lazyProviders.push(provider);
                            }
                        });
                        return lazyProviders.concat(eagerProviders);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ProviderElementContext.prototype, "transformedDirectiveAsts", {
                    get: function () {
                        var sortedProviderTypes = this.transformProviders.map(function (provider) { return provider.token.identifier; });
                        var sortedDirectives = this._directiveAsts.slice();
                        sortedDirectives.sort(function (dir1, dir2) { return sortedProviderTypes.indexOf(dir1.directive.type) -
                            sortedProviderTypes.indexOf(dir2.directive.type); });
                        return sortedDirectives;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ProviderElementContext.prototype, "queryMatches", {
                    get: function () {
                        var allMatches = [];
                        this._queriedTokens.forEach(function (matches) { allMatches.push.apply(allMatches, matches); });
                        return allMatches;
                    },
                    enumerable: true,
                    configurable: true
                });
                ProviderElementContext.prototype._addQueryReadsTo = function (token, defaultValue, queryReadTokens) {
                    this._getQueriesFor(token).forEach(function (query) {
                        var queryValue = query.meta.read || defaultValue;
                        var tokenRef = tokenReference(queryValue);
                        var queryMatches = queryReadTokens.get(tokenRef);
                        if (!queryMatches) {
                            queryMatches = [];
                            queryReadTokens.set(tokenRef, queryMatches);
                        }
                        queryMatches.push({ queryId: query.queryId, value: queryValue });
                    });
                };
                ProviderElementContext.prototype._getQueriesFor = function (token) {
                    var result = [];
                    var currentEl = this;
                    var distance = 0;
                    var queries;
                    while (currentEl !== null) {
                        queries = currentEl._contentQueries.get(tokenReference(token));
                        if (queries) {
                            result.push.apply(result, queries.filter(function (query) { return query.meta.descendants || distance <= 1; }));
                        }
                        if (currentEl._directiveAsts.length > 0) {
                            distance++;
                        }
                        currentEl = currentEl._parent;
                    }
                    queries = this.viewContext.viewQueries.get(tokenReference(token));
                    if (queries) {
                        result.push.apply(result, queries);
                    }
                    return result;
                };
                ProviderElementContext.prototype._getOrCreateLocalProvider = function (requestingProviderType, token, eager) {
                    var _this = this;
                    var resolvedProvider = this._allProviders.get(tokenReference(token));
                    if (!resolvedProvider || ((requestingProviderType === ProviderAstType.Directive ||
                        requestingProviderType === ProviderAstType.PublicService) &&
                        resolvedProvider.providerType === ProviderAstType.PrivateService) ||
                        ((requestingProviderType === ProviderAstType.PrivateService ||
                            requestingProviderType === ProviderAstType.PublicService) &&
                            resolvedProvider.providerType === ProviderAstType.Builtin)) {
                        return null;
                    }
                    var transformedProviderAst = this._transformedProviders.get(tokenReference(token));
                    if (transformedProviderAst) {
                        return transformedProviderAst;
                    }
                    if (this._seenProviders.get(tokenReference(token)) != null) {
                        this.viewContext.errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + tokenName(token), this._sourceSpan));
                        return null;
                    }
                    this._seenProviders.set(tokenReference(token), true);
                    var transformedProviders = resolvedProvider.providers.map(function (provider) {
                        var transformedUseValue = provider.useValue;
                        var transformedUseExisting = provider.useExisting;
                        var transformedDeps = undefined;
                        if (provider.useExisting != null) {
                            var existingDiDep = _this._getDependency(resolvedProvider.providerType, { token: provider.useExisting }, eager);
                            if (existingDiDep.token != null) {
                                transformedUseExisting = existingDiDep.token;
                            }
                            else {
                                transformedUseExisting = null;
                                transformedUseValue = existingDiDep.value;
                            }
                        }
                        else if (provider.useFactory) {
                            var deps = provider.deps || provider.useFactory.diDeps;
                            transformedDeps =
                                deps.map(function (dep) { return _this._getDependency(resolvedProvider.providerType, dep, eager); });
                        }
                        else if (provider.useClass) {
                            var deps = provider.deps || provider.useClass.diDeps;
                            transformedDeps =
                                deps.map(function (dep) { return _this._getDependency(resolvedProvider.providerType, dep, eager); });
                        }
                        return _transformProvider(provider, {
                            useExisting: transformedUseExisting,
                            useValue: transformedUseValue,
                            deps: transformedDeps
                        });
                    });
                    transformedProviderAst =
                        _transformProviderAst(resolvedProvider, { eager: eager, providers: transformedProviders });
                    this._transformedProviders.set(tokenReference(token), transformedProviderAst);
                    return transformedProviderAst;
                };
                ProviderElementContext.prototype._getLocalDependency = function (requestingProviderType, dep, eager) {
                    if (eager === void 0) { eager = false; }
                    if (dep.isAttribute) {
                        var attrValue = this._attrs[dep.token.value];
                        return { isValue: true, value: attrValue == null ? null : attrValue };
                    }
                    if (dep.token != null) {
                        // access builtints
                        if ((requestingProviderType === ProviderAstType.Directive ||
                            requestingProviderType === ProviderAstType.Component)) {
                            if (tokenReference(dep.token) ===
                                this.viewContext.reflector.resolveExternalReference(Identifiers.Renderer) ||
                                tokenReference(dep.token) ===
                                    this.viewContext.reflector.resolveExternalReference(Identifiers.ElementRef) ||
                                tokenReference(dep.token) ===
                                    this.viewContext.reflector.resolveExternalReference(Identifiers.ChangeDetectorRef) ||
                                tokenReference(dep.token) ===
                                    this.viewContext.reflector.resolveExternalReference(Identifiers.TemplateRef)) {
                                return dep;
                            }
                            if (tokenReference(dep.token) ===
                                this.viewContext.reflector.resolveExternalReference(Identifiers.ViewContainerRef)) {
                                this.transformedHasViewContainer = true;
                            }
                        }
                        // access the injector
                        if (tokenReference(dep.token) ===
                            this.viewContext.reflector.resolveExternalReference(Identifiers.Injector)) {
                            return dep;
                        }
                        // access providers
                        if (this._getOrCreateLocalProvider(requestingProviderType, dep.token, eager) != null) {
                            return dep;
                        }
                    }
                    return null;
                };
                ProviderElementContext.prototype._getDependency = function (requestingProviderType, dep, eager) {
                    if (eager === void 0) { eager = false; }
                    var currElement = this;
                    var currEager = eager;
                    var result = null;
                    if (!dep.isSkipSelf) {
                        result = this._getLocalDependency(requestingProviderType, dep, eager);
                    }
                    if (dep.isSelf) {
                        if (!result && dep.isOptional) {
                            result = { isValue: true, value: null };
                        }
                    }
                    else {
                        // check parent elements
                        while (!result && currElement._parent) {
                            var prevElement = currElement;
                            currElement = currElement._parent;
                            if (prevElement._isViewRoot) {
                                currEager = false;
                            }
                            result = currElement._getLocalDependency(ProviderAstType.PublicService, dep, currEager);
                        }
                        // check @Host restriction
                        if (!result) {
                            if (!dep.isHost || this.viewContext.component.isHost ||
                                this.viewContext.component.type.reference === tokenReference(dep.token) ||
                                this.viewContext.viewProviders.get(tokenReference(dep.token)) != null) {
                                result = dep;
                            }
                            else {
                                result = dep.isOptional ? { isValue: true, value: null } : null;
                            }
                        }
                    }
                    if (!result) {
                        this.viewContext.errors.push(new ProviderError("No provider for " + tokenName(dep.token), this._sourceSpan));
                    }
                    return result;
                };
                return ProviderElementContext;
            }());
            var NgModuleProviderAnalyzer = /** @class */ (function () {
                function NgModuleProviderAnalyzer(reflector, ngModule, extraProviders, sourceSpan) {
                    var _this = this;
                    this.reflector = reflector;
                    this._transformedProviders = new Map();
                    this._seenProviders = new Map();
                    this._errors = [];
                    this._allProviders = new Map();
                    ngModule.transitiveModule.modules.forEach(function (ngModuleType) {
                        var ngModuleProvider = { token: { identifier: ngModuleType }, useClass: ngModuleType };
                        _resolveProviders([ngModuleProvider], ProviderAstType.PublicService, true, sourceSpan, _this._errors, _this._allProviders, /* isModule */ true);
                    });
                    _resolveProviders(ngModule.transitiveModule.providers.map(function (entry) { return entry.provider; }).concat(extraProviders), ProviderAstType.PublicService, false, sourceSpan, this._errors, this._allProviders, 
                    /* isModule */ false);
                }
                NgModuleProviderAnalyzer.prototype.parse = function () {
                    var _this = this;
                    Array.from(this._allProviders.values()).forEach(function (provider) {
                        _this._getOrCreateLocalProvider(provider.token, provider.eager);
                    });
                    if (this._errors.length > 0) {
                        var errorString = this._errors.join('\n');
                        throw new Error("Provider parse errors:\n" + errorString);
                    }
                    // Note: Maps keep their insertion order.
                    var lazyProviders = [];
                    var eagerProviders = [];
                    this._transformedProviders.forEach(function (provider) {
                        if (provider.eager) {
                            eagerProviders.push(provider);
                        }
                        else {
                            lazyProviders.push(provider);
                        }
                    });
                    return lazyProviders.concat(eagerProviders);
                };
                NgModuleProviderAnalyzer.prototype._getOrCreateLocalProvider = function (token, eager) {
                    var _this = this;
                    var resolvedProvider = this._allProviders.get(tokenReference(token));
                    if (!resolvedProvider) {
                        return null;
                    }
                    var transformedProviderAst = this._transformedProviders.get(tokenReference(token));
                    if (transformedProviderAst) {
                        return transformedProviderAst;
                    }
                    if (this._seenProviders.get(tokenReference(token)) != null) {
                        this._errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + tokenName(token), resolvedProvider.sourceSpan));
                        return null;
                    }
                    this._seenProviders.set(tokenReference(token), true);
                    var transformedProviders = resolvedProvider.providers.map(function (provider) {
                        var transformedUseValue = provider.useValue;
                        var transformedUseExisting = provider.useExisting;
                        var transformedDeps = undefined;
                        if (provider.useExisting != null) {
                            var existingDiDep = _this._getDependency({ token: provider.useExisting }, eager, resolvedProvider.sourceSpan);
                            if (existingDiDep.token != null) {
                                transformedUseExisting = existingDiDep.token;
                            }
                            else {
                                transformedUseExisting = null;
                                transformedUseValue = existingDiDep.value;
                            }
                        }
                        else if (provider.useFactory) {
                            var deps = provider.deps || provider.useFactory.diDeps;
                            transformedDeps =
                                deps.map(function (dep) { return _this._getDependency(dep, eager, resolvedProvider.sourceSpan); });
                        }
                        else if (provider.useClass) {
                            var deps = provider.deps || provider.useClass.diDeps;
                            transformedDeps =
                                deps.map(function (dep) { return _this._getDependency(dep, eager, resolvedProvider.sourceSpan); });
                        }
                        return _transformProvider(provider, {
                            useExisting: transformedUseExisting,
                            useValue: transformedUseValue,
                            deps: transformedDeps
                        });
                    });
                    transformedProviderAst =
                        _transformProviderAst(resolvedProvider, { eager: eager, providers: transformedProviders });
                    this._transformedProviders.set(tokenReference(token), transformedProviderAst);
                    return transformedProviderAst;
                };
                NgModuleProviderAnalyzer.prototype._getDependency = function (dep, eager, requestorSourceSpan) {
                    if (eager === void 0) { eager = false; }
                    var foundLocal = false;
                    if (!dep.isSkipSelf && dep.token != null) {
                        // access the injector
                        if (tokenReference(dep.token) ===
                            this.reflector.resolveExternalReference(Identifiers.Injector) ||
                            tokenReference(dep.token) ===
                                this.reflector.resolveExternalReference(Identifiers.ComponentFactoryResolver)) {
                            foundLocal = true;
                            // access providers
                        }
                        else if (this._getOrCreateLocalProvider(dep.token, eager) != null) {
                            foundLocal = true;
                        }
                    }
                    return dep;
                };
                return NgModuleProviderAnalyzer;
            }());
            function _transformProvider(provider, _c) {
                var useExisting = _c.useExisting, useValue = _c.useValue, deps = _c.deps;
                return {
                    token: provider.token,
                    useClass: provider.useClass,
                    useExisting: useExisting,
                    useFactory: provider.useFactory,
                    useValue: useValue,
                    deps: deps,
                    multi: provider.multi
                };
            }
            function _transformProviderAst(provider, _c) {
                var eager = _c.eager, providers = _c.providers;
                return new ProviderAst(provider.token, provider.multiProvider, provider.eager || eager, providers, provider.providerType, provider.lifecycleHooks, provider.sourceSpan, provider.isModule);
            }
            function _resolveProvidersFromDirectives(directives, sourceSpan, targetErrors) {
                var providersByToken = new Map();
                directives.forEach(function (directive) {
                    var dirProvider = { token: { identifier: directive.type }, useClass: directive.type };
                    _resolveProviders([dirProvider], directive.isComponent ? ProviderAstType.Component : ProviderAstType.Directive, true, sourceSpan, targetErrors, providersByToken, /* isModule */ false);
                });
                // Note: directives need to be able to overwrite providers of a component!
                var directivesWithComponentFirst = directives.filter(function (dir) { return dir.isComponent; }).concat(directives.filter(function (dir) { return !dir.isComponent; }));
                directivesWithComponentFirst.forEach(function (directive) {
                    _resolveProviders(directive.providers, ProviderAstType.PublicService, false, sourceSpan, targetErrors, providersByToken, /* isModule */ false);
                    _resolveProviders(directive.viewProviders, ProviderAstType.PrivateService, false, sourceSpan, targetErrors, providersByToken, /* isModule */ false);
                });
                return providersByToken;
            }
            function _resolveProviders(providers, providerType, eager, sourceSpan, targetErrors, targetProvidersByToken, isModule) {
                providers.forEach(function (provider) {
                    var resolvedProvider = targetProvidersByToken.get(tokenReference(provider.token));
                    if (resolvedProvider != null && !!resolvedProvider.multiProvider !== !!provider.multi) {
                        targetErrors.push(new ProviderError("Mixing multi and non multi provider is not possible for token " + tokenName(resolvedProvider.token), sourceSpan));
                    }
                    if (!resolvedProvider) {
                        var lifecycleHooks = provider.token.identifier &&
                            provider.token.identifier.lifecycleHooks ?
                            provider.token.identifier.lifecycleHooks :
                            [];
                        var isUseValue = !(provider.useClass || provider.useExisting || provider.useFactory);
                        resolvedProvider = new ProviderAst(provider.token, !!provider.multi, eager || isUseValue, [provider], providerType, lifecycleHooks, sourceSpan, isModule);
                        targetProvidersByToken.set(tokenReference(provider.token), resolvedProvider);
                    }
                    else {
                        if (!provider.multi) {
                            resolvedProvider.providers.length = 0;
                        }
                        resolvedProvider.providers.push(provider);
                    }
                });
            }
            function _getViewQueries(component) {
                // Note: queries start with id 1 so we can use the number in a Bloom filter!
                var viewQueryId = 1;
                var viewQueries = new Map();
                if (component.viewQueries) {
                    component.viewQueries.forEach(function (query) { return _addQueryToTokenMap(viewQueries, { meta: query, queryId: viewQueryId++ }); });
                }
                return viewQueries;
            }
            function _getContentQueries(contentQueryStartId, directives) {
                var contentQueryId = contentQueryStartId;
                var contentQueries = new Map();
                directives.forEach(function (directive, directiveIndex) {
                    if (directive.queries) {
                        directive.queries.forEach(function (query) { return _addQueryToTokenMap(contentQueries, { meta: query, queryId: contentQueryId++ }); });
                    }
                });
                return contentQueries;
            }
            function _addQueryToTokenMap(map, query) {
                query.meta.selectors.forEach(function (token) {
                    var entry = map.get(tokenReference(token));
                    if (!entry) {
                        entry = [];
                        map.set(tokenReference(token), entry);
                    }
                    entry.push(query);
                });
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var StyleWithImports = /** @class */ (function () {
                function StyleWithImports(style, styleUrls) {
                    this.style = style;
                    this.styleUrls = styleUrls;
                }
                return StyleWithImports;
            }());
            function isStyleUrlResolvable(url) {
                if (url == null || url.length === 0 || url[0] == '/')
                    return false;
                var schemeMatch = url.match(URL_WITH_SCHEMA_REGEXP);
                return schemeMatch === null || schemeMatch[1] == 'package' || schemeMatch[1] == 'asset';
            }
            /**
             * Rewrites stylesheets by resolving and removing the @import urls that
             * are either relative or don't have a `package:` scheme
             */
            function extractStyleUrls(resolver, baseUrl, cssText) {
                var foundUrls = [];
                var modifiedCssText = cssText.replace(CSS_STRIPPABLE_COMMENT_REGEXP, '')
                    .replace(CSS_IMPORT_REGEXP, function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    var url = m[1] || m[2];
                    if (!isStyleUrlResolvable(url)) {
                        // Do not attempt to resolve non-package absolute URLs with URI
                        // scheme
                        return m[0];
                    }
                    foundUrls.push(resolver.resolve(baseUrl, url));
                    return '';
                });
                return new StyleWithImports(modifiedCssText, foundUrls);
            }
            var CSS_IMPORT_REGEXP = /@import\s+(?:url\()?\s*(?:(?:['"]([^'"]*))|([^;\)\s]*))[^;]*;?/g;
            var CSS_STRIPPABLE_COMMENT_REGEXP = /\/\*(?!#\s*(?:sourceURL|sourceMappingURL)=)[\s\S]+?\*\//g;
            var URL_WITH_SCHEMA_REGEXP = /^([^:/?#]+):/;
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var PROPERTY_PARTS_SEPARATOR = '.';
            var ATTRIBUTE_PREFIX = 'attr';
            var CLASS_PREFIX = 'class';
            var STYLE_PREFIX = 'style';
            var ANIMATE_PROP_PREFIX = 'animate-';
            /**
             * Parses bindings in templates and in the directive host area.
             */
            var BindingParser = /** @class */ (function () {
                function BindingParser(_exprParser, _interpolationConfig, _schemaRegistry, pipes, errors) {
                    this._exprParser = _exprParser;
                    this._interpolationConfig = _interpolationConfig;
                    this._schemaRegistry = _schemaRegistry;
                    this.errors = errors;
                    this.pipesByName = null;
                    this._usedPipes = new Map();
                    // When the `pipes` parameter is `null`, do not check for used pipes
                    // This is used in IVY when we might not know the available pipes at compile time
                    if (pipes) {
                        var pipesByName_1 = new Map();
                        pipes.forEach(function (pipe) { return pipesByName_1.set(pipe.name, pipe); });
                        this.pipesByName = pipesByName_1;
                    }
                }
                Object.defineProperty(BindingParser.prototype, "interpolationConfig", {
                    get: function () { return this._interpolationConfig; },
                    enumerable: true,
                    configurable: true
                });
                BindingParser.prototype.getUsedPipes = function () { return Array.from(this._usedPipes.values()); };
                BindingParser.prototype.createBoundHostProperties = function (dirMeta, sourceSpan) {
                    var _this = this;
                    if (dirMeta.hostProperties) {
                        var boundProps_1 = [];
                        Object.keys(dirMeta.hostProperties).forEach(function (propName) {
                            var expression = dirMeta.hostProperties[propName];
                            if (typeof expression === 'string') {
                                _this.parsePropertyBinding(propName, expression, true, sourceSpan, sourceSpan.start.offset, undefined, [], boundProps_1);
                            }
                            else {
                                _this._reportError("Value of the host property binding \"" + propName + "\" needs to be a string representing an expression but got \"" + expression + "\" (" + typeof expression + ")", sourceSpan);
                            }
                        });
                        return boundProps_1;
                    }
                    return null;
                };
                BindingParser.prototype.createDirectiveHostPropertyAsts = function (dirMeta, elementSelector, sourceSpan) {
                    var _this = this;
                    var boundProps = this.createBoundHostProperties(dirMeta, sourceSpan);
                    return boundProps &&
                        boundProps.map(function (prop) { return _this.createBoundElementProperty(elementSelector, prop); });
                };
                BindingParser.prototype.createDirectiveHostEventAsts = function (dirMeta, sourceSpan) {
                    var _this = this;
                    if (dirMeta.hostListeners) {
                        var targetEvents_1 = [];
                        Object.keys(dirMeta.hostListeners).forEach(function (propName) {
                            var expression = dirMeta.hostListeners[propName];
                            if (typeof expression === 'string') {
                                // TODO: pass a more accurate handlerSpan for this event.
                                _this.parseEvent(propName, expression, sourceSpan, sourceSpan, [], targetEvents_1);
                            }
                            else {
                                _this._reportError("Value of the host listener \"" + propName + "\" needs to be a string representing an expression but got \"" + expression + "\" (" + typeof expression + ")", sourceSpan);
                            }
                        });
                        return targetEvents_1;
                    }
                    return null;
                };
                BindingParser.prototype.parseInterpolation = function (value, sourceSpan) {
                    var sourceInfo = sourceSpan.start.toString();
                    try {
                        var ast = this._exprParser.parseInterpolation(value, sourceInfo, sourceSpan.start.offset, this._interpolationConfig);
                        if (ast)
                            this._reportExpressionParserErrors(ast.errors, sourceSpan);
                        this._checkPipes(ast, sourceSpan);
                        return ast;
                    }
                    catch (e) {
                        this._reportError("" + e, sourceSpan);
                        return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo, sourceSpan.start.offset);
                    }
                };
                // Parse an inline template binding. ie `<tag *tplKey="<tplValue>">`
                BindingParser.prototype.parseInlineTemplateBinding = function (tplKey, tplValue, sourceSpan, absoluteOffset, targetMatchableAttrs, targetProps, targetVars) {
                    var bindings = this._parseTemplateBindings(tplKey, tplValue, sourceSpan);
                    for (var i = 0; i < bindings.length; i++) {
                        var binding = bindings[i];
                        if (binding.keyIsVar) {
                            targetVars.push(new ParsedVariable(binding.key, binding.name, sourceSpan));
                        }
                        else if (binding.expression) {
                            this._parsePropertyAst(binding.key, binding.expression, sourceSpan, undefined, targetMatchableAttrs, targetProps);
                        }
                        else {
                            targetMatchableAttrs.push([binding.key, '']);
                            this.parseLiteralAttr(binding.key, null, sourceSpan, absoluteOffset, undefined, targetMatchableAttrs, targetProps);
                        }
                    }
                };
                BindingParser.prototype._parseTemplateBindings = function (tplKey, tplValue, sourceSpan) {
                    var _this = this;
                    var sourceInfo = sourceSpan.start.toString();
                    try {
                        var bindingsResult = this._exprParser.parseTemplateBindings(tplKey, tplValue, sourceInfo, sourceSpan.start.offset);
                        this._reportExpressionParserErrors(bindingsResult.errors, sourceSpan);
                        bindingsResult.templateBindings.forEach(function (binding) {
                            if (binding.expression) {
                                _this._checkPipes(binding.expression, sourceSpan);
                            }
                        });
                        bindingsResult.warnings.forEach(function (warning) { _this._reportError(warning, sourceSpan, ParseErrorLevel.WARNING); });
                        return bindingsResult.templateBindings;
                    }
                    catch (e) {
                        this._reportError("" + e, sourceSpan);
                        return [];
                    }
                };
                BindingParser.prototype.parseLiteralAttr = function (name, value, sourceSpan, absoluteOffset, valueSpan, targetMatchableAttrs, targetProps) {
                    if (isAnimationLabel(name)) {
                        name = name.substring(1);
                        if (value) {
                            this._reportError("Assigning animation triggers via @prop=\"exp\" attributes with an expression is invalid." +
                                " Use property bindings (e.g. [@prop]=\"exp\") or use an attribute without a value (e.g. @prop) instead.", sourceSpan, ParseErrorLevel.ERROR);
                        }
                        this._parseAnimation(name, value, sourceSpan, absoluteOffset, valueSpan, targetMatchableAttrs, targetProps);
                    }
                    else {
                        targetProps.push(new ParsedProperty(name, this._exprParser.wrapLiteralPrimitive(value, '', absoluteOffset), ParsedPropertyType.LITERAL_ATTR, sourceSpan, valueSpan));
                    }
                };
                BindingParser.prototype.parsePropertyBinding = function (name, expression, isHost, sourceSpan, absoluteOffset, valueSpan, targetMatchableAttrs, targetProps) {
                    var isAnimationProp = false;
                    if (name.startsWith(ANIMATE_PROP_PREFIX)) {
                        isAnimationProp = true;
                        name = name.substring(ANIMATE_PROP_PREFIX.length);
                    }
                    else if (isAnimationLabel(name)) {
                        isAnimationProp = true;
                        name = name.substring(1);
                    }
                    if (isAnimationProp) {
                        this._parseAnimation(name, expression, sourceSpan, absoluteOffset, valueSpan, targetMatchableAttrs, targetProps);
                    }
                    else {
                        this._parsePropertyAst(name, this._parseBinding(expression, isHost, valueSpan || sourceSpan, absoluteOffset), sourceSpan, valueSpan, targetMatchableAttrs, targetProps);
                    }
                };
                BindingParser.prototype.parsePropertyInterpolation = function (name, value, sourceSpan, valueSpan, targetMatchableAttrs, targetProps) {
                    var expr = this.parseInterpolation(value, valueSpan || sourceSpan);
                    if (expr) {
                        this._parsePropertyAst(name, expr, sourceSpan, valueSpan, targetMatchableAttrs, targetProps);
                        return true;
                    }
                    return false;
                };
                BindingParser.prototype._parsePropertyAst = function (name, ast, sourceSpan, valueSpan, targetMatchableAttrs, targetProps) {
                    targetMatchableAttrs.push([name, ast.source]);
                    targetProps.push(new ParsedProperty(name, ast, ParsedPropertyType.DEFAULT, sourceSpan, valueSpan));
                };
                BindingParser.prototype._parseAnimation = function (name, expression, sourceSpan, absoluteOffset, valueSpan, targetMatchableAttrs, targetProps) {
                    // This will occur when a @trigger is not paired with an expression.
                    // For animations it is valid to not have an expression since */void
                    // states will be applied by angular when the element is attached/detached
                    var ast = this._parseBinding(expression || 'undefined', false, valueSpan || sourceSpan, absoluteOffset);
                    targetMatchableAttrs.push([name, ast.source]);
                    targetProps.push(new ParsedProperty(name, ast, ParsedPropertyType.ANIMATION, sourceSpan, valueSpan));
                };
                BindingParser.prototype._parseBinding = function (value, isHostBinding, sourceSpan, absoluteOffset) {
                    var sourceInfo = (sourceSpan && sourceSpan.start || '(unknown)').toString();
                    try {
                        var ast = isHostBinding ?
                            this._exprParser.parseSimpleBinding(value, sourceInfo, absoluteOffset, this._interpolationConfig) :
                            this._exprParser.parseBinding(value, sourceInfo, absoluteOffset, this._interpolationConfig);
                        if (ast)
                            this._reportExpressionParserErrors(ast.errors, sourceSpan);
                        this._checkPipes(ast, sourceSpan);
                        return ast;
                    }
                    catch (e) {
                        this._reportError("" + e, sourceSpan);
                        return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo, absoluteOffset);
                    }
                };
                BindingParser.prototype.createBoundElementProperty = function (elementSelector, boundProp, skipValidation, mapPropertyName) {
                    if (skipValidation === void 0) { skipValidation = false; }
                    if (mapPropertyName === void 0) { mapPropertyName = true; }
                    if (boundProp.isAnimation) {
                        return new BoundElementProperty(boundProp.name, 4 /* Animation */, SecurityContext.NONE, boundProp.expression, null, boundProp.sourceSpan, boundProp.valueSpan);
                    }
                    var unit = null;
                    var bindingType = undefined;
                    var boundPropertyName = null;
                    var parts = boundProp.name.split(PROPERTY_PARTS_SEPARATOR);
                    var securityContexts = undefined;
                    // Check for special cases (prefix style, attr, class)
                    if (parts.length > 1) {
                        if (parts[0] == ATTRIBUTE_PREFIX) {
                            boundPropertyName = parts[1];
                            if (!skipValidation) {
                                this._validatePropertyOrAttributeName(boundPropertyName, boundProp.sourceSpan, true);
                            }
                            securityContexts = calcPossibleSecurityContexts(this._schemaRegistry, elementSelector, boundPropertyName, true);
                            var nsSeparatorIdx = boundPropertyName.indexOf(':');
                            if (nsSeparatorIdx > -1) {
                                var ns = boundPropertyName.substring(0, nsSeparatorIdx);
                                var name = boundPropertyName.substring(nsSeparatorIdx + 1);
                                boundPropertyName = mergeNsAndName(ns, name);
                            }
                            bindingType = 1 /* Attribute */;
                        }
                        else if (parts[0] == CLASS_PREFIX) {
                            boundPropertyName = parts[1];
                            bindingType = 2 /* Class */;
                            securityContexts = [SecurityContext.NONE];
                        }
                        else if (parts[0] == STYLE_PREFIX) {
                            unit = parts.length > 2 ? parts[2] : null;
                            boundPropertyName = parts[1];
                            bindingType = 3 /* Style */;
                            securityContexts = [SecurityContext.STYLE];
                        }
                    }
                    // If not a special case, use the full property name
                    if (boundPropertyName === null) {
                        var mappedPropName = this._schemaRegistry.getMappedPropName(boundProp.name);
                        boundPropertyName = mapPropertyName ? mappedPropName : boundProp.name;
                        securityContexts = calcPossibleSecurityContexts(this._schemaRegistry, elementSelector, mappedPropName, false);
                        bindingType = 0 /* Property */;
                        if (!skipValidation) {
                            this._validatePropertyOrAttributeName(mappedPropName, boundProp.sourceSpan, false);
                        }
                    }
                    return new BoundElementProperty(boundPropertyName, bindingType, securityContexts[0], boundProp.expression, unit, boundProp.sourceSpan, boundProp.valueSpan);
                };
                BindingParser.prototype.parseEvent = function (name, expression, sourceSpan, handlerSpan, targetMatchableAttrs, targetEvents) {
                    if (isAnimationLabel(name)) {
                        name = name.substr(1);
                        this._parseAnimationEvent(name, expression, sourceSpan, handlerSpan, targetEvents);
                    }
                    else {
                        this._parseRegularEvent(name, expression, sourceSpan, handlerSpan, targetMatchableAttrs, targetEvents);
                    }
                };
                BindingParser.prototype.calcPossibleSecurityContexts = function (selector, propName, isAttribute) {
                    var prop = this._schemaRegistry.getMappedPropName(propName);
                    return calcPossibleSecurityContexts(this._schemaRegistry, selector, prop, isAttribute);
                };
                BindingParser.prototype._parseAnimationEvent = function (name, expression, sourceSpan, handlerSpan, targetEvents) {
                    var matches = splitAtPeriod(name, [name, '']);
                    var eventName = matches[0];
                    var phase = matches[1].toLowerCase();
                    if (phase) {
                        switch (phase) {
                            case 'start':
                            case 'done':
                                var ast = this._parseAction(expression, handlerSpan);
                                targetEvents.push(new ParsedEvent(eventName, phase, 1 /* Animation */, ast, sourceSpan, handlerSpan));
                                break;
                            default:
                                this._reportError("The provided animation output phase value \"" + phase + "\" for \"@" + eventName + "\" is not supported (use start or done)", sourceSpan);
                                break;
                        }
                    }
                    else {
                        this._reportError("The animation trigger output event (@" + eventName + ") is missing its phase value name (start or done are currently supported)", sourceSpan);
                    }
                };
                BindingParser.prototype._parseRegularEvent = function (name, expression, sourceSpan, handlerSpan, targetMatchableAttrs, targetEvents) {
                    // long format: 'target: eventName'
                    var _c = splitAtColon(name, [null, name]), target = _c[0], eventName = _c[1];
                    var ast = this._parseAction(expression, handlerSpan);
                    targetMatchableAttrs.push([name, ast.source]);
                    targetEvents.push(new ParsedEvent(eventName, target, 0 /* Regular */, ast, sourceSpan, handlerSpan));
                    // Don't detect directives for event names for now,
                    // so don't add the event name to the matchableAttrs
                };
                BindingParser.prototype._parseAction = function (value, sourceSpan) {
                    var sourceInfo = (sourceSpan && sourceSpan.start || '(unknown').toString();
                    var absoluteOffset = (sourceSpan && sourceSpan.start) ? sourceSpan.start.offset : 0;
                    try {
                        var ast = this._exprParser.parseAction(value, sourceInfo, absoluteOffset, this._interpolationConfig);
                        if (ast) {
                            this._reportExpressionParserErrors(ast.errors, sourceSpan);
                        }
                        if (!ast || ast.ast instanceof EmptyExpr) {
                            this._reportError("Empty expressions are not allowed", sourceSpan);
                            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo, absoluteOffset);
                        }
                        this._checkPipes(ast, sourceSpan);
                        return ast;
                    }
                    catch (e) {
                        this._reportError("" + e, sourceSpan);
                        return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo, absoluteOffset);
                    }
                };
                BindingParser.prototype._reportError = function (message, sourceSpan, level) {
                    if (level === void 0) { level = ParseErrorLevel.ERROR; }
                    this.errors.push(new ParseError(sourceSpan, message, level));
                };
                BindingParser.prototype._reportExpressionParserErrors = function (errors, sourceSpan) {
                    for (var _c = 0, errors_2 = errors; _c < errors_2.length; _c++) {
                        var error_1 = errors_2[_c];
                        this._reportError(error_1.message, sourceSpan);
                    }
                };
                // Make sure all the used pipes are known in `this.pipesByName`
                BindingParser.prototype._checkPipes = function (ast, sourceSpan) {
                    var _this = this;
                    if (ast && this.pipesByName) {
                        var collector = new PipeCollector();
                        ast.visit(collector);
                        collector.pipes.forEach(function (ast, pipeName) {
                            var pipeMeta = _this.pipesByName.get(pipeName);
                            if (!pipeMeta) {
                                _this._reportError("The pipe '" + pipeName + "' could not be found", new ParseSourceSpan(sourceSpan.start.moveBy(ast.span.start), sourceSpan.start.moveBy(ast.span.end)));
                            }
                            else {
                                _this._usedPipes.set(pipeName, pipeMeta);
                            }
                        });
                    }
                };
                /**
                 * @param propName the name of the property / attribute
                 * @param sourceSpan
                 * @param isAttr true when binding to an attribute
                 */
                BindingParser.prototype._validatePropertyOrAttributeName = function (propName, sourceSpan, isAttr) {
                    var report = isAttr ? this._schemaRegistry.validateAttribute(propName) :
                        this._schemaRegistry.validateProperty(propName);
                    if (report.error) {
                        this._reportError(report.msg, sourceSpan, ParseErrorLevel.ERROR);
                    }
                };
                return BindingParser;
            }());
            var PipeCollector = /** @class */ (function (_super_1) {
                __extends(PipeCollector, _super_1);
                function PipeCollector() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this.pipes = new Map();
                    return _this;
                }
                PipeCollector.prototype.visitPipe = function (ast, context) {
                    this.pipes.set(ast.name, ast);
                    ast.exp.visit(this);
                    this.visitAll(ast.args, context);
                    return null;
                };
                return PipeCollector;
            }(RecursiveAstVisitor$1));
            function isAnimationLabel(name) {
                return name[0] == '@';
            }
            function calcPossibleSecurityContexts(registry, selector, propName, isAttribute) {
                var ctxs = [];
                CssSelector.parse(selector).forEach(function (selector) {
                    var elementNames = selector.element ? [selector.element] : registry.allKnownElementNames();
                    var notElementNames = new Set(selector.notSelectors.filter(function (selector) { return selector.isElementSelector(); })
                        .map(function (selector) { return selector.element; }));
                    var possibleElementNames = elementNames.filter(function (elementName) { return !notElementNames.has(elementName); });
                    ctxs.push.apply(ctxs, possibleElementNames.map(function (elementName) { return registry.securityContext(elementName, propName, isAttribute); }));
                });
                return ctxs.length === 0 ? [SecurityContext.NONE] : Array.from(new Set(ctxs)).sort();
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var NG_CONTENT_SELECT_ATTR = 'select';
            var LINK_ELEMENT = 'link';
            var LINK_STYLE_REL_ATTR = 'rel';
            var LINK_STYLE_HREF_ATTR = 'href';
            var LINK_STYLE_REL_VALUE = 'stylesheet';
            var STYLE_ELEMENT = 'style';
            var SCRIPT_ELEMENT = 'script';
            var NG_NON_BINDABLE_ATTR = 'ngNonBindable';
            var NG_PROJECT_AS = 'ngProjectAs';
            function preparseElement(ast) {
                var selectAttr = null;
                var hrefAttr = null;
                var relAttr = null;
                var nonBindable = false;
                var projectAs = '';
                ast.attrs.forEach(function (attr) {
                    var lcAttrName = attr.name.toLowerCase();
                    if (lcAttrName == NG_CONTENT_SELECT_ATTR) {
                        selectAttr = attr.value;
                    }
                    else if (lcAttrName == LINK_STYLE_HREF_ATTR) {
                        hrefAttr = attr.value;
                    }
                    else if (lcAttrName == LINK_STYLE_REL_ATTR) {
                        relAttr = attr.value;
                    }
                    else if (attr.name == NG_NON_BINDABLE_ATTR) {
                        nonBindable = true;
                    }
                    else if (attr.name == NG_PROJECT_AS) {
                        if (attr.value.length > 0) {
                            projectAs = attr.value;
                        }
                    }
                });
                selectAttr = normalizeNgContentSelect(selectAttr);
                var nodeName = ast.name.toLowerCase();
                var type = PreparsedElementType.OTHER;
                if (isNgContent(nodeName)) {
                    type = PreparsedElementType.NG_CONTENT;
                }
                else if (nodeName == STYLE_ELEMENT) {
                    type = PreparsedElementType.STYLE;
                }
                else if (nodeName == SCRIPT_ELEMENT) {
                    type = PreparsedElementType.SCRIPT;
                }
                else if (nodeName == LINK_ELEMENT && relAttr == LINK_STYLE_REL_VALUE) {
                    type = PreparsedElementType.STYLESHEET;
                }
                return new PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs);
            }
            var PreparsedElementType;
            (function (PreparsedElementType) {
                PreparsedElementType[PreparsedElementType["NG_CONTENT"] = 0] = "NG_CONTENT";
                PreparsedElementType[PreparsedElementType["STYLE"] = 1] = "STYLE";
                PreparsedElementType[PreparsedElementType["STYLESHEET"] = 2] = "STYLESHEET";
                PreparsedElementType[PreparsedElementType["SCRIPT"] = 3] = "SCRIPT";
                PreparsedElementType[PreparsedElementType["OTHER"] = 4] = "OTHER";
            })(PreparsedElementType || (PreparsedElementType = {}));
            var PreparsedElement = /** @class */ (function () {
                function PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs) {
                    this.type = type;
                    this.selectAttr = selectAttr;
                    this.hrefAttr = hrefAttr;
                    this.nonBindable = nonBindable;
                    this.projectAs = projectAs;
                }
                return PreparsedElement;
            }());
            function normalizeNgContentSelect(selectAttr) {
                if (selectAttr === null || selectAttr.length === 0) {
                    return '*';
                }
                return selectAttr;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var BIND_NAME_REGEXP = /^(?:(?:(?:(bind-)|(let-)|(ref-|#)|(on-)|(bindon-)|(@))(.+))|\[\(([^\)]+)\)\]|\[([^\]]+)\]|\(([^\)]+)\))$/;
            // Group 1 = "bind-"
            var KW_BIND_IDX = 1;
            // Group 2 = "let-"
            var KW_LET_IDX = 2;
            // Group 3 = "ref-/#"
            var KW_REF_IDX = 3;
            // Group 4 = "on-"
            var KW_ON_IDX = 4;
            // Group 5 = "bindon-"
            var KW_BINDON_IDX = 5;
            // Group 6 = "@"
            var KW_AT_IDX = 6;
            // Group 7 = the identifier after "bind-", "let-", "ref-/#", "on-", "bindon-" or "@"
            var IDENT_KW_IDX = 7;
            // Group 8 = identifier inside [()]
            var IDENT_BANANA_BOX_IDX = 8;
            // Group 9 = identifier inside []
            var IDENT_PROPERTY_IDX = 9;
            // Group 10 = identifier inside ()
            var IDENT_EVENT_IDX = 10;
            var TEMPLATE_ATTR_PREFIX = '*';
            var CLASS_ATTR = 'class';
            var _TEXT_CSS_SELECTOR;
            function TEXT_CSS_SELECTOR() {
                if (!_TEXT_CSS_SELECTOR) {
                    _TEXT_CSS_SELECTOR = CssSelector.parse('*')[0];
                }
                return _TEXT_CSS_SELECTOR;
            }
            var TemplateParseError = /** @class */ (function (_super_1) {
                __extends(TemplateParseError, _super_1);
                function TemplateParseError(message, span, level) {
                    return _super_1.call(this, span, message, level) || this;
                }
                return TemplateParseError;
            }(ParseError));
            var TemplateParseResult = /** @class */ (function () {
                function TemplateParseResult(templateAst, usedPipes, errors) {
                    this.templateAst = templateAst;
                    this.usedPipes = usedPipes;
                    this.errors = errors;
                }
                return TemplateParseResult;
            }());
            var TemplateParser = /** @class */ (function () {
                function TemplateParser(_config, _reflector, _exprParser, _schemaRegistry, _htmlParser, _console, transforms) {
                    this._config = _config;
                    this._reflector = _reflector;
                    this._exprParser = _exprParser;
                    this._schemaRegistry = _schemaRegistry;
                    this._htmlParser = _htmlParser;
                    this._console = _console;
                    this.transforms = transforms;
                }
                Object.defineProperty(TemplateParser.prototype, "expressionParser", {
                    get: function () { return this._exprParser; },
                    enumerable: true,
                    configurable: true
                });
                TemplateParser.prototype.parse = function (component, template, directives, pipes, schemas, templateUrl, preserveWhitespaces) {
                    var result = this.tryParse(component, template, directives, pipes, schemas, templateUrl, preserveWhitespaces);
                    var warnings = result.errors.filter(function (error) { return error.level === ParseErrorLevel.WARNING; });
                    var errors = result.errors.filter(function (error) { return error.level === ParseErrorLevel.ERROR; });
                    if (warnings.length > 0) {
                        this._console.warn("Template parse warnings:\n" + warnings.join('\n'));
                    }
                    if (errors.length > 0) {
                        var errorString = errors.join('\n');
                        throw syntaxError("Template parse errors:\n" + errorString, errors);
                    }
                    return { template: result.templateAst, pipes: result.usedPipes };
                };
                TemplateParser.prototype.tryParse = function (component, template, directives, pipes, schemas, templateUrl, preserveWhitespaces) {
                    var htmlParseResult = typeof template === 'string' ?
                        this._htmlParser.parse(template, templateUrl, {
                            tokenizeExpansionForms: true,
                            interpolationConfig: this.getInterpolationConfig(component)
                        }) :
                        template;
                    if (!preserveWhitespaces) {
                        htmlParseResult = removeWhitespaces(htmlParseResult);
                    }
                    return this.tryParseHtml(this.expandHtml(htmlParseResult), component, directives, pipes, schemas);
                };
                TemplateParser.prototype.tryParseHtml = function (htmlAstWithErrors, component, directives, pipes, schemas) {
                    var result;
                    var errors = htmlAstWithErrors.errors;
                    var usedPipes = [];
                    if (htmlAstWithErrors.rootNodes.length > 0) {
                        var uniqDirectives = removeSummaryDuplicates(directives);
                        var uniqPipes = removeSummaryDuplicates(pipes);
                        var providerViewContext = new ProviderViewContext(this._reflector, component);
                        var interpolationConfig = undefined;
                        if (component.template && component.template.interpolation) {
                            interpolationConfig = {
                                start: component.template.interpolation[0],
                                end: component.template.interpolation[1]
                            };
                        }
                        var bindingParser = new BindingParser(this._exprParser, interpolationConfig, this._schemaRegistry, uniqPipes, errors);
                        var parseVisitor = new TemplateParseVisitor(this._reflector, this._config, providerViewContext, uniqDirectives, bindingParser, this._schemaRegistry, schemas, errors);
                        result = visitAll$1(parseVisitor, htmlAstWithErrors.rootNodes, EMPTY_ELEMENT_CONTEXT);
                        errors.push.apply(errors, providerViewContext.errors);
                        usedPipes.push.apply(usedPipes, bindingParser.getUsedPipes());
                    }
                    else {
                        result = [];
                    }
                    this._assertNoReferenceDuplicationOnTemplate(result, errors);
                    if (errors.length > 0) {
                        return new TemplateParseResult(result, usedPipes, errors);
                    }
                    if (this.transforms) {
                        this.transforms.forEach(function (transform) { result = templateVisitAll(transform, result); });
                    }
                    return new TemplateParseResult(result, usedPipes, errors);
                };
                TemplateParser.prototype.expandHtml = function (htmlAstWithErrors, forced) {
                    if (forced === void 0) { forced = false; }
                    var errors = htmlAstWithErrors.errors;
                    if (errors.length == 0 || forced) {
                        // Transform ICU messages to angular directives
                        var expandedHtmlAst = expandNodes(htmlAstWithErrors.rootNodes);
                        errors.push.apply(errors, expandedHtmlAst.errors);
                        htmlAstWithErrors = new ParseTreeResult(expandedHtmlAst.nodes, errors);
                    }
                    return htmlAstWithErrors;
                };
                TemplateParser.prototype.getInterpolationConfig = function (component) {
                    if (component.template) {
                        return InterpolationConfig.fromArray(component.template.interpolation);
                    }
                    return undefined;
                };
                /** @internal */
                TemplateParser.prototype._assertNoReferenceDuplicationOnTemplate = function (result, errors) {
                    var existingReferences = [];
                    result.filter(function (element) { return !!element.references; })
                        .forEach(function (element) { return element.references.forEach(function (reference) {
                        var name = reference.name;
                        if (existingReferences.indexOf(name) < 0) {
                            existingReferences.push(name);
                        }
                        else {
                            var error_2 = new TemplateParseError("Reference \"#" + name + "\" is defined several times", reference.sourceSpan, ParseErrorLevel.ERROR);
                            errors.push(error_2);
                        }
                    }); });
                };
                return TemplateParser;
            }());
            var TemplateParseVisitor = /** @class */ (function () {
                function TemplateParseVisitor(reflector, config, providerViewContext, directives, _bindingParser, _schemaRegistry, _schemas, _targetErrors) {
                    var _this = this;
                    this.reflector = reflector;
                    this.config = config;
                    this.providerViewContext = providerViewContext;
                    this._bindingParser = _bindingParser;
                    this._schemaRegistry = _schemaRegistry;
                    this._schemas = _schemas;
                    this._targetErrors = _targetErrors;
                    this.selectorMatcher = new SelectorMatcher();
                    this.directivesIndex = new Map();
                    this.ngContentCount = 0;
                    // Note: queries start with id 1 so we can use the number in a Bloom filter!
                    this.contentQueryStartId = providerViewContext.component.viewQueries.length + 1;
                    directives.forEach(function (directive, index) {
                        var selector = CssSelector.parse(directive.selector);
                        _this.selectorMatcher.addSelectables(selector, directive);
                        _this.directivesIndex.set(directive, index);
                    });
                }
                TemplateParseVisitor.prototype.visitExpansion = function (expansion, context) { return null; };
                TemplateParseVisitor.prototype.visitExpansionCase = function (expansionCase, context) { return null; };
                TemplateParseVisitor.prototype.visitText = function (text, parent) {
                    var ngContentIndex = parent.findNgContentIndex(TEXT_CSS_SELECTOR());
                    var valueNoNgsp = replaceNgsp(text.value);
                    var expr = this._bindingParser.parseInterpolation(valueNoNgsp, text.sourceSpan);
                    return expr ? new BoundTextAst(expr, ngContentIndex, text.sourceSpan) :
                        new TextAst(valueNoNgsp, ngContentIndex, text.sourceSpan);
                };
                TemplateParseVisitor.prototype.visitAttribute = function (attribute, context) {
                    return new AttrAst(attribute.name, attribute.value, attribute.sourceSpan);
                };
                TemplateParseVisitor.prototype.visitComment = function (comment, context) { return null; };
                TemplateParseVisitor.prototype.visitElement = function (element, parent) {
                    var _this = this;
                    var queryStartIndex = this.contentQueryStartId;
                    var elName = element.name;
                    var preparsedElement = preparseElement(element);
                    if (preparsedElement.type === PreparsedElementType.SCRIPT ||
                        preparsedElement.type === PreparsedElementType.STYLE) {
                        // Skipping <script> for security reasons
                        // Skipping <style> as we already processed them
                        // in the StyleCompiler
                        return null;
                    }
                    if (preparsedElement.type === PreparsedElementType.STYLESHEET &&
                        isStyleUrlResolvable(preparsedElement.hrefAttr)) {
                        // Skipping stylesheets with either relative urls or package scheme as we already processed
                        // them in the StyleCompiler
                        return null;
                    }
                    var matchableAttrs = [];
                    var elementOrDirectiveProps = [];
                    var elementOrDirectiveRefs = [];
                    var elementVars = [];
                    var events = [];
                    var templateElementOrDirectiveProps = [];
                    var templateMatchableAttrs = [];
                    var templateElementVars = [];
                    var hasInlineTemplates = false;
                    var attrs = [];
                    var isTemplateElement = isNgTemplate(element.name);
                    element.attrs.forEach(function (attr) {
                        var parsedVariables = [];
                        var hasBinding = _this._parseAttr(isTemplateElement, attr, matchableAttrs, elementOrDirectiveProps, events, elementOrDirectiveRefs, elementVars);
                        elementVars.push.apply(elementVars, parsedVariables.map(function (v) { return VariableAst.fromParsedVariable(v); }));
                        var templateValue;
                        var templateKey;
                        var normalizedName = _this._normalizeAttributeName(attr.name);
                        if (normalizedName.startsWith(TEMPLATE_ATTR_PREFIX)) {
                            templateValue = attr.value;
                            templateKey = normalizedName.substring(TEMPLATE_ATTR_PREFIX.length);
                        }
                        var hasTemplateBinding = templateValue != null;
                        if (hasTemplateBinding) {
                            if (hasInlineTemplates) {
                                _this._reportError("Can't have multiple template bindings on one element. Use only one attribute prefixed with *", attr.sourceSpan);
                            }
                            hasInlineTemplates = true;
                            var parsedVariables_1 = [];
                            _this._bindingParser.parseInlineTemplateBinding(templateKey, templateValue, attr.sourceSpan, attr.sourceSpan.start.offset, templateMatchableAttrs, templateElementOrDirectiveProps, parsedVariables_1);
                            templateElementVars.push.apply(templateElementVars, parsedVariables_1.map(function (v) { return VariableAst.fromParsedVariable(v); }));
                        }
                        if (!hasBinding && !hasTemplateBinding) {
                            // don't include the bindings as attributes as well in the AST
                            attrs.push(_this.visitAttribute(attr, null));
                            matchableAttrs.push([attr.name, attr.value]);
                        }
                    });
                    var elementCssSelector = createElementCssSelector(elName, matchableAttrs);
                    var _c = this._parseDirectives(this.selectorMatcher, elementCssSelector), directiveMetas = _c.directives, matchElement = _c.matchElement;
                    var references = [];
                    var boundDirectivePropNames = new Set();
                    var directiveAsts = this._createDirectiveAsts(isTemplateElement, element.name, directiveMetas, elementOrDirectiveProps, elementOrDirectiveRefs, element.sourceSpan, references, boundDirectivePropNames);
                    var elementProps = this._createElementPropertyAsts(element.name, elementOrDirectiveProps, boundDirectivePropNames);
                    var isViewRoot = parent.isTemplateElement || hasInlineTemplates;
                    var providerContext = new ProviderElementContext(this.providerViewContext, parent.providerContext, isViewRoot, directiveAsts, attrs, references, isTemplateElement, queryStartIndex, element.sourceSpan);
                    var children = visitAll$1(preparsedElement.nonBindable ? NON_BINDABLE_VISITOR : this, element.children, ElementContext.create(isTemplateElement, directiveAsts, isTemplateElement ? parent.providerContext : providerContext));
                    providerContext.afterElement();
                    // Override the actual selector when the `ngProjectAs` attribute is provided
                    var projectionSelector = preparsedElement.projectAs != '' ?
                        CssSelector.parse(preparsedElement.projectAs)[0] :
                        elementCssSelector;
                    var ngContentIndex = parent.findNgContentIndex(projectionSelector);
                    var parsedElement;
                    if (preparsedElement.type === PreparsedElementType.NG_CONTENT) {
                        // `<ng-content>` element
                        if (element.children && !element.children.every(_isEmptyTextNode)) {
                            this._reportError("<ng-content> element cannot have content.", element.sourceSpan);
                        }
                        parsedElement = new NgContentAst(this.ngContentCount++, hasInlineTemplates ? null : ngContentIndex, element.sourceSpan);
                    }
                    else if (isTemplateElement) {
                        // `<ng-template>` element
                        this._assertAllEventsPublishedByDirectives(directiveAsts, events);
                        this._assertNoComponentsNorElementBindingsOnTemplate(directiveAsts, elementProps, element.sourceSpan);
                        parsedElement = new EmbeddedTemplateAst(attrs, events, references, elementVars, providerContext.transformedDirectiveAsts, providerContext.transformProviders, providerContext.transformedHasViewContainer, providerContext.queryMatches, children, hasInlineTemplates ? null : ngContentIndex, element.sourceSpan);
                    }
                    else {
                        // element other than `<ng-content>` and `<ng-template>`
                        this._assertElementExists(matchElement, element);
                        this._assertOnlyOneComponent(directiveAsts, element.sourceSpan);
                        var ngContentIndex_1 = hasInlineTemplates ? null : parent.findNgContentIndex(projectionSelector);
                        parsedElement = new ElementAst(elName, attrs, elementProps, events, references, providerContext.transformedDirectiveAsts, providerContext.transformProviders, providerContext.transformedHasViewContainer, providerContext.queryMatches, children, hasInlineTemplates ? null : ngContentIndex_1, element.sourceSpan, element.endSourceSpan || null);
                    }
                    if (hasInlineTemplates) {
                        // The element as a *-attribute
                        var templateQueryStartIndex = this.contentQueryStartId;
                        var templateSelector = createElementCssSelector('ng-template', templateMatchableAttrs);
                        var directives = this._parseDirectives(this.selectorMatcher, templateSelector).directives;
                        var templateBoundDirectivePropNames = new Set();
                        var templateDirectiveAsts = this._createDirectiveAsts(true, elName, directives, templateElementOrDirectiveProps, [], element.sourceSpan, [], templateBoundDirectivePropNames);
                        var templateElementProps = this._createElementPropertyAsts(elName, templateElementOrDirectiveProps, templateBoundDirectivePropNames);
                        this._assertNoComponentsNorElementBindingsOnTemplate(templateDirectiveAsts, templateElementProps, element.sourceSpan);
                        var templateProviderContext = new ProviderElementContext(this.providerViewContext, parent.providerContext, parent.isTemplateElement, templateDirectiveAsts, [], [], true, templateQueryStartIndex, element.sourceSpan);
                        templateProviderContext.afterElement();
                        parsedElement = new EmbeddedTemplateAst([], [], [], templateElementVars, templateProviderContext.transformedDirectiveAsts, templateProviderContext.transformProviders, templateProviderContext.transformedHasViewContainer, templateProviderContext.queryMatches, [parsedElement], ngContentIndex, element.sourceSpan);
                    }
                    return parsedElement;
                };
                TemplateParseVisitor.prototype._parseAttr = function (isTemplateElement, attr, targetMatchableAttrs, targetProps, targetEvents, targetRefs, targetVars) {
                    var name = this._normalizeAttributeName(attr.name);
                    var value = attr.value;
                    var srcSpan = attr.sourceSpan;
                    var absoluteOffset = attr.valueSpan ? attr.valueSpan.start.offset : srcSpan.start.offset;
                    var boundEvents = [];
                    var bindParts = name.match(BIND_NAME_REGEXP);
                    var hasBinding = false;
                    if (bindParts !== null) {
                        hasBinding = true;
                        if (bindParts[KW_BIND_IDX] != null) {
                            this._bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX], value, false, srcSpan, absoluteOffset, attr.valueSpan, targetMatchableAttrs, targetProps);
                        }
                        else if (bindParts[KW_LET_IDX]) {
                            if (isTemplateElement) {
                                var identifier = bindParts[IDENT_KW_IDX];
                                this._parseVariable(identifier, value, srcSpan, targetVars);
                            }
                            else {
                                this._reportError("\"let-\" is only supported on ng-template elements.", srcSpan);
                            }
                        }
                        else if (bindParts[KW_REF_IDX]) {
                            var identifier = bindParts[IDENT_KW_IDX];
                            this._parseReference(identifier, value, srcSpan, targetRefs);
                        }
                        else if (bindParts[KW_ON_IDX]) {
                            this._bindingParser.parseEvent(bindParts[IDENT_KW_IDX], value, srcSpan, attr.valueSpan || srcSpan, targetMatchableAttrs, boundEvents);
                        }
                        else if (bindParts[KW_BINDON_IDX]) {
                            this._bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX], value, false, srcSpan, absoluteOffset, attr.valueSpan, targetMatchableAttrs, targetProps);
                            this._parseAssignmentEvent(bindParts[IDENT_KW_IDX], value, srcSpan, attr.valueSpan || srcSpan, targetMatchableAttrs, boundEvents);
                        }
                        else if (bindParts[KW_AT_IDX]) {
                            this._bindingParser.parseLiteralAttr(name, value, srcSpan, absoluteOffset, attr.valueSpan, targetMatchableAttrs, targetProps);
                        }
                        else if (bindParts[IDENT_BANANA_BOX_IDX]) {
                            this._bindingParser.parsePropertyBinding(bindParts[IDENT_BANANA_BOX_IDX], value, false, srcSpan, absoluteOffset, attr.valueSpan, targetMatchableAttrs, targetProps);
                            this._parseAssignmentEvent(bindParts[IDENT_BANANA_BOX_IDX], value, srcSpan, attr.valueSpan || srcSpan, targetMatchableAttrs, boundEvents);
                        }
                        else if (bindParts[IDENT_PROPERTY_IDX]) {
                            this._bindingParser.parsePropertyBinding(bindParts[IDENT_PROPERTY_IDX], value, false, srcSpan, absoluteOffset, attr.valueSpan, targetMatchableAttrs, targetProps);
                        }
                        else if (bindParts[IDENT_EVENT_IDX]) {
                            this._bindingParser.parseEvent(bindParts[IDENT_EVENT_IDX], value, srcSpan, attr.valueSpan || srcSpan, targetMatchableAttrs, boundEvents);
                        }
                    }
                    else {
                        hasBinding = this._bindingParser.parsePropertyInterpolation(name, value, srcSpan, attr.valueSpan, targetMatchableAttrs, targetProps);
                    }
                    if (!hasBinding) {
                        this._bindingParser.parseLiteralAttr(name, value, srcSpan, absoluteOffset, attr.valueSpan, targetMatchableAttrs, targetProps);
                    }
                    targetEvents.push.apply(targetEvents, boundEvents.map(function (e) { return BoundEventAst.fromParsedEvent(e); }));
                    return hasBinding;
                };
                TemplateParseVisitor.prototype._normalizeAttributeName = function (attrName) {
                    return /^data-/i.test(attrName) ? attrName.substring(5) : attrName;
                };
                TemplateParseVisitor.prototype._parseVariable = function (identifier, value, sourceSpan, targetVars) {
                    if (identifier.indexOf('-') > -1) {
                        this._reportError("\"-\" is not allowed in variable names", sourceSpan);
                    }
                    targetVars.push(new VariableAst(identifier, value, sourceSpan));
                };
                TemplateParseVisitor.prototype._parseReference = function (identifier, value, sourceSpan, targetRefs) {
                    if (identifier.indexOf('-') > -1) {
                        this._reportError("\"-\" is not allowed in reference names", sourceSpan);
                    }
                    targetRefs.push(new ElementOrDirectiveRef(identifier, value, sourceSpan));
                };
                TemplateParseVisitor.prototype._parseAssignmentEvent = function (name, expression, sourceSpan, valueSpan, targetMatchableAttrs, targetEvents) {
                    this._bindingParser.parseEvent(name + "Change", expression + "=$event", sourceSpan, valueSpan, targetMatchableAttrs, targetEvents);
                };
                TemplateParseVisitor.prototype._parseDirectives = function (selectorMatcher, elementCssSelector) {
                    var _this = this;
                    // Need to sort the directives so that we get consistent results throughout,
                    // as selectorMatcher uses Maps inside.
                    // Also deduplicate directives as they might match more than one time!
                    var directives = new Array(this.directivesIndex.size);
                    // Whether any directive selector matches on the element name
                    var matchElement = false;
                    selectorMatcher.match(elementCssSelector, function (selector, directive) {
                        directives[_this.directivesIndex.get(directive)] = directive;
                        matchElement = matchElement || selector.hasElementSelector();
                    });
                    return {
                        directives: directives.filter(function (dir) { return !!dir; }),
                        matchElement: matchElement,
                    };
                };
                TemplateParseVisitor.prototype._createDirectiveAsts = function (isTemplateElement, elementName, directives, props, elementOrDirectiveRefs, elementSourceSpan, targetReferences, targetBoundDirectivePropNames) {
                    var _this = this;
                    var matchedReferences = new Set();
                    var component = null;
                    var directiveAsts = directives.map(function (directive) {
                        var sourceSpan = new ParseSourceSpan(elementSourceSpan.start, elementSourceSpan.end, "Directive " + identifierName(directive.type));
                        if (directive.isComponent) {
                            component = directive;
                        }
                        var directiveProperties = [];
                        var boundProperties = _this._bindingParser.createDirectiveHostPropertyAsts(directive, elementName, sourceSpan);
                        var hostProperties = boundProperties.map(function (prop) { return BoundElementPropertyAst.fromBoundProperty(prop); });
                        // Note: We need to check the host properties here as well,
                        // as we don't know the element name in the DirectiveWrapperCompiler yet.
                        hostProperties = _this._checkPropertiesInSchema(elementName, hostProperties);
                        var parsedEvents = _this._bindingParser.createDirectiveHostEventAsts(directive, sourceSpan);
                        _this._createDirectivePropertyAsts(directive.inputs, props, directiveProperties, targetBoundDirectivePropNames);
                        elementOrDirectiveRefs.forEach(function (elOrDirRef) {
                            if ((elOrDirRef.value.length === 0 && directive.isComponent) ||
                                (elOrDirRef.isReferenceToDirective(directive))) {
                                targetReferences.push(new ReferenceAst(elOrDirRef.name, createTokenForReference(directive.type.reference), elOrDirRef.value, elOrDirRef.sourceSpan));
                                matchedReferences.add(elOrDirRef.name);
                            }
                        });
                        var hostEvents = parsedEvents.map(function (e) { return BoundEventAst.fromParsedEvent(e); });
                        var contentQueryStartId = _this.contentQueryStartId;
                        _this.contentQueryStartId += directive.queries.length;
                        return new DirectiveAst(directive, directiveProperties, hostProperties, hostEvents, contentQueryStartId, sourceSpan);
                    });
                    elementOrDirectiveRefs.forEach(function (elOrDirRef) {
                        if (elOrDirRef.value.length > 0) {
                            if (!matchedReferences.has(elOrDirRef.name)) {
                                _this._reportError("There is no directive with \"exportAs\" set to \"" + elOrDirRef.value + "\"", elOrDirRef.sourceSpan);
                            }
                        }
                        else if (!component) {
                            var refToken = null;
                            if (isTemplateElement) {
                                refToken = createTokenForExternalReference(_this.reflector, Identifiers.TemplateRef);
                            }
                            targetReferences.push(new ReferenceAst(elOrDirRef.name, refToken, elOrDirRef.value, elOrDirRef.sourceSpan));
                        }
                    });
                    return directiveAsts;
                };
                TemplateParseVisitor.prototype._createDirectivePropertyAsts = function (directiveProperties, boundProps, targetBoundDirectiveProps, targetBoundDirectivePropNames) {
                    if (directiveProperties) {
                        var boundPropsByName_1 = new Map();
                        boundProps.forEach(function (boundProp) {
                            var prevValue = boundPropsByName_1.get(boundProp.name);
                            if (!prevValue || prevValue.isLiteral) {
                                // give [a]="b" a higher precedence than a="b" on the same element
                                boundPropsByName_1.set(boundProp.name, boundProp);
                            }
                        });
                        Object.keys(directiveProperties).forEach(function (dirProp) {
                            var elProp = directiveProperties[dirProp];
                            var boundProp = boundPropsByName_1.get(elProp);
                            // Bindings are optional, so this binding only needs to be set up if an expression is given.
                            if (boundProp) {
                                targetBoundDirectivePropNames.add(boundProp.name);
                                if (!isEmptyExpression(boundProp.expression)) {
                                    targetBoundDirectiveProps.push(new BoundDirectivePropertyAst(dirProp, boundProp.name, boundProp.expression, boundProp.sourceSpan));
                                }
                            }
                        });
                    }
                };
                TemplateParseVisitor.prototype._createElementPropertyAsts = function (elementName, props, boundDirectivePropNames) {
                    var _this = this;
                    var boundElementProps = [];
                    props.forEach(function (prop) {
                        if (!prop.isLiteral && !boundDirectivePropNames.has(prop.name)) {
                            var boundProp = _this._bindingParser.createBoundElementProperty(elementName, prop);
                            boundElementProps.push(BoundElementPropertyAst.fromBoundProperty(boundProp));
                        }
                    });
                    return this._checkPropertiesInSchema(elementName, boundElementProps);
                };
                TemplateParseVisitor.prototype._findComponentDirectives = function (directives) {
                    return directives.filter(function (directive) { return directive.directive.isComponent; });
                };
                TemplateParseVisitor.prototype._findComponentDirectiveNames = function (directives) {
                    return this._findComponentDirectives(directives)
                        .map(function (directive) { return identifierName(directive.directive.type); });
                };
                TemplateParseVisitor.prototype._assertOnlyOneComponent = function (directives, sourceSpan) {
                    var componentTypeNames = this._findComponentDirectiveNames(directives);
                    if (componentTypeNames.length > 1) {
                        this._reportError("More than one component matched on this element.\n" +
                            "Make sure that only one component's selector can match a given element.\n" +
                            ("Conflicting components: " + componentTypeNames.join(',')), sourceSpan);
                    }
                };
                /**
                 * Make sure that non-angular tags conform to the schemas.
                 *
                 * Note: An element is considered an angular tag when at least one directive selector matches the
                 * tag name.
                 *
                 * @param matchElement Whether any directive has matched on the tag name
                 * @param element the html element
                 */
                TemplateParseVisitor.prototype._assertElementExists = function (matchElement, element) {
                    var elName = element.name.replace(/^:xhtml:/, '');
                    if (!matchElement && !this._schemaRegistry.hasElement(elName, this._schemas)) {
                        var errorMsg = "'" + elName + "' is not a known element:\n";
                        errorMsg +=
                            "1. If '" + elName + "' is an Angular component, then verify that it is part of this module.\n";
                        if (elName.indexOf('-') > -1) {
                            errorMsg +=
                                "2. If '" + elName + "' is a Web Component then add 'CUSTOM_ELEMENTS_SCHEMA' to the '@NgModule.schemas' of this component to suppress this message.";
                        }
                        else {
                            errorMsg +=
                                "2. To allow any element add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
                        }
                        this._reportError(errorMsg, element.sourceSpan);
                    }
                };
                TemplateParseVisitor.prototype._assertNoComponentsNorElementBindingsOnTemplate = function (directives, elementProps, sourceSpan) {
                    var _this = this;
                    var componentTypeNames = this._findComponentDirectiveNames(directives);
                    if (componentTypeNames.length > 0) {
                        this._reportError("Components on an embedded template: " + componentTypeNames.join(','), sourceSpan);
                    }
                    elementProps.forEach(function (prop) {
                        _this._reportError("Property binding " + prop.name + " not used by any directive on an embedded template. Make sure that the property name is spelled correctly and all directives are listed in the \"@NgModule.declarations\".", sourceSpan);
                    });
                };
                TemplateParseVisitor.prototype._assertAllEventsPublishedByDirectives = function (directives, events) {
                    var _this = this;
                    var allDirectiveEvents = new Set();
                    directives.forEach(function (directive) {
                        Object.keys(directive.directive.outputs).forEach(function (k) {
                            var eventName = directive.directive.outputs[k];
                            allDirectiveEvents.add(eventName);
                        });
                    });
                    events.forEach(function (event) {
                        if (event.target != null || !allDirectiveEvents.has(event.name)) {
                            _this._reportError("Event binding " + event.fullName + " not emitted by any directive on an embedded template. Make sure that the event name is spelled correctly and all directives are listed in the \"@NgModule.declarations\".", event.sourceSpan);
                        }
                    });
                };
                TemplateParseVisitor.prototype._checkPropertiesInSchema = function (elementName, boundProps) {
                    var _this = this;
                    // Note: We can't filter out empty expressions before this method,
                    // as we still want to validate them!
                    return boundProps.filter(function (boundProp) {
                        if (boundProp.type === 0 /* Property */ &&
                            !_this._schemaRegistry.hasProperty(elementName, boundProp.name, _this._schemas)) {
                            var errorMsg = "Can't bind to '" + boundProp.name + "' since it isn't a known property of '" + elementName + "'.";
                            if (elementName.startsWith('ng-')) {
                                errorMsg +=
                                    "\n1. If '" + boundProp.name + "' is an Angular directive, then add 'CommonModule' to the '@NgModule.imports' of this component." +
                                        "\n2. To allow any property add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
                            }
                            else if (elementName.indexOf('-') > -1) {
                                errorMsg +=
                                    "\n1. If '" + elementName + "' is an Angular component and it has '" + boundProp.name + "' input, then verify that it is part of this module." +
                                        ("\n2. If '" + elementName + "' is a Web Component then add 'CUSTOM_ELEMENTS_SCHEMA' to the '@NgModule.schemas' of this component to suppress this message.") +
                                        "\n3. To allow any property add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
                            }
                            _this._reportError(errorMsg, boundProp.sourceSpan);
                        }
                        return !isEmptyExpression(boundProp.value);
                    });
                };
                TemplateParseVisitor.prototype._reportError = function (message, sourceSpan, level) {
                    if (level === void 0) { level = ParseErrorLevel.ERROR; }
                    this._targetErrors.push(new ParseError(sourceSpan, message, level));
                };
                return TemplateParseVisitor;
            }());
            var NonBindableVisitor = /** @class */ (function () {
                function NonBindableVisitor() {
                }
                NonBindableVisitor.prototype.visitElement = function (ast, parent) {
                    var preparsedElement = preparseElement(ast);
                    if (preparsedElement.type === PreparsedElementType.SCRIPT ||
                        preparsedElement.type === PreparsedElementType.STYLE ||
                        preparsedElement.type === PreparsedElementType.STYLESHEET) {
                        // Skipping <script> for security reasons
                        // Skipping <style> and stylesheets as we already processed them
                        // in the StyleCompiler
                        return null;
                    }
                    var attrNameAndValues = ast.attrs.map(function (attr) { return [attr.name, attr.value]; });
                    var selector = createElementCssSelector(ast.name, attrNameAndValues);
                    var ngContentIndex = parent.findNgContentIndex(selector);
                    var children = visitAll$1(this, ast.children, EMPTY_ELEMENT_CONTEXT);
                    return new ElementAst(ast.name, visitAll$1(this, ast.attrs), [], [], [], [], [], false, [], children, ngContentIndex, ast.sourceSpan, ast.endSourceSpan);
                };
                NonBindableVisitor.prototype.visitComment = function (comment, context) { return null; };
                NonBindableVisitor.prototype.visitAttribute = function (attribute, context) {
                    return new AttrAst(attribute.name, attribute.value, attribute.sourceSpan);
                };
                NonBindableVisitor.prototype.visitText = function (text, parent) {
                    var ngContentIndex = parent.findNgContentIndex(TEXT_CSS_SELECTOR());
                    return new TextAst(text.value, ngContentIndex, text.sourceSpan);
                };
                NonBindableVisitor.prototype.visitExpansion = function (expansion, context) { return expansion; };
                NonBindableVisitor.prototype.visitExpansionCase = function (expansionCase, context) { return expansionCase; };
                return NonBindableVisitor;
            }());
            /**
             * A reference to an element or directive in a template. E.g., the reference in this template:
             *
             * <div #myMenu="coolMenu">
             *
             * would be {name: 'myMenu', value: 'coolMenu', sourceSpan: ...}
             */
            var ElementOrDirectiveRef = /** @class */ (function () {
                function ElementOrDirectiveRef(name, value, sourceSpan) {
                    this.name = name;
                    this.value = value;
                    this.sourceSpan = sourceSpan;
                }
                /** Gets whether this is a reference to the given directive. */
                ElementOrDirectiveRef.prototype.isReferenceToDirective = function (directive) {
                    return splitExportAs(directive.exportAs).indexOf(this.value) !== -1;
                };
                return ElementOrDirectiveRef;
            }());
            /** Splits a raw, potentially comma-delimited `exportAs` value into an array of names. */
            function splitExportAs(exportAs) {
                return exportAs ? exportAs.split(',').map(function (e) { return e.trim(); }) : [];
            }
            function splitClasses(classAttrValue) {
                return classAttrValue.trim().split(/\s+/g);
            }
            var ElementContext = /** @class */ (function () {
                function ElementContext(isTemplateElement, _ngContentIndexMatcher, _wildcardNgContentIndex, providerContext) {
                    this.isTemplateElement = isTemplateElement;
                    this._ngContentIndexMatcher = _ngContentIndexMatcher;
                    this._wildcardNgContentIndex = _wildcardNgContentIndex;
                    this.providerContext = providerContext;
                }
                ElementContext.create = function (isTemplateElement, directives, providerContext) {
                    var matcher = new SelectorMatcher();
                    var wildcardNgContentIndex = null;
                    var component = directives.find(function (directive) { return directive.directive.isComponent; });
                    if (component) {
                        var ngContentSelectors = component.directive.template.ngContentSelectors;
                        for (var i = 0; i < ngContentSelectors.length; i++) {
                            var selector = ngContentSelectors[i];
                            if (selector === '*') {
                                wildcardNgContentIndex = i;
                            }
                            else {
                                matcher.addSelectables(CssSelector.parse(ngContentSelectors[i]), i);
                            }
                        }
                    }
                    return new ElementContext(isTemplateElement, matcher, wildcardNgContentIndex, providerContext);
                };
                ElementContext.prototype.findNgContentIndex = function (selector) {
                    var ngContentIndices = [];
                    this._ngContentIndexMatcher.match(selector, function (selector, ngContentIndex) { ngContentIndices.push(ngContentIndex); });
                    ngContentIndices.sort();
                    if (this._wildcardNgContentIndex != null) {
                        ngContentIndices.push(this._wildcardNgContentIndex);
                    }
                    return ngContentIndices.length > 0 ? ngContentIndices[0] : null;
                };
                return ElementContext;
            }());
            function createElementCssSelector(elementName, attributes) {
                var cssSelector = new CssSelector();
                var elNameNoNs = splitNsName(elementName)[1];
                cssSelector.setElement(elNameNoNs);
                for (var i = 0; i < attributes.length; i++) {
                    var attrName = attributes[i][0];
                    var attrNameNoNs = splitNsName(attrName)[1];
                    var attrValue = attributes[i][1];
                    cssSelector.addAttribute(attrNameNoNs, attrValue);
                    if (attrName.toLowerCase() == CLASS_ATTR) {
                        var classes = splitClasses(attrValue);
                        classes.forEach(function (className) { return cssSelector.addClassName(className); });
                    }
                }
                return cssSelector;
            }
            var EMPTY_ELEMENT_CONTEXT = new ElementContext(true, new SelectorMatcher(), null, null);
            var NON_BINDABLE_VISITOR = new NonBindableVisitor();
            function _isEmptyTextNode(node) {
                return node instanceof Text$3 && node.value.trim().length == 0;
            }
            function removeSummaryDuplicates(items) {
                var map = new Map();
                items.forEach(function (item) {
                    if (!map.get(item.type.reference)) {
                        map.set(item.type.reference, item);
                    }
                });
                return Array.from(map.values());
            }
            function isEmptyExpression(ast) {
                if (ast instanceof ASTWithSource) {
                    ast = ast.ast;
                }
                return ast instanceof EmptyExpr;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Parses string representation of a style and converts it into object literal.
             *
             * @param value string representation of style as used in the `style` attribute in HTML.
             *   Example: `color: red; height: auto`.
             * @returns An array of style property name and value pairs, e.g. `['color', 'red', 'height',
             * 'auto']`
             */
            function parse(value) {
                // we use a string array here instead of a string map
                // because a string-map is not guaranteed to retain the
                // order of the entries whereas a string array can be
                // construted in a [key, value, key, value] format.
                var styles = [];
                var i = 0;
                var parenDepth = 0;
                var quote = 0 /* QuoteNone */;
                var valueStart = 0;
                var propStart = 0;
                var currentProp = null;
                var valueHasQuotes = false;
                while (i < value.length) {
                    var token = value.charCodeAt(i++);
                    switch (token) {
                        case 40 /* OpenParen */:
                            parenDepth++;
                            break;
                        case 41 /* CloseParen */:
                            parenDepth--;
                            break;
                        case 39 /* QuoteSingle */:
                            // valueStart needs to be there since prop values don't
                            // have quotes in CSS
                            valueHasQuotes = valueHasQuotes || valueStart > 0;
                            if (quote === 0 /* QuoteNone */) {
                                quote = 39 /* QuoteSingle */;
                            }
                            else if (quote === 39 /* QuoteSingle */ && value.charCodeAt(i - 1) !== 92 /* BackSlash */) {
                                quote = 0 /* QuoteNone */;
                            }
                            break;
                        case 34 /* QuoteDouble */:
                            // same logic as above
                            valueHasQuotes = valueHasQuotes || valueStart > 0;
                            if (quote === 0 /* QuoteNone */) {
                                quote = 34 /* QuoteDouble */;
                            }
                            else if (quote === 34 /* QuoteDouble */ && value.charCodeAt(i - 1) !== 92 /* BackSlash */) {
                                quote = 0 /* QuoteNone */;
                            }
                            break;
                        case 58 /* Colon */:
                            if (!currentProp && parenDepth === 0 && quote === 0 /* QuoteNone */) {
                                currentProp = hyphenate(value.substring(propStart, i - 1).trim());
                                valueStart = i;
                            }
                            break;
                        case 59 /* Semicolon */:
                            if (currentProp && valueStart > 0 && parenDepth === 0 && quote === 0 /* QuoteNone */) {
                                var styleVal = value.substring(valueStart, i - 1).trim();
                                styles.push(currentProp, valueHasQuotes ? stripUnnecessaryQuotes(styleVal) : styleVal);
                                propStart = i;
                                valueStart = 0;
                                currentProp = null;
                                valueHasQuotes = false;
                            }
                            break;
                    }
                }
                if (currentProp && valueStart) {
                    var styleVal = value.substr(valueStart).trim();
                    styles.push(currentProp, valueHasQuotes ? stripUnnecessaryQuotes(styleVal) : styleVal);
                }
                return styles;
            }
            function stripUnnecessaryQuotes(value) {
                var qS = value.charCodeAt(0);
                var qE = value.charCodeAt(value.length - 1);
                if (qS == qE && (qS == 39 /* QuoteSingle */ || qS == 34 /* QuoteDouble */)) {
                    var tempValue = value.substring(1, value.length - 1);
                    // special case to avoid using a multi-quoted string that was just chomped
                    // (e.g. `font-family: "Verdana", "sans-serif"`)
                    if (tempValue.indexOf('\'') == -1 && tempValue.indexOf('"') == -1) {
                        value = tempValue;
                    }
                }
                return value;
            }
            function hyphenate(value) {
                return value.replace(/[a-z][A-Z]/g, function (v) {
                    return v.charAt(0) + '-' + v.charAt(1);
                }).toLowerCase();
            }
            var IMPORTANT_FLAG = '!important';
            /**
             * Produces creation/update instructions for all styling bindings (class and style)
             *
             * It also produces the creation instruction to register all initial styling values
             * (which are all the static class="..." and style="..." attribute values that exist
             * on an element within a template).
             *
             * The builder class below handles producing instructions for the following cases:
             *
             * - Static style/class attributes (style="..." and class="...")
             * - Dynamic style/class map bindings ([style]="map" and [class]="map|string")
             * - Dynamic style/class property bindings ([style.prop]="exp" and [class.name]="exp")
             *
             * Due to the complex relationship of all of these cases, the instructions generated
             * for these attributes/properties/bindings must be done so in the correct order. The
             * order which these must be generated is as follows:
             *
             * if (createMode) {
             *   styling(...)
             * }
             * if (updateMode) {
             *   styleMap(...)
             *   classMap(...)
             *   styleProp(...)
             *   classProp(...)
             *   stylingApply(...)
             * }
             *
             * The creation/update methods within the builder class produce these instructions.
             */
            var StylingBuilder = /** @class */ (function () {
                function StylingBuilder(_elementIndexExpr, _directiveExpr) {
                    this._elementIndexExpr = _elementIndexExpr;
                    this._directiveExpr = _directiveExpr;
                    /** Whether or not there are any static styling values present */
                    this._hasInitialValues = false;
                    /**
                     *  Whether or not there are any styling bindings present
                     *  (i.e. `[style]`, `[class]`, `[style.prop]` or `[class.name]`)
                     */
                    this.hasBindings = false;
                    /** the input for [class] (if it exists) */
                    this._classMapInput = null;
                    /** the input for [style] (if it exists) */
                    this._styleMapInput = null;
                    /** an array of each [style.prop] input */
                    this._singleStyleInputs = null;
                    /** an array of each [class.name] input */
                    this._singleClassInputs = null;
                    this._lastStylingInput = null;
                    this._firstStylingInput = null;
                    // maps are used instead of hash maps because a Map will
                    // retain the ordering of the keys
                    /**
                     * Represents the location of each style binding in the template
                     * (e.g. `<div [style.width]="w" [style.height]="h">` implies
                     * that `width=0` and `height=1`)
                     */
                    this._stylesIndex = new Map();
                    /**
                     * Represents the location of each class binding in the template
                     * (e.g. `<div [class.big]="b" [class.hidden]="h">` implies
                     * that `big=0` and `hidden=1`)
                     */
                    this._classesIndex = new Map();
                    this._initialStyleValues = [];
                    this._initialClassValues = [];
                    // certain style properties ALWAYS need sanitization
                    // this is checked each time new styles are encountered
                    this._useDefaultSanitizer = false;
                }
                /**
                 * Registers a given input to the styling builder to be later used when producing AOT code.
                 *
                 * The code below will only accept the input if it is somehow tied to styling (whether it be
                 * style/class bindings or static style/class attributes).
                 */
                StylingBuilder.prototype.registerBoundInput = function (input) {
                    // [attr.style] or [attr.class] are skipped in the code below,
                    // they should not be treated as styling-based bindings since
                    // they are intended to be written directly to the attr and
                    // will therefore skip all style/class resolution that is present
                    // with style="", [style]="" and [style.prop]="", class="",
                    // [class.prop]="". [class]="" assignments
                    var binding = null;
                    var name = input.name;
                    switch (input.type) {
                        case 0 /* Property */:
                            binding = this.registerInputBasedOnName(name, input.value, input.sourceSpan);
                            break;
                        case 3 /* Style */:
                            binding = this.registerStyleInput(name, false, input.value, input.sourceSpan, input.unit);
                            break;
                        case 2 /* Class */:
                            binding = this.registerClassInput(name, false, input.value, input.sourceSpan);
                            break;
                    }
                    return binding ? true : false;
                };
                StylingBuilder.prototype.registerInputBasedOnName = function (name, expression, sourceSpan) {
                    var binding = null;
                    var nameToMatch = name.substring(0, 5); // class | style
                    var isStyle = nameToMatch === 'style';
                    var isClass = isStyle ? false : (nameToMatch === 'class');
                    if (isStyle || isClass) {
                        var isMapBased = name.charAt(5) !== '.'; // style.prop or class.prop makes this a no
                        var property = name.substr(isMapBased ? 5 : 6); // the dot explains why there's a +1
                        if (isStyle) {
                            binding = this.registerStyleInput(property, isMapBased, expression, sourceSpan);
                        }
                        else {
                            binding = this.registerClassInput(property, isMapBased, expression, sourceSpan);
                        }
                    }
                    return binding;
                };
                StylingBuilder.prototype.registerStyleInput = function (name, isMapBased, value, sourceSpan, unit) {
                    if (isEmptyExpression(value)) {
                        return null;
                    }
                    name = normalizePropName(name);
                    var _c = parseProperty(name), property = _c.property, hasOverrideFlag = _c.hasOverrideFlag, bindingUnit = _c.unit;
                    var entry = {
                        name: property,
                        unit: unit || bindingUnit, value: value, sourceSpan: sourceSpan, hasOverrideFlag: hasOverrideFlag
                    };
                    if (isMapBased) {
                        this._useDefaultSanitizer = true;
                        this._styleMapInput = entry;
                    }
                    else {
                        (this._singleStyleInputs = this._singleStyleInputs || []).push(entry);
                        this._useDefaultSanitizer = this._useDefaultSanitizer || isStyleSanitizable(name);
                        registerIntoMap(this._stylesIndex, property);
                    }
                    this._lastStylingInput = entry;
                    this._firstStylingInput = this._firstStylingInput || entry;
                    this.hasBindings = true;
                    return entry;
                };
                StylingBuilder.prototype.registerClassInput = function (name, isMapBased, value, sourceSpan) {
                    if (isEmptyExpression(value)) {
                        return null;
                    }
                    var _c = parseProperty(name), property = _c.property, hasOverrideFlag = _c.hasOverrideFlag;
                    var entry = { name: property, value: value, sourceSpan: sourceSpan, hasOverrideFlag: hasOverrideFlag, unit: null };
                    if (isMapBased) {
                        this._classMapInput = entry;
                    }
                    else {
                        (this._singleClassInputs = this._singleClassInputs || []).push(entry);
                        registerIntoMap(this._classesIndex, property);
                    }
                    this._lastStylingInput = entry;
                    this._firstStylingInput = this._firstStylingInput || entry;
                    this.hasBindings = true;
                    return entry;
                };
                /**
                 * Registers the element's static style string value to the builder.
                 *
                 * @param value the style string (e.g. `width:100px; height:200px;`)
                 */
                StylingBuilder.prototype.registerStyleAttr = function (value) {
                    this._initialStyleValues = parse(value);
                    this._hasInitialValues = true;
                };
                /**
                 * Registers the element's static class string value to the builder.
                 *
                 * @param value the className string (e.g. `disabled gold zoom`)
                 */
                StylingBuilder.prototype.registerClassAttr = function (value) {
                    this._initialClassValues = value.trim().split(/\s+/g);
                    this._hasInitialValues = true;
                };
                /**
                 * Appends all styling-related expressions to the provided attrs array.
                 *
                 * @param attrs an existing array where each of the styling expressions
                 * will be inserted into.
                 */
                StylingBuilder.prototype.populateInitialStylingAttrs = function (attrs) {
                    // [CLASS_MARKER, 'foo', 'bar', 'baz' ...]
                    if (this._initialClassValues.length) {
                        attrs.push(literal(1 /* Classes */));
                        for (var i = 0; i < this._initialClassValues.length; i++) {
                            attrs.push(literal(this._initialClassValues[i]));
                        }
                    }
                    // [STYLE_MARKER, 'width', '200px', 'height', '100px', ...]
                    if (this._initialStyleValues.length) {
                        attrs.push(literal(2 /* Styles */));
                        for (var i = 0; i < this._initialStyleValues.length; i += 2) {
                            attrs.push(literal(this._initialStyleValues[i]), literal(this._initialStyleValues[i + 1]));
                        }
                    }
                };
                /**
                 * Builds an instruction with all the expressions and parameters for `elementHostAttrs`.
                 *
                 * The instruction generation code below is used for producing the AOT statement code which is
                 * responsible for registering initial styles (within a directive hostBindings' creation block),
                 * as well as any of the provided attribute values, to the directive host element.
                 */
                StylingBuilder.prototype.buildHostAttrsInstruction = function (sourceSpan, attrs, constantPool) {
                    var _this = this;
                    if (this._directiveExpr && (attrs.length || this._hasInitialValues)) {
                        return {
                            sourceSpan: sourceSpan,
                            reference: Identifiers$1.elementHostAttrs,
                            allocateBindingSlots: 0,
                            params: function () {
                                // params => elementHostAttrs(attrs)
                                _this.populateInitialStylingAttrs(attrs);
                                var attrArray = !attrs.some(function (attr) { return attr instanceof WrappedNodeExpr; }) ?
                                    getConstantLiteralFromArray(constantPool, attrs) :
                                    literalArr(attrs);
                                return [attrArray];
                            }
                        };
                    }
                    return null;
                };
                /**
                 * Builds an instruction with all the expressions and parameters for `styling`.
                 *
                 * The instruction generation code below is used for producing the AOT statement code which is
                 * responsible for registering style/class bindings to an element.
                 */
                StylingBuilder.prototype.buildStylingInstruction = function (sourceSpan, constantPool) {
                    if (this.hasBindings) {
                        return {
                            sourceSpan: sourceSpan,
                            allocateBindingSlots: 0,
                            reference: Identifiers$1.styling,
                            params: function () { return []; },
                        };
                    }
                    return null;
                };
                /**
                 * Builds an instruction with all the expressions and parameters for `classMap`.
                 *
                 * The instruction data will contain all expressions for `classMap` to function
                 * which includes the `[class]` expression params.
                 */
                StylingBuilder.prototype.buildClassMapInstruction = function (valueConverter) {
                    if (this._classMapInput) {
                        return this._buildMapBasedInstruction(valueConverter, true, this._classMapInput);
                    }
                    return null;
                };
                /**
                 * Builds an instruction with all the expressions and parameters for `styleMap`.
                 *
                 * The instruction data will contain all expressions for `styleMap` to function
                 * which includes the `[style]` expression params.
                 */
                StylingBuilder.prototype.buildStyleMapInstruction = function (valueConverter) {
                    if (this._styleMapInput) {
                        return this._buildMapBasedInstruction(valueConverter, false, this._styleMapInput);
                    }
                    return null;
                };
                StylingBuilder.prototype._buildMapBasedInstruction = function (valueConverter, isClassBased, stylingInput) {
                    // each styling binding value is stored in the LView
                    var totalBindingSlotsRequired = 1;
                    // these values must be outside of the update block so that they can
                    // be evaluated (the AST visit call) during creation time so that any
                    // pipes can be picked up in time before the template is built
                    var mapValue = stylingInput.value.visit(valueConverter);
                    var reference;
                    if (mapValue instanceof Interpolation && isClassBased) {
                        totalBindingSlotsRequired += mapValue.expressions.length;
                        reference = getClassMapInterpolationExpression(mapValue);
                    }
                    else {
                        reference = isClassBased ? Identifiers$1.classMap : Identifiers$1.styleMap;
                    }
                    return {
                        sourceSpan: stylingInput.sourceSpan,
                        reference: reference,
                        allocateBindingSlots: totalBindingSlotsRequired,
                        supportsInterpolation: isClassBased,
                        params: function (convertFn) {
                            var convertResult = convertFn(mapValue);
                            return Array.isArray(convertResult) ? convertResult : [convertResult];
                        }
                    };
                };
                StylingBuilder.prototype._buildSingleInputs = function (reference, inputs, mapIndex, allowUnits, valueConverter, getInterpolationExpressionFn) {
                    var totalBindingSlotsRequired = 0;
                    return inputs.map(function (input) {
                        var value = input.value.visit(valueConverter);
                        // each styling binding value is stored in the LView
                        var totalBindingSlotsRequired = 1;
                        if (value instanceof Interpolation) {
                            totalBindingSlotsRequired += value.expressions.length;
                            if (getInterpolationExpressionFn) {
                                reference = getInterpolationExpressionFn(value);
                            }
                        }
                        return {
                            sourceSpan: input.sourceSpan,
                            supportsInterpolation: !!getInterpolationExpressionFn,
                            allocateBindingSlots: totalBindingSlotsRequired, reference: reference,
                            params: function (convertFn) {
                                // params => stylingProp(propName, value)
                                var params = [];
                                params.push(literal(input.name));
                                var convertResult = convertFn(value);
                                if (Array.isArray(convertResult)) {
                                    params.push.apply(params, convertResult);
                                }
                                else {
                                    params.push(convertResult);
                                }
                                if (allowUnits && input.unit) {
                                    params.push(literal(input.unit));
                                }
                                return params;
                            }
                        };
                    });
                };
                StylingBuilder.prototype._buildClassInputs = function (valueConverter) {
                    if (this._singleClassInputs) {
                        return this._buildSingleInputs(Identifiers$1.classProp, this._singleClassInputs, this._classesIndex, false, valueConverter);
                    }
                    return [];
                };
                StylingBuilder.prototype._buildStyleInputs = function (valueConverter) {
                    if (this._singleStyleInputs) {
                        return this._buildSingleInputs(Identifiers$1.styleProp, this._singleStyleInputs, this._stylesIndex, true, valueConverter, getStylePropInterpolationExpression);
                    }
                    return [];
                };
                StylingBuilder.prototype._buildApplyFn = function () {
                    return {
                        sourceSpan: this._lastStylingInput ? this._lastStylingInput.sourceSpan : null,
                        reference: Identifiers$1.stylingApply,
                        allocateBindingSlots: 0,
                        params: function () { return []; }
                    };
                };
                StylingBuilder.prototype._buildSanitizerFn = function () {
                    return {
                        sourceSpan: this._firstStylingInput ? this._firstStylingInput.sourceSpan : null,
                        reference: Identifiers$1.styleSanitizer,
                        allocateBindingSlots: 0,
                        params: function () { return [importExpr(Identifiers$1.defaultStyleSanitizer)]; }
                    };
                };
                /**
                 * Constructs all instructions which contain the expressions that will be placed
                 * into the update block of a template function or a directive hostBindings function.
                 */
                StylingBuilder.prototype.buildUpdateLevelInstructions = function (valueConverter) {
                    var instructions = [];
                    if (this.hasBindings) {
                        if (this._useDefaultSanitizer) {
                            instructions.push(this._buildSanitizerFn());
                        }
                        var styleMapInstruction = this.buildStyleMapInstruction(valueConverter);
                        if (styleMapInstruction) {
                            instructions.push(styleMapInstruction);
                        }
                        var classMapInstruction = this.buildClassMapInstruction(valueConverter);
                        if (classMapInstruction) {
                            instructions.push(classMapInstruction);
                        }
                        instructions.push.apply(instructions, this._buildStyleInputs(valueConverter));
                        instructions.push.apply(instructions, this._buildClassInputs(valueConverter));
                        instructions.push(this._buildApplyFn());
                    }
                    return instructions;
                };
                return StylingBuilder;
            }());
            function registerIntoMap(map, key) {
                if (!map.has(key)) {
                    map.set(key, map.size);
                }
            }
            function isStyleSanitizable(prop) {
                // Note that browsers support both the dash case and
                // camel case property names when setting through JS.
                return prop === 'background-image' || prop === 'backgroundImage' || prop === 'background' ||
                    prop === 'border-image' || prop === 'borderImage' || prop === 'filter' ||
                    prop === 'list-style' || prop === 'listStyle' || prop === 'list-style-image' ||
                    prop === 'listStyleImage' || prop === 'clip-path' || prop === 'clipPath';
            }
            /**
             * Simple helper function to either provide the constant literal that will house the value
             * here or a null value if the provided values are empty.
             */
            function getConstantLiteralFromArray(constantPool, values) {
                return values.length ? constantPool.getConstLiteral(literalArr(values), true) : NULL_EXPR;
            }
            /**
             * Simple helper function that adds a parameter or does nothing at all depending on the provided
             * predicate and totalExpectedArgs values
             */
            function addParam(params, predicate, value, argNumber, totalExpectedArgs) {
                if (predicate && value) {
                    params.push(value);
                }
                else if (argNumber < totalExpectedArgs) {
                    params.push(NULL_EXPR);
                }
            }
            function parseProperty(name) {
                var hasOverrideFlag = false;
                var overrideIndex = name.indexOf(IMPORTANT_FLAG);
                if (overrideIndex !== -1) {
                    name = overrideIndex > 0 ? name.substring(0, overrideIndex) : '';
                    hasOverrideFlag = true;
                }
                var unit = '';
                var property = name;
                var unitIndex = name.lastIndexOf('.');
                if (unitIndex > 0) {
                    unit = name.substr(unitIndex + 1);
                    property = name.substring(0, unitIndex);
                }
                return { property: property, unit: unit, hasOverrideFlag: hasOverrideFlag };
            }
            /**
             * Gets the instruction to generate for an interpolated class map.
             * @param interpolation An Interpolation AST
             */
            function getClassMapInterpolationExpression(interpolation) {
                switch (getInterpolationArgsLength(interpolation)) {
                    case 1:
                        return Identifiers$1.classMap;
                    case 3:
                        return Identifiers$1.classMapInterpolate1;
                    case 5:
                        return Identifiers$1.classMapInterpolate2;
                    case 7:
                        return Identifiers$1.classMapInterpolate3;
                    case 9:
                        return Identifiers$1.classMapInterpolate4;
                    case 11:
                        return Identifiers$1.classMapInterpolate5;
                    case 13:
                        return Identifiers$1.classMapInterpolate6;
                    case 15:
                        return Identifiers$1.classMapInterpolate7;
                    case 17:
                        return Identifiers$1.classMapInterpolate8;
                    default:
                        return Identifiers$1.classMapInterpolateV;
                }
            }
            /**
             * Gets the instruction to generate for an interpolated style prop.
             * @param interpolation An Interpolation AST
             */
            function getStylePropInterpolationExpression(interpolation) {
                switch (getInterpolationArgsLength(interpolation)) {
                    case 1:
                        return Identifiers$1.styleProp;
                    case 3:
                        return Identifiers$1.stylePropInterpolate1;
                    case 5:
                        return Identifiers$1.stylePropInterpolate2;
                    case 7:
                        return Identifiers$1.stylePropInterpolate3;
                    case 9:
                        return Identifiers$1.stylePropInterpolate4;
                    case 11:
                        return Identifiers$1.stylePropInterpolate5;
                    case 13:
                        return Identifiers$1.stylePropInterpolate6;
                    case 15:
                        return Identifiers$1.stylePropInterpolate7;
                    case 17:
                        return Identifiers$1.stylePropInterpolate8;
                    default:
                        return Identifiers$1.stylePropInterpolateV;
                }
            }
            function normalizePropName(prop) {
                return hyphenate(prop);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TokenType$1;
            (function (TokenType) {
                TokenType[TokenType["Character"] = 0] = "Character";
                TokenType[TokenType["Identifier"] = 1] = "Identifier";
                TokenType[TokenType["Keyword"] = 2] = "Keyword";
                TokenType[TokenType["String"] = 3] = "String";
                TokenType[TokenType["Operator"] = 4] = "Operator";
                TokenType[TokenType["Number"] = 5] = "Number";
                TokenType[TokenType["Error"] = 6] = "Error";
            })(TokenType$1 || (TokenType$1 = {}));
            var KEYWORDS = ['var', 'let', 'as', 'null', 'undefined', 'true', 'false', 'if', 'else', 'this'];
            var Lexer = /** @class */ (function () {
                function Lexer() {
                }
                Lexer.prototype.tokenize = function (text) {
                    var scanner = new _Scanner(text);
                    var tokens = [];
                    var token = scanner.scanToken();
                    while (token != null) {
                        tokens.push(token);
                        token = scanner.scanToken();
                    }
                    return tokens;
                };
                return Lexer;
            }());
            var Token$1 = /** @class */ (function () {
                function Token$1(index, type, numValue, strValue) {
                    this.index = index;
                    this.type = type;
                    this.numValue = numValue;
                    this.strValue = strValue;
                }
                Token$1.prototype.isCharacter = function (code) {
                    return this.type == TokenType$1.Character && this.numValue == code;
                };
                Token$1.prototype.isNumber = function () { return this.type == TokenType$1.Number; };
                Token$1.prototype.isString = function () { return this.type == TokenType$1.String; };
                Token$1.prototype.isOperator = function (operator) {
                    return this.type == TokenType$1.Operator && this.strValue == operator;
                };
                Token$1.prototype.isIdentifier = function () { return this.type == TokenType$1.Identifier; };
                Token$1.prototype.isKeyword = function () { return this.type == TokenType$1.Keyword; };
                Token$1.prototype.isKeywordLet = function () { return this.type == TokenType$1.Keyword && this.strValue == 'let'; };
                Token$1.prototype.isKeywordAs = function () { return this.type == TokenType$1.Keyword && this.strValue == 'as'; };
                Token$1.prototype.isKeywordNull = function () { return this.type == TokenType$1.Keyword && this.strValue == 'null'; };
                Token$1.prototype.isKeywordUndefined = function () {
                    return this.type == TokenType$1.Keyword && this.strValue == 'undefined';
                };
                Token$1.prototype.isKeywordTrue = function () { return this.type == TokenType$1.Keyword && this.strValue == 'true'; };
                Token$1.prototype.isKeywordFalse = function () { return this.type == TokenType$1.Keyword && this.strValue == 'false'; };
                Token$1.prototype.isKeywordThis = function () { return this.type == TokenType$1.Keyword && this.strValue == 'this'; };
                Token$1.prototype.isError = function () { return this.type == TokenType$1.Error; };
                Token$1.prototype.toNumber = function () { return this.type == TokenType$1.Number ? this.numValue : -1; };
                Token$1.prototype.toString = function () {
                    switch (this.type) {
                        case TokenType$1.Character:
                        case TokenType$1.Identifier:
                        case TokenType$1.Keyword:
                        case TokenType$1.Operator:
                        case TokenType$1.String:
                        case TokenType$1.Error:
                            return this.strValue;
                        case TokenType$1.Number:
                            return this.numValue.toString();
                        default:
                            return null;
                    }
                };
                return Token$1;
            }());
            function newCharacterToken(index, code) {
                return new Token$1(index, TokenType$1.Character, code, String.fromCharCode(code));
            }
            function newIdentifierToken(index, text) {
                return new Token$1(index, TokenType$1.Identifier, 0, text);
            }
            function newKeywordToken(index, text) {
                return new Token$1(index, TokenType$1.Keyword, 0, text);
            }
            function newOperatorToken(index, text) {
                return new Token$1(index, TokenType$1.Operator, 0, text);
            }
            function newStringToken(index, text) {
                return new Token$1(index, TokenType$1.String, 0, text);
            }
            function newNumberToken(index, n) {
                return new Token$1(index, TokenType$1.Number, n, '');
            }
            function newErrorToken(index, message) {
                return new Token$1(index, TokenType$1.Error, 0, message);
            }
            var EOF = new Token$1(-1, TokenType$1.Character, 0, '');
            var _Scanner = /** @class */ (function () {
                function _Scanner(input) {
                    this.input = input;
                    this.peek = 0;
                    this.index = -1;
                    this.length = input.length;
                    this.advance();
                }
                _Scanner.prototype.advance = function () {
                    this.peek = ++this.index >= this.length ? $EOF : this.input.charCodeAt(this.index);
                };
                _Scanner.prototype.scanToken = function () {
                    var input = this.input, length = this.length;
                    var peek = this.peek, index = this.index;
                    // Skip whitespace.
                    while (peek <= $SPACE) {
                        if (++index >= length) {
                            peek = $EOF;
                            break;
                        }
                        else {
                            peek = input.charCodeAt(index);
                        }
                    }
                    this.peek = peek;
                    this.index = index;
                    if (index >= length) {
                        return null;
                    }
                    // Handle identifiers and numbers.
                    if (isIdentifierStart(peek))
                        return this.scanIdentifier();
                    if (isDigit(peek))
                        return this.scanNumber(index);
                    var start = index;
                    switch (peek) {
                        case $PERIOD:
                            this.advance();
                            return isDigit(this.peek) ? this.scanNumber(start) :
                                newCharacterToken(start, $PERIOD);
                        case $LPAREN:
                        case $RPAREN:
                        case $LBRACE:
                        case $RBRACE:
                        case $LBRACKET:
                        case $RBRACKET:
                        case $COMMA:
                        case $COLON:
                        case $SEMICOLON:
                            return this.scanCharacter(start, peek);
                        case $SQ:
                        case $DQ:
                            return this.scanString();
                        case $HASH:
                        case $PLUS:
                        case $MINUS:
                        case $STAR:
                        case $SLASH:
                        case $PERCENT:
                        case $CARET:
                            return this.scanOperator(start, String.fromCharCode(peek));
                        case $QUESTION:
                            return this.scanComplexOperator(start, '?', $PERIOD, '.');
                        case $LT:
                        case $GT:
                            return this.scanComplexOperator(start, String.fromCharCode(peek), $EQ, '=');
                        case $BANG:
                        case $EQ:
                            return this.scanComplexOperator(start, String.fromCharCode(peek), $EQ, '=', $EQ, '=');
                        case $AMPERSAND:
                            return this.scanComplexOperator(start, '&', $AMPERSAND, '&');
                        case $BAR:
                            return this.scanComplexOperator(start, '|', $BAR, '|');
                        case $NBSP:
                            while (isWhitespace(this.peek))
                                this.advance();
                            return this.scanToken();
                    }
                    this.advance();
                    return this.error("Unexpected character [" + String.fromCharCode(peek) + "]", 0);
                };
                _Scanner.prototype.scanCharacter = function (start, code) {
                    this.advance();
                    return newCharacterToken(start, code);
                };
                _Scanner.prototype.scanOperator = function (start, str) {
                    this.advance();
                    return newOperatorToken(start, str);
                };
                /**
                 * Tokenize a 2/3 char long operator
                 *
                 * @param start start index in the expression
                 * @param one first symbol (always part of the operator)
                 * @param twoCode code point for the second symbol
                 * @param two second symbol (part of the operator when the second code point matches)
                 * @param threeCode code point for the third symbol
                 * @param three third symbol (part of the operator when provided and matches source expression)
                 */
                _Scanner.prototype.scanComplexOperator = function (start, one, twoCode, two, threeCode, three) {
                    this.advance();
                    var str = one;
                    if (this.peek == twoCode) {
                        this.advance();
                        str += two;
                    }
                    if (threeCode != null && this.peek == threeCode) {
                        this.advance();
                        str += three;
                    }
                    return newOperatorToken(start, str);
                };
                _Scanner.prototype.scanIdentifier = function () {
                    var start = this.index;
                    this.advance();
                    while (isIdentifierPart(this.peek))
                        this.advance();
                    var str = this.input.substring(start, this.index);
                    return KEYWORDS.indexOf(str) > -1 ? newKeywordToken(start, str) :
                        newIdentifierToken(start, str);
                };
                _Scanner.prototype.scanNumber = function (start) {
                    var simple = (this.index === start);
                    this.advance(); // Skip initial digit.
                    while (true) {
                        if (isDigit(this.peek)) {
                            // Do nothing.
                        }
                        else if (this.peek == $PERIOD) {
                            simple = false;
                        }
                        else if (isExponentStart(this.peek)) {
                            this.advance();
                            if (isExponentSign(this.peek))
                                this.advance();
                            if (!isDigit(this.peek))
                                return this.error('Invalid exponent', -1);
                            simple = false;
                        }
                        else {
                            break;
                        }
                        this.advance();
                    }
                    var str = this.input.substring(start, this.index);
                    var value = simple ? parseIntAutoRadix(str) : parseFloat(str);
                    return newNumberToken(start, value);
                };
                _Scanner.prototype.scanString = function () {
                    var start = this.index;
                    var quote = this.peek;
                    this.advance(); // Skip initial quote.
                    var buffer = '';
                    var marker = this.index;
                    var input = this.input;
                    while (this.peek != quote) {
                        if (this.peek == $BACKSLASH) {
                            buffer += input.substring(marker, this.index);
                            this.advance();
                            var unescapedCode = void 0;
                            // Workaround for TS2.1-introduced type strictness
                            this.peek = this.peek;
                            if (this.peek == $u) {
                                // 4 character hex code for unicode character.
                                var hex = input.substring(this.index + 1, this.index + 5);
                                if (/^[0-9a-f]+$/i.test(hex)) {
                                    unescapedCode = parseInt(hex, 16);
                                }
                                else {
                                    return this.error("Invalid unicode escape [\\u" + hex + "]", 0);
                                }
                                for (var i = 0; i < 5; i++) {
                                    this.advance();
                                }
                            }
                            else {
                                unescapedCode = unescape(this.peek);
                                this.advance();
                            }
                            buffer += String.fromCharCode(unescapedCode);
                            marker = this.index;
                        }
                        else if (this.peek == $EOF) {
                            return this.error('Unterminated quote', 0);
                        }
                        else {
                            this.advance();
                        }
                    }
                    var last = input.substring(marker, this.index);
                    this.advance(); // Skip terminating quote.
                    return newStringToken(start, buffer + last);
                };
                _Scanner.prototype.error = function (message, offset) {
                    var position = this.index + offset;
                    return newErrorToken(position, "Lexer Error: " + message + " at column " + position + " in expression [" + this.input + "]");
                };
                return _Scanner;
            }());
            function isIdentifierStart(code) {
                return ($a <= code && code <= $z) || ($A <= code && code <= $Z) ||
                    (code == $_) || (code == $$);
            }
            function isIdentifier(input) {
                if (input.length == 0)
                    return false;
                var scanner = new _Scanner(input);
                if (!isIdentifierStart(scanner.peek))
                    return false;
                scanner.advance();
                while (scanner.peek !== $EOF) {
                    if (!isIdentifierPart(scanner.peek))
                        return false;
                    scanner.advance();
                }
                return true;
            }
            function isIdentifierPart(code) {
                return isAsciiLetter(code) || isDigit(code) || (code == $_) ||
                    (code == $$);
            }
            function isExponentStart(code) {
                return code == $e || code == $E;
            }
            function isExponentSign(code) {
                return code == $MINUS || code == $PLUS;
            }
            function isQuote(code) {
                return code === $SQ || code === $DQ || code === $BT;
            }
            function unescape(code) {
                switch (code) {
                    case $n:
                        return $LF;
                    case $f:
                        return $FF;
                    case $r:
                        return $CR;
                    case $t:
                        return $TAB;
                    case $v:
                        return $VTAB;
                    default:
                        return code;
                }
            }
            function parseIntAutoRadix(text) {
                var result = parseInt(text);
                if (isNaN(result)) {
                    throw new Error('Invalid integer literal when parsing ' + text);
                }
                return result;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var SplitInterpolation = /** @class */ (function () {
                function SplitInterpolation(strings, expressions, offsets) {
                    this.strings = strings;
                    this.expressions = expressions;
                    this.offsets = offsets;
                }
                return SplitInterpolation;
            }());
            var TemplateBindingParseResult = /** @class */ (function () {
                function TemplateBindingParseResult(templateBindings, warnings, errors) {
                    this.templateBindings = templateBindings;
                    this.warnings = warnings;
                    this.errors = errors;
                }
                return TemplateBindingParseResult;
            }());
            function _createInterpolateRegExp(config) {
                var pattern = escapeRegExp(config.start) + '([\\s\\S]*?)' + escapeRegExp(config.end);
                return new RegExp(pattern, 'g');
            }
            var Parser$1 = /** @class */ (function () {
                function Parser$1(_lexer) {
                    this._lexer = _lexer;
                    this.errors = [];
                }
                Parser$1.prototype.parseAction = function (input, location, absoluteOffset, interpolationConfig) {
                    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                    this._checkNoInterpolation(input, location, interpolationConfig);
                    var sourceToLex = this._stripComments(input);
                    var tokens = this._lexer.tokenize(this._stripComments(input));
                    var ast = new _ParseAST(input, location, absoluteOffset, tokens, sourceToLex.length, true, this.errors, input.length - sourceToLex.length)
                        .parseChain();
                    return new ASTWithSource(ast, input, location, absoluteOffset, this.errors);
                };
                Parser$1.prototype.parseBinding = function (input, location, absoluteOffset, interpolationConfig) {
                    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                    var ast = this._parseBindingAst(input, location, absoluteOffset, interpolationConfig);
                    return new ASTWithSource(ast, input, location, absoluteOffset, this.errors);
                };
                Parser$1.prototype.parseSimpleBinding = function (input, location, absoluteOffset, interpolationConfig) {
                    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                    var ast = this._parseBindingAst(input, location, absoluteOffset, interpolationConfig);
                    var errors = SimpleExpressionChecker.check(ast);
                    if (errors.length > 0) {
                        this._reportError("Host binding expression cannot contain " + errors.join(' '), input, location);
                    }
                    return new ASTWithSource(ast, input, location, absoluteOffset, this.errors);
                };
                Parser$1.prototype._reportError = function (message, input, errLocation, ctxLocation) {
                    this.errors.push(new ParserError(message, input, errLocation, ctxLocation));
                };
                Parser$1.prototype._parseBindingAst = function (input, location, absoluteOffset, interpolationConfig) {
                    // Quotes expressions use 3rd-party expression language. We don't want to use
                    // our lexer or parser for that, so we check for that ahead of time.
                    var quote = this._parseQuote(input, location);
                    if (quote != null) {
                        return quote;
                    }
                    this._checkNoInterpolation(input, location, interpolationConfig);
                    var sourceToLex = this._stripComments(input);
                    var tokens = this._lexer.tokenize(sourceToLex);
                    return new _ParseAST(input, location, absoluteOffset, tokens, sourceToLex.length, false, this.errors, input.length - sourceToLex.length)
                        .parseChain();
                };
                Parser$1.prototype._parseQuote = function (input, location) {
                    if (input == null)
                        return null;
                    var prefixSeparatorIndex = input.indexOf(':');
                    if (prefixSeparatorIndex == -1)
                        return null;
                    var prefix = input.substring(0, prefixSeparatorIndex).trim();
                    if (!isIdentifier(prefix))
                        return null;
                    var uninterpretedExpression = input.substring(prefixSeparatorIndex + 1);
                    return new Quote(new ParseSpan(0, input.length), prefix, uninterpretedExpression, location);
                };
                Parser$1.prototype.parseTemplateBindings = function (tplKey, tplValue, location, absoluteOffset) {
                    var tokens = this._lexer.tokenize(tplValue);
                    return new _ParseAST(tplValue, location, absoluteOffset, tokens, tplValue.length, false, this.errors, 0)
                        .parseTemplateBindings(tplKey);
                };
                Parser$1.prototype.parseInterpolation = function (input, location, absoluteOffset, interpolationConfig) {
                    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                    var split = this.splitInterpolation(input, location, interpolationConfig);
                    if (split == null)
                        return null;
                    var expressions = [];
                    for (var i = 0; i < split.expressions.length; ++i) {
                        var expressionText = split.expressions[i];
                        var sourceToLex = this._stripComments(expressionText);
                        var tokens = this._lexer.tokenize(sourceToLex);
                        var ast = new _ParseAST(input, location, absoluteOffset, tokens, sourceToLex.length, false, this.errors, split.offsets[i] + (expressionText.length - sourceToLex.length))
                            .parseChain();
                        expressions.push(ast);
                    }
                    return new ASTWithSource(new Interpolation(new ParseSpan(0, input == null ? 0 : input.length), split.strings, expressions), input, location, absoluteOffset, this.errors);
                };
                Parser$1.prototype.splitInterpolation = function (input, location, interpolationConfig) {
                    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                    var regexp = _createInterpolateRegExp(interpolationConfig);
                    var parts = input.split(regexp);
                    if (parts.length <= 1) {
                        return null;
                    }
                    var strings = [];
                    var expressions = [];
                    var offsets = [];
                    var offset = 0;
                    for (var i = 0; i < parts.length; i++) {
                        var part = parts[i];
                        if (i % 2 === 0) {
                            // fixed string
                            strings.push(part);
                            offset += part.length;
                        }
                        else if (part.trim().length > 0) {
                            offset += interpolationConfig.start.length;
                            expressions.push(part);
                            offsets.push(offset);
                            offset += part.length + interpolationConfig.end.length;
                        }
                        else {
                            this._reportError('Blank expressions are not allowed in interpolated strings', input, "at column " + this._findInterpolationErrorColumn(parts, i, interpolationConfig) + " in", location);
                            expressions.push('$implict');
                            offsets.push(offset);
                        }
                    }
                    return new SplitInterpolation(strings, expressions, offsets);
                };
                Parser$1.prototype.wrapLiteralPrimitive = function (input, location, absoluteOffset) {
                    return new ASTWithSource(new LiteralPrimitive(new ParseSpan(0, input == null ? 0 : input.length), input), input, location, absoluteOffset, this.errors);
                };
                Parser$1.prototype._stripComments = function (input) {
                    var i = this._commentStart(input);
                    return i != null ? input.substring(0, i).trim() : input;
                };
                Parser$1.prototype._commentStart = function (input) {
                    var outerQuote = null;
                    for (var i = 0; i < input.length - 1; i++) {
                        var char = input.charCodeAt(i);
                        var nextChar = input.charCodeAt(i + 1);
                        if (char === $SLASH && nextChar == $SLASH && outerQuote == null)
                            return i;
                        if (outerQuote === char) {
                            outerQuote = null;
                        }
                        else if (outerQuote == null && isQuote(char)) {
                            outerQuote = char;
                        }
                    }
                    return null;
                };
                Parser$1.prototype._checkNoInterpolation = function (input, location, interpolationConfig) {
                    var regexp = _createInterpolateRegExp(interpolationConfig);
                    var parts = input.split(regexp);
                    if (parts.length > 1) {
                        this._reportError("Got interpolation (" + interpolationConfig.start + interpolationConfig.end + ") where expression was expected", input, "at column " + this._findInterpolationErrorColumn(parts, 1, interpolationConfig) + " in", location);
                    }
                };
                Parser$1.prototype._findInterpolationErrorColumn = function (parts, partInErrIdx, interpolationConfig) {
                    var errLocation = '';
                    for (var j = 0; j < partInErrIdx; j++) {
                        errLocation += j % 2 === 0 ?
                            parts[j] :
                            "" + interpolationConfig.start + parts[j] + interpolationConfig.end;
                    }
                    return errLocation.length;
                };
                return Parser$1;
            }());
            var _ParseAST = /** @class */ (function () {
                function _ParseAST(input, location, absoluteOffset, tokens, inputLength, parseAction, errors, offset) {
                    this.input = input;
                    this.location = location;
                    this.absoluteOffset = absoluteOffset;
                    this.tokens = tokens;
                    this.inputLength = inputLength;
                    this.parseAction = parseAction;
                    this.errors = errors;
                    this.offset = offset;
                    this.rparensExpected = 0;
                    this.rbracketsExpected = 0;
                    this.rbracesExpected = 0;
                    this.index = 0;
                }
                _ParseAST.prototype.peek = function (offset) {
                    var i = this.index + offset;
                    return i < this.tokens.length ? this.tokens[i] : EOF;
                };
                Object.defineProperty(_ParseAST.prototype, "next", {
                    get: function () { return this.peek(0); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_ParseAST.prototype, "inputIndex", {
                    get: function () {
                        return (this.index < this.tokens.length) ? this.next.index + this.offset :
                            this.inputLength + this.offset;
                    },
                    enumerable: true,
                    configurable: true
                });
                _ParseAST.prototype.span = function (start) { return new ParseSpan(start, this.inputIndex); };
                _ParseAST.prototype.advance = function () { this.index++; };
                _ParseAST.prototype.optionalCharacter = function (code) {
                    if (this.next.isCharacter(code)) {
                        this.advance();
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                _ParseAST.prototype.peekKeywordLet = function () { return this.next.isKeywordLet(); };
                _ParseAST.prototype.peekKeywordAs = function () { return this.next.isKeywordAs(); };
                _ParseAST.prototype.expectCharacter = function (code) {
                    if (this.optionalCharacter(code))
                        return;
                    this.error("Missing expected " + String.fromCharCode(code));
                };
                _ParseAST.prototype.optionalOperator = function (op) {
                    if (this.next.isOperator(op)) {
                        this.advance();
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                _ParseAST.prototype.expectOperator = function (operator) {
                    if (this.optionalOperator(operator))
                        return;
                    this.error("Missing expected operator " + operator);
                };
                _ParseAST.prototype.expectIdentifierOrKeyword = function () {
                    var n = this.next;
                    if (!n.isIdentifier() && !n.isKeyword()) {
                        this.error("Unexpected token " + n + ", expected identifier or keyword");
                        return '';
                    }
                    this.advance();
                    return n.toString();
                };
                _ParseAST.prototype.expectIdentifierOrKeywordOrString = function () {
                    var n = this.next;
                    if (!n.isIdentifier() && !n.isKeyword() && !n.isString()) {
                        this.error("Unexpected token " + n + ", expected identifier, keyword, or string");
                        return '';
                    }
                    this.advance();
                    return n.toString();
                };
                _ParseAST.prototype.parseChain = function () {
                    var exprs = [];
                    var start = this.inputIndex;
                    while (this.index < this.tokens.length) {
                        var expr = this.parsePipe();
                        exprs.push(expr);
                        if (this.optionalCharacter($SEMICOLON)) {
                            if (!this.parseAction) {
                                this.error('Binding expression cannot contain chained expression');
                            }
                            while (this.optionalCharacter($SEMICOLON)) {
                            } // read all semicolons
                        }
                        else if (this.index < this.tokens.length) {
                            this.error("Unexpected token '" + this.next + "'");
                        }
                    }
                    if (exprs.length == 0)
                        return new EmptyExpr(this.span(start));
                    if (exprs.length == 1)
                        return exprs[0];
                    return new Chain(this.span(start), exprs);
                };
                _ParseAST.prototype.parsePipe = function () {
                    var result = this.parseExpression();
                    if (this.optionalOperator('|')) {
                        if (this.parseAction) {
                            this.error('Cannot have a pipe in an action expression');
                        }
                        do {
                            var name = this.expectIdentifierOrKeyword();
                            var args = [];
                            while (this.optionalCharacter($COLON)) {
                                args.push(this.parseExpression());
                            }
                            result = new BindingPipe(this.span(result.span.start), result, name, args);
                        } while (this.optionalOperator('|'));
                    }
                    return result;
                };
                _ParseAST.prototype.parseExpression = function () { return this.parseConditional(); };
                _ParseAST.prototype.parseConditional = function () {
                    var start = this.inputIndex;
                    var result = this.parseLogicalOr();
                    if (this.optionalOperator('?')) {
                        var yes = this.parsePipe();
                        var no = void 0;
                        if (!this.optionalCharacter($COLON)) {
                            var end = this.inputIndex;
                            var expression = this.input.substring(start, end);
                            this.error("Conditional expression " + expression + " requires all 3 expressions");
                            no = new EmptyExpr(this.span(start));
                        }
                        else {
                            no = this.parsePipe();
                        }
                        return new Conditional(this.span(start), result, yes, no);
                    }
                    else {
                        return result;
                    }
                };
                _ParseAST.prototype.parseLogicalOr = function () {
                    // '||'
                    var result = this.parseLogicalAnd();
                    while (this.optionalOperator('||')) {
                        var right = this.parseLogicalAnd();
                        result = new Binary(this.span(result.span.start), '||', result, right);
                    }
                    return result;
                };
                _ParseAST.prototype.parseLogicalAnd = function () {
                    // '&&'
                    var result = this.parseEquality();
                    while (this.optionalOperator('&&')) {
                        var right = this.parseEquality();
                        result = new Binary(this.span(result.span.start), '&&', result, right);
                    }
                    return result;
                };
                _ParseAST.prototype.parseEquality = function () {
                    // '==','!=','===','!=='
                    var result = this.parseRelational();
                    while (this.next.type == TokenType$1.Operator) {
                        var operator = this.next.strValue;
                        switch (operator) {
                            case '==':
                            case '===':
                            case '!=':
                            case '!==':
                                this.advance();
                                var right = this.parseRelational();
                                result = new Binary(this.span(result.span.start), operator, result, right);
                                continue;
                        }
                        break;
                    }
                    return result;
                };
                _ParseAST.prototype.parseRelational = function () {
                    // '<', '>', '<=', '>='
                    var result = this.parseAdditive();
                    while (this.next.type == TokenType$1.Operator) {
                        var operator = this.next.strValue;
                        switch (operator) {
                            case '<':
                            case '>':
                            case '<=':
                            case '>=':
                                this.advance();
                                var right = this.parseAdditive();
                                result = new Binary(this.span(result.span.start), operator, result, right);
                                continue;
                        }
                        break;
                    }
                    return result;
                };
                _ParseAST.prototype.parseAdditive = function () {
                    // '+', '-'
                    var result = this.parseMultiplicative();
                    while (this.next.type == TokenType$1.Operator) {
                        var operator = this.next.strValue;
                        switch (operator) {
                            case '+':
                            case '-':
                                this.advance();
                                var right = this.parseMultiplicative();
                                result = new Binary(this.span(result.span.start), operator, result, right);
                                continue;
                        }
                        break;
                    }
                    return result;
                };
                _ParseAST.prototype.parseMultiplicative = function () {
                    // '*', '%', '/'
                    var result = this.parsePrefix();
                    while (this.next.type == TokenType$1.Operator) {
                        var operator = this.next.strValue;
                        switch (operator) {
                            case '*':
                            case '%':
                            case '/':
                                this.advance();
                                var right = this.parsePrefix();
                                result = new Binary(this.span(result.span.start), operator, result, right);
                                continue;
                        }
                        break;
                    }
                    return result;
                };
                _ParseAST.prototype.parsePrefix = function () {
                    if (this.next.type == TokenType$1.Operator) {
                        var start = this.inputIndex;
                        var operator = this.next.strValue;
                        var result = void 0;
                        switch (operator) {
                            case '+':
                                this.advance();
                                result = this.parsePrefix();
                                return new Binary(this.span(start), '-', result, new LiteralPrimitive(new ParseSpan(start, start), 0));
                            case '-':
                                this.advance();
                                result = this.parsePrefix();
                                return new Binary(this.span(start), operator, new LiteralPrimitive(new ParseSpan(start, start), 0), result);
                            case '!':
                                this.advance();
                                result = this.parsePrefix();
                                return new PrefixNot(this.span(start), result);
                        }
                    }
                    return this.parseCallChain();
                };
                _ParseAST.prototype.parseCallChain = function () {
                    var result = this.parsePrimary();
                    while (true) {
                        if (this.optionalCharacter($PERIOD)) {
                            result = this.parseAccessMemberOrMethodCall(result, false);
                        }
                        else if (this.optionalOperator('?.')) {
                            result = this.parseAccessMemberOrMethodCall(result, true);
                        }
                        else if (this.optionalCharacter($LBRACKET)) {
                            this.rbracketsExpected++;
                            var key = this.parsePipe();
                            this.rbracketsExpected--;
                            this.expectCharacter($RBRACKET);
                            if (this.optionalOperator('=')) {
                                var value = this.parseConditional();
                                result = new KeyedWrite(this.span(result.span.start), result, key, value);
                            }
                            else {
                                result = new KeyedRead(this.span(result.span.start), result, key);
                            }
                        }
                        else if (this.optionalCharacter($LPAREN)) {
                            this.rparensExpected++;
                            var args = this.parseCallArguments();
                            this.rparensExpected--;
                            this.expectCharacter($RPAREN);
                            result = new FunctionCall(this.span(result.span.start), result, args);
                        }
                        else if (this.optionalOperator('!')) {
                            result = new NonNullAssert(this.span(result.span.start), result);
                        }
                        else {
                            return result;
                        }
                    }
                };
                _ParseAST.prototype.parsePrimary = function () {
                    var start = this.inputIndex;
                    if (this.optionalCharacter($LPAREN)) {
                        this.rparensExpected++;
                        var result = this.parsePipe();
                        this.rparensExpected--;
                        this.expectCharacter($RPAREN);
                        return result;
                    }
                    else if (this.next.isKeywordNull()) {
                        this.advance();
                        return new LiteralPrimitive(this.span(start), null);
                    }
                    else if (this.next.isKeywordUndefined()) {
                        this.advance();
                        return new LiteralPrimitive(this.span(start), void 0);
                    }
                    else if (this.next.isKeywordTrue()) {
                        this.advance();
                        return new LiteralPrimitive(this.span(start), true);
                    }
                    else if (this.next.isKeywordFalse()) {
                        this.advance();
                        return new LiteralPrimitive(this.span(start), false);
                    }
                    else if (this.next.isKeywordThis()) {
                        this.advance();
                        return new ImplicitReceiver(this.span(start));
                    }
                    else if (this.optionalCharacter($LBRACKET)) {
                        this.rbracketsExpected++;
                        var elements = this.parseExpressionList($RBRACKET);
                        this.rbracketsExpected--;
                        this.expectCharacter($RBRACKET);
                        return new LiteralArray(this.span(start), elements);
                    }
                    else if (this.next.isCharacter($LBRACE)) {
                        return this.parseLiteralMap();
                    }
                    else if (this.next.isIdentifier()) {
                        return this.parseAccessMemberOrMethodCall(new ImplicitReceiver(this.span(start)), false);
                    }
                    else if (this.next.isNumber()) {
                        var value = this.next.toNumber();
                        this.advance();
                        return new LiteralPrimitive(this.span(start), value);
                    }
                    else if (this.next.isString()) {
                        var literalValue = this.next.toString();
                        this.advance();
                        return new LiteralPrimitive(this.span(start), literalValue);
                    }
                    else if (this.index >= this.tokens.length) {
                        this.error("Unexpected end of expression: " + this.input);
                        return new EmptyExpr(this.span(start));
                    }
                    else {
                        this.error("Unexpected token " + this.next);
                        return new EmptyExpr(this.span(start));
                    }
                };
                _ParseAST.prototype.parseExpressionList = function (terminator) {
                    var result = [];
                    if (!this.next.isCharacter(terminator)) {
                        do {
                            result.push(this.parsePipe());
                        } while (this.optionalCharacter($COMMA));
                    }
                    return result;
                };
                _ParseAST.prototype.parseLiteralMap = function () {
                    var keys = [];
                    var values = [];
                    var start = this.inputIndex;
                    this.expectCharacter($LBRACE);
                    if (!this.optionalCharacter($RBRACE)) {
                        this.rbracesExpected++;
                        do {
                            var quoted = this.next.isString();
                            var key = this.expectIdentifierOrKeywordOrString();
                            keys.push({ key: key, quoted: quoted });
                            this.expectCharacter($COLON);
                            values.push(this.parsePipe());
                        } while (this.optionalCharacter($COMMA));
                        this.rbracesExpected--;
                        this.expectCharacter($RBRACE);
                    }
                    return new LiteralMap(this.span(start), keys, values);
                };
                _ParseAST.prototype.parseAccessMemberOrMethodCall = function (receiver, isSafe) {
                    if (isSafe === void 0) { isSafe = false; }
                    var start = receiver.span.start;
                    var id = this.expectIdentifierOrKeyword();
                    if (this.optionalCharacter($LPAREN)) {
                        this.rparensExpected++;
                        var args = this.parseCallArguments();
                        this.expectCharacter($RPAREN);
                        this.rparensExpected--;
                        var span = this.span(start);
                        return isSafe ? new SafeMethodCall(span, receiver, id, args) :
                            new MethodCall(span, receiver, id, args);
                    }
                    else {
                        if (isSafe) {
                            if (this.optionalOperator('=')) {
                                this.error('The \'?.\' operator cannot be used in the assignment');
                                return new EmptyExpr(this.span(start));
                            }
                            else {
                                return new SafePropertyRead(this.span(start), receiver, id);
                            }
                        }
                        else {
                            if (this.optionalOperator('=')) {
                                if (!this.parseAction) {
                                    this.error('Bindings cannot contain assignments');
                                    return new EmptyExpr(this.span(start));
                                }
                                var value = this.parseConditional();
                                return new PropertyWrite(this.span(start), receiver, id, value);
                            }
                            else {
                                return new PropertyRead(this.span(start), receiver, id);
                            }
                        }
                    }
                };
                _ParseAST.prototype.parseCallArguments = function () {
                    if (this.next.isCharacter($RPAREN))
                        return [];
                    var positionals = [];
                    do {
                        positionals.push(this.parsePipe());
                    } while (this.optionalCharacter($COMMA));
                    return positionals;
                };
                /**
                 * An identifier, a keyword, a string with an optional `-` in between.
                 */
                _ParseAST.prototype.expectTemplateBindingKey = function () {
                    var result = '';
                    var operatorFound = false;
                    do {
                        result += this.expectIdentifierOrKeywordOrString();
                        operatorFound = this.optionalOperator('-');
                        if (operatorFound) {
                            result += '-';
                        }
                    } while (operatorFound);
                    return result.toString();
                };
                // Parses the AST for `<some-tag *tplKey=AST>`
                _ParseAST.prototype.parseTemplateBindings = function (tplKey) {
                    var firstBinding = true;
                    var bindings = [];
                    var warnings = [];
                    do {
                        var start = this.inputIndex;
                        var rawKey = void 0;
                        var key = void 0;
                        var isVar = false;
                        if (firstBinding) {
                            rawKey = key = tplKey;
                            firstBinding = false;
                        }
                        else {
                            isVar = this.peekKeywordLet();
                            if (isVar)
                                this.advance();
                            rawKey = this.expectTemplateBindingKey();
                            key = isVar ? rawKey : tplKey + rawKey[0].toUpperCase() + rawKey.substring(1);
                            this.optionalCharacter($COLON);
                        }
                        var name = null;
                        var expression = null;
                        if (isVar) {
                            if (this.optionalOperator('=')) {
                                name = this.expectTemplateBindingKey();
                            }
                            else {
                                name = '\$implicit';
                            }
                        }
                        else if (this.peekKeywordAs()) {
                            this.advance(); // consume `as`
                            name = rawKey;
                            key = this.expectTemplateBindingKey(); // read local var name
                            isVar = true;
                        }
                        else if (this.next !== EOF && !this.peekKeywordLet()) {
                            var start_2 = this.inputIndex;
                            var ast = this.parsePipe();
                            var source = this.input.substring(start_2 - this.offset, this.inputIndex - this.offset);
                            expression =
                                new ASTWithSource(ast, source, this.location, this.absoluteOffset, this.errors);
                        }
                        bindings.push(new TemplateBinding(this.span(start), key, isVar, name, expression));
                        if (this.peekKeywordAs() && !isVar) {
                            var letStart = this.inputIndex;
                            this.advance(); // consume `as`
                            var letName = this.expectTemplateBindingKey(); // read local var name
                            bindings.push(new TemplateBinding(this.span(letStart), letName, true, key, null));
                        }
                        if (!this.optionalCharacter($SEMICOLON)) {
                            this.optionalCharacter($COMMA);
                        }
                    } while (this.index < this.tokens.length);
                    return new TemplateBindingParseResult(bindings, warnings, this.errors);
                };
                _ParseAST.prototype.error = function (message, index) {
                    if (index === void 0) { index = null; }
                    this.errors.push(new ParserError(message, this.input, this.locationText(index), this.location));
                    this.skip();
                };
                _ParseAST.prototype.locationText = function (index) {
                    if (index === void 0) { index = null; }
                    if (index == null)
                        index = this.index;
                    return (index < this.tokens.length) ? "at column " + (this.tokens[index].index + 1) + " in" :
                        "at the end of the expression";
                };
                // Error recovery should skip tokens until it encounters a recovery point. skip() treats
                // the end of input and a ';' as unconditionally a recovery point. It also treats ')',
                // '}' and ']' as conditional recovery points if one of calling productions is expecting
                // one of these symbols. This allows skip() to recover from errors such as '(a.) + 1' allowing
                // more of the AST to be retained (it doesn't skip any tokens as the ')' is retained because
                // of the '(' begins an '(' <expr> ')' production). The recovery points of grouping symbols
                // must be conditional as they must be skipped if none of the calling productions are not
                // expecting the closing token else we will never make progress in the case of an
                // extraneous group closing symbol (such as a stray ')'). This is not the case for ';' because
                // parseChain() is always the root production and it expects a ';'.
                // If a production expects one of these token it increments the corresponding nesting count,
                // and then decrements it just prior to checking if the token is in the input.
                _ParseAST.prototype.skip = function () {
                    var n = this.next;
                    while (this.index < this.tokens.length && !n.isCharacter($SEMICOLON) &&
                        (this.rparensExpected <= 0 || !n.isCharacter($RPAREN)) &&
                        (this.rbracesExpected <= 0 || !n.isCharacter($RBRACE)) &&
                        (this.rbracketsExpected <= 0 || !n.isCharacter($RBRACKET))) {
                        if (this.next.isError()) {
                            this.errors.push(new ParserError(this.next.toString(), this.input, this.locationText(), this.location));
                        }
                        this.advance();
                        n = this.next;
                    }
                };
                return _ParseAST;
            }());
            var SimpleExpressionChecker = /** @class */ (function () {
                function SimpleExpressionChecker() {
                    this.errors = [];
                }
                SimpleExpressionChecker.check = function (ast) {
                    var s = new SimpleExpressionChecker();
                    ast.visit(s);
                    return s.errors;
                };
                SimpleExpressionChecker.prototype.visitImplicitReceiver = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitInterpolation = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitLiteralPrimitive = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitPropertyRead = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitPropertyWrite = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitSafePropertyRead = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitMethodCall = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitSafeMethodCall = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitFunctionCall = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitLiteralArray = function (ast, context) { this.visitAll(ast.expressions); };
                SimpleExpressionChecker.prototype.visitLiteralMap = function (ast, context) { this.visitAll(ast.values); };
                SimpleExpressionChecker.prototype.visitBinary = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitPrefixNot = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitNonNullAssert = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitConditional = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitPipe = function (ast, context) { this.errors.push('pipes'); };
                SimpleExpressionChecker.prototype.visitKeyedRead = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitKeyedWrite = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitAll = function (asts) {
                    var _this = this;
                    return asts.map(function (node) { return node.visit(_this); });
                };
                SimpleExpressionChecker.prototype.visitChain = function (ast, context) { };
                SimpleExpressionChecker.prototype.visitQuote = function (ast, context) { };
                return SimpleExpressionChecker;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // =================================================================================================
            // =================================================================================================
            // =========== S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P  ===========
            // =================================================================================================
            // =================================================================================================
            //
            //        DO NOT EDIT THIS LIST OF SECURITY SENSITIVE PROPERTIES WITHOUT A SECURITY REVIEW!
            //                               Reach out to mprobst for details.
            //
            // =================================================================================================
            /** Map from tagName|propertyName SecurityContext. Properties applying to all tags use '*'. */
            var _SECURITY_SCHEMA;
            function SECURITY_SCHEMA() {
                if (!_SECURITY_SCHEMA) {
                    _SECURITY_SCHEMA = {};
                    // Case is insignificant below, all element and attribute names are lower-cased for lookup.
                    registerContext(SecurityContext.HTML, [
                        'iframe|srcdoc',
                        '*|innerHTML',
                        '*|outerHTML',
                    ]);
                    registerContext(SecurityContext.STYLE, ['*|style']);
                    // NB: no SCRIPT contexts here, they are never allowed due to the parser stripping them.
                    registerContext(SecurityContext.URL, [
                        '*|formAction', 'area|href', 'area|ping', 'audio|src', 'a|href',
                        'a|ping', 'blockquote|cite', 'body|background', 'del|cite', 'form|action',
                        'img|src', 'img|srcset', 'input|src', 'ins|cite', 'q|cite',
                        'source|src', 'source|srcset', 'track|src', 'video|poster', 'video|src',
                    ]);
                    registerContext(SecurityContext.RESOURCE_URL, [
                        'applet|code',
                        'applet|codebase',
                        'base|href',
                        'embed|src',
                        'frame|src',
                        'head|profile',
                        'html|manifest',
                        'iframe|src',
                        'link|href',
                        'media|src',
                        'object|codebase',
                        'object|data',
                        'script|src',
                    ]);
                }
                return _SECURITY_SCHEMA;
            }
            function registerContext(ctx, specs) {
                for (var _c = 0, specs_1 = specs; _c < specs_1.length; _c++) {
                    var spec = specs_1[_c];
                    _SECURITY_SCHEMA[spec.toLowerCase()] = ctx;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ElementSchemaRegistry = /** @class */ (function () {
                function ElementSchemaRegistry() {
                }
                return ElementSchemaRegistry;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var BOOLEAN = 'boolean';
            var NUMBER = 'number';
            var STRING = 'string';
            var OBJECT = 'object';
            /**
             * This array represents the DOM schema. It encodes inheritance, properties, and events.
             *
             * ## Overview
             *
             * Each line represents one kind of element. The `element_inheritance` and properties are joined
             * using `element_inheritance|properties` syntax.
             *
             * ## Element Inheritance
             *
             * The `element_inheritance` can be further subdivided as `element1,element2,...^parentElement`.
             * Here the individual elements are separated by `,` (commas). Every element in the list
             * has identical properties.
             *
             * An `element` may inherit additional properties from `parentElement` If no `^parentElement` is
             * specified then `""` (blank) element is assumed.
             *
             * NOTE: The blank element inherits from root `[Element]` element, the super element of all
             * elements.
             *
             * NOTE an element prefix such as `:svg:` has no special meaning to the schema.
             *
             * ## Properties
             *
             * Each element has a set of properties separated by `,` (commas). Each property can be prefixed
             * by a special character designating its type:
             *
             * - (no prefix): property is a string.
             * - `*`: property represents an event.
             * - `!`: property is a boolean.
             * - `#`: property is a number.
             * - `%`: property is an object.
             *
             * ## Query
             *
             * The class creates an internal squas representation which allows to easily answer the query of
             * if a given property exist on a given element.
             *
             * NOTE: We don't yet support querying for types or events.
             * NOTE: This schema is auto extracted from `schema_extractor.ts` located in the test folder,
             *       see dom_element_schema_registry_spec.ts
             */
            // =================================================================================================
            // =================================================================================================
            // =========== S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P  ===========
            // =================================================================================================
            // =================================================================================================
            //
            //                       DO NOT EDIT THIS DOM SCHEMA WITHOUT A SECURITY REVIEW!
            //
            // Newly added properties must be security reviewed and assigned an appropriate SecurityContext in
            // dom_security_schema.ts. Reach out to mprobst & rjamet for details.
            //
            // =================================================================================================
            var SCHEMA = [
                '[Element]|textContent,%classList,className,id,innerHTML,*beforecopy,*beforecut,*beforepaste,*copy,*cut,*paste,*search,*selectstart,*webkitfullscreenchange,*webkitfullscreenerror,*wheel,outerHTML,#scrollLeft,#scrollTop,slot' +
                    /* added manually to avoid breaking changes */
                    ',*message,*mozfullscreenchange,*mozfullscreenerror,*mozpointerlockchange,*mozpointerlockerror,*webglcontextcreationerror,*webglcontextlost,*webglcontextrestored',
                '[HTMLElement]^[Element]|accessKey,contentEditable,dir,!draggable,!hidden,innerText,lang,*abort,*auxclick,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*gotpointercapture,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*lostpointercapture,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*pointercancel,*pointerdown,*pointerenter,*pointerleave,*pointermove,*pointerout,*pointerover,*pointerup,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,outerText,!spellcheck,%style,#tabIndex,title,!translate',
                'abbr,address,article,aside,b,bdi,bdo,cite,code,dd,dfn,dt,em,figcaption,figure,footer,header,i,kbd,main,mark,nav,noscript,rb,rp,rt,rtc,ruby,s,samp,section,small,strong,sub,sup,u,var,wbr^[HTMLElement]|accessKey,contentEditable,dir,!draggable,!hidden,innerText,lang,*abort,*auxclick,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*gotpointercapture,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*lostpointercapture,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*pointercancel,*pointerdown,*pointerenter,*pointerleave,*pointermove,*pointerout,*pointerover,*pointerup,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,outerText,!spellcheck,%style,#tabIndex,title,!translate',
                'media^[HTMLElement]|!autoplay,!controls,%controlsList,%crossOrigin,#currentTime,!defaultMuted,#defaultPlaybackRate,!disableRemotePlayback,!loop,!muted,*encrypted,*waitingforkey,#playbackRate,preload,src,%srcObject,#volume',
                ':svg:^[HTMLElement]|*abort,*auxclick,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*gotpointercapture,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*lostpointercapture,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*pointercancel,*pointerdown,*pointerenter,*pointerleave,*pointermove,*pointerout,*pointerover,*pointerup,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,%style,#tabIndex',
                ':svg:graphics^:svg:|',
                ':svg:animation^:svg:|*begin,*end,*repeat',
                ':svg:geometry^:svg:|',
                ':svg:componentTransferFunction^:svg:|',
                ':svg:gradient^:svg:|',
                ':svg:textContent^:svg:graphics|',
                ':svg:textPositioning^:svg:textContent|',
                'a^[HTMLElement]|charset,coords,download,hash,host,hostname,href,hreflang,name,password,pathname,ping,port,protocol,referrerPolicy,rel,rev,search,shape,target,text,type,username',
                'area^[HTMLElement]|alt,coords,download,hash,host,hostname,href,!noHref,password,pathname,ping,port,protocol,referrerPolicy,rel,search,shape,target,username',
                'audio^media|',
                'br^[HTMLElement]|clear',
                'base^[HTMLElement]|href,target',
                'body^[HTMLElement]|aLink,background,bgColor,link,*beforeunload,*blur,*error,*focus,*hashchange,*languagechange,*load,*message,*offline,*online,*pagehide,*pageshow,*popstate,*rejectionhandled,*resize,*scroll,*storage,*unhandledrejection,*unload,text,vLink',
                'button^[HTMLElement]|!autofocus,!disabled,formAction,formEnctype,formMethod,!formNoValidate,formTarget,name,type,value',
                'canvas^[HTMLElement]|#height,#width',
                'content^[HTMLElement]|select',
                'dl^[HTMLElement]|!compact',
                'datalist^[HTMLElement]|',
                'details^[HTMLElement]|!open',
                'dialog^[HTMLElement]|!open,returnValue',
                'dir^[HTMLElement]|!compact',
                'div^[HTMLElement]|align',
                'embed^[HTMLElement]|align,height,name,src,type,width',
                'fieldset^[HTMLElement]|!disabled,name',
                'font^[HTMLElement]|color,face,size',
                'form^[HTMLElement]|acceptCharset,action,autocomplete,encoding,enctype,method,name,!noValidate,target',
                'frame^[HTMLElement]|frameBorder,longDesc,marginHeight,marginWidth,name,!noResize,scrolling,src',
                'frameset^[HTMLElement]|cols,*beforeunload,*blur,*error,*focus,*hashchange,*languagechange,*load,*message,*offline,*online,*pagehide,*pageshow,*popstate,*rejectionhandled,*resize,*scroll,*storage,*unhandledrejection,*unload,rows',
                'hr^[HTMLElement]|align,color,!noShade,size,width',
                'head^[HTMLElement]|',
                'h1,h2,h3,h4,h5,h6^[HTMLElement]|align',
                'html^[HTMLElement]|version',
                'iframe^[HTMLElement]|align,!allowFullscreen,frameBorder,height,longDesc,marginHeight,marginWidth,name,referrerPolicy,%sandbox,scrolling,src,srcdoc,width',
                'img^[HTMLElement]|align,alt,border,%crossOrigin,#height,#hspace,!isMap,longDesc,lowsrc,name,referrerPolicy,sizes,src,srcset,useMap,#vspace,#width',
                'input^[HTMLElement]|accept,align,alt,autocapitalize,autocomplete,!autofocus,!checked,!defaultChecked,defaultValue,dirName,!disabled,%files,formAction,formEnctype,formMethod,!formNoValidate,formTarget,#height,!incremental,!indeterminate,max,#maxLength,min,#minLength,!multiple,name,pattern,placeholder,!readOnly,!required,selectionDirection,#selectionEnd,#selectionStart,#size,src,step,type,useMap,value,%valueAsDate,#valueAsNumber,#width',
                'li^[HTMLElement]|type,#value',
                'label^[HTMLElement]|htmlFor',
                'legend^[HTMLElement]|align',
                'link^[HTMLElement]|as,charset,%crossOrigin,!disabled,href,hreflang,integrity,media,referrerPolicy,rel,%relList,rev,%sizes,target,type',
                'map^[HTMLElement]|name',
                'marquee^[HTMLElement]|behavior,bgColor,direction,height,#hspace,#loop,#scrollAmount,#scrollDelay,!trueSpeed,#vspace,width',
                'menu^[HTMLElement]|!compact',
                'meta^[HTMLElement]|content,httpEquiv,name,scheme',
                'meter^[HTMLElement]|#high,#low,#max,#min,#optimum,#value',
                'ins,del^[HTMLElement]|cite,dateTime',
                'ol^[HTMLElement]|!compact,!reversed,#start,type',
                'object^[HTMLElement]|align,archive,border,code,codeBase,codeType,data,!declare,height,#hspace,name,standby,type,useMap,#vspace,width',
                'optgroup^[HTMLElement]|!disabled,label',
                'option^[HTMLElement]|!defaultSelected,!disabled,label,!selected,text,value',
                'output^[HTMLElement]|defaultValue,%htmlFor,name,value',
                'p^[HTMLElement]|align',
                'param^[HTMLElement]|name,type,value,valueType',
                'picture^[HTMLElement]|',
                'pre^[HTMLElement]|#width',
                'progress^[HTMLElement]|#max,#value',
                'q,blockquote,cite^[HTMLElement]|',
                'script^[HTMLElement]|!async,charset,%crossOrigin,!defer,event,htmlFor,integrity,src,text,type',
                'select^[HTMLElement]|!autofocus,!disabled,#length,!multiple,name,!required,#selectedIndex,#size,value',
                'shadow^[HTMLElement]|',
                'slot^[HTMLElement]|name',
                'source^[HTMLElement]|media,sizes,src,srcset,type',
                'span^[HTMLElement]|',
                'style^[HTMLElement]|!disabled,media,type',
                'caption^[HTMLElement]|align',
                'th,td^[HTMLElement]|abbr,align,axis,bgColor,ch,chOff,#colSpan,headers,height,!noWrap,#rowSpan,scope,vAlign,width',
                'col,colgroup^[HTMLElement]|align,ch,chOff,#span,vAlign,width',
                'table^[HTMLElement]|align,bgColor,border,%caption,cellPadding,cellSpacing,frame,rules,summary,%tFoot,%tHead,width',
                'tr^[HTMLElement]|align,bgColor,ch,chOff,vAlign',
                'tfoot,thead,tbody^[HTMLElement]|align,ch,chOff,vAlign',
                'template^[HTMLElement]|',
                'textarea^[HTMLElement]|autocapitalize,!autofocus,#cols,defaultValue,dirName,!disabled,#maxLength,#minLength,name,placeholder,!readOnly,!required,#rows,selectionDirection,#selectionEnd,#selectionStart,value,wrap',
                'title^[HTMLElement]|text',
                'track^[HTMLElement]|!default,kind,label,src,srclang',
                'ul^[HTMLElement]|!compact,type',
                'unknown^[HTMLElement]|',
                'video^media|#height,poster,#width',
                ':svg:a^:svg:graphics|',
                ':svg:animate^:svg:animation|',
                ':svg:animateMotion^:svg:animation|',
                ':svg:animateTransform^:svg:animation|',
                ':svg:circle^:svg:geometry|',
                ':svg:clipPath^:svg:graphics|',
                ':svg:defs^:svg:graphics|',
                ':svg:desc^:svg:|',
                ':svg:discard^:svg:|',
                ':svg:ellipse^:svg:geometry|',
                ':svg:feBlend^:svg:|',
                ':svg:feColorMatrix^:svg:|',
                ':svg:feComponentTransfer^:svg:|',
                ':svg:feComposite^:svg:|',
                ':svg:feConvolveMatrix^:svg:|',
                ':svg:feDiffuseLighting^:svg:|',
                ':svg:feDisplacementMap^:svg:|',
                ':svg:feDistantLight^:svg:|',
                ':svg:feDropShadow^:svg:|',
                ':svg:feFlood^:svg:|',
                ':svg:feFuncA^:svg:componentTransferFunction|',
                ':svg:feFuncB^:svg:componentTransferFunction|',
                ':svg:feFuncG^:svg:componentTransferFunction|',
                ':svg:feFuncR^:svg:componentTransferFunction|',
                ':svg:feGaussianBlur^:svg:|',
                ':svg:feImage^:svg:|',
                ':svg:feMerge^:svg:|',
                ':svg:feMergeNode^:svg:|',
                ':svg:feMorphology^:svg:|',
                ':svg:feOffset^:svg:|',
                ':svg:fePointLight^:svg:|',
                ':svg:feSpecularLighting^:svg:|',
                ':svg:feSpotLight^:svg:|',
                ':svg:feTile^:svg:|',
                ':svg:feTurbulence^:svg:|',
                ':svg:filter^:svg:|',
                ':svg:foreignObject^:svg:graphics|',
                ':svg:g^:svg:graphics|',
                ':svg:image^:svg:graphics|',
                ':svg:line^:svg:geometry|',
                ':svg:linearGradient^:svg:gradient|',
                ':svg:mpath^:svg:|',
                ':svg:marker^:svg:|',
                ':svg:mask^:svg:|',
                ':svg:metadata^:svg:|',
                ':svg:path^:svg:geometry|',
                ':svg:pattern^:svg:|',
                ':svg:polygon^:svg:geometry|',
                ':svg:polyline^:svg:geometry|',
                ':svg:radialGradient^:svg:gradient|',
                ':svg:rect^:svg:geometry|',
                ':svg:svg^:svg:graphics|#currentScale,#zoomAndPan',
                ':svg:script^:svg:|type',
                ':svg:set^:svg:animation|',
                ':svg:stop^:svg:|',
                ':svg:style^:svg:|!disabled,media,title,type',
                ':svg:switch^:svg:graphics|',
                ':svg:symbol^:svg:|',
                ':svg:tspan^:svg:textPositioning|',
                ':svg:text^:svg:textPositioning|',
                ':svg:textPath^:svg:textContent|',
                ':svg:title^:svg:|',
                ':svg:use^:svg:graphics|',
                ':svg:view^:svg:|#zoomAndPan',
                'data^[HTMLElement]|value',
                'keygen^[HTMLElement]|!autofocus,challenge,!disabled,form,keytype,name',
                'menuitem^[HTMLElement]|type,label,icon,!disabled,!checked,radiogroup,!default',
                'summary^[HTMLElement]|',
                'time^[HTMLElement]|dateTime',
                ':svg:cursor^:svg:|',
            ];
            var _ATTR_TO_PROP = {
                'class': 'className',
                'for': 'htmlFor',
                'formaction': 'formAction',
                'innerHtml': 'innerHTML',
                'readonly': 'readOnly',
                'tabindex': 'tabIndex',
            };
            var DomElementSchemaRegistry = /** @class */ (function (_super_1) {
                __extends(DomElementSchemaRegistry, _super_1);
                function DomElementSchemaRegistry() {
                    var _this = _super_1.call(this) || this;
                    _this._schema = {};
                    SCHEMA.forEach(function (encodedType) {
                        var type = {};
                        var _c = encodedType.split('|'), strType = _c[0], strProperties = _c[1];
                        var properties = strProperties.split(',');
                        var _d = strType.split('^'), typeNames = _d[0], superName = _d[1];
                        typeNames.split(',').forEach(function (tag) { return _this._schema[tag.toLowerCase()] = type; });
                        var superType = superName && _this._schema[superName.toLowerCase()];
                        if (superType) {
                            Object.keys(superType).forEach(function (prop) { type[prop] = superType[prop]; });
                        }
                        properties.forEach(function (property) {
                            if (property.length > 0) {
                                switch (property[0]) {
                                    case '*':
                                        // We don't yet support events.
                                        // If ever allowing to bind to events, GO THROUGH A SECURITY REVIEW, allowing events
                                        // will
                                        // almost certainly introduce bad XSS vulnerabilities.
                                        // type[property.substring(1)] = EVENT;
                                        break;
                                    case '!':
                                        type[property.substring(1)] = BOOLEAN;
                                        break;
                                    case '#':
                                        type[property.substring(1)] = NUMBER;
                                        break;
                                    case '%':
                                        type[property.substring(1)] = OBJECT;
                                        break;
                                    default:
                                        type[property] = STRING;
                                }
                            }
                        });
                    });
                    return _this;
                }
                DomElementSchemaRegistry.prototype.hasProperty = function (tagName, propName, schemaMetas) {
                    if (schemaMetas.some(function (schema) { return schema.name === NO_ERRORS_SCHEMA.name; })) {
                        return true;
                    }
                    if (tagName.indexOf('-') > -1) {
                        if (isNgContainer(tagName) || isNgContent(tagName)) {
                            return false;
                        }
                        if (schemaMetas.some(function (schema) { return schema.name === CUSTOM_ELEMENTS_SCHEMA.name; })) {
                            // Can't tell now as we don't know which properties a custom element will get
                            // once it is instantiated
                            return true;
                        }
                    }
                    var elementProperties = this._schema[tagName.toLowerCase()] || this._schema['unknown'];
                    return !!elementProperties[propName];
                };
                DomElementSchemaRegistry.prototype.hasElement = function (tagName, schemaMetas) {
                    if (schemaMetas.some(function (schema) { return schema.name === NO_ERRORS_SCHEMA.name; })) {
                        return true;
                    }
                    if (tagName.indexOf('-') > -1) {
                        if (isNgContainer(tagName) || isNgContent(tagName)) {
                            return true;
                        }
                        if (schemaMetas.some(function (schema) { return schema.name === CUSTOM_ELEMENTS_SCHEMA.name; })) {
                            // Allow any custom elements
                            return true;
                        }
                    }
                    return !!this._schema[tagName.toLowerCase()];
                };
                /**
                 * securityContext returns the security context for the given property on the given DOM tag.
                 *
                 * Tag and property name are statically known and cannot change at runtime, i.e. it is not
                 * possible to bind a value into a changing attribute or tag name.
                 *
                 * The filtering is based on a list of allowed tags|attributes. All attributes in the schema
                 * above are assumed to have the 'NONE' security context, i.e. that they are safe inert
                 * string values. Only specific well known attack vectors are assigned their appropriate context.
                 */
                DomElementSchemaRegistry.prototype.securityContext = function (tagName, propName, isAttribute) {
                    if (isAttribute) {
                        // NB: For security purposes, use the mapped property name, not the attribute name.
                        propName = this.getMappedPropName(propName);
                    }
                    // Make sure comparisons are case insensitive, so that case differences between attribute and
                    // property names do not have a security impact.
                    tagName = tagName.toLowerCase();
                    propName = propName.toLowerCase();
                    var ctx = SECURITY_SCHEMA()[tagName + '|' + propName];
                    if (ctx) {
                        return ctx;
                    }
                    ctx = SECURITY_SCHEMA()['*|' + propName];
                    return ctx ? ctx : SecurityContext.NONE;
                };
                DomElementSchemaRegistry.prototype.getMappedPropName = function (propName) { return _ATTR_TO_PROP[propName] || propName; };
                DomElementSchemaRegistry.prototype.getDefaultComponentElementName = function () { return 'ng-component'; };
                DomElementSchemaRegistry.prototype.validateProperty = function (name) {
                    if (name.toLowerCase().startsWith('on')) {
                        var msg = "Binding to event property '" + name + "' is disallowed for security reasons, " +
                            ("please use (" + name.slice(2) + ")=...") +
                            ("\nIf '" + name + "' is a directive input, make sure the directive is imported by the") +
                            " current module.";
                        return { error: true, msg: msg };
                    }
                    else {
                        return { error: false };
                    }
                };
                DomElementSchemaRegistry.prototype.validateAttribute = function (name) {
                    if (name.toLowerCase().startsWith('on')) {
                        var msg = "Binding to event attribute '" + name + "' is disallowed for security reasons, " +
                            ("please use (" + name.slice(2) + ")=...");
                        return { error: true, msg: msg };
                    }
                    else {
                        return { error: false };
                    }
                };
                DomElementSchemaRegistry.prototype.allKnownElementNames = function () { return Object.keys(this._schema); };
                DomElementSchemaRegistry.prototype.normalizeAnimationStyleProperty = function (propName) {
                    return dashCaseToCamelCase(propName);
                };
                DomElementSchemaRegistry.prototype.normalizeAnimationStyleValue = function (camelCaseProp, userProvidedProp, val) {
                    var unit = '';
                    var strVal = val.toString().trim();
                    var errorMsg = null;
                    if (_isPixelDimensionStyle(camelCaseProp) && val !== 0 && val !== '0') {
                        if (typeof val === 'number') {
                            unit = 'px';
                        }
                        else {
                            var valAndSuffixMatch = val.match(/^[+-]?[\d\.]+([a-z]*)$/);
                            if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                                errorMsg = "Please provide a CSS unit value for " + userProvidedProp + ":" + val;
                            }
                        }
                    }
                    return { error: errorMsg, value: strVal + unit };
                };
                return DomElementSchemaRegistry;
            }(ElementSchemaRegistry));
            function _isPixelDimensionStyle(prop) {
                switch (prop) {
                    case 'width':
                    case 'height':
                    case 'minWidth':
                    case 'minHeight':
                    case 'maxWidth':
                    case 'maxHeight':
                    case 'left':
                    case 'top':
                    case 'bottom':
                    case 'right':
                    case 'fontSize':
                    case 'outlineWidth':
                    case 'outlineOffset':
                    case 'paddingTop':
                    case 'paddingLeft':
                    case 'paddingBottom':
                    case 'paddingRight':
                    case 'marginTop':
                    case 'marginLeft':
                    case 'marginBottom':
                    case 'marginRight':
                    case 'borderRadius':
                    case 'borderWidth':
                    case 'borderTopWidth':
                    case 'borderLeftWidth':
                    case 'borderRightWidth':
                    case 'borderBottomWidth':
                    case 'textIndent':
                        return true;
                    default:
                        return false;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var BIND_NAME_REGEXP$1 = /^(?:(?:(?:(bind-)|(let-)|(ref-|#)|(on-)|(bindon-)|(@))(.+))|\[\(([^\)]+)\)\]|\[([^\]]+)\]|\(([^\)]+)\))$/;
            // Group 1 = "bind-"
            var KW_BIND_IDX$1 = 1;
            // Group 2 = "let-"
            var KW_LET_IDX$1 = 2;
            // Group 3 = "ref-/#"
            var KW_REF_IDX$1 = 3;
            // Group 4 = "on-"
            var KW_ON_IDX$1 = 4;
            // Group 5 = "bindon-"
            var KW_BINDON_IDX$1 = 5;
            // Group 6 = "@"
            var KW_AT_IDX$1 = 6;
            // Group 7 = the identifier after "bind-", "let-", "ref-/#", "on-", "bindon-" or "@"
            var IDENT_KW_IDX$1 = 7;
            // Group 8 = identifier inside [()]
            var IDENT_BANANA_BOX_IDX$1 = 8;
            // Group 9 = identifier inside []
            var IDENT_PROPERTY_IDX$1 = 9;
            // Group 10 = identifier inside ()
            var IDENT_EVENT_IDX$1 = 10;
            var TEMPLATE_ATTR_PREFIX$1 = '*';
            function htmlAstToRender3Ast(htmlNodes, bindingParser) {
                var transformer = new HtmlAstToIvyAst(bindingParser);
                var ivyNodes = visitAll$1(transformer, htmlNodes);
                // Errors might originate in either the binding parser or the html to ivy transformer
                var allErrors = bindingParser.errors.concat(transformer.errors);
                var errors = allErrors.filter(function (e) { return e.level === ParseErrorLevel.ERROR; });
                if (errors.length > 0) {
                    var errorString = errors.join('\n');
                    throw syntaxError("Template parse errors:\n" + errorString, errors);
                }
                return {
                    nodes: ivyNodes,
                    errors: allErrors,
                    styleUrls: transformer.styleUrls,
                    styles: transformer.styles,
                };
            }
            var HtmlAstToIvyAst = /** @class */ (function () {
                function HtmlAstToIvyAst(bindingParser) {
                    this.bindingParser = bindingParser;
                    this.errors = [];
                    this.styles = [];
                    this.styleUrls = [];
                }
                // HTML visitor
                HtmlAstToIvyAst.prototype.visitElement = function (element) {
                    var _this = this;
                    var preparsedElement = preparseElement(element);
                    if (preparsedElement.type === PreparsedElementType.SCRIPT) {
                        return null;
                    }
                    else if (preparsedElement.type === PreparsedElementType.STYLE) {
                        var contents = textContents(element);
                        if (contents !== null) {
                            this.styles.push(contents);
                        }
                        return null;
                    }
                    else if (preparsedElement.type === PreparsedElementType.STYLESHEET &&
                        isStyleUrlResolvable(preparsedElement.hrefAttr)) {
                        this.styleUrls.push(preparsedElement.hrefAttr);
                        return null;
                    }
                    // Whether the element is a `<ng-template>`
                    var isTemplateElement = isNgTemplate(element.name);
                    var parsedProperties = [];
                    var boundEvents = [];
                    var variables = [];
                    var references = [];
                    var attributes = [];
                    var i18nAttrsMeta = {};
                    var templateParsedProperties = [];
                    var templateVariables = [];
                    // Whether the element has any *-attribute
                    var elementHasInlineTemplate = false;
                    for (var _c = 0, _d = element.attrs; _c < _d.length; _c++) {
                        var attribute = _d[_c];
                        var hasBinding = false;
                        var normalizedName = normalizeAttributeName(attribute.name);
                        // `*attr` defines template bindings
                        var isTemplateBinding = false;
                        if (attribute.i18n) {
                            i18nAttrsMeta[attribute.name] = attribute.i18n;
                        }
                        if (normalizedName.startsWith(TEMPLATE_ATTR_PREFIX$1)) {
                            // *-attributes
                            if (elementHasInlineTemplate) {
                                this.reportError("Can't have multiple template bindings on one element. Use only one attribute prefixed with *", attribute.sourceSpan);
                            }
                            isTemplateBinding = true;
                            elementHasInlineTemplate = true;
                            var templateValue = attribute.value;
                            var templateKey = normalizedName.substring(TEMPLATE_ATTR_PREFIX$1.length);
                            var parsedVariables = [];
                            var absoluteOffset = attribute.valueSpan ? attribute.valueSpan.start.offset :
                                attribute.sourceSpan.start.offset;
                            this.bindingParser.parseInlineTemplateBinding(templateKey, templateValue, attribute.sourceSpan, absoluteOffset, [], templateParsedProperties, parsedVariables);
                            templateVariables.push.apply(templateVariables, parsedVariables.map(function (v) { return new Variable(v.name, v.value, v.sourceSpan); }));
                        }
                        else {
                            // Check for variables, events, property bindings, interpolation
                            hasBinding = this.parseAttribute(isTemplateElement, attribute, [], parsedProperties, boundEvents, variables, references);
                        }
                        if (!hasBinding && !isTemplateBinding) {
                            // don't include the bindings as attributes as well in the AST
                            attributes.push(this.visitAttribute(attribute));
                        }
                    }
                    var children = visitAll$1(preparsedElement.nonBindable ? NON_BINDABLE_VISITOR$1 : this, element.children);
                    var parsedElement;
                    if (preparsedElement.type === PreparsedElementType.NG_CONTENT) {
                        // `<ng-content>`
                        if (element.children &&
                            !element.children.every(function (node) { return isEmptyTextNode(node) || isCommentNode(node); })) {
                            this.reportError("<ng-content> element cannot have content.", element.sourceSpan);
                        }
                        var selector = preparsedElement.selectAttr;
                        var attrs = element.attrs.map(function (attr) { return _this.visitAttribute(attr); });
                        parsedElement = new Content(selector, attrs, element.sourceSpan, element.i18n);
                    }
                    else if (isTemplateElement) {
                        // `<ng-template>`
                        var attrs = this.extractAttributes(element.name, parsedProperties, i18nAttrsMeta);
                        parsedElement = new Template(element.name, attributes, attrs.bound, boundEvents, [ /* no template attributes */], children, references, variables, element.sourceSpan, element.startSourceSpan, element.endSourceSpan, element.i18n);
                    }
                    else {
                        var attrs = this.extractAttributes(element.name, parsedProperties, i18nAttrsMeta);
                        parsedElement = new Element(element.name, attributes, attrs.bound, boundEvents, children, references, element.sourceSpan, element.startSourceSpan, element.endSourceSpan, element.i18n);
                    }
                    if (elementHasInlineTemplate) {
                        // If this node is an inline-template (e.g. has *ngFor) then we need to create a template
                        // node that contains this node.
                        // Moreover, if the node is an element, then we need to hoist its attributes to the template
                        // node for matching against content projection selectors.
                        var attrs = this.extractAttributes('ng-template', templateParsedProperties, i18nAttrsMeta);
                        var templateAttrs_1 = [];
                        attrs.literal.forEach(function (attr) { return templateAttrs_1.push(attr); });
                        attrs.bound.forEach(function (attr) { return templateAttrs_1.push(attr); });
                        var hoistedAttrs = parsedElement instanceof Element ?
                            {
                                attributes: parsedElement.attributes,
                                inputs: parsedElement.inputs,
                                outputs: parsedElement.outputs,
                            } :
                            { attributes: [], inputs: [], outputs: [] };
                        // TODO(pk): test for this case
                        parsedElement = new Template(parsedElement.name, hoistedAttrs.attributes, hoistedAttrs.inputs, hoistedAttrs.outputs, templateAttrs_1, [parsedElement], [ /* no references */], templateVariables, element.sourceSpan, element.startSourceSpan, element.endSourceSpan, element.i18n);
                    }
                    return parsedElement;
                };
                HtmlAstToIvyAst.prototype.visitAttribute = function (attribute) {
                    return new TextAttribute(attribute.name, attribute.value, attribute.sourceSpan, attribute.valueSpan, attribute.i18n);
                };
                HtmlAstToIvyAst.prototype.visitText = function (text) {
                    return this._visitTextWithInterpolation(text.value, text.sourceSpan, text.i18n);
                };
                HtmlAstToIvyAst.prototype.visitExpansion = function (expansion) {
                    var _this = this;
                    var meta = expansion.i18n;
                    // do not generate Icu in case it was created
                    // outside of i18n block in a template
                    if (!meta) {
                        return null;
                    }
                    var vars = {};
                    var placeholders = {};
                    // extract VARs from ICUs - we process them separately while
                    // assembling resulting message via goog.getMsg function, since
                    // we need to pass them to top-level goog.getMsg call
                    Object.keys(meta.placeholders).forEach(function (key) {
                        var value = meta.placeholders[key];
                        if (key.startsWith(I18N_ICU_VAR_PREFIX)) {
                            var config = _this.bindingParser.interpolationConfig;
                            // ICU expression is a plain string, not wrapped into start
                            // and end tags, so we wrap it before passing to binding parser
                            var wrapped = "" + config.start + value + config.end;
                            vars[key] = _this._visitTextWithInterpolation(wrapped, expansion.sourceSpan);
                        }
                        else {
                            placeholders[key] = _this._visitTextWithInterpolation(value, expansion.sourceSpan);
                        }
                    });
                    return new Icu(vars, placeholders, expansion.sourceSpan, meta);
                };
                HtmlAstToIvyAst.prototype.visitExpansionCase = function (expansionCase) { return null; };
                HtmlAstToIvyAst.prototype.visitComment = function (comment) { return null; };
                // convert view engine `ParsedProperty` to a format suitable for IVY
                HtmlAstToIvyAst.prototype.extractAttributes = function (elementName, properties, i18nPropsMeta) {
                    var _this = this;
                    var bound = [];
                    var literal = [];
                    properties.forEach(function (prop) {
                        var i18n = i18nPropsMeta[prop.name];
                        if (prop.isLiteral) {
                            literal.push(new TextAttribute(prop.name, prop.expression.source || '', prop.sourceSpan, undefined, i18n));
                        }
                        else {
                            // Note that validation is skipped and property mapping is disabled
                            // due to the fact that we need to make sure a given prop is not an
                            // input of a directive and directive matching happens at runtime.
                            var bep = _this.bindingParser.createBoundElementProperty(elementName, prop, /* skipValidation */ true, /* mapPropertyName */ false);
                            bound.push(BoundAttribute.fromBoundElementProperty(bep, i18n));
                        }
                    });
                    return { bound: bound, literal: literal };
                };
                HtmlAstToIvyAst.prototype.parseAttribute = function (isTemplateElement, attribute, matchableAttributes, parsedProperties, boundEvents, variables, references) {
                    var name = normalizeAttributeName(attribute.name);
                    var value = attribute.value;
                    var srcSpan = attribute.sourceSpan;
                    var absoluteOffset = attribute.valueSpan ? attribute.valueSpan.start.offset : srcSpan.start.offset;
                    var bindParts = name.match(BIND_NAME_REGEXP$1);
                    var hasBinding = false;
                    if (bindParts) {
                        hasBinding = true;
                        if (bindParts[KW_BIND_IDX$1] != null) {
                            this.bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX$1], value, false, srcSpan, absoluteOffset, attribute.valueSpan, matchableAttributes, parsedProperties);
                        }
                        else if (bindParts[KW_LET_IDX$1]) {
                            if (isTemplateElement) {
                                var identifier = bindParts[IDENT_KW_IDX$1];
                                this.parseVariable(identifier, value, srcSpan, attribute.valueSpan, variables);
                            }
                            else {
                                this.reportError("\"let-\" is only supported on ng-template elements.", srcSpan);
                            }
                        }
                        else if (bindParts[KW_REF_IDX$1]) {
                            var identifier = bindParts[IDENT_KW_IDX$1];
                            this.parseReference(identifier, value, srcSpan, attribute.valueSpan, references);
                        }
                        else if (bindParts[KW_ON_IDX$1]) {
                            var events = [];
                            this.bindingParser.parseEvent(bindParts[IDENT_KW_IDX$1], value, srcSpan, attribute.valueSpan || srcSpan, matchableAttributes, events);
                            addEvents(events, boundEvents);
                        }
                        else if (bindParts[KW_BINDON_IDX$1]) {
                            this.bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX$1], value, false, srcSpan, absoluteOffset, attribute.valueSpan, matchableAttributes, parsedProperties);
                            this.parseAssignmentEvent(bindParts[IDENT_KW_IDX$1], value, srcSpan, attribute.valueSpan, matchableAttributes, boundEvents);
                        }
                        else if (bindParts[KW_AT_IDX$1]) {
                            this.bindingParser.parseLiteralAttr(name, value, srcSpan, absoluteOffset, attribute.valueSpan, matchableAttributes, parsedProperties);
                        }
                        else if (bindParts[IDENT_BANANA_BOX_IDX$1]) {
                            this.bindingParser.parsePropertyBinding(bindParts[IDENT_BANANA_BOX_IDX$1], value, false, srcSpan, absoluteOffset, attribute.valueSpan, matchableAttributes, parsedProperties);
                            this.parseAssignmentEvent(bindParts[IDENT_BANANA_BOX_IDX$1], value, srcSpan, attribute.valueSpan, matchableAttributes, boundEvents);
                        }
                        else if (bindParts[IDENT_PROPERTY_IDX$1]) {
                            this.bindingParser.parsePropertyBinding(bindParts[IDENT_PROPERTY_IDX$1], value, false, srcSpan, absoluteOffset, attribute.valueSpan, matchableAttributes, parsedProperties);
                        }
                        else if (bindParts[IDENT_EVENT_IDX$1]) {
                            var events = [];
                            this.bindingParser.parseEvent(bindParts[IDENT_EVENT_IDX$1], value, srcSpan, attribute.valueSpan || srcSpan, matchableAttributes, events);
                            addEvents(events, boundEvents);
                        }
                    }
                    else {
                        hasBinding = this.bindingParser.parsePropertyInterpolation(name, value, srcSpan, attribute.valueSpan, matchableAttributes, parsedProperties);
                    }
                    return hasBinding;
                };
                HtmlAstToIvyAst.prototype._visitTextWithInterpolation = function (value, sourceSpan, i18n) {
                    var valueNoNgsp = replaceNgsp(value);
                    var expr = this.bindingParser.parseInterpolation(valueNoNgsp, sourceSpan);
                    return expr ? new BoundText(expr, sourceSpan, i18n) : new Text(valueNoNgsp, sourceSpan);
                };
                HtmlAstToIvyAst.prototype.parseVariable = function (identifier, value, sourceSpan, valueSpan, variables) {
                    if (identifier.indexOf('-') > -1) {
                        this.reportError("\"-\" is not allowed in variable names", sourceSpan);
                    }
                    variables.push(new Variable(identifier, value, sourceSpan, valueSpan));
                };
                HtmlAstToIvyAst.prototype.parseReference = function (identifier, value, sourceSpan, valueSpan, references) {
                    if (identifier.indexOf('-') > -1) {
                        this.reportError("\"-\" is not allowed in reference names", sourceSpan);
                    }
                    references.push(new Reference(identifier, value, sourceSpan, valueSpan));
                };
                HtmlAstToIvyAst.prototype.parseAssignmentEvent = function (name, expression, sourceSpan, valueSpan, targetMatchableAttrs, boundEvents) {
                    var events = [];
                    this.bindingParser.parseEvent(name + "Change", expression + "=$event", sourceSpan, valueSpan || sourceSpan, targetMatchableAttrs, events);
                    addEvents(events, boundEvents);
                };
                HtmlAstToIvyAst.prototype.reportError = function (message, sourceSpan, level) {
                    if (level === void 0) { level = ParseErrorLevel.ERROR; }
                    this.errors.push(new ParseError(sourceSpan, message, level));
                };
                return HtmlAstToIvyAst;
            }());
            var NonBindableVisitor$1 = /** @class */ (function () {
                function NonBindableVisitor$1() {
                }
                NonBindableVisitor$1.prototype.visitElement = function (ast) {
                    var preparsedElement = preparseElement(ast);
                    if (preparsedElement.type === PreparsedElementType.SCRIPT ||
                        preparsedElement.type === PreparsedElementType.STYLE ||
                        preparsedElement.type === PreparsedElementType.STYLESHEET) {
                        // Skipping <script> for security reasons
                        // Skipping <style> and stylesheets as we already processed them
                        // in the StyleCompiler
                        return null;
                    }
                    var children = visitAll$1(this, ast.children, null);
                    return new Element(ast.name, visitAll$1(this, ast.attrs), 
                    /* inputs */ [], /* outputs */ [], children, /* references */ [], ast.sourceSpan, ast.startSourceSpan, ast.endSourceSpan);
                };
                NonBindableVisitor$1.prototype.visitComment = function (comment) { return null; };
                NonBindableVisitor$1.prototype.visitAttribute = function (attribute) {
                    return new TextAttribute(attribute.name, attribute.value, attribute.sourceSpan, undefined, attribute.i18n);
                };
                NonBindableVisitor$1.prototype.visitText = function (text) { return new Text(text.value, text.sourceSpan); };
                NonBindableVisitor$1.prototype.visitExpansion = function (expansion) { return null; };
                NonBindableVisitor$1.prototype.visitExpansionCase = function (expansionCase) { return null; };
                return NonBindableVisitor$1;
            }());
            var NON_BINDABLE_VISITOR$1 = new NonBindableVisitor$1();
            function normalizeAttributeName(attrName) {
                return /^data-/i.test(attrName) ? attrName.substring(5) : attrName;
            }
            function addEvents(events, boundEvents) {
                boundEvents.push.apply(boundEvents, events.map(function (e) { return BoundEvent.fromParsedEvent(e); }));
            }
            function isEmptyTextNode(node) {
                return node instanceof Text$3 && node.value.trim().length == 0;
            }
            function isCommentNode(node) {
                return node instanceof Comment;
            }
            function textContents(node) {
                if (node.children.length !== 1 || !(node.children[0] instanceof Text$3)) {
                    return null;
                }
                else {
                    return node.children[0].value;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TagType;
            (function (TagType) {
                TagType[TagType["ELEMENT"] = 0] = "ELEMENT";
                TagType[TagType["TEMPLATE"] = 1] = "TEMPLATE";
                TagType[TagType["PROJECTION"] = 2] = "PROJECTION";
            })(TagType || (TagType = {}));
            /**
             * Generates an object that is used as a shared state between parent and all child contexts.
             */
            function setupRegistry() {
                return { getUniqueId: getSeqNumberGenerator(), icus: new Map() };
            }
            /**
             * I18nContext is a helper class which keeps track of all i18n-related aspects
             * (accumulates placeholders, bindings, etc) between i18nStart and i18nEnd instructions.
             *
             * When we enter a nested template, the top-level context is being passed down
             * to the nested component, which uses this context to generate a child instance
             * of I18nContext class (to handle nested template) and at the end, reconciles it back
             * with the parent context.
             *
             * @param index Instruction index of i18nStart, which initiates this context
             * @param ref Reference to a translation const that represents the content if thus context
             * @param level Nestng level defined for child contexts
             * @param templateIndex Instruction index of a template which this context belongs to
             * @param meta Meta information (id, meaning, description, etc) associated with this context
             */
            var I18nContext = /** @class */ (function () {
                function I18nContext(index, ref, level, templateIndex, meta, registry) {
                    if (level === void 0) { level = 0; }
                    if (templateIndex === void 0) { templateIndex = null; }
                    this.index = index;
                    this.ref = ref;
                    this.level = level;
                    this.templateIndex = templateIndex;
                    this.meta = meta;
                    this.registry = registry;
                    this.bindings = new Set();
                    this.placeholders = new Map();
                    this.isEmitted = false;
                    this._unresolvedCtxCount = 0;
                    this._registry = registry || setupRegistry();
                    this.id = this._registry.getUniqueId();
                }
                I18nContext.prototype.appendTag = function (type, node, index, closed) {
                    if (node.isVoid && closed) {
                        return; // ignore "close" for void tags
                    }
                    var ph = node.isVoid || !closed ? node.startName : node.closeName;
                    var content = { type: type, index: index, ctx: this.id, isVoid: node.isVoid, closed: closed };
                    updatePlaceholderMap(this.placeholders, ph, content);
                };
                Object.defineProperty(I18nContext.prototype, "icus", {
                    get: function () { return this._registry.icus; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(I18nContext.prototype, "isRoot", {
                    get: function () { return this.level === 0; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(I18nContext.prototype, "isResolved", {
                    get: function () { return this._unresolvedCtxCount === 0; },
                    enumerable: true,
                    configurable: true
                });
                I18nContext.prototype.getSerializedPlaceholders = function () {
                    var result = new Map();
                    this.placeholders.forEach(function (values, key) { return result.set(key, values.map(serializePlaceholderValue)); });
                    return result;
                };
                // public API to accumulate i18n-related content
                I18nContext.prototype.appendBinding = function (binding) { this.bindings.add(binding); };
                I18nContext.prototype.appendIcu = function (name, ref) {
                    updatePlaceholderMap(this._registry.icus, name, ref);
                };
                I18nContext.prototype.appendBoundText = function (node) {
                    var _this = this;
                    var phs = assembleBoundTextPlaceholders(node, this.bindings.size, this.id);
                    phs.forEach(function (values, key) { return updatePlaceholderMap.apply(void 0, [_this.placeholders, key].concat(values)); });
                };
                I18nContext.prototype.appendTemplate = function (node, index) {
                    // add open and close tags at the same time,
                    // since we process nested templates separately
                    this.appendTag(TagType.TEMPLATE, node, index, false);
                    this.appendTag(TagType.TEMPLATE, node, index, true);
                    this._unresolvedCtxCount++;
                };
                I18nContext.prototype.appendElement = function (node, index, closed) {
                    this.appendTag(TagType.ELEMENT, node, index, closed);
                };
                I18nContext.prototype.appendProjection = function (node, index) {
                    // add open and close tags at the same time,
                    // since we process projected content separately
                    this.appendTag(TagType.PROJECTION, node, index, false);
                    this.appendTag(TagType.PROJECTION, node, index, true);
                };
                /**
                 * Generates an instance of a child context based on the root one,
                 * when we enter a nested template within I18n section.
                 *
                 * @param index Instruction index of corresponding i18nStart, which initiates this context
                 * @param templateIndex Instruction index of a template which this context belongs to
                 * @param meta Meta information (id, meaning, description, etc) associated with this context
                 *
                 * @returns I18nContext instance
                 */
                I18nContext.prototype.forkChildContext = function (index, templateIndex, meta) {
                    return new I18nContext(index, this.ref, this.level + 1, templateIndex, meta, this._registry);
                };
                /**
                 * Reconciles child context into parent one once the end of the i18n block is reached (i18nEnd).
                 *
                 * @param context Child I18nContext instance to be reconciled with parent context.
                 */
                I18nContext.prototype.reconcileChildContext = function (context) {
                    var _this = this;
                    // set the right context id for open and close
                    // template tags, so we can use it as sub-block ids
                    ['start', 'close'].forEach(function (op) {
                        var key = context.meta[op + "Name"];
                        var phs = _this.placeholders.get(key) || [];
                        var tag = phs.find(findTemplateFn(_this.id, context.templateIndex));
                        if (tag) {
                            tag.ctx = context.id;
                        }
                    });
                    // reconcile placeholders
                    var childPhs = context.placeholders;
                    childPhs.forEach(function (values, key) {
                        var phs = _this.placeholders.get(key);
                        if (!phs) {
                            _this.placeholders.set(key, values);
                            return;
                        }
                        // try to find matching template...
                        var tmplIdx = findIndex(phs, findTemplateFn(context.id, context.templateIndex));
                        if (tmplIdx >= 0) {
                            // ... if found - replace it with nested template content
                            var isCloseTag = key.startsWith('CLOSE');
                            var isTemplateTag = key.endsWith('NG-TEMPLATE');
                            if (isTemplateTag) {
                                // current template's content is placed before or after
                                // parent template tag, depending on the open/close atrribute
                                phs.splice.apply(phs, [tmplIdx + (isCloseTag ? 0 : 1), 0].concat(values));
                            }
                            else {
                                var idx = isCloseTag ? values.length - 1 : 0;
                                values[idx].tmpl = phs[tmplIdx];
                                phs.splice.apply(phs, [tmplIdx, 1].concat(values));
                            }
                        }
                        else {
                            // ... otherwise just append content to placeholder value
                            phs.push.apply(phs, values);
                        }
                        _this.placeholders.set(key, phs);
                    });
                    this._unresolvedCtxCount--;
                };
                return I18nContext;
            }());
            //
            // Helper methods
            //
            function wrap(symbol, index, contextId, closed) {
                var state = closed ? '/' : '';
                return wrapI18nPlaceholder("" + state + symbol + index, contextId);
            }
            function wrapTag(symbol, _c, closed) {
                var index = _c.index, ctx = _c.ctx, isVoid = _c.isVoid;
                return isVoid ? wrap(symbol, index, ctx) + wrap(symbol, index, ctx, true) :
                    wrap(symbol, index, ctx, closed);
            }
            function findTemplateFn(ctx, templateIndex) {
                return function (token) { return typeof token === 'object' && token.type === TagType.TEMPLATE &&
                    token.index === templateIndex && token.ctx === ctx; };
            }
            function serializePlaceholderValue(value) {
                var element = function (data, closed) { return wrapTag('#', data, closed); };
                var template = function (data, closed) { return wrapTag('*', data, closed); };
                var projection = function (data, closed) { return wrapTag('!', data, closed); };
                switch (value.type) {
                    case TagType.ELEMENT:
                        // close element tag
                        if (value.closed) {
                            return element(value, true) + (value.tmpl ? template(value.tmpl, true) : '');
                        }
                        // open element tag that also initiates a template
                        if (value.tmpl) {
                            return template(value.tmpl) + element(value) +
                                (value.isVoid ? template(value.tmpl, true) : '');
                        }
                        return element(value);
                    case TagType.TEMPLATE:
                        return template(value, value.closed);
                    case TagType.PROJECTION:
                        return projection(value, value.closed);
                    default:
                        return value;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TAG_TO_PLACEHOLDER_NAMES = {
                'A': 'LINK',
                'B': 'BOLD_TEXT',
                'BR': 'LINE_BREAK',
                'EM': 'EMPHASISED_TEXT',
                'H1': 'HEADING_LEVEL1',
                'H2': 'HEADING_LEVEL2',
                'H3': 'HEADING_LEVEL3',
                'H4': 'HEADING_LEVEL4',
                'H5': 'HEADING_LEVEL5',
                'H6': 'HEADING_LEVEL6',
                'HR': 'HORIZONTAL_RULE',
                'I': 'ITALIC_TEXT',
                'LI': 'LIST_ITEM',
                'LINK': 'MEDIA_LINK',
                'OL': 'ORDERED_LIST',
                'P': 'PARAGRAPH',
                'Q': 'QUOTATION',
                'S': 'STRIKETHROUGH_TEXT',
                'SMALL': 'SMALL_TEXT',
                'SUB': 'SUBSTRIPT',
                'SUP': 'SUPERSCRIPT',
                'TBODY': 'TABLE_BODY',
                'TD': 'TABLE_CELL',
                'TFOOT': 'TABLE_FOOTER',
                'TH': 'TABLE_HEADER_CELL',
                'THEAD': 'TABLE_HEADER',
                'TR': 'TABLE_ROW',
                'TT': 'MONOSPACED_TEXT',
                'U': 'UNDERLINED_TEXT',
                'UL': 'UNORDERED_LIST',
            };
            /**
             * Creates unique names for placeholder with different content.
             *
             * Returns the same placeholder name when the content is identical.
             */
            var PlaceholderRegistry = /** @class */ (function () {
                function PlaceholderRegistry() {
                    // Count the occurrence of the base name top generate a unique name
                    this._placeHolderNameCounts = {};
                    // Maps signature to placeholder names
                    this._signatureToName = {};
                }
                PlaceholderRegistry.prototype.getStartTagPlaceholderName = function (tag, attrs, isVoid) {
                    var signature = this._hashTag(tag, attrs, isVoid);
                    if (this._signatureToName[signature]) {
                        return this._signatureToName[signature];
                    }
                    var upperTag = tag.toUpperCase();
                    var baseName = TAG_TO_PLACEHOLDER_NAMES[upperTag] || "TAG_" + upperTag;
                    var name = this._generateUniqueName(isVoid ? baseName : "START_" + baseName);
                    this._signatureToName[signature] = name;
                    return name;
                };
                PlaceholderRegistry.prototype.getCloseTagPlaceholderName = function (tag) {
                    var signature = this._hashClosingTag(tag);
                    if (this._signatureToName[signature]) {
                        return this._signatureToName[signature];
                    }
                    var upperTag = tag.toUpperCase();
                    var baseName = TAG_TO_PLACEHOLDER_NAMES[upperTag] || "TAG_" + upperTag;
                    var name = this._generateUniqueName("CLOSE_" + baseName);
                    this._signatureToName[signature] = name;
                    return name;
                };
                PlaceholderRegistry.prototype.getPlaceholderName = function (name, content) {
                    var upperName = name.toUpperCase();
                    var signature = "PH: " + upperName + "=" + content;
                    if (this._signatureToName[signature]) {
                        return this._signatureToName[signature];
                    }
                    var uniqueName = this._generateUniqueName(upperName);
                    this._signatureToName[signature] = uniqueName;
                    return uniqueName;
                };
                PlaceholderRegistry.prototype.getUniquePlaceholder = function (name) {
                    return this._generateUniqueName(name.toUpperCase());
                };
                // Generate a hash for a tag - does not take attribute order into account
                PlaceholderRegistry.prototype._hashTag = function (tag, attrs, isVoid) {
                    var start = "<" + tag;
                    var strAttrs = Object.keys(attrs).sort().map(function (name) { return " " + name + "=" + attrs[name]; }).join('');
                    var end = isVoid ? '/>' : "></" + tag + ">";
                    return start + strAttrs + end;
                };
                PlaceholderRegistry.prototype._hashClosingTag = function (tag) { return this._hashTag("/" + tag, {}, false); };
                PlaceholderRegistry.prototype._generateUniqueName = function (base) {
                    var seen = this._placeHolderNameCounts.hasOwnProperty(base);
                    if (!seen) {
                        this._placeHolderNameCounts[base] = 1;
                        return base;
                    }
                    var id = this._placeHolderNameCounts[base];
                    this._placeHolderNameCounts[base] = id + 1;
                    return base + "_" + id;
                };
                return PlaceholderRegistry;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _expParser = new Parser$1(new Lexer());
            /**
             * Returns a function converting html nodes to an i18n Message given an interpolationConfig
             */
            function createI18nMessageFactory(interpolationConfig) {
                var visitor = new _I18nVisitor(_expParser, interpolationConfig);
                return function (nodes, meaning, description, id, visitNodeFn) { return visitor.toI18nMessage(nodes, meaning, description, id, visitNodeFn); };
            }
            var _I18nVisitor = /** @class */ (function () {
                function _I18nVisitor(_expressionParser, _interpolationConfig) {
                    this._expressionParser = _expressionParser;
                    this._interpolationConfig = _interpolationConfig;
                }
                _I18nVisitor.prototype.toI18nMessage = function (nodes, meaning, description, id, visitNodeFn) {
                    this._isIcu = nodes.length == 1 && nodes[0] instanceof Expansion;
                    this._icuDepth = 0;
                    this._placeholderRegistry = new PlaceholderRegistry();
                    this._placeholderToContent = {};
                    this._placeholderToMessage = {};
                    this._visitNodeFn = visitNodeFn;
                    var i18nodes = visitAll$1(this, nodes, {});
                    return new Message(i18nodes, this._placeholderToContent, this._placeholderToMessage, meaning, description, id);
                };
                _I18nVisitor.prototype._visitNode = function (html, i18n) {
                    if (this._visitNodeFn) {
                        this._visitNodeFn(html, i18n);
                    }
                    return i18n;
                };
                _I18nVisitor.prototype.visitElement = function (el, context) {
                    var children = visitAll$1(this, el.children);
                    var attrs = {};
                    el.attrs.forEach(function (attr) {
                        // Do not visit the attributes, translatable ones are top-level ASTs
                        attrs[attr.name] = attr.value;
                    });
                    var isVoid = getHtmlTagDefinition(el.name).isVoid;
                    var startPhName = this._placeholderRegistry.getStartTagPlaceholderName(el.name, attrs, isVoid);
                    this._placeholderToContent[startPhName] = el.sourceSpan.toString();
                    var closePhName = '';
                    if (!isVoid) {
                        closePhName = this._placeholderRegistry.getCloseTagPlaceholderName(el.name);
                        this._placeholderToContent[closePhName] = "</" + el.name + ">";
                    }
                    var node = new TagPlaceholder(el.name, attrs, startPhName, closePhName, children, isVoid, el.sourceSpan);
                    return this._visitNode(el, node);
                };
                _I18nVisitor.prototype.visitAttribute = function (attribute, context) {
                    var node = this._visitTextWithInterpolation(attribute.value, attribute.sourceSpan);
                    return this._visitNode(attribute, node);
                };
                _I18nVisitor.prototype.visitText = function (text, context) {
                    var node = this._visitTextWithInterpolation(text.value, text.sourceSpan);
                    return this._visitNode(text, node);
                };
                _I18nVisitor.prototype.visitComment = function (comment, context) { return null; };
                _I18nVisitor.prototype.visitExpansion = function (icu, context) {
                    var _this = this;
                    this._icuDepth++;
                    var i18nIcuCases = {};
                    var i18nIcu = new Icu$1(icu.switchValue, icu.type, i18nIcuCases, icu.sourceSpan);
                    icu.cases.forEach(function (caze) {
                        i18nIcuCases[caze.value] = new Container(caze.expression.map(function (node) { return node.visit(_this, {}); }), caze.expSourceSpan);
                    });
                    this._icuDepth--;
                    if (this._isIcu || this._icuDepth > 0) {
                        // Returns an ICU node when:
                        // - the message (vs a part of the message) is an ICU message, or
                        // - the ICU message is nested.
                        var expPh = this._placeholderRegistry.getUniquePlaceholder("VAR_" + icu.type);
                        i18nIcu.expressionPlaceholder = expPh;
                        this._placeholderToContent[expPh] = icu.switchValue;
                        return this._visitNode(icu, i18nIcu);
                    }
                    // Else returns a placeholder
                    // ICU placeholders should not be replaced with their original content but with the their
                    // translations. We need to create a new visitor (they are not re-entrant) to compute the
                    // message id.
                    // TODO(vicb): add a html.Node -> i18n.Message cache to avoid having to re-create the msg
                    var phName = this._placeholderRegistry.getPlaceholderName('ICU', icu.sourceSpan.toString());
                    var visitor = new _I18nVisitor(this._expressionParser, this._interpolationConfig);
                    this._placeholderToMessage[phName] = visitor.toI18nMessage([icu], '', '', '');
                    var node = new IcuPlaceholder(i18nIcu, phName, icu.sourceSpan);
                    return this._visitNode(icu, node);
                };
                _I18nVisitor.prototype.visitExpansionCase = function (icuCase, context) {
                    throw new Error('Unreachable code');
                };
                _I18nVisitor.prototype._visitTextWithInterpolation = function (text, sourceSpan) {
                    var splitInterpolation = this._expressionParser.splitInterpolation(text, sourceSpan.start.toString(), this._interpolationConfig);
                    if (!splitInterpolation) {
                        // No expression, return a single text
                        return new Text$1(text, sourceSpan);
                    }
                    // Return a group of text + expressions
                    var nodes = [];
                    var container = new Container(nodes, sourceSpan);
                    var _c = this._interpolationConfig, sDelimiter = _c.start, eDelimiter = _c.end;
                    for (var i = 0; i < splitInterpolation.strings.length - 1; i++) {
                        var expression = splitInterpolation.expressions[i];
                        var baseName = _extractPlaceholderName(expression) || 'INTERPOLATION';
                        var phName = this._placeholderRegistry.getPlaceholderName(baseName, expression);
                        if (splitInterpolation.strings[i].length) {
                            // No need to add empty strings
                            nodes.push(new Text$1(splitInterpolation.strings[i], sourceSpan));
                        }
                        nodes.push(new Placeholder(expression, phName, sourceSpan));
                        this._placeholderToContent[phName] = sDelimiter + expression + eDelimiter;
                    }
                    // The last index contains no expression
                    var lastStringIdx = splitInterpolation.strings.length - 1;
                    if (splitInterpolation.strings[lastStringIdx].length) {
                        nodes.push(new Text$1(splitInterpolation.strings[lastStringIdx], sourceSpan));
                    }
                    return container;
                };
                return _I18nVisitor;
            }());
            var _CUSTOM_PH_EXP = /\/\/[\s\S]*i18n[\s\S]*\([\s\S]*ph[\s\S]*=[\s\S]*("|')([\s\S]*?)\1[\s\S]*\)/g;
            function _extractPlaceholderName(input) {
                return input.split(_CUSTOM_PH_EXP)[2];
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function setI18nRefs(html, i18n) {
                html.i18n = i18n;
            }
            /**
             * This visitor walks over HTML parse tree and converts information stored in
             * i18n-related attributes ("i18n" and "i18n-*") into i18n meta object that is
             * stored with other element's and attribute's information.
             */
            var I18nMetaVisitor = /** @class */ (function () {
                function I18nMetaVisitor(interpolationConfig, keepI18nAttrs) {
                    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                    if (keepI18nAttrs === void 0) { keepI18nAttrs = false; }
                    this.interpolationConfig = interpolationConfig;
                    this.keepI18nAttrs = keepI18nAttrs;
                    // i18n message generation factory
                    this._createI18nMessage = createI18nMessageFactory(interpolationConfig);
                }
                I18nMetaVisitor.prototype._generateI18nMessage = function (nodes, meta, visitNodeFn) {
                    if (meta === void 0) { meta = ''; }
                    var parsed = typeof meta === 'string' ? parseI18nMeta(meta) : metaFromI18nMessage(meta);
                    var message = this._createI18nMessage(nodes, parsed.meaning || '', parsed.description || '', parsed.id || '', visitNodeFn);
                    if (!message.id) {
                        // generate (or restore) message id if not specified in template
                        message.id = typeof meta !== 'string' && meta.id || decimalDigest(message);
                    }
                    return message;
                };
                I18nMetaVisitor.prototype.visitElement = function (element, context) {
                    if (hasI18nAttrs(element)) {
                        var attrs = [];
                        var attrsMeta = {};
                        for (var _c = 0, _d = element.attrs; _c < _d.length; _c++) {
                            var attr = _d[_c];
                            if (attr.name === I18N_ATTR) {
                                // root 'i18n' node attribute
                                var i18n = element.i18n || attr.value;
                                var message = this._generateI18nMessage(element.children, i18n, setI18nRefs);
                                // do not assign empty i18n meta
                                if (message.nodes.length) {
                                    element.i18n = message;
                                }
                            }
                            else if (attr.name.startsWith(I18N_ATTR_PREFIX)) {
                                // 'i18n-*' attributes
                                var key = attr.name.slice(I18N_ATTR_PREFIX.length);
                                attrsMeta[key] = attr.value;
                            }
                            else {
                                // non-i18n attributes
                                attrs.push(attr);
                            }
                        }
                        // set i18n meta for attributes
                        if (Object.keys(attrsMeta).length) {
                            for (var _e = 0, attrs_1 = attrs; _e < attrs_1.length; _e++) {
                                var attr = attrs_1[_e];
                                var meta = attrsMeta[attr.name];
                                // do not create translation for empty attributes
                                if (meta !== undefined && attr.value) {
                                    attr.i18n = this._generateI18nMessage([attr], attr.i18n || meta);
                                }
                            }
                        }
                        if (!this.keepI18nAttrs) {
                            // update element's attributes,
                            // keeping only non-i18n related ones
                            element.attrs = attrs;
                        }
                    }
                    visitAll$1(this, element.children);
                    return element;
                };
                I18nMetaVisitor.prototype.visitExpansion = function (expansion, context) {
                    var message;
                    var meta = expansion.i18n;
                    if (meta instanceof IcuPlaceholder) {
                        // set ICU placeholder name (e.g. "ICU_1"),
                        // generated while processing root element contents,
                        // so we can reference it when we output translation
                        var name = meta.name;
                        message = this._generateI18nMessage([expansion], meta);
                        var icu = icuFromI18nMessage(message);
                        icu.name = name;
                    }
                    else {
                        // when ICU is a root level translation
                        message = this._generateI18nMessage([expansion], meta);
                    }
                    expansion.i18n = message;
                    return expansion;
                };
                I18nMetaVisitor.prototype.visitText = function (text, context) { return text; };
                I18nMetaVisitor.prototype.visitAttribute = function (attribute, context) { return attribute; };
                I18nMetaVisitor.prototype.visitComment = function (comment, context) { return comment; };
                I18nMetaVisitor.prototype.visitExpansionCase = function (expansionCase, context) { return expansionCase; };
                return I18nMetaVisitor;
            }());
            function processI18nMeta(htmlAstWithErrors, interpolationConfig) {
                if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                return new ParseTreeResult(visitAll$1(new I18nMetaVisitor(interpolationConfig, /* keepI18nAttrs */ false), htmlAstWithErrors.rootNodes), htmlAstWithErrors.errors);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * This visitor walks over i18n tree and generates its string representation, including ICUs and
             * placeholders in `{$placeholder}` (for plain messages) or `{PLACEHOLDER}` (inside ICUs) format.
             */
            var SerializerVisitor = /** @class */ (function () {
                function SerializerVisitor() {
                    /**
                     * Keeps track of ICU nesting level, allowing to detect that we are processing elements of an ICU.
                     *
                     * This is needed due to the fact that placeholders in ICUs and in other messages are represented
                     * differently in Closure:
                     * - {$placeholder} in non-ICU case
                     * - {PLACEHOLDER} inside ICU
                     */
                    this.icuNestingLevel = 0;
                }
                SerializerVisitor.prototype.formatPh = function (value) {
                    var isInsideIcu = this.icuNestingLevel > 0;
                    var formatted = formatI18nPlaceholderName(value, /* useCamelCase */ !isInsideIcu);
                    return isInsideIcu ? "{" + formatted + "}" : "{$" + formatted + "}";
                };
                SerializerVisitor.prototype.visitText = function (text, context) { return text.value; };
                SerializerVisitor.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    return container.children.map(function (child) { return child.visit(_this); }).join('');
                };
                SerializerVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    this.icuNestingLevel++;
                    var strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
                    var result = "{" + icu.expressionPlaceholder + ", " + icu.type + ", " + strCases.join(' ') + "}";
                    this.icuNestingLevel--;
                    return result;
                };
                SerializerVisitor.prototype.visitTagPlaceholder = function (ph, context) {
                    var _this = this;
                    return ph.isVoid ?
                        this.formatPh(ph.startName) :
                        "" + this.formatPh(ph.startName) + ph.children.map(function (child) { return child.visit(_this); }).join('') + this.formatPh(ph.closeName);
                };
                SerializerVisitor.prototype.visitPlaceholder = function (ph, context) { return this.formatPh(ph.name); };
                SerializerVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
                    return this.formatPh(ph.name);
                };
                return SerializerVisitor;
            }());
            var serializerVisitor$1 = new SerializerVisitor();
            function getSerializedI18nContent(message) {
                return message.nodes.map(function (node) { return node.visit(serializerVisitor$1, null); }).join('');
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // Selector attribute name of `<ng-content>`
            var NG_CONTENT_SELECT_ATTR$1 = 'select';
            // Attribute name of `ngProjectAs`.
            var NG_PROJECT_AS_ATTR_NAME = 'ngProjectAs';
            // List of supported global targets for event listeners
            var GLOBAL_TARGET_RESOLVERS = new Map([['window', Identifiers$1.resolveWindow], ['document', Identifiers$1.resolveDocument], ['body', Identifiers$1.resolveBody]]);
            var LEADING_TRIVIA_CHARS = [' ', '\n', '\r', '\t'];
            //  if (rf & flags) { .. }
            function renderFlagCheckIfStmt(flags, statements) {
                return ifStmt(variable(RENDER_FLAGS).bitwiseAnd(literal(flags), null, false), statements);
            }
            function prepareEventListenerParameters(eventAst, handlerName, scope) {
                if (handlerName === void 0) { handlerName = null; }
                if (scope === void 0) { scope = null; }
                var type = eventAst.type, name = eventAst.name, target = eventAst.target, phase = eventAst.phase, handler = eventAst.handler;
                if (target && !GLOBAL_TARGET_RESOLVERS.has(target)) {
                    throw new Error("Unexpected global target '" + target + "' defined for '" + name + "' event.\n        Supported list of global targets: " + Array.from(GLOBAL_TARGET_RESOLVERS.keys()) + ".");
                }
                var implicitReceiverExpr = (scope === null || scope.bindingLevel === 0) ?
                    variable(CONTEXT_NAME) :
                    scope.getOrCreateSharedContextVar(0);
                var bindingExpr = convertActionBinding(scope, implicitReceiverExpr, handler, 'b', function () { return error('Unexpected interpolation'); }, eventAst.handlerSpan);
                var statements = [];
                if (scope) {
                    statements.push.apply(statements, scope.restoreViewStatement());
                    statements.push.apply(statements, scope.variableDeclarations());
                }
                statements.push.apply(statements, bindingExpr.render3Stmts);
                var eventName = type === 1 /* Animation */ ? prepareSyntheticListenerName(name, phase) : name;
                var fnName = handlerName && sanitizeIdentifier(handlerName);
                var fnArgs = [new FnParam('$event', DYNAMIC_TYPE)];
                var handlerFn = fn(fnArgs, statements, INFERRED_TYPE, null, fnName);
                var params = [literal(eventName), handlerFn];
                if (target) {
                    params.push(literal(false), // `useCapture` flag, defaults to `false`
                    importExpr(GLOBAL_TARGET_RESOLVERS.get(target)));
                }
                return params;
            }
            var TemplateDefinitionBuilder = /** @class */ (function () {
                function TemplateDefinitionBuilder(constantPool, parentBindingScope, level, contextName, i18nContext, templateIndex, templateName, directiveMatcher, directives, pipeTypeByName, pipes, _namespace, relativeContextFilePath, i18nUseExternalIds) {
                    var _this = this;
                    if (level === void 0) { level = 0; }
                    this.constantPool = constantPool;
                    this.level = level;
                    this.contextName = contextName;
                    this.i18nContext = i18nContext;
                    this.templateIndex = templateIndex;
                    this.templateName = templateName;
                    this.directiveMatcher = directiveMatcher;
                    this.directives = directives;
                    this.pipeTypeByName = pipeTypeByName;
                    this.pipes = pipes;
                    this._namespace = _namespace;
                    this.relativeContextFilePath = relativeContextFilePath;
                    this.i18nUseExternalIds = i18nUseExternalIds;
                    this._dataIndex = 0;
                    this._bindingContext = 0;
                    this._prefixCode = [];
                    /**
                     * List of callbacks to generate creation mode instructions. We store them here as we process
                     * the template so bindings in listeners are resolved only once all nodes have been visited.
                     * This ensures all local refs and context variables are available for matching.
                     */
                    this._creationCodeFns = [];
                    /**
                     * List of callbacks to generate update mode instructions. We store them here as we process
                     * the template so bindings are resolved only once all nodes have been visited. This ensures
                     * all local refs and context variables are available for matching.
                     */
                    this._updateCodeFns = [];
                    /**
                     * Memorizes the last node index for which a select instruction has been generated.
                     * We're initializing this to -1 to ensure the `select(0)` instruction is generated before any
                     * relevant update instructions.
                     */
                    this._lastNodeIndexWithFlush = -1;
                    /** Temporary variable declarations generated from visiting pipes, literals, etc. */
                    this._tempVariables = [];
                    /**
                     * List of callbacks to build nested templates. Nested templates must not be visited until
                     * after the parent template has finished visiting all of its nodes. This ensures that all
                     * local ref bindings in nested templates are able to find local ref values if the refs
                     * are defined after the template declaration.
                     */
                    this._nestedTemplateFns = [];
                    this._unsupported = unsupported;
                    // i18n context local to this template
                    this.i18n = null;
                    // Number of slots to reserve for pureFunctions
                    this._pureFunctionSlots = 0;
                    // Number of binding slots
                    this._bindingSlots = 0;
                    // Projection slots found in the template. Projection slots can distribute projected
                    // nodes based on a selector, or can just use the wildcard selector to match
                    // all nodes which aren't matching any selector.
                    this._ngContentReservedSlots = [];
                    // Number of non-default selectors found in all parent templates of this template. We need to
                    // track it to properly adjust projection slot index in the `projection` instruction.
                    this._ngContentSelectorsOffset = 0;
                    // Expression that should be used as implicit receiver when converting template
                    // expressions to output AST.
                    this._implicitReceiverExpr = null;
                    // These should be handled in the template or element directly.
                    this.visitReference = invalid$1;
                    this.visitVariable = invalid$1;
                    this.visitTextAttribute = invalid$1;
                    this.visitBoundAttribute = invalid$1;
                    this.visitBoundEvent = invalid$1;
                    this._bindingScope = parentBindingScope.nestedScope(level);
                    // Turn the relative context file path into an identifier by replacing non-alphanumeric
                    // characters with underscores.
                    this.fileBasedI18nSuffix = relativeContextFilePath.replace(/[^A-Za-z0-9]/g, '_') + '_';
                    this._valueConverter = new ValueConverter(constantPool, function () { return _this.allocateDataSlot(); }, function (numSlots) { return _this.allocatePureFunctionSlots(numSlots); }, function (name, localName, slot, value) {
                        var pipeType = pipeTypeByName.get(name);
                        if (pipeType) {
                            _this.pipes.add(pipeType);
                        }
                        _this._bindingScope.set(_this.level, localName, value);
                        _this.creationInstruction(null, Identifiers$1.pipe, [literal(slot), literal(name)]);
                    });
                }
                TemplateDefinitionBuilder.prototype.registerContextVariables = function (variable$1) {
                    var scopedName = this._bindingScope.freshReferenceName();
                    var retrievalLevel = this.level;
                    var lhs = variable(variable$1.name + scopedName);
                    this._bindingScope.set(retrievalLevel, variable$1.name, lhs, 1 /* CONTEXT */, function (scope, relativeLevel) {
                        var rhs;
                        if (scope.bindingLevel === retrievalLevel) {
                            // e.g. ctx
                            rhs = variable(CONTEXT_NAME);
                        }
                        else {
                            var sharedCtxVar = scope.getSharedContextName(retrievalLevel);
                            // e.g. ctx_r0   OR  x(2);
                            rhs = sharedCtxVar ? sharedCtxVar : generateNextContextExpr(relativeLevel);
                        }
                        // e.g. const $item$ = x(2).$implicit;
                        return [lhs.set(rhs.prop(variable$1.value || IMPLICIT_REFERENCE)).toConstDecl()];
                    });
                };
                TemplateDefinitionBuilder.prototype.buildTemplateFunction = function (nodes, variables, ngContentSelectorsOffset, i18n) {
                    var _this = this;
                    if (ngContentSelectorsOffset === void 0) { ngContentSelectorsOffset = 0; }
                    this._ngContentSelectorsOffset = ngContentSelectorsOffset;
                    if (this._namespace !== Identifiers$1.namespaceHTML) {
                        this.creationInstruction(null, this._namespace);
                    }
                    // Create variable bindings
                    variables.forEach(function (v) { return _this.registerContextVariables(v); });
                    // Initiate i18n context in case:
                    // - this template has parent i18n context
                    // - or the template has i18n meta associated with it,
                    //   but it's not initiated by the Element (e.g. <ng-template i18n>)
                    var initI18nContext = this.i18nContext || (isI18nRootNode(i18n) && !isSingleI18nIcu(i18n) &&
                        !(isSingleElementTemplate(nodes) && nodes[0].i18n === i18n));
                    var selfClosingI18nInstruction = hasTextChildrenOnly(nodes);
                    if (initI18nContext) {
                        this.i18nStart(null, i18n, selfClosingI18nInstruction);
                    }
                    // This is the initial pass through the nodes of this template. In this pass, we
                    // queue all creation mode and update mode instructions for generation in the second
                    // pass. It's necessary to separate the passes to ensure local refs are defined before
                    // resolving bindings. We also count bindings in this pass as we walk bound expressions.
                    visitAll(this, nodes);
                    // Add total binding count to pure function count so pure function instructions are
                    // generated with the correct slot offset when update instructions are processed.
                    this._pureFunctionSlots += this._bindingSlots;
                    // Pipes are walked in the first pass (to enqueue `pipe()` creation instructions and
                    // `pipeBind` update instructions), so we have to update the slot offsets manually
                    // to account for bindings.
                    this._valueConverter.updatePipeSlotOffsets(this._bindingSlots);
                    // Nested templates must be processed before creation instructions so template()
                    // instructions can be generated with the correct internal const count.
                    this._nestedTemplateFns.forEach(function (buildTemplateFn) { return buildTemplateFn(); });
                    // Output the `projectionDef` instruction when some `<ng-content>` tags are present.
                    // The `projectionDef` instruction is only emitted for the component template and
                    // is skipped for nested templates (<ng-template> tags).
                    if (this.level === 0 && this._ngContentReservedSlots.length) {
                        var parameters = [];
                        // By default the `projectionDef` instructions creates one slot for the wildcard
                        // selector if no parameters are passed. Therefore we only want to allocate a new
                        // array for the projection slots if the default projection slot is not sufficient.
                        if (this._ngContentReservedSlots.length > 1 || this._ngContentReservedSlots[0] !== '*') {
                            var r3ReservedSlots = this._ngContentReservedSlots.map(function (s) { return s !== '*' ? parseSelectorToR3Selector(s) : s; });
                            parameters.push(this.constantPool.getConstLiteral(asLiteral(r3ReservedSlots), true));
                        }
                        // Since we accumulate ngContent selectors while processing template elements,
                        // we *prepend* `projectionDef` to creation instructions block, to put it before
                        // any `projection` instructions
                        this.creationInstruction(null, Identifiers$1.projectionDef, parameters, /* prepend */ true);
                    }
                    if (initI18nContext) {
                        this.i18nEnd(null, selfClosingI18nInstruction);
                    }
                    // Generate all the creation mode instructions (e.g. resolve bindings in listeners)
                    var creationStatements = this._creationCodeFns.map(function (fn) { return fn(); });
                    // Generate all the update mode instructions (e.g. resolve property or text bindings)
                    var updateStatements = this._updateCodeFns.map(function (fn) { return fn(); });
                    //  Variable declaration must occur after binding resolution so we can generate context
                    //  instructions that build on each other.
                    // e.g. const b = nextContext().$implicit(); const b = nextContext();
                    var creationVariables = this._bindingScope.viewSnapshotStatements();
                    var updateVariables = this._bindingScope.variableDeclarations().concat(this._tempVariables);
                    var creationBlock = creationStatements.length > 0 ?
                        [renderFlagCheckIfStmt(1 /* Create */, creationVariables.concat(creationStatements))] :
                        [];
                    var updateBlock = updateStatements.length > 0 ?
                        [renderFlagCheckIfStmt(2 /* Update */, updateVariables.concat(updateStatements))] :
                        [];
                    return fn(
                    // i.e. (rf: RenderFlags, ctx: any)
                    [new FnParam(RENDER_FLAGS, NUMBER_TYPE), new FnParam(CONTEXT_NAME, null)], this._prefixCode.concat(creationBlock, updateBlock), INFERRED_TYPE, null, this.templateName);
                };
                // LocalResolver
                TemplateDefinitionBuilder.prototype.getLocal = function (name) { return this._bindingScope.get(name); };
                // LocalResolver
                TemplateDefinitionBuilder.prototype.notifyImplicitReceiverUse = function () { this._bindingScope.notifyImplicitReceiverUse(); };
                TemplateDefinitionBuilder.prototype.i18nTranslate = function (message, params, ref, transformFn) {
                    var _c;
                    if (params === void 0) { params = {}; }
                    var _ref = ref || variable(this.constantPool.uniqueName(TRANSLATION_PREFIX));
                    // Closure Compiler requires const names to start with `MSG_` but disallows any other const to
                    // start with `MSG_`. We define a variable starting with `MSG_` just for the `goog.getMsg` call
                    var closureVar = this.i18nGenerateClosureVar(message.id);
                    var formattedParams = this.i18nFormatPlaceholderNames(params, /* useCamelCase */ true);
                    var meta = metaFromI18nMessage(message);
                    var content = getSerializedI18nContent(message);
                    var statements = getTranslationDeclStmts(_ref, closureVar, content, meta, formattedParams, transformFn);
                    (_c = this.constantPool.statements).push.apply(_c, statements);
                    return _ref;
                };
                TemplateDefinitionBuilder.prototype.i18nFormatPlaceholderNames = function (params, useCamelCase) {
                    if (params === void 0) { params = {}; }
                    var _params = {};
                    if (params && Object.keys(params).length) {
                        Object.keys(params).forEach(function (key) { return _params[formatI18nPlaceholderName(key, useCamelCase)] = params[key]; });
                    }
                    return _params;
                };
                TemplateDefinitionBuilder.prototype.i18nAppendBindings = function (expressions) {
                    var _this = this;
                    if (expressions.length > 0) {
                        expressions.forEach(function (expression) { return _this.i18n.appendBinding(expression); });
                    }
                };
                TemplateDefinitionBuilder.prototype.i18nBindProps = function (props) {
                    var _this = this;
                    var bound = {};
                    Object.keys(props).forEach(function (key) {
                        var prop = props[key];
                        if (prop instanceof Text) {
                            bound[key] = literal(prop.value);
                        }
                        else {
                            var value = prop.value.visit(_this._valueConverter);
                            _this.allocateBindingSlots(value);
                            if (value instanceof Interpolation) {
                                var strings = value.strings, expressions = value.expressions;
                                var _c = _this.i18n, id = _c.id, bindings = _c.bindings;
                                var label = assembleI18nBoundString(strings, bindings.size, id);
                                _this.i18nAppendBindings(expressions);
                                bound[key] = literal(label);
                            }
                        }
                    });
                    return bound;
                };
                TemplateDefinitionBuilder.prototype.i18nGenerateClosureVar = function (messageId) {
                    var name;
                    var suffix = this.fileBasedI18nSuffix.toUpperCase();
                    if (this.i18nUseExternalIds) {
                        var prefix = getTranslationConstPrefix("EXTERNAL_");
                        var uniqueSuffix = this.constantPool.uniqueName(suffix);
                        name = "" + prefix + sanitizeIdentifier(messageId) + "$$" + uniqueSuffix;
                    }
                    else {
                        var prefix = getTranslationConstPrefix(suffix);
                        name = this.constantPool.uniqueName(prefix);
                    }
                    return variable(name);
                };
                TemplateDefinitionBuilder.prototype.i18nUpdateRef = function (context) {
                    var icus = context.icus, meta = context.meta, isRoot = context.isRoot, isResolved = context.isResolved, isEmitted = context.isEmitted;
                    if (isRoot && isResolved && !isEmitted && !isSingleI18nIcu(meta)) {
                        context.isEmitted = true;
                        var placeholders = context.getSerializedPlaceholders();
                        var icuMapping_1 = {};
                        var params_3 = placeholders.size ? placeholdersToParams(placeholders) : {};
                        if (icus.size) {
                            icus.forEach(function (refs, key) {
                                if (refs.length === 1) {
                                    // if we have one ICU defined for a given
                                    // placeholder - just output its reference
                                    params_3[key] = refs[0];
                                }
                                else {
                                    // ... otherwise we need to activate post-processing
                                    // to replace ICU placeholders with proper values
                                    var placeholder = wrapI18nPlaceholder("" + I18N_ICU_MAPPING_PREFIX + key);
                                    params_3[key] = literal(placeholder);
                                    icuMapping_1[key] = literalArr(refs);
                                }
                            });
                        }
                        // translation requires post processing in 2 cases:
                        // - if we have placeholders with multiple values (ex. `START_DIV`: [�#1�, �#2�, ...])
                        // - if we have multiple ICUs that refer to the same placeholder name
                        var needsPostprocessing = Array.from(placeholders.values()).some(function (value) { return value.length > 1; }) ||
                            Object.keys(icuMapping_1).length;
                        var transformFn = void 0;
                        if (needsPostprocessing) {
                            transformFn = function (raw) {
                                var args = [raw];
                                if (Object.keys(icuMapping_1).length) {
                                    args.push(mapLiteral(icuMapping_1, true));
                                }
                                return instruction(null, Identifiers$1.i18nPostprocess, args);
                            };
                        }
                        this.i18nTranslate(meta, params_3, context.ref, transformFn);
                    }
                };
                TemplateDefinitionBuilder.prototype.i18nStart = function (span, meta, selfClosing) {
                    if (span === void 0) { span = null; }
                    var index = this.allocateDataSlot();
                    if (this.i18nContext) {
                        this.i18n = this.i18nContext.forkChildContext(index, this.templateIndex, meta);
                    }
                    else {
                        var ref_1 = variable(this.constantPool.uniqueName(TRANSLATION_PREFIX));
                        this.i18n = new I18nContext(index, ref_1, 0, this.templateIndex, meta);
                    }
                    // generate i18nStart instruction
                    var _c = this.i18n, id = _c.id, ref = _c.ref;
                    var params = [literal(index), ref];
                    if (id > 0) {
                        // do not push 3rd argument (sub-block id)
                        // into i18nStart call for top level i18n context
                        params.push(literal(id));
                    }
                    this.creationInstruction(span, selfClosing ? Identifiers$1.i18n : Identifiers$1.i18nStart, params);
                };
                TemplateDefinitionBuilder.prototype.i18nEnd = function (span, selfClosing) {
                    var _this = this;
                    if (span === void 0) { span = null; }
                    if (!this.i18n) {
                        throw new Error('i18nEnd is executed with no i18n context present');
                    }
                    if (this.i18nContext) {
                        this.i18nContext.reconcileChildContext(this.i18n);
                        this.i18nUpdateRef(this.i18nContext);
                    }
                    else {
                        this.i18nUpdateRef(this.i18n);
                    }
                    // setup accumulated bindings
                    var _c = this.i18n, index = _c.index, bindings = _c.bindings;
                    if (bindings.size) {
                        var chainBindings_1 = [];
                        bindings.forEach(function (binding) {
                            chainBindings_1.push({ sourceSpan: span, value: function () { return _this.convertPropertyBinding(binding); } });
                        });
                        this.updateInstructionChain(index, Identifiers$1.i18nExp, chainBindings_1);
                        this.updateInstruction(index, span, Identifiers$1.i18nApply, [literal(index)]);
                    }
                    if (!selfClosing) {
                        this.creationInstruction(span, Identifiers$1.i18nEnd);
                    }
                    this.i18n = null; // reset local i18n context
                };
                TemplateDefinitionBuilder.prototype.visitContent = function (ngContent) {
                    var slot = this.allocateDataSlot();
                    var projectionSlotIdx = this._ngContentSelectorsOffset + this._ngContentReservedSlots.length;
                    var parameters = [literal(slot)];
                    var attributes = [];
                    this._ngContentReservedSlots.push(ngContent.selector);
                    ngContent.attributes.forEach(function (attribute) {
                        var name = attribute.name, value = attribute.value;
                        if (name === NG_PROJECT_AS_ATTR_NAME) {
                            attributes.push.apply(attributes, getNgProjectAsLiteral(attribute));
                        }
                        else if (name.toLowerCase() !== NG_CONTENT_SELECT_ATTR$1) {
                            attributes.push(literal(name), literal(value));
                        }
                    });
                    if (attributes.length > 0) {
                        parameters.push(literal(projectionSlotIdx), literalArr(attributes));
                    }
                    else if (projectionSlotIdx !== 0) {
                        parameters.push(literal(projectionSlotIdx));
                    }
                    this.creationInstruction(ngContent.sourceSpan, Identifiers$1.projection, parameters);
                    if (this.i18n) {
                        this.i18n.appendProjection(ngContent.i18n, slot);
                    }
                };
                TemplateDefinitionBuilder.prototype.getNamespaceInstruction = function (namespaceKey) {
                    switch (namespaceKey) {
                        case 'math':
                            return Identifiers$1.namespaceMathML;
                        case 'svg':
                            return Identifiers$1.namespaceSVG;
                        default:
                            return Identifiers$1.namespaceHTML;
                    }
                };
                TemplateDefinitionBuilder.prototype.addNamespaceInstruction = function (nsInstruction, element) {
                    this._namespace = nsInstruction;
                    this.creationInstruction(element.sourceSpan, nsInstruction);
                };
                TemplateDefinitionBuilder.prototype.visitElement = function (element) {
                    var _this = this;
                    var elementIndex = this.allocateDataSlot();
                    var stylingBuilder = new StylingBuilder(literal(elementIndex), null);
                    var isNonBindableMode = false;
                    var isI18nRootElement = isI18nRootNode(element.i18n) && !isSingleI18nIcu(element.i18n);
                    if (isI18nRootElement && this.i18n) {
                        throw new Error("Could not mark an element as translatable inside of a translatable section");
                    }
                    var i18nAttrs = [];
                    var outputAttrs = [];
                    var _c = splitNsName(element.name), namespaceKey = _c[0], elementName = _c[1];
                    var isNgContainer$1 = isNgContainer(element.name);
                    // Handle styling, i18n, ngNonBindable attributes
                    for (var _d = 0, _e = element.attributes; _d < _e.length; _d++) {
                        var attr = _e[_d];
                        var name = attr.name, value = attr.value;
                        if (name === NON_BINDABLE_ATTR) {
                            isNonBindableMode = true;
                        }
                        else if (name === 'style') {
                            stylingBuilder.registerStyleAttr(value);
                        }
                        else if (name === 'class') {
                            stylingBuilder.registerClassAttr(value);
                        }
                        else {
                            if (attr.i18n) {
                                // Place attributes into a separate array for i18n processing, but also keep such
                                // attributes in the main list to make them available for directive matching at runtime.
                                // TODO(FW-1248): prevent attributes duplication in `i18nAttributes` and `elementStart`
                                // arguments
                                i18nAttrs.push(attr);
                            }
                            else {
                                outputAttrs.push(attr);
                            }
                        }
                    }
                    // Match directives on non i18n attributes
                    this.matchDirectives(element.name, element);
                    // Regular element or ng-container creation mode
                    var parameters = [literal(elementIndex)];
                    if (!isNgContainer$1) {
                        parameters.push(literal(elementName));
                    }
                    // Add the attributes
                    var attributes = [];
                    var allOtherInputs = [];
                    element.inputs.forEach(function (input) {
                        var stylingInputWasSet = stylingBuilder.registerBoundInput(input);
                        if (!stylingInputWasSet) {
                            if (input.type === 0 /* Property */ && input.i18n) {
                                // Place attributes into a separate array for i18n processing, but also keep such
                                // attributes in the main list to make them available for directive matching at runtime.
                                // TODO(FW-1248): prevent attributes duplication in `i18nAttributes` and `elementStart`
                                // arguments
                                i18nAttrs.push(input);
                            }
                            else {
                                allOtherInputs.push(input);
                            }
                        }
                    });
                    outputAttrs.forEach(function (attr) {
                        if (attr.name === NG_PROJECT_AS_ATTR_NAME) {
                            attributes.push.apply(attributes, getNgProjectAsLiteral(attr));
                        }
                        else {
                            attributes.push.apply(attributes, getAttributeNameLiterals(attr.name).concat([literal(attr.value)]));
                        }
                    });
                    // add attributes for directive and projection matching purposes
                    attributes.push.apply(attributes, this.prepareNonRenderAttrs(allOtherInputs, element.outputs, stylingBuilder, [], i18nAttrs));
                    parameters.push(this.toAttrsParam(attributes));
                    // local refs (ex.: <div #foo #bar="baz">)
                    parameters.push(this.prepareRefsParameter(element.references));
                    var wasInNamespace = this._namespace;
                    var currentNamespace = this.getNamespaceInstruction(namespaceKey);
                    // If the namespace is changing now, include an instruction to change it
                    // during element creation.
                    if (currentNamespace !== wasInNamespace) {
                        this.addNamespaceInstruction(currentNamespace, element);
                    }
                    if (this.i18n) {
                        this.i18n.appendElement(element.i18n, elementIndex);
                    }
                    // Note that we do not append text node instructions and ICUs inside i18n section,
                    // so we exclude them while calculating whether current element has children
                    var hasChildren = (!isI18nRootElement && this.i18n) ? !hasTextChildrenOnly(element.children) :
                        element.children.length > 0;
                    var createSelfClosingInstruction = !stylingBuilder.hasBindings &&
                        element.outputs.length === 0 && i18nAttrs.length === 0 && !hasChildren;
                    var createSelfClosingI18nInstruction = !createSelfClosingInstruction &&
                        !stylingBuilder.hasBindings && hasTextChildrenOnly(element.children);
                    if (createSelfClosingInstruction) {
                        this.creationInstruction(element.sourceSpan, isNgContainer$1 ? Identifiers$1.elementContainer : Identifiers$1.element, trimTrailingNulls(parameters));
                    }
                    else {
                        this.creationInstruction(element.sourceSpan, isNgContainer$1 ? Identifiers$1.elementContainerStart : Identifiers$1.elementStart, trimTrailingNulls(parameters));
                        if (isNonBindableMode) {
                            this.creationInstruction(element.sourceSpan, Identifiers$1.disableBindings);
                        }
                        // process i18n element attributes
                        if (i18nAttrs.length) {
                            var hasBindings_1 = false;
                            var i18nAttrArgs_1 = [];
                            var bindings_1 = [];
                            i18nAttrs.forEach(function (attr) {
                                var message = attr.i18n;
                                if (attr instanceof TextAttribute) {
                                    i18nAttrArgs_1.push(literal(attr.name), _this.i18nTranslate(message));
                                }
                                else {
                                    var converted = attr.value.visit(_this._valueConverter);
                                    _this.allocateBindingSlots(converted);
                                    if (converted instanceof Interpolation) {
                                        var placeholders = assembleBoundTextPlaceholders(message);
                                        var params = placeholdersToParams(placeholders);
                                        i18nAttrArgs_1.push(literal(attr.name), _this.i18nTranslate(message, params));
                                        converted.expressions.forEach(function (expression) {
                                            hasBindings_1 = true;
                                            bindings_1.push({
                                                sourceSpan: element.sourceSpan,
                                                value: function () { return _this.convertExpressionBinding(expression); }
                                            });
                                        });
                                    }
                                }
                            });
                            if (bindings_1.length) {
                                this.updateInstructionChain(elementIndex, Identifiers$1.i18nExp, bindings_1);
                            }
                            if (i18nAttrArgs_1.length) {
                                var index = literal(this.allocateDataSlot());
                                var args = this.constantPool.getConstLiteral(literalArr(i18nAttrArgs_1), true);
                                this.creationInstruction(element.sourceSpan, Identifiers$1.i18nAttributes, [index, args]);
                                if (hasBindings_1) {
                                    this.updateInstruction(elementIndex, element.sourceSpan, Identifiers$1.i18nApply, [index]);
                                }
                            }
                        }
                        // The style bindings code is placed into two distinct blocks within the template function AOT
                        // code: creation and update. The creation code contains the `styling` instructions
                        // which will apply the collected binding values to the element. `styling` is
                        // designed to run inside of `elementStart` and `elementEnd`. The update instructions
                        // (things like `styleProp`, `classProp`, etc..) are applied later on in this
                        // file
                        this.processStylingInstruction(elementIndex, stylingBuilder.buildStylingInstruction(element.sourceSpan, this.constantPool), true);
                        // Generate Listeners (outputs)
                        element.outputs.forEach(function (outputAst) {
                            _this.creationInstruction(outputAst.sourceSpan, Identifiers$1.listener, _this.prepareListenerParameter(element.name, outputAst, elementIndex));
                        });
                        // Note: it's important to keep i18n/i18nStart instructions after i18nAttributes and
                        // listeners, to make sure i18nAttributes instruction targets current element at runtime.
                        if (isI18nRootElement) {
                            this.i18nStart(element.sourceSpan, element.i18n, createSelfClosingI18nInstruction);
                        }
                    }
                    // the code here will collect all update-level styling instructions and add them to the
                    // update block of the template function AOT code. Instructions like `styleProp`,
                    // `styleMap`, `classMap`, `classProp` and `stylingApply`
                    // are all generated and assigned in the code below.
                    var stylingInstructions = stylingBuilder.buildUpdateLevelInstructions(this._valueConverter);
                    var limit = stylingInstructions.length - 1;
                    for (var i = 0; i <= limit; i++) {
                        var instruction_1 = stylingInstructions[i];
                        this._bindingSlots += instruction_1.allocateBindingSlots;
                        this.processStylingInstruction(elementIndex, instruction_1, false);
                    }
                    // the reason why `undefined` is used is because the renderer understands this as a
                    // special value to symbolize that there is no RHS to this binding
                    // TODO (matsko): revisit this once FW-959 is approached
                    var emptyValueBindInstruction = literal(undefined);
                    var propertyBindings = [];
                    var attributeBindings = [];
                    // Generate element input bindings
                    allOtherInputs.forEach(function (input) {
                        var inputType = input.type;
                        if (inputType === 4 /* Animation */) {
                            var value_1 = input.value.visit(_this._valueConverter);
                            // animation bindings can be presented in the following formats:
                            // 1. [@binding]="fooExp"
                            // 2. [@binding]="{value:fooExp, params:{...}}"
                            // 3. [@binding]
                            // 4. @binding
                            // All formats will be valid for when a synthetic binding is created.
                            // The reasoning for this is because the renderer should get each
                            // synthetic binding value in the order of the array that they are
                            // defined in...
                            var hasValue_1 = value_1 instanceof LiteralPrimitive ? !!value_1.value : true;
                            _this.allocateBindingSlots(value_1);
                            propertyBindings.push({
                                name: prepareSyntheticPropertyName(input.name),
                                sourceSpan: input.sourceSpan,
                                value: function () { return hasValue_1 ? _this.convertPropertyBinding(value_1) : emptyValueBindInstruction; }
                            });
                        }
                        else {
                            // we must skip attributes with associated i18n context, since these attributes are handled
                            // separately and corresponding `i18nExp` and `i18nApply` instructions will be generated
                            if (input.i18n)
                                return;
                            var value_2 = input.value.visit(_this._valueConverter);
                            if (value_2 !== undefined) {
                                var params_4 = [];
                                var _c = splitNsName(input.name), attrNamespace = _c[0], attrName_1 = _c[1];
                                var isAttributeBinding = inputType === 1 /* Attribute */;
                                var sanitizationRef = resolveSanitizationFn(input.securityContext, isAttributeBinding);
                                if (sanitizationRef)
                                    params_4.push(sanitizationRef);
                                if (attrNamespace) {
                                    var namespaceLiteral = literal(attrNamespace);
                                    if (sanitizationRef) {
                                        params_4.push(namespaceLiteral);
                                    }
                                    else {
                                        // If there wasn't a sanitization ref, we need to add
                                        // an extra param so that we can pass in the namespace.
                                        params_4.push(literal(null), namespaceLiteral);
                                    }
                                }
                                _this.allocateBindingSlots(value_2);
                                if (inputType === 0 /* Property */) {
                                    if (value_2 instanceof Interpolation) {
                                        // prop="{{value}}" and friends
                                        _this.interpolatedUpdateInstruction(getPropertyInterpolationExpression(value_2), elementIndex, attrName_1, input, value_2, params_4);
                                    }
                                    else {
                                        // [prop]="value"
                                        // Collect all the properties so that we can chain into a single function at the end.
                                        propertyBindings.push({
                                            name: attrName_1,
                                            sourceSpan: input.sourceSpan,
                                            value: function () { return _this.convertPropertyBinding(value_2); }, params: params_4
                                        });
                                    }
                                }
                                else if (inputType === 1 /* Attribute */) {
                                    if (value_2 instanceof Interpolation && getInterpolationArgsLength(value_2) > 1) {
                                        // attr.name="text{{value}}" and friends
                                        _this.interpolatedUpdateInstruction(getAttributeInterpolationExpression(value_2), elementIndex, attrName_1, input, value_2, params_4);
                                    }
                                    else {
                                        var boundValue_1 = value_2 instanceof Interpolation ? value_2.expressions[0] : value_2;
                                        // [attr.name]="value" or attr.name="{{value}}"
                                        // Collect the attribute bindings so that they can be chained at the end.
                                        attributeBindings.push({
                                            name: attrName_1,
                                            sourceSpan: input.sourceSpan,
                                            value: function () { return _this.convertPropertyBinding(boundValue_1); }, params: params_4
                                        });
                                    }
                                }
                                else {
                                    // class prop
                                    _this.updateInstruction(elementIndex, input.sourceSpan, Identifiers$1.classProp, function () {
                                        return [
                                            literal(elementIndex), literal(attrName_1), _this.convertPropertyBinding(value_2)
                                        ].concat(params_4);
                                    });
                                }
                            }
                        }
                    });
                    if (propertyBindings.length > 0) {
                        this.updateInstructionChain(elementIndex, Identifiers$1.property, propertyBindings);
                    }
                    if (attributeBindings.length > 0) {
                        this.updateInstructionChain(elementIndex, Identifiers$1.attribute, attributeBindings);
                    }
                    // Traverse element child nodes
                    visitAll(this, element.children);
                    if (!isI18nRootElement && this.i18n) {
                        this.i18n.appendElement(element.i18n, elementIndex, true);
                    }
                    if (!createSelfClosingInstruction) {
                        // Finish element construction mode.
                        var span = element.endSourceSpan || element.sourceSpan;
                        if (isI18nRootElement) {
                            this.i18nEnd(span, createSelfClosingI18nInstruction);
                        }
                        if (isNonBindableMode) {
                            this.creationInstruction(span, Identifiers$1.enableBindings);
                        }
                        this.creationInstruction(span, isNgContainer$1 ? Identifiers$1.elementContainerEnd : Identifiers$1.elementEnd);
                    }
                };
                /**
                 * Adds an update instruction for an interpolated property or attribute, such as
                 * `prop="{{value}}"` or `attr.title="{{value}}"`
                 */
                TemplateDefinitionBuilder.prototype.interpolatedUpdateInstruction = function (instruction, elementIndex, attrName, input, value, params) {
                    var _this = this;
                    this.updateInstruction(elementIndex, input.sourceSpan, instruction, function () { return [literal(attrName)].concat(_this.getUpdateInstructionArguments(value), params); });
                };
                TemplateDefinitionBuilder.prototype.visitTemplate = function (template) {
                    var _this = this;
                    var NG_TEMPLATE_TAG_NAME = 'ng-template';
                    var templateIndex = this.allocateDataSlot();
                    if (this.i18n) {
                        this.i18n.appendTemplate(template.i18n, templateIndex);
                    }
                    var tagName = sanitizeIdentifier(template.tagName || '');
                    var contextName = "" + this.contextName + (tagName ? '_' + tagName : '') + "_" + templateIndex;
                    var templateName = contextName + "_Template";
                    var parameters = [
                        literal(templateIndex),
                        variable(templateName),
                        // We don't care about the tag's namespace here, because we infer
                        // it based on the parent nodes inside the template instruction.
                        literal(template.tagName ? splitNsName(template.tagName)[1] : template.tagName),
                    ];
                    // find directives matching on a given <ng-template> node
                    this.matchDirectives(NG_TEMPLATE_TAG_NAME, template);
                    // prepare attributes parameter (including attributes used for directive matching)
                    var attrsExprs = [];
                    template.attributes.forEach(function (a) { attrsExprs.push(asLiteral(a.name), asLiteral(a.value)); });
                    attrsExprs.push.apply(attrsExprs, this.prepareNonRenderAttrs(template.inputs, template.outputs, undefined, template.templateAttrs));
                    parameters.push(this.toAttrsParam(attrsExprs));
                    // local refs (ex.: <ng-template #foo>)
                    if (template.references && template.references.length) {
                        parameters.push(this.prepareRefsParameter(template.references));
                        parameters.push(importExpr(Identifiers$1.templateRefExtractor));
                    }
                    // Create the template function
                    var templateVisitor = new TemplateDefinitionBuilder(this.constantPool, this._bindingScope, this.level + 1, contextName, this.i18n, templateIndex, templateName, this.directiveMatcher, this.directives, this.pipeTypeByName, this.pipes, this._namespace, this.fileBasedI18nSuffix, this.i18nUseExternalIds);
                    // Nested templates must not be visited until after their parent templates have completed
                    // processing, so they are queued here until after the initial pass. Otherwise, we wouldn't
                    // be able to support bindings in nested templates to local refs that occur after the
                    // template definition. e.g. <div *ngIf="showing">{{ foo }}</div>  <div #foo></div>
                    this._nestedTemplateFns.push(function () {
                        var _c;
                        var templateFunctionExpr = templateVisitor.buildTemplateFunction(template.children, template.variables, _this._ngContentReservedSlots.length + _this._ngContentSelectorsOffset, template.i18n);
                        _this.constantPool.statements.push(templateFunctionExpr.toDeclStmt(templateName, null));
                        if (templateVisitor._ngContentReservedSlots.length) {
                            (_c = _this._ngContentReservedSlots).push.apply(_c, templateVisitor._ngContentReservedSlots);
                        }
                    });
                    // e.g. template(1, MyComp_Template_1)
                    this.creationInstruction(template.sourceSpan, Identifiers$1.templateCreate, function () {
                        parameters.splice(2, 0, literal(templateVisitor.getConstCount()), literal(templateVisitor.getVarCount()));
                        return trimTrailingNulls(parameters);
                    });
                    // handle property bindings e.g. ɵɵproperty('ngForOf', ctx.items), et al;
                    this.templatePropertyBindings(templateIndex, template.templateAttrs);
                    // Only add normal input/output binding instructions on explicit ng-template elements.
                    if (template.tagName === NG_TEMPLATE_TAG_NAME) {
                        // Add the input bindings
                        this.templatePropertyBindings(templateIndex, template.inputs);
                        // Generate listeners for directive output
                        template.outputs.forEach(function (outputAst) {
                            _this.creationInstruction(outputAst.sourceSpan, Identifiers$1.listener, _this.prepareListenerParameter('ng_template', outputAst, templateIndex));
                        });
                    }
                };
                TemplateDefinitionBuilder.prototype.visitBoundText = function (text) {
                    var _this = this;
                    if (this.i18n) {
                        var value_3 = text.value.visit(this._valueConverter);
                        this.allocateBindingSlots(value_3);
                        if (value_3 instanceof Interpolation) {
                            this.i18n.appendBoundText(text.i18n);
                            this.i18nAppendBindings(value_3.expressions);
                        }
                        return;
                    }
                    var nodeIndex = this.allocateDataSlot();
                    this.creationInstruction(text.sourceSpan, Identifiers$1.text, [literal(nodeIndex)]);
                    var value = text.value.visit(this._valueConverter);
                    this.allocateBindingSlots(value);
                    if (value instanceof Interpolation) {
                        this.updateInstruction(nodeIndex, text.sourceSpan, getTextInterpolationExpression(value), function () { return _this.getUpdateInstructionArguments(value); });
                    }
                    else {
                        this.updateInstruction(nodeIndex, text.sourceSpan, Identifiers$1.textBinding, function () { return [_this.convertPropertyBinding(value)]; });
                    }
                };
                TemplateDefinitionBuilder.prototype.visitText = function (text) {
                    // when a text element is located within a translatable
                    // block, we exclude this text element from instructions set,
                    // since it will be captured in i18n content and processed at runtime
                    if (!this.i18n) {
                        this.creationInstruction(text.sourceSpan, Identifiers$1.text, [literal(this.allocateDataSlot()), literal(text.value)]);
                    }
                };
                TemplateDefinitionBuilder.prototype.visitIcu = function (icu) {
                    var _this = this;
                    var initWasInvoked = false;
                    // if an ICU was created outside of i18n block, we still treat
                    // it as a translatable entity and invoke i18nStart and i18nEnd
                    // to generate i18n context and the necessary instructions
                    if (!this.i18n) {
                        initWasInvoked = true;
                        this.i18nStart(null, icu.i18n, true);
                    }
                    var i18n = this.i18n;
                    var vars = this.i18nBindProps(icu.vars);
                    var placeholders = this.i18nBindProps(icu.placeholders);
                    // output ICU directly and keep ICU reference in context
                    var message = icu.i18n;
                    // we always need post-processing function for ICUs, to make sure that:
                    // - all placeholders in a form of {PLACEHOLDER} are replaced with actual values (note:
                    // `goog.getMsg` does not process ICUs and uses the `{PLACEHOLDER}` format for placeholders
                    // inside ICUs)
                    // - all ICU vars (such as `VAR_SELECT` or `VAR_PLURAL`) are replaced with correct values
                    var transformFn = function (raw) {
                        var params = Object.assign({}, vars, placeholders);
                        var formatted = _this.i18nFormatPlaceholderNames(params, /* useCamelCase */ false);
                        return instruction(null, Identifiers$1.i18nPostprocess, [raw, mapLiteral(formatted, true)]);
                    };
                    // in case the whole i18n message is a single ICU - we do not need to
                    // create a separate top-level translation, we can use the root ref instead
                    // and make this ICU a top-level translation
                    // note: ICU placeholders are replaced with actual values in `i18nPostprocess` function
                    // separately, so we do not pass placeholders into `i18nTranslate` function.
                    if (isSingleI18nIcu(i18n.meta)) {
                        this.i18nTranslate(message, /* placeholders */ {}, i18n.ref, transformFn);
                    }
                    else {
                        // output ICU directly and keep ICU reference in context
                        var ref = this.i18nTranslate(message, /* placeholders */ {}, /* ref */ undefined, transformFn);
                        i18n.appendIcu(icuFromI18nMessage(message).name, ref);
                    }
                    if (initWasInvoked) {
                        this.i18nEnd(null, true);
                    }
                    return null;
                };
                TemplateDefinitionBuilder.prototype.allocateDataSlot = function () { return this._dataIndex++; };
                TemplateDefinitionBuilder.prototype.getConstCount = function () { return this._dataIndex; };
                TemplateDefinitionBuilder.prototype.getVarCount = function () { return this._pureFunctionSlots; };
                TemplateDefinitionBuilder.prototype.getNgContentSelectors = function () {
                    return this._ngContentReservedSlots.length ?
                        this.constantPool.getConstLiteral(asLiteral(this._ngContentReservedSlots), true) :
                        null;
                };
                TemplateDefinitionBuilder.prototype.bindingContext = function () { return "" + this._bindingContext++; };
                TemplateDefinitionBuilder.prototype.templatePropertyBindings = function (templateIndex, attrs) {
                    var _this = this;
                    var propertyBindings = [];
                    attrs.forEach(function (input) {
                        if (input instanceof BoundAttribute) {
                            var value_4 = input.value.visit(_this._valueConverter);
                            if (value_4 !== undefined) {
                                _this.allocateBindingSlots(value_4);
                                propertyBindings.push({
                                    name: input.name,
                                    sourceSpan: input.sourceSpan,
                                    value: function () { return _this.convertPropertyBinding(value_4); }
                                });
                            }
                        }
                    });
                    if (propertyBindings.length > 0) {
                        this.updateInstructionChain(templateIndex, Identifiers$1.property, propertyBindings);
                    }
                };
                // Bindings must only be resolved after all local refs have been visited, so all
                // instructions are queued in callbacks that execute once the initial pass has completed.
                // Otherwise, we wouldn't be able to support local refs that are defined after their
                // bindings. e.g. {{ foo }} <div #foo></div>
                TemplateDefinitionBuilder.prototype.instructionFn = function (fns, span, reference, paramsOrFn, prepend) {
                    if (prepend === void 0) { prepend = false; }
                    fns[prepend ? 'unshift' : 'push'](function () {
                        var params = Array.isArray(paramsOrFn) ? paramsOrFn : paramsOrFn();
                        return instruction(span, reference, params).toStmt();
                    });
                };
                TemplateDefinitionBuilder.prototype.processStylingInstruction = function (elementIndex, instruction, createMode) {
                    var _this = this;
                    if (instruction) {
                        if (createMode) {
                            this.creationInstruction(instruction.sourceSpan, instruction.reference, function () {
                                return instruction.params(function (value) { return _this.convertPropertyBinding(value); });
                            });
                        }
                        else {
                            this.updateInstruction(elementIndex, instruction.sourceSpan, instruction.reference, function () {
                                return instruction
                                    .params(function (value) {
                                    return (instruction.supportsInterpolation && value instanceof Interpolation) ?
                                        _this.getUpdateInstructionArguments(value) :
                                        _this.convertPropertyBinding(value);
                                });
                            });
                        }
                    }
                };
                TemplateDefinitionBuilder.prototype.creationInstruction = function (span, reference, paramsOrFn, prepend) {
                    this.instructionFn(this._creationCodeFns, span, reference, paramsOrFn || [], prepend);
                };
                TemplateDefinitionBuilder.prototype.updateInstruction = function (nodeIndex, span, reference, paramsOrFn) {
                    this.addSelectInstructionIfNecessary(nodeIndex, span);
                    this.instructionFn(this._updateCodeFns, span, reference, paramsOrFn || []);
                };
                TemplateDefinitionBuilder.prototype.updateInstructionChain = function (nodeIndex, reference, bindings) {
                    var span = bindings.length ? bindings[0].sourceSpan : null;
                    this.addSelectInstructionIfNecessary(nodeIndex, span);
                    this._updateCodeFns.push(function () {
                        var calls = bindings.map(function (property) {
                            var fnParams = [property.value()].concat((property.params || []));
                            if (property.name) {
                                fnParams.unshift(literal(property.name));
                            }
                            return fnParams;
                        });
                        return chainedInstruction(reference, calls, span).toStmt();
                    });
                };
                TemplateDefinitionBuilder.prototype.addSelectInstructionIfNecessary = function (nodeIndex, span) {
                    if (this._lastNodeIndexWithFlush < nodeIndex) {
                        if (nodeIndex > 0) {
                            this.instructionFn(this._updateCodeFns, span, Identifiers$1.select, [literal(nodeIndex)]);
                        }
                        this._lastNodeIndexWithFlush = nodeIndex;
                    }
                };
                TemplateDefinitionBuilder.prototype.allocatePureFunctionSlots = function (numSlots) {
                    var originalSlots = this._pureFunctionSlots;
                    this._pureFunctionSlots += numSlots;
                    return originalSlots;
                };
                TemplateDefinitionBuilder.prototype.allocateBindingSlots = function (value) {
                    this._bindingSlots += value instanceof Interpolation ? value.expressions.length : 1;
                };
                /**
                 * Gets an expression that refers to the implicit receiver. The implicit
                 * receiver is always the root level context.
                 */
                TemplateDefinitionBuilder.prototype.getImplicitReceiverExpr = function () {
                    if (this._implicitReceiverExpr) {
                        return this._implicitReceiverExpr;
                    }
                    return this._implicitReceiverExpr = this.level === 0 ?
                        variable(CONTEXT_NAME) :
                        this._bindingScope.getOrCreateSharedContextVar(0);
                };
                TemplateDefinitionBuilder.prototype.convertExpressionBinding = function (value) {
                    var convertedPropertyBinding = convertPropertyBinding(this, this.getImplicitReceiverExpr(), value, this.bindingContext(), BindingForm.TrySimple);
                    return convertedPropertyBinding.currValExpr;
                };
                TemplateDefinitionBuilder.prototype.convertPropertyBinding = function (value) {
                    var _c;
                    var convertedPropertyBinding = convertPropertyBinding(this, this.getImplicitReceiverExpr(), value, this.bindingContext(), BindingForm.TrySimple, function () { return error('Unexpected interpolation'); });
                    var valExpr = convertedPropertyBinding.currValExpr;
                    (_c = this._tempVariables).push.apply(_c, convertedPropertyBinding.stmts);
                    return valExpr;
                };
                /**
                 * Gets a list of argument expressions to pass to an update instruction expression. Also updates
                 * the temp variables state with temp variables that were identified as needing to be created
                 * while visiting the arguments.
                 * @param value The original expression we will be resolving an arguments list from.
                 */
                TemplateDefinitionBuilder.prototype.getUpdateInstructionArguments = function (value) {
                    var _c;
                    var _d = convertUpdateArguments(this, this.getImplicitReceiverExpr(), value, this.bindingContext()), args = _d.args, stmts = _d.stmts;
                    (_c = this._tempVariables).push.apply(_c, stmts);
                    return args;
                };
                TemplateDefinitionBuilder.prototype.matchDirectives = function (tagName, elOrTpl) {
                    var _this = this;
                    if (this.directiveMatcher) {
                        var selector = createCssSelector(tagName, getAttrsForDirectiveMatching(elOrTpl));
                        this.directiveMatcher.match(selector, function (cssSelector, staticType) { _this.directives.add(staticType); });
                    }
                };
                /**
                 * Prepares all attribute expression values for the `TAttributes` array.
                 *
                 * The purpose of this function is to properly construct an attributes array that
                 * is passed into the `elementStart` (or just `element`) functions. Because there
                 * are many different types of attributes, the array needs to be constructed in a
                 * special way so that `elementStart` can properly evaluate them.
                 *
                 * The format looks like this:
                 *
                 * ```
                 * attrs = [prop, value, prop2, value2,
                 *   CLASSES, class1, class2,
                 *   STYLES, style1, value1, style2, value2,
                 *   BINDINGS, name1, name2, name3,
                 *   TEMPLATE, name4, name5, name6,
                 *   I18N, name7, name8, ...]
                 * ```
                 *
                 * Note that this function will fully ignore all synthetic (@foo) attribute values
                 * because those values are intended to always be generated as property instructions.
                 */
                TemplateDefinitionBuilder.prototype.prepareNonRenderAttrs = function (inputs, outputs, styles, templateAttrs, i18nAttrs) {
                    if (templateAttrs === void 0) { templateAttrs = []; }
                    if (i18nAttrs === void 0) { i18nAttrs = []; }
                    var alreadySeen = new Set();
                    var attrExprs = [];
                    function addAttrExpr(key, value) {
                        if (typeof key === 'string') {
                            if (!alreadySeen.has(key)) {
                                attrExprs.push.apply(attrExprs, getAttributeNameLiterals(key));
                                value !== undefined && attrExprs.push(value);
                                alreadySeen.add(key);
                            }
                        }
                        else {
                            attrExprs.push(literal(key));
                        }
                    }
                    // it's important that this occurs before BINDINGS and TEMPLATE because once `elementStart`
                    // comes across the BINDINGS or TEMPLATE markers then it will continue reading each value as
                    // as single property value cell by cell.
                    if (styles) {
                        styles.populateInitialStylingAttrs(attrExprs);
                    }
                    if (inputs.length || outputs.length) {
                        var attrsLengthBeforeInputs = attrExprs.length;
                        for (var i = 0; i < inputs.length; i++) {
                            var input = inputs[i];
                            // We don't want the animation and attribute bindings in the
                            // attributes array since they aren't used for directive matching.
                            if (input.type !== 4 /* Animation */ && input.type !== 1 /* Attribute */) {
                                addAttrExpr(input.name);
                            }
                        }
                        for (var i = 0; i < outputs.length; i++) {
                            var output = outputs[i];
                            if (output.type !== 1 /* Animation */) {
                                addAttrExpr(output.name);
                            }
                        }
                        // this is a cheap way of adding the marker only after all the input/output
                        // values have been filtered (by not including the animation ones) and added
                        // to the expressions. The marker is important because it tells the runtime
                        // code that this is where attributes without values start...
                        if (attrExprs.length !== attrsLengthBeforeInputs) {
                            attrExprs.splice(attrsLengthBeforeInputs, 0, literal(3 /* Bindings */));
                        }
                    }
                    if (templateAttrs.length) {
                        attrExprs.push(literal(4 /* Template */));
                        templateAttrs.forEach(function (attr) { return addAttrExpr(attr.name); });
                    }
                    if (i18nAttrs.length) {
                        attrExprs.push(literal(6 /* I18n */));
                        i18nAttrs.forEach(function (attr) { return addAttrExpr(attr.name); });
                    }
                    return attrExprs;
                };
                TemplateDefinitionBuilder.prototype.toAttrsParam = function (attrsExprs) {
                    return attrsExprs.length > 0 ?
                        this.constantPool.getConstLiteral(literalArr(attrsExprs), true) :
                        TYPED_NULL_EXPR;
                };
                TemplateDefinitionBuilder.prototype.prepareRefsParameter = function (references) {
                    var _this = this;
                    if (!references || references.length === 0) {
                        return TYPED_NULL_EXPR;
                    }
                    var refsParam = flatten(references.map(function (reference) {
                        var slot = _this.allocateDataSlot();
                        // Generate the update temporary.
                        var variableName = _this._bindingScope.freshReferenceName();
                        var retrievalLevel = _this.level;
                        var lhs = variable(variableName);
                        _this._bindingScope.set(retrievalLevel, reference.name, lhs, 0 /* DEFAULT */, function (scope, relativeLevel) {
                            // e.g. nextContext(2);
                            var nextContextStmt = relativeLevel > 0 ? [generateNextContextExpr(relativeLevel).toStmt()] : [];
                            // e.g. const $foo$ = reference(1);
                            var refExpr = lhs.set(importExpr(Identifiers$1.reference).callFn([literal(slot)]));
                            return nextContextStmt.concat(refExpr.toConstDecl());
                        }, true);
                        return [reference.name, reference.value];
                    }));
                    return this.constantPool.getConstLiteral(asLiteral(refsParam), true);
                };
                TemplateDefinitionBuilder.prototype.prepareListenerParameter = function (tagName, outputAst, index) {
                    var _this = this;
                    return function () {
                        var eventName = outputAst.name;
                        var bindingFnName = outputAst.type === 1 /* Animation */ ?
                            // synthetic @listener.foo values are treated the exact same as are standard listeners
                            prepareSyntheticListenerFunctionName(eventName, outputAst.phase) :
                            sanitizeIdentifier(eventName);
                        var handlerName = _this.templateName + "_" + tagName + "_" + bindingFnName + "_" + index + "_listener";
                        var scope = _this._bindingScope.nestedScope(_this._bindingScope.bindingLevel);
                        return prepareEventListenerParameters(outputAst, handlerName, scope);
                    };
                };
                return TemplateDefinitionBuilder;
            }());
            var ValueConverter = /** @class */ (function (_super_1) {
                __extends(ValueConverter, _super_1);
                function ValueConverter(constantPool, allocateSlot, allocatePureFunctionSlots, definePipe) {
                    var _this = _super_1.call(this) || this;
                    _this.constantPool = constantPool;
                    _this.allocateSlot = allocateSlot;
                    _this.allocatePureFunctionSlots = allocatePureFunctionSlots;
                    _this.definePipe = definePipe;
                    _this._pipeBindExprs = [];
                    return _this;
                }
                // AstMemoryEfficientTransformer
                ValueConverter.prototype.visitPipe = function (pipe, context) {
                    // Allocate a slot to create the pipe
                    var slot = this.allocateSlot();
                    var slotPseudoLocal = "PIPE:" + slot;
                    // Allocate one slot for the result plus one slot per pipe argument
                    var pureFunctionSlot = this.allocatePureFunctionSlots(2 + pipe.args.length);
                    var target = new PropertyRead(pipe.span, new ImplicitReceiver(pipe.span), slotPseudoLocal);
                    var _c = pipeBindingCallInfo(pipe.args), identifier = _c.identifier, isVarLength = _c.isVarLength;
                    this.definePipe(pipe.name, slotPseudoLocal, slot, importExpr(identifier));
                    var args = [pipe.exp].concat(pipe.args);
                    var convertedArgs = isVarLength ? this.visitAll([new LiteralArray(pipe.span, args)]) : this.visitAll(args);
                    var pipeBindExpr = new FunctionCall(pipe.span, target, [
                        new LiteralPrimitive(pipe.span, slot),
                        new LiteralPrimitive(pipe.span, pureFunctionSlot)
                    ].concat(convertedArgs));
                    this._pipeBindExprs.push(pipeBindExpr);
                    return pipeBindExpr;
                };
                ValueConverter.prototype.updatePipeSlotOffsets = function (bindingSlots) {
                    this._pipeBindExprs.forEach(function (pipe) {
                        // update the slot offset arg (index 1) to account for binding slots
                        var slotOffset = pipe.args[1];
                        slotOffset.value += bindingSlots;
                    });
                };
                ValueConverter.prototype.visitLiteralArray = function (array, context) {
                    var _this = this;
                    return new BuiltinFunctionCall(array.span, this.visitAll(array.expressions), function (values) {
                        // If the literal has calculated (non-literal) elements transform it into
                        // calls to literal factories that compose the literal and will cache intermediate
                        // values. Otherwise, just return an literal array that contains the values.
                        var literal = literalArr(values);
                        return values.every(function (a) { return a.isConstant(); }) ?
                            _this.constantPool.getConstLiteral(literal, true) :
                            getLiteralFactory(_this.constantPool, literal, _this.allocatePureFunctionSlots);
                    });
                };
                ValueConverter.prototype.visitLiteralMap = function (map, context) {
                    var _this = this;
                    return new BuiltinFunctionCall(map.span, this.visitAll(map.values), function (values) {
                        // If the literal has calculated (non-literal) elements  transform it into
                        // calls to literal factories that compose the literal and will cache intermediate
                        // values. Otherwise, just return an literal array that contains the values.
                        var literal = literalMap(values.map(function (value, index) { return ({ key: map.keys[index].key, value: value, quoted: map.keys[index].quoted }); }));
                        return values.every(function (a) { return a.isConstant(); }) ?
                            _this.constantPool.getConstLiteral(literal, true) :
                            getLiteralFactory(_this.constantPool, literal, _this.allocatePureFunctionSlots);
                    });
                };
                return ValueConverter;
            }(AstMemoryEfficientTransformer));
            // Pipes always have at least one parameter, the value they operate on
            var pipeBindingIdentifiers = [Identifiers$1.pipeBind1, Identifiers$1.pipeBind2, Identifiers$1.pipeBind3, Identifiers$1.pipeBind4];
            function pipeBindingCallInfo(args) {
                var identifier = pipeBindingIdentifiers[args.length];
                return {
                    identifier: identifier || Identifiers$1.pipeBindV,
                    isVarLength: !identifier,
                };
            }
            var pureFunctionIdentifiers = [
                Identifiers$1.pureFunction0, Identifiers$1.pureFunction1, Identifiers$1.pureFunction2, Identifiers$1.pureFunction3, Identifiers$1.pureFunction4,
                Identifiers$1.pureFunction5, Identifiers$1.pureFunction6, Identifiers$1.pureFunction7, Identifiers$1.pureFunction8
            ];
            function pureFunctionCallInfo(args) {
                var identifier = pureFunctionIdentifiers[args.length];
                return {
                    identifier: identifier || Identifiers$1.pureFunctionV,
                    isVarLength: !identifier,
                };
            }
            function instruction(span, reference, params) {
                return importExpr(reference, null, span).callFn(params, span);
            }
            // e.g. x(2);
            function generateNextContextExpr(relativeLevelDiff) {
                return importExpr(Identifiers$1.nextContext)
                    .callFn(relativeLevelDiff > 1 ? [literal(relativeLevelDiff)] : []);
            }
            function getLiteralFactory(constantPool, literal$1, allocateSlots) {
                var _c = constantPool.getLiteralFactory(literal$1), literalFactory = _c.literalFactory, literalFactoryArguments = _c.literalFactoryArguments;
                // Allocate 1 slot for the result plus 1 per argument
                var startSlot = allocateSlots(1 + literalFactoryArguments.length);
                literalFactoryArguments.length > 0 || error("Expected arguments to a literal factory function");
                var _d = pureFunctionCallInfo(literalFactoryArguments), identifier = _d.identifier, isVarLength = _d.isVarLength;
                // Literal factories are pure functions that only need to be re-invoked when the parameters
                // change.
                var args = [
                    literal(startSlot),
                    literalFactory,
                ];
                if (isVarLength) {
                    args.push(literalArr(literalFactoryArguments));
                }
                else {
                    args.push.apply(args, literalFactoryArguments);
                }
                return importExpr(identifier).callFn(args);
            }
            /**
             * Gets an array of literals that can be added to an expression
             * to represent the name and namespace of an attribute. E.g.
             * `:xlink:href` turns into `[AttributeMarker.NamespaceURI, 'xlink', 'href']`.
             *
             * @param name Name of the attribute, including the namespace.
             */
            function getAttributeNameLiterals(name) {
                var _c = splitNsName(name), attributeNamespace = _c[0], attributeName = _c[1];
                var nameLiteral = literal(attributeName);
                if (attributeNamespace) {
                    return [
                        literal(0 /* NamespaceURI */), literal(attributeNamespace), nameLiteral
                    ];
                }
                return [nameLiteral];
            }
            /** The prefix used to get a shared context in BindingScope's map. */
            var SHARED_CONTEXT_KEY = '$$shared_ctx$$';
            var BindingScope = /** @class */ (function () {
                function BindingScope(bindingLevel, parent) {
                    if (bindingLevel === void 0) { bindingLevel = 0; }
                    if (parent === void 0) { parent = null; }
                    this.bindingLevel = bindingLevel;
                    this.parent = parent;
                    /** Keeps a map from local variables to their BindingData. */
                    this.map = new Map();
                    this.referenceNameIndex = 0;
                    this.restoreViewVariable = null;
                }
                Object.defineProperty(BindingScope, "ROOT_SCOPE", {
                    get: function () {
                        if (!BindingScope._ROOT_SCOPE) {
                            BindingScope._ROOT_SCOPE = new BindingScope().set(0, '$event', variable('$event'));
                        }
                        return BindingScope._ROOT_SCOPE;
                    },
                    enumerable: true,
                    configurable: true
                });
                BindingScope.prototype.get = function (name) {
                    var current = this;
                    while (current) {
                        var value = current.map.get(name);
                        if (value != null) {
                            if (current !== this) {
                                // make a local copy and reset the `declare` state
                                value = {
                                    retrievalLevel: value.retrievalLevel,
                                    lhs: value.lhs,
                                    declareLocalCallback: value.declareLocalCallback,
                                    declare: false,
                                    priority: value.priority,
                                    localRef: value.localRef
                                };
                                // Cache the value locally.
                                this.map.set(name, value);
                                // Possibly generate a shared context var
                                this.maybeGenerateSharedContextVar(value);
                                this.maybeRestoreView(value.retrievalLevel, value.localRef);
                            }
                            if (value.declareLocalCallback && !value.declare) {
                                value.declare = true;
                            }
                            return value.lhs;
                        }
                        current = current.parent;
                    }
                    // If we get to this point, we are looking for a property on the top level component
                    // - If level === 0, we are on the top and don't need to re-declare `ctx`.
                    // - If level > 0, we are in an embedded view. We need to retrieve the name of the
                    // local var we used to store the component context, e.g. const $comp$ = x();
                    return this.bindingLevel === 0 ? null : this.getComponentProperty(name);
                };
                /**
                 * Create a local variable for later reference.
                 *
                 * @param retrievalLevel The level from which this value can be retrieved
                 * @param name Name of the variable.
                 * @param lhs AST representing the left hand side of the `let lhs = rhs;`.
                 * @param priority The sorting priority of this var
                 * @param declareLocalCallback The callback to invoke when declaring this local var
                 * @param localRef Whether or not this is a local ref
                 */
                BindingScope.prototype.set = function (retrievalLevel, name, lhs, priority /* DEFAULT */, declareLocalCallback, localRef) {
                    if (priority === void 0) { priority = 0; }
                    if (this.map.has(name)) {
                        if (localRef) {
                            // Do not throw an error if it's a local ref and do not update existing value,
                            // so the first defined ref is always returned.
                            return this;
                        }
                        error("The name " + name + " is already defined in scope to be " + this.map.get(name));
                    }
                    this.map.set(name, {
                        retrievalLevel: retrievalLevel,
                        lhs: lhs,
                        declare: false,
                        declareLocalCallback: declareLocalCallback,
                        priority: priority,
                        localRef: localRef || false
                    });
                    return this;
                };
                // Implemented as part of LocalResolver.
                BindingScope.prototype.getLocal = function (name) { return this.get(name); };
                // Implemented as part of LocalResolver.
                BindingScope.prototype.notifyImplicitReceiverUse = function () {
                    if (this.bindingLevel !== 0) {
                        // Since the implicit receiver is accessed in an embedded view, we need to
                        // ensure that we declare a shared context variable for the current template
                        // in the update variables.
                        this.map.get(SHARED_CONTEXT_KEY + 0).declare = true;
                    }
                };
                BindingScope.prototype.nestedScope = function (level) {
                    var newScope = new BindingScope(level, this);
                    if (level > 0)
                        newScope.generateSharedContextVar(0);
                    return newScope;
                };
                /**
                 * Gets or creates a shared context variable and returns its expression. Note that
                 * this does not mean that the shared variable will be declared. Variables in the
                 * binding scope will be only declared if they are used.
                 */
                BindingScope.prototype.getOrCreateSharedContextVar = function (retrievalLevel) {
                    var bindingKey = SHARED_CONTEXT_KEY + retrievalLevel;
                    if (!this.map.has(bindingKey)) {
                        this.generateSharedContextVar(retrievalLevel);
                    }
                    // Shared context variables are always generated as "ReadVarExpr".
                    return this.map.get(bindingKey).lhs;
                };
                BindingScope.prototype.getSharedContextName = function (retrievalLevel) {
                    var sharedCtxObj = this.map.get(SHARED_CONTEXT_KEY + retrievalLevel);
                    // Shared context variables are always generated as "ReadVarExpr".
                    return sharedCtxObj && sharedCtxObj.declare ? sharedCtxObj.lhs : null;
                };
                BindingScope.prototype.maybeGenerateSharedContextVar = function (value) {
                    if (value.priority === 1 /* CONTEXT */ &&
                        value.retrievalLevel < this.bindingLevel) {
                        var sharedCtxObj = this.map.get(SHARED_CONTEXT_KEY + value.retrievalLevel);
                        if (sharedCtxObj) {
                            sharedCtxObj.declare = true;
                        }
                        else {
                            this.generateSharedContextVar(value.retrievalLevel);
                        }
                    }
                };
                BindingScope.prototype.generateSharedContextVar = function (retrievalLevel) {
                    var lhs = variable(CONTEXT_NAME + this.freshReferenceName());
                    this.map.set(SHARED_CONTEXT_KEY + retrievalLevel, {
                        retrievalLevel: retrievalLevel,
                        lhs: lhs,
                        declareLocalCallback: function (scope, relativeLevel) {
                            // const ctx_r0 = nextContext(2);
                            return [lhs.set(generateNextContextExpr(relativeLevel)).toConstDecl()];
                        },
                        declare: false,
                        priority: 2 /* SHARED_CONTEXT */,
                        localRef: false
                    });
                };
                BindingScope.prototype.getComponentProperty = function (name) {
                    var componentValue = this.map.get(SHARED_CONTEXT_KEY + 0);
                    componentValue.declare = true;
                    this.maybeRestoreView(0, false);
                    return componentValue.lhs.prop(name);
                };
                BindingScope.prototype.maybeRestoreView = function (retrievalLevel, localRefLookup) {
                    // We want to restore the current view in listener fns if:
                    // 1 - we are accessing a value in a parent view, which requires walking the view tree rather
                    // than using the ctx arg. In this case, the retrieval and binding level will be different.
                    // 2 - we are looking up a local ref, which requires restoring the view where the local
                    // ref is stored
                    if (this.isListenerScope() && (retrievalLevel < this.bindingLevel || localRefLookup)) {
                        if (!this.parent.restoreViewVariable) {
                            // parent saves variable to generate a shared `const $s$ = getCurrentView();` instruction
                            this.parent.restoreViewVariable = variable(this.parent.freshReferenceName());
                        }
                        this.restoreViewVariable = this.parent.restoreViewVariable;
                    }
                };
                BindingScope.prototype.restoreViewStatement = function () {
                    // restoreView($state$);
                    return this.restoreViewVariable ?
                        [instruction(null, Identifiers$1.restoreView, [this.restoreViewVariable]).toStmt()] :
                        [];
                };
                BindingScope.prototype.viewSnapshotStatements = function () {
                    // const $state$ = getCurrentView();
                    var getCurrentViewInstruction = instruction(null, Identifiers$1.getCurrentView, []);
                    return this.restoreViewVariable ?
                        [this.restoreViewVariable.set(getCurrentViewInstruction).toConstDecl()] :
                        [];
                };
                BindingScope.prototype.isListenerScope = function () { return this.parent && this.parent.bindingLevel === this.bindingLevel; };
                BindingScope.prototype.variableDeclarations = function () {
                    var _this = this;
                    var currentContextLevel = 0;
                    return Array.from(this.map.values())
                        .filter(function (value) { return value.declare; })
                        .sort(function (a, b) { return b.retrievalLevel - a.retrievalLevel || b.priority - a.priority; })
                        .reduce(function (stmts, value) {
                        var levelDiff = _this.bindingLevel - value.retrievalLevel;
                        var currStmts = value.declareLocalCallback(_this, levelDiff - currentContextLevel);
                        currentContextLevel = levelDiff;
                        return stmts.concat(currStmts);
                    }, []);
                };
                BindingScope.prototype.freshReferenceName = function () {
                    var current = this;
                    // Find the top scope as it maintains the global reference count
                    while (current.parent)
                        current = current.parent;
                    var ref = "" + REFERENCE_PREFIX + current.referenceNameIndex++;
                    return ref;
                };
                return BindingScope;
            }());
            /**
             * Creates a `CssSelector` given a tag name and a map of attributes
             */
            function createCssSelector(tag, attributes) {
                var cssSelector = new CssSelector();
                cssSelector.setElement(tag);
                Object.getOwnPropertyNames(attributes).forEach(function (name) {
                    var value = attributes[name];
                    cssSelector.addAttribute(name, value);
                    if (name.toLowerCase() === 'class') {
                        var classes = value.trim().split(/\s+/);
                        classes.forEach(function (className) { return cssSelector.addClassName(className); });
                    }
                });
                return cssSelector;
            }
            /**
             * Creates an array of expressions out of an `ngProjectAs` attributes
             * which can be added to the instruction parameters.
             */
            function getNgProjectAsLiteral(attribute) {
                // Parse the attribute value into a CssSelectorList. Note that we only take the
                // first selector, because we don't support multiple selectors in ngProjectAs.
                var parsedR3Selector = parseSelectorToR3Selector(attribute.value)[0];
                return [literal(5 /* ProjectAs */), asLiteral(parsedR3Selector)];
            }
            /**
             * Gets the instruction to generate for an interpolated property
             * @param interpolation An Interpolation AST
             */
            function getPropertyInterpolationExpression(interpolation) {
                switch (getInterpolationArgsLength(interpolation)) {
                    case 1:
                        return Identifiers$1.propertyInterpolate;
                    case 3:
                        return Identifiers$1.propertyInterpolate1;
                    case 5:
                        return Identifiers$1.propertyInterpolate2;
                    case 7:
                        return Identifiers$1.propertyInterpolate3;
                    case 9:
                        return Identifiers$1.propertyInterpolate4;
                    case 11:
                        return Identifiers$1.propertyInterpolate5;
                    case 13:
                        return Identifiers$1.propertyInterpolate6;
                    case 15:
                        return Identifiers$1.propertyInterpolate7;
                    case 17:
                        return Identifiers$1.propertyInterpolate8;
                    default:
                        return Identifiers$1.propertyInterpolateV;
                }
            }
            /**
             * Gets the instruction to generate for an interpolated attribute
             * @param interpolation An Interpolation AST
             */
            function getAttributeInterpolationExpression(interpolation) {
                switch (getInterpolationArgsLength(interpolation)) {
                    case 3:
                        return Identifiers$1.attributeInterpolate1;
                    case 5:
                        return Identifiers$1.attributeInterpolate2;
                    case 7:
                        return Identifiers$1.attributeInterpolate3;
                    case 9:
                        return Identifiers$1.attributeInterpolate4;
                    case 11:
                        return Identifiers$1.attributeInterpolate5;
                    case 13:
                        return Identifiers$1.attributeInterpolate6;
                    case 15:
                        return Identifiers$1.attributeInterpolate7;
                    case 17:
                        return Identifiers$1.attributeInterpolate8;
                    default:
                        return Identifiers$1.attributeInterpolateV;
                }
            }
            /**
             * Gets the instruction to generate for interpolated text.
             * @param interpolation An Interpolation AST
             */
            function getTextInterpolationExpression(interpolation) {
                switch (getInterpolationArgsLength(interpolation)) {
                    case 1:
                        return Identifiers$1.textInterpolate;
                    case 3:
                        return Identifiers$1.textInterpolate1;
                    case 5:
                        return Identifiers$1.textInterpolate2;
                    case 7:
                        return Identifiers$1.textInterpolate3;
                    case 9:
                        return Identifiers$1.textInterpolate4;
                    case 11:
                        return Identifiers$1.textInterpolate5;
                    case 13:
                        return Identifiers$1.textInterpolate6;
                    case 15:
                        return Identifiers$1.textInterpolate7;
                    case 17:
                        return Identifiers$1.textInterpolate8;
                    default:
                        return Identifiers$1.textInterpolateV;
                }
            }
            /**
             * Parse a template into render3 `Node`s and additional metadata, with no other dependencies.
             *
             * @param template text of the template to parse
             * @param templateUrl URL to use for source mapping of the parsed template
             * @param options options to modify how the template is parsed
             */
            function parseTemplate(template, templateUrl, options) {
                if (options === void 0) { options = {}; }
                var interpolationConfig = options.interpolationConfig, preserveWhitespaces = options.preserveWhitespaces;
                var bindingParser = makeBindingParser(interpolationConfig);
                var htmlParser = new HtmlParser();
                var parseResult = htmlParser.parse(template, templateUrl, Object.assign({ leadingTriviaChars: LEADING_TRIVIA_CHARS }, options, { tokenizeExpansionForms: true }));
                if (parseResult.errors && parseResult.errors.length > 0) {
                    return { errors: parseResult.errors, nodes: [], styleUrls: [], styles: [] };
                }
                var rootNodes = parseResult.rootNodes;
                // process i18n meta information (scan attributes, generate ids)
                // before we run whitespace removal process, because existing i18n
                // extraction process (ng xi18n) relies on a raw content to generate
                // message ids
                rootNodes =
                    visitAll$1(new I18nMetaVisitor(interpolationConfig, !preserveWhitespaces), rootNodes);
                if (!preserveWhitespaces) {
                    rootNodes = visitAll$1(new WhitespaceVisitor(), rootNodes);
                    // run i18n meta visitor again in case we remove whitespaces, because
                    // that might affect generated i18n message content. During this pass
                    // i18n IDs generated at the first pass will be preserved, so we can mimic
                    // existing extraction process (ng xi18n)
                    rootNodes = visitAll$1(new I18nMetaVisitor(interpolationConfig, /* keepI18nAttrs */ false), rootNodes);
                }
                var _c = htmlAstToRender3Ast(rootNodes, bindingParser), nodes = _c.nodes, errors = _c.errors, styleUrls = _c.styleUrls, styles = _c.styles;
                if (errors && errors.length > 0) {
                    return { errors: errors, nodes: [], styleUrls: [], styles: [] };
                }
                return { nodes: nodes, styleUrls: styleUrls, styles: styles };
            }
            /**
             * Construct a `BindingParser` with a default configuration.
             */
            function makeBindingParser(interpolationConfig) {
                if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
                return new BindingParser(new Parser$1(new Lexer()), interpolationConfig, new DomElementSchemaRegistry(), null, []);
            }
            function resolveSanitizationFn(context, isAttribute) {
                switch (context) {
                    case SecurityContext.HTML:
                        return importExpr(Identifiers$1.sanitizeHtml);
                    case SecurityContext.SCRIPT:
                        return importExpr(Identifiers$1.sanitizeScript);
                    case SecurityContext.STYLE:
                        // the compiler does not fill in an instruction for [style.prop?] binding
                        // values because the style algorithm knows internally what props are subject
                        // to sanitization (only [attr.style] values are explicitly sanitized)
                        return isAttribute ? importExpr(Identifiers$1.sanitizeStyle) : null;
                    case SecurityContext.URL:
                        return importExpr(Identifiers$1.sanitizeUrl);
                    case SecurityContext.RESOURCE_URL:
                        return importExpr(Identifiers$1.sanitizeResourceUrl);
                    default:
                        return null;
                }
            }
            function isSingleElementTemplate(children) {
                return children.length === 1 && children[0] instanceof Element;
            }
            function isTextNode(node) {
                return node instanceof Text || node instanceof BoundText || node instanceof Icu;
            }
            function hasTextChildrenOnly(children) {
                return children.every(isTextNode);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var EMPTY_ARRAY = [];
            // This regex matches any binding names that contain the "attr." prefix, e.g. "attr.required"
            // If there is a match, the first matching group will contain the attribute name to bind.
            var ATTR_REGEX = /attr\.([^\]]+)/;
            function getStylingPrefix(name) {
                return name.substring(0, 5); // style or class
            }
            function baseDirectiveFields(meta, constantPool, bindingParser) {
                var definitionMap = new DefinitionMap();
                // e.g. `type: MyDirective`
                definitionMap.set('type', meta.type);
                // e.g. `selectors: [['', 'someDir', '']]`
                definitionMap.set('selectors', createDirectiveSelector(meta.selector));
                // e.g. `factory: () => new MyApp(directiveInject(ElementRef))`
                var result = compileFactoryFunction({
                    name: meta.name,
                    type: meta.type,
                    deps: meta.deps,
                    injectFn: Identifiers$1.directiveInject,
                });
                definitionMap.set('factory', result.factory);
                if (meta.queries.length > 0) {
                    // e.g. `contentQueries: (rf, ctx, dirIndex) => { ... }
                    definitionMap.set('contentQueries', createContentQueriesFunction(meta.queries, constantPool, meta.name));
                }
                if (meta.viewQueries.length) {
                    definitionMap.set('viewQuery', createViewQueriesFunction(meta.viewQueries, constantPool, meta.name));
                }
                // e.g. `hostBindings: (rf, ctx, elIndex) => { ... }
                definitionMap.set('hostBindings', createHostBindingsFunction(meta.host, meta.typeSourceSpan, bindingParser, constantPool, meta.selector || '', meta.name));
                // e.g 'inputs: {a: 'a'}`
                definitionMap.set('inputs', conditionallyCreateMapObjectLiteral(meta.inputs, true));
                // e.g 'outputs: {a: 'a'}`
                definitionMap.set('outputs', conditionallyCreateMapObjectLiteral(meta.outputs));
                if (meta.exportAs !== null) {
                    definitionMap.set('exportAs', literalArr(meta.exportAs.map(function (e) { return literal(e); })));
                }
                return { definitionMap: definitionMap, statements: result.statements };
            }
            /**
             * Add features to the definition map.
             */
            function addFeatures(definitionMap, meta) {
                // e.g. `features: [NgOnChangesFeature()]`
                var features = [];
                var providers = meta.providers;
                var viewProviders = meta.viewProviders;
                if (providers || viewProviders) {
                    var args = [providers || new LiteralArrayExpr([])];
                    if (viewProviders) {
                        args.push(viewProviders);
                    }
                    features.push(importExpr(Identifiers$1.ProvidersFeature).callFn(args));
                }
                if (meta.usesInheritance) {
                    features.push(importExpr(Identifiers$1.InheritDefinitionFeature));
                }
                if (meta.lifecycle.usesOnChanges) {
                    features.push(importExpr(Identifiers$1.NgOnChangesFeature).callFn(EMPTY_ARRAY));
                }
                if (features.length) {
                    definitionMap.set('features', literalArr(features));
                }
            }
            /**
             * Compile a directive for the render3 runtime as defined by the `R3DirectiveMetadata`.
             */
            function compileDirectiveFromMetadata(meta, constantPool, bindingParser) {
                var _c = baseDirectiveFields(meta, constantPool, bindingParser), definitionMap = _c.definitionMap, statements = _c.statements;
                addFeatures(definitionMap, meta);
                var expression = importExpr(Identifiers$1.defineDirective).callFn([definitionMap.toLiteralMap()]);
                if (!meta.selector) {
                    throw new Error("Directive " + meta.name + " has no selector, please add it!");
                }
                var type = createTypeForDef(meta, Identifiers$1.DirectiveDefWithMeta);
                return { expression: expression, type: type, statements: statements };
            }
            /**
             * Compile a base definition for the render3 runtime as defined by {@link R3BaseRefMetadata}
             * @param meta the metadata used for compilation.
             */
            function compileBaseDefFromMetadata(meta, constantPool, bindingParser) {
                var definitionMap = new DefinitionMap();
                if (meta.inputs) {
                    var inputs_1 = meta.inputs;
                    var inputsMap = Object.keys(inputs_1).map(function (key) {
                        var v = inputs_1[key];
                        var value = Array.isArray(v) ? literalArr(v.map(function (vx) { return literal(vx); })) : literal(v);
                        return { key: key, value: value, quoted: false };
                    });
                    definitionMap.set('inputs', literalMap(inputsMap));
                }
                if (meta.outputs) {
                    var outputs_1 = meta.outputs;
                    var outputsMap = Object.keys(outputs_1).map(function (key) {
                        var value = literal(outputs_1[key]);
                        return { key: key, value: value, quoted: false };
                    });
                    definitionMap.set('outputs', literalMap(outputsMap));
                }
                if (meta.viewQueries && meta.viewQueries.length > 0) {
                    definitionMap.set('viewQuery', createViewQueriesFunction(meta.viewQueries, constantPool));
                }
                if (meta.queries && meta.queries.length > 0) {
                    definitionMap.set('contentQueries', createContentQueriesFunction(meta.queries, constantPool));
                }
                if (meta.host) {
                    definitionMap.set('hostBindings', createHostBindingsFunction(meta.host, meta.typeSourceSpan, bindingParser, constantPool, meta.name));
                }
                var expression = importExpr(Identifiers$1.defineBase).callFn([definitionMap.toLiteralMap()]);
                var type = new ExpressionType(importExpr(Identifiers$1.BaseDef), /* modifiers */ null, [expressionType(meta.type)]);
                return { expression: expression, type: type };
            }
            /**
             * Compile a component for the render3 runtime as defined by the `R3ComponentMetadata`.
             */
            function compileComponentFromMetadata(meta, constantPool, bindingParser) {
                var _c = baseDirectiveFields(meta, constantPool, bindingParser), definitionMap = _c.definitionMap, statements = _c.statements;
                addFeatures(definitionMap, meta);
                var selector = meta.selector && CssSelector.parse(meta.selector);
                var firstSelector = selector && selector[0];
                // e.g. `attr: ["class", ".my.app"]`
                // This is optional an only included if the first selector of a component specifies attributes.
                if (firstSelector) {
                    var selectorAttributes = firstSelector.getAttrs();
                    if (selectorAttributes.length) {
                        definitionMap.set('attrs', constantPool.getConstLiteral(literalArr(selectorAttributes.map(function (value) { return value != null ? literal(value) : literal(undefined); })), 
                        /* forceShared */ true));
                    }
                }
                // Generate the CSS matcher that recognize directive
                var directiveMatcher = null;
                if (meta.directives.length > 0) {
                    var matcher = new SelectorMatcher();
                    for (var _d = 0, _e = meta.directives; _d < _e.length; _d++) {
                        var _f = _e[_d], selector_1 = _f.selector, expression_1 = _f.expression;
                        matcher.addSelectables(CssSelector.parse(selector_1), expression_1);
                    }
                    directiveMatcher = matcher;
                }
                // e.g. `template: function MyComponent_Template(_ctx, _cm) {...}`
                var templateTypeName = meta.name;
                var templateName = templateTypeName ? templateTypeName + "_Template" : null;
                var directivesUsed = new Set();
                var pipesUsed = new Set();
                var changeDetection = meta.changeDetection;
                var template = meta.template;
                var templateBuilder = new TemplateDefinitionBuilder(constantPool, BindingScope.ROOT_SCOPE, 0, templateTypeName, null, null, templateName, directiveMatcher, directivesUsed, meta.pipes, pipesUsed, Identifiers$1.namespaceHTML, meta.relativeContextFilePath, meta.i18nUseExternalIds);
                var templateFunctionExpression = templateBuilder.buildTemplateFunction(template.nodes, []);
                // We need to provide this so that dynamically generated components know what
                // projected content blocks to pass through to the component when it is instantiated.
                var ngContentSelectors = templateBuilder.getNgContentSelectors();
                if (ngContentSelectors) {
                    definitionMap.set('ngContentSelectors', ngContentSelectors);
                }
                // e.g. `consts: 2`
                definitionMap.set('consts', literal(templateBuilder.getConstCount()));
                // e.g. `vars: 2`
                definitionMap.set('vars', literal(templateBuilder.getVarCount()));
                definitionMap.set('template', templateFunctionExpression);
                // e.g. `directives: [MyDirective]`
                if (directivesUsed.size) {
                    var directivesExpr = literalArr(Array.from(directivesUsed));
                    if (meta.wrapDirectivesAndPipesInClosure) {
                        directivesExpr = fn([], [new ReturnStatement(directivesExpr)]);
                    }
                    definitionMap.set('directives', directivesExpr);
                }
                // e.g. `pipes: [MyPipe]`
                if (pipesUsed.size) {
                    var pipesExpr = literalArr(Array.from(pipesUsed));
                    if (meta.wrapDirectivesAndPipesInClosure) {
                        pipesExpr = fn([], [new ReturnStatement(pipesExpr)]);
                    }
                    definitionMap.set('pipes', pipesExpr);
                }
                if (meta.encapsulation === null) {
                    meta.encapsulation = ViewEncapsulation.Emulated;
                }
                // e.g. `styles: [str1, str2]`
                if (meta.styles && meta.styles.length) {
                    var styleValues = meta.encapsulation == ViewEncapsulation.Emulated ?
                        compileStyles(meta.styles, CONTENT_ATTR, HOST_ATTR) :
                        meta.styles;
                    var strings = styleValues.map(function (str) { return literal(str); });
                    definitionMap.set('styles', literalArr(strings));
                }
                else if (meta.encapsulation === ViewEncapsulation.Emulated) {
                    // If there is no style, don't generate css selectors on elements
                    meta.encapsulation = ViewEncapsulation.None;
                }
                // Only set view encapsulation if it's not the default value
                if (meta.encapsulation !== ViewEncapsulation.Emulated) {
                    definitionMap.set('encapsulation', literal(meta.encapsulation));
                }
                // e.g. `animation: [trigger('123', [])]`
                if (meta.animations !== null) {
                    definitionMap.set('data', literalMap([{ key: 'animation', value: meta.animations, quoted: false }]));
                }
                // Only set the change detection flag if it's defined and it's not the default.
                if (changeDetection != null && changeDetection !== ChangeDetectionStrategy.Default) {
                    definitionMap.set('changeDetection', literal(changeDetection));
                }
                // On the type side, remove newlines from the selector as it will need to fit into a TypeScript
                // string literal, which must be on one line.
                var selectorForType = (meta.selector || '').replace(/\n/g, '');
                var expression = importExpr(Identifiers$1.defineComponent).callFn([definitionMap.toLiteralMap()]);
                var type = createTypeForDef(meta, Identifiers$1.ComponentDefWithMeta);
                return { expression: expression, type: type, statements: statements };
            }
            /**
             * A wrapper around `compileDirective` which depends on render2 global analysis data as its input
             * instead of the `R3DirectiveMetadata`.
             *
             * `R3DirectiveMetadata` is computed from `CompileDirectiveMetadata` and other statically reflected
             * information.
             */
            function compileDirectiveFromRender2(outputCtx, directive, reflector, bindingParser) {
                var name = identifierName(directive.type);
                name || error("Cannot resolver the name of " + directive.type);
                var definitionField = outputCtx.constantPool.propertyNameOf(1 /* Directive */);
                var meta = directiveMetadataFromGlobalMetadata(directive, outputCtx, reflector);
                var res = compileDirectiveFromMetadata(meta, outputCtx.constantPool, bindingParser);
                // Create the partial class to be merged with the actual class.
                outputCtx.statements.push(new ClassStmt(name, null, [new ClassField(definitionField, INFERRED_TYPE, [StmtModifier.Static], res.expression)], [], new ClassMethod(null, [], []), []));
            }
            /**
             * A wrapper around `compileComponent` which depends on render2 global analysis data as its input
             * instead of the `R3DirectiveMetadata`.
             *
             * `R3ComponentMetadata` is computed from `CompileDirectiveMetadata` and other statically reflected
             * information.
             */
            function compileComponentFromRender2(outputCtx, component, render3Ast, reflector, bindingParser, directiveTypeBySel, pipeTypeByName) {
                var name = identifierName(component.type);
                name || error("Cannot resolver the name of " + component.type);
                var definitionField = outputCtx.constantPool.propertyNameOf(2 /* Component */);
                var summary = component.toSummary();
                // Compute the R3ComponentMetadata from the CompileDirectiveMetadata
                var meta = Object.assign({}, directiveMetadataFromGlobalMetadata(component, outputCtx, reflector), { selector: component.selector, template: { nodes: render3Ast.nodes }, directives: [], pipes: typeMapToExpressionMap(pipeTypeByName, outputCtx), viewQueries: queriesFromGlobalMetadata(component.viewQueries, outputCtx), wrapDirectivesAndPipesInClosure: false, styles: (summary.template && summary.template.styles) || EMPTY_ARRAY, encapsulation: (summary.template && summary.template.encapsulation) || ViewEncapsulation.Emulated, interpolation: DEFAULT_INTERPOLATION_CONFIG, animations: null, viewProviders: component.viewProviders.length > 0 ? new WrappedNodeExpr(component.viewProviders) : null, relativeContextFilePath: '', i18nUseExternalIds: true });
                var res = compileComponentFromMetadata(meta, outputCtx.constantPool, bindingParser);
                // Create the partial class to be merged with the actual class.
                outputCtx.statements.push(new ClassStmt(name, null, [new ClassField(definitionField, INFERRED_TYPE, [StmtModifier.Static], res.expression)], [], new ClassMethod(null, [], []), []));
            }
            /**
             * Compute `R3DirectiveMetadata` given `CompileDirectiveMetadata` and a `CompileReflector`.
             */
            function directiveMetadataFromGlobalMetadata(directive, outputCtx, reflector) {
                // The global-analysis based Ivy mode in ngc is no longer utilized/supported.
                throw new Error('unsupported');
            }
            /**
             * Convert `CompileQueryMetadata` into `R3QueryMetadata`.
             */
            function queriesFromGlobalMetadata(queries, outputCtx) {
                return queries.map(function (query) {
                    var read = null;
                    if (query.read && query.read.identifier) {
                        read = outputCtx.importExpr(query.read.identifier.reference);
                    }
                    return {
                        propertyName: query.propertyName,
                        first: query.first,
                        predicate: selectorsFromGlobalMetadata(query.selectors, outputCtx),
                        descendants: query.descendants, read: read,
                        static: !!query.static
                    };
                });
            }
            /**
             * Convert `CompileTokenMetadata` for query selectors into either an expression for a predicate
             * type, or a list of string predicates.
             */
            function selectorsFromGlobalMetadata(selectors, outputCtx) {
                if (selectors.length > 1 || (selectors.length == 1 && selectors[0].value)) {
                    var selectorStrings = selectors.map(function (value) { return value.value; });
                    selectorStrings.some(function (value) { return !value; }) &&
                        error('Found a type among the string selectors expected');
                    return outputCtx.constantPool.getConstLiteral(literalArr(selectorStrings.map(function (value) { return literal(value); })));
                }
                if (selectors.length == 1) {
                    var first = selectors[0];
                    if (first.identifier) {
                        return outputCtx.importExpr(first.identifier.reference);
                    }
                }
                error('Unexpected query form');
                return NULL_EXPR;
            }
            function prepareQueryParams(query, constantPool) {
                var parameters = [getQueryPredicate(query, constantPool), literal(query.descendants)];
                if (query.read) {
                    parameters.push(query.read);
                }
                return parameters;
            }
            // Turn a directive selector into an R3-compatible selector for directive def
            function createDirectiveSelector(selector) {
                return asLiteral(parseSelectorToR3Selector(selector));
            }
            function convertAttributesToExpressions(attributes) {
                var values = [];
                for (var _c = 0, _d = Object.getOwnPropertyNames(attributes); _c < _d.length; _c++) {
                    var key = _d[_c];
                    var value = attributes[key];
                    values.push(literal(key), value);
                }
                return values;
            }
            // Define and update any content queries
            function createContentQueriesFunction(queries, constantPool, name) {
                var createStatements = [];
                var updateStatements = [];
                var tempAllocator = temporaryAllocator(updateStatements, TEMPORARY_NAME);
                for (var _c = 0, queries_1 = queries; _c < queries_1.length; _c++) {
                    var query = queries_1[_c];
                    var queryInstruction = query.static ? Identifiers$1.staticContentQuery : Identifiers$1.contentQuery;
                    // creation, e.g. r3.contentQuery(dirIndex, somePredicate, true, null);
                    createStatements.push(importExpr(queryInstruction)
                        .callFn([variable('dirIndex')].concat(prepareQueryParams(query, constantPool)))
                        .toStmt());
                    // update, e.g. (r3.queryRefresh(tmp = r3.loadContentQuery()) && (ctx.someDir = tmp));
                    var temporary = tempAllocator();
                    var getQueryList = importExpr(Identifiers$1.loadContentQuery).callFn([]);
                    var refresh = importExpr(Identifiers$1.queryRefresh).callFn([temporary.set(getQueryList)]);
                    var updateDirective = variable(CONTEXT_NAME)
                        .prop(query.propertyName)
                        .set(query.first ? temporary.prop('first') : temporary);
                    updateStatements.push(refresh.and(updateDirective).toStmt());
                }
                var contentQueriesFnName = name ? name + "_ContentQueries" : null;
                return fn([
                    new FnParam(RENDER_FLAGS, NUMBER_TYPE), new FnParam(CONTEXT_NAME, null),
                    new FnParam('dirIndex', null)
                ], [
                    renderFlagCheckIfStmt(1 /* Create */, createStatements),
                    renderFlagCheckIfStmt(2 /* Update */, updateStatements)
                ], INFERRED_TYPE, null, contentQueriesFnName);
            }
            function stringAsType(str) {
                return expressionType(literal(str));
            }
            function stringMapAsType(map) {
                var mapValues = Object.keys(map).map(function (key) {
                    var value = Array.isArray(map[key]) ? map[key][0] : map[key];
                    return {
                        key: key,
                        value: literal(value),
                        quoted: true,
                    };
                });
                return expressionType(literalMap(mapValues));
            }
            function stringArrayAsType(arr) {
                return arr.length > 0 ? expressionType(literalArr(arr.map(function (value) { return literal(value); }))) :
                    NONE_TYPE;
            }
            function createTypeForDef(meta, typeBase) {
                // On the type side, remove newlines from the selector as it will need to fit into a TypeScript
                // string literal, which must be on one line.
                var selectorForType = (meta.selector || '').replace(/\n/g, '');
                return expressionType(importExpr(typeBase, [
                    typeWithParameters(meta.type, meta.typeArgumentCount),
                    stringAsType(selectorForType),
                    meta.exportAs !== null ? stringArrayAsType(meta.exportAs) : NONE_TYPE,
                    stringMapAsType(meta.inputs),
                    stringMapAsType(meta.outputs),
                    stringArrayAsType(meta.queries.map(function (q) { return q.propertyName; })),
                ]));
            }
            // Define and update any view queries
            function createViewQueriesFunction(viewQueries, constantPool, name) {
                var createStatements = [];
                var updateStatements = [];
                var tempAllocator = temporaryAllocator(updateStatements, TEMPORARY_NAME);
                viewQueries.forEach(function (query) {
                    var queryInstruction = query.static ? Identifiers$1.staticViewQuery : Identifiers$1.viewQuery;
                    // creation, e.g. r3.viewQuery(somePredicate, true);
                    var queryDefinition = importExpr(queryInstruction).callFn(prepareQueryParams(query, constantPool));
                    createStatements.push(queryDefinition.toStmt());
                    // update, e.g. (r3.queryRefresh(tmp = r3.loadViewQuery()) && (ctx.someDir = tmp));
                    var temporary = tempAllocator();
                    var getQueryList = importExpr(Identifiers$1.loadViewQuery).callFn([]);
                    var refresh = importExpr(Identifiers$1.queryRefresh).callFn([temporary.set(getQueryList)]);
                    var updateDirective = variable(CONTEXT_NAME)
                        .prop(query.propertyName)
                        .set(query.first ? temporary.prop('first') : temporary);
                    updateStatements.push(refresh.and(updateDirective).toStmt());
                });
                var viewQueryFnName = name ? name + "_Query" : null;
                return fn([new FnParam(RENDER_FLAGS, NUMBER_TYPE), new FnParam(CONTEXT_NAME, null)], [
                    renderFlagCheckIfStmt(1 /* Create */, createStatements),
                    renderFlagCheckIfStmt(2 /* Update */, updateStatements)
                ], INFERRED_TYPE, null, viewQueryFnName);
            }
            // Return a host binding function or null if one is not necessary.
            function createHostBindingsFunction(hostBindingsMetadata, typeSourceSpan, bindingParser, constantPool, selector, name) {
                // Initialize hostVarsCount to number of bound host properties (interpolations illegal)
                var hostVarsCount = Object.keys(hostBindingsMetadata.properties).length;
                var elVarExp = variable('elIndex');
                var bindingContext = variable(CONTEXT_NAME);
                var styleBuilder = new StylingBuilder(elVarExp, bindingContext);
                var _c = hostBindingsMetadata.specialAttributes, styleAttr = _c.styleAttr, classAttr = _c.classAttr;
                if (styleAttr !== undefined) {
                    styleBuilder.registerStyleAttr(styleAttr);
                }
                if (classAttr !== undefined) {
                    styleBuilder.registerClassAttr(classAttr);
                }
                var createStatements = [];
                var updateStatements = [];
                var totalHostVarsCount = hostVarsCount;
                var hostBindingSourceSpan = typeSourceSpan;
                var directiveSummary = metadataAsSummary(hostBindingsMetadata);
                var valueConverter;
                var getValueConverter = function () {
                    if (!valueConverter) {
                        var hostVarsCountFn = function (numSlots) {
                            var originalVarsCount = totalHostVarsCount;
                            totalHostVarsCount += numSlots;
                            return originalVarsCount;
                        };
                        valueConverter = new ValueConverter(constantPool, function () { return error('Unexpected node'); }, // new nodes are illegal here
                        hostVarsCountFn, function () { return error('Unexpected pipe'); }); // pipes are illegal here
                    }
                    return valueConverter;
                };
                // Calculate host event bindings
                var eventBindings = bindingParser.createDirectiveHostEventAsts(directiveSummary, hostBindingSourceSpan);
                if (eventBindings && eventBindings.length) {
                    var listeners = createHostListeners(eventBindings, name);
                    createStatements.push.apply(createStatements, listeners);
                }
                // Calculate the host property bindings
                var bindings = bindingParser.createBoundHostProperties(directiveSummary, hostBindingSourceSpan);
                var propertyBindings = [];
                var attributeBindings = [];
                var syntheticHostBindings = [];
                bindings && bindings.forEach(function (binding) {
                    var name = binding.name;
                    var stylingInputWasSet = styleBuilder.registerInputBasedOnName(name, binding.expression, binding.sourceSpan);
                    if (!stylingInputWasSet) {
                        // resolve literal arrays and literal objects
                        var value = binding.expression.visit(getValueConverter());
                        var bindingExpr = bindingFn(bindingContext, value);
                        var _c = getBindingNameAndInstruction(binding), bindingName = _c.bindingName, instruction_2 = _c.instruction, isAttribute = _c.isAttribute;
                        var securityContexts = bindingParser.calcPossibleSecurityContexts(selector, bindingName, isAttribute)
                            .filter(function (context) { return context !== SecurityContext.NONE; });
                        var sanitizerFn = null;
                        if (securityContexts.length) {
                            if (securityContexts.length === 2 &&
                                securityContexts.indexOf(SecurityContext.URL) > -1 &&
                                securityContexts.indexOf(SecurityContext.RESOURCE_URL) > -1) {
                                // Special case for some URL attributes (such as "src" and "href") that may be a part
                                // of different security contexts. In this case we use special santitization function and
                                // select the actual sanitizer at runtime based on a tag name that is provided while
                                // invoking sanitization function.
                                sanitizerFn = importExpr(Identifiers$1.sanitizeUrlOrResourceUrl);
                            }
                            else {
                                sanitizerFn = resolveSanitizationFn(securityContexts[0], isAttribute);
                            }
                        }
                        var instructionParams = [literal(bindingName), bindingExpr.currValExpr];
                        if (sanitizerFn) {
                            instructionParams.push(sanitizerFn);
                        }
                        updateStatements.push.apply(updateStatements, bindingExpr.stmts);
                        if (instruction_2 === Identifiers$1.hostProperty) {
                            propertyBindings.push(instructionParams);
                        }
                        else if (instruction_2 === Identifiers$1.attribute) {
                            attributeBindings.push(instructionParams);
                        }
                        else if (instruction_2 === Identifiers$1.updateSyntheticHostBinding) {
                            syntheticHostBindings.push(instructionParams);
                        }
                        else {
                            updateStatements.push(importExpr(instruction_2).callFn(instructionParams).toStmt());
                        }
                    }
                });
                if (propertyBindings.length > 0) {
                    updateStatements.push(chainedInstruction(Identifiers$1.hostProperty, propertyBindings).toStmt());
                }
                if (attributeBindings.length > 0) {
                    updateStatements.push(chainedInstruction(Identifiers$1.attribute, attributeBindings).toStmt());
                }
                if (syntheticHostBindings.length > 0) {
                    updateStatements.push(chainedInstruction(Identifiers$1.updateSyntheticHostBinding, syntheticHostBindings).toStmt());
                }
                // since we're dealing with directives/components and both have hostBinding
                // functions, we need to generate a special hostAttrs instruction that deals
                // with both the assignment of styling as well as static attributes to the host
                // element. The instruction below will instruct all initial styling (styling
                // that is inside of a host binding within a directive/component) to be attached
                // to the host element alongside any of the provided host attributes that were
                // collected earlier.
                var hostAttrs = convertAttributesToExpressions(hostBindingsMetadata.attributes);
                var hostInstruction = styleBuilder.buildHostAttrsInstruction(null, hostAttrs, constantPool);
                if (hostInstruction) {
                    createStatements.push(createStylingStmt(hostInstruction, bindingContext, bindingFn));
                }
                if (styleBuilder.hasBindings) {
                    // singular style/class bindings (things like `[style.prop]` and `[class.name]`)
                    // MUST be registered on a given element within the component/directive
                    // templateFn/hostBindingsFn functions. The instruction below will figure out
                    // what all the bindings are and then generate the statements required to register
                    // those bindings to the element via `styling`.
                    var stylingInstruction = styleBuilder.buildStylingInstruction(null, constantPool);
                    if (stylingInstruction) {
                        createStatements.push(createStylingStmt(stylingInstruction, bindingContext, bindingFn));
                    }
                    // finally each binding that was registered in the statement above will need to be added to
                    // the update block of a component/directive templateFn/hostBindingsFn so that the bindings
                    // are evaluated and updated for the element.
                    styleBuilder.buildUpdateLevelInstructions(getValueConverter()).forEach(function (instruction) {
                        // we subtract a value of `1` here because the binding slot was already
                        // allocated at the top of this method when all the input bindings were
                        // counted.
                        totalHostVarsCount += Math.max(instruction.allocateBindingSlots - 1, 0);
                        updateStatements.push(createStylingStmt(instruction, bindingContext, bindingFn));
                    });
                }
                if (totalHostVarsCount) {
                    createStatements.unshift(importExpr(Identifiers$1.allocHostVars).callFn([literal(totalHostVarsCount)]).toStmt());
                }
                if (createStatements.length > 0 || updateStatements.length > 0) {
                    var hostBindingsFnName = name ? name + "_HostBindings" : null;
                    var statements = [];
                    if (createStatements.length > 0) {
                        statements.push(renderFlagCheckIfStmt(1 /* Create */, createStatements));
                    }
                    if (updateStatements.length > 0) {
                        statements.push(renderFlagCheckIfStmt(2 /* Update */, updateStatements));
                    }
                    return fn([
                        new FnParam(RENDER_FLAGS, NUMBER_TYPE), new FnParam(CONTEXT_NAME, null),
                        new FnParam(elVarExp.name, NUMBER_TYPE)
                    ], statements, INFERRED_TYPE, null, hostBindingsFnName);
                }
                return null;
            }
            function bindingFn(implicit, value) {
                return convertPropertyBinding(null, implicit, value, 'b', BindingForm.TrySimple, function () { return error('Unexpected interpolation'); });
            }
            function createStylingStmt(instruction, bindingContext, bindingFn) {
                var params = instruction.params(function (value) { return bindingFn(bindingContext, value).currValExpr; });
                return importExpr(instruction.reference, null, instruction.sourceSpan)
                    .callFn(params, instruction.sourceSpan)
                    .toStmt();
            }
            function getBindingNameAndInstruction(binding) {
                var bindingName = binding.name;
                var instruction;
                // Check to see if this is an attr binding or a property binding
                var attrMatches = bindingName.match(ATTR_REGEX);
                if (attrMatches) {
                    bindingName = attrMatches[1];
                    instruction = Identifiers$1.attribute;
                }
                else {
                    if (binding.isAnimation) {
                        bindingName = prepareSyntheticPropertyName(bindingName);
                        // host bindings that have a synthetic property (e.g. @foo) should always be rendered
                        // in the context of the component and not the parent. Therefore there is a special
                        // compatibility instruction available for this purpose.
                        instruction = Identifiers$1.updateSyntheticHostBinding;
                    }
                    else {
                        instruction = Identifiers$1.hostProperty;
                    }
                }
                return { bindingName: bindingName, instruction: instruction, isAttribute: !!attrMatches };
            }
            function createHostListeners(eventBindings, name) {
                return eventBindings.map(function (binding) {
                    var bindingName = binding.name && sanitizeIdentifier(binding.name);
                    var bindingFnName = binding.type === 1 /* Animation */ ?
                        prepareSyntheticListenerFunctionName(bindingName, binding.targetOrPhase) :
                        bindingName;
                    var handlerName = name && bindingName ? name + "_" + bindingFnName + "_HostBindingHandler" : null;
                    var params = prepareEventListenerParameters(BoundEvent.fromParsedEvent(binding), handlerName);
                    var instruction = binding.type == 1 /* Animation */ ? Identifiers$1.componentHostSyntheticListener : Identifiers$1.listener;
                    return importExpr(instruction).callFn(params).toStmt();
                });
            }
            function metadataAsSummary(meta) {
                // clang-format off
                return {
                    // This is used by the BindingParser, which only deals with listeners and properties. There's no
                    // need to pass attributes to it.
                    hostAttributes: {},
                    hostListeners: meta.listeners,
                    hostProperties: meta.properties,
                };
                // clang-format on
            }
            function typeMapToExpressionMap(map, outputCtx) {
                // Convert each map entry into another entry where the value is an expression importing the type.
                var entries = Array.from(map).map(function (_c) {
                    var key = _c[0], type = _c[1];
                    return [key, outputCtx.importExpr(type)];
                });
                return new Map(entries);
            }
            var HOST_REG_EXP$1 = /^(?:\[([^\]]+)\])|(?:\(([^\)]+)\))$/;
            function parseHostBindings(host) {
                var attributes = {};
                var listeners = {};
                var properties = {};
                var specialAttributes = {};
                for (var _c = 0, _d = Object.keys(host); _c < _d.length; _c++) {
                    var key = _d[_c];
                    var value = host[key];
                    var matches = key.match(HOST_REG_EXP$1);
                    if (matches === null) {
                        switch (key) {
                            case 'class':
                                if (typeof value !== 'string') {
                                    // TODO(alxhub): make this a diagnostic.
                                    throw new Error("Class binding must be string");
                                }
                                specialAttributes.classAttr = value;
                                break;
                            case 'style':
                                if (typeof value !== 'string') {
                                    // TODO(alxhub): make this a diagnostic.
                                    throw new Error("Style binding must be string");
                                }
                                specialAttributes.styleAttr = value;
                                break;
                            default:
                                if (typeof value === 'string') {
                                    attributes[key] = literal(value);
                                }
                                else {
                                    attributes[key] = value;
                                }
                        }
                    }
                    else if (matches[1 /* Binding */] != null) {
                        if (typeof value !== 'string') {
                            // TODO(alxhub): make this a diagnostic.
                            throw new Error("Property binding must be string");
                        }
                        // synthetic properties (the ones that have a `@` as a prefix)
                        // are still treated the same as regular properties. Therefore
                        // there is no point in storing them in a separate map.
                        properties[matches[1 /* Binding */]] = value;
                    }
                    else if (matches[2 /* Event */] != null) {
                        if (typeof value !== 'string') {
                            // TODO(alxhub): make this a diagnostic.
                            throw new Error("Event binding must be string");
                        }
                        listeners[matches[2 /* Event */]] = value;
                    }
                }
                return { attributes: attributes, listeners: listeners, properties: properties, specialAttributes: specialAttributes };
            }
            /**
             * Verifies host bindings and returns the list of errors (if any). Empty array indicates that a
             * given set of host bindings has no errors.
             *
             * @param bindings set of host bindings to verify.
             * @param sourceSpan source span where host bindings were defined.
             * @returns array of errors associated with a given set of host bindings.
             */
            function verifyHostBindings(bindings, sourceSpan) {
                var summary = metadataAsSummary(bindings);
                // TODO: abstract out host bindings verification logic and use it instead of
                // creating events and properties ASTs to detect errors (FW-996)
                var bindingParser = makeBindingParser();
                bindingParser.createDirectiveHostEventAsts(summary, sourceSpan);
                bindingParser.createBoundHostProperties(summary, sourceSpan);
                return bindingParser.errors;
            }
            function compileStyles(styles, selector, hostSelector) {
                var shadowCss = new ShadowCss();
                return styles.map(function (style) { return shadowCss.shimCssText(style, selector, hostSelector); });
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * An interface for retrieving documents by URL that the compiler uses
             * to load templates.
             */
            var ResourceLoader = /** @class */ (function () {
                function ResourceLoader() {
                }
                ResourceLoader.prototype.get = function (url) { return ''; };
                return ResourceLoader;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var CompilerFacadeImpl = /** @class */ (function () {
                function CompilerFacadeImpl(jitEvaluator) {
                    if (jitEvaluator === void 0) { jitEvaluator = new JitEvaluator(); }
                    this.jitEvaluator = jitEvaluator;
                    this.R3ResolvedDependencyType = R3ResolvedDependencyType;
                    this.ResourceLoader = ResourceLoader;
                    this.elementSchemaRegistry = new DomElementSchemaRegistry();
                }
                CompilerFacadeImpl.prototype.compilePipe = function (angularCoreEnv, sourceMapUrl, facade) {
                    var res = compilePipeFromMetadata({
                        name: facade.name,
                        type: new WrappedNodeExpr(facade.type),
                        typeArgumentCount: facade.typeArgumentCount,
                        deps: convertR3DependencyMetadataArray(facade.deps),
                        pipeName: facade.pipeName,
                        pure: facade.pure,
                    });
                    return this.jitExpression(res.expression, angularCoreEnv, sourceMapUrl, res.statements);
                };
                CompilerFacadeImpl.prototype.compileInjectable = function (angularCoreEnv, sourceMapUrl, facade) {
                    var _c = compileInjectable({
                        name: facade.name,
                        type: new WrappedNodeExpr(facade.type),
                        typeArgumentCount: facade.typeArgumentCount,
                        providedIn: computeProvidedIn(facade.providedIn),
                        useClass: wrapExpression(facade, USE_CLASS),
                        useFactory: wrapExpression(facade, USE_FACTORY),
                        useValue: wrapExpression(facade, USE_VALUE),
                        useExisting: wrapExpression(facade, USE_EXISTING),
                        ctorDeps: convertR3DependencyMetadataArray(facade.ctorDeps),
                        userDeps: convertR3DependencyMetadataArray(facade.userDeps) || undefined,
                    }), expression = _c.expression, statements = _c.statements;
                    return this.jitExpression(expression, angularCoreEnv, sourceMapUrl, statements);
                };
                CompilerFacadeImpl.prototype.compileInjector = function (angularCoreEnv, sourceMapUrl, facade) {
                    var meta = {
                        name: facade.name,
                        type: new WrappedNodeExpr(facade.type),
                        deps: convertR3DependencyMetadataArray(facade.deps),
                        providers: new WrappedNodeExpr(facade.providers),
                        imports: facade.imports.map(function (i) { return new WrappedNodeExpr(i); }),
                    };
                    var res = compileInjector(meta);
                    return this.jitExpression(res.expression, angularCoreEnv, sourceMapUrl, res.statements);
                };
                CompilerFacadeImpl.prototype.compileNgModule = function (angularCoreEnv, sourceMapUrl, facade) {
                    var meta = {
                        type: new WrappedNodeExpr(facade.type),
                        bootstrap: facade.bootstrap.map(wrapReference),
                        declarations: facade.declarations.map(wrapReference),
                        imports: facade.imports.map(wrapReference),
                        exports: facade.exports.map(wrapReference),
                        emitInline: true,
                        containsForwardDecls: false,
                        schemas: facade.schemas ? facade.schemas.map(wrapReference) : null,
                        id: facade.id ? new WrappedNodeExpr(facade.id) : null,
                    };
                    var res = compileNgModule(meta);
                    return this.jitExpression(res.expression, angularCoreEnv, sourceMapUrl, []);
                };
                CompilerFacadeImpl.prototype.compileDirective = function (angularCoreEnv, sourceMapUrl, facade) {
                    var constantPool = new ConstantPool();
                    var bindingParser = makeBindingParser();
                    var meta = convertDirectiveFacadeToMetadata(facade);
                    var res = compileDirectiveFromMetadata(meta, constantPool, bindingParser);
                    var preStatements = constantPool.statements.concat(res.statements);
                    return this.jitExpression(res.expression, angularCoreEnv, sourceMapUrl, preStatements);
                };
                CompilerFacadeImpl.prototype.compileComponent = function (angularCoreEnv, sourceMapUrl, facade) {
                    // The ConstantPool is a requirement of the JIT'er.
                    var constantPool = new ConstantPool();
                    var interpolationConfig = facade.interpolation ?
                        InterpolationConfig.fromArray(facade.interpolation) :
                        DEFAULT_INTERPOLATION_CONFIG;
                    // Parse the template and check for errors.
                    var template = parseTemplate(facade.template, sourceMapUrl, { preserveWhitespaces: facade.preserveWhitespaces, interpolationConfig: interpolationConfig });
                    if (template.errors !== undefined) {
                        var errors = template.errors.map(function (err) { return err.toString(); }).join(', ');
                        throw new Error("Errors during JIT compilation of template for " + facade.name + ": " + errors);
                    }
                    // Compile the component metadata, including template, into an expression.
                    // TODO(alxhub): implement inputs, outputs, queries, etc.
                    var res = compileComponentFromMetadata(Object.assign({}, facade, convertDirectiveFacadeToMetadata(facade), { selector: facade.selector || this.elementSchemaRegistry.getDefaultComponentElementName(), template: template, wrapDirectivesAndPipesInClosure: false, styles: facade.styles || [], encapsulation: facade.encapsulation, interpolation: interpolationConfig, changeDetection: facade.changeDetection, animations: facade.animations != null ? new WrappedNodeExpr(facade.animations) : null, viewProviders: facade.viewProviders != null ? new WrappedNodeExpr(facade.viewProviders) :
                            null, relativeContextFilePath: '', i18nUseExternalIds: true }), constantPool, makeBindingParser(interpolationConfig));
                    var preStatements = constantPool.statements.concat(res.statements);
                    return this.jitExpression(res.expression, angularCoreEnv, "ng:///" + facade.name + ".js", preStatements);
                };
                CompilerFacadeImpl.prototype.compileBase = function (angularCoreEnv, sourceMapUrl, facade) {
                    var constantPool = new ConstantPool();
                    var typeSourceSpan = this.createParseSourceSpan('Base', facade.name, "ng:///" + facade.name + ".js");
                    var meta = Object.assign({}, facade, { typeSourceSpan: typeSourceSpan, viewQueries: facade.viewQueries ? facade.viewQueries.map(convertToR3QueryMetadata) :
                            facade.viewQueries, queries: facade.queries ? facade.queries.map(convertToR3QueryMetadata) : facade.queries, host: extractHostBindings(facade.propMetadata, typeSourceSpan) });
                    var res = compileBaseDefFromMetadata(meta, constantPool, makeBindingParser());
                    return this.jitExpression(res.expression, angularCoreEnv, sourceMapUrl, constantPool.statements);
                };
                CompilerFacadeImpl.prototype.createParseSourceSpan = function (kind, typeName, sourceUrl) {
                    return r3JitTypeSourceSpan(kind, typeName, sourceUrl);
                };
                /**
                 * JIT compiles an expression and returns the result of executing that expression.
                 *
                 * @param def the definition which will be compiled and executed to get the value to patch
                 * @param context an object map of @angular/core symbol names to symbols which will be available
                 * in the context of the compiled expression
                 * @param sourceUrl a URL to use for the source map of the compiled expression
                 * @param preStatements a collection of statements that should be evaluated before the expression.
                 */
                CompilerFacadeImpl.prototype.jitExpression = function (def, context, sourceUrl, preStatements) {
                    // The ConstantPool may contain Statements which declare variables used in the final expression.
                    // Therefore, its statements need to precede the actual JIT operation. The final statement is a
                    // declaration of $def which is set to the expression being compiled.
                    var statements = preStatements.concat([
                        new DeclareVarStmt('$def', def, undefined, [StmtModifier.Exported]),
                    ]);
                    var res = this.jitEvaluator.evaluateStatements(sourceUrl, statements, new R3JitReflector(context), /* enableSourceMaps */ true);
                    return res['$def'];
                };
                return CompilerFacadeImpl;
            }());
            var USE_CLASS = Object.keys({ useClass: null })[0];
            var USE_FACTORY = Object.keys({ useFactory: null })[0];
            var USE_VALUE = Object.keys({ useValue: null })[0];
            var USE_EXISTING = Object.keys({ useExisting: null })[0];
            var wrapReference = function (value) {
                var wrapped = new WrappedNodeExpr(value);
                return { value: wrapped, type: wrapped };
            };
            function convertToR3QueryMetadata(facade) {
                return Object.assign({}, facade, { predicate: Array.isArray(facade.predicate) ? facade.predicate :
                        new WrappedNodeExpr(facade.predicate), read: facade.read ? new WrappedNodeExpr(facade.read) : null, static: facade.static });
            }
            function convertDirectiveFacadeToMetadata(facade) {
                var inputsFromMetadata = parseInputOutputs(facade.inputs || []);
                var outputsFromMetadata = parseInputOutputs(facade.outputs || []);
                var propMetadata = facade.propMetadata;
                var inputsFromType = {};
                var outputsFromType = {};
                var _loop_3 = function (field) {
                    if (propMetadata.hasOwnProperty(field)) {
                        propMetadata[field].forEach(function (ann) {
                            if (isInput(ann)) {
                                inputsFromType[field] =
                                    ann.bindingPropertyName ? [ann.bindingPropertyName, field] : field;
                            }
                            else if (isOutput(ann)) {
                                outputsFromType[field] = ann.bindingPropertyName || field;
                            }
                        });
                    }
                };
                for (var field in propMetadata) {
                    _loop_3(field);
                }
                return Object.assign({}, facade, { typeSourceSpan: facade.typeSourceSpan, type: new WrappedNodeExpr(facade.type), deps: convertR3DependencyMetadataArray(facade.deps), host: extractHostBindings(facade.propMetadata, facade.typeSourceSpan, facade.host), inputs: Object.assign({}, inputsFromMetadata, inputsFromType), outputs: Object.assign({}, outputsFromMetadata, outputsFromType), queries: facade.queries.map(convertToR3QueryMetadata), providers: facade.providers != null ? new WrappedNodeExpr(facade.providers) : null, viewQueries: facade.viewQueries.map(convertToR3QueryMetadata) });
            }
            function wrapExpression(obj, property) {
                if (obj.hasOwnProperty(property)) {
                    return new WrappedNodeExpr(obj[property]);
                }
                else {
                    return undefined;
                }
            }
            function computeProvidedIn(providedIn) {
                if (providedIn == null || typeof providedIn === 'string') {
                    return new LiteralExpr(providedIn);
                }
                else {
                    return new WrappedNodeExpr(providedIn);
                }
            }
            function convertR3DependencyMetadata(facade) {
                var tokenExpr;
                if (facade.token === null) {
                    tokenExpr = new LiteralExpr(null);
                }
                else if (facade.resolved === R3ResolvedDependencyType.Attribute) {
                    tokenExpr = new LiteralExpr(facade.token);
                }
                else {
                    tokenExpr = new WrappedNodeExpr(facade.token);
                }
                return {
                    token: tokenExpr,
                    resolved: facade.resolved,
                    host: facade.host,
                    optional: facade.optional,
                    self: facade.self,
                    skipSelf: facade.skipSelf
                };
            }
            function convertR3DependencyMetadataArray(facades) {
                return facades == null ? null : facades.map(convertR3DependencyMetadata);
            }
            function extractHostBindings(propMetadata, sourceSpan, host) {
                // First parse the declarations from the metadata.
                var bindings = parseHostBindings(host || {});
                // After that check host bindings for errors
                var errors = verifyHostBindings(bindings, sourceSpan);
                if (errors.length) {
                    throw new Error(errors.map(function (error) { return error.msg; }).join('\n'));
                }
                var _loop_4 = function (field) {
                    if (propMetadata.hasOwnProperty(field)) {
                        propMetadata[field].forEach(function (ann) {
                            if (isHostBinding(ann)) {
                                bindings.properties[ann.hostPropertyName || field] = field;
                            }
                            else if (isHostListener(ann)) {
                                bindings.listeners[ann.eventName || field] = field + "(" + (ann.args || []).join(',') + ")";
                            }
                        });
                    }
                };
                // Next, loop over the properties of the object, looking for @HostBinding and @HostListener.
                for (var field in propMetadata) {
                    _loop_4(field);
                }
                return bindings;
            }
            function isHostBinding(value) {
                return value.ngMetadataName === 'HostBinding';
            }
            function isHostListener(value) {
                return value.ngMetadataName === 'HostListener';
            }
            function isInput(value) {
                return value.ngMetadataName === 'Input';
            }
            function isOutput(value) {
                return value.ngMetadataName === 'Output';
            }
            function parseInputOutputs(values) {
                return values.reduce(function (map, value) {
                    var _c = value.split(',').map(function (piece) { return piece.trim(); }), field = _c[0], property = _c[1];
                    map[field] = property || field;
                    return map;
                }, {});
            }
            function publishFacade(global) {
                var ng = global.ng || (global.ng = {});
                ng.ɵcompilerFacade = new CompilerFacadeImpl();
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var VERSION$1 = new Version('8.2.13');
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var CompilerConfig = /** @class */ (function () {
                function CompilerConfig(_c) {
                    var _d = _c === void 0 ? {} : _c, _e = _d.defaultEncapsulation, defaultEncapsulation = _e === void 0 ? ViewEncapsulation.Emulated : _e, _f = _d.useJit, useJit = _f === void 0 ? true : _f, _g = _d.jitDevMode, jitDevMode = _g === void 0 ? false : _g, _h = _d.missingTranslation, missingTranslation = _h === void 0 ? null : _h, preserveWhitespaces = _d.preserveWhitespaces, strictInjectionParameters = _d.strictInjectionParameters;
                    this.defaultEncapsulation = defaultEncapsulation;
                    this.useJit = !!useJit;
                    this.jitDevMode = !!jitDevMode;
                    this.missingTranslation = missingTranslation;
                    this.preserveWhitespaces = preserveWhitespacesDefault(noUndefined(preserveWhitespaces));
                    this.strictInjectionParameters = strictInjectionParameters === true;
                }
                return CompilerConfig;
            }());
            function preserveWhitespacesDefault(preserveWhitespacesOption, defaultSetting) {
                if (defaultSetting === void 0) { defaultSetting = false; }
                return preserveWhitespacesOption === null ? defaultSetting : preserveWhitespacesOption;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var DirectiveNormalizer = /** @class */ (function () {
                function DirectiveNormalizer(_resourceLoader, _urlResolver, _htmlParser, _config) {
                    this._resourceLoader = _resourceLoader;
                    this._urlResolver = _urlResolver;
                    this._htmlParser = _htmlParser;
                    this._config = _config;
                    this._resourceLoaderCache = new Map();
                }
                DirectiveNormalizer.prototype.clearCache = function () { this._resourceLoaderCache.clear(); };
                DirectiveNormalizer.prototype.clearCacheFor = function (normalizedDirective) {
                    var _this = this;
                    if (!normalizedDirective.isComponent) {
                        return;
                    }
                    var template = normalizedDirective.template;
                    this._resourceLoaderCache.delete(template.templateUrl);
                    template.externalStylesheets.forEach(function (stylesheet) { _this._resourceLoaderCache.delete(stylesheet.moduleUrl); });
                };
                DirectiveNormalizer.prototype._fetch = function (url) {
                    var result = this._resourceLoaderCache.get(url);
                    if (!result) {
                        result = this._resourceLoader.get(url);
                        this._resourceLoaderCache.set(url, result);
                    }
                    return result;
                };
                DirectiveNormalizer.prototype.normalizeTemplate = function (prenormData) {
                    var _this = this;
                    if (isDefined(prenormData.template)) {
                        if (isDefined(prenormData.templateUrl)) {
                            throw syntaxError("'" + stringify(prenormData.componentType) + "' component cannot define both template and templateUrl");
                        }
                        if (typeof prenormData.template !== 'string') {
                            throw syntaxError("The template specified for component " + stringify(prenormData.componentType) + " is not a string");
                        }
                    }
                    else if (isDefined(prenormData.templateUrl)) {
                        if (typeof prenormData.templateUrl !== 'string') {
                            throw syntaxError("The templateUrl specified for component " + stringify(prenormData.componentType) + " is not a string");
                        }
                    }
                    else {
                        throw syntaxError("No template specified for component " + stringify(prenormData.componentType));
                    }
                    if (isDefined(prenormData.preserveWhitespaces) &&
                        typeof prenormData.preserveWhitespaces !== 'boolean') {
                        throw syntaxError("The preserveWhitespaces option for component " + stringify(prenormData.componentType) + " must be a boolean");
                    }
                    return SyncAsync.then(this._preParseTemplate(prenormData), function (preparsedTemplate) { return _this._normalizeTemplateMetadata(prenormData, preparsedTemplate); });
                };
                DirectiveNormalizer.prototype._preParseTemplate = function (prenomData) {
                    var _this = this;
                    var template;
                    var templateUrl;
                    if (prenomData.template != null) {
                        template = prenomData.template;
                        templateUrl = prenomData.moduleUrl;
                    }
                    else {
                        templateUrl = this._urlResolver.resolve(prenomData.moduleUrl, prenomData.templateUrl);
                        template = this._fetch(templateUrl);
                    }
                    return SyncAsync.then(template, function (template) { return _this._preparseLoadedTemplate(prenomData, template, templateUrl); });
                };
                DirectiveNormalizer.prototype._preparseLoadedTemplate = function (prenormData, template, templateAbsUrl) {
                    var isInline = !!prenormData.template;
                    var interpolationConfig = InterpolationConfig.fromArray(prenormData.interpolation);
                    var templateUrl = templateSourceUrl({ reference: prenormData.ngModuleType }, { type: { reference: prenormData.componentType } }, { isInline: isInline, templateUrl: templateAbsUrl });
                    var rootNodesAndErrors = this._htmlParser.parse(template, templateUrl, { tokenizeExpansionForms: true, interpolationConfig: interpolationConfig });
                    if (rootNodesAndErrors.errors.length > 0) {
                        var errorString = rootNodesAndErrors.errors.join('\n');
                        throw syntaxError("Template parse errors:\n" + errorString);
                    }
                    var templateMetadataStyles = this._normalizeStylesheet(new CompileStylesheetMetadata({ styles: prenormData.styles, moduleUrl: prenormData.moduleUrl }));
                    var visitor = new TemplatePreparseVisitor();
                    visitAll$1(visitor, rootNodesAndErrors.rootNodes);
                    var templateStyles = this._normalizeStylesheet(new CompileStylesheetMetadata({ styles: visitor.styles, styleUrls: visitor.styleUrls, moduleUrl: templateAbsUrl }));
                    var styles = templateMetadataStyles.styles.concat(templateStyles.styles);
                    var inlineStyleUrls = templateMetadataStyles.styleUrls.concat(templateStyles.styleUrls);
                    var styleUrls = this
                        ._normalizeStylesheet(new CompileStylesheetMetadata({ styleUrls: prenormData.styleUrls, moduleUrl: prenormData.moduleUrl }))
                        .styleUrls;
                    return {
                        template: template,
                        templateUrl: templateAbsUrl, isInline: isInline,
                        htmlAst: rootNodesAndErrors, styles: styles, inlineStyleUrls: inlineStyleUrls, styleUrls: styleUrls,
                        ngContentSelectors: visitor.ngContentSelectors,
                    };
                };
                DirectiveNormalizer.prototype._normalizeTemplateMetadata = function (prenormData, preparsedTemplate) {
                    var _this = this;
                    return SyncAsync.then(this._loadMissingExternalStylesheets(preparsedTemplate.styleUrls.concat(preparsedTemplate.inlineStyleUrls)), function (externalStylesheets) { return _this._normalizeLoadedTemplateMetadata(prenormData, preparsedTemplate, externalStylesheets); });
                };
                DirectiveNormalizer.prototype._normalizeLoadedTemplateMetadata = function (prenormData, preparsedTemplate, stylesheets) {
                    var _this = this;
                    // Algorithm:
                    // - produce exactly 1 entry per original styleUrl in
                    // CompileTemplateMetadata.externalStylesheets with all styles inlined
                    // - inline all styles that are referenced by the template into CompileTemplateMetadata.styles.
                    // Reason: be able to determine how many stylesheets there are even without loading
                    // the template nor the stylesheets, so we can create a stub for TypeScript always synchronously
                    // (as resource loading may be async)
                    var styles = preparsedTemplate.styles.slice();
                    this._inlineStyles(preparsedTemplate.inlineStyleUrls, stylesheets, styles);
                    var styleUrls = preparsedTemplate.styleUrls;
                    var externalStylesheets = styleUrls.map(function (styleUrl) {
                        var stylesheet = stylesheets.get(styleUrl);
                        var styles = stylesheet.styles.slice();
                        _this._inlineStyles(stylesheet.styleUrls, stylesheets, styles);
                        return new CompileStylesheetMetadata({ moduleUrl: styleUrl, styles: styles });
                    });
                    var encapsulation = prenormData.encapsulation;
                    if (encapsulation == null) {
                        encapsulation = this._config.defaultEncapsulation;
                    }
                    if (encapsulation === ViewEncapsulation.Emulated && styles.length === 0 &&
                        styleUrls.length === 0) {
                        encapsulation = ViewEncapsulation.None;
                    }
                    return new CompileTemplateMetadata({
                        encapsulation: encapsulation,
                        template: preparsedTemplate.template,
                        templateUrl: preparsedTemplate.templateUrl,
                        htmlAst: preparsedTemplate.htmlAst, styles: styles, styleUrls: styleUrls,
                        ngContentSelectors: preparsedTemplate.ngContentSelectors,
                        animations: prenormData.animations,
                        interpolation: prenormData.interpolation,
                        isInline: preparsedTemplate.isInline, externalStylesheets: externalStylesheets,
                        preserveWhitespaces: preserveWhitespacesDefault(prenormData.preserveWhitespaces, this._config.preserveWhitespaces),
                    });
                };
                DirectiveNormalizer.prototype._inlineStyles = function (styleUrls, stylesheets, targetStyles) {
                    var _this = this;
                    styleUrls.forEach(function (styleUrl) {
                        var stylesheet = stylesheets.get(styleUrl);
                        stylesheet.styles.forEach(function (style) { return targetStyles.push(style); });
                        _this._inlineStyles(stylesheet.styleUrls, stylesheets, targetStyles);
                    });
                };
                DirectiveNormalizer.prototype._loadMissingExternalStylesheets = function (styleUrls, loadedStylesheets) {
                    var _this = this;
                    if (loadedStylesheets === void 0) { loadedStylesheets = new Map(); }
                    return SyncAsync.then(SyncAsync.all(styleUrls.filter(function (styleUrl) { return !loadedStylesheets.has(styleUrl); })
                        .map(function (styleUrl) { return SyncAsync.then(_this._fetch(styleUrl), function (loadedStyle) {
                        var stylesheet = _this._normalizeStylesheet(new CompileStylesheetMetadata({ styles: [loadedStyle], moduleUrl: styleUrl }));
                        loadedStylesheets.set(styleUrl, stylesheet);
                        return _this._loadMissingExternalStylesheets(stylesheet.styleUrls, loadedStylesheets);
                    }); })), function (_) { return loadedStylesheets; });
                };
                DirectiveNormalizer.prototype._normalizeStylesheet = function (stylesheet) {
                    var _this = this;
                    var moduleUrl = stylesheet.moduleUrl;
                    var allStyleUrls = stylesheet.styleUrls.filter(isStyleUrlResolvable)
                        .map(function (url) { return _this._urlResolver.resolve(moduleUrl, url); });
                    var allStyles = stylesheet.styles.map(function (style) {
                        var styleWithImports = extractStyleUrls(_this._urlResolver, moduleUrl, style);
                        allStyleUrls.push.apply(allStyleUrls, styleWithImports.styleUrls);
                        return styleWithImports.style;
                    });
                    return new CompileStylesheetMetadata({ styles: allStyles, styleUrls: allStyleUrls, moduleUrl: moduleUrl });
                };
                return DirectiveNormalizer;
            }());
            var TemplatePreparseVisitor = /** @class */ (function () {
                function TemplatePreparseVisitor() {
                    this.ngContentSelectors = [];
                    this.styles = [];
                    this.styleUrls = [];
                    this.ngNonBindableStackCount = 0;
                }
                TemplatePreparseVisitor.prototype.visitElement = function (ast, context) {
                    var preparsedElement = preparseElement(ast);
                    switch (preparsedElement.type) {
                        case PreparsedElementType.NG_CONTENT:
                            if (this.ngNonBindableStackCount === 0) {
                                this.ngContentSelectors.push(preparsedElement.selectAttr);
                            }
                            break;
                        case PreparsedElementType.STYLE:
                            var textContent_1 = '';
                            ast.children.forEach(function (child) {
                                if (child instanceof Text$3) {
                                    textContent_1 += child.value;
                                }
                            });
                            this.styles.push(textContent_1);
                            break;
                        case PreparsedElementType.STYLESHEET:
                            this.styleUrls.push(preparsedElement.hrefAttr);
                            break;
                        default:
                            break;
                    }
                    if (preparsedElement.nonBindable) {
                        this.ngNonBindableStackCount++;
                    }
                    visitAll$1(this, ast.children);
                    if (preparsedElement.nonBindable) {
                        this.ngNonBindableStackCount--;
                    }
                    return null;
                };
                TemplatePreparseVisitor.prototype.visitExpansion = function (ast, context) { visitAll$1(this, ast.cases); };
                TemplatePreparseVisitor.prototype.visitExpansionCase = function (ast, context) {
                    visitAll$1(this, ast.expression);
                };
                TemplatePreparseVisitor.prototype.visitComment = function (ast, context) { return null; };
                TemplatePreparseVisitor.prototype.visitAttribute = function (ast, context) { return null; };
                TemplatePreparseVisitor.prototype.visitText = function (ast, context) { return null; };
                return TemplatePreparseVisitor;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var QUERY_METADATA_IDENTIFIERS = [
                createViewChild,
                createViewChildren,
                createContentChild,
                createContentChildren,
            ];
            /*
             * Resolve a `Type` for {@link Directive}.
             *
             * This interface can be overridden by the application developer to create custom behavior.
             *
             * See {@link Compiler}
             */
            var DirectiveResolver = /** @class */ (function () {
                function DirectiveResolver(_reflector) {
                    this._reflector = _reflector;
                }
                DirectiveResolver.prototype.isDirective = function (type) {
                    var typeMetadata = this._reflector.annotations(resolveForwardRef(type));
                    return typeMetadata && typeMetadata.some(isDirectiveMetadata);
                };
                DirectiveResolver.prototype.resolve = function (type, throwIfNotFound) {
                    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
                    var typeMetadata = this._reflector.annotations(resolveForwardRef(type));
                    if (typeMetadata) {
                        var metadata = findLast(typeMetadata, isDirectiveMetadata);
                        if (metadata) {
                            var propertyMetadata = this._reflector.propMetadata(type);
                            var guards = this._reflector.guards(type);
                            return this._mergeWithPropertyMetadata(metadata, propertyMetadata, guards, type);
                        }
                    }
                    if (throwIfNotFound) {
                        throw new Error("No Directive annotation found on " + stringify(type));
                    }
                    return null;
                };
                DirectiveResolver.prototype._mergeWithPropertyMetadata = function (dm, propertyMetadata, guards, directiveType) {
                    var inputs = [];
                    var outputs = [];
                    var host = {};
                    var queries = {};
                    Object.keys(propertyMetadata).forEach(function (propName) {
                        var input = findLast(propertyMetadata[propName], function (a) { return createInput.isTypeOf(a); });
                        if (input) {
                            if (input.bindingPropertyName) {
                                inputs.push(propName + ": " + input.bindingPropertyName);
                            }
                            else {
                                inputs.push(propName);
                            }
                        }
                        var output = findLast(propertyMetadata[propName], function (a) { return createOutput.isTypeOf(a); });
                        if (output) {
                            if (output.bindingPropertyName) {
                                outputs.push(propName + ": " + output.bindingPropertyName);
                            }
                            else {
                                outputs.push(propName);
                            }
                        }
                        var hostBindings = propertyMetadata[propName].filter(function (a) { return createHostBinding.isTypeOf(a); });
                        hostBindings.forEach(function (hostBinding) {
                            if (hostBinding.hostPropertyName) {
                                var startWith = hostBinding.hostPropertyName[0];
                                if (startWith === '(') {
                                    throw new Error("@HostBinding can not bind to events. Use @HostListener instead.");
                                }
                                else if (startWith === '[') {
                                    throw new Error("@HostBinding parameter should be a property name, 'class.<name>', or 'attr.<name>'.");
                                }
                                host["[" + hostBinding.hostPropertyName + "]"] = propName;
                            }
                            else {
                                host["[" + propName + "]"] = propName;
                            }
                        });
                        var hostListeners = propertyMetadata[propName].filter(function (a) { return createHostListener.isTypeOf(a); });
                        hostListeners.forEach(function (hostListener) {
                            var args = hostListener.args || [];
                            host["(" + hostListener.eventName + ")"] = propName + "(" + args.join(',') + ")";
                        });
                        var query = findLast(propertyMetadata[propName], function (a) { return QUERY_METADATA_IDENTIFIERS.some(function (i) { return i.isTypeOf(a); }); });
                        if (query) {
                            queries[propName] = query;
                        }
                    });
                    return this._merge(dm, inputs, outputs, host, queries, guards, directiveType);
                };
                DirectiveResolver.prototype._extractPublicName = function (def) { return splitAtColon(def, [null, def])[1].trim(); };
                DirectiveResolver.prototype._dedupeBindings = function (bindings) {
                    var names = new Set();
                    var publicNames = new Set();
                    var reversedResult = [];
                    // go last to first to allow later entries to overwrite previous entries
                    for (var i = bindings.length - 1; i >= 0; i--) {
                        var binding = bindings[i];
                        var name = this._extractPublicName(binding);
                        publicNames.add(name);
                        if (!names.has(name)) {
                            names.add(name);
                            reversedResult.push(binding);
                        }
                    }
                    return reversedResult.reverse();
                };
                DirectiveResolver.prototype._merge = function (directive, inputs, outputs, host, queries, guards, directiveType) {
                    var mergedInputs = this._dedupeBindings(directive.inputs ? directive.inputs.concat(inputs) : inputs);
                    var mergedOutputs = this._dedupeBindings(directive.outputs ? directive.outputs.concat(outputs) : outputs);
                    var mergedHost = directive.host ? Object.assign({}, directive.host, host) : host;
                    var mergedQueries = directive.queries ? Object.assign({}, directive.queries, queries) : queries;
                    if (createComponent.isTypeOf(directive)) {
                        var comp = directive;
                        return createComponent({
                            selector: comp.selector,
                            inputs: mergedInputs,
                            outputs: mergedOutputs,
                            host: mergedHost,
                            exportAs: comp.exportAs,
                            moduleId: comp.moduleId,
                            queries: mergedQueries,
                            changeDetection: comp.changeDetection,
                            providers: comp.providers,
                            viewProviders: comp.viewProviders,
                            entryComponents: comp.entryComponents,
                            template: comp.template,
                            templateUrl: comp.templateUrl,
                            styles: comp.styles,
                            styleUrls: comp.styleUrls,
                            encapsulation: comp.encapsulation,
                            animations: comp.animations,
                            interpolation: comp.interpolation,
                            preserveWhitespaces: directive.preserveWhitespaces,
                        });
                    }
                    else {
                        return createDirective({
                            selector: directive.selector,
                            inputs: mergedInputs,
                            outputs: mergedOutputs,
                            host: mergedHost,
                            exportAs: directive.exportAs,
                            queries: mergedQueries,
                            providers: directive.providers, guards: guards
                        });
                    }
                };
                return DirectiveResolver;
            }());
            function isDirectiveMetadata(type) {
                return createDirective.isTypeOf(type) || createComponent.isTypeOf(type);
            }
            function findLast(arr, condition) {
                for (var i = arr.length - 1; i >= 0; i--) {
                    if (condition(arr[i])) {
                        return arr[i];
                    }
                }
                return null;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * An i18n error.
             */
            var I18nError = /** @class */ (function (_super_1) {
                __extends(I18nError, _super_1);
                function I18nError(span, msg) {
                    return _super_1.call(this, span, msg) || this;
                }
                return I18nError;
            }(ParseError));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _I18N_ATTR = 'i18n';
            var _I18N_ATTR_PREFIX = 'i18n-';
            var _I18N_COMMENT_PREFIX_REGEXP = /^i18n:?/;
            var MEANING_SEPARATOR = '|';
            var ID_SEPARATOR = '@@';
            var i18nCommentsWarned = false;
            /**
             * Extract translatable messages from an html AST
             */
            function extractMessages(nodes, interpolationConfig, implicitTags, implicitAttrs) {
                var visitor = new _Visitor$2(implicitTags, implicitAttrs);
                return visitor.extract(nodes, interpolationConfig);
            }
            function mergeTranslations(nodes, translations, interpolationConfig, implicitTags, implicitAttrs) {
                var visitor = new _Visitor$2(implicitTags, implicitAttrs);
                return visitor.merge(nodes, translations, interpolationConfig);
            }
            var ExtractionResult = /** @class */ (function () {
                function ExtractionResult(messages, errors) {
                    this.messages = messages;
                    this.errors = errors;
                }
                return ExtractionResult;
            }());
            var _VisitorMode;
            (function (_VisitorMode) {
                _VisitorMode[_VisitorMode["Extract"] = 0] = "Extract";
                _VisitorMode[_VisitorMode["Merge"] = 1] = "Merge";
            })(_VisitorMode || (_VisitorMode = {}));
            /**
             * This Visitor is used:
             * 1. to extract all the translatable strings from an html AST (see `extract()`),
             * 2. to replace the translatable strings with the actual translations (see `merge()`)
             *
             * @internal
             */
            var _Visitor$2 = /** @class */ (function () {
                function _Visitor$2(_implicitTags, _implicitAttrs) {
                    this._implicitTags = _implicitTags;
                    this._implicitAttrs = _implicitAttrs;
                }
                /**
                 * Extracts the messages from the tree
                 */
                _Visitor$2.prototype.extract = function (nodes, interpolationConfig) {
                    var _this = this;
                    this._init(_VisitorMode.Extract, interpolationConfig);
                    nodes.forEach(function (node) { return node.visit(_this, null); });
                    if (this._inI18nBlock) {
                        this._reportError(nodes[nodes.length - 1], 'Unclosed block');
                    }
                    return new ExtractionResult(this._messages, this._errors);
                };
                /**
                 * Returns a tree where all translatable nodes are translated
                 */
                _Visitor$2.prototype.merge = function (nodes, translations, interpolationConfig) {
                    this._init(_VisitorMode.Merge, interpolationConfig);
                    this._translations = translations;
                    // Construct a single fake root element
                    var wrapper = new Element$1('wrapper', [], nodes, undefined, undefined, undefined);
                    var translatedNode = wrapper.visit(this, null);
                    if (this._inI18nBlock) {
                        this._reportError(nodes[nodes.length - 1], 'Unclosed block');
                    }
                    return new ParseTreeResult(translatedNode.children, this._errors);
                };
                _Visitor$2.prototype.visitExpansionCase = function (icuCase, context) {
                    // Parse cases for translatable html attributes
                    var expression = visitAll$1(this, icuCase.expression, context);
                    if (this._mode === _VisitorMode.Merge) {
                        return new ExpansionCase(icuCase.value, expression, icuCase.sourceSpan, icuCase.valueSourceSpan, icuCase.expSourceSpan);
                    }
                };
                _Visitor$2.prototype.visitExpansion = function (icu, context) {
                    this._mayBeAddBlockChildren(icu);
                    var wasInIcu = this._inIcu;
                    if (!this._inIcu) {
                        // nested ICU messages should not be extracted but top-level translated as a whole
                        if (this._isInTranslatableSection) {
                            this._addMessage([icu]);
                        }
                        this._inIcu = true;
                    }
                    var cases = visitAll$1(this, icu.cases, context);
                    if (this._mode === _VisitorMode.Merge) {
                        icu = new Expansion(icu.switchValue, icu.type, cases, icu.sourceSpan, icu.switchValueSourceSpan);
                    }
                    this._inIcu = wasInIcu;
                    return icu;
                };
                _Visitor$2.prototype.visitComment = function (comment, context) {
                    var isOpening = _isOpeningComment(comment);
                    if (isOpening && this._isInTranslatableSection) {
                        this._reportError(comment, 'Could not start a block inside a translatable section');
                        return;
                    }
                    var isClosing = _isClosingComment(comment);
                    if (isClosing && !this._inI18nBlock) {
                        this._reportError(comment, 'Trying to close an unopened block');
                        return;
                    }
                    if (!this._inI18nNode && !this._inIcu) {
                        if (!this._inI18nBlock) {
                            if (isOpening) {
                                // deprecated from v5 you should use <ng-container i18n> instead of i18n comments
                                if (!i18nCommentsWarned && console && console.warn) {
                                    i18nCommentsWarned = true;
                                    var details = comment.sourceSpan.details ? ", " + comment.sourceSpan.details : '';
                                    // TODO(ocombe): use a log service once there is a public one available
                                    console.warn("I18n comments are deprecated, use an <ng-container> element instead (" + comment.sourceSpan.start + details + ")");
                                }
                                this._inI18nBlock = true;
                                this._blockStartDepth = this._depth;
                                this._blockChildren = [];
                                this._blockMeaningAndDesc =
                                    comment.value.replace(_I18N_COMMENT_PREFIX_REGEXP, '').trim();
                                this._openTranslatableSection(comment);
                            }
                        }
                        else {
                            if (isClosing) {
                                if (this._depth == this._blockStartDepth) {
                                    this._closeTranslatableSection(comment, this._blockChildren);
                                    this._inI18nBlock = false;
                                    var message = this._addMessage(this._blockChildren, this._blockMeaningAndDesc);
                                    // merge attributes in sections
                                    var nodes = this._translateMessage(comment, message);
                                    return visitAll$1(this, nodes);
                                }
                                else {
                                    this._reportError(comment, 'I18N blocks should not cross element boundaries');
                                    return;
                                }
                            }
                        }
                    }
                };
                _Visitor$2.prototype.visitText = function (text, context) {
                    if (this._isInTranslatableSection) {
                        this._mayBeAddBlockChildren(text);
                    }
                    return text;
                };
                _Visitor$2.prototype.visitElement = function (el, context) {
                    var _this = this;
                    this._mayBeAddBlockChildren(el);
                    this._depth++;
                    var wasInI18nNode = this._inI18nNode;
                    var wasInImplicitNode = this._inImplicitNode;
                    var childNodes = [];
                    var translatedChildNodes = undefined;
                    // Extract:
                    // - top level nodes with the (implicit) "i18n" attribute if not already in a section
                    // - ICU messages
                    var i18nAttr = _getI18nAttr(el);
                    var i18nMeta = i18nAttr ? i18nAttr.value : '';
                    var isImplicit = this._implicitTags.some(function (tag) { return el.name === tag; }) && !this._inIcu &&
                        !this._isInTranslatableSection;
                    var isTopLevelImplicit = !wasInImplicitNode && isImplicit;
                    this._inImplicitNode = wasInImplicitNode || isImplicit;
                    if (!this._isInTranslatableSection && !this._inIcu) {
                        if (i18nAttr || isTopLevelImplicit) {
                            this._inI18nNode = true;
                            var message = this._addMessage(el.children, i18nMeta);
                            translatedChildNodes = this._translateMessage(el, message);
                        }
                        if (this._mode == _VisitorMode.Extract) {
                            var isTranslatable = i18nAttr || isTopLevelImplicit;
                            if (isTranslatable)
                                this._openTranslatableSection(el);
                            visitAll$1(this, el.children);
                            if (isTranslatable)
                                this._closeTranslatableSection(el, el.children);
                        }
                    }
                    else {
                        if (i18nAttr || isTopLevelImplicit) {
                            this._reportError(el, 'Could not mark an element as translatable inside a translatable section');
                        }
                        if (this._mode == _VisitorMode.Extract) {
                            // Descend into child nodes for extraction
                            visitAll$1(this, el.children);
                        }
                    }
                    if (this._mode === _VisitorMode.Merge) {
                        var visitNodes = translatedChildNodes || el.children;
                        visitNodes.forEach(function (child) {
                            var visited = child.visit(_this, context);
                            if (visited && !_this._isInTranslatableSection) {
                                // Do not add the children from translatable sections (= i18n blocks here)
                                // They will be added later in this loop when the block closes (i.e. on `<!-- /i18n -->`)
                                childNodes = childNodes.concat(visited);
                            }
                        });
                    }
                    this._visitAttributesOf(el);
                    this._depth--;
                    this._inI18nNode = wasInI18nNode;
                    this._inImplicitNode = wasInImplicitNode;
                    if (this._mode === _VisitorMode.Merge) {
                        var translatedAttrs = this._translateAttributes(el);
                        return new Element$1(el.name, translatedAttrs, childNodes, el.sourceSpan, el.startSourceSpan, el.endSourceSpan);
                    }
                    return null;
                };
                _Visitor$2.prototype.visitAttribute = function (attribute, context) {
                    throw new Error('unreachable code');
                };
                _Visitor$2.prototype._init = function (mode, interpolationConfig) {
                    this._mode = mode;
                    this._inI18nBlock = false;
                    this._inI18nNode = false;
                    this._depth = 0;
                    this._inIcu = false;
                    this._msgCountAtSectionStart = undefined;
                    this._errors = [];
                    this._messages = [];
                    this._inImplicitNode = false;
                    this._createI18nMessage = createI18nMessageFactory(interpolationConfig);
                };
                // looks for translatable attributes
                _Visitor$2.prototype._visitAttributesOf = function (el) {
                    var _this = this;
                    var explicitAttrNameToValue = {};
                    var implicitAttrNames = this._implicitAttrs[el.name] || [];
                    el.attrs.filter(function (attr) { return attr.name.startsWith(_I18N_ATTR_PREFIX); })
                        .forEach(function (attr) { return explicitAttrNameToValue[attr.name.slice(_I18N_ATTR_PREFIX.length)] =
                        attr.value; });
                    el.attrs.forEach(function (attr) {
                        if (attr.name in explicitAttrNameToValue) {
                            _this._addMessage([attr], explicitAttrNameToValue[attr.name]);
                        }
                        else if (implicitAttrNames.some(function (name) { return attr.name === name; })) {
                            _this._addMessage([attr]);
                        }
                    });
                };
                // add a translatable message
                _Visitor$2.prototype._addMessage = function (ast, msgMeta) {
                    if (ast.length == 0 ||
                        ast.length == 1 && ast[0] instanceof Attribute && !ast[0].value) {
                        // Do not create empty messages
                        return null;
                    }
                    var _c = _parseMessageMeta(msgMeta), meaning = _c.meaning, description = _c.description, id = _c.id;
                    var message = this._createI18nMessage(ast, meaning, description, id);
                    this._messages.push(message);
                    return message;
                };
                // Translates the given message given the `TranslationBundle`
                // This is used for translating elements / blocks - see `_translateAttributes` for attributes
                // no-op when called in extraction mode (returns [])
                _Visitor$2.prototype._translateMessage = function (el, message) {
                    if (message && this._mode === _VisitorMode.Merge) {
                        var nodes = this._translations.get(message);
                        if (nodes) {
                            return nodes;
                        }
                        this._reportError(el, "Translation unavailable for message id=\"" + this._translations.digest(message) + "\"");
                    }
                    return [];
                };
                // translate the attributes of an element and remove i18n specific attributes
                _Visitor$2.prototype._translateAttributes = function (el) {
                    var _this = this;
                    var attributes = el.attrs;
                    var i18nParsedMessageMeta = {};
                    attributes.forEach(function (attr) {
                        if (attr.name.startsWith(_I18N_ATTR_PREFIX)) {
                            i18nParsedMessageMeta[attr.name.slice(_I18N_ATTR_PREFIX.length)] =
                                _parseMessageMeta(attr.value);
                        }
                    });
                    var translatedAttributes = [];
                    attributes.forEach(function (attr) {
                        if (attr.name === _I18N_ATTR || attr.name.startsWith(_I18N_ATTR_PREFIX)) {
                            // strip i18n specific attributes
                            return;
                        }
                        if (attr.value && attr.value != '' && i18nParsedMessageMeta.hasOwnProperty(attr.name)) {
                            var _c = i18nParsedMessageMeta[attr.name], meaning = _c.meaning, description = _c.description, id = _c.id;
                            var message = _this._createI18nMessage([attr], meaning, description, id);
                            var nodes = _this._translations.get(message);
                            if (nodes) {
                                if (nodes.length == 0) {
                                    translatedAttributes.push(new Attribute(attr.name, '', attr.sourceSpan));
                                }
                                else if (nodes[0] instanceof Text$3) {
                                    var value = nodes[0].value;
                                    translatedAttributes.push(new Attribute(attr.name, value, attr.sourceSpan));
                                }
                                else {
                                    _this._reportError(el, "Unexpected translation for attribute \"" + attr.name + "\" (id=\"" + (id || _this._translations.digest(message)) + "\")");
                                }
                            }
                            else {
                                _this._reportError(el, "Translation unavailable for attribute \"" + attr.name + "\" (id=\"" + (id || _this._translations.digest(message)) + "\")");
                            }
                        }
                        else {
                            translatedAttributes.push(attr);
                        }
                    });
                    return translatedAttributes;
                };
                /**
                 * Add the node as a child of the block when:
                 * - we are in a block,
                 * - we are not inside a ICU message (those are handled separately),
                 * - the node is a "direct child" of the block
                 */
                _Visitor$2.prototype._mayBeAddBlockChildren = function (node) {
                    if (this._inI18nBlock && !this._inIcu && this._depth == this._blockStartDepth) {
                        this._blockChildren.push(node);
                    }
                };
                /**
                 * Marks the start of a section, see `_closeTranslatableSection`
                 */
                _Visitor$2.prototype._openTranslatableSection = function (node) {
                    if (this._isInTranslatableSection) {
                        this._reportError(node, 'Unexpected section start');
                    }
                    else {
                        this._msgCountAtSectionStart = this._messages.length;
                    }
                };
                Object.defineProperty(_Visitor$2.prototype, "_isInTranslatableSection", {
                    /**
                     * A translatable section could be:
                     * - the content of translatable element,
                     * - nodes between `<!-- i18n -->` and `<!-- /i18n -->` comments
                     */
                    get: function () {
                        return this._msgCountAtSectionStart !== void 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Terminates a section.
                 *
                 * If a section has only one significant children (comments not significant) then we should not
                 * keep the message from this children:
                 *
                 * `<p i18n="meaning|description">{ICU message}</p>` would produce two messages:
                 * - one for the <p> content with meaning and description,
                 * - another one for the ICU message.
                 *
                 * In this case the last message is discarded as it contains less information (the AST is
                 * otherwise identical).
                 *
                 * Note that we should still keep messages extracted from attributes inside the section (ie in the
                 * ICU message here)
                 */
                _Visitor$2.prototype._closeTranslatableSection = function (node, directChildren) {
                    if (!this._isInTranslatableSection) {
                        this._reportError(node, 'Unexpected section end');
                        return;
                    }
                    var startIndex = this._msgCountAtSectionStart;
                    var significantChildren = directChildren.reduce(function (count, node) { return count + (node instanceof Comment ? 0 : 1); }, 0);
                    if (significantChildren == 1) {
                        for (var i = this._messages.length - 1; i >= startIndex; i--) {
                            var ast = this._messages[i].nodes;
                            if (!(ast.length == 1 && ast[0] instanceof Text$1)) {
                                this._messages.splice(i, 1);
                                break;
                            }
                        }
                    }
                    this._msgCountAtSectionStart = undefined;
                };
                _Visitor$2.prototype._reportError = function (node, msg) {
                    this._errors.push(new I18nError(node.sourceSpan, msg));
                };
                return _Visitor$2;
            }());
            function _isOpeningComment(n) {
                return !!(n instanceof Comment && n.value && n.value.startsWith('i18n'));
            }
            function _isClosingComment(n) {
                return !!(n instanceof Comment && n.value && n.value === '/i18n');
            }
            function _getI18nAttr(p) {
                return p.attrs.find(function (attr) { return attr.name === _I18N_ATTR; }) || null;
            }
            function _parseMessageMeta(i18n) {
                if (!i18n)
                    return { meaning: '', description: '', id: '' };
                var idIndex = i18n.indexOf(ID_SEPARATOR);
                var descIndex = i18n.indexOf(MEANING_SEPARATOR);
                var _c = (idIndex > -1) ? [i18n.slice(0, idIndex), i18n.slice(idIndex + 2)] : [i18n, ''], meaningAndDesc = _c[0], id = _c[1];
                var _d = (descIndex > -1) ?
                    [meaningAndDesc.slice(0, descIndex), meaningAndDesc.slice(descIndex + 1)] :
                    ['', meaningAndDesc], meaning = _d[0], description = _d[1];
                return { meaning: meaning, description: description, id: id };
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var XmlTagDefinition = /** @class */ (function () {
                function XmlTagDefinition() {
                    this.closedByParent = false;
                    this.contentType = TagContentType.PARSABLE_DATA;
                    this.isVoid = false;
                    this.ignoreFirstLf = false;
                    this.canSelfClose = true;
                }
                XmlTagDefinition.prototype.requireExtraParent = function (currentParent) { return false; };
                XmlTagDefinition.prototype.isClosedByChild = function (name) { return false; };
                return XmlTagDefinition;
            }());
            var _TAG_DEFINITION = new XmlTagDefinition();
            function getXmlTagDefinition(tagName) {
                return _TAG_DEFINITION;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var XmlParser = /** @class */ (function (_super_1) {
                __extends(XmlParser, _super_1);
                function XmlParser() {
                    return _super_1.call(this, getXmlTagDefinition) || this;
                }
                XmlParser.prototype.parse = function (source, url, options) {
                    return _super_1.prototype.parse.call(this, source, url, options);
                };
                return XmlParser;
            }(Parser));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _VERSION = '1.2';
            var _XMLNS = 'urn:oasis:names:tc:xliff:document:1.2';
            // TODO(vicb): make this a param (s/_/-/)
            var _DEFAULT_SOURCE_LANG = 'en';
            var _PLACEHOLDER_TAG$1 = 'x';
            var _MARKER_TAG = 'mrk';
            var _FILE_TAG = 'file';
            var _SOURCE_TAG$1 = 'source';
            var _SEGMENT_SOURCE_TAG = 'seg-source';
            var _ALT_TRANS_TAG = 'alt-trans';
            var _TARGET_TAG = 'target';
            var _UNIT_TAG = 'trans-unit';
            var _CONTEXT_GROUP_TAG = 'context-group';
            var _CONTEXT_TAG = 'context';
            // http://docs.oasis-open.org/xliff/v1.2/os/xliff-core.html
            // http://docs.oasis-open.org/xliff/v1.2/xliff-profile-html/xliff-profile-html-1.2.html
            var Xliff = /** @class */ (function (_super_1) {
                __extends(Xliff, _super_1);
                function Xliff() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                Xliff.prototype.write = function (messages, locale) {
                    var visitor = new _WriteVisitor();
                    var transUnits = [];
                    messages.forEach(function (message) {
                        var _c;
                        var contextTags = [];
                        message.sources.forEach(function (source) {
                            var contextGroupTag = new Tag(_CONTEXT_GROUP_TAG, { purpose: 'location' });
                            contextGroupTag.children.push(new CR(10), new Tag(_CONTEXT_TAG, { 'context-type': 'sourcefile' }, [new Text$2(source.filePath)]), new CR(10), new Tag(_CONTEXT_TAG, { 'context-type': 'linenumber' }, [new Text$2("" + source.startLine)]), new CR(8));
                            contextTags.push(new CR(8), contextGroupTag);
                        });
                        var transUnit = new Tag(_UNIT_TAG, { id: message.id, datatype: 'html' });
                        (_c = transUnit.children).push.apply(_c, [new CR(8), new Tag(_SOURCE_TAG$1, {}, visitor.serialize(message.nodes))].concat(contextTags));
                        if (message.description) {
                            transUnit.children.push(new CR(8), new Tag('note', { priority: '1', from: 'description' }, [new Text$2(message.description)]));
                        }
                        if (message.meaning) {
                            transUnit.children.push(new CR(8), new Tag('note', { priority: '1', from: 'meaning' }, [new Text$2(message.meaning)]));
                        }
                        transUnit.children.push(new CR(6));
                        transUnits.push(new CR(6), transUnit);
                    });
                    var body = new Tag('body', {}, transUnits.concat([new CR(4)]));
                    var file = new Tag('file', {
                        'source-language': locale || _DEFAULT_SOURCE_LANG,
                        datatype: 'plaintext',
                        original: 'ng2.template',
                    }, [new CR(4), body, new CR(2)]);
                    var xliff = new Tag('xliff', { version: _VERSION, xmlns: _XMLNS }, [new CR(2), file, new CR()]);
                    return serialize([
                        new Declaration({ version: '1.0', encoding: 'UTF-8' }), new CR(), xliff, new CR()
                    ]);
                };
                Xliff.prototype.load = function (content, url) {
                    // xliff to xml nodes
                    var xliffParser = new XliffParser();
                    var _c = xliffParser.parse(content, url), locale = _c.locale, msgIdToHtml = _c.msgIdToHtml, errors = _c.errors;
                    // xml nodes to i18n nodes
                    var i18nNodesByMsgId = {};
                    var converter = new XmlToI18n();
                    Object.keys(msgIdToHtml).forEach(function (msgId) {
                        var _c = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _c.i18nNodes, e = _c.errors;
                        errors.push.apply(errors, e);
                        i18nNodesByMsgId[msgId] = i18nNodes;
                    });
                    if (errors.length) {
                        throw new Error("xliff parse errors:\n" + errors.join('\n'));
                    }
                    return { locale: locale, i18nNodesByMsgId: i18nNodesByMsgId };
                };
                Xliff.prototype.digest = function (message) { return digest(message); };
                return Xliff;
            }(Serializer));
            var _WriteVisitor = /** @class */ (function () {
                function _WriteVisitor() {
                }
                _WriteVisitor.prototype.visitText = function (text, context) { return [new Text$2(text.value)]; };
                _WriteVisitor.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    var nodes = [];
                    container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
                    return nodes;
                };
                _WriteVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
                    Object.keys(icu.cases).forEach(function (c) {
                        nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
                    });
                    nodes.push(new Text$2("}"));
                    return nodes;
                };
                _WriteVisitor.prototype.visitTagPlaceholder = function (ph, context) {
                    var ctype = getCtypeForTag(ph.tag);
                    if (ph.isVoid) {
                        // void tags have no children nor closing tags
                        return [new Tag(_PLACEHOLDER_TAG$1, { id: ph.startName, ctype: ctype, 'equiv-text': "<" + ph.tag + "/>" })];
                    }
                    var startTagPh = new Tag(_PLACEHOLDER_TAG$1, { id: ph.startName, ctype: ctype, 'equiv-text': "<" + ph.tag + ">" });
                    var closeTagPh = new Tag(_PLACEHOLDER_TAG$1, { id: ph.closeName, ctype: ctype, 'equiv-text': "</" + ph.tag + ">" });
                    return [startTagPh].concat(this.serialize(ph.children), [closeTagPh]);
                };
                _WriteVisitor.prototype.visitPlaceholder = function (ph, context) {
                    return [new Tag(_PLACEHOLDER_TAG$1, { id: ph.name, 'equiv-text': "{{" + ph.value + "}}" })];
                };
                _WriteVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
                    var equivText = "{" + ph.value.expression + ", " + ph.value.type + ", " + Object.keys(ph.value.cases).map(function (value) { return value + ' {...}'; }).join(' ') + "}";
                    return [new Tag(_PLACEHOLDER_TAG$1, { id: ph.name, 'equiv-text': equivText })];
                };
                _WriteVisitor.prototype.serialize = function (nodes) {
                    var _this = this;
                    return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
                };
                return _WriteVisitor;
            }());
            // TODO(vicb): add error management (structure)
            // Extract messages as xml nodes from the xliff file
            var XliffParser = /** @class */ (function () {
                function XliffParser() {
                    this._locale = null;
                }
                XliffParser.prototype.parse = function (xliff, url) {
                    this._unitMlString = null;
                    this._msgIdToHtml = {};
                    var xml = new XmlParser().parse(xliff, url);
                    this._errors = xml.errors;
                    visitAll$1(this, xml.rootNodes, null);
                    return {
                        msgIdToHtml: this._msgIdToHtml,
                        errors: this._errors,
                        locale: this._locale,
                    };
                };
                XliffParser.prototype.visitElement = function (element, context) {
                    switch (element.name) {
                        case _UNIT_TAG:
                            this._unitMlString = null;
                            var idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
                            if (!idAttr) {
                                this._addError(element, "<" + _UNIT_TAG + "> misses the \"id\" attribute");
                            }
                            else {
                                var id = idAttr.value;
                                if (this._msgIdToHtml.hasOwnProperty(id)) {
                                    this._addError(element, "Duplicated translations for msg " + id);
                                }
                                else {
                                    visitAll$1(this, element.children, null);
                                    if (typeof this._unitMlString === 'string') {
                                        this._msgIdToHtml[id] = this._unitMlString;
                                    }
                                    else {
                                        this._addError(element, "Message " + id + " misses a translation");
                                    }
                                }
                            }
                            break;
                        // ignore those tags
                        case _SOURCE_TAG$1:
                        case _SEGMENT_SOURCE_TAG:
                        case _ALT_TRANS_TAG:
                            break;
                        case _TARGET_TAG:
                            var innerTextStart = element.startSourceSpan.end.offset;
                            var innerTextEnd = element.endSourceSpan.start.offset;
                            var content = element.startSourceSpan.start.file.content;
                            var innerText = content.slice(innerTextStart, innerTextEnd);
                            this._unitMlString = innerText;
                            break;
                        case _FILE_TAG:
                            var localeAttr = element.attrs.find(function (attr) { return attr.name === 'target-language'; });
                            if (localeAttr) {
                                this._locale = localeAttr.value;
                            }
                            visitAll$1(this, element.children, null);
                            break;
                        default:
                            // TODO(vicb): assert file structure, xliff version
                            // For now only recurse on unhandled nodes
                            visitAll$1(this, element.children, null);
                    }
                };
                XliffParser.prototype.visitAttribute = function (attribute, context) { };
                XliffParser.prototype.visitText = function (text, context) { };
                XliffParser.prototype.visitComment = function (comment, context) { };
                XliffParser.prototype.visitExpansion = function (expansion, context) { };
                XliffParser.prototype.visitExpansionCase = function (expansionCase, context) { };
                XliffParser.prototype._addError = function (node, message) {
                    this._errors.push(new I18nError(node.sourceSpan, message));
                };
                return XliffParser;
            }());
            // Convert ml nodes (xliff syntax) to i18n nodes
            var XmlToI18n = /** @class */ (function () {
                function XmlToI18n() {
                }
                XmlToI18n.prototype.convert = function (message, url) {
                    var xmlIcu = new XmlParser().parse(message, url, { tokenizeExpansionForms: true });
                    this._errors = xmlIcu.errors;
                    var i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
                        [] : [].concat.apply([], visitAll$1(this, xmlIcu.rootNodes));
                    return {
                        i18nNodes: i18nNodes,
                        errors: this._errors,
                    };
                };
                XmlToI18n.prototype.visitText = function (text, context) { return new Text$1(text.value, text.sourceSpan); };
                XmlToI18n.prototype.visitElement = function (el, context) {
                    if (el.name === _PLACEHOLDER_TAG$1) {
                        var nameAttr = el.attrs.find(function (attr) { return attr.name === 'id'; });
                        if (nameAttr) {
                            return new Placeholder('', nameAttr.value, el.sourceSpan);
                        }
                        this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"id\" attribute");
                        return null;
                    }
                    if (el.name === _MARKER_TAG) {
                        return [].concat.apply([], visitAll$1(this, el.children));
                    }
                    this._addError(el, "Unexpected tag");
                    return null;
                };
                XmlToI18n.prototype.visitExpansion = function (icu, context) {
                    var caseMap = {};
                    visitAll$1(this, icu.cases).forEach(function (c) {
                        caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
                    });
                    return new Icu$1(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
                };
                XmlToI18n.prototype.visitExpansionCase = function (icuCase, context) {
                    return {
                        value: icuCase.value,
                        nodes: visitAll$1(this, icuCase.expression),
                    };
                };
                XmlToI18n.prototype.visitComment = function (comment, context) { };
                XmlToI18n.prototype.visitAttribute = function (attribute, context) { };
                XmlToI18n.prototype._addError = function (node, message) {
                    this._errors.push(new I18nError(node.sourceSpan, message));
                };
                return XmlToI18n;
            }());
            function getCtypeForTag(tag) {
                switch (tag.toLowerCase()) {
                    case 'br':
                        return 'lb';
                    case 'img':
                        return 'image';
                    default:
                        return "x-" + tag;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _VERSION$1 = '2.0';
            var _XMLNS$1 = 'urn:oasis:names:tc:xliff:document:2.0';
            // TODO(vicb): make this a param (s/_/-/)
            var _DEFAULT_SOURCE_LANG$1 = 'en';
            var _PLACEHOLDER_TAG$2 = 'ph';
            var _PLACEHOLDER_SPANNING_TAG = 'pc';
            var _MARKER_TAG$1 = 'mrk';
            var _XLIFF_TAG = 'xliff';
            var _SOURCE_TAG$2 = 'source';
            var _TARGET_TAG$1 = 'target';
            var _UNIT_TAG$1 = 'unit';
            // http://docs.oasis-open.org/xliff/xliff-core/v2.0/os/xliff-core-v2.0-os.html
            var Xliff2 = /** @class */ (function (_super_1) {
                __extends(Xliff2, _super_1);
                function Xliff2() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                Xliff2.prototype.write = function (messages, locale) {
                    var visitor = new _WriteVisitor$1();
                    var units = [];
                    messages.forEach(function (message) {
                        var unit = new Tag(_UNIT_TAG$1, { id: message.id });
                        var notes = new Tag('notes');
                        if (message.description || message.meaning) {
                            if (message.description) {
                                notes.children.push(new CR(8), new Tag('note', { category: 'description' }, [new Text$2(message.description)]));
                            }
                            if (message.meaning) {
                                notes.children.push(new CR(8), new Tag('note', { category: 'meaning' }, [new Text$2(message.meaning)]));
                            }
                        }
                        message.sources.forEach(function (source) {
                            notes.children.push(new CR(8), new Tag('note', { category: 'location' }, [
                                new Text$2(source.filePath + ":" + source.startLine + (source.endLine !== source.startLine ? ',' + source.endLine : ''))
                            ]));
                        });
                        notes.children.push(new CR(6));
                        unit.children.push(new CR(6), notes);
                        var segment = new Tag('segment');
                        segment.children.push(new CR(8), new Tag(_SOURCE_TAG$2, {}, visitor.serialize(message.nodes)), new CR(6));
                        unit.children.push(new CR(6), segment, new CR(4));
                        units.push(new CR(4), unit);
                    });
                    var file = new Tag('file', { 'original': 'ng.template', id: 'ngi18n' }, units.concat([new CR(2)]));
                    var xliff = new Tag(_XLIFF_TAG, { version: _VERSION$1, xmlns: _XMLNS$1, srcLang: locale || _DEFAULT_SOURCE_LANG$1 }, [new CR(2), file, new CR()]);
                    return serialize([
                        new Declaration({ version: '1.0', encoding: 'UTF-8' }), new CR(), xliff, new CR()
                    ]);
                };
                Xliff2.prototype.load = function (content, url) {
                    // xliff to xml nodes
                    var xliff2Parser = new Xliff2Parser();
                    var _c = xliff2Parser.parse(content, url), locale = _c.locale, msgIdToHtml = _c.msgIdToHtml, errors = _c.errors;
                    // xml nodes to i18n nodes
                    var i18nNodesByMsgId = {};
                    var converter = new XmlToI18n$1();
                    Object.keys(msgIdToHtml).forEach(function (msgId) {
                        var _c = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _c.i18nNodes, e = _c.errors;
                        errors.push.apply(errors, e);
                        i18nNodesByMsgId[msgId] = i18nNodes;
                    });
                    if (errors.length) {
                        throw new Error("xliff2 parse errors:\n" + errors.join('\n'));
                    }
                    return { locale: locale, i18nNodesByMsgId: i18nNodesByMsgId };
                };
                Xliff2.prototype.digest = function (message) { return decimalDigest(message); };
                return Xliff2;
            }(Serializer));
            var _WriteVisitor$1 = /** @class */ (function () {
                function _WriteVisitor$1() {
                }
                _WriteVisitor$1.prototype.visitText = function (text, context) { return [new Text$2(text.value)]; };
                _WriteVisitor$1.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    var nodes = [];
                    container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
                    return nodes;
                };
                _WriteVisitor$1.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
                    Object.keys(icu.cases).forEach(function (c) {
                        nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
                    });
                    nodes.push(new Text$2("}"));
                    return nodes;
                };
                _WriteVisitor$1.prototype.visitTagPlaceholder = function (ph, context) {
                    var _this = this;
                    var type = getTypeForTag(ph.tag);
                    if (ph.isVoid) {
                        var tagPh = new Tag(_PLACEHOLDER_TAG$2, {
                            id: (this._nextPlaceholderId++).toString(),
                            equiv: ph.startName,
                            type: type,
                            disp: "<" + ph.tag + "/>",
                        });
                        return [tagPh];
                    }
                    var tagPc = new Tag(_PLACEHOLDER_SPANNING_TAG, {
                        id: (this._nextPlaceholderId++).toString(),
                        equivStart: ph.startName,
                        equivEnd: ph.closeName,
                        type: type,
                        dispStart: "<" + ph.tag + ">",
                        dispEnd: "</" + ph.tag + ">",
                    });
                    var nodes = [].concat.apply([], ph.children.map(function (node) { return node.visit(_this); }));
                    if (nodes.length) {
                        nodes.forEach(function (node) { return tagPc.children.push(node); });
                    }
                    else {
                        tagPc.children.push(new Text$2(''));
                    }
                    return [tagPc];
                };
                _WriteVisitor$1.prototype.visitPlaceholder = function (ph, context) {
                    var idStr = (this._nextPlaceholderId++).toString();
                    return [new Tag(_PLACEHOLDER_TAG$2, {
                            id: idStr,
                            equiv: ph.name,
                            disp: "{{" + ph.value + "}}",
                        })];
                };
                _WriteVisitor$1.prototype.visitIcuPlaceholder = function (ph, context) {
                    var cases = Object.keys(ph.value.cases).map(function (value) { return value + ' {...}'; }).join(' ');
                    var idStr = (this._nextPlaceholderId++).toString();
                    return [new Tag(_PLACEHOLDER_TAG$2, { id: idStr, equiv: ph.name, disp: "{" + ph.value.expression + ", " + ph.value.type + ", " + cases + "}" })];
                };
                _WriteVisitor$1.prototype.serialize = function (nodes) {
                    var _this = this;
                    this._nextPlaceholderId = 0;
                    return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
                };
                return _WriteVisitor$1;
            }());
            // Extract messages as xml nodes from the xliff file
            var Xliff2Parser = /** @class */ (function () {
                function Xliff2Parser() {
                    this._locale = null;
                }
                Xliff2Parser.prototype.parse = function (xliff, url) {
                    this._unitMlString = null;
                    this._msgIdToHtml = {};
                    var xml = new XmlParser().parse(xliff, url);
                    this._errors = xml.errors;
                    visitAll$1(this, xml.rootNodes, null);
                    return {
                        msgIdToHtml: this._msgIdToHtml,
                        errors: this._errors,
                        locale: this._locale,
                    };
                };
                Xliff2Parser.prototype.visitElement = function (element, context) {
                    switch (element.name) {
                        case _UNIT_TAG$1:
                            this._unitMlString = null;
                            var idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
                            if (!idAttr) {
                                this._addError(element, "<" + _UNIT_TAG$1 + "> misses the \"id\" attribute");
                            }
                            else {
                                var id = idAttr.value;
                                if (this._msgIdToHtml.hasOwnProperty(id)) {
                                    this._addError(element, "Duplicated translations for msg " + id);
                                }
                                else {
                                    visitAll$1(this, element.children, null);
                                    if (typeof this._unitMlString === 'string') {
                                        this._msgIdToHtml[id] = this._unitMlString;
                                    }
                                    else {
                                        this._addError(element, "Message " + id + " misses a translation");
                                    }
                                }
                            }
                            break;
                        case _SOURCE_TAG$2:
                            // ignore source message
                            break;
                        case _TARGET_TAG$1:
                            var innerTextStart = element.startSourceSpan.end.offset;
                            var innerTextEnd = element.endSourceSpan.start.offset;
                            var content = element.startSourceSpan.start.file.content;
                            var innerText = content.slice(innerTextStart, innerTextEnd);
                            this._unitMlString = innerText;
                            break;
                        case _XLIFF_TAG:
                            var localeAttr = element.attrs.find(function (attr) { return attr.name === 'trgLang'; });
                            if (localeAttr) {
                                this._locale = localeAttr.value;
                            }
                            var versionAttr = element.attrs.find(function (attr) { return attr.name === 'version'; });
                            if (versionAttr) {
                                var version = versionAttr.value;
                                if (version !== '2.0') {
                                    this._addError(element, "The XLIFF file version " + version + " is not compatible with XLIFF 2.0 serializer");
                                }
                                else {
                                    visitAll$1(this, element.children, null);
                                }
                            }
                            break;
                        default:
                            visitAll$1(this, element.children, null);
                    }
                };
                Xliff2Parser.prototype.visitAttribute = function (attribute, context) { };
                Xliff2Parser.prototype.visitText = function (text, context) { };
                Xliff2Parser.prototype.visitComment = function (comment, context) { };
                Xliff2Parser.prototype.visitExpansion = function (expansion, context) { };
                Xliff2Parser.prototype.visitExpansionCase = function (expansionCase, context) { };
                Xliff2Parser.prototype._addError = function (node, message) {
                    this._errors.push(new I18nError(node.sourceSpan, message));
                };
                return Xliff2Parser;
            }());
            // Convert ml nodes (xliff syntax) to i18n nodes
            var XmlToI18n$1 = /** @class */ (function () {
                function XmlToI18n$1() {
                }
                XmlToI18n$1.prototype.convert = function (message, url) {
                    var xmlIcu = new XmlParser().parse(message, url, { tokenizeExpansionForms: true });
                    this._errors = xmlIcu.errors;
                    var i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
                        [] : [].concat.apply([], visitAll$1(this, xmlIcu.rootNodes));
                    return {
                        i18nNodes: i18nNodes,
                        errors: this._errors,
                    };
                };
                XmlToI18n$1.prototype.visitText = function (text, context) { return new Text$1(text.value, text.sourceSpan); };
                XmlToI18n$1.prototype.visitElement = function (el, context) {
                    var _this = this;
                    switch (el.name) {
                        case _PLACEHOLDER_TAG$2:
                            var nameAttr = el.attrs.find(function (attr) { return attr.name === 'equiv'; });
                            if (nameAttr) {
                                return [new Placeholder('', nameAttr.value, el.sourceSpan)];
                            }
                            this._addError(el, "<" + _PLACEHOLDER_TAG$2 + "> misses the \"equiv\" attribute");
                            break;
                        case _PLACEHOLDER_SPANNING_TAG:
                            var startAttr = el.attrs.find(function (attr) { return attr.name === 'equivStart'; });
                            var endAttr = el.attrs.find(function (attr) { return attr.name === 'equivEnd'; });
                            if (!startAttr) {
                                this._addError(el, "<" + _PLACEHOLDER_TAG$2 + "> misses the \"equivStart\" attribute");
                            }
                            else if (!endAttr) {
                                this._addError(el, "<" + _PLACEHOLDER_TAG$2 + "> misses the \"equivEnd\" attribute");
                            }
                            else {
                                var startId = startAttr.value;
                                var endId = endAttr.value;
                                var nodes = [];
                                return nodes.concat.apply(nodes, [new Placeholder('', startId, el.sourceSpan)].concat(el.children.map(function (node) { return node.visit(_this, null); }), [new Placeholder('', endId, el.sourceSpan)]));
                            }
                            break;
                        case _MARKER_TAG$1:
                            return [].concat.apply([], visitAll$1(this, el.children));
                        default:
                            this._addError(el, "Unexpected tag");
                    }
                    return null;
                };
                XmlToI18n$1.prototype.visitExpansion = function (icu, context) {
                    var caseMap = {};
                    visitAll$1(this, icu.cases).forEach(function (c) {
                        caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
                    });
                    return new Icu$1(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
                };
                XmlToI18n$1.prototype.visitExpansionCase = function (icuCase, context) {
                    return {
                        value: icuCase.value,
                        nodes: [].concat.apply([], visitAll$1(this, icuCase.expression)),
                    };
                };
                XmlToI18n$1.prototype.visitComment = function (comment, context) { };
                XmlToI18n$1.prototype.visitAttribute = function (attribute, context) { };
                XmlToI18n$1.prototype._addError = function (node, message) {
                    this._errors.push(new I18nError(node.sourceSpan, message));
                };
                return XmlToI18n$1;
            }());
            function getTypeForTag(tag) {
                switch (tag.toLowerCase()) {
                    case 'br':
                    case 'b':
                    case 'i':
                    case 'u':
                        return 'fmt';
                    case 'img':
                        return 'image';
                    case 'a':
                        return 'link';
                    default:
                        return 'other';
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _TRANSLATIONS_TAG = 'translationbundle';
            var _TRANSLATION_TAG = 'translation';
            var _PLACEHOLDER_TAG$3 = 'ph';
            var Xtb = /** @class */ (function (_super_1) {
                __extends(Xtb, _super_1);
                function Xtb() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                Xtb.prototype.write = function (messages, locale) { throw new Error('Unsupported'); };
                Xtb.prototype.load = function (content, url) {
                    // xtb to xml nodes
                    var xtbParser = new XtbParser();
                    var _c = xtbParser.parse(content, url), locale = _c.locale, msgIdToHtml = _c.msgIdToHtml, errors = _c.errors;
                    // xml nodes to i18n nodes
                    var i18nNodesByMsgId = {};
                    var converter = new XmlToI18n$2();
                    // Because we should be able to load xtb files that rely on features not supported by angular,
                    // we need to delay the conversion of html to i18n nodes so that non angular messages are not
                    // converted
                    Object.keys(msgIdToHtml).forEach(function (msgId) {
                        var valueFn = function () {
                            var _c = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _c.i18nNodes, errors = _c.errors;
                            if (errors.length) {
                                throw new Error("xtb parse errors:\n" + errors.join('\n'));
                            }
                            return i18nNodes;
                        };
                        createLazyProperty(i18nNodesByMsgId, msgId, valueFn);
                    });
                    if (errors.length) {
                        throw new Error("xtb parse errors:\n" + errors.join('\n'));
                    }
                    return { locale: locale, i18nNodesByMsgId: i18nNodesByMsgId };
                };
                Xtb.prototype.digest = function (message) { return digest$1(message); };
                Xtb.prototype.createNameMapper = function (message) {
                    return new SimplePlaceholderMapper(message, toPublicName);
                };
                return Xtb;
            }(Serializer));
            function createLazyProperty(messages, id, valueFn) {
                Object.defineProperty(messages, id, {
                    configurable: true,
                    enumerable: true,
                    get: function () {
                        var value = valueFn();
                        Object.defineProperty(messages, id, { enumerable: true, value: value });
                        return value;
                    },
                    set: function (_) { throw new Error('Could not overwrite an XTB translation'); },
                });
            }
            // Extract messages as xml nodes from the xtb file
            var XtbParser = /** @class */ (function () {
                function XtbParser() {
                    this._locale = null;
                }
                XtbParser.prototype.parse = function (xtb, url) {
                    this._bundleDepth = 0;
                    this._msgIdToHtml = {};
                    // We can not parse the ICU messages at this point as some messages might not originate
                    // from Angular that could not be lex'd.
                    var xml = new XmlParser().parse(xtb, url);
                    this._errors = xml.errors;
                    visitAll$1(this, xml.rootNodes);
                    return {
                        msgIdToHtml: this._msgIdToHtml,
                        errors: this._errors,
                        locale: this._locale,
                    };
                };
                XtbParser.prototype.visitElement = function (element, context) {
                    switch (element.name) {
                        case _TRANSLATIONS_TAG:
                            this._bundleDepth++;
                            if (this._bundleDepth > 1) {
                                this._addError(element, "<" + _TRANSLATIONS_TAG + "> elements can not be nested");
                            }
                            var langAttr = element.attrs.find(function (attr) { return attr.name === 'lang'; });
                            if (langAttr) {
                                this._locale = langAttr.value;
                            }
                            visitAll$1(this, element.children, null);
                            this._bundleDepth--;
                            break;
                        case _TRANSLATION_TAG:
                            var idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
                            if (!idAttr) {
                                this._addError(element, "<" + _TRANSLATION_TAG + "> misses the \"id\" attribute");
                            }
                            else {
                                var id = idAttr.value;
                                if (this._msgIdToHtml.hasOwnProperty(id)) {
                                    this._addError(element, "Duplicated translations for msg " + id);
                                }
                                else {
                                    var innerTextStart = element.startSourceSpan.end.offset;
                                    var innerTextEnd = element.endSourceSpan.start.offset;
                                    var content = element.startSourceSpan.start.file.content;
                                    var innerText = content.slice(innerTextStart, innerTextEnd);
                                    this._msgIdToHtml[id] = innerText;
                                }
                            }
                            break;
                        default:
                            this._addError(element, 'Unexpected tag');
                    }
                };
                XtbParser.prototype.visitAttribute = function (attribute, context) { };
                XtbParser.prototype.visitText = function (text, context) { };
                XtbParser.prototype.visitComment = function (comment, context) { };
                XtbParser.prototype.visitExpansion = function (expansion, context) { };
                XtbParser.prototype.visitExpansionCase = function (expansionCase, context) { };
                XtbParser.prototype._addError = function (node, message) {
                    this._errors.push(new I18nError(node.sourceSpan, message));
                };
                return XtbParser;
            }());
            // Convert ml nodes (xtb syntax) to i18n nodes
            var XmlToI18n$2 = /** @class */ (function () {
                function XmlToI18n$2() {
                }
                XmlToI18n$2.prototype.convert = function (message, url) {
                    var xmlIcu = new XmlParser().parse(message, url, { tokenizeExpansionForms: true });
                    this._errors = xmlIcu.errors;
                    var i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
                        [] :
                        visitAll$1(this, xmlIcu.rootNodes);
                    return {
                        i18nNodes: i18nNodes,
                        errors: this._errors,
                    };
                };
                XmlToI18n$2.prototype.visitText = function (text, context) { return new Text$1(text.value, text.sourceSpan); };
                XmlToI18n$2.prototype.visitExpansion = function (icu, context) {
                    var caseMap = {};
                    visitAll$1(this, icu.cases).forEach(function (c) {
                        caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
                    });
                    return new Icu$1(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
                };
                XmlToI18n$2.prototype.visitExpansionCase = function (icuCase, context) {
                    return {
                        value: icuCase.value,
                        nodes: visitAll$1(this, icuCase.expression),
                    };
                };
                XmlToI18n$2.prototype.visitElement = function (el, context) {
                    if (el.name === _PLACEHOLDER_TAG$3) {
                        var nameAttr = el.attrs.find(function (attr) { return attr.name === 'name'; });
                        if (nameAttr) {
                            return new Placeholder('', nameAttr.value, el.sourceSpan);
                        }
                        this._addError(el, "<" + _PLACEHOLDER_TAG$3 + "> misses the \"name\" attribute");
                    }
                    else {
                        this._addError(el, "Unexpected tag");
                    }
                    return null;
                };
                XmlToI18n$2.prototype.visitComment = function (comment, context) { };
                XmlToI18n$2.prototype.visitAttribute = function (attribute, context) { };
                XmlToI18n$2.prototype._addError = function (node, message) {
                    this._errors.push(new I18nError(node.sourceSpan, message));
                };
                return XmlToI18n$2;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A container for translated messages
             */
            var TranslationBundle = /** @class */ (function () {
                function TranslationBundle(_i18nNodesByMsgId, locale, digest, mapperFactory, missingTranslationStrategy, console) {
                    if (_i18nNodesByMsgId === void 0) { _i18nNodesByMsgId = {}; }
                    if (missingTranslationStrategy === void 0) { missingTranslationStrategy = MissingTranslationStrategy.Warning; }
                    this._i18nNodesByMsgId = _i18nNodesByMsgId;
                    this.digest = digest;
                    this.mapperFactory = mapperFactory;
                    this._i18nToHtml = new I18nToHtmlVisitor(_i18nNodesByMsgId, locale, digest, mapperFactory, missingTranslationStrategy, console);
                }
                // Creates a `TranslationBundle` by parsing the given `content` with the `serializer`.
                TranslationBundle.load = function (content, url, serializer, missingTranslationStrategy, console) {
                    var _c = serializer.load(content, url), locale = _c.locale, i18nNodesByMsgId = _c.i18nNodesByMsgId;
                    var digestFn = function (m) { return serializer.digest(m); };
                    var mapperFactory = function (m) { return serializer.createNameMapper(m); };
                    return new TranslationBundle(i18nNodesByMsgId, locale, digestFn, mapperFactory, missingTranslationStrategy, console);
                };
                // Returns the translation as HTML nodes from the given source message.
                TranslationBundle.prototype.get = function (srcMsg) {
                    var html = this._i18nToHtml.convert(srcMsg);
                    if (html.errors.length) {
                        throw new Error(html.errors.join('\n'));
                    }
                    return html.nodes;
                };
                TranslationBundle.prototype.has = function (srcMsg) { return this.digest(srcMsg) in this._i18nNodesByMsgId; };
                return TranslationBundle;
            }());
            var I18nToHtmlVisitor = /** @class */ (function () {
                function I18nToHtmlVisitor(_i18nNodesByMsgId, _locale, _digest, _mapperFactory, _missingTranslationStrategy, _console) {
                    if (_i18nNodesByMsgId === void 0) { _i18nNodesByMsgId = {}; }
                    this._i18nNodesByMsgId = _i18nNodesByMsgId;
                    this._locale = _locale;
                    this._digest = _digest;
                    this._mapperFactory = _mapperFactory;
                    this._missingTranslationStrategy = _missingTranslationStrategy;
                    this._console = _console;
                    this._contextStack = [];
                    this._errors = [];
                }
                I18nToHtmlVisitor.prototype.convert = function (srcMsg) {
                    this._contextStack.length = 0;
                    this._errors.length = 0;
                    // i18n to text
                    var text = this._convertToText(srcMsg);
                    // text to html
                    var url = srcMsg.nodes[0].sourceSpan.start.file.url;
                    var html = new HtmlParser().parse(text, url, { tokenizeExpansionForms: true });
                    return {
                        nodes: html.rootNodes,
                        errors: this._errors.concat(html.errors),
                    };
                };
                I18nToHtmlVisitor.prototype.visitText = function (text, context) {
                    // `convert()` uses an `HtmlParser` to return `html.Node`s
                    // we should then make sure that any special characters are escaped
                    return escapeXml(text.value);
                };
                I18nToHtmlVisitor.prototype.visitContainer = function (container, context) {
                    var _this = this;
                    return container.children.map(function (n) { return n.visit(_this); }).join('');
                };
                I18nToHtmlVisitor.prototype.visitIcu = function (icu, context) {
                    var _this = this;
                    var cases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
                    // TODO(vicb): Once all format switch to using expression placeholders
                    // we should throw when the placeholder is not in the source message
                    var exp = this._srcMsg.placeholders.hasOwnProperty(icu.expression) ?
                        this._srcMsg.placeholders[icu.expression] :
                        icu.expression;
                    return "{" + exp + ", " + icu.type + ", " + cases.join(' ') + "}";
                };
                I18nToHtmlVisitor.prototype.visitPlaceholder = function (ph, context) {
                    var phName = this._mapper(ph.name);
                    if (this._srcMsg.placeholders.hasOwnProperty(phName)) {
                        return this._srcMsg.placeholders[phName];
                    }
                    if (this._srcMsg.placeholderToMessage.hasOwnProperty(phName)) {
                        return this._convertToText(this._srcMsg.placeholderToMessage[phName]);
                    }
                    this._addError(ph, "Unknown placeholder \"" + ph.name + "\"");
                    return '';
                };
                // Loaded message contains only placeholders (vs tag and icu placeholders).
                // However when a translation can not be found, we need to serialize the source message
                // which can contain tag placeholders
                I18nToHtmlVisitor.prototype.visitTagPlaceholder = function (ph, context) {
                    var _this = this;
                    var tag = "" + ph.tag;
                    var attrs = Object.keys(ph.attrs).map(function (name) { return name + "=\"" + ph.attrs[name] + "\""; }).join(' ');
                    if (ph.isVoid) {
                        return "<" + tag + " " + attrs + "/>";
                    }
                    var children = ph.children.map(function (c) { return c.visit(_this); }).join('');
                    return "<" + tag + " " + attrs + ">" + children + "</" + tag + ">";
                };
                // Loaded message contains only placeholders (vs tag and icu placeholders).
                // However when a translation can not be found, we need to serialize the source message
                // which can contain tag placeholders
                I18nToHtmlVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
                    // An ICU placeholder references the source message to be serialized
                    return this._convertToText(this._srcMsg.placeholderToMessage[ph.name]);
                };
                /**
                 * Convert a source message to a translated text string:
                 * - text nodes are replaced with their translation,
                 * - placeholders are replaced with their content,
                 * - ICU nodes are converted to ICU expressions.
                 */
                I18nToHtmlVisitor.prototype._convertToText = function (srcMsg) {
                    var _this = this;
                    var id = this._digest(srcMsg);
                    var mapper = this._mapperFactory ? this._mapperFactory(srcMsg) : null;
                    var nodes;
                    this._contextStack.push({ msg: this._srcMsg, mapper: this._mapper });
                    this._srcMsg = srcMsg;
                    if (this._i18nNodesByMsgId.hasOwnProperty(id)) {
                        // When there is a translation use its nodes as the source
                        // And create a mapper to convert serialized placeholder names to internal names
                        nodes = this._i18nNodesByMsgId[id];
                        this._mapper = function (name) { return mapper ? mapper.toInternalName(name) : name; };
                    }
                    else {
                        // When no translation has been found
                        // - report an error / a warning / nothing,
                        // - use the nodes from the original message
                        // - placeholders are already internal and need no mapper
                        if (this._missingTranslationStrategy === MissingTranslationStrategy.Error) {
                            var ctx = this._locale ? " for locale \"" + this._locale + "\"" : '';
                            this._addError(srcMsg.nodes[0], "Missing translation for message \"" + id + "\"" + ctx);
                        }
                        else if (this._console &&
                            this._missingTranslationStrategy === MissingTranslationStrategy.Warning) {
                            var ctx = this._locale ? " for locale \"" + this._locale + "\"" : '';
                            this._console.warn("Missing translation for message \"" + id + "\"" + ctx);
                        }
                        nodes = srcMsg.nodes;
                        this._mapper = function (name) { return name; };
                    }
                    var text = nodes.map(function (node) { return node.visit(_this); }).join('');
                    var context = this._contextStack.pop();
                    this._srcMsg = context.msg;
                    this._mapper = context.mapper;
                    return text;
                };
                I18nToHtmlVisitor.prototype._addError = function (el, msg) {
                    this._errors.push(new I18nError(el.sourceSpan, msg));
                };
                return I18nToHtmlVisitor;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var I18NHtmlParser = /** @class */ (function () {
                function I18NHtmlParser(_htmlParser, translations, translationsFormat, missingTranslation, console) {
                    if (missingTranslation === void 0) { missingTranslation = MissingTranslationStrategy.Warning; }
                    this._htmlParser = _htmlParser;
                    if (translations) {
                        var serializer = createSerializer(translationsFormat);
                        this._translationBundle =
                            TranslationBundle.load(translations, 'i18n', serializer, missingTranslation, console);
                    }
                    else {
                        this._translationBundle =
                            new TranslationBundle({}, null, digest, undefined, missingTranslation, console);
                    }
                }
                I18NHtmlParser.prototype.parse = function (source, url, options) {
                    if (options === void 0) { options = {}; }
                    var interpolationConfig = options.interpolationConfig || DEFAULT_INTERPOLATION_CONFIG;
                    var parseResult = this._htmlParser.parse(source, url, Object.assign({ interpolationConfig: interpolationConfig }, options));
                    if (parseResult.errors.length) {
                        return new ParseTreeResult(parseResult.rootNodes, parseResult.errors);
                    }
                    return mergeTranslations(parseResult.rootNodes, this._translationBundle, interpolationConfig, [], {});
                };
                return I18NHtmlParser;
            }());
            function createSerializer(format) {
                format = (format || 'xlf').toLowerCase();
                switch (format) {
                    case 'xmb':
                        return new Xmb();
                    case 'xtb':
                        return new Xtb();
                    case 'xliff2':
                    case 'xlf2':
                        return new Xliff2();
                    case 'xliff':
                    case 'xlf':
                    default:
                        return new Xliff();
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var QUOTED_KEYS = '$quoted$';
            function convertValueToOutputAst(ctx, value, type) {
                if (type === void 0) { type = null; }
                return visitValue(value, new _ValueOutputAstTransformer(ctx), type);
            }
            var _ValueOutputAstTransformer = /** @class */ (function () {
                function _ValueOutputAstTransformer(ctx) {
                    this.ctx = ctx;
                }
                _ValueOutputAstTransformer.prototype.visitArray = function (arr, type) {
                    var _this = this;
                    return literalArr(arr.map(function (value) { return visitValue(value, _this, null); }), type);
                };
                _ValueOutputAstTransformer.prototype.visitStringMap = function (map, type) {
                    var _this = this;
                    var entries = [];
                    var quotedSet = new Set(map && map[QUOTED_KEYS]);
                    Object.keys(map).forEach(function (key) {
                        entries.push(new LiteralMapEntry(key, visitValue(map[key], _this, null), quotedSet.has(key)));
                    });
                    return new LiteralMapExpr(entries, type);
                };
                _ValueOutputAstTransformer.prototype.visitPrimitive = function (value, type) { return literal(value, type); };
                _ValueOutputAstTransformer.prototype.visitOther = function (value, type) {
                    if (value instanceof Expression) {
                        return value;
                    }
                    else {
                        return this.ctx.importExpr(value);
                    }
                };
                return _ValueOutputAstTransformer;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function mapEntry$1(key, value) {
                return { key: key, value: value, quoted: false };
            }
            var InjectableCompiler = /** @class */ (function () {
                function InjectableCompiler(reflector, alwaysGenerateDef) {
                    this.reflector = reflector;
                    this.alwaysGenerateDef = alwaysGenerateDef;
                    this.tokenInjector = reflector.resolveExternalReference(Identifiers.Injector);
                }
                InjectableCompiler.prototype.depsArray = function (deps, ctx) {
                    var _this = this;
                    return deps.map(function (dep) {
                        var token = dep;
                        var args = [token];
                        var flags = 0 /* Default */;
                        if (Array.isArray(dep)) {
                            for (var i = 0; i < dep.length; i++) {
                                var v = dep[i];
                                if (v) {
                                    if (v.ngMetadataName === 'Optional') {
                                        flags |= 8 /* Optional */;
                                    }
                                    else if (v.ngMetadataName === 'SkipSelf') {
                                        flags |= 4 /* SkipSelf */;
                                    }
                                    else if (v.ngMetadataName === 'Self') {
                                        flags |= 2 /* Self */;
                                    }
                                    else if (v.ngMetadataName === 'Inject') {
                                        token = v.token;
                                    }
                                    else {
                                        token = v;
                                    }
                                }
                            }
                        }
                        var tokenExpr;
                        if (typeof token === 'string') {
                            tokenExpr = literal(token);
                        }
                        else if (token === _this.tokenInjector) {
                            tokenExpr = importExpr(Identifiers.INJECTOR);
                        }
                        else {
                            tokenExpr = ctx.importExpr(token);
                        }
                        if (flags !== 0 /* Default */) {
                            args = [tokenExpr, literal(flags)];
                        }
                        else {
                            args = [tokenExpr];
                        }
                        return importExpr(Identifiers.inject).callFn(args);
                    });
                };
                InjectableCompiler.prototype.factoryFor = function (injectable, ctx) {
                    var retValue;
                    if (injectable.useExisting) {
                        retValue = importExpr(Identifiers.inject).callFn([ctx.importExpr(injectable.useExisting)]);
                    }
                    else if (injectable.useFactory) {
                        var deps = injectable.deps || [];
                        if (deps.length > 0) {
                            retValue = ctx.importExpr(injectable.useFactory).callFn(this.depsArray(deps, ctx));
                        }
                        else {
                            return ctx.importExpr(injectable.useFactory);
                        }
                    }
                    else if (injectable.useValue) {
                        retValue = convertValueToOutputAst(ctx, injectable.useValue);
                    }
                    else {
                        var clazz = injectable.useClass || injectable.symbol;
                        var depArgs = this.depsArray(this.reflector.parameters(clazz), ctx);
                        retValue = new InstantiateExpr(ctx.importExpr(clazz), depArgs);
                    }
                    return fn([], [new ReturnStatement(retValue)], undefined, undefined, injectable.symbol.name + '_Factory');
                };
                InjectableCompiler.prototype.injectableDef = function (injectable, ctx) {
                    var providedIn = NULL_EXPR;
                    if (injectable.providedIn !== undefined) {
                        if (injectable.providedIn === null) {
                            providedIn = NULL_EXPR;
                        }
                        else if (typeof injectable.providedIn === 'string') {
                            providedIn = literal(injectable.providedIn);
                        }
                        else {
                            providedIn = ctx.importExpr(injectable.providedIn);
                        }
                    }
                    var def = [
                        mapEntry$1('factory', this.factoryFor(injectable, ctx)),
                        mapEntry$1('token', ctx.importExpr(injectable.type.reference)),
                        mapEntry$1('providedIn', providedIn),
                    ];
                    return importExpr(Identifiers.ɵɵdefineInjectable).callFn([literalMap(def)]);
                };
                InjectableCompiler.prototype.compile = function (injectable, ctx) {
                    if (this.alwaysGenerateDef || injectable.providedIn !== undefined) {
                        var className = identifierName(injectable.type);
                        var clazz = new ClassStmt(className, null, [
                            new ClassField('ngInjectableDef', INFERRED_TYPE, [StmtModifier.Static], this.injectableDef(injectable, ctx)),
                        ], [], new ClassMethod(null, [], []), []);
                        ctx.statements.push(clazz);
                    }
                };
                return InjectableCompiler;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var STRIP_SRC_FILE_SUFFIXES = /(\.ts|\.d\.ts|\.js|\.jsx|\.tsx)$/;
            var GENERATED_FILE = /\.ngfactory\.|\.ngsummary\./;
            var JIT_SUMMARY_FILE = /\.ngsummary\./;
            var JIT_SUMMARY_NAME = /NgSummary$/;
            function ngfactoryFilePath(filePath, forceSourceFile) {
                if (forceSourceFile === void 0) { forceSourceFile = false; }
                var urlWithSuffix = splitTypescriptSuffix(filePath, forceSourceFile);
                return urlWithSuffix[0] + ".ngfactory" + normalizeGenFileSuffix(urlWithSuffix[1]);
            }
            function stripGeneratedFileSuffix(filePath) {
                return filePath.replace(GENERATED_FILE, '.');
            }
            function isGeneratedFile(filePath) {
                return GENERATED_FILE.test(filePath);
            }
            function splitTypescriptSuffix(path, forceSourceFile) {
                if (forceSourceFile === void 0) { forceSourceFile = false; }
                if (path.endsWith('.d.ts')) {
                    return [path.slice(0, -5), forceSourceFile ? '.ts' : '.d.ts'];
                }
                var lastDot = path.lastIndexOf('.');
                if (lastDot !== -1) {
                    return [path.substring(0, lastDot), path.substring(lastDot)];
                }
                return [path, ''];
            }
            function normalizeGenFileSuffix(srcFileSuffix) {
                return srcFileSuffix === '.tsx' ? '.ts' : srcFileSuffix;
            }
            function summaryFileName(fileName) {
                var fileNameWithoutSuffix = fileName.replace(STRIP_SRC_FILE_SUFFIXES, '');
                return fileNameWithoutSuffix + ".ngsummary.json";
            }
            function summaryForJitFileName(fileName, forceSourceFile) {
                if (forceSourceFile === void 0) { forceSourceFile = false; }
                var urlWithSuffix = splitTypescriptSuffix(stripGeneratedFileSuffix(fileName), forceSourceFile);
                return urlWithSuffix[0] + ".ngsummary" + urlWithSuffix[1];
            }
            function stripSummaryForJitFileSuffix(filePath) {
                return filePath.replace(JIT_SUMMARY_FILE, '.');
            }
            function summaryForJitName(symbolName) {
                return symbolName + "NgSummary";
            }
            function stripSummaryForJitNameSuffix(symbolName) {
                return symbolName.replace(JIT_SUMMARY_NAME, '');
            }
            var LOWERED_SYMBOL = /\u0275\d+/;
            function isLoweredSymbol(name) {
                return LOWERED_SYMBOL.test(name);
            }
            function createLoweredSymbol(id) {
                return "\u0275" + id;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var LifecycleHooks;
            (function (LifecycleHooks) {
                LifecycleHooks[LifecycleHooks["OnInit"] = 0] = "OnInit";
                LifecycleHooks[LifecycleHooks["OnDestroy"] = 1] = "OnDestroy";
                LifecycleHooks[LifecycleHooks["DoCheck"] = 2] = "DoCheck";
                LifecycleHooks[LifecycleHooks["OnChanges"] = 3] = "OnChanges";
                LifecycleHooks[LifecycleHooks["AfterContentInit"] = 4] = "AfterContentInit";
                LifecycleHooks[LifecycleHooks["AfterContentChecked"] = 5] = "AfterContentChecked";
                LifecycleHooks[LifecycleHooks["AfterViewInit"] = 6] = "AfterViewInit";
                LifecycleHooks[LifecycleHooks["AfterViewChecked"] = 7] = "AfterViewChecked";
            })(LifecycleHooks || (LifecycleHooks = {}));
            var LIFECYCLE_HOOKS_VALUES = [
                LifecycleHooks.OnInit, LifecycleHooks.OnDestroy, LifecycleHooks.DoCheck, LifecycleHooks.OnChanges,
                LifecycleHooks.AfterContentInit, LifecycleHooks.AfterContentChecked, LifecycleHooks.AfterViewInit,
                LifecycleHooks.AfterViewChecked
            ];
            function hasLifecycleHook(reflector, hook, token) {
                return reflector.hasLifecycleHook(token, getHookName(hook));
            }
            function getAllLifecycleHooks(reflector, token) {
                return LIFECYCLE_HOOKS_VALUES.filter(function (hook) { return hasLifecycleHook(reflector, hook, token); });
            }
            function getHookName(hook) {
                switch (hook) {
                    case LifecycleHooks.OnInit:
                        return 'ngOnInit';
                    case LifecycleHooks.OnDestroy:
                        return 'ngOnDestroy';
                    case LifecycleHooks.DoCheck:
                        return 'ngDoCheck';
                    case LifecycleHooks.OnChanges:
                        return 'ngOnChanges';
                    case LifecycleHooks.AfterContentInit:
                        return 'ngAfterContentInit';
                    case LifecycleHooks.AfterContentChecked:
                        return 'ngAfterContentChecked';
                    case LifecycleHooks.AfterViewInit:
                        return 'ngAfterViewInit';
                    case LifecycleHooks.AfterViewChecked:
                        return 'ngAfterViewChecked';
                    default:
                        // This default case is not needed by TypeScript compiler, as the switch is exhaustive.
                        // However Closure Compiler does not understand that and reports an error in typed mode.
                        // The `throw new Error` below works around the problem, and the unexpected: never variable
                        // makes sure tsc still checks this code is unreachable.
                        var unexpected = hook;
                        throw new Error("unexpected " + unexpected);
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ERROR_COMPONENT_TYPE = 'ngComponentType';
            // Design notes:
            // - don't lazily create metadata:
            //   For some metadata, we need to do async work sometimes,
            //   so the user has to kick off this loading.
            //   But we want to report errors even when the async work is
            //   not required to check that the user would have been able
            //   to wait correctly.
            var CompileMetadataResolver = /** @class */ (function () {
                function CompileMetadataResolver(_config, _htmlParser, _ngModuleResolver, _directiveResolver, _pipeResolver, _summaryResolver, _schemaRegistry, _directiveNormalizer, _console, _staticSymbolCache, _reflector, _errorCollector) {
                    this._config = _config;
                    this._htmlParser = _htmlParser;
                    this._ngModuleResolver = _ngModuleResolver;
                    this._directiveResolver = _directiveResolver;
                    this._pipeResolver = _pipeResolver;
                    this._summaryResolver = _summaryResolver;
                    this._schemaRegistry = _schemaRegistry;
                    this._directiveNormalizer = _directiveNormalizer;
                    this._console = _console;
                    this._staticSymbolCache = _staticSymbolCache;
                    this._reflector = _reflector;
                    this._errorCollector = _errorCollector;
                    this._nonNormalizedDirectiveCache = new Map();
                    this._directiveCache = new Map();
                    this._summaryCache = new Map();
                    this._pipeCache = new Map();
                    this._ngModuleCache = new Map();
                    this._ngModuleOfTypes = new Map();
                    this._shallowModuleCache = new Map();
                }
                CompileMetadataResolver.prototype.getReflector = function () { return this._reflector; };
                CompileMetadataResolver.prototype.clearCacheFor = function (type) {
                    var dirMeta = this._directiveCache.get(type);
                    this._directiveCache.delete(type);
                    this._nonNormalizedDirectiveCache.delete(type);
                    this._summaryCache.delete(type);
                    this._pipeCache.delete(type);
                    this._ngModuleOfTypes.delete(type);
                    // Clear all of the NgModule as they contain transitive information!
                    this._ngModuleCache.clear();
                    if (dirMeta) {
                        this._directiveNormalizer.clearCacheFor(dirMeta);
                    }
                };
                CompileMetadataResolver.prototype.clearCache = function () {
                    this._directiveCache.clear();
                    this._nonNormalizedDirectiveCache.clear();
                    this._summaryCache.clear();
                    this._pipeCache.clear();
                    this._ngModuleCache.clear();
                    this._ngModuleOfTypes.clear();
                    this._directiveNormalizer.clearCache();
                };
                CompileMetadataResolver.prototype._createProxyClass = function (baseType, name) {
                    var delegate = null;
                    var proxyClass = function () {
                        if (!delegate) {
                            throw new Error("Illegal state: Class " + name + " for type " + stringify(baseType) + " is not compiled yet!");
                        }
                        return delegate.apply(this, arguments);
                    };
                    proxyClass.setDelegate = function (d) {
                        delegate = d;
                        proxyClass.prototype = d.prototype;
                    };
                    // Make stringify work correctly
                    proxyClass.overriddenName = name;
                    return proxyClass;
                };
                CompileMetadataResolver.prototype.getGeneratedClass = function (dirType, name) {
                    if (dirType instanceof StaticSymbol) {
                        return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), name);
                    }
                    else {
                        return this._createProxyClass(dirType, name);
                    }
                };
                CompileMetadataResolver.prototype.getComponentViewClass = function (dirType) {
                    return this.getGeneratedClass(dirType, viewClassName(dirType, 0));
                };
                CompileMetadataResolver.prototype.getHostComponentViewClass = function (dirType) {
                    return this.getGeneratedClass(dirType, hostViewClassName(dirType));
                };
                CompileMetadataResolver.prototype.getHostComponentType = function (dirType) {
                    var name = identifierName({ reference: dirType }) + "_Host";
                    if (dirType instanceof StaticSymbol) {
                        return this._staticSymbolCache.get(dirType.filePath, name);
                    }
                    return this._createProxyClass(dirType, name);
                };
                CompileMetadataResolver.prototype.getRendererType = function (dirType) {
                    if (dirType instanceof StaticSymbol) {
                        return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), rendererTypeName(dirType));
                    }
                    else {
                        // returning an object as proxy,
                        // that we fill later during runtime compilation.
                        return {};
                    }
                };
                CompileMetadataResolver.prototype.getComponentFactory = function (selector, dirType, inputs, outputs) {
                    if (dirType instanceof StaticSymbol) {
                        return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), componentFactoryName(dirType));
                    }
                    else {
                        var hostView = this.getHostComponentViewClass(dirType);
                        // Note: ngContentSelectors will be filled later once the template is
                        // loaded.
                        var createComponentFactory = this._reflector.resolveExternalReference(Identifiers.createComponentFactory);
                        return createComponentFactory(selector, dirType, hostView, inputs, outputs, []);
                    }
                };
                CompileMetadataResolver.prototype.initComponentFactory = function (factory, ngContentSelectors) {
                    var _c;
                    if (!(factory instanceof StaticSymbol)) {
                        (_c = factory.ngContentSelectors).push.apply(_c, ngContentSelectors);
                    }
                };
                CompileMetadataResolver.prototype._loadSummary = function (type, kind) {
                    var typeSummary = this._summaryCache.get(type);
                    if (!typeSummary) {
                        var summary = this._summaryResolver.resolveSummary(type);
                        typeSummary = summary ? summary.type : null;
                        this._summaryCache.set(type, typeSummary || null);
                    }
                    return typeSummary && typeSummary.summaryKind === kind ? typeSummary : null;
                };
                CompileMetadataResolver.prototype.getHostComponentMetadata = function (compMeta, hostViewType) {
                    var hostType = this.getHostComponentType(compMeta.type.reference);
                    if (!hostViewType) {
                        hostViewType = this.getHostComponentViewClass(hostType);
                    }
                    // Note: ! is ok here as this method should only be called with normalized directive
                    // metadata, which always fills in the selector.
                    var template = CssSelector.parse(compMeta.selector)[0].getMatchingElementTemplate();
                    var templateUrl = '';
                    var htmlAst = this._htmlParser.parse(template, templateUrl);
                    return CompileDirectiveMetadata.create({
                        isHost: true,
                        type: { reference: hostType, diDeps: [], lifecycleHooks: [] },
                        template: new CompileTemplateMetadata({
                            encapsulation: ViewEncapsulation.None,
                            template: template,
                            templateUrl: templateUrl,
                            htmlAst: htmlAst,
                            styles: [],
                            styleUrls: [],
                            ngContentSelectors: [],
                            animations: [],
                            isInline: true,
                            externalStylesheets: [],
                            interpolation: null,
                            preserveWhitespaces: false,
                        }),
                        exportAs: null,
                        changeDetection: ChangeDetectionStrategy.Default,
                        inputs: [],
                        outputs: [],
                        host: {},
                        isComponent: true,
                        selector: '*',
                        providers: [],
                        viewProviders: [],
                        queries: [],
                        guards: {},
                        viewQueries: [],
                        componentViewType: hostViewType,
                        rendererType: { id: '__Host__', encapsulation: ViewEncapsulation.None, styles: [], data: {} },
                        entryComponents: [],
                        componentFactory: null
                    });
                };
                CompileMetadataResolver.prototype.loadDirectiveMetadata = function (ngModuleType, directiveType, isSync) {
                    var _this = this;
                    if (this._directiveCache.has(directiveType)) {
                        return null;
                    }
                    directiveType = resolveForwardRef(directiveType);
                    var _c = this.getNonNormalizedDirectiveMetadata(directiveType), annotation = _c.annotation, metadata = _c.metadata;
                    var createDirectiveMetadata = function (templateMetadata) {
                        var normalizedDirMeta = new CompileDirectiveMetadata({
                            isHost: false,
                            type: metadata.type,
                            isComponent: metadata.isComponent,
                            selector: metadata.selector,
                            exportAs: metadata.exportAs,
                            changeDetection: metadata.changeDetection,
                            inputs: metadata.inputs,
                            outputs: metadata.outputs,
                            hostListeners: metadata.hostListeners,
                            hostProperties: metadata.hostProperties,
                            hostAttributes: metadata.hostAttributes,
                            providers: metadata.providers,
                            viewProviders: metadata.viewProviders,
                            queries: metadata.queries,
                            guards: metadata.guards,
                            viewQueries: metadata.viewQueries,
                            entryComponents: metadata.entryComponents,
                            componentViewType: metadata.componentViewType,
                            rendererType: metadata.rendererType,
                            componentFactory: metadata.componentFactory,
                            template: templateMetadata
                        });
                        if (templateMetadata) {
                            _this.initComponentFactory(metadata.componentFactory, templateMetadata.ngContentSelectors);
                        }
                        _this._directiveCache.set(directiveType, normalizedDirMeta);
                        _this._summaryCache.set(directiveType, normalizedDirMeta.toSummary());
                        return null;
                    };
                    if (metadata.isComponent) {
                        var template = metadata.template;
                        var templateMeta = this._directiveNormalizer.normalizeTemplate({
                            ngModuleType: ngModuleType,
                            componentType: directiveType,
                            moduleUrl: this._reflector.componentModuleUrl(directiveType, annotation),
                            encapsulation: template.encapsulation,
                            template: template.template,
                            templateUrl: template.templateUrl,
                            styles: template.styles,
                            styleUrls: template.styleUrls,
                            animations: template.animations,
                            interpolation: template.interpolation,
                            preserveWhitespaces: template.preserveWhitespaces
                        });
                        if (isPromise(templateMeta) && isSync) {
                            this._reportError(componentStillLoadingError(directiveType), directiveType);
                            return null;
                        }
                        return SyncAsync.then(templateMeta, createDirectiveMetadata);
                    }
                    else {
                        // directive
                        createDirectiveMetadata(null);
                        return null;
                    }
                };
                CompileMetadataResolver.prototype.getNonNormalizedDirectiveMetadata = function (directiveType) {
                    var _this = this;
                    directiveType = resolveForwardRef(directiveType);
                    if (!directiveType) {
                        return null;
                    }
                    var cacheEntry = this._nonNormalizedDirectiveCache.get(directiveType);
                    if (cacheEntry) {
                        return cacheEntry;
                    }
                    var dirMeta = this._directiveResolver.resolve(directiveType, false);
                    if (!dirMeta) {
                        return null;
                    }
                    var nonNormalizedTemplateMetadata = undefined;
                    if (createComponent.isTypeOf(dirMeta)) {
                        // component
                        var compMeta = dirMeta;
                        assertArrayOfStrings('styles', compMeta.styles);
                        assertArrayOfStrings('styleUrls', compMeta.styleUrls);
                        assertInterpolationSymbols('interpolation', compMeta.interpolation);
                        var animations = compMeta.animations;
                        nonNormalizedTemplateMetadata = new CompileTemplateMetadata({
                            encapsulation: noUndefined(compMeta.encapsulation),
                            template: noUndefined(compMeta.template),
                            templateUrl: noUndefined(compMeta.templateUrl),
                            htmlAst: null,
                            styles: compMeta.styles || [],
                            styleUrls: compMeta.styleUrls || [],
                            animations: animations || [],
                            interpolation: noUndefined(compMeta.interpolation),
                            isInline: !!compMeta.template,
                            externalStylesheets: [],
                            ngContentSelectors: [],
                            preserveWhitespaces: noUndefined(dirMeta.preserveWhitespaces),
                        });
                    }
                    var changeDetectionStrategy = null;
                    var viewProviders = [];
                    var entryComponentMetadata = [];
                    var selector = dirMeta.selector;
                    if (createComponent.isTypeOf(dirMeta)) {
                        // Component
                        var compMeta = dirMeta;
                        changeDetectionStrategy = compMeta.changeDetection;
                        if (compMeta.viewProviders) {
                            viewProviders = this._getProvidersMetadata(compMeta.viewProviders, entryComponentMetadata, "viewProviders for \"" + stringifyType(directiveType) + "\"", [], directiveType);
                        }
                        if (compMeta.entryComponents) {
                            entryComponentMetadata = flattenAndDedupeArray(compMeta.entryComponents)
                                .map(function (type) { return _this._getEntryComponentMetadata(type); })
                                .concat(entryComponentMetadata);
                        }
                        if (!selector) {
                            selector = this._schemaRegistry.getDefaultComponentElementName();
                        }
                    }
                    else {
                        // Directive
                        if (!selector) {
                            this._reportError(syntaxError("Directive " + stringifyType(directiveType) + " has no selector, please add it!"), directiveType);
                            selector = 'error';
                        }
                    }
                    var providers = [];
                    if (dirMeta.providers != null) {
                        providers = this._getProvidersMetadata(dirMeta.providers, entryComponentMetadata, "providers for \"" + stringifyType(directiveType) + "\"", [], directiveType);
                    }
                    var queries = [];
                    var viewQueries = [];
                    if (dirMeta.queries != null) {
                        queries = this._getQueriesMetadata(dirMeta.queries, false, directiveType);
                        viewQueries = this._getQueriesMetadata(dirMeta.queries, true, directiveType);
                    }
                    var metadata = CompileDirectiveMetadata.create({
                        isHost: false,
                        selector: selector,
                        exportAs: noUndefined(dirMeta.exportAs),
                        isComponent: !!nonNormalizedTemplateMetadata,
                        type: this._getTypeMetadata(directiveType),
                        template: nonNormalizedTemplateMetadata,
                        changeDetection: changeDetectionStrategy,
                        inputs: dirMeta.inputs || [],
                        outputs: dirMeta.outputs || [],
                        host: dirMeta.host || {},
                        providers: providers || [],
                        viewProviders: viewProviders || [],
                        queries: queries || [],
                        guards: dirMeta.guards || {},
                        viewQueries: viewQueries || [],
                        entryComponents: entryComponentMetadata,
                        componentViewType: nonNormalizedTemplateMetadata ? this.getComponentViewClass(directiveType) :
                            null,
                        rendererType: nonNormalizedTemplateMetadata ? this.getRendererType(directiveType) : null,
                        componentFactory: null
                    });
                    if (nonNormalizedTemplateMetadata) {
                        metadata.componentFactory =
                            this.getComponentFactory(selector, directiveType, metadata.inputs, metadata.outputs);
                    }
                    cacheEntry = { metadata: metadata, annotation: dirMeta };
                    this._nonNormalizedDirectiveCache.set(directiveType, cacheEntry);
                    return cacheEntry;
                };
                /**
                 * Gets the metadata for the given directive.
                 * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
                 */
                CompileMetadataResolver.prototype.getDirectiveMetadata = function (directiveType) {
                    var dirMeta = this._directiveCache.get(directiveType);
                    if (!dirMeta) {
                        this._reportError(syntaxError("Illegal state: getDirectiveMetadata can only be called after loadNgModuleDirectiveAndPipeMetadata for a module that declares it. Directive " + stringifyType(directiveType) + "."), directiveType);
                    }
                    return dirMeta;
                };
                CompileMetadataResolver.prototype.getDirectiveSummary = function (dirType) {
                    var dirSummary = this._loadSummary(dirType, CompileSummaryKind.Directive);
                    if (!dirSummary) {
                        this._reportError(syntaxError("Illegal state: Could not load the summary for directive " + stringifyType(dirType) + "."), dirType);
                    }
                    return dirSummary;
                };
                CompileMetadataResolver.prototype.isDirective = function (type) {
                    return !!this._loadSummary(type, CompileSummaryKind.Directive) ||
                        this._directiveResolver.isDirective(type);
                };
                CompileMetadataResolver.prototype.isPipe = function (type) {
                    return !!this._loadSummary(type, CompileSummaryKind.Pipe) ||
                        this._pipeResolver.isPipe(type);
                };
                CompileMetadataResolver.prototype.isNgModule = function (type) {
                    return !!this._loadSummary(type, CompileSummaryKind.NgModule) ||
                        this._ngModuleResolver.isNgModule(type);
                };
                CompileMetadataResolver.prototype.getNgModuleSummary = function (moduleType, alreadyCollecting) {
                    if (alreadyCollecting === void 0) { alreadyCollecting = null; }
                    var moduleSummary = this._loadSummary(moduleType, CompileSummaryKind.NgModule);
                    if (!moduleSummary) {
                        var moduleMeta = this.getNgModuleMetadata(moduleType, false, alreadyCollecting);
                        moduleSummary = moduleMeta ? moduleMeta.toSummary() : null;
                        if (moduleSummary) {
                            this._summaryCache.set(moduleType, moduleSummary);
                        }
                    }
                    return moduleSummary;
                };
                /**
                 * Loads the declared directives and pipes of an NgModule.
                 */
                CompileMetadataResolver.prototype.loadNgModuleDirectiveAndPipeMetadata = function (moduleType, isSync, throwIfNotFound) {
                    var _this = this;
                    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
                    var ngModule = this.getNgModuleMetadata(moduleType, throwIfNotFound);
                    var loading = [];
                    if (ngModule) {
                        ngModule.declaredDirectives.forEach(function (id) {
                            var promise = _this.loadDirectiveMetadata(moduleType, id.reference, isSync);
                            if (promise) {
                                loading.push(promise);
                            }
                        });
                        ngModule.declaredPipes.forEach(function (id) { return _this._loadPipeMetadata(id.reference); });
                    }
                    return Promise.all(loading);
                };
                CompileMetadataResolver.prototype.getShallowModuleMetadata = function (moduleType) {
                    var compileMeta = this._shallowModuleCache.get(moduleType);
                    if (compileMeta) {
                        return compileMeta;
                    }
                    var ngModuleMeta = findLast(this._reflector.shallowAnnotations(moduleType), createNgModule.isTypeOf);
                    compileMeta = {
                        type: this._getTypeMetadata(moduleType),
                        rawExports: ngModuleMeta.exports,
                        rawImports: ngModuleMeta.imports,
                        rawProviders: ngModuleMeta.providers,
                    };
                    this._shallowModuleCache.set(moduleType, compileMeta);
                    return compileMeta;
                };
                CompileMetadataResolver.prototype.getNgModuleMetadata = function (moduleType, throwIfNotFound, alreadyCollecting) {
                    var _this = this;
                    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
                    if (alreadyCollecting === void 0) { alreadyCollecting = null; }
                    moduleType = resolveForwardRef(moduleType);
                    var compileMeta = this._ngModuleCache.get(moduleType);
                    if (compileMeta) {
                        return compileMeta;
                    }
                    var meta = this._ngModuleResolver.resolve(moduleType, throwIfNotFound);
                    if (!meta) {
                        return null;
                    }
                    var declaredDirectives = [];
                    var exportedNonModuleIdentifiers = [];
                    var declaredPipes = [];
                    var importedModules = [];
                    var exportedModules = [];
                    var providers = [];
                    var entryComponents = [];
                    var bootstrapComponents = [];
                    var schemas = [];
                    if (meta.imports) {
                        flattenAndDedupeArray(meta.imports).forEach(function (importedType) {
                            var importedModuleType = undefined;
                            if (isValidType(importedType)) {
                                importedModuleType = importedType;
                            }
                            else if (importedType && importedType.ngModule) {
                                var moduleWithProviders = importedType;
                                importedModuleType = moduleWithProviders.ngModule;
                                if (moduleWithProviders.providers) {
                                    providers.push.apply(providers, _this._getProvidersMetadata(moduleWithProviders.providers, entryComponents, "provider for the NgModule '" + stringifyType(importedModuleType) + "'", [], importedType));
                                }
                            }
                            if (importedModuleType) {
                                if (_this._checkSelfImport(moduleType, importedModuleType))
                                    return;
                                if (!alreadyCollecting)
                                    alreadyCollecting = new Set();
                                if (alreadyCollecting.has(importedModuleType)) {
                                    _this._reportError(syntaxError(_this._getTypeDescriptor(importedModuleType) + " '" + stringifyType(importedType) + "' is imported recursively by the module '" + stringifyType(moduleType) + "'."), moduleType);
                                    return;
                                }
                                alreadyCollecting.add(importedModuleType);
                                var importedModuleSummary = _this.getNgModuleSummary(importedModuleType, alreadyCollecting);
                                alreadyCollecting.delete(importedModuleType);
                                if (!importedModuleSummary) {
                                    _this._reportError(syntaxError("Unexpected " + _this._getTypeDescriptor(importedType) + " '" + stringifyType(importedType) + "' imported by the module '" + stringifyType(moduleType) + "'. Please add a @NgModule annotation."), moduleType);
                                    return;
                                }
                                importedModules.push(importedModuleSummary);
                            }
                            else {
                                _this._reportError(syntaxError("Unexpected value '" + stringifyType(importedType) + "' imported by the module '" + stringifyType(moduleType) + "'"), moduleType);
                                return;
                            }
                        });
                    }
                    if (meta.exports) {
                        flattenAndDedupeArray(meta.exports).forEach(function (exportedType) {
                            if (!isValidType(exportedType)) {
                                _this._reportError(syntaxError("Unexpected value '" + stringifyType(exportedType) + "' exported by the module '" + stringifyType(moduleType) + "'"), moduleType);
                                return;
                            }
                            if (!alreadyCollecting)
                                alreadyCollecting = new Set();
                            if (alreadyCollecting.has(exportedType)) {
                                _this._reportError(syntaxError(_this._getTypeDescriptor(exportedType) + " '" + stringify(exportedType) + "' is exported recursively by the module '" + stringifyType(moduleType) + "'"), moduleType);
                                return;
                            }
                            alreadyCollecting.add(exportedType);
                            var exportedModuleSummary = _this.getNgModuleSummary(exportedType, alreadyCollecting);
                            alreadyCollecting.delete(exportedType);
                            if (exportedModuleSummary) {
                                exportedModules.push(exportedModuleSummary);
                            }
                            else {
                                exportedNonModuleIdentifiers.push(_this._getIdentifierMetadata(exportedType));
                            }
                        });
                    }
                    // Note: This will be modified later, so we rely on
                    // getting a new instance every time!
                    var transitiveModule = this._getTransitiveNgModuleMetadata(importedModules, exportedModules);
                    if (meta.declarations) {
                        flattenAndDedupeArray(meta.declarations).forEach(function (declaredType) {
                            if (!isValidType(declaredType)) {
                                _this._reportError(syntaxError("Unexpected value '" + stringifyType(declaredType) + "' declared by the module '" + stringifyType(moduleType) + "'"), moduleType);
                                return;
                            }
                            var declaredIdentifier = _this._getIdentifierMetadata(declaredType);
                            if (_this.isDirective(declaredType)) {
                                transitiveModule.addDirective(declaredIdentifier);
                                declaredDirectives.push(declaredIdentifier);
                                _this._addTypeToModule(declaredType, moduleType);
                            }
                            else if (_this.isPipe(declaredType)) {
                                transitiveModule.addPipe(declaredIdentifier);
                                transitiveModule.pipes.push(declaredIdentifier);
                                declaredPipes.push(declaredIdentifier);
                                _this._addTypeToModule(declaredType, moduleType);
                            }
                            else {
                                _this._reportError(syntaxError("Unexpected " + _this._getTypeDescriptor(declaredType) + " '" + stringifyType(declaredType) + "' declared by the module '" + stringifyType(moduleType) + "'. Please add a @Pipe/@Directive/@Component annotation."), moduleType);
                                return;
                            }
                        });
                    }
                    var exportedDirectives = [];
                    var exportedPipes = [];
                    exportedNonModuleIdentifiers.forEach(function (exportedId) {
                        if (transitiveModule.directivesSet.has(exportedId.reference)) {
                            exportedDirectives.push(exportedId);
                            transitiveModule.addExportedDirective(exportedId);
                        }
                        else if (transitiveModule.pipesSet.has(exportedId.reference)) {
                            exportedPipes.push(exportedId);
                            transitiveModule.addExportedPipe(exportedId);
                        }
                        else {
                            _this._reportError(syntaxError("Can't export " + _this._getTypeDescriptor(exportedId.reference) + " " + stringifyType(exportedId.reference) + " from " + stringifyType(moduleType) + " as it was neither declared nor imported!"), moduleType);
                            return;
                        }
                    });
                    // The providers of the module have to go last
                    // so that they overwrite any other provider we already added.
                    if (meta.providers) {
                        providers.push.apply(providers, this._getProvidersMetadata(meta.providers, entryComponents, "provider for the NgModule '" + stringifyType(moduleType) + "'", [], moduleType));
                    }
                    if (meta.entryComponents) {
                        entryComponents.push.apply(entryComponents, flattenAndDedupeArray(meta.entryComponents)
                            .map(function (type) { return _this._getEntryComponentMetadata(type); }));
                    }
                    if (meta.bootstrap) {
                        flattenAndDedupeArray(meta.bootstrap).forEach(function (type) {
                            if (!isValidType(type)) {
                                _this._reportError(syntaxError("Unexpected value '" + stringifyType(type) + "' used in the bootstrap property of module '" + stringifyType(moduleType) + "'"), moduleType);
                                return;
                            }
                            bootstrapComponents.push(_this._getIdentifierMetadata(type));
                        });
                    }
                    entryComponents.push.apply(entryComponents, bootstrapComponents.map(function (type) { return _this._getEntryComponentMetadata(type.reference); }));
                    if (meta.schemas) {
                        schemas.push.apply(schemas, flattenAndDedupeArray(meta.schemas));
                    }
                    compileMeta = new CompileNgModuleMetadata({
                        type: this._getTypeMetadata(moduleType),
                        providers: providers,
                        entryComponents: entryComponents,
                        bootstrapComponents: bootstrapComponents,
                        schemas: schemas,
                        declaredDirectives: declaredDirectives,
                        exportedDirectives: exportedDirectives,
                        declaredPipes: declaredPipes,
                        exportedPipes: exportedPipes,
                        importedModules: importedModules,
                        exportedModules: exportedModules,
                        transitiveModule: transitiveModule,
                        id: meta.id || null,
                    });
                    entryComponents.forEach(function (id) { return transitiveModule.addEntryComponent(id); });
                    providers.forEach(function (provider) { return transitiveModule.addProvider(provider, compileMeta.type); });
                    transitiveModule.addModule(compileMeta.type);
                    this._ngModuleCache.set(moduleType, compileMeta);
                    return compileMeta;
                };
                CompileMetadataResolver.prototype._checkSelfImport = function (moduleType, importedModuleType) {
                    if (moduleType === importedModuleType) {
                        this._reportError(syntaxError("'" + stringifyType(moduleType) + "' module can't import itself"), moduleType);
                        return true;
                    }
                    return false;
                };
                CompileMetadataResolver.prototype._getTypeDescriptor = function (type) {
                    if (isValidType(type)) {
                        if (this.isDirective(type)) {
                            return 'directive';
                        }
                        if (this.isPipe(type)) {
                            return 'pipe';
                        }
                        if (this.isNgModule(type)) {
                            return 'module';
                        }
                    }
                    if (type.provide) {
                        return 'provider';
                    }
                    return 'value';
                };
                CompileMetadataResolver.prototype._addTypeToModule = function (type, moduleType) {
                    var oldModule = this._ngModuleOfTypes.get(type);
                    if (oldModule && oldModule !== moduleType) {
                        this._reportError(syntaxError("Type " + stringifyType(type) + " is part of the declarations of 2 modules: " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + "! " +
                            ("Please consider moving " + stringifyType(type) + " to a higher module that imports " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + ". ") +
                            ("You can also create a new NgModule that exports and includes " + stringifyType(type) + " then import that NgModule in " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + ".")), moduleType);
                        return;
                    }
                    this._ngModuleOfTypes.set(type, moduleType);
                };
                CompileMetadataResolver.prototype._getTransitiveNgModuleMetadata = function (importedModules, exportedModules) {
                    // collect `providers` / `entryComponents` from all imported and all exported modules
                    var result = new TransitiveCompileNgModuleMetadata();
                    var modulesByToken = new Map();
                    importedModules.concat(exportedModules).forEach(function (modSummary) {
                        modSummary.modules.forEach(function (mod) { return result.addModule(mod); });
                        modSummary.entryComponents.forEach(function (comp) { return result.addEntryComponent(comp); });
                        var addedTokens = new Set();
                        modSummary.providers.forEach(function (entry) {
                            var tokenRef = tokenReference(entry.provider.token);
                            var prevModules = modulesByToken.get(tokenRef);
                            if (!prevModules) {
                                prevModules = new Set();
                                modulesByToken.set(tokenRef, prevModules);
                            }
                            var moduleRef = entry.module.reference;
                            // Note: the providers of one module may still contain multiple providers
                            // per token (e.g. for multi providers), and we need to preserve these.
                            if (addedTokens.has(tokenRef) || !prevModules.has(moduleRef)) {
                                prevModules.add(moduleRef);
                                addedTokens.add(tokenRef);
                                result.addProvider(entry.provider, entry.module);
                            }
                        });
                    });
                    exportedModules.forEach(function (modSummary) {
                        modSummary.exportedDirectives.forEach(function (id) { return result.addExportedDirective(id); });
                        modSummary.exportedPipes.forEach(function (id) { return result.addExportedPipe(id); });
                    });
                    importedModules.forEach(function (modSummary) {
                        modSummary.exportedDirectives.forEach(function (id) { return result.addDirective(id); });
                        modSummary.exportedPipes.forEach(function (id) { return result.addPipe(id); });
                    });
                    return result;
                };
                CompileMetadataResolver.prototype._getIdentifierMetadata = function (type) {
                    type = resolveForwardRef(type);
                    return { reference: type };
                };
                CompileMetadataResolver.prototype.isInjectable = function (type) {
                    var annotations = this._reflector.tryAnnotations(type);
                    return annotations.some(function (ann) { return createInjectable.isTypeOf(ann); });
                };
                CompileMetadataResolver.prototype.getInjectableSummary = function (type) {
                    return {
                        summaryKind: CompileSummaryKind.Injectable,
                        type: this._getTypeMetadata(type, null, false)
                    };
                };
                CompileMetadataResolver.prototype.getInjectableMetadata = function (type, dependencies, throwOnUnknownDeps) {
                    if (dependencies === void 0) { dependencies = null; }
                    if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
                    var typeSummary = this._loadSummary(type, CompileSummaryKind.Injectable);
                    var typeMetadata = typeSummary ?
                        typeSummary.type :
                        this._getTypeMetadata(type, dependencies, throwOnUnknownDeps);
                    var annotations = this._reflector.annotations(type).filter(function (ann) { return createInjectable.isTypeOf(ann); });
                    if (annotations.length === 0) {
                        return null;
                    }
                    var meta = annotations[annotations.length - 1];
                    return {
                        symbol: type,
                        type: typeMetadata,
                        providedIn: meta.providedIn,
                        useValue: meta.useValue,
                        useClass: meta.useClass,
                        useExisting: meta.useExisting,
                        useFactory: meta.useFactory,
                        deps: meta.deps,
                    };
                };
                CompileMetadataResolver.prototype._getTypeMetadata = function (type, dependencies, throwOnUnknownDeps) {
                    if (dependencies === void 0) { dependencies = null; }
                    if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
                    var identifier = this._getIdentifierMetadata(type);
                    return {
                        reference: identifier.reference,
                        diDeps: this._getDependenciesMetadata(identifier.reference, dependencies, throwOnUnknownDeps),
                        lifecycleHooks: getAllLifecycleHooks(this._reflector, identifier.reference),
                    };
                };
                CompileMetadataResolver.prototype._getFactoryMetadata = function (factory, dependencies) {
                    if (dependencies === void 0) { dependencies = null; }
                    factory = resolveForwardRef(factory);
                    return { reference: factory, diDeps: this._getDependenciesMetadata(factory, dependencies) };
                };
                /**
                 * Gets the metadata for the given pipe.
                 * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
                 */
                CompileMetadataResolver.prototype.getPipeMetadata = function (pipeType) {
                    var pipeMeta = this._pipeCache.get(pipeType);
                    if (!pipeMeta) {
                        this._reportError(syntaxError("Illegal state: getPipeMetadata can only be called after loadNgModuleDirectiveAndPipeMetadata for a module that declares it. Pipe " + stringifyType(pipeType) + "."), pipeType);
                    }
                    return pipeMeta || null;
                };
                CompileMetadataResolver.prototype.getPipeSummary = function (pipeType) {
                    var pipeSummary = this._loadSummary(pipeType, CompileSummaryKind.Pipe);
                    if (!pipeSummary) {
                        this._reportError(syntaxError("Illegal state: Could not load the summary for pipe " + stringifyType(pipeType) + "."), pipeType);
                    }
                    return pipeSummary;
                };
                CompileMetadataResolver.prototype.getOrLoadPipeMetadata = function (pipeType) {
                    var pipeMeta = this._pipeCache.get(pipeType);
                    if (!pipeMeta) {
                        pipeMeta = this._loadPipeMetadata(pipeType);
                    }
                    return pipeMeta;
                };
                CompileMetadataResolver.prototype._loadPipeMetadata = function (pipeType) {
                    pipeType = resolveForwardRef(pipeType);
                    var pipeAnnotation = this._pipeResolver.resolve(pipeType);
                    var pipeMeta = new CompilePipeMetadata({
                        type: this._getTypeMetadata(pipeType),
                        name: pipeAnnotation.name,
                        pure: !!pipeAnnotation.pure
                    });
                    this._pipeCache.set(pipeType, pipeMeta);
                    this._summaryCache.set(pipeType, pipeMeta.toSummary());
                    return pipeMeta;
                };
                CompileMetadataResolver.prototype._getDependenciesMetadata = function (typeOrFunc, dependencies, throwOnUnknownDeps) {
                    var _this = this;
                    if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
                    var hasUnknownDeps = false;
                    var params = dependencies || this._reflector.parameters(typeOrFunc) || [];
                    var dependenciesMetadata = params.map(function (param) {
                        var isAttribute = false;
                        var isHost = false;
                        var isSelf = false;
                        var isSkipSelf = false;
                        var isOptional = false;
                        var token = null;
                        if (Array.isArray(param)) {
                            param.forEach(function (paramEntry) {
                                if (createHost.isTypeOf(paramEntry)) {
                                    isHost = true;
                                }
                                else if (createSelf.isTypeOf(paramEntry)) {
                                    isSelf = true;
                                }
                                else if (createSkipSelf.isTypeOf(paramEntry)) {
                                    isSkipSelf = true;
                                }
                                else if (createOptional.isTypeOf(paramEntry)) {
                                    isOptional = true;
                                }
                                else if (createAttribute.isTypeOf(paramEntry)) {
                                    isAttribute = true;
                                    token = paramEntry.attributeName;
                                }
                                else if (createInject.isTypeOf(paramEntry)) {
                                    token = paramEntry.token;
                                }
                                else if (createInjectionToken.isTypeOf(paramEntry) ||
                                    paramEntry instanceof StaticSymbol) {
                                    token = paramEntry;
                                }
                                else if (isValidType(paramEntry) && token == null) {
                                    token = paramEntry;
                                }
                            });
                        }
                        else {
                            token = param;
                        }
                        if (token == null) {
                            hasUnknownDeps = true;
                            return {};
                        }
                        return {
                            isAttribute: isAttribute,
                            isHost: isHost,
                            isSelf: isSelf,
                            isSkipSelf: isSkipSelf,
                            isOptional: isOptional,
                            token: _this._getTokenMetadata(token)
                        };
                    });
                    if (hasUnknownDeps) {
                        var depsTokens = dependenciesMetadata.map(function (dep) { return dep.token ? stringifyType(dep.token) : '?'; }).join(', ');
                        var message = "Can't resolve all parameters for " + stringifyType(typeOrFunc) + ": (" + depsTokens + ").";
                        if (throwOnUnknownDeps || this._config.strictInjectionParameters) {
                            this._reportError(syntaxError(message), typeOrFunc);
                        }
                        else {
                            this._console.warn("Warning: " + message + " This will become an error in Angular v6.x");
                        }
                    }
                    return dependenciesMetadata;
                };
                CompileMetadataResolver.prototype._getTokenMetadata = function (token) {
                    token = resolveForwardRef(token);
                    var compileToken;
                    if (typeof token === 'string') {
                        compileToken = { value: token };
                    }
                    else {
                        compileToken = { identifier: { reference: token } };
                    }
                    return compileToken;
                };
                CompileMetadataResolver.prototype._getProvidersMetadata = function (providers, targetEntryComponents, debugInfo, compileProviders, type) {
                    var _this = this;
                    if (compileProviders === void 0) { compileProviders = []; }
                    providers.forEach(function (provider, providerIdx) {
                        if (Array.isArray(provider)) {
                            _this._getProvidersMetadata(provider, targetEntryComponents, debugInfo, compileProviders);
                        }
                        else {
                            provider = resolveForwardRef(provider);
                            var providerMeta = undefined;
                            if (provider && typeof provider === 'object' && provider.hasOwnProperty('provide')) {
                                _this._validateProvider(provider);
                                providerMeta = new ProviderMeta(provider.provide, provider);
                            }
                            else if (isValidType(provider)) {
                                providerMeta = new ProviderMeta(provider, { useClass: provider });
                            }
                            else if (provider === void 0) {
                                _this._reportError(syntaxError("Encountered undefined provider! Usually this means you have a circular dependencies. This might be caused by using 'barrel' index.ts files."));
                                return;
                            }
                            else {
                                var providersInfo = providers.reduce(function (soFar, seenProvider, seenProviderIdx) {
                                    if (seenProviderIdx < providerIdx) {
                                        soFar.push("" + stringifyType(seenProvider));
                                    }
                                    else if (seenProviderIdx == providerIdx) {
                                        soFar.push("?" + stringifyType(seenProvider) + "?");
                                    }
                                    else if (seenProviderIdx == providerIdx + 1) {
                                        soFar.push('...');
                                    }
                                    return soFar;
                                }, [])
                                    .join(', ');
                                _this._reportError(syntaxError("Invalid " + (debugInfo ? debugInfo : 'provider') + " - only instances of Provider and Type are allowed, got: [" + providersInfo + "]"), type);
                                return;
                            }
                            if (providerMeta.token ===
                                _this._reflector.resolveExternalReference(Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS)) {
                                targetEntryComponents.push.apply(targetEntryComponents, _this._getEntryComponentsFromProvider(providerMeta, type));
                            }
                            else {
                                compileProviders.push(_this.getProviderMetadata(providerMeta));
                            }
                        }
                    });
                    return compileProviders;
                };
                CompileMetadataResolver.prototype._validateProvider = function (provider) {
                    if (provider.hasOwnProperty('useClass') && provider.useClass == null) {
                        this._reportError(syntaxError("Invalid provider for " + stringifyType(provider.provide) + ". useClass cannot be " + provider.useClass + ".\n           Usually it happens when:\n           1. There's a circular dependency (might be caused by using index.ts (barrel) files).\n           2. Class was used before it was declared. Use forwardRef in this case."));
                    }
                };
                CompileMetadataResolver.prototype._getEntryComponentsFromProvider = function (provider, type) {
                    var _this = this;
                    var components = [];
                    var collectedIdentifiers = [];
                    if (provider.useFactory || provider.useExisting || provider.useClass) {
                        this._reportError(syntaxError("The ANALYZE_FOR_ENTRY_COMPONENTS token only supports useValue!"), type);
                        return [];
                    }
                    if (!provider.multi) {
                        this._reportError(syntaxError("The ANALYZE_FOR_ENTRY_COMPONENTS token only supports 'multi = true'!"), type);
                        return [];
                    }
                    extractIdentifiers(provider.useValue, collectedIdentifiers);
                    collectedIdentifiers.forEach(function (identifier) {
                        var entry = _this._getEntryComponentMetadata(identifier.reference, false);
                        if (entry) {
                            components.push(entry);
                        }
                    });
                    return components;
                };
                CompileMetadataResolver.prototype._getEntryComponentMetadata = function (dirType, throwIfNotFound) {
                    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
                    var dirMeta = this.getNonNormalizedDirectiveMetadata(dirType);
                    if (dirMeta && dirMeta.metadata.isComponent) {
                        return { componentType: dirType, componentFactory: dirMeta.metadata.componentFactory };
                    }
                    var dirSummary = this._loadSummary(dirType, CompileSummaryKind.Directive);
                    if (dirSummary && dirSummary.isComponent) {
                        return { componentType: dirType, componentFactory: dirSummary.componentFactory };
                    }
                    if (throwIfNotFound) {
                        throw syntaxError(dirType.name + " cannot be used as an entry component.");
                    }
                    return null;
                };
                CompileMetadataResolver.prototype._getInjectableTypeMetadata = function (type, dependencies) {
                    if (dependencies === void 0) { dependencies = null; }
                    var typeSummary = this._loadSummary(type, CompileSummaryKind.Injectable);
                    if (typeSummary) {
                        return typeSummary.type;
                    }
                    return this._getTypeMetadata(type, dependencies);
                };
                CompileMetadataResolver.prototype.getProviderMetadata = function (provider) {
                    var compileDeps = undefined;
                    var compileTypeMetadata = null;
                    var compileFactoryMetadata = null;
                    var token = this._getTokenMetadata(provider.token);
                    if (provider.useClass) {
                        compileTypeMetadata =
                            this._getInjectableTypeMetadata(provider.useClass, provider.dependencies);
                        compileDeps = compileTypeMetadata.diDeps;
                        if (provider.token === provider.useClass) {
                            // use the compileTypeMetadata as it contains information about lifecycleHooks...
                            token = { identifier: compileTypeMetadata };
                        }
                    }
                    else if (provider.useFactory) {
                        compileFactoryMetadata = this._getFactoryMetadata(provider.useFactory, provider.dependencies);
                        compileDeps = compileFactoryMetadata.diDeps;
                    }
                    return {
                        token: token,
                        useClass: compileTypeMetadata,
                        useValue: provider.useValue,
                        useFactory: compileFactoryMetadata,
                        useExisting: provider.useExisting ? this._getTokenMetadata(provider.useExisting) : undefined,
                        deps: compileDeps,
                        multi: provider.multi
                    };
                };
                CompileMetadataResolver.prototype._getQueriesMetadata = function (queries, isViewQuery, directiveType) {
                    var _this = this;
                    var res = [];
                    Object.keys(queries).forEach(function (propertyName) {
                        var query = queries[propertyName];
                        if (query.isViewQuery === isViewQuery) {
                            res.push(_this._getQueryMetadata(query, propertyName, directiveType));
                        }
                    });
                    return res;
                };
                CompileMetadataResolver.prototype._queryVarBindings = function (selector) { return selector.split(/\s*,\s*/); };
                CompileMetadataResolver.prototype._getQueryMetadata = function (q, propertyName, typeOrFunc) {
                    var _this = this;
                    var selectors;
                    if (typeof q.selector === 'string') {
                        selectors =
                            this._queryVarBindings(q.selector).map(function (varName) { return _this._getTokenMetadata(varName); });
                    }
                    else {
                        if (!q.selector) {
                            this._reportError(syntaxError("Can't construct a query for the property \"" + propertyName + "\" of \"" + stringifyType(typeOrFunc) + "\" since the query selector wasn't defined."), typeOrFunc);
                            selectors = [];
                        }
                        else {
                            selectors = [this._getTokenMetadata(q.selector)];
                        }
                    }
                    return {
                        selectors: selectors,
                        first: q.first,
                        descendants: q.descendants, propertyName: propertyName,
                        read: q.read ? this._getTokenMetadata(q.read) : null,
                        static: q.static
                    };
                };
                CompileMetadataResolver.prototype._reportError = function (error, type, otherType) {
                    if (this._errorCollector) {
                        this._errorCollector(error, type);
                        if (otherType) {
                            this._errorCollector(error, otherType);
                        }
                    }
                    else {
                        throw error;
                    }
                };
                return CompileMetadataResolver;
            }());
            function flattenArray(tree, out) {
                if (out === void 0) { out = []; }
                if (tree) {
                    for (var i = 0; i < tree.length; i++) {
                        var item = resolveForwardRef(tree[i]);
                        if (Array.isArray(item)) {
                            flattenArray(item, out);
                        }
                        else {
                            out.push(item);
                        }
                    }
                }
                return out;
            }
            function dedupeArray(array) {
                if (array) {
                    return Array.from(new Set(array));
                }
                return [];
            }
            function flattenAndDedupeArray(tree) {
                return dedupeArray(flattenArray(tree));
            }
            function isValidType(value) {
                return (value instanceof StaticSymbol) || (value instanceof Type);
            }
            function extractIdentifiers(value, targetIdentifiers) {
                visitValue(value, new _CompileValueConverter(), targetIdentifiers);
            }
            var _CompileValueConverter = /** @class */ (function (_super_1) {
                __extends(_CompileValueConverter, _super_1);
                function _CompileValueConverter() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                _CompileValueConverter.prototype.visitOther = function (value, targetIdentifiers) {
                    targetIdentifiers.push({ reference: value });
                };
                return _CompileValueConverter;
            }(ValueTransformer));
            function stringifyType(type) {
                if (type instanceof StaticSymbol) {
                    return type.name + " in " + type.filePath;
                }
                else {
                    return stringify(type);
                }
            }
            /**
             * Indicates that a component is still being loaded in a synchronous compile.
             */
            function componentStillLoadingError(compType) {
                var error = Error("Can't compile synchronously as " + stringify(compType) + " is still being loaded!");
                error[ERROR_COMPONENT_TYPE] = compType;
                return error;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function providerDef(ctx, providerAst) {
                var flags = 0 /* None */;
                if (!providerAst.eager) {
                    flags |= 4096 /* LazyProvider */;
                }
                if (providerAst.providerType === ProviderAstType.PrivateService) {
                    flags |= 8192 /* PrivateProvider */;
                }
                if (providerAst.isModule) {
                    flags |= 1073741824 /* TypeModuleProvider */;
                }
                providerAst.lifecycleHooks.forEach(function (lifecycleHook) {
                    // for regular providers, we only support ngOnDestroy
                    if (lifecycleHook === LifecycleHooks.OnDestroy ||
                        providerAst.providerType === ProviderAstType.Directive ||
                        providerAst.providerType === ProviderAstType.Component) {
                        flags |= lifecycleHookToNodeFlag(lifecycleHook);
                    }
                });
                var _c = providerAst.multiProvider ?
                    multiProviderDef(ctx, flags, providerAst.providers) :
                    singleProviderDef(ctx, flags, providerAst.providerType, providerAst.providers[0]), providerExpr = _c.providerExpr, providerFlags = _c.flags, depsExpr = _c.depsExpr;
                return {
                    providerExpr: providerExpr,
                    flags: providerFlags, depsExpr: depsExpr,
                    tokenExpr: tokenExpr(ctx, providerAst.token),
                };
            }
            function multiProviderDef(ctx, flags, providers) {
                var allDepDefs = [];
                var allParams = [];
                var exprs = providers.map(function (provider, providerIndex) {
                    var expr;
                    if (provider.useClass) {
                        var depExprs = convertDeps(providerIndex, provider.deps || provider.useClass.diDeps);
                        expr = ctx.importExpr(provider.useClass.reference).instantiate(depExprs);
                    }
                    else if (provider.useFactory) {
                        var depExprs = convertDeps(providerIndex, provider.deps || provider.useFactory.diDeps);
                        expr = ctx.importExpr(provider.useFactory.reference).callFn(depExprs);
                    }
                    else if (provider.useExisting) {
                        var depExprs = convertDeps(providerIndex, [{ token: provider.useExisting }]);
                        expr = depExprs[0];
                    }
                    else {
                        expr = convertValueToOutputAst(ctx, provider.useValue);
                    }
                    return expr;
                });
                var providerExpr = fn(allParams, [new ReturnStatement(literalArr(exprs))], INFERRED_TYPE);
                return {
                    providerExpr: providerExpr,
                    flags: flags | 1024 /* TypeFactoryProvider */,
                    depsExpr: literalArr(allDepDefs)
                };
                function convertDeps(providerIndex, deps) {
                    return deps.map(function (dep, depIndex) {
                        var paramName = "p" + providerIndex + "_" + depIndex;
                        allParams.push(new FnParam(paramName, DYNAMIC_TYPE));
                        allDepDefs.push(depDef(ctx, dep));
                        return variable(paramName);
                    });
                }
            }
            function singleProviderDef(ctx, flags, providerType, providerMeta) {
                var providerExpr;
                var deps;
                if (providerType === ProviderAstType.Directive || providerType === ProviderAstType.Component) {
                    providerExpr = ctx.importExpr(providerMeta.useClass.reference);
                    flags |= 16384 /* TypeDirective */;
                    deps = providerMeta.deps || providerMeta.useClass.diDeps;
                }
                else {
                    if (providerMeta.useClass) {
                        providerExpr = ctx.importExpr(providerMeta.useClass.reference);
                        flags |= 512 /* TypeClassProvider */;
                        deps = providerMeta.deps || providerMeta.useClass.diDeps;
                    }
                    else if (providerMeta.useFactory) {
                        providerExpr = ctx.importExpr(providerMeta.useFactory.reference);
                        flags |= 1024 /* TypeFactoryProvider */;
                        deps = providerMeta.deps || providerMeta.useFactory.diDeps;
                    }
                    else if (providerMeta.useExisting) {
                        providerExpr = NULL_EXPR;
                        flags |= 2048 /* TypeUseExistingProvider */;
                        deps = [{ token: providerMeta.useExisting }];
                    }
                    else {
                        providerExpr = convertValueToOutputAst(ctx, providerMeta.useValue);
                        flags |= 256 /* TypeValueProvider */;
                        deps = [];
                    }
                }
                var depsExpr = literalArr(deps.map(function (dep) { return depDef(ctx, dep); }));
                return { providerExpr: providerExpr, flags: flags, depsExpr: depsExpr };
            }
            function tokenExpr(ctx, tokenMeta) {
                return tokenMeta.identifier ? ctx.importExpr(tokenMeta.identifier.reference) :
                    literal(tokenMeta.value);
            }
            function depDef(ctx, dep) {
                // Note: the following fields have already been normalized out by provider_analyzer:
                // - isAttribute, isHost
                var expr = dep.isValue ? convertValueToOutputAst(ctx, dep.value) : tokenExpr(ctx, dep.token);
                var flags = 0 /* None */;
                if (dep.isSkipSelf) {
                    flags |= 1 /* SkipSelf */;
                }
                if (dep.isOptional) {
                    flags |= 2 /* Optional */;
                }
                if (dep.isSelf) {
                    flags |= 4 /* Self */;
                }
                if (dep.isValue) {
                    flags |= 8 /* Value */;
                }
                return flags === 0 /* None */ ? expr : literalArr([literal(flags), expr]);
            }
            function lifecycleHookToNodeFlag(lifecycleHook) {
                var nodeFlag = 0 /* None */;
                switch (lifecycleHook) {
                    case LifecycleHooks.AfterContentChecked:
                        nodeFlag = 2097152 /* AfterContentChecked */;
                        break;
                    case LifecycleHooks.AfterContentInit:
                        nodeFlag = 1048576 /* AfterContentInit */;
                        break;
                    case LifecycleHooks.AfterViewChecked:
                        nodeFlag = 8388608 /* AfterViewChecked */;
                        break;
                    case LifecycleHooks.AfterViewInit:
                        nodeFlag = 4194304 /* AfterViewInit */;
                        break;
                    case LifecycleHooks.DoCheck:
                        nodeFlag = 262144 /* DoCheck */;
                        break;
                    case LifecycleHooks.OnChanges:
                        nodeFlag = 524288 /* OnChanges */;
                        break;
                    case LifecycleHooks.OnDestroy:
                        nodeFlag = 131072 /* OnDestroy */;
                        break;
                    case LifecycleHooks.OnInit:
                        nodeFlag = 65536 /* OnInit */;
                        break;
                }
                return nodeFlag;
            }
            function componentFactoryResolverProviderDef(reflector, ctx, flags, entryComponents) {
                var entryComponentFactories = entryComponents.map(function (entryComponent) { return ctx.importExpr(entryComponent.componentFactory); });
                var token = createTokenForExternalReference(reflector, Identifiers.ComponentFactoryResolver);
                var classMeta = {
                    diDeps: [
                        { isValue: true, value: literalArr(entryComponentFactories) },
                        { token: token, isSkipSelf: true, isOptional: true },
                        { token: createTokenForExternalReference(reflector, Identifiers.NgModuleRef) },
                    ],
                    lifecycleHooks: [],
                    reference: reflector.resolveExternalReference(Identifiers.CodegenComponentFactoryResolver)
                };
                var _c = singleProviderDef(ctx, flags, ProviderAstType.PrivateService, {
                    token: token,
                    multi: false,
                    useClass: classMeta,
                }), providerExpr = _c.providerExpr, providerFlags = _c.flags, depsExpr = _c.depsExpr;
                return { providerExpr: providerExpr, flags: providerFlags, depsExpr: depsExpr, tokenExpr: tokenExpr(ctx, token) };
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var NgModuleCompileResult = /** @class */ (function () {
                function NgModuleCompileResult(ngModuleFactoryVar) {
                    this.ngModuleFactoryVar = ngModuleFactoryVar;
                }
                return NgModuleCompileResult;
            }());
            var LOG_VAR = variable('_l');
            var NgModuleCompiler = /** @class */ (function () {
                function NgModuleCompiler(reflector) {
                    this.reflector = reflector;
                }
                NgModuleCompiler.prototype.compile = function (ctx, ngModuleMeta, extraProviders) {
                    var sourceSpan = typeSourceSpan('NgModule', ngModuleMeta.type);
                    var entryComponentFactories = ngModuleMeta.transitiveModule.entryComponents;
                    var bootstrapComponents = ngModuleMeta.bootstrapComponents;
                    var providerParser = new NgModuleProviderAnalyzer(this.reflector, ngModuleMeta, extraProviders, sourceSpan);
                    var providerDefs = [componentFactoryResolverProviderDef(this.reflector, ctx, 0 /* None */, entryComponentFactories)]
                        .concat(providerParser.parse().map(function (provider) { return providerDef(ctx, provider); }))
                        .map(function (_c) {
                        var providerExpr = _c.providerExpr, depsExpr = _c.depsExpr, flags = _c.flags, tokenExpr = _c.tokenExpr;
                        return importExpr(Identifiers.moduleProviderDef).callFn([
                            literal(flags), tokenExpr, providerExpr, depsExpr
                        ]);
                    });
                    var ngModuleDef = importExpr(Identifiers.moduleDef).callFn([literalArr(providerDefs)]);
                    var ngModuleDefFactory = fn([new FnParam(LOG_VAR.name)], [new ReturnStatement(ngModuleDef)], INFERRED_TYPE);
                    var ngModuleFactoryVar = identifierName(ngModuleMeta.type) + "NgFactory";
                    this._createNgModuleFactory(ctx, ngModuleMeta.type.reference, importExpr(Identifiers.createModuleFactory).callFn([
                        ctx.importExpr(ngModuleMeta.type.reference),
                        literalArr(bootstrapComponents.map(function (id) { return ctx.importExpr(id.reference); })),
                        ngModuleDefFactory
                    ]));
                    if (ngModuleMeta.id) {
                        var id = typeof ngModuleMeta.id === 'string' ? literal(ngModuleMeta.id) :
                            ctx.importExpr(ngModuleMeta.id);
                        var registerFactoryStmt = importExpr(Identifiers.RegisterModuleFactoryFn)
                            .callFn([id, variable(ngModuleFactoryVar)])
                            .toStmt();
                        ctx.statements.push(registerFactoryStmt);
                    }
                    return new NgModuleCompileResult(ngModuleFactoryVar);
                };
                NgModuleCompiler.prototype.createStub = function (ctx, ngModuleReference) {
                    this._createNgModuleFactory(ctx, ngModuleReference, NULL_EXPR);
                };
                NgModuleCompiler.prototype._createNgModuleFactory = function (ctx, reference, value) {
                    var ngModuleFactoryVar = identifierName({ reference: reference }) + "NgFactory";
                    var ngModuleFactoryStmt = variable(ngModuleFactoryVar)
                        .set(value)
                        .toDeclStmt(importType(Identifiers.NgModuleFactory, [expressionType(ctx.importExpr(reference))], [TypeModifier.Const]), [StmtModifier.Final, StmtModifier.Exported]);
                    ctx.statements.push(ngModuleFactoryStmt);
                };
                return NgModuleCompiler;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Resolves types to {@link NgModule}.
             */
            var NgModuleResolver = /** @class */ (function () {
                function NgModuleResolver(_reflector) {
                    this._reflector = _reflector;
                }
                NgModuleResolver.prototype.isNgModule = function (type) { return this._reflector.annotations(type).some(createNgModule.isTypeOf); };
                NgModuleResolver.prototype.resolve = function (type, throwIfNotFound) {
                    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
                    var ngModuleMeta = findLast(this._reflector.annotations(type), createNgModule.isTypeOf);
                    if (ngModuleMeta) {
                        return ngModuleMeta;
                    }
                    else {
                        if (throwIfNotFound) {
                            throw new Error("No NgModule metadata found for '" + stringify(type) + "'.");
                        }
                        return null;
                    }
                };
                return NgModuleResolver;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _debugFilePath = '/debug/lib';
            function debugOutputAstAsTypeScript(ast) {
                var converter = new _TsEmitterVisitor();
                var ctx = EmitterVisitorContext.createRoot();
                var asts = Array.isArray(ast) ? ast : [ast];
                asts.forEach(function (ast) {
                    if (ast instanceof Statement) {
                        ast.visitStatement(converter, ctx);
                    }
                    else if (ast instanceof Expression) {
                        ast.visitExpression(converter, ctx);
                    }
                    else if (ast instanceof Type$1) {
                        ast.visitType(converter, ctx);
                    }
                    else {
                        throw new Error("Don't know how to print debug info for " + ast);
                    }
                });
                return ctx.toSource();
            }
            var TypeScriptEmitter = /** @class */ (function () {
                function TypeScriptEmitter() {
                }
                TypeScriptEmitter.prototype.emitStatementsAndContext = function (genFilePath, stmts, preamble, emitSourceMaps, referenceFilter, importFilter) {
                    if (preamble === void 0) { preamble = ''; }
                    if (emitSourceMaps === void 0) { emitSourceMaps = true; }
                    var converter = new _TsEmitterVisitor(referenceFilter, importFilter);
                    var ctx = EmitterVisitorContext.createRoot();
                    converter.visitAllStatements(stmts, ctx);
                    var preambleLines = preamble ? preamble.split('\n') : [];
                    converter.reexports.forEach(function (reexports, exportedModuleName) {
                        var reexportsCode = reexports.map(function (reexport) { return reexport.name + " as " + reexport.as; }).join(',');
                        preambleLines.push("export {" + reexportsCode + "} from '" + exportedModuleName + "';");
                    });
                    converter.importsWithPrefixes.forEach(function (prefix, importedModuleName) {
                        // Note: can't write the real word for import as it screws up system.js auto detection...
                        preambleLines.push("imp" +
                            ("ort * as " + prefix + " from '" + importedModuleName + "';"));
                    });
                    var sm = emitSourceMaps ?
                        ctx.toSourceMapGenerator(genFilePath, preambleLines.length).toJsComment() :
                        '';
                    var lines = preambleLines.concat([ctx.toSource(), sm]);
                    if (sm) {
                        // always add a newline at the end, as some tools have bugs without it.
                        lines.push('');
                    }
                    ctx.setPreambleLineCount(preambleLines.length);
                    return { sourceText: lines.join('\n'), context: ctx };
                };
                TypeScriptEmitter.prototype.emitStatements = function (genFilePath, stmts, preamble) {
                    if (preamble === void 0) { preamble = ''; }
                    return this.emitStatementsAndContext(genFilePath, stmts, preamble).sourceText;
                };
                return TypeScriptEmitter;
            }());
            var _TsEmitterVisitor = /** @class */ (function (_super_1) {
                __extends(_TsEmitterVisitor, _super_1);
                function _TsEmitterVisitor(referenceFilter, importFilter) {
                    var _this = _super_1.call(this, false) || this;
                    _this.referenceFilter = referenceFilter;
                    _this.importFilter = importFilter;
                    _this.typeExpression = 0;
                    _this.importsWithPrefixes = new Map();
                    _this.reexports = new Map();
                    return _this;
                }
                _TsEmitterVisitor.prototype.visitType = function (t, ctx, defaultType) {
                    if (defaultType === void 0) { defaultType = 'any'; }
                    if (t) {
                        this.typeExpression++;
                        t.visitType(this, ctx);
                        this.typeExpression--;
                    }
                    else {
                        ctx.print(null, defaultType);
                    }
                };
                _TsEmitterVisitor.prototype.visitLiteralExpr = function (ast, ctx) {
                    var value = ast.value;
                    if (value == null && ast.type != INFERRED_TYPE) {
                        ctx.print(ast, "(" + value + " as any)");
                        return null;
                    }
                    return _super_1.prototype.visitLiteralExpr.call(this, ast, ctx);
                };
                // Temporary workaround to support strictNullCheck enabled consumers of ngc emit.
                // In SNC mode, [] have the type never[], so we cast here to any[].
                // TODO: narrow the cast to a more explicit type, or use a pattern that does not
                // start with [].concat. see https://github.com/angular/angular/pull/11846
                _TsEmitterVisitor.prototype.visitLiteralArrayExpr = function (ast, ctx) {
                    if (ast.entries.length === 0) {
                        ctx.print(ast, '(');
                    }
                    var result = _super_1.prototype.visitLiteralArrayExpr.call(this, ast, ctx);
                    if (ast.entries.length === 0) {
                        ctx.print(ast, ' as any[])');
                    }
                    return result;
                };
                _TsEmitterVisitor.prototype.visitExternalExpr = function (ast, ctx) {
                    this._visitIdentifier(ast.value, ast.typeParams, ctx);
                    return null;
                };
                _TsEmitterVisitor.prototype.visitAssertNotNullExpr = function (ast, ctx) {
                    var result = _super_1.prototype.visitAssertNotNullExpr.call(this, ast, ctx);
                    ctx.print(ast, '!');
                    return result;
                };
                _TsEmitterVisitor.prototype.visitDeclareVarStmt = function (stmt, ctx) {
                    if (stmt.hasModifier(StmtModifier.Exported) && stmt.value instanceof ExternalExpr &&
                        !stmt.type) {
                        // check for a reexport
                        var _c = stmt.value.value, name = _c.name, moduleName = _c.moduleName;
                        if (moduleName) {
                            var reexports = this.reexports.get(moduleName);
                            if (!reexports) {
                                reexports = [];
                                this.reexports.set(moduleName, reexports);
                            }
                            reexports.push({ name: name, as: stmt.name });
                            return null;
                        }
                    }
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        ctx.print(stmt, "export ");
                    }
                    if (stmt.hasModifier(StmtModifier.Final)) {
                        ctx.print(stmt, "const");
                    }
                    else {
                        ctx.print(stmt, "var");
                    }
                    ctx.print(stmt, " " + stmt.name);
                    this._printColonType(stmt.type, ctx);
                    if (stmt.value) {
                        ctx.print(stmt, " = ");
                        stmt.value.visitExpression(this, ctx);
                    }
                    ctx.println(stmt, ";");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitWrappedNodeExpr = function (ast, ctx) {
                    throw new Error('Cannot visit a WrappedNodeExpr when outputting Typescript.');
                };
                _TsEmitterVisitor.prototype.visitCastExpr = function (ast, ctx) {
                    ctx.print(ast, "(<");
                    ast.type.visitType(this, ctx);
                    ctx.print(ast, ">");
                    ast.value.visitExpression(this, ctx);
                    ctx.print(ast, ")");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitInstantiateExpr = function (ast, ctx) {
                    ctx.print(ast, "new ");
                    this.typeExpression++;
                    ast.classExpr.visitExpression(this, ctx);
                    this.typeExpression--;
                    ctx.print(ast, "(");
                    this.visitAllExpressions(ast.args, ctx, ',');
                    ctx.print(ast, ")");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitDeclareClassStmt = function (stmt, ctx) {
                    var _this = this;
                    ctx.pushClass(stmt);
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        ctx.print(stmt, "export ");
                    }
                    ctx.print(stmt, "class " + stmt.name);
                    if (stmt.parent != null) {
                        ctx.print(stmt, " extends ");
                        this.typeExpression++;
                        stmt.parent.visitExpression(this, ctx);
                        this.typeExpression--;
                    }
                    ctx.println(stmt, " {");
                    ctx.incIndent();
                    stmt.fields.forEach(function (field) { return _this._visitClassField(field, ctx); });
                    if (stmt.constructorMethod != null) {
                        this._visitClassConstructor(stmt, ctx);
                    }
                    stmt.getters.forEach(function (getter) { return _this._visitClassGetter(getter, ctx); });
                    stmt.methods.forEach(function (method) { return _this._visitClassMethod(method, ctx); });
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                    ctx.popClass();
                    return null;
                };
                _TsEmitterVisitor.prototype._visitClassField = function (field, ctx) {
                    if (field.hasModifier(StmtModifier.Private)) {
                        // comment out as a workaround for #10967
                        ctx.print(null, "/*private*/ ");
                    }
                    if (field.hasModifier(StmtModifier.Static)) {
                        ctx.print(null, 'static ');
                    }
                    ctx.print(null, field.name);
                    this._printColonType(field.type, ctx);
                    if (field.initializer) {
                        ctx.print(null, ' = ');
                        field.initializer.visitExpression(this, ctx);
                    }
                    ctx.println(null, ";");
                };
                _TsEmitterVisitor.prototype._visitClassGetter = function (getter, ctx) {
                    if (getter.hasModifier(StmtModifier.Private)) {
                        ctx.print(null, "private ");
                    }
                    ctx.print(null, "get " + getter.name + "()");
                    this._printColonType(getter.type, ctx);
                    ctx.println(null, " {");
                    ctx.incIndent();
                    this.visitAllStatements(getter.body, ctx);
                    ctx.decIndent();
                    ctx.println(null, "}");
                };
                _TsEmitterVisitor.prototype._visitClassConstructor = function (stmt, ctx) {
                    ctx.print(stmt, "constructor(");
                    this._visitParams(stmt.constructorMethod.params, ctx);
                    ctx.println(stmt, ") {");
                    ctx.incIndent();
                    this.visitAllStatements(stmt.constructorMethod.body, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                };
                _TsEmitterVisitor.prototype._visitClassMethod = function (method, ctx) {
                    if (method.hasModifier(StmtModifier.Private)) {
                        ctx.print(null, "private ");
                    }
                    ctx.print(null, method.name + "(");
                    this._visitParams(method.params, ctx);
                    ctx.print(null, ")");
                    this._printColonType(method.type, ctx, 'void');
                    ctx.println(null, " {");
                    ctx.incIndent();
                    this.visitAllStatements(method.body, ctx);
                    ctx.decIndent();
                    ctx.println(null, "}");
                };
                _TsEmitterVisitor.prototype.visitFunctionExpr = function (ast, ctx) {
                    if (ast.name) {
                        ctx.print(ast, 'function ');
                        ctx.print(ast, ast.name);
                    }
                    ctx.print(ast, "(");
                    this._visitParams(ast.params, ctx);
                    ctx.print(ast, ")");
                    this._printColonType(ast.type, ctx, 'void');
                    if (!ast.name) {
                        ctx.print(ast, " => ");
                    }
                    ctx.println(ast, '{');
                    ctx.incIndent();
                    this.visitAllStatements(ast.statements, ctx);
                    ctx.decIndent();
                    ctx.print(ast, "}");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        ctx.print(stmt, "export ");
                    }
                    ctx.print(stmt, "function " + stmt.name + "(");
                    this._visitParams(stmt.params, ctx);
                    ctx.print(stmt, ")");
                    this._printColonType(stmt.type, ctx, 'void');
                    ctx.println(stmt, " {");
                    ctx.incIndent();
                    this.visitAllStatements(stmt.statements, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitTryCatchStmt = function (stmt, ctx) {
                    ctx.println(stmt, "try {");
                    ctx.incIndent();
                    this.visitAllStatements(stmt.bodyStmts, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "} catch (" + CATCH_ERROR_VAR$1.name + ") {");
                    ctx.incIndent();
                    var catchStmts = [CATCH_STACK_VAR$1.set(CATCH_ERROR_VAR$1.prop('stack', null)).toDeclStmt(null, [
                            StmtModifier.Final
                        ])].concat(stmt.catchStmts);
                    this.visitAllStatements(catchStmts, ctx);
                    ctx.decIndent();
                    ctx.println(stmt, "}");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitBuiltinType = function (type, ctx) {
                    var typeStr;
                    switch (type.name) {
                        case BuiltinTypeName.Bool:
                            typeStr = 'boolean';
                            break;
                        case BuiltinTypeName.Dynamic:
                            typeStr = 'any';
                            break;
                        case BuiltinTypeName.Function:
                            typeStr = 'Function';
                            break;
                        case BuiltinTypeName.Number:
                            typeStr = 'number';
                            break;
                        case BuiltinTypeName.Int:
                            typeStr = 'number';
                            break;
                        case BuiltinTypeName.String:
                            typeStr = 'string';
                            break;
                        case BuiltinTypeName.None:
                            typeStr = 'never';
                            break;
                        default:
                            throw new Error("Unsupported builtin type " + type.name);
                    }
                    ctx.print(null, typeStr);
                    return null;
                };
                _TsEmitterVisitor.prototype.visitExpressionType = function (ast, ctx) {
                    var _this = this;
                    ast.value.visitExpression(this, ctx);
                    if (ast.typeParams !== null) {
                        ctx.print(null, '<');
                        this.visitAllObjects(function (type) { return _this.visitType(type, ctx); }, ast.typeParams, ctx, ',');
                        ctx.print(null, '>');
                    }
                    return null;
                };
                _TsEmitterVisitor.prototype.visitArrayType = function (type, ctx) {
                    this.visitType(type.of, ctx);
                    ctx.print(null, "[]");
                    return null;
                };
                _TsEmitterVisitor.prototype.visitMapType = function (type, ctx) {
                    ctx.print(null, "{[key: string]:");
                    this.visitType(type.valueType, ctx);
                    ctx.print(null, "}");
                    return null;
                };
                _TsEmitterVisitor.prototype.getBuiltinMethodName = function (method) {
                    var name;
                    switch (method) {
                        case BuiltinMethod.ConcatArray:
                            name = 'concat';
                            break;
                        case BuiltinMethod.SubscribeObservable:
                            name = 'subscribe';
                            break;
                        case BuiltinMethod.Bind:
                            name = 'bind';
                            break;
                        default:
                            throw new Error("Unknown builtin method: " + method);
                    }
                    return name;
                };
                _TsEmitterVisitor.prototype._visitParams = function (params, ctx) {
                    var _this = this;
                    this.visitAllObjects(function (param) {
                        ctx.print(null, param.name);
                        _this._printColonType(param.type, ctx);
                    }, params, ctx, ',');
                };
                _TsEmitterVisitor.prototype._visitIdentifier = function (value, typeParams, ctx) {
                    var _this = this;
                    var name = value.name, moduleName = value.moduleName;
                    if (this.referenceFilter && this.referenceFilter(value)) {
                        ctx.print(null, '(null as any)');
                        return;
                    }
                    if (moduleName && (!this.importFilter || !this.importFilter(value))) {
                        var prefix = this.importsWithPrefixes.get(moduleName);
                        if (prefix == null) {
                            prefix = "i" + this.importsWithPrefixes.size;
                            this.importsWithPrefixes.set(moduleName, prefix);
                        }
                        ctx.print(null, prefix + ".");
                    }
                    ctx.print(null, name);
                    if (this.typeExpression > 0) {
                        // If we are in a type expression that refers to a generic type then supply
                        // the required type parameters. If there were not enough type parameters
                        // supplied, supply any as the type. Outside a type expression the reference
                        // should not supply type parameters and be treated as a simple value reference
                        // to the constructor function itself.
                        var suppliedParameters = typeParams || [];
                        if (suppliedParameters.length > 0) {
                            ctx.print(null, "<");
                            this.visitAllObjects(function (type) { return type.visitType(_this, ctx); }, typeParams, ctx, ',');
                            ctx.print(null, ">");
                        }
                    }
                };
                _TsEmitterVisitor.prototype._printColonType = function (type, ctx, defaultType) {
                    if (type !== INFERRED_TYPE) {
                        ctx.print(null, ':');
                        this.visitType(type, ctx, defaultType);
                    }
                };
                return _TsEmitterVisitor;
            }(AbstractEmitterVisitor));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Resolve a `Type` for {@link Pipe}.
             *
             * This interface can be overridden by the application developer to create custom behavior.
             *
             * See {@link Compiler}
             */
            var PipeResolver = /** @class */ (function () {
                function PipeResolver(_reflector) {
                    this._reflector = _reflector;
                }
                PipeResolver.prototype.isPipe = function (type) {
                    var typeMetadata = this._reflector.annotations(resolveForwardRef(type));
                    return typeMetadata && typeMetadata.some(createPipe.isTypeOf);
                };
                /**
                 * Return {@link Pipe} for a given `Type`.
                 */
                PipeResolver.prototype.resolve = function (type, throwIfNotFound) {
                    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
                    var metas = this._reflector.annotations(resolveForwardRef(type));
                    if (metas) {
                        var annotation = findLast(metas, createPipe.isTypeOf);
                        if (annotation) {
                            return annotation;
                        }
                    }
                    if (throwIfNotFound) {
                        throw new Error("No Pipe decorator found on " + stringify(type));
                    }
                    return null;
                };
                return PipeResolver;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Generates code that is used to type check templates.
             */
            var TypeCheckCompiler = /** @class */ (function () {
                function TypeCheckCompiler(options, reflector) {
                    this.options = options;
                    this.reflector = reflector;
                }
                /**
                 * Important notes:
                 * - This must not produce new `import` statements, but only refer to types outside
                 *   of the file via the variables provided via externalReferenceVars.
                 *   This allows Typescript to reuse the old program's structure as no imports have changed.
                 * - This must not produce any exports, as this would pollute the .d.ts file
                 *   and also violate the point above.
                 */
                TypeCheckCompiler.prototype.compileComponent = function (componentId, component, template, usedPipes, externalReferenceVars, ctx) {
                    var _this = this;
                    var pipes = new Map();
                    usedPipes.forEach(function (p) { return pipes.set(p.name, p.type.reference); });
                    var embeddedViewCount = 0;
                    var viewBuilderFactory = function (parent, guards) {
                        var embeddedViewIndex = embeddedViewCount++;
                        return new ViewBuilder(_this.options, _this.reflector, externalReferenceVars, parent, component.type.reference, component.isHost, embeddedViewIndex, pipes, guards, ctx, viewBuilderFactory);
                    };
                    var visitor = viewBuilderFactory(null, []);
                    visitor.visitAll([], template);
                    return visitor.build(componentId);
                };
                return TypeCheckCompiler;
            }());
            var DYNAMIC_VAR_NAME = '_any';
            var TypeCheckLocalResolver = /** @class */ (function () {
                function TypeCheckLocalResolver() {
                }
                TypeCheckLocalResolver.prototype.notifyImplicitReceiverUse = function () { };
                TypeCheckLocalResolver.prototype.getLocal = function (name) {
                    if (name === EventHandlerVars.event.name) {
                        // References to the event should not be type-checked.
                        // TODO(chuckj): determine a better type for the event.
                        return variable(DYNAMIC_VAR_NAME);
                    }
                    return null;
                };
                return TypeCheckLocalResolver;
            }());
            var defaultResolver = new TypeCheckLocalResolver();
            var ViewBuilder = /** @class */ (function () {
                function ViewBuilder(options, reflector, externalReferenceVars, parent, component, isHostComponent, embeddedViewIndex, pipes, guards, ctx, viewBuilderFactory) {
                    this.options = options;
                    this.reflector = reflector;
                    this.externalReferenceVars = externalReferenceVars;
                    this.parent = parent;
                    this.component = component;
                    this.isHostComponent = isHostComponent;
                    this.embeddedViewIndex = embeddedViewIndex;
                    this.pipes = pipes;
                    this.guards = guards;
                    this.ctx = ctx;
                    this.viewBuilderFactory = viewBuilderFactory;
                    this.refOutputVars = new Map();
                    this.variables = [];
                    this.children = [];
                    this.updates = [];
                    this.actions = [];
                }
                ViewBuilder.prototype.getOutputVar = function (type) {
                    var varName;
                    if (type === this.component && this.isHostComponent) {
                        varName = DYNAMIC_VAR_NAME;
                    }
                    else if (type instanceof StaticSymbol) {
                        varName = this.externalReferenceVars.get(type);
                    }
                    else {
                        varName = DYNAMIC_VAR_NAME;
                    }
                    if (!varName) {
                        throw new Error("Illegal State: referring to a type without a variable " + JSON.stringify(type));
                    }
                    return varName;
                };
                ViewBuilder.prototype.getTypeGuardExpressions = function (ast) {
                    var result = this.guards.slice();
                    for (var _c = 0, _d = ast.directives; _c < _d.length; _c++) {
                        var directive = _d[_c];
                        for (var _e = 0, _f = directive.inputs; _e < _f.length; _e++) {
                            var input = _f[_e];
                            var guard = directive.directive.guards[input.directiveName];
                            if (guard) {
                                var useIf = guard === 'UseIf';
                                result.push({
                                    guard: guard,
                                    useIf: useIf,
                                    expression: { context: this.component, value: input.value }
                                });
                            }
                        }
                    }
                    return result;
                };
                ViewBuilder.prototype.visitAll = function (variables, astNodes) {
                    this.variables = variables;
                    templateVisitAll(this, astNodes);
                };
                ViewBuilder.prototype.build = function (componentId, targetStatements) {
                    var _this = this;
                    if (targetStatements === void 0) { targetStatements = []; }
                    this.children.forEach(function (child) { return child.build(componentId, targetStatements); });
                    var viewStmts = [variable(DYNAMIC_VAR_NAME).set(NULL_EXPR).toDeclStmt(DYNAMIC_TYPE)];
                    var bindingCount = 0;
                    this.updates.forEach(function (expression) {
                        var _c = _this.preprocessUpdateExpression(expression), sourceSpan = _c.sourceSpan, context = _c.context, value = _c.value;
                        var bindingId = "" + bindingCount++;
                        var nameResolver = context === _this.component ? _this : defaultResolver;
                        var _d = convertPropertyBinding(nameResolver, variable(_this.getOutputVar(context)), value, bindingId, BindingForm.General), stmts = _d.stmts, currValExpr = _d.currValExpr;
                        stmts.push(new ExpressionStatement(currValExpr));
                        viewStmts.push.apply(viewStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
                    });
                    this.actions.forEach(function (_c) {
                        var sourceSpan = _c.sourceSpan, context = _c.context, value = _c.value;
                        var bindingId = "" + bindingCount++;
                        var nameResolver = context === _this.component ? _this : defaultResolver;
                        var stmts = convertActionBinding(nameResolver, variable(_this.getOutputVar(context)), value, bindingId).stmts;
                        viewStmts.push.apply(viewStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
                    });
                    if (this.guards.length) {
                        var guardExpression = undefined;
                        for (var _c = 0, _d = this.guards; _c < _d.length; _c++) {
                            var guard = _d[_c];
                            var _e = this.preprocessUpdateExpression(guard.expression), context = _e.context, value = _e.value;
                            var bindingId = "" + bindingCount++;
                            var nameResolver = context === this.component ? this : defaultResolver;
                            // We only support support simple expressions and ignore others as they
                            // are unlikely to affect type narrowing.
                            var _f = convertPropertyBinding(nameResolver, variable(this.getOutputVar(context)), value, bindingId, BindingForm.TrySimple), stmts = _f.stmts, currValExpr = _f.currValExpr;
                            if (stmts.length == 0) {
                                var guardClause = guard.useIf ? currValExpr : this.ctx.importExpr(guard.guard).callFn([currValExpr]);
                                guardExpression = guardExpression ? guardExpression.and(guardClause) : guardClause;
                            }
                        }
                        if (guardExpression) {
                            viewStmts = [new IfStmt(guardExpression, viewStmts)];
                        }
                    }
                    var viewName = "_View_" + componentId + "_" + this.embeddedViewIndex;
                    var viewFactory = new DeclareFunctionStmt(viewName, [], viewStmts);
                    targetStatements.push(viewFactory);
                    return targetStatements;
                };
                ViewBuilder.prototype.visitBoundText = function (ast, context) {
                    var _this = this;
                    var astWithSource = ast.value;
                    var inter = astWithSource.ast;
                    inter.expressions.forEach(function (expr) { return _this.updates.push({ context: _this.component, value: expr, sourceSpan: ast.sourceSpan }); });
                };
                ViewBuilder.prototype.visitEmbeddedTemplate = function (ast, context) {
                    this.visitElementOrTemplate(ast);
                    // Note: The old view compiler used to use an `any` type
                    // for the context in any embedded view.
                    // We keep this behaivor behind a flag for now.
                    if (this.options.fullTemplateTypeCheck) {
                        // Find any applicable type guards. For example, NgIf has a type guard on ngIf
                        // (see NgIf.ngIfTypeGuard) that can be used to indicate that a template is only
                        // stamped out if ngIf is truthy so any bindings in the template can assume that,
                        // if a nullable type is used for ngIf, that expression is not null or undefined.
                        var guards = this.getTypeGuardExpressions(ast);
                        var childVisitor = this.viewBuilderFactory(this, guards);
                        this.children.push(childVisitor);
                        childVisitor.visitAll(ast.variables, ast.children);
                    }
                };
                ViewBuilder.prototype.visitElement = function (ast, context) {
                    var _this = this;
                    this.visitElementOrTemplate(ast);
                    var inputDefs = [];
                    var updateRendererExpressions = [];
                    var outputDefs = [];
                    ast.inputs.forEach(function (inputAst) {
                        _this.updates.push({ context: _this.component, value: inputAst.value, sourceSpan: inputAst.sourceSpan });
                    });
                    templateVisitAll(this, ast.children);
                };
                ViewBuilder.prototype.visitElementOrTemplate = function (ast) {
                    var _this = this;
                    ast.directives.forEach(function (dirAst) { _this.visitDirective(dirAst); });
                    ast.references.forEach(function (ref) {
                        var outputVarType = null;
                        // Note: The old view compiler used to use an `any` type
                        // for directives exposed via `exportAs`.
                        // We keep this behaivor behind a flag for now.
                        if (ref.value && ref.value.identifier && _this.options.fullTemplateTypeCheck) {
                            outputVarType = ref.value.identifier.reference;
                        }
                        else {
                            outputVarType = BuiltinTypeName.Dynamic;
                        }
                        _this.refOutputVars.set(ref.name, outputVarType);
                    });
                    ast.outputs.forEach(function (outputAst) {
                        _this.actions.push({ context: _this.component, value: outputAst.handler, sourceSpan: outputAst.sourceSpan });
                    });
                };
                ViewBuilder.prototype.visitDirective = function (dirAst) {
                    var _this = this;
                    var dirType = dirAst.directive.type.reference;
                    dirAst.inputs.forEach(function (input) { return _this.updates.push({ context: _this.component, value: input.value, sourceSpan: input.sourceSpan }); });
                    // Note: The old view compiler used to use an `any` type
                    // for expressions in host properties / events.
                    // We keep this behaivor behind a flag for now.
                    if (this.options.fullTemplateTypeCheck) {
                        dirAst.hostProperties.forEach(function (inputAst) { return _this.updates.push({ context: dirType, value: inputAst.value, sourceSpan: inputAst.sourceSpan }); });
                        dirAst.hostEvents.forEach(function (hostEventAst) { return _this.actions.push({
                            context: dirType,
                            value: hostEventAst.handler,
                            sourceSpan: hostEventAst.sourceSpan
                        }); });
                    }
                };
                ViewBuilder.prototype.notifyImplicitReceiverUse = function () { };
                ViewBuilder.prototype.getLocal = function (name) {
                    if (name == EventHandlerVars.event.name) {
                        return variable(this.getOutputVar(BuiltinTypeName.Dynamic));
                    }
                    for (var currBuilder = this; currBuilder; currBuilder = currBuilder.parent) {
                        var outputVarType = void 0;
                        // check references
                        outputVarType = currBuilder.refOutputVars.get(name);
                        if (outputVarType == null) {
                            // check variables
                            var varAst = currBuilder.variables.find(function (varAst) { return varAst.name === name; });
                            if (varAst) {
                                outputVarType = BuiltinTypeName.Dynamic;
                            }
                        }
                        if (outputVarType != null) {
                            return variable(this.getOutputVar(outputVarType));
                        }
                    }
                    return null;
                };
                ViewBuilder.prototype.pipeOutputVar = function (name) {
                    var pipe = this.pipes.get(name);
                    if (!pipe) {
                        throw new Error("Illegal State: Could not find pipe " + name + " in template of " + this.component);
                    }
                    return this.getOutputVar(pipe);
                };
                ViewBuilder.prototype.preprocessUpdateExpression = function (expression) {
                    var _this = this;
                    return {
                        sourceSpan: expression.sourceSpan,
                        context: expression.context,
                        value: convertPropertyBindingBuiltins({
                            createLiteralArrayConverter: function (argCount) { return function (args) {
                                var arr = literalArr(args);
                                // Note: The old view compiler used to use an `any` type
                                // for arrays.
                                return _this.options.fullTemplateTypeCheck ? arr : arr.cast(DYNAMIC_TYPE);
                            }; },
                            createLiteralMapConverter: function (keys) { return function (values) {
                                var entries = keys.map(function (k, i) { return ({
                                    key: k.key,
                                    value: values[i],
                                    quoted: k.quoted,
                                }); });
                                var map = literalMap(entries);
                                // Note: The old view compiler used to use an `any` type
                                // for maps.
                                return _this.options.fullTemplateTypeCheck ? map : map.cast(DYNAMIC_TYPE);
                            }; },
                            createPipeConverter: function (name, argCount) { return function (args) {
                                // Note: The old view compiler used to use an `any` type
                                // for pipes.
                                var pipeExpr = _this.options.fullTemplateTypeCheck ?
                                    variable(_this.pipeOutputVar(name)) :
                                    variable(_this.getOutputVar(BuiltinTypeName.Dynamic));
                                return pipeExpr.callMethod('transform', args);
                            }; },
                        }, expression.value)
                    };
                };
                ViewBuilder.prototype.visitNgContent = function (ast, context) { };
                ViewBuilder.prototype.visitText = function (ast, context) { };
                ViewBuilder.prototype.visitDirectiveProperty = function (ast, context) { };
                ViewBuilder.prototype.visitReference = function (ast, context) { };
                ViewBuilder.prototype.visitVariable = function (ast, context) { };
                ViewBuilder.prototype.visitEvent = function (ast, context) { };
                ViewBuilder.prototype.visitElementProperty = function (ast, context) { };
                ViewBuilder.prototype.visitAttr = function (ast, context) { };
                return ViewBuilder;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var CLASS_ATTR$1 = 'class';
            var STYLE_ATTR = 'style';
            var IMPLICIT_TEMPLATE_VAR = '\$implicit';
            var ViewCompileResult = /** @class */ (function () {
                function ViewCompileResult(viewClassVar, rendererTypeVar) {
                    this.viewClassVar = viewClassVar;
                    this.rendererTypeVar = rendererTypeVar;
                }
                return ViewCompileResult;
            }());
            var ViewCompiler = /** @class */ (function () {
                function ViewCompiler(_reflector) {
                    this._reflector = _reflector;
                }
                ViewCompiler.prototype.compileComponent = function (outputCtx, component, template, styles, usedPipes) {
                    var _c;
                    var _this = this;
                    var embeddedViewCount = 0;
                    var staticQueryIds = findStaticQueryIds(template);
                    var renderComponentVarName = undefined;
                    if (!component.isHost) {
                        var template_1 = component.template;
                        var customRenderData = [];
                        if (template_1.animations && template_1.animations.length) {
                            customRenderData.push(new LiteralMapEntry('animation', convertValueToOutputAst(outputCtx, template_1.animations), true));
                        }
                        var renderComponentVar = variable(rendererTypeName(component.type.reference));
                        renderComponentVarName = renderComponentVar.name;
                        outputCtx.statements.push(renderComponentVar
                            .set(importExpr(Identifiers.createRendererType2).callFn([new LiteralMapExpr([
                                new LiteralMapEntry('encapsulation', literal(template_1.encapsulation), false),
                                new LiteralMapEntry('styles', styles, false),
                                new LiteralMapEntry('data', new LiteralMapExpr(customRenderData), false)
                            ])]))
                            .toDeclStmt(importType(Identifiers.RendererType2), [StmtModifier.Final, StmtModifier.Exported]));
                    }
                    var viewBuilderFactory = function (parent) {
                        var embeddedViewIndex = embeddedViewCount++;
                        return new ViewBuilder$1(_this._reflector, outputCtx, parent, component, embeddedViewIndex, usedPipes, staticQueryIds, viewBuilderFactory);
                    };
                    var visitor = viewBuilderFactory(null);
                    visitor.visitAll([], template);
                    (_c = outputCtx.statements).push.apply(_c, visitor.build());
                    return new ViewCompileResult(visitor.viewName, renderComponentVarName);
                };
                return ViewCompiler;
            }());
            var LOG_VAR$1 = variable('_l');
            var VIEW_VAR = variable('_v');
            var CHECK_VAR = variable('_ck');
            var COMP_VAR = variable('_co');
            var EVENT_NAME_VAR = variable('en');
            var ALLOW_DEFAULT_VAR = variable("ad");
            var ViewBuilder$1 = /** @class */ (function () {
                function ViewBuilder$1(reflector, outputCtx, parent, component, embeddedViewIndex, usedPipes, staticQueryIds, viewBuilderFactory) {
                    this.reflector = reflector;
                    this.outputCtx = outputCtx;
                    this.parent = parent;
                    this.component = component;
                    this.embeddedViewIndex = embeddedViewIndex;
                    this.usedPipes = usedPipes;
                    this.staticQueryIds = staticQueryIds;
                    this.viewBuilderFactory = viewBuilderFactory;
                    this.nodes = [];
                    this.purePipeNodeIndices = Object.create(null);
                    // Need Object.create so that we don't have builtin values...
                    this.refNodeIndices = Object.create(null);
                    this.variables = [];
                    this.children = [];
                    // TODO(tbosch): The old view compiler used to use an `any` type
                    // for the context in any embedded view. We keep this behaivor for now
                    // to be able to introduce the new view compiler without too many errors.
                    this.compType = this.embeddedViewIndex > 0 ?
                        DYNAMIC_TYPE :
                        expressionType(outputCtx.importExpr(this.component.type.reference));
                    this.viewName = viewClassName(this.component.type.reference, this.embeddedViewIndex);
                }
                ViewBuilder$1.prototype.visitAll = function (variables, astNodes) {
                    var _this = this;
                    this.variables = variables;
                    // create the pipes for the pure pipes immediately, so that we know their indices.
                    if (!this.parent) {
                        this.usedPipes.forEach(function (pipe) {
                            if (pipe.pure) {
                                _this.purePipeNodeIndices[pipe.name] = _this._createPipe(null, pipe);
                            }
                        });
                    }
                    if (!this.parent) {
                        var queryIds_1 = staticViewQueryIds(this.staticQueryIds);
                        this.component.viewQueries.forEach(function (query, queryIndex) {
                            // Note: queries start with id 1 so we can use the number in a Bloom filter!
                            var queryId = queryIndex + 1;
                            var bindingType = query.first ? 0 /* First */ : 1 /* All */;
                            var flags = 134217728 /* TypeViewQuery */ | calcStaticDynamicQueryFlags(queryIds_1, queryId, query);
                            _this.nodes.push(function () { return ({
                                sourceSpan: null,
                                nodeFlags: flags,
                                nodeDef: importExpr(Identifiers.queryDef).callFn([
                                    literal(flags), literal(queryId),
                                    new LiteralMapExpr([new LiteralMapEntry(query.propertyName, literal(bindingType), false)])
                                ])
                            }); });
                        });
                    }
                    templateVisitAll(this, astNodes);
                    if (this.parent && (astNodes.length === 0 || needsAdditionalRootNode(astNodes))) {
                        // if the view is an embedded view, then we need to add an additional root node in some cases
                        this.nodes.push(function () { return ({
                            sourceSpan: null,
                            nodeFlags: 1 /* TypeElement */,
                            nodeDef: importExpr(Identifiers.anchorDef).callFn([
                                literal(0 /* None */), NULL_EXPR, NULL_EXPR, literal(0)
                            ])
                        }); });
                    }
                };
                ViewBuilder$1.prototype.build = function (targetStatements) {
                    if (targetStatements === void 0) { targetStatements = []; }
                    this.children.forEach(function (child) { return child.build(targetStatements); });
                    var _c = this._createNodeExpressions(), updateRendererStmts = _c.updateRendererStmts, updateDirectivesStmts = _c.updateDirectivesStmts, nodeDefExprs = _c.nodeDefExprs;
                    var updateRendererFn = this._createUpdateFn(updateRendererStmts);
                    var updateDirectivesFn = this._createUpdateFn(updateDirectivesStmts);
                    var viewFlags = 0 /* None */;
                    if (!this.parent && this.component.changeDetection === ChangeDetectionStrategy.OnPush) {
                        viewFlags |= 2 /* OnPush */;
                    }
                    var viewFactory = new DeclareFunctionStmt(this.viewName, [new FnParam(LOG_VAR$1.name)], [new ReturnStatement(importExpr(Identifiers.viewDef).callFn([
                            literal(viewFlags),
                            literalArr(nodeDefExprs),
                            updateDirectivesFn,
                            updateRendererFn,
                        ]))], importType(Identifiers.ViewDefinition), this.embeddedViewIndex === 0 ? [StmtModifier.Exported] : []);
                    targetStatements.push(viewFactory);
                    return targetStatements;
                };
                ViewBuilder$1.prototype._createUpdateFn = function (updateStmts) {
                    var updateFn;
                    if (updateStmts.length > 0) {
                        var preStmts = [];
                        if (!this.component.isHost && findReadVarNames(updateStmts).has(COMP_VAR.name)) {
                            preStmts.push(COMP_VAR.set(VIEW_VAR.prop('component')).toDeclStmt(this.compType));
                        }
                        updateFn = fn([
                            new FnParam(CHECK_VAR.name, INFERRED_TYPE),
                            new FnParam(VIEW_VAR.name, INFERRED_TYPE)
                        ], preStmts.concat(updateStmts), INFERRED_TYPE);
                    }
                    else {
                        updateFn = NULL_EXPR;
                    }
                    return updateFn;
                };
                ViewBuilder$1.prototype.visitNgContent = function (ast, context) {
                    // ngContentDef(ngContentIndex: number, index: number): NodeDef;
                    this.nodes.push(function () { return ({
                        sourceSpan: ast.sourceSpan,
                        nodeFlags: 8 /* TypeNgContent */,
                        nodeDef: importExpr(Identifiers.ngContentDef).callFn([
                            literal(ast.ngContentIndex), literal(ast.index)
                        ])
                    }); });
                };
                ViewBuilder$1.prototype.visitText = function (ast, context) {
                    // Static text nodes have no check function
                    var checkIndex = -1;
                    this.nodes.push(function () { return ({
                        sourceSpan: ast.sourceSpan,
                        nodeFlags: 2 /* TypeText */,
                        nodeDef: importExpr(Identifiers.textDef).callFn([
                            literal(checkIndex),
                            literal(ast.ngContentIndex),
                            literalArr([literal(ast.value)]),
                        ])
                    }); });
                };
                ViewBuilder$1.prototype.visitBoundText = function (ast, context) {
                    var _this = this;
                    var nodeIndex = this.nodes.length;
                    // reserve the space in the nodeDefs array
                    this.nodes.push(null);
                    var astWithSource = ast.value;
                    var inter = astWithSource.ast;
                    var updateRendererExpressions = inter.expressions.map(function (expr, bindingIndex) { return _this._preprocessUpdateExpression({ nodeIndex: nodeIndex, bindingIndex: bindingIndex, sourceSpan: ast.sourceSpan, context: COMP_VAR, value: expr }); });
                    // Check index is the same as the node index during compilation
                    // They might only differ at runtime
                    var checkIndex = nodeIndex;
                    this.nodes[nodeIndex] = function () { return ({
                        sourceSpan: ast.sourceSpan,
                        nodeFlags: 2 /* TypeText */,
                        nodeDef: importExpr(Identifiers.textDef).callFn([
                            literal(checkIndex),
                            literal(ast.ngContentIndex),
                            literalArr(inter.strings.map(function (s) { return literal(s); })),
                        ]),
                        updateRenderer: updateRendererExpressions
                    }); };
                };
                ViewBuilder$1.prototype.visitEmbeddedTemplate = function (ast, context) {
                    var _this = this;
                    var nodeIndex = this.nodes.length;
                    // reserve the space in the nodeDefs array
                    this.nodes.push(null);
                    var _c = this._visitElementOrTemplate(nodeIndex, ast), flags = _c.flags, queryMatchesExpr = _c.queryMatchesExpr, hostEvents = _c.hostEvents;
                    var childVisitor = this.viewBuilderFactory(this);
                    this.children.push(childVisitor);
                    childVisitor.visitAll(ast.variables, ast.children);
                    var childCount = this.nodes.length - nodeIndex - 1;
                    // anchorDef(
                    //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], ngContentIndex: number,
                    //   childCount: number, handleEventFn?: ElementHandleEventFn, templateFactory?:
                    //   ViewDefinitionFactory): NodeDef;
                    this.nodes[nodeIndex] = function () { return ({
                        sourceSpan: ast.sourceSpan,
                        nodeFlags: 1 /* TypeElement */ | flags,
                        nodeDef: importExpr(Identifiers.anchorDef).callFn([
                            literal(flags),
                            queryMatchesExpr,
                            literal(ast.ngContentIndex),
                            literal(childCount),
                            _this._createElementHandleEventFn(nodeIndex, hostEvents),
                            variable(childVisitor.viewName),
                        ])
                    }); };
                };
                ViewBuilder$1.prototype.visitElement = function (ast, context) {
                    var _this = this;
                    var nodeIndex = this.nodes.length;
                    // reserve the space in the nodeDefs array so we can add children
                    this.nodes.push(null);
                    // Using a null element name creates an anchor.
                    var elName = isNgContainer(ast.name) ? null : ast.name;
                    var _c = this._visitElementOrTemplate(nodeIndex, ast), flags = _c.flags, usedEvents = _c.usedEvents, queryMatchesExpr = _c.queryMatchesExpr, dirHostBindings = _c.hostBindings, hostEvents = _c.hostEvents;
                    var inputDefs = [];
                    var updateRendererExpressions = [];
                    var outputDefs = [];
                    if (elName) {
                        var hostBindings = ast.inputs
                            .map(function (inputAst) { return ({
                            context: COMP_VAR,
                            inputAst: inputAst,
                            dirAst: null,
                        }); })
                            .concat(dirHostBindings);
                        if (hostBindings.length) {
                            updateRendererExpressions =
                                hostBindings.map(function (hostBinding, bindingIndex) { return _this._preprocessUpdateExpression({
                                    context: hostBinding.context,
                                    nodeIndex: nodeIndex,
                                    bindingIndex: bindingIndex,
                                    sourceSpan: hostBinding.inputAst.sourceSpan,
                                    value: hostBinding.inputAst.value
                                }); });
                            inputDefs = hostBindings.map(function (hostBinding) { return elementBindingDef(hostBinding.inputAst, hostBinding.dirAst); });
                        }
                        outputDefs = usedEvents.map(function (_c) {
                            var target = _c[0], eventName = _c[1];
                            return literalArr([literal(target), literal(eventName)]);
                        });
                    }
                    templateVisitAll(this, ast.children);
                    var childCount = this.nodes.length - nodeIndex - 1;
                    var compAst = ast.directives.find(function (dirAst) { return dirAst.directive.isComponent; });
                    var compRendererType = NULL_EXPR;
                    var compView = NULL_EXPR;
                    if (compAst) {
                        compView = this.outputCtx.importExpr(compAst.directive.componentViewType);
                        compRendererType = this.outputCtx.importExpr(compAst.directive.rendererType);
                    }
                    // Check index is the same as the node index during compilation
                    // They might only differ at runtime
                    var checkIndex = nodeIndex;
                    this.nodes[nodeIndex] = function () { return ({
                        sourceSpan: ast.sourceSpan,
                        nodeFlags: 1 /* TypeElement */ | flags,
                        nodeDef: importExpr(Identifiers.elementDef).callFn([
                            literal(checkIndex),
                            literal(flags),
                            queryMatchesExpr,
                            literal(ast.ngContentIndex),
                            literal(childCount),
                            literal(elName),
                            elName ? fixedAttrsDef(ast) : NULL_EXPR,
                            inputDefs.length ? literalArr(inputDefs) : NULL_EXPR,
                            outputDefs.length ? literalArr(outputDefs) : NULL_EXPR,
                            _this._createElementHandleEventFn(nodeIndex, hostEvents),
                            compView,
                            compRendererType,
                        ]),
                        updateRenderer: updateRendererExpressions
                    }); };
                };
                ViewBuilder$1.prototype._visitElementOrTemplate = function (nodeIndex, ast) {
                    var _this = this;
                    var flags = 0 /* None */;
                    if (ast.hasViewContainer) {
                        flags |= 16777216 /* EmbeddedViews */;
                    }
                    var usedEvents = new Map();
                    ast.outputs.forEach(function (event) {
                        var _c = elementEventNameAndTarget(event, null), name = _c.name, target = _c.target;
                        usedEvents.set(elementEventFullName(target, name), [target, name]);
                    });
                    ast.directives.forEach(function (dirAst) {
                        dirAst.hostEvents.forEach(function (event) {
                            var _c = elementEventNameAndTarget(event, dirAst), name = _c.name, target = _c.target;
                            usedEvents.set(elementEventFullName(target, name), [target, name]);
                        });
                    });
                    var hostBindings = [];
                    var hostEvents = [];
                    this._visitComponentFactoryResolverProvider(ast.directives);
                    ast.providers.forEach(function (providerAst, providerIndex) {
                        var dirAst = undefined;
                        var dirIndex = undefined;
                        ast.directives.forEach(function (localDirAst, i) {
                            if (localDirAst.directive.type.reference === tokenReference(providerAst.token)) {
                                dirAst = localDirAst;
                                dirIndex = i;
                            }
                        });
                        if (dirAst) {
                            var _c = _this._visitDirective(providerAst, dirAst, dirIndex, nodeIndex, ast.references, ast.queryMatches, usedEvents, _this.staticQueryIds.get(ast)), dirHostBindings = _c.hostBindings, dirHostEvents = _c.hostEvents;
                            hostBindings.push.apply(hostBindings, dirHostBindings);
                            hostEvents.push.apply(hostEvents, dirHostEvents);
                        }
                        else {
                            _this._visitProvider(providerAst, ast.queryMatches);
                        }
                    });
                    var queryMatchExprs = [];
                    ast.queryMatches.forEach(function (match) {
                        var valueType = undefined;
                        if (tokenReference(match.value) ===
                            _this.reflector.resolveExternalReference(Identifiers.ElementRef)) {
                            valueType = 0 /* ElementRef */;
                        }
                        else if (tokenReference(match.value) ===
                            _this.reflector.resolveExternalReference(Identifiers.ViewContainerRef)) {
                            valueType = 3 /* ViewContainerRef */;
                        }
                        else if (tokenReference(match.value) ===
                            _this.reflector.resolveExternalReference(Identifiers.TemplateRef)) {
                            valueType = 2 /* TemplateRef */;
                        }
                        if (valueType != null) {
                            queryMatchExprs.push(literalArr([literal(match.queryId), literal(valueType)]));
                        }
                    });
                    ast.references.forEach(function (ref) {
                        var valueType = undefined;
                        if (!ref.value) {
                            valueType = 1 /* RenderElement */;
                        }
                        else if (tokenReference(ref.value) ===
                            _this.reflector.resolveExternalReference(Identifiers.TemplateRef)) {
                            valueType = 2 /* TemplateRef */;
                        }
                        if (valueType != null) {
                            _this.refNodeIndices[ref.name] = nodeIndex;
                            queryMatchExprs.push(literalArr([literal(ref.name), literal(valueType)]));
                        }
                    });
                    ast.outputs.forEach(function (outputAst) {
                        hostEvents.push({ context: COMP_VAR, eventAst: outputAst, dirAst: null });
                    });
                    return {
                        flags: flags,
                        usedEvents: Array.from(usedEvents.values()),
                        queryMatchesExpr: queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
                        hostBindings: hostBindings,
                        hostEvents: hostEvents
                    };
                };
                ViewBuilder$1.prototype._visitDirective = function (providerAst, dirAst, directiveIndex, elementNodeIndex, refs, queryMatches, usedEvents, queryIds) {
                    var _this = this;
                    var nodeIndex = this.nodes.length;
                    // reserve the space in the nodeDefs array so we can add children
                    this.nodes.push(null);
                    dirAst.directive.queries.forEach(function (query, queryIndex) {
                        var queryId = dirAst.contentQueryStartId + queryIndex;
                        var flags = 67108864 /* TypeContentQuery */ | calcStaticDynamicQueryFlags(queryIds, queryId, query);
                        var bindingType = query.first ? 0 /* First */ : 1 /* All */;
                        _this.nodes.push(function () { return ({
                            sourceSpan: dirAst.sourceSpan,
                            nodeFlags: flags,
                            nodeDef: importExpr(Identifiers.queryDef).callFn([
                                literal(flags), literal(queryId),
                                new LiteralMapExpr([new LiteralMapEntry(query.propertyName, literal(bindingType), false)])
                            ]),
                        }); });
                    });
                    // Note: the operation below might also create new nodeDefs,
                    // but we don't want them to be a child of a directive,
                    // as they might be a provider/pipe on their own.
                    // I.e. we only allow queries as children of directives nodes.
                    var childCount = this.nodes.length - nodeIndex - 1;
                    var _c = this._visitProviderOrDirective(providerAst, queryMatches), flags = _c.flags, queryMatchExprs = _c.queryMatchExprs, providerExpr = _c.providerExpr, depsExpr = _c.depsExpr;
                    refs.forEach(function (ref) {
                        if (ref.value && tokenReference(ref.value) === tokenReference(providerAst.token)) {
                            _this.refNodeIndices[ref.name] = nodeIndex;
                            queryMatchExprs.push(literalArr([literal(ref.name), literal(4 /* Provider */)]));
                        }
                    });
                    if (dirAst.directive.isComponent) {
                        flags |= 32768 /* Component */;
                    }
                    var inputDefs = dirAst.inputs.map(function (inputAst, inputIndex) {
                        var mapValue = literalArr([literal(inputIndex), literal(inputAst.directiveName)]);
                        // Note: it's important to not quote the key so that we can capture renames by minifiers!
                        return new LiteralMapEntry(inputAst.directiveName, mapValue, false);
                    });
                    var outputDefs = [];
                    var dirMeta = dirAst.directive;
                    Object.keys(dirMeta.outputs).forEach(function (propName) {
                        var eventName = dirMeta.outputs[propName];
                        if (usedEvents.has(eventName)) {
                            // Note: it's important to not quote the key so that we can capture renames by minifiers!
                            outputDefs.push(new LiteralMapEntry(propName, literal(eventName), false));
                        }
                    });
                    var updateDirectiveExpressions = [];
                    if (dirAst.inputs.length || (flags & (262144 /* DoCheck */ | 65536 /* OnInit */)) > 0) {
                        updateDirectiveExpressions =
                            dirAst.inputs.map(function (input, bindingIndex) { return _this._preprocessUpdateExpression({
                                nodeIndex: nodeIndex,
                                bindingIndex: bindingIndex,
                                sourceSpan: input.sourceSpan,
                                context: COMP_VAR,
                                value: input.value
                            }); });
                    }
                    var dirContextExpr = importExpr(Identifiers.nodeValue).callFn([VIEW_VAR, literal(nodeIndex)]);
                    var hostBindings = dirAst.hostProperties.map(function (inputAst) { return ({
                        context: dirContextExpr,
                        dirAst: dirAst,
                        inputAst: inputAst,
                    }); });
                    var hostEvents = dirAst.hostEvents.map(function (hostEventAst) { return ({
                        context: dirContextExpr,
                        eventAst: hostEventAst, dirAst: dirAst,
                    }); });
                    // Check index is the same as the node index during compilation
                    // They might only differ at runtime
                    var checkIndex = nodeIndex;
                    this.nodes[nodeIndex] = function () { return ({
                        sourceSpan: dirAst.sourceSpan,
                        nodeFlags: 16384 /* TypeDirective */ | flags,
                        nodeDef: importExpr(Identifiers.directiveDef).callFn([
                            literal(checkIndex),
                            literal(flags),
                            queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
                            literal(childCount),
                            providerExpr,
                            depsExpr,
                            inputDefs.length ? new LiteralMapExpr(inputDefs) : NULL_EXPR,
                            outputDefs.length ? new LiteralMapExpr(outputDefs) : NULL_EXPR,
                        ]),
                        updateDirectives: updateDirectiveExpressions,
                        directive: dirAst.directive.type,
                    }); };
                    return { hostBindings: hostBindings, hostEvents: hostEvents };
                };
                ViewBuilder$1.prototype._visitProvider = function (providerAst, queryMatches) {
                    this._addProviderNode(this._visitProviderOrDirective(providerAst, queryMatches));
                };
                ViewBuilder$1.prototype._visitComponentFactoryResolverProvider = function (directives) {
                    var componentDirMeta = directives.find(function (dirAst) { return dirAst.directive.isComponent; });
                    if (componentDirMeta && componentDirMeta.directive.entryComponents.length) {
                        var _c = componentFactoryResolverProviderDef(this.reflector, this.outputCtx, 8192 /* PrivateProvider */, componentDirMeta.directive.entryComponents), providerExpr = _c.providerExpr, depsExpr = _c.depsExpr, flags = _c.flags, tokenExpr_1 = _c.tokenExpr;
                        this._addProviderNode({
                            providerExpr: providerExpr,
                            depsExpr: depsExpr,
                            flags: flags,
                            tokenExpr: tokenExpr_1,
                            queryMatchExprs: [],
                            sourceSpan: componentDirMeta.sourceSpan
                        });
                    }
                };
                ViewBuilder$1.prototype._addProviderNode = function (data) {
                    var nodeIndex = this.nodes.length;
                    // providerDef(
                    //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], token:any,
                    //   value: any, deps: ([DepFlags, any] | any)[]): NodeDef;
                    this.nodes.push(function () { return ({
                        sourceSpan: data.sourceSpan,
                        nodeFlags: data.flags,
                        nodeDef: importExpr(Identifiers.providerDef).callFn([
                            literal(data.flags),
                            data.queryMatchExprs.length ? literalArr(data.queryMatchExprs) : NULL_EXPR,
                            data.tokenExpr, data.providerExpr, data.depsExpr
                        ])
                    }); });
                };
                ViewBuilder$1.prototype._visitProviderOrDirective = function (providerAst, queryMatches) {
                    var flags = 0 /* None */;
                    var queryMatchExprs = [];
                    queryMatches.forEach(function (match) {
                        if (tokenReference(match.value) === tokenReference(providerAst.token)) {
                            queryMatchExprs.push(literalArr([literal(match.queryId), literal(4 /* Provider */)]));
                        }
                    });
                    var _c = providerDef(this.outputCtx, providerAst), providerExpr = _c.providerExpr, depsExpr = _c.depsExpr, providerFlags = _c.flags, tokenExpr = _c.tokenExpr;
                    return {
                        flags: flags | providerFlags,
                        queryMatchExprs: queryMatchExprs,
                        providerExpr: providerExpr,
                        depsExpr: depsExpr,
                        tokenExpr: tokenExpr,
                        sourceSpan: providerAst.sourceSpan
                    };
                };
                ViewBuilder$1.prototype.getLocal = function (name) {
                    if (name == EventHandlerVars.event.name) {
                        return EventHandlerVars.event;
                    }
                    var currViewExpr = VIEW_VAR;
                    for (var currBuilder = this; currBuilder; currBuilder = currBuilder.parent,
                        currViewExpr = currViewExpr.prop('parent').cast(DYNAMIC_TYPE)) {
                        // check references
                        var refNodeIndex = currBuilder.refNodeIndices[name];
                        if (refNodeIndex != null) {
                            return importExpr(Identifiers.nodeValue).callFn([currViewExpr, literal(refNodeIndex)]);
                        }
                        // check variables
                        var varAst = currBuilder.variables.find(function (varAst) { return varAst.name === name; });
                        if (varAst) {
                            var varValue = varAst.value || IMPLICIT_TEMPLATE_VAR;
                            return currViewExpr.prop('context').prop(varValue);
                        }
                    }
                    return null;
                };
                ViewBuilder$1.prototype.notifyImplicitReceiverUse = function () {
                    // Not needed in View Engine as View Engine walks through the generated
                    // expressions to figure out if the implicit receiver is used and needs
                    // to be generated as part of the pre-update statements.
                };
                ViewBuilder$1.prototype._createLiteralArrayConverter = function (sourceSpan, argCount) {
                    if (argCount === 0) {
                        var valueExpr_1 = importExpr(Identifiers.EMPTY_ARRAY);
                        return function () { return valueExpr_1; };
                    }
                    var checkIndex = this.nodes.length;
                    this.nodes.push(function () { return ({
                        sourceSpan: sourceSpan,
                        nodeFlags: 32 /* TypePureArray */,
                        nodeDef: importExpr(Identifiers.pureArrayDef).callFn([
                            literal(checkIndex),
                            literal(argCount),
                        ])
                    }); });
                    return function (args) { return callCheckStmt(checkIndex, args); };
                };
                ViewBuilder$1.prototype._createLiteralMapConverter = function (sourceSpan, keys) {
                    if (keys.length === 0) {
                        var valueExpr_2 = importExpr(Identifiers.EMPTY_MAP);
                        return function () { return valueExpr_2; };
                    }
                    var map = literalMap(keys.map(function (e, i) { return (Object.assign({}, e, { value: literal(i) })); }));
                    var checkIndex = this.nodes.length;
                    this.nodes.push(function () { return ({
                        sourceSpan: sourceSpan,
                        nodeFlags: 64 /* TypePureObject */,
                        nodeDef: importExpr(Identifiers.pureObjectDef).callFn([
                            literal(checkIndex),
                            map,
                        ])
                    }); });
                    return function (args) { return callCheckStmt(checkIndex, args); };
                };
                ViewBuilder$1.prototype._createPipeConverter = function (expression, name, argCount) {
                    var pipe = this.usedPipes.find(function (pipeSummary) { return pipeSummary.name === name; });
                    if (pipe.pure) {
                        var checkIndex_1 = this.nodes.length;
                        this.nodes.push(function () { return ({
                            sourceSpan: expression.sourceSpan,
                            nodeFlags: 128 /* TypePurePipe */,
                            nodeDef: importExpr(Identifiers.purePipeDef).callFn([
                                literal(checkIndex_1),
                                literal(argCount),
                            ])
                        }); });
                        // find underlying pipe in the component view
                        var compViewExpr = VIEW_VAR;
                        var compBuilder = this;
                        while (compBuilder.parent) {
                            compBuilder = compBuilder.parent;
                            compViewExpr = compViewExpr.prop('parent').cast(DYNAMIC_TYPE);
                        }
                        var pipeNodeIndex = compBuilder.purePipeNodeIndices[name];
                        var pipeValueExpr_1 = importExpr(Identifiers.nodeValue).callFn([compViewExpr, literal(pipeNodeIndex)]);
                        return function (args) { return callUnwrapValue(expression.nodeIndex, expression.bindingIndex, callCheckStmt(checkIndex_1, [pipeValueExpr_1].concat(args))); };
                    }
                    else {
                        var nodeIndex = this._createPipe(expression.sourceSpan, pipe);
                        var nodeValueExpr_1 = importExpr(Identifiers.nodeValue).callFn([VIEW_VAR, literal(nodeIndex)]);
                        return function (args) { return callUnwrapValue(expression.nodeIndex, expression.bindingIndex, nodeValueExpr_1.callMethod('transform', args)); };
                    }
                };
                ViewBuilder$1.prototype._createPipe = function (sourceSpan, pipe) {
                    var _this = this;
                    var nodeIndex = this.nodes.length;
                    var flags = 0 /* None */;
                    pipe.type.lifecycleHooks.forEach(function (lifecycleHook) {
                        // for pipes, we only support ngOnDestroy
                        if (lifecycleHook === LifecycleHooks.OnDestroy) {
                            flags |= lifecycleHookToNodeFlag(lifecycleHook);
                        }
                    });
                    var depExprs = pipe.type.diDeps.map(function (diDep) { return depDef(_this.outputCtx, diDep); });
                    // function pipeDef(
                    //   flags: NodeFlags, ctor: any, deps: ([DepFlags, any] | any)[]): NodeDef
                    this.nodes.push(function () { return ({
                        sourceSpan: sourceSpan,
                        nodeFlags: 16 /* TypePipe */,
                        nodeDef: importExpr(Identifiers.pipeDef).callFn([
                            literal(flags), _this.outputCtx.importExpr(pipe.type.reference), literalArr(depExprs)
                        ])
                    }); });
                    return nodeIndex;
                };
                /**
                 * For the AST in `UpdateExpression.value`:
                 * - create nodes for pipes, literal arrays and, literal maps,
                 * - update the AST to replace pipes, literal arrays and, literal maps with calls to check fn.
                 *
                 * WARNING: This might create new nodeDefs (for pipes and literal arrays and literal maps)!
                 */
                ViewBuilder$1.prototype._preprocessUpdateExpression = function (expression) {
                    var _this = this;
                    return {
                        nodeIndex: expression.nodeIndex,
                        bindingIndex: expression.bindingIndex,
                        sourceSpan: expression.sourceSpan,
                        context: expression.context,
                        value: convertPropertyBindingBuiltins({
                            createLiteralArrayConverter: function (argCount) { return _this._createLiteralArrayConverter(expression.sourceSpan, argCount); },
                            createLiteralMapConverter: function (keys) { return _this._createLiteralMapConverter(expression.sourceSpan, keys); },
                            createPipeConverter: function (name, argCount) { return _this._createPipeConverter(expression, name, argCount); }
                        }, expression.value)
                    };
                };
                ViewBuilder$1.prototype._createNodeExpressions = function () {
                    var self = this;
                    var updateBindingCount = 0;
                    var updateRendererStmts = [];
                    var updateDirectivesStmts = [];
                    var nodeDefExprs = this.nodes.map(function (factory, nodeIndex) {
                        var _c = factory(), nodeDef = _c.nodeDef, nodeFlags = _c.nodeFlags, updateDirectives = _c.updateDirectives, updateRenderer = _c.updateRenderer, sourceSpan = _c.sourceSpan;
                        if (updateRenderer) {
                            updateRendererStmts.push.apply(updateRendererStmts, createUpdateStatements(nodeIndex, sourceSpan, updateRenderer, false));
                        }
                        if (updateDirectives) {
                            updateDirectivesStmts.push.apply(updateDirectivesStmts, createUpdateStatements(nodeIndex, sourceSpan, updateDirectives, (nodeFlags & (262144 /* DoCheck */ | 65536 /* OnInit */)) > 0));
                        }
                        // We use a comma expression to call the log function before
                        // the nodeDef function, but still use the result of the nodeDef function
                        // as the value.
                        // Note: We only add the logger to elements / text nodes,
                        // so we don't generate too much code.
                        var logWithNodeDef = nodeFlags & 3 /* CatRenderNode */ ?
                            new CommaExpr([LOG_VAR$1.callFn([]).callFn([]), nodeDef]) :
                            nodeDef;
                        return applySourceSpanToExpressionIfNeeded(logWithNodeDef, sourceSpan);
                    });
                    return { updateRendererStmts: updateRendererStmts, updateDirectivesStmts: updateDirectivesStmts, nodeDefExprs: nodeDefExprs };
                    function createUpdateStatements(nodeIndex, sourceSpan, expressions, allowEmptyExprs) {
                        var updateStmts = [];
                        var exprs = expressions.map(function (_c) {
                            var sourceSpan = _c.sourceSpan, context = _c.context, value = _c.value;
                            var bindingId = "" + updateBindingCount++;
                            var nameResolver = context === COMP_VAR ? self : null;
                            var _d = convertPropertyBinding(nameResolver, context, value, bindingId, BindingForm.General), stmts = _d.stmts, currValExpr = _d.currValExpr;
                            updateStmts.push.apply(updateStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
                            return applySourceSpanToExpressionIfNeeded(currValExpr, sourceSpan);
                        });
                        if (expressions.length || allowEmptyExprs) {
                            updateStmts.push(applySourceSpanToStatementIfNeeded(callCheckStmt(nodeIndex, exprs).toStmt(), sourceSpan));
                        }
                        return updateStmts;
                    }
                };
                ViewBuilder$1.prototype._createElementHandleEventFn = function (nodeIndex, handlers) {
                    var _this = this;
                    var handleEventStmts = [];
                    var handleEventBindingCount = 0;
                    handlers.forEach(function (_c) {
                        var context = _c.context, eventAst = _c.eventAst, dirAst = _c.dirAst;
                        var bindingId = "" + handleEventBindingCount++;
                        var nameResolver = context === COMP_VAR ? _this : null;
                        var _d = convertActionBinding(nameResolver, context, eventAst.handler, bindingId), stmts = _d.stmts, allowDefault = _d.allowDefault;
                        var trueStmts = stmts;
                        if (allowDefault) {
                            trueStmts.push(ALLOW_DEFAULT_VAR.set(allowDefault.and(ALLOW_DEFAULT_VAR)).toStmt());
                        }
                        var _e = elementEventNameAndTarget(eventAst, dirAst), eventTarget = _e.target, eventName = _e.name;
                        var fullEventName = elementEventFullName(eventTarget, eventName);
                        handleEventStmts.push(applySourceSpanToStatementIfNeeded(new IfStmt(literal(fullEventName).identical(EVENT_NAME_VAR), trueStmts), eventAst.sourceSpan));
                    });
                    var handleEventFn;
                    if (handleEventStmts.length > 0) {
                        var preStmts = [ALLOW_DEFAULT_VAR.set(literal(true)).toDeclStmt(BOOL_TYPE)];
                        if (!this.component.isHost && findReadVarNames(handleEventStmts).has(COMP_VAR.name)) {
                            preStmts.push(COMP_VAR.set(VIEW_VAR.prop('component')).toDeclStmt(this.compType));
                        }
                        handleEventFn = fn([
                            new FnParam(VIEW_VAR.name, INFERRED_TYPE),
                            new FnParam(EVENT_NAME_VAR.name, INFERRED_TYPE),
                            new FnParam(EventHandlerVars.event.name, INFERRED_TYPE)
                        ], preStmts.concat(handleEventStmts, [new ReturnStatement(ALLOW_DEFAULT_VAR)]), INFERRED_TYPE);
                    }
                    else {
                        handleEventFn = NULL_EXPR;
                    }
                    return handleEventFn;
                };
                ViewBuilder$1.prototype.visitDirective = function (ast, context) { };
                ViewBuilder$1.prototype.visitDirectiveProperty = function (ast, context) { };
                ViewBuilder$1.prototype.visitReference = function (ast, context) { };
                ViewBuilder$1.prototype.visitVariable = function (ast, context) { };
                ViewBuilder$1.prototype.visitEvent = function (ast, context) { };
                ViewBuilder$1.prototype.visitElementProperty = function (ast, context) { };
                ViewBuilder$1.prototype.visitAttr = function (ast, context) { };
                return ViewBuilder$1;
            }());
            function needsAdditionalRootNode(astNodes) {
                var lastAstNode = astNodes[astNodes.length - 1];
                if (lastAstNode instanceof EmbeddedTemplateAst) {
                    return lastAstNode.hasViewContainer;
                }
                if (lastAstNode instanceof ElementAst) {
                    if (isNgContainer(lastAstNode.name) && lastAstNode.children.length) {
                        return needsAdditionalRootNode(lastAstNode.children);
                    }
                    return lastAstNode.hasViewContainer;
                }
                return lastAstNode instanceof NgContentAst;
            }
            function elementBindingDef(inputAst, dirAst) {
                var inputType = inputAst.type;
                switch (inputType) {
                    case 1 /* Attribute */:
                        return literalArr([
                            literal(1 /* TypeElementAttribute */), literal(inputAst.name),
                            literal(inputAst.securityContext)
                        ]);
                    case 0 /* Property */:
                        return literalArr([
                            literal(8 /* TypeProperty */), literal(inputAst.name),
                            literal(inputAst.securityContext)
                        ]);
                    case 4 /* Animation */:
                        var bindingType = 8 /* TypeProperty */ |
                            (dirAst && dirAst.directive.isComponent ? 32 /* SyntheticHostProperty */ :
                                16 /* SyntheticProperty */);
                        return literalArr([
                            literal(bindingType), literal('@' + inputAst.name), literal(inputAst.securityContext)
                        ]);
                    case 2 /* Class */:
                        return literalArr([literal(2 /* TypeElementClass */), literal(inputAst.name), NULL_EXPR]);
                    case 3 /* Style */:
                        return literalArr([
                            literal(4 /* TypeElementStyle */), literal(inputAst.name), literal(inputAst.unit)
                        ]);
                    default:
                        // This default case is not needed by TypeScript compiler, as the switch is exhaustive.
                        // However Closure Compiler does not understand that and reports an error in typed mode.
                        // The `throw new Error` below works around the problem, and the unexpected: never variable
                        // makes sure tsc still checks this code is unreachable.
                        var unexpected = inputType;
                        throw new Error("unexpected " + unexpected);
                }
            }
            function fixedAttrsDef(elementAst) {
                var mapResult = Object.create(null);
                elementAst.attrs.forEach(function (attrAst) { mapResult[attrAst.name] = attrAst.value; });
                elementAst.directives.forEach(function (dirAst) {
                    Object.keys(dirAst.directive.hostAttributes).forEach(function (name) {
                        var value = dirAst.directive.hostAttributes[name];
                        var prevValue = mapResult[name];
                        mapResult[name] = prevValue != null ? mergeAttributeValue(name, prevValue, value) : value;
                    });
                });
                // Note: We need to sort to get a defined output order
                // for tests and for caching generated artifacts...
                return literalArr(Object.keys(mapResult).sort().map(function (attrName) { return literalArr([literal(attrName), literal(mapResult[attrName])]); }));
            }
            function mergeAttributeValue(attrName, attrValue1, attrValue2) {
                if (attrName == CLASS_ATTR$1 || attrName == STYLE_ATTR) {
                    return attrValue1 + " " + attrValue2;
                }
                else {
                    return attrValue2;
                }
            }
            function callCheckStmt(nodeIndex, exprs) {
                if (exprs.length > 10) {
                    return CHECK_VAR.callFn([VIEW_VAR, literal(nodeIndex), literal(1 /* Dynamic */), literalArr(exprs)]);
                }
                else {
                    return CHECK_VAR.callFn([VIEW_VAR, literal(nodeIndex), literal(0 /* Inline */)].concat(exprs));
                }
            }
            function callUnwrapValue(nodeIndex, bindingIdx, expr) {
                return importExpr(Identifiers.unwrapValue).callFn([
                    VIEW_VAR, literal(nodeIndex), literal(bindingIdx), expr
                ]);
            }
            function findStaticQueryIds(nodes, result) {
                if (result === void 0) { result = new Map(); }
                nodes.forEach(function (node) {
                    var staticQueryIds = new Set();
                    var dynamicQueryIds = new Set();
                    var queryMatches = undefined;
                    if (node instanceof ElementAst) {
                        findStaticQueryIds(node.children, result);
                        node.children.forEach(function (child) {
                            var childData = result.get(child);
                            childData.staticQueryIds.forEach(function (queryId) { return staticQueryIds.add(queryId); });
                            childData.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
                        });
                        queryMatches = node.queryMatches;
                    }
                    else if (node instanceof EmbeddedTemplateAst) {
                        findStaticQueryIds(node.children, result);
                        node.children.forEach(function (child) {
                            var childData = result.get(child);
                            childData.staticQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
                            childData.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
                        });
                        queryMatches = node.queryMatches;
                    }
                    if (queryMatches) {
                        queryMatches.forEach(function (match) { return staticQueryIds.add(match.queryId); });
                    }
                    dynamicQueryIds.forEach(function (queryId) { return staticQueryIds.delete(queryId); });
                    result.set(node, { staticQueryIds: staticQueryIds, dynamicQueryIds: dynamicQueryIds });
                });
                return result;
            }
            function staticViewQueryIds(nodeStaticQueryIds) {
                var staticQueryIds = new Set();
                var dynamicQueryIds = new Set();
                Array.from(nodeStaticQueryIds.values()).forEach(function (entry) {
                    entry.staticQueryIds.forEach(function (queryId) { return staticQueryIds.add(queryId); });
                    entry.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
                });
                dynamicQueryIds.forEach(function (queryId) { return staticQueryIds.delete(queryId); });
                return { staticQueryIds: staticQueryIds, dynamicQueryIds: dynamicQueryIds };
            }
            function elementEventNameAndTarget(eventAst, dirAst) {
                if (eventAst.isAnimation) {
                    return {
                        name: "@" + eventAst.name + "." + eventAst.phase,
                        target: dirAst && dirAst.directive.isComponent ? 'component' : null
                    };
                }
                else {
                    return eventAst;
                }
            }
            function calcStaticDynamicQueryFlags(queryIds, queryId, query) {
                var flags = 0 /* None */;
                // Note: We only make queries static that query for a single item.
                // This is because of backwards compatibility with the old view compiler...
                if (query.first && shouldResolveAsStaticQuery(queryIds, queryId, query)) {
                    flags |= 268435456 /* StaticQuery */;
                }
                else {
                    flags |= 536870912 /* DynamicQuery */;
                }
                return flags;
            }
            function shouldResolveAsStaticQuery(queryIds, queryId, query) {
                // If query.static has been set by the user, use that value to determine whether
                // the query is static. If none has been set, sort the query into static/dynamic
                // based on query results (i.e. dynamic if CD needs to run to get all results).
                return query.static ||
                    query.static == null &&
                        (queryIds.staticQueryIds.has(queryId) || !queryIds.dynamicQueryIds.has(queryId));
            }
            function elementEventFullName(target, name) {
                return target ? target + ":" + name : name;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A container for message extracted from the templates.
             */
            var MessageBundle = /** @class */ (function () {
                function MessageBundle(_htmlParser, _implicitTags, _implicitAttrs, _locale) {
                    if (_locale === void 0) { _locale = null; }
                    this._htmlParser = _htmlParser;
                    this._implicitTags = _implicitTags;
                    this._implicitAttrs = _implicitAttrs;
                    this._locale = _locale;
                    this._messages = [];
                }
                MessageBundle.prototype.updateFromTemplate = function (html, url, interpolationConfig) {
                    var _c;
                    var htmlParserResult = this._htmlParser.parse(html, url, { tokenizeExpansionForms: true, interpolationConfig: interpolationConfig });
                    if (htmlParserResult.errors.length) {
                        return htmlParserResult.errors;
                    }
                    var i18nParserResult = extractMessages(htmlParserResult.rootNodes, interpolationConfig, this._implicitTags, this._implicitAttrs);
                    if (i18nParserResult.errors.length) {
                        return i18nParserResult.errors;
                    }
                    (_c = this._messages).push.apply(_c, i18nParserResult.messages);
                    return [];
                };
                // Return the message in the internal format
                // The public (serialized) format might be different, see the `write` method.
                MessageBundle.prototype.getMessages = function () { return this._messages; };
                MessageBundle.prototype.write = function (serializer, filterSources) {
                    var messages = {};
                    var mapperVisitor = new MapPlaceholderNames();
                    // Deduplicate messages based on their ID
                    this._messages.forEach(function (message) {
                        var _c;
                        var id = serializer.digest(message);
                        if (!messages.hasOwnProperty(id)) {
                            messages[id] = message;
                        }
                        else {
                            (_c = messages[id].sources).push.apply(_c, message.sources);
                        }
                    });
                    // Transform placeholder names using the serializer mapping
                    var msgList = Object.keys(messages).map(function (id) {
                        var mapper = serializer.createNameMapper(messages[id]);
                        var src = messages[id];
                        var nodes = mapper ? mapperVisitor.convert(src.nodes, mapper) : src.nodes;
                        var transformedMessage = new Message(nodes, {}, {}, src.meaning, src.description, id);
                        transformedMessage.sources = src.sources;
                        if (filterSources) {
                            transformedMessage.sources.forEach(function (source) { return source.filePath = filterSources(source.filePath); });
                        }
                        return transformedMessage;
                    });
                    return serializer.write(msgList, this._locale);
                };
                return MessageBundle;
            }());
            // Transform an i18n AST by renaming the placeholder nodes with the given mapper
            var MapPlaceholderNames = /** @class */ (function (_super_1) {
                __extends(MapPlaceholderNames, _super_1);
                function MapPlaceholderNames() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                MapPlaceholderNames.prototype.convert = function (nodes, mapper) {
                    var _this = this;
                    return mapper ? nodes.map(function (n) { return n.visit(_this, mapper); }) : nodes;
                };
                MapPlaceholderNames.prototype.visitTagPlaceholder = function (ph, mapper) {
                    var _this = this;
                    var startName = mapper.toPublicName(ph.startName);
                    var closeName = ph.closeName ? mapper.toPublicName(ph.closeName) : ph.closeName;
                    var children = ph.children.map(function (n) { return n.visit(_this, mapper); });
                    return new TagPlaceholder(ph.tag, ph.attrs, startName, closeName, children, ph.isVoid, ph.sourceSpan);
                };
                MapPlaceholderNames.prototype.visitPlaceholder = function (ph, mapper) {
                    return new Placeholder(ph.value, mapper.toPublicName(ph.name), ph.sourceSpan);
                };
                MapPlaceholderNames.prototype.visitIcuPlaceholder = function (ph, mapper) {
                    return new IcuPlaceholder(ph.value, mapper.toPublicName(ph.name), ph.sourceSpan);
                };
                return MapPlaceholderNames;
            }(CloneVisitor));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var GeneratedFile = /** @class */ (function () {
                function GeneratedFile(srcFileUrl, genFileUrl, sourceOrStmts) {
                    this.srcFileUrl = srcFileUrl;
                    this.genFileUrl = genFileUrl;
                    if (typeof sourceOrStmts === 'string') {
                        this.source = sourceOrStmts;
                        this.stmts = null;
                    }
                    else {
                        this.source = null;
                        this.stmts = sourceOrStmts;
                    }
                }
                GeneratedFile.prototype.isEquivalent = function (other) {
                    if (this.genFileUrl !== other.genFileUrl) {
                        return false;
                    }
                    if (this.source) {
                        return this.source === other.source;
                    }
                    if (other.stmts == null) {
                        return false;
                    }
                    // Note: the constructor guarantees that if this.source is not filled,
                    // then this.stmts is.
                    return areAllEquivalent(this.stmts, other.stmts);
                };
                return GeneratedFile;
            }());
            function toTypeScript(file, preamble) {
                if (preamble === void 0) { preamble = ''; }
                if (!file.stmts) {
                    throw new Error("Illegal state: No stmts present on GeneratedFile " + file.genFileUrl);
                }
                return new TypeScriptEmitter().emitStatements(file.genFileUrl, file.stmts, preamble);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function listLazyRoutes(moduleMeta, reflector) {
                var allLazyRoutes = [];
                for (var _c = 0, _d = moduleMeta.transitiveModule.providers; _c < _d.length; _c++) {
                    var _e = _d[_c], provider = _e.provider, module_1 = _e.module;
                    if (tokenReference(provider.token) === reflector.ROUTES) {
                        var loadChildren = _collectLoadChildren(provider.useValue);
                        for (var _f = 0, loadChildren_1 = loadChildren; _f < loadChildren_1.length; _f++) {
                            var route = loadChildren_1[_f];
                            allLazyRoutes.push(parseLazyRoute(route, reflector, module_1.reference));
                        }
                    }
                }
                return allLazyRoutes;
            }
            function _collectLoadChildren(routes, target) {
                if (target === void 0) { target = []; }
                if (typeof routes === 'string') {
                    target.push(routes);
                }
                else if (Array.isArray(routes)) {
                    for (var _c = 0, routes_1 = routes; _c < routes_1.length; _c++) {
                        var route = routes_1[_c];
                        _collectLoadChildren(route, target);
                    }
                }
                else if (routes.loadChildren) {
                    _collectLoadChildren(routes.loadChildren, target);
                }
                else if (routes.children) {
                    _collectLoadChildren(routes.children, target);
                }
                return target;
            }
            function parseLazyRoute(route, reflector, module) {
                var _c = route.split('#'), routePath = _c[0], routeName = _c[1];
                var referencedModule = reflector.resolveExternalReference({
                    moduleName: routePath,
                    name: routeName,
                }, module ? module.filePath : undefined);
                return { route: route, module: module || referencedModule, referencedModule: referencedModule };
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var TS = /^(?!.*\.d\.ts$).*\.ts$/;
            var ResolvedStaticSymbol = /** @class */ (function () {
                function ResolvedStaticSymbol(symbol, metadata) {
                    this.symbol = symbol;
                    this.metadata = metadata;
                }
                return ResolvedStaticSymbol;
            }());
            var SUPPORTED_SCHEMA_VERSION = 4;
            /**
             * This class is responsible for loading metadata per symbol,
             * and normalizing references between symbols.
             *
             * Internally, it only uses symbols without members,
             * and deduces the values for symbols with members based
             * on these symbols.
             */
            var StaticSymbolResolver = /** @class */ (function () {
                function StaticSymbolResolver(host, staticSymbolCache, summaryResolver, errorRecorder) {
                    this.host = host;
                    this.staticSymbolCache = staticSymbolCache;
                    this.summaryResolver = summaryResolver;
                    this.errorRecorder = errorRecorder;
                    this.metadataCache = new Map();
                    // Note: this will only contain StaticSymbols without members!
                    this.resolvedSymbols = new Map();
                    this.resolvedFilePaths = new Set();
                    // Note: this will only contain StaticSymbols without members!
                    this.importAs = new Map();
                    this.symbolResourcePaths = new Map();
                    this.symbolFromFile = new Map();
                    this.knownFileNameToModuleNames = new Map();
                }
                StaticSymbolResolver.prototype.resolveSymbol = function (staticSymbol) {
                    if (staticSymbol.members.length > 0) {
                        return this._resolveSymbolMembers(staticSymbol);
                    }
                    // Note: always ask for a summary first,
                    // as we might have read shallow metadata via a .d.ts file
                    // for the symbol.
                    var resultFromSummary = this._resolveSymbolFromSummary(staticSymbol);
                    if (resultFromSummary) {
                        return resultFromSummary;
                    }
                    var resultFromCache = this.resolvedSymbols.get(staticSymbol);
                    if (resultFromCache) {
                        return resultFromCache;
                    }
                    // Note: Some users use libraries that were not compiled with ngc, i.e. they don't
                    // have summaries, only .d.ts files. So we always need to check both, the summary
                    // and metadata.
                    this._createSymbolsOf(staticSymbol.filePath);
                    return this.resolvedSymbols.get(staticSymbol);
                };
                /**
                 * getImportAs produces a symbol that can be used to import the given symbol.
                 * The import might be different than the symbol if the symbol is exported from
                 * a library with a summary; in which case we want to import the symbol from the
                 * ngfactory re-export instead of directly to avoid introducing a direct dependency
                 * on an otherwise indirect dependency.
                 *
                 * @param staticSymbol the symbol for which to generate a import symbol
                 */
                StaticSymbolResolver.prototype.getImportAs = function (staticSymbol, useSummaries) {
                    if (useSummaries === void 0) { useSummaries = true; }
                    if (staticSymbol.members.length) {
                        var baseSymbol = this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name);
                        var baseImportAs = this.getImportAs(baseSymbol, useSummaries);
                        return baseImportAs ?
                            this.getStaticSymbol(baseImportAs.filePath, baseImportAs.name, staticSymbol.members) :
                            null;
                    }
                    var summarizedFileName = stripSummaryForJitFileSuffix(staticSymbol.filePath);
                    if (summarizedFileName !== staticSymbol.filePath) {
                        var summarizedName = stripSummaryForJitNameSuffix(staticSymbol.name);
                        var baseSymbol = this.getStaticSymbol(summarizedFileName, summarizedName, staticSymbol.members);
                        var baseImportAs = this.getImportAs(baseSymbol, useSummaries);
                        return baseImportAs ?
                            this.getStaticSymbol(summaryForJitFileName(baseImportAs.filePath), summaryForJitName(baseImportAs.name), baseSymbol.members) :
                            null;
                    }
                    var result = (useSummaries && this.summaryResolver.getImportAs(staticSymbol)) || null;
                    if (!result) {
                        result = this.importAs.get(staticSymbol);
                    }
                    return result;
                };
                /**
                 * getResourcePath produces the path to the original location of the symbol and should
                 * be used to determine the relative location of resource references recorded in
                 * symbol metadata.
                 */
                StaticSymbolResolver.prototype.getResourcePath = function (staticSymbol) {
                    return this.symbolResourcePaths.get(staticSymbol) || staticSymbol.filePath;
                };
                /**
                 * getTypeArity returns the number of generic type parameters the given symbol
                 * has. If the symbol is not a type the result is null.
                 */
                StaticSymbolResolver.prototype.getTypeArity = function (staticSymbol) {
                    // If the file is a factory/ngsummary file, don't resolve the symbol as doing so would
                    // cause the metadata for an factory/ngsummary file to be loaded which doesn't exist.
                    // All references to generated classes must include the correct arity whenever
                    // generating code.
                    if (isGeneratedFile(staticSymbol.filePath)) {
                        return null;
                    }
                    var resolvedSymbol = unwrapResolvedMetadata(this.resolveSymbol(staticSymbol));
                    while (resolvedSymbol && resolvedSymbol.metadata instanceof StaticSymbol) {
                        resolvedSymbol = unwrapResolvedMetadata(this.resolveSymbol(resolvedSymbol.metadata));
                    }
                    return (resolvedSymbol && resolvedSymbol.metadata && resolvedSymbol.metadata.arity) || null;
                };
                StaticSymbolResolver.prototype.getKnownModuleName = function (filePath) {
                    return this.knownFileNameToModuleNames.get(filePath) || null;
                };
                StaticSymbolResolver.prototype.recordImportAs = function (sourceSymbol, targetSymbol) {
                    sourceSymbol.assertNoMembers();
                    targetSymbol.assertNoMembers();
                    this.importAs.set(sourceSymbol, targetSymbol);
                };
                StaticSymbolResolver.prototype.recordModuleNameForFileName = function (fileName, moduleName) {
                    this.knownFileNameToModuleNames.set(fileName, moduleName);
                };
                /**
                 * Invalidate all information derived from the given file.
                 *
                 * @param fileName the file to invalidate
                 */
                StaticSymbolResolver.prototype.invalidateFile = function (fileName) {
                    this.metadataCache.delete(fileName);
                    this.resolvedFilePaths.delete(fileName);
                    var symbols = this.symbolFromFile.get(fileName);
                    if (symbols) {
                        this.symbolFromFile.delete(fileName);
                        for (var _c = 0, symbols_1 = symbols; _c < symbols_1.length; _c++) {
                            var symbol = symbols_1[_c];
                            this.resolvedSymbols.delete(symbol);
                            this.importAs.delete(symbol);
                            this.symbolResourcePaths.delete(symbol);
                        }
                    }
                };
                /** @internal */
                StaticSymbolResolver.prototype.ignoreErrorsFor = function (cb) {
                    var recorder = this.errorRecorder;
                    this.errorRecorder = function () { };
                    try {
                        return cb();
                    }
                    finally {
                        this.errorRecorder = recorder;
                    }
                };
                StaticSymbolResolver.prototype._resolveSymbolMembers = function (staticSymbol) {
                    var members = staticSymbol.members;
                    var baseResolvedSymbol = this.resolveSymbol(this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name));
                    if (!baseResolvedSymbol) {
                        return null;
                    }
                    var baseMetadata = unwrapResolvedMetadata(baseResolvedSymbol.metadata);
                    if (baseMetadata instanceof StaticSymbol) {
                        return new ResolvedStaticSymbol(staticSymbol, this.getStaticSymbol(baseMetadata.filePath, baseMetadata.name, members));
                    }
                    else if (baseMetadata && baseMetadata.__symbolic === 'class') {
                        if (baseMetadata.statics && members.length === 1) {
                            return new ResolvedStaticSymbol(staticSymbol, baseMetadata.statics[members[0]]);
                        }
                    }
                    else {
                        var value = baseMetadata;
                        for (var i = 0; i < members.length && value; i++) {
                            value = value[members[i]];
                        }
                        return new ResolvedStaticSymbol(staticSymbol, value);
                    }
                    return null;
                };
                StaticSymbolResolver.prototype._resolveSymbolFromSummary = function (staticSymbol) {
                    var summary = this.summaryResolver.resolveSummary(staticSymbol);
                    return summary ? new ResolvedStaticSymbol(staticSymbol, summary.metadata) : null;
                };
                /**
                 * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
                 * All types passed to the StaticResolver should be pseudo-types returned by this method.
                 *
                 * @param declarationFile the absolute path of the file where the symbol is declared
                 * @param name the name of the type.
                 * @param members a symbol for a static member of the named type
                 */
                StaticSymbolResolver.prototype.getStaticSymbol = function (declarationFile, name, members) {
                    return this.staticSymbolCache.get(declarationFile, name, members);
                };
                /**
                 * hasDecorators checks a file's metadata for the presence of decorators without evaluating the
                 * metadata.
                 *
                 * @param filePath the absolute path to examine for decorators.
                 * @returns true if any class in the file has a decorator.
                 */
                StaticSymbolResolver.prototype.hasDecorators = function (filePath) {
                    var metadata = this.getModuleMetadata(filePath);
                    if (metadata['metadata']) {
                        return Object.keys(metadata['metadata']).some(function (metadataKey) {
                            var entry = metadata['metadata'][metadataKey];
                            return entry && entry.__symbolic === 'class' && entry.decorators;
                        });
                    }
                    return false;
                };
                StaticSymbolResolver.prototype.getSymbolsOf = function (filePath) {
                    var summarySymbols = this.summaryResolver.getSymbolsOf(filePath);
                    if (summarySymbols) {
                        return summarySymbols;
                    }
                    // Note: Some users use libraries that were not compiled with ngc, i.e. they don't
                    // have summaries, only .d.ts files, but `summaryResolver.isLibraryFile` returns true.
                    this._createSymbolsOf(filePath);
                    var metadataSymbols = [];
                    this.resolvedSymbols.forEach(function (resolvedSymbol) {
                        if (resolvedSymbol.symbol.filePath === filePath) {
                            metadataSymbols.push(resolvedSymbol.symbol);
                        }
                    });
                    return metadataSymbols;
                };
                StaticSymbolResolver.prototype._createSymbolsOf = function (filePath) {
                    var _this = this;
                    if (this.resolvedFilePaths.has(filePath)) {
                        return;
                    }
                    this.resolvedFilePaths.add(filePath);
                    var resolvedSymbols = [];
                    var metadata = this.getModuleMetadata(filePath);
                    if (metadata['importAs']) {
                        // Index bundle indices should use the importAs module name defined
                        // in the bundle.
                        this.knownFileNameToModuleNames.set(filePath, metadata['importAs']);
                    }
                    // handle the symbols in one of the re-export location
                    if (metadata['exports']) {
                        var _loop_5 = function (moduleExport) {
                            // handle the symbols in the list of explicitly re-exported symbols.
                            if (moduleExport.export) {
                                moduleExport.export.forEach(function (exportSymbol) {
                                    var symbolName;
                                    if (typeof exportSymbol === 'string') {
                                        symbolName = exportSymbol;
                                    }
                                    else {
                                        symbolName = exportSymbol.as;
                                    }
                                    symbolName = unescapeIdentifier(symbolName);
                                    var symName = symbolName;
                                    if (typeof exportSymbol !== 'string') {
                                        symName = unescapeIdentifier(exportSymbol.name);
                                    }
                                    var resolvedModule = _this.resolveModule(moduleExport.from, filePath);
                                    if (resolvedModule) {
                                        var targetSymbol = _this.getStaticSymbol(resolvedModule, symName);
                                        var sourceSymbol = _this.getStaticSymbol(filePath, symbolName);
                                        resolvedSymbols.push(_this.createExport(sourceSymbol, targetSymbol));
                                    }
                                });
                            }
                            else {
                                // handle the symbols via export * directives.
                                var resolvedModule = this_2.resolveModule(moduleExport.from, filePath);
                                if (resolvedModule) {
                                    var nestedExports = this_2.getSymbolsOf(resolvedModule);
                                    nestedExports.forEach(function (targetSymbol) {
                                        var sourceSymbol = _this.getStaticSymbol(filePath, targetSymbol.name);
                                        resolvedSymbols.push(_this.createExport(sourceSymbol, targetSymbol));
                                    });
                                }
                            }
                        };
                        var this_2 = this;
                        for (var _c = 0, _d = metadata['exports']; _c < _d.length; _c++) {
                            var moduleExport = _d[_c];
                            _loop_5(moduleExport);
                        }
                    }
                    // handle the actual metadata. Has to be after the exports
                    // as there might be collisions in the names, and we want the symbols
                    // of the current module to win ofter reexports.
                    if (metadata['metadata']) {
                        // handle direct declarations of the symbol
                        var topLevelSymbolNames_1 = new Set(Object.keys(metadata['metadata']).map(unescapeIdentifier));
                        var origins_1 = metadata['origins'] || {};
                        Object.keys(metadata['metadata']).forEach(function (metadataKey) {
                            var symbolMeta = metadata['metadata'][metadataKey];
                            var name = unescapeIdentifier(metadataKey);
                            var symbol = _this.getStaticSymbol(filePath, name);
                            var origin = origins_1.hasOwnProperty(metadataKey) && origins_1[metadataKey];
                            if (origin) {
                                // If the symbol is from a bundled index, use the declaration location of the
                                // symbol so relative references (such as './my.html') will be calculated
                                // correctly.
                                var originFilePath = _this.resolveModule(origin, filePath);
                                if (!originFilePath) {
                                    _this.reportError(new Error("Couldn't resolve original symbol for " + origin + " from " + _this.host.getOutputName(filePath)));
                                }
                                else {
                                    _this.symbolResourcePaths.set(symbol, originFilePath);
                                }
                            }
                            resolvedSymbols.push(_this.createResolvedSymbol(symbol, filePath, topLevelSymbolNames_1, symbolMeta));
                        });
                    }
                    resolvedSymbols.forEach(function (resolvedSymbol) { return _this.resolvedSymbols.set(resolvedSymbol.symbol, resolvedSymbol); });
                    this.symbolFromFile.set(filePath, resolvedSymbols.map(function (resolvedSymbol) { return resolvedSymbol.symbol; }));
                };
                StaticSymbolResolver.prototype.createResolvedSymbol = function (sourceSymbol, topLevelPath, topLevelSymbolNames, metadata) {
                    var _this = this;
                    // For classes that don't have Angular summaries / metadata,
                    // we only keep their arity, but nothing else
                    // (e.g. their constructor parameters).
                    // We do this to prevent introducing deep imports
                    // as we didn't generate .ngfactory.ts files with proper reexports.
                    var isTsFile = TS.test(sourceSymbol.filePath);
                    if (this.summaryResolver.isLibraryFile(sourceSymbol.filePath) && !isTsFile && metadata &&
                        metadata['__symbolic'] === 'class') {
                        var transformedMeta_1 = { __symbolic: 'class', arity: metadata.arity };
                        return new ResolvedStaticSymbol(sourceSymbol, transformedMeta_1);
                    }
                    var _originalFileMemo;
                    var getOriginalName = function () {
                        if (!_originalFileMemo) {
                            // Guess what the original file name is from the reference. If it has a `.d.ts` extension
                            // replace it with `.ts`. If it already has `.ts` just leave it in place. If it doesn't have
                            // .ts or .d.ts, append `.ts'. Also, if it is in `node_modules`, trim the `node_module`
                            // location as it is not important to finding the file.
                            _originalFileMemo =
                                _this.host.getOutputName(topLevelPath.replace(/((\.ts)|(\.d\.ts)|)$/, '.ts')
                                    .replace(/^.*node_modules[/\\]/, ''));
                        }
                        return _originalFileMemo;
                    };
                    var self = this;
                    var ReferenceTransformer = /** @class */ (function (_super_1) {
                        __extends(ReferenceTransformer, _super_1);
                        function ReferenceTransformer() {
                            return _super_1 !== null && _super_1.apply(this, arguments) || this;
                        }
                        ReferenceTransformer.prototype.visitStringMap = function (map, functionParams) {
                            var symbolic = map['__symbolic'];
                            if (symbolic === 'function') {
                                var oldLen = functionParams.length;
                                functionParams.push.apply(functionParams, (map['parameters'] || []));
                                var result = _super_1.prototype.visitStringMap.call(this, map, functionParams);
                                functionParams.length = oldLen;
                                return result;
                            }
                            else if (symbolic === 'reference') {
                                var module_2 = map['module'];
                                var name = map['name'] ? unescapeIdentifier(map['name']) : map['name'];
                                if (!name) {
                                    return null;
                                }
                                var filePath = void 0;
                                if (module_2) {
                                    filePath = self.resolveModule(module_2, sourceSymbol.filePath);
                                    if (!filePath) {
                                        return {
                                            __symbolic: 'error',
                                            message: "Could not resolve " + module_2 + " relative to " + self.host.getMetadataFor(sourceSymbol.filePath) + ".",
                                            line: map['line'],
                                            character: map['character'],
                                            fileName: getOriginalName()
                                        };
                                    }
                                    return {
                                        __symbolic: 'resolved',
                                        symbol: self.getStaticSymbol(filePath, name),
                                        line: map['line'],
                                        character: map['character'],
                                        fileName: getOriginalName()
                                    };
                                }
                                else if (functionParams.indexOf(name) >= 0) {
                                    // reference to a function parameter
                                    return { __symbolic: 'reference', name: name };
                                }
                                else {
                                    if (topLevelSymbolNames.has(name)) {
                                        return self.getStaticSymbol(topLevelPath, name);
                                    }
                                    // ambient value
                                    null;
                                }
                            }
                            else if (symbolic === 'error') {
                                return Object.assign({}, map, { fileName: getOriginalName() });
                            }
                            else {
                                return _super_1.prototype.visitStringMap.call(this, map, functionParams);
                            }
                        };
                        return ReferenceTransformer;
                    }(ValueTransformer));
                    var transformedMeta = visitValue(metadata, new ReferenceTransformer(), []);
                    var unwrappedTransformedMeta = unwrapResolvedMetadata(transformedMeta);
                    if (unwrappedTransformedMeta instanceof StaticSymbol) {
                        return this.createExport(sourceSymbol, unwrappedTransformedMeta);
                    }
                    return new ResolvedStaticSymbol(sourceSymbol, transformedMeta);
                };
                StaticSymbolResolver.prototype.createExport = function (sourceSymbol, targetSymbol) {
                    sourceSymbol.assertNoMembers();
                    targetSymbol.assertNoMembers();
                    if (this.summaryResolver.isLibraryFile(sourceSymbol.filePath) &&
                        this.summaryResolver.isLibraryFile(targetSymbol.filePath)) {
                        // This case is for an ng library importing symbols from a plain ts library
                        // transitively.
                        // Note: We rely on the fact that we discover symbols in the direction
                        // from source files to library files
                        this.importAs.set(targetSymbol, this.getImportAs(sourceSymbol) || sourceSymbol);
                    }
                    return new ResolvedStaticSymbol(sourceSymbol, targetSymbol);
                };
                StaticSymbolResolver.prototype.reportError = function (error, context, path) {
                    if (this.errorRecorder) {
                        this.errorRecorder(error, (context && context.filePath) || path);
                    }
                    else {
                        throw error;
                    }
                };
                /**
                 * @param module an absolute path to a module file.
                 */
                StaticSymbolResolver.prototype.getModuleMetadata = function (module) {
                    var moduleMetadata = this.metadataCache.get(module);
                    if (!moduleMetadata) {
                        var moduleMetadatas = this.host.getMetadataFor(module);
                        if (moduleMetadatas) {
                            var maxVersion_1 = -1;
                            moduleMetadatas.forEach(function (md) {
                                if (md && md['version'] > maxVersion_1) {
                                    maxVersion_1 = md['version'];
                                    moduleMetadata = md;
                                }
                            });
                        }
                        if (!moduleMetadata) {
                            moduleMetadata =
                                { __symbolic: 'module', version: SUPPORTED_SCHEMA_VERSION, module: module, metadata: {} };
                        }
                        if (moduleMetadata['version'] != SUPPORTED_SCHEMA_VERSION) {
                            var errorMessage = moduleMetadata['version'] == 2 ?
                                "Unsupported metadata version " + moduleMetadata['version'] + " for module " + module + ". This module should be compiled with a newer version of ngc" :
                                "Metadata version mismatch for module " + this.host.getOutputName(module) + ", found version " + moduleMetadata['version'] + ", expected " + SUPPORTED_SCHEMA_VERSION;
                            this.reportError(new Error(errorMessage));
                        }
                        this.metadataCache.set(module, moduleMetadata);
                    }
                    return moduleMetadata;
                };
                StaticSymbolResolver.prototype.getSymbolByModule = function (module, symbolName, containingFile) {
                    var filePath = this.resolveModule(module, containingFile);
                    if (!filePath) {
                        this.reportError(new Error("Could not resolve module " + module + (containingFile ? ' relative to ' +
                            this.host.getOutputName(containingFile) : '')));
                        return this.getStaticSymbol("ERROR:" + module, symbolName);
                    }
                    return this.getStaticSymbol(filePath, symbolName);
                };
                StaticSymbolResolver.prototype.resolveModule = function (module, containingFile) {
                    try {
                        return this.host.moduleNameToFileName(module, containingFile);
                    }
                    catch (e) {
                        console.error("Could not resolve module '" + module + "' relative to file " + containingFile);
                        this.reportError(e, undefined, containingFile);
                    }
                    return null;
                };
                return StaticSymbolResolver;
            }());
            // Remove extra underscore from escaped identifier.
            // See https://github.com/Microsoft/TypeScript/blob/master/src/compiler/utilities.ts
            function unescapeIdentifier(identifier) {
                return identifier.startsWith('___') ? identifier.substr(1) : identifier;
            }
            function unwrapResolvedMetadata(metadata) {
                if (metadata && metadata.__symbolic === 'resolved') {
                    return metadata.symbol;
                }
                return metadata;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function serializeSummaries(srcFileName, forJitCtx, summaryResolver, symbolResolver, symbols, types, createExternalSymbolReexports) {
                if (createExternalSymbolReexports === void 0) { createExternalSymbolReexports = false; }
                var toJsonSerializer = new ToJsonSerializer(symbolResolver, summaryResolver, srcFileName);
                // for symbols, we use everything except for the class metadata itself
                // (we keep the statics though), as the class metadata is contained in the
                // CompileTypeSummary.
                symbols.forEach(function (resolvedSymbol) { return toJsonSerializer.addSummary({ symbol: resolvedSymbol.symbol, metadata: resolvedSymbol.metadata }); });
                // Add type summaries.
                types.forEach(function (_c) {
                    var summary = _c.summary, metadata = _c.metadata;
                    toJsonSerializer.addSummary({ symbol: summary.type.reference, metadata: undefined, type: summary });
                });
                var _c = toJsonSerializer.serialize(createExternalSymbolReexports), json = _c.json, exportAs = _c.exportAs;
                if (forJitCtx) {
                    var forJitSerializer_1 = new ForJitSerializer(forJitCtx, symbolResolver, summaryResolver);
                    types.forEach(function (_c) {
                        var summary = _c.summary, metadata = _c.metadata;
                        forJitSerializer_1.addSourceType(summary, metadata);
                    });
                    toJsonSerializer.unprocessedSymbolSummariesBySymbol.forEach(function (summary) {
                        if (summaryResolver.isLibraryFile(summary.symbol.filePath) && summary.type) {
                            forJitSerializer_1.addLibType(summary.type);
                        }
                    });
                    forJitSerializer_1.serialize(exportAs);
                }
                return { json: json, exportAs: exportAs };
            }
            function deserializeSummaries(symbolCache, summaryResolver, libraryFileName, json) {
                var deserializer = new FromJsonDeserializer(symbolCache, summaryResolver);
                return deserializer.deserialize(libraryFileName, json);
            }
            function createForJitStub(outputCtx, reference) {
                return createSummaryForJitFunction(outputCtx, reference, NULL_EXPR);
            }
            function createSummaryForJitFunction(outputCtx, reference, value) {
                var fnName = summaryForJitName(reference.name);
                outputCtx.statements.push(fn([], [new ReturnStatement(value)], new ArrayType(DYNAMIC_TYPE)).toDeclStmt(fnName, [
                    StmtModifier.Final, StmtModifier.Exported
                ]));
            }
            var ToJsonSerializer = /** @class */ (function (_super_1) {
                __extends(ToJsonSerializer, _super_1);
                function ToJsonSerializer(symbolResolver, summaryResolver, srcFileName) {
                    var _this = _super_1.call(this) || this;
                    _this.symbolResolver = symbolResolver;
                    _this.summaryResolver = summaryResolver;
                    _this.srcFileName = srcFileName;
                    // Note: This only contains symbols without members.
                    _this.symbols = [];
                    _this.indexBySymbol = new Map();
                    _this.reexportedBy = new Map();
                    // This now contains a `__symbol: number` in the place of
                    // StaticSymbols, but otherwise has the same shape as the original objects.
                    _this.processedSummaryBySymbol = new Map();
                    _this.processedSummaries = [];
                    _this.unprocessedSymbolSummariesBySymbol = new Map();
                    _this.moduleName = symbolResolver.getKnownModuleName(srcFileName);
                    return _this;
                }
                ToJsonSerializer.prototype.addSummary = function (summary) {
                    var _this = this;
                    var unprocessedSummary = this.unprocessedSymbolSummariesBySymbol.get(summary.symbol);
                    var processedSummary = this.processedSummaryBySymbol.get(summary.symbol);
                    if (!unprocessedSummary) {
                        unprocessedSummary = { symbol: summary.symbol, metadata: undefined };
                        this.unprocessedSymbolSummariesBySymbol.set(summary.symbol, unprocessedSummary);
                        processedSummary = { symbol: this.processValue(summary.symbol, 0 /* None */) };
                        this.processedSummaries.push(processedSummary);
                        this.processedSummaryBySymbol.set(summary.symbol, processedSummary);
                    }
                    if (!unprocessedSummary.metadata && summary.metadata) {
                        var metadata_1 = summary.metadata || {};
                        if (metadata_1.__symbolic === 'class') {
                            // For classes, we keep everything except their class decorators.
                            // We need to keep e.g. the ctor args, method names, method decorators
                            // so that the class can be extended in another compilation unit.
                            // We don't keep the class decorators as
                            // 1) they refer to data
                            //   that should not cause a rebuild of downstream compilation units
                            //   (e.g. inline templates of @Component, or @NgModule.declarations)
                            // 2) their data is already captured in TypeSummaries, e.g. DirectiveSummary.
                            var clone_1 = {};
                            Object.keys(metadata_1).forEach(function (propName) {
                                if (propName !== 'decorators') {
                                    clone_1[propName] = metadata_1[propName];
                                }
                            });
                            metadata_1 = clone_1;
                        }
                        else if (isCall(metadata_1)) {
                            if (!isFunctionCall(metadata_1) && !isMethodCallOnVariable(metadata_1)) {
                                // Don't store complex calls as we won't be able to simplify them anyways later on.
                                metadata_1 = {
                                    __symbolic: 'error',
                                    message: 'Complex function calls are not supported.',
                                };
                            }
                        }
                        // Note: We need to keep storing ctor calls for e.g.
                        // `export const x = new InjectionToken(...)`
                        unprocessedSummary.metadata = metadata_1;
                        processedSummary.metadata = this.processValue(metadata_1, 1 /* ResolveValue */);
                        if (metadata_1 instanceof StaticSymbol &&
                            this.summaryResolver.isLibraryFile(metadata_1.filePath)) {
                            var declarationSymbol = this.symbols[this.indexBySymbol.get(metadata_1)];
                            if (!isLoweredSymbol(declarationSymbol.name)) {
                                // Note: symbols that were introduced during codegen in the user file can have a reexport
                                // if a user used `export *`. However, we can't rely on this as tsickle will change
                                // `export *` into named exports, using only the information from the typechecker.
                                // As we introduce the new symbols after typecheck, Tsickle does not know about them,
                                // and omits them when expanding `export *`.
                                // So we have to keep reexporting these symbols manually via .ngfactory files.
                                this.reexportedBy.set(declarationSymbol, summary.symbol);
                            }
                        }
                    }
                    if (!unprocessedSummary.type && summary.type) {
                        unprocessedSummary.type = summary.type;
                        // Note: We don't add the summaries of all referenced symbols as for the ResolvedSymbols,
                        // as the type summaries already contain the transitive data that they require
                        // (in a minimal way).
                        processedSummary.type = this.processValue(summary.type, 0 /* None */);
                        // except for reexported directives / pipes, so we need to store
                        // their summaries explicitly.
                        if (summary.type.summaryKind === CompileSummaryKind.NgModule) {
                            var ngModuleSummary = summary.type;
                            ngModuleSummary.exportedDirectives.concat(ngModuleSummary.exportedPipes).forEach(function (id) {
                                var symbol = id.reference;
                                if (_this.summaryResolver.isLibraryFile(symbol.filePath) &&
                                    !_this.unprocessedSymbolSummariesBySymbol.has(symbol)) {
                                    var summary_1 = _this.summaryResolver.resolveSummary(symbol);
                                    if (summary_1) {
                                        _this.addSummary(summary_1);
                                    }
                                }
                            });
                        }
                    }
                };
                /**
                 * @param createExternalSymbolReexports Whether external static symbols should be re-exported.
                 * This can be enabled if external symbols should be re-exported by the current module in
                 * order to avoid dynamically generated module dependencies which can break strict dependency
                 * enforcements (as in Google3). Read more here: https://github.com/angular/angular/issues/25644
                 */
                ToJsonSerializer.prototype.serialize = function (createExternalSymbolReexports) {
                    var _this = this;
                    var exportAs = [];
                    var json = JSON.stringify({
                        moduleName: this.moduleName,
                        summaries: this.processedSummaries,
                        symbols: this.symbols.map(function (symbol, index) {
                            symbol.assertNoMembers();
                            var importAs = undefined;
                            if (_this.summaryResolver.isLibraryFile(symbol.filePath)) {
                                var reexportSymbol = _this.reexportedBy.get(symbol);
                                if (reexportSymbol) {
                                    // In case the given external static symbol is already manually exported by the
                                    // user, we just proxy the external static symbol reference to the manual export.
                                    // This ensures that the AOT compiler imports the external symbol through the
                                    // user export and does not introduce another dependency which is not needed.
                                    importAs = _this.indexBySymbol.get(reexportSymbol);
                                }
                                else if (createExternalSymbolReexports) {
                                    // In this case, the given external static symbol is *not* manually exported by
                                    // the user, and we manually create a re-export in the factory file so that we
                                    // don't introduce another module dependency. This is useful when running within
                                    // Bazel so that the AOT compiler does not introduce any module dependencies
                                    // which can break the strict dependency enforcement. (e.g. as in Google3)
                                    // Read more about this here: https://github.com/angular/angular/issues/25644
                                    var summary = _this.unprocessedSymbolSummariesBySymbol.get(symbol);
                                    if (!summary || !summary.metadata || summary.metadata.__symbolic !== 'interface') {
                                        importAs = symbol.name + "_" + index;
                                        exportAs.push({ symbol: symbol, exportAs: importAs });
                                    }
                                }
                            }
                            return {
                                __symbol: index,
                                name: symbol.name,
                                filePath: _this.summaryResolver.toSummaryFileName(symbol.filePath, _this.srcFileName),
                                importAs: importAs
                            };
                        })
                    });
                    return { json: json, exportAs: exportAs };
                };
                ToJsonSerializer.prototype.processValue = function (value, flags) {
                    return visitValue(value, this, flags);
                };
                ToJsonSerializer.prototype.visitOther = function (value, context) {
                    if (value instanceof StaticSymbol) {
                        var baseSymbol = this.symbolResolver.getStaticSymbol(value.filePath, value.name);
                        var index = this.visitStaticSymbol(baseSymbol, context);
                        return { __symbol: index, members: value.members };
                    }
                };
                /**
                 * Strip line and character numbers from ngsummaries.
                 * Emitting them causes white spaces changes to retrigger upstream
                 * recompilations in bazel.
                 * TODO: find out a way to have line and character numbers in errors without
                 * excessive recompilation in bazel.
                 */
                ToJsonSerializer.prototype.visitStringMap = function (map, context) {
                    if (map['__symbolic'] === 'resolved') {
                        return visitValue(map['symbol'], this, context);
                    }
                    if (map['__symbolic'] === 'error') {
                        delete map['line'];
                        delete map['character'];
                    }
                    return _super_1.prototype.visitStringMap.call(this, map, context);
                };
                /**
                 * Returns null if the options.resolveValue is true, and the summary for the symbol
                 * resolved to a type or could not be resolved.
                 */
                ToJsonSerializer.prototype.visitStaticSymbol = function (baseSymbol, flags) {
                    var index = this.indexBySymbol.get(baseSymbol);
                    var summary = null;
                    if (flags & 1 /* ResolveValue */ &&
                        this.summaryResolver.isLibraryFile(baseSymbol.filePath)) {
                        if (this.unprocessedSymbolSummariesBySymbol.has(baseSymbol)) {
                            // the summary for this symbol was already added
                            // -> nothing to do.
                            return index;
                        }
                        summary = this.loadSummary(baseSymbol);
                        if (summary && summary.metadata instanceof StaticSymbol) {
                            // The summary is a reexport
                            index = this.visitStaticSymbol(summary.metadata, flags);
                            // reset the summary as it is just a reexport, so we don't want to store it.
                            summary = null;
                        }
                    }
                    else if (index != null) {
                        // Note: == on purpose to compare with undefined!
                        // No summary and the symbol is already added -> nothing to do.
                        return index;
                    }
                    // Note: == on purpose to compare with undefined!
                    if (index == null) {
                        index = this.symbols.length;
                        this.symbols.push(baseSymbol);
                    }
                    this.indexBySymbol.set(baseSymbol, index);
                    if (summary) {
                        this.addSummary(summary);
                    }
                    return index;
                };
                ToJsonSerializer.prototype.loadSummary = function (symbol) {
                    var summary = this.summaryResolver.resolveSummary(symbol);
                    if (!summary) {
                        // some symbols might originate from a plain typescript library
                        // that just exported .d.ts and .metadata.json files, i.e. where no summary
                        // files were created.
                        var resolvedSymbol = this.symbolResolver.resolveSymbol(symbol);
                        if (resolvedSymbol) {
                            summary = { symbol: resolvedSymbol.symbol, metadata: resolvedSymbol.metadata };
                        }
                    }
                    return summary;
                };
                return ToJsonSerializer;
            }(ValueTransformer));
            var ForJitSerializer = /** @class */ (function () {
                function ForJitSerializer(outputCtx, symbolResolver, summaryResolver) {
                    this.outputCtx = outputCtx;
                    this.symbolResolver = symbolResolver;
                    this.summaryResolver = summaryResolver;
                    this.data = [];
                }
                ForJitSerializer.prototype.addSourceType = function (summary, metadata) {
                    this.data.push({ summary: summary, metadata: metadata, isLibrary: false });
                };
                ForJitSerializer.prototype.addLibType = function (summary) {
                    this.data.push({ summary: summary, metadata: null, isLibrary: true });
                };
                ForJitSerializer.prototype.serialize = function (exportAsArr) {
                    var _this = this;
                    var exportAsBySymbol = new Map();
                    for (var _c = 0, exportAsArr_1 = exportAsArr; _c < exportAsArr_1.length; _c++) {
                        var _d = exportAsArr_1[_c], symbol = _d.symbol, exportAs = _d.exportAs;
                        exportAsBySymbol.set(symbol, exportAs);
                    }
                    var ngModuleSymbols = new Set();
                    for (var _e = 0, _f = this.data; _e < _f.length; _e++) {
                        var _g = _f[_e], summary = _g.summary, metadata = _g.metadata, isLibrary = _g.isLibrary;
                        if (summary.summaryKind === CompileSummaryKind.NgModule) {
                            // collect the symbols that refer to NgModule classes.
                            // Note: we can't just rely on `summary.type.summaryKind` to determine this as
                            // we don't add the summaries of all referenced symbols when we serialize type summaries.
                            // See serializeSummaries for details.
                            ngModuleSymbols.add(summary.type.reference);
                            var modSummary = summary;
                            for (var _h = 0, _j = modSummary.modules; _h < _j.length; _h++) {
                                var mod = _j[_h];
                                ngModuleSymbols.add(mod.reference);
                            }
                        }
                        if (!isLibrary) {
                            var fnName = summaryForJitName(summary.type.reference.name);
                            createSummaryForJitFunction(this.outputCtx, summary.type.reference, this.serializeSummaryWithDeps(summary, metadata));
                        }
                    }
                    ngModuleSymbols.forEach(function (ngModuleSymbol) {
                        if (_this.summaryResolver.isLibraryFile(ngModuleSymbol.filePath)) {
                            var exportAs = exportAsBySymbol.get(ngModuleSymbol) || ngModuleSymbol.name;
                            var jitExportAsName = summaryForJitName(exportAs);
                            _this.outputCtx.statements.push(variable(jitExportAsName)
                                .set(_this.serializeSummaryRef(ngModuleSymbol))
                                .toDeclStmt(null, [StmtModifier.Exported]));
                        }
                    });
                };
                ForJitSerializer.prototype.serializeSummaryWithDeps = function (summary, metadata) {
                    var _this = this;
                    var expressions = [this.serializeSummary(summary)];
                    var providers = [];
                    if (metadata instanceof CompileNgModuleMetadata) {
                        expressions.push.apply(expressions, 
                        // For directives / pipes, we only add the declared ones,
                        // and rely on transitively importing NgModules to get the transitive
                        // summaries.
                        metadata.declaredDirectives.concat(metadata.declaredPipes)
                            .map(function (type) { return type.reference; })
                            // For modules,
                            // we also add the summaries for modules
                            // from libraries.
                            // This is ok as we produce reexports for all transitive modules.
                            .concat(metadata.transitiveModule.modules.map(function (type) { return type.reference; })
                            .filter(function (ref) { return ref !== metadata.type.reference; }))
                            .map(function (ref) { return _this.serializeSummaryRef(ref); }));
                        // Note: We don't use `NgModuleSummary.providers`, as that one is transitive,
                        // and we already have transitive modules.
                        providers = metadata.providers;
                    }
                    else if (summary.summaryKind === CompileSummaryKind.Directive) {
                        var dirSummary = summary;
                        providers = dirSummary.providers.concat(dirSummary.viewProviders);
                    }
                    // Note: We can't just refer to the `ngsummary.ts` files for `useClass` providers (as we do for
                    // declaredDirectives / declaredPipes), as we allow
                    // providers without ctor arguments to skip the `@Injectable` decorator,
                    // i.e. we didn't generate .ngsummary.ts files for these.
                    expressions.push.apply(expressions, providers.filter(function (provider) { return !!provider.useClass; }).map(function (provider) { return _this.serializeSummary({
                        summaryKind: CompileSummaryKind.Injectable, type: provider.useClass
                    }); }));
                    return literalArr(expressions);
                };
                ForJitSerializer.prototype.serializeSummaryRef = function (typeSymbol) {
                    var jitImportedSymbol = this.symbolResolver.getStaticSymbol(summaryForJitFileName(typeSymbol.filePath), summaryForJitName(typeSymbol.name));
                    return this.outputCtx.importExpr(jitImportedSymbol);
                };
                ForJitSerializer.prototype.serializeSummary = function (data) {
                    var outputCtx = this.outputCtx;
                    var Transformer = /** @class */ (function () {
                        function Transformer() {
                        }
                        Transformer.prototype.visitArray = function (arr, context) {
                            var _this = this;
                            return literalArr(arr.map(function (entry) { return visitValue(entry, _this, context); }));
                        };
                        Transformer.prototype.visitStringMap = function (map, context) {
                            var _this = this;
                            return new LiteralMapExpr(Object.keys(map).map(function (key) { return new LiteralMapEntry(key, visitValue(map[key], _this, context), false); }));
                        };
                        Transformer.prototype.visitPrimitive = function (value, context) { return literal(value); };
                        Transformer.prototype.visitOther = function (value, context) {
                            if (value instanceof StaticSymbol) {
                                return outputCtx.importExpr(value);
                            }
                            else {
                                throw new Error("Illegal State: Encountered value " + value);
                            }
                        };
                        return Transformer;
                    }());
                    return visitValue(data, new Transformer(), null);
                };
                return ForJitSerializer;
            }());
            var FromJsonDeserializer = /** @class */ (function (_super_1) {
                __extends(FromJsonDeserializer, _super_1);
                function FromJsonDeserializer(symbolCache, summaryResolver) {
                    var _this = _super_1.call(this) || this;
                    _this.symbolCache = symbolCache;
                    _this.summaryResolver = summaryResolver;
                    return _this;
                }
                FromJsonDeserializer.prototype.deserialize = function (libraryFileName, json) {
                    var _this = this;
                    var data = JSON.parse(json);
                    var allImportAs = [];
                    this.symbols = data.symbols.map(function (serializedSymbol) { return _this.symbolCache.get(_this.summaryResolver.fromSummaryFileName(serializedSymbol.filePath, libraryFileName), serializedSymbol.name); });
                    data.symbols.forEach(function (serializedSymbol, index) {
                        var symbol = _this.symbols[index];
                        var importAs = serializedSymbol.importAs;
                        if (typeof importAs === 'number') {
                            allImportAs.push({ symbol: symbol, importAs: _this.symbols[importAs] });
                        }
                        else if (typeof importAs === 'string') {
                            allImportAs.push({ symbol: symbol, importAs: _this.symbolCache.get(ngfactoryFilePath(libraryFileName), importAs) });
                        }
                    });
                    var summaries = visitValue(data.summaries, this, null);
                    return { moduleName: data.moduleName, summaries: summaries, importAs: allImportAs };
                };
                FromJsonDeserializer.prototype.visitStringMap = function (map, context) {
                    if ('__symbol' in map) {
                        var baseSymbol = this.symbols[map['__symbol']];
                        var members = map['members'];
                        return members.length ? this.symbolCache.get(baseSymbol.filePath, baseSymbol.name, members) :
                            baseSymbol;
                    }
                    else {
                        return _super_1.prototype.visitStringMap.call(this, map, context);
                    }
                };
                return FromJsonDeserializer;
            }(ValueTransformer));
            function isCall(metadata) {
                return metadata && metadata.__symbolic === 'call';
            }
            function isFunctionCall(metadata) {
                return isCall(metadata) && unwrapResolvedMetadata(metadata.expression) instanceof StaticSymbol;
            }
            function isMethodCallOnVariable(metadata) {
                return isCall(metadata) && metadata.expression && metadata.expression.__symbolic === 'select' &&
                    unwrapResolvedMetadata(metadata.expression.expression) instanceof StaticSymbol;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var AotCompiler = /** @class */ (function () {
                function AotCompiler(_config, _options, _host, reflector, _metadataResolver, _templateParser, _styleCompiler, _viewCompiler, _typeCheckCompiler, _ngModuleCompiler, _injectableCompiler, _outputEmitter, _summaryResolver, _symbolResolver) {
                    this._config = _config;
                    this._options = _options;
                    this._host = _host;
                    this.reflector = reflector;
                    this._metadataResolver = _metadataResolver;
                    this._templateParser = _templateParser;
                    this._styleCompiler = _styleCompiler;
                    this._viewCompiler = _viewCompiler;
                    this._typeCheckCompiler = _typeCheckCompiler;
                    this._ngModuleCompiler = _ngModuleCompiler;
                    this._injectableCompiler = _injectableCompiler;
                    this._outputEmitter = _outputEmitter;
                    this._summaryResolver = _summaryResolver;
                    this._symbolResolver = _symbolResolver;
                    this._templateAstCache = new Map();
                    this._analyzedFiles = new Map();
                    this._analyzedFilesForInjectables = new Map();
                }
                AotCompiler.prototype.clearCache = function () { this._metadataResolver.clearCache(); };
                AotCompiler.prototype.analyzeModulesSync = function (rootFiles) {
                    var _this = this;
                    var analyzeResult = analyzeAndValidateNgModules(rootFiles, this._host, this._symbolResolver, this._metadataResolver);
                    analyzeResult.ngModules.forEach(function (ngModule) { return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, true); });
                    return analyzeResult;
                };
                AotCompiler.prototype.analyzeModulesAsync = function (rootFiles) {
                    var _this = this;
                    var analyzeResult = analyzeAndValidateNgModules(rootFiles, this._host, this._symbolResolver, this._metadataResolver);
                    return Promise
                        .all(analyzeResult.ngModules.map(function (ngModule) { return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false); }))
                        .then(function () { return analyzeResult; });
                };
                AotCompiler.prototype._analyzeFile = function (fileName) {
                    var analyzedFile = this._analyzedFiles.get(fileName);
                    if (!analyzedFile) {
                        analyzedFile =
                            analyzeFile(this._host, this._symbolResolver, this._metadataResolver, fileName);
                        this._analyzedFiles.set(fileName, analyzedFile);
                    }
                    return analyzedFile;
                };
                AotCompiler.prototype._analyzeFileForInjectables = function (fileName) {
                    var analyzedFile = this._analyzedFilesForInjectables.get(fileName);
                    if (!analyzedFile) {
                        analyzedFile = analyzeFileForInjectables(this._host, this._symbolResolver, this._metadataResolver, fileName);
                        this._analyzedFilesForInjectables.set(fileName, analyzedFile);
                    }
                    return analyzedFile;
                };
                AotCompiler.prototype.findGeneratedFileNames = function (fileName) {
                    var _this = this;
                    var genFileNames = [];
                    var file = this._analyzeFile(fileName);
                    // Make sure we create a .ngfactory if we have a injectable/directive/pipe/NgModule
                    // or a reference to a non source file.
                    // Note: This is overestimating the required .ngfactory files as the real calculation is harder.
                    // Only do this for StubEmitFlags.Basic, as adding a type check block
                    // does not change this file (as we generate type check blocks based on NgModules).
                    if (this._options.allowEmptyCodegenFiles || file.directives.length || file.pipes.length ||
                        file.injectables.length || file.ngModules.length || file.exportsNonSourceFiles) {
                        genFileNames.push(ngfactoryFilePath(file.fileName, true));
                        if (this._options.enableSummariesForJit) {
                            genFileNames.push(summaryForJitFileName(file.fileName, true));
                        }
                    }
                    var fileSuffix = normalizeGenFileSuffix(splitTypescriptSuffix(file.fileName, true)[1]);
                    file.directives.forEach(function (dirSymbol) {
                        var compMeta = _this._metadataResolver.getNonNormalizedDirectiveMetadata(dirSymbol).metadata;
                        if (!compMeta.isComponent) {
                            return;
                        }
                        // Note: compMeta is a component and therefore template is non null.
                        compMeta.template.styleUrls.forEach(function (styleUrl) {
                            var normalizedUrl = _this._host.resourceNameToFileName(styleUrl, file.fileName);
                            if (!normalizedUrl) {
                                throw syntaxError("Couldn't resolve resource " + styleUrl + " relative to " + file.fileName);
                            }
                            var needsShim = (compMeta.template.encapsulation ||
                                _this._config.defaultEncapsulation) === ViewEncapsulation.Emulated;
                            genFileNames.push(_stylesModuleUrl(normalizedUrl, needsShim, fileSuffix));
                            if (_this._options.allowEmptyCodegenFiles) {
                                genFileNames.push(_stylesModuleUrl(normalizedUrl, !needsShim, fileSuffix));
                            }
                        });
                    });
                    return genFileNames;
                };
                AotCompiler.prototype.emitBasicStub = function (genFileName, originalFileName) {
                    var outputCtx = this._createOutputContext(genFileName);
                    if (genFileName.endsWith('.ngfactory.ts')) {
                        if (!originalFileName) {
                            throw new Error("Assertion error: require the original file for .ngfactory.ts stubs. File: " + genFileName);
                        }
                        var originalFile = this._analyzeFile(originalFileName);
                        this._createNgFactoryStub(outputCtx, originalFile, 1 /* Basic */);
                    }
                    else if (genFileName.endsWith('.ngsummary.ts')) {
                        if (this._options.enableSummariesForJit) {
                            if (!originalFileName) {
                                throw new Error("Assertion error: require the original file for .ngsummary.ts stubs. File: " + genFileName);
                            }
                            var originalFile = this._analyzeFile(originalFileName);
                            _createEmptyStub(outputCtx);
                            originalFile.ngModules.forEach(function (ngModule) {
                                // create exports that user code can reference
                                createForJitStub(outputCtx, ngModule.type.reference);
                            });
                        }
                    }
                    else if (genFileName.endsWith('.ngstyle.ts')) {
                        _createEmptyStub(outputCtx);
                    }
                    // Note: for the stubs, we don't need a property srcFileUrl,
                    // as later on in emitAllImpls we will create the proper GeneratedFiles with the
                    // correct srcFileUrl.
                    // This is good as e.g. for .ngstyle.ts files we can't derive
                    // the url of components based on the genFileUrl.
                    return this._codegenSourceModule('unknown', outputCtx);
                };
                AotCompiler.prototype.emitTypeCheckStub = function (genFileName, originalFileName) {
                    var originalFile = this._analyzeFile(originalFileName);
                    var outputCtx = this._createOutputContext(genFileName);
                    if (genFileName.endsWith('.ngfactory.ts')) {
                        this._createNgFactoryStub(outputCtx, originalFile, 2 /* TypeCheck */);
                    }
                    return outputCtx.statements.length > 0 ?
                        this._codegenSourceModule(originalFile.fileName, outputCtx) :
                        null;
                };
                AotCompiler.prototype.loadFilesAsync = function (fileNames, tsFiles) {
                    var _this = this;
                    var files = fileNames.map(function (fileName) { return _this._analyzeFile(fileName); });
                    var loadingPromises = [];
                    files.forEach(function (file) { return file.ngModules.forEach(function (ngModule) { return loadingPromises.push(_this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false)); }); });
                    var analyzedInjectables = tsFiles.map(function (tsFile) { return _this._analyzeFileForInjectables(tsFile); });
                    return Promise.all(loadingPromises).then(function (_) { return ({
                        analyzedModules: mergeAndValidateNgFiles(files),
                        analyzedInjectables: analyzedInjectables,
                    }); });
                };
                AotCompiler.prototype.loadFilesSync = function (fileNames, tsFiles) {
                    var _this = this;
                    var files = fileNames.map(function (fileName) { return _this._analyzeFile(fileName); });
                    files.forEach(function (file) { return file.ngModules.forEach(function (ngModule) { return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, true); }); });
                    var analyzedInjectables = tsFiles.map(function (tsFile) { return _this._analyzeFileForInjectables(tsFile); });
                    return {
                        analyzedModules: mergeAndValidateNgFiles(files),
                        analyzedInjectables: analyzedInjectables,
                    };
                };
                AotCompiler.prototype._createNgFactoryStub = function (outputCtx, file, emitFlags) {
                    var _this = this;
                    var componentId = 0;
                    file.ngModules.forEach(function (ngModuleMeta, ngModuleIndex) {
                        // Note: the code below needs to executed for StubEmitFlags.Basic and StubEmitFlags.TypeCheck,
                        // so we don't change the .ngfactory file too much when adding the type-check block.
                        // create exports that user code can reference
                        _this._ngModuleCompiler.createStub(outputCtx, ngModuleMeta.type.reference);
                        // add references to the symbols from the metadata.
                        // These can be used by the type check block for components,
                        // and they also cause TypeScript to include these files into the program too,
                        // which will make them part of the analyzedFiles.
                        var externalReferences = ngModuleMeta.transitiveModule.directives.map(function (d) { return d.reference; }).concat(ngModuleMeta.transitiveModule.pipes.map(function (d) { return d.reference; }), ngModuleMeta.importedModules.map(function (m) { return m.type.reference; }), ngModuleMeta.exportedModules.map(function (m) { return m.type.reference; }), _this._externalIdentifierReferences([Identifiers.TemplateRef, Identifiers.ElementRef]));
                        var externalReferenceVars = new Map();
                        externalReferences.forEach(function (ref, typeIndex) {
                            externalReferenceVars.set(ref, "_decl" + ngModuleIndex + "_" + typeIndex);
                        });
                        externalReferenceVars.forEach(function (varName, reference) {
                            outputCtx.statements.push(variable(varName)
                                .set(NULL_EXPR.cast(DYNAMIC_TYPE))
                                .toDeclStmt(expressionType(outputCtx.importExpr(reference, /* typeParams */ null, /* useSummaries */ false))));
                        });
                        if (emitFlags & 2 /* TypeCheck */) {
                            // add the type-check block for all components of the NgModule
                            ngModuleMeta.declaredDirectives.forEach(function (dirId) {
                                var compMeta = _this._metadataResolver.getDirectiveMetadata(dirId.reference);
                                if (!compMeta.isComponent) {
                                    return;
                                }
                                componentId++;
                                _this._createTypeCheckBlock(outputCtx, compMeta.type.reference.name + "_Host_" + componentId, ngModuleMeta, _this._metadataResolver.getHostComponentMetadata(compMeta), [compMeta.type], externalReferenceVars);
                                _this._createTypeCheckBlock(outputCtx, compMeta.type.reference.name + "_" + componentId, ngModuleMeta, compMeta, ngModuleMeta.transitiveModule.directives, externalReferenceVars);
                            });
                        }
                    });
                    if (outputCtx.statements.length === 0) {
                        _createEmptyStub(outputCtx);
                    }
                };
                AotCompiler.prototype._externalIdentifierReferences = function (references) {
                    var result = [];
                    for (var _c = 0, references_1 = references; _c < references_1.length; _c++) {
                        var reference = references_1[_c];
                        var token = createTokenForExternalReference(this.reflector, reference);
                        if (token.identifier) {
                            result.push(token.identifier.reference);
                        }
                    }
                    return result;
                };
                AotCompiler.prototype._createTypeCheckBlock = function (ctx, componentId, moduleMeta, compMeta, directives, externalReferenceVars) {
                    var _c;
                    var _d = this._parseTemplate(compMeta, moduleMeta, directives), parsedTemplate = _d.template, usedPipes = _d.pipes;
                    (_c = ctx.statements).push.apply(_c, this._typeCheckCompiler.compileComponent(componentId, compMeta, parsedTemplate, usedPipes, externalReferenceVars, ctx));
                };
                AotCompiler.prototype.emitMessageBundle = function (analyzeResult, locale) {
                    var _this = this;
                    var errors = [];
                    var htmlParser = new HtmlParser();
                    // TODO(vicb): implicit tags & attributes
                    var messageBundle = new MessageBundle(htmlParser, [], {}, locale);
                    analyzeResult.files.forEach(function (file) {
                        var compMetas = [];
                        file.directives.forEach(function (directiveType) {
                            var dirMeta = _this._metadataResolver.getDirectiveMetadata(directiveType);
                            if (dirMeta && dirMeta.isComponent) {
                                compMetas.push(dirMeta);
                            }
                        });
                        compMetas.forEach(function (compMeta) {
                            var html = compMeta.template.template;
                            // Template URL points to either an HTML or TS file depending on whether
                            // the file is used with `templateUrl:` or `template:`, respectively.
                            var templateUrl = compMeta.template.templateUrl;
                            var interpolationConfig = InterpolationConfig.fromArray(compMeta.template.interpolation);
                            errors.push.apply(errors, messageBundle.updateFromTemplate(html, templateUrl, interpolationConfig));
                        });
                    });
                    if (errors.length) {
                        throw new Error(errors.map(function (e) { return e.toString(); }).join('\n'));
                    }
                    return messageBundle;
                };
                AotCompiler.prototype.emitAllPartialModules = function (_c, r3Files) {
                    var _this = this;
                    var ngModuleByPipeOrDirective = _c.ngModuleByPipeOrDirective, files = _c.files;
                    var contextMap = new Map();
                    var getContext = function (fileName) {
                        if (!contextMap.has(fileName)) {
                            contextMap.set(fileName, _this._createOutputContext(fileName));
                        }
                        return contextMap.get(fileName);
                    };
                    files.forEach(function (file) { return _this._compilePartialModule(file.fileName, ngModuleByPipeOrDirective, file.directives, file.pipes, file.ngModules, file.injectables, getContext(file.fileName)); });
                    r3Files.forEach(function (file) { return _this._compileShallowModules(file.fileName, file.shallowModules, getContext(file.fileName)); });
                    return Array.from(contextMap.values())
                        .map(function (context) { return ({
                        fileName: context.genFilePath,
                        statements: context.constantPool.statements.concat(context.statements),
                    }); });
                };
                AotCompiler.prototype._compileShallowModules = function (fileName, shallowModules, context) {
                    var _this = this;
                    shallowModules.forEach(function (module) { return compileNgModuleFromRender2(context, module, _this._injectableCompiler); });
                };
                AotCompiler.prototype._compilePartialModule = function (fileName, ngModuleByPipeOrDirective, directives, pipes, ngModules, injectables, context) {
                    var _this = this;
                    var errors = [];
                    var schemaRegistry = new DomElementSchemaRegistry();
                    var hostBindingParser = new BindingParser(this._templateParser.expressionParser, DEFAULT_INTERPOLATION_CONFIG, schemaRegistry, [], errors);
                    // Process all components and directives
                    directives.forEach(function (directiveType) {
                        var directiveMetadata = _this._metadataResolver.getDirectiveMetadata(directiveType);
                        if (directiveMetadata.isComponent) {
                            var module_3 = ngModuleByPipeOrDirective.get(directiveType);
                            module_3 ||
                                error("Cannot determine the module for component '" + identifierName(directiveMetadata.type) + "'");
                            var htmlAst = directiveMetadata.template.htmlAst;
                            var preserveWhitespaces = directiveMetadata.template.preserveWhitespaces;
                            if (!preserveWhitespaces) {
                                htmlAst = removeWhitespaces(htmlAst);
                            }
                            var render3Ast = htmlAstToRender3Ast(htmlAst.rootNodes, hostBindingParser);
                            // Map of StaticType by directive selectors
                            var directiveTypeBySel_1 = new Map();
                            var directives_1 = module_3.transitiveModule.directives.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
                            directives_1.forEach(function (directive) {
                                if (directive.selector) {
                                    directiveTypeBySel_1.set(directive.selector, directive.type.reference);
                                }
                            });
                            // Map of StaticType by pipe names
                            var pipeTypeByName_1 = new Map();
                            var pipes_1 = module_3.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
                            pipes_1.forEach(function (pipe) { pipeTypeByName_1.set(pipe.name, pipe.type.reference); });
                            compileComponentFromRender2(context, directiveMetadata, render3Ast, _this.reflector, hostBindingParser, directiveTypeBySel_1, pipeTypeByName_1);
                        }
                        else {
                            compileDirectiveFromRender2(context, directiveMetadata, _this.reflector, hostBindingParser);
                        }
                    });
                    pipes.forEach(function (pipeType) {
                        var pipeMetadata = _this._metadataResolver.getPipeMetadata(pipeType);
                        if (pipeMetadata) {
                            compilePipeFromRender2(context, pipeMetadata, _this.reflector);
                        }
                    });
                    injectables.forEach(function (injectable) { return _this._injectableCompiler.compile(injectable, context); });
                };
                AotCompiler.prototype.emitAllPartialModules2 = function (files) {
                    var _this = this;
                    // Using reduce like this is a select many pattern (where map is a select pattern)
                    return files.reduce(function (r, file) {
                        r.push.apply(r, _this._emitPartialModule2(file.fileName, file.injectables));
                        return r;
                    }, []);
                };
                AotCompiler.prototype._emitPartialModule2 = function (fileName, injectables) {
                    var _this = this;
                    var context = this._createOutputContext(fileName);
                    injectables.forEach(function (injectable) { return _this._injectableCompiler.compile(injectable, context); });
                    if (context.statements && context.statements.length > 0) {
                        return [{ fileName: fileName, statements: context.constantPool.statements.concat(context.statements) }];
                    }
                    return [];
                };
                AotCompiler.prototype.emitAllImpls = function (analyzeResult) {
                    var _this = this;
                    var ngModuleByPipeOrDirective = analyzeResult.ngModuleByPipeOrDirective, files = analyzeResult.files;
                    var sourceModules = files.map(function (file) { return _this._compileImplFile(file.fileName, ngModuleByPipeOrDirective, file.directives, file.pipes, file.ngModules, file.injectables); });
                    return flatten(sourceModules);
                };
                AotCompiler.prototype._compileImplFile = function (srcFileUrl, ngModuleByPipeOrDirective, directives, pipes, ngModules, injectables) {
                    var _this = this;
                    var fileSuffix = normalizeGenFileSuffix(splitTypescriptSuffix(srcFileUrl, true)[1]);
                    var generatedFiles = [];
                    var outputCtx = this._createOutputContext(ngfactoryFilePath(srcFileUrl, true));
                    generatedFiles.push.apply(generatedFiles, this._createSummary(srcFileUrl, directives, pipes, ngModules, injectables, outputCtx));
                    // compile all ng modules
                    ngModules.forEach(function (ngModuleMeta) { return _this._compileModule(outputCtx, ngModuleMeta); });
                    // compile components
                    directives.forEach(function (dirType) {
                        var compMeta = _this._metadataResolver.getDirectiveMetadata(dirType);
                        if (!compMeta.isComponent) {
                            return;
                        }
                        var ngModule = ngModuleByPipeOrDirective.get(dirType);
                        if (!ngModule) {
                            throw new Error("Internal Error: cannot determine the module for component " + identifierName(compMeta.type) + "!");
                        }
                        // compile styles
                        var componentStylesheet = _this._styleCompiler.compileComponent(outputCtx, compMeta);
                        // Note: compMeta is a component and therefore template is non null.
                        compMeta.template.externalStylesheets.forEach(function (stylesheetMeta) {
                            // Note: fill non shim and shim style files as they might
                            // be shared by component with and without ViewEncapsulation.
                            var shim = _this._styleCompiler.needsStyleShim(compMeta);
                            generatedFiles.push(_this._codegenStyles(srcFileUrl, compMeta, stylesheetMeta, shim, fileSuffix));
                            if (_this._options.allowEmptyCodegenFiles) {
                                generatedFiles.push(_this._codegenStyles(srcFileUrl, compMeta, stylesheetMeta, !shim, fileSuffix));
                            }
                        });
                        // compile components
                        var compViewVars = _this._compileComponent(outputCtx, compMeta, ngModule, ngModule.transitiveModule.directives, componentStylesheet, fileSuffix);
                        _this._compileComponentFactory(outputCtx, compMeta, ngModule, fileSuffix);
                    });
                    if (outputCtx.statements.length > 0 || this._options.allowEmptyCodegenFiles) {
                        var srcModule = this._codegenSourceModule(srcFileUrl, outputCtx);
                        generatedFiles.unshift(srcModule);
                    }
                    return generatedFiles;
                };
                AotCompiler.prototype._createSummary = function (srcFileName, directives, pipes, ngModules, injectables, ngFactoryCtx) {
                    var _this = this;
                    var symbolSummaries = this._symbolResolver.getSymbolsOf(srcFileName)
                        .map(function (symbol) { return _this._symbolResolver.resolveSymbol(symbol); });
                    var typeData = ngModules.map(function (meta) { return ({
                        summary: _this._metadataResolver.getNgModuleSummary(meta.type.reference),
                        metadata: _this._metadataResolver.getNgModuleMetadata(meta.type.reference)
                    }); }).concat(directives.map(function (ref) { return ({
                        summary: _this._metadataResolver.getDirectiveSummary(ref),
                        metadata: _this._metadataResolver.getDirectiveMetadata(ref)
                    }); }), pipes.map(function (ref) { return ({
                        summary: _this._metadataResolver.getPipeSummary(ref),
                        metadata: _this._metadataResolver.getPipeMetadata(ref)
                    }); }), injectables.map(function (ref) { return ({
                        summary: _this._metadataResolver.getInjectableSummary(ref.symbol),
                        metadata: _this._metadataResolver.getInjectableSummary(ref.symbol).type
                    }); }));
                    var forJitOutputCtx = this._options.enableSummariesForJit ?
                        this._createOutputContext(summaryForJitFileName(srcFileName, true)) :
                        null;
                    var _c = serializeSummaries(srcFileName, forJitOutputCtx, this._summaryResolver, this._symbolResolver, symbolSummaries, typeData, this._options.createExternalSymbolFactoryReexports), json = _c.json, exportAs = _c.exportAs;
                    exportAs.forEach(function (entry) {
                        ngFactoryCtx.statements.push(variable(entry.exportAs).set(ngFactoryCtx.importExpr(entry.symbol)).toDeclStmt(null, [
                            StmtModifier.Exported
                        ]));
                    });
                    var summaryJson = new GeneratedFile(srcFileName, summaryFileName(srcFileName), json);
                    var result = [summaryJson];
                    if (forJitOutputCtx) {
                        result.push(this._codegenSourceModule(srcFileName, forJitOutputCtx));
                    }
                    return result;
                };
                AotCompiler.prototype._compileModule = function (outputCtx, ngModule) {
                    var providers = [];
                    if (this._options.locale) {
                        var normalizedLocale = this._options.locale.replace(/_/g, '-');
                        providers.push({
                            token: createTokenForExternalReference(this.reflector, Identifiers.LOCALE_ID),
                            useValue: normalizedLocale,
                        });
                    }
                    if (this._options.i18nFormat) {
                        providers.push({
                            token: createTokenForExternalReference(this.reflector, Identifiers.TRANSLATIONS_FORMAT),
                            useValue: this._options.i18nFormat
                        });
                    }
                    this._ngModuleCompiler.compile(outputCtx, ngModule, providers);
                };
                AotCompiler.prototype._compileComponentFactory = function (outputCtx, compMeta, ngModule, fileSuffix) {
                    var hostMeta = this._metadataResolver.getHostComponentMetadata(compMeta);
                    var hostViewFactoryVar = this._compileComponent(outputCtx, hostMeta, ngModule, [compMeta.type], null, fileSuffix)
                        .viewClassVar;
                    var compFactoryVar = componentFactoryName(compMeta.type.reference);
                    var inputsExprs = [];
                    for (var propName in compMeta.inputs) {
                        var templateName = compMeta.inputs[propName];
                        // Don't quote so that the key gets minified...
                        inputsExprs.push(new LiteralMapEntry(propName, literal(templateName), false));
                    }
                    var outputsExprs = [];
                    for (var propName in compMeta.outputs) {
                        var templateName = compMeta.outputs[propName];
                        // Don't quote so that the key gets minified...
                        outputsExprs.push(new LiteralMapEntry(propName, literal(templateName), false));
                    }
                    outputCtx.statements.push(variable(compFactoryVar)
                        .set(importExpr(Identifiers.createComponentFactory).callFn([
                        literal(compMeta.selector), outputCtx.importExpr(compMeta.type.reference),
                        variable(hostViewFactoryVar), new LiteralMapExpr(inputsExprs),
                        new LiteralMapExpr(outputsExprs),
                        literalArr(compMeta.template.ngContentSelectors.map(function (selector) { return literal(selector); }))
                    ]))
                        .toDeclStmt(importType(Identifiers.ComponentFactory, [expressionType(outputCtx.importExpr(compMeta.type.reference))], [TypeModifier.Const]), [StmtModifier.Final, StmtModifier.Exported]));
                };
                AotCompiler.prototype._compileComponent = function (outputCtx, compMeta, ngModule, directiveIdentifiers, componentStyles, fileSuffix) {
                    var _c = this._parseTemplate(compMeta, ngModule, directiveIdentifiers), parsedTemplate = _c.template, usedPipes = _c.pipes;
                    var stylesExpr = componentStyles ? variable(componentStyles.stylesVar) : literalArr([]);
                    var viewResult = this._viewCompiler.compileComponent(outputCtx, compMeta, parsedTemplate, stylesExpr, usedPipes);
                    if (componentStyles) {
                        _resolveStyleStatements(this._symbolResolver, componentStyles, this._styleCompiler.needsStyleShim(compMeta), fileSuffix);
                    }
                    return viewResult;
                };
                AotCompiler.prototype._parseTemplate = function (compMeta, ngModule, directiveIdentifiers) {
                    var _this = this;
                    if (this._templateAstCache.has(compMeta.type.reference)) {
                        return this._templateAstCache.get(compMeta.type.reference);
                    }
                    var preserveWhitespaces = compMeta.template.preserveWhitespaces;
                    var directives = directiveIdentifiers.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
                    var pipes = ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
                    var result = this._templateParser.parse(compMeta, compMeta.template.htmlAst, directives, pipes, ngModule.schemas, templateSourceUrl(ngModule.type, compMeta, compMeta.template), preserveWhitespaces);
                    this._templateAstCache.set(compMeta.type.reference, result);
                    return result;
                };
                AotCompiler.prototype._createOutputContext = function (genFilePath) {
                    var _this = this;
                    var importExpr$1 = function (symbol, typeParams, useSummaries) {
                        if (typeParams === void 0) { typeParams = null; }
                        if (useSummaries === void 0) { useSummaries = true; }
                        if (!(symbol instanceof StaticSymbol)) {
                            throw new Error("Internal error: unknown identifier " + JSON.stringify(symbol));
                        }
                        var arity = _this._symbolResolver.getTypeArity(symbol) || 0;
                        var _c = _this._symbolResolver.getImportAs(symbol, useSummaries) || symbol, filePath = _c.filePath, name = _c.name, members = _c.members;
                        var importModule = _this._fileNameToModuleName(filePath, genFilePath);
                        // It should be good enough to compare filePath to genFilePath and if they are equal
                        // there is a self reference. However, ngfactory files generate to .ts but their
                        // symbols have .d.ts so a simple compare is insufficient. They should be canonical
                        // and is tracked by #17705.
                        var selfReference = _this._fileNameToModuleName(genFilePath, genFilePath);
                        var moduleName = importModule === selfReference ? null : importModule;
                        // If we are in a type expression that refers to a generic type then supply
                        // the required type parameters. If there were not enough type parameters
                        // supplied, supply any as the type. Outside a type expression the reference
                        // should not supply type parameters and be treated as a simple value reference
                        // to the constructor function itself.
                        var suppliedTypeParams = typeParams || [];
                        var missingTypeParamsCount = arity - suppliedTypeParams.length;
                        var allTypeParams = suppliedTypeParams.concat(new Array(missingTypeParamsCount).fill(DYNAMIC_TYPE));
                        return members.reduce(function (expr, memberName) { return expr.prop(memberName); }, importExpr(new ExternalReference(moduleName, name, null), allTypeParams));
                    };
                    return { statements: [], genFilePath: genFilePath, importExpr: importExpr$1, constantPool: new ConstantPool() };
                };
                AotCompiler.prototype._fileNameToModuleName = function (importedFilePath, containingFilePath) {
                    return this._summaryResolver.getKnownModuleName(importedFilePath) ||
                        this._symbolResolver.getKnownModuleName(importedFilePath) ||
                        this._host.fileNameToModuleName(importedFilePath, containingFilePath);
                };
                AotCompiler.prototype._codegenStyles = function (srcFileUrl, compMeta, stylesheetMetadata, isShimmed, fileSuffix) {
                    var outputCtx = this._createOutputContext(_stylesModuleUrl(stylesheetMetadata.moduleUrl, isShimmed, fileSuffix));
                    var compiledStylesheet = this._styleCompiler.compileStyles(outputCtx, compMeta, stylesheetMetadata, isShimmed);
                    _resolveStyleStatements(this._symbolResolver, compiledStylesheet, isShimmed, fileSuffix);
                    return this._codegenSourceModule(srcFileUrl, outputCtx);
                };
                AotCompiler.prototype._codegenSourceModule = function (srcFileUrl, ctx) {
                    return new GeneratedFile(srcFileUrl, ctx.genFilePath, ctx.statements);
                };
                AotCompiler.prototype.listLazyRoutes = function (entryRoute, analyzedModules) {
                    var self = this;
                    if (entryRoute) {
                        var symbol = parseLazyRoute(entryRoute, this.reflector).referencedModule;
                        return visitLazyRoute(symbol);
                    }
                    else if (analyzedModules) {
                        var allLazyRoutes = [];
                        for (var _c = 0, _d = analyzedModules.ngModules; _c < _d.length; _c++) {
                            var ngModule = _d[_c];
                            var lazyRoutes = listLazyRoutes(ngModule, this.reflector);
                            for (var _e = 0, lazyRoutes_1 = lazyRoutes; _e < lazyRoutes_1.length; _e++) {
                                var lazyRoute = lazyRoutes_1[_e];
                                allLazyRoutes.push(lazyRoute);
                            }
                        }
                        return allLazyRoutes;
                    }
                    else {
                        throw new Error("Either route or analyzedModules has to be specified!");
                    }
                    function visitLazyRoute(symbol, seenRoutes, allLazyRoutes) {
                        if (seenRoutes === void 0) { seenRoutes = new Set(); }
                        if (allLazyRoutes === void 0) { allLazyRoutes = []; }
                        // Support pointing to default exports, but stop recursing there,
                        // as the StaticReflector does not yet support default exports.
                        if (seenRoutes.has(symbol) || !symbol.name) {
                            return allLazyRoutes;
                        }
                        seenRoutes.add(symbol);
                        var lazyRoutes = listLazyRoutes(self._metadataResolver.getNgModuleMetadata(symbol, true), self.reflector);
                        for (var _c = 0, lazyRoutes_2 = lazyRoutes; _c < lazyRoutes_2.length; _c++) {
                            var lazyRoute = lazyRoutes_2[_c];
                            allLazyRoutes.push(lazyRoute);
                            visitLazyRoute(lazyRoute.referencedModule, seenRoutes, allLazyRoutes);
                        }
                        return allLazyRoutes;
                    }
                };
                return AotCompiler;
            }());
            function _createEmptyStub(outputCtx) {
                // Note: We need to produce at least one import statement so that
                // TypeScript knows that the file is an es6 module. Otherwise our generated
                // exports / imports won't be emitted properly by TypeScript.
                outputCtx.statements.push(importExpr(Identifiers.ComponentFactory).toStmt());
            }
            function _resolveStyleStatements(symbolResolver, compileResult, needsShim, fileSuffix) {
                compileResult.dependencies.forEach(function (dep) {
                    dep.setValue(symbolResolver.getStaticSymbol(_stylesModuleUrl(dep.moduleUrl, needsShim, fileSuffix), dep.name));
                });
            }
            function _stylesModuleUrl(stylesheetUrl, shim, suffix) {
                return "" + stylesheetUrl + (shim ? '.shim' : '') + ".ngstyle" + suffix;
            }
            function analyzeNgModules(fileNames, host, staticSymbolResolver, metadataResolver) {
                var files = _analyzeFilesIncludingNonProgramFiles(fileNames, host, staticSymbolResolver, metadataResolver);
                return mergeAnalyzedFiles(files);
            }
            function analyzeAndValidateNgModules(fileNames, host, staticSymbolResolver, metadataResolver) {
                return validateAnalyzedModules(analyzeNgModules(fileNames, host, staticSymbolResolver, metadataResolver));
            }
            function validateAnalyzedModules(analyzedModules) {
                if (analyzedModules.symbolsMissingModule && analyzedModules.symbolsMissingModule.length) {
                    var messages = analyzedModules.symbolsMissingModule.map(function (s) { return "Cannot determine the module for class " + s.name + " in " + s.filePath + "! Add " + s.name + " to the NgModule to fix it."; });
                    throw syntaxError(messages.join('\n'));
                }
                return analyzedModules;
            }
            // Analyzes all of the program files,
            // including files that are not part of the program
            // but are referenced by an NgModule.
            function _analyzeFilesIncludingNonProgramFiles(fileNames, host, staticSymbolResolver, metadataResolver) {
                var seenFiles = new Set();
                var files = [];
                var visitFile = function (fileName) {
                    if (seenFiles.has(fileName) || !host.isSourceFile(fileName)) {
                        return false;
                    }
                    seenFiles.add(fileName);
                    var analyzedFile = analyzeFile(host, staticSymbolResolver, metadataResolver, fileName);
                    files.push(analyzedFile);
                    analyzedFile.ngModules.forEach(function (ngModule) {
                        ngModule.transitiveModule.modules.forEach(function (modMeta) { return visitFile(modMeta.reference.filePath); });
                    });
                };
                fileNames.forEach(function (fileName) { return visitFile(fileName); });
                return files;
            }
            function analyzeFile(host, staticSymbolResolver, metadataResolver, fileName) {
                var directives = [];
                var pipes = [];
                var injectables = [];
                var ngModules = [];
                var hasDecorators = staticSymbolResolver.hasDecorators(fileName);
                var exportsNonSourceFiles = false;
                // Don't analyze .d.ts files that have no decorators as a shortcut
                // to speed up the analysis. This prevents us from
                // resolving the references in these files.
                // Note: exportsNonSourceFiles is only needed when compiling with summaries,
                // which is not the case when .d.ts files are treated as input files.
                if (!fileName.endsWith('.d.ts') || hasDecorators) {
                    staticSymbolResolver.getSymbolsOf(fileName).forEach(function (symbol) {
                        var resolvedSymbol = staticSymbolResolver.resolveSymbol(symbol);
                        var symbolMeta = resolvedSymbol.metadata;
                        if (!symbolMeta || symbolMeta.__symbolic === 'error') {
                            return;
                        }
                        var isNgSymbol = false;
                        if (symbolMeta.__symbolic === 'class') {
                            if (metadataResolver.isDirective(symbol)) {
                                isNgSymbol = true;
                                directives.push(symbol);
                            }
                            else if (metadataResolver.isPipe(symbol)) {
                                isNgSymbol = true;
                                pipes.push(symbol);
                            }
                            else if (metadataResolver.isNgModule(symbol)) {
                                var ngModule = metadataResolver.getNgModuleMetadata(symbol, false);
                                if (ngModule) {
                                    isNgSymbol = true;
                                    ngModules.push(ngModule);
                                }
                            }
                            else if (metadataResolver.isInjectable(symbol)) {
                                isNgSymbol = true;
                                var injectable = metadataResolver.getInjectableMetadata(symbol, null, false);
                                if (injectable) {
                                    injectables.push(injectable);
                                }
                            }
                        }
                        if (!isNgSymbol) {
                            exportsNonSourceFiles =
                                exportsNonSourceFiles || isValueExportingNonSourceFile(host, symbolMeta);
                        }
                    });
                }
                return {
                    fileName: fileName, directives: directives, pipes: pipes, ngModules: ngModules, injectables: injectables, exportsNonSourceFiles: exportsNonSourceFiles,
                };
            }
            function analyzeFileForInjectables(host, staticSymbolResolver, metadataResolver, fileName) {
                var injectables = [];
                var shallowModules = [];
                if (staticSymbolResolver.hasDecorators(fileName)) {
                    staticSymbolResolver.getSymbolsOf(fileName).forEach(function (symbol) {
                        var resolvedSymbol = staticSymbolResolver.resolveSymbol(symbol);
                        var symbolMeta = resolvedSymbol.metadata;
                        if (!symbolMeta || symbolMeta.__symbolic === 'error') {
                            return;
                        }
                        if (symbolMeta.__symbolic === 'class') {
                            if (metadataResolver.isInjectable(symbol)) {
                                var injectable = metadataResolver.getInjectableMetadata(symbol, null, false);
                                if (injectable) {
                                    injectables.push(injectable);
                                }
                            }
                            else if (metadataResolver.isNgModule(symbol)) {
                                var module_4 = metadataResolver.getShallowModuleMetadata(symbol);
                                if (module_4) {
                                    shallowModules.push(module_4);
                                }
                            }
                        }
                    });
                }
                return { fileName: fileName, injectables: injectables, shallowModules: shallowModules };
            }
            function isValueExportingNonSourceFile(host, metadata) {
                var exportsNonSourceFiles = false;
                var Visitor = /** @class */ (function () {
                    function Visitor() {
                    }
                    Visitor.prototype.visitArray = function (arr, context) {
                        var _this = this;
                        arr.forEach(function (v) { return visitValue(v, _this, context); });
                    };
                    Visitor.prototype.visitStringMap = function (map, context) {
                        var _this = this;
                        Object.keys(map).forEach(function (key) { return visitValue(map[key], _this, context); });
                    };
                    Visitor.prototype.visitPrimitive = function (value, context) { };
                    Visitor.prototype.visitOther = function (value, context) {
                        if (value instanceof StaticSymbol && !host.isSourceFile(value.filePath)) {
                            exportsNonSourceFiles = true;
                        }
                    };
                    return Visitor;
                }());
                visitValue(metadata, new Visitor(), null);
                return exportsNonSourceFiles;
            }
            function mergeAnalyzedFiles(analyzedFiles) {
                var allNgModules = [];
                var ngModuleByPipeOrDirective = new Map();
                var allPipesAndDirectives = new Set();
                analyzedFiles.forEach(function (af) {
                    af.ngModules.forEach(function (ngModule) {
                        allNgModules.push(ngModule);
                        ngModule.declaredDirectives.forEach(function (d) { return ngModuleByPipeOrDirective.set(d.reference, ngModule); });
                        ngModule.declaredPipes.forEach(function (p) { return ngModuleByPipeOrDirective.set(p.reference, ngModule); });
                    });
                    af.directives.forEach(function (d) { return allPipesAndDirectives.add(d); });
                    af.pipes.forEach(function (p) { return allPipesAndDirectives.add(p); });
                });
                var symbolsMissingModule = [];
                allPipesAndDirectives.forEach(function (ref) {
                    if (!ngModuleByPipeOrDirective.has(ref)) {
                        symbolsMissingModule.push(ref);
                    }
                });
                return {
                    ngModules: allNgModules,
                    ngModuleByPipeOrDirective: ngModuleByPipeOrDirective,
                    symbolsMissingModule: symbolsMissingModule,
                    files: analyzedFiles
                };
            }
            function mergeAndValidateNgFiles(files) {
                return validateAnalyzedModules(mergeAnalyzedFiles(files));
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var FORMATTED_MESSAGE = 'ngFormattedMessage';
            function indentStr(level) {
                if (level <= 0)
                    return '';
                if (level < 6)
                    return ['', ' ', '  ', '   ', '    ', '     '][level];
                var half = indentStr(Math.floor(level / 2));
                return half + half + (level % 2 === 1 ? ' ' : '');
            }
            function formatChain(chain, indent) {
                if (indent === void 0) { indent = 0; }
                if (!chain)
                    return '';
                var position = chain.position ?
                    chain.position.fileName + "(" + (chain.position.line + 1) + "," + (chain.position.column + 1) + ")" :
                    '';
                var prefix = position && indent === 0 ? position + ": " : '';
                var postfix = position && indent !== 0 ? " at " + position : '';
                var message = "" + prefix + chain.message + postfix;
                return "" + indentStr(indent) + message + ((chain.next && ('\n' + formatChain(chain.next, indent + 2))) || '');
            }
            function formattedError(chain) {
                var message = formatChain(chain) + '.';
                var error = syntaxError(message);
                error[FORMATTED_MESSAGE] = true;
                error.chain = chain;
                error.position = chain.position;
                return error;
            }
            function isFormattedError(error) {
                return !!error[FORMATTED_MESSAGE];
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ANGULAR_CORE = '@angular/core';
            var ANGULAR_ROUTER = '@angular/router';
            var HIDDEN_KEY = /^\$.*\$$/;
            var IGNORE = {
                __symbolic: 'ignore'
            };
            var USE_VALUE$1 = 'useValue';
            var PROVIDE = 'provide';
            var REFERENCE_SET = new Set([USE_VALUE$1, 'useFactory', 'data', 'id', 'loadChildren']);
            var TYPEGUARD_POSTFIX = 'TypeGuard';
            var USE_IF = 'UseIf';
            function shouldIgnore(value) {
                return value && value.__symbolic == 'ignore';
            }
            /**
             * A static reflector implements enough of the Reflector API that is necessary to compile
             * templates statically.
             */
            var StaticReflector = /** @class */ (function () {
                function StaticReflector(summaryResolver, symbolResolver, knownMetadataClasses, knownMetadataFunctions, errorRecorder) {
                    var _this = this;
                    if (knownMetadataClasses === void 0) { knownMetadataClasses = []; }
                    if (knownMetadataFunctions === void 0) { knownMetadataFunctions = []; }
                    this.summaryResolver = summaryResolver;
                    this.symbolResolver = symbolResolver;
                    this.errorRecorder = errorRecorder;
                    this.annotationCache = new Map();
                    this.shallowAnnotationCache = new Map();
                    this.propertyCache = new Map();
                    this.parameterCache = new Map();
                    this.methodCache = new Map();
                    this.staticCache = new Map();
                    this.conversionMap = new Map();
                    this.resolvedExternalReferences = new Map();
                    this.annotationForParentClassWithSummaryKind = new Map();
                    this.initializeConversionMap();
                    knownMetadataClasses.forEach(function (kc) { return _this._registerDecoratorOrConstructor(_this.getStaticSymbol(kc.filePath, kc.name), kc.ctor); });
                    knownMetadataFunctions.forEach(function (kf) { return _this._registerFunction(_this.getStaticSymbol(kf.filePath, kf.name), kf.fn); });
                    this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Directive, [createDirective, createComponent]);
                    this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Pipe, [createPipe]);
                    this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.NgModule, [createNgModule]);
                    this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Injectable, [createInjectable, createPipe, createDirective, createComponent, createNgModule]);
                }
                StaticReflector.prototype.componentModuleUrl = function (typeOrFunc) {
                    var staticSymbol = this.findSymbolDeclaration(typeOrFunc);
                    return this.symbolResolver.getResourcePath(staticSymbol);
                };
                StaticReflector.prototype.resolveExternalReference = function (ref, containingFile) {
                    var key = undefined;
                    if (!containingFile) {
                        key = ref.moduleName + ":" + ref.name;
                        var declarationSymbol_1 = this.resolvedExternalReferences.get(key);
                        if (declarationSymbol_1)
                            return declarationSymbol_1;
                    }
                    var refSymbol = this.symbolResolver.getSymbolByModule(ref.moduleName, ref.name, containingFile);
                    var declarationSymbol = this.findSymbolDeclaration(refSymbol);
                    if (!containingFile) {
                        this.symbolResolver.recordModuleNameForFileName(refSymbol.filePath, ref.moduleName);
                        this.symbolResolver.recordImportAs(declarationSymbol, refSymbol);
                    }
                    if (key) {
                        this.resolvedExternalReferences.set(key, declarationSymbol);
                    }
                    return declarationSymbol;
                };
                StaticReflector.prototype.findDeclaration = function (moduleUrl, name, containingFile) {
                    return this.findSymbolDeclaration(this.symbolResolver.getSymbolByModule(moduleUrl, name, containingFile));
                };
                StaticReflector.prototype.tryFindDeclaration = function (moduleUrl, name, containingFile) {
                    var _this = this;
                    return this.symbolResolver.ignoreErrorsFor(function () { return _this.findDeclaration(moduleUrl, name, containingFile); });
                };
                StaticReflector.prototype.findSymbolDeclaration = function (symbol) {
                    var resolvedSymbol = this.symbolResolver.resolveSymbol(symbol);
                    if (resolvedSymbol) {
                        var resolvedMetadata = resolvedSymbol.metadata;
                        if (resolvedMetadata && resolvedMetadata.__symbolic === 'resolved') {
                            resolvedMetadata = resolvedMetadata.symbol;
                        }
                        if (resolvedMetadata instanceof StaticSymbol) {
                            return this.findSymbolDeclaration(resolvedSymbol.metadata);
                        }
                    }
                    return symbol;
                };
                StaticReflector.prototype.tryAnnotations = function (type) {
                    var originalRecorder = this.errorRecorder;
                    this.errorRecorder = function (error, fileName) { };
                    try {
                        return this.annotations(type);
                    }
                    finally {
                        this.errorRecorder = originalRecorder;
                    }
                };
                StaticReflector.prototype.annotations = function (type) {
                    var _this = this;
                    return this._annotations(type, function (type, decorators) { return _this.simplify(type, decorators); }, this.annotationCache);
                };
                StaticReflector.prototype.shallowAnnotations = function (type) {
                    var _this = this;
                    return this._annotations(type, function (type, decorators) { return _this.simplify(type, decorators, true); }, this.shallowAnnotationCache);
                };
                StaticReflector.prototype._annotations = function (type, simplify, annotationCache) {
                    var annotations = annotationCache.get(type);
                    if (!annotations) {
                        annotations = [];
                        var classMetadata = this.getTypeMetadata(type);
                        var parentType = this.findParentType(type, classMetadata);
                        if (parentType) {
                            var parentAnnotations = this.annotations(parentType);
                            annotations.push.apply(annotations, parentAnnotations);
                        }
                        var ownAnnotations_1 = [];
                        if (classMetadata['decorators']) {
                            ownAnnotations_1 = simplify(type, classMetadata['decorators']);
                            if (ownAnnotations_1) {
                                annotations.push.apply(annotations, ownAnnotations_1);
                            }
                        }
                        if (parentType && !this.summaryResolver.isLibraryFile(type.filePath) &&
                            this.summaryResolver.isLibraryFile(parentType.filePath)) {
                            var summary = this.summaryResolver.resolveSummary(parentType);
                            if (summary && summary.type) {
                                var requiredAnnotationTypes = this.annotationForParentClassWithSummaryKind.get(summary.type.summaryKind);
                                var typeHasRequiredAnnotation = requiredAnnotationTypes.some(function (requiredType) { return ownAnnotations_1.some(function (ann) { return requiredType.isTypeOf(ann); }); });
                                if (!typeHasRequiredAnnotation) {
                                    this.reportError(formatMetadataError(metadataError("Class " + type.name + " in " + type.filePath + " extends from a " + CompileSummaryKind[summary.type.summaryKind] + " in another compilation unit without duplicating the decorator", 
                                    /* summary */ undefined, "Please add a " + requiredAnnotationTypes.map(function (type) { return type.ngMetadataName; }).join(' or ') + " decorator to the class"), type), type);
                                }
                            }
                        }
                        annotationCache.set(type, annotations.filter(function (ann) { return !!ann; }));
                    }
                    return annotations;
                };
                StaticReflector.prototype.propMetadata = function (type) {
                    var _this = this;
                    var propMetadata = this.propertyCache.get(type);
                    if (!propMetadata) {
                        var classMetadata = this.getTypeMetadata(type);
                        propMetadata = {};
                        var parentType = this.findParentType(type, classMetadata);
                        if (parentType) {
                            var parentPropMetadata_1 = this.propMetadata(parentType);
                            Object.keys(parentPropMetadata_1).forEach(function (parentProp) {
                                propMetadata[parentProp] = parentPropMetadata_1[parentProp];
                            });
                        }
                        var members_1 = classMetadata['members'] || {};
                        Object.keys(members_1).forEach(function (propName) {
                            var propData = members_1[propName];
                            var prop = propData
                                .find(function (a) { return a['__symbolic'] == 'property' || a['__symbolic'] == 'method'; });
                            var decorators = [];
                            if (propMetadata[propName]) {
                                decorators.push.apply(decorators, propMetadata[propName]);
                            }
                            propMetadata[propName] = decorators;
                            if (prop && prop['decorators']) {
                                decorators.push.apply(decorators, _this.simplify(type, prop['decorators']));
                            }
                        });
                        this.propertyCache.set(type, propMetadata);
                    }
                    return propMetadata;
                };
                StaticReflector.prototype.parameters = function (type) {
                    var _this = this;
                    if (!(type instanceof StaticSymbol)) {
                        this.reportError(new Error("parameters received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
                        return [];
                    }
                    try {
                        var parameters_1 = this.parameterCache.get(type);
                        if (!parameters_1) {
                            var classMetadata = this.getTypeMetadata(type);
                            var parentType = this.findParentType(type, classMetadata);
                            var members = classMetadata ? classMetadata['members'] : null;
                            var ctorData = members ? members['__ctor__'] : null;
                            if (ctorData) {
                                var ctor = ctorData.find(function (a) { return a['__symbolic'] == 'constructor'; });
                                var rawParameterTypes = ctor['parameters'] || [];
                                var parameterDecorators_1 = this.simplify(type, ctor['parameterDecorators'] || []);
                                parameters_1 = [];
                                rawParameterTypes.forEach(function (rawParamType, index) {
                                    var nestedResult = [];
                                    var paramType = _this.trySimplify(type, rawParamType);
                                    if (paramType)
                                        nestedResult.push(paramType);
                                    var decorators = parameterDecorators_1 ? parameterDecorators_1[index] : null;
                                    if (decorators) {
                                        nestedResult.push.apply(nestedResult, decorators);
                                    }
                                    parameters_1.push(nestedResult);
                                });
                            }
                            else if (parentType) {
                                parameters_1 = this.parameters(parentType);
                            }
                            if (!parameters_1) {
                                parameters_1 = [];
                            }
                            this.parameterCache.set(type, parameters_1);
                        }
                        return parameters_1;
                    }
                    catch (e) {
                        console.error("Failed on type " + JSON.stringify(type) + " with error " + e);
                        throw e;
                    }
                };
                StaticReflector.prototype._methodNames = function (type) {
                    var methodNames = this.methodCache.get(type);
                    if (!methodNames) {
                        var classMetadata = this.getTypeMetadata(type);
                        methodNames = {};
                        var parentType = this.findParentType(type, classMetadata);
                        if (parentType) {
                            var parentMethodNames_1 = this._methodNames(parentType);
                            Object.keys(parentMethodNames_1).forEach(function (parentProp) {
                                methodNames[parentProp] = parentMethodNames_1[parentProp];
                            });
                        }
                        var members_2 = classMetadata['members'] || {};
                        Object.keys(members_2).forEach(function (propName) {
                            var propData = members_2[propName];
                            var isMethod = propData.some(function (a) { return a['__symbolic'] == 'method'; });
                            methodNames[propName] = methodNames[propName] || isMethod;
                        });
                        this.methodCache.set(type, methodNames);
                    }
                    return methodNames;
                };
                StaticReflector.prototype._staticMembers = function (type) {
                    var staticMembers = this.staticCache.get(type);
                    if (!staticMembers) {
                        var classMetadata = this.getTypeMetadata(type);
                        var staticMemberData = classMetadata['statics'] || {};
                        staticMembers = Object.keys(staticMemberData);
                        this.staticCache.set(type, staticMembers);
                    }
                    return staticMembers;
                };
                StaticReflector.prototype.findParentType = function (type, classMetadata) {
                    var parentType = this.trySimplify(type, classMetadata['extends']);
                    if (parentType instanceof StaticSymbol) {
                        return parentType;
                    }
                };
                StaticReflector.prototype.hasLifecycleHook = function (type, lcProperty) {
                    if (!(type instanceof StaticSymbol)) {
                        this.reportError(new Error("hasLifecycleHook received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
                    }
                    try {
                        return !!this._methodNames(type)[lcProperty];
                    }
                    catch (e) {
                        console.error("Failed on type " + JSON.stringify(type) + " with error " + e);
                        throw e;
                    }
                };
                StaticReflector.prototype.guards = function (type) {
                    if (!(type instanceof StaticSymbol)) {
                        this.reportError(new Error("guards received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
                        return {};
                    }
                    var staticMembers = this._staticMembers(type);
                    var result = {};
                    for (var _c = 0, staticMembers_1 = staticMembers; _c < staticMembers_1.length; _c++) {
                        var name = staticMembers_1[_c];
                        if (name.endsWith(TYPEGUARD_POSTFIX)) {
                            var property = name.substr(0, name.length - TYPEGUARD_POSTFIX.length);
                            var value = void 0;
                            if (property.endsWith(USE_IF)) {
                                property = name.substr(0, property.length - USE_IF.length);
                                value = USE_IF;
                            }
                            else {
                                value = this.getStaticSymbol(type.filePath, type.name, [name]);
                            }
                            result[property] = value;
                        }
                    }
                    return result;
                };
                StaticReflector.prototype._registerDecoratorOrConstructor = function (type, ctor) {
                    this.conversionMap.set(type, function (context, args) { return new (ctor.bind.apply(ctor, [void 0].concat(args)))(); });
                };
                StaticReflector.prototype._registerFunction = function (type, fn) {
                    this.conversionMap.set(type, function (context, args) { return fn.apply(undefined, args); });
                };
                StaticReflector.prototype.initializeConversionMap = function () {
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Injectable'), createInjectable);
                    this.injectionToken = this.findDeclaration(ANGULAR_CORE, 'InjectionToken');
                    this.opaqueToken = this.findDeclaration(ANGULAR_CORE, 'OpaqueToken');
                    this.ROUTES = this.tryFindDeclaration(ANGULAR_ROUTER, 'ROUTES');
                    this.ANALYZE_FOR_ENTRY_COMPONENTS =
                        this.findDeclaration(ANGULAR_CORE, 'ANALYZE_FOR_ENTRY_COMPONENTS');
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Host'), createHost);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Self'), createSelf);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'SkipSelf'), createSkipSelf);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Inject'), createInject);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Optional'), createOptional);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Attribute'), createAttribute);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ContentChild'), createContentChild);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ContentChildren'), createContentChildren);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ViewChild'), createViewChild);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ViewChildren'), createViewChildren);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Input'), createInput);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Output'), createOutput);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Pipe'), createPipe);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'HostBinding'), createHostBinding);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'HostListener'), createHostListener);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Directive'), createDirective);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Component'), createComponent);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'NgModule'), createNgModule);
                    // Note: Some metadata classes can be used directly with Provider.deps.
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Host'), createHost);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Self'), createSelf);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'SkipSelf'), createSkipSelf);
                    this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Optional'), createOptional);
                };
                /**
                 * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
                 * All types passed to the StaticResolver should be pseudo-types returned by this method.
                 *
                 * @param declarationFile the absolute path of the file where the symbol is declared
                 * @param name the name of the type.
                 */
                StaticReflector.prototype.getStaticSymbol = function (declarationFile, name, members) {
                    return this.symbolResolver.getStaticSymbol(declarationFile, name, members);
                };
                /**
                 * Simplify but discard any errors
                 */
                StaticReflector.prototype.trySimplify = function (context, value) {
                    var originalRecorder = this.errorRecorder;
                    this.errorRecorder = function (error, fileName) { };
                    var result = this.simplify(context, value);
                    this.errorRecorder = originalRecorder;
                    return result;
                };
                /** @internal */
                StaticReflector.prototype.simplify = function (context, value, lazy) {
                    if (lazy === void 0) { lazy = false; }
                    var self = this;
                    var scope = BindingScope$1.empty;
                    var calling = new Map();
                    var rootContext = context;
                    function simplifyInContext(context, value, depth, references) {
                        function resolveReferenceValue(staticSymbol) {
                            var resolvedSymbol = self.symbolResolver.resolveSymbol(staticSymbol);
                            return resolvedSymbol ? resolvedSymbol.metadata : null;
                        }
                        function simplifyEagerly(value) {
                            return simplifyInContext(context, value, depth, 0);
                        }
                        function simplifyLazily(value) {
                            return simplifyInContext(context, value, depth, references + 1);
                        }
                        function simplifyNested(nestedContext, value) {
                            if (nestedContext === context) {
                                // If the context hasn't changed let the exception propagate unmodified.
                                return simplifyInContext(nestedContext, value, depth + 1, references);
                            }
                            try {
                                return simplifyInContext(nestedContext, value, depth + 1, references);
                            }
                            catch (e) {
                                if (isMetadataError(e)) {
                                    // Propagate the message text up but add a message to the chain that explains how we got
                                    // here.
                                    // e.chain implies e.symbol
                                    var summaryMsg = e.chain ? 'references \'' + e.symbol.name + '\'' : errorSummary(e);
                                    var summary = "'" + nestedContext.name + "' " + summaryMsg;
                                    var chain = { message: summary, position: e.position, next: e.chain };
                                    // TODO(chuckj): retrieve the position information indirectly from the collectors node
                                    // map if the metadata is from a .ts file.
                                    self.error({
                                        message: e.message,
                                        advise: e.advise,
                                        context: e.context, chain: chain,
                                        symbol: nestedContext
                                    }, context);
                                }
                                else {
                                    // It is probably an internal error.
                                    throw e;
                                }
                            }
                        }
                        function simplifyCall(functionSymbol, targetFunction, args, targetExpression) {
                            if (targetFunction && targetFunction['__symbolic'] == 'function') {
                                if (calling.get(functionSymbol)) {
                                    self.error({
                                        message: 'Recursion is not supported',
                                        summary: "called '" + functionSymbol.name + "' recursively",
                                        value: targetFunction
                                    }, functionSymbol);
                                }
                                try {
                                    var value_5 = targetFunction['value'];
                                    if (value_5 && (depth != 0 || value_5.__symbolic != 'error')) {
                                        var parameters = targetFunction['parameters'];
                                        var defaults = targetFunction.defaults;
                                        args = args.map(function (arg) { return simplifyNested(context, arg); })
                                            .map(function (arg) { return shouldIgnore(arg) ? undefined : arg; });
                                        if (defaults && defaults.length > args.length) {
                                            args.push.apply(args, defaults.slice(args.length).map(function (value) { return simplify(value); }));
                                        }
                                        calling.set(functionSymbol, true);
                                        var functionScope = BindingScope$1.build();
                                        for (var i = 0; i < parameters.length; i++) {
                                            functionScope.define(parameters[i], args[i]);
                                        }
                                        var oldScope = scope;
                                        var result_2;
                                        try {
                                            scope = functionScope.done();
                                            result_2 = simplifyNested(functionSymbol, value_5);
                                        }
                                        finally {
                                            scope = oldScope;
                                        }
                                        return result_2;
                                    }
                                }
                                finally {
                                    calling.delete(functionSymbol);
                                }
                            }
                            if (depth === 0) {
                                // If depth is 0 we are evaluating the top level expression that is describing element
                                // decorator. In this case, it is a decorator we don't understand, such as a custom
                                // non-angular decorator, and we should just ignore it.
                                return IGNORE;
                            }
                            var position = undefined;
                            if (targetExpression && targetExpression.__symbolic == 'resolved') {
                                var line = targetExpression.line;
                                var character = targetExpression.character;
                                var fileName = targetExpression.fileName;
                                if (fileName != null && line != null && character != null) {
                                    position = { fileName: fileName, line: line, column: character };
                                }
                            }
                            self.error({
                                message: FUNCTION_CALL_NOT_SUPPORTED,
                                context: functionSymbol,
                                value: targetFunction, position: position
                            }, context);
                        }
                        function simplify(expression) {
                            if (isPrimitive(expression)) {
                                return expression;
                            }
                            if (expression instanceof Array) {
                                var result_3 = [];
                                for (var _c = 0, expression_2 = expression; _c < expression_2.length; _c++) {
                                    var item = expression_2[_c];
                                    // Check for a spread expression
                                    if (item && item.__symbolic === 'spread') {
                                        // We call with references as 0 because we require the actual value and cannot
                                        // tolerate a reference here.
                                        var spreadArray = simplifyEagerly(item.expression);
                                        if (Array.isArray(spreadArray)) {
                                            for (var _d = 0, spreadArray_1 = spreadArray; _d < spreadArray_1.length; _d++) {
                                                var spreadItem = spreadArray_1[_d];
                                                result_3.push(spreadItem);
                                            }
                                            continue;
                                        }
                                    }
                                    var value_6 = simplify(item);
                                    if (shouldIgnore(value_6)) {
                                        continue;
                                    }
                                    result_3.push(value_6);
                                }
                                return result_3;
                            }
                            if (expression instanceof StaticSymbol) {
                                // Stop simplification at builtin symbols or if we are in a reference context and
                                // the symbol doesn't have members.
                                if (expression === self.injectionToken || self.conversionMap.has(expression) ||
                                    (references > 0 && !expression.members.length)) {
                                    return expression;
                                }
                                else {
                                    var staticSymbol = expression;
                                    var declarationValue = resolveReferenceValue(staticSymbol);
                                    if (declarationValue != null) {
                                        return simplifyNested(staticSymbol, declarationValue);
                                    }
                                    else {
                                        return staticSymbol;
                                    }
                                }
                            }
                            if (expression) {
                                if (expression['__symbolic']) {
                                    var staticSymbol = void 0;
                                    switch (expression['__symbolic']) {
                                        case 'binop':
                                            var left = simplify(expression['left']);
                                            if (shouldIgnore(left))
                                                return left;
                                            var right = simplify(expression['right']);
                                            if (shouldIgnore(right))
                                                return right;
                                            switch (expression['operator']) {
                                                case '&&':
                                                    return left && right;
                                                case '||':
                                                    return left || right;
                                                case '|':
                                                    return left | right;
                                                case '^':
                                                    return left ^ right;
                                                case '&':
                                                    return left & right;
                                                case '==':
                                                    return left == right;
                                                case '!=':
                                                    return left != right;
                                                case '===':
                                                    return left === right;
                                                case '!==':
                                                    return left !== right;
                                                case '<':
                                                    return left < right;
                                                case '>':
                                                    return left > right;
                                                case '<=':
                                                    return left <= right;
                                                case '>=':
                                                    return left >= right;
                                                case '<<':
                                                    return left << right;
                                                case '>>':
                                                    return left >> right;
                                                case '+':
                                                    return left + right;
                                                case '-':
                                                    return left - right;
                                                case '*':
                                                    return left * right;
                                                case '/':
                                                    return left / right;
                                                case '%':
                                                    return left % right;
                                            }
                                            return null;
                                        case 'if':
                                            var condition = simplify(expression['condition']);
                                            return condition ? simplify(expression['thenExpression']) :
                                                simplify(expression['elseExpression']);
                                        case 'pre':
                                            var operand = simplify(expression['operand']);
                                            if (shouldIgnore(operand))
                                                return operand;
                                            switch (expression['operator']) {
                                                case '+':
                                                    return operand;
                                                case '-':
                                                    return -operand;
                                                case '!':
                                                    return !operand;
                                                case '~':
                                                    return ~operand;
                                            }
                                            return null;
                                        case 'index':
                                            var indexTarget = simplifyEagerly(expression['expression']);
                                            var index = simplifyEagerly(expression['index']);
                                            if (indexTarget && isPrimitive(index))
                                                return indexTarget[index];
                                            return null;
                                        case 'select':
                                            var member = expression['member'];
                                            var selectContext = context;
                                            var selectTarget = simplify(expression['expression']);
                                            if (selectTarget instanceof StaticSymbol) {
                                                var members = selectTarget.members.concat(member);
                                                selectContext =
                                                    self.getStaticSymbol(selectTarget.filePath, selectTarget.name, members);
                                                var declarationValue = resolveReferenceValue(selectContext);
                                                if (declarationValue != null) {
                                                    return simplifyNested(selectContext, declarationValue);
                                                }
                                                else {
                                                    return selectContext;
                                                }
                                            }
                                            if (selectTarget && isPrimitive(member))
                                                return simplifyNested(selectContext, selectTarget[member]);
                                            return null;
                                        case 'reference':
                                            // Note: This only has to deal with variable references, as symbol references have
                                            // been converted into 'resolved'
                                            // in the StaticSymbolResolver.
                                            var name = expression['name'];
                                            var localValue = scope.resolve(name);
                                            if (localValue != BindingScope$1.missing) {
                                                return localValue;
                                            }
                                            break;
                                        case 'resolved':
                                            try {
                                                return simplify(expression.symbol);
                                            }
                                            catch (e) {
                                                // If an error is reported evaluating the symbol record the position of the
                                                // reference in the error so it can
                                                // be reported in the error message generated from the exception.
                                                if (isMetadataError(e) && expression.fileName != null &&
                                                    expression.line != null && expression.character != null) {
                                                    e.position = {
                                                        fileName: expression.fileName,
                                                        line: expression.line,
                                                        column: expression.character
                                                    };
                                                }
                                                throw e;
                                            }
                                        case 'class':
                                            return context;
                                        case 'function':
                                            return context;
                                        case 'new':
                                        case 'call':
                                            // Determine if the function is a built-in conversion
                                            staticSymbol = simplifyInContext(context, expression['expression'], depth + 1, /* references */ 0);
                                            if (staticSymbol instanceof StaticSymbol) {
                                                if (staticSymbol === self.injectionToken || staticSymbol === self.opaqueToken) {
                                                    // if somebody calls new InjectionToken, don't create an InjectionToken,
                                                    // but rather return the symbol to which the InjectionToken is assigned to.
                                                    // OpaqueToken is supported too as it is required by the language service to
                                                    // support v4 and prior versions of Angular.
                                                    return context;
                                                }
                                                var argExpressions = expression['arguments'] || [];
                                                var converter = self.conversionMap.get(staticSymbol);
                                                if (converter) {
                                                    var args = argExpressions.map(function (arg) { return simplifyNested(context, arg); })
                                                        .map(function (arg) { return shouldIgnore(arg) ? undefined : arg; });
                                                    return converter(context, args);
                                                }
                                                else {
                                                    // Determine if the function is one we can simplify.
                                                    var targetFunction = resolveReferenceValue(staticSymbol);
                                                    return simplifyCall(staticSymbol, targetFunction, argExpressions, expression['expression']);
                                                }
                                            }
                                            return IGNORE;
                                        case 'error':
                                            var message = expression.message;
                                            if (expression['line'] != null) {
                                                self.error({
                                                    message: message,
                                                    context: expression.context,
                                                    value: expression,
                                                    position: {
                                                        fileName: expression['fileName'],
                                                        line: expression['line'],
                                                        column: expression['character']
                                                    }
                                                }, context);
                                            }
                                            else {
                                                self.error({ message: message, context: expression.context }, context);
                                            }
                                            return IGNORE;
                                        case 'ignore':
                                            return expression;
                                    }
                                    return null;
                                }
                                return mapStringMap(expression, function (value, name) {
                                    if (REFERENCE_SET.has(name)) {
                                        if (name === USE_VALUE$1 && PROVIDE in expression) {
                                            // If this is a provider expression, check for special tokens that need the value
                                            // during analysis.
                                            var provide = simplify(expression.provide);
                                            if (provide === self.ROUTES || provide == self.ANALYZE_FOR_ENTRY_COMPONENTS) {
                                                return simplify(value);
                                            }
                                        }
                                        return simplifyLazily(value);
                                    }
                                    return simplify(value);
                                });
                            }
                            return IGNORE;
                        }
                        return simplify(value);
                    }
                    var result;
                    try {
                        result = simplifyInContext(context, value, 0, lazy ? 1 : 0);
                    }
                    catch (e) {
                        if (this.errorRecorder) {
                            this.reportError(e, context);
                        }
                        else {
                            throw formatMetadataError(e, context);
                        }
                    }
                    if (shouldIgnore(result)) {
                        return undefined;
                    }
                    return result;
                };
                StaticReflector.prototype.getTypeMetadata = function (type) {
                    var resolvedSymbol = this.symbolResolver.resolveSymbol(type);
                    return resolvedSymbol && resolvedSymbol.metadata ? resolvedSymbol.metadata :
                        { __symbolic: 'class' };
                };
                StaticReflector.prototype.reportError = function (error, context, path) {
                    if (this.errorRecorder) {
                        this.errorRecorder(formatMetadataError(error, context), (context && context.filePath) || path);
                    }
                    else {
                        throw error;
                    }
                };
                StaticReflector.prototype.error = function (_c, reportingContext) {
                    var message = _c.message, summary = _c.summary, advise = _c.advise, position = _c.position, context = _c.context, value = _c.value, symbol = _c.symbol, chain = _c.chain;
                    this.reportError(metadataError(message, summary, advise, position, symbol, context, chain), reportingContext);
                };
                return StaticReflector;
            }());
            var METADATA_ERROR = 'ngMetadataError';
            function metadataError(message, summary, advise, position, symbol, context, chain) {
                var error = syntaxError(message);
                error[METADATA_ERROR] = true;
                if (advise)
                    error.advise = advise;
                if (position)
                    error.position = position;
                if (summary)
                    error.summary = summary;
                if (context)
                    error.context = context;
                if (chain)
                    error.chain = chain;
                if (symbol)
                    error.symbol = symbol;
                return error;
            }
            function isMetadataError(error) {
                return !!error[METADATA_ERROR];
            }
            var REFERENCE_TO_NONEXPORTED_CLASS = 'Reference to non-exported class';
            var VARIABLE_NOT_INITIALIZED = 'Variable not initialized';
            var DESTRUCTURE_NOT_SUPPORTED = 'Destructuring not supported';
            var COULD_NOT_RESOLVE_TYPE = 'Could not resolve type';
            var FUNCTION_CALL_NOT_SUPPORTED = 'Function call not supported';
            var REFERENCE_TO_LOCAL_SYMBOL = 'Reference to a local symbol';
            var LAMBDA_NOT_SUPPORTED = 'Lambda not supported';
            function expandedMessage(message, context) {
                switch (message) {
                    case REFERENCE_TO_NONEXPORTED_CLASS:
                        if (context && context.className) {
                            return "References to a non-exported class are not supported in decorators but " + context.className + " was referenced.";
                        }
                        break;
                    case VARIABLE_NOT_INITIALIZED:
                        return 'Only initialized variables and constants can be referenced in decorators because the value of this variable is needed by the template compiler';
                    case DESTRUCTURE_NOT_SUPPORTED:
                        return 'Referencing an exported destructured variable or constant is not supported in decorators and this value is needed by the template compiler';
                    case COULD_NOT_RESOLVE_TYPE:
                        if (context && context.typeName) {
                            return "Could not resolve type " + context.typeName;
                        }
                        break;
                    case FUNCTION_CALL_NOT_SUPPORTED:
                        if (context && context.name) {
                            return "Function calls are not supported in decorators but '" + context.name + "' was called";
                        }
                        return 'Function calls are not supported in decorators';
                    case REFERENCE_TO_LOCAL_SYMBOL:
                        if (context && context.name) {
                            return "Reference to a local (non-exported) symbols are not supported in decorators but '" + context.name + "' was referenced";
                        }
                        break;
                    case LAMBDA_NOT_SUPPORTED:
                        return "Function expressions are not supported in decorators";
                }
                return message;
            }
            function messageAdvise(message, context) {
                switch (message) {
                    case REFERENCE_TO_NONEXPORTED_CLASS:
                        if (context && context.className) {
                            return "Consider exporting '" + context.className + "'";
                        }
                        break;
                    case DESTRUCTURE_NOT_SUPPORTED:
                        return 'Consider simplifying to avoid destructuring';
                    case REFERENCE_TO_LOCAL_SYMBOL:
                        if (context && context.name) {
                            return "Consider exporting '" + context.name + "'";
                        }
                        break;
                    case LAMBDA_NOT_SUPPORTED:
                        return "Consider changing the function expression into an exported function";
                }
                return undefined;
            }
            function errorSummary(error) {
                if (error.summary) {
                    return error.summary;
                }
                switch (error.message) {
                    case REFERENCE_TO_NONEXPORTED_CLASS:
                        if (error.context && error.context.className) {
                            return "references non-exported class " + error.context.className;
                        }
                        break;
                    case VARIABLE_NOT_INITIALIZED:
                        return 'is not initialized';
                    case DESTRUCTURE_NOT_SUPPORTED:
                        return 'is a destructured variable';
                    case COULD_NOT_RESOLVE_TYPE:
                        return 'could not be resolved';
                    case FUNCTION_CALL_NOT_SUPPORTED:
                        if (error.context && error.context.name) {
                            return "calls '" + error.context.name + "'";
                        }
                        return "calls a function";
                    case REFERENCE_TO_LOCAL_SYMBOL:
                        if (error.context && error.context.name) {
                            return "references local variable " + error.context.name;
                        }
                        return "references a local variable";
                }
                return 'contains the error';
            }
            function mapStringMap(input, transform) {
                if (!input)
                    return {};
                var result = {};
                Object.keys(input).forEach(function (key) {
                    var value = transform(input[key], key);
                    if (!shouldIgnore(value)) {
                        if (HIDDEN_KEY.test(key)) {
                            Object.defineProperty(result, key, { enumerable: false, configurable: true, value: value });
                        }
                        else {
                            result[key] = value;
                        }
                    }
                });
                return result;
            }
            function isPrimitive(o) {
                return o === null || (typeof o !== 'function' && typeof o !== 'object');
            }
            var BindingScope$1 = /** @class */ (function () {
                function BindingScope$1() {
                }
                BindingScope$1.build = function () {
                    var current = new Map();
                    return {
                        define: function (name, value) {
                            current.set(name, value);
                            return this;
                        },
                        done: function () {
                            return current.size > 0 ? new PopulatedScope(current) : BindingScope$1.empty;
                        }
                    };
                };
                return BindingScope$1;
            }());
            BindingScope$1.missing = {};
            BindingScope$1.empty = { resolve: function (name) { return BindingScope$1.missing; } };
            var PopulatedScope = /** @class */ (function (_super_1) {
                __extends(PopulatedScope, _super_1);
                function PopulatedScope(bindings) {
                    var _this = _super_1.call(this) || this;
                    _this.bindings = bindings;
                    return _this;
                }
                PopulatedScope.prototype.resolve = function (name) {
                    return this.bindings.has(name) ? this.bindings.get(name) : BindingScope$1.missing;
                };
                return PopulatedScope;
            }(BindingScope$1));
            function formatMetadataMessageChain(chain, advise) {
                var expanded = expandedMessage(chain.message, chain.context);
                var nesting = chain.symbol ? " in '" + chain.symbol.name + "'" : '';
                var message = "" + expanded + nesting;
                var position = chain.position;
                var next = chain.next ?
                    formatMetadataMessageChain(chain.next, advise) :
                    advise ? { message: advise } : undefined;
                return { message: message, position: position, next: next };
            }
            function formatMetadataError(e, context) {
                if (isMetadataError(e)) {
                    // Produce a formatted version of the and leaving enough information in the original error
                    // to recover the formatting information to eventually produce a diagnostic error message.
                    var position = e.position;
                    var chain = {
                        message: "Error during template compile of '" + context.name + "'",
                        position: position,
                        next: { message: e.message, next: e.chain, context: e.context, symbol: e.symbol }
                    };
                    var advise = e.advise || messageAdvise(e.message, e.context);
                    return formattedError(formatMetadataMessageChain(chain, advise));
                }
                return e;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var AotSummaryResolver = /** @class */ (function () {
                function AotSummaryResolver(host, staticSymbolCache) {
                    this.host = host;
                    this.staticSymbolCache = staticSymbolCache;
                    // Note: this will only contain StaticSymbols without members!
                    this.summaryCache = new Map();
                    this.loadedFilePaths = new Map();
                    // Note: this will only contain StaticSymbols without members!
                    this.importAs = new Map();
                    this.knownFileNameToModuleNames = new Map();
                }
                AotSummaryResolver.prototype.isLibraryFile = function (filePath) {
                    // Note: We need to strip the .ngfactory. file path,
                    // so this method also works for generated files
                    // (for which host.isSourceFile will always return false).
                    return !this.host.isSourceFile(stripGeneratedFileSuffix(filePath));
                };
                AotSummaryResolver.prototype.toSummaryFileName = function (filePath, referringSrcFileName) {
                    return this.host.toSummaryFileName(filePath, referringSrcFileName);
                };
                AotSummaryResolver.prototype.fromSummaryFileName = function (fileName, referringLibFileName) {
                    return this.host.fromSummaryFileName(fileName, referringLibFileName);
                };
                AotSummaryResolver.prototype.resolveSummary = function (staticSymbol) {
                    var rootSymbol = staticSymbol.members.length ?
                        this.staticSymbolCache.get(staticSymbol.filePath, staticSymbol.name) :
                        staticSymbol;
                    var summary = this.summaryCache.get(rootSymbol);
                    if (!summary) {
                        this._loadSummaryFile(staticSymbol.filePath);
                        summary = this.summaryCache.get(staticSymbol);
                    }
                    return (rootSymbol === staticSymbol && summary) || null;
                };
                AotSummaryResolver.prototype.getSymbolsOf = function (filePath) {
                    if (this._loadSummaryFile(filePath)) {
                        return Array.from(this.summaryCache.keys()).filter(function (symbol) { return symbol.filePath === filePath; });
                    }
                    return null;
                };
                AotSummaryResolver.prototype.getImportAs = function (staticSymbol) {
                    staticSymbol.assertNoMembers();
                    return this.importAs.get(staticSymbol);
                };
                /**
                 * Converts a file path to a module name that can be used as an `import`.
                 */
                AotSummaryResolver.prototype.getKnownModuleName = function (importedFilePath) {
                    return this.knownFileNameToModuleNames.get(importedFilePath) || null;
                };
                AotSummaryResolver.prototype.addSummary = function (summary) { this.summaryCache.set(summary.symbol, summary); };
                AotSummaryResolver.prototype._loadSummaryFile = function (filePath) {
                    var _this = this;
                    var hasSummary = this.loadedFilePaths.get(filePath);
                    if (hasSummary != null) {
                        return hasSummary;
                    }
                    var json = null;
                    if (this.isLibraryFile(filePath)) {
                        var summaryFilePath = summaryFileName(filePath);
                        try {
                            json = this.host.loadSummary(summaryFilePath);
                        }
                        catch (e) {
                            console.error("Error loading summary file " + summaryFilePath);
                            throw e;
                        }
                    }
                    hasSummary = json != null;
                    this.loadedFilePaths.set(filePath, hasSummary);
                    if (json) {
                        var _c = deserializeSummaries(this.staticSymbolCache, this, filePath, json), moduleName = _c.moduleName, summaries = _c.summaries, importAs = _c.importAs;
                        summaries.forEach(function (summary) { return _this.summaryCache.set(summary.symbol, summary); });
                        if (moduleName) {
                            this.knownFileNameToModuleNames.set(filePath, moduleName);
                        }
                        importAs.forEach(function (importAs) { _this.importAs.set(importAs.symbol, importAs.importAs); });
                    }
                    return hasSummary;
                };
                return AotSummaryResolver;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function createAotUrlResolver(host) {
                return {
                    resolve: function (basePath, url) {
                        var filePath = host.resourceNameToFileName(url, basePath);
                        if (!filePath) {
                            throw syntaxError("Couldn't resolve resource " + url + " from " + basePath);
                        }
                        return filePath;
                    }
                };
            }
            /**
             * Creates a new AotCompiler based on options and a host.
             */
            function createAotCompiler(compilerHost, options, errorCollector) {
                var translations = options.translations || '';
                var urlResolver = createAotUrlResolver(compilerHost);
                var symbolCache = new StaticSymbolCache();
                var summaryResolver = new AotSummaryResolver(compilerHost, symbolCache);
                var symbolResolver = new StaticSymbolResolver(compilerHost, symbolCache, summaryResolver);
                var staticReflector = new StaticReflector(summaryResolver, symbolResolver, [], [], errorCollector);
                var htmlParser;
                if (!!options.enableIvy) {
                    // Ivy handles i18n at the compiler level so we must use a regular parser
                    htmlParser = new HtmlParser();
                }
                else {
                    htmlParser = new I18NHtmlParser(new HtmlParser(), translations, options.i18nFormat, options.missingTranslation, console);
                }
                var config = new CompilerConfig({
                    defaultEncapsulation: ViewEncapsulation.Emulated,
                    useJit: false,
                    missingTranslation: options.missingTranslation,
                    preserveWhitespaces: options.preserveWhitespaces,
                    strictInjectionParameters: options.strictInjectionParameters,
                });
                var normalizer = new DirectiveNormalizer({ get: function (url) { return compilerHost.loadResource(url); } }, urlResolver, htmlParser, config);
                var expressionParser = new Parser$1(new Lexer());
                var elementSchemaRegistry = new DomElementSchemaRegistry();
                var tmplParser = new TemplateParser(config, staticReflector, expressionParser, elementSchemaRegistry, htmlParser, console, []);
                var resolver = new CompileMetadataResolver(config, htmlParser, new NgModuleResolver(staticReflector), new DirectiveResolver(staticReflector), new PipeResolver(staticReflector), summaryResolver, elementSchemaRegistry, normalizer, console, symbolCache, staticReflector, errorCollector);
                // TODO(vicb): do not pass options.i18nFormat here
                var viewCompiler = new ViewCompiler(staticReflector);
                var typeCheckCompiler = new TypeCheckCompiler(options, staticReflector);
                var compiler = new AotCompiler(config, options, compilerHost, staticReflector, resolver, tmplParser, new StyleCompiler(urlResolver), viewCompiler, typeCheckCompiler, new NgModuleCompiler(staticReflector), new InjectableCompiler(staticReflector, !!options.enableIvy), new TypeScriptEmitter(), summaryResolver, symbolResolver);
                return { compiler: compiler, reflector: staticReflector };
            }
            var SummaryResolver = /** @class */ (function () {
                function SummaryResolver() {
                }
                return SummaryResolver;
            }());
            var JitSummaryResolver = /** @class */ (function () {
                function JitSummaryResolver() {
                    this._summaries = new Map();
                }
                JitSummaryResolver.prototype.isLibraryFile = function () { return false; };
                JitSummaryResolver.prototype.toSummaryFileName = function (fileName) { return fileName; };
                JitSummaryResolver.prototype.fromSummaryFileName = function (fileName) { return fileName; };
                JitSummaryResolver.prototype.resolveSummary = function (reference) {
                    return this._summaries.get(reference) || null;
                };
                JitSummaryResolver.prototype.getSymbolsOf = function () { return []; };
                JitSummaryResolver.prototype.getImportAs = function (reference) { return reference; };
                JitSummaryResolver.prototype.getKnownModuleName = function (fileName) { return null; };
                JitSummaryResolver.prototype.addSummary = function (summary) { this._summaries.set(summary.symbol, summary); };
                return JitSummaryResolver;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function interpretStatements(statements, reflector) {
                var ctx = new _ExecutionContext(null, null, null, new Map());
                var visitor = new StatementInterpreter(reflector);
                visitor.visitAllStatements(statements, ctx);
                var result = {};
                ctx.exports.forEach(function (exportName) { result[exportName] = ctx.vars.get(exportName); });
                return result;
            }
            function _executeFunctionStatements(varNames, varValues, statements, ctx, visitor) {
                var childCtx = ctx.createChildWihtLocalVars();
                for (var i = 0; i < varNames.length; i++) {
                    childCtx.vars.set(varNames[i], varValues[i]);
                }
                var result = visitor.visitAllStatements(statements, childCtx);
                return result ? result.value : null;
            }
            var _ExecutionContext = /** @class */ (function () {
                function _ExecutionContext(parent, instance, className, vars) {
                    this.parent = parent;
                    this.instance = instance;
                    this.className = className;
                    this.vars = vars;
                    this.exports = [];
                }
                _ExecutionContext.prototype.createChildWihtLocalVars = function () {
                    return new _ExecutionContext(this, this.instance, this.className, new Map());
                };
                return _ExecutionContext;
            }());
            var ReturnValue = /** @class */ (function () {
                function ReturnValue(value) {
                    this.value = value;
                }
                return ReturnValue;
            }());
            function createDynamicClass(_classStmt, _ctx, _visitor) {
                var propertyDescriptors = {};
                _classStmt.getters.forEach(function (getter) {
                    // Note: use `function` instead of arrow function to capture `this`
                    propertyDescriptors[getter.name] = {
                        configurable: false,
                        get: function () {
                            var instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
                            return _executeFunctionStatements([], [], getter.body, instanceCtx, _visitor);
                        }
                    };
                });
                _classStmt.methods.forEach(function (method) {
                    var paramNames = method.params.map(function (param) { return param.name; });
                    // Note: use `function` instead of arrow function to capture `this`
                    propertyDescriptors[method.name] = {
                        writable: false,
                        configurable: false,
                        value: function () {
                            var args = [];
                            for (var _c = 0; _c < arguments.length; _c++) {
                                args[_c] = arguments[_c];
                            }
                            var instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
                            return _executeFunctionStatements(paramNames, args, method.body, instanceCtx, _visitor);
                        }
                    };
                });
                var ctorParamNames = _classStmt.constructorMethod.params.map(function (param) { return param.name; });
                // Note: use `function` instead of arrow function to capture `this`
                var ctor = function () {
                    var _this = this;
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    var instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
                    _classStmt.fields.forEach(function (field) { _this[field.name] = undefined; });
                    _executeFunctionStatements(ctorParamNames, args, _classStmt.constructorMethod.body, instanceCtx, _visitor);
                };
                var superClass = _classStmt.parent ? _classStmt.parent.visitExpression(_visitor, _ctx) : Object;
                ctor.prototype = Object.create(superClass.prototype, propertyDescriptors);
                return ctor;
            }
            var StatementInterpreter = /** @class */ (function () {
                function StatementInterpreter(reflector) {
                    this.reflector = reflector;
                }
                StatementInterpreter.prototype.debugAst = function (ast) { return debugOutputAstAsTypeScript(ast); };
                StatementInterpreter.prototype.visitDeclareVarStmt = function (stmt, ctx) {
                    var initialValue = stmt.value ? stmt.value.visitExpression(this, ctx) : undefined;
                    ctx.vars.set(stmt.name, initialValue);
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        ctx.exports.push(stmt.name);
                    }
                    return null;
                };
                StatementInterpreter.prototype.visitWriteVarExpr = function (expr, ctx) {
                    var value = expr.value.visitExpression(this, ctx);
                    var currCtx = ctx;
                    while (currCtx != null) {
                        if (currCtx.vars.has(expr.name)) {
                            currCtx.vars.set(expr.name, value);
                            return value;
                        }
                        currCtx = currCtx.parent;
                    }
                    throw new Error("Not declared variable " + expr.name);
                };
                StatementInterpreter.prototype.visitWrappedNodeExpr = function (ast, ctx) {
                    throw new Error('Cannot interpret a WrappedNodeExpr.');
                };
                StatementInterpreter.prototype.visitTypeofExpr = function (ast, ctx) {
                    throw new Error('Cannot interpret a TypeofExpr');
                };
                StatementInterpreter.prototype.visitReadVarExpr = function (ast, ctx) {
                    var varName = ast.name;
                    if (ast.builtin != null) {
                        switch (ast.builtin) {
                            case BuiltinVar.Super:
                                return Object.getPrototypeOf(ctx.instance);
                            case BuiltinVar.This:
                                return ctx.instance;
                            case BuiltinVar.CatchError:
                                varName = CATCH_ERROR_VAR$2;
                                break;
                            case BuiltinVar.CatchStack:
                                varName = CATCH_STACK_VAR$2;
                                break;
                            default:
                                throw new Error("Unknown builtin variable " + ast.builtin);
                        }
                    }
                    var currCtx = ctx;
                    while (currCtx != null) {
                        if (currCtx.vars.has(varName)) {
                            return currCtx.vars.get(varName);
                        }
                        currCtx = currCtx.parent;
                    }
                    throw new Error("Not declared variable " + varName);
                };
                StatementInterpreter.prototype.visitWriteKeyExpr = function (expr, ctx) {
                    var receiver = expr.receiver.visitExpression(this, ctx);
                    var index = expr.index.visitExpression(this, ctx);
                    var value = expr.value.visitExpression(this, ctx);
                    receiver[index] = value;
                    return value;
                };
                StatementInterpreter.prototype.visitWritePropExpr = function (expr, ctx) {
                    var receiver = expr.receiver.visitExpression(this, ctx);
                    var value = expr.value.visitExpression(this, ctx);
                    receiver[expr.name] = value;
                    return value;
                };
                StatementInterpreter.prototype.visitInvokeMethodExpr = function (expr, ctx) {
                    var receiver = expr.receiver.visitExpression(this, ctx);
                    var args = this.visitAllExpressions(expr.args, ctx);
                    var result;
                    if (expr.builtin != null) {
                        switch (expr.builtin) {
                            case BuiltinMethod.ConcatArray:
                                result = receiver.concat.apply(receiver, args);
                                break;
                            case BuiltinMethod.SubscribeObservable:
                                result = receiver.subscribe({ next: args[0] });
                                break;
                            case BuiltinMethod.Bind:
                                result = receiver.bind.apply(receiver, args);
                                break;
                            default:
                                throw new Error("Unknown builtin method " + expr.builtin);
                        }
                    }
                    else {
                        result = receiver[expr.name].apply(receiver, args);
                    }
                    return result;
                };
                StatementInterpreter.prototype.visitInvokeFunctionExpr = function (stmt, ctx) {
                    var args = this.visitAllExpressions(stmt.args, ctx);
                    var fnExpr = stmt.fn;
                    if (fnExpr instanceof ReadVarExpr && fnExpr.builtin === BuiltinVar.Super) {
                        ctx.instance.constructor.prototype.constructor.apply(ctx.instance, args);
                        return null;
                    }
                    else {
                        var fn_2 = stmt.fn.visitExpression(this, ctx);
                        return fn_2.apply(null, args);
                    }
                };
                StatementInterpreter.prototype.visitReturnStmt = function (stmt, ctx) {
                    return new ReturnValue(stmt.value.visitExpression(this, ctx));
                };
                StatementInterpreter.prototype.visitDeclareClassStmt = function (stmt, ctx) {
                    var clazz = createDynamicClass(stmt, ctx, this);
                    ctx.vars.set(stmt.name, clazz);
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        ctx.exports.push(stmt.name);
                    }
                    return null;
                };
                StatementInterpreter.prototype.visitExpressionStmt = function (stmt, ctx) {
                    return stmt.expr.visitExpression(this, ctx);
                };
                StatementInterpreter.prototype.visitIfStmt = function (stmt, ctx) {
                    var condition = stmt.condition.visitExpression(this, ctx);
                    if (condition) {
                        return this.visitAllStatements(stmt.trueCase, ctx);
                    }
                    else if (stmt.falseCase != null) {
                        return this.visitAllStatements(stmt.falseCase, ctx);
                    }
                    return null;
                };
                StatementInterpreter.prototype.visitTryCatchStmt = function (stmt, ctx) {
                    try {
                        return this.visitAllStatements(stmt.bodyStmts, ctx);
                    }
                    catch (e) {
                        var childCtx = ctx.createChildWihtLocalVars();
                        childCtx.vars.set(CATCH_ERROR_VAR$2, e);
                        childCtx.vars.set(CATCH_STACK_VAR$2, e.stack);
                        return this.visitAllStatements(stmt.catchStmts, childCtx);
                    }
                };
                StatementInterpreter.prototype.visitThrowStmt = function (stmt, ctx) {
                    throw stmt.error.visitExpression(this, ctx);
                };
                StatementInterpreter.prototype.visitCommentStmt = function (stmt, context) { return null; };
                StatementInterpreter.prototype.visitJSDocCommentStmt = function (stmt, context) { return null; };
                StatementInterpreter.prototype.visitInstantiateExpr = function (ast, ctx) {
                    var args = this.visitAllExpressions(ast.args, ctx);
                    var clazz = ast.classExpr.visitExpression(this, ctx);
                    return new (clazz.bind.apply(clazz, [void 0].concat(args)))();
                };
                StatementInterpreter.prototype.visitLiteralExpr = function (ast, ctx) { return ast.value; };
                StatementInterpreter.prototype.visitExternalExpr = function (ast, ctx) {
                    return this.reflector.resolveExternalReference(ast.value);
                };
                StatementInterpreter.prototype.visitConditionalExpr = function (ast, ctx) {
                    if (ast.condition.visitExpression(this, ctx)) {
                        return ast.trueCase.visitExpression(this, ctx);
                    }
                    else if (ast.falseCase != null) {
                        return ast.falseCase.visitExpression(this, ctx);
                    }
                    return null;
                };
                StatementInterpreter.prototype.visitNotExpr = function (ast, ctx) {
                    return !ast.condition.visitExpression(this, ctx);
                };
                StatementInterpreter.prototype.visitAssertNotNullExpr = function (ast, ctx) {
                    return ast.condition.visitExpression(this, ctx);
                };
                StatementInterpreter.prototype.visitCastExpr = function (ast, ctx) {
                    return ast.value.visitExpression(this, ctx);
                };
                StatementInterpreter.prototype.visitFunctionExpr = function (ast, ctx) {
                    var paramNames = ast.params.map(function (param) { return param.name; });
                    return _declareFn(paramNames, ast.statements, ctx, this);
                };
                StatementInterpreter.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
                    var paramNames = stmt.params.map(function (param) { return param.name; });
                    ctx.vars.set(stmt.name, _declareFn(paramNames, stmt.statements, ctx, this));
                    if (stmt.hasModifier(StmtModifier.Exported)) {
                        ctx.exports.push(stmt.name);
                    }
                    return null;
                };
                StatementInterpreter.prototype.visitBinaryOperatorExpr = function (ast, ctx) {
                    var _this = this;
                    var lhs = function () { return ast.lhs.visitExpression(_this, ctx); };
                    var rhs = function () { return ast.rhs.visitExpression(_this, ctx); };
                    switch (ast.operator) {
                        case BinaryOperator.Equals:
                            return lhs() == rhs();
                        case BinaryOperator.Identical:
                            return lhs() === rhs();
                        case BinaryOperator.NotEquals:
                            return lhs() != rhs();
                        case BinaryOperator.NotIdentical:
                            return lhs() !== rhs();
                        case BinaryOperator.And:
                            return lhs() && rhs();
                        case BinaryOperator.Or:
                            return lhs() || rhs();
                        case BinaryOperator.Plus:
                            return lhs() + rhs();
                        case BinaryOperator.Minus:
                            return lhs() - rhs();
                        case BinaryOperator.Divide:
                            return lhs() / rhs();
                        case BinaryOperator.Multiply:
                            return lhs() * rhs();
                        case BinaryOperator.Modulo:
                            return lhs() % rhs();
                        case BinaryOperator.Lower:
                            return lhs() < rhs();
                        case BinaryOperator.LowerEquals:
                            return lhs() <= rhs();
                        case BinaryOperator.Bigger:
                            return lhs() > rhs();
                        case BinaryOperator.BiggerEquals:
                            return lhs() >= rhs();
                        default:
                            throw new Error("Unknown operator " + ast.operator);
                    }
                };
                StatementInterpreter.prototype.visitReadPropExpr = function (ast, ctx) {
                    var result;
                    var receiver = ast.receiver.visitExpression(this, ctx);
                    result = receiver[ast.name];
                    return result;
                };
                StatementInterpreter.prototype.visitReadKeyExpr = function (ast, ctx) {
                    var receiver = ast.receiver.visitExpression(this, ctx);
                    var prop = ast.index.visitExpression(this, ctx);
                    return receiver[prop];
                };
                StatementInterpreter.prototype.visitLiteralArrayExpr = function (ast, ctx) {
                    return this.visitAllExpressions(ast.entries, ctx);
                };
                StatementInterpreter.prototype.visitLiteralMapExpr = function (ast, ctx) {
                    var _this = this;
                    var result = {};
                    ast.entries.forEach(function (entry) { return result[entry.key] = entry.value.visitExpression(_this, ctx); });
                    return result;
                };
                StatementInterpreter.prototype.visitCommaExpr = function (ast, context) {
                    var values = this.visitAllExpressions(ast.parts, context);
                    return values[values.length - 1];
                };
                StatementInterpreter.prototype.visitAllExpressions = function (expressions, ctx) {
                    var _this = this;
                    return expressions.map(function (expr) { return expr.visitExpression(_this, ctx); });
                };
                StatementInterpreter.prototype.visitAllStatements = function (statements, ctx) {
                    for (var i = 0; i < statements.length; i++) {
                        var stmt = statements[i];
                        var val = stmt.visitStatement(this, ctx);
                        if (val instanceof ReturnValue) {
                            return val;
                        }
                    }
                    return null;
                };
                return StatementInterpreter;
            }());
            function _declareFn(varNames, statements, ctx, visitor) {
                return function () {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    return _executeFunctionStatements(varNames, args, statements, ctx, visitor);
                };
            }
            var CATCH_ERROR_VAR$2 = 'error';
            var CATCH_STACK_VAR$2 = 'stack';
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * An internal module of the Angular compiler that begins with component types,
             * extracts templates, and eventually produces a compiled version of the component
             * ready for linking into an application.
             *
             * @security  When compiling templates at runtime, you must ensure that the entire template comes
             * from a trusted source. Attacker-controlled data introduced by a template could expose your
             * application to XSS risks.  For more detail, see the [Security Guide](http://g.co/ng/security).
             */
            var JitCompiler = /** @class */ (function () {
                function JitCompiler(_metadataResolver, _templateParser, _styleCompiler, _viewCompiler, _ngModuleCompiler, _summaryResolver, _reflector, _jitEvaluator, _compilerConfig, _console, getExtraNgModuleProviders) {
                    this._metadataResolver = _metadataResolver;
                    this._templateParser = _templateParser;
                    this._styleCompiler = _styleCompiler;
                    this._viewCompiler = _viewCompiler;
                    this._ngModuleCompiler = _ngModuleCompiler;
                    this._summaryResolver = _summaryResolver;
                    this._reflector = _reflector;
                    this._jitEvaluator = _jitEvaluator;
                    this._compilerConfig = _compilerConfig;
                    this._console = _console;
                    this.getExtraNgModuleProviders = getExtraNgModuleProviders;
                    this._compiledTemplateCache = new Map();
                    this._compiledHostTemplateCache = new Map();
                    this._compiledDirectiveWrapperCache = new Map();
                    this._compiledNgModuleCache = new Map();
                    this._sharedStylesheetCount = 0;
                    this._addedAotSummaries = new Set();
                }
                JitCompiler.prototype.compileModuleSync = function (moduleType) {
                    return SyncAsync.assertSync(this._compileModuleAndComponents(moduleType, true));
                };
                JitCompiler.prototype.compileModuleAsync = function (moduleType) {
                    return Promise.resolve(this._compileModuleAndComponents(moduleType, false));
                };
                JitCompiler.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
                    return SyncAsync.assertSync(this._compileModuleAndAllComponents(moduleType, true));
                };
                JitCompiler.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
                    return Promise.resolve(this._compileModuleAndAllComponents(moduleType, false));
                };
                JitCompiler.prototype.getComponentFactory = function (component) {
                    var summary = this._metadataResolver.getDirectiveSummary(component);
                    return summary.componentFactory;
                };
                JitCompiler.prototype.loadAotSummaries = function (summaries) {
                    this.clearCache();
                    this._addAotSummaries(summaries);
                };
                JitCompiler.prototype._addAotSummaries = function (fn) {
                    if (this._addedAotSummaries.has(fn)) {
                        return;
                    }
                    this._addedAotSummaries.add(fn);
                    var summaries = fn();
                    for (var i = 0; i < summaries.length; i++) {
                        var entry = summaries[i];
                        if (typeof entry === 'function') {
                            this._addAotSummaries(entry);
                        }
                        else {
                            var summary = entry;
                            this._summaryResolver.addSummary({ symbol: summary.type.reference, metadata: null, type: summary });
                        }
                    }
                };
                JitCompiler.prototype.hasAotSummary = function (ref) { return !!this._summaryResolver.resolveSummary(ref); };
                JitCompiler.prototype._filterJitIdentifiers = function (ids) {
                    var _this = this;
                    return ids.map(function (mod) { return mod.reference; }).filter(function (ref) { return !_this.hasAotSummary(ref); });
                };
                JitCompiler.prototype._compileModuleAndComponents = function (moduleType, isSync) {
                    var _this = this;
                    return SyncAsync.then(this._loadModules(moduleType, isSync), function () {
                        _this._compileComponents(moduleType, null);
                        return _this._compileModule(moduleType);
                    });
                };
                JitCompiler.prototype._compileModuleAndAllComponents = function (moduleType, isSync) {
                    var _this = this;
                    return SyncAsync.then(this._loadModules(moduleType, isSync), function () {
                        var componentFactories = [];
                        _this._compileComponents(moduleType, componentFactories);
                        return {
                            ngModuleFactory: _this._compileModule(moduleType),
                            componentFactories: componentFactories
                        };
                    });
                };
                JitCompiler.prototype._loadModules = function (mainModule, isSync) {
                    var _this = this;
                    var loading = [];
                    var mainNgModule = this._metadataResolver.getNgModuleMetadata(mainModule);
                    // Note: for runtime compilation, we want to transitively compile all modules,
                    // so we also need to load the declared directives / pipes for all nested modules.
                    this._filterJitIdentifiers(mainNgModule.transitiveModule.modules).forEach(function (nestedNgModule) {
                        // getNgModuleMetadata only returns null if the value passed in is not an NgModule
                        var moduleMeta = _this._metadataResolver.getNgModuleMetadata(nestedNgModule);
                        _this._filterJitIdentifiers(moduleMeta.declaredDirectives).forEach(function (ref) {
                            var promise = _this._metadataResolver.loadDirectiveMetadata(moduleMeta.type.reference, ref, isSync);
                            if (promise) {
                                loading.push(promise);
                            }
                        });
                        _this._filterJitIdentifiers(moduleMeta.declaredPipes)
                            .forEach(function (ref) { return _this._metadataResolver.getOrLoadPipeMetadata(ref); });
                    });
                    return SyncAsync.all(loading);
                };
                JitCompiler.prototype._compileModule = function (moduleType) {
                    var ngModuleFactory = this._compiledNgModuleCache.get(moduleType);
                    if (!ngModuleFactory) {
                        var moduleMeta = this._metadataResolver.getNgModuleMetadata(moduleType);
                        // Always provide a bound Compiler
                        var extraProviders = this.getExtraNgModuleProviders(moduleMeta.type.reference);
                        var outputCtx = createOutputContext();
                        var compileResult = this._ngModuleCompiler.compile(outputCtx, moduleMeta, extraProviders);
                        ngModuleFactory = this._interpretOrJit(ngModuleJitUrl(moduleMeta), outputCtx.statements)[compileResult.ngModuleFactoryVar];
                        this._compiledNgModuleCache.set(moduleMeta.type.reference, ngModuleFactory);
                    }
                    return ngModuleFactory;
                };
                /**
                 * @internal
                 */
                JitCompiler.prototype._compileComponents = function (mainModule, allComponentFactories) {
                    var _this = this;
                    var ngModule = this._metadataResolver.getNgModuleMetadata(mainModule);
                    var moduleByJitDirective = new Map();
                    var templates = new Set();
                    var transJitModules = this._filterJitIdentifiers(ngModule.transitiveModule.modules);
                    transJitModules.forEach(function (localMod) {
                        var localModuleMeta = _this._metadataResolver.getNgModuleMetadata(localMod);
                        _this._filterJitIdentifiers(localModuleMeta.declaredDirectives).forEach(function (dirRef) {
                            moduleByJitDirective.set(dirRef, localModuleMeta);
                            var dirMeta = _this._metadataResolver.getDirectiveMetadata(dirRef);
                            if (dirMeta.isComponent) {
                                templates.add(_this._createCompiledTemplate(dirMeta, localModuleMeta));
                                if (allComponentFactories) {
                                    var template = _this._createCompiledHostTemplate(dirMeta.type.reference, localModuleMeta);
                                    templates.add(template);
                                    allComponentFactories.push(dirMeta.componentFactory);
                                }
                            }
                        });
                    });
                    transJitModules.forEach(function (localMod) {
                        var localModuleMeta = _this._metadataResolver.getNgModuleMetadata(localMod);
                        _this._filterJitIdentifiers(localModuleMeta.declaredDirectives).forEach(function (dirRef) {
                            var dirMeta = _this._metadataResolver.getDirectiveMetadata(dirRef);
                            if (dirMeta.isComponent) {
                                dirMeta.entryComponents.forEach(function (entryComponentType) {
                                    var moduleMeta = moduleByJitDirective.get(entryComponentType.componentType);
                                    templates.add(_this._createCompiledHostTemplate(entryComponentType.componentType, moduleMeta));
                                });
                            }
                        });
                        localModuleMeta.entryComponents.forEach(function (entryComponentType) {
                            if (!_this.hasAotSummary(entryComponentType.componentType)) {
                                var moduleMeta = moduleByJitDirective.get(entryComponentType.componentType);
                                templates.add(_this._createCompiledHostTemplate(entryComponentType.componentType, moduleMeta));
                            }
                        });
                    });
                    templates.forEach(function (template) { return _this._compileTemplate(template); });
                };
                JitCompiler.prototype.clearCacheFor = function (type) {
                    this._compiledNgModuleCache.delete(type);
                    this._metadataResolver.clearCacheFor(type);
                    this._compiledHostTemplateCache.delete(type);
                    var compiledTemplate = this._compiledTemplateCache.get(type);
                    if (compiledTemplate) {
                        this._compiledTemplateCache.delete(type);
                    }
                };
                JitCompiler.prototype.clearCache = function () {
                    // Note: don't clear the _addedAotSummaries, as they don't change!
                    this._metadataResolver.clearCache();
                    this._compiledTemplateCache.clear();
                    this._compiledHostTemplateCache.clear();
                    this._compiledNgModuleCache.clear();
                };
                JitCompiler.prototype._createCompiledHostTemplate = function (compType, ngModule) {
                    if (!ngModule) {
                        throw new Error("Component " + stringify(compType) + " is not part of any NgModule or the module has not been imported into your module.");
                    }
                    var compiledTemplate = this._compiledHostTemplateCache.get(compType);
                    if (!compiledTemplate) {
                        var compMeta = this._metadataResolver.getDirectiveMetadata(compType);
                        assertComponent(compMeta);
                        var hostMeta = this._metadataResolver.getHostComponentMetadata(compMeta, compMeta.componentFactory.viewDefFactory);
                        compiledTemplate =
                            new CompiledTemplate(true, compMeta.type, hostMeta, ngModule, [compMeta.type]);
                        this._compiledHostTemplateCache.set(compType, compiledTemplate);
                    }
                    return compiledTemplate;
                };
                JitCompiler.prototype._createCompiledTemplate = function (compMeta, ngModule) {
                    var compiledTemplate = this._compiledTemplateCache.get(compMeta.type.reference);
                    if (!compiledTemplate) {
                        assertComponent(compMeta);
                        compiledTemplate = new CompiledTemplate(false, compMeta.type, compMeta, ngModule, ngModule.transitiveModule.directives);
                        this._compiledTemplateCache.set(compMeta.type.reference, compiledTemplate);
                    }
                    return compiledTemplate;
                };
                JitCompiler.prototype._compileTemplate = function (template) {
                    var _this = this;
                    if (template.isCompiled) {
                        return;
                    }
                    var compMeta = template.compMeta;
                    var externalStylesheetsByModuleUrl = new Map();
                    var outputContext = createOutputContext();
                    var componentStylesheet = this._styleCompiler.compileComponent(outputContext, compMeta);
                    compMeta.template.externalStylesheets.forEach(function (stylesheetMeta) {
                        var compiledStylesheet = _this._styleCompiler.compileStyles(createOutputContext(), compMeta, stylesheetMeta);
                        externalStylesheetsByModuleUrl.set(stylesheetMeta.moduleUrl, compiledStylesheet);
                    });
                    this._resolveStylesCompileResult(componentStylesheet, externalStylesheetsByModuleUrl);
                    var pipes = template.ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
                    var _c = this._parseTemplate(compMeta, template.ngModule, template.directives), parsedTemplate = _c.template, usedPipes = _c.pipes;
                    var compileResult = this._viewCompiler.compileComponent(outputContext, compMeta, parsedTemplate, variable(componentStylesheet.stylesVar), usedPipes);
                    var evalResult = this._interpretOrJit(templateJitUrl(template.ngModule.type, template.compMeta), outputContext.statements);
                    var viewClass = evalResult[compileResult.viewClassVar];
                    var rendererType = evalResult[compileResult.rendererTypeVar];
                    template.compiled(viewClass, rendererType);
                };
                JitCompiler.prototype._parseTemplate = function (compMeta, ngModule, directiveIdentifiers) {
                    var _this = this;
                    // Note: ! is ok here as components always have a template.
                    var preserveWhitespaces = compMeta.template.preserveWhitespaces;
                    var directives = directiveIdentifiers.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
                    var pipes = ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
                    return this._templateParser.parse(compMeta, compMeta.template.htmlAst, directives, pipes, ngModule.schemas, templateSourceUrl(ngModule.type, compMeta, compMeta.template), preserveWhitespaces);
                };
                JitCompiler.prototype._resolveStylesCompileResult = function (result, externalStylesheetsByModuleUrl) {
                    var _this = this;
                    result.dependencies.forEach(function (dep, i) {
                        var nestedCompileResult = externalStylesheetsByModuleUrl.get(dep.moduleUrl);
                        var nestedStylesArr = _this._resolveAndEvalStylesCompileResult(nestedCompileResult, externalStylesheetsByModuleUrl);
                        dep.setValue(nestedStylesArr);
                    });
                };
                JitCompiler.prototype._resolveAndEvalStylesCompileResult = function (result, externalStylesheetsByModuleUrl) {
                    this._resolveStylesCompileResult(result, externalStylesheetsByModuleUrl);
                    return this._interpretOrJit(sharedStylesheetJitUrl(result.meta, this._sharedStylesheetCount++), result.outputCtx.statements)[result.stylesVar];
                };
                JitCompiler.prototype._interpretOrJit = function (sourceUrl, statements) {
                    if (!this._compilerConfig.useJit) {
                        return interpretStatements(statements, this._reflector);
                    }
                    else {
                        return this._jitEvaluator.evaluateStatements(sourceUrl, statements, this._reflector, this._compilerConfig.jitDevMode);
                    }
                };
                return JitCompiler;
            }());
            var CompiledTemplate = /** @class */ (function () {
                function CompiledTemplate(isHost, compType, compMeta, ngModule, directives) {
                    this.isHost = isHost;
                    this.compType = compType;
                    this.compMeta = compMeta;
                    this.ngModule = ngModule;
                    this.directives = directives;
                    this._viewClass = null;
                    this.isCompiled = false;
                }
                CompiledTemplate.prototype.compiled = function (viewClass, rendererType) {
                    this._viewClass = viewClass;
                    this.compMeta.componentViewType.setDelegate(viewClass);
                    for (var prop in rendererType) {
                        this.compMeta.rendererType[prop] = rendererType[prop];
                    }
                    this.isCompiled = true;
                };
                return CompiledTemplate;
            }());
            function assertComponent(meta) {
                if (!meta.isComponent) {
                    throw new Error("Could not compile '" + identifierName(meta.type) + "' because it is not a component.");
                }
            }
            function createOutputContext() {
                var importExpr$1 = function (symbol) { return importExpr({ name: identifierName(symbol), moduleName: null, runtime: symbol }); };
                return { statements: [], genFilePath: '', importExpr: importExpr$1, constantPool: new ConstantPool() };
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Provides access to reflection data about symbols that the compiler needs.
             */
            var CompileReflector = /** @class */ (function () {
                function CompileReflector() {
                }
                return CompileReflector;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Create a {@link UrlResolver} with no package prefix.
             */
            function createUrlResolverWithoutPackagePrefix() {
                return new UrlResolver();
            }
            function createOfflineCompileUrlResolver() {
                return new UrlResolver('.');
            }
            var UrlResolver = /** @class */ (function () {
                function UrlResolverImpl(_packagePrefix) {
                    if (_packagePrefix === void 0) { _packagePrefix = null; }
                    this._packagePrefix = _packagePrefix;
                }
                /**
                 * Resolves the `url` given the `baseUrl`:
                 * - when the `url` is null, the `baseUrl` is returned,
                 * - if `url` is relative ('path/to/here', './path/to/here'), the resolved url is a combination of
                 * `baseUrl` and `url`,
                 * - if `url` is absolute (it has a scheme: 'http://', 'https://' or start with '/'), the `url` is
                 * returned as is (ignoring the `baseUrl`)
                 */
                UrlResolverImpl.prototype.resolve = function (baseUrl, url) {
                    var resolvedUrl = url;
                    if (baseUrl != null && baseUrl.length > 0) {
                        resolvedUrl = _resolveUrl(baseUrl, resolvedUrl);
                    }
                    var resolvedParts = _split(resolvedUrl);
                    var prefix = this._packagePrefix;
                    if (prefix != null && resolvedParts != null &&
                        resolvedParts[_ComponentIndex.Scheme] == 'package') {
                        var path = resolvedParts[_ComponentIndex.Path];
                        prefix = prefix.replace(/\/+$/, '');
                        path = path.replace(/^\/+/, '');
                        return prefix + "/" + path;
                    }
                    return resolvedUrl;
                };
                return UrlResolverImpl;
            }());
            /**
             * Extract the scheme of a URL.
             */
            function getUrlScheme(url) {
                var match = _split(url);
                return (match && match[_ComponentIndex.Scheme]) || '';
            }
            // The code below is adapted from Traceur:
            // https://github.com/google/traceur-compiler/blob/9511c1dafa972bf0de1202a8a863bad02f0f95a8/src/runtime/url.js
            /**
             * Builds a URI string from already-encoded parts.
             *
             * No encoding is performed.  Any component may be omitted as either null or
             * undefined.
             *
             * @param opt_scheme The scheme such as 'http'.
             * @param opt_userInfo The user name before the '@'.
             * @param opt_domain The domain such as 'www.google.com', already
             *     URI-encoded.
             * @param opt_port The port number.
             * @param opt_path The path, already URI-encoded.  If it is not
             *     empty, it must begin with a slash.
             * @param opt_queryData The URI-encoded query data.
             * @param opt_fragment The URI-encoded fragment identifier.
             * @return The fully combined URI.
             */
            function _buildFromEncodedParts(opt_scheme, opt_userInfo, opt_domain, opt_port, opt_path, opt_queryData, opt_fragment) {
                var out = [];
                if (opt_scheme != null) {
                    out.push(opt_scheme + ':');
                }
                if (opt_domain != null) {
                    out.push('//');
                    if (opt_userInfo != null) {
                        out.push(opt_userInfo + '@');
                    }
                    out.push(opt_domain);
                    if (opt_port != null) {
                        out.push(':' + opt_port);
                    }
                }
                if (opt_path != null) {
                    out.push(opt_path);
                }
                if (opt_queryData != null) {
                    out.push('?' + opt_queryData);
                }
                if (opt_fragment != null) {
                    out.push('#' + opt_fragment);
                }
                return out.join('');
            }
            /**
             * A regular expression for breaking a URI into its component parts.
             *
             * {@link http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234} says
             * As the "first-match-wins" algorithm is identical to the "greedy"
             * disambiguation method used by POSIX regular expressions, it is natural and
             * commonplace to use a regular expression for parsing the potential five
             * components of a URI reference.
             *
             * The following line is the regular expression for breaking-down a
             * well-formed URI reference into its components.
             *
             * <pre>
             * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
             *  12            3  4          5       6  7        8 9
             * </pre>
             *
             * The numbers in the second line above are only to assist readability; they
             * indicate the reference points for each subexpression (i.e., each paired
             * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
             * For example, matching the above expression to
             * <pre>
             *     http://www.ics.uci.edu/pub/ietf/uri/#Related
             * </pre>
             * results in the following subexpression matches:
             * <pre>
             *    $1 = http:
             *    $2 = http
             *    $3 = //www.ics.uci.edu
             *    $4 = www.ics.uci.edu
             *    $5 = /pub/ietf/uri/
             *    $6 = <undefined>
             *    $7 = <undefined>
             *    $8 = #Related
             *    $9 = Related
             * </pre>
             * where <undefined> indicates that the component is not present, as is the
             * case for the query component in the above example. Therefore, we can
             * determine the value of the five components as
             * <pre>
             *    scheme    = $2
             *    authority = $4
             *    path      = $5
             *    query     = $7
             *    fragment  = $9
             * </pre>
             *
             * The regular expression has been modified slightly to expose the
             * userInfo, domain, and port separately from the authority.
             * The modified version yields
             * <pre>
             *    $1 = http              scheme
             *    $2 = <undefined>       userInfo -\
             *    $3 = www.ics.uci.edu   domain     | authority
             *    $4 = <undefined>       port     -/
             *    $5 = /pub/ietf/uri/    path
             *    $6 = <undefined>       query without ?
             *    $7 = Related           fragment without #
             * </pre>
             * @internal
             */
            var _splitRe = new RegExp('^' +
                '(?:' +
                '([^:/?#.]+)' + // scheme - ignore special characters
                // used by other URL parts such as :,
                // ?, /, #, and .
                ':)?' +
                '(?://' +
                '(?:([^/?#]*)@)?' + // userInfo
                '([\\w\\d\\-\\u0100-\\uffff.%]*)' + // domain - restrict to letters,
                // digits, dashes, dots, percent
                // escapes, and unicode characters.
                '(?::([0-9]+))?' + // port
                ')?' +
                '([^?#]+)?' + // path
                '(?:\\?([^#]*))?' + // query
                '(?:#(.*))?' + // fragment
                '$');
            /**
             * The index of each URI component in the return value of goog.uri.utils.split.
             * @enum {number}
             */
            var _ComponentIndex;
            (function (_ComponentIndex) {
                _ComponentIndex[_ComponentIndex["Scheme"] = 1] = "Scheme";
                _ComponentIndex[_ComponentIndex["UserInfo"] = 2] = "UserInfo";
                _ComponentIndex[_ComponentIndex["Domain"] = 3] = "Domain";
                _ComponentIndex[_ComponentIndex["Port"] = 4] = "Port";
                _ComponentIndex[_ComponentIndex["Path"] = 5] = "Path";
                _ComponentIndex[_ComponentIndex["QueryData"] = 6] = "QueryData";
                _ComponentIndex[_ComponentIndex["Fragment"] = 7] = "Fragment";
            })(_ComponentIndex || (_ComponentIndex = {}));
            /**
             * Splits a URI into its component parts.
             *
             * Each component can be accessed via the component indices; for example:
             * <pre>
             * goog.uri.utils.split(someStr)[goog.uri.utils.CompontentIndex.QUERY_DATA];
             * </pre>
             *
             * @param uri The URI string to examine.
             * @return Each component still URI-encoded.
             *     Each component that is present will contain the encoded value, whereas
             *     components that are not present will be undefined or empty, depending
             *     on the browser's regular expression implementation.  Never null, since
             *     arbitrary strings may still look like path names.
             */
            function _split(uri) {
                return uri.match(_splitRe);
            }
            /**
              * Removes dot segments in given path component, as described in
              * RFC 3986, section 5.2.4.
              *
              * @param path A non-empty path component.
              * @return Path component with removed dot segments.
              */
            function _removeDotSegments(path) {
                if (path == '/')
                    return '/';
                var leadingSlash = path[0] == '/' ? '/' : '';
                var trailingSlash = path[path.length - 1] === '/' ? '/' : '';
                var segments = path.split('/');
                var out = [];
                var up = 0;
                for (var pos = 0; pos < segments.length; pos++) {
                    var segment = segments[pos];
                    switch (segment) {
                        case '':
                        case '.':
                            break;
                        case '..':
                            if (out.length > 0) {
                                out.pop();
                            }
                            else {
                                up++;
                            }
                            break;
                        default:
                            out.push(segment);
                    }
                }
                if (leadingSlash == '') {
                    while (up-- > 0) {
                        out.unshift('..');
                    }
                    if (out.length === 0)
                        out.push('.');
                }
                return leadingSlash + out.join('/') + trailingSlash;
            }
            /**
             * Takes an array of the parts from split and canonicalizes the path part
             * and then joins all the parts.
             */
            function _joinAndCanonicalizePath(parts) {
                var path = parts[_ComponentIndex.Path];
                path = path == null ? '' : _removeDotSegments(path);
                parts[_ComponentIndex.Path] = path;
                return _buildFromEncodedParts(parts[_ComponentIndex.Scheme], parts[_ComponentIndex.UserInfo], parts[_ComponentIndex.Domain], parts[_ComponentIndex.Port], path, parts[_ComponentIndex.QueryData], parts[_ComponentIndex.Fragment]);
            }
            /**
             * Resolves a URL.
             * @param base The URL acting as the base URL.
             * @param to The URL to resolve.
             */
            function _resolveUrl(base, url) {
                var parts = _split(encodeURI(url));
                var baseParts = _split(base);
                if (parts[_ComponentIndex.Scheme] != null) {
                    return _joinAndCanonicalizePath(parts);
                }
                else {
                    parts[_ComponentIndex.Scheme] = baseParts[_ComponentIndex.Scheme];
                }
                for (var i = _ComponentIndex.Scheme; i <= _ComponentIndex.Port; i++) {
                    if (parts[i] == null) {
                        parts[i] = baseParts[i];
                    }
                }
                if (parts[_ComponentIndex.Path][0] == '/') {
                    return _joinAndCanonicalizePath(parts);
                }
                var path = baseParts[_ComponentIndex.Path];
                if (path == null)
                    path = '/';
                var index = path.lastIndexOf('/');
                path = path.substring(0, index + 1) + parts[_ComponentIndex.Path];
                parts[_ComponentIndex.Path] = path;
                return _joinAndCanonicalizePath(parts);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var Extractor = /** @class */ (function () {
                function Extractor(host, staticSymbolResolver, messageBundle, metadataResolver) {
                    this.host = host;
                    this.staticSymbolResolver = staticSymbolResolver;
                    this.messageBundle = messageBundle;
                    this.metadataResolver = metadataResolver;
                }
                Extractor.prototype.extract = function (rootFiles) {
                    var _this = this;
                    var _c = analyzeAndValidateNgModules(rootFiles, this.host, this.staticSymbolResolver, this.metadataResolver), files = _c.files, ngModules = _c.ngModules;
                    return Promise
                        .all(ngModules.map(function (ngModule) { return _this.metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false); }))
                        .then(function () {
                        var errors = [];
                        files.forEach(function (file) {
                            var compMetas = [];
                            file.directives.forEach(function (directiveType) {
                                var dirMeta = _this.metadataResolver.getDirectiveMetadata(directiveType);
                                if (dirMeta && dirMeta.isComponent) {
                                    compMetas.push(dirMeta);
                                }
                            });
                            compMetas.forEach(function (compMeta) {
                                var html = compMeta.template.template;
                                // Template URL points to either an HTML or TS file depending on
                                // whether the file is used with `templateUrl:` or `template:`,
                                // respectively.
                                var templateUrl = compMeta.template.templateUrl;
                                var interpolationConfig = InterpolationConfig.fromArray(compMeta.template.interpolation);
                                errors.push.apply(errors, _this.messageBundle.updateFromTemplate(html, templateUrl, interpolationConfig));
                            });
                        });
                        if (errors.length) {
                            throw new Error(errors.map(function (e) { return e.toString(); }).join('\n'));
                        }
                        return _this.messageBundle;
                    });
                };
                Extractor.create = function (host, locale) {
                    var htmlParser = new HtmlParser();
                    var urlResolver = createAotUrlResolver(host);
                    var symbolCache = new StaticSymbolCache();
                    var summaryResolver = new AotSummaryResolver(host, symbolCache);
                    var staticSymbolResolver = new StaticSymbolResolver(host, symbolCache, summaryResolver);
                    var staticReflector = new StaticReflector(summaryResolver, staticSymbolResolver);
                    var config = new CompilerConfig({ defaultEncapsulation: ViewEncapsulation.Emulated, useJit: false });
                    var normalizer = new DirectiveNormalizer({ get: function (url) { return host.loadResource(url); } }, urlResolver, htmlParser, config);
                    var elementSchemaRegistry = new DomElementSchemaRegistry();
                    var resolver = new CompileMetadataResolver(config, htmlParser, new NgModuleResolver(staticReflector), new DirectiveResolver(staticReflector), new PipeResolver(staticReflector), summaryResolver, elementSchemaRegistry, normalizer, console, symbolCache, staticReflector);
                    // TODO(vicb): implicit tags & attributes
                    var messageBundle = new MessageBundle(htmlParser, [], {}, locale);
                    var extractor = new Extractor(host, staticSymbolResolver, messageBundle, resolver);
                    return { extractor: extractor, staticReflector: staticReflector };
                };
                return Extractor;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Processes `Target`s with a given set of directives and performs a binding operation, which
             * returns an object similar to TypeScript's `ts.TypeChecker` that contains knowledge about the
             * target.
             */
            var R3TargetBinder = /** @class */ (function () {
                function R3TargetBinder(directiveMatcher) {
                    this.directiveMatcher = directiveMatcher;
                }
                /**
                 * Perform a binding operation on the given `Target` and return a `BoundTarget` which contains
                 * metadata about the types referenced in the template.
                 */
                R3TargetBinder.prototype.bind = function (target) {
                    if (!target.template) {
                        // TODO(alxhub): handle targets which contain things like HostBindings, etc.
                        throw new Error('Binding without a template not yet supported');
                    }
                    // First, parse the template into a `Scope` structure. This operation captures the syntactic
                    // scopes in the template and makes them available for later use.
                    var scope = Scope.apply(target.template);
                    // Next, perform directive matching on the template using the `DirectiveBinder`. This returns:
                    //   - directives: Map of nodes (elements & ng-templates) to the directives on them.
                    //   - bindings: Map of inputs, outputs, and attributes to the directive/element that claims
                    //     them. TODO(alxhub): handle multiple directives claiming an input/output/etc.
                    //   - references: Map of #references to their targets.
                    var _c = DirectiveBinder.apply(target.template, this.directiveMatcher), directives = _c.directives, bindings = _c.bindings, references = _c.references;
                    // Finally, run the TemplateBinder to bind references, variables, and other entities within the
                    // template. This extracts all the metadata that doesn't depend on directive matching.
                    var _d = TemplateBinder.apply(target.template, scope), expressions = _d.expressions, symbols = _d.symbols, nestingLevel = _d.nestingLevel, usedPipes = _d.usedPipes;
                    return new R3BoundTarget(target, directives, bindings, references, expressions, symbols, nestingLevel, usedPipes);
                };
                return R3TargetBinder;
            }());
            /**
             * Represents a binding scope within a template.
             *
             * Any variables, references, or other named entities declared within the template will
             * be captured and available by name in `namedEntities`. Additionally, child templates will
             * be analyzed and have their child `Scope`s available in `childScopes`.
             */
            var Scope = /** @class */ (function () {
                function Scope(parentScope) {
                    this.parentScope = parentScope;
                    /**
                     * Named members of the `Scope`, such as `Reference`s or `Variable`s.
                     */
                    this.namedEntities = new Map();
                    /**
                     * Child `Scope`s for immediately nested `Template`s.
                     */
                    this.childScopes = new Map();
                }
                /**
                 * Process a template (either as a `Template` sub-template with variables, or a plain array of
                 * template `Node`s) and construct its `Scope`.
                 */
                Scope.apply = function (template) {
                    var scope = new Scope();
                    scope.ingest(template);
                    return scope;
                };
                /**
                 * Internal method to process the template and populate the `Scope`.
                 */
                Scope.prototype.ingest = function (template) {
                    var _this = this;
                    if (template instanceof Template) {
                        // Variables on an <ng-template> are defined in the inner scope.
                        template.variables.forEach(function (node) { return _this.visitVariable(node); });
                        // Process the nodes of the template.
                        template.children.forEach(function (node) { return node.visit(_this); });
                    }
                    else {
                        // No overarching `Template` instance, so process the nodes directly.
                        template.forEach(function (node) { return node.visit(_this); });
                    }
                };
                Scope.prototype.visitElement = function (element) {
                    var _this = this;
                    // `Element`s in the template may have `Reference`s which are captured in the scope.
                    element.references.forEach(function (node) { return _this.visitReference(node); });
                    // Recurse into the `Element`'s children.
                    element.children.forEach(function (node) { return node.visit(_this); });
                };
                Scope.prototype.visitTemplate = function (template) {
                    var _this = this;
                    // References on a <ng-template> are defined in the outer scope, so capture them before
                    // processing the template's child scope.
                    template.references.forEach(function (node) { return _this.visitReference(node); });
                    // Next, create an inner scope and process the template within it.
                    var scope = new Scope(this);
                    scope.ingest(template);
                    this.childScopes.set(template, scope);
                };
                Scope.prototype.visitVariable = function (variable) {
                    // Declare the variable if it's not already.
                    this.maybeDeclare(variable);
                };
                Scope.prototype.visitReference = function (reference) {
                    // Declare the variable if it's not already.
                    this.maybeDeclare(reference);
                };
                // Unused visitors.
                Scope.prototype.visitContent = function (content) { };
                Scope.prototype.visitBoundAttribute = function (attr) { };
                Scope.prototype.visitBoundEvent = function (event) { };
                Scope.prototype.visitBoundText = function (text) { };
                Scope.prototype.visitText = function (text) { };
                Scope.prototype.visitTextAttribute = function (attr) { };
                Scope.prototype.visitIcu = function (icu) { };
                Scope.prototype.maybeDeclare = function (thing) {
                    // Declare something with a name, as long as that name isn't taken.
                    if (!this.namedEntities.has(thing.name)) {
                        this.namedEntities.set(thing.name, thing);
                    }
                };
                /**
                 * Look up a variable within this `Scope`.
                 *
                 * This can recurse into a parent `Scope` if it's available.
                 */
                Scope.prototype.lookup = function (name) {
                    if (this.namedEntities.has(name)) {
                        // Found in the local scope.
                        return this.namedEntities.get(name);
                    }
                    else if (this.parentScope !== undefined) {
                        // Not in the local scope, but there's a parent scope so check there.
                        return this.parentScope.lookup(name);
                    }
                    else {
                        // At the top level and it wasn't found.
                        return null;
                    }
                };
                /**
                 * Get the child scope for a `Template`.
                 *
                 * This should always be defined.
                 */
                Scope.prototype.getChildScope = function (template) {
                    var res = this.childScopes.get(template);
                    if (res === undefined) {
                        throw new Error("Assertion error: child scope for " + template + " not found");
                    }
                    return res;
                };
                return Scope;
            }());
            /**
             * Processes a template and matches directives on nodes (elements and templates).
             *
             * Usually used via the static `apply()` method.
             */
            var DirectiveBinder = /** @class */ (function () {
                function DirectiveBinder(matcher, directives, bindings, references) {
                    this.matcher = matcher;
                    this.directives = directives;
                    this.bindings = bindings;
                    this.references = references;
                }
                /**
                 * Process a template (list of `Node`s) and perform directive matching against each node.
                 *
                 * @param template the list of template `Node`s to match (recursively).
                 * @param selectorMatcher a `SelectorMatcher` containing the directives that are in scope for
                 * this template.
                 * @returns three maps which contain information about directives in the template: the
                 * `directives` map which lists directives matched on each node, the `bindings` map which
                 * indicates which directives claimed which bindings (inputs, outputs, etc), and the `references`
                 * map which resolves #references (`Reference`s) within the template to the named directive or
                 * template node.
                 */
                DirectiveBinder.apply = function (template, selectorMatcher) {
                    var directives = new Map();
                    var bindings = new Map();
                    var references = new Map();
                    var matcher = new DirectiveBinder(selectorMatcher, directives, bindings, references);
                    matcher.ingest(template);
                    return { directives: directives, bindings: bindings, references: references };
                };
                DirectiveBinder.prototype.ingest = function (template) {
                    var _this = this;
                    template.forEach(function (node) { return node.visit(_this); });
                };
                DirectiveBinder.prototype.visitElement = function (element) { this.visitElementOrTemplate(element.name, element); };
                DirectiveBinder.prototype.visitTemplate = function (template) { this.visitElementOrTemplate('ng-template', template); };
                DirectiveBinder.prototype.visitElementOrTemplate = function (tag, node) {
                    var _this = this;
                    // First, determine the HTML shape of the node for the purpose of directive matching.
                    // Do this by building up a `CssSelector` for the node.
                    var cssSelector = new CssSelector();
                    cssSelector.setElement(tag);
                    // Add attributes to the CSS selector.
                    var attrs = getAttrsForDirectiveMatching(node);
                    Object.getOwnPropertyNames(attrs).forEach(function (name) {
                        var value = attrs[name];
                        cssSelector.addAttribute(name, value);
                        // Treat the 'class' attribute specially.
                        if (name.toLowerCase() === 'class') {
                            var classes = value.trim().split(/\s+/g);
                            classes.forEach(function (className) { return cssSelector.addClassName(className); });
                        }
                    });
                    // Next, use the `SelectorMatcher` to get the list of directives on the node.
                    var directives = [];
                    this.matcher.match(cssSelector, function (_, directive) { return directives.push(directive); });
                    if (directives.length > 0) {
                        this.directives.set(node, directives);
                    }
                    // Resolve any references that are created on this node.
                    node.references.forEach(function (ref) {
                        var dirTarget = null;
                        // If the reference expression is empty, then it matches the "primary" directive on the node
                        // (if there is one). Otherwise it matches the host node itself (either an element or
                        // <ng-template> node).
                        if (ref.value.trim() === '') {
                            // This could be a reference to a component if there is one.
                            dirTarget = directives.find(function (dir) { return dir.isComponent; }) || null;
                        }
                        else {
                            // This is a reference to a directive exported via exportAs. One should exist.
                            dirTarget =
                                directives.find(function (dir) { return dir.exportAs !== null && dir.exportAs.some(function (value) { return value === ref.value; }); }) ||
                                    null;
                            // Check if a matching directive was found, and error if it wasn't.
                            if (dirTarget === null) {
                                // TODO(alxhub): Return an error value here that can be used for template validation.
                                throw new Error("Assertion error: failed to find directive with exportAs: " + ref.value);
                            }
                        }
                        if (dirTarget !== null) {
                            // This reference points to a directive.
                            _this.references.set(ref, { directive: dirTarget, node: node });
                        }
                        else {
                            // This reference points to the node itself.
                            _this.references.set(ref, node);
                        }
                    });
                    // Associate attributes/bindings on the node with directives or with the node itself.
                    var processAttribute = function (attribute) {
                        var dir = directives.find(function (dir) { return dir.inputs.hasOwnProperty(attribute.name); });
                        if (dir !== undefined) {
                            _this.bindings.set(attribute, dir);
                        }
                        else {
                            _this.bindings.set(attribute, node);
                        }
                    };
                    node.attributes.forEach(processAttribute);
                    node.inputs.forEach(processAttribute);
                    node.outputs.forEach(processAttribute);
                    if (node instanceof Template) {
                        node.templateAttrs.forEach(processAttribute);
                    }
                    // Recurse into the node's children.
                    node.children.forEach(function (child) { return child.visit(_this); });
                };
                // Unused visitors.
                DirectiveBinder.prototype.visitContent = function (content) { };
                DirectiveBinder.prototype.visitVariable = function (variable) { };
                DirectiveBinder.prototype.visitReference = function (reference) { };
                DirectiveBinder.prototype.visitTextAttribute = function (attribute) { };
                DirectiveBinder.prototype.visitBoundAttribute = function (attribute) { };
                DirectiveBinder.prototype.visitBoundEvent = function (attribute) { };
                DirectiveBinder.prototype.visitBoundAttributeOrEvent = function (node) { };
                DirectiveBinder.prototype.visitText = function (text) { };
                DirectiveBinder.prototype.visitBoundText = function (text) { };
                DirectiveBinder.prototype.visitIcu = function (icu) { };
                return DirectiveBinder;
            }());
            /**
             * Processes a template and extract metadata about expressions and symbols within.
             *
             * This is a companion to the `DirectiveBinder` that doesn't require knowledge of directives matched
             * within the template in order to operate.
             *
             * Expressions are visited by the superclass `RecursiveAstVisitor`, with custom logic provided
             * by overridden methods from that visitor.
             */
            var TemplateBinder = /** @class */ (function (_super_1) {
                __extends(TemplateBinder, _super_1);
                function TemplateBinder(bindings, symbols, usedPipes, nestingLevel, scope, template, level) {
                    var _this = _super_1.call(this) || this;
                    _this.bindings = bindings;
                    _this.symbols = symbols;
                    _this.usedPipes = usedPipes;
                    _this.nestingLevel = nestingLevel;
                    _this.scope = scope;
                    _this.template = template;
                    _this.level = level;
                    _this.pipesUsed = [];
                    // Save a bit of processing time by constructing this closure in advance.
                    _this.visitNode = function (node) { return node.visit(_this); };
                    return _this;
                }
                /**
                 * Process a template and extract metadata about expressions and symbols within.
                 *
                 * @param template the nodes of the template to process
                 * @param scope the `Scope` of the template being processed.
                 * @returns three maps which contain metadata about the template: `expressions` which interprets
                 * special `AST` nodes in expressions as pointing to references or variables declared within the
                 * template, `symbols` which maps those variables and references to the nested `Template` which
                 * declares them, if any, and `nestingLevel` which associates each `Template` with a integer
                 * nesting level (how many levels deep within the template structure the `Template` is), starting
                 * at 1.
                 */
                TemplateBinder.apply = function (template, scope) {
                    var expressions = new Map();
                    var symbols = new Map();
                    var nestingLevel = new Map();
                    var usedPipes = new Set();
                    // The top-level template has nesting level 0.
                    var binder = new TemplateBinder(expressions, symbols, usedPipes, nestingLevel, scope, template instanceof Template ? template : null, 0);
                    binder.ingest(template);
                    return { expressions: expressions, symbols: symbols, nestingLevel: nestingLevel, usedPipes: usedPipes };
                };
                TemplateBinder.prototype.ingest = function (template) {
                    if (template instanceof Template) {
                        // For <ng-template>s, process only variables and child nodes. Inputs, outputs, templateAttrs,
                        // and references were all processed in the scope of the containing template.
                        template.variables.forEach(this.visitNode);
                        template.children.forEach(this.visitNode);
                        // Set the nesting level.
                        this.nestingLevel.set(template, this.level);
                    }
                    else {
                        // Visit each node from the top-level template.
                        template.forEach(this.visitNode);
                    }
                };
                TemplateBinder.prototype.visitElement = function (element) {
                    // Visit the inputs, outputs, and children of the element.
                    element.inputs.forEach(this.visitNode);
                    element.outputs.forEach(this.visitNode);
                    element.children.forEach(this.visitNode);
                };
                TemplateBinder.prototype.visitTemplate = function (template) {
                    // First, visit inputs, outputs and template attributes of the template node.
                    template.inputs.forEach(this.visitNode);
                    template.outputs.forEach(this.visitNode);
                    template.templateAttrs.forEach(this.visitNode);
                    // References are also evaluated in the outer context.
                    template.references.forEach(this.visitNode);
                    // Next, recurse into the template using its scope, and bumping the nesting level up by one.
                    var childScope = this.scope.getChildScope(template);
                    var binder = new TemplateBinder(this.bindings, this.symbols, this.usedPipes, this.nestingLevel, childScope, template, this.level + 1);
                    binder.ingest(template);
                };
                TemplateBinder.prototype.visitVariable = function (variable) {
                    // Register the `Variable` as a symbol in the current `Template`.
                    if (this.template !== null) {
                        this.symbols.set(variable, this.template);
                    }
                };
                TemplateBinder.prototype.visitReference = function (reference) {
                    // Register the `Reference` as a symbol in the current `Template`.
                    if (this.template !== null) {
                        this.symbols.set(reference, this.template);
                    }
                };
                // Unused template visitors
                TemplateBinder.prototype.visitText = function (text) { };
                TemplateBinder.prototype.visitContent = function (content) { };
                TemplateBinder.prototype.visitTextAttribute = function (attribute) { };
                TemplateBinder.prototype.visitIcu = function (icu) { };
                // The remaining visitors are concerned with processing AST expressions within template bindings
                TemplateBinder.prototype.visitBoundAttribute = function (attribute) { attribute.value.visit(this); };
                TemplateBinder.prototype.visitBoundEvent = function (event) { event.handler.visit(this); };
                TemplateBinder.prototype.visitBoundText = function (text) { text.value.visit(this); };
                TemplateBinder.prototype.visitPipe = function (ast, context) {
                    this.usedPipes.add(ast.name);
                    return _super_1.prototype.visitPipe.call(this, ast, context);
                };
                // These five types of AST expressions can refer to expression roots, which could be variables
                // or references in the current scope.
                TemplateBinder.prototype.visitPropertyRead = function (ast, context) {
                    this.maybeMap(context, ast, ast.name);
                    return _super_1.prototype.visitPropertyRead.call(this, ast, context);
                };
                TemplateBinder.prototype.visitSafePropertyRead = function (ast, context) {
                    this.maybeMap(context, ast, ast.name);
                    return _super_1.prototype.visitSafePropertyRead.call(this, ast, context);
                };
                TemplateBinder.prototype.visitPropertyWrite = function (ast, context) {
                    this.maybeMap(context, ast, ast.name);
                    return _super_1.prototype.visitPropertyWrite.call(this, ast, context);
                };
                TemplateBinder.prototype.visitMethodCall = function (ast, context) {
                    this.maybeMap(context, ast, ast.name);
                    return _super_1.prototype.visitMethodCall.call(this, ast, context);
                };
                TemplateBinder.prototype.visitSafeMethodCall = function (ast, context) {
                    this.maybeMap(context, ast, ast.name);
                    return _super_1.prototype.visitSafeMethodCall.call(this, ast, context);
                };
                TemplateBinder.prototype.maybeMap = function (scope, ast, name) {
                    // If the receiver of the expression isn't the `ImplicitReceiver`, this isn't the root of an
                    // `AST` expression that maps to a `Variable` or `Reference`.
                    if (!(ast.receiver instanceof ImplicitReceiver)) {
                        return;
                    }
                    // Check whether the name exists in the current scope. If so, map it. Otherwise, the name is
                    // probably a property on the top-level component context.
                    var target = this.scope.lookup(name);
                    if (target !== null) {
                        this.bindings.set(ast, target);
                    }
                };
                return TemplateBinder;
            }(RecursiveAstVisitor$1));
            /**
             * Metadata container for a `Target` that allows queries for specific bits of metadata.
             *
             * See `BoundTarget` for documentation on the individual methods.
             */
            var R3BoundTarget = /** @class */ (function () {
                function R3BoundTarget(target, directives, bindings, references, exprTargets, symbols, nestingLevel, usedPipes) {
                    this.target = target;
                    this.directives = directives;
                    this.bindings = bindings;
                    this.references = references;
                    this.exprTargets = exprTargets;
                    this.symbols = symbols;
                    this.nestingLevel = nestingLevel;
                    this.usedPipes = usedPipes;
                }
                R3BoundTarget.prototype.getDirectivesOfNode = function (node) {
                    return this.directives.get(node) || null;
                };
                R3BoundTarget.prototype.getReferenceTarget = function (ref) {
                    return this.references.get(ref) || null;
                };
                R3BoundTarget.prototype.getConsumerOfBinding = function (binding) {
                    return this.bindings.get(binding) || null;
                };
                R3BoundTarget.prototype.getExpressionTarget = function (expr) {
                    return this.exprTargets.get(expr) || null;
                };
                R3BoundTarget.prototype.getTemplateOfSymbol = function (symbol) {
                    return this.symbols.get(symbol) || null;
                };
                R3BoundTarget.prototype.getNestingLevel = function (template) { return this.nestingLevel.get(template) || 0; };
                R3BoundTarget.prototype.getUsedDirectives = function () {
                    var set = new Set();
                    this.directives.forEach(function (dirs) { return dirs.forEach(function (dir) { return set.add(dir); }); });
                    return Array.from(set.values());
                };
                R3BoundTarget.prototype.getUsedPipes = function () { return Array.from(this.usedPipes); };
                return R3BoundTarget;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // This file only reexports content of the `src` folder. Keep it that way.
            // This function call has a global side effects and publishes the compiler into global namespace for
            // the late binding of the Compiler to the @angular/core for jit compilation.
            publishFacade(_global);
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // This file only reexports content of the `src` folder. Keep it that way.
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            //# sourceMappingURL=compiler.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/core/fesm2015/core.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/@angular/core/fesm2015/core.js ***!
          \*****************************************************/
        /*! exports provided: ɵangular_packages_core_core_q, ɵangular_packages_core_core_n, ɵangular_packages_core_core_o, ɵangular_packages_core_core_p, ɵangular_packages_core_core_r, ɵangular_packages_core_core_f, ɵangular_packages_core_core_l, ɵangular_packages_core_core_m, ɵangular_packages_core_core_k, ɵangular_packages_core_core_j, ɵangular_packages_core_core_b, ɵangular_packages_core_core_a, ɵangular_packages_core_core_c, ɵangular_packages_core_core_d, ɵangular_packages_core_core_e, ɵangular_packages_core_core_i, ɵangular_packages_core_core_s, ɵangular_packages_core_core_u, ɵangular_packages_core_core_t, ɵangular_packages_core_core_x, ɵangular_packages_core_core_v, ɵangular_packages_core_core_w, ɵangular_packages_core_core_ba, ɵangular_packages_core_core_bb, ɵangular_packages_core_core_bc, ɵangular_packages_core_core_bd, ɵangular_packages_core_core_be, ɵangular_packages_core_core_bm, ɵangular_packages_core_core_bl, ɵangular_packages_core_core_g, ɵangular_packages_core_core_h, ɵangular_packages_core_core_bg, ɵangular_packages_core_core_bk, ɵangular_packages_core_core_bh, ɵangular_packages_core_core_bi, ɵangular_packages_core_core_bn, ɵangular_packages_core_core_y, ɵangular_packages_core_core_z, createPlatform, assertPlatform, destroyPlatform, getPlatform, PlatformRef, ApplicationRef, createPlatformFactory, NgProbeToken, enableProdMode, isDevMode, APP_ID, PACKAGE_ROOT_URL, PLATFORM_INITIALIZER, PLATFORM_ID, APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, ApplicationInitStatus, DebugElement, DebugEventListener, DebugNode, asNativeElements, getDebugNode, Testability, TestabilityRegistry, setTestabilityGetter, TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID, MissingTranslationStrategy, ApplicationModule, wtfCreateScope, wtfLeave, wtfStartTimeRange, wtfEndTimeRange, Type, EventEmitter, ErrorHandler, Sanitizer, SecurityContext, Attribute, ANALYZE_FOR_ENTRY_COMPONENTS, ContentChild, ContentChildren, Query, ViewChild, ViewChildren, Component, Directive, HostBinding, HostListener, Input, Output, Pipe, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ViewEncapsulation, Version, VERSION, InjectFlags, ɵɵdefineInjectable, defineInjectable, ɵɵdefineInjector, forwardRef, resolveForwardRef, Injectable, Injector, ɵɵinject, inject, INJECTOR, ReflectiveInjector, ResolvedReflectiveFactory, ReflectiveKey, InjectionToken, Inject, Optional, Self, SkipSelf, Host, NgZone, ɵNoopNgZone, RenderComponentType, Renderer, Renderer2, RendererFactory2, RendererStyleFlags2, RootRenderer, COMPILER_OPTIONS, Compiler, CompilerFactory, ModuleWithComponentFactories, ComponentFactory, ɵComponentFactory, ComponentRef, ComponentFactoryResolver, ElementRef, NgModuleFactory, NgModuleRef, NgModuleFactoryLoader, getModuleFactory, QueryList, SystemJsNgModuleLoader, SystemJsNgModuleLoaderConfig, TemplateRef, ViewContainerRef, EmbeddedViewRef, ViewRef, ChangeDetectionStrategy, ChangeDetectorRef, DefaultIterableDiffer, IterableDiffers, KeyValueDiffers, SimpleChange, WrappedValue, platformCore, ɵALLOW_MULTIPLE_PLATFORMS, ɵAPP_ID_RANDOM_PROVIDER, ɵdefaultIterableDiffers, ɵdefaultKeyValueDiffers, ɵdevModeEqual, ɵisListLikeIterable, ɵChangeDetectorStatus, ɵisDefaultChangeDetectionStrategy, ɵConsole, ɵsetCurrentInjector, ɵgetInjectableDef, ɵAPP_ROOT, ɵDEFAULT_LOCALE_ID, ɵivyEnabled, ɵCodegenComponentFactoryResolver, ɵclearResolutionOfComponentResourcesQueue, ɵresolveComponentResources, ɵReflectionCapabilities, ɵRenderDebugInfo, ɵ_sanitizeHtml, ɵ_sanitizeStyle, ɵ_sanitizeUrl, ɵglobal, ɵlooseIdentical, ɵstringify, ɵmakeDecorator, ɵisObservable, ɵisPromise, ɵclearOverrides, ɵinitServicesIfNeeded, ɵoverrideComponentView, ɵoverrideProvider, ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR, ɵgetLocalePluralCase, ɵfindLocaleData, ɵLOCALE_DATA, ɵLocaleDataIndex, ɵɵattribute, ɵɵattributeInterpolate1, ɵɵattributeInterpolate2, ɵɵattributeInterpolate3, ɵɵattributeInterpolate4, ɵɵattributeInterpolate5, ɵɵattributeInterpolate6, ɵɵattributeInterpolate7, ɵɵattributeInterpolate8, ɵɵattributeInterpolateV, ɵɵdefineBase, ɵɵdefineComponent, ɵɵdefineDirective, ɵɵdefinePipe, ɵɵdefineNgModule, ɵdetectChanges, ɵrenderComponent, ɵRender3ComponentFactory, ɵRender3ComponentRef, ɵɵdirectiveInject, ɵɵinjectAttribute, ɵɵinjectPipeChangeDetectorRef, ɵɵgetFactoryOf, ɵɵgetInheritedFactory, ɵɵsetComponentScope, ɵɵsetNgModuleScope, ɵɵtemplateRefExtractor, ɵɵProvidersFeature, ɵɵInheritDefinitionFeature, ɵɵNgOnChangesFeature, ɵLifecycleHooksFeature, ɵRender3NgModuleRef, ɵmarkDirty, ɵNgModuleFactory, ɵNO_CHANGE, ɵɵcontainer, ɵɵnextContext, ɵɵelementStart, ɵɵnamespaceHTML, ɵɵnamespaceMathML, ɵɵnamespaceSVG, ɵɵelement, ɵɵlistener, ɵɵtext, ɵɵtextInterpolate, ɵɵtextInterpolate1, ɵɵtextInterpolate2, ɵɵtextInterpolate3, ɵɵtextInterpolate4, ɵɵtextInterpolate5, ɵɵtextInterpolate6, ɵɵtextInterpolate7, ɵɵtextInterpolate8, ɵɵtextInterpolateV, ɵɵembeddedViewStart, ɵɵprojection, ɵɵpipeBind1, ɵɵpipeBind2, ɵɵpipeBind3, ɵɵpipeBind4, ɵɵpipeBindV, ɵɵpureFunction0, ɵɵpureFunction1, ɵɵpureFunction2, ɵɵpureFunction3, ɵɵpureFunction4, ɵɵpureFunction5, ɵɵpureFunction6, ɵɵpureFunction7, ɵɵpureFunction8, ɵɵpureFunctionV, ɵɵgetCurrentView, ɵgetDirectives, ɵgetHostElement, ɵɵrestoreView, ɵɵcontainerRefreshStart, ɵɵcontainerRefreshEnd, ɵɵqueryRefresh, ɵɵviewQuery, ɵɵstaticViewQuery, ɵɵstaticContentQuery, ɵɵloadViewQuery, ɵɵcontentQuery, ɵɵloadContentQuery, ɵɵelementEnd, ɵɵhostProperty, ɵɵproperty, ɵɵpropertyInterpolate, ɵɵpropertyInterpolate1, ɵɵpropertyInterpolate2, ɵɵpropertyInterpolate3, ɵɵpropertyInterpolate4, ɵɵpropertyInterpolate5, ɵɵpropertyInterpolate6, ɵɵpropertyInterpolate7, ɵɵpropertyInterpolate8, ɵɵpropertyInterpolateV, ɵɵupdateSyntheticHostBinding, ɵɵcomponentHostSyntheticListener, ɵɵprojectionDef, ɵɵreference, ɵɵenableBindings, ɵɵdisableBindings, ɵɵallocHostVars, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵelementContainer, ɵɵstyling, ɵɵstyleMap, ɵɵstyleSanitizer, ɵɵclassMap, ɵɵclassMapInterpolate1, ɵɵclassMapInterpolate2, ɵɵclassMapInterpolate3, ɵɵclassMapInterpolate4, ɵɵclassMapInterpolate5, ɵɵclassMapInterpolate6, ɵɵclassMapInterpolate7, ɵɵclassMapInterpolate8, ɵɵclassMapInterpolateV, ɵɵstyleProp, ɵɵstylePropInterpolate1, ɵɵstylePropInterpolate2, ɵɵstylePropInterpolate3, ɵɵstylePropInterpolate4, ɵɵstylePropInterpolate5, ɵɵstylePropInterpolate6, ɵɵstylePropInterpolate7, ɵɵstylePropInterpolate8, ɵɵstylePropInterpolateV, ɵɵstylingApply, ɵɵclassProp, ɵɵelementHostAttrs, ɵɵselect, ɵɵtextBinding, ɵɵtemplate, ɵɵembeddedViewEnd, ɵstore, ɵɵload, ɵɵpipe, ɵwhenRendered, ɵɵi18n, ɵɵi18nAttributes, ɵɵi18nExp, ɵɵi18nStart, ɵɵi18nEnd, ɵɵi18nApply, ɵɵi18nPostprocess, ɵi18nConfigureLocalize, ɵɵi18nLocalize, ɵsetLocaleId, ɵsetClassMetadata, ɵɵresolveWindow, ɵɵresolveDocument, ɵɵresolveBody, ɵcompileComponent, ɵcompileDirective, ɵcompileNgModule, ɵcompileNgModuleDefs, ɵpatchComponentDefWithScope, ɵresetCompiledComponents, ɵflushModuleScopingQueueAsMuchAsPossible, ɵtransitiveScopesFor, ɵcompilePipe, ɵɵsanitizeHtml, ɵɵsanitizeStyle, ɵɵdefaultStyleSanitizer, ɵɵsanitizeScript, ɵɵsanitizeUrl, ɵɵsanitizeResourceUrl, ɵɵsanitizeUrlOrResourceUrl, ɵbypassSanitizationTrustHtml, ɵbypassSanitizationTrustStyle, ɵbypassSanitizationTrustScript, ɵbypassSanitizationTrustUrl, ɵbypassSanitizationTrustResourceUrl, ɵgetLContext, ɵNG_ELEMENT_ID, ɵNG_COMPONENT_DEF, ɵNG_DIRECTIVE_DEF, ɵNG_PIPE_DEF, ɵNG_MODULE_DEF, ɵNG_BASE_DEF, ɵNG_INJECTABLE_DEF, ɵNG_INJECTOR_DEF, ɵcompileNgModuleFactory__POST_R3__, ɵisBoundToModule__POST_R3__, ɵSWITCH_COMPILE_COMPONENT__POST_R3__, ɵSWITCH_COMPILE_DIRECTIVE__POST_R3__, ɵSWITCH_COMPILE_PIPE__POST_R3__, ɵSWITCH_COMPILE_NGMODULE__POST_R3__, ɵgetDebugNode__POST_R3__, ɵSWITCH_COMPILE_INJECTABLE__POST_R3__, ɵSWITCH_IVY_ENABLED__POST_R3__, ɵSWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__, ɵCompiler_compileModuleSync__POST_R3__, ɵCompiler_compileModuleAsync__POST_R3__, ɵCompiler_compileModuleAndAllComponentsSync__POST_R3__, ɵCompiler_compileModuleAndAllComponentsAsync__POST_R3__, ɵSWITCH_ELEMENT_REF_FACTORY__POST_R3__, ɵSWITCH_TEMPLATE_REF_FACTORY__POST_R3__, ɵSWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__, ɵSWITCH_RENDERER2_FACTORY__POST_R3__, ɵgetModuleFactory__POST_R3__, ɵregisterNgModuleType, ɵpublishGlobalUtil, ɵpublishDefaultGlobalUtils, ɵcreateInjector, ɵINJECTOR_IMPL__POST_R3__, ɵregisterModuleFactory, ɵEMPTY_ARRAY, ɵEMPTY_MAP, ɵand, ɵccf, ɵcmf, ɵcrt, ɵdid, ɵeld, ɵgetComponentViewDefinitionFactory, ɵinlineInterpolate, ɵinterpolate, ɵmod, ɵmpd, ɵncd, ɵnov, ɵpid, ɵprd, ɵpad, ɵpod, ɵppd, ɵqud, ɵted, ɵunv, ɵvid */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_q", function () { return APPLICATION_MODULE_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_n", function () { return _iterableDiffersFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_o", function () { return _keyValueDiffersFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_p", function () { return _localeFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_r", function () { return zoneSchedulerFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_f", function () { return _appIdRandomProviderFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_l", function () { return DefaultIterableDifferFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_m", function () { return DefaultKeyValueDifferFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_k", function () { return DebugElement__PRE_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_j", function () { return DebugNode__PRE_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_b", function () { return NullInjector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_a", function () { return injectInjectorOnly; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_c", function () { return ReflectiveInjector_; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_d", function () { return ReflectiveDependency; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_e", function () { return resolveReflectiveProviders; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_i", function () { return getModuleFactory__PRE_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_s", function () { return wtfEnabled; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_u", function () { return createScope; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_t", function () { return detectWTF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_x", function () { return endTimeRange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_v", function () { return leave; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_w", function () { return startTimeRange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_ba", function () { return SCHEDULER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bb", function () { return injectAttributeImpl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bc", function () { return getLView; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bd", function () { return getPreviousOrParentTNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_be", function () { return nextContextImpl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bm", function () { return getRootContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bl", function () { return loadInternal; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_g", function () { return createElementRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_h", function () { return createTemplateRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bg", function () { return getUrlSanitizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bk", function () { return noSideEffects; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bh", function () { return makeParamDecorator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bi", function () { return makePropDecorator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bn", function () { return getClosureSafeProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_y", function () { return _def; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_z", function () { return DebugContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatform", function () { return createPlatform; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assertPlatform", function () { return assertPlatform; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyPlatform", function () { return destroyPlatform; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatform", function () { return getPlatform; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformRef", function () { return PlatformRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationRef", function () { return ApplicationRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatformFactory", function () { return createPlatformFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgProbeToken", function () { return NgProbeToken; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableProdMode", function () { return enableProdMode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDevMode", function () { return isDevMode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_ID", function () { return APP_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PACKAGE_ROOT_URL", function () { return PACKAGE_ROOT_URL; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_INITIALIZER", function () { return PLATFORM_INITIALIZER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_ID", function () { return PLATFORM_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_BOOTSTRAP_LISTENER", function () { return APP_BOOTSTRAP_LISTENER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_INITIALIZER", function () { return APP_INITIALIZER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationInitStatus", function () { return ApplicationInitStatus; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugElement", function () { return DebugElement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugEventListener", function () { return DebugEventListener; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugNode", function () { return DebugNode$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asNativeElements", function () { return asNativeElements; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebugNode", function () { return getDebugNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Testability", function () { return Testability; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestabilityRegistry", function () { return TestabilityRegistry; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTestabilityGetter", function () { return setTestabilityGetter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSLATIONS", function () { return TRANSLATIONS$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSLATIONS_FORMAT", function () { return TRANSLATIONS_FORMAT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCALE_ID", function () { return LOCALE_ID$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationStrategy", function () { return MissingTranslationStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationModule", function () { return ApplicationModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfCreateScope", function () { return wtfCreateScope; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfLeave", function () { return wtfLeave; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfStartTimeRange", function () { return wtfStartTimeRange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfEndTimeRange", function () { return wtfEndTimeRange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Type", function () { return Type; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventEmitter", function () { return EventEmitter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorHandler", function () { return ErrorHandler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sanitizer", function () { return Sanitizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecurityContext", function () { return SecurityContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Attribute", function () { return Attribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANALYZE_FOR_ENTRY_COMPONENTS", function () { return ANALYZE_FOR_ENTRY_COMPONENTS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentChild", function () { return ContentChild; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentChildren", function () { return ContentChildren; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Query", function () { return Query; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewChild", function () { return ViewChild; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewChildren", function () { return ViewChildren; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function () { return Component; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Directive", function () { return Directive; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HostBinding", function () { return HostBinding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HostListener", function () { return HostListener; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function () { return Input; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Output", function () { return Output; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pipe", function () { return Pipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModule", function () { return NgModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CUSTOM_ELEMENTS_SCHEMA", function () { return CUSTOM_ELEMENTS_SCHEMA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_ERRORS_SCHEMA", function () { return NO_ERRORS_SCHEMA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewEncapsulation", function () { return ViewEncapsulation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Version", function () { return Version; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InjectFlags", function () { return InjectFlags; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefineInjectable", function () { return ɵɵdefineInjectable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineInjectable", function () { return defineInjectable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefineInjector", function () { return ɵɵdefineInjector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardRef", function () { return forwardRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveForwardRef", function () { return resolveForwardRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Injectable", function () { return Injectable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Injector", function () { return Injector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵinject", function () { return ɵɵinject; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function () { return inject; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INJECTOR", function () { return INJECTOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReflectiveInjector", function () { return ReflectiveInjector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolvedReflectiveFactory", function () { return ResolvedReflectiveFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReflectiveKey", function () { return ReflectiveKey; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InjectionToken", function () { return InjectionToken; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Inject", function () { return Inject; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Optional", function () { return Optional; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Self", function () { return Self; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SkipSelf", function () { return SkipSelf; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Host", function () { return Host; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgZone", function () { return NgZone; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNoopNgZone", function () { return NoopNgZone; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderComponentType", function () { return RenderComponentType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer", function () { return Renderer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer2", function () { return Renderer2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererFactory2", function () { return RendererFactory2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererStyleFlags2", function () { return RendererStyleFlags2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RootRenderer", function () { return RootRenderer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPILER_OPTIONS", function () { return COMPILER_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Compiler", function () { return Compiler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompilerFactory", function () { return CompilerFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleWithComponentFactories", function () { return ModuleWithComponentFactories; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentFactory", function () { return ComponentFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵComponentFactory", function () { return ComponentFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentRef", function () { return ComponentRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentFactoryResolver", function () { return ComponentFactoryResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementRef", function () { return ElementRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleFactory", function () { return NgModuleFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleRef", function () { return NgModuleRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleFactoryLoader", function () { return NgModuleFactoryLoader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModuleFactory", function () { return getModuleFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryList", function () { return QueryList; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemJsNgModuleLoader", function () { return SystemJsNgModuleLoader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemJsNgModuleLoaderConfig", function () { return SystemJsNgModuleLoaderConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateRef", function () { return TemplateRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewContainerRef", function () { return ViewContainerRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmbeddedViewRef", function () { return EmbeddedViewRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewRef", function () { return ViewRef$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeDetectionStrategy", function () { return ChangeDetectionStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeDetectorRef", function () { return ChangeDetectorRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultIterableDiffer", function () { return DefaultIterableDiffer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IterableDiffers", function () { return IterableDiffers; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyValueDiffers", function () { return KeyValueDiffers; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleChange", function () { return SimpleChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WrappedValue", function () { return WrappedValue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformCore", function () { return platformCore; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵALLOW_MULTIPLE_PLATFORMS", function () { return ALLOW_MULTIPLE_PLATFORMS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAPP_ID_RANDOM_PROVIDER", function () { return APP_ID_RANDOM_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefaultIterableDiffers", function () { return defaultIterableDiffers; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefaultKeyValueDiffers", function () { return defaultKeyValueDiffers; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdevModeEqual", function () { return devModeEqual$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisListLikeIterable", function () { return isListLikeIterable$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵChangeDetectorStatus", function () { return ChangeDetectorStatus; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisDefaultChangeDetectionStrategy", function () { return isDefaultChangeDetectionStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵConsole", function () { return Console; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetCurrentInjector", function () { return setCurrentInjector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetInjectableDef", function () { return getInjectableDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAPP_ROOT", function () { return APP_ROOT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDEFAULT_LOCALE_ID", function () { return DEFAULT_LOCALE_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵivyEnabled", function () { return ivyEnabled; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCodegenComponentFactoryResolver", function () { return CodegenComponentFactoryResolver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵclearResolutionOfComponentResourcesQueue", function () { return clearResolutionOfComponentResourcesQueue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵresolveComponentResources", function () { return resolveComponentResources; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵReflectionCapabilities", function () { return ReflectionCapabilities; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵRenderDebugInfo", function () { return RenderDebugInfo; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ_sanitizeHtml", function () { return _sanitizeHtml; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ_sanitizeStyle", function () { return _sanitizeStyle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ_sanitizeUrl", function () { return _sanitizeUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵglobal", function () { return _global; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵlooseIdentical", function () { return looseIdentical; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵstringify", function () { return stringify; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmakeDecorator", function () { return makeDecorator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisObservable", function () { return isObservable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisPromise", function () { return isPromise; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵclearOverrides", function () { return clearOverrides; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinitServicesIfNeeded", function () { return initServicesIfNeeded; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵoverrideComponentView", function () { return overrideComponentView; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵoverrideProvider", function () { return overrideProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR", function () { return NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetLocalePluralCase", function () { return getLocalePluralCase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵfindLocaleData", function () { return findLocaleData; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵLOCALE_DATA", function () { return LOCALE_DATA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵLocaleDataIndex", function () { return LocaleDataIndex; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattribute", function () { return ɵɵattribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate1", function () { return ɵɵattributeInterpolate1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate2", function () { return ɵɵattributeInterpolate2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate3", function () { return ɵɵattributeInterpolate3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate4", function () { return ɵɵattributeInterpolate4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate5", function () { return ɵɵattributeInterpolate5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate6", function () { return ɵɵattributeInterpolate6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate7", function () { return ɵɵattributeInterpolate7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolate8", function () { return ɵɵattributeInterpolate8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵattributeInterpolateV", function () { return ɵɵattributeInterpolateV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefineBase", function () { return ɵɵdefineBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefineComponent", function () { return ɵɵdefineComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefineDirective", function () { return ɵɵdefineDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefinePipe", function () { return ɵɵdefinePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefineNgModule", function () { return ɵɵdefineNgModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdetectChanges", function () { return detectChanges; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵrenderComponent", function () { return renderComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵRender3ComponentFactory", function () { return ComponentFactory$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵRender3ComponentRef", function () { return ComponentRef$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdirectiveInject", function () { return ɵɵdirectiveInject; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵinjectAttribute", function () { return ɵɵinjectAttribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵinjectPipeChangeDetectorRef", function () { return ɵɵinjectPipeChangeDetectorRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵgetFactoryOf", function () { return ɵɵgetFactoryOf; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵgetInheritedFactory", function () { return ɵɵgetInheritedFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsetComponentScope", function () { return ɵɵsetComponentScope; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsetNgModuleScope", function () { return ɵɵsetNgModuleScope; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtemplateRefExtractor", function () { return ɵɵtemplateRefExtractor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵProvidersFeature", function () { return ɵɵProvidersFeature; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵInheritDefinitionFeature", function () { return ɵɵInheritDefinitionFeature; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵNgOnChangesFeature", function () { return ɵɵNgOnChangesFeature; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵLifecycleHooksFeature", function () { return LifecycleHooksFeature; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵRender3NgModuleRef", function () { return NgModuleRef$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmarkDirty", function () { return markDirty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgModuleFactory", function () { return NgModuleFactory$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNO_CHANGE", function () { return NO_CHANGE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵcontainer", function () { return ɵɵcontainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵnextContext", function () { return ɵɵnextContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelementStart", function () { return ɵɵelementStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵnamespaceHTML", function () { return ɵɵnamespaceHTML; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵnamespaceMathML", function () { return ɵɵnamespaceMathML; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵnamespaceSVG", function () { return ɵɵnamespaceSVG; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelement", function () { return ɵɵelement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵlistener", function () { return ɵɵlistener; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtext", function () { return ɵɵtext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate", function () { return ɵɵtextInterpolate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate1", function () { return ɵɵtextInterpolate1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate2", function () { return ɵɵtextInterpolate2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate3", function () { return ɵɵtextInterpolate3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate4", function () { return ɵɵtextInterpolate4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate5", function () { return ɵɵtextInterpolate5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate6", function () { return ɵɵtextInterpolate6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate7", function () { return ɵɵtextInterpolate7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolate8", function () { return ɵɵtextInterpolate8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextInterpolateV", function () { return ɵɵtextInterpolateV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵembeddedViewStart", function () { return ɵɵembeddedViewStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵprojection", function () { return ɵɵprojection; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpipeBind1", function () { return ɵɵpipeBind1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpipeBind2", function () { return ɵɵpipeBind2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpipeBind3", function () { return ɵɵpipeBind3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpipeBind4", function () { return ɵɵpipeBind4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpipeBindV", function () { return ɵɵpipeBindV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction0", function () { return ɵɵpureFunction0; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction1", function () { return ɵɵpureFunction1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction2", function () { return ɵɵpureFunction2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction3", function () { return ɵɵpureFunction3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction4", function () { return ɵɵpureFunction4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction5", function () { return ɵɵpureFunction5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction6", function () { return ɵɵpureFunction6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction7", function () { return ɵɵpureFunction7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunction8", function () { return ɵɵpureFunction8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpureFunctionV", function () { return ɵɵpureFunctionV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵgetCurrentView", function () { return ɵɵgetCurrentView; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetDirectives", function () { return getDirectives; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetHostElement", function () { return getHostElement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵrestoreView", function () { return ɵɵrestoreView; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵcontainerRefreshStart", function () { return ɵɵcontainerRefreshStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵcontainerRefreshEnd", function () { return ɵɵcontainerRefreshEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵqueryRefresh", function () { return ɵɵqueryRefresh; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵviewQuery", function () { return ɵɵviewQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstaticViewQuery", function () { return ɵɵstaticViewQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstaticContentQuery", function () { return ɵɵstaticContentQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵloadViewQuery", function () { return ɵɵloadViewQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵcontentQuery", function () { return ɵɵcontentQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵloadContentQuery", function () { return ɵɵloadContentQuery; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelementEnd", function () { return ɵɵelementEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵhostProperty", function () { return ɵɵhostProperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵproperty", function () { return ɵɵproperty; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate", function () { return ɵɵpropertyInterpolate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate1", function () { return ɵɵpropertyInterpolate1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate2", function () { return ɵɵpropertyInterpolate2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate3", function () { return ɵɵpropertyInterpolate3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate4", function () { return ɵɵpropertyInterpolate4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate5", function () { return ɵɵpropertyInterpolate5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate6", function () { return ɵɵpropertyInterpolate6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate7", function () { return ɵɵpropertyInterpolate7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolate8", function () { return ɵɵpropertyInterpolate8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpropertyInterpolateV", function () { return ɵɵpropertyInterpolateV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵupdateSyntheticHostBinding", function () { return ɵɵupdateSyntheticHostBinding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵcomponentHostSyntheticListener", function () { return ɵɵcomponentHostSyntheticListener; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵprojectionDef", function () { return ɵɵprojectionDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵreference", function () { return ɵɵreference; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵenableBindings", function () { return ɵɵenableBindings; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdisableBindings", function () { return ɵɵdisableBindings; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵallocHostVars", function () { return ɵɵallocHostVars; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelementContainerStart", function () { return ɵɵelementContainerStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelementContainerEnd", function () { return ɵɵelementContainerEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelementContainer", function () { return ɵɵelementContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstyling", function () { return ɵɵstyling; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstyleMap", function () { return ɵɵstyleMap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstyleSanitizer", function () { return ɵɵstyleSanitizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMap", function () { return ɵɵclassMap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate1", function () { return ɵɵclassMapInterpolate1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate2", function () { return ɵɵclassMapInterpolate2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate3", function () { return ɵɵclassMapInterpolate3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate4", function () { return ɵɵclassMapInterpolate4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate5", function () { return ɵɵclassMapInterpolate5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate6", function () { return ɵɵclassMapInterpolate6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate7", function () { return ɵɵclassMapInterpolate7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolate8", function () { return ɵɵclassMapInterpolate8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassMapInterpolateV", function () { return ɵɵclassMapInterpolateV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstyleProp", function () { return ɵɵstyleProp; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate1", function () { return ɵɵstylePropInterpolate1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate2", function () { return ɵɵstylePropInterpolate2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate3", function () { return ɵɵstylePropInterpolate3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate4", function () { return ɵɵstylePropInterpolate4; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate5", function () { return ɵɵstylePropInterpolate5; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate6", function () { return ɵɵstylePropInterpolate6; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate7", function () { return ɵɵstylePropInterpolate7; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolate8", function () { return ɵɵstylePropInterpolate8; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylePropInterpolateV", function () { return ɵɵstylePropInterpolateV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵstylingApply", function () { return ɵɵstylingApply; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵclassProp", function () { return ɵɵclassProp; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵelementHostAttrs", function () { return ɵɵelementHostAttrs; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵselect", function () { return ɵɵselect; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtextBinding", function () { return ɵɵtextBinding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵtemplate", function () { return ɵɵtemplate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵembeddedViewEnd", function () { return ɵɵembeddedViewEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵstore", function () { return store; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵload", function () { return ɵɵload; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵpipe", function () { return ɵɵpipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵwhenRendered", function () { return whenRendered; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18n", function () { return ɵɵi18n; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nAttributes", function () { return ɵɵi18nAttributes; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nExp", function () { return ɵɵi18nExp; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nStart", function () { return ɵɵi18nStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nEnd", function () { return ɵɵi18nEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nApply", function () { return ɵɵi18nApply; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nPostprocess", function () { return ɵɵi18nPostprocess; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi18nConfigureLocalize", function () { return i18nConfigureLocalize; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵi18nLocalize", function () { return ɵɵi18nLocalize; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetLocaleId", function () { return setLocaleId; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetClassMetadata", function () { return setClassMetadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵresolveWindow", function () { return ɵɵresolveWindow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵresolveDocument", function () { return ɵɵresolveDocument; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵresolveBody", function () { return ɵɵresolveBody; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcompileComponent", function () { return compileComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcompileDirective", function () { return compileDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcompileNgModule", function () { return compileNgModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcompileNgModuleDefs", function () { return compileNgModuleDefs; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpatchComponentDefWithScope", function () { return patchComponentDefWithScope; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵresetCompiledComponents", function () { return resetCompiledComponents; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵflushModuleScopingQueueAsMuchAsPossible", function () { return flushModuleScopingQueueAsMuchAsPossible; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵtransitiveScopesFor", function () { return transitiveScopesFor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcompilePipe", function () { return compilePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsanitizeHtml", function () { return ɵɵsanitizeHtml; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsanitizeStyle", function () { return ɵɵsanitizeStyle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵdefaultStyleSanitizer", function () { return ɵɵdefaultStyleSanitizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsanitizeScript", function () { return ɵɵsanitizeScript; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsanitizeUrl", function () { return ɵɵsanitizeUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsanitizeResourceUrl", function () { return ɵɵsanitizeResourceUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵɵsanitizeUrlOrResourceUrl", function () { return ɵɵsanitizeUrlOrResourceUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustHtml", function () { return bypassSanitizationTrustHtml; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustStyle", function () { return bypassSanitizationTrustStyle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustScript", function () { return bypassSanitizationTrustScript; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustUrl", function () { return bypassSanitizationTrustUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustResourceUrl", function () { return bypassSanitizationTrustResourceUrl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetLContext", function () { return getLContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_ELEMENT_ID", function () { return NG_ELEMENT_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_COMPONENT_DEF", function () { return NG_COMPONENT_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_DIRECTIVE_DEF", function () { return NG_DIRECTIVE_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_PIPE_DEF", function () { return NG_PIPE_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_MODULE_DEF", function () { return NG_MODULE_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_BASE_DEF", function () { return NG_BASE_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_INJECTABLE_DEF", function () { return NG_INJECTABLE_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNG_INJECTOR_DEF", function () { return NG_INJECTOR_DEF; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcompileNgModuleFactory__POST_R3__", function () { return compileNgModuleFactory__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisBoundToModule__POST_R3__", function () { return isBoundToModule__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_COMPILE_COMPONENT__POST_R3__", function () { return SWITCH_COMPILE_COMPONENT__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_COMPILE_DIRECTIVE__POST_R3__", function () { return SWITCH_COMPILE_DIRECTIVE__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_COMPILE_PIPE__POST_R3__", function () { return SWITCH_COMPILE_PIPE__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_COMPILE_NGMODULE__POST_R3__", function () { return SWITCH_COMPILE_NGMODULE__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetDebugNode__POST_R3__", function () { return getDebugNode__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_COMPILE_INJECTABLE__POST_R3__", function () { return SWITCH_COMPILE_INJECTABLE__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_IVY_ENABLED__POST_R3__", function () { return SWITCH_IVY_ENABLED__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__", function () { return SWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCompiler_compileModuleSync__POST_R3__", function () { return Compiler_compileModuleSync__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCompiler_compileModuleAsync__POST_R3__", function () { return Compiler_compileModuleAsync__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCompiler_compileModuleAndAllComponentsSync__POST_R3__", function () { return Compiler_compileModuleAndAllComponentsSync__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCompiler_compileModuleAndAllComponentsAsync__POST_R3__", function () { return Compiler_compileModuleAndAllComponentsAsync__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_ELEMENT_REF_FACTORY__POST_R3__", function () { return SWITCH_ELEMENT_REF_FACTORY__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_TEMPLATE_REF_FACTORY__POST_R3__", function () { return SWITCH_TEMPLATE_REF_FACTORY__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__", function () { return SWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSWITCH_RENDERER2_FACTORY__POST_R3__", function () { return SWITCH_RENDERER2_FACTORY__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetModuleFactory__POST_R3__", function () { return getModuleFactory__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵregisterNgModuleType", function () { return registerNgModuleType; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpublishGlobalUtil", function () { return publishGlobalUtil; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpublishDefaultGlobalUtils", function () { return publishDefaultGlobalUtils; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcreateInjector", function () { return createInjector; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵINJECTOR_IMPL__POST_R3__", function () { return INJECTOR_IMPL__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵregisterModuleFactory", function () { return registerModuleFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEMPTY_ARRAY", function () { return EMPTY_ARRAY$3; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEMPTY_MAP", function () { return EMPTY_MAP; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵand", function () { return anchorDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵccf", function () { return createComponentFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcmf", function () { return createNgModuleFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcrt", function () { return createRendererType2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdid", function () { return directiveDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵeld", function () { return elementDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetComponentViewDefinitionFactory", function () { return getComponentViewDefinitionFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinlineInterpolate", function () { return inlineInterpolate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinterpolate", function () { return interpolate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmod", function () { return moduleDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmpd", function () { return moduleProvideDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵncd", function () { return ngContentDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵnov", function () { return nodeValue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpid", function () { return pipeDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵprd", function () { return providerDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpad", function () { return pureArrayDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpod", function () { return pureObjectDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵppd", function () { return purePipeDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵqud", function () { return queryDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵted", function () { return textDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵunv", function () { return unwrapValue; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵvid", function () { return viewDef; });
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ANNOTATIONS = '__annotations__';
            var PARAMETERS = '__parameters__';
            var PROP_METADATA = '__prop__metadata__';
            /**
             * @suppress {globalThis}
             */
            function makeDecorator(name, props, parentClass, additionalProcessing, typeFn) {
                var metaCtor = makeMetadataCtor(props);
                function DecoratorFactory() {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    if (this instanceof DecoratorFactory) {
                        metaCtor.call.apply(metaCtor, [this].concat(args));
                        return this;
                    }
                    var annotationInstance = new (DecoratorFactory.bind.apply(DecoratorFactory, [void 0].concat(args)))();
                    return function TypeDecorator(cls) {
                        if (typeFn)
                            typeFn.apply(void 0, [cls].concat(args));
                        // Use of Object.defineProperty is important since it creates non-enumerable property which
                        // prevents the property is copied during subclassing.
                        var annotations = cls.hasOwnProperty(ANNOTATIONS) ?
                            cls[ANNOTATIONS] :
                            Object.defineProperty(cls, ANNOTATIONS, { value: [] })[ANNOTATIONS];
                        annotations.push(annotationInstance);
                        if (additionalProcessing)
                            additionalProcessing(cls);
                        return cls;
                    };
                }
                if (parentClass) {
                    DecoratorFactory.prototype = Object.create(parentClass.prototype);
                }
                DecoratorFactory.prototype.ngMetadataName = name;
                DecoratorFactory.annotationCls = DecoratorFactory;
                return DecoratorFactory;
            }
            function makeMetadataCtor(props) {
                return function ctor() {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    if (props) {
                        var values = props.apply(void 0, args);
                        for (var propName in values) {
                            this[propName] = values[propName];
                        }
                    }
                };
            }
            function makeParamDecorator(name, props, parentClass) {
                var metaCtor = makeMetadataCtor(props);
                function ParamDecoratorFactory() {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    if (this instanceof ParamDecoratorFactory) {
                        metaCtor.apply(this, args);
                        return this;
                    }
                    var annotationInstance = new (ParamDecoratorFactory.bind.apply(ParamDecoratorFactory, [void 0].concat(args)))();
                    ParamDecorator.annotation = annotationInstance;
                    return ParamDecorator;
                    function ParamDecorator(cls, unusedKey, index) {
                        // Use of Object.defineProperty is important since it creates non-enumerable property which
                        // prevents the property is copied during subclassing.
                        var parameters = cls.hasOwnProperty(PARAMETERS) ?
                            cls[PARAMETERS] :
                            Object.defineProperty(cls, PARAMETERS, { value: [] })[PARAMETERS];
                        // there might be gaps if some in between parameters do not have annotations.
                        // we pad with nulls.
                        while (parameters.length <= index) {
                            parameters.push(null);
                        }
                        (parameters[index] = parameters[index] || []).push(annotationInstance);
                        return cls;
                    }
                }
                if (parentClass) {
                    ParamDecoratorFactory.prototype = Object.create(parentClass.prototype);
                }
                ParamDecoratorFactory.prototype.ngMetadataName = name;
                ParamDecoratorFactory.annotationCls = ParamDecoratorFactory;
                return ParamDecoratorFactory;
            }
            function makePropDecorator(name, props, parentClass, additionalProcessing) {
                var metaCtor = makeMetadataCtor(props);
                function PropDecoratorFactory() {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    if (this instanceof PropDecoratorFactory) {
                        metaCtor.apply(this, args);
                        return this;
                    }
                    var decoratorInstance = new (PropDecoratorFactory.bind.apply(PropDecoratorFactory, [void 0].concat(args)))();
                    function PropDecorator(target, name) {
                        var constructor = target.constructor;
                        // Use of Object.defineProperty is important since it creates non-enumerable property which
                        // prevents the property is copied during subclassing.
                        var meta = constructor.hasOwnProperty(PROP_METADATA) ?
                            constructor[PROP_METADATA] :
                            Object.defineProperty(constructor, PROP_METADATA, { value: {} })[PROP_METADATA];
                        meta[name] = meta.hasOwnProperty(name) && meta[name] || [];
                        meta[name].unshift(decoratorInstance);
                        if (additionalProcessing)
                            additionalProcessing.apply(void 0, [target, name].concat(args));
                    }
                    return PropDecorator;
                }
                if (parentClass) {
                    PropDecoratorFactory.prototype = Object.create(parentClass.prototype);
                }
                PropDecoratorFactory.prototype.ngMetadataName = name;
                PropDecoratorFactory.annotationCls = PropDecoratorFactory;
                return PropDecoratorFactory;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Type of the Inject decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function InjectDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ0 = /**
             * @param {?} token
             * @return {?}
             */ function (token) { return ({ token: token }); };
            /**
             * Inject decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Inject = makeParamDecorator('Inject', (ɵ0));
            /**
             * Type of the Optional decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function OptionalDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * Optional decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Optional = makeParamDecorator('Optional');
            /**
             * Type of the Self decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function SelfDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * Self decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Self = makeParamDecorator('Self');
            /**
             * Type of the SkipSelf decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function SkipSelfDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * SkipSelf decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var SkipSelf = makeParamDecorator('SkipSelf');
            /**
             * Type of the Host decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function HostDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * Host decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Host = makeParamDecorator('Host');
            /**
             * Type of the Attribute decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function AttributeDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ1 = /**
             * @param {?=} attributeName
             * @return {?}
             */ function (attributeName) { return ({ attributeName: attributeName }); };
            /**
             * Attribute decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Attribute = makeParamDecorator('Attribute', (ɵ1));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Injection flags for DI.
             *
             * @publicApi
             */
            var InjectFlags;
            (function (InjectFlags) {
                // TODO(alxhub): make this 'const' when ngc no longer writes exports of it into ngfactory files.
                /** Check self and check parent injector if needed */
                InjectFlags[InjectFlags["Default"] = 0] = "Default";
                /**
                 * Specifies that an injector should retrieve a dependency from any injector until reaching the
                 * host element of the current component. (Only used with Element Injector)
                 */
                InjectFlags[InjectFlags["Host"] = 1] = "Host";
                /** Don't ascend to ancestors of the node requesting injection. */
                InjectFlags[InjectFlags["Self"] = 2] = "Self";
                /** Skip the node that is requesting injection. */
                InjectFlags[InjectFlags["SkipSelf"] = 4] = "SkipSelf";
                /** Inject `defaultValue` instead if token not found. */
                InjectFlags[InjectFlags["Optional"] = 8] = "Optional";
            })(InjectFlags || (InjectFlags = {}));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function getClosureSafeProperty(objWithPropertyToExtract) {
                for (var key in objWithPropertyToExtract) {
                    if (objWithPropertyToExtract[key] === getClosureSafeProperty) {
                        return key;
                    }
                }
                throw Error('Could not find renamed property on target object.');
            }
            /**
             * Sets properties on a target object from a source object, but only if
             * the property doesn't already exist on the target object.
             * @param target The target to set properties on
             * @param source The source of the property keys and values to set
             */
            function fillProperties(target, source) {
                for (var key in source) {
                    if (source.hasOwnProperty(key) && !target.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Construct an `InjectableDef` which defines how a token will be constructed by the DI system, and
             * in which injectors (if any) it will be available.
             *
             * This should be assigned to a static `ngInjectableDef` field on a type, which will then be an
             * `InjectableType`.
             *
             * Options:
             * * `providedIn` determines which injectors will include the injectable, by either associating it
             *   with an `@NgModule` or other `InjectorType`, or by specifying that this injectable should be
             *   provided in the `'root'` injector, which will be the application-level injector in most apps.
             * * `factory` gives the zero argument function which will create an instance of the injectable.
             *   The factory can call `inject` to access the `Injector` and request injection of dependencies.
             *
             * @codeGenApi
             */
            function ɵɵdefineInjectable(opts) {
                return {
                    token: opts.token, providedIn: opts.providedIn || null, factory: opts.factory,
                    value: undefined,
                };
            }
            /**
             * @deprecated in v8, delete after v10. This API should be used only be generated code, and that
             * code should now use ɵɵdefineInjectable instead.
             * @publicApi
             */
            var defineInjectable = ɵɵdefineInjectable;
            /**
             * Construct an `InjectorDef` which configures an injector.
             *
             * This should be assigned to a static `ngInjectorDef` field on a type, which will then be an
             * `InjectorType`.
             *
             * Options:
             *
             * * `factory`: an `InjectorType` is an instantiable type, so a zero argument `factory` function to
             *   create the type must be provided. If that factory function needs to inject arguments, it can
             *   use the `inject` function.
             * * `providers`: an optional array of providers to add to the injector. Each provider must
             *   either have a factory or point to a type which has an `ngInjectableDef` static property (the
             *   type must be an `InjectableType`).
             * * `imports`: an optional array of imports of other `InjectorType`s or `InjectorTypeWithModule`s
             *   whose providers will also be added to the injector. Locally provided types will override
             *   providers from imports.
             *
             * @publicApi
             */
            function ɵɵdefineInjector(options) {
                return {
                    factory: options.factory, providers: options.providers || [], imports: options.imports || [],
                };
            }
            /**
             * Read the `ngInjectableDef` for `type` in a way which is immune to accidentally reading inherited
             * value.
             *
             * @param type A type which may have its own (non-inherited) `ngInjectableDef`.
             */
            function getInjectableDef(type) {
                var def = type[NG_INJECTABLE_DEF];
                // The definition read above may come from a base class. `hasOwnProperty` is not sufficient to
                // distinguish this case, as in older browsers (e.g. IE10) static property inheritance is
                // implemented by copying the properties.
                //
                // Instead, the ngInjectableDef's token is compared to the type, and if they don't match then the
                // property was not defined directly on the type itself, and was likely inherited. The definition
                // is only returned if the type matches the def.token.
                return def && def.token === type ? def : null;
            }
            /**
             * Read the `ngInjectableDef` for `type` or read the `ngInjectableDef` from one of its ancestors.
             *
             * @param type A type which may have `ngInjectableDef`, via inheritance.
             *
             * @deprecated Will be removed in v10, where an error will occur in the scenario if we find the
             * `ngInjectableDef` on an ancestor only.
             */
            function getInheritedInjectableDef(type) {
                if (type && type[NG_INJECTABLE_DEF]) {
                    // TODO(FW-1307): Re-add ngDevMode when closure can handle it
                    // ngDevMode &&
                    console.warn("DEPRECATED: DI is instantiating a token \"" + type.name + "\" that inherits its @Injectable decorator but does not provide one itself.\n" +
                        ("This will become an error in v10. Please add @Injectable() to the \"" + type.name + "\" class."));
                    return type[NG_INJECTABLE_DEF];
                }
                else {
                    return null;
                }
            }
            /**
             * Read the `ngInjectorDef` type in a way which is immune to accidentally reading inherited value.
             *
             * @param type type which may have `ngInjectorDef`
             */
            function getInjectorDef(type) {
                return type && type.hasOwnProperty(NG_INJECTOR_DEF) ? type[NG_INJECTOR_DEF] : null;
            }
            var NG_INJECTABLE_DEF = getClosureSafeProperty({ ngInjectableDef: getClosureSafeProperty });
            var NG_INJECTOR_DEF = getClosureSafeProperty({ ngInjectorDef: getClosureSafeProperty });
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function stringify(token) {
                if (typeof token === 'string') {
                    return token;
                }
                if (token instanceof Array) {
                    return '[' + token.map(stringify).join(', ') + ']';
                }
                if (token == null) {
                    return '' + token;
                }
                if (token.overriddenName) {
                    return "" + token.overriddenName;
                }
                if (token.name) {
                    return "" + token.name;
                }
                var res = token.toString();
                if (res == null) {
                    return '' + res;
                }
                var newLineIndex = res.indexOf('\n');
                return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An interface that a function passed into {\@link forwardRef} has to implement.
             *
             * \@usageNotes
             * ### Example
             *
             * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref_fn'}
             * \@publicApi
             * @record
             */
            function ForwardRefFn() { }
            /** @type {?} */
            var __forward_ref__ = getClosureSafeProperty({ __forward_ref__: getClosureSafeProperty });
            /**
             * Allows to refer to references which are not yet defined.
             *
             * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
             * DI is declared, but not yet defined. It is also used when the `token` which we use when creating
             * a query is not yet defined.
             *
             * \@usageNotes
             * ### Example
             * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref'}
             * \@publicApi
             * @param {?} forwardRefFn
             * @return {?}
             */
            function forwardRef(forwardRefFn) {
                (( /** @type {?} */(forwardRefFn))).__forward_ref__ = forwardRef;
                (( /** @type {?} */(forwardRefFn))).toString = ( /**
                 * @return {?}
                 */function () { return stringify(this()); });
                return (( /** @type {?} */(( /** @type {?} */(forwardRefFn)))));
            }
            /**
             * Lazily retrieves the reference value from a forwardRef.
             *
             * Acts as the identity function when given a non-forward-ref value.
             *
             * \@usageNotes
             * ### Example
             *
             * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='resolve_forward_ref'}
             *
             * @see `forwardRef`
             * \@publicApi
             * @template T
             * @param {?} type
             * @return {?}
             */
            function resolveForwardRef(type) {
                /** @type {?} */
                var fn = type;
                if (typeof fn === 'function' && fn.hasOwnProperty(__forward_ref__) &&
                    fn.__forward_ref__ === forwardRef) {
                    return fn();
                }
                else {
                    return type;
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var __globalThis = typeof globalThis !== 'undefined' && globalThis;
            var __window = typeof window !== 'undefined' && window;
            var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
                self instanceof WorkerGlobalScope && self;
            var __global = typeof global !== 'undefined' && global;
            // Always use __globalThis if available, which is the spec-defined global variable across all
            // environments, then fallback to __global first, because in Node tests both __global and
            // __window may be defined and _global should be __global in that case.
            var _global = __globalThis || __global || __window || __self;
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var R3ResolvedDependencyType;
            (function (R3ResolvedDependencyType) {
                R3ResolvedDependencyType[R3ResolvedDependencyType["Token"] = 0] = "Token";
                R3ResolvedDependencyType[R3ResolvedDependencyType["Attribute"] = 1] = "Attribute";
                R3ResolvedDependencyType[R3ResolvedDependencyType["ChangeDetectorRef"] = 2] = "ChangeDetectorRef";
            })(R3ResolvedDependencyType || (R3ResolvedDependencyType = {}));
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function getCompilerFacade() {
                var globalNg = _global['ng'];
                if (!globalNg || !globalNg.ɵcompilerFacade) {
                    throw new Error("Angular JIT compilation failed: '@angular/compiler' not loaded!\n" +
                        "  - JIT compilation is discouraged for production use-cases! Consider AOT mode instead.\n" +
                        "  - Did you bootstrap using '@angular/platform-browser-dynamic' or '@angular/platform-server'?\n" +
                        "  - Alternatively provide the compiler with 'import \"@angular/compiler\";' before bootstrapping.");
                }
                return globalNg.ɵcompilerFacade;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Creates a token that can be used in a DI Provider.
             *
             * Use an `InjectionToken` whenever the type you are injecting is not reified (does not have a
             * runtime representation) such as when injecting an interface, callable type, array or
             * parameterized type.
             *
             * `InjectionToken` is parameterized on `T` which is the type of object which will be returned by
             * the `Injector`. This provides additional level of type safety.
             *
             * ```
             * interface MyInterface {...}
             * var myInterface = injector.get(new InjectionToken<MyInterface>('SomeToken'));
             * // myInterface is inferred to be MyInterface.
             * ```
             *
             * When creating an `InjectionToken`, you can optionally specify a factory function which returns
             * (possibly by creating) a default value of the parameterized type `T`. This sets up the
             * `InjectionToken` using this factory as a provider as if it was defined explicitly in the
             * application's root injector. If the factory function, which takes zero arguments, needs to inject
             * dependencies, it can do so using the `inject` function. See below for an example.
             *
             * Additionally, if a `factory` is specified you can also specify the `providedIn` option, which
             * overrides the above behavior and marks the token as belonging to a particular `\@NgModule`. As
             * mentioned above, `'root'` is the default value for `providedIn`.
             *
             * \@usageNotes
             * ### Basic Example
             *
             * ### Plain InjectionToken
             *
             * {\@example core/di/ts/injector_spec.ts region='InjectionToken'}
             *
             * ### Tree-shakable InjectionToken
             *
             * {\@example core/di/ts/injector_spec.ts region='ShakableInjectionToken'}
             *
             *
             * \@publicApi
             * @template T
             */
            var InjectionToken = /** @class */ (function () {
                /**
                 * @param {?} _desc
                 * @param {?=} options
                 */
                function InjectionToken(_desc, options) {
                    this._desc = _desc;
                    /**
                     * \@internal
                     */
                    this.ngMetadataName = 'InjectionToken';
                    /** @nocollapse */ this.ngInjectableDef = undefined;
                    if (typeof options == 'number') {
                        // This is a special hack to assign __NG_ELEMENT_ID__ to this instance.
                        // __NG_ELEMENT_ID__ is Used by Ivy to determine bloom filter id.
                        // We are using it to assign `-1` which is used to identify `Injector`.
                        (( /** @type {?} */(this))).__NG_ELEMENT_ID__ = options;
                    }
                    else if (options !== undefined) {
                        /** @nocollapse */ this.ngInjectableDef = ɵɵdefineInjectable({
                            token: this,
                            providedIn: options.providedIn || 'root',
                            factory: options.factory,
                        });
                    }
                }
                /**
                 * @return {?}
                 */
                InjectionToken.prototype.toString = function () { return "InjectionToken " + this._desc; };
                return InjectionToken;
            }());
            if (false) { }
            /**
             * @record
             * @template T
             */
            function InjectableDefToken() { }
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An InjectionToken that gets the current `Injector` for `createInjector()`-style injectors.
             *
             * Requesting this token instead of `Injector` allows `StaticInjector` to be tree-shaken from a
             * project.
             *
             * \@publicApi
             * @type {?}
             */
            var INJECTOR = new InjectionToken('INJECTOR', ( /** @type {?} */(-1)));
            /** @type {?} */
            var _THROW_IF_NOT_FOUND = new Object();
            /** @type {?} */
            var THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
            /** @type {?} */
            var NG_TEMP_TOKEN_PATH = 'ngTempTokenPath';
            /** @type {?} */
            var NG_TOKEN_PATH = 'ngTokenPath';
            /** @type {?} */
            var NEW_LINE = /\n/gm;
            /** @type {?} */
            var NO_NEW_LINE = 'ɵ';
            /** @type {?} */
            var SOURCE = '__source';
            var ɵ0$1 = getClosureSafeProperty;
            /** @type {?} */
            var USE_VALUE = getClosureSafeProperty({ provide: String, useValue: ɵ0$1 });
            /**
             * Current injector value used by `inject`.
             * - `undefined`: it is an error to call `inject`
             * - `null`: `inject` can be called but there is no injector (limp-mode).
             * - Injector instance: Use the injector for resolution.
             * @type {?}
             */
            var _currentInjector = undefined;
            /**
             * @param {?} injector
             * @return {?}
             */
            function setCurrentInjector(injector) {
                /** @type {?} */
                var former = _currentInjector;
                _currentInjector = injector;
                return former;
            }
            /**
             * Current implementation of inject.
             *
             * By default, it is `injectInjectorOnly`, which makes it `Injector`-only aware. It can be changed
             * to `directiveInject`, which brings in the `NodeInjector` system of ivy. It is designed this
             * way for two reasons:
             *  1. `Injector` should not depend on ivy logic.
             *  2. To maintain tree shake-ability we don't want to bring in unnecessary code.
             * @type {?}
             */
            var _injectImplementation;
            /**
             * Sets the current inject implementation.
             * @param {?} impl
             * @return {?}
             */
            function setInjectImplementation(impl) {
                /** @type {?} */
                var previous = _injectImplementation;
                _injectImplementation = impl;
                return previous;
            }
            /**
             * @template T
             * @param {?} token
             * @param {?=} flags
             * @return {?}
             */
            function injectInjectorOnly(token, flags) {
                if (flags === void 0) { flags = InjectFlags.Default; }
                if (_currentInjector === undefined) {
                    throw new Error("inject() must be called from an injection context");
                }
                else if (_currentInjector === null) {
                    return injectRootLimpMode(token, undefined, flags);
                }
                else {
                    return _currentInjector.get(token, flags & InjectFlags.Optional ? null : undefined, flags);
                }
            }
            /**
             * @template T
             * @param {?} token
             * @param {?=} flags
             * @return {?}
             */
            function ɵɵinject(token, flags) {
                if (flags === void 0) { flags = InjectFlags.Default; }
                return (_injectImplementation || injectInjectorOnly)(token, flags);
            }
            /**
             * Injects a token from the currently active injector.
             *
             * Must be used in the context of a factory function such as one defined for an
             * `InjectionToken`. Throws an error if not called from such a context.
             *
             * Within such a factory function, using this function to request injection of a dependency
             * is faster and more type-safe than providing an additional array of dependencies
             * (as has been common with `useFactory` providers).
             *
             * \@param token The injection token for the dependency to be injected.
             * \@param flags Optional flags that control how injection is executed.
             * The flags correspond to injection strategies that can be specified with
             * parameter decorators `\@Host`, `\@Self`, `\@SkipSef`, and `\@Optional`.
             * \@return True if injection is successful, null otherwise.
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example core/di/ts/injector_spec.ts region='ShakableInjectionToken'}
             *
             * \@publicApi
             * @type {?}
             */
            var inject = ɵɵinject;
            /**
             * Injects `root` tokens in limp mode.
             *
             * If no injector exists, we can still inject tree-shakable providers which have `providedIn` set to
             * `"root"`. This is known as the limp mode injection. In such case the value is stored in the
             * `InjectableDef`.
             * @template T
             * @param {?} token
             * @param {?} notFoundValue
             * @param {?} flags
             * @return {?}
             */
            function injectRootLimpMode(token, notFoundValue, flags) {
                /** @type {?} */
                var injectableDef = getInjectableDef(token);
                if (injectableDef && injectableDef.providedIn == 'root') {
                    return injectableDef.value === undefined ? injectableDef.value = injectableDef.factory() :
                        injectableDef.value;
                }
                if (flags & InjectFlags.Optional)
                    return null;
                if (notFoundValue !== undefined)
                    return notFoundValue;
                throw new Error("Injector: NOT_FOUND [" + stringify(token) + "]");
            }
            /**
             * @param {?} types
             * @return {?}
             */
            function injectArgs(types) {
                /** @type {?} */
                var args = [];
                for (var i = 0; i < types.length; i++) {
                    /** @type {?} */
                    var arg = resolveForwardRef(types[i]);
                    if (Array.isArray(arg)) {
                        if (arg.length === 0) {
                            throw new Error('Arguments array must have arguments.');
                        }
                        /** @type {?} */
                        var type = undefined;
                        /** @type {?} */
                        var flags = InjectFlags.Default;
                        for (var j = 0; j < arg.length; j++) {
                            /** @type {?} */
                            var meta = arg[j];
                            if (meta instanceof Optional || meta.ngMetadataName === 'Optional' || meta === Optional) {
                                flags |= InjectFlags.Optional;
                            }
                            else if (meta instanceof SkipSelf || meta.ngMetadataName === 'SkipSelf' || meta === SkipSelf) {
                                flags |= InjectFlags.SkipSelf;
                            }
                            else if (meta instanceof Self || meta.ngMetadataName === 'Self' || meta === Self) {
                                flags |= InjectFlags.Self;
                            }
                            else if (meta instanceof Inject || meta === Inject) {
                                type = meta.token;
                            }
                            else {
                                type = meta;
                            }
                        }
                        args.push(ɵɵinject(( /** @type {?} */(type)), flags));
                    }
                    else {
                        args.push(ɵɵinject(arg));
                    }
                }
                return args;
            }
            var NullInjector = /** @class */ (function () {
                function NullInjector() {
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @return {?}
                 */
                NullInjector.prototype.get = function (token, notFoundValue) {
                    if (notFoundValue === void 0) { notFoundValue = THROW_IF_NOT_FOUND; }
                    if (notFoundValue === THROW_IF_NOT_FOUND) {
                        // Intentionally left behind: With dev tools open the debugger will stop here. There is no
                        // reason why correctly written application should cause this exception.
                        // TODO(misko): uncomment the next line once `ngDevMode` works with closure.
                        // if(ngDevMode) debugger;
                        /** @type {?} */
                        var error = new Error("NullInjectorError: No provider for " + stringify(token) + "!");
                        error.name = 'NullInjectorError';
                        throw error;
                    }
                    return notFoundValue;
                };
                return NullInjector;
            }());
            /**
             * @param {?} e
             * @param {?} token
             * @param {?} injectorErrorName
             * @param {?} source
             * @return {?}
             */
            function catchInjectorError(e, token, injectorErrorName, source) {
                /** @type {?} */
                var tokenPath = e[NG_TEMP_TOKEN_PATH];
                if (token[SOURCE]) {
                    tokenPath.unshift(token[SOURCE]);
                }
                e.message = formatError('\n' + e.message, tokenPath, injectorErrorName, source);
                e[NG_TOKEN_PATH] = tokenPath;
                e[NG_TEMP_TOKEN_PATH] = null;
                throw e;
            }
            /**
             * @param {?} text
             * @param {?} obj
             * @param {?} injectorErrorName
             * @param {?=} source
             * @return {?}
             */
            function formatError(text, obj, injectorErrorName, source) {
                if (source === void 0) { source = null; }
                text = text && text.charAt(0) === '\n' && text.charAt(1) == NO_NEW_LINE ? text.substr(2) : text;
                /** @type {?} */
                var context = stringify(obj);
                if (obj instanceof Array) {
                    context = obj.map(stringify).join(' -> ');
                }
                else if (typeof obj === 'object') {
                    /** @type {?} */
                    var parts = ( /** @type {?} */([]));
                    for (var key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            /** @type {?} */
                            var value = obj[key];
                            parts.push(key + ':' + (typeof value === 'string' ? JSON.stringify(value) : stringify(value)));
                        }
                    }
                    context = "{" + parts.join(', ') + "}";
                }
                return "" + injectorErrorName + (source ? '(' + source + ')' : '') + "[" + context + "]: " + text.replace(NEW_LINE, '\n  ');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A mapping of the \@angular/core API surface used in generated expressions to the actual symbols.
             *
             * This should be kept up to date with the public exports of \@angular/core.
             * @type {?}
             */
            var angularCoreDiEnv = {
                'ɵɵdefineInjectable': ɵɵdefineInjectable,
                'ɵɵdefineInjector': ɵɵdefineInjector,
                'ɵɵinject': ɵɵinject,
                'ɵɵgetFactoryOf': getFactoryOf,
            };
            /**
             * @template T
             * @param {?} type
             * @return {?}
             */
            function getFactoryOf(type) {
                /** @type {?} */
                var typeAny = ( /** @type {?} */(type));
                /** @type {?} */
                var def = getInjectableDef(typeAny) || getInjectorDef(typeAny);
                if (!def || def.factory === undefined) {
                    return null;
                }
                return def.factory;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Represents an instance of an NgModule created via a {\@link NgModuleFactory}.
             *
             * `NgModuleRef` provides access to the NgModule Instance as well other objects related to this
             * NgModule Instance.
             *
             * \@publicApi
             * @abstract
             * @template T
             */
            var NgModuleRef = /** @class */ (function () {
                function NgModuleRef() {
                }
                return NgModuleRef;
            }());
            if (false) { }
            /**
             * @record
             * @template T
             */
            function InternalNgModuleRef() { }
            if (false) { }
            /**
             * \@publicApi
             * @abstract
             * @template T
             */
            var NgModuleFactory = /** @class */ (function () {
                function NgModuleFactory() {
                }
                return NgModuleFactory;
            }());
            if (false) { }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
            * Equivalent to ES6 spread, add each item to an array.
            *
            * @param items The items to add
            * @param arr The array to which you want to add the items
            */
            function addAllToArray(items, arr) {
                for (var i = 0; i < items.length; i++) {
                    arr.push(items[i]);
                }
            }
            /**
             * Flattens an array.
             */
            function flatten(list, dst) {
                if (dst === undefined)
                    dst = list;
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    if (Array.isArray(item)) {
                        // we need to inline it.
                        if (dst === list) {
                            // Our assumption that the list was already flat was wrong and
                            // we need to clone flat since we need to write to it.
                            dst = list.slice(0, i);
                        }
                        flatten(item, dst);
                    }
                    else if (dst !== list) {
                        dst.push(item);
                    }
                }
                return dst;
            }
            function deepForEach(input, fn) {
                input.forEach(function (value) { return Array.isArray(value) ? deepForEach(value, fn) : fn(value); });
            }
            function addToArray(arr, index, value) {
                // perf: array.push is faster than array.splice!
                if (index >= arr.length) {
                    arr.push(value);
                }
                else {
                    arr.splice(index, 0, value);
                }
            }
            function removeFromArray(arr, index) {
                // perf: array.pop is faster than array.splice!
                if (index >= arr.length - 1) {
                    return arr.pop();
                }
                else {
                    return arr.splice(index, 1)[0];
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function assertNumber(actual, msg) {
                if (typeof actual != 'number') {
                    throwError(msg);
                }
            }
            function assertEqual(actual, expected, msg) {
                if (actual != expected) {
                    throwError(msg);
                }
            }
            function assertNotEqual(actual, expected, msg) {
                if (actual == expected) {
                    throwError(msg);
                }
            }
            function assertSame(actual, expected, msg) {
                if (actual !== expected) {
                    throwError(msg);
                }
            }
            function assertNotSame(actual, expected, msg) {
                if (actual === expected) {
                    throwError(msg);
                }
            }
            function assertLessThan(actual, expected, msg) {
                if (actual >= expected) {
                    throwError(msg);
                }
            }
            function assertGreaterThan(actual, expected, msg) {
                if (actual <= expected) {
                    throwError(msg);
                }
            }
            function assertNotDefined(actual, msg) {
                if (actual != null) {
                    throwError(msg);
                }
            }
            function assertDefined(actual, msg) {
                if (actual == null) {
                    throwError(msg);
                }
            }
            function throwError(msg) {
                // tslint:disable-next-line
                debugger; // Left intentionally for better debugger experience.
                throw new Error("ASSERTION ERROR: " + msg);
            }
            function assertDomNode(node) {
                // If we're in a worker, `Node` will not be defined.
                assertEqual((typeof Node !== 'undefined' && node instanceof Node) ||
                    (typeof node === 'object' && node != null &&
                        node.constructor.name === 'WebWorkerRenderNode'), true, "The provided value must be an instance of a DOM Node but got " + stringify(node));
            }
            function assertDataInRange(arr, index) {
                var maxLen = arr ? arr.length : 0;
                assertLessThan(index, maxLen, "Index expected to be less than " + maxLen + " but got " + index);
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function ngDevModeResetPerfCounters() {
                var locationString = typeof location !== 'undefined' ? location.toString() : '';
                var newCounters = {
                    namedConstructors: locationString.indexOf('ngDevMode=namedConstructors') != -1,
                    firstTemplatePass: 0,
                    tNode: 0,
                    tView: 0,
                    rendererCreateTextNode: 0,
                    rendererSetText: 0,
                    rendererCreateElement: 0,
                    rendererAddEventListener: 0,
                    rendererSetAttribute: 0,
                    rendererRemoveAttribute: 0,
                    rendererSetProperty: 0,
                    rendererSetClassName: 0,
                    rendererAddClass: 0,
                    rendererRemoveClass: 0,
                    rendererSetStyle: 0,
                    rendererRemoveStyle: 0,
                    rendererDestroy: 0,
                    rendererDestroyNode: 0,
                    rendererMoveNode: 0,
                    rendererRemoveNode: 0,
                    rendererAppendChild: 0,
                    rendererInsertBefore: 0,
                    rendererCreateComment: 0,
                    styleMap: 0,
                    styleMapCacheMiss: 0,
                    classMap: 0,
                    classMapCacheMiss: 0,
                    styleProp: 0,
                    stylePropCacheMiss: 0,
                    classProp: 0,
                    classPropCacheMiss: 0,
                    flushStyling: 0,
                    classesApplied: 0,
                    stylesApplied: 0,
                    stylingWritePersistedState: 0,
                    stylingReadPersistedState: 0,
                };
                // Make sure to refer to ngDevMode as ['ngDevMode'] for closure.
                var allowNgDevModeTrue = locationString.indexOf('ngDevMode=false') === -1;
                _global['ngDevMode'] = allowNgDevModeTrue && newCounters;
                return newCounters;
            }
            /**
             * This checks to see if the `ngDevMode` has been set. If yes,
             * then we honor it, otherwise we default to dev mode with additional checks.
             *
             * The idea is that unless we are doing production build where we explicitly
             * set `ngDevMode == false` we should be helping the developer by providing
             * as much early warning and errors as possible.
             *
             * NOTE: changes to the `ngDevMode` name must be synced with `compiler-cli/src/tooling.ts`.
             */
            if (typeof ngDevMode === 'undefined' || ngDevMode) {
                ngDevModeResetPerfCounters();
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @enum {number} */
            var ChangeDetectionStrategy = {
                /**
                 * Use the `CheckOnce` strategy, meaning that automatic change detection is deactivated
                 * until reactivated by setting the strategy to `Default` (`CheckAlways`).
                 * Change detection can still be explicitly invoked.
                 * This strategy applies to all child directives and cannot be overridden.
                 */
                OnPush: 0,
                /**
                 * Use the default `CheckAlways` strategy, in which change detection is automatic until
                 * explicitly deactivated.
                 */
                Default: 1,
            };
            ChangeDetectionStrategy[ChangeDetectionStrategy.OnPush] = 'OnPush';
            ChangeDetectionStrategy[ChangeDetectionStrategy.Default] = 'Default';
            /** @enum {number} */
            var ChangeDetectorStatus = {
                /**
                 * A state in which, after calling `detectChanges()`, the change detector
                 * state becomes `Checked`, and must be explicitly invoked or reactivated.
                 */
                CheckOnce: 0,
                /**
                 * A state in which change detection is skipped until the change detector mode
                 * becomes `CheckOnce`.
                 */
                Checked: 1,
                /**
                 * A state in which change detection continues automatically until explicitly
                 * deactivated.
                 */
                CheckAlways: 2,
                /**
                 * A state in which a change detector sub tree is not a part of the main tree and
                 * should be skipped.
                 */
                Detached: 3,
                /**
                 * Indicates that the change detector encountered an error checking a binding
                 * or calling a directive lifecycle method and is now in an inconsistent state. Change
                 * detectors in this state do not detect changes.
                 */
                Errored: 4,
                /**
                 * Indicates that the change detector has been destroyed.
                 */
                Destroyed: 5,
            };
            ChangeDetectorStatus[ChangeDetectorStatus.CheckOnce] = 'CheckOnce';
            ChangeDetectorStatus[ChangeDetectorStatus.Checked] = 'Checked';
            ChangeDetectorStatus[ChangeDetectorStatus.CheckAlways] = 'CheckAlways';
            ChangeDetectorStatus[ChangeDetectorStatus.Detached] = 'Detached';
            ChangeDetectorStatus[ChangeDetectorStatus.Errored] = 'Errored';
            ChangeDetectorStatus[ChangeDetectorStatus.Destroyed] = 'Destroyed';
            /**
             * Reports whether a given strategy is currently the default for change detection.
             * @see `ChangeDetectorStatus` / `ChangeDetectorRef`
             * @param {?} changeDetectionStrategy The strategy to check.
             * @return {?} True if the given strategy is the current default, false otherwise.
             */
            function isDefaultChangeDetectionStrategy(changeDetectionStrategy) {
                return changeDetectionStrategy == null ||
                    changeDetectionStrategy === ChangeDetectionStrategy.Default;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @enum {number} */
            var ViewEncapsulation = {
                /**
                 * Emulate `Native` scoping of styles by adding an attribute containing surrogate id to the Host
                 * Element and pre-processing the style rules provided via {@link Component#styles styles} or
                 * {@link Component#styleUrls styleUrls}, and adding the new Host Element attribute to all
                 * selectors.
                 *
                 * This is the default option.
                 */
                Emulated: 0,
                /**
                 * @deprecated v6.1.0 - use {ViewEncapsulation.ShadowDom} instead.
                 * Use the native encapsulation mechanism of the renderer.
                 *
                 * For the DOM this means using the deprecated [Shadow DOM
                 * v0](https://w3c.github.io/webcomponents/spec/shadow/) and
                 * creating a ShadowRoot for Component's Host Element.
                 */
                Native: 1,
                /**
                 * Don't provide any template or style encapsulation.
                 */
                None: 2,
                /**
                 * Use Shadow DOM to encapsulate styles.
                 *
                 * For the DOM this means using modern [Shadow
                 * DOM](https://w3c.github.io/webcomponents/spec/shadow/) and
                 * creating a ShadowRoot for Component's Host Element.
                 */
                ShadowDom: 3,
            };
            ViewEncapsulation[ViewEncapsulation.Emulated] = 'Emulated';
            ViewEncapsulation[ViewEncapsulation.Native] = 'Native';
            ViewEncapsulation[ViewEncapsulation.None] = 'None';
            ViewEncapsulation[ViewEncapsulation.ShadowDom] = 'ShadowDom';
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Convince closure compiler that the wrapped function has no side-effects.
             *
             * Closure compiler always assumes that `toString` has no side-effects. We use this quirk to
             * allow us to execute a function but have closure compiler mark the call as no-side-effects.
             * It is important that the return value for the `noSideEffects` function be assigned
             * to something which is retained otherwise the call to `noSideEffects` will be removed by closure
             * compiler.
             */
            function noSideEffects(fn) {
                return '' + { toString: fn };
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This file contains reuseable "empty" symbols that can be used as default return values
             * in different parts of the rendering code. Because the same symbols are returned, this
             * allows for identity checks against these values to be consistently used by the framework
             * code.
             * @type {?}
             */
            var EMPTY_OBJ = {};
            /** @type {?} */
            var EMPTY_ARRAY = [];
            // freezing the values prevents any code from accidentally inserting new values in
            if (typeof ngDevMode !== 'undefined' && ngDevMode) {
                // These property accesses can be ignored because ngDevMode will be set to false
                // when optimizing code and the whole if statement will be dropped.
                // tslint:disable-next-line:no-toplevel-property-access
                Object.freeze(EMPTY_OBJ);
                // tslint:disable-next-line:no-toplevel-property-access
                Object.freeze(EMPTY_ARRAY);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var NG_COMPONENT_DEF = getClosureSafeProperty({ ngComponentDef: getClosureSafeProperty });
            /** @type {?} */
            var NG_DIRECTIVE_DEF = getClosureSafeProperty({ ngDirectiveDef: getClosureSafeProperty });
            /** @type {?} */
            var NG_PIPE_DEF = getClosureSafeProperty({ ngPipeDef: getClosureSafeProperty });
            /** @type {?} */
            var NG_MODULE_DEF = getClosureSafeProperty({ ngModuleDef: getClosureSafeProperty });
            /** @type {?} */
            var NG_LOCALE_ID_DEF = getClosureSafeProperty({ ngLocaleIdDef: getClosureSafeProperty });
            /** @type {?} */
            var NG_BASE_DEF = getClosureSafeProperty({ ngBaseDef: getClosureSafeProperty });
            // TODO(misko): This is wrong. The NG_ELEMENT_ID should never be minified.
            /**
             * If a directive is diPublic, bloomAdd sets a property on the type with this constant as
             * the key and the directive's unique ID as the value. This allows us to map directives to their
             * bloom filter bit for DI.
             * @type {?}
             */
            var NG_ELEMENT_ID = getClosureSafeProperty({ __NG_ELEMENT_ID__: getClosureSafeProperty });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _renderCompCount = 0;
            /**
             * Create a component definition object.
             *
             *
             * # Example
             * ```
             * class MyDirective {
             *   // Generated by Angular Template Compiler
             *   // [Symbol] syntax will not be supported by TypeScript until v2.7
             *   static ngComponentDef = defineComponent({
             *     ...
             *   });
             * }
             * ```
             * \@codeGenApi
             * @template T
             * @param {?} componentDefinition
             * @return {?}
             */
            function ɵɵdefineComponent(componentDefinition) {
                /** @type {?} */
                var type = componentDefinition.type;
                /** @type {?} */
                var typePrototype = type.prototype;
                /** @type {?} */
                var declaredInputs = ( /** @type {?} */({}));
                /** @type {?} */
                var def = {
                    type: type,
                    providersResolver: null,
                    consts: componentDefinition.consts,
                    vars: componentDefinition.vars,
                    factory: componentDefinition.factory,
                    template: componentDefinition.template || ( /** @type {?} */(null)),
                    ngContentSelectors: componentDefinition.ngContentSelectors,
                    hostBindings: componentDefinition.hostBindings || null,
                    contentQueries: componentDefinition.contentQueries || null,
                    declaredInputs: declaredInputs,
                    inputs: ( /** @type {?} */(null)),
                    // assigned in noSideEffects
                    outputs: ( /** @type {?} */(null)),
                    // assigned in noSideEffects
                    exportAs: componentDefinition.exportAs || null,
                    onChanges: null,
                    onInit: typePrototype.ngOnInit || null,
                    doCheck: typePrototype.ngDoCheck || null,
                    afterContentInit: typePrototype.ngAfterContentInit || null,
                    afterContentChecked: typePrototype.ngAfterContentChecked || null,
                    afterViewInit: typePrototype.ngAfterViewInit || null,
                    afterViewChecked: typePrototype.ngAfterViewChecked || null,
                    onDestroy: typePrototype.ngOnDestroy || null,
                    onPush: componentDefinition.changeDetection === ChangeDetectionStrategy.OnPush,
                    directiveDefs: ( /** @type {?} */(null)),
                    // assigned in noSideEffects
                    pipeDefs: ( /** @type {?} */(null)),
                    // assigned in noSideEffects
                    selectors: componentDefinition.selectors,
                    viewQuery: componentDefinition.viewQuery || null,
                    features: ( /** @type {?} */(componentDefinition.features)) || null,
                    data: componentDefinition.data || {},
                    // TODO(misko): convert ViewEncapsulation into const enum so that it can be used directly in the
                    // next line. Also `None` should be 0 not 2.
                    encapsulation: componentDefinition.encapsulation || ViewEncapsulation.Emulated,
                    id: 'c',
                    styles: componentDefinition.styles || EMPTY_ARRAY,
                    _: ( /** @type {?} */(null)),
                    setInput: null,
                    schemas: componentDefinition.schemas || null,
                    tView: null,
                };
                def._ = ( /** @type {?} */(noSideEffects(( /**
                 * @return {?}
                 */function () {
                    /** @type {?} */
                    var directiveTypes = ( /** @type {?} */(componentDefinition.directives));
                    /** @type {?} */
                    var feature = componentDefinition.features;
                    /** @type {?} */
                    var pipeTypes = ( /** @type {?} */(componentDefinition.pipes));
                    def.id += _renderCompCount++;
                    def.inputs = invertObject(componentDefinition.inputs, declaredInputs),
                        def.outputs = invertObject(componentDefinition.outputs),
                        feature && feature.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (fn) { return fn(def); }));
                    def.directiveDefs = directiveTypes ?
                        ( /**
                         * @return {?}
                         */function () { return (typeof directiveTypes === 'function' ? directiveTypes() : directiveTypes)
                            .map(extractDirectiveDef); }) :
                        null;
                    def.pipeDefs = pipeTypes ?
                        ( /**
                         * @return {?}
                         */function () { return (typeof pipeTypes === 'function' ? pipeTypes() : pipeTypes).map(extractPipeDef); }) :
                        null;
                    // Add ngInjectableDef so components are reachable through the module injector by default
                    // (unless it has already been set by the @Injectable decorator). This is mostly to
                    // support injecting components in tests. In real application code, components should
                    // be retrieved through the node injector, so this isn't a problem.
                    if (!type.hasOwnProperty(NG_INJECTABLE_DEF)) {
                        (( /** @type {?} */(type)))[NG_INJECTABLE_DEF] =
                            ɵɵdefineInjectable({ token: type, factory: ( /** @type {?} */(componentDefinition.factory)) });
                    }
                }))));
                return ( /** @type {?} */(def));
            }
            /**
             * \@codeGenApi
             * @param {?} type
             * @param {?} directives
             * @param {?} pipes
             * @return {?}
             */
            function ɵɵsetComponentScope(type, directives, pipes) {
                /** @type {?} */
                var def = (( /** @type {?} */(type.ngComponentDef)));
                def.directiveDefs = ( /**
                 * @return {?}
                 */function () { return directives.map(extractDirectiveDef); });
                def.pipeDefs = ( /**
                 * @return {?}
                 */function () { return pipes.map(extractPipeDef); });
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function extractDirectiveDef(type) {
                /** @type {?} */
                var def = getComponentDef(type) || getDirectiveDef(type);
                if (ngDevMode && !def) {
                    throw new Error("'" + type.name + "' is neither 'ComponentType' or 'DirectiveType'.");
                }
                return ( /** @type {?} */(def));
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function extractPipeDef(type) {
                /** @type {?} */
                var def = getPipeDef(type);
                if (ngDevMode && !def) {
                    throw new Error("'" + type.name + "' is not a 'PipeType'.");
                }
                return ( /** @type {?} */(def));
            }
            /**
             * \@codeGenApi
             * @template T
             * @param {?} def
             * @return {?}
             */
            function ɵɵdefineNgModule(def) {
                /** @type {?} */
                var res = {
                    type: def.type,
                    bootstrap: def.bootstrap || EMPTY_ARRAY,
                    declarations: def.declarations || EMPTY_ARRAY,
                    imports: def.imports || EMPTY_ARRAY,
                    exports: def.exports || EMPTY_ARRAY,
                    transitiveCompileScopes: null,
                    schemas: def.schemas || null,
                    id: def.id || null,
                };
                return ( /** @type {?} */(res));
            }
            /**
             * Adds the module metadata that is necessary to compute the module's transitive scope to an
             * existing module definition.
             *
             * Scope metadata of modules is not used in production builds, so calls to this function can be
             * marked pure to tree-shake it from the bundle, allowing for all referenced declarations
             * to become eligible for tree-shaking as well.
             *
             * \@codeGenApi
             * @param {?} type
             * @param {?} scope
             * @return {?}
             */
            function ɵɵsetNgModuleScope(type, scope) {
                return ( /** @type {?} */(noSideEffects(( /**
                 * @return {?}
                 */function () {
                    /** @type {?} */
                    /** @nocollapse */ var ngModuleDef = getNgModuleDef(type, true);
                    ngModuleDef.declarations = scope.declarations || EMPTY_ARRAY;
                    ngModuleDef.imports = scope.imports || EMPTY_ARRAY;
                    ngModuleDef.exports = scope.exports || EMPTY_ARRAY;
                }))));
            }
            /**
             * Inverts an inputs or outputs lookup such that the keys, which were the
             * minified keys, are part of the values, and the values are parsed so that
             * the publicName of the property is the new key
             *
             * e.g. for
             *
             * ```
             * class Comp {
             * \@Input()
             *   propName1: string;
             *
             * \@Input('publicName2')
             *   declaredPropName2: number;
             * }
             * ```
             *
             * will be serialized as
             *
             * ```
             * {
             *   propName1: 'propName1',
             *   declaredPropName2: ['publicName2', 'declaredPropName2'],
             * }
             * ```
             *
             * which is than translated by the minifier as:
             *
             * ```
             * {
             *   minifiedPropName1: 'propName1',
             *   minifiedPropName2: ['publicName2', 'declaredPropName2'],
             * }
             * ```
             *
             * becomes: (public name => minifiedName)
             *
             * ```
             * {
             *  'propName1': 'minifiedPropName1',
             *  'publicName2': 'minifiedPropName2',
             * }
             * ```
             *
             * Optionally the function can take `secondary` which will result in: (public name => declared name)
             *
             * ```
             * {
             *  'propName1': 'propName1',
             *  'publicName2': 'declaredPropName2',
             * }
             * ```
             *
             * @template T
             * @param {?=} obj
             * @param {?=} secondary
             * @return {?}
             */
            function invertObject(obj, secondary) {
                if (obj == null)
                    return ( /** @type {?} */(EMPTY_OBJ));
                /** @type {?} */
                var newLookup = {};
                for (var minifiedKey in obj) {
                    if (obj.hasOwnProperty(minifiedKey)) {
                        /** @type {?} */
                        var publicName = ( /** @type {?} */(obj[minifiedKey]));
                        /** @type {?} */
                        var declaredName = publicName;
                        if (Array.isArray(publicName)) {
                            declaredName = publicName[1];
                            publicName = publicName[0];
                        }
                        newLookup[publicName] = minifiedKey;
                        if (secondary) {
                            (secondary[publicName] = ( /** @type {?} */(declaredName)));
                        }
                    }
                }
                return newLookup;
            }
            /**
             * Create a base definition
             *
             * # Example
             * ```ts
             * class ShouldBeInherited {
             *   static ngBaseDef = ɵɵdefineBase({
             *      ...
             *   })
             * }
             * ```
             *
             * \@codeGenApi
             * @template T
             * @param {?} baseDefinition The base definition parameters
             *
             * @return {?}
             */
            function ɵɵdefineBase(baseDefinition) {
                /** @type {?} */
                var declaredInputs = ( /** @type {?} */({}));
                return {
                    inputs: invertObject(( /** @type {?} */(baseDefinition.inputs)), declaredInputs),
                    declaredInputs: declaredInputs,
                    outputs: invertObject(( /** @type {?} */(baseDefinition.outputs))),
                    viewQuery: baseDefinition.viewQuery || null,
                    contentQueries: baseDefinition.contentQueries || null,
                    hostBindings: baseDefinition.hostBindings || null
                };
            }
            /**
             * Create a directive definition object.
             *
             * # Example
             * ```ts
             * class MyDirective {
             *   // Generated by Angular Template Compiler
             *   // [Symbol] syntax will not be supported by TypeScript until v2.7
             *   static ngDirectiveDef = ɵɵdefineDirective({
             *     ...
             *   });
             * }
             * ```
             *
             * \@codeGenApi
             * @type {?}
             */
            var ɵɵdefineDirective = ( /** @type {?} */(( /** @type {?} */(ɵɵdefineComponent))));
            /**
             * Create a pipe definition object.
             *
             * # Example
             * ```
             * class MyPipe implements PipeTransform {
             *   // Generated by Angular Template Compiler
             *   static ngPipeDef = definePipe({
             *     ...
             *   });
             * }
             * ```
             * \@codeGenApi
             * @template T
             * @param {?} pipeDef Pipe definition generated by the compiler
             *
             * @return {?}
             */
            function ɵɵdefinePipe(pipeDef) {
                return ( /** @type {?} */((( /** @type {?} */({
                    name: pipeDef.name,
                    factory: pipeDef.factory,
                    pure: pipeDef.pure !== false,
                    onDestroy: pipeDef.type.prototype.ngOnDestroy || null
                })))));
            }
            /**
             * The following getter methods retrieve the definition form the type. Currently the retrieval
             * honors inheritance, but in the future we may change the rule to require that definitions are
             * explicit. This would require some sort of migration strategy.
             * @template T
             * @param {?} type
             * @return {?}
             */
            function getComponentDef(type) {
                return (( /** @type {?} */(type)))[NG_COMPONENT_DEF] || null;
            }
            /**
             * @template T
             * @param {?} type
             * @return {?}
             */
            function getDirectiveDef(type) {
                return (( /** @type {?} */(type)))[NG_DIRECTIVE_DEF] || null;
            }
            /**
             * @template T
             * @param {?} type
             * @return {?}
             */
            function getPipeDef(type) {
                return (( /** @type {?} */(type)))[NG_PIPE_DEF] || null;
            }
            /**
             * @template T
             * @param {?} type
             * @return {?}
             */
            function getBaseDef(type) {
                return (( /** @type {?} */(type)))[NG_BASE_DEF] || null;
            }
            /**
             * @template T
             * @param {?} type
             * @param {?=} throwNotFound
             * @return {?}
             */
            function getNgModuleDef(type, throwNotFound) {
                /** @type {?} */
                /** @nocollapse */ var ngModuleDef = (( /** @type {?} */(type)))[NG_MODULE_DEF] || null;
                if (!ngModuleDef && throwNotFound === true) {
                    throw new Error("Type " + stringify(type) + " does not have 'ngModuleDef' property.");
                }
                return ngModuleDef;
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function getNgLocaleIdDef(type) {
                return (( /** @type {?} */(type)))[NG_LOCALE_ID_DEF] || null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // Below are constants for LView indices to help us look up LView members
            // without having to remember the specific indices.
            // Uglify will inline these when minifying so there shouldn't be a cost.
            /** @type {?} */
            var HOST = 0;
            /** @type {?} */
            var TVIEW = 1;
            /** @type {?} */
            var FLAGS = 2;
            /** @type {?} */
            var PARENT = 3;
            /** @type {?} */
            var NEXT = 4;
            /** @type {?} */
            var QUERIES = 5;
            /** @type {?} */
            var T_HOST = 6;
            /** @type {?} */
            var BINDING_INDEX = 7;
            /** @type {?} */
            var CLEANUP = 8;
            /** @type {?} */
            var CONTEXT = 9;
            /** @type {?} */
            var INJECTOR$1 = 10;
            /** @type {?} */
            var RENDERER_FACTORY = 11;
            /** @type {?} */
            var RENDERER = 12;
            /** @type {?} */
            var SANITIZER = 13;
            /** @type {?} */
            var CHILD_HEAD = 14;
            /** @type {?} */
            var CHILD_TAIL = 15;
            /** @type {?} */
            var DECLARATION_VIEW = 16;
            /** @type {?} */
            var DECLARATION_LCONTAINER = 17;
            /** @type {?} */
            var PREORDER_HOOK_FLAGS = 18;
            /**
             * Size of LView's header. Necessary to adjust for it when setting slots.
             * @type {?}
             */
            var HEADER_OFFSET = 19;
            /**
             * @record
             */
            function OpaqueViewState() { }
            if (false) { }
            /**
             * `LView` stores all of the information needed to process the instructions as
             * they are invoked from the template. Each embedded view and component view has its
             * own `LView`. When processing a particular view, we set the `viewData` to that
             * `LView`. When that view is done processing, the `viewData` is set back to
             * whatever the original `viewData` was before (the parent `LView`).
             *
             * Keeping separate state for each view facilities view insertion / deletion, so we
             * don't have to edit the data array based on which views are present.
             * @record
             */
            function LView() { }
            if (false) { }
            /** @enum {number} */
            var LViewFlags = {
                /** The state of the init phase on the first 2 bits */
                InitPhaseStateIncrementer: 1,
                InitPhaseStateMask: 3,
                /**
                 * Whether or not the view is in creationMode.
                 *
                 * This must be stored in the view rather than using `data` as a marker so that
                 * we can properly support embedded views. Otherwise, when exiting a child view
                 * back into the parent view, `data` will be defined and `creationMode` will be
                 * improperly reported as false.
                 */
                CreationMode: 4,
                /**
                 * Whether or not this LView instance is on its first processing pass.
                 *
                 * An LView instance is considered to be on its "first pass" until it
                 * has completed one creation mode run and one update mode run. At this
                 * time, the flag is turned off.
                 */
                FirstLViewPass: 8,
                /** Whether this view has default change detection strategy (checks always) or onPush */
                CheckAlways: 16,
                /**
                 * Whether or not manual change detection is turned on for onPush components.
                 *
                 * This is a special mode that only marks components dirty in two cases:
                 * 1) There has been a change to an @Input property
                 * 2) `markDirty()` has been called manually by the user
                 *
                 * Note that in this mode, the firing of events does NOT mark components
                 * dirty automatically.
                 *
                 * Manual mode is turned off by default for backwards compatibility, as events
                 * automatically mark OnPush components dirty in View Engine.
                 *
                 * TODO: Add a public API to ChangeDetectionStrategy to turn this mode on
                 */
                ManualOnPush: 32,
                /** Whether or not this view is currently dirty (needing check) */
                Dirty: 64,
                /** Whether or not this view is currently attached to change detection tree. */
                Attached: 128,
                /** Whether or not this view is destroyed. */
                Destroyed: 256,
                /** Whether or not this view is the root view */
                IsRoot: 512,
                /**
                 * Index of the current init phase on last 22 bits
                 */
                IndexWithinInitPhaseIncrementer: 1024,
                IndexWithinInitPhaseShift: 10,
                IndexWithinInitPhaseReset: 1023,
            };
            /** @enum {number} */
            var InitPhaseState = {
                OnInitHooksToBeRun: 0,
                AfterContentInitHooksToBeRun: 1,
                AfterViewInitHooksToBeRun: 2,
                InitPhaseCompleted: 3,
            };
            /** @enum {number} */
            var PreOrderHookFlags = {
                /** The index of the next pre-order hook to be called in the hooks array, on the first 16
                   bits */
                IndexOfTheNextPreOrderHookMaskMask: 65535,
                /**
                 * The number of init hooks that have already been called, on the last 16 bits
                 */
                NumberOfInitHooksCalledIncrementer: 65536,
                NumberOfInitHooksCalledShift: 16,
                NumberOfInitHooksCalledMask: 4294901760,
            };
            /**
             * Set of instructions used to process host bindings efficiently.
             *
             * See VIEW_DATA.md for more information.
             * @record
             */
            function ExpandoInstructions() { }
            /**
             * The static data for an LView (shared between all templates of a
             * given type).
             *
             * Stored on the `ComponentDef.tView`.
             * @record
             */
            function TView() { }
            if (false) { }
            /** @enum {number} */
            var RootContextFlags = {
                Empty: 0, DetectChanges: 1, FlushPlayers: 2,
            };
            /**
             * RootContext contains information which is shared for all components which
             * were bootstrapped with {\@link renderComponent}.
             * @record
             */
            function RootContext() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Special location which allows easy identification of type. If we have an array which was
             * retrieved from the `LView` and that array has `true` at `TYPE` location, we know it is
             * `LContainer`.
             * @type {?}
             */
            var TYPE = 1;
            /**
             * Below are constants for LContainer indices to help us look up LContainer members
             * without having to remember the specific indices.
             * Uglify will inline these when minifying so there shouldn't be a cost.
             * @type {?}
             */
            var ACTIVE_INDEX = 2;
            // PARENT and NEXT are indices 3 and 4
            // As we already have these constants in LView, we don't need to re-create them.
            /** @type {?} */
            var MOVED_VIEWS = 5;
            // T_HOST is index 6
            // We already have this constants in LView, we don't need to re-create it.
            /** @type {?} */
            var NATIVE = 7;
            /** @type {?} */
            var VIEW_REFS = 8;
            /**
             * Size of LContainer's header. Represents the index after which all views in the
             * container will be inserted. We need to keep a record of current views so we know
             * which views are already in the DOM (and don't need to be re-added) and so we can
             * remove views from the DOM when they are no longer required.
             * @type {?}
             */
            var CONTAINER_HEADER_OFFSET = 9;
            /**
             * The state associated with a container.
             *
             * This is an array so that its structure is closer to LView. This helps
             * when traversing the view tree (which is a mix of containers and component
             * views), so we can jump to viewOrContainer[NEXT] in the same way regardless
             * of type.
             * @record
             */
            function LContainer() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$1 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * True if `value` is `LView`.
             * @param {?} value wrapped value of `RNode`, `LView`, `LContainer`
             * @return {?}
             */
            function isLView(value) {
                return Array.isArray(value) && typeof value[TYPE] === 'object';
            }
            /**
             * True if `value` is `LContainer`.
             * @param {?} value wrapped value of `RNode`, `LView`, `LContainer`
             * @return {?}
             */
            function isLContainer(value) {
                return Array.isArray(value) && value[TYPE] === true;
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function isContentQueryHost(tNode) {
                return (tNode.flags & 4 /* hasContentQuery */) !== 0;
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function isComponent(tNode) {
                return (tNode.flags & 1 /* isComponent */) === 1 /* isComponent */;
            }
            /**
             * @template T
             * @param {?} def
             * @return {?}
             */
            function isComponentDef(def) {
                return (( /** @type {?} */(def))).template !== null;
            }
            /**
             * @param {?} target
             * @return {?}
             */
            function isRootView(target) {
                return (target[FLAGS] & 512 /* IsRoot */) !== 0;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function assertTNodeForLView(tNode, lView) {
                tNode.hasOwnProperty('tView_') && assertEqual((( /** @type {?} */(( /** @type {?} */(tNode))))).tView_, lView[TVIEW], 'This TNode does not belong to this LView.');
            }
            /**
             * @param {?} actual
             * @param {?=} msg
             * @return {?}
             */
            function assertComponentType(actual, msg) {
                if (msg === void 0) { msg = 'Type passed in is not ComponentType, it does not have \'ngComponentDef\' property.'; }
                if (!getComponentDef(actual)) {
                    throwError(msg);
                }
            }
            /**
             * @param {?} actual
             * @param {?=} msg
             * @return {?}
             */
            function assertNgModuleType(actual, msg) {
                if (msg === void 0) { msg = 'Type passed in is not NgModuleType, it does not have \'ngModuleDef\' property.'; }
                if (!getNgModuleDef(actual)) {
                    throwError(msg);
                }
            }
            /**
             * @param {?} isParent
             * @return {?}
             */
            function assertPreviousIsParent(isParent) {
                assertEqual(isParent, true, 'previousOrParentTNode should be a parent');
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function assertHasParent(tNode) {
                assertDefined(tNode, 'previousOrParentTNode should exist!');
                assertDefined(( /** @type {?} */(tNode)).parent, 'previousOrParentTNode should have a parent');
            }
            /**
             * @param {?} lView
             * @param {?} index
             * @param {?=} arr
             * @return {?}
             */
            function assertDataNext(lView, index, arr) {
                if (arr == null)
                    arr = lView;
                assertEqual(arr.length, index, "index " + index + " expected to be at the end of arr (length " + arr.length + ")");
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function assertLContainerOrUndefined(value) {
                value && assertEqual(isLContainer(value), true, 'Expecting LContainer or undefined or null');
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function assertLContainer(value) {
                assertDefined(value, 'LContainer must be defined');
                assertEqual(isLContainer(value), true, 'Expecting LContainer');
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function assertLViewOrUndefined(value) {
                value && assertEqual(isLView(value), true, 'Expecting LView or undefined or null');
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function assertLView(value) {
                assertDefined(value, 'LView must be defined');
                assertEqual(isLView(value), true, 'Expecting LView');
            }
            /**
             * @param {?} tView
             * @param {?} errMessage
             * @return {?}
             */
            function assertFirstTemplatePass(tView, errMessage) {
                assertEqual(tView.firstTemplatePass, true, errMessage);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var TNODE = 8;
            /** @type {?} */
            var PARENT_INJECTOR = 8;
            /** @type {?} */
            var INJECTOR_BLOOM_PARENT_SIZE = 9;
            /**
             * Represents a relative location of parent injector.
             *
             * The interfaces encodes number of parents `LView`s to traverse and index in the `LView`
             * pointing to the parent injector.
             * @record
             */
            function RelativeInjectorLocation() { }
            if (false) { }
            /** @enum {number} */
            var RelativeInjectorLocationFlags = {
                InjectorIndexMask: 32767,
                ViewOffsetShift: 16,
                NO_PARENT: -1,
            };
            /** @type {?} */
            var NO_PARENT_INJECTOR = ( /** @type {?} */(-1));
            /**
             * Each injector is saved in 9 contiguous slots in `LView` and 9 contiguous slots in
             * `TView.data`. This allows us to store information about the current node's tokens (which
             * can be shared in `TView`) as well as the tokens of its ancestor nodes (which cannot be
             * shared, so they live in `LView`).
             *
             * Each of these slots (aside from the last slot) contains a bloom filter. This bloom filter
             * determines whether a directive is available on the associated node or not. This prevents us
             * from searching the directives array at this level unless it's probable the directive is in it.
             *
             * See: https://en.wikipedia.org/wiki/Bloom_filter for more about bloom filters.
             *
             * Because all injectors have been flattened into `LView` and `TViewData`, they cannot typed
             * using interfaces as they were previously. The start index of each `LInjector` and `TInjector`
             * will differ based on where it is flattened into the main array, so it's not possible to know
             * the indices ahead of time and save their types here. The interfaces are still included here
             * for documentation purposes.
             *
             * export interface LInjector extends Array<any> {
             *
             *    // Cumulative bloom for directive IDs 0-31  (IDs are % BLOOM_SIZE)
             *    [0]: number;
             *
             *    // Cumulative bloom for directive IDs 32-63
             *    [1]: number;
             *
             *    // Cumulative bloom for directive IDs 64-95
             *    [2]: number;
             *
             *    // Cumulative bloom for directive IDs 96-127
             *    [3]: number;
             *
             *    // Cumulative bloom for directive IDs 128-159
             *    [4]: number;
             *
             *    // Cumulative bloom for directive IDs 160 - 191
             *    [5]: number;
             *
             *    // Cumulative bloom for directive IDs 192 - 223
             *    [6]: number;
             *
             *    // Cumulative bloom for directive IDs 224 - 255
             *    [7]: number;
             *
             *    // We need to store a reference to the injector's parent so DI can keep looking up
             *    // the injector tree until it finds the dependency it's looking for.
             *    [PARENT_INJECTOR]: number;
             * }
             *
             * export interface TInjector extends Array<any> {
             *
             *    // Shared node bloom for directive IDs 0-31  (IDs are % BLOOM_SIZE)
             *    [0]: number;
             *
             *    // Shared node bloom for directive IDs 32-63
             *    [1]: number;
             *
             *    // Shared node bloom for directive IDs 64-95
             *    [2]: number;
             *
             *    // Shared node bloom for directive IDs 96-127
             *    [3]: number;
             *
             *    // Shared node bloom for directive IDs 128-159
             *    [4]: number;
             *
             *    // Shared node bloom for directive IDs 160 - 191
             *    [5]: number;
             *
             *    // Shared node bloom for directive IDs 192 - 223
             *    [6]: number;
             *
             *    // Shared node bloom for directive IDs 224 - 255
             *    [7]: number;
             *
             *    // Necessary to find directive indices for a particular node.
             *    [TNODE]: TElementNode|TElementContainerNode|TContainerNode;
             *  }
             */
            /**
             * Factory for creating instances of injectors in the NodeInjector.
             *
             * This factory is complicated by the fact that it can resolve `multi` factories as well.
             *
             * NOTE: Some of the fields are optional which means that this class has two hidden classes.
             * - One without `multi` support (most common)
             * - One with `multi` values, (rare).
             *
             * Since VMs can cache up to 4 inline hidden classes this is OK.
             *
             * - Single factory: Only `resolving` and `factory` is defined.
             * - `providers` factory: `componentProviders` is a number and `index = -1`.
             * - `viewProviders` factory: `componentProviders` is a number and `index` points to `providers`.
             */
            var NodeInjectorFactory = /** @class */ (function () {
                /**
                 * @param {?} factory
                 * @param {?} isViewProvider
                 * @param {?} injectImplementation
                 */
                function NodeInjectorFactory(factory, 
                /**
                 * Set to `true` if the token is declared in `viewProviders` (or if it is component).
                 */
                isViewProvider, injectImplementation) {
                    this.factory = factory;
                    /**
                     * Marker set to true during factory invocation to see if we get into recursive loop.
                     * Recursive loop causes an error to be displayed.
                     */
                    this.resolving = false;
                    this.canSeeViewProviders = isViewProvider;
                    this.injectImpl = injectImplementation;
                }
                return NodeInjectorFactory;
            }());
            if (false) { }
            /**
             * @param {?} obj
             * @return {?}
             */
            function isFactory(obj) {
                // See: https://jsperf.com/instanceof-vs-getprototypeof
                return obj !== null && typeof obj == 'object' &&
                    Object.getPrototypeOf(obj) == NodeInjectorFactory.prototype;
            }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$2 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} tNode
             * @param {?} type
             * @return {?}
             */
            function assertNodeType(tNode, type) {
                assertDefined(tNode, 'should be called with a TNode');
                assertEqual(tNode.type, type, "should be a " + typeName(type));
            }
            /**
             * @param {?} tNode
             * @param {...?} types
             * @return {?}
             */
            function assertNodeOfPossibleTypes(tNode) {
                var types = [];
                for (var _c = 1; _c < arguments.length; _c++) {
                    types[_c - 1] = arguments[_c];
                }
                assertDefined(tNode, 'should be called with a TNode');
                /** @type {?} */
                var found = types.some(( /**
                 * @param {?} type
                 * @return {?}
                 */function (/**
                 * @param {?} type
                 * @return {?}
                 */ type) { return tNode.type === type; }));
                assertEqual(found, true, "Should be one of " + types.map(typeName).join(', ') + " but got " + typeName(tNode.type));
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function typeName(type) {
                if (type == 1 /* Projection */)
                    return 'Projection';
                if (type == 0 /* Container */)
                    return 'Container';
                if (type == 2 /* View */)
                    return 'View';
                if (type == 3 /* Element */)
                    return 'Element';
                if (type == 4 /* ElementContainer */)
                    return 'ElementContainer';
                return '<unknown>';
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Adds all directive lifecycle hooks from the given `DirectiveDef` to the given `TView`.
             *
             * Must be run *only* on the first template pass.
             *
             * Sets up the pre-order hooks on the provided `tView`,
             * see {\@link HookData} for details about the data structure.
             *
             * @param {?} directiveIndex The index of the directive in LView
             * @param {?} directiveDef The definition containing the hooks to setup in tView
             * @param {?} tView The current TView
             * @param {?} nodeIndex The index of the node to which the directive is attached
             * @param {?} initialPreOrderHooksLength the number of pre-order hooks already registered before the
             * current process, used to know if the node index has to be added to the array. If it is -1,
             * the node index is never added.
             * @param {?} initialPreOrderCheckHooksLength same as previous for pre-order check hooks
             * @return {?}
             */
            function registerPreOrderHooks(directiveIndex, directiveDef, tView, nodeIndex, initialPreOrderHooksLength, initialPreOrderCheckHooksLength) {
                ngDevMode &&
                    assertEqual(tView.firstTemplatePass, true, 'Should only be called on first template pass');
                var onChanges = directiveDef.onChanges, onInit = directiveDef.onInit, doCheck = directiveDef.doCheck;
                if (initialPreOrderHooksLength >= 0 &&
                    (!tView.preOrderHooks || initialPreOrderHooksLength === tView.preOrderHooks.length) &&
                    (onChanges || onInit || doCheck)) {
                    (tView.preOrderHooks || (tView.preOrderHooks = [])).push(nodeIndex);
                }
                if (initialPreOrderCheckHooksLength >= 0 &&
                    (!tView.preOrderCheckHooks ||
                        initialPreOrderCheckHooksLength === tView.preOrderCheckHooks.length) &&
                    (onChanges || doCheck)) {
                    (tView.preOrderCheckHooks || (tView.preOrderCheckHooks = [])).push(nodeIndex);
                }
                if (onChanges) {
                    (tView.preOrderHooks || (tView.preOrderHooks = [])).push(directiveIndex, onChanges);
                    (tView.preOrderCheckHooks || (tView.preOrderCheckHooks = [])).push(directiveIndex, onChanges);
                }
                if (onInit) {
                    (tView.preOrderHooks || (tView.preOrderHooks = [])).push(-directiveIndex, onInit);
                }
                if (doCheck) {
                    (tView.preOrderHooks || (tView.preOrderHooks = [])).push(directiveIndex, doCheck);
                    (tView.preOrderCheckHooks || (tView.preOrderCheckHooks = [])).push(directiveIndex, doCheck);
                }
            }
            /**
             *
             * Loops through the directives on the provided `tNode` and queues hooks to be
             * run that are not initialization hooks.
             *
             * Should be executed during `elementEnd()` and similar to
             * preserve hook execution order. Content, view, and destroy hooks for projected
             * components and directives must be called *before* their hosts.
             *
             * Sets up the content, view, and destroy hooks on the provided `tView`,
             * see {\@link HookData} for details about the data structure.
             *
             * NOTE: This does not set up `onChanges`, `onInit` or `doCheck`, those are set up
             * separately at `elementStart`.
             *
             * @param {?} tView The current TView
             * @param {?} tNode The TNode whose directives are to be searched for hooks to queue
             * @return {?}
             */
            function registerPostOrderHooks(tView, tNode) {
                if (tView.firstTemplatePass) {
                    // It's necessary to loop through the directives at elementEnd() (rather than processing in
                    // directiveCreate) so we can preserve the current hook order. Content, view, and destroy
                    // hooks for projected components and directives must be called *before* their hosts.
                    for (var i = tNode.directiveStart, end = tNode.directiveEnd; i < end; i++) {
                        /** @type {?} */
                        var directiveDef_1 = ( /** @type {?} */(tView.data[i]));
                        if (directiveDef_1.afterContentInit) {
                            (tView.contentHooks || (tView.contentHooks = [])).push(-i, directiveDef_1.afterContentInit);
                        }
                        if (directiveDef_1.afterContentChecked) {
                            (tView.contentHooks || (tView.contentHooks = [])).push(i, directiveDef_1.afterContentChecked);
                            (tView.contentCheckHooks || (tView.contentCheckHooks = [])).push(i, directiveDef_1.afterContentChecked);
                        }
                        if (directiveDef_1.afterViewInit) {
                            (tView.viewHooks || (tView.viewHooks = [])).push(-i, directiveDef_1.afterViewInit);
                        }
                        if (directiveDef_1.afterViewChecked) {
                            (tView.viewHooks || (tView.viewHooks = [])).push(i, directiveDef_1.afterViewChecked);
                            (tView.viewCheckHooks || (tView.viewCheckHooks = [])).push(i, directiveDef_1.afterViewChecked);
                        }
                        if (directiveDef_1.onDestroy != null) {
                            (tView.destroyHooks || (tView.destroyHooks = [])).push(i, directiveDef_1.onDestroy);
                        }
                    }
                }
            }
            /**
             * Executing hooks requires complex logic as we need to deal with 2 constraints.
             *
             * 1. Init hooks (ngOnInit, ngAfterContentInit, ngAfterViewInit) must all be executed once and only
             * once, across many change detection cycles. This must be true even if some hooks throw, or if
             * some recursively trigger a change detection cycle.
             * To solve that, it is required to track the state of the execution of these init hooks.
             * This is done by storing and maintaining flags in the view: the {@link InitPhaseState},
             * and the index within that phase. They can be seen as a cursor in the following structure:
             * [[onInit1, onInit2], [afterContentInit1], [afterViewInit1, afterViewInit2, afterViewInit3]]
             * They are are stored as flags in LView[FLAGS].
             *
             * 2. Pre-order hooks can be executed in batches, because of the select instruction.
             * To be able to pause and resume their execution, we also need some state about the hook's array
             * that is being processed:
             * - the index of the next hook to be executed
             * - the number of init hooks already found in the processed part of the  array
             * They are are stored as flags in LView[PREORDER_HOOK_FLAGS].
             */
            /**
             * Executes necessary hooks at the start of executing a template.
             *
             * Executes hooks that are to be run during the initialization of a directive such
             * as `onChanges`, `onInit`, and `doCheck`.
             *
             * @param {?} currentView
             * @param {?} tView Static data for the view containing the hooks to be executed
             * @param {?} checkNoChangesMode Whether or not we're in checkNoChanges mode.
             * @param {?} currentNodeIndex
             * @return {?}
             */
            function executePreOrderHooks(currentView, tView, checkNoChangesMode, currentNodeIndex) {
                if (!checkNoChangesMode) {
                    executeHooks(currentView, tView.preOrderHooks, tView.preOrderCheckHooks, checkNoChangesMode, 0 /* OnInitHooksToBeRun */, currentNodeIndex !== undefined ? currentNodeIndex : null);
                }
            }
            /**
             * Executes hooks against the given `LView` based off of whether or not
             * This is the first pass.
             *
             * @param {?} currentView The view instance data to run the hooks against
             * @param {?} firstPassHooks An array of hooks to run if we're in the first view pass
             * @param {?} checkHooks An Array of hooks to run if we're not in the first view pass.
             * @param {?} checkNoChangesMode Whether or not we're in no changes mode.
             * @param {?} initPhaseState the current state of the init phase
             * @param {?} currentNodeIndex 3 cases depending the the value:
             * - undefined: all hooks from the array should be executed (post-order case)
             * - null: execute hooks only from the saved index until the end of the array (pre-order case, when
             * flushing the remaining hooks)
             * - number: execute hooks only from the saved index until that node index exclusive (pre-order
             * case, when executing select(number))
             * @return {?}
             */
            function executeHooks(currentView, firstPassHooks, checkHooks, checkNoChangesMode, initPhaseState, currentNodeIndex) {
                if (checkNoChangesMode)
                    return;
                /** @type {?} */
                var hooksToCall = (currentView[FLAGS] & 3 /* InitPhaseStateMask */) === initPhaseState ?
                    firstPassHooks :
                    checkHooks;
                if (hooksToCall) {
                    callHooks(currentView, hooksToCall, initPhaseState, currentNodeIndex);
                }
                // The init phase state must be always checked here as it may have been recursively updated
                if (currentNodeIndex == null &&
                    (currentView[FLAGS] & 3 /* InitPhaseStateMask */) === initPhaseState &&
                    initPhaseState !== 3 /* InitPhaseCompleted */) {
                    currentView[FLAGS] &= 1023 /* IndexWithinInitPhaseReset */;
                    currentView[FLAGS] += 1 /* InitPhaseStateIncrementer */;
                }
            }
            /**
             * Calls lifecycle hooks with their contexts, skipping init hooks if it's not
             * the first LView pass
             *
             * @param {?} currentView The current view
             * @param {?} arr The array in which the hooks are found
             * @param {?} initPhase
             * @param {?} currentNodeIndex 3 cases depending the the value:
             * - undefined: all hooks from the array should be executed (post-order case)
             * - null: execute hooks only from the saved index until the end of the array (pre-order case, when
             * flushing the remaining hooks)
             * - number: execute hooks only from the saved index until that node index exclusive (pre-order
             * case, when executing select(number))
             * @return {?}
             */
            function callHooks(currentView, arr, initPhase, currentNodeIndex) {
                /** @type {?} */
                var startIndex = currentNodeIndex !== undefined ?
                    (currentView[PREORDER_HOOK_FLAGS] & 65535 /* IndexOfTheNextPreOrderHookMaskMask */) :
                    0;
                /** @type {?} */
                var nodeIndexLimit = currentNodeIndex != null ? currentNodeIndex : -1;
                /** @type {?} */
                var lastNodeIndexFound = 0;
                for (var i = startIndex; i < arr.length; i++) {
                    /** @type {?} */
                    var hook = ( /** @type {?} */(arr[i + 1]));
                    if (typeof hook === 'number') {
                        lastNodeIndexFound = ( /** @type {?} */(arr[i]));
                        if (currentNodeIndex != null && lastNodeIndexFound >= currentNodeIndex) {
                            break;
                        }
                    }
                    else {
                        /** @type {?} */
                        var isInitHook = arr[i] < 0;
                        if (isInitHook)
                            currentView[PREORDER_HOOK_FLAGS] += 65536 /* NumberOfInitHooksCalledIncrementer */;
                        if (lastNodeIndexFound < nodeIndexLimit || nodeIndexLimit == -1) {
                            callHook(currentView, initPhase, arr, i);
                            currentView[PREORDER_HOOK_FLAGS] =
                                (currentView[PREORDER_HOOK_FLAGS] & 4294901760 /* NumberOfInitHooksCalledMask */) + i +
                                    2;
                        }
                        i++;
                    }
                }
            }
            /**
             * Execute one hook against the current `LView`.
             *
             * @param {?} currentView The current view
             * @param {?} initPhase
             * @param {?} arr The array in which the hooks are found
             * @param {?} i The current index within the hook data array
             * @return {?}
             */
            function callHook(currentView, initPhase, arr, i) {
                /** @type {?} */
                var isInitHook = arr[i] < 0;
                /** @type {?} */
                var hook = ( /** @type {?} */(arr[i + 1]));
                /** @type {?} */
                var directiveIndex = isInitHook ? -arr[i] : ( /** @type {?} */(arr[i]));
                /** @type {?} */
                var directive = currentView[directiveIndex];
                if (isInitHook) {
                    /** @type {?} */
                    var indexWithintInitPhase = currentView[FLAGS] >> 10 /* IndexWithinInitPhaseShift */;
                    // The init phase state must be always checked here as it may have been recursively
                    // updated
                    if (indexWithintInitPhase <
                        (currentView[PREORDER_HOOK_FLAGS] >> 16 /* NumberOfInitHooksCalledShift */) &&
                        (currentView[FLAGS] & 3 /* InitPhaseStateMask */) === initPhase) {
                        currentView[FLAGS] += 1024 /* IndexWithinInitPhaseIncrementer */;
                        hook.call(directive);
                    }
                }
                else {
                    hook.call(directive);
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
            * @license
            * Copyright Google Inc. All Rights Reserved.
            *
            * Use of this source code is governed by an MIT-style license that can be
            * found in the LICENSE file at https://angular.io/license
            */
            /**
             * --------
             *
             * // TODO(matsko): add updateMask info
             *
             * This file contains all state-based logic for styling in Angular.
             *
             * Styling in Angular is evaluated with a series of styling-specific
             * template instructions which are called one after another each time
             * change detection occurs in Angular.
             *
             * Styling makes use of various temporary, state-based variables between
             * instructions so that it can better cache and optimize its values.
             * These values are usually populated and cleared when an element is
             * exited in change detection (once all the instructions are run for
             * that element).
             *
             * There are, however, situations where the state-based values
             * need to be stored and used at a later point. This ONLY occurs when
             * there are template-level as well as host-binding-level styling
             * instructions on the same element. The example below shows exactly
             * what could be:
             *
             * ```html
             * <!-- two sources of styling: the template and the directive -->
             * <div [style.width]="width" dir-that-sets-height></div>
             * ```
             *
             * If and when this situation occurs, the current styling state is
             * stored in a storage map value and then later accessed once the
             * host bindings are evaluated. Once styling for the current element
             * is over then the map entry will be cleared.
             *
             * To learn more about the algorithm see `TStylingContext`.
             *
             * --------
             */
            /** @type {?} */
            var _stylingState = null;
            /** @type {?} */
            var _stateStorage = new Map();
            // this value is not used outside this file and is only here
            // as a caching check for when the element changes.
            /** @type {?} */
            var _stylingElement = null;
            /**
             * Used as a state reference for update values between style/class binding instructions.
             * @record
             */
            function StylingState() { }
            if (false) { }
            /** @type {?} */
            var STYLING_INDEX_START_VALUE = 1;
            /** @type {?} */
            var BIT_MASK_START_VALUE = 0;
            /**
             * @param {?} element
             * @param {?=} readFromMap
             * @return {?}
             */
            function getStylingState(element, readFromMap) {
                if (!_stylingElement || element !== _stylingElement) {
                    _stylingElement = element;
                    if (readFromMap) {
                        _stylingState = _stateStorage.get(element) || null;
                        ngDevMode && ngDevMode.stylingReadPersistedState++;
                    }
                    _stylingState = _stylingState || {
                        classesBitMask: BIT_MASK_START_VALUE,
                        classesIndex: STYLING_INDEX_START_VALUE,
                        stylesBitMask: BIT_MASK_START_VALUE,
                        stylesIndex: STYLING_INDEX_START_VALUE,
                    };
                }
                return ( /** @type {?} */(_stylingState));
            }
            /**
             * @return {?}
             */
            function resetStylingState() {
                _stylingState = null;
                _stylingElement = null;
            }
            /**
             * @param {?} element
             * @param {?} state
             * @return {?}
             */
            function storeStylingState(element, state) {
                ngDevMode && ngDevMode.stylingWritePersistedState++;
                _stateStorage.set(element, state);
            }
            /**
             * @param {?} element
             * @return {?}
             */
            function deleteStylingStateFromStorage(element) {
                _stateStorage.delete(element);
            }
            /**
             * @return {?}
             */
            function resetAllStylingState() {
                resetStylingState();
                _stateStorage.clear();
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * This property will be monkey-patched on elements, components and directives
             * @type {?}
             */
            var MONKEY_PATCH_KEY_NAME = '__ngContext__';
            /**
             * The internal view context which is specific to a given DOM element, directive or
             * component instance. Each value in here (besides the LView and element node details)
             * can be present, null or undefined. If undefined then it implies the value has not been
             * looked up yet, otherwise, if null, then a lookup was executed and nothing was found.
             *
             * Each value will get filled when the respective value is examined within the getContext
             * function. The component, element and each directive instance will share the same instance
             * of the context.
             * @record
             */
            function LContext() { }
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * For efficiency reasons we often put several different data types (`RNode`, `LView`, `LContainer`)
             * in same location in `LView`. This is because we don't want to pre-allocate space for it
             * because the storage is sparse. This file contains utilities for dealing with such data types.
             *
             * How do we know what is stored at a given location in `LView`.
             * - `Array.isArray(value) === false` => `RNode` (The normal storage value)
             * - `Array.isArray(value) === true` => then the `value[0]` represents the wrapped value.
             *   - `typeof value[TYPE] === 'object'` => `LView`
             *      - This happens when we have a component at a given location
             *   - `typeof value[TYPE] === true` => `LContainer`
             *      - This happens when we have `LContainer` binding at a given location.
             *
             *
             * NOTE: it is assumed that `Array.isArray` and `typeof` operations are very efficient.
             */
            /**
             * Returns `RNode`.
             * @param {?} value wrapped value of `RNode`, `LView`, `LContainer`
             * @return {?}
             */
            function unwrapRNode(value) {
                while (Array.isArray(value)) {
                    value = ( /** @type {?} */(value[HOST]));
                }
                return ( /** @type {?} */(value));
            }
            /**
             * Returns `LView` or `null` if not found.
             * @param {?} value wrapped value of `RNode`, `LView`, `LContainer`
             * @return {?}
             */
            function unwrapLView(value) {
                while (Array.isArray(value)) {
                    // This check is same as `isLView()` but we don't call at as we don't want to call
                    // `Array.isArray()` twice and give JITer more work for inlining.
                    if (typeof value[TYPE] === 'object')
                        return ( /** @type {?} */(value));
                    value = ( /** @type {?} */(value[HOST]));
                }
                return null;
            }
            /**
             * Returns `LContainer` or `null` if not found.
             * @param {?} value wrapped value of `RNode`, `LView`, `LContainer`
             * @return {?}
             */
            function unwrapLContainer(value) {
                while (Array.isArray(value)) {
                    // This check is same as `isLContainer()` but we don't call at as we don't want to call
                    // `Array.isArray()` twice and give JITer more work for inlining.
                    if (value[TYPE] === true)
                        return ( /** @type {?} */(value));
                    value = ( /** @type {?} */(value[HOST]));
                }
                return null;
            }
            /**
             * Retrieves an element value from the provided `viewData`, by unwrapping
             * from any containers, component views, or style contexts.
             * @param {?} index
             * @param {?} lView
             * @return {?}
             */
            function getNativeByIndex(index, lView) {
                return unwrapRNode(lView[index + HEADER_OFFSET]);
            }
            /**
             * Retrieve an `RNode` for a given `TNode` and `LView`.
             *
             * This function guarantees in dev mode to retrieve a non-null `RNode`.
             *
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function getNativeByTNode(tNode, lView) {
                ngDevMode && assertTNodeForLView(tNode, lView);
                ngDevMode && assertDataInRange(lView, tNode.index);
                /** @type {?} */
                var node = unwrapRNode(lView[tNode.index]);
                ngDevMode && assertDomNode(node);
                return node;
            }
            /**
             * Retrieve an `RNode` or `null` for a given `TNode` and `LView`.
             *
             * Some `TNode`s don't have associated `RNode`s. For example `Projection`
             *
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function getNativeByTNodeOrNull(tNode, lView) {
                ngDevMode && assertTNodeForLView(tNode, lView);
                /** @type {?} */
                var index = tNode.index;
                /** @type {?} */
                var node = index == -1 ? null : unwrapRNode(lView[index]);
                ngDevMode && node !== null && assertDomNode(node);
                return node;
            }
            /**
             * A helper function that returns `true` if a given `TNode` has any matching directives.
             * @param {?} tNode
             * @return {?}
             */
            function hasDirectives(tNode) {
                return tNode.directiveEnd > tNode.directiveStart;
            }
            /**
             * @param {?} index
             * @param {?} view
             * @return {?}
             */
            function getTNode(index, view) {
                ngDevMode && assertGreaterThan(index, -1, 'wrong index for TNode');
                ngDevMode && assertLessThan(index, view[TVIEW].data.length, 'wrong index for TNode');
                return ( /** @type {?} */(view[TVIEW].data[index + HEADER_OFFSET]));
            }
            /**
             * Retrieves a value from any `LView` or `TData`.
             * @template T
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function loadInternal(view, index) {
                ngDevMode && assertDataInRange(view, index + HEADER_OFFSET);
                return view[index + HEADER_OFFSET];
            }
            /**
             * @param {?} nodeIndex
             * @param {?} hostView
             * @return {?}
             */
            function getComponentViewByIndex(nodeIndex, hostView) {
                // Could be an LView or an LContainer. If LContainer, unwrap to find LView.
                /** @type {?} */
                var slotValue = hostView[nodeIndex];
                /** @type {?} */
                var lView = isLView(slotValue) ? slotValue : slotValue[HOST];
                return lView;
            }
            /**
             * Returns the monkey-patch value data present on the target (which could be
             * a component, directive or a DOM node).
             * @param {?} target
             * @return {?}
             */
            function readPatchedData(target) {
                ngDevMode && assertDefined(target, 'Target expected');
                return target[MONKEY_PATCH_KEY_NAME];
            }
            /**
             * @param {?} target
             * @return {?}
             */
            function readPatchedLView(target) {
                /** @type {?} */
                var value = readPatchedData(target);
                if (value) {
                    return Array.isArray(value) ? value : (( /** @type {?} */(value))).lView;
                }
                return null;
            }
            /**
             * Returns a boolean for whether the view is attached to the change detection tree.
             *
             * Note: This determines whether a view should be checked, not whether it's inserted
             * into a container. For that, you'll want `viewAttachedToContainer` below.
             * @param {?} view
             * @return {?}
             */
            function viewAttachedToChangeDetector(view) {
                return (view[FLAGS] & 128 /* Attached */) === 128 /* Attached */;
            }
            /**
             * Returns a boolean for whether the view is attached to a container.
             * @param {?} view
             * @return {?}
             */
            function viewAttachedToContainer(view) {
                return isLContainer(view[PARENT]);
            }
            /**
             * Resets the pre-order hook flags of the view.
             * @param {?} lView the LView on which the flags are reset
             * @return {?}
             */
            function resetPreOrderHookFlags(lView) {
                lView[PREORDER_HOOK_FLAGS] = 0;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Store the element depth count. This is used to identify the root elements of the template
             * so that we can than attach `LView` to only those elements.
             * @type {?}
             */
            var elementDepthCount;
            /**
             * @return {?}
             */
            function getElementDepthCount() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return elementDepthCount;
            }
            /**
             * @return {?}
             */
            function increaseElementDepthCount() {
                elementDepthCount++;
            }
            /**
             * @return {?}
             */
            function decreaseElementDepthCount() {
                elementDepthCount--;
            }
            /** @type {?} */
            var currentDirectiveDef = null;
            /**
             * @return {?}
             */
            function getCurrentDirectiveDef() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return currentDirectiveDef;
            }
            /**
             * @param {?} def
             * @return {?}
             */
            function setCurrentDirectiveDef(def) {
                currentDirectiveDef = def;
            }
            /**
             * Stores whether directives should be matched to elements.
             *
             * When template contains `ngNonBindable` than we need to prevent the runtime form matching
             * directives on children of that element.
             *
             * Example:
             * ```
             * <my-comp my-directive>
             *   Should match component / directive.
             * </my-comp>
             * <div ngNonBindable>
             *   <my-comp my-directive>
             *     Should not match component / directive because we are in ngNonBindable.
             *   </my-comp>
             * </div>
             * ```
             * @type {?}
             */
            var bindingsEnabled;
            /**
             * @return {?}
             */
            function getBindingsEnabled() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return bindingsEnabled;
            }
            /**
             * Enables directive matching on elements.
             *
             *  * Example:
             * ```
             * <my-comp my-directive>
             *   Should match component / directive.
             * </my-comp>
             * <div ngNonBindable>
             *   <!-- ɵɵdisableBindings() -->
             *   <my-comp my-directive>
             *     Should not match component / directive because we are in ngNonBindable.
             *   </my-comp>
             *   <!-- ɵɵenableBindings() -->
             * </div>
             * ```
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵenableBindings() {
                bindingsEnabled = true;
            }
            /**
             * Disables directive matching on element.
             *
             *  * Example:
             * ```
             * <my-comp my-directive>
             *   Should match component / directive.
             * </my-comp>
             * <div ngNonBindable>
             *   <!-- ɵɵdisableBindings() -->
             *   <my-comp my-directive>
             *     Should not match component / directive because we are in ngNonBindable.
             *   </my-comp>
             *   <!-- ɵɵenableBindings() -->
             * </div>
             * ```
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵdisableBindings() {
                bindingsEnabled = false;
            }
            /**
             * @return {?}
             */
            function getLView() {
                return lView;
            }
            /**
             * Used as the starting directive id value.
             *
             * All subsequent directives are incremented from this value onwards.
             * The reason why this value is `1` instead of `0` is because the `0`
             * value is reserved for the template.
             * @type {?}
             */
            var MIN_DIRECTIVE_ID = 1;
            /** @type {?} */
            var activeDirectiveId = MIN_DIRECTIVE_ID;
            /**
             * Position depth (with respect from leaf to root) in a directive sub-class inheritance chain.
             * @type {?}
             */
            var activeDirectiveSuperClassDepthPosition = 0;
            /**
             * Total count of how many directives are a part of an inheritance chain.
             *
             * When directives are sub-classed (extended) from one to another, Angular
             * needs to keep track of exactly how many were encountered so it can accurately
             * generate the next directive id (once the next directive id is visited).
             * Normally the next directive id just a single incremented value from the
             * previous one, however, if the previous directive is a part of an inheritance
             * chain (a series of sub-classed directives) then the incremented value must
             * also take into account the total amount of sub-classed values.
             *
             * Note that this value resets back to zero once the next directive is
             * visited (when `incrementActiveDirectiveId` or `setActiveHostElement`
             * is called).
             * @type {?}
             */
            var activeDirectiveSuperClassHeight = 0;
            /**
             * Sets the active directive host element and resets the directive id value
             * (when the provided elementIndex value has changed).
             *
             * @param {?=} elementIndex the element index value for the host element where
             *                     the directive/component instance lives
             * @return {?}
             */
            function setActiveHostElement(elementIndex) {
                if (elementIndex === void 0) { elementIndex = null; }
                if (_selectedIndex !== elementIndex) {
                    setSelectedIndex(elementIndex == null ? -1 : elementIndex);
                    activeDirectiveId = elementIndex == null ? 0 : MIN_DIRECTIVE_ID;
                    activeDirectiveSuperClassDepthPosition = 0;
                    activeDirectiveSuperClassHeight = 0;
                }
            }
            /**
             * Returns the current id value of the current directive.
             *
             * For example we have an element that has two directives on it:
             * <div dir-one dir-two></div>
             *
             * dirOne->hostBindings() (id == 1)
             * dirTwo->hostBindings() (id == 2)
             *
             * Note that this is only active when `hostBinding` functions are being processed.
             *
             * Note that directive id values are specific to an element (this means that
             * the same id value could be present on another element with a completely
             * different set of directives).
             * @return {?}
             */
            function getActiveDirectiveId() {
                return activeDirectiveId;
            }
            /**
             * Increments the current directive id value.
             *
             * For example we have an element that has two directives on it:
             * <div dir-one dir-two></div>
             *
             * dirOne->hostBindings() (index = 1)
             * // increment
             * dirTwo->hostBindings() (index = 2)
             *
             * Depending on whether or not a previous directive had any inherited
             * directives present, that value will be incremented in addition
             * to the id jumping up by one.
             *
             * Note that this is only active when `hostBinding` functions are being processed.
             *
             * Note that directive id values are specific to an element (this means that
             * the same id value could be present on another element with a completely
             * different set of directives).
             * @return {?}
             */
            function incrementActiveDirectiveId() {
                activeDirectiveId += 1 + activeDirectiveSuperClassHeight;
                // because we are dealing with a new directive this
                // means we have exited out of the inheritance chain
                activeDirectiveSuperClassDepthPosition = 0;
                activeDirectiveSuperClassHeight = 0;
            }
            /**
             * Set the current super class (reverse inheritance) position depth for a directive.
             *
             * For example we have two directives: Child and Other (but Child is a sub-class of Parent)
             * <div child-dir other-dir></div>
             *
             * // increment
             * parentInstance->hostBindings() (depth = 1)
             * // decrement
             * childInstance->hostBindings() (depth = 0)
             * otherInstance->hostBindings() (depth = 0 b/c it's a different directive)
             *
             * Note that this is only active when `hostBinding` functions are being processed.
             * @param {?} delta
             * @return {?}
             */
            function adjustActiveDirectiveSuperClassDepthPosition(delta) {
                activeDirectiveSuperClassDepthPosition += delta;
                // we keep track of the height value so that when the next directive is visited
                // then Angular knows to generate a new directive id value which has taken into
                // account how many sub-class directives were a part of the previous directive.
                activeDirectiveSuperClassHeight =
                    Math.max(activeDirectiveSuperClassHeight, activeDirectiveSuperClassDepthPosition);
            }
            /**
             * Returns he current depth of the super/sub class inheritance chain.
             *
             * This will return how many inherited directive/component classes
             * exist in the current chain.
             *
             * ```typescript
             * \@Directive({ selector: '[super-dir]' })
             * class SuperDir {}
             *  / selector: '[sub-dir]' })
             * class SubDir extends SuperDir {}
             *
             * // if `<div sub-dir>` is used then the super class height is `1`
             * // if `<div super-dir>` is used then the super class height is `0`
             * ```
             * @return {?}
             */
            function getActiveDirectiveSuperClassHeight() {
                return activeDirectiveSuperClassHeight;
            }
            /**
             * Returns the current super class (reverse inheritance) depth for a directive.
             *
             * This is designed to help instruction code distinguish different hostBindings
             * calls from each other when a directive has extended from another directive.
             * Normally using the directive id value is enough, but with the case
             * of parent/sub-class directive inheritance more information is required.
             *
             * Note that this is only active when `hostBinding` functions are being processed.
             * @return {?}
             */
            function getActiveDirectiveSuperClassDepth() {
                return activeDirectiveSuperClassDepthPosition;
            }
            /**
             * Restores `contextViewData` to the given OpaqueViewState instance.
             *
             * Used in conjunction with the getCurrentView() instruction to save a snapshot
             * of the current view and restore it when listeners are invoked. This allows
             * walking the declaration view tree in listeners to get vars from parent views.
             *
             * \@codeGenApi
             * @param {?} viewToRestore The OpaqueViewState instance to restore.
             *
             * @return {?}
             */
            function ɵɵrestoreView(viewToRestore) {
                contextLView = ( /** @type {?} */(( /** @type {?} */(viewToRestore))));
            }
            /**
             * Used to set the parent property when nodes are created and track query results.
             * @type {?}
             */
            var previousOrParentTNode;
            /**
             * @return {?}
             */
            function getPreviousOrParentTNode() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return previousOrParentTNode;
            }
            /**
             * @param {?} tNode
             * @param {?} _isParent
             * @return {?}
             */
            function setPreviousOrParentTNode(tNode, _isParent) {
                previousOrParentTNode = tNode;
                isParent = _isParent;
            }
            /**
             * @param {?} tNode
             * @param {?} view
             * @return {?}
             */
            function setTNodeAndViewData(tNode, view) {
                ngDevMode && assertLViewOrUndefined(view);
                previousOrParentTNode = tNode;
                lView = view;
            }
            /**
             * If `isParent` is:
             *  - `true`: then `previousOrParentTNode` points to a parent node.
             *  - `false`: then `previousOrParentTNode` points to previous node (sibling).
             * @type {?}
             */
            var isParent;
            /**
             * @return {?}
             */
            function getIsParent() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return isParent;
            }
            /**
             * @return {?}
             */
            function setIsNotParent() {
                isParent = false;
            }
            /**
             * @return {?}
             */
            function setIsParent() {
                isParent = true;
            }
            /**
             * Checks whether a given view is in creation mode
             * @param {?=} view
             * @return {?}
             */
            function isCreationMode(view) {
                if (view === void 0) { view = lView; }
                return (view[FLAGS] & 4 /* CreationMode */) === 4 /* CreationMode */;
            }
            /**
             * State of the current view being processed.
             *
             * An array of nodes (text, element, container, etc), pipes, their bindings, and
             * any local variables that need to be stored between invocations.
             * @type {?}
             */
            var lView;
            /**
             * The last viewData retrieved by nextContext().
             * Allows building nextContext() and reference() calls.
             *
             * e.g. const inner = x().$implicit; const outer = x().$implicit;
             * @type {?}
             */
            var contextLView = ( /** @type {?} */(null));
            /**
             * @return {?}
             */
            function getContextLView() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return contextLView;
            }
            /**
             * In this mode, any changes in bindings will throw an ExpressionChangedAfterChecked error.
             *
             * Necessary to support ChangeDetectorRef.checkNoChanges().
             * @type {?}
             */
            var checkNoChangesMode = false;
            /**
             * @return {?}
             */
            function getCheckNoChangesMode() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return checkNoChangesMode;
            }
            /**
             * @param {?} mode
             * @return {?}
             */
            function setCheckNoChangesMode(mode) {
                checkNoChangesMode = mode;
            }
            /**
             * The root index from which pure function instructions should calculate their binding
             * indices. In component views, this is TView.bindingStartIndex. In a host binding
             * context, this is the TView.expandoStartIndex + any dirs/hostVars before the given dir.
             * @type {?}
             */
            var bindingRootIndex = -1;
            // top level variables should not be exported for performance reasons (PERF_NOTES.md)
            /**
             * @return {?}
             */
            function getBindingRoot() {
                return bindingRootIndex;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function setBindingRoot(value) {
                bindingRootIndex = value;
            }
            /**
             * Current index of a View or Content Query which needs to be processed next.
             * We iterate over the list of Queries and increment current query index at every step.
             * @type {?}
             */
            var currentQueryIndex = 0;
            /**
             * @return {?}
             */
            function getCurrentQueryIndex() {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return currentQueryIndex;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function setCurrentQueryIndex(value) {
                currentQueryIndex = value;
            }
            /**
             * Swap the current state with a new state.
             *
             * For performance reasons we store the state in the top level of the module.
             * This way we minimize the number of properties to read. Whenever a new view
             * is entered we have to store the state for later, and when the view is
             * exited the state has to be restored
             *
             * @param {?} newView New state to become active
             * @param {?} hostTNode
             * @return {?} the previous state;
             */
            function enterView(newView, hostTNode) {
                ngDevMode && assertLViewOrUndefined(newView);
                /** @type {?} */
                var oldView = lView;
                if (newView) {
                    /** @type {?} */
                    var tView = newView[TVIEW];
                    bindingRootIndex = tView.bindingStartIndex;
                }
                previousOrParentTNode = ( /** @type {?} */(hostTNode));
                isParent = true;
                lView = contextLView = newView;
                return oldView;
            }
            /**
             * @template T
             * @param {?=} level
             * @return {?}
             */
            function nextContextImpl(level) {
                if (level === void 0) { level = 1; }
                contextLView = walkUpViews(level, ( /** @type {?} */(contextLView)));
                return ( /** @type {?} */(contextLView[CONTEXT]));
            }
            /**
             * @param {?} nestingLevel
             * @param {?} currentView
             * @return {?}
             */
            function walkUpViews(nestingLevel, currentView) {
                while (nestingLevel > 0) {
                    ngDevMode && assertDefined(currentView[DECLARATION_VIEW], 'Declaration view should be defined if nesting level is greater than 0.');
                    currentView = ( /** @type {?} */(currentView[DECLARATION_VIEW]));
                    nestingLevel--;
                }
                return currentView;
            }
            /**
             * Resets the application state.
             * @return {?}
             */
            function resetComponentState() {
                isParent = false;
                previousOrParentTNode = ( /** @type {?} */(null));
                elementDepthCount = 0;
                bindingsEnabled = true;
                setCurrentStyleSanitizer(null);
                resetAllStylingState();
            }
            /**
             * Used in lieu of enterView to make it clear when we are exiting a child view. This makes
             * the direction of traversal (up or down the view tree) a bit clearer.
             *
             * @param {?} newView New state to become active
             * @param {?} safeToRunHooks Whether the runtime is in a state where running lifecycle hooks is valid.
             * This is not always the case (for example, the application may have crashed and `leaveView` is
             * being executed while unwinding the call stack).
             * @return {?}
             */
            function leaveView(newView, safeToRunHooks) {
                /** @type {?} */
                var tView = lView[TVIEW];
                if (isCreationMode(lView)) {
                    lView[FLAGS] &= ~4 /* CreationMode */;
                }
                else {
                    try {
                        resetPreOrderHookFlags(lView);
                        safeToRunHooks && executeHooks(lView, tView.viewHooks, tView.viewCheckHooks, checkNoChangesMode, 2 /* AfterViewInitHooksToBeRun */, undefined);
                    }
                    finally {
                        // Views are clean and in update mode after being checked, so these bits are cleared
                        lView[FLAGS] &= ~(64 /* Dirty */ | 8 /* FirstLViewPass */);
                        lView[BINDING_INDEX] = tView.bindingStartIndex;
                    }
                }
                enterView(newView, null);
            }
            /** @type {?} */
            var _selectedIndex = -1;
            /**
             * Gets the most recent index passed to {\@link select}
             *
             * Used with {\@link property} instruction (and more in the future) to identify the index in the
             * current `LView` to act on.
             * @return {?}
             */
            function getSelectedIndex() {
                return _selectedIndex;
            }
            /**
             * Sets the most recent index passed to {\@link select}
             *
             * Used with {\@link property} instruction (and more in the future) to identify the index in the
             * current `LView` to act on.
             * @param {?} index
             * @return {?}
             */
            function setSelectedIndex(index) {
                _selectedIndex = index;
                // we have now jumped to another element
                // therefore the state is stale
                resetStylingState();
            }
            /** @type {?} */
            var _currentNamespace = null;
            /**
             * Sets the namespace used to create elements to `'http://www.w3.org/2000/svg'` in global state.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵnamespaceSVG() {
                _currentNamespace = 'http://www.w3.org/2000/svg';
            }
            /**
             * Sets the namespace used to create elements to `'http://www.w3.org/1998/MathML/'` in global state.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵnamespaceMathML() {
                _currentNamespace = 'http://www.w3.org/1998/MathML/';
            }
            /**
             * Sets the namespace used to create elements to `null`, which forces element creation to use
             * `createElement` rather than `createElementNS`.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵnamespaceHTML() {
                namespaceHTMLInternal();
            }
            /**
             * Sets the namespace used to create elements to `null`, which forces element creation to use
             * `createElement` rather than `createElementNS`.
             * @return {?}
             */
            function namespaceHTMLInternal() {
                _currentNamespace = null;
            }
            /**
             * @return {?}
             */
            function getNamespace() {
                return _currentNamespace;
            }
            /** @type {?} */
            var _currentSanitizer;
            /**
             * @param {?} sanitizer
             * @return {?}
             */
            function setCurrentStyleSanitizer(sanitizer) {
                _currentSanitizer = sanitizer;
            }
            /**
             * @return {?}
             */
            function getCurrentStyleSanitizer() {
                return _currentSanitizer;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns whether the values are different from a change detection stand point.
             *
             * Constraints are relaxed in checkNoChanges mode. See `devModeEqual` for details.
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function isDifferent(a, b) {
                // NaN is the only value that is not equal to itself so the first
                // test checks if both a and b are not NaN
                return !(a !== a && b !== b) && a !== b;
            }
            /**
             * Used for stringify render output in Ivy.
             * Important! This function is very performance-sensitive and we should
             * be extra careful not to introduce megamorphic reads in it.
             * @param {?} value
             * @return {?}
             */
            function renderStringify(value) {
                if (typeof value === 'string')
                    return value;
                if (value == null)
                    return '';
                return '' + value;
            }
            /**
             * Used to stringify a value so that it can be displayed in an error message.
             * Important! This function contains a megamorphic read and should only be
             * used for error messages.
             * @param {?} value
             * @return {?}
             */
            function stringifyForError(value) {
                if (typeof value === 'function')
                    return value.name || value.toString();
                if (typeof value === 'object' && value != null && typeof value.type === 'function') {
                    return value.type.name || value.type.toString();
                }
                return renderStringify(value);
            }
            var ɵ0$2 = /**
             * @return {?}
             */ function () { return (typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || // browser only
                setTimeout // everything else
            ).bind(_global); };
            /** @type {?} */
            var defaultScheduler = ((ɵ0$2))();
            /**
             *
             * \@codeGenApi
             * @param {?} element
             * @return {?}
             */
            function ɵɵresolveWindow(element) {
                return { name: 'window', target: element.ownerDocument.defaultView };
            }
            /**
             *
             * \@codeGenApi
             * @param {?} element
             * @return {?}
             */
            function ɵɵresolveDocument(element) {
                return { name: 'document', target: element.ownerDocument };
            }
            /**
             *
             * \@codeGenApi
             * @param {?} element
             * @return {?}
             */
            function ɵɵresolveBody(element) {
                return { name: 'body', target: element.ownerDocument.body };
            }
            /**
             * The special delimiter we use to separate property names, prefixes, and suffixes
             * in property binding metadata. See storeBindingMetadata().
             *
             * We intentionally use the Unicode "REPLACEMENT CHARACTER" (U+FFFD) as a delimiter
             * because it is a very uncommon character that is unlikely to be part of a user's
             * property names or interpolation strings. If it is in fact used in a property
             * binding, DebugElement.properties will not return the correct value for that
             * binding. However, there should be no runtime effect for real applications.
             *
             * This character is typically rendered as a question mark inside of a diamond.
             * See https://en.wikipedia.org/wiki/Specials_(Unicode_block)
             *
             * @type {?}
             */
            var INTERPOLATION_DELIMITER = "\uFFFD";
            /**
             * Determines whether or not the given string is a property metadata string.
             * See storeBindingMetadata().
             * @param {?} str
             * @return {?}
             */
            function isPropMetadataString(str) {
                return str.indexOf(INTERPOLATION_DELIMITER) >= 0;
            }
            /**
             * Unwrap a value which might be behind a closure (for forward declaration reasons).
             * @template T
             * @param {?} value
             * @return {?}
             */
            function maybeUnwrapFn(value) {
                if (value instanceof Function) {
                    return value();
                }
                else {
                    return value;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAP_BASED_ENTRY_PROP_NAME = '--MAP--';
            /** @type {?} */
            var TEMPLATE_DIRECTIVE_INDEX = 0;
            /**
             * Creates a new instance of the `TStylingContext`.
             *
             * The `TStylingContext` is used as a manifest of all style or all class bindings on
             * an element. Because it is a T-level data-structure, it is only created once per
             * tNode for styles and for classes. This function allocates a new instance of a
             * `TStylingContext` with the initial values (see `interfaces.ts` for more info).
             * @param {?=} initialStyling
             * @return {?}
             */
            function allocTStylingContext(initialStyling) {
                // because map-based bindings deal with a dynamic set of values, there
                // is no way to know ahead of time whether or not sanitization is required.
                // For this reason the configuration will always mark sanitization as active
                // (this means that when map-based values are applied then sanitization will
                // be checked against each property).
                /** @type {?} */
                var mapBasedConfig = 1 /* SanitizationRequired */;
                return [
                    initialStyling || [''],
                    0 /* Initial */,
                    TEMPLATE_DIRECTIVE_INDEX,
                    mapBasedConfig,
                    0,
                    MAP_BASED_ENTRY_PROP_NAME,
                ];
            }
            /**
             * Sets the provided directive as the last directive index in the provided `TStylingContext`.
             *
             * Styling in Angular can be applied from the template as well as multiple sources of
             * host bindings. This means that each binding function (the template function or the
             * hostBindings functions) will generate styling instructions as well as a styling
             * apply function (i.e. `stylingApply()`). Because host bindings functions and the
             * template function are independent from one another this means that the styling apply
             * function will be called multiple times. By tracking the last directive index (which
             * is what happens in this function) the styling algorithm knows exactly when to flush
             * styling (which is when the last styling apply function is executed).
             * @param {?} context
             * @param {?} lastDirectiveIndex
             * @return {?}
             */
            function updateLastDirectiveIndex(context, lastDirectiveIndex) {
                if (lastDirectiveIndex === TEMPLATE_DIRECTIVE_INDEX) {
                    /** @type {?} */
                    var currentValue = context[2 /* LastDirectiveIndexPosition */];
                    if (currentValue > TEMPLATE_DIRECTIVE_INDEX) {
                        // This means that a directive or two contained a host bindings function, but
                        // now the template function also contains styling. When this combination of sources
                        // comes up then we need to tell the context to store the state between updates
                        // (because host bindings evaluation happens after template binding evaluation).
                        markContextToPersistState(context);
                    }
                }
                else {
                    context[2 /* LastDirectiveIndexPosition */] = lastDirectiveIndex;
                }
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function getConfig(context) {
                return context[1 /* ConfigPosition */];
            }
            /**
             * @param {?} context
             * @param {?} value
             * @return {?}
             */
            function setConfig(context, value) {
                context[1 /* ConfigPosition */] = value;
            }
            /**
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function getProp(context, index) {
                return ( /** @type {?} */(context[index + 2 /* PropOffset */]));
            }
            /**
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function getPropConfig(context, index) {
                return (( /** @type {?} */(context[index + 0 /* ConfigAndGuardOffset */]))) &
                    1 /* Mask */;
            }
            /**
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function isSanitizationRequired(context, index) {
                return (getPropConfig(context, index) & 1 /* SanitizationRequired */) > 0;
            }
            /**
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function getGuardMask(context, index) {
                /** @type {?} */
                var configGuardValue = ( /** @type {?} */(context[index + 0 /* ConfigAndGuardOffset */]));
                return configGuardValue >> 1 /* TotalBits */;
            }
            /**
             * @param {?} context
             * @param {?} index
             * @param {?} maskValue
             * @return {?}
             */
            function setGuardMask(context, index, maskValue) {
                /** @type {?} */
                var config = getPropConfig(context, index);
                /** @type {?} */
                var guardMask = maskValue << 1 /* TotalBits */;
                context[index + 0 /* ConfigAndGuardOffset */] = config | guardMask;
            }
            /**
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function getValuesCount(context, index) {
                return ( /** @type {?} */(context[index + 1 /* ValuesCountOffset */]));
            }
            /**
             * @param {?} context
             * @param {?} index
             * @param {?} offset
             * @return {?}
             */
            function getBindingValue(context, index, offset) {
                return ( /** @type {?} */(context[index + 3 /* BindingsStartOffset */ + offset]));
            }
            /**
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function getDefaultValue(context, index) {
                /** @type {?} */
                var valuesCount = getValuesCount(context, index);
                return ( /** @type {?} */(context[index + 3 /* BindingsStartOffset */ + valuesCount - 1]));
            }
            /**
             * Temporary function which determines whether or not a context is
             * allowed to be flushed based on the provided directive index.
             * @param {?} context
             * @param {?} index
             * @return {?}
             */
            function allowStylingFlush(context, index) {
                return (context && index === context[2 /* LastDirectiveIndexPosition */]) ? true :
                    false;
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function lockContext(context) {
                setConfig(context, getConfig(context) | 1 /* Locked */);
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function isContextLocked(context) {
                return (getConfig(context) & 1 /* Locked */) > 0;
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function stateIsPersisted(context) {
                return (getConfig(context) & 2 /* PersistStateValues */) > 0;
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function markContextToPersistState(context) {
                setConfig(context, getConfig(context) | 2 /* PersistStateValues */);
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function getPropValuesStartPosition(context) {
                return 6 /* MapBindingsBindingsStartPosition */ +
                    context[4 /* MapBindingsValuesCountPosition */];
            }
            /**
             * @param {?} prop
             * @return {?}
             */
            function isMapBased(prop) {
                return prop === MAP_BASED_ENTRY_PROP_NAME;
            }
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function hasValueChanged(a, b) {
                /** @type {?} */
                var compareValueA = Array.isArray(a) ? a[0 /* RawValuePosition */] : a;
                /** @type {?} */
                var compareValueB = Array.isArray(b) ? b[0 /* RawValuePosition */] : b;
                // these are special cases for String based values (which are created as artifacts
                // when sanitization is bypassed on a particular value)
                if (compareValueA instanceof String) {
                    compareValueA = compareValueA.toString();
                }
                if (compareValueB instanceof String) {
                    compareValueB = compareValueB.toString();
                }
                return isDifferent(compareValueA, compareValueB);
            }
            /**
             * Determines whether the provided styling value is truthy or falsy.
             * @param {?} value
             * @return {?}
             */
            function isStylingValueDefined(value) {
                // the reason why null is compared against is because
                // a CSS class value that is set to `false` must be
                // respected (otherwise it would be treated as falsy).
                // Empty string values are because developers usually
                // set a value to an empty string to remove it.
                return value != null && value !== '';
            }
            /**
             * @param {?} a
             * @param {?} b
             * @param {?=} separator
             * @return {?}
             */
            function concatString(a, b, separator) {
                if (separator === void 0) { separator = ' '; }
                return a + ((b.length && a.length) ? separator : '') + b;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function hyphenate(value) {
                return value.replace(/[a-z][A-Z]/g, ( /**
                 * @param {?} v
                 * @return {?}
                 */function (/**
                 * @param {?} v
                 * @return {?}
                 */ v) { return v.charAt(0) + '-' + v.charAt(1); })).toLowerCase();
            }
            /**
             * Returns an instance of `StylingMapArray`.
             *
             * This function is designed to find an instance of `StylingMapArray` in case it is stored
             * inside of an instance of `TStylingContext`. When a styling context is created it
             * will copy over an initial styling values from the tNode (which are stored as a
             * `StylingMapArray` on the `tNode.classes` or `tNode.styles` values).
             * @param {?} value
             * @return {?}
             */
            function getStylingMapArray(value) {
                return isStylingContext(value) ?
                    (( /** @type {?} */(value)))[0 /* InitialStylingValuePosition */] :
                    value;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isStylingContext(value) {
                // the StylingMapArray is in the format of [initial, prop, string, prop, string]
                // and this is the defining value to distinguish between arrays
                return Array.isArray(value) &&
                    value.length >= 6 /* MapBindingsBindingsStartPosition */ &&
                    typeof value[1] !== 'string';
            }
            /**
             * @param {?} context
             * @return {?}
             */
            function getInitialStylingValue(context) {
                /** @type {?} */
                var map = getStylingMapArray(context);
                return map && (( /** @type {?} */(map[0 /* RawValuePosition */]))) || '';
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function hasClassInput(tNode) {
                return (tNode.flags & 8 /* hasClassInput */) !== 0;
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function hasStyleInput(tNode) {
                return (tNode.flags & 16 /* hasStyleInput */) !== 0;
            }
            /**
             * @param {?} map
             * @param {?} index
             * @return {?}
             */
            function getMapProp(map, index) {
                return ( /** @type {?} */(map[index + 0 /* PropOffset */]));
            }
            /**
             * @param {?} map
             * @param {?} index
             * @param {?} value
             * @return {?}
             */
            function setMapValue(map, index, value) {
                map[index + 1 /* ValueOffset */] = value;
            }
            /**
             * @param {?} map
             * @param {?} index
             * @return {?}
             */
            function getMapValue(map, index) {
                return ( /** @type {?} */(map[index + 1 /* ValueOffset */]));
            }
            /**
             * @param {?} classes
             * @return {?}
             */
            function forceClassesAsString(classes) {
                if (classes && typeof classes !== 'string') {
                    classes = Object.keys(classes).join(' ');
                }
                return (( /** @type {?} */(classes))) || '';
            }
            /**
             * @param {?} styles
             * @return {?}
             */
            function forceStylesAsString(styles) {
                /** @type {?} */
                var str = '';
                if (styles) {
                    /** @type {?} */
                    var props = Object.keys(styles);
                    for (var i = 0; i < props.length; i++) {
                        /** @type {?} */
                        var prop = props[i];
                        str = concatString(str, prop + ":" + styles[prop], ';');
                    }
                }
                return str;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * The goal here is to make sure that the browser DOM API is the Renderer.
             * We do this by defining a subset of DOM API to be the renderer and than
             * use that time for rendering.
             *
             * At runtime we can then use the DOM api directly, in server or web-worker
             * it will be easy to implement such API.
             */
            /** @enum {number} */
            var RendererStyleFlags3 = {
                Important: 1,
                DashCase: 2,
            };
            RendererStyleFlags3[RendererStyleFlags3.Important] = 'Important';
            RendererStyleFlags3[RendererStyleFlags3.DashCase] = 'DashCase';
            /**
             * Object Oriented style of API needed to create elements and text nodes.
             *
             * This is the native browser API style, e.g. operations are methods on individual objects
             * like HTMLElement. With this style, no additional code is needed as a facade
             * (reducing payload size).
             *
             * @record
             */
            function ObjectOrientedRenderer3() { }
            if (false) { }
            /**
             * Returns whether the `renderer` is a `ProceduralRenderer3`
             * @param {?} renderer
             * @return {?}
             */
            function isProceduralRenderer(renderer) {
                return !!((( /** @type {?} */(renderer))).listen);
            }
            /**
             * Procedural style of API needed to create elements and text nodes.
             *
             * In non-native browser environments (e.g. platforms such as web-workers), this is the
             * facade that enables element manipulation. This also facilitates backwards compatibility
             * with Renderer2.
             * @record
             */
            function ProceduralRenderer3() { }
            if (false) { }
            /**
             * @record
             */
            function RendererFactory3() { }
            if (false) { }
            var ɵ0$3 = /**
             * @param {?} hostElement
             * @param {?} rendererType
             * @return {?}
             */ function (hostElement, rendererType) { return document; };
            /** @type {?} */
            var domRendererFactory3 = {
                createRenderer: (ɵ0$3)
            };
            /**
             * Subset of API needed for appending elements and text nodes.
             * @record
             */
            function RNode() { }
            if (false) { }
            /**
             * Subset of API needed for writing attributes, properties, and setting up
             * listeners on Element.
             * @record
             */
            function RElement() { }
            if (false) { }
            /**
             * @record
             */
            function RCssStyleDeclaration() { }
            if (false) { }
            /**
             * @record
             */
            function RDomTokenList() { }
            if (false) { }
            /**
             * @record
             */
            function RText() { }
            if (false) { }
            /**
             * @record
             */
            function RComment() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$3 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Assigns all attribute values to the provided element via the inferred renderer.
             *
             * This function accepts two forms of attribute entries:
             *
             * default: (key, value):
             *  attrs = [key1, value1, key2, value2]
             *
             * namespaced: (NAMESPACE_MARKER, uri, name, value)
             *  attrs = [NAMESPACE_MARKER, uri, name, value, NAMESPACE_MARKER, uri, name, value]
             *
             * The `attrs` array can contain a mix of both the default and namespaced entries.
             * The "default" values are set without a marker, but if the function comes across
             * a marker value then it will attempt to set a namespaced value. If the marker is
             * not of a namespaced value then the function will quit and return the index value
             * where it stopped during the iteration of the attrs array.
             *
             * See [AttributeMarker] to understand what the namespace marker value is.
             *
             * Note that this instruction does not support assigning style and class values to
             * an element. See `elementStart` and `elementHostAttrs` to learn how styling values
             * are applied to an element.
             *
             * @param {?} native The element that the attributes will be assigned to
             * @param {?} attrs The attribute array of values that will be assigned to the element
             * @return {?} the index value that was last accessed in the attributes array
             */
            function setUpAttributes(native, attrs) {
                /** @type {?} */
                var renderer = getLView()[RENDERER];
                /** @type {?} */
                var isProc = isProceduralRenderer(renderer);
                /** @type {?} */
                var i = 0;
                while (i < attrs.length) {
                    /** @type {?} */
                    var value = attrs[i];
                    if (typeof value === 'number') {
                        // only namespaces are supported. Other value types (such as style/class
                        // entries) are not supported in this function.
                        if (value !== 0 /* NamespaceURI */) {
                            break;
                        }
                        // we just landed on the marker value ... therefore
                        // we should skip to the next entry
                        i++;
                        /** @type {?} */
                        var namespaceURI = ( /** @type {?} */(attrs[i++]));
                        /** @type {?} */
                        var attrName = ( /** @type {?} */(attrs[i++]));
                        /** @type {?} */
                        var attrVal = ( /** @type {?} */(attrs[i++]));
                        ngDevMode && ngDevMode.rendererSetAttribute++;
                        isProc ?
                            (( /** @type {?} */(renderer))).setAttribute(native, attrName, attrVal, namespaceURI) :
                            native.setAttributeNS(namespaceURI, attrName, attrVal);
                    }
                    else {
                        // attrName is string;
                        /** @type {?} */
                        var attrName = ( /** @type {?} */(value));
                        /** @type {?} */
                        var attrVal = attrs[++i];
                        // Standard attributes
                        ngDevMode && ngDevMode.rendererSetAttribute++;
                        if (isAnimationProp(attrName)) {
                            if (isProc) {
                                (( /** @type {?} */(renderer))).setProperty(native, attrName, attrVal);
                            }
                        }
                        else {
                            isProc ?
                                (( /** @type {?} */(renderer)))
                                    .setAttribute(native, ( /** @type {?} */(attrName)), ( /** @type {?} */(attrVal))) :
                                native.setAttribute(( /** @type {?} */(attrName)), ( /** @type {?} */(attrVal)));
                        }
                        i++;
                    }
                }
                // another piece of code may iterate over the same attributes array. Therefore
                // it may be helpful to return the exact spot where the attributes array exited
                // whether by running into an unsupported marker or if all the static values were
                // iterated over.
                return i;
            }
            /**
             * @param {?} attrs
             * @param {?} startIndex
             * @return {?}
             */
            function attrsStylingIndexOf(attrs, startIndex) {
                for (var i = startIndex; i < attrs.length; i++) {
                    /** @type {?} */
                    var val = attrs[i];
                    if (val === 1 /* Classes */ || val === 2 /* Styles */) {
                        return i;
                    }
                }
                return -1;
            }
            /**
             * Test whether the given value is a marker that indicates that the following
             * attribute values in a `TAttributes` array are only the names of attributes,
             * and not name-value pairs.
             * @param {?} marker The attribute marker to test.
             * @return {?} true if the marker is a "name-only" marker (e.g. `Bindings`, `Template` or `I18n`).
             */
            function isNameOnlyAttributeMarker(marker) {
                return marker === 3 /* Bindings */ || marker === 4 /* Template */ ||
                    marker === 6 /* I18n */;
            }
            /** @type {?} */
            var ANIMATION_PROP_PREFIX = '@';
            /**
             * @param {?} name
             * @return {?}
             */
            function isAnimationProp(name) {
                return name[0] === ANIMATION_PROP_PREFIX;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /// Parent Injector Utils ///////////////////////////////////////////////////////////////
            /**
             * @param {?} parentLocation
             * @return {?}
             */
            function hasParentInjector(parentLocation) {
                return parentLocation !== NO_PARENT_INJECTOR;
            }
            /**
             * @param {?} parentLocation
             * @return {?}
             */
            function getParentInjectorIndex(parentLocation) {
                return (( /** @type {?} */(( /** @type {?} */(parentLocation))))) & 32767 /* InjectorIndexMask */;
            }
            /**
             * @param {?} parentLocation
             * @return {?}
             */
            function getParentInjectorViewOffset(parentLocation) {
                return (( /** @type {?} */(( /** @type {?} */(parentLocation))))) >> 16 /* ViewOffsetShift */;
            }
            /**
             * Unwraps a parent injector location number to find the view offset from the current injector,
             * then walks up the declaration view tree until the view is found that contains the parent
             * injector.
             *
             * @param {?} location The location of the parent injector, which contains the view offset
             * @param {?} startView The LView instance from which to start walking up the view tree
             * @return {?} The LView instance that contains the parent injector
             */
            function getParentInjectorView(location, startView) {
                /** @type {?} */
                var viewOffset = getParentInjectorViewOffset(location);
                /** @type {?} */
                var parentView = startView;
                // For most cases, the parent injector can be found on the host node (e.g. for component
                // or container), but we must keep the loop here to support the rarer case of deeply nested
                // <ng-template> tags or inline views, where the parent injector might live many views
                // above the child injector.
                while (viewOffset > 0) {
                    parentView = ( /** @type {?} */(parentView[DECLARATION_VIEW]));
                    viewOffset--;
                }
                return parentView;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Gets the parent LView of the passed LView, if the PARENT is an LContainer, will get the parent of
             * that LContainer, which is an LView
             * @param {?} lView the lView whose parent to get
             * @return {?}
             */
            function getLViewParent(lView) {
                ngDevMode && assertLView(lView);
                /** @type {?} */
                var parent = lView[PARENT];
                return isLContainer(parent) ? ( /** @type {?} */(parent[PARENT])) : parent;
            }
            /**
             * Retrieve the root view from any component or `LView` by walking the parent `LView` until
             * reaching the root `LView`.
             *
             * @param {?} componentOrLView any component or `LView`
             * @return {?}
             */
            function getRootView(componentOrLView) {
                ngDevMode && assertDefined(componentOrLView, 'component');
                /** @type {?} */
                var lView = isLView(componentOrLView) ? componentOrLView : ( /** @type {?} */(readPatchedLView(componentOrLView)));
                while (lView && !(lView[FLAGS] & 512 /* IsRoot */)) {
                    lView = ( /** @type {?} */(getLViewParent(lView)));
                }
                ngDevMode && assertLView(lView);
                return lView;
            }
            /**
             * Given an `LView`, find the closest declaration view which is not an embedded view.
             *
             * This method searches for the `LView` associated with the component which declared the `LView`.
             *
             * This function may return itself if the `LView` passed in is not an embedded `LView`. Otherwise
             * it walks the declaration parents until it finds a component view (non-embedded-view.)
             *
             * @param {?} lView LView for which we want a host element node
             * @return {?} The host node
             */
            function findComponentView(lView) {
                /** @type {?} */
                var rootTNode = lView[T_HOST];
                while (rootTNode !== null && rootTNode.type === 2 /* View */) {
                    ngDevMode && assertDefined(lView[DECLARATION_VIEW], 'lView[DECLARATION_VIEW]');
                    lView = ( /** @type {?} */(lView[DECLARATION_VIEW]));
                    rootTNode = lView[T_HOST];
                }
                ngDevMode && assertLView(lView);
                return lView;
            }
            /**
             * Returns the `RootContext` instance that is associated with
             * the application where the target is situated. It does this by walking the parent views until it
             * gets to the root view, then getting the context off of that.
             *
             * @param {?} viewOrComponent the `LView` or component to get the root context for.
             * @return {?}
             */
            function getRootContext(viewOrComponent) {
                /** @type {?} */
                var rootView = getRootView(viewOrComponent);
                ngDevMode &&
                    assertDefined(rootView[CONTEXT], 'RootView has no context. Perhaps it is disconnected?');
                return ( /** @type {?} */(rootView[CONTEXT]));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Defines if the call to `inject` should include `viewProviders` in its resolution.
             *
             * This is set to true when we try to instantiate a component. This value is reset in
             * `getNodeInjectable` to a value which matches the declaration location of the token about to be
             * instantiated. This is done so that if we are injecting a token which was declared outside of
             * `viewProviders` we don't accidentally pull `viewProviders` in.
             *
             * Example:
             *
             * ```
             * \@Injectable()
             * class MyService {
             *   constructor(public value: String) {}
             * }
             *
             * \@Component({
             *   providers: [
             *     MyService,
             *     {provide: String, value: 'providers' }
             *   ]
             *   viewProviders: [
             *     {provide: String, value: 'viewProviders'}
             *   ]
             * })
             * class MyComponent {
             *   constructor(myService: MyService, value: String) {
             *     // We expect that Component can see into `viewProviders`.
             *     expect(value).toEqual('viewProviders');
             *     // `MyService` was not declared in `viewProviders` hence it can't see it.
             *     expect(myService.value).toEqual('providers');
             *   }
             * }
             *
             * ```
             * @type {?}
             */
            var includeViewProviders = true;
            /**
             * @param {?} v
             * @return {?}
             */
            function setIncludeViewProviders(v) {
                /** @type {?} */
                var oldValue = includeViewProviders;
                includeViewProviders = v;
                return oldValue;
            }
            /**
             * The number of slots in each bloom filter (used by DI). The larger this number, the fewer
             * directives that will share slots, and thus, the fewer false positives when checking for
             * the existence of a directive.
             * @type {?}
             */
            var BLOOM_SIZE = 256;
            /** @type {?} */
            var BLOOM_MASK = BLOOM_SIZE - 1;
            /**
             * Counter used to generate unique IDs for directives.
             * @type {?}
             */
            var nextNgElementId = 0;
            /**
             * Registers this directive as present in its node's injector by flipping the directive's
             * corresponding bit in the injector's bloom filter.
             *
             * @param {?} injectorIndex The index of the node injector where this token should be registered
             * @param {?} tView The TView for the injector's bloom filters
             * @param {?} type The directive token to register
             * @return {?}
             */
            function bloomAdd(injectorIndex, tView, type) {
                ngDevMode && assertEqual(tView.firstTemplatePass, true, 'expected firstTemplatePass to be true');
                /** @type {?} */
                var id = typeof type !== 'string' ? (( /** @type {?} */(type)))[NG_ELEMENT_ID] : type.charCodeAt(0) || 0;
                // Set a unique ID on the directive type, so if something tries to inject the directive,
                // we can easily retrieve the ID and hash it into the bloom bit that should be checked.
                if (id == null) {
                    id = (( /** @type {?} */(type)))[NG_ELEMENT_ID] = nextNgElementId++;
                }
                // We only have BLOOM_SIZE (256) slots in our bloom filter (8 buckets * 32 bits each),
                // so all unique IDs must be modulo-ed into a number from 0 - 255 to fit into the filter.
                /** @type {?} */
                var bloomBit = id & BLOOM_MASK;
                // Create a mask that targets the specific bit associated with the directive.
                // JS bit operations are 32 bits, so this will be a number between 2^0 and 2^31, corresponding
                // to bit positions 0 - 31 in a 32 bit integer.
                /** @type {?} */
                var mask = 1 << bloomBit;
                // Use the raw bloomBit number to determine which bloom filter bucket we should check
                // e.g: bf0 = [0 - 31], bf1 = [32 - 63], bf2 = [64 - 95], bf3 = [96 - 127], etc
                /** @type {?} */
                var b7 = bloomBit & 0x80;
                /** @type {?} */
                var b6 = bloomBit & 0x40;
                /** @type {?} */
                var b5 = bloomBit & 0x20;
                /** @type {?} */
                var tData = ( /** @type {?} */(tView.data));
                if (b7) {
                    b6 ? (b5 ? (tData[injectorIndex + 7] |= mask) : (tData[injectorIndex + 6] |= mask)) :
                        (b5 ? (tData[injectorIndex + 5] |= mask) : (tData[injectorIndex + 4] |= mask));
                }
                else {
                    b6 ? (b5 ? (tData[injectorIndex + 3] |= mask) : (tData[injectorIndex + 2] |= mask)) :
                        (b5 ? (tData[injectorIndex + 1] |= mask) : (tData[injectorIndex] |= mask));
                }
            }
            /**
             * Creates (or gets an existing) injector for a given element or container.
             *
             * @param {?} tNode for which an injector should be retrieved / created.
             * @param {?} hostView View where the node is stored
             * @return {?} Node injector
             */
            function getOrCreateNodeInjectorForNode(tNode, hostView) {
                /** @type {?} */
                var existingInjectorIndex = getInjectorIndex(tNode, hostView);
                if (existingInjectorIndex !== -1) {
                    return existingInjectorIndex;
                }
                /** @type {?} */
                var tView = hostView[TVIEW];
                if (tView.firstTemplatePass) {
                    tNode.injectorIndex = hostView.length;
                    insertBloom(tView.data, tNode); // foundation for node bloom
                    insertBloom(hostView, null); // foundation for cumulative bloom
                    insertBloom(tView.blueprint, null);
                    ngDevMode && assertEqual(tNode.flags === 0 || tNode.flags === 1 /* isComponent */, true, 'expected tNode.flags to not be initialized');
                }
                /** @type {?} */
                var parentLoc = getParentInjectorLocation(tNode, hostView);
                /** @type {?} */
                var parentIndex = getParentInjectorIndex(parentLoc);
                /** @type {?} */
                var parentLView = getParentInjectorView(parentLoc, hostView);
                /** @type {?} */
                var injectorIndex = tNode.injectorIndex;
                // If a parent injector can't be found, its location is set to -1.
                // In that case, we don't need to set up a cumulative bloom
                if (hasParentInjector(parentLoc)) {
                    /** @type {?} */
                    var parentData = ( /** @type {?} */(parentLView[TVIEW].data));
                    // Creates a cumulative bloom filter that merges the parent's bloom filter
                    // and its own cumulative bloom (which contains tokens for all ancestors)
                    for (var i = 0; i < 8; i++) {
                        hostView[injectorIndex + i] = parentLView[parentIndex + i] | parentData[parentIndex + i];
                    }
                }
                hostView[injectorIndex + PARENT_INJECTOR] = parentLoc;
                return injectorIndex;
            }
            /**
             * @param {?} arr
             * @param {?} footer
             * @return {?}
             */
            function insertBloom(arr, footer) {
                arr.push(0, 0, 0, 0, 0, 0, 0, 0, footer);
            }
            /**
             * @param {?} tNode
             * @param {?} hostView
             * @return {?}
             */
            function getInjectorIndex(tNode, hostView) {
                if (tNode.injectorIndex === -1 ||
                    // If the injector index is the same as its parent's injector index, then the index has been
                    // copied down from the parent node. No injector has been created yet on this node.
                    (tNode.parent && tNode.parent.injectorIndex === tNode.injectorIndex) ||
                    // After the first template pass, the injector index might exist but the parent values
                    // might not have been calculated yet for this instance
                    hostView[tNode.injectorIndex + PARENT_INJECTOR] == null) {
                    return -1;
                }
                else {
                    return tNode.injectorIndex;
                }
            }
            /**
             * Finds the index of the parent injector, with a view offset if applicable. Used to set the
             * parent injector initially.
             *
             * Returns a combination of number of `ViewData` we have to go up and index in that `Viewdata`
             * @param {?} tNode
             * @param {?} view
             * @return {?}
             */
            function getParentInjectorLocation(tNode, view) {
                if (tNode.parent && tNode.parent.injectorIndex !== -1) {
                    return ( /** @type {?} */(tNode.parent.injectorIndex)); // ViewOffset is 0
                }
                // For most cases, the parent injector index can be found on the host node (e.g. for component
                // or container), so this loop will be skipped, but we must keep the loop here to support
                // the rarer case of deeply nested <ng-template> tags or inline views.
                /** @type {?} */
                var hostTNode = view[T_HOST];
                /** @type {?} */
                var viewOffset = 1;
                while (hostTNode && hostTNode.injectorIndex === -1) {
                    view = ( /** @type {?} */(view[DECLARATION_VIEW]));
                    hostTNode = view ? view[T_HOST] : null;
                    viewOffset++;
                }
                return hostTNode ?
                    hostTNode.injectorIndex | (viewOffset << 16 /* ViewOffsetShift */) :
                    ( /** @type {?} */(-1));
            }
            /**
             * Makes a type or an injection token public to the DI system by adding it to an
             * injector's bloom filter.
             *
             * @param {?} injectorIndex
             * @param {?} tView
             * @param {?} token The type or the injection token to be made public
             * @return {?}
             */
            function diPublicInInjector(injectorIndex, tView, token) {
                bloomAdd(injectorIndex, tView, token);
            }
            /**
             * Inject static attribute value into directive constructor.
             *
             * This method is used with `factory` functions which are generated as part of
             * `defineDirective` or `defineComponent`. The method retrieves the static value
             * of an attribute. (Dynamic attributes are not supported since they are not resolved
             *  at the time of injection and can change over time.)
             *
             * # Example
             * Given:
             * ```
             * \@Component(...)
             * class MyComponent {
             *   constructor(\@Attribute('title') title: string) { ... }
             * }
             * ```
             * When instantiated with
             * ```
             * <my-component title="Hello"></my-component>
             * ```
             *
             * Then factory method generated is:
             * ```
             * MyComponent.ngComponentDef = defineComponent({
             *   factory: () => new MyComponent(injectAttribute('title'))
             *   ...
             * })
             * ```
             *
             * \@publicApi
             * @param {?} tNode
             * @param {?} attrNameToInject
             * @return {?}
             */
            function injectAttributeImpl(tNode, attrNameToInject) {
                ngDevMode && assertNodeOfPossibleTypes(tNode, 0 /* Container */, 3 /* Element */, 4 /* ElementContainer */);
                ngDevMode && assertDefined(tNode, 'expecting tNode');
                if (attrNameToInject === 'class') {
                    return getInitialStylingValue(tNode.classes);
                }
                if (attrNameToInject === 'style') {
                    return getInitialStylingValue(tNode.styles);
                }
                /** @type {?} */
                var attrs = tNode.attrs;
                if (attrs) {
                    /** @type {?} */
                    var attrsLength = attrs.length;
                    /** @type {?} */
                    var i = 0;
                    while (i < attrsLength) {
                        /** @type {?} */
                        var value = attrs[i];
                        // If we hit a `Bindings` or `Template` marker then we are done.
                        if (isNameOnlyAttributeMarker(value))
                            break;
                        // Skip namespaced attributes
                        if (value === 0 /* NamespaceURI */) {
                            // we skip the next two values
                            // as namespaced attributes looks like
                            // [..., AttributeMarker.NamespaceURI, 'http://someuri.com/test', 'test:exist',
                            // 'existValue', ...]
                            i = i + 2;
                        }
                        else if (typeof value === 'number') {
                            // Skip to the first value of the marked attribute.
                            i++;
                            while (i < attrsLength && typeof attrs[i] === 'string') {
                                i++;
                            }
                        }
                        else if (value === attrNameToInject) {
                            return ( /** @type {?} */(attrs[i + 1]));
                        }
                        else {
                            i = i + 2;
                        }
                    }
                }
                return null;
            }
            /**
             * Returns the value associated to the given token from the NodeInjectors => ModuleInjector.
             *
             * Look for the injector providing the token by walking up the node injector tree and then
             * the module injector tree.
             *
             * This function patches `token` with `__NG_ELEMENT_ID__` which contains the id for the bloom
             * filter. Negative values are reserved for special objects.
             *   - `-1` is reserved for injecting `Injector` (implemented by `NodeInjector`)
             *
             * @template T
             * @param {?} tNode The Node where the search for the injector should start
             * @param {?} lView The `LView` that contains the `tNode`
             * @param {?} token The token to look for
             * @param {?=} flags Injection flags
             * @param {?=} notFoundValue The value to return when the injection flags is `InjectFlags.Optional`
             * @return {?} the value from the injector, `null` when not found, or `notFoundValue` if provided
             */
            function getOrCreateInjectable(tNode, lView, token, flags, notFoundValue) {
                if (flags === void 0) { flags = InjectFlags.Default; }
                if (tNode) {
                    /** @type {?} */
                    var bloomHash = bloomHashBitOrFactory(token);
                    // If the ID stored here is a function, this is a special object like ElementRef or TemplateRef
                    // so just call the factory function to create it.
                    if (typeof bloomHash === 'function') {
                        /** @type {?} */
                        var savePreviousOrParentTNode = getPreviousOrParentTNode();
                        /** @type {?} */
                        var saveLView = getLView();
                        setTNodeAndViewData(tNode, lView);
                        try {
                            /** @type {?} */
                            var value = bloomHash();
                            if (value == null && !(flags & InjectFlags.Optional)) {
                                throw new Error("No provider for " + stringifyForError(token) + "!");
                            }
                            else {
                                return value;
                            }
                        }
                        finally {
                            setTNodeAndViewData(savePreviousOrParentTNode, saveLView);
                        }
                    }
                    else if (typeof bloomHash == 'number') {
                        if (bloomHash === -1) {
                            // `-1` is a special value used to identify `Injector` types.
                            return ( /** @type {?} */(new NodeInjector(tNode, lView)));
                        }
                        // If the token has a bloom hash, then it is a token which could be in NodeInjector.
                        // A reference to the previous injector TView that was found while climbing the element
                        // injector tree. This is used to know if viewProviders can be accessed on the current
                        // injector.
                        /** @type {?} */
                        var previousTView = null;
                        /** @type {?} */
                        var injectorIndex = getInjectorIndex(tNode, lView);
                        /** @type {?} */
                        var parentLocation = NO_PARENT_INJECTOR;
                        /** @type {?} */
                        var hostTElementNode = flags & InjectFlags.Host ? findComponentView(lView)[T_HOST] : null;
                        // If we should skip this injector, or if there is no injector on this node, start by
                        // searching
                        // the parent injector.
                        if (injectorIndex === -1 || flags & InjectFlags.SkipSelf) {
                            parentLocation = injectorIndex === -1 ? getParentInjectorLocation(tNode, lView) :
                                lView[injectorIndex + PARENT_INJECTOR];
                            if (!shouldSearchParent(flags, false)) {
                                injectorIndex = -1;
                            }
                            else {
                                previousTView = lView[TVIEW];
                                injectorIndex = getParentInjectorIndex(parentLocation);
                                lView = getParentInjectorView(parentLocation, lView);
                            }
                        }
                        // Traverse up the injector tree until we find a potential match or until we know there
                        // *isn't* a match.
                        while (injectorIndex !== -1) {
                            parentLocation = lView[injectorIndex + PARENT_INJECTOR];
                            // Check the current injector. If it matches, see if it contains token.
                            /** @type {?} */
                            var tView = lView[TVIEW];
                            if (bloomHasToken(bloomHash, injectorIndex, tView.data)) {
                                // At this point, we have an injector which *may* contain the token, so we step through
                                // the providers and directives associated with the injector's corresponding node to get
                                // the instance.
                                /** @type {?} */
                                var instance = searchTokensOnInjector(injectorIndex, lView, token, previousTView, flags, hostTElementNode);
                                if (instance !== NOT_FOUND) {
                                    return instance;
                                }
                            }
                            if (shouldSearchParent(flags, lView[TVIEW].data[injectorIndex + TNODE] === hostTElementNode) &&
                                bloomHasToken(bloomHash, injectorIndex, lView)) {
                                // The def wasn't found anywhere on this node, so it was a false positive.
                                // Traverse up the tree and continue searching.
                                previousTView = tView;
                                injectorIndex = getParentInjectorIndex(parentLocation);
                                lView = getParentInjectorView(parentLocation, lView);
                            }
                            else {
                                // If we should not search parent OR If the ancestor bloom filter value does not have the
                                // bit corresponding to the directive we can give up on traversing up to find the specific
                                // injector.
                                injectorIndex = -1;
                            }
                        }
                    }
                }
                if (flags & InjectFlags.Optional && notFoundValue === undefined) {
                    // This must be set or the NullInjector will throw for optional deps
                    notFoundValue = null;
                }
                if ((flags & (InjectFlags.Self | InjectFlags.Host)) === 0) {
                    /** @type {?} */
                    var moduleInjector = lView[INJECTOR$1];
                    // switch to `injectInjectorOnly` implementation for module injector, since module injector
                    // should not have access to Component/Directive DI scope (that may happen through
                    // `directiveInject` implementation)
                    /** @type {?} */
                    var previousInjectImplementation = setInjectImplementation(undefined);
                    try {
                        if (moduleInjector) {
                            return moduleInjector.get(token, notFoundValue, flags & InjectFlags.Optional);
                        }
                        else {
                            return injectRootLimpMode(token, notFoundValue, flags & InjectFlags.Optional);
                        }
                    }
                    finally {
                        setInjectImplementation(previousInjectImplementation);
                    }
                }
                if (flags & InjectFlags.Optional) {
                    return notFoundValue;
                }
                else {
                    throw new Error("NodeInjector: NOT_FOUND [" + stringifyForError(token) + "]");
                }
            }
            /** @type {?} */
            var NOT_FOUND = {};
            /**
             * @template T
             * @param {?} injectorIndex
             * @param {?} lView
             * @param {?} token
             * @param {?} previousTView
             * @param {?} flags
             * @param {?} hostTElementNode
             * @return {?}
             */
            function searchTokensOnInjector(injectorIndex, lView, token, previousTView, flags, hostTElementNode) {
                /** @type {?} */
                var currentTView = lView[TVIEW];
                /** @type {?} */
                var tNode = ( /** @type {?} */(currentTView.data[injectorIndex + TNODE]));
                // First, we need to determine if view providers can be accessed by the starting element.
                // There are two possibities
                /** @type {?} */
                var canAccessViewProviders = previousTView == null ?
                    // 1) This is the first invocation `previousTView == null` which means that we are at the
                    // `TNode` of where injector is starting to look. In such a case the only time we are allowed
                    // to look into the ViewProviders is if:
                    // - we are on a component
                    // - AND the injector set `includeViewProviders` to true (implying that the token can see
                    // ViewProviders because it is the Component or a Service which itself was declared in
                    // ViewProviders)
                    (isComponent(tNode) && includeViewProviders) :
                    // 2) `previousTView != null` which means that we are now walking across the parent nodes.
                    // In such a case we are only allowed to look into the ViewProviders if:
                    // - We just crossed from child View to Parent View `previousTView != currentTView`
                    // - AND the parent TNode is an Element.
                    // This means that we just came from the Component's View and therefore are allowed to see
                    // into the ViewProviders.
                    (previousTView != currentTView && (tNode.type === 3 /* Element */));
                // This special case happens when there is a @host on the inject and when we are searching
                // on the host element node.
                /** @type {?} */
                var isHostSpecialCase = (flags & InjectFlags.Host) && hostTElementNode === tNode;
                /** @type {?} */
                var injectableIdx = locateDirectiveOrProvider(tNode, currentTView, token, canAccessViewProviders, isHostSpecialCase);
                if (injectableIdx !== null) {
                    return getNodeInjectable(currentTView.data, lView, injectableIdx, ( /** @type {?} */(tNode)));
                }
                else {
                    return NOT_FOUND;
                }
            }
            /**
             * Searches for the given token among the node's directives and providers.
             *
             * @template T
             * @param {?} tNode TNode on which directives are present.
             * @param {?} tView The tView we are currently processing
             * @param {?} token Provider token or type of a directive to look for.
             * @param {?} canAccessViewProviders Whether view providers should be considered.
             * @param {?} isHostSpecialCase Whether the host special case applies.
             * @return {?} Index of a found directive or provider, or null when none found.
             */
            function locateDirectiveOrProvider(tNode, tView, token, canAccessViewProviders, isHostSpecialCase) {
                /** @type {?} */
                var nodeProviderIndexes = tNode.providerIndexes;
                /** @type {?} */
                var tInjectables = tView.data;
                /** @type {?} */
                var injectablesStart = nodeProviderIndexes & 65535 /* ProvidersStartIndexMask */;
                /** @type {?} */
                var directivesStart = tNode.directiveStart;
                /** @type {?} */
                var directiveEnd = tNode.directiveEnd;
                /** @type {?} */
                var cptViewProvidersCount = nodeProviderIndexes >> 16 /* CptViewProvidersCountShift */;
                /** @type {?} */
                var startingIndex = canAccessViewProviders ? injectablesStart : injectablesStart + cptViewProvidersCount;
                // When the host special case applies, only the viewProviders and the component are visible
                /** @type {?} */
                var endIndex = isHostSpecialCase ? injectablesStart + cptViewProvidersCount : directiveEnd;
                for (var i = startingIndex; i < endIndex; i++) {
                    /** @type {?} */
                    var providerTokenOrDef = ( /** @type {?} */(tInjectables[i]));
                    if (i < directivesStart && token === providerTokenOrDef ||
                        i >= directivesStart && (( /** @type {?} */(providerTokenOrDef))).type === token) {
                        return i;
                    }
                }
                if (isHostSpecialCase) {
                    /** @type {?} */
                    var dirDef = ( /** @type {?} */(tInjectables[directivesStart]));
                    if (dirDef && isComponentDef(dirDef) && dirDef.type === token) {
                        return directivesStart;
                    }
                }
                return null;
            }
            /**
             * Retrieve or instantiate the injectable from the `lData` at particular `index`.
             *
             * This function checks to see if the value has already been instantiated and if so returns the
             * cached `injectable`. Otherwise if it detects that the value is still a factory it
             * instantiates the `injectable` and caches the value.
             * @param {?} tData
             * @param {?} lData
             * @param {?} index
             * @param {?} tNode
             * @return {?}
             */
            function getNodeInjectable(tData, lData, index, tNode) {
                /** @type {?} */
                var value = lData[index];
                if (isFactory(value)) {
                    /** @type {?} */
                    var factory = value;
                    if (factory.resolving) {
                        throw new Error("Circular dep for " + stringifyForError(tData[index]));
                    }
                    /** @type {?} */
                    var previousIncludeViewProviders = setIncludeViewProviders(factory.canSeeViewProviders);
                    factory.resolving = true;
                    /** @type {?} */
                    var previousInjectImplementation = void 0;
                    if (factory.injectImpl) {
                        previousInjectImplementation = setInjectImplementation(factory.injectImpl);
                    }
                    /** @type {?} */
                    var savePreviousOrParentTNode = getPreviousOrParentTNode();
                    /** @type {?} */
                    var saveLView = getLView();
                    setTNodeAndViewData(tNode, lData);
                    try {
                        value = lData[index] = factory.factory(undefined, tData, lData, tNode);
                    }
                    finally {
                        if (factory.injectImpl)
                            setInjectImplementation(previousInjectImplementation);
                        setIncludeViewProviders(previousIncludeViewProviders);
                        factory.resolving = false;
                        setTNodeAndViewData(savePreviousOrParentTNode, saveLView);
                    }
                }
                return value;
            }
            /**
             * Returns the bit in an injector's bloom filter that should be used to determine whether or not
             * the directive might be provided by the injector.
             *
             * When a directive is public, it is added to the bloom filter and given a unique ID that can be
             * retrieved on the Type. When the directive isn't public or the token is not a directive `null`
             * is returned as the node injector can not possibly provide that token.
             *
             * @param {?} token the injection token
             * @return {?} the matching bit to check in the bloom filter or `null` if the token is not known.
             *   When the returned value is negative then it represents special values such as `Injector`.
             */
            function bloomHashBitOrFactory(token) {
                ngDevMode && assertDefined(token, 'token must be defined');
                if (typeof token === 'string') {
                    return token.charCodeAt(0) || 0;
                }
                /** @type {?} */
                var tokenId = (( /** @type {?} */(token)))[NG_ELEMENT_ID];
                // Negative token IDs are used for special objects such as `Injector`
                return (typeof tokenId === 'number' && tokenId > 0) ? tokenId & BLOOM_MASK : tokenId;
            }
            /**
             * @param {?} bloomHash
             * @param {?} injectorIndex
             * @param {?} injectorView
             * @return {?}
             */
            function bloomHasToken(bloomHash, injectorIndex, injectorView) {
                // Create a mask that targets the specific bit associated with the directive we're looking for.
                // JS bit operations are 32 bits, so this will be a number between 2^0 and 2^31, corresponding
                // to bit positions 0 - 31 in a 32 bit integer.
                /** @type {?} */
                var mask = 1 << bloomHash;
                /** @type {?} */
                var b7 = bloomHash & 0x80;
                /** @type {?} */
                var b6 = bloomHash & 0x40;
                /** @type {?} */
                var b5 = bloomHash & 0x20;
                // Our bloom filter size is 256 bits, which is eight 32-bit bloom filter buckets:
                // bf0 = [0 - 31], bf1 = [32 - 63], bf2 = [64 - 95], bf3 = [96 - 127], etc.
                // Get the bloom filter value from the appropriate bucket based on the directive's bloomBit.
                /** @type {?} */
                var value;
                if (b7) {
                    value = b6 ? (b5 ? injectorView[injectorIndex + 7] : injectorView[injectorIndex + 6]) :
                        (b5 ? injectorView[injectorIndex + 5] : injectorView[injectorIndex + 4]);
                }
                else {
                    value = b6 ? (b5 ? injectorView[injectorIndex + 3] : injectorView[injectorIndex + 2]) :
                        (b5 ? injectorView[injectorIndex + 1] : injectorView[injectorIndex]);
                }
                // If the bloom filter value has the bit corresponding to the directive's bloomBit flipped on,
                // this injector is a potential match.
                return !!(value & mask);
            }
            /**
             * Returns true if flags prevent parent injector from being searched for tokens
             * @param {?} flags
             * @param {?} isFirstHostTNode
             * @return {?}
             */
            function shouldSearchParent(flags, isFirstHostTNode) {
                return !(flags & InjectFlags.Self) && !(flags & InjectFlags.Host && isFirstHostTNode);
            }
            var NodeInjector = /** @class */ (function () {
                /**
                 * @param {?} _tNode
                 * @param {?} _lView
                 */
                function NodeInjector(_tNode, _lView) {
                    this._tNode = _tNode;
                    this._lView = _lView;
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @return {?}
                 */
                NodeInjector.prototype.get = function (token, notFoundValue) {
                    return getOrCreateInjectable(this._tNode, this._lView, token, undefined, notFoundValue);
                };
                return NodeInjector;
            }());
            if (false) { }
            /**
             * \@codeGenApi
             * @template T
             * @param {?} type
             * @return {?}
             */
            function ɵɵgetFactoryOf(type) {
                /** @type {?} */
                var typeAny = ( /** @type {?} */(type));
                /** @type {?} */
                var def = getComponentDef(typeAny) || getDirectiveDef(typeAny) ||
                    getPipeDef(typeAny) || getInjectableDef(typeAny) || getInjectorDef(typeAny);
                if (!def || def.factory === undefined) {
                    return null;
                }
                return def.factory;
            }
            /**
             * \@codeGenApi
             * @template T
             * @param {?} type
             * @return {?}
             */
            function ɵɵgetInheritedFactory(type) {
                /** @type {?} */
                var proto = ( /** @type {?} */(Object.getPrototypeOf(type.prototype).constructor));
                /** @type {?} */
                var factory = ɵɵgetFactoryOf(proto);
                if (factory !== null) {
                    return factory;
                }
                else {
                    // There is no factory defined. Either this was improper usage of inheritance
                    // (no Angular decorator on the superclass) or there is no constructor at all
                    // in the inheritance chain. Since the two cases cannot be distinguished, the
                    // latter has to be assumed.
                    return ( /**
                     * @param {?} t
                     * @return {?}
                     */function (t) { return new t(); });
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var ERROR_TYPE = 'ngType';
            var ERROR_DEBUG_CONTEXT = 'ngDebugContext';
            var ERROR_ORIGINAL_ERROR = 'ngOriginalError';
            var ERROR_LOGGER = 'ngErrorLogger';
            function wrappedError(message, originalError) {
                var msg = message + " caused by: " + (originalError instanceof Error ? originalError.message : originalError);
                var error = Error(msg);
                error[ERROR_ORIGINAL_ERROR] = originalError;
                return error;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} error
             * @return {?}
             */
            function getType(error) {
                return (( /** @type {?} */(error)))[ERROR_TYPE];
            }
            /**
             * @param {?} error
             * @return {?}
             */
            function getDebugContext(error) {
                return (( /** @type {?} */(error)))[ERROR_DEBUG_CONTEXT];
            }
            /**
             * @param {?} error
             * @return {?}
             */
            function getOriginalError(error) {
                return (( /** @type {?} */(error)))[ERROR_ORIGINAL_ERROR];
            }
            /**
             * @param {?} error
             * @return {?}
             */
            function getErrorLogger(error) {
                return (( /** @type {?} */(error)))[ERROR_LOGGER] || defaultErrorLogger;
            }
            /**
             * @param {?} console
             * @param {...?} values
             * @return {?}
             */
            function defaultErrorLogger(console) {
                var values = [];
                for (var _c = 1; _c < arguments.length; _c++) {
                    values[_c - 1] = arguments[_c];
                }
                console.error.apply(console, values);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Provides a hook for centralized exception handling.
             *
             * The default implementation of `ErrorHandler` prints error messages to the `console`. To
             * intercept error handling, write a custom exception handler that replaces this default as
             * appropriate for your app.
             *
             * \@usageNotes
             * ### Example
             *
             * ```
             * class MyErrorHandler implements ErrorHandler {
             *   handleError(error) {
             *     // do something with the exception
             *   }
             * }
             *
             * \@NgModule({
             *   providers: [{provide: ErrorHandler, useClass: MyErrorHandler}]
             * })
             * class MyModule {}
             * ```
             *
             * \@publicApi
             */
            var ErrorHandler = /** @class */ (function () {
                function ErrorHandler() {
                    /**
                     * \@internal
                     */
                    this._console = console;
                }
                /**
                 * @param {?} error
                 * @return {?}
                 */
                ErrorHandler.prototype.handleError = function (error) {
                    /** @type {?} */
                    var originalError = this._findOriginalError(error);
                    /** @type {?} */
                    var context = this._findContext(error);
                    // Note: Browser consoles show the place from where console.error was called.
                    // We can use this to give users additional information about the error.
                    /** @type {?} */
                    var errorLogger = getErrorLogger(error);
                    errorLogger(this._console, "ERROR", error);
                    if (originalError) {
                        errorLogger(this._console, "ORIGINAL ERROR", originalError);
                    }
                    if (context) {
                        errorLogger(this._console, 'ERROR CONTEXT', context);
                    }
                };
                /**
                 * \@internal
                 * @param {?} error
                 * @return {?}
                 */
                ErrorHandler.prototype._findContext = function (error) {
                    if (error) {
                        return getDebugContext(error) ? getDebugContext(error) :
                            this._findContext(getOriginalError(error));
                    }
                    return null;
                };
                /**
                 * \@internal
                 * @param {?} error
                 * @return {?}
                 */
                ErrorHandler.prototype._findOriginalError = function (error) {
                    /** @type {?} */
                    var e = getOriginalError(error);
                    while (e && getOriginalError(e)) {
                        e = getOriginalError(e);
                    }
                    return e;
                };
                return ErrorHandler;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * A schema definition associated with an NgModule.
             *
             * @see `\@NgModule`, `CUSTOM_ELEMENTS_SCHEMA`, `NO_ERRORS_SCHEMA`
             *
             * @param name The name of a defined schema.
             *
             * \@publicApi
             * @record
             */
            function SchemaMetadata() { }
            if (false) { }
            /**
             * Defines a schema that allows an NgModule to contain the following:
             * - Non-Angular elements named with dash case (`-`).
             * - Element properties named with dash case (`-`).
             * Dash case is the naming convention for custom elements.
             *
             * \@publicApi
             * @type {?}
             */
            var CUSTOM_ELEMENTS_SCHEMA = {
                name: 'custom-elements'
            };
            /**
             * Defines a schema that allows any property on any element.
             *
             * \@publicApi
             * @type {?}
             */
            var NO_ERRORS_SCHEMA = {
                name: 'no-errors-schema'
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var BRAND = '__SANITIZER_TRUSTED_BRAND__';
            /** @enum {string} */
            var BypassType = {
                Url: 'Url',
                Html: 'Html',
                ResourceUrl: 'ResourceUrl',
                Script: 'Script',
                Style: 'Style',
            };
            /**
             * A branded trusted string used with sanitization.
             *
             * See: {\@link TrustedHtmlString}, {\@link TrustedResourceUrlString}, {\@link TrustedScriptString},
             * {\@link TrustedStyleString}, {\@link TrustedUrlString}
             * @record
             */
            function TrustedString() { }
            if (false) { }
            /**
             * A branded trusted string used with sanitization of `html` strings.
             *
             * See: {\@link bypassSanitizationTrustHtml} and {\@link htmlSanitizer}.
             * @record
             */
            function TrustedHtmlString() { }
            if (false) { }
            /**
             * A branded trusted string used with sanitization of `style` strings.
             *
             * See: {\@link bypassSanitizationTrustStyle} and {\@link styleSanitizer}.
             * @record
             */
            function TrustedStyleString() { }
            if (false) { }
            /**
             * A branded trusted string used with sanitization of `url` strings.
             *
             * See: {\@link bypassSanitizationTrustScript} and {\@link scriptSanitizer}.
             * @record
             */
            function TrustedScriptString() { }
            if (false) { }
            /**
             * A branded trusted string used with sanitization of `url` strings.
             *
             * See: {\@link bypassSanitizationTrustUrl} and {\@link urlSanitizer}.
             * @record
             */
            function TrustedUrlString() { }
            if (false) { }
            /**
             * A branded trusted string used with sanitization of `resourceUrl` strings.
             *
             * See: {\@link bypassSanitizationTrustResourceUrl} and {\@link resourceUrlSanitizer}.
             * @record
             */
            function TrustedResourceUrlString() { }
            if (false) { }
            /**
             * @param {?} value
             * @param {?} type
             * @return {?}
             */
            function allowSanitizationBypass(value, type) {
                return (value instanceof String && (( /** @type {?} */(value)))[BRAND] === type);
            }
            /**
             * Mark `html` string as trusted.
             *
             * This function wraps the trusted string in `String` and brands it in a way which makes it
             * recognizable to {\@link htmlSanitizer} to be trusted implicitly.
             *
             * @param {?} trustedHtml `html` string which needs to be implicitly trusted.
             * @return {?} a `html` `String` which has been branded to be implicitly trusted.
             */
            function bypassSanitizationTrustHtml(trustedHtml) {
                return bypassSanitizationTrustString(trustedHtml, "Html" /* Html */);
            }
            /**
             * Mark `style` string as trusted.
             *
             * This function wraps the trusted string in `String` and brands it in a way which makes it
             * recognizable to {\@link styleSanitizer} to be trusted implicitly.
             *
             * @param {?} trustedStyle `style` string which needs to be implicitly trusted.
             * @return {?} a `style` `String` which has been branded to be implicitly trusted.
             */
            function bypassSanitizationTrustStyle(trustedStyle) {
                return bypassSanitizationTrustString(trustedStyle, "Style" /* Style */);
            }
            /**
             * Mark `script` string as trusted.
             *
             * This function wraps the trusted string in `String` and brands it in a way which makes it
             * recognizable to {\@link scriptSanitizer} to be trusted implicitly.
             *
             * @param {?} trustedScript `script` string which needs to be implicitly trusted.
             * @return {?} a `script` `String` which has been branded to be implicitly trusted.
             */
            function bypassSanitizationTrustScript(trustedScript) {
                return bypassSanitizationTrustString(trustedScript, "Script" /* Script */);
            }
            /**
             * Mark `url` string as trusted.
             *
             * This function wraps the trusted string in `String` and brands it in a way which makes it
             * recognizable to {\@link urlSanitizer} to be trusted implicitly.
             *
             * @param {?} trustedUrl `url` string which needs to be implicitly trusted.
             * @return {?} a `url` `String` which has been branded to be implicitly trusted.
             */
            function bypassSanitizationTrustUrl(trustedUrl) {
                return bypassSanitizationTrustString(trustedUrl, "Url" /* Url */);
            }
            /**
             * Mark `url` string as trusted.
             *
             * This function wraps the trusted string in `String` and brands it in a way which makes it
             * recognizable to {\@link resourceUrlSanitizer} to be trusted implicitly.
             *
             * @param {?} trustedResourceUrl `url` string which needs to be implicitly trusted.
             * @return {?} a `url` `String` which has been branded to be implicitly trusted.
             */
            function bypassSanitizationTrustResourceUrl(trustedResourceUrl) {
                return bypassSanitizationTrustString(trustedResourceUrl, "ResourceUrl" /* ResourceUrl */);
            }
            /**
             * @param {?} trustedString
             * @param {?} mode
             * @return {?}
             */
            function bypassSanitizationTrustString(trustedString, mode) {
                // tslint:disable-next-line
                /** @type {?} */
                var trusted = ( /** @type {?} */(new String(trustedString)));
                trusted[BRAND] = mode;
                return trusted;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * This file is used to control if the default rendering pipeline should be `ViewEngine` or `Ivy`.
             *
             * For more information on how to run and debug tests with either Ivy or View Engine (legacy),
             * please see [BAZEL.md](./docs/BAZEL.md).
             */
            var _devMode = true;
            var _runModeLocked = false;
            /**
             * Returns whether Angular is in development mode. After called once,
             * the value is locked and won't change any more.
             *
             * By default, this is true, unless a user calls `enableProdMode` before calling this.
             *
             * @publicApi
             */
            function isDevMode() {
                _runModeLocked = true;
                return _devMode;
            }
            /**
             * Disable Angular's development mode, which turns off assertions and other
             * checks within the framework.
             *
             * One important assertion this disables verifies that a change detection pass
             * does not result in additional changes to any bindings (also known as
             * unidirectional data flow).
             *
             * @publicApi
             */
            function enableProdMode() {
                if (_runModeLocked) {
                    throw new Error('Cannot enable prod mode after platform setup.');
                }
                _devMode = false;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * This helper class is used to get hold of an inert tree of DOM elements containing dirty HTML
             * that needs sanitizing.
             * Depending upon browser support we must use one of three strategies for doing this.
             * Support: Safari 10.x -> XHR strategy
             * Support: Firefox -> DomParser strategy
             * Default: InertDocument strategy
             */
            var InertBodyHelper = /** @class */ (function () {
                /**
                 * @param {?} defaultDoc
                 */
                function InertBodyHelper(defaultDoc) {
                    this.defaultDoc = defaultDoc;
                    this.inertDocument = this.defaultDoc.implementation.createHTMLDocument('sanitization-inert');
                    this.inertBodyElement = this.inertDocument.body;
                    if (this.inertBodyElement == null) {
                        // usually there should be only one body element in the document, but IE doesn't have any, so
                        // we need to create one.
                        /** @type {?} */
                        var inertHtml = this.inertDocument.createElement('html');
                        this.inertDocument.appendChild(inertHtml);
                        this.inertBodyElement = this.inertDocument.createElement('body');
                        inertHtml.appendChild(this.inertBodyElement);
                    }
                    this.inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
                    if (this.inertBodyElement.querySelector && !this.inertBodyElement.querySelector('svg')) {
                        // We just hit the Safari 10.1 bug - which allows JS to run inside the SVG G element
                        // so use the XHR strategy.
                        this.getInertBodyElement = this.getInertBodyElement_XHR;
                        return;
                    }
                    this.inertBodyElement.innerHTML =
                        '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
                    if (this.inertBodyElement.querySelector && this.inertBodyElement.querySelector('svg img')) {
                        // We just hit the Firefox bug - which prevents the inner img JS from being sanitized
                        // so use the DOMParser strategy, if it is available.
                        // If the DOMParser is not available then we are not in Firefox (Server/WebWorker?) so we
                        // fall through to the default strategy below.
                        if (isDOMParserAvailable()) {
                            this.getInertBodyElement = this.getInertBodyElement_DOMParser;
                            return;
                        }
                    }
                    // None of the bugs were hit so it is safe for us to use the default InertDocument strategy
                    this.getInertBodyElement = this.getInertBodyElement_InertDocument;
                }
                /**
                 * Use XHR to create and fill an inert body element (on Safari 10.1)
                 * See
                 * https://github.com/cure53/DOMPurify/blob/a992d3a75031cb8bb032e5ea8399ba972bdf9a65/src/purify.js#L439-L449
                 * @private
                 * @param {?} html
                 * @return {?}
                 */
                InertBodyHelper.prototype.getInertBodyElement_XHR = function (html) {
                    // We add these extra elements to ensure that the rest of the content is parsed as expected
                    // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
                    // `<head>` tag.
                    html = '<body><remove></remove>' + html + '</body>';
                    try {
                        html = encodeURI(html);
                    }
                    catch (_a) {
                        return null;
                    }
                    /** @type {?} */
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'document';
                    xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
                    xhr.send(undefined);
                    /** @type {?} */
                    var body = xhr.response.body;
                    body.removeChild(( /** @type {?} */(body.firstChild)));
                    return body;
                };
                /**
                 * Use DOMParser to create and fill an inert body element (on Firefox)
                 * See https://github.com/cure53/DOMPurify/releases/tag/0.6.7
                 *
                 * @private
                 * @param {?} html
                 * @return {?}
                 */
                InertBodyHelper.prototype.getInertBodyElement_DOMParser = function (html) {
                    // We add these extra elements to ensure that the rest of the content is parsed as expected
                    // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
                    // `<head>` tag.
                    html = '<body><remove></remove>' + html + '</body>';
                    try {
                        /** @type {?} */
                        var body = ( /** @type {?} */(new (( /** @type {?} */(window)))
                            .DOMParser()
                            .parseFromString(html, 'text/html')
                            .body));
                        body.removeChild(( /** @type {?} */(body.firstChild)));
                        return body;
                    }
                    catch (_a) {
                        return null;
                    }
                };
                /**
                 * Use an HTML5 `template` element, if supported, or an inert body element created via
                 * `createHtmlDocument` to create and fill an inert DOM element.
                 * This is the default sane strategy to use if the browser does not require one of the specialised
                 * strategies above.
                 * @private
                 * @param {?} html
                 * @return {?}
                 */
                InertBodyHelper.prototype.getInertBodyElement_InertDocument = function (html) {
                    // Prefer using <template> element if supported.
                    /** @type {?} */
                    var templateEl = this.inertDocument.createElement('template');
                    if ('content' in templateEl) {
                        templateEl.innerHTML = html;
                        return templateEl;
                    }
                    this.inertBodyElement.innerHTML = html;
                    // Support: IE 9-11 only
                    // strip custom-namespaced attributes on IE<=11
                    if ((( /** @type {?} */(this.defaultDoc))).documentMode) {
                        this.stripCustomNsAttrs(this.inertBodyElement);
                    }
                    return this.inertBodyElement;
                };
                /**
                 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
                 * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g.
                 * 'ns1:xlink:foo').
                 *
                 * This is undesirable since we don't want to allow any of these custom attributes. This method
                 * strips them all.
                 * @private
                 * @param {?} el
                 * @return {?}
                 */
                InertBodyHelper.prototype.stripCustomNsAttrs = function (el) {
                    /** @type {?} */
                    var elAttrs = el.attributes;
                    // loop backwards so that we can support removals.
                    for (var i = elAttrs.length - 1; 0 < i; i--) {
                        /** @type {?} */
                        var attrib = elAttrs.item(i);
                        /** @type {?} */
                        var attrName = ( /** @type {?} */(attrib)).name;
                        if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
                            el.removeAttribute(attrName);
                        }
                    }
                    /** @type {?} */
                    var childNode = ( /** @type {?} */(el.firstChild));
                    while (childNode) {
                        if (childNode.nodeType === Node.ELEMENT_NODE)
                            this.stripCustomNsAttrs(( /** @type {?} */(childNode)));
                        childNode = childNode.nextSibling;
                    }
                };
                return InertBodyHelper;
            }());
            if (false) { }
            /**
             * We need to determine whether the DOMParser exists in the global context.
             * The try-catch is because, on some browsers, trying to access this property
             * on window can actually throw an error.
             *
             * @suppress {uselessCode}
             * @return {?}
             */
            function isDOMParserAvailable() {
                try {
                    return !!(( /** @type {?} */(window))).DOMParser;
                }
                catch (_a) {
                    return false;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A pattern that recognizes a commonly useful subset of URLs that are safe.
             *
             * This regular expression matches a subset of URLs that will not cause script
             * execution if used in URL context within a HTML document. Specifically, this
             * regular expression matches if (comment from here on and regex copied from
             * Soy's EscapingConventions):
             * (1) Either an allowed protocol (http, https, mailto or ftp).
             * (2) or no protocol.  A protocol must be followed by a colon. The below
             *     allows that by allowing colons only after one of the characters [/?#].
             *     A colon after a hash (#) must be in the fragment.
             *     Otherwise, a colon after a (?) must be in a query.
             *     Otherwise, a colon after a single solidus (/) must be in a path.
             *     Otherwise, a colon after a double solidus (//) must be in the authority
             *     (before port).
             *
             * The pattern disallows &, used in HTML entity declarations before
             * one of the characters in [/?#]. This disallows HTML entities used in the
             * protocol name, which should never happen, e.g. "h&#116;tp" for "http".
             * It also disallows HTML entities in the first path part of a relative path,
             * e.g. "foo&lt;bar/baz".  Our existing escaping functions should not produce
             * that. More importantly, it disallows masking of a colon,
             * e.g. "javascript&#58;...".
             *
             * This regular expression was taken from the Closure sanitization library.
             * @type {?}
             */
            var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
            /* A pattern that matches safe srcset values */
            /** @type {?} */
            var SAFE_SRCSET_PATTERN = /^(?:(?:https?|file):|[^&:/?#]*(?:[/?#]|$))/gi;
            /**
             * A pattern that matches safe data URLs. Only matches image, video and audio types.
             * @type {?}
             */
            var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
            /**
             * @param {?} url
             * @return {?}
             */
            function _sanitizeUrl(url) {
                url = String(url);
                if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN))
                    return url;
                if (isDevMode()) {
                    console.warn("WARNING: sanitizing unsafe URL value " + url + " (see http://g.co/ng/security#xss)");
                }
                return 'unsafe:' + url;
            }
            /**
             * @param {?} srcset
             * @return {?}
             */
            function sanitizeSrcset(srcset) {
                srcset = String(srcset);
                return srcset.split(',').map(( /**
                 * @param {?} srcset
                 * @return {?}
                 */function (srcset) { return _sanitizeUrl(srcset.trim()); })).join(', ');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} tags
             * @return {?}
             */
            function tagSet(tags) {
                /** @type {?} */
                var res = {};
                for (var _c = 0, _d = tags.split(','); _c < _d.length; _c++) {
                    var t = _d[_c];
                    res[t] = true;
                }
                return res;
            }
            /**
             * @param {...?} sets
             * @return {?}
             */
            function merge() {
                var sets = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    sets[_c] = arguments[_c];
                }
                /** @type {?} */
                var res = {};
                for (var _d = 0, sets_1 = sets; _d < sets_1.length; _d++) {
                    var s = sets_1[_d];
                    for (var v in s) {
                        if (s.hasOwnProperty(v))
                            res[v] = true;
                    }
                }
                return res;
            }
            // Good source of info about elements and attributes
            // http://dev.w3.org/html5/spec/Overview.html#semantics
            // http://simon.html5.org/html-elements
            // Safe Void Elements - HTML5
            // http://dev.w3.org/html5/spec/Overview.html#void-elements
            /** @type {?} */
            var VOID_ELEMENTS = tagSet('area,br,col,hr,img,wbr');
            // Elements that you can, intentionally, leave open (and which close themselves)
            // http://dev.w3.org/html5/spec/Overview.html#optional-tags
            /** @type {?} */
            var OPTIONAL_END_TAG_BLOCK_ELEMENTS = tagSet('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr');
            /** @type {?} */
            var OPTIONAL_END_TAG_INLINE_ELEMENTS = tagSet('rp,rt');
            /** @type {?} */
            var OPTIONAL_END_TAG_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, OPTIONAL_END_TAG_BLOCK_ELEMENTS);
            // Safe Block Elements - HTML5
            /** @type {?} */
            var BLOCK_ELEMENTS = merge(OPTIONAL_END_TAG_BLOCK_ELEMENTS, tagSet('address,article,' +
                'aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
                'h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul'));
            // Inline Elements - HTML5
            /** @type {?} */
            var INLINE_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, tagSet('a,abbr,acronym,audio,b,' +
                'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,' +
                'samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video'));
            /** @type {?} */
            var VALID_ELEMENTS = merge(VOID_ELEMENTS, BLOCK_ELEMENTS, INLINE_ELEMENTS, OPTIONAL_END_TAG_ELEMENTS);
            // Attributes that have href and hence need to be sanitized
            /** @type {?} */
            var URI_ATTRS = tagSet('background,cite,href,itemtype,longdesc,poster,src,xlink:href');
            // Attributes that have special href set hence need to be sanitized
            /** @type {?} */
            var SRCSET_ATTRS = tagSet('srcset');
            /** @type {?} */
            var HTML_ATTRS = tagSet('abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,' +
                'compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,' +
                'ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,' +
                'scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,' +
                'valign,value,vspace,width');
            // Accessibility attributes as per WAI-ARIA 1.1 (W3C Working Draft 14 December 2018)
            /** @type {?} */
            var ARIA_ATTRS = tagSet('aria-activedescendant,aria-atomic,aria-autocomplete,aria-busy,aria-checked,aria-colcount,aria-colindex,' +
                'aria-colspan,aria-controls,aria-current,aria-describedby,aria-details,aria-disabled,aria-dropeffect,' +
                'aria-errormessage,aria-expanded,aria-flowto,aria-grabbed,aria-haspopup,aria-hidden,aria-invalid,' +
                'aria-keyshortcuts,aria-label,aria-labelledby,aria-level,aria-live,aria-modal,aria-multiline,' +
                'aria-multiselectable,aria-orientation,aria-owns,aria-placeholder,aria-posinset,aria-pressed,aria-readonly,' +
                'aria-relevant,aria-required,aria-roledescription,aria-rowcount,aria-rowindex,aria-rowspan,aria-selected,' +
                'aria-setsize,aria-sort,aria-valuemax,aria-valuemin,aria-valuenow,aria-valuetext');
            // NB: This currently consciously doesn't support SVG. SVG sanitization has had several security
            // issues in the past, so it seems safer to leave it out if possible. If support for binding SVG via
            // innerHTML is required, SVG attributes should be added here.
            // NB: Sanitization does not allow <form> elements or other active elements (<button> etc). Those
            // can be sanitized, but they increase security surface area without a legitimate use case, so they
            // are left out here.
            /** @type {?} */
            var VALID_ATTRS = merge(URI_ATTRS, SRCSET_ATTRS, HTML_ATTRS, ARIA_ATTRS);
            // Elements whose content should not be traversed/preserved, if the elements themselves are invalid.
            //
            // Typically, `<invalid>Some content</invalid>` would traverse (and in this case preserve)
            // `Some content`, but strip `invalid-element` opening/closing tags. For some elements, though, we
            // don't want to preserve the content, if the elements themselves are going to be removed.
            /** @type {?} */
            var SKIP_TRAVERSING_CONTENT_IF_INVALID_ELEMENTS = tagSet('script,style,template');
            /**
             * SanitizingHtmlSerializer serializes a DOM fragment, stripping out any unsafe elements and unsafe
             * attributes.
             */
            var SanitizingHtmlSerializer = /** @class */ (function () {
                function SanitizingHtmlSerializer() {
                    // Explicitly track if something was stripped, to avoid accidentally warning of sanitization just
                    // because characters were re-encoded.
                    this.sanitizedSomething = false;
                    this.buf = [];
                }
                /**
                 * @param {?} el
                 * @return {?}
                 */
                SanitizingHtmlSerializer.prototype.sanitizeChildren = function (el) {
                    // This cannot use a TreeWalker, as it has to run on Angular's various DOM adapters.
                    // However this code never accesses properties off of `document` before deleting its contents
                    // again, so it shouldn't be vulnerable to DOM clobbering.
                    /** @type {?} */
                    var current = ( /** @type {?} */(el.firstChild));
                    /** @type {?} */
                    var traverseContent = true;
                    while (current) {
                        if (current.nodeType === Node.ELEMENT_NODE) {
                            traverseContent = this.startElement(( /** @type {?} */(current)));
                        }
                        else if (current.nodeType === Node.TEXT_NODE) {
                            this.chars(( /** @type {?} */(current.nodeValue)));
                        }
                        else {
                            // Strip non-element, non-text nodes.
                            this.sanitizedSomething = true;
                        }
                        if (traverseContent && current.firstChild) {
                            current = ( /** @type {?} */(current.firstChild));
                            continue;
                        }
                        while (current) {
                            // Leaving the element. Walk up and to the right, closing tags as we go.
                            if (current.nodeType === Node.ELEMENT_NODE) {
                                this.endElement(( /** @type {?} */(current)));
                            }
                            /** @type {?} */
                            var next = this.checkClobberedElement(current, ( /** @type {?} */(current.nextSibling)));
                            if (next) {
                                current = next;
                                break;
                            }
                            current = this.checkClobberedElement(current, ( /** @type {?} */(current.parentNode)));
                        }
                    }
                    return this.buf.join('');
                };
                /**
                 * Sanitizes an opening element tag (if valid) and returns whether the element's contents should
                 * be traversed. Element content must always be traversed (even if the element itself is not
                 * valid/safe), unless the element is one of `SKIP_TRAVERSING_CONTENT_IF_INVALID_ELEMENTS`.
                 *
                 * @private
                 * @param {?} element The element to sanitize.
                 * @return {?} True if the element's contents should be traversed.
                 */
                SanitizingHtmlSerializer.prototype.startElement = function (element) {
                    /** @type {?} */
                    var tagName = element.nodeName.toLowerCase();
                    if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
                        this.sanitizedSomething = true;
                        return !SKIP_TRAVERSING_CONTENT_IF_INVALID_ELEMENTS.hasOwnProperty(tagName);
                    }
                    this.buf.push('<');
                    this.buf.push(tagName);
                    /** @type {?} */
                    var elAttrs = element.attributes;
                    for (var i = 0; i < elAttrs.length; i++) {
                        /** @type {?} */
                        var elAttr = elAttrs.item(i);
                        /** @type {?} */
                        var attrName = ( /** @type {?} */(elAttr)).name;
                        /** @type {?} */
                        var lower = attrName.toLowerCase();
                        if (!VALID_ATTRS.hasOwnProperty(lower)) {
                            this.sanitizedSomething = true;
                            continue;
                        }
                        /** @type {?} */
                        var value = ( /** @type {?} */(elAttr)).value;
                        // TODO(martinprobst): Special case image URIs for data:image/...
                        if (URI_ATTRS[lower])
                            value = _sanitizeUrl(value);
                        if (SRCSET_ATTRS[lower])
                            value = sanitizeSrcset(value);
                        this.buf.push(' ', attrName, '="', encodeEntities(value), '"');
                    }
                    this.buf.push('>');
                    return true;
                };
                /**
                 * @private
                 * @param {?} current
                 * @return {?}
                 */
                SanitizingHtmlSerializer.prototype.endElement = function (current) {
                    /** @type {?} */
                    var tagName = current.nodeName.toLowerCase();
                    if (VALID_ELEMENTS.hasOwnProperty(tagName) && !VOID_ELEMENTS.hasOwnProperty(tagName)) {
                        this.buf.push('</');
                        this.buf.push(tagName);
                        this.buf.push('>');
                    }
                };
                /**
                 * @private
                 * @param {?} chars
                 * @return {?}
                 */
                SanitizingHtmlSerializer.prototype.chars = function (chars) { this.buf.push(encodeEntities(chars)); };
                /**
                 * @param {?} node
                 * @param {?} nextNode
                 * @return {?}
                 */
                SanitizingHtmlSerializer.prototype.checkClobberedElement = function (node, nextNode) {
                    if (nextNode &&
                        (node.compareDocumentPosition(nextNode) &
                            Node.DOCUMENT_POSITION_CONTAINED_BY) === Node.DOCUMENT_POSITION_CONTAINED_BY) {
                        throw new Error("Failed to sanitize html because the element is clobbered: " + (( /** @type {?} */(node))).outerHTML);
                    }
                    return nextNode;
                };
                return SanitizingHtmlSerializer;
            }());
            if (false) { }
            // Regular Expressions for parsing tags and attributes
            /** @type {?} */
            var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
            // ! to ~ is the ASCII range.
            /** @type {?} */
            var NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
            /**
             * Escapes all potentially dangerous characters, so that the
             * resulting string can be safely inserted into attribute or
             * element text.
             * @param {?} value
             * @return {?}
             */
            function encodeEntities(value) {
                return value.replace(/&/g, '&amp;')
                    .replace(SURROGATE_PAIR_REGEXP, ( /**
             * @param {?} match
             * @return {?}
             */function (match) {
                    /** @type {?} */
                    var hi = match.charCodeAt(0);
                    /** @type {?} */
                    var low = match.charCodeAt(1);
                    return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
                }))
                    .replace(NON_ALPHANUMERIC_REGEXP, ( /**
             * @param {?} match
             * @return {?}
             */function (match) { return '&#' + match.charCodeAt(0) + ';'; }))
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
            }
            /** @type {?} */
            var inertBodyHelper;
            /**
             * Sanitizes the given unsafe, untrusted HTML fragment, and returns HTML text that is safe to add to
             * the DOM in a browser environment.
             * @param {?} defaultDoc
             * @param {?} unsafeHtmlInput
             * @return {?}
             */
            function _sanitizeHtml(defaultDoc, unsafeHtmlInput) {
                /** @type {?} */
                var inertBodyElement = null;
                try {
                    inertBodyHelper = inertBodyHelper || new InertBodyHelper(defaultDoc);
                    // Make sure unsafeHtml is actually a string (TypeScript types are not enforced at runtime).
                    /** @type {?} */
                    var unsafeHtml = unsafeHtmlInput ? String(unsafeHtmlInput) : '';
                    inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
                    // mXSS protection. Repeatedly parse the document to make sure it stabilizes, so that a browser
                    // trying to auto-correct incorrect HTML cannot cause formerly inert HTML to become dangerous.
                    /** @type {?} */
                    var mXSSAttempts = 5;
                    /** @type {?} */
                    var parsedHtml = unsafeHtml;
                    do {
                        if (mXSSAttempts === 0) {
                            throw new Error('Failed to sanitize html because the input is unstable');
                        }
                        mXSSAttempts--;
                        unsafeHtml = parsedHtml;
                        parsedHtml = ( /** @type {?} */(inertBodyElement)).innerHTML;
                        inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
                    } while (unsafeHtml !== parsedHtml);
                    /** @type {?} */
                    var sanitizer = new SanitizingHtmlSerializer();
                    /** @type {?} */
                    var safeHtml = sanitizer.sanitizeChildren(( /** @type {?} */(getTemplateContent(( /** @type {?} */(inertBodyElement))))) || inertBodyElement);
                    if (isDevMode() && sanitizer.sanitizedSomething) {
                        console.warn('WARNING: sanitizing HTML stripped some content, see http://g.co/ng/security#xss');
                    }
                    return safeHtml;
                }
                finally {
                    // In case anything goes wrong, clear out inertElement to reset the entire DOM structure.
                    if (inertBodyElement) {
                        /** @type {?} */
                        var parent = getTemplateContent(inertBodyElement) || inertBodyElement;
                        while (parent.firstChild) {
                            parent.removeChild(parent.firstChild);
                        }
                    }
                }
            }
            /**
             * @param {?} el
             * @return {?}
             */
            function getTemplateContent(el) {
                return 'content' in (( /** @type {?} */(el))) && isTemplateElement(el) ?
                    el.content :
                    null;
            }
            /**
             * @param {?} el
             * @return {?}
             */
            function isTemplateElement(el) {
                return el.nodeType === Node.ELEMENT_NODE && el.nodeName === 'TEMPLATE';
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @enum {number} */
            var SecurityContext = {
                NONE: 0,
                HTML: 1,
                STYLE: 2,
                SCRIPT: 3,
                URL: 4,
                RESOURCE_URL: 5,
            };
            SecurityContext[SecurityContext.NONE] = 'NONE';
            SecurityContext[SecurityContext.HTML] = 'HTML';
            SecurityContext[SecurityContext.STYLE] = 'STYLE';
            SecurityContext[SecurityContext.SCRIPT] = 'SCRIPT';
            SecurityContext[SecurityContext.URL] = 'URL';
            SecurityContext[SecurityContext.RESOURCE_URL] = 'RESOURCE_URL';
            /**
             * Sanitizer is used by the views to sanitize potentially dangerous values.
             *
             * \@publicApi
             * @abstract
             */
            var Sanitizer = /** @class */ (function () {
                function Sanitizer() {
                }
                return Sanitizer;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Regular expression for safe style values.
             *
             * Quotes (" and ') are allowed, but a check must be done elsewhere to ensure they're balanced.
             *
             * ',' allows multiple values to be assigned to the same property (e.g. background-attachment or
             * font-family) and hence could allow multiple values to get injected, but that should pose no risk
             * of XSS.
             *
             * The function expression checks only for XSS safety, not for CSS validity.
             *
             * This regular expression was taken from the Closure sanitization library, and augmented for
             * transformation values.
             * @type {?}
             */
            var VALUES = '[-,."\'%_!# a-zA-Z0-9]+';
            /** @type {?} */
            var TRANSFORMATION_FNS = '(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|Z|3d)?';
            /** @type {?} */
            var COLOR_FNS = '(?:rgb|hsl)a?';
            /** @type {?} */
            var GRADIENTS = '(?:repeating-)?(?:linear|radial)-gradient';
            /** @type {?} */
            var CSS3_FNS = '(?:calc|attr)';
            /** @type {?} */
            var FN_ARGS = '\\([-0-9.%, #a-zA-Z]+\\)';
            /** @type {?} */
            var SAFE_STYLE_VALUE = new RegExp("^(" + VALUES + "|" +
                ("(?:" + TRANSFORMATION_FNS + "|" + COLOR_FNS + "|" + GRADIENTS + "|" + CSS3_FNS + ")") +
                (FN_ARGS + ")$"), 'g');
            /**
             * Matches a `url(...)` value with an arbitrary argument as long as it does
             * not contain parentheses.
             *
             * The URL value still needs to be sanitized separately.
             *
             * `url(...)` values are a very common use case, e.g. for `background-image`. With carefully crafted
             * CSS style rules, it is possible to construct an information leak with `url` values in CSS, e.g.
             * by observing whether scroll bars are displayed, or character ranges used by a font face
             * definition.
             *
             * Angular only allows binding CSS values (as opposed to entire CSS rules), so it is unlikely that
             * binding a URL value without further cooperation from the page will cause an information leak, and
             * if so, it is just a leak, not a full blown XSS vulnerability.
             *
             * Given the common use case, low likelihood of attack vector, and low impact of an attack, this
             * code is permissive and allows URLs that sanitize otherwise.
             * @type {?}
             */
            var URL_RE = /^url\(([^)]+)\)$/;
            /**
             * Checks that quotes (" and ') are properly balanced inside a string. Assumes
             * that neither escape (\) nor any other character that could result in
             * breaking out of a string parsing context are allowed;
             * see http://www.w3.org/TR/css3-syntax/#string-token-diagram.
             *
             * This code was taken from the Closure sanitization library.
             * @param {?} value
             * @return {?}
             */
            function hasBalancedQuotes(value) {
                /** @type {?} */
                var outsideSingle = true;
                /** @type {?} */
                var outsideDouble = true;
                for (var i = 0; i < value.length; i++) {
                    /** @type {?} */
                    var c = value.charAt(i);
                    if (c === '\'' && outsideDouble) {
                        outsideSingle = !outsideSingle;
                    }
                    else if (c === '"' && outsideSingle) {
                        outsideDouble = !outsideDouble;
                    }
                }
                return outsideSingle && outsideDouble;
            }
            /**
             * Sanitizes the given untrusted CSS style property value (i.e. not an entire object, just a single
             * value) and returns a value that is safe to use in a browser environment.
             * @param {?} value
             * @return {?}
             */
            function _sanitizeStyle(value) {
                value = String(value).trim(); // Make sure it's actually a string.
                if (!value)
                    return '';
                // Single url(...) values are supported, but only for URLs that sanitize cleanly. See above for
                // reasoning behind this.
                /** @type {?} */
                var urlMatch = value.match(URL_RE);
                if ((urlMatch && _sanitizeUrl(urlMatch[1]) === urlMatch[1]) ||
                    value.match(SAFE_STYLE_VALUE) && hasBalancedQuotes(value)) {
                    return value; // Safe style values.
                }
                if (isDevMode()) {
                    console.warn("WARNING: sanitizing unsafe style value " + value + " (see http://g.co/ng/security#xss).");
                }
                return 'unsafe';
            }
            /** @enum {number} */
            var StyleSanitizeMode = {
                /** Just check to see if the property is required to be sanitized or not */
                ValidateProperty: 1,
                /** Skip checking the property; just sanitize the value */
                SanitizeOnly: 2,
                /** Check the property and (if true) then sanitize the value */
                ValidateAndSanitize: 3,
            };
            /**
             * Used to intercept and sanitize style values before they are written to the renderer.
             *
             * This function is designed to be called in two modes. When a value is not provided
             * then the function will return a boolean whether a property will be sanitized later.
             * If a value is provided then the sanitized version of that will be returned.
             * @record
             */
            function StyleSanitizeFn() { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An `html` sanitizer which converts untrusted `html` **string** into trusted string by removing
             * dangerous content.
             *
             * This method parses the `html` and locates potentially dangerous content (such as urls and
             * javascript) and removes it.
             *
             * It is possible to mark a string as trusted by calling {\@link bypassSanitizationTrustHtml}.
             *
             * \@publicApi
             * @param {?} unsafeHtml untrusted `html`, typically from the user.
             * @return {?} `html` string which is safe to display to user, because all of the dangerous javascript
             * and urls have been removed.
             *
             */
            function ɵɵsanitizeHtml(unsafeHtml) {
                /** @type {?} */
                var sanitizer = getSanitizer();
                if (sanitizer) {
                    return sanitizer.sanitize(SecurityContext.HTML, unsafeHtml) || '';
                }
                if (allowSanitizationBypass(unsafeHtml, "Html" /* Html */)) {
                    return unsafeHtml.toString();
                }
                return _sanitizeHtml(document, renderStringify(unsafeHtml));
            }
            /**
             * A `style` sanitizer which converts untrusted `style` **string** into trusted string by removing
             * dangerous content.
             *
             * This method parses the `style` and locates potentially dangerous content (such as urls and
             * javascript) and removes it.
             *
             * It is possible to mark a string as trusted by calling {\@link bypassSanitizationTrustStyle}.
             *
             * \@publicApi
             * @param {?} unsafeStyle untrusted `style`, typically from the user.
             * @return {?} `style` string which is safe to bind to the `style` properties, because all of the
             * dangerous javascript and urls have been removed.
             *
             */
            function ɵɵsanitizeStyle(unsafeStyle) {
                /** @type {?} */
                var sanitizer = getSanitizer();
                if (sanitizer) {
                    return sanitizer.sanitize(SecurityContext.STYLE, unsafeStyle) || '';
                }
                if (allowSanitizationBypass(unsafeStyle, "Style" /* Style */)) {
                    return unsafeStyle.toString();
                }
                return _sanitizeStyle(renderStringify(unsafeStyle));
            }
            /**
             * A `url` sanitizer which converts untrusted `url` **string** into trusted string by removing
             * dangerous
             * content.
             *
             * This method parses the `url` and locates potentially dangerous content (such as javascript) and
             * removes it.
             *
             * It is possible to mark a string as trusted by calling {\@link bypassSanitizationTrustUrl}.
             *
             * \@publicApi
             * @param {?} unsafeUrl untrusted `url`, typically from the user.
             * @return {?} `url` string which is safe to bind to the `src` properties such as `<img src>`, because
             * all of the dangerous javascript has been removed.
             *
             */
            function ɵɵsanitizeUrl(unsafeUrl) {
                /** @type {?} */
                var sanitizer = getSanitizer();
                if (sanitizer) {
                    return sanitizer.sanitize(SecurityContext.URL, unsafeUrl) || '';
                }
                if (allowSanitizationBypass(unsafeUrl, "Url" /* Url */)) {
                    return unsafeUrl.toString();
                }
                return _sanitizeUrl(renderStringify(unsafeUrl));
            }
            /**
             * A `url` sanitizer which only lets trusted `url`s through.
             *
             * This passes only `url`s marked trusted by calling {\@link bypassSanitizationTrustResourceUrl}.
             *
             * \@publicApi
             * @param {?} unsafeResourceUrl untrusted `url`, typically from the user.
             * @return {?} `url` string which is safe to bind to the `src` properties such as `<img src>`, because
             * only trusted `url`s have been allowed to pass.
             *
             */
            function ɵɵsanitizeResourceUrl(unsafeResourceUrl) {
                /** @type {?} */
                var sanitizer = getSanitizer();
                if (sanitizer) {
                    return sanitizer.sanitize(SecurityContext.RESOURCE_URL, unsafeResourceUrl) || '';
                }
                if (allowSanitizationBypass(unsafeResourceUrl, "ResourceUrl" /* ResourceUrl */)) {
                    return unsafeResourceUrl.toString();
                }
                throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
            }
            /**
             * A `script` sanitizer which only lets trusted javascript through.
             *
             * This passes only `script`s marked trusted by calling {\@link
             * bypassSanitizationTrustScript}.
             *
             * \@publicApi
             * @param {?} unsafeScript untrusted `script`, typically from the user.
             * @return {?} `url` string which is safe to bind to the `<script>` element such as `<img src>`,
             * because only trusted `scripts` have been allowed to pass.
             *
             */
            function ɵɵsanitizeScript(unsafeScript) {
                /** @type {?} */
                var sanitizer = getSanitizer();
                if (sanitizer) {
                    return sanitizer.sanitize(SecurityContext.SCRIPT, unsafeScript) || '';
                }
                if (allowSanitizationBypass(unsafeScript, "Script" /* Script */)) {
                    return unsafeScript.toString();
                }
                throw new Error('unsafe value used in a script context');
            }
            /**
             * Detects which sanitizer to use for URL property, based on tag name and prop name.
             *
             * The rules are based on the RESOURCE_URL context config from
             * `packages/compiler/src/schema/dom_security_schema.ts`.
             * If tag and prop names don't match Resource URL schema, use URL sanitizer.
             * @param {?} tag
             * @param {?} prop
             * @return {?}
             */
            function getUrlSanitizer(tag, prop) {
                if ((prop === 'src' && (tag === 'embed' || tag === 'frame' || tag === 'iframe' ||
                    tag === 'media' || tag === 'script')) ||
                    (prop === 'href' && (tag === 'base' || tag === 'link'))) {
                    return ɵɵsanitizeResourceUrl;
                }
                return ɵɵsanitizeUrl;
            }
            /**
             * Sanitizes URL, selecting sanitizer function based on tag and property names.
             *
             * This function is used in case we can't define security context at compile time, when only prop
             * name is available. This happens when we generate host bindings for Directives/Components. The
             * host element is unknown at compile time, so we defer calculation of specific sanitizer to
             * runtime.
             *
             * \@publicApi
             * @param {?} unsafeUrl untrusted `url`, typically from the user.
             * @param {?} tag target element tag name.
             * @param {?} prop name of the property that contains the value.
             * @return {?} `url` string which is safe to bind.
             *
             */
            function ɵɵsanitizeUrlOrResourceUrl(unsafeUrl, tag, prop) {
                return getUrlSanitizer(tag, prop)(unsafeUrl);
            }
            /**
             * The default style sanitizer will handle sanitization for style properties by
             * sanitizing any CSS property that can include a `url` value (usually image-based properties)
             *
             * \@publicApi
             * @type {?}
             */
            var ɵɵdefaultStyleSanitizer = (( /** @type {?} */(( /**
             * @param {?} prop
             * @param {?} value
             * @param {?=} mode
             * @return {?}
             */function (prop, value, mode) {
                mode = mode || 3 /* ValidateAndSanitize */;
                /** @type {?} */
                var doSanitizeValue = true;
                if (mode & 1 /* ValidateProperty */) {
                    doSanitizeValue = prop === 'background-image' || prop === 'background' ||
                        prop === 'border-image' || prop === 'filter' || prop === 'list-style' ||
                        prop === 'list-style-image' || prop === 'clip-path';
                }
                if (mode & 2 /* SanitizeOnly */) {
                    return doSanitizeValue ? ɵɵsanitizeStyle(value) : value;
                }
                else {
                    return doSanitizeValue;
                }
            }))));
            /**
             * @param {?} name
             * @return {?}
             */
            function validateAgainstEventProperties(name) {
                if (name.toLowerCase().startsWith('on')) {
                    /** @type {?} */
                    var msg = "Binding to event property '" + name + "' is disallowed for security reasons, " +
                        ("please use (" + name.slice(2) + ")=...") +
                        ("\nIf '" + name + "' is a directive input, make sure the directive is imported by the") +
                        " current module.";
                    throw new Error(msg);
                }
            }
            /**
             * @param {?} name
             * @return {?}
             */
            function validateAgainstEventAttributes(name) {
                if (name.toLowerCase().startsWith('on')) {
                    /** @type {?} */
                    var msg = "Binding to event attribute '" + name + "' is disallowed for security reasons, " +
                        ("please use (" + name.slice(2) + ")=...");
                    throw new Error(msg);
                }
            }
            /**
             * @return {?}
             */
            function getSanitizer() {
                /** @type {?} */
                var lView = getLView();
                return lView && lView[SANITIZER];
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * THIS FILE CONTAINS CODE WHICH SHOULD BE TREE SHAKEN AND NEVER CALLED FROM PRODUCTION CODE!!!
             */
            /**
             * Creates an `Array` construction with a given name. This is useful when
             * looking for memory consumption to see what time of array it is.
             *
             *
             * @param name Name to give to the constructor
             * @returns A subclass of `Array` if possible. This can only be done in
             *          environments which support `class` construct.
             */
            function createNamedArrayType(name) {
                // This should never be called in prod mode, so let's verify that is the case.
                if (ngDevMode) {
                    try {
                        // We need to do it this way so that TypeScript does not down-level the below code.
                        var FunctionConstructor = createNamedArrayType.constructor;
                        return (new FunctionConstructor('Array', "return class ABC extends Array{}"))(Array);
                    }
                    catch (e) {
                        // If it does not work just give up and fall back to regular Array.
                        return Array;
                    }
                }
                else {
                    throw new Error('Looks like we are in \'prod mode\', but we are creating a named Array type, which is wrong! Check your code');
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function normalizeDebugBindingName(name) {
                // Attribute names with `$` (eg `x-y$`) are valid per spec, but unsupported by some browsers
                name = camelCaseToDashCase(name.replace(/[$@]/g, '_'));
                return "ng-reflect-" + name;
            }
            var CAMEL_CASE_REGEXP = /([A-Z])/g;
            function camelCaseToDashCase(input) {
                return input.replace(CAMEL_CASE_REGEXP, function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    return '-' + m[1].toLowerCase();
                });
            }
            function normalizeDebugBindingValue(value) {
                try {
                    // Limit the size of the value as otherwise the DOM just gets polluted.
                    return value != null ? value.toString().slice(0, 30) : value;
                }
                catch (e) {
                    return '[ERROR] Exception while trying to serialize the value';
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns the matching `LContext` data for a given DOM node, directive or component instance.
             *
             * This function will examine the provided DOM element, component, or directive instance\'s
             * monkey-patched property to derive the `LContext` data. Once called then the monkey-patched
             * value will be that of the newly created `LContext`.
             *
             * If the monkey-patched value is the `LView` instance then the context value for that
             * target will be created and the monkey-patch reference will be updated. Therefore when this
             * function is called it may mutate the provided element\'s, component\'s or any of the associated
             * directive\'s monkey-patch values.
             *
             * If the monkey-patch value is not detected then the code will walk up the DOM until an element
             * is found which contains a monkey-patch reference. When that occurs then the provided element
             * will be updated with a new context (which is then returned). If the monkey-patch value is not
             * detected for a component/directive instance then it will throw an error (all components and
             * directives should be automatically monkey-patched by ivy).
             *
             * @param {?} target Component, Directive or DOM Node.
             * @return {?}
             */
            function getLContext(target) {
                /** @type {?} */
                var mpValue = readPatchedData(target);
                if (mpValue) {
                    // only when it's an array is it considered an LView instance
                    // ... otherwise it's an already constructed LContext instance
                    if (Array.isArray(mpValue)) {
                        /** @type {?} */
                        var lView_1 = ( /** @type {?} */(mpValue));
                        /** @type {?} */
                        var nodeIndex = void 0;
                        /** @type {?} */
                        var component = undefined;
                        /** @type {?} */
                        var directives = undefined;
                        if (isComponentInstance(target)) {
                            nodeIndex = findViaComponent(lView_1, target);
                            if (nodeIndex == -1) {
                                throw new Error('The provided component was not found in the application');
                            }
                            component = target;
                        }
                        else if (isDirectiveInstance(target)) {
                            nodeIndex = findViaDirective(lView_1, target);
                            if (nodeIndex == -1) {
                                throw new Error('The provided directive was not found in the application');
                            }
                            directives = getDirectivesAtNodeIndex(nodeIndex, lView_1, false);
                        }
                        else {
                            nodeIndex = findViaNativeElement(lView_1, ( /** @type {?} */(target)));
                            if (nodeIndex == -1) {
                                return null;
                            }
                        }
                        // the goal is not to fill the entire context full of data because the lookups
                        // are expensive. Instead, only the target data (the element, component, container, ICU
                        // expression or directive details) are filled into the context. If called multiple times
                        // with different target values then the missing target data will be filled in.
                        /** @type {?} */
                        var native = unwrapRNode(lView_1[nodeIndex]);
                        /** @type {?} */
                        var existingCtx = readPatchedData(native);
                        /** @type {?} */
                        var context = (existingCtx && !Array.isArray(existingCtx)) ?
                            existingCtx :
                            createLContext(lView_1, nodeIndex, native);
                        // only when the component has been discovered then update the monkey-patch
                        if (component && context.component === undefined) {
                            context.component = component;
                            attachPatchData(context.component, context);
                        }
                        // only when the directives have been discovered then update the monkey-patch
                        if (directives && context.directives === undefined) {
                            context.directives = directives;
                            for (var i = 0; i < directives.length; i++) {
                                attachPatchData(directives[i], context);
                            }
                        }
                        attachPatchData(context.native, context);
                        mpValue = context;
                    }
                }
                else {
                    /** @type {?} */
                    var rElement = ( /** @type {?} */(target));
                    ngDevMode && assertDomNode(rElement);
                    // if the context is not found then we need to traverse upwards up the DOM
                    // to find the nearest element that has already been monkey patched with data
                    /** @type {?} */
                    var parent = ( /** @type {?} */(rElement));
                    while (parent = parent.parentNode) {
                        /** @type {?} */
                        var parentContext = readPatchedData(parent);
                        if (parentContext) {
                            /** @type {?} */
                            var lView_2 = void 0;
                            if (Array.isArray(parentContext)) {
                                lView_2 = ( /** @type {?} */(parentContext));
                            }
                            else {
                                lView_2 = parentContext.lView;
                            }
                            // the edge of the app was also reached here through another means
                            // (maybe because the DOM was changed manually).
                            if (!lView_2) {
                                return null;
                            }
                            /** @type {?} */
                            var index = findViaNativeElement(lView_2, rElement);
                            if (index >= 0) {
                                /** @type {?} */
                                var native = unwrapRNode(lView_2[index]);
                                /** @type {?} */
                                var context = createLContext(lView_2, index, native);
                                attachPatchData(native, context);
                                mpValue = context;
                                break;
                            }
                        }
                    }
                }
                return (( /** @type {?} */(mpValue))) || null;
            }
            /**
             * Creates an empty instance of a `LContext` context
             * @param {?} lView
             * @param {?} nodeIndex
             * @param {?} native
             * @return {?}
             */
            function createLContext(lView, nodeIndex, native) {
                return {
                    lView: lView,
                    nodeIndex: nodeIndex,
                    native: native,
                    component: undefined,
                    directives: undefined,
                    localRefs: undefined,
                };
            }
            /**
             * Takes a component instance and returns the view for that component.
             *
             * @param {?} componentInstance
             * @return {?} The component's view
             */
            function getComponentViewByInstance(componentInstance) {
                /** @type {?} */
                var lView = readPatchedData(componentInstance);
                /** @type {?} */
                var view;
                if (Array.isArray(lView)) {
                    /** @type {?} */
                    var nodeIndex = findViaComponent(lView, componentInstance);
                    view = getComponentViewByIndex(nodeIndex, lView);
                    /** @type {?} */
                    var context = createLContext(lView, nodeIndex, ( /** @type {?} */(view[HOST])));
                    context.component = componentInstance;
                    attachPatchData(componentInstance, context);
                    attachPatchData(context.native, context);
                }
                else {
                    /** @type {?} */
                    var context = ( /** @type {?} */(( /** @type {?} */(lView))));
                    view = getComponentViewByIndex(context.nodeIndex, context.lView);
                }
                return view;
            }
            /**
             * Assigns the given data to the given target (which could be a component,
             * directive or DOM node instance) using monkey-patching.
             * @param {?} target
             * @param {?} data
             * @return {?}
             */
            function attachPatchData(target, data) {
                target[MONKEY_PATCH_KEY_NAME] = data;
            }
            /**
             * @param {?} instance
             * @return {?}
             */
            function isComponentInstance(instance) {
                return instance && instance.constructor && instance.constructor.ngComponentDef;
            }
            /**
             * @param {?} instance
             * @return {?}
             */
            function isDirectiveInstance(instance) {
                return instance && instance.constructor && instance.constructor.ngDirectiveDef;
            }
            /**
             * Locates the element within the given LView and returns the matching index
             * @param {?} lView
             * @param {?} target
             * @return {?}
             */
            function findViaNativeElement(lView, target) {
                /** @type {?} */
                var tNode = lView[TVIEW].firstChild;
                while (tNode) {
                    /** @type {?} */
                    var native = ( /** @type {?} */(getNativeByTNodeOrNull(tNode, lView)));
                    if (native === target) {
                        return tNode.index;
                    }
                    tNode = traverseNextElement(tNode);
                }
                return -1;
            }
            /**
             * Locates the next tNode (child, sibling or parent).
             * @param {?} tNode
             * @return {?}
             */
            function traverseNextElement(tNode) {
                if (tNode.child) {
                    return tNode.child;
                }
                else if (tNode.next) {
                    return tNode.next;
                }
                else {
                    // Let's take the following template: <div><span>text</span></div><component/>
                    // After checking the text node, we need to find the next parent that has a "next" TNode,
                    // in this case the parent `div`, so that we can find the component.
                    while (tNode.parent && !tNode.parent.next) {
                        tNode = tNode.parent;
                    }
                    return tNode.parent && tNode.parent.next;
                }
            }
            /**
             * Locates the component within the given LView and returns the matching index
             * @param {?} lView
             * @param {?} componentInstance
             * @return {?}
             */
            function findViaComponent(lView, componentInstance) {
                /** @type {?} */
                var componentIndices = lView[TVIEW].components;
                if (componentIndices) {
                    for (var i = 0; i < componentIndices.length; i++) {
                        /** @type {?} */
                        var elementComponentIndex = componentIndices[i];
                        /** @type {?} */
                        var componentView = getComponentViewByIndex(elementComponentIndex, lView);
                        if (componentView[CONTEXT] === componentInstance) {
                            return elementComponentIndex;
                        }
                    }
                }
                else {
                    /** @type {?} */
                    var rootComponentView = getComponentViewByIndex(HEADER_OFFSET, lView);
                    /** @type {?} */
                    var rootComponent = rootComponentView[CONTEXT];
                    if (rootComponent === componentInstance) {
                        // we are dealing with the root element here therefore we know that the
                        // element is the very first element after the HEADER data in the lView
                        return HEADER_OFFSET;
                    }
                }
                return -1;
            }
            /**
             * Locates the directive within the given LView and returns the matching index
             * @param {?} lView
             * @param {?} directiveInstance
             * @return {?}
             */
            function findViaDirective(lView, directiveInstance) {
                // if a directive is monkey patched then it will (by default)
                // have a reference to the LView of the current view. The
                // element bound to the directive being search lives somewhere
                // in the view data. We loop through the nodes and check their
                // list of directives for the instance.
                /** @type {?} */
                var tNode = lView[TVIEW].firstChild;
                while (tNode) {
                    /** @type {?} */
                    var directiveIndexStart = tNode.directiveStart;
                    /** @type {?} */
                    var directiveIndexEnd = tNode.directiveEnd;
                    for (var i = directiveIndexStart; i < directiveIndexEnd; i++) {
                        if (lView[i] === directiveInstance) {
                            return tNode.index;
                        }
                    }
                    tNode = traverseNextElement(tNode);
                }
                return -1;
            }
            /**
             * Returns a list of directives extracted from the given view based on the
             * provided list of directive index values.
             *
             * @param {?} nodeIndex The node index
             * @param {?} lView The target view data
             * @param {?} includeComponents Whether or not to include components in returned directives
             * @return {?}
             */
            function getDirectivesAtNodeIndex(nodeIndex, lView, includeComponents) {
                /** @type {?} */
                var tNode = ( /** @type {?} */(lView[TVIEW].data[nodeIndex]));
                /** @type {?} */
                var directiveStartIndex = tNode.directiveStart;
                if (directiveStartIndex == 0)
                    return EMPTY_ARRAY;
                /** @type {?} */
                var directiveEndIndex = tNode.directiveEnd;
                if (!includeComponents && tNode.flags & 1 /* isComponent */)
                    directiveStartIndex++;
                return lView.slice(directiveStartIndex, directiveEndIndex);
            }
            /**
             * @param {?} nodeIndex
             * @param {?} lView
             * @return {?}
             */
            function getComponentAtNodeIndex(nodeIndex, lView) {
                /** @type {?} */
                var tNode = ( /** @type {?} */(lView[TVIEW].data[nodeIndex]));
                /** @type {?} */
                var directiveStartIndex = tNode.directiveStart;
                return tNode.flags & 1 /* isComponent */ ? lView[directiveStartIndex] : null;
            }
            /**
             * Returns a map of local references (local reference name => element or directive instance) that
             * exist on a given element.
             * @param {?} lView
             * @param {?} nodeIndex
             * @return {?}
             */
            function discoverLocalRefs(lView, nodeIndex) {
                /** @type {?} */
                var tNode = ( /** @type {?} */(lView[TVIEW].data[nodeIndex]));
                if (tNode && tNode.localNames) {
                    /** @type {?} */
                    var result = {};
                    /** @type {?} */
                    var localIndex = tNode.index + 1;
                    for (var i = 0; i < tNode.localNames.length; i += 2) {
                        result[tNode.localNames[i]] = lView[localIndex];
                        localIndex++;
                    }
                    return result;
                }
                return null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Called when directives inject each other (creating a circular dependency)
             * @param {?} token
             * @return {?}
             */
            function throwCyclicDependencyError(token) {
                throw new Error("Cannot instantiate cyclic dependency! " + token);
            }
            /**
             * Called when there are multiple component selectors that match a given node
             * @param {?} tNode
             * @return {?}
             */
            function throwMultipleComponentError(tNode) {
                throw new Error("Multiple components match node with tagname " + tNode.tagName);
            }
            /**
             * Throws an ExpressionChangedAfterChecked error if checkNoChanges mode is on.
             * @param {?} creationMode
             * @param {?} oldValue
             * @param {?} currValue
             * @return {?}
             */
            function throwErrorIfNoChangesMode(creationMode, oldValue, currValue) {
                /** @type {?} */
                var msg = "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
                if (creationMode) {
                    msg +=
                        " It seems like the view has been created after its parent and its children have been dirty checked." +
                            " Has it been created in a change detection hook ?";
                }
                // TODO: include debug context
                throw new Error(msg);
            }
            /**
             * @return {?}
             */
            function throwMixedMultiProviderError() {
                throw new Error("Cannot mix multi providers and regular providers");
            }
            /**
             * @param {?=} ngModuleType
             * @param {?=} providers
             * @param {?=} provider
             * @return {?}
             */
            function throwInvalidProviderError(ngModuleType, providers, provider) {
                /** @type {?} */
                var ngModuleDetail = '';
                if (ngModuleType && providers) {
                    /** @type {?} */
                    var providerDetail = providers.map(( /**
                     * @param {?} v
                     * @return {?}
                     */function (/**
                     * @param {?} v
                     * @return {?}
                     */ v) { return v == provider ? '?' + provider + '?' : '...'; }));
                    ngModuleDetail =
                        " - only instances of Provider and Type are allowed, got: [" + providerDetail.join(', ') + "]";
                }
                throw new Error("Invalid provider for the NgModule '" + stringify(ngModuleType) + "'" + ngModuleDetail);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @enum {number} */
            var TNodeType = {
                /**
                 * The TNode contains information about an {@link LContainer} for embedded views.
                 */
                Container: 0,
                /**
                 * The TNode contains information about an `<ng-content>` projection
                 */
                Projection: 1,
                /**
                 * The TNode contains information about an {@link LView}
                 */
                View: 2,
                /**
                 * The TNode contains information about a DOM element aka {@link RNode}.
                 */
                Element: 3,
                /**
                 * The TNode contains information about an `<ng-container>` element {@link RNode}.
                 */
                ElementContainer: 4,
                /**
                 * The TNode contains information about an ICU comment used in `i18n`.
                 */
                IcuContainer: 5,
            };
            /** @enum {number} */
            var TNodeFlags = {
                /** This bit is set if the node is a component */
                isComponent: 1,
                /** This bit is set if the node has been projected */
                isProjected: 2,
                /** This bit is set if any directive on this node has content queries */
                hasContentQuery: 4,
                /** This bit is set if the node has any "class" inputs */
                hasClassInput: 8,
                /** This bit is set if the node has any "style" inputs */
                hasStyleInput: 16,
                /** This bit is set if the node has been detached by i18n */
                isDetached: 32,
            };
            /** @enum {number} */
            var TNodeProviderIndexes = {
                /** The index of the first provider on this node is encoded on the least significant bits */
                ProvidersStartIndexMask: 65535,
                /** The count of view providers from the component on this node is encoded on the 16 most
                   significant bits */
                CptViewProvidersCountShift: 16,
                CptViewProvidersCountShifter: 65536,
            };
            /** @enum {number} */
            var AttributeMarker = {
                /**
                 * Marker indicates that the following 3 values in the attributes array are:
                 * namespaceUri, attributeName, attributeValue
                 * in that order.
                 */
                NamespaceURI: 0,
                /**
                  * Signals class declaration.
                  *
                  * Each value following `Classes` designates a class name to include on the element.
                  * ## Example:
                  *
                  * Given:
                  * ```
                  * <div class="foo bar baz">...<d/vi>
                  * ```
                  *
                  * the generated code is:
                  * ```
                  * var _c1 = [AttributeMarker.Classes, 'foo', 'bar', 'baz'];
                  * ```
                  */
                Classes: 1,
                /**
                 * Signals style declaration.
                 *
                 * Each pair of values following `Styles` designates a style name and value to include on the
                 * element.
                 * ## Example:
                 *
                 * Given:
                 * ```
                 * <div style="width:100px; height:200px; color:red">...</div>
                 * ```
                 *
                 * the generated code is:
                 * ```
                 * var _c1 = [AttributeMarker.Styles, 'width', '100px', 'height'. '200px', 'color', 'red'];
                 * ```
                 */
                Styles: 2,
                /**
                 * Signals that the following attribute names were extracted from input or output bindings.
                 *
                 * For example, given the following HTML:
                 *
                 * ```
                 * <div moo="car" [foo]="exp" (bar)="doSth()">
                 * ```
                 *
                 * the generated code is:
                 *
                 * ```
                 * var _c1 = ['moo', 'car', AttributeMarker.Bindings, 'foo', 'bar'];
                 * ```
                 */
                Bindings: 3,
                /**
                 * Signals that the following attribute names were hoisted from an inline-template declaration.
                 *
                 * For example, given the following HTML:
                 *
                 * ```
                 * <div *ngFor="let value of values; trackBy:trackBy" dirA [dirB]="value">
                 * ```
                 *
                 * the generated code for the `template()` instruction would include:
                 *
                 * ```
                 * ['dirA', '', AttributeMarker.Bindings, 'dirB', AttributeMarker.Template, 'ngFor', 'ngForOf',
                 * 'ngForTrackBy', 'let-value']
                 * ```
                 *
                 * while the generated code for the `element()` instruction inside the template function would
                 * include:
                 *
                 * ```
                 * ['dirA', '', AttributeMarker.Bindings, 'dirB']
                 * ```
                 */
                Template: 4,
                /**
                 * Signals that the following attribute is `ngProjectAs` and its value is a parsed `CssSelector`.
                 *
                 * For example, given the following HTML:
                 *
                 * ```
                 * <h1 attr="value" ngProjectAs="[title]">
                 * ```
                 *
                 * the generated code for the `element()` instruction would include:
                 *
                 * ```
                 * ['attr', 'value', AttributeMarker.ProjectAs, ['', 'title', '']]
                 * ```
                 */
                ProjectAs: 5,
                /**
                 * Signals that the following attribute will be translated by runtime i18n
                 *
                 * For example, given the following HTML:
                 *
                 * ```
                 * <div moo="car" foo="value" i18n-foo [bar]="binding" i18n-bar>
                 * ```
                 *
                 * the generated code is:
                 *
                 * ```
                 * var _c1 = ['moo', 'car', AttributeMarker.I18n, 'foo', 'bar'];
                 */
                I18n: 6,
            };
            /**
             * Binding data (flyweight) for a particular node that is shared between all templates
             * of a specific type.
             *
             * If a property is:
             *    - PropertyAliases: that property's data was generated and this is it
             *    - Null: that property's data was already generated and nothing was found.
             *    - Undefined: that property's data has not yet been generated
             *
             * see: https://en.wikipedia.org/wiki/Flyweight_pattern for more on the Flyweight pattern
             * @record
             */
            function TNode() { }
            if (false) { }
            /**
             * Static data for an element
             * @record
             */
            function TElementNode() { }
            if (false) { }
            /**
             * Static data for a text node
             * @record
             */
            function TTextNode() { }
            if (false) { }
            /**
             * Static data for an LContainer
             * @record
             */
            function TContainerNode() { }
            if (false) { }
            /**
             * Static data for an <ng-container>
             * @record
             */
            function TElementContainerNode() { }
            if (false) { }
            /**
             * Static data for an ICU expression
             * @record
             */
            function TIcuContainerNode() { }
            if (false) { }
            /**
             * Static data for a view
             * @record
             */
            function TViewNode() { }
            if (false) { }
            /**
             * Static data for an LProjectionNode
             * @record
             */
            function TProjectionNode() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$4 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @enum {number} */
            var SelectorFlags = {
                /** Indicates this is the beginning of a new negative selector */
                NOT: 1,
                /** Mode for matching attributes */
                ATTRIBUTE: 2,
                /** Mode for matching tag names */
                ELEMENT: 4,
                /** Mode for matching class names */
                CLASS: 8,
            };
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$5 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var unusedValueToPlacateAjd = unusedValueExportToPlacateAjd$4 + unusedValueExportToPlacateAjd$5;
            /** @type {?} */
            var NG_TEMPLATE_SELECTOR = 'ng-template';
            /**
             * @param {?} nodeClassAttrVal
             * @param {?} cssClassToMatch
             * @return {?}
             */
            function isCssClassMatching(nodeClassAttrVal, cssClassToMatch) {
                /** @type {?} */
                var nodeClassesLen = nodeClassAttrVal.length;
                /** @type {?} */
                var matchIndex = ( /** @type {?} */(nodeClassAttrVal)).indexOf(cssClassToMatch);
                /** @type {?} */
                var matchEndIdx = matchIndex + cssClassToMatch.length;
                if (matchIndex === -1 // no match
                    || (matchIndex > 0 && ( /** @type {?} */(nodeClassAttrVal))[matchIndex - 1] !== ' ') // no space before
                    ||
                        (matchEndIdx < nodeClassesLen && ( /** @type {?} */(nodeClassAttrVal))[matchEndIdx] !== ' ')) // no space after
                 {
                    return false;
                }
                return true;
            }
            /**
             * Function that checks whether a given tNode matches tag-based selector and has a valid type.
             *
             * Matching can be performed in 2 modes: projection mode (when we project nodes) and regular
             * directive matching mode:
             * - in the "directive matching" mode we do _not_ take TContainer's tagName into account if it is
             * different from NG_TEMPLATE_SELECTOR (value different from NG_TEMPLATE_SELECTOR indicates that a
             * tag name was extracted from * syntax so we would match the same directive twice);
             * - in the "projection" mode, we use a tag name potentially extracted from the * syntax processing
             * (applicable to TNodeType.Container only).
             * @param {?} tNode
             * @param {?} currentSelector
             * @param {?} isProjectionMode
             * @return {?}
             */
            function hasTagAndTypeMatch(tNode, currentSelector, isProjectionMode) {
                /** @type {?} */
                var tagNameToCompare = tNode.type === 0 /* Container */ && !isProjectionMode ?
                    NG_TEMPLATE_SELECTOR :
                    tNode.tagName;
                return currentSelector === tagNameToCompare;
            }
            /**
             * A utility function to match an Ivy node static data against a simple CSS selector
             *
             * @param {?} tNode
             * @param {?} selector The selector to try matching against the node.
             * @param {?} isProjectionMode if `true` we are matching for content projection, otherwise we are doing
             * directive matching.
             * @return {?} true if node matches the selector.
             */
            function isNodeMatchingSelector(tNode, selector, isProjectionMode) {
                ngDevMode && assertDefined(selector[0], 'Selector should have a tag name');
                /** @type {?} */
                var mode = 4 /* ELEMENT */;
                /** @type {?} */
                var nodeAttrs = tNode.attrs || [];
                // Find the index of first attribute that has no value, only a name.
                /** @type {?} */
                var nameOnlyMarkerIdx = getNameOnlyMarkerIndex(nodeAttrs);
                // When processing ":not" selectors, we skip to the next ":not" if the
                // current one doesn't match
                /** @type {?} */
                var skipToNextSelector = false;
                for (var i = 0; i < selector.length; i++) {
                    /** @type {?} */
                    var current = selector[i];
                    if (typeof current === 'number') {
                        // If we finish processing a :not selector and it hasn't failed, return false
                        if (!skipToNextSelector && !isPositive(mode) && !isPositive(( /** @type {?} */(current)))) {
                            return false;
                        }
                        // If we are skipping to the next :not() and this mode flag is positive,
                        // it's a part of the current :not() selector, and we should keep skipping
                        if (skipToNextSelector && isPositive(current))
                            continue;
                        skipToNextSelector = false;
                        mode = (( /** @type {?} */(current))) | (mode & 1 /* NOT */);
                        continue;
                    }
                    if (skipToNextSelector)
                        continue;
                    if (mode & 4 /* ELEMENT */) {
                        mode = 2 /* ATTRIBUTE */ | mode & 1 /* NOT */;
                        if (current !== '' && !hasTagAndTypeMatch(tNode, current, isProjectionMode) ||
                            current === '' && selector.length === 1) {
                            if (isPositive(mode))
                                return false;
                            skipToNextSelector = true;
                        }
                    }
                    else {
                        /** @type {?} */
                        var selectorAttrValue = mode & 8 /* CLASS */ ? current : selector[++i];
                        // special case for matching against classes when a tNode has been instantiated with
                        // class and style values as separate attribute values (e.g. ['title', CLASS, 'foo'])
                        if ((mode & 8 /* CLASS */) && tNode.classes) {
                            if (!isCssClassMatching(getInitialStylingValue(tNode.classes), ( /** @type {?} */(selectorAttrValue)))) {
                                if (isPositive(mode))
                                    return false;
                                skipToNextSelector = true;
                            }
                            continue;
                        }
                        /** @type {?} */
                        var isInlineTemplate = tNode.type == 0 /* Container */ && tNode.tagName !== NG_TEMPLATE_SELECTOR;
                        /** @type {?} */
                        var attrName = (mode & 8 /* CLASS */) ? 'class' : current;
                        /** @type {?} */
                        var attrIndexInNode = findAttrIndexInNode(attrName, nodeAttrs, isInlineTemplate, isProjectionMode);
                        if (attrIndexInNode === -1) {
                            if (isPositive(mode))
                                return false;
                            skipToNextSelector = true;
                            continue;
                        }
                        if (selectorAttrValue !== '') {
                            /** @type {?} */
                            var nodeAttrValue = void 0;
                            if (attrIndexInNode > nameOnlyMarkerIdx) {
                                nodeAttrValue = '';
                            }
                            else {
                                ngDevMode && assertNotEqual(nodeAttrs[attrIndexInNode], 0 /* NamespaceURI */, 'We do not match directives on namespaced attributes');
                                nodeAttrValue = ( /** @type {?} */(nodeAttrs[attrIndexInNode + 1]));
                            }
                            /** @type {?} */
                            var compareAgainstClassName = mode & 8 /* CLASS */ ? nodeAttrValue : null;
                            if (compareAgainstClassName &&
                                !isCssClassMatching(compareAgainstClassName, ( /** @type {?} */(selectorAttrValue))) ||
                                mode & 2 /* ATTRIBUTE */ && selectorAttrValue !== nodeAttrValue) {
                                if (isPositive(mode))
                                    return false;
                                skipToNextSelector = true;
                            }
                        }
                    }
                }
                return isPositive(mode) || skipToNextSelector;
            }
            /**
             * @param {?} mode
             * @return {?}
             */
            function isPositive(mode) {
                return (mode & 1 /* NOT */) === 0;
            }
            /**
             * Examines the attribute's definition array for a node to find the index of the
             * attribute that matches the given `name`.
             *
             * NOTE: This will not match namespaced attributes.
             *
             * Attribute matching depends upon `isInlineTemplate` and `isProjectionMode`.
             * The following table summarizes which types of attributes we attempt to match:
             *
             * ===========================================================================================================
             * Modes                   | Normal Attributes | Bindings Attributes | Template Attributes | I18n
             * Attributes
             * ===========================================================================================================
             * Inline + Projection     | YES               | YES                 | NO                  | YES
             * -----------------------------------------------------------------------------------------------------------
             * Inline + Directive      | NO                | NO                  | YES                 | NO
             * -----------------------------------------------------------------------------------------------------------
             * Non-inline + Projection | YES               | YES                 | NO                  | YES
             * -----------------------------------------------------------------------------------------------------------
             * Non-inline + Directive  | YES               | YES                 | NO                  | YES
             * ===========================================================================================================
             *
             * @param {?} name the name of the attribute to find
             * @param {?} attrs the attribute array to examine
             * @param {?} isInlineTemplate true if the node being matched is an inline template (e.g. `*ngFor`)
             * rather than a manually expanded template node (e.g `<ng-template>`).
             * @param {?} isProjectionMode true if we are matching against content projection otherwise we are
             * matching against directives.
             * @return {?}
             */
            function findAttrIndexInNode(name, attrs, isInlineTemplate, isProjectionMode) {
                if (attrs === null)
                    return -1;
                /** @type {?} */
                var i = 0;
                if (isProjectionMode || !isInlineTemplate) {
                    /** @type {?} */
                    var bindingsMode = false;
                    while (i < attrs.length) {
                        /** @type {?} */
                        var maybeAttrName = attrs[i];
                        if (maybeAttrName === name) {
                            return i;
                        }
                        else if (maybeAttrName === 3 /* Bindings */ || maybeAttrName === 6 /* I18n */) {
                            bindingsMode = true;
                        }
                        else if (maybeAttrName === 1 /* Classes */) {
                            /** @type {?} */
                            var value = attrs[++i];
                            // We should skip classes here because we have a separate mechanism for
                            // matching classes in projection mode.
                            while (typeof value === 'string') {
                                value = attrs[++i];
                            }
                            continue;
                        }
                        else if (maybeAttrName === 4 /* Template */) {
                            // We do not care about Template attributes in this scenario.
                            break;
                        }
                        else if (maybeAttrName === 0 /* NamespaceURI */) {
                            // Skip the whole namespaced attribute and value. This is by design.
                            i += 4;
                            continue;
                        }
                        // In binding mode there are only names, rather than name-value pairs.
                        i += bindingsMode ? 1 : 2;
                    }
                    // We did not match the attribute
                    return -1;
                }
                else {
                    return matchTemplateAttribute(attrs, name);
                }
            }
            /**
             * @param {?} tNode
             * @param {?} selector
             * @param {?=} isProjectionMode
             * @return {?}
             */
            function isNodeMatchingSelectorList(tNode, selector, isProjectionMode) {
                if (isProjectionMode === void 0) { isProjectionMode = false; }
                for (var i = 0; i < selector.length; i++) {
                    if (isNodeMatchingSelector(tNode, selector[i], isProjectionMode)) {
                        return true;
                    }
                }
                return false;
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function getProjectAsAttrValue(tNode) {
                /** @type {?} */
                var nodeAttrs = tNode.attrs;
                if (nodeAttrs != null) {
                    /** @type {?} */
                    var ngProjectAsAttrIdx = nodeAttrs.indexOf(5 /* ProjectAs */);
                    // only check for ngProjectAs in attribute names, don't accidentally match attribute's value
                    // (attribute names are stored at even indexes)
                    if ((ngProjectAsAttrIdx & 1) === 0) {
                        return ( /** @type {?} */(nodeAttrs[ngProjectAsAttrIdx + 1]));
                    }
                }
                return null;
            }
            /**
             * @param {?} nodeAttrs
             * @return {?}
             */
            function getNameOnlyMarkerIndex(nodeAttrs) {
                for (var i = 0; i < nodeAttrs.length; i++) {
                    /** @type {?} */
                    var nodeAttr = nodeAttrs[i];
                    if (isNameOnlyAttributeMarker(nodeAttr)) {
                        return i;
                    }
                }
                return nodeAttrs.length;
            }
            /**
             * @param {?} attrs
             * @param {?} name
             * @return {?}
             */
            function matchTemplateAttribute(attrs, name) {
                /** @type {?} */
                var i = attrs.indexOf(4 /* Template */);
                if (i > -1) {
                    i++;
                    while (i < attrs.length) {
                        if (attrs[i] === name)
                            return i;
                        i++;
                    }
                }
                return -1;
            }
            /**
             * Checks whether a selector is inside a CssSelectorList
             * @param {?} selector Selector to be checked.
             * @param {?} list List in which to look for the selector.
             * @return {?}
             */
            function isSelectorInSelectorList(selector, list) {
                selectorListLoop: for (var i = 0; i < list.length; i++) {
                    /** @type {?} */
                    var currentSelectorInList = list[i];
                    if (selector.length !== currentSelectorInList.length) {
                        continue;
                    }
                    for (var j = 0; j < selector.length; j++) {
                        if (selector[j] !== currentSelectorInList[j]) {
                            continue selectorListLoop;
                        }
                    }
                    return true;
                }
                return false;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // The first bit value reflects a map-based binding value's bit.
            // The reason why it's always activated for every entry in the map
            // is so that if any map-binding values update then all other prop
            // based bindings will pass the guard check automatically without
            // any extra code or flags.
            /**
             * --------
             *
             * This file contains the core logic for styling in Angular.
             *
             * All styling bindings (i.e. `[style]`, `[style.prop]`, `[class]` and `[class.name]`)
             * will have their values be applied through the logic in this file.
             *
             * When a binding is encountered (e.g. `<div [style.width]="w">`) then
             * the binding data will be populated into a `TStylingContext` data-structure.
             * There is only one `TStylingContext` per `TNode` and each element instance
             * will update its style/class binding values in concert with the styling
             * context.
             *
             * To learn more about the algorithm see `TStylingContext`.
             *
             * --------
             * @type {?}
             */
            var DEFAULT_GUARD_MASK_VALUE = 1;
            /**
             * The guard/update mask bit index location for map-based bindings.
             *
             * All map-based bindings (i.e. `[style]` and `[class]` )
             * @type {?}
             */
            var STYLING_INDEX_FOR_MAP_BINDING = 0;
            /**
             * Default fallback value for a styling binding.
             *
             * A value of `null` is used here which signals to the styling algorithm that
             * the styling value is not present. This way if there are no other values
             * detected then it will be removed once the style/class property is dirty and
             * diffed within the styling algorithm present in `flushStyling`.
             * @type {?}
             */
            var DEFAULT_BINDING_VALUE = null;
            /**
             * Default size count value for a new entry in a context.
             *
             * A value of `1` is used here because each entry in the context has a default
             * property.
             * @type {?}
             */
            var DEFAULT_SIZE_VALUE = 1;
            /** @type {?} */
            var deferredBindingQueue = [];
            /**
             * Visits a class-based binding and updates the new value (if changed).
             *
             * This function is called each time a class-based styling instruction
             * is executed. It's important that it's always called (even if the value
             * has not changed) so that the inner counter index value is incremented.
             * This way, each instruction is always guaranteed to get the same counter
             * state each time it's called (which then allows the `TStylingContext`
             * and the bit mask values to be in sync).
             * @param {?} context
             * @param {?} data
             * @param {?} element
             * @param {?} prop
             * @param {?} bindingIndex
             * @param {?} value
             * @param {?} deferRegistration
             * @param {?} forceUpdate
             * @return {?}
             */
            function updateClassBinding(context, data, element, prop, bindingIndex, value, deferRegistration, forceUpdate) {
                /** @type {?} */
                var isMapBased = !prop;
                /** @type {?} */
                var state = getStylingState(element, stateIsPersisted(context));
                /** @type {?} */
                var index = isMapBased ? STYLING_INDEX_FOR_MAP_BINDING : state.classesIndex++;
                /** @type {?} */
                var updated = updateBindingData(context, data, index, prop, bindingIndex, value, deferRegistration, forceUpdate, false);
                if (updated || forceUpdate) {
                    // We flip the bit in the bitMask to reflect that the binding
                    // at the `index` slot has changed. This identifies to the flushing
                    // phase that the bindings for this particular CSS class need to be
                    // applied again because on or more of the bindings for the CSS
                    // class have changed.
                    state.classesBitMask |= 1 << index;
                    return true;
                }
                return false;
            }
            /**
             * Visits a style-based binding and updates the new value (if changed).
             *
             * This function is called each time a style-based styling instruction
             * is executed. It's important that it's always called (even if the value
             * has not changed) so that the inner counter index value is incremented.
             * This way, each instruction is always guaranteed to get the same counter
             * state each time it's called (which then allows the `TStylingContext`
             * and the bit mask values to be in sync).
             * @param {?} context
             * @param {?} data
             * @param {?} element
             * @param {?} prop
             * @param {?} bindingIndex
             * @param {?} value
             * @param {?} sanitizer
             * @param {?} deferRegistration
             * @param {?} forceUpdate
             * @return {?}
             */
            function updateStyleBinding(context, data, element, prop, bindingIndex, value, sanitizer, deferRegistration, forceUpdate) {
                /** @type {?} */
                var isMapBased = !prop;
                /** @type {?} */
                var state = getStylingState(element, stateIsPersisted(context));
                /** @type {?} */
                var index = isMapBased ? STYLING_INDEX_FOR_MAP_BINDING : state.stylesIndex++;
                /** @type {?} */
                var sanitizationRequired = isMapBased ?
                    true :
                    (sanitizer ? sanitizer(( /** @type {?} */(prop)), null, 1 /* ValidateProperty */) : false);
                /** @type {?} */
                var updated = updateBindingData(context, data, index, prop, bindingIndex, value, deferRegistration, forceUpdate, sanitizationRequired);
                if (updated || forceUpdate) {
                    // We flip the bit in the bitMask to reflect that the binding
                    // at the `index` slot has changed. This identifies to the flushing
                    // phase that the bindings for this particular property need to be
                    // applied again because on or more of the bindings for the CSS
                    // property have changed.
                    state.stylesBitMask |= 1 << index;
                    return true;
                }
                return false;
            }
            /**
             * Called each time a binding value has changed within the provided `TStylingContext`.
             *
             * This function is designed to be called from `updateStyleBinding` and `updateClassBinding`.
             * If called during the first update pass, the binding will be registered in the context.
             * If the binding does get registered and the `deferRegistration` flag is true then the
             * binding data will be queued up until the context is later flushed in `applyStyling`.
             *
             * This function will also update binding slot in the provided `LStylingData` with the
             * new binding entry (if it has changed).
             *
             * @param {?} context
             * @param {?} data
             * @param {?} counterIndex
             * @param {?} prop
             * @param {?} bindingIndex
             * @param {?} value
             * @param {?} deferRegistration
             * @param {?} forceUpdate
             * @param {?} sanitizationRequired
             * @return {?} whether or not the binding value was updated in the `LStylingData`.
             */
            function updateBindingData(context, data, counterIndex, prop, bindingIndex, value, deferRegistration, forceUpdate, sanitizationRequired) {
                if (!isContextLocked(context)) {
                    if (deferRegistration) {
                        deferBindingRegistration(context, counterIndex, prop, bindingIndex, sanitizationRequired);
                    }
                    else {
                        deferredBindingQueue.length && flushDeferredBindings();
                        // this will only happen during the first update pass of the
                        // context. The reason why we can't use `tNode.firstTemplatePass`
                        // here is because its not guaranteed to be true when the first
                        // update pass is executed (remember that all styling instructions
                        // are run in the update phase, and, as a result, are no more
                        // styling instructions that are run in the creation phase).
                        registerBinding(context, counterIndex, prop, bindingIndex, sanitizationRequired);
                    }
                }
                /** @type {?} */
                var changed = forceUpdate || hasValueChanged(data[bindingIndex], value);
                if (changed) {
                    data[bindingIndex] = value;
                }
                return changed;
            }
            /**
             * Schedules a binding registration to be run at a later point.
             *
             * The reasoning for this feature is to ensure that styling
             * bindings are registered in the correct order for when
             * directives/components have a super/sub class inheritance
             * chains. Each directive's styling bindings must be
             * registered into the context in reverse order. Therefore all
             * bindings will be buffered in reverse order and then applied
             * after the inheritance chain exits.
             * @param {?} context
             * @param {?} counterIndex
             * @param {?} prop
             * @param {?} bindingIndex
             * @param {?} sanitizationRequired
             * @return {?}
             */
            function deferBindingRegistration(context, counterIndex, prop, bindingIndex, sanitizationRequired) {
                deferredBindingQueue.unshift(context, counterIndex, prop, bindingIndex, sanitizationRequired);
            }
            /**
             * Flushes the collection of deferred bindings and causes each entry
             * to be registered into the context.
             * @return {?}
             */
            function flushDeferredBindings() {
                /** @type {?} */
                var i = 0;
                while (i < deferredBindingQueue.length) {
                    /** @type {?} */
                    var context = ( /** @type {?} */(deferredBindingQueue[i++]));
                    /** @type {?} */
                    var count = ( /** @type {?} */(deferredBindingQueue[i++]));
                    /** @type {?} */
                    var prop = ( /** @type {?} */(deferredBindingQueue[i++]));
                    /** @type {?} */
                    var bindingIndex = ( /** @type {?} */(deferredBindingQueue[i++]));
                    /** @type {?} */
                    var sanitizationRequired = ( /** @type {?} */(deferredBindingQueue[i++]));
                    registerBinding(context, count, prop, bindingIndex, sanitizationRequired);
                }
                deferredBindingQueue.length = 0;
            }
            /**
             * Registers the provided binding (prop + bindingIndex) into the context.
             *
             * This function is shared between bindings that are assigned immediately
             * (via `updateBindingData`) and at a deferred stage. When called, it will
             * figure out exactly where to place the binding data in the context.
             *
             * It is needed because it will either update or insert a styling property
             * into the context at the correct spot.
             *
             * When called, one of two things will happen:
             *
             * 1) If the property already exists in the context then it will just add
             *    the provided `bindingValue` to the end of the binding sources region
             *    for that particular property.
             *
             *    - If the binding value is a number then it will be added as a new
             *      binding index source next to the other binding sources for the property.
             *
             *    - Otherwise, if the binding value is a string/boolean/null type then it will
             *      replace the default value for the property if the default value is `null`.
             *
             * 2) If the property does not exist then it will be inserted into the context.
             *    The styling context relies on all properties being stored in alphabetical
             *    order, so it knows exactly where to store it.
             *
             *    When inserted, a default `null` value is created for the property which exists
             *    as the default value for the binding. If the bindingValue property is inserted
             *    and it is either a string, number or null value then that will replace the default
             *    value.
             *
             * Note that this function is also used for map-based styling bindings. They are treated
             * much the same as prop-based bindings, but, because they do not have a property value
             * (since it's a map), all map-based entries are stored in an already populated area of
             * the context at the top (which is reserved for map-based entries).
             * @param {?} context
             * @param {?} countId
             * @param {?} prop
             * @param {?} bindingValue
             * @param {?=} sanitizationRequired
             * @return {?}
             */
            function registerBinding(context, countId, prop, bindingValue, sanitizationRequired) {
                /** @type {?} */
                var registered = false;
                if (prop) {
                    // prop-based bindings (e.g `<div [style.width]="w" [class.foo]="f">`)
                    /** @type {?} */
                    var found = false;
                    /** @type {?} */
                    var i = getPropValuesStartPosition(context);
                    while (i < context.length) {
                        /** @type {?} */
                        var valuesCount = getValuesCount(context, i);
                        /** @type {?} */
                        var p = getProp(context, i);
                        found = prop <= p;
                        if (found) {
                            // all style/class bindings are sorted by property name
                            if (prop < p) {
                                allocateNewContextEntry(context, i, prop, sanitizationRequired);
                            }
                            addBindingIntoContext(context, false, i, bindingValue, countId);
                            break;
                        }
                        i += 3 /* BindingsStartOffset */ + valuesCount;
                    }
                    if (!found) {
                        allocateNewContextEntry(context, context.length, prop, sanitizationRequired);
                        addBindingIntoContext(context, false, i, bindingValue, countId);
                        registered = true;
                    }
                }
                else {
                    // map-based bindings (e.g `<div [style]="s" [class]="{className:true}">`)
                    // there is no need to allocate the map-based binding region into the context
                    // since it is already there when the context is first created.
                    addBindingIntoContext(context, true, 3 /* MapBindingsPosition */, bindingValue, countId);
                    registered = true;
                }
                return registered;
            }
            /**
             * @param {?} context
             * @param {?} index
             * @param {?} prop
             * @param {?=} sanitizationRequired
             * @return {?}
             */
            function allocateNewContextEntry(context, index, prop, sanitizationRequired) {
                // 1,2: splice index locations
                // 3: each entry gets a config value (guard mask + flags)
                // 4. each entry gets a size value (which is always one because there is always a default binding
                // value)
                // 5. the property that is getting allocated into the context
                // 6. the default binding value (usually `null`)
                /** @type {?} */
                var config = sanitizationRequired ? 1 /* SanitizationRequired */ :
                    0 /* Default */;
                context.splice(index, 0, config, DEFAULT_SIZE_VALUE, prop, DEFAULT_BINDING_VALUE);
                setGuardMask(context, index, DEFAULT_GUARD_MASK_VALUE);
            }
            /**
             * Inserts a new binding value into a styling property tuple in the `TStylingContext`.
             *
             * A bindingValue is inserted into a context during the first update pass
             * of a template or host bindings function. When this occurs, two things
             * happen:
             *
             * - If the bindingValue value is a number then it is treated as a bindingIndex
             *   value (a index in the `LView`) and it will be inserted next to the other
             *   binding index entries.
             *
             * - Otherwise the binding value will update the default value for the property
             *   and this will only happen if the default value is `null`.
             *
             * Note that this function also handles map-based bindings and will insert them
             * at the top of the context.
             * @param {?} context
             * @param {?} isMapBased
             * @param {?} index
             * @param {?} bindingValue
             * @param {?} countId
             * @return {?}
             */
            function addBindingIntoContext(context, isMapBased, index, bindingValue, countId) {
                /** @type {?} */
                var valuesCount = getValuesCount(context, index);
                /** @type {?} */
                var firstValueIndex = index + 3 /* BindingsStartOffset */;
                /** @type {?} */
                var lastValueIndex = firstValueIndex + valuesCount;
                if (!isMapBased) {
                    // prop-based values all have default values, but map-based entries do not.
                    // we want to access the index for the default value in this case and not just
                    // the bindings...
                    lastValueIndex--;
                }
                if (typeof bindingValue === 'number') {
                    // the loop here will check to see if the binding already exists
                    // for the property in the context. Why? The reason for this is
                    // because the styling context is not "locked" until the first
                    // flush has occurred. This means that if a repeated element
                    // registers its styling bindings then it will register each
                    // binding more than once (since its duplicated). This check
                    // will prevent that from happening. Note that this only happens
                    // when a binding is first encountered and not each time it is
                    // updated.
                    for (var i = firstValueIndex; i <= lastValueIndex; i++) {
                        /** @type {?} */
                        var indexAtPosition = context[i];
                        if (indexAtPosition === bindingValue)
                            return;
                    }
                    context.splice(lastValueIndex, 0, bindingValue);
                    (( /** @type {?} */(context[index + 1 /* ValuesCountOffset */])))++;
                    // now that a new binding index has been added to the property
                    // the guard mask bit value (at the `countId` position) needs
                    // to be included into the existing mask value.
                    /** @type {?} */
                    var guardMask = getGuardMask(context, index) | (1 << countId);
                    setGuardMask(context, index, guardMask);
                }
                else if (bindingValue !== null && context[lastValueIndex] == null) {
                    context[lastValueIndex] = bindingValue;
                }
            }
            /**
             * Applies all pending style and class bindings to the provided element.
             *
             * This function will attempt to flush styling via the provided `classesContext`
             * and `stylesContext` context values. This function is designed to be run from
             * the `stylingApply()` instruction (which is run at the very end of styling
             * change detection) and will rely on any state values that are set from when
             * any styling bindings update.
             *
             * This function may be called multiple times on the same element because it can
             * be called from the template code as well as from host bindings. In order for
             * styling to be successfully flushed to the element (which will only happen once
             * despite this being called multiple times), the following criteria must be met:
             *
             * - `flushStyling` is called from the very last directive that has styling for
             *    the element (see `allowStylingFlush()`).
             * - one or more bindings for classes or styles has updated (this is checked by
             *   examining the classes or styles bit mask).
             *
             * If the style and class values are successfully applied to the element then
             * the temporary state values for the element will be cleared. Otherwise, if
             * this did not occur then the styling state is persisted (see `state.ts` for
             * more information on how this works).
             * @param {?} renderer
             * @param {?} data
             * @param {?} classesContext
             * @param {?} stylesContext
             * @param {?} element
             * @param {?} directiveIndex
             * @param {?} styleSanitizer
             * @return {?}
             */
            function flushStyling(renderer, data, classesContext, stylesContext, element, directiveIndex, styleSanitizer) {
                ngDevMode && ngDevMode.flushStyling++;
                /** @type {?} */
                var persistState = classesContext ? stateIsPersisted(classesContext) :
                    (stylesContext ? stateIsPersisted(stylesContext) : false);
                /** @type {?} */
                var allowFlushClasses = allowStylingFlush(classesContext, directiveIndex);
                /** @type {?} */
                var allowFlushStyles = allowStylingFlush(stylesContext, directiveIndex);
                // deferred bindings are bindings which are scheduled to register with
                // the context at a later point. These bindings can only registered when
                // the context will be 100% flushed to the element.
                if (deferredBindingQueue.length && (allowFlushClasses || allowFlushStyles)) {
                    flushDeferredBindings();
                }
                /** @type {?} */
                var state = getStylingState(element, persistState);
                /** @type {?} */
                var classesFlushed = maybeApplyStyling(renderer, element, data, classesContext, allowFlushClasses, state.classesBitMask, setClass, null);
                /** @type {?} */
                var stylesFlushed = maybeApplyStyling(renderer, element, data, stylesContext, allowFlushStyles, state.stylesBitMask, setStyle, styleSanitizer);
                if (classesFlushed && stylesFlushed) {
                    resetStylingState();
                    if (persistState) {
                        deleteStylingStateFromStorage(element);
                    }
                }
                else if (persistState) {
                    storeStylingState(element, state);
                }
            }
            /**
             * @param {?} renderer
             * @param {?} element
             * @param {?} data
             * @param {?} context
             * @param {?} allowFlush
             * @param {?} bitMask
             * @param {?} styleSetter
             * @param {?} styleSanitizer
             * @return {?}
             */
            function maybeApplyStyling(renderer, element, data, context, allowFlush, bitMask, styleSetter, styleSanitizer) {
                if (allowFlush && context) {
                    lockAndFinalizeContext(context);
                    if (contextHasUpdates(context, bitMask)) {
                        ngDevMode && (styleSanitizer ? ngDevMode.stylesApplied++ : ngDevMode.classesApplied++);
                        applyStyling(( /** @type {?} */(context)), renderer, element, data, bitMask, styleSetter, styleSanitizer);
                        return true;
                    }
                }
                return allowFlush;
            }
            /**
             * @param {?} context
             * @param {?} bitMask
             * @return {?}
             */
            function contextHasUpdates(context, bitMask) {
                return context && bitMask > BIT_MASK_START_VALUE;
            }
            /**
             * Locks the context (so no more bindings can be added) and also copies over initial class/style
             * values into their binding areas.
             *
             * There are two main actions that take place in this function:
             *
             * - Locking the context:
             *   Locking the context is required so that the style/class instructions know NOT to
             *   register a binding again after the first update pass has run. If a locking bit was
             *   not used then it would need to scan over the context each time an instruction is run
             *   (which is expensive).
             *
             * - Patching initial values:
             *   Directives and component host bindings may include static class/style values which are
             *   bound to the host element. When this happens, the styling context will need to be informed
             *   so it can use these static styling values as defaults when a matching binding is falsy.
             *   These initial styling values are read from the initial styling values slot within the
             *   provided `TStylingContext` (which is an instance of a `StylingMapArray`). This inner map will
             *   be updated each time a host binding applies its static styling values (via `elementHostAttrs`)
             *   so these values are only read at this point because this is the very last point before the
             *   first style/class values are flushed to the element.
             * @param {?} context
             * @return {?}
             */
            function lockAndFinalizeContext(context) {
                if (!isContextLocked(context)) {
                    /** @type {?} */
                    var initialValues = getStylingMapArray(context);
                    if (initialValues) {
                        updateInitialStylingOnContext(context, initialValues);
                    }
                    lockContext(context);
                }
            }
            /**
             * Runs through the provided styling context and applies each value to
             * the provided element (via the renderer) if one or more values are present.
             *
             * This function will iterate over all entries present in the provided
             * `TStylingContext` array (both prop-based and map-based bindings).-
             *
             * Each entry, within the `TStylingContext` array, is stored alphabetically
             * and this means that each prop/value entry will be applied in order
             * (so long as it is marked dirty in the provided `bitMask` value).
             *
             * If there are any map-based entries present (which are applied to the
             * element via the `[style]` and `[class]` bindings) then those entries
             * will be applied as well. However, the code for that is not a part of
             * this function. Instead, each time a property is visited, then the
             * code below will call an external function called `stylingMapsSyncFn`
             * and, if present, it will keep the application of styling values in
             * map-based bindings up to sync with the application of prop-based
             * bindings.
             *
             * Visit `styling_next/map_based_bindings.ts` to learn more about how the
             * algorithm works for map-based styling bindings.
             *
             * Note that this function is not designed to be called in isolation (use
             * `applyClasses` and `applyStyles` to actually apply styling values).
             * @param {?} context
             * @param {?} renderer
             * @param {?} element
             * @param {?} bindingData
             * @param {?} bitMaskValue
             * @param {?} applyStylingFn
             * @param {?} sanitizer
             * @return {?}
             */
            function applyStyling(context, renderer, element, bindingData, bitMaskValue, applyStylingFn, sanitizer) {
                /** @type {?} */
                var bitMask = normalizeBitMaskValue(bitMaskValue);
                /** @type {?} */
                var stylingMapsSyncFn = getStylingMapsSyncFn();
                /** @type {?} */
                var mapsGuardMask = getGuardMask(context, 3 /* MapBindingsPosition */);
                /** @type {?} */
                var applyAllValues = (bitMask & mapsGuardMask) > 0;
                /** @type {?} */
                var mapsMode = applyAllValues ? 1 /* ApplyAllValues */ : 0 /* TraverseValues */;
                /** @type {?} */
                var i = getPropValuesStartPosition(context);
                while (i < context.length) {
                    /** @type {?} */
                    var valuesCount = getValuesCount(context, i);
                    /** @type {?} */
                    var guardMask = getGuardMask(context, i);
                    if (bitMask & guardMask) {
                        /** @type {?} */
                        var valueApplied = false;
                        /** @type {?} */
                        var prop = getProp(context, i);
                        /** @type {?} */
                        var valuesCountUpToDefault = valuesCount - 1;
                        /** @type {?} */
                        var defaultValue = ( /** @type {?} */(getBindingValue(context, i, valuesCountUpToDefault)));
                        // case 1: apply prop-based values
                        // try to apply the binding values and see if a non-null
                        // value gets set for the styling binding
                        for (var j = 0; j < valuesCountUpToDefault; j++) {
                            /** @type {?} */
                            var bindingIndex = ( /** @type {?} */(getBindingValue(context, i, j)));
                            /** @type {?} */
                            var value = bindingData[bindingIndex];
                            if (isStylingValueDefined(value)) {
                                /** @type {?} */
                                var finalValue = sanitizer && isSanitizationRequired(context, i) ?
                                    sanitizer(prop, value, 2 /* SanitizeOnly */) :
                                    value;
                                applyStylingFn(renderer, element, prop, finalValue, bindingIndex);
                                valueApplied = true;
                                break;
                            }
                        }
                        // case 2: apply map-based values
                        // traverse through each map-based styling binding and update all values up to
                        // the provided `prop` value. If the property was not applied in the loop above
                        // then it will be attempted to be applied in the maps sync code below.
                        if (stylingMapsSyncFn) {
                            // determine whether or not to apply the target property or to skip it
                            /** @type {?} */
                            var mode = mapsMode | (valueApplied ? 4 /* SkipTargetProp */ :
                                2 /* ApplyTargetProp */);
                            /** @type {?} */
                            var valueAppliedWithinMap = stylingMapsSyncFn(context, renderer, element, bindingData, applyStylingFn, sanitizer, mode, prop, defaultValue);
                            valueApplied = valueApplied || valueAppliedWithinMap;
                        }
                        // case 3: apply the default value
                        // if the value has not yet been applied then a truthy value does not exist in the
                        // prop-based or map-based bindings code. If and when this happens, just apply the
                        // default value (even if the default value is `null`).
                        if (!valueApplied) {
                            applyStylingFn(renderer, element, prop, defaultValue);
                        }
                    }
                    i += 3 /* BindingsStartOffset */ + valuesCount;
                }
                // the map-based styling entries may have not applied all their
                // values. For this reason, one more call to the sync function
                // needs to be issued at the end.
                if (stylingMapsSyncFn) {
                    stylingMapsSyncFn(context, renderer, element, bindingData, applyStylingFn, sanitizer, mapsMode);
                }
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function normalizeBitMaskValue(value) {
                // if pass => apply all values (-1 implies that all bits are flipped to true)
                if (value === true)
                    return -1;
                // if pass => skip all values
                if (value === false)
                    return 0;
                // return the bit mask value as is
                return value;
            }
            /** @type {?} */
            var _activeStylingMapApplyFn = null;
            /**
             * @return {?}
             */
            function getStylingMapsSyncFn() {
                return _activeStylingMapApplyFn;
            }
            /**
             * @param {?} fn
             * @return {?}
             */
            function setStylingMapsSyncFn(fn) {
                _activeStylingMapApplyFn = fn;
            }
            /**
             * Assigns a style value to a style property for the given element.
             * @type {?}
             */
            var setStyle = ( /**
             * @param {?} renderer
             * @param {?} native
             * @param {?} prop
             * @param {?} value
             * @return {?}
             */function (renderer, native, prop, value) {
                // the reason why this may be `null` is either because
                // it's a container element or it's a part of a test
                // environment that doesn't have styling. In either
                // case it's safe not to apply styling to the element.
                /** @type {?} */
                var nativeStyle = native.style;
                if (value) {
                    // opacity, z-index and flexbox all have number values
                    // and these need to be converted into strings so that
                    // they can be assigned properly.
                    value = value.toString();
                    ngDevMode && ngDevMode.rendererSetStyle++;
                    renderer && isProceduralRenderer(renderer) ?
                        renderer.setStyle(native, prop, value, RendererStyleFlags3.DashCase) :
                        (nativeStyle && nativeStyle.setProperty(prop, value));
                }
                else {
                    ngDevMode && ngDevMode.rendererRemoveStyle++;
                    renderer && isProceduralRenderer(renderer) ?
                        renderer.removeStyle(native, prop, RendererStyleFlags3.DashCase) :
                        (nativeStyle && nativeStyle.removeProperty(prop));
                }
            });
            var ɵ0$4 = setStyle;
            /**
             * Adds/removes the provided className value to the provided element.
             * @type {?}
             */
            var setClass = ( /**
             * @param {?} renderer
             * @param {?} native
             * @param {?} className
             * @param {?} value
             * @return {?}
             */function (renderer, native, className, value) {
                if (className !== '') {
                    // the reason why this may be `null` is either because
                    // it's a container element or it's a part of a test
                    // environment that doesn't have styling. In either
                    // case it's safe not to apply styling to the element.
                    /** @type {?} */
                    var classList = native.classList;
                    if (value) {
                        ngDevMode && ngDevMode.rendererAddClass++;
                        renderer && isProceduralRenderer(renderer) ? renderer.addClass(native, className) :
                            (classList && classList.add(className));
                    }
                    else {
                        ngDevMode && ngDevMode.rendererRemoveClass++;
                        renderer && isProceduralRenderer(renderer) ? renderer.removeClass(native, className) :
                            (classList && classList.remove(className));
                    }
                }
            });
            var ɵ1$1 = setClass;
            /**
             * Iterates over all provided styling entries and renders them on the element.
             *
             * This function is used alongside a `StylingMapArray` entry. This entry is not
             * the same as the `TStylingContext` and is only really used when an element contains
             * initial styling values (e.g. `<div style="width:200px">`), but no style/class bindings
             * are present. If and when that happens then this function will be called to render all
             * initial styling values on an element.
             * @param {?} renderer
             * @param {?} element
             * @param {?} stylingValues
             * @param {?} isClassBased
             * @return {?}
             */
            function renderStylingMap(renderer, element, stylingValues, isClassBased) {
                /** @type {?} */
                var stylingMapArr = getStylingMapArray(stylingValues);
                if (stylingMapArr) {
                    for (var i = 1 /* ValuesStartPosition */; i < stylingMapArr.length; i += 2 /* TupleSize */) {
                        /** @type {?} */
                        var prop = getMapProp(stylingMapArr, i);
                        /** @type {?} */
                        var value = getMapValue(stylingMapArr, i);
                        if (isClassBased) {
                            setClass(renderer, element, prop, value, null);
                        }
                        else {
                            setStyle(renderer, element, prop, value, null);
                        }
                    }
                }
            }
            /**
             * Registers all initial styling entries into the provided context.
             *
             * This function will iterate over all entries in the provided `initialStyling` ar}ray and register
             * them as default (initial) values in the provided context. Initial styling values in a context are
             * the default values that are to be applied unless overwritten by a binding.
             *
             * The reason why this function exists and isn't a part of the context construction is because
             * host binding is evaluated at a later stage after the element is created. This means that
             * if a directive or component contains any initial styling code (i.e. `<div class="foo">`)
             * then that initial styling data can only be applied once the styling for that element
             * is first applied (at the end of the update phase). Once that happens then the context will
             * update itself with the complete initial styling for the element.
             * @param {?} context
             * @param {?} initialStyling
             * @return {?}
             */
            function updateInitialStylingOnContext(context, initialStyling) {
                // `-1` is used here because all initial styling data is not a spart
                // of a binding (since it's static)
                /** @type {?} */
                var INITIAL_STYLING_COUNT_ID = -1;
                for (var i = 1 /* ValuesStartPosition */; i < initialStyling.length; i += 2 /* TupleSize */) {
                    /** @type {?} */
                    var value = getMapValue(initialStyling, i);
                    if (value) {
                        /** @type {?} */
                        var prop = getMapProp(initialStyling, i);
                        registerBinding(context, INITIAL_STYLING_COUNT_ID, prop, value, false);
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * A special value which designates that a value has not changed.
             * @type {?}
             */
            var NO_CHANGE = ( /** @type {?} */({}));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @enum {number} */
            var I18nMutateOpCode = {
                /**
                 * Stores shift amount for bits 17-3 that contain reference index.
                 */
                SHIFT_REF: 3,
                /**
                 * Stores shift amount for bits 31-17 that contain parent index.
                 */
                SHIFT_PARENT: 17,
                /**
                 * Mask for OpCode
                 */
                MASK_OPCODE: 7,
                /**
                 * OpCode to select a node. (next OpCode will contain the operation.)
                 */
                Select: 0,
                /**
                 * OpCode to append the current node to `PARENT`.
                 */
                AppendChild: 1,
                /**
                 * OpCode to remove the `REF` node from `PARENT`.
                 */
                Remove: 3,
                /**
                 * OpCode to set the attribute of a node.
                 */
                Attr: 4,
                /**
                 * OpCode to simulate elementEnd()
                 */
                ElementEnd: 5,
                /**
                 * OpCode to read the remove OpCodes for the nested ICU
                 */
                RemoveNestedIcu: 6,
            };
            /**
             * Marks that the next string is for element.
             *
             * See `I18nMutateOpCodes` documentation.
             * @type {?}
             */
            var ELEMENT_MARKER = {
                marker: 'element'
            };
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * Marks that the next string is for comment.
             *
             * See `I18nMutateOpCodes` documentation.
             * @type {?}
             */
            var COMMENT_MARKER = {
                marker: 'comment'
            };
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * Array storing OpCode for dynamically creating `i18n` blocks.
             *
             * Example:
             * ```ts
             * <I18nCreateOpCode>[
             *   // For adding text nodes
             *   // ---------------------
             *   // Equivalent to:
             *   //   const node = lView[index++] = document.createTextNode('abc');
             *   //   lView[1].insertBefore(node, lView[2]);
             *   'abc', 1 << SHIFT_PARENT | 2 << SHIFT_REF | InsertBefore,
             *
             *   // Equivalent to:
             *   //   const node = lView[index++] = document.createTextNode('xyz');
             *   //   lView[1].appendChild(node);
             *   'xyz', 1 << SHIFT_PARENT | AppendChild,
             *
             *   // For adding element nodes
             *   // ---------------------
             *   // Equivalent to:
             *   //   const node = lView[index++] = document.createElement('div');
             *   //   lView[1].insertBefore(node, lView[2]);
             *   ELEMENT_MARKER, 'div', 1 << SHIFT_PARENT | 2 << SHIFT_REF | InsertBefore,
             *
             *   // Equivalent to:
             *   //   const node = lView[index++] = document.createElement('div');
             *   //   lView[1].appendChild(node);
             *   ELEMENT_MARKER, 'div', 1 << SHIFT_PARENT | AppendChild,
             *
             *   // For adding comment nodes
             *   // ---------------------
             *   // Equivalent to:
             *   //   const node = lView[index++] = document.createComment('');
             *   //   lView[1].insertBefore(node, lView[2]);
             *   COMMENT_MARKER, '', 1 << SHIFT_PARENT | 2 << SHIFT_REF | InsertBefore,
             *
             *   // Equivalent to:
             *   //   const node = lView[index++] = document.createComment('');
             *   //   lView[1].appendChild(node);
             *   COMMENT_MARKER, '', 1 << SHIFT_PARENT | AppendChild,
             *
             *   // For moving existing nodes to a different location
             *   // --------------------------------------------------
             *   // Equivalent to:
             *   //   const node = lView[1];
             *   //   lView[2].insertBefore(node, lView[3]);
             *   1 << SHIFT_REF | Select, 2 << SHIFT_PARENT | 3 << SHIFT_REF | InsertBefore,
             *
             *   // Equivalent to:
             *   //   const node = lView[1];
             *   //   lView[2].appendChild(node);
             *   1 << SHIFT_REF | Select, 2 << SHIFT_PARENT | AppendChild,
             *
             *   // For removing existing nodes
             *   // --------------------------------------------------
             *   //   const node = lView[1];
             *   //   removeChild(tView.data(1), node, lView);
             *   1 << SHIFT_REF | Remove,
             *
             *   // For writing attributes
             *   // --------------------------------------------------
             *   //   const node = lView[1];
             *   //   node.setAttribute('attr', 'value');
             *   1 << SHIFT_REF | Select, 'attr', 'value'
             *            // NOTE: Select followed by two string (vs select followed by OpCode)
             * ];
             * ```
             * NOTE:
             *   - `index` is initial location where the extra nodes should be stored in the EXPANDO section of
             * `LVIewData`.
             *
             * See: `applyI18nCreateOpCodes`;
             * @record
             */
            function I18nMutateOpCodes() { }
            /** @enum {number} */
            var I18nUpdateOpCode = {
                /**
                 * Stores shift amount for bits 17-2 that contain reference index.
                 */
                SHIFT_REF: 2,
                /**
                 * Mask for OpCode
                 */
                MASK_OPCODE: 3,
                /**
                 * OpCode to update a text node.
                 */
                Text: 0,
                /**
                 * OpCode to update a attribute of a node.
                 */
                Attr: 1,
                /**
                 * OpCode to switch the current ICU case.
                 */
                IcuSwitch: 2,
                /**
                 * OpCode to update the current ICU case.
                 */
                IcuUpdate: 3,
            };
            /**
             * Stores DOM operations which need to be applied to update DOM render tree due to changes in
             * expressions.
             *
             * The basic idea is that `i18nExp` OpCodes capture expression changes and update a change
             * mask bit. (Bit 1 for expression 1, bit 2 for expression 2 etc..., bit 32 for expression 32 and
             * higher.) The OpCodes then compare its own change mask against the expression change mask to
             * determine if the OpCodes should execute.
             *
             * These OpCodes can be used by both the i18n block as well as ICU sub-block.
             *
             * ## Example
             *
             * Assume
             * ```ts
             *   if (rf & RenderFlags.Update) {
             *    i18nExp(bind(ctx.exp1)); // If changed set mask bit 1
             *    i18nExp(bind(ctx.exp2)); // If changed set mask bit 2
             *    i18nExp(bind(ctx.exp3)); // If changed set mask bit 3
             *    i18nExp(bind(ctx.exp4)); // If changed set mask bit 4
             *    i18nApply(0);            // Apply all changes by executing the OpCodes.
             *  }
             * ```
             * We can assume that each call to `i18nExp` sets an internal `changeMask` bit depending on the
             * index of `i18nExp`.
             *
             * ### OpCodes
             * ```ts
             * <I18nUpdateOpCodes>[
             *   // The following OpCodes represent: `<div i18n-title="pre{{exp1}}in{{exp2}}post">`
             *   // If `changeMask & 0b11`
             *   //        has changed then execute update OpCodes.
             *   //        has NOT changed then skip `7` values and start processing next OpCodes.
             *   0b11, 7,
             *   // Concatenate `newValue = 'pre'+lView[bindIndex-4]+'in'+lView[bindIndex-3]+'post';`.
             *   'pre', -4, 'in', -3, 'post',
             *   // Update attribute: `elementAttribute(1, 'title', sanitizerFn(newValue));`
             *   1 << SHIFT_REF | Attr, 'title', sanitizerFn,
             *
             *   // The following OpCodes represent: `<div i18n>Hello {{exp3}}!">`
             *   // If `changeMask & 0b100`
             *   //        has changed then execute update OpCodes.
             *   //        has NOT changed then skip `4` values and start processing next OpCodes.
             *   0b100, 4,
             *   // Concatenate `newValue = 'Hello ' + lView[bindIndex -2] + '!';`.
             *   'Hello ', -2, '!',
             *   // Update text: `lView[1].textContent = newValue;`
             *   1 << SHIFT_REF | Text,
             *
             *   // The following OpCodes represent: `<div i18n>{exp4, plural, ... }">`
             *   // If `changeMask & 0b1000`
             *   //        has changed then execute update OpCodes.
             *   //        has NOT changed then skip `4` values and start processing next OpCodes.
             *   0b1000, 4,
             *   // Concatenate `newValue = lView[bindIndex -1];`.
             *   -1,
             *   // Switch ICU: `icuSwitchCase(lView[1], 0, newValue);`
             *   0 << SHIFT_ICU | 1 << SHIFT_REF | IcuSwitch,
             *
             *   // Note `changeMask & -1` is always true, so the IcuUpdate will always execute.
             *   -1, 1,
             *   // Update ICU: `icuUpdateCase(lView[1], 0);`
             *   0 << SHIFT_ICU | 1 << SHIFT_REF | IcuUpdate,
             *
             * ];
             * ```
             *
             * @record
             */
            function I18nUpdateOpCodes() { }
            /**
             * Store information for the i18n translation block.
             * @record
             */
            function TI18n() { }
            if (false) { }
            /** @enum {number} */
            var IcuType = {
                select: 0,
                plural: 1,
            };
            /**
             * @record
             */
            function TIcu() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$6 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             * @param {?} obj
             * @param {?} debug
             * @return {?}
             */
            function attachDebugObject(obj, debug) {
                Object.defineProperty(obj, 'debug', { value: debug, enumerable: false });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to apply styling values presently within any map-based bindings on an element.
             *
             * Angular supports map-based styling bindings which can be applied via the
             * `[style]` and `[class]` bindings which can be placed on any HTML element.
             * These bindings can work independently, together or alongside prop-based
             * styling bindings (e.g. `<div [style]="x" [style.width]="w">`).
             *
             * If a map-based styling binding is detected by the compiler, the following
             * AOT code is produced:
             *
             * ```typescript
             * styleMap(ctx.styles); // styles = {key:value}
             * classMap(ctx.classes); // classes = {key:value}|string
             * ```
             *
             * If and when either of the instructions above are evaluated, then the code
             * present in this file is included into the bundle. The mechanism used, to
             * activate support for map-based bindings at runtime is possible via the
             * `activeStylingMapFeature` function (which is also present in this file).
             *
             * # The Algorithm
             * Whenever a map-based binding updates (which is when the identity of the
             * map-value changes) then the map is iterated over and a `StylingMapArray` array
             * is produced. The `StylingMapArray` instance is stored in the binding location
             * where the `BINDING_INDEX` is situated when the `styleMap()` or `classMap()`
             * instruction were called. Once the binding changes, then the internal `bitMask`
             * value is marked as dirty.
             *
             * Styling values are applied once CD exits the element (which happens when
             * the `select(n)` instruction is called or the template function exits). When
             * this occurs, all prop-based bindings are applied. If a map-based binding is
             * present then a special flushing function (called a sync function) is made
             * available and it will be called each time a styling property is flushed.
             *
             * The flushing algorithm is designed to apply styling for a property (which is
             * a CSS property or a className value) one by one. If map-based bindings
             * are present, then the flushing algorithm will keep calling the maps styling
             * sync function each time a property is visited. This way, the flushing
             * behavior of map-based bindings will always be at the same property level
             * as the current prop-based property being iterated over (because everything
             * is alphabetically sorted).
             *
             * Let's imagine we have the following HTML template code:
             *
             * ```html
             * <div [style]="{width:'100px', height:'200px', 'z-index':'10'}"
             *      [style.width.px]="200">...</div>
             * ```
             *
             * When CD occurs, both the `[style]` and `[style.width]` bindings
             * are evaluated. Then when the styles are flushed on screen, the
             * following operations happen:
             *
             * 1. `[style.width]` is attempted to be written to the element.
             *
             * 2.  Once that happens, the algorithm instructs the map-based
             *     entries (`[style]` in this case) to "catch up" and apply
             *     all values up to the `width` value. When this happens the
             *     `height` value is applied to the element (since it is
             *     alphabetically situated before the `width` property).
             *
             * 3. Since there are no more prop-based entries anymore, the
             *    loop exits and then, just before the flushing ends, it
             *    instructs all map-based bindings to "finish up" applying
             *    their values.
             *
             * 4. The only remaining value within the map-based entries is
             *    the `z-index` value (`width` got skipped because it was
             *    successfully applied via the prop-based `[style.width]`
             *    binding). Since all map-based entries are told to "finish up",
             *    the `z-index` value is iterated over and it is then applied
             *    to the element.
             *
             * The most important thing to take note of here is that prop-based
             * bindings are evaluated in order alongside map-based bindings.
             * This allows all styling across an element to be applied in O(n)
             * time (a similar algorithm is that of the array merge algorithm
             * in merge sort).
             * @type {?}
             */
            var syncStylingMap = ( /**
             * @param {?} context
             * @param {?} renderer
             * @param {?} element
             * @param {?} data
             * @param {?} applyStylingFn
             * @param {?} sanitizer
             * @param {?} mode
             * @param {?=} targetProp
             * @param {?=} defaultValue
             * @return {?}
             */function (context, renderer, element, data, applyStylingFn, sanitizer, mode, targetProp, defaultValue) {
                /** @type {?} */
                var targetPropValueWasApplied = false;
                // once the map-based styling code is activate it is never deactivated. For this reason a
                // check to see if the current styling context has any map based bindings is required.
                /** @type {?} */
                var totalMaps = getValuesCount(context, 3 /* MapBindingsPosition */);
                if (totalMaps) {
                    /** @type {?} */
                    var runTheSyncAlgorithm = true;
                    /** @type {?} */
                    var loopUntilEnd = !targetProp;
                    // If the code is told to finish up (run until the end), but the mode
                    // hasn't been flagged to apply values (it only traverses values) then
                    // there is no point in iterating over the array because nothing will
                    // be applied to the element.
                    if (loopUntilEnd && (mode & ~1 /* ApplyAllValues */)) {
                        runTheSyncAlgorithm = false;
                        targetPropValueWasApplied = true;
                    }
                    if (runTheSyncAlgorithm) {
                        targetPropValueWasApplied = innerSyncStylingMap(context, renderer, element, data, applyStylingFn, sanitizer, mode, targetProp || null, 0, defaultValue || null);
                    }
                    if (loopUntilEnd) {
                        resetSyncCursors();
                    }
                }
                return targetPropValueWasApplied;
            });
            /**
             * Recursive function designed to apply map-based styling to an element one map at a time.
             *
             * This function is designed to be called from the `syncStylingMap` function and will
             * apply map-based styling data one map at a time to the provided `element`.
             *
             * This function is recursive and it will call itself if a follow-up map value is to be
             * processed. To learn more about how the algorithm works, see `syncStylingMap`.
             * @param {?} context
             * @param {?} renderer
             * @param {?} element
             * @param {?} data
             * @param {?} applyStylingFn
             * @param {?} sanitizer
             * @param {?} mode
             * @param {?} targetProp
             * @param {?} currentMapIndex
             * @param {?} defaultValue
             * @return {?}
             */
            function innerSyncStylingMap(context, renderer, element, data, applyStylingFn, sanitizer, mode, targetProp, currentMapIndex, defaultValue) {
                /** @type {?} */
                var targetPropValueWasApplied = false;
                /** @type {?} */
                var totalMaps = getValuesCount(context, 3 /* MapBindingsPosition */);
                if (currentMapIndex < totalMaps) {
                    /** @type {?} */
                    var bindingIndex = ( /** @type {?} */(getBindingValue(context, 3 /* MapBindingsPosition */, currentMapIndex)));
                    /** @type {?} */
                    var stylingMapArr = ( /** @type {?} */(data[bindingIndex]));
                    /** @type {?} */
                    var cursor = getCurrentSyncCursor(currentMapIndex);
                    while (cursor < stylingMapArr.length) {
                        /** @type {?} */
                        var prop = getMapProp(stylingMapArr, cursor);
                        /** @type {?} */
                        var iteratedTooFar = targetProp && prop > targetProp;
                        /** @type {?} */
                        var isTargetPropMatched = !iteratedTooFar && prop === targetProp;
                        /** @type {?} */
                        var value = getMapValue(stylingMapArr, cursor);
                        /** @type {?} */
                        var valueIsDefined = isStylingValueDefined(value);
                        // the recursive code is designed to keep applying until
                        // it reaches or goes past the target prop. If and when
                        // this happens then it will stop processing values, but
                        // all other map values must also catch up to the same
                        // point. This is why a recursive call is still issued
                        // even if the code has iterated too far.
                        /** @type {?} */
                        var innerMode = iteratedTooFar ? mode : resolveInnerMapMode(mode, valueIsDefined, isTargetPropMatched);
                        /** @type {?} */
                        var innerProp = iteratedTooFar ? targetProp : prop;
                        /** @type {?} */
                        var valueApplied = innerSyncStylingMap(context, renderer, element, data, applyStylingFn, sanitizer, innerMode, innerProp, currentMapIndex + 1, defaultValue);
                        if (iteratedTooFar) {
                            if (!targetPropValueWasApplied) {
                                targetPropValueWasApplied = valueApplied;
                            }
                            break;
                        }
                        if (!valueApplied && isValueAllowedToBeApplied(mode, isTargetPropMatched)) {
                            /** @type {?} */
                            var useDefault = isTargetPropMatched && !valueIsDefined;
                            /** @type {?} */
                            var valueToApply = useDefault ? defaultValue : value;
                            /** @type {?} */
                            var bindingIndexToApply = useDefault ? bindingIndex : null;
                            /** @type {?} */
                            var finalValue = sanitizer ?
                                sanitizer(prop, valueToApply, 3 /* ValidateAndSanitize */) :
                                valueToApply;
                            applyStylingFn(renderer, element, prop, finalValue, bindingIndexToApply);
                            valueApplied = true;
                        }
                        targetPropValueWasApplied = valueApplied && isTargetPropMatched;
                        cursor += 2 /* TupleSize */;
                    }
                    setCurrentSyncCursor(currentMapIndex, cursor);
                    // this is a fallback case in the event that the styling map is `null` for this
                    // binding but there are other map-based bindings that need to be evaluated
                    // afterwards. If the `prop` value is falsy then the intention is to cycle
                    // through all of the properties in the remaining maps as well. If the current
                    // styling map is too short then there are no values to iterate over. In either
                    // case the follow-up maps need to be iterated over.
                    if (stylingMapArr.length === 1 /* ValuesStartPosition */ || !targetProp) {
                        return innerSyncStylingMap(context, renderer, element, data, applyStylingFn, sanitizer, mode, targetProp, currentMapIndex + 1, defaultValue);
                    }
                }
                return targetPropValueWasApplied;
            }
            /**
             * Enables support for map-based styling bindings (e.g. `[style]` and `[class]` bindings).
             * @return {?}
             */
            function activateStylingMapFeature() {
                setStylingMapsSyncFn(syncStylingMap);
            }
            /**
             * Used to determine the mode for the inner recursive call.
             *
             * If an inner map is iterated on then this is done so for one
             * of two reasons:
             *
             * - value is being applied:
             *   if the value is being applied from this current styling
             *   map then there is no need to apply it in a deeper map.
             *
             * - value is being not applied:
             *   apply the value if it is found in a deeper map.
             *
             * When these reasons are encountered the flags will for the
             * inner map mode will be configured.
             * @param {?} currentMode
             * @param {?} valueIsDefined
             * @param {?} isExactMatch
             * @return {?}
             */
            function resolveInnerMapMode(currentMode, valueIsDefined, isExactMatch) {
                /** @type {?} */
                var innerMode = currentMode;
                if (!valueIsDefined && !(currentMode & 4 /* SkipTargetProp */) &&
                    (isExactMatch || (currentMode & 1 /* ApplyAllValues */))) {
                    // case 1: set the mode to apply the targeted prop value if it
                    // ends up being encountered in another map value
                    innerMode |= 2 /* ApplyTargetProp */;
                    innerMode &= ~4 /* SkipTargetProp */;
                }
                else {
                    // case 2: set the mode to skip the targeted prop value if it
                    // ends up being encountered in another map value
                    innerMode |= 4 /* SkipTargetProp */;
                    innerMode &= ~2 /* ApplyTargetProp */;
                }
                return innerMode;
            }
            /**
             * Decides whether or not a prop/value entry will be applied to an element.
             *
             * To determine whether or not a value is to be applied,
             * the following procedure is evaluated:
             *
             * First check to see the current `mode` status:
             *  1. If the mode value permits all props to be applied then allow.
             *    - But do not allow if the current prop is set to be skipped.
             *  2. Otherwise if the current prop is permitted then allow.
             * @param {?} mode
             * @param {?} isTargetPropMatched
             * @return {?}
             */
            function isValueAllowedToBeApplied(mode, isTargetPropMatched) {
                /** @type {?} */
                var doApplyValue = (mode & 1 /* ApplyAllValues */) > 0;
                if (!doApplyValue) {
                    if (mode & 2 /* ApplyTargetProp */) {
                        doApplyValue = isTargetPropMatched;
                    }
                }
                else if ((mode & 4 /* SkipTargetProp */) && isTargetPropMatched) {
                    doApplyValue = false;
                }
                return doApplyValue;
            }
            /**
             * Used to keep track of concurrent cursor values for multiple map-based styling bindings present on
             * an element.
             * @type {?}
             */
            var MAP_CURSORS = [];
            /**
             * Used to reset the state of each cursor value being used to iterate over map-based styling
             * bindings.
             * @return {?}
             */
            function resetSyncCursors() {
                for (var i = 0; i < MAP_CURSORS.length; i++) {
                    MAP_CURSORS[i] = 1 /* ValuesStartPosition */;
                }
            }
            /**
             * Returns an active cursor value at a given mapIndex location.
             * @param {?} mapIndex
             * @return {?}
             */
            function getCurrentSyncCursor(mapIndex) {
                if (mapIndex >= MAP_CURSORS.length) {
                    MAP_CURSORS.push(1 /* ValuesStartPosition */);
                }
                return MAP_CURSORS[mapIndex];
            }
            /**
             * Sets a cursor value at a given mapIndex location.
             * @param {?} mapIndex
             * @param {?} indexValue
             * @return {?}
             */
            function setCurrentSyncCursor(mapIndex, indexValue) {
                MAP_CURSORS[mapIndex] = indexValue;
            }
            /**
             * Used to convert a {key:value} map into a `StylingMapArray` array.
             *
             * This function will either generate a new `StylingMapArray` instance
             * or it will patch the provided `newValues` map value into an
             * existing `StylingMapArray` value (this only happens if `bindingValue`
             * is an instance of `StylingMapArray`).
             *
             * If a new key/value map is provided with an old `StylingMapArray`
             * value then all properties will be overwritten with their new
             * values or with `null`. This means that the array will never
             * shrink in size (but it will also not be created and thrown
             * away whenever the {key:value} map entries change).
             * @param {?} bindingValue
             * @param {?} newValues
             * @param {?=} normalizeProps
             * @return {?}
             */
            function normalizeIntoStylingMap(bindingValue, newValues, normalizeProps) {
                /** @type {?} */
                var stylingMapArr = Array.isArray(bindingValue) ? bindingValue : [null];
                stylingMapArr[0 /* RawValuePosition */] = newValues || null;
                // because the new values may not include all the properties
                // that the old ones had, all values are set to `null` before
                // the new values are applied. This way, when flushed, the
                // styling algorithm knows exactly what style/class values
                // to remove from the element (since they are `null`).
                for (var j = 1 /* ValuesStartPosition */; j < stylingMapArr.length; j += 2 /* TupleSize */) {
                    setMapValue(stylingMapArr, j, null);
                }
                /** @type {?} */
                var props = null;
                /** @type {?} */
                var map;
                /** @type {?} */
                var allValuesTrue = false;
                if (typeof newValues === 'string') { // [class] bindings allow string values
                    if (newValues.length) {
                        props = newValues.split(/\s+/);
                        allValuesTrue = true;
                    }
                }
                else {
                    props = newValues ? Object.keys(newValues) : null;
                    map = newValues;
                }
                if (props) {
                    for (var i = 0; i < props.length; i++) {
                        /** @type {?} */
                        var prop = ( /** @type {?} */(props[i]));
                        /** @type {?} */
                        var newProp = normalizeProps ? hyphenate(prop) : prop;
                        /** @type {?} */
                        var value = allValuesTrue ? true : ( /** @type {?} */(map))[prop];
                        addItemToStylingMap(stylingMapArr, newProp, value, true);
                    }
                }
                return stylingMapArr;
            }
            /**
             * Inserts the provided item into the provided styling array at the right spot.
             *
             * The `StylingMapArray` type is a sorted key/value array of entries. This means
             * that when a new entry is inserted it must be placed at the right spot in the
             * array. This function figures out exactly where to place it.
             * @param {?} stylingMapArr
             * @param {?} prop
             * @param {?} value
             * @param {?=} allowOverwrite
             * @return {?}
             */
            function addItemToStylingMap(stylingMapArr, prop, value, allowOverwrite) {
                for (var j = 1 /* ValuesStartPosition */; j < stylingMapArr.length; j += 2 /* TupleSize */) {
                    /** @type {?} */
                    var propAtIndex = getMapProp(stylingMapArr, j);
                    if (prop <= propAtIndex) {
                        /** @type {?} */
                        var applied = false;
                        if (propAtIndex === prop) {
                            /** @type {?} */
                            var valueAtIndex = stylingMapArr[j];
                            if (allowOverwrite || !isStylingValueDefined(valueAtIndex)) {
                                applied = true;
                                setMapValue(stylingMapArr, j, value);
                            }
                        }
                        else {
                            applied = true;
                            stylingMapArr.splice(j, 0, prop, value);
                        }
                        return applied;
                    }
                }
                stylingMapArr.push(prop, value);
                return true;
            }
            /**
             * Converts the provided styling map array into a string.
             *
             * Classes => `one two three`
             * Styles => `prop:value; prop2:value2`
             * @param {?} map
             * @param {?} isClassBased
             * @return {?}
             */
            function stylingMapToString(map, isClassBased) {
                /** @type {?} */
                var str = '';
                for (var i = 1 /* ValuesStartPosition */; i < map.length; i += 2 /* TupleSize */) {
                    /** @type {?} */
                    var prop = getMapProp(map, i);
                    /** @type {?} */
                    var value = ( /** @type {?} */(getMapValue(map, i)));
                    /** @type {?} */
                    var attrValue = concatString(prop, isClassBased ? '' : value, ':');
                    str = concatString(str, attrValue, isClassBased ? ' ' : '; ');
                }
                return str;
            }
            /**
             * Converts the provided styling map array into a key value map.
             * @param {?} map
             * @return {?}
             */
            function stylingMapToStringMap(map) {
                /** @type {?} */
                var stringMap = {};
                if (map) {
                    for (var i = 1 /* ValuesStartPosition */; i < map.length; i += 2 /* TupleSize */) {
                        /** @type {?} */
                        var prop = getMapProp(map, i);
                        /** @type {?} */
                        var value = ( /** @type {?} */(getMapValue(map, i)));
                        stringMap[prop] = value;
                    }
                }
                return stringMap;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A debug/testing-oriented summary of a styling entry.
             *
             * A value such as this is generated as an artifact of the `DebugStyling`
             * summary.
             * @record
             */
            function LStylingSummary() { }
            if (false) { }
            /**
             * A debug/testing-oriented summary of all styling entries for a `DebugNode` instance.
             * @record
             */
            function DebugStyling() { }
            if (false) { }
            /**
             * A debug/testing-oriented summary of all styling entries within a `TStylingContext`.
             * @record
             */
            function TStylingTupleSummary() { }
            if (false) { }
            /**
             * Instantiates and attaches an instance of `TStylingContextDebug` to the provided context.
             * @param {?} context
             * @return {?}
             */
            function attachStylingDebugObject(context) {
                /** @type {?} */
                var debug = new TStylingContextDebug(context);
                attachDebugObject(context, debug);
                return debug;
            }
            /**
             * A human-readable debug summary of the styling data present within `TStylingContext`.
             *
             * This class is designed to be used within testing code or when an
             * application has `ngDevMode` activated.
             */
            var TStylingContextDebug = /** @class */ (function () {
                /**
                 * @param {?} context
                 */
                function TStylingContextDebug(context) {
                    this.context = context;
                }
                Object.defineProperty(TStylingContextDebug.prototype, "isLocked", {
                    /**
                     * @return {?}
                     */
                    get: function () { return isContextLocked(this.context); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(TStylingContextDebug.prototype, "entries", {
                    /**
                     * Returns a detailed summary of each styling entry in the context.
                     *
                     * See `TStylingTupleSummary`.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var context = this.context;
                        /** @type {?} */
                        var entries = {};
                        /** @type {?} */
                        var start = 3 /* MapBindingsPosition */;
                        /** @type {?} */
                        var i = start;
                        while (i < context.length) {
                            /** @type {?} */
                            var valuesCount = getValuesCount(context, i);
                            // the context may contain placeholder values which are populated ahead of time,
                            // but contain no actual binding values. In this situation there is no point in
                            // classifying this as an "entry" since no real data is stored here yet.
                            if (valuesCount) {
                                /** @type {?} */
                                var prop = getProp(context, i);
                                /** @type {?} */
                                var guardMask = getGuardMask(context, i);
                                /** @type {?} */
                                var defaultValue = getDefaultValue(context, i);
                                /** @type {?} */
                                var sanitizationRequired = isSanitizationRequired(context, i);
                                /** @type {?} */
                                var bindingsStartPosition = i + 3 /* BindingsStartOffset */;
                                /** @type {?} */
                                var sources = [];
                                for (var j = 0; j < valuesCount; j++) {
                                    sources.push(( /** @type {?} */(context[bindingsStartPosition + j])));
                                }
                                entries[prop] = { prop: prop, guardMask: guardMask, sanitizationRequired: sanitizationRequired, valuesCount: valuesCount, defaultValue: defaultValue, sources: sources };
                            }
                            i += 3 /* BindingsStartOffset */ + valuesCount;
                        }
                        return entries;
                    },
                    enumerable: true,
                    configurable: true
                });
                return TStylingContextDebug;
            }());
            if (false) { }
            /**
             * A human-readable debug summary of the styling data present for a `DebugNode` instance.
             *
             * This class is designed to be used within testing code or when an
             * application has `ngDevMode` activated.
             */
            var NodeStylingDebug = /** @class */ (function () {
                /**
                 * @param {?} context
                 * @param {?} _data
                 * @param {?=} _isClassBased
                 */
                function NodeStylingDebug(context, _data, _isClassBased) {
                    this.context = context;
                    this._data = _data;
                    this._isClassBased = _isClassBased;
                    this._sanitizer = null;
                }
                /**
                 * Overrides the sanitizer used to process styles.
                 * @param {?} sanitizer
                 * @return {?}
                 */
                NodeStylingDebug.prototype.overrideSanitizer = function (sanitizer) { this._sanitizer = sanitizer; };
                Object.defineProperty(NodeStylingDebug.prototype, "summary", {
                    /**
                     * Returns a detailed summary of each styling entry in the context and
                     * what their runtime representation is.
                     *
                     * See `LStylingSummary`.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var entries = {};
                        this._mapValues(( /**
                         * @param {?} prop
                         * @param {?} value
                         * @param {?} bindingIndex
                         * @return {?}
                         */function (prop, value, bindingIndex) {
                            entries[prop] = { prop: prop, value: value, bindingIndex: bindingIndex };
                        }));
                        return entries;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NodeStylingDebug.prototype, "values", {
                    /**
                     * Returns a key/value map of all the styles/classes that were last applied to the element.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var entries = {};
                        this._mapValues(( /**
                         * @param {?} prop
                         * @param {?} value
                         * @return {?}
                         */function (prop, value) { entries[prop] = value; }));
                        return entries;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @param {?} fn
                 * @return {?}
                 */
                NodeStylingDebug.prototype._mapValues = function (fn) {
                    // there is no need to store/track an element instance. The
                    // element is only used when the styling algorithm attempts to
                    // style the value (and we mock out the stylingApplyFn anyway).
                    /** @type {?} */
                    var mockElement = ( /** @type {?} */({}));
                    /** @type {?} */
                    var hasMaps = getValuesCount(this.context, 3 /* MapBindingsPosition */) > 0;
                    if (hasMaps) {
                        activateStylingMapFeature();
                    }
                    /** @type {?} */
                    var mapFn = ( /**
                     * @param {?} renderer
                     * @param {?} element
                     * @param {?} prop
                     * @param {?} value
                     * @param {?=} bindingIndex
                     * @return {?}
                     */function (renderer, element, prop, value, bindingIndex) { fn(prop, value, bindingIndex || null); });
                    /** @type {?} */
                    var sanitizer = this._isClassBased ? null : (this._sanitizer || getCurrentStyleSanitizer());
                    applyStyling(this.context, null, mockElement, this._data, true, mapFn, sanitizer);
                };
                return NodeStylingDebug;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /*
             * This file contains conditionally attached classes which provide human readable (debug) level
             * information for `LView`, `LContainer` and other internal data structures. These data structures
             * are stored internally as array which makes it very difficult during debugging to reason about the
             * current state of the system.
             *
             * Patching the array with extra property does change the array's hidden class' but it does not
             * change the cost of access, therefore this patching should not have significant if any impact in
             * `ngDevMode` mode. (see: https://jsperf.com/array-vs-monkey-patch-array)
             *
             * So instead of seeing:
             * ```
             * Array(30) [Object, 659, null, …]
             * ```
             *
             * You get to see:
             * ```
             * LViewDebug {
             *   views: [...],
             *   flags: {attached: true, ...}
             *   nodes: [
             *     {html: '<div id="123">', ..., nodes: [
             *       {html: '<span>', ..., nodes: null}
             *     ]}
             *   ]
             * }
             * ```
             */
            /** @type {?} */
            var LViewArray = ngDevMode && createNamedArrayType('LView');
            /** @type {?} */
            var LVIEW_EMPTY;
            // can't initialize here or it will not be tree shaken, because `LView`
            // constructor could have side-effects.
            /**
             * This function clones a blueprint and creates LView.
             *
             * Simple slice will keep the same type, and we need it to be LView
             * @param {?} list
             * @return {?}
             */
            function cloneToLView(list) {
                if (LVIEW_EMPTY === undefined)
                    LVIEW_EMPTY = new ( /** @type {?} */(LViewArray))();
                return ( /** @type {?} */(LVIEW_EMPTY.concat(list)));
            }
            /**
             * This class is a debug version of Object literal so that we can have constructor name show up in
             * debug tools in ngDevMode.
             * @type {?}
             */
            var TViewConstructor = /** @class */ (function () {
                /**
                 * @param {?} id
                 * @param {?} blueprint
                 * @param {?} template
                 * @param {?} queries
                 * @param {?} viewQuery
                 * @param {?} node
                 * @param {?} data
                 * @param {?} bindingStartIndex
                 * @param {?} expandoStartIndex
                 * @param {?} expandoInstructions
                 * @param {?} firstTemplatePass
                 * @param {?} staticViewQueries
                 * @param {?} staticContentQueries
                 * @param {?} preOrderHooks
                 * @param {?} preOrderCheckHooks
                 * @param {?} contentHooks
                 * @param {?} contentCheckHooks
                 * @param {?} viewHooks
                 * @param {?} viewCheckHooks
                 * @param {?} destroyHooks
                 * @param {?} cleanup
                 * @param {?} contentQueries
                 * @param {?} components
                 * @param {?} directiveRegistry
                 * @param {?} pipeRegistry
                 * @param {?} firstChild
                 * @param {?} schemas
                 */
                function TView(id, //
                blueprint, //
                template, //
                queries, //
                viewQuery, //
                node, //
                data, //
                bindingStartIndex, //
                expandoStartIndex, //
                expandoInstructions, //
                firstTemplatePass, //
                staticViewQueries, //
                staticContentQueries, //
                preOrderHooks, //
                preOrderCheckHooks, //
                contentHooks, //
                contentCheckHooks, //
                viewHooks, //
                viewCheckHooks, //
                destroyHooks, //
                cleanup, //
                contentQueries, //
                components, //
                directiveRegistry, //
                pipeRegistry, //
                firstChild, //
                schemas) {
                    this.id = id;
                    this.blueprint = blueprint;
                    this.template = template;
                    this.queries = queries;
                    this.viewQuery = viewQuery;
                    this.node = node;
                    this.data = data;
                    this.bindingStartIndex = bindingStartIndex;
                    this.expandoStartIndex = expandoStartIndex;
                    this.expandoInstructions = expandoInstructions;
                    this.firstTemplatePass = firstTemplatePass;
                    this.staticViewQueries = staticViewQueries;
                    this.staticContentQueries = staticContentQueries;
                    this.preOrderHooks = preOrderHooks;
                    this.preOrderCheckHooks = preOrderCheckHooks;
                    this.contentHooks = contentHooks;
                    this.contentCheckHooks = contentCheckHooks;
                    this.viewHooks = viewHooks;
                    this.viewCheckHooks = viewCheckHooks;
                    this.destroyHooks = destroyHooks;
                    this.cleanup = cleanup;
                    this.contentQueries = contentQueries;
                    this.components = components;
                    this.directiveRegistry = directiveRegistry;
                    this.pipeRegistry = pipeRegistry;
                    this.firstChild = firstChild;
                    this.schemas = schemas;
                }
                return TView;
            }());
            /** @type {?} */
            var TNodeConstructor = /** @class */ (function () {
                /**
                 * @param {?} tView_
                 * @param {?} type
                 * @param {?} index
                 * @param {?} injectorIndex
                 * @param {?} directiveStart
                 * @param {?} directiveEnd
                 * @param {?} propertyMetadataStartIndex
                 * @param {?} propertyMetadataEndIndex
                 * @param {?} flags
                 * @param {?} providerIndexes
                 * @param {?} tagName
                 * @param {?} attrs
                 * @param {?} localNames
                 * @param {?} initialInputs
                 * @param {?} inputs
                 * @param {?} outputs
                 * @param {?} tViews
                 * @param {?} next
                 * @param {?} projectionNext
                 * @param {?} child
                 * @param {?} parent
                 * @param {?} projection
                 * @param {?} styles
                 * @param {?} classes
                 */
                function TNode(tView_, //
                type, //
                index, //
                injectorIndex, //
                directiveStart, //
                directiveEnd, //
                propertyMetadataStartIndex, //
                propertyMetadataEndIndex, //
                flags, //
                providerIndexes, //
                tagName, //
                attrs, //
                localNames, //
                initialInputs, //
                inputs, //
                outputs, //
                tViews, //
                next, //
                projectionNext, //
                child, //
                parent, //
                projection, //
                styles, //
                classes) {
                    this.tView_ = tView_;
                    this.type = type;
                    this.index = index;
                    this.injectorIndex = injectorIndex;
                    this.directiveStart = directiveStart;
                    this.directiveEnd = directiveEnd;
                    this.propertyMetadataStartIndex = propertyMetadataStartIndex;
                    this.propertyMetadataEndIndex = propertyMetadataEndIndex;
                    this.flags = flags;
                    this.providerIndexes = providerIndexes;
                    this.tagName = tagName;
                    this.attrs = attrs;
                    this.localNames = localNames;
                    this.initialInputs = initialInputs;
                    this.inputs = inputs;
                    this.outputs = outputs;
                    this.tViews = tViews;
                    this.next = next;
                    this.projectionNext = projectionNext;
                    this.child = child;
                    this.parent = parent;
                    this.projection = projection;
                    this.styles = styles;
                    this.classes = classes;
                }
                Object.defineProperty(TNode.prototype, "type_", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        switch (this.type) {
                            case 0 /* Container */:
                                return 'TNodeType.Container';
                            case 3 /* Element */:
                                return 'TNodeType.Element';
                            case 4 /* ElementContainer */:
                                return 'TNodeType.ElementContainer';
                            case 5 /* IcuContainer */:
                                return 'TNodeType.IcuContainer';
                            case 1 /* Projection */:
                                return 'TNodeType.Projection';
                            case 2 /* View */:
                                return 'TNodeType.View';
                            default:
                                return 'TNodeType.???';
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(TNode.prototype, "flags_", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var flags = [];
                        if (this.flags & 8 /* hasClassInput */)
                            flags.push('TNodeFlags.hasClassInput');
                        if (this.flags & 4 /* hasContentQuery */)
                            flags.push('TNodeFlags.hasContentQuery');
                        if (this.flags & 16 /* hasStyleInput */)
                            flags.push('TNodeFlags.hasStyleInput');
                        if (this.flags & 1 /* isComponent */)
                            flags.push('TNodeFlags.isComponent');
                        if (this.flags & 32 /* isDetached */)
                            flags.push('TNodeFlags.isDetached');
                        if (this.flags & 2 /* isProjected */)
                            flags.push('TNodeFlags.isProjected');
                        return flags.join('|');
                    },
                    enumerable: true,
                    configurable: true
                });
                return TNode;
            }());
            /** @type {?} */
            var TViewData = ngDevMode && createNamedArrayType('TViewData');
            /** @type {?} */
            var TVIEWDATA_EMPTY;
            // can't initialize here or it will not be tree shaken, because `LView`
            // constructor could have side-effects.
            /**
             * This function clones a blueprint and creates TData.
             *
             * Simple slice will keep the same type, and we need it to be TData
             * @param {?} list
             * @return {?}
             */
            function cloneToTViewData(list) {
                if (TVIEWDATA_EMPTY === undefined)
                    TVIEWDATA_EMPTY = new ( /** @type {?} */(TViewData))();
                return ( /** @type {?} */(TVIEWDATA_EMPTY.concat(list)));
            }
            /** @type {?} */
            var LViewBlueprint = ngDevMode && createNamedArrayType('LViewBlueprint');
            /** @type {?} */
            var MatchesArray = ngDevMode && createNamedArrayType('MatchesArray');
            /** @type {?} */
            var TViewComponents = ngDevMode && createNamedArrayType('TViewComponents');
            /** @type {?} */
            var TNodeLocalNames = ngDevMode && createNamedArrayType('TNodeLocalNames');
            /** @type {?} */
            var TNodeInitialInputs = ngDevMode && createNamedArrayType('TNodeInitialInputs');
            /** @type {?} */
            var TNodeInitialData = ngDevMode && createNamedArrayType('TNodeInitialData');
            /** @type {?} */
            var LCleanup = ngDevMode && createNamedArrayType('LCleanup');
            /** @type {?} */
            var TCleanup = ngDevMode && createNamedArrayType('TCleanup');
            /**
             * @param {?} lView
             * @return {?}
             */
            function attachLViewDebug(lView) {
                attachDebugObject(lView, new LViewDebug(lView));
            }
            /**
             * @param {?} lContainer
             * @return {?}
             */
            function attachLContainerDebug(lContainer) {
                attachDebugObject(lContainer, new LContainerDebug(lContainer));
            }
            /**
             * @param {?} obj
             * @return {?}
             */
            function toDebug(obj) {
                if (obj) {
                    /** @type {?} */
                    var debug = (( /** @type {?} */(obj))).debug;
                    assertDefined(debug, 'Object does not have a debug representation.');
                    return debug;
                }
                else {
                    return obj;
                }
            }
            /**
             * Use this method to unwrap a native element in `LView` and convert it into HTML for easier
             * reading.
             *
             * @param {?} value possibly wrapped native DOM node.
             * @param {?=} includeChildren If `true` then the serialized HTML form will include child elements (same
             * as `outerHTML`). If `false` then the serialized HTML form will only contain the element itself
             * (will not serialize child elements).
             * @return {?}
             */
            function toHtml(value, includeChildren) {
                if (includeChildren === void 0) { includeChildren = false; }
                /** @type {?} */
                var node = ( /** @type {?} */(unwrapRNode(value)));
                if (node) {
                    /** @type {?} */
                    var isTextNode = node.nodeType === Node.TEXT_NODE;
                    /** @type {?} */
                    var outerHTML = (isTextNode ? node.textContent : node.outerHTML) || '';
                    if (includeChildren || isTextNode) {
                        return outerHTML;
                    }
                    else {
                        /** @type {?} */
                        var innerHTML = node.innerHTML;
                        return outerHTML.split(innerHTML)[0] || null;
                    }
                }
                else {
                    return null;
                }
            }
            var LViewDebug = /** @class */ (function () {
                /**
                 * @param {?} _raw_lView
                 */
                function LViewDebug(_raw_lView) {
                    this._raw_lView = _raw_lView;
                }
                Object.defineProperty(LViewDebug.prototype, "flags", {
                    /**
                     * Flags associated with the `LView` unpacked into a more readable state.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var flags = this._raw_lView[FLAGS];
                        return {
                            __raw__flags__: flags,
                            initPhaseState: flags & 3 /* InitPhaseStateMask */,
                            creationMode: !!(flags & 4 /* CreationMode */),
                            firstViewPass: !!(flags & 8 /* FirstLViewPass */),
                            checkAlways: !!(flags & 16 /* CheckAlways */),
                            dirty: !!(flags & 64 /* Dirty */),
                            attached: !!(flags & 128 /* Attached */),
                            destroyed: !!(flags & 256 /* Destroyed */),
                            isRoot: !!(flags & 512 /* IsRoot */),
                            indexWithinInitPhase: flags >> 10 /* IndexWithinInitPhaseShift */,
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LViewDebug.prototype, "parent", {
                    /**
                     * @return {?}
                     */
                    get: function () { return toDebug(this._raw_lView[PARENT]); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LViewDebug.prototype, "host", {
                    /**
                     * @return {?}
                     */
                    get: function () { return toHtml(this._raw_lView[HOST], true); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LViewDebug.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._raw_lView[CONTEXT]; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LViewDebug.prototype, "nodes", {
                    /**
                     * The tree of nodes associated with the current `LView`. The nodes have been normalized into a
                     * tree structure with relevant details pulled out for readability.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var lView = this._raw_lView;
                        /** @type {?} */
                        var tNode = lView[TVIEW].firstChild;
                        return toDebugNodes(tNode, lView);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LViewDebug.prototype, "__other__", {
                    /**
                     * Additional information which is hidden behind a property. The extra level of indirection is
                     * done so that the debug view would not be cluttered with properties which are only rarely
                     * relevant to the developer.
                     * @return {?}
                     */
                    get: function () {
                        return {
                            tView: this._raw_lView[TVIEW],
                            cleanup: this._raw_lView[CLEANUP],
                            injector: this._raw_lView[INJECTOR$1],
                            rendererFactory: this._raw_lView[RENDERER_FACTORY],
                            renderer: this._raw_lView[RENDERER],
                            sanitizer: this._raw_lView[SANITIZER],
                            childHead: toDebug(this._raw_lView[CHILD_HEAD]),
                            next: toDebug(this._raw_lView[NEXT]),
                            childTail: toDebug(this._raw_lView[CHILD_TAIL]),
                            declarationView: toDebug(this._raw_lView[DECLARATION_VIEW]),
                            queries: null,
                            tHost: this._raw_lView[T_HOST],
                            bindingIndex: this._raw_lView[BINDING_INDEX],
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LViewDebug.prototype, "childViews", {
                    /**
                     * Normalized view of child views (and containers) attached at this location.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var childViews = [];
                        /** @type {?} */
                        var child = this.__other__.childHead;
                        while (child) {
                            childViews.push(child);
                            child = child.__other__.next;
                        }
                        return childViews;
                    },
                    enumerable: true,
                    configurable: true
                });
                return LViewDebug;
            }());
            if (false) { }
            /**
             * @record
             */
            function DebugNode() { }
            if (false) { }
            /**
             * Turns a flat list of nodes into a tree by walking the associated `TNode` tree.
             *
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function toDebugNodes(tNode, lView) {
                if (tNode) {
                    /** @type {?} */
                    var debugNodes = [];
                    /** @type {?} */
                    var tNodeCursor = tNode;
                    while (tNodeCursor) {
                        /** @type {?} */
                        var rawValue = lView[tNode.index];
                        /** @type {?} */
                        var native = unwrapRNode(rawValue);
                        /** @type {?} */
                        var componentLViewDebug = toDebug(readLViewValue(rawValue));
                        /** @type {?} */
                        var styles = isStylingContext(tNode.styles) ?
                            new NodeStylingDebug(( /** @type {?} */(( /** @type {?} */(tNode.styles)))), lView) :
                            null;
                        /** @type {?} */
                        var classes = isStylingContext(tNode.classes) ?
                            new NodeStylingDebug(( /** @type {?} */(( /** @type {?} */(tNode.classes)))), lView, true) :
                            null;
                        debugNodes.push({
                            html: toHtml(native),
                            native: ( /** @type {?} */(native)), styles: styles, classes: classes,
                            nodes: toDebugNodes(tNode.child, lView),
                            component: componentLViewDebug,
                        });
                        tNodeCursor = tNodeCursor.next;
                    }
                    return debugNodes;
                }
                else {
                    return null;
                }
            }
            var LContainerDebug = /** @class */ (function () {
                /**
                 * @param {?} _raw_lContainer
                 */
                function LContainerDebug(_raw_lContainer) {
                    this._raw_lContainer = _raw_lContainer;
                }
                Object.defineProperty(LContainerDebug.prototype, "activeIndex", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._raw_lContainer[ACTIVE_INDEX]; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LContainerDebug.prototype, "views", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._raw_lContainer.slice(CONTAINER_HEADER_OFFSET)
                            .map(( /** @type {?} */(toDebug)));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LContainerDebug.prototype, "parent", {
                    /**
                     * @return {?}
                     */
                    get: function () { return toDebug(this._raw_lContainer[PARENT]); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LContainerDebug.prototype, "movedViews", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._raw_lContainer[MOVED_VIEWS]; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LContainerDebug.prototype, "host", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._raw_lContainer[HOST]; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LContainerDebug.prototype, "native", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._raw_lContainer[NATIVE]; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LContainerDebug.prototype, "__other__", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return {
                            next: toDebug(this._raw_lContainer[NEXT]),
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                return LContainerDebug;
            }());
            if (false) { }
            /**
             * Return an `LView` value if found.
             *
             * @param {?} value `LView` if any
             * @return {?}
             */
            function readLViewValue(value) {
                while (Array.isArray(value)) {
                    // This check is not quite right, as it does not take into account `StylingContext`
                    // This is why it is in debug, not in util.ts
                    if (value.length >= HEADER_OFFSET - 1)
                        return ( /** @type {?} */(value));
                    value = value[HOST];
                }
                return null;
            }
            var I18NDebugItem = /** @class */ (function () {
                /**
                 * @param {?} __raw_opCode
                 * @param {?} _lView
                 * @param {?} nodeIndex
                 * @param {?} type
                 */
                function I18NDebugItem(__raw_opCode, _lView, nodeIndex, type) {
                    this.__raw_opCode = __raw_opCode;
                    this._lView = _lView;
                    this.nodeIndex = nodeIndex;
                    this.type = type;
                }
                Object.defineProperty(I18NDebugItem.prototype, "tNode", {
                    /**
                     * @return {?}
                     */
                    get: function () { return getTNode(this.nodeIndex, this._lView); },
                    enumerable: true,
                    configurable: true
                });
                return I18NDebugItem;
            }());
            if (false) { }
            /**
             * Turns a list of "Create" & "Update" OpCodes into a human-readable list of operations for
             * debugging purposes.
             * @param {?} mutateOpCodes mutation opCodes to read
             * @param {?} updateOpCodes update opCodes to read
             * @param {?} icus list of ICU expressions
             * @param {?} lView The view the opCodes are acting on
             * @return {?}
             */
            function attachI18nOpCodesDebug(mutateOpCodes, updateOpCodes, icus, lView) {
                attachDebugObject(mutateOpCodes, new I18nMutateOpCodesDebug(mutateOpCodes, lView));
                attachDebugObject(updateOpCodes, new I18nUpdateOpCodesDebug(updateOpCodes, icus, lView));
                if (icus) {
                    icus.forEach(( /**
                     * @param {?} icu
                     * @return {?}
                     */function (/**
                     * @param {?} icu
                     * @return {?}
                     */ icu) {
                        icu.create.forEach(( /**
                         * @param {?} icuCase
                         * @return {?}
                         */function (/**
                         * @param {?} icuCase
                         * @return {?}
                         */ icuCase) { attachDebugObject(icuCase, new I18nMutateOpCodesDebug(icuCase, lView)); }));
                        icu.update.forEach(( /**
                         * @param {?} icuCase
                         * @return {?}
                         */function (/**
                         * @param {?} icuCase
                         * @return {?}
                         */ icuCase) {
                            attachDebugObject(icuCase, new I18nUpdateOpCodesDebug(icuCase, icus, lView));
                        }));
                    }));
                }
            }
            var I18nMutateOpCodesDebug = /** @class */ (function () {
                /**
                 * @param {?} __raw_opCodes
                 * @param {?} __lView
                 */
                function I18nMutateOpCodesDebug(__raw_opCodes, __lView) {
                    this.__raw_opCodes = __raw_opCodes;
                    this.__lView = __lView;
                }
                Object.defineProperty(I18nMutateOpCodesDebug.prototype, "operations", {
                    /**
                     * A list of operation information about how the OpCodes will act on the view.
                     * @return {?}
                     */
                    get: function () {
                        var _c = this, __lView = _c.__lView, __raw_opCodes = _c.__raw_opCodes;
                        /** @type {?} */
                        var results = [];
                        for (var i = 0; i < __raw_opCodes.length; i++) {
                            /** @type {?} */
                            var opCode = __raw_opCodes[i];
                            /** @type {?} */
                            var result = void 0;
                            if (typeof opCode === 'string') {
                                result = {
                                    __raw_opCode: opCode,
                                    type: 'Create Text Node',
                                    nodeIndex: __raw_opCodes[++i],
                                    text: opCode,
                                };
                            }
                            if (typeof opCode === 'number') {
                                switch (opCode & 7 /* MASK_OPCODE */) {
                                    case 1 /* AppendChild */:
                                        /** @type {?} */
                                        var destinationNodeIndex = opCode >>> 17 /* SHIFT_PARENT */;
                                        result = new I18NDebugItem(opCode, __lView, destinationNodeIndex, 'AppendChild');
                                        break;
                                    case 0 /* Select */:
                                        /** @type {?} */
                                        var nodeIndex = opCode >>> 3 /* SHIFT_REF */;
                                        result = new I18NDebugItem(opCode, __lView, nodeIndex, 'Select');
                                        break;
                                    case 5 /* ElementEnd */:
                                        /** @type {?} */
                                        var elementIndex = opCode >>> 3 /* SHIFT_REF */;
                                        result = new I18NDebugItem(opCode, __lView, elementIndex, 'ElementEnd');
                                        break;
                                    case 4 /* Attr */:
                                        elementIndex = opCode >>> 3 /* SHIFT_REF */;
                                        result = new I18NDebugItem(opCode, __lView, elementIndex, 'Attr');
                                        result['attrName'] = __raw_opCodes[++i];
                                        result['attrValue'] = __raw_opCodes[++i];
                                        break;
                                }
                            }
                            if (!result) {
                                switch (opCode) {
                                    case COMMENT_MARKER:
                                        result = {
                                            __raw_opCode: opCode,
                                            type: 'COMMENT_MARKER',
                                            commentValue: __raw_opCodes[++i],
                                            nodeIndex: __raw_opCodes[++i],
                                        };
                                        break;
                                    case ELEMENT_MARKER:
                                        result = {
                                            __raw_opCode: opCode,
                                            type: 'ELEMENT_MARKER',
                                        };
                                        break;
                                }
                            }
                            if (!result) {
                                result = {
                                    __raw_opCode: opCode,
                                    type: 'Unknown Op Code',
                                    code: opCode,
                                };
                            }
                            results.push(result);
                        }
                        return results;
                    },
                    enumerable: true,
                    configurable: true
                });
                return I18nMutateOpCodesDebug;
            }());
            if (false) { }
            var I18nUpdateOpCodesDebug = /** @class */ (function () {
                /**
                 * @param {?} __raw_opCodes
                 * @param {?} icus
                 * @param {?} __lView
                 */
                function I18nUpdateOpCodesDebug(__raw_opCodes, icus, __lView) {
                    this.__raw_opCodes = __raw_opCodes;
                    this.icus = icus;
                    this.__lView = __lView;
                }
                Object.defineProperty(I18nUpdateOpCodesDebug.prototype, "operations", {
                    /**
                     * A list of operation information about how the OpCodes will act on the view.
                     * @return {?}
                     */
                    get: function () {
                        var _c = this, __lView = _c.__lView, __raw_opCodes = _c.__raw_opCodes, icus = _c.icus;
                        /** @type {?} */
                        var results = [];
                        for (var i = 0; i < __raw_opCodes.length; i++) {
                            // bit code to check if we should apply the next update
                            /** @type {?} */
                            var checkBit = ( /** @type {?} */(__raw_opCodes[i]));
                            // Number of opCodes to skip until next set of update codes
                            /** @type {?} */
                            var skipCodes = ( /** @type {?} */(__raw_opCodes[++i]));
                            /** @type {?} */
                            var value = '';
                            for (var j = i + 1; j <= (i + skipCodes); j++) {
                                /** @type {?} */
                                var opCode = __raw_opCodes[j];
                                if (typeof opCode === 'string') {
                                    value += opCode;
                                }
                                else if (typeof opCode == 'number') {
                                    if (opCode < 0) {
                                        // It's a binding index whose value is negative
                                        // We cannot know the value of the binding so we only show the index
                                        value += "\uFFFD" + (-opCode - 1) + "\uFFFD";
                                    }
                                    else {
                                        /** @type {?} */
                                        var nodeIndex = opCode >>> 2 /* SHIFT_REF */;
                                        /** @type {?} */
                                        var tIcuIndex = void 0;
                                        /** @type {?} */
                                        var tIcu = void 0;
                                        switch (opCode & 3 /* MASK_OPCODE */) {
                                            case 1 /* Attr */:
                                                /** @type {?} */
                                                var attrName = ( /** @type {?} */(__raw_opCodes[++j]));
                                                /** @type {?} */
                                                var sanitizeFn = __raw_opCodes[++j];
                                                results.push({
                                                    __raw_opCode: opCode,
                                                    checkBit: checkBit,
                                                    type: 'Attr',
                                                    attrValue: value, attrName: attrName, sanitizeFn: sanitizeFn,
                                                });
                                                break;
                                            case 0 /* Text */:
                                                results.push({
                                                    __raw_opCode: opCode,
                                                    checkBit: checkBit,
                                                    type: 'Text', nodeIndex: nodeIndex,
                                                    text: value,
                                                });
                                                break;
                                            case 2 /* IcuSwitch */:
                                                tIcuIndex = ( /** @type {?} */(__raw_opCodes[++j]));
                                                tIcu = ( /** @type {?} */(icus))[tIcuIndex];
                                                /** @type {?} */
                                                var result = new I18NDebugItem(opCode, __lView, nodeIndex, 'IcuSwitch');
                                                result['tIcuIndex'] = tIcuIndex;
                                                result['checkBit'] = checkBit;
                                                result['mainBinding'] = value;
                                                result['tIcu'] = tIcu;
                                                results.push(result);
                                                break;
                                            case 3 /* IcuUpdate */:
                                                tIcuIndex = ( /** @type {?} */(__raw_opCodes[++j]));
                                                tIcu = ( /** @type {?} */(icus))[tIcuIndex];
                                                result = new I18NDebugItem(opCode, __lView, nodeIndex, 'IcuUpdate');
                                                result['tIcuIndex'] = tIcuIndex;
                                                result['checkBit'] = checkBit;
                                                result['tIcu'] = tIcu;
                                                results.push(result);
                                                break;
                                        }
                                    }
                                }
                            }
                            i += skipCodes;
                        }
                        return results;
                    },
                    enumerable: true,
                    configurable: true
                });
                return I18nUpdateOpCodesDebug;
            }());
            if (false) { }
            /**
             * @record
             */
            function I18nOpCodesDebug() { }
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Selects an element for later binding instructions.
             *
             * Used in conjunction with instructions like {\@link property} to act on elements with specified
             * indices, for example those created with {\@link element} or {\@link elementStart}.
             *
             * ```ts
             * (rf: RenderFlags, ctx: any) => {
             *   if (rf & 1) {
             *     element(0, 'div');
             *   }
             *   if (rf & 2) {
             *     select(0); // Select the <div/> created above.
             *     property('title', 'test');
             *   }
             *  }
             * ```
             * \@codeGenApi
             * @param {?} index the index of the item to act on with the following instructions
             *
             * @return {?}
             */
            function ɵɵselect(index) {
                ngDevMode && assertGreaterThan(index, -1, 'Invalid index');
                ngDevMode &&
                    assertLessThan(index, getLView().length - HEADER_OFFSET, 'Should be within range for the view data');
                /** @type {?} */
                var lView = getLView();
                selectInternal(lView, index);
            }
            /**
             * @param {?} lView
             * @param {?} index
             * @return {?}
             */
            function selectInternal(lView, index) {
                // Flush the initial hooks for elements in the view that have been added up to this point.
                executePreOrderHooks(lView, lView[TVIEW], getCheckNoChangesMode(), index);
                // We must set the selected index *after* running the hooks, because hooks may have side-effects
                // that cause other template functions to run, thus updating the selected index, which is global
                // state. If we run `setSelectedIndex` *before* we run the hooks, in some cases the selected index
                // will be altered by the time we leave the `ɵɵselect` instruction.
                setSelectedIndex(index);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$5 = /**
             * @return {?}
             */ function () { return Promise.resolve(null); };
            /**
             * A permanent marker promise which signifies that the current CD tree is
             * clean.
             * @type {?}
             */
            var _CLEAN_PROMISE = ((ɵ0$5))();
            /** @enum {number} */
            var BindingDirection = {
                Input: 0,
                Output: 1,
            };
            /**
             * Refreshes the view, executing the following steps in that order:
             * triggers init hooks, refreshes dynamic embedded views, triggers content hooks, sets host
             * bindings, refreshes child components.
             * Note: view hooks are triggered later when leaving the view.
             * @param {?} lView
             * @return {?}
             */
            function refreshDescendantViews(lView) {
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var creationMode = isCreationMode(lView);
                // This needs to be set before children are processed to support recursive components
                tView.firstTemplatePass = false;
                // Resetting the bindingIndex of the current LView as the next steps may trigger change detection.
                lView[BINDING_INDEX] = tView.bindingStartIndex;
                // If this is a creation pass, we should not call lifecycle hooks or evaluate bindings.
                // This will be done in the update pass.
                if (!creationMode) {
                    /** @type {?} */
                    var checkNoChangesMode_1 = getCheckNoChangesMode();
                    executePreOrderHooks(lView, tView, checkNoChangesMode_1, undefined);
                    refreshDynamicEmbeddedViews(lView);
                    // Content query results must be refreshed before content hooks are called.
                    refreshContentQueries(tView, lView);
                    resetPreOrderHookFlags(lView);
                    executeHooks(lView, tView.contentHooks, tView.contentCheckHooks, checkNoChangesMode_1, 1 /* AfterContentInitHooksToBeRun */, undefined);
                    setHostBindings(tView, lView);
                }
                // We resolve content queries specifically marked as `static` in creation mode. Dynamic
                // content queries are resolved during change detection (i.e. update mode), after embedded
                // views are refreshed (see block above).
                if (creationMode && tView.staticContentQueries) {
                    refreshContentQueries(tView, lView);
                }
                // We must materialize query results before child components are processed
                // in case a child component has projected a container. The LContainer needs
                // to exist so the embedded views are properly attached by the container.
                if (!creationMode || tView.staticViewQueries) {
                    executeViewQueryFn(2 /* Update */, tView, lView[CONTEXT]);
                }
                refreshChildComponents(lView, tView.components);
            }
            /**
             * Sets the host bindings for the current view.
             * @param {?} tView
             * @param {?} viewData
             * @return {?}
             */
            function setHostBindings(tView, viewData) {
                /** @type {?} */
                var selectedIndex = getSelectedIndex();
                try {
                    if (tView.expandoInstructions) {
                        /** @type {?} */
                        var bindingRootIndex_1 = viewData[BINDING_INDEX] = tView.expandoStartIndex;
                        setBindingRoot(bindingRootIndex_1);
                        /** @type {?} */
                        var currentDirectiveIndex = -1;
                        /** @type {?} */
                        var currentElementIndex = -1;
                        for (var i = 0; i < tView.expandoInstructions.length; i++) {
                            /** @type {?} */
                            var instruction = tView.expandoInstructions[i];
                            if (typeof instruction === 'number') {
                                if (instruction <= 0) {
                                    // Negative numbers mean that we are starting new EXPANDO block and need to update
                                    // the current element and directive index.
                                    currentElementIndex = -instruction;
                                    setActiveHostElement(currentElementIndex);
                                    // Injector block and providers are taken into account.
                                    /** @type {?} */
                                    var providerCount = (( /** @type {?} */(tView.expandoInstructions[++i])));
                                    bindingRootIndex_1 += INJECTOR_BLOOM_PARENT_SIZE + providerCount;
                                    currentDirectiveIndex = bindingRootIndex_1;
                                }
                                else {
                                    // This is either the injector size (so the binding root can skip over directives
                                    // and get to the first set of host bindings on this node) or the host var count
                                    // (to get to the next set of host bindings on this node).
                                    bindingRootIndex_1 += instruction;
                                }
                                setBindingRoot(bindingRootIndex_1);
                            }
                            else {
                                // If it's not a number, it's a host binding function that needs to be executed.
                                if (instruction !== null) {
                                    viewData[BINDING_INDEX] = bindingRootIndex_1;
                                    /** @type {?} */
                                    var hostCtx = unwrapRNode(viewData[currentDirectiveIndex]);
                                    instruction(2 /* Update */, hostCtx, currentElementIndex);
                                    // Each directive gets a uniqueId value that is the same for both
                                    // create and update calls when the hostBindings function is called. The
                                    // directive uniqueId is not set anywhere--it is just incremented between
                                    // each hostBindings call and is useful for helping instruction code
                                    // uniquely determine which directive is currently active when executed.
                                    incrementActiveDirectiveId();
                                }
                                currentDirectiveIndex++;
                            }
                        }
                    }
                }
                finally {
                    setActiveHostElement(selectedIndex);
                }
            }
            /**
             * Refreshes all content queries declared by directives in a given view
             * @param {?} tView
             * @param {?} lView
             * @return {?}
             */
            function refreshContentQueries(tView, lView) {
                /** @type {?} */
                var contentQueries = tView.contentQueries;
                if (contentQueries !== null) {
                    for (var i = 0; i < contentQueries.length; i += 2) {
                        /** @type {?} */
                        var queryStartIdx = contentQueries[i];
                        /** @type {?} */
                        var directiveDefIdx = contentQueries[i + 1];
                        if (directiveDefIdx !== -1) {
                            /** @type {?} */
                            var directiveDef_2 = ( /** @type {?} */(tView.data[directiveDefIdx]));
                            ngDevMode &&
                                assertDefined(directiveDef_2.contentQueries, 'contentQueries function should be defined');
                            setCurrentQueryIndex(queryStartIdx);
                            ( /** @type {?} */(directiveDef_2.contentQueries))(2 /* Update */, lView[directiveDefIdx], directiveDefIdx);
                        }
                    }
                }
            }
            /**
             * Refreshes child components in the current view.
             * @param {?} hostLView
             * @param {?} components
             * @return {?}
             */
            function refreshChildComponents(hostLView, components) {
                if (components != null) {
                    for (var i = 0; i < components.length; i++) {
                        componentRefresh(hostLView, components[i]);
                    }
                }
            }
            /**
             * Creates a native element from a tag name, using a renderer.
             * @param {?} name the tag name
             * @param {?=} overriddenRenderer Optional A renderer to override the default one
             * @return {?} the element created
             */
            function elementCreate(name, overriddenRenderer) {
                /** @type {?} */
                var native;
                /** @type {?} */
                var rendererToUse = overriddenRenderer || getLView()[RENDERER];
                /** @type {?} */
                var namespace = getNamespace();
                if (isProceduralRenderer(rendererToUse)) {
                    native = rendererToUse.createElement(name, namespace);
                }
                else {
                    if (namespace === null) {
                        native = rendererToUse.createElement(name);
                    }
                    else {
                        native = rendererToUse.createElementNS(namespace, name);
                    }
                }
                return native;
            }
            /**
             * @template T
             * @param {?} parentLView
             * @param {?} tView
             * @param {?} context
             * @param {?} flags
             * @param {?} host
             * @param {?} tHostNode
             * @param {?=} rendererFactory
             * @param {?=} renderer
             * @param {?=} sanitizer
             * @param {?=} injector
             * @return {?}
             */
            function createLView(parentLView, tView, context, flags, host, tHostNode, rendererFactory, renderer, sanitizer, injector) {
                /** @type {?} */
                var lView = ngDevMode ? cloneToLView(tView.blueprint) : ( /** @type {?} */(tView.blueprint.slice()));
                lView[HOST] = host;
                lView[FLAGS] = flags | 4 /* CreationMode */ | 128 /* Attached */ | 8 /* FirstLViewPass */;
                resetPreOrderHookFlags(lView);
                lView[PARENT] = lView[DECLARATION_VIEW] = parentLView;
                lView[CONTEXT] = context;
                lView[RENDERER_FACTORY] = ( /** @type {?} */((rendererFactory || parentLView && parentLView[RENDERER_FACTORY])));
                ngDevMode && assertDefined(lView[RENDERER_FACTORY], 'RendererFactory is required');
                lView[RENDERER] = ( /** @type {?} */((renderer || parentLView && parentLView[RENDERER])));
                ngDevMode && assertDefined(lView[RENDERER], 'Renderer is required');
                lView[SANITIZER] = sanitizer || parentLView && parentLView[SANITIZER] || ( /** @type {?} */(null));
                lView[( /** @type {?} */(INJECTOR$1))] = injector || parentLView && parentLView[INJECTOR$1] || null;
                lView[T_HOST] = tHostNode;
                ngDevMode && attachLViewDebug(lView);
                return lView;
            }
            /**
             * @param {?} tView
             * @param {?} tHostNode
             * @param {?} index
             * @param {?} type
             * @param {?} name
             * @param {?} attrs
             * @return {?}
             */
            function getOrCreateTNode(tView, tHostNode, index, type, name, attrs) {
                // Keep this function short, so that the VM will inline it.
                /** @type {?} */
                var adjustedIndex = index + HEADER_OFFSET;
                /** @type {?} */
                var tNode = ( /** @type {?} */(tView.data[adjustedIndex])) ||
                    createTNodeAtIndex(tView, tHostNode, adjustedIndex, type, name, attrs, index);
                setPreviousOrParentTNode(tNode, true);
                return ( /** @type {?} */(tNode));
            }
            /**
             * @param {?} tView
             * @param {?} tHostNode
             * @param {?} adjustedIndex
             * @param {?} type
             * @param {?} name
             * @param {?} attrs
             * @param {?} index
             * @return {?}
             */
            function createTNodeAtIndex(tView, tHostNode, adjustedIndex, type, name, attrs, index) {
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                /** @type {?} */
                var isParent = getIsParent();
                /** @type {?} */
                var parent = isParent ? previousOrParentTNode : previousOrParentTNode && previousOrParentTNode.parent;
                // Parents cannot cross component boundaries because components will be used in multiple places,
                // so it's only set if the view is the same.
                /** @type {?} */
                var parentInSameView = parent && parent !== tHostNode;
                /** @type {?} */
                var tParentNode = parentInSameView ? ( /** @type {?} */(parent)) : null;
                /** @type {?} */
                var tNode = tView.data[adjustedIndex] =
                    createTNode(tView, tParentNode, type, adjustedIndex, name, attrs);
                // The first node is not always the one at index 0, in case of i18n, index 0 can be the
                // instruction `i18nStart` and the first node has the index 1 or more
                if (index === 0 || !tView.firstChild) {
                    tView.firstChild = tNode;
                }
                // Now link ourselves into the tree.
                if (previousOrParentTNode) {
                    if (isParent && previousOrParentTNode.child == null &&
                        (tNode.parent !== null || previousOrParentTNode.type === 2 /* View */)) {
                        // We are in the same view, which means we are adding content node to the parent view.
                        previousOrParentTNode.child = tNode;
                    }
                    else if (!isParent) {
                        previousOrParentTNode.next = tNode;
                    }
                }
                return tNode;
            }
            /**
             * @param {?} tView
             * @param {?} tParentNode
             * @param {?} index
             * @param {?} lView
             * @return {?}
             */
            function assignTViewNodeToLView(tView, tParentNode, index, lView) {
                // View nodes are not stored in data because they can be added / removed at runtime (which
                // would cause indices to change). Their TNodes are instead stored in tView.node.
                /** @type {?} */
                var tNode = tView.node;
                if (tNode == null) {
                    ngDevMode && tParentNode &&
                        assertNodeOfPossibleTypes(tParentNode, 3 /* Element */, 0 /* Container */);
                    tView.node = tNode = ( /** @type {?} */(createTNode(tView, ( /** @type {?} */(tParentNode)), //
                    2 /* View */, index, null, null)));
                }
                return lView[T_HOST] = ( /** @type {?} */(tNode));
            }
            /**
             * When elements are created dynamically after a view blueprint is created (e.g. through
             * i18nApply() or ComponentFactory.create), we need to adjust the blueprint for future
             * template passes.
             *
             * @param {?} view The LView containing the blueprint to adjust
             * @param {?} numSlotsToAlloc The number of slots to alloc in the LView, should be >0
             * @return {?}
             */
            function allocExpando(view, numSlotsToAlloc) {
                ngDevMode && assertGreaterThan(numSlotsToAlloc, 0, 'The number of slots to alloc should be greater than 0');
                if (numSlotsToAlloc > 0) {
                    /** @type {?} */
                    var tView = view[TVIEW];
                    if (tView.firstTemplatePass) {
                        for (var i = 0; i < numSlotsToAlloc; i++) {
                            tView.blueprint.push(null);
                            tView.data.push(null);
                            view.push(null);
                        }
                        // We should only increment the expando start index if there aren't already directives
                        // and injectors saved in the "expando" section
                        if (!tView.expandoInstructions) {
                            tView.expandoStartIndex += numSlotsToAlloc;
                        }
                        else {
                            // Since we're adding the dynamic nodes into the expando section, we need to let the host
                            // bindings know that they should skip x slots
                            tView.expandoInstructions.push(numSlotsToAlloc);
                        }
                    }
                }
            }
            //////////////////////////
            //// Render
            //////////////////////////
            /**
             * Used for creating the LViewNode of a dynamic embedded view,
             * either through ViewContainerRef.createEmbeddedView() or TemplateRef.createEmbeddedView().
             * Such lViewNode will then be renderer with renderEmbeddedTemplate() (see below).
             * @template T
             * @param {?} tView
             * @param {?} context
             * @param {?} declarationView
             * @param {?} injectorIndex
             * @return {?}
             */
            function createEmbeddedViewAndNode(tView, context, declarationView, injectorIndex) {
                /** @type {?} */
                var _isParent = getIsParent();
                /** @type {?} */
                var _previousOrParentTNode = getPreviousOrParentTNode();
                setPreviousOrParentTNode(( /** @type {?} */(null)), true);
                /** @type {?} */
                var lView = createLView(declarationView, tView, context, 16 /* CheckAlways */, null, null);
                lView[DECLARATION_VIEW] = declarationView;
                assignTViewNodeToLView(tView, null, -1, lView);
                if (tView.firstTemplatePass) {
                    ( /** @type {?} */(tView.node)).injectorIndex = injectorIndex;
                }
                setPreviousOrParentTNode(_previousOrParentTNode, _isParent);
                return lView;
            }
            /**
             * Used for rendering embedded views (e.g. dynamically created views)
             *
             * Dynamically created views must store/retrieve their TViews differently from component views
             * because their template functions are nested in the template functions of their hosts, creating
             * closures. If their host template happens to be an embedded template in a loop (e.g. ngFor
             * inside
             * an ngFor), the nesting would mean we'd have multiple instances of the template function, so we
             * can't store TViews in the template function itself (as we do for comps). Instead, we store the
             * TView for dynamically created views on their host TNode, which only has one instance.
             * @template T
             * @param {?} viewToRender
             * @param {?} tView
             * @param {?} context
             * @return {?}
             */
            function renderEmbeddedTemplate(viewToRender, tView, context) {
                /** @type {?} */
                var _isParent = getIsParent();
                /** @type {?} */
                var _previousOrParentTNode = getPreviousOrParentTNode();
                /** @type {?} */
                var oldView;
                if (viewToRender[FLAGS] & 512 /* IsRoot */) {
                    // This is a root view inside the view tree
                    tickRootContext(getRootContext(viewToRender));
                }
                else {
                    // Will become true if the `try` block executes with no errors.
                    /** @type {?} */
                    var safeToRunHooks = false;
                    try {
                        setPreviousOrParentTNode(( /** @type {?} */(null)), true);
                        oldView = enterView(viewToRender, viewToRender[T_HOST]);
                        resetPreOrderHookFlags(viewToRender);
                        executeTemplate(viewToRender, ( /** @type {?} */(tView.template)), getRenderFlags(viewToRender), context);
                        // This must be set to false immediately after the first creation run because in an
                        // ngFor loop, all the views will be created together before update mode runs and turns
                        // off firstTemplatePass. If we don't set it here, instances will perform directive
                        // matching, etc again and again.
                        tView.firstTemplatePass = false;
                        refreshDescendantViews(viewToRender);
                        safeToRunHooks = true;
                    }
                    finally {
                        leaveView(( /** @type {?} */(oldView)), safeToRunHooks);
                        setPreviousOrParentTNode(_previousOrParentTNode, _isParent);
                    }
                }
            }
            /**
             * @template T
             * @param {?} hostView
             * @param {?} context
             * @param {?=} templateFn
             * @return {?}
             */
            function renderComponentOrTemplate(hostView, context, templateFn) {
                /** @type {?} */
                var rendererFactory = hostView[RENDERER_FACTORY];
                /** @type {?} */
                var oldView = enterView(hostView, hostView[T_HOST]);
                /** @type {?} */
                var normalExecutionPath = !getCheckNoChangesMode();
                /** @type {?} */
                var creationModeIsActive = isCreationMode(hostView);
                // Will become true if the `try` block executes with no errors.
                /** @type {?} */
                var safeToRunHooks = false;
                try {
                    if (normalExecutionPath && !creationModeIsActive && rendererFactory.begin) {
                        rendererFactory.begin();
                    }
                    if (creationModeIsActive) {
                        // creation mode pass
                        templateFn && executeTemplate(hostView, templateFn, 1 /* Create */, context);
                        refreshDescendantViews(hostView);
                        hostView[FLAGS] &= ~4 /* CreationMode */;
                    }
                    // update mode pass
                    resetPreOrderHookFlags(hostView);
                    templateFn && executeTemplate(hostView, templateFn, 2 /* Update */, context);
                    refreshDescendantViews(hostView);
                    safeToRunHooks = true;
                }
                finally {
                    if (normalExecutionPath && !creationModeIsActive && rendererFactory.end) {
                        rendererFactory.end();
                    }
                    leaveView(oldView, safeToRunHooks);
                }
            }
            /**
             * @template T
             * @param {?} lView
             * @param {?} templateFn
             * @param {?} rf
             * @param {?} context
             * @return {?}
             */
            function executeTemplate(lView, templateFn, rf, context) {
                namespaceHTMLInternal();
                /** @type {?} */
                var prevSelectedIndex = getSelectedIndex();
                try {
                    setActiveHostElement(null);
                    if (rf & 2 /* Update */) {
                        // When we're updating, have an inherent ɵɵselect(0) so we don't have to generate that
                        // instruction for most update blocks
                        selectInternal(lView, 0);
                    }
                    templateFn(rf, context);
                }
                finally {
                    setSelectedIndex(prevSelectedIndex);
                }
            }
            /**
             * This function returns the default configuration of rendering flags depending on when the
             * template is in creation mode or update mode. Update block and create block are
             * always run separately.
             * @param {?} view
             * @return {?}
             */
            function getRenderFlags(view) {
                return isCreationMode(view) ? 1 /* Create */ : 2 /* Update */;
            }
            //////////////////////////
            //// Element
            //////////////////////////
            /**
             * @param {?} tView
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function executeContentQueries(tView, tNode, lView) {
                if (isContentQueryHost(tNode)) {
                    /** @type {?} */
                    var start = tNode.directiveStart;
                    /** @type {?} */
                    var end = tNode.directiveEnd;
                    for (var directiveIndex = start; directiveIndex < end; directiveIndex++) {
                        /** @type {?} */
                        var def = ( /** @type {?} */(tView.data[directiveIndex]));
                        if (def.contentQueries) {
                            def.contentQueries(1 /* Create */, lView[directiveIndex], directiveIndex);
                        }
                    }
                }
            }
            /**
             * Creates directive instances and populates local refs.
             *
             * @param {?} tView
             * @param {?} lView
             * @param {?} tNode
             * @param {?=} localRefExtractor mapping function that extracts local ref value from TNode
             * @return {?}
             */
            function createDirectivesAndLocals(tView, lView, tNode, localRefExtractor) {
                if (localRefExtractor === void 0) { localRefExtractor = getNativeByTNode; }
                if (!getBindingsEnabled())
                    return;
                instantiateAllDirectives(tView, lView, tNode);
                invokeDirectivesHostBindings(tView, lView, tNode);
                saveResolvedLocalsInData(lView, tNode, localRefExtractor);
                setActiveHostElement(null);
            }
            /**
             * Takes a list of local names and indices and pushes the resolved local variable values
             * to LView in the same order as they are loaded in the template with load().
             * @param {?} viewData
             * @param {?} tNode
             * @param {?} localRefExtractor
             * @return {?}
             */
            function saveResolvedLocalsInData(viewData, tNode, localRefExtractor) {
                /** @type {?} */
                var localNames = tNode.localNames;
                if (localNames) {
                    /** @type {?} */
                    var localIndex = tNode.index + 1;
                    for (var i = 0; i < localNames.length; i += 2) {
                        /** @type {?} */
                        var index = ( /** @type {?} */(localNames[i + 1]));
                        /** @type {?} */
                        var value = index === -1 ?
                            localRefExtractor(( /** @type {?} */(tNode)), viewData) :
                            viewData[index];
                        viewData[localIndex++] = value;
                    }
                }
            }
            /**
             * Gets TView from a template function or creates a new TView
             * if it doesn't already exist.
             *
             * @param {?} def ComponentDef
             * @return {?} TView
             */
            function getOrCreateTView(def) {
                return def.tView || (def.tView = createTView(-1, def.template, def.consts, def.vars, def.directiveDefs, def.pipeDefs, def.viewQuery, def.schemas));
            }
            /**
             * Creates a TView instance
             *
             * @param {?} viewIndex The viewBlockId for inline views, or -1 if it's a component/dynamic
             * @param {?} templateFn Template function
             * @param {?} consts The number of nodes, local refs, and pipes in this template
             * @param {?} vars
             * @param {?} directives Registry of directives for this view
             * @param {?} pipes Registry of pipes for this view
             * @param {?} viewQuery View queries for this view
             * @param {?} schemas Schemas for this view
             * @return {?}
             */
            function createTView(viewIndex, templateFn, consts, vars, directives, pipes, viewQuery, schemas) {
                ngDevMode && ngDevMode.tView++;
                /** @type {?} */
                var bindingStartIndex = HEADER_OFFSET + consts;
                // This length does not yet contain host bindings from child directives because at this point,
                // we don't know which directives are active on this template. As soon as a directive is matched
                // that has a host binding, we will update the blueprint with that def's hostVars count.
                /** @type {?} */
                var initialViewLength = bindingStartIndex + vars;
                /** @type {?} */
                var blueprint = createViewBlueprint(bindingStartIndex, initialViewLength);
                return blueprint[( /** @type {?} */(TVIEW))] = ngDevMode ?
                    new TViewConstructor(viewIndex, // id: number,
                    blueprint, // blueprint: LView,
                    templateFn, // template: ComponentTemplate<{}>|null,
                    null, // queries: TQueries|null
                    viewQuery, ( /** @type {?} */(null)), // node: TViewNode|TElementNode|null,
                    cloneToTViewData(blueprint).fill(null, bindingStartIndex), // data: TData,
                    bindingStartIndex, // bindingStartIndex: number,
                    initialViewLength, // expandoStartIndex: number,
                    null, // expandoInstructions: ExpandoInstructions|null,
                    true, // firstTemplatePass: boolean,
                    false, // staticViewQueries: boolean,
                    false, // staticContentQueries: boolean,
                    null, // preOrderHooks: HookData|null,
                    null, // preOrderCheckHooks: HookData|null,
                    null, // contentHooks: HookData|null,
                    null, // contentCheckHooks: HookData|null,
                    null, // viewHooks: HookData|null,
                    null, // viewCheckHooks: HookData|null,
                    null, // destroyHooks: HookData|null,
                    null, // cleanup: any[]|null,
                    null, // contentQueries: number[]|null,
                    null, // components: number[]|null,
                    typeof directives === 'function' ?
                        directives() :
                        directives, // directiveRegistry: DirectiveDefList|null,
                    typeof pipes === 'function' ? pipes() : pipes, // pipeRegistry: PipeDefList|null,
                    null, // firstChild: TNode|null,
                    schemas) :
                    {
                        id: viewIndex,
                        blueprint: blueprint,
                        template: templateFn,
                        queries: null,
                        viewQuery: viewQuery,
                        node: ( /** @type {?} */(null)),
                        data: blueprint.slice().fill(null, bindingStartIndex),
                        bindingStartIndex: bindingStartIndex,
                        expandoStartIndex: initialViewLength,
                        expandoInstructions: null,
                        firstTemplatePass: true,
                        staticViewQueries: false,
                        staticContentQueries: false,
                        preOrderHooks: null,
                        preOrderCheckHooks: null,
                        contentHooks: null,
                        contentCheckHooks: null,
                        viewHooks: null,
                        viewCheckHooks: null,
                        destroyHooks: null,
                        cleanup: null,
                        contentQueries: null,
                        components: null,
                        directiveRegistry: typeof directives === 'function' ? directives() : directives,
                        pipeRegistry: typeof pipes === 'function' ? pipes() : pipes,
                        firstChild: null,
                        schemas: schemas,
                    };
            }
            /**
             * @param {?} bindingStartIndex
             * @param {?} initialViewLength
             * @return {?}
             */
            function createViewBlueprint(bindingStartIndex, initialViewLength) {
                /** @type {?} */
                var blueprint = ( /** @type {?} */(new (ngDevMode ? ( /** @type {?} */(LViewBlueprint)) : Array)(initialViewLength)
                    .fill(null, 0, bindingStartIndex)
                    .fill(NO_CHANGE, bindingStartIndex)));
                blueprint[BINDING_INDEX] = bindingStartIndex;
                return blueprint;
            }
            /**
             * @param {?} text
             * @param {?} token
             * @return {?}
             */
            function createError(text, token) {
                return new Error("Renderer: " + text + " [" + stringifyForError(token) + "]");
            }
            /**
             * Locates the host native element, used for bootstrapping existing nodes into rendering pipeline.
             *
             * @param {?} factory
             * @param {?} elementOrSelector Render element or CSS selector to locate the element.
             * @return {?}
             */
            function locateHostElement(factory, elementOrSelector) {
                /** @type {?} */
                var defaultRenderer = factory.createRenderer(null, null);
                /** @type {?} */
                var rNode = typeof elementOrSelector === 'string' ?
                    (isProceduralRenderer(defaultRenderer) ?
                        defaultRenderer.selectRootElement(elementOrSelector) :
                        defaultRenderer.querySelector(elementOrSelector)) :
                    elementOrSelector;
                if (ngDevMode && !rNode) {
                    if (typeof elementOrSelector === 'string') {
                        throw createError('Host node with selector not found:', elementOrSelector);
                    }
                    else {
                        throw createError('Host node is required:', elementOrSelector);
                    }
                }
                return rNode;
            }
            /**
             * Saves context for this cleanup function in LView.cleanupInstances.
             *
             * On the first template pass, saves in TView:
             * - Cleanup function
             * - Index of context we just saved in LView.cleanupInstances
             * @param {?} lView
             * @param {?} context
             * @param {?} cleanupFn
             * @return {?}
             */
            function storeCleanupWithContext(lView, context, cleanupFn) {
                /** @type {?} */
                var lCleanup = getCleanup(lView);
                lCleanup.push(context);
                if (lView[TVIEW].firstTemplatePass) {
                    getTViewCleanup(lView).push(cleanupFn, lCleanup.length - 1);
                }
            }
            /**
             * Saves the cleanup function itself in LView.cleanupInstances.
             *
             * This is necessary for functions that are wrapped with their contexts, like in renderer2
             * listeners.
             *
             * On the first template pass, the index of the cleanup function is saved in TView.
             * @param {?} view
             * @param {?} cleanupFn
             * @return {?}
             */
            function storeCleanupFn(view, cleanupFn) {
                getCleanup(view).push(cleanupFn);
                if (view[TVIEW].firstTemplatePass) {
                    getTViewCleanup(view).push(( /** @type {?} */(view[CLEANUP])).length - 1, null);
                }
            }
            /**
             * Constructs a TNode object from the arguments.
             *
             * @param {?} tView `TView` to which this `TNode` belongs (used only in `ngDevMode`)
             * @param {?} tParent
             * @param {?} type The type of the node
             * @param {?} adjustedIndex The index of the TNode in TView.data, adjusted for HEADER_OFFSET
             * @param {?} tagName The tag name of the node
             * @param {?} attrs The attributes defined on this node
             * @return {?} the TNode object
             */
            function createTNode(tView, tParent, type, adjustedIndex, tagName, attrs) {
                ngDevMode && ngDevMode.tNode++;
                /** @type {?} */
                var injectorIndex = tParent ? tParent.injectorIndex : -1;
                return ngDevMode ? new TNodeConstructor(tView, // tView_: TView
                type, // type: TNodeType
                adjustedIndex, // index: number
                injectorIndex, // injectorIndex: number
                -1, // directiveStart: number
                -1, // directiveEnd: number
                -1, // propertyMetadataStartIndex: number
                -1, // propertyMetadataEndIndex: number
                0, // flags: TNodeFlags
                0, // providerIndexes: TNodeProviderIndexes
                tagName, // tagName: string|null
                attrs, // attrs: (string|AttributeMarker|(string|SelectorFlags)[])[]|null
                null, // localNames: (string|number)[]|null
                undefined, // initialInputs: (string[]|null)[]|null|undefined
                undefined, // inputs: PropertyAliases|null|undefined
                undefined, // outputs: PropertyAliases|null|undefined
                null, // tViews: ITView|ITView[]|null
                null, // next: ITNode|null
                null, // projectionNext: ITNode|null
                null, // child: ITNode|null
                tParent, // parent: TElementNode|TContainerNode|null
                null, // projection: number|(ITNode|RNode[])[]|null
                null, // styles: TStylingContext|null
                null) :
                    {
                        type: type,
                        index: adjustedIndex,
                        injectorIndex: injectorIndex,
                        directiveStart: -1,
                        directiveEnd: -1,
                        propertyMetadataStartIndex: -1,
                        propertyMetadataEndIndex: -1,
                        flags: 0,
                        providerIndexes: 0,
                        tagName: tagName,
                        attrs: attrs,
                        localNames: null,
                        initialInputs: undefined,
                        inputs: undefined,
                        outputs: undefined,
                        tViews: null,
                        next: null,
                        projectionNext: null,
                        child: null,
                        parent: tParent,
                        projection: null,
                        styles: null,
                        classes: null,
                    };
            }
            /**
             * Consolidates all inputs or outputs of all directives on this logical node.
             *
             * @param {?} tNode
             * @param {?} direction whether to consider inputs or outputs
             * @return {?} PropertyAliases|null aggregate of all properties if any, `null` otherwise
             */
            function generatePropertyAliases(tNode, direction) {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                /** @type {?} */
                var propStore = null;
                /** @type {?} */
                var start = tNode.directiveStart;
                /** @type {?} */
                var end = tNode.directiveEnd;
                if (end > start) {
                    /** @type {?} */
                    var isInput = direction === 0 /* Input */;
                    /** @type {?} */
                    var defs = tView.data;
                    for (var i = start; i < end; i++) {
                        /** @type {?} */
                        var directiveDef_3 = ( /** @type {?} */(defs[i]));
                        /** @type {?} */
                        var propertyAliasMap = isInput ? directiveDef_3.inputs : directiveDef_3.outputs;
                        for (var publicName in propertyAliasMap) {
                            if (propertyAliasMap.hasOwnProperty(publicName)) {
                                propStore = propStore || {};
                                /** @type {?} */
                                var internalName = propertyAliasMap[publicName];
                                /** @type {?} */
                                var hasProperty = propStore.hasOwnProperty(publicName);
                                hasProperty ? propStore[publicName].push(i, publicName, internalName) :
                                    (propStore[publicName] = [i, publicName, internalName]);
                            }
                        }
                    }
                }
                return propStore;
            }
            /**
             * Mapping between attributes names that don't correspond to their element property names.
             * Note: this mapping has to be kept in sync with the equally named mapping in the template
             * type-checking machinery of ngtsc.
             * @type {?}
             */
            var ATTR_TO_PROP = {
                'class': 'className',
                'for': 'htmlFor',
                'formaction': 'formAction',
                'innerHtml': 'innerHTML',
                'readonly': 'readOnly',
                'tabindex': 'tabIndex',
            };
            /**
             * @template T
             * @param {?} index
             * @param {?} propName
             * @param {?} value
             * @param {?=} sanitizer
             * @param {?=} nativeOnly
             * @param {?=} loadRendererFn
             * @return {?}
             */
            function elementPropertyInternal(index, propName, value, sanitizer, nativeOnly, loadRendererFn) {
                ngDevMode && assertNotSame(value, ( /** @type {?} */(NO_CHANGE)), 'Incoming value should never be NO_CHANGE.');
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var element = ( /** @type {?} */(getNativeByIndex(index, lView)));
                /** @type {?} */
                var tNode = getTNode(index, lView);
                /** @type {?} */
                var inputData;
                /** @type {?} */
                var dataValue;
                if (!nativeOnly && (inputData = initializeTNodeInputs(tNode)) &&
                    (dataValue = inputData[propName])) {
                    setInputsForProperty(lView, dataValue, value);
                    if (isComponent(tNode))
                        markDirtyIfOnPush(lView, index + HEADER_OFFSET);
                    if (ngDevMode) {
                        if (tNode.type === 3 /* Element */ || tNode.type === 0 /* Container */) {
                            /**
                             * dataValue is an array containing runtime input or output names for the directives:
                             * i+0: directive instance index
                             * i+1: publicName
                             * i+2: privateName
                             *
                             * e.g. [0, 'change', 'change-minified']
                             * we want to set the reflected property with the privateName: dataValue[i+2]
                             */
                            for (var i = 0; i < dataValue.length; i += 3) {
                                setNgReflectProperty(lView, element, tNode.type, ( /** @type {?} */(dataValue[i + 2])), value);
                            }
                        }
                    }
                }
                else if (tNode.type === 3 /* Element */) {
                    propName = ATTR_TO_PROP[propName] || propName;
                    if (ngDevMode) {
                        validateAgainstEventProperties(propName);
                        validateAgainstUnknownProperties(lView, element, propName, tNode);
                        ngDevMode.rendererSetProperty++;
                    }
                    savePropertyDebugData(tNode, lView, propName, lView[TVIEW].data, nativeOnly);
                    /** @type {?} */
                    var renderer = loadRendererFn ? loadRendererFn(tNode, lView) : lView[RENDERER];
                    // It is assumed that the sanitizer is only added when the compiler determines that the
                    // property
                    // is risky, so sanitization can be done without further checks.
                    value = sanitizer != null ? (( /** @type {?} */(sanitizer(value, tNode.tagName || '', propName)))) : value;
                    if (isProceduralRenderer(renderer)) {
                        renderer.setProperty(( /** @type {?} */(element)), propName, value);
                    }
                    else if (!isAnimationProp(propName)) {
                        (( /** @type {?} */(element))).setProperty ? (( /** @type {?} */(element))).setProperty(propName, value) :
                            (( /** @type {?} */(element)))[propName] = value;
                    }
                }
                else if (tNode.type === 0 /* Container */) {
                    // If the node is a container and the property didn't
                    // match any of the inputs or schemas we should throw.
                    if (ngDevMode && !matchingSchemas(lView, tNode.tagName)) {
                        throw createUnknownPropertyError(propName, tNode);
                    }
                }
            }
            /**
             * If node is an OnPush component, marks its LView dirty.
             * @param {?} lView
             * @param {?} viewIndex
             * @return {?}
             */
            function markDirtyIfOnPush(lView, viewIndex) {
                ngDevMode && assertLView(lView);
                /** @type {?} */
                var childComponentLView = getComponentViewByIndex(viewIndex, lView);
                if (!(childComponentLView[FLAGS] & 16 /* CheckAlways */)) {
                    childComponentLView[FLAGS] |= 64 /* Dirty */;
                }
            }
            /**
             * @param {?} lView
             * @param {?} element
             * @param {?} type
             * @param {?} attrName
             * @param {?} value
             * @return {?}
             */
            function setNgReflectProperty(lView, element, type, attrName, value) {
                var _c;
                /** @type {?} */
                var renderer = lView[RENDERER];
                attrName = normalizeDebugBindingName(attrName);
                /** @type {?} */
                var debugValue = normalizeDebugBindingValue(value);
                if (type === 3 /* Element */) {
                    if (value == null) {
                        isProceduralRenderer(renderer) ? renderer.removeAttribute((( /** @type {?} */(element))), attrName) :
                            (( /** @type {?} */(element))).removeAttribute(attrName);
                    }
                    else {
                        isProceduralRenderer(renderer) ?
                            renderer.setAttribute((( /** @type {?} */(element))), attrName, debugValue) :
                            (( /** @type {?} */(element))).setAttribute(attrName, debugValue);
                    }
                }
                else {
                    /** @type {?} */
                    var textContent = "bindings=" + JSON.stringify((_c = {}, _c[attrName] = debugValue, _c), null, 2);
                    if (isProceduralRenderer(renderer)) {
                        renderer.setValue((( /** @type {?} */(element))), textContent);
                    }
                    else {
                        (( /** @type {?} */(element))).textContent = textContent;
                    }
                }
            }
            /**
             * @param {?} hostView
             * @param {?} element
             * @param {?} propName
             * @param {?} tNode
             * @return {?}
             */
            function validateAgainstUnknownProperties(hostView, element, propName, tNode) {
                // If the tag matches any of the schemas we shouldn't throw.
                if (matchingSchemas(hostView, tNode.tagName)) {
                    return;
                }
                // If prop is not a known property of the HTML element...
                if (!(propName in element) &&
                    // and we are in a browser context... (web worker nodes should be skipped)
                    typeof Node === 'function' && element instanceof Node &&
                    // and isn't a synthetic animation property...
                    propName[0] !== ANIMATION_PROP_PREFIX) {
                    // ... it is probably a user error and we should throw.
                    throw createUnknownPropertyError(propName, tNode);
                }
            }
            /**
             * @param {?} hostView
             * @param {?} tagName
             * @return {?}
             */
            function matchingSchemas(hostView, tagName) {
                /** @type {?} */
                var schemas = hostView[TVIEW].schemas;
                if (schemas !== null) {
                    for (var i = 0; i < schemas.length; i++) {
                        /** @type {?} */
                        var schema = schemas[i];
                        if (schema === NO_ERRORS_SCHEMA ||
                            schema === CUSTOM_ELEMENTS_SCHEMA && tagName && tagName.indexOf('-') > -1) {
                            return true;
                        }
                    }
                }
                return false;
            }
            /**
             * Stores debugging data for this property binding on first template pass.
             * This enables features like DebugElement.properties.
             * @param {?} tNode
             * @param {?} lView
             * @param {?} propName
             * @param {?} tData
             * @param {?} nativeOnly
             * @return {?}
             */
            function savePropertyDebugData(tNode, lView, propName, tData, nativeOnly) {
                /** @type {?} */
                var lastBindingIndex = lView[BINDING_INDEX] - 1;
                // Bind/interpolation functions save binding metadata in the last binding index,
                // but leave the property name blank. If the interpolation delimiter is at the 0
                // index, we know that this is our first pass and the property name still needs to
                // be set.
                /** @type {?} */
                var bindingMetadata = ( /** @type {?} */(tData[lastBindingIndex]));
                if (bindingMetadata[0] == INTERPOLATION_DELIMITER) {
                    tData[lastBindingIndex] = propName + bindingMetadata;
                    // We don't want to store indices for host bindings because they are stored in a
                    // different part of LView (the expando section).
                    if (!nativeOnly) {
                        if (tNode.propertyMetadataStartIndex == -1) {
                            tNode.propertyMetadataStartIndex = lastBindingIndex;
                        }
                        tNode.propertyMetadataEndIndex = lastBindingIndex + 1;
                    }
                }
            }
            /**
             * Creates an error that should be thrown when encountering an unknown property on an element.
             * @param {?} propName Name of the invalid property.
             * @param {?} tNode Node on which we encountered the error.
             * @return {?}
             */
            function createUnknownPropertyError(propName, tNode) {
                return new Error("Template error: Can't bind to '" + propName + "' since it isn't a known property of '" + tNode.tagName + "'.");
            }
            /**
             * Instantiate a root component.
             * @template T
             * @param {?} tView
             * @param {?} viewData
             * @param {?} def
             * @return {?}
             */
            function instantiateRootComponent(tView, viewData, def) {
                /** @type {?} */
                var rootTNode = getPreviousOrParentTNode();
                if (tView.firstTemplatePass) {
                    if (def.providersResolver)
                        def.providersResolver(def);
                    generateExpandoInstructionBlock(tView, rootTNode, 1);
                    baseResolveDirective(tView, viewData, def, def.factory);
                }
                /** @type {?} */
                var directive = getNodeInjectable(tView.data, viewData, viewData.length - 1, ( /** @type {?} */(rootTNode)));
                postProcessBaseDirective(viewData, rootTNode, directive);
                return directive;
            }
            /**
             * Resolve the matched directives on a node.
             * @param {?} tView
             * @param {?} lView
             * @param {?} tNode
             * @param {?} localRefs
             * @return {?}
             */
            function resolveDirectives(tView, lView, tNode, localRefs) {
                // Please make sure to have explicit type for `exportsMap`. Inferred type triggers bug in
                // tsickle.
                ngDevMode && assertEqual(tView.firstTemplatePass, true, 'should run on first template pass only');
                if (!getBindingsEnabled())
                    return;
                /** @type {?} */
                var directives = findDirectiveMatches(tView, lView, tNode);
                /** @type {?} */
                var exportsMap = localRefs ? { '': -1 } : null;
                if (directives) {
                    initNodeFlags(tNode, tView.data.length, directives.length);
                    // When the same token is provided by several directives on the same node, some rules apply in
                    // the viewEngine:
                    // - viewProviders have priority over providers
                    // - the last directive in NgModule.declarations has priority over the previous one
                    // So to match these rules, the order in which providers are added in the arrays is very
                    // important.
                    for (var i = 0; i < directives.length; i++) {
                        /** @type {?} */
                        var def = ( /** @type {?} */(directives[i]));
                        if (def.providersResolver)
                            def.providersResolver(def);
                    }
                    generateExpandoInstructionBlock(tView, tNode, directives.length);
                    /** @type {?} */
                    var initialPreOrderHooksLength = (tView.preOrderHooks && tView.preOrderHooks.length) || 0;
                    /** @type {?} */
                    var initialPreOrderCheckHooksLength = (tView.preOrderCheckHooks && tView.preOrderCheckHooks.length) || 0;
                    /** @type {?} */
                    var nodeIndex = tNode.index - HEADER_OFFSET;
                    for (var i = 0; i < directives.length; i++) {
                        /** @type {?} */
                        var def = ( /** @type {?} */(directives[i]));
                        /** @type {?} */
                        var directiveDefIdx = tView.data.length;
                        baseResolveDirective(tView, lView, def, def.factory);
                        saveNameToExportMap(( /** @type {?} */(tView.data)).length - 1, def, exportsMap);
                        // Init hooks are queued now so ngOnInit is called in host components before
                        // any projected components.
                        registerPreOrderHooks(directiveDefIdx, def, tView, nodeIndex, initialPreOrderHooksLength, initialPreOrderCheckHooksLength);
                    }
                }
                if (exportsMap)
                    cacheMatchingLocalNames(tNode, localRefs, exportsMap);
            }
            /**
             * Instantiate all the directives that were previously resolved on the current node.
             * @param {?} tView
             * @param {?} lView
             * @param {?} tNode
             * @return {?}
             */
            function instantiateAllDirectives(tView, lView, tNode) {
                /** @type {?} */
                var start = tNode.directiveStart;
                /** @type {?} */
                var end = tNode.directiveEnd;
                if (!tView.firstTemplatePass && start < end) {
                    getOrCreateNodeInjectorForNode(( /** @type {?} */(tNode)), lView);
                }
                for (var i = start; i < end; i++) {
                    /** @type {?} */
                    var def = ( /** @type {?} */(tView.data[i]));
                    if (isComponentDef(def)) {
                        addComponentLogic(lView, tNode, ( /** @type {?} */(def)));
                    }
                    /** @type {?} */
                    var directive = getNodeInjectable(tView.data, ( /** @type {?} */(lView)), i, ( /** @type {?} */(tNode)));
                    postProcessDirective(lView, directive, def, i);
                }
            }
            /**
             * @param {?} tView
             * @param {?} viewData
             * @param {?} tNode
             * @return {?}
             */
            function invokeDirectivesHostBindings(tView, viewData, tNode) {
                /** @type {?} */
                var start = tNode.directiveStart;
                /** @type {?} */
                var end = tNode.directiveEnd;
                /** @type {?} */
                var expando = ( /** @type {?} */(tView.expandoInstructions));
                /** @type {?} */
                var firstTemplatePass = tView.firstTemplatePass;
                /** @type {?} */
                var elementIndex = tNode.index - HEADER_OFFSET;
                /** @type {?} */
                var selectedIndex = getSelectedIndex();
                try {
                    setActiveHostElement(elementIndex);
                    for (var i = start; i < end; i++) {
                        /** @type {?} */
                        var def = ( /** @type {?} */(tView.data[i]));
                        /** @type {?} */
                        var directive = viewData[i];
                        if (def.hostBindings) {
                            invokeHostBindingsInCreationMode(def, expando, directive, tNode, firstTemplatePass);
                            // Each directive gets a uniqueId value that is the same for both
                            // create and update calls when the hostBindings function is called. The
                            // directive uniqueId is not set anywhere--it is just incremented between
                            // each hostBindings call and is useful for helping instruction code
                            // uniquely determine which directive is currently active when executed.
                            incrementActiveDirectiveId();
                        }
                        else if (firstTemplatePass) {
                            expando.push(null);
                        }
                    }
                }
                finally {
                    setActiveHostElement(selectedIndex);
                }
            }
            /**
             * @param {?} def
             * @param {?} expando
             * @param {?} directive
             * @param {?} tNode
             * @param {?} firstTemplatePass
             * @return {?}
             */
            function invokeHostBindingsInCreationMode(def, expando, directive, tNode, firstTemplatePass) {
                /** @type {?} */
                var previousExpandoLength = expando.length;
                setCurrentDirectiveDef(def);
                /** @type {?} */
                var elementIndex = tNode.index - HEADER_OFFSET;
                ( /** @type {?} */(def.hostBindings))(1 /* Create */, directive, elementIndex);
                setCurrentDirectiveDef(null);
                // `hostBindings` function may or may not contain `allocHostVars` call
                // (e.g. it may not if it only contains host listeners), so we need to check whether
                // `expandoInstructions` has changed and if not - we still push `hostBindings` to
                // expando block, to make sure we execute it for DI cycle
                if (previousExpandoLength === expando.length && firstTemplatePass) {
                    expando.push(def.hostBindings);
                }
            }
            /**
             * Generates a new block in TView.expandoInstructions for this node.
             *
             * Each expando block starts with the element index (turned negative so we can distinguish
             * it from the hostVar count) and the directive count. See more in VIEW_DATA.md.
             * @param {?} tView
             * @param {?} tNode
             * @param {?} directiveCount
             * @return {?}
             */
            function generateExpandoInstructionBlock(tView, tNode, directiveCount) {
                ngDevMode && assertEqual(tView.firstTemplatePass, true, 'Expando block should only be generated on first template pass.');
                /** @type {?} */
                var elementIndex = -(tNode.index - HEADER_OFFSET);
                /** @type {?} */
                var providerStartIndex = tNode.providerIndexes & 65535 /* ProvidersStartIndexMask */;
                /** @type {?} */
                var providerCount = tView.data.length - providerStartIndex;
                (tView.expandoInstructions || (tView.expandoInstructions = [])).push(elementIndex, providerCount, directiveCount);
            }
            /**
             * Process a directive on the current node after its creation.
             * @template T
             * @param {?} viewData
             * @param {?} directive
             * @param {?} def
             * @param {?} directiveDefIdx
             * @return {?}
             */
            function postProcessDirective(viewData, directive, def, directiveDefIdx) {
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                postProcessBaseDirective(viewData, previousOrParentTNode, directive);
                ngDevMode && assertDefined(previousOrParentTNode, 'previousOrParentTNode');
                if (previousOrParentTNode && previousOrParentTNode.attrs) {
                    setInputsFromAttrs(directiveDefIdx, directive, def, previousOrParentTNode);
                }
                if (viewData[TVIEW].firstTemplatePass && def.contentQueries) {
                    previousOrParentTNode.flags |= 4 /* hasContentQuery */;
                }
                if (isComponentDef(def)) {
                    /** @type {?} */
                    var componentView = getComponentViewByIndex(previousOrParentTNode.index, viewData);
                    componentView[CONTEXT] = directive;
                }
            }
            /**
             * A lighter version of postProcessDirective() that is used for the root component.
             * @template T
             * @param {?} lView
             * @param {?} previousOrParentTNode
             * @param {?} directive
             * @return {?}
             */
            function postProcessBaseDirective(lView, previousOrParentTNode, directive) {
                /** @type {?} */
                var native = getNativeByTNode(previousOrParentTNode, lView);
                ngDevMode && assertEqual(lView[BINDING_INDEX], lView[TVIEW].bindingStartIndex, 'directives should be created before any bindings');
                ngDevMode && assertPreviousIsParent(getIsParent());
                attachPatchData(directive, lView);
                if (native) {
                    attachPatchData(native, lView);
                }
            }
            /**
             * Matches the current node against all available selectors.
             * If a component is matched (at most one), it is returned in first position in the array.
             * @param {?} tView
             * @param {?} viewData
             * @param {?} tNode
             * @return {?}
             */
            function findDirectiveMatches(tView, viewData, tNode) {
                ngDevMode && assertEqual(tView.firstTemplatePass, true, 'should run on first template pass only');
                /** @type {?} */
                var registry = tView.directiveRegistry;
                /** @type {?} */
                var matches = null;
                if (registry) {
                    for (var i = 0; i < registry.length; i++) {
                        /** @type {?} */
                        var def = ( /** @type {?} */(registry[i]));
                        if (isNodeMatchingSelectorList(tNode, ( /** @type {?} */(def.selectors)), /* isProjectionMode */ false)) {
                            matches || (matches = ngDevMode ? new ( /** @type {?} */(MatchesArray))() : []);
                            diPublicInInjector(getOrCreateNodeInjectorForNode(tNode, viewData), tView, def.type);
                            if (isComponentDef(def)) {
                                if (tNode.flags & 1 /* isComponent */)
                                    throwMultipleComponentError(tNode);
                                tNode.flags = 1 /* isComponent */;
                                // The component is always stored first with directives after.
                                matches.unshift(def);
                            }
                            else {
                                matches.push(def);
                            }
                        }
                    }
                }
                return matches;
            }
            /**
             * Stores index of component's host element so it will be queued for view refresh during CD.
             * @param {?} previousOrParentTNode
             * @return {?}
             */
            function queueComponentIndexForCheck(previousOrParentTNode) {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                ngDevMode &&
                    assertEqual(tView.firstTemplatePass, true, 'Should only be called in first template pass.');
                (tView.components || (tView.components = ngDevMode ? new ( /** @type {?} */(TViewComponents))() : [])).push(previousOrParentTNode.index);
            }
            /**
             * Caches local names and their matching directive indices for query and template lookups.
             * @param {?} tNode
             * @param {?} localRefs
             * @param {?} exportsMap
             * @return {?}
             */
            function cacheMatchingLocalNames(tNode, localRefs, exportsMap) {
                if (localRefs) {
                    /** @type {?} */
                    var localNames = tNode.localNames =
                        ngDevMode ? new ( /** @type {?} */(TNodeLocalNames))() : [];
                    // Local names must be stored in tNode in the same order that localRefs are defined
                    // in the template to ensure the data is loaded in the same slots as their refs
                    // in the template (for template queries).
                    for (var i = 0; i < localRefs.length; i += 2) {
                        /** @type {?} */
                        var index = exportsMap[localRefs[i + 1]];
                        if (index == null)
                            throw new Error("Export of name '" + localRefs[i + 1] + "' not found!");
                        localNames.push(localRefs[i], index);
                    }
                }
            }
            /**
             * Builds up an export map as directives are created, so local refs can be quickly mapped
             * to their directive instances.
             * @param {?} index
             * @param {?} def
             * @param {?} exportsMap
             * @return {?}
             */
            function saveNameToExportMap(index, def, exportsMap) {
                if (exportsMap) {
                    if (def.exportAs) {
                        for (var i = 0; i < def.exportAs.length; i++) {
                            exportsMap[def.exportAs[i]] = index;
                        }
                    }
                    if ((( /** @type {?} */(def))).template)
                        exportsMap[''] = index;
                }
            }
            /**
             * Initializes the flags on the current node, setting all indices to the initial index,
             * the directive count to 0, and adding the isComponent flag.
             * @param {?} tNode
             * @param {?} index the initial index
             * @param {?} numberOfDirectives
             * @return {?}
             */
            function initNodeFlags(tNode, index, numberOfDirectives) {
                /** @type {?} */
                var flags = tNode.flags;
                ngDevMode && assertEqual(flags === 0 || flags === 1 /* isComponent */, true, 'expected node flags to not be initialized');
                ngDevMode && assertNotEqual(numberOfDirectives, tNode.directiveEnd - tNode.directiveStart, 'Reached the max number of directives');
                // When the first directive is created on a node, save the index
                tNode.flags = flags & 1 /* isComponent */;
                tNode.directiveStart = index;
                tNode.directiveEnd = index + numberOfDirectives;
                tNode.providerIndexes = index;
            }
            /**
             * @template T
             * @param {?} tView
             * @param {?} viewData
             * @param {?} def
             * @param {?} directiveFactory
             * @return {?}
             */
            function baseResolveDirective(tView, viewData, def, directiveFactory) {
                tView.data.push(def);
                /** @type {?} */
                var nodeInjectorFactory = new NodeInjectorFactory(directiveFactory, isComponentDef(def), null);
                tView.blueprint.push(nodeInjectorFactory);
                viewData.push(nodeInjectorFactory);
            }
            /**
             * @template T
             * @param {?} lView
             * @param {?} previousOrParentTNode
             * @param {?} def
             * @return {?}
             */
            function addComponentLogic(lView, previousOrParentTNode, def) {
                /** @type {?} */
                var native = getNativeByTNode(previousOrParentTNode, lView);
                /** @type {?} */
                var tView = getOrCreateTView(def);
                // Only component views should be added to the view tree directly. Embedded views are
                // accessed through their containers because they may be removed / re-added later.
                /** @type {?} */
                var rendererFactory = lView[RENDERER_FACTORY];
                /** @type {?} */
                var componentView = addToViewTree(lView, createLView(lView, tView, null, def.onPush ? 64 /* Dirty */ : 16 /* CheckAlways */, lView[previousOrParentTNode.index], ( /** @type {?} */(previousOrParentTNode)), rendererFactory, rendererFactory.createRenderer(( /** @type {?} */(native)), def)));
                componentView[T_HOST] = ( /** @type {?} */(previousOrParentTNode));
                // Component view will always be created before any injected LContainers,
                // so this is a regular element, wrap it with the component view
                lView[previousOrParentTNode.index] = componentView;
                if (lView[TVIEW].firstTemplatePass) {
                    queueComponentIndexForCheck(previousOrParentTNode);
                }
            }
            /**
             * @param {?} index
             * @param {?} name
             * @param {?} value
             * @param {?} lView
             * @param {?=} sanitizer
             * @param {?=} namespace
             * @return {?}
             */
            function elementAttributeInternal(index, name, value, lView, sanitizer, namespace) {
                ngDevMode && assertNotSame(value, ( /** @type {?} */(NO_CHANGE)), 'Incoming value should never be NO_CHANGE.');
                ngDevMode && validateAgainstEventAttributes(name);
                /** @type {?} */
                var element = ( /** @type {?} */(getNativeByIndex(index, lView)));
                /** @type {?} */
                var renderer = lView[RENDERER];
                if (value == null) {
                    ngDevMode && ngDevMode.rendererRemoveAttribute++;
                    isProceduralRenderer(renderer) ? renderer.removeAttribute(element, name, namespace) :
                        element.removeAttribute(name);
                }
                else {
                    ngDevMode && ngDevMode.rendererSetAttribute++;
                    /** @type {?} */
                    var tNode = getTNode(index, lView);
                    /** @type {?} */
                    var strValue = sanitizer == null ? renderStringify(value) : sanitizer(value, tNode.tagName || '', name);
                    if (isProceduralRenderer(renderer)) {
                        renderer.setAttribute(element, name, strValue, namespace);
                    }
                    else {
                        namespace ? element.setAttributeNS(namespace, name, strValue) :
                            element.setAttribute(name, strValue);
                    }
                }
            }
            /**
             * Sets initial input properties on directive instances from attribute data
             *
             * @template T
             * @param {?} directiveIndex Index of the directive in directives array
             * @param {?} instance Instance of the directive on which to set the initial inputs
             * @param {?} def The directive def that contains the list of inputs
             * @param {?} tNode The static data for this node
             * @return {?}
             */
            function setInputsFromAttrs(directiveIndex, instance, def, tNode) {
                /** @type {?} */
                var initialInputData = ( /** @type {?} */(tNode.initialInputs));
                if (initialInputData === undefined || directiveIndex >= initialInputData.length) {
                    initialInputData = generateInitialInputs(directiveIndex, def.inputs, tNode);
                }
                /** @type {?} */
                var initialInputs = initialInputData[directiveIndex];
                if (initialInputs) {
                    /** @type {?} */
                    var setInput = def.setInput;
                    for (var i = 0; i < initialInputs.length;) {
                        /** @type {?} */
                        var publicName = initialInputs[i++];
                        /** @type {?} */
                        var privateName = initialInputs[i++];
                        /** @type {?} */
                        var value = initialInputs[i++];
                        if (setInput) {
                            ( /** @type {?} */(def.setInput))(instance, value, publicName, privateName);
                        }
                        else {
                            (( /** @type {?} */(instance)))[privateName] = value;
                        }
                        if (ngDevMode) {
                            /** @type {?} */
                            var lView_3 = getLView();
                            /** @type {?} */
                            var nativeElement = ( /** @type {?} */(getNativeByTNode(tNode, lView_3)));
                            setNgReflectProperty(lView_3, nativeElement, tNode.type, privateName, value);
                        }
                    }
                }
            }
            /**
             * Generates initialInputData for a node and stores it in the template's static storage
             * so subsequent template invocations don't have to recalculate it.
             *
             * initialInputData is an array containing values that need to be set as input properties
             * for directives on this node, but only once on creation. We need this array to support
             * the case where you set an \@Input property of a directive using attribute-like syntax.
             * e.g. if you have a `name` \@Input, you can set it once like this:
             *
             * <my-component name="Bess"></my-component>
             *
             * @param {?} directiveIndex Index to store the initial input data
             * @param {?} inputs The list of inputs from the directive def
             * @param {?} tNode The static data on this node
             * @return {?}
             */
            function generateInitialInputs(directiveIndex, inputs, tNode) {
                /** @type {?} */
                var initialInputData = tNode.initialInputs || (tNode.initialInputs = ngDevMode ? new ( /** @type {?} */(TNodeInitialInputs))() : []);
                // Ensure that we don't create sparse arrays
                for (var i_5 = initialInputData.length; i_5 <= directiveIndex; i_5++) {
                    initialInputData.push(null);
                }
                /** @type {?} */
                var attrs = ( /** @type {?} */(tNode.attrs));
                /** @type {?} */
                var i = 0;
                while (i < attrs.length) {
                    /** @type {?} */
                    var attrName = attrs[i];
                    if (attrName === 0 /* NamespaceURI */) {
                        // We do not allow inputs on namespaced attributes.
                        i += 4;
                        continue;
                    }
                    else if (attrName === 5 /* ProjectAs */) {
                        // Skip over the `ngProjectAs` value.
                        i += 2;
                        continue;
                    }
                    // If we hit any other attribute markers, we're done anyway. None of those are valid inputs.
                    if (typeof attrName === 'number')
                        break;
                    /** @type {?} */
                    var minifiedInputName = inputs[( /** @type {?} */(attrName))];
                    /** @type {?} */
                    var attrValue = attrs[i + 1];
                    if (minifiedInputName !== undefined) {
                        /** @type {?} */
                        var inputsToStore = initialInputData[directiveIndex] ||
                            (initialInputData[directiveIndex] = ngDevMode ? new ( /** @type {?} */(TNodeInitialData))() : []);
                        inputsToStore.push(( /** @type {?} */(attrName)), minifiedInputName, ( /** @type {?} */(attrValue)));
                    }
                    i += 2;
                }
                return initialInputData;
            }
            //////////////////////////
            //// ViewContainer & View
            //////////////////////////
            // Not sure why I need to do `any` here but TS complains later.
            /** @type {?} */
            var LContainerArray = ngDevMode && createNamedArrayType('LContainer');
            /**
             * Creates a LContainer, either from a container instruction, or for a ViewContainerRef.
             *
             * @param {?} hostNative The host element for the LContainer
             * @param {?} currentView The parent view of the LContainer
             * @param {?} native The native comment element
             * @param {?} tNode
             * @param {?=} isForViewContainerRef Optional a flag indicating the ViewContainerRef case
             * @return {?} LContainer
             */
            function createLContainer(hostNative, currentView, native, tNode, isForViewContainerRef) {
                ngDevMode && assertDomNode(native);
                ngDevMode && assertLView(currentView);
                // https://jsperf.com/array-literal-vs-new-array-really
                /** @type {?} */
                var lContainer = new (ngDevMode ? LContainerArray : Array)(hostNative, // host native
                true, // Boolean `true` in this position signifies that this is an `LContainer`
                isForViewContainerRef ? -1 : 0, // active index
                currentView, // parent
                null, // next
                null, // queries
                tNode, // t_host
                native, // native,
                null);
                ngDevMode && attachLContainerDebug(lContainer);
                return lContainer;
            }
            /**
             * Goes over dynamic embedded views (ones created through ViewContainerRef APIs) and refreshes
             * them
             * by executing an associated template function.
             * @param {?} lView
             * @return {?}
             */
            function refreshDynamicEmbeddedViews(lView) {
                for (var current = lView[CHILD_HEAD]; current !== null; current = current[NEXT]) {
                    // Note: current can be an LView or an LContainer instance, but here we are only interested
                    // in LContainer. We can tell it's an LContainer because its length is less than the LView
                    // header.
                    if (current[ACTIVE_INDEX] === -1 && isLContainer(current)) {
                        for (var i = CONTAINER_HEADER_OFFSET; i < current.length; i++) {
                            /** @type {?} */
                            var dynamicViewData = current[i];
                            // The directives and pipes are not needed here as an existing view is only being
                            // refreshed.
                            ngDevMode && assertDefined(dynamicViewData[TVIEW], 'TView must be allocated');
                            renderEmbeddedTemplate(dynamicViewData, dynamicViewData[TVIEW], ( /** @type {?} */(dynamicViewData[CONTEXT])));
                        }
                    }
                }
            }
            /////////////
            /**
             * Refreshes components by entering the component view and processing its bindings, queries, etc.
             *
             * @param {?} hostLView
             * @param {?} adjustedElementIndex  Element index in LView[] (adjusted for HEADER_OFFSET)
             * @return {?}
             */
            function componentRefresh(hostLView, adjustedElementIndex) {
                ngDevMode && assertDataInRange(hostLView, adjustedElementIndex);
                /** @type {?} */
                var componentView = getComponentViewByIndex(adjustedElementIndex, hostLView);
                ngDevMode &&
                    assertNodeType(( /** @type {?} */(hostLView[TVIEW].data[adjustedElementIndex])), 3 /* Element */);
                // Only components in creation mode, attached CheckAlways
                // components or attached, dirty OnPush components should be checked
                if ((viewAttachedToChangeDetector(componentView) || isCreationMode(hostLView)) &&
                    componentView[FLAGS] & (16 /* CheckAlways */ | 64 /* Dirty */)) {
                    syncViewWithBlueprint(componentView);
                    checkView(componentView, componentView[CONTEXT]);
                }
            }
            /**
             * Syncs an LView instance with its blueprint if they have gotten out of sync.
             *
             * Typically, blueprints and their view instances should always be in sync, so the loop here
             * will be skipped. However, consider this case of two components side-by-side:
             *
             * App template:
             * ```
             * <comp></comp>
             * <comp></comp>
             * ```
             *
             * The following will happen:
             * 1. App template begins processing.
             * 2. First <comp> is matched as a component and its LView is created.
             * 3. Second <comp> is matched as a component and its LView is created.
             * 4. App template completes processing, so it's time to check child templates.
             * 5. First <comp> template is checked. It has a directive, so its def is pushed to blueprint.
             * 6. Second <comp> template is checked. Its blueprint has been updated by the first
             * <comp> template, but its LView was created before this update, so it is out of sync.
             *
             * Note that embedded views inside ngFor loops will never be out of sync because these views
             * are processed as soon as they are created.
             *
             * @param {?} componentView The view to sync
             * @return {?}
             */
            function syncViewWithBlueprint(componentView) {
                /** @type {?} */
                var componentTView = componentView[TVIEW];
                for (var i = componentView.length; i < componentTView.blueprint.length; i++) {
                    componentView[i] = componentTView.blueprint[i];
                }
            }
            /**
             * Adds LView or LContainer to the end of the current view tree.
             *
             * This structure will be used to traverse through nested views to remove listeners
             * and call onDestroy callbacks.
             *
             * @template T
             * @param {?} lView The view where LView or LContainer should be added
             * @param {?} lViewOrLContainer The LView or LContainer to add to the view tree
             * @return {?} The state passed in
             */
            function addToViewTree(lView, lViewOrLContainer) {
                // TODO(benlesh/misko): This implementation is incorrect, because it always adds the LContainer
                // to
                // the end of the queue, which means if the developer retrieves the LContainers from RNodes out
                // of
                // order, the change detection will run out of order, as the act of retrieving the the
                // LContainer
                // from the RNode is what adds it to the queue.
                if (lView[CHILD_HEAD]) {
                    ( /** @type {?} */(lView[CHILD_TAIL]))[NEXT] = lViewOrLContainer;
                }
                else {
                    lView[CHILD_HEAD] = lViewOrLContainer;
                }
                lView[CHILD_TAIL] = lViewOrLContainer;
                return lViewOrLContainer;
            }
            ///////////////////////////////
            //// Change detection
            ///////////////////////////////
            /**
             * Marks current view and all ancestors dirty.
             *
             * Returns the root view because it is found as a byproduct of marking the view tree
             * dirty, and can be used by methods that consume markViewDirty() to easily schedule
             * change detection. Otherwise, such methods would need to traverse up the view tree
             * an additional time to get the root view and schedule a tick on it.
             *
             * @param {?} lView The starting LView to mark dirty
             * @return {?} the root LView
             */
            function markViewDirty(lView) {
                while (lView) {
                    lView[FLAGS] |= 64 /* Dirty */;
                    /** @type {?} */
                    var parent = getLViewParent(lView);
                    // Stop traversing up as soon as you find a root view that wasn't attached to any container
                    if (isRootView(lView) && !parent) {
                        return lView;
                    }
                    // continue otherwise
                    lView = ( /** @type {?} */(parent));
                }
                return null;
            }
            /**
             * Used to schedule change detection on the whole application.
             *
             * Unlike `tick`, `scheduleTick` coalesces multiple calls into one change detection run.
             * It is usually called indirectly by calling `markDirty` when the view needs to be
             * re-rendered.
             *
             * Typically `scheduleTick` uses `requestAnimationFrame` to coalesce multiple
             * `scheduleTick` requests. The scheduling function can be overridden in
             * `renderComponent`'s `scheduler` option.
             * @param {?} rootContext
             * @param {?} flags
             * @return {?}
             */
            function scheduleTick(rootContext, flags) {
                /** @type {?} */
                var nothingScheduled = rootContext.flags === 0 /* Empty */;
                rootContext.flags |= flags;
                if (nothingScheduled && rootContext.clean == _CLEAN_PROMISE) {
                    /** @type {?} */
                    var res_1;
                    rootContext.clean = new Promise(( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) { return res_1 = r; }));
                    rootContext.scheduler(( /**
                     * @return {?}
                     */function () {
                        if (rootContext.flags & 1 /* DetectChanges */) {
                            rootContext.flags &= ~1 /* DetectChanges */;
                            tickRootContext(rootContext);
                        }
                        if (rootContext.flags & 2 /* FlushPlayers */) {
                            rootContext.flags &= ~2 /* FlushPlayers */;
                            /** @type {?} */
                            var playerHandler = rootContext.playerHandler;
                            if (playerHandler) {
                                playerHandler.flushPlayers();
                            }
                        }
                        rootContext.clean = _CLEAN_PROMISE;
                        ( /** @type {?} */(res_1))(null);
                    }));
                }
            }
            /**
             * @param {?} rootContext
             * @return {?}
             */
            function tickRootContext(rootContext) {
                for (var i = 0; i < rootContext.components.length; i++) {
                    /** @type {?} */
                    var rootComponent = rootContext.components[i];
                    renderComponentOrTemplate(( /** @type {?} */(readPatchedLView(rootComponent))), rootComponent);
                }
            }
            /**
             * @template T
             * @param {?} view
             * @param {?} context
             * @return {?}
             */
            function detectChangesInternal(view, context) {
                /** @type {?} */
                var rendererFactory = view[RENDERER_FACTORY];
                if (rendererFactory.begin)
                    rendererFactory.begin();
                try {
                    if (isCreationMode(view)) {
                        checkView(view, context); // creation mode pass
                    }
                    checkView(view, context); // update mode pass
                }
                catch (error) {
                    handleError(view, error);
                    throw error;
                }
                finally {
                    if (rendererFactory.end)
                        rendererFactory.end();
                }
            }
            /**
             * Synchronously perform change detection on a root view and its components.
             *
             * @param {?} lView The view which the change detection should be performed on.
             * @return {?}
             */
            function detectChangesInRootView(lView) {
                tickRootContext(( /** @type {?} */(lView[CONTEXT])));
            }
            /**
             * Checks the change detector and its children, and throws if any changes are detected.
             *
             * This is used in development mode to verify that running change detection doesn't
             * introduce other changes.
             * @template T
             * @param {?} component
             * @return {?}
             */
            function checkNoChanges(component) {
                /** @type {?} */
                var view = getComponentViewByInstance(component);
                checkNoChangesInternal(view, component);
            }
            /**
             * @template T
             * @param {?} view
             * @param {?} context
             * @return {?}
             */
            function checkNoChangesInternal(view, context) {
                setCheckNoChangesMode(true);
                try {
                    detectChangesInternal(view, context);
                }
                finally {
                    setCheckNoChangesMode(false);
                }
            }
            /**
             * Checks the change detector on a root view and its components, and throws if any changes are
             * detected.
             *
             * This is used in development mode to verify that running change detection doesn't
             * introduce other changes.
             *
             * @param {?} lView The view which the change detection should be checked on.
             * @return {?}
             */
            function checkNoChangesInRootView(lView) {
                setCheckNoChangesMode(true);
                try {
                    detectChangesInRootView(lView);
                }
                finally {
                    setCheckNoChangesMode(false);
                }
            }
            /**
             * Checks the view of the component provided. Does not gate on dirty checks or execute doCheck.
             * @template T
             * @param {?} hostView
             * @param {?} component
             * @return {?}
             */
            function checkView(hostView, component) {
                /** @type {?} */
                var hostTView = hostView[TVIEW];
                /** @type {?} */
                var oldView = enterView(hostView, hostView[T_HOST]);
                /** @type {?} */
                var templateFn = ( /** @type {?} */(hostTView.template));
                /** @type {?} */
                var creationMode = isCreationMode(hostView);
                // Will become true if the `try` block executes with no errors.
                /** @type {?} */
                var safeToRunHooks = false;
                try {
                    resetPreOrderHookFlags(hostView);
                    creationMode && executeViewQueryFn(1 /* Create */, hostTView, component);
                    executeTemplate(hostView, templateFn, getRenderFlags(hostView), component);
                    refreshDescendantViews(hostView);
                    safeToRunHooks = true;
                }
                finally {
                    leaveView(oldView, safeToRunHooks);
                }
            }
            /**
             * @template T
             * @param {?} flags
             * @param {?} tView
             * @param {?} component
             * @return {?}
             */
            function executeViewQueryFn(flags, tView, component) {
                /** @type {?} */
                var viewQuery = tView.viewQuery;
                if (viewQuery !== null) {
                    setCurrentQueryIndex(0);
                    viewQuery(flags, component);
                }
            }
            ///////////////////////////////
            //// Bindings & interpolations
            ///////////////////////////////
            /**
             * Creates binding metadata for a particular binding and stores it in
             * TView.data. These are generated in order to support DebugElement.properties.
             *
             * Each binding / interpolation will have one (including attribute bindings)
             * because at the time of binding, we don't know to which instruction the binding
             * belongs. It is always stored in TView.data at the index of the last binding
             * value in LView (e.g. for interpolation8, it would be stored at the index of
             * the 8th value).
             *
             * @param {?} lView The LView that contains the current binding index.
             * @param {?=} prefix The static prefix string
             * @param {?=} suffix The static suffix string
             *
             * @return {?} Newly created binding metadata string for this binding or null
             */
            function storeBindingMetadata(lView, prefix, suffix) {
                if (prefix === void 0) { prefix = ''; }
                if (suffix === void 0) { suffix = ''; }
                /** @type {?} */
                var tData = lView[TVIEW].data;
                /** @type {?} */
                var lastBindingIndex = lView[BINDING_INDEX] - 1;
                /** @type {?} */
                var value = INTERPOLATION_DELIMITER + prefix + INTERPOLATION_DELIMITER + suffix;
                return tData[lastBindingIndex] == null ? (tData[lastBindingIndex] = value) : null;
            }
            /** @type {?} */
            var CLEAN_PROMISE = _CLEAN_PROMISE;
            /**
             * @param {?} tNode
             * @return {?}
             */
            function initializeTNodeInputs(tNode) {
                // If tNode.inputs is undefined, a listener has created outputs, but inputs haven't
                // yet been checked.
                if (tNode.inputs === undefined) {
                    // mark inputs as checked
                    tNode.inputs = generatePropertyAliases(tNode, 0 /* Input */);
                }
                return tNode.inputs;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function getCleanup(view) {
                // top level variables should not be exported for performance reasons (PERF_NOTES.md)
                return view[CLEANUP] || (view[CLEANUP] = ngDevMode ? new ( /** @type {?} */(LCleanup))() : []);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function getTViewCleanup(view) {
                return view[TVIEW].cleanup || (view[TVIEW].cleanup = ngDevMode ? new ( /** @type {?} */(TCleanup))() : []);
            }
            /**
             * There are cases where the sub component's renderer needs to be included
             * instead of the current renderer (see the componentSyntheticHost* instructions).
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function loadComponentRenderer(tNode, lView) {
                /** @type {?} */
                var componentLView = ( /** @type {?} */(lView[tNode.index]));
                return componentLView[RENDERER];
            }
            /**
             * Handles an error thrown in an LView.
             * @param {?} lView
             * @param {?} error
             * @return {?}
             */
            function handleError(lView, error) {
                /** @type {?} */
                var injector = lView[INJECTOR$1];
                /** @type {?} */
                var errorHandler = injector ? injector.get(ErrorHandler, null) : null;
                errorHandler && errorHandler.handleError(error);
            }
            /**
             * Set the inputs of directives at the current node to corresponding value.
             *
             * @param {?} lView the `LView` which contains the directives.
             * @param {?} inputs mapping between the public "input" name and privately-known,
             * possibly minified, property names to write to.
             * @param {?} value Value to set.
             * @return {?}
             */
            function setInputsForProperty(lView, inputs, value) {
                /** @type {?} */
                var tView = lView[TVIEW];
                for (var i = 0; i < inputs.length;) {
                    /** @type {?} */
                    var index = ( /** @type {?} */(inputs[i++]));
                    /** @type {?} */
                    var publicName = ( /** @type {?} */(inputs[i++]));
                    /** @type {?} */
                    var privateName = ( /** @type {?} */(inputs[i++]));
                    /** @type {?} */
                    var instance = lView[index];
                    ngDevMode && assertDataInRange(lView, index);
                    /** @type {?} */
                    var def = ( /** @type {?} */(tView.data[index]));
                    /** @type {?} */
                    var setInput = def.setInput;
                    if (setInput) {
                        ( /** @type {?} */(def.setInput))(instance, value, publicName, privateName);
                    }
                    else {
                        instance[privateName] = value;
                    }
                }
            }
            /**
             * Updates a text binding at a given index in a given LView.
             * @param {?} lView
             * @param {?} index
             * @param {?} value
             * @return {?}
             */
            function textBindingInternal(lView, index, value) {
                ngDevMode && assertNotSame(value, ( /** @type {?} */(NO_CHANGE)), 'value should not be NO_CHANGE');
                ngDevMode && assertDataInRange(lView, index + HEADER_OFFSET);
                /** @type {?} */
                var element = ( /** @type {?} */(( /** @type {?} */(getNativeByIndex(index, lView)))));
                ngDevMode && assertDefined(element, 'native element should exist');
                ngDevMode && ngDevMode.rendererSetText++;
                /** @type {?} */
                var renderer = lView[RENDERER];
                isProceduralRenderer(renderer) ? renderer.setValue(element, value) : element.textContent = value;
            }
            /**
             * Renders all initial styling (class and style values) on to the element from the tNode.
             *
             * All initial styling data (i.e. any values extracted from the `style` or `class` attributes
             * on an element) are collected into the `tNode.styles` and `tNode.classes` data structures.
             * These values are populated during the creation phase of an element and are then later
             * applied once the element is instantiated. This function applies each of the static
             * style and class entries to the element.
             * @param {?} renderer
             * @param {?} native
             * @param {?} tNode
             * @return {?}
             */
            function renderInitialStyling(renderer, native, tNode) {
                renderStylingMap(renderer, native, tNode.classes, true);
                renderStylingMap(renderer, native, tNode.styles, false);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var unusedValueToPlacateAjd$1 = unusedValueExportToPlacateAjd$1 + unusedValueExportToPlacateAjd$4 + unusedValueExportToPlacateAjd$5 + unusedValueExportToPlacateAjd$3 + unusedValueExportToPlacateAjd;
            /**
             * @param {?} tNode
             * @param {?} embeddedView
             * @return {?}
             */
            function getLContainer(tNode, embeddedView) {
                ngDevMode && assertLView(embeddedView);
                /** @type {?} */
                var container = ( /** @type {?} */(embeddedView[PARENT]));
                if (tNode.index === -1) {
                    // This is a dynamically created view inside a dynamic container.
                    // The parent isn't an LContainer if the embedded view hasn't been attached yet.
                    return isLContainer(container) ? container : null;
                }
                else {
                    ngDevMode && assertLContainer(container);
                    // This is a inline view node (e.g. embeddedViewStart)
                    return container;
                }
            }
            /**
             * Retrieves render parent for a given view.
             * Might be null if a view is not yet attached to any container.
             * @param {?} tViewNode
             * @param {?} view
             * @return {?}
             */
            function getContainerRenderParent(tViewNode, view) {
                /** @type {?} */
                var container = getLContainer(tViewNode, view);
                return container ? nativeParentNode(view[RENDERER], container[NATIVE]) : null;
            }
            /** @enum {number} */
            var WalkTNodeTreeAction = {
                /** node insert in the native environment */
                Insert: 0,
                /** node detach from the native environment */
                Detach: 1,
                /** node destruction using the renderer's API */
                Destroy: 2,
            };
            /**
             * NOTE: for performance reasons, the possible actions are inlined within the function instead of
             * being passed as an argument.
             * @param {?} action
             * @param {?} renderer
             * @param {?} parent
             * @param {?} lNodeToHandle
             * @param {?=} beforeNode
             * @return {?}
             */
            function executeActionOnElementOrContainer(action, renderer, parent, lNodeToHandle, beforeNode) {
                // If this slot was allocated for a text node dynamically created by i18n, the text node itself
                // won't be created until i18nApply() in the update block, so this node should be skipped.
                // For more info, see "ICU expressions should work inside an ngTemplateOutlet inside an ngFor"
                // in `i18n_spec.ts`.
                if (lNodeToHandle != null) {
                    /** @type {?} */
                    var lContainer = void 0;
                    /** @type {?} */
                    var isComponent_1 = false;
                    // We are expecting an RNode, but in the case of a component or LContainer the `RNode` is
                    // wrapped
                    // in an array which needs to be unwrapped. We need to know if it is a component and if
                    // it has LContainer so that we can process all of those cases appropriately.
                    if (isLContainer(lNodeToHandle)) {
                        lContainer = lNodeToHandle;
                    }
                    else if (isLView(lNodeToHandle)) {
                        isComponent_1 = true;
                        ngDevMode && assertDefined(lNodeToHandle[HOST], 'HOST must be defined for a component LView');
                        lNodeToHandle = ( /** @type {?} */(lNodeToHandle[HOST]));
                    }
                    /** @type {?} */
                    var rNode = unwrapRNode(lNodeToHandle);
                    ngDevMode && assertDomNode(rNode);
                    if (action === 0 /* Insert */) {
                        nativeInsertBefore(renderer, ( /** @type {?} */(parent)), rNode, beforeNode || null);
                    }
                    else if (action === 1 /* Detach */) {
                        nativeRemoveNode(renderer, rNode, isComponent_1);
                    }
                    else if (action === 2 /* Destroy */) {
                        ngDevMode && ngDevMode.rendererDestroyNode++;
                        ( /** @type {?} */((( /** @type {?} */(renderer))).destroyNode))(rNode);
                    }
                    if (lContainer != null) {
                        executeActionOnContainer(renderer, action, lContainer, parent, beforeNode);
                    }
                }
            }
            /**
             * @param {?} value
             * @param {?} renderer
             * @return {?}
             */
            function createTextNode(value, renderer) {
                return isProceduralRenderer(renderer) ? renderer.createText(renderStringify(value)) :
                    renderer.createTextNode(renderStringify(value));
            }
            /**
             * @param {?} lView
             * @param {?} insertMode
             * @param {?=} beforeNode
             * @return {?}
             */
            function addRemoveViewFromContainer(lView, insertMode, beforeNode) {
                /** @type {?} */
                var renderParent = getContainerRenderParent(( /** @type {?} */(lView[TVIEW].node)), lView);
                ngDevMode && assertNodeType(( /** @type {?} */(lView[TVIEW].node)), 2 /* View */);
                if (renderParent) {
                    /** @type {?} */
                    var renderer = lView[RENDERER];
                    /** @type {?} */
                    var action = insertMode ? 0 /* Insert */ : 1 /* Detach */;
                    executeActionOnView(renderer, action, lView, renderParent, beforeNode);
                }
            }
            /**
             * Detach a `LView` from the DOM by detaching its nodes.
             *
             * @param {?} lView the `LView` to be detached.
             * @return {?}
             */
            function renderDetachView(lView) {
                executeActionOnView(lView[RENDERER], 1 /* Detach */, lView, null, null);
            }
            /**
             * Traverses down and up the tree of views and containers to remove listeners and
             * call onDestroy callbacks.
             *
             * Notes:
             *  - Because it's used for onDestroy calls, it needs to be bottom-up.
             *  - Must process containers instead of their views to avoid splicing
             *  when views are destroyed and re-added.
             *  - Using a while loop because it's faster than recursion
             *  - Destroy only called on movement to sibling or movement to parent (laterally or up)
             *
             * @param {?} rootView The view to destroy
             * @return {?}
             */
            function destroyViewTree(rootView) {
                // If the view has no children, we can clean it up and return early.
                /** @type {?} */
                var lViewOrLContainer = rootView[CHILD_HEAD];
                if (!lViewOrLContainer) {
                    return cleanUpView(rootView);
                }
                while (lViewOrLContainer) {
                    /** @type {?} */
                    var next = null;
                    if (isLView(lViewOrLContainer)) {
                        // If LView, traverse down to child.
                        next = lViewOrLContainer[CHILD_HEAD];
                    }
                    else {
                        ngDevMode && assertLContainer(lViewOrLContainer);
                        // If container, traverse down to its first LView.
                        /** @type {?} */
                        var firstView = lViewOrLContainer[CONTAINER_HEADER_OFFSET];
                        if (firstView)
                            next = firstView;
                    }
                    if (!next) {
                        // Only clean up view when moving to the side or up, as destroy hooks
                        // should be called in order from the bottom up.
                        while (lViewOrLContainer && !( /** @type {?} */(lViewOrLContainer))[NEXT] && lViewOrLContainer !== rootView) {
                            cleanUpView(lViewOrLContainer);
                            lViewOrLContainer = getParentState(lViewOrLContainer, rootView);
                        }
                        cleanUpView(lViewOrLContainer || rootView);
                        next = lViewOrLContainer && ( /** @type {?} */(lViewOrLContainer))[NEXT];
                    }
                    lViewOrLContainer = next;
                }
            }
            /**
             * Inserts a view into a container.
             *
             * This adds the view to the container's array of active views in the correct
             * position. It also adds the view's elements to the DOM if the container isn't a
             * root node of another view (in that case, the view's elements will be added when
             * the container's parent view is added later).
             *
             * @param {?} lView The view to insert
             * @param {?} lContainer The container into which the view should be inserted
             * @param {?} index Which index in the container to insert the child view into
             * @return {?}
             */
            function insertView(lView, lContainer, index) {
                ngDevMode && assertLView(lView);
                ngDevMode && assertLContainer(lContainer);
                /** @type {?} */
                var indexInContainer = CONTAINER_HEADER_OFFSET + index;
                /** @type {?} */
                var containerLength = lContainer.length;
                if (index > 0) {
                    // This is a new view, we need to add it to the children.
                    lContainer[indexInContainer - 1][NEXT] = lView;
                }
                if (index < containerLength - CONTAINER_HEADER_OFFSET) {
                    lView[NEXT] = lContainer[indexInContainer];
                    addToArray(lContainer, CONTAINER_HEADER_OFFSET + index, lView);
                }
                else {
                    lContainer.push(lView);
                    lView[NEXT] = null;
                }
                lView[PARENT] = lContainer;
                // track views where declaration and insertion points are different
                /** @type {?} */
                var declarationLContainer = lView[DECLARATION_LCONTAINER];
                if (declarationLContainer !== null && lContainer !== declarationLContainer) {
                    trackMovedView(declarationLContainer, lView);
                }
                // notify query that a new view has been added
                /** @type {?} */
                var lQueries = lView[QUERIES];
                if (lQueries !== null) {
                    lQueries.insertView(lView[TVIEW]);
                }
                // Sets the attached flag
                lView[FLAGS] |= 128 /* Attached */;
            }
            /**
             * Track views created from the declaration container (TemplateRef) and inserted into a
             * different LContainer.
             * @param {?} declarationContainer
             * @param {?} lView
             * @return {?}
             */
            function trackMovedView(declarationContainer, lView) {
                ngDevMode && assertLContainer(declarationContainer);
                /** @type {?} */
                var declaredViews = declarationContainer[MOVED_VIEWS];
                if (declaredViews === null) {
                    declarationContainer[MOVED_VIEWS] = [lView];
                }
                else {
                    declaredViews.push(lView);
                }
            }
            /**
             * @param {?} declarationContainer
             * @param {?} lView
             * @return {?}
             */
            function detachMovedView(declarationContainer, lView) {
                ngDevMode && assertLContainer(declarationContainer);
                ngDevMode && assertDefined(declarationContainer[MOVED_VIEWS], 'A projected view should belong to a non-empty projected views collection');
                /** @type {?} */
                var projectedViews = ( /** @type {?} */(declarationContainer[MOVED_VIEWS]));
                /** @type {?} */
                var declaredViewIndex = projectedViews.indexOf(lView);
                projectedViews.splice(declaredViewIndex, 1);
            }
            /**
             * Detaches a view from a container.
             *
             * This method removes the view from the container's array of active views. It also
             * removes the view's elements from the DOM.
             *
             * @param {?} lContainer The container from which to detach a view
             * @param {?} removeIndex The index of the view to detach
             * @return {?} Detached LView instance.
             */
            function detachView(lContainer, removeIndex) {
                if (lContainer.length <= CONTAINER_HEADER_OFFSET)
                    return;
                /** @type {?} */
                var indexInContainer = CONTAINER_HEADER_OFFSET + removeIndex;
                /** @type {?} */
                var viewToDetach = lContainer[indexInContainer];
                if (viewToDetach) {
                    /** @type {?} */
                    var declarationLContainer = viewToDetach[DECLARATION_LCONTAINER];
                    if (declarationLContainer !== null && declarationLContainer !== lContainer) {
                        detachMovedView(declarationLContainer, viewToDetach);
                    }
                    if (removeIndex > 0) {
                        lContainer[indexInContainer - 1][NEXT] = ( /** @type {?} */(viewToDetach[NEXT]));
                    }
                    /** @type {?} */
                    var removedLView = removeFromArray(lContainer, CONTAINER_HEADER_OFFSET + removeIndex);
                    addRemoveViewFromContainer(viewToDetach, false);
                    // notify query that a view has been removed
                    /** @type {?} */
                    var lQueries = removedLView[QUERIES];
                    if (lQueries !== null) {
                        lQueries.detachView(removedLView[TVIEW]);
                    }
                    viewToDetach[PARENT] = null;
                    viewToDetach[NEXT] = null;
                    // Unsets the attached flag
                    viewToDetach[FLAGS] &= ~128 /* Attached */;
                }
                return viewToDetach;
            }
            /**
             * Removes a view from a container, i.e. detaches it and then destroys the underlying LView.
             *
             * @param {?} lContainer The container from which to remove a view
             * @param {?} removeIndex The index of the view to remove
             * @return {?}
             */
            function removeView(lContainer, removeIndex) {
                /** @type {?} */
                var detachedView = detachView(lContainer, removeIndex);
                detachedView && destroyLView(detachedView);
            }
            /**
             * A standalone function which destroys an LView,
             * conducting cleanup (e.g. removing listeners, calling onDestroys).
             *
             * @param {?} lView The view to be destroyed.
             * @return {?}
             */
            function destroyLView(lView) {
                if (!(lView[FLAGS] & 256 /* Destroyed */)) {
                    /** @type {?} */
                    var renderer = lView[RENDERER];
                    if (isProceduralRenderer(renderer) && renderer.destroyNode) {
                        executeActionOnView(renderer, 2 /* Destroy */, lView, null, null);
                    }
                    destroyViewTree(lView);
                }
            }
            /**
             * Determines which LViewOrLContainer to jump to when traversing back up the
             * tree in destroyViewTree.
             *
             * Normally, the view's parent LView should be checked, but in the case of
             * embedded views, the container (which is the view node's parent, but not the
             * LView's parent) needs to be checked for a possible next property.
             *
             * @param {?} lViewOrLContainer The LViewOrLContainer for which we need a parent state
             * @param {?} rootView The rootView, so we don't propagate too far up the view tree
             * @return {?} The correct parent LViewOrLContainer
             */
            function getParentState(lViewOrLContainer, rootView) {
                /** @type {?} */
                var tNode;
                if (isLView(lViewOrLContainer) && (tNode = lViewOrLContainer[T_HOST]) &&
                    tNode.type === 2 /* View */) {
                    // if it's an embedded view, the state needs to go up to the container, in case the
                    // container has a next
                    return getLContainer(( /** @type {?} */(tNode)), lViewOrLContainer);
                }
                else {
                    // otherwise, use parent view for containers or component views
                    return lViewOrLContainer[PARENT] === rootView ? null : lViewOrLContainer[PARENT];
                }
            }
            /**
             * Calls onDestroys hooks for all directives and pipes in a given view and then removes all
             * listeners. Listeners are removed as the last step so events delivered in the onDestroys hooks
             * can be propagated to \@Output listeners.
             *
             * @param {?} view The LView to clean up
             * @return {?}
             */
            function cleanUpView(view) {
                if (isLView(view) && !(view[FLAGS] & 256 /* Destroyed */)) {
                    // Usually the Attached flag is removed when the view is detached from its parent, however
                    // if it's a root view, the flag won't be unset hence why we're also removing on destroy.
                    view[FLAGS] &= ~128 /* Attached */;
                    // Mark the LView as destroyed *before* executing the onDestroy hooks. An onDestroy hook
                    // runs arbitrary user code, which could include its own `viewRef.destroy()` (or similar). If
                    // We don't flag the view as destroyed before the hooks, this could lead to an infinite loop.
                    // This also aligns with the ViewEngine behavior. It also means that the onDestroy hook is
                    // really more of an "afterDestroy" hook if you think about it.
                    view[FLAGS] |= 256 /* Destroyed */;
                    executeOnDestroys(view);
                    removeListeners(view);
                    /** @type {?} */
                    var hostTNode = view[T_HOST];
                    // For component views only, the local renderer is destroyed as clean up time.
                    if (hostTNode && hostTNode.type === 3 /* Element */ && isProceduralRenderer(view[RENDERER])) {
                        ngDevMode && ngDevMode.rendererDestroy++;
                        (( /** @type {?} */(view[RENDERER]))).destroy();
                    }
                    /** @type {?} */
                    var declarationContainer = view[DECLARATION_LCONTAINER];
                    // we are dealing with an embedded view that is still inserted into a container
                    if (declarationContainer !== null && isLContainer(view[PARENT])) {
                        // and this is a projected view
                        if (declarationContainer !== view[PARENT]) {
                            detachMovedView(declarationContainer, view);
                        }
                        // For embedded views still attached to a container: remove query result from this view.
                        /** @type {?} */
                        var lQueries = view[QUERIES];
                        if (lQueries !== null) {
                            lQueries.detachView(view[TVIEW]);
                        }
                    }
                }
            }
            /**
             * Removes listeners and unsubscribes from output subscriptions
             * @param {?} lView
             * @return {?}
             */
            function removeListeners(lView) {
                /** @type {?} */
                var tCleanup = lView[TVIEW].cleanup;
                if (tCleanup !== null) {
                    /** @type {?} */
                    var lCleanup = ( /** @type {?} */(lView[CLEANUP]));
                    for (var i = 0; i < tCleanup.length - 1; i += 2) {
                        if (typeof tCleanup[i] === 'string') {
                            // This is a native DOM listener
                            /** @type {?} */
                            var idxOrTargetGetter = tCleanup[i + 1];
                            /** @type {?} */
                            var target = typeof idxOrTargetGetter === 'function' ?
                                idxOrTargetGetter(lView) :
                                unwrapRNode(lView[idxOrTargetGetter]);
                            /** @type {?} */
                            var listener = lCleanup[tCleanup[i + 2]];
                            /** @type {?} */
                            var useCaptureOrSubIdx = tCleanup[i + 3];
                            if (typeof useCaptureOrSubIdx === 'boolean') {
                                // native DOM listener registered with Renderer3
                                target.removeEventListener(tCleanup[i], listener, useCaptureOrSubIdx);
                            }
                            else {
                                if (useCaptureOrSubIdx >= 0) {
                                    // unregister
                                    lCleanup[useCaptureOrSubIdx]();
                                }
                                else {
                                    // Subscription
                                    lCleanup[-useCaptureOrSubIdx].unsubscribe();
                                }
                            }
                            i += 2;
                        }
                        else {
                            // This is a cleanup function that is grouped with the index of its context
                            /** @type {?} */
                            var context = lCleanup[tCleanup[i + 1]];
                            tCleanup[i].call(context);
                        }
                    }
                    lView[CLEANUP] = null;
                }
            }
            /**
             * Calls onDestroy hooks for this view
             * @param {?} view
             * @return {?}
             */
            function executeOnDestroys(view) {
                /** @type {?} */
                var tView = view[TVIEW];
                /** @type {?} */
                var destroyHooks;
                if (tView != null && (destroyHooks = tView.destroyHooks) != null) {
                    for (var i = 0; i < destroyHooks.length; i += 2) {
                        /** @type {?} */
                        var context = view[( /** @type {?} */(destroyHooks[i]))];
                        // Only call the destroy hook if the context has been requested.
                        if (!(context instanceof NodeInjectorFactory)) {
                            (( /** @type {?} */(destroyHooks[i + 1]))).call(context);
                        }
                    }
                }
            }
            /**
             * Returns a native element if a node can be inserted into the given parent.
             *
             * There are two reasons why we may not be able to insert a element immediately.
             * - Projection: When creating a child content element of a component, we have to skip the
             *   insertion because the content of a component will be projected.
             *   `<component><content>delayed due to projection</content></component>`
             * - Parent container is disconnected: This can happen when we are inserting a view into
             *   parent container, which itself is disconnected. For example the parent container is part
             *   of a View which has not be inserted or is made for projection but has not been inserted
             *   into destination.
             * @param {?} tNode
             * @param {?} currentView
             * @return {?}
             */
            function getRenderParent(tNode, currentView) {
                // Nodes of the top-most view can be inserted eagerly.
                if (isRootView(currentView)) {
                    return nativeParentNode(currentView[RENDERER], getNativeByTNode(tNode, currentView));
                }
                // Skip over element and ICU containers as those are represented by a comment node and
                // can't be used as a render parent.
                /** @type {?} */
                var parent = getHighestElementOrICUContainer(tNode);
                /** @type {?} */
                var renderParent = parent.parent;
                // If the parent is null, then we are inserting across views: either into an embedded view or a
                // component view.
                if (renderParent == null) {
                    /** @type {?} */
                    var hostTNode = ( /** @type {?} */(currentView[T_HOST]));
                    if (hostTNode.type === 2 /* View */) {
                        // We are inserting a root element of an embedded view We might delay insertion of children
                        // for a given view if it is disconnected. This might happen for 2 main reasons:
                        // - view is not inserted into any container(view was created but not inserted yet)
                        // - view is inserted into a container but the container itself is not inserted into the DOM
                        // (container might be part of projection or child of a view that is not inserted yet).
                        // In other words we can insert children of a given view if this view was inserted into a
                        // container and the container itself has its render parent determined.
                        return getContainerRenderParent(( /** @type {?} */(hostTNode)), currentView);
                    }
                    else {
                        // We are inserting a root element of the component view into the component host element and
                        // it should always be eager.
                        return getHostNative(currentView);
                    }
                }
                else {
                    /** @type {?} */
                    var isIcuCase = parent && parent.type === 5 /* IcuContainer */;
                    // If the parent of this node is an ICU container, then it is represented by comment node and we
                    // need to use it as an anchor. If it is projected then its direct parent node is the renderer.
                    if (isIcuCase && parent.flags & 2 /* isProjected */) {
                        return ( /** @type {?} */(getNativeByTNode(parent, currentView).parentNode));
                    }
                    ngDevMode && assertNodeType(renderParent, 3 /* Element */);
                    if (renderParent.flags & 1 /* isComponent */ && !isIcuCase) {
                        /** @type {?} */
                        var tData = currentView[TVIEW].data;
                        /** @type {?} */
                        var tNode_1 = ( /** @type {?} */(tData[renderParent.index]));
                        /** @type {?} */
                        var encapsulation = (( /** @type {?} */(tData[tNode_1.directiveStart]))).encapsulation;
                        // We've got a parent which is an element in the current view. We just need to verify if the
                        // parent element is not a component. Component's content nodes are not inserted immediately
                        // because they will be projected, and so doing insert at this point would be wasteful.
                        // Since the projection would then move it to its final destination. Note that we can't
                        // make this assumption when using the Shadow DOM, because the native projection placeholders
                        // (<content> or <slot>) have to be in place as elements are being inserted.
                        if (encapsulation !== ViewEncapsulation.ShadowDom &&
                            encapsulation !== ViewEncapsulation.Native) {
                            return null;
                        }
                    }
                    return ( /** @type {?} */(getNativeByTNode(renderParent, currentView)));
                }
            }
            /**
             * Gets the native host element for a given view. Will return null if the current view does not have
             * a host element.
             * @param {?} currentView
             * @return {?}
             */
            function getHostNative(currentView) {
                ngDevMode && assertLView(currentView);
                /** @type {?} */
                var hostTNode = currentView[T_HOST];
                return hostTNode && hostTNode.type === 3 /* Element */ ?
                    (( /** @type {?} */(getNativeByTNode(hostTNode, ( /** @type {?} */(getLViewParent(currentView))))))) :
                    null;
            }
            /**
             * Inserts a native node before another native node for a given parent using {\@link Renderer3}.
             * This is a utility function that can be used when native nodes were determined - it abstracts an
             * actual renderer being used.
             * @param {?} renderer
             * @param {?} parent
             * @param {?} child
             * @param {?} beforeNode
             * @return {?}
             */
            function nativeInsertBefore(renderer, parent, child, beforeNode) {
                ngDevMode && ngDevMode.rendererInsertBefore++;
                if (isProceduralRenderer(renderer)) {
                    renderer.insertBefore(parent, child, beforeNode);
                }
                else {
                    parent.insertBefore(child, beforeNode, true);
                }
            }
            /**
             * @param {?} renderer
             * @param {?} parent
             * @param {?} child
             * @return {?}
             */
            function nativeAppendChild(renderer, parent, child) {
                ngDevMode && ngDevMode.rendererAppendChild++;
                if (isProceduralRenderer(renderer)) {
                    renderer.appendChild(parent, child);
                }
                else {
                    parent.appendChild(child);
                }
            }
            /**
             * @param {?} renderer
             * @param {?} parent
             * @param {?} child
             * @param {?} beforeNode
             * @return {?}
             */
            function nativeAppendOrInsertBefore(renderer, parent, child, beforeNode) {
                if (beforeNode !== null) {
                    nativeInsertBefore(renderer, parent, child, beforeNode);
                }
                else {
                    nativeAppendChild(renderer, parent, child);
                }
            }
            /**
             * Removes a node from the DOM given its native parent.
             * @param {?} renderer
             * @param {?} parent
             * @param {?} child
             * @param {?=} isHostElement
             * @return {?}
             */
            function nativeRemoveChild(renderer, parent, child, isHostElement) {
                if (isProceduralRenderer(renderer)) {
                    renderer.removeChild(parent, child, isHostElement);
                }
                else {
                    parent.removeChild(child);
                }
            }
            /**
             * Returns a native parent of a given native node.
             * @param {?} renderer
             * @param {?} node
             * @return {?}
             */
            function nativeParentNode(renderer, node) {
                return ( /** @type {?} */((isProceduralRenderer(renderer) ? renderer.parentNode(node) : node.parentNode)));
            }
            /**
             * Returns a native sibling of a given native node.
             * @param {?} renderer
             * @param {?} node
             * @return {?}
             */
            function nativeNextSibling(renderer, node) {
                return isProceduralRenderer(renderer) ? renderer.nextSibling(node) : node.nextSibling;
            }
            /**
             * Finds a native "anchor" node for cases where we can't append a native child directly
             * (`appendChild`) and need to use a reference (anchor) node for the `insertBefore` operation.
             * @param {?} parentTNode
             * @param {?} lView
             * @return {?}
             */
            function getNativeAnchorNode(parentTNode, lView) {
                if (parentTNode.type === 2 /* View */) {
                    /** @type {?} */
                    var lContainer = ( /** @type {?} */(getLContainer(( /** @type {?} */(parentTNode)), lView)));
                    /** @type {?} */
                    var index = lContainer.indexOf(lView, CONTAINER_HEADER_OFFSET) - CONTAINER_HEADER_OFFSET;
                    return getBeforeNodeForView(index, lContainer);
                }
                else if (parentTNode.type === 4 /* ElementContainer */ ||
                    parentTNode.type === 5 /* IcuContainer */) {
                    return getNativeByTNode(parentTNode, lView);
                }
                return null;
            }
            /**
             * Appends the `child` native node (or a collection of nodes) to the `parent`.
             *
             * The element insertion might be delayed {\@link canInsertNativeNode}.
             *
             * @param {?} childEl The native child (or children) that should be appended
             * @param {?} childTNode The TNode of the child element
             * @param {?} currentView The current LView
             * @return {?} Whether or not the child was appended
             */
            function appendChild(childEl, childTNode, currentView) {
                /** @type {?} */
                var renderParent = getRenderParent(childTNode, currentView);
                if (renderParent != null) {
                    /** @type {?} */
                    var renderer = currentView[RENDERER];
                    /** @type {?} */
                    var parentTNode = childTNode.parent || ( /** @type {?} */(currentView[T_HOST]));
                    /** @type {?} */
                    var anchorNode = getNativeAnchorNode(parentTNode, currentView);
                    if (Array.isArray(childEl)) {
                        for (var _c = 0, childEl_1 = childEl; _c < childEl_1.length; _c++) {
                            var nativeNode = childEl_1[_c];
                            nativeAppendOrInsertBefore(renderer, renderParent, nativeNode, anchorNode);
                        }
                    }
                    else {
                        nativeAppendOrInsertBefore(renderer, renderParent, childEl, anchorNode);
                    }
                }
            }
            /**
             * Gets the top-level element or an ICU container if those containers are nested.
             *
             * @param {?} tNode The starting TNode for which we should skip element and ICU containers
             * @return {?} The TNode of the highest level ICU container or element container
             */
            function getHighestElementOrICUContainer(tNode) {
                while (tNode.parent != null && (tNode.parent.type === 4 /* ElementContainer */ ||
                    tNode.parent.type === 5 /* IcuContainer */)) {
                    tNode = tNode.parent;
                }
                return tNode;
            }
            /**
             * @param {?} viewIndexInContainer
             * @param {?} lContainer
             * @return {?}
             */
            function getBeforeNodeForView(viewIndexInContainer, lContainer) {
                /** @type {?} */
                var nextViewIndex = CONTAINER_HEADER_OFFSET + viewIndexInContainer + 1;
                if (nextViewIndex < lContainer.length) {
                    /** @type {?} */
                    var lView_4 = ( /** @type {?} */(lContainer[nextViewIndex]));
                    ngDevMode && assertDefined(lView_4[T_HOST], 'Missing Host TNode');
                    /** @type {?} */
                    var tViewNodeChild = (( /** @type {?} */(lView_4[T_HOST]))).child;
                    return tViewNodeChild !== null ? getNativeByTNodeOrNull(tViewNodeChild, lView_4) :
                        lContainer[NATIVE];
                }
                else {
                    return lContainer[NATIVE];
                }
            }
            /**
             * Removes a native node itself using a given renderer. To remove the node we are looking up its
             * parent from the native tree as not all platforms / browsers support the equivalent of
             * node.remove().
             *
             * @param {?} renderer A renderer to be used
             * @param {?} rNode The native node that should be removed
             * @param {?=} isHostElement A flag indicating if a node to be removed is a host of a component.
             * @return {?}
             */
            function nativeRemoveNode(renderer, rNode, isHostElement) {
                /** @type {?} */
                var nativeParent = nativeParentNode(renderer, rNode);
                if (nativeParent) {
                    nativeRemoveChild(renderer, nativeParent, rNode, isHostElement);
                }
            }
            /**
             * Appends nodes to a target projection place. Nodes to insert were previously re-distribution and
             * stored on a component host level.
             * @param {?} lView A LView where nodes are inserted (target LView)
             * @param {?} tProjectionNode A projection node where previously re-distribution should be appended
             * (target insertion place)
             * @param {?} selectorIndex A bucket from where nodes to project should be taken
             * @param {?} componentView A where projectable nodes were initially created (source view)
             * @return {?}
             */
            function appendProjectedNodes(lView, tProjectionNode, selectorIndex, componentView) {
                /** @type {?} */
                var projectedView = ( /** @type {?} */(( /** @type {?} */(componentView[PARENT]))));
                /** @type {?} */
                var componentNode = ( /** @type {?} */(componentView[T_HOST]));
                /** @type {?} */
                var nodeToProject = (( /** @type {?} */(componentNode.projection)))[selectorIndex];
                if (Array.isArray(nodeToProject)) {
                    appendChild(nodeToProject, tProjectionNode, lView);
                }
                else {
                    while (nodeToProject) {
                        if (!(nodeToProject.flags & 32 /* isDetached */)) {
                            if (nodeToProject.type === 1 /* Projection */) {
                                appendProjectedNodes(lView, tProjectionNode, (( /** @type {?} */(nodeToProject))).projection, findComponentView(projectedView));
                            }
                            else {
                                // This flag must be set now or we won't know that this node is projected
                                // if the nodes are inserted into a container later.
                                nodeToProject.flags |= 2 /* isProjected */;
                                appendProjectedNode(nodeToProject, tProjectionNode, lView, projectedView);
                            }
                        }
                        nodeToProject = nodeToProject.projectionNext;
                    }
                }
            }
            /**
             * Loops over all children of a TNode container and appends them to the DOM
             *
             * @param {?} ngContainerChildTNode The first child of the TNode container
             * @param {?} tProjectionNode The projection (ng-content) TNode
             * @param {?} currentView Current LView
             * @param {?} projectionView Projection view (view above current)
             * @return {?}
             */
            function appendProjectedChildren(ngContainerChildTNode, tProjectionNode, currentView, projectionView) {
                while (ngContainerChildTNode) {
                    appendProjectedNode(ngContainerChildTNode, tProjectionNode, currentView, projectionView);
                    ngContainerChildTNode = ngContainerChildTNode.next;
                }
            }
            /**
             * Appends a projected node to the DOM, or in the case of a projected container,
             * appends the nodes from all of the container's active views to the DOM.
             *
             * @param {?} projectedTNode The TNode to be projected
             * @param {?} tProjectionNode The projection (ng-content) TNode
             * @param {?} currentView Current LView
             * @param {?} projectionView Projection view (view above current)
             * @return {?}
             */
            function appendProjectedNode(projectedTNode, tProjectionNode, currentView, projectionView) {
                /** @type {?} */
                var native = getNativeByTNode(projectedTNode, projectionView);
                appendChild(native, tProjectionNode, currentView);
                // the projected contents are processed while in the shadow view (which is the currentView)
                // therefore we need to extract the view where the host element lives since it's the
                // logical container of the content projected views
                attachPatchData(native, projectionView);
                /** @type {?} */
                var nodeOrContainer = projectionView[projectedTNode.index];
                if (projectedTNode.type === 0 /* Container */) {
                    // The node we are adding is a container and we are adding it to an element which
                    // is not a component (no more re-projection).
                    // Alternatively a container is projected at the root of a component's template
                    // and can't be re-projected (as not content of any component).
                    // Assign the final projection location in those cases.
                    for (var i = CONTAINER_HEADER_OFFSET; i < nodeOrContainer.length; i++) {
                        addRemoveViewFromContainer(nodeOrContainer[i], true, nodeOrContainer[NATIVE]);
                    }
                }
                else if (projectedTNode.type === 5 /* IcuContainer */) {
                    // The node we are adding is an ICU container which is why we also need to project all the
                    // children nodes that might have been created previously and are linked to this anchor
                    /** @type {?} */
                    var ngContainerChildTNode = ( /** @type {?} */(projectedTNode.child));
                    appendProjectedChildren(ngContainerChildTNode, ngContainerChildTNode, projectionView, projectionView);
                }
                else {
                    if (projectedTNode.type === 4 /* ElementContainer */) {
                        appendProjectedChildren(projectedTNode.child, tProjectionNode, currentView, projectionView);
                    }
                    if (isLContainer(nodeOrContainer)) {
                        appendChild(nodeOrContainer[NATIVE], tProjectionNode, currentView);
                    }
                }
            }
            /**
             * `executeActionOnView` performs an operation on the view as specified in `action` (insert, detach,
             * destroy)
             *
             * Inserting a view without projection or containers at top level is simple. Just iterate over the
             * root nodes of the View, and for each node perform the `action`.
             *
             * Things get more complicated with containers and projections. That is because coming across:
             * - Container: implies that we have to insert/remove/destroy the views of that container as well
             *              which in turn can have their own Containers at the View roots.
             * - Projection: implies that we have to insert/remove/destroy the nodes of the projection. The
             *               complication is that the nodes we are projecting can themselves have Containers
             *               or other Projections.
             *
             * As you can see this is a very recursive problem. While the recursive implementation is not the
             * most efficient one, trying to unroll the nodes non-recursively results in very complex code that
             * is very hard (to maintain). We are sacrificing a bit of performance for readability using a
             * recursive implementation.
             *
             * @param {?} renderer Renderer to use
             * @param {?} action action to perform (insert, detach, destroy)
             * @param {?} lView The LView which needs to be inserted, detached, destroyed.
             * @param {?} renderParent parent DOM element for insertion/removal.
             * @param {?} beforeNode Before which node the insertions should happen.
             * @return {?}
             */
            function executeActionOnView(renderer, action, lView, renderParent, beforeNode) {
                /** @type {?} */
                var tView = lView[TVIEW];
                ngDevMode && assertNodeType(( /** @type {?} */(tView.node)), 2 /* View */);
                /** @type {?} */
                var viewRootTNode = ( /** @type {?} */(tView.node)).child;
                while (viewRootTNode !== null) {
                    executeActionOnNode(renderer, action, lView, viewRootTNode, renderParent, beforeNode);
                    viewRootTNode = viewRootTNode.next;
                }
            }
            /**
             * `executeActionOnProjection` performs an operation on the projection specified by `action`
             * (insert, detach, destroy).
             *
             * Inserting a projection requires us to locate the projected nodes from the parent component. The
             * complication is that those nodes themselves could be re-projected from their parent component.
             *
             * @param {?} renderer Renderer to use
             * @param {?} action action to perform (insert, detach, destroy)
             * @param {?} lView The LView which needs to be inserted, detached, destroyed.
             * @param {?} tProjectionNode projection TNode to process
             * @param {?} renderParent parent DOM element for insertion/removal.
             * @param {?} beforeNode Before which node the insertions should happen.
             * @return {?}
             */
            function executeActionOnProjection(renderer, action, lView, tProjectionNode, renderParent, beforeNode) {
                /** @type {?} */
                var componentLView = findComponentView(lView);
                /** @type {?} */
                var componentNode = ( /** @type {?} */(componentLView[T_HOST]));
                ngDevMode && assertDefined(componentNode.projection, 'Element nodes for which projection is processed must have projection defined.');
                /** @type {?} */
                var nodeToProject = ( /** @type {?} */(componentNode.projection))[tProjectionNode.projection];
                if (nodeToProject !== undefined) {
                    if (Array.isArray(nodeToProject)) {
                        for (var i = 0; i < nodeToProject.length; i++) {
                            /** @type {?} */
                            var rNode = nodeToProject[i];
                            ngDevMode && assertDomNode(rNode);
                            executeActionOnElementOrContainer(action, renderer, renderParent, rNode, beforeNode);
                        }
                    }
                    else {
                        /** @type {?} */
                        var projectionTNode = nodeToProject;
                        /** @type {?} */
                        var projectedComponentLView = ( /** @type {?} */(componentLView[PARENT]));
                        while (projectionTNode !== null) {
                            executeActionOnNode(renderer, action, projectedComponentLView, projectionTNode, renderParent, beforeNode);
                            projectionTNode = projectionTNode.projectionNext;
                        }
                    }
                }
            }
            /**
             * `executeActionOnContainer` performs an operation on the container and its views as specified by
             * `action` (insert, detach, destroy)
             *
             * Inserting a Container is complicated by the fact that the container may have Views which
             * themselves have containers or projections.
             *
             * @param {?} renderer Renderer to use
             * @param {?} action action to perform (insert, detach, destroy)
             * @param {?} lContainer The LContainer which needs to be inserted, detached, destroyed.
             * @param {?} renderParent parent DOM element for insertion/removal.
             * @param {?} beforeNode Before which node the insertions should happen.
             * @return {?}
             */
            function executeActionOnContainer(renderer, action, lContainer, renderParent, beforeNode) {
                ngDevMode && assertLContainer(lContainer);
                /** @type {?} */
                var anchor = lContainer[NATIVE];
                // LContainer has its own before node.
                /** @type {?} */
                var native = unwrapRNode(lContainer);
                // An LContainer can be created dynamically on any node by injecting ViewContainerRef.
                // Asking for a ViewContainerRef on an element will result in a creation of a separate anchor node
                // (comment in the DOM) that will be different from the LContainer's host node. In this particular
                // case we need to execute action on 2 nodes:
                // - container's host node (this is done in the executeNodeAction)
                // - container's host node (this is done here)
                if (anchor !== native) {
                    executeActionOnElementOrContainer(action, renderer, renderParent, anchor, beforeNode);
                }
                for (var i = CONTAINER_HEADER_OFFSET; i < lContainer.length; i++) {
                    /** @type {?} */
                    var lView_5 = ( /** @type {?} */(lContainer[i]));
                    executeActionOnView(renderer, action, lView_5, renderParent, anchor);
                }
            }
            /**
             * `executeActionOnElementContainerOrIcuContainer` performs an operation on the ng-container node
             * and its child nodes as specified by the `action` (insert, detach, destroy).
             *
             * @param {?} renderer Renderer to use
             * @param {?} action action to perform (insert, detach, destroy)
             * @param {?} lView The LView which needs to be inserted, detached, destroyed.
             * @param {?} tNode The TNode associated with the `ElementContainer` or `IcuContainer`.
             * @param {?} renderParent parent DOM element for insertion/removal.
             * @param {?} beforeNode Before which node the insertions should happen.
             * @return {?}
             */
            function executeActionOnElementContainerOrIcuContainer(renderer, action, lView, tNode, renderParent, beforeNode) {
                /** @type {?} */
                var node = lView[tNode.index];
                executeActionOnElementOrContainer(action, renderer, renderParent, node, beforeNode);
                /** @type {?} */
                var childTNode = tNode.child;
                while (childTNode) {
                    executeActionOnNode(renderer, action, lView, childTNode, renderParent, beforeNode);
                    childTNode = childTNode.next;
                }
            }
            /**
             * @param {?} renderer
             * @param {?} action
             * @param {?} lView
             * @param {?} tNode
             * @param {?} renderParent
             * @param {?} beforeNode
             * @return {?}
             */
            function executeActionOnNode(renderer, action, lView, tNode, renderParent, beforeNode) {
                /** @type {?} */
                var nodeType = tNode.type;
                if (!(tNode.flags & 32 /* isDetached */)) {
                    if (nodeType === 4 /* ElementContainer */ || nodeType === 5 /* IcuContainer */) {
                        executeActionOnElementContainerOrIcuContainer(renderer, action, lView, ( /** @type {?} */(tNode)), renderParent, beforeNode);
                    }
                    else if (nodeType === 1 /* Projection */) {
                        executeActionOnProjection(renderer, action, lView, ( /** @type {?} */(tNode)), renderParent, beforeNode);
                    }
                    else {
                        ngDevMode && assertNodeOfPossibleTypes(tNode, 3 /* Element */, 0 /* Container */);
                        executeActionOnElementOrContainer(action, renderer, renderParent, lView[tNode.index], beforeNode);
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Unwraps a parent injector location number to find the view offset from the current injector,
             * then walks up the declaration view tree until the TNode of the parent injector is found.
             *
             * @param {?} location The location of the parent injector, which contains the view offset
             * @param {?} startView The LView instance from which to start walking up the view tree
             * @param {?} startTNode The TNode instance of the starting element
             * @return {?} The TNode of the parent injector
             */
            function getParentInjectorTNode(location, startView, startTNode) {
                if (startTNode.parent && startTNode.parent.injectorIndex !== -1) {
                    // view offset is 0
                    /** @type {?} */
                    var injectorIndex = startTNode.parent.injectorIndex;
                    /** @type {?} */
                    var parentTNode_1 = startTNode.parent;
                    while (parentTNode_1.parent != null && injectorIndex == parentTNode_1.injectorIndex) {
                        parentTNode_1 = parentTNode_1.parent;
                    }
                    return parentTNode_1;
                }
                /** @type {?} */
                var viewOffset = getParentInjectorViewOffset(location);
                // view offset is 1
                /** @type {?} */
                var parentView = startView;
                /** @type {?} */
                var parentTNode = ( /** @type {?} */(startView[T_HOST]));
                // view offset is superior to 1
                while (viewOffset > 1) {
                    parentView = ( /** @type {?} */(parentView[DECLARATION_VIEW]));
                    parentTNode = ( /** @type {?} */(parentView[T_HOST]));
                    viewOffset--;
                }
                return parentTNode;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function viewEngine_ChangeDetectorRef_interface() { }
            /**
             * @template T
             */
            var ViewRef = /** @class */ (function () {
                /**
                 * @param {?} _lView
                 * @param {?} _context
                 * @param {?} _componentIndex
                 */
                function ViewRef(_lView, _context, _componentIndex) {
                    this._context = _context;
                    this._componentIndex = _componentIndex;
                    this._appRef = null;
                    this._viewContainerRef = null;
                    /**
                     * \@internal
                     */
                    this._tViewNode = null;
                    this._lView = _lView;
                }
                Object.defineProperty(ViewRef.prototype, "rootNodes", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (this._lView[HOST] == null) {
                            /** @type {?} */
                            var tView = ( /** @type {?} */(this._lView[T_HOST]));
                            return collectNativeNodes(this._lView, tView, []);
                        }
                        return [];
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ViewRef.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._context ? this._context : this._lookUpContext(); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ViewRef.prototype, "destroyed", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return (this._lView[FLAGS] & 256 /* Destroyed */) === 256 /* Destroyed */;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ViewRef.prototype.destroy = function () {
                    if (this._appRef) {
                        this._appRef.detachView(this);
                    }
                    else if (this._viewContainerRef) {
                        /** @type {?} */
                        var index = this._viewContainerRef.indexOf(this);
                        if (index > -1) {
                            this._viewContainerRef.detach(index);
                        }
                        this._viewContainerRef = null;
                    }
                    destroyLView(this._lView);
                };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                ViewRef.prototype.onDestroy = function (callback) { storeCleanupFn(this._lView, callback); };
                /**
                 * Marks a view and all of its ancestors dirty.
                 *
                 * It also triggers change detection by calling `scheduleTick` internally, which coalesces
                 * multiple `markForCheck` calls to into one change detection run.
                 *
                 * This can be used to ensure an {\@link ChangeDetectionStrategy#OnPush OnPush} component is
                 * checked when it needs to be re-rendered but the two normal triggers haven't marked it
                 * dirty (i.e. inputs haven't changed and events haven't fired in the view).
                 *
                 * <!-- TODO: Add a link to a chapter on OnPush components -->
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * ```typescript
                 * \@Component({
                 *   selector: 'my-app',
                 *   template: `Number of ticks: {{numberOfTicks}}`
                 *   changeDetection: ChangeDetectionStrategy.OnPush,
                 * })
                 * class AppComponent {
                 *   numberOfTicks = 0;
                 *
                 *   constructor(private ref: ChangeDetectorRef) {
                 *     setInterval(() => {
                 *       this.numberOfTicks++;
                 *       // the following is required, otherwise the view will not be updated
                 *       this.ref.markForCheck();
                 *     }, 1000);
                 *   }
                 * }
                 * ```
                 * @return {?}
                 */
                ViewRef.prototype.markForCheck = function () { markViewDirty(this._lView); };
                /**
                 * Detaches the view from the change detection tree.
                 *
                 * Detached views will not be checked during change detection runs until they are
                 * re-attached, even if they are dirty. `detach` can be used in combination with
                 * {\@link ChangeDetectorRef#detectChanges detectChanges} to implement local change
                 * detection checks.
                 *
                 * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
                 * <!-- TODO: Add a live demo once ref.detectChanges is merged into master -->
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * The following example defines a component with a large list of readonly data.
                 * Imagine the data changes constantly, many times per second. For performance reasons,
                 * we want to check and update the list every five seconds. We can do that by detaching
                 * the component's change detector and doing a local check every five seconds.
                 *
                 * ```typescript
                 * class DataProvider {
                 *   // in a real application the returned data will be different every time
                 *   get data() {
                 *     return [1,2,3,4,5];
                 *   }
                 * }
                 *
                 * \@Component({
                 *   selector: 'giant-list',
                 *   template: `
                 *     <li *ngFor="let d of dataProvider.data">Data {{d}}</li>
                 *   `,
                 * })
                 * class GiantList {
                 *   constructor(private ref: ChangeDetectorRef, private dataProvider: DataProvider) {
                 *     ref.detach();
                 *     setInterval(() => {
                 *       this.ref.detectChanges();
                 *     }, 5000);
                 *   }
                 * }
                 *  /
                 *   selector: 'app',
                 *   providers: [DataProvider],
                 *   template: `
                 *     <giant-list><giant-list>
                 *   `,
                 * })
                 * class App {
                 * }
                 * ```
                 * @return {?}
                 */
                ViewRef.prototype.detach = function () { this._lView[FLAGS] &= ~128 /* Attached */; };
                /**
                 * Re-attaches a view to the change detection tree.
                 *
                 * This can be used to re-attach views that were previously detached from the tree
                 * using {\@link ChangeDetectorRef#detach detach}. Views are attached to the tree by default.
                 *
                 * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * The following example creates a component displaying `live` data. The component will detach
                 * its change detector from the main change detector tree when the component's live property
                 * is set to false.
                 *
                 * ```typescript
                 * class DataProvider {
                 *   data = 1;
                 *
                 *   constructor() {
                 *     setInterval(() => {
                 *       this.data = this.data * 2;
                 *     }, 500);
                 *   }
                 * }
                 *
                 * \@Component({
                 *   selector: 'live-data',
                 *   inputs: ['live'],
                 *   template: 'Data: {{dataProvider.data}}'
                 * })
                 * class LiveData {
                 *   constructor(private ref: ChangeDetectorRef, private dataProvider: DataProvider) {}
                 *
                 *   set live(value) {
                 *     if (value) {
                 *       this.ref.reattach();
                 *     } else {
                 *       this.ref.detach();
                 *     }
                 *   }
                 * }
                 *  /
                 *   selector: 'my-app',
                 *   providers: [DataProvider],
                 *   template: `
                 *     Live Update: <input type="checkbox" [(ngModel)]="live">
                 *     <live-data [live]="live"><live-data>
                 *   `,
                 * })
                 * class AppComponent {
                 *   live = true;
                 * }
                 * ```
                 * @return {?}
                 */
                ViewRef.prototype.reattach = function () { this._lView[FLAGS] |= 128 /* Attached */; };
                /**
                 * Checks the view and its children.
                 *
                 * This can also be used in combination with {\@link ChangeDetectorRef#detach detach} to implement
                 * local change detection checks.
                 *
                 * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
                 * <!-- TODO: Add a live demo once ref.detectChanges is merged into master -->
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * The following example defines a component with a large list of readonly data.
                 * Imagine, the data changes constantly, many times per second. For performance reasons,
                 * we want to check and update the list every five seconds.
                 *
                 * We can do that by detaching the component's change detector and doing a local change detection
                 * check every five seconds.
                 *
                 * See {\@link ChangeDetectorRef#detach detach} for more information.
                 * @return {?}
                 */
                ViewRef.prototype.detectChanges = function () { detectChangesInternal(this._lView, this.context); };
                /**
                 * Checks the change detector and its children, and throws if any changes are detected.
                 *
                 * This is used in development mode to verify that running change detection doesn't
                 * introduce other changes.
                 * @return {?}
                 */
                ViewRef.prototype.checkNoChanges = function () { checkNoChangesInternal(this._lView, this.context); };
                /**
                 * @param {?} vcRef
                 * @return {?}
                 */
                ViewRef.prototype.attachToViewContainerRef = function (vcRef) {
                    if (this._appRef) {
                        throw new Error('This view is already attached directly to the ApplicationRef!');
                    }
                    this._viewContainerRef = vcRef;
                };
                /**
                 * @return {?}
                 */
                ViewRef.prototype.detachFromAppRef = function () {
                    this._appRef = null;
                    renderDetachView(this._lView);
                };
                /**
                 * @param {?} appRef
                 * @return {?}
                 */
                ViewRef.prototype.attachToAppRef = function (appRef) {
                    if (this._viewContainerRef) {
                        throw new Error('This view is already attached to a ViewContainer!');
                    }
                    this._appRef = appRef;
                };
                /**
                 * @private
                 * @return {?}
                 */
                ViewRef.prototype._lookUpContext = function () {
                    return this._context = ( /** @type {?} */(( /** @type {?} */(getLViewParent(this._lView)))[this._componentIndex]));
                };
                return ViewRef;
            }());
            if (false) { }
            /**
             * \@internal
             * @template T
             */
            var RootViewRef = /** @class */ (function (_super_1) {
                __extends(RootViewRef, _super_1);
                /**
                 * @param {?} _view
                 */
                function RootViewRef(_view) {
                    var _this = _super_1.call(this, _view, null, -1) || this;
                    _this._view = _view;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                RootViewRef.prototype.detectChanges = function () { detectChangesInRootView(this._view); };
                /**
                 * @return {?}
                 */
                RootViewRef.prototype.checkNoChanges = function () { checkNoChangesInRootView(this._view); };
                Object.defineProperty(RootViewRef.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(null)); },
                    enumerable: true,
                    configurable: true
                });
                return RootViewRef;
            }(ViewRef));
            if (false) { }
            /**
             * @param {?} lView
             * @param {?} parentTNode
             * @param {?} result
             * @return {?}
             */
            function collectNativeNodes(lView, parentTNode, result) {
                /** @type {?} */
                var tNodeChild = parentTNode.child;
                while (tNodeChild) {
                    /** @type {?} */
                    var nativeNode = getNativeByTNodeOrNull(tNodeChild, lView);
                    nativeNode && result.push(nativeNode);
                    if (tNodeChild.type === 4 /* ElementContainer */) {
                        collectNativeNodes(lView, tNodeChild, result);
                    }
                    else if (tNodeChild.type === 1 /* Projection */) {
                        /** @type {?} */
                        var componentView = findComponentView(lView);
                        /** @type {?} */
                        var componentHost = ( /** @type {?} */(componentView[T_HOST]));
                        /** @type {?} */
                        var parentView = getLViewParent(componentView);
                        /** @type {?} */
                        var currentProjectedNode = (( /** @type {?} */(componentHost.projection)))[( /** @type {?} */(tNodeChild.projection))];
                        while (currentProjectedNode && parentView) {
                            result.push(getNativeByTNode(currentProjectedNode, parentView));
                            currentProjectedNode = currentProjectedNode.next;
                        }
                    }
                    tNodeChild = tNodeChild.next;
                }
                return result;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Creates an ElementRef from the most recent node.
             *
             * @param {?} ElementRefToken
             * @return {?} The ElementRef instance to use
             */
            function injectElementRef(ElementRefToken) {
                return createElementRef(ElementRefToken, getPreviousOrParentTNode(), getLView());
            }
            /** @type {?} */
            var R3ElementRef;
            /**
             * Creates an ElementRef given a node.
             *
             * @param {?} ElementRefToken The ElementRef type
             * @param {?} tNode The node for which you'd like an ElementRef
             * @param {?} view The view to which the node belongs
             * @return {?} The ElementRef instance to use
             */
            function createElementRef(ElementRefToken, tNode, view) {
                if (!R3ElementRef) {
                    // TODO: Fix class name, should be ElementRef, but there appears to be a rollup bug
                    R3ElementRef = /** @class */ (function (_super_1) {
                        __extends(ElementRef_, _super_1);
                        function ElementRef_() {
                            return _super_1 !== null && _super_1.apply(this, arguments) || this;
                        }
                        return ElementRef_;
                    }(ElementRefToken));
                }
                return new R3ElementRef(( /** @type {?} */(getNativeByTNode(tNode, view))));
            }
            /** @type {?} */
            var R3TemplateRef;
            /**
             * Creates a TemplateRef given a node.
             *
             * @template T
             * @param {?} TemplateRefToken
             * @param {?} ElementRefToken
             * @return {?} The TemplateRef instance to use
             */
            function injectTemplateRef(TemplateRefToken, ElementRefToken) {
                return createTemplateRef(TemplateRefToken, ElementRefToken, getPreviousOrParentTNode(), getLView());
            }
            /**
             * Creates a TemplateRef and stores it on the injector.
             *
             * @template T
             * @param {?} TemplateRefToken The TemplateRef type
             * @param {?} ElementRefToken The ElementRef type
             * @param {?} hostTNode The node on which a TemplateRef is requested
             * @param {?} hostView The view to which the node belongs
             * @return {?} The TemplateRef instance or null if we can't create a TemplateRef on a given node type
             */
            function createTemplateRef(TemplateRefToken, ElementRefToken, hostTNode, hostView) {
                if (!R3TemplateRef) {
                    // TODO: Fix class name, should be TemplateRef, but there appears to be a rollup bug
                    R3TemplateRef = /** @class */ (function (_super_1) {
                        __extends(TemplateRef_, _super_1);
                        /**
                         * @param {?} _declarationView
                         * @param {?} _declarationTContainer
                         * @param {?} elementRef
                         */
                        function TemplateRef_(_declarationView, _declarationTContainer, elementRef) {
                            var _this = _super_1.call(this) || this;
                            _this._declarationView = _declarationView;
                            _this._declarationTContainer = _declarationTContainer;
                            _this.elementRef = elementRef;
                            return _this;
                        }
                        /**
                         * @param {?} context
                         * @return {?}
                         */
                        TemplateRef_.prototype.createEmbeddedView = function (context) {
                            /** @type {?} */
                            var embeddedTView = ( /** @type {?} */(this._declarationTContainer.tViews));
                            /** @type {?} */
                            var lView = createEmbeddedViewAndNode(embeddedTView, context, this._declarationView, this._declarationTContainer.injectorIndex);
                            /** @type {?} */
                            var declarationLContainer = this._declarationView[this._declarationTContainer.index];
                            ngDevMode && assertLContainer(declarationLContainer);
                            lView[DECLARATION_LCONTAINER] = declarationLContainer;
                            /** @type {?} */
                            var declarationViewLQueries = this._declarationView[QUERIES];
                            if (declarationViewLQueries !== null) {
                                lView[QUERIES] = declarationViewLQueries.createEmbeddedView(embeddedTView);
                            }
                            renderEmbeddedTemplate(lView, embeddedTView, context);
                            /** @type {?} */
                            var viewRef = new ViewRef(lView, context, -1);
                            viewRef._tViewNode = ( /** @type {?} */(lView[T_HOST]));
                            return viewRef;
                        };
                        return TemplateRef_;
                    }(TemplateRefToken));
                }
                if (hostTNode.type === 0 /* Container */) {
                    ngDevMode && assertDefined(hostTNode.tViews, 'TView must be allocated');
                    return new R3TemplateRef(hostView, ( /** @type {?} */(hostTNode)), createElementRef(ElementRefToken, hostTNode, hostView));
                }
                else {
                    return null;
                }
            }
            /** @type {?} */
            var R3ViewContainerRef;
            /**
             * Creates a ViewContainerRef and stores it on the injector. Or, if the ViewContainerRef
             * already exists, retrieves the existing ViewContainerRef.
             *
             * @param {?} ViewContainerRefToken
             * @param {?} ElementRefToken
             * @return {?} The ViewContainerRef instance to use
             */
            function injectViewContainerRef(ViewContainerRefToken, ElementRefToken) {
                /** @type {?} */
                var previousTNode = ( /** @type {?} */(getPreviousOrParentTNode()));
                return createContainerRef(ViewContainerRefToken, ElementRefToken, previousTNode, getLView());
            }
            /**
             * Creates a ViewContainerRef and stores it on the injector.
             *
             * @param {?} ViewContainerRefToken The ViewContainerRef type
             * @param {?} ElementRefToken The ElementRef type
             * @param {?} hostTNode The node that is requesting a ViewContainerRef
             * @param {?} hostView The view to which the node belongs
             * @return {?} The ViewContainerRef instance to use
             */
            function createContainerRef(ViewContainerRefToken, ElementRefToken, hostTNode, hostView) {
                if (!R3ViewContainerRef) {
                    // TODO: Fix class name, should be ViewContainerRef, but there appears to be a rollup bug
                    R3ViewContainerRef = /** @class */ (function (_super_1) {
                        __extends(ViewContainerRef_, _super_1);
                        /**
                         * @param {?} _lContainer
                         * @param {?} _hostTNode
                         * @param {?} _hostView
                         */
                        function ViewContainerRef_(_lContainer, _hostTNode, _hostView) {
                            var _this = _super_1.call(this) || this;
                            _this._lContainer = _lContainer;
                            _this._hostTNode = _hostTNode;
                            _this._hostView = _hostView;
                            return _this;
                        }
                        Object.defineProperty(ViewContainerRef_.prototype, "element", {
                            /**
                             * @return {?}
                             */
                            get: function () {
                                return createElementRef(ElementRefToken, this._hostTNode, this._hostView);
                            },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(ViewContainerRef_.prototype, "injector", {
                            /**
                             * @return {?}
                             */
                            get: function () { return new NodeInjector(this._hostTNode, this._hostView); },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(ViewContainerRef_.prototype, "parentInjector", {
                            /**
                             * @deprecated No replacement
                             * @return {?}
                             */
                            get: function () {
                                /** @type {?} */
                                var parentLocation = getParentInjectorLocation(this._hostTNode, this._hostView);
                                /** @type {?} */
                                var parentView = getParentInjectorView(parentLocation, this._hostView);
                                /** @type {?} */
                                var parentTNode = getParentInjectorTNode(parentLocation, this._hostView, this._hostTNode);
                                return !hasParentInjector(parentLocation) || parentTNode == null ?
                                    new NodeInjector(null, this._hostView) :
                                    new NodeInjector(parentTNode, parentView);
                            },
                            enumerable: true,
                            configurable: true
                        });
                        /**
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.clear = function () {
                            while (this.length > 0) {
                                this.remove(this.length - 1);
                            }
                        };
                        /**
                         * @param {?} index
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.get = function (index) {
                            return this._lContainer[VIEW_REFS] !== null && ( /** @type {?} */(this._lContainer[VIEW_REFS]))[index] || null;
                        };
                        Object.defineProperty(ViewContainerRef_.prototype, "length", {
                            /**
                             * @return {?}
                             */
                            get: function () { return this._lContainer.length - CONTAINER_HEADER_OFFSET; },
                            enumerable: true,
                            configurable: true
                        });
                        /**
                         * @template C
                         * @param {?} templateRef
                         * @param {?=} context
                         * @param {?=} index
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.createEmbeddedView = function (templateRef, context, index) {
                            /** @type {?} */
                            var viewRef = templateRef.createEmbeddedView(context || ( /** @type {?} */({})));
                            this.insert(viewRef, index);
                            return viewRef;
                        };
                        /**
                         * @template C
                         * @param {?} componentFactory
                         * @param {?=} index
                         * @param {?=} injector
                         * @param {?=} projectableNodes
                         * @param {?=} ngModuleRef
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.createComponent = function (componentFactory, index, injector, projectableNodes, ngModuleRef) {
                            /** @type {?} */
                            var contextInjector = injector || this.parentInjector;
                            if (!ngModuleRef && (( /** @type {?} */(componentFactory))).ngModule == null && contextInjector) {
                                ngModuleRef = contextInjector.get(NgModuleRef, null);
                            }
                            /** @type {?} */
                            var componentRef = componentFactory.create(contextInjector, projectableNodes, undefined, ngModuleRef);
                            this.insert(componentRef.hostView, index);
                            return componentRef;
                        };
                        /**
                         * @param {?} viewRef
                         * @param {?=} index
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.insert = function (viewRef, index) {
                            if (viewRef.destroyed) {
                                throw new Error('Cannot insert a destroyed View in a ViewContainer!');
                            }
                            this.allocateContainerIfNeeded();
                            /** @type {?} */
                            var lView = ( /** @type {?} */((( /** @type {?} */(viewRef)))._lView));
                            /** @type {?} */
                            var adjustedIdx = this._adjustIndex(index);
                            if (viewAttachedToContainer(lView)) {
                                // If view is already attached, fall back to move() so we clean up
                                // references appropriately.
                                return this.move(viewRef, adjustedIdx);
                            }
                            insertView(lView, this._lContainer, adjustedIdx);
                            /** @type {?} */
                            var beforeNode = getBeforeNodeForView(adjustedIdx, this._lContainer);
                            addRemoveViewFromContainer(lView, true, beforeNode);
                            (( /** @type {?} */(viewRef))).attachToViewContainerRef(this);
                            addToArray(( /** @type {?} */(this._lContainer[VIEW_REFS])), adjustedIdx, viewRef);
                            return viewRef;
                        };
                        /**
                         * @param {?} viewRef
                         * @param {?} newIndex
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.move = function (viewRef, newIndex) {
                            if (viewRef.destroyed) {
                                throw new Error('Cannot move a destroyed View in a ViewContainer!');
                            }
                            /** @type {?} */
                            var index = this.indexOf(viewRef);
                            if (index !== -1)
                                this.detach(index);
                            this.insert(viewRef, newIndex);
                            return viewRef;
                        };
                        /**
                         * @param {?} viewRef
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.indexOf = function (viewRef) {
                            return this._lContainer[VIEW_REFS] !== null ?
                                ( /** @type {?} */(this._lContainer[VIEW_REFS])).indexOf(viewRef) :
                                0;
                        };
                        /**
                         * @param {?=} index
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.remove = function (index) {
                            this.allocateContainerIfNeeded();
                            /** @type {?} */
                            var adjustedIdx = this._adjustIndex(index, -1);
                            removeView(this._lContainer, adjustedIdx);
                            removeFromArray(( /** @type {?} */(this._lContainer[VIEW_REFS])), adjustedIdx);
                        };
                        /**
                         * @param {?=} index
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.detach = function (index) {
                            this.allocateContainerIfNeeded();
                            /** @type {?} */
                            var adjustedIdx = this._adjustIndex(index, -1);
                            /** @type {?} */
                            var view = detachView(this._lContainer, adjustedIdx);
                            /** @type {?} */
                            var wasDetached = view && removeFromArray(( /** @type {?} */(this._lContainer[VIEW_REFS])), adjustedIdx) != null;
                            return wasDetached ? new ViewRef(( /** @type {?} */(view)), ( /** @type {?} */(view))[CONTEXT], -1) : null;
                        };
                        /**
                         * @private
                         * @param {?=} index
                         * @param {?=} shift
                         * @return {?}
                         */
                        ViewContainerRef_.prototype._adjustIndex = function (index, shift) {
                            if (shift === void 0) { shift = 0; }
                            if (index == null) {
                                return this.length + shift;
                            }
                            if (ngDevMode) {
                                assertGreaterThan(index, -1, 'index must be positive');
                                // +1 because it's legal to insert at the end.
                                assertLessThan(index, this.length + 1 + shift, 'index');
                            }
                            return index;
                        };
                        /**
                         * @private
                         * @return {?}
                         */
                        ViewContainerRef_.prototype.allocateContainerIfNeeded = function () {
                            if (this._lContainer[VIEW_REFS] === null) {
                                this._lContainer[VIEW_REFS] = [];
                            }
                        };
                        return ViewContainerRef_;
                    }(ViewContainerRefToken));
                }
                ngDevMode && assertNodeOfPossibleTypes(hostTNode, 0 /* Container */, 3 /* Element */, 4 /* ElementContainer */);
                /** @type {?} */
                var lContainer;
                /** @type {?} */
                var slotValue = hostView[hostTNode.index];
                if (isLContainer(slotValue)) {
                    // If the host is a container, we don't need to create a new LContainer
                    lContainer = slotValue;
                    lContainer[ACTIVE_INDEX] = -1;
                }
                else {
                    /** @type {?} */
                    var commentNode = void 0;
                    // If the host is an element container, the native host element is guaranteed to be a
                    // comment and we can reuse that comment as anchor element for the new LContainer.
                    if (hostTNode.type === 4 /* ElementContainer */) {
                        commentNode = ( /** @type {?} */(unwrapRNode(slotValue)));
                    }
                    else {
                        ngDevMode && ngDevMode.rendererCreateComment++;
                        commentNode = hostView[RENDERER].createComment(ngDevMode ? 'container' : '');
                    }
                    // A container can be created on the root (topmost / bootstrapped) component and in this case we
                    // can't use LTree to insert container's marker node (both parent of a comment node and the
                    // commend node itself is located outside of elements hold by LTree). In this specific case we
                    // use low-level DOM manipulation to insert container's marker (comment) node.
                    if (isRootView(hostView)) {
                        /** @type {?} */
                        var renderer = hostView[RENDERER];
                        /** @type {?} */
                        var hostNative = ( /** @type {?} */(getNativeByTNode(hostTNode, hostView)));
                        /** @type {?} */
                        var parentOfHostNative = nativeParentNode(renderer, hostNative);
                        nativeInsertBefore(renderer, ( /** @type {?} */(parentOfHostNative)), commentNode, nativeNextSibling(renderer, hostNative));
                    }
                    else {
                        appendChild(commentNode, hostTNode, hostView);
                    }
                    hostView[hostTNode.index] = lContainer =
                        createLContainer(slotValue, hostView, commentNode, hostTNode, true);
                    addToViewTree(hostView, lContainer);
                }
                return new R3ViewContainerRef(lContainer, hostTNode, hostView);
            }
            /**
             * Returns a ChangeDetectorRef (a.k.a. a ViewRef)
             * @param {?=} isPipe
             * @return {?}
             */
            function injectChangeDetectorRef(isPipe) {
                if (isPipe === void 0) { isPipe = false; }
                return createViewRef(getPreviousOrParentTNode(), getLView(), isPipe);
            }
            /**
             * Creates a ViewRef and stores it on the injector as ChangeDetectorRef (public alias).
             *
             * @param {?} hostTNode The node that is requesting a ChangeDetectorRef
             * @param {?} hostView The view to which the node belongs
             * @param {?} isPipe Whether the view is being injected into a pipe.
             * @return {?} The ChangeDetectorRef to use
             */
            function createViewRef(hostTNode, hostView, isPipe) {
                if (isComponent(hostTNode) && !isPipe) {
                    /** @type {?} */
                    var componentIndex = hostTNode.directiveStart;
                    /** @type {?} */
                    var componentView = getComponentViewByIndex(hostTNode.index, hostView);
                    return new ViewRef(componentView, null, componentIndex);
                }
                else if (hostTNode.type === 3 /* Element */ || hostTNode.type === 0 /* Container */ ||
                    hostTNode.type === 4 /* ElementContainer */) {
                    /** @type {?} */
                    var hostComponentView = findComponentView(hostView);
                    return new ViewRef(hostComponentView, hostComponentView[CONTEXT], -1);
                }
                return ( /** @type {?} */(null));
            }
            /**
             * Returns a Renderer2 (or throws when application was bootstrapped with Renderer3)
             * @param {?} view
             * @return {?}
             */
            function getOrCreateRenderer2(view) {
                /** @type {?} */
                var renderer = view[RENDERER];
                if (isProceduralRenderer(renderer)) {
                    return ( /** @type {?} */(renderer));
                }
                else {
                    throw new Error('Cannot inject Renderer2 when the application uses Renderer3!');
                }
            }
            /**
             * Injects a Renderer2 for the current component.
             * @return {?}
             */
            function injectRenderer2() {
                // We need the Renderer to be based on the component that it's being injected into, however since
                // DI happens before we've entered its view, `getLView` will return the parent view instead.
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = getPreviousOrParentTNode();
                /** @type {?} */
                var nodeAtIndex = getComponentViewByIndex(tNode.index, lView);
                return getOrCreateRenderer2(isLView(nodeAtIndex) ? nodeAtIndex : lView);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Base class for Angular Views, provides change detection functionality.
             * A change-detection tree collects all views that are to be checked for changes.
             * Use the methods to add and remove views from the tree, initiate change-detection,
             * and explicitly mark views as _dirty_, meaning that they have changed and need to be rerendered.
             *
             * \@usageNotes
             *
             * The following examples demonstrate how to modify default change-detection behavior
             * to perform explicit detection when needed.
             *
             * ### Use `markForCheck()` with `CheckOnce` strategy
             *
             * The following example sets the `OnPush` change-detection strategy for a component
             * (`CheckOnce`, rather than the default `CheckAlways`), then forces a second check
             * after an interval. See [live demo](http://plnkr.co/edit/GC512b?p=preview).
             *
             * <code-example path="core/ts/change_detect/change-detection.ts"
             * region="mark-for-check"></code-example>
             *
             * ### Detach change detector to limit how often check occurs
             *
             * The following example defines a component with a large list of read-only data
             * that is expected to change constantly, many times per second.
             * To improve performance, we want to check and update the list
             * less often than the changes actually occur. To do that, we detach
             * the component's change detector and perform an explicit local check every five seconds.
             *
             * <code-example path="core/ts/change_detect/change-detection.ts" region="detach"></code-example>
             *
             *
             * ### Reattaching a detached component
             *
             * The following example creates a component displaying live data.
             * The component detaches its change detector from the main change detector tree
             * when the `live` property is set to false, and reattaches it when the property
             * becomes true.
             *
             * <code-example path="core/ts/change_detect/change-detection.ts" region="reattach"></code-example>
             *
             * \@publicApi
             * @abstract
             */
            var ChangeDetectorRef = /** @class */ (function () {
                function ChangeDetectorRef() {
                }
                return ChangeDetectorRef;
            }());
            /**
             * \@internal
             * @nocollapse
             */
            ChangeDetectorRef.__NG_ELEMENT_ID__ = ( /**
             * @return {?}
             */function () { return SWITCH_CHANGE_DETECTOR_REF_FACTORY(); });
            if (false) { }
            /** @type {?} */
            var SWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__ = injectChangeDetectorRef;
            /** @type {?} */
            var SWITCH_CHANGE_DETECTOR_REF_FACTORY__PRE_R3__ = ( /**
             * @param {...?} args
             * @return {?}
             */function () {
                var args = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    args[_c] = arguments[_c];
                }
            });
            var ɵ0$6 = SWITCH_CHANGE_DETECTOR_REF_FACTORY__PRE_R3__;
            /** @type {?} */
            var SWITCH_CHANGE_DETECTOR_REF_FACTORY = SWITCH_CHANGE_DETECTOR_REF_FACTORY__PRE_R3__;
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @description
             *
             * Represents a type that a Component or other object is instances of.
             *
             * An example of a `Type` is `MyCustomComponent` class, which in JavaScript is be represented by
             * the `MyCustomComponent` constructor function.
             *
             * @publicApi
             */
            var Type = Function;
            function isType(v) {
                return typeof v === 'function';
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Attention: These regex has to hold even if the code is minified!
             */
            var DELEGATE_CTOR = /^function\s+\S+\(\)\s*{[\s\S]+\.apply\(this,\s*arguments\)/;
            var INHERITED_CLASS = /^class\s+[A-Za-z\d$_]*\s*extends\s+[^{]+{/;
            var INHERITED_CLASS_WITH_CTOR = /^class\s+[A-Za-z\d$_]*\s*extends\s+[^{]+{[\s\S]*constructor\s*\(/;
            var INHERITED_CLASS_WITH_DELEGATE_CTOR = /^class\s+[A-Za-z\d$_]*\s*extends\s+[^{]+{[\s\S]*constructor\s*\(\)\s*{\s+super\(\.\.\.arguments\)/;
            /**
             * Determine whether a stringified type is a class which delegates its constructor
             * to its parent.
             *
             * This is not trivial since compiled code can actually contain a constructor function
             * even if the original source code did not. For instance, when the child class contains
             * an initialized instance property.
             */
            function isDelegateCtor(typeStr) {
                return DELEGATE_CTOR.test(typeStr) || INHERITED_CLASS_WITH_DELEGATE_CTOR.test(typeStr) ||
                    (INHERITED_CLASS.test(typeStr) && !INHERITED_CLASS_WITH_CTOR.test(typeStr));
            }
            var ReflectionCapabilities = /** @class */ (function () {
                function ReflectionCapabilities(reflect) {
                    this._reflect = reflect || _global['Reflect'];
                }
                ReflectionCapabilities.prototype.isReflectionEnabled = function () { return true; };
                ReflectionCapabilities.prototype.factory = function (t) { return function () {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    return new (t.bind.apply(t, [void 0].concat(args)))();
                }; };
                /** @internal */
                ReflectionCapabilities.prototype._zipTypesAndAnnotations = function (paramTypes, paramAnnotations) {
                    var result;
                    if (typeof paramTypes === 'undefined') {
                        result = new Array(paramAnnotations.length);
                    }
                    else {
                        result = new Array(paramTypes.length);
                    }
                    for (var i = 0; i < result.length; i++) {
                        // TS outputs Object for parameters without types, while Traceur omits
                        // the annotations. For now we preserve the Traceur behavior to aid
                        // migration, but this can be revisited.
                        if (typeof paramTypes === 'undefined') {
                            result[i] = [];
                        }
                        else if (paramTypes[i] && paramTypes[i] != Object) {
                            result[i] = [paramTypes[i]];
                        }
                        else {
                            result[i] = [];
                        }
                        if (paramAnnotations && paramAnnotations[i] != null) {
                            result[i] = result[i].concat(paramAnnotations[i]);
                        }
                    }
                    return result;
                };
                ReflectionCapabilities.prototype._ownParameters = function (type, parentCtor) {
                    var typeStr = type.toString();
                    // If we have no decorators, we only have function.length as metadata.
                    // In that case, to detect whether a child class declared an own constructor or not,
                    // we need to look inside of that constructor to check whether it is
                    // just calling the parent.
                    // This also helps to work around for https://github.com/Microsoft/TypeScript/issues/12439
                    // that sets 'design:paramtypes' to []
                    // if a class inherits from another class but has no ctor declared itself.
                    if (isDelegateCtor(typeStr)) {
                        return null;
                    }
                    // Prefer the direct API.
                    if (type.parameters && type.parameters !== parentCtor.parameters) {
                        return type.parameters;
                    }
                    // API of tsickle for lowering decorators to properties on the class.
                    var tsickleCtorParams = type.ctorParameters;
                    if (tsickleCtorParams && tsickleCtorParams !== parentCtor.ctorParameters) {
                        // Newer tsickle uses a function closure
                        // Retain the non-function case for compatibility with older tsickle
                        var ctorParameters = typeof tsickleCtorParams === 'function' ? tsickleCtorParams() : tsickleCtorParams;
                        var paramTypes_1 = ctorParameters.map(function (ctorParam) { return ctorParam && ctorParam.type; });
                        var paramAnnotations_1 = ctorParameters.map(function (ctorParam) { return ctorParam && convertTsickleDecoratorIntoMetadata(ctorParam.decorators); });
                        return this._zipTypesAndAnnotations(paramTypes_1, paramAnnotations_1);
                    }
                    // API for metadata created by invoking the decorators.
                    var paramAnnotations = type.hasOwnProperty(PARAMETERS) && type[PARAMETERS];
                    var paramTypes = this._reflect && this._reflect.getOwnMetadata &&
                        this._reflect.getOwnMetadata('design:paramtypes', type);
                    if (paramTypes || paramAnnotations) {
                        return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
                    }
                    // If a class has no decorators, at least create metadata
                    // based on function.length.
                    // Note: We know that this is a real constructor as we checked
                    // the content of the constructor above.
                    return new Array(type.length).fill(undefined);
                };
                ReflectionCapabilities.prototype.parameters = function (type) {
                    // Note: only report metadata if we have at least one class decorator
                    // to stay in sync with the static reflector.
                    if (!isType(type)) {
                        return [];
                    }
                    var parentCtor = getParentCtor(type);
                    var parameters = this._ownParameters(type, parentCtor);
                    if (!parameters && parentCtor !== Object) {
                        parameters = this.parameters(parentCtor);
                    }
                    return parameters || [];
                };
                ReflectionCapabilities.prototype._ownAnnotations = function (typeOrFunc, parentCtor) {
                    // Prefer the direct API.
                    if (typeOrFunc.annotations && typeOrFunc.annotations !== parentCtor.annotations) {
                        var annotations = typeOrFunc.annotations;
                        if (typeof annotations === 'function' && annotations.annotations) {
                            annotations = annotations.annotations;
                        }
                        return annotations;
                    }
                    // API of tsickle for lowering decorators to properties on the class.
                    if (typeOrFunc.decorators && typeOrFunc.decorators !== parentCtor.decorators) {
                        return convertTsickleDecoratorIntoMetadata(typeOrFunc.decorators);
                    }
                    // API for metadata created by invoking the decorators.
                    if (typeOrFunc.hasOwnProperty(ANNOTATIONS)) {
                        return typeOrFunc[ANNOTATIONS];
                    }
                    return null;
                };
                ReflectionCapabilities.prototype.annotations = function (typeOrFunc) {
                    if (!isType(typeOrFunc)) {
                        return [];
                    }
                    var parentCtor = getParentCtor(typeOrFunc);
                    var ownAnnotations = this._ownAnnotations(typeOrFunc, parentCtor) || [];
                    var parentAnnotations = parentCtor !== Object ? this.annotations(parentCtor) : [];
                    return parentAnnotations.concat(ownAnnotations);
                };
                ReflectionCapabilities.prototype._ownPropMetadata = function (typeOrFunc, parentCtor) {
                    // Prefer the direct API.
                    if (typeOrFunc.propMetadata &&
                        typeOrFunc.propMetadata !== parentCtor.propMetadata) {
                        var propMetadata = typeOrFunc.propMetadata;
                        if (typeof propMetadata === 'function' && propMetadata.propMetadata) {
                            propMetadata = propMetadata.propMetadata;
                        }
                        return propMetadata;
                    }
                    // API of tsickle for lowering decorators to properties on the class.
                    if (typeOrFunc.propDecorators &&
                        typeOrFunc.propDecorators !== parentCtor.propDecorators) {
                        var propDecorators_1 = typeOrFunc.propDecorators;
                        var propMetadata_1 = {};
                        Object.keys(propDecorators_1).forEach(function (prop) {
                            propMetadata_1[prop] = convertTsickleDecoratorIntoMetadata(propDecorators_1[prop]);
                        });
                        return propMetadata_1;
                    }
                    // API for metadata created by invoking the decorators.
                    if (typeOrFunc.hasOwnProperty(PROP_METADATA)) {
                        return typeOrFunc[PROP_METADATA];
                    }
                    return null;
                };
                ReflectionCapabilities.prototype.propMetadata = function (typeOrFunc) {
                    if (!isType(typeOrFunc)) {
                        return {};
                    }
                    var parentCtor = getParentCtor(typeOrFunc);
                    var propMetadata = {};
                    if (parentCtor !== Object) {
                        var parentPropMetadata_2 = this.propMetadata(parentCtor);
                        Object.keys(parentPropMetadata_2).forEach(function (propName) {
                            propMetadata[propName] = parentPropMetadata_2[propName];
                        });
                    }
                    var ownPropMetadata = this._ownPropMetadata(typeOrFunc, parentCtor);
                    if (ownPropMetadata) {
                        Object.keys(ownPropMetadata).forEach(function (propName) {
                            var decorators = [];
                            if (propMetadata.hasOwnProperty(propName)) {
                                decorators.push.apply(decorators, propMetadata[propName]);
                            }
                            decorators.push.apply(decorators, ownPropMetadata[propName]);
                            propMetadata[propName] = decorators;
                        });
                    }
                    return propMetadata;
                };
                ReflectionCapabilities.prototype.ownPropMetadata = function (typeOrFunc) {
                    if (!isType(typeOrFunc)) {
                        return {};
                    }
                    return this._ownPropMetadata(typeOrFunc, getParentCtor(typeOrFunc)) || {};
                };
                ReflectionCapabilities.prototype.hasLifecycleHook = function (type, lcProperty) {
                    return type instanceof Type && lcProperty in type.prototype;
                };
                ReflectionCapabilities.prototype.guards = function (type) { return {}; };
                ReflectionCapabilities.prototype.getter = function (name) { return new Function('o', 'return o.' + name + ';'); };
                ReflectionCapabilities.prototype.setter = function (name) {
                    return new Function('o', 'v', 'return o.' + name + ' = v;');
                };
                ReflectionCapabilities.prototype.method = function (name) {
                    var functionBody = "if (!o." + name + ") throw new Error('\"" + name + "\" is undefined');\n        return o." + name + ".apply(o, args);";
                    return new Function('o', 'args', functionBody);
                };
                // There is not a concept of import uri in Js, but this is useful in developing Dart applications.
                ReflectionCapabilities.prototype.importUri = function (type) {
                    // StaticSymbol
                    if (typeof type === 'object' && type['filePath']) {
                        return type['filePath'];
                    }
                    // Runtime type
                    return "./" + stringify(type);
                };
                ReflectionCapabilities.prototype.resourceUri = function (type) { return "./" + stringify(type); };
                ReflectionCapabilities.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
                    return runtime;
                };
                ReflectionCapabilities.prototype.resolveEnum = function (enumIdentifier, name) { return enumIdentifier[name]; };
                return ReflectionCapabilities;
            }());
            function convertTsickleDecoratorIntoMetadata(decoratorInvocations) {
                if (!decoratorInvocations) {
                    return [];
                }
                return decoratorInvocations.map(function (decoratorInvocation) {
                    var decoratorType = decoratorInvocation.type;
                    var annotationCls = decoratorType.annotationCls;
                    var annotationArgs = decoratorInvocation.args ? decoratorInvocation.args : [];
                    return new (annotationCls.bind.apply(annotationCls, [void 0].concat(annotationArgs)))();
                });
            }
            function getParentCtor(ctor) {
                var parentProto = ctor.prototype ? Object.getPrototypeOf(ctor.prototype) : null;
                var parentCtor = parentProto ? parentProto.constructor : null;
                // Note: We always use `Object` as the null value
                // to simplify checking later on.
                return parentCtor || Object;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _reflect = null;
            /**
             * @return {?}
             */
            function getReflect() {
                return (_reflect = _reflect || new ReflectionCapabilities());
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function reflectDependencies(type) {
                return convertDependencies(getReflect().parameters(type));
            }
            /**
             * @param {?} deps
             * @return {?}
             */
            function convertDependencies(deps) {
                /** @type {?} */
                var compiler = getCompilerFacade();
                return deps.map(( /**
                 * @param {?} dep
                 * @return {?}
                 */function (/**
                 * @param {?} dep
                 * @return {?}
                 */ dep) { return reflectDependency(compiler, dep); }));
            }
            /**
             * @param {?} compiler
             * @param {?} dep
             * @return {?}
             */
            function reflectDependency(compiler, dep) {
                /** @type {?} */
                var meta = {
                    token: null,
                    host: false,
                    optional: false,
                    resolved: compiler.R3ResolvedDependencyType.Token,
                    self: false,
                    skipSelf: false,
                };
                /**
                 * @param {?} token
                 * @return {?}
                 */
                function setTokenAndResolvedType(token) {
                    meta.resolved = compiler.R3ResolvedDependencyType.Token;
                    meta.token = token;
                }
                if (Array.isArray(dep)) {
                    if (dep.length === 0) {
                        throw new Error('Dependency array must have arguments.');
                    }
                    for (var j = 0; j < dep.length; j++) {
                        /** @type {?} */
                        var param = dep[j];
                        if (param === undefined) {
                            // param may be undefined if type of dep is not set by ngtsc
                            continue;
                        }
                        else if (param instanceof Optional || param.__proto__.ngMetadataName === 'Optional') {
                            meta.optional = true;
                        }
                        else if (param instanceof SkipSelf || param.__proto__.ngMetadataName === 'SkipSelf') {
                            meta.skipSelf = true;
                        }
                        else if (param instanceof Self || param.__proto__.ngMetadataName === 'Self') {
                            meta.self = true;
                        }
                        else if (param instanceof Host || param.__proto__.ngMetadataName === 'Host') {
                            meta.host = true;
                        }
                        else if (param instanceof Inject) {
                            meta.token = param.token;
                        }
                        else if (param instanceof Attribute) {
                            if (param.attributeName === undefined) {
                                throw new Error("Attribute name must be defined.");
                            }
                            meta.token = param.attributeName;
                            meta.resolved = compiler.R3ResolvedDependencyType.Attribute;
                        }
                        else if (param === ChangeDetectorRef) {
                            meta.token = param;
                            meta.resolved = compiler.R3ResolvedDependencyType.ChangeDetectorRef;
                        }
                        else {
                            setTokenAndResolvedType(param);
                        }
                    }
                }
                else {
                    setTokenAndResolvedType(dep);
                }
                return meta;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Compile an Angular injectable according to its `Injectable` metadata, and patch the resulting
             * `ngInjectableDef` onto the injectable type.
             * @param {?} type
             * @param {?=} srcMeta
             * @return {?}
             */
            function compileInjectable(type, srcMeta) {
                /** @type {?} */
                var def = null;
                // if NG_INJECTABLE_DEF is already defined on this class then don't overwrite it
                if (type.hasOwnProperty(NG_INJECTABLE_DEF))
                    return;
                Object.defineProperty(type, NG_INJECTABLE_DEF, {
                    get: ( /**
                     * @return {?}
                     */function () {
                        if (def === null) {
                            // Allow the compilation of a class with a `@Injectable()` decorator without parameters
                            /** @type {?} */
                            var meta = srcMeta || { providedIn: null };
                            /** @type {?} */
                            var hasAProvider = isUseClassProvider(meta) || isUseFactoryProvider(meta) ||
                                isUseValueProvider(meta) || isUseExistingProvider(meta);
                            /** @type {?} */
                            var compilerMeta = {
                                name: type.name,
                                type: type,
                                typeArgumentCount: 0,
                                providedIn: meta.providedIn,
                                ctorDeps: reflectDependencies(type),
                                userDeps: undefined,
                            };
                            if ((isUseClassProvider(meta) || isUseFactoryProvider(meta)) && meta.deps !== undefined) {
                                compilerMeta.userDeps = convertDependencies(meta.deps);
                            }
                            if (!hasAProvider) {
                                // In the case the user specifies a type provider, treat it as {provide: X, useClass: X}.
                                // The deps will have been reflected above, causing the factory to create the class by
                                // calling
                                // its constructor with injected deps.
                                compilerMeta.useClass = type;
                            }
                            else if (isUseClassProvider(meta)) {
                                // The user explicitly specified useClass, and may or may not have provided deps.
                                compilerMeta.useClass = meta.useClass;
                            }
                            else if (isUseValueProvider(meta)) {
                                // The user explicitly specified useValue.
                                compilerMeta.useValue = meta.useValue;
                            }
                            else if (isUseFactoryProvider(meta)) {
                                // The user explicitly specified useFactory.
                                compilerMeta.useFactory = meta.useFactory;
                            }
                            else if (isUseExistingProvider(meta)) {
                                // The user explicitly specified useExisting.
                                compilerMeta.useExisting = meta.useExisting;
                            }
                            else {
                                // Can't happen - either hasAProvider will be false, or one of the providers will be set.
                                throw new Error("Unreachable state.");
                            }
                            def = getCompilerFacade().compileInjectable(angularCoreDiEnv, "ng:///" + type.name + "/ngInjectableDef.js", compilerMeta);
                        }
                        return def;
                    }),
                });
            }
            var ɵ0$7 = getClosureSafeProperty;
            /** @type {?} */
            var USE_VALUE$1 = getClosureSafeProperty({ provide: String, useValue: ɵ0$7 });
            /**
             * @param {?} meta
             * @return {?}
             */
            function isUseClassProvider(meta) {
                return (( /** @type {?} */(meta))).useClass !== undefined;
            }
            /**
             * @param {?} meta
             * @return {?}
             */
            function isUseValueProvider(meta) {
                return USE_VALUE$1 in meta;
            }
            /**
             * @param {?} meta
             * @return {?}
             */
            function isUseFactoryProvider(meta) {
                return (( /** @type {?} */(meta))).useFactory !== undefined;
            }
            /**
             * @param {?} meta
             * @return {?}
             */
            function isUseExistingProvider(meta) {
                return (( /** @type {?} */(meta))).useExisting !== undefined;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$8 = getClosureSafeProperty;
            /** @type {?} */
            var USE_VALUE$2 = getClosureSafeProperty({ provide: String, useValue: ɵ0$8 });
            /** @type {?} */
            var EMPTY_ARRAY$1 = [];
            /**
             * @param {?} type
             * @param {?=} provider
             * @return {?}
             */
            function convertInjectableProviderToFactory(type, provider) {
                if (!provider) {
                    /** @type {?} */
                    var reflectionCapabilities = new ReflectionCapabilities();
                    /** @type {?} */
                    var deps_1 = reflectionCapabilities.parameters(type);
                    // TODO - convert to flags.
                    return ( /**
                     * @return {?}
                     */function () { return new (type.bind.apply(type, [void 0].concat(injectArgs(( /** @type {?} */(deps_1))))))(); });
                }
                if (USE_VALUE$2 in provider) {
                    /** @type {?} */
                    var valueProvider_1 = (( /** @type {?} */(provider)));
                    return ( /**
                     * @return {?}
                     */function () { return valueProvider_1.useValue; });
                }
                else if ((( /** @type {?} */(provider))).useExisting) {
                    /** @type {?} */
                    var existingProvider_1 = (( /** @type {?} */(provider)));
                    return ( /**
                     * @return {?}
                     */function () { return ɵɵinject(existingProvider_1.useExisting); });
                }
                else if ((( /** @type {?} */(provider))).useFactory) {
                    /** @type {?} */
                    var factoryProvider_1 = (( /** @type {?} */(provider)));
                    return ( /**
                     * @return {?}
                     */function () { return factoryProvider_1.useFactory.apply(factoryProvider_1, injectArgs(factoryProvider_1.deps || EMPTY_ARRAY$1)); });
                }
                else if ((( /** @type {?} */(provider))).useClass) {
                    /** @type {?} */
                    var classProvider_1 = (( /** @type {?} */(provider)));
                    /** @type {?} */
                    var deps_2 = (( /** @type {?} */(provider))).deps;
                    if (!deps_2) {
                        /** @type {?} */
                        var reflectionCapabilities = new ReflectionCapabilities();
                        deps_2 = reflectionCapabilities.parameters(type);
                    }
                    return ( /**
                     * @return {?}
                     */function () {
                        var _c;
                        return new ((_c = classProvider_1.useClass).bind.apply(_c, [void 0].concat(injectArgs(deps_2))))();
                    });
                }
                else {
                    /** @type {?} */
                    var deps_3 = (( /** @type {?} */(provider))).deps;
                    if (!deps_3) {
                        /** @type {?} */
                        var reflectionCapabilities = new ReflectionCapabilities();
                        deps_3 = reflectionCapabilities.parameters(type);
                    }
                    return ( /**
                     * @return {?}
                     */function () { return new (type.bind.apply(type, [void 0].concat(injectArgs(( /** @type {?} */(deps_3))))))(); });
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Type of the Injectable decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function InjectableDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ0$9 = /**
             * @param {?} type
             * @param {?} meta
             * @return {?}
             */ function (type, meta) { return SWITCH_COMPILE_INJECTABLE(( /** @type {?} */(type)), meta); };
            /**
             * Injectable decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Injectable = makeDecorator('Injectable', undefined, undefined, undefined, (ɵ0$9));
            /**
             * Type representing injectable service.
             *
             * \@publicApi
             * @record
             * @template T
             */
            function InjectableType() { }
            if (false) { }
            /**
             * Supports \@Injectable() in JIT mode for Render2.
             * @param {?} injectableType
             * @param {?=} options
             * @return {?}
             */
            function render2CompileInjectable(injectableType, options) {
                if (options && options.providedIn !== undefined && !getInjectableDef(injectableType)) {
                    (( /** @type {?} */(injectableType))).ngInjectableDef = ɵɵdefineInjectable({
                        token: injectableType,
                        providedIn: options.providedIn,
                        factory: convertInjectableProviderToFactory(injectableType, options),
                    });
                }
            }
            /** @type {?} */
            var SWITCH_COMPILE_INJECTABLE__POST_R3__ = compileInjectable;
            /** @type {?} */
            var SWITCH_COMPILE_INJECTABLE__PRE_R3__ = render2CompileInjectable;
            /** @type {?} */
            var SWITCH_COMPILE_INJECTABLE = SWITCH_COMPILE_INJECTABLE__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An internal token whose presence in an injector indicates that the injector should treat itself
             * as a root scoped injector when processing requests for unknown tokens which may indicate
             * they are provided in the root scope.
             * @type {?}
             */
            var APP_ROOT = new InjectionToken('The presence of this token marks an injector as being the root injector.');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Marker which indicates that a value has not yet been created from the factory function.
             * @type {?}
             */
            var NOT_YET = {};
            /**
             * Marker which indicates that the factory function for a token is in the process of being called.
             *
             * If the injector is asked to inject a token with its value set to CIRCULAR, that indicates
             * injection of a dependency has recursively attempted to inject the original token, and there is
             * a circular dependency among the providers.
             * @type {?}
             */
            var CIRCULAR = {};
            /** @type {?} */
            var EMPTY_ARRAY$2 = ( /** @type {?} */([]));
            /**
             * A lazily initialized NullInjector.
             * @type {?}
             */
            var NULL_INJECTOR = undefined;
            /**
             * @return {?}
             */
            function getNullInjector() {
                if (NULL_INJECTOR === undefined) {
                    NULL_INJECTOR = new NullInjector();
                }
                return NULL_INJECTOR;
            }
            /**
             * An entry in the injector which tracks information about the given token, including a possible
             * current value.
             * @record
             * @template T
             */
            function Record() { }
            if (false) { }
            /**
             * Create a new `Injector` which is configured using a `defType` of `InjectorType<any>`s.
             *
             * \@publicApi
             * @param {?} defType
             * @param {?=} parent
             * @param {?=} additionalProviders
             * @param {?=} name
             * @return {?}
             */
            function createInjector(defType, parent, additionalProviders, name) {
                if (parent === void 0) { parent = null; }
                if (additionalProviders === void 0) { additionalProviders = null; }
                parent = parent || getNullInjector();
                return new R3Injector(defType, additionalProviders, parent, name);
            }
            var R3Injector = /** @class */ (function () {
                /**
                 * @param {?} def
                 * @param {?} additionalProviders
                 * @param {?} parent
                 * @param {?=} source
                 */
                function R3Injector(def, additionalProviders, parent, source) {
                    var _this = this;
                    if (source === void 0) { source = null; }
                    this.parent = parent;
                    /**
                     * Map of tokens to records which contain the instances of those tokens.
                     */
                    this.records = new Map();
                    /**
                     * The transitive set of `InjectorType`s which define this injector.
                     */
                    this.injectorDefTypes = new Set();
                    /**
                     * Set of values instantiated by this injector which contain `ngOnDestroy` lifecycle hooks.
                     */
                    this.onDestroy = new Set();
                    this._destroyed = false;
                    // Start off by creating Records for every provider declared in every InjectorType
                    // included transitively in `def`.
                    /** @type {?} */
                    var dedupStack = [];
                    deepForEach([def], ( /**
                     * @param {?} injectorDef
                     * @return {?}
                     */function (/**
                     * @param {?} injectorDef
                     * @return {?}
                     */ injectorDef) { return _this.processInjectorType(injectorDef, [], dedupStack); }));
                    additionalProviders && deepForEach(additionalProviders, ( /**
                     * @param {?} provider
                     * @return {?}
                     */function (/**
                     * @param {?} provider
                     * @return {?}
                     */ provider) { return _this.processProvider(provider, def, additionalProviders); }));
                    // Make sure the INJECTOR token provides this injector.
                    this.records.set(INJECTOR, makeRecord(undefined, this));
                    // Detect whether this injector has the APP_ROOT_SCOPE token and thus should provide
                    // any injectable scoped to APP_ROOT_SCOPE.
                    this.isRootInjector = this.records.has(APP_ROOT);
                    // Eagerly instantiate the InjectorType classes themselves.
                    this.injectorDefTypes.forEach(( /**
                     * @param {?} defType
                     * @return {?}
                     */function (/**
                     * @param {?} defType
                     * @return {?}
                     */ defType) { return _this.get(defType); }));
                    // Source name, used for debugging
                    this.source = source || (typeof def === 'object' ? null : stringify(def));
                }
                Object.defineProperty(R3Injector.prototype, "destroyed", {
                    /**
                     * Flag indicating that this injector was previously destroyed.
                     * @return {?}
                     */
                    get: function () { return this._destroyed; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Destroy the injector and release references to every instance or provider associated with it.
                 *
                 * Also calls the `OnDestroy` lifecycle hooks of every instance that was created for which a
                 * hook was found.
                 * @return {?}
                 */
                R3Injector.prototype.destroy = function () {
                    this.assertNotDestroyed();
                    // Set destroyed = true first, in case lifecycle hooks re-enter destroy().
                    this._destroyed = true;
                    try {
                        // Call all the lifecycle hooks.
                        this.onDestroy.forEach(( /**
                         * @param {?} service
                         * @return {?}
                         */function (/**
                         * @param {?} service
                         * @return {?}
                         */ service) { return service.ngOnDestroy(); }));
                    }
                    finally {
                        // Release all references.
                        this.records.clear();
                        this.onDestroy.clear();
                        this.injectorDefTypes.clear();
                    }
                };
                /**
                 * @template T
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @param {?=} flags
                 * @return {?}
                 */
                R3Injector.prototype.get = function (token, notFoundValue, flags) {
                    if (notFoundValue === void 0) { notFoundValue = THROW_IF_NOT_FOUND; }
                    if (flags === void 0) { flags = InjectFlags.Default; }
                    this.assertNotDestroyed();
                    // Set the injection context.
                    /** @type {?} */
                    var previousInjector = setCurrentInjector(this);
                    try {
                        // Check for the SkipSelf flag.
                        if (!(flags & InjectFlags.SkipSelf)) {
                            // SkipSelf isn't set, check if the record belongs to this injector.
                            /** @type {?} */
                            var record = this.records.get(token);
                            if (record === undefined) {
                                // No record, but maybe the token is scoped to this injector. Look for an ngInjectableDef
                                // with a scope matching this injector.
                                /** @type {?} */
                                var def = couldBeInjectableType(token) && getInjectableDef(token);
                                if (def && this.injectableDefInScope(def)) {
                                    // Found an ngInjectableDef and it's scoped to this injector. Pretend as if it was here
                                    // all along.
                                    record = makeRecord(injectableDefOrInjectorDefFactory(token), NOT_YET);
                                    this.records.set(token, record);
                                }
                            }
                            // If a record was found, get the instance for it and return it.
                            if (record !== undefined) {
                                return this.hydrate(token, record);
                            }
                        }
                        // Select the next injector based on the Self flag - if self is set, the next injector is
                        // the NullInjector, otherwise it's the parent.
                        /** @type {?} */
                        var nextInjector = !(flags & InjectFlags.Self) ? this.parent : getNullInjector();
                        return nextInjector.get(token, flags & InjectFlags.Optional ? null : notFoundValue);
                    }
                    catch (e) {
                        if (e.name === 'NullInjectorError') {
                            /** @type {?} */
                            var path = e[NG_TEMP_TOKEN_PATH] = e[NG_TEMP_TOKEN_PATH] || [];
                            path.unshift(stringify(token));
                            if (previousInjector) {
                                // We still have a parent injector, keep throwing
                                throw e;
                            }
                            else {
                                // Format & throw the final error message when we don't have any previous injector
                                return catchInjectorError(e, token, 'R3InjectorError', this.source);
                            }
                        }
                        else {
                            throw e;
                        }
                    }
                    finally {
                        // Lastly, clean up the state by restoring the previous injector.
                        setCurrentInjector(previousInjector);
                    }
                };
                /**
                 * @return {?}
                 */
                R3Injector.prototype.toString = function () {
                    /** @type {?} */
                    var tokens = ( /** @type {?} */([]));
                    /** @type {?} */
                    var records = this.records;
                    records.forEach(( /**
                     * @param {?} v
                     * @param {?} token
                     * @return {?}
                     */function (v, token) { return tokens.push(stringify(token)); }));
                    return "R3Injector[" + tokens.join(', ') + "]";
                };
                /**
                 * @private
                 * @return {?}
                 */
                R3Injector.prototype.assertNotDestroyed = function () {
                    if (this._destroyed) {
                        throw new Error('Injector has already been destroyed.');
                    }
                };
                /**
                 * Add an `InjectorType` or `InjectorTypeWithProviders` and all of its transitive providers
                 * to this injector.
                 *
                 * If an `InjectorTypeWithProviders` that declares providers besides the type is specified,
                 * the function will return "true" to indicate that the providers of the type definition need
                 * to be processed. This allows us to process providers of injector types after all imports of
                 * an injector definition are processed. (following View Engine semantics: see FW-1349)
                 * @private
                 * @param {?} defOrWrappedDef
                 * @param {?} parents
                 * @param {?} dedupStack
                 * @return {?}
                 */
                R3Injector.prototype.processInjectorType = function (defOrWrappedDef, parents, dedupStack) {
                    var _this = this;
                    defOrWrappedDef = resolveForwardRef(defOrWrappedDef);
                    if (!defOrWrappedDef)
                        return false;
                    // Either the defOrWrappedDef is an InjectorType (with ngInjectorDef) or an
                    // InjectorDefTypeWithProviders (aka ModuleWithProviders). Detecting either is a megamorphic
                    // read, so care is taken to only do the read once.
                    // First attempt to read the ngInjectorDef.
                    /** @type {?} */
                    var def = getInjectorDef(defOrWrappedDef);
                    // If that's not present, then attempt to read ngModule from the InjectorDefTypeWithProviders.
                    /** @type {?} */
                    var ngModule = (def == null) && (( /** @type {?} */(defOrWrappedDef))).ngModule || undefined;
                    // Determine the InjectorType. In the case where `defOrWrappedDef` is an `InjectorType`,
                    // then this is easy. In the case of an InjectorDefTypeWithProviders, then the definition type
                    // is the `ngModule`.
                    /** @type {?} */
                    var defType = (ngModule === undefined) ? (( /** @type {?} */(defOrWrappedDef))) : ngModule;
                    // Check for circular dependencies.
                    if (ngDevMode && parents.indexOf(defType) !== -1) {
                        /** @type {?} */
                        var defName = stringify(defType);
                        throw new Error("Circular dependency in DI detected for type " + defName + ". Dependency path: " + parents.map(( /**
                         * @param {?} defType
                         * @return {?}
                         */function (/**
                         * @param {?} defType
                         * @return {?}
                         */ defType) { return stringify(defType); })).join(' > ') + " > " + defName + ".");
                    }
                    // Check for multiple imports of the same module
                    /** @type {?} */
                    var isDuplicate = dedupStack.indexOf(defType) !== -1;
                    // Finally, if defOrWrappedType was an `InjectorDefTypeWithProviders`, then the actual
                    // `InjectorDef` is on its `ngModule`.
                    if (ngModule !== undefined) {
                        def = getInjectorDef(ngModule);
                    }
                    // If no definition was found, it might be from exports. Remove it.
                    if (def == null) {
                        return false;
                    }
                    // Track the InjectorType and add a provider for it.
                    this.injectorDefTypes.add(defType);
                    this.records.set(defType, makeRecord(def.factory, NOT_YET));
                    // Add providers in the same way that @NgModule resolution did:
                    // First, include providers from any imports.
                    if (def.imports != null && !isDuplicate) {
                        // Before processing defType's imports, add it to the set of parents. This way, if it ends
                        // up deeply importing itself, this can be detected.
                        ngDevMode && parents.push(defType);
                        // Add it to the set of dedups. This way we can detect multiple imports of the same module
                        dedupStack.push(defType);
                        /** @type {?} */
                        var importTypesWithProviders_1;
                        try {
                            deepForEach(def.imports, ( /**
                             * @param {?} imported
                             * @return {?}
                             */function (/**
                             * @param {?} imported
                             * @return {?}
                             */ imported) {
                                if (_this.processInjectorType(imported, parents, dedupStack)) {
                                    if (importTypesWithProviders_1 === undefined)
                                        importTypesWithProviders_1 = [];
                                    // If the processed import is an injector type with providers, we store it in the
                                    // list of import types with providers, so that we can process those afterwards.
                                    importTypesWithProviders_1.push(imported);
                                }
                            }));
                        }
                        finally {
                            // Remove it from the parents set when finished.
                            ngDevMode && parents.pop();
                        }
                        // Imports which are declared with providers (TypeWithProviders) need to be processed
                        // after all imported modules are processed. This is similar to how View Engine
                        // processes/merges module imports in the metadata resolver. See: FW-1349.
                        if (importTypesWithProviders_1 !== undefined) {
                            var _loop_6 = function (i) {
                                var _c = importTypesWithProviders_1[i], ngModule_1 = _c.ngModule, providers = _c.providers;
                                deepForEach(( /** @type {?} */(providers)), ( /**
                                 * @param {?} provider
                                 * @return {?}
                                 */function (/**
                                 * @param {?} provider
                                 * @return {?}
                                 */ provider) { return _this.processProvider(provider, ngModule_1, providers || EMPTY_ARRAY$2); }));
                            };
                            for (var i = 0; i < importTypesWithProviders_1.length; i++) {
                                _loop_6(i);
                            }
                        }
                    }
                    // Next, include providers listed on the definition itself.
                    /** @type {?} */
                    var defProviders = def.providers;
                    if (defProviders != null && !isDuplicate) {
                        /** @type {?} */
                        var injectorType_1 = ( /** @type {?} */(defOrWrappedDef));
                        deepForEach(defProviders, ( /**
                         * @param {?} provider
                         * @return {?}
                         */function (/**
                         * @param {?} provider
                         * @return {?}
                         */ provider) { return _this.processProvider(provider, injectorType_1, defProviders); }));
                    }
                    return (ngModule !== undefined &&
                        (( /** @type {?} */(defOrWrappedDef))).providers !== undefined);
                };
                /**
                 * Process a `SingleProvider` and add it.
                 * @private
                 * @param {?} provider
                 * @param {?} ngModuleType
                 * @param {?} providers
                 * @return {?}
                 */
                R3Injector.prototype.processProvider = function (provider, ngModuleType, providers) {
                    // Determine the token from the provider. Either it's its own token, or has a {provide: ...}
                    // property.
                    provider = resolveForwardRef(provider);
                    /** @type {?} */
                    var token = isTypeProvider(provider) ? provider : resolveForwardRef(provider && provider.provide);
                    // Construct a `Record` for the provider.
                    /** @type {?} */
                    var record = providerToRecord(provider, ngModuleType, providers);
                    if (!isTypeProvider(provider) && provider.multi === true) {
                        // If the provider indicates that it's a multi-provider, process it specially.
                        // First check whether it's been defined already.
                        /** @type {?} */
                        var multiRecord_1 = this.records.get(token);
                        if (multiRecord_1) {
                            // It has. Throw a nice error if
                            if (multiRecord_1.multi === undefined) {
                                throwMixedMultiProviderError();
                            }
                        }
                        else {
                            multiRecord_1 = makeRecord(undefined, NOT_YET, true);
                            multiRecord_1.factory = ( /**
                             * @return {?}
                             */function () { return injectArgs(( /** @type {?} */(( /** @type {?} */(multiRecord_1)).multi))); });
                            this.records.set(token, multiRecord_1);
                        }
                        token = provider;
                        ( /** @type {?} */(multiRecord_1.multi)).push(provider);
                    }
                    else {
                        /** @type {?} */
                        var existing = this.records.get(token);
                        if (existing && existing.multi !== undefined) {
                            throwMixedMultiProviderError();
                        }
                    }
                    this.records.set(token, record);
                };
                /**
                 * @private
                 * @template T
                 * @param {?} token
                 * @param {?} record
                 * @return {?}
                 */
                R3Injector.prototype.hydrate = function (token, record) {
                    if (record.value === CIRCULAR) {
                        throwCyclicDependencyError(stringify(token));
                    }
                    else if (record.value === NOT_YET) {
                        record.value = CIRCULAR;
                        record.value = ( /** @type {?} */(record.factory))();
                    }
                    if (typeof record.value === 'object' && record.value && hasOnDestroy(record.value)) {
                        this.onDestroy.add(record.value);
                    }
                    return ( /** @type {?} */(record.value));
                };
                /**
                 * @private
                 * @param {?} def
                 * @return {?}
                 */
                R3Injector.prototype.injectableDefInScope = function (def) {
                    if (!def.providedIn) {
                        return false;
                    }
                    else if (typeof def.providedIn === 'string') {
                        return def.providedIn === 'any' || (def.providedIn === 'root' && this.isRootInjector);
                    }
                    else {
                        return this.injectorDefTypes.has(def.providedIn);
                    }
                };
                return R3Injector;
            }());
            if (false) { }
            /**
             * @param {?} token
             * @return {?}
             */
            function injectableDefOrInjectorDefFactory(token) {
                // Most tokens will have an ngInjectableDef directly on them, which specifies a factory directly.
                /** @type {?} */
                var injectableDef = getInjectableDef(token);
                if (injectableDef !== null) {
                    return injectableDef.factory;
                }
                // If the token is an NgModule, it's also injectable but the factory is on its ngInjectorDef.
                /** @type {?} */
                var injectorDef = getInjectorDef(token);
                if (injectorDef !== null) {
                    return injectorDef.factory;
                }
                // InjectionTokens should have an ngInjectableDef and thus should be handled above.
                // If it's missing that, it's an error.
                if (token instanceof InjectionToken) {
                    throw new Error("Token " + stringify(token) + " is missing an ngInjectableDef definition.");
                }
                // Undecorated types can sometimes be created if they have no constructor arguments.
                if (token instanceof Function) {
                    return getUndecoratedInjectableFactory(token);
                }
                // There was no way to resolve a factory for this token.
                throw new Error('unreachable');
            }
            /**
             * @param {?} token
             * @return {?}
             */
            function getUndecoratedInjectableFactory(token) {
                // If the token has parameters then it has dependencies that we cannot resolve implicitly.
                /** @type {?} */
                var paramLength = token.length;
                if (paramLength > 0) {
                    /** @type {?} */
                    var args = new Array(paramLength).fill('?');
                    throw new Error("Can't resolve all parameters for " + stringify(token) + ": (" + args.join(', ') + ").");
                }
                // The constructor function appears to have no parameters.
                // This might be because it inherits from a super-class. In which case, use an ngInjectableDef
                // from an ancestor if there is one.
                // Otherwise this really is a simple class with no dependencies, so return a factory that
                // just instantiates the zero-arg constructor.
                /** @type {?} */
                var inheritedInjectableDef = getInheritedInjectableDef(token);
                if (inheritedInjectableDef !== null) {
                    return ( /**
                     * @return {?}
                     */function () { return inheritedInjectableDef.factory(( /** @type {?} */(token))); });
                }
                else {
                    return ( /**
                     * @return {?}
                     */function () { return new (( /** @type {?} */(token)))(); });
                }
            }
            /**
             * @param {?} provider
             * @param {?} ngModuleType
             * @param {?} providers
             * @return {?}
             */
            function providerToRecord(provider, ngModuleType, providers) {
                /** @type {?} */
                var factory = providerToFactory(provider, ngModuleType, providers);
                if (isValueProvider(provider)) {
                    return makeRecord(undefined, provider.useValue);
                }
                else {
                    return makeRecord(factory, NOT_YET);
                }
            }
            /**
             * Converts a `SingleProvider` into a factory function.
             *
             * @param {?} provider provider to convert to factory
             * @param {?=} ngModuleType
             * @param {?=} providers
             * @return {?}
             */
            function providerToFactory(provider, ngModuleType, providers) {
                /** @type {?} */
                var factory = undefined;
                if (isTypeProvider(provider)) {
                    return injectableDefOrInjectorDefFactory(resolveForwardRef(provider));
                }
                else {
                    if (isValueProvider(provider)) {
                        factory = ( /**
                         * @return {?}
                         */function () { return resolveForwardRef(provider.useValue); });
                    }
                    else if (isExistingProvider(provider)) {
                        factory = ( /**
                         * @return {?}
                         */function () { return ɵɵinject(resolveForwardRef(provider.useExisting)); });
                    }
                    else if (isFactoryProvider(provider)) {
                        factory = ( /**
                         * @return {?}
                         */function () { return provider.useFactory.apply(provider, injectArgs(provider.deps || [])); });
                    }
                    else {
                        /** @type {?} */
                        var classRef_1 = resolveForwardRef(provider &&
                            ((( /** @type {?} */(provider))).useClass || provider.provide));
                        if (!classRef_1) {
                            throwInvalidProviderError(ngModuleType, providers, provider);
                        }
                        if (hasDeps(provider)) {
                            factory = ( /**
                             * @return {?}
                             */function () { return new ((classRef_1).bind.apply((classRef_1), [void 0].concat(injectArgs(provider.deps))))(); });
                        }
                        else {
                            return injectableDefOrInjectorDefFactory(classRef_1);
                        }
                    }
                }
                return factory;
            }
            /**
             * @template T
             * @param {?} factory
             * @param {?} value
             * @param {?=} multi
             * @return {?}
             */
            function makeRecord(factory, value, multi) {
                if (multi === void 0) { multi = false; }
                return {
                    factory: factory,
                    value: value,
                    multi: multi ? [] : undefined,
                };
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isValueProvider(value) {
                return value !== null && typeof value == 'object' && USE_VALUE in value;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isExistingProvider(value) {
                return !!(value && (( /** @type {?} */(value))).useExisting);
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isFactoryProvider(value) {
                return !!(value && (( /** @type {?} */(value))).useFactory);
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isTypeProvider(value) {
                return typeof value === 'function';
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isClassProvider(value) {
                return !!(( /** @type {?} */(value))).useClass;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function hasDeps(value) {
                return !!(( /** @type {?} */(value))).deps;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function hasOnDestroy(value) {
                return value !== null && typeof value === 'object' &&
                    typeof (( /** @type {?} */(value))).ngOnDestroy === 'function';
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function couldBeInjectableType(value) {
                return (typeof value === 'function') ||
                    (typeof value === 'object' && value instanceof InjectionToken);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} providers
             * @param {?} parent
             * @param {?} name
             * @return {?}
             */
            function INJECTOR_IMPL__PRE_R3__(providers, parent, name) {
                return new StaticInjector(providers, parent, name);
            }
            /**
             * @param {?} providers
             * @param {?} parent
             * @param {?} name
             * @return {?}
             */
            function INJECTOR_IMPL__POST_R3__(providers, parent, name) {
                return createInjector({ name: name }, parent, providers, name);
            }
            /** @type {?} */
            var INJECTOR_IMPL = INJECTOR_IMPL__PRE_R3__;
            /**
             * Concrete injectors implement this interface.
             *
             * For more details, see the ["Dependency Injection Guide"](guide/dependency-injection).
             *
             * \@usageNotes
             * ### Example
             *
             * {\@example core/di/ts/injector_spec.ts region='Injector'}
             *
             * `Injector` returns itself when given `Injector` as a token:
             *
             * {\@example core/di/ts/injector_spec.ts region='injectInjector'}
             *
             * \@publicApi
             * @abstract
             */
            var Injector = /** @class */ (function () {
                function Injector() {
                }
                /**
                 * Create a new Injector which is configure using `StaticProvider`s.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * {\@example core/di/ts/provider_spec.ts region='ConstructorProvider'}
                 * @param {?} options
                 * @param {?=} parent
                 * @return {?}
                 */
                Injector.create = function (options, parent) {
                    if (Array.isArray(options)) {
                        return INJECTOR_IMPL(options, parent, '');
                    }
                    else {
                        return INJECTOR_IMPL(options.providers, options.parent, options.name || '');
                    }
                };
                return Injector;
            }());
            Injector.THROW_IF_NOT_FOUND = THROW_IF_NOT_FOUND;
            Injector.NULL = new NullInjector();
            /** @nocollapse */
            /** @nocollapse */ Injector.ngInjectableDef = ɵɵdefineInjectable({
                token: Injector,
                providedIn: ( /** @type {?} */('any')),
                factory: ( /**
                 * @return {?}
                 */function () { return ɵɵinject(INJECTOR); }),
            });
            /**
             * \@internal
             * @nocollapse
             */
            Injector.__NG_ELEMENT_ID__ = -1;
            if (false) { }
            /** @type {?} */
            var IDENT = ( /**
             * @template T
             * @param {?} value
             * @return {?}
             */function (value) {
                return value;
            });
            var ɵ0$a = IDENT;
            /** @type {?} */
            var EMPTY = ( /** @type {?} */([]));
            /** @type {?} */
            var CIRCULAR$1 = IDENT;
            /** @type {?} */
            var MULTI_PROVIDER_FN = ( /**
             * @return {?}
             */function () {
                return Array.prototype.slice.call(arguments);
            });
            var ɵ1$2 = MULTI_PROVIDER_FN;
            /** @enum {number} */
            var OptionFlags = {
                Optional: 1,
                CheckSelf: 2,
                CheckParent: 4,
                Default: 6,
            };
            /** @type {?} */
            var NO_NEW_LINE$1 = 'ɵ';
            var StaticInjector = /** @class */ (function () {
                /**
                 * @param {?} providers
                 * @param {?=} parent
                 * @param {?=} source
                 */
                function StaticInjector(providers, parent, source) {
                    if (parent === void 0) { parent = Injector.NULL; }
                    if (source === void 0) { source = null; }
                    this.parent = parent;
                    this.source = source;
                    /** @type {?} */
                    var records = this._records = new Map();
                    records.set(Injector, ( /** @type {?} */({ token: Injector, fn: IDENT, deps: EMPTY, value: this, useNew: false })));
                    records.set(INJECTOR, ( /** @type {?} */({ token: INJECTOR, fn: IDENT, deps: EMPTY, value: this, useNew: false })));
                    recursivelyProcessProviders(records, providers);
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @param {?=} flags
                 * @return {?}
                 */
                StaticInjector.prototype.get = function (token, notFoundValue, flags) {
                    if (flags === void 0) { flags = InjectFlags.Default; }
                    /** @type {?} */
                    var record = this._records.get(token);
                    try {
                        return tryResolveToken(token, record, this._records, this.parent, notFoundValue, flags);
                    }
                    catch (e) {
                        return catchInjectorError(e, token, 'StaticInjectorError', this.source);
                    }
                };
                /**
                 * @return {?}
                 */
                StaticInjector.prototype.toString = function () {
                    /** @type {?} */
                    var tokens = ( /** @type {?} */([]));
                    /** @type {?} */
                    var records = this._records;
                    records.forEach(( /**
                     * @param {?} v
                     * @param {?} token
                     * @return {?}
                     */function (v, token) { return tokens.push(stringify(token)); }));
                    return "StaticInjector[" + tokens.join(', ') + "]";
                };
                return StaticInjector;
            }());
            if (false) { }
            /**
             * @record
             */
            function Record$1() { }
            if (false) { }
            /**
             * @record
             */
            function DependencyRecord() { }
            if (false) { }
            /**
             * @param {?} provider
             * @return {?}
             */
            function resolveProvider(provider) {
                /** @type {?} */
                var deps = computeDeps(provider);
                /** @type {?} */
                var fn = IDENT;
                /** @type {?} */
                var value = EMPTY;
                /** @type {?} */
                var useNew = false;
                /** @type {?} */
                var provide = resolveForwardRef(provider.provide);
                if (USE_VALUE in provider) {
                    // We need to use USE_VALUE in provider since provider.useValue could be defined as undefined.
                    value = (( /** @type {?} */(provider))).useValue;
                }
                else if ((( /** @type {?} */(provider))).useFactory) {
                    fn = (( /** @type {?} */(provider))).useFactory;
                }
                else if ((( /** @type {?} */(provider))).useExisting) {
                    // Just use IDENT
                }
                else if ((( /** @type {?} */(provider))).useClass) {
                    useNew = true;
                    fn = resolveForwardRef((( /** @type {?} */(provider))).useClass);
                }
                else if (typeof provide == 'function') {
                    useNew = true;
                    fn = provide;
                }
                else {
                    throw staticError('StaticProvider does not have [useValue|useFactory|useExisting|useClass] or [provide] is not newable', provider);
                }
                return { deps: deps, fn: fn, useNew: useNew, value: value };
            }
            /**
             * @param {?} token
             * @return {?}
             */
            function multiProviderMixError(token) {
                return staticError('Cannot mix multi providers and regular providers', token);
            }
            /**
             * @param {?} records
             * @param {?} provider
             * @return {?}
             */
            function recursivelyProcessProviders(records, provider) {
                if (provider) {
                    provider = resolveForwardRef(provider);
                    if (provider instanceof Array) {
                        // if we have an array recurse into the array
                        for (var i = 0; i < provider.length; i++) {
                            recursivelyProcessProviders(records, provider[i]);
                        }
                    }
                    else if (typeof provider === 'function') {
                        // Functions were supported in ReflectiveInjector, but are not here. For safety give useful
                        // error messages
                        throw staticError('Function/Class not supported', provider);
                    }
                    else if (provider && typeof provider === 'object' && provider.provide) {
                        // At this point we have what looks like a provider: {provide: ?, ....}
                        /** @type {?} */
                        var token = resolveForwardRef(provider.provide);
                        /** @type {?} */
                        var resolvedProvider = resolveProvider(provider);
                        if (provider.multi === true) {
                            // This is a multi provider.
                            /** @type {?} */
                            var multiProvider = records.get(token);
                            if (multiProvider) {
                                if (multiProvider.fn !== MULTI_PROVIDER_FN) {
                                    throw multiProviderMixError(token);
                                }
                            }
                            else {
                                // Create a placeholder factory which will look up the constituents of the multi provider.
                                records.set(token, multiProvider = ( /** @type {?} */({
                                    token: provider.provide,
                                    deps: [],
                                    useNew: false,
                                    fn: MULTI_PROVIDER_FN,
                                    value: EMPTY
                                })));
                            }
                            // Treat the provider as the token.
                            token = provider;
                            multiProvider.deps.push({ token: token, options: 6 /* Default */ });
                        }
                        /** @type {?} */
                        var record = records.get(token);
                        if (record && record.fn == MULTI_PROVIDER_FN) {
                            throw multiProviderMixError(token);
                        }
                        records.set(token, resolvedProvider);
                    }
                    else {
                        throw staticError('Unexpected provider', provider);
                    }
                }
            }
            /**
             * @param {?} token
             * @param {?} record
             * @param {?} records
             * @param {?} parent
             * @param {?} notFoundValue
             * @param {?} flags
             * @return {?}
             */
            function tryResolveToken(token, record, records, parent, notFoundValue, flags) {
                try {
                    return resolveToken(token, record, records, parent, notFoundValue, flags);
                }
                catch (e) {
                    // ensure that 'e' is of type Error.
                    if (!(e instanceof Error)) {
                        e = new Error(e);
                    }
                    /** @type {?} */
                    var path = e[NG_TEMP_TOKEN_PATH] = e[NG_TEMP_TOKEN_PATH] || [];
                    path.unshift(token);
                    if (record && record.value == CIRCULAR$1) {
                        // Reset the Circular flag.
                        record.value = EMPTY;
                    }
                    throw e;
                }
            }
            /**
             * @param {?} token
             * @param {?} record
             * @param {?} records
             * @param {?} parent
             * @param {?} notFoundValue
             * @param {?} flags
             * @return {?}
             */
            function resolveToken(token, record, records, parent, notFoundValue, flags) {
                /** @type {?} */
                var value;
                if (record && !(flags & InjectFlags.SkipSelf)) {
                    // If we don't have a record, this implies that we don't own the provider hence don't know how
                    // to resolve it.
                    value = record.value;
                    if (value == CIRCULAR$1) {
                        throw Error(NO_NEW_LINE$1 + 'Circular dependency');
                    }
                    else if (value === EMPTY) {
                        record.value = CIRCULAR$1;
                        /** @type {?} */
                        var obj = undefined;
                        /** @type {?} */
                        var useNew = record.useNew;
                        /** @type {?} */
                        var fn = record.fn;
                        /** @type {?} */
                        var depRecords = record.deps;
                        /** @type {?} */
                        var deps = EMPTY;
                        if (depRecords.length) {
                            deps = [];
                            for (var i = 0; i < depRecords.length; i++) {
                                /** @type {?} */
                                var depRecord = depRecords[i];
                                /** @type {?} */
                                var options = depRecord.options;
                                /** @type {?} */
                                var childRecord = options & 2 /* CheckSelf */ ? records.get(depRecord.token) : undefined;
                                deps.push(tryResolveToken(
                                // Current Token to resolve
                                depRecord.token, 
                                // A record which describes how to resolve the token.
                                // If undefined, this means we don't have such a record
                                childRecord, 
                                // Other records we know about.
                                records, 
                                // If we don't know how to resolve dependency and we should not check parent for it,
                                // than pass in Null injector.
                                !childRecord && !(options & 4 /* CheckParent */) ? Injector.NULL : parent, options & 1 /* Optional */ ? null : Injector.THROW_IF_NOT_FOUND, InjectFlags.Default));
                            }
                        }
                        record.value = value = useNew ? new ((( /** @type {?} */(fn))).bind.apply((( /** @type {?} */(fn))), [void 0].concat(deps)))() : fn.apply(obj, deps);
                    }
                }
                else if (!(flags & InjectFlags.Self)) {
                    value = parent.get(token, notFoundValue, InjectFlags.Default);
                }
                return value;
            }
            /**
             * @param {?} provider
             * @return {?}
             */
            function computeDeps(provider) {
                /** @type {?} */
                var deps = EMPTY;
                /** @type {?} */
                var providerDeps = (( /** @type {?} */(provider))).deps;
                if (providerDeps && providerDeps.length) {
                    deps = [];
                    for (var i = 0; i < providerDeps.length; i++) {
                        /** @type {?} */
                        var options = 6 /* Default */;
                        /** @type {?} */
                        var token = resolveForwardRef(providerDeps[i]);
                        if (token instanceof Array) {
                            for (var j = 0, annotations = token; j < annotations.length; j++) {
                                /** @type {?} */
                                var annotation = annotations[j];
                                if (annotation instanceof Optional || annotation == Optional) {
                                    options = options | 1 /* Optional */;
                                }
                                else if (annotation instanceof SkipSelf || annotation == SkipSelf) {
                                    options = options & ~2 /* CheckSelf */;
                                }
                                else if (annotation instanceof Self || annotation == Self) {
                                    options = options & ~4 /* CheckParent */;
                                }
                                else if (annotation instanceof Inject) {
                                    token = (( /** @type {?} */(annotation))).token;
                                }
                                else {
                                    token = resolveForwardRef(annotation);
                                }
                            }
                        }
                        deps.push({ token: token, options: options });
                    }
                }
                else if ((( /** @type {?} */(provider))).useExisting) {
                    /** @type {?} */
                    var token = resolveForwardRef((( /** @type {?} */(provider))).useExisting);
                    deps = [{ token: token, options: 6 /* Default */ }];
                }
                else if (!providerDeps && !(USE_VALUE in provider)) {
                    // useValue & useExisting are the only ones which are exempt from deps all others need it.
                    throw staticError('\'deps\' required', provider);
                }
                return deps;
            }
            /**
             * @param {?} text
             * @param {?} obj
             * @return {?}
             */
            function staticError(text, obj) {
                return new Error(formatError(text, obj, 'StaticInjectorError'));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} keys
             * @return {?}
             */
            function findFirstClosedCycle(keys) {
                /** @type {?} */
                var res = [];
                for (var i = 0; i < keys.length; ++i) {
                    if (res.indexOf(keys[i]) > -1) {
                        res.push(keys[i]);
                        return res;
                    }
                    res.push(keys[i]);
                }
                return res;
            }
            /**
             * @param {?} keys
             * @return {?}
             */
            function constructResolvingPath(keys) {
                if (keys.length > 1) {
                    /** @type {?} */
                    var reversed = findFirstClosedCycle(keys.slice().reverse());
                    /** @type {?} */
                    var tokenStrs = reversed.map(( /**
                     * @param {?} k
                     * @return {?}
                     */function (/**
                     * @param {?} k
                     * @return {?}
                     */ k) { return stringify(k.token); }));
                    return ' (' + tokenStrs.join(' -> ') + ')';
                }
                return '';
            }
            /**
             * @record
             */
            function InjectionError() { }
            if (false) { }
            /**
             * @param {?} injector
             * @param {?} key
             * @param {?} constructResolvingMessage
             * @param {?=} originalError
             * @return {?}
             */
            function injectionError(injector, key, constructResolvingMessage, originalError) {
                /** @type {?} */
                var keys = [key];
                /** @type {?} */
                var errMsg = constructResolvingMessage(keys);
                /** @type {?} */
                var error = ( /** @type {?} */((originalError ? wrappedError(errMsg, originalError) : Error(errMsg))));
                error.addKey = addKey;
                error.keys = keys;
                error.injectors = [injector];
                error.constructResolvingMessage = constructResolvingMessage;
                (( /** @type {?} */(error)))[ERROR_ORIGINAL_ERROR] = originalError;
                return error;
            }
            /**
             * @this {?}
             * @param {?} injector
             * @param {?} key
             * @return {?}
             */
            function addKey(injector, key) {
                this.injectors.push(injector);
                this.keys.push(key);
                // Note: This updated message won't be reflected in the `.stack` property
                this.message = this.constructResolvingMessage(this.keys);
            }
            /**
             * Thrown when trying to retrieve a dependency by key from {\@link Injector}, but the
             * {\@link Injector} does not have a {\@link Provider} for the given key.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * class A {
             *   constructor(b:B) {}
             * }
             *
             * expect(() => Injector.resolveAndCreate([A])).toThrowError();
             * ```
             * @param {?} injector
             * @param {?} key
             * @return {?}
             */
            function noProviderError(injector, key) {
                return injectionError(injector, key, ( /**
                 * @param {?} keys
                 * @return {?}
                 */function (keys) {
                    /** @type {?} */
                    var first = stringify(keys[0].token);
                    return "No provider for " + first + "!" + constructResolvingPath(keys);
                }));
            }
            /**
             * Thrown when dependencies form a cycle.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * var injector = Injector.resolveAndCreate([
             *   {provide: "one", useFactory: (two) => "two", deps: [[new Inject("two")]]},
             *   {provide: "two", useFactory: (one) => "one", deps: [[new Inject("one")]]}
             * ]);
             *
             * expect(() => injector.get("one")).toThrowError();
             * ```
             *
             * Retrieving `A` or `B` throws a `CyclicDependencyError` as the graph above cannot be constructed.
             * @param {?} injector
             * @param {?} key
             * @return {?}
             */
            function cyclicDependencyError(injector, key) {
                return injectionError(injector, key, ( /**
                 * @param {?} keys
                 * @return {?}
                 */function (keys) {
                    return "Cannot instantiate cyclic dependency!" + constructResolvingPath(keys);
                }));
            }
            /**
             * Thrown when a constructing type returns with an Error.
             *
             * The `InstantiationError` class contains the original error plus the dependency graph which caused
             * this object to be instantiated.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * class A {
             *   constructor() {
             *     throw new Error('message');
             *   }
             * }
             *
             * var injector = Injector.resolveAndCreate([A]);
             * try {
             *   injector.get(A);
             * } catch (e) {
             *   expect(e instanceof InstantiationError).toBe(true);
             *   expect(e.originalException.message).toEqual("message");
             *   expect(e.originalStack).toBeDefined();
             * }
             * ```
             * @param {?} injector
             * @param {?} originalException
             * @param {?} originalStack
             * @param {?} key
             * @return {?}
             */
            function instantiationError(injector, originalException, originalStack, key) {
                return injectionError(injector, key, ( /**
                 * @param {?} keys
                 * @return {?}
                 */function (keys) {
                    /** @type {?} */
                    var first = stringify(keys[0].token);
                    return originalException.message + ": Error during instantiation of " + first + "!" + constructResolvingPath(keys) + ".";
                }), originalException);
            }
            /**
             * Thrown when an object other then {\@link Provider} (or `Type`) is passed to {\@link Injector}
             * creation.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * expect(() => Injector.resolveAndCreate(["not a type"])).toThrowError();
             * ```
             * @param {?} provider
             * @return {?}
             */
            function invalidProviderError(provider) {
                return Error("Invalid provider - only instances of Provider and Type are allowed, got: " + provider);
            }
            /**
             * Thrown when the class has no annotation information.
             *
             * Lack of annotation information prevents the {\@link Injector} from determining which dependencies
             * need to be injected into the constructor.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * class A {
             *   constructor(b) {}
             * }
             *
             * expect(() => Injector.resolveAndCreate([A])).toThrowError();
             * ```
             *
             * This error is also thrown when the class not marked with {\@link Injectable} has parameter types.
             *
             * ```typescript
             * class B {}
             *
             * class A {
             *   constructor(b:B) {} // no information about the parameter types of A is available at runtime.
             * }
             *
             * expect(() => Injector.resolveAndCreate([A,B])).toThrowError();
             * ```
             *
             * @param {?} typeOrFunc
             * @param {?} params
             * @return {?}
             */
            function noAnnotationError(typeOrFunc, params) {
                /** @type {?} */
                var signature = [];
                for (var i = 0, ii = params.length; i < ii; i++) {
                    /** @type {?} */
                    var parameter = params[i];
                    if (!parameter || parameter.length == 0) {
                        signature.push('?');
                    }
                    else {
                        signature.push(parameter.map(stringify).join(' '));
                    }
                }
                return Error('Cannot resolve all parameters for \'' + stringify(typeOrFunc) + '\'(' +
                    signature.join(', ') + '). ' +
                    'Make sure that all the parameters are decorated with Inject or have valid type annotations and that \'' +
                    stringify(typeOrFunc) + '\' is decorated with Injectable.');
            }
            /**
             * Thrown when getting an object by index.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * class A {}
             *
             * var injector = Injector.resolveAndCreate([A]);
             *
             * expect(() => injector.getAt(100)).toThrowError();
             * ```
             *
             * @param {?} index
             * @return {?}
             */
            function outOfBoundsError(index) {
                return Error("Index " + index + " is out-of-bounds.");
            }
            // TODO: add a working example after alpha38 is released
            /**
             * Thrown when a multi provider and a regular provider are bound to the same token.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * expect(() => Injector.resolveAndCreate([
             *   { provide: "Strings", useValue: "string1", multi: true},
             *   { provide: "Strings", useValue: "string2", multi: false}
             * ])).toThrowError();
             * ```
             * @param {?} provider1
             * @param {?} provider2
             * @return {?}
             */
            function mixingMultiProvidersWithRegularProvidersError(provider1, provider2) {
                return Error("Cannot mix multi providers and regular providers, got: " + provider1 + " " + provider2);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A unique object used for retrieving items from the {\@link ReflectiveInjector}.
             *
             * Keys have:
             * - a system-wide unique `id`.
             * - a `token`.
             *
             * `Key` is used internally by {\@link ReflectiveInjector} because its system-wide unique `id` allows
             * the
             * injector to store created objects in a more efficient way.
             *
             * `Key` should not be created directly. {\@link ReflectiveInjector} creates keys automatically when
             * resolving
             * providers.
             *
             * @deprecated No replacement
             * \@publicApi
             */
            var ReflectiveKey = /** @class */ (function () {
                /**
                 * Private
                 * @param {?} token
                 * @param {?} id
                 */
                function ReflectiveKey(token, id) {
                    this.token = token;
                    this.id = id;
                    if (!token) {
                        throw new Error('Token must be defined!');
                    }
                    this.displayName = stringify(this.token);
                }
                /**
                 * Retrieves a `Key` for a token.
                 * @param {?} token
                 * @return {?}
                 */
                ReflectiveKey.get = function (token) {
                    return _globalKeyRegistry.get(resolveForwardRef(token));
                };
                Object.defineProperty(ReflectiveKey, "numberOfKeys", {
                    /**
                     * @return {?} the number of keys registered in the system.
                     */
                    get: function () { return _globalKeyRegistry.numberOfKeys; },
                    enumerable: true,
                    configurable: true
                });
                return ReflectiveKey;
            }());
            if (false) { }
            var KeyRegistry = /** @class */ (function () {
                function KeyRegistry() {
                    this._allKeys = new Map();
                }
                /**
                 * @param {?} token
                 * @return {?}
                 */
                KeyRegistry.prototype.get = function (token) {
                    if (token instanceof ReflectiveKey)
                        return token;
                    if (this._allKeys.has(token)) {
                        return ( /** @type {?} */(this._allKeys.get(token)));
                    }
                    /** @type {?} */
                    var newKey = new ReflectiveKey(token, ReflectiveKey.numberOfKeys);
                    this._allKeys.set(token, newKey);
                    return newKey;
                };
                Object.defineProperty(KeyRegistry.prototype, "numberOfKeys", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._allKeys.size; },
                    enumerable: true,
                    configurable: true
                });
                return KeyRegistry;
            }());
            if (false) { }
            /** @type {?} */
            var _globalKeyRegistry = new KeyRegistry();
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Provides access to reflection data about symbols. Used internally by Angular
             * to power dependency injection and compilation.
             */
            var Reflector = /** @class */ (function () {
                function Reflector(reflectionCapabilities) {
                    this.reflectionCapabilities = reflectionCapabilities;
                }
                Reflector.prototype.updateCapabilities = function (caps) { this.reflectionCapabilities = caps; };
                Reflector.prototype.factory = function (type) { return this.reflectionCapabilities.factory(type); };
                Reflector.prototype.parameters = function (typeOrFunc) {
                    return this.reflectionCapabilities.parameters(typeOrFunc);
                };
                Reflector.prototype.annotations = function (typeOrFunc) {
                    return this.reflectionCapabilities.annotations(typeOrFunc);
                };
                Reflector.prototype.propMetadata = function (typeOrFunc) {
                    return this.reflectionCapabilities.propMetadata(typeOrFunc);
                };
                Reflector.prototype.hasLifecycleHook = function (type, lcProperty) {
                    return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
                };
                Reflector.prototype.getter = function (name) { return this.reflectionCapabilities.getter(name); };
                Reflector.prototype.setter = function (name) { return this.reflectionCapabilities.setter(name); };
                Reflector.prototype.method = function (name) { return this.reflectionCapabilities.method(name); };
                Reflector.prototype.importUri = function (type) { return this.reflectionCapabilities.importUri(type); };
                Reflector.prototype.resourceUri = function (type) { return this.reflectionCapabilities.resourceUri(type); };
                Reflector.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
                    return this.reflectionCapabilities.resolveIdentifier(name, moduleUrl, members, runtime);
                };
                Reflector.prototype.resolveEnum = function (identifier, name) {
                    return this.reflectionCapabilities.resolveEnum(identifier, name);
                };
                return Reflector;
            }());
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * The {@link Reflector} used internally in Angular to access metadata
             * about symbols.
             */
            var reflector = new Reflector(new ReflectionCapabilities());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function NormalizedProvider() { }
            /**
             * `Dependency` is used by the framework to extend DI.
             * This is internal to Angular and should not be used directly.
             */
            var ReflectiveDependency = /** @class */ (function () {
                /**
                 * @param {?} key
                 * @param {?} optional
                 * @param {?} visibility
                 */
                function ReflectiveDependency(key, optional, visibility) {
                    this.key = key;
                    this.optional = optional;
                    this.visibility = visibility;
                }
                /**
                 * @param {?} key
                 * @return {?}
                 */
                ReflectiveDependency.fromKey = function (key) {
                    return new ReflectiveDependency(key, false, null);
                };
                return ReflectiveDependency;
            }());
            if (false) { }
            /** @type {?} */
            var _EMPTY_LIST = [];
            /**
             * An internal resolved representation of a `Provider` used by the `Injector`.
             *
             * \@usageNotes
             * This is usually created automatically by `Injector.resolveAndCreate`.
             *
             * It can be created manually, as follows:
             *
             * ### Example
             *
             * ```typescript
             * var resolvedProviders = Injector.resolve([{ provide: 'message', useValue: 'Hello' }]);
             * var injector = Injector.fromResolvedProviders(resolvedProviders);
             *
             * expect(injector.get('message')).toEqual('Hello');
             * ```
             *
             * \@publicApi
             * @record
             */
            function ResolvedReflectiveProvider() { }
            if (false) { }
            var ResolvedReflectiveProvider_ = /** @class */ (function () {
                /**
                 * @param {?} key
                 * @param {?} resolvedFactories
                 * @param {?} multiProvider
                 */
                function ResolvedReflectiveProvider_(key, resolvedFactories, multiProvider) {
                    this.key = key;
                    this.resolvedFactories = resolvedFactories;
                    this.multiProvider = multiProvider;
                    this.resolvedFactory = this.resolvedFactories[0];
                }
                return ResolvedReflectiveProvider_;
            }());
            if (false) { }
            /**
             * An internal resolved representation of a factory function created by resolving `Provider`.
             * \@publicApi
             */
            var ResolvedReflectiveFactory = /** @class */ (function () {
                /**
                 * @param {?} factory
                 * @param {?} dependencies
                 */
                function ResolvedReflectiveFactory(factory, dependencies) {
                    this.factory = factory;
                    this.dependencies = dependencies;
                }
                return ResolvedReflectiveFactory;
            }());
            if (false) { }
            /**
             * Resolve a single provider.
             * @param {?} provider
             * @return {?}
             */
            function resolveReflectiveFactory(provider) {
                /** @type {?} */
                var factoryFn;
                /** @type {?} */
                var resolvedDeps;
                if (provider.useClass) {
                    /** @type {?} */
                    var useClass = resolveForwardRef(provider.useClass);
                    factoryFn = reflector.factory(useClass);
                    resolvedDeps = _dependenciesFor(useClass);
                }
                else if (provider.useExisting) {
                    factoryFn = ( /**
                     * @param {?} aliasInstance
                     * @return {?}
                     */function (aliasInstance) { return aliasInstance; });
                    resolvedDeps = [ReflectiveDependency.fromKey(ReflectiveKey.get(provider.useExisting))];
                }
                else if (provider.useFactory) {
                    factoryFn = provider.useFactory;
                    resolvedDeps = constructDependencies(provider.useFactory, provider.deps);
                }
                else {
                    factoryFn = ( /**
                     * @return {?}
                     */function () { return provider.useValue; });
                    resolvedDeps = _EMPTY_LIST;
                }
                return new ResolvedReflectiveFactory(factoryFn, resolvedDeps);
            }
            /**
             * Converts the `Provider` into `ResolvedProvider`.
             *
             * `Injector` internally only uses `ResolvedProvider`, `Provider` contains convenience provider
             * syntax.
             * @param {?} provider
             * @return {?}
             */
            function resolveReflectiveProvider(provider) {
                return new ResolvedReflectiveProvider_(ReflectiveKey.get(provider.provide), [resolveReflectiveFactory(provider)], provider.multi || false);
            }
            /**
             * Resolve a list of Providers.
             * @param {?} providers
             * @return {?}
             */
            function resolveReflectiveProviders(providers) {
                /** @type {?} */
                var normalized = _normalizeProviders(providers, []);
                /** @type {?} */
                var resolved = normalized.map(resolveReflectiveProvider);
                /** @type {?} */
                var resolvedProviderMap = mergeResolvedReflectiveProviders(resolved, new Map());
                return Array.from(resolvedProviderMap.values());
            }
            /**
             * Merges a list of ResolvedProviders into a list where each key is contained exactly once and
             * multi providers have been merged.
             * @param {?} providers
             * @param {?} normalizedProvidersMap
             * @return {?}
             */
            function mergeResolvedReflectiveProviders(providers, normalizedProvidersMap) {
                for (var i = 0; i < providers.length; i++) {
                    /** @type {?} */
                    var provider = providers[i];
                    /** @type {?} */
                    var existing = normalizedProvidersMap.get(provider.key.id);
                    if (existing) {
                        if (provider.multiProvider !== existing.multiProvider) {
                            throw mixingMultiProvidersWithRegularProvidersError(existing, provider);
                        }
                        if (provider.multiProvider) {
                            for (var j = 0; j < provider.resolvedFactories.length; j++) {
                                existing.resolvedFactories.push(provider.resolvedFactories[j]);
                            }
                        }
                        else {
                            normalizedProvidersMap.set(provider.key.id, provider);
                        }
                    }
                    else {
                        /** @type {?} */
                        var resolvedProvider = void 0;
                        if (provider.multiProvider) {
                            resolvedProvider = new ResolvedReflectiveProvider_(provider.key, provider.resolvedFactories.slice(), provider.multiProvider);
                        }
                        else {
                            resolvedProvider = provider;
                        }
                        normalizedProvidersMap.set(provider.key.id, resolvedProvider);
                    }
                }
                return normalizedProvidersMap;
            }
            /**
             * @param {?} providers
             * @param {?} res
             * @return {?}
             */
            function _normalizeProviders(providers, res) {
                providers.forEach(( /**
                 * @param {?} b
                 * @return {?}
                 */function (/**
                 * @param {?} b
                 * @return {?}
                 */ b) {
                    if (b instanceof Type) {
                        res.push(( /** @type {?} */({ provide: b, useClass: b })));
                    }
                    else if (b && typeof b == 'object' && (( /** @type {?} */(b))).provide !== undefined) {
                        res.push(( /** @type {?} */(b)));
                    }
                    else if (b instanceof Array) {
                        _normalizeProviders(b, res);
                    }
                    else {
                        throw invalidProviderError(b);
                    }
                }));
                return res;
            }
            /**
             * @param {?} typeOrFunc
             * @param {?=} dependencies
             * @return {?}
             */
            function constructDependencies(typeOrFunc, dependencies) {
                if (!dependencies) {
                    return _dependenciesFor(typeOrFunc);
                }
                else {
                    /** @type {?} */
                    var params_5 = dependencies.map(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return [t]; }));
                    return dependencies.map(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return _extractToken(typeOrFunc, t, params_5); }));
                }
            }
            /**
             * @param {?} typeOrFunc
             * @return {?}
             */
            function _dependenciesFor(typeOrFunc) {
                /** @type {?} */
                var params = reflector.parameters(typeOrFunc);
                if (!params)
                    return [];
                if (params.some(( /**
                 * @param {?} p
                 * @return {?}
                 */function (/**
                 * @param {?} p
                 * @return {?}
                 */ p) { return p == null; }))) {
                    throw noAnnotationError(typeOrFunc, params);
                }
                return params.map(( /**
                 * @param {?} p
                 * @return {?}
                 */function (/**
                 * @param {?} p
                 * @return {?}
                 */ p) { return _extractToken(typeOrFunc, p, params); }));
            }
            /**
             * @param {?} typeOrFunc
             * @param {?} metadata
             * @param {?} params
             * @return {?}
             */
            function _extractToken(typeOrFunc, metadata, params) {
                /** @type {?} */
                var token = null;
                /** @type {?} */
                var optional = false;
                if (!Array.isArray(metadata)) {
                    if (metadata instanceof Inject) {
                        return _createDependency(metadata.token, optional, null);
                    }
                    else {
                        return _createDependency(metadata, optional, null);
                    }
                }
                /** @type {?} */
                var visibility = null;
                for (var i = 0; i < metadata.length; ++i) {
                    /** @type {?} */
                    var paramMetadata = metadata[i];
                    if (paramMetadata instanceof Type) {
                        token = paramMetadata;
                    }
                    else if (paramMetadata instanceof Inject) {
                        token = paramMetadata.token;
                    }
                    else if (paramMetadata instanceof Optional) {
                        optional = true;
                    }
                    else if (paramMetadata instanceof Self || paramMetadata instanceof SkipSelf) {
                        visibility = paramMetadata;
                    }
                    else if (paramMetadata instanceof InjectionToken) {
                        token = paramMetadata;
                    }
                }
                token = resolveForwardRef(token);
                if (token != null) {
                    return _createDependency(token, optional, visibility);
                }
                else {
                    throw noAnnotationError(typeOrFunc, params);
                }
            }
            /**
             * @param {?} token
             * @param {?} optional
             * @param {?} visibility
             * @return {?}
             */
            function _createDependency(token, optional, visibility) {
                return new ReflectiveDependency(ReflectiveKey.get(token), optional, visibility);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Threshold for the dynamic version
            /** @type {?} */
            var UNDEFINED = new Object();
            /**
             * A ReflectiveDependency injection container used for instantiating objects and resolving
             * dependencies.
             *
             * An `Injector` is a replacement for a `new` operator, which can automatically resolve the
             * constructor dependencies.
             *
             * In typical use, application code asks for the dependencies in the constructor and they are
             * resolved by the `Injector`.
             *
             * \@usageNotes
             * ### Example
             *
             * The following example creates an `Injector` configured to create `Engine` and `Car`.
             *
             * ```typescript
             * \@Injectable()
             * class Engine {
             * }
             *
             * \@Injectable()
             * class Car {
             *   constructor(public engine:Engine) {}
             * }
             *
             * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
             * var car = injector.get(Car);
             * expect(car instanceof Car).toBe(true);
             * expect(car.engine instanceof Engine).toBe(true);
             * ```
             *
             * Notice, we don't use the `new` operator because we explicitly want to have the `Injector`
             * resolve all of the object's dependencies automatically.
             *
             * @deprecated from v5 - slow and brings in a lot of code, Use `Injector.create` instead.
             * \@publicApi
             * @abstract
             */
            var ReflectiveInjector = /** @class */ (function () {
                function ReflectiveInjector() {
                }
                /**
                 * Turns an array of provider definitions into an array of resolved providers.
                 *
                 * A resolution is a process of flattening multiple nested arrays and converting individual
                 * providers into an array of `ResolvedReflectiveProvider`s.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * ```typescript
                 * \@Injectable()
                 * class Engine {
                 * }
                 *  /
                 * class Car {
                 *   constructor(public engine:Engine) {}
                 * }
                 *
                 * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
                 *
                 * expect(providers.length).toEqual(2);
                 *
                 * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
                 * expect(providers[0].key.displayName).toBe("Car");
                 * expect(providers[0].dependencies.length).toEqual(1);
                 * expect(providers[0].factory).toBeDefined();
                 *
                 * expect(providers[1].key.displayName).toBe("Engine");
                 * });
                 * ```
                 *
                 * @param {?} providers
                 * @return {?}
                 */
                ReflectiveInjector.resolve = function (providers) {
                    return resolveReflectiveProviders(providers);
                };
                /**
                 * Resolves an array of providers and creates an injector from those providers.
                 *
                 * The passed-in providers can be an array of `Type`, `Provider`,
                 * or a recursive array of more providers.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * ```typescript
                 * \@Injectable()
                 * class Engine {
                 * }
                 *  /
                 * class Car {
                 *   constructor(public engine:Engine) {}
                 * }
                 *
                 * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
                 * expect(injector.get(Car) instanceof Car).toBe(true);
                 * ```
                 * @param {?} providers
                 * @param {?=} parent
                 * @return {?}
                 */
                ReflectiveInjector.resolveAndCreate = function (providers, parent) {
                    /** @type {?} */
                    var ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
                    return ReflectiveInjector.fromResolvedProviders(ResolvedReflectiveProviders, parent);
                };
                /**
                 * Creates an injector from previously resolved providers.
                 *
                 * This API is the recommended way to construct injectors in performance-sensitive parts.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * ```typescript
                 * \@Injectable()
                 * class Engine {
                 * }
                 *  /
                 * class Car {
                 *   constructor(public engine:Engine) {}
                 * }
                 *
                 * var providers = ReflectiveInjector.resolve([Car, Engine]);
                 * var injector = ReflectiveInjector.fromResolvedProviders(providers);
                 * expect(injector.get(Car) instanceof Car).toBe(true);
                 * ```
                 * @param {?} providers
                 * @param {?=} parent
                 * @return {?}
                 */
                ReflectiveInjector.fromResolvedProviders = function (providers, parent) {
                    return new ReflectiveInjector_(providers, parent);
                };
                return ReflectiveInjector;
            }());
            if (false) { }
            var ReflectiveInjector_ = /** @class */ (function () {
                /**
                 * Private
                 * @param {?} _providers
                 * @param {?=} _parent
                 */
                function ReflectiveInjector_(_providers, _parent) {
                    /**
                     * \@internal
                     */
                    this._constructionCounter = 0;
                    this._providers = _providers;
                    this.parent = _parent || null;
                    /** @type {?} */
                    var len = _providers.length;
                    this.keyIds = new Array(len);
                    this.objs = new Array(len);
                    for (var i = 0; i < len; i++) {
                        this.keyIds[i] = _providers[i].key.id;
                        this.objs[i] = UNDEFINED;
                    }
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.get = function (token, notFoundValue) {
                    if (notFoundValue === void 0) { notFoundValue = THROW_IF_NOT_FOUND; }
                    return this._getByKey(ReflectiveKey.get(token), null, notFoundValue);
                };
                /**
                 * @param {?} providers
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.resolveAndCreateChild = function (providers) {
                    /** @type {?} */
                    var ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
                    return this.createChildFromResolved(ResolvedReflectiveProviders);
                };
                /**
                 * @param {?} providers
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.createChildFromResolved = function (providers) {
                    /** @type {?} */
                    var inj = new ReflectiveInjector_(providers);
                    (( /** @type {?} */(inj))).parent = this;
                    return inj;
                };
                /**
                 * @param {?} provider
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.resolveAndInstantiate = function (provider) {
                    return this.instantiateResolved(ReflectiveInjector.resolve([provider])[0]);
                };
                /**
                 * @param {?} provider
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.instantiateResolved = function (provider) {
                    return this._instantiateProvider(provider);
                };
                /**
                 * @param {?} index
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.getProviderAtIndex = function (index) {
                    if (index < 0 || index >= this._providers.length) {
                        throw outOfBoundsError(index);
                    }
                    return this._providers[index];
                };
                /**
                 * \@internal
                 * @param {?} provider
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._new = function (provider) {
                    if (this._constructionCounter++ > this._getMaxNumberOfObjects()) {
                        throw cyclicDependencyError(this, provider.key);
                    }
                    return this._instantiateProvider(provider);
                };
                /**
                 * @private
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._getMaxNumberOfObjects = function () { return this.objs.length; };
                /**
                 * @private
                 * @param {?} provider
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._instantiateProvider = function (provider) {
                    if (provider.multiProvider) {
                        /** @type {?} */
                        var res = new Array(provider.resolvedFactories.length);
                        for (var i = 0; i < provider.resolvedFactories.length; ++i) {
                            res[i] = this._instantiate(provider, provider.resolvedFactories[i]);
                        }
                        return res;
                    }
                    else {
                        return this._instantiate(provider, provider.resolvedFactories[0]);
                    }
                };
                /**
                 * @private
                 * @param {?} provider
                 * @param {?} ResolvedReflectiveFactory
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._instantiate = function (provider, ResolvedReflectiveFactory) {
                    var _this = this;
                    /** @type {?} */
                    var factory = ResolvedReflectiveFactory.factory;
                    /** @type {?} */
                    var deps;
                    try {
                        deps =
                            ResolvedReflectiveFactory.dependencies.map(( /**
                             * @param {?} dep
                             * @return {?}
                             */function (/**
                             * @param {?} dep
                             * @return {?}
                             */ dep) { return _this._getByReflectiveDependency(dep); }));
                    }
                    catch (e) {
                        if (e.addKey) {
                            e.addKey(this, provider.key);
                        }
                        throw e;
                    }
                    /** @type {?} */
                    var obj;
                    try {
                        obj = factory.apply(void 0, deps);
                    }
                    catch (e) {
                        throw instantiationError(this, e, e.stack, provider.key);
                    }
                    return obj;
                };
                /**
                 * @private
                 * @param {?} dep
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._getByReflectiveDependency = function (dep) {
                    return this._getByKey(dep.key, dep.visibility, dep.optional ? null : THROW_IF_NOT_FOUND);
                };
                /**
                 * @private
                 * @param {?} key
                 * @param {?} visibility
                 * @param {?} notFoundValue
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._getByKey = function (key, visibility, notFoundValue) {
                    if (key === ReflectiveInjector_.INJECTOR_KEY) {
                        return this;
                    }
                    if (visibility instanceof Self) {
                        return this._getByKeySelf(key, notFoundValue);
                    }
                    else {
                        return this._getByKeyDefault(key, notFoundValue, visibility);
                    }
                };
                /**
                 * @private
                 * @param {?} keyId
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._getObjByKeyId = function (keyId) {
                    for (var i = 0; i < this.keyIds.length; i++) {
                        if (this.keyIds[i] === keyId) {
                            if (this.objs[i] === UNDEFINED) {
                                this.objs[i] = this._new(this._providers[i]);
                            }
                            return this.objs[i];
                        }
                    }
                    return UNDEFINED;
                };
                /**
                 * \@internal
                 * @param {?} key
                 * @param {?} notFoundValue
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._throwOrNull = function (key, notFoundValue) {
                    if (notFoundValue !== THROW_IF_NOT_FOUND) {
                        return notFoundValue;
                    }
                    else {
                        throw noProviderError(this, key);
                    }
                };
                /**
                 * \@internal
                 * @param {?} key
                 * @param {?} notFoundValue
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._getByKeySelf = function (key, notFoundValue) {
                    /** @type {?} */
                    var obj = this._getObjByKeyId(key.id);
                    return (obj !== UNDEFINED) ? obj : this._throwOrNull(key, notFoundValue);
                };
                /**
                 * \@internal
                 * @param {?} key
                 * @param {?} notFoundValue
                 * @param {?} visibility
                 * @return {?}
                 */
                ReflectiveInjector_.prototype._getByKeyDefault = function (key, notFoundValue, visibility) {
                    /** @type {?} */
                    var inj;
                    if (visibility instanceof SkipSelf) {
                        inj = this.parent;
                    }
                    else {
                        inj = this;
                    }
                    while (inj instanceof ReflectiveInjector_) {
                        /** @type {?} */
                        var inj_ = ( /** @type {?} */(inj));
                        /** @type {?} */
                        var obj = inj_._getObjByKeyId(key.id);
                        if (obj !== UNDEFINED)
                            return obj;
                        inj = inj_.parent;
                    }
                    if (inj !== null) {
                        return inj.get(key.token, notFoundValue);
                    }
                    else {
                        return this._throwOrNull(key, notFoundValue);
                    }
                };
                Object.defineProperty(ReflectiveInjector_.prototype, "displayName", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var providers = _mapProviders(this, ( /**
                         * @param {?} b
                         * @return {?}
                         */function (b) { return ' "' + b.key.displayName + '" '; }))
                            .join(', ');
                        return "ReflectiveInjector(providers: [" + providers + "])";
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ReflectiveInjector_.prototype.toString = function () { return this.displayName; };
                return ReflectiveInjector_;
            }());
            ReflectiveInjector_.INJECTOR_KEY = ReflectiveKey.get(Injector);
            if (false) { }
            /**
             * @param {?} injector
             * @param {?} fn
             * @return {?}
             */
            function _mapProviders(injector, fn) {
                /** @type {?} */
                var res = new Array(injector._providers.length);
                for (var i = 0; i < injector._providers.length; ++i) {
                    res[i] = fn(injector.getProviderAtIndex(i));
                }
                return res;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A DI token that you can use to create a virtual [provider](guide/glossary#provider)
             * that will populate the `entryComponents` field of components and NgModules
             * based on its `useValue` property value.
             * All components that are referenced in the `useValue` value (either directly
             * or in a nested array or map) are added to the `entryComponents` property.
             *
             * \@usageNotes
             *
             * The following example shows how the router can populate the `entryComponents`
             * field of an NgModule based on a router configuration that refers
             * to components.
             *
             * ```typescript
             * // helper function inside the router
             * function provideRoutes(routes) {
             *   return [
             *     {provide: ROUTES, useValue: routes},
             *     {provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: routes, multi: true}
             *   ];
             * }
             *
             * // user code
             * let routes = [
             *   {path: '/root', component: RootComp},
             *   {path: '/teams', component: TeamsComp}
             * ];
             *
             * \@NgModule({
             *   providers: [provideRoutes(routes)]
             * })
             * class ModuleWithRoutes {}
             * ```
             *
             * \@publicApi
             * @type {?}
             */
            var ANALYZE_FOR_ENTRY_COMPONENTS = new InjectionToken('AnalyzeForEntryComponents');
            /**
             * Type of the `Attribute` decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function AttributeDecorator$1() { }
            /**
             * Type of the Attribute metadata.
             *
             * \@publicApi
             * @record
             */
            function Attribute$1() { }
            if (false) { }
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * Base class for query metadata.
             *
             * @see `ContentChildren`.
             * @see `ContentChild`.
             * @see `ViewChildren`.
             * @see `ViewChild`.
             *
             * \@publicApi
             * @abstract
             */
            var Query = /** @class */ (function () {
                function Query() {
                }
                return Query;
            }());
            /**
             * Type of the ContentChildren decorator / constructor function.
             *
             * @see `ContentChildren`.
             * \@publicApi
             * @record
             */
            function ContentChildrenDecorator() { }
            var ɵ0$b = /**
             * @param {?=} selector
             * @param {?=} data
             * @return {?}
             */ function (selector, data) {
                if (data === void 0) { data = {}; }
                return (Object.assign({ selector: selector, first: false, isViewQuery: false, descendants: false }, data));
            };
            /**
             * ContentChildren decorator and metadata.
             *
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var ContentChildren = makePropDecorator('ContentChildren', (ɵ0$b), Query);
            /**
             * Type of the ContentChild decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function ContentChildDecorator() { }
            var ɵ1$3 = /**
             * @param {?=} selector
             * @param {?=} data
             * @return {?}
             */ function (selector, data) {
                if (data === void 0) { data = {}; }
                return (Object.assign({ selector: selector, first: true, isViewQuery: false, descendants: true }, data));
            };
            /**
             * ContentChild decorator and metadata.
             *
             *
             * \@Annotation
             *
             * \@publicApi
             * @type {?}
             */
            var ContentChild = makePropDecorator('ContentChild', (ɵ1$3), Query);
            /**
             * Type of the ViewChildren decorator / constructor function.
             *
             * @see `ViewChildren`.
             *
             * \@publicApi
             * @record
             */
            function ViewChildrenDecorator() { }
            var ɵ2 = /**
             * @param {?=} selector
             * @param {?=} data
             * @return {?}
             */ function (selector, data) {
                if (data === void 0) { data = {}; }
                return (Object.assign({ selector: selector, first: false, isViewQuery: true, descendants: true }, data));
            };
            /**
             * ViewChildren decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var ViewChildren = makePropDecorator('ViewChildren', (ɵ2), Query);
            /**
             * Type of the ViewChild decorator / constructor function.
             *
             * @see `ViewChild`.
             * \@publicApi
             * @record
             */
            function ViewChildDecorator() { }
            var ɵ3 = /**
             * @param {?} selector
             * @param {?} data
             * @return {?}
             */ function (selector, data) { return (Object.assign({ selector: selector, first: true, isViewQuery: true, descendants: true }, data)); };
            /**
             * ViewChild decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var ViewChild = makePropDecorator('ViewChild', (ɵ3), Query);
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Used to resolve resource URLs on `\@Component` when used with JIT compilation.
             *
             * Example:
             * ```
             * \@Component({
             *   selector: 'my-comp',
             *   templateUrl: 'my-comp.html', // This requires asynchronous resolution
             * })
             * class MyComponent{
             * }
             *
             * // Calling `renderComponent` will fail because `renderComponent` is a synchronous process
             * // and `MyComponent`'s `\@Component.templateUrl` needs to be resolved asynchronously.
             *
             * // Calling `resolveComponentResources()` will resolve `\@Component.templateUrl` into
             * // `\@Component.template`, which allows `renderComponent` to proceed in a synchronous manner.
             *
             * // Use browser's `fetch()` function as the default resource resolution strategy.
             * resolveComponentResources(fetch).then(() => {
             *   // After resolution all URLs have been converted into `template` strings.
             *   renderComponent(MyComponent);
             * });
             *
             * ```
             *
             * NOTE: In AOT the resolution happens during compilation, and so there should be no need
             * to call this method outside JIT mode.
             *
             * @param {?} resourceResolver a function which is responsible for returning a `Promise` to the
             * contents of the resolved URL. Browser's `fetch()` method is a good default implementation.
             * @return {?}
             */
            function resolveComponentResources(resourceResolver) {
                // Store all promises which are fetching the resources.
                /** @type {?} */
                var componentResolved = [];
                // Cache so that we don't fetch the same resource more than once.
                /** @type {?} */
                var urlMap = new Map();
                /**
                 * @param {?} url
                 * @return {?}
                 */
                function cachedResourceResolve(url) {
                    /** @type {?} */
                    var promise = urlMap.get(url);
                    if (!promise) {
                        /** @type {?} */
                        var resp = resourceResolver(url);
                        urlMap.set(url, promise = resp.then(unwrapResponse));
                    }
                    return promise;
                }
                componentResourceResolutionQueue.forEach(( /**
                 * @param {?} component
                 * @param {?} type
                 * @return {?}
                 */function (component, type) {
                    /** @type {?} */
                    var promises = [];
                    if (component.templateUrl) {
                        promises.push(cachedResourceResolve(component.templateUrl).then(( /**
                         * @param {?} template
                         * @return {?}
                         */function (template) {
                            component.template = template;
                        })));
                    }
                    /** @type {?} */
                    var styleUrls = component.styleUrls;
                    /** @type {?} */
                    var styles = component.styles || (component.styles = []);
                    /** @type {?} */
                    var styleOffset = component.styles.length;
                    styleUrls && styleUrls.forEach(( /**
                     * @param {?} styleUrl
                     * @param {?} index
                     * @return {?}
                     */function (styleUrl, index) {
                        styles.push(''); // pre-allocate array.
                        promises.push(cachedResourceResolve(styleUrl).then(( /**
                         * @param {?} style
                         * @return {?}
                         */function (style) {
                            styles[styleOffset + index] = style;
                            styleUrls.splice(styleUrls.indexOf(styleUrl), 1);
                            if (styleUrls.length == 0) {
                                component.styleUrls = undefined;
                            }
                        })));
                    }));
                    /** @type {?} */
                    var fullyResolved = Promise.all(promises).then(( /**
                     * @return {?}
                     */function () { return componentDefResolved(type); }));
                    componentResolved.push(fullyResolved);
                }));
                clearResolutionOfComponentResourcesQueue();
                return Promise.all(componentResolved).then(( /**
                 * @return {?}
                 */function () { return undefined; }));
            }
            /** @type {?} */
            var componentResourceResolutionQueue = new Map();
            // Track when existing ngComponentDef for a Type is waiting on resources.
            /** @type {?} */
            var componentDefPendingResolution = new Set();
            /**
             * @param {?} type
             * @param {?} metadata
             * @return {?}
             */
            function maybeQueueResolutionOfComponentResources(type, metadata) {
                if (componentNeedsResolution(metadata)) {
                    componentResourceResolutionQueue.set(type, metadata);
                    componentDefPendingResolution.add(type);
                }
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function isComponentDefPendingResolution(type) {
                return componentDefPendingResolution.has(type);
            }
            /**
             * @param {?} component
             * @return {?}
             */
            function componentNeedsResolution(component) {
                return !!((component.templateUrl && !component.hasOwnProperty('template')) ||
                    component.styleUrls && component.styleUrls.length);
            }
            /**
             * @return {?}
             */
            function clearResolutionOfComponentResourcesQueue() {
                /** @type {?} */
                var old = componentResourceResolutionQueue;
                componentResourceResolutionQueue = new Map();
                return old;
            }
            /**
             * @param {?} queue
             * @return {?}
             */
            function restoreComponentResolutionQueue(queue) {
                componentDefPendingResolution.clear();
                queue.forEach(( /**
                 * @param {?} _
                 * @param {?} type
                 * @return {?}
                 */function (_, type) { return componentDefPendingResolution.add(type); }));
                componentResourceResolutionQueue = queue;
            }
            /**
             * @return {?}
             */
            function isComponentResourceResolutionQueueEmpty() {
                return componentResourceResolutionQueue.size === 0;
            }
            /**
             * @param {?} response
             * @return {?}
             */
            function unwrapResponse(response) {
                return typeof response == 'string' ? response : response.text();
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function componentDefResolved(type) {
                componentDefPendingResolution.delete(type);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Allocates the necessary amount of slots for host vars.
             *
             * \@codeGenApi
             * @param {?} count Amount of vars to be allocated
             *
             * @return {?}
             */
            function ɵɵallocHostVars(count) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                if (!tView.firstTemplatePass)
                    return;
                queueHostBindingForCheck(tView, ( /** @type {?} */(getCurrentDirectiveDef())), count);
                prefillHostVars(tView, lView, count);
            }
            /**
             * Stores host binding fn and number of host vars so it will be queued for binding refresh during
             * CD.
             * @param {?} tView
             * @param {?} def
             * @param {?} hostVars
             * @return {?}
             */
            function queueHostBindingForCheck(tView, def, hostVars) {
                ngDevMode &&
                    assertEqual(tView.firstTemplatePass, true, 'Should only be called in first template pass.');
                /** @type {?} */
                var expando = ( /** @type {?} */(tView.expandoInstructions));
                /** @type {?} */
                var length = expando.length;
                // Check whether a given `hostBindings` function already exists in expandoInstructions,
                // which can happen in case directive definition was extended from base definition (as a part of
                // the `InheritDefinitionFeature` logic). If we found the same `hostBindings` function in the
                // list, we just increase the number of host vars associated with that function, but do not add it
                // into the list again.
                if (length >= 2 && expando[length - 2] === def.hostBindings) {
                    expando[length - 1] = (( /** @type {?} */(expando[length - 1]))) + hostVars;
                }
                else {
                    expando.push(( /** @type {?} */(def.hostBindings)), hostVars);
                }
            }
            /**
             * On the first template pass, we need to reserve space for host binding values
             * after directives are matched (so all directives are saved, then bindings).
             * Because we are updating the blueprint, we only need to do this once.
             * @param {?} tView
             * @param {?} lView
             * @param {?} totalHostVars
             * @return {?}
             */
            function prefillHostVars(tView, lView, totalHostVars) {
                ngDevMode &&
                    assertEqual(tView.firstTemplatePass, true, 'Should only be called in first template pass.');
                for (var i = 0; i < totalHostVars; i++) {
                    lView.push(NO_CHANGE);
                    tView.blueprint.push(NO_CHANGE);
                    tView.data.push(null);
                }
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var _symbolIterator = null;
            function getSymbolIterator() {
                if (!_symbolIterator) {
                    var Symbol = _global['Symbol'];
                    if (Symbol && Symbol.iterator) {
                        _symbolIterator = Symbol.iterator;
                    }
                    else {
                        // es6-shim specific logic
                        var keys = Object.getOwnPropertyNames(Map.prototype);
                        for (var i = 0; i < keys.length; ++i) {
                            var key = keys[i];
                            if (key !== 'entries' && key !== 'size' &&
                                Map.prototype[key] === Map.prototype['entries']) {
                                _symbolIterator = key;
                            }
                        }
                    }
                }
                return _symbolIterator;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function isListLikeIterable(obj) {
                if (!isJsObject(obj))
                    return false;
                return Array.isArray(obj) ||
                    (!(obj instanceof Map) && // JS Map are iterables but return entries as [k, v]
                        getSymbolIterator() in obj); // JS Iterable have a Symbol.iterator prop
            }
            function areIterablesEqual(a, b, comparator) {
                var iterator1 = a[getSymbolIterator()]();
                var iterator2 = b[getSymbolIterator()]();
                while (true) {
                    var item1 = iterator1.next();
                    var item2 = iterator2.next();
                    if (item1.done && item2.done)
                        return true;
                    if (item1.done || item2.done)
                        return false;
                    if (!comparator(item1.value, item2.value))
                        return false;
                }
            }
            function iterateListLike(obj, fn) {
                if (Array.isArray(obj)) {
                    for (var i = 0; i < obj.length; i++) {
                        fn(obj[i]);
                    }
                }
                else {
                    var iterator = obj[getSymbolIterator()]();
                    var item = void 0;
                    while (!((item = iterator.next()).done)) {
                        fn(item.value);
                    }
                }
            }
            function isJsObject(o) {
                return o !== null && (typeof o === 'function' || typeof o === 'object');
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // JS has NaN !== NaN
            function looseIdentical(a, b) {
                return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
            }
            function devModeEqual(a, b) {
                var isListLikeIterableA = isListLikeIterable(a);
                var isListLikeIterableB = isListLikeIterable(b);
                if (isListLikeIterableA && isListLikeIterableB) {
                    return areIterablesEqual(a, b, devModeEqual);
                }
                else {
                    var isAObject = a && (typeof a === 'object' || typeof a === 'function');
                    var isBObject = b && (typeof b === 'object' || typeof b === 'function');
                    if (!isListLikeIterableA && isAObject && !isListLikeIterableB && isBObject) {
                        return true;
                    }
                    else {
                        return looseIdentical(a, b);
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function devModeEqual$1(a, b) {
                /** @type {?} */
                var isListLikeIterableA = isListLikeIterable$1(a);
                /** @type {?} */
                var isListLikeIterableB = isListLikeIterable$1(b);
                if (isListLikeIterableA && isListLikeIterableB) {
                    return areIterablesEqual$1(a, b, devModeEqual$1);
                }
                else {
                    /** @type {?} */
                    var isAObject = a && (typeof a === 'object' || typeof a === 'function');
                    /** @type {?} */
                    var isBObject = b && (typeof b === 'object' || typeof b === 'function');
                    if (!isListLikeIterableA && isAObject && !isListLikeIterableB && isBObject) {
                        return true;
                    }
                    else {
                        return looseIdentical(a, b);
                    }
                }
            }
            /**
             * Indicates that the result of a {\@link Pipe} transformation has changed even though the
             * reference has not changed.
             *
             * Wrapped values are unwrapped automatically during the change detection, and the unwrapped value
             * is stored.
             *
             * Example:
             *
             * ```
             * if (this._latestValue === this._latestReturnedValue) {
             *    return this._latestReturnedValue;
             *  } else {
             *    this._latestReturnedValue = this._latestValue;
             *    return WrappedValue.wrap(this._latestValue); // this will force update
             *  }
             * ```
             *
             * \@publicApi
             */
            var WrappedValue = /** @class */ (function () {
                /**
                 * @param {?} value
                 */
                function WrappedValue(value) {
                    this.wrapped = value;
                }
                /**
                 * Creates a wrapped value.
                 * @param {?} value
                 * @return {?}
                 */
                WrappedValue.wrap = function (value) { return new WrappedValue(value); };
                /**
                 * Returns the underlying value of a wrapped value.
                 * Returns the given `value` when it is not wrapped.
                 *
                 * @param {?} value
                 * @return {?}
                 */
                WrappedValue.unwrap = function (value) { return WrappedValue.isWrapped(value) ? value.wrapped : value; };
                /**
                 * Returns true if `value` is a wrapped value.
                 * @param {?} value
                 * @return {?}
                 */
                WrappedValue.isWrapped = function (value) { return value instanceof WrappedValue; };
                return WrappedValue;
            }());
            if (false) { }
            /**
             * @param {?} obj
             * @return {?}
             */
            function isListLikeIterable$1(obj) {
                if (!isJsObject$1(obj))
                    return false;
                return Array.isArray(obj) ||
                    (!(obj instanceof Map) && // JS Map are iterables but return entries as [k, v]
                        getSymbolIterator() in obj); // JS Iterable have a Symbol.iterator prop
            }
            /**
             * @param {?} a
             * @param {?} b
             * @param {?} comparator
             * @return {?}
             */
            function areIterablesEqual$1(a, b, comparator) {
                /** @type {?} */
                var iterator1 = a[getSymbolIterator()]();
                /** @type {?} */
                var iterator2 = b[getSymbolIterator()]();
                while (true) {
                    /** @type {?} */
                    var item1 = iterator1.next();
                    /** @type {?} */
                    var item2 = iterator2.next();
                    if (item1.done && item2.done)
                        return true;
                    if (item1.done || item2.done)
                        return false;
                    if (!comparator(item1.value, item2.value))
                        return false;
                }
            }
            /**
             * @param {?} obj
             * @param {?} fn
             * @return {?}
             */
            function iterateListLike$1(obj, fn) {
                if (Array.isArray(obj)) {
                    for (var i = 0; i < obj.length; i++) {
                        fn(obj[i]);
                    }
                }
                else {
                    /** @type {?} */
                    var iterator = obj[getSymbolIterator()]();
                    /** @type {?} */
                    var item = void 0;
                    while (!((item = iterator.next()).done)) {
                        fn(item.value);
                    }
                }
            }
            /**
             * @param {?} o
             * @return {?}
             */
            function isJsObject$1(o) {
                return o !== null && (typeof o === 'function' || typeof o === 'object');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO(misko): consider inlining
            /**
             * Updates binding and returns the value.
             * @param {?} lView
             * @param {?} bindingIndex
             * @param {?} value
             * @return {?}
             */
            function updateBinding(lView, bindingIndex, value) {
                return lView[bindingIndex] = value;
            }
            /**
             * Gets the current binding value.
             * @param {?} lView
             * @param {?} bindingIndex
             * @return {?}
             */
            function getBinding(lView, bindingIndex) {
                ngDevMode && assertDataInRange(lView, bindingIndex);
                ngDevMode &&
                    assertNotSame(lView[bindingIndex], NO_CHANGE, 'Stored value should never be NO_CHANGE.');
                return lView[bindingIndex];
            }
            /**
             * Updates binding if changed, then returns whether it was updated.
             * @param {?} lView
             * @param {?} bindingIndex
             * @param {?} value
             * @return {?}
             */
            function bindingUpdated(lView, bindingIndex, value) {
                ngDevMode && assertNotSame(value, NO_CHANGE, 'Incoming value should never be NO_CHANGE.');
                ngDevMode &&
                    assertLessThan(bindingIndex, lView.length, "Slot should have been initialized to NO_CHANGE");
                /** @type {?} */
                var oldValue = lView[bindingIndex];
                if (isDifferent(oldValue, value)) {
                    if (ngDevMode && getCheckNoChangesMode()) {
                        // View engine didn't report undefined values as changed on the first checkNoChanges pass
                        // (before the change detection was run).
                        /** @type {?} */
                        var oldValueToCompare = oldValue !== NO_CHANGE ? oldValue : undefined;
                        if (!devModeEqual$1(oldValueToCompare, value)) {
                            throwErrorIfNoChangesMode(oldValue === NO_CHANGE, oldValueToCompare, value);
                        }
                    }
                    lView[bindingIndex] = value;
                    return true;
                }
                return false;
            }
            /**
             * Updates 2 bindings if changed, then returns whether either was updated.
             * @param {?} lView
             * @param {?} bindingIndex
             * @param {?} exp1
             * @param {?} exp2
             * @return {?}
             */
            function bindingUpdated2(lView, bindingIndex, exp1, exp2) {
                /** @type {?} */
                var different = bindingUpdated(lView, bindingIndex, exp1);
                return bindingUpdated(lView, bindingIndex + 1, exp2) || different;
            }
            /**
             * Updates 3 bindings if changed, then returns whether any was updated.
             * @param {?} lView
             * @param {?} bindingIndex
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @return {?}
             */
            function bindingUpdated3(lView, bindingIndex, exp1, exp2, exp3) {
                /** @type {?} */
                var different = bindingUpdated2(lView, bindingIndex, exp1, exp2);
                return bindingUpdated(lView, bindingIndex + 2, exp3) || different;
            }
            /**
             * Updates 4 bindings if changed, then returns whether any was updated.
             * @param {?} lView
             * @param {?} bindingIndex
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?} exp4
             * @return {?}
             */
            function bindingUpdated4(lView, bindingIndex, exp1, exp2, exp3, exp4) {
                /** @type {?} */
                var different = bindingUpdated2(lView, bindingIndex, exp1, exp2);
                return bindingUpdated2(lView, bindingIndex + 2, exp3, exp4) || different;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Update a property on a selected element.
             *
             * Operates on the element selected by index via the {\@link select} instruction.
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled
             *
             * \@codeGenApi
             * @template T
             * @param {?} propName Name of property. Because it is going to DOM, this is not subject to
             *        renaming as part of minification.
             * @param {?} value New value to write.
             * @param {?=} sanitizer An optional function used to sanitize the value.
             * @return {?} This function returns itself so that it may be chained
             * (e.g. `property('name', ctx.name)('title', ctx.title)`)
             *
             */
            function ɵɵproperty(propName, value, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                ngDevMode && assertNotEqual(index, -1, 'selected index cannot be -1');
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var bindReconciledValue = bind(lView, value);
                if (bindReconciledValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, bindReconciledValue, sanitizer);
                }
                return ɵɵproperty;
            }
            /**
             * Creates a single value binding.
             *
             * @template T
             * @param {?} lView Current view
             * @param {?} value Value to diff
             * @return {?}
             */
            function bind(lView, value) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX]++;
                storeBindingMetadata(lView);
                return bindingUpdated(lView, bindingIndex, value) ? value : NO_CHANGE;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Updates the value of or removes a bound attribute on an Element.
             *
             * Used in the case of `[attr.title]="value"`
             *
             * \@codeGenApi
             * @param {?} name name The name of the attribute.
             * @param {?} value value The attribute is removed when value is `null` or `undefined`.
             *                  Otherwise the attribute value is set to the stringified value.
             * @param {?=} sanitizer An optional function used to sanitize the value.
             * @param {?=} namespace Optional namespace to use when setting the attribute.
             *
             * @return {?}
             */
            function ɵɵattribute(name, value, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var bound = bind(lView, value);
                if (bound !== NO_CHANGE) {
                    elementAttributeInternal(index, name, bound, lView, sanitizer, namespace);
                }
                return ɵɵattribute;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Create interpolation bindings with a variable number of expressions.
             *
             * If there are 1 to 8 expressions `interpolation1()` to `interpolation8()` should be used instead.
             * Those are faster because there is no need to create an array of expressions and iterate over it.
             *
             * `values`:
             * - has static text at even indexes,
             * - has evaluated expressions at odd indexes.
             *
             * Returns the concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
             * @param {?} lView
             * @param {?} values
             * @return {?}
             */
            function interpolationV(lView, values) {
                ngDevMode && assertLessThan(2, values.length, 'should have at least 3 values');
                ngDevMode && assertEqual(values.length % 2, 1, 'should have an odd number of values');
                /** @type {?} */
                var isBindingUpdated = false;
                /** @type {?} */
                var tData = lView[TVIEW].data;
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                if (tData[bindingIndex] == null) {
                    // 2 is the index of the first static interstitial value (ie. not prefix)
                    for (var i = 2; i < values.length; i += 2) {
                        tData[bindingIndex++] = values[i];
                    }
                    bindingIndex = lView[BINDING_INDEX];
                }
                for (var i = 1; i < values.length; i += 2) {
                    // Check if bindings (odd indexes) have changed
                    isBindingUpdated = bindingUpdated(lView, bindingIndex++, values[i]) || isBindingUpdated;
                }
                lView[BINDING_INDEX] = bindingIndex;
                storeBindingMetadata(lView, values[0], values[values.length - 1]);
                if (!isBindingUpdated) {
                    return NO_CHANGE;
                }
                // Build the updated content
                /** @type {?} */
                var content = values[0];
                for (var i = 1; i < values.length; i += 2) {
                    content += renderStringify(values[i]) + values[i + 1];
                }
                return content;
            }
            /**
             * Creates an interpolation binding with 1 expression.
             *
             * @param {?} lView
             * @param {?} prefix static value used for concatenation only.
             * @param {?} v0 value checked for change.
             * @param {?} suffix static value used for concatenation only.
             * @return {?}
             */
            function interpolation1(lView, prefix, v0, suffix) {
                /** @type {?} */
                var different = bindingUpdated(lView, lView[BINDING_INDEX]++, v0);
                storeBindingMetadata(lView, prefix, suffix);
                return different ? prefix + renderStringify(v0) + suffix : NO_CHANGE;
            }
            /**
             * Creates an interpolation binding with 2 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} suffix
             * @return {?}
             */
            function interpolation2(lView, prefix, v0, i0, v1, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated2(lView, bindingIndex, v0, v1);
                lView[BINDING_INDEX] += 2;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    lView[TVIEW].data[bindingIndex] = i0;
                }
                return different ? prefix + renderStringify(v0) + i0 + renderStringify(v1) + suffix : NO_CHANGE;
            }
            /**
             * Creates an interpolation binding with 3 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} suffix
             * @return {?}
             */
            function interpolation3(lView, prefix, v0, i0, v1, i1, v2, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated3(lView, bindingIndex, v0, v1, v2);
                lView[BINDING_INDEX] += 3;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    /** @type {?} */
                    var tData = lView[TVIEW].data;
                    tData[bindingIndex] = i0;
                    tData[bindingIndex + 1] = i1;
                }
                return different ?
                    prefix + renderStringify(v0) + i0 + renderStringify(v1) + i1 + renderStringify(v2) + suffix :
                    NO_CHANGE;
            }
            /**
             * Create an interpolation binding with 4 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} suffix
             * @return {?}
             */
            function interpolation4(lView, prefix, v0, i0, v1, i1, v2, i2, v3, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, v0, v1, v2, v3);
                lView[BINDING_INDEX] += 4;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    /** @type {?} */
                    var tData = lView[TVIEW].data;
                    tData[bindingIndex] = i0;
                    tData[bindingIndex + 1] = i1;
                    tData[bindingIndex + 2] = i2;
                }
                return different ?
                    prefix + renderStringify(v0) + i0 + renderStringify(v1) + i1 + renderStringify(v2) + i2 +
                        renderStringify(v3) + suffix :
                    NO_CHANGE;
            }
            /**
             * Creates an interpolation binding with 5 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} suffix
             * @return {?}
             */
            function interpolation5(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, v0, v1, v2, v3);
                different = bindingUpdated(lView, bindingIndex + 4, v4) || different;
                lView[BINDING_INDEX] += 5;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    /** @type {?} */
                    var tData = lView[TVIEW].data;
                    tData[bindingIndex] = i0;
                    tData[bindingIndex + 1] = i1;
                    tData[bindingIndex + 2] = i2;
                    tData[bindingIndex + 3] = i3;
                }
                return different ?
                    prefix + renderStringify(v0) + i0 + renderStringify(v1) + i1 + renderStringify(v2) + i2 +
                        renderStringify(v3) + i3 + renderStringify(v4) + suffix :
                    NO_CHANGE;
            }
            /**
             * Creates an interpolation binding with 6 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} i4
             * @param {?} v5
             * @param {?} suffix
             * @return {?}
             */
            function interpolation6(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, v0, v1, v2, v3);
                different = bindingUpdated2(lView, bindingIndex + 4, v4, v5) || different;
                lView[BINDING_INDEX] += 6;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    /** @type {?} */
                    var tData = lView[TVIEW].data;
                    tData[bindingIndex] = i0;
                    tData[bindingIndex + 1] = i1;
                    tData[bindingIndex + 2] = i2;
                    tData[bindingIndex + 3] = i3;
                    tData[bindingIndex + 4] = i4;
                }
                return different ?
                    prefix + renderStringify(v0) + i0 + renderStringify(v1) + i1 + renderStringify(v2) + i2 +
                        renderStringify(v3) + i3 + renderStringify(v4) + i4 + renderStringify(v5) + suffix :
                    NO_CHANGE;
            }
            /**
             * Creates an interpolation binding with 7 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} i4
             * @param {?} v5
             * @param {?} i5
             * @param {?} v6
             * @param {?} suffix
             * @return {?}
             */
            function interpolation7(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, v0, v1, v2, v3);
                different = bindingUpdated3(lView, bindingIndex + 4, v4, v5, v6) || different;
                lView[BINDING_INDEX] += 7;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    /** @type {?} */
                    var tData = lView[TVIEW].data;
                    tData[bindingIndex] = i0;
                    tData[bindingIndex + 1] = i1;
                    tData[bindingIndex + 2] = i2;
                    tData[bindingIndex + 3] = i3;
                    tData[bindingIndex + 4] = i4;
                    tData[bindingIndex + 5] = i5;
                }
                return different ?
                    prefix + renderStringify(v0) + i0 + renderStringify(v1) + i1 + renderStringify(v2) + i2 +
                        renderStringify(v3) + i3 + renderStringify(v4) + i4 + renderStringify(v5) + i5 +
                        renderStringify(v6) + suffix :
                    NO_CHANGE;
            }
            /**
             * Creates an interpolation binding with 8 expressions.
             * @param {?} lView
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} i4
             * @param {?} v5
             * @param {?} i5
             * @param {?} v6
             * @param {?} i6
             * @param {?} v7
             * @param {?} suffix
             * @return {?}
             */
            function interpolation8(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix) {
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX];
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, v0, v1, v2, v3);
                different = bindingUpdated4(lView, bindingIndex + 4, v4, v5, v6, v7) || different;
                lView[BINDING_INDEX] += 8;
                // Only set static strings the first time (data will be null subsequent runs).
                /** @type {?} */
                var data = storeBindingMetadata(lView, prefix, suffix);
                if (data) {
                    /** @type {?} */
                    var tData = lView[TVIEW].data;
                    tData[bindingIndex] = i0;
                    tData[bindingIndex + 1] = i1;
                    tData[bindingIndex + 2] = i2;
                    tData[bindingIndex + 3] = i3;
                    tData[bindingIndex + 4] = i4;
                    tData[bindingIndex + 5] = i5;
                    tData[bindingIndex + 6] = i6;
                }
                return different ?
                    prefix + renderStringify(v0) + i0 + renderStringify(v1) + i1 + renderStringify(v2) + i2 +
                        renderStringify(v3) + i3 + renderStringify(v4) + i4 + renderStringify(v5) + i5 +
                        renderStringify(v6) + i6 + renderStringify(v7) + suffix :
                    NO_CHANGE;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             *
             * Update an interpolated attribute on an element with single bound value surrounded by text.
             *
             * Used when the value passed to a property has 1 interpolated value in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate1('title', 'prefix', v0, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate1(attrName, prefix, v0, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation1(lView, prefix, v0, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate1;
            }
            /**
             *
             * Update an interpolated attribute on an element with 2 bound values surrounded by text.
             *
             * Used when the value passed to a property has 2 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate2('title', 'prefix', v0, '-', v1, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate2(attrName, prefix, v0, i0, v1, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation2(lView, prefix, v0, i0, v1, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate2;
            }
            /**
             *
             * Update an interpolated attribute on an element with 3 bound values surrounded by text.
             *
             * Used when the value passed to a property has 3 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}-{{v2}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate3(
             * 'title', 'prefix', v0, '-', v1, '-', v2, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate3(attrName, prefix, v0, i0, v1, i1, v2, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation3(lView, prefix, v0, i0, v1, i1, v2, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate3;
            }
            /**
             *
             * Update an interpolated attribute on an element with 4 bound values surrounded by text.
             *
             * Used when the value passed to a property has 4 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate4(
             * 'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate4(attrName, prefix, v0, i0, v1, i1, v2, i2, v3, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation4(lView, prefix, v0, i0, v1, i1, v2, i2, v3, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate4;
            }
            /**
             *
             * Update an interpolated attribute on an element with 5 bound values surrounded by text.
             *
             * Used when the value passed to a property has 5 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate5(
             * 'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate5(attrName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation5(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate5;
            }
            /**
             *
             * Update an interpolated attribute on an element with 6 bound values surrounded by text.
             *
             * Used when the value passed to a property has 6 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate6(
             *    'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate6(attrName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation6(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate6;
            }
            /**
             *
             * Update an interpolated attribute on an element with 7 bound values surrounded by text.
             *
             * Used when the value passed to a property has 7 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate7(
             *    'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate7(attrName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation7(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate7;
            }
            /**
             *
             * Update an interpolated attribute on an element with 8 bound values surrounded by text.
             *
             * Used when the value passed to a property has 8 interpolated values in it:
             *
             * ```html
             * <div attr.title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolate8(
             *  'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} i6 Static value used for concatenation only.
             * @param {?} v7 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolate8(attrName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation8(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolatedValue, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolate8;
            }
            /**
             * Update an interpolated attribute on an element with 8 or more bound values surrounded by text.
             *
             * Used when the number of interpolated values exceeds 7.
             *
             * ```html
             * <div
             *  title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}-{{v8}}-{{v9}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵattributeInterpolateV(
             *  'title', ['prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, '-', v9,
             *  'suffix']);
             * ```
             *
             * \@codeGenApi
             * @param {?} attrName The name of the attribute to update.
             * @param {?} values The a collection of values and the strings in-between those values, beginning with
             * a string prefix and ending with a string suffix.
             * (e.g. `['prefix', value0, '-', value1, '-', value2, ..., value99, 'suffix']`)
             * @param {?=} sanitizer An optional sanitizer function
             * @param {?=} namespace
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵattributeInterpolateV(attrName, values, sanitizer, namespace) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolationV(lView, values);
                if (interpolated !== NO_CHANGE) {
                    elementAttributeInternal(index, attrName, interpolated, lView, sanitizer, namespace);
                }
                return ɵɵattributeInterpolateV;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Synchronously perform change detection on a component (and possibly its sub-components).
             *
             * This function triggers change detection in a synchronous way on a component. There should
             * be very little reason to call this function directly since a preferred way to do change
             * detection is to {\@link markDirty} the component and wait for the scheduler to call this method
             * at some future point in time. This is because a single user action often results in many
             * components being invalidated and calling change detection on each component synchronously
             * would be inefficient. It is better to wait until all components are marked as dirty and
             * then perform single change detection across all of the components
             *
             * @template T
             * @param {?} component The component which the change detection should be performed on.
             * @return {?}
             */
            function detectChanges(component) {
                /** @type {?} */
                var view = getComponentViewByInstance(component);
                detectChangesInternal(view, component);
            }
            /**
             * Mark the component as dirty (needing change detection).
             *
             * Marking a component dirty will schedule a change detection on this
             * component at some point in the future. Marking an already dirty
             * component as dirty is a noop. Only one outstanding change detection
             * can be scheduled per component tree. (Two components bootstrapped with
             * separate `renderComponent` will have separate schedulers)
             *
             * When the root component is bootstrapped with `renderComponent`, a scheduler
             * can be provided.
             *
             * \@publicApi
             * @template T
             * @param {?} component Component to mark as dirty.
             *
             * @return {?}
             */
            function markDirty(component) {
                ngDevMode && assertDefined(component, 'component');
                /** @type {?} */
                var rootView = ( /** @type {?} */(markViewDirty(getComponentViewByInstance(component))));
                ngDevMode && assertDefined(rootView[CONTEXT], 'rootContext should be defined');
                scheduleTick(( /** @type {?} */(rootView[CONTEXT])), 1 /* DetectChanges */);
            }
            /**
             * Used to perform change detection on the whole application.
             *
             * This is equivalent to `detectChanges`, but invoked on root component. Additionally, `tick`
             * executes lifecycle hooks and conditionally checks components based on their
             * `ChangeDetectionStrategy` and dirtiness.
             *
             * The preferred way to trigger change detection is to call `markDirty`. `markDirty` internally
             * schedules `tick` using a scheduler in order to coalesce multiple `markDirty` calls into a
             * single change detection run. By default, the scheduler is `requestAnimationFrame`, but can
             * be changed when calling `renderComponent` and providing the `scheduler` option.
             * @template T
             * @param {?} component
             * @return {?}
             */
            function tick(component) {
                /** @type {?} */
                var rootView = getRootView(component);
                /** @type {?} */
                var rootContext = ( /** @type {?} */(rootView[CONTEXT]));
                tickRootContext(rootContext);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Creates an LContainer for inline views, e.g.
             *
             * % if (showing) {
             *   <div></div>
             * % }
             *
             * \@codeGenApi
             * @param {?} index The index of the container in the data array
             *
             * @return {?}
             */
            function ɵɵcontainer(index) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = containerInternal(lView, index, null, null);
                if (lView[TVIEW].firstTemplatePass) {
                    tNode.tViews = [];
                }
                setIsNotParent();
            }
            /**
             * Creates an LContainer for an ng-template (dynamically-inserted view), e.g.
             *
             * <ng-template #foo>
             *    <div></div>
             * </ng-template>
             *
             * \@codeGenApi
             * @param {?} index The index of the container in the data array
             * @param {?} templateFn Inline template
             * @param {?} consts The number of nodes, local refs, and pipes for this template
             * @param {?} vars The number of bindings for this template
             * @param {?=} tagName The name of the container element, if applicable
             * @param {?=} attrs The attrs attached to the container, if applicable
             * @param {?=} localRefs A set of local reference bindings on the element.
             * @param {?=} localRefExtractor A function which extracts local-refs values from the template.
             *        Defaults to the current element associated with the local-ref.
             *
             * @return {?}
             */
            function ɵɵtemplate(index, templateFn, consts, vars, tagName, attrs, localRefs, localRefExtractor) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                // TODO: consider a separate node type for templates
                /** @type {?} */
                var tContainerNode = containerInternal(lView, index, tagName || null, attrs || null);
                if (tView.firstTemplatePass) {
                    ngDevMode && ngDevMode.firstTemplatePass++;
                    resolveDirectives(tView, lView, tContainerNode, localRefs || null);
                    /** @type {?} */
                    var embeddedTView = tContainerNode.tViews = createTView(-1, templateFn, consts, vars, tView.directiveRegistry, tView.pipeRegistry, null, null);
                    if (tView.queries !== null) {
                        tView.queries.template(tView, tContainerNode);
                        embeddedTView.queries = tView.queries.embeddedTView(tContainerNode);
                    }
                }
                createDirectivesAndLocals(tView, lView, tContainerNode, localRefExtractor);
                attachPatchData(getNativeByTNode(tContainerNode, lView), lView);
                registerPostOrderHooks(tView, tContainerNode);
                setIsNotParent();
            }
            /**
             * Sets a container up to receive views.
             *
             * \@codeGenApi
             * @param {?} index The index of the container in the data array
             *
             * @return {?}
             */
            function ɵɵcontainerRefreshStart(index) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var previousOrParentTNode = ( /** @type {?} */(loadInternal(tView.data, index)));
                ngDevMode && assertNodeType(previousOrParentTNode, 0 /* Container */);
                setPreviousOrParentTNode(previousOrParentTNode, true);
                lView[index + HEADER_OFFSET][ACTIVE_INDEX] = 0;
                // We need to execute init hooks here so ngOnInit hooks are called in top level views
                // before they are called in embedded views (for backwards compatibility).
                executePreOrderHooks(lView, tView, getCheckNoChangesMode(), undefined);
            }
            /**
             * Marks the end of the LContainer.
             *
             * Marking the end of LContainer is the time when to child views get inserted or removed.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵcontainerRefreshEnd() {
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                if (getIsParent()) {
                    setIsNotParent();
                }
                else {
                    ngDevMode && assertNodeType(previousOrParentTNode, 2 /* View */);
                    ngDevMode && assertHasParent(previousOrParentTNode);
                    previousOrParentTNode = ( /** @type {?} */(previousOrParentTNode.parent));
                    setPreviousOrParentTNode(previousOrParentTNode, false);
                }
                ngDevMode && assertNodeType(previousOrParentTNode, 0 /* Container */);
                /** @type {?} */
                var lContainer = getLView()[previousOrParentTNode.index];
                /** @type {?} */
                var nextIndex = lContainer[ACTIVE_INDEX];
                // remove extra views at the end of the container
                while (nextIndex < lContainer.length - CONTAINER_HEADER_OFFSET) {
                    removeView(lContainer, nextIndex);
                }
            }
            /**
             * @param {?} lView
             * @param {?} nodeIndex
             * @param {?} tagName
             * @param {?} attrs
             * @return {?}
             */
            function containerInternal(lView, nodeIndex, tagName, attrs) {
                ngDevMode && assertEqual(lView[BINDING_INDEX], lView[TVIEW].bindingStartIndex, 'container nodes should be created before any bindings');
                /** @type {?} */
                var adjustedIndex = nodeIndex + HEADER_OFFSET;
                ngDevMode && assertDataInRange(lView, nodeIndex + HEADER_OFFSET);
                ngDevMode && ngDevMode.rendererCreateComment++;
                /** @type {?} */
                var comment = lView[adjustedIndex] =
                    lView[RENDERER].createComment(ngDevMode ? 'container' : '');
                /** @type {?} */
                var tNode = getOrCreateTNode(lView[TVIEW], lView[T_HOST], nodeIndex, 0 /* Container */, tagName, attrs);
                /** @type {?} */
                var lContainer = lView[adjustedIndex] = createLContainer(comment, lView, comment, tNode);
                appendChild(comment, tNode, lView);
                // Containers are added to the current view tree instead of their embedded views
                // because views can be removed and re-inserted.
                addToViewTree(lView, lContainer);
                ngDevMode && assertNodeType(getPreviousOrParentTNode(), 0 /* Container */);
                return tNode;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Store a value in the `data` at a given `index`.
             * @template T
             * @param {?} index
             * @param {?} value
             * @return {?}
             */
            function store(index, value) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                // We don't store any static data for local variables, so the first time
                // we see the template, we should store as null to avoid a sparse array
                /** @type {?} */
                var adjustedIndex = index + HEADER_OFFSET;
                if (adjustedIndex >= tView.data.length) {
                    tView.data[adjustedIndex] = null;
                    tView.blueprint[adjustedIndex] = null;
                }
                lView[adjustedIndex] = value;
            }
            /**
             * Retrieves a local reference from the current contextViewData.
             *
             * If the reference to retrieve is in a parent view, this instruction is used in conjunction
             * with a nextContext() call, which walks up the tree and updates the contextViewData instance.
             *
             * \@codeGenApi
             * @template T
             * @param {?} index The index of the local ref in contextViewData.
             *
             * @return {?}
             */
            function ɵɵreference(index) {
                /** @type {?} */
                var contextLView = getContextLView();
                return loadInternal(contextLView, index);
            }
            /**
             * Retrieves a value from current `viewData`.
             *
             * \@codeGenApi
             * @template T
             * @param {?} index
             * @return {?}
             */
            function ɵɵload(index) {
                return loadInternal(getLView(), index);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @template T
             * @param {?} token
             * @param {?=} flags
             * @return {?}
             */
            function ɵɵdirectiveInject(token, flags) {
                if (flags === void 0) { flags = InjectFlags.Default; }
                token = resolveForwardRef(token);
                /** @type {?} */
                var lView = getLView();
                // Fall back to inject() if view hasn't been created. This situation can happen in tests
                // if inject utilities are used before bootstrapping.
                if (lView == null)
                    return ɵɵinject(token, flags);
                return getOrCreateInjectable(( /** @type {?} */(getPreviousOrParentTNode())), lView, token, flags);
            }
            /**
             * Facade for the attribute injection from DI.
             *
             * \@codeGenApi
             * @param {?} attrNameToInject
             * @return {?}
             */
            function ɵɵinjectAttribute(attrNameToInject) {
                return injectAttributeImpl(getPreviousOrParentTNode(), attrNameToInject);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * --------
             *
             * This file contains the core logic for how styling instructions are processed in Angular.
             *
             * To learn more about the algorithm see `TStylingContext`.
             *
             * --------
             */
            /**
             * Temporary function to bridge styling functionality between this new
             * refactor (which is here inside of `styling_next/`) and the old
             * implementation (which lives inside of `styling/`).
             *
             * This function is executed during the creation block of an element.
             * Because the existing styling implementation issues a call to the
             * `styling()` instruction, this instruction will also get run. The
             * central idea here is that the directive index values are bound
             * into the context. The directive index is temporary and is only
             * required until the `select(n)` instruction is fully functional.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵstyling() {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                if (tView.firstTemplatePass) {
                    updateLastDirectiveIndex$1(getPreviousOrParentTNode(), getActiveDirectiveStylingIndex());
                }
            }
            /**
             * Sets the current style sanitizer function which will then be used
             * within all follow-up prop and map-based style binding instructions
             * for the given element.
             *
             * Note that once styling has been applied to the element (i.e. once
             * `select(n)` is executed or the hostBindings/template function exits)
             * then the active `sanitizerFn` will be set to `null`. This means that
             * once styling is applied to another element then a another call to
             * `styleSanitizer` will need to be made.
             *
             * \@codeGenApi
             * @param {?} sanitizer
             * @return {?}
             */
            function ɵɵstyleSanitizer(sanitizer) {
                setCurrentStyleSanitizer(sanitizer);
            }
            /**
             * Update a style binding on an element with the provided value.
             *
             * If the style value is falsy then it will be removed from the element
             * (or assigned a different value depending if there are any styles placed
             * on the element with `styleMap` or any static styles that are
             * present from when the element was created with `styling`).
             *
             * Note that the styling element is updated as part of `stylingApply`.
             *
             * \@codeGenApi
             * @param {?} prop A valid CSS property.
             * @param {?} value New value to write (`null` or an empty string to remove).
             * @param {?=} suffix Optional suffix. Used with scalar values to add unit such as `px`.
             *        Note that when a suffix is provided then the underlying sanitizer will
             *        be ignored.
             *
             * Note that this will apply the provided style value to the host element if this function is called
             * within a host binding.
             *
             * @return {?}
             */
            function ɵɵstyleProp(prop, value, suffix) {
                stylePropInternal(getSelectedIndex(), prop, value, suffix);
            }
            /**
             * @param {?} elementIndex
             * @param {?} prop
             * @param {?} value
             * @param {?=} suffix
             * @return {?}
             */
            function stylePropInternal(elementIndex, prop, value, suffix) {
                /** @type {?} */
                var lView = getLView();
                // if a value is interpolated then it may render a `NO_CHANGE` value.
                // in this case we do not need to do anything, but the binding index
                // still needs to be incremented because all styling binding values
                // are stored inside of the lView.
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX]++;
                /** @type {?} */
                var updated = _stylingProp(elementIndex, bindingIndex, prop, resolveStylePropValue(value, suffix), false, deferStylingUpdate());
                if (ngDevMode) {
                    ngDevMode.styleProp++;
                    if (updated) {
                        ngDevMode.stylePropCacheMiss++;
                    }
                }
            }
            /**
             * Update a class binding on an element with the provided value.
             *
             * This instruction is meant to handle the `[class.foo]="exp"` case and,
             * therefore, the class binding itself must already be allocated using
             * `styling` within the creation block.
             *
             * \@codeGenApi
             * @param {?} className
             * @param {?} value A true/false value which will turn the class on or off.
             *
             * Note that this will apply the provided class value to the host element if this function
             * is called within a host binding.
             *
             * @return {?}
             */
            function ɵɵclassProp(className, value) {
                /** @type {?} */
                var lView = getLView();
                // if a value is interpolated then it may render a `NO_CHANGE` value.
                // in this case we do not need to do anything, but the binding index
                // still needs to be incremented because all styling binding values
                // are stored inside of the lView.
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX]++;
                /** @type {?} */
                var updated = _stylingProp(getSelectedIndex(), bindingIndex, className, value, true, deferStylingUpdate());
                if (ngDevMode) {
                    ngDevMode.classProp++;
                    if (updated) {
                        ngDevMode.classPropCacheMiss++;
                    }
                }
            }
            /**
             * Shared function used to update a prop-based styling binding for an element.
             * @param {?} elementIndex
             * @param {?} bindingIndex
             * @param {?} prop
             * @param {?} value
             * @param {?} isClassBased
             * @param {?} defer
             * @return {?}
             */
            function _stylingProp(elementIndex, bindingIndex, prop, value, isClassBased, defer) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = getTNode(elementIndex, lView);
                /** @type {?} */
                var native = ( /** @type {?} */(getNativeByTNode(tNode, lView)));
                /** @type {?} */
                var updated = false;
                if (value !== NO_CHANGE) {
                    if (isClassBased) {
                        updated = updateClassBinding(getClassesContext(tNode), lView, native, prop, bindingIndex, ( /** @type {?} */(value)), defer, false);
                    }
                    else {
                        /** @type {?} */
                        var sanitizer = getCurrentStyleSanitizer();
                        updated = updateStyleBinding(getStylesContext(tNode), lView, native, prop, bindingIndex, ( /** @type {?} */(value)), sanitizer, defer, false);
                    }
                }
                return updated;
            }
            /**
             * Update style bindings using an object literal on an element.
             *
             * This instruction is meant to apply styling via the `[style]="exp"` template bindings.
             * When styles are applied to the element they will then be updated with respect to
             * any styles/classes set via `styleProp`. If any styles are set to falsy
             * then they will be removed from the element.
             *
             * Note that the styling instruction will not be applied until `stylingApply` is called.
             *
             * \@codeGenApi
             * @param {?} styles A key/value style map of the styles that will be applied to the given element.
             *        Any missing styles (that have already been applied to the element beforehand) will be
             *        removed (unset) from the element's styling.
             *
             * Note that this will apply the provided styleMap value to the host element if this function
             * is called within a host binding.
             *
             * @return {?}
             */
            function ɵɵstyleMap(styles) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = getTNode(index, lView);
                /** @type {?} */
                var context = getStylesContext(tNode);
                /** @type {?} */
                var directiveIndex = getActiveDirectiveStylingIndex();
                // if a value is interpolated then it may render a `NO_CHANGE` value.
                // in this case we do not need to do anything, but the binding index
                // still needs to be incremented because all styling binding values
                // are stored inside of the lView.
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX]++;
                // inputs are only evaluated from a template binding into a directive, therefore,
                // there should not be a situation where a directive host bindings function
                // evaluates the inputs (this should only happen in the template function)
                if (!directiveIndex && hasStyleInput(tNode) && styles !== NO_CHANGE) {
                    updateDirectiveInputValue(context, lView, tNode, bindingIndex, styles, false);
                    styles = NO_CHANGE;
                }
                /** @type {?} */
                var updated = _stylingMap(index, context, bindingIndex, styles, false, deferStylingUpdate());
                if (ngDevMode) {
                    ngDevMode.styleMap++;
                    if (updated) {
                        ngDevMode.styleMapCacheMiss++;
                    }
                }
            }
            /**
             * Update class bindings using an object literal or class-string on an element.
             *
             * This instruction is meant to apply styling via the `[class]="exp"` template bindings.
             * When classes are applied to the element they will then be updated with
             * respect to any styles/classes set via `classProp`. If any
             * classes are set to falsy then they will be removed from the element.
             *
             * Note that the styling instruction will not be applied until `stylingApply` is called.
             * Note that this will the provided classMap value to the host element if this function is called
             * within a host binding.
             *
             * \@codeGenApi
             * @param {?} classes A key/value map or string of CSS classes that will be added to the
             *        given element. Any missing classes (that have already been applied to the element
             *        beforehand) will be removed (unset) from the element's list of CSS classes.
             *
             * @return {?}
             */
            function ɵɵclassMap(classes) {
                classMapInternal(getSelectedIndex(), classes);
            }
            /**
             * @param {?} elementIndex
             * @param {?} classes
             * @return {?}
             */
            function classMapInternal(elementIndex, classes) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = getTNode(elementIndex, lView);
                /** @type {?} */
                var context = getClassesContext(tNode);
                /** @type {?} */
                var directiveIndex = getActiveDirectiveStylingIndex();
                // if a value is interpolated then it may render a `NO_CHANGE` value.
                // in this case we do not need to do anything, but the binding index
                // still needs to be incremented because all styling binding values
                // are stored inside of the lView.
                /** @type {?} */
                var bindingIndex = lView[BINDING_INDEX]++;
                // inputs are only evaluated from a template binding into a directive, therefore,
                // there should not be a situation where a directive host bindings function
                // evaluates the inputs (this should only happen in the template function)
                if (!directiveIndex && hasClassInput(tNode) && classes !== NO_CHANGE) {
                    updateDirectiveInputValue(context, lView, tNode, bindingIndex, classes, true);
                    classes = NO_CHANGE;
                }
                /** @type {?} */
                var updated = _stylingMap(elementIndex, context, bindingIndex, classes, true, deferStylingUpdate());
                if (ngDevMode) {
                    ngDevMode.classMap++;
                    if (updated) {
                        ngDevMode.classMapCacheMiss++;
                    }
                }
            }
            /**
             * Shared function used to update a map-based styling binding for an element.
             *
             * When this function is called it will activate support for `[style]` and
             * `[class]` bindings in Angular.
             * @param {?} elementIndex
             * @param {?} context
             * @param {?} bindingIndex
             * @param {?} value
             * @param {?} isClassBased
             * @param {?} defer
             * @return {?}
             */
            function _stylingMap(elementIndex, context, bindingIndex, value, isClassBased, defer) {
                activateStylingMapFeature();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var valueHasChanged = false;
                if (value !== NO_CHANGE) {
                    /** @type {?} */
                    var tNode = getTNode(elementIndex, lView);
                    /** @type {?} */
                    var native = ( /** @type {?} */(getNativeByTNode(tNode, lView)));
                    /** @type {?} */
                    var oldValue = lView[bindingIndex];
                    valueHasChanged = hasValueChanged(oldValue, value);
                    /** @type {?} */
                    var stylingMapArr = normalizeIntoStylingMap(oldValue, value, !isClassBased);
                    if (isClassBased) {
                        updateClassBinding(context, lView, native, null, bindingIndex, stylingMapArr, defer, valueHasChanged);
                    }
                    else {
                        /** @type {?} */
                        var sanitizer = getCurrentStyleSanitizer();
                        updateStyleBinding(context, lView, native, null, bindingIndex, stylingMapArr, sanitizer, defer, valueHasChanged);
                    }
                }
                return valueHasChanged;
            }
            /**
             * Writes a value to a directive's `style` or `class` input binding (if it has changed).
             *
             * If a directive has a `\@Input` binding that is set on `style` or `class` then that value
             * will take priority over the underlying style/class styling bindings. This value will
             * be updated for the binding each time during change detection.
             *
             * When this occurs this function will attempt to write the value to the input binding
             * depending on the following situations:
             *
             * - If `oldValue !== newValue`
             * - If `newValue` is `null` (but this is skipped if it is during the first update pass--
             *    which is when the context is not locked yet)
             * @param {?} context
             * @param {?} lView
             * @param {?} tNode
             * @param {?} bindingIndex
             * @param {?} newValue
             * @param {?} isClassBased
             * @return {?}
             */
            function updateDirectiveInputValue(context, lView, tNode, bindingIndex, newValue, isClassBased) {
                /** @type {?} */
                var oldValue = lView[bindingIndex];
                if (oldValue !== newValue) {
                    // even if the value has changed we may not want to emit it to the
                    // directive input(s) in the event that it is falsy during the
                    // first update pass.
                    if (newValue || isContextLocked(context)) {
                        /** @type {?} */
                        var inputs = ( /** @type {?} */(( /** @type {?} */(tNode.inputs))[isClassBased ? 'class' : 'style']));
                        /** @type {?} */
                        var initialValue = getInitialStylingValue(context);
                        /** @type {?} */
                        var value = normalizeStylingDirectiveInputValue(initialValue, newValue, isClassBased);
                        setInputsForProperty(lView, inputs, value);
                    }
                    lView[bindingIndex] = newValue;
                }
            }
            /**
             * Returns the appropriate directive input value for `style` or `class`.
             *
             * Earlier versions of Angular expect a binding value to be passed into directive code
             * exactly as it is unless there is a static value present (in which case both values
             * will be stringified and concatenated).
             * @param {?} initialValue
             * @param {?} bindingValue
             * @param {?} isClassBased
             * @return {?}
             */
            function normalizeStylingDirectiveInputValue(initialValue, bindingValue, isClassBased) {
                /** @type {?} */
                var value = bindingValue;
                // we only concat values if there is an initial value, otherwise we return the value as is.
                // Note that this is to satisfy backwards-compatibility in Angular.
                if (initialValue.length > 0) {
                    if (isClassBased) {
                        value = concatString(initialValue, forceClassesAsString(bindingValue));
                    }
                    else {
                        value = concatString(initialValue, forceStylesAsString(( /** @type {?} */(bindingValue))), ';');
                    }
                }
                return value;
            }
            /**
             * Flushes all styling code to the element.
             *
             * This function is designed to be called from the template and hostBindings
             * functions and may be called multiple times depending whether multiple
             * sources of styling exist. If called multiple times, only the last call
             * to `stlyingApply()` will render styling to the element.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵstylingApply() {
                /** @type {?} */
                var elementIndex = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = getTNode(elementIndex, lView);
                /** @type {?} */
                var renderer = getRenderer(tNode, lView);
                /** @type {?} */
                var native = ( /** @type {?} */(getNativeByTNode(tNode, lView)));
                /** @type {?} */
                var directiveIndex = getActiveDirectiveStylingIndex();
                /** @type {?} */
                var sanitizer = getCurrentStyleSanitizer();
                flushStyling(renderer, lView, getClassesContext(tNode), getStylesContext(tNode), native, directiveIndex, sanitizer);
                setCurrentStyleSanitizer(null);
            }
            /**
             * @param {?} tNode
             * @param {?} lView
             * @return {?}
             */
            function getRenderer(tNode, lView) {
                return tNode.type === 3 /* Element */ ? lView[RENDERER] : null;
            }
            /**
             * Searches and assigns provided all static style/class entries (found in the `attrs` value)
             * and registers them in their respective styling contexts.
             * @param {?} tNode
             * @param {?} attrs
             * @param {?} startIndex
             * @return {?}
             */
            function registerInitialStylingOnTNode(tNode, attrs, startIndex) {
                /** @type {?} */
                var hasAdditionalInitialStyling = false;
                /** @type {?} */
                var styles = getStylingMapArray(tNode.styles);
                /** @type {?} */
                var classes = getStylingMapArray(tNode.classes);
                /** @type {?} */
                var mode = -1;
                for (var i = startIndex; i < attrs.length; i++) {
                    /** @type {?} */
                    var attr = ( /** @type {?} */(attrs[i]));
                    if (typeof attr == 'number') {
                        mode = attr;
                    }
                    else if (mode == 1 /* Classes */) {
                        classes = classes || [''];
                        addItemToStylingMap(classes, attr, true);
                        hasAdditionalInitialStyling = true;
                    }
                    else if (mode == 2 /* Styles */) {
                        /** @type {?} */
                        var value = ( /** @type {?} */(attrs[++i]));
                        styles = styles || [''];
                        addItemToStylingMap(styles, attr, value);
                        hasAdditionalInitialStyling = true;
                    }
                }
                if (classes && classes.length > 1 /* ValuesStartPosition */) {
                    if (!tNode.classes) {
                        tNode.classes = classes;
                    }
                    updateRawValueOnContext(tNode.classes, stylingMapToString(classes, true));
                }
                if (styles && styles.length > 1 /* ValuesStartPosition */) {
                    if (!tNode.styles) {
                        tNode.styles = styles;
                    }
                    updateRawValueOnContext(tNode.styles, stylingMapToString(styles, false));
                }
                return hasAdditionalInitialStyling;
            }
            /**
             * @param {?} context
             * @param {?} value
             * @return {?}
             */
            function updateRawValueOnContext(context, value) {
                /** @type {?} */
                var stylingMapArr = ( /** @type {?} */(getStylingMapArray(context)));
                stylingMapArr[0 /* RawValuePosition */] = value;
            }
            /**
             * @return {?}
             */
            function getActiveDirectiveStylingIndex() {
                // whenever a directive's hostBindings function is called a uniqueId value
                // is assigned. Normally this is enough to help distinguish one directive
                // from another for the styling context, but there are situations where a
                // sub-class directive could inherit and assign styling in concert with a
                // parent directive. To help the styling code distinguish between a parent
                // sub-classed directive the inheritance depth is taken into account as well.
                return getActiveDirectiveId() + getActiveDirectiveSuperClassDepth();
            }
            /**
             * Temporary function that will update the max directive index value in
             * both the classes and styles contexts present on the provided `tNode`.
             *
             * This code is only used because the `select(n)` code functionality is not
             * yet 100% functional. The `select(n)` instruction cannot yet evaluate host
             * bindings function code in sync with the associated template function code.
             * For this reason the styling algorithm needs to track the last directive index
             * value so that it knows exactly when to render styling to the element since
             * `stylingApply()` is called multiple times per CD (`stylingApply` will be
             * removed once `select(n)` is fixed).
             * @param {?} tNode
             * @param {?} directiveIndex
             * @return {?}
             */
            function updateLastDirectiveIndex$1(tNode, directiveIndex) {
                updateLastDirectiveIndex(getClassesContext(tNode), directiveIndex);
                updateLastDirectiveIndex(getStylesContext(tNode), directiveIndex);
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function getStylesContext(tNode) {
                return getContext(tNode, false);
            }
            /**
             * @param {?} tNode
             * @return {?}
             */
            function getClassesContext(tNode) {
                return getContext(tNode, true);
            }
            /**
             * Returns/instantiates a styling context from/to a `tNode` instance.
             * @param {?} tNode
             * @param {?} isClassBased
             * @return {?}
             */
            function getContext(tNode, isClassBased) {
                /** @type {?} */
                var context = isClassBased ? tNode.classes : tNode.styles;
                if (!isStylingContext(context)) {
                    context = allocTStylingContext(context);
                    if (ngDevMode) {
                        attachStylingDebugObject(( /** @type {?} */(context)));
                    }
                    if (isClassBased) {
                        tNode.classes = context;
                    }
                    else {
                        tNode.styles = context;
                    }
                }
                return ( /** @type {?} */(context));
            }
            /**
             * @param {?} value
             * @param {?} suffix
             * @return {?}
             */
            function resolveStylePropValue(value, suffix) {
                if (value === NO_CHANGE)
                    return value;
                /** @type {?} */
                var resolvedValue = null;
                if (value !== null) {
                    if (suffix) {
                        // when a suffix is applied then it will bypass
                        // sanitization entirely (b/c a new string is created)
                        resolvedValue = renderStringify(value) + suffix;
                    }
                    else {
                        // sanitization happens by dealing with a String value
                        // this means that the string value will be passed through
                        // into the style rendering later (which is where the value
                        // will be sanitized before it is applied)
                        resolvedValue = ( /** @type {?} */(( /** @type {?} */(value))));
                    }
                }
                return resolvedValue;
            }
            /**
             * Whether or not a style/class binding update should be applied later.
             *
             * This function will decide whether a binding should be applied immediately
             * or later (just before the styles/classes are flushed to the element). The
             * reason why this feature exists is because of super/sub directive inheritance.
             * Angular will evaluate host bindings on the super directive first and the sub
             * directive, but the styling bindings on the sub directive are of higher priority
             * than the super directive. For this reason all styling bindings that take place
             * in this circumstance will need to be deferred until later so that they can be
             * applied together and in a different order (the algorithm handles that part).
             * @return {?}
             */
            function deferStylingUpdate() {
                return getActiveDirectiveSuperClassHeight() > 0;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Create DOM element. The instruction must later be followed by `elementEnd()` call.
             *
             * \@codeGenApi
             * @param {?} index Index of the element in the LView array
             * @param {?} name Name of the DOM Node
             * @param {?=} attrs Statically bound set of attributes, classes, and styles to be written into the DOM
             *              element on creation. Use [AttributeMarker] to denote the meaning of this array.
             * @param {?=} localRefs A set of local reference bindings on the element.
             *
             * Attributes and localRefs are passed as an array of strings where elements with an even index
             * hold an attribute name and elements with an odd index hold an attribute value, ex.:
             * ['id', 'warning5', 'class', 'alert']
             *
             * @return {?}
             */
            function ɵɵelementStart(index, name, attrs, localRefs) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                ngDevMode && assertEqual(lView[BINDING_INDEX], tView.bindingStartIndex, 'elements should be created before any bindings ');
                ngDevMode && ngDevMode.rendererCreateElement++;
                ngDevMode && assertDataInRange(lView, index + HEADER_OFFSET);
                /** @type {?} */
                var native = lView[index + HEADER_OFFSET] = elementCreate(name);
                /** @type {?} */
                var renderer = lView[RENDERER];
                /** @type {?} */
                var tNode = getOrCreateTNode(tView, lView[T_HOST], index, 3 /* Element */, name, attrs || null);
                if (attrs != null) {
                    /** @type {?} */
                    var lastAttrIndex = setUpAttributes(native, attrs);
                    if (tView.firstTemplatePass) {
                        registerInitialStylingOnTNode(tNode, attrs, lastAttrIndex);
                    }
                }
                renderInitialStyling(renderer, native, tNode);
                appendChild(native, tNode, lView);
                // any immediate children of a component or template container must be pre-emptively
                // monkey-patched with the component view data so that the element can be inspected
                // later on using any element discovery utility methods (see `element_discovery.ts`)
                if (getElementDepthCount() === 0) {
                    attachPatchData(native, lView);
                }
                increaseElementDepthCount();
                // if a directive contains a host binding for "class" then all class-based data will
                // flow through that (except for `[class.prop]` bindings). This also includes initial
                // static class values as well. (Note that this will be fixed once map-based `[style]`
                // and `[class]` bindings work for multiple directives.)
                if (tView.firstTemplatePass) {
                    ngDevMode && ngDevMode.firstTemplatePass++;
                    resolveDirectives(tView, lView, tNode, localRefs || null);
                    /** @type {?} */
                    var inputData = initializeTNodeInputs(tNode);
                    if (inputData && inputData.hasOwnProperty('class')) {
                        tNode.flags |= 8 /* hasClassInput */;
                    }
                    if (inputData && inputData.hasOwnProperty('style')) {
                        tNode.flags |= 16 /* hasStyleInput */;
                    }
                    if (tView.queries !== null) {
                        tView.queries.elementStart(tView, tNode);
                    }
                }
                createDirectivesAndLocals(tView, lView, tNode);
                executeContentQueries(tView, tNode, lView);
            }
            /**
             * Mark the end of the element.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵelementEnd() {
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                ngDevMode && assertDefined(previousOrParentTNode, 'No parent node to close.');
                if (getIsParent()) {
                    setIsNotParent();
                }
                else {
                    ngDevMode && assertHasParent(getPreviousOrParentTNode());
                    previousOrParentTNode = ( /** @type {?} */(previousOrParentTNode.parent));
                    setPreviousOrParentTNode(previousOrParentTNode, false);
                }
                /** @type {?} */
                var tNode = previousOrParentTNode;
                ngDevMode && assertNodeType(tNode, 3 /* Element */);
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                registerPostOrderHooks(tView, previousOrParentTNode);
                decreaseElementDepthCount();
                if (tView.firstTemplatePass && tView.queries !== null &&
                    isContentQueryHost(previousOrParentTNode)) {
                    ( /** @type {?} */(tView.queries)).elementEnd(previousOrParentTNode);
                }
                if (hasClassInput(tNode) && tNode.classes) {
                    setDirectiveStylingInput(tNode.classes, lView, ( /** @type {?} */(tNode.inputs))['class']);
                }
                if (hasStyleInput(tNode) && tNode.styles) {
                    setDirectiveStylingInput(tNode.styles, lView, ( /** @type {?} */(tNode.inputs))['style']);
                }
            }
            /**
             * Creates an empty element using {\@link elementStart} and {\@link elementEnd}
             *
             * \@codeGenApi
             * @param {?} index Index of the element in the data array
             * @param {?} name Name of the DOM Node
             * @param {?=} attrs Statically bound set of attributes, classes, and styles to be written into the DOM
             *              element on creation. Use [AttributeMarker] to denote the meaning of this array.
             * @param {?=} localRefs A set of local reference bindings on the element.
             *
             * @return {?}
             */
            function ɵɵelement(index, name, attrs, localRefs) {
                ɵɵelementStart(index, name, attrs, localRefs);
                ɵɵelementEnd();
            }
            /**
             * Assign static attribute values to a host element.
             *
             * This instruction will assign static attribute values as well as class and style
             * values to an element within the host bindings function. Since attribute values
             * can consist of different types of values, the `attrs` array must include the values in
             * the following format:
             *
             * attrs = [
             *   // static attributes (like `title`, `name`, `id`...)
             *   attr1, value1, attr2, value,
             *
             *   // a single namespace value (like `x:id`)
             *   NAMESPACE_MARKER, namespaceUri1, name1, value1,
             *
             *   // another single namespace value (like `x:name`)
             *   NAMESPACE_MARKER, namespaceUri2, name2, value2,
             *
             *   // a series of CSS classes that will be applied to the element (no spaces)
             *   CLASSES_MARKER, class1, class2, class3,
             *
             *   // a series of CSS styles (property + value) that will be applied to the element
             *   STYLES_MARKER, prop1, value1, prop2, value2
             * ]
             *
             * All non-class and non-style attributes must be defined at the start of the list
             * first before all class and style values are set. When there is a change in value
             * type (like when classes and styles are introduced) a marker must be used to separate
             * the entries. The marker values themselves are set via entries found in the
             * [AttributeMarker] enum.
             *
             * NOTE: This instruction is meant to used from `hostBindings` function only.
             *
             * \@codeGenApi
             * @param {?} attrs An array of static values (attributes, classes and styles) with the correct marker
             * values.
             *
             * @return {?}
             */
            function ɵɵelementHostAttrs(attrs) {
                /** @type {?} */
                var hostElementIndex = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var tNode = getTNode(hostElementIndex, lView);
                // non-element nodes (e.g. `<ng-container>`) are not rendered as actual
                // element nodes and adding styles/classes on to them will cause runtime
                // errors...
                if (tNode.type === 3 /* Element */) {
                    /** @type {?} */
                    var native = ( /** @type {?} */(getNativeByTNode(tNode, lView)));
                    /** @type {?} */
                    var lastAttrIndex = setUpAttributes(native, attrs);
                    if (tView.firstTemplatePass) {
                        /** @type {?} */
                        var stylingNeedsToBeRendered = registerInitialStylingOnTNode(tNode, attrs, lastAttrIndex);
                        // this is only called during the first template pass in the
                        // event that this current directive assigned initial style/class
                        // host attribute values to the element. Because initial styling
                        // values are applied before directives are first rendered (within
                        // `createElement`) this means that initial styling for any directives
                        // still needs to be applied. Note that this will only happen during
                        // the first template pass and not each time a directive applies its
                        // attribute values to the element.
                        if (stylingNeedsToBeRendered) {
                            /** @type {?} */
                            var renderer = lView[RENDERER];
                            renderInitialStyling(renderer, native, tNode);
                        }
                    }
                }
            }
            /**
             * @param {?} context
             * @param {?} lView
             * @param {?} stylingInputs
             * @return {?}
             */
            function setDirectiveStylingInput(context, lView, stylingInputs) {
                // older versions of Angular treat the input as `null` in the
                // event that the value does not exist at all. For this reason
                // we can't have a styling value be an empty string.
                /** @type {?} */
                var value = getInitialStylingValue(context) || null;
                // Ivy does an extra `[class]` write with a falsy value since the value
                // is applied during creation mode. This is a deviation from VE and should
                // be (Jira Issue = FW-1467).
                setInputsForProperty(lView, stylingInputs, value);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Creates a logical container for other nodes (<ng-container>) backed by a comment node in the DOM.
             * The instruction must later be followed by `elementContainerEnd()` call.
             *
             * \@codeGenApi
             * @param {?} index Index of the element in the LView array
             * @param {?=} attrs Set of attributes to be used when matching directives.
             * @param {?=} localRefs A set of local reference bindings on the element.
             *
             * Even if this instruction accepts a set of attributes no actual attribute values are propagated to
             * the DOM (as a comment node can't have attributes). Attributes are here only for directive
             * matching purposes and setting initial inputs of directives.
             *
             * @return {?}
             */
            function ɵɵelementContainerStart(index, attrs, localRefs) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var renderer = lView[RENDERER];
                /** @type {?} */
                var tagName = 'ng-container';
                ngDevMode && assertEqual(lView[BINDING_INDEX], tView.bindingStartIndex, 'element containers should be created before any bindings');
                ngDevMode && ngDevMode.rendererCreateComment++;
                ngDevMode && assertDataInRange(lView, index + HEADER_OFFSET);
                /** @type {?} */
                var native = lView[index + HEADER_OFFSET] = renderer.createComment(ngDevMode ? tagName : '');
                ngDevMode && assertDataInRange(lView, index - 1);
                /** @type {?} */
                var tNode = getOrCreateTNode(tView, lView[T_HOST], index, 4 /* ElementContainer */, tagName, attrs || null);
                if (attrs && tView.firstTemplatePass) {
                    // While ng-container doesn't necessarily support styling, we use the style context to identify
                    // and execute directives on the ng-container.
                    registerInitialStylingOnTNode(tNode, ( /** @type {?} */(attrs)), 0);
                }
                appendChild(native, tNode, lView);
                if (tView.firstTemplatePass) {
                    ngDevMode && ngDevMode.firstTemplatePass++;
                    resolveDirectives(tView, lView, tNode, localRefs || null);
                    if (tView.queries) {
                        tView.queries.elementStart(tView, tNode);
                    }
                }
                createDirectivesAndLocals(tView, lView, tNode);
                attachPatchData(native, lView);
                executeContentQueries(tView, tNode, lView);
            }
            /**
             * Mark the end of the <ng-container>.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵelementContainerEnd() {
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                if (getIsParent()) {
                    setIsNotParent();
                }
                else {
                    ngDevMode && assertHasParent(previousOrParentTNode);
                    previousOrParentTNode = ( /** @type {?} */(previousOrParentTNode.parent));
                    setPreviousOrParentTNode(previousOrParentTNode, false);
                }
                ngDevMode && assertNodeType(previousOrParentTNode, 4 /* ElementContainer */);
                registerPostOrderHooks(tView, previousOrParentTNode);
                if (tView.firstTemplatePass && tView.queries !== null &&
                    isContentQueryHost(previousOrParentTNode)) {
                    tView.queries.elementEnd(previousOrParentTNode);
                }
            }
            /**
             * Creates an empty logical container using {\@link elementContainerStart}
             * and {\@link elementContainerEnd}
             *
             * \@codeGenApi
             * @param {?} index Index of the element in the LView array
             * @param {?=} attrs Set of attributes to be used when matching directives.
             * @param {?=} localRefs A set of local reference bindings on the element.
             *
             * @return {?}
             */
            function ɵɵelementContainer(index, attrs, localRefs) {
                ɵɵelementContainerStart(index, attrs, localRefs);
                ɵɵelementContainerEnd();
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Marks the start of an embedded view.
             *
             * \@codeGenApi
             * @param {?} viewBlockId The ID of this view
             * @param {?} consts
             * @param {?} vars
             * @return {?} boolean Whether or not this view is in creation mode
             *
             */
            function ɵɵembeddedViewStart(viewBlockId, consts, vars) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                // The previous node can be a view node if we are processing an inline for loop
                /** @type {?} */
                var containerTNode = previousOrParentTNode.type === 2 /* View */ ?
                    ( /** @type {?} */(previousOrParentTNode.parent)) :
                    previousOrParentTNode;
                /** @type {?} */
                var lContainer = ( /** @type {?} */(lView[containerTNode.index]));
                ngDevMode && assertNodeType(containerTNode, 0 /* Container */);
                /** @type {?} */
                var viewToRender = scanForView(lContainer, ( /** @type {?} */(lContainer[ACTIVE_INDEX])), viewBlockId);
                if (viewToRender) {
                    setIsParent();
                    enterView(viewToRender, viewToRender[TVIEW].node);
                }
                else {
                    // When we create a new LView, we always reset the state of the instructions.
                    viewToRender = createLView(lView, getOrCreateEmbeddedTView(viewBlockId, consts, vars, ( /** @type {?} */(containerTNode))), null, 16 /* CheckAlways */, null, null);
                    /** @type {?} */
                    var tParentNode = getIsParent() ? previousOrParentTNode :
                        previousOrParentTNode && previousOrParentTNode.parent;
                    assignTViewNodeToLView(viewToRender[TVIEW], tParentNode, viewBlockId, viewToRender);
                    enterView(viewToRender, viewToRender[TVIEW].node);
                }
                if (lContainer) {
                    if (isCreationMode(viewToRender)) {
                        // it is a new view, insert it into collection of views for a given container
                        insertView(viewToRender, lContainer, ( /** @type {?} */(lContainer[ACTIVE_INDEX])));
                    }
                    ( /** @type {?} */(lContainer[ACTIVE_INDEX]))++;
                }
                return isCreationMode(viewToRender) ? 1 /* Create */ | 2 /* Update */ :
                    2 /* Update */;
            }
            /**
             * Initialize the TView (e.g. static data) for the active embedded view.
             *
             * Each embedded view block must create or retrieve its own TView. Otherwise, the embedded view's
             * static data for a particular node would overwrite the static data for a node in the view above
             * it with the same index (since it's in the same template).
             *
             * @param {?} viewIndex The index of the TView in TNode.tViews
             * @param {?} consts The number of nodes, local refs, and pipes in this template
             * @param {?} vars The number of bindings and pure function bindings in this template
             * @param {?} parent
             * @return {?} TView
             */
            function getOrCreateEmbeddedTView(viewIndex, consts, vars, parent) {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                ngDevMode && assertNodeType(parent, 0 /* Container */);
                /** @type {?} */
                var containerTViews = ( /** @type {?} */(parent.tViews));
                ngDevMode && assertDefined(containerTViews, 'TView expected');
                ngDevMode && assertEqual(Array.isArray(containerTViews), true, 'TViews should be in an array');
                if (viewIndex >= containerTViews.length || containerTViews[viewIndex] == null) {
                    containerTViews[viewIndex] = createTView(viewIndex, null, consts, vars, tView.directiveRegistry, tView.pipeRegistry, null, null);
                }
                return containerTViews[viewIndex];
            }
            /**
             * Looks for a view with a given view block id inside a provided LContainer.
             * Removes views that need to be deleted in the process.
             *
             * @param {?} lContainer to search for views
             * @param {?} startIdx starting index in the views array to search from
             * @param {?} viewBlockId exact view block id to look for
             * @return {?}
             */
            function scanForView(lContainer, startIdx, viewBlockId) {
                for (var i = startIdx + CONTAINER_HEADER_OFFSET; i < lContainer.length; i++) {
                    /** @type {?} */
                    var viewAtPositionId = lContainer[i][TVIEW].id;
                    if (viewAtPositionId === viewBlockId) {
                        return lContainer[i];
                    }
                    else if (viewAtPositionId < viewBlockId) {
                        // found a view that should not be at this position - remove
                        removeView(lContainer, i - CONTAINER_HEADER_OFFSET);
                    }
                    else {
                        // found a view with id greater than the one we are searching for
                        // which means that required view doesn't exist and can't be found at
                        // later positions in the views array - stop the searchdef.cont here
                        break;
                    }
                }
                return null;
            }
            /**
             * Marks the end of an embedded view.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵembeddedViewEnd() {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var viewHost = lView[T_HOST];
                if (isCreationMode(lView)) {
                    refreshDescendantViews(lView); // creation mode pass
                    lView[FLAGS] &= ~4 /* CreationMode */;
                }
                resetPreOrderHookFlags(lView);
                refreshDescendantViews(lView); // update mode pass
                // update mode pass
                /** @type {?} */
                var lContainer = ( /** @type {?} */(lView[PARENT]));
                ngDevMode && assertLContainerOrUndefined(lContainer);
                // It's always safe to run hooks here, as `leaveView` is not called during the 'finally' block
                // of a try-catch-finally statement, so it can never be reached while unwinding the stack due to
                // an error being thrown.
                leaveView(( /** @type {?} */(lContainer[PARENT])), /* safeToRunHooks */ true);
                setPreviousOrParentTNode(( /** @type {?} */(viewHost)), false);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns the current OpaqueViewState instance.
             *
             * Used in conjunction with the restoreView() instruction to save a snapshot
             * of the current view and restore it when listeners are invoked. This allows
             * walking the declaration view tree in listeners to get vars from parent views.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵgetCurrentView() {
                return ( /** @type {?} */(( /** @type {?} */(getLView()))));
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Determine if the argument is shaped like a Promise
             */
            function isPromise(obj) {
                // allow any Promise/A+ compliant thenable.
                // It's up to the caller to ensure that obj.then conforms to the spec
                return !!obj && typeof obj.then === 'function';
            }
            /**
             * Determine if the argument is an Observable
             */
            function isObservable(obj) {
                // TODO: use isObservable once we update pass rxjs 6.1
                // https://github.com/ReactiveX/rxjs/blob/master/CHANGELOG.md#610-2018-05-03
                return !!obj && typeof obj.subscribe === 'function';
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Adds an event listener to the current node.
             *
             * If an output exists on one of the node's directives, it also subscribes to the output
             * and saves the subscription for later cleanup.
             *
             * \@codeGenApi
             * @param {?} eventName Name of the event
             * @param {?} listenerFn The function to be called when event emits
             * @param {?=} useCapture Whether or not to use capture in event listener
             * @param {?=} eventTargetResolver Function that returns global target information in case this listener
             * should be attached to a global object like window, document or body
             *
             * @return {?}
             */
            function ɵɵlistener(eventName, listenerFn, useCapture, eventTargetResolver) {
                if (useCapture === void 0) { useCapture = false; }
                listenerInternal(eventName, listenerFn, useCapture, eventTargetResolver);
            }
            /**
             * Registers a synthetic host listener (e.g. `(\@foo.start)`) on a component.
             *
             * This instruction is for compatibility purposes and is designed to ensure that a
             * synthetic host listener (e.g. `\@HostListener('\@foo.start')`) properly gets rendered
             * in the component's renderer. Normally all host listeners are evaluated with the
             * parent component's renderer, but, in the case of animation \@triggers, they need
             * to be evaluated with the sub component's renderer (because that's where the
             * animation triggers are defined).
             *
             * Do not use this instruction as a replacement for `listener`. This instruction
             * only exists to ensure compatibility with the ViewEngine's host binding behavior.
             *
             * \@codeGenApi
             * @param {?} eventName Name of the event
             * @param {?} listenerFn The function to be called when event emits
             * @param {?=} useCapture Whether or not to use capture in event listener
             * @param {?=} eventTargetResolver Function that returns global target information in case this listener
             * should be attached to a global object like window, document or body
             *
             * @return {?}
             */
            function ɵɵcomponentHostSyntheticListener(eventName, listenerFn, useCapture, eventTargetResolver) {
                if (useCapture === void 0) { useCapture = false; }
                listenerInternal(eventName, listenerFn, useCapture, eventTargetResolver, loadComponentRenderer);
            }
            /**
             * A utility function that checks if a given element has already an event handler registered for an
             * event with a specified name. The TView.cleanup data structure is used to find out which events
             * are registered for a given element.
             * @param {?} lView
             * @param {?} eventName
             * @param {?} tNodeIdx
             * @return {?}
             */
            function findExistingListener(lView, eventName, tNodeIdx) {
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var tCleanup = tView.cleanup;
                if (tCleanup != null) {
                    for (var i = 0; i < tCleanup.length - 1; i += 2) {
                        /** @type {?} */
                        var cleanupEventName = tCleanup[i];
                        if (cleanupEventName === eventName && tCleanup[i + 1] === tNodeIdx) {
                            // We have found a matching event name on the same node but it might not have been
                            // registered yet, so we must explicitly verify entries in the LView cleanup data
                            // structures.
                            /** @type {?} */
                            var lCleanup = ( /** @type {?} */(lView[CLEANUP]));
                            /** @type {?} */
                            var listenerIdxInLCleanup = tCleanup[i + 2];
                            return lCleanup.length > listenerIdxInLCleanup ? lCleanup[listenerIdxInLCleanup] : null;
                        }
                        // TView.cleanup can have a mix of 4-elements entries (for event handler cleanups) or
                        // 2-element entries (for directive and queries destroy hooks). As such we can encounter
                        // blocks of 4 or 2 items in the tView.cleanup and this is why we iterate over 2 elements
                        // first and jump another 2 elements if we detect listeners cleanup (4 elements). Also check
                        // documentation of TView.cleanup for more details of this data structure layout.
                        if (typeof cleanupEventName === 'string') {
                            i += 2;
                        }
                    }
                }
                return null;
            }
            /**
             * @param {?} eventName
             * @param {?} listenerFn
             * @param {?=} useCapture
             * @param {?=} eventTargetResolver
             * @param {?=} loadRendererFn
             * @return {?}
             */
            function listenerInternal(eventName, listenerFn, useCapture, eventTargetResolver, loadRendererFn) {
                if (useCapture === void 0) { useCapture = false; }
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tNode = getPreviousOrParentTNode();
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var firstTemplatePass = tView.firstTemplatePass;
                /** @type {?} */
                var tCleanup = firstTemplatePass && (tView.cleanup || (tView.cleanup = []));
                ngDevMode && assertNodeOfPossibleTypes(tNode, 3 /* Element */, 0 /* Container */, 4 /* ElementContainer */);
                /** @type {?} */
                var processOutputs = true;
                // add native event listener - applicable to elements only
                if (tNode.type === 3 /* Element */) {
                    /** @type {?} */
                    var native = ( /** @type {?} */(getNativeByTNode(tNode, lView)));
                    /** @type {?} */
                    var resolved = eventTargetResolver ? eventTargetResolver(native) : ( /** @type {?} */(EMPTY_OBJ));
                    /** @type {?} */
                    var target = resolved.target || native;
                    /** @type {?} */
                    var renderer = loadRendererFn ? loadRendererFn(tNode, lView) : lView[RENDERER];
                    /** @type {?} */
                    var lCleanup = getCleanup(lView);
                    /** @type {?} */
                    var lCleanupIndex = lCleanup.length;
                    /** @type {?} */
                    var idxOrTargetGetter = eventTargetResolver ?
                        ( /**
                         * @param {?} _lView
                         * @return {?}
                         */function (_lView) { return eventTargetResolver(unwrapRNode(_lView[tNode.index])).target; }) :
                        tNode.index;
                    // In order to match current behavior, native DOM event listeners must be added for all
                    // events (including outputs).
                    if (isProceduralRenderer(renderer)) {
                        // There might be cases where multiple directives on the same element try to register an event
                        // handler function for the same event. In this situation we want to avoid registration of
                        // several native listeners as each registration would be intercepted by NgZone and
                        // trigger change detection. This would mean that a single user action would result in several
                        // change detections being invoked. To avoid this situation we want to have only one call to
                        // native handler registration (for the same element and same type of event).
                        //
                        // In order to have just one native event handler in presence of multiple handler functions,
                        // we just register a first handler function as a native event listener and then chain
                        // (coalesce) other handler functions on top of the first native handler function.
                        /** @type {?} */
                        var existingListener = null;
                        // Please note that the coalescing described here doesn't happen for events specifying an
                        // alternative target (ex. (document:click)) - this is to keep backward compatibility with the
                        // view engine.
                        // Also, we don't have to search for existing listeners is there are no directives
                        // matching on a given node as we can't register multiple event handlers for the same event in
                        // a template (this would mean having duplicate attributes).
                        if (!eventTargetResolver && hasDirectives(tNode)) {
                            existingListener = findExistingListener(lView, eventName, tNode.index);
                        }
                        if (existingListener !== null) {
                            // Attach a new listener at the head of the coalesced listeners list.
                            (( /** @type {?} */(listenerFn))).__ngNextListenerFn__ = (( /** @type {?} */(existingListener))).__ngNextListenerFn__;
                            (( /** @type {?} */(existingListener))).__ngNextListenerFn__ = listenerFn;
                            processOutputs = false;
                        }
                        else {
                            // The first argument of `listen` function in Procedural Renderer is:
                            // - either a target name (as a string) in case of global target (window, document, body)
                            // - or element reference (in all other cases)
                            listenerFn = wrapListener(tNode, lView, listenerFn, false /** preventDefault */);
                            /** @type {?} */
                            var cleanupFn = renderer.listen(resolved.name || target, eventName, listenerFn);
                            ngDevMode && ngDevMode.rendererAddEventListener++;
                            lCleanup.push(listenerFn, cleanupFn);
                            tCleanup && tCleanup.push(eventName, idxOrTargetGetter, lCleanupIndex, lCleanupIndex + 1);
                        }
                    }
                    else {
                        listenerFn = wrapListener(tNode, lView, listenerFn, true /** preventDefault */);
                        target.addEventListener(eventName, listenerFn, useCapture);
                        ngDevMode && ngDevMode.rendererAddEventListener++;
                        lCleanup.push(listenerFn);
                        tCleanup && tCleanup.push(eventName, idxOrTargetGetter, lCleanupIndex, useCapture);
                    }
                }
                // subscribe to directive outputs
                if (tNode.outputs === undefined) {
                    // if we create TNode here, inputs must be undefined so we know they still need to be
                    // checked
                    tNode.outputs = generatePropertyAliases(tNode, 1 /* Output */);
                }
                /** @type {?} */
                var outputs = tNode.outputs;
                /** @type {?} */
                var props;
                if (processOutputs && outputs && (props = outputs[eventName])) {
                    /** @type {?} */
                    var propsLength = props.length;
                    if (propsLength) {
                        /** @type {?} */
                        var lCleanup = getCleanup(lView);
                        for (var i = 0; i < propsLength; i += 3) {
                            /** @type {?} */
                            var index = ( /** @type {?} */(props[i]));
                            ngDevMode && assertDataInRange(lView, index);
                            /** @type {?} */
                            var minifiedName = props[i + 2];
                            /** @type {?} */
                            var directiveInstance = lView[index];
                            /** @type {?} */
                            var output = directiveInstance[minifiedName];
                            if (ngDevMode && !isObservable(output)) {
                                throw new Error("@Output " + minifiedName + " not initialized in '" + directiveInstance.constructor.name + "'.");
                            }
                            /** @type {?} */
                            var subscription = output.subscribe(listenerFn);
                            /** @type {?} */
                            var idx = lCleanup.length;
                            lCleanup.push(listenerFn, subscription);
                            tCleanup && tCleanup.push(eventName, tNode.index, idx, -(idx + 1));
                        }
                    }
                }
            }
            /**
             * @param {?} lView
             * @param {?} listenerFn
             * @param {?} e
             * @return {?}
             */
            function executeListenerWithErrorHandling(lView, listenerFn, e) {
                try {
                    // Only explicitly returning false from a listener should preventDefault
                    return listenerFn(e) !== false;
                }
                catch (error) {
                    handleError(lView, error);
                    return false;
                }
            }
            /**
             * Wraps an event listener with a function that marks ancestors dirty and prevents default behavior,
             * if applicable.
             *
             * @param {?} tNode The TNode associated with this listener
             * @param {?} lView The LView that contains this listener
             * @param {?} listenerFn The listener function to call
             * @param {?} wrapWithPreventDefault Whether or not to prevent default behavior
             * (the procedural renderer does this already, so in those cases, we should skip)
             * @return {?}
             */
            function wrapListener(tNode, lView, listenerFn, wrapWithPreventDefault) {
                // Note: we are performing most of the work in the listener function itself
                // to optimize listener registration.
                return ( /**
                 * @param {?} e
                 * @return {?}
                 */function wrapListenerIn_markDirtyAndPreventDefault(e) {
                    // In order to be backwards compatible with View Engine, events on component host nodes
                    // must also mark the component view itself dirty (i.e. the view that it owns).
                    /** @type {?} */
                    var startView = tNode.flags & 1 /* isComponent */ ? getComponentViewByIndex(tNode.index, lView) : lView;
                    // See interfaces/view.ts for more on LViewFlags.ManualOnPush
                    if ((lView[FLAGS] & 32 /* ManualOnPush */) === 0) {
                        markViewDirty(startView);
                    }
                    /** @type {?} */
                    var result = executeListenerWithErrorHandling(lView, listenerFn, e);
                    // A just-invoked listener function might have coalesced listeners so we need to check for
                    // their presence and invoke as needed.
                    /** @type {?} */
                    var nextListenerFn = (( /** @type {?} */(wrapListenerIn_markDirtyAndPreventDefault))).__ngNextListenerFn__;
                    while (nextListenerFn) {
                        // We should prevent default if any of the listeners explicitly return false
                        result = executeListenerWithErrorHandling(lView, nextListenerFn, e) && result;
                        nextListenerFn = (( /** @type {?} */(nextListenerFn))).__ngNextListenerFn__;
                    }
                    if (wrapWithPreventDefault && result === false) {
                        e.preventDefault();
                        // Necessary for legacy browsers that don't support preventDefault (e.g. IE)
                        e.returnValue = false;
                    }
                    return result;
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Retrieves a context at the level specified and saves it as the global, contextViewData.
             * Will get the next level up if level is not specified.
             *
             * This is used to save contexts of parent views so they can be bound in embedded views, or
             * in conjunction with reference() to bind a ref from a parent view.
             *
             * \@codeGenApi
             * @template T
             * @param {?=} level The relative level of the view from which to grab context compared to contextVewData
             * @return {?} context
             *
             */
            function ɵɵnextContext(level) {
                if (level === void 0) { level = 1; }
                return nextContextImpl(level);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Checks a given node against matching projection slots and returns the
             * determined slot index. Returns "null" if no slot matched the given node.
             *
             * This function takes into account the parsed ngProjectAs selector from the
             * node's attributes. If present, it will check whether the ngProjectAs selector
             * matches any of the projection slot selectors.
             * @param {?} tNode
             * @param {?} projectionSlots
             * @return {?}
             */
            function matchingProjectionSlotIndex(tNode, projectionSlots) {
                /** @type {?} */
                var wildcardNgContentIndex = null;
                /** @type {?} */
                var ngProjectAsAttrVal = getProjectAsAttrValue(tNode);
                for (var i = 0; i < projectionSlots.length; i++) {
                    /** @type {?} */
                    var slotValue = projectionSlots[i];
                    // The last wildcard projection slot should match all nodes which aren't matching
                    // any selector. This is necessary to be backwards compatible with view engine.
                    if (slotValue === '*') {
                        wildcardNgContentIndex = i;
                        continue;
                    }
                    // If we ran into an `ngProjectAs` attribute, we should match its parsed selector
                    // to the list of selectors, otherwise we fall back to matching against the node.
                    if (ngProjectAsAttrVal === null ?
                        isNodeMatchingSelectorList(tNode, slotValue, /* isProjectionMode */ true) :
                        isSelectorInSelectorList(ngProjectAsAttrVal, slotValue)) {
                        return i; // first matching selector "captures" a given node
                    }
                }
                return wildcardNgContentIndex;
            }
            /**
             * Instruction to distribute projectable nodes among <ng-content> occurrences in a given template.
             * It takes all the selectors from the entire component's template and decides where
             * each projected node belongs (it re-distributes nodes among "buckets" where each "bucket" is
             * backed by a selector).
             *
             * This function requires CSS selectors to be provided in 2 forms: parsed (by a compiler) and text,
             * un-parsed form.
             *
             * The parsed form is needed for efficient matching of a node against a given CSS selector.
             * The un-parsed, textual form is needed for support of the ngProjectAs attribute.
             *
             * Having a CSS selector in 2 different formats is not ideal, but alternatives have even more
             * drawbacks:
             * - having only a textual form would require runtime parsing of CSS selectors;
             * - we can't have only a parsed as we can't re-construct textual form from it (as entered by a
             * template author).
             *
             * \@codeGenApi
             * @param {?=} projectionSlots
             * @return {?}
             */
            function ɵɵprojectionDef(projectionSlots) {
                /** @type {?} */
                var componentNode = ( /** @type {?} */(findComponentView(getLView())[T_HOST]));
                if (!componentNode.projection) {
                    // If no explicit projection slots are defined, fall back to a single
                    // projection slot with the wildcard selector.
                    /** @type {?} */
                    var numProjectionSlots = projectionSlots ? projectionSlots.length : 1;
                    /** @type {?} */
                    var projectionHeads = componentNode.projection =
                        new Array(numProjectionSlots).fill(null);
                    /** @type {?} */
                    var tails = projectionHeads.slice();
                    /** @type {?} */
                    var componentChild = componentNode.child;
                    while (componentChild !== null) {
                        /** @type {?} */
                        var slotIndex = projectionSlots ? matchingProjectionSlotIndex(componentChild, projectionSlots) : 0;
                        if (slotIndex !== null) {
                            if (tails[slotIndex]) {
                                ( /** @type {?} */(tails[slotIndex])).projectionNext = componentChild;
                            }
                            else {
                                projectionHeads[slotIndex] = componentChild;
                            }
                            tails[slotIndex] = componentChild;
                        }
                        componentChild = componentChild.next;
                    }
                }
            }
            /** @type {?} */
            var delayProjection = false;
            /**
             * @param {?} value
             * @return {?}
             */
            function setDelayProjection(value) {
                delayProjection = value;
            }
            /**
             * Inserts previously re-distributed projected nodes. This instruction must be preceded by a call
             * to the projectionDef instruction.
             *
             * \@codeGenApi
             * @param {?} nodeIndex
             * @param {?=} selectorIndex
             * @param {?=} attrs
             * @return {?}
             */
            function ɵɵprojection(nodeIndex, selectorIndex, attrs) {
                if (selectorIndex === void 0) { selectorIndex = 0; }
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tProjectionNode = getOrCreateTNode(lView[TVIEW], lView[T_HOST], nodeIndex, 1 /* Projection */, null, attrs || null);
                // We can't use viewData[HOST_NODE] because projection nodes can be nested in embedded views.
                if (tProjectionNode.projection === null)
                    tProjectionNode.projection = selectorIndex;
                // `<ng-content>` has no content
                setIsNotParent();
                // We might need to delay the projection of nodes if they are in the middle of an i18n block
                if (!delayProjection) {
                    // re-distribution of projectable nodes is stored on a component's view level
                    appendProjectedNodes(lView, tProjectionNode, selectorIndex, findComponentView(lView));
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             *
             * Update an interpolated property on an element with a lone bound value
             *
             * Used when the value passed to a property has 1 interpolated value in it, an no additional text
             * surrounds that interpolated value:
             *
             * ```html
             * <div title="{{v0}}"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate('title', v0);
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} v0 Value checked for change.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate(propName, v0, sanitizer) {
                ɵɵpropertyInterpolate1(propName, '', v0, '', sanitizer);
                return ɵɵpropertyInterpolate;
            }
            /**
             *
             * Update an interpolated property on an element with single bound value surrounded by text.
             *
             * Used when the value passed to a property has 1 interpolated value in it:
             *
             * ```html
             * <div title="prefix{{v0}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate1('title', 'prefix', v0, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate1(propName, prefix, v0, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation1(getLView(), prefix, v0, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate1;
            }
            /**
             *
             * Update an interpolated property on an element with 2 bound values surrounded by text.
             *
             * Used when the value passed to a property has 2 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate2('title', 'prefix', v0, '-', v1, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate2(propName, prefix, v0, i0, v1, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation2(getLView(), prefix, v0, i0, v1, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate2;
            }
            /**
             *
             * Update an interpolated property on an element with 3 bound values surrounded by text.
             *
             * Used when the value passed to a property has 3 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}-{{v2}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate3(
             * 'title', 'prefix', v0, '-', v1, '-', v2, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate3(propName, prefix, v0, i0, v1, i1, v2, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation3(getLView(), prefix, v0, i0, v1, i1, v2, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate3;
            }
            /**
             *
             * Update an interpolated property on an element with 4 bound values surrounded by text.
             *
             * Used when the value passed to a property has 4 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate4(
             * 'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate4(propName, prefix, v0, i0, v1, i1, v2, i2, v3, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation4(getLView(), prefix, v0, i0, v1, i1, v2, i2, v3, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate4;
            }
            /**
             *
             * Update an interpolated property on an element with 5 bound values surrounded by text.
             *
             * Used when the value passed to a property has 5 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate5(
             * 'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate5(propName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation5(getLView(), prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate5;
            }
            /**
             *
             * Update an interpolated property on an element with 6 bound values surrounded by text.
             *
             * Used when the value passed to a property has 6 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate6(
             *    'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate6(propName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation6(getLView(), prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate6;
            }
            /**
             *
             * Update an interpolated property on an element with 7 bound values surrounded by text.
             *
             * Used when the value passed to a property has 7 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate7(
             *    'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate7(propName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation7(getLView(), prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate7;
            }
            /**
             *
             * Update an interpolated property on an element with 8 bound values surrounded by text.
             *
             * Used when the value passed to a property has 8 interpolated values in it:
             *
             * ```html
             * <div title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolate8(
             *  'title', 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, 'suffix');
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} i6 Static value used for concatenation only.
             * @param {?} v7 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolate8(propName, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolation8(getLView(), prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolate8;
            }
            /**
             * Update an interpolated property on an element with 8 or more bound values surrounded by text.
             *
             * Used when the number of interpolated values exceeds 7.
             *
             * ```html
             * <div
             *  title="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}-{{v8}}-{{v9}}suffix"></div>
             * ```
             *
             * Its compiled representation is::
             *
             * ```ts
             * ɵɵpropertyInterpolateV(
             *  'title', ['prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, '-', v9,
             *  'suffix']);
             * ```
             *
             * If the property name also exists as an input property on one of the element's directives,
             * the component property will be set instead of the element property. This check must
             * be conducted at runtime so child components that add new `\@Inputs` don't have to be re-compiled.
             *
             * \@codeGenApi
             * @param {?} propName The name of the property to update.
             * @param {?} values The a collection of values and the strings inbetween those values, beginning with a
             * string prefix and ending with a string suffix.
             * (e.g. `['prefix', value0, '-', value1, '-', value2, ..., value99, 'suffix']`)
             * @param {?=} sanitizer An optional sanitizer function
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵpropertyInterpolateV(propName, values, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var interpolatedValue = interpolationV(getLView(), values);
                if (interpolatedValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, interpolatedValue, sanitizer);
                }
                return ɵɵpropertyInterpolateV;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Create static text node
             *
             * \@codeGenApi
             * @param {?} index Index of the node in the data array
             * @param {?=} value Value to write. This value will be stringified.
             *
             * @return {?}
             */
            function ɵɵtext(index, value) {
                /** @type {?} */
                var lView = getLView();
                ngDevMode && assertEqual(lView[BINDING_INDEX], lView[TVIEW].bindingStartIndex, 'text nodes should be created before any bindings');
                ngDevMode && ngDevMode.rendererCreateTextNode++;
                ngDevMode && assertDataInRange(lView, index + HEADER_OFFSET);
                /** @type {?} */
                var textNative = lView[index + HEADER_OFFSET] = createTextNode(value, lView[RENDERER]);
                ngDevMode && ngDevMode.rendererSetText++;
                /** @type {?} */
                var tNode = getOrCreateTNode(lView[TVIEW], lView[T_HOST], index, 3 /* Element */, null, null);
                // Text nodes are self closing.
                setIsNotParent();
                appendChild(textNative, tNode, lView);
            }
            /**
             * Create text node with binding
             * Bindings should be handled externally with the proper interpolation(1-8) method
             *
             * \@codeGenApi
             * @template T
             * @param {?} value Stringified value to write.
             *
             * @return {?}
             */
            function ɵɵtextBinding(value) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var bound = bind(lView, value);
                if (bound !== NO_CHANGE) {
                    textBindingInternal(lView, index, renderStringify(bound));
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             *
             * Update text content with a lone bound value
             *
             * Used when a text node has 1 interpolated value in it, an no additional text
             * surrounds that interpolated value:
             *
             * ```html
             * <div>{{v0}}</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate(v0);
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} v0
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate(v0) {
                ɵɵtextInterpolate1('', v0, '');
                return ɵɵtextInterpolate;
            }
            /**
             *
             * Update text content with single bound value surrounded by other text.
             *
             * Used when a text node has 1 interpolated value in it:
             *
             * ```html
             * <div>prefix{{v0}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate1('prefix', v0, 'suffix');
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate1(prefix, v0, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation1(lView, prefix, v0, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate1;
            }
            /**
             *
             * Update text content with 2 bound values surrounded by other text.
             *
             * Used when a text node has 2 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate2('prefix', v0, '-', v1, 'suffix');
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate2(prefix, v0, i0, v1, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation2(lView, prefix, v0, i0, v1, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate2;
            }
            /**
             *
             * Update text content with 3 bound values surrounded by other text.
             *
             * Used when a text node has 3 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate3(
             * 'prefix', v0, '-', v1, '-', v2, 'suffix');
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate3(prefix, v0, i0, v1, i1, v2, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation3(lView, prefix, v0, i0, v1, i1, v2, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate3;
            }
            /**
             *
             * Update text content with 4 bound values surrounded by other text.
             *
             * Used when a text node has 4 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate4(
             * 'prefix', v0, '-', v1, '-', v2, '-', v3, 'suffix');
             * ```
             * @see ɵɵtextInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate4(prefix, v0, i0, v1, i1, v2, i2, v3, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation4(lView, prefix, v0, i0, v1, i1, v2, i2, v3, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate4;
            }
            /**
             *
             * Update text content with 5 bound values surrounded by other text.
             *
             * Used when a text node has 5 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate5(
             * 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, 'suffix');
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate5(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation5(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate5;
            }
            /**
             *
             * Update text content with 6 bound values surrounded by other text.
             *
             * Used when a text node has 6 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate6(
             *    'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, 'suffix');
             * ```
             *
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change. \@returns itself, so that it may be chained.
             * @param {?} suffix
             * @return {?}
             */
            function ɵɵtextInterpolate6(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation6(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate6;
            }
            /**
             *
             * Update text content with 7 bound values surrounded by other text.
             *
             * Used when a text node has 7 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate7(
             *    'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, 'suffix');
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} i4
             * @param {?} v5
             * @param {?} i5
             * @param {?} v6
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate7(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation7(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate7;
            }
            /**
             *
             * Update text content with 8 bound values surrounded by other text.
             *
             * Used when a text node has 8 interpolated values in it:
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolate8(
             *  'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, 'suffix');
             * ```
             * @see textInterpolateV
             * \@codeGenApi
             * @param {?} prefix
             * @param {?} v0
             * @param {?} i0
             * @param {?} v1
             * @param {?} i1
             * @param {?} v2
             * @param {?} i2
             * @param {?} v3
             * @param {?} i3
             * @param {?} v4
             * @param {?} i4
             * @param {?} v5
             * @param {?} i5
             * @param {?} v6
             * @param {?} i6
             * @param {?} v7
             * @param {?} suffix
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolate8(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolation8(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolate8;
            }
            /**
             * Update text content with 9 or more bound values other surrounded by text.
             *
             * Used when the number of interpolated values exceeds 8.
             *
             * ```html
             * <div>prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}-{{v8}}-{{v9}}suffix</div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵtextInterpolateV(
             *  ['prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, '-', v9,
             *  'suffix']);
             * ```
             * .
             * \@codeGenApi
             * @param {?} values The a collection of values and the strings in between those values, beginning with
             * a string prefix and ending with a string suffix.
             * (e.g. `['prefix', value0, '-', value1, '-', value2, ..., value99, 'suffix']`)
             *
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵtextInterpolateV(values) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolated = interpolationV(lView, values);
                if (interpolated !== NO_CHANGE) {
                    textBindingInternal(lView, index, ( /** @type {?} */(interpolated)));
                }
                return ɵɵtextInterpolateV;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             *
             * Update an interpolated class on an element with single bound value surrounded by text.
             *
             * Used when the value passed to a property has 1 interpolated value in it:
             *
             * ```html
             * <div class="prefix{{v0}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate1('prefix', v0, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate1(prefix, v0, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation1(lView, prefix, v0, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 2 bound values surrounded by text.
             *
             * Used when the value passed to a property has 2 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate2('prefix', v0, '-', v1, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate2(prefix, v0, i0, v1, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation2(lView, prefix, v0, i0, v1, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 3 bound values surrounded by text.
             *
             * Used when the value passed to a property has 3 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}-{{v2}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate3(
             * 'prefix', v0, '-', v1, '-', v2, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate3(prefix, v0, i0, v1, i1, v2, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation3(lView, prefix, v0, i0, v1, i1, v2, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 4 bound values surrounded by text.
             *
             * Used when the value passed to a property has 4 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate4(
             * 'prefix', v0, '-', v1, '-', v2, '-', v3, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate4(prefix, v0, i0, v1, i1, v2, i2, v3, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation4(lView, prefix, v0, i0, v1, i1, v2, i2, v3, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 5 bound values surrounded by text.
             *
             * Used when the value passed to a property has 5 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate5(
             * 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate5(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation5(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 6 bound values surrounded by text.
             *
             * Used when the value passed to a property has 6 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate6(
             *    'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate6(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation6(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 7 bound values surrounded by text.
             *
             * Used when the value passed to a property has 7 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate7(
             *    'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate7(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation7(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             *
             * Update an interpolated class on an element with 8 bound values surrounded by text.
             *
             * Used when the value passed to a property has 8 interpolated values in it:
             *
             * ```html
             * <div class="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolate8(
             *  'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} i6 Static value used for concatenation only.
             * @param {?} v7 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @return {?}
             */
            function ɵɵclassMapInterpolate8(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation8(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             * Update an interpolated class on an element with 8 or more bound values surrounded by text.
             *
             * Used when the number of interpolated values exceeds 7.
             *
             * ```html
             * <div
             *  class="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}-{{v8}}-{{v9}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵclassMapInterpolateV(
             *  ['prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, '-', v9,
             *  'suffix']);
             * ```
             * .
             * \@codeGenApi
             * @param {?} values The a collection of values and the strings in-between those values, beginning with
             * a string prefix and ending with a string suffix.
             * (e.g. `['prefix', value0, '-', value1, '-', value2, ..., value99, 'suffix']`)
             * @return {?}
             */
            function ɵɵclassMapInterpolateV(values) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolationV(lView, values);
                classMapInternal(getSelectedIndex(), interpolatedValue);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             *
             * Update an interpolated style property on an element with single bound value surrounded by text.
             *
             * Used when the value passed to a property has 1 interpolated value in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate1(0, 'prefix', v0, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate1(prop, prefix, v0, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation1(lView, prefix, v0, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate1;
            }
            /**
             *
             * Update an interpolated style property on an element with 2 bound values surrounded by text.
             *
             * Used when the value passed to a property has 2 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate2(0, 'prefix', v0, '-', v1, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate2(prop, prefix, v0, i0, v1, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation2(lView, prefix, v0, i0, v1, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate2;
            }
            /**
             *
             * Update an interpolated style property on an element with 3 bound values surrounded by text.
             *
             * Used when the value passed to a property has 3 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}-{{v2}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate3(0, 'prefix', v0, '-', v1, '-', v2, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate3(prop, prefix, v0, i0, v1, i1, v2, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation3(lView, prefix, v0, i0, v1, i1, v2, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate3;
            }
            /**
             *
             * Update an interpolated style property on an element with 4 bound values surrounded by text.
             *
             * Used when the value passed to a property has 4 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate4(0, 'prefix', v0, '-', v1, '-', v2, '-', v3, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate4(prop, prefix, v0, i0, v1, i1, v2, i2, v3, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation4(lView, prefix, v0, i0, v1, i1, v2, i2, v3, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate4;
            }
            /**
             *
             * Update an interpolated style property on an element with 5 bound values surrounded by text.
             *
             * Used when the value passed to a property has 5 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate5(0, 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate5(prop, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation5(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate5;
            }
            /**
             *
             * Update an interpolated style property on an element with 6 bound values surrounded by text.
             *
             * Used when the value passed to a property has 6 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate6(0, 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate6(prop, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation6(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate6;
            }
            /**
             *
             * Update an interpolated style property on an element with 7 bound values surrounded by text.
             *
             * Used when the value passed to a property has 7 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate7(
             *    0, 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate7(prop, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation7(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate7;
            }
            /**
             *
             * Update an interpolated style property on an element with 8 bound values surrounded by text.
             *
             * Used when the value passed to a property has 8 interpolated values in it:
             *
             * ```html
             * <div style.color="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}suffix"></div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolate8(0, 'prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6,
             * '-', v7, 'suffix');
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} prefix Static value used for concatenation only.
             * @param {?} v0 Value checked for change.
             * @param {?} i0 Static value used for concatenation only.
             * @param {?} v1 Value checked for change.
             * @param {?} i1 Static value used for concatenation only.
             * @param {?} v2 Value checked for change.
             * @param {?} i2 Static value used for concatenation only.
             * @param {?} v3 Value checked for change.
             * @param {?} i3 Static value used for concatenation only.
             * @param {?} v4 Value checked for change.
             * @param {?} i4 Static value used for concatenation only.
             * @param {?} v5 Value checked for change.
             * @param {?} i5 Static value used for concatenation only.
             * @param {?} v6 Value checked for change.
             * @param {?} i6 Static value used for concatenation only.
             * @param {?} v7 Value checked for change.
             * @param {?} suffix Static value used for concatenation only.
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolate8(prop, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolation8(lView, prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolate8;
            }
            /**
             * Update an interpolated style property on an element with 8 or more bound values surrounded by
             * text.
             *
             * Used when the number of interpolated values exceeds 7.
             *
             * ```html
             * <div
             *  style.color="prefix{{v0}}-{{v1}}-{{v2}}-{{v3}}-{{v4}}-{{v5}}-{{v6}}-{{v7}}-{{v8}}-{{v9}}suffix">
             * </div>
             * ```
             *
             * Its compiled representation is:
             *
             * ```ts
             * ɵɵstylePropInterpolateV(
             *  0, ['prefix', v0, '-', v1, '-', v2, '-', v3, '-', v4, '-', v5, '-', v6, '-', v7, '-', v9,
             *  'suffix']);
             * ```
             *
             * \@codeGenApi
             * @param {?} prop
             * @param {?} values The a collection of values and the strings in-between those values, beginning with
             * a string prefix and ending with a string suffix.
             * (e.g. `['prefix', value0, '-', value1, '-', value2, ..., value99, 'suffix']`)
             * @param {?=} valueSuffix Optional suffix. Used with scalar values to add unit such as `px`.
             * @return {?} itself, so that it may be chained.
             */
            function ɵɵstylePropInterpolateV(prop, values, valueSuffix) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var interpolatedValue = interpolationV(lView, values);
                stylePropInternal(getSelectedIndex(), prop, ( /** @type {?} */(interpolatedValue)), valueSuffix);
                return ɵɵstylePropInterpolateV;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Update a property on a host element. Only applies to native node properties, not inputs.
             *
             * Operates on the element selected by index via the {\@link select} instruction.
             *
             * \@codeGenApi
             * @template T
             * @param {?} propName Name of property. Because it is going to DOM, this is not subject to
             *        renaming as part of minification.
             * @param {?} value New value to write.
             * @param {?=} sanitizer An optional function used to sanitize the value.
             * @return {?} This function returns itself so that it may be chained
             * (e.g. `property('name', ctx.name)('title', ctx.title)`)
             *
             */
            function ɵɵhostProperty(propName, value, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                ngDevMode && assertNotEqual(index, -1, 'selected index cannot be -1');
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var bindReconciledValue = bind(lView, value);
                if (bindReconciledValue !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, bindReconciledValue, sanitizer, true);
                }
                return ɵɵhostProperty;
            }
            /**
             * Updates a synthetic host binding (e.g. `[\@foo]`) on a component.
             *
             * This instruction is for compatibility purposes and is designed to ensure that a
             * synthetic host binding (e.g. `\@HostBinding('\@foo')`) properly gets rendered in
             * the component's renderer. Normally all host bindings are evaluated with the parent
             * component's renderer, but, in the case of animation \@triggers, they need to be
             * evaluated with the sub component's renderer (because that's where the animation
             * triggers are defined).
             *
             * Do not use this instruction as a replacement for `elementProperty`. This instruction
             * only exists to ensure compatibility with the ViewEngine's host binding behavior.
             *
             * \@codeGenApi
             * @template T
             * @param {?} propName Name of property. Because it is going to DOM, this is not subject to
             *        renaming as part of minification.
             * @param {?} value New value to write.
             * @param {?=} sanitizer An optional function used to sanitize the value.
             *
             * @return {?}
             */
            function ɵɵupdateSyntheticHostBinding(propName, value, sanitizer) {
                /** @type {?} */
                var index = getSelectedIndex();
                /** @type {?} */
                var lView = getLView();
                // TODO(benlesh): remove bind call here.
                /** @type {?} */
                var bound = bind(lView, value);
                if (bound !== NO_CHANGE) {
                    elementPropertyInternal(index, propName, bound, sanitizer, true, loadComponentRenderer);
                }
                return ɵɵupdateSyntheticHostBinding;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns the component instance associated with a given DOM host element.
             * Elements which don't represent components return `null`.
             *
             * \@publicApi
             * @template T
             * @param {?} element Host DOM element from which the component should be retrieved.
             *
             * ```
             * <my-app>
             *   #VIEW
             *     <div>
             *       <child-comp></child-comp>
             *     </div>
             * </mp-app>
             *
             * expect(getComponent(<child-comp>) instanceof ChildComponent).toBeTruthy();
             * expect(getComponent(<my-app>) instanceof MyApp).toBeTruthy();
             * ```
             *
             * @return {?}
             */
            function getComponent(element) {
                /** @type {?} */
                var context = loadLContextFromNode(element);
                if (context.component === undefined) {
                    context.component = getComponentAtNodeIndex(context.nodeIndex, context.lView);
                }
                return ( /** @type {?} */(context.component));
            }
            /**
             * Returns the component instance associated with a given DOM host element.
             * Elements which don't represent components return `null`.
             *
             * \@publicApi
             * @template T
             * @param {?} element Host DOM element from which the component should be retrieved.
             *
             * ```
             * <my-app>
             *   #VIEW
             *     <div>
             *       <child-comp></child-comp>
             *     </div>
             * </mp-app>
             *
             * expect(getComponent(<child-comp>) instanceof ChildComponent).toBeTruthy();
             * expect(getComponent(<my-app>) instanceof MyApp).toBeTruthy();
             * ```
             *
             * @return {?}
             */
            function getContext$1(element) {
                /** @type {?} */
                var context = ( /** @type {?} */(loadLContextFromNode(element)));
                return ( /** @type {?} */(context.lView[CONTEXT]));
            }
            /**
             * Returns the component instance associated with view which owns the DOM element (`null`
             * otherwise).
             *
             * \@publicApi
             * @template T
             * @param {?} element DOM element which is owned by an existing component's view.
             *
             * ```
             * <my-app>
             *   #VIEW
             *     <div>
             *       <child-comp></child-comp>
             *     </div>
             * </mp-app>
             *
             * expect(getViewComponent(<child-comp>) instanceof MyApp).toBeTruthy();
             * expect(getViewComponent(<my-app>)).toEqual(null);
             * ```
             *
             * @return {?}
             */
            function getViewComponent(element) {
                /** @type {?} */
                var context = ( /** @type {?} */(loadLContext(element)));
                /** @type {?} */
                var lView = context.lView;
                /** @type {?} */
                var parent;
                ngDevMode && assertLView(lView);
                while (lView[HOST] === null && (parent = ( /** @type {?} */(getLViewParent(lView))))) {
                    // As long as lView[HOST] is null we know we are part of sub-template such as `*ngIf`
                    lView = parent;
                }
                return lView[FLAGS] & 512 /* IsRoot */ ? null : ( /** @type {?} */(lView[CONTEXT]));
            }
            /**
             * Retrieve all root components.
             *
             * Root components are those which have been bootstrapped by Angular.
             *
             * \@publicApi
             * @param {?} target A DOM element, component or directive instance.
             *
             * @return {?}
             */
            function getRootComponents(target) {
                return getRootContext(target).components.slice();
            }
            /**
             * Retrieves an `Injector` associated with the element, component or directive.
             *
             * \@publicApi
             * @param {?} target A DOM element, component or directive instance.
             *
             * @return {?}
             */
            function getInjector(target) {
                /** @type {?} */
                var context = loadLContext(target);
                /** @type {?} */
                var tNode = ( /** @type {?} */(context.lView[TVIEW].data[context.nodeIndex]));
                return new NodeInjector(tNode, context.lView);
            }
            /**
             * Retrieve a set of injection tokens at a given DOM node.
             *
             * \@publicApi
             * @param {?} element Element for which the injection tokens should be retrieved.
             * @return {?}
             */
            function getInjectionTokens(element) {
                /** @type {?} */
                var context = loadLContext(element, false);
                if (!context)
                    return [];
                /** @type {?} */
                var lView = context.lView;
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var tNode = ( /** @type {?} */(tView.data[context.nodeIndex]));
                /** @type {?} */
                var providerTokens = [];
                /** @type {?} */
                var startIndex = tNode.providerIndexes & 65535 /* ProvidersStartIndexMask */;
                /** @type {?} */
                var endIndex = tNode.directiveEnd;
                for (var i = startIndex; i < endIndex; i++) {
                    /** @type {?} */
                    var value = tView.data[i];
                    if (isDirectiveDefHack(value)) {
                        // The fact that we sometimes store Type and sometimes DirectiveDef in this location is a
                        // design flaw.  We should always store same type so that we can be monomorphic. The issue
                        // is that for Components/Directives we store the def instead the type. The correct behavior
                        // is that we should always be storing injectable type in this location.
                        value = value.type;
                    }
                    providerTokens.push(value);
                }
                return providerTokens;
            }
            /**
             * Retrieves directives associated with a given DOM host element.
             *
             * \@publicApi
             * @param {?} target A DOM element, component or directive instance.
             *
             * @return {?}
             */
            function getDirectives(target) {
                /** @type {?} */
                var context = ( /** @type {?} */(loadLContext(target)));
                if (context.directives === undefined) {
                    context.directives = getDirectivesAtNodeIndex(context.nodeIndex, context.lView, false);
                }
                return context.directives || [];
            }
            /**
             * @param {?} target
             * @param {?=} throwOnNotFound
             * @return {?}
             */
            function loadLContext(target, throwOnNotFound) {
                if (throwOnNotFound === void 0) { throwOnNotFound = true; }
                /** @type {?} */
                var context = getLContext(target);
                if (!context && throwOnNotFound) {
                    throw new Error(ngDevMode ? "Unable to find context associated with " + stringifyForError(target) :
                        'Invalid ng target');
                }
                return context;
            }
            /**
             * Retrieve map of local references.
             *
             * The references are retrieved as a map of local reference name to element or directive instance.
             *
             * \@publicApi
             * @param {?} target A DOM element, component or directive instance.
             *
             * @return {?}
             */
            function getLocalRefs(target) {
                /** @type {?} */
                var context = ( /** @type {?} */(loadLContext(target)));
                if (context.localRefs === undefined) {
                    context.localRefs = discoverLocalRefs(context.lView, context.nodeIndex);
                }
                return context.localRefs || {};
            }
            /**
             * Retrieve the host element of the component.
             *
             * Use this function to retrieve the host element of the component. The host
             * element is the element which the component is associated with.
             *
             * \@publicApi
             * @template T
             * @param {?} directive Component or Directive for which the host element should be retrieved.
             *
             * @return {?}
             */
            function getHostElement(directive) {
                return ( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(getLContext(directive))).native))));
            }
            /**
             * Retrieves the rendered text for a given component.
             *
             * This function retrieves the host element of a component and
             * and then returns the `textContent` for that element. This implies
             * that the text returned will include re-projected content of
             * the component as well.
             *
             * @param {?} component The component to return the content text for.
             * @return {?}
             */
            function getRenderedText(component) {
                /** @type {?} */
                var hostElement = getHostElement(component);
                return hostElement.textContent || '';
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function loadLContextFromNode(node) {
                if (!(node instanceof Node))
                    throw new Error('Expecting instance of DOM Node');
                return ( /** @type {?} */(loadLContext(node)));
            }
            /**
             * @record
             */
            function Listener() { }
            if (false) { }
            /**
             * @param {?} listener
             * @return {?}
             */
            function isBrowserEvents(listener) {
                // Browser events are those which don't have `useCapture` as boolean.
                return typeof listener.useCapture === 'boolean';
            }
            /**
             * Retrieves a list of DOM listeners.
             *
             * ```
             * <my-app>
             *   #VIEW
             *     <div (click)="doSomething()">
             *     </div>
             * </mp-app>
             *
             * expect(getListeners(<div>)).toEqual({
             *   name: 'click',
             *   element: <div>,
             *   callback: () => doSomething(),
             *   useCapture: false
             * });
             * ```
             *
             * \@publicApi
             * @param {?} element Element for which the DOM listeners should be retrieved.
             * @return {?}
             */
            function getListeners(element) {
                /** @type {?} */
                var lContext = loadLContextFromNode(element);
                /** @type {?} */
                var lView = lContext.lView;
                /** @type {?} */
                var tView = lView[TVIEW];
                /** @type {?} */
                var lCleanup = lView[CLEANUP];
                /** @type {?} */
                var tCleanup = tView.cleanup;
                /** @type {?} */
                var listeners = [];
                if (tCleanup && lCleanup) {
                    for (var i = 0; i < tCleanup.length;) {
                        /** @type {?} */
                        var firstParam = tCleanup[i++];
                        /** @type {?} */
                        var secondParam = tCleanup[i++];
                        if (typeof firstParam === 'string') {
                            /** @type {?} */
                            var name = firstParam;
                            /** @type {?} */
                            var listenerElement = ( /** @type {?} */(( /** @type {?} */(unwrapRNode(lView[secondParam])))));
                            /** @type {?} */
                            var callback = lCleanup[tCleanup[i++]];
                            /** @type {?} */
                            var useCaptureOrIndx = tCleanup[i++];
                            // if useCaptureOrIndx is boolean then report it as is.
                            // if useCaptureOrIndx is positive number then it in unsubscribe method
                            // if useCaptureOrIndx is negative number then it is a Subscription
                            /** @type {?} */
                            var useCapture = typeof useCaptureOrIndx === 'boolean' ?
                                useCaptureOrIndx :
                                (useCaptureOrIndx >= 0 ? false : null);
                            if (element == listenerElement) {
                                listeners.push({ element: element, name: name, callback: callback, useCapture: useCapture });
                            }
                        }
                    }
                }
                listeners.sort(sortListeners);
                return listeners;
            }
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function sortListeners(a, b) {
                if (a.name == b.name)
                    return 0;
                return a.name < b.name ? -1 : 1;
            }
            /**
             * This function should not exist because it is megamorphic and only mostly correct.
             *
             * See call site for more info.
             * @param {?} obj
             * @return {?}
             */
            function isDirectiveDefHack(obj) {
                return obj.type !== undefined && obj.template !== undefined && obj.declaredInputs !== undefined;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This value reflects the property on the window where the dev
             * tools are patched (window.ng).
             *
             * @type {?}
             */
            var GLOBAL_PUBLISH_EXPANDO_KEY = 'ng';
            /** @type {?} */
            var _published = false;
            /**
             * Publishes a collection of default debug tools onto`window.ng`.
             *
             * These functions are available globally when Angular is in development
             * mode and are automatically stripped away from prod mode is on.
             * @return {?}
             */
            function publishDefaultGlobalUtils() {
                if (!_published) {
                    _published = true;
                    publishGlobalUtil('getComponent', getComponent);
                    publishGlobalUtil('getContext', getContext$1);
                    publishGlobalUtil('getListeners', getListeners);
                    publishGlobalUtil('getViewComponent', getViewComponent);
                    publishGlobalUtil('getHostElement', getHostElement);
                    publishGlobalUtil('getInjector', getInjector);
                    publishGlobalUtil('getRootComponents', getRootComponents);
                    publishGlobalUtil('getDirectives', getDirectives);
                    publishGlobalUtil('markDirty', markDirty);
                }
            }
            /**
             * Publishes the given function to `window.ng` so that it can be
             * used from the browser console when an application is not in production.
             * @param {?} name
             * @param {?} fn
             * @return {?}
             */
            function publishGlobalUtil(name, fn) {
                /** @type {?} */
                var w = ( /** @type {?} */(( /** @type {?} */(_global))));
                ngDevMode && assertDefined(fn, 'function not defined');
                if (w) {
                    /** @type {?} */
                    var container = w[GLOBAL_PUBLISH_EXPANDO_KEY];
                    if (!container) {
                        container = w[GLOBAL_PUBLISH_EXPANDO_KEY] = {};
                    }
                    container[name] = fn;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Options that control how the component should be bootstrapped.
             * @record
             */
            function CreateComponentOptions() { }
            if (false) { }
            // TODO: A hack to not pull in the NullInjector from @angular/core.
            var ɵ0$c = /**
             * @param {?} token
             * @param {?=} notFoundValue
             * @return {?}
             */ function (token, notFoundValue) {
                throw new Error('NullInjector: Not found: ' + stringifyForError(token));
            };
            /** @type {?} */
            var NULL_INJECTOR$1 = {
                get: (ɵ0$c)
            };
            /**
             * Bootstraps a Component into an existing host element and returns an instance
             * of the component.
             *
             * Use this function to bootstrap a component into the DOM tree. Each invocation
             * of this function will create a separate tree of components, injectors and
             * change detection cycles and lifetimes. To dynamically insert a new component
             * into an existing tree such that it shares the same injection, change detection
             * and object lifetime, use {\@link ViewContainer#createComponent}.
             *
             * @template T
             * @param {?} componentType Component to bootstrap
             * @param {?=} opts
             * @return {?}
             */
            function renderComponent(componentType /* Type as workaround for: Microsoft/TypeScript/issues/4881 */, opts) {
                if (opts === void 0) { opts = {}; }
                ngDevMode && publishDefaultGlobalUtils();
                ngDevMode && assertComponentType(componentType);
                // this is preemptively set to avoid having test and debug code accidentally
                // read data from a previous application state...
                setActiveHostElement(null);
                /** @type {?} */
                var rendererFactory = opts.rendererFactory || domRendererFactory3;
                /** @type {?} */
                var sanitizer = opts.sanitizer || null;
                /** @type {?} */
                var componentDef = ( /** @type {?} */(getComponentDef(componentType)));
                if (componentDef.type != componentType)
                    componentDef.type = componentType;
                // The first index of the first selector is the tag name.
                /** @type {?} */
                var componentTag = ( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(componentDef.selectors))[0]))[0]));
                /** @type {?} */
                var hostRNode = locateHostElement(rendererFactory, opts.host || componentTag);
                /** @type {?} */
                var rootFlags = componentDef.onPush ? 64 /* Dirty */ | 512 /* IsRoot */ :
                    16 /* CheckAlways */ | 512 /* IsRoot */;
                /** @type {?} */
                var rootContext = createRootContext(opts.scheduler, opts.playerHandler);
                /** @type {?} */
                var renderer = rendererFactory.createRenderer(hostRNode, componentDef);
                /** @type {?} */
                var rootView = createLView(null, createTView(-1, null, 1, 0, null, null, null, null), rootContext, rootFlags, null, null, rendererFactory, renderer, undefined, opts.injector || null);
                /** @type {?} */
                var oldView = enterView(rootView, null);
                /** @type {?} */
                var component;
                // Will become true if the `try` block executes with no errors.
                /** @type {?} */
                var safeToRunHooks = false;
                try {
                    if (rendererFactory.begin)
                        rendererFactory.begin();
                    /** @type {?} */
                    var componentView = createRootComponentView(hostRNode, componentDef, rootView, rendererFactory, renderer, sanitizer);
                    component = createRootComponent(componentView, componentDef, rootView, rootContext, opts.hostFeatures || null);
                    addToViewTree(rootView, componentView);
                    refreshDescendantViews(rootView); // creation mode pass
                    rootView[FLAGS] &= ~4 /* CreationMode */;
                    resetPreOrderHookFlags(rootView);
                    refreshDescendantViews(rootView); // update mode pass
                    safeToRunHooks = true;
                }
                finally {
                    leaveView(oldView, safeToRunHooks);
                    if (rendererFactory.end)
                        rendererFactory.end();
                }
                return component;
            }
            /**
             * Creates the root component view and the root component node.
             *
             * @param {?} rNode Render host element.
             * @param {?} def ComponentDef
             * @param {?} rootView The parent view where the host node is stored
             * @param {?} rendererFactory
             * @param {?} renderer The current renderer
             * @param {?=} sanitizer The sanitizer, if provided
             *
             * @return {?} Component view created
             */
            function createRootComponentView(rNode, def, rootView, rendererFactory, renderer, sanitizer) {
                resetComponentState();
                /** @type {?} */
                var tView = rootView[TVIEW];
                ngDevMode && assertDataInRange(rootView, 0 + HEADER_OFFSET);
                rootView[0 + HEADER_OFFSET] = rNode;
                /** @type {?} */
                var tNode = getOrCreateTNode(tView, null, 0, 3 /* Element */, null, null);
                /** @type {?} */
                var componentView = createLView(rootView, getOrCreateTView(def), null, def.onPush ? 64 /* Dirty */ : 16 /* CheckAlways */, rootView[HEADER_OFFSET], tNode, rendererFactory, renderer, sanitizer);
                if (tView.firstTemplatePass) {
                    diPublicInInjector(getOrCreateNodeInjectorForNode(tNode, rootView), tView, def.type);
                    tNode.flags = 1 /* isComponent */;
                    initNodeFlags(tNode, rootView.length, 1);
                    queueComponentIndexForCheck(tNode);
                }
                // Store component view at node index, with node as the HOST
                return rootView[HEADER_OFFSET] = componentView;
            }
            /**
             * Creates a root component and sets it up with features and host bindings. Shared by
             * renderComponent() and ViewContainerRef.createComponent().
             * @template T
             * @param {?} componentView
             * @param {?} componentDef
             * @param {?} rootView
             * @param {?} rootContext
             * @param {?} hostFeatures
             * @return {?}
             */
            function createRootComponent(componentView, componentDef, rootView, rootContext, hostFeatures) {
                /** @type {?} */
                var tView = rootView[TVIEW];
                // Create directive instance with factory() and store at next index in viewData
                /** @type {?} */
                var component = instantiateRootComponent(tView, rootView, componentDef);
                rootContext.components.push(component);
                componentView[CONTEXT] = component;
                hostFeatures && hostFeatures.forEach(( /**
                 * @param {?} feature
                 * @return {?}
                 */function (feature) { return feature(component, componentDef); }));
                // We want to generate an empty QueryList for root content queries for backwards
                // compatibility with ViewEngine.
                if (componentDef.contentQueries) {
                    componentDef.contentQueries(1 /* Create */, component, rootView.length - 1);
                }
                /** @type {?} */
                var rootTNode = getPreviousOrParentTNode();
                if (tView.firstTemplatePass && componentDef.hostBindings) {
                    /** @type {?} */
                    var elementIndex = rootTNode.index - HEADER_OFFSET;
                    setActiveHostElement(elementIndex);
                    /** @type {?} */
                    var expando = ( /** @type {?} */(tView.expandoInstructions));
                    invokeHostBindingsInCreationMode(componentDef, expando, component, rootTNode, tView.firstTemplatePass);
                    setActiveHostElement(null);
                }
                return component;
            }
            /**
             * @param {?=} scheduler
             * @param {?=} playerHandler
             * @return {?}
             */
            function createRootContext(scheduler, playerHandler) {
                return {
                    components: [],
                    scheduler: scheduler || defaultScheduler,
                    clean: CLEAN_PROMISE,
                    playerHandler: playerHandler || null,
                    flags: 0 /* Empty */
                };
            }
            /**
             * Used to enable lifecycle hooks on the root component.
             *
             * Include this feature when calling `renderComponent` if the root component
             * you are rendering has lifecycle hooks defined. Otherwise, the hooks won't
             * be called properly.
             *
             * Example:
             *
             * ```
             * renderComponent(AppComponent, {features: [RootLifecycleHooks]});
             * ```
             * @param {?} component
             * @param {?} def
             * @return {?}
             */
            function LifecycleHooksFeature(component, def) {
                /** @type {?} */
                var rootTView = ( /** @type {?} */(readPatchedLView(component)))[TVIEW];
                /** @type {?} */
                var dirIndex = rootTView.data.length - 1;
                registerPreOrderHooks(dirIndex, def, rootTView, -1, -1, -1);
                // TODO(misko): replace `as TNode` with createTNode call. (needs refactoring to lose dep on
                // LNode).
                registerPostOrderHooks(rootTView, ( /** @type {?} */({ directiveStart: dirIndex, directiveEnd: dirIndex + 1 })));
            }
            /**
             * Wait on component until it is rendered.
             *
             * This function returns a `Promise` which is resolved when the component's
             * change detection is executed. This is determined by finding the scheduler
             * associated with the `component`'s render tree and waiting until the scheduler
             * flushes. If nothing is scheduled, the function returns a resolved promise.
             *
             * Example:
             * ```
             * await whenRendered(myComponent);
             * ```
             *
             * @param {?} component Component to wait upon
             * @return {?} Promise which resolves when the component is rendered.
             */
            function whenRendered(component) {
                return getRootContext(component).clean;
            }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Represents a basic change from a previous to a new value for a single
             * property on a directive instance. Passed as a value in a
             * {@link SimpleChanges} object to the `ngOnChanges` hook.
             *
             * @see `OnChanges`
             *
             * @publicApi
             */
            var SimpleChange = /** @class */ (function () {
                function SimpleChange(previousValue, currentValue, firstChange) {
                    this.previousValue = previousValue;
                    this.currentValue = currentValue;
                    this.firstChange = firstChange;
                }
                /**
                 * Check whether the new value is the first value assigned.
                 */
                SimpleChange.prototype.isFirstChange = function () { return this.firstChange; };
                return SimpleChange;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var PRIVATE_PREFIX = '__ngOnChanges_';
            /**
             * The NgOnChangesFeature decorates a component with support for the ngOnChanges
             * lifecycle hook, so it should be included in any component that implements
             * that hook.
             *
             * If the component or directive uses inheritance, the NgOnChangesFeature MUST
             * be included as a feature AFTER {\@link InheritDefinitionFeature}, otherwise
             * inherited properties will not be propagated to the ngOnChanges lifecycle
             * hook.
             *
             * Example usage:
             *
             * ```
             * static ngComponentDef = defineComponent({
             *   ...
             *   inputs: {name: 'publicName'},
             *   features: [NgOnChangesFeature()]
             * });
             * ```
             *
             * \@codeGenApi
             * @template T
             * @return {?}
             */
            function ɵɵNgOnChangesFeature() {
                // This option ensures that the ngOnChanges lifecycle hook will be inherited
                // from superclasses (in InheritDefinitionFeature).
                (( /** @type {?} */(NgOnChangesFeatureImpl))).ngInherit = true;
                return NgOnChangesFeatureImpl;
            }
            /**
             * @template T
             * @param {?} definition
             * @return {?}
             */
            function NgOnChangesFeatureImpl(definition) {
                if (definition.type.prototype.ngOnChanges) {
                    definition.setInput = ngOnChangesSetInput;
                    definition.onChanges = wrapOnChanges();
                }
            }
            /**
             * @return {?}
             */
            function wrapOnChanges() {
                return ( /**
                 * @this {?}
                 * @return {?}
                 */function wrapOnChangesHook_inPreviousChangesStorage() {
                    /** @type {?} */
                    var simpleChangesStore = getSimpleChangesStore(this);
                    /** @type {?} */
                    var current = simpleChangesStore && simpleChangesStore.current;
                    if (current) {
                        /** @type {?} */
                        var previous = ( /** @type {?} */(simpleChangesStore)).previous;
                        if (previous === EMPTY_OBJ) {
                            ( /** @type {?} */(simpleChangesStore)).previous = current;
                        }
                        else {
                            // New changes are copied to the previous store, so that we don't lose history for inputs
                            // which were not changed this time
                            for (var key in current) {
                                previous[key] = current[key];
                            }
                        }
                        ( /** @type {?} */(simpleChangesStore)).current = null;
                        this.ngOnChanges(current);
                    }
                });
            }
            /**
             * @template T
             * @this {?}
             * @param {?} instance
             * @param {?} value
             * @param {?} publicName
             * @param {?} privateName
             * @return {?}
             */
            function ngOnChangesSetInput(instance, value, publicName, privateName) {
                /** @type {?} */
                var simpleChangesStore = getSimpleChangesStore(instance) ||
                    setSimpleChangesStore(instance, { previous: EMPTY_OBJ, current: null });
                /** @type {?} */
                var current = simpleChangesStore.current || (simpleChangesStore.current = {});
                /** @type {?} */
                var previous = simpleChangesStore.previous;
                /** @type {?} */
                var declaredName = (( /** @type {?} */(this.declaredInputs)))[publicName];
                /** @type {?} */
                var previousChange = previous[declaredName];
                current[declaredName] = new SimpleChange(previousChange && previousChange.currentValue, value, previous === EMPTY_OBJ);
                (( /** @type {?} */(instance)))[privateName] = value;
            }
            /** @type {?} */
            var SIMPLE_CHANGES_STORE = '__ngSimpleChanges__';
            /**
             * @param {?} instance
             * @return {?}
             */
            function getSimpleChangesStore(instance) {
                return instance[SIMPLE_CHANGES_STORE] || null;
            }
            /**
             * @param {?} instance
             * @param {?} store
             * @return {?}
             */
            function setSimpleChangesStore(instance, store) {
                return instance[SIMPLE_CHANGES_STORE] = store;
            }
            /**
             * @record
             */
            function NgSimpleChangesStore() { }
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} type
             * @return {?}
             */
            function getSuperType(type) {
                return Object.getPrototypeOf(type.prototype).constructor;
            }
            /**
             * Merges the definition from a super class to a sub class.
             * \@codeGenApi
             * @param {?} definition The definition that is a SubClass of another directive of component
             *
             * @return {?}
             */
            function ɵɵInheritDefinitionFeature(definition) {
                /** @type {?} */
                var superType = getSuperType(definition.type);
                while (superType) {
                    /** @type {?} */
                    var superDef = undefined;
                    if (isComponentDef(definition)) {
                        // Don't use getComponentDef/getDirectiveDef. This logic relies on inheritance.
                        superDef = superType.ngComponentDef || superType.ngDirectiveDef;
                    }
                    else {
                        if (superType.ngComponentDef) {
                            throw new Error('Directives cannot inherit Components');
                        }
                        // Don't use getComponentDef/getDirectiveDef. This logic relies on inheritance.
                        superDef = superType.ngDirectiveDef;
                    }
                    /** @nocollapse @type {?} */
                    var baseDef = (( /** @type {?} */(superType))).ngBaseDef;
                    // Some fields in the definition may be empty, if there were no values to put in them that
                    // would've justified object creation. Unwrap them if necessary.
                    if (baseDef || superDef) {
                        /** @type {?} */
                        var writeableDef = ( /** @type {?} */(definition));
                        writeableDef.inputs = maybeUnwrapEmpty(definition.inputs);
                        writeableDef.declaredInputs = maybeUnwrapEmpty(definition.declaredInputs);
                        writeableDef.outputs = maybeUnwrapEmpty(definition.outputs);
                    }
                    if (baseDef) {
                        /** @type {?} */
                        var baseViewQuery = baseDef.viewQuery;
                        /** @type {?} */
                        var baseContentQueries = baseDef.contentQueries;
                        /** @type {?} */
                        var baseHostBindings = baseDef.hostBindings;
                        baseHostBindings && inheritHostBindings(definition, baseHostBindings);
                        baseViewQuery && inheritViewQuery(definition, baseViewQuery);
                        baseContentQueries && inheritContentQueries(definition, baseContentQueries);
                        fillProperties(definition.inputs, baseDef.inputs);
                        fillProperties(definition.declaredInputs, baseDef.declaredInputs);
                        fillProperties(definition.outputs, baseDef.outputs);
                    }
                    if (superDef) {
                        // Merge hostBindings
                        /** @type {?} */
                        var superHostBindings = superDef.hostBindings;
                        superHostBindings && inheritHostBindings(definition, superHostBindings);
                        // Merge queries
                        /** @type {?} */
                        var superViewQuery = superDef.viewQuery;
                        /** @type {?} */
                        var superContentQueries = superDef.contentQueries;
                        superViewQuery && inheritViewQuery(definition, superViewQuery);
                        superContentQueries && inheritContentQueries(definition, superContentQueries);
                        // Merge inputs and outputs
                        fillProperties(definition.inputs, superDef.inputs);
                        fillProperties(definition.declaredInputs, superDef.declaredInputs);
                        fillProperties(definition.outputs, superDef.outputs);
                        // Inherit hooks
                        // Assume super class inheritance feature has already run.
                        definition.afterContentChecked =
                            definition.afterContentChecked || superDef.afterContentChecked;
                        definition.afterContentInit = definition.afterContentInit || superDef.afterContentInit;
                        definition.afterViewChecked = definition.afterViewChecked || superDef.afterViewChecked;
                        definition.afterViewInit = definition.afterViewInit || superDef.afterViewInit;
                        definition.doCheck = definition.doCheck || superDef.doCheck;
                        definition.onDestroy = definition.onDestroy || superDef.onDestroy;
                        definition.onInit = definition.onInit || superDef.onInit;
                        // Run parent features
                        /** @type {?} */
                        var features = superDef.features;
                        if (features) {
                            for (var _c = 0, features_1 = features; _c < features_1.length; _c++) {
                                var feature = features_1[_c];
                                if (feature && feature.ngInherit) {
                                    (( /** @type {?} */(feature)))(definition);
                                }
                            }
                        }
                    }
                    else {
                        // Even if we don't have a definition, check the type for the hooks and use those if need be
                        /** @type {?} */
                        var superPrototype = superType.prototype;
                        if (superPrototype) {
                            definition.afterContentChecked =
                                definition.afterContentChecked || superPrototype.ngAfterContentChecked;
                            definition.afterContentInit =
                                definition.afterContentInit || superPrototype.ngAfterContentInit;
                            definition.afterViewChecked =
                                definition.afterViewChecked || superPrototype.ngAfterViewChecked;
                            definition.afterViewInit = definition.afterViewInit || superPrototype.ngAfterViewInit;
                            definition.doCheck = definition.doCheck || superPrototype.ngDoCheck;
                            definition.onDestroy = definition.onDestroy || superPrototype.ngOnDestroy;
                            definition.onInit = definition.onInit || superPrototype.ngOnInit;
                            if (superPrototype.ngOnChanges) {
                                ɵɵNgOnChangesFeature()(definition);
                            }
                        }
                    }
                    superType = Object.getPrototypeOf(superType);
                }
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function maybeUnwrapEmpty(value) {
                if (value === EMPTY_OBJ) {
                    return {};
                }
                else if (value === EMPTY_ARRAY) {
                    return [];
                }
                else {
                    return value;
                }
            }
            /**
             * @param {?} definition
             * @param {?} superViewQuery
             * @return {?}
             */
            function inheritViewQuery(definition, superViewQuery) {
                /** @type {?} */
                var prevViewQuery = definition.viewQuery;
                if (prevViewQuery) {
                    definition.viewQuery = ( /**
                     * @param {?} rf
                     * @param {?} ctx
                     * @return {?}
                     */function (rf, ctx) {
                        superViewQuery(rf, ctx);
                        prevViewQuery(rf, ctx);
                    });
                }
                else {
                    definition.viewQuery = superViewQuery;
                }
            }
            /**
             * @param {?} definition
             * @param {?} superContentQueries
             * @return {?}
             */
            function inheritContentQueries(definition, superContentQueries) {
                /** @type {?} */
                var prevContentQueries = definition.contentQueries;
                if (prevContentQueries) {
                    definition.contentQueries = ( /**
                     * @param {?} rf
                     * @param {?} ctx
                     * @param {?} directiveIndex
                     * @return {?}
                     */function (rf, ctx, directiveIndex) {
                        superContentQueries(rf, ctx, directiveIndex);
                        prevContentQueries(rf, ctx, directiveIndex);
                    });
                }
                else {
                    definition.contentQueries = superContentQueries;
                }
            }
            /**
             * @param {?} definition
             * @param {?} superHostBindings
             * @return {?}
             */
            function inheritHostBindings(definition, superHostBindings) {
                /** @type {?} */
                var prevHostBindings = definition.hostBindings;
                // If the subclass does not have a host bindings function, we set the subclass host binding
                // function to be the superclass's (in this feature). We should check if they're the same here
                // to ensure we don't inherit it twice.
                if (superHostBindings !== prevHostBindings) {
                    if (prevHostBindings) {
                        // because inheritance is unknown during compile time, the runtime code
                        // needs to be informed of the super-class depth so that instruction code
                        // can distinguish one host bindings function from another. The reason why
                        // relying on the directive uniqueId exclusively is not enough is because the
                        // uniqueId value and the directive instance stay the same between hostBindings
                        // calls throughout the directive inheritance chain. This means that without
                        // a super-class depth value, there is no way to know whether a parent or
                        // sub-class host bindings function is currently being executed.
                        definition.hostBindings = ( /**
                         * @param {?} rf
                         * @param {?} ctx
                         * @param {?} elementIndex
                         * @return {?}
                         */function (rf, ctx, elementIndex) {
                            // The reason why we increment first and then decrement is so that parent
                            // hostBindings calls have a higher id value compared to sub-class hostBindings
                            // calls (this way the leaf directive is always at a super-class depth of 0).
                            adjustActiveDirectiveSuperClassDepthPosition(1);
                            try {
                                superHostBindings(rf, ctx, elementIndex);
                            }
                            finally {
                                adjustActiveDirectiveSuperClassDepthPosition(-1);
                            }
                            prevHostBindings(rf, ctx, elementIndex);
                        });
                    }
                    else {
                        definition.hostBindings = superHostBindings;
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Resolves the providers which are defined in the DirectiveDef.
             *
             * When inserting the tokens and the factories in their respective arrays, we can assume that
             * this method is called first for the component (if any), and then for other directives on the same
             * node.
             * As a consequence,the providers are always processed in that order:
             * 1) The view providers of the component
             * 2) The providers of the component
             * 3) The providers of the other directives
             * This matches the structure of the injectables arrays of a view (for each node).
             * So the tokens and the factories can be pushed at the end of the arrays, except
             * in one case for multi providers.
             *
             * @template T
             * @param {?} def the directive definition
             * @param {?} providers
             * @param {?} viewProviders
             * @return {?}
             */
            function providersResolver(def, providers, viewProviders) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var tView = lView[TVIEW];
                if (tView.firstTemplatePass) {
                    /** @type {?} */
                    var isComponent_2 = isComponentDef(def);
                    // The list of view providers is processed first, and the flags are updated
                    resolveProvider$1(viewProviders, tView.data, tView.blueprint, isComponent_2, true);
                    // Then, the list of providers is processed, and the flags are updated
                    resolveProvider$1(providers, tView.data, tView.blueprint, isComponent_2, false);
                }
            }
            /**
             * Resolves a provider and publishes it to the DI system.
             * @param {?} provider
             * @param {?} tInjectables
             * @param {?} lInjectablesBlueprint
             * @param {?} isComponent
             * @param {?} isViewProvider
             * @return {?}
             */
            function resolveProvider$1(provider, tInjectables, lInjectablesBlueprint, isComponent, isViewProvider) {
                provider = resolveForwardRef(provider);
                if (Array.isArray(provider)) {
                    // Recursively call `resolveProvider`
                    // Recursion is OK in this case because this code will not be in hot-path once we implement
                    // cloning of the initial state.
                    for (var i = 0; i < provider.length; i++) {
                        resolveProvider$1(provider[i], tInjectables, lInjectablesBlueprint, isComponent, isViewProvider);
                    }
                }
                else {
                    /** @type {?} */
                    var lView_6 = getLView();
                    /** @type {?} */
                    var tView = lView_6[TVIEW];
                    /** @type {?} */
                    var token = isTypeProvider(provider) ? provider : resolveForwardRef(provider.provide);
                    /** @type {?} */
                    var providerFactory = providerToFactory(provider);
                    /** @type {?} */
                    var tNode = getPreviousOrParentTNode();
                    /** @type {?} */
                    var beginIndex = tNode.providerIndexes & 65535 /* ProvidersStartIndexMask */;
                    /** @type {?} */
                    var endIndex = tNode.directiveStart;
                    /** @type {?} */
                    var cptViewProvidersCount = tNode.providerIndexes >> 16 /* CptViewProvidersCountShift */;
                    if (isClassProvider(provider) || isTypeProvider(provider)) {
                        /** @type {?} */
                        var prototype = ((( /** @type {?} */(provider))).useClass || provider).prototype;
                        /** @type {?} */
                        var ngOnDestroy = prototype.ngOnDestroy;
                        if (ngOnDestroy) {
                            (tView.destroyHooks || (tView.destroyHooks = [])).push(tInjectables.length, ngOnDestroy);
                        }
                    }
                    if (isTypeProvider(provider) || !provider.multi) {
                        // Single provider case: the factory is created and pushed immediately
                        /** @type {?} */
                        var factory = new NodeInjectorFactory(providerFactory, isViewProvider, ɵɵdirectiveInject);
                        /** @type {?} */
                        var existingFactoryIndex = indexOf(token, tInjectables, isViewProvider ? beginIndex : beginIndex + cptViewProvidersCount, endIndex);
                        if (existingFactoryIndex == -1) {
                            diPublicInInjector(getOrCreateNodeInjectorForNode(( /** @type {?} */(tNode)), lView_6), tView, token);
                            tInjectables.push(token);
                            tNode.directiveStart++;
                            tNode.directiveEnd++;
                            if (isViewProvider) {
                                tNode.providerIndexes += 65536 /* CptViewProvidersCountShifter */;
                            }
                            lInjectablesBlueprint.push(factory);
                            lView_6.push(factory);
                        }
                        else {
                            lInjectablesBlueprint[existingFactoryIndex] = factory;
                            lView_6[existingFactoryIndex] = factory;
                        }
                    }
                    else {
                        // Multi provider case:
                        // We create a multi factory which is going to aggregate all the values.
                        // Since the output of such a factory depends on content or view injection,
                        // we create two of them, which are linked together.
                        //
                        // The first one (for view providers) is always in the first block of the injectables array,
                        // and the second one (for providers) is always in the second block.
                        // This is important because view providers have higher priority. When a multi token
                        // is being looked up, the view providers should be found first.
                        // Note that it is not possible to have a multi factory in the third block (directive block).
                        //
                        // The algorithm to process multi providers is as follows:
                        // 1) If the multi provider comes from the `viewProviders` of the component:
                        //   a) If the special view providers factory doesn't exist, it is created and pushed.
                        //   b) Else, the multi provider is added to the existing multi factory.
                        // 2) If the multi provider comes from the `providers` of the component or of another
                        // directive:
                        //   a) If the multi factory doesn't exist, it is created and provider pushed into it.
                        //      It is also linked to the multi factory for view providers, if it exists.
                        //   b) Else, the multi provider is added to the existing multi factory.
                        /** @type {?} */
                        var existingProvidersFactoryIndex = indexOf(token, tInjectables, beginIndex + cptViewProvidersCount, endIndex);
                        /** @type {?} */
                        var existingViewProvidersFactoryIndex = indexOf(token, tInjectables, beginIndex, beginIndex + cptViewProvidersCount);
                        /** @type {?} */
                        var doesProvidersFactoryExist = existingProvidersFactoryIndex >= 0 &&
                            lInjectablesBlueprint[existingProvidersFactoryIndex];
                        /** @type {?} */
                        var doesViewProvidersFactoryExist = existingViewProvidersFactoryIndex >= 0 &&
                            lInjectablesBlueprint[existingViewProvidersFactoryIndex];
                        if (isViewProvider && !doesViewProvidersFactoryExist ||
                            !isViewProvider && !doesProvidersFactoryExist) {
                            // Cases 1.a and 2.a
                            diPublicInInjector(getOrCreateNodeInjectorForNode(( /** @type {?} */(tNode)), lView_6), tView, token);
                            /** @type {?} */
                            var factory = multiFactory(isViewProvider ? multiViewProvidersFactoryResolver : multiProvidersFactoryResolver, lInjectablesBlueprint.length, isViewProvider, isComponent, providerFactory);
                            if (!isViewProvider && doesViewProvidersFactoryExist) {
                                lInjectablesBlueprint[existingViewProvidersFactoryIndex].providerFactory = factory;
                            }
                            tInjectables.push(token);
                            tNode.directiveStart++;
                            tNode.directiveEnd++;
                            if (isViewProvider) {
                                tNode.providerIndexes += 65536 /* CptViewProvidersCountShifter */;
                            }
                            lInjectablesBlueprint.push(factory);
                            lView_6.push(factory);
                        }
                        else {
                            // Cases 1.b and 2.b
                            multiFactoryAdd(( /** @type {?} */(lInjectablesBlueprint))[isViewProvider ? existingViewProvidersFactoryIndex : existingProvidersFactoryIndex], providerFactory, !isViewProvider && isComponent);
                        }
                        if (!isViewProvider && isComponent && doesViewProvidersFactoryExist) {
                            ( /** @type {?} */(lInjectablesBlueprint[existingViewProvidersFactoryIndex].componentProviders))++;
                        }
                    }
                }
            }
            /**
             * Add a factory in a multi factory.
             * @param {?} multiFactory
             * @param {?} factory
             * @param {?} isComponentProvider
             * @return {?}
             */
            function multiFactoryAdd(multiFactory, factory, isComponentProvider) {
                ( /** @type {?} */(multiFactory.multi)).push(factory);
                if (isComponentProvider) {
                    ( /** @type {?} */(multiFactory.componentProviders))++;
                }
            }
            /**
             * Returns the index of item in the array, but only in the begin to end range.
             * @param {?} item
             * @param {?} arr
             * @param {?} begin
             * @param {?} end
             * @return {?}
             */
            function indexOf(item, arr, begin, end) {
                for (var i = begin; i < end; i++) {
                    if (arr[i] === item)
                        return i;
                }
                return -1;
            }
            /**
             * Use this with `multi` `providers`.
             * @this {?}
             * @param {?} _
             * @param {?} tData
             * @param {?} lData
             * @param {?} tNode
             * @return {?}
             */
            function multiProvidersFactoryResolver(_, tData, lData, tNode) {
                return multiResolve(( /** @type {?} */(this.multi)), []);
            }
            /**
             * Use this with `multi` `viewProviders`.
             *
             * This factory knows how to concatenate itself with the existing `multi` `providers`.
             * @this {?}
             * @param {?} _
             * @param {?} tData
             * @param {?} lData
             * @param {?} tNode
             * @return {?}
             */
            function multiViewProvidersFactoryResolver(_, tData, lData, tNode) {
                /** @type {?} */
                var factories = ( /** @type {?} */(this.multi));
                /** @type {?} */
                var result;
                if (this.providerFactory) {
                    /** @type {?} */
                    var componentCount = ( /** @type {?} */(this.providerFactory.componentProviders));
                    /** @type {?} */
                    var multiProviders = getNodeInjectable(tData, lData, ( /** @type {?} */(( /** @type {?} */(this.providerFactory)).index)), tNode);
                    // Copy the section of the array which contains `multi` `providers` from the component
                    result = multiProviders.slice(0, componentCount);
                    // Insert the `viewProvider` instances.
                    multiResolve(factories, result);
                    // Copy the section of the array which contains `multi` `providers` from other directives
                    for (var i = componentCount; i < multiProviders.length; i++) {
                        result.push(multiProviders[i]);
                    }
                }
                else {
                    result = [];
                    // Insert the `viewProvider` instances.
                    multiResolve(factories, result);
                }
                return result;
            }
            /**
             * Maps an array of factories into an array of values.
             * @param {?} factories
             * @param {?} result
             * @return {?}
             */
            function multiResolve(factories, result) {
                for (var i = 0; i < factories.length; i++) {
                    /** @type {?} */
                    var factory = ( /** @type {?} */(( /** @type {?} */(factories[i]))));
                    result.push(factory());
                }
                return result;
            }
            /**
             * Creates a multi factory.
             * @param {?} factoryFn
             * @param {?} index
             * @param {?} isViewProvider
             * @param {?} isComponent
             * @param {?} f
             * @return {?}
             */
            function multiFactory(factoryFn, index, isViewProvider, isComponent, f) {
                /** @type {?} */
                var factory = new NodeInjectorFactory(factoryFn, isViewProvider, ɵɵdirectiveInject);
                factory.multi = [];
                factory.index = index;
                factory.componentProviders = 0;
                multiFactoryAdd(factory, f, isComponent && !isViewProvider);
                return factory;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This feature resolves the providers of a directive (or component),
             * and publish them into the DI system, making it visible to others for injection.
             *
             * For example:
             * ```ts
             * class ComponentWithProviders {
             *   constructor(private greeter: GreeterDE) {}
             *
             *   static ngComponentDef = defineComponent({
             *     type: ComponentWithProviders,
             *     selectors: [['component-with-providers']],
             *    factory: () => new ComponentWithProviders(directiveInject(GreeterDE as any)),
             *    consts: 1,
             *    vars: 1,
             *    template: function(fs: RenderFlags, ctx: ComponentWithProviders) {
             *      if (fs & RenderFlags.Create) {
             *        ɵɵtext(0);
             *      }
             *      if (fs & RenderFlags.Update) {
             *        ɵɵselect(0);
             *        ɵɵtextBinding(ctx.greeter.greet());
             *      }
             *    },
             *    features: [ProvidersFeature([GreeterDE])]
             *  });
             * }
             * ```
             *
             * \@codeGenApi
             * @template T
             * @param {?} providers
             * @param {?=} viewProviders
             * @return {?}
             */
            function ɵɵProvidersFeature(providers, viewProviders) {
                if (viewProviders === void 0) { viewProviders = []; }
                return ( /**
                 * @param {?} definition
                 * @return {?}
                 */function (definition) {
                    definition.providersResolver =
                        ( /**
                         * @param {?} def
                         * @param {?=} processProvidersFn
                         * @return {?}
                         */function (def, processProvidersFn) {
                            return providersResolver(def, //
                            processProvidersFn ? processProvidersFn(providers) : providers, //
                            viewProviders);
                        });
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Represents a component created by a `ComponentFactory`.
             * Provides access to the component instance and related objects,
             * and provides the means of destroying the instance.
             *
             * \@publicApi
             * @abstract
             * @template C
             */
            var ComponentRef = /** @class */ (function () {
                function ComponentRef() {
                }
                return ComponentRef;
            }());
            if (false) { }
            /**
             * Base class for a factory that can create a component dynamically.
             * Instantiate a factory for a given type of component with `resolveComponentFactory()`.
             * Use the resulting `ComponentFactory.create()` method to create a component of that type.
             *
             * @see [Dynamic Components](guide/dynamic-component-loader)
             *
             * \@publicApi
             * @abstract
             * @template C
             */
            var ComponentFactory = /** @class */ (function () {
                function ComponentFactory() {
                }
                return ComponentFactory;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} component
             * @return {?}
             */
            function noComponentFactoryError(component) {
                /** @type {?} */
                var error = Error("No component factory found for " + stringify(component) + ". Did you add it to @NgModule.entryComponents?");
                (( /** @type {?} */(error)))[ERROR_COMPONENT] = component;
                return error;
            }
            /** @type {?} */
            var ERROR_COMPONENT = 'ngComponent';
            /**
             * @param {?} error
             * @return {?}
             */
            function getComponent$1(error) {
                return (( /** @type {?} */(error)))[ERROR_COMPONENT];
            }
            var _NullComponentFactoryResolver = /** @class */ (function () {
                function _NullComponentFactoryResolver() {
                }
                /**
                 * @template T
                 * @param {?} component
                 * @return {?}
                 */
                _NullComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
                    throw noComponentFactoryError(component);
                };
                return _NullComponentFactoryResolver;
            }());
            /**
             * A simple registry that maps `Components` to generated `ComponentFactory` classes
             * that can be used to create instances of components.
             * Use to obtain the factory for a given component type,
             * then use the factory's `create()` method to create a component of that type.
             *
             * @see [Dynamic Components](guide/dynamic-component-loader)
             * \@publicApi
             * @abstract
             */
            var ComponentFactoryResolver = /** @class */ (function () {
                function ComponentFactoryResolver() {
                }
                return ComponentFactoryResolver;
            }());
            ComponentFactoryResolver.NULL = new _NullComponentFactoryResolver();
            if (false) { }
            var CodegenComponentFactoryResolver = /** @class */ (function () {
                /**
                 * @param {?} factories
                 * @param {?} _parent
                 * @param {?} _ngModule
                 */
                function CodegenComponentFactoryResolver(factories, _parent, _ngModule) {
                    this._parent = _parent;
                    this._ngModule = _ngModule;
                    this._factories = new Map();
                    for (var i = 0; i < factories.length; i++) {
                        /** @type {?} */
                        var factory = factories[i];
                        this._factories.set(factory.componentType, factory);
                    }
                }
                /**
                 * @template T
                 * @param {?} component
                 * @return {?}
                 */
                CodegenComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
                    /** @type {?} */
                    var factory = this._factories.get(component);
                    if (!factory && this._parent) {
                        factory = this._parent.resolveComponentFactory(component);
                    }
                    if (!factory) {
                        throw noComponentFactoryError(component);
                    }
                    return new ComponentFactoryBoundToModule(factory, this._ngModule);
                };
                return CodegenComponentFactoryResolver;
            }());
            if (false) { }
            /**
             * @template C
             */
            var ComponentFactoryBoundToModule = /** @class */ (function (_super_1) {
                __extends(ComponentFactoryBoundToModule, _super_1);
                /**
                 * @param {?} factory
                 * @param {?} ngModule
                 */
                function ComponentFactoryBoundToModule(factory, ngModule) {
                    var _this = _super_1.call(this) || this;
                    _this.factory = factory;
                    _this.ngModule = ngModule;
                    _this.selector = factory.selector;
                    _this.componentType = factory.componentType;
                    _this.ngContentSelectors = factory.ngContentSelectors;
                    _this.inputs = factory.inputs;
                    _this.outputs = factory.outputs;
                    return _this;
                }
                /**
                 * @param {?} injector
                 * @param {?=} projectableNodes
                 * @param {?=} rootSelectorOrNode
                 * @param {?=} ngModule
                 * @return {?}
                 */
                ComponentFactoryBoundToModule.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
                    return this.factory.create(injector, projectableNodes, rootSelectorOrNode, ngModule || this.ngModule);
                };
                return ComponentFactoryBoundToModule;
            }(ComponentFactory));
            if (false) { }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function noop() {
                var args = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    args[_c] = arguments[_c];
                }
                // Do nothing.
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A wrapper around a native element inside of a View.
             *
             * An `ElementRef` is backed by a render-specific element. In the browser, this is usually a DOM
             * element.
             *
             * \@security Permitting direct access to the DOM can make your application more vulnerable to
             * XSS attacks. Carefully review any use of `ElementRef` in your code. For more detail, see the
             * [Security Guide](http://g.co/ng/security).
             *
             * \@publicApi
             * @template T
             */
            // Note: We don't expose things like `Injector`, `ViewContainer`, ... here,
            // i.e. users have to ask for what they need. With that, we can build better analysis tools
            // and could do better codegen in the future.
            var ElementRef = /** @class */ (function () {
                /**
                 * @param {?} nativeElement
                 */
                function ElementRef(nativeElement) {
                    this.nativeElement = nativeElement;
                }
                return ElementRef;
            }());
            /**
             * \@internal
             * @nocollapse
             */
            ElementRef.__NG_ELEMENT_ID__ = ( /**
             * @return {?}
             */function () { return SWITCH_ELEMENT_REF_FACTORY(ElementRef); });
            if (false) { }
            /** @type {?} */
            var SWITCH_ELEMENT_REF_FACTORY__POST_R3__ = injectElementRef;
            /** @type {?} */
            var SWITCH_ELEMENT_REF_FACTORY__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_ELEMENT_REF_FACTORY = SWITCH_ELEMENT_REF_FACTORY__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @deprecated Use `RendererType2` (and `Renderer2`) instead.
             * \@publicApi
             */
            var RenderComponentType = /** @class */ (function () {
                /**
                 * @param {?} id
                 * @param {?} templateUrl
                 * @param {?} slotCount
                 * @param {?} encapsulation
                 * @param {?} styles
                 * @param {?} animations
                 */
                function RenderComponentType(id, templateUrl, slotCount, encapsulation, styles, animations) {
                    this.id = id;
                    this.templateUrl = templateUrl;
                    this.slotCount = slotCount;
                    this.encapsulation = encapsulation;
                    this.styles = styles;
                    this.animations = animations;
                }
                return RenderComponentType;
            }());
            if (false) { }
            /**
             * @deprecated Debug info is handled internally in the view engine now.
             * @abstract
             */
            var RenderDebugInfo = /** @class */ (function () {
                function RenderDebugInfo() {
                }
                return RenderDebugInfo;
            }());
            if (false) { }
            /**
             * @deprecated Use the `Renderer2` instead.
             * @record
             */
            function DirectRenderer() { }
            if (false) { }
            /**
             * @deprecated Use the `Renderer2` instead.
             * \@publicApi
             * @abstract
             */
            var Renderer = /** @class */ (function () {
                function Renderer() {
                }
                return Renderer;
            }());
            if (false) { }
            /** @type {?} */
            var Renderer2Interceptor = new InjectionToken('Renderer2Interceptor');
            /**
             * Injectable service that provides a low-level interface for modifying the UI.
             *
             * Use this service to bypass Angular's templating and make custom UI changes that can't be
             * expressed declaratively. For example if you need to set a property or an attribute whose name is
             * not statically known, use {\@link Renderer#setElementProperty setElementProperty} or
             * {\@link Renderer#setElementAttribute setElementAttribute} respectively.
             *
             * If you are implementing a custom renderer, you must implement this interface.
             *
             * The default Renderer implementation is `DomRenderer`. Also available is `WebWorkerRenderer`.
             *
             * @deprecated Use `RendererFactory2` instead.
             * \@publicApi
             * @abstract
             */
            var RootRenderer = /** @class */ (function () {
                function RootRenderer() {
                }
                return RootRenderer;
            }());
            if (false) { }
            /**
             * Used by `RendererFactory2` to associate custom rendering data and styles
             * with a rendering implementation.
             * \@publicApi
             * @record
             */
            function RendererType2() { }
            if (false) { }
            /**
             * Creates and initializes a custom renderer that implements the `Renderer2` base class.
             *
             * \@publicApi
             * @abstract
             */
            var RendererFactory2 = /** @class */ (function () {
                function RendererFactory2() {
                }
                return RendererFactory2;
            }());
            if (false) { }
            /** @enum {number} */
            var RendererStyleFlags2 = {
                /**
                 * Marks a style as important.
                 */
                Important: 1,
                /**
                 * Marks a style as using dash case naming (this-is-dash-case).
                 */
                DashCase: 2,
            };
            RendererStyleFlags2[RendererStyleFlags2.Important] = 'Important';
            RendererStyleFlags2[RendererStyleFlags2.DashCase] = 'DashCase';
            /**
             * Extend this base class to implement custom rendering. By default, Angular
             * renders a template into DOM. You can use custom rendering to intercept
             * rendering calls, or to render to something other than DOM.
             *
             * Create your custom renderer using `RendererFactory2`.
             *
             * Use a custom renderer to bypass Angular's templating and
             * make custom UI changes that can't be expressed declaratively.
             * For example if you need to set a property or an attribute whose name is
             * not statically known, use the `setProperty()` or
             * `setAttribute()` method.
             *
             * \@publicApi
             * @abstract
             */
            var Renderer2 = /** @class */ (function () {
                function Renderer2() {
                }
                return Renderer2;
            }());
            /**
             * \@internal
             * @nocollapse
             */
            Renderer2.__NG_ELEMENT_ID__ = ( /**
             * @return {?}
             */function () { return SWITCH_RENDERER2_FACTORY(); });
            if (false) { }
            /** @type {?} */
            var SWITCH_RENDERER2_FACTORY__POST_R3__ = injectRenderer2;
            /** @type {?} */
            var SWITCH_RENDERER2_FACTORY__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_RENDERER2_FACTORY = SWITCH_RENDERER2_FACTORY__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * \@description Represents the version of Angular
             *
             * \@publicApi
             */
            var Version = /** @class */ (function () {
                /**
                 * @param {?} full
                 */
                function Version(full) {
                    this.full = full;
                    this.major = full.split('.')[0];
                    this.minor = full.split('.')[1];
                    this.patch = full.split('.').slice(2).join('.');
                }
                return Version;
            }());
            if (false) { }
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new Version('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var DefaultIterableDifferFactory = /** @class */ (function () {
                function DefaultIterableDifferFactory() {
                }
                /**
                 * @param {?} obj
                 * @return {?}
                 */
                DefaultIterableDifferFactory.prototype.supports = function (obj) { return isListLikeIterable$1(obj); };
                /**
                 * @template V
                 * @param {?=} trackByFn
                 * @return {?}
                 */
                DefaultIterableDifferFactory.prototype.create = function (trackByFn) {
                    return new DefaultIterableDiffer(trackByFn);
                };
                return DefaultIterableDifferFactory;
            }());
            /** @type {?} */
            var trackByIdentity = ( /**
             * @param {?} index
             * @param {?} item
             * @return {?}
             */function (index, item) { return item; });
            var ɵ0$d = trackByIdentity;
            /**
             * @deprecated v4.0.0 - Should not be part of public API.
             * \@publicApi
             * @template V
             */
            var DefaultIterableDiffer = /** @class */ (function () {
                /**
                 * @param {?=} trackByFn
                 */
                function DefaultIterableDiffer(trackByFn) {
                    this.length = 0;
                    // Keeps track of the used records at any point in time (during & across `_check()` calls)
                    this._linkedRecords = null;
                    // Keeps track of the removed records at any point in time during `_check()` calls.
                    this._unlinkedRecords = null;
                    this._previousItHead = null;
                    this._itHead = null;
                    this._itTail = null;
                    this._additionsHead = null;
                    this._additionsTail = null;
                    this._movesHead = null;
                    this._movesTail = null;
                    this._removalsHead = null;
                    this._removalsTail = null;
                    // Keeps track of records where custom track by is the same, but item identity has changed
                    this._identityChangesHead = null;
                    this._identityChangesTail = null;
                    this._trackByFn = trackByFn || trackByIdentity;
                }
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._itHead; record !== null; record = record._next) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachOperation = function (fn) {
                    /** @type {?} */
                    var nextIt = this._itHead;
                    /** @type {?} */
                    var nextRemove = this._removalsHead;
                    /** @type {?} */
                    var addRemoveOffset = 0;
                    /** @type {?} */
                    var moveOffsets = null;
                    while (nextIt || nextRemove) {
                        // Figure out which is the next record to process
                        // Order: remove, add, move
                        /** @type {?} */
                        var record = !nextRemove ||
                            nextIt &&
                                ( /** @type {?} */(nextIt.currentIndex)) <
                                    getPreviousIndex(nextRemove, addRemoveOffset, moveOffsets) ?
                            ( /** @type {?} */(nextIt)) :
                            nextRemove;
                        /** @type {?} */
                        var adjPreviousIndex = getPreviousIndex(record, addRemoveOffset, moveOffsets);
                        /** @type {?} */
                        var currentIndex = record.currentIndex;
                        // consume the item, and adjust the addRemoveOffset and update moveDistance if necessary
                        if (record === nextRemove) {
                            addRemoveOffset--;
                            nextRemove = nextRemove._nextRemoved;
                        }
                        else {
                            nextIt = ( /** @type {?} */(nextIt))._next;
                            if (record.previousIndex == null) {
                                addRemoveOffset++;
                            }
                            else {
                                // INVARIANT:  currentIndex < previousIndex
                                if (!moveOffsets)
                                    moveOffsets = [];
                                /** @type {?} */
                                var localMovePreviousIndex = adjPreviousIndex - addRemoveOffset;
                                /** @type {?} */
                                var localCurrentIndex = ( /** @type {?} */(currentIndex)) - addRemoveOffset;
                                if (localMovePreviousIndex != localCurrentIndex) {
                                    for (var i = 0; i < localMovePreviousIndex; i++) {
                                        /** @type {?} */
                                        var offset = i < moveOffsets.length ? moveOffsets[i] : (moveOffsets[i] = 0);
                                        /** @type {?} */
                                        var index = offset + i;
                                        if (localCurrentIndex <= index && index < localMovePreviousIndex) {
                                            moveOffsets[i] = offset + 1;
                                        }
                                    }
                                    /** @type {?} */
                                    var previousIndex = record.previousIndex;
                                    moveOffsets[previousIndex] = localCurrentIndex - localMovePreviousIndex;
                                }
                            }
                        }
                        if (adjPreviousIndex !== currentIndex) {
                            fn(record, adjPreviousIndex, currentIndex);
                        }
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachPreviousItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._previousItHead; record !== null; record = record._nextPrevious) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachAddedItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachMovedItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._movesHead; record !== null; record = record._nextMoved) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachRemovedItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.forEachIdentityChange = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._identityChangesHead; record !== null; record = record._nextIdentityChange) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} collection
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.diff = function (collection) {
                    if (collection == null)
                        collection = [];
                    if (!isListLikeIterable$1(collection)) {
                        throw new Error("Error trying to diff '" + stringify(collection) + "'. Only arrays and iterables are allowed");
                    }
                    if (this.check(collection)) {
                        return this;
                    }
                    else {
                        return null;
                    }
                };
                /**
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.onDestroy = function () { };
                /**
                 * @param {?} collection
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype.check = function (collection) {
                    var _this = this;
                    this._reset();
                    /** @type {?} */
                    var record = this._itHead;
                    /** @type {?} */
                    var mayBeDirty = false;
                    /** @type {?} */
                    var index;
                    /** @type {?} */
                    var item;
                    /** @type {?} */
                    var itemTrackBy;
                    if (Array.isArray(collection)) {
                        (( /** @type {?} */(this))).length = collection.length;
                        for (var index_2 = 0; index_2 < this.length; index_2++) {
                            item = collection[index_2];
                            itemTrackBy = this._trackByFn(index_2, item);
                            if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
                                record = this._mismatch(record, item, itemTrackBy, index_2);
                                mayBeDirty = true;
                            }
                            else {
                                if (mayBeDirty) {
                                    // TODO(misko): can we limit this to duplicates only?
                                    record = this._verifyReinsertion(record, item, itemTrackBy, index_2);
                                }
                                if (!looseIdentical(record.item, item))
                                    this._addIdentityChange(record, item);
                            }
                            record = record._next;
                        }
                    }
                    else {
                        index = 0;
                        iterateListLike$1(collection, ( /**
                         * @param {?} item
                         * @return {?}
                         */function (item) {
                            itemTrackBy = _this._trackByFn(index, item);
                            if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
                                record = _this._mismatch(record, item, itemTrackBy, index);
                                mayBeDirty = true;
                            }
                            else {
                                if (mayBeDirty) {
                                    // TODO(misko): can we limit this to duplicates only?
                                    record = _this._verifyReinsertion(record, item, itemTrackBy, index);
                                }
                                if (!looseIdentical(record.item, item))
                                    _this._addIdentityChange(record, item);
                            }
                            record = record._next;
                            index++;
                        }));
                        (( /** @type {?} */(this))).length = index;
                    }
                    this._truncate(record);
                    (( /** @type {?} */(this))).collection = collection;
                    return this.isDirty;
                };
                Object.defineProperty(DefaultIterableDiffer.prototype, "isDirty", {
                    /* CollectionChanges is considered dirty if it has any additions, moves, removals, or identity
                       * changes.
                       */
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._additionsHead !== null || this._movesHead !== null ||
                            this._removalsHead !== null || this._identityChangesHead !== null;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Reset the state of the change objects to show no changes. This means set previousKey to
                 * currentKey, and clear all of the queues (additions, moves, removals).
                 * Set the previousIndexes of moved and added items to their currentIndexes
                 * Reset the list of additions, moves and removals
                 *
                 * \@internal
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._reset = function () {
                    if (this.isDirty) {
                        /** @type {?} */
                        var record = void 0;
                        /** @type {?} */
                        var nextRecord = void 0;
                        for (record = this._previousItHead = this._itHead; record !== null; record = record._next) {
                            record._nextPrevious = record._next;
                        }
                        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                            record.previousIndex = record.currentIndex;
                        }
                        this._additionsHead = this._additionsTail = null;
                        for (record = this._movesHead; record !== null; record = nextRecord) {
                            record.previousIndex = record.currentIndex;
                            nextRecord = record._nextMoved;
                        }
                        this._movesHead = this._movesTail = null;
                        this._removalsHead = this._removalsTail = null;
                        this._identityChangesHead = this._identityChangesTail = null;
                        // TODO(vicb): when assert gets supported
                        // assert(!this.isDirty);
                    }
                };
                /**
                 * This is the core function which handles differences between collections.
                 *
                 * - `record` is the record which we saw at this position last time. If null then it is a new
                 *   item.
                 * - `item` is the current item in the collection
                 * - `index` is the position of the item in the collection
                 *
                 * \@internal
                 * @param {?} record
                 * @param {?} item
                 * @param {?} itemTrackBy
                 * @param {?} index
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._mismatch = function (record, item, itemTrackBy, index) {
                    // The previous record after which we will append the current one.
                    /** @type {?} */
                    var previousRecord;
                    if (record === null) {
                        previousRecord = this._itTail;
                    }
                    else {
                        previousRecord = record._prev;
                        // Remove the record from the collection since we know it does not match the item.
                        this._remove(record);
                    }
                    // Attempt to see if we have seen the item before.
                    record = this._linkedRecords === null ? null : this._linkedRecords.get(itemTrackBy, index);
                    if (record !== null) {
                        // We have seen this before, we need to move it forward in the collection.
                        // But first we need to check if identity changed, so we can update in view if necessary
                        if (!looseIdentical(record.item, item))
                            this._addIdentityChange(record, item);
                        this._moveAfter(record, previousRecord, index);
                    }
                    else {
                        // Never seen it, check evicted list.
                        record = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
                        if (record !== null) {
                            // It is an item which we have evicted earlier: reinsert it back into the list.
                            // But first we need to check if identity changed, so we can update in view if necessary
                            if (!looseIdentical(record.item, item))
                                this._addIdentityChange(record, item);
                            this._reinsertAfter(record, previousRecord, index);
                        }
                        else {
                            // It is a new item: add it.
                            record =
                                this._addAfter(new IterableChangeRecord_(item, itemTrackBy), previousRecord, index);
                        }
                    }
                    return record;
                };
                /**
                 * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
                 *
                 * Use case: `[a, a]` => `[b, a, a]`
                 *
                 * If we did not have this check then the insertion of `b` would:
                 *   1) evict first `a`
                 *   2) insert `b` at `0` index.
                 *   3) leave `a` at index `1` as is. <-- this is wrong!
                 *   3) reinsert `a` at index 2. <-- this is wrong!
                 *
                 * The correct behavior is:
                 *   1) evict first `a`
                 *   2) insert `b` at `0` index.
                 *   3) reinsert `a` at index 1.
                 *   3) move `a` at from `1` to `2`.
                 *
                 *
                 * Double check that we have not evicted a duplicate item. We need to check if the item type may
                 * have already been removed:
                 * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
                 * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
                 * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
                 * at the end.
                 *
                 * \@internal
                 * @param {?} record
                 * @param {?} item
                 * @param {?} itemTrackBy
                 * @param {?} index
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._verifyReinsertion = function (record, item, itemTrackBy, index) {
                    /** @type {?} */
                    var reinsertRecord = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
                    if (reinsertRecord !== null) {
                        record = this._reinsertAfter(reinsertRecord, ( /** @type {?} */(record._prev)), index);
                    }
                    else if (record.currentIndex != index) {
                        record.currentIndex = index;
                        this._addToMoves(record, index);
                    }
                    return record;
                };
                /**
                 * Get rid of any excess {\@link IterableChangeRecord_}s from the previous collection
                 *
                 * - `record` The first excess {\@link IterableChangeRecord_}.
                 *
                 * \@internal
                 * @param {?} record
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._truncate = function (record) {
                    // Anything after that needs to be removed;
                    while (record !== null) {
                        /** @type {?} */
                        var nextRecord = record._next;
                        this._addToRemovals(this._unlink(record));
                        record = nextRecord;
                    }
                    if (this._unlinkedRecords !== null) {
                        this._unlinkedRecords.clear();
                    }
                    if (this._additionsTail !== null) {
                        this._additionsTail._nextAdded = null;
                    }
                    if (this._movesTail !== null) {
                        this._movesTail._nextMoved = null;
                    }
                    if (this._itTail !== null) {
                        this._itTail._next = null;
                    }
                    if (this._removalsTail !== null) {
                        this._removalsTail._nextRemoved = null;
                    }
                    if (this._identityChangesTail !== null) {
                        this._identityChangesTail._nextIdentityChange = null;
                    }
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @param {?} prevRecord
                 * @param {?} index
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._reinsertAfter = function (record, prevRecord, index) {
                    if (this._unlinkedRecords !== null) {
                        this._unlinkedRecords.remove(record);
                    }
                    /** @type {?} */
                    var prev = record._prevRemoved;
                    /** @type {?} */
                    var next = record._nextRemoved;
                    if (prev === null) {
                        this._removalsHead = next;
                    }
                    else {
                        prev._nextRemoved = next;
                    }
                    if (next === null) {
                        this._removalsTail = prev;
                    }
                    else {
                        next._prevRemoved = prev;
                    }
                    this._insertAfter(record, prevRecord, index);
                    this._addToMoves(record, index);
                    return record;
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @param {?} prevRecord
                 * @param {?} index
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._moveAfter = function (record, prevRecord, index) {
                    this._unlink(record);
                    this._insertAfter(record, prevRecord, index);
                    this._addToMoves(record, index);
                    return record;
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @param {?} prevRecord
                 * @param {?} index
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._addAfter = function (record, prevRecord, index) {
                    this._insertAfter(record, prevRecord, index);
                    if (this._additionsTail === null) {
                        // TODO(vicb):
                        // assert(this._additionsHead === null);
                        this._additionsTail = this._additionsHead = record;
                    }
                    else {
                        // TODO(vicb):
                        // assert(_additionsTail._nextAdded === null);
                        // assert(record._nextAdded === null);
                        this._additionsTail = this._additionsTail._nextAdded = record;
                    }
                    return record;
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @param {?} prevRecord
                 * @param {?} index
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._insertAfter = function (record, prevRecord, index) {
                    // TODO(vicb):
                    // assert(record != prevRecord);
                    // assert(record._next === null);
                    // assert(record._prev === null);
                    // TODO(vicb):
                    // assert(record != prevRecord);
                    // assert(record._next === null);
                    // assert(record._prev === null);
                    /** @type {?} */
                    var next = prevRecord === null ? this._itHead : prevRecord._next;
                    // TODO(vicb):
                    // assert(next != record);
                    // assert(prevRecord != record);
                    record._next = next;
                    record._prev = prevRecord;
                    if (next === null) {
                        this._itTail = record;
                    }
                    else {
                        next._prev = record;
                    }
                    if (prevRecord === null) {
                        this._itHead = record;
                    }
                    else {
                        prevRecord._next = record;
                    }
                    if (this._linkedRecords === null) {
                        this._linkedRecords = new _DuplicateMap();
                    }
                    this._linkedRecords.put(record);
                    record.currentIndex = index;
                    return record;
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._remove = function (record) {
                    return this._addToRemovals(this._unlink(record));
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._unlink = function (record) {
                    if (this._linkedRecords !== null) {
                        this._linkedRecords.remove(record);
                    }
                    /** @type {?} */
                    var prev = record._prev;
                    /** @type {?} */
                    var next = record._next;
                    // TODO(vicb):
                    // assert((record._prev = null) === null);
                    // assert((record._next = null) === null);
                    if (prev === null) {
                        this._itHead = next;
                    }
                    else {
                        prev._next = next;
                    }
                    if (next === null) {
                        this._itTail = prev;
                    }
                    else {
                        next._prev = prev;
                    }
                    return record;
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @param {?} toIndex
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._addToMoves = function (record, toIndex) {
                    // TODO(vicb):
                    // assert(record._nextMoved === null);
                    if (record.previousIndex === toIndex) {
                        return record;
                    }
                    if (this._movesTail === null) {
                        // TODO(vicb):
                        // assert(_movesHead === null);
                        this._movesTail = this._movesHead = record;
                    }
                    else {
                        // TODO(vicb):
                        // assert(_movesTail._nextMoved === null);
                        this._movesTail = this._movesTail._nextMoved = record;
                    }
                    return record;
                };
                /**
                 * @private
                 * @param {?} record
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._addToRemovals = function (record) {
                    if (this._unlinkedRecords === null) {
                        this._unlinkedRecords = new _DuplicateMap();
                    }
                    this._unlinkedRecords.put(record);
                    record.currentIndex = null;
                    record._nextRemoved = null;
                    if (this._removalsTail === null) {
                        // TODO(vicb):
                        // assert(_removalsHead === null);
                        this._removalsTail = this._removalsHead = record;
                        record._prevRemoved = null;
                    }
                    else {
                        // TODO(vicb):
                        // assert(_removalsTail._nextRemoved === null);
                        // assert(record._nextRemoved === null);
                        record._prevRemoved = this._removalsTail;
                        this._removalsTail = this._removalsTail._nextRemoved = record;
                    }
                    return record;
                };
                /**
                 * \@internal
                 * @param {?} record
                 * @param {?} item
                 * @return {?}
                 */
                DefaultIterableDiffer.prototype._addIdentityChange = function (record, item) {
                    record.item = item;
                    if (this._identityChangesTail === null) {
                        this._identityChangesTail = this._identityChangesHead = record;
                    }
                    else {
                        this._identityChangesTail = this._identityChangesTail._nextIdentityChange = record;
                    }
                    return record;
                };
                return DefaultIterableDiffer;
            }());
            if (false) { }
            /**
             * @template V
             */
            var IterableChangeRecord_ = /** @class */ (function () {
                /**
                 * @param {?} item
                 * @param {?} trackById
                 */
                function IterableChangeRecord_(item, trackById) {
                    this.item = item;
                    this.trackById = trackById;
                    this.currentIndex = null;
                    this.previousIndex = null;
                    /**
                     * \@internal
                     */
                    this._nextPrevious = null;
                    /**
                     * \@internal
                     */
                    this._prev = null;
                    /**
                     * \@internal
                     */
                    this._next = null;
                    /**
                     * \@internal
                     */
                    this._prevDup = null;
                    /**
                     * \@internal
                     */
                    this._nextDup = null;
                    /**
                     * \@internal
                     */
                    this._prevRemoved = null;
                    /**
                     * \@internal
                     */
                    this._nextRemoved = null;
                    /**
                     * \@internal
                     */
                    this._nextAdded = null;
                    /**
                     * \@internal
                     */
                    this._nextMoved = null;
                    /**
                     * \@internal
                     */
                    this._nextIdentityChange = null;
                }
                return IterableChangeRecord_;
            }());
            if (false) { }
            // A linked list of CollectionChangeRecords with the same IterableChangeRecord_.item
            /**
             * @template V
             */
            var _DuplicateItemRecordList = /** @class */ (function () {
                function _DuplicateItemRecordList() {
                    /**
                     * \@internal
                     */
                    this._head = null;
                    /**
                     * \@internal
                     */
                    this._tail = null;
                }
                /**
                 * Append the record to the list of duplicates.
                 *
                 * Note: by design all records in the list of duplicates hold the same value in record.item.
                 * @param {?} record
                 * @return {?}
                 */
                _DuplicateItemRecordList.prototype.add = function (record) {
                    if (this._head === null) {
                        this._head = this._tail = record;
                        record._nextDup = null;
                        record._prevDup = null;
                    }
                    else {
                        // TODO(vicb):
                        // assert(record.item ==  _head.item ||
                        //       record.item is num && record.item.isNaN && _head.item is num && _head.item.isNaN);
                        ( /** @type {?} */(this._tail))._nextDup = record;
                        record._prevDup = this._tail;
                        record._nextDup = null;
                        this._tail = record;
                    }
                };
                // Returns a IterableChangeRecord_ having IterableChangeRecord_.trackById == trackById and
                // IterableChangeRecord_.currentIndex >= atOrAfterIndex
                /**
                 * @param {?} trackById
                 * @param {?} atOrAfterIndex
                 * @return {?}
                 */
                _DuplicateItemRecordList.prototype.get = function (trackById, atOrAfterIndex) {
                    /** @type {?} */
                    var record;
                    for (record = this._head; record !== null; record = record._nextDup) {
                        if ((atOrAfterIndex === null || atOrAfterIndex <= ( /** @type {?} */(record.currentIndex))) &&
                            looseIdentical(record.trackById, trackById)) {
                            return record;
                        }
                    }
                    return null;
                };
                /**
                 * Remove one {\@link IterableChangeRecord_} from the list of duplicates.
                 *
                 * Returns whether the list of duplicates is empty.
                 * @param {?} record
                 * @return {?}
                 */
                _DuplicateItemRecordList.prototype.remove = function (record) {
                    // TODO(vicb):
                    // assert(() {
                    //  // verify that the record being removed is in the list.
                    //  for (IterableChangeRecord_ cursor = _head; cursor != null; cursor = cursor._nextDup) {
                    //    if (identical(cursor, record)) return true;
                    //  }
                    //  return false;
                    //});
                    // TODO(vicb):
                    // assert(() {
                    //  // verify that the record being removed is in the list.
                    //  for (IterableChangeRecord_ cursor = _head; cursor != null; cursor = cursor._nextDup) {
                    //    if (identical(cursor, record)) return true;
                    //  }
                    //  return false;
                    //});
                    /** @type {?} */
                    var prev = record._prevDup;
                    /** @type {?} */
                    var next = record._nextDup;
                    if (prev === null) {
                        this._head = next;
                    }
                    else {
                        prev._nextDup = next;
                    }
                    if (next === null) {
                        this._tail = prev;
                    }
                    else {
                        next._prevDup = prev;
                    }
                    return this._head === null;
                };
                return _DuplicateItemRecordList;
            }());
            if (false) { }
            /**
             * @template V
             */
            var _DuplicateMap = /** @class */ (function () {
                function _DuplicateMap() {
                    this.map = new Map();
                }
                /**
                 * @param {?} record
                 * @return {?}
                 */
                _DuplicateMap.prototype.put = function (record) {
                    /** @type {?} */
                    var key = record.trackById;
                    /** @type {?} */
                    var duplicates = this.map.get(key);
                    if (!duplicates) {
                        duplicates = new _DuplicateItemRecordList();
                        this.map.set(key, duplicates);
                    }
                    duplicates.add(record);
                };
                /**
                 * Retrieve the `value` using key. Because the IterableChangeRecord_ value may be one which we
                 * have already iterated over, we use the `atOrAfterIndex` to pretend it is not there.
                 *
                 * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
                 * have any more `a`s needs to return the second `a`.
                 * @param {?} trackById
                 * @param {?} atOrAfterIndex
                 * @return {?}
                 */
                _DuplicateMap.prototype.get = function (trackById, atOrAfterIndex) {
                    /** @type {?} */
                    var key = trackById;
                    /** @type {?} */
                    var recordList = this.map.get(key);
                    return recordList ? recordList.get(trackById, atOrAfterIndex) : null;
                };
                /**
                 * Removes a {\@link IterableChangeRecord_} from the list of duplicates.
                 *
                 * The list of duplicates also is removed from the map if it gets empty.
                 * @param {?} record
                 * @return {?}
                 */
                _DuplicateMap.prototype.remove = function (record) {
                    /** @type {?} */
                    var key = record.trackById;
                    /** @type {?} */
                    var recordList = ( /** @type {?} */(this.map.get(key)));
                    // Remove the list of duplicates when it gets empty
                    if (recordList.remove(record)) {
                        this.map.delete(key);
                    }
                    return record;
                };
                Object.defineProperty(_DuplicateMap.prototype, "isEmpty", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.map.size === 0; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                _DuplicateMap.prototype.clear = function () { this.map.clear(); };
                return _DuplicateMap;
            }());
            if (false) { }
            /**
             * @param {?} item
             * @param {?} addRemoveOffset
             * @param {?} moveOffsets
             * @return {?}
             */
            function getPreviousIndex(item, addRemoveOffset, moveOffsets) {
                /** @type {?} */
                var previousIndex = item.previousIndex;
                if (previousIndex === null)
                    return previousIndex;
                /** @type {?} */
                var moveOffset = 0;
                if (moveOffsets && previousIndex < moveOffsets.length) {
                    moveOffset = moveOffsets[previousIndex];
                }
                return previousIndex + addRemoveOffset + moveOffset;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @template K, V
             */
            var DefaultKeyValueDifferFactory = /** @class */ (function () {
                function DefaultKeyValueDifferFactory() {
                }
                /**
                 * @param {?} obj
                 * @return {?}
                 */
                DefaultKeyValueDifferFactory.prototype.supports = function (obj) { return obj instanceof Map || isJsObject$1(obj); };
                /**
                 * @template K, V
                 * @return {?}
                 */
                DefaultKeyValueDifferFactory.prototype.create = function () { return new DefaultKeyValueDiffer(); };
                return DefaultKeyValueDifferFactory;
            }());
            /**
             * @template K, V
             */
            var DefaultKeyValueDiffer = /** @class */ (function () {
                function DefaultKeyValueDiffer() {
                    this._records = new Map();
                    this._mapHead = null;
                    // _appendAfter is used in the check loop
                    this._appendAfter = null;
                    this._previousMapHead = null;
                    this._changesHead = null;
                    this._changesTail = null;
                    this._additionsHead = null;
                    this._additionsTail = null;
                    this._removalsHead = null;
                    this._removalsTail = null;
                }
                Object.defineProperty(DefaultKeyValueDiffer.prototype, "isDirty", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._additionsHead !== null || this._changesHead !== null ||
                            this._removalsHead !== null;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.forEachItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._mapHead; record !== null; record = record._next) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.forEachPreviousItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.forEachChangedItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._changesHead; record !== null; record = record._nextChanged) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.forEachAddedItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                        fn(record);
                    }
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.forEachRemovedItem = function (fn) {
                    /** @type {?} */
                    var record;
                    for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
                        fn(record);
                    }
                };
                /**
                 * @param {?=} map
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.diff = function (map) {
                    if (!map) {
                        map = new Map();
                    }
                    else if (!(map instanceof Map || isJsObject$1(map))) {
                        throw new Error("Error trying to diff '" + stringify(map) + "'. Only maps and objects are allowed");
                    }
                    return this.check(map) ? this : null;
                };
                /**
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.onDestroy = function () { };
                /**
                 * Check the current state of the map vs the previous.
                 * The algorithm is optimised for when the keys do no change.
                 * @param {?} map
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype.check = function (map) {
                    var _this = this;
                    this._reset();
                    /** @type {?} */
                    var insertBefore = this._mapHead;
                    this._appendAfter = null;
                    this._forEach(map, ( /**
                     * @param {?} value
                     * @param {?} key
                     * @return {?}
                     */function (value, key) {
                        if (insertBefore && insertBefore.key === key) {
                            _this._maybeAddToChanges(insertBefore, value);
                            _this._appendAfter = insertBefore;
                            insertBefore = insertBefore._next;
                        }
                        else {
                            /** @type {?} */
                            var record = _this._getOrCreateRecordForKey(key, value);
                            insertBefore = _this._insertBeforeOrAppend(insertBefore, record);
                        }
                    }));
                    // Items remaining at the end of the list have been deleted
                    if (insertBefore) {
                        if (insertBefore._prev) {
                            insertBefore._prev._next = null;
                        }
                        this._removalsHead = insertBefore;
                        for (var record = insertBefore; record !== null; record = record._nextRemoved) {
                            if (record === this._mapHead) {
                                this._mapHead = null;
                            }
                            this._records.delete(record.key);
                            record._nextRemoved = record._next;
                            record.previousValue = record.currentValue;
                            record.currentValue = null;
                            record._prev = null;
                            record._next = null;
                        }
                    }
                    // Make sure tails have no next records from previous runs
                    if (this._changesTail)
                        this._changesTail._nextChanged = null;
                    if (this._additionsTail)
                        this._additionsTail._nextAdded = null;
                    return this.isDirty;
                };
                /**
                 * Inserts a record before `before` or append at the end of the list when `before` is null.
                 *
                 * Notes:
                 * - This method appends at `this._appendAfter`,
                 * - This method updates `this._appendAfter`,
                 * - The return value is the new value for the insertion pointer.
                 * @private
                 * @param {?} before
                 * @param {?} record
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._insertBeforeOrAppend = function (before, record) {
                    if (before) {
                        /** @type {?} */
                        var prev = before._prev;
                        record._next = before;
                        record._prev = prev;
                        before._prev = record;
                        if (prev) {
                            prev._next = record;
                        }
                        if (before === this._mapHead) {
                            this._mapHead = record;
                        }
                        this._appendAfter = before;
                        return before;
                    }
                    if (this._appendAfter) {
                        this._appendAfter._next = record;
                        record._prev = this._appendAfter;
                    }
                    else {
                        this._mapHead = record;
                    }
                    this._appendAfter = record;
                    return null;
                };
                /**
                 * @private
                 * @param {?} key
                 * @param {?} value
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._getOrCreateRecordForKey = function (key, value) {
                    if (this._records.has(key)) {
                        /** @type {?} */
                        var record_1 = ( /** @type {?} */(this._records.get(key)));
                        this._maybeAddToChanges(record_1, value);
                        /** @type {?} */
                        var prev = record_1._prev;
                        /** @type {?} */
                        var next = record_1._next;
                        if (prev) {
                            prev._next = next;
                        }
                        if (next) {
                            next._prev = prev;
                        }
                        record_1._next = null;
                        record_1._prev = null;
                        return record_1;
                    }
                    /** @type {?} */
                    var record = new KeyValueChangeRecord_(key);
                    this._records.set(key, record);
                    record.currentValue = value;
                    this._addToAdditions(record);
                    return record;
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._reset = function () {
                    if (this.isDirty) {
                        /** @type {?} */
                        var record = void 0;
                        // let `_previousMapHead` contain the state of the map before the changes
                        this._previousMapHead = this._mapHead;
                        for (record = this._previousMapHead; record !== null; record = record._next) {
                            record._nextPrevious = record._next;
                        }
                        // Update `record.previousValue` with the value of the item before the changes
                        // We need to update all changed items (that's those which have been added and changed)
                        for (record = this._changesHead; record !== null; record = record._nextChanged) {
                            record.previousValue = record.currentValue;
                        }
                        for (record = this._additionsHead; record != null; record = record._nextAdded) {
                            record.previousValue = record.currentValue;
                        }
                        this._changesHead = this._changesTail = null;
                        this._additionsHead = this._additionsTail = null;
                        this._removalsHead = null;
                    }
                };
                // Add the record or a given key to the list of changes only when the value has actually changed
                /**
                 * @private
                 * @param {?} record
                 * @param {?} newValue
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._maybeAddToChanges = function (record, newValue) {
                    if (!looseIdentical(newValue, record.currentValue)) {
                        record.previousValue = record.currentValue;
                        record.currentValue = newValue;
                        this._addToChanges(record);
                    }
                };
                /**
                 * @private
                 * @param {?} record
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._addToAdditions = function (record) {
                    if (this._additionsHead === null) {
                        this._additionsHead = this._additionsTail = record;
                    }
                    else {
                        ( /** @type {?} */(this._additionsTail))._nextAdded = record;
                        this._additionsTail = record;
                    }
                };
                /**
                 * @private
                 * @param {?} record
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._addToChanges = function (record) {
                    if (this._changesHead === null) {
                        this._changesHead = this._changesTail = record;
                    }
                    else {
                        ( /** @type {?} */(this._changesTail))._nextChanged = record;
                        this._changesTail = record;
                    }
                };
                /**
                 * \@internal
                 * @private
                 * @template K, V
                 * @param {?} obj
                 * @param {?} fn
                 * @return {?}
                 */
                DefaultKeyValueDiffer.prototype._forEach = function (obj, fn) {
                    if (obj instanceof Map) {
                        obj.forEach(fn);
                    }
                    else {
                        Object.keys(obj).forEach(( /**
                         * @param {?} k
                         * @return {?}
                         */function (/**
                         * @param {?} k
                         * @return {?}
                         */ k) { return fn(obj[k], k); }));
                    }
                };
                return DefaultKeyValueDiffer;
            }());
            if (false) { }
            /**
             * @template K, V
             */
            var KeyValueChangeRecord_ = /** @class */ (function () {
                /**
                 * @param {?} key
                 */
                function KeyValueChangeRecord_(key) {
                    this.key = key;
                    this.previousValue = null;
                    this.currentValue = null;
                    /**
                     * \@internal
                     */
                    this._nextPrevious = null;
                    /**
                     * \@internal
                     */
                    this._next = null;
                    /**
                     * \@internal
                     */
                    this._prev = null;
                    /**
                     * \@internal
                     */
                    this._nextAdded = null;
                    /**
                     * \@internal
                     */
                    this._nextRemoved = null;
                    /**
                     * \@internal
                     */
                    this._nextChanged = null;
                }
                return KeyValueChangeRecord_;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A strategy for tracking changes over time to an iterable. Used by {\@link NgForOf} to
             * respond to changes in an iterable by effecting equivalent changes in the DOM.
             *
             * \@publicApi
             * @record
             * @template V
             */
            function IterableDiffer() { }
            if (false) { }
            /**
             * An object describing the changes in the `Iterable` collection since last time
             * `IterableDiffer#diff()` was invoked.
             *
             * \@publicApi
             * @record
             * @template V
             */
            function IterableChanges() { }
            if (false) { }
            /**
             * Record representing the item change information.
             *
             * \@publicApi
             * @record
             * @template V
             */
            function IterableChangeRecord() { }
            if (false) { }
            /**
             * @deprecated v4.0.0 - Use IterableChangeRecord instead.
             * \@publicApi
             * @record
             * @template V
             */
            function CollectionChangeRecord() { }
            /**
             * An optional function passed into the `NgForOf` directive that defines how to track
             * changes for items in an iterable.
             * The function takes the iteration index and item ID.
             * When supplied, Angular tracks changes by the return value of the function.
             *
             * \@publicApi
             * @record
             * @template T
             */
            function TrackByFunction() { }
            /**
             * Provides a factory for {\@link IterableDiffer}.
             *
             * \@publicApi
             * @record
             */
            function IterableDifferFactory() { }
            if (false) { }
            /**
             * A repository of different iterable diffing strategies used by NgFor, NgClass, and others.
             *
             * \@publicApi
             */
            var IterableDiffers = /** @class */ (function () {
                /**
                 * @param {?} factories
                 */
                function IterableDiffers(factories) {
                    this.factories = factories;
                }
                /**
                 * @param {?} factories
                 * @param {?=} parent
                 * @return {?}
                 */
                IterableDiffers.create = function (factories, parent) {
                    if (parent != null) {
                        /** @type {?} */
                        var copied = parent.factories.slice();
                        factories = factories.concat(copied);
                    }
                    return new IterableDiffers(factories);
                };
                /**
                 * Takes an array of {\@link IterableDifferFactory} and returns a provider used to extend the
                 * inherited {\@link IterableDiffers} instance with the provided factories and return a new
                 * {\@link IterableDiffers} instance.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * The following example shows how to extend an existing list of factories,
                 * which will only be applied to the injector for this component and its children.
                 * This step is all that's required to make a new {\@link IterableDiffer} available.
                 *
                 * ```
                 * \@Component({
                 *   viewProviders: [
                 *     IterableDiffers.extend([new ImmutableListDiffer()])
                 *   ]
                 * })
                 * ```
                 * @param {?} factories
                 * @return {?}
                 */
                IterableDiffers.extend = function (factories) {
                    return {
                        provide: IterableDiffers,
                        useFactory: ( /**
                         * @param {?} parent
                         * @return {?}
                         */function (parent) {
                            if (!parent) {
                                // Typically would occur when calling IterableDiffers.extend inside of dependencies passed
                                // to
                                // bootstrap(), which would override default pipes instead of extending them.
                                throw new Error('Cannot extend IterableDiffers without a parent injector');
                            }
                            return IterableDiffers.create(factories, parent);
                        }),
                        // Dependency technically isn't optional, but we can provide a better error message this way.
                        deps: [[IterableDiffers, new SkipSelf(), new Optional()]]
                    };
                };
                /**
                 * @param {?} iterable
                 * @return {?}
                 */
                IterableDiffers.prototype.find = function (iterable) {
                    /** @type {?} */
                    var factory = this.factories.find(( /**
                     * @param {?} f
                     * @return {?}
                     */function (/**
                     * @param {?} f
                     * @return {?}
                     */ f) { return f.supports(iterable); }));
                    if (factory != null) {
                        return factory;
                    }
                    else {
                        throw new Error("Cannot find a differ supporting object '" + iterable + "' of type '" + getTypeNameForDebugging(iterable) + "'");
                    }
                };
                return IterableDiffers;
            }());
            /** @nocollapse */
            /** @nocollapse */ IterableDiffers.ngInjectableDef = ɵɵdefineInjectable({
                token: IterableDiffers,
                providedIn: 'root',
                factory: ( /**
                 * @nocollapse @return {?}
                 */function () { return new IterableDiffers([new DefaultIterableDifferFactory()]); })
            });
            if (false) { }
            /**
             * @param {?} type
             * @return {?}
             */
            function getTypeNameForDebugging(type) {
                return type['name'] || typeof type;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A differ that tracks changes made to an object over time.
             *
             * \@publicApi
             * @record
             * @template K, V
             */
            function KeyValueDiffer() { }
            if (false) { }
            /**
             * An object describing the changes in the `Map` or `{[k:string]: string}` since last time
             * `KeyValueDiffer#diff()` was invoked.
             *
             * \@publicApi
             * @record
             * @template K, V
             */
            function KeyValueChanges() { }
            if (false) { }
            /**
             * Record representing the item change information.
             *
             * \@publicApi
             * @record
             * @template K, V
             */
            function KeyValueChangeRecord() { }
            if (false) { }
            /**
             * Provides a factory for {\@link KeyValueDiffer}.
             *
             * \@publicApi
             * @record
             */
            function KeyValueDifferFactory() { }
            if (false) { }
            /**
             * A repository of different Map diffing strategies used by NgClass, NgStyle, and others.
             *
             * \@publicApi
             */
            var KeyValueDiffers = /** @class */ (function () {
                /**
                 * @param {?} factories
                 */
                function KeyValueDiffers(factories) {
                    this.factories = factories;
                }
                /**
                 * @template S
                 * @param {?} factories
                 * @param {?=} parent
                 * @return {?}
                 */
                KeyValueDiffers.create = function (factories, parent) {
                    if (parent) {
                        /** @type {?} */
                        var copied = parent.factories.slice();
                        factories = factories.concat(copied);
                    }
                    return new KeyValueDiffers(factories);
                };
                /**
                 * Takes an array of {\@link KeyValueDifferFactory} and returns a provider used to extend the
                 * inherited {\@link KeyValueDiffers} instance with the provided factories and return a new
                 * {\@link KeyValueDiffers} instance.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * The following example shows how to extend an existing list of factories,
                 * which will only be applied to the injector for this component and its children.
                 * This step is all that's required to make a new {\@link KeyValueDiffer} available.
                 *
                 * ```
                 * \@Component({
                 *   viewProviders: [
                 *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
                 *   ]
                 * })
                 * ```
                 * @template S
                 * @param {?} factories
                 * @return {?}
                 */
                KeyValueDiffers.extend = function (factories) {
                    return {
                        provide: KeyValueDiffers,
                        useFactory: ( /**
                         * @param {?} parent
                         * @return {?}
                         */function (parent) {
                            if (!parent) {
                                // Typically would occur when calling KeyValueDiffers.extend inside of dependencies passed
                                // to bootstrap(), which would override default pipes instead of extending them.
                                throw new Error('Cannot extend KeyValueDiffers without a parent injector');
                            }
                            return KeyValueDiffers.create(factories, parent);
                        }),
                        // Dependency technically isn't optional, but we can provide a better error message this way.
                        deps: [[KeyValueDiffers, new SkipSelf(), new Optional()]]
                    };
                };
                /**
                 * @param {?} kv
                 * @return {?}
                 */
                KeyValueDiffers.prototype.find = function (kv) {
                    /** @type {?} */
                    var factory = this.factories.find(( /**
                     * @param {?} f
                     * @return {?}
                     */function (/**
                     * @param {?} f
                     * @return {?}
                     */ f) { return f.supports(kv); }));
                    if (factory) {
                        return factory;
                    }
                    throw new Error("Cannot find a differ supporting object '" + kv + "'");
                };
                return KeyValueDiffers;
            }());
            /** @nocollapse */
            /** @nocollapse */ KeyValueDiffers.ngInjectableDef = ɵɵdefineInjectable({
                token: KeyValueDiffers,
                providedIn: 'root',
                factory: ( /**
                 * @nocollapse @return {?}
                 */function () { return new KeyValueDiffers([new DefaultKeyValueDifferFactory()]); })
            });
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Structural diffing for `Object`s and `Map`s.
             * @type {?}
             */
            var keyValDiff = [new DefaultKeyValueDifferFactory()];
            /**
             * Structural diffing for `Iterable` types such as `Array`s.
             * @type {?}
             */
            var iterableDiff = [new DefaultIterableDifferFactory()];
            /** @type {?} */
            var defaultIterableDiffers = new IterableDiffers(iterableDiff);
            /** @type {?} */
            var defaultKeyValueDiffers = new KeyValueDiffers(keyValDiff);
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Represents an embedded template that can be used to instantiate embedded views.
             * To instantiate embedded views based on a template, use the `ViewContainerRef`
             * method `createEmbeddedView()`.
             *
             * Access a `TemplateRef` instance by placing a directive on an `<ng-template>`
             * element (or directive prefixed with `*`). The `TemplateRef` for the embedded view
             * is injected into the constructor of the directive,
             * using the `TemplateRef` token.
             *
             * You can also use a `Query` to find a `TemplateRef` associated with
             * a component or a directive.
             *
             * @see `ViewContainerRef`
             * @see [Navigate the Component Tree with DI](guide/dependency-injection-navtree)
             *
             * \@publicApi
             * @abstract
             * @template C
             */
            var TemplateRef = /** @class */ (function () {
                function TemplateRef() {
                }
                return TemplateRef;
            }());
            /**
             * \@internal
             * @nocollapse
             */
            TemplateRef.__NG_ELEMENT_ID__ = ( /**
             * @return {?}
             */function () { return SWITCH_TEMPLATE_REF_FACTORY(TemplateRef, ElementRef); });
            if (false) { }
            /** @type {?} */
            var SWITCH_TEMPLATE_REF_FACTORY__POST_R3__ = injectTemplateRef;
            /** @type {?} */
            var SWITCH_TEMPLATE_REF_FACTORY__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_TEMPLATE_REF_FACTORY = SWITCH_TEMPLATE_REF_FACTORY__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Represents a container where one or more views can be attached to a component.
             *
             * Can contain *host views* (created by instantiating a
             * component with the `createComponent()` method), and *embedded views*
             * (created by instantiating a `TemplateRef` with the `createEmbeddedView()` method).
             *
             * A view container instance can contain other view containers,
             * creating a [view hierarchy](guide/glossary#view-tree).
             *
             * @see `ComponentRef`
             * @see `EmbeddedViewRef`
             *
             * \@publicApi
             * @abstract
             */
            var ViewContainerRef = /** @class */ (function () {
                function ViewContainerRef() {
                }
                return ViewContainerRef;
            }());
            /**
             * \@internal
             * @nocollapse
             */
            ViewContainerRef.__NG_ELEMENT_ID__ = ( /**
             * @return {?}
             */function () { return SWITCH_VIEW_CONTAINER_REF_FACTORY(ViewContainerRef, ElementRef); });
            if (false) { }
            /** @type {?} */
            var SWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__ = injectViewContainerRef;
            /** @type {?} */
            var SWITCH_VIEW_CONTAINER_REF_FACTORY__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_VIEW_CONTAINER_REF_FACTORY = SWITCH_VIEW_CONTAINER_REF_FACTORY__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} context
             * @param {?} oldValue
             * @param {?} currValue
             * @param {?} isFirstCheck
             * @return {?}
             */
            function expressionChangedAfterItHasBeenCheckedError(context, oldValue, currValue, isFirstCheck) {
                /** @type {?} */
                var msg = "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
                if (isFirstCheck) {
                    msg +=
                        " It seems like the view has been created after its parent and its children have been dirty checked." +
                            " Has it been created in a change detection hook ?";
                }
                return viewDebugError(msg, context);
            }
            /**
             * @param {?} err
             * @param {?} context
             * @return {?}
             */
            function viewWrappedDebugError(err, context) {
                if (!(err instanceof Error)) {
                    // errors that are not Error instances don't have a stack,
                    // so it is ok to wrap them into a new Error object...
                    err = new Error(err.toString());
                }
                _addDebugContext(err, context);
                return err;
            }
            /**
             * @param {?} msg
             * @param {?} context
             * @return {?}
             */
            function viewDebugError(msg, context) {
                /** @type {?} */
                var err = new Error(msg);
                _addDebugContext(err, context);
                return err;
            }
            /**
             * @param {?} err
             * @param {?} context
             * @return {?}
             */
            function _addDebugContext(err, context) {
                (( /** @type {?} */(err)))[ERROR_DEBUG_CONTEXT] = context;
                (( /** @type {?} */(err)))[ERROR_LOGGER] = context.logError.bind(context);
            }
            /**
             * @param {?} err
             * @return {?}
             */
            function isViewDebugError(err) {
                return !!getDebugContext(err);
            }
            /**
             * @param {?} action
             * @return {?}
             */
            function viewDestroyedError(action) {
                return new Error("ViewDestroyedError: Attempt to use a destroyed view: " + action);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Factory for ViewDefinitions/NgModuleDefinitions.
             * We use a function so we can reexeute it in case an error happens and use the given logger
             * function to log the error from the definition of the node, which is shown in all browser
             * logs.
             * @record
             * @template D
             */
            function DefinitionFactory() { }
            /**
             * Function to call console.error at the right source location. This is an indirection
             * via another function as browser will log the location that actually called
             * `console.error`.
             * @record
             */
            function NodeLogger() { }
            /**
             * @record
             * @template DF
             */
            function Definition() { }
            if (false) { }
            /**
             * @record
             */
            function NgModuleDefinition() { }
            if (false) { }
            /**
             * @record
             */
            function NgModuleDefinitionFactory() { }
            /**
             * @record
             */
            function ViewDefinition() { }
            if (false) { }
            /**
             * @record
             */
            function ViewDefinitionFactory() { }
            /**
             * @record
             */
            function ViewUpdateFn() { }
            /**
             * @record
             */
            function NodeCheckFn() { }
            /** @enum {number} */
            var ArgumentType = {
                Inline: 0, Dynamic: 1,
            };
            /**
             * @record
             */
            function ViewHandleEventFn() { }
            /** @enum {number} */
            var ViewFlags = {
                None: 0,
                OnPush: 2,
            };
            /**
             * A node definition in the view.
             *
             * Note: We use one type for all nodes so that loops that loop over all nodes
             * of a ViewDefinition stay monomorphic!
             * @record
             */
            function NodeDef() { }
            if (false) { }
            /** @enum {number} */
            var NodeFlags = {
                None: 0,
                TypeElement: 1,
                TypeText: 2,
                ProjectedTemplate: 4,
                CatRenderNode: 3,
                TypeNgContent: 8,
                TypePipe: 16,
                TypePureArray: 32,
                TypePureObject: 64,
                TypePurePipe: 128,
                CatPureExpression: 224,
                TypeValueProvider: 256,
                TypeClassProvider: 512,
                TypeFactoryProvider: 1024,
                TypeUseExistingProvider: 2048,
                LazyProvider: 4096,
                PrivateProvider: 8192,
                TypeDirective: 16384,
                Component: 32768,
                CatProviderNoDirective: 3840,
                CatProvider: 20224,
                OnInit: 65536,
                OnDestroy: 131072,
                DoCheck: 262144,
                OnChanges: 524288,
                AfterContentInit: 1048576,
                AfterContentChecked: 2097152,
                AfterViewInit: 4194304,
                AfterViewChecked: 8388608,
                EmbeddedViews: 16777216,
                ComponentView: 33554432,
                TypeContentQuery: 67108864,
                TypeViewQuery: 134217728,
                StaticQuery: 268435456,
                DynamicQuery: 536870912,
                TypeNgModule: 1073741824,
                CatQuery: 201326592,
                // mutually exclusive values...
                Types: 201347067,
            };
            /**
             * @record
             */
            function BindingDef() { }
            if (false) { }
            /** @enum {number} */
            var BindingFlags = {
                TypeElementAttribute: 1,
                TypeElementClass: 2,
                TypeElementStyle: 4,
                TypeProperty: 8,
                SyntheticProperty: 16,
                SyntheticHostProperty: 32,
                CatSyntheticProperty: 48,
                // mutually exclusive values...
                Types: 15,
            };
            /**
             * @record
             */
            function OutputDef() { }
            if (false) { }
            /** @enum {number} */
            var OutputType = {
                ElementOutput: 0, DirectiveOutput: 1,
            };
            /** @enum {number} */
            var QueryValueType = {
                ElementRef: 0,
                RenderElement: 1,
                TemplateRef: 2,
                ViewContainerRef: 3,
                Provider: 4,
            };
            /**
             * @record
             */
            function ElementDef() { }
            if (false) { }
            /**
             * @record
             */
            function ElementHandleEventFn() { }
            /**
             * @record
             */
            function ProviderDef() { }
            if (false) { }
            /**
             * @record
             */
            function NgModuleProviderDef() { }
            if (false) { }
            /**
             * @record
             */
            function DepDef() { }
            if (false) { }
            /** @enum {number} */
            var DepFlags = {
                None: 0,
                SkipSelf: 1,
                Optional: 2,
                Self: 4,
                Value: 8,
            };
            /**
             * @record
             */
            function TextDef() { }
            if (false) { }
            /**
             * @record
             */
            function QueryDef() { }
            if (false) { }
            /**
             * @record
             */
            function QueryBindingDef() { }
            if (false) { }
            /** @enum {number} */
            var QueryBindingType = {
                First: 0, All: 1,
            };
            /**
             * @record
             */
            function NgContentDef() { }
            if (false) { }
            /**
             * @record
             */
            function NgModuleData() { }
            if (false) { }
            /**
             * View instance data.
             * Attention: Adding fields to this is performance sensitive!
             * @record
             */
            function ViewData() { }
            if (false) { }
            /** @enum {number} */
            var ViewState = {
                BeforeFirstCheck: 1,
                FirstCheck: 2,
                Attached: 4,
                ChecksEnabled: 8,
                IsProjectedView: 16,
                CheckProjectedView: 32,
                CheckProjectedViews: 64,
                Destroyed: 128,
                // InitState Uses 3 bits
                InitState_Mask: 1792,
                InitState_BeforeInit: 0,
                InitState_CallingOnInit: 256,
                InitState_CallingAfterContentInit: 512,
                InitState_CallingAfterViewInit: 768,
                InitState_AfterInit: 1024,
                CatDetectChanges: 12,
                CatInit: 13,
            };
            // Called before each cycle of a view's check to detect whether this is in the
            // initState for which we need to call ngOnInit, ngAfterContentInit or ngAfterViewInit
            // lifecycle methods. Returns true if this check cycle should call lifecycle
            // methods.
            /**
             * @param {?} view
             * @param {?} priorInitState
             * @param {?} newInitState
             * @return {?}
             */
            function shiftInitState(view, priorInitState, newInitState) {
                // Only update the InitState if we are currently in the prior state.
                // For example, only move into CallingInit if we are in BeforeInit. Only
                // move into CallingContentInit if we are in CallingInit. Normally this will
                // always be true because of how checkCycle is called in checkAndUpdateView.
                // However, if checkAndUpdateView is called recursively or if an exception is
                // thrown while checkAndUpdateView is running, checkAndUpdateView starts over
                // from the beginning. This ensures the state is monotonically increasing,
                // terminating in the AfterInit state, which ensures the Init methods are called
                // at least once and only once.
                /** @type {?} */
                var state = view.state;
                /** @type {?} */
                var initState = state & 1792 /* InitState_Mask */;
                if (initState === priorInitState) {
                    view.state = (state & ~1792 /* InitState_Mask */) | newInitState;
                    view.initIndex = -1;
                    return true;
                }
                return initState === newInitState;
            }
            // Returns true if the lifecycle init method should be called for the node with
            // the given init index.
            /**
             * @param {?} view
             * @param {?} initState
             * @param {?} index
             * @return {?}
             */
            function shouldCallLifecycleInitHook(view, initState, index) {
                if ((view.state & 1792 /* InitState_Mask */) === initState && view.initIndex <= index) {
                    view.initIndex = index + 1;
                    return true;
                }
                return false;
            }
            /**
             * @record
             */
            function DisposableFn() { }
            /**
             * Node instance data.
             *
             * We have a separate type per NodeType to save memory
             * (TextData | ElementData | ProviderData | PureExpressionData | QueryList<any>)
             *
             * To keep our code monomorphic,
             * we prohibit using `NodeData` directly but enforce the use of accessors (`asElementData`, ...).
             * This way, no usage site can get a `NodeData` from view.nodes and then use it for different
             * purposes.
             */
            var NodeData = /** @class */ (function () {
                function NodeData() {
                }
                return NodeData;
            }());
            if (false) { }
            /**
             * Data for an instantiated NodeType.Text.
             *
             * Attention: Adding fields to this is performance sensitive!
             * @record
             */
            function TextData() { }
            if (false) { }
            /**
             * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function asTextData(view, index) {
                return ( /** @type {?} */(view.nodes[index]));
            }
            /**
             * Data for an instantiated NodeType.Element.
             *
             * Attention: Adding fields to this is performance sensitive!
             * @record
             */
            function ElementData() { }
            if (false) { }
            /**
             * @record
             */
            function ViewContainerData() { }
            if (false) { }
            /**
             * @record
             */
            function TemplateData() { }
            if (false) { }
            /**
             * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function asElementData(view, index) {
                return ( /** @type {?} */(view.nodes[index]));
            }
            /**
             * Data for an instantiated NodeType.Provider.
             *
             * Attention: Adding fields to this is performance sensitive!
             * @record
             */
            function ProviderData() { }
            if (false) { }
            /**
             * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function asProviderData(view, index) {
                return ( /** @type {?} */(view.nodes[index]));
            }
            /**
             * Data for an instantiated NodeType.PureExpression.
             *
             * Attention: Adding fields to this is performance sensitive!
             * @record
             */
            function PureExpressionData() { }
            if (false) { }
            /**
             * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function asPureExpressionData(view, index) {
                return ( /** @type {?} */(view.nodes[index]));
            }
            /**
             * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function asQueryList(view, index) {
                return ( /** @type {?} */(view.nodes[index]));
            }
            /**
             * @record
             */
            function RootData() { }
            if (false) { }
            /**
             * @abstract
             */
            var DebugContext = /** @class */ (function () {
                function DebugContext() {
                }
                return DebugContext;
            }());
            if (false) { }
            /** @enum {number} */
            var CheckType = {
                CheckAndUpdate: 0, CheckNoChanges: 1,
            };
            /**
             * @record
             */
            function ProviderOverride() { }
            if (false) { }
            // WARNING: interface has both a type and a value, skipping emit
            /**
             * This object is used to prevent cycles in the source files and to have a place where
             * debug mode can hook it. It is lazily filled when `isDevMode` is known.
             * @type {?}
             */
            var Services = {
                setCurrentNode: ( /** @type {?} */(undefined)),
                createRootView: ( /** @type {?} */(undefined)),
                createEmbeddedView: ( /** @type {?} */(undefined)),
                createComponentView: ( /** @type {?} */(undefined)),
                createNgModuleRef: ( /** @type {?} */(undefined)),
                overrideProvider: ( /** @type {?} */(undefined)),
                overrideComponentView: ( /** @type {?} */(undefined)),
                clearOverrides: ( /** @type {?} */(undefined)),
                checkAndUpdateView: ( /** @type {?} */(undefined)),
                checkNoChangesView: ( /** @type {?} */(undefined)),
                destroyView: ( /** @type {?} */(undefined)),
                resolveDep: ( /** @type {?} */(undefined)),
                createDebugContext: ( /** @type {?} */(undefined)),
                handleEvent: ( /** @type {?} */(undefined)),
                updateDirectives: ( /** @type {?} */(undefined)),
                updateRenderer: ( /** @type {?} */(undefined)),
                dirtyParentQueries: ( /** @type {?} */(undefined)),
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var NOOP = ( /**
             * @return {?}
             */function () { });
            /** @type {?} */
            var _tokenKeyCache = new Map();
            /**
             * @param {?} token
             * @return {?}
             */
            function tokenKey(token) {
                /** @type {?} */
                var key = _tokenKeyCache.get(token);
                if (!key) {
                    key = stringify(token) + '_' + _tokenKeyCache.size;
                    _tokenKeyCache.set(token, key);
                }
                return key;
            }
            /**
             * @param {?} view
             * @param {?} nodeIdx
             * @param {?} bindingIdx
             * @param {?} value
             * @return {?}
             */
            function unwrapValue(view, nodeIdx, bindingIdx, value) {
                if (WrappedValue.isWrapped(value)) {
                    value = WrappedValue.unwrap(value);
                    /** @type {?} */
                    var globalBindingIdx = view.def.nodes[nodeIdx].bindingIndex + bindingIdx;
                    /** @type {?} */
                    var oldValue = WrappedValue.unwrap(view.oldValues[globalBindingIdx]);
                    view.oldValues[globalBindingIdx] = new WrappedValue(oldValue);
                }
                return value;
            }
            /** @type {?} */
            var UNDEFINED_RENDERER_TYPE_ID = '$$undefined';
            /** @type {?} */
            var EMPTY_RENDERER_TYPE_ID = '$$empty';
            // Attention: this function is called as top level function.
            // Putting any logic in here will destroy closure tree shaking!
            /**
             * @param {?} values
             * @return {?}
             */
            function createRendererType2(values) {
                return {
                    id: UNDEFINED_RENDERER_TYPE_ID,
                    styles: values.styles,
                    encapsulation: values.encapsulation,
                    data: values.data
                };
            }
            /** @type {?} */
            var _renderCompCount$1 = 0;
            /**
             * @param {?=} type
             * @return {?}
             */
            function resolveRendererType2(type) {
                if (type && type.id === UNDEFINED_RENDERER_TYPE_ID) {
                    // first time we see this RendererType2. Initialize it...
                    /** @type {?} */
                    var isFilled = ((type.encapsulation != null && type.encapsulation !== ViewEncapsulation.None) ||
                        type.styles.length || Object.keys(type.data).length);
                    if (isFilled) {
                        type.id = "c" + _renderCompCount$1++;
                    }
                    else {
                        type.id = EMPTY_RENDERER_TYPE_ID;
                    }
                }
                if (type && type.id === EMPTY_RENDERER_TYPE_ID) {
                    type = null;
                }
                return type || null;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} bindingIdx
             * @param {?} value
             * @return {?}
             */
            function checkBinding(view, def, bindingIdx, value) {
                /** @type {?} */
                var oldValues = view.oldValues;
                if ((view.state & 2 /* FirstCheck */) ||
                    !looseIdentical(oldValues[def.bindingIndex + bindingIdx], value)) {
                    return true;
                }
                return false;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} bindingIdx
             * @param {?} value
             * @return {?}
             */
            function checkAndUpdateBinding(view, def, bindingIdx, value) {
                if (checkBinding(view, def, bindingIdx, value)) {
                    view.oldValues[def.bindingIndex + bindingIdx] = value;
                    return true;
                }
                return false;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} bindingIdx
             * @param {?} value
             * @return {?}
             */
            function checkBindingNoChanges(view, def, bindingIdx, value) {
                /** @type {?} */
                var oldValue = view.oldValues[def.bindingIndex + bindingIdx];
                if ((view.state & 1 /* BeforeFirstCheck */) || !devModeEqual$1(oldValue, value)) {
                    /** @type {?} */
                    var bindingName = def.bindings[bindingIdx].name;
                    throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, def.nodeIndex), bindingName + ": " + oldValue, bindingName + ": " + value, (view.state & 1 /* BeforeFirstCheck */) !== 0);
                }
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function markParentViewsForCheck(view) {
                /** @type {?} */
                var currView = view;
                while (currView) {
                    if (currView.def.flags & 2 /* OnPush */) {
                        currView.state |= 8 /* ChecksEnabled */;
                    }
                    currView = currView.viewContainerParent || currView.parent;
                }
            }
            /**
             * @param {?} view
             * @param {?} endView
             * @return {?}
             */
            function markParentViewsForCheckProjectedViews(view, endView) {
                /** @type {?} */
                var currView = view;
                while (currView && currView !== endView) {
                    currView.state |= 64 /* CheckProjectedViews */;
                    currView = currView.viewContainerParent || currView.parent;
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeIndex
             * @param {?} eventName
             * @param {?} event
             * @return {?}
             */
            function dispatchEvent(view, nodeIndex, eventName, event) {
                try {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[nodeIndex];
                    /** @type {?} */
                    var startView = nodeDef.flags & 33554432 /* ComponentView */ ?
                        asElementData(view, nodeIndex).componentView :
                        view;
                    markParentViewsForCheck(startView);
                    return Services.handleEvent(view, nodeIndex, eventName, event);
                }
                catch (e) {
                    // Attention: Don't rethrow, as it would cancel Observable subscriptions!
                    view.root.errorHandler.handleError(e);
                }
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function declaredViewContainer(view) {
                if (view.parent) {
                    /** @type {?} */
                    var parentView = view.parent;
                    return asElementData(parentView, ( /** @type {?} */(view.parentNodeDef)).nodeIndex);
                }
                return null;
            }
            /**
             * for component views, this is the host element.
             * for embedded views, this is the index of the parent node
             * that contains the view container.
             * @param {?} view
             * @return {?}
             */
            function viewParentEl(view) {
                /** @type {?} */
                var parentView = view.parent;
                if (parentView) {
                    return ( /** @type {?} */(view.parentNodeDef)).parent;
                }
                else {
                    return null;
                }
            }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function renderNode(view, def) {
                switch (def.flags & 201347067 /* Types */) {
                    case 1 /* TypeElement */:
                        return asElementData(view, def.nodeIndex).renderElement;
                    case 2 /* TypeText */:
                        return asTextData(view, def.nodeIndex).renderText;
                }
            }
            /**
             * @param {?} target
             * @param {?} name
             * @return {?}
             */
            function elementEventFullName(target, name) {
                return target ? target + ":" + name : name;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function isComponentView(view) {
                return !!view.parent && !!(( /** @type {?} */(view.parentNodeDef)).flags & 32768 /* Component */);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function isEmbeddedView(view) {
                return !!view.parent && !(( /** @type {?} */(view.parentNodeDef)).flags & 32768 /* Component */);
            }
            /**
             * @param {?} queryId
             * @return {?}
             */
            function filterQueryId(queryId) {
                return 1 << (queryId % 32);
            }
            /**
             * @param {?} matchedQueriesDsl
             * @return {?}
             */
            function splitMatchedQueriesDsl(matchedQueriesDsl) {
                /** @type {?} */
                var matchedQueries = {};
                /** @type {?} */
                var matchedQueryIds = 0;
                /** @type {?} */
                var references = {};
                if (matchedQueriesDsl) {
                    matchedQueriesDsl.forEach(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var queryId = _c[0], valueType = _c[1];
                        if (typeof queryId === 'number') {
                            matchedQueries[queryId] = valueType;
                            matchedQueryIds |= filterQueryId(queryId);
                        }
                        else {
                            references[queryId] = valueType;
                        }
                    }));
                }
                return { matchedQueries: matchedQueries, references: references, matchedQueryIds: matchedQueryIds };
            }
            /**
             * @param {?} deps
             * @param {?=} sourceName
             * @return {?}
             */
            function splitDepsDsl(deps, sourceName) {
                return deps.map(( /**
                 * @param {?} value
                 * @return {?}
                 */function (/**
                 * @param {?} value
                 * @return {?}
                 */ value) {
                    /** @type {?} */
                    var token;
                    /** @type {?} */
                    var flags;
                    if (Array.isArray(value)) {
                        flags = value[0], token = value[1];
                    }
                    else {
                        flags = 0 /* None */;
                        token = value;
                    }
                    if (token && (typeof token === 'function' || typeof token === 'object') && sourceName) {
                        Object.defineProperty(token, SOURCE, { value: sourceName, configurable: true });
                    }
                    return { flags: flags, token: token, tokenKey: tokenKey(token) };
                }));
            }
            /**
             * @param {?} view
             * @param {?} renderHost
             * @param {?} def
             * @return {?}
             */
            function getParentRenderElement(view, renderHost, def) {
                /** @type {?} */
                var renderParent = def.renderParent;
                if (renderParent) {
                    if ((renderParent.flags & 1 /* TypeElement */) === 0 ||
                        (renderParent.flags & 33554432 /* ComponentView */) === 0 ||
                        (( /** @type {?} */(renderParent.element)).componentRendererType &&
                            ( /** @type {?} */(( /** @type {?} */(renderParent.element)).componentRendererType)).encapsulation ===
                                ViewEncapsulation.Native)) {
                        // only children of non components, or children of components with native encapsulation should
                        // be attached.
                        return asElementData(view, ( /** @type {?} */(def.renderParent)).nodeIndex).renderElement;
                    }
                }
                else {
                    return renderHost;
                }
            }
            /** @type {?} */
            var DEFINITION_CACHE = new WeakMap();
            /**
             * @template D
             * @param {?} factory
             * @return {?}
             */
            function resolveDefinition(factory) {
                /** @type {?} */
                var value = ( /** @type {?} */(( /** @type {?} */(DEFINITION_CACHE.get(factory)))));
                if (!value) {
                    value = factory(( /**
                     * @return {?}
                     */function () { return NOOP; }));
                    value.factory = factory;
                    DEFINITION_CACHE.set(factory, value);
                }
                return value;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function rootRenderNodes(view) {
                /** @type {?} */
                var renderNodes = [];
                visitRootRenderNodes(view, 0 /* Collect */, undefined, undefined, renderNodes);
                return renderNodes;
            }
            /** @enum {number} */
            var RenderNodeAction = {
                Collect: 0, AppendChild: 1, InsertBefore: 2, RemoveChild: 3,
            };
            /**
             * @param {?} view
             * @param {?} action
             * @param {?} parentNode
             * @param {?} nextSibling
             * @param {?=} target
             * @return {?}
             */
            function visitRootRenderNodes(view, action, parentNode, nextSibling, target) {
                // We need to re-compute the parent node in case the nodes have been moved around manually
                if (action === 3 /* RemoveChild */) {
                    parentNode = view.renderer.parentNode(renderNode(view, ( /** @type {?} */(view.def.lastRenderRootNode))));
                }
                visitSiblingRenderNodes(view, action, 0, view.def.nodes.length - 1, parentNode, nextSibling, target);
            }
            /**
             * @param {?} view
             * @param {?} action
             * @param {?} startIndex
             * @param {?} endIndex
             * @param {?} parentNode
             * @param {?} nextSibling
             * @param {?=} target
             * @return {?}
             */
            function visitSiblingRenderNodes(view, action, startIndex, endIndex, parentNode, nextSibling, target) {
                for (var i = startIndex; i <= endIndex; i++) {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[i];
                    if (nodeDef.flags & (1 /* TypeElement */ | 2 /* TypeText */ | 8 /* TypeNgContent */)) {
                        visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target);
                    }
                    // jump to next sibling
                    i += nodeDef.childCount;
                }
            }
            /**
             * @param {?} view
             * @param {?} ngContentIndex
             * @param {?} action
             * @param {?} parentNode
             * @param {?} nextSibling
             * @param {?=} target
             * @return {?}
             */
            function visitProjectedRenderNodes(view, ngContentIndex, action, parentNode, nextSibling, target) {
                /** @type {?} */
                var compView = view;
                while (compView && !isComponentView(compView)) {
                    compView = compView.parent;
                }
                /** @type {?} */
                var hostView = ( /** @type {?} */(compView)).parent;
                /** @type {?} */
                var hostElDef = viewParentEl(( /** @type {?} */(compView)));
                /** @type {?} */
                var startIndex = ( /** @type {?} */(hostElDef)).nodeIndex + 1;
                /** @type {?} */
                var endIndex = ( /** @type {?} */(hostElDef)).nodeIndex + ( /** @type {?} */(hostElDef)).childCount;
                for (var i = startIndex; i <= endIndex; i++) {
                    /** @type {?} */
                    var nodeDef = ( /** @type {?} */(hostView)).def.nodes[i];
                    if (nodeDef.ngContentIndex === ngContentIndex) {
                        visitRenderNode(( /** @type {?} */(hostView)), nodeDef, action, parentNode, nextSibling, target);
                    }
                    // jump to next sibling
                    i += nodeDef.childCount;
                }
                if (!( /** @type {?} */(hostView)).parent) {
                    // a root view
                    /** @type {?} */
                    var projectedNodes = view.root.projectableNodes[ngContentIndex];
                    if (projectedNodes) {
                        for (var i = 0; i < projectedNodes.length; i++) {
                            execRenderNodeAction(view, projectedNodes[i], action, parentNode, nextSibling, target);
                        }
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} action
             * @param {?} parentNode
             * @param {?} nextSibling
             * @param {?=} target
             * @return {?}
             */
            function visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target) {
                if (nodeDef.flags & 8 /* TypeNgContent */) {
                    visitProjectedRenderNodes(view, ( /** @type {?} */(nodeDef.ngContent)).index, action, parentNode, nextSibling, target);
                }
                else {
                    /** @type {?} */
                    var rn = renderNode(view, nodeDef);
                    if (action === 3 /* RemoveChild */ && (nodeDef.flags & 33554432 /* ComponentView */) &&
                        (nodeDef.bindingFlags & 48 /* CatSyntheticProperty */)) {
                        // Note: we might need to do both actions.
                        if (nodeDef.bindingFlags & (16 /* SyntheticProperty */)) {
                            execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
                        }
                        if (nodeDef.bindingFlags & (32 /* SyntheticHostProperty */)) {
                            /** @type {?} */
                            var compView = asElementData(view, nodeDef.nodeIndex).componentView;
                            execRenderNodeAction(compView, rn, action, parentNode, nextSibling, target);
                        }
                    }
                    else {
                        execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
                    }
                    if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
                        /** @type {?} */
                        var embeddedViews = ( /** @type {?} */(asElementData(view, nodeDef.nodeIndex).viewContainer))._embeddedViews;
                        for (var k = 0; k < embeddedViews.length; k++) {
                            visitRootRenderNodes(embeddedViews[k], action, parentNode, nextSibling, target);
                        }
                    }
                    if (nodeDef.flags & 1 /* TypeElement */ && !( /** @type {?} */(nodeDef.element)).name) {
                        visitSiblingRenderNodes(view, action, nodeDef.nodeIndex + 1, nodeDef.nodeIndex + nodeDef.childCount, parentNode, nextSibling, target);
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} renderNode
             * @param {?} action
             * @param {?} parentNode
             * @param {?} nextSibling
             * @param {?=} target
             * @return {?}
             */
            function execRenderNodeAction(view, renderNode, action, parentNode, nextSibling, target) {
                /** @type {?} */
                var renderer = view.renderer;
                switch (action) {
                    case 1 /* AppendChild */:
                        renderer.appendChild(parentNode, renderNode);
                        break;
                    case 2 /* InsertBefore */:
                        renderer.insertBefore(parentNode, renderNode, nextSibling);
                        break;
                    case 3 /* RemoveChild */:
                        renderer.removeChild(parentNode, renderNode);
                        break;
                    case 0 /* Collect */:
                        ( /** @type {?} */(target)).push(renderNode);
                        break;
                }
            }
            /** @type {?} */
            var NS_PREFIX_RE = /^:([^:]+):(.+)$/;
            /**
             * @param {?} name
             * @return {?}
             */
            function splitNamespace(name) {
                if (name[0] === ':') {
                    /** @type {?} */
                    var match = ( /** @type {?} */(name.match(NS_PREFIX_RE)));
                    return [match[1], match[2]];
                }
                return ['', name];
            }
            /**
             * @param {?} bindings
             * @return {?}
             */
            function calcBindingFlags(bindings) {
                /** @type {?} */
                var flags = 0;
                for (var i = 0; i < bindings.length; i++) {
                    flags |= bindings[i].flags;
                }
                return flags;
            }
            /**
             * @param {?} valueCount
             * @param {?} constAndInterp
             * @return {?}
             */
            function interpolate(valueCount, constAndInterp) {
                /** @type {?} */
                var result = '';
                for (var i = 0; i < valueCount * 2; i = i + 2) {
                    result = result + constAndInterp[i] + _toStringWithNull(constAndInterp[i + 1]);
                }
                return result + constAndInterp[valueCount * 2];
            }
            /**
             * @param {?} valueCount
             * @param {?} c0
             * @param {?} a1
             * @param {?} c1
             * @param {?=} a2
             * @param {?=} c2
             * @param {?=} a3
             * @param {?=} c3
             * @param {?=} a4
             * @param {?=} c4
             * @param {?=} a5
             * @param {?=} c5
             * @param {?=} a6
             * @param {?=} c6
             * @param {?=} a7
             * @param {?=} c7
             * @param {?=} a8
             * @param {?=} c8
             * @param {?=} a9
             * @param {?=} c9
             * @return {?}
             */
            function inlineInterpolate(valueCount, c0, a1, c1, a2, c2, a3, c3, a4, c4, a5, c5, a6, c6, a7, c7, a8, c8, a9, c9) {
                switch (valueCount) {
                    case 1:
                        return c0 + _toStringWithNull(a1) + c1;
                    case 2:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2;
                    case 3:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3;
                    case 4:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3 + _toStringWithNull(a4) + c4;
                    case 5:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5;
                    case 6:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) + c6;
                    case 7:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                            c6 + _toStringWithNull(a7) + c7;
                    case 8:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                            c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8;
                    case 9:
                        return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                            c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                            c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8 + _toStringWithNull(a9) + c9;
                    default:
                        throw new Error("Does not support more than 9 expressions");
                }
            }
            /**
             * @param {?} v
             * @return {?}
             */
            function _toStringWithNull(v) {
                return v != null ? v.toString() : '';
            }
            /** @type {?} */
            var EMPTY_ARRAY$3 = [];
            /** @type {?} */
            var EMPTY_MAP = {};
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var UNDEFINED_VALUE = new Object();
            /** @type {?} */
            var InjectorRefTokenKey = tokenKey(Injector);
            /** @type {?} */
            var INJECTORRefTokenKey = tokenKey(INJECTOR);
            /** @type {?} */
            var NgModuleRefTokenKey = tokenKey(NgModuleRef);
            /**
             * @param {?} flags
             * @param {?} token
             * @param {?} value
             * @param {?} deps
             * @return {?}
             */
            function moduleProvideDef(flags, token, value, deps) {
                // Need to resolve forwardRefs as e.g. for `useValue` we
                // lowered the expression and then stopped evaluating it,
                // i.e. also didn't unwrap it.
                value = resolveForwardRef(value);
                /** @type {?} */
                var depDefs = splitDepsDsl(deps, stringify(token));
                return {
                    // will bet set by the module definition
                    index: -1,
                    deps: depDefs, flags: flags, token: token, value: value
                };
            }
            /**
             * @param {?} providers
             * @return {?}
             */
            function moduleDef(providers) {
                /** @type {?} */
                var providersByKey = {};
                /** @type {?} */
                var modules = [];
                /** @type {?} */
                var isRoot = false;
                for (var i = 0; i < providers.length; i++) {
                    /** @type {?} */
                    var provider = providers[i];
                    if (provider.token === APP_ROOT && provider.value === true) {
                        isRoot = true;
                    }
                    if (provider.flags & 1073741824 /* TypeNgModule */) {
                        modules.push(provider.token);
                    }
                    provider.index = i;
                    providersByKey[tokenKey(provider.token)] = provider;
                }
                return {
                    // Will be filled later...
                    factory: null,
                    providersByKey: providersByKey,
                    providers: providers,
                    modules: modules,
                    isRoot: isRoot,
                };
            }
            /**
             * @param {?} data
             * @return {?}
             */
            function initNgModule(data) {
                /** @type {?} */
                var def = data._def;
                /** @type {?} */
                var providers = data._providers = new Array(def.providers.length);
                for (var i = 0; i < def.providers.length; i++) {
                    /** @type {?} */
                    var provDef = def.providers[i];
                    if (!(provDef.flags & 4096 /* LazyProvider */)) {
                        // Make sure the provider has not been already initialized outside this loop.
                        if (providers[i] === undefined) {
                            providers[i] = _createProviderInstance(data, provDef);
                        }
                    }
                }
            }
            /**
             * @param {?} data
             * @param {?} depDef
             * @param {?=} notFoundValue
             * @return {?}
             */
            function resolveNgModuleDep(data, depDef, notFoundValue) {
                if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
                /** @type {?} */
                var former = setCurrentInjector(data);
                try {
                    if (depDef.flags & 8 /* Value */) {
                        return depDef.token;
                    }
                    if (depDef.flags & 2 /* Optional */) {
                        notFoundValue = null;
                    }
                    if (depDef.flags & 1 /* SkipSelf */) {
                        return data._parent.get(depDef.token, notFoundValue);
                    }
                    /** @type {?} */
                    var tokenKey_1 = depDef.tokenKey;
                    switch (tokenKey_1) {
                        case InjectorRefTokenKey:
                        case INJECTORRefTokenKey:
                        case NgModuleRefTokenKey:
                            return data;
                    }
                    /** @type {?} */
                    var providerDef_1 = data._def.providersByKey[tokenKey_1];
                    /** @type {?} */
                    var injectableDef = void 0;
                    if (providerDef_1) {
                        /** @type {?} */
                        var providerInstance = data._providers[providerDef_1.index];
                        if (providerInstance === undefined) {
                            providerInstance = data._providers[providerDef_1.index] =
                                _createProviderInstance(data, providerDef_1);
                        }
                        return providerInstance === UNDEFINED_VALUE ? undefined : providerInstance;
                    }
                    else if ((injectableDef = getInjectableDef(depDef.token)) && targetsModule(data, injectableDef)) {
                        /** @type {?} */
                        var index = data._providers.length;
                        data._def.providers[index] = data._def.providersByKey[depDef.tokenKey] = {
                            flags: 1024 /* TypeFactoryProvider */ | 4096 /* LazyProvider */,
                            value: injectableDef.factory,
                            deps: [], index: index,
                            token: depDef.token,
                        };
                        data._providers[index] = UNDEFINED_VALUE;
                        return (data._providers[index] =
                            _createProviderInstance(data, data._def.providersByKey[depDef.tokenKey]));
                    }
                    else if (depDef.flags & 4 /* Self */) {
                        return notFoundValue;
                    }
                    return data._parent.get(depDef.token, notFoundValue);
                }
                finally {
                    setCurrentInjector(former);
                }
            }
            /**
             * @param {?} ngModule
             * @param {?} scope
             * @return {?}
             */
            function moduleTransitivelyPresent(ngModule, scope) {
                return ngModule._def.modules.indexOf(scope) > -1;
            }
            /**
             * @param {?} ngModule
             * @param {?} def
             * @return {?}
             */
            function targetsModule(ngModule, def) {
                return def.providedIn != null && (moduleTransitivelyPresent(ngModule, def.providedIn) ||
                    def.providedIn === 'root' && ngModule._def.isRoot);
            }
            /**
             * @param {?} ngModule
             * @param {?} providerDef
             * @return {?}
             */
            function _createProviderInstance(ngModule, providerDef) {
                /** @type {?} */
                var injectable;
                switch (providerDef.flags & 201347067 /* Types */) {
                    case 512 /* TypeClassProvider */:
                        injectable = _createClass(ngModule, providerDef.value, providerDef.deps);
                        break;
                    case 1024 /* TypeFactoryProvider */:
                        injectable = _callFactory(ngModule, providerDef.value, providerDef.deps);
                        break;
                    case 2048 /* TypeUseExistingProvider */:
                        injectable = resolveNgModuleDep(ngModule, providerDef.deps[0]);
                        break;
                    case 256 /* TypeValueProvider */:
                        injectable = providerDef.value;
                        break;
                }
                // The read of `ngOnDestroy` here is slightly expensive as it's megamorphic, so it should be
                // avoided if possible. The sequence of checks here determines whether ngOnDestroy needs to be
                // checked. It might not if the `injectable` isn't an object or if NodeFlags.OnDestroy is already
                // set (ngOnDestroy was detected statically).
                if (injectable !== UNDEFINED_VALUE && injectable !== null && typeof injectable === 'object' &&
                    !(providerDef.flags & 131072 /* OnDestroy */) && typeof injectable.ngOnDestroy === 'function') {
                    providerDef.flags |= 131072 /* OnDestroy */;
                }
                return injectable === undefined ? UNDEFINED_VALUE : injectable;
            }
            /**
             * @param {?} ngModule
             * @param {?} ctor
             * @param {?} deps
             * @return {?}
             */
            function _createClass(ngModule, ctor, deps) {
                /** @type {?} */
                var len = deps.length;
                switch (len) {
                    case 0:
                        return new ctor();
                    case 1:
                        return new ctor(resolveNgModuleDep(ngModule, deps[0]));
                    case 2:
                        return new ctor(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]));
                    case 3:
                        return new ctor(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]), resolveNgModuleDep(ngModule, deps[2]));
                    default:
                        /** @type {?} */
                        var depValues = new Array(len);
                        for (var i = 0; i < len; i++) {
                            depValues[i] = resolveNgModuleDep(ngModule, deps[i]);
                        }
                        return new (ctor.bind.apply(ctor, [void 0].concat(depValues)))();
                }
            }
            /**
             * @param {?} ngModule
             * @param {?} factory
             * @param {?} deps
             * @return {?}
             */
            function _callFactory(ngModule, factory, deps) {
                /** @type {?} */
                var len = deps.length;
                switch (len) {
                    case 0:
                        return factory();
                    case 1:
                        return factory(resolveNgModuleDep(ngModule, deps[0]));
                    case 2:
                        return factory(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]));
                    case 3:
                        return factory(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]), resolveNgModuleDep(ngModule, deps[2]));
                    default:
                        /** @type {?} */
                        var depValues = Array(len);
                        for (var i = 0; i < len; i++) {
                            depValues[i] = resolveNgModuleDep(ngModule, deps[i]);
                        }
                        return factory.apply(void 0, depValues);
                }
            }
            /**
             * @param {?} ngModule
             * @param {?} lifecycles
             * @return {?}
             */
            function callNgModuleLifecycle(ngModule, lifecycles) {
                /** @type {?} */
                var def = ngModule._def;
                /** @type {?} */
                var destroyed = new Set();
                for (var i = 0; i < def.providers.length; i++) {
                    /** @type {?} */
                    var provDef = def.providers[i];
                    if (provDef.flags & 131072 /* OnDestroy */) {
                        /** @type {?} */
                        var instance = ngModule._providers[i];
                        if (instance && instance !== UNDEFINED_VALUE) {
                            /** @type {?} */
                            var onDestroy = instance.ngOnDestroy;
                            if (typeof onDestroy === 'function' && !destroyed.has(instance)) {
                                onDestroy.apply(instance);
                                destroyed.add(instance);
                            }
                        }
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} parentView
             * @param {?} elementData
             * @param {?} viewIndex
             * @param {?} view
             * @return {?}
             */
            function attachEmbeddedView(parentView, elementData, viewIndex, view) {
                /** @type {?} */
                var embeddedViews = ( /** @type {?} */(elementData.viewContainer))._embeddedViews;
                if (viewIndex === null || viewIndex === undefined) {
                    viewIndex = embeddedViews.length;
                }
                view.viewContainerParent = parentView;
                addToArray(embeddedViews, ( /** @type {?} */(viewIndex)), view);
                attachProjectedView(elementData, view);
                Services.dirtyParentQueries(view);
                /** @type {?} */
                var prevView = ( /** @type {?} */(viewIndex)) > 0 ? embeddedViews[( /** @type {?} */(viewIndex)) - 1] : null;
                renderAttachEmbeddedView(elementData, prevView, view);
            }
            /**
             * @param {?} vcElementData
             * @param {?} view
             * @return {?}
             */
            function attachProjectedView(vcElementData, view) {
                /** @type {?} */
                var dvcElementData = declaredViewContainer(view);
                if (!dvcElementData || dvcElementData === vcElementData ||
                    view.state & 16 /* IsProjectedView */) {
                    return;
                }
                // Note: For performance reasons, we
                // - add a view to template._projectedViews only 1x throughout its lifetime,
                //   and remove it not until the view is destroyed.
                //   (hard, as when a parent view is attached/detached we would need to attach/detach all
                //    nested projected views as well, even across component boundaries).
                // - don't track the insertion order of views in the projected views array
                //   (hard, as when the views of the same template are inserted different view containers)
                view.state |= 16 /* IsProjectedView */;
                /** @type {?} */
                var projectedViews = dvcElementData.template._projectedViews;
                if (!projectedViews) {
                    projectedViews = dvcElementData.template._projectedViews = [];
                }
                projectedViews.push(view);
                // Note: we are changing the NodeDef here as we cannot calculate
                // the fact whether a template is used for projection during compilation.
                markNodeAsProjectedTemplate(( /** @type {?} */(view.parent)).def, ( /** @type {?} */(view.parentNodeDef)));
            }
            /**
             * @param {?} viewDef
             * @param {?} nodeDef
             * @return {?}
             */
            function markNodeAsProjectedTemplate(viewDef, nodeDef) {
                if (nodeDef.flags & 4 /* ProjectedTemplate */) {
                    return;
                }
                viewDef.nodeFlags |= 4 /* ProjectedTemplate */;
                nodeDef.flags |= 4 /* ProjectedTemplate */;
                /** @type {?} */
                var parentNodeDef = nodeDef.parent;
                while (parentNodeDef) {
                    parentNodeDef.childFlags |= 4 /* ProjectedTemplate */;
                    parentNodeDef = parentNodeDef.parent;
                }
            }
            /**
             * @param {?} elementData
             * @param {?=} viewIndex
             * @return {?}
             */
            function detachEmbeddedView(elementData, viewIndex) {
                /** @type {?} */
                var embeddedViews = ( /** @type {?} */(elementData.viewContainer))._embeddedViews;
                if (viewIndex == null || viewIndex >= embeddedViews.length) {
                    viewIndex = embeddedViews.length - 1;
                }
                if (viewIndex < 0) {
                    return null;
                }
                /** @type {?} */
                var view = embeddedViews[viewIndex];
                view.viewContainerParent = null;
                removeFromArray(embeddedViews, viewIndex);
                // See attachProjectedView for why we don't update projectedViews here.
                Services.dirtyParentQueries(view);
                renderDetachView$1(view);
                return view;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function detachProjectedView(view) {
                if (!(view.state & 16 /* IsProjectedView */)) {
                    return;
                }
                /** @type {?} */
                var dvcElementData = declaredViewContainer(view);
                if (dvcElementData) {
                    /** @type {?} */
                    var projectedViews = dvcElementData.template._projectedViews;
                    if (projectedViews) {
                        removeFromArray(projectedViews, projectedViews.indexOf(view));
                        Services.dirtyParentQueries(view);
                    }
                }
            }
            /**
             * @param {?} elementData
             * @param {?} oldViewIndex
             * @param {?} newViewIndex
             * @return {?}
             */
            function moveEmbeddedView(elementData, oldViewIndex, newViewIndex) {
                /** @type {?} */
                var embeddedViews = ( /** @type {?} */(elementData.viewContainer))._embeddedViews;
                /** @type {?} */
                var view = embeddedViews[oldViewIndex];
                removeFromArray(embeddedViews, oldViewIndex);
                if (newViewIndex == null) {
                    newViewIndex = embeddedViews.length;
                }
                addToArray(embeddedViews, newViewIndex, view);
                // Note: Don't need to change projectedViews as the order in there
                // as always invalid...
                Services.dirtyParentQueries(view);
                renderDetachView$1(view);
                /** @type {?} */
                var prevView = newViewIndex > 0 ? embeddedViews[newViewIndex - 1] : null;
                renderAttachEmbeddedView(elementData, prevView, view);
                return view;
            }
            /**
             * @param {?} elementData
             * @param {?} prevView
             * @param {?} view
             * @return {?}
             */
            function renderAttachEmbeddedView(elementData, prevView, view) {
                /** @type {?} */
                var prevRenderNode = prevView ? renderNode(prevView, ( /** @type {?} */(prevView.def.lastRenderRootNode))) :
                    elementData.renderElement;
                /** @type {?} */
                var parentNode = view.renderer.parentNode(prevRenderNode);
                /** @type {?} */
                var nextSibling = view.renderer.nextSibling(prevRenderNode);
                // Note: We can't check if `nextSibling` is present, as on WebWorkers it will always be!
                // However, browsers automatically do `appendChild` when there is no `nextSibling`.
                visitRootRenderNodes(view, 2 /* InsertBefore */, parentNode, nextSibling, undefined);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function renderDetachView$1(view) {
                visitRootRenderNodes(view, 3 /* RemoveChild */, null, null, undefined);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EMPTY_CONTEXT = new Object();
            // Attention: this function is called as top level function.
            // Putting any logic in here will destroy closure tree shaking!
            /**
             * @param {?} selector
             * @param {?} componentType
             * @param {?} viewDefFactory
             * @param {?} inputs
             * @param {?} outputs
             * @param {?} ngContentSelectors
             * @return {?}
             */
            function createComponentFactory(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors) {
                return new ComponentFactory_(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors);
            }
            /**
             * @param {?} componentFactory
             * @return {?}
             */
            function getComponentViewDefinitionFactory(componentFactory) {
                return (( /** @type {?} */(componentFactory))).viewDefFactory;
            }
            var ComponentFactory_ = /** @class */ (function (_super_1) {
                __extends(ComponentFactory_, _super_1);
                /**
                 * @param {?} selector
                 * @param {?} componentType
                 * @param {?} viewDefFactory
                 * @param {?} _inputs
                 * @param {?} _outputs
                 * @param {?} ngContentSelectors
                 */
                function ComponentFactory_(selector, componentType, viewDefFactory, _inputs, _outputs, ngContentSelectors) {
                    var _this = 
                    // Attention: this ctor is called as top level function.
                    // Putting any logic in here will destroy closure tree shaking!
                    _super_1.call(this) || this;
                    _this.selector = selector;
                    _this.componentType = componentType;
                    _this._inputs = _inputs;
                    _this._outputs = _outputs;
                    _this.ngContentSelectors = ngContentSelectors;
                    _this.viewDefFactory = viewDefFactory;
                    return _this;
                }
                Object.defineProperty(ComponentFactory_.prototype, "inputs", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var inputsArr = [];
                        /** @type {?} */
                        var inputs = ( /** @type {?} */(this._inputs));
                        for (var propName in inputs) {
                            /** @type {?} */
                            var templateName = inputs[propName];
                            inputsArr.push({ propName: propName, templateName: templateName });
                        }
                        return inputsArr;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ComponentFactory_.prototype, "outputs", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var outputsArr = [];
                        for (var propName in this._outputs) {
                            /** @type {?} */
                            var templateName = this._outputs[propName];
                            outputsArr.push({ propName: propName, templateName: templateName });
                        }
                        return outputsArr;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Creates a new component.
                 * @param {?} injector
                 * @param {?=} projectableNodes
                 * @param {?=} rootSelectorOrNode
                 * @param {?=} ngModule
                 * @return {?}
                 */
                ComponentFactory_.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
                    if (!ngModule) {
                        throw new Error('ngModule should be provided');
                    }
                    /** @type {?} */
                    var viewDef = resolveDefinition(this.viewDefFactory);
                    /** @type {?} */
                    var componentNodeIndex = ( /** @type {?} */(( /** @type {?} */(viewDef.nodes[0].element)).componentProvider)).nodeIndex;
                    /** @type {?} */
                    var view = Services.createRootView(injector, projectableNodes || [], rootSelectorOrNode, viewDef, ngModule, EMPTY_CONTEXT);
                    /** @type {?} */
                    var component = asProviderData(view, componentNodeIndex).instance;
                    if (rootSelectorOrNode) {
                        view.renderer.setAttribute(asElementData(view, 0).renderElement, 'ng-version', VERSION.full);
                    }
                    return new ComponentRef_(view, new ViewRef_(view), component);
                };
                return ComponentFactory_;
            }(ComponentFactory));
            if (false) { }
            var ComponentRef_ = /** @class */ (function (_super_1) {
                __extends(ComponentRef_, _super_1);
                /**
                 * @param {?} _view
                 * @param {?} _viewRef
                 * @param {?} _component
                 */
                function ComponentRef_(_view, _viewRef, _component) {
                    var _this = _super_1.call(this) || this;
                    _this._view = _view;
                    _this._viewRef = _viewRef;
                    _this._component = _component;
                    _this._elDef = _this._view.def.nodes[0];
                    _this.hostView = _viewRef;
                    _this.changeDetectorRef = _viewRef;
                    _this.instance = _component;
                    return _this;
                }
                Object.defineProperty(ComponentRef_.prototype, "location", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return new ElementRef(asElementData(this._view, this._elDef.nodeIndex).renderElement);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ComponentRef_.prototype, "injector", {
                    /**
                     * @return {?}
                     */
                    get: function () { return new Injector_(this._view, this._elDef); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ComponentRef_.prototype, "componentType", {
                    /**
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(this._component.constructor)); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ComponentRef_.prototype.destroy = function () { this._viewRef.destroy(); };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                ComponentRef_.prototype.onDestroy = function (callback) { this._viewRef.onDestroy(callback); };
                return ComponentRef_;
            }(ComponentRef));
            if (false) { }
            /**
             * @param {?} view
             * @param {?} elDef
             * @param {?} elData
             * @return {?}
             */
            function createViewContainerData(view, elDef, elData) {
                return new ViewContainerRef_(view, elDef, elData);
            }
            var ViewContainerRef_ = /** @class */ (function () {
                /**
                 * @param {?} _view
                 * @param {?} _elDef
                 * @param {?} _data
                 */
                function ViewContainerRef_(_view, _elDef, _data) {
                    this._view = _view;
                    this._elDef = _elDef;
                    this._data = _data;
                    /**
                     * \@internal
                     */
                    this._embeddedViews = [];
                }
                Object.defineProperty(ViewContainerRef_.prototype, "element", {
                    /**
                     * @return {?}
                     */
                    get: function () { return new ElementRef(this._data.renderElement); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ViewContainerRef_.prototype, "injector", {
                    /**
                     * @return {?}
                     */
                    get: function () { return new Injector_(this._view, this._elDef); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ViewContainerRef_.prototype, "parentInjector", {
                    /**
                     * @deprecated No replacement
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var view = this._view;
                        /** @type {?} */
                        var elDef = this._elDef.parent;
                        while (!elDef && view) {
                            elDef = viewParentEl(view);
                            view = ( /** @type {?} */(view.parent));
                        }
                        return view ? new Injector_(view, elDef) : new Injector_(this._view, null);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ViewContainerRef_.prototype.clear = function () {
                    /** @type {?} */
                    var len = this._embeddedViews.length;
                    for (var i = len - 1; i >= 0; i--) {
                        /** @type {?} */
                        var view = ( /** @type {?} */(detachEmbeddedView(this._data, i)));
                        Services.destroyView(view);
                    }
                };
                /**
                 * @param {?} index
                 * @return {?}
                 */
                ViewContainerRef_.prototype.get = function (index) {
                    /** @type {?} */
                    var view = this._embeddedViews[index];
                    if (view) {
                        /** @type {?} */
                        var ref = new ViewRef_(view);
                        ref.attachToViewContainerRef(this);
                        return ref;
                    }
                    return null;
                };
                Object.defineProperty(ViewContainerRef_.prototype, "length", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._embeddedViews.length; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @template C
                 * @param {?} templateRef
                 * @param {?=} context
                 * @param {?=} index
                 * @return {?}
                 */
                ViewContainerRef_.prototype.createEmbeddedView = function (templateRef, context, index) {
                    /** @type {?} */
                    var viewRef = templateRef.createEmbeddedView(context || ( /** @type {?} */({})));
                    this.insert(viewRef, index);
                    return viewRef;
                };
                /**
                 * @template C
                 * @param {?} componentFactory
                 * @param {?=} index
                 * @param {?=} injector
                 * @param {?=} projectableNodes
                 * @param {?=} ngModuleRef
                 * @return {?}
                 */
                ViewContainerRef_.prototype.createComponent = function (componentFactory, index, injector, projectableNodes, ngModuleRef) {
                    /** @type {?} */
                    var contextInjector = injector || this.parentInjector;
                    if (!ngModuleRef && !(componentFactory instanceof ComponentFactoryBoundToModule)) {
                        ngModuleRef = contextInjector.get(NgModuleRef);
                    }
                    /** @type {?} */
                    var componentRef = componentFactory.create(contextInjector, projectableNodes, undefined, ngModuleRef);
                    this.insert(componentRef.hostView, index);
                    return componentRef;
                };
                /**
                 * @param {?} viewRef
                 * @param {?=} index
                 * @return {?}
                 */
                ViewContainerRef_.prototype.insert = function (viewRef, index) {
                    if (viewRef.destroyed) {
                        throw new Error('Cannot insert a destroyed View in a ViewContainer!');
                    }
                    /** @type {?} */
                    var viewRef_ = ( /** @type {?} */(viewRef));
                    /** @type {?} */
                    var viewData = viewRef_._view;
                    attachEmbeddedView(this._view, this._data, index, viewData);
                    viewRef_.attachToViewContainerRef(this);
                    return viewRef;
                };
                /**
                 * @param {?} viewRef
                 * @param {?} currentIndex
                 * @return {?}
                 */
                ViewContainerRef_.prototype.move = function (viewRef, currentIndex) {
                    if (viewRef.destroyed) {
                        throw new Error('Cannot move a destroyed View in a ViewContainer!');
                    }
                    /** @type {?} */
                    var previousIndex = this._embeddedViews.indexOf(viewRef._view);
                    moveEmbeddedView(this._data, previousIndex, currentIndex);
                    return viewRef;
                };
                /**
                 * @param {?} viewRef
                 * @return {?}
                 */
                ViewContainerRef_.prototype.indexOf = function (viewRef) {
                    return this._embeddedViews.indexOf((( /** @type {?} */(viewRef)))._view);
                };
                /**
                 * @param {?=} index
                 * @return {?}
                 */
                ViewContainerRef_.prototype.remove = function (index) {
                    /** @type {?} */
                    var viewData = detachEmbeddedView(this._data, index);
                    if (viewData) {
                        Services.destroyView(viewData);
                    }
                };
                /**
                 * @param {?=} index
                 * @return {?}
                 */
                ViewContainerRef_.prototype.detach = function (index) {
                    /** @type {?} */
                    var view = detachEmbeddedView(this._data, index);
                    return view ? new ViewRef_(view) : null;
                };
                return ViewContainerRef_;
            }());
            if (false) { }
            /**
             * @param {?} view
             * @return {?}
             */
            function createChangeDetectorRef(view) {
                return new ViewRef_(view);
            }
            var ViewRef_ = /** @class */ (function () {
                /**
                 * @param {?} _view
                 */
                function ViewRef_(_view) {
                    this._view = _view;
                    this._viewContainerRef = null;
                    this._appRef = null;
                }
                Object.defineProperty(ViewRef_.prototype, "rootNodes", {
                    /**
                     * @return {?}
                     */
                    get: function () { return rootRenderNodes(this._view); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ViewRef_.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._view.context; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ViewRef_.prototype, "destroyed", {
                    /**
                     * @return {?}
                     */
                    get: function () { return (this._view.state & 128 /* Destroyed */) !== 0; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.markForCheck = function () { markParentViewsForCheck(this._view); };
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.detach = function () { this._view.state &= ~4 /* Attached */; };
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.detectChanges = function () {
                    /** @type {?} */
                    var fs = this._view.root.rendererFactory;
                    if (fs.begin) {
                        fs.begin();
                    }
                    try {
                        Services.checkAndUpdateView(this._view);
                    }
                    finally {
                        if (fs.end) {
                            fs.end();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.checkNoChanges = function () { Services.checkNoChangesView(this._view); };
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.reattach = function () { this._view.state |= 4 /* Attached */; };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                ViewRef_.prototype.onDestroy = function (callback) {
                    if (!this._view.disposables) {
                        this._view.disposables = [];
                    }
                    this._view.disposables.push(( /** @type {?} */(callback)));
                };
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.destroy = function () {
                    if (this._appRef) {
                        this._appRef.detachView(this);
                    }
                    else if (this._viewContainerRef) {
                        this._viewContainerRef.detach(this._viewContainerRef.indexOf(this));
                    }
                    Services.destroyView(this._view);
                };
                /**
                 * @return {?}
                 */
                ViewRef_.prototype.detachFromAppRef = function () {
                    this._appRef = null;
                    renderDetachView$1(this._view);
                    Services.dirtyParentQueries(this._view);
                };
                /**
                 * @param {?} appRef
                 * @return {?}
                 */
                ViewRef_.prototype.attachToAppRef = function (appRef) {
                    if (this._viewContainerRef) {
                        throw new Error('This view is already attached to a ViewContainer!');
                    }
                    this._appRef = appRef;
                };
                /**
                 * @param {?} vcRef
                 * @return {?}
                 */
                ViewRef_.prototype.attachToViewContainerRef = function (vcRef) {
                    if (this._appRef) {
                        throw new Error('This view is already attached directly to the ApplicationRef!');
                    }
                    this._viewContainerRef = vcRef;
                };
                return ViewRef_;
            }());
            if (false) { }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function createTemplateData(view, def) {
                return new TemplateRef_(view, def);
            }
            var TemplateRef_ = /** @class */ (function (_super_1) {
                __extends(TemplateRef_, _super_1);
                /**
                 * @param {?} _parentView
                 * @param {?} _def
                 */
                function TemplateRef_(_parentView, _def) {
                    var _this = _super_1.call(this) || this;
                    _this._parentView = _parentView;
                    _this._def = _def;
                    return _this;
                }
                /**
                 * @param {?} context
                 * @return {?}
                 */
                TemplateRef_.prototype.createEmbeddedView = function (context) {
                    return new ViewRef_(Services.createEmbeddedView(this._parentView, this._def, ( /** @type {?} */(( /** @type {?} */(this._def.element)).template)), context));
                };
                Object.defineProperty(TemplateRef_.prototype, "elementRef", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return new ElementRef(asElementData(this._parentView, this._def.nodeIndex).renderElement);
                    },
                    enumerable: true,
                    configurable: true
                });
                return TemplateRef_;
            }(TemplateRef));
            if (false) { }
            /**
             * @param {?} view
             * @param {?} elDef
             * @return {?}
             */
            function createInjector$1(view, elDef) {
                return new Injector_(view, elDef);
            }
            var Injector_ = /** @class */ (function () {
                /**
                 * @param {?} view
                 * @param {?} elDef
                 */
                function Injector_(view, elDef) {
                    this.view = view;
                    this.elDef = elDef;
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @return {?}
                 */
                Injector_.prototype.get = function (token, notFoundValue) {
                    if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
                    /** @type {?} */
                    var allowPrivateServices = this.elDef ? (this.elDef.flags & 33554432 /* ComponentView */) !== 0 : false;
                    return Services.resolveDep(this.view, this.elDef, allowPrivateServices, { flags: 0 /* None */, token: token, tokenKey: tokenKey(token) }, notFoundValue);
                };
                return Injector_;
            }());
            if (false) { }
            /**
             * @param {?} view
             * @param {?} index
             * @return {?}
             */
            function nodeValue(view, index) {
                /** @type {?} */
                var def = view.def.nodes[index];
                if (def.flags & 1 /* TypeElement */) {
                    /** @type {?} */
                    var elData = asElementData(view, def.nodeIndex);
                    return ( /** @type {?} */(def.element)).template ? elData.template : elData.renderElement;
                }
                else if (def.flags & 2 /* TypeText */) {
                    return asTextData(view, def.nodeIndex).renderText;
                }
                else if (def.flags & (20224 /* CatProvider */ | 16 /* TypePipe */)) {
                    return asProviderData(view, def.nodeIndex).instance;
                }
                throw new Error("Illegal state: read nodeValue for node index " + index);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function createRendererV1(view) {
                return new RendererAdapter(view.renderer);
            }
            var RendererAdapter = /** @class */ (function () {
                /**
                 * @param {?} delegate
                 */
                function RendererAdapter(delegate) {
                    this.delegate = delegate;
                }
                /**
                 * @param {?} selectorOrNode
                 * @return {?}
                 */
                RendererAdapter.prototype.selectRootElement = function (selectorOrNode) {
                    return this.delegate.selectRootElement(selectorOrNode);
                };
                /**
                 * @param {?} parent
                 * @param {?} namespaceAndName
                 * @return {?}
                 */
                RendererAdapter.prototype.createElement = function (parent, namespaceAndName) {
                    var _c = splitNamespace(namespaceAndName), ns = _c[0], name = _c[1];
                    /** @type {?} */
                    var el = this.delegate.createElement(name, ns);
                    if (parent) {
                        this.delegate.appendChild(parent, el);
                    }
                    return el;
                };
                /**
                 * @param {?} hostElement
                 * @return {?}
                 */
                RendererAdapter.prototype.createViewRoot = function (hostElement) { return hostElement; };
                /**
                 * @param {?} parentElement
                 * @return {?}
                 */
                RendererAdapter.prototype.createTemplateAnchor = function (parentElement) {
                    /** @type {?} */
                    var comment = this.delegate.createComment('');
                    if (parentElement) {
                        this.delegate.appendChild(parentElement, comment);
                    }
                    return comment;
                };
                /**
                 * @param {?} parentElement
                 * @param {?} value
                 * @return {?}
                 */
                RendererAdapter.prototype.createText = function (parentElement, value) {
                    /** @type {?} */
                    var node = this.delegate.createText(value);
                    if (parentElement) {
                        this.delegate.appendChild(parentElement, node);
                    }
                    return node;
                };
                /**
                 * @param {?} parentElement
                 * @param {?} nodes
                 * @return {?}
                 */
                RendererAdapter.prototype.projectNodes = function (parentElement, nodes) {
                    for (var i = 0; i < nodes.length; i++) {
                        this.delegate.appendChild(parentElement, nodes[i]);
                    }
                };
                /**
                 * @param {?} node
                 * @param {?} viewRootNodes
                 * @return {?}
                 */
                RendererAdapter.prototype.attachViewAfter = function (node, viewRootNodes) {
                    /** @type {?} */
                    var parentElement = this.delegate.parentNode(node);
                    /** @type {?} */
                    var nextSibling = this.delegate.nextSibling(node);
                    for (var i = 0; i < viewRootNodes.length; i++) {
                        this.delegate.insertBefore(parentElement, viewRootNodes[i], nextSibling);
                    }
                };
                /**
                 * @param {?} viewRootNodes
                 * @return {?}
                 */
                RendererAdapter.prototype.detachView = function (viewRootNodes) {
                    for (var i = 0; i < viewRootNodes.length; i++) {
                        /** @type {?} */
                        var node = viewRootNodes[i];
                        /** @type {?} */
                        var parentElement = this.delegate.parentNode(node);
                        this.delegate.removeChild(parentElement, node);
                    }
                };
                /**
                 * @param {?} hostElement
                 * @param {?} viewAllNodes
                 * @return {?}
                 */
                RendererAdapter.prototype.destroyView = function (hostElement, viewAllNodes) {
                    for (var i = 0; i < viewAllNodes.length; i++) {
                        ( /** @type {?} */(this.delegate.destroyNode))(viewAllNodes[i]);
                    }
                };
                /**
                 * @param {?} renderElement
                 * @param {?} name
                 * @param {?} callback
                 * @return {?}
                 */
                RendererAdapter.prototype.listen = function (renderElement, name, callback) {
                    return this.delegate.listen(renderElement, name, ( /** @type {?} */(callback)));
                };
                /**
                 * @param {?} target
                 * @param {?} name
                 * @param {?} callback
                 * @return {?}
                 */
                RendererAdapter.prototype.listenGlobal = function (target, name, callback) {
                    return this.delegate.listen(target, name, ( /** @type {?} */(callback)));
                };
                /**
                 * @param {?} renderElement
                 * @param {?} propertyName
                 * @param {?} propertyValue
                 * @return {?}
                 */
                RendererAdapter.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) {
                    this.delegate.setProperty(renderElement, propertyName, propertyValue);
                };
                /**
                 * @param {?} renderElement
                 * @param {?} namespaceAndName
                 * @param {?=} attributeValue
                 * @return {?}
                 */
                RendererAdapter.prototype.setElementAttribute = function (renderElement, namespaceAndName, attributeValue) {
                    var _c = splitNamespace(namespaceAndName), ns = _c[0], name = _c[1];
                    if (attributeValue != null) {
                        this.delegate.setAttribute(renderElement, name, attributeValue, ns);
                    }
                    else {
                        this.delegate.removeAttribute(renderElement, name, ns);
                    }
                };
                /**
                 * @param {?} renderElement
                 * @param {?} propertyName
                 * @param {?} propertyValue
                 * @return {?}
                 */
                RendererAdapter.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) { };
                /**
                 * @param {?} renderElement
                 * @param {?} className
                 * @param {?} isAdd
                 * @return {?}
                 */
                RendererAdapter.prototype.setElementClass = function (renderElement, className, isAdd) {
                    if (isAdd) {
                        this.delegate.addClass(renderElement, className);
                    }
                    else {
                        this.delegate.removeClass(renderElement, className);
                    }
                };
                /**
                 * @param {?} renderElement
                 * @param {?} styleName
                 * @param {?=} styleValue
                 * @return {?}
                 */
                RendererAdapter.prototype.setElementStyle = function (renderElement, styleName, styleValue) {
                    if (styleValue != null) {
                        this.delegate.setStyle(renderElement, styleName, styleValue);
                    }
                    else {
                        this.delegate.removeStyle(renderElement, styleName);
                    }
                };
                /**
                 * @param {?} renderElement
                 * @param {?} methodName
                 * @param {?} args
                 * @return {?}
                 */
                RendererAdapter.prototype.invokeElementMethod = function (renderElement, methodName, args) {
                    (( /** @type {?} */(renderElement)))[methodName].apply(renderElement, args);
                };
                /**
                 * @param {?} renderNode
                 * @param {?} text
                 * @return {?}
                 */
                RendererAdapter.prototype.setText = function (renderNode, text) { this.delegate.setValue(renderNode, text); };
                /**
                 * @return {?}
                 */
                RendererAdapter.prototype.animate = function () { throw new Error('Renderer.animate is no longer supported!'); };
                return RendererAdapter;
            }());
            if (false) { }
            /**
             * @param {?} moduleType
             * @param {?} parent
             * @param {?} bootstrapComponents
             * @param {?} def
             * @return {?}
             */
            function createNgModuleRef(moduleType, parent, bootstrapComponents, def) {
                return new NgModuleRef_(moduleType, parent, bootstrapComponents, def);
            }
            var NgModuleRef_ = /** @class */ (function () {
                /**
                 * @param {?} _moduleType
                 * @param {?} _parent
                 * @param {?} _bootstrapComponents
                 * @param {?} _def
                 */
                function NgModuleRef_(_moduleType, _parent, _bootstrapComponents, _def) {
                    this._moduleType = _moduleType;
                    this._parent = _parent;
                    this._bootstrapComponents = _bootstrapComponents;
                    this._def = _def;
                    this._destroyListeners = [];
                    this._destroyed = false;
                    this.injector = this;
                    initNgModule(this);
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @param {?=} injectFlags
                 * @return {?}
                 */
                NgModuleRef_.prototype.get = function (token, notFoundValue, injectFlags) {
                    if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
                    if (injectFlags === void 0) { injectFlags = InjectFlags.Default; }
                    /** @type {?} */
                    var flags = 0 /* None */;
                    if (injectFlags & InjectFlags.SkipSelf) {
                        flags |= 1 /* SkipSelf */;
                    }
                    else if (injectFlags & InjectFlags.Self) {
                        flags |= 4 /* Self */;
                    }
                    return resolveNgModuleDep(this, { token: token, tokenKey: tokenKey(token), flags: flags }, notFoundValue);
                };
                Object.defineProperty(NgModuleRef_.prototype, "instance", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.get(this._moduleType); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgModuleRef_.prototype, "componentFactoryResolver", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.get(ComponentFactoryResolver); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                NgModuleRef_.prototype.destroy = function () {
                    if (this._destroyed) {
                        throw new Error("The ng module " + stringify(this.instance.constructor) + " has already been destroyed.");
                    }
                    this._destroyed = true;
                    callNgModuleLifecycle(this, 131072 /* OnDestroy */);
                    this._destroyListeners.forEach(( /**
                     * @param {?} listener
                     * @return {?}
                     */function (listener) { return listener(); }));
                };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                NgModuleRef_.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
                return NgModuleRef_;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var RendererV1TokenKey = tokenKey(Renderer);
            /** @type {?} */
            var Renderer2TokenKey = tokenKey(Renderer2);
            /** @type {?} */
            var ElementRefTokenKey = tokenKey(ElementRef);
            /** @type {?} */
            var ViewContainerRefTokenKey = tokenKey(ViewContainerRef);
            /** @type {?} */
            var TemplateRefTokenKey = tokenKey(TemplateRef);
            /** @type {?} */
            var ChangeDetectorRefTokenKey = tokenKey(ChangeDetectorRef);
            /** @type {?} */
            var InjectorRefTokenKey$1 = tokenKey(Injector);
            /** @type {?} */
            var INJECTORRefTokenKey$1 = tokenKey(INJECTOR);
            /**
             * @param {?} checkIndex
             * @param {?} flags
             * @param {?} matchedQueries
             * @param {?} childCount
             * @param {?} ctor
             * @param {?} deps
             * @param {?=} props
             * @param {?=} outputs
             * @return {?}
             */
            function directiveDef(checkIndex, flags, matchedQueries, childCount, ctor, deps, props, outputs) {
                /** @type {?} */
                var bindings = [];
                if (props) {
                    for (var prop in props) {
                        var _c = props[prop], bindingIndex = _c[0], nonMinifiedName = _c[1];
                        bindings[bindingIndex] = {
                            flags: 8 /* TypeProperty */,
                            name: prop, nonMinifiedName: nonMinifiedName,
                            ns: null,
                            securityContext: null,
                            suffix: null
                        };
                    }
                }
                /** @type {?} */
                var outputDefs = [];
                if (outputs) {
                    for (var propName in outputs) {
                        outputDefs.push({ type: 1 /* DirectiveOutput */, propName: propName, target: null, eventName: outputs[propName] });
                    }
                }
                flags |= 16384 /* TypeDirective */;
                return _def(checkIndex, flags, matchedQueries, childCount, ctor, ctor, deps, bindings, outputDefs);
            }
            /**
             * @param {?} flags
             * @param {?} ctor
             * @param {?} deps
             * @return {?}
             */
            function pipeDef(flags, ctor, deps) {
                flags |= 16 /* TypePipe */;
                return _def(-1, flags, null, 0, ctor, ctor, deps);
            }
            /**
             * @param {?} flags
             * @param {?} matchedQueries
             * @param {?} token
             * @param {?} value
             * @param {?} deps
             * @return {?}
             */
            function providerDef(flags, matchedQueries, token, value, deps) {
                return _def(-1, flags, matchedQueries, 0, token, value, deps);
            }
            /**
             * @param {?} checkIndex
             * @param {?} flags
             * @param {?} matchedQueriesDsl
             * @param {?} childCount
             * @param {?} token
             * @param {?} value
             * @param {?} deps
             * @param {?=} bindings
             * @param {?=} outputs
             * @return {?}
             */
            function _def(checkIndex, flags, matchedQueriesDsl, childCount, token, value, deps, bindings, outputs) {
                var _c = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _c.matchedQueries, references = _c.references, matchedQueryIds = _c.matchedQueryIds;
                if (!outputs) {
                    outputs = [];
                }
                if (!bindings) {
                    bindings = [];
                }
                // Need to resolve forwardRefs as e.g. for `useValue` we
                // lowered the expression and then stopped evaluating it,
                // i.e. also didn't unwrap it.
                value = resolveForwardRef(value);
                /** @type {?} */
                var depDefs = splitDepsDsl(deps, stringify(token));
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    checkIndex: checkIndex,
                    flags: flags,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references,
                    ngContentIndex: -1, childCount: childCount, bindings: bindings,
                    bindingFlags: calcBindingFlags(bindings), outputs: outputs,
                    element: null,
                    provider: { token: token, value: value, deps: depDefs },
                    text: null,
                    query: null,
                    ngContent: null
                };
            }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function createProviderInstance(view, def) {
                return _createProviderInstance$1(view, def);
            }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function createPipeInstance(view, def) {
                // deps are looked up from component.
                /** @type {?} */
                var compView = view;
                while (compView.parent && !isComponentView(compView)) {
                    compView = compView.parent;
                }
                // pipes can see the private services of the component
                /** @type {?} */
                var allowPrivateServices = true;
                // pipes are always eager and classes!
                return createClass(( /** @type {?} */(compView.parent)), ( /** @type {?} */(viewParentEl(compView))), allowPrivateServices, ( /** @type {?} */(def.provider)).value, ( /** @type {?} */(def.provider)).deps);
            }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function createDirectiveInstance(view, def) {
                // components can see other private services, other directives can't.
                /** @type {?} */
                var allowPrivateServices = (def.flags & 32768 /* Component */) > 0;
                // directives are always eager and classes!
                /** @type {?} */
                var instance = createClass(view, ( /** @type {?} */(def.parent)), allowPrivateServices, ( /** @type {?} */(def.provider)).value, ( /** @type {?} */(def.provider)).deps);
                if (def.outputs.length) {
                    for (var i = 0; i < def.outputs.length; i++) {
                        /** @type {?} */
                        var output = def.outputs[i];
                        /** @type {?} */
                        var outputObservable = instance[( /** @type {?} */(output.propName))];
                        if (isObservable(outputObservable)) {
                            /** @type {?} */
                            var subscription = outputObservable.subscribe(eventHandlerClosure(view, ( /** @type {?} */(def.parent)).nodeIndex, output.eventName));
                            ( /** @type {?} */(view.disposables))[def.outputIndex + i] = subscription.unsubscribe.bind(subscription);
                        }
                        else {
                            throw new Error("@Output " + output.propName + " not initialized in '" + instance.constructor.name + "'.");
                        }
                    }
                }
                return instance;
            }
            /**
             * @param {?} view
             * @param {?} index
             * @param {?} eventName
             * @return {?}
             */
            function eventHandlerClosure(view, index, eventName) {
                return ( /**
                 * @param {?} event
                 * @return {?}
                 */function (event) { return dispatchEvent(view, index, eventName, event); });
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} v0
             * @param {?} v1
             * @param {?} v2
             * @param {?} v3
             * @param {?} v4
             * @param {?} v5
             * @param {?} v6
             * @param {?} v7
             * @param {?} v8
             * @param {?} v9
             * @return {?}
             */
            function checkAndUpdateDirectiveInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var providerData = asProviderData(view, def.nodeIndex);
                /** @type {?} */
                var directive = providerData.instance;
                /** @type {?} */
                var changed = false;
                /** @type {?} */
                var changes = ( /** @type {?} */(undefined));
                /** @type {?} */
                var bindLen = def.bindings.length;
                if (bindLen > 0 && checkBinding(view, def, 0, v0)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 0, v0, changes);
                }
                if (bindLen > 1 && checkBinding(view, def, 1, v1)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 1, v1, changes);
                }
                if (bindLen > 2 && checkBinding(view, def, 2, v2)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 2, v2, changes);
                }
                if (bindLen > 3 && checkBinding(view, def, 3, v3)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 3, v3, changes);
                }
                if (bindLen > 4 && checkBinding(view, def, 4, v4)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 4, v4, changes);
                }
                if (bindLen > 5 && checkBinding(view, def, 5, v5)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 5, v5, changes);
                }
                if (bindLen > 6 && checkBinding(view, def, 6, v6)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 6, v6, changes);
                }
                if (bindLen > 7 && checkBinding(view, def, 7, v7)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 7, v7, changes);
                }
                if (bindLen > 8 && checkBinding(view, def, 8, v8)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 8, v8, changes);
                }
                if (bindLen > 9 && checkBinding(view, def, 9, v9)) {
                    changed = true;
                    changes = updateProp(view, providerData, def, 9, v9, changes);
                }
                if (changes) {
                    directive.ngOnChanges(changes);
                }
                if ((def.flags & 65536 /* OnInit */) &&
                    shouldCallLifecycleInitHook(view, 256 /* InitState_CallingOnInit */, def.nodeIndex)) {
                    directive.ngOnInit();
                }
                if (def.flags & 262144 /* DoCheck */) {
                    directive.ngDoCheck();
                }
                return changed;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} values
             * @return {?}
             */
            function checkAndUpdateDirectiveDynamic(view, def, values) {
                /** @type {?} */
                var providerData = asProviderData(view, def.nodeIndex);
                /** @type {?} */
                var directive = providerData.instance;
                /** @type {?} */
                var changed = false;
                /** @type {?} */
                var changes = ( /** @type {?} */(undefined));
                for (var i = 0; i < values.length; i++) {
                    if (checkBinding(view, def, i, values[i])) {
                        changed = true;
                        changes = updateProp(view, providerData, def, i, values[i], changes);
                    }
                }
                if (changes) {
                    directive.ngOnChanges(changes);
                }
                if ((def.flags & 65536 /* OnInit */) &&
                    shouldCallLifecycleInitHook(view, 256 /* InitState_CallingOnInit */, def.nodeIndex)) {
                    directive.ngOnInit();
                }
                if (def.flags & 262144 /* DoCheck */) {
                    directive.ngDoCheck();
                }
                return changed;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function _createProviderInstance$1(view, def) {
                // private services can see other private services
                /** @type {?} */
                var allowPrivateServices = (def.flags & 8192 /* PrivateProvider */) > 0;
                /** @type {?} */
                var providerDef = def.provider;
                switch (def.flags & 201347067 /* Types */) {
                    case 512 /* TypeClassProvider */:
                        return createClass(view, ( /** @type {?} */(def.parent)), allowPrivateServices, ( /** @type {?} */(providerDef)).value, ( /** @type {?} */(providerDef)).deps);
                    case 1024 /* TypeFactoryProvider */:
                        return callFactory(view, ( /** @type {?} */(def.parent)), allowPrivateServices, ( /** @type {?} */(providerDef)).value, ( /** @type {?} */(providerDef)).deps);
                    case 2048 /* TypeUseExistingProvider */:
                        return resolveDep(view, ( /** @type {?} */(def.parent)), allowPrivateServices, ( /** @type {?} */(providerDef)).deps[0]);
                    case 256 /* TypeValueProvider */:
                        return ( /** @type {?} */(providerDef)).value;
                }
            }
            /**
             * @param {?} view
             * @param {?} elDef
             * @param {?} allowPrivateServices
             * @param {?} ctor
             * @param {?} deps
             * @return {?}
             */
            function createClass(view, elDef, allowPrivateServices, ctor, deps) {
                /** @type {?} */
                var len = deps.length;
                switch (len) {
                    case 0:
                        return new ctor();
                    case 1:
                        return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]));
                    case 2:
                        return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
                    case 3:
                        return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
                    default:
                        /** @type {?} */
                        var depValues = new Array(len);
                        for (var i = 0; i < len; i++) {
                            depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
                        }
                        return new (ctor.bind.apply(ctor, [void 0].concat(depValues)))();
                }
            }
            /**
             * @param {?} view
             * @param {?} elDef
             * @param {?} allowPrivateServices
             * @param {?} factory
             * @param {?} deps
             * @return {?}
             */
            function callFactory(view, elDef, allowPrivateServices, factory, deps) {
                /** @type {?} */
                var len = deps.length;
                switch (len) {
                    case 0:
                        return factory();
                    case 1:
                        return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]));
                    case 2:
                        return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
                    case 3:
                        return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
                    default:
                        /** @type {?} */
                        var depValues = Array(len);
                        for (var i = 0; i < len; i++) {
                            depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
                        }
                        return factory.apply(void 0, depValues);
                }
            }
            // This default value is when checking the hierarchy for a token.
            //
            // It means both:
            // - the token is not provided by the current injector,
            // - only the element injectors should be checked (ie do not check module injectors
            //
            //          mod1
            //         /
            //       el1   mod2
            //         \  /
            //         el2
            //
            // When requesting el2.injector.get(token), we should check in the following order and return the
            // first found value:
            // - el2.injector.get(token, default)
            // - el1.injector.get(token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) -> do not check the module
            // - mod2.injector.get(token, default)
            /** @type {?} */
            var NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR = {};
            /**
             * @param {?} view
             * @param {?} elDef
             * @param {?} allowPrivateServices
             * @param {?} depDef
             * @param {?=} notFoundValue
             * @return {?}
             */
            function resolveDep(view, elDef, allowPrivateServices, depDef, notFoundValue) {
                if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
                if (depDef.flags & 8 /* Value */) {
                    return depDef.token;
                }
                /** @type {?} */
                var startView = view;
                if (depDef.flags & 2 /* Optional */) {
                    notFoundValue = null;
                }
                /** @type {?} */
                var tokenKey = depDef.tokenKey;
                if (tokenKey === ChangeDetectorRefTokenKey) {
                    // directives on the same element as a component should be able to control the change detector
                    // of that component as well.
                    allowPrivateServices = !!(elDef && ( /** @type {?} */(elDef.element)).componentView);
                }
                if (elDef && (depDef.flags & 1 /* SkipSelf */)) {
                    allowPrivateServices = false;
                    elDef = ( /** @type {?} */(elDef.parent));
                }
                /** @type {?} */
                var searchView = view;
                while (searchView) {
                    if (elDef) {
                        switch (tokenKey) {
                            case RendererV1TokenKey: {
                                /** @type {?} */
                                var compView = findCompView(searchView, elDef, allowPrivateServices);
                                return createRendererV1(compView);
                            }
                            case Renderer2TokenKey: {
                                /** @type {?} */
                                var compView = findCompView(searchView, elDef, allowPrivateServices);
                                return compView.renderer;
                            }
                            case ElementRefTokenKey:
                                return new ElementRef(asElementData(searchView, elDef.nodeIndex).renderElement);
                            case ViewContainerRefTokenKey:
                                return asElementData(searchView, elDef.nodeIndex).viewContainer;
                            case TemplateRefTokenKey: {
                                if (( /** @type {?} */(elDef.element)).template) {
                                    return asElementData(searchView, elDef.nodeIndex).template;
                                }
                                break;
                            }
                            case ChangeDetectorRefTokenKey: {
                                /** @type {?} */
                                var cdView = findCompView(searchView, elDef, allowPrivateServices);
                                return createChangeDetectorRef(cdView);
                            }
                            case InjectorRefTokenKey$1:
                            case INJECTORRefTokenKey$1:
                                return createInjector$1(searchView, elDef);
                            default:
                                /** @type {?} */
                                var providerDef_2 = ( /** @type {?} */((allowPrivateServices ? ( /** @type {?} */(elDef.element)).allProviders :
                                    ( /** @type {?} */(elDef.element)).publicProviders)))[tokenKey];
                                if (providerDef_2) {
                                    /** @type {?} */
                                    var providerData = asProviderData(searchView, providerDef_2.nodeIndex);
                                    if (!providerData) {
                                        providerData = { instance: _createProviderInstance$1(searchView, providerDef_2) };
                                        searchView.nodes[providerDef_2.nodeIndex] = ( /** @type {?} */(providerData));
                                    }
                                    return providerData.instance;
                                }
                        }
                    }
                    allowPrivateServices = isComponentView(searchView);
                    elDef = ( /** @type {?} */(viewParentEl(searchView)));
                    searchView = ( /** @type {?} */(searchView.parent));
                    if (depDef.flags & 4 /* Self */) {
                        searchView = null;
                    }
                }
                /** @type {?} */
                var value = startView.root.injector.get(depDef.token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR);
                if (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR ||
                    notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) {
                    // Return the value from the root element injector when
                    // - it provides it
                    //   (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
                    // - the module injector should not be checked
                    //   (notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
                    return value;
                }
                return startView.root.ngModule.injector.get(depDef.token, notFoundValue);
            }
            /**
             * @param {?} view
             * @param {?} elDef
             * @param {?} allowPrivateServices
             * @return {?}
             */
            function findCompView(view, elDef, allowPrivateServices) {
                /** @type {?} */
                var compView;
                if (allowPrivateServices) {
                    compView = asElementData(view, elDef.nodeIndex).componentView;
                }
                else {
                    compView = view;
                    while (compView.parent && !isComponentView(compView)) {
                        compView = compView.parent;
                    }
                }
                return compView;
            }
            /**
             * @param {?} view
             * @param {?} providerData
             * @param {?} def
             * @param {?} bindingIdx
             * @param {?} value
             * @param {?} changes
             * @return {?}
             */
            function updateProp(view, providerData, def, bindingIdx, value, changes) {
                if (def.flags & 32768 /* Component */) {
                    /** @type {?} */
                    var compView = asElementData(view, ( /** @type {?} */(def.parent)).nodeIndex).componentView;
                    if (compView.def.flags & 2 /* OnPush */) {
                        compView.state |= 8 /* ChecksEnabled */;
                    }
                }
                /** @type {?} */
                var binding = def.bindings[bindingIdx];
                /** @type {?} */
                var propName = ( /** @type {?} */(binding.name));
                // Note: This is still safe with Closure Compiler as
                // the user passed in the property name as an object has to `providerDef`,
                // so Closure Compiler will have renamed the property correctly already.
                providerData.instance[propName] = value;
                if (def.flags & 524288 /* OnChanges */) {
                    changes = changes || {};
                    /** @type {?} */
                    var oldValue = WrappedValue.unwrap(view.oldValues[def.bindingIndex + bindingIdx]);
                    /** @type {?} */
                    var binding_1 = def.bindings[bindingIdx];
                    changes[( /** @type {?} */(binding_1.nonMinifiedName))] =
                        new SimpleChange(oldValue, value, (view.state & 2 /* FirstCheck */) !== 0);
                }
                view.oldValues[def.bindingIndex + bindingIdx] = value;
                return changes;
            }
            // This function calls the ngAfterContentCheck, ngAfterContentInit,
            // ngAfterViewCheck, and ngAfterViewInit lifecycle hooks (depending on the node
            // flags in lifecycle). Unlike ngDoCheck, ngOnChanges and ngOnInit, which are
            // called during a pre-order traversal of the view tree (that is calling the
            // parent hooks before the child hooks) these events are sent in using a
            // post-order traversal of the tree (children before parents). This changes the
            // meaning of initIndex in the view state. For ngOnInit, initIndex tracks the
            // expected nodeIndex which a ngOnInit should be called. When sending
            // ngAfterContentInit and ngAfterViewInit it is the expected count of
            // ngAfterContentInit or ngAfterViewInit methods that have been called. This
            // ensure that despite being called recursively or after picking up after an
            // exception, the ngAfterContentInit or ngAfterViewInit will be called on the
            // correct nodes. Consider for example, the following (where E is an element
            // and D is a directive)
            //  Tree:       pre-order index  post-order index
            //    E1        0                6
            //      E2      1                1
            //       D3     2                0
            //      E4      3                5
            //       E5     4                4
            //        E6    5                2
            //        E7    6                3
            // As can be seen, the post-order index has an unclear relationship to the
            // pre-order index (postOrderIndex === preOrderIndex - parentCount +
            // childCount). Since number of calls to ngAfterContentInit and ngAfterViewInit
            // are stable (will be the same for the same view regardless of exceptions or
            // recursion) we just need to count them which will roughly correspond to the
            // post-order index (it skips elements and directives that do not have
            // lifecycle hooks).
            //
            // For example, if an exception is raised in the E6.onAfterViewInit() the
            // initIndex is left at 3 (by shouldCallLifecycleInitHook() which set it to
            // initIndex + 1). When checkAndUpdateView() is called again D3, E2 and E6 will
            // not have their ngAfterViewInit() called but, starting with E7, the rest of
            // the view will begin getting ngAfterViewInit() called until a check and
            // pass is complete.
            //
            // This algorthim also handles recursion. Consider if E4's ngAfterViewInit()
            // indirectly calls E1's ChangeDetectorRef.detectChanges(). The expected
            // initIndex is set to 6, the recusive checkAndUpdateView() starts walk again.
            // D3, E2, E6, E7, E5 and E4 are skipped, ngAfterViewInit() is called on E1.
            // When the recursion returns the initIndex will be 7 so E1 is skipped as it
            // has already been called in the recursively called checkAnUpdateView().
            /**
             * @param {?} view
             * @param {?} lifecycles
             * @return {?}
             */
            function callLifecycleHooksChildrenFirst(view, lifecycles) {
                if (!(view.def.nodeFlags & lifecycles)) {
                    return;
                }
                /** @type {?} */
                var nodes = view.def.nodes;
                /** @type {?} */
                var initIndex = 0;
                for (var i = 0; i < nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = nodes[i];
                    /** @type {?} */
                    var parent = nodeDef.parent;
                    if (!parent && nodeDef.flags & lifecycles) {
                        // matching root node (e.g. a pipe)
                        callProviderLifecycles(view, i, nodeDef.flags & lifecycles, initIndex++);
                    }
                    if ((nodeDef.childFlags & lifecycles) === 0) {
                        // no child matches one of the lifecycles
                        i += nodeDef.childCount;
                    }
                    while (parent && (parent.flags & 1 /* TypeElement */) &&
                        i === parent.nodeIndex + parent.childCount) {
                        // last child of an element
                        if (parent.directChildFlags & lifecycles) {
                            initIndex = callElementProvidersLifecycles(view, parent, lifecycles, initIndex);
                        }
                        parent = parent.parent;
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} elDef
             * @param {?} lifecycles
             * @param {?} initIndex
             * @return {?}
             */
            function callElementProvidersLifecycles(view, elDef, lifecycles, initIndex) {
                for (var i = elDef.nodeIndex + 1; i <= elDef.nodeIndex + elDef.childCount; i++) {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[i];
                    if (nodeDef.flags & lifecycles) {
                        callProviderLifecycles(view, i, nodeDef.flags & lifecycles, initIndex++);
                    }
                    // only visit direct children
                    i += nodeDef.childCount;
                }
                return initIndex;
            }
            /**
             * @param {?} view
             * @param {?} index
             * @param {?} lifecycles
             * @param {?} initIndex
             * @return {?}
             */
            function callProviderLifecycles(view, index, lifecycles, initIndex) {
                /** @type {?} */
                var providerData = asProviderData(view, index);
                if (!providerData) {
                    return;
                }
                /** @type {?} */
                var provider = providerData.instance;
                if (!provider) {
                    return;
                }
                Services.setCurrentNode(view, index);
                if (lifecycles & 1048576 /* AfterContentInit */ &&
                    shouldCallLifecycleInitHook(view, 512 /* InitState_CallingAfterContentInit */, initIndex)) {
                    provider.ngAfterContentInit();
                }
                if (lifecycles & 2097152 /* AfterContentChecked */) {
                    provider.ngAfterContentChecked();
                }
                if (lifecycles & 4194304 /* AfterViewInit */ &&
                    shouldCallLifecycleInitHook(view, 768 /* InitState_CallingAfterViewInit */, initIndex)) {
                    provider.ngAfterViewInit();
                }
                if (lifecycles & 8388608 /* AfterViewChecked */) {
                    provider.ngAfterViewChecked();
                }
                if (lifecycles & 131072 /* OnDestroy */) {
                    provider.ngOnDestroy();
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ComponentFactoryResolver$1 = /** @class */ (function (_super_1) {
                __extends(ComponentFactoryResolver$1, _super_1);
                /**
                 * @param {?=} ngModule The NgModuleRef to which all resolved factories are bound.
                 */
                function ComponentFactoryResolver$1(ngModule) {
                    var _this = _super_1.call(this) || this;
                    _this.ngModule = ngModule;
                    return _this;
                }
                /**
                 * @template T
                 * @param {?} component
                 * @return {?}
                 */
                ComponentFactoryResolver$1.prototype.resolveComponentFactory = function (component) {
                    ngDevMode && assertComponentType(component);
                    /** @type {?} */
                    var componentDef = ( /** @type {?} */(getComponentDef(component)));
                    return new ComponentFactory$1(componentDef, this.ngModule);
                };
                return ComponentFactoryResolver$1;
            }(ComponentFactoryResolver));
            if (false) { }
            /**
             * @param {?} map
             * @return {?}
             */
            function toRefArray(map) {
                /** @type {?} */
                var array = [];
                for (var nonMinified in map) {
                    if (map.hasOwnProperty(nonMinified)) {
                        /** @type {?} */
                        var minified = map[nonMinified];
                        array.push({ propName: minified, templateName: nonMinified });
                    }
                }
                return array;
            }
            /**
             * A change detection scheduler token for {\@link RootContext}. This token is the default value used
             * for the default `RootContext` found in the {\@link ROOT_CONTEXT} token.
             * @type {?}
             */
            var SCHEDULER = new InjectionToken('SCHEDULER_TOKEN', {
                providedIn: 'root',
                factory: ( /**
                 * @return {?}
                 */function () { return defaultScheduler; }),
            });
            /**
             * @param {?} rootViewInjector
             * @param {?} moduleInjector
             * @return {?}
             */
            function createChainedInjector(rootViewInjector, moduleInjector) {
                return {
                    get: ( /**
                     * @template T
                     * @param {?} token
                     * @param {?=} notFoundValue
                     * @param {?=} flags
                     * @return {?}
                     */function (token, notFoundValue, flags) {
                        /** @type {?} */
                        var value = rootViewInjector.get(token, ( /** @type {?} */(NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)), flags);
                        if (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR ||
                            notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) {
                            // Return the value from the root element injector when
                            // - it provides it
                            //   (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
                            // - the module injector should not be checked
                            //   (notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
                            return value;
                        }
                        return moduleInjector.get(token, notFoundValue, flags);
                    })
                };
            }
            /**
             * Render3 implementation of {\@link viewEngine_ComponentFactory}.
             * @template T
             */
            var ComponentFactory$1 = /** @class */ (function (_super_1) {
                __extends(ComponentFactory$1, _super_1);
                /**
                 * @param {?} componentDef The component definition.
                 * @param {?=} ngModule The NgModuleRef to which the factory is bound.
                 */
                function ComponentFactory$1(componentDef, ngModule) {
                    var _this = _super_1.call(this) || this;
                    _this.componentDef = componentDef;
                    _this.ngModule = ngModule;
                    _this.componentType = componentDef.type;
                    // default to 'div' in case this component has an attribute selector
                    _this.selector = ( /** @type {?} */(componentDef.selectors[0][0])) || 'div';
                    _this.ngContentSelectors =
                        componentDef.ngContentSelectors ? componentDef.ngContentSelectors : [];
                    _this.isBoundToModule = !!ngModule;
                    return _this;
                }
                Object.defineProperty(ComponentFactory$1.prototype, "inputs", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return toRefArray(this.componentDef.inputs);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ComponentFactory$1.prototype, "outputs", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return toRefArray(this.componentDef.outputs);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} injector
                 * @param {?=} projectableNodes
                 * @param {?=} rootSelectorOrNode
                 * @param {?=} ngModule
                 * @return {?}
                 */
                ComponentFactory$1.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
                    ngModule = ngModule || this.ngModule;
                    /** @type {?} */
                    var rootViewInjector = ngModule ? createChainedInjector(injector, ngModule.injector) : injector;
                    /** @type {?} */
                    var rendererFactory = ( /** @type {?} */(rootViewInjector.get(RendererFactory2, domRendererFactory3)));
                    /** @type {?} */
                    var sanitizer = rootViewInjector.get(Sanitizer, null);
                    // Ensure that the namespace for the root node is correct,
                    // otherwise the browser might not render out the element properly.
                    namespaceHTMLInternal();
                    /** @type {?} */
                    var hostRNode = rootSelectorOrNode ?
                        locateHostElement(rendererFactory, rootSelectorOrNode) :
                        elementCreate(this.selector, rendererFactory.createRenderer(null, this.componentDef));
                    /** @type {?} */
                    var rootFlags = this.componentDef.onPush ? 64 /* Dirty */ | 512 /* IsRoot */ :
                        16 /* CheckAlways */ | 512 /* IsRoot */;
                    // Check whether this Component needs to be isolated from other components, i.e. whether it
                    // should be placed into its own (empty) root context or existing root context should be used.
                    // Note: this is internal-only convention and might change in the future, so it should not be
                    // relied upon externally.
                    /** @type {?} */
                    var isIsolated = typeof rootSelectorOrNode === 'string' &&
                        /^#root-ng-internal-isolated-\d+/.test(rootSelectorOrNode);
                    /** @type {?} */
                    var rootContext = createRootContext();
                    /** @type {?} */
                    var renderer = rendererFactory.createRenderer(hostRNode, this.componentDef);
                    if (rootSelectorOrNode && hostRNode) {
                        ngDevMode && ngDevMode.rendererSetAttribute++;
                        isProceduralRenderer(renderer) ?
                            renderer.setAttribute(hostRNode, 'ng-version', VERSION.full) :
                            hostRNode.setAttribute('ng-version', VERSION.full);
                    }
                    // Create the root view. Uses empty TView and ContentTemplate.
                    /** @type {?} */
                    var rootLView = createLView(null, createTView(-1, null, 1, 0, null, null, null, null), rootContext, rootFlags, null, null, rendererFactory, renderer, sanitizer, rootViewInjector);
                    // rootView is the parent when bootstrapping
                    /** @type {?} */
                    var oldLView = enterView(rootLView, null);
                    /** @type {?} */
                    var component;
                    /** @type {?} */
                    var tElementNode;
                    // Will become true if the `try` block executes with no errors.
                    /** @type {?} */
                    var safeToRunHooks = false;
                    try {
                        /** @type {?} */
                        var componentView = createRootComponentView(hostRNode, this.componentDef, rootLView, rendererFactory, renderer);
                        tElementNode = ( /** @type {?} */(getTNode(0, rootLView)));
                        if (projectableNodes) {
                            // projectable nodes can be passed as array of arrays or an array of iterables (ngUpgrade
                            // case). Here we do normalize passed data structure to be an array of arrays to avoid
                            // complex checks down the line.
                            tElementNode.projection =
                                projectableNodes.map(( /**
                                 * @param {?} nodesforSlot
                                 * @return {?}
                                 */function (nodesforSlot) { return Array.from(nodesforSlot); }));
                        }
                        // TODO: should LifecycleHooksFeature and other host features be generated by the compiler and
                        // executed here?
                        // Angular 5 reference: https://stackblitz.com/edit/lifecycle-hooks-vcref
                        component = createRootComponent(componentView, this.componentDef, rootLView, rootContext, [LifecycleHooksFeature]);
                        addToViewTree(rootLView, componentView);
                        refreshDescendantViews(rootLView);
                        safeToRunHooks = true;
                    }
                    finally {
                        leaveView(oldLView, safeToRunHooks);
                    }
                    /** @type {?} */
                    var componentRef = new ComponentRef$1(this.componentType, component, createElementRef(ElementRef, tElementNode, rootLView), rootLView, tElementNode);
                    if (!rootSelectorOrNode || isIsolated) {
                        // The host element of the internal or isolated root view is attached to the component's host
                        // view node.
                        ( /** @type {?} */(componentRef.hostView._tViewNode)).child = tElementNode;
                    }
                    return componentRef;
                };
                return ComponentFactory$1;
            }(ComponentFactory));
            if (false) { }
            /** @type {?} */
            var componentFactoryResolver = new ComponentFactoryResolver$1();
            /**
             * Creates a ComponentFactoryResolver and stores it on the injector. Or, if the
             * ComponentFactoryResolver
             * already exists, retrieves the existing ComponentFactoryResolver.
             *
             * @return {?} The ComponentFactoryResolver instance to use
             */
            function injectComponentFactoryResolver() {
                return componentFactoryResolver;
            }
            /**
             * Represents an instance of a Component created via a {\@link ComponentFactory}.
             *
             * `ComponentRef` provides access to the Component Instance as well other objects related to this
             * Component Instance and allows you to destroy the Component Instance via the {\@link #destroy}
             * method.
             *
             * @template T
             */
            var ComponentRef$1 = /** @class */ (function (_super_1) {
                __extends(ComponentRef$1, _super_1);
                /**
                 * @param {?} componentType
                 * @param {?} instance
                 * @param {?} location
                 * @param {?} _rootLView
                 * @param {?} _tNode
                 */
                function ComponentRef$1(componentType, instance, location, _rootLView, _tNode) {
                    var _this = _super_1.call(this) || this;
                    _this.location = location;
                    _this._rootLView = _rootLView;
                    _this._tNode = _tNode;
                    _this.destroyCbs = [];
                    _this.instance = instance;
                    _this.hostView = _this.changeDetectorRef = new RootViewRef(_rootLView);
                    _this.hostView._tViewNode = assignTViewNodeToLView(_rootLView[TVIEW], null, -1, _rootLView);
                    _this.componentType = componentType;
                    return _this;
                }
                Object.defineProperty(ComponentRef$1.prototype, "injector", {
                    /**
                     * @return {?}
                     */
                    get: function () { return new NodeInjector(this._tNode, this._rootLView); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ComponentRef$1.prototype.destroy = function () {
                    if (this.destroyCbs) {
                        this.destroyCbs.forEach(( /**
                         * @param {?} fn
                         * @return {?}
                         */function (/**
                         * @param {?} fn
                         * @return {?}
                         */ fn) { return fn(); }));
                        this.destroyCbs = null;
                        !this.hostView.destroyed && this.hostView.destroy();
                    }
                };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                ComponentRef$1.prototype.onDestroy = function (callback) {
                    if (this.destroyCbs) {
                        this.destroyCbs.push(callback);
                    }
                };
                return ComponentRef$1;
            }(ComponentRef));
            if (false) { }
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * NOTE: changes to the `ngI18nClosureMode` name must be synced with `compiler-cli/src/tooling.ts`.
             */
            if (typeof ngI18nClosureMode === 'undefined') {
                // These property accesses can be ignored because ngI18nClosureMode will be set to false
                // when optimizing code and the whole if statement will be dropped.
                // Make sure to refer to ngI18nClosureMode as ['ngI18nClosureMode'] for closure.
                // NOTE: we need to have it in IIFE so that the tree-shaker is happy.
                (function () {
                    // tslint:disable-next-line:no-toplevel-property-access
                    _global['ngI18nClosureMode'] =
                        // TODO(FW-1250): validate that this actually, you know, works.
                        // tslint:disable-next-line:no-toplevel-property-access
                        typeof goog !== 'undefined' && typeof goog.getMsg === 'function';
                })();
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * This const is used to store the locale data registered with `registerLocaleData`
             * @type {?}
             */
            var LOCALE_DATA = {};
            /** @enum {number} */
            var LocaleDataIndex = {
                LocaleId: 0,
                DayPeriodsFormat: 1,
                DayPeriodsStandalone: 2,
                DaysFormat: 3,
                DaysStandalone: 4,
                MonthsFormat: 5,
                MonthsStandalone: 6,
                Eras: 7,
                FirstDayOfWeek: 8,
                WeekendRange: 9,
                DateFormat: 10,
                TimeFormat: 11,
                DateTimeFormat: 12,
                NumberSymbols: 13,
                NumberFormats: 14,
                CurrencySymbol: 15,
                CurrencyName: 16,
                Currencies: 17,
                PluralCase: 18,
                ExtraData: 19,
            };
            LocaleDataIndex[LocaleDataIndex.LocaleId] = 'LocaleId';
            LocaleDataIndex[LocaleDataIndex.DayPeriodsFormat] = 'DayPeriodsFormat';
            LocaleDataIndex[LocaleDataIndex.DayPeriodsStandalone] = 'DayPeriodsStandalone';
            LocaleDataIndex[LocaleDataIndex.DaysFormat] = 'DaysFormat';
            LocaleDataIndex[LocaleDataIndex.DaysStandalone] = 'DaysStandalone';
            LocaleDataIndex[LocaleDataIndex.MonthsFormat] = 'MonthsFormat';
            LocaleDataIndex[LocaleDataIndex.MonthsStandalone] = 'MonthsStandalone';
            LocaleDataIndex[LocaleDataIndex.Eras] = 'Eras';
            LocaleDataIndex[LocaleDataIndex.FirstDayOfWeek] = 'FirstDayOfWeek';
            LocaleDataIndex[LocaleDataIndex.WeekendRange] = 'WeekendRange';
            LocaleDataIndex[LocaleDataIndex.DateFormat] = 'DateFormat';
            LocaleDataIndex[LocaleDataIndex.TimeFormat] = 'TimeFormat';
            LocaleDataIndex[LocaleDataIndex.DateTimeFormat] = 'DateTimeFormat';
            LocaleDataIndex[LocaleDataIndex.NumberSymbols] = 'NumberSymbols';
            LocaleDataIndex[LocaleDataIndex.NumberFormats] = 'NumberFormats';
            LocaleDataIndex[LocaleDataIndex.CurrencySymbol] = 'CurrencySymbol';
            LocaleDataIndex[LocaleDataIndex.CurrencyName] = 'CurrencyName';
            LocaleDataIndex[LocaleDataIndex.Currencies] = 'Currencies';
            LocaleDataIndex[LocaleDataIndex.PluralCase] = 'PluralCase';
            LocaleDataIndex[LocaleDataIndex.ExtraData] = 'ExtraData';
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            // THIS CODE IS GENERATED - DO NOT MODIFY
            // See angular/tools/gulp-tasks/cldr/extract.js
            /** @type {?} */
            var u = undefined;
            /**
             * @param {?} n
             * @return {?}
             */
            function plural(n) {
                /** @type {?} */
                var i = Math.floor(Math.abs(n));
                /** @type {?} */
                var v = n.toString().replace(/^[^.]*\.?/, '').length;
                if (i === 1 && v === 0)
                    return 1;
                return 5;
            }
            var localeEn = [
                'en', [['a', 'p'], ['AM', 'PM'], u], [['AM', 'PM'], u, u],
                [
                    ['S', 'M', 'T', 'W', 'T', 'F', 'S'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
                ],
                u,
                [
                    ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                    ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    [
                        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
                        'October', 'November', 'December'
                    ]
                ],
                u, [['B', 'A'], ['BC', 'AD'], ['Before Christ', 'Anno Domini']], 0, [6, 0],
                ['M/d/yy', 'MMM d, y', 'MMMM d, y', 'EEEE, MMMM d, y'],
                ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'], ['{1}, {0}', u, '{1} \'at\' {0}', u],
                ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
                ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], '$', 'US Dollar', {}, plural
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Retrieves the plural function used by ICU expressions to determine the plural case to use
             * for a given locale.
             * @see `NgPlural` / [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             * @param {?} locale A locale code for the locale format rules to use.
             * @return {?} The plural function for the locale.
             */
            function getLocalePluralCase(locale) {
                /** @type {?} */
                var data = findLocaleData(locale);
                return data[LocaleDataIndex.PluralCase];
            }
            /**
             * Finds the locale data for a given locale.
             *
             * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
             * @param {?} locale The locale code.
             * @return {?} The locale data.
             */
            function findLocaleData(locale) {
                /** @type {?} */
                var normalizedLocale = locale.toLowerCase().replace(/_/g, '-');
                /** @type {?} */
                var match = LOCALE_DATA[normalizedLocale];
                if (match) {
                    return match;
                }
                // let's try to find a parent locale
                /** @type {?} */
                var parentLocale = normalizedLocale.split('-')[0];
                match = LOCALE_DATA[parentLocale];
                if (match) {
                    return match;
                }
                if (parentLocale === 'en') {
                    return localeEn;
                }
                throw new Error("Missing locale data for the locale \"" + locale + "\".");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns the plural case based on the locale
             * @param {?} value
             * @param {?} locale
             * @return {?}
             */
            function getPluralCase(value, locale) {
                /** @type {?} */
                var plural = getLocalePluralCase(locale)(value);
                switch (plural) {
                    case 0:
                        return 'zero';
                    case 1:
                        return 'one';
                    case 2:
                        return 'two';
                    case 3:
                        return 'few';
                    case 4:
                        return 'many';
                    default:
                        return 'other';
                }
            }
            /**
             * The locale id that the application is using by default (for translations and ICU expressions).
             * @type {?}
             */
            var DEFAULT_LOCALE_ID = 'en-US';
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MARKER = "\uFFFD";
            /** @type {?} */
            var ICU_BLOCK_REGEXP = /^\s*(�\d+:?\d*�)\s*,\s*(select|plural)\s*,/;
            /** @type {?} */
            var SUBTEMPLATE_REGEXP = /�\/?\*(\d+:\d+)�/gi;
            /** @type {?} */
            var PH_REGEXP = /�(\/?[#*!]\d+):?\d*�/gi;
            /** @type {?} */
            var BINDING_REGEXP = /�(\d+):?\d*�/gi;
            /** @type {?} */
            var ICU_REGEXP = /({\s*�\d+:?\d*�\s*,\s*\S{6}\s*,[\s\S]*})/gi;
            /** @enum {string} */
            var TagType = {
                ELEMENT: '#',
                TEMPLATE: '*',
                PROJECTION: '!',
            };
            // i18nPostprocess consts
            /** @type {?} */
            var ROOT_TEMPLATE_ID = 0;
            /** @type {?} */
            var PP_MULTI_VALUE_PLACEHOLDERS_REGEXP = /\[(�.+?�?)\]/;
            /** @type {?} */
            var PP_PLACEHOLDERS_REGEXP = /\[(�.+?�?)\]|(�\/?\*\d+:\d+�)/g;
            /** @type {?} */
            var PP_ICU_VARS_REGEXP = /({\s*)(VAR_(PLURAL|SELECT)(_\d+)?)(\s*,)/g;
            /** @type {?} */
            var PP_ICU_PLACEHOLDERS_REGEXP = /{([A-Z0-9_]+)}/g;
            /** @type {?} */
            var PP_ICUS_REGEXP = /�I18N_EXP_(ICU(_\d+)?)�/g;
            /** @type {?} */
            var PP_CLOSE_TEMPLATE_REGEXP = /\/\*/;
            /** @type {?} */
            var PP_TEMPLATE_ID_REGEXP = /\d+\:(\d+)/;
            /**
             * @record
             */
            function IcuExpression() { }
            if (false) { }
            /**
             * @record
             */
            function IcuCase() { }
            if (false) { }
            /**
             * Breaks pattern into strings and top level {...} blocks.
             * Can be used to break a message into text and ICU expressions, or to break an ICU expression into
             * keys and cases.
             * Original code from closure library, modified for Angular.
             *
             * @param {?} pattern (sub)Pattern to be broken.
             *
             * @return {?}
             */
            function extractParts(pattern) {
                if (!pattern) {
                    return [];
                }
                /** @type {?} */
                var prevPos = 0;
                /** @type {?} */
                var braceStack = [];
                /** @type {?} */
                var results = [];
                /** @type {?} */
                var braces = /[{}]/g;
                // lastIndex doesn't get set to 0 so we have to.
                braces.lastIndex = 0;
                /** @type {?} */
                var match;
                while (match = braces.exec(pattern)) {
                    /** @type {?} */
                    var pos = match.index;
                    if (match[0] == '}') {
                        braceStack.pop();
                        if (braceStack.length == 0) {
                            // End of the block.
                            /** @type {?} */
                            var block = pattern.substring(prevPos, pos);
                            if (ICU_BLOCK_REGEXP.test(block)) {
                                results.push(parseICUBlock(block));
                            }
                            else {
                                results.push(block);
                            }
                            prevPos = pos + 1;
                        }
                    }
                    else {
                        if (braceStack.length == 0) {
                            /** @type {?} */
                            var substring_1 = pattern.substring(prevPos, pos);
                            results.push(substring_1);
                            prevPos = pos + 1;
                        }
                        braceStack.push('{');
                    }
                }
                /** @type {?} */
                var substring = pattern.substring(prevPos);
                results.push(substring);
                return results;
            }
            /**
             * Parses text containing an ICU expression and produces a JSON object for it.
             * Original code from closure library, modified for Angular.
             *
             * @param {?} pattern Text containing an ICU expression that needs to be parsed.
             *
             * @return {?}
             */
            function parseICUBlock(pattern) {
                /** @type {?} */
                var cases = [];
                /** @type {?} */
                var values = [];
                /** @type {?} */
                var icuType = 1 /* plural */;
                /** @type {?} */
                var mainBinding = 0;
                pattern = pattern.replace(ICU_BLOCK_REGEXP, ( /**
                 * @param {?} str
                 * @param {?} binding
                 * @param {?} type
                 * @return {?}
                 */function (str, binding, type) {
                    if (type === 'select') {
                        icuType = 0 /* select */;
                    }
                    else {
                        icuType = 1 /* plural */;
                    }
                    mainBinding = parseInt(binding.substr(1), 10);
                    return '';
                }));
                /** @type {?} */
                var parts = ( /** @type {?} */(extractParts(pattern)));
                // Looking for (key block)+ sequence. One of the keys has to be "other".
                for (var pos = 0; pos < parts.length;) {
                    /** @type {?} */
                    var key = parts[pos++].trim();
                    if (icuType === 1 /* plural */) {
                        // Key can be "=x", we just want "x"
                        key = key.replace(/\s*(?:=)?(\w+)\s*/, '$1');
                    }
                    if (key.length) {
                        cases.push(key);
                    }
                    /** @type {?} */
                    var blocks = ( /** @type {?} */(extractParts(parts[pos++])));
                    if (cases.length > values.length) {
                        values.push(blocks);
                    }
                }
                assertGreaterThan(cases.indexOf('other'), -1, 'Missing key "other" in ICU statement.');
                // TODO(ocombe): support ICU expressions in attributes, see #21615
                return { type: icuType, mainBinding: mainBinding, cases: cases, values: values };
            }
            /**
             * Removes everything inside the sub-templates of a message.
             * @param {?} message
             * @return {?}
             */
            function removeInnerTemplateTranslation(message) {
                /** @type {?} */
                var match;
                /** @type {?} */
                var res = '';
                /** @type {?} */
                var index = 0;
                /** @type {?} */
                var inTemplate = false;
                /** @type {?} */
                var tagMatched;
                while ((match = SUBTEMPLATE_REGEXP.exec(message)) !== null) {
                    if (!inTemplate) {
                        res += message.substring(index, match.index + match[0].length);
                        tagMatched = match[1];
                        inTemplate = true;
                    }
                    else {
                        if (match[0] === MARKER + "/*" + tagMatched + MARKER) {
                            index = match.index;
                            inTemplate = false;
                        }
                    }
                }
                ngDevMode &&
                    assertEqual(inTemplate, false, "Tag mismatch: unable to find the end of the sub-template in the translation \"" + message + "\"");
                res += message.substr(index);
                return res;
            }
            /**
             * Extracts a part of a message and removes the rest.
             *
             * This method is used for extracting a part of the message associated with a template. A translated
             * message can span multiple templates.
             *
             * Example:
             * ```
             * <div i18n>Translate <span *ngIf>me</span>!</div>
             * ```
             *
             * @param {?} message The message to crop
             * @param {?=} subTemplateIndex Index of the sub-template to extract. If undefined it returns the
             * external template and removes all sub-templates.
             * @return {?}
             */
            function getTranslationForTemplate(message, subTemplateIndex) {
                if (typeof subTemplateIndex !== 'number') {
                    // We want the root template message, ignore all sub-templates
                    return removeInnerTemplateTranslation(message);
                }
                else {
                    // We want a specific sub-template
                    /** @type {?} */
                    var start = message.indexOf(":" + subTemplateIndex + MARKER) + 2 + subTemplateIndex.toString().length;
                    /** @type {?} */
                    var end = message.search(new RegExp(MARKER + "\\/\\*\\d+:" + subTemplateIndex + MARKER));
                    return removeInnerTemplateTranslation(message.substring(start, end));
                }
            }
            /**
             * Generate the OpCodes to update the bindings of a string.
             *
             * @param {?} str The string containing the bindings.
             * @param {?} destinationNode Index of the destination node which will receive the binding.
             * @param {?=} attrName Name of the attribute, if the string belongs to an attribute.
             * @param {?=} sanitizeFn Sanitization function used to sanitize the string after update, if necessary.
             * @return {?}
             */
            function generateBindingUpdateOpCodes(str, destinationNode, attrName, sanitizeFn) {
                if (sanitizeFn === void 0) { sanitizeFn = null; }
                /** @type {?} */
                var updateOpCodes = [null, null];
                // Alloc space for mask and size
                /** @type {?} */
                var textParts = str.split(BINDING_REGEXP);
                /** @type {?} */
                var mask = 0;
                for (var j = 0; j < textParts.length; j++) {
                    /** @type {?} */
                    var textValue = textParts[j];
                    if (j & 1) {
                        // Odd indexes are bindings
                        /** @type {?} */
                        var bindingIndex = parseInt(textValue, 10);
                        updateOpCodes.push(-1 - bindingIndex);
                        mask = mask | toMaskBit(bindingIndex);
                    }
                    else if (textValue !== '') {
                        // Even indexes are text
                        updateOpCodes.push(textValue);
                    }
                }
                updateOpCodes.push(destinationNode << 2 /* SHIFT_REF */ |
                    (attrName ? 1 /* Attr */ : 0 /* Text */));
                if (attrName) {
                    updateOpCodes.push(attrName, sanitizeFn);
                }
                updateOpCodes[0] = mask;
                updateOpCodes[1] = updateOpCodes.length - 2;
                return updateOpCodes;
            }
            /**
             * @param {?} icuExpression
             * @param {?=} mask
             * @return {?}
             */
            function getBindingMask(icuExpression, mask) {
                if (mask === void 0) { mask = 0; }
                mask = mask | toMaskBit(icuExpression.mainBinding);
                /** @type {?} */
                var match;
                for (var i = 0; i < icuExpression.values.length; i++) {
                    /** @type {?} */
                    var valueArr = icuExpression.values[i];
                    for (var j = 0; j < valueArr.length; j++) {
                        /** @type {?} */
                        var value = valueArr[j];
                        if (typeof value === 'string') {
                            while (match = BINDING_REGEXP.exec(value)) {
                                mask = mask | toMaskBit(parseInt(match[1], 10));
                            }
                        }
                        else {
                            mask = getBindingMask(( /** @type {?} */(value)), mask);
                        }
                    }
                }
                return mask;
            }
            /** @type {?} */
            var i18nIndexStack = [];
            /** @type {?} */
            var i18nIndexStackPointer = -1;
            /**
             * Convert binding index to mask bit.
             *
             * Each index represents a single bit on the bit-mask. Because bit-mask only has 32 bits, we make
             * the 32nd bit share all masks for all bindings higher than 32. Since it is extremely rare to have
             * more than 32 bindings this will be hit very rarely. The downside of hitting this corner case is
             * that we will execute binding code more often than necessary. (penalty of performance)
             * @param {?} bindingIndex
             * @return {?}
             */
            function toMaskBit(bindingIndex) {
                return 1 << Math.min(bindingIndex, 31);
            }
            /** @type {?} */
            var parentIndexStack = [];
            /**
             * Marks a block of text as translatable.
             *
             * The instructions `i18nStart` and `i18nEnd` mark the translation block in the template.
             * The translation `message` is the value which is locale specific. The translation string may
             * contain placeholders which associate inner elements and sub-templates within the translation.
             *
             * The translation `message` placeholders are:
             * - `�{index}(:{block})�`: *Binding Placeholder*: Marks a location where an expression will be
             *   interpolated into. The placeholder `index` points to the expression binding index. An optional
             *   `block` that matches the sub-template in which it was declared.
             * - `�#{index}(:{block})�`/`�/#{index}(:{block})�`: *Element Placeholder*:  Marks the beginning
             *   and end of DOM element that were embedded in the original translation block. The placeholder
             *   `index` points to the element index in the template instructions set. An optional `block` that
             *   matches the sub-template in which it was declared.
             * - `�!{index}(:{block})�`/`�/!{index}(:{block})�`: *Projection Placeholder*:  Marks the
             *   beginning and end of <ng-content> that was embedded in the original translation block.
             *   The placeholder `index` points to the element index in the template instructions set.
             *   An optional `block` that matches the sub-template in which it was declared.
             * - `�*{index}:{block}�`/`�/*{index}:{block}�`: *Sub-template Placeholder*: Sub-templates must be
             *   split up and translated separately in each angular template function. The `index` points to the
             *   `template` instruction index. A `block` that matches the sub-template in which it was declared.
             *
             * \@codeGenApi
             * @param {?} index A unique index of the translation in the static block.
             * @param {?} message The translation message.
             * @param {?=} subTemplateIndex Optional sub-template index in the `message`.
             *
             * @return {?}
             */
            function ɵɵi18nStart(index, message, subTemplateIndex) {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                ngDevMode && assertDefined(tView, "tView should be defined");
                i18nIndexStack[++i18nIndexStackPointer] = index;
                // We need to delay projections until `i18nEnd`
                setDelayProjection(true);
                if (tView.firstTemplatePass && tView.data[index + HEADER_OFFSET] === null) {
                    i18nStartFirstPass(tView, index, message, subTemplateIndex);
                }
            }
            // Count for the number of vars that will be allocated for each i18n block.
            // It is global because this is used in multiple functions that include loops and recursive calls.
            // This is reset to 0 when `i18nStartFirstPass` is called.
            /** @type {?} */
            var i18nVarsCount;
            /**
             * See `i18nStart` above.
             * @param {?} tView
             * @param {?} index
             * @param {?} message
             * @param {?=} subTemplateIndex
             * @return {?}
             */
            function i18nStartFirstPass(tView, index, message, subTemplateIndex) {
                /** @type {?} */
                var viewData = getLView();
                /** @type {?} */
                var startIndex = tView.blueprint.length - HEADER_OFFSET;
                i18nVarsCount = 0;
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                /** @type {?} */
                var parentTNode = getIsParent() ? getPreviousOrParentTNode() :
                    previousOrParentTNode && previousOrParentTNode.parent;
                /** @type {?} */
                var parentIndex = parentTNode && parentTNode !== viewData[T_HOST] ? parentTNode.index - HEADER_OFFSET : index;
                /** @type {?} */
                var parentIndexPointer = 0;
                parentIndexStack[parentIndexPointer] = parentIndex;
                /** @type {?} */
                var createOpCodes = [];
                // If the previous node wasn't the direct parent then we have a translation without top level
                // element and we need to keep a reference of the previous element if there is one
                if (index > 0 && previousOrParentTNode !== parentTNode) {
                    // Create an OpCode to select the previous TNode
                    createOpCodes.push(previousOrParentTNode.index << 3 /* SHIFT_REF */ | 0 /* Select */);
                }
                /** @type {?} */
                var updateOpCodes = [];
                /** @type {?} */
                var icuExpressions = [];
                /** @type {?} */
                var templateTranslation = getTranslationForTemplate(message, subTemplateIndex);
                /** @type {?} */
                var msgParts = replaceNgsp(templateTranslation).split(PH_REGEXP);
                for (var i = 0; i < msgParts.length; i++) {
                    /** @type {?} */
                    var value = msgParts[i];
                    if (i & 1) {
                        // Odd indexes are placeholders (elements and sub-templates)
                        if (value.charAt(0) === '/') {
                            // It is a closing tag
                            if (value.charAt(1) === "#" /* ELEMENT */) {
                                /** @type {?} */
                                var phIndex = parseInt(value.substr(2), 10);
                                parentIndex = parentIndexStack[--parentIndexPointer];
                                createOpCodes.push(phIndex << 3 /* SHIFT_REF */ | 5 /* ElementEnd */);
                            }
                        }
                        else {
                            /** @type {?} */
                            var phIndex = parseInt(value.substr(1), 10);
                            // The value represents a placeholder that we move to the designated index
                            createOpCodes.push(phIndex << 3 /* SHIFT_REF */ | 0 /* Select */, parentIndex << 17 /* SHIFT_PARENT */ | 1 /* AppendChild */);
                            if (value.charAt(0) === "#" /* ELEMENT */) {
                                parentIndexStack[++parentIndexPointer] = parentIndex = phIndex;
                            }
                        }
                    }
                    else {
                        // Even indexes are text (including bindings & ICU expressions)
                        /** @type {?} */
                        var parts = extractParts(value);
                        for (var j = 0; j < parts.length; j++) {
                            if (j & 1) {
                                // Odd indexes are ICU expressions
                                // Create the comment node that will anchor the ICU expression
                                /** @type {?} */
                                var icuNodeIndex = startIndex + i18nVarsCount++;
                                createOpCodes.push(COMMENT_MARKER, ngDevMode ? "ICU " + icuNodeIndex : '', icuNodeIndex, parentIndex << 17 /* SHIFT_PARENT */ | 1 /* AppendChild */);
                                // Update codes for the ICU expression
                                /** @type {?} */
                                var icuExpression = ( /** @type {?} */(parts[j]));
                                /** @type {?} */
                                var mask = getBindingMask(icuExpression);
                                icuStart(icuExpressions, icuExpression, icuNodeIndex, icuNodeIndex);
                                // Since this is recursive, the last TIcu that was pushed is the one we want
                                /** @type {?} */
                                var tIcuIndex = icuExpressions.length - 1;
                                updateOpCodes.push(toMaskBit(icuExpression.mainBinding), // mask of the main binding
                                3, // skip 3 opCodes if not changed
                                -1 - icuExpression.mainBinding, icuNodeIndex << 2 /* SHIFT_REF */ | 2 /* IcuSwitch */, tIcuIndex, mask, // mask of all the bindings of this ICU expression
                                2, // skip 2 opCodes if not changed
                                icuNodeIndex << 2 /* SHIFT_REF */ | 3 /* IcuUpdate */, tIcuIndex);
                            }
                            else if (parts[j] !== '') {
                                /** @type {?} */
                                var text = ( /** @type {?} */(parts[j]));
                                // Even indexes are text (including bindings)
                                /** @type {?} */
                                var hasBinding = text.match(BINDING_REGEXP);
                                // Create text nodes
                                /** @type {?} */
                                var textNodeIndex = startIndex + i18nVarsCount++;
                                createOpCodes.push(
                                // If there is a binding, the value will be set during update
                                hasBinding ? '' : text, textNodeIndex, parentIndex << 17 /* SHIFT_PARENT */ | 1 /* AppendChild */);
                                if (hasBinding) {
                                    addAllToArray(generateBindingUpdateOpCodes(text, textNodeIndex), updateOpCodes);
                                }
                            }
                        }
                    }
                }
                if (i18nVarsCount > 0) {
                    allocExpando(viewData, i18nVarsCount);
                }
                ngDevMode &&
                    attachI18nOpCodesDebug(createOpCodes, updateOpCodes, icuExpressions.length ? icuExpressions : null, viewData);
                // NOTE: local var needed to properly assert the type of `TI18n`.
                /** @type {?} */
                var tI18n = {
                    vars: i18nVarsCount,
                    create: createOpCodes,
                    update: updateOpCodes,
                    icus: icuExpressions.length ? icuExpressions : null,
                };
                tView.data[index + HEADER_OFFSET] = tI18n;
            }
            /**
             * @param {?} tNode
             * @param {?} parentTNode
             * @param {?} previousTNode
             * @param {?} viewData
             * @return {?}
             */
            function appendI18nNode(tNode, parentTNode, previousTNode, viewData) {
                ngDevMode && ngDevMode.rendererMoveNode++;
                /** @type {?} */
                var nextNode = tNode.next;
                if (!previousTNode) {
                    previousTNode = parentTNode;
                }
                // Re-organize node tree to put this node in the correct position.
                if (previousTNode === parentTNode && tNode !== parentTNode.child) {
                    tNode.next = parentTNode.child;
                    parentTNode.child = tNode;
                }
                else if (previousTNode !== parentTNode && tNode !== previousTNode.next) {
                    tNode.next = previousTNode.next;
                    previousTNode.next = tNode;
                }
                else {
                    tNode.next = null;
                }
                if (parentTNode !== viewData[T_HOST]) {
                    tNode.parent = ( /** @type {?} */(parentTNode));
                }
                // If tNode was moved around, we might need to fix a broken link.
                /** @type {?} */
                var cursor = tNode.next;
                while (cursor) {
                    if (cursor.next === tNode) {
                        cursor.next = nextNode;
                    }
                    cursor = cursor.next;
                }
                // If the placeholder to append is a projection, we need to move the projected nodes instead
                if (tNode.type === 1 /* Projection */) {
                    /** @type {?} */
                    var tProjectionNode = ( /** @type {?} */(tNode));
                    appendProjectedNodes(viewData, tProjectionNode, tProjectionNode.projection, findComponentView(viewData));
                    return tNode;
                }
                appendChild(getNativeByTNode(tNode, viewData), tNode, viewData);
                /** @type {?} */
                var slotValue = viewData[tNode.index];
                if (tNode.type !== 0 /* Container */ && isLContainer(slotValue)) {
                    // Nodes that inject ViewContainerRef also have a comment node that should be moved
                    appendChild(slotValue[NATIVE], tNode, viewData);
                }
                return tNode;
            }
            /**
             * Handles message string post-processing for internationalization.
             *
             * Handles message string post-processing by transforming it from intermediate
             * format (that might contain some markers that we need to replace) to the final
             * form, consumable by i18nStart instruction. Post processing steps include:
             *
             * 1. Resolve all multi-value cases (like [�*1:1��#2:1�|�#4:1�|�5�])
             * 2. Replace all ICU vars (like "VAR_PLURAL")
             * 3. Replace all placeholders used inside ICUs in a form of {PLACEHOLDER}
             * 4. Replace all ICU references with corresponding values (like �ICU_EXP_ICU_1�)
             *    in case multiple ICUs have the same placeholder name
             *
             * \@codeGenApi
             * @param {?} message Raw translation string for post processing
             * @param {?=} replacements Set of replacements that should be applied
             *
             * @return {?} Transformed string that can be consumed by i18nStart instruction
             *
             */
            function ɵɵi18nPostprocess(message, replacements) {
                if (replacements === void 0) { replacements = {}; }
                /**
                 * Step 1: resolve all multi-value placeholders like [�#5�|�*1:1��#2:1�|�#4:1�]
                 *
                 * Note: due to the way we process nested templates (BFS), multi-value placeholders are typically
                 * grouped by templates, for example: [�#5�|�#6�|�#1:1�|�#3:2�] where �#5� and �#6� belong to root
                 * template, �#1:1� belong to nested template with index 1 and �#1:2� - nested template with index
                 * 3. However in real templates the order might be different: i.e. �#1:1� and/or �#3:2� may go in
                 * front of �#6�. The post processing step restores the right order by keeping track of the
                 * template id stack and looks for placeholders that belong to the currently active template.
                 * @type {?}
                 */
                var result = message;
                if (PP_MULTI_VALUE_PLACEHOLDERS_REGEXP.test(message)) {
                    /** @type {?} */
                    var matches_1 = {};
                    /** @type {?} */
                    var templateIdsStack_1 = [ROOT_TEMPLATE_ID];
                    result = result.replace(PP_PLACEHOLDERS_REGEXP, ( /**
                     * @param {?} m
                     * @param {?} phs
                     * @param {?} tmpl
                     * @return {?}
                     */function (m, phs, tmpl) {
                        /** @type {?} */
                        var content = phs || tmpl;
                        /** @type {?} */
                        var placeholders = matches_1[content] || [];
                        if (!placeholders.length) {
                            content.split('|').forEach(( /**
                             * @param {?} placeholder
                             * @return {?}
                             */function (placeholder) {
                                /** @type {?} */
                                var match = placeholder.match(PP_TEMPLATE_ID_REGEXP);
                                /** @type {?} */
                                var templateId = match ? parseInt(match[1], 10) : ROOT_TEMPLATE_ID;
                                /** @type {?} */
                                var isCloseTemplateTag = PP_CLOSE_TEMPLATE_REGEXP.test(placeholder);
                                placeholders.push([templateId, isCloseTemplateTag, placeholder]);
                            }));
                            matches_1[content] = placeholders;
                        }
                        if (!placeholders.length) {
                            throw new Error("i18n postprocess: unmatched placeholder - " + content);
                        }
                        /** @type {?} */
                        var currentTemplateId = templateIdsStack_1[templateIdsStack_1.length - 1];
                        /** @type {?} */
                        var idx = 0;
                        // find placeholder index that matches current template id
                        for (var i = 0; i < placeholders.length; i++) {
                            if (placeholders[i][0] === currentTemplateId) {
                                idx = i;
                                break;
                            }
                        }
                        // update template id stack based on the current tag extracted
                        var _c = placeholders[idx], templateId = _c[0], isCloseTemplateTag = _c[1], placeholder = _c[2];
                        if (isCloseTemplateTag) {
                            templateIdsStack_1.pop();
                        }
                        else if (currentTemplateId !== templateId) {
                            templateIdsStack_1.push(templateId);
                        }
                        // remove processed tag from the list
                        placeholders.splice(idx, 1);
                        return placeholder;
                    }));
                }
                // return current result if no replacements specified
                if (!Object.keys(replacements).length) {
                    return result;
                }
                /**
                 * Step 2: replace all ICU vars (like "VAR_PLURAL")
                 */
                result = result.replace(PP_ICU_VARS_REGEXP, ( /**
                 * @param {?} match
                 * @param {?} start
                 * @param {?} key
                 * @param {?} _type
                 * @param {?} _idx
                 * @param {?} end
                 * @return {?}
                 */function (match, start, key, _type, _idx, end) {
                    return replacements.hasOwnProperty(key) ? "" + start + replacements[key] + end : match;
                }));
                /**
                 * Step 3: replace all placeholders used inside ICUs in a form of {PLACEHOLDER}
                 */
                result = result.replace(PP_ICU_PLACEHOLDERS_REGEXP, ( /**
                 * @param {?} match
                 * @param {?} key
                 * @return {?}
                 */function (match, key) {
                    return replacements.hasOwnProperty(key) ? ( /** @type {?} */(replacements[key])) : match;
                }));
                /**
                 * Step 4: replace all ICU references with corresponding values (like �ICU_EXP_ICU_1�) in case
                 * multiple ICUs have the same placeholder name
                 */
                result = result.replace(PP_ICUS_REGEXP, ( /**
                 * @param {?} match
                 * @param {?} key
                 * @return {?}
                 */function (match, key) {
                    if (replacements.hasOwnProperty(key)) {
                        /** @type {?} */
                        var list = ( /** @type {?} */(replacements[key]));
                        if (!list.length) {
                            throw new Error("i18n postprocess: unmatched ICU - " + match + " with key: " + key);
                        }
                        return ( /** @type {?} */(list.shift()));
                    }
                    return match;
                }));
                return result;
            }
            /**
             * Translates a translation block marked by `i18nStart` and `i18nEnd`. It inserts the text/ICU nodes
             * into the render tree, moves the placeholder nodes and removes the deleted nodes.
             *
             * \@codeGenApi
             * @return {?}
             */
            function ɵɵi18nEnd() {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                ngDevMode && assertDefined(tView, "tView should be defined");
                i18nEndFirstPass(tView);
                // Stop delaying projections
                setDelayProjection(false);
            }
            /**
             * See `i18nEnd` above.
             * @param {?} tView
             * @return {?}
             */
            function i18nEndFirstPass(tView) {
                /** @type {?} */
                var viewData = getLView();
                ngDevMode && assertEqual(viewData[BINDING_INDEX], viewData[TVIEW].bindingStartIndex, 'i18nEnd should be called before any binding');
                /** @type {?} */
                var rootIndex = i18nIndexStack[i18nIndexStackPointer--];
                /** @type {?} */
                var tI18n = ( /** @type {?} */(tView.data[rootIndex + HEADER_OFFSET]));
                ngDevMode && assertDefined(tI18n, "You should call i18nStart before i18nEnd");
                // Find the last node that was added before `i18nEnd`
                /** @type {?} */
                var lastCreatedNode = getPreviousOrParentTNode();
                // Read the instructions to insert/move/remove DOM elements
                /** @type {?} */
                var visitedNodes = readCreateOpCodes(rootIndex, tI18n.create, tI18n.icus, viewData);
                // Remove deleted nodes
                for (var i = rootIndex + 1; i <= lastCreatedNode.index - HEADER_OFFSET; i++) {
                    if (visitedNodes.indexOf(i) === -1) {
                        removeNode(i, viewData);
                    }
                }
            }
            /**
             * Creates and stores the dynamic TNode, and unhooks it from the tree for now.
             * @param {?} lView
             * @param {?} index
             * @param {?} type
             * @param {?} native
             * @param {?} name
             * @return {?}
             */
            function createDynamicNodeAtIndex(lView, index, type, native, name) {
                /** @type {?} */
                var previousOrParentTNode = getPreviousOrParentTNode();
                ngDevMode && assertDataInRange(lView, index + HEADER_OFFSET);
                lView[index + HEADER_OFFSET] = native;
                /** @type {?} */
                var tNode = getOrCreateTNode(lView[TVIEW], lView[T_HOST], index, ( /** @type {?} */(type)), name, null);
                // We are creating a dynamic node, the previous tNode might not be pointing at this node.
                // We will link ourselves into the tree later with `appendI18nNode`.
                if (previousOrParentTNode.next === tNode) {
                    previousOrParentTNode.next = null;
                }
                return tNode;
            }
            /**
             * @param {?} index
             * @param {?} createOpCodes
             * @param {?} icus
             * @param {?} viewData
             * @return {?}
             */
            function readCreateOpCodes(index, createOpCodes, icus, viewData) {
                /** @type {?} */
                var renderer = getLView()[RENDERER];
                /** @type {?} */
                var currentTNode = null;
                /** @type {?} */
                var previousTNode = null;
                /** @type {?} */
                var visitedNodes = [];
                for (var i = 0; i < createOpCodes.length; i++) {
                    /** @type {?} */
                    var opCode = createOpCodes[i];
                    if (typeof opCode == 'string') {
                        /** @type {?} */
                        var textRNode = createTextNode(opCode, renderer);
                        /** @type {?} */
                        var textNodeIndex = ( /** @type {?} */(createOpCodes[++i]));
                        ngDevMode && ngDevMode.rendererCreateTextNode++;
                        previousTNode = currentTNode;
                        currentTNode =
                            createDynamicNodeAtIndex(viewData, textNodeIndex, 3 /* Element */, textRNode, null);
                        visitedNodes.push(textNodeIndex);
                        setIsNotParent();
                    }
                    else if (typeof opCode == 'number') {
                        switch (opCode & 7 /* MASK_OPCODE */) {
                            case 1 /* AppendChild */:
                                /** @type {?} */
                                var destinationNodeIndex = opCode >>> 17 /* SHIFT_PARENT */;
                                /** @type {?} */
                                var destinationTNode = void 0;
                                if (destinationNodeIndex === index) {
                                    // If the destination node is `i18nStart`, we don't have a
                                    // top-level node and we should use the host node instead
                                    destinationTNode = ( /** @type {?} */(viewData[T_HOST]));
                                }
                                else {
                                    destinationTNode = getTNode(destinationNodeIndex, viewData);
                                }
                                ngDevMode &&
                                    assertDefined(( /** @type {?} */(currentTNode)), "You need to create or select a node before you can insert it into the DOM");
                                previousTNode = appendI18nNode(( /** @type {?} */(currentTNode)), destinationTNode, previousTNode, viewData);
                                break;
                            case 0 /* Select */:
                                /** @type {?} */
                                var nodeIndex = opCode >>> 3 /* SHIFT_REF */;
                                visitedNodes.push(nodeIndex);
                                previousTNode = currentTNode;
                                currentTNode = getTNode(nodeIndex, viewData);
                                if (currentTNode) {
                                    setPreviousOrParentTNode(currentTNode, currentTNode.type === 3 /* Element */);
                                }
                                break;
                            case 5 /* ElementEnd */:
                                /** @type {?} */
                                var elementIndex = opCode >>> 3 /* SHIFT_REF */;
                                previousTNode = currentTNode = getTNode(elementIndex, viewData);
                                setPreviousOrParentTNode(currentTNode, false);
                                break;
                            case 4 /* Attr */:
                                /** @type {?} */
                                var elementNodeIndex = opCode >>> 3 /* SHIFT_REF */;
                                /** @type {?} */
                                var attrName = ( /** @type {?} */(createOpCodes[++i]));
                                /** @type {?} */
                                var attrValue = ( /** @type {?} */(createOpCodes[++i]));
                                // This code is used for ICU expressions only, since we don't support
                                // directives/components in ICUs, we don't need to worry about inputs here
                                elementAttributeInternal(elementNodeIndex, attrName, attrValue, viewData);
                                break;
                            default:
                                throw new Error("Unable to determine the type of mutate operation for \"" + opCode + "\"");
                        }
                    }
                    else {
                        switch (opCode) {
                            case COMMENT_MARKER:
                                /** @type {?} */
                                var commentValue = ( /** @type {?} */(createOpCodes[++i]));
                                /** @type {?} */
                                var commentNodeIndex = ( /** @type {?} */(createOpCodes[++i]));
                                ngDevMode && assertEqual(typeof commentValue, 'string', "Expected \"" + commentValue + "\" to be a comment node value");
                                /** @type {?} */
                                var commentRNode = renderer.createComment(commentValue);
                                ngDevMode && ngDevMode.rendererCreateComment++;
                                previousTNode = currentTNode;
                                currentTNode = createDynamicNodeAtIndex(viewData, commentNodeIndex, 5 /* IcuContainer */, commentRNode, null);
                                visitedNodes.push(commentNodeIndex);
                                attachPatchData(commentRNode, viewData);
                                (( /** @type {?} */(currentTNode))).activeCaseIndex = null;
                                // We will add the case nodes later, during the update phase
                                setIsNotParent();
                                break;
                            case ELEMENT_MARKER:
                                /** @type {?} */
                                var tagNameValue = ( /** @type {?} */(createOpCodes[++i]));
                                /** @type {?} */
                                var elementNodeIndex = ( /** @type {?} */(createOpCodes[++i]));
                                ngDevMode && assertEqual(typeof tagNameValue, 'string', "Expected \"" + tagNameValue + "\" to be an element node tag name");
                                /** @type {?} */
                                var elementRNode = renderer.createElement(tagNameValue);
                                ngDevMode && ngDevMode.rendererCreateElement++;
                                previousTNode = currentTNode;
                                currentTNode = createDynamicNodeAtIndex(viewData, elementNodeIndex, 3 /* Element */, elementRNode, tagNameValue);
                                visitedNodes.push(elementNodeIndex);
                                break;
                            default:
                                throw new Error("Unable to determine the type of mutate operation for \"" + opCode + "\"");
                        }
                    }
                }
                setIsNotParent();
                return visitedNodes;
            }
            /**
             * @param {?} updateOpCodes
             * @param {?} icus
             * @param {?} bindingsStartIndex
             * @param {?} changeMask
             * @param {?} viewData
             * @param {?=} bypassCheckBit
             * @return {?}
             */
            function readUpdateOpCodes(updateOpCodes, icus, bindingsStartIndex, changeMask, viewData, bypassCheckBit) {
                if (bypassCheckBit === void 0) { bypassCheckBit = false; }
                /** @type {?} */
                var caseCreated = false;
                for (var i = 0; i < updateOpCodes.length; i++) {
                    // bit code to check if we should apply the next update
                    /** @type {?} */
                    var checkBit = ( /** @type {?} */(updateOpCodes[i]));
                    // Number of opCodes to skip until next set of update codes
                    /** @type {?} */
                    var skipCodes = ( /** @type {?} */(updateOpCodes[++i]));
                    if (bypassCheckBit || (checkBit & changeMask)) {
                        // The value has been updated since last checked
                        /** @type {?} */
                        var value = '';
                        for (var j = i + 1; j <= (i + skipCodes); j++) {
                            /** @type {?} */
                            var opCode = updateOpCodes[j];
                            if (typeof opCode == 'string') {
                                value += opCode;
                            }
                            else if (typeof opCode == 'number') {
                                if (opCode < 0) {
                                    // It's a binding index whose value is negative
                                    value += renderStringify(viewData[bindingsStartIndex - opCode]);
                                }
                                else {
                                    /** @type {?} */
                                    var nodeIndex = opCode >>> 2 /* SHIFT_REF */;
                                    /** @type {?} */
                                    var tIcuIndex = void 0;
                                    /** @type {?} */
                                    var tIcu = void 0;
                                    /** @type {?} */
                                    var icuTNode = void 0;
                                    switch (opCode & 3 /* MASK_OPCODE */) {
                                        case 1 /* Attr */:
                                            /** @type {?} */
                                            var propName = ( /** @type {?} */(updateOpCodes[++j]));
                                            /** @type {?} */
                                            var sanitizeFn = ( /** @type {?} */(updateOpCodes[++j]));
                                            elementPropertyInternal(nodeIndex, propName, value, sanitizeFn);
                                            break;
                                        case 0 /* Text */:
                                            textBindingInternal(viewData, nodeIndex, value);
                                            break;
                                        case 2 /* IcuSwitch */:
                                            tIcuIndex = ( /** @type {?} */(updateOpCodes[++j]));
                                            tIcu = ( /** @type {?} */(icus))[tIcuIndex];
                                            icuTNode = ( /** @type {?} */(getTNode(nodeIndex, viewData)));
                                            // If there is an active case, delete the old nodes
                                            if (icuTNode.activeCaseIndex !== null) {
                                                /** @type {?} */
                                                var removeCodes = tIcu.remove[icuTNode.activeCaseIndex];
                                                for (var k = 0; k < removeCodes.length; k++) {
                                                    /** @type {?} */
                                                    var removeOpCode = ( /** @type {?} */(removeCodes[k]));
                                                    switch (removeOpCode & 7 /* MASK_OPCODE */) {
                                                        case 3 /* Remove */:
                                                            /** @type {?} */
                                                            var nodeIndex_1 = removeOpCode >>> 3 /* SHIFT_REF */;
                                                            removeNode(nodeIndex_1, viewData);
                                                            break;
                                                        case 6 /* RemoveNestedIcu */:
                                                            /** @type {?} */
                                                            var nestedIcuNodeIndex = ( /** @type {?} */(removeCodes[k + 1])) >>> 3 /* SHIFT_REF */;
                                                            /** @type {?} */
                                                            var nestedIcuTNode = ( /** @type {?} */(getTNode(nestedIcuNodeIndex, viewData)));
                                                            /** @type {?} */
                                                            var activeIndex = nestedIcuTNode.activeCaseIndex;
                                                            if (activeIndex !== null) {
                                                                /** @type {?} */
                                                                var nestedIcuTIndex = removeOpCode >>> 3 /* SHIFT_REF */;
                                                                /** @type {?} */
                                                                var nestedTIcu = ( /** @type {?} */(icus))[nestedIcuTIndex];
                                                                addAllToArray(nestedTIcu.remove[activeIndex], removeCodes);
                                                            }
                                                            break;
                                                    }
                                                }
                                            }
                                            // Update the active caseIndex
                                            /** @type {?} */
                                            var caseIndex = getCaseIndex(tIcu, value);
                                            icuTNode.activeCaseIndex = caseIndex !== -1 ? caseIndex : null;
                                            // Add the nodes for the new case
                                            readCreateOpCodes(-1, tIcu.create[caseIndex], icus, viewData);
                                            caseCreated = true;
                                            break;
                                        case 3 /* IcuUpdate */:
                                            tIcuIndex = ( /** @type {?} */(updateOpCodes[++j]));
                                            tIcu = ( /** @type {?} */(icus))[tIcuIndex];
                                            icuTNode = ( /** @type {?} */(getTNode(nodeIndex, viewData)));
                                            readUpdateOpCodes(tIcu.update[( /** @type {?} */(icuTNode.activeCaseIndex))], icus, bindingsStartIndex, changeMask, viewData, caseCreated);
                                            break;
                                    }
                                }
                            }
                        }
                    }
                    i += skipCodes;
                }
            }
            /**
             * @param {?} index
             * @param {?} viewData
             * @return {?}
             */
            function removeNode(index, viewData) {
                /** @type {?} */
                var removedPhTNode = getTNode(index, viewData);
                /** @type {?} */
                var removedPhRNode = getNativeByIndex(index, viewData);
                if (removedPhRNode) {
                    nativeRemoveNode(viewData[RENDERER], removedPhRNode);
                }
                /** @type {?} */
                var slotValue = ( /** @type {?} */(ɵɵload(index)));
                if (isLContainer(slotValue)) {
                    /** @type {?} */
                    var lContainer = ( /** @type {?} */(slotValue));
                    if (removedPhTNode.type !== 0 /* Container */) {
                        nativeRemoveNode(viewData[RENDERER], lContainer[NATIVE]);
                    }
                }
                // Define this node as detached so that we don't risk projecting it
                removedPhTNode.flags |= 32 /* isDetached */;
                ngDevMode && ngDevMode.rendererRemoveNode++;
            }
            /**
             *
             * Use this instruction to create a translation block that doesn't contain any placeholder.
             * It calls both {\@link i18nStart} and {\@link i18nEnd} in one instruction.
             *
             * The translation `message` is the value which is locale specific. The translation string may
             * contain placeholders which associate inner elements and sub-templates within the translation.
             *
             * The translation `message` placeholders are:
             * - `�{index}(:{block})�`: *Binding Placeholder*: Marks a location where an expression will be
             *   interpolated into. The placeholder `index` points to the expression binding index. An optional
             *   `block` that matches the sub-template in which it was declared.
             * - `�#{index}(:{block})�`/`�/#{index}(:{block})�`: *Element Placeholder*:  Marks the beginning
             *   and end of DOM element that were embedded in the original translation block. The placeholder
             *   `index` points to the element index in the template instructions set. An optional `block` that
             *   matches the sub-template in which it was declared.
             * - `�*{index}:{block}�`/`�/*{index}:{block}�`: *Sub-template Placeholder*: Sub-templates must be
             *   split up and translated separately in each angular template function. The `index` points to the
             *   `template` instruction index. A `block` that matches the sub-template in which it was declared.
             *
             * \@codeGenApi
             * @param {?} index A unique index of the translation in the static block.
             * @param {?} message The translation message.
             * @param {?=} subTemplateIndex Optional sub-template index in the `message`.
             *
             * @return {?}
             */
            function ɵɵi18n(index, message, subTemplateIndex) {
                ɵɵi18nStart(index, message, subTemplateIndex);
                ɵɵi18nEnd();
            }
            /**
             * Marks a list of attributes as translatable.
             *
             * \@codeGenApi
             * @param {?} index A unique index in the static block
             * @param {?} values
             *
             * @return {?}
             */
            function ɵɵi18nAttributes(index, values) {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                ngDevMode && assertDefined(tView, "tView should be defined");
                i18nAttributesFirstPass(tView, index, values);
            }
            /**
             * See `i18nAttributes` above.
             * @param {?} tView
             * @param {?} index
             * @param {?} values
             * @return {?}
             */
            function i18nAttributesFirstPass(tView, index, values) {
                /** @type {?} */
                var previousElement = getPreviousOrParentTNode();
                /** @type {?} */
                var previousElementIndex = previousElement.index - HEADER_OFFSET;
                /** @type {?} */
                var updateOpCodes = [];
                for (var i = 0; i < values.length; i += 2) {
                    /** @type {?} */
                    var attrName = values[i];
                    /** @type {?} */
                    var message = values[i + 1];
                    /** @type {?} */
                    var parts = message.split(ICU_REGEXP);
                    for (var j = 0; j < parts.length; j++) {
                        /** @type {?} */
                        var value = parts[j];
                        if (j & 1) {
                            // Odd indexes are ICU expressions
                            // TODO(ocombe): support ICU expressions in attributes
                            throw new Error('ICU expressions are not yet supported in attributes');
                        }
                        else if (value !== '') {
                            // Even indexes are text (including bindings)
                            /** @type {?} */
                            var hasBinding = !!value.match(BINDING_REGEXP);
                            if (hasBinding) {
                                if (tView.firstTemplatePass && tView.data[index + HEADER_OFFSET] === null) {
                                    addAllToArray(generateBindingUpdateOpCodes(value, previousElementIndex, attrName), updateOpCodes);
                                }
                            }
                            else {
                                /** @type {?} */
                                var lView_7 = getLView();
                                elementAttributeInternal(previousElementIndex, attrName, value, lView_7);
                                // Check if that attribute is a directive input
                                /** @type {?} */
                                var tNode = getTNode(previousElementIndex, lView_7);
                                /** @type {?} */
                                var dataValue = tNode.inputs && tNode.inputs[attrName];
                                if (dataValue) {
                                    setInputsForProperty(lView_7, dataValue, value);
                                }
                            }
                        }
                    }
                }
                if (tView.firstTemplatePass && tView.data[index + HEADER_OFFSET] === null) {
                    tView.data[index + HEADER_OFFSET] = updateOpCodes;
                }
            }
            /** @type {?} */
            var changeMask = 0;
            /** @type {?} */
            var shiftsCounter = 0;
            /**
             * Stores the values of the bindings during each update cycle in order to determine if we need to
             * update the translated nodes.
             *
             * \@codeGenApi
             * @template T
             * @param {?} value The binding's value
             * @return {?} This function returns itself so that it may be chained
             * (e.g. `i18nExp(ctx.name)(ctx.title)`)
             *
             */
            function ɵɵi18nExp(value) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var expression = bind(lView, value);
                if (expression !== NO_CHANGE) {
                    changeMask = changeMask | (1 << shiftsCounter);
                }
                shiftsCounter++;
                return ɵɵi18nExp;
            }
            /**
             * Updates a translation block or an i18n attribute when the bindings have changed.
             *
             * \@codeGenApi
             * @param {?} index Index of either {\@link i18nStart} (translation block) or {\@link i18nAttributes}
             * (i18n attribute) on which it should update the content.
             *
             * @return {?}
             */
            function ɵɵi18nApply(index) {
                if (shiftsCounter) {
                    /** @type {?} */
                    var lView_8 = getLView();
                    /** @type {?} */
                    var tView = lView_8[TVIEW];
                    ngDevMode && assertDefined(tView, "tView should be defined");
                    /** @type {?} */
                    var tI18n = tView.data[index + HEADER_OFFSET];
                    /** @type {?} */
                    var updateOpCodes = void 0;
                    /** @type {?} */
                    var icus = null;
                    if (Array.isArray(tI18n)) {
                        updateOpCodes = ( /** @type {?} */(tI18n));
                    }
                    else {
                        updateOpCodes = (( /** @type {?} */(tI18n))).update;
                        icus = (( /** @type {?} */(tI18n))).icus;
                    }
                    /** @type {?} */
                    var bindingsStartIndex = lView_8[BINDING_INDEX] - shiftsCounter - 1;
                    readUpdateOpCodes(updateOpCodes, icus, bindingsStartIndex, changeMask, lView_8);
                    // Reset changeMask & maskBit to default for the next update cycle
                    changeMask = 0;
                    shiftsCounter = 0;
                }
            }
            /**
             * Returns the index of the current case of an ICU expression depending on the main binding value
             *
             * @param {?} icuExpression
             * @param {?} bindingValue The value of the main binding used by this ICU expression
             * @return {?}
             */
            function getCaseIndex(icuExpression, bindingValue) {
                /** @type {?} */
                var index = icuExpression.cases.indexOf(bindingValue);
                if (index === -1) {
                    switch (icuExpression.type) {
                        case 1 /* plural */: {
                            /** @type {?} */
                            var resolvedCase = getPluralCase(bindingValue, getLocaleId());
                            index = icuExpression.cases.indexOf(resolvedCase);
                            if (index === -1 && resolvedCase !== 'other') {
                                index = icuExpression.cases.indexOf('other');
                            }
                            break;
                        }
                        case 0 /* select */: {
                            index = icuExpression.cases.indexOf('other');
                            break;
                        }
                    }
                }
                return index;
            }
            /**
             * Generate the OpCodes for ICU expressions.
             *
             * @param {?} tIcus
             * @param {?} icuExpression
             * @param {?} startIndex
             * @param {?} expandoStartIndex
             * @return {?}
             */
            function icuStart(tIcus, icuExpression, startIndex, expandoStartIndex) {
                /** @type {?} */
                var createCodes = [];
                /** @type {?} */
                var removeCodes = [];
                /** @type {?} */
                var updateCodes = [];
                /** @type {?} */
                var vars = [];
                /** @type {?} */
                var childIcus = [];
                for (var i = 0; i < icuExpression.values.length; i++) {
                    // Each value is an array of strings & other ICU expressions
                    /** @type {?} */
                    var valueArr = icuExpression.values[i];
                    /** @type {?} */
                    var nestedIcus = [];
                    for (var j = 0; j < valueArr.length; j++) {
                        /** @type {?} */
                        var value = valueArr[j];
                        if (typeof value !== 'string') {
                            // It is an nested ICU expression
                            /** @type {?} */
                            var icuIndex = nestedIcus.push(( /** @type {?} */(value))) - 1;
                            // Replace nested ICU expression by a comment node
                            valueArr[j] = "<!--\uFFFD" + icuIndex + "\uFFFD-->";
                        }
                    }
                    /** @type {?} */
                    var icuCase = parseIcuCase(valueArr.join(''), startIndex, nestedIcus, tIcus, expandoStartIndex);
                    createCodes.push(icuCase.create);
                    removeCodes.push(icuCase.remove);
                    updateCodes.push(icuCase.update);
                    vars.push(icuCase.vars);
                    childIcus.push(icuCase.childIcus);
                }
                /** @type {?} */
                var tIcu = {
                    type: icuExpression.type,
                    vars: vars,
                    childIcus: childIcus,
                    cases: icuExpression.cases,
                    create: createCodes,
                    remove: removeCodes,
                    update: updateCodes
                };
                tIcus.push(tIcu);
                // Adding the maximum possible of vars needed (based on the cases with the most vars)
                i18nVarsCount += Math.max.apply(Math, vars);
            }
            /**
             * Transforms a string template into an HTML template and a list of instructions used to update
             * attributes or nodes that contain bindings.
             *
             * @param {?} unsafeHtml The string to parse
             * @param {?} parentIndex
             * @param {?} nestedIcus
             * @param {?} tIcus
             * @param {?} expandoStartIndex
             * @return {?}
             */
            function parseIcuCase(unsafeHtml, parentIndex, nestedIcus, tIcus, expandoStartIndex) {
                /** @type {?} */
                var inertBodyHelper = new InertBodyHelper(document);
                /** @type {?} */
                var inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
                if (!inertBodyElement) {
                    throw new Error('Unable to generate inert body element');
                }
                /** @type {?} */
                var wrapper = ( /** @type {?} */(getTemplateContent(( /** @type {?} */(inertBodyElement))))) || inertBodyElement;
                /** @type {?} */
                var opCodes = { vars: 0, childIcus: [], create: [], remove: [], update: [] };
                parseNodes(wrapper.firstChild, opCodes, parentIndex, nestedIcus, tIcus, expandoStartIndex);
                return opCodes;
            }
            /** @type {?} */
            var NESTED_ICU = /�(\d+)�/;
            /**
             * Parses a node, its children and its siblings, and generates the mutate & update OpCodes.
             *
             * @param {?} currentNode The first node to parse
             * @param {?} icuCase The data for the ICU expression case that contains those nodes
             * @param {?} parentIndex Index of the current node's parent
             * @param {?} nestedIcus Data for the nested ICU expressions that this case contains
             * @param {?} tIcus Data for all ICU expressions of the current message
             * @param {?} expandoStartIndex Expando start index for the current ICU expression
             * @return {?}
             */
            function parseNodes(currentNode, icuCase, parentIndex, nestedIcus, tIcus, expandoStartIndex) {
                if (currentNode) {
                    /** @type {?} */
                    var nestedIcusToCreate = [];
                    while (currentNode) {
                        /** @type {?} */
                        var nextNode = currentNode.nextSibling;
                        /** @type {?} */
                        var newIndex = expandoStartIndex + ++icuCase.vars;
                        switch (currentNode.nodeType) {
                            case Node.ELEMENT_NODE:
                                /** @type {?} */
                                var element = ( /** @type {?} */(currentNode));
                                /** @type {?} */
                                var tagName = element.tagName.toLowerCase();
                                if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
                                    // This isn't a valid element, we won't create an element for it
                                    icuCase.vars--;
                                }
                                else {
                                    icuCase.create.push(ELEMENT_MARKER, tagName, newIndex, parentIndex << 17 /* SHIFT_PARENT */ | 1 /* AppendChild */);
                                    /** @type {?} */
                                    var elAttrs = element.attributes;
                                    for (var i = 0; i < elAttrs.length; i++) {
                                        /** @type {?} */
                                        var attr = ( /** @type {?} */(elAttrs.item(i)));
                                        /** @type {?} */
                                        var lowerAttrName = attr.name.toLowerCase();
                                        /** @type {?} */
                                        var hasBinding_1 = !!attr.value.match(BINDING_REGEXP);
                                        // we assume the input string is safe, unless it's using a binding
                                        if (hasBinding_1) {
                                            if (VALID_ATTRS.hasOwnProperty(lowerAttrName)) {
                                                if (URI_ATTRS[lowerAttrName]) {
                                                    addAllToArray(generateBindingUpdateOpCodes(attr.value, newIndex, attr.name, _sanitizeUrl), icuCase.update);
                                                }
                                                else if (SRCSET_ATTRS[lowerAttrName]) {
                                                    addAllToArray(generateBindingUpdateOpCodes(attr.value, newIndex, attr.name, sanitizeSrcset), icuCase.update);
                                                }
                                                else {
                                                    addAllToArray(generateBindingUpdateOpCodes(attr.value, newIndex, attr.name), icuCase.update);
                                                }
                                            }
                                            else {
                                                ngDevMode &&
                                                    console.warn("WARNING: ignoring unsafe attribute value " + lowerAttrName + " on element " + tagName + " (see http://g.co/ng/security#xss)");
                                            }
                                        }
                                        else {
                                            icuCase.create.push(newIndex << 3 /* SHIFT_REF */ | 4 /* Attr */, attr.name, attr.value);
                                        }
                                    }
                                    // Parse the children of this node (if any)
                                    parseNodes(currentNode.firstChild, icuCase, newIndex, nestedIcus, tIcus, expandoStartIndex);
                                    // Remove the parent node after the children
                                    icuCase.remove.push(newIndex << 3 /* SHIFT_REF */ | 3 /* Remove */);
                                }
                                break;
                            case Node.TEXT_NODE:
                                /** @type {?} */
                                var value = currentNode.textContent || '';
                                /** @type {?} */
                                var hasBinding = value.match(BINDING_REGEXP);
                                icuCase.create.push(hasBinding ? '' : value, newIndex, parentIndex << 17 /* SHIFT_PARENT */ | 1 /* AppendChild */);
                                icuCase.remove.push(newIndex << 3 /* SHIFT_REF */ | 3 /* Remove */);
                                if (hasBinding) {
                                    addAllToArray(generateBindingUpdateOpCodes(value, newIndex), icuCase.update);
                                }
                                break;
                            case Node.COMMENT_NODE:
                                // Check if the comment node is a placeholder for a nested ICU
                                /** @type {?} */
                                var match = NESTED_ICU.exec(currentNode.textContent || '');
                                if (match) {
                                    /** @type {?} */
                                    var nestedIcuIndex = parseInt(match[1], 10);
                                    /** @type {?} */
                                    var newLocal = ngDevMode ? "nested ICU " + nestedIcuIndex : '';
                                    // Create the comment node that will anchor the ICU expression
                                    icuCase.create.push(COMMENT_MARKER, newLocal, newIndex, parentIndex << 17 /* SHIFT_PARENT */ | 1 /* AppendChild */);
                                    /** @type {?} */
                                    var nestedIcu = nestedIcus[nestedIcuIndex];
                                    nestedIcusToCreate.push([nestedIcu, newIndex]);
                                }
                                else {
                                    // We do not handle any other type of comment
                                    icuCase.vars--;
                                }
                                break;
                            default:
                                // We do not handle any other type of element
                                icuCase.vars--;
                        }
                        currentNode = ( /** @type {?} */(nextNode));
                    }
                    for (var i = 0; i < nestedIcusToCreate.length; i++) {
                        /** @type {?} */
                        var nestedIcu = nestedIcusToCreate[i][0];
                        /** @type {?} */
                        var nestedIcuNodeIndex = nestedIcusToCreate[i][1];
                        icuStart(tIcus, nestedIcu, nestedIcuNodeIndex, expandoStartIndex + icuCase.vars);
                        // Since this is recursive, the last TIcu that was pushed is the one we want
                        /** @type {?} */
                        var nestTIcuIndex = tIcus.length - 1;
                        icuCase.vars += Math.max.apply(Math, tIcus[nestTIcuIndex].vars);
                        icuCase.childIcus.push(nestTIcuIndex);
                        /** @type {?} */
                        var mask = getBindingMask(nestedIcu);
                        icuCase.update.push(toMaskBit(nestedIcu.mainBinding), // mask of the main binding
                        3, // skip 3 opCodes if not changed
                        -1 - nestedIcu.mainBinding, nestedIcuNodeIndex << 2 /* SHIFT_REF */ | 2 /* IcuSwitch */, nestTIcuIndex, mask, // mask of all the bindings of this ICU expression
                        2, // skip 2 opCodes if not changed
                        nestedIcuNodeIndex << 2 /* SHIFT_REF */ | 3 /* IcuUpdate */, nestTIcuIndex);
                        icuCase.remove.push(nestTIcuIndex << 3 /* SHIFT_REF */ | 6 /* RemoveNestedIcu */, nestedIcuNodeIndex << 3 /* SHIFT_REF */ | 3 /* Remove */);
                    }
                }
            }
            /**
             * Angular Dart introduced &ngsp; as a placeholder for non-removable space, see:
             * https://github.com/dart-lang/angular/blob/0bb611387d29d65b5af7f9d2515ab571fd3fbee4/_tests/test/compiler/preserve_whitespace_test.dart#L25-L32
             * In Angular Dart &ngsp; is converted to the 0xE500 PUA (Private Use Areas) unicode character
             * and later on replaced by a space. We are re-implementing the same idea here, since translations
             * might contain this special character.
             * @type {?}
             */
            var NGSP_UNICODE_REGEXP = /\uE500/g;
            /**
             * @param {?} value
             * @return {?}
             */
            function replaceNgsp(value) {
                return value.replace(NGSP_UNICODE_REGEXP, ' ');
            }
            /** @type {?} */
            var TRANSLATIONS = {};
            /**
             * @record
             */
            function I18nLocalizeOptions() { }
            if (false) { }
            /**
             * Set the configuration for `i18nLocalize`.
             *
             * @deprecated this method is temporary & should not be used as it will be removed soon
             * @param {?=} options
             * @return {?}
             */
            function i18nConfigureLocalize(options) {
                if (options === void 0) { options = {
                    translations: {}
                }; }
                TRANSLATIONS = options.translations;
            }
            /** @type {?} */
            var LOCALIZE_PH_REGEXP = /\{\$(.*?)\}/g;
            /**
             * A goog.getMsg-like function for users that do not use Closure.
             *
             * This method is required as a *temporary* measure to prevent i18n tests from being blocked while
             * running outside of Closure Compiler. This method will not be needed once runtime translation
             * service support is introduced.
             *
             * \@codeGenApi
             * @deprecated this method is temporary & should not be used as it will be removed soon
             * @param {?} input
             * @param {?=} placeholders
             * @return {?}
             */
            function ɵɵi18nLocalize(input, placeholders) {
                if (typeof TRANSLATIONS[input] !== 'undefined') { // to account for empty string
                    input = TRANSLATIONS[input];
                }
                if (placeholders !== undefined && Object.keys(placeholders).length) {
                    return input.replace(LOCALIZE_PH_REGEXP, ( /**
                     * @param {?} _
                     * @param {?} key
                     * @return {?}
                     */function (_, key) { return placeholders[key] || ''; }));
                }
                return input;
            }
            /**
             * The locale id that the application is currently using (for translations and ICU expressions).
             * This is the ivy version of `LOCALE_ID` that was defined as an injection token for the view engine
             * but is now defined as a global value.
             * @type {?}
             */
            var LOCALE_ID = DEFAULT_LOCALE_ID;
            /**
             * Sets the locale id that will be used for translations and ICU expressions.
             * This is the ivy version of `LOCALE_ID` that was defined as an injection token for the view engine
             * but is now defined as a global value.
             *
             * @param {?} localeId
             * @return {?}
             */
            function setLocaleId(localeId) {
                assertDefined(localeId, "Expected localeId to be defined");
                if (typeof localeId === 'string') {
                    LOCALE_ID = localeId.toLowerCase().replace(/_/g, '-');
                }
            }
            /**
             * Gets the locale id that will be used for translations and ICU expressions.
             * This is the ivy version of `LOCALE_ID` that was defined as an injection token for the view engine
             * but is now defined as a global value.
             * @return {?}
             */
            function getLocaleId() {
                return LOCALE_ID;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Map of module-id to the corresponding NgModule.
             * - In pre Ivy we track NgModuleFactory,
             * - In post Ivy we track the NgModuleType
             * @type {?}
             */
            var modules = new Map();
            /**
             * Registers a loaded module. Should only be called from generated NgModuleFactory code.
             * \@publicApi
             * @param {?} id
             * @param {?} factory
             * @return {?}
             */
            function registerModuleFactory(id, factory) {
                /** @type {?} */
                var existing = ( /** @type {?} */(modules.get(id)));
                assertSameOrNotExisting(id, existing && existing.moduleType, factory.moduleType);
                modules.set(id, factory);
            }
            /**
             * @param {?} id
             * @param {?} type
             * @param {?} incoming
             * @return {?}
             */
            function assertSameOrNotExisting(id, type, incoming) {
                if (type && type !== incoming) {
                    throw new Error("Duplicate module registered for " + id + " - " + stringify(type) + " vs " + stringify(type.name));
                }
            }
            /**
             * @param {?} ngModuleType
             * @return {?}
             */
            function registerNgModuleType(ngModuleType) {
                if (ngModuleType.ngModuleDef.id !== null) {
                    /** @type {?} */
                    var id = ngModuleType.ngModuleDef.id;
                    /** @type {?} */
                    var existing = ( /** @type {?} */(modules.get(id)));
                    assertSameOrNotExisting(id, existing, ngModuleType);
                    modules.set(id, ngModuleType);
                }
                /** @type {?} */
                var imports = ngModuleType.ngModuleDef.imports;
                if (imports instanceof Function) {
                    imports = imports();
                }
                if (imports) {
                    imports.forEach(( /**
                     * @param {?} i
                     * @return {?}
                     */function (/**
                     * @param {?} i
                     * @return {?}
                     */ i) { return registerNgModuleType(( /** @type {?} */(i))); }));
                }
            }
            /**
             * @return {?}
             */
            function clearModulesForTest() {
                modules.clear();
            }
            /**
             * @param {?} id
             * @return {?}
             */
            function getRegisteredNgModuleType(id) {
                return modules.get(id);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             * @template T
             */
            function NgModuleType() { }
            if (false) { }
            /** @type {?} */
            var COMPONENT_FACTORY_RESOLVER = {
                provide: ComponentFactoryResolver,
                useClass: ComponentFactoryResolver$1,
                deps: [NgModuleRef],
            };
            /**
             * @template T
             */
            var NgModuleRef$1 = /** @class */ (function (_super_1) {
                __extends(NgModuleRef$1, _super_1);
                /**
                 * @param {?} ngModuleType
                 * @param {?} _parent
                 */
                function NgModuleRef$1(ngModuleType, _parent) {
                    var _this = _super_1.call(this) || this;
                    _this._parent = _parent;
                    // tslint:disable-next-line:require-internal-with-underscore
                    _this._bootstrapComponents = [];
                    _this.injector = _this;
                    _this.destroyCbs = [];
                    /** @type {?} */
                    /** @nocollapse */ var ngModuleDef = getNgModuleDef(ngModuleType);
                    ngDevMode && assertDefined(ngModuleDef, "NgModule '" + stringify(ngModuleType) + "' is not a subtype of 'NgModuleType'.");
                    /** @type {?} */
                    var ngLocaleIdDef = getNgLocaleIdDef(ngModuleType);
                    if (ngLocaleIdDef) {
                        setLocaleId(ngLocaleIdDef);
                    }
                    _this._bootstrapComponents = maybeUnwrapFn(( /** @type {?} */(ngModuleDef)).bootstrap);
                    /** @type {?} */
                    var additionalProviders = [
                        {
                            provide: NgModuleRef,
                            useValue: _this,
                        },
                        COMPONENT_FACTORY_RESOLVER
                    ];
                    _this._r3Injector = ( /** @type {?} */(createInjector(ngModuleType, _parent, additionalProviders, stringify(ngModuleType))));
                    _this.instance = _this.get(ngModuleType);
                    return _this;
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @param {?=} injectFlags
                 * @return {?}
                 */
                NgModuleRef$1.prototype.get = function (token, notFoundValue, injectFlags) {
                    if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
                    if (injectFlags === void 0) { injectFlags = InjectFlags.Default; }
                    if (token === Injector || token === NgModuleRef || token === INJECTOR) {
                        return this;
                    }
                    return this._r3Injector.get(token, notFoundValue, injectFlags);
                };
                Object.defineProperty(NgModuleRef$1.prototype, "componentFactoryResolver", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.get(ComponentFactoryResolver);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                NgModuleRef$1.prototype.destroy = function () {
                    ngDevMode && assertDefined(this.destroyCbs, 'NgModule already destroyed');
                    /** @type {?} */
                    var injector = this._r3Injector;
                    !injector.destroyed && injector.destroy();
                    ( /** @type {?} */(this.destroyCbs)).forEach(( /**
                     * @param {?} fn
                     * @return {?}
                     */function (/**
                     * @param {?} fn
                     * @return {?}
                     */ fn) { return fn(); }));
                    this.destroyCbs = null;
                };
                /**
                 * @param {?} callback
                 * @return {?}
                 */
                NgModuleRef$1.prototype.onDestroy = function (callback) {
                    ngDevMode && assertDefined(this.destroyCbs, 'NgModule already destroyed');
                    ( /** @type {?} */(this.destroyCbs)).push(callback);
                };
                return NgModuleRef$1;
            }(NgModuleRef));
            if (false) { }
            /**
             * @template T
             */
            var NgModuleFactory$1 = /** @class */ (function (_super_1) {
                __extends(NgModuleFactory$1, _super_1);
                /**
                 * @param {?} moduleType
                 */
                function NgModuleFactory$1(moduleType) {
                    var _this = _super_1.call(this) || this;
                    _this.moduleType = moduleType;
                    /** @type {?} */
                    /** @nocollapse */ var ngModuleDef = getNgModuleDef(moduleType);
                    if (ngModuleDef !== null) {
                        // Register the NgModule with Angular's module registry. The location (and hence timing) of
                        // this call is critical to ensure this works correctly (modules get registered when expected)
                        // without bloating bundles (modules are registered when otherwise not referenced).
                        //
                        // In View Engine, registration occurs in the .ngfactory.js file as a side effect. This has
                        // several practical consequences:
                        //
                        // - If an .ngfactory file is not imported from, the module won't be registered (and can be
                        //   tree shaken).
                        // - If an .ngfactory file is imported from, the module will be registered even if an instance
                        //   is not actually created (via `create` below).
                        // - Since an .ngfactory file in View Engine references the .ngfactory files of the NgModule's
                        //   imports,
                        //
                        // In Ivy, things are a bit different. .ngfactory files still exist for compatibility, but are
                        // not a required API to use - there are other ways to obtain an NgModuleFactory for a given
                        // NgModule. Thus, relying on a side effect in the .ngfactory file is not sufficient. Instead,
                        // the side effect of registration is added here, in the constructor of NgModuleFactory,
                        // ensuring no matter how a factory is created, the module is registered correctly.
                        //
                        // An alternative would be to include the registration side effect inline following the actual
                        // NgModule definition. This also has the correct timing, but breaks tree-shaking - modules
                        // will be registered and retained even if they're otherwise never referenced.
                        registerNgModuleType(( /** @type {?} */(moduleType)));
                    }
                    return _this;
                }
                /**
                 * @param {?} parentInjector
                 * @return {?}
                 */
                NgModuleFactory$1.prototype.create = function (parentInjector) {
                    return new NgModuleRef$1(this.moduleType, parentInjector);
                };
                return NgModuleFactory$1;
            }(NgModuleFactory));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function TypeWithMetadata() { }
            if (false) { }
            /**
             * Adds decorator, constructor, and property metadata to a given type via static metadata fields
             * on the type.
             *
             * These metadata fields can later be read with Angular's `ReflectionCapabilities` API.
             *
             * Calls to `setClassMetadata` can be marked as pure, resulting in the metadata assignments being
             * tree-shaken away during production builds.
             * @param {?} type
             * @param {?} decorators
             * @param {?} ctorParameters
             * @param {?} propDecorators
             * @return {?}
             */
            function setClassMetadata(type, decorators, ctorParameters, propDecorators) {
                return ( /** @type {?} */(noSideEffects(( /**
                 * @return {?}
                 */function () {
                    var _c;
                    /** @type {?} */
                    var clazz = ( /** @type {?} */(type));
                    // We determine whether a class has its own metadata by taking the metadata from the parent
                    // constructor and checking whether it's the same as the subclass metadata below. We can't use
                    // `hasOwnProperty` here because it doesn't work correctly in IE10 for static fields that are
                    // defined by TS. See https://github.com/angular/angular/pull/28439#issuecomment-459349218.
                    /** @type {?} */
                    var parentPrototype = clazz.prototype ? Object.getPrototypeOf(clazz.prototype) : null;
                    /** @type {?} */
                    var parentConstructor = parentPrototype && parentPrototype.constructor;
                    if (decorators !== null) {
                        if (clazz.decorators !== undefined &&
                            (!parentConstructor || parentConstructor.decorators !== clazz.decorators)) {
                            (_c = clazz.decorators).push.apply(_c, decorators);
                        }
                        else {
                            clazz.decorators = decorators;
                        }
                    }
                    if (ctorParameters !== null) {
                        // Rather than merging, clobber the existing parameters. If other projects exist which use
                        // tsickle-style annotations and reflect over them in the same way, this could cause issues,
                        // but that is vanishingly unlikely.
                        clazz.ctorParameters = ctorParameters;
                    }
                    if (propDecorators !== null) {
                        // The property decorator objects are merged as it is possible different fields have different
                        // decorator types. Decorators on individual fields are not merged, as it's also incredibly
                        // unlikely that a field will be decorated both with an Angular decorator and a non-Angular
                        // decorator that's also been downleveled.
                        if (clazz.propDecorators !== undefined &&
                            (!parentConstructor || parentConstructor.propDecorators !== clazz.propDecorators)) {
                            clazz.propDecorators = Object.assign({}, clazz.propDecorators, propDecorators);
                        }
                        else {
                            clazz.propDecorators = propDecorators;
                        }
                    }
                }))));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Bindings for pure functions are stored after regular bindings.
             *
             * |------consts------|---------vars---------|                 |----- hostVars (dir1) ------|
             * ------------------------------------------------------------------------------------------
             * | nodes/refs/pipes | bindings | fn slots  | injector | dir1 | host bindings | host slots |
             * ------------------------------------------------------------------------------------------
             *                    ^                      ^
             *      TView.bindingStartIndex      TView.expandoStartIndex
             *
             * Pure function instructions are given an offset from the binding root. Adding the offset to the
             * binding root gives the first index where the bindings are stored. In component views, the binding
             * root is the bindingStartIndex. In host bindings, the binding root is the expandoStartIndex +
             * any directive instances + any hostVars in directives evaluated before it.
             *
             * See VIEW_DATA.md for more information about host binding resolution.
             */
            /**
             * If the value hasn't been saved, calls the pure function to store and return the
             * value. If it has been saved, returns the saved value.
             *
             * \@codeGenApi
             * @template T
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn Function that returns a value
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} value
             *
             */
            function ɵɵpureFunction0(slotOffset, pureFn, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                return isCreationMode() ?
                    updateBinding(lView, bindingIndex, thisArg ? pureFn.call(thisArg) : pureFn()) :
                    getBinding(lView, bindingIndex);
            }
            /**
             * If the value of the provided exp has changed, calls the pure function to return
             * an updated value. Or if the value has not changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn Function that returns an updated value
             * @param {?} exp Updated expression value
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction1(slotOffset, pureFn, exp, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                return bindingUpdated(lView, bindingIndex, exp) ?
                    updateBinding(lView, bindingIndex + 1, thisArg ? pureFn.call(thisArg, exp) : pureFn(exp)) :
                    getBinding(lView, bindingIndex + 1);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction2(slotOffset, pureFn, exp1, exp2, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                return bindingUpdated2(lView, bindingIndex, exp1, exp2) ?
                    updateBinding(lView, bindingIndex + 2, thisArg ? pureFn.call(thisArg, exp1, exp2) : pureFn(exp1, exp2)) :
                    getBinding(lView, bindingIndex + 2);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction3(slotOffset, pureFn, exp1, exp2, exp3, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                return bindingUpdated3(lView, bindingIndex, exp1, exp2, exp3) ?
                    updateBinding(lView, bindingIndex + 3, thisArg ? pureFn.call(thisArg, exp1, exp2, exp3) : pureFn(exp1, exp2, exp3)) :
                    getBinding(lView, bindingIndex + 3);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?} exp4
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction4(slotOffset, pureFn, exp1, exp2, exp3, exp4, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                return bindingUpdated4(lView, bindingIndex, exp1, exp2, exp3, exp4) ?
                    updateBinding(lView, bindingIndex + 4, thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4) : pureFn(exp1, exp2, exp3, exp4)) :
                    getBinding(lView, bindingIndex + 4);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?} exp4
             * @param {?} exp5
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction5(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, exp1, exp2, exp3, exp4);
                return bindingUpdated(lView, bindingIndex + 4, exp5) || different ?
                    updateBinding(lView, bindingIndex + 5, thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5) :
                        pureFn(exp1, exp2, exp3, exp4, exp5)) :
                    getBinding(lView, bindingIndex + 5);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?} exp4
             * @param {?} exp5
             * @param {?} exp6
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction6(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, exp6, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, exp1, exp2, exp3, exp4);
                return bindingUpdated2(lView, bindingIndex + 4, exp5, exp6) || different ?
                    updateBinding(lView, bindingIndex + 6, thisArg ?
                        pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5, exp6) :
                        pureFn(exp1, exp2, exp3, exp4, exp5, exp6)) :
                    getBinding(lView, bindingIndex + 6);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?} exp4
             * @param {?} exp5
             * @param {?} exp6
             * @param {?} exp7
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction7(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, exp6, exp7, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, exp1, exp2, exp3, exp4);
                return bindingUpdated3(lView, bindingIndex + 4, exp5, exp6, exp7) || different ?
                    updateBinding(lView, bindingIndex + 7, thisArg ?
                        pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5, exp6, exp7) :
                        pureFn(exp1, exp2, exp3, exp4, exp5, exp6, exp7)) :
                    getBinding(lView, bindingIndex + 7);
            }
            /**
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn
             * @param {?} exp1
             * @param {?} exp2
             * @param {?} exp3
             * @param {?} exp4
             * @param {?} exp5
             * @param {?} exp6
             * @param {?} exp7
             * @param {?} exp8
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunction8(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var different = bindingUpdated4(lView, bindingIndex, exp1, exp2, exp3, exp4);
                return bindingUpdated4(lView, bindingIndex + 4, exp5, exp6, exp7, exp8) || different ?
                    updateBinding(lView, bindingIndex + 8, thisArg ?
                        pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8) :
                        pureFn(exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8)) :
                    getBinding(lView, bindingIndex + 8);
            }
            /**
             * pureFunction instruction that can support any number of bindings.
             *
             * If the value of any provided exp has changed, calls the pure function to return
             * an updated value. Or if no values have changed, returns cached value.
             *
             * \@codeGenApi
             * @param {?} slotOffset the offset from binding root to the reserved slot
             * @param {?} pureFn A pure function that takes binding values and builds an object or array
             * containing those values.
             * @param {?} exps An array of binding values
             * @param {?=} thisArg Optional calling context of pureFn
             * @return {?} Updated or cached value
             *
             */
            function ɵɵpureFunctionV(slotOffset, pureFn, exps, thisArg) {
                // TODO(kara): use bindingRoot instead of bindingStartIndex when implementing host bindings
                /** @type {?} */
                var bindingIndex = getBindingRoot() + slotOffset;
                /** @type {?} */
                var different = false;
                /** @type {?} */
                var lView = getLView();
                for (var i = 0; i < exps.length; i++) {
                    bindingUpdated(lView, bindingIndex++, exps[i]) && (different = true);
                }
                return different ? updateBinding(lView, bindingIndex, pureFn.apply(thisArg, exps)) :
                    getBinding(lView, bindingIndex);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Create a pipe.
             *
             * \@codeGenApi
             * @param {?} index Pipe index where the pipe will be stored.
             * @param {?} pipeName The name of the pipe
             * @return {?} T the instance of the pipe.
             *
             */
            function ɵɵpipe(index, pipeName) {
                /** @type {?} */
                var tView = getLView()[TVIEW];
                /** @type {?} */
                var pipeDef;
                /** @type {?} */
                var adjustedIndex = index + HEADER_OFFSET;
                if (tView.firstTemplatePass) {
                    pipeDef = getPipeDef$1(pipeName, tView.pipeRegistry);
                    tView.data[adjustedIndex] = pipeDef;
                    if (pipeDef.onDestroy) {
                        (tView.destroyHooks || (tView.destroyHooks = [])).push(adjustedIndex, pipeDef.onDestroy);
                    }
                }
                else {
                    pipeDef = ( /** @type {?} */(tView.data[adjustedIndex]));
                }
                /** @type {?} */
                var pipeInstance = pipeDef.factory();
                store(index, pipeInstance);
                return pipeInstance;
            }
            /**
             * Searches the pipe registry for a pipe with the given name. If one is found,
             * returns the pipe. Otherwise, an error is thrown because the pipe cannot be resolved.
             *
             * \@publicApi
             * @param {?} name Name of pipe to resolve
             * @param {?} registry Full list of available pipes
             * @return {?} Matching PipeDef
             *
             */
            function getPipeDef$1(name, registry) {
                if (registry) {
                    for (var i = registry.length - 1; i >= 0; i--) {
                        /** @type {?} */
                        var pipeDef_1 = registry[i];
                        if (name === pipeDef_1.name) {
                            return pipeDef_1;
                        }
                    }
                }
                throw new Error("The pipe '" + name + "' could not be found!");
            }
            /**
             * Invokes a pipe with 1 arguments.
             *
             * This instruction acts as a guard to {\@link PipeTransform#transform} invoking
             * the pipe only when an input to the pipe changes.
             *
             * \@codeGenApi
             * @param {?} index Pipe index where the pipe was stored on creation.
             * @param {?} slotOffset the offset in the reserved slot space
             * @param {?} v1 1st argument to {\@link PipeTransform#transform}.
             *
             * @return {?}
             */
            function ɵɵpipeBind1(index, slotOffset, v1) {
                /** @type {?} */
                var pipeInstance = ɵɵload(index);
                return unwrapValue$1(isPure(index) ? ɵɵpureFunction1(slotOffset, pipeInstance.transform, v1, pipeInstance) :
                    pipeInstance.transform(v1));
            }
            /**
             * Invokes a pipe with 2 arguments.
             *
             * This instruction acts as a guard to {\@link PipeTransform#transform} invoking
             * the pipe only when an input to the pipe changes.
             *
             * \@codeGenApi
             * @param {?} index Pipe index where the pipe was stored on creation.
             * @param {?} slotOffset the offset in the reserved slot space
             * @param {?} v1 1st argument to {\@link PipeTransform#transform}.
             * @param {?} v2 2nd argument to {\@link PipeTransform#transform}.
             *
             * @return {?}
             */
            function ɵɵpipeBind2(index, slotOffset, v1, v2) {
                /** @type {?} */
                var pipeInstance = ɵɵload(index);
                return unwrapValue$1(isPure(index) ? ɵɵpureFunction2(slotOffset, pipeInstance.transform, v1, v2, pipeInstance) :
                    pipeInstance.transform(v1, v2));
            }
            /**
             * Invokes a pipe with 3 arguments.
             *
             * This instruction acts as a guard to {\@link PipeTransform#transform} invoking
             * the pipe only when an input to the pipe changes.
             *
             * \@codeGenApi
             * @param {?} index Pipe index where the pipe was stored on creation.
             * @param {?} slotOffset the offset in the reserved slot space
             * @param {?} v1 1st argument to {\@link PipeTransform#transform}.
             * @param {?} v2 2nd argument to {\@link PipeTransform#transform}.
             * @param {?} v3 4rd argument to {\@link PipeTransform#transform}.
             *
             * @return {?}
             */
            function ɵɵpipeBind3(index, slotOffset, v1, v2, v3) {
                /** @type {?} */
                var pipeInstance = ɵɵload(index);
                return unwrapValue$1(isPure(index) ?
                    ɵɵpureFunction3(slotOffset, pipeInstance.transform, v1, v2, v3, pipeInstance) :
                    pipeInstance.transform(v1, v2, v3));
            }
            /**
             * Invokes a pipe with 4 arguments.
             *
             * This instruction acts as a guard to {\@link PipeTransform#transform} invoking
             * the pipe only when an input to the pipe changes.
             *
             * \@codeGenApi
             * @param {?} index Pipe index where the pipe was stored on creation.
             * @param {?} slotOffset the offset in the reserved slot space
             * @param {?} v1 1st argument to {\@link PipeTransform#transform}.
             * @param {?} v2 2nd argument to {\@link PipeTransform#transform}.
             * @param {?} v3 3rd argument to {\@link PipeTransform#transform}.
             * @param {?} v4 4th argument to {\@link PipeTransform#transform}.
             *
             * @return {?}
             */
            function ɵɵpipeBind4(index, slotOffset, v1, v2, v3, v4) {
                /** @type {?} */
                var pipeInstance = ɵɵload(index);
                return unwrapValue$1(isPure(index) ?
                    ɵɵpureFunction4(slotOffset, pipeInstance.transform, v1, v2, v3, v4, pipeInstance) :
                    pipeInstance.transform(v1, v2, v3, v4));
            }
            /**
             * Invokes a pipe with variable number of arguments.
             *
             * This instruction acts as a guard to {\@link PipeTransform#transform} invoking
             * the pipe only when an input to the pipe changes.
             *
             * \@codeGenApi
             * @param {?} index Pipe index where the pipe was stored on creation.
             * @param {?} slotOffset the offset in the reserved slot space
             * @param {?} values Array of arguments to pass to {\@link PipeTransform#transform} method.
             *
             * @return {?}
             */
            function ɵɵpipeBindV(index, slotOffset, values) {
                /** @type {?} */
                var pipeInstance = ɵɵload(index);
                return unwrapValue$1(isPure(index) ? ɵɵpureFunctionV(slotOffset, pipeInstance.transform, values, pipeInstance) :
                    pipeInstance.transform.apply(pipeInstance, values));
            }
            /**
             * @param {?} index
             * @return {?}
             */
            function isPure(index) {
                return (( /** @type {?} */(getLView()[TVIEW].data[index + HEADER_OFFSET]))).pure;
            }
            /**
             * Unwrap the output of a pipe transformation.
             * In order to trick change detection into considering that the new value is always different from
             * the old one, the old value is overwritten by NO_CHANGE.
             *
             * @param {?} newValue the pipe transformation output.
             * @return {?}
             */
            function unwrapValue$1(newValue) {
                if (WrappedValue.isWrapped(newValue)) {
                    newValue = WrappedValue.unwrap(newValue);
                    /** @type {?} */
                    var lView_9 = getLView();
                    // The NO_CHANGE value needs to be written at the index where the impacted binding value is
                    // stored
                    /** @type {?} */
                    var bindingToInvalidateIdx = lView_9[BINDING_INDEX];
                    lView_9[bindingToInvalidateIdx] = NO_CHANGE;
                }
                return newValue;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Use in components with the `\@Output` directive to emit custom events
             * synchronously or asynchronously, and register handlers for those events
             * by subscribing to an instance.
             *
             * \@usageNotes
             *
             * Extends
             * [RxJS `Subject`](https://rxjs.dev/api/index/class/Subject)
             * for Angular by adding the `emit()` method.
             *
             * In the following example, a component defines two output properties
             * that create event emitters. When the title is clicked, the emitter
             * emits an open or close event to toggle the current visibility state.
             *
             * ```html
             * \@Component({
             *   selector: 'zippy',
             *   template: `
             *   <div class="zippy">
             *     <div (click)="toggle()">Toggle</div>
             *     <div [hidden]="!visible">
             *       <ng-content></ng-content>
             *     </div>
             *  </div>`})
             * export class Zippy {
             *   visible: boolean = true;
             * \@Output() open: EventEmitter<any> = new EventEmitter();
             * \@Output() close: EventEmitter<any> = new EventEmitter();
             *
             *   toggle() {
             *     this.visible = !this.visible;
             *     if (this.visible) {
             *       this.open.emit(null);
             *     } else {
             *       this.close.emit(null);
             *     }
             *   }
             * }
             * ```
             *
             * Access the event object with the `$event` argument passed to the output event
             * handler:
             *
             * ```html
             * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
             * ```
             *
             * @see [Observables in Angular](guide/observables-in-angular)
             * \@publicApi
             * @template T
             */
            var EventEmitter = /** @class */ (function (_super_1) {
                __extends(EventEmitter, _super_1);
                // tslint:disable-line
                /**
                 * Creates an instance of this class that can
                 * deliver events synchronously or asynchronously.
                 *
                 * @param {?=} isAsync When true, deliver events asynchronously.
                 *
                 */
                function EventEmitter(isAsync) {
                    if (isAsync === void 0) { isAsync = false; }
                    var _this = _super_1.call(this) || this;
                    _this.__isAsync = isAsync;
                    return _this;
                }
                /**
                 * Emits an event containing a given value.
                 * @param {?=} value The value to emit.
                 * @return {?}
                 */
                EventEmitter.prototype.emit = function (value) { _super_1.prototype.next.call(this, value); };
                /**
                 * Registers handlers for events emitted by this instance.
                 * @param {?=} generatorOrNext When supplied, a custom handler for emitted events.
                 * @param {?=} error When supplied, a custom handler for an error notification
                 * from this emitter.
                 * @param {?=} complete When supplied, a custom handler for a completion
                 * notification from this emitter.
                 * @return {?}
                 */
                EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
                    /** @type {?} */
                    var schedulerFn;
                    /** @type {?} */
                    var errorFn = ( /**
                     * @param {?} err
                     * @return {?}
                     */function (err) { return null; });
                    /** @type {?} */
                    var completeFn = ( /**
                     * @return {?}
                     */function () { return null; });
                    if (generatorOrNext && typeof generatorOrNext === 'object') {
                        schedulerFn = this.__isAsync ? ( /**
                         * @param {?} value
                         * @return {?}
                         */function (value) {
                            setTimeout(( /**
                             * @return {?}
                             */function () { return generatorOrNext.next(value); }));
                        }) : ( /**
                         * @param {?} value
                         * @return {?}
                         */function (value) { generatorOrNext.next(value); });
                        if (generatorOrNext.error) {
                            errorFn = this.__isAsync ? ( /**
                             * @param {?} err
                             * @return {?}
                             */function (err) {
                                setTimeout(( /**
                                 * @return {?}
                                 */function () { return generatorOrNext.error(err); }));
                            }) :
                                ( /**
                                 * @param {?} err
                                 * @return {?}
                                 */function (err) { generatorOrNext.error(err); });
                        }
                        if (generatorOrNext.complete) {
                            completeFn = this.__isAsync ? ( /**
                             * @return {?}
                             */function () {
                                setTimeout(( /**
                                 * @return {?}
                                 */function () { return generatorOrNext.complete(); }));
                            }) :
                                ( /**
                                 * @return {?}
                                 */function () { generatorOrNext.complete(); });
                        }
                    }
                    else {
                        schedulerFn = this.__isAsync ? ( /**
                         * @param {?} value
                         * @return {?}
                         */function (value) {
                            setTimeout(( /**
                             * @return {?}
                             */function () { return generatorOrNext(value); }));
                        }) :
                            ( /**
                             * @param {?} value
                             * @return {?}
                             */function (value) { generatorOrNext(value); });
                        if (error) {
                            errorFn =
                                this.__isAsync ? ( /**
                                 * @param {?} err
                                 * @return {?}
                                 */function (err) {
                                    setTimeout(( /**
                                     * @return {?}
                                     */function () { return error(err); }));
                                }) : ( /**
                                 * @param {?} err
                                 * @return {?}
                                 */function (err) { error(err); });
                        }
                        if (complete) {
                            completeFn =
                                this.__isAsync ? ( /**
                                 * @return {?}
                                 */function () {
                                    setTimeout(( /**
                                     * @return {?}
                                     */function () { return complete(); }));
                                }) : ( /**
                                 * @return {?}
                                 */function () { complete(); });
                        }
                    }
                    /** @type {?} */
                    var sink = _super_1.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
                    if (generatorOrNext instanceof rxjs__WEBPACK_IMPORTED_MODULE_0__["Subscription"]) {
                        generatorOrNext.add(sink);
                    }
                    return sink;
                };
                return EventEmitter;
            }(rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @template T
             * @this {?}
             * @return {?}
             */
            function symbolIterator() {
                return (( /** @type {?} */((( /** @type {?} */(( /** @type {?} */(this)))))._results)))[getSymbolIterator()]();
            }
            /**
             * An unmodifiable list of items that Angular keeps up to date when the state
             * of the application changes.
             *
             * The type of object that {\@link ViewChildren}, {\@link ContentChildren}, and {\@link QueryList}
             * provide.
             *
             * Implements an iterable interface, therefore it can be used in both ES6
             * javascript `for (var i of items)` loops as well as in Angular templates with
             * `*ngFor="let i of myList"`.
             *
             * Changes can be observed by subscribing to the changes `Observable`.
             *
             * NOTE: In the future this class will implement an `Observable` interface.
             *
             * \@usageNotes
             * ### Example
             * ```typescript
             * \@Component({...})
             * class Container {
             * \@ViewChildren(Item) items:QueryList<Item>;
             * }
             * ```
             *
             * \@publicApi
             * @template T
             */
            var QueryList = /** @class */ (function () {
                function QueryList() {
                    this.dirty = true;
                    this._results = [];
                    this.changes = new EventEmitter();
                    this.length = 0;
                    // This function should be declared on the prototype, but doing so there will cause the class
                    // declaration to have side-effects and become not tree-shakable. For this reason we do it in
                    // the constructor.
                    // [getSymbolIterator()](): Iterator<T> { ... }
                    /** @type {?} */
                    var symbol = getSymbolIterator();
                    /** @type {?} */
                    var proto = ( /** @type {?} */(QueryList.prototype));
                    if (!proto[symbol])
                        proto[symbol] = symbolIterator;
                }
                /**
                 * See
                 * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
                 * @template U
                 * @param {?} fn
                 * @return {?}
                 */
                QueryList.prototype.map = function (fn) { return this._results.map(fn); };
                /**
                 * See
                 * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
                 * @param {?} fn
                 * @return {?}
                 */
                QueryList.prototype.filter = function (fn) {
                    return this._results.filter(fn);
                };
                /**
                 * See
                 * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
                 * @param {?} fn
                 * @return {?}
                 */
                QueryList.prototype.find = function (fn) {
                    return this._results.find(fn);
                };
                /**
                 * See
                 * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
                 * @template U
                 * @param {?} fn
                 * @param {?} init
                 * @return {?}
                 */
                QueryList.prototype.reduce = function (fn, init) {
                    return this._results.reduce(fn, init);
                };
                /**
                 * See
                 * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
                 * @param {?} fn
                 * @return {?}
                 */
                QueryList.prototype.forEach = function (fn) { this._results.forEach(fn); };
                /**
                 * See
                 * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
                 * @param {?} fn
                 * @return {?}
                 */
                QueryList.prototype.some = function (fn) {
                    return this._results.some(fn);
                };
                /**
                 * Returns a copy of the internal results list as an Array.
                 * @return {?}
                 */
                QueryList.prototype.toArray = function () { return this._results.slice(); };
                /**
                 * @return {?}
                 */
                QueryList.prototype.toString = function () { return this._results.toString(); };
                /**
                 * Updates the stored data of the query list, and resets the `dirty` flag to `false`, so that
                 * on change detection, it will not notify of changes to the queries, unless a new change
                 * occurs.
                 *
                 * @param {?} resultsTree The query results to store
                 * @return {?}
                 */
                QueryList.prototype.reset = function (resultsTree) {
                    this._results = flatten(resultsTree);
                    (( /** @type {?} */(this))).dirty = false;
                    (( /** @type {?} */(this))).length = this._results.length;
                    (( /** @type {?} */(this))).last = this._results[this.length - 1];
                    (( /** @type {?} */(this))).first = this._results[0];
                };
                /**
                 * Triggers a change event by emitting on the `changes` {\@link EventEmitter}.
                 * @return {?}
                 */
                QueryList.prototype.notifyOnChanges = function () { (( /** @type {?} */(this.changes))).emit(this); };
                /**
                 * internal
                 * @return {?}
                 */
                QueryList.prototype.setDirty = function () { (( /** @type {?} */(this))).dirty = true; };
                /**
                 * internal
                 * @return {?}
                 */
                QueryList.prototype.destroy = function () {
                    (( /** @type {?} */(this.changes))).complete();
                    (( /** @type {?} */(this.changes))).unsubscribe();
                };
                return QueryList;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @enum {number} */
            var RenderFlags = {
                /* Whether to run the creation block (e.g. create elements and directives) */
                Create: 1,
                /* Whether to run the update block (e.g. refresh bindings) */
                Update: 2,
            };
            /**
             * A subclass of `Type` which has a static `ngComponentDef`:`ComponentDef` field making it
             * consumable for rendering.
             * @record
             * @template T
             */
            function ComponentType() { }
            if (false) { }
            /**
             * A subclass of `Type` which has a static `ngDirectiveDef`:`DirectiveDef` field making it
             * consumable for rendering.
             * @record
             * @template T
             */
            function DirectiveType() { }
            if (false) { }
            /** @enum {number} */
            var DirectiveDefFlags = {
                ContentQuery: 2,
            };
            /**
             * A subclass of `Type` which has a static `ngPipeDef`:`PipeDef` field making it
             * consumable for rendering.
             * @record
             * @template T
             */
            function PipeType() { }
            if (false) { }
            /**
             * Runtime information for classes that are inherited by components or directives
             * that aren't defined as components or directives.
             *
             * This is an internal data structure used by the renderer to determine what inputs
             * and outputs should be inherited.
             *
             * See: {\@link defineBase}
             *
             * \@codeGenApi
             * @record
             * @template T
             */
            function ɵɵBaseDef() { }
            if (false) { }
            /**
             * Runtime link information for Directives.
             *
             * This is internal data structure used by the render to link
             * directives into templates.
             *
             * NOTE: Always use `defineDirective` function to create this object,
             * never create the object directly since the shape of this object
             * can change between versions.
             *
             * @param Selector type metadata specifying the selector of the directive or component
             *
             * See: {\@link defineDirective}
             * @record
             * @template T
             */
            function DirectiveDef() { }
            if (false) { }
            /**
             * Runtime link information for Components.
             *
             * This is internal data structure used by the render to link
             * components into templates.
             *
             * NOTE: Always use `defineComponent` function to create this object,
             * never create the object directly since the shape of this object
             * can change between versions.
             *
             * See: {\@link defineComponent}
             * @record
             * @template T
             */
            function ComponentDef() { }
            if (false) { }
            /**
             * Runtime link information for Pipes.
             *
             * This is internal data structure used by the renderer to link
             * pipes into templates.
             *
             * NOTE: Always use `definePipe` function to create this object,
             * never create the object directly since the shape of this object
             * can change between versions.
             *
             * See: {\@link definePipe}
             * @record
             * @template T
             */
            function PipeDef() { }
            if (false) { }
            /**
             * @record
             */
            function DirectiveDefFeature() { }
            if (false) { }
            /**
             * @record
             */
            function ComponentDefFeature() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$7 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * An object representing query metadata extracted from query annotations.
             * @record
             */
            function TQueryMetadata() { }
            if (false) { }
            /**
             * TQuery objects represent all the query-related data that remain the same from one view instance
             * to another and can be determined on the very first template pass. Most notably TQuery holds all
             * the matches for a given view.
             * @record
             */
            function TQuery() { }
            if (false) { }
            /**
             * TQueries represent a collection of individual TQuery objects tracked in a given view. Most of the
             * methods on this interface are simple proxy methods to the corresponding functionality on TQuery.
             * @record
             */
            function TQueries() { }
            if (false) { }
            /**
             * An interface that represents query-related information specific to a view instance. Most notably
             * it contains:
             * - materialized query matches;
             * - a pointer to a QueryList where materialized query results should be reported.
             * @record
             * @template T
             */
            function LQuery() { }
            if (false) { }
            /**
             * lQueries represent a collection of individual LQuery objects tracked in a given view.
             * @record
             */
            function LQueries() { }
            if (false) { }
            // Note: This hack is necessary so we don't erroneously get a circular dependency
            // failure based on types.
            /** @type {?} */
            var unusedValueExportToPlacateAjd$8 = 1;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var unusedValueToPlacateAjd$2 = unusedValueExportToPlacateAjd$7 + unusedValueExportToPlacateAjd$2 + unusedValueExportToPlacateAjd$4 + unusedValueExportToPlacateAjd$8;
            /**
             * @template T
             */
            var LQuery_ = /** @class */ (function () {
                /**
                 * @param {?} queryList
                 */
                function LQuery_(queryList) {
                    this.queryList = queryList;
                    this.matches = null;
                }
                /**
                 * @return {?}
                 */
                LQuery_.prototype.clone = function () { return new LQuery_(this.queryList); };
                /**
                 * @return {?}
                 */
                LQuery_.prototype.setDirty = function () { this.queryList.setDirty(); };
                return LQuery_;
            }());
            if (false) { }
            var LQueries_ = /** @class */ (function () {
                /**
                 * @param {?=} queries
                 */
                function LQueries_(queries) {
                    if (queries === void 0) { queries = []; }
                    this.queries = queries;
                }
                /**
                 * @param {?} tView
                 * @return {?}
                 */
                LQueries_.prototype.createEmbeddedView = function (tView) {
                    /** @type {?} */
                    var tQueries = tView.queries;
                    if (tQueries !== null) {
                        /** @type {?} */
                        var noOfInheritedQueries = tView.contentQueries !== null ? tView.contentQueries[0] : tQueries.length;
                        /** @type {?} */
                        var viewLQueries = new Array(noOfInheritedQueries);
                        // An embedded view has queries propagated from a declaration view at the beginning of the
                        // TQueries collection and up until a first content query declared in the embedded view. Only
                        // propagated LQueries are created at this point (LQuery corresponding to declared content
                        // queries will be instantiated from the content query instructions for each directive).
                        for (var i = 0; i < noOfInheritedQueries; i++) {
                            /** @type {?} */
                            var tQuery = tQueries.getByIndex(i);
                            /** @type {?} */
                            var parentLQuery = this.queries[tQuery.indexInDeclarationView];
                            viewLQueries[i] = parentLQuery.clone();
                        }
                        return new LQueries_(viewLQueries);
                    }
                    return null;
                };
                /**
                 * @param {?} tView
                 * @return {?}
                 */
                LQueries_.prototype.insertView = function (tView) { this.dirtyQueriesWithMatches(tView); };
                /**
                 * @param {?} tView
                 * @return {?}
                 */
                LQueries_.prototype.detachView = function (tView) { this.dirtyQueriesWithMatches(tView); };
                /**
                 * @private
                 * @param {?} tView
                 * @return {?}
                 */
                LQueries_.prototype.dirtyQueriesWithMatches = function (tView) {
                    for (var i = 0; i < this.queries.length; i++) {
                        if (getTQuery(tView, i).matches !== null) {
                            this.queries[i].setDirty();
                        }
                    }
                };
                return LQueries_;
            }());
            if (false) { }
            var TQueryMetadata_ = /** @class */ (function () {
                /**
                 * @param {?} predicate
                 * @param {?} descendants
                 * @param {?} isStatic
                 * @param {?=} read
                 */
                function TQueryMetadata_(predicate, descendants, isStatic, read) {
                    if (read === void 0) { read = null; }
                    this.predicate = predicate;
                    this.descendants = descendants;
                    this.isStatic = isStatic;
                    this.read = read;
                }
                return TQueryMetadata_;
            }());
            if (false) { }
            var TQueries_ = /** @class */ (function () {
                /**
                 * @param {?=} queries
                 */
                function TQueries_(queries) {
                    if (queries === void 0) { queries = []; }
                    this.queries = queries;
                }
                /**
                 * @param {?} tView
                 * @param {?} tNode
                 * @return {?}
                 */
                TQueries_.prototype.elementStart = function (tView, tNode) {
                    ngDevMode && assertFirstTemplatePass(tView, 'Queries should collect results on the first template pass only');
                    for (var _c = 0, _d = this.queries; _c < _d.length; _c++) {
                        var query = _d[_c];
                        query.elementStart(tView, tNode);
                    }
                };
                /**
                 * @param {?} tNode
                 * @return {?}
                 */
                TQueries_.prototype.elementEnd = function (tNode) {
                    for (var _c = 0, _d = this.queries; _c < _d.length; _c++) {
                        var query = _d[_c];
                        query.elementEnd(tNode);
                    }
                };
                /**
                 * @param {?} tNode
                 * @return {?}
                 */
                TQueries_.prototype.embeddedTView = function (tNode) {
                    /** @type {?} */
                    var queriesForTemplateRef = null;
                    for (var i = 0; i < this.length; i++) {
                        /** @type {?} */
                        var childQueryIndex = queriesForTemplateRef !== null ? queriesForTemplateRef.length : 0;
                        /** @type {?} */
                        var tqueryClone = this.getByIndex(i).embeddedTView(tNode, childQueryIndex);
                        if (tqueryClone) {
                            tqueryClone.indexInDeclarationView = i;
                            if (queriesForTemplateRef !== null) {
                                queriesForTemplateRef.push(tqueryClone);
                            }
                            else {
                                queriesForTemplateRef = [tqueryClone];
                            }
                        }
                    }
                    return queriesForTemplateRef !== null ? new TQueries_(queriesForTemplateRef) : null;
                };
                /**
                 * @param {?} tView
                 * @param {?} tNode
                 * @return {?}
                 */
                TQueries_.prototype.template = function (tView, tNode) {
                    ngDevMode && assertFirstTemplatePass(tView, 'Queries should collect results on the first template pass only');
                    for (var _c = 0, _d = this.queries; _c < _d.length; _c++) {
                        var query = _d[_c];
                        query.template(tView, tNode);
                    }
                };
                /**
                 * @param {?} index
                 * @return {?}
                 */
                TQueries_.prototype.getByIndex = function (index) {
                    ngDevMode && assertDataInRange(this.queries, index);
                    return this.queries[index];
                };
                Object.defineProperty(TQueries_.prototype, "length", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.queries.length; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} tquery
                 * @return {?}
                 */
                TQueries_.prototype.track = function (tquery) { this.queries.push(tquery); };
                return TQueries_;
            }());
            if (false) { }
            var TQuery_ = /** @class */ (function () {
                /**
                 * @param {?} metadata
                 * @param {?=} nodeIndex
                 */
                function TQuery_(metadata, nodeIndex) {
                    if (nodeIndex === void 0) { nodeIndex = -1; }
                    this.metadata = metadata;
                    this.matches = null;
                    this.indexInDeclarationView = -1;
                    this.crossesNgTemplate = false;
                    /**
                     * A flag indicating if a given query still applies to nodes it is crossing. We use this flag
                     * (alongside with _declarationNodeIndex) to know when to stop applying content queries to
                     * elements in a template.
                     */
                    this._appliesToNextNode = true;
                    this._declarationNodeIndex = nodeIndex;
                }
                /**
                 * @param {?} tView
                 * @param {?} tNode
                 * @return {?}
                 */
                TQuery_.prototype.elementStart = function (tView, tNode) {
                    if (this.isApplyingToNode(tNode)) {
                        this.matchTNode(tView, tNode);
                    }
                };
                /**
                 * @param {?} tNode
                 * @return {?}
                 */
                TQuery_.prototype.elementEnd = function (tNode) {
                    if (this._declarationNodeIndex === tNode.index) {
                        this._appliesToNextNode = false;
                    }
                };
                /**
                 * @param {?} tView
                 * @param {?} tNode
                 * @return {?}
                 */
                TQuery_.prototype.template = function (tView, tNode) { this.elementStart(tView, tNode); };
                /**
                 * @param {?} tNode
                 * @param {?} childQueryIndex
                 * @return {?}
                 */
                TQuery_.prototype.embeddedTView = function (tNode, childQueryIndex) {
                    if (this.isApplyingToNode(tNode)) {
                        this.crossesNgTemplate = true;
                        // A marker indicating a `<ng-template>` element (a placeholder for query results from
                        // embedded views created based on this `<ng-template>`).
                        this.addMatch(-tNode.index, childQueryIndex);
                        return new TQuery_(this.metadata);
                    }
                    return null;
                };
                /**
                 * @private
                 * @param {?} tNode
                 * @return {?}
                 */
                TQuery_.prototype.isApplyingToNode = function (tNode) {
                    if (this._appliesToNextNode && this.metadata.descendants === false) {
                        return this._declarationNodeIndex === (tNode.parent ? tNode.parent.index : -1);
                    }
                    return this._appliesToNextNode;
                };
                /**
                 * @private
                 * @param {?} tView
                 * @param {?} tNode
                 * @return {?}
                 */
                TQuery_.prototype.matchTNode = function (tView, tNode) {
                    if (Array.isArray(this.metadata.predicate)) {
                        /** @type {?} */
                        var localNames = ( /** @type {?} */(this.metadata.predicate));
                        for (var i = 0; i < localNames.length; i++) {
                            this.matchTNodeWithReadOption(tView, tNode, getIdxOfMatchingSelector(tNode, localNames[i]));
                        }
                    }
                    else {
                        /** @type {?} */
                        var typePredicate = ( /** @type {?} */(this.metadata.predicate));
                        if (typePredicate === TemplateRef) {
                            if (tNode.type === 0 /* Container */) {
                                this.matchTNodeWithReadOption(tView, tNode, -1);
                            }
                        }
                        else {
                            this.matchTNodeWithReadOption(tView, tNode, locateDirectiveOrProvider(tNode, tView, typePredicate, false, false));
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} tView
                 * @param {?} tNode
                 * @param {?} nodeMatchIdx
                 * @return {?}
                 */
                TQuery_.prototype.matchTNodeWithReadOption = function (tView, tNode, nodeMatchIdx) {
                    if (nodeMatchIdx !== null) {
                        /** @type {?} */
                        var read = this.metadata.read;
                        if (read !== null) {
                            if (read === ElementRef || read === ViewContainerRef ||
                                read === TemplateRef && tNode.type === 0 /* Container */) {
                                this.addMatch(tNode.index, -2);
                            }
                            else {
                                /** @type {?} */
                                var directiveOrProviderIdx = locateDirectiveOrProvider(tNode, tView, read, false, false);
                                if (directiveOrProviderIdx !== null) {
                                    this.addMatch(tNode.index, directiveOrProviderIdx);
                                }
                            }
                        }
                        else {
                            this.addMatch(tNode.index, nodeMatchIdx);
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} tNodeIdx
                 * @param {?} matchIdx
                 * @return {?}
                 */
                TQuery_.prototype.addMatch = function (tNodeIdx, matchIdx) {
                    if (this.matches === null) {
                        this.matches = [tNodeIdx, matchIdx];
                    }
                    else {
                        this.matches.push(tNodeIdx, matchIdx);
                    }
                };
                return TQuery_;
            }());
            if (false) { }
            /**
             * Iterates over local names for a given node and returns directive index
             * (or -1 if a local name points to an element).
             *
             * @param {?} tNode static data of a node to check
             * @param {?} selector selector to match
             * @return {?} directive index, -1 or null if a selector didn't match any of the local names
             */
            function getIdxOfMatchingSelector(tNode, selector) {
                /** @type {?} */
                var localNames = tNode.localNames;
                if (localNames !== null) {
                    for (var i = 0; i < localNames.length; i += 2) {
                        if (localNames[i] === selector) {
                            return ( /** @type {?} */(localNames[i + 1]));
                        }
                    }
                }
                return null;
            }
            /**
             * @param {?} tNode
             * @param {?} currentView
             * @return {?}
             */
            function createResultByTNodeType(tNode, currentView) {
                if (tNode.type === 3 /* Element */ || tNode.type === 4 /* ElementContainer */) {
                    return createElementRef(ElementRef, tNode, currentView);
                }
                else if (tNode.type === 0 /* Container */) {
                    return createTemplateRef(TemplateRef, ElementRef, tNode, currentView);
                }
                return null;
            }
            /**
             * @param {?} lView
             * @param {?} tNode
             * @param {?} matchingIdx
             * @param {?} read
             * @return {?}
             */
            function createResultForNode(lView, tNode, matchingIdx, read) {
                if (matchingIdx === -1) {
                    // if read token and / or strategy is not specified, detect it using appropriate tNode type
                    return createResultByTNodeType(tNode, lView);
                }
                else if (matchingIdx === -2) {
                    // read a special token from a node injector
                    return createSpecialToken(lView, tNode, read);
                }
                else {
                    // read a token
                    return getNodeInjectable(lView[TVIEW].data, lView, matchingIdx, ( /** @type {?} */(tNode)));
                }
            }
            /**
             * @param {?} lView
             * @param {?} tNode
             * @param {?} read
             * @return {?}
             */
            function createSpecialToken(lView, tNode, read) {
                if (read === ElementRef) {
                    return createElementRef(ElementRef, tNode, lView);
                }
                else if (read === TemplateRef) {
                    return createTemplateRef(TemplateRef, ElementRef, tNode, lView);
                }
                else if (read === ViewContainerRef) {
                    ngDevMode && assertNodeOfPossibleTypes(tNode, 3 /* Element */, 0 /* Container */, 4 /* ElementContainer */);
                    return createContainerRef(ViewContainerRef, ElementRef, ( /** @type {?} */(tNode)), lView);
                }
                else {
                    ngDevMode &&
                        throwError("Special token to read should be one of ElementRef, TemplateRef or ViewContainerRef but got " + stringify(read) + ".");
                }
            }
            /**
             * A helper function that creates query results for a given view. This function is meant to do the
             * processing once and only once for a given view instance (a set of results for a given view
             * doesn't change).
             * @template T
             * @param {?} lView
             * @param {?} tQuery
             * @param {?} queryIndex
             * @return {?}
             */
            function materializeViewResults(lView, tQuery, queryIndex) {
                /** @type {?} */
                var lQuery = ( /** @type {?} */(( /** @type {?} */(lView[QUERIES])).queries))[queryIndex];
                if (lQuery.matches === null) {
                    /** @type {?} */
                    var tViewData = lView[TVIEW].data;
                    /** @type {?} */
                    var tQueryMatches = ( /** @type {?} */(tQuery.matches));
                    /** @type {?} */
                    var result = new Array(tQueryMatches.length / 2);
                    for (var i = 0; i < tQueryMatches.length; i += 2) {
                        /** @type {?} */
                        var matchedNodeIdx = tQueryMatches[i];
                        if (matchedNodeIdx < 0) {
                            // we at the <ng-template> marker which might have results in views created based on this
                            // <ng-template> - those results will be in separate views though, so here we just leave
                            // null as a placeholder
                            result[i / 2] = null;
                        }
                        else {
                            ngDevMode && assertDataInRange(tViewData, matchedNodeIdx);
                            /** @type {?} */
                            var tNode = ( /** @type {?} */(tViewData[matchedNodeIdx]));
                            result[i / 2] =
                                createResultForNode(lView, tNode, tQueryMatches[i + 1], tQuery.metadata.read);
                        }
                    }
                    lQuery.matches = result;
                }
                return lQuery.matches;
            }
            /**
             * A helper function that collects (already materialized) query results from a tree of views,
             * starting with a provided LView.
             * @template T
             * @param {?} lView
             * @param {?} queryIndex
             * @param {?} result
             * @return {?}
             */
            function collectQueryResults(lView, queryIndex, result) {
                /** @type {?} */
                var tQuery = ( /** @type {?} */(lView[TVIEW].queries)).getByIndex(queryIndex);
                /** @type {?} */
                var tQueryMatches = tQuery.matches;
                if (tQueryMatches !== null) {
                    /** @type {?} */
                    var lViewResults = materializeViewResults(lView, tQuery, queryIndex);
                    for (var i = 0; i < tQueryMatches.length; i += 2) {
                        /** @type {?} */
                        var tNodeIdx = tQueryMatches[i];
                        if (tNodeIdx > 0) {
                            /** @type {?} */
                            var viewResult = lViewResults[i / 2];
                            ngDevMode && assertDefined(viewResult, 'materialized query result should be defined');
                            result.push(( /** @type {?} */(viewResult)));
                        }
                        else {
                            /** @type {?} */
                            var childQueryIndex = tQueryMatches[i + 1];
                            /** @type {?} */
                            var declarationLContainer = ( /** @type {?} */(lView[-tNodeIdx]));
                            ngDevMode && assertLContainer(declarationLContainer);
                            // collect matches for views inserted in this container
                            for (var i_6 = CONTAINER_HEADER_OFFSET; i_6 < declarationLContainer.length; i_6++) {
                                /** @type {?} */
                                var embeddedLView = declarationLContainer[i_6];
                                if (embeddedLView[DECLARATION_LCONTAINER] === embeddedLView[PARENT]) {
                                    collectQueryResults(embeddedLView, childQueryIndex, result);
                                }
                            }
                            // collect matches for views created from this declaration container and inserted into
                            // different containers
                            if (declarationLContainer[MOVED_VIEWS] !== null) {
                                for (var _c = 0, _d = ( /** @type {?} */(declarationLContainer[MOVED_VIEWS])); _c < _d.length; _c++) {
                                    var embeddedLView = _d[_c];
                                    collectQueryResults(embeddedLView, childQueryIndex, result);
                                }
                            }
                        }
                    }
                }
                return result;
            }
            /**
             * Refreshes a query by combining matches from all active views and removing matches from deleted
             * views.
             *
             * \@codeGenApi
             * @param {?} queryList
             * @return {?} `true` if a query got dirty during change detection or if this is a static query
             * resolving in creation mode, `false` otherwise.
             *
             */
            function ɵɵqueryRefresh(queryList) {
                /** @type {?} */
                var lView = getLView();
                /** @type {?} */
                var queryIndex = getCurrentQueryIndex();
                setCurrentQueryIndex(queryIndex + 1);
                /** @type {?} */
                var tQuery = getTQuery(lView[TVIEW], queryIndex);
                if (queryList.dirty && (isCreationMode() === tQuery.metadata.isStatic)) {
                    if (tQuery.matches === null) {
                        queryList.reset([]);
                    }
                    else {
                        /** @type {?} */
                        var result = tQuery.crossesNgTemplate ? collectQueryResults(lView, queryIndex, []) :
                            materializeViewResults(lView, tQuery, queryIndex);
                        queryList.reset(result);
                        queryList.notifyOnChanges();
                    }
                    return true;
                }
                return false;
            }
            /**
             * Creates new QueryList for a static view query.
             *
             * \@codeGenApi
             * @template T
             * @param {?} predicate The type for which the query will search
             * @param {?} descend Whether or not to descend into children
             * @param {?=} read What to save in the query
             *
             * @return {?}
             */
            function ɵɵstaticViewQuery(predicate, descend, read) {
                viewQueryInternal(getLView(), predicate, descend, read, true);
            }
            /**
             * Creates new QueryList, stores the reference in LView and returns QueryList.
             *
             * \@codeGenApi
             * @template T
             * @param {?} predicate The type for which the query will search
             * @param {?} descend Whether or not to descend into children
             * @param {?=} read What to save in the query
             *
             * @return {?}
             */
            function ɵɵviewQuery(predicate, descend, read) {
                viewQueryInternal(getLView(), predicate, descend, read, false);
            }
            /**
             * @template T
             * @param {?} lView
             * @param {?} predicate
             * @param {?} descend
             * @param {?} read
             * @param {?} isStatic
             * @return {?}
             */
            function viewQueryInternal(lView, predicate, descend, read, isStatic) {
                /** @type {?} */
                var tView = lView[TVIEW];
                if (tView.firstTemplatePass) {
                    createTQuery(tView, new TQueryMetadata_(predicate, descend, isStatic, read), -1);
                    if (isStatic) {
                        tView.staticViewQueries = true;
                    }
                }
                createLQuery(lView);
            }
            /**
             * Loads a QueryList corresponding to the current view query.
             *
             * \@codeGenApi
             * @template T
             * @return {?}
             */
            function ɵɵloadViewQuery() {
                return loadQueryInternal(getLView(), getCurrentQueryIndex());
            }
            /**
             * Registers a QueryList, associated with a content query, for later refresh (part of a view
             * refresh).
             *
             * \@codeGenApi
             * @template T
             * @param {?} directiveIndex Current directive index
             * @param {?} predicate The type for which the query will search
             * @param {?} descend Whether or not to descend into children
             * @param {?=} read What to save in the query
             * @return {?} QueryList<T>
             *
             */
            function ɵɵcontentQuery(directiveIndex, predicate, descend, read) {
                contentQueryInternal(getLView(), predicate, descend, read, false, getPreviousOrParentTNode(), directiveIndex);
            }
            /**
             * Registers a QueryList, associated with a static content query, for later refresh
             * (part of a view refresh).
             *
             * \@codeGenApi
             * @template T
             * @param {?} directiveIndex Current directive index
             * @param {?} predicate The type for which the query will search
             * @param {?} descend Whether or not to descend into children
             * @param {?=} read What to save in the query
             * @return {?} QueryList<T>
             *
             */
            function ɵɵstaticContentQuery(directiveIndex, predicate, descend, read) {
                contentQueryInternal(getLView(), predicate, descend, read, true, getPreviousOrParentTNode(), directiveIndex);
            }
            /**
             * @template T
             * @param {?} lView
             * @param {?} predicate
             * @param {?} descend
             * @param {?} read
             * @param {?} isStatic
             * @param {?} tNode
             * @param {?} directiveIndex
             * @return {?}
             */
            function contentQueryInternal(lView, predicate, descend, read, isStatic, tNode, directiveIndex) {
                /** @type {?} */
                var tView = lView[TVIEW];
                if (tView.firstTemplatePass) {
                    createTQuery(tView, new TQueryMetadata_(predicate, descend, isStatic, read), tNode.index);
                    saveContentQueryAndDirectiveIndex(tView, directiveIndex);
                    if (isStatic) {
                        tView.staticContentQueries = true;
                    }
                }
                createLQuery(lView);
            }
            /**
             * Loads a QueryList corresponding to the current content query.
             *
             * \@codeGenApi
             * @template T
             * @return {?}
             */
            function ɵɵloadContentQuery() {
                return loadQueryInternal(getLView(), getCurrentQueryIndex());
            }
            /**
             * @template T
             * @param {?} lView
             * @param {?} queryIndex
             * @return {?}
             */
            function loadQueryInternal(lView, queryIndex) {
                ngDevMode &&
                    assertDefined(lView[QUERIES], 'LQueries should be defined when trying to load a query');
                ngDevMode && assertDataInRange(( /** @type {?} */(lView[QUERIES])).queries, queryIndex);
                return ( /** @type {?} */(lView[QUERIES])).queries[queryIndex].queryList;
            }
            /**
             * @template T
             * @param {?} lView
             * @return {?}
             */
            function createLQuery(lView) {
                /** @type {?} */
                var queryList = new QueryList();
                storeCleanupWithContext(lView, queryList, queryList.destroy);
                if (lView[QUERIES] === null)
                    lView[QUERIES] = new LQueries_();
                ( /** @type {?} */(lView[QUERIES])).queries.push(new LQuery_(queryList));
            }
            /**
             * @param {?} tView
             * @param {?} metadata
             * @param {?} nodeIndex
             * @return {?}
             */
            function createTQuery(tView, metadata, nodeIndex) {
                if (tView.queries === null)
                    tView.queries = new TQueries_();
                tView.queries.track(new TQuery_(metadata, nodeIndex));
            }
            /**
             * @param {?} tView
             * @param {?} directiveIndex
             * @return {?}
             */
            function saveContentQueryAndDirectiveIndex(tView, directiveIndex) {
                /** @type {?} */
                var tViewContentQueries = tView.contentQueries || (tView.contentQueries = []);
                /** @type {?} */
                var lastSavedDirectiveIndex = tView.contentQueries.length ? tViewContentQueries[tViewContentQueries.length - 1] : -1;
                if (directiveIndex !== lastSavedDirectiveIndex) {
                    tViewContentQueries.push(( /** @type {?} */(tView.queries)).length - 1, directiveIndex);
                }
            }
            /**
             * @param {?} tView
             * @param {?} index
             * @return {?}
             */
            function getTQuery(tView, index) {
                ngDevMode && assertDefined(tView.queries, 'TQueries must be defined to retrieve a TQuery');
                return ( /** @type {?} */(tView.queries)).getByIndex(index);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Retrieves `TemplateRef` instance from `Injector` when a local reference is placed on the
             * `<ng-template>` element.
             *
             * \@codeGenApi
             * @param {?} tNode
             * @param {?} currentView
             * @return {?}
             */
            function ɵɵtemplateRefExtractor(tNode, currentView) {
                return createTemplateRef(TemplateRef, ElementRef, tNode, currentView);
            }
            /**
             * Returns the appropriate `ChangeDetectorRef` for a pipe.
             *
             * \@codeGenApi
             * @param {?=} flags
             * @return {?}
             */
            function ɵɵinjectPipeChangeDetectorRef(flags) {
                if (flags === void 0) { flags = InjectFlags.Default; }
                /** @type {?} */
                var value = injectChangeDetectorRef(true);
                if (value == null && !(flags & InjectFlags.Optional)) {
                    throw new Error("No provider for ChangeDetectorRef!");
                }
                else {
                    return value;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$e = /**
             * @return {?}
             */ function () { return ({
                'ɵɵattribute': ɵɵattribute,
                'ɵɵattributeInterpolate1': ɵɵattributeInterpolate1,
                'ɵɵattributeInterpolate2': ɵɵattributeInterpolate2,
                'ɵɵattributeInterpolate3': ɵɵattributeInterpolate3,
                'ɵɵattributeInterpolate4': ɵɵattributeInterpolate4,
                'ɵɵattributeInterpolate5': ɵɵattributeInterpolate5,
                'ɵɵattributeInterpolate6': ɵɵattributeInterpolate6,
                'ɵɵattributeInterpolate7': ɵɵattributeInterpolate7,
                'ɵɵattributeInterpolate8': ɵɵattributeInterpolate8,
                'ɵɵattributeInterpolateV': ɵɵattributeInterpolateV,
                'ɵɵdefineBase': ɵɵdefineBase,
                'ɵɵdefineComponent': ɵɵdefineComponent,
                'ɵɵdefineDirective': ɵɵdefineDirective,
                'ɵɵdefineInjectable': ɵɵdefineInjectable,
                'ɵɵdefineInjector': ɵɵdefineInjector,
                'ɵɵdefineNgModule': ɵɵdefineNgModule,
                'ɵɵdefinePipe': ɵɵdefinePipe,
                'ɵɵdirectiveInject': ɵɵdirectiveInject,
                'ɵɵgetFactoryOf': ɵɵgetFactoryOf,
                'ɵɵgetInheritedFactory': ɵɵgetInheritedFactory,
                'ɵɵinject': ɵɵinject,
                'ɵɵinjectAttribute': ɵɵinjectAttribute,
                'ɵɵinjectPipeChangeDetectorRef': ɵɵinjectPipeChangeDetectorRef,
                'ɵɵtemplateRefExtractor': ɵɵtemplateRefExtractor,
                'ɵɵNgOnChangesFeature': ɵɵNgOnChangesFeature,
                'ɵɵProvidersFeature': ɵɵProvidersFeature,
                'ɵɵInheritDefinitionFeature': ɵɵInheritDefinitionFeature,
                'ɵɵcontainer': ɵɵcontainer,
                'ɵɵnextContext': ɵɵnextContext,
                'ɵɵcontainerRefreshStart': ɵɵcontainerRefreshStart,
                'ɵɵcontainerRefreshEnd': ɵɵcontainerRefreshEnd,
                'ɵɵnamespaceHTML': ɵɵnamespaceHTML,
                'ɵɵnamespaceMathML': ɵɵnamespaceMathML,
                'ɵɵnamespaceSVG': ɵɵnamespaceSVG,
                'ɵɵenableBindings': ɵɵenableBindings,
                'ɵɵdisableBindings': ɵɵdisableBindings,
                'ɵɵallocHostVars': ɵɵallocHostVars,
                'ɵɵelementStart': ɵɵelementStart,
                'ɵɵelementEnd': ɵɵelementEnd,
                'ɵɵelement': ɵɵelement,
                'ɵɵelementContainerStart': ɵɵelementContainerStart,
                'ɵɵelementContainerEnd': ɵɵelementContainerEnd,
                'ɵɵelementContainer': ɵɵelementContainer,
                'ɵɵpureFunction0': ɵɵpureFunction0,
                'ɵɵpureFunction1': ɵɵpureFunction1,
                'ɵɵpureFunction2': ɵɵpureFunction2,
                'ɵɵpureFunction3': ɵɵpureFunction3,
                'ɵɵpureFunction4': ɵɵpureFunction4,
                'ɵɵpureFunction5': ɵɵpureFunction5,
                'ɵɵpureFunction6': ɵɵpureFunction6,
                'ɵɵpureFunction7': ɵɵpureFunction7,
                'ɵɵpureFunction8': ɵɵpureFunction8,
                'ɵɵpureFunctionV': ɵɵpureFunctionV,
                'ɵɵgetCurrentView': ɵɵgetCurrentView,
                'ɵɵrestoreView': ɵɵrestoreView,
                'ɵɵlistener': ɵɵlistener,
                'ɵɵload': ɵɵload,
                'ɵɵprojection': ɵɵprojection,
                'ɵɵupdateSyntheticHostBinding': ɵɵupdateSyntheticHostBinding,
                'ɵɵcomponentHostSyntheticListener': ɵɵcomponentHostSyntheticListener,
                'ɵɵpipeBind1': ɵɵpipeBind1,
                'ɵɵpipeBind2': ɵɵpipeBind2,
                'ɵɵpipeBind3': ɵɵpipeBind3,
                'ɵɵpipeBind4': ɵɵpipeBind4,
                'ɵɵpipeBindV': ɵɵpipeBindV,
                'ɵɵprojectionDef': ɵɵprojectionDef,
                'ɵɵhostProperty': ɵɵhostProperty,
                'ɵɵproperty': ɵɵproperty,
                'ɵɵpropertyInterpolate': ɵɵpropertyInterpolate,
                'ɵɵpropertyInterpolate1': ɵɵpropertyInterpolate1,
                'ɵɵpropertyInterpolate2': ɵɵpropertyInterpolate2,
                'ɵɵpropertyInterpolate3': ɵɵpropertyInterpolate3,
                'ɵɵpropertyInterpolate4': ɵɵpropertyInterpolate4,
                'ɵɵpropertyInterpolate5': ɵɵpropertyInterpolate5,
                'ɵɵpropertyInterpolate6': ɵɵpropertyInterpolate6,
                'ɵɵpropertyInterpolate7': ɵɵpropertyInterpolate7,
                'ɵɵpropertyInterpolate8': ɵɵpropertyInterpolate8,
                'ɵɵpropertyInterpolateV': ɵɵpropertyInterpolateV,
                'ɵɵpipe': ɵɵpipe,
                'ɵɵqueryRefresh': ɵɵqueryRefresh,
                'ɵɵviewQuery': ɵɵviewQuery,
                'ɵɵstaticViewQuery': ɵɵstaticViewQuery,
                'ɵɵstaticContentQuery': ɵɵstaticContentQuery,
                'ɵɵloadViewQuery': ɵɵloadViewQuery,
                'ɵɵcontentQuery': ɵɵcontentQuery,
                'ɵɵloadContentQuery': ɵɵloadContentQuery,
                'ɵɵreference': ɵɵreference,
                'ɵɵelementHostAttrs': ɵɵelementHostAttrs,
                'ɵɵclassMap': ɵɵclassMap,
                'ɵɵclassMapInterpolate1': ɵɵclassMapInterpolate1,
                'ɵɵclassMapInterpolate2': ɵɵclassMapInterpolate2,
                'ɵɵclassMapInterpolate3': ɵɵclassMapInterpolate3,
                'ɵɵclassMapInterpolate4': ɵɵclassMapInterpolate4,
                'ɵɵclassMapInterpolate5': ɵɵclassMapInterpolate5,
                'ɵɵclassMapInterpolate6': ɵɵclassMapInterpolate6,
                'ɵɵclassMapInterpolate7': ɵɵclassMapInterpolate7,
                'ɵɵclassMapInterpolate8': ɵɵclassMapInterpolate8,
                'ɵɵclassMapInterpolateV': ɵɵclassMapInterpolateV,
                'ɵɵstyling': ɵɵstyling,
                'ɵɵstyleMap': ɵɵstyleMap,
                'ɵɵstyleProp': ɵɵstyleProp,
                'ɵɵstylePropInterpolate1': ɵɵstylePropInterpolate1,
                'ɵɵstylePropInterpolate2': ɵɵstylePropInterpolate2,
                'ɵɵstylePropInterpolate3': ɵɵstylePropInterpolate3,
                'ɵɵstylePropInterpolate4': ɵɵstylePropInterpolate4,
                'ɵɵstylePropInterpolate5': ɵɵstylePropInterpolate5,
                'ɵɵstylePropInterpolate6': ɵɵstylePropInterpolate6,
                'ɵɵstylePropInterpolate7': ɵɵstylePropInterpolate7,
                'ɵɵstylePropInterpolate8': ɵɵstylePropInterpolate8,
                'ɵɵstylePropInterpolateV': ɵɵstylePropInterpolateV,
                'ɵɵstyleSanitizer': ɵɵstyleSanitizer,
                'ɵɵstylingApply': ɵɵstylingApply,
                'ɵɵclassProp': ɵɵclassProp,
                'ɵɵselect': ɵɵselect,
                'ɵɵtemplate': ɵɵtemplate,
                'ɵɵtext': ɵɵtext,
                'ɵɵtextBinding': ɵɵtextBinding,
                'ɵɵtextInterpolate': ɵɵtextInterpolate,
                'ɵɵtextInterpolate1': ɵɵtextInterpolate1,
                'ɵɵtextInterpolate2': ɵɵtextInterpolate2,
                'ɵɵtextInterpolate3': ɵɵtextInterpolate3,
                'ɵɵtextInterpolate4': ɵɵtextInterpolate4,
                'ɵɵtextInterpolate5': ɵɵtextInterpolate5,
                'ɵɵtextInterpolate6': ɵɵtextInterpolate6,
                'ɵɵtextInterpolate7': ɵɵtextInterpolate7,
                'ɵɵtextInterpolate8': ɵɵtextInterpolate8,
                'ɵɵtextInterpolateV': ɵɵtextInterpolateV,
                'ɵɵembeddedViewStart': ɵɵembeddedViewStart,
                'ɵɵembeddedViewEnd': ɵɵembeddedViewEnd,
                'ɵɵi18n': ɵɵi18n,
                'ɵɵi18nAttributes': ɵɵi18nAttributes,
                'ɵɵi18nExp': ɵɵi18nExp,
                'ɵɵi18nStart': ɵɵi18nStart,
                'ɵɵi18nEnd': ɵɵi18nEnd,
                'ɵɵi18nApply': ɵɵi18nApply,
                'ɵɵi18nPostprocess': ɵɵi18nPostprocess,
                'ɵɵi18nLocalize': ɵɵi18nLocalize,
                'ɵɵresolveWindow': ɵɵresolveWindow,
                'ɵɵresolveDocument': ɵɵresolveDocument,
                'ɵɵresolveBody': ɵɵresolveBody,
                'ɵɵsetComponentScope': ɵɵsetComponentScope,
                'ɵɵsetNgModuleScope': ɵɵsetNgModuleScope,
                'ɵɵsanitizeHtml': ɵɵsanitizeHtml,
                'ɵɵsanitizeStyle': ɵɵsanitizeStyle,
                'ɵɵdefaultStyleSanitizer': ɵɵdefaultStyleSanitizer,
                'ɵɵsanitizeResourceUrl': ɵɵsanitizeResourceUrl,
                'ɵɵsanitizeScript': ɵɵsanitizeScript,
                'ɵɵsanitizeUrl': ɵɵsanitizeUrl,
                'ɵɵsanitizeUrlOrResourceUrl': ɵɵsanitizeUrlOrResourceUrl,
            }); };
            /**
             * A mapping of the \@angular/core API surface used in generated expressions to the actual symbols.
             *
             * This should be kept up to date with the public exports of \@angular/core.
             * @type {?}
             */
            var angularCoreEnv = ((ɵ0$e))();
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EMPTY_ARRAY$4 = [];
            /**
             * @record
             */
            function ModuleQueueItem() { }
            if (false) { }
            /** @type {?} */
            var moduleQueue = [];
            /**
             * Enqueues moduleDef to be checked later to see if scope can be set on its
             * component declarations.
             * @param {?} moduleType
             * @param {?} ngModule
             * @return {?}
             */
            function enqueueModuleForDelayedScoping(moduleType, ngModule) {
                moduleQueue.push({ moduleType: moduleType, ngModule: ngModule });
            }
            /** @type {?} */
            var flushingModuleQueue = false;
            /**
             * Loops over queued module definitions, if a given module definition has all of its
             * declarations resolved, it dequeues that module definition and sets the scope on
             * its declarations.
             * @return {?}
             */
            function flushModuleScopingQueueAsMuchAsPossible() {
                if (!flushingModuleQueue) {
                    flushingModuleQueue = true;
                    try {
                        for (var i = moduleQueue.length - 1; i >= 0; i--) {
                            var _c = moduleQueue[i], moduleType = _c.moduleType, ngModule = _c.ngModule;
                            if (ngModule.declarations && ngModule.declarations.every(isResolvedDeclaration)) {
                                // dequeue
                                moduleQueue.splice(i, 1);
                                setScopeOnDeclaredComponents(moduleType, ngModule);
                            }
                        }
                    }
                    finally {
                        flushingModuleQueue = false;
                    }
                }
            }
            /**
             * Returns truthy if a declaration has resolved. If the declaration happens to be
             * an array of declarations, it will recurse to check each declaration in that array
             * (which may also be arrays).
             * @param {?} declaration
             * @return {?}
             */
            function isResolvedDeclaration(declaration) {
                if (Array.isArray(declaration)) {
                    return declaration.every(isResolvedDeclaration);
                }
                return !!resolveForwardRef(declaration);
            }
            /**
             * Compiles a module in JIT mode.
             *
             * This function automatically gets called when a class has a `\@NgModule` decorator.
             * @param {?} moduleType
             * @param {?=} ngModule
             * @return {?}
             */
            function compileNgModule(moduleType, ngModule) {
                if (ngModule === void 0) { ngModule = {}; }
                compileNgModuleDefs(( /** @type {?} */(moduleType)), ngModule);
                // Because we don't know if all declarations have resolved yet at the moment the
                // NgModule decorator is executing, we're enqueueing the setting of module scope
                // on its declarations to be run at a later time when all declarations for the module,
                // including forward refs, have resolved.
                enqueueModuleForDelayedScoping(moduleType, ngModule);
            }
            /**
             * Compiles and adds the `ngModuleDef` and `ngInjectorDef` properties to the module class.
             *
             * It's possible to compile a module via this API which will allow duplicate declarations in its
             * root.
             * @param {?} moduleType
             * @param {?} ngModule
             * @param {?=} allowDuplicateDeclarationsInRoot
             * @return {?}
             */
            function compileNgModuleDefs(moduleType, ngModule, allowDuplicateDeclarationsInRoot) {
                if (allowDuplicateDeclarationsInRoot === void 0) { allowDuplicateDeclarationsInRoot = false; }
                ngDevMode && assertDefined(moduleType, 'Required value moduleType');
                ngDevMode && assertDefined(ngModule, 'Required value ngModule');
                /** @type {?} */
                var declarations = flatten(ngModule.declarations || EMPTY_ARRAY$4);
                /** @type {?} */
                /** @nocollapse */ var ngModuleDef = null;
                Object.defineProperty(moduleType, NG_MODULE_DEF, {
                    configurable: true,
                    get: ( /**
                     * @return {?}
                     */function () {
                        if (ngModuleDef === null) {
                            if (ngDevMode && ngModule.imports && ngModule.imports.indexOf(moduleType) > -1) {
                                // We need to assert this immediately, because allowing it to continue will cause it to
                                // go into an infinite loop before we've reached the point where we throw all the errors.
                                throw new Error("'" + stringifyForError(moduleType) + "' module can't import itself");
                            }
                            ngModuleDef = getCompilerFacade().compileNgModule(angularCoreEnv, "ng:///" + moduleType.name + "/ngModuleDef.js", {
                                type: moduleType,
                                bootstrap: flatten(ngModule.bootstrap || EMPTY_ARRAY$4).map(resolveForwardRef),
                                declarations: declarations.map(resolveForwardRef),
                                imports: flatten(ngModule.imports || EMPTY_ARRAY$4)
                                    .map(resolveForwardRef)
                                    .map(expandModuleWithProviders),
                                exports: flatten(ngModule.exports || EMPTY_ARRAY$4)
                                    .map(resolveForwardRef)
                                    .map(expandModuleWithProviders),
                                emitInline: true,
                                schemas: ngModule.schemas ? flatten(ngModule.schemas) : null,
                                id: ngModule.id || null,
                            });
                        }
                        return ngModuleDef;
                    })
                });
                /** @type {?} */
                /** @nocollapse */ var ngInjectorDef = null;
                Object.defineProperty(moduleType, NG_INJECTOR_DEF, {
                    get: ( /**
                     * @return {?}
                     */function () {
                        if (ngInjectorDef === null) {
                            ngDevMode && verifySemanticsOfNgModuleDef(( /** @type {?} */(( /** @type {?} */(moduleType)))), allowDuplicateDeclarationsInRoot);
                            /** @type {?} */
                            var meta = {
                                name: moduleType.name,
                                type: moduleType,
                                deps: reflectDependencies(moduleType),
                                providers: ngModule.providers || EMPTY_ARRAY$4,
                                imports: [
                                    (ngModule.imports || EMPTY_ARRAY$4).map(resolveForwardRef),
                                    (ngModule.exports || EMPTY_ARRAY$4).map(resolveForwardRef),
                                ],
                            };
                            ngInjectorDef = getCompilerFacade().compileInjector(angularCoreEnv, "ng:///" + moduleType.name + "/ngInjectorDef.js", meta);
                        }
                        return ngInjectorDef;
                    }),
                    // Make the property configurable in dev mode to allow overriding in tests
                    configurable: !!ngDevMode,
                });
            }
            /**
             * @param {?} moduleType
             * @param {?} allowDuplicateDeclarationsInRoot
             * @param {?=} importingModule
             * @return {?}
             */
            function verifySemanticsOfNgModuleDef(moduleType, allowDuplicateDeclarationsInRoot, importingModule) {
                if (verifiedNgModule.get(moduleType))
                    return;
                verifiedNgModule.set(moduleType, true);
                moduleType = resolveForwardRef(moduleType);
                /** @type {?} */
                var ngModuleDef;
                if (importingModule) {
                    ngModuleDef = ( /** @type {?} */(getNgModuleDef(moduleType)));
                    if (!ngModuleDef) {
                        throw new Error("Unexpected value '" + moduleType.name + "' imported by the module '" + importingModule.name + "'. Please add an @NgModule annotation.");
                    }
                }
                else {
                    ngModuleDef = getNgModuleDef(moduleType, true);
                }
                /** @type {?} */
                var errors = [];
                /** @type {?} */
                var declarations = maybeUnwrapFn(ngModuleDef.declarations);
                /** @type {?} */
                var imports = maybeUnwrapFn(ngModuleDef.imports);
                flatten(imports).map(unwrapModuleWithProvidersImports).forEach(( /**
                 * @param {?} mod
                 * @return {?}
                 */function (/**
                 * @param {?} mod
                 * @return {?}
                 */ mod) {
                    verifySemanticsOfNgModuleImport(mod, moduleType);
                    verifySemanticsOfNgModuleDef(mod, false, moduleType);
                }));
                /** @type {?} */
                var exports = maybeUnwrapFn(ngModuleDef.exports);
                declarations.forEach(verifyDeclarationsHaveDefinitions);
                /** @type {?} */
                var combinedDeclarations = declarations.map(resolveForwardRef).concat(flatten(imports.map(computeCombinedExports)).map(resolveForwardRef));
                exports.forEach(verifyExportsAreDeclaredOrReExported);
                declarations.forEach(( /**
                 * @param {?} decl
                 * @return {?}
                 */function (/**
                 * @param {?} decl
                 * @return {?}
                 */ decl) { return verifyDeclarationIsUnique(decl, allowDuplicateDeclarationsInRoot); }));
                declarations.forEach(verifyComponentEntryComponentsIsPartOfNgModule);
                /** @type {?} */
                var ngModule = getAnnotation(moduleType, 'NgModule');
                if (ngModule) {
                    ngModule.imports &&
                        flatten(ngModule.imports).map(unwrapModuleWithProvidersImports).forEach(( /**
                         * @param {?} mod
                         * @return {?}
                         */function (/**
                         * @param {?} mod
                         * @return {?}
                         */ mod) {
                            verifySemanticsOfNgModuleImport(mod, moduleType);
                            verifySemanticsOfNgModuleDef(mod, false, moduleType);
                        }));
                    ngModule.bootstrap && deepForEach(ngModule.bootstrap, verifyCorrectBootstrapType);
                    ngModule.bootstrap && deepForEach(ngModule.bootstrap, verifyComponentIsPartOfNgModule);
                    ngModule.entryComponents &&
                        deepForEach(ngModule.entryComponents, verifyComponentIsPartOfNgModule);
                }
                // Throw Error if any errors were detected.
                if (errors.length) {
                    throw new Error(errors.join('\n'));
                }
                ////////////////////////////////////////////////////////////////////////////////////////////////
                /**
                 * @param {?} type
                 * @return {?}
                 */
                function verifyDeclarationsHaveDefinitions(type) {
                    type = resolveForwardRef(type);
                    /** @type {?} */
                    var def = getComponentDef(type) || getDirectiveDef(type) || getPipeDef(type);
                    if (!def) {
                        errors.push("Unexpected value '" + stringifyForError(type) + "' declared by the module '" + stringifyForError(moduleType) + "'. Please add a @Pipe/@Directive/@Component annotation.");
                    }
                }
                /**
                 * @param {?} type
                 * @return {?}
                 */
                function verifyExportsAreDeclaredOrReExported(type) {
                    type = resolveForwardRef(type);
                    /** @type {?} */
                    var kind = getComponentDef(type) && 'component' || getDirectiveDef(type) && 'directive' ||
                        getPipeDef(type) && 'pipe';
                    if (kind) {
                        // only checked if we are declared as Component, Directive, or Pipe
                        // Modules don't need to be declared or imported.
                        if (combinedDeclarations.lastIndexOf(type) === -1) {
                            // We are exporting something which we don't explicitly declare or import.
                            errors.push("Can't export " + kind + " " + stringifyForError(type) + " from " + stringifyForError(moduleType) + " as it was neither declared nor imported!");
                        }
                    }
                }
                /**
                 * @param {?} type
                 * @param {?} suppressErrors
                 * @return {?}
                 */
                function verifyDeclarationIsUnique(type, suppressErrors) {
                    type = resolveForwardRef(type);
                    /** @type {?} */
                    var existingModule = ownerNgModule.get(type);
                    if (existingModule && existingModule !== moduleType) {
                        if (!suppressErrors) {
                            /** @type {?} */
                            var modules_1 = [existingModule, moduleType].map(stringifyForError).sort();
                            errors.push("Type " + stringifyForError(type) + " is part of the declarations of 2 modules: " + modules_1[0] + " and " + modules_1[1] + "! " +
                                ("Please consider moving " + stringifyForError(type) + " to a higher module that imports " + modules_1[0] + " and " + modules_1[1] + ". ") +
                                ("You can also create a new NgModule that exports and includes " + stringifyForError(type) + " then import that NgModule in " + modules_1[0] + " and " + modules_1[1] + "."));
                        }
                    }
                    else {
                        // Mark type as having owner.
                        ownerNgModule.set(type, moduleType);
                    }
                }
                /**
                 * @param {?} type
                 * @return {?}
                 */
                function verifyComponentIsPartOfNgModule(type) {
                    type = resolveForwardRef(type);
                    /** @type {?} */
                    var existingModule = ownerNgModule.get(type);
                    if (!existingModule) {
                        errors.push("Component " + stringifyForError(type) + " is not part of any NgModule or the module has not been imported into your module.");
                    }
                }
                /**
                 * @param {?} type
                 * @return {?}
                 */
                function verifyCorrectBootstrapType(type) {
                    type = resolveForwardRef(type);
                    if (!getComponentDef(type)) {
                        errors.push(stringifyForError(type) + " cannot be used as an entry component.");
                    }
                }
                /**
                 * @param {?} type
                 * @return {?}
                 */
                function verifyComponentEntryComponentsIsPartOfNgModule(type) {
                    type = resolveForwardRef(type);
                    if (getComponentDef(type)) {
                        // We know we are component
                        /** @type {?} */
                        var component = getAnnotation(type, 'Component');
                        if (component && component.entryComponents) {
                            deepForEach(component.entryComponents, verifyComponentIsPartOfNgModule);
                        }
                    }
                }
                /**
                 * @param {?} type
                 * @param {?} importingModule
                 * @return {?}
                 */
                function verifySemanticsOfNgModuleImport(type, importingModule) {
                    type = resolveForwardRef(type);
                    if (getComponentDef(type) || getDirectiveDef(type)) {
                        throw new Error("Unexpected directive '" + type.name + "' imported by the module '" + importingModule.name + "'. Please add an @NgModule annotation.");
                    }
                    if (getPipeDef(type)) {
                        throw new Error("Unexpected pipe '" + type.name + "' imported by the module '" + importingModule.name + "'. Please add an @NgModule annotation.");
                    }
                }
            }
            /**
             * @param {?} typeOrWithProviders
             * @return {?}
             */
            function unwrapModuleWithProvidersImports(typeOrWithProviders) {
                typeOrWithProviders = resolveForwardRef(typeOrWithProviders);
                return (( /** @type {?} */(typeOrWithProviders))).ngModule || typeOrWithProviders;
            }
            /**
             * @template T
             * @param {?} type
             * @param {?} name
             * @return {?}
             */
            function getAnnotation(type, name) {
                /** @type {?} */
                var annotation = null;
                collect(type.__annotations__);
                collect(type.decorators);
                return annotation;
                /**
                 * @param {?} annotations
                 * @return {?}
                 */
                function collect(annotations) {
                    if (annotations) {
                        annotations.forEach(readAnnotation);
                    }
                }
                /**
                 * @param {?} decorator
                 * @return {?}
                 */
                function readAnnotation(decorator) {
                    if (!annotation) {
                        /** @type {?} */
                        var proto = Object.getPrototypeOf(decorator);
                        if (proto.ngMetadataName == name) {
                            annotation = ( /** @type {?} */(decorator));
                        }
                        else if (decorator.type) {
                            /** @type {?} */
                            var proto_1 = Object.getPrototypeOf(decorator.type);
                            if (proto_1.ngMetadataName == name) {
                                annotation = decorator.args[0];
                            }
                        }
                    }
                }
            }
            /**
             * Keep track of compiled components. This is needed because in tests we often want to compile the
             * same component with more than one NgModule. This would cause an error unless we reset which
             * NgModule the component belongs to. We keep the list of compiled components here so that the
             * TestBed can reset it later.
             * @type {?}
             */
            var ownerNgModule = new Map();
            /** @type {?} */
            var verifiedNgModule = new Map();
            /**
             * @return {?}
             */
            function resetCompiledComponents() {
                ownerNgModule = new Map();
                verifiedNgModule = new Map();
                moduleQueue.length = 0;
            }
            /**
             * Computes the combined declarations of explicit declarations, as well as declarations inherited by
             * traversing the exports of imported modules.
             * @param {?} type
             * @return {?}
             */
            function computeCombinedExports(type) {
                type = resolveForwardRef(type);
                /** @type {?} */
                /** @nocollapse */ var ngModuleDef = getNgModuleDef(type, true);
                return flatten(maybeUnwrapFn(ngModuleDef.exports).map(( /**
                     * @param {?} type
                     * @return {?}
                     */function (type) {
                    /** @type {?} */
                    /** @nocollapse */ var ngModuleDef = getNgModuleDef(type);
                    if (ngModuleDef) {
                        verifySemanticsOfNgModuleDef(( /** @type {?} */(( /** @type {?} */(type)))), false);
                        return computeCombinedExports(type);
                    }
                    else {
                        return type;
                    }
                }))).slice();
            }
            /**
             * Some declared components may be compiled asynchronously, and thus may not have their
             * ngComponentDef set yet. If this is the case, then a reference to the module is written into
             * the `ngSelectorScope` property of the declared type.
             * @param {?} moduleType
             * @param {?} ngModule
             * @return {?}
             */
            function setScopeOnDeclaredComponents(moduleType, ngModule) {
                /** @type {?} */
                var declarations = flatten(ngModule.declarations || EMPTY_ARRAY$4);
                /** @type {?} */
                var transitiveScopes = transitiveScopesFor(moduleType);
                declarations.forEach(( /**
                 * @param {?} declaration
                 * @return {?}
                 */function (/**
                 * @param {?} declaration
                 * @return {?}
                 */ declaration) {
                    if (declaration.hasOwnProperty(NG_COMPONENT_DEF)) {
                        // An `ngComponentDef` field exists - go ahead and patch the component directly.
                        /** @type {?} */
                        var component = ( /** @type {?} */(declaration));
                        /** @type {?} */
                        var componentDef = ( /** @type {?} */(getComponentDef(component)));
                        patchComponentDefWithScope(componentDef, transitiveScopes);
                    }
                    else if (!declaration.hasOwnProperty(NG_DIRECTIVE_DEF) && !declaration.hasOwnProperty(NG_PIPE_DEF)) {
                        // Set `ngSelectorScope` for future reference when the component compilation finishes.
                        (( /** @type {?} */(declaration))).ngSelectorScope = moduleType;
                    }
                }));
            }
            /**
             * Patch the definition of a component with directives and pipes from the compilation scope of
             * a given module.
             * @template C
             * @param {?} componentDef
             * @param {?} transitiveScopes
             * @return {?}
             */
            function patchComponentDefWithScope(componentDef, transitiveScopes) {
                componentDef.directiveDefs = ( /**
                 * @return {?}
                 */function () { return Array.from(transitiveScopes.compilation.directives)
                    .map(( /**
             * @param {?} dir
             * @return {?}
             */function (/**
             * @param {?} dir
             * @return {?}
             */ dir) { return dir.hasOwnProperty(NG_COMPONENT_DEF) ? ( /** @type {?} */(getComponentDef(dir))) :
                    ( /** @type {?} */(getDirectiveDef(dir))); }))
                    .filter(( /**
             * @param {?} def
             * @return {?}
             */function (/**
             * @param {?} def
             * @return {?}
             */ def) { return !!def; })); });
                componentDef.pipeDefs = ( /**
                 * @return {?}
                 */function () { return Array.from(transitiveScopes.compilation.pipes).map(( /**
                 * @param {?} pipe
                 * @return {?}
                 */function (/**
                 * @param {?} pipe
                 * @return {?}
                 */ pipe) { return ( /** @type {?} */(getPipeDef(pipe))); })); });
                componentDef.schemas = transitiveScopes.schemas;
                // Since we avoid Components/Directives/Pipes recompiling in case there are no overrides, we
                // may face a problem where previously compiled defs available to a given Component/Directive
                // are cached in TView and may become stale (in case any of these defs gets recompiled). In
                // order to avoid this problem, we force fresh TView to be created.
                componentDef.tView = null;
            }
            /**
             * Compute the pair of transitive scopes (compilation scope and exported scope) for a given module.
             *
             * This operation is memoized and the result is cached on the module's definition. It can be called
             * on modules with components that have not fully compiled yet, but the result should not be used
             * until they have.
             * @template T
             * @param {?} moduleType
             * @param {?=} processNgModuleFn
             * @return {?}
             */
            function transitiveScopesFor(moduleType, processNgModuleFn) {
                if (!isNgModule(moduleType)) {
                    throw new Error(moduleType.name + " does not have an ngModuleDef");
                }
                /** @type {?} */
                var def = ( /** @type {?} */(getNgModuleDef(moduleType)));
                if (def.transitiveCompileScopes !== null) {
                    return def.transitiveCompileScopes;
                }
                /** @type {?} */
                var scopes = {
                    schemas: def.schemas || null,
                    compilation: {
                        directives: new Set(),
                        pipes: new Set(),
                    },
                    exported: {
                        directives: new Set(),
                        pipes: new Set(),
                    },
                };
                maybeUnwrapFn(def.declarations).forEach(( /**
                 * @param {?} declared
                 * @return {?}
                 */function (/**
                 * @param {?} declared
                 * @return {?}
                 */ declared) {
                    /** @type {?} */
                    var declaredWithDefs = ( /** @type {?} */(declared));
                    if (getPipeDef(declaredWithDefs)) {
                        scopes.compilation.pipes.add(declared);
                    }
                    else {
                        // Either declared has an ngComponentDef or ngDirectiveDef, or it's a component which hasn't
                        // had its template compiled yet. In either case, it gets added to the compilation's
                        // directives.
                        scopes.compilation.directives.add(declared);
                    }
                }));
                maybeUnwrapFn(def.imports).forEach(( /**
                 * @template I
                 * @param {?} imported
                 * @return {?}
                 */function (imported) {
                    /** @type {?} */
                    var importedType = ( /** @type {?} */(imported));
                    if (!isNgModule(importedType)) {
                        throw new Error("Importing " + importedType.name + " which does not have an ngModuleDef");
                    }
                    if (processNgModuleFn) {
                        processNgModuleFn(( /** @type {?} */(importedType)));
                    }
                    // When this module imports another, the imported module's exported directives and pipes are
                    // added to the compilation scope of this module.
                    /** @type {?} */
                    var importedScope = transitiveScopesFor(importedType, processNgModuleFn);
                    importedScope.exported.directives.forEach(( /**
                     * @param {?} entry
                     * @return {?}
                     */function (/**
                     * @param {?} entry
                     * @return {?}
                     */ entry) { return scopes.compilation.directives.add(entry); }));
                    importedScope.exported.pipes.forEach(( /**
                     * @param {?} entry
                     * @return {?}
                     */function (/**
                     * @param {?} entry
                     * @return {?}
                     */ entry) { return scopes.compilation.pipes.add(entry); }));
                }));
                maybeUnwrapFn(def.exports).forEach(( /**
                 * @template E
                 * @param {?} exported
                 * @return {?}
                 */function (exported) {
                    /** @type {?} */
                    var exportedType = ( /** @type {?} */(exported));
                    // Either the type is a module, a pipe, or a component/directive (which may not have an
                    // ngComponentDef as it might be compiled asynchronously).
                    if (isNgModule(exportedType)) {
                        // When this module exports another, the exported module's exported directives and pipes are
                        // added to both the compilation and exported scopes of this module.
                        /** @type {?} */
                        var exportedScope = transitiveScopesFor(exportedType, processNgModuleFn);
                        exportedScope.exported.directives.forEach(( /**
                         * @param {?} entry
                         * @return {?}
                         */function (/**
                         * @param {?} entry
                         * @return {?}
                         */ entry) {
                            scopes.compilation.directives.add(entry);
                            scopes.exported.directives.add(entry);
                        }));
                        exportedScope.exported.pipes.forEach(( /**
                         * @param {?} entry
                         * @return {?}
                         */function (/**
                         * @param {?} entry
                         * @return {?}
                         */ entry) {
                            scopes.compilation.pipes.add(entry);
                            scopes.exported.pipes.add(entry);
                        }));
                    }
                    else if (getPipeDef(exportedType)) {
                        scopes.exported.pipes.add(exportedType);
                    }
                    else {
                        scopes.exported.directives.add(exportedType);
                    }
                }));
                def.transitiveCompileScopes = scopes;
                return scopes;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function expandModuleWithProviders(value) {
                if (isModuleWithProviders(value)) {
                    return value.ngModule;
                }
                return value;
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isModuleWithProviders(value) {
                return (( /** @type {?} */(value))).ngModule !== undefined;
            }
            /**
             * @template T
             * @param {?} value
             * @return {?}
             */
            function isNgModule(value) {
                return !!getNgModuleDef(value);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Compile an Angular component according to its decorator metadata, and patch the resulting
             * ngComponentDef onto the component type.
             *
             * Compilation may be asynchronous (due to the need to resolve URLs for the component template or
             * other resources, for example). In the event that compilation is not immediate, `compileComponent`
             * will enqueue resource resolution into a global queue and will fail to return the `ngComponentDef`
             * until the global queue has been resolved with a call to `resolveComponentResources`.
             * @param {?} type
             * @param {?} metadata
             * @return {?}
             */
            function compileComponent(type, metadata) {
                /** @type {?} */
                /** @nocollapse */ var ngComponentDef = null;
                // Metadata may have resources which need to be resolved.
                maybeQueueResolutionOfComponentResources(type, metadata);
                Object.defineProperty(type, NG_COMPONENT_DEF, {
                    get: ( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var compiler = getCompilerFacade();
                        if (ngComponentDef === null) {
                            if (componentNeedsResolution(metadata)) {
                                /** @type {?} */
                                var error = ["Component '" + type.name + "' is not resolved:"];
                                if (metadata.templateUrl) {
                                    error.push(" - templateUrl: " + metadata.templateUrl);
                                }
                                if (metadata.styleUrls && metadata.styleUrls.length) {
                                    error.push(" - styleUrls: " + JSON.stringify(metadata.styleUrls));
                                }
                                error.push("Did you run and wait for 'resolveComponentResources()'?");
                                throw new Error(error.join('\n'));
                            }
                            /** @type {?} */
                            var templateUrl = metadata.templateUrl || "ng:///" + type.name + "/template.html";
                            /** @type {?} */
                            var meta = Object.assign({}, directiveMetadata(type, metadata), { typeSourceSpan: compiler.createParseSourceSpan('Component', type.name, templateUrl), template: metadata.template || '', preserveWhitespaces: metadata.preserveWhitespaces || false, styles: metadata.styles || EMPTY_ARRAY, animations: metadata.animations, directives: [], changeDetection: metadata.changeDetection, pipes: new Map(), encapsulation: metadata.encapsulation || ViewEncapsulation.Emulated, interpolation: metadata.interpolation, viewProviders: metadata.viewProviders || null });
                            if (meta.usesInheritance) {
                                addBaseDefToUndecoratedParents(type);
                            }
                            ngComponentDef = compiler.compileComponent(angularCoreEnv, templateUrl, meta);
                            // When NgModule decorator executed, we enqueued the module definition such that
                            // it would only dequeue and add itself as module scope to all of its declarations,
                            // but only if  if all of its declarations had resolved. This call runs the check
                            // to see if any modules that are in the queue can be dequeued and add scope to
                            // their declarations.
                            flushModuleScopingQueueAsMuchAsPossible();
                            // If component compilation is async, then the @NgModule annotation which declares the
                            // component may execute and set an ngSelectorScope property on the component type. This
                            // allows the component to patch itself with directiveDefs from the module after it
                            // finishes compiling.
                            if (hasSelectorScope(type)) {
                                /** @type {?} */
                                var scopes = transitiveScopesFor(type.ngSelectorScope);
                                patchComponentDefWithScope(ngComponentDef, scopes);
                            }
                        }
                        return ngComponentDef;
                    }),
                    // Make the property configurable in dev mode to allow overriding in tests
                    configurable: !!ngDevMode,
                });
                // Add ngInjectableDef so components are reachable through the module injector by default
                // This is mostly to support injecting components in tests. In real application code,
                // components should be retrieved through the node injector, so this isn't a problem.
                compileInjectable(type);
            }
            /**
             * @template T
             * @param {?} component
             * @return {?}
             */
            function hasSelectorScope(component) {
                return (( /** @type {?} */(component))).ngSelectorScope !== undefined;
            }
            /**
             * Compile an Angular directive according to its decorator metadata, and patch the resulting
             * ngDirectiveDef onto the component type.
             *
             * In the event that compilation is not immediate, `compileDirective` will return a `Promise` which
             * will resolve when compilation completes and the directive becomes usable.
             * @param {?} type
             * @param {?} directive
             * @return {?}
             */
            function compileDirective(type, directive) {
                /** @type {?} */
                /** @nocollapse */ var ngDirectiveDef = null;
                Object.defineProperty(type, NG_DIRECTIVE_DEF, {
                    get: ( /**
                     * @return {?}
                     */function () {
                        if (ngDirectiveDef === null) {
                            /** @type {?} */
                            var name = type && type.name;
                            /** @type {?} */
                            var sourceMapUrl = "ng:///" + name + "/ngDirectiveDef.js";
                            /** @type {?} */
                            var compiler = getCompilerFacade();
                            /** @type {?} */
                            var facade = directiveMetadata(( /** @type {?} */(type)), directive);
                            facade.typeSourceSpan = compiler.createParseSourceSpan('Directive', name, sourceMapUrl);
                            if (facade.usesInheritance) {
                                addBaseDefToUndecoratedParents(type);
                            }
                            ngDirectiveDef = compiler.compileDirective(angularCoreEnv, sourceMapUrl, facade);
                        }
                        return ngDirectiveDef;
                    }),
                    // Make the property configurable in dev mode to allow overriding in tests
                    configurable: !!ngDevMode,
                });
                // Add ngInjectableDef so directives are reachable through the module injector by default
                // This is mostly to support injecting directives in tests. In real application code,
                // directives should be retrieved through the node injector, so this isn't a problem.
                compileInjectable(type);
            }
            /**
             * @param {?} type
             * @return {?}
             */
            function extendsDirectlyFromObject(type) {
                return Object.getPrototypeOf(type.prototype) === Object.prototype;
            }
            /**
             * Extract the `R3DirectiveMetadata` for a particular directive (either a `Directive` or a
             * `Component`).
             * @param {?} type
             * @param {?} metadata
             * @return {?}
             */
            function directiveMetadata(type, metadata) {
                // Reflect inputs and outputs.
                /** @type {?} */
                var propMetadata = getReflect().ownPropMetadata(type);
                return {
                    name: type.name,
                    type: type,
                    typeArgumentCount: 0,
                    selector: ( /** @type {?} */(metadata.selector)),
                    deps: reflectDependencies(type),
                    host: metadata.host || EMPTY_OBJ,
                    propMetadata: propMetadata,
                    inputs: metadata.inputs || EMPTY_ARRAY,
                    outputs: metadata.outputs || EMPTY_ARRAY,
                    queries: extractQueriesMetadata(type, propMetadata, isContentQuery),
                    lifecycle: { usesOnChanges: type.prototype.hasOwnProperty('ngOnChanges') },
                    typeSourceSpan: ( /** @type {?} */(null)),
                    usesInheritance: !extendsDirectlyFromObject(type),
                    exportAs: extractExportAs(metadata.exportAs),
                    providers: metadata.providers || null,
                    viewQueries: extractQueriesMetadata(type, propMetadata, isViewQuery),
                };
            }
            /**
             * Adds an `ngBaseDef` to all parent classes of a type that don't have an Angular decorator.
             * @param {?} type
             * @return {?}
             */
            function addBaseDefToUndecoratedParents(type) {
                /** @type {?} */
                var objPrototype = Object.prototype;
                /** @type {?} */
                var parent = Object.getPrototypeOf(type);
                // Go up the prototype until we hit `Object`.
                while (parent && parent !== objPrototype) {
                    // Since inheritance works if the class was annotated already, we only need to add
                    // the base def if there are no annotations and the base def hasn't been created already.
                    if (!getDirectiveDef(parent) && !getComponentDef(parent) && !getBaseDef(parent)) {
                        /** @type {?} */
                        var facade = extractBaseDefMetadata(parent);
                        facade && compileBase(parent, facade);
                    }
                    parent = Object.getPrototypeOf(parent);
                }
            }
            /**
             * Compiles the base metadata into a base definition.
             * @param {?} type
             * @param {?} facade
             * @return {?}
             */
            function compileBase(type, facade) {
                /** @type {?} */
                /** @nocollapse */ var ngBaseDef = null;
                Object.defineProperty(type, NG_BASE_DEF, {
                    get: ( /**
                     * @return {?}
                     */function () {
                        if (ngBaseDef === null) {
                            /** @type {?} */
                            var name = type && type.name;
                            /** @type {?} */
                            var sourceMapUrl = "ng://" + name + "/ngBaseDef.js";
                            /** @type {?} */
                            var compiler = getCompilerFacade();
                            ngBaseDef = compiler.compileBase(angularCoreEnv, sourceMapUrl, facade);
                        }
                        return ngBaseDef;
                    }),
                    // Make the property configurable in dev mode to allow overriding in tests
                    configurable: !!ngDevMode,
                });
            }
            /**
             * Extracts the metadata necessary to construct an `ngBaseDef` from a class.
             * @param {?} type
             * @return {?}
             */
            function extractBaseDefMetadata(type) {
                /** @type {?} */
                var propMetadata = getReflect().ownPropMetadata(type);
                /** @type {?} */
                var viewQueries = extractQueriesMetadata(type, propMetadata, isViewQuery);
                /** @type {?} */
                var queries = extractQueriesMetadata(type, propMetadata, isContentQuery);
                /** @type {?} */
                var inputs;
                /** @type {?} */
                var outputs;
                // We only need to know whether there are any HostListener or HostBinding
                // decorators present, the parsing logic is in the compiler already.
                /** @type {?} */
                var hasHostDecorators = false;
                var _loop_7 = function (field) {
                    propMetadata[field].forEach(( /**
                     * @param {?} ann
                     * @return {?}
                     */function (/**
                     * @param {?} ann
                     * @return {?}
                     */ ann) {
                        /** @type {?} */
                        var metadataName = ann.ngMetadataName;
                        if (metadataName === 'Input') {
                            inputs = inputs || {};
                            inputs[field] = ann.bindingPropertyName ? [ann.bindingPropertyName, field] : field;
                        }
                        else if (metadataName === 'Output') {
                            outputs = outputs || {};
                            outputs[field] = ann.bindingPropertyName || field;
                        }
                        else if (metadataName === 'HostBinding' || metadataName === 'HostListener') {
                            hasHostDecorators = true;
                        }
                    }));
                };
                for (var field in propMetadata) {
                    _loop_7(field);
                }
                // Only generate the base def if there's any info inside it.
                if (inputs || outputs || viewQueries.length || queries.length || hasHostDecorators) {
                    return { name: type.name, type: type, inputs: inputs, outputs: outputs, viewQueries: viewQueries, queries: queries, propMetadata: propMetadata };
                }
                return null;
            }
            /**
             * @param {?} selector
             * @return {?}
             */
            function convertToR3QueryPredicate(selector) {
                return typeof selector === 'string' ? splitByComma(selector) : resolveForwardRef(selector);
            }
            /**
             * @param {?} propertyName
             * @param {?} ann
             * @return {?}
             */
            function convertToR3QueryMetadata(propertyName, ann) {
                return {
                    propertyName: propertyName,
                    predicate: convertToR3QueryPredicate(ann.selector),
                    descendants: ann.descendants,
                    first: ann.first,
                    read: ann.read ? ann.read : null,
                    static: !!ann.static
                };
            }
            /**
             * @param {?} type
             * @param {?} propMetadata
             * @param {?} isQueryAnn
             * @return {?}
             */
            function extractQueriesMetadata(type, propMetadata, isQueryAnn) {
                /** @type {?} */
                var queriesMeta = [];
                var _loop_8 = function (field) {
                    if (propMetadata.hasOwnProperty(field)) {
                        /** @type {?} */
                        var annotations_1 = propMetadata[field];
                        annotations_1.forEach(( /**
                         * @param {?} ann
                         * @return {?}
                         */function (/**
                         * @param {?} ann
                         * @return {?}
                         */ ann) {
                            if (isQueryAnn(ann)) {
                                if (!ann.selector) {
                                    throw new Error("Can't construct a query for the property \"" + field + "\" of " +
                                        ("\"" + stringifyForError(type) + "\" since the query selector wasn't defined."));
                                }
                                if (annotations_1.some(isInputAnn)) {
                                    throw new Error("Cannot combine @Input decorators with query decorators");
                                }
                                queriesMeta.push(convertToR3QueryMetadata(field, ann));
                            }
                        }));
                    }
                };
                for (var field in propMetadata) {
                    _loop_8(field);
                }
                return queriesMeta;
            }
            /**
             * @param {?} exportAs
             * @return {?}
             */
            function extractExportAs(exportAs) {
                if (exportAs === undefined) {
                    return null;
                }
                return exportAs.split(',').map(( /**
                 * @param {?} part
                 * @return {?}
                 */function (/**
                 * @param {?} part
                 * @return {?}
                 */ part) { return part.trim(); }));
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isContentQuery(value) {
                /** @type {?} */
                var name = value.ngMetadataName;
                return name === 'ContentChild' || name === 'ContentChildren';
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isViewQuery(value) {
                /** @type {?} */
                var name = value.ngMetadataName;
                return name === 'ViewChild' || name === 'ViewChildren';
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function isInputAnn(value) {
                return value.ngMetadataName === 'Input';
            }
            /**
             * @param {?} value
             * @return {?}
             */
            function splitByComma(value) {
                return value.split(',').map(( /**
                 * @param {?} piece
                 * @return {?}
                 */function (/**
                 * @param {?} piece
                 * @return {?}
                 */ piece) { return piece.trim(); }));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} type
             * @param {?} meta
             * @return {?}
             */
            function compilePipe(type, meta) {
                /** @type {?} */
                /** @nocollapse */ var ngPipeDef = null;
                Object.defineProperty(type, NG_PIPE_DEF, {
                    get: ( /**
                     * @return {?}
                     */function () {
                        if (ngPipeDef === null) {
                            /** @type {?} */
                            var typeName_1 = type.name;
                            ngPipeDef =
                                getCompilerFacade().compilePipe(angularCoreEnv, "ng:///" + typeName_1 + "/ngPipeDef.js", {
                                    type: type,
                                    typeArgumentCount: 0,
                                    name: typeName_1,
                                    deps: reflectDependencies(type),
                                    pipeName: meta.name,
                                    pure: meta.pure !== undefined ? meta.pure : true
                                });
                        }
                        return ngPipeDef;
                    }),
                    // Make the property configurable in dev mode to allow overriding in tests
                    configurable: !!ngDevMode,
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Type of the Directive decorator / constructor function.
             * \@publicApi
             * @record
             */
            function DirectiveDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ0$f = /**
             * @param {?=} dir
             * @return {?}
             */ function (dir) {
                if (dir === void 0) { dir = {}; }
                return dir;
            }, ɵ1$4 = /**
             * @param {?} type
             * @param {?} meta
             * @return {?}
             */ function (type, meta) { return SWITCH_COMPILE_DIRECTIVE(type, meta); };
            /**
             * Type of the Directive metadata.
             *
             * \@publicApi
             * @type {?}
             */
            var Directive = makeDecorator('Directive', (ɵ0$f), undefined, undefined, (ɵ1$4));
            /**
             * Component decorator interface
             *
             * \@publicApi
             * @record
             */
            function ComponentDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ2$1 = /**
             * @param {?=} c
             * @return {?}
             */ function (c) {
                if (c === void 0) { c = {}; }
                return (Object.assign({ changeDetection: ChangeDetectionStrategy.Default }, c));
            }, ɵ3$1 = /**
             * @param {?} type
             * @param {?} meta
             * @return {?}
             */ function (type, meta) { return SWITCH_COMPILE_COMPONENT(type, meta); };
            /**
             * Component decorator and metadata.
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Component = makeDecorator('Component', (ɵ2$1), Directive, undefined, (ɵ3$1));
            /**
             * Type of the Pipe decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function PipeDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ4 = /**
             * @param {?} p
             * @return {?}
             */ function (p) { return (Object.assign({ pure: true }, p)); }, ɵ5 = /**
             * @param {?} type
             * @param {?} meta
             * @return {?}
             */ function (type, meta) { return SWITCH_COMPILE_PIPE(type, meta); };
            /**
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Pipe = makeDecorator('Pipe', (ɵ4), undefined, undefined, (ɵ5));
            /**
             * \@publicApi
             * @record
             */
            function InputDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ6 = /**
             * @param {?=} bindingPropertyName
             * @return {?}
             */ function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); };
            /**
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Input = makePropDecorator('Input', (ɵ6));
            /**
             * Type of the Output decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function OutputDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ7 = /**
             * @param {?=} bindingPropertyName
             * @return {?}
             */ function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); };
            /**
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var Output = makePropDecorator('Output', (ɵ7));
            /**
             * Type of the HostBinding decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function HostBindingDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ8 = /**
             * @param {?=} hostPropertyName
             * @return {?}
             */ function (hostPropertyName) { return ({ hostPropertyName: hostPropertyName }); };
            /**
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var HostBinding = makePropDecorator('HostBinding', (ɵ8));
            /**
             * Type of the HostListener decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function HostListenerDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ9 = /**
             * @param {?=} eventName
             * @param {?=} args
             * @return {?}
             */ function (eventName, args) { return ({ eventName: eventName, args: args }); };
            /**
             * Decorator that binds a DOM event to a host listener and supplies configuration metadata.
             * Angular invokes the supplied handler method when the host element emits the specified event,
             * and updates the bound element with the result.
             *
             * If the handler method returns false, applies `preventDefault` on the bound element.
             *
             * \@usageNotes
             *
             * The following example declares a directive
             * that attaches a click listener to a button and counts clicks.
             *
             * ```ts
             * \@Directive({selector: 'button[counting]'})
             * class CountClicks {
             *   numberOfClicks = 0;
             *
             * \@HostListener('click', ['$event.target'])
             *   onClick(btn) {
             *     console.log('button', btn, 'number of clicks:', this.numberOfClicks++);
             *  }
             * }
             *
             * \@Component({
             *   selector: 'app',
             *   template: '<button counting>Increment</button>',
             * })
             * class App {}
             * ```
             *
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var HostListener = makePropDecorator('HostListener', (ɵ9));
            /** @type {?} */
            var SWITCH_COMPILE_COMPONENT__POST_R3__ = compileComponent;
            /** @type {?} */
            var SWITCH_COMPILE_DIRECTIVE__POST_R3__ = compileDirective;
            /** @type {?} */
            var SWITCH_COMPILE_PIPE__POST_R3__ = compilePipe;
            /** @type {?} */
            var SWITCH_COMPILE_COMPONENT__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_COMPILE_DIRECTIVE__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_COMPILE_PIPE__PRE_R3__ = noop;
            /** @type {?} */
            var SWITCH_COMPILE_COMPONENT = SWITCH_COMPILE_COMPONENT__PRE_R3__;
            /** @type {?} */
            var SWITCH_COMPILE_DIRECTIVE = SWITCH_COMPILE_DIRECTIVE__PRE_R3__;
            /** @type {?} */
            var SWITCH_COMPILE_PIPE = SWITCH_COMPILE_PIPE__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Represents the expansion of an `NgModule` into its scopes.
             *
             * A scope is a set of directives and pipes that are visible in a particular context. Each
             * `NgModule` has two scopes. The `compilation` scope is the set of directives and pipes that will
             * be recognized in the templates of components declared by the module. The `exported` scope is the
             * set of directives and pipes exported by a module (that is, module B's exported scope gets added
             * to module A's compilation scope when module A imports B).
             * @record
             */
            function NgModuleTransitiveScopes() { }
            if (false) { }
            /**
             * Runtime link information for NgModules.
             *
             * This is the internal data structure used by the runtime to assemble components, directives,
             * pipes, and injectors.
             *
             * NOTE: Always use `ɵɵdefineNgModule` function to create this object,
             * never create the object directly since the shape of this object
             * can change between versions.
             * @record
             * @template T
             */
            function NgModuleDef() { }
            if (false) { }
            /**
             * A wrapper around an NgModule that associates it with the providers.
             *
             * @param T the module type. In Ivy applications, this must be explicitly
             * provided.
             *
             * \@publicApi
             * @record
             * @template T
             */
            function ModuleWithProviders() { }
            if (false) { }
            /**
             * Type of the NgModule decorator / constructor function.
             *
             * \@publicApi
             * @record
             */
            function NgModuleDecorator() { }
            // WARNING: interface has both a type and a value, skipping emit
            var ɵ0$g = /**
             * @param {?} ngModule
             * @return {?}
             */ function (ngModule) { return ngModule; }, ɵ1$5 = /**
             * Decorator that marks the following class as an NgModule, and supplies
             * configuration metadata for it.
             *
             * * The `declarations` and `entryComponents` options configure the compiler
             * with information about what belongs to the NgModule.
             * * The `providers` options configures the NgModule's injector to provide
             * dependencies the NgModule members.
             * * The `imports` and `exports` options bring in members from other modules, and make
             * this module's members available to others.
             * @param {?} type
             * @param {?} meta
             * @return {?}
             */ function (type, meta) { return SWITCH_COMPILE_NGMODULE(type, meta); };
            /**
             * \@Annotation
             * \@publicApi
             * @type {?}
             */
            var NgModule = makeDecorator('NgModule', (ɵ0$g), undefined, undefined, (ɵ1$5));
            /**
             * \@description
             * Hook for manual bootstrapping of the application instead of using bootstrap array in \@NgModule
             * annotation.
             *
             * Reference to the current application is provided as a parameter.
             *
             * See ["Bootstrapping"](guide/bootstrapping) and ["Entry components"](guide/entry-components).
             *
             * \@usageNotes
             * ```typescript
             * class AppModule implements DoBootstrap {
             *   ngDoBootstrap(appRef: ApplicationRef) {
             *     appRef.bootstrap(AppComponent); // Or some other component
             *   }
             * }
             * ```
             *
             * \@publicApi
             * @record
             */
            function DoBootstrap() { }
            if (false) { }
            /**
             * @param {?} moduleType
             * @param {?=} metadata
             * @return {?}
             */
            function preR3NgModuleCompile(moduleType, metadata) {
                /** @type {?} */
                var imports = (metadata && metadata.imports) || [];
                if (metadata && metadata.exports) {
                    imports = imports.concat([metadata.exports]);
                }
                (( /** @type {?} */(moduleType))).ngInjectorDef = ɵɵdefineInjector({
                    factory: convertInjectableProviderToFactory(moduleType, { useClass: moduleType }),
                    providers: metadata && metadata.providers,
                    imports: imports,
                });
            }
            /** @type {?} */
            var SWITCH_COMPILE_NGMODULE__POST_R3__ = compileNgModule;
            /** @type {?} */
            var SWITCH_COMPILE_NGMODULE__PRE_R3__ = preR3NgModuleCompile;
            /** @type {?} */
            var SWITCH_COMPILE_NGMODULE = SWITCH_COMPILE_NGMODULE__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A function that will be executed when an application is initialized.
             *
             * \@publicApi
             * @type {?}
             */
            var APP_INITIALIZER = new InjectionToken('Application Initializer');
            /**
             * A class that reflects the state of running {\@link APP_INITIALIZER}s.
             *
             * \@publicApi
             */
            var ApplicationInitStatus = /** @class */ (function () {
                /**
                 * @param {?} appInits
                 */
                function ApplicationInitStatus(appInits) {
                    var _this = this;
                    this.appInits = appInits;
                    this.initialized = false;
                    this.done = false;
                    this.donePromise = new Promise(( /**
                     * @param {?} res
                     * @param {?} rej
                     * @return {?}
                     */function (res, rej) {
                        _this.resolve = res;
                        _this.reject = rej;
                    }));
                }
                /**
                 * \@internal
                 * @return {?}
                 */
                ApplicationInitStatus.prototype.runInitializers = function () {
                    var _this = this;
                    if (this.initialized) {
                        return;
                    }
                    /** @type {?} */
                    var asyncInitPromises = [];
                    /** @type {?} */
                    var complete = ( /**
                     * @return {?}
                     */function () {
                        (( /** @type {?} */(_this))).done = true;
                        _this.resolve();
                    });
                    if (this.appInits) {
                        for (var i = 0; i < this.appInits.length; i++) {
                            /** @type {?} */
                            var initResult = this.appInits[i]();
                            if (isPromise(initResult)) {
                                asyncInitPromises.push(initResult);
                            }
                        }
                    }
                    Promise.all(asyncInitPromises).then(( /**
                     * @return {?}
                     */function () { complete(); })).catch(( /**
                     * @param {?} e
                     * @return {?}
                     */function (/**
                     * @param {?} e
                     * @return {?}
                     */ e) { _this.reject(e); }));
                    if (asyncInitPromises.length === 0) {
                        complete();
                    }
                    this.initialized = true;
                };
                return ApplicationInitStatus;
            }());
            ApplicationInitStatus.decorators = [
                { type: Injectable }
            ];
            /** @nocollapse */
            ApplicationInitStatus.ctorParameters = function () { return [
                { type: Array, decorators: [{ type: Inject, args: [APP_INITIALIZER,] }, { type: Optional }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A DI Token representing a unique string id assigned to the application by Angular and used
             * primarily for prefixing application attributes and CSS styles when
             * {\@link ViewEncapsulation#Emulated ViewEncapsulation.Emulated} is being used.
             *
             * If you need to avoid randomly generated value to be used as an application id, you can provide
             * a custom value via a DI provider <!-- TODO: provider --> configuring the root {\@link Injector}
             * using this token.
             * \@publicApi
             * @type {?}
             */
            var APP_ID = new InjectionToken('AppId');
            /**
             * @return {?}
             */
            function _appIdRandomProviderFactory() {
                return "" + _randomChar() + _randomChar() + _randomChar();
            }
            /**
             * Providers that will generate a random APP_ID_TOKEN.
             * \@publicApi
             * @type {?}
             */
            var APP_ID_RANDOM_PROVIDER = {
                provide: APP_ID,
                useFactory: _appIdRandomProviderFactory,
                deps: ( /** @type {?} */([])),
            };
            /**
             * @return {?}
             */
            function _randomChar() {
                return String.fromCharCode(97 + Math.floor(Math.random() * 25));
            }
            /**
             * A function that will be executed when a platform is initialized.
             * \@publicApi
             * @type {?}
             */
            var PLATFORM_INITIALIZER = new InjectionToken('Platform Initializer');
            /**
             * A token that indicates an opaque platform id.
             * \@publicApi
             * @type {?}
             */
            var PLATFORM_ID = new InjectionToken('Platform ID');
            /**
             * All callbacks provided via this token will be called for every component that is bootstrapped.
             * Signature of the callback:
             *
             * `(componentRef: ComponentRef) => void`.
             *
             * \@publicApi
             * @type {?}
             */
            var APP_BOOTSTRAP_LISTENER = new InjectionToken('appBootstrapListener');
            /**
             * A token which indicates the root directory of the application
             * \@publicApi
             * @type {?}
             */
            var PACKAGE_ROOT_URL = new InjectionToken('Application Packages Root URL');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var Console = /** @class */ (function () {
                function Console() {
                }
                /**
                 * @param {?} message
                 * @return {?}
                 */
                Console.prototype.log = function (message) {
                    // tslint:disable-next-line:no-console
                    console.log(message);
                };
                // Note: for reporting errors use `DOM.logError()` as it is platform specific
                /**
                 * @param {?} message
                 * @return {?}
                 */
                Console.prototype.warn = function (message) {
                    // tslint:disable-next-line:no-console
                    console.warn(message);
                };
                return Console;
            }());
            Console.decorators = [
                { type: Injectable }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Provide this token to set the locale of your application.
             * It is used for i18n extraction, by i18n pipes (DatePipe, I18nPluralPipe, CurrencyPipe,
             * DecimalPipe and PercentPipe) and by ICU expressions.
             *
             * See the [i18n guide](guide/i18n#setting-up-locale) for more information.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * import { LOCALE_ID } from '\@angular/core';
             * import { platformBrowserDynamic } from '\@angular/platform-browser-dynamic';
             * import { AppModule } from './app/app.module';
             *
             * platformBrowserDynamic().bootstrapModule(AppModule, {
             *   providers: [{provide: LOCALE_ID, useValue: 'en-US' }]
             * });
             * ```
             *
             * \@publicApi
             * @type {?}
             */
            var LOCALE_ID$1 = new InjectionToken('LocaleId');
            /**
             * Use this token at bootstrap to provide the content of your translation file (`xtb`,
             * `xlf` or `xlf2`) when you want to translate your application in another language.
             *
             * See the [i18n guide](guide/i18n#merge) for more information.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * import { TRANSLATIONS } from '\@angular/core';
             * import { platformBrowserDynamic } from '\@angular/platform-browser-dynamic';
             * import { AppModule } from './app/app.module';
             *
             * // content of your translation file
             * const translations = '....';
             *
             * platformBrowserDynamic().bootstrapModule(AppModule, {
             *   providers: [{provide: TRANSLATIONS, useValue: translations }]
             * });
             * ```
             *
             * \@publicApi
             * @type {?}
             */
            var TRANSLATIONS$1 = new InjectionToken('Translations');
            /**
             * Provide this token at bootstrap to set the format of your {\@link TRANSLATIONS}: `xtb`,
             * `xlf` or `xlf2`.
             *
             * See the [i18n guide](guide/i18n#merge) for more information.
             *
             * \@usageNotes
             * ### Example
             *
             * ```typescript
             * import { TRANSLATIONS_FORMAT } from '\@angular/core';
             * import { platformBrowserDynamic } from '\@angular/platform-browser-dynamic';
             * import { AppModule } from './app/app.module';
             *
             * platformBrowserDynamic().bootstrapModule(AppModule, {
             *   providers: [{provide: TRANSLATIONS_FORMAT, useValue: 'xlf' }]
             * });
             * ```
             *
             * \@publicApi
             * @type {?}
             */
            var TRANSLATIONS_FORMAT = new InjectionToken('TranslationsFormat');
            /** @enum {number} */
            var MissingTranslationStrategy = {
                Error: 0,
                Warning: 1,
                Ignore: 2,
            };
            MissingTranslationStrategy[MissingTranslationStrategy.Error] = 'Error';
            MissingTranslationStrategy[MissingTranslationStrategy.Warning] = 'Warning';
            MissingTranslationStrategy[MissingTranslationStrategy.Ignore] = 'Ignore';
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var SWITCH_IVY_ENABLED__POST_R3__ = true;
            /** @type {?} */
            var SWITCH_IVY_ENABLED__PRE_R3__ = false;
            /** @type {?} */
            var ivyEnabled = SWITCH_IVY_ENABLED__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Combination of NgModuleFactory and ComponentFactorys.
             *
             * \@publicApi
             * @template T
             */
            var ModuleWithComponentFactories = /** @class */ (function () {
                /**
                 * @param {?} ngModuleFactory
                 * @param {?} componentFactories
                 */
                function ModuleWithComponentFactories(ngModuleFactory, componentFactories) {
                    this.ngModuleFactory = ngModuleFactory;
                    this.componentFactories = componentFactories;
                }
                return ModuleWithComponentFactories;
            }());
            if (false) { }
            /**
             * @return {?}
             */
            function _throwError() {
                throw new Error("Runtime compiler is not loaded");
            }
            /** @type {?} */
            var Compiler_compileModuleSync__PRE_R3__ = ( /** @type {?} */(_throwError));
            /** @type {?} */
            var Compiler_compileModuleSync__POST_R3__ = ( /**
             * @template T
             * @param {?} moduleType
             * @return {?}
             */function (moduleType) {
                return new NgModuleFactory$1(moduleType);
            });
            /** @type {?} */
            var Compiler_compileModuleSync = Compiler_compileModuleSync__PRE_R3__;
            /** @type {?} */
            var Compiler_compileModuleAsync__PRE_R3__ = ( /** @type {?} */(_throwError));
            /** @type {?} */
            var Compiler_compileModuleAsync__POST_R3__ = ( /**
             * @template T
             * @param {?} moduleType
             * @return {?}
             */function (moduleType) {
                return Promise.resolve(Compiler_compileModuleSync__POST_R3__(moduleType));
            });
            /** @type {?} */
            var Compiler_compileModuleAsync = Compiler_compileModuleAsync__PRE_R3__;
            /** @type {?} */
            var Compiler_compileModuleAndAllComponentsSync__PRE_R3__ = ( /** @type {?} */(_throwError));
            /** @type {?} */
            var Compiler_compileModuleAndAllComponentsSync__POST_R3__ = ( /**
             * @template T
             * @param {?} moduleType
             * @return {?}
             */function (moduleType) {
                /** @type {?} */
                var ngModuleFactory = Compiler_compileModuleSync__POST_R3__(moduleType);
                /** @type {?} */
                var moduleDef = ( /** @type {?} */(getNgModuleDef(moduleType)));
                /** @type {?} */
                var componentFactories = maybeUnwrapFn(moduleDef.declarations)
                    .reduce(( /**
             * @param {?} factories
             * @param {?} declaration
             * @return {?}
             */function (factories, declaration) {
                    /** @type {?} */
                    var componentDef = getComponentDef(declaration);
                    componentDef && factories.push(new ComponentFactory$1(componentDef));
                    return factories;
                }), ( /** @type {?} */([])));
                return new ModuleWithComponentFactories(ngModuleFactory, componentFactories);
            });
            /** @type {?} */
            var Compiler_compileModuleAndAllComponentsSync = Compiler_compileModuleAndAllComponentsSync__PRE_R3__;
            /** @type {?} */
            var Compiler_compileModuleAndAllComponentsAsync__PRE_R3__ = ( /** @type {?} */(_throwError));
            /** @type {?} */
            var Compiler_compileModuleAndAllComponentsAsync__POST_R3__ = ( /**
             * @template T
             * @param {?} moduleType
             * @return {?}
             */function (moduleType) {
                return Promise.resolve(Compiler_compileModuleAndAllComponentsSync__POST_R3__(moduleType));
            });
            /** @type {?} */
            var Compiler_compileModuleAndAllComponentsAsync = Compiler_compileModuleAndAllComponentsAsync__PRE_R3__;
            /**
             * Low-level service for running the angular compiler during runtime
             * to create {\@link ComponentFactory}s, which
             * can later be used to create and render a Component instance.
             *
             * Each `\@NgModule` provides an own `Compiler` to its injector,
             * that will use the directives/pipes of the ng module for compilation
             * of components.
             *
             * \@publicApi
             */
            var Compiler = /** @class */ (function () {
                function Compiler() {
                    /**
                     * Compiles the given NgModule and all of its components. All templates of the components listed
                     * in `entryComponents` have to be inlined.
                     */
                    this.compileModuleSync = Compiler_compileModuleSync;
                    /**
                     * Compiles the given NgModule and all of its components
                     */
                    this.compileModuleAsync = Compiler_compileModuleAsync;
                    /**
                     * Same as {\@link #compileModuleSync} but also creates ComponentFactories for all components.
                     */
                    this.compileModuleAndAllComponentsSync = Compiler_compileModuleAndAllComponentsSync;
                    /**
                     * Same as {\@link #compileModuleAsync} but also creates ComponentFactories for all components.
                     */
                    this.compileModuleAndAllComponentsAsync = Compiler_compileModuleAndAllComponentsAsync;
                }
                /**
                 * Clears all caches.
                 * @return {?}
                 */
                Compiler.prototype.clearCache = function () { };
                /**
                 * Clears the cache for the given component/ngModule.
                 * @param {?} type
                 * @return {?}
                 */
                Compiler.prototype.clearCacheFor = function (type) { };
                /**
                 * Returns the id for a given NgModule, if one is defined and known to the compiler.
                 * @param {?} moduleType
                 * @return {?}
                 */
                Compiler.prototype.getModuleId = function (moduleType) { return undefined; };
                return Compiler;
            }());
            Compiler.decorators = [
                { type: Injectable }
            ];
            if (false) { }
            /**
             * Token to provide CompilerOptions in the platform injector.
             *
             * \@publicApi
             * @type {?}
             */
            var COMPILER_OPTIONS = new InjectionToken('compilerOptions');
            /**
             * A factory for creating a Compiler
             *
             * \@publicApi
             * @abstract
             */
            var CompilerFactory = /** @class */ (function () {
                function CompilerFactory() {
                }
                return CompilerFactory;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A scope function for the Web Tracing Framework (WTF).
             *
             * \@publicApi
             * @deprecated the Web Tracing Framework is no longer supported in Angular
             * @record
             */
            function WtfScopeFn() { }
            /**
             * @record
             */
            function WTF() { }
            if (false) { }
            /**
             * @record
             */
            function Trace() { }
            if (false) { }
            /**
             * @record
             */
            function Range() { }
            /**
             * @record
             */
            function Events() { }
            if (false) { }
            /**
             * @record
             */
            function Scope() { }
            /** @type {?} */
            var trace;
            /** @type {?} */
            var events;
            /**
             * @return {?}
             */
            function detectWTF() {
                /** @type {?} */
                var wtf = (( /** @type {?} */(_global)))['wtf'];
                if (wtf) {
                    trace = wtf['trace'];
                    if (trace) {
                        events = trace['events'];
                        return true;
                    }
                }
                return false;
            }
            /**
             * @param {?} signature
             * @param {?=} flags
             * @return {?}
             */
            function createScope(signature, flags) {
                if (flags === void 0) { flags = null; }
                return events.createScope(signature, flags);
            }
            /**
             * @template T
             * @param {?} scope
             * @param {?=} returnValue
             * @return {?}
             */
            function leave(scope, returnValue) {
                trace.leaveScope(scope, returnValue);
                return returnValue;
            }
            /**
             * @param {?} rangeType
             * @param {?} action
             * @return {?}
             */
            function startTimeRange(rangeType, action) {
                return trace.beginTimeRange(rangeType, action);
            }
            /**
             * @param {?} range
             * @return {?}
             */
            function endTimeRange(range) {
                trace.endTimeRange(range);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * True if WTF is enabled.
             * @type {?}
             */
            var wtfEnabled = detectWTF();
            /**
             * @param {?=} arg0
             * @param {?=} arg1
             * @return {?}
             */
            function noopScope(arg0, arg1) {
                return null;
            }
            /**
             * Create trace scope.
             *
             * Scopes must be strictly nested and are analogous to stack frames, but
             * do not have to follow the stack frames. Instead it is recommended that they follow logical
             * nesting. You may want to use
             * [Event
             * Signatures](http://google.github.io/tracing-framework/instrumenting-code.html#custom-events)
             * as they are defined in WTF.
             *
             * Used to mark scope entry. The return value is used to leave the scope.
             *
             *     var myScope = wtfCreateScope('MyClass#myMethod(ascii someVal)');
             *
             *     someMethod() {
             *        var s = myScope('Foo'); // 'Foo' gets stored in tracing UI
             *        // DO SOME WORK HERE
             *        return wtfLeave(s, 123); // Return value 123
             *     }
             *
             * Note, adding try-finally block around the work to ensure that `wtfLeave` gets called can
             * negatively impact the performance of your application. For this reason we recommend that
             * you don't add them to ensure that `wtfLeave` gets called. In production `wtfLeave` is a noop and
             * so try-finally block has no value. When debugging perf issues, skipping `wtfLeave`, do to
             * exception, will produce incorrect trace, but presence of exception signifies logic error which
             * needs to be fixed before the app should be profiled. Add try-finally only when you expect that
             * an exception is expected during normal execution while profiling.
             *
             * \@publicApi
             * @deprecated the Web Tracing Framework is no longer supported in Angular
             * @type {?}
             */
            var wtfCreateScope = wtfEnabled ? createScope : ( /**
             * @param {?} signature
             * @param {?=} flags
             * @return {?}
             */function (signature, flags) { return noopScope; });
            /**
             * Used to mark end of Scope.
             *
             * - `scope` to end.
             * - `returnValue` (optional) to be passed to the WTF.
             *
             * Returns the `returnValue for easy chaining.
             * \@publicApi
             * @deprecated the Web Tracing Framework is no longer supported in Angular
             * @type {?}
             */
            var wtfLeave = wtfEnabled ? leave : ( /**
             * @param {?} s
             * @param {?=} r
             * @return {?}
             */function (s, r) { return r; });
            /**
             * Used to mark Async start. Async are similar to scope but they don't have to be strictly nested.
             * The return value is used in the call to [endAsync]. Async ranges only work if WTF has been
             * enabled.
             *
             *     someMethod() {
             *        var s = wtfStartTimeRange('HTTP:GET', 'some.url');
             *        var future = new Future.delay(5).then((_) {
             *          wtfEndTimeRange(s);
             *        });
             *     }
             * \@publicApi
             * @deprecated the Web Tracing Framework is no longer supported in Angular
             * @type {?}
             */
            var wtfStartTimeRange = wtfEnabled ? startTimeRange : ( /**
             * @param {?} rangeType
             * @param {?} action
             * @return {?}
             */function (rangeType, action) { return null; });
            /**
             * Ends a async time range operation.
             * [range] is the return value from [wtfStartTimeRange] Async ranges only work if WTF has been
             * enabled.
             * \@publicApi
             * @deprecated the Web Tracing Framework is no longer supported in Angular
             * @type {?}
             */
            var wtfEndTimeRange = wtfEnabled ? endTimeRange : ( /**
             * @param {?} r
             * @return {?}
             */function (r) { return null; });
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            var promise = (function () { return Promise.resolve(0); })();
            function scheduleMicroTask(fn) {
                if (typeof Zone === 'undefined') {
                    // use promise to schedule microTask instead of use Zone
                    promise.then(function () { fn && fn.apply(null, null); });
                }
                else {
                    Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An injectable service for executing work inside or outside of the Angular zone.
             *
             * The most common use of this service is to optimize performance when starting a work consisting of
             * one or more asynchronous tasks that don't require UI updates or error handling to be handled by
             * Angular. Such tasks can be kicked off via {\@link #runOutsideAngular} and if needed, these tasks
             * can reenter the Angular zone via {\@link #run}.
             *
             * <!-- TODO: add/fix links to:
             *   - docs explaining zones and the use of zones in Angular and change-detection
             *   - link to runOutsideAngular/run (throughout this file!)
             *   -->
             *
             * \@usageNotes
             * ### Example
             *
             * ```
             * import {Component, NgZone} from '\@angular/core';
             * import {NgIf} from '\@angular/common';
             *
             * \@Component({
             *   selector: 'ng-zone-demo',
             *   template: `
             *     <h2>Demo: NgZone</h2>
             *
             *     <p>Progress: {{progress}}%</p>
             *     <p *ngIf="progress >= 100">Done processing {{label}} of Angular zone!</p>
             *
             *     <button (click)="processWithinAngularZone()">Process within Angular zone</button>
             *     <button (click)="processOutsideOfAngularZone()">Process outside of Angular zone</button>
             *   `,
             * })
             * export class NgZoneDemo {
             *   progress: number = 0;
             *   label: string;
             *
             *   constructor(private _ngZone: NgZone) {}
             *
             *   // Loop inside the Angular zone
             *   // so the UI DOES refresh after each setTimeout cycle
             *   processWithinAngularZone() {
             *     this.label = 'inside';
             *     this.progress = 0;
             *     this._increaseProgress(() => console.log('Inside Done!'));
             *   }
             *
             *   // Loop outside of the Angular zone
             *   // so the UI DOES NOT refresh after each setTimeout cycle
             *   processOutsideOfAngularZone() {
             *     this.label = 'outside';
             *     this.progress = 0;
             *     this._ngZone.runOutsideAngular(() => {
             *       this._increaseProgress(() => {
             *         // reenter the Angular zone and display done
             *         this._ngZone.run(() => { console.log('Outside Done!'); });
             *       });
             *     });
             *   }
             *
             *   _increaseProgress(doneCallback: () => void) {
             *     this.progress += 1;
             *     console.log(`Current progress: ${this.progress}%`);
             *
             *     if (this.progress < 100) {
             *       window.setTimeout(() => this._increaseProgress(doneCallback), 10);
             *     } else {
             *       doneCallback();
             *     }
             *   }
             * }
             * ```
             *
             * \@publicApi
             */
            var NgZone = /** @class */ (function () {
                /**
                 * @param {?} __0
                 */
                function NgZone(_c) {
                    var _d = _c.enableLongStackTrace, enableLongStackTrace = _d === void 0 ? false : _d;
                    this.hasPendingMicrotasks = false;
                    this.hasPendingMacrotasks = false;
                    /**
                     * Whether there are no outstanding microtasks or macrotasks.
                     */
                    this.isStable = true;
                    /**
                     * Notifies when code enters Angular Zone. This gets fired first on VM Turn.
                     */
                    this.onUnstable = new EventEmitter(false);
                    /**
                     * Notifies when there is no more microtasks enqueued in the current VM Turn.
                     * This is a hint for Angular to do change detection, which may enqueue more microtasks.
                     * For this reason this event can fire multiple times per VM Turn.
                     */
                    this.onMicrotaskEmpty = new EventEmitter(false);
                    /**
                     * Notifies when the last `onMicrotaskEmpty` has run and there are no more microtasks, which
                     * implies we are about to relinquish VM turn.
                     * This event gets called just once.
                     */
                    this.onStable = new EventEmitter(false);
                    /**
                     * Notifies that an error has been delivered.
                     */
                    this.onError = new EventEmitter(false);
                    if (typeof Zone == 'undefined') {
                        throw new Error("In this configuration Angular requires Zone.js");
                    }
                    Zone.assertZonePatched();
                    /** @type {?} */
                    var self = ( /** @type {?} */(( /** @type {?} */(this))));
                    self._nesting = 0;
                    self._outer = self._inner = Zone.current;
                    if ((( /** @type {?} */(Zone)))['wtfZoneSpec']) {
                        self._inner = self._inner.fork((( /** @type {?} */(Zone)))['wtfZoneSpec']);
                    }
                    if ((( /** @type {?} */(Zone)))['TaskTrackingZoneSpec']) {
                        self._inner = self._inner.fork(new (( /** @type {?} */((( /** @type {?} */(Zone)))['TaskTrackingZoneSpec']))));
                    }
                    if (enableLongStackTrace && (( /** @type {?} */(Zone)))['longStackTraceZoneSpec']) {
                        self._inner = self._inner.fork((( /** @type {?} */(Zone)))['longStackTraceZoneSpec']);
                    }
                    forkInnerZoneWithAngularBehavior(self);
                }
                /**
                 * @return {?}
                 */
                NgZone.isInAngularZone = function () { return Zone.current.get('isAngularZone') === true; };
                /**
                 * @return {?}
                 */
                NgZone.assertInAngularZone = function () {
                    if (!NgZone.isInAngularZone()) {
                        throw new Error('Expected to be in Angular Zone, but it is not!');
                    }
                };
                /**
                 * @return {?}
                 */
                NgZone.assertNotInAngularZone = function () {
                    if (NgZone.isInAngularZone()) {
                        throw new Error('Expected to not be in Angular Zone, but it is!');
                    }
                };
                /**
                 * Executes the `fn` function synchronously within the Angular zone and returns value returned by
                 * the function.
                 *
                 * Running functions via `run` allows you to reenter Angular zone from a task that was executed
                 * outside of the Angular zone (typically started via {\@link #runOutsideAngular}).
                 *
                 * Any future tasks or microtasks scheduled from within this function will continue executing from
                 * within the Angular zone.
                 *
                 * If a synchronous error happens it will be rethrown and not reported via `onError`.
                 * @template T
                 * @param {?} fn
                 * @param {?=} applyThis
                 * @param {?=} applyArgs
                 * @return {?}
                 */
                NgZone.prototype.run = function (fn, applyThis, applyArgs) {
                    return ( /** @type {?} */((( /** @type {?} */(( /** @type {?} */(this)))))._inner.run(fn, applyThis, applyArgs)));
                };
                /**
                 * Executes the `fn` function synchronously within the Angular zone as a task and returns value
                 * returned by the function.
                 *
                 * Running functions via `run` allows you to reenter Angular zone from a task that was executed
                 * outside of the Angular zone (typically started via {\@link #runOutsideAngular}).
                 *
                 * Any future tasks or microtasks scheduled from within this function will continue executing from
                 * within the Angular zone.
                 *
                 * If a synchronous error happens it will be rethrown and not reported via `onError`.
                 * @template T
                 * @param {?} fn
                 * @param {?=} applyThis
                 * @param {?=} applyArgs
                 * @param {?=} name
                 * @return {?}
                 */
                NgZone.prototype.runTask = function (fn, applyThis, applyArgs, name) {
                    /** @type {?} */
                    var zone = (( /** @type {?} */(( /** @type {?} */(this)))))._inner;
                    /** @type {?} */
                    var task = zone.scheduleEventTask('NgZoneEvent: ' + name, fn, EMPTY_PAYLOAD, noop$1, noop$1);
                    try {
                        return ( /** @type {?} */(zone.runTask(task, applyThis, applyArgs)));
                    }
                    finally {
                        zone.cancelTask(task);
                    }
                };
                /**
                 * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
                 * rethrown.
                 * @template T
                 * @param {?} fn
                 * @param {?=} applyThis
                 * @param {?=} applyArgs
                 * @return {?}
                 */
                NgZone.prototype.runGuarded = function (fn, applyThis, applyArgs) {
                    return ( /** @type {?} */((( /** @type {?} */(( /** @type {?} */(this)))))._inner.runGuarded(fn, applyThis, applyArgs)));
                };
                /**
                 * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
                 * the function.
                 *
                 * Running functions via {\@link #runOutsideAngular} allows you to escape Angular's zone and do
                 * work that
                 * doesn't trigger Angular change-detection or is subject to Angular's error handling.
                 *
                 * Any future tasks or microtasks scheduled from within this function will continue executing from
                 * outside of the Angular zone.
                 *
                 * Use {\@link #run} to reenter the Angular zone and do work that updates the application model.
                 * @template T
                 * @param {?} fn
                 * @return {?}
                 */
                NgZone.prototype.runOutsideAngular = function (fn) {
                    return ( /** @type {?} */((( /** @type {?} */(( /** @type {?} */(this)))))._outer.run(fn)));
                };
                return NgZone;
            }());
            if (false) { }
            /**
             * @return {?}
             */
            function noop$1() { }
            /** @type {?} */
            var EMPTY_PAYLOAD = {};
            /**
             * @record
             */
            function NgZonePrivate() { }
            if (false) { }
            /**
             * @param {?} zone
             * @return {?}
             */
            function checkStable(zone) {
                if (zone._nesting == 0 && !zone.hasPendingMicrotasks && !zone.isStable) {
                    try {
                        zone._nesting++;
                        zone.onMicrotaskEmpty.emit(null);
                    }
                    finally {
                        zone._nesting--;
                        if (!zone.hasPendingMicrotasks) {
                            try {
                                zone.runOutsideAngular(( /**
                                 * @return {?}
                                 */function () { return zone.onStable.emit(null); }));
                            }
                            finally {
                                zone.isStable = true;
                            }
                        }
                    }
                }
            }
            /**
             * @param {?} zone
             * @return {?}
             */
            function forkInnerZoneWithAngularBehavior(zone) {
                zone._inner = zone._inner.fork({
                    name: 'angular',
                    properties: ( /** @type {?} */({ 'isAngularZone': true })),
                    onInvokeTask: ( /**
                     * @param {?} delegate
                     * @param {?} current
                     * @param {?} target
                     * @param {?} task
                     * @param {?} applyThis
                     * @param {?} applyArgs
                     * @return {?}
                     */function (delegate, current, target, task, applyThis, applyArgs) {
                        try {
                            onEnter(zone);
                            return delegate.invokeTask(target, task, applyThis, applyArgs);
                        }
                        finally {
                            onLeave(zone);
                        }
                    }),
                    onInvoke: ( /**
                     * @param {?} delegate
                     * @param {?} current
                     * @param {?} target
                     * @param {?} callback
                     * @param {?} applyThis
                     * @param {?=} applyArgs
                     * @param {?=} source
                     * @return {?}
                     */function (delegate, current, target, callback, applyThis, applyArgs, source) {
                        try {
                            onEnter(zone);
                            return delegate.invoke(target, callback, applyThis, applyArgs, source);
                        }
                        finally {
                            onLeave(zone);
                        }
                    }),
                    onHasTask: ( /**
                     * @param {?} delegate
                     * @param {?} current
                     * @param {?} target
                     * @param {?} hasTaskState
                     * @return {?}
                     */function (delegate, current, target, hasTaskState) {
                        delegate.hasTask(target, hasTaskState);
                        if (current === target) {
                            // We are only interested in hasTask events which originate from our zone
                            // (A child hasTask event is not interesting to us)
                            if (hasTaskState.change == 'microTask') {
                                zone.hasPendingMicrotasks = hasTaskState.microTask;
                                checkStable(zone);
                            }
                            else if (hasTaskState.change == 'macroTask') {
                                zone.hasPendingMacrotasks = hasTaskState.macroTask;
                            }
                        }
                    }),
                    onHandleError: ( /**
                     * @param {?} delegate
                     * @param {?} current
                     * @param {?} target
                     * @param {?} error
                     * @return {?}
                     */function (delegate, current, target, error) {
                        delegate.handleError(target, error);
                        zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return zone.onError.emit(error); }));
                        return false;
                    })
                });
            }
            /**
             * @param {?} zone
             * @return {?}
             */
            function onEnter(zone) {
                zone._nesting++;
                if (zone.isStable) {
                    zone.isStable = false;
                    zone.onUnstable.emit(null);
                }
            }
            /**
             * @param {?} zone
             * @return {?}
             */
            function onLeave(zone) {
                zone._nesting--;
                checkStable(zone);
            }
            /**
             * Provides a noop implementation of `NgZone` which does nothing. This zone requires explicit calls
             * to framework to perform rendering.
             */
            var NoopNgZone = /** @class */ (function () {
                function NoopNgZone() {
                    this.hasPendingMicrotasks = false;
                    this.hasPendingMacrotasks = false;
                    this.isStable = true;
                    this.onUnstable = new EventEmitter();
                    this.onMicrotaskEmpty = new EventEmitter();
                    this.onStable = new EventEmitter();
                    this.onError = new EventEmitter();
                }
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                NoopNgZone.prototype.run = function (fn) { return fn(); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                NoopNgZone.prototype.runGuarded = function (fn) { return fn(); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                NoopNgZone.prototype.runOutsideAngular = function (fn) { return fn(); };
                /**
                 * @template T
                 * @param {?} fn
                 * @return {?}
                 */
                NoopNgZone.prototype.runTask = function (fn) { return fn(); };
                return NoopNgZone;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @record
             */
            function PendingMacrotask() { }
            if (false) { }
            /**
             * @record
             */
            function TaskData() { }
            if (false) { }
            /**
             * @record
             */
            function WaitCallback() { }
            if (false) { }
            /**
             * The Testability service provides testing hooks that can be accessed from
             * the browser and by services such as Protractor. Each bootstrapped Angular
             * application on the page will have an instance of Testability.
             * \@publicApi
             */
            var Testability = /** @class */ (function () {
                /**
                 * @param {?} _ngZone
                 */
                function Testability(_ngZone) {
                    var _this = this;
                    this._ngZone = _ngZone;
                    this._pendingCount = 0;
                    this._isZoneStable = true;
                    /**
                     * Whether any work was done since the last 'whenStable' callback. This is
                     * useful to detect if this could have potentially destabilized another
                     * component while it is stabilizing.
                     * \@internal
                     */
                    this._didWork = false;
                    this._callbacks = [];
                    this.taskTrackingZone = null;
                    this._watchAngularEvents();
                    _ngZone.run(( /**
                     * @return {?}
                     */function () {
                        _this.taskTrackingZone =
                            typeof Zone == 'undefined' ? null : Zone.current.get('TaskTrackingZone');
                    }));
                }
                /**
                 * @private
                 * @return {?}
                 */
                Testability.prototype._watchAngularEvents = function () {
                    var _this = this;
                    this._ngZone.onUnstable.subscribe({
                        next: ( /**
                         * @return {?}
                         */function () {
                            _this._didWork = true;
                            _this._isZoneStable = false;
                        })
                    });
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._ngZone.onStable.subscribe({
                            next: ( /**
                             * @return {?}
                             */function () {
                                NgZone.assertNotInAngularZone();
                                scheduleMicroTask(( /**
                                 * @return {?}
                                 */function () {
                                    _this._isZoneStable = true;
                                    _this._runCallbacksIfReady();
                                }));
                            })
                        });
                    }));
                };
                /**
                 * Increases the number of pending request
                 * @deprecated pending requests are now tracked with zones.
                 * @return {?}
                 */
                Testability.prototype.increasePendingRequestCount = function () {
                    this._pendingCount += 1;
                    this._didWork = true;
                    return this._pendingCount;
                };
                /**
                 * Decreases the number of pending request
                 * @deprecated pending requests are now tracked with zones
                 * @return {?}
                 */
                Testability.prototype.decreasePendingRequestCount = function () {
                    this._pendingCount -= 1;
                    if (this._pendingCount < 0) {
                        throw new Error('pending async requests below zero');
                    }
                    this._runCallbacksIfReady();
                    return this._pendingCount;
                };
                /**
                 * Whether an associated application is stable
                 * @return {?}
                 */
                Testability.prototype.isStable = function () {
                    return this._isZoneStable && this._pendingCount === 0 && !this._ngZone.hasPendingMacrotasks;
                };
                /**
                 * @private
                 * @return {?}
                 */
                Testability.prototype._runCallbacksIfReady = function () {
                    var _this = this;
                    if (this.isStable()) {
                        // Schedules the call backs in a new frame so that it is always async.
                        scheduleMicroTask(( /**
                         * @return {?}
                         */function () {
                            while (_this._callbacks.length !== 0) {
                                /** @type {?} */
                                var cb = ( /** @type {?} */(_this._callbacks.pop()));
                                clearTimeout(cb.timeoutId);
                                cb.doneCb(_this._didWork);
                            }
                            _this._didWork = false;
                        }));
                    }
                    else {
                        // Still not stable, send updates.
                        /** @type {?} */
                        var pending_1 = this.getPendingTasks();
                        this._callbacks = this._callbacks.filter(( /**
                         * @param {?} cb
                         * @return {?}
                         */function (cb) {
                            if (cb.updateCb && cb.updateCb(pending_1)) {
                                clearTimeout(cb.timeoutId);
                                return false;
                            }
                            return true;
                        }));
                        this._didWork = true;
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                Testability.prototype.getPendingTasks = function () {
                    if (!this.taskTrackingZone) {
                        return [];
                    }
                    // Copy the tasks data so that we don't leak tasks.
                    return this.taskTrackingZone.macroTasks.map(( /**
                     * @param {?} t
                     * @return {?}
                     */function (t) {
                        return {
                            source: t.source,
                            // From TaskTrackingZone:
                            // https://github.com/angular/zone.js/blob/master/lib/zone-spec/task-tracking.ts#L40
                            creationLocation: ( /** @type {?} */((( /** @type {?} */(t))).creationLocation)),
                            data: t.data
                        };
                    }));
                };
                /**
                 * @private
                 * @param {?} cb
                 * @param {?=} timeout
                 * @param {?=} updateCb
                 * @return {?}
                 */
                Testability.prototype.addCallback = function (cb, timeout, updateCb) {
                    var _this = this;
                    /** @type {?} */
                    var timeoutId = -1;
                    if (timeout && timeout > 0) {
                        timeoutId = setTimeout(( /**
                         * @return {?}
                         */function () {
                            _this._callbacks = _this._callbacks.filter(( /**
                             * @param {?} cb
                             * @return {?}
                             */function (cb) { return cb.timeoutId !== timeoutId; }));
                            cb(_this._didWork, _this.getPendingTasks());
                        }), timeout);
                    }
                    this._callbacks.push(( /** @type {?} */({ doneCb: cb, timeoutId: timeoutId, updateCb: updateCb })));
                };
                /**
                 * Wait for the application to be stable with a timeout. If the timeout is reached before that
                 * happens, the callback receives a list of the macro tasks that were pending, otherwise null.
                 *
                 * @param {?} doneCb The callback to invoke when Angular is stable or the timeout expires
                 *    whichever comes first.
                 * @param {?=} timeout Optional. The maximum time to wait for Angular to become stable. If not
                 *    specified, whenStable() will wait forever.
                 * @param {?=} updateCb Optional. If specified, this callback will be invoked whenever the set of
                 *    pending macrotasks changes. If this callback returns true doneCb will not be invoked
                 *    and no further updates will be issued.
                 * @return {?}
                 */
                Testability.prototype.whenStable = function (doneCb, timeout, updateCb) {
                    if (updateCb && !this.taskTrackingZone) {
                        throw new Error('Task tracking zone is required when passing an update callback to ' +
                            'whenStable(). Is "zone.js/dist/task-tracking.js" loaded?');
                    }
                    // These arguments are 'Function' above to keep the public API simple.
                    this.addCallback(( /** @type {?} */(doneCb)), timeout, ( /** @type {?} */(updateCb)));
                    this._runCallbacksIfReady();
                };
                /**
                 * Get the number of pending requests
                 * @deprecated pending requests are now tracked with zones
                 * @return {?}
                 */
                Testability.prototype.getPendingRequestCount = function () { return this._pendingCount; };
                /**
                 * Find providers by name
                 * @param {?} using The root element to search from
                 * @param {?} provider The name of binding variable
                 * @param {?} exactMatch Whether using exactMatch
                 * @return {?}
                 */
                Testability.prototype.findProviders = function (using, provider, exactMatch) {
                    // TODO(juliemr): implement.
                    return [];
                };
                return Testability;
            }());
            Testability.decorators = [
                { type: Injectable }
            ];
            /** @nocollapse */
            Testability.ctorParameters = function () { return [
                { type: NgZone }
            ]; };
            if (false) { }
            /**
             * A global registry of {\@link Testability} instances for specific elements.
             * \@publicApi
             */
            var TestabilityRegistry = /** @class */ (function () {
                function TestabilityRegistry() {
                    /**
                     * \@internal
                     */
                    this._applications = new Map();
                    _testabilityGetter.addToWindow(this);
                }
                /**
                 * Registers an application with a testability hook so that it can be tracked
                 * @param {?} token token of application, root element
                 * @param {?} testability Testability hook
                 * @return {?}
                 */
                TestabilityRegistry.prototype.registerApplication = function (token, testability) {
                    this._applications.set(token, testability);
                };
                /**
                 * Unregisters an application.
                 * @param {?} token token of application, root element
                 * @return {?}
                 */
                TestabilityRegistry.prototype.unregisterApplication = function (token) { this._applications.delete(token); };
                /**
                 * Unregisters all applications
                 * @return {?}
                 */
                TestabilityRegistry.prototype.unregisterAllApplications = function () { this._applications.clear(); };
                /**
                 * Get a testability hook associated with the application
                 * @param {?} elem root element
                 * @return {?}
                 */
                TestabilityRegistry.prototype.getTestability = function (elem) { return this._applications.get(elem) || null; };
                /**
                 * Get all registered testabilities
                 * @return {?}
                 */
                TestabilityRegistry.prototype.getAllTestabilities = function () { return Array.from(this._applications.values()); };
                /**
                 * Get all registered applications(root elements)
                 * @return {?}
                 */
                TestabilityRegistry.prototype.getAllRootElements = function () { return Array.from(this._applications.keys()); };
                /**
                 * Find testability of a node in the Tree
                 * @param {?} elem node
                 * @param {?=} findInAncestors whether finding testability in ancestors if testability was not found in
                 * current node
                 * @return {?}
                 */
                TestabilityRegistry.prototype.findTestabilityInTree = function (elem, findInAncestors) {
                    if (findInAncestors === void 0) { findInAncestors = true; }
                    return _testabilityGetter.findTestabilityInTree(this, elem, findInAncestors);
                };
                return TestabilityRegistry;
            }());
            TestabilityRegistry.decorators = [
                { type: Injectable }
            ];
            /** @nocollapse */
            TestabilityRegistry.ctorParameters = function () { return []; };
            if (false) { }
            /**
             * Adapter interface for retrieving the `Testability` service associated for a
             * particular context.
             *
             * \@publicApi
             * @record
             */
            function GetTestability() { }
            if (false) { }
            var _NoopGetTestability = /** @class */ (function () {
                function _NoopGetTestability() {
                }
                /**
                 * @param {?} registry
                 * @return {?}
                 */
                _NoopGetTestability.prototype.addToWindow = function (registry) { };
                /**
                 * @param {?} registry
                 * @param {?} elem
                 * @param {?} findInAncestors
                 * @return {?}
                 */
                _NoopGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
                    return null;
                };
                return _NoopGetTestability;
            }());
            /**
             * Set the {\@link GetTestability} implementation used by the Angular testing framework.
             * \@publicApi
             * @param {?} getter
             * @return {?}
             */
            function setTestabilityGetter(getter) {
                _testabilityGetter = getter;
            }
            /** @type {?} */
            var _testabilityGetter = new _NoopGetTestability();
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _platform;
            /** @type {?} */
            var compileNgModuleFactory = compileNgModuleFactory__PRE_R3__;
            /**
             * @template M
             * @param {?} injector
             * @param {?} options
             * @param {?} moduleType
             * @return {?}
             */
            function compileNgModuleFactory__PRE_R3__(injector, options, moduleType) {
                /** @type {?} */
                var compilerFactory = injector.get(CompilerFactory);
                /** @type {?} */
                var compiler = compilerFactory.createCompiler([options]);
                return compiler.compileModuleAsync(moduleType);
            }
            /**
             * @template M
             * @param {?} injector
             * @param {?} options
             * @param {?} moduleType
             * @return {?}
             */
            function compileNgModuleFactory__POST_R3__(injector, options, moduleType) {
                ngDevMode && assertNgModuleType(moduleType);
                /** @type {?} */
                var moduleFactory = new NgModuleFactory$1(moduleType);
                if (isComponentResourceResolutionQueueEmpty()) {
                    return Promise.resolve(moduleFactory);
                }
                /** @type {?} */
                var compilerOptions = injector.get(COMPILER_OPTIONS, []).concat(options);
                /** @type {?} */
                var compilerProviders = _mergeArrays(compilerOptions.map(( /**
                 * @param {?} o
                 * @return {?}
                 */function (/**
                 * @param {?} o
                 * @return {?}
                 */ o) { return ( /** @type {?} */(o.providers)); })));
                // In case there are no compiler providers, we just return the module factory as
                // there won't be any resource loader. This can happen with Ivy, because AOT compiled
                // modules can be still passed through "bootstrapModule". In that case we shouldn't
                // unnecessarily require the JIT compiler.
                if (compilerProviders.length === 0) {
                    return Promise.resolve(moduleFactory);
                }
                /** @type {?} */
                var compiler = getCompilerFacade();
                /** @type {?} */
                var compilerInjector = Injector.create({ providers: compilerProviders });
                /** @type {?} */
                var resourceLoader = compilerInjector.get(compiler.ResourceLoader);
                // The resource loader can also return a string while the "resolveComponentResources"
                // always expects a promise. Therefore we need to wrap the returned value in a promise.
                return resolveComponentResources(( /**
                 * @param {?} url
                 * @return {?}
                 */function (/**
                 * @param {?} url
                 * @return {?}
                 */ url) { return Promise.resolve(resourceLoader.get(url)); }))
                    .then(( /**
             * @return {?}
             */function () { return moduleFactory; }));
            }
            /** @type {?} */
            var isBoundToModule = isBoundToModule__PRE_R3__;
            /**
             * @template C
             * @param {?} cf
             * @return {?}
             */
            function isBoundToModule__PRE_R3__(cf) {
                return cf instanceof ComponentFactoryBoundToModule;
            }
            /**
             * @template C
             * @param {?} cf
             * @return {?}
             */
            function isBoundToModule__POST_R3__(cf) {
                return (( /** @type {?} */(cf))).isBoundToModule;
            }
            /** @type {?} */
            var ALLOW_MULTIPLE_PLATFORMS = new InjectionToken('AllowMultipleToken');
            /**
             * A token for third-party components that can register themselves with NgProbe.
             *
             * \@publicApi
             */
            var NgProbeToken = /** @class */ (function () {
                /**
                 * @param {?} name
                 * @param {?} token
                 */
                function NgProbeToken(name, token) {
                    this.name = name;
                    this.token = token;
                }
                return NgProbeToken;
            }());
            if (false) { }
            /**
             * Creates a platform.
             * Platforms have to be eagerly created via this function.
             *
             * \@publicApi
             * @param {?} injector
             * @return {?}
             */
            function createPlatform(injector) {
                if (_platform && !_platform.destroyed &&
                    !_platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
                    throw new Error('There can be only one platform. Destroy the previous one to create a new one.');
                }
                _platform = injector.get(PlatformRef);
                /** @type {?} */
                var inits = injector.get(PLATFORM_INITIALIZER, null);
                if (inits)
                    inits.forEach(( /**
                     * @param {?} init
                     * @return {?}
                     */function (init) { return init(); }));
                return _platform;
            }
            /**
             * Creates a factory for a platform
             *
             * \@publicApi
             * @param {?} parentPlatformFactory
             * @param {?} name
             * @param {?=} providers
             * @return {?}
             */
            function createPlatformFactory(parentPlatformFactory, name, providers) {
                if (providers === void 0) { providers = []; }
                /** @type {?} */
                var desc = "Platform: " + name;
                /** @type {?} */
                var marker = new InjectionToken(desc);
                return ( /**
                 * @param {?=} extraProviders
                 * @return {?}
                 */function (extraProviders) {
                    if (extraProviders === void 0) { extraProviders = []; }
                    /** @type {?} */
                    var platform = getPlatform();
                    if (!platform || platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
                        if (parentPlatformFactory) {
                            parentPlatformFactory(providers.concat(extraProviders).concat({ provide: marker, useValue: true }));
                        }
                        else {
                            /** @type {?} */
                            var injectedProviders = providers.concat(extraProviders).concat({ provide: marker, useValue: true });
                            createPlatform(Injector.create({ providers: injectedProviders, name: desc }));
                        }
                    }
                    return assertPlatform(marker);
                });
            }
            /**
             * Checks that there currently is a platform which contains the given token as a provider.
             *
             * \@publicApi
             * @param {?} requiredToken
             * @return {?}
             */
            function assertPlatform(requiredToken) {
                /** @type {?} */
                var platform = getPlatform();
                if (!platform) {
                    throw new Error('No platform exists!');
                }
                if (!platform.injector.get(requiredToken, null)) {
                    throw new Error('A platform with a different configuration has been created. Please destroy it first.');
                }
                return platform;
            }
            /**
             * Destroy the existing platform.
             *
             * \@publicApi
             * @return {?}
             */
            function destroyPlatform() {
                if (_platform && !_platform.destroyed) {
                    _platform.destroy();
                }
            }
            /**
             * Returns the current platform.
             *
             * \@publicApi
             * @return {?}
             */
            function getPlatform() {
                return _platform && !_platform.destroyed ? _platform : null;
            }
            /**
             * Provides additional options to the bootstraping process.
             *
             *
             * @record
             */
            function BootstrapOptions() { }
            if (false) { }
            /**
             * The Angular platform is the entry point for Angular on a web page. Each page
             * has exactly one platform, and services (such as reflection) which are common
             * to every Angular application running on the page are bound in its scope.
             *
             * A page's platform is initialized implicitly when a platform is created via a platform factory
             * (e.g. {\@link platformBrowser}), or explicitly by calling the {\@link createPlatform} function.
             *
             * \@publicApi
             */
            var PlatformRef = /** @class */ (function () {
                /**
                 * \@internal
                 * @param {?} _injector
                 */
                function PlatformRef(_injector) {
                    this._injector = _injector;
                    this._modules = [];
                    this._destroyListeners = [];
                    this._destroyed = false;
                }
                /**
                 * Creates an instance of an `\@NgModule` for the given platform
                 * for offline compilation.
                 *
                 * \@usageNotes
                 * ### Simple Example
                 *
                 * ```typescript
                 * my_module.ts:
                 *
                 * \@NgModule({
                 *   imports: [BrowserModule]
                 * })
                 * class MyModule {}
                 *
                 * main.ts:
                 * import {MyModuleNgFactory} from './my_module.ngfactory';
                 * import {platformBrowser} from '\@angular/platform-browser';
                 *
                 * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
                 * ```
                 * @template M
                 * @param {?} moduleFactory
                 * @param {?=} options
                 * @return {?}
                 */
                PlatformRef.prototype.bootstrapModuleFactory = function (moduleFactory, options) {
                    var _this = this;
                    // Note: We need to create the NgZone _before_ we instantiate the module,
                    // as instantiating the module creates some providers eagerly.
                    // So we create a mini parent injector that just contains the new NgZone and
                    // pass that as parent to the NgModuleFactory.
                    /** @type {?} */
                    var ngZoneOption = options ? options.ngZone : undefined;
                    /** @type {?} */
                    var ngZone = getNgZone(ngZoneOption);
                    /** @type {?} */
                    var providers = [{ provide: NgZone, useValue: ngZone }];
                    // Attention: Don't use ApplicationRef.run here,
                    // as we want to be sure that all possible constructor calls are inside `ngZone.run`!
                    return ngZone.run(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var ngZoneInjector = Injector.create({ providers: providers, parent: _this.injector, name: moduleFactory.moduleType.name });
                        /** @type {?} */
                        var moduleRef = ( /** @type {?} */(moduleFactory.create(ngZoneInjector)));
                        /** @type {?} */
                        var exceptionHandler = moduleRef.injector.get(ErrorHandler, null);
                        if (!exceptionHandler) {
                            throw new Error('No ErrorHandler. Is platform module (BrowserModule) included?');
                        }
                        // If the `LOCALE_ID` provider is defined at bootstrap we set the value for runtime i18n (ivy)
                        if (ivyEnabled) {
                            /** @type {?} */
                            var localeId = moduleRef.injector.get(LOCALE_ID$1, DEFAULT_LOCALE_ID);
                            setLocaleId(localeId || DEFAULT_LOCALE_ID);
                        }
                        moduleRef.onDestroy(( /**
                         * @return {?}
                         */function () { return remove(_this._modules, moduleRef); }));
                        ( /** @type {?} */(ngZone)).runOutsideAngular(( /**
                         * @return {?}
                         */function () { return ( /** @type {?} */(ngZone)).onError.subscribe({ next: ( /**
                                 * @param {?} error
                                 * @return {?}
                                 */function (error) { exceptionHandler.handleError(error); }) }); }));
                        return _callAndReportToErrorHandler(exceptionHandler, ( /** @type {?} */(ngZone)), ( /**
                         * @return {?}
                         */function () {
                            /** @type {?} */
                            var initStatus = moduleRef.injector.get(ApplicationInitStatus);
                            initStatus.runInitializers();
                            return initStatus.donePromise.then(( /**
                             * @return {?}
                             */function () {
                                _this._moduleDoBootstrap(moduleRef);
                                return moduleRef;
                            }));
                        }));
                    }));
                };
                /**
                 * Creates an instance of an `\@NgModule` for a given platform using the given runtime compiler.
                 *
                 * \@usageNotes
                 * ### Simple Example
                 *
                 * ```typescript
                 * \@NgModule({
                 *   imports: [BrowserModule]
                 * })
                 * class MyModule {}
                 *
                 * let moduleRef = platformBrowser().bootstrapModule(MyModule);
                 * ```
                 *
                 * @template M
                 * @param {?} moduleType
                 * @param {?=} compilerOptions
                 * @return {?}
                 */
                PlatformRef.prototype.bootstrapModule = function (moduleType, compilerOptions) {
                    var _this = this;
                    if (compilerOptions === void 0) { compilerOptions = []; }
                    /** @type {?} */
                    var options = optionsReducer({}, compilerOptions);
                    return compileNgModuleFactory(this.injector, options, moduleType)
                        .then(( /**
                 * @param {?} moduleFactory
                 * @return {?}
                 */function (/**
                 * @param {?} moduleFactory
                 * @return {?}
                 */ moduleFactory) { return _this.bootstrapModuleFactory(moduleFactory, options); }));
                };
                /**
                 * @private
                 * @param {?} moduleRef
                 * @return {?}
                 */
                PlatformRef.prototype._moduleDoBootstrap = function (moduleRef) {
                    /** @type {?} */
                    var appRef = ( /** @type {?} */(moduleRef.injector.get(ApplicationRef)));
                    if (moduleRef._bootstrapComponents.length > 0) {
                        moduleRef._bootstrapComponents.forEach(( /**
                         * @param {?} f
                         * @return {?}
                         */function (/**
                         * @param {?} f
                         * @return {?}
                         */ f) { return appRef.bootstrap(f); }));
                    }
                    else if (moduleRef.instance.ngDoBootstrap) {
                        moduleRef.instance.ngDoBootstrap(appRef);
                    }
                    else {
                        throw new Error("The module " + stringify(moduleRef.instance.constructor) + " was bootstrapped, but it does not declare \"@NgModule.bootstrap\" components nor a \"ngDoBootstrap\" method. " +
                            "Please define one of these.");
                    }
                    this._modules.push(moduleRef);
                };
                /**
                 * Register a listener to be called when the platform is disposed.
                 * @param {?} callback
                 * @return {?}
                 */
                PlatformRef.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
                Object.defineProperty(PlatformRef.prototype, "injector", {
                    /**
                     * Retrieve the platform {\@link Injector}, which is the parent injector for
                     * every Angular application on the page and provides singleton providers.
                     * @return {?}
                     */
                    get: function () { return this._injector; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Destroy the Angular platform and all Angular applications on the page.
                 * @return {?}
                 */
                PlatformRef.prototype.destroy = function () {
                    if (this._destroyed) {
                        throw new Error('The platform has already been destroyed!');
                    }
                    this._modules.slice().forEach(( /**
                     * @param {?} module
                     * @return {?}
                     */function (/**
                     * @param {?} module
                     * @return {?}
                     */ module) { return module.destroy(); }));
                    this._destroyListeners.forEach(( /**
                     * @param {?} listener
                     * @return {?}
                     */function (/**
                     * @param {?} listener
                     * @return {?}
                     */ listener) { return listener(); }));
                    this._destroyed = true;
                };
                Object.defineProperty(PlatformRef.prototype, "destroyed", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._destroyed; },
                    enumerable: true,
                    configurable: true
                });
                return PlatformRef;
            }());
            PlatformRef.decorators = [
                { type: Injectable }
            ];
            /** @nocollapse */
            PlatformRef.ctorParameters = function () { return [
                { type: Injector }
            ]; };
            if (false) { }
            /**
             * @param {?=} ngZoneOption
             * @return {?}
             */
            function getNgZone(ngZoneOption) {
                /** @type {?} */
                var ngZone;
                if (ngZoneOption === 'noop') {
                    ngZone = new NoopNgZone();
                }
                else {
                    ngZone = (ngZoneOption === 'zone.js' ? undefined : ngZoneOption) ||
                        new NgZone({ enableLongStackTrace: isDevMode() });
                }
                return ngZone;
            }
            /**
             * @param {?} errorHandler
             * @param {?} ngZone
             * @param {?} callback
             * @return {?}
             */
            function _callAndReportToErrorHandler(errorHandler, ngZone, callback) {
                try {
                    /** @type {?} */
                    var result = callback();
                    if (isPromise(result)) {
                        return result.catch(( /**
                         * @param {?} e
                         * @return {?}
                         */function (e) {
                            ngZone.runOutsideAngular(( /**
                             * @return {?}
                             */function () { return errorHandler.handleError(e); }));
                            // rethrow as the exception handler might not do it
                            throw e;
                        }));
                    }
                    return result;
                }
                catch (e) {
                    ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () { return errorHandler.handleError(e); }));
                    // rethrow as the exception handler might not do it
                    throw e;
                }
            }
            /**
             * @template T
             * @param {?} dst
             * @param {?} objs
             * @return {?}
             */
            function optionsReducer(dst, objs) {
                if (Array.isArray(objs)) {
                    dst = objs.reduce(optionsReducer, dst);
                }
                else {
                    dst = Object.assign({}, dst, (( /** @type {?} */(objs))));
                }
                return dst;
            }
            /**
             * A reference to an Angular application running on a page.
             *
             * \@usageNotes
             *
             * {\@a is-stable-examples}
             * ### isStable examples and caveats
             *
             * Note two important points about `isStable`, demonstrated in the examples below:
             * - the application will never be stable if you start any kind
             * of recurrent asynchronous task when the application starts
             * (for example for a polling process, started with a `setInterval`, a `setTimeout`
             * or using RxJS operators like `interval`);
             * - the `isStable` Observable runs outside of the Angular zone.
             *
             * Let's imagine that you start a recurrent task
             * (here incrementing a counter, using RxJS `interval`),
             * and at the same time subscribe to `isStable`.
             *
             * ```
             * constructor(appRef: ApplicationRef) {
             *   appRef.isStable.pipe(
             *      filter(stable => stable)
             *   ).subscribe(() => console.log('App is stable now');
             *   interval(1000).subscribe(counter => console.log(counter));
             * }
             * ```
             * In this example, `isStable` will never emit `true`,
             * and the trace "App is stable now" will never get logged.
             *
             * If you want to execute something when the app is stable,
             * you have to wait for the application to be stable
             * before starting your polling process.
             *
             * ```
             * constructor(appRef: ApplicationRef) {
             *   appRef.isStable.pipe(
             *     first(stable => stable),
             *     tap(stable => console.log('App is stable now')),
             *     switchMap(() => interval(1000))
             *   ).subscribe(counter => console.log(counter));
             * }
             * ```
             * In this example, the trace "App is stable now" will be logged
             * and then the counter starts incrementing every second.
             *
             * Note also that this Observable runs outside of the Angular zone,
             * which means that the code in the subscription
             * to this Observable will not trigger the change detection.
             *
             * Let's imagine that instead of logging the counter value,
             * you update a field of your component
             * and display it in its template.
             *
             * ```
             * constructor(appRef: ApplicationRef) {
             *   appRef.isStable.pipe(
             *     first(stable => stable),
             *     switchMap(() => interval(1000))
             *   ).subscribe(counter => this.value = counter);
             * }
             * ```
             * As the `isStable` Observable runs outside the zone,
             * the `value` field will be updated properly,
             * but the template will not be refreshed!
             *
             * You'll have to manually trigger the change detection to update the template.
             *
             * ```
             * constructor(appRef: ApplicationRef, cd: ChangeDetectorRef) {
             *   appRef.isStable.pipe(
             *     first(stable => stable),
             *     switchMap(() => interval(1000))
             *   ).subscribe(counter => {
             *     this.value = counter;
             *     cd.detectChanges();
             *   });
             * }
             * ```
             *
             * Or make the subscription callback run inside the zone.
             *
             * ```
             * constructor(appRef: ApplicationRef, zone: NgZone) {
             *   appRef.isStable.pipe(
             *     first(stable => stable),
             *     switchMap(() => interval(1000))
             *   ).subscribe(counter => zone.run(() => this.value = counter));
             * }
             * ```
             *
             * \@publicApi
             */
            var ApplicationRef = /** @class */ (function () {
                /**
                 * \@internal
                 * @param {?} _zone
                 * @param {?} _console
                 * @param {?} _injector
                 * @param {?} _exceptionHandler
                 * @param {?} _componentFactoryResolver
                 * @param {?} _initStatus
                 */
                function ApplicationRef(_zone, _console, _injector, _exceptionHandler, _componentFactoryResolver, _initStatus) {
                    var _this = this;
                    this._zone = _zone;
                    this._console = _console;
                    this._injector = _injector;
                    this._exceptionHandler = _exceptionHandler;
                    this._componentFactoryResolver = _componentFactoryResolver;
                    this._initStatus = _initStatus;
                    this._bootstrapListeners = [];
                    this._views = [];
                    this._runningTick = false;
                    this._enforceNoNewChanges = false;
                    this._stable = true;
                    /**
                     * Get a list of component types registered to this application.
                     * This list is populated even before the component is created.
                     */
                    this.componentTypes = [];
                    /**
                     * Get a list of components registered to this application.
                     */
                    this.components = [];
                    this._enforceNoNewChanges = isDevMode();
                    this._zone.onMicrotaskEmpty.subscribe({ next: ( /**
                             * @return {?}
                             */function () {
                            _this._zone.run(( /**
                             * @return {?}
                             */function () { _this.tick(); }));
                        }) });
                    /** @type {?} */
                    var isCurrentlyStable = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        _this._stable = _this._zone.isStable && !_this._zone.hasPendingMacrotasks &&
                            !_this._zone.hasPendingMicrotasks;
                        _this._zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            observer.next(_this._stable);
                            observer.complete();
                        }));
                    }));
                    /** @type {?} */
                    var isStable = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Observable"](( /**
                     * @param {?} observer
                     * @return {?}
                     */function (observer) {
                        // Create the subscription to onStable outside the Angular Zone so that
                        // the callback is run outside the Angular Zone.
                        /** @type {?} */
                        var stableSub;
                        _this._zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            stableSub = _this._zone.onStable.subscribe(( /**
                             * @return {?}
                             */function () {
                                NgZone.assertNotInAngularZone();
                                // Check whether there are no pending macro/micro tasks in the next tick
                                // to allow for NgZone to update the state.
                                scheduleMicroTask(( /**
                                 * @return {?}
                                 */function () {
                                    if (!_this._stable && !_this._zone.hasPendingMacrotasks &&
                                        !_this._zone.hasPendingMicrotasks) {
                                        _this._stable = true;
                                        observer.next(true);
                                    }
                                }));
                            }));
                        }));
                        /** @type {?} */
                        var unstableSub = _this._zone.onUnstable.subscribe(( /**
                         * @return {?}
                         */function () {
                            NgZone.assertInAngularZone();
                            if (_this._stable) {
                                _this._stable = false;
                                _this._zone.runOutsideAngular(( /**
                                 * @return {?}
                                 */function () { observer.next(false); }));
                            }
                        }));
                        return ( /**
                         * @return {?}
                         */function () {
                            stableSub.unsubscribe();
                            unstableSub.unsubscribe();
                        });
                    }));
                    (( /** @type {?} */(this))).isStable =
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_0__["merge"])(isCurrentlyStable, isStable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_1__["share"])()));
                }
                /**
                 * Bootstrap a new component at the root level of the application.
                 *
                 * \@usageNotes
                 * ### Bootstrap process
                 *
                 * When bootstrapping a new root component into an application, Angular mounts the
                 * specified application component onto DOM elements identified by the componentType's
                 * selector and kicks off automatic change detection to finish initializing the component.
                 *
                 * Optionally, a component can be mounted onto a DOM element that does not match the
                 * componentType's selector.
                 *
                 * ### Example
                 * {\@example core/ts/platform/platform.ts region='longform'}
                 * @template C
                 * @param {?} componentOrFactory
                 * @param {?=} rootSelectorOrNode
                 * @return {?}
                 */
                ApplicationRef.prototype.bootstrap = function (componentOrFactory, rootSelectorOrNode) {
                    var _this = this;
                    if (!this._initStatus.done) {
                        throw new Error('Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module.');
                    }
                    /** @type {?} */
                    var componentFactory;
                    if (componentOrFactory instanceof ComponentFactory) {
                        componentFactory = componentOrFactory;
                    }
                    else {
                        componentFactory =
                            ( /** @type {?} */(this._componentFactoryResolver.resolveComponentFactory(componentOrFactory)));
                    }
                    this.componentTypes.push(componentFactory.componentType);
                    // Create a factory associated with the current module if it's not bound to some other
                    /** @type {?} */
                    var ngModule = isBoundToModule(componentFactory) ? null : this._injector.get(NgModuleRef);
                    /** @type {?} */
                    var selectorOrNode = rootSelectorOrNode || componentFactory.selector;
                    /** @type {?} */
                    var compRef = componentFactory.create(Injector.NULL, [], selectorOrNode, ngModule);
                    compRef.onDestroy(( /**
                     * @return {?}
                     */function () { _this._unloadComponent(compRef); }));
                    /** @type {?} */
                    var testability = compRef.injector.get(Testability, null);
                    if (testability) {
                        compRef.injector.get(TestabilityRegistry)
                            .registerApplication(compRef.location.nativeElement, testability);
                    }
                    this._loadComponent(compRef);
                    if (isDevMode()) {
                        this._console.log("Angular is running in the development mode. Call enableProdMode() to enable the production mode.");
                    }
                    return compRef;
                };
                /**
                 * Invoke this method to explicitly process change detection and its side-effects.
                 *
                 * In development mode, `tick()` also performs a second change detection cycle to ensure that no
                 * further changes are detected. If additional changes are picked up during this second cycle,
                 * bindings in the app have side-effects that cannot be resolved in a single change detection
                 * pass.
                 * In this case, Angular throws an error, since an Angular application can only have one change
                 * detection pass during which all change detection must complete.
                 * @return {?}
                 */
                ApplicationRef.prototype.tick = function () {
                    var _this = this;
                    if (this._runningTick) {
                        throw new Error('ApplicationRef.tick is called recursively');
                    }
                    /** @type {?} */
                    var scope = ApplicationRef._tickScope();
                    try {
                        this._runningTick = true;
                        for (var _c = 0, _d = this._views; _c < _d.length; _c++) {
                            var view = _d[_c];
                            view.detectChanges();
                        }
                        if (this._enforceNoNewChanges) {
                            for (var _e = 0, _f = this._views; _e < _f.length; _e++) {
                                var view = _f[_e];
                                view.checkNoChanges();
                            }
                        }
                    }
                    catch (e) {
                        // Attention: Don't rethrow as it could cancel subscriptions to Observables!
                        this._zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return _this._exceptionHandler.handleError(e); }));
                    }
                    finally {
                        this._runningTick = false;
                        wtfLeave(scope);
                    }
                };
                /**
                 * Attaches a view so that it will be dirty checked.
                 * The view will be automatically detached when it is destroyed.
                 * This will throw if the view is already attached to a ViewContainer.
                 * @param {?} viewRef
                 * @return {?}
                 */
                ApplicationRef.prototype.attachView = function (viewRef) {
                    /** @type {?} */
                    var view = (( /** @type {?} */(viewRef)));
                    this._views.push(view);
                    view.attachToAppRef(this);
                };
                /**
                 * Detaches a view from dirty checking again.
                 * @param {?} viewRef
                 * @return {?}
                 */
                ApplicationRef.prototype.detachView = function (viewRef) {
                    /** @type {?} */
                    var view = (( /** @type {?} */(viewRef)));
                    remove(this._views, view);
                    view.detachFromAppRef();
                };
                /**
                 * @private
                 * @param {?} componentRef
                 * @return {?}
                 */
                ApplicationRef.prototype._loadComponent = function (componentRef) {
                    this.attachView(componentRef.hostView);
                    this.tick();
                    this.components.push(componentRef);
                    // Get the listeners lazily to prevent DI cycles.
                    /** @type {?} */
                    var listeners = this._injector.get(APP_BOOTSTRAP_LISTENER, []).concat(this._bootstrapListeners);
                    listeners.forEach(( /**
                     * @param {?} listener
                     * @return {?}
                     */function (listener) { return listener(componentRef); }));
                };
                /**
                 * @private
                 * @param {?} componentRef
                 * @return {?}
                 */
                ApplicationRef.prototype._unloadComponent = function (componentRef) {
                    this.detachView(componentRef.hostView);
                    remove(this.components, componentRef);
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                ApplicationRef.prototype.ngOnDestroy = function () {
                    // TODO(alxhub): Dispose of the NgZone.
                    this._views.slice().forEach(( /**
                     * @param {?} view
                     * @return {?}
                     */function (view) { return view.destroy(); }));
                };
                Object.defineProperty(ApplicationRef.prototype, "viewCount", {
                    /**
                     * Returns the number of attached views.
                     * @return {?}
                     */
                    get: function () { return this._views.length; },
                    enumerable: true,
                    configurable: true
                });
                return ApplicationRef;
            }());
            /**
             * \@internal
             */
            ApplicationRef._tickScope = wtfCreateScope('ApplicationRef#tick()');
            ApplicationRef.decorators = [
                { type: Injectable }
            ];
            /** @nocollapse */
            ApplicationRef.ctorParameters = function () { return [
                { type: NgZone },
                { type: Console },
                { type: Injector },
                { type: ErrorHandler },
                { type: ComponentFactoryResolver },
                { type: ApplicationInitStatus }
            ]; };
            if (false) { }
            /**
             * @template T
             * @param {?} list
             * @param {?} el
             * @return {?}
             */
            function remove(list, el) {
                /** @type {?} */
                var index = list.indexOf(el);
                if (index > -1) {
                    list.splice(index, 1);
                }
            }
            /**
             * @param {?} parts
             * @return {?}
             */
            function _mergeArrays(parts) {
                /** @type {?} */
                var result = [];
                parts.forEach(( /**
                 * @param {?} part
                 * @return {?}
                 */function (part) { return part && result.push.apply(result, part); }));
                return result;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to load ng module factories.
             *
             * \@publicApi
             * @deprecated the `string` form of `loadChildren` is deprecated, and `NgModuleFactoryLoader` is
             * part of its implementation. See `LoadChildren` for more details.
             * @abstract
             */
            var NgModuleFactoryLoader = /** @class */ (function () {
                function NgModuleFactoryLoader() {
                }
                return NgModuleFactoryLoader;
            }());
            if (false) { }
            /**
             * @param {?} id
             * @return {?}
             */
            function getModuleFactory__PRE_R3__(id) {
                /** @type {?} */
                var factory = ( /** @type {?} */(getRegisteredNgModuleType(id)));
                if (!factory)
                    throw noModuleError(id);
                return factory;
            }
            /**
             * @param {?} id
             * @return {?}
             */
            function getModuleFactory__POST_R3__(id) {
                /** @type {?} */
                var type = ( /** @type {?} */(getRegisteredNgModuleType(id)));
                if (!type)
                    throw noModuleError(id);
                return new NgModuleFactory$1(type);
            }
            /**
             * Returns the NgModuleFactory with the given id, if it exists and has been loaded.
             * Factories for modules that do not specify an `id` cannot be retrieved. Throws if the module
             * cannot be found.
             * \@publicApi
             * @type {?}
             */
            var getModuleFactory = getModuleFactory__PRE_R3__;
            /**
             * @param {?} id
             * @return {?}
             */
            function noModuleError(id) {
                return new Error("No module with ID " + id + " loaded");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _SEPARATOR = '#';
            /** @type {?} */
            var FACTORY_CLASS_SUFFIX = 'NgFactory';
            /**
             * Configuration for SystemJsNgModuleLoader.
             * token.
             *
             * \@publicApi
             * @deprecated the `string` form of `loadChildren` is deprecated, and `SystemJsNgModuleLoaderConfig`
             * is part of its implementation. See `LoadChildren` for more details.
             * @abstract
             */
            var SystemJsNgModuleLoaderConfig = /** @class */ (function () {
                function SystemJsNgModuleLoaderConfig() {
                }
                return SystemJsNgModuleLoaderConfig;
            }());
            if (false) { }
            /** @type {?} */
            var DEFAULT_CONFIG = {
                factoryPathPrefix: '',
                factoryPathSuffix: '.ngfactory',
            };
            /**
             * NgModuleFactoryLoader that uses SystemJS to load NgModuleFactory
             * \@publicApi
             * @deprecated the `string` form of `loadChildren` is deprecated, and `SystemJsNgModuleLoader` is
             * part of its implementation. See `LoadChildren` for more details.
             */
            var SystemJsNgModuleLoader = /** @class */ (function () {
                /**
                 * @param {?} _compiler
                 * @param {?=} config
                 */
                function SystemJsNgModuleLoader(_compiler, config) {
                    this._compiler = _compiler;
                    this._config = config || DEFAULT_CONFIG;
                }
                /**
                 * @param {?} path
                 * @return {?}
                 */
                SystemJsNgModuleLoader.prototype.load = function (path) {
                    /** @type {?} */
                    var legacyOfflineMode = !ivyEnabled && this._compiler instanceof Compiler;
                    return legacyOfflineMode ? this.loadFactory(path) : this.loadAndCompile(path);
                };
                /**
                 * @private
                 * @param {?} path
                 * @return {?}
                 */
                SystemJsNgModuleLoader.prototype.loadAndCompile = function (path) {
                    var _this = this;
                    var _c = path.split(_SEPARATOR), module = _c[0], exportName = _c[1];
                    if (exportName === undefined) {
                        exportName = 'default';
                    }
                    return __webpack_require__("./src/$$_lazy_route_resource lazy recursive")(module)
                        .then(( /**
                 * @param {?} module
                 * @return {?}
                 */function (module) { return module[exportName]; }))
                        .then(( /**
                 * @param {?} type
                 * @return {?}
                 */function (type) { return checkNotEmpty(type, module, exportName); }))
                        .then(( /**
                 * @param {?} type
                 * @return {?}
                 */function (type) { return _this._compiler.compileModuleAsync(type); }));
                };
                /**
                 * @private
                 * @param {?} path
                 * @return {?}
                 */
                SystemJsNgModuleLoader.prototype.loadFactory = function (path) {
                    var _c = path.split(_SEPARATOR), module = _c[0], exportName = _c[1];
                    /** @type {?} */
                    var factoryClassSuffix = FACTORY_CLASS_SUFFIX;
                    if (exportName === undefined) {
                        exportName = 'default';
                        factoryClassSuffix = '';
                    }
                    return __webpack_require__("./src/$$_lazy_route_resource lazy recursive")(this._config.factoryPathPrefix + module + this._config.factoryPathSuffix)
                        .then(( /**
                 * @param {?} module
                 * @return {?}
                 */function (module) { return module[exportName + factoryClassSuffix]; }))
                        .then(( /**
                 * @param {?} factory
                 * @return {?}
                 */function (factory) { return checkNotEmpty(factory, module, exportName); }));
                };
                return SystemJsNgModuleLoader;
            }());
            SystemJsNgModuleLoader.decorators = [
                { type: Injectable }
            ];
            /** @nocollapse */
            SystemJsNgModuleLoader.ctorParameters = function () { return [
                { type: Compiler },
                { type: SystemJsNgModuleLoaderConfig, decorators: [{ type: Optional }] }
            ]; };
            if (false) { }
            /**
             * @param {?} value
             * @param {?} modulePath
             * @param {?} exportName
             * @return {?}
             */
            function checkNotEmpty(value, modulePath, exportName) {
                if (!value) {
                    throw new Error("Cannot find '" + exportName + "' in '" + modulePath + "'");
                }
                return value;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Represents an Angular [view](guide/glossary#view),
             * specifically the [host view](guide/glossary#view-tree) that is defined by a component.
             * Also serves as the base class
             * that adds destroy methods for [embedded views](guide/glossary#view-tree).
             *
             * @see `EmbeddedViewRef`
             *
             * \@publicApi
             * @abstract
             */
            var ViewRef$1 = /** @class */ (function (_super_1) {
                __extends(ViewRef$1, _super_1);
                function ViewRef$1() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return ViewRef$1;
            }(ChangeDetectorRef));
            if (false) { }
            /**
             * Represents an Angular [view](guide/glossary#view) in a view container.
             * An [embedded view](guide/glossary#view-tree) can be referenced from a component
             * other than the hosting component whose template defines it, or it can be defined
             * independently by a `TemplateRef`.
             *
             * Properties of elements in a view can change, but the structure (number and order) of elements in
             * a view cannot. Change the structure of elements by inserting, moving, or
             * removing nested views in a view container.
             *
             * @see `ViewContainerRef`
             *
             * \@usageNotes
             *
             * The following template breaks down into two separate `TemplateRef` instances,
             * an outer one and an inner one.
             *
             * ```
             * Count: {{items.length}}
             * <ul>
             *   <li *ngFor="let  item of items">{{item}}</li>
             * </ul>
             * ```
             *
             * This is the outer `TemplateRef`:
             *
             * ```
             * Count: {{items.length}}
             * <ul>
             *   <ng-template ngFor let-item [ngForOf]="items"></ng-template>
             * </ul>
             * ```
             *
             * This is the inner `TemplateRef`:
             *
             * ```
             *   <li>{{item}}</li>
             * ```
             *
             * The outer and inner `TemplateRef` instances are assembled into views as follows:
             *
             * ```
             * <!-- ViewRef: outer-0 -->
             * Count: 2
             * <ul>
             *   <ng-template view-container-ref></ng-template>
             *   <!-- ViewRef: inner-1 --><li>first</li><!-- /ViewRef: inner-1 -->
             *   <!-- ViewRef: inner-2 --><li>second</li><!-- /ViewRef: inner-2 -->
             * </ul>
             * <!-- /ViewRef: outer-0 -->
             * ```
             * \@publicApi
             * @abstract
             * @template C
             */
            var EmbeddedViewRef = /** @class */ (function (_super_1) {
                __extends(EmbeddedViewRef, _super_1);
                function EmbeddedViewRef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return EmbeddedViewRef;
            }(ViewRef$1));
            if (false) { }
            /**
             * @record
             */
            function InternalViewRef() { }
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             */
            var DebugEventListener = /** @class */ (function () {
                /**
                 * @param {?} name
                 * @param {?} callback
                 */
                function DebugEventListener(name, callback) {
                    this.name = name;
                    this.callback = callback;
                }
                return DebugEventListener;
            }());
            if (false) { }
            // WARNING: interface has both a type and a value, skipping emit
            var DebugNode__PRE_R3__ = /** @class */ (function () {
                /**
                 * @param {?} nativeNode
                 * @param {?} parent
                 * @param {?} _debugContext
                 */
                function DebugNode__PRE_R3__(nativeNode, parent, _debugContext) {
                    this.listeners = [];
                    this.parent = null;
                    this._debugContext = _debugContext;
                    this.nativeNode = nativeNode;
                    if (parent && parent instanceof DebugElement__PRE_R3__) {
                        parent.addChild(this);
                    }
                }
                Object.defineProperty(DebugNode__PRE_R3__.prototype, "injector", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._debugContext.injector; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__PRE_R3__.prototype, "componentInstance", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._debugContext.component; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__PRE_R3__.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._debugContext.context; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__PRE_R3__.prototype, "references", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._debugContext.references; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__PRE_R3__.prototype, "providerTokens", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._debugContext.providerTokens; },
                    enumerable: true,
                    configurable: true
                });
                return DebugNode__PRE_R3__;
            }());
            if (false) { }
            // WARNING: interface has both a type and a value, skipping emit
            var DebugElement__PRE_R3__ = /** @class */ (function (_super_1) {
                __extends(DebugElement__PRE_R3__, _super_1);
                /**
                 * @param {?} nativeNode
                 * @param {?} parent
                 * @param {?} _debugContext
                 */
                function DebugElement__PRE_R3__(nativeNode, parent, _debugContext) {
                    var _this = _super_1.call(this, nativeNode, parent, _debugContext) || this;
                    _this.properties = {};
                    _this.attributes = {};
                    _this.classes = {};
                    _this.styles = {};
                    _this.childNodes = [];
                    _this.nativeElement = nativeNode;
                    return _this;
                }
                /**
                 * @param {?} child
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.addChild = function (child) {
                    if (child) {
                        this.childNodes.push(child);
                        (( /** @type {?} */(child))).parent = this;
                    }
                };
                /**
                 * @param {?} child
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.removeChild = function (child) {
                    /** @type {?} */
                    var childIndex = this.childNodes.indexOf(child);
                    if (childIndex !== -1) {
                        (( /** @type {?} */(child))).parent = null;
                        this.childNodes.splice(childIndex, 1);
                    }
                };
                /**
                 * @param {?} child
                 * @param {?} newChildren
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.insertChildrenAfter = function (child, newChildren) {
                    var _c;
                    var _this = this;
                    /** @type {?} */
                    var siblingIndex = this.childNodes.indexOf(child);
                    if (siblingIndex !== -1) {
                        (_c = this.childNodes).splice.apply(_c, [siblingIndex + 1, 0].concat(newChildren));
                        newChildren.forEach(( /**
                         * @param {?} c
                         * @return {?}
                         */function (/**
                         * @param {?} c
                         * @return {?}
                         */ c) {
                            if (c.parent) {
                                (( /** @type {?} */(c.parent))).removeChild(c);
                            }
                            (( /** @type {?} */(child))).parent = _this;
                        }));
                    }
                };
                /**
                 * @param {?} refChild
                 * @param {?} newChild
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.insertBefore = function (refChild, newChild) {
                    /** @type {?} */
                    var refIndex = this.childNodes.indexOf(refChild);
                    if (refIndex === -1) {
                        this.addChild(newChild);
                    }
                    else {
                        if (newChild.parent) {
                            (( /** @type {?} */(newChild.parent))).removeChild(newChild);
                        }
                        (( /** @type {?} */(newChild))).parent = this;
                        this.childNodes.splice(refIndex, 0, newChild);
                    }
                };
                /**
                 * @param {?} predicate
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.query = function (predicate) {
                    /** @type {?} */
                    var results = this.queryAll(predicate);
                    return results[0] || null;
                };
                /**
                 * @param {?} predicate
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.queryAll = function (predicate) {
                    /** @type {?} */
                    var matches = [];
                    _queryElementChildren(this, predicate, matches);
                    return matches;
                };
                /**
                 * @param {?} predicate
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.queryAllNodes = function (predicate) {
                    /** @type {?} */
                    var matches = [];
                    _queryNodeChildren(this, predicate, matches);
                    return matches;
                };
                Object.defineProperty(DebugElement__PRE_R3__.prototype, "children", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return ( /** @type {?} */(this
                            .childNodes //
                            .filter(( /**
                     * @param {?} node
                     * @return {?}
                     */function (node) { return node instanceof DebugElement__PRE_R3__; }))));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} eventName
                 * @param {?} eventObj
                 * @return {?}
                 */
                DebugElement__PRE_R3__.prototype.triggerEventHandler = function (eventName, eventObj) {
                    this.listeners.forEach(( /**
                     * @param {?} listener
                     * @return {?}
                     */function (listener) {
                        if (listener.name == eventName) {
                            listener.callback(eventObj);
                        }
                    }));
                };
                return DebugElement__PRE_R3__;
            }(DebugNode__PRE_R3__));
            if (false) { }
            /**
             * \@publicApi
             * @param {?} debugEls
             * @return {?}
             */
            function asNativeElements(debugEls) {
                return debugEls.map(( /**
                 * @param {?} el
                 * @return {?}
                 */function (el) { return el.nativeElement; }));
            }
            /**
             * @param {?} element
             * @param {?} predicate
             * @param {?} matches
             * @return {?}
             */
            function _queryElementChildren(element, predicate, matches) {
                element.childNodes.forEach(( /**
                 * @param {?} node
                 * @return {?}
                 */function (/**
                 * @param {?} node
                 * @return {?}
                 */ node) {
                    if (node instanceof DebugElement__PRE_R3__) {
                        if (predicate(node)) {
                            matches.push(node);
                        }
                        _queryElementChildren(node, predicate, matches);
                    }
                }));
            }
            /**
             * @param {?} parentNode
             * @param {?} predicate
             * @param {?} matches
             * @return {?}
             */
            function _queryNodeChildren(parentNode, predicate, matches) {
                if (parentNode instanceof DebugElement__PRE_R3__) {
                    parentNode.childNodes.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        if (predicate(node)) {
                            matches.push(node);
                        }
                        if (node instanceof DebugElement__PRE_R3__) {
                            _queryNodeChildren(node, predicate, matches);
                        }
                    }));
                }
            }
            var DebugNode__POST_R3__ = /** @class */ (function () {
                /**
                 * @param {?} nativeNode
                 */
                function DebugNode__POST_R3__(nativeNode) {
                    this.nativeNode = nativeNode;
                }
                Object.defineProperty(DebugNode__POST_R3__.prototype, "parent", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var parent = ( /** @type {?} */(this.nativeNode.parentNode));
                        return parent ? new DebugElement__POST_R3__(parent) : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__POST_R3__.prototype, "injector", {
                    /**
                     * @return {?}
                     */
                    get: function () { return getInjector(this.nativeNode); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__POST_R3__.prototype, "componentInstance", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var nativeElement = this.nativeNode;
                        return nativeElement &&
                            (getComponent(( /** @type {?} */(nativeElement))) || getViewComponent(nativeElement));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__POST_R3__.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return getComponent(( /** @type {?} */(this.nativeNode))) || getContext$1(( /** @type {?} */(this.nativeNode)));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__POST_R3__.prototype, "listeners", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return getListeners(( /** @type {?} */(this.nativeNode))).filter(isBrowserEvents);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__POST_R3__.prototype, "references", {
                    /**
                     * @return {?}
                     */
                    get: function () { return getLocalRefs(this.nativeNode); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugNode__POST_R3__.prototype, "providerTokens", {
                    /**
                     * @return {?}
                     */
                    get: function () { return getInjectionTokens(( /** @type {?} */(this.nativeNode))); },
                    enumerable: true,
                    configurable: true
                });
                return DebugNode__POST_R3__;
            }());
            if (false) { }
            var DebugElement__POST_R3__ = /** @class */ (function (_super_1) {
                __extends(DebugElement__POST_R3__, _super_1);
                /**
                 * @param {?} nativeNode
                 */
                function DebugElement__POST_R3__(nativeNode) {
                    var _this = this;
                    ngDevMode && assertDomNode(nativeNode);
                    _this = _super_1.call(this, nativeNode) || this;
                    return _this;
                }
                Object.defineProperty(DebugElement__POST_R3__.prototype, "nativeElement", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.nativeNode.nodeType == Node.ELEMENT_NODE ? ( /** @type {?} */(this.nativeNode)) : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "name", {
                    /**
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(this.nativeElement)).nodeName; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "properties", {
                    /**
                     *  Gets a map of property names to property values for an element.
                     *
                     *  This map includes:
                     *  - Regular property bindings (e.g. `[id]="id"`)
                     *  - Host property bindings (e.g. `host: { '[id]': "id" }`)
                     *  - Interpolated property bindings (e.g. `id="{{ value }}")
                     *
                     *  It does not include:
                     *  - input property bindings (e.g. `[myCustomInput]="value"`)
                     *  - attribute bindings (e.g. `[attr.role]="menu"`)
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var context = ( /** @type {?} */(loadLContext(this.nativeNode)));
                        /** @type {?} */
                        var lView = context.lView;
                        /** @type {?} */
                        var tData = lView[TVIEW].data;
                        /** @type {?} */
                        var tNode = ( /** @type {?} */(tData[context.nodeIndex]));
                        /** @type {?} */
                        var properties = collectPropertyBindings(tNode, lView, tData);
                        /** @type {?} */
                        var hostProperties = collectHostPropertyBindings(tNode, lView, tData);
                        /** @type {?} */
                        var className = collectClassNames(this);
                        /** @type {?} */
                        var output = Object.assign({}, properties, hostProperties);
                        if (className) {
                            output['className'] = output['className'] ? output['className'] + (" " + className) : className;
                        }
                        return output;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "attributes", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var attributes = {};
                        /** @type {?} */
                        var element = this.nativeElement;
                        if (!element) {
                            return attributes;
                        }
                        /** @type {?} */
                        var context = loadLContext(element);
                        /** @type {?} */
                        var lView = context.lView;
                        /** @type {?} */
                        var tNodeAttrs = (( /** @type {?} */(lView[TVIEW].data[context.nodeIndex]))).attrs;
                        /** @type {?} */
                        var lowercaseTNodeAttrs = [];
                        // For debug nodes we take the element's attribute directly from the DOM since it allows us
                        // to account for ones that weren't set via bindings (e.g. ViewEngine keeps track of the ones
                        // that are set through `Renderer2`). The problem is that the browser will lowercase all names,
                        // however since we have the attributes already on the TNode, we can preserve the case by going
                        // through them once, adding them to the `attributes` map and putting their lower-cased name
                        // into an array. Afterwards when we're going through the native DOM attributes, we can check
                        // whether we haven't run into an attribute already through the TNode.
                        if (tNodeAttrs) {
                            /** @type {?} */
                            var i = 0;
                            while (i < tNodeAttrs.length) {
                                /** @type {?} */
                                var attrName = tNodeAttrs[i];
                                // Stop as soon as we hit a marker. We only care about the regular attributes. Everything
                                // else will be handled below when we read the final attributes off the DOM.
                                if (typeof attrName !== 'string')
                                    break;
                                /** @type {?} */
                                var attrValue = tNodeAttrs[i + 1];
                                attributes[attrName] = ( /** @type {?} */(attrValue));
                                lowercaseTNodeAttrs.push(attrName.toLowerCase());
                                i += 2;
                            }
                        }
                        /** @type {?} */
                        var eAttrs = element.attributes;
                        for (var i = 0; i < eAttrs.length; i++) {
                            /** @type {?} */
                            var attr = eAttrs[i];
                            // Make sure that we don't assign the same attribute both in its
                            // case-sensitive form and the lower-cased one from the browser.
                            if (lowercaseTNodeAttrs.indexOf(attr.name) === -1) {
                                attributes[attr.name] = attr.value;
                            }
                        }
                        return attributes;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "styles", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return _getStylingDebugInfo(this.nativeElement, false);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "classes", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return _getStylingDebugInfo(this.nativeElement, true);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "childNodes", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var childNodes = this.nativeNode.childNodes;
                        /** @type {?} */
                        var children = [];
                        for (var i = 0; i < childNodes.length; i++) {
                            /** @type {?} */
                            var element = childNodes[i];
                            children.push(getDebugNode__POST_R3__(element));
                        }
                        return children;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugElement__POST_R3__.prototype, "children", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var nativeElement = this.nativeElement;
                        if (!nativeElement)
                            return [];
                        /** @type {?} */
                        var childNodes = nativeElement.children;
                        /** @type {?} */
                        var children = [];
                        for (var i = 0; i < childNodes.length; i++) {
                            /** @type {?} */
                            var element = childNodes[i];
                            children.push(getDebugNode__POST_R3__(element));
                        }
                        return children;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} predicate
                 * @return {?}
                 */
                DebugElement__POST_R3__.prototype.query = function (predicate) {
                    /** @type {?} */
                    var results = this.queryAll(predicate);
                    return results[0] || null;
                };
                /**
                 * @param {?} predicate
                 * @return {?}
                 */
                DebugElement__POST_R3__.prototype.queryAll = function (predicate) {
                    /** @type {?} */
                    var matches = [];
                    _queryAllR3(this, predicate, matches, true);
                    return matches;
                };
                /**
                 * @param {?} predicate
                 * @return {?}
                 */
                DebugElement__POST_R3__.prototype.queryAllNodes = function (predicate) {
                    /** @type {?} */
                    var matches = [];
                    _queryAllR3(this, predicate, matches, false);
                    return matches;
                };
                /**
                 * @param {?} eventName
                 * @param {?} eventObj
                 * @return {?}
                 */
                DebugElement__POST_R3__.prototype.triggerEventHandler = function (eventName, eventObj) {
                    this.listeners.forEach(( /**
                     * @param {?} listener
                     * @return {?}
                     */function (listener) {
                        if (listener.name === eventName) {
                            listener.callback(eventObj);
                        }
                    }));
                };
                return DebugElement__POST_R3__;
            }(DebugNode__POST_R3__));
            /**
             * @param {?} element
             * @param {?} isClassBased
             * @return {?}
             */
            function _getStylingDebugInfo(element, isClassBased) {
                if (element) {
                    /** @type {?} */
                    var context = loadLContextFromNode(element);
                    /** @type {?} */
                    var lView_10 = context.lView;
                    /** @type {?} */
                    var tData = lView_10[TVIEW].data;
                    /** @type {?} */
                    var tNode = ( /** @type {?} */(tData[context.nodeIndex]));
                    if (isClassBased) {
                        return isStylingContext(tNode.classes) ?
                            new NodeStylingDebug(( /** @type {?} */(tNode.classes)), lView_10, true).values :
                            stylingMapToStringMap(tNode.classes);
                    }
                    else {
                        return isStylingContext(tNode.styles) ?
                            new NodeStylingDebug(( /** @type {?} */(tNode.styles)), lView_10, false).values :
                            stylingMapToStringMap(tNode.styles);
                    }
                }
                return {};
            }
            /**
             * @param {?} parentElement
             * @param {?} predicate
             * @param {?} matches
             * @param {?} elementsOnly
             * @return {?}
             */
            function _queryAllR3(parentElement, predicate, matches, elementsOnly) {
                /** @type {?} */
                var context = ( /** @type {?} */(loadLContext(parentElement.nativeNode)));
                /** @type {?} */
                var parentTNode = ( /** @type {?} */(context.lView[TVIEW].data[context.nodeIndex]));
                _queryNodeChildrenR3(parentTNode, context.lView, predicate, matches, elementsOnly, parentElement.nativeNode);
            }
            /**
             * Recursively match the current TNode against the predicate, and goes on with the next ones.
             *
             * @param {?} tNode the current TNode
             * @param {?} lView the LView of this TNode
             * @param {?} predicate the predicate to match
             * @param {?} matches the list of positive matches
             * @param {?} elementsOnly whether only elements should be searched
             * @param {?} rootNativeNode the root native node on which predicate should not be matched
             * @return {?}
             */
            function _queryNodeChildrenR3(tNode, lView, predicate, matches, elementsOnly, rootNativeNode) {
                /** @type {?} */
                var nativeNode = getNativeByTNodeOrNull(tNode, lView);
                // For each type of TNode, specific logic is executed.
                if (tNode.type === 3 /* Element */ || tNode.type === 4 /* ElementContainer */) {
                    // Case 1: the TNode is an element
                    // The native node has to be checked.
                    _addQueryMatchR3(nativeNode, predicate, matches, elementsOnly, rootNativeNode);
                    if (isComponent(tNode)) {
                        // If the element is the host of a component, then all nodes in its view have to be processed.
                        // Note: the component's content (tNode.child) will be processed from the insertion points.
                        /** @type {?} */
                        var componentView = getComponentViewByIndex(tNode.index, lView);
                        if (componentView && componentView[TVIEW].firstChild) {
                            _queryNodeChildrenR3(( /** @type {?} */(componentView[TVIEW].firstChild)), componentView, predicate, matches, elementsOnly, rootNativeNode);
                        }
                    }
                    else {
                        if (tNode.child) {
                            // Otherwise, its children have to be processed.
                            _queryNodeChildrenR3(tNode.child, lView, predicate, matches, elementsOnly, rootNativeNode);
                        }
                        // We also have to query the DOM directly in order to catch elements inserted through
                        // Renderer2. Note that this is __not__ optimal, because we're walking similar trees multiple
                        // times. ViewEngine could do it more efficiently, because all the insertions go through
                        // Renderer2, however that's not the case in Ivy. This approach is being used because:
                        // 1. Matching the ViewEngine behavior would mean potentially introducing a depedency
                        //    from `Renderer2` to Ivy which could bring Ivy code into ViewEngine.
                        // 2. We would have to make `Renderer3` "know" about debug nodes.
                        // 3. It allows us to capture nodes that were inserted directly via the DOM.
                        nativeNode && _queryNativeNodeDescendants(nativeNode, predicate, matches, elementsOnly);
                    }
                    // In all cases, if a dynamic container exists for this node, each view inside it has to be
                    // processed.
                    /** @type {?} */
                    var nodeOrContainer = lView[tNode.index];
                    if (isLContainer(nodeOrContainer)) {
                        _queryNodeChildrenInContainerR3(nodeOrContainer, predicate, matches, elementsOnly, rootNativeNode);
                    }
                }
                else if (tNode.type === 0 /* Container */) {
                    // Case 2: the TNode is a container
                    // The native node has to be checked.
                    /** @type {?} */
                    var lContainer = lView[tNode.index];
                    _addQueryMatchR3(lContainer[NATIVE], predicate, matches, elementsOnly, rootNativeNode);
                    // Each view inside the container has to be processed.
                    _queryNodeChildrenInContainerR3(lContainer, predicate, matches, elementsOnly, rootNativeNode);
                }
                else if (tNode.type === 1 /* Projection */) {
                    // Case 3: the TNode is a projection insertion point (i.e. a <ng-content>).
                    // The nodes projected at this location all need to be processed.
                    /** @type {?} */
                    var componentView = findComponentView(( /** @type {?} */(lView)));
                    /** @type {?} */
                    var componentHost = ( /** @type {?} */(componentView[T_HOST]));
                    /** @type {?} */
                    var head = (( /** @type {?} */(componentHost.projection)))[( /** @type {?} */(tNode.projection))];
                    if (Array.isArray(head)) {
                        for (var _c = 0, head_1 = head; _c < head_1.length; _c++) {
                            var nativeNode_1 = head_1[_c];
                            _addQueryMatchR3(nativeNode_1, predicate, matches, elementsOnly, rootNativeNode);
                        }
                    }
                    else if (head) {
                        /** @type {?} */
                        var nextLView = ( /** @type {?} */(( /** @type {?} */(componentView[PARENT]))));
                        /** @type {?} */
                        var nextTNode = ( /** @type {?} */(nextLView[TVIEW].data[head.index]));
                        _queryNodeChildrenR3(nextTNode, nextLView, predicate, matches, elementsOnly, rootNativeNode);
                    }
                }
                else if (tNode.child) {
                    // Case 4: the TNode is a view.
                    _queryNodeChildrenR3(tNode.child, lView, predicate, matches, elementsOnly, rootNativeNode);
                }
                // We don't want to go to the next sibling of the root node.
                if (rootNativeNode !== nativeNode) {
                    // To determine the next node to be processed, we need to use the next or the projectionNext
                    // link, depending on whether the current node has been projected.
                    /** @type {?} */
                    var nextTNode = (tNode.flags & 2 /* isProjected */) ? tNode.projectionNext : tNode.next;
                    if (nextTNode) {
                        _queryNodeChildrenR3(nextTNode, lView, predicate, matches, elementsOnly, rootNativeNode);
                    }
                }
            }
            /**
             * Process all TNodes in a given container.
             *
             * @param {?} lContainer the container to be processed
             * @param {?} predicate the predicate to match
             * @param {?} matches the list of positive matches
             * @param {?} elementsOnly whether only elements should be searched
             * @param {?} rootNativeNode the root native node on which predicate should not be matched
             * @return {?}
             */
            function _queryNodeChildrenInContainerR3(lContainer, predicate, matches, elementsOnly, rootNativeNode) {
                for (var i = CONTAINER_HEADER_OFFSET; i < lContainer.length; i++) {
                    /** @type {?} */
                    var childView = lContainer[i];
                    _queryNodeChildrenR3(( /** @type {?} */(childView[TVIEW].node)), childView, predicate, matches, elementsOnly, rootNativeNode);
                }
            }
            /**
             * Match the current native node against the predicate.
             *
             * @param {?} nativeNode the current native node
             * @param {?} predicate the predicate to match
             * @param {?} matches the list of positive matches
             * @param {?} elementsOnly whether only elements should be searched
             * @param {?} rootNativeNode the root native node on which predicate should not be matched
             * @return {?}
             */
            function _addQueryMatchR3(nativeNode, predicate, matches, elementsOnly, rootNativeNode) {
                if (rootNativeNode !== nativeNode) {
                    /** @type {?} */
                    var debugNode = getDebugNode(nativeNode);
                    if (!debugNode) {
                        return;
                    }
                    // Type of the "predicate and "matches" array are set based on the value of
                    // the "elementsOnly" parameter. TypeScript is not able to properly infer these
                    // types with generics, so we manually cast the parameters accordingly.
                    if (elementsOnly && debugNode instanceof DebugElement__POST_R3__ && predicate(debugNode) &&
                        matches.indexOf(debugNode) === -1) {
                        matches.push(debugNode);
                    }
                    else if (!elementsOnly && (( /** @type {?} */(predicate)))(debugNode) &&
                        (( /** @type {?} */(matches))).indexOf(debugNode) === -1) {
                        (( /** @type {?} */(matches))).push(debugNode);
                    }
                }
            }
            /**
             * Match all the descendants of a DOM node against a predicate.
             *
             * @param {?} parentNode
             * @param {?} predicate the predicate to match
             * @param {?} matches the list of positive matches
             * @param {?} elementsOnly whether only elements should be searched
             * @return {?}
             */
            function _queryNativeNodeDescendants(parentNode, predicate, matches, elementsOnly) {
                /** @type {?} */
                var nodes = parentNode.childNodes;
                /** @type {?} */
                var length = nodes.length;
                for (var i = 0; i < length; i++) {
                    /** @type {?} */
                    var node = nodes[i];
                    /** @type {?} */
                    var debugNode = getDebugNode(node);
                    if (debugNode) {
                        if (elementsOnly && debugNode instanceof DebugElement__POST_R3__ && predicate(debugNode) &&
                            matches.indexOf(debugNode) === -1) {
                            matches.push(debugNode);
                        }
                        else if (!elementsOnly && (( /** @type {?} */(predicate)))(debugNode) &&
                            (( /** @type {?} */(matches))).indexOf(debugNode) === -1) {
                            (( /** @type {?} */(matches))).push(debugNode);
                        }
                        _queryNativeNodeDescendants(node, predicate, matches, elementsOnly);
                    }
                }
            }
            /**
             * Iterates through the property bindings for a given node and generates
             * a map of property names to values. This map only contains property bindings
             * defined in templates, not in host bindings.
             * @param {?} tNode
             * @param {?} lView
             * @param {?} tData
             * @return {?}
             */
            function collectPropertyBindings(tNode, lView, tData) {
                /** @type {?} */
                var properties = {};
                /** @type {?} */
                var bindingIndex = getFirstBindingIndex(tNode.propertyMetadataStartIndex, tData);
                while (bindingIndex < tNode.propertyMetadataEndIndex) {
                    /** @type {?} */
                    var value = void 0;
                    /** @type {?} */
                    var propMetadata = ( /** @type {?} */(tData[bindingIndex]));
                    while (!isPropMetadataString(propMetadata)) {
                        // This is the first value for an interpolation. We need to build up
                        // the full interpolation by combining runtime values in LView with
                        // the static interstitial values stored in TData.
                        value = (value || '') + renderStringify(lView[bindingIndex]) + tData[bindingIndex];
                        propMetadata = ( /** @type {?} */(tData[++bindingIndex]));
                    }
                    value = value === undefined ? lView[bindingIndex] : value += lView[bindingIndex];
                    // Property metadata string has 3 parts: property name, prefix, and suffix
                    /** @type {?} */
                    var metadataParts = propMetadata.split(INTERPOLATION_DELIMITER);
                    /** @type {?} */
                    var propertyName = metadataParts[0];
                    // Attr bindings don't have property names and should be skipped
                    if (propertyName) {
                        // Wrap value with prefix and suffix (will be '' for normal bindings), if they're defined.
                        // Avoid wrapping for normal bindings so that the value doesn't get cast to a string.
                        properties[propertyName] = (metadataParts[1] && metadataParts[2]) ?
                            metadataParts[1] + value + metadataParts[2] :
                            value;
                    }
                    bindingIndex++;
                }
                return properties;
            }
            /**
             * Retrieves the first binding index that holds values for this property
             * binding.
             *
             * For normal bindings (e.g. `[id]="id"`), the binding index is the
             * same as the metadata index. For interpolations (e.g. `id="{{id}}-{{name}}"`),
             * there can be multiple binding values, so we might have to loop backwards
             * from the metadata index until we find the first one.
             *
             * @param {?} metadataIndex The index of the first property metadata string for
             * this node.
             * @param {?} tData The data array for the current TView
             * @return {?} The first binding index for this binding
             */
            function getFirstBindingIndex(metadataIndex, tData) {
                /** @type {?} */
                var currentBindingIndex = metadataIndex - 1;
                // If the slot before the metadata holds a string, we know that this
                // metadata applies to an interpolation with at least 2 bindings, and
                // we need to search further to access the first binding value.
                /** @type {?} */
                var currentValue = tData[currentBindingIndex];
                // We need to iterate until we hit either a:
                // - TNode (it is an element slot marking the end of `consts` section), OR a
                // - metadata string (slot is attribute metadata or a previous node's property metadata)
                while (typeof currentValue === 'string' && !isPropMetadataString(currentValue)) {
                    currentValue = tData[--currentBindingIndex];
                }
                return currentBindingIndex + 1;
            }
            /**
             * @param {?} tNode
             * @param {?} lView
             * @param {?} tData
             * @return {?}
             */
            function collectHostPropertyBindings(tNode, lView, tData) {
                /** @type {?} */
                var properties = {};
                // Host binding values for a node are stored after directives on that node
                /** @type {?} */
                var hostPropIndex = tNode.directiveEnd;
                /** @type {?} */
                var propMetadata = ( /** @type {?} */(tData[hostPropIndex]));
                // When we reach a value in TView.data that is not a string, we know we've
                // hit the next node's providers and directives and should stop copying data.
                while (typeof propMetadata === 'string') {
                    /** @type {?} */
                    var propertyName = propMetadata.split(INTERPOLATION_DELIMITER)[0];
                    properties[propertyName] = lView[hostPropIndex];
                    propMetadata = tData[++hostPropIndex];
                }
                return properties;
            }
            /**
             * @param {?} debugElement
             * @return {?}
             */
            function collectClassNames(debugElement) {
                /** @type {?} */
                var classes = debugElement.classes;
                /** @type {?} */
                var output = '';
                for (var _c = 0, _d = Object.keys(classes); _c < _d.length; _c++) {
                    var className = _d[_c];
                    if (classes[className]) {
                        output = output ? output + (" " + className) : className;
                    }
                }
                return output;
            }
            // Need to keep the nodes in a global Map so that multiple angular apps are supported.
            /** @type {?} */
            var _nativeNodeToDebugNode = new Map();
            /**
             * @param {?} nativeNode
             * @return {?}
             */
            function getDebugNode__PRE_R3__(nativeNode) {
                return _nativeNodeToDebugNode.get(nativeNode) || null;
            }
            /** @type {?} */
            var NG_DEBUG_PROPERTY = '__ng_debug__';
            /**
             * @param {?} nativeNode
             * @return {?}
             */
            function getDebugNode__POST_R3__(nativeNode) {
                if (nativeNode instanceof Node) {
                    if (!(nativeNode.hasOwnProperty(NG_DEBUG_PROPERTY))) {
                        (( /** @type {?} */(nativeNode)))[NG_DEBUG_PROPERTY] = nativeNode.nodeType == Node.ELEMENT_NODE ?
                            new DebugElement__POST_R3__(( /** @type {?} */(nativeNode))) :
                            new DebugNode__POST_R3__(nativeNode);
                    }
                    return (( /** @type {?} */(nativeNode)))[NG_DEBUG_PROPERTY];
                }
                return null;
            }
            /**
             * \@publicApi
             * @type {?}
             */
            var getDebugNode = getDebugNode__PRE_R3__;
            /**
             * @return {?}
             */
            function getAllDebugNodes() {
                return Array.from(_nativeNodeToDebugNode.values());
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function indexDebugNode(node) {
                _nativeNodeToDebugNode.set(node.nativeNode, node);
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function removeDebugNodeFromIndex(node) {
                _nativeNodeToDebugNode.delete(node.nativeNode);
            }
            /**
             * A boolean-valued function over a value, possibly including context information
             * regarding that value's position in an array.
             *
             * \@publicApi
             * @record
             * @template T
             */
            function Predicate() { }
            /**
             * \@publicApi
             * @type {?}
             */
            var DebugNode$1 = DebugNode__PRE_R3__;
            /**
             * \@publicApi
             * @type {?}
             */
            var DebugElement = DebugElement__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _CORE_PLATFORM_PROVIDERS = [
                // Set a default platform name for platforms that don't set it explicitly.
                { provide: PLATFORM_ID, useValue: 'unknown' },
                { provide: PlatformRef, deps: [Injector] },
                { provide: TestabilityRegistry, deps: [] },
                { provide: Console, deps: [] },
            ];
            /**
             * This platform has to be included in any other platform
             *
             * \@publicApi
             * @type {?}
             */
            var platformCore = createPlatformFactory(null, 'core', _CORE_PLATFORM_PROVIDERS);
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @return {?}
             */
            function _iterableDiffersFactory() {
                return defaultIterableDiffers;
            }
            /**
             * @return {?}
             */
            function _keyValueDiffersFactory() {
                return defaultKeyValueDiffers;
            }
            /**
             * @param {?=} locale
             * @return {?}
             */
            function _localeFactory(locale) {
                if (locale) {
                    if (ivyEnabled) {
                        setLocaleId(locale);
                    }
                    return locale;
                }
                // Use `goog.LOCALE` as default value for `LOCALE_ID` token for Closure Compiler.
                // Note: default `goog.LOCALE` value is `en`, when Angular used `en-US`. In order to preserve
                // backwards compatibility, we use Angular default value over Closure Compiler's one.
                if (ngI18nClosureMode && typeof goog !== 'undefined' && goog.LOCALE !== 'en') {
                    if (ivyEnabled) {
                        setLocaleId(goog.LOCALE);
                    }
                    return goog.LOCALE;
                }
                return DEFAULT_LOCALE_ID;
            }
            /**
             * A built-in [dependency injection token](guide/glossary#di-token)
             * that is used to configure the root injector for bootstrapping.
             * @type {?}
             */
            var APPLICATION_MODULE_PROVIDERS = [
                {
                    provide: ApplicationRef,
                    useClass: ApplicationRef,
                    deps: [NgZone, Console, Injector, ErrorHandler, ComponentFactoryResolver, ApplicationInitStatus]
                },
                { provide: SCHEDULER, deps: [NgZone], useFactory: zoneSchedulerFactory },
                {
                    provide: ApplicationInitStatus,
                    useClass: ApplicationInitStatus,
                    deps: [[new Optional(), APP_INITIALIZER]]
                },
                { provide: Compiler, useClass: Compiler, deps: [] },
                APP_ID_RANDOM_PROVIDER,
                { provide: IterableDiffers, useFactory: _iterableDiffersFactory, deps: [] },
                { provide: KeyValueDiffers, useFactory: _keyValueDiffersFactory, deps: [] },
                {
                    provide: LOCALE_ID$1,
                    useFactory: _localeFactory,
                    deps: [[new Inject(LOCALE_ID$1), new Optional(), new SkipSelf()]]
                },
            ];
            /**
             * Schedule work at next available slot.
             *
             * In Ivy this is just `requestAnimationFrame`. For compatibility reasons when bootstrapped
             * using `platformRef.bootstrap` we need to use `NgZone.onStable` as the scheduling mechanism.
             * This overrides the scheduling mechanism in Ivy to `NgZone.onStable`.
             *
             * @param {?} ngZone NgZone to use for scheduling.
             * @return {?}
             */
            function zoneSchedulerFactory(ngZone) {
                /** @type {?} */
                var queue = [];
                ngZone.onStable.subscribe(( /**
                 * @return {?}
                 */function () {
                    while (queue.length) {
                        ( /** @type {?} */(queue.pop()))();
                    }
                }));
                return ( /**
                 * @param {?} fn
                 * @return {?}
                 */function (fn) { queue.push(fn); });
            }
            /**
             * Configures the root injector for an app with
             * providers of `\@angular/core` dependencies that `ApplicationRef` needs
             * to bootstrap components.
             *
             * Re-exported by `BrowserModule`, which is included automatically in the root
             * `AppModule` when you create a new app with the CLI `new` command.
             *
             * \@publicApi
             */
            var ApplicationModule = /** @class */ (function () {
                // Inject ApplicationRef to make it eager...
                /**
                 * @param {?} appRef
                 */
                function ApplicationModule(appRef) {
                }
                return ApplicationModule;
            }());
            ApplicationModule.decorators = [
                { type: NgModule, args: [{ providers: APPLICATION_MODULE_PROVIDERS },] }
            ];
            /** @nocollapse */
            ApplicationModule.ctorParameters = function () { return [
                { type: ApplicationRef }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} flags
             * @param {?} matchedQueriesDsl
             * @param {?} ngContentIndex
             * @param {?} childCount
             * @param {?=} handleEvent
             * @param {?=} templateFactory
             * @return {?}
             */
            function anchorDef(flags, matchedQueriesDsl, ngContentIndex, childCount, handleEvent, templateFactory) {
                flags |= 1 /* TypeElement */;
                var _c = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _c.matchedQueries, references = _c.references, matchedQueryIds = _c.matchedQueryIds;
                /** @type {?} */
                var template = templateFactory ? resolveDefinition(templateFactory) : null;
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    flags: flags,
                    checkIndex: -1,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
                    bindings: [],
                    bindingFlags: 0,
                    outputs: [],
                    element: {
                        ns: null,
                        name: null,
                        attrs: null, template: template,
                        componentProvider: null,
                        componentView: null,
                        componentRendererType: null,
                        publicProviders: null,
                        allProviders: null,
                        handleEvent: handleEvent || NOOP
                    },
                    provider: null,
                    text: null,
                    query: null,
                    ngContent: null
                };
            }
            /**
             * @param {?} checkIndex
             * @param {?} flags
             * @param {?} matchedQueriesDsl
             * @param {?} ngContentIndex
             * @param {?} childCount
             * @param {?} namespaceAndName
             * @param {?=} fixedAttrs
             * @param {?=} bindings
             * @param {?=} outputs
             * @param {?=} handleEvent
             * @param {?=} componentView
             * @param {?=} componentRendererType
             * @return {?}
             */
            function elementDef(checkIndex, flags, matchedQueriesDsl, ngContentIndex, childCount, namespaceAndName, fixedAttrs, bindings, outputs, handleEvent, componentView, componentRendererType) {
                var _c;
                if (fixedAttrs === void 0) { fixedAttrs = []; }
                if (!handleEvent) {
                    handleEvent = NOOP;
                }
                var _d = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _d.matchedQueries, references = _d.references, matchedQueryIds = _d.matchedQueryIds;
                /** @type {?} */
                var ns = ( /** @type {?} */(null));
                /** @type {?} */
                var name = ( /** @type {?} */(null));
                if (namespaceAndName) {
                    _c = splitNamespace(namespaceAndName), ns = _c[0], name = _c[1];
                }
                bindings = bindings || [];
                /** @type {?} */
                var bindingDefs = new Array(bindings.length);
                for (var i = 0; i < bindings.length; i++) {
                    var _e = bindings[i], bindingFlags = _e[0], namespaceAndName_1 = _e[1], suffixOrSecurityContext = _e[2];
                    var _f = splitNamespace(namespaceAndName_1), ns_1 = _f[0], name_1 = _f[1];
                    /** @type {?} */
                    var securityContext = ( /** @type {?} */(undefined));
                    /** @type {?} */
                    var suffix = ( /** @type {?} */(undefined));
                    switch (bindingFlags & 15 /* Types */) {
                        case 4 /* TypeElementStyle */:
                            suffix = ( /** @type {?} */(suffixOrSecurityContext));
                            break;
                        case 1 /* TypeElementAttribute */:
                        case 8 /* TypeProperty */:
                            securityContext = ( /** @type {?} */(suffixOrSecurityContext));
                            break;
                    }
                    bindingDefs[i] =
                        { flags: bindingFlags, ns: ns_1, name: name_1, nonMinifiedName: name_1, securityContext: securityContext, suffix: suffix };
                }
                outputs = outputs || [];
                /** @type {?} */
                var outputDefs = new Array(outputs.length);
                for (var i = 0; i < outputs.length; i++) {
                    var _g = outputs[i], target = _g[0], eventName = _g[1];
                    outputDefs[i] = {
                        type: 0 /* ElementOutput */,
                        target: ( /** @type {?} */(target)), eventName: eventName,
                        propName: null
                    };
                }
                fixedAttrs = fixedAttrs || [];
                /** @type {?} */
                var attrs = ( /** @type {?} */(fixedAttrs.map(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                    var namespaceAndName = _c[0], value = _c[1];
                    var _d = splitNamespace(namespaceAndName), ns = _d[0], name = _d[1];
                    return [ns, name, value];
                }))));
                componentRendererType = resolveRendererType2(componentRendererType);
                if (componentView) {
                    flags |= 33554432 /* ComponentView */;
                }
                flags |= 1 /* TypeElement */;
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    checkIndex: checkIndex,
                    flags: flags,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
                    bindings: bindingDefs,
                    bindingFlags: calcBindingFlags(bindingDefs),
                    outputs: outputDefs,
                    element: {
                        ns: ns,
                        name: name,
                        attrs: attrs,
                        template: null,
                        // will bet set by the view definition
                        componentProvider: null,
                        componentView: componentView || null,
                        componentRendererType: componentRendererType,
                        publicProviders: null,
                        allProviders: null,
                        handleEvent: handleEvent || NOOP,
                    },
                    provider: null,
                    text: null,
                    query: null,
                    ngContent: null
                };
            }
            /**
             * @param {?} view
             * @param {?} renderHost
             * @param {?} def
             * @return {?}
             */
            function createElement(view, renderHost, def) {
                /** @type {?} */
                var elDef = ( /** @type {?} */(def.element));
                /** @type {?} */
                var rootSelectorOrNode = view.root.selectorOrNode;
                /** @type {?} */
                var renderer = view.renderer;
                /** @type {?} */
                var el;
                if (view.parent || !rootSelectorOrNode) {
                    if (elDef.name) {
                        el = renderer.createElement(elDef.name, elDef.ns);
                    }
                    else {
                        el = renderer.createComment('');
                    }
                    /** @type {?} */
                    var parentEl = getParentRenderElement(view, renderHost, def);
                    if (parentEl) {
                        renderer.appendChild(parentEl, el);
                    }
                }
                else {
                    // when using native Shadow DOM, do not clear the root element contents to allow slot projection
                    /** @type {?} */
                    var preserveContent = (!!elDef.componentRendererType &&
                        elDef.componentRendererType.encapsulation === ViewEncapsulation.ShadowDom);
                    el = renderer.selectRootElement(rootSelectorOrNode, preserveContent);
                }
                if (elDef.attrs) {
                    for (var i = 0; i < elDef.attrs.length; i++) {
                        var _c = elDef.attrs[i], ns = _c[0], name = _c[1], value = _c[2];
                        renderer.setAttribute(el, name, value, ns);
                    }
                }
                return el;
            }
            /**
             * @param {?} view
             * @param {?} compView
             * @param {?} def
             * @param {?} el
             * @return {?}
             */
            function listenToElementOutputs(view, compView, def, el) {
                for (var i = 0; i < def.outputs.length; i++) {
                    /** @type {?} */
                    var output = def.outputs[i];
                    /** @type {?} */
                    var handleEventClosure = renderEventHandlerClosure(view, def.nodeIndex, elementEventFullName(output.target, output.eventName));
                    /** @type {?} */
                    var listenTarget = output.target;
                    /** @type {?} */
                    var listenerView = view;
                    if (output.target === 'component') {
                        listenTarget = null;
                        listenerView = compView;
                    }
                    /** @type {?} */
                    var disposable = ( /** @type {?} */(listenerView.renderer.listen(listenTarget || el, output.eventName, handleEventClosure)));
                    ( /** @type {?} */(view.disposables))[def.outputIndex + i] = disposable;
                }
            }
            /**
             * @param {?} view
             * @param {?} index
             * @param {?} eventName
             * @return {?}
             */
            function renderEventHandlerClosure(view, index, eventName) {
                return ( /**
                 * @param {?} event
                 * @return {?}
                 */function (event) { return dispatchEvent(view, index, eventName, event); });
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} v0
             * @param {?} v1
             * @param {?} v2
             * @param {?} v3
             * @param {?} v4
             * @param {?} v5
             * @param {?} v6
             * @param {?} v7
             * @param {?} v8
             * @param {?} v9
             * @return {?}
             */
            function checkAndUpdateElementInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var bindLen = def.bindings.length;
                /** @type {?} */
                var changed = false;
                if (bindLen > 0 && checkAndUpdateElementValue(view, def, 0, v0))
                    changed = true;
                if (bindLen > 1 && checkAndUpdateElementValue(view, def, 1, v1))
                    changed = true;
                if (bindLen > 2 && checkAndUpdateElementValue(view, def, 2, v2))
                    changed = true;
                if (bindLen > 3 && checkAndUpdateElementValue(view, def, 3, v3))
                    changed = true;
                if (bindLen > 4 && checkAndUpdateElementValue(view, def, 4, v4))
                    changed = true;
                if (bindLen > 5 && checkAndUpdateElementValue(view, def, 5, v5))
                    changed = true;
                if (bindLen > 6 && checkAndUpdateElementValue(view, def, 6, v6))
                    changed = true;
                if (bindLen > 7 && checkAndUpdateElementValue(view, def, 7, v7))
                    changed = true;
                if (bindLen > 8 && checkAndUpdateElementValue(view, def, 8, v8))
                    changed = true;
                if (bindLen > 9 && checkAndUpdateElementValue(view, def, 9, v9))
                    changed = true;
                return changed;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} values
             * @return {?}
             */
            function checkAndUpdateElementDynamic(view, def, values) {
                /** @type {?} */
                var changed = false;
                for (var i = 0; i < values.length; i++) {
                    if (checkAndUpdateElementValue(view, def, i, values[i]))
                        changed = true;
                }
                return changed;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} bindingIdx
             * @param {?} value
             * @return {?}
             */
            function checkAndUpdateElementValue(view, def, bindingIdx, value) {
                if (!checkAndUpdateBinding(view, def, bindingIdx, value)) {
                    return false;
                }
                /** @type {?} */
                var binding = def.bindings[bindingIdx];
                /** @type {?} */
                var elData = asElementData(view, def.nodeIndex);
                /** @type {?} */
                var renderNode = elData.renderElement;
                /** @type {?} */
                var name = ( /** @type {?} */(binding.name));
                switch (binding.flags & 15 /* Types */) {
                    case 1 /* TypeElementAttribute */:
                        setElementAttribute(view, binding, renderNode, binding.ns, name, value);
                        break;
                    case 2 /* TypeElementClass */:
                        setElementClass(view, renderNode, name, value);
                        break;
                    case 4 /* TypeElementStyle */:
                        setElementStyle(view, binding, renderNode, name, value);
                        break;
                    case 8 /* TypeProperty */:
                        /** @type {?} */
                        var bindView = (def.flags & 33554432 /* ComponentView */ &&
                            binding.flags & 32 /* SyntheticHostProperty */) ?
                            elData.componentView :
                            view;
                        setElementProperty(bindView, binding, renderNode, name, value);
                        break;
                }
                return true;
            }
            /**
             * @param {?} view
             * @param {?} binding
             * @param {?} renderNode
             * @param {?} ns
             * @param {?} name
             * @param {?} value
             * @return {?}
             */
            function setElementAttribute(view, binding, renderNode, ns, name, value) {
                /** @type {?} */
                var securityContext = binding.securityContext;
                /** @type {?} */
                var renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
                renderValue = renderValue != null ? renderValue.toString() : null;
                /** @type {?} */
                var renderer = view.renderer;
                if (value != null) {
                    renderer.setAttribute(renderNode, name, renderValue, ns);
                }
                else {
                    renderer.removeAttribute(renderNode, name, ns);
                }
            }
            /**
             * @param {?} view
             * @param {?} renderNode
             * @param {?} name
             * @param {?} value
             * @return {?}
             */
            function setElementClass(view, renderNode, name, value) {
                /** @type {?} */
                var renderer = view.renderer;
                if (value) {
                    renderer.addClass(renderNode, name);
                }
                else {
                    renderer.removeClass(renderNode, name);
                }
            }
            /**
             * @param {?} view
             * @param {?} binding
             * @param {?} renderNode
             * @param {?} name
             * @param {?} value
             * @return {?}
             */
            function setElementStyle(view, binding, renderNode, name, value) {
                /** @type {?} */
                var renderValue = view.root.sanitizer.sanitize(SecurityContext.STYLE, ( /** @type {?} */(value)));
                if (renderValue != null) {
                    renderValue = renderValue.toString();
                    /** @type {?} */
                    var unit = binding.suffix;
                    if (unit != null) {
                        renderValue = renderValue + unit;
                    }
                }
                else {
                    renderValue = null;
                }
                /** @type {?} */
                var renderer = view.renderer;
                if (renderValue != null) {
                    renderer.setStyle(renderNode, name, renderValue);
                }
                else {
                    renderer.removeStyle(renderNode, name);
                }
            }
            /**
             * @param {?} view
             * @param {?} binding
             * @param {?} renderNode
             * @param {?} name
             * @param {?} value
             * @return {?}
             */
            function setElementProperty(view, binding, renderNode, name, value) {
                /** @type {?} */
                var securityContext = binding.securityContext;
                /** @type {?} */
                var renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
                view.renderer.setProperty(renderNode, name, renderValue);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} flags
             * @param {?} id
             * @param {?} bindings
             * @return {?}
             */
            function queryDef(flags, id, bindings) {
                /** @type {?} */
                var bindingDefs = [];
                for (var propName in bindings) {
                    /** @type {?} */
                    var bindingType = bindings[propName];
                    bindingDefs.push({ propName: propName, bindingType: bindingType });
                }
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    // TODO(vicb): check
                    checkIndex: -1, flags: flags,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0,
                    ngContentIndex: -1,
                    matchedQueries: {},
                    matchedQueryIds: 0,
                    references: {},
                    childCount: 0,
                    bindings: [],
                    bindingFlags: 0,
                    outputs: [],
                    element: null,
                    provider: null,
                    text: null,
                    query: { id: id, filterId: filterQueryId(id), bindings: bindingDefs },
                    ngContent: null
                };
            }
            /**
             * @return {?}
             */
            function createQuery() {
                return new QueryList();
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function dirtyParentQueries(view) {
                /** @type {?} */
                var queryIds = view.def.nodeMatchedQueries;
                while (view.parent && isEmbeddedView(view)) {
                    /** @type {?} */
                    var tplDef = ( /** @type {?} */(view.parentNodeDef));
                    view = view.parent;
                    // content queries
                    /** @type {?} */
                    var end = tplDef.nodeIndex + tplDef.childCount;
                    for (var i = 0; i <= end; i++) {
                        /** @type {?} */
                        var nodeDef = view.def.nodes[i];
                        if ((nodeDef.flags & 67108864 /* TypeContentQuery */) &&
                            (nodeDef.flags & 536870912 /* DynamicQuery */) &&
                            (( /** @type {?} */(nodeDef.query)).filterId & queryIds) === ( /** @type {?} */(nodeDef.query)).filterId) {
                            asQueryList(view, i).setDirty();
                        }
                        if ((nodeDef.flags & 1 /* TypeElement */ && i + nodeDef.childCount < tplDef.nodeIndex) ||
                            !(nodeDef.childFlags & 67108864 /* TypeContentQuery */) ||
                            !(nodeDef.childFlags & 536870912 /* DynamicQuery */)) {
                            // skip elements that don't contain the template element or no query.
                            i += nodeDef.childCount;
                        }
                    }
                }
                // view queries
                if (view.def.nodeFlags & 134217728 /* TypeViewQuery */) {
                    for (var i = 0; i < view.def.nodes.length; i++) {
                        /** @type {?} */
                        var nodeDef = view.def.nodes[i];
                        if ((nodeDef.flags & 134217728 /* TypeViewQuery */) && (nodeDef.flags & 536870912 /* DynamicQuery */)) {
                            asQueryList(view, i).setDirty();
                        }
                        // only visit the root nodes
                        i += nodeDef.childCount;
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @return {?}
             */
            function checkAndUpdateQuery(view, nodeDef) {
                /** @type {?} */
                var queryList = asQueryList(view, nodeDef.nodeIndex);
                if (!queryList.dirty) {
                    return;
                }
                /** @type {?} */
                var directiveInstance;
                /** @type {?} */
                var newValues = ( /** @type {?} */(undefined));
                if (nodeDef.flags & 67108864 /* TypeContentQuery */) {
                    /** @type {?} */
                    var elementDef_1 = ( /** @type {?} */(( /** @type {?} */(nodeDef.parent)).parent));
                    newValues = calcQueryValues(view, elementDef_1.nodeIndex, elementDef_1.nodeIndex + elementDef_1.childCount, ( /** @type {?} */(nodeDef.query)), []);
                    directiveInstance = asProviderData(view, ( /** @type {?} */(nodeDef.parent)).nodeIndex).instance;
                }
                else if (nodeDef.flags & 134217728 /* TypeViewQuery */) {
                    newValues = calcQueryValues(view, 0, view.def.nodes.length - 1, ( /** @type {?} */(nodeDef.query)), []);
                    directiveInstance = view.component;
                }
                queryList.reset(newValues);
                /** @type {?} */
                var bindings = ( /** @type {?} */(nodeDef.query)).bindings;
                /** @type {?} */
                var notify = false;
                for (var i = 0; i < bindings.length; i++) {
                    /** @type {?} */
                    var binding = bindings[i];
                    /** @type {?} */
                    var boundValue = void 0;
                    switch (binding.bindingType) {
                        case 0 /* First */:
                            boundValue = queryList.first;
                            break;
                        case 1 /* All */:
                            boundValue = queryList;
                            notify = true;
                            break;
                    }
                    directiveInstance[binding.propName] = boundValue;
                }
                if (notify) {
                    queryList.notifyOnChanges();
                }
            }
            /**
             * @param {?} view
             * @param {?} startIndex
             * @param {?} endIndex
             * @param {?} queryDef
             * @param {?} values
             * @return {?}
             */
            function calcQueryValues(view, startIndex, endIndex, queryDef, values) {
                for (var i = startIndex; i <= endIndex; i++) {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[i];
                    /** @type {?} */
                    var valueType = nodeDef.matchedQueries[queryDef.id];
                    if (valueType != null) {
                        values.push(getQueryValue(view, nodeDef, valueType));
                    }
                    if (nodeDef.flags & 1 /* TypeElement */ && ( /** @type {?} */(nodeDef.element)).template &&
                        (( /** @type {?} */(( /** @type {?} */(nodeDef.element)).template)).nodeMatchedQueries & queryDef.filterId) ===
                            queryDef.filterId) {
                        /** @type {?} */
                        var elementData = asElementData(view, i);
                        // check embedded views that were attached at the place of their template,
                        // but process child nodes first if some match the query (see issue #16568)
                        if ((nodeDef.childMatchedQueries & queryDef.filterId) === queryDef.filterId) {
                            calcQueryValues(view, i + 1, i + nodeDef.childCount, queryDef, values);
                            i += nodeDef.childCount;
                        }
                        if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
                            /** @type {?} */
                            var embeddedViews = ( /** @type {?} */(elementData.viewContainer))._embeddedViews;
                            for (var k = 0; k < embeddedViews.length; k++) {
                                /** @type {?} */
                                var embeddedView = embeddedViews[k];
                                /** @type {?} */
                                var dvc = declaredViewContainer(embeddedView);
                                if (dvc && dvc === elementData) {
                                    calcQueryValues(embeddedView, 0, embeddedView.def.nodes.length - 1, queryDef, values);
                                }
                            }
                        }
                        /** @type {?} */
                        var projectedViews = elementData.template._projectedViews;
                        if (projectedViews) {
                            for (var k = 0; k < projectedViews.length; k++) {
                                /** @type {?} */
                                var projectedView = projectedViews[k];
                                calcQueryValues(projectedView, 0, projectedView.def.nodes.length - 1, queryDef, values);
                            }
                        }
                    }
                    if ((nodeDef.childMatchedQueries & queryDef.filterId) !== queryDef.filterId) {
                        // if no child matches the query, skip the children.
                        i += nodeDef.childCount;
                    }
                }
                return values;
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} queryValueType
             * @return {?}
             */
            function getQueryValue(view, nodeDef, queryValueType) {
                if (queryValueType != null) {
                    // a match
                    switch (queryValueType) {
                        case 1 /* RenderElement */:
                            return asElementData(view, nodeDef.nodeIndex).renderElement;
                        case 0 /* ElementRef */:
                            return new ElementRef(asElementData(view, nodeDef.nodeIndex).renderElement);
                        case 2 /* TemplateRef */:
                            return asElementData(view, nodeDef.nodeIndex).template;
                        case 3 /* ViewContainerRef */:
                            return asElementData(view, nodeDef.nodeIndex).viewContainer;
                        case 4 /* Provider */:
                            return asProviderData(view, nodeDef.nodeIndex).instance;
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} ngContentIndex
             * @param {?} index
             * @return {?}
             */
            function ngContentDef(ngContentIndex, index) {
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    checkIndex: -1,
                    flags: 8 /* TypeNgContent */,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0,
                    matchedQueries: {},
                    matchedQueryIds: 0,
                    references: {}, ngContentIndex: ngContentIndex,
                    childCount: 0,
                    bindings: [],
                    bindingFlags: 0,
                    outputs: [],
                    element: null,
                    provider: null,
                    text: null,
                    query: null,
                    ngContent: { index: index }
                };
            }
            /**
             * @param {?} view
             * @param {?} renderHost
             * @param {?} def
             * @return {?}
             */
            function appendNgContent(view, renderHost, def) {
                /** @type {?} */
                var parentEl = getParentRenderElement(view, renderHost, def);
                if (!parentEl) {
                    // Nothing to do if there is no parent element.
                    return;
                }
                /** @type {?} */
                var ngContentIndex = ( /** @type {?} */(def.ngContent)).index;
                visitProjectedRenderNodes(view, ngContentIndex, 1 /* AppendChild */, parentEl, null, undefined);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} checkIndex
             * @param {?} argCount
             * @return {?}
             */
            function purePipeDef(checkIndex, argCount) {
                // argCount + 1 to include the pipe as first arg
                return _pureExpressionDef(128 /* TypePurePipe */, checkIndex, new Array(argCount + 1));
            }
            /**
             * @param {?} checkIndex
             * @param {?} argCount
             * @return {?}
             */
            function pureArrayDef(checkIndex, argCount) {
                return _pureExpressionDef(32 /* TypePureArray */, checkIndex, new Array(argCount));
            }
            /**
             * @param {?} checkIndex
             * @param {?} propToIndex
             * @return {?}
             */
            function pureObjectDef(checkIndex, propToIndex) {
                /** @type {?} */
                var keys = Object.keys(propToIndex);
                /** @type {?} */
                var nbKeys = keys.length;
                /** @type {?} */
                var propertyNames = new Array(nbKeys);
                for (var i = 0; i < nbKeys; i++) {
                    /** @type {?} */
                    var key = keys[i];
                    /** @type {?} */
                    var index = propToIndex[key];
                    propertyNames[index] = key;
                }
                return _pureExpressionDef(64 /* TypePureObject */, checkIndex, propertyNames);
            }
            /**
             * @param {?} flags
             * @param {?} checkIndex
             * @param {?} propertyNames
             * @return {?}
             */
            function _pureExpressionDef(flags, checkIndex, propertyNames) {
                /** @type {?} */
                var bindings = new Array(propertyNames.length);
                for (var i = 0; i < propertyNames.length; i++) {
                    /** @type {?} */
                    var prop = propertyNames[i];
                    bindings[i] = {
                        flags: 8 /* TypeProperty */,
                        name: prop,
                        ns: null,
                        nonMinifiedName: prop,
                        securityContext: null,
                        suffix: null
                    };
                }
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    checkIndex: checkIndex,
                    flags: flags,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0,
                    matchedQueries: {},
                    matchedQueryIds: 0,
                    references: {},
                    ngContentIndex: -1,
                    childCount: 0, bindings: bindings,
                    bindingFlags: calcBindingFlags(bindings),
                    outputs: [],
                    element: null,
                    provider: null,
                    text: null,
                    query: null,
                    ngContent: null
                };
            }
            /**
             * @param {?} view
             * @param {?} def
             * @return {?}
             */
            function createPureExpression(view, def) {
                return { value: undefined };
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} v0
             * @param {?} v1
             * @param {?} v2
             * @param {?} v3
             * @param {?} v4
             * @param {?} v5
             * @param {?} v6
             * @param {?} v7
             * @param {?} v8
             * @param {?} v9
             * @return {?}
             */
            function checkAndUpdatePureExpressionInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var bindings = def.bindings;
                /** @type {?} */
                var changed = false;
                /** @type {?} */
                var bindLen = bindings.length;
                if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
                    changed = true;
                if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
                    changed = true;
                if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
                    changed = true;
                if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
                    changed = true;
                if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
                    changed = true;
                if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
                    changed = true;
                if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
                    changed = true;
                if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
                    changed = true;
                if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
                    changed = true;
                if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
                    changed = true;
                if (changed) {
                    /** @type {?} */
                    var data = asPureExpressionData(view, def.nodeIndex);
                    /** @type {?} */
                    var value = void 0;
                    switch (def.flags & 201347067 /* Types */) {
                        case 32 /* TypePureArray */:
                            value = new Array(bindings.length);
                            if (bindLen > 0)
                                value[0] = v0;
                            if (bindLen > 1)
                                value[1] = v1;
                            if (bindLen > 2)
                                value[2] = v2;
                            if (bindLen > 3)
                                value[3] = v3;
                            if (bindLen > 4)
                                value[4] = v4;
                            if (bindLen > 5)
                                value[5] = v5;
                            if (bindLen > 6)
                                value[6] = v6;
                            if (bindLen > 7)
                                value[7] = v7;
                            if (bindLen > 8)
                                value[8] = v8;
                            if (bindLen > 9)
                                value[9] = v9;
                            break;
                        case 64 /* TypePureObject */:
                            value = {};
                            if (bindLen > 0)
                                value[( /** @type {?} */(bindings[0].name))] = v0;
                            if (bindLen > 1)
                                value[( /** @type {?} */(bindings[1].name))] = v1;
                            if (bindLen > 2)
                                value[( /** @type {?} */(bindings[2].name))] = v2;
                            if (bindLen > 3)
                                value[( /** @type {?} */(bindings[3].name))] = v3;
                            if (bindLen > 4)
                                value[( /** @type {?} */(bindings[4].name))] = v4;
                            if (bindLen > 5)
                                value[( /** @type {?} */(bindings[5].name))] = v5;
                            if (bindLen > 6)
                                value[( /** @type {?} */(bindings[6].name))] = v6;
                            if (bindLen > 7)
                                value[( /** @type {?} */(bindings[7].name))] = v7;
                            if (bindLen > 8)
                                value[( /** @type {?} */(bindings[8].name))] = v8;
                            if (bindLen > 9)
                                value[( /** @type {?} */(bindings[9].name))] = v9;
                            break;
                        case 128 /* TypePurePipe */:
                            /** @type {?} */
                            var pipe = v0;
                            switch (bindLen) {
                                case 1:
                                    value = pipe.transform(v0);
                                    break;
                                case 2:
                                    value = pipe.transform(v1);
                                    break;
                                case 3:
                                    value = pipe.transform(v1, v2);
                                    break;
                                case 4:
                                    value = pipe.transform(v1, v2, v3);
                                    break;
                                case 5:
                                    value = pipe.transform(v1, v2, v3, v4);
                                    break;
                                case 6:
                                    value = pipe.transform(v1, v2, v3, v4, v5);
                                    break;
                                case 7:
                                    value = pipe.transform(v1, v2, v3, v4, v5, v6);
                                    break;
                                case 8:
                                    value = pipe.transform(v1, v2, v3, v4, v5, v6, v7);
                                    break;
                                case 9:
                                    value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8);
                                    break;
                                case 10:
                                    value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8, v9);
                                    break;
                            }
                            break;
                    }
                    data.value = value;
                }
                return changed;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} values
             * @return {?}
             */
            function checkAndUpdatePureExpressionDynamic(view, def, values) {
                /** @type {?} */
                var bindings = def.bindings;
                /** @type {?} */
                var changed = false;
                for (var i = 0; i < values.length; i++) {
                    // Note: We need to loop over all values, so that
                    // the old values are updates as well!
                    if (checkAndUpdateBinding(view, def, i, values[i])) {
                        changed = true;
                    }
                }
                if (changed) {
                    /** @type {?} */
                    var data = asPureExpressionData(view, def.nodeIndex);
                    /** @type {?} */
                    var value = void 0;
                    switch (def.flags & 201347067 /* Types */) {
                        case 32 /* TypePureArray */:
                            value = values;
                            break;
                        case 64 /* TypePureObject */:
                            value = {};
                            for (var i = 0; i < values.length; i++) {
                                value[( /** @type {?} */(bindings[i].name))] = values[i];
                            }
                            break;
                        case 128 /* TypePurePipe */:
                            /** @type {?} */
                            var pipe = values[0];
                            /** @type {?} */
                            var params = values.slice(1);
                            value = pipe.transform.apply(pipe, params);
                            break;
                    }
                    data.value = value;
                }
                return changed;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} checkIndex
             * @param {?} ngContentIndex
             * @param {?} staticText
             * @return {?}
             */
            function textDef(checkIndex, ngContentIndex, staticText) {
                /** @type {?} */
                var bindings = new Array(staticText.length - 1);
                for (var i = 1; i < staticText.length; i++) {
                    bindings[i - 1] = {
                        flags: 8 /* TypeProperty */,
                        name: null,
                        ns: null,
                        nonMinifiedName: null,
                        securityContext: null,
                        suffix: staticText[i],
                    };
                }
                return {
                    // will bet set by the view definition
                    nodeIndex: -1,
                    parent: null,
                    renderParent: null,
                    bindingIndex: -1,
                    outputIndex: -1,
                    // regular values
                    checkIndex: checkIndex,
                    flags: 2 /* TypeText */,
                    childFlags: 0,
                    directChildFlags: 0,
                    childMatchedQueries: 0,
                    matchedQueries: {},
                    matchedQueryIds: 0,
                    references: {}, ngContentIndex: ngContentIndex,
                    childCount: 0, bindings: bindings,
                    bindingFlags: 8 /* TypeProperty */,
                    outputs: [],
                    element: null,
                    provider: null,
                    text: { prefix: staticText[0] },
                    query: null,
                    ngContent: null,
                };
            }
            /**
             * @param {?} view
             * @param {?} renderHost
             * @param {?} def
             * @return {?}
             */
            function createText(view, renderHost, def) {
                /** @type {?} */
                var renderNode;
                /** @type {?} */
                var renderer = view.renderer;
                renderNode = renderer.createText(( /** @type {?} */(def.text)).prefix);
                /** @type {?} */
                var parentEl = getParentRenderElement(view, renderHost, def);
                if (parentEl) {
                    renderer.appendChild(parentEl, renderNode);
                }
                return { renderText: renderNode };
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} v0
             * @param {?} v1
             * @param {?} v2
             * @param {?} v3
             * @param {?} v4
             * @param {?} v5
             * @param {?} v6
             * @param {?} v7
             * @param {?} v8
             * @param {?} v9
             * @return {?}
             */
            function checkAndUpdateTextInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var changed = false;
                /** @type {?} */
                var bindings = def.bindings;
                /** @type {?} */
                var bindLen = bindings.length;
                if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
                    changed = true;
                if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
                    changed = true;
                if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
                    changed = true;
                if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
                    changed = true;
                if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
                    changed = true;
                if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
                    changed = true;
                if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
                    changed = true;
                if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
                    changed = true;
                if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
                    changed = true;
                if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
                    changed = true;
                if (changed) {
                    /** @type {?} */
                    var value = ( /** @type {?} */(def.text)).prefix;
                    if (bindLen > 0)
                        value += _addInterpolationPart(v0, bindings[0]);
                    if (bindLen > 1)
                        value += _addInterpolationPart(v1, bindings[1]);
                    if (bindLen > 2)
                        value += _addInterpolationPart(v2, bindings[2]);
                    if (bindLen > 3)
                        value += _addInterpolationPart(v3, bindings[3]);
                    if (bindLen > 4)
                        value += _addInterpolationPart(v4, bindings[4]);
                    if (bindLen > 5)
                        value += _addInterpolationPart(v5, bindings[5]);
                    if (bindLen > 6)
                        value += _addInterpolationPart(v6, bindings[6]);
                    if (bindLen > 7)
                        value += _addInterpolationPart(v7, bindings[7]);
                    if (bindLen > 8)
                        value += _addInterpolationPart(v8, bindings[8]);
                    if (bindLen > 9)
                        value += _addInterpolationPart(v9, bindings[9]);
                    /** @type {?} */
                    var renderNode_1 = asTextData(view, def.nodeIndex).renderText;
                    view.renderer.setValue(renderNode_1, value);
                }
                return changed;
            }
            /**
             * @param {?} view
             * @param {?} def
             * @param {?} values
             * @return {?}
             */
            function checkAndUpdateTextDynamic(view, def, values) {
                /** @type {?} */
                var bindings = def.bindings;
                /** @type {?} */
                var changed = false;
                for (var i = 0; i < values.length; i++) {
                    // Note: We need to loop over all values, so that
                    // the old values are updates as well!
                    if (checkAndUpdateBinding(view, def, i, values[i])) {
                        changed = true;
                    }
                }
                if (changed) {
                    /** @type {?} */
                    var value = '';
                    for (var i = 0; i < values.length; i++) {
                        value = value + _addInterpolationPart(values[i], bindings[i]);
                    }
                    value = ( /** @type {?} */(def.text)).prefix + value;
                    /** @type {?} */
                    var renderNode_2 = asTextData(view, def.nodeIndex).renderText;
                    view.renderer.setValue(renderNode_2, value);
                }
                return changed;
            }
            /**
             * @param {?} value
             * @param {?} binding
             * @return {?}
             */
            function _addInterpolationPart(value, binding) {
                /** @type {?} */
                var valueStr = value != null ? value.toString() : '';
                return valueStr + binding.suffix;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} flags
             * @param {?} nodes
             * @param {?=} updateDirectives
             * @param {?=} updateRenderer
             * @return {?}
             */
            function viewDef(flags, nodes, updateDirectives, updateRenderer) {
                // clone nodes and set auto calculated values
                /** @type {?} */
                var viewBindingCount = 0;
                /** @type {?} */
                var viewDisposableCount = 0;
                /** @type {?} */
                var viewNodeFlags = 0;
                /** @type {?} */
                var viewRootNodeFlags = 0;
                /** @type {?} */
                var viewMatchedQueries = 0;
                /** @type {?} */
                var currentParent = null;
                /** @type {?} */
                var currentRenderParent = null;
                /** @type {?} */
                var currentElementHasPublicProviders = false;
                /** @type {?} */
                var currentElementHasPrivateProviders = false;
                /** @type {?} */
                var lastRenderRootNode = null;
                for (var i = 0; i < nodes.length; i++) {
                    /** @type {?} */
                    var node = nodes[i];
                    node.nodeIndex = i;
                    node.parent = currentParent;
                    node.bindingIndex = viewBindingCount;
                    node.outputIndex = viewDisposableCount;
                    node.renderParent = currentRenderParent;
                    viewNodeFlags |= node.flags;
                    viewMatchedQueries |= node.matchedQueryIds;
                    if (node.element) {
                        /** @type {?} */
                        var elDef = node.element;
                        elDef.publicProviders =
                            currentParent ? ( /** @type {?} */(currentParent.element)).publicProviders : Object.create(null);
                        elDef.allProviders = elDef.publicProviders;
                        // Note: We assume that all providers of an element are before any child element!
                        currentElementHasPublicProviders = false;
                        currentElementHasPrivateProviders = false;
                        if (node.element.template) {
                            viewMatchedQueries |= node.element.template.nodeMatchedQueries;
                        }
                    }
                    validateNode(currentParent, node, nodes.length);
                    viewBindingCount += node.bindings.length;
                    viewDisposableCount += node.outputs.length;
                    if (!currentRenderParent && (node.flags & 3 /* CatRenderNode */)) {
                        lastRenderRootNode = node;
                    }
                    if (node.flags & 20224 /* CatProvider */) {
                        if (!currentElementHasPublicProviders) {
                            currentElementHasPublicProviders = true;
                            // Use prototypical inheritance to not get O(n^2) complexity...
                            ( /** @type {?} */(( /** @type {?} */(currentParent)).element)).publicProviders =
                                Object.create(( /** @type {?} */(( /** @type {?} */(currentParent)).element)).publicProviders);
                            ( /** @type {?} */(( /** @type {?} */(currentParent)).element)).allProviders = ( /** @type {?} */(( /** @type {?} */(currentParent)).element)).publicProviders;
                        }
                        /** @type {?} */
                        var isPrivateService = (node.flags & 8192 /* PrivateProvider */) !== 0;
                        /** @type {?} */
                        var isComponent_3 = (node.flags & 32768 /* Component */) !== 0;
                        if (!isPrivateService || isComponent_3) {
                            ( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(currentParent)).element)).publicProviders))[tokenKey(( /** @type {?} */(node.provider)).token)] = node;
                        }
                        else {
                            if (!currentElementHasPrivateProviders) {
                                currentElementHasPrivateProviders = true;
                                // Use prototypical inheritance to not get O(n^2) complexity...
                                ( /** @type {?} */(( /** @type {?} */(currentParent)).element)).allProviders =
                                    Object.create(( /** @type {?} */(( /** @type {?} */(currentParent)).element)).publicProviders);
                            }
                            ( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(currentParent)).element)).allProviders))[tokenKey(( /** @type {?} */(node.provider)).token)] = node;
                        }
                        if (isComponent_3) {
                            ( /** @type {?} */(( /** @type {?} */(currentParent)).element)).componentProvider = node;
                        }
                    }
                    if (currentParent) {
                        currentParent.childFlags |= node.flags;
                        currentParent.directChildFlags |= node.flags;
                        currentParent.childMatchedQueries |= node.matchedQueryIds;
                        if (node.element && node.element.template) {
                            currentParent.childMatchedQueries |= node.element.template.nodeMatchedQueries;
                        }
                    }
                    else {
                        viewRootNodeFlags |= node.flags;
                    }
                    if (node.childCount > 0) {
                        currentParent = node;
                        if (!isNgContainer(node)) {
                            currentRenderParent = node;
                        }
                    }
                    else {
                        // When the current node has no children, check if it is the last children of its parent.
                        // When it is, propagate the flags up.
                        // The loop is required because an element could be the last transitive children of several
                        // elements. We loop to either the root or the highest opened element (= with remaining
                        // children)
                        while (currentParent && i === currentParent.nodeIndex + currentParent.childCount) {
                            /** @type {?} */
                            var newParent = currentParent.parent;
                            if (newParent) {
                                newParent.childFlags |= currentParent.childFlags;
                                newParent.childMatchedQueries |= currentParent.childMatchedQueries;
                            }
                            currentParent = newParent;
                            // We also need to update the render parent & account for ng-container
                            if (currentParent && isNgContainer(currentParent)) {
                                currentRenderParent = currentParent.renderParent;
                            }
                            else {
                                currentRenderParent = currentParent;
                            }
                        }
                    }
                }
                /** @type {?} */
                var handleEvent = ( /**
                 * @param {?} view
                 * @param {?} nodeIndex
                 * @param {?} eventName
                 * @param {?} event
                 * @return {?}
                 */function (view, nodeIndex, eventName, event) { return ( /** @type {?} */(( /** @type {?} */(nodes[nodeIndex].element)).handleEvent))(view, eventName, event); });
                return {
                    // Will be filled later...
                    factory: null,
                    nodeFlags: viewNodeFlags,
                    rootNodeFlags: viewRootNodeFlags,
                    nodeMatchedQueries: viewMatchedQueries, flags: flags,
                    nodes: nodes,
                    updateDirectives: updateDirectives || NOOP,
                    updateRenderer: updateRenderer || NOOP, handleEvent: handleEvent,
                    bindingCount: viewBindingCount,
                    outputCount: viewDisposableCount, lastRenderRootNode: lastRenderRootNode
                };
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function isNgContainer(node) {
                return (node.flags & 1 /* TypeElement */) !== 0 && ( /** @type {?} */(node.element)).name === null;
            }
            /**
             * @param {?} parent
             * @param {?} node
             * @param {?} nodeCount
             * @return {?}
             */
            function validateNode(parent, node, nodeCount) {
                /** @type {?} */
                var template = node.element && node.element.template;
                if (template) {
                    if (!template.lastRenderRootNode) {
                        throw new Error("Illegal State: Embedded templates without nodes are not allowed!");
                    }
                    if (template.lastRenderRootNode &&
                        template.lastRenderRootNode.flags & 16777216 /* EmbeddedViews */) {
                        throw new Error("Illegal State: Last root node of a template can't have embedded views, at index " + node.nodeIndex + "!");
                    }
                }
                if (node.flags & 20224 /* CatProvider */) {
                    /** @type {?} */
                    var parentFlags = parent ? parent.flags : 0;
                    if ((parentFlags & 1 /* TypeElement */) === 0) {
                        throw new Error("Illegal State: StaticProvider/Directive nodes need to be children of elements or anchors, at index " + node.nodeIndex + "!");
                    }
                }
                if (node.query) {
                    if (node.flags & 67108864 /* TypeContentQuery */ &&
                        (!parent || (parent.flags & 16384 /* TypeDirective */) === 0)) {
                        throw new Error("Illegal State: Content Query nodes need to be children of directives, at index " + node.nodeIndex + "!");
                    }
                    if (node.flags & 134217728 /* TypeViewQuery */ && parent) {
                        throw new Error("Illegal State: View Query nodes have to be top level nodes, at index " + node.nodeIndex + "!");
                    }
                }
                if (node.childCount) {
                    /** @type {?} */
                    var parentEnd = parent ? parent.nodeIndex + parent.childCount : nodeCount - 1;
                    if (node.nodeIndex <= parentEnd && node.nodeIndex + node.childCount > parentEnd) {
                        throw new Error("Illegal State: childCount of node leads outside of parent, at index " + node.nodeIndex + "!");
                    }
                }
            }
            /**
             * @param {?} parent
             * @param {?} anchorDef
             * @param {?} viewDef
             * @param {?=} context
             * @return {?}
             */
            function createEmbeddedView(parent, anchorDef, viewDef, context) {
                // embedded views are seen as siblings to the anchor, so we need
                // to get the parent of the anchor and use it as parentIndex.
                /** @type {?} */
                var view = createView(parent.root, parent.renderer, parent, anchorDef, viewDef);
                initView(view, parent.component, context);
                createViewNodes(view);
                return view;
            }
            /**
             * @param {?} root
             * @param {?} def
             * @param {?=} context
             * @return {?}
             */
            function createRootView(root, def, context) {
                /** @type {?} */
                var view = createView(root, root.renderer, null, null, def);
                initView(view, context, context);
                createViewNodes(view);
                return view;
            }
            /**
             * @param {?} parentView
             * @param {?} nodeDef
             * @param {?} viewDef
             * @param {?} hostElement
             * @return {?}
             */
            function createComponentView(parentView, nodeDef, viewDef, hostElement) {
                /** @type {?} */
                var rendererType = ( /** @type {?} */(nodeDef.element)).componentRendererType;
                /** @type {?} */
                var compRenderer;
                if (!rendererType) {
                    compRenderer = parentView.root.renderer;
                }
                else {
                    compRenderer = parentView.root.rendererFactory.createRenderer(hostElement, rendererType);
                }
                return createView(parentView.root, compRenderer, parentView, ( /** @type {?} */(nodeDef.element)).componentProvider, viewDef);
            }
            /**
             * @param {?} root
             * @param {?} renderer
             * @param {?} parent
             * @param {?} parentNodeDef
             * @param {?} def
             * @return {?}
             */
            function createView(root, renderer, parent, parentNodeDef, def) {
                /** @type {?} */
                var nodes = new Array(def.nodes.length);
                /** @type {?} */
                var disposables = def.outputCount ? new Array(def.outputCount) : null;
                /** @type {?} */
                var view = {
                    def: def,
                    parent: parent,
                    viewContainerParent: null, parentNodeDef: parentNodeDef,
                    context: null,
                    component: null, nodes: nodes,
                    state: 13 /* CatInit */, root: root, renderer: renderer,
                    oldValues: new Array(def.bindingCount), disposables: disposables,
                    initIndex: -1
                };
                return view;
            }
            /**
             * @param {?} view
             * @param {?} component
             * @param {?} context
             * @return {?}
             */
            function initView(view, component, context) {
                view.component = component;
                view.context = context;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function createViewNodes(view) {
                /** @type {?} */
                var renderHost;
                if (isComponentView(view)) {
                    /** @type {?} */
                    var hostDef = view.parentNodeDef;
                    renderHost = asElementData(( /** @type {?} */(view.parent)), ( /** @type {?} */(( /** @type {?} */(hostDef)).parent)).nodeIndex).renderElement;
                }
                /** @type {?} */
                var def = view.def;
                /** @type {?} */
                var nodes = view.nodes;
                for (var i = 0; i < def.nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = def.nodes[i];
                    Services.setCurrentNode(view, i);
                    /** @type {?} */
                    var nodeData = void 0;
                    switch (nodeDef.flags & 201347067 /* Types */) {
                        case 1 /* TypeElement */:
                            /** @type {?} */
                            var el = ( /** @type {?} */(createElement(view, renderHost, nodeDef)));
                            /** @type {?} */
                            var componentView = ( /** @type {?} */(undefined));
                            if (nodeDef.flags & 33554432 /* ComponentView */) {
                                /** @type {?} */
                                var compViewDef = resolveDefinition(( /** @type {?} */(( /** @type {?} */(nodeDef.element)).componentView)));
                                componentView = Services.createComponentView(view, nodeDef, compViewDef, el);
                            }
                            listenToElementOutputs(view, componentView, nodeDef, el);
                            nodeData = ( /** @type {?} */({
                                renderElement: el,
                                componentView: componentView,
                                viewContainer: null,
                                template: ( /** @type {?} */(nodeDef.element)).template ? createTemplateData(view, nodeDef) : undefined
                            }));
                            if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
                                nodeData.viewContainer = createViewContainerData(view, nodeDef, nodeData);
                            }
                            break;
                        case 2 /* TypeText */:
                            nodeData = ( /** @type {?} */(createText(view, renderHost, nodeDef)));
                            break;
                        case 512 /* TypeClassProvider */:
                        case 1024 /* TypeFactoryProvider */:
                        case 2048 /* TypeUseExistingProvider */:
                        case 256 /* TypeValueProvider */: {
                            nodeData = nodes[i];
                            if (!nodeData && !(nodeDef.flags & 4096 /* LazyProvider */)) {
                                /** @type {?} */
                                var instance = createProviderInstance(view, nodeDef);
                                nodeData = ( /** @type {?} */({ instance: instance }));
                            }
                            break;
                        }
                        case 16 /* TypePipe */: {
                            /** @type {?} */
                            var instance = createPipeInstance(view, nodeDef);
                            nodeData = ( /** @type {?} */({ instance: instance }));
                            break;
                        }
                        case 16384 /* TypeDirective */: {
                            nodeData = nodes[i];
                            if (!nodeData) {
                                /** @type {?} */
                                var instance = createDirectiveInstance(view, nodeDef);
                                nodeData = ( /** @type {?} */({ instance: instance }));
                            }
                            if (nodeDef.flags & 32768 /* Component */) {
                                /** @type {?} */
                                var compView = asElementData(view, ( /** @type {?} */(nodeDef.parent)).nodeIndex).componentView;
                                initView(compView, nodeData.instance, nodeData.instance);
                            }
                            break;
                        }
                        case 32 /* TypePureArray */:
                        case 64 /* TypePureObject */:
                        case 128 /* TypePurePipe */:
                            nodeData = ( /** @type {?} */(createPureExpression(view, nodeDef)));
                            break;
                        case 67108864 /* TypeContentQuery */:
                        case 134217728 /* TypeViewQuery */:
                            nodeData = ( /** @type {?} */(createQuery()));
                            break;
                        case 8 /* TypeNgContent */:
                            appendNgContent(view, renderHost, nodeDef);
                            // no runtime data needed for NgContent...
                            nodeData = undefined;
                            break;
                    }
                    nodes[i] = nodeData;
                }
                // Create the ViewData.nodes of component views after we created everything else,
                // so that e.g. ng-content works
                execComponentViewsAction(view, ViewAction.CreateViewNodes);
                // fill static content and view queries
                execQueriesAction(view, 67108864 /* TypeContentQuery */ | 134217728 /* TypeViewQuery */, 268435456 /* StaticQuery */, 0 /* CheckAndUpdate */);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function checkNoChangesView(view) {
                markProjectedViewsForCheck(view);
                Services.updateDirectives(view, 1 /* CheckNoChanges */);
                execEmbeddedViewsAction(view, ViewAction.CheckNoChanges);
                Services.updateRenderer(view, 1 /* CheckNoChanges */);
                execComponentViewsAction(view, ViewAction.CheckNoChanges);
                // Note: We don't check queries for changes as we didn't do this in v2.x.
                // TODO(tbosch): investigate if we can enable the check again in v5.x with a nicer error message.
                view.state &= ~(64 /* CheckProjectedViews */ | 32 /* CheckProjectedView */);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function checkAndUpdateView(view) {
                if (view.state & 1 /* BeforeFirstCheck */) {
                    view.state &= ~1 /* BeforeFirstCheck */;
                    view.state |= 2 /* FirstCheck */;
                }
                else {
                    view.state &= ~2 /* FirstCheck */;
                }
                shiftInitState(view, 0 /* InitState_BeforeInit */, 256 /* InitState_CallingOnInit */);
                markProjectedViewsForCheck(view);
                Services.updateDirectives(view, 0 /* CheckAndUpdate */);
                execEmbeddedViewsAction(view, ViewAction.CheckAndUpdate);
                execQueriesAction(view, 67108864 /* TypeContentQuery */, 536870912 /* DynamicQuery */, 0 /* CheckAndUpdate */);
                /** @type {?} */
                var callInit = shiftInitState(view, 256 /* InitState_CallingOnInit */, 512 /* InitState_CallingAfterContentInit */);
                callLifecycleHooksChildrenFirst(view, 2097152 /* AfterContentChecked */ | (callInit ? 1048576 /* AfterContentInit */ : 0));
                Services.updateRenderer(view, 0 /* CheckAndUpdate */);
                execComponentViewsAction(view, ViewAction.CheckAndUpdate);
                execQueriesAction(view, 134217728 /* TypeViewQuery */, 536870912 /* DynamicQuery */, 0 /* CheckAndUpdate */);
                callInit = shiftInitState(view, 512 /* InitState_CallingAfterContentInit */, 768 /* InitState_CallingAfterViewInit */);
                callLifecycleHooksChildrenFirst(view, 8388608 /* AfterViewChecked */ | (callInit ? 4194304 /* AfterViewInit */ : 0));
                if (view.def.flags & 2 /* OnPush */) {
                    view.state &= ~8 /* ChecksEnabled */;
                }
                view.state &= ~(64 /* CheckProjectedViews */ | 32 /* CheckProjectedView */);
                shiftInitState(view, 768 /* InitState_CallingAfterViewInit */, 1024 /* InitState_AfterInit */);
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} argStyle
             * @param {?=} v0
             * @param {?=} v1
             * @param {?=} v2
             * @param {?=} v3
             * @param {?=} v4
             * @param {?=} v5
             * @param {?=} v6
             * @param {?=} v7
             * @param {?=} v8
             * @param {?=} v9
             * @return {?}
             */
            function checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                if (argStyle === 0 /* Inline */) {
                    return checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                }
                else {
                    return checkAndUpdateNodeDynamic(view, nodeDef, v0);
                }
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function markProjectedViewsForCheck(view) {
                /** @type {?} */
                var def = view.def;
                if (!(def.nodeFlags & 4 /* ProjectedTemplate */)) {
                    return;
                }
                for (var i = 0; i < def.nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = def.nodes[i];
                    if (nodeDef.flags & 4 /* ProjectedTemplate */) {
                        /** @type {?} */
                        var projectedViews = asElementData(view, i).template._projectedViews;
                        if (projectedViews) {
                            for (var i_7 = 0; i_7 < projectedViews.length; i_7++) {
                                /** @type {?} */
                                var projectedView = projectedViews[i_7];
                                projectedView.state |= 32 /* CheckProjectedView */;
                                markParentViewsForCheckProjectedViews(projectedView, view);
                            }
                        }
                    }
                    else if ((nodeDef.childFlags & 4 /* ProjectedTemplate */) === 0) {
                        // a parent with leafs
                        // no child is a component,
                        // then skip the children
                        i += nodeDef.childCount;
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?=} v0
             * @param {?=} v1
             * @param {?=} v2
             * @param {?=} v3
             * @param {?=} v4
             * @param {?=} v5
             * @param {?=} v6
             * @param {?=} v7
             * @param {?=} v8
             * @param {?=} v9
             * @return {?}
             */
            function checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                switch (nodeDef.flags & 201347067 /* Types */) {
                    case 1 /* TypeElement */:
                        return checkAndUpdateElementInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                    case 2 /* TypeText */:
                        return checkAndUpdateTextInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                    case 16384 /* TypeDirective */:
                        return checkAndUpdateDirectiveInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                    case 32 /* TypePureArray */:
                    case 64 /* TypePureObject */:
                    case 128 /* TypePurePipe */:
                        return checkAndUpdatePureExpressionInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                    default:
                        throw 'unreachable';
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} values
             * @return {?}
             */
            function checkAndUpdateNodeDynamic(view, nodeDef, values) {
                switch (nodeDef.flags & 201347067 /* Types */) {
                    case 1 /* TypeElement */:
                        return checkAndUpdateElementDynamic(view, nodeDef, values);
                    case 2 /* TypeText */:
                        return checkAndUpdateTextDynamic(view, nodeDef, values);
                    case 16384 /* TypeDirective */:
                        return checkAndUpdateDirectiveDynamic(view, nodeDef, values);
                    case 32 /* TypePureArray */:
                    case 64 /* TypePureObject */:
                    case 128 /* TypePurePipe */:
                        return checkAndUpdatePureExpressionDynamic(view, nodeDef, values);
                    default:
                        throw 'unreachable';
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} argStyle
             * @param {?=} v0
             * @param {?=} v1
             * @param {?=} v2
             * @param {?=} v3
             * @param {?=} v4
             * @param {?=} v5
             * @param {?=} v6
             * @param {?=} v7
             * @param {?=} v8
             * @param {?=} v9
             * @return {?}
             */
            function checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                if (argStyle === 0 /* Inline */) {
                    checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                }
                else {
                    checkNoChangesNodeDynamic(view, nodeDef, v0);
                }
                // Returning false is ok here as we would have thrown in case of a change.
                return false;
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} v0
             * @param {?} v1
             * @param {?} v2
             * @param {?} v3
             * @param {?} v4
             * @param {?} v5
             * @param {?} v6
             * @param {?} v7
             * @param {?} v8
             * @param {?} v9
             * @return {?}
             */
            function checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var bindLen = nodeDef.bindings.length;
                if (bindLen > 0)
                    checkBindingNoChanges(view, nodeDef, 0, v0);
                if (bindLen > 1)
                    checkBindingNoChanges(view, nodeDef, 1, v1);
                if (bindLen > 2)
                    checkBindingNoChanges(view, nodeDef, 2, v2);
                if (bindLen > 3)
                    checkBindingNoChanges(view, nodeDef, 3, v3);
                if (bindLen > 4)
                    checkBindingNoChanges(view, nodeDef, 4, v4);
                if (bindLen > 5)
                    checkBindingNoChanges(view, nodeDef, 5, v5);
                if (bindLen > 6)
                    checkBindingNoChanges(view, nodeDef, 6, v6);
                if (bindLen > 7)
                    checkBindingNoChanges(view, nodeDef, 7, v7);
                if (bindLen > 8)
                    checkBindingNoChanges(view, nodeDef, 8, v8);
                if (bindLen > 9)
                    checkBindingNoChanges(view, nodeDef, 9, v9);
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} values
             * @return {?}
             */
            function checkNoChangesNodeDynamic(view, nodeDef, values) {
                for (var i = 0; i < values.length; i++) {
                    checkBindingNoChanges(view, nodeDef, i, values[i]);
                }
            }
            /**
             * Workaround https://github.com/angular/tsickle/issues/497
             * @suppress {misplacedTypeAnnotation}
             * @param {?} view
             * @param {?} nodeDef
             * @return {?}
             */
            function checkNoChangesQuery(view, nodeDef) {
                /** @type {?} */
                var queryList = asQueryList(view, nodeDef.nodeIndex);
                if (queryList.dirty) {
                    throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, nodeDef.nodeIndex), "Query " + ( /** @type {?} */(nodeDef.query)).id + " not dirty", "Query " + ( /** @type {?} */(nodeDef.query)).id + " dirty", (view.state & 1 /* BeforeFirstCheck */) !== 0);
                }
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function destroyView(view) {
                if (view.state & 128 /* Destroyed */) {
                    return;
                }
                execEmbeddedViewsAction(view, ViewAction.Destroy);
                execComponentViewsAction(view, ViewAction.Destroy);
                callLifecycleHooksChildrenFirst(view, 131072 /* OnDestroy */);
                if (view.disposables) {
                    for (var i = 0; i < view.disposables.length; i++) {
                        view.disposables[i]();
                    }
                }
                detachProjectedView(view);
                if (view.renderer.destroyNode) {
                    destroyViewNodes(view);
                }
                if (isComponentView(view)) {
                    view.renderer.destroy();
                }
                view.state |= 128 /* Destroyed */;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function destroyViewNodes(view) {
                /** @type {?} */
                var len = view.def.nodes.length;
                for (var i = 0; i < len; i++) {
                    /** @type {?} */
                    var def = view.def.nodes[i];
                    if (def.flags & 1 /* TypeElement */) {
                        ( /** @type {?} */(view.renderer.destroyNode))(asElementData(view, i).renderElement);
                    }
                    else if (def.flags & 2 /* TypeText */) {
                        ( /** @type {?} */(view.renderer.destroyNode))(asTextData(view, i).renderText);
                    }
                    else if (def.flags & 67108864 /* TypeContentQuery */ || def.flags & 134217728 /* TypeViewQuery */) {
                        asQueryList(view, i).destroy();
                    }
                }
            }
            /** @enum {number} */
            var ViewAction = {
                CreateViewNodes: 0,
                CheckNoChanges: 1,
                CheckNoChangesProjectedViews: 2,
                CheckAndUpdate: 3,
                CheckAndUpdateProjectedViews: 4,
                Destroy: 5,
            };
            ViewAction[ViewAction.CreateViewNodes] = 'CreateViewNodes';
            ViewAction[ViewAction.CheckNoChanges] = 'CheckNoChanges';
            ViewAction[ViewAction.CheckNoChangesProjectedViews] = 'CheckNoChangesProjectedViews';
            ViewAction[ViewAction.CheckAndUpdate] = 'CheckAndUpdate';
            ViewAction[ViewAction.CheckAndUpdateProjectedViews] = 'CheckAndUpdateProjectedViews';
            ViewAction[ViewAction.Destroy] = 'Destroy';
            /**
             * @param {?} view
             * @param {?} action
             * @return {?}
             */
            function execComponentViewsAction(view, action) {
                /** @type {?} */
                var def = view.def;
                if (!(def.nodeFlags & 33554432 /* ComponentView */)) {
                    return;
                }
                for (var i = 0; i < def.nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = def.nodes[i];
                    if (nodeDef.flags & 33554432 /* ComponentView */) {
                        // a leaf
                        callViewAction(asElementData(view, i).componentView, action);
                    }
                    else if ((nodeDef.childFlags & 33554432 /* ComponentView */) === 0) {
                        // a parent with leafs
                        // no child is a component,
                        // then skip the children
                        i += nodeDef.childCount;
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} action
             * @return {?}
             */
            function execEmbeddedViewsAction(view, action) {
                /** @type {?} */
                var def = view.def;
                if (!(def.nodeFlags & 16777216 /* EmbeddedViews */)) {
                    return;
                }
                for (var i = 0; i < def.nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = def.nodes[i];
                    if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
                        // a leaf
                        /** @type {?} */
                        var embeddedViews = ( /** @type {?} */(asElementData(view, i).viewContainer))._embeddedViews;
                        for (var k = 0; k < embeddedViews.length; k++) {
                            callViewAction(embeddedViews[k], action);
                        }
                    }
                    else if ((nodeDef.childFlags & 16777216 /* EmbeddedViews */) === 0) {
                        // a parent with leafs
                        // no child is a component,
                        // then skip the children
                        i += nodeDef.childCount;
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} action
             * @return {?}
             */
            function callViewAction(view, action) {
                /** @type {?} */
                var viewState = view.state;
                switch (action) {
                    case ViewAction.CheckNoChanges:
                        if ((viewState & 128 /* Destroyed */) === 0) {
                            if ((viewState & 12 /* CatDetectChanges */) === 12 /* CatDetectChanges */) {
                                checkNoChangesView(view);
                            }
                            else if (viewState & 64 /* CheckProjectedViews */) {
                                execProjectedViewsAction(view, ViewAction.CheckNoChangesProjectedViews);
                            }
                        }
                        break;
                    case ViewAction.CheckNoChangesProjectedViews:
                        if ((viewState & 128 /* Destroyed */) === 0) {
                            if (viewState & 32 /* CheckProjectedView */) {
                                checkNoChangesView(view);
                            }
                            else if (viewState & 64 /* CheckProjectedViews */) {
                                execProjectedViewsAction(view, action);
                            }
                        }
                        break;
                    case ViewAction.CheckAndUpdate:
                        if ((viewState & 128 /* Destroyed */) === 0) {
                            if ((viewState & 12 /* CatDetectChanges */) === 12 /* CatDetectChanges */) {
                                checkAndUpdateView(view);
                            }
                            else if (viewState & 64 /* CheckProjectedViews */) {
                                execProjectedViewsAction(view, ViewAction.CheckAndUpdateProjectedViews);
                            }
                        }
                        break;
                    case ViewAction.CheckAndUpdateProjectedViews:
                        if ((viewState & 128 /* Destroyed */) === 0) {
                            if (viewState & 32 /* CheckProjectedView */) {
                                checkAndUpdateView(view);
                            }
                            else if (viewState & 64 /* CheckProjectedViews */) {
                                execProjectedViewsAction(view, action);
                            }
                        }
                        break;
                    case ViewAction.Destroy:
                        // Note: destroyView recurses over all views,
                        // so we don't need to special case projected views here.
                        destroyView(view);
                        break;
                    case ViewAction.CreateViewNodes:
                        createViewNodes(view);
                        break;
                }
            }
            /**
             * @param {?} view
             * @param {?} action
             * @return {?}
             */
            function execProjectedViewsAction(view, action) {
                execEmbeddedViewsAction(view, action);
                execComponentViewsAction(view, action);
            }
            /**
             * @param {?} view
             * @param {?} queryFlags
             * @param {?} staticDynamicQueryFlag
             * @param {?} checkType
             * @return {?}
             */
            function execQueriesAction(view, queryFlags, staticDynamicQueryFlag, checkType) {
                if (!(view.def.nodeFlags & queryFlags) || !(view.def.nodeFlags & staticDynamicQueryFlag)) {
                    return;
                }
                /** @type {?} */
                var nodeCount = view.def.nodes.length;
                for (var i = 0; i < nodeCount; i++) {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[i];
                    if ((nodeDef.flags & queryFlags) && (nodeDef.flags & staticDynamicQueryFlag)) {
                        Services.setCurrentNode(view, nodeDef.nodeIndex);
                        switch (checkType) {
                            case 0 /* CheckAndUpdate */:
                                checkAndUpdateQuery(view, nodeDef);
                                break;
                            case 1 /* CheckNoChanges */:
                                checkNoChangesQuery(view, nodeDef);
                                break;
                        }
                    }
                    if (!(nodeDef.childFlags & queryFlags) || !(nodeDef.childFlags & staticDynamicQueryFlag)) {
                        // no child has a matching query
                        // then skip the children
                        i += nodeDef.childCount;
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var initialized = false;
            /**
             * @return {?}
             */
            function initServicesIfNeeded() {
                if (initialized) {
                    return;
                }
                initialized = true;
                /** @type {?} */
                var services = isDevMode() ? createDebugServices() : createProdServices();
                Services.setCurrentNode = services.setCurrentNode;
                Services.createRootView = services.createRootView;
                Services.createEmbeddedView = services.createEmbeddedView;
                Services.createComponentView = services.createComponentView;
                Services.createNgModuleRef = services.createNgModuleRef;
                Services.overrideProvider = services.overrideProvider;
                Services.overrideComponentView = services.overrideComponentView;
                Services.clearOverrides = services.clearOverrides;
                Services.checkAndUpdateView = services.checkAndUpdateView;
                Services.checkNoChangesView = services.checkNoChangesView;
                Services.destroyView = services.destroyView;
                Services.resolveDep = resolveDep;
                Services.createDebugContext = services.createDebugContext;
                Services.handleEvent = services.handleEvent;
                Services.updateDirectives = services.updateDirectives;
                Services.updateRenderer = services.updateRenderer;
                Services.dirtyParentQueries = dirtyParentQueries;
            }
            /**
             * @return {?}
             */
            function createProdServices() {
                return {
                    setCurrentNode: ( /**
                     * @return {?}
                     */function () { }),
                    createRootView: createProdRootView,
                    createEmbeddedView: createEmbeddedView,
                    createComponentView: createComponentView,
                    createNgModuleRef: createNgModuleRef,
                    overrideProvider: NOOP,
                    overrideComponentView: NOOP,
                    clearOverrides: NOOP,
                    checkAndUpdateView: checkAndUpdateView,
                    checkNoChangesView: checkNoChangesView,
                    destroyView: destroyView,
                    createDebugContext: ( /**
                     * @param {?} view
                     * @param {?} nodeIndex
                     * @return {?}
                     */function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); }),
                    handleEvent: ( /**
                     * @param {?} view
                     * @param {?} nodeIndex
                     * @param {?} eventName
                     * @param {?} event
                     * @return {?}
                     */function (view, nodeIndex, eventName, event) { return view.def.handleEvent(view, nodeIndex, eventName, event); }),
                    updateDirectives: ( /**
                     * @param {?} view
                     * @param {?} checkType
                     * @return {?}
                     */function (view, checkType) { return view.def.updateDirectives(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
                        prodCheckNoChangesNode, view); }),
                    updateRenderer: ( /**
                     * @param {?} view
                     * @param {?} checkType
                     * @return {?}
                     */function (view, checkType) { return view.def.updateRenderer(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
                        prodCheckNoChangesNode, view); }),
                };
            }
            /**
             * @return {?}
             */
            function createDebugServices() {
                return {
                    setCurrentNode: debugSetCurrentNode,
                    createRootView: debugCreateRootView,
                    createEmbeddedView: debugCreateEmbeddedView,
                    createComponentView: debugCreateComponentView,
                    createNgModuleRef: debugCreateNgModuleRef,
                    overrideProvider: debugOverrideProvider,
                    overrideComponentView: debugOverrideComponentView,
                    clearOverrides: debugClearOverrides,
                    checkAndUpdateView: debugCheckAndUpdateView,
                    checkNoChangesView: debugCheckNoChangesView,
                    destroyView: debugDestroyView,
                    createDebugContext: ( /**
                     * @param {?} view
                     * @param {?} nodeIndex
                     * @return {?}
                     */function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); }),
                    handleEvent: debugHandleEvent,
                    updateDirectives: debugUpdateDirectives,
                    updateRenderer: debugUpdateRenderer,
                };
            }
            /**
             * @param {?} elInjector
             * @param {?} projectableNodes
             * @param {?} rootSelectorOrNode
             * @param {?} def
             * @param {?} ngModule
             * @param {?=} context
             * @return {?}
             */
            function createProdRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
                /** @type {?} */
                var rendererFactory = ngModule.injector.get(RendererFactory2);
                return createRootView(createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode), def, context);
            }
            /**
             * @param {?} elInjector
             * @param {?} projectableNodes
             * @param {?} rootSelectorOrNode
             * @param {?} def
             * @param {?} ngModule
             * @param {?=} context
             * @return {?}
             */
            function debugCreateRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
                /** @type {?} */
                var rendererFactory = ngModule.injector.get(RendererFactory2);
                /** @type {?} */
                var root = createRootData(elInjector, ngModule, new DebugRendererFactory2(rendererFactory), projectableNodes, rootSelectorOrNode);
                /** @type {?} */
                var defWithOverride = applyProviderOverridesToView(def);
                return callWithDebugContext(DebugAction.create, createRootView, null, [root, defWithOverride, context]);
            }
            /**
             * @param {?} elInjector
             * @param {?} ngModule
             * @param {?} rendererFactory
             * @param {?} projectableNodes
             * @param {?} rootSelectorOrNode
             * @return {?}
             */
            function createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode) {
                /** @type {?} */
                var sanitizer = ngModule.injector.get(Sanitizer);
                /** @type {?} */
                var errorHandler = ngModule.injector.get(ErrorHandler);
                /** @type {?} */
                var renderer = rendererFactory.createRenderer(null, null);
                return {
                    ngModule: ngModule,
                    injector: elInjector, projectableNodes: projectableNodes,
                    selectorOrNode: rootSelectorOrNode, sanitizer: sanitizer, rendererFactory: rendererFactory, renderer: renderer, errorHandler: errorHandler
                };
            }
            /**
             * @param {?} parentView
             * @param {?} anchorDef
             * @param {?} viewDef
             * @param {?=} context
             * @return {?}
             */
            function debugCreateEmbeddedView(parentView, anchorDef, viewDef, context) {
                /** @type {?} */
                var defWithOverride = applyProviderOverridesToView(viewDef);
                return callWithDebugContext(DebugAction.create, createEmbeddedView, null, [parentView, anchorDef, defWithOverride, context]);
            }
            /**
             * @param {?} parentView
             * @param {?} nodeDef
             * @param {?} viewDef
             * @param {?} hostElement
             * @return {?}
             */
            function debugCreateComponentView(parentView, nodeDef, viewDef, hostElement) {
                /** @type {?} */
                var overrideComponentView = viewDefOverrides.get(( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(nodeDef.element)).componentProvider)).provider)).token);
                if (overrideComponentView) {
                    viewDef = overrideComponentView;
                }
                else {
                    viewDef = applyProviderOverridesToView(viewDef);
                }
                return callWithDebugContext(DebugAction.create, createComponentView, null, [parentView, nodeDef, viewDef, hostElement]);
            }
            /**
             * @param {?} moduleType
             * @param {?} parentInjector
             * @param {?} bootstrapComponents
             * @param {?} def
             * @return {?}
             */
            function debugCreateNgModuleRef(moduleType, parentInjector, bootstrapComponents, def) {
                /** @type {?} */
                var defWithOverride = applyProviderOverridesToNgModule(def);
                return createNgModuleRef(moduleType, parentInjector, bootstrapComponents, defWithOverride);
            }
            /** @type {?} */
            var providerOverrides = new Map();
            /** @type {?} */
            var providerOverridesWithScope = new Map();
            /** @type {?} */
            var viewDefOverrides = new Map();
            /**
             * @param {?} override
             * @return {?}
             */
            function debugOverrideProvider(override) {
                providerOverrides.set(override.token, override);
                /** @type {?} */
                var injectableDef;
                if (typeof override.token === 'function' && (injectableDef = getInjectableDef(override.token)) &&
                    typeof injectableDef.providedIn === 'function') {
                    providerOverridesWithScope.set(( /** @type {?} */(override.token)), override);
                }
            }
            /**
             * @param {?} comp
             * @param {?} compFactory
             * @return {?}
             */
            function debugOverrideComponentView(comp, compFactory) {
                /** @type {?} */
                var hostViewDef = resolveDefinition(getComponentViewDefinitionFactory(compFactory));
                /** @type {?} */
                var compViewDef = resolveDefinition(( /** @type {?} */(( /** @type {?} */(hostViewDef.nodes[0].element)).componentView)));
                viewDefOverrides.set(comp, compViewDef);
            }
            /**
             * @return {?}
             */
            function debugClearOverrides() {
                providerOverrides.clear();
                providerOverridesWithScope.clear();
                viewDefOverrides.clear();
            }
            // Notes about the algorithm:
            // 1) Locate the providers of an element and check if one of them was overwritten
            // 2) Change the providers of that element
            //
            // We only create new datastructures if we need to, to keep perf impact
            // reasonable.
            /**
             * @param {?} def
             * @return {?}
             */
            function applyProviderOverridesToView(def) {
                if (providerOverrides.size === 0) {
                    return def;
                }
                /** @type {?} */
                var elementIndicesWithOverwrittenProviders = findElementIndicesWithOverwrittenProviders(def);
                if (elementIndicesWithOverwrittenProviders.length === 0) {
                    return def;
                }
                // clone the whole view definition,
                // as it maintains references between the nodes that are hard to update.
                def = ( /** @type {?} */(def.factory))(( /**
                 * @return {?}
                 */function () { return NOOP; }));
                for (var i = 0; i < elementIndicesWithOverwrittenProviders.length; i++) {
                    applyProviderOverridesToElement(def, elementIndicesWithOverwrittenProviders[i]);
                }
                return def;
                /**
                 * @param {?} def
                 * @return {?}
                 */
                function findElementIndicesWithOverwrittenProviders(def) {
                    /** @type {?} */
                    var elIndicesWithOverwrittenProviders = [];
                    /** @type {?} */
                    var lastElementDef = null;
                    for (var i = 0; i < def.nodes.length; i++) {
                        /** @type {?} */
                        var nodeDef = def.nodes[i];
                        if (nodeDef.flags & 1 /* TypeElement */) {
                            lastElementDef = nodeDef;
                        }
                        if (lastElementDef && nodeDef.flags & 3840 /* CatProviderNoDirective */ &&
                            providerOverrides.has(( /** @type {?} */(nodeDef.provider)).token)) {
                            elIndicesWithOverwrittenProviders.push(( /** @type {?} */(lastElementDef)).nodeIndex);
                            lastElementDef = null;
                        }
                    }
                    return elIndicesWithOverwrittenProviders;
                }
                /**
                 * @param {?} viewDef
                 * @param {?} elIndex
                 * @return {?}
                 */
                function applyProviderOverridesToElement(viewDef, elIndex) {
                    for (var i = elIndex + 1; i < viewDef.nodes.length; i++) {
                        /** @type {?} */
                        var nodeDef = viewDef.nodes[i];
                        if (nodeDef.flags & 1 /* TypeElement */) {
                            // stop at the next element
                            return;
                        }
                        if (nodeDef.flags & 3840 /* CatProviderNoDirective */) {
                            /** @type {?} */
                            var provider = ( /** @type {?} */(nodeDef.provider));
                            /** @type {?} */
                            var override = providerOverrides.get(provider.token);
                            if (override) {
                                nodeDef.flags = (nodeDef.flags & ~3840 /* CatProviderNoDirective */) | override.flags;
                                provider.deps = splitDepsDsl(override.deps);
                                provider.value = override.value;
                            }
                        }
                    }
                }
            }
            // Notes about the algorithm:
            // We only create new datastructures if we need to, to keep perf impact
            // reasonable.
            /**
             * @param {?} def
             * @return {?}
             */
            function applyProviderOverridesToNgModule(def) {
                var _c = calcHasOverrides(def), hasOverrides = _c.hasOverrides, hasDeprecatedOverrides = _c.hasDeprecatedOverrides;
                if (!hasOverrides) {
                    return def;
                }
                // clone the whole view definition,
                // as it maintains references between the nodes that are hard to update.
                def = ( /** @type {?} */(def.factory))(( /**
                 * @return {?}
                 */function () { return NOOP; }));
                applyProviderOverrides(def);
                return def;
                /**
                 * @param {?} def
                 * @return {?}
                 */
                function calcHasOverrides(def) {
                    /** @type {?} */
                    var hasOverrides = false;
                    /** @type {?} */
                    var hasDeprecatedOverrides = false;
                    if (providerOverrides.size === 0) {
                        return { hasOverrides: hasOverrides, hasDeprecatedOverrides: hasDeprecatedOverrides };
                    }
                    def.providers.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        /** @type {?} */
                        var override = providerOverrides.get(node.token);
                        if ((node.flags & 3840 /* CatProviderNoDirective */) && override) {
                            hasOverrides = true;
                            hasDeprecatedOverrides = hasDeprecatedOverrides || override.deprecatedBehavior;
                        }
                    }));
                    def.modules.forEach(( /**
                     * @param {?} module
                     * @return {?}
                     */function (/**
                     * @param {?} module
                     * @return {?}
                     */ module) {
                        providerOverridesWithScope.forEach(( /**
                         * @param {?} override
                         * @param {?} token
                         * @return {?}
                         */function (override, token) {
                            if (( /** @type {?} */(getInjectableDef(token))).providedIn === module) {
                                hasOverrides = true;
                                hasDeprecatedOverrides = hasDeprecatedOverrides || override.deprecatedBehavior;
                            }
                        }));
                    }));
                    return { hasOverrides: hasOverrides, hasDeprecatedOverrides: hasDeprecatedOverrides };
                }
                /**
                 * @param {?} def
                 * @return {?}
                 */
                function applyProviderOverrides(def) {
                    for (var i = 0; i < def.providers.length; i++) {
                        /** @type {?} */
                        var provider = def.providers[i];
                        if (hasDeprecatedOverrides) {
                            // We had a bug where me made
                            // all providers lazy. Keep this logic behind a flag
                            // for migrating existing users.
                            provider.flags |= 4096 /* LazyProvider */;
                        }
                        /** @type {?} */
                        var override = providerOverrides.get(provider.token);
                        if (override) {
                            provider.flags = (provider.flags & ~3840 /* CatProviderNoDirective */) | override.flags;
                            provider.deps = splitDepsDsl(override.deps);
                            provider.value = override.value;
                        }
                    }
                    if (providerOverridesWithScope.size > 0) {
                        /** @type {?} */
                        var moduleSet_1 = new Set(def.modules);
                        providerOverridesWithScope.forEach(( /**
                         * @param {?} override
                         * @param {?} token
                         * @return {?}
                         */function (override, token) {
                            if (moduleSet_1.has(( /** @type {?} */(getInjectableDef(token))).providedIn)) {
                                /** @type {?} */
                                var provider = {
                                    token: token,
                                    flags: override.flags | (hasDeprecatedOverrides ? 4096 /* LazyProvider */ : 0 /* None */),
                                    deps: splitDepsDsl(override.deps),
                                    value: override.value,
                                    index: def.providers.length,
                                };
                                def.providers.push(provider);
                                def.providersByKey[tokenKey(token)] = provider;
                            }
                        }));
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} checkIndex
             * @param {?} argStyle
             * @param {?=} v0
             * @param {?=} v1
             * @param {?=} v2
             * @param {?=} v3
             * @param {?=} v4
             * @param {?=} v5
             * @param {?=} v6
             * @param {?=} v7
             * @param {?=} v8
             * @param {?=} v9
             * @return {?}
             */
            function prodCheckAndUpdateNode(view, checkIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var nodeDef = view.def.nodes[checkIndex];
                checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                return (nodeDef.flags & 224 /* CatPureExpression */) ?
                    asPureExpressionData(view, checkIndex).value :
                    undefined;
            }
            /**
             * @param {?} view
             * @param {?} checkIndex
             * @param {?} argStyle
             * @param {?=} v0
             * @param {?=} v1
             * @param {?=} v2
             * @param {?=} v3
             * @param {?=} v4
             * @param {?=} v5
             * @param {?=} v6
             * @param {?=} v7
             * @param {?=} v8
             * @param {?=} v9
             * @return {?}
             */
            function prodCheckNoChangesNode(view, checkIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
                /** @type {?} */
                var nodeDef = view.def.nodes[checkIndex];
                checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
                return (nodeDef.flags & 224 /* CatPureExpression */) ?
                    asPureExpressionData(view, checkIndex).value :
                    undefined;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function debugCheckAndUpdateView(view) {
                return callWithDebugContext(DebugAction.detectChanges, checkAndUpdateView, null, [view]);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function debugCheckNoChangesView(view) {
                return callWithDebugContext(DebugAction.checkNoChanges, checkNoChangesView, null, [view]);
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function debugDestroyView(view) {
                return callWithDebugContext(DebugAction.destroy, destroyView, null, [view]);
            }
            /** @enum {number} */
            var DebugAction = {
                create: 0,
                detectChanges: 1,
                checkNoChanges: 2,
                destroy: 3,
                handleEvent: 4,
            };
            DebugAction[DebugAction.create] = 'create';
            DebugAction[DebugAction.detectChanges] = 'detectChanges';
            DebugAction[DebugAction.checkNoChanges] = 'checkNoChanges';
            DebugAction[DebugAction.destroy] = 'destroy';
            DebugAction[DebugAction.handleEvent] = 'handleEvent';
            /** @type {?} */
            var _currentAction;
            /** @type {?} */
            var _currentView;
            /** @type {?} */
            var _currentNodeIndex;
            /**
             * @param {?} view
             * @param {?} nodeIndex
             * @return {?}
             */
            function debugSetCurrentNode(view, nodeIndex) {
                _currentView = view;
                _currentNodeIndex = nodeIndex;
            }
            /**
             * @param {?} view
             * @param {?} nodeIndex
             * @param {?} eventName
             * @param {?} event
             * @return {?}
             */
            function debugHandleEvent(view, nodeIndex, eventName, event) {
                debugSetCurrentNode(view, nodeIndex);
                return callWithDebugContext(DebugAction.handleEvent, view.def.handleEvent, null, [view, nodeIndex, eventName, event]);
            }
            /**
             * @param {?} view
             * @param {?} checkType
             * @return {?}
             */
            function debugUpdateDirectives(view, checkType) {
                if (view.state & 128 /* Destroyed */) {
                    throw viewDestroyedError(DebugAction[_currentAction]);
                }
                debugSetCurrentNode(view, nextDirectiveWithBinding(view, 0));
                return view.def.updateDirectives(debugCheckDirectivesFn, view);
                /**
                 * @param {?} view
                 * @param {?} nodeIndex
                 * @param {?} argStyle
                 * @param {...?} values
                 * @return {?}
                 */
                function debugCheckDirectivesFn(view, nodeIndex, argStyle) {
                    var values = [];
                    for (var _c = 3; _c < arguments.length; _c++) {
                        values[_c - 3] = arguments[_c];
                    }
                    /** @type {?} */
                    var nodeDef = view.def.nodes[nodeIndex];
                    if (checkType === 0 /* CheckAndUpdate */) {
                        debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
                    }
                    else {
                        debugCheckNoChangesNode(view, nodeDef, argStyle, values);
                    }
                    if (nodeDef.flags & 16384 /* TypeDirective */) {
                        debugSetCurrentNode(view, nextDirectiveWithBinding(view, nodeIndex));
                    }
                    return (nodeDef.flags & 224 /* CatPureExpression */) ?
                        asPureExpressionData(view, nodeDef.nodeIndex).value :
                        undefined;
                }
            }
            /**
             * @param {?} view
             * @param {?} checkType
             * @return {?}
             */
            function debugUpdateRenderer(view, checkType) {
                if (view.state & 128 /* Destroyed */) {
                    throw viewDestroyedError(DebugAction[_currentAction]);
                }
                debugSetCurrentNode(view, nextRenderNodeWithBinding(view, 0));
                return view.def.updateRenderer(debugCheckRenderNodeFn, view);
                /**
                 * @param {?} view
                 * @param {?} nodeIndex
                 * @param {?} argStyle
                 * @param {...?} values
                 * @return {?}
                 */
                function debugCheckRenderNodeFn(view, nodeIndex, argStyle) {
                    var values = [];
                    for (var _c = 3; _c < arguments.length; _c++) {
                        values[_c - 3] = arguments[_c];
                    }
                    /** @type {?} */
                    var nodeDef = view.def.nodes[nodeIndex];
                    if (checkType === 0 /* CheckAndUpdate */) {
                        debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
                    }
                    else {
                        debugCheckNoChangesNode(view, nodeDef, argStyle, values);
                    }
                    if (nodeDef.flags & 3 /* CatRenderNode */) {
                        debugSetCurrentNode(view, nextRenderNodeWithBinding(view, nodeIndex));
                    }
                    return (nodeDef.flags & 224 /* CatPureExpression */) ?
                        asPureExpressionData(view, nodeDef.nodeIndex).value :
                        undefined;
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} argStyle
             * @param {?} givenValues
             * @return {?}
             */
            function debugCheckAndUpdateNode(view, nodeDef, argStyle, givenValues) {
                /** @type {?} */
                var changed = (( /** @type {?} */(checkAndUpdateNode))).apply(void 0, [view, nodeDef, argStyle].concat(givenValues));
                if (changed) {
                    /** @type {?} */
                    var values = argStyle === 1 /* Dynamic */ ? givenValues[0] : givenValues;
                    if (nodeDef.flags & 16384 /* TypeDirective */) {
                        /** @type {?} */
                        var bindingValues = {};
                        for (var i = 0; i < nodeDef.bindings.length; i++) {
                            /** @type {?} */
                            var binding = nodeDef.bindings[i];
                            /** @type {?} */
                            var value = values[i];
                            if (binding.flags & 8 /* TypeProperty */) {
                                bindingValues[normalizeDebugBindingName(( /** @type {?} */(binding.nonMinifiedName)))] =
                                    normalizeDebugBindingValue(value);
                            }
                        }
                        /** @type {?} */
                        var elDef = ( /** @type {?} */(nodeDef.parent));
                        /** @type {?} */
                        var el = asElementData(view, elDef.nodeIndex).renderElement;
                        if (!( /** @type {?} */(elDef.element)).name) {
                            // a comment.
                            view.renderer.setValue(el, "bindings=" + JSON.stringify(bindingValues, null, 2));
                        }
                        else {
                            // a regular element.
                            for (var attr in bindingValues) {
                                /** @type {?} */
                                var value = bindingValues[attr];
                                if (value != null) {
                                    view.renderer.setAttribute(el, attr, value);
                                }
                                else {
                                    view.renderer.removeAttribute(el, attr);
                                }
                            }
                        }
                    }
                }
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} argStyle
             * @param {?} values
             * @return {?}
             */
            function debugCheckNoChangesNode(view, nodeDef, argStyle, values) {
                (( /** @type {?} */(checkNoChangesNode))).apply(void 0, [view, nodeDef, argStyle].concat(values));
            }
            /**
             * @param {?} view
             * @param {?} nodeIndex
             * @return {?}
             */
            function nextDirectiveWithBinding(view, nodeIndex) {
                for (var i = nodeIndex; i < view.def.nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[i];
                    if (nodeDef.flags & 16384 /* TypeDirective */ && nodeDef.bindings && nodeDef.bindings.length) {
                        return i;
                    }
                }
                return null;
            }
            /**
             * @param {?} view
             * @param {?} nodeIndex
             * @return {?}
             */
            function nextRenderNodeWithBinding(view, nodeIndex) {
                for (var i = nodeIndex; i < view.def.nodes.length; i++) {
                    /** @type {?} */
                    var nodeDef = view.def.nodes[i];
                    if ((nodeDef.flags & 3 /* CatRenderNode */) && nodeDef.bindings && nodeDef.bindings.length) {
                        return i;
                    }
                }
                return null;
            }
            var DebugContext_ = /** @class */ (function () {
                /**
                 * @param {?} view
                 * @param {?} nodeIndex
                 */
                function DebugContext_(view, nodeIndex) {
                    this.view = view;
                    this.nodeIndex = nodeIndex;
                    if (nodeIndex == null) {
                        this.nodeIndex = nodeIndex = 0;
                    }
                    this.nodeDef = view.def.nodes[nodeIndex];
                    /** @type {?} */
                    var elDef = this.nodeDef;
                    /** @type {?} */
                    var elView = view;
                    while (elDef && (elDef.flags & 1 /* TypeElement */) === 0) {
                        elDef = ( /** @type {?} */(elDef.parent));
                    }
                    if (!elDef) {
                        while (!elDef && elView) {
                            elDef = ( /** @type {?} */(viewParentEl(elView)));
                            elView = ( /** @type {?} */(elView.parent));
                        }
                    }
                    this.elDef = elDef;
                    this.elView = elView;
                }
                Object.defineProperty(DebugContext_.prototype, "elOrCompView", {
                    /**
                     * @private
                     * @return {?}
                     */
                    get: function () {
                        // Has to be done lazily as we use the DebugContext also during creation of elements...
                        return asElementData(this.elView, this.elDef.nodeIndex).componentView || this.view;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "injector", {
                    /**
                     * @return {?}
                     */
                    get: function () { return createInjector$1(this.elView, this.elDef); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "component", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.elOrCompView.component; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "context", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.elOrCompView.context; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "providerTokens", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var tokens = [];
                        if (this.elDef) {
                            for (var i = this.elDef.nodeIndex + 1; i <= this.elDef.nodeIndex + this.elDef.childCount; i++) {
                                /** @type {?} */
                                var childDef = this.elView.def.nodes[i];
                                if (childDef.flags & 20224 /* CatProvider */) {
                                    tokens.push(( /** @type {?} */(childDef.provider)).token);
                                }
                                i += childDef.childCount;
                            }
                        }
                        return tokens;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "references", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var references = {};
                        if (this.elDef) {
                            collectReferences(this.elView, this.elDef, references);
                            for (var i = this.elDef.nodeIndex + 1; i <= this.elDef.nodeIndex + this.elDef.childCount; i++) {
                                /** @type {?} */
                                var childDef = this.elView.def.nodes[i];
                                if (childDef.flags & 20224 /* CatProvider */) {
                                    collectReferences(this.elView, childDef, references);
                                }
                                i += childDef.childCount;
                            }
                        }
                        return references;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "componentRenderElement", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var elData = findHostElement(this.elOrCompView);
                        return elData ? elData.renderElement : undefined;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(DebugContext_.prototype, "renderNode", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.nodeDef.flags & 2 /* TypeText */ ? renderNode(this.view, this.nodeDef) :
                            renderNode(this.elView, this.elDef);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} console
                 * @param {...?} values
                 * @return {?}
                 */
                DebugContext_.prototype.logError = function (console) {
                    var values = [];
                    for (var _c = 1; _c < arguments.length; _c++) {
                        values[_c - 1] = arguments[_c];
                    }
                    /** @type {?} */
                    var logViewDef;
                    /** @type {?} */
                    var logNodeIndex;
                    if (this.nodeDef.flags & 2 /* TypeText */) {
                        logViewDef = this.view.def;
                        logNodeIndex = this.nodeDef.nodeIndex;
                    }
                    else {
                        logViewDef = this.elView.def;
                        logNodeIndex = this.elDef.nodeIndex;
                    }
                    // Note: we only generate a log function for text and element nodes
                    // to make the generated code as small as possible.
                    /** @type {?} */
                    var renderNodeIndex = getRenderNodeIndex(logViewDef, logNodeIndex);
                    /** @type {?} */
                    var currRenderNodeIndex = -1;
                    /** @type {?} */
                    var nodeLogger = ( /**
                     * @return {?}
                     */function () {
                        var _c;
                        currRenderNodeIndex++;
                        if (currRenderNodeIndex === renderNodeIndex) {
                            return (_c = console.error).bind.apply(_c, [console].concat(values));
                        }
                        else {
                            return NOOP;
                        }
                    });
                    ( /** @type {?} */(logViewDef.factory))(nodeLogger);
                    if (currRenderNodeIndex < renderNodeIndex) {
                        console.error('Illegal state: the ViewDefinitionFactory did not call the logger!');
                        console.error.apply(console, values);
                    }
                };
                return DebugContext_;
            }());
            if (false) { }
            /**
             * @param {?} viewDef
             * @param {?} nodeIndex
             * @return {?}
             */
            function getRenderNodeIndex(viewDef, nodeIndex) {
                /** @type {?} */
                var renderNodeIndex = -1;
                for (var i = 0; i <= nodeIndex; i++) {
                    /** @type {?} */
                    var nodeDef = viewDef.nodes[i];
                    if (nodeDef.flags & 3 /* CatRenderNode */) {
                        renderNodeIndex++;
                    }
                }
                return renderNodeIndex;
            }
            /**
             * @param {?} view
             * @return {?}
             */
            function findHostElement(view) {
                while (view && !isComponentView(view)) {
                    view = ( /** @type {?} */(view.parent));
                }
                if (view.parent) {
                    return asElementData(view.parent, ( /** @type {?} */(viewParentEl(view))).nodeIndex);
                }
                return null;
            }
            /**
             * @param {?} view
             * @param {?} nodeDef
             * @param {?} references
             * @return {?}
             */
            function collectReferences(view, nodeDef, references) {
                for (var refName in nodeDef.references) {
                    references[refName] = getQueryValue(view, nodeDef, nodeDef.references[refName]);
                }
            }
            /**
             * @param {?} action
             * @param {?} fn
             * @param {?} self
             * @param {?} args
             * @return {?}
             */
            function callWithDebugContext(action, fn, self, args) {
                /** @type {?} */
                var oldAction = _currentAction;
                /** @type {?} */
                var oldView = _currentView;
                /** @type {?} */
                var oldNodeIndex = _currentNodeIndex;
                try {
                    _currentAction = action;
                    /** @type {?} */
                    var result = fn.apply(self, args);
                    _currentView = oldView;
                    _currentNodeIndex = oldNodeIndex;
                    _currentAction = oldAction;
                    return result;
                }
                catch (e) {
                    if (isViewDebugError(e) || !_currentView) {
                        throw e;
                    }
                    throw viewWrappedDebugError(e, ( /** @type {?} */(getCurrentDebugContext())));
                }
            }
            /**
             * @return {?}
             */
            function getCurrentDebugContext() {
                return _currentView ? new DebugContext_(_currentView, _currentNodeIndex) : null;
            }
            var DebugRendererFactory2 = /** @class */ (function () {
                /**
                 * @param {?} delegate
                 */
                function DebugRendererFactory2(delegate) {
                    this.delegate = delegate;
                }
                /**
                 * @param {?} element
                 * @param {?} renderData
                 * @return {?}
                 */
                DebugRendererFactory2.prototype.createRenderer = function (element, renderData) {
                    return new DebugRenderer2(this.delegate.createRenderer(element, renderData));
                };
                /**
                 * @return {?}
                 */
                DebugRendererFactory2.prototype.begin = function () {
                    if (this.delegate.begin) {
                        this.delegate.begin();
                    }
                };
                /**
                 * @return {?}
                 */
                DebugRendererFactory2.prototype.end = function () {
                    if (this.delegate.end) {
                        this.delegate.end();
                    }
                };
                /**
                 * @return {?}
                 */
                DebugRendererFactory2.prototype.whenRenderingDone = function () {
                    if (this.delegate.whenRenderingDone) {
                        return this.delegate.whenRenderingDone();
                    }
                    return Promise.resolve(null);
                };
                return DebugRendererFactory2;
            }());
            if (false) { }
            var DebugRenderer2 = /** @class */ (function () {
                /**
                 * @param {?} delegate
                 */
                function DebugRenderer2(delegate) {
                    this.delegate = delegate;
                    /**
                     * Factory function used to create a `DebugContext` when a node is created.
                     *
                     * The `DebugContext` allows to retrieve information about the nodes that are useful in tests.
                     *
                     * The factory is configurable so that the `DebugRenderer2` could instantiate either a View Engine
                     * or a Render context.
                     */
                    this.debugContextFactory = getCurrentDebugContext;
                    this.data = this.delegate.data;
                }
                /**
                 * @private
                 * @param {?} nativeElement
                 * @return {?}
                 */
                DebugRenderer2.prototype.createDebugContext = function (nativeElement) { return this.debugContextFactory(nativeElement); };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                DebugRenderer2.prototype.destroyNode = function (node) {
                    /** @type {?} */
                    var debugNode = ( /** @type {?} */(getDebugNode(node)));
                    removeDebugNodeFromIndex(debugNode);
                    if (debugNode instanceof DebugNode__PRE_R3__) {
                        debugNode.listeners.length = 0;
                    }
                    if (this.delegate.destroyNode) {
                        this.delegate.destroyNode(node);
                    }
                };
                /**
                 * @return {?}
                 */
                DebugRenderer2.prototype.destroy = function () { this.delegate.destroy(); };
                /**
                 * @param {?} name
                 * @param {?=} namespace
                 * @return {?}
                 */
                DebugRenderer2.prototype.createElement = function (name, namespace) {
                    /** @type {?} */
                    var el = this.delegate.createElement(name, namespace);
                    /** @type {?} */
                    var debugCtx = this.createDebugContext(el);
                    if (debugCtx) {
                        /** @type {?} */
                        var debugEl = new DebugElement__PRE_R3__(el, null, debugCtx);
                        (( /** @type {?} */(debugEl))).name = name;
                        indexDebugNode(debugEl);
                    }
                    return el;
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DebugRenderer2.prototype.createComment = function (value) {
                    /** @type {?} */
                    var comment = this.delegate.createComment(value);
                    /** @type {?} */
                    var debugCtx = this.createDebugContext(comment);
                    if (debugCtx) {
                        indexDebugNode(new DebugNode__PRE_R3__(comment, null, debugCtx));
                    }
                    return comment;
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DebugRenderer2.prototype.createText = function (value) {
                    /** @type {?} */
                    var text = this.delegate.createText(value);
                    /** @type {?} */
                    var debugCtx = this.createDebugContext(text);
                    if (debugCtx) {
                        indexDebugNode(new DebugNode__PRE_R3__(text, null, debugCtx));
                    }
                    return text;
                };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @return {?}
                 */
                DebugRenderer2.prototype.appendChild = function (parent, newChild) {
                    /** @type {?} */
                    var debugEl = getDebugNode(parent);
                    /** @type {?} */
                    var debugChildEl = getDebugNode(newChild);
                    if (debugEl && debugChildEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.addChild(debugChildEl);
                    }
                    this.delegate.appendChild(parent, newChild);
                };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @param {?} refChild
                 * @return {?}
                 */
                DebugRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
                    /** @type {?} */
                    var debugEl = getDebugNode(parent);
                    /** @type {?} */
                    var debugChildEl = getDebugNode(newChild);
                    /** @type {?} */
                    var debugRefEl = ( /** @type {?} */(getDebugNode(refChild)));
                    if (debugEl && debugChildEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.insertBefore(debugRefEl, debugChildEl);
                    }
                    this.delegate.insertBefore(parent, newChild, refChild);
                };
                /**
                 * @param {?} parent
                 * @param {?} oldChild
                 * @return {?}
                 */
                DebugRenderer2.prototype.removeChild = function (parent, oldChild) {
                    /** @type {?} */
                    var debugEl = getDebugNode(parent);
                    /** @type {?} */
                    var debugChildEl = getDebugNode(oldChild);
                    if (debugEl && debugChildEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.removeChild(debugChildEl);
                    }
                    this.delegate.removeChild(parent, oldChild);
                };
                /**
                 * @param {?} selectorOrNode
                 * @param {?=} preserveContent
                 * @return {?}
                 */
                DebugRenderer2.prototype.selectRootElement = function (selectorOrNode, preserveContent) {
                    /** @type {?} */
                    var el = this.delegate.selectRootElement(selectorOrNode, preserveContent);
                    /** @type {?} */
                    var debugCtx = getCurrentDebugContext();
                    if (debugCtx) {
                        indexDebugNode(new DebugElement__PRE_R3__(el, null, debugCtx));
                    }
                    return el;
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @param {?=} namespace
                 * @return {?}
                 */
                DebugRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        /** @type {?} */
                        var fullName = namespace ? namespace + ':' + name : name;
                        debugEl.attributes[fullName] = value;
                    }
                    this.delegate.setAttribute(el, name, value, namespace);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?=} namespace
                 * @return {?}
                 */
                DebugRenderer2.prototype.removeAttribute = function (el, name, namespace) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        /** @type {?} */
                        var fullName = namespace ? namespace + ':' + name : name;
                        debugEl.attributes[fullName] = null;
                    }
                    this.delegate.removeAttribute(el, name, namespace);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                DebugRenderer2.prototype.addClass = function (el, name) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.classes[name] = true;
                    }
                    this.delegate.addClass(el, name);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                DebugRenderer2.prototype.removeClass = function (el, name) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.classes[name] = false;
                    }
                    this.delegate.removeClass(el, name);
                };
                /**
                 * @param {?} el
                 * @param {?} style
                 * @param {?} value
                 * @param {?} flags
                 * @return {?}
                 */
                DebugRenderer2.prototype.setStyle = function (el, style, value, flags) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.styles[style] = value;
                    }
                    this.delegate.setStyle(el, style, value, flags);
                };
                /**
                 * @param {?} el
                 * @param {?} style
                 * @param {?} flags
                 * @return {?}
                 */
                DebugRenderer2.prototype.removeStyle = function (el, style, flags) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.styles[style] = null;
                    }
                    this.delegate.removeStyle(el, style, flags);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                DebugRenderer2.prototype.setProperty = function (el, name, value) {
                    /** @type {?} */
                    var debugEl = getDebugNode(el);
                    if (debugEl && debugEl instanceof DebugElement__PRE_R3__) {
                        debugEl.properties[name] = value;
                    }
                    this.delegate.setProperty(el, name, value);
                };
                /**
                 * @param {?} target
                 * @param {?} eventName
                 * @param {?} callback
                 * @return {?}
                 */
                DebugRenderer2.prototype.listen = function (target, eventName, callback) {
                    if (typeof target !== 'string') {
                        /** @type {?} */
                        var debugEl = getDebugNode(target);
                        if (debugEl) {
                            debugEl.listeners.push(new DebugEventListener(eventName, callback));
                        }
                    }
                    return this.delegate.listen(target, eventName, callback);
                };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                DebugRenderer2.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                DebugRenderer2.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
                /**
                 * @param {?} node
                 * @param {?} value
                 * @return {?}
                 */
                DebugRenderer2.prototype.setValue = function (node, value) { return this.delegate.setValue(node, value); };
                return DebugRenderer2;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} override
             * @return {?}
             */
            function overrideProvider(override) {
                initServicesIfNeeded();
                return Services.overrideProvider(override);
            }
            /**
             * @param {?} comp
             * @param {?} componentFactory
             * @return {?}
             */
            function overrideComponentView(comp, componentFactory) {
                initServicesIfNeeded();
                return Services.overrideComponentView(comp, componentFactory);
            }
            /**
             * @return {?}
             */
            function clearOverrides() {
                initServicesIfNeeded();
                return Services.clearOverrides();
            }
            // Attention: this function is called as top level function.
            // Putting any logic in here will destroy closure tree shaking!
            /**
             * @param {?} ngModuleType
             * @param {?} bootstrapComponents
             * @param {?} defFactory
             * @return {?}
             */
            function createNgModuleFactory(ngModuleType, bootstrapComponents, defFactory) {
                return new NgModuleFactory_(ngModuleType, bootstrapComponents, defFactory);
            }
            /**
             * @param {?} def
             * @return {?}
             */
            function cloneNgModuleDefinition(def) {
                /** @type {?} */
                var providers = Array.from(def.providers);
                /** @type {?} */
                var modules = Array.from(def.modules);
                /** @type {?} */
                var providersByKey = {};
                for (var key in def.providersByKey) {
                    providersByKey[key] = def.providersByKey[key];
                }
                return {
                    factory: def.factory,
                    isRoot: def.isRoot, providers: providers, modules: modules, providersByKey: providersByKey,
                };
            }
            var NgModuleFactory_ = /** @class */ (function (_super_1) {
                __extends(NgModuleFactory_, _super_1);
                /**
                 * @param {?} moduleType
                 * @param {?} _bootstrapComponents
                 * @param {?} _ngModuleDefFactory
                 */
                function NgModuleFactory_(moduleType, _bootstrapComponents, _ngModuleDefFactory) {
                    var _this = 
                    // Attention: this ctor is called as top level function.
                    // Putting any logic in here will destroy closure tree shaking!
                    _super_1.call(this) || this;
                    _this.moduleType = moduleType;
                    _this._bootstrapComponents = _bootstrapComponents;
                    _this._ngModuleDefFactory = _ngModuleDefFactory;
                    return _this;
                }
                /**
                 * @param {?} parentInjector
                 * @return {?}
                 */
                NgModuleFactory_.prototype.create = function (parentInjector) {
                    initServicesIfNeeded();
                    // Clone the NgModuleDefinition so that any tree shakeable provider definition
                    // added to this instance of the NgModuleRef doesn't affect the cached copy.
                    // See https://github.com/angular/angular/issues/25018.
                    /** @type {?} */
                    var def = cloneNgModuleDefinition(resolveDefinition(this._ngModuleDefFactory));
                    return Services.createNgModuleRef(this.moduleType, parentInjector || Injector.NULL, this._bootstrapComponents, def);
                };
                return NgModuleFactory_;
            }(NgModuleFactory));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=core.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/elements/fesm2015/elements.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/@angular/elements/fesm2015/elements.js ***!
          \*************************************************************/
        /*! exports provided: NgElement, createCustomElement, VERSION */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgElement", function () { return NgElement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomElement", function () { return createCustomElement; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0 = /**
             * @return {?}
             */ function () {
                /** @type {?} */
                var elProto = ( /** @type {?} */(Element.prototype));
                return elProto.matches || elProto.matchesSelector || elProto.mozMatchesSelector ||
                    elProto.msMatchesSelector || elProto.oMatchesSelector || elProto.webkitMatchesSelector;
            };
            /** @type {?} */
            var matches = ((ɵ0))();
            /**
             * Provide methods for scheduling the execution of a callback.
             * @type {?}
             */
            var scheduler = {
                /**
                 * Schedule a callback to be called after some delay.
                 *
                 * Returns a function that when executed will cancel the scheduled function.
                 * @param {?} taskFn
                 * @param {?} delay
                 * @return {?}
                 */
                schedule: function (taskFn, delay) {
                    var id = setTimeout(taskFn, delay);
                    return ( /**
                     * @return {?}
                     */function () { return clearTimeout(id); });
                },
                /**
                 * Schedule a callback to be called before the next render.
                 * (If `window.requestAnimationFrame()` is not available, use `scheduler.schedule()` instead.)
                 *
                 * Returns a function that when executed will cancel the scheduled function.
                 * @param {?} taskFn
                 * @return {?}
                 */
                scheduleBeforeRender: function (taskFn) {
                    // TODO(gkalpak): Implement a better way of accessing `requestAnimationFrame()`
                    //                (e.g. accounting for vendor prefix, SSR-compatibility, etc).
                    if (typeof window === 'undefined') {
                        // For SSR just schedule immediately.
                        return scheduler.schedule(taskFn, 0);
                    }
                    if (typeof window.requestAnimationFrame === 'undefined') {
                        /** @type {?} */
                        var frameMs = 16;
                        return scheduler.schedule(taskFn, frameMs);
                    }
                    /** @type {?} */
                    var id = window.requestAnimationFrame(taskFn);
                    return ( /**
                     * @return {?}
                     */function () { return window.cancelAnimationFrame(id); });
                },
            };
            /**
             * Convert a camelCased string to kebab-cased.
             * @param {?} input
             * @return {?}
             */
            function camelToDashCase(input) {
                return input.replace(/[A-Z]/g, ( /**
                 * @param {?} char
                 * @return {?}
                 */function (/**
                 * @param {?} char
                 * @return {?}
                 */ char) { return "-" + char.toLowerCase(); }));
            }
            /**
             * Create a `CustomEvent` (even on browsers where `CustomEvent` is not a constructor).
             * @param {?} doc
             * @param {?} name
             * @param {?} detail
             * @return {?}
             */
            function createCustomEvent(doc, name, detail) {
                /** @type {?} */
                var bubbles = false;
                /** @type {?} */
                var cancelable = false;
                // On IE9-11, `CustomEvent` is not a constructor.
                if (typeof CustomEvent !== 'function') {
                    /** @type {?} */
                    var event = doc.createEvent('CustomEvent');
                    event.initCustomEvent(name, bubbles, cancelable, detail);
                    return event;
                }
                return new CustomEvent(name, { bubbles: bubbles, cancelable: cancelable, detail: detail });
            }
            /**
             * Check whether the input is an `Element`.
             * @param {?} node
             * @return {?}
             */
            function isElement(node) {
                return !!node && node.nodeType === Node.ELEMENT_NODE;
            }
            /**
             * Check whether the input is a function.
             * @param {?} value
             * @return {?}
             */
            function isFunction(value) {
                return typeof value === 'function';
            }
            /**
             * Convert a kebab-cased string to camelCased.
             * @param {?} input
             * @return {?}
             */
            function kebabToCamelCase(input) {
                return input.replace(/-([a-z\d])/g, ( /**
                 * @param {?} _
                 * @param {?} char
                 * @return {?}
                 */function (_, char) { return char.toUpperCase(); }));
            }
            /**
             * Check whether an `Element` matches a CSS selector.
             * @param {?} element
             * @param {?} selector
             * @return {?}
             */
            function matchesSelector(element, selector) {
                return matches.call(element, selector);
            }
            /**
             * Test two values for strict equality, accounting for the fact that `NaN !== NaN`.
             * @param {?} value1
             * @param {?} value2
             * @return {?}
             */
            function strictEquals(value1, value2) {
                return value1 === value2 || (value1 !== value1 && value2 !== value2);
            }
            /**
             * Gets a map of default set of attributes to observe and the properties they affect.
             * @param {?} inputs
             * @return {?}
             */
            function getDefaultAttributeToPropertyInputs(inputs) {
                /** @type {?} */
                var attributeToPropertyInputs = {};
                inputs.forEach(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                    var propName = _c.propName, templateName = _c.templateName;
                    attributeToPropertyInputs[camelToDashCase(templateName)] = propName;
                }));
                return attributeToPropertyInputs;
            }
            /**
             * Gets a component's set of inputs. Uses the injector to get the component factory where the inputs
             * are defined.
             * @param {?} component
             * @param {?} injector
             * @return {?}
             */
            function getComponentInputs(component, injector) {
                /** @type {?} */
                var componentFactoryResolver = injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ComponentFactoryResolver"]);
                /** @type {?} */
                var componentFactory = componentFactoryResolver.resolveComponentFactory(component);
                return componentFactory.inputs;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} host
             * @param {?} ngContentSelectors
             * @return {?}
             */
            function extractProjectableNodes(host, ngContentSelectors) {
                /** @type {?} */
                var nodes = host.childNodes;
                /** @type {?} */
                var projectableNodes = ngContentSelectors.map(( /**
                 * @return {?}
                 */function () { return []; }));
                /** @type {?} */
                var wildcardIndex = -1;
                ngContentSelectors.some(( /**
                 * @param {?} selector
                 * @param {?} i
                 * @return {?}
                 */function (selector, i) {
                    if (selector === '*') {
                        wildcardIndex = i;
                        return true;
                    }
                    return false;
                }));
                for (var i = 0, ii = nodes.length; i < ii; ++i) {
                    /** @type {?} */
                    var node = nodes[i];
                    /** @type {?} */
                    var ngContentIndex = findMatchingIndex(node, ngContentSelectors, wildcardIndex);
                    if (ngContentIndex !== -1) {
                        projectableNodes[ngContentIndex].push(node);
                    }
                }
                return projectableNodes;
            }
            /**
             * @param {?} node
             * @param {?} selectors
             * @param {?} defaultIndex
             * @return {?}
             */
            function findMatchingIndex(node, selectors, defaultIndex) {
                /** @type {?} */
                var matchingIndex = defaultIndex;
                if (isElement(node)) {
                    selectors.some(( /**
                     * @param {?} selector
                     * @param {?} i
                     * @return {?}
                     */function (selector, i) {
                        if ((selector !== '*') && matchesSelector(node, selector)) {
                            matchingIndex = i;
                            return true;
                        }
                        return false;
                    }));
                }
                return matchingIndex;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Time in milliseconds to wait before destroying the component ref when disconnected.
             * @type {?}
             */
            var DESTROY_DELAY = 10;
            /**
             * Factory that creates new ComponentNgElementStrategy instance. Gets the component factory with the
             * constructor's injector's factory resolver and passes that factory to each strategy.
             *
             * \@publicApi
             */
            var ComponentNgElementStrategyFactory = /** @class */ (function () {
                /**
                 * @param {?} component
                 * @param {?} injector
                 */
                function ComponentNgElementStrategyFactory(component, injector) {
                    this.component = component;
                    this.injector = injector;
                    this.componentFactory =
                        injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ComponentFactoryResolver"]).resolveComponentFactory(component);
                }
                /**
                 * @param {?} injector
                 * @return {?}
                 */
                ComponentNgElementStrategyFactory.prototype.create = function (injector) {
                    return new ComponentNgElementStrategy(this.componentFactory, injector);
                };
                return ComponentNgElementStrategyFactory;
            }());
            if (false) { }
            /**
             * Creates and destroys a component ref using a component factory and handles change detection
             * in response to input changes.
             *
             * \@publicApi
             */
            var ComponentNgElementStrategy = /** @class */ (function () {
                /**
                 * @param {?} componentFactory
                 * @param {?} injector
                 */
                function ComponentNgElementStrategy(componentFactory, injector) {
                    this.componentFactory = componentFactory;
                    this.injector = injector;
                    /**
                     * Changes that have been made to the component ref since the last time onChanges was called.
                     */
                    this.inputChanges = null;
                    /**
                     * Whether the created component implements the onChanges function.
                     */
                    this.implementsOnChanges = false;
                    /**
                     * Whether a change detection has been scheduled to run on the component.
                     */
                    this.scheduledChangeDetectionFn = null;
                    /**
                     * Callback function that when called will cancel a scheduled destruction on the component.
                     */
                    this.scheduledDestroyFn = null;
                    /**
                     * Initial input values that were set before the component was created.
                     */
                    this.initialInputValues = new Map();
                    /**
                     * Set of inputs that were not initially set when the component was created.
                     */
                    this.uninitializedInputs = new Set();
                }
                /**
                 * Initializes a new component if one has not yet been created and cancels any scheduled
                 * destruction.
                 * @param {?} element
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.connect = function (element) {
                    // If the element is marked to be destroyed, cancel the task since the component was reconnected
                    if (this.scheduledDestroyFn !== null) {
                        this.scheduledDestroyFn();
                        this.scheduledDestroyFn = null;
                        return;
                    }
                    if (!this.componentRef) {
                        this.initializeComponent(element);
                    }
                };
                /**
                 * Schedules the component to be destroyed after some small delay in case the element is just
                 * being moved across the DOM.
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.disconnect = function () {
                    var _this = this;
                    // Return if there is no componentRef or the component is already scheduled for destruction
                    if (!this.componentRef || this.scheduledDestroyFn !== null) {
                        return;
                    }
                    // Schedule the component to be destroyed after a small timeout in case it is being
                    // moved elsewhere in the DOM
                    this.scheduledDestroyFn = scheduler.schedule(( /**
                     * @return {?}
                     */function () {
                        if (_this.componentRef) {
                            ( /** @type {?} */(_this.componentRef)).destroy();
                            _this.componentRef = null;
                        }
                    }), DESTROY_DELAY);
                };
                /**
                 * Returns the component property value. If the component has not yet been created, the value is
                 * retrieved from the cached initialization values.
                 * @param {?} property
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.getInputValue = function (property) {
                    if (!this.componentRef) {
                        return this.initialInputValues.get(property);
                    }
                    return (( /** @type {?} */(this.componentRef.instance)))[property];
                };
                /**
                 * Sets the input value for the property. If the component has not yet been created, the value is
                 * cached and set when the component is created.
                 * @param {?} property
                 * @param {?} value
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.setInputValue = function (property, value) {
                    if (!this.componentRef) {
                        this.initialInputValues.set(property, value);
                        return;
                    }
                    if (strictEquals(value, this.getInputValue(property))) {
                        return;
                    }
                    this.recordInputChange(property, value);
                    (( /** @type {?} */(this.componentRef.instance)))[property] = value;
                    this.scheduleDetectChanges();
                };
                /**
                 * Creates a new component through the component factory with the provided element host and
                 * sets up its initial inputs, listens for outputs changes, and runs an initial change detection.
                 * @protected
                 * @param {?} element
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.initializeComponent = function (element) {
                    /** @type {?} */
                    var childInjector = _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injector"].create({ providers: [], parent: this.injector });
                    /** @type {?} */
                    var projectableNodes = extractProjectableNodes(element, this.componentFactory.ngContentSelectors);
                    this.componentRef = this.componentFactory.create(childInjector, projectableNodes, element);
                    this.implementsOnChanges =
                        isFunction((( /** @type {?} */(( /** @type {?} */(this.componentRef.instance))))).ngOnChanges);
                    this.initializeInputs();
                    this.initializeOutputs();
                    this.detectChanges();
                    /** @type {?} */
                    var applicationRef = this.injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ApplicationRef"]);
                    applicationRef.attachView(this.componentRef.hostView);
                };
                /**
                 * Set any stored initial inputs on the component's properties.
                 * @protected
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.initializeInputs = function () {
                    var _this = this;
                    this.componentFactory.inputs.forEach(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var propName = _c.propName;
                        if (_this.initialInputValues.has(propName)) {
                            _this.setInputValue(propName, _this.initialInputValues.get(propName));
                        }
                        else {
                            // Keep track of inputs that were not initialized in case we need to know this for
                            // calling ngOnChanges with SimpleChanges
                            _this.uninitializedInputs.add(propName);
                        }
                    }));
                    this.initialInputValues.clear();
                };
                /**
                 * Sets up listeners for the component's outputs so that the events stream emits the events.
                 * @protected
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.initializeOutputs = function () {
                    var _this = this;
                    /** @type {?} */
                    var eventEmitters = this.componentFactory.outputs.map(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var propName = _c.propName, templateName = _c.templateName;
                        /** @type {?} */
                        var emitter = ( /** @type {?} */((( /** @type {?} */(( /** @type {?} */(_this.componentRef)).instance)))[propName]));
                        return emitter.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(( /**
                         * @param {?} value
                         * @return {?}
                         */function (value) { return ({ name: templateName, value: value }); })));
                    }));
                    this.events = Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["merge"]).apply(void 0, eventEmitters);
                };
                /**
                 * Calls ngOnChanges with all the inputs that have changed since the last call.
                 * @protected
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.callNgOnChanges = function () {
                    if (!this.implementsOnChanges || this.inputChanges === null) {
                        return;
                    }
                    // Cache the changes and set inputChanges to null to capture any changes that might occur
                    // during ngOnChanges.
                    /** @type {?} */
                    var inputChanges = this.inputChanges;
                    this.inputChanges = null;
                    (( /** @type {?} */(( /** @type {?} */(( /** @type {?} */(this.componentRef)).instance))))).ngOnChanges(inputChanges);
                };
                /**
                 * Schedules change detection to run on the component.
                 * Ignores subsequent calls if already scheduled.
                 * @protected
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.scheduleDetectChanges = function () {
                    var _this = this;
                    if (this.scheduledChangeDetectionFn) {
                        return;
                    }
                    this.scheduledChangeDetectionFn = scheduler.scheduleBeforeRender(( /**
                     * @return {?}
                     */function () {
                        _this.scheduledChangeDetectionFn = null;
                        _this.detectChanges();
                    }));
                };
                /**
                 * Records input changes so that the component receives SimpleChanges in its onChanges function.
                 * @protected
                 * @param {?} property
                 * @param {?} currentValue
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.recordInputChange = function (property, currentValue) {
                    // Do not record the change if the component does not implement `OnChanges`.
                    if (this.componentRef && !this.implementsOnChanges) {
                        return;
                    }
                    if (this.inputChanges === null) {
                        this.inputChanges = {};
                    }
                    // If there already is a change, modify the current value to match but leave the values for
                    // previousValue and isFirstChange.
                    /** @type {?} */
                    var pendingChange = this.inputChanges[property];
                    if (pendingChange) {
                        pendingChange.currentValue = currentValue;
                        return;
                    }
                    /** @type {?} */
                    var isFirstChange = this.uninitializedInputs.has(property);
                    this.uninitializedInputs.delete(property);
                    /** @type {?} */
                    var previousValue = isFirstChange ? undefined : this.getInputValue(property);
                    this.inputChanges[property] = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["SimpleChange"](previousValue, currentValue, isFirstChange);
                };
                /**
                 * Runs change detection on the component.
                 * @protected
                 * @return {?}
                 */
                ComponentNgElementStrategy.prototype.detectChanges = function () {
                    if (!this.componentRef) {
                        return;
                    }
                    this.callNgOnChanges();
                    ( /** @type {?} */(this.componentRef)).changeDetectorRef.detectChanges();
                };
                return ComponentNgElementStrategy;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Prototype for a class constructor based on an Angular component
             * that can be used for custom element registration. Implemented and returned
             * by the {\@link createCustomElement createCustomElement() function}.
             *
             * \@publicApi
             * @record
             * @template P
             */
            function NgElementConstructor() { }
            if (false) { }
            /**
             * Implements the functionality needed for a custom element.
             *
             * \@publicApi
             * @abstract
             */
            var NgElement = /** @class */ (function (_super_1) {
                __extends(NgElement, _super_1);
                function NgElement() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * A subscription to change, connect, and disconnect events in the custom element.
                     */
                    _this.ngElementEventsSubscription = null;
                    return _this;
                }
                return NgElement;
            }(HTMLElement));
            if (false) { }
            /**
             * A configuration that initializes an NgElementConstructor with the
             * dependencies and strategy it needs to transform a component into
             * a custom element class.
             *
             * \@publicApi
             * @record
             */
            function NgElementConfig() { }
            if (false) { }
            /**
             * \@description Creates a custom element class based on an Angular component.
             *
             * Builds a class that encapsulates the functionality of the provided component and
             * uses the configuration information to provide more context to the class.
             * Takes the component factory's inputs and outputs to convert them to the proper
             * custom element API and add hooks to input changes.
             *
             * The configuration's injector is the initial injector set on the class,
             * and used by default for each created instance.This behavior can be overridden with the
             * static property to affect all newly created instances, or as a constructor argument for
             * one-off creations.
             *
             * \@publicApi
             * @template P
             * @param {?} component The component to transform.
             * @param {?} config A configuration that provides initialization information to the created class.
             * @return {?} The custom-element construction class, which can be registered with
             * a browser's `CustomElementRegistry`.
             *
             */
            function createCustomElement(component, config) {
                /** @type {?} */
                var inputs = getComponentInputs(component, config.injector);
                /** @type {?} */
                var strategyFactory = config.strategyFactory || new ComponentNgElementStrategyFactory(component, config.injector);
                /** @type {?} */
                var attributeToPropertyInputs = getDefaultAttributeToPropertyInputs(inputs);
                var NgElementImpl = /** @class */ (function (_super_1) {
                    __extends(NgElementImpl, _super_1);
                    /**
                     * @param {?=} injector
                     */
                    function NgElementImpl(injector) {
                        var _this = _super_1.call(this) || this;
                        // Note that some polyfills (e.g. document-register-element) do not call the constructor.
                        // Do not assume this strategy has been created.
                        // TODO(andrewseguin): Add e2e tests that cover cases where the constructor isn't called. For
                        // now this is tested using a Google internal test suite.
                        _this.ngElementStrategy = strategyFactory.create(injector || config.injector);
                        return _this;
                    }
                    /**
                     * @param {?} attrName
                     * @param {?} oldValue
                     * @param {?} newValue
                     * @param {?=} namespace
                     * @return {?}
                     */
                    NgElementImpl.prototype.attributeChangedCallback = function (attrName, oldValue, newValue, namespace) {
                        if (!this.ngElementStrategy) {
                            this.ngElementStrategy = strategyFactory.create(config.injector);
                        }
                        /** @type {?} */
                        var propName = ( /** @type {?} */(attributeToPropertyInputs[attrName]));
                        this.ngElementStrategy.setInputValue(propName, newValue);
                    };
                    /**
                     * @return {?}
                     */
                    NgElementImpl.prototype.connectedCallback = function () {
                        var _this = this;
                        if (!this.ngElementStrategy) {
                            this.ngElementStrategy = strategyFactory.create(config.injector);
                        }
                        this.ngElementStrategy.connect(this);
                        // Listen for events from the strategy and dispatch them as custom events
                        this.ngElementEventsSubscription = this.ngElementStrategy.events.subscribe(( /**
                         * @param {?} e
                         * @return {?}
                         */function (/**
                         * @param {?} e
                         * @return {?}
                         */ e) {
                            /** @type {?} */
                            var customEvent = createCustomEvent(( /** @type {?} */(_this.ownerDocument)), e.name, e.value);
                            _this.dispatchEvent(customEvent);
                        }));
                    };
                    /**
                     * @return {?}
                     */
                    NgElementImpl.prototype.disconnectedCallback = function () {
                        if (this.ngElementStrategy) {
                            this.ngElementStrategy.disconnect();
                        }
                        if (this.ngElementEventsSubscription) {
                            this.ngElementEventsSubscription.unsubscribe();
                            this.ngElementEventsSubscription = null;
                        }
                    };
                    return NgElementImpl;
                }(NgElement));
                // Work around a bug in closure typed optimizations(b/79557487) where it is not honoring static
                // field externs. So using quoted access to explicitly prevent renaming.
                NgElementImpl['observedAttributes'] = Object.keys(attributeToPropertyInputs);
                if (false) { }
                // Add getters and setters to the prototype for each property input. If the config does not
                // contain property inputs, use all inputs by default.
                inputs.map(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                    var propName = _c.propName;
                    return propName;
                })).forEach(( /**
                 * @param {?} property
                 * @return {?}
                 */function (/**
                 * @param {?} property
                 * @return {?}
                 */ property) {
                    Object.defineProperty(NgElementImpl.prototype, property, {
                        get: ( /**
                         * @return {?}
                         */function () { return this.ngElementStrategy.getInputValue(property); }),
                        set: ( /**
                         * @param {?} newValue
                         * @return {?}
                         */function (newValue) { this.ngElementStrategy.setInputValue(property, newValue); }),
                        configurable: true,
                        enumerable: true,
                    });
                }));
                return ( /** @type {?} */((( /** @type {?} */(NgElementImpl)))));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Version"]('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=elements.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/forms/fesm2015/forms.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/@angular/forms/fesm2015/forms.js ***!
          \*******************************************************/
        /*! exports provided: ɵangular_packages_forms_forms_d, ɵInternalFormsSharedModule, ɵangular_packages_forms_forms_c, ɵangular_packages_forms_forms_a, ɵangular_packages_forms_forms_b, ɵangular_packages_forms_forms_e, ɵangular_packages_forms_forms_f, ɵangular_packages_forms_forms_g, ɵangular_packages_forms_forms_h, ɵangular_packages_forms_forms_i, ɵangular_packages_forms_forms_j, ɵangular_packages_forms_forms_k, ɵangular_packages_forms_forms_l, ɵangular_packages_forms_forms_z, ɵNgNoValidate, ɵangular_packages_forms_forms_m, ɵangular_packages_forms_forms_n, ɵangular_packages_forms_forms_o, ɵangular_packages_forms_forms_p, ɵangular_packages_forms_forms_q, ɵangular_packages_forms_forms_r, ɵangular_packages_forms_forms_s, ɵangular_packages_forms_forms_t, ɵangular_packages_forms_forms_v, ɵangular_packages_forms_forms_u, ɵangular_packages_forms_forms_w, ɵangular_packages_forms_forms_y, ɵNgSelectMultipleOption, ɵangular_packages_forms_forms_x, ɵangular_packages_forms_forms_bb, ɵangular_packages_forms_forms_bc, ɵangular_packages_forms_forms_be, ɵangular_packages_forms_forms_bd, ɵangular_packages_forms_forms_bf, ɵangular_packages_forms_forms_ba, AbstractControlDirective, AbstractFormGroupDirective, CheckboxControlValueAccessor, ControlContainer, NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE, DefaultValueAccessor, NgControl, NgControlStatus, NgControlStatusGroup, NgForm, NgFormSelectorWarning, NgModel, NgModelGroup, NumberValueAccessor, RadioControlValueAccessor, RangeValueAccessor, FormControlDirective, FormControlName, FormGroupDirective, FormArrayName, FormGroupName, NgSelectOption, SelectControlValueAccessor, SelectMultipleControlValueAccessor, CheckboxRequiredValidator, EmailValidator, MaxLengthValidator, MinLengthValidator, PatternValidator, RequiredValidator, FormBuilder, AbstractControl, FormArray, FormControl, FormGroup, NG_ASYNC_VALIDATORS, NG_VALIDATORS, Validators, VERSION, FormsModule, ReactiveFormsModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_d", function () { return ɵInternalFormsSharedModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵInternalFormsSharedModule", function () { return ɵInternalFormsSharedModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_c", function () { return REACTIVE_DRIVEN_DIRECTIVES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_a", function () { return SHARED_FORM_DIRECTIVES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_b", function () { return TEMPLATE_DRIVEN_DIRECTIVES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_e", function () { return CHECKBOX_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_f", function () { return DEFAULT_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_g", function () { return AbstractControlStatus; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_h", function () { return ngControlStatusHost; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_i", function () { return formDirectiveProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_j", function () { return NG_FORM_SELECTOR_WARNING; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_k", function () { return formControlBinding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_l", function () { return modelGroupProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_z", function () { return ɵNgNoValidate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgNoValidate", function () { return ɵNgNoValidate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_m", function () { return NUMBER_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_n", function () { return RADIO_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_o", function () { return RadioControlRegistry; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_p", function () { return RANGE_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_q", function () { return NG_MODEL_WITH_FORM_CONTROL_WARNING; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_r", function () { return formControlBinding$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_s", function () { return controlNameBinding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_t", function () { return formDirectiveProvider$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_v", function () { return formArrayNameProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_u", function () { return formGroupNameProvider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_w", function () { return SELECT_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_y", function () { return ɵNgSelectMultipleOption; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgSelectMultipleOption", function () { return ɵNgSelectMultipleOption; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_x", function () { return SELECT_MULTIPLE_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bb", function () { return CHECKBOX_REQUIRED_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bc", function () { return EMAIL_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_be", function () { return MAX_LENGTH_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bd", function () { return MIN_LENGTH_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bf", function () { return PATTERN_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_ba", function () { return REQUIRED_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControlDirective", function () { return AbstractControlDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractFormGroupDirective", function () { return AbstractFormGroupDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxControlValueAccessor", function () { return CheckboxControlValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlContainer", function () { return ControlContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALUE_ACCESSOR", function () { return NG_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPOSITION_BUFFER_MODE", function () { return COMPOSITION_BUFFER_MODE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultValueAccessor", function () { return DefaultValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControl", function () { return NgControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatus", function () { return NgControlStatus; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatusGroup", function () { return NgControlStatusGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForm", function () { return NgForm; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgFormSelectorWarning", function () { return NgFormSelectorWarning; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModel", function () { return NgModel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModelGroup", function () { return NgModelGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberValueAccessor", function () { return NumberValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioControlValueAccessor", function () { return RadioControlValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RangeValueAccessor", function () { return RangeValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlDirective", function () { return FormControlDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlName", function () { return FormControlName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupDirective", function () { return FormGroupDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArrayName", function () { return FormArrayName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupName", function () { return FormGroupName; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSelectOption", function () { return NgSelectOption; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectControlValueAccessor", function () { return SelectControlValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectMultipleControlValueAccessor", function () { return SelectMultipleControlValueAccessor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxRequiredValidator", function () { return CheckboxRequiredValidator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function () { return EmailValidator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function () { return MaxLengthValidator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function () { return MinLengthValidator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PatternValidator", function () { return PatternValidator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function () { return RequiredValidator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormBuilder", function () { return FormBuilder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function () { return AbstractControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArray", function () { return FormArray; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function () { return FormControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function () { return FormGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_ASYNC_VALIDATORS", function () { return NG_ASYNC_VALIDATORS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALIDATORS", function () { return NG_VALIDATORS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validators", function () { return Validators; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormsModule", function () { return FormsModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactiveFormsModule", function () { return ReactiveFormsModule; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * Defines an interface that acts as a bridge between the Angular forms API and a
             * native element in the DOM.
             *
             * Implement this interface to create a custom form control directive
             * that integrates with Angular forms.
             *
             * @see DefaultValueAccessor
             *
             * \@publicApi
             * @record
             */
            function ControlValueAccessor() { }
            if (false) { }
            /**
             * Used to provide a `ControlValueAccessor` for form controls.
             *
             * See `DefaultValueAccessor` for how to implement one.
             *
             * \@publicApi
             * @type {?}
             */
            var NG_VALUE_ACCESSOR = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('NgValueAccessor');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var CHECKBOX_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return CheckboxControlValueAccessor; })),
                multi: true,
            };
            /**
             * \@description
             * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
             * element.
             *
             * \@usageNotes
             *
             * ### Using a checkbox with a reactive form.
             *
             * The following example shows how to use a checkbox with a reactive form.
             *
             * ```ts
             * const rememberLoginControl = new FormControl();
             * ```
             *
             * ```
             * <input type="checkbox" [formControl]="rememberLoginControl">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var CheckboxControlValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 */
                function CheckboxControlValueAccessor(_renderer, _elementRef) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    /**
                     * \@description
                     * The registered callback function called when a change event occurs on the input element.
                     */
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                }
                /**
                 * Sets the "checked" property on the input element.
                 *
                 * @param {?} value The checked value
                 * @return {?}
                 */
                CheckboxControlValueAccessor.prototype.writeValue = function (value) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                return CheckboxControlValueAccessor;
            }());
            CheckboxControlValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                            host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                            providers: [CHECKBOX_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            CheckboxControlValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var DEFAULT_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return DefaultValueAccessor; })),
                multi: true
            };
            /**
             * We must check whether the agent is Android because composition events
             * behave differently between iOS and Android.
             * @return {?}
             */
            function _isAndroid() {
                /** @type {?} */
                var userAgent = Object(_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["ɵgetDOM"])() ? Object(_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["ɵgetDOM"])().getUserAgent() : '';
                return /android (\d+)/.test(userAgent.toLowerCase());
            }
            /**
             * \@description
             * Provide this token to control if form directives buffer IME input until
             * the "compositionend" event occurs.
             * \@publicApi
             * @type {?}
             */
            var COMPOSITION_BUFFER_MODE = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('CompositionEventMode');
            /**
             * \@description
             * The default `ControlValueAccessor` for writing a value and listening to changes on input
             * elements. The accessor is used by the `FormControlDirective`, `FormControlName`, and
             * `NgModel` directives.
             *
             * \@usageNotes
             *
             * ### Using the default value accessor
             *
             * The following example shows how to use an input element that activates the default value accessor
             * (in this case, a text field).
             *
             * ```ts
             * const firstNameControl = new FormControl();
             * ```
             *
             * ```
             * <input type="text" [formControl]="firstNameControl">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var DefaultValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 * @param {?} _compositionMode
                 */
                function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    this._compositionMode = _compositionMode;
                    /**
                     * \@description
                     * The registered callback function called when an input event occurs on the input element.
                     */
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * Whether the user is creating a composition string (IME events).
                     */
                    this._composing = false;
                    if (this._compositionMode == null) {
                        this._compositionMode = !_isAndroid();
                    }
                }
                /**
                 * Sets the "value" property on the input element.
                 *
                 * @param {?} value The checked value
                 * @return {?}
                 */
                DefaultValueAccessor.prototype.writeValue = function (value) {
                    /** @type {?} */
                    var normalizedValue = value == null ? '' : value;
                    this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                DefaultValueAccessor.prototype._handleInput = function (value) {
                    if (!this._compositionMode || (this._compositionMode && !this._composing)) {
                        this.onChange(value);
                    }
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                DefaultValueAccessor.prototype._compositionStart = function () { this._composing = true; };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                DefaultValueAccessor.prototype._compositionEnd = function (value) {
                    this._composing = false;
                    this._compositionMode && this.onChange(value);
                };
                return DefaultValueAccessor;
            }());
            DefaultValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                            // TODO: vsavkin replace the above selector with the one below it once
                            // https://github.com/angular/angular/issues/3011 is implemented
                            // selector: '[ngModel],[formControl],[formControlName]',
                            host: {
                                '(input)': '$any(this)._handleInput($event.target.value)',
                                '(blur)': 'onTouched()',
                                '(compositionstart)': '$any(this)._compositionStart()',
                                '(compositionend)': '$any(this)._compositionEnd($event.target.value)'
                            },
                            providers: [DEFAULT_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            DefaultValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: Boolean, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [COMPOSITION_BUFFER_MODE,] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * \@description
             * Base class for control directives.
             *
             * This class is only used internally in the `ReactiveFormsModule` and the `FormsModule`.
             *
             * \@publicApi
             * @abstract
             */
            var AbstractControlDirective = /** @class */ (function () {
                function AbstractControlDirective() {
                }
                Object.defineProperty(AbstractControlDirective.prototype, "value", {
                    /**
                     * \@description
                     * Reports the value of the control if it is present, otherwise null.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.value : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "valid", {
                    /**
                     * \@description
                     * Reports whether the control is valid. A control is considered valid if no
                     * validation errors exist with the current value.
                     * If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.valid : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
                    /**
                     * \@description
                     * Reports whether the control is invalid, meaning that an error exists in the input value.
                     * If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.invalid : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "pending", {
                    /**
                     * \@description
                     * Reports whether a control is pending, meaning that that async validation is occurring and
                     * errors are not yet available for the input value. If the control is not present, null is
                     * returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.pending : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
                    /**
                     * \@description
                     * Reports whether the control is disabled, meaning that the control is disabled
                     * in the UI and is exempt from validation checks and excluded from aggregate
                     * values of ancestor controls. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.disabled : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
                    /**
                     * \@description
                     * Reports whether the control is enabled, meaning that the control is included in ancestor
                     * calculations of validity or value. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.enabled : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "errors", {
                    /**
                     * \@description
                     * Reports the control's validation errors. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.errors : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
                    /**
                     * \@description
                     * Reports whether the control is pristine, meaning that the user has not yet changed
                     * the value in the UI. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.pristine : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
                    /**
                     * \@description
                     * Reports whether the control is dirty, meaning that the user has changed
                     * the value in the UI. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.dirty : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "touched", {
                    /**
                     * \@description
                     * Reports whether the control is touched, meaning that the user has triggered
                     * a `blur` event on it. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.touched : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "status", {
                    /**
                     * \@description
                     * Reports the validation status of the control. Possible values include:
                     * 'VALID', 'INVALID', 'DISABLED', and 'PENDING'.
                     * If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.status : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
                    /**
                     * \@description
                     * Reports whether the control is untouched, meaning that the user has not yet triggered
                     * a `blur` event on it. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () { return this.control ? this.control.untouched : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
                    /**
                     * \@description
                     * Returns a multicasting observable that emits a validation status whenever it is
                     * calculated for the control. If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () {
                        return this.control ? this.control.statusChanges : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
                    /**
                     * \@description
                     * Returns a multicasting observable of value changes for the control that emits every time the
                     * value of the control changes in the UI or programmatically.
                     * If the control is not present, null is returned.
                     * @return {?}
                     */
                    get: function () {
                        return this.control ? this.control.valueChanges : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlDirective.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array that represents the path from the top-level form to this control.
                     * Each index is the string name of the control on that level.
                     * @return {?}
                     */
                    get: function () { return null; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Resets the control with the provided value if the control is present.
                 * @param {?=} value
                 * @return {?}
                 */
                AbstractControlDirective.prototype.reset = function (value) {
                    if (value === void 0) { value = undefined; }
                    if (this.control)
                        this.control.reset(value);
                };
                /**
                 * \@description
                 * Reports whether the control with the given path has the error specified.
                 *
                 * \@usageNotes
                 * For example, for the following `FormGroup`:
                 *
                 * ```
                 * form = new FormGroup({
                 *   address: new FormGroup({ street: new FormControl() })
                 * });
                 * ```
                 *
                 * The path to the 'street' control from the root form would be 'address' -> 'street'.
                 *
                 * It can be provided to this method in one of two formats:
                 *
                 * 1. An array of string control names, e.g. `['address', 'street']`
                 * 1. A period-delimited list of control names in one string, e.g. `'address.street'`
                 *
                 * If no path is given, this method checks for the error on the current control.
                 *
                 * @param {?} errorCode The code of the error to check
                 * @param {?=} path A list of control names that designates how to move from the current control
                 * to the control that should be queried for errors.
                 *
                 * @return {?} whether the given error is present in the control at the given path.
                 *
                 * If the control is not present, false is returned.
                 */
                AbstractControlDirective.prototype.hasError = function (errorCode, path) {
                    return this.control ? this.control.hasError(errorCode, path) : false;
                };
                /**
                 * \@description
                 * Reports error data for the control with the given path.
                 *
                 * \@usageNotes
                 * For example, for the following `FormGroup`:
                 *
                 * ```
                 * form = new FormGroup({
                 *   address: new FormGroup({ street: new FormControl() })
                 * });
                 * ```
                 *
                 * The path to the 'street' control from the root form would be 'address' -> 'street'.
                 *
                 * It can be provided to this method in one of two formats:
                 *
                 * 1. An array of string control names, e.g. `['address', 'street']`
                 * 1. A period-delimited list of control names in one string, e.g. `'address.street'`
                 *
                 * @param {?} errorCode The code of the error to check
                 * @param {?=} path A list of control names that designates how to move from the current control
                 * to the control that should be queried for errors.
                 *
                 * @return {?} error data for that particular error. If the control or error is not present,
                 * null is returned.
                 */
                AbstractControlDirective.prototype.getError = function (errorCode, path) {
                    return this.control ? this.control.getError(errorCode, path) : null;
                };
                return AbstractControlDirective;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * A base class for directives that contain multiple registered instances of `NgControl`.
             * Only used by the forms module.
             *
             * \@publicApi
             * @abstract
             */
            var ControlContainer = /** @class */ (function (_super_1) {
                __extends(ControlContainer, _super_1);
                function ControlContainer() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                Object.defineProperty(ControlContainer.prototype, "formDirective", {
                    /**
                     * \@description
                     * The top-level form directive for the control.
                     * @return {?}
                     */
                    get: function () { return null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ControlContainer.prototype, "path", {
                    /**
                     * \@description
                     * The path to this group.
                     * @return {?}
                     */
                    get: function () { return null; },
                    enumerable: true,
                    configurable: true
                });
                return ControlContainer;
            }(AbstractControlDirective));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @return {?}
             */
            function unimplemented() {
                throw new Error('unimplemented');
            }
            /**
             * \@description
             * A base class that all control `FormControl`-based directives extend. It binds a `FormControl`
             * object to a DOM element.
             *
             * \@publicApi
             * @abstract
             */
            var NgControl = /** @class */ (function (_super_1) {
                __extends(NgControl, _super_1);
                function NgControl() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * \@description
                     * The parent form for the control.
                     *
                     * \@internal
                     */
                    _this._parent = null;
                    /**
                     * \@description
                     * The name for the control
                     */
                    _this.name = null;
                    /**
                     * \@description
                     * The value accessor for the control
                     */
                    _this.valueAccessor = null;
                    /**
                     * \@description
                     * The uncomposed array of synchronous validators for the control
                     *
                     * \@internal
                     */
                    _this._rawValidators = [];
                    /**
                     * \@description
                     * The uncomposed array of async validators for the control
                     *
                     * \@internal
                     */
                    _this._rawAsyncValidators = [];
                    return _this;
                }
                Object.defineProperty(NgControl.prototype, "validator", {
                    /**
                     * \@description
                     * The registered synchronous validator function for the control
                     *
                     * @throws An exception that this method is not implemented
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(unimplemented())); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgControl.prototype, "asyncValidator", {
                    /**
                     * \@description
                     * The registered async validator function for the control
                     *
                     * @throws An exception that this method is not implemented
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(unimplemented())); },
                    enumerable: true,
                    configurable: true
                });
                return NgControl;
            }(AbstractControlDirective));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var AbstractControlStatus = /** @class */ (function () {
                /**
                 * @param {?} cd
                 */
                function AbstractControlStatus(cd) {
                    this._cd = cd;
                }
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.untouched : false; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.touched : false; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.pristine : false; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.dirty : false; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.valid : false; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.invalid : false; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._cd.control ? this._cd.control.pending : false; },
                    enumerable: true,
                    configurable: true
                });
                return AbstractControlStatus;
            }());
            if (false) { }
            /** @type {?} */
            var ngControlStatusHost = {
                '[class.ng-untouched]': 'ngClassUntouched',
                '[class.ng-touched]': 'ngClassTouched',
                '[class.ng-pristine]': 'ngClassPristine',
                '[class.ng-dirty]': 'ngClassDirty',
                '[class.ng-valid]': 'ngClassValid',
                '[class.ng-invalid]': 'ngClassInvalid',
                '[class.ng-pending]': 'ngClassPending',
            };
            /**
             * \@description
             * Directive automatically applied to Angular form controls that sets CSS classes
             * based on control status.
             *
             * \@usageNotes
             *
             * ### CSS classes applied
             *
             * The following classes are applied as the properties become true:
             *
             * * ng-valid
             * * ng-invalid
             * * ng-pending
             * * ng-pristine
             * * ng-dirty
             * * ng-untouched
             * * ng-touched
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgControlStatus = /** @class */ (function (_super_1) {
                __extends(NgControlStatus, _super_1);
                /**
                 * @param {?} cd
                 */
                function NgControlStatus(cd) {
                    return _super_1.call(this, cd) || this;
                }
                return NgControlStatus;
            }(AbstractControlStatus));
            NgControlStatus.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] }
            ];
            /** @nocollapse */
            NgControlStatus.ctorParameters = function () { return [
                { type: NgControl, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }] }
            ]; };
            /**
             * \@description
             * Directive automatically applied to Angular form groups that sets CSS classes
             * based on control status (valid/invalid/dirty/etc).
             *
             * @see `NgControlStatus`
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgControlStatusGroup = /** @class */ (function (_super_1) {
                __extends(NgControlStatusGroup, _super_1);
                /**
                 * @param {?} cd
                 */
                function NgControlStatusGroup(cd) {
                    return _super_1.call(this, cd) || this;
                }
                return NgControlStatusGroup;
            }(AbstractControlStatus));
            NgControlStatusGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                            host: ngControlStatusHost
                        },] }
            ];
            /** @nocollapse */
            NgControlStatusGroup.ctorParameters = function () { return [
                { type: ControlContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} value
             * @return {?}
             */
            function isEmptyInputValue(value) {
                // we don't check for string here so it also works with arrays
                return value == null || value.length === 0;
            }
            /**
             * \@description
             * An `InjectionToken` for registering additional synchronous validators used with `AbstractControl`s.
             *
             * @see `NG_ASYNC_VALIDATORS`
             *
             * \@usageNotes
             *
             * ### Providing a custom validator
             *
             * The following example registers a custom validator directive. Adding the validator to the
             * existing collection of validators requires the `multi: true` option.
             *
             * ```typescript
             * \@Directive({
             *   selector: '[customValidator]',
             *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
             * })
             * class CustomValidatorDirective implements Validator {
             *   validate(control: AbstractControl): ValidationErrors | null {
             *     return { 'custom': true };
             *   }
             * }
             * ```
             *
             * \@publicApi
             * @type {?}
             */
            var NG_VALIDATORS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('NgValidators');
            /**
             * \@description
             * An `InjectionToken` for registering additional asynchronous validators used with `AbstractControl`s.
             *
             * @see `NG_VALIDATORS`
             *
             * \@publicApi
             * @type {?}
             */
            var NG_ASYNC_VALIDATORS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('NgAsyncValidators');
            /**
             * A regular expression that matches valid e-mail addresses.
             *
             * At a high level, this regexp matches e-mail addresses of the format `local-part\@tld`, where:
             * - `local-part` consists of one or more of the allowed characters (alphanumeric and some
             *   punctuation symbols).
             * - `local-part` cannot begin or end with a period (`.`).
             * - `local-part` cannot be longer than 64 characters.
             * - `tld` consists of one or more `labels` separated by periods (`.`). For example `localhost` or
             *   `foo.com`.
             * - A `label` consists of one or more of the allowed characters (alphanumeric, dashes (`-`) and
             *   periods (`.`)).
             * - A `label` cannot begin or end with a dash (`-`) or a period (`.`).
             * - A `label` cannot be longer than 63 characters.
             * - The whole address cannot be longer than 254 characters.
             *
             * ## Implementation background
             *
             * This regexp was ported over from AngularJS (see there for git history):
             * https://github.com/angular/angular.js/blob/c133ef836/src/ng/directive/input.js#L27
             * It is based on the
             * [WHATWG version](https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address) with
             * some enhancements to incorporate more RFC rules (such as rules related to domain names and the
             * lengths of different parts of the address). The main differences from the WHATWG version are:
             *   - Disallow `local-part` to begin or end with a period (`.`).
             *   - Disallow `local-part` length to exceed 64 characters.
             *   - Disallow total address length to exceed 254 characters.
             *
             * See [this commit](https://github.com/angular/angular.js/commit/f3f5cf72e) for more details.
             * @type {?}
             */
            var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            /**
             * \@description
             * Provides a set of built-in validators that can be used by form controls.
             *
             * A validator is a function that processes a `FormControl` or collection of
             * controls and returns an error map or null. A null map means that validation has passed.
             *
             * @see [Form Validation](/guide/form-validation)
             *
             * \@publicApi
             */
            var Validators = /** @class */ (function () {
                function Validators() {
                }
                /**
                 * \@description
                 * Validator that requires the control's value to be greater than or equal to the provided number.
                 * The validator exists only as a function and not as a directive.
                 *
                 * \@usageNotes
                 *
                 * ### Validate against a minimum of 3
                 *
                 * ```typescript
                 * const control = new FormControl(2, Validators.min(3));
                 *
                 * console.log(control.errors); // {min: {min: 3, actual: 2}}
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} min
                 * @return {?} A validator function that returns an error map with the
                 * `min` property if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.min = function (min) {
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
                            return null; // don't validate empty values to allow optional controls
                        }
                        /** @type {?} */
                        var value = parseFloat(control.value);
                        // Controls with NaN values after parsing should be treated as not having a
                        // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
                        return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
                    });
                };
                /**
                 * \@description
                 * Validator that requires the control's value to be less than or equal to the provided number.
                 * The validator exists only as a function and not as a directive.
                 *
                 * \@usageNotes
                 *
                 * ### Validate against a maximum of 15
                 *
                 * ```typescript
                 * const control = new FormControl(16, Validators.max(15));
                 *
                 * console.log(control.errors); // {max: {max: 15, actual: 16}}
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} max
                 * @return {?} A validator function that returns an error map with the
                 * `max` property if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.max = function (max) {
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
                            return null; // don't validate empty values to allow optional controls
                        }
                        /** @type {?} */
                        var value = parseFloat(control.value);
                        // Controls with NaN values after parsing should be treated as not having a
                        // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
                        return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
                    });
                };
                /**
                 * \@description
                 * Validator that requires the control have a non-empty value.
                 *
                 * \@usageNotes
                 *
                 * ### Validate that the field is non-empty
                 *
                 * ```typescript
                 * const control = new FormControl('', Validators.required);
                 *
                 * console.log(control.errors); // {required: true}
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} control
                 * @return {?} An error map with the `required` property
                 * if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.required = function (control) {
                    return isEmptyInputValue(control.value) ? { 'required': true } : null;
                };
                /**
                 * \@description
                 * Validator that requires the control's value be true. This validator is commonly
                 * used for required checkboxes.
                 *
                 * \@usageNotes
                 *
                 * ### Validate that the field value is true
                 *
                 * ```typescript
                 * const control = new FormControl('', Validators.requiredTrue);
                 *
                 * console.log(control.errors); // {required: true}
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} control
                 * @return {?} An error map that contains the `required` property
                 * set to `true` if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.requiredTrue = function (control) {
                    return control.value === true ? null : { 'required': true };
                };
                /**
                 * \@description
                 * Validator that requires the control's value pass an email validation test.
                 *
                 * Tests the value using a [regular expression](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions)
                 * pattern suitable for common usecases. The pattern is based on the definition of a valid email
                 * address in the [WHATWG HTML specification](https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address)
                 * with some enhancements to incorporate more RFC rules (such as rules related to domain names and
                 * the lengths of different parts of the address).
                 *
                 * The differences from the WHATWG version include:
                 * - Disallow `local-part` (the part before the `\@` symbol) to begin or end with a period (`.`).
                 * - Disallow `local-part` to be longer than 64 characters.
                 * - Disallow the whole address to be longer than 254 characters.
                 *
                 * If this pattern does not satisfy your business needs, you can use `Validators.pattern()` to
                 * validate the value against a different pattern.
                 *
                 * \@usageNotes
                 *
                 * ### Validate that the field matches a valid email pattern
                 *
                 * ```typescript
                 * const control = new FormControl('bad\@', Validators.email);
                 *
                 * console.log(control.errors); // {email: true}
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} control
                 * @return {?} An error map with the `email` property
                 * if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.email = function (control) {
                    if (isEmptyInputValue(control.value)) {
                        return null; // don't validate empty values to allow optional controls
                    }
                    return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
                };
                /**
                 * \@description
                 * Validator that requires the length of the control's value to be greater than or equal
                 * to the provided minimum length. This validator is also provided by default if you use the
                 * the HTML5 `minlength` attribute.
                 *
                 * \@usageNotes
                 *
                 * ### Validate that the field has a minimum of 3 characters
                 *
                 * ```typescript
                 * const control = new FormControl('ng', Validators.minLength(3));
                 *
                 * console.log(control.errors); // {minlength: {requiredLength: 3, actualLength: 2}}
                 * ```
                 *
                 * ```html
                 * <input minlength="5">
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} minLength
                 * @return {?} A validator function that returns an error map with the
                 * `minlength` if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.minLength = function (minLength) {
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        if (isEmptyInputValue(control.value)) {
                            return null; // don't validate empty values to allow optional controls
                        }
                        /** @type {?} */
                        var length = control.value ? control.value.length : 0;
                        return length < minLength ?
                            { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                            null;
                    });
                };
                /**
                 * \@description
                 * Validator that requires the length of the control's value to be less than or equal
                 * to the provided maximum length. This validator is also provided by default if you use the
                 * the HTML5 `maxlength` attribute.
                 *
                 * \@usageNotes
                 *
                 * ### Validate that the field has maximum of 5 characters
                 *
                 * ```typescript
                 * const control = new FormControl('Angular', Validators.maxLength(5));
                 *
                 * console.log(control.errors); // {maxlength: {requiredLength: 5, actualLength: 7}}
                 * ```
                 *
                 * ```html
                 * <input maxlength="5">
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} maxLength
                 * @return {?} A validator function that returns an error map with the
                 * `maxlength` property if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.maxLength = function (maxLength) {
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        /** @type {?} */
                        var length = control.value ? control.value.length : 0;
                        return length > maxLength ?
                            { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                            null;
                    });
                };
                /**
                 * \@description
                 * Validator that requires the control's value to match a regex pattern. This validator is also
                 * provided by default if you use the HTML5 `pattern` attribute.
                 *
                 * \@usageNotes
                 *
                 * ### Validate that the field only contains letters or spaces
                 *
                 * ```typescript
                 * const control = new FormControl('1', Validators.pattern('[a-zA-Z ]*'));
                 *
                 * console.log(control.errors); // {pattern: {requiredPattern: '^[a-zA-Z ]*$', actualValue: '1'}}
                 * ```
                 *
                 * ```html
                 * <input pattern="[a-zA-Z ]*">
                 * ```
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} pattern A regular expression to be used as is to test the values, or a string.
                 * If a string is passed, the `^` character is prepended and the `$` character is
                 * appended to the provided string (if not already present), and the resulting regular
                 * expression is used to test the values.
                 *
                 * @return {?} A validator function that returns an error map with the
                 * `pattern` property if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.pattern = function (pattern) {
                    if (!pattern)
                        return Validators.nullValidator;
                    /** @type {?} */
                    var regex;
                    /** @type {?} */
                    var regexStr;
                    if (typeof pattern === 'string') {
                        regexStr = '';
                        if (pattern.charAt(0) !== '^')
                            regexStr += '^';
                        regexStr += pattern;
                        if (pattern.charAt(pattern.length - 1) !== '$')
                            regexStr += '$';
                        regex = new RegExp(regexStr);
                    }
                    else {
                        regexStr = pattern.toString();
                        regex = pattern;
                    }
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        if (isEmptyInputValue(control.value)) {
                            return null; // don't validate empty values to allow optional controls
                        }
                        /** @type {?} */
                        var value = control.value;
                        return regex.test(value) ? null :
                            { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
                    });
                };
                /**
                 * \@description
                 * Validator that performs no operation.
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} control
                 * @return {?}
                 */
                Validators.nullValidator = function (control) { return null; };
                /**
                 * @param {?} validators
                 * @return {?}
                 */
                Validators.compose = function (validators) {
                    if (!validators)
                        return null;
                    /** @type {?} */
                    var presentValidators = ( /** @type {?} */(validators.filter(isPresent)));
                    if (presentValidators.length == 0)
                        return null;
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        return _mergeErrors(_executeValidators(control, presentValidators));
                    });
                };
                /**
                 * \@description
                 * Compose multiple async validators into a single function that returns the union
                 * of the individual error objects for the provided control.
                 *
                 * @see `updateValueAndValidity()`
                 *
                 * @param {?} validators
                 * @return {?} A validator function that returns an error map with the
                 * merged error objects of the async validators if the validation check fails, otherwise `null`.
                 *
                 */
                Validators.composeAsync = function (validators) {
                    if (!validators)
                        return null;
                    /** @type {?} */
                    var presentValidators = ( /** @type {?} */(validators.filter(isPresent)));
                    if (presentValidators.length == 0)
                        return null;
                    return ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        /** @type {?} */
                        var observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["forkJoin"])(observables).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(_mergeErrors));
                    });
                };
                return Validators;
            }());
            /**
             * @param {?} o
             * @return {?}
             */
            function isPresent(o) {
                return o != null;
            }
            /**
             * @param {?} r
             * @return {?}
             */
            function toObservable(r) {
                /** @type {?} */
                var obs = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵisPromise"])(r) ? Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(r) : r;
                if (!(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵisObservable"])(obs))) {
                    throw new Error("Expected validator to return Promise or Observable.");
                }
                return obs;
            }
            /**
             * @param {?} control
             * @param {?} validators
             * @return {?}
             */
            function _executeValidators(control, validators) {
                return validators.map(( /**
                 * @param {?} v
                 * @return {?}
                 */function (/**
                 * @param {?} v
                 * @return {?}
                 */ v) { return v(control); }));
            }
            /**
             * @param {?} control
             * @param {?} validators
             * @return {?}
             */
            function _executeAsyncValidators(control, validators) {
                return validators.map(( /**
                 * @param {?} v
                 * @return {?}
                 */function (/**
                 * @param {?} v
                 * @return {?}
                 */ v) { return v(control); }));
            }
            /**
             * @param {?} arrayOfErrors
             * @return {?}
             */
            function _mergeErrors(arrayOfErrors) {
                /** @type {?} */
                var res = arrayOfErrors.reduce(( /**
                 * @param {?} res
                 * @param {?} errors
                 * @return {?}
                 */function (res, errors) {
                    return errors != null ? Object.assign({}, ( /** @type {?} */(res)), errors) : ( /** @type {?} */(res));
                }), {});
                return Object.keys(res).length === 0 ? null : res;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @param {?} validator
             * @return {?}
             */
            function normalizeValidator(validator) {
                if ((( /** @type {?} */(validator))).validate) {
                    return ( /**
                     * @param {?} c
                     * @return {?}
                     */function (c) { return (( /** @type {?} */(validator))).validate(c); });
                }
                else {
                    return ( /** @type {?} */(validator));
                }
            }
            /**
             * @param {?} validator
             * @return {?}
             */
            function normalizeAsyncValidator(validator) {
                if ((( /** @type {?} */(validator))).validate) {
                    return ( /**
                     * @param {?} c
                     * @return {?}
                     */function (c) { return (( /** @type {?} */(validator))).validate(c); });
                }
                else {
                    return ( /** @type {?} */(validator));
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var NUMBER_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return NumberValueAccessor; })),
                multi: true
            };
            /**
             * \@description
             * The `ControlValueAccessor` for writing a number value and listening to number input changes.
             * The value accessor is used by the `FormControlDirective`, `FormControlName`, and  `NgModel`
             * directives.
             *
             * \@usageNotes
             *
             * ### Using a number input with a reactive form.
             *
             * The following example shows how to use a number input with a reactive form.
             *
             * ```ts
             * const totalCountControl = new FormControl();
             * ```
             *
             * ```
             * <input type="number" [formControl]="totalCountControl">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NumberValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 */
                function NumberValueAccessor(_renderer, _elementRef) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    /**
                     * \@description
                     * The registered callback function called when a change or input event occurs on the input
                     * element.
                     */
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                }
                /**
                 * Sets the "value" property on the input element.
                 *
                 * @param {?} value The checked value
                 * @return {?}
                 */
                NumberValueAccessor.prototype.writeValue = function (value) {
                    // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
                    /** @type {?} */
                    var normalizedValue = value == null ? '' : value;
                    this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                NumberValueAccessor.prototype.registerOnChange = function (fn) {
                    this.onChange = ( /**
                     * @param {?} value
                     * @return {?}
                     */function (value) { fn(value == '' ? null : parseFloat(value)); });
                };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                return NumberValueAccessor;
            }());
            NumberValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                            host: {
                                '(change)': 'onChange($event.target.value)',
                                '(input)': 'onChange($event.target.value)',
                                '(blur)': 'onTouched()'
                            },
                            providers: [NUMBER_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            NumberValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var RADIO_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return RadioControlValueAccessor; })),
                multi: true
            };
            /**
             * \@description
             * Class used by Angular to track radio buttons. For internal use only.
             */
            var RadioControlRegistry = /** @class */ (function () {
                function RadioControlRegistry() {
                    this._accessors = [];
                }
                /**
                 * \@description
                 * Adds a control to the internal registry. For internal use only.
                 * @param {?} control
                 * @param {?} accessor
                 * @return {?}
                 */
                RadioControlRegistry.prototype.add = function (control, accessor) {
                    this._accessors.push([control, accessor]);
                };
                /**
                 * \@description
                 * Removes a control from the internal registry. For internal use only.
                 * @param {?} accessor
                 * @return {?}
                 */
                RadioControlRegistry.prototype.remove = function (accessor) {
                    for (var i = this._accessors.length - 1; i >= 0; --i) {
                        if (this._accessors[i][1] === accessor) {
                            this._accessors.splice(i, 1);
                            return;
                        }
                    }
                };
                /**
                 * \@description
                 * Selects a radio button. For internal use only.
                 * @param {?} accessor
                 * @return {?}
                 */
                RadioControlRegistry.prototype.select = function (accessor) {
                    var _this = this;
                    this._accessors.forEach(( /**
                     * @param {?} c
                     * @return {?}
                     */function (c) {
                        if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                            c[1].fireUncheck(accessor.value);
                        }
                    }));
                };
                /**
                 * @private
                 * @param {?} controlPair
                 * @param {?} accessor
                 * @return {?}
                 */
                RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
                    if (!controlPair[0].control)
                        return false;
                    return controlPair[0]._parent === accessor._control._parent &&
                        controlPair[1].name === accessor.name;
                };
                return RadioControlRegistry;
            }());
            RadioControlRegistry.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            if (false) { }
            /**
             * \@description
             * The `ControlValueAccessor` for writing radio control values and listening to radio control
             * changes. The value accessor is used by the `FormControlDirective`, `FormControlName`, and
             * `NgModel` directives.
             *
             * \@usageNotes
             *
             * ### Using radio buttons with reactive form directives
             *
             * The follow example shows how to use radio buttons in a reactive form. When using radio buttons in
             * a reactive form, radio buttons in the same group should have the same `formControlName`.
             * Providing a `name` attribute is optional.
             *
             * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var RadioControlValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 * @param {?} _registry
                 * @param {?} _injector
                 */
                function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    this._registry = _registry;
                    this._injector = _injector;
                    /**
                     * \@description
                     * The registered callback function called when a change event occurs on the input element.
                     */
                    this.onChange = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive is initialized. For internal use only.
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.ngOnInit = function () {
                    this._control = this._injector.get(NgControl);
                    this._checkName();
                    this._registry.add(this._control, this);
                };
                /**
                 * \@description
                 * Lifecycle method called before the directive's instance is destroyed. For internal use only.
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
                /**
                 * \@description
                 * Sets the "checked" property value on the radio input element.
                 *
                 * @param {?} value The checked value
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.writeValue = function (value) {
                    this._state = value === this.value;
                    this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
                    var _this = this;
                    this._fn = fn;
                    this.onChange = ( /**
                     * @return {?}
                     */function () {
                        fn(_this.value);
                        _this._registry.select(_this);
                    });
                };
                /**
                 * Sets the "value" on the radio input element and unchecks it.
                 *
                 * @param {?} value
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                /**
                 * @private
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype._checkName = function () {
                    if (this.name && this.formControlName && this.name !== this.formControlName) {
                        this._throwNameError();
                    }
                    if (!this.name && this.formControlName)
                        this.name = this.formControlName;
                };
                /**
                 * @private
                 * @return {?}
                 */
                RadioControlValueAccessor.prototype._throwNameError = function () {
                    throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
                };
                return RadioControlValueAccessor;
            }());
            RadioControlValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                            host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                            providers: [RADIO_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            RadioControlValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: RadioControlRegistry },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injector"] }
            ]; };
            RadioControlValueAccessor.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                formControlName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var RANGE_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return RangeValueAccessor; })),
                multi: true
            };
            /**
             * \@description
             * The `ControlValueAccessor` for writing a range value and listening to range input changes.
             * The value accessor is used by the `FormControlDirective`, `FormControlName`, and  `NgModel`
             * directives.
             *
             * \@usageNotes
             *
             * ### Using a range input with a reactive form
             *
             * The following example shows how to use a range input with a reactive form.
             *
             * ```ts
             * const ageControl = new FormControl();
             * ```
             *
             * ```
             * <input type="range" [formControl]="ageControl">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var RangeValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 */
                function RangeValueAccessor(_renderer, _elementRef) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    /**
                     * \@description
                     * The registered callback function called when a change or input event occurs on the input
                     * element.
                     */
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                }
                /**
                 * Sets the "value" property on the input element.
                 *
                 * @param {?} value The checked value
                 * @return {?}
                 */
                RangeValueAccessor.prototype.writeValue = function (value) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                RangeValueAccessor.prototype.registerOnChange = function (fn) {
                    this.onChange = ( /**
                     * @param {?} value
                     * @return {?}
                     */function (value) { fn(value == '' ? null : parseFloat(value)); });
                };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the range input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                return RangeValueAccessor;
            }());
            RangeValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                            host: {
                                '(change)': 'onChange($event.target.value)',
                                '(input)': 'onChange($event.target.value)',
                                '(blur)': 'onTouched()'
                            },
                            providers: [RANGE_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            RangeValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var FormErrorExamples = {
                formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
                formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
                formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
                ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
                ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ReactiveErrors = /** @class */ (function () {
                function ReactiveErrors() {
                }
                /**
                 * @return {?}
                 */
                ReactiveErrors.controlParentException = function () {
                    throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
                };
                /**
                 * @return {?}
                 */
                ReactiveErrors.ngModelGroupException = function () {
                    throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
                };
                /**
                 * @return {?}
                 */
                ReactiveErrors.missingFormException = function () {
                    throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
                };
                /**
                 * @return {?}
                 */
                ReactiveErrors.groupParentException = function () {
                    throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
                };
                /**
                 * @return {?}
                 */
                ReactiveErrors.arrayParentException = function () {
                    throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
                };
                /**
                 * @return {?}
                 */
                ReactiveErrors.disabledAttrWarning = function () {
                    console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
                };
                /**
                 * @param {?} directiveName
                 * @return {?}
                 */
                ReactiveErrors.ngModelWarning = function (directiveName) {
                    console.warn("\n    It looks like you're using ngModel on the same form field as " + directiveName + ". \n    Support for using the ngModel input property and ngModelChange event with \n    reactive form directives has been deprecated in Angular v6 and will be removed \n    in Angular v7.\n    \n    For more information on this, see our API docs here:\n    https://angular.io/api/forms/" + (directiveName === 'formControl' ? 'FormControlDirective'
                        : 'FormControlName') + "#use-with-ngmodel\n    ");
                };
                return ReactiveErrors;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var SELECT_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return SelectControlValueAccessor; })),
                multi: true
            };
            /**
             * @param {?} id
             * @param {?} value
             * @return {?}
             */
            function _buildValueString(id, value) {
                if (id == null)
                    return "" + value;
                if (value && typeof value === 'object')
                    value = 'Object';
                return (id + ": " + value).slice(0, 50);
            }
            /**
             * @param {?} valueString
             * @return {?}
             */
            function _extractId(valueString) {
                return valueString.split(':')[0];
            }
            /**
             * \@description
             * The `ControlValueAccessor` for writing select control values and listening to select control
             * changes. The value accessor is used by the `FormControlDirective`, `FormControlName`, and
             * `NgModel` directives.
             *
             * \@usageNotes
             *
             * ### Using select controls in a reactive form
             *
             * The following examples show how to use a select control in a reactive form.
             *
             * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
             *
             * ### Using select controls in a template-driven form
             *
             * To use a select in a template-driven form, simply add an `ngModel` and a `name`
             * attribute to the main `<select>` tag.
             *
             * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
             *
             * ### Customizing option selection
             *
             * Angular uses object identity to select option. It's possible for the identities of items
             * to change while the data does not. This can happen, for example, if the items are produced
             * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
             * second response will produce objects with different identities.
             *
             * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
             * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
             * If `compareWith` is given, Angular selects option by the return value of the function.
             *
             * ```ts
             * const selectedCountriesControl = new FormControl();
             * ```
             *
             * ```
             * <select [compareWith]="compareFn"  [formControl]="selectedCountriesControl">
             *     <option *ngFor="let country of countries" [ngValue]="country">
             *         {{country.name}}
             *     </option>
             * </select>
             *
             * compareFn(c1: Country, c2: Country): boolean {
             *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
             * }
             * ```
             *
             * **Note:** We listen to the 'change' event because 'input' events aren't fired
             * for selects in Firefox and IE:
             * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
             * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var SelectControlValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 */
                function SelectControlValueAccessor(_renderer, _elementRef) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    /**
                     * \@internal
                     */
                    this._optionMap = new Map();
                    /**
                     * \@internal
                     */
                    this._idCounter = 0;
                    /**
                     * \@description
                     * The registered callback function called when a change event occurs on the input element.
                     */
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                    this._compareWith = _angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵlooseIdentical"];
                }
                Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
                    /**
                     * \@description
                     * Tracks the option comparison algorithm for tracking identities when
                     * checking for changes.
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        if (typeof fn !== 'function') {
                            throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
                        }
                        this._compareWith = fn;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the "value" property on the input element. The "selectedIndex"
                 * property is also set if an ID is provided on the option element.
                 *
                 * @param {?} value The checked value
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype.writeValue = function (value) {
                    this.value = value;
                    /** @type {?} */
                    var id = this._getOptionId(value);
                    if (id == null) {
                        this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
                    }
                    /** @type {?} */
                    var valueString = _buildValueString(id, value);
                    this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
                    var _this = this;
                    this.onChange = ( /**
                     * @param {?} valueString
                     * @return {?}
                     */function (valueString) {
                        _this.value = _this._getOptionValue(valueString);
                        fn(_this.value);
                    });
                };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the select input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype._getOptionId = function (value) {
                    for (var _c = 0, _d = Array.from(this._optionMap.keys()); _c < _d.length; _c++) {
                        var id = _d[_c];
                        if (this._compareWith(this._optionMap.get(id), value))
                            return id;
                    }
                    return null;
                };
                /**
                 * \@internal
                 * @param {?} valueString
                 * @return {?}
                 */
                SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
                    /** @type {?} */
                    var id = _extractId(valueString);
                    return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
                };
                return SelectControlValueAccessor;
            }());
            SelectControlValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                            host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                            providers: [SELECT_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            SelectControlValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            SelectControlValueAccessor.propDecorators = {
                compareWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@description
             * Marks `<option>` as dynamic, so Angular can be notified when options change.
             *
             * @see `SelectControlValueAccessor`
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgSelectOption = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _renderer
                 * @param {?} _select
                 */
                function NgSelectOption(_element, _renderer, _select) {
                    this._element = _element;
                    this._renderer = _renderer;
                    this._select = _select;
                    if (this._select)
                        this.id = this._select._registerOption();
                }
                Object.defineProperty(NgSelectOption.prototype, "ngValue", {
                    /**
                     * \@description
                     * Tracks the value bound to the option element. Unlike the value binding,
                     * ngValue supports binding to objects.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._select == null)
                            return;
                        this._select._optionMap.set(this.id, value);
                        this._setElementValue(_buildValueString(this.id, value));
                        this._select.writeValue(this._select.value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgSelectOption.prototype, "value", {
                    /**
                     * \@description
                     * Tracks simple string values bound to the option element.
                     * For objects, use the `ngValue` input binding.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._setElementValue(value);
                        if (this._select)
                            this._select.writeValue(this._select.value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                NgSelectOption.prototype._setElementValue = function (value) {
                    this._renderer.setProperty(this._element.nativeElement, 'value', value);
                };
                /**
                 * \@description
                 * Lifecycle method called before the directive's instance is destroyed. For internal use only.
                 * @return {?}
                 */
                NgSelectOption.prototype.ngOnDestroy = function () {
                    if (this._select) {
                        this._select._optionMap.delete(this.id);
                        this._select.writeValue(this._select.value);
                    }
                };
                return NgSelectOption;
            }());
            NgSelectOption.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: 'option' },] }
            ];
            /** @nocollapse */
            NgSelectOption.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: SelectControlValueAccessor, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] }
            ]; };
            NgSelectOption.propDecorators = {
                ngValue: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngValue',] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['value',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var SELECT_MULTIPLE_VALUE_ACCESSOR = {
                provide: NG_VALUE_ACCESSOR,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return SelectMultipleControlValueAccessor; })),
                multi: true
            };
            /**
             * @param {?} id
             * @param {?} value
             * @return {?}
             */
            function _buildValueString$1(id, value) {
                if (id == null)
                    return "" + value;
                if (typeof value === 'string')
                    value = "'" + value + "'";
                if (value && typeof value === 'object')
                    value = 'Object';
                return (id + ": " + value).slice(0, 50);
            }
            /**
             * @param {?} valueString
             * @return {?}
             */
            function _extractId$1(valueString) {
                return valueString.split(':')[0];
            }
            /**
             * Mock interface for HTML Options
             * @record
             */
            function HTMLOption() { }
            if (false) { }
            /**
             * Mock interface for HTMLCollection
             * @abstract
             */
            var HTMLCollection = /** @class */ (function () {
                function HTMLCollection() {
                }
                return HTMLCollection;
            }());
            if (false) { }
            /**
             * \@description
             * The `ControlValueAccessor` for writing multi-select control values and listening to multi-select control
             * changes. The value accessor is used by the `FormControlDirective`, `FormControlName`, and `NgModel`
             * directives.
             *
             * @see `SelectControlValueAccessor`
             *
             * \@usageNotes
             *
             * ### Using a multi-select control
             *
             * The follow example shows you how to use a multi-select control with a reactive form.
             *
             * ```ts
             * const countryControl = new FormControl();
             * ```
             *
             * ```
             * <select multiple name="countries" [formControl]="countryControl">
             *   <option *ngFor="let country of countries" [ngValue]="country">
             *     {{ country.name }}
             *   </option>
             * </select>
             * ```
             *
             * ### Customizing option selection
             *
             * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
             * See the `SelectControlValueAccessor` for usage.
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var SelectMultipleControlValueAccessor = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} _elementRef
                 */
                function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
                    this._renderer = _renderer;
                    this._elementRef = _elementRef;
                    /**
                     * \@internal
                     */
                    this._optionMap = new Map();
                    /**
                     * \@internal
                     */
                    this._idCounter = 0;
                    /**
                     * \@description
                     * The registered callback function called when a change event occurs on the input element.
                     */
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * \@description
                     * The registered callback function called when a blur event occurs on the input element.
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                    this._compareWith = _angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵlooseIdentical"];
                }
                Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
                    /**
                     * \@description
                     * Tracks the option comparison algorithm for tracking identities when
                     * checking for changes.
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        if (typeof fn !== 'function') {
                            throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
                        }
                        this._compareWith = fn;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Sets the "value" property on one or of more
                 * of the select's options.
                 *
                 * @param {?} value The value
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
                    var _this = this;
                    this.value = value;
                    /** @type {?} */
                    var optionSelectedStateSetter;
                    if (Array.isArray(value)) {
                        // convert values to ids
                        /** @type {?} */
                        var ids_1 = value.map(( /**
                         * @param {?} v
                         * @return {?}
                         */function (v) { return _this._getOptionId(v); }));
                        optionSelectedStateSetter = ( /**
                         * @param {?} opt
                         * @param {?} o
                         * @return {?}
                         */function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); });
                    }
                    else {
                        optionSelectedStateSetter = ( /**
                         * @param {?} opt
                         * @param {?} o
                         * @return {?}
                         */function (opt, o) { opt._setSelected(false); });
                    }
                    this._optionMap.forEach(optionSelectedStateSetter);
                };
                /**
                 * \@description
                 * Registers a function called when the control value changes
                 * and writes an array of the selected options.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
                    var _this = this;
                    this.onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) {
                        /** @type {?} */
                        var selected = [];
                        if (_.hasOwnProperty('selectedOptions')) {
                            /** @type {?} */
                            var options = _.selectedOptions;
                            for (var i = 0; i < options.length; i++) {
                                /** @type {?} */
                                var opt = options.item(i);
                                /** @type {?} */
                                var val = _this._getOptionValue(opt.value);
                                selected.push(val);
                            }
                        }
                        // Degrade on IE
                        else {
                            /** @type {?} */
                            var options = ( /** @type {?} */(_.options));
                            for (var i = 0; i < options.length; i++) {
                                /** @type {?} */
                                var opt = options.item(i);
                                if (opt.selected) {
                                    /** @type {?} */
                                    var val = _this._getOptionValue(opt.value);
                                    selected.push(val);
                                }
                            }
                        }
                        _this.value = selected;
                        fn(selected);
                    });
                };
                /**
                 * \@description
                 * Registers a function called when the control is touched.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
                /**
                 * Sets the "disabled" property on the select input element.
                 *
                 * @param {?} isDisabled The disabled value
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
                    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
                };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
                    /** @type {?} */
                    var id = (this._idCounter++).toString();
                    this._optionMap.set(id, value);
                    return id;
                };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
                    for (var _c = 0, _d = Array.from(this._optionMap.keys()); _c < _d.length; _c++) {
                        var id = _d[_c];
                        if (this._compareWith(( /** @type {?} */(this._optionMap.get(id)))._value, value))
                            return id;
                    }
                    return null;
                };
                /**
                 * \@internal
                 * @param {?} valueString
                 * @return {?}
                 */
                SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
                    /** @type {?} */
                    var id = _extractId$1(valueString);
                    return this._optionMap.has(id) ? ( /** @type {?} */(this._optionMap.get(id)))._value : valueString;
                };
                return SelectMultipleControlValueAccessor;
            }());
            SelectMultipleControlValueAccessor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                            host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                            providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                        },] }
            ];
            /** @nocollapse */
            SelectMultipleControlValueAccessor.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            SelectMultipleControlValueAccessor.propDecorators = {
                compareWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@description
             * Marks `<option>` as dynamic, so Angular can be notified when options change.
             *
             * @see `SelectMultipleControlValueAccessor`
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var ɵNgSelectMultipleOption = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _renderer
                 * @param {?} _select
                 */
                function ɵNgSelectMultipleOption(_element, _renderer, _select) {
                    this._element = _element;
                    this._renderer = _renderer;
                    this._select = _select;
                    if (this._select) {
                        this.id = this._select._registerOption(this);
                    }
                }
                Object.defineProperty(ɵNgSelectMultipleOption.prototype, "ngValue", {
                    /**
                     * \@description
                     * Tracks the value bound to the option element. Unlike the value binding,
                     * ngValue supports binding to objects.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._select == null)
                            return;
                        this._value = value;
                        this._setElementValue(_buildValueString$1(this.id, value));
                        this._select.writeValue(this._select.value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ɵNgSelectMultipleOption.prototype, "value", {
                    /**
                     * \@description
                     * Tracks simple string values bound to the option element.
                     * For objects, use the `ngValue` input binding.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._select) {
                            this._value = value;
                            this._setElementValue(_buildValueString$1(this.id, value));
                            this._select.writeValue(this._select.value);
                        }
                        else {
                            this._setElementValue(value);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                ɵNgSelectMultipleOption.prototype._setElementValue = function (value) {
                    this._renderer.setProperty(this._element.nativeElement, 'value', value);
                };
                /**
                 * \@internal
                 * @param {?} selected
                 * @return {?}
                 */
                ɵNgSelectMultipleOption.prototype._setSelected = function (selected) {
                    this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
                };
                /**
                 * \@description
                 * Lifecycle method called before the directive's instance is destroyed. For internal use only.
                 * @return {?}
                 */
                ɵNgSelectMultipleOption.prototype.ngOnDestroy = function () {
                    if (this._select) {
                        this._select._optionMap.delete(this.id);
                        this._select.writeValue(this._select.value);
                    }
                };
                return ɵNgSelectMultipleOption;
            }());
            ɵNgSelectMultipleOption.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: 'option' },] }
            ];
            /** @nocollapse */
            ɵNgSelectMultipleOption.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Renderer2"] },
                { type: SelectMultipleControlValueAccessor, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] }
            ]; };
            ɵNgSelectMultipleOption.propDecorators = {
                ngValue: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngValue',] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['value',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} name
             * @param {?} parent
             * @return {?}
             */
            function controlPath(name, parent) {
                return ( /** @type {?} */(parent.path)).concat([name]);
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function setUpControl(control, dir) {
                if (!control)
                    _throwError(dir, 'Cannot find control with');
                if (!dir.valueAccessor)
                    _throwError(dir, 'No value accessor for form control with');
                control.validator = Validators.compose([( /** @type {?} */(control.validator)), dir.validator]);
                control.asyncValidator = Validators.composeAsync([( /** @type {?} */(control.asyncValidator)), dir.asyncValidator]);
                ( /** @type {?} */(dir.valueAccessor)).writeValue(control.value);
                setUpViewChangePipeline(control, dir);
                setUpModelChangePipeline(control, dir);
                setUpBlurPipeline(control, dir);
                if (( /** @type {?} */(dir.valueAccessor)).setDisabledState) {
                    control.registerOnDisabledChange(( /**
                     * @param {?} isDisabled
                     * @return {?}
                     */function (isDisabled) { ( /** @type {?} */(( /** @type {?} */(dir.valueAccessor)).setDisabledState))(isDisabled); }));
                }
                // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
                dir._rawValidators.forEach(( /**
                 * @param {?} validator
                 * @return {?}
                 */function (validator) {
                    if ((( /** @type {?} */(validator))).registerOnValidatorChange)
                        ( /** @type {?} */((( /** @type {?} */(validator))).registerOnValidatorChange))(( /**
                         * @return {?}
                         */function () { return control.updateValueAndValidity(); }));
                }));
                dir._rawAsyncValidators.forEach(( /**
                 * @param {?} validator
                 * @return {?}
                 */function (validator) {
                    if ((( /** @type {?} */(validator))).registerOnValidatorChange)
                        ( /** @type {?} */((( /** @type {?} */(validator))).registerOnValidatorChange))(( /**
                         * @return {?}
                         */function () { return control.updateValueAndValidity(); }));
                }));
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function cleanUpControl(control, dir) {
                ( /** @type {?} */(dir.valueAccessor)).registerOnChange(( /**
                 * @return {?}
                 */function () { return _noControlError(dir); }));
                ( /** @type {?} */(dir.valueAccessor)).registerOnTouched(( /**
                 * @return {?}
                 */function () { return _noControlError(dir); }));
                dir._rawValidators.forEach(( /**
                 * @param {?} validator
                 * @return {?}
                 */function (validator) {
                    if (validator.registerOnValidatorChange) {
                        validator.registerOnValidatorChange(null);
                    }
                }));
                dir._rawAsyncValidators.forEach(( /**
                 * @param {?} validator
                 * @return {?}
                 */function (validator) {
                    if (validator.registerOnValidatorChange) {
                        validator.registerOnValidatorChange(null);
                    }
                }));
                if (control)
                    control._clearChangeFns();
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function setUpViewChangePipeline(control, dir) {
                ( /** @type {?} */(dir.valueAccessor)).registerOnChange(( /**
                 * @param {?} newValue
                 * @return {?}
                 */function (newValue) {
                    control._pendingValue = newValue;
                    control._pendingChange = true;
                    control._pendingDirty = true;
                    if (control.updateOn === 'change')
                        updateControl(control, dir);
                }));
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function setUpBlurPipeline(control, dir) {
                ( /** @type {?} */(dir.valueAccessor)).registerOnTouched(( /**
                 * @return {?}
                 */function () {
                    control._pendingTouched = true;
                    if (control.updateOn === 'blur' && control._pendingChange)
                        updateControl(control, dir);
                    if (control.updateOn !== 'submit')
                        control.markAsTouched();
                }));
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function updateControl(control, dir) {
                if (control._pendingDirty)
                    control.markAsDirty();
                control.setValue(control._pendingValue, { emitModelToViewChange: false });
                dir.viewToModelUpdate(control._pendingValue);
                control._pendingChange = false;
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function setUpModelChangePipeline(control, dir) {
                control.registerOnChange(( /**
                 * @param {?} newValue
                 * @param {?} emitModelEvent
                 * @return {?}
                 */function (newValue, emitModelEvent) {
                    // control -> view
                    ( /** @type {?} */(dir.valueAccessor)).writeValue(newValue);
                    // control -> ngModel
                    if (emitModelEvent)
                        dir.viewToModelUpdate(newValue);
                }));
            }
            /**
             * @param {?} control
             * @param {?} dir
             * @return {?}
             */
            function setUpFormContainer(control, dir) {
                if (control == null)
                    _throwError(dir, 'Cannot find control with');
                control.validator = Validators.compose([control.validator, dir.validator]);
                control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
            }
            /**
             * @param {?} dir
             * @return {?}
             */
            function _noControlError(dir) {
                return _throwError(dir, 'There is no FormControl instance attached to form control element with');
            }
            /**
             * @param {?} dir
             * @param {?} message
             * @return {?}
             */
            function _throwError(dir, message) {
                /** @type {?} */
                var messageEnd;
                if (( /** @type {?} */(dir.path)).length > 1) {
                    messageEnd = "path: '" + ( /** @type {?} */(dir.path)).join(' -> ') + "'";
                }
                else if (( /** @type {?} */(dir.path))[0]) {
                    messageEnd = "name: '" + dir.path + "'";
                }
                else {
                    messageEnd = 'unspecified name attribute';
                }
                throw new Error(message + " " + messageEnd);
            }
            /**
             * @param {?} validators
             * @return {?}
             */
            function composeValidators(validators) {
                return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
            }
            /**
             * @param {?} validators
             * @return {?}
             */
            function composeAsyncValidators(validators) {
                return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
                    null;
            }
            /**
             * @param {?} changes
             * @param {?} viewModel
             * @return {?}
             */
            function isPropertyUpdated(changes, viewModel) {
                if (!changes.hasOwnProperty('model'))
                    return false;
                /** @type {?} */
                var change = changes['model'];
                if (change.isFirstChange())
                    return true;
                return !Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵlooseIdentical"])(viewModel, change.currentValue);
            }
            /** @type {?} */
            var BUILTIN_ACCESSORS = [
                CheckboxControlValueAccessor,
                RangeValueAccessor,
                NumberValueAccessor,
                SelectControlValueAccessor,
                SelectMultipleControlValueAccessor,
                RadioControlValueAccessor,
            ];
            /**
             * @param {?} valueAccessor
             * @return {?}
             */
            function isBuiltInAccessor(valueAccessor) {
                return BUILTIN_ACCESSORS.some(( /**
                 * @param {?} a
                 * @return {?}
                 */function (/**
                 * @param {?} a
                 * @return {?}
                 */ a) { return valueAccessor.constructor === a; }));
            }
            /**
             * @param {?} form
             * @param {?} directives
             * @return {?}
             */
            function syncPendingControls(form, directives) {
                form._syncPendingControls();
                directives.forEach(( /**
                 * @param {?} dir
                 * @return {?}
                 */function (/**
                 * @param {?} dir
                 * @return {?}
                 */ dir) {
                    /** @type {?} */
                    var control = ( /** @type {?} */(dir.control));
                    if (control.updateOn === 'submit' && control._pendingChange) {
                        dir.viewToModelUpdate(control._pendingValue);
                        control._pendingChange = false;
                    }
                }));
            }
            // TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
            /**
             * @param {?} dir
             * @param {?} valueAccessors
             * @return {?}
             */
            function selectValueAccessor(dir, valueAccessors) {
                if (!valueAccessors)
                    return null;
                if (!Array.isArray(valueAccessors))
                    _throwError(dir, 'Value accessor was not provided as an array for form control with');
                /** @type {?} */
                var defaultAccessor = undefined;
                /** @type {?} */
                var builtinAccessor = undefined;
                /** @type {?} */
                var customAccessor = undefined;
                valueAccessors.forEach(( /**
                 * @param {?} v
                 * @return {?}
                 */function (v) {
                    if (v.constructor === DefaultValueAccessor) {
                        defaultAccessor = v;
                    }
                    else if (isBuiltInAccessor(v)) {
                        if (builtinAccessor)
                            _throwError(dir, 'More than one built-in value accessor matches form control with');
                        builtinAccessor = v;
                    }
                    else {
                        if (customAccessor)
                            _throwError(dir, 'More than one custom value accessor matches form control with');
                        customAccessor = v;
                    }
                }));
                if (customAccessor)
                    return customAccessor;
                if (builtinAccessor)
                    return builtinAccessor;
                if (defaultAccessor)
                    return defaultAccessor;
                _throwError(dir, 'No valid value accessor for form control with');
                return null;
            }
            /**
             * @template T
             * @param {?} list
             * @param {?} el
             * @return {?}
             */
            function removeDir(list, el) {
                /** @type {?} */
                var index = list.indexOf(el);
                if (index > -1)
                    list.splice(index, 1);
            }
            // TODO(kara): remove after deprecation period
            /**
             * @param {?} name
             * @param {?} type
             * @param {?} instance
             * @param {?} warningConfig
             * @return {?}
             */
            function _ngModelWarning(name, type, instance, warningConfig) {
                if (!Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["isDevMode"])() || warningConfig === 'never')
                    return;
                if (((warningConfig === null || warningConfig === 'once') && !type._ngModelWarningSentOnce) ||
                    (warningConfig === 'always' && !instance._ngModelWarningSent)) {
                    ReactiveErrors.ngModelWarning(name);
                    type._ngModelWarningSentOnce = true;
                    instance._ngModelWarningSent = true;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Reports that a FormControl is valid, meaning that no errors exist in the input value.
             *
             * @see `status`
             * @type {?}
             */
            var VALID = 'VALID';
            /**
             * Reports that a FormControl is invalid, meaning that an error exists in the input value.
             *
             * @see `status`
             * @type {?}
             */
            var INVALID = 'INVALID';
            /**
             * Reports that a FormControl is pending, meaning that that async validation is occurring and
             * errors are not yet available for the input value.
             *
             * @see `markAsPending`
             * @see `status`
             * @type {?}
             */
            var PENDING = 'PENDING';
            /**
             * Reports that a FormControl is disabled, meaning that the control is exempt from ancestor
             * calculations of validity or value.
             *
             * @see `markAsDisabled`
             * @see `status`
             * @type {?}
             */
            var DISABLED = 'DISABLED';
            /**
             * @param {?} control
             * @param {?} path
             * @param {?} delimiter
             * @return {?}
             */
            function _find(control, path, delimiter) {
                if (path == null)
                    return null;
                if (!(path instanceof Array)) {
                    path = (( /** @type {?} */(path))).split(delimiter);
                }
                if (path instanceof Array && (path.length === 0))
                    return null;
                return (( /** @type {?} */(path))).reduce(( /**
                 * @param {?} v
                 * @param {?} name
                 * @return {?}
                 */function (v, name) {
                    if (v instanceof FormGroup) {
                        return v.controls.hasOwnProperty(( /** @type {?} */(name))) ? v.controls[name] : null;
                    }
                    if (v instanceof FormArray) {
                        return v.at(( /** @type {?} */(name))) || null;
                    }
                    return null;
                }), control);
            }
            /**
             * @param {?=} validatorOrOpts
             * @return {?}
             */
            function coerceToValidator(validatorOrOpts) {
                /** @type {?} */
                var validator = ( /** @type {?} */((isOptionsObj(validatorOrOpts) ? (( /** @type {?} */(validatorOrOpts))).validators :
                    validatorOrOpts)));
                return Array.isArray(validator) ? composeValidators(validator) : validator || null;
            }
            /**
             * @param {?=} asyncValidator
             * @param {?=} validatorOrOpts
             * @return {?}
             */
            function coerceToAsyncValidator(asyncValidator, validatorOrOpts) {
                /** @type {?} */
                var origAsyncValidator = ( /** @type {?} */((isOptionsObj(validatorOrOpts) ? (( /** @type {?} */(validatorOrOpts))).asyncValidators :
                    asyncValidator)));
                return Array.isArray(origAsyncValidator) ? composeAsyncValidators(origAsyncValidator) :
                    origAsyncValidator || null;
            }
            /**
             * Interface for options provided to an `AbstractControl`.
             *
             * \@publicApi
             * @record
             */
            function AbstractControlOptions() { }
            if (false) { }
            /**
             * @param {?=} validatorOrOpts
             * @return {?}
             */
            function isOptionsObj(validatorOrOpts) {
                return validatorOrOpts != null && !Array.isArray(validatorOrOpts) &&
                    typeof validatorOrOpts === 'object';
            }
            /**
             * This is the base class for `FormControl`, `FormGroup`, and `FormArray`.
             *
             * It provides some of the shared behavior that all controls and groups of controls have, like
             * running validators, calculating status, and resetting state. It also defines the properties
             * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
             * instantiated directly.
             *
             * @see [Forms Guide](/guide/forms)
             * @see [Reactive Forms Guide](/guide/reactive-forms)
             * @see [Dynamic Forms Guide](/guide/dynamic-form)
             *
             * \@publicApi
             * @abstract
             */
            var AbstractControl = /** @class */ (function () {
                /**
                 * Initialize the AbstractControl instance.
                 *
                 * @param {?} validator The function that determines the synchronous validity of this control.
                 * @param {?} asyncValidator The function that determines the asynchronous validity of this
                 * control.
                 */
                function AbstractControl(validator, asyncValidator) {
                    this.validator = validator;
                    this.asyncValidator = asyncValidator;
                    /**
                     * \@internal
                     */
                    this._onCollectionChange = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * A control is `pristine` if the user has not yet changed
                     * the value in the UI.
                     *
                     * @return True if the user has not yet changed the value in the UI; compare `dirty`.
                     * Programmatic changes to a control's value do not mark it dirty.
                     */
                    this.pristine = true;
                    /**
                     * True if the control is marked as `touched`.
                     *
                     * A control is marked `touched` once the user has triggered
                     * a `blur` event on it.
                     */
                    this.touched = false;
                    /**
                     * \@internal
                     */
                    this._onDisabledChange = [];
                }
                Object.defineProperty(AbstractControl.prototype, "parent", {
                    /**
                     * The parent control.
                     * @return {?}
                     */
                    get: function () { return this._parent; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "valid", {
                    /**
                     * A control is `valid` when its `status` is `VALID`.
                     *
                     * @see {\@link AbstractControl.status}
                     *
                     * @return {?} True if the control has passed all of its validation tests,
                     * false otherwise.
                     */
                    get: function () { return this.status === VALID; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "invalid", {
                    /**
                     * A control is `invalid` when its `status` is `INVALID`.
                     *
                     * @see {\@link AbstractControl.status}
                     *
                     * @return {?} True if this control has failed one or more of its validation checks,
                     * false otherwise.
                     */
                    get: function () { return this.status === INVALID; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "pending", {
                    /**
                     * A control is `pending` when its `status` is `PENDING`.
                     *
                     * @see {\@link AbstractControl.status}
                     *
                     * @return {?} True if this control is in the process of conducting a validation check,
                     * false otherwise.
                     */
                    get: function () { return this.status == PENDING; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "disabled", {
                    /**
                     * A control is `disabled` when its `status` is `DISABLED`.
                     *
                     * Disabled controls are exempt from validation checks and
                     * are not included in the aggregate value of their ancestor
                     * controls.
                     *
                     * @see {\@link AbstractControl.status}
                     *
                     * @return {?} True if the control is disabled, false otherwise.
                     */
                    get: function () { return this.status === DISABLED; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "enabled", {
                    /**
                     * A control is `enabled` as long as its `status` is not `DISABLED`.
                     *
                     * @see {\@link AbstractControl.status}
                     *
                     * @return {?} True if the control has any status other than 'DISABLED',
                     * false if the status is 'DISABLED'.
                     *
                     */
                    get: function () { return this.status !== DISABLED; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "dirty", {
                    /**
                     * A control is `dirty` if the user has changed the value
                     * in the UI.
                     *
                     * @return {?} True if the user has changed the value of this control in the UI; compare `pristine`.
                     * Programmatic changes to a control's value do not mark it dirty.
                     */
                    get: function () { return !this.pristine; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "untouched", {
                    /**
                     * True if the control has not been marked as touched
                     *
                     * A control is `untouched` if the user has not yet triggered
                     * a `blur` event on it.
                     * @return {?}
                     */
                    get: function () { return !this.touched; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractControl.prototype, "updateOn", {
                    /**
                     * Reports the update strategy of the `AbstractControl` (meaning
                     * the event on which the control updates itself).
                     * Possible values: `'change'` | `'blur'` | `'submit'`
                     * Default value: `'change'`
                     * @return {?}
                     */
                    get: function () {
                        return this._updateOn ? this._updateOn : (this.parent ? this.parent.updateOn : 'change');
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the synchronous validators that are active on this control.  Calling
                 * this overwrites any existing sync validators.
                 *
                 * When you add or remove a validator at run time, you must call
                 * `updateValueAndValidity()` for the new validation to take effect.
                 *
                 * @param {?} newValidator
                 * @return {?}
                 */
                AbstractControl.prototype.setValidators = function (newValidator) {
                    this.validator = coerceToValidator(newValidator);
                };
                /**
                 * Sets the async validators that are active on this control. Calling this
                 * overwrites any existing async validators.
                 *
                 * When you add or remove a validator at run time, you must call
                 * `updateValueAndValidity()` for the new validation to take effect.
                 *
                 * @param {?} newValidator
                 * @return {?}
                 */
                AbstractControl.prototype.setAsyncValidators = function (newValidator) {
                    this.asyncValidator = coerceToAsyncValidator(newValidator);
                };
                /**
                 * Empties out the sync validator list.
                 *
                 * When you add or remove a validator at run time, you must call
                 * `updateValueAndValidity()` for the new validation to take effect.
                 *
                 * @return {?}
                 */
                AbstractControl.prototype.clearValidators = function () { this.validator = null; };
                /**
                 * Empties out the async validator list.
                 *
                 * When you add or remove a validator at run time, you must call
                 * `updateValueAndValidity()` for the new validation to take effect.
                 *
                 * @return {?}
                 */
                AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
                /**
                 * Marks the control as `touched`. A control is touched by focus and
                 * blur events that do not change the value.
                 *
                 * @see `markAsUntouched()` / `markAsDirty()` / `markAsPristine()`
                 *
                 * @param {?=} opts Configuration options that determine how the control propagates changes
                 * and emits events events after marking is applied.
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false.
                 * @return {?}
                 */
                AbstractControl.prototype.markAsTouched = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).touched = true;
                    if (this._parent && !opts.onlySelf) {
                        this._parent.markAsTouched(opts);
                    }
                };
                /**
                 * Marks the control and all its descendant controls as `touched`.
                 * @see `markAsTouched()`
                 * @return {?}
                 */
                AbstractControl.prototype.markAllAsTouched = function () {
                    this.markAsTouched({ onlySelf: true });
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control.markAllAsTouched(); }));
                };
                /**
                 * Marks the control as `untouched`.
                 *
                 * If the control has any children, also marks all children as `untouched`
                 * and recalculates the `touched` status of all parent controls.
                 *
                 * @see `markAsTouched()` / `markAsDirty()` / `markAsPristine()`
                 *
                 * @param {?=} opts Configuration options that determine how the control propagates changes
                 * and emits events after the marking is applied.
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false.
                 * @return {?}
                 */
                AbstractControl.prototype.markAsUntouched = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).touched = false;
                    this._pendingTouched = false;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { control.markAsUntouched({ onlySelf: true }); }));
                    if (this._parent && !opts.onlySelf) {
                        this._parent._updateTouched(opts);
                    }
                };
                /**
                 * Marks the control as `dirty`. A control becomes dirty when
                 * the control's value is changed through the UI; compare `markAsTouched`.
                 *
                 * @see `markAsTouched()` / `markAsUntouched()` / `markAsPristine()`
                 *
                 * @param {?=} opts Configuration options that determine how the control propagates changes
                 * and emits events after marking is applied.
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false.
                 * @return {?}
                 */
                AbstractControl.prototype.markAsDirty = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).pristine = false;
                    if (this._parent && !opts.onlySelf) {
                        this._parent.markAsDirty(opts);
                    }
                };
                /**
                 * Marks the control as `pristine`.
                 *
                 * If the control has any children, marks all children as `pristine`,
                 * and recalculates the `pristine` status of all parent
                 * controls.
                 *
                 * @see `markAsTouched()` / `markAsUntouched()` / `markAsDirty()`
                 *
                 * @param {?=} opts Configuration options that determine how the control emits events after
                 * marking is applied.
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false..
                 * @return {?}
                 */
                AbstractControl.prototype.markAsPristine = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).pristine = true;
                    this._pendingDirty = false;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { control.markAsPristine({ onlySelf: true }); }));
                    if (this._parent && !opts.onlySelf) {
                        this._parent._updatePristine(opts);
                    }
                };
                /**
                 * Marks the control as `pending`.
                 *
                 * A control is pending while the control performs async validation.
                 *
                 * @see {\@link AbstractControl.status}
                 *
                 * @param {?=} opts Configuration options that determine how the control propagates changes and
                 * emits events after marking is applied.
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false..
                 * * `emitEvent`: When true or not supplied (the default), the `statusChanges`
                 * observable emits an event with the latest status the control is marked pending.
                 * When false, no events are emitted.
                 *
                 * @return {?}
                 */
                AbstractControl.prototype.markAsPending = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).status = PENDING;
                    if (opts.emitEvent !== false) {
                        (( /** @type {?} */(this.statusChanges))).emit(this.status);
                    }
                    if (this._parent && !opts.onlySelf) {
                        this._parent.markAsPending(opts);
                    }
                };
                /**
                 * Disables the control. This means the control is exempt from validation checks and
                 * excluded from the aggregate value of any parent. Its status is `DISABLED`.
                 *
                 * If the control has children, all children are also disabled.
                 *
                 * @see {\@link AbstractControl.status}
                 *
                 * @param {?=} opts Configuration options that determine how the control propagates
                 * changes and emits events after the control is disabled.
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false..
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control is disabled.
                 * When false, no events are emitted.
                 * @return {?}
                 */
                AbstractControl.prototype.disable = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    // If parent has been marked artificially dirty we don't want to re-calculate the
                    // parent's dirtiness based on the children.
                    /** @type {?} */
                    var skipPristineCheck = this._parentMarkedDirty(opts.onlySelf);
                    (( /** @type {?} */(this))).status = DISABLED;
                    (( /** @type {?} */(this))).errors = null;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { control.disable(Object.assign({}, opts, { onlySelf: true })); }));
                    this._updateValue();
                    if (opts.emitEvent !== false) {
                        (( /** @type {?} */(this.valueChanges))).emit(this.value);
                        (( /** @type {?} */(this.statusChanges))).emit(this.status);
                    }
                    this._updateAncestors(Object.assign({}, opts, { skipPristineCheck: skipPristineCheck }));
                    this._onDisabledChange.forEach(( /**
                     * @param {?} changeFn
                     * @return {?}
                     */function (changeFn) { return changeFn(true); }));
                };
                /**
                 * Enables the control. This means the control is included in validation checks and
                 * the aggregate value of its parent. Its status recalculates based on its value and
                 * its validators.
                 *
                 * By default, if the control has children, all children are enabled.
                 *
                 * @see {\@link AbstractControl.status}
                 *
                 * @param {?=} opts Configure options that control how the control propagates changes and
                 * emits events when marked as untouched
                 * * `onlySelf`: When true, mark only this control. When false or not supplied,
                 * marks all direct ancestors. Default is false..
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control is enabled.
                 * When false, no events are emitted.
                 * @return {?}
                 */
                AbstractControl.prototype.enable = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    // If parent has been marked artificially dirty we don't want to re-calculate the
                    // parent's dirtiness based on the children.
                    /** @type {?} */
                    var skipPristineCheck = this._parentMarkedDirty(opts.onlySelf);
                    (( /** @type {?} */(this))).status = VALID;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { control.enable(Object.assign({}, opts, { onlySelf: true })); }));
                    this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
                    this._updateAncestors(Object.assign({}, opts, { skipPristineCheck: skipPristineCheck }));
                    this._onDisabledChange.forEach(( /**
                     * @param {?} changeFn
                     * @return {?}
                     */function (changeFn) { return changeFn(false); }));
                };
                /**
                 * @private
                 * @param {?} opts
                 * @return {?}
                 */
                AbstractControl.prototype._updateAncestors = function (opts) {
                    if (this._parent && !opts.onlySelf) {
                        this._parent.updateValueAndValidity(opts);
                        if (!opts.skipPristineCheck) {
                            this._parent._updatePristine();
                        }
                        this._parent._updateTouched();
                    }
                };
                /**
                 * @param {?} parent Sets the parent of the control
                 * @return {?}
                 */
                AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
                /**
                 * Recalculates the value and validation status of the control.
                 *
                 * By default, it also updates the value and validity of its ancestors.
                 *
                 * @param {?=} opts Configuration options determine how the control propagates changes and emits events
                 * after updates and validity checks are applied.
                 * * `onlySelf`: When true, only update this control. When false or not supplied,
                 * update all direct ancestors. Default is false..
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control is updated.
                 * When false, no events are emitted.
                 * @return {?}
                 */
                AbstractControl.prototype.updateValueAndValidity = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    this._setInitialStatus();
                    this._updateValue();
                    if (this.enabled) {
                        this._cancelExistingSubscription();
                        (( /** @type {?} */(this))).errors = this._runValidator();
                        (( /** @type {?} */(this))).status = this._calculateStatus();
                        if (this.status === VALID || this.status === PENDING) {
                            this._runAsyncValidator(opts.emitEvent);
                        }
                    }
                    if (opts.emitEvent !== false) {
                        (( /** @type {?} */(this.valueChanges))).emit(this.value);
                        (( /** @type {?} */(this.statusChanges))).emit(this.status);
                    }
                    if (this._parent && !opts.onlySelf) {
                        this._parent.updateValueAndValidity(opts);
                    }
                };
                /**
                 * \@internal
                 * @param {?=} opts
                 * @return {?}
                 */
                AbstractControl.prototype._updateTreeValidity = function (opts) {
                    if (opts === void 0) { opts = { emitEvent: true }; }
                    this._forEachChild(( /**
                     * @param {?} ctrl
                     * @return {?}
                     */function (ctrl) { return ctrl._updateTreeValidity(opts); }));
                    this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
                };
                /**
                 * @private
                 * @return {?}
                 */
                AbstractControl.prototype._setInitialStatus = function () {
                    (( /** @type {?} */(this))).status = this._allControlsDisabled() ? DISABLED : VALID;
                };
                /**
                 * @private
                 * @return {?}
                 */
                AbstractControl.prototype._runValidator = function () {
                    return this.validator ? this.validator(this) : null;
                };
                /**
                 * @private
                 * @param {?=} emitEvent
                 * @return {?}
                 */
                AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
                    var _this = this;
                    if (this.asyncValidator) {
                        (( /** @type {?} */(this))).status = PENDING;
                        /** @type {?} */
                        var obs = toObservable(this.asyncValidator(this));
                        this._asyncValidationSubscription =
                            obs.subscribe(( /**
                             * @param {?} errors
                             * @return {?}
                             */function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); }));
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                AbstractControl.prototype._cancelExistingSubscription = function () {
                    if (this._asyncValidationSubscription) {
                        this._asyncValidationSubscription.unsubscribe();
                    }
                };
                /**
                 * Sets errors on a form control when running validations manually, rather than automatically.
                 *
                 * Calling `setErrors` also updates the validity of the parent control.
                 *
                 * \@usageNotes
                 * ### Manually set the errors for a control
                 *
                 * ```
                 * const login = new FormControl('someLogin');
                 * login.setErrors({
                 *   notUnique: true
                 * });
                 *
                 * expect(login.valid).toEqual(false);
                 * expect(login.errors).toEqual({ notUnique: true });
                 *
                 * login.setValue('someOtherLogin');
                 *
                 * expect(login.valid).toEqual(true);
                 * ```
                 * @param {?} errors
                 * @param {?=} opts
                 * @return {?}
                 */
                AbstractControl.prototype.setErrors = function (errors, opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).errors = errors;
                    this._updateControlsErrors(opts.emitEvent !== false);
                };
                /**
                 * Retrieves a child control given the control's name or path.
                 *
                 * \@usageNotes
                 * ### Retrieve a nested control
                 *
                 * For example, to get a `name` control nested within a `person` sub-group:
                 *
                 * * `this.form.get('person.name');`
                 *
                 * -OR-
                 *
                 * * `this.form.get(['person', 'name']);`
                 * @param {?} path A dot-delimited string or array of string/number values that define the path to the
                 * control.
                 *
                 * @return {?}
                 */
                AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
                /**
                 * \@description
                 * Reports error data for the control with the given path.
                 *
                 * \@usageNotes
                 * For example, for the following `FormGroup`:
                 *
                 * ```
                 * form = new FormGroup({
                 *   address: new FormGroup({ street: new FormControl() })
                 * });
                 * ```
                 *
                 * The path to the 'street' control from the root form would be 'address' -> 'street'.
                 *
                 * It can be provided to this method in one of two formats:
                 *
                 * 1. An array of string control names, e.g. `['address', 'street']`
                 * 1. A period-delimited list of control names in one string, e.g. `'address.street'`
                 *
                 * @param {?} errorCode The code of the error to check
                 * @param {?=} path A list of control names that designates how to move from the current control
                 * to the control that should be queried for errors.
                 *
                 * @return {?} error data for that particular error. If the control or error is not present,
                 * null is returned.
                 */
                AbstractControl.prototype.getError = function (errorCode, path) {
                    /** @type {?} */
                    var control = path ? this.get(path) : this;
                    return control && control.errors ? control.errors[errorCode] : null;
                };
                /**
                 * \@description
                 * Reports whether the control with the given path has the error specified.
                 *
                 * \@usageNotes
                 * For example, for the following `FormGroup`:
                 *
                 * ```
                 * form = new FormGroup({
                 *   address: new FormGroup({ street: new FormControl() })
                 * });
                 * ```
                 *
                 * The path to the 'street' control from the root form would be 'address' -> 'street'.
                 *
                 * It can be provided to this method in one of two formats:
                 *
                 * 1. An array of string control names, e.g. `['address', 'street']`
                 * 1. A period-delimited list of control names in one string, e.g. `'address.street'`
                 *
                 * If no path is given, this method checks for the error on the current control.
                 *
                 * @param {?} errorCode The code of the error to check
                 * @param {?=} path A list of control names that designates how to move from the current control
                 * to the control that should be queried for errors.
                 *
                 * @return {?} whether the given error is present in the control at the given path.
                 *
                 * If the control is not present, false is returned.
                 */
                AbstractControl.prototype.hasError = function (errorCode, path) {
                    return !!this.getError(errorCode, path);
                };
                Object.defineProperty(AbstractControl.prototype, "root", {
                    /**
                     * Retrieves the top-level ancestor of this control.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var x = this;
                        while (x._parent) {
                            x = x._parent;
                        }
                        return x;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@internal
                 * @param {?} emitEvent
                 * @return {?}
                 */
                AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
                    (( /** @type {?} */(this))).status = this._calculateStatus();
                    if (emitEvent) {
                        (( /** @type {?} */(this.statusChanges))).emit(this.status);
                    }
                    if (this._parent) {
                        this._parent._updateControlsErrors(emitEvent);
                    }
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                AbstractControl.prototype._initObservables = function () {
                    (( /** @type {?} */(this))).valueChanges = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    (( /** @type {?} */(this))).statusChanges = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                };
                /**
                 * @private
                 * @return {?}
                 */
                AbstractControl.prototype._calculateStatus = function () {
                    if (this._allControlsDisabled())
                        return DISABLED;
                    if (this.errors)
                        return INVALID;
                    if (this._anyControlsHaveStatus(PENDING))
                        return PENDING;
                    if (this._anyControlsHaveStatus(INVALID))
                        return INVALID;
                    return VALID;
                };
                /**
                 * \@internal
                 * @param {?} status
                 * @return {?}
                 */
                AbstractControl.prototype._anyControlsHaveStatus = function (status) {
                    return this._anyControls(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control.status === status; }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                AbstractControl.prototype._anyControlsDirty = function () {
                    return this._anyControls(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control.dirty; }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                AbstractControl.prototype._anyControlsTouched = function () {
                    return this._anyControls(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control.touched; }));
                };
                /**
                 * \@internal
                 * @param {?=} opts
                 * @return {?}
                 */
                AbstractControl.prototype._updatePristine = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).pristine = !this._anyControlsDirty();
                    if (this._parent && !opts.onlySelf) {
                        this._parent._updatePristine(opts);
                    }
                };
                /**
                 * \@internal
                 * @param {?=} opts
                 * @return {?}
                 */
                AbstractControl.prototype._updateTouched = function (opts) {
                    if (opts === void 0) { opts = {}; }
                    (( /** @type {?} */(this))).touched = this._anyControlsTouched();
                    if (this._parent && !opts.onlySelf) {
                        this._parent._updateTouched(opts);
                    }
                };
                /**
                 * \@internal
                 * @param {?} formState
                 * @return {?}
                 */
                AbstractControl.prototype._isBoxedValue = function (formState) {
                    return typeof formState === 'object' && formState !== null &&
                        Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
                };
                /**
                 * \@internal
                 * @param {?} fn
                 * @return {?}
                 */
                AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
                /**
                 * \@internal
                 * @param {?=} opts
                 * @return {?}
                 */
                AbstractControl.prototype._setUpdateStrategy = function (opts) {
                    if (isOptionsObj(opts) && (( /** @type {?} */(opts))).updateOn != null) {
                        this._updateOn = ( /** @type {?} */((( /** @type {?} */(opts))).updateOn));
                    }
                };
                /**
                 * Check to see if parent has been marked artificially dirty.
                 *
                 * \@internal
                 * @private
                 * @param {?=} onlySelf
                 * @return {?}
                 */
                AbstractControl.prototype._parentMarkedDirty = function (onlySelf) {
                    /** @type {?} */
                    var parentDirty = this._parent && this._parent.dirty;
                    return !onlySelf && parentDirty && !this._parent._anyControlsDirty();
                };
                return AbstractControl;
            }());
            if (false) { }
            /**
             * Tracks the value and validation status of an individual form control.
             *
             * This is one of the three fundamental building blocks of Angular forms, along with
             * `FormGroup` and `FormArray`. It extends the `AbstractControl` class that
             * implements most of the base functionality for accessing the value, validation status,
             * user interactions and events.
             *
             * @see `AbstractControl`
             * @see [Reactive Forms Guide](guide/reactive-forms)
             * @see [Usage Notes](#usage-notes)
             *
             * \@usageNotes
             *
             * ### Initializing Form Controls
             *
             * Instantiate a `FormControl`, with an initial value.
             *
             * ```ts
             * const control = new FormControl('some value');
             * console.log(control.value);     // 'some value'
             * ```
             *
             * The following example initializes the control with a form state object. The `value`
             * and `disabled` keys are required in this case.
             *
             * ```ts
             * const control = new FormControl({ value: 'n/a', disabled: true });
             * console.log(control.value);     // 'n/a'
             * console.log(control.status);    // 'DISABLED'
             * ```
             *
             * The following example initializes the control with a sync validator.
             *
             * ```ts
             * const control = new FormControl('', Validators.required);
             * console.log(control.value);      // ''
             * console.log(control.status);     // 'INVALID'
             * ```
             *
             * The following example initializes the control using an options object.
             *
             * ```ts
             * const control = new FormControl('', {
             *    validators: Validators.required,
             *    asyncValidators: myAsyncValidator
             * });
             * ```
             *
             * ### Configure the control to update on a blur event
             *
             * Set the `updateOn` option to `'blur'` to update on the blur `event`.
             *
             * ```ts
             * const control = new FormControl('', { updateOn: 'blur' });
             * ```
             *
             * ### Configure the control to update on a submit event
             *
             * Set the `updateOn` option to `'submit'` to update on a submit `event`.
             *
             * ```ts
             * const control = new FormControl('', { updateOn: 'submit' });
             * ```
             *
             * ### Reset the control back to an initial value
             *
             * You reset to a specific form state by passing through a standalone
             * value or a form state object that contains both a value and a disabled state
             * (these are the only two properties that cannot be calculated).
             *
             * ```ts
             * const control = new FormControl('Nancy');
             *
             * console.log(control.value); // 'Nancy'
             *
             * control.reset('Drew');
             *
             * console.log(control.value); // 'Drew'
             * ```
             *
             * ### Reset the control back to an initial value and disabled
             *
             * ```
             * const control = new FormControl('Nancy');
             *
             * console.log(control.value); // 'Nancy'
             * console.log(control.status); // 'VALID'
             *
             * control.reset({ value: 'Drew', disabled: true });
             *
             * console.log(control.value); // 'Drew'
             * console.log(control.status); // 'DISABLED'
             * ```
             *
             * \@publicApi
             */
            var FormControl = /** @class */ (function (_super_1) {
                __extends(FormControl, _super_1);
                /**
                 * Creates a new `FormControl` instance.
                 *
                 * @param {?=} formState Initializes the control with an initial value,
                 * or an object that defines the initial value and disabled state.
                 *
                 * @param {?=} validatorOrOpts A synchronous validator function, or an array of
                 * such functions, or an `AbstractControlOptions` object that contains validation functions
                 * and a validation trigger.
                 *
                 * @param {?=} asyncValidator A single async validator or array of async validator functions
                 *
                 */
                function FormControl(formState, validatorOrOpts, asyncValidator) {
                    if (formState === void 0) { formState = null; }
                    var _this = _super_1.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
                    /**
                     * \@internal
                     */
                    _this._onChange = [];
                    _this._applyFormState(formState);
                    _this._setUpdateStrategy(validatorOrOpts);
                    _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
                    _this._initObservables();
                    return _this;
                }
                /**
                 * Sets a new value for the form control.
                 *
                 * @param {?} value The new value for the control.
                 * @param {?=} options Configuration options that determine how the control propagates changes
                 * and emits events when the value changes.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 *
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
                 * false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control value is updated.
                 * When false, no events are emitted.
                 * * `emitModelToViewChange`: When true or not supplied  (the default), each change triggers an
                 * `onChange` event to
                 * update the view.
                 * * `emitViewToModelChange`: When true or not supplied (the default), each change triggers an
                 * `ngModelChange`
                 * event to update the model.
                 *
                 * @return {?}
                 */
                FormControl.prototype.setValue = function (value, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    (( /** @type {?} */(this))).value = this._pendingValue = value;
                    if (this._onChange.length && options.emitModelToViewChange !== false) {
                        this._onChange.forEach(( /**
                         * @param {?} changeFn
                         * @return {?}
                         */function (changeFn) { return changeFn(_this.value, options.emitViewToModelChange !== false); }));
                    }
                    this.updateValueAndValidity(options);
                };
                /**
                 * Patches the value of a control.
                 *
                 * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
                 * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
                 * `FormArrays`, where it does behave differently.
                 *
                 * @see `setValue` for options
                 * @param {?} value
                 * @param {?=} options
                 * @return {?}
                 */
                FormControl.prototype.patchValue = function (value, options) {
                    if (options === void 0) { options = {}; }
                    this.setValue(value, options);
                };
                /**
                 * Resets the form control, marking it `pristine` and `untouched`, and setting
                 * the value to null.
                 *
                 * @param {?=} formState Resets the control with an initial value,
                 * or an object that defines the initial value and disabled state.
                 *
                 * @param {?=} options Configuration options that determine how the control propagates changes
                 * and emits events after the value changes.
                 *
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
                 * false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control is reset.
                 * When false, no events are emitted.
                 *
                 * @return {?}
                 */
                FormControl.prototype.reset = function (formState, options) {
                    if (formState === void 0) { formState = null; }
                    if (options === void 0) { options = {}; }
                    this._applyFormState(formState);
                    this.markAsPristine(options);
                    this.markAsUntouched(options);
                    this.setValue(this.value, options);
                    this._pendingChange = false;
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormControl.prototype._updateValue = function () { };
                /**
                 * \@internal
                 * @param {?} condition
                 * @return {?}
                 */
                FormControl.prototype._anyControls = function (condition) { return false; };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
                /**
                 * Register a listener for change events.
                 *
                 * @param {?} fn The method that is called when the value changes
                 * @return {?}
                 */
                FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormControl.prototype._clearChangeFns = function () {
                    this._onChange = [];
                    this._onDisabledChange = [];
                    this._onCollectionChange = ( /**
                     * @return {?}
                     */function () { });
                };
                /**
                 * Register a listener for disabled events.
                 *
                 * @param {?} fn The method that is called when the disabled status changes.
                 * @return {?}
                 */
                FormControl.prototype.registerOnDisabledChange = function (fn) {
                    this._onDisabledChange.push(fn);
                };
                /**
                 * \@internal
                 * @param {?} cb
                 * @return {?}
                 */
                FormControl.prototype._forEachChild = function (cb) { };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormControl.prototype._syncPendingControls = function () {
                    if (this.updateOn === 'submit') {
                        if (this._pendingDirty)
                            this.markAsDirty();
                        if (this._pendingTouched)
                            this.markAsTouched();
                        if (this._pendingChange) {
                            this.setValue(this._pendingValue, { onlySelf: true, emitModelToViewChange: false });
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * @private
                 * @param {?} formState
                 * @return {?}
                 */
                FormControl.prototype._applyFormState = function (formState) {
                    if (this._isBoxedValue(formState)) {
                        (( /** @type {?} */(this))).value = this._pendingValue = formState.value;
                        formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                            this.enable({ onlySelf: true, emitEvent: false });
                    }
                    else {
                        (( /** @type {?} */(this))).value = this._pendingValue = formState;
                    }
                };
                return FormControl;
            }(AbstractControl));
            if (false) { }
            /**
             * Tracks the value and validity state of a group of `FormControl` instances.
             *
             * A `FormGroup` aggregates the values of each child `FormControl` into one object,
             * with each control name as the key.  It calculates its status by reducing the status values
             * of its children. For example, if one of the controls in a group is invalid, the entire
             * group becomes invalid.
             *
             * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
             * along with `FormControl` and `FormArray`.
             *
             * When instantiating a `FormGroup`, pass in a collection of child controls as the first
             * argument. The key for each child registers the name for the control.
             *
             * \@usageNotes
             *
             * ### Create a form group with 2 controls
             *
             * ```
             * const form = new FormGroup({
             *   first: new FormControl('Nancy', Validators.minLength(2)),
             *   last: new FormControl('Drew'),
             * });
             *
             * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
             * console.log(form.status);  // 'VALID'
             * ```
             *
             * ### Create a form group with a group-level validator
             *
             * You include group-level validators as the second arg, or group-level async
             * validators as the third arg. These come in handy when you want to perform validation
             * that considers the value of more than one child control.
             *
             * ```
             * const form = new FormGroup({
             *   password: new FormControl('', Validators.minLength(2)),
             *   passwordConfirm: new FormControl('', Validators.minLength(2)),
             * }, passwordMatchValidator);
             *
             *
             * function passwordMatchValidator(g: FormGroup) {
             *    return g.get('password').value === g.get('passwordConfirm').value
             *       ? null : {'mismatch': true};
             * }
             * ```
             *
             * Like `FormControl` instances, you choose to pass in
             * validators and async validators as part of an options object.
             *
             * ```
             * const form = new FormGroup({
             *   password: new FormControl('')
             *   passwordConfirm: new FormControl('')
             * }, { validators: passwordMatchValidator, asyncValidators: otherValidator });
             * ```
             *
             * ### Set the updateOn property for all controls in a form group
             *
             * The options object is used to set a default value for each child
             * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
             * group level, all child controls default to 'blur', unless the child
             * has explicitly specified a different `updateOn` value.
             *
             * ```ts
             * const c = new FormGroup({
             *   one: new FormControl()
             * }, { updateOn: 'blur' });
             * ```
             *
             * \@publicApi
             */
            var FormGroup = /** @class */ (function (_super_1) {
                __extends(FormGroup, _super_1);
                /**
                 * Creates a new `FormGroup` instance.
                 *
                 * @param {?} controls A collection of child controls. The key for each child is the name
                 * under which it is registered.
                 *
                 * @param {?=} validatorOrOpts A synchronous validator function, or an array of
                 * such functions, or an `AbstractControlOptions` object that contains validation functions
                 * and a validation trigger.
                 *
                 * @param {?=} asyncValidator A single async validator or array of async validator functions
                 *
                 */
                function FormGroup(controls, validatorOrOpts, asyncValidator) {
                    var _this = _super_1.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
                    _this.controls = controls;
                    _this._initObservables();
                    _this._setUpdateStrategy(validatorOrOpts);
                    _this._setUpControls();
                    _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
                    return _this;
                }
                /**
                 * Registers a control with the group's list of controls.
                 *
                 * This method does not update the value or validity of the control.
                 * Use {\@link FormGroup#addControl addControl} instead.
                 *
                 * @param {?} name The control name to register in the collection
                 * @param {?} control Provides the control for the given name
                 * @return {?}
                 */
                FormGroup.prototype.registerControl = function (name, control) {
                    if (this.controls[name])
                        return this.controls[name];
                    this.controls[name] = control;
                    control.setParent(this);
                    control._registerOnCollectionChange(this._onCollectionChange);
                    return control;
                };
                /**
                 * Add a control to this group.
                 *
                 * This method also updates the value and validity of the control.
                 *
                 * @param {?} name The control name to add to the collection
                 * @param {?} control Provides the control for the given name
                 * @return {?}
                 */
                FormGroup.prototype.addControl = function (name, control) {
                    this.registerControl(name, control);
                    this.updateValueAndValidity();
                    this._onCollectionChange();
                };
                /**
                 * Remove a control from this group.
                 *
                 * @param {?} name The control name to remove from the collection
                 * @return {?}
                 */
                FormGroup.prototype.removeControl = function (name) {
                    if (this.controls[name])
                        this.controls[name]._registerOnCollectionChange(( /**
                         * @return {?}
                         */function () { }));
                    delete (this.controls[name]);
                    this.updateValueAndValidity();
                    this._onCollectionChange();
                };
                /**
                 * Replace an existing control.
                 *
                 * @param {?} name The control name to replace in the collection
                 * @param {?} control Provides the control for the given name
                 * @return {?}
                 */
                FormGroup.prototype.setControl = function (name, control) {
                    if (this.controls[name])
                        this.controls[name]._registerOnCollectionChange(( /**
                         * @return {?}
                         */function () { }));
                    delete (this.controls[name]);
                    if (control)
                        this.registerControl(name, control);
                    this.updateValueAndValidity();
                    this._onCollectionChange();
                };
                /**
                 * Check whether there is an enabled control with the given name in the group.
                 *
                 * Reports false for disabled controls. If you'd like to check for existence in the group
                 * only, use {\@link AbstractControl#get get} instead.
                 *
                 * @param {?} controlName The control name to check for existence in the collection
                 *
                 * @return {?} false for disabled controls, true otherwise.
                 */
                FormGroup.prototype.contains = function (controlName) {
                    return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
                };
                /**
                 * Sets the value of the `FormGroup`. It accepts an object that matches
                 * the structure of the group, with control names as keys.
                 *
                 * \@usageNotes
                 * ### Set the complete value for the form group
                 *
                 * ```
                 * const form = new FormGroup({
                 *   first: new FormControl(),
                 *   last: new FormControl()
                 * });
                 *
                 * console.log(form.value);   // {first: null, last: null}
                 *
                 * form.setValue({first: 'Nancy', last: 'Drew'});
                 * console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
                 * ```
                 *
                 * @throws When strict checks fail, such as setting the value of a control
                 * that doesn't exist or if you exclude a value of a control that does exist.
                 *
                 * @param {?} value The new value for the control that matches the structure of the group.
                 * @param {?=} options Configuration options that determine how the control propagates changes
                 * and emits events after the value changes.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 *
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
                 * false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control value is updated.
                 * When false, no events are emitted.
                 * @return {?}
                 */
                FormGroup.prototype.setValue = function (value, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    this._checkAllValuesPresent(value);
                    Object.keys(value).forEach(( /**
                     * @param {?} name
                     * @return {?}
                     */function (/**
                     * @param {?} name
                     * @return {?}
                     */ name) {
                        _this._throwIfControlMissing(name);
                        _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
                    }));
                    this.updateValueAndValidity(options);
                };
                /**
                 * Patches the value of the `FormGroup`. It accepts an object with control
                 * names as keys, and does its best to match the values to the correct controls
                 * in the group.
                 *
                 * It accepts both super-sets and sub-sets of the group without throwing an error.
                 *
                 * \@usageNotes
                 * ### Patch the value for a form group
                 *
                 * ```
                 * const form = new FormGroup({
                 *    first: new FormControl(),
                 *    last: new FormControl()
                 * });
                 * console.log(form.value);   // {first: null, last: null}
                 *
                 * form.patchValue({first: 'Nancy'});
                 * console.log(form.value);   // {first: 'Nancy', last: null}
                 * ```
                 *
                 * @param {?} value The object that matches the structure of the group.
                 * @param {?=} options Configuration options that determine how the control propagates changes and
                 * emits events after the value is patched.
                 * * `onlySelf`: When true, each change only affects this control and not its parent. Default is
                 * true.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control value is updated.
                 * When false, no events are emitted.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 * @return {?}
                 */
                FormGroup.prototype.patchValue = function (value, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    Object.keys(value).forEach(( /**
                     * @param {?} name
                     * @return {?}
                     */function (/**
                     * @param {?} name
                     * @return {?}
                     */ name) {
                        if (_this.controls[name]) {
                            _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
                        }
                    }));
                    this.updateValueAndValidity(options);
                };
                /**
                 * Resets the `FormGroup`, marks all descendants are marked `pristine` and `untouched`, and
                 * the value of all descendants to null.
                 *
                 * You reset to a specific form state by passing in a map of states
                 * that matches the structure of your form, with control names as keys. The state
                 * is a standalone value or a form state object with both a value and a disabled
                 * status.
                 *
                 * \@usageNotes
                 *
                 * ### Reset the form group values
                 *
                 * ```ts
                 * const form = new FormGroup({
                 *   first: new FormControl('first name'),
                 *   last: new FormControl('last name')
                 * });
                 *
                 * console.log(form.value);  // {first: 'first name', last: 'last name'}
                 *
                 * form.reset({ first: 'name', last: 'last name' });
                 *
                 * console.log(form.value);  // {first: 'name', last: 'last name'}
                 * ```
                 *
                 * ### Reset the form group values and disabled status
                 *
                 * ```
                 * const form = new FormGroup({
                 *   first: new FormControl('first name'),
                 *   last: new FormControl('last name')
                 * });
                 *
                 * form.reset({
                 *   first: {value: 'name', disabled: true},
                 *   last: 'last'
                 * });
                 *
                 * console.log(this.form.value);  // {first: 'name', last: 'last name'}
                 * console.log(this.form.get('first').status);  // 'DISABLED'
                 * ```
                 * @param {?=} value Resets the control with an initial value,
                 * or an object that defines the initial value and disabled state.
                 *
                 * @param {?=} options Configuration options that determine how the control propagates changes
                 * and emits events when the group is reset.
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
                 * false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control is reset.
                 * When false, no events are emitted.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 *
                 * @return {?}
                 */
                FormGroup.prototype.reset = function (value, options) {
                    if (value === void 0) { value = {}; }
                    if (options === void 0) { options = {}; }
                    this._forEachChild(( /**
                     * @param {?} control
                     * @param {?} name
                     * @return {?}
                     */function (control, name) {
                        control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
                    }));
                    this._updatePristine(options);
                    this._updateTouched(options);
                    this.updateValueAndValidity(options);
                };
                /**
                 * The aggregate value of the `FormGroup`, including any disabled controls.
                 *
                 * Retrieves all values regardless of disabled status.
                 * The `value` property is the best way to get the value of the group, because
                 * it excludes disabled controls in the `FormGroup`.
                 * @return {?}
                 */
                FormGroup.prototype.getRawValue = function () {
                    return this._reduceChildren({}, ( /**
                     * @param {?} acc
                     * @param {?} control
                     * @param {?} name
                     * @return {?}
                     */function (acc, control, name) {
                        acc[name] = control instanceof FormControl ? control.value : (( /** @type {?} */(control))).getRawValue();
                        return acc;
                    }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroup.prototype._syncPendingControls = function () {
                    /** @type {?} */
                    var subtreeUpdated = this._reduceChildren(false, ( /**
                     * @param {?} updated
                     * @param {?} child
                     * @return {?}
                     */function (updated, child) {
                        return child._syncPendingControls() ? true : updated;
                    }));
                    if (subtreeUpdated)
                        this.updateValueAndValidity({ onlySelf: true });
                    return subtreeUpdated;
                };
                /**
                 * \@internal
                 * @param {?} name
                 * @return {?}
                 */
                FormGroup.prototype._throwIfControlMissing = function (name) {
                    if (!Object.keys(this.controls).length) {
                        throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
                    }
                    if (!this.controls[name]) {
                        throw new Error("Cannot find form control with name: " + name + ".");
                    }
                };
                /**
                 * \@internal
                 * @param {?} cb
                 * @return {?}
                 */
                FormGroup.prototype._forEachChild = function (cb) {
                    var _this = this;
                    Object.keys(this.controls).forEach(( /**
                     * @param {?} k
                     * @return {?}
                     */function (/**
                     * @param {?} k
                     * @return {?}
                     */ k) { return cb(_this.controls[k], k); }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroup.prototype._setUpControls = function () {
                    var _this = this;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        control.setParent(_this);
                        control._registerOnCollectionChange(_this._onCollectionChange);
                    }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroup.prototype._updateValue = function () { (( /** @type {?} */(this))).value = this._reduceValue(); };
                /**
                 * \@internal
                 * @param {?} condition
                 * @return {?}
                 */
                FormGroup.prototype._anyControls = function (condition) {
                    var _this = this;
                    /** @type {?} */
                    var res = false;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @param {?} name
                     * @return {?}
                     */function (control, name) {
                        res = res || (_this.contains(name) && condition(control));
                    }));
                    return res;
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroup.prototype._reduceValue = function () {
                    var _this = this;
                    return this._reduceChildren({}, ( /**
                     * @param {?} acc
                     * @param {?} control
                     * @param {?} name
                     * @return {?}
                     */function (acc, control, name) {
                        if (control.enabled || _this.disabled) {
                            acc[name] = control.value;
                        }
                        return acc;
                    }));
                };
                /**
                 * \@internal
                 * @param {?} initValue
                 * @param {?} fn
                 * @return {?}
                 */
                FormGroup.prototype._reduceChildren = function (initValue, fn) {
                    /** @type {?} */
                    var res = initValue;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @param {?} name
                     * @return {?}
                     */function (control, name) { res = fn(res, control, name); }));
                    return res;
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroup.prototype._allControlsDisabled = function () {
                    for (var _c = 0, _d = Object.keys(this.controls); _c < _d.length; _c++) {
                        var controlName = _d[_c];
                        if (this.controls[controlName].enabled) {
                            return false;
                        }
                    }
                    return Object.keys(this.controls).length > 0 || this.disabled;
                };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                FormGroup.prototype._checkAllValuesPresent = function (value) {
                    this._forEachChild(( /**
                     * @param {?} control
                     * @param {?} name
                     * @return {?}
                     */function (control, name) {
                        if (value[name] === undefined) {
                            throw new Error("Must supply a value for form control with name: '" + name + "'.");
                        }
                    }));
                };
                return FormGroup;
            }(AbstractControl));
            if (false) { }
            /**
             * Tracks the value and validity state of an array of `FormControl`,
             * `FormGroup` or `FormArray` instances.
             *
             * A `FormArray` aggregates the values of each child `FormControl` into an array.
             * It calculates its status by reducing the status values of its children. For example, if one of
             * the controls in a `FormArray` is invalid, the entire array becomes invalid.
             *
             * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
             * along with `FormControl` and `FormGroup`.
             *
             * \@usageNotes
             *
             * ### Create an array of form controls
             *
             * ```
             * const arr = new FormArray([
             *   new FormControl('Nancy', Validators.minLength(2)),
             *   new FormControl('Drew'),
             * ]);
             *
             * console.log(arr.value);   // ['Nancy', 'Drew']
             * console.log(arr.status);  // 'VALID'
             * ```
             *
             * ### Create a form array with array-level validators
             *
             * You include array-level validators and async validators. These come in handy
             * when you want to perform validation that considers the value of more than one child
             * control.
             *
             * The two types of validators are passed in separately as the second and third arg
             * respectively, or together as part of an options object.
             *
             * ```
             * const arr = new FormArray([
             *   new FormControl('Nancy'),
             *   new FormControl('Drew')
             * ], {validators: myValidator, asyncValidators: myAsyncValidator});
             * ```
             *
             * ### Set the updateOn property for all controls in a form array
             *
             * The options object is used to set a default value for each child
             * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
             * array level, all child controls default to 'blur', unless the child
             * has explicitly specified a different `updateOn` value.
             *
             * ```ts
             * const arr = new FormArray([
             *    new FormControl()
             * ], {updateOn: 'blur'});
             * ```
             *
             * ### Adding or removing controls from a form array
             *
             * To change the controls in the array, use the `push`, `insert`, `removeAt` or `clear` methods
             * in `FormArray` itself. These methods ensure the controls are properly tracked in the
             * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
             * the `FormArray` directly, as that result in strange and unexpected behavior such
             * as broken change detection.
             *
             * \@publicApi
             */
            var FormArray = /** @class */ (function (_super_1) {
                __extends(FormArray, _super_1);
                /**
                 * Creates a new `FormArray` instance.
                 *
                 * @param {?} controls An array of child controls. Each child control is given an index
                 * where it is registered.
                 *
                 * @param {?=} validatorOrOpts A synchronous validator function, or an array of
                 * such functions, or an `AbstractControlOptions` object that contains validation functions
                 * and a validation trigger.
                 *
                 * @param {?=} asyncValidator A single async validator or array of async validator functions
                 *
                 */
                function FormArray(controls, validatorOrOpts, asyncValidator) {
                    var _this = _super_1.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
                    _this.controls = controls;
                    _this._initObservables();
                    _this._setUpdateStrategy(validatorOrOpts);
                    _this._setUpControls();
                    _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
                    return _this;
                }
                /**
                 * Get the `AbstractControl` at the given `index` in the array.
                 *
                 * @param {?} index Index in the array to retrieve the control
                 * @return {?}
                 */
                FormArray.prototype.at = function (index) { return this.controls[index]; };
                /**
                 * Insert a new `AbstractControl` at the end of the array.
                 *
                 * @param {?} control Form control to be inserted
                 * @return {?}
                 */
                FormArray.prototype.push = function (control) {
                    this.controls.push(control);
                    this._registerControl(control);
                    this.updateValueAndValidity();
                    this._onCollectionChange();
                };
                /**
                 * Insert a new `AbstractControl` at the given `index` in the array.
                 *
                 * @param {?} index Index in the array to insert the control
                 * @param {?} control Form control to be inserted
                 * @return {?}
                 */
                FormArray.prototype.insert = function (index, control) {
                    this.controls.splice(index, 0, control);
                    this._registerControl(control);
                    this.updateValueAndValidity();
                };
                /**
                 * Remove the control at the given `index` in the array.
                 *
                 * @param {?} index Index in the array to remove the control
                 * @return {?}
                 */
                FormArray.prototype.removeAt = function (index) {
                    if (this.controls[index])
                        this.controls[index]._registerOnCollectionChange(( /**
                         * @return {?}
                         */function () { }));
                    this.controls.splice(index, 1);
                    this.updateValueAndValidity();
                };
                /**
                 * Replace an existing control.
                 *
                 * @param {?} index Index in the array to replace the control
                 * @param {?} control The `AbstractControl` control to replace the existing control
                 * @return {?}
                 */
                FormArray.prototype.setControl = function (index, control) {
                    if (this.controls[index])
                        this.controls[index]._registerOnCollectionChange(( /**
                         * @return {?}
                         */function () { }));
                    this.controls.splice(index, 1);
                    if (control) {
                        this.controls.splice(index, 0, control);
                        this._registerControl(control);
                    }
                    this.updateValueAndValidity();
                    this._onCollectionChange();
                };
                Object.defineProperty(FormArray.prototype, "length", {
                    /**
                     * Length of the control array.
                     * @return {?}
                     */
                    get: function () { return this.controls.length; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the value of the `FormArray`. It accepts an array that matches
                 * the structure of the control.
                 *
                 * This method performs strict checks, and throws an error if you try
                 * to set the value of a control that doesn't exist or if you exclude the
                 * value of a control.
                 *
                 * \@usageNotes
                 * ### Set the values for the controls in the form array
                 *
                 * ```
                 * const arr = new FormArray([
                 *   new FormControl(),
                 *   new FormControl()
                 * ]);
                 * console.log(arr.value);   // [null, null]
                 *
                 * arr.setValue(['Nancy', 'Drew']);
                 * console.log(arr.value);   // ['Nancy', 'Drew']
                 * ```
                 *
                 * @param {?} value Array of values for the controls
                 * @param {?=} options Configure options that determine how the control propagates changes and
                 * emits events after the value changes
                 *
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
                 * is false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control value is updated.
                 * When false, no events are emitted.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 * @return {?}
                 */
                FormArray.prototype.setValue = function (value, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    this._checkAllValuesPresent(value);
                    value.forEach(( /**
                     * @param {?} newValue
                     * @param {?} index
                     * @return {?}
                     */function (newValue, index) {
                        _this._throwIfControlMissing(index);
                        _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
                    }));
                    this.updateValueAndValidity(options);
                };
                /**
                 * Patches the value of the `FormArray`. It accepts an array that matches the
                 * structure of the control, and does its best to match the values to the correct
                 * controls in the group.
                 *
                 * It accepts both super-sets and sub-sets of the array without throwing an error.
                 *
                 * \@usageNotes
                 * ### Patch the values for controls in a form array
                 *
                 * ```
                 * const arr = new FormArray([
                 *    new FormControl(),
                 *    new FormControl()
                 * ]);
                 * console.log(arr.value);   // [null, null]
                 *
                 * arr.patchValue(['Nancy']);
                 * console.log(arr.value);   // ['Nancy', null]
                 * ```
                 *
                 * @param {?} value Array of latest values for the controls
                 * @param {?=} options Configure options that determine how the control propagates changes and
                 * emits events after the value changes
                 *
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
                 * is false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control value is updated.
                 * When false, no events are emitted.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 * @return {?}
                 */
                FormArray.prototype.patchValue = function (value, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    value.forEach(( /**
                     * @param {?} newValue
                     * @param {?} index
                     * @return {?}
                     */function (newValue, index) {
                        if (_this.at(index)) {
                            _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
                        }
                    }));
                    this.updateValueAndValidity(options);
                };
                /**
                 * Resets the `FormArray` and all descendants are marked `pristine` and `untouched`, and the
                 * value of all descendants to null or null maps.
                 *
                 * You reset to a specific form state by passing in an array of states
                 * that matches the structure of the control. The state is a standalone value
                 * or a form state object with both a value and a disabled status.
                 *
                 * \@usageNotes
                 * ### Reset the values in a form array
                 *
                 * ```ts
                 * const arr = new FormArray([
                 *    new FormControl(),
                 *    new FormControl()
                 * ]);
                 * arr.reset(['name', 'last name']);
                 *
                 * console.log(this.arr.value);  // ['name', 'last name']
                 * ```
                 *
                 * ### Reset the values in a form array and the disabled status for the first control
                 *
                 * ```
                 * this.arr.reset([
                 *   {value: 'name', disabled: true},
                 *   'last'
                 * ]);
                 *
                 * console.log(this.arr.value);  // ['name', 'last name']
                 * console.log(this.arr.get(0).status);  // 'DISABLED'
                 * ```
                 *
                 * @param {?=} value Array of values for the controls
                 * @param {?=} options Configure options that determine how the control propagates changes and
                 * emits events after the value changes
                 *
                 * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
                 * is false.
                 * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
                 * `valueChanges`
                 * observables emit events with the latest status and value when the control is reset.
                 * When false, no events are emitted.
                 * The configuration options are passed to the {\@link AbstractControl#updateValueAndValidity
                 * updateValueAndValidity} method.
                 * @return {?}
                 */
                FormArray.prototype.reset = function (value, options) {
                    if (value === void 0) { value = []; }
                    if (options === void 0) { options = {}; }
                    this._forEachChild(( /**
                     * @param {?} control
                     * @param {?} index
                     * @return {?}
                     */function (control, index) {
                        control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
                    }));
                    this._updatePristine(options);
                    this._updateTouched(options);
                    this.updateValueAndValidity(options);
                };
                /**
                 * The aggregate value of the array, including any disabled controls.
                 *
                 * Reports all values regardless of disabled status.
                 * For enabled controls only, the `value` property is the best way to get the value of the array.
                 * @return {?}
                 */
                FormArray.prototype.getRawValue = function () {
                    return this.controls.map(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        return control instanceof FormControl ? control.value : (( /** @type {?} */(control))).getRawValue();
                    }));
                };
                /**
                 * Remove all controls in the `FormArray`.
                 *
                 * \@usageNotes
                 * ### Remove all elements from a FormArray
                 *
                 * ```ts
                 * const arr = new FormArray([
                 *    new FormControl(),
                 *    new FormControl()
                 * ]);
                 * console.log(arr.length);  // 2
                 *
                 * arr.clear();
                 * console.log(arr.length);  // 0
                 * ```
                 *
                 * It's a simpler and more efficient alternative to removing all elements one by one:
                 *
                 * ```ts
                 * const arr = new FormArray([
                 *    new FormControl(),
                 *    new FormControl()
                 * ]);
                 *
                 * while (arr.length) {
                 *    arr.removeAt(0);
                 * }
                 * ```
                 * @return {?}
                 */
                FormArray.prototype.clear = function () {
                    if (this.controls.length < 1)
                        return;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control._registerOnCollectionChange(( /**
                     * @return {?}
                     */function () { })); }));
                    this.controls.splice(0);
                    this.updateValueAndValidity();
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormArray.prototype._syncPendingControls = function () {
                    /** @type {?} */
                    var subtreeUpdated = this.controls.reduce(( /**
                     * @param {?} updated
                     * @param {?} child
                     * @return {?}
                     */function (updated, child) {
                        return child._syncPendingControls() ? true : updated;
                    }), false);
                    if (subtreeUpdated)
                        this.updateValueAndValidity({ onlySelf: true });
                    return subtreeUpdated;
                };
                /**
                 * \@internal
                 * @param {?} index
                 * @return {?}
                 */
                FormArray.prototype._throwIfControlMissing = function (index) {
                    if (!this.controls.length) {
                        throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
                    }
                    if (!this.at(index)) {
                        throw new Error("Cannot find form control at index " + index);
                    }
                };
                /**
                 * \@internal
                 * @param {?} cb
                 * @return {?}
                 */
                FormArray.prototype._forEachChild = function (cb) {
                    this.controls.forEach(( /**
                     * @param {?} control
                     * @param {?} index
                     * @return {?}
                     */function (control, index) { cb(control, index); }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormArray.prototype._updateValue = function () {
                    var _this = this;
                    (( /** @type {?} */(this))).value =
                        this.controls.filter(( /**
                         * @param {?} control
                         * @return {?}
                         */function (control) { return control.enabled || _this.disabled; }))
                            .map(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control.value; }));
                };
                /**
                 * \@internal
                 * @param {?} condition
                 * @return {?}
                 */
                FormArray.prototype._anyControls = function (condition) {
                    return this.controls.some(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return control.enabled && condition(control); }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormArray.prototype._setUpControls = function () {
                    var _this = this;
                    this._forEachChild(( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) { return _this._registerControl(control); }));
                };
                /**
                 * \@internal
                 * @param {?} value
                 * @return {?}
                 */
                FormArray.prototype._checkAllValuesPresent = function (value) {
                    this._forEachChild(( /**
                     * @param {?} control
                     * @param {?} i
                     * @return {?}
                     */function (control, i) {
                        if (value[i] === undefined) {
                            throw new Error("Must supply a value for form control at index: " + i + ".");
                        }
                    }));
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormArray.prototype._allControlsDisabled = function () {
                    for (var _c = 0, _d = this.controls; _c < _d.length; _c++) {
                        var control = _d[_c];
                        if (control.enabled)
                            return false;
                    }
                    return this.controls.length > 0 || this.disabled;
                };
                /**
                 * @private
                 * @param {?} control
                 * @return {?}
                 */
                FormArray.prototype._registerControl = function (control) {
                    control.setParent(this);
                    control._registerOnCollectionChange(this._onCollectionChange);
                };
                return FormArray;
            }(AbstractControl));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var formDirectiveProvider = {
                provide: ControlContainer,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return NgForm; }))
            };
            var ɵ0 = /**
             * @return {?}
             */ function () { return Promise.resolve(null); };
            /** @type {?} */
            var resolvedPromise = ((ɵ0))();
            /**
             * \@description
             * Creates a top-level `FormGroup` instance and binds it to a form
             * to track aggregate form value and validation status.
             *
             * As soon as you import the `FormsModule`, this directive becomes active by default on
             * all `<form>` tags.  You don't need to add a special selector.
             *
             * You optionally export the directive into a local template variable using `ngForm` as the key
             * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
             * `FormGroup` instance are duplicated on the directive itself, so a reference to it
             * gives you access to the aggregate value and validity status of the form, as well as
             * user interaction properties like `dirty` and `touched`.
             *
             * To register child controls with the form, use `NgModel` with a `name`
             * attribute. You may use `NgModelGroup` to create sub-groups within the form.
             *
             * If necessary, listen to the directive's `ngSubmit` event to be notified when the user has
             * triggered a form submission. The `ngSubmit` event emits the original form
             * submission event.
             *
             * In template driven forms, all `<form>` tags are automatically tagged as `NgForm`.
             * To import the `FormsModule` but skip its usage in some forms,
             * for example, to use native HTML5 validation, add the `ngNoForm` and the `<form>`
             * tags won't create an `NgForm` directive. In reactive forms, using `ngNoForm` is
             * unnecessary because the `<form>` tags are inert. In that case, you would
             * refrain from using the `formGroup` directive.
             *
             * \@usageNotes
             *
             * ### Migrating from deprecated ngForm selector
             *
             * Support for using `ngForm` element selector has been deprecated in Angular v6 and will be removed
             * in Angular v9.
             *
             * This has been deprecated to keep selectors consistent with other core Angular selectors,
             * as element selectors are typically written in kebab-case.
             *
             * Now deprecated:
             * ```html
             * <ngForm #myForm="ngForm">
             * ```
             *
             * After:
             * ```html
             * <ng-form #myForm="ngForm">
             * ```
             *
             * ### Listening for form submission
             *
             * The following example shows how to capture the form values from the "ngSubmit" event.
             *
             * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
             *
             * ### Setting the update options
             *
             * The following example shows you how to change the "updateOn" option from its default using
             * ngFormOptions.
             *
             * ```html
             * <form [ngFormOptions]="{updateOn: 'blur'}">
             *    <input name="one" ngModel>  <!-- this ngModel will update on blur -->
             * </form>
             * ```
             *
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgForm = /** @class */ (function (_super_1) {
                __extends(NgForm, _super_1);
                /**
                 * @param {?} validators
                 * @param {?} asyncValidators
                 */
                function NgForm(validators, asyncValidators) {
                    var _this = _super_1.call(this) || this;
                    /**
                     * \@description
                     * Returns whether the form submission has been triggered.
                     */
                    _this.submitted = false;
                    _this._directives = [];
                    /**
                     * \@description
                     * Event emitter for the "ngSubmit" event
                     */
                    _this.ngSubmit = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    _this.form =
                        new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
                    return _this;
                }
                /**
                 * \@description
                 * Lifecycle method called after the view is initialized. For internal use only.
                 * @return {?}
                 */
                NgForm.prototype.ngAfterViewInit = function () { this._setUpdateStrategy(); };
                Object.defineProperty(NgForm.prototype, "formDirective", {
                    /**
                     * \@description
                     * The directive instance.
                     * @return {?}
                     */
                    get: function () { return this; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForm.prototype, "control", {
                    /**
                     * \@description
                     * The internal `FormGroup` instance.
                     * @return {?}
                     */
                    get: function () { return this.form; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForm.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array representing the path to this group. Because this directive
                     * always lives at the top level of a form, it is always an empty array.
                     * @return {?}
                     */
                    get: function () { return []; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgForm.prototype, "controls", {
                    /**
                     * \@description
                     * Returns a map of the controls in this group.
                     * @return {?}
                     */
                    get: function () { return this.form.controls; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Method that sets up the control directive in this group, re-calculates its value
                 * and validity, and adds the instance to the internal list of directives.
                 *
                 * @param {?} dir The `NgModel` directive instance.
                 * @return {?}
                 */
                NgForm.prototype.addControl = function (dir) {
                    var _this = this;
                    resolvedPromise.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var container = _this._findContainer(dir.path);
                        (( /** @type {?} */(dir))).control =
                            ( /** @type {?} */(container.registerControl(dir.name, dir.control)));
                        setUpControl(dir.control, dir);
                        dir.control.updateValueAndValidity({ emitEvent: false });
                        _this._directives.push(dir);
                    }));
                };
                /**
                 * \@description
                 * Retrieves the `FormControl` instance from the provided `NgModel` directive.
                 *
                 * @param {?} dir The `NgModel` directive instance.
                 * @return {?}
                 */
                NgForm.prototype.getControl = function (dir) { return ( /** @type {?} */(this.form.get(dir.path))); };
                /**
                 * \@description
                 * Removes the `NgModel` instance from the internal list of directives
                 *
                 * @param {?} dir The `NgModel` directive instance.
                 * @return {?}
                 */
                NgForm.prototype.removeControl = function (dir) {
                    var _this = this;
                    resolvedPromise.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var container = _this._findContainer(dir.path);
                        if (container) {
                            container.removeControl(dir.name);
                        }
                        removeDir(_this._directives, dir);
                    }));
                };
                /**
                 * \@description
                 * Adds a new `NgModelGroup` directive instance to the form.
                 *
                 * @param {?} dir The `NgModelGroup` directive instance.
                 * @return {?}
                 */
                NgForm.prototype.addFormGroup = function (dir) {
                    var _this = this;
                    resolvedPromise.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var container = _this._findContainer(dir.path);
                        /** @type {?} */
                        var group = new FormGroup({});
                        setUpFormContainer(group, dir);
                        container.registerControl(dir.name, group);
                        group.updateValueAndValidity({ emitEvent: false });
                    }));
                };
                /**
                 * \@description
                 * Removes the `NgModelGroup` directive instance from the form.
                 *
                 * @param {?} dir The `NgModelGroup` directive instance.
                 * @return {?}
                 */
                NgForm.prototype.removeFormGroup = function (dir) {
                    var _this = this;
                    resolvedPromise.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var container = _this._findContainer(dir.path);
                        if (container) {
                            container.removeControl(dir.name);
                        }
                    }));
                };
                /**
                 * \@description
                 * Retrieves the `FormGroup` for a provided `NgModelGroup` directive instance
                 *
                 * @param {?} dir The `NgModelGroup` directive instance.
                 * @return {?}
                 */
                NgForm.prototype.getFormGroup = function (dir) { return ( /** @type {?} */(this.form.get(dir.path))); };
                /**
                 * Sets the new value for the provided `NgControl` directive.
                 *
                 * @param {?} dir The `NgControl` directive instance.
                 * @param {?} value The new value for the directive's control.
                 * @return {?}
                 */
                NgForm.prototype.updateModel = function (dir, value) {
                    var _this = this;
                    resolvedPromise.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var ctrl = ( /** @type {?} */(_this.form.get(( /** @type {?} */(dir.path)))));
                        ctrl.setValue(value);
                    }));
                };
                /**
                 * \@description
                 * Sets the value for this `FormGroup`.
                 *
                 * @param {?} value The new value
                 * @return {?}
                 */
                NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
                /**
                 * \@description
                 * Method called when the "submit" event is triggered on the form.
                 * Triggers the `ngSubmit` emitter to emit the "submit" event as its payload.
                 *
                 * @param {?} $event The "submit" event object
                 * @return {?}
                 */
                NgForm.prototype.onSubmit = function ($event) {
                    (( /** @type {?} */(this))).submitted = true;
                    syncPendingControls(this.form, this._directives);
                    this.ngSubmit.emit($event);
                    return false;
                };
                /**
                 * \@description
                 * Method called when the "reset" event is triggered on the form.
                 * @return {?}
                 */
                NgForm.prototype.onReset = function () { this.resetForm(); };
                /**
                 * \@description
                 * Resets the form to an initial value and resets its submitted status.
                 *
                 * @param {?=} value The new value for the form.
                 * @return {?}
                 */
                NgForm.prototype.resetForm = function (value) {
                    if (value === void 0) { value = undefined; }
                    this.form.reset(value);
                    (( /** @type {?} */(this))).submitted = false;
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgForm.prototype._setUpdateStrategy = function () {
                    if (this.options && this.options.updateOn != null) {
                        this.form._updateOn = this.options.updateOn;
                    }
                };
                /**
                 * \@internal
                 * @param {?} path
                 * @return {?}
                 */
                NgForm.prototype._findContainer = function (path) {
                    path.pop();
                    return path.length ? ( /** @type {?} */(this.form.get(path))) : this.form;
                };
                return NgForm;
            }(ControlContainer));
            NgForm.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,ng-form,[ngForm]',
                            providers: [formDirectiveProvider],
                            host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                            outputs: ['ngSubmit'],
                            exportAs: 'ngForm'
                        },] }
            ];
            /** @nocollapse */
            NgForm.ctorParameters = function () { return [
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] }
            ]; };
            NgForm.propDecorators = {
                options: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngFormOptions',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var TemplateDrivenErrors = /** @class */ (function () {
                function TemplateDrivenErrors() {
                }
                /**
                 * @return {?}
                 */
                TemplateDrivenErrors.modelParentException = function () {
                    throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
                };
                /**
                 * @return {?}
                 */
                TemplateDrivenErrors.formGroupNameException = function () {
                    throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
                };
                /**
                 * @return {?}
                 */
                TemplateDrivenErrors.missingNameException = function () {
                    throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
                };
                /**
                 * @return {?}
                 */
                TemplateDrivenErrors.modelGroupParentException = function () {
                    throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
                };
                /**
                 * @return {?}
                 */
                TemplateDrivenErrors.ngFormWarning = function () {
                    console.warn("\n    It looks like you're using 'ngForm'.\n\n    Support for using the 'ngForm' element selector has been deprecated in Angular v6 and will be removed\n    in Angular v9.\n\n    Use 'ng-form' instead.\n\n    Before:\n    <ngForm #myForm=\"ngForm\">\n\n    After:\n    <ng-form #myForm=\"ngForm\">\n    ");
                };
                return TemplateDrivenErrors;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * `InjectionToken` to provide to turn off the warning when using 'ngForm' deprecated selector.
             * @type {?}
             */
            var NG_FORM_SELECTOR_WARNING = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('NgFormSelectorWarning');
            /**
             * This directive is solely used to display warnings when the deprecated `ngForm` selector is used.
             *
             * @deprecated in Angular v6 and will be removed in Angular v9.
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgFormSelectorWarning = /** @class */ (function () {
                /**
                 * @param {?} ngFormWarning
                 */
                function NgFormSelectorWarning(ngFormWarning) {
                    if (((!ngFormWarning || ngFormWarning === 'once') && !NgFormSelectorWarning._ngFormWarning) ||
                        ngFormWarning === 'always') {
                        TemplateDrivenErrors.ngFormWarning();
                        NgFormSelectorWarning._ngFormWarning = true;
                    }
                }
                return NgFormSelectorWarning;
            }());
            /**
             * Static property used to track whether the deprecation warning for this selector has been sent.
             * Used to support warning config of "once".
             *
             * \@internal
             */
            NgFormSelectorWarning._ngFormWarning = false;
            NgFormSelectorWarning.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: 'ngForm' },] }
            ];
            /** @nocollapse */
            NgFormSelectorWarning.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_FORM_SELECTOR_WARNING,] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * A base class for code shared between the `NgModelGroup` and `FormGroupName` directives.
             *
             * \@publicApi
             */
            var AbstractFormGroupDirective = /** @class */ (function (_super_1) {
                __extends(AbstractFormGroupDirective, _super_1);
                function AbstractFormGroupDirective() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * \@description
                 * An internal callback method triggered on the instance after the inputs are set.
                 * Registers the group with its parent group.
                 * @return {?}
                 */
                AbstractFormGroupDirective.prototype.ngOnInit = function () {
                    this._checkParentType();
                    ( /** @type {?} */(this.formDirective)).addFormGroup(this);
                };
                /**
                 * \@description
                 * An internal callback method triggered before the instance is destroyed.
                 * Removes the group from its parent group.
                 * @return {?}
                 */
                AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
                    if (this.formDirective) {
                        this.formDirective.removeFormGroup(this);
                    }
                };
                Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
                    /**
                     * \@description
                     * The `FormGroup` bound to this directive.
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(this.formDirective)).getFormGroup(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
                    /**
                     * \@description
                     * The path to this group from the top-level directive.
                     * @return {?}
                     */
                    get: function () { return controlPath(this.name, this._parent); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
                    /**
                     * \@description
                     * The top-level directive for this group if present, otherwise null.
                     * @return {?}
                     */
                    get: function () { return this._parent ? this._parent.formDirective : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
                    /**
                     * \@description
                     * The synchronous validators registered with this group.
                     * @return {?}
                     */
                    get: function () { return composeValidators(this._validators); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
                    /**
                     * \@description
                     * The async validators registered with this group.
                     * @return {?}
                     */
                    get: function () {
                        return composeAsyncValidators(this._asyncValidators);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@internal
                 * @return {?}
                 */
                AbstractFormGroupDirective.prototype._checkParentType = function () { };
                return AbstractFormGroupDirective;
            }(ControlContainer));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var modelGroupProvider = {
                provide: ControlContainer,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return NgModelGroup; }))
            };
            /**
             * \@description
             * Creates and binds a `FormGroup` instance to a DOM element.
             *
             * This directive can only be used as a child of `NgForm` (within `<form>` tags).
             *
             * Use this directive to validate a sub-group of your form separately from the
             * rest of your form, or if some values in your domain model make more sense
             * to consume together in a nested object.
             *
             * Provide a name for the sub-group and it will become the key
             * for the sub-group in the form's full value. If you need direct access, export the directive into
             * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
             *
             * \@usageNotes
             *
             * ### Consuming controls in a grouping
             *
             * The following example shows you how to combine controls together in a sub-group
             * of the form.
             *
             * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
             *
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgModelGroup = /** @class */ (function (_super_1) {
                __extends(NgModelGroup, _super_1);
                /**
                 * @param {?} parent
                 * @param {?} validators
                 * @param {?} asyncValidators
                 */
                function NgModelGroup(parent, validators, asyncValidators) {
                    var _this = _super_1.call(this) || this;
                    _this._parent = parent;
                    _this._validators = validators;
                    _this._asyncValidators = asyncValidators;
                    return _this;
                }
                /**
                 * \@internal
                 * @return {?}
                 */
                NgModelGroup.prototype._checkParentType = function () {
                    if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
                        TemplateDrivenErrors.modelGroupParentException();
                    }
                };
                return NgModelGroup;
            }(AbstractFormGroupDirective));
            NgModelGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] }
            ];
            /** @nocollapse */
            NgModelGroup.ctorParameters = function () { return [
                { type: ControlContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] }
            ]; };
            NgModelGroup.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngModelGroup',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var formControlBinding = {
                provide: NgControl,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return NgModel; }))
            };
            var ɵ0$1 = /**
             * @return {?}
             */ function () { return Promise.resolve(null); };
            /**
             * `ngModel` forces an additional change detection run when its inputs change:
             * E.g.:
             * ```
             * <div>{{myModel.valid}}</div>
             * <input [(ngModel)]="myValue" #myModel="ngModel">
             * ```
             * I.e. `ngModel` can export itself on the element and then be used in the template.
             * Normally, this would result in expressions before the `input` that use the exported directive
             * to have and old value as they have been
             * dirty checked before. As this is a very common case for `ngModel`, we added this second change
             * detection run.
             *
             * Notes:
             * - this is just one extra run no matter how many `ngModel` have been changed.
             * - this is a general problem when using `exportAs` for directives!
             * @type {?}
             */
            var resolvedPromise$1 = ((ɵ0$1))();
            /**
             * \@description
             * Creates a `FormControl` instance from a domain model and binds it
             * to a form control element.
             *
             * The `FormControl` instance tracks the value, user interaction, and
             * validation status of the control and keeps the view synced with the model. If used
             * within a parent form, the directive also registers itself with the form as a child
             * control.
             *
             * This directive is used by itself or as part of a larger form. Use the
             * `ngModel` selector to activate it.
             *
             * It accepts a domain model as an optional `Input`. If you have a one-way binding
             * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
             * class sets the value in the view. If you have a two-way binding with `[()]` syntax
             * (also known as 'banana-box syntax'), the value in the UI always syncs back to
             * the domain model in your class.
             *
             * To inspect the properties of the associated `FormControl` (like validity state),
             * export the directive into a local template variable using `ngModel` as the key (ex: `#myVar="ngModel"`).
             * You then access the control using the directive's `control` property,
             * but most properties used (like `valid` and `dirty`) fall through to the control anyway for direct access.
             * See a full list of properties directly available in `AbstractControlDirective`.
             *
             * @see `RadioControlValueAccessor`
             * @see `SelectControlValueAccessor`
             *
             * \@usageNotes
             *
             * ### Using ngModel on a standalone control
             *
             * The following examples show a simple standalone control using `ngModel`:
             *
             * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
             *
             * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
             * so that the control can be registered with the parent form under that name.
             *
             * In the context of a parent form, it's often unnecessary to include one-way or two-way binding,
             * as the parent form syncs the value for you. You access its properties by exporting it into a
             * local template variable using `ngForm` such as (`#f="ngForm"`). Use the variable where
             * needed on form submission.
             *
             * If you do need to populate initial values into your form, using a one-way binding for
             * `ngModel` tends to be sufficient as long as you use the exported form's value rather
             * than the domain model's value on submit.
             *
             * ### Using ngModel within a form
             *
             * The following example shows controls using `ngModel` within a form:
             *
             * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
             *
             * ### Using a standalone ngModel within a group
             *
             * The following example shows you how to use a standalone ngModel control
             * within a form. This controls the display of the form, but doesn't contain form data.
             *
             * ```html
             * <form>
             *   <input name="login" ngModel placeholder="Login">
             *   <input type="checkbox" ngModel [ngModelOptions]="{standalone: true}"> Show more options?
             * </form>
             * <!-- form value: {login: ''} -->
             * ```
             *
             * ### Setting the ngModel name attribute through options
             *
             * The following example shows you an alternate way to set the name attribute. The name attribute is used
             * within a custom form component, and the name `\@Input` property serves a different purpose.
             *
             * ```html
             * <form>
             *   <my-person-control name="Nancy" ngModel [ngModelOptions]="{name: 'user'}">
             *   </my-person-control>
             * </form>
             * <!-- form value: {user: ''} -->
             * ```
             *
             * \@ngModule FormsModule
             * \@publicApi
             */
            var NgModel = /** @class */ (function (_super_1) {
                __extends(NgModel, _super_1);
                /**
                 * @param {?} parent
                 * @param {?} validators
                 * @param {?} asyncValidators
                 * @param {?} valueAccessors
                 */
                function NgModel(parent, validators, asyncValidators, valueAccessors) {
                    var _this = _super_1.call(this) || this;
                    _this.control = new FormControl();
                    /**
                     * \@internal
                     */
                    _this._registered = false;
                    /**
                     * \@description
                     * Event emitter for producing the `ngModelChange` event after
                     * the view model updates.
                     */
                    _this.update = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    _this._parent = parent;
                    _this._rawValidators = validators || [];
                    _this._rawAsyncValidators = asyncValidators || [];
                    _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
                    return _this;
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use
                 * only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                NgModel.prototype.ngOnChanges = function (changes) {
                    this._checkForErrors();
                    if (!this._registered)
                        this._setUpControl();
                    if ('isDisabled' in changes) {
                        this._updateDisabled(changes);
                    }
                    if (isPropertyUpdated(changes, this.viewModel)) {
                        this._updateValue(this.model);
                        this.viewModel = this.model;
                    }
                };
                /**
                 * \@description
                 * Lifecycle method called before the directive's instance is destroyed. For internal
                 * use only.
                 * @return {?}
                 */
                NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
                Object.defineProperty(NgModel.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array that represents the path from the top-level form to this control.
                     * Each index is the string name of the control on that level.
                     * @return {?}
                     */
                    get: function () {
                        return this._parent ? controlPath(this.name, this._parent) : [this.name];
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgModel.prototype, "formDirective", {
                    /**
                     * \@description
                     * The top-level directive for this control if present, otherwise null.
                     * @return {?}
                     */
                    get: function () { return this._parent ? this._parent.formDirective : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgModel.prototype, "validator", {
                    /**
                     * \@description
                     * Synchronous validator function composed of all the synchronous validators
                     * registered with this directive.
                     * @return {?}
                     */
                    get: function () { return composeValidators(this._rawValidators); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NgModel.prototype, "asyncValidator", {
                    /**
                     * \@description
                     * Async validator function composed of all the async validators registered with this
                     * directive.
                     * @return {?}
                     */
                    get: function () {
                        return composeAsyncValidators(this._rawAsyncValidators);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Sets the new value for the view model and emits an `ngModelChange` event.
                 *
                 * @param {?} newValue The new value emitted by `ngModelChange`.
                 * @return {?}
                 */
                NgModel.prototype.viewToModelUpdate = function (newValue) {
                    this.viewModel = newValue;
                    this.update.emit(newValue);
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._setUpControl = function () {
                    this._setUpdateStrategy();
                    this._isStandalone() ? this._setUpStandalone() :
                        this.formDirective.addControl(this);
                    this._registered = true;
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._setUpdateStrategy = function () {
                    if (this.options && this.options.updateOn != null) {
                        this.control._updateOn = this.options.updateOn;
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._isStandalone = function () {
                    return !this._parent || !!(this.options && this.options.standalone);
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._setUpStandalone = function () {
                    setUpControl(this.control, this);
                    this.control.updateValueAndValidity({ emitEvent: false });
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._checkForErrors = function () {
                    if (!this._isStandalone()) {
                        this._checkParentType();
                    }
                    this._checkName();
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._checkParentType = function () {
                    if (!(this._parent instanceof NgModelGroup) &&
                        this._parent instanceof AbstractFormGroupDirective) {
                        TemplateDrivenErrors.formGroupNameException();
                    }
                    else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
                        TemplateDrivenErrors.modelParentException();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                NgModel.prototype._checkName = function () {
                    if (this.options && this.options.name)
                        this.name = this.options.name;
                    if (!this._isStandalone() && !this.name) {
                        TemplateDrivenErrors.missingNameException();
                    }
                };
                /**
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                NgModel.prototype._updateValue = function (value) {
                    var _this = this;
                    resolvedPromise$1.then(( /**
                     * @return {?}
                     */function () { _this.control.setValue(value, { emitViewToModelChange: false }); }));
                };
                /**
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                NgModel.prototype._updateDisabled = function (changes) {
                    var _this = this;
                    /** @type {?} */
                    var disabledValue = changes['isDisabled'].currentValue;
                    /** @type {?} */
                    var isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
                    resolvedPromise$1.then(( /**
                     * @return {?}
                     */function () {
                        if (isDisabled && !_this.control.disabled) {
                            _this.control.disable();
                        }
                        else if (!isDisabled && _this.control.disabled) {
                            _this.control.enable();
                        }
                    }));
                };
                return NgModel;
            }(NgControl));
            NgModel.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[ngModel]:not([formControlName]):not([formControl])',
                            providers: [formControlBinding],
                            exportAs: 'ngModel'
                        },] }
            ];
            /** @nocollapse */
            NgModel.ctorParameters = function () { return [
                { type: ControlContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALUE_ACCESSOR,] }] }
            ]; };
            NgModel.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                isDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['disabled',] }],
                model: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngModel',] }],
                options: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngModelOptions',] }],
                update: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"], args: ['ngModelChange',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             *
             * Adds `novalidate` attribute to all forms by default.
             *
             * `novalidate` is used to disable browser's native form validation.
             *
             * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
             *
             * ```
             * <form ngNativeValidate></form>
             * ```
             *
             * \@publicApi
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             */
            var ɵNgNoValidate = /** @class */ (function () {
                function ɵNgNoValidate() {
                }
                return ɵNgNoValidate;
            }());
            ɵNgNoValidate.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                            host: { 'novalidate': '' },
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Token to provide to turn off the ngModel warning on formControl and formControlName.
             * @type {?}
             */
            var NG_MODEL_WITH_FORM_CONTROL_WARNING = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('NgModelWithFormControlWarning');
            /** @type {?} */
            var formControlBinding$1 = {
                provide: NgControl,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return FormControlDirective; }))
            };
            /**
             * \@description
             * * Syncs a standalone `FormControl` instance to a form control element.
             *
             * @see [Reactive Forms Guide](guide/reactive-forms)
             * @see `FormControl`
             * @see `AbstractControl`
             *
             * \@usageNotes
             *
             * ### Registering a single form control
             *
             * The following examples shows how to register a standalone control and set its value.
             *
             * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
             *
             * ### Use with ngModel
             *
             * Support for using the `ngModel` input property and `ngModelChange` event with reactive
             * form directives has been deprecated in Angular v6 and will be removed in Angular v7.
             *
             * Now deprecated:
             *
             * ```html
             * <input [formControl]="control" [(ngModel)]="value">
             * ```
             *
             * ```ts
             * this.value = 'some value';
             * ```
             *
             * This has been deprecated for a few reasons. First, developers have found this pattern
             * confusing. It seems like the actual `ngModel` directive is being used, but in fact it's
             * an input/output property named `ngModel` on the reactive form directive that simply
             * approximates (some of) its behavior. Specifically, it allows getting/setting the value
             * and intercepting value events. However, some of `ngModel`'s other features - like
             * delaying updates with`ngModelOptions` or exporting the directive - simply don't work,
             * which has understandably caused some confusion.
             *
             * In addition, this pattern mixes template-driven and reactive forms strategies, which
             * we generally don't recommend because it doesn't take advantage of the full benefits of
             * either strategy. Setting the value in the template violates the template-agnostic
             * principles behind reactive forms, whereas adding a `FormControl`/`FormGroup` layer in
             * the class removes the convenience of defining forms in the template.
             *
             * To update your code before v7, you'll want to decide whether to stick with reactive form
             * directives (and get/set values using reactive forms patterns) or switch over to
             * template-driven directives.
             *
             * After (choice 1 - use reactive forms):
             *
             * ```html
             * <input [formControl]="control">
             * ```
             *
             * ```ts
             * this.control.setValue('some value');
             * ```
             *
             * After (choice 2 - use template-driven forms):
             *
             * ```html
             * <input [(ngModel)]="value">
             * ```
             *
             * ```ts
             * this.value = 'some value';
             * ```
             *
             * By default, when you use this pattern, you will see a deprecation warning once in dev
             * mode. You can choose to silence this warning by providing a config for
             * `ReactiveFormsModule` at import time:
             *
             * ```ts
             * imports: [
             *   ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'});
             * ]
             * ```
             *
             * Alternatively, you can choose to surface a separate warning for each instance of this
             * pattern with a config value of `"always"`. This may help to track down where in the code
             * the pattern is being used as the code is being updated.
             *
             * \@ngModule ReactiveFormsModule
             * \@publicApi
             */
            var FormControlDirective = /** @class */ (function (_super_1) {
                __extends(FormControlDirective, _super_1);
                /**
                 * @param {?} validators
                 * @param {?} asyncValidators
                 * @param {?} valueAccessors
                 * @param {?} _ngModelWarningConfig
                 */
                function FormControlDirective(validators, asyncValidators, valueAccessors, _ngModelWarningConfig) {
                    var _this = _super_1.call(this) || this;
                    _this._ngModelWarningConfig = _ngModelWarningConfig;
                    /**
                     * @deprecated as of v6
                     */
                    _this.update = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * \@description
                     * Instance property used to track whether an ngModel warning has been sent out for this
                     * particular `FormControlDirective` instance. Used to support warning config of "always".
                     *
                     * \@internal
                     */
                    _this._ngModelWarningSent = false;
                    _this._rawValidators = validators || [];
                    _this._rawAsyncValidators = asyncValidators || [];
                    _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
                    return _this;
                }
                Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
                    /**
                     * \@description
                     * Triggers a warning that this input should not be used with reactive forms.
                     * @param {?} isDisabled
                     * @return {?}
                     */
                    set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use
                 * only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                FormControlDirective.prototype.ngOnChanges = function (changes) {
                    if (this._isControlChanged(changes)) {
                        setUpControl(this.form, this);
                        if (this.control.disabled && ( /** @type {?} */(this.valueAccessor)).setDisabledState) {
                            ( /** @type {?} */(( /** @type {?} */(this.valueAccessor)).setDisabledState))(true);
                        }
                        this.form.updateValueAndValidity({ emitEvent: false });
                    }
                    if (isPropertyUpdated(changes, this.viewModel)) {
                        _ngModelWarning('formControl', FormControlDirective, this, this._ngModelWarningConfig);
                        this.form.setValue(this.model);
                        this.viewModel = this.model;
                    }
                };
                Object.defineProperty(FormControlDirective.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array that represents the path from the top-level form to this control.
                     * Each index is the string name of the control on that level.
                     * @return {?}
                     */
                    get: function () { return []; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormControlDirective.prototype, "validator", {
                    /**
                     * \@description
                     * Synchronous validator function composed of all the synchronous validators
                     * registered with this directive.
                     * @return {?}
                     */
                    get: function () { return composeValidators(this._rawValidators); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
                    /**
                     * \@description
                     * Async validator function composed of all the async validators registered with this
                     * directive.
                     * @return {?}
                     */
                    get: function () {
                        return composeAsyncValidators(this._rawAsyncValidators);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormControlDirective.prototype, "control", {
                    /**
                     * \@description
                     * The `FormControl` bound to this directive.
                     * @return {?}
                     */
                    get: function () { return this.form; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Sets the new value for the view model and emits an `ngModelChange` event.
                 *
                 * @param {?} newValue The new value for the view model.
                 * @return {?}
                 */
                FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
                    this.viewModel = newValue;
                    this.update.emit(newValue);
                };
                /**
                 * @private
                 * @param {?} changes
                 * @return {?}
                 */
                FormControlDirective.prototype._isControlChanged = function (changes) {
                    return changes.hasOwnProperty('form');
                };
                return FormControlDirective;
            }(NgControl));
            /**
             * \@description
             * Static property used to track whether any ngModel warnings have been sent across
             * all instances of FormControlDirective. Used to support warning config of "once".
             *
             * \@internal
             */
            FormControlDirective._ngModelWarningSentOnce = false;
            FormControlDirective.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] }
            ];
            /** @nocollapse */
            FormControlDirective.ctorParameters = function () { return [
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALUE_ACCESSOR,] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_MODEL_WITH_FORM_CONTROL_WARNING,] }] }
            ]; };
            FormControlDirective.propDecorators = {
                form: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['formControl',] }],
                isDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['disabled',] }],
                model: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngModel',] }],
                update: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"], args: ['ngModelChange',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var formDirectiveProvider$1 = {
                provide: ControlContainer,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return FormGroupDirective; }))
            };
            /**
             * \@description
             *
             * Binds an existing `FormGroup` to a DOM element.
             *
             * This directive accepts an existing `FormGroup` instance. It will then use this
             * `FormGroup` instance to match any child `FormControl`, `FormGroup`,
             * and `FormArray` instances to child `FormControlName`, `FormGroupName`,
             * and `FormArrayName` directives.
             *
             * @see [Reactive Forms Guide](guide/reactive-forms)
             * @see `AbstractControl`
             *
             * ### Register Form Group
             *
             * The following example registers a `FormGroup` with first name and last name controls,
             * and listens for the *ngSubmit* event when the button is clicked.
             *
             * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
             *
             * \@ngModule ReactiveFormsModule
             * \@publicApi
             */
            var FormGroupDirective = /** @class */ (function (_super_1) {
                __extends(FormGroupDirective, _super_1);
                /**
                 * @param {?} _validators
                 * @param {?} _asyncValidators
                 */
                function FormGroupDirective(_validators, _asyncValidators) {
                    var _this = _super_1.call(this) || this;
                    _this._validators = _validators;
                    _this._asyncValidators = _asyncValidators;
                    /**
                     * \@description
                     * Reports whether the form submission has been triggered.
                     */
                    _this.submitted = false;
                    /**
                     * \@description
                     * Tracks the list of added `FormControlName` instances
                     */
                    _this.directives = [];
                    /**
                     * \@description
                     * Tracks the `FormGroup` bound to this directive.
                     */
                    _this.form = ( /** @type {?} */(null));
                    /**
                     * \@description
                     * Emits an event when the form submission has been triggered.
                     */
                    _this.ngSubmit = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    return _this;
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                FormGroupDirective.prototype.ngOnChanges = function (changes) {
                    this._checkFormPresent();
                    if (changes.hasOwnProperty('form')) {
                        this._updateValidators();
                        this._updateDomValue();
                        this._updateRegistrations();
                    }
                };
                Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
                    /**
                     * \@description
                     * Returns this directive's instance.
                     * @return {?}
                     */
                    get: function () { return this; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormGroupDirective.prototype, "control", {
                    /**
                     * \@description
                     * Returns the `FormGroup` bound to this directive.
                     * @return {?}
                     */
                    get: function () { return this.form; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormGroupDirective.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array representing the path to this group. Because this directive
                     * always lives at the top level of a form, it always an empty array.
                     * @return {?}
                     */
                    get: function () { return []; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Method that sets up the control directive in this group, re-calculates its value
                 * and validity, and adds the instance to the internal list of directives.
                 *
                 * @param {?} dir The `FormControlName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.addControl = function (dir) {
                    /** @type {?} */
                    var ctrl = this.form.get(dir.path);
                    setUpControl(ctrl, dir);
                    ctrl.updateValueAndValidity({ emitEvent: false });
                    this.directives.push(dir);
                    return ctrl;
                };
                /**
                 * \@description
                 * Retrieves the `FormControl` instance from the provided `FormControlName` directive
                 *
                 * @param {?} dir The `FormControlName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.getControl = function (dir) { return ( /** @type {?} */(this.form.get(dir.path))); };
                /**
                 * \@description
                 * Removes the `FormControlName` instance from the internal list of directives
                 *
                 * @param {?} dir The `FormControlName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.removeControl = function (dir) { removeDir(this.directives, dir); };
                /**
                 * Adds a new `FormGroupName` directive instance to the form.
                 *
                 * @param {?} dir The `FormGroupName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.addFormGroup = function (dir) {
                    /** @type {?} */
                    var ctrl = this.form.get(dir.path);
                    setUpFormContainer(ctrl, dir);
                    ctrl.updateValueAndValidity({ emitEvent: false });
                };
                /**
                 * No-op method to remove the form group.
                 *
                 * @param {?} dir The `FormGroupName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.removeFormGroup = function (dir) { };
                /**
                 * \@description
                 * Retrieves the `FormGroup` for a provided `FormGroupName` directive instance
                 *
                 * @param {?} dir The `FormGroupName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.getFormGroup = function (dir) { return ( /** @type {?} */(this.form.get(dir.path))); };
                /**
                 * Adds a new `FormArrayName` directive instance to the form.
                 *
                 * @param {?} dir The `FormArrayName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.addFormArray = function (dir) {
                    /** @type {?} */
                    var ctrl = this.form.get(dir.path);
                    setUpFormContainer(ctrl, dir);
                    ctrl.updateValueAndValidity({ emitEvent: false });
                };
                /**
                 * No-op method to remove the form array.
                 *
                 * @param {?} dir The `FormArrayName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.removeFormArray = function (dir) { };
                /**
                 * \@description
                 * Retrieves the `FormArray` for a provided `FormArrayName` directive instance.
                 *
                 * @param {?} dir The `FormArrayName` directive instance.
                 * @return {?}
                 */
                FormGroupDirective.prototype.getFormArray = function (dir) { return ( /** @type {?} */(this.form.get(dir.path))); };
                /**
                 * Sets the new value for the provided `FormControlName` directive.
                 *
                 * @param {?} dir The `FormControlName` directive instance.
                 * @param {?} value The new value for the directive's control.
                 * @return {?}
                 */
                FormGroupDirective.prototype.updateModel = function (dir, value) {
                    /** @type {?} */
                    var ctrl = ( /** @type {?} */(this.form.get(dir.path)));
                    ctrl.setValue(value);
                };
                /**
                 * \@description
                 * Method called with the "submit" event is triggered on the form.
                 * Triggers the `ngSubmit` emitter to emit the "submit" event as its payload.
                 *
                 * @param {?} $event The "submit" event object
                 * @return {?}
                 */
                FormGroupDirective.prototype.onSubmit = function ($event) {
                    (( /** @type {?} */(this))).submitted = true;
                    syncPendingControls(this.form, this.directives);
                    this.ngSubmit.emit($event);
                    return false;
                };
                /**
                 * \@description
                 * Method called when the "reset" event is triggered on the form.
                 * @return {?}
                 */
                FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
                /**
                 * \@description
                 * Resets the form to an initial value and resets its submitted status.
                 *
                 * @param {?=} value The new value for the form.
                 * @return {?}
                 */
                FormGroupDirective.prototype.resetForm = function (value) {
                    if (value === void 0) { value = undefined; }
                    this.form.reset(value);
                    (( /** @type {?} */(this))).submitted = false;
                };
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroupDirective.prototype._updateDomValue = function () {
                    var _this = this;
                    this.directives.forEach(( /**
                     * @param {?} dir
                     * @return {?}
                     */function (/**
                     * @param {?} dir
                     * @return {?}
                     */ dir) {
                        /** @type {?} */
                        var newCtrl = _this.form.get(dir.path);
                        if (dir.control !== newCtrl) {
                            cleanUpControl(dir.control, dir);
                            if (newCtrl)
                                setUpControl(newCtrl, dir);
                            (( /** @type {?} */(dir))).control = newCtrl;
                        }
                    }));
                    this.form._updateTreeValidity({ emitEvent: false });
                };
                /**
                 * @private
                 * @return {?}
                 */
                FormGroupDirective.prototype._updateRegistrations = function () {
                    var _this = this;
                    this.form._registerOnCollectionChange(( /**
                     * @return {?}
                     */function () { return _this._updateDomValue(); }));
                    if (this._oldForm)
                        this._oldForm._registerOnCollectionChange(( /**
                         * @return {?}
                         */function () { }));
                    this._oldForm = this.form;
                };
                /**
                 * @private
                 * @return {?}
                 */
                FormGroupDirective.prototype._updateValidators = function () {
                    /** @type {?} */
                    var sync = composeValidators(this._validators);
                    this.form.validator = Validators.compose([( /** @type {?} */(this.form.validator)), ( /** @type {?} */(sync))]);
                    /** @type {?} */
                    var async = composeAsyncValidators(this._asyncValidators);
                    this.form.asyncValidator = Validators.composeAsync([( /** @type {?} */(this.form.asyncValidator)), ( /** @type {?} */(async))]);
                };
                /**
                 * @private
                 * @return {?}
                 */
                FormGroupDirective.prototype._checkFormPresent = function () {
                    if (!this.form) {
                        ReactiveErrors.missingFormException();
                    }
                };
                return FormGroupDirective;
            }(ControlContainer));
            FormGroupDirective.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[formGroup]',
                            providers: [formDirectiveProvider$1],
                            host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                            exportAs: 'ngForm'
                        },] }
            ];
            /** @nocollapse */
            FormGroupDirective.ctorParameters = function () { return [
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] }
            ]; };
            FormGroupDirective.propDecorators = {
                form: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['formGroup',] }],
                ngSubmit: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var formGroupNameProvider = {
                provide: ControlContainer,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return FormGroupName; }))
            };
            /**
             * \@description
             *
             * Syncs a nested `FormGroup` to a DOM element.
             *
             * This directive can only be used with a parent `FormGroupDirective`.
             *
             * It accepts the string name of the nested `FormGroup` to link, and
             * looks for a `FormGroup` registered with that name in the parent
             * `FormGroup` instance you passed into `FormGroupDirective`.
             *
             * Use nested form groups to validate a sub-group of a
             * form separately from the rest or to group the values of certain
             * controls into their own nested object.
             *
             * @see [Reactive Forms Guide](guide/reactive-forms)
             *
             * \@usageNotes
             *
             * ### Access the group by name
             *
             * The following example uses the {\@link AbstractControl#get get} method to access the
             * associated `FormGroup`
             *
             * ```ts
             *   this.form.get('name');
             * ```
             *
             * ### Access individual controls in the group
             *
             * The following example uses the {\@link AbstractControl#get get} method to access
             * individual controls within the group using dot syntax.
             *
             * ```ts
             *   this.form.get('name.first');
             * ```
             *
             * ### Register a nested `FormGroup`.
             *
             * The following example registers a nested *name* `FormGroup` within an existing `FormGroup`,
             * and provides methods to retrieve the nested `FormGroup` and individual controls.
             *
             * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
             *
             * \@ngModule ReactiveFormsModule
             * \@publicApi
             */
            var FormGroupName = /** @class */ (function (_super_1) {
                __extends(FormGroupName, _super_1);
                /**
                 * @param {?} parent
                 * @param {?} validators
                 * @param {?} asyncValidators
                 */
                function FormGroupName(parent, validators, asyncValidators) {
                    var _this = _super_1.call(this) || this;
                    _this._parent = parent;
                    _this._validators = validators;
                    _this._asyncValidators = asyncValidators;
                    return _this;
                }
                /**
                 * \@internal
                 * @return {?}
                 */
                FormGroupName.prototype._checkParentType = function () {
                    if (_hasInvalidParent(this._parent)) {
                        ReactiveErrors.groupParentException();
                    }
                };
                return FormGroupName;
            }(AbstractFormGroupDirective));
            FormGroupName.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] }
            ];
            /** @nocollapse */
            FormGroupName.ctorParameters = function () { return [
                { type: ControlContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] }
            ]; };
            FormGroupName.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['formGroupName',] }]
            };
            if (false) { }
            /** @type {?} */
            var formArrayNameProvider = {
                provide: ControlContainer,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return FormArrayName; }))
            };
            /**
             * \@description
             *
             * Syncs a nested `FormArray` to a DOM element.
             *
             * This directive is designed to be used with a parent `FormGroupDirective` (selector:
             * `[formGroup]`).
             *
             * It accepts the string name of the nested `FormArray` you want to link, and
             * will look for a `FormArray` registered with that name in the parent
             * `FormGroup` instance you passed into `FormGroupDirective`.
             *
             * @see [Reactive Forms Guide](guide/reactive-forms)
             * @see `AbstractControl`
             *
             * \@usageNotes
             *
             * ### Example
             *
             * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
             *
             * \@ngModule ReactiveFormsModule
             * \@publicApi
             */
            var FormArrayName = /** @class */ (function (_super_1) {
                __extends(FormArrayName, _super_1);
                /**
                 * @param {?} parent
                 * @param {?} validators
                 * @param {?} asyncValidators
                 */
                function FormArrayName(parent, validators, asyncValidators) {
                    var _this = _super_1.call(this) || this;
                    _this._parent = parent;
                    _this._validators = validators;
                    _this._asyncValidators = asyncValidators;
                    return _this;
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs are initialized. For internal use only.
                 *
                 * @throws If the directive does not have a valid parent.
                 * @return {?}
                 */
                FormArrayName.prototype.ngOnInit = function () {
                    this._checkParentType();
                    ( /** @type {?} */(this.formDirective)).addFormArray(this);
                };
                /**
                 * \@description
                 * A lifecycle method called before the directive's instance is destroyed. For internal use only.
                 * @return {?}
                 */
                FormArrayName.prototype.ngOnDestroy = function () {
                    if (this.formDirective) {
                        this.formDirective.removeFormArray(this);
                    }
                };
                Object.defineProperty(FormArrayName.prototype, "control", {
                    /**
                     * \@description
                     * The `FormArray` bound to this directive.
                     * @return {?}
                     */
                    get: function () { return ( /** @type {?} */(this.formDirective)).getFormArray(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormArrayName.prototype, "formDirective", {
                    /**
                     * \@description
                     * The top-level directive for this group if present, otherwise null.
                     * @return {?}
                     */
                    get: function () {
                        return this._parent ? ( /** @type {?} */(this._parent.formDirective)) : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormArrayName.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array that represents the path from the top-level form to this control.
                     * Each index is the string name of the control on that level.
                     * @return {?}
                     */
                    get: function () { return controlPath(this.name, this._parent); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormArrayName.prototype, "validator", {
                    /**
                     * \@description
                     * Synchronous validator function composed of all the synchronous validators registered with this
                     * directive.
                     * @return {?}
                     */
                    get: function () { return composeValidators(this._validators); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
                    /**
                     * \@description
                     * Async validator function composed of all the async validators registered with this directive.
                     * @return {?}
                     */
                    get: function () {
                        return composeAsyncValidators(this._asyncValidators);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @return {?}
                 */
                FormArrayName.prototype._checkParentType = function () {
                    if (_hasInvalidParent(this._parent)) {
                        ReactiveErrors.arrayParentException();
                    }
                };
                return FormArrayName;
            }(ControlContainer));
            FormArrayName.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] }
            ];
            /** @nocollapse */
            FormArrayName.ctorParameters = function () { return [
                { type: ControlContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] }
            ]; };
            FormArrayName.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['formArrayName',] }]
            };
            if (false) { }
            /**
             * @param {?} parent
             * @return {?}
             */
            function _hasInvalidParent(parent) {
                return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
                    !(parent instanceof FormArrayName);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var controlNameBinding = {
                provide: NgControl,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return FormControlName; }))
            };
            /**
             * \@description
             * Syncs a `FormControl` in an existing `FormGroup` to a form control
             * element by name.
             *
             * @see [Reactive Forms Guide](guide/reactive-forms)
             * @see `FormControl`
             * @see `AbstractControl`
             *
             * \@usageNotes
             *
             * ### Register `FormControl` within a group
             *
             * The following example shows how to register multiple form controls within a form group
             * and set their value.
             *
             * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
             *
             * To see `formControlName` examples with different form control types, see:
             *
             * * Radio buttons: `RadioControlValueAccessor`
             * * Selects: `SelectControlValueAccessor`
             *
             * ### Use with ngModel
             *
             * Support for using the `ngModel` input property and `ngModelChange` event with reactive
             * form directives has been deprecated in Angular v6 and will be removed in Angular v7.
             *
             * Now deprecated:
             *
             * ```html
             * <form [formGroup]="form">
             *   <input formControlName="first" [(ngModel)]="value">
             * </form>
             * ```
             *
             * ```ts
             * this.value = 'some value';
             * ```
             *
             * This has been deprecated for a few reasons. First, developers have found this pattern
             * confusing. It seems like the actual `ngModel` directive is being used, but in fact it's
             * an input/output property named `ngModel` on the reactive form directive that simply
             * approximates (some of) its behavior. Specifically, it allows getting/setting the value
             * and intercepting value events. However, some of `ngModel`'s other features - like
             * delaying updates with`ngModelOptions` or exporting the directive - simply don't work,
             * which has understandably caused some confusion.
             *
             * In addition, this pattern mixes template-driven and reactive forms strategies, which
             * we generally don't recommend because it doesn't take advantage of the full benefits of
             * either strategy. Setting the value in the template violates the template-agnostic
             * principles behind reactive forms, whereas adding a `FormControl`/`FormGroup` layer in
             * the class removes the convenience of defining forms in the template.
             *
             * To update your code before v7, you'll want to decide whether to stick with reactive form
             * directives (and get/set values using reactive forms patterns) or switch over to
             * template-driven directives.
             *
             * After (choice 1 - use reactive forms):
             *
             * ```html
             * <form [formGroup]="form">
             *   <input formControlName="first">
             * </form>
             * ```
             *
             * ```ts
             * this.form.get('first').setValue('some value');
             * ```
             *
             * After (choice 2 - use template-driven forms):
             *
             * ```html
             * <input [(ngModel)]="value">
             * ```
             *
             * ```ts
             * this.value = 'some value';
             * ```
             *
             * By default, when you use this pattern, you will see a deprecation warning once in dev
             * mode. You can choose to silence this warning by providing a config for
             * `ReactiveFormsModule` at import time:
             *
             * ```ts
             * imports: [
             *   ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'})
             * ]
             * ```
             *
             * Alternatively, you can choose to surface a separate warning for each instance of this
             * pattern with a config value of `"always"`. This may help to track down where in the code
             * the pattern is being used as the code is being updated.
             *
             * \@ngModule ReactiveFormsModule
             * \@publicApi
             */
            var FormControlName = /** @class */ (function (_super_1) {
                __extends(FormControlName, _super_1);
                /**
                 * @param {?} parent
                 * @param {?} validators
                 * @param {?} asyncValidators
                 * @param {?} valueAccessors
                 * @param {?} _ngModelWarningConfig
                 */
                function FormControlName(parent, validators, asyncValidators, valueAccessors, _ngModelWarningConfig) {
                    var _this = _super_1.call(this) || this;
                    _this._ngModelWarningConfig = _ngModelWarningConfig;
                    _this._added = false;
                    /**
                     * @deprecated as of v6
                     */
                    _this.update = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * \@description
                     * Instance property used to track whether an ngModel warning has been sent out for this
                     * particular FormControlName instance. Used to support warning config of "always".
                     *
                     * \@internal
                     */
                    _this._ngModelWarningSent = false;
                    _this._parent = parent;
                    _this._rawValidators = validators || [];
                    _this._rawAsyncValidators = asyncValidators || [];
                    _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
                    return _this;
                }
                Object.defineProperty(FormControlName.prototype, "isDisabled", {
                    /**
                     * \@description
                     * Triggers a warning that this input should not be used with reactive forms.
                     * @param {?} isDisabled
                     * @return {?}
                     */
                    set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                FormControlName.prototype.ngOnChanges = function (changes) {
                    if (!this._added)
                        this._setUpControl();
                    if (isPropertyUpdated(changes, this.viewModel)) {
                        _ngModelWarning('formControlName', FormControlName, this, this._ngModelWarningConfig);
                        this.viewModel = this.model;
                        this.formDirective.updateModel(this, this.model);
                    }
                };
                /**
                 * \@description
                 * Lifecycle method called before the directive's instance is destroyed. For internal use only.
                 * @return {?}
                 */
                FormControlName.prototype.ngOnDestroy = function () {
                    if (this.formDirective) {
                        this.formDirective.removeControl(this);
                    }
                };
                /**
                 * \@description
                 * Sets the new value for the view model and emits an `ngModelChange` event.
                 *
                 * @param {?} newValue The new value for the view model.
                 * @return {?}
                 */
                FormControlName.prototype.viewToModelUpdate = function (newValue) {
                    this.viewModel = newValue;
                    this.update.emit(newValue);
                };
                Object.defineProperty(FormControlName.prototype, "path", {
                    /**
                     * \@description
                     * Returns an array that represents the path from the top-level form to this control.
                     * Each index is the string name of the control on that level.
                     * @return {?}
                     */
                    get: function () { return controlPath(this.name, ( /** @type {?} */(this._parent))); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormControlName.prototype, "formDirective", {
                    /**
                     * \@description
                     * The top-level directive for this group if present, otherwise null.
                     * @return {?}
                     */
                    get: function () { return this._parent ? this._parent.formDirective : null; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormControlName.prototype, "validator", {
                    /**
                     * \@description
                     * Synchronous validator function composed of all the synchronous validators
                     * registered with this directive.
                     * @return {?}
                     */
                    get: function () { return composeValidators(this._rawValidators); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(FormControlName.prototype, "asyncValidator", {
                    /**
                     * \@description
                     * Async validator function composed of all the async validators registered with this
                     * directive.
                     * @return {?}
                     */
                    get: function () {
                        return ( /** @type {?} */(composeAsyncValidators(this._rawAsyncValidators)));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @return {?}
                 */
                FormControlName.prototype._checkParentType = function () {
                    if (!(this._parent instanceof FormGroupName) &&
                        this._parent instanceof AbstractFormGroupDirective) {
                        ReactiveErrors.ngModelGroupException();
                    }
                    else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
                        !(this._parent instanceof FormArrayName)) {
                        ReactiveErrors.controlParentException();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                FormControlName.prototype._setUpControl = function () {
                    this._checkParentType();
                    (( /** @type {?} */(this))).control = this.formDirective.addControl(this);
                    if (this.control.disabled && ( /** @type {?} */(this.valueAccessor)).setDisabledState) {
                        ( /** @type {?} */(( /** @type {?} */(this.valueAccessor)).setDisabledState))(true);
                    }
                    this._added = true;
                };
                return FormControlName;
            }(NgControl));
            /**
             * \@description
             * Static property used to track whether any ngModel warnings have been sent across
             * all instances of FormControlName. Used to support warning config of "once".
             *
             * \@internal
             */
            FormControlName._ngModelWarningSentOnce = false;
            FormControlName.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] }
            ];
            /** @nocollapse */
            FormControlName.ctorParameters = function () { return [
                { type: ControlContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_ASYNC_VALIDATORS,] }] },
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_VALUE_ACCESSOR,] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [NG_MODEL_WITH_FORM_CONTROL_WARNING,] }] }
            ]; };
            FormControlName.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['formControlName',] }],
                isDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['disabled',] }],
                model: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['ngModel',] }],
                update: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"], args: ['ngModelChange',] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             * An interface implemented by classes that perform synchronous validation.
             *
             * \@usageNotes
             *
             * ### Provide a custom validator
             *
             * The following example implements the `Validator` interface to create a
             * validator directive with a custom error key.
             *
             * ```typescript
             * \@Directive({
             *   selector: '[customValidator]',
             *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
             * })
             * class CustomValidatorDirective implements Validator {
             *   validate(control: AbstractControl): ValidationErrors|null {
             *     return {'custom': true};
             *   }
             * }
             * ```
             *
             * \@publicApi
             * @record
             */
            function Validator() { }
            if (false) { }
            /**
             * \@description
             * An interface implemented by classes that perform asynchronous validation.
             *
             * \@usageNotes
             *
             * ### Provide a custom async validator directive
             *
             * The following example implements the `AsyncValidator` interface to create an
             * async validator directive with a custom error key.
             *
             * ```typescript
             * import { of as observableOf } from 'rxjs';
             *
             * \@Directive({
             *   selector: '[customAsyncValidator]',
             *   providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: CustomAsyncValidatorDirective, multi:
             * true}]
             * })
             * class CustomAsyncValidatorDirective implements AsyncValidator {
             *   validate(control: AbstractControl): Observable<ValidationErrors|null> {
             *     return observableOf({'custom': true});
             *   }
             * }
             * ```
             *
             * \@publicApi
             * @record
             */
            function AsyncValidator() { }
            if (false) { }
            /**
             * \@description
             * Provider which adds `RequiredValidator` to the `NG_VALIDATORS` multi-provider list.
             * @type {?}
             */
            var REQUIRED_VALIDATOR = {
                provide: NG_VALIDATORS,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return RequiredValidator; })),
                multi: true
            };
            /**
             * \@description
             * Provider which adds `CheckboxRequiredValidator` to the `NG_VALIDATORS` multi-provider list.
             * @type {?}
             */
            var CHECKBOX_REQUIRED_VALIDATOR = {
                provide: NG_VALIDATORS,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return CheckboxRequiredValidator; })),
                multi: true
            };
            /**
             * \@description
             * A directive that adds the `required` validator to any controls marked with the
             * `required` attribute. The directive is provided with the `NG_VALIDATORS` multi-provider list.
             *
             * @see [Form Validation](guide/form-validation)
             *
             * \@usageNotes
             *
             * ### Adding a required validator using template-driven forms
             *
             * ```
             * <input name="fullName" ngModel required>
             * ```
             *
             * \@ngModule FormsModule
             * \@ngModule ReactiveFormsModule
             * \@publicApi
             */
            var RequiredValidator = /** @class */ (function () {
                function RequiredValidator() {
                }
                Object.defineProperty(RequiredValidator.prototype, "required", {
                    /**
                     * \@description
                     * Tracks changes to the required attribute bound to this directive.
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._required = value != null && value !== false && "" + value !== 'false';
                        if (this._onChange)
                            this._onChange();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Method that validates whether the control is empty.
                 * Returns the validation result if enabled, otherwise null.
                 * @param {?} control
                 * @return {?}
                 */
                RequiredValidator.prototype.validate = function (control) {
                    return this.required ? Validators.required(control) : null;
                };
                /**
                 * \@description
                 * Registers a callback function to call when the validator inputs change.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
                return RequiredValidator;
            }());
            RequiredValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                            providers: [REQUIRED_VALIDATOR],
                            host: { '[attr.required]': 'required ? "" : null' }
                        },] }
            ];
            RequiredValidator.propDecorators = {
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * A Directive that adds the `required` validator to checkbox controls marked with the
             * `required` attribute. The directive is provided with the `NG_VALIDATORS` multi-provider list.
             *
             * @see [Form Validation](guide/form-validation)
             *
             * \@usageNotes
             *
             * ### Adding a required checkbox validator using template-driven forms
             *
             * The following example shows how to add a checkbox required validator to an input attached to an ngModel binding.
             *
             * ```
             * <input type="checkbox" name="active" ngModel required>
             * ```
             *
             * \@publicApi
             * \@ngModule FormsModule
             * \@ngModule ReactiveFormsModule
             */
            var CheckboxRequiredValidator = /** @class */ (function (_super_1) {
                __extends(CheckboxRequiredValidator, _super_1);
                function CheckboxRequiredValidator() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * \@description
                 * Method that validates whether or not the checkbox has been checked.
                 * Returns the validation result if enabled, otherwise null.
                 * @param {?} control
                 * @return {?}
                 */
                CheckboxRequiredValidator.prototype.validate = function (control) {
                    return this.required ? Validators.requiredTrue(control) : null;
                };
                return CheckboxRequiredValidator;
            }(RequiredValidator));
            CheckboxRequiredValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                            providers: [CHECKBOX_REQUIRED_VALIDATOR],
                            host: { '[attr.required]': 'required ? "" : null' }
                        },] }
            ];
            /**
             * \@description
             * Provider which adds `EmailValidator` to the `NG_VALIDATORS` multi-provider list.
             * @type {?}
             */
            var EMAIL_VALIDATOR = {
                provide: NG_VALIDATORS,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return EmailValidator; })),
                multi: true
            };
            /**
             * A directive that adds the `email` validator to controls marked with the
             * `email` attribute. The directive is provided with the `NG_VALIDATORS` multi-provider list.
             *
             * @see [Form Validation](guide/form-validation)
             *
             * \@usageNotes
             *
             * ### Adding an email validator
             *
             * The following example shows how to add an email validator to an input attached to an ngModel binding.
             *
             * ```
             * <input type="email" name="email" ngModel email>
             * <input type="email" name="email" ngModel email="true">
             * <input type="email" name="email" ngModel [email]="true">
             * ```
             *
             * \@publicApi
             * \@ngModule FormsModule
             * \@ngModule ReactiveFormsModule
             */
            var EmailValidator = /** @class */ (function () {
                function EmailValidator() {
                }
                Object.defineProperty(EmailValidator.prototype, "email", {
                    /**
                     * \@description
                     * Tracks changes to the email attribute bound to this directive.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._enabled = value === '' || value === true || value === 'true';
                        if (this._onChange)
                            this._onChange();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@description
                 * Method that validates whether an email address is valid.
                 * Returns the validation result if enabled, otherwise null.
                 * @param {?} control
                 * @return {?}
                 */
                EmailValidator.prototype.validate = function (control) {
                    return this._enabled ? Validators.email(control) : null;
                };
                /**
                 * \@description
                 * Registers a callback function to call when the validator inputs change.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                EmailValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
                return EmailValidator;
            }());
            EmailValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                            providers: [EMAIL_VALIDATOR]
                        },] }
            ];
            EmailValidator.propDecorators = {
                email: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@description
             * A function that receives a control and synchronously returns a map of
             * validation errors if present, otherwise null.
             *
             * \@publicApi
             * @record
             */
            function ValidatorFn() { }
            /**
             * \@description
             * A function that receives a control and returns a Promise or observable
             * that emits validation errors if present, otherwise null.
             *
             * \@publicApi
             * @record
             */
            function AsyncValidatorFn() { }
            /**
             * \@description
             * Provider which adds `MinLengthValidator` to the `NG_VALIDATORS` multi-provider list.
             * @type {?}
             */
            var MIN_LENGTH_VALIDATOR = {
                provide: NG_VALIDATORS,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MinLengthValidator; })),
                multi: true
            };
            /**
             * A directive that adds minimum length validation to controls marked with the
             * `minlength` attribute. The directive is provided with the `NG_VALIDATORS` mult-provider list.
             *
             * @see [Form Validation](guide/form-validation)
             *
             * \@usageNotes
             *
             * ### Adding a minimum length validator
             *
             * The following example shows how to add a minimum length validator to an input attached to an
             * ngModel binding.
             *
             * ```html
             * <input name="firstName" ngModel minlength="4">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var MinLengthValidator = /** @class */ (function () {
                function MinLengthValidator() {
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use
                 * only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                MinLengthValidator.prototype.ngOnChanges = function (changes) {
                    if ('minlength' in changes) {
                        this._createValidator();
                        if (this._onChange)
                            this._onChange();
                    }
                };
                /**
                 * \@description
                 * Method that validates whether the value meets a minimum length
                 * requirement. Returns the validation result if enabled, otherwise null.
                 * @param {?} control
                 * @return {?}
                 */
                MinLengthValidator.prototype.validate = function (control) {
                    return this.minlength == null ? null : this._validator(control);
                };
                /**
                 * \@description
                 * Registers a callback function to call when the validator inputs change.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
                /**
                 * @private
                 * @return {?}
                 */
                MinLengthValidator.prototype._createValidator = function () {
                    this._validator = Validators.minLength(parseInt(this.minlength, 10));
                };
                return MinLengthValidator;
            }());
            MinLengthValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                            providers: [MIN_LENGTH_VALIDATOR],
                            host: { '[attr.minlength]': 'minlength ? minlength : null' }
                        },] }
            ];
            MinLengthValidator.propDecorators = {
                minlength: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@description
             * Provider which adds `MaxLengthValidator` to the `NG_VALIDATORS` multi-provider list.
             * @type {?}
             */
            var MAX_LENGTH_VALIDATOR = {
                provide: NG_VALIDATORS,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MaxLengthValidator; })),
                multi: true
            };
            /**
             * A directive that adds max length validation to controls marked with the
             * `maxlength` attribute. The directive is provided with the `NG_VALIDATORS` multi-provider list.
             *
             * @see [Form Validation](guide/form-validation)
             *
             * \@usageNotes
             *
             * ### Adding a maximum length validator
             *
             * The following example shows how to add a maximum length validator to an input attached to an
             * ngModel binding.
             *
             * ```html
             * <input name="firstName" ngModel maxlength="25">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var MaxLengthValidator = /** @class */ (function () {
                function MaxLengthValidator() {
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use
                 * only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                MaxLengthValidator.prototype.ngOnChanges = function (changes) {
                    if ('maxlength' in changes) {
                        this._createValidator();
                        if (this._onChange)
                            this._onChange();
                    }
                };
                /**
                 * \@description
                 * Method that validates whether the value exceeds
                 * the maximum length requirement.
                 * @param {?} control
                 * @return {?}
                 */
                MaxLengthValidator.prototype.validate = function (control) {
                    return this.maxlength != null ? this._validator(control) : null;
                };
                /**
                 * \@description
                 * Registers a callback function to call when the validator inputs change.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
                /**
                 * @private
                 * @return {?}
                 */
                MaxLengthValidator.prototype._createValidator = function () {
                    this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
                };
                return MaxLengthValidator;
            }());
            MaxLengthValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                            providers: [MAX_LENGTH_VALIDATOR],
                            host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                        },] }
            ];
            MaxLengthValidator.propDecorators = {
                maxlength: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * \@description
             * Provider which adds `PatternValidator` to the `NG_VALIDATORS` multi-provider list.
             * @type {?}
             */
            var PATTERN_VALIDATOR = {
                provide: NG_VALIDATORS,
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return PatternValidator; })),
                multi: true
            };
            /**
             * \@description
             * A directive that adds regex pattern validation to controls marked with the
             * `pattern` attribute. The regex must match the entire control value.
             * The directive is provided with the `NG_VALIDATORS` multi-provider list.
             *
             * @see [Form Validation](guide/form-validation)
             *
             * \@usageNotes
             *
             * ### Adding a pattern validator
             *
             * The following example shows how to add a pattern validator to an input attached to an
             * ngModel binding.
             *
             * ```html
             * <input name="firstName" ngModel pattern="[a-zA-Z ]*">
             * ```
             *
             * \@ngModule ReactiveFormsModule
             * \@ngModule FormsModule
             * \@publicApi
             */
            var PatternValidator = /** @class */ (function () {
                function PatternValidator() {
                }
                /**
                 * \@description
                 * A lifecycle method called when the directive's inputs change. For internal use
                 * only.
                 *
                 * @param {?} changes A object of key/value pairs for the set of changed inputs.
                 * @return {?}
                 */
                PatternValidator.prototype.ngOnChanges = function (changes) {
                    if ('pattern' in changes) {
                        this._createValidator();
                        if (this._onChange)
                            this._onChange();
                    }
                };
                /**
                 * \@description
                 * Method that validates whether the value matches the
                 * the pattern requirement.
                 * @param {?} control
                 * @return {?}
                 */
                PatternValidator.prototype.validate = function (control) { return this._validator(control); };
                /**
                 * \@description
                 * Registers a callback function to call when the validator inputs change.
                 *
                 * @param {?} fn The callback function
                 * @return {?}
                 */
                PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
                /**
                 * @private
                 * @return {?}
                 */
                PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
                return PatternValidator;
            }());
            PatternValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                            providers: [PATTERN_VALIDATOR],
                            host: { '[attr.pattern]': 'pattern ? pattern : null' }
                        },] }
            ];
            PatternValidator.propDecorators = {
                pattern: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var SHARED_FORM_DIRECTIVES = [
                ɵNgNoValidate,
                NgSelectOption,
                ɵNgSelectMultipleOption,
                DefaultValueAccessor,
                NumberValueAccessor,
                RangeValueAccessor,
                CheckboxControlValueAccessor,
                SelectControlValueAccessor,
                SelectMultipleControlValueAccessor,
                RadioControlValueAccessor,
                NgControlStatus,
                NgControlStatusGroup,
                RequiredValidator,
                MinLengthValidator,
                MaxLengthValidator,
                PatternValidator,
                CheckboxRequiredValidator,
                EmailValidator,
            ];
            /** @type {?} */
            var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm, NgFormSelectorWarning];
            /** @type {?} */
            var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
            /**
             * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
             */
            var ɵInternalFormsSharedModule = /** @class */ (function () {
                function ɵInternalFormsSharedModule() {
                }
                return ɵInternalFormsSharedModule;
            }());
            ɵInternalFormsSharedModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: SHARED_FORM_DIRECTIVES,
                            exports: SHARED_FORM_DIRECTIVES,
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} options
             * @return {?}
             */
            function isAbstractControlOptions(options) {
                return (( /** @type {?} */(options))).asyncValidators !== undefined ||
                    (( /** @type {?} */(options))).validators !== undefined ||
                    (( /** @type {?} */(options))).updateOn !== undefined;
            }
            /**
             * \@description
             * Creates an `AbstractControl` from a user-specified configuration.
             *
             * The `FormBuilder` provides syntactic sugar that shortens creating instances of a `FormControl`,
             * `FormGroup`, or `FormArray`. It reduces the amount of boilerplate needed to build complex
             * forms.
             *
             * @see [Reactive Forms Guide](/guide/reactive-forms)
             *
             * \@publicApi
             */
            var FormBuilder = /** @class */ (function () {
                function FormBuilder() {
                }
                /**
                 * \@description
                 * Construct a new `FormGroup` instance.
                 *
                 * @param {?} controlsConfig A collection of child controls. The key for each child is the name
                 * under which it is registered.
                 *
                 * @param {?=} options Configuration options object for the `FormGroup`. The object can
                 * have two shapes:
                 *
                 * 1) `AbstractControlOptions` object (preferred), which consists of:
                 * * `validators`: A synchronous validator function, or an array of validator functions
                 * * `asyncValidators`: A single async validator or array of async validator functions
                 * * `updateOn`: The event upon which the control should be updated (options: 'change' | 'blur' |
                 * submit')
                 *
                 * 2) Legacy configuration object, which consists of:
                 * * `validator`: A synchronous validator function, or an array of validator functions
                 * * `asyncValidator`: A single async validator or array of async validator functions
                 *
                 * @return {?}
                 */
                FormBuilder.prototype.group = function (controlsConfig, options) {
                    if (options === void 0) { options = null; }
                    /** @type {?} */
                    var controls = this._reduceControls(controlsConfig);
                    /** @type {?} */
                    var validators = null;
                    /** @type {?} */
                    var asyncValidators = null;
                    /** @type {?} */
                    var updateOn = undefined;
                    if (options != null) {
                        if (isAbstractControlOptions(options)) {
                            // `options` are `AbstractControlOptions`
                            validators = options.validators != null ? options.validators : null;
                            asyncValidators = options.asyncValidators != null ? options.asyncValidators : null;
                            updateOn = options.updateOn != null ? options.updateOn : undefined;
                        }
                        else {
                            // `options` are legacy form group options
                            validators = options['validator'] != null ? options['validator'] : null;
                            asyncValidators = options['asyncValidator'] != null ? options['asyncValidator'] : null;
                        }
                    }
                    return new FormGroup(controls, { asyncValidators: asyncValidators, updateOn: updateOn, validators: validators });
                };
                /**
                 * \@description
                 * Construct a new `FormControl` with the given state, validators and options.
                 *
                 * \@usageNotes
                 *
                 * ### Initialize a control as disabled
                 *
                 * The following example returns a control with an initial value in a disabled state.
                 *
                 * <code-example path="forms/ts/formBuilder/form_builder_example.ts" region="disabled-control">
                 * </code-example>
                 * @param {?} formState Initializes the control with an initial state value, or
                 * with an object that contains both a value and a disabled status.
                 *
                 * @param {?=} validatorOrOpts A synchronous validator function, or an array of
                 * such functions, or an `AbstractControlOptions` object that contains
                 * validation functions and a validation trigger.
                 *
                 * @param {?=} asyncValidator A single async validator or array of async validator
                 * functions.
                 *
                 * @return {?}
                 */
                FormBuilder.prototype.control = function (formState, validatorOrOpts, asyncValidator) {
                    return new FormControl(formState, validatorOrOpts, asyncValidator);
                };
                /**
                 * Constructs a new `FormArray` from the given array of configurations,
                 * validators and options.
                 *
                 * @param {?} controlsConfig An array of child controls or control configs. Each
                 * child control is given an index when it is registered.
                 *
                 * @param {?=} validatorOrOpts A synchronous validator function, or an array of
                 * such functions, or an `AbstractControlOptions` object that contains
                 * validation functions and a validation trigger.
                 *
                 * @param {?=} asyncValidator A single async validator or array of async validator
                 * functions.
                 * @return {?}
                 */
                FormBuilder.prototype.array = function (controlsConfig, validatorOrOpts, asyncValidator) {
                    var _this = this;
                    /** @type {?} */
                    var controls = controlsConfig.map(( /**
                     * @param {?} c
                     * @return {?}
                     */function (/**
                     * @param {?} c
                     * @return {?}
                     */ c) { return _this._createControl(c); }));
                    return new FormArray(controls, validatorOrOpts, asyncValidator);
                };
                /**
                 * \@internal
                 * @param {?} controlsConfig
                 * @return {?}
                 */
                FormBuilder.prototype._reduceControls = function (controlsConfig) {
                    var _this = this;
                    /** @type {?} */
                    var controls = {};
                    Object.keys(controlsConfig).forEach(( /**
                     * @param {?} controlName
                     * @return {?}
                     */function (/**
                     * @param {?} controlName
                     * @return {?}
                     */ controlName) {
                        controls[controlName] = _this._createControl(controlsConfig[controlName]);
                    }));
                    return controls;
                };
                /**
                 * \@internal
                 * @param {?} controlConfig
                 * @return {?}
                 */
                FormBuilder.prototype._createControl = function (controlConfig) {
                    if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
                        controlConfig instanceof FormArray) {
                        return controlConfig;
                    }
                    else if (Array.isArray(controlConfig)) {
                        /** @type {?} */
                        var value = controlConfig[0];
                        /** @type {?} */
                        var validator = controlConfig.length > 1 ? controlConfig[1] : null;
                        /** @type {?} */
                        var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
                        return this.control(value, validator, asyncValidator);
                    }
                    else {
                        return this.control(controlConfig);
                    }
                };
                return FormBuilder;
            }());
            FormBuilder.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Version"]('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Exports the required providers and directives for template-driven forms,
             * making them available for import by NgModules that import this module.
             *
             * @see [Forms Guide](/guide/forms)
             *
             * \@publicApi
             */
            var FormsModule = /** @class */ (function () {
                function FormsModule() {
                }
                /**
                 * \@description
                 * Provides options for configuring the template-driven forms module.
                 *
                 * @param {?} opts An object of configuration options
                 * * `warnOnDeprecatedNgFormSelector` Configures when to emit a warning when the deprecated
                 * `ngForm` selector is used.
                 * @return {?}
                 */
                FormsModule.withConfig = function (opts) {
                    return {
                        ngModule: FormsModule,
                        providers: [{ provide: NG_FORM_SELECTOR_WARNING, useValue: opts.warnOnDeprecatedNgFormSelector }]
                    };
                };
                return FormsModule;
            }());
            FormsModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                            providers: [RadioControlRegistry],
                            exports: [ɵInternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
                        },] }
            ];
            /**
             * Exports the required infrastructure and directives for reactive forms,
             * making them available for import by NgModules that import this module.
             * @see [Forms](guide/reactive-forms)
             *
             * @see [Reactive Forms Guide](/guide/reactive-forms)
             *
             * \@publicApi
             */
            var ReactiveFormsModule = /** @class */ (function () {
                function ReactiveFormsModule() {
                }
                /**
                 * \@description
                 * Provides options for configuring the reactive forms module.
                 *
                 * @param {?} opts An object of configuration options
                 * * `warnOnNgModelWithFormControl` Configures when to emit a warning when an `ngModel`
                 * binding is used with reactive form directives.
                 * @return {?}
                 */
                ReactiveFormsModule.withConfig = function (opts) {
                    return {
                        ngModule: ReactiveFormsModule,
                        providers: [{
                                provide: NG_MODEL_WITH_FORM_CONTROL_WARNING,
                                useValue: opts.warnOnNgModelWithFormControl
                            }]
                    };
                };
                return ReactiveFormsModule;
            }());
            ReactiveFormsModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                            providers: [FormBuilder, RadioControlRegistry],
                            exports: [ɵInternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=forms.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/autocomplete.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/autocomplete.js ***!
          \****************************************************************/
        /*! exports provided: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY, MatAutocompleteSelectedEvent, MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocomplete, MatAutocompleteModule, MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY, getMatAutocompleteMissingPanelError, AUTOCOMPLETE_OPTION_HEIGHT, AUTOCOMPLETE_PANEL_HEIGHT, MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER, MAT_AUTOCOMPLETE_VALUE_ACCESSOR, MatAutocompleteTrigger, MatAutocompleteOrigin */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY", function () { return MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteSelectedEvent", function () { return MatAutocompleteSelectedEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_DEFAULT_OPTIONS", function () { return MAT_AUTOCOMPLETE_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAutocomplete", function () { return MatAutocomplete; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteModule", function () { return MatAutocompleteModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY", function () { return MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatAutocompleteMissingPanelError", function () { return getMatAutocompleteMissingPanelError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOCOMPLETE_OPTION_HEIGHT", function () { return AUTOCOMPLETE_OPTION_HEIGHT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOCOMPLETE_PANEL_HEIGHT", function () { return AUTOCOMPLETE_PANEL_HEIGHT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_SCROLL_STRATEGY", function () { return MAT_AUTOCOMPLETE_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER", function () { return MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_VALUE_ACCESSOR", function () { return MAT_AUTOCOMPLETE_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteTrigger", function () { return MatAutocompleteTrigger; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteOrigin", function () { return MatAutocompleteOrigin; });
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Autocomplete IDs need to be unique across components, so this counter exists outside of
             * the component definition.
             * @type {?}
             */
            var _uniqueAutocompleteIdCounter = 0;
            /**
             * Event object that is emitted when an autocomplete option is selected.
             */
            var MatAutocompleteSelectedEvent = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} option
                 */
                function MatAutocompleteSelectedEvent(source, option) {
                    this.source = source;
                    this.option = option;
                }
                return MatAutocompleteSelectedEvent;
            }());
            // Boilerplate for applying mixins to MatAutocomplete.
            /**
             * \@docs-private
             */
            var MatAutocompleteBase = /** @class */ (function () {
                function MatAutocompleteBase() {
                }
                return MatAutocompleteBase;
            }());
            /** @type {?} */
            var _MatAutocompleteMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisableRipple"])(MatAutocompleteBase);
            /**
             * Injection token to be used to override the default options for `mat-autocomplete`.
             * @type {?}
             */
            var MAT_AUTOCOMPLETE_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_2__["InjectionToken"]('mat-autocomplete-default-options', {
                providedIn: 'root',
                factory: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY() {
                return { autoActiveFirstOption: false };
            }
            var MatAutocomplete = /** @class */ (function (_super_1) {
                __extends(MatAutocomplete, _super_1);
                /**
                 * @param {?} _changeDetectorRef
                 * @param {?} _elementRef
                 * @param {?} defaults
                 */
                function MatAutocomplete(_changeDetectorRef, _elementRef, defaults) {
                    var _this = _super_1.call(this) || this;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._elementRef = _elementRef;
                    /**
                     * Whether the autocomplete panel should be visible, depending on option length.
                     */
                    _this.showPanel = false;
                    _this._isOpen = false;
                    /**
                     * Function that maps an option's control value to its display value in the trigger.
                     */
                    _this.displayWith = null;
                    /**
                     * Event that is emitted whenever an option from the list is selected.
                     */
                    _this.optionSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_2__["EventEmitter"]();
                    /**
                     * Event that is emitted when the autocomplete panel is opened.
                     */
                    _this.opened = new _angular_core__WEBPACK_IMPORTED_MODULE_2__["EventEmitter"]();
                    /**
                     * Event that is emitted when the autocomplete panel is closed.
                     */
                    _this.closed = new _angular_core__WEBPACK_IMPORTED_MODULE_2__["EventEmitter"]();
                    _this._classList = {};
                    /**
                     * Unique ID to be used by autocomplete trigger's "aria-owns" property.
                     */
                    _this.id = "mat-autocomplete-" + _uniqueAutocompleteIdCounter++;
                    _this._autoActiveFirstOption = !!defaults.autoActiveFirstOption;
                    return _this;
                }
                Object.defineProperty(MatAutocomplete.prototype, "isOpen", {
                    /**
                     * Whether the autocomplete panel is open.
                     * @return {?}
                     */
                    get: function () { return this._isOpen && this.showPanel; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatAutocomplete.prototype, "autoActiveFirstOption", {
                    /**
                     * Whether the first option should be highlighted when the autocomplete panel is opened.
                     * Can be configured globally through the `MAT_AUTOCOMPLETE_DEFAULT_OPTIONS` token.
                     * @return {?}
                     */
                    get: function () { return this._autoActiveFirstOption; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._autoActiveFirstOption = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatAutocomplete.prototype, "classList", {
                    /**
                     * Takes classes set on the host mat-autocomplete element and applies them to the panel
                     * inside the overlay container to allow for easy styling.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value && value.length) {
                            this._classList = value.split(' ').reduce(( /**
                             * @param {?} classList
                             * @param {?} className
                             * @return {?}
                             */function (classList, className) {
                                classList[className.trim()] = true;
                                return classList;
                            }), ( /** @type {?} */({})));
                        }
                        else {
                            this._classList = {};
                        }
                        this._setVisibilityClasses(this._classList);
                        this._elementRef.nativeElement.className = '';
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatAutocomplete.prototype.ngAfterContentInit = function () {
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["ActiveDescendantKeyManager"](this.options).withWrap();
                    // Set the initial visibility state.
                    this._setVisibility();
                };
                /**
                 * Sets the panel scrollTop. This allows us to manually scroll to display options
                 * above or below the fold, as they are not actually being focused when active.
                 * @param {?} scrollTop
                 * @return {?}
                 */
                MatAutocomplete.prototype._setScrollTop = function (scrollTop) {
                    if (this.panel) {
                        this.panel.nativeElement.scrollTop = scrollTop;
                    }
                };
                /**
                 * Returns the panel's scrollTop.
                 * @return {?}
                 */
                MatAutocomplete.prototype._getScrollTop = function () {
                    return this.panel ? this.panel.nativeElement.scrollTop : 0;
                };
                /**
                 * Panel should hide itself when the option list is empty.
                 * @return {?}
                 */
                MatAutocomplete.prototype._setVisibility = function () {
                    this.showPanel = !!this.options.length;
                    this._setVisibilityClasses(this._classList);
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Emits the `select` event.
                 * @param {?} option
                 * @return {?}
                 */
                MatAutocomplete.prototype._emitSelectEvent = function (option) {
                    /** @type {?} */
                    var event = new MatAutocompleteSelectedEvent(this, option);
                    this.optionSelected.emit(event);
                };
                /**
                 * Sets the autocomplete visibility classes on a classlist based on the panel is visible.
                 * @private
                 * @param {?} classList
                 * @return {?}
                 */
                MatAutocomplete.prototype._setVisibilityClasses = function (classList) {
                    classList['mat-autocomplete-visible'] = this.showPanel;
                    classList['mat-autocomplete-hidden'] = !this.showPanel;
                };
                return MatAutocomplete;
            }(_MatAutocompleteMixinBase));
            MatAutocomplete.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"], args: [{ selector: 'mat-autocomplete',
                            template: "<ng-template><div class=\"mat-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_classList\" #panel><ng-content></ng-content></div></ng-template>",
                            styles: [".mat-autocomplete-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;visibility:hidden;max-width:none;max-height:256px;position:relative;width:100%;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden}.mat-autocomplete-panel-above .mat-autocomplete-panel{border-radius:0;border-top-left-radius:4px;border-top-right-radius:4px}.mat-autocomplete-panel .mat-divider-horizontal{margin-top:-1px}@media (-ms-high-contrast:active){.mat-autocomplete-panel{outline:solid 1px}}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectionStrategy"].OnPush,
                            exportAs: 'matAutocomplete',
                            inputs: ['disableRipple'],
                            host: {
                                'class': 'mat-autocomplete'
                            },
                            providers: [
                                { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MAT_OPTION_PARENT_COMPONENT"], useExisting: MatAutocomplete }
                            ]
                        },] },
            ];
            /** @nocollapse */
            MatAutocomplete.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] }] }
            ]; };
            MatAutocomplete.propDecorators = {
                template: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewChild"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_2__["TemplateRef"], { static: true },] }],
                panel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewChild"], args: ['panel', { static: false },] }],
                options: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatOption"], { descendants: true },] }],
                optionGroups: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatOptgroup"],] }],
                displayWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }],
                autoActiveFirstOption: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }],
                panelWidth: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }],
                optionSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Output"] }],
                opened: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Output"] }],
                closed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Output"] }],
                classList: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['class',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Directive applied to an element to make it usable
             * as a connection point for an autocomplete panel.
             */
            var MatAutocompleteOrigin = /** @class */ (function () {
                /**
                 * @param {?} elementRef
                 */
                function MatAutocompleteOrigin(elementRef) {
                    this.elementRef = elementRef;
                }
                return MatAutocompleteOrigin;
            }());
            MatAutocompleteOrigin.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Directive"], args: [{
                            selector: '[matAutocompleteOrigin]',
                            exportAs: 'matAutocompleteOrigin',
                        },] },
            ];
            /** @nocollapse */
            MatAutocompleteOrigin.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The height of each autocomplete option.
             * @type {?}
             */
            var AUTOCOMPLETE_OPTION_HEIGHT = 48;
            /**
             * The total height of the autocomplete panel.
             * @type {?}
             */
            var AUTOCOMPLETE_PANEL_HEIGHT = 256;
            /**
             * Injection token that determines the scroll handling while the autocomplete panel is open.
             * @type {?}
             */
            var MAT_AUTOCOMPLETE_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_2__["InjectionToken"]('mat-autocomplete-scroll-strategy');
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.reposition(); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER = {
                provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
                deps: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["Overlay"]],
                useFactory: MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY,
            };
            /**
             * Provider that allows the autocomplete to register as a ControlValueAccessor.
             * \@docs-private
             * @type {?}
             */
            var MAT_AUTOCOMPLETE_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_11__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatAutocompleteTrigger; })),
                multi: true
            };
            /**
             * Creates an error to be thrown when attempting to use an autocomplete trigger without a panel.
             * \@docs-private
             * @return {?}
             */
            function getMatAutocompleteMissingPanelError() {
                return Error('Attempting to open an undefined instance of `mat-autocomplete`. ' +
                    'Make sure that the id passed to the `matAutocomplete` is correct and that ' +
                    'you\'re attempting to open it after the ngAfterContentInit hook.');
            }
            var MatAutocompleteTrigger = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _overlay
                 * @param {?} _viewContainerRef
                 * @param {?} _zone
                 * @param {?} _changeDetectorRef
                 * @param {?} scrollStrategy
                 * @param {?} _dir
                 * @param {?} _formField
                 * @param {?} _document
                 * @param {?=} _viewportRuler
                 */
                function MatAutocompleteTrigger(_element, _overlay, _viewContainerRef, _zone, _changeDetectorRef, scrollStrategy, _dir, _formField, _document, _viewportRuler) {
                    var _this = this;
                    this._element = _element;
                    this._overlay = _overlay;
                    this._viewContainerRef = _viewContainerRef;
                    this._zone = _zone;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._dir = _dir;
                    this._formField = _formField;
                    this._document = _document;
                    this._viewportRuler = _viewportRuler;
                    this._componentDestroyed = false;
                    this._autocompleteDisabled = false;
                    /**
                     * Whether or not the label state is being overridden.
                     */
                    this._manuallyFloatingLabel = false;
                    /**
                     * Subscription to viewport size changes.
                     */
                    this._viewportSubscription = rxjs__WEBPACK_IMPORTED_MODULE_13__["Subscription"].EMPTY;
                    /**
                     * Whether the autocomplete can open the next time it is focused. Used to prevent a focused,
                     * closed autocomplete from being reopened if the user switches to another browser tab and then
                     * comes back.
                     */
                    this._canOpenOnNextFocus = true;
                    /**
                     * Stream of keyboard events that can close the panel.
                     */
                    this._closeKeyEventStream = new rxjs__WEBPACK_IMPORTED_MODULE_13__["Subject"]();
                    /**
                     * Event handler for when the window is blurred. Needs to be an
                     * arrow function in order to preserve the context.
                     */
                    this._windowBlurHandler = ( /**
                     * @return {?}
                     */function () {
                        // If the user blurred the window while the autocomplete is focused, it means that it'll be
                        // refocused when they come back. In this case we want to skip the first focus event, if the
                        // pane was closed, in order to avoid reopening it unintentionally.
                        _this._canOpenOnNextFocus =
                            _this._document.activeElement !== _this._element.nativeElement || _this.panelOpen;
                    });
                    /**
                     * `View -> model callback called when value changes`
                     */
                    this._onChange = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * `View -> model callback called when autocomplete has been touched`
                     */
                    this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * Position of the autocomplete panel relative to the trigger element. A position of `auto`
                     * will render the panel underneath the trigger if there is enough space for it to fit in
                     * the viewport, otherwise the panel will be shown above it. If the position is set to
                     * `above` or `below`, the panel will always be shown above or below the trigger. no matter
                     * whether it fits completely in the viewport.
                     */
                    this.position = 'auto';
                    /**
                     * `autocomplete` attribute to be set on the input element.
                     * \@docs-private
                     */
                    this.autocompleteAttribute = 'off';
                    this._overlayAttached = false;
                    /**
                     * Stream of autocomplete option selections.
                     */
                    this.optionSelections = ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["defer"])(( /**
                     * @return {?}
                     */function () {
                        if (_this.autocomplete && _this.autocomplete.options) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["merge"]).apply(void 0, _this.autocomplete.options.map(( /**
                             * @param {?} option
                             * @return {?}
                             */function (/**
                             * @param {?} option
                             * @return {?}
                             */ option) { return option.onSelectionChange; })));
                        }
                        // If there are any subscribers before `ngAfterViewInit`, the `autocomplete` will be undefined.
                        // Return a stream that we'll replace with the real one once everything is in place.
                        return _this._zone.onStable
                            .asObservable()
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["switchMap"])(( /**
                     * @return {?}
                     */function () { return _this.optionSelections; })));
                    }))));
                    this._scrollStrategy = scrollStrategy;
                }
                Object.defineProperty(MatAutocompleteTrigger.prototype, "autocompleteDisabled", {
                    /**
                     * Whether the autocomplete is disabled. When disabled, the element will
                     * act as a regular input and the user won't be able to open the panel.
                     * @return {?}
                     */
                    get: function () { return this._autocompleteDisabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._autocompleteDisabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    if (typeof window !== 'undefined') {
                        this._zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            window.addEventListener('blur', _this._windowBlurHandler);
                        }));
                        if (Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_7__["_supportsShadowDom"])()) {
                            /** @type {?} */
                            var element = this._element.nativeElement;
                            /** @type {?} */
                            var rootNode = element.getRootNode ? element.getRootNode() : null;
                            // We need to take the `ShadowRoot` off of `window`, because the built-in types are
                            // incorrect. See https://github.com/Microsoft/TypeScript/issues/27929.
                            this._isInsideShadowRoot = rootNode instanceof (( /** @type {?} */(window))).ShadowRoot;
                        }
                    }
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.ngOnChanges = function (changes) {
                    if (changes['position'] && this._positionStrategy) {
                        this._setStrategyPositions(this._positionStrategy);
                        if (this.panelOpen) {
                            ( /** @type {?} */(this._overlayRef)).updatePosition();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.ngOnDestroy = function () {
                    if (typeof window !== 'undefined') {
                        window.removeEventListener('blur', this._windowBlurHandler);
                    }
                    this._viewportSubscription.unsubscribe();
                    this._componentDestroyed = true;
                    this._destroyPanel();
                    this._closeKeyEventStream.complete();
                };
                Object.defineProperty(MatAutocompleteTrigger.prototype, "panelOpen", {
                    /**
                     * Whether or not the autocomplete panel is open.
                     * @return {?}
                     */
                    get: function () {
                        return this._overlayAttached && this.autocomplete.showPanel;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Opens the autocomplete suggestion panel.
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.openPanel = function () {
                    this._attachOverlay();
                    this._floatLabel();
                };
                /**
                 * Closes the autocomplete suggestion panel.
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.closePanel = function () {
                    this._resetLabel();
                    if (!this._overlayAttached) {
                        return;
                    }
                    if (this.panelOpen) {
                        // Only emit if the panel was visible.
                        this.autocomplete.closed.emit();
                    }
                    this.autocomplete._isOpen = this._overlayAttached = false;
                    if (this._overlayRef && this._overlayRef.hasAttached()) {
                        this._overlayRef.detach();
                        this._closingActionsSubscription.unsubscribe();
                    }
                    // Note that in some cases this can end up being called after the component is destroyed.
                    // Add a check to ensure that we don't try to run change detection on a destroyed view.
                    if (!this._componentDestroyed) {
                        // We need to trigger change detection manually, because
                        // `fromEvent` doesn't seem to do it at the proper time.
                        // This ensures that the label is reset when the
                        // user clicks outside.
                        this._changeDetectorRef.detectChanges();
                    }
                };
                /**
                 * Updates the position of the autocomplete suggestion panel to ensure that it fits all options
                 * within the viewport.
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.updatePosition = function () {
                    if (this._overlayAttached) {
                        ( /** @type {?} */(this._overlayRef)).updatePosition();
                    }
                };
                Object.defineProperty(MatAutocompleteTrigger.prototype, "panelClosingActions", {
                    /**
                     * A stream of actions that should close the autocomplete panel, including
                     * when an option is selected, on blur, and when TAB is pressed.
                     * @return {?}
                     */
                    get: function () {
                        var _this = this;
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["merge"])(this.optionSelections, this.autocomplete._keyManager.tabOut.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["filter"])(( /**
                         * @return {?}
                         */function () { return _this._overlayAttached; }))), this._closeKeyEventStream, this._getOutsideClickStream(), this._overlayRef ?
                            this._overlayRef.detachments().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["filter"])(( /**
                             * @return {?}
                             */function () { return _this._overlayAttached; }))) :
                            Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["of"])()).pipe(
                        // Normalize the output so we return a consistent type.
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["map"])(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) { return event instanceof _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatOptionSelectionChange"] ? event : null; })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatAutocompleteTrigger.prototype, "activeOption", {
                    /**
                     * The currently active option, coerced to MatOption type.
                     * @return {?}
                     */
                    get: function () {
                        if (this.autocomplete && this.autocomplete._keyManager) {
                            return this.autocomplete._keyManager.activeItem;
                        }
                        return null;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Stream of clicks outside of the autocomplete panel.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._getOutsideClickStream = function () {
                    var _this = this;
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["merge"])(( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["fromEvent"])(this._document, 'click'))), ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["fromEvent"])(this._document, 'touchend'))))
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["filter"])(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) {
                        // If we're in the Shadow DOM, the event target will be the shadow root, so we have to
                        // fall back to check the first element in the path of the click event.
                        /** @type {?} */
                        var clickTarget = ( /** @type {?} */((_this._isInsideShadowRoot && event.composedPath ? event.composedPath()[0] :
                            event.target)));
                        /** @type {?} */
                        var formField = _this._formField ? _this._formField._elementRef.nativeElement : null;
                        return _this._overlayAttached && clickTarget !== _this._element.nativeElement &&
                            (!formField || !formField.contains(clickTarget)) &&
                            (!!_this._overlayRef && !_this._overlayRef.overlayElement.contains(clickTarget));
                    })));
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} value
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.writeValue = function (value) {
                    var _this = this;
                    Promise.resolve(null).then(( /**
                     * @return {?}
                     */function () { return _this._setTriggerValue(value); }));
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.registerOnChange = function (fn) {
                    this._onChange = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype.setDisabledState = function (isDisabled) {
                    this._element.nativeElement.disabled = isDisabled;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._handleKeydown = function (event) {
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    // Prevent the default action on all escape key presses. This is here primarily to bring IE
                    // in line with other browsers. By default, pressing escape on IE will cause it to revert
                    // the input value to the one that it had on focus, however it won't dispatch any events
                    // which means that the model value will be out of sync with the view.
                    if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["ESCAPE"]) {
                        event.preventDefault();
                    }
                    if (this.activeOption && keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["ENTER"] && this.panelOpen) {
                        this.activeOption._selectViaInteraction();
                        this._resetActiveItem();
                        event.preventDefault();
                    }
                    else if (this.autocomplete) {
                        /** @type {?} */
                        var prevActiveItem = this.autocomplete._keyManager.activeItem;
                        /** @type {?} */
                        var isArrowKey = keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["UP_ARROW"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["DOWN_ARROW"];
                        if (this.panelOpen || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["TAB"]) {
                            this.autocomplete._keyManager.onKeydown(event);
                        }
                        else if (isArrowKey && this._canOpen()) {
                            this.openPanel();
                        }
                        if (isArrowKey || this.autocomplete._keyManager.activeItem !== prevActiveItem) {
                            this._scrollToOption();
                        }
                    }
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._handleInput = function (event) {
                    /** @type {?} */
                    var target = ( /** @type {?} */(event.target));
                    /** @type {?} */
                    var value = target.value;
                    // Based on `NumberValueAccessor` from forms.
                    if (target.type === 'number') {
                        value = value == '' ? null : parseFloat(value);
                    }
                    // If the input has a placeholder, IE will fire the `input` event on page load,
                    // focus and blur, in addition to when the user actually changed the value. To
                    // filter out all of the extra events, we save the value on focus and between
                    // `input` events, and we check whether it changed.
                    // See: https://connect.microsoft.com/IE/feedback/details/885747/
                    if (this._previousValue !== value) {
                        this._previousValue = value;
                        this._onChange(value);
                        if (this._canOpen() && this._document.activeElement === event.target) {
                            this.openPanel();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._handleFocus = function () {
                    if (!this._canOpenOnNextFocus) {
                        this._canOpenOnNextFocus = true;
                    }
                    else if (this._canOpen()) {
                        this._previousValue = this._element.nativeElement.value;
                        this._attachOverlay();
                        this._floatLabel(true);
                    }
                };
                /**
                 * In "auto" mode, the label will animate down as soon as focus is lost.
                 * This causes the value to jump when selecting an option with the mouse.
                 * This method manually floats the label until the panel can be closed.
                 * @private
                 * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._floatLabel = function (shouldAnimate) {
                    if (shouldAnimate === void 0) { shouldAnimate = false; }
                    if (this._formField && this._formField.floatLabel === 'auto') {
                        if (shouldAnimate) {
                            this._formField._animateAndLockLabel();
                        }
                        else {
                            this._formField.floatLabel = 'always';
                        }
                        this._manuallyFloatingLabel = true;
                    }
                };
                /**
                 * If the label has been manually elevated, return it to its normal state.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._resetLabel = function () {
                    if (this._manuallyFloatingLabel) {
                        this._formField.floatLabel = 'auto';
                        this._manuallyFloatingLabel = false;
                    }
                };
                /**
                 * Given that we are not actually focusing active options, we must manually adjust scroll
                 * to reveal options below the fold. First, we find the offset of the option from the top
                 * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
                 * the panel height + the option height, so the active option will be just visible at the
                 * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
                 * will become the offset. If that offset is visible within the panel already, the scrollTop is
                 * not adjusted.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._scrollToOption = function () {
                    /** @type {?} */
                    var index = this.autocomplete._keyManager.activeItemIndex || 0;
                    /** @type {?} */
                    var labelCount = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["_countGroupLabelsBeforeOption"])(index, this.autocomplete.options, this.autocomplete.optionGroups);
                    if (index === 0 && labelCount === 1) {
                        // If we've got one group label before the option and we're at the top option,
                        // scroll the list to the top. This is better UX than scrolling the list to the
                        // top of the option, because it allows the user to read the top group's label.
                        this.autocomplete._setScrollTop(0);
                    }
                    else {
                        /** @type {?} */
                        var newScrollPosition = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["_getOptionScrollPosition"])(index + labelCount, AUTOCOMPLETE_OPTION_HEIGHT, this.autocomplete._getScrollTop(), AUTOCOMPLETE_PANEL_HEIGHT);
                        this.autocomplete._setScrollTop(newScrollPosition);
                    }
                };
                /**
                 * This method listens to a stream of panel closing actions and resets the
                 * stream every time the option list changes.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._subscribeToClosingActions = function () {
                    var _this = this;
                    /** @type {?} */
                    var firstStable = this._zone.onStable.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["take"])(1));
                    /** @type {?} */
                    var optionChanges = this.autocomplete.options.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["tap"])(( /**
                     * @return {?}
                     */function () { return _this._positionStrategy.reapplyLastPosition(); })), 
                    // Defer emitting to the stream until the next tick, because changing
                    // bindings in here will cause "changed after checked" errors.
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["delay"])(0));
                    // When the zone is stable initially, and when the option list changes...
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_13__["merge"])(firstStable, optionChanges)
                        .pipe(
                    // create a new stream of panelClosingActions, replacing any previous streams
                    // that were created, and flatten it so our stream only emits closing events...
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["switchMap"])(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var wasOpen = _this.panelOpen;
                        _this._resetActiveItem();
                        _this.autocomplete._setVisibility();
                        if (_this.panelOpen) {
                            ( /** @type {?} */(_this._overlayRef)).updatePosition();
                            // If the `panelOpen` state changed, we need to make sure to emit the `opened`
                            // event, because we may not have emitted it when the panel was attached. This
                            // can happen if the users opens the panel and there are no options, but the
                            // options come in slightly later or as a result of the value changing.
                            if (wasOpen !== _this.panelOpen) {
                                _this.autocomplete.opened.emit();
                            }
                        }
                        return _this.panelClosingActions;
                    })), 
                    // when the first closing event occurs...
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_14__["take"])(1))
                        // set the value, close the panel, and complete.
                        .subscribe(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) { return _this._setValueAndClose(event); }));
                };
                /**
                 * Destroys the autocomplete suggestion panel.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._destroyPanel = function () {
                    if (this._overlayRef) {
                        this.closePanel();
                        this._overlayRef.dispose();
                        this._overlayRef = null;
                    }
                };
                /**
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._setTriggerValue = function (value) {
                    /** @type {?} */
                    var toDisplay = this.autocomplete && this.autocomplete.displayWith ?
                        this.autocomplete.displayWith(value) :
                        value;
                    // Simply falling back to an empty string if the display value is falsy does not work properly.
                    // The display value can also be the number zero and shouldn't fall back to an empty string.
                    /** @type {?} */
                    var inputValue = toDisplay != null ? toDisplay : '';
                    // If it's used within a `MatFormField`, we should set it through the property so it can go
                    // through change detection.
                    if (this._formField) {
                        this._formField._control.value = inputValue;
                    }
                    else {
                        this._element.nativeElement.value = inputValue;
                    }
                    this._previousValue = inputValue;
                };
                /**
                 * This method closes the panel, and if a value is specified, also sets the associated
                 * control to that value. It will also mark the control as dirty if this interaction
                 * stemmed from the user.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._setValueAndClose = function (event) {
                    if (event && event.source) {
                        this._clearPreviousSelectedOption(event.source);
                        this._setTriggerValue(event.source.value);
                        this._onChange(event.source.value);
                        this._element.nativeElement.focus();
                        this.autocomplete._emitSelectEvent(event.source);
                    }
                    this.closePanel();
                };
                /**
                 * Clear any previous selected option and emit a selection change event for this option
                 * @private
                 * @param {?} skip
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._clearPreviousSelectedOption = function (skip) {
                    this.autocomplete.options.forEach(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) {
                        if (option != skip && option.selected) {
                            option.deselect();
                        }
                    }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._attachOverlay = function () {
                    var _this = this;
                    if (!this.autocomplete) {
                        throw getMatAutocompleteMissingPanelError();
                    }
                    /** @type {?} */
                    var overlayRef = this._overlayRef;
                    if (!overlayRef) {
                        this._portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__["TemplatePortal"](this.autocomplete.template, this._viewContainerRef);
                        overlayRef = this._overlay.create(this._getOverlayConfig());
                        this._overlayRef = overlayRef;
                        // Use the `keydownEvents` in order to take advantage of
                        // the overlay event targeting provided by the CDK overlay.
                        overlayRef.keydownEvents().subscribe(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) {
                            // Close when pressing ESCAPE or ALT + UP_ARROW, based on the a11y guidelines.
                            // See: https://www.w3.org/TR/wai-aria-practices-1.1/#textbox-keyboard-interaction
                            if (event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["ESCAPE"] || (event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["UP_ARROW"] && event.altKey)) {
                                _this._resetActiveItem();
                                _this._closeKeyEventStream.next();
                                // We need to stop propagation, otherwise the event will eventually
                                // reach the input itself and cause the overlay to be reopened.
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        }));
                        if (this._viewportRuler) {
                            this._viewportSubscription = this._viewportRuler.change().subscribe(( /**
                             * @return {?}
                             */function () {
                                if (_this.panelOpen && overlayRef) {
                                    overlayRef.updateSize({ width: _this._getPanelWidth() });
                                }
                            }));
                        }
                    }
                    else {
                        // Update the trigger, panel width and direction, in case anything has changed.
                        this._positionStrategy.setOrigin(this._getConnectedElement());
                        overlayRef.updateSize({ width: this._getPanelWidth() });
                    }
                    if (overlayRef && !overlayRef.hasAttached()) {
                        overlayRef.attach(this._portal);
                        this._closingActionsSubscription = this._subscribeToClosingActions();
                    }
                    /** @type {?} */
                    var wasOpen = this.panelOpen;
                    this.autocomplete._setVisibility();
                    this.autocomplete._isOpen = this._overlayAttached = true;
                    // We need to do an extra `panelOpen` check in here, because the
                    // autocomplete won't be shown if there are no options.
                    if (this.panelOpen && wasOpen !== this.panelOpen) {
                        this.autocomplete.opened.emit();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._getOverlayConfig = function () {
                    return new _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["OverlayConfig"]({
                        positionStrategy: this._getOverlayPosition(),
                        scrollStrategy: this._scrollStrategy(),
                        width: this._getPanelWidth(),
                        direction: this._dir
                    });
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._getOverlayPosition = function () {
                    /** @type {?} */
                    var strategy = this._overlay.position()
                        .flexibleConnectedTo(this._getConnectedElement())
                        .withFlexibleDimensions(false)
                        .withPush(false);
                    this._setStrategyPositions(strategy);
                    this._positionStrategy = strategy;
                    return strategy;
                };
                /**
                 * Sets the positions on a position strategy based on the directive's input state.
                 * @private
                 * @param {?} positionStrategy
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._setStrategyPositions = function (positionStrategy) {
                    /** @type {?} */
                    var belowPosition = {
                        originX: 'start',
                        originY: 'bottom',
                        overlayX: 'start',
                        overlayY: 'top'
                    };
                    /** @type {?} */
                    var abovePosition = {
                        originX: 'start',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'bottom',
                        // The overlay edge connected to the trigger should have squared corners, while
                        // the opposite end has rounded corners. We apply a CSS class to swap the
                        // border-radius based on the overlay position.
                        panelClass: 'mat-autocomplete-panel-above'
                    };
                    /** @type {?} */
                    var positions;
                    if (this.position === 'above') {
                        positions = [abovePosition];
                    }
                    else if (this.position === 'below') {
                        positions = [belowPosition];
                    }
                    else {
                        positions = [belowPosition, abovePosition];
                    }
                    positionStrategy.withPositions(positions);
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._getConnectedElement = function () {
                    if (this.connectedTo) {
                        return this.connectedTo.elementRef;
                    }
                    return this._formField ? this._formField.getConnectedOverlayOrigin() : this._element;
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._getPanelWidth = function () {
                    return this.autocomplete.panelWidth || this._getHostWidth();
                };
                /**
                 * Returns the width of the input element, so the panel width can match it.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._getHostWidth = function () {
                    return this._getConnectedElement().nativeElement.getBoundingClientRect().width;
                };
                /**
                 * Resets the active item to -1 so arrow events will activate the
                 * correct options, or to 0 if the consumer opted into it.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._resetActiveItem = function () {
                    this.autocomplete._keyManager.setActiveItem(this.autocomplete.autoActiveFirstOption ? 0 : -1);
                };
                /**
                 * Determines whether the panel can be opened.
                 * @private
                 * @return {?}
                 */
                MatAutocompleteTrigger.prototype._canOpen = function () {
                    /** @type {?} */
                    var element = this._element.nativeElement;
                    return !element.readOnly && !element.disabled && !this._autocompleteDisabled;
                };
                return MatAutocompleteTrigger;
            }());
            MatAutocompleteTrigger.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Directive"], args: [{
                            selector: "input[matAutocomplete], textarea[matAutocomplete]",
                            host: {
                                'class': 'mat-autocomplete-trigger',
                                '[attr.autocomplete]': 'autocompleteAttribute',
                                '[attr.role]': 'autocompleteDisabled ? null : "combobox"',
                                '[attr.aria-autocomplete]': 'autocompleteDisabled ? null : "list"',
                                '[attr.aria-activedescendant]': '(panelOpen && activeOption) ? activeOption.id : null',
                                '[attr.aria-expanded]': 'autocompleteDisabled ? null : panelOpen.toString()',
                                '[attr.aria-owns]': '(autocompleteDisabled || !panelOpen) ? null : autocomplete?.id',
                                '[attr.aria-haspopup]': '!autocompleteDisabled',
                                // Note: we use `focusin`, as opposed to `focus`, in order to open the panel
                                // a little earlier. This avoids issues where IE delays the focusing of the input.
                                '(focusin)': '_handleFocus()',
                                '(blur)': '_onTouched()',
                                '(input)': '_handleInput($event)',
                                '(keydown)': '_handleKeydown($event)',
                            },
                            exportAs: 'matAutocompleteTrigger',
                            providers: [MAT_AUTOCOMPLETE_VALUE_ACCESSOR]
                        },] },
            ];
            /** @nocollapse */
            MatAutocompleteTrigger.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"] },
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY,] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_4__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }] },
                { type: _angular_material_form_field__WEBPACK_IMPORTED_MODULE_12__["MatFormField"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Host"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_10__["DOCUMENT"],] }] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ViewportRuler"] }
            ]; };
            MatAutocompleteTrigger.propDecorators = {
                autocomplete: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matAutocomplete',] }],
                position: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matAutocompletePosition',] }],
                connectedTo: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matAutocompleteConnectedTo',] }],
                autocompleteAttribute: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['autocomplete',] }],
                autocompleteDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matAutocompleteDisabled',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatAutocompleteModule = /** @class */ (function () {
                function MatAutocompleteModule() {
                }
                return MatAutocompleteModule;
            }());
            MatAutocompleteModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatOptionModule"], _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["OverlayModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"], _angular_common__WEBPACK_IMPORTED_MODULE_10__["CommonModule"]],
                            exports: [
                                MatAutocomplete,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatOptionModule"],
                                MatAutocompleteTrigger,
                                MatAutocompleteOrigin,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"]
                            ],
                            declarations: [MatAutocomplete, MatAutocompleteTrigger, MatAutocompleteOrigin],
                            providers: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=autocomplete.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/badge.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/badge.js ***!
          \*********************************************************/
        /*! exports provided: MatBadgeModule, MatBadge */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBadgeModule", function () { return MatBadgeModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBadge", function () { return MatBadge; });
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var nextId = 0;
            // Boilerplate for applying mixins to MatBadge.
            /**
             * \@docs-private
             */
            var MatBadgeBase = /** @class */ (function () {
                function MatBadgeBase() {
                }
                return MatBadgeBase;
            }());
            /** @type {?} */
            var _MatBadgeMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisabled"])(MatBadgeBase);
            /**
             * Directive to display a text badge.
             */
            var MatBadge = /** @class */ (function (_super_1) {
                __extends(MatBadge, _super_1);
                /**
                 * @param {?} _ngZone
                 * @param {?} _elementRef
                 * @param {?} _ariaDescriber
                 * @param {?} _renderer
                 * @param {?=} _animationMode
                 */
                function MatBadge(_ngZone, _elementRef, _ariaDescriber, _renderer, _animationMode) {
                    var _this = _super_1.call(this) || this;
                    _this._ngZone = _ngZone;
                    _this._elementRef = _elementRef;
                    _this._ariaDescriber = _ariaDescriber;
                    _this._renderer = _renderer;
                    _this._animationMode = _animationMode;
                    /**
                     * Whether the badge has any content.
                     */
                    _this._hasContent = false;
                    _this._color = 'primary';
                    _this._overlap = true;
                    /**
                     * Position the badge should reside.
                     * Accepts any combination of 'above'|'below' and 'before'|'after'
                     */
                    _this.position = 'above after';
                    /**
                     * Size of the badge. Can be 'small', 'medium', or 'large'.
                     */
                    _this.size = 'medium';
                    /**
                     * Unique id for the badge
                     */
                    _this._id = nextId++;
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["isDevMode"])()) {
                        /** @type {?} */
                        var nativeElement = _elementRef.nativeElement;
                        if (nativeElement.nodeType !== nativeElement.ELEMENT_NODE) {
                            throw Error('matBadge must be attached to an element node.');
                        }
                    }
                    return _this;
                }
                Object.defineProperty(MatBadge.prototype, "color", {
                    /**
                     * The color of the badge. Can be `primary`, `accent`, or `warn`.
                     * @return {?}
                     */
                    get: function () { return this._color; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._setColor(value);
                        this._color = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatBadge.prototype, "overlap", {
                    /**
                     * Whether the badge should overlap its contents or not
                     * @return {?}
                     */
                    get: function () { return this._overlap; },
                    /**
                     * @param {?} val
                     * @return {?}
                     */
                    set: function (val) {
                        this._overlap = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(val);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatBadge.prototype, "description", {
                    /**
                     * Message used to describe the decorated element via aria-describedby
                     * @return {?}
                     */
                    get: function () { return this._description; },
                    /**
                     * @param {?} newDescription
                     * @return {?}
                     */
                    set: function (newDescription) {
                        if (newDescription !== this._description) {
                            /** @type {?} */
                            var badgeElement = this._badgeElement;
                            this._updateHostAriaDescription(newDescription, this._description);
                            this._description = newDescription;
                            if (badgeElement) {
                                newDescription ? badgeElement.setAttribute('aria-label', newDescription) :
                                    badgeElement.removeAttribute('aria-label');
                            }
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatBadge.prototype, "hidden", {
                    /**
                     * Whether the badge is hidden.
                     * @return {?}
                     */
                    get: function () { return this._hidden; },
                    /**
                     * @param {?} val
                     * @return {?}
                     */
                    set: function (val) {
                        this._hidden = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(val);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Whether the badge is above the host or not
                 * @return {?}
                 */
                MatBadge.prototype.isAbove = function () {
                    return this.position.indexOf('below') === -1;
                };
                /**
                 * Whether the badge is after the host or not
                 * @return {?}
                 */
                MatBadge.prototype.isAfter = function () {
                    return this.position.indexOf('before') === -1;
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatBadge.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var contentChange = changes['content'];
                    if (contentChange) {
                        /** @type {?} */
                        var value = contentChange.currentValue;
                        this._hasContent = value != null && ("" + value).trim().length > 0;
                        this._updateTextContent();
                    }
                };
                /**
                 * @return {?}
                 */
                MatBadge.prototype.ngOnDestroy = function () {
                    /** @type {?} */
                    var badgeElement = this._badgeElement;
                    if (badgeElement) {
                        if (this.description) {
                            this._ariaDescriber.removeDescription(badgeElement, this.description);
                        }
                        // When creating a badge through the Renderer, Angular will keep it in an index.
                        // We have to destroy it ourselves, otherwise it'll be retained in memory.
                        if (this._renderer.destroyNode) {
                            this._renderer.destroyNode(badgeElement);
                        }
                    }
                };
                /**
                 * Gets the element into which the badge's content is being rendered.
                 * Undefined if the element hasn't been created (e.g. if the badge doesn't have content).
                 * @return {?}
                 */
                MatBadge.prototype.getBadgeElement = function () {
                    return this._badgeElement;
                };
                /**
                 * Injects a span element into the DOM with the content.
                 * @private
                 * @return {?}
                 */
                MatBadge.prototype._updateTextContent = function () {
                    if (!this._badgeElement) {
                        this._badgeElement = this._createBadgeElement();
                    }
                    else {
                        this._badgeElement.textContent = this.content;
                    }
                    return this._badgeElement;
                };
                /**
                 * Creates the badge element
                 * @private
                 * @return {?}
                 */
                MatBadge.prototype._createBadgeElement = function () {
                    /** @type {?} */
                    var badgeElement = this._renderer.createElement('span');
                    /** @type {?} */
                    var activeClass = 'mat-badge-active';
                    /** @type {?} */
                    var contentClass = 'mat-badge-content';
                    // Clear any existing badges which may have persisted from a server-side render.
                    this._clearExistingBadges(contentClass);
                    badgeElement.setAttribute('id', "mat-badge-content-" + this._id);
                    badgeElement.classList.add(contentClass);
                    badgeElement.textContent = this.content;
                    if (this._animationMode === 'NoopAnimations') {
                        badgeElement.classList.add('_mat-animation-noopable');
                    }
                    if (this.description) {
                        badgeElement.setAttribute('aria-label', this.description);
                    }
                    this._elementRef.nativeElement.appendChild(badgeElement);
                    // animate in after insertion
                    if (typeof requestAnimationFrame === 'function' && this._animationMode !== 'NoopAnimations') {
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            requestAnimationFrame(( /**
                             * @return {?}
                             */function () {
                                badgeElement.classList.add(activeClass);
                            }));
                        }));
                    }
                    else {
                        badgeElement.classList.add(activeClass);
                    }
                    return badgeElement;
                };
                /**
                 * Sets the aria-label property on the element
                 * @private
                 * @param {?} newDescription
                 * @param {?} oldDescription
                 * @return {?}
                 */
                MatBadge.prototype._updateHostAriaDescription = function (newDescription, oldDescription) {
                    // ensure content available before setting label
                    /** @type {?} */
                    var content = this._updateTextContent();
                    if (oldDescription) {
                        this._ariaDescriber.removeDescription(content, oldDescription);
                    }
                    if (newDescription) {
                        this._ariaDescriber.describe(content, newDescription);
                    }
                };
                /**
                 * Adds css theme class given the color to the component host
                 * @private
                 * @param {?} colorPalette
                 * @return {?}
                 */
                MatBadge.prototype._setColor = function (colorPalette) {
                    if (colorPalette !== this._color) {
                        if (this._color) {
                            this._elementRef.nativeElement.classList.remove("mat-badge-" + this._color);
                        }
                        if (colorPalette) {
                            this._elementRef.nativeElement.classList.add("mat-badge-" + colorPalette);
                        }
                    }
                };
                /**
                 * Clears any existing badges that might be left over from server-side rendering.
                 * @private
                 * @param {?} cssClass
                 * @return {?}
                 */
                MatBadge.prototype._clearExistingBadges = function (cssClass) {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    /** @type {?} */
                    var childCount = element.children.length;
                    // Use a reverse while, because we'll be removing elements from the list as we're iterating.
                    while (childCount--) {
                        /** @type {?} */
                        var currentChild = element.children[childCount];
                        if (currentChild.classList.contains(cssClass)) {
                            element.removeChild(currentChild);
                        }
                    }
                };
                return MatBadge;
            }(_MatBadgeMixinBase));
            MatBadge.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Directive"], args: [{
                            selector: '[matBadge]',
                            inputs: ['disabled: matBadgeDisabled'],
                            host: {
                                'class': 'mat-badge',
                                '[class.mat-badge-overlap]': 'overlap',
                                '[class.mat-badge-above]': 'isAbove()',
                                '[class.mat-badge-below]': '!isAbove()',
                                '[class.mat-badge-before]': '!isAfter()',
                                '[class.mat-badge-after]': 'isAfter()',
                                '[class.mat-badge-small]': 'size === "small"',
                                '[class.mat-badge-medium]': 'size === "medium"',
                                '[class.mat-badge-large]': 'size === "large"',
                                '[class.mat-badge-hidden]': 'hidden || !_hasContent',
                                '[class.mat-badge-disabled]': 'disabled',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatBadge.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["AriaDescriber"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Renderer2"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatBadge.propDecorators = {
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadgeColor',] }],
                overlap: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadgeOverlap',] }],
                position: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadgePosition',] }],
                content: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadge',] }],
                description: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadgeDescription',] }],
                size: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadgeSize',] }],
                hidden: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"], args: ['matBadgeHidden',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatBadgeModule = /** @class */ (function () {
                function MatBadgeModule() {
                }
                return MatBadgeModule;
            }());
            MatBadgeModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"], args: [{
                            imports: [
                                _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["A11yModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"]
                            ],
                            exports: [MatBadge],
                            declarations: [MatBadge],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=badge.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/bottom-sheet.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/bottom-sheet.js ***!
          \****************************************************************/
        /*! exports provided: MatBottomSheetModule, MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, MatBottomSheet, MAT_BOTTOM_SHEET_DATA, MatBottomSheetConfig, MatBottomSheetContainer, matBottomSheetAnimations, MatBottomSheetRef */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetModule", function () { return MatBottomSheetModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_BOTTOM_SHEET_DEFAULT_OPTIONS", function () { return MAT_BOTTOM_SHEET_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheet", function () { return MatBottomSheet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_BOTTOM_SHEET_DATA", function () { return MAT_BOTTOM_SHEET_DATA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetConfig", function () { return MatBottomSheetConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetContainer", function () { return MatBottomSheetContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matBottomSheetAnimations", function () { return matBottomSheetAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetRef", function () { return MatBottomSheetRef; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/layout */ "./node_modules/@angular/cdk/esm2015/layout.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to access the data that was passed in to a bottom sheet.
             * @type {?}
             */
            var MAT_BOTTOM_SHEET_DATA = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MatBottomSheetData');
            /**
             * Configuration used when opening a bottom sheet.
             * @template D
             */
            var MatBottomSheetConfig = /** @class */ (function () {
                function MatBottomSheetConfig() {
                    /**
                     * Data being injected into the child component.
                     */
                    this.data = null;
                    /**
                     * Whether the bottom sheet has a backdrop.
                     */
                    this.hasBackdrop = true;
                    /**
                     * Whether the user can use escape or clicking outside to close the bottom sheet.
                     */
                    this.disableClose = false;
                    /**
                     * Aria label to assign to the bottom sheet element.
                     */
                    this.ariaLabel = null;
                    /**
                     * Whether the bottom sheet should close when the user goes backwards/forwards in history.
                     * Note that this usually doesn't include clicking on links (unless the user is using
                     * the `HashLocationStrategy`).
                     */
                    this.closeOnNavigation = true;
                    // Note that this is disabled by default, because while the a11y recommendations are to focus
                    // the first focusable element, doing so prevents screen readers from reading out the
                    // rest of the bottom sheet content.
                    /**
                     * Whether the bottom sheet should focus the first focusable element on open.
                     */
                    this.autoFocus = false;
                    /**
                     * Whether the bottom sheet should restore focus to the
                     * previously-focused element, after it's closed.
                     */
                    this.restoreFocus = true;
                }
                return MatBottomSheetConfig;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the Material bottom sheet.
             * @type {?}
             */
            var matBottomSheetAnimations = {
                /**
                 * Animation that shows and hides a bottom sheet.
                 */
                bottomSheetState: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('state', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('void, hidden', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ transform: 'translateY(100%)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('visible', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ transform: 'translateY(0%)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('visible => void, visible => hidden', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["AnimationDurations"].COMPLEX + " " + _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["AnimationCurves"].ACCELERATION_CURVE)),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('void => visible', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["AnimationDurations"].EXITING + " " + _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["AnimationCurves"].DECELERATION_CURVE)),
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO(crisbeto): consolidate some logic between this, MatDialog and MatSnackBar
            /**
             * Internal component that wraps user-provided bottom sheet content.
             * \@docs-private
             */
            var MatBottomSheetContainer = /** @class */ (function (_super_1) {
                __extends(MatBottomSheetContainer, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} _focusTrapFactory
                 * @param {?} breakpointObserver
                 * @param {?} document
                 * @param {?} bottomSheetConfig
                 */
                function MatBottomSheetContainer(_elementRef, _changeDetectorRef, _focusTrapFactory, breakpointObserver, document, bottomSheetConfig) {
                    var _this = _super_1.call(this) || this;
                    _this._elementRef = _elementRef;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._focusTrapFactory = _focusTrapFactory;
                    _this.bottomSheetConfig = bottomSheetConfig;
                    /**
                     * The state of the bottom sheet animations.
                     */
                    _this._animationState = 'void';
                    /**
                     * Emits whenever the state of the animation changes.
                     */
                    _this._animationStateChanged = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Element that was focused before the bottom sheet was opened.
                     */
                    _this._elementFocusedBeforeOpened = null;
                    _this._document = document;
                    _this._breakpointSubscription = breakpointObserver
                        .observe([_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["Breakpoints"].Medium, _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["Breakpoints"].Large, _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["Breakpoints"].XLarge])
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._toggleClass('mat-bottom-sheet-container-medium', breakpointObserver.isMatched(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["Breakpoints"].Medium));
                        _this._toggleClass('mat-bottom-sheet-container-large', breakpointObserver.isMatched(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["Breakpoints"].Large));
                        _this._toggleClass('mat-bottom-sheet-container-xlarge', breakpointObserver.isMatched(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["Breakpoints"].XLarge));
                    }));
                    return _this;
                }
                /**
                 * Attach a component portal as content to this bottom sheet container.
                 * @template T
                 * @param {?} portal
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype.attachComponentPortal = function (portal) {
                    this._validatePortalAttached();
                    this._setPanelClass();
                    this._savePreviouslyFocusedElement();
                    return this._portalOutlet.attachComponentPortal(portal);
                };
                /**
                 * Attach a template portal as content to this bottom sheet container.
                 * @template C
                 * @param {?} portal
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype.attachTemplatePortal = function (portal) {
                    this._validatePortalAttached();
                    this._setPanelClass();
                    this._savePreviouslyFocusedElement();
                    return this._portalOutlet.attachTemplatePortal(portal);
                };
                /**
                 * Begin animation of bottom sheet entrance into view.
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype.enter = function () {
                    if (!this._destroyed) {
                        this._animationState = 'visible';
                        this._changeDetectorRef.detectChanges();
                    }
                };
                /**
                 * Begin animation of the bottom sheet exiting from view.
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype.exit = function () {
                    if (!this._destroyed) {
                        this._animationState = 'hidden';
                        this._changeDetectorRef.markForCheck();
                    }
                };
                /**
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype.ngOnDestroy = function () {
                    this._breakpointSubscription.unsubscribe();
                    this._destroyed = true;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._onAnimationDone = function (event) {
                    if (event.toState === 'hidden') {
                        this._restoreFocus();
                    }
                    else if (event.toState === 'visible') {
                        this._trapFocus();
                    }
                    this._animationStateChanged.emit(event);
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._onAnimationStart = function (event) {
                    this._animationStateChanged.emit(event);
                };
                /**
                 * @private
                 * @param {?} cssClass
                 * @param {?} add
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._toggleClass = function (cssClass, add) {
                    /** @type {?} */
                    var classList = this._elementRef.nativeElement.classList;
                    add ? classList.add(cssClass) : classList.remove(cssClass);
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._validatePortalAttached = function () {
                    if (this._portalOutlet.hasAttached()) {
                        throw Error('Attempting to attach bottom sheet content after content is already attached');
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._setPanelClass = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    /** @type {?} */
                    var panelClass = this.bottomSheetConfig.panelClass;
                    if (Array.isArray(panelClass)) {
                        // Note that we can't use a spread here, because IE doesn't support multiple arguments.
                        panelClass.forEach(( /**
                         * @param {?} cssClass
                         * @return {?}
                         */function (/**
                         * @param {?} cssClass
                         * @return {?}
                         */ cssClass) { return element.classList.add(cssClass); }));
                    }
                    else if (panelClass) {
                        element.classList.add(panelClass);
                    }
                };
                /**
                 * Moves the focus inside the focus trap.
                 * @private
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._trapFocus = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    if (!this._focusTrap) {
                        this._focusTrap = this._focusTrapFactory.create(element);
                    }
                    if (this.bottomSheetConfig.autoFocus) {
                        this._focusTrap.focusInitialElementWhenReady();
                    }
                    else {
                        /** @type {?} */
                        var activeElement = this._document.activeElement;
                        // Otherwise ensure that focus is on the container. It's possible that a different
                        // component tried to move focus while the open animation was running. See:
                        // https://github.com/angular/components/issues/16215. Note that we only want to do this
                        // if the focus isn't inside the bottom sheet already, because it's possible that the
                        // consumer turned off `autoFocus` in order to move focus themselves.
                        if (activeElement !== element && !element.contains(activeElement)) {
                            element.focus();
                        }
                    }
                };
                /**
                 * Restores focus to the element that was focused before the bottom sheet was opened.
                 * @private
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._restoreFocus = function () {
                    /** @type {?} */
                    var toFocus = this._elementFocusedBeforeOpened;
                    // We need the extra check, because IE can set the `activeElement` to null in some cases.
                    if (this.bottomSheetConfig.restoreFocus && toFocus && typeof toFocus.focus === 'function') {
                        toFocus.focus();
                    }
                    if (this._focusTrap) {
                        this._focusTrap.destroy();
                    }
                };
                /**
                 * Saves a reference to the element that was focused before the bottom sheet was opened.
                 * @private
                 * @return {?}
                 */
                MatBottomSheetContainer.prototype._savePreviouslyFocusedElement = function () {
                    var _this = this;
                    this._elementFocusedBeforeOpened = ( /** @type {?} */(this._document.activeElement));
                    // The `focus` method isn't available during server-side rendering.
                    if (this._elementRef.nativeElement.focus) {
                        Promise.resolve().then(( /**
                         * @return {?}
                         */function () { return _this._elementRef.nativeElement.focus(); }));
                    }
                };
                return MatBottomSheetContainer;
            }(_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["BasePortalOutlet"]));
            MatBottomSheetContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-bottom-sheet-container',
                            template: "<ng-template cdkPortalOutlet></ng-template>",
                            styles: [".mat-bottom-sheet-container{padding:8px 16px;min-width:100vw;box-sizing:border-box;display:block;outline:0;max-height:80vh;overflow:auto}@media (-ms-high-contrast:active){.mat-bottom-sheet-container{outline:1px solid}}.mat-bottom-sheet-container-large,.mat-bottom-sheet-container-medium,.mat-bottom-sheet-container-xlarge{border-top-left-radius:4px;border-top-right-radius:4px}.mat-bottom-sheet-container-medium{min-width:384px;max-width:calc(100vw - 128px)}.mat-bottom-sheet-container-large{min-width:512px;max-width:calc(100vw - 256px)}.mat-bottom-sheet-container-xlarge{min-width:576px;max-width:calc(100vw - 384px)}"],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            animations: [matBottomSheetAnimations.bottomSheetState],
                            host: {
                                'class': 'mat-bottom-sheet-container',
                                'tabindex': '-1',
                                'role': 'dialog',
                                'aria-modal': 'true',
                                '[attr.aria-label]': 'bottomSheetConfig?.ariaLabel',
                                '[@state]': '_animationState',
                                '(@state.start)': '_onAnimationStart($event)',
                                '(@state.done)': '_onAnimationDone($event)'
                            },
                        },] },
            ];
            /** @nocollapse */
            MatBottomSheetContainer.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_6__["FocusTrapFactory"] },
                { type: _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_4__["BreakpointObserver"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"],] }] },
                { type: MatBottomSheetConfig }
            ]; };
            MatBottomSheetContainer.propDecorators = {
                _portalOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["CdkPortalOutlet"], { static: true },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatBottomSheetModule = /** @class */ (function () {
                function MatBottomSheetModule() {
                }
                return MatBottomSheetModule;
            }());
            MatBottomSheetModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"],
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_7__["OverlayModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"],
                                _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalModule"],
                            ],
                            exports: [MatBottomSheetContainer, _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"]],
                            declarations: [MatBottomSheetContainer],
                            entryComponents: [MatBottomSheetContainer],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Reference to a bottom sheet dispatched from the bottom sheet service.
             * @template T, R
             */
            var MatBottomSheetRef = /** @class */ (function () {
                /**
                 * @param {?} containerInstance
                 * @param {?} _overlayRef
                 * @param {?=} _location
                 */
                function MatBottomSheetRef(containerInstance, _overlayRef, 
                // @breaking-change 8.0.0 `_location` parameter to be removed.
                _location) {
                    var _this = this;
                    this._overlayRef = _overlayRef;
                    /**
                     * Subject for notifying the user that the bottom sheet has been dismissed.
                     */
                    this._afterDismissed = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    /**
                     * Subject for notifying the user that the bottom sheet has opened and appeared.
                     */
                    this._afterOpened = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    this.containerInstance = containerInstance;
                    this.disableClose = containerInstance.bottomSheetConfig.disableClose;
                    // Emit when opening animation completes
                    containerInstance._animationStateChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) { return event.phaseName === 'done' && event.toState === 'visible'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["take"])(1))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._afterOpened.next();
                        _this._afterOpened.complete();
                    }));
                    // Dispose overlay when closing animation is complete
                    containerInstance._animationStateChanged
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) { return event.phaseName === 'done' && event.toState === 'hidden'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["take"])(1))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        clearTimeout(_this._closeFallbackTimeout);
                        _overlayRef.dispose();
                    }));
                    _overlayRef.detachments().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["take"])(1)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._afterDismissed.next(_this._result);
                        _this._afterDismissed.complete();
                    }));
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_overlayRef.backdropClick(), _overlayRef.keydownEvents().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) { return event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["ESCAPE"]; })))).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        if (!_this.disableClose &&
                            (event.type !== 'keydown' || !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["hasModifierKey"])(( /** @type {?} */(event))))) {
                            event.preventDefault();
                            _this.dismiss();
                        }
                    }));
                }
                /**
                 * Dismisses the bottom sheet.
                 * @param {?=} result Data to be passed back to the bottom sheet opener.
                 * @return {?}
                 */
                MatBottomSheetRef.prototype.dismiss = function (result) {
                    var _this = this;
                    if (!this._afterDismissed.closed) {
                        // Transition the backdrop in parallel to the bottom sheet.
                        this.containerInstance._animationStateChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) { return event.phaseName === 'start'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["take"])(1)).subscribe(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) {
                            // The logic that disposes of the overlay depends on the exit animation completing, however
                            // it isn't guaranteed if the parent view is destroyed while it's running. Add a fallback
                            // timeout which will clean everything up if the animation hasn't fired within the specified
                            // amount of time plus 100ms. We don't need to run this outside the NgZone, because for the
                            // vast majority of cases the timeout will have been cleared before it has fired.
                            _this._closeFallbackTimeout = setTimeout(( /**
                             * @return {?}
                             */function () {
                                _this._overlayRef.dispose();
                            }), event.totalTime + 100);
                            _this._overlayRef.detachBackdrop();
                        }));
                        this._result = result;
                        this.containerInstance.exit();
                    }
                };
                /**
                 * Gets an observable that is notified when the bottom sheet is finished closing.
                 * @return {?}
                 */
                MatBottomSheetRef.prototype.afterDismissed = function () {
                    return this._afterDismissed.asObservable();
                };
                /**
                 * Gets an observable that is notified when the bottom sheet has opened and appeared.
                 * @return {?}
                 */
                MatBottomSheetRef.prototype.afterOpened = function () {
                    return this._afterOpened.asObservable();
                };
                /**
                 * Gets an observable that emits when the overlay's backdrop has been clicked.
                 * @return {?}
                 */
                MatBottomSheetRef.prototype.backdropClick = function () {
                    return this._overlayRef.backdropClick();
                };
                /**
                 * Gets an observable that emits when keydown events are targeted on the overlay.
                 * @return {?}
                 */
                MatBottomSheetRef.prototype.keydownEvents = function () {
                    return this._overlayRef.keydownEvents();
                };
                return MatBottomSheetRef;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to specify default bottom sheet options.
             * @type {?}
             */
            var MAT_BOTTOM_SHEET_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-bottom-sheet-default-options');
            /**
             * Service to trigger Material Design bottom sheets.
             */
            var MatBottomSheet = /** @class */ (function () {
                /**
                 * @param {?} _overlay
                 * @param {?} _injector
                 * @param {?} _parentBottomSheet
                 * @param {?=} _location
                 * @param {?=} _defaultOptions
                 */
                function MatBottomSheet(_overlay, _injector, _parentBottomSheet, _location, _defaultOptions) {
                    this._overlay = _overlay;
                    this._injector = _injector;
                    this._parentBottomSheet = _parentBottomSheet;
                    this._location = _location;
                    this._defaultOptions = _defaultOptions;
                    this._bottomSheetRefAtThisLevel = null;
                }
                Object.defineProperty(MatBottomSheet.prototype, "_openedBottomSheetRef", {
                    /**
                     * Reference to the currently opened bottom sheet.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var parent = this._parentBottomSheet;
                        return parent ? parent._openedBottomSheetRef : this._bottomSheetRefAtThisLevel;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._parentBottomSheet) {
                            this._parentBottomSheet._openedBottomSheetRef = value;
                        }
                        else {
                            this._bottomSheetRefAtThisLevel = value;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @template T, D, R
                 * @param {?} componentOrTemplateRef
                 * @param {?=} config
                 * @return {?}
                 */
                MatBottomSheet.prototype.open = function (componentOrTemplateRef, config) {
                    var _this = this;
                    /** @type {?} */
                    var _config = _applyConfigDefaults(this._defaultOptions || new MatBottomSheetConfig(), config);
                    /** @type {?} */
                    var overlayRef = this._createOverlay(_config);
                    /** @type {?} */
                    var container = this._attachContainer(overlayRef, _config);
                    /** @type {?} */
                    var ref = new MatBottomSheetRef(container, overlayRef, this._location);
                    if (componentOrTemplateRef instanceof _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"]) {
                        container.attachTemplatePortal(new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["TemplatePortal"](componentOrTemplateRef, ( /** @type {?} */(null)), ( /** @type {?} */({
                            $implicit: _config.data,
                            bottomSheetRef: ref
                        }))));
                    }
                    else {
                        /** @type {?} */
                        var portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](componentOrTemplateRef, undefined, this._createInjector(_config, ref));
                        /** @type {?} */
                        var contentRef = container.attachComponentPortal(portal);
                        ref.instance = contentRef.instance;
                    }
                    // When the bottom sheet is dismissed, clear the reference to it.
                    ref.afterDismissed().subscribe(( /**
                     * @return {?}
                     */function () {
                        // Clear the bottom sheet ref if it hasn't already been replaced by a newer one.
                        if (_this._openedBottomSheetRef == ref) {
                            _this._openedBottomSheetRef = null;
                        }
                    }));
                    if (this._openedBottomSheetRef) {
                        // If a bottom sheet is already in view, dismiss it and enter the
                        // new bottom sheet after exit animation is complete.
                        this._openedBottomSheetRef.afterDismissed().subscribe(( /**
                         * @return {?}
                         */function () { return ref.containerInstance.enter(); }));
                        this._openedBottomSheetRef.dismiss();
                    }
                    else {
                        // If no bottom sheet is in view, enter the new bottom sheet.
                        ref.containerInstance.enter();
                    }
                    this._openedBottomSheetRef = ref;
                    return ref;
                };
                /**
                 * Dismisses the currently-visible bottom sheet.
                 * @return {?}
                 */
                MatBottomSheet.prototype.dismiss = function () {
                    if (this._openedBottomSheetRef) {
                        this._openedBottomSheetRef.dismiss();
                    }
                };
                /**
                 * @return {?}
                 */
                MatBottomSheet.prototype.ngOnDestroy = function () {
                    if (this._bottomSheetRefAtThisLevel) {
                        this._bottomSheetRefAtThisLevel.dismiss();
                    }
                };
                /**
                 * Attaches the bottom sheet container component to the overlay.
                 * @private
                 * @param {?} overlayRef
                 * @param {?} config
                 * @return {?}
                 */
                MatBottomSheet.prototype._attachContainer = function (overlayRef, config) {
                    /** @type {?} */
                    var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
                    /** @type {?} */
                    var injector = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalInjector"](userInjector || this._injector, new WeakMap([
                        [MatBottomSheetConfig, config]
                    ]));
                    /** @type {?} */
                    var containerPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](MatBottomSheetContainer, config.viewContainerRef, injector);
                    /** @type {?} */
                    var containerRef = overlayRef.attach(containerPortal);
                    return containerRef.instance;
                };
                /**
                 * Creates a new overlay and places it in the correct location.
                 * @private
                 * @param {?} config The user-specified bottom sheet config.
                 * @return {?}
                 */
                MatBottomSheet.prototype._createOverlay = function (config) {
                    /** @type {?} */
                    var overlayConfig = new _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_7__["OverlayConfig"]({
                        direction: config.direction,
                        hasBackdrop: config.hasBackdrop,
                        disposeOnNavigation: config.closeOnNavigation,
                        maxWidth: '100%',
                        scrollStrategy: config.scrollStrategy || this._overlay.scrollStrategies.block(),
                        positionStrategy: this._overlay.position().global().centerHorizontally().bottom('0')
                    });
                    if (config.backdropClass) {
                        overlayConfig.backdropClass = config.backdropClass;
                    }
                    return this._overlay.create(overlayConfig);
                };
                /**
                 * Creates an injector to be used inside of a bottom sheet component.
                 * @private
                 * @template T
                 * @param {?} config Config that was used to create the bottom sheet.
                 * @param {?} bottomSheetRef Reference to the bottom sheet.
                 * @return {?}
                 */
                MatBottomSheet.prototype._createInjector = function (config, bottomSheetRef) {
                    /** @type {?} */
                    var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
                    /** @type {?} */
                    var injectionTokens = new WeakMap([
                        [MatBottomSheetRef, bottomSheetRef],
                        [MAT_BOTTOM_SHEET_DATA, config.data]
                    ]);
                    if (config.direction &&
                        (!userInjector || !userInjector.get(_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_11__["Directionality"], null))) {
                        injectionTokens.set(_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_11__["Directionality"], {
                            value: config.direction,
                            change: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["of"])()
                        });
                    }
                    return new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalInjector"](userInjector || this._injector, injectionTokens);
                };
                return MatBottomSheet;
            }());
            MatBottomSheet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: MatBottomSheetModule },] },
            ];
            /** @nocollapse */
            MatBottomSheet.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_7__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injector"] },
                { type: MatBottomSheet, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: _angular_common__WEBPACK_IMPORTED_MODULE_5__["Location"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: MatBottomSheetConfig, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,] }] }
            ]; };
            /** @nocollapse */ MatBottomSheet.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function MatBottomSheet_Factory() { return new MatBottomSheet(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_7__["Overlay"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["INJECTOR"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(MatBottomSheet, 12), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_5__["Location"], 8), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, 8)); }, token: MatBottomSheet, providedIn: MatBottomSheetModule });
            /**
             * Applies default options to the bottom sheet config.
             * @param {?} defaults Object containing the default values to which to fall back.
             * @param {?=} config The configuration to which the defaults will be applied.
             * @return {?} The new configuration object with defaults applied.
             */
            function _applyConfigDefaults(defaults, config) {
                return Object.assign({}, defaults, config);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=bottom-sheet.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/button-toggle.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/button-toggle.js ***!
          \*****************************************************************/
        /*! exports provided: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR, MatButtonToggleGroupMultiple, MatButtonToggleChange, MatButtonToggleGroup, MatButtonToggle, MatButtonToggleModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS", function () { return MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR", function () { return MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleGroupMultiple", function () { return MatButtonToggleGroupMultiple; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleChange", function () { return MatButtonToggleChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleGroup", function () { return MatButtonToggleGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggle", function () { return MatButtonToggle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleModule", function () { return MatButtonToggleModule; });
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to configure the
             * default options for all button toggles within an app.
             * @type {?}
             */
            var MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS');
            /**
             * Provider Expression that allows mat-button-toggle-group to register as a ControlValueAccessor.
             * This allows it to support [(ngModel)].
             * \@docs-private
             * @type {?}
             */
            var MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatButtonToggleGroup; })),
                multi: true
            };
            /**
             * @deprecated Use `MatButtonToggleGroup` instead.
             * \@breaking-change 8.0.0
             */
            var MatButtonToggleGroupMultiple = /** @class */ (function () {
                function MatButtonToggleGroupMultiple() {
                }
                return MatButtonToggleGroupMultiple;
            }());
            /** @type {?} */
            var _uniqueIdCounter = 0;
            /**
             * Change event object emitted by MatButtonToggle.
             */
            var MatButtonToggleChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} value
                 */
                function MatButtonToggleChange(source, value) {
                    this.source = source;
                    this.value = value;
                }
                return MatButtonToggleChange;
            }());
            /**
             * Exclusive selection button toggle group that behaves like a radio-button group.
             */
            var MatButtonToggleGroup = /** @class */ (function () {
                /**
                 * @param {?} _changeDetector
                 * @param {?=} defaultOptions
                 */
                function MatButtonToggleGroup(_changeDetector, defaultOptions) {
                    this._changeDetector = _changeDetector;
                    this._vertical = false;
                    this._multiple = false;
                    this._disabled = false;
                    /**
                     * The method to be called in order to update ngModel.
                     * Now `ngModel` binding is not supported in multiple selection mode.
                     */
                    this._controlValueAccessorChangeFn = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * onTouch function registered via registerOnTouch (ControlValueAccessor).
                     */
                    this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    this._name = "mat-button-toggle-group-" + _uniqueIdCounter++;
                    /**
                     * Event that emits whenever the value of the group changes.
                     * Used to facilitate two-way data binding.
                     * \@docs-private
                     */
                    this.valueChange = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the group's value changes.
                     */
                    this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    this.appearance =
                        defaultOptions && defaultOptions.appearance ? defaultOptions.appearance : 'standard';
                }
                Object.defineProperty(MatButtonToggleGroup.prototype, "name", {
                    /**
                     * `name` attribute for the underlying `input` element.
                     * @return {?}
                     */
                    get: function () { return this._name; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        var _this = this;
                        this._name = value;
                        if (this._buttonToggles) {
                            this._buttonToggles.forEach(( /**
                             * @param {?} toggle
                             * @return {?}
                             */function (/**
                             * @param {?} toggle
                             * @return {?}
                             */ toggle) {
                                toggle.name = _this._name;
                                toggle._markForCheck();
                            }));
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggleGroup.prototype, "vertical", {
                    /**
                     * Whether the toggle group is vertical.
                     * @return {?}
                     */
                    get: function () { return this._vertical; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._vertical = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggleGroup.prototype, "value", {
                    /**
                     * Value of the toggle group.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var selected = this._selectionModel ? this._selectionModel.selected : [];
                        if (this.multiple) {
                            return selected.map(( /**
                             * @param {?} toggle
                             * @return {?}
                             */function (/**
                             * @param {?} toggle
                             * @return {?}
                             */ toggle) { return toggle.value; }));
                        }
                        return selected[0] ? selected[0].value : undefined;
                    },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) {
                        this._setSelectionByValue(newValue);
                        this.valueChange.emit(this.value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggleGroup.prototype, "selected", {
                    /**
                     * Selected button toggles in the group.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var selected = this._selectionModel ? this._selectionModel.selected : [];
                        return this.multiple ? selected : (selected[0] || null);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggleGroup.prototype, "multiple", {
                    /**
                     * Whether multiple button toggles can be selected.
                     * @return {?}
                     */
                    get: function () { return this._multiple; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._multiple = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggleGroup.prototype, "disabled", {
                    /**
                     * Whether multiple button toggle group is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        if (this._buttonToggles) {
                            this._buttonToggles.forEach(( /**
                             * @param {?} toggle
                             * @return {?}
                             */function (/**
                             * @param {?} toggle
                             * @return {?}
                             */ toggle) { return toggle._markForCheck(); }));
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype.ngOnInit = function () {
                    this._selectionModel = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_2__["SelectionModel"](this.multiple, undefined, false);
                };
                /**
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype.ngAfterContentInit = function () {
                    var _c;
                    (_c = this._selectionModel).select.apply(_c, this._buttonToggles.filter(( /**
                     * @param {?} toggle
                     * @return {?}
                     */function (/**
                     * @param {?} toggle
                     * @return {?}
                     */ toggle) { return toggle.checked; })));
                };
                /**
                 * Sets the model value. Implemented as part of ControlValueAccessor.
                 * @param {?} value Value to be set to the model.
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype.writeValue = function (value) {
                    this.value = value;
                    this._changeDetector.markForCheck();
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype.registerOnChange = function (fn) {
                    this._controlValueAccessorChangeFn = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                };
                /**
                 * Dispatch change event with current selection and group value.
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._emitChangeEvent = function () {
                    /** @type {?} */
                    var selected = this.selected;
                    /** @type {?} */
                    var source = Array.isArray(selected) ? selected[selected.length - 1] : selected;
                    /** @type {?} */
                    var event = new MatButtonToggleChange(( /** @type {?} */(source)), this.value);
                    this._controlValueAccessorChangeFn(event.value);
                    this.change.emit(event);
                };
                /**
                 * Syncs a button toggle's selected state with the model value.
                 * @param {?} toggle Toggle to be synced.
                 * @param {?} select Whether the toggle should be selected.
                 * @param {?=} isUserInput Whether the change was a result of a user interaction.
                 * @param {?=} deferEvents Whether to defer emitting the change events.
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._syncButtonToggle = function (toggle, select, isUserInput, deferEvents) {
                    if (isUserInput === void 0) { isUserInput = false; }
                    if (deferEvents === void 0) { deferEvents = false; }
                    // Deselect the currently-selected toggle, if we're in single-selection
                    // mode and the button being toggled isn't selected at the moment.
                    if (!this.multiple && this.selected && !toggle.checked) {
                        (( /** @type {?} */(this.selected))).checked = false;
                    }
                    if (this._selectionModel) {
                        if (select) {
                            this._selectionModel.select(toggle);
                        }
                        else {
                            this._selectionModel.deselect(toggle);
                        }
                    }
                    else {
                        deferEvents = true;
                    }
                    // We need to defer in some cases in order to avoid "changed after checked errors", however
                    // the side-effect is that we may end up updating the model value out of sequence in others
                    // The `deferEvents` flag allows us to decide whether to do it on a case-by-case basis.
                    if (deferEvents) {
                    }
                    else {
                        this._updateModelValue(isUserInput);
                    }
                };
                /**
                 * Checks whether a button toggle is selected.
                 * @param {?} toggle
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._isSelected = function (toggle) {
                    return this._selectionModel && this._selectionModel.isSelected(toggle);
                };
                /**
                 * Determines whether a button toggle should be checked on init.
                 * @param {?} toggle
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._isPrechecked = function (toggle) {
                    if (typeof this._rawValue === 'undefined') {
                        return false;
                    }
                    if (this.multiple && Array.isArray(this._rawValue)) {
                        return this._rawValue.some(( /**
                         * @param {?} value
                         * @return {?}
                         */function (/**
                         * @param {?} value
                         * @return {?}
                         */ value) { return toggle.value != null && value === toggle.value; }));
                    }
                    return toggle.value === this._rawValue;
                };
                /**
                 * Updates the selection state of the toggles in the group based on a value.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._setSelectionByValue = function (value) {
                    var _this = this;
                    this._rawValue = value;
                    if (!this._buttonToggles) {
                        return;
                    }
                    if (this.multiple && value) {
                        if (!Array.isArray(value)) {
                            throw Error('Value must be an array in multiple-selection mode.');
                        }
                        this._clearSelection();
                        value.forEach(( /**
                         * @param {?} currentValue
                         * @return {?}
                         */function (currentValue) { return _this._selectValue(currentValue); }));
                    }
                    else {
                        this._clearSelection();
                        this._selectValue(value);
                    }
                };
                /**
                 * Clears the selected toggles.
                 * @private
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._clearSelection = function () {
                    this._selectionModel.clear();
                    this._buttonToggles.forEach(( /**
                     * @param {?} toggle
                     * @return {?}
                     */function (/**
                     * @param {?} toggle
                     * @return {?}
                     */ toggle) { return toggle.checked = false; }));
                };
                /**
                 * Selects a value if there's a toggle that corresponds to it.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._selectValue = function (value) {
                    /** @type {?} */
                    var correspondingOption = this._buttonToggles.find(( /**
                     * @param {?} toggle
                     * @return {?}
                     */function (/**
                     * @param {?} toggle
                     * @return {?}
                     */ toggle) {
                        return toggle.value != null && toggle.value === value;
                    }));
                    if (correspondingOption) {
                        correspondingOption.checked = true;
                        this._selectionModel.select(correspondingOption);
                    }
                };
                /**
                 * Syncs up the group's value with the model and emits the change event.
                 * @private
                 * @param {?} isUserInput
                 * @return {?}
                 */
                MatButtonToggleGroup.prototype._updateModelValue = function (isUserInput) {
                    // Only emit the change event for user input.
                    if (isUserInput) {
                        this._emitChangeEvent();
                    }
                    // Note: we emit this one no matter whether it was a user interaction, because
                    // it is used by Angular to sync up the two-way data binding.
                    this.valueChange.emit(this.value);
                };
                return MatButtonToggleGroup;
            }());
            MatButtonToggleGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'mat-button-toggle-group',
                            providers: [
                                MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR,
                                { provide: MatButtonToggleGroupMultiple, useExisting: MatButtonToggleGroup },
                            ],
                            host: {
                                'role': 'group',
                                'class': 'mat-button-toggle-group',
                                '[attr.aria-disabled]': 'disabled',
                                '[class.mat-button-toggle-vertical]': 'vertical',
                                '[class.mat-button-toggle-group-appearance-standard]': 'appearance === "standard"',
                            },
                            exportAs: 'matButtonToggleGroup',
                        },] },
            ];
            /** @nocollapse */
            MatButtonToggleGroup.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,] }] }
            ]; };
            MatButtonToggleGroup.propDecorators = {
                _buttonToggles: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["forwardRef"])(( /**
                                         * @return {?}
                                         */function () { return MatButtonToggle; })),] }],
                appearance: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                vertical: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                valueChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                multiple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }]
            };
            // Boilerplate for applying mixins to the MatButtonToggle class.
            /**
             * \@docs-private
             */
            var MatButtonToggleBase = /** @class */ (function () {
                function MatButtonToggleBase() {
                }
                return MatButtonToggleBase;
            }());
            /** @type {?} */
            var _MatButtonToggleMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinDisableRipple"])(MatButtonToggleBase);
            /**
             * Single button inside of a toggle group.
             */
            var MatButtonToggle = /** @class */ (function (_super_1) {
                __extends(MatButtonToggle, _super_1);
                /**
                 * @param {?} toggleGroup
                 * @param {?} _changeDetectorRef
                 * @param {?} _elementRef
                 * @param {?} _focusMonitor
                 * @param {?} defaultTabIndex
                 * @param {?=} defaultOptions
                 */
                function MatButtonToggle(toggleGroup, _changeDetectorRef, _elementRef, _focusMonitor, 
                // @breaking-change 8.0.0 `defaultTabIndex` to be made a required parameter.
                defaultTabIndex, defaultOptions) {
                    var _this = _super_1.call(this) || this;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._elementRef = _elementRef;
                    _this._focusMonitor = _focusMonitor;
                    _this._isSingleSelector = false;
                    _this._checked = false;
                    /**
                     * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
                     */
                    _this.ariaLabelledby = null;
                    _this._disabled = false;
                    /**
                     * Event emitted when the group value changes.
                     */
                    _this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /** @type {?} */
                    var parsedTabIndex = Number(defaultTabIndex);
                    _this.tabIndex = (parsedTabIndex || parsedTabIndex === 0) ? parsedTabIndex : null;
                    _this.buttonToggleGroup = toggleGroup;
                    _this.appearance =
                        defaultOptions && defaultOptions.appearance ? defaultOptions.appearance : 'standard';
                    return _this;
                }
                Object.defineProperty(MatButtonToggle.prototype, "buttonId", {
                    /**
                     * Unique ID for the underlying `button` element.
                     * @return {?}
                     */
                    get: function () { return this.id + "-button"; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggle.prototype, "appearance", {
                    /**
                     * The appearance style of the button.
                     * @return {?}
                     */
                    get: function () {
                        return this.buttonToggleGroup ? this.buttonToggleGroup.appearance : this._appearance;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._appearance = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggle.prototype, "checked", {
                    /**
                     * Whether the button is checked.
                     * @return {?}
                     */
                    get: function () {
                        return this.buttonToggleGroup ? this.buttonToggleGroup._isSelected(this) : this._checked;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        if (newValue !== this._checked) {
                            this._checked = newValue;
                            if (this.buttonToggleGroup) {
                                this.buttonToggleGroup._syncButtonToggle(this, this._checked);
                            }
                            this._changeDetectorRef.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatButtonToggle.prototype, "disabled", {
                    /**
                     * Whether the button is disabled.
                     * @return {?}
                     */
                    get: function () {
                        return this._disabled || (this.buttonToggleGroup && this.buttonToggleGroup.disabled);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatButtonToggle.prototype.ngOnInit = function () {
                    this._isSingleSelector = this.buttonToggleGroup && !this.buttonToggleGroup.multiple;
                    this._type = this._isSingleSelector ? 'radio' : 'checkbox';
                    this.id = this.id || "mat-button-toggle-" + _uniqueIdCounter++;
                    if (this._isSingleSelector) {
                        this.name = this.buttonToggleGroup.name;
                    }
                    if (this.buttonToggleGroup && this.buttonToggleGroup._isPrechecked(this)) {
                        this.checked = true;
                    }
                    this._focusMonitor.monitor(this._elementRef, true);
                };
                /**
                 * @return {?}
                 */
                MatButtonToggle.prototype.ngOnDestroy = function () {
                    /** @type {?} */
                    var group = this.buttonToggleGroup;
                    this._focusMonitor.stopMonitoring(this._elementRef);
                    // Remove the toggle from the selection once it's destroyed. Needs to happen
                    // on the next tick in order to avoid "changed after checked" errors.
                    if (group && group._isSelected(this)) {
                        group._syncButtonToggle(this, false, false, true);
                    }
                };
                /**
                 * Focuses the button.
                 * @param {?=} options
                 * @return {?}
                 */
                MatButtonToggle.prototype.focus = function (options) {
                    this._buttonElement.nativeElement.focus(options);
                };
                /**
                 * Checks the button toggle due to an interaction with the underlying native button.
                 * @return {?}
                 */
                MatButtonToggle.prototype._onButtonClick = function () {
                    /** @type {?} */
                    var newChecked = this._isSingleSelector ? true : !this._checked;
                    if (newChecked !== this._checked) {
                        this._checked = newChecked;
                        if (this.buttonToggleGroup) {
                            this.buttonToggleGroup._syncButtonToggle(this, this._checked, true);
                            this.buttonToggleGroup._onTouched();
                        }
                    }
                    // Emit a change event when it's the single selector
                    this.change.emit(new MatButtonToggleChange(this, this.value));
                };
                /**
                 * Marks the button toggle as needing checking for change detection.
                 * This method is exposed because the parent button toggle group will directly
                 * update bound properties of the radio button.
                 * @return {?}
                 */
                MatButtonToggle.prototype._markForCheck = function () {
                    // When the group value changes, the button will not be notified.
                    // Use `markForCheck` to explicit update button toggle's status.
                    this._changeDetectorRef.markForCheck();
                };
                return MatButtonToggle;
            }(_MatButtonToggleMixinBase));
            MatButtonToggle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'mat-button-toggle',
                            template: "<button #button class=\"mat-button-toggle-button\" type=\"button\" [id]=\"buttonId\" [attr.tabindex]=\"disabled ? -1 : tabIndex\" [attr.aria-pressed]=\"checked\" [disabled]=\"disabled || null\" [attr.name]=\"name || null\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (click)=\"_onButtonClick()\"><div class=\"mat-button-toggle-label-content\"><ng-content></ng-content></div></button><div class=\"mat-button-toggle-focus-overlay\"></div><div class=\"mat-button-toggle-ripple\" matRipple [matRippleTrigger]=\"button\" [matRippleDisabled]=\"this.disableRipple || this.disabled\"></div>",
                            styles: [".mat-button-toggle-group,.mat-button-toggle-standalone{position:relative;display:inline-flex;flex-direction:row;white-space:nowrap;overflow:hidden;border-radius:2px;-webkit-tap-highlight-color:transparent}@media (-ms-high-contrast:active){.mat-button-toggle-group,.mat-button-toggle-standalone{outline:solid 1px}}.mat-button-toggle-group-appearance-standard,.mat-button-toggle-standalone.mat-button-toggle-appearance-standard{border-radius:4px}@media (-ms-high-contrast:active){.mat-button-toggle-group-appearance-standard,.mat-button-toggle-standalone.mat-button-toggle-appearance-standard{outline:0}}.mat-button-toggle-vertical{flex-direction:column}.mat-button-toggle-vertical .mat-button-toggle-label-content{display:block}.mat-button-toggle{white-space:nowrap;position:relative}.mat-button-toggle .mat-icon svg{vertical-align:top}.mat-button-toggle.cdk-keyboard-focused .mat-button-toggle-focus-overlay{opacity:1}@media (-ms-high-contrast:active){.mat-button-toggle.cdk-keyboard-focused .mat-button-toggle-focus-overlay{opacity:.5}}.mat-button-toggle-appearance-standard:not(.mat-button-toggle-disabled):hover .mat-button-toggle-focus-overlay{opacity:.04}.mat-button-toggle-appearance-standard.cdk-keyboard-focused:not(.mat-button-toggle-disabled) .mat-button-toggle-focus-overlay{opacity:.12}@media (-ms-high-contrast:active){.mat-button-toggle-appearance-standard.cdk-keyboard-focused:not(.mat-button-toggle-disabled) .mat-button-toggle-focus-overlay{opacity:.5}}@media (hover:none){.mat-button-toggle-appearance-standard:not(.mat-button-toggle-disabled):hover .mat-button-toggle-focus-overlay{display:none}}.mat-button-toggle-label-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;line-height:36px;padding:0 16px;position:relative}.mat-button-toggle-appearance-standard .mat-button-toggle-label-content{line-height:48px;padding:0 12px}.mat-button-toggle-label-content>*{vertical-align:middle}.mat-button-toggle-focus-overlay{border-radius:inherit;pointer-events:none;opacity:0;top:0;left:0;right:0;bottom:0;position:absolute}.mat-button-toggle-checked .mat-button-toggle-focus-overlay{border-bottom:solid 36px}@media (-ms-high-contrast:active){.mat-button-toggle-checked .mat-button-toggle-focus-overlay{opacity:.5;height:0}}@media (-ms-high-contrast:active){.mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-focus-overlay{border-bottom:solid 48px}}.mat-button-toggle .mat-button-toggle-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-button-toggle-button{border:0;background:0 0;color:inherit;padding:0;margin:0;font:inherit;outline:0;width:100%;cursor:pointer}.mat-button-toggle-disabled .mat-button-toggle-button{cursor:default}.mat-button-toggle-button::-moz-focus-inner{border:0}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                            exportAs: 'matButtonToggle',
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush,
                            inputs: ['disableRipple'],
                            host: {
                                '[class.mat-button-toggle-standalone]': '!buttonToggleGroup',
                                '[class.mat-button-toggle-checked]': 'checked',
                                '[class.mat-button-toggle-disabled]': 'disabled',
                                '[class.mat-button-toggle-appearance-standard]': 'appearance === "standard"',
                                'class': 'mat-button-toggle',
                                // Always reset the tabindex to -1 so it doesn't conflict with the one on the `button`,
                                // but can still receive focus from things like cdkFocusInitial.
                                '[attr.tabindex]': '-1',
                                '[attr.id]': 'id',
                                '[attr.name]': 'null',
                                '(focus)': 'focus()',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatButtonToggle.ctorParameters = function () { return [
                { type: MatButtonToggleGroup, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["FocusMonitor"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Attribute"], args: ['tabindex',] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,] }] }
            ]; };
            MatButtonToggle.propDecorators = {
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['aria-labelledby',] }],
                _buttonElement: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"], args: ['button', { static: false },] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                tabIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                appearance: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                checked: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatButtonToggleModule = /** @class */ (function () {
                function MatButtonToggleModule() {
                }
                return MatButtonToggleModule;
            }());
            MatButtonToggleModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatCommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatRippleModule"]],
                            exports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatCommonModule"], MatButtonToggleGroup, MatButtonToggle],
                            declarations: [MatButtonToggleGroup, MatButtonToggle],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=button-toggle.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/button.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/button.js ***!
          \**********************************************************/
        /*! exports provided: MatButtonModule, MatButton, MatAnchor */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButtonModule", function () { return MatButtonModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatButton", function () { return MatButton; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAnchor", function () { return MatAnchor; });
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Default color palette for round buttons (mat-fab and mat-mini-fab)
             * @type {?}
             */
            var DEFAULT_ROUND_BUTTON_COLOR = 'accent';
            /**
             * List of classes to add to MatButton instances based on host attributes to
             * style as different variants.
             * @type {?}
             */
            var BUTTON_HOST_ATTRIBUTES = [
                'mat-button',
                'mat-flat-button',
                'mat-icon-button',
                'mat-raised-button',
                'mat-stroked-button',
                'mat-mini-fab',
                'mat-fab',
            ];
            // Boilerplate for applying mixins to MatButton.
            /**
             * \@docs-private
             */
            var MatButtonBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatButtonBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatButtonBase;
            }());
            /** @type {?} */
            var _MatButtonMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinColor"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinDisabled"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinDisableRipple"])(MatButtonBase)));
            /**
             * Material design button.
             */
            var MatButton = /** @class */ (function (_super_1) {
                __extends(MatButton, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _focusMonitor
                 * @param {?} _animationMode
                 */
                function MatButton(elementRef, _focusMonitor, _animationMode) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._focusMonitor = _focusMonitor;
                    _this._animationMode = _animationMode;
                    /**
                     * Whether the button is round.
                     */
                    _this.isRoundButton = _this._hasHostAttributes('mat-fab', 'mat-mini-fab');
                    /**
                     * Whether the button is icon button.
                     */
                    _this.isIconButton = _this._hasHostAttributes('mat-icon-button');
                    // For each of the variant selectors that is present in the button's host
                    // attributes, add the correct corresponding class.
                    for (var _c = 0, BUTTON_HOST_ATTRIBUTES_1 = BUTTON_HOST_ATTRIBUTES; _c < BUTTON_HOST_ATTRIBUTES_1.length; _c++) {
                        var attr = BUTTON_HOST_ATTRIBUTES_1[_c];
                        if (_this._hasHostAttributes(attr)) {
                            (( /** @type {?} */(_this._getHostElement()))).classList.add(attr);
                        }
                    }
                    // Add a class that applies to all buttons. This makes it easier to target if somebody
                    // wants to target all Material buttons. We do it here rather than `host` to ensure that
                    // the class is applied to derived classes.
                    elementRef.nativeElement.classList.add('mat-button-base');
                    _this._focusMonitor.monitor(_this._elementRef, true);
                    if (_this.isRoundButton) {
                        _this.color = DEFAULT_ROUND_BUTTON_COLOR;
                    }
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatButton.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this._elementRef);
                };
                /**
                 * Focuses the button.
                 * @param {?=} origin
                 * @param {?=} options
                 * @return {?}
                 */
                MatButton.prototype.focus = function (origin, options) {
                    if (origin === void 0) { origin = 'program'; }
                    this._focusMonitor.focusVia(this._getHostElement(), origin, options);
                };
                /**
                 * @return {?}
                 */
                MatButton.prototype._getHostElement = function () {
                    return this._elementRef.nativeElement;
                };
                /**
                 * @return {?}
                 */
                MatButton.prototype._isRippleDisabled = function () {
                    return this.disableRipple || this.disabled;
                };
                /**
                 * Gets whether the button has one of the given attributes.
                 * @param {...?} attributes
                 * @return {?}
                 */
                MatButton.prototype._hasHostAttributes = function () {
                    var _this = this;
                    var attributes = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        attributes[_c] = arguments[_c];
                    }
                    return attributes.some(( /**
                     * @param {?} attribute
                     * @return {?}
                     */function (/**
                     * @param {?} attribute
                     * @return {?}
                     */ attribute) { return _this._getHostElement().hasAttribute(attribute); }));
                };
                return MatButton;
            }(_MatButtonMixinBase));
            MatButton.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],\n             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],\n             button[mat-flat-button]",
                            exportAs: 'matButton',
                            host: {
                                '[attr.disabled]': 'disabled || null',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                            },
                            template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span><div matRipple class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"isRoundButton || isIconButton\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"isIconButton\" [matRippleTrigger]=\"_getHostElement()\"></div><div class=\"mat-button-focus-overlay\"></div>",
                            styles: [".mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:.04}@media (hover:none){.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:0}}.mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button[disabled]{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-raised-button::-moz-focus-inner{border:0}._mat-animation-noopable.mat-raised-button{transition:none;animation:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button .mat-button-focus-overlay,.mat-stroked-button .mat-button-ripple.mat-ripple{top:-1px;left:-1px;right:-1px;bottom:-1px}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab::-moz-focus-inner{border:0}.mat-fab[disabled]{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-fab::-moz-focus-inner{border:0}._mat-animation-noopable.mat-fab{transition:none;animation:none}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab[disabled]{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-mini-fab::-moz-focus-inner{border:0}._mat-animation-noopable.mat-mini-fab{transition:none;animation:none}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button-focus-overlay,.mat-button-ripple.mat-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-ripple.mat-ripple:not(:empty){transform:translateZ(0)}.mat-button-focus-overlay{opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable .mat-button-focus-overlay{transition:none}@media (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:#fff}}@media (-ms-high-contrast:black-on-white){.mat-button-focus-overlay{background-color:#000}}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-flat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*,.mat-stroked-button .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:block;font-size:inherit;width:2.5em;height:2.5em}@media (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"],
                            inputs: ['disabled', 'disableRipple', 'color'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatButton.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["FocusMonitor"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatButton.propDecorators = {
                ripple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatRipple"], { static: false },] }]
            };
            /**
             * Material design anchor button.
             */
            var MatAnchor = /** @class */ (function (_super_1) {
                __extends(MatAnchor, _super_1);
                /**
                 * @param {?} focusMonitor
                 * @param {?} elementRef
                 * @param {?} animationMode
                 */
                function MatAnchor(focusMonitor, elementRef, animationMode) {
                    return _super_1.call(this, elementRef, focusMonitor, animationMode) || this;
                }
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatAnchor.prototype._haltDisabledEvents = function (event) {
                    // A disabled button shouldn't apply any actions
                    if (this.disabled) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                    }
                };
                return MatAnchor;
            }(MatButton));
            MatAnchor.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: "a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab],\n             a[mat-mini-fab], a[mat-stroked-button], a[mat-flat-button]",
                            exportAs: 'matButton, matAnchor',
                            host: {
                                // Note that we ignore the user-specified tabindex when it's disabled for
                                // consistency with the `mat-button` applied on native buttons where even
                                // though they have an index, they're not tabbable.
                                '[attr.tabindex]': 'disabled ? -1 : (tabIndex || 0)',
                                '[attr.disabled]': 'disabled || null',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '(click)': '_haltDisabledEvents($event)',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                            },
                            inputs: ['disabled', 'disableRipple', 'color'],
                            template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span><div matRipple class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"isRoundButton || isIconButton\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"isIconButton\" [matRippleTrigger]=\"_getHostElement()\"></div><div class=\"mat-button-focus-overlay\"></div>",
                            styles: [".mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:.04}@media (hover:none){.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:0}}.mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button[disabled]{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-raised-button::-moz-focus-inner{border:0}._mat-animation-noopable.mat-raised-button{transition:none;animation:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button .mat-button-focus-overlay,.mat-stroked-button .mat-button-ripple.mat-ripple{top:-1px;left:-1px;right:-1px;bottom:-1px}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab::-moz-focus-inner{border:0}.mat-fab[disabled]{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-fab::-moz-focus-inner{border:0}._mat-animation-noopable.mat-fab{transition:none;animation:none}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab[disabled]{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-mini-fab::-moz-focus-inner{border:0}._mat-animation-noopable.mat-mini-fab{transition:none;animation:none}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button-focus-overlay,.mat-button-ripple.mat-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-ripple.mat-ripple:not(:empty){transform:translateZ(0)}.mat-button-focus-overlay{opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable .mat-button-focus-overlay{transition:none}@media (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:#fff}}@media (-ms-high-contrast:black-on-white){.mat-button-focus-overlay{background-color:#000}}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-flat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*,.mat-stroked-button .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:block;font-size:inherit;width:2.5em;height:2.5em}@media (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatAnchor.ctorParameters = function () { return [
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["FocusMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatAnchor.propDecorators = {
                tabIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatButtonModule = /** @class */ (function () {
                function MatButtonModule() {
                }
                return MatButtonModule;
            }());
            MatButtonModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatRippleModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"],
                            ],
                            exports: [
                                MatButton,
                                MatAnchor,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"],
                            ],
                            declarations: [
                                MatButton,
                                MatAnchor,
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=button.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/card.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/card.js ***!
          \********************************************************/
        /*! exports provided: MatCardContent, MatCardTitle, MatCardSubtitle, MatCardActions, MatCardFooter, MatCardImage, MatCardSmImage, MatCardMdImage, MatCardLgImage, MatCardXlImage, MatCardAvatar, MatCard, MatCardHeader, MatCardTitleGroup, MatCardModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardContent", function () { return MatCardContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardTitle", function () { return MatCardTitle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardSubtitle", function () { return MatCardSubtitle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardActions", function () { return MatCardActions; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardFooter", function () { return MatCardFooter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardImage", function () { return MatCardImage; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardSmImage", function () { return MatCardSmImage; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardMdImage", function () { return MatCardMdImage; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardLgImage", function () { return MatCardLgImage; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardXlImage", function () { return MatCardXlImage; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardAvatar", function () { return MatCardAvatar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCard", function () { return MatCard; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardHeader", function () { return MatCardHeader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardTitleGroup", function () { return MatCardTitleGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCardModule", function () { return MatCardModule; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Content of a card, needed as it's used as a selector in the API.
             * \@docs-private
             */
            var MatCardContent = /** @class */ (function () {
                function MatCardContent() {
                }
                return MatCardContent;
            }());
            MatCardContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-card-content',
                            host: { 'class': 'mat-card-content' }
                        },] },
            ];
            /**
             * Title of a card, needed as it's used as a selector in the API.
             * \@docs-private
             */
            var MatCardTitle = /** @class */ (function () {
                function MatCardTitle() {
                }
                return MatCardTitle;
            }());
            MatCardTitle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: "mat-card-title, [mat-card-title], [matCardTitle]",
                            host: {
                                'class': 'mat-card-title'
                            }
                        },] },
            ];
            /**
             * Sub-title of a card, needed as it's used as a selector in the API.
             * \@docs-private
             */
            var MatCardSubtitle = /** @class */ (function () {
                function MatCardSubtitle() {
                }
                return MatCardSubtitle;
            }());
            MatCardSubtitle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: "mat-card-subtitle, [mat-card-subtitle], [matCardSubtitle]",
                            host: {
                                'class': 'mat-card-subtitle'
                            }
                        },] },
            ];
            /**
             * Action section of a card, needed as it's used as a selector in the API.
             * \@docs-private
             */
            var MatCardActions = /** @class */ (function () {
                function MatCardActions() {
                    /**
                     * Position of the actions inside the card.
                     */
                    this.align = 'start';
                }
                return MatCardActions;
            }());
            MatCardActions.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-card-actions',
                            exportAs: 'matCardActions',
                            host: {
                                'class': 'mat-card-actions',
                                '[class.mat-card-actions-align-end]': 'align === "end"',
                            }
                        },] },
            ];
            MatCardActions.propDecorators = {
                align: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * Footer of a card, needed as it's used as a selector in the API.
             * \@docs-private
             */
            var MatCardFooter = /** @class */ (function () {
                function MatCardFooter() {
                }
                return MatCardFooter;
            }());
            MatCardFooter.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-card-footer',
                            host: { 'class': 'mat-card-footer' }
                        },] },
            ];
            /**
             * Image used in a card, needed to add the mat- CSS styling.
             * \@docs-private
             */
            var MatCardImage = /** @class */ (function () {
                function MatCardImage() {
                }
                return MatCardImage;
            }());
            MatCardImage.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-card-image], [matCardImage]',
                            host: { 'class': 'mat-card-image' }
                        },] },
            ];
            /**
             * Image used in a card, needed to add the mat- CSS styling.
             * \@docs-private
             */
            var MatCardSmImage = /** @class */ (function () {
                function MatCardSmImage() {
                }
                return MatCardSmImage;
            }());
            MatCardSmImage.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-card-sm-image], [matCardImageSmall]',
                            host: { 'class': 'mat-card-sm-image' }
                        },] },
            ];
            /**
             * Image used in a card, needed to add the mat- CSS styling.
             * \@docs-private
             */
            var MatCardMdImage = /** @class */ (function () {
                function MatCardMdImage() {
                }
                return MatCardMdImage;
            }());
            MatCardMdImage.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-card-md-image], [matCardImageMedium]',
                            host: { 'class': 'mat-card-md-image' }
                        },] },
            ];
            /**
             * Image used in a card, needed to add the mat- CSS styling.
             * \@docs-private
             */
            var MatCardLgImage = /** @class */ (function () {
                function MatCardLgImage() {
                }
                return MatCardLgImage;
            }());
            MatCardLgImage.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-card-lg-image], [matCardImageLarge]',
                            host: { 'class': 'mat-card-lg-image' }
                        },] },
            ];
            /**
             * Large image used in a card, needed to add the mat- CSS styling.
             * \@docs-private
             */
            var MatCardXlImage = /** @class */ (function () {
                function MatCardXlImage() {
                }
                return MatCardXlImage;
            }());
            MatCardXlImage.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-card-xl-image], [matCardImageXLarge]',
                            host: { 'class': 'mat-card-xl-image' }
                        },] },
            ];
            /**
             * Avatar image used in a card, needed to add the mat- CSS styling.
             * \@docs-private
             */
            var MatCardAvatar = /** @class */ (function () {
                function MatCardAvatar() {
                }
                return MatCardAvatar;
            }());
            MatCardAvatar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-card-avatar], [matCardAvatar]',
                            host: { 'class': 'mat-card-avatar' }
                        },] },
            ];
            /**
             * A basic content container component that adds the styles of a Material design card.
             *
             * While this component can be used alone, it also provides a number
             * of preset styles for common card sections, including:
             * - mat-card-title
             * - mat-card-subtitle
             * - mat-card-content
             * - mat-card-actions
             * - mat-card-footer
             */
            var MatCard = /** @class */ (function () {
                // @breaking-change 9.0.0 `_animationMode` parameter to be made required.
                /**
                 * @param {?=} _animationMode
                 */
                function MatCard(_animationMode) {
                    this._animationMode = _animationMode;
                }
                return MatCard;
            }());
            MatCard.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-card',
                            exportAs: 'matCard',
                            template: "<ng-content></ng-content><ng-content select=\"mat-card-footer\"></ng-content>",
                            styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:block;position:relative;padding:16px;border-radius:4px}._mat-animation-noopable.mat-card{transition:none;animation:none}.mat-card .mat-divider-horizontal{position:absolute;left:0;width:100%}[dir=rtl] .mat-card .mat-divider-horizontal{left:auto;right:0}.mat-card .mat-divider-horizontal.mat-divider-inset{position:static;margin:0}[dir=rtl] .mat-card .mat-divider-horizontal.mat-divider-inset{margin-right:0}@media (-ms-high-contrast:active){.mat-card{outline:solid 1px}}.mat-card-actions,.mat-card-content,.mat-card-subtitle{display:block;margin-bottom:16px}.mat-card-title{display:block;margin-bottom:8px}.mat-card-actions{margin-left:-8px;margin-right:-8px;padding:8px 0}.mat-card-actions-align-end{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 32px);margin:0 -16px 16px -16px}.mat-card-footer{display:block;margin:0 -16px -16px -16px}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button,.mat-card-actions .mat-stroked-button{margin:0 8px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header .mat-card-title{margin-bottom:12px}.mat-card-header-text{margin:0 16px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0;object-fit:cover}.mat-card-title-group{display:flex;justify-content:space-between}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-title-group>.mat-card-xl-image{margin:-8px 0 8px}@media (max-width:599px){.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}}.mat-card-content>:first-child,.mat-card>:first-child{margin-top:0}.mat-card-content>:last-child:not(.mat-card-footer),.mat-card>:last-child:not(.mat-card-footer){margin-bottom:0}.mat-card-image:first-child{margin-top:-16px;border-top-left-radius:inherit;border-top-right-radius:inherit}.mat-card>.mat-card-actions:last-child{margin-bottom:-8px;padding-bottom:0}.mat-card-actions .mat-button:first-child,.mat-card-actions .mat-raised-button:first-child,.mat-card-actions .mat-stroked-button:first-child{margin-left:0;margin-right:0}.mat-card-subtitle:not(:first-child),.mat-card-title:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child){margin-top:-8px}.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            host: {
                                'class': 'mat-card',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatCard.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            /**
             * Component intended to be used within the `<mat-card>` component. It adds styles for a
             * preset header section (i.e. a title, subtitle, and avatar layout).
             * \@docs-private
             */
            var MatCardHeader = /** @class */ (function () {
                function MatCardHeader() {
                }
                return MatCardHeader;
            }());
            MatCardHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-card-header',
                            template: "<ng-content select=\"[mat-card-avatar], [matCardAvatar]\"></ng-content><div class=\"mat-card-header-text\"><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content></ng-content>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            host: { 'class': 'mat-card-header' }
                        },] },
            ];
            /**
             * Component intended to be used within the `<mat-card>` component. It adds styles for a preset
             * layout that groups an image with a title section.
             * \@docs-private
             */
            var MatCardTitleGroup = /** @class */ (function () {
                function MatCardTitleGroup() {
                }
                return MatCardTitleGroup;
            }());
            MatCardTitleGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-card-title-group',
                            template: "<div><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content select=\"img\"></ng-content><ng-content></ng-content>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            host: { 'class': 'mat-card-title-group' }
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatCardModule = /** @class */ (function () {
                function MatCardModule() {
                }
                return MatCardModule;
            }());
            MatCardModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"]],
                            exports: [
                                MatCard,
                                MatCardHeader,
                                MatCardTitleGroup,
                                MatCardContent,
                                MatCardTitle,
                                MatCardSubtitle,
                                MatCardActions,
                                MatCardFooter,
                                MatCardSmImage,
                                MatCardMdImage,
                                MatCardLgImage,
                                MatCardImage,
                                MatCardXlImage,
                                MatCardAvatar,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"],
                            ],
                            declarations: [
                                MatCard, MatCardHeader, MatCardTitleGroup, MatCardContent, MatCardTitle, MatCardSubtitle,
                                MatCardActions, MatCardFooter, MatCardSmImage, MatCardMdImage, MatCardLgImage, MatCardImage,
                                MatCardXlImage, MatCardAvatar,
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=card.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/checkbox.js": 
        /*!************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/checkbox.js ***!
          \************************************************************/
        /*! exports provided: MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR, TransitionCheckState, MatCheckboxChange, MatCheckbox, MAT_CHECKBOX_CLICK_ACTION, _MatCheckboxRequiredValidatorModule, MatCheckboxModule, MAT_CHECKBOX_REQUIRED_VALIDATOR, MatCheckboxRequiredValidator */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR", function () { return MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionCheckState", function () { return TransitionCheckState; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCheckboxChange", function () { return MatCheckboxChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCheckbox", function () { return MatCheckbox; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_CHECKBOX_CLICK_ACTION", function () { return MAT_CHECKBOX_CLICK_ACTION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatCheckboxRequiredValidatorModule", function () { return _MatCheckboxRequiredValidatorModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCheckboxModule", function () { return MatCheckboxModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_CHECKBOX_REQUIRED_VALIDATOR", function () { return MAT_CHECKBOX_REQUIRED_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCheckboxRequiredValidator", function () { return MatCheckboxRequiredValidator; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/observers */ "./node_modules/@angular/cdk/esm2015/observers.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to specify the checkbox click behavior.
             * @type {?}
             */
            var MAT_CHECKBOX_CLICK_ACTION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-checkbox-click-action');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Increasing integer for generating unique ids for checkbox components.
            /** @type {?} */
            var nextUniqueId = 0;
            /**
             * Provider Expression that allows mat-checkbox to register as a ControlValueAccessor.
             * This allows it to support [(ngModel)].
             * \@docs-private
             * @type {?}
             */
            var MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatCheckbox; })),
                multi: true
            };
            /** @enum {number} */
            var TransitionCheckState = {
                /** The initial state of the component before any user interaction. */
                Init: 0,
                /** The state representing the component when it's becoming checked. */
                Checked: 1,
                /** The state representing the component when it's becoming unchecked. */
                Unchecked: 2,
                /** The state representing the component when it's becoming indeterminate. */
                Indeterminate: 3,
            };
            TransitionCheckState[TransitionCheckState.Init] = 'Init';
            TransitionCheckState[TransitionCheckState.Checked] = 'Checked';
            TransitionCheckState[TransitionCheckState.Unchecked] = 'Unchecked';
            TransitionCheckState[TransitionCheckState.Indeterminate] = 'Indeterminate';
            /**
             * Change event object emitted by MatCheckbox.
             */
            var MatCheckboxChange = /** @class */ (function () {
                function MatCheckboxChange() {
                }
                return MatCheckboxChange;
            }());
            // Boilerplate for applying mixins to MatCheckbox.
            /**
             * \@docs-private
             */
            var MatCheckboxBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatCheckboxBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatCheckboxBase;
            }());
            /** @type {?} */
            var _MatCheckboxMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinTabIndex"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinColor"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinDisabled"])(MatCheckboxBase)), 'accent'));
            /**
             * A material design checkbox component. Supports all of the functionality of an HTML5 checkbox,
             * and exposes a similar API. A MatCheckbox can be either checked, unchecked, indeterminate, or
             * disabled. Note that all additional accessibility attributes are taken care of by the component,
             * so there is no need to provide them yourself. However, if you want to omit a label and still
             * have the checkbox be accessible, you may supply an [aria-label] input.
             * See: https://material.io/design/components/selection-controls.html
             */
            var MatCheckbox = /** @class */ (function (_super_1) {
                __extends(MatCheckbox, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} _focusMonitor
                 * @param {?} _ngZone
                 * @param {?} tabIndex
                 * @param {?} _clickAction
                 * @param {?=} _animationMode
                 */
                function MatCheckbox(elementRef, _changeDetectorRef, _focusMonitor, _ngZone, tabIndex, _clickAction, _animationMode) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._focusMonitor = _focusMonitor;
                    _this._ngZone = _ngZone;
                    _this._clickAction = _clickAction;
                    _this._animationMode = _animationMode;
                    /**
                     * Attached to the aria-label attribute of the host element. In most cases, aria-labelledby will
                     * take precedence so this may be omitted.
                     */
                    _this.ariaLabel = '';
                    /**
                     * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
                     */
                    _this.ariaLabelledby = null;
                    _this._uniqueId = "mat-checkbox-" + ++nextUniqueId;
                    /**
                     * A unique id for the checkbox input. If none is supplied, it will be auto-generated.
                     */
                    _this.id = _this._uniqueId;
                    /**
                     * Whether the label should appear after or before the checkbox. Defaults to 'after'
                     */
                    _this.labelPosition = 'after';
                    /**
                     * Name value will be applied to the input element if present
                     */
                    _this.name = null;
                    /**
                     * Event emitted when the checkbox's `checked` value changes.
                     */
                    _this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted when the checkbox's `indeterminate` value changes.
                     */
                    _this.indeterminateChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
                     * \@docs-private
                     */
                    _this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    _this._currentAnimationClass = '';
                    _this._currentCheckState = TransitionCheckState.Init;
                    _this._controlValueAccessorChangeFn = ( /**
                     * @return {?}
                     */function () { });
                    _this._checked = false;
                    _this._disabled = false;
                    _this._indeterminate = false;
                    _this.tabIndex = parseInt(tabIndex) || 0;
                    _this._focusMonitor.monitor(elementRef, true).subscribe(( /**
                     * @param {?} focusOrigin
                     * @return {?}
                     */function (/**
                     * @param {?} focusOrigin
                     * @return {?}
                     */ focusOrigin) {
                        if (!focusOrigin) {
                            // When a focused element becomes disabled, the browser *immediately* fires a blur event.
                            // Angular does not expect events to be raised during change detection, so any state change
                            // (such as a form control's 'ng-touched') will cause a changed-after-checked error.
                            // See https://github.com/angular/angular/issues/17793. To work around this, we defer
                            // telling the form control it has been touched until the next tick.
                            Promise.resolve().then(( /**
                             * @return {?}
                             */function () {
                                _this._onTouched();
                                _changeDetectorRef.markForCheck();
                            }));
                        }
                    }));
                    return _this;
                }
                Object.defineProperty(MatCheckbox.prototype, "inputId", {
                    /**
                     * Returns the unique id for the visual hidden input.
                     * @return {?}
                     */
                    get: function () { return (this.id || this._uniqueId) + "-input"; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCheckbox.prototype, "required", {
                    /**
                     * Whether the checkbox is required.
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                // TODO: Delete next major revision.
                /**
                 * @return {?}
                 */
                MatCheckbox.prototype.ngAfterViewChecked = function () { };
                /**
                 * @return {?}
                 */
                MatCheckbox.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this._elementRef);
                };
                Object.defineProperty(MatCheckbox.prototype, "checked", {
                    /**
                     * Whether the checkbox is checked.
                     * @return {?}
                     */
                    get: function () { return this._checked; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value != this.checked) {
                            this._checked = value;
                            this._changeDetectorRef.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCheckbox.prototype, "disabled", {
                    /**
                     * Whether the checkbox is disabled. This fully overrides the implementation provided by
                     * mixinDisabled, but the mixin is still required because mixinTabIndex requires it.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                        if (newValue !== this.disabled) {
                            this._disabled = newValue;
                            this._changeDetectorRef.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCheckbox.prototype, "indeterminate", {
                    /**
                     * Whether the checkbox is indeterminate. This is also known as "mixed" mode and can be used to
                     * represent a checkbox with three states, e.g. a checkbox that represents a nested list of
                     * checkable items. Note that whenever checkbox is manually clicked, indeterminate is immediately
                     * set to false.
                     * @return {?}
                     */
                    get: function () { return this._indeterminate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var changed = value != this._indeterminate;
                        this._indeterminate = value;
                        if (changed) {
                            if (this._indeterminate) {
                                this._transitionCheckState(TransitionCheckState.Indeterminate);
                            }
                            else {
                                this._transitionCheckState(this.checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
                            }
                            this.indeterminateChange.emit(this._indeterminate);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatCheckbox.prototype._isRippleDisabled = function () {
                    return this.disableRipple || this.disabled;
                };
                /**
                 * Method being called whenever the label text changes.
                 * @return {?}
                 */
                MatCheckbox.prototype._onLabelTextChange = function () {
                    // Since the event of the `cdkObserveContent` directive runs outside of the zone, the checkbox
                    // component will be only marked for check, but no actual change detection runs automatically.
                    // Instead of going back into the zone in order to trigger a change detection which causes
                    // *all* components to be checked (if explicitly marked or not using OnPush), we only trigger
                    // an explicit change detection for the checkbox view and its children.
                    this._changeDetectorRef.detectChanges();
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} value
                 * @return {?}
                 */
                MatCheckbox.prototype.writeValue = function (value) {
                    this.checked = !!value;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatCheckbox.prototype.registerOnChange = function (fn) {
                    this._controlValueAccessorChangeFn = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatCheckbox.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatCheckbox.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                };
                /**
                 * @return {?}
                 */
                MatCheckbox.prototype._getAriaChecked = function () {
                    return this.checked ? 'true' : (this.indeterminate ? 'mixed' : 'false');
                };
                /**
                 * @private
                 * @param {?} newState
                 * @return {?}
                 */
                MatCheckbox.prototype._transitionCheckState = function (newState) {
                    /** @type {?} */
                    var oldState = this._currentCheckState;
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    if (oldState === newState) {
                        return;
                    }
                    if (this._currentAnimationClass.length > 0) {
                        element.classList.remove(this._currentAnimationClass);
                    }
                    this._currentAnimationClass = this._getAnimationClassForCheckStateTransition(oldState, newState);
                    this._currentCheckState = newState;
                    if (this._currentAnimationClass.length > 0) {
                        element.classList.add(this._currentAnimationClass);
                        // Remove the animation class to avoid animation when the checkbox is moved between containers
                        /** @type {?} */
                        var animationClass_1 = this._currentAnimationClass;
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            setTimeout(( /**
                             * @return {?}
                             */function () {
                                element.classList.remove(animationClass_1);
                            }), 1000);
                        }));
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatCheckbox.prototype._emitChangeEvent = function () {
                    /** @type {?} */
                    var event = new MatCheckboxChange();
                    event.source = this;
                    event.checked = this.checked;
                    this._controlValueAccessorChangeFn(this.checked);
                    this.change.emit(event);
                };
                /**
                 * Toggles the `checked` state of the checkbox.
                 * @return {?}
                 */
                MatCheckbox.prototype.toggle = function () {
                    this.checked = !this.checked;
                };
                /**
                 * Event handler for checkbox input element.
                 * Toggles checked state if element is not disabled.
                 * Do not toggle on (change) event since IE doesn't fire change event when
                 *   indeterminate checkbox is clicked.
                 * @param {?} event
                 * @return {?}
                 */
                MatCheckbox.prototype._onInputClick = function (event) {
                    var _this = this;
                    // We have to stop propagation for click events on the visual hidden input element.
                    // By default, when a user clicks on a label element, a generated click event will be
                    // dispatched on the associated input element. Since we are using a label element as our
                    // root container, the click event on the `checkbox` will be executed twice.
                    // The real click event will bubble up, and the generated click event also tries to bubble up.
                    // This will lead to multiple click events.
                    // Preventing bubbling for the second event will solve that issue.
                    event.stopPropagation();
                    // If resetIndeterminate is false, and the current state is indeterminate, do nothing on click
                    if (!this.disabled && this._clickAction !== 'noop') {
                        // When user manually click on the checkbox, `indeterminate` is set to false.
                        if (this.indeterminate && this._clickAction !== 'check') {
                            Promise.resolve().then(( /**
                             * @return {?}
                             */function () {
                                _this._indeterminate = false;
                                _this.indeterminateChange.emit(_this._indeterminate);
                            }));
                        }
                        this.toggle();
                        this._transitionCheckState(this._checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
                        // Emit our custom change event if the native input emitted one.
                        // It is important to only emit it, if the native input triggered one, because
                        // we don't want to trigger a change event, when the `checked` variable changes for example.
                        this._emitChangeEvent();
                    }
                    else if (!this.disabled && this._clickAction === 'noop') {
                        // Reset native input when clicked with noop. The native checkbox becomes checked after
                        // click, reset it to be align with `checked` value of `mat-checkbox`.
                        this._inputElement.nativeElement.checked = this.checked;
                        this._inputElement.nativeElement.indeterminate = this.indeterminate;
                    }
                };
                /**
                 * Focuses the checkbox.
                 * @param {?=} origin
                 * @param {?=} options
                 * @return {?}
                 */
                MatCheckbox.prototype.focus = function (origin, options) {
                    if (origin === void 0) { origin = 'keyboard'; }
                    this._focusMonitor.focusVia(this._inputElement, origin, options);
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatCheckbox.prototype._onInteractionEvent = function (event) {
                    // We always have to stop propagation on the change event.
                    // Otherwise the change event, from the input element, will bubble up and
                    // emit its event object to the `change` output.
                    event.stopPropagation();
                };
                /**
                 * @private
                 * @param {?} oldState
                 * @param {?} newState
                 * @return {?}
                 */
                MatCheckbox.prototype._getAnimationClassForCheckStateTransition = function (oldState, newState) {
                    // Don't transition if animations are disabled.
                    if (this._animationMode === 'NoopAnimations') {
                        return '';
                    }
                    /** @type {?} */
                    var animSuffix = '';
                    switch (oldState) {
                        case TransitionCheckState.Init:
                            // Handle edge case where user interacts with checkbox that does not have [(ngModel)] or
                            // [checked] bound to it.
                            if (newState === TransitionCheckState.Checked) {
                                animSuffix = 'unchecked-checked';
                            }
                            else if (newState == TransitionCheckState.Indeterminate) {
                                animSuffix = 'unchecked-indeterminate';
                            }
                            else {
                                return '';
                            }
                            break;
                        case TransitionCheckState.Unchecked:
                            animSuffix = newState === TransitionCheckState.Checked ?
                                'unchecked-checked' : 'unchecked-indeterminate';
                            break;
                        case TransitionCheckState.Checked:
                            animSuffix = newState === TransitionCheckState.Unchecked ?
                                'checked-unchecked' : 'checked-indeterminate';
                            break;
                        case TransitionCheckState.Indeterminate:
                            animSuffix = newState === TransitionCheckState.Checked ?
                                'indeterminate-checked' : 'indeterminate-unchecked';
                            break;
                    }
                    return "mat-checkbox-anim-" + animSuffix;
                };
                return MatCheckbox;
            }(_MatCheckboxMixinBase));
            MatCheckbox.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-checkbox',
                            template: "<label [attr.for]=\"inputId\" class=\"mat-checkbox-layout\" #label><div class=\"mat-checkbox-inner-container\" [class.mat-checkbox-inner-container-no-side-margin]=\"!checkboxLabel.textContent || !checkboxLabel.textContent.trim()\"><input #input class=\"mat-checkbox-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [checked]=\"checked\" [attr.value]=\"value\" [disabled]=\"disabled\" [attr.name]=\"name\" [tabIndex]=\"tabIndex\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel || null\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-checked]=\"_getAriaChecked()\" (change)=\"_onInteractionEvent($event)\" (click)=\"_onInputClick($event)\"><div matRipple class=\"mat-checkbox-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleRadius]=\"20\" [matRippleCentered]=\"true\" [matRippleAnimation]=\"{enterDuration: 150}\"><div class=\"mat-ripple-element mat-checkbox-persistent-ripple\"></div></div><div class=\"mat-checkbox-frame\"></div><div class=\"mat-checkbox-background\"><svg version=\"1.1\" focusable=\"false\" class=\"mat-checkbox-checkmark\" viewBox=\"0 0 24 24\" xml:space=\"preserve\"><path class=\"mat-checkbox-checkmark-path\" fill=\"none\" stroke=\"white\" d=\"M4.1,12.7 9,17.6 20.3,6.3\"/></svg><div class=\"mat-checkbox-mixedmark\"></div></div></div><span class=\"mat-checkbox-label\" #checkboxLabel (cdkObserveContent)=\"_onLabelTextChange()\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></span></label>",
                            styles: ["@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0,0,.2,.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(.4,0,1,1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}100%,32.8%{opacity:0;transform:scaleX(0)}}.mat-checkbox-background,.mat-checkbox-frame{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);cursor:pointer;-webkit-tap-highlight-color:transparent}._mat-animation-noopable.mat-checkbox{transition:none;animation:none}.mat-checkbox .mat-ripple-element:not(.mat-checkbox-persistent-ripple){opacity:.16}.mat-checkbox-layout{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.mat-checkbox-label{-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.mat-checkbox-inner-container{display:inline-block;height:16px;line-height:0;margin:auto;margin-right:8px;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:16px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-inner-container-no-side-margin{margin-left:0;margin-right:0}.mat-checkbox-frame{background-color:transparent;transition:border-color 90ms cubic-bezier(0,0,.2,.1);border-width:2px;border-style:solid}._mat-animation-noopable .mat-checkbox-frame{transition:none}@media (-ms-high-contrast:active){.mat-checkbox.cdk-keyboard-focused .mat-checkbox-frame{border-style:dotted}}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0,0,.2,.1),opacity 90ms cubic-bezier(0,0,.2,.1)}._mat-animation-noopable .mat-checkbox-background{transition:none}.mat-checkbox-persistent-ripple{width:100%;height:100%;transform:none}.mat-checkbox-inner-container:hover .mat-checkbox-persistent-ripple{opacity:.04}.mat-checkbox.cdk-keyboard-focused .mat-checkbox-persistent-ripple{opacity:.12}.mat-checkbox-persistent-ripple,.mat-checkbox.mat-checkbox-disabled .mat-checkbox-inner-container:hover .mat-checkbox-persistent-ripple{opacity:0}@media (hover:none){.mat-checkbox-inner-container:hover .mat-checkbox-persistent-ripple{display:none}}.mat-checkbox-checkmark{top:0;left:0;right:0;bottom:0;position:absolute;width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.13333px}.mat-checkbox-mixedmark{width:calc(100% - 6px);height:2px;opacity:0;transform:scaleX(0) rotate(0);border-radius:2px}@media (-ms-high-contrast:active){.mat-checkbox-mixedmark{height:0;border-top:solid 2px;margin-top:2px}}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:transparent}.mat-checkbox-disabled{cursor:default}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear 0s mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear 0s mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:.3s linear 0s mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox .mat-checkbox-ripple{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none}"],
                            exportAs: 'matCheckbox',
                            host: {
                                'class': 'mat-checkbox',
                                '[id]': 'id',
                                '[attr.tabindex]': 'null',
                                '[class.mat-checkbox-indeterminate]': 'indeterminate',
                                '[class.mat-checkbox-checked]': 'checked',
                                '[class.mat-checkbox-disabled]': 'disabled',
                                '[class.mat-checkbox-label-before]': 'labelPosition == "before"',
                                '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                            },
                            providers: [MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR],
                            inputs: ['disableRipple', 'color', 'tabIndex'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush
                        },] },
            ];
            /** @nocollapse */
            MatCheckbox.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["FocusMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['tabindex',] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_CHECKBOX_CLICK_ACTION,] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatCheckbox.propDecorators = {
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-labelledby',] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                labelPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                indeterminateChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                _inputElement: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['input', { static: false },] }],
                ripple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatRipple"], { static: false },] }],
                checked: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                indeterminate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAT_CHECKBOX_REQUIRED_VALIDATOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["NG_VALIDATORS"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatCheckboxRequiredValidator; })),
                multi: true
            };
            /**
             * Validator for Material checkbox's required attribute in template-driven checkbox.
             * Current CheckboxRequiredValidator only work with `input type=checkbox` and does not
             * work with `mat-checkbox`.
             */
            var MatCheckboxRequiredValidator = /** @class */ (function (_super_1) {
                __extends(MatCheckboxRequiredValidator, _super_1);
                function MatCheckboxRequiredValidator() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatCheckboxRequiredValidator;
            }(_angular_forms__WEBPACK_IMPORTED_MODULE_3__["CheckboxRequiredValidator"]));
            MatCheckboxRequiredValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: "mat-checkbox[required][formControlName],\n             mat-checkbox[required][formControl], mat-checkbox[required][ngModel]",
                            providers: [MAT_CHECKBOX_REQUIRED_VALIDATOR],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This module is used by both original and MDC-based checkbox implementations.
             */
            // tslint:disable-next-line:class-name
            var _MatCheckboxRequiredValidatorModule = /** @class */ (function () {
                function _MatCheckboxRequiredValidatorModule() {
                }
                return _MatCheckboxRequiredValidatorModule;
            }());
            _MatCheckboxRequiredValidatorModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            exports: [MatCheckboxRequiredValidator],
                            declarations: [MatCheckboxRequiredValidator],
                        },] },
            ];
            var MatCheckboxModule = /** @class */ (function () {
                function MatCheckboxModule() {
                }
                return MatCheckboxModule;
            }());
            MatCheckboxModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_7__["CommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatRippleModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatCommonModule"], _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_6__["ObserversModule"],
                                _MatCheckboxRequiredValidatorModule
                            ],
                            exports: [MatCheckbox, _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatCommonModule"], _MatCheckboxRequiredValidatorModule],
                            declarations: [MatCheckbox],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=checkbox.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/chips.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/chips.js ***!
          \*********************************************************/
        /*! exports provided: MatChipsModule, MatChipListChange, MatChipList, MatChipSelectionChange, MatChipAvatar, MatChipTrailingIcon, MatChip, MatChipRemove, MatChipInput, MAT_CHIPS_DEFAULT_OPTIONS */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipsModule", function () { return MatChipsModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipListChange", function () { return MatChipListChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipList", function () { return MatChipList; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipSelectionChange", function () { return MatChipSelectionChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipAvatar", function () { return MatChipAvatar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipTrailingIcon", function () { return MatChipTrailingIcon; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChip", function () { return MatChip; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipRemove", function () { return MatChipRemove; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatChipInput", function () { return MatChipInput; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_CHIPS_DEFAULT_OPTIONS", function () { return MAT_CHIPS_DEFAULT_OPTIONS; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Event object emitted by MatChip when selected or deselected.
             */
            var MatChipSelectionChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} selected
                 * @param {?=} isUserInput
                 */
                function MatChipSelectionChange(source, selected, isUserInput) {
                    if (isUserInput === void 0) { isUserInput = false; }
                    this.source = source;
                    this.selected = selected;
                    this.isUserInput = isUserInput;
                }
                return MatChipSelectionChange;
            }());
            // Boilerplate for applying mixins to MatChip.
            /**
             * \@docs-private
             */
            var MatChipBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatChipBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatChipBase;
            }());
            /** @type {?} */
            var _MatChipMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinColor"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinDisabled"])(MatChipBase)), 'primary');
            /**
             * Dummy directive to add CSS class to chip avatar.
             * \@docs-private
             */
            var MatChipAvatar = /** @class */ (function () {
                function MatChipAvatar() {
                }
                return MatChipAvatar;
            }());
            MatChipAvatar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'mat-chip-avatar, [matChipAvatar]',
                            host: { 'class': 'mat-chip-avatar' }
                        },] },
            ];
            /**
             * Dummy directive to add CSS class to chip trailing icon.
             * \@docs-private
             */
            var MatChipTrailingIcon = /** @class */ (function () {
                function MatChipTrailingIcon() {
                }
                return MatChipTrailingIcon;
            }());
            MatChipTrailingIcon.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'mat-chip-trailing-icon, [matChipTrailingIcon]',
                            host: { 'class': 'mat-chip-trailing-icon' }
                        },] },
            ];
            /**
             * Material design styled Chip component. Used inside the MatChipList component.
             */
            var MatChip = /** @class */ (function (_super_1) {
                __extends(MatChip, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _ngZone
                 * @param {?} platform
                 * @param {?} globalRippleOptions
                 * @param {?=} animationMode
                 * @param {?=} _changeDetectorRef
                 */
                function MatChip(_elementRef, _ngZone, platform, globalRippleOptions, 
                // @breaking-change 8.0.0 `animationMode` parameter to become required.
                animationMode, _changeDetectorRef) {
                    var _this = _super_1.call(this, _elementRef) || this;
                    _this._elementRef = _elementRef;
                    _this._ngZone = _ngZone;
                    _this._changeDetectorRef = _changeDetectorRef;
                    /**
                     * Whether the chip has focus.
                     */
                    _this._hasFocus = false;
                    /**
                     * Whether the chip list is selectable
                     */
                    _this.chipListSelectable = true;
                    /**
                     * Whether the chip list is in multi-selection mode.
                     */
                    _this._chipListMultiple = false;
                    _this._selected = false;
                    _this._selectable = true;
                    _this._removable = true;
                    /**
                     * Emits when the chip is focused.
                     */
                    _this._onFocus = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                    /**
                     * Emits when the chip is blured.
                     */
                    _this._onBlur = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                    /**
                     * Emitted when the chip is selected or deselected.
                     */
                    _this.selectionChange = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Emitted when the chip is destroyed.
                     */
                    _this.destroyed = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Emitted when a chip is to be removed.
                     */
                    _this.removed = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    _this._addHostClassName();
                    _this._chipRipple = new _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["RippleRenderer"](_this, _ngZone, _elementRef, platform);
                    _this._chipRipple.setupTriggerEvents(_elementRef);
                    _this.rippleConfig = globalRippleOptions || {};
                    _this._animationsDisabled = animationMode === 'NoopAnimations';
                    return _this;
                }
                Object.defineProperty(MatChip.prototype, "rippleDisabled", {
                    /**
                     * Whether ripples are disabled on interaction
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this.disabled || this.disableRipple || !!this.rippleConfig.disabled;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChip.prototype, "selected", {
                    /**
                     * Whether the chip is selected.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var coercedValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                        if (coercedValue !== this._selected) {
                            this._selected = coercedValue;
                            this._dispatchSelectionChange();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChip.prototype, "value", {
                    /**
                     * The value of the chip. Defaults to the content inside `<mat-chip>` tags.
                     * @return {?}
                     */
                    get: function () {
                        return this._value !== undefined
                            ? this._value
                            : this._elementRef.nativeElement.textContent;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._value = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChip.prototype, "selectable", {
                    /**
                     * Whether or not the chip is selectable. When a chip is not selectable,
                     * changes to its selected state are always ignored. By default a chip is
                     * selectable, and it becomes non-selectable if its parent chip list is
                     * not selectable.
                     * @return {?}
                     */
                    get: function () { return this._selectable && this.chipListSelectable; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._selectable = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChip.prototype, "removable", {
                    /**
                     * Determines whether or not the chip displays the remove styling and emits (removed) events.
                     * @return {?}
                     */
                    get: function () { return this._removable; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._removable = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChip.prototype, "ariaSelected", {
                    /**
                     * The ARIA selected applied to the chip.
                     * @return {?}
                     */
                    get: function () {
                        // Remove the `aria-selected` when the chip is deselected in single-selection mode, because
                        // it adds noise to NVDA users where "not selected" will be read out for each chip.
                        return this.selectable && (this._chipListMultiple || this.selected) ?
                            this.selected.toString() : null;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatChip.prototype._addHostClassName = function () {
                    /** @type {?} */
                    var basicChipAttrName = 'mat-basic-chip';
                    /** @type {?} */
                    var element = ( /** @type {?} */(this._elementRef.nativeElement));
                    if (element.hasAttribute(basicChipAttrName) ||
                        element.tagName.toLowerCase() === basicChipAttrName) {
                        element.classList.add(basicChipAttrName);
                        return;
                    }
                    else {
                        element.classList.add('mat-standard-chip');
                    }
                };
                /**
                 * @return {?}
                 */
                MatChip.prototype.ngOnDestroy = function () {
                    this.destroyed.emit({ chip: this });
                    this._chipRipple._removeTriggerEvents();
                };
                /**
                 * Selects the chip.
                 * @return {?}
                 */
                MatChip.prototype.select = function () {
                    if (!this._selected) {
                        this._selected = true;
                        this._dispatchSelectionChange();
                        this._markForCheck();
                    }
                };
                /**
                 * Deselects the chip.
                 * @return {?}
                 */
                MatChip.prototype.deselect = function () {
                    if (this._selected) {
                        this._selected = false;
                        this._dispatchSelectionChange();
                        this._markForCheck();
                    }
                };
                /**
                 * Select this chip and emit selected event
                 * @return {?}
                 */
                MatChip.prototype.selectViaInteraction = function () {
                    if (!this._selected) {
                        this._selected = true;
                        this._dispatchSelectionChange(true);
                        this._markForCheck();
                    }
                };
                /**
                 * Toggles the current selected state of this chip.
                 * @param {?=} isUserInput
                 * @return {?}
                 */
                MatChip.prototype.toggleSelected = function (isUserInput) {
                    if (isUserInput === void 0) { isUserInput = false; }
                    this._selected = !this.selected;
                    this._dispatchSelectionChange(isUserInput);
                    this._markForCheck();
                    return this.selected;
                };
                /**
                 * Allows for programmatic focusing of the chip.
                 * @return {?}
                 */
                MatChip.prototype.focus = function () {
                    if (!this._hasFocus) {
                        this._elementRef.nativeElement.focus();
                        this._onFocus.next({ chip: this });
                    }
                    this._hasFocus = true;
                };
                /**
                 * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
                 * BACKSPACE keys are pressed.
                 *
                 * Informs any listeners of the removal request. Does not remove the chip from the DOM.
                 * @return {?}
                 */
                MatChip.prototype.remove = function () {
                    if (this.removable) {
                        this.removed.emit({ chip: this });
                    }
                };
                /**
                 * Handles click events on the chip.
                 * @param {?} event
                 * @return {?}
                 */
                MatChip.prototype._handleClick = function (event) {
                    if (this.disabled) {
                        event.preventDefault();
                    }
                    else {
                        event.stopPropagation();
                    }
                };
                /**
                 * Handle custom key presses.
                 * @param {?} event
                 * @return {?}
                 */
                MatChip.prototype._handleKeydown = function (event) {
                    if (this.disabled) {
                        return;
                    }
                    switch (event.keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["DELETE"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["BACKSPACE"]:
                            // If we are removable, remove the focused chip
                            this.remove();
                            // Always prevent so page navigation does not occur
                            event.preventDefault();
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["SPACE"]:
                            // If we are selectable, toggle the focused chip
                            if (this.selectable) {
                                this.toggleSelected(true);
                            }
                            // Always prevent space from scrolling the page since the list has focus
                            event.preventDefault();
                            break;
                    }
                };
                /**
                 * @return {?}
                 */
                MatChip.prototype._blur = function () {
                    var _this = this;
                    // When animations are enabled, Angular may end up removing the chip from the DOM a little
                    // earlier than usual, causing it to be blurred and throwing off the logic in the chip list
                    // that moves focus not the next item. To work around the issue, we defer marking the chip
                    // as not focused until the next time the zone stabilizes.
                    this._ngZone.onStable
                        .asObservable()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["take"])(1))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._ngZone.run(( /**
                         * @return {?}
                         */function () {
                            _this._hasFocus = false;
                            _this._onBlur.next({ chip: _this });
                        }));
                    }));
                };
                /**
                 * @private
                 * @param {?=} isUserInput
                 * @return {?}
                 */
                MatChip.prototype._dispatchSelectionChange = function (isUserInput) {
                    if (isUserInput === void 0) { isUserInput = false; }
                    this.selectionChange.emit({
                        source: this,
                        isUserInput: isUserInput,
                        selected: this._selected
                    });
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatChip.prototype._markForCheck = function () {
                    // @breaking-change 9.0.0 Remove this method once the _changeDetectorRef is a required param.
                    if (this._changeDetectorRef) {
                        this._changeDetectorRef.markForCheck();
                    }
                };
                return MatChip;
            }(_MatChipMixinBase));
            MatChip.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]",
                            inputs: ['color', 'disabled', 'disableRipple'],
                            exportAs: 'matChip',
                            host: {
                                'class': 'mat-chip',
                                '[attr.tabindex]': 'disabled ? null : -1',
                                'role': 'option',
                                '[class.mat-chip-selected]': 'selected',
                                '[class.mat-chip-with-avatar]': 'avatar',
                                '[class.mat-chip-with-trailing-icon]': 'trailingIcon || removeIcon',
                                '[class.mat-chip-disabled]': 'disabled',
                                '[class._mat-animation-noopable]': '_animationsDisabled',
                                '[attr.disabled]': 'disabled || null',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '[attr.aria-selected]': 'ariaSelected',
                                '(click)': '_handleClick($event)',
                                '(keydown)': '_handleKeydown($event)',
                                '(focus)': 'focus()',
                                '(blur)': '_blur()',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatChip.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_2__["Platform"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_RIPPLE_GLOBAL_OPTIONS"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__["ANIMATION_MODULE_TYPE"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] }
            ]; };
            MatChip.propDecorators = {
                avatar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChild"], args: [MatChipAvatar, { static: false },] }],
                trailingIcon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChild"], args: [MatChipTrailingIcon, { static: false },] }],
                removeIcon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChild"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["forwardRef"])(( /**
                                         * @return {?}
                                         */function () { return MatChipRemove; })), { static: false },] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                selectable: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                removable: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                selectionChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                destroyed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                removed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }]
            };
            /**
             * Applies proper (click) support and adds styling for use with the Material Design "cancel" icon
             * available at https://material.io/icons/#ic_cancel.
             *
             * Example:
             *
             *     `<mat-chip>
             *       <mat-icon matChipRemove>cancel</mat-icon>
             *     </mat-chip>`
             *
             * You *may* use a custom icon, but you may need to override the `mat-chip-remove` positioning
             * styles to properly center the icon within the chip.
             */
            var MatChipRemove = /** @class */ (function () {
                /**
                 * @param {?} _parentChip
                 */
                function MatChipRemove(_parentChip) {
                    this._parentChip = _parentChip;
                }
                /**
                 * Calls the parent chip's public `remove()` method if applicable.
                 * @param {?} event
                 * @return {?}
                 */
                MatChipRemove.prototype._handleClick = function (event) {
                    /** @type {?} */
                    var parentChip = this._parentChip;
                    if (parentChip.removable && !parentChip.disabled) {
                        parentChip.remove();
                    }
                    // We need to stop event propagation because otherwise the event will bubble up to the
                    // form field and cause the `onContainerClick` method to be invoked. This method would then
                    // reset the focused chip that has been focused after chip removal. Usually the parent
                    // the parent click listener of the `MatChip` would prevent propagation, but it can happen
                    // that the chip is being removed before the event bubbles up.
                    event.stopPropagation();
                };
                return MatChipRemove;
            }());
            MatChipRemove.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: '[matChipRemove]',
                            host: {
                                'class': 'mat-chip-remove mat-chip-trailing-icon',
                                '(click)': '_handleClick($event)',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatChipRemove.ctorParameters = function () { return [
                { type: MatChip }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token to be used to override the default options for the chips module.
             * @type {?}
             */
            var MAT_CHIPS_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('mat-chips-default-options');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatChipList.
            /**
             * \@docs-private
             */
            var MatChipListBase = /** @class */ (function () {
                /**
                 * @param {?} _defaultErrorStateMatcher
                 * @param {?} _parentForm
                 * @param {?} _parentFormGroup
                 * @param {?} ngControl
                 */
                function MatChipListBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
                    this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
                    this._parentForm = _parentForm;
                    this._parentFormGroup = _parentFormGroup;
                    this.ngControl = ngControl;
                }
                return MatChipListBase;
            }());
            /** @type {?} */
            var _MatChipListMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinErrorState"])(MatChipListBase);
            // Increasing integer for generating unique ids for chip-list components.
            /** @type {?} */
            var nextUniqueId = 0;
            /**
             * Change event object that is emitted when the chip list value has changed.
             */
            var MatChipListChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} value
                 */
                function MatChipListChange(source, value) {
                    this.source = source;
                    this.value = value;
                }
                return MatChipListChange;
            }());
            /**
             * A material design chips component (named ChipList for its similarity to the List component).
             */
            var MatChipList = /** @class */ (function (_super_1) {
                __extends(MatChipList, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} _dir
                 * @param {?} _parentForm
                 * @param {?} _parentFormGroup
                 * @param {?} _defaultErrorStateMatcher
                 * @param {?} ngControl
                 */
                function MatChipList(_elementRef, _changeDetectorRef, _dir, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, ngControl) {
                    var _this = _super_1.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
                    _this._elementRef = _elementRef;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._dir = _dir;
                    _this.ngControl = ngControl;
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     */
                    _this.controlType = 'mat-chip-list';
                    /**
                     * When a chip is destroyed, we store the index of the destroyed chip until the chips
                     * query list notifies about the update. This is necessary because we cannot determine an
                     * appropriate chip that should receive focus until the array of chips updated completely.
                     */
                    _this._lastDestroyedChipIndex = null;
                    /**
                     * Subject that emits when the component has been destroyed.
                     */
                    _this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                    /**
                     * Uid of the chip list
                     */
                    _this._uid = "mat-chip-list-" + nextUniqueId++;
                    /**
                     * Tab index for the chip list.
                     */
                    _this._tabIndex = 0;
                    /**
                     * User defined tab index.
                     * When it is not null, use user defined tab index. Otherwise use _tabIndex
                     */
                    _this._userTabIndex = null;
                    /**
                     * Function when touched
                     */
                    _this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * Function when changed
                     */
                    _this._onChange = ( /**
                     * @return {?}
                     */function () { });
                    _this._multiple = false;
                    _this._compareWith = ( /**
                     * @param {?} o1
                     * @param {?} o2
                     * @return {?}
                     */function (o1, o2) { return o1 === o2; });
                    _this._required = false;
                    _this._disabled = false;
                    /**
                     * Orientation of the chip list.
                     */
                    _this.ariaOrientation = 'horizontal';
                    _this._selectable = true;
                    /**
                     * Event emitted when the selected chip list value has been changed by the user.
                     */
                    _this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event that emits whenever the raw value of the chip-list changes. This is here primarily
                     * to facilitate the two-way binding for the `value` input.
                     * \@docs-private
                     */
                    _this.valueChange = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    if (_this.ngControl) {
                        _this.ngControl.valueAccessor = _this;
                    }
                    return _this;
                }
                Object.defineProperty(MatChipList.prototype, "selected", {
                    /**
                     * The array of selected chips inside chip list.
                     * @return {?}
                     */
                    get: function () {
                        return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "role", {
                    /**
                     * The ARIA role applied to the chip list.
                     * @return {?}
                     */
                    get: function () { return this.empty ? null : 'listbox'; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "multiple", {
                    /**
                     * Whether the user should be allowed to select multiple chips.
                     * @return {?}
                     */
                    get: function () { return this._multiple; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._multiple = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                        this._syncChipsState();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "compareWith", {
                    /**
                     * A function to compare the option values with the selected values. The first argument
                     * is a value from an option. The second is a value from the selection. A boolean
                     * should be returned.
                     * @return {?}
                     */
                    get: function () { return this._compareWith; },
                    /**
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        this._compareWith = fn;
                        if (this._selectionModel) {
                            // A different comparator means the selection could change.
                            this._initializeSelection();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "value", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this.writeValue(value);
                        this._value = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "id", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this._chipInput ? this._chipInput.id : this._uid;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "required", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                        this.stateChanges.next();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "placeholder", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this._chipInput ? this._chipInput.placeholder : this._placeholder;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._placeholder = value;
                        this.stateChanges.next();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "focused", {
                    /**
                     * Whether any chips or the matChipInput inside of this chip-list has focus.
                     * @return {?}
                     */
                    get: function () {
                        return (this._chipInput && this._chipInput.focused) || this._hasFocusedChip();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "empty", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return (!this._chipInput || this._chipInput.empty) && this.chips.length === 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "shouldLabelFloat", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return !this.empty || this.focused; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "disabled", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this.ngControl ? !!this.ngControl.disabled : this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                        this._syncChipsState();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "selectable", {
                    /**
                     * Whether or not this chip list is selectable. When a chip list is not selectable,
                     * the selected states for all the chips inside the chip list are always ignored.
                     * @return {?}
                     */
                    get: function () { return this._selectable; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        var _this = this;
                        this._selectable = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value);
                        if (this.chips) {
                            this.chips.forEach(( /**
                             * @param {?} chip
                             * @return {?}
                             */function (/**
                             * @param {?} chip
                             * @return {?}
                             */ chip) { return chip.chipListSelectable = _this._selectable; }));
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "tabIndex", {
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._userTabIndex = value;
                        this._tabIndex = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "chipSelectionChanges", {
                    /**
                     * Combined stream of all of the child chips' selection change events.
                     * @return {?}
                     */
                    get: function () {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"]).apply(void 0, this.chips.map(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) { return chip.selectionChange; })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "chipFocusChanges", {
                    /**
                     * Combined stream of all of the child chips' focus change events.
                     * @return {?}
                     */
                    get: function () {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"]).apply(void 0, this.chips.map(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) { return chip._onFocus; })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "chipBlurChanges", {
                    /**
                     * Combined stream of all of the child chips' blur change events.
                     * @return {?}
                     */
                    get: function () {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"]).apply(void 0, this.chips.map(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) { return chip._onBlur; })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipList.prototype, "chipRemoveChanges", {
                    /**
                     * Combined stream of all of the child chips' remove change events.
                     * @return {?}
                     */
                    get: function () {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"]).apply(void 0, this.chips.map(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) { return chip.destroyed; })));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatChipList.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_8__["FocusKeyManager"](this.chips)
                        .withWrap()
                        .withVerticalOrientation()
                        .withHorizontalOrientation(this._dir ? this._dir.value : 'ltr');
                    if (this._dir) {
                        this._dir.change
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["takeUntil"])(this._destroyed))
                            .subscribe(( /**
                     * @param {?} dir
                     * @return {?}
                     */function (/**
                     * @param {?} dir
                     * @return {?}
                     */ dir) { return _this._keyManager.withHorizontalOrientation(dir); }));
                    }
                    this._keyManager.tabOut.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._allowFocusEscape();
                    }));
                    // When the list changes, re-subscribe
                    this.chips.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["startWith"])(null), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () {
                        if (_this.disabled) {
                            // Since this happens after the content has been
                            // checked, we need to defer it to the next tick.
                            Promise.resolve().then(( /**
                             * @return {?}
                             */function () {
                                _this._syncChipsState();
                            }));
                        }
                        _this._resetChips();
                        // Reset chips selected/deselected status
                        _this._initializeSelection();
                        // Check to see if we need to update our tab index
                        _this._updateTabIndex();
                        // Check to see if we have a destroyed chip and need to refocus
                        _this._updateFocusForDestroyedChips();
                        _this.stateChanges.next();
                    }));
                };
                /**
                 * @return {?}
                 */
                MatChipList.prototype.ngOnInit = function () {
                    this._selectionModel = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_10__["SelectionModel"](this.multiple, undefined, false);
                    this.stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatChipList.prototype.ngDoCheck = function () {
                    if (this.ngControl) {
                        // We need to re-evaluate this on every change detection cycle, because there are some
                        // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                        // that whatever logic is in here has to be super lean or we risk destroying the performance.
                        this.updateErrorState();
                    }
                };
                /**
                 * @return {?}
                 */
                MatChipList.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                    this.stateChanges.complete();
                    this._dropSubscriptions();
                };
                /**
                 * Associates an HTML input element with this chip list.
                 * @param {?} inputElement
                 * @return {?}
                 */
                MatChipList.prototype.registerInput = function (inputElement) {
                    this._chipInput = inputElement;
                };
                /**
                 * Implemented as part of MatFormFieldControl.
                 * \@docs-private
                 * @param {?} ids
                 * @return {?}
                 */
                MatChipList.prototype.setDescribedByIds = function (ids) { this._ariaDescribedby = ids.join(' '); };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} value
                 * @return {?}
                 */
                MatChipList.prototype.writeValue = function (value) {
                    if (this.chips) {
                        this._setSelectionByValue(value, false);
                    }
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatChipList.prototype.registerOnChange = function (fn) {
                    this._onChange = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatChipList.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatChipList.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                    this.stateChanges.next();
                };
                /**
                 * Implemented as part of MatFormFieldControl.
                 * \@docs-private
                 * @param {?} event
                 * @return {?}
                 */
                MatChipList.prototype.onContainerClick = function (event) {
                    if (!this._originatesFromChip(event)) {
                        this.focus();
                    }
                };
                /**
                 * Focuses the first non-disabled chip in this chip list, or the associated input when there
                 * are no eligible chips.
                 * @param {?=} options
                 * @return {?}
                 */
                MatChipList.prototype.focus = function (options) {
                    if (this.disabled) {
                        return;
                    }
                    // TODO: ARIA says this should focus the first `selected` chip if any are selected.
                    // Focus on first element if there's no chipInput inside chip-list
                    if (this._chipInput && this._chipInput.focused) {
                        // do nothing
                    }
                    else if (this.chips.length > 0) {
                        this._keyManager.setFirstItemActive();
                        this.stateChanges.next();
                    }
                    else {
                        this._focusInput(options);
                        this.stateChanges.next();
                    }
                };
                /**
                 * Attempt to focus an input if we have one.
                 * @param {?=} options
                 * @return {?}
                 */
                MatChipList.prototype._focusInput = function (options) {
                    if (this._chipInput) {
                        this._chipInput.focus(options);
                    }
                };
                /**
                 * Pass events to the keyboard manager. Available here for tests.
                 * @param {?} event
                 * @return {?}
                 */
                MatChipList.prototype._keydown = function (event) {
                    /** @type {?} */
                    var target = ( /** @type {?} */(event.target));
                    // If they are on an empty input and hit backspace, focus the last chip
                    if (event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["BACKSPACE"] && this._isInputEmpty(target)) {
                        this._keyManager.setLastItemActive();
                        event.preventDefault();
                    }
                    else if (target && target.classList.contains('mat-chip')) {
                        if (event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["HOME"]) {
                            this._keyManager.setFirstItemActive();
                            event.preventDefault();
                        }
                        else if (event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["END"]) {
                            this._keyManager.setLastItemActive();
                            event.preventDefault();
                        }
                        else {
                            this._keyManager.onKeydown(event);
                        }
                        this.stateChanges.next();
                    }
                };
                /**
                 * Check the tab index as you should not be allowed to focus an empty list.
                 * @protected
                 * @return {?}
                 */
                MatChipList.prototype._updateTabIndex = function () {
                    // If we have 0 chips, we should not allow keyboard focus
                    this._tabIndex = this._userTabIndex || (this.chips.length === 0 ? -1 : 0);
                };
                /**
                 * If the amount of chips changed, we need to update the
                 * key manager state and focus the next closest chip.
                 * @protected
                 * @return {?}
                 */
                MatChipList.prototype._updateFocusForDestroyedChips = function () {
                    // Move focus to the closest chip. If no other chips remain, focus the chip-list itself.
                    if (this._lastDestroyedChipIndex != null) {
                        if (this.chips.length) {
                            /** @type {?} */
                            var newChipIndex = Math.min(this._lastDestroyedChipIndex, this.chips.length - 1);
                            this._keyManager.setActiveItem(newChipIndex);
                        }
                        else {
                            this.focus();
                        }
                    }
                    this._lastDestroyedChipIndex = null;
                };
                /**
                 * Utility to ensure all indexes are valid.
                 *
                 * @private
                 * @param {?} index The index to be checked.
                 * @return {?} True if the index is valid for our list of chips.
                 */
                MatChipList.prototype._isValidIndex = function (index) {
                    return index >= 0 && index < this.chips.length;
                };
                /**
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                MatChipList.prototype._isInputEmpty = function (element) {
                    if (element && element.nodeName.toLowerCase() === 'input') {
                        /** @type {?} */
                        var input = ( /** @type {?} */(element));
                        return !input.value;
                    }
                    return false;
                };
                /**
                 * @param {?} value
                 * @param {?=} isUserInput
                 * @return {?}
                 */
                MatChipList.prototype._setSelectionByValue = function (value, isUserInput) {
                    var _this = this;
                    if (isUserInput === void 0) { isUserInput = true; }
                    this._clearSelection();
                    this.chips.forEach(( /**
                     * @param {?} chip
                     * @return {?}
                     */function (/**
                     * @param {?} chip
                     * @return {?}
                     */ chip) { return chip.deselect(); }));
                    if (Array.isArray(value)) {
                        value.forEach(( /**
                         * @param {?} currentValue
                         * @return {?}
                         */function (/**
                         * @param {?} currentValue
                         * @return {?}
                         */ currentValue) { return _this._selectValue(currentValue, isUserInput); }));
                        this._sortValues();
                    }
                    else {
                        /** @type {?} */
                        var correspondingChip = this._selectValue(value, isUserInput);
                        // Shift focus to the active item. Note that we shouldn't do this in multiple
                        // mode, because we don't know what chip the user interacted with last.
                        if (correspondingChip) {
                            if (isUserInput) {
                                this._keyManager.setActiveItem(correspondingChip);
                            }
                        }
                    }
                };
                /**
                 * Finds and selects the chip based on its value.
                 * @private
                 * @param {?} value
                 * @param {?=} isUserInput
                 * @return {?} Chip that has the corresponding value.
                 */
                MatChipList.prototype._selectValue = function (value, isUserInput) {
                    var _this = this;
                    if (isUserInput === void 0) { isUserInput = true; }
                    /** @type {?} */
                    var correspondingChip = this.chips.find(( /**
                     * @param {?} chip
                     * @return {?}
                     */function (/**
                     * @param {?} chip
                     * @return {?}
                     */ chip) {
                        return chip.value != null && _this._compareWith(chip.value, value);
                    }));
                    if (correspondingChip) {
                        isUserInput ? correspondingChip.selectViaInteraction() : correspondingChip.select();
                        this._selectionModel.select(correspondingChip);
                    }
                    return correspondingChip;
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._initializeSelection = function () {
                    var _this = this;
                    // Defer setting the value in order to avoid the "Expression
                    // has changed after it was checked" errors from Angular.
                    Promise.resolve().then(( /**
                     * @return {?}
                     */function () {
                        if (_this.ngControl || _this._value) {
                            _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value, false);
                            _this.stateChanges.next();
                        }
                    }));
                };
                /**
                 * Deselects every chip in the list.
                 * @private
                 * @param {?=} skip Chip that should not be deselected.
                 * @return {?}
                 */
                MatChipList.prototype._clearSelection = function (skip) {
                    this._selectionModel.clear();
                    this.chips.forEach(( /**
                     * @param {?} chip
                     * @return {?}
                     */function (/**
                     * @param {?} chip
                     * @return {?}
                     */ chip) {
                        if (chip !== skip) {
                            chip.deselect();
                        }
                    }));
                    this.stateChanges.next();
                };
                /**
                 * Sorts the model values, ensuring that they keep the same
                 * order that they have in the panel.
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._sortValues = function () {
                    var _this = this;
                    if (this._multiple) {
                        this._selectionModel.clear();
                        this.chips.forEach(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) {
                            if (chip.selected) {
                                _this._selectionModel.select(chip);
                            }
                        }));
                        this.stateChanges.next();
                    }
                };
                /**
                 * Emits change event to set the model value.
                 * @private
                 * @param {?=} fallbackValue
                 * @return {?}
                 */
                MatChipList.prototype._propagateChanges = function (fallbackValue) {
                    /** @type {?} */
                    var valueToEmit = null;
                    if (Array.isArray(this.selected)) {
                        valueToEmit = this.selected.map(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) { return chip.value; }));
                    }
                    else {
                        valueToEmit = this.selected ? this.selected.value : fallbackValue;
                    }
                    this._value = valueToEmit;
                    this.change.emit(new MatChipListChange(this, valueToEmit));
                    this.valueChange.emit(valueToEmit);
                    this._onChange(valueToEmit);
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * When blurred, mark the field as touched when focus moved outside the chip list.
                 * @return {?}
                 */
                MatChipList.prototype._blur = function () {
                    var _this = this;
                    if (!this._hasFocusedChip()) {
                        this._keyManager.setActiveItem(-1);
                    }
                    if (!this.disabled) {
                        if (this._chipInput) {
                            // If there's a chip input, we should check whether the focus moved to chip input.
                            // If the focus is not moved to chip input, mark the field as touched. If the focus moved
                            // to chip input, do nothing.
                            // Timeout is needed to wait for the focus() event trigger on chip input.
                            setTimeout(( /**
                             * @return {?}
                             */function () {
                                if (!_this.focused) {
                                    _this._markAsTouched();
                                }
                            }));
                        }
                        else {
                            // If there's no chip input, then mark the field as touched.
                            this._markAsTouched();
                        }
                    }
                };
                /**
                 * Mark the field as touched
                 * @return {?}
                 */
                MatChipList.prototype._markAsTouched = function () {
                    this._onTouched();
                    this._changeDetectorRef.markForCheck();
                    this.stateChanges.next();
                };
                /**
                 * Removes the `tabindex` from the chip list and resets it back afterwards, allowing the
                 * user to tab out of it. This prevents the list from capturing focus and redirecting
                 * it back to the first chip, creating a focus trap, if it user tries to tab away.
                 * @return {?}
                 */
                MatChipList.prototype._allowFocusEscape = function () {
                    var _this = this;
                    if (this._tabIndex !== -1) {
                        this._tabIndex = -1;
                        setTimeout(( /**
                         * @return {?}
                         */function () {
                            _this._tabIndex = _this._userTabIndex || 0;
                            _this._changeDetectorRef.markForCheck();
                        }));
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._resetChips = function () {
                    this._dropSubscriptions();
                    this._listenToChipsFocus();
                    this._listenToChipsSelection();
                    this._listenToChipsRemoved();
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._dropSubscriptions = function () {
                    if (this._chipFocusSubscription) {
                        this._chipFocusSubscription.unsubscribe();
                        this._chipFocusSubscription = null;
                    }
                    if (this._chipBlurSubscription) {
                        this._chipBlurSubscription.unsubscribe();
                        this._chipBlurSubscription = null;
                    }
                    if (this._chipSelectionSubscription) {
                        this._chipSelectionSubscription.unsubscribe();
                        this._chipSelectionSubscription = null;
                    }
                    if (this._chipRemoveSubscription) {
                        this._chipRemoveSubscription.unsubscribe();
                        this._chipRemoveSubscription = null;
                    }
                };
                /**
                 * Listens to user-generated selection events on each chip.
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._listenToChipsSelection = function () {
                    var _this = this;
                    this._chipSelectionSubscription = this.chipSelectionChanges.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        event.source.selected
                            ? _this._selectionModel.select(event.source)
                            : _this._selectionModel.deselect(event.source);
                        // For single selection chip list, make sure the deselected value is unselected.
                        if (!_this.multiple) {
                            _this.chips.forEach(( /**
                             * @param {?} chip
                             * @return {?}
                             */function (/**
                             * @param {?} chip
                             * @return {?}
                             */ chip) {
                                if (!_this._selectionModel.isSelected(chip) && chip.selected) {
                                    chip.deselect();
                                }
                            }));
                        }
                        if (event.isUserInput) {
                            _this._propagateChanges();
                        }
                    }));
                };
                /**
                 * Listens to user-generated selection events on each chip.
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._listenToChipsFocus = function () {
                    var _this = this;
                    this._chipFocusSubscription = this.chipFocusChanges.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        /** @type {?} */
                        var chipIndex = _this.chips.toArray().indexOf(event.chip);
                        if (_this._isValidIndex(chipIndex)) {
                            _this._keyManager.updateActiveItemIndex(chipIndex);
                        }
                        _this.stateChanges.next();
                    }));
                    this._chipBlurSubscription = this.chipBlurChanges.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._blur();
                        _this.stateChanges.next();
                    }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._listenToChipsRemoved = function () {
                    var _this = this;
                    this._chipRemoveSubscription = this.chipRemoveChanges.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        /** @type {?} */
                        var chip = event.chip;
                        /** @type {?} */
                        var chipIndex = _this.chips.toArray().indexOf(event.chip);
                        // In case the chip that will be removed is currently focused, we temporarily store
                        // the index in order to be able to determine an appropriate sibling chip that will
                        // receive focus.
                        if (_this._isValidIndex(chipIndex) && chip._hasFocus) {
                            _this._lastDestroyedChipIndex = chipIndex;
                        }
                    }));
                };
                /**
                 * Checks whether an event comes from inside a chip element.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                MatChipList.prototype._originatesFromChip = function (event) {
                    /** @type {?} */
                    var currentElement = ( /** @type {?} */(event.target));
                    while (currentElement && currentElement !== this._elementRef.nativeElement) {
                        if (currentElement.classList.contains('mat-chip')) {
                            return true;
                        }
                        currentElement = currentElement.parentElement;
                    }
                    return false;
                };
                /**
                 * Checks whether any of the chips is focused.
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._hasFocusedChip = function () {
                    return this.chips.some(( /**
                     * @param {?} chip
                     * @return {?}
                     */function (/**
                     * @param {?} chip
                     * @return {?}
                     */ chip) { return chip._hasFocus; }));
                };
                /**
                 * Syncs the list's state with the individual chips.
                 * @private
                 * @return {?}
                 */
                MatChipList.prototype._syncChipsState = function () {
                    var _this = this;
                    if (this.chips) {
                        this.chips.forEach(( /**
                         * @param {?} chip
                         * @return {?}
                         */function (/**
                         * @param {?} chip
                         * @return {?}
                         */ chip) {
                            chip.disabled = _this._disabled;
                            chip._chipListMultiple = _this.multiple;
                        }));
                    }
                };
                return MatChipList;
            }(_MatChipListMixinBase));
            MatChipList.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'mat-chip-list',
                            template: "<div class=\"mat-chip-list-wrapper\"><ng-content></ng-content></div>",
                            exportAs: 'matChipList',
                            host: {
                                '[attr.tabindex]': 'disabled ? null : _tabIndex',
                                '[attr.aria-describedby]': '_ariaDescribedby || null',
                                '[attr.aria-required]': 'required.toString()',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '[attr.aria-invalid]': 'errorState',
                                '[attr.aria-multiselectable]': 'multiple',
                                '[attr.role]': 'role',
                                '[class.mat-chip-list-disabled]': 'disabled',
                                '[class.mat-chip-list-invalid]': 'errorState',
                                '[class.mat-chip-list-required]': 'required',
                                '[attr.aria-orientation]': 'ariaOrientation',
                                'class': 'mat-chip-list',
                                '(focus)': 'focus()',
                                '(blur)': '_blur()',
                                '(keydown)': '_keydown($event)',
                                '[id]': '_uid',
                            },
                            providers: [{ provide: _angular_material_form_field__WEBPACK_IMPORTED_MODULE_12__["MatFormFieldControl"], useExisting: MatChipList }],
                            styles: [".mat-chip{position:relative;overflow:hidden;box-sizing:border-box;-webkit-tap-highlight-color:transparent;transform:translateZ(0)}.mat-standard-chip{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px}._mat-animation-noopable.mat-standard-chip{transition:none;animation:none}.mat-standard-chip .mat-chip-remove.mat-icon{width:18px;height:18px}.mat-standard-chip::after{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:inherit;opacity:0;content:'';pointer-events:none;transition:opacity .2s cubic-bezier(.35,0,.25,1)}.mat-standard-chip:hover::after{opacity:.12}.mat-standard-chip:focus{outline:0}.mat-standard-chip:focus::after{opacity:.16}@media (-ms-high-contrast:active){.mat-standard-chip{outline:solid 1px}.mat-standard-chip:focus{outline:dotted 2px}}.mat-standard-chip.mat-chip-disabled::after{opacity:0}.mat-standard-chip.mat-chip-disabled .mat-chip-remove,.mat-standard-chip.mat-chip-disabled .mat-chip-trailing-icon{cursor:default}.mat-standard-chip.mat-chip-with-avatar,.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-top:0;padding-bottom:0}.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-right:8px;padding-left:0}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-left:8px;padding-right:0}.mat-standard-chip.mat-chip-with-trailing-icon{padding-top:7px;padding-bottom:7px;padding-right:8px;padding-left:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon{padding-left:8px;padding-right:12px}.mat-standard-chip.mat-chip-with-avatar{padding-left:0;padding-right:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-avatar{padding-right:0;padding-left:12px}.mat-standard-chip .mat-chip-avatar{width:24px;height:24px;margin-right:8px;margin-left:4px}[dir=rtl] .mat-standard-chip .mat-chip-avatar{margin-left:8px;margin-right:4px}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{width:18px;height:18px;cursor:pointer}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{margin-left:8px;margin-right:0}[dir=rtl] .mat-standard-chip .mat-chip-remove,[dir=rtl] .mat-standard-chip .mat-chip-trailing-icon{margin-right:8px;margin-left:0}.mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin:-4px}.mat-chip-list-wrapper .mat-standard-chip,.mat-chip-list-wrapper input.mat-input-element{margin:4px}.mat-chip-list-stacked .mat-chip-list-wrapper{flex-direction:column;align-items:flex-start}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-standard-chip{width:100%}.mat-chip-avatar{border-radius:50%;justify-content:center;align-items:center;display:flex;overflow:hidden;object-fit:cover}input.mat-chip-input{width:150px;margin:4px;flex:1 0 150px}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush
                        },] },
            ];
            /** @nocollapse */
            MatChipList.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_9__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_11__["NgForm"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_11__["FormGroupDirective"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["ErrorStateMatcher"] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_11__["NgControl"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Self"] }] }
            ]; };
            MatChipList.propDecorators = {
                errorStateMatcher: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                multiple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                compareWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                placeholder: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                ariaOrientation: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['aria-orientation',] }],
                selectable: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                tabIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                valueChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                chips: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [MatChip, {
                                // We need to use `descendants: true`, because Ivy will no longer match
                                // indirect descendants if it's left as false.
                                descendants: true
                            },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Increasing integer for generating unique ids.
            /** @type {?} */
            var nextUniqueId$1 = 0;
            /**
             * Directive that adds chip-specific behaviors to an input element inside `<mat-form-field>`.
             * May be placed inside or outside of an `<mat-chip-list>`.
             */
            var MatChipInput = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _defaultOptions
                 */
                function MatChipInput(_elementRef, _defaultOptions) {
                    this._elementRef = _elementRef;
                    this._defaultOptions = _defaultOptions;
                    /**
                     * Whether the control is focused.
                     */
                    this.focused = false;
                    this._addOnBlur = false;
                    /**
                     * The list of key codes that will trigger a chipEnd event.
                     *
                     * Defaults to `[ENTER]`.
                     */
                    this.separatorKeyCodes = this._defaultOptions.separatorKeyCodes;
                    /**
                     * Emitted when a chip is to be added.
                     */
                    this.chipEnd = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * The input's placeholder text.
                     */
                    this.placeholder = '';
                    /**
                     * Unique id for the input.
                     */
                    this.id = "mat-chip-list-input-" + nextUniqueId$1++;
                    this._disabled = false;
                    this._inputElement = ( /** @type {?} */(this._elementRef.nativeElement));
                }
                Object.defineProperty(MatChipInput.prototype, "chipList", {
                    /**
                     * Register input for chip list
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value) {
                            this._chipList = value;
                            this._chipList.registerInput(this);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipInput.prototype, "addOnBlur", {
                    /**
                     * Whether or not the chipEnd event will be emitted when the input is blurred.
                     * @return {?}
                     */
                    get: function () { return this._addOnBlur; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._addOnBlur = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipInput.prototype, "disabled", {
                    /**
                     * Whether the input is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled || (this._chipList && this._chipList.disabled); },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatChipInput.prototype, "empty", {
                    /**
                     * Whether the input is empty.
                     * @return {?}
                     */
                    get: function () { return !this._inputElement.value; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatChipInput.prototype.ngOnChanges = function () {
                    this._chipList.stateChanges.next();
                };
                /**
                 * Utility method to make host definition/tests more clear.
                 * @param {?=} event
                 * @return {?}
                 */
                MatChipInput.prototype._keydown = function (event) {
                    // Allow the user's focus to escape when they're tabbing forward. Note that we don't
                    // want to do this when going backwards, because focus should go back to the first chip.
                    if (event && event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["TAB"] && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["hasModifierKey"])(event, 'shiftKey')) {
                        this._chipList._allowFocusEscape();
                    }
                    this._emitChipEnd(event);
                };
                /**
                 * Checks to see if the blur should emit the (chipEnd) event.
                 * @return {?}
                 */
                MatChipInput.prototype._blur = function () {
                    if (this.addOnBlur) {
                        this._emitChipEnd();
                    }
                    this.focused = false;
                    // Blur the chip list if it is not focused
                    if (!this._chipList.focused) {
                        this._chipList._blur();
                    }
                    this._chipList.stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatChipInput.prototype._focus = function () {
                    this.focused = true;
                    this._chipList.stateChanges.next();
                };
                /**
                 * Checks to see if the (chipEnd) event needs to be emitted.
                 * @param {?=} event
                 * @return {?}
                 */
                MatChipInput.prototype._emitChipEnd = function (event) {
                    if (!this._inputElement.value && !!event) {
                        this._chipList._keydown(event);
                    }
                    if (!event || this._isSeparatorKey(event)) {
                        this.chipEnd.emit({ input: this._inputElement, value: this._inputElement.value });
                        if (event) {
                            event.preventDefault();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                MatChipInput.prototype._onInput = function () {
                    // Let chip list know whenever the value changes.
                    this._chipList.stateChanges.next();
                };
                /**
                 * Focuses the input.
                 * @param {?=} options
                 * @return {?}
                 */
                MatChipInput.prototype.focus = function (options) {
                    this._inputElement.focus(options);
                };
                /**
                 * Checks whether a keycode is one of the configured separators.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                MatChipInput.prototype._isSeparatorKey = function (event) {
                    if (Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["hasModifierKey"])(event)) {
                        return false;
                    }
                    /** @type {?} */
                    var separators = this.separatorKeyCodes;
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    return Array.isArray(separators) ? separators.indexOf(keyCode) > -1 : separators.has(keyCode);
                };
                return MatChipInput;
            }());
            MatChipInput.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'input[matChipInputFor]',
                            exportAs: 'matChipInput, matChipInputFor',
                            host: {
                                'class': 'mat-chip-input mat-input-element',
                                '(keydown)': '_keydown($event)',
                                '(blur)': '_blur()',
                                '(focus)': '_focus()',
                                '(input)': '_onInput()',
                                '[id]': 'id',
                                '[attr.disabled]': 'disabled || null',
                                '[attr.placeholder]': 'placeholder || null',
                                '[attr.aria-invalid]': '_chipList && _chipList.ngControl ? _chipList.ngControl.invalid : null',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatChipInput.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_CHIPS_DEFAULT_OPTIONS,] }] }
            ]; };
            MatChipInput.propDecorators = {
                chipList: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['matChipInputFor',] }],
                addOnBlur: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['matChipInputAddOnBlur',] }],
                separatorKeyCodes: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['matChipInputSeparatorKeyCodes',] }],
                chipEnd: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"], args: ['matChipInputTokenEnd',] }],
                placeholder: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var CHIP_DECLARATIONS = [
                MatChipList,
                MatChip,
                MatChipInput,
                MatChipRemove,
                MatChipAvatar,
                MatChipTrailingIcon,
            ];
            var ɵ0 = ({
                separatorKeyCodes: [_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_1__["ENTER"]]
            });
            var MatChipsModule = /** @class */ (function () {
                function MatChipsModule() {
                }
                return MatChipsModule;
            }());
            MatChipsModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            exports: CHIP_DECLARATIONS,
                            declarations: CHIP_DECLARATIONS,
                            providers: [
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["ErrorStateMatcher"],
                                {
                                    provide: MAT_CHIPS_DEFAULT_OPTIONS,
                                    useValue: ( /** @type {?} */(ɵ0))
                                }
                            ]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=chips.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/core.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/core.js ***!
          \********************************************************/
        /*! exports provided: VERSION, AnimationCurves, AnimationDurations, MatCommonModule, MATERIAL_SANITY_CHECKS, mixinDisabled, mixinColor, mixinDisableRipple, mixinTabIndex, mixinErrorState, mixinInitialized, NativeDateModule, MatNativeDateModule, MAT_DATE_LOCALE_FACTORY, MAT_DATE_LOCALE, MAT_DATE_LOCALE_PROVIDER, DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter, MAT_NATIVE_DATE_FORMATS, ShowOnDirtyErrorStateMatcher, ErrorStateMatcher, MAT_HAMMER_OPTIONS, GestureConfig, setLines, MatLine, MatLineSetter, MatLineModule, MatOptionModule, _countGroupLabelsBeforeOption, _getOptionScrollPosition, MatOptionSelectionChange, MAT_OPTION_PARENT_COMPONENT, MatOption, MatOptgroup, MAT_LABEL_GLOBAL_OPTIONS, MatRippleModule, MAT_RIPPLE_GLOBAL_OPTIONS, MatRipple, RippleState, RippleRef, defaultRippleAnimationConfig, RippleRenderer, MatPseudoCheckboxModule, MatPseudoCheckbox, JAN, FEB, MAR, APR, MAY, JUN, JUL, AUG, SEP, OCT, NOV, DEC, ɵa1 */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION$1; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationCurves", function () { return AnimationCurves; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationDurations", function () { return AnimationDurations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCommonModule", function () { return MatCommonModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MATERIAL_SANITY_CHECKS", function () { return MATERIAL_SANITY_CHECKS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinDisabled", function () { return mixinDisabled; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinColor", function () { return mixinColor; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinDisableRipple", function () { return mixinDisableRipple; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinTabIndex", function () { return mixinTabIndex; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinErrorState", function () { return mixinErrorState; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinInitialized", function () { return mixinInitialized; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NativeDateModule", function () { return NativeDateModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatNativeDateModule", function () { return MatNativeDateModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_LOCALE_FACTORY", function () { return MAT_DATE_LOCALE_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_LOCALE", function () { return MAT_DATE_LOCALE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_LOCALE_PROVIDER", function () { return MAT_DATE_LOCALE_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateAdapter", function () { return DateAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_FORMATS", function () { return MAT_DATE_FORMATS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NativeDateAdapter", function () { return NativeDateAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_NATIVE_DATE_FORMATS", function () { return MAT_NATIVE_DATE_FORMATS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShowOnDirtyErrorStateMatcher", function () { return ShowOnDirtyErrorStateMatcher; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorStateMatcher", function () { return ErrorStateMatcher; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_HAMMER_OPTIONS", function () { return MAT_HAMMER_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GestureConfig", function () { return GestureConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLines", function () { return setLines; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatLine", function () { return MatLine; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatLineSetter", function () { return MatLineSetter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatLineModule", function () { return MatLineModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatOptionModule", function () { return MatOptionModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_countGroupLabelsBeforeOption", function () { return _countGroupLabelsBeforeOption; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getOptionScrollPosition", function () { return _getOptionScrollPosition; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatOptionSelectionChange", function () { return MatOptionSelectionChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_OPTION_PARENT_COMPONENT", function () { return MAT_OPTION_PARENT_COMPONENT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatOption", function () { return MatOption; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatOptgroup", function () { return MatOptgroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_LABEL_GLOBAL_OPTIONS", function () { return MAT_LABEL_GLOBAL_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRippleModule", function () { return MatRippleModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_RIPPLE_GLOBAL_OPTIONS", function () { return MAT_RIPPLE_GLOBAL_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRipple", function () { return MatRipple; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RippleState", function () { return RippleState; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RippleRef", function () { return RippleRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultRippleAnimationConfig", function () { return defaultRippleAnimationConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RippleRenderer", function () { return RippleRenderer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPseudoCheckboxModule", function () { return MatPseudoCheckboxModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPseudoCheckbox", function () { return MatPseudoCheckbox; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JAN", function () { return JAN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEB", function () { return FEB; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAR", function () { return MAR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APR", function () { return APR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAY", function () { return MAY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JUN", function () { return JUN; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JUL", function () { return JUL; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUG", function () { return AUG; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEP", function () { return SEP; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OCT", function () { return OCT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOV", function () { return NOV; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEC", function () { return DEC; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa1", function () { return MATERIAL_SANITY_CHECKS_FACTORY; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk */ "./node_modules/@angular/cdk/esm2015/cdk.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Current version of Angular Material.
             * @type {?}
             */
            var VERSION$1 = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Version"]('8.2.3');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             */
            var AnimationCurves = /** @class */ (function () {
                function AnimationCurves() {
                }
                return AnimationCurves;
            }());
            AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
            AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
            AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
            AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
            /**
             * \@docs-private
             */
            var AnimationDurations = /** @class */ (function () {
                function AnimationDurations() {
                }
                return AnimationDurations;
            }());
            AnimationDurations.COMPLEX = '375ms';
            AnimationDurations.ENTERING = '225ms';
            AnimationDurations.EXITING = '195ms';
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Private version constant to circumvent test/build issues,
            // i.e. avoid core to depend on the @angular/material primary entry-point
            // Can be removed once the Material primary entry-point no longer
            // re-exports all secondary entry-points
            /** @type {?} */
            var VERSION$2 = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Version"]('8.2.3');
            /**
             * \@docs-private
             * @return {?}
             */
            function MATERIAL_SANITY_CHECKS_FACTORY() {
                return true;
            }
            /**
             * Injection token that configures whether the Material sanity checks are enabled.
             * @type {?}
             */
            var MATERIAL_SANITY_CHECKS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-sanity-checks', {
                providedIn: 'root',
                factory: MATERIAL_SANITY_CHECKS_FACTORY,
            });
            /**
             * Module that captures anything that should be loaded and/or run for *all* Angular Material
             * components. This includes Bidi, etc.
             *
             * This module should be imported to each top-level component module (e.g., MatTabsModule).
             */
            var MatCommonModule = /** @class */ (function () {
                /**
                 * @param {?} _sanityChecksEnabled
                 * @param {?=} _hammerLoader
                 */
                function MatCommonModule(_sanityChecksEnabled, _hammerLoader) {
                    this._sanityChecksEnabled = _sanityChecksEnabled;
                    this._hammerLoader = _hammerLoader;
                    /**
                     * Whether we've done the global sanity checks (e.g. a theme is loaded, there is a doctype).
                     */
                    this._hasDoneGlobalChecks = false;
                    /**
                     * Whether we've already checked for HammerJs availability.
                     */
                    this._hasCheckedHammer = false;
                    /**
                     * Reference to the global `document` object.
                     */
                    this._document = typeof document === 'object' && document ? document : null;
                    /**
                     * Reference to the global 'window' object.
                     */
                    this._window = typeof window === 'object' && window ? window : null;
                    if (this._areChecksEnabled() && !this._hasDoneGlobalChecks) {
                        this._checkDoctypeIsDefined();
                        this._checkThemeIsPresent();
                        this._checkCdkVersionMatch();
                        this._hasDoneGlobalChecks = true;
                    }
                }
                /**
                 * Whether any sanity checks are enabled
                 * @private
                 * @return {?}
                 */
                MatCommonModule.prototype._areChecksEnabled = function () {
                    return this._sanityChecksEnabled && Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["isDevMode"])() && !this._isTestEnv();
                };
                /**
                 * Whether the code is running in tests.
                 * @private
                 * @return {?}
                 */
                MatCommonModule.prototype._isTestEnv = function () {
                    /** @type {?} */
                    var window = ( /** @type {?} */(this._window));
                    return window && (window.__karma__ || window.jasmine);
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatCommonModule.prototype._checkDoctypeIsDefined = function () {
                    if (this._document && !this._document.doctype) {
                        console.warn('Current document does not have a doctype. This may cause ' +
                            'some Angular Material components not to behave as expected.');
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatCommonModule.prototype._checkThemeIsPresent = function () {
                    // We need to assert that the `body` is defined, because these checks run very early
                    // and the `body` won't be defined if the consumer put their scripts in the `head`.
                    if (!this._document || !this._document.body || typeof getComputedStyle !== 'function') {
                        return;
                    }
                    /** @type {?} */
                    var testElement = this._document.createElement('div');
                    testElement.classList.add('mat-theme-loaded-marker');
                    this._document.body.appendChild(testElement);
                    /** @type {?} */
                    var computedStyle = getComputedStyle(testElement);
                    // In some situations the computed style of the test element can be null. For example in
                    // Firefox, the computed style is null if an application is running inside of a hidden iframe.
                    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
                    if (computedStyle && computedStyle.display !== 'none') {
                        console.warn('Could not find Angular Material core theme. Most Material ' +
                            'components may not work as expected. For more info refer ' +
                            'to the theming guide: https://material.angular.io/guide/theming');
                    }
                    this._document.body.removeChild(testElement);
                };
                /**
                 * Checks whether the material version matches the cdk version
                 * @private
                 * @return {?}
                 */
                MatCommonModule.prototype._checkCdkVersionMatch = function () {
                    if (VERSION$2.full !== _angular_cdk__WEBPACK_IMPORTED_MODULE_3__["VERSION"].full) {
                        console.warn('The Angular Material version (' + VERSION$2.full + ') does not match ' +
                            'the Angular CDK version (' + _angular_cdk__WEBPACK_IMPORTED_MODULE_3__["VERSION"].full + ').\n' +
                            'Please ensure the versions of these two packages exactly match.');
                    }
                };
                /**
                 * Checks whether HammerJS is available.
                 * @return {?}
                 */
                MatCommonModule.prototype._checkHammerIsAvailable = function () {
                    if (this._hasCheckedHammer || !this._window) {
                        return;
                    }
                    if (this._areChecksEnabled() && !(( /** @type {?} */(this._window)))['Hammer'] && !this._hammerLoader) {
                        console.warn('Could not find HammerJS. Certain Angular Material components may not work correctly.');
                    }
                    this._hasCheckedHammer = true;
                };
                return MatCommonModule;
            }());
            MatCommonModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["BidiModule"]],
                            exports: [_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["BidiModule"]],
                        },] },
            ];
            /** @nocollapse */
            MatCommonModule.ctorParameters = function () { return [
                { type: Boolean, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MATERIAL_SANITY_CHECKS,] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["HAMMER_LOADER"],] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to augment a directive with a `disabled` property.
             * @template T
             * @param {?} base
             * @return {?}
             */
            function mixinDisabled(base) {
                return /** @class */ (function (_super_1) {
                    __extends(class_3, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_3() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        _this._disabled = false;
                        return _this;
                    }
                    Object.defineProperty(class_3.prototype, "disabled", {
                        /**
                         * @return {?}
                         */
                        get: function () { return this._disabled; },
                        /**
                         * @param {?} value
                         * @return {?}
                         */
                        set: function (value) { this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceBooleanProperty"])(value); },
                        enumerable: true,
                        configurable: true
                    });
                    return class_3;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to augment a directive with a `color` property.
             * @template T
             * @param {?} base
             * @param {?=} defaultColor
             * @return {?}
             */
            function mixinColor(base, defaultColor) {
                return /** @class */ (function (_super_1) {
                    __extends(class_4, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_4() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        // Set the default color that can be specified from the mixin.
                        _this.color = defaultColor;
                        return _this;
                    }
                    Object.defineProperty(class_4.prototype, "color", {
                        /**
                         * @return {?}
                         */
                        get: function () { return this._color; },
                        /**
                         * @param {?} value
                         * @return {?}
                         */
                        set: function (value) {
                            /** @type {?} */
                            var colorPalette = value || defaultColor;
                            if (colorPalette !== this._color) {
                                if (this._color) {
                                    this._elementRef.nativeElement.classList.remove("mat-" + this._color);
                                }
                                if (colorPalette) {
                                    this._elementRef.nativeElement.classList.add("mat-" + colorPalette);
                                }
                                this._color = colorPalette;
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return class_4;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to augment a directive with a `disableRipple` property.
             * @template T
             * @param {?} base
             * @return {?}
             */
            function mixinDisableRipple(base) {
                return /** @class */ (function (_super_1) {
                    __extends(class_5, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_5() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        _this._disableRipple = false;
                        return _this;
                    }
                    Object.defineProperty(class_5.prototype, "disableRipple", {
                        /**
                         * Whether the ripple effect is disabled or not.
                         * @return {?}
                         */
                        get: function () { return this._disableRipple; },
                        /**
                         * @param {?} value
                         * @return {?}
                         */
                        set: function (value) { this._disableRipple = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceBooleanProperty"])(value); },
                        enumerable: true,
                        configurable: true
                    });
                    return class_5;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to augment a directive with a `tabIndex` property.
             * @template T
             * @param {?} base
             * @param {?=} defaultTabIndex
             * @return {?}
             */
            function mixinTabIndex(base, defaultTabIndex) {
                if (defaultTabIndex === void 0) { defaultTabIndex = 0; }
                return /** @class */ (function (_super_1) {
                    __extends(class_6, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_6() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        _this._tabIndex = defaultTabIndex;
                        return _this;
                    }
                    Object.defineProperty(class_6.prototype, "tabIndex", {
                        /**
                         * @return {?}
                         */
                        get: function () { return this.disabled ? -1 : this._tabIndex; },
                        /**
                         * @param {?} value
                         * @return {?}
                         */
                        set: function (value) {
                            // If the specified tabIndex value is null or undefined, fall back to the default value.
                            this._tabIndex = value != null ? value : defaultTabIndex;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return class_6;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to augment a directive with updateErrorState method.
             * For component with `errorState` and need to update `errorState`.
             * @template T
             * @param {?} base
             * @return {?}
             */
            function mixinErrorState(base) {
                return /** @class */ (function (_super_1) {
                    __extends(class_7, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_7() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        /**
                         * Whether the component is in an error state.
                         */
                        _this.errorState = false;
                        /**
                         * Stream that emits whenever the state of the input changes such that the wrapping
                         * `MatFormField` needs to run change detection.
                         */
                        _this.stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                        return _this;
                    }
                    /**
                     * @return {?}
                     */
                    class_7.prototype.updateErrorState = function () {
                        /** @type {?} */
                        var oldState = this.errorState;
                        /** @type {?} */
                        var parent = this._parentFormGroup || this._parentForm;
                        /** @type {?} */
                        var matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
                        /** @type {?} */
                        var control = this.ngControl ? ( /** @type {?} */(this.ngControl.control)) : null;
                        /** @type {?} */
                        var newState = matcher.isErrorState(control, parent);
                        if (newState !== oldState) {
                            this.errorState = newState;
                            this.stateChanges.next();
                        }
                    };
                    return class_7;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Mixin to augment a directive with an initialized property that will emits when ngOnInit ends.
             * @template T
             * @param {?} base
             * @return {?}
             */
            function mixinInitialized(base) {
                return /** @class */ (function (_super_1) {
                    __extends(class_8, _super_1);
                    /**
                     * @param {...?} args
                     */
                    function class_8() {
                        var args = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            args[_c] = arguments[_c];
                        }
                        var _this = _super_1.apply(this, args) || this;
                        /**
                         * Whether this directive has been marked as initialized.
                         */
                        _this._isInitialized = false;
                        /**
                         * List of subscribers that subscribed before the directive was initialized. Should be notified
                         * during _markInitialized. Set to null after pending subscribers are notified, and should
                         * not expect to be populated after.
                         */
                        _this._pendingSubscribers = [];
                        /**
                         * Observable stream that emits when the directive initializes. If already initialized, the
                         * subscriber is stored to be notified once _markInitialized is called.
                         */
                        _this.initialized = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"](( /**
                         * @param {?} subscriber
                         * @return {?}
                         */function (/**
                         * @param {?} subscriber
                         * @return {?}
                         */ subscriber) {
                            // If initialized, immediately notify the subscriber. Otherwise store the subscriber to notify
                            // when _markInitialized is called.
                            if (_this._isInitialized) {
                                _this._notifySubscriber(subscriber);
                            }
                            else {
                                ( /** @type {?} */(_this._pendingSubscribers)).push(subscriber);
                            }
                        }));
                        return _this;
                    }
                    /**
                     * Marks the state as initialized and notifies pending subscribers. Should be called at the end
                     * of ngOnInit.
                     * \@docs-private
                     * @return {?}
                     */
                    class_8.prototype._markInitialized = function () {
                        if (this._isInitialized) {
                            throw Error('This directive has already been marked as initialized and ' +
                                'should not be called twice.');
                        }
                        this._isInitialized = true;
                        ( /** @type {?} */(this._pendingSubscribers)).forEach(this._notifySubscriber);
                        this._pendingSubscribers = null;
                    };
                    /**
                     * Emits and completes the subscriber stream (should only emit once).
                     * @param {?} subscriber
                     * @return {?}
                     */
                    class_8.prototype._notifySubscriber = function (subscriber) {
                        subscriber.next();
                        subscriber.complete();
                    };
                    return class_8;
                }(base));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * InjectionToken for datepicker that can be used to override default locale code.
             * @type {?}
             */
            var MAT_DATE_LOCALE = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_DATE_LOCALE', {
                providedIn: 'root',
                factory: MAT_DATE_LOCALE_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_DATE_LOCALE_FACTORY() {
                return Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["inject"])(_angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"]);
            }
            /**
             * No longer needed since MAT_DATE_LOCALE has been changed to a scoped injectable.
             * If you are importing and providing this in your code you can simply remove it.
             * @deprecated
             * \@breaking-change 8.0.0
             * @type {?}
             */
            var MAT_DATE_LOCALE_PROVIDER = { provide: MAT_DATE_LOCALE, useExisting: _angular_core__WEBPACK_IMPORTED_MODULE_0__["LOCALE_ID"] };
            /**
             * Adapts type `D` to be usable as a date by cdk-based components that work with dates.
             * @abstract
             * @template D
             */
            var DateAdapter = /** @class */ (function () {
                function DateAdapter() {
                    this._localeChanges = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                }
                Object.defineProperty(DateAdapter.prototype, "localeChanges", {
                    /**
                     * A stream that emits when the locale changes.
                     * @return {?}
                     */
                    get: function () { return this._localeChanges; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Attempts to deserialize a value to a valid date object. This is different from parsing in that
                 * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
                 * string). The default implementation does not allow any deserialization, it simply checks that
                 * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
                 * method on all of its `\@Input()` properties that accept dates. It is therefore possible to
                 * support passing values from your backend directly to these properties by overriding this method
                 * to also deserialize the format used by your backend.
                 * @param {?} value The value to be deserialized into a date object.
                 * @return {?} The deserialized date object, either a valid date, null if the value can be
                 *     deserialized into a null date (e.g. the empty string), or an invalid date.
                 */
                DateAdapter.prototype.deserialize = function (value) {
                    if (value == null || this.isDateInstance(value) && this.isValid(value)) {
                        return value;
                    }
                    return this.invalid();
                };
                /**
                 * Sets the locale used for all dates.
                 * @param {?} locale The new locale.
                 * @return {?}
                 */
                DateAdapter.prototype.setLocale = function (locale) {
                    this.locale = locale;
                    this._localeChanges.next();
                };
                /**
                 * Compares two dates.
                 * @param {?} first The first date to compare.
                 * @param {?} second The second date to compare.
                 * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
                 *     a number greater than 0 if the first date is later.
                 */
                DateAdapter.prototype.compareDate = function (first, second) {
                    return this.getYear(first) - this.getYear(second) ||
                        this.getMonth(first) - this.getMonth(second) ||
                        this.getDate(first) - this.getDate(second);
                };
                /**
                 * Checks if two dates are equal.
                 * @param {?} first The first date to check.
                 * @param {?} second The second date to check.
                 * @return {?} Whether the two dates are equal.
                 *     Null dates are considered equal to other null dates.
                 */
                DateAdapter.prototype.sameDate = function (first, second) {
                    if (first && second) {
                        /** @type {?} */
                        var firstValid = this.isValid(first);
                        /** @type {?} */
                        var secondValid = this.isValid(second);
                        if (firstValid && secondValid) {
                            return !this.compareDate(first, second);
                        }
                        return firstValid == secondValid;
                    }
                    return first == second;
                };
                /**
                 * Clamp the given date between min and max dates.
                 * @param {?} date The date to clamp.
                 * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
                 * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
                 * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
                 *     otherwise `date`.
                 */
                DateAdapter.prototype.clampDate = function (date, min, max) {
                    if (min && this.compareDate(date, min) < 0) {
                        return min;
                    }
                    if (max && this.compareDate(date, max) > 0) {
                        return max;
                    }
                    return date;
                };
                return DateAdapter;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAT_DATE_FORMATS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-date-formats');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO(mmalerba): Remove when we no longer support safari 9.
            /**
             * Whether the browser supports the Intl API.
             * @type {?}
             */
            var SUPPORTS_INTL_API;
            // We need a try/catch around the reference to `Intl`, because accessing it in some cases can
            // cause IE to throw. These cases are tied to particular versions of Windows and can happen if
            // the consumer is providing a polyfilled `Map`. See:
            // https://github.com/Microsoft/ChakraCore/issues/3189
            // https://github.com/angular/components/issues/15687
            try {
                SUPPORTS_INTL_API = typeof Intl != 'undefined';
            }
            catch (_a) {
                SUPPORTS_INTL_API = false;
            }
            /**
             * The default month names to use if Intl API is not available.
             * @type {?}
             */
            var DEFAULT_MONTH_NAMES = {
                'long': [
                    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
                    'October', 'November', 'December'
                ],
                'short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                'narrow': ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
            };
            var ɵ0 = /**
             * @param {?} i
             * @return {?}
             */ function (/**
             * @param {?} i
             * @return {?}
             */ i) { return String(i + 1); };
            /**
             * The default date names to use if Intl API is not available.
             * @type {?}
             */
            var DEFAULT_DATE_NAMES = range(31, (ɵ0));
            /**
             * The default day of the week names to use if Intl API is not available.
             * @type {?}
             */
            var DEFAULT_DAY_OF_WEEK_NAMES = {
                'long': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                'short': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                'narrow': ['S', 'M', 'T', 'W', 'T', 'F', 'S']
            };
            /**
             * Matches strings that have the form of a valid RFC 3339 string
             * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
             * because the regex will match strings an with out of bounds month, date, etc.
             * @type {?}
             */
            var ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
            /**
             * Creates an array and fills it with values.
             * @template T
             * @param {?} length
             * @param {?} valueFunction
             * @return {?}
             */
            function range(length, valueFunction) {
                /** @type {?} */
                var valuesArray = Array(length);
                for (var i = 0; i < length; i++) {
                    valuesArray[i] = valueFunction(i);
                }
                return valuesArray;
            }
            /**
             * Adapts the native JS Date for use with cdk-based components that work with dates.
             */
            var NativeDateAdapter = /** @class */ (function (_super_1) {
                __extends(NativeDateAdapter, _super_1);
                /**
                 * @param {?} matDateLocale
                 * @param {?} platform
                 */
                function NativeDateAdapter(matDateLocale, platform) {
                    var _this = _super_1.call(this) || this;
                    /**
                     * Whether to use `timeZone: 'utc'` with `Intl.DateTimeFormat` when formatting dates.
                     * Without this `Intl.DateTimeFormat` sometimes chooses the wrong timeZone, which can throw off
                     * the result. (e.g. in the en-US locale `new Date(1800, 7, 14).toLocaleDateString()`
                     * will produce `'8/13/1800'`.
                     *
                     * TODO(mmalerba): drop this variable. It's not being used in the code right now. We're now
                     * getting the string representation of a Date object from its utc representation. We're keeping
                     * it here for sometime, just for precaution, in case we decide to revert some of these changes
                     * though.
                     */
                    _this.useUtcForDisplay = true;
                    _super_1.prototype.setLocale.call(_this, matDateLocale);
                    // IE does its own time zone correction, so we disable this on IE.
                    _this.useUtcForDisplay = !platform.TRIDENT;
                    _this._clampDate = platform.TRIDENT || platform.EDGE;
                    return _this;
                }
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getYear = function (date) {
                    return date.getFullYear();
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getMonth = function (date) {
                    return date.getMonth();
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getDate = function (date) {
                    return date.getDate();
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getDayOfWeek = function (date) {
                    return date.getDay();
                };
                /**
                 * @param {?} style
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getMonthNames = function (style) {
                    var _this = this;
                    if (SUPPORTS_INTL_API) {
                        /** @type {?} */
                        var dtf_1 = new Intl.DateTimeFormat(this.locale, { month: style, timeZone: 'utc' });
                        return range(12, ( /**
                         * @param {?} i
                         * @return {?}
                         */function (/**
                         * @param {?} i
                         * @return {?}
                         */ i) { return _this._stripDirectionalityCharacters(_this._format(dtf_1, new Date(2017, i, 1))); }));
                    }
                    return DEFAULT_MONTH_NAMES[style];
                };
                /**
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getDateNames = function () {
                    var _this = this;
                    if (SUPPORTS_INTL_API) {
                        /** @type {?} */
                        var dtf_2 = new Intl.DateTimeFormat(this.locale, { day: 'numeric', timeZone: 'utc' });
                        return range(31, ( /**
                         * @param {?} i
                         * @return {?}
                         */function (/**
                         * @param {?} i
                         * @return {?}
                         */ i) { return _this._stripDirectionalityCharacters(_this._format(dtf_2, new Date(2017, 0, i + 1))); }));
                    }
                    return DEFAULT_DATE_NAMES;
                };
                /**
                 * @param {?} style
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getDayOfWeekNames = function (style) {
                    var _this = this;
                    if (SUPPORTS_INTL_API) {
                        /** @type {?} */
                        var dtf_3 = new Intl.DateTimeFormat(this.locale, { weekday: style, timeZone: 'utc' });
                        return range(7, ( /**
                         * @param {?} i
                         * @return {?}
                         */function (/**
                         * @param {?} i
                         * @return {?}
                         */ i) { return _this._stripDirectionalityCharacters(_this._format(dtf_3, new Date(2017, 0, i + 1))); }));
                    }
                    return DEFAULT_DAY_OF_WEEK_NAMES[style];
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getYearName = function (date) {
                    if (SUPPORTS_INTL_API) {
                        /** @type {?} */
                        var dtf = new Intl.DateTimeFormat(this.locale, { year: 'numeric', timeZone: 'utc' });
                        return this._stripDirectionalityCharacters(this._format(dtf, date));
                    }
                    return String(this.getYear(date));
                };
                /**
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getFirstDayOfWeek = function () {
                    // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
                    return 0;
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.getNumDaysInMonth = function (date) {
                    return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.clone = function (date) {
                    return new Date(date.getTime());
                };
                /**
                 * @param {?} year
                 * @param {?} month
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.createDate = function (year, month, date) {
                    // Check for invalid month and date (except upper bound on date which we have to check after
                    // creating the Date).
                    if (month < 0 || month > 11) {
                        throw Error("Invalid month index \"" + month + "\". Month index has to be between 0 and 11.");
                    }
                    if (date < 1) {
                        throw Error("Invalid date \"" + date + "\". Date has to be greater than 0.");
                    }
                    /** @type {?} */
                    var result = this._createDateWithOverflow(year, month, date);
                    // Check that the date wasn't above the upper bound for the month, causing the month to overflow
                    if (result.getMonth() != month) {
                        throw Error("Invalid date \"" + date + "\" for month with index \"" + month + "\".");
                    }
                    return result;
                };
                /**
                 * @return {?}
                 */
                NativeDateAdapter.prototype.today = function () {
                    return new Date();
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NativeDateAdapter.prototype.parse = function (value) {
                    // We have no way using the native JS Date to set the parse format or locale, so we ignore these
                    // parameters.
                    if (typeof value == 'number') {
                        return new Date(value);
                    }
                    return value ? new Date(Date.parse(value)) : null;
                };
                /**
                 * @param {?} date
                 * @param {?} displayFormat
                 * @return {?}
                 */
                NativeDateAdapter.prototype.format = function (date, displayFormat) {
                    if (!this.isValid(date)) {
                        throw Error('NativeDateAdapter: Cannot format invalid date.');
                    }
                    if (SUPPORTS_INTL_API) {
                        // On IE and Edge the i18n API will throw a hard error that can crash the entire app
                        // if we attempt to format a date whose year is less than 1 or greater than 9999.
                        if (this._clampDate && (date.getFullYear() < 1 || date.getFullYear() > 9999)) {
                            date = this.clone(date);
                            date.setFullYear(Math.max(1, Math.min(9999, date.getFullYear())));
                        }
                        displayFormat = Object.assign({}, displayFormat, { timeZone: 'utc' });
                        /** @type {?} */
                        var dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
                        return this._stripDirectionalityCharacters(this._format(dtf, date));
                    }
                    return this._stripDirectionalityCharacters(date.toDateString());
                };
                /**
                 * @param {?} date
                 * @param {?} years
                 * @return {?}
                 */
                NativeDateAdapter.prototype.addCalendarYears = function (date, years) {
                    return this.addCalendarMonths(date, years * 12);
                };
                /**
                 * @param {?} date
                 * @param {?} months
                 * @return {?}
                 */
                NativeDateAdapter.prototype.addCalendarMonths = function (date, months) {
                    /** @type {?} */
                    var newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
                    // It's possible to wind up in the wrong month if the original month has more days than the new
                    // month. In this case we want to go to the last day of the desired month.
                    // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
                    // guarantee this.
                    if (this.getMonth(newDate) != ((this.getMonth(date) + months) % 12 + 12) % 12) {
                        newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
                    }
                    return newDate;
                };
                /**
                 * @param {?} date
                 * @param {?} days
                 * @return {?}
                 */
                NativeDateAdapter.prototype.addCalendarDays = function (date, days) {
                    return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.toIso8601 = function (date) {
                    return [
                        date.getUTCFullYear(),
                        this._2digit(date.getUTCMonth() + 1),
                        this._2digit(date.getUTCDate())
                    ].join('-');
                };
                /**
                 * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
                 * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
                 * invalid date for all other values.
                 * @param {?} value
                 * @return {?}
                 */
                NativeDateAdapter.prototype.deserialize = function (value) {
                    if (typeof value === 'string') {
                        if (!value) {
                            return null;
                        }
                        // The `Date` constructor accepts formats other than ISO 8601, so we need to make sure the
                        // string is the right format first.
                        if (ISO_8601_REGEX.test(value)) {
                            /** @type {?} */
                            var date = new Date(value);
                            if (this.isValid(date)) {
                                return date;
                            }
                        }
                    }
                    return _super_1.prototype.deserialize.call(this, value);
                };
                /**
                 * @param {?} obj
                 * @return {?}
                 */
                NativeDateAdapter.prototype.isDateInstance = function (obj) {
                    return obj instanceof Date;
                };
                /**
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype.isValid = function (date) {
                    return !isNaN(date.getTime());
                };
                /**
                 * @return {?}
                 */
                NativeDateAdapter.prototype.invalid = function () {
                    return new Date(NaN);
                };
                /**
                 * Creates a date but allows the month and date to overflow.
                 * @private
                 * @param {?} year
                 * @param {?} month
                 * @param {?} date
                 * @return {?}
                 */
                NativeDateAdapter.prototype._createDateWithOverflow = function (year, month, date) {
                    /** @type {?} */
                    var result = new Date(year, month, date);
                    // We need to correct for the fact that JS native Date treats years in range [0, 99] as
                    // abbreviations for 19xx.
                    if (year >= 0 && year < 100) {
                        result.setFullYear(this.getYear(result) - 1900);
                    }
                    return result;
                };
                /**
                 * Pads a number to make it two digits.
                 * @private
                 * @param {?} n The number to pad.
                 * @return {?} The padded number.
                 */
                NativeDateAdapter.prototype._2digit = function (n) {
                    return ('00' + n).slice(-2);
                };
                /**
                 * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
                 * other browsers do not. We remove them to make output consistent and because they interfere with
                 * date parsing.
                 * @private
                 * @param {?} str The string to strip direction characters from.
                 * @return {?} The stripped string.
                 */
                NativeDateAdapter.prototype._stripDirectionalityCharacters = function (str) {
                    return str.replace(/[\u200e\u200f]/g, '');
                };
                /**
                 * When converting Date object to string, javascript built-in functions may return wrong
                 * results because it applies its internal DST rules. The DST rules around the world change
                 * very frequently, and the current valid rule is not always valid in previous years though.
                 * We work around this problem building a new Date object which has its internal UTC
                 * representation with the local date and time.
                 * @private
                 * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
                 *    timeZone set to 'utc' to work fine.
                 * @param {?} date Date from which we want to get the string representation according to dtf
                 * @return {?} A Date object with its UTC representation based on the passed in date info
                 */
                NativeDateAdapter.prototype._format = function (dtf, date) {
                    /** @type {?} */
                    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
                    return dtf.format(d);
                };
                return NativeDateAdapter;
            }(DateAdapter));
            NativeDateAdapter.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
            ];
            /** @nocollapse */
            NativeDateAdapter.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_DATE_LOCALE,] }] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["Platform"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAT_NATIVE_DATE_FORMATS = {
                parse: {
                    dateInput: null,
                },
                display: {
                    dateInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
                    monthYearLabel: { year: 'numeric', month: 'short' },
                    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
                    monthYearA11yLabel: { year: 'numeric', month: 'long' },
                }
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NativeDateModule = /** @class */ (function () {
                function NativeDateModule() {
                }
                return NativeDateModule;
            }());
            NativeDateModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["PlatformModule"]],
                            providers: [
                                { provide: DateAdapter, useClass: NativeDateAdapter },
                            ],
                        },] },
            ];
            var ɵ0$1 = MAT_NATIVE_DATE_FORMATS;
            var MatNativeDateModule = /** @class */ (function () {
                function MatNativeDateModule() {
                }
                return MatNativeDateModule;
            }());
            MatNativeDateModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [NativeDateModule],
                            providers: [{ provide: MAT_DATE_FORMATS, useValue: ɵ0$1 }],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Error state matcher that matches when a control is invalid and dirty.
             */
            var ShowOnDirtyErrorStateMatcher = /** @class */ (function () {
                function ShowOnDirtyErrorStateMatcher() {
                }
                /**
                 * @param {?} control
                 * @param {?} form
                 * @return {?}
                 */
                ShowOnDirtyErrorStateMatcher.prototype.isErrorState = function (control, form) {
                    return !!(control && control.invalid && (control.dirty || (form && form.submitted)));
                };
                return ShowOnDirtyErrorStateMatcher;
            }());
            ShowOnDirtyErrorStateMatcher.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
            ];
            /**
             * Provider that defines how form controls behave with regards to displaying error messages.
             */
            var ErrorStateMatcher = /** @class */ (function () {
                function ErrorStateMatcher() {
                }
                /**
                 * @param {?} control
                 * @param {?} form
                 * @return {?}
                 */
                ErrorStateMatcher.prototype.isErrorState = function (control, form) {
                    return !!(control && control.invalid && (control.touched || (form && form.submitted)));
                };
                return ErrorStateMatcher;
            }());
            ErrorStateMatcher.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ ErrorStateMatcher.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to provide options to the Hammerjs instance.
             * More info at http://hammerjs.github.io/api/.
             * @type {?}
             */
            var MAT_HAMMER_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_HAMMER_OPTIONS');
            /** @type {?} */
            var ANGULAR_MATERIAL_SUPPORTED_HAMMER_GESTURES = [
                'longpress',
                'slide',
                'slidestart',
                'slideend',
                'slideright',
                'slideleft'
            ];
            var ɵ0$2 = /**
             * @return {?}
             */ function () { }, ɵ1 = /**
             * @return {?}
             */ function () { };
            /**
             * Fake HammerInstance that is used when a Hammer instance is requested when HammerJS has not
             * been loaded on the page.
             * @type {?}
             */
            var noopHammerInstance = {
                on: (ɵ0$2),
                off: (ɵ1),
            };
            /**
             * Adjusts configuration of our gesture library, Hammer.
             */
            var GestureConfig = /** @class */ (function (_super_1) {
                __extends(GestureConfig, _super_1);
                /**
                 * @param {?=} _hammerOptions
                 * @param {?=} commonModule
                 */
                function GestureConfig(_hammerOptions, commonModule) {
                    var _this = _super_1.call(this) || this;
                    _this._hammerOptions = _hammerOptions;
                    /**
                     * List of new event names to add to the gesture support list
                     */
                    _this.events = ANGULAR_MATERIAL_SUPPORTED_HAMMER_GESTURES;
                    if (commonModule) {
                        commonModule._checkHammerIsAvailable();
                    }
                    return _this;
                }
                /**
                 * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
                 *
                 * Our gesture names come from the Material Design gestures spec:
                 * https://material.io/design/#gestures-touch-mechanics
                 *
                 * More information on default recognizers can be found in Hammer docs:
                 * http://hammerjs.github.io/recognizer-pan/
                 * http://hammerjs.github.io/recognizer-press/
                 *
                 * @param {?} element Element to which to assign the new HammerJS gestures.
                 * @return {?} Newly-created HammerJS instance.
                 */
                GestureConfig.prototype.buildHammer = function (element) {
                    /** @type {?} */
                    var hammer = typeof window !== 'undefined' ? (( /** @type {?} */(window))).Hammer : null;
                    if (!hammer) {
                        // If HammerJS is not loaded here, return the noop HammerInstance. This is necessary to
                        // ensure that omitting HammerJS completely will not cause any errors while *also* supporting
                        // the lazy-loading of HammerJS via the HAMMER_LOADER token introduced in Angular 6.1.
                        // Because we can't depend on HAMMER_LOADER's existance until 7.0, we have to always set
                        // `this.events` to the set we support, instead of conditionally setting it to `[]` if
                        // `HAMMER_LOADER` is present (and then throwing an Error here if `window.Hammer` is
                        // undefined).
                        // @breaking-change 8.0.0
                        return noopHammerInstance;
                    }
                    /** @type {?} */
                    var mc = new hammer(element, this._hammerOptions || undefined);
                    // Default Hammer Recognizers.
                    /** @type {?} */
                    var pan = new hammer.Pan();
                    /** @type {?} */
                    var swipe = new hammer.Swipe();
                    /** @type {?} */
                    var press = new hammer.Press();
                    // Notice that a HammerJS recognizer can only depend on one other recognizer once.
                    // Otherwise the previous `recognizeWith` will be dropped.
                    // TODO: Confirm threshold numbers with Material Design UX Team
                    /** @type {?} */
                    var slide = this._createRecognizer(pan, { event: 'slide', threshold: 0 }, swipe);
                    /** @type {?} */
                    var longpress = this._createRecognizer(press, { event: 'longpress', time: 500 });
                    // Overwrite the default `pan` event to use the swipe event.
                    pan.recognizeWith(swipe);
                    // Since the slide event threshold is set to zero, the slide recognizer can fire and
                    // accidentally reset the longpress recognizer. In order to make sure that the two
                    // recognizers can run simultaneously but don't affect each other, we allow the slide
                    // recognizer to recognize while a longpress is being processed.
                    // See: https://github.com/hammerjs/hammer.js/blob/master/src/manager.js#L123-L124
                    longpress.recognizeWith(slide);
                    // Add customized gestures to Hammer manager
                    mc.add([swipe, press, pan, slide, longpress]);
                    return ( /** @type {?} */(mc));
                };
                /**
                 * Creates a new recognizer, without affecting the default recognizers of HammerJS
                 * @private
                 * @param {?} base
                 * @param {?} options
                 * @param {...?} inheritances
                 * @return {?}
                 */
                GestureConfig.prototype._createRecognizer = function (base, options) {
                    var inheritances = [];
                    for (var _c = 2; _c < arguments.length; _c++) {
                        inheritances[_c - 2] = arguments[_c];
                    }
                    /** @type {?} */
                    var recognizer = new (( /** @type {?} */(base.constructor)))(options);
                    inheritances.push(base);
                    inheritances.forEach(( /**
                     * @param {?} item
                     * @return {?}
                     */function (/**
                     * @param {?} item
                     * @return {?}
                     */ item) { return recognizer.recognizeWith(item); }));
                    return recognizer;
                };
                return GestureConfig;
            }(_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["HammerGestureConfig"]));
            GestureConfig.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] },
            ];
            /** @nocollapse */
            GestureConfig.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_HAMMER_OPTIONS,] }] },
                { type: MatCommonModule, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Shared directive to count lines inside a text area, such as a list item.
             * Line elements can be extracted with a \@ContentChildren(MatLine) query, then
             * counted by checking the query list's length.
             */
            var MatLine = /** @class */ (function () {
                function MatLine() {
                }
                return MatLine;
            }());
            MatLine.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-line], [matLine]',
                            host: { 'class': 'mat-line' }
                        },] },
            ];
            /**
             * Helper that takes a query list of lines and sets the correct class on the host.
             * \@docs-private
             * @param {?} lines
             * @param {?} element
             * @return {?}
             */
            function setLines(lines, element) {
                // Note: doesn't need to unsubscribe, because `changes`
                // gets completed by Angular when the view is destroyed.
                lines.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(lines)).subscribe(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                    var length = _c.length;
                    setClass(element, 'mat-2-line', false);
                    setClass(element, 'mat-3-line', false);
                    setClass(element, 'mat-multi-line', false);
                    if (length === 2 || length === 3) {
                        setClass(element, "mat-" + length + "-line", true);
                    }
                    else if (length > 3) {
                        setClass(element, "mat-multi-line", true);
                    }
                }));
            }
            /**
             * Adds or removes a class from an element.
             * @param {?} element
             * @param {?} className
             * @param {?} isAdd
             * @return {?}
             */
            function setClass(element, className, isAdd) {
                /** @type {?} */
                var classList = element.nativeElement.classList;
                isAdd ? classList.add(className) : classList.remove(className);
            }
            /**
             * Helper that takes a query list of lines and sets the correct class on the host.
             * \@docs-private
             * @deprecated Use `setLines` instead.
             * \@breaking-change 8.0.0
             */
            var MatLineSetter = /** @class */ (function () {
                /**
                 * @param {?} lines
                 * @param {?} element
                 */
                function MatLineSetter(lines, element) {
                    setLines(lines, element);
                }
                return MatLineSetter;
            }());
            var MatLineModule = /** @class */ (function () {
                function MatLineModule() {
                }
                return MatLineModule;
            }());
            MatLineModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [MatCommonModule],
                            exports: [MatLine, MatCommonModule],
                            declarations: [MatLine],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @enum {number} */
            var RippleState = {
                FADING_IN: 0, VISIBLE: 1, FADING_OUT: 2, HIDDEN: 3,
            };
            RippleState[RippleState.FADING_IN] = 'FADING_IN';
            RippleState[RippleState.VISIBLE] = 'VISIBLE';
            RippleState[RippleState.FADING_OUT] = 'FADING_OUT';
            RippleState[RippleState.HIDDEN] = 'HIDDEN';
            /**
             * Reference to a previously launched ripple element.
             */
            var RippleRef = /** @class */ (function () {
                /**
                 * @param {?} _renderer
                 * @param {?} element
                 * @param {?} config
                 */
                function RippleRef(_renderer, element, config) {
                    this._renderer = _renderer;
                    this.element = element;
                    this.config = config;
                    /**
                     * Current state of the ripple.
                     */
                    this.state = RippleState.HIDDEN;
                }
                /**
                 * Fades out the ripple element.
                 * @return {?}
                 */
                RippleRef.prototype.fadeOut = function () {
                    this._renderer.fadeOutRipple(this);
                };
                return RippleRef;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Default ripple animation configuration for ripples without an explicit
             * animation config specified.
             * @type {?}
             */
            var defaultRippleAnimationConfig = {
                enterDuration: 450,
                exitDuration: 400
            };
            /**
             * Timeout for ignoring mouse events. Mouse events will be temporary ignored after touch
             * events to avoid synthetic mouse events.
             * @type {?}
             */
            var ignoreMouseEventsTimeout = 800;
            /**
             * Options that apply to all the event listeners that are bound by the ripple renderer.
             * @type {?}
             */
            var passiveEventOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["normalizePassiveListenerOptions"])({ passive: true });
            /**
             * Helper service that performs DOM manipulations. Not intended to be used outside this module.
             * The constructor takes a reference to the ripple directive's host element and a map of DOM
             * event handlers to be installed on the element that triggers ripple animations.
             * This will eventually become a custom renderer once Angular support exists.
             * \@docs-private
             */
            var RippleRenderer = /** @class */ (function () {
                /**
                 * @param {?} _target
                 * @param {?} _ngZone
                 * @param {?} elementOrElementRef
                 * @param {?} platform
                 */
                function RippleRenderer(_target, _ngZone, elementOrElementRef, platform) {
                    var _this = this;
                    this._target = _target;
                    this._ngZone = _ngZone;
                    /**
                     * Whether the pointer is currently down or not.
                     */
                    this._isPointerDown = false;
                    /**
                     * Events to be registered on the trigger element.
                     */
                    this._triggerEvents = new Map();
                    /**
                     * Set of currently active ripple references.
                     */
                    this._activeRipples = new Set();
                    /**
                     * Function being called whenever the trigger is being pressed using mouse.
                     */
                    this._onMousedown = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        // Screen readers will fire fake mouse events for space/enter. Skip launching a
                        // ripple in this case for consistency with the non-screen-reader experience.
                        /** @type {?} */
                        var isFakeMousedown = Object(_angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_8__["isFakeMousedownFromScreenReader"])(event);
                        /** @type {?} */
                        var isSyntheticEvent = _this._lastTouchStartEvent &&
                            Date.now() < _this._lastTouchStartEvent + ignoreMouseEventsTimeout;
                        if (!_this._target.rippleDisabled && !isFakeMousedown && !isSyntheticEvent) {
                            _this._isPointerDown = true;
                            _this.fadeInRipple(event.clientX, event.clientY, _this._target.rippleConfig);
                        }
                    });
                    /**
                     * Function being called whenever the trigger is being pressed using touch.
                     */
                    this._onTouchStart = ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        if (!_this._target.rippleDisabled) {
                            // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
                            // events will launch a second ripple if we don't ignore mouse events for a specific
                            // time after a touchstart event.
                            _this._lastTouchStartEvent = Date.now();
                            _this._isPointerDown = true;
                            // Use `changedTouches` so we skip any touches where the user put
                            // their finger down, but used another finger to tap the element again.
                            /** @type {?} */
                            var touches = event.changedTouches;
                            for (var i = 0; i < touches.length; i++) {
                                _this.fadeInRipple(touches[i].clientX, touches[i].clientY, _this._target.rippleConfig);
                            }
                        }
                    });
                    /**
                     * Function being called whenever the trigger is being released.
                     */
                    this._onPointerUp = ( /**
                     * @return {?}
                     */function () {
                        if (!_this._isPointerDown) {
                            return;
                        }
                        _this._isPointerDown = false;
                        // Fade-out all ripples that are visible and not persistent.
                        _this._activeRipples.forEach(( /**
                         * @param {?} ripple
                         * @return {?}
                         */function (/**
                         * @param {?} ripple
                         * @return {?}
                         */ ripple) {
                            // By default, only ripples that are completely visible will fade out on pointer release.
                            // If the `terminateOnPointerUp` option is set, ripples that still fade in will also fade out.
                            /** @type {?} */
                            var isVisible = ripple.state === RippleState.VISIBLE ||
                                ripple.config.terminateOnPointerUp && ripple.state === RippleState.FADING_IN;
                            if (!ripple.config.persistent && isVisible) {
                                ripple.fadeOut();
                            }
                        }));
                    });
                    // Only do anything if we're on the browser.
                    if (platform.isBrowser) {
                        this._containerElement = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceElement"])(elementOrElementRef);
                        // Specify events which need to be registered on the trigger.
                        this._triggerEvents
                            .set('mousedown', this._onMousedown)
                            .set('mouseup', this._onPointerUp)
                            .set('mouseleave', this._onPointerUp)
                            .set('touchstart', this._onTouchStart)
                            .set('touchend', this._onPointerUp)
                            .set('touchcancel', this._onPointerUp);
                    }
                }
                /**
                 * Fades in a ripple at the given coordinates.
                 * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
                 * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
                 * @param {?=} config Extra ripple options.
                 * @return {?}
                 */
                RippleRenderer.prototype.fadeInRipple = function (x, y, config) {
                    var _this = this;
                    if (config === void 0) { config = {}; }
                    /** @type {?} */
                    var containerRect = this._containerRect =
                        this._containerRect || this._containerElement.getBoundingClientRect();
                    /** @type {?} */
                    var animationConfig = Object.assign({}, defaultRippleAnimationConfig, config.animation);
                    if (config.centered) {
                        x = containerRect.left + containerRect.width / 2;
                        y = containerRect.top + containerRect.height / 2;
                    }
                    /** @type {?} */
                    var radius = config.radius || distanceToFurthestCorner(x, y, containerRect);
                    /** @type {?} */
                    var offsetX = x - containerRect.left;
                    /** @type {?} */
                    var offsetY = y - containerRect.top;
                    /** @type {?} */
                    var duration = animationConfig.enterDuration;
                    /** @type {?} */
                    var ripple = document.createElement('div');
                    ripple.classList.add('mat-ripple-element');
                    ripple.style.left = offsetX - radius + "px";
                    ripple.style.top = offsetY - radius + "px";
                    ripple.style.height = radius * 2 + "px";
                    ripple.style.width = radius * 2 + "px";
                    // If the color is not set, the default CSS color will be used.
                    ripple.style.backgroundColor = config.color || null;
                    ripple.style.transitionDuration = duration + "ms";
                    this._containerElement.appendChild(ripple);
                    // By default the browser does not recalculate the styles of dynamically created
                    // ripple elements. This is critical because then the `scale` would not animate properly.
                    enforceStyleRecalculation(ripple);
                    ripple.style.transform = 'scale(1)';
                    // Exposed reference to the ripple that will be returned.
                    /** @type {?} */
                    var rippleRef = new RippleRef(this, ripple, config);
                    rippleRef.state = RippleState.FADING_IN;
                    // Add the ripple reference to the list of all active ripples.
                    this._activeRipples.add(rippleRef);
                    if (!config.persistent) {
                        this._mostRecentTransientRipple = rippleRef;
                    }
                    // Wait for the ripple element to be completely faded in.
                    // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
                    this._runTimeoutOutsideZone(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var isMostRecentTransientRipple = rippleRef === _this._mostRecentTransientRipple;
                        rippleRef.state = RippleState.VISIBLE;
                        // When the timer runs out while the user has kept their pointer down, we want to
                        // keep only the persistent ripples and the latest transient ripple. We do this,
                        // because we don't want stacked transient ripples to appear after their enter
                        // animation has finished.
                        if (!config.persistent && (!isMostRecentTransientRipple || !_this._isPointerDown)) {
                            rippleRef.fadeOut();
                        }
                    }), duration);
                    return rippleRef;
                };
                /**
                 * Fades out a ripple reference.
                 * @param {?} rippleRef
                 * @return {?}
                 */
                RippleRenderer.prototype.fadeOutRipple = function (rippleRef) {
                    /** @type {?} */
                    var wasActive = this._activeRipples.delete(rippleRef);
                    if (rippleRef === this._mostRecentTransientRipple) {
                        this._mostRecentTransientRipple = null;
                    }
                    // Clear out the cached bounding rect if we have no more ripples.
                    if (!this._activeRipples.size) {
                        this._containerRect = null;
                    }
                    // For ripples that are not active anymore, don't re-run the fade-out animation.
                    if (!wasActive) {
                        return;
                    }
                    /** @type {?} */
                    var rippleEl = rippleRef.element;
                    /** @type {?} */
                    var animationConfig = Object.assign({}, defaultRippleAnimationConfig, rippleRef.config.animation);
                    rippleEl.style.transitionDuration = animationConfig.exitDuration + "ms";
                    rippleEl.style.opacity = '0';
                    rippleRef.state = RippleState.FADING_OUT;
                    // Once the ripple faded out, the ripple can be safely removed from the DOM.
                    this._runTimeoutOutsideZone(( /**
                     * @return {?}
                     */function () {
                        rippleRef.state = RippleState.HIDDEN;
                        ( /** @type {?} */(rippleEl.parentNode)).removeChild(rippleEl);
                    }), animationConfig.exitDuration);
                };
                /**
                 * Fades out all currently active ripples.
                 * @return {?}
                 */
                RippleRenderer.prototype.fadeOutAll = function () {
                    this._activeRipples.forEach(( /**
                     * @param {?} ripple
                     * @return {?}
                     */function (/**
                     * @param {?} ripple
                     * @return {?}
                     */ ripple) { return ripple.fadeOut(); }));
                };
                /**
                 * Sets up the trigger event listeners
                 * @param {?} elementOrElementRef
                 * @return {?}
                 */
                RippleRenderer.prototype.setupTriggerEvents = function (elementOrElementRef) {
                    var _this = this;
                    /** @type {?} */
                    var element = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceElement"])(elementOrElementRef);
                    if (!element || element === this._triggerElement) {
                        return;
                    }
                    // Remove all previously registered event listeners from the trigger element.
                    this._removeTriggerEvents();
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._triggerEvents.forEach(( /**
                         * @param {?} fn
                         * @param {?} type
                         * @return {?}
                         */function (fn, type) {
                            element.addEventListener(type, fn, passiveEventOptions);
                        }));
                    }));
                    this._triggerElement = element;
                };
                /**
                 * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
                 * @private
                 * @param {?} fn
                 * @param {?=} delay
                 * @return {?}
                 */
                RippleRenderer.prototype._runTimeoutOutsideZone = function (fn, delay) {
                    if (delay === void 0) { delay = 0; }
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () { return setTimeout(fn, delay); }));
                };
                /**
                 * Removes previously registered event listeners from the trigger element.
                 * @return {?}
                 */
                RippleRenderer.prototype._removeTriggerEvents = function () {
                    var _this = this;
                    if (this._triggerElement) {
                        this._triggerEvents.forEach(( /**
                         * @param {?} fn
                         * @param {?} type
                         * @return {?}
                         */function (fn, type) {
                            ( /** @type {?} */(_this._triggerElement)).removeEventListener(type, fn, passiveEventOptions);
                        }));
                    }
                };
                return RippleRenderer;
            }());
            /**
             * Enforces a style recalculation of a DOM element by computing its styles.
             * @param {?} element
             * @return {?}
             */
            function enforceStyleRecalculation(element) {
                // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
                // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
                // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
                window.getComputedStyle(element).getPropertyValue('opacity');
            }
            /**
             * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
             * @param {?} x
             * @param {?} y
             * @param {?} rect
             * @return {?}
             */
            function distanceToFurthestCorner(x, y, rect) {
                /** @type {?} */
                var distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
                /** @type {?} */
                var distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
                return Math.sqrt(distX * distX + distY * distY);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to specify the global ripple options.
             * @type {?}
             */
            var MAT_RIPPLE_GLOBAL_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-ripple-global-options');
            var MatRipple = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} ngZone
                 * @param {?} platform
                 * @param {?=} globalOptions
                 * @param {?=} animationMode
                 */
                function MatRipple(_elementRef, ngZone, platform, globalOptions, animationMode) {
                    this._elementRef = _elementRef;
                    /**
                     * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
                     * will be the distance from the center of the ripple to the furthest corner of the host element's
                     * bounding rectangle.
                     */
                    this.radius = 0;
                    this._disabled = false;
                    /**
                     * Whether ripple directive is initialized and the input bindings are set.
                     */
                    this._isInitialized = false;
                    this._globalOptions = globalOptions || {};
                    this._rippleRenderer = new RippleRenderer(this, ngZone, _elementRef, platform);
                    if (animationMode === 'NoopAnimations') {
                        this._globalOptions.animation = { enterDuration: 0, exitDuration: 0 };
                    }
                }
                Object.defineProperty(MatRipple.prototype, "disabled", {
                    /**
                     * Whether click events will not trigger the ripple. Ripples can be still launched manually
                     * by using the `launch()` method.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = value;
                        this._setupTriggerEventsIfEnabled();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRipple.prototype, "trigger", {
                    /**
                     * The element that triggers the ripple when click events are received.
                     * Defaults to the directive's host element.
                     * @return {?}
                     */
                    get: function () { return this._trigger || this._elementRef.nativeElement; },
                    /**
                     * @param {?} trigger
                     * @return {?}
                     */
                    set: function (trigger) {
                        this._trigger = trigger;
                        this._setupTriggerEventsIfEnabled();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatRipple.prototype.ngOnInit = function () {
                    this._isInitialized = true;
                    this._setupTriggerEventsIfEnabled();
                };
                /**
                 * @return {?}
                 */
                MatRipple.prototype.ngOnDestroy = function () {
                    this._rippleRenderer._removeTriggerEvents();
                };
                /**
                 * Fades out all currently showing ripple elements.
                 * @return {?}
                 */
                MatRipple.prototype.fadeOutAll = function () {
                    this._rippleRenderer.fadeOutAll();
                };
                Object.defineProperty(MatRipple.prototype, "rippleConfig", {
                    /**
                     * Ripple configuration from the directive's input values.
                     * \@docs-private Implemented as part of RippleTarget
                     * @return {?}
                     */
                    get: function () {
                        return {
                            centered: this.centered,
                            radius: this.radius,
                            color: this.color,
                            animation: Object.assign({}, this._globalOptions.animation, this.animation),
                            terminateOnPointerUp: this._globalOptions.terminateOnPointerUp,
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRipple.prototype, "rippleDisabled", {
                    /**
                     * Whether ripples on pointer-down are disabled or not.
                     * \@docs-private Implemented as part of RippleTarget
                     * @return {?}
                     */
                    get: function () {
                        return this.disabled || !!this._globalOptions.disabled;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets up the trigger event listeners if ripples are enabled.
                 * @private
                 * @return {?}
                 */
                MatRipple.prototype._setupTriggerEventsIfEnabled = function () {
                    if (!this.disabled && this._isInitialized) {
                        this._rippleRenderer.setupTriggerEvents(this.trigger);
                    }
                };
                /**
                 * Launches a manual ripple at the specified coordinated or just by the ripple config.
                 * @param {?} configOrX
                 * @param {?=} y
                 * @param {?=} config
                 * @return {?}
                 */
                MatRipple.prototype.launch = function (configOrX, y, config) {
                    if (y === void 0) { y = 0; }
                    if (typeof configOrX === 'number') {
                        return this._rippleRenderer.fadeInRipple(configOrX, y, Object.assign({}, this.rippleConfig, config));
                    }
                    else {
                        return this._rippleRenderer.fadeInRipple(0, 0, Object.assign({}, this.rippleConfig, configOrX));
                    }
                };
                return MatRipple;
            }());
            MatRipple.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-ripple], [matRipple]',
                            exportAs: 'matRipple',
                            host: {
                                'class': 'mat-ripple',
                                '[class.mat-ripple-unbounded]': 'unbounded'
                            }
                        },] },
            ];
            /** @nocollapse */
            MatRipple.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["Platform"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatRipple.propDecorators = {
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleColor',] }],
                unbounded: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleUnbounded',] }],
                centered: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleCentered',] }],
                radius: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleRadius',] }],
                animation: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleAnimation',] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleDisabled',] }],
                trigger: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matRippleTrigger',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatRippleModule = /** @class */ (function () {
                function MatRippleModule() {
                }
                return MatRippleModule;
            }());
            MatRippleModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [MatCommonModule, _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_6__["PlatformModule"]],
                            exports: [MatRipple, MatCommonModule],
                            declarations: [MatRipple],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Component that shows a simplified checkbox without including any kind of "real" checkbox.
             * Meant to be used when the checkbox is purely decorative and a large number of them will be
             * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
             * Note that theming is meant to be handled by the parent element, e.g.
             * `mat-primary .mat-pseudo-checkbox`.
             *
             * Note that this component will be completely invisible to screen-reader users. This is *not*
             * interchangeable with `<mat-checkbox>` and should *not* be used if the user would directly
             * interact with the checkbox. The pseudo-checkbox should only be used as an implementation detail
             * of more complex components that appropriately handle selected / checked state.
             * \@docs-private
             */
            var MatPseudoCheckbox = /** @class */ (function () {
                /**
                 * @param {?=} _animationMode
                 */
                function MatPseudoCheckbox(_animationMode) {
                    this._animationMode = _animationMode;
                    /**
                     * Display state of the checkbox.
                     */
                    this.state = 'unchecked';
                    /**
                     * Whether the checkbox is disabled.
                     */
                    this.disabled = false;
                }
                return MatPseudoCheckbox;
            }());
            MatPseudoCheckbox.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            selector: 'mat-pseudo-checkbox',
                            styles: [".mat-pseudo-checkbox{width:16px;height:16px;border:2px solid;border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;flex-shrink:0;transition:border-color 90ms cubic-bezier(0,0,.2,.1),background-color 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox::after{position:absolute;opacity:0;content:'';border-bottom:2px solid currentColor;transition:opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate{border-color:transparent}._mat-animation-noopable.mat-pseudo-checkbox{transition:none;animation:none}._mat-animation-noopable.mat-pseudo-checkbox::after{transition:none}.mat-pseudo-checkbox-disabled{cursor:default}.mat-pseudo-checkbox-indeterminate::after{top:5px;left:1px;width:10px;opacity:1;border-radius:2px}.mat-pseudo-checkbox-checked::after{top:2.4px;left:1px;width:8px;height:3px;border-left:2px solid currentColor;transform:rotate(-45deg);opacity:1;box-sizing:content-box}"],
                            template: '',
                            host: {
                                'class': 'mat-pseudo-checkbox',
                                '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
                                '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
                                '[class.mat-pseudo-checkbox-disabled]': 'disabled',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatPseudoCheckbox.ctorParameters = function () { return [
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatPseudoCheckbox.propDecorators = {
                state: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatPseudoCheckboxModule = /** @class */ (function () {
                function MatPseudoCheckboxModule() {
                }
                return MatPseudoCheckboxModule;
            }());
            MatPseudoCheckboxModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            exports: [MatPseudoCheckbox],
                            declarations: [MatPseudoCheckbox]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatOptgroup.
            /**
             * \@docs-private
             */
            var MatOptgroupBase = /** @class */ (function () {
                function MatOptgroupBase() {
                }
                return MatOptgroupBase;
            }());
            /** @type {?} */
            var _MatOptgroupMixinBase = mixinDisabled(MatOptgroupBase);
            // Counter for unique group ids.
            /** @type {?} */
            var _uniqueOptgroupIdCounter = 0;
            /**
             * Component that is used to group instances of `mat-option`.
             */
            var MatOptgroup = /** @class */ (function (_super_1) {
                __extends(MatOptgroup, _super_1);
                function MatOptgroup() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * Unique id for the underlying label.
                     */
                    _this._labelId = "mat-optgroup-label-" + _uniqueOptgroupIdCounter++;
                    return _this;
                }
                return MatOptgroup;
            }(_MatOptgroupMixinBase));
            MatOptgroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-optgroup',
                            exportAs: 'matOptgroup',
                            template: "<label class=\"mat-optgroup-label\" [id]=\"_labelId\">{{ label }}<ng-content></ng-content></label><ng-content select=\"mat-option, ng-container\"></ng-content>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            inputs: ['disabled'],
                            styles: [".mat-optgroup-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;max-width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup-label[disabled]{cursor:default}[dir=rtl] .mat-optgroup-label{text-align:right}.mat-optgroup-label .mat-icon{margin-right:16px;vertical-align:middle}.mat-optgroup-label .mat-icon svg{vertical-align:top}[dir=rtl] .mat-optgroup-label .mat-icon{margin-left:16px;margin-right:0}"],
                            host: {
                                'class': 'mat-optgroup',
                                'role': 'group',
                                '[class.mat-optgroup-disabled]': 'disabled',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '[attr.aria-labelledby]': '_labelId',
                            }
                        },] },
            ];
            MatOptgroup.propDecorators = {
                label: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Option IDs need to be unique across components, so this counter exists outside of
             * the component definition.
             * @type {?}
             */
            var _uniqueIdCounter = 0;
            /**
             * Event object emitted by MatOption when selected or deselected.
             */
            var MatOptionSelectionChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?=} isUserInput
                 */
                function MatOptionSelectionChange(source, isUserInput) {
                    if (isUserInput === void 0) { isUserInput = false; }
                    this.source = source;
                    this.isUserInput = isUserInput;
                }
                return MatOptionSelectionChange;
            }());
            /**
             * Injection token used to provide the parent component to options.
             * @type {?}
             */
            var MAT_OPTION_PARENT_COMPONENT = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_OPTION_PARENT_COMPONENT');
            /**
             * Single option inside of a `<mat-select>` element.
             */
            var MatOption = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _changeDetectorRef
                 * @param {?} _parent
                 * @param {?} group
                 */
                function MatOption(_element, _changeDetectorRef, _parent, group) {
                    this._element = _element;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._parent = _parent;
                    this.group = group;
                    this._selected = false;
                    this._active = false;
                    this._disabled = false;
                    this._mostRecentViewValue = '';
                    /**
                     * The unique ID of the option.
                     */
                    this.id = "mat-option-" + _uniqueIdCounter++;
                    /**
                     * Event emitted when the option is selected or deselected.
                     */
                    // tslint:disable-next-line:no-output-on-prefix
                    this.onSelectionChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when the state of the option changes and any parents have to be notified.
                     */
                    this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                }
                Object.defineProperty(MatOption.prototype, "multiple", {
                    /**
                     * Whether the wrapping component is in multiple selection mode.
                     * @return {?}
                     */
                    get: function () { return this._parent && this._parent.multiple; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatOption.prototype, "selected", {
                    /**
                     * Whether or not the option is currently selected.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatOption.prototype, "disabled", {
                    /**
                     * Whether the option is disabled.
                     * @return {?}
                     */
                    get: function () { return (this.group && this.group.disabled) || this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatOption.prototype, "disableRipple", {
                    /**
                     * Whether ripples for the option are disabled.
                     * @return {?}
                     */
                    get: function () { return this._parent && this._parent.disableRipple; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatOption.prototype, "active", {
                    /**
                     * Whether or not the option is currently active and ready to be selected.
                     * An active option displays styles as if it is focused, but the
                     * focus is actually retained somewhere else. This comes in handy
                     * for components like autocomplete where focus must remain on the input.
                     * @return {?}
                     */
                    get: function () {
                        return this._active;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatOption.prototype, "viewValue", {
                    /**
                     * The displayed value of the option. It is necessary to show the selected option in the
                     * select's trigger.
                     * @return {?}
                     */
                    get: function () {
                        // TODO(kara): Add input property alternative for node envs.
                        return (this._getHostElement().textContent || '').trim();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Selects the option.
                 * @return {?}
                 */
                MatOption.prototype.select = function () {
                    if (!this._selected) {
                        this._selected = true;
                        this._changeDetectorRef.markForCheck();
                        this._emitSelectionChangeEvent();
                    }
                };
                /**
                 * Deselects the option.
                 * @return {?}
                 */
                MatOption.prototype.deselect = function () {
                    if (this._selected) {
                        this._selected = false;
                        this._changeDetectorRef.markForCheck();
                        this._emitSelectionChangeEvent();
                    }
                };
                /**
                 * Sets focus onto this option.
                 * @param {?=} _origin
                 * @param {?=} options
                 * @return {?}
                 */
                MatOption.prototype.focus = function (_origin, options) {
                    // Note that we aren't using `_origin`, but we need to keep it because some internal consumers
                    // use `MatOption` in a `FocusKeyManager` and we need it to match `FocusableOption`.
                    /** @type {?} */
                    var element = this._getHostElement();
                    if (typeof element.focus === 'function') {
                        element.focus(options);
                    }
                };
                /**
                 * This method sets display styles on the option to make it appear
                 * active. This is used by the ActiveDescendantKeyManager so key
                 * events will display the proper options as active on arrow key events.
                 * @return {?}
                 */
                MatOption.prototype.setActiveStyles = function () {
                    if (!this._active) {
                        this._active = true;
                        this._changeDetectorRef.markForCheck();
                    }
                };
                /**
                 * This method removes display styles on the option that made it appear
                 * active. This is used by the ActiveDescendantKeyManager so key
                 * events will display the proper options as active on arrow key events.
                 * @return {?}
                 */
                MatOption.prototype.setInactiveStyles = function () {
                    if (this._active) {
                        this._active = false;
                        this._changeDetectorRef.markForCheck();
                    }
                };
                /**
                 * Gets the label to be used when determining whether the option should be focused.
                 * @return {?}
                 */
                MatOption.prototype.getLabel = function () {
                    return this.viewValue;
                };
                /**
                 * Ensures the option is selected when activated from the keyboard.
                 * @param {?} event
                 * @return {?}
                 */
                MatOption.prototype._handleKeydown = function (event) {
                    if ((event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_10__["ENTER"] || event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_10__["SPACE"]) && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_10__["hasModifierKey"])(event)) {
                        this._selectViaInteraction();
                        // Prevent the page from scrolling down and form submits.
                        event.preventDefault();
                    }
                };
                /**
                 * `Selects the option while indicating the selection came from the user. Used to
                 * determine if the select's view -> model callback should be invoked.`
                 * @return {?}
                 */
                MatOption.prototype._selectViaInteraction = function () {
                    if (!this.disabled) {
                        this._selected = this.multiple ? !this._selected : true;
                        this._changeDetectorRef.markForCheck();
                        this._emitSelectionChangeEvent(true);
                    }
                };
                /**
                 * Gets the `aria-selected` value for the option. We explicitly omit the `aria-selected`
                 * attribute from single-selection, unselected options. Including the `aria-selected="false"`
                 * attributes adds a significant amount of noise to screen-reader users without providing useful
                 * information.
                 * @return {?}
                 */
                MatOption.prototype._getAriaSelected = function () {
                    return this.selected || (this.multiple ? false : null);
                };
                /**
                 * Returns the correct tabindex for the option depending on disabled state.
                 * @return {?}
                 */
                MatOption.prototype._getTabIndex = function () {
                    return this.disabled ? '-1' : '0';
                };
                /**
                 * Gets the host DOM element.
                 * @return {?}
                 */
                MatOption.prototype._getHostElement = function () {
                    return this._element.nativeElement;
                };
                /**
                 * @return {?}
                 */
                MatOption.prototype.ngAfterViewChecked = function () {
                    // Since parent components could be using the option's label to display the selected values
                    // (e.g. `mat-select`) and they don't have a way of knowing if the option's label has changed
                    // we have to check for changes in the DOM ourselves and dispatch an event. These checks are
                    // relatively cheap, however we still limit them only to selected options in order to avoid
                    // hitting the DOM too often.
                    if (this._selected) {
                        /** @type {?} */
                        var viewValue = this.viewValue;
                        if (viewValue !== this._mostRecentViewValue) {
                            this._mostRecentViewValue = viewValue;
                            this._stateChanges.next();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                MatOption.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                /**
                 * Emits the selection change event.
                 * @private
                 * @param {?=} isUserInput
                 * @return {?}
                 */
                MatOption.prototype._emitSelectionChangeEvent = function (isUserInput) {
                    if (isUserInput === void 0) { isUserInput = false; }
                    this.onSelectionChange.emit(new MatOptionSelectionChange(this, isUserInput));
                };
                return MatOption;
            }());
            MatOption.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-option',
                            exportAs: 'matOption',
                            host: {
                                'role': 'option',
                                '[attr.tabindex]': '_getTabIndex()',
                                '[class.mat-selected]': 'selected',
                                '[class.mat-option-multiple]': 'multiple',
                                '[class.mat-active]': 'active',
                                '[id]': 'id',
                                '[attr.aria-selected]': '_getAriaSelected()',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '[class.mat-option-disabled]': 'disabled',
                                '(click)': '_selectViaInteraction()',
                                '(keydown)': '_handleKeydown($event)',
                                'class': 'mat-option',
                            },
                            styles: [".mat-option{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;max-width:100%;position:relative;cursor:pointer;outline:0;display:flex;flex-direction:row;max-width:100%;box-sizing:border-box;align-items:center;-webkit-tap-highlight-color:transparent}.mat-option[disabled]{cursor:default}[dir=rtl] .mat-option{text-align:right}.mat-option .mat-icon{margin-right:16px;vertical-align:middle}.mat-option .mat-icon svg{vertical-align:top}[dir=rtl] .mat-option .mat-icon{margin-left:16px;margin-right:0}.mat-option[aria-disabled=true]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:32px}[dir=rtl] .mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:16px;padding-right:32px}@media (-ms-high-contrast:active){.mat-option{margin:0 1px}.mat-option.mat-active{border:solid 1px currentColor;margin:0}}.mat-option-text{display:inline-block;flex-grow:1;overflow:hidden;text-overflow:ellipsis}.mat-option .mat-option-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}@media (-ms-high-contrast:active){.mat-option .mat-option-ripple{opacity:.5}}.mat-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .mat-option-pseudo-checkbox{margin-left:8px;margin-right:0}"],
                            template: "<mat-pseudo-checkbox *ngIf=\"multiple\" class=\"mat-option-pseudo-checkbox\" [state]=\"selected ? 'checked' : ''\" [disabled]=\"disabled\"></mat-pseudo-checkbox><span class=\"mat-option-text\"><ng-content></ng-content></span><div class=\"mat-option-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"disabled || disableRipple\"></div>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatOption.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_OPTION_PARENT_COMPONENT,] }] },
                { type: MatOptgroup, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatOption.propDecorators = {
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                onSelectionChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * Counts the amount of option group labels that precede the specified option.
             * \@docs-private
             * @param {?} optionIndex Index of the option at which to start counting.
             * @param {?} options Flat list of all of the options.
             * @param {?} optionGroups Flat list of all of the option groups.
             * @return {?}
             */
            function _countGroupLabelsBeforeOption(optionIndex, options, optionGroups) {
                if (optionGroups.length) {
                    /** @type {?} */
                    var optionsArray = options.toArray();
                    /** @type {?} */
                    var groups = optionGroups.toArray();
                    /** @type {?} */
                    var groupCounter = 0;
                    for (var i = 0; i < optionIndex + 1; i++) {
                        if (optionsArray[i].group && optionsArray[i].group === groups[groupCounter]) {
                            groupCounter++;
                        }
                    }
                    return groupCounter;
                }
                return 0;
            }
            /**
             * Determines the position to which to scroll a panel in order for an option to be into view.
             * \@docs-private
             * @param {?} optionIndex Index of the option to be scrolled into the view.
             * @param {?} optionHeight Height of the options.
             * @param {?} currentScrollPosition Current scroll position of the panel.
             * @param {?} panelHeight Height of the panel.
             * @return {?}
             */
            function _getOptionScrollPosition(optionIndex, optionHeight, currentScrollPosition, panelHeight) {
                /** @type {?} */
                var optionOffset = optionIndex * optionHeight;
                if (optionOffset < currentScrollPosition) {
                    return optionOffset;
                }
                if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
                    return Math.max(0, optionOffset - panelHeight + optionHeight);
                }
                return currentScrollPosition;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatOptionModule = /** @class */ (function () {
                function MatOptionModule() {
                }
                return MatOptionModule;
            }());
            MatOptionModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [MatRippleModule, _angular_common__WEBPACK_IMPORTED_MODULE_11__["CommonModule"], MatPseudoCheckboxModule],
                            exports: [MatOption, MatOptgroup],
                            declarations: [MatOption, MatOptgroup]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * InjectionToken that can be used to specify the global label options.
             * @type {?}
             */
            var MAT_LABEL_GLOBAL_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-label-global-options');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * When constructing a Date, the month is zero-based. This can be confusing, since people are
             * used to seeing them one-based. So we create these aliases to make writing the tests easier.
             * \@docs-private
             * \@breaking-change 8.0.0 Remove this with V8 since it was only targeted for testing.
             * @type {?}
             */
            var JAN = 0;
            /** @type {?} */
            var FEB = 1;
            /** @type {?} */
            var MAR = 2;
            /** @type {?} */
            var APR = 3;
            /** @type {?} */
            var MAY = 4;
            /** @type {?} */
            var JUN = 5;
            /** @type {?} */
            var JUL = 6;
            /** @type {?} */
            var AUG = 7;
            /** @type {?} */
            var SEP = 8;
            /** @type {?} */
            var OCT = 9;
            /** @type {?} */
            var NOV = 10;
            /** @type {?} */
            var DEC = 11;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=core.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/datepicker.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/datepicker.js ***!
          \**************************************************************/
        /*! exports provided: MatMultiYearView, yearsPerPage, yearsPerRow, MatDatepickerModule, MatCalendarHeader, MatCalendar, MatCalendarCell, MatCalendarBody, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY, MAT_DATEPICKER_SCROLL_STRATEGY, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER, MatDatepickerContent, MatDatepicker, matDatepickerAnimations, MAT_DATEPICKER_VALUE_ACCESSOR, MAT_DATEPICKER_VALIDATORS, MatDatepickerInputEvent, MatDatepickerInput, MatDatepickerIntl, MatDatepickerToggleIcon, MatDatepickerToggle, MatMonthView, MatYearView */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMultiYearView", function () { return MatMultiYearView; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearsPerPage", function () { return yearsPerPage; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearsPerRow", function () { return yearsPerRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerModule", function () { return MatDatepickerModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCalendarHeader", function () { return MatCalendarHeader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCalendar", function () { return MatCalendar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCalendarCell", function () { return MatCalendarCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCalendarBody", function () { return MatCalendarBody; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY", function () { return MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_SCROLL_STRATEGY", function () { return MAT_DATEPICKER_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER", function () { return MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerContent", function () { return MatDatepickerContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepicker", function () { return MatDatepicker; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matDatepickerAnimations", function () { return matDatepickerAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_VALUE_ACCESSOR", function () { return MAT_DATEPICKER_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_VALIDATORS", function () { return MAT_DATEPICKER_VALIDATORS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerInputEvent", function () { return MatDatepickerInputEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerInput", function () { return MatDatepickerInput; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerIntl", function () { return MatDatepickerIntl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerToggleIcon", function () { return MatDatepickerToggleIcon; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerToggle", function () { return MatDatepickerToggle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMonthView", function () { return MatMonthView; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatYearView", function () { return MatYearView; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
            /* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
            /* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             * @param {?} provider
             * @return {?}
             */
            function createMissingDateImplError(provider) {
                return Error("MatDatepicker: No provider found for " + provider + ". You must import one of the following " +
                    "modules at your application root: MatNativeDateModule, MatMomentDateModule, or provide a " +
                    "custom implementation.");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Datepicker data that requires internationalization.
             */
            var MatDatepickerIntl = /** @class */ (function () {
                function MatDatepickerIntl() {
                    /**
                     * Stream that emits whenever the labels here are changed. Use this to notify
                     * components if the labels have changed after initialization.
                     */
                    this.changes = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * A label for the calendar popup (used by screen readers).
                     */
                    this.calendarLabel = 'Calendar';
                    /**
                     * A label for the button used to open the calendar popup (used by screen readers).
                     */
                    this.openCalendarLabel = 'Open calendar';
                    /**
                     * A label for the previous month button (used by screen readers).
                     */
                    this.prevMonthLabel = 'Previous month';
                    /**
                     * A label for the next month button (used by screen readers).
                     */
                    this.nextMonthLabel = 'Next month';
                    /**
                     * A label for the previous year button (used by screen readers).
                     */
                    this.prevYearLabel = 'Previous year';
                    /**
                     * A label for the next year button (used by screen readers).
                     */
                    this.nextYearLabel = 'Next year';
                    /**
                     * A label for the previous multi-year button (used by screen readers).
                     */
                    this.prevMultiYearLabel = 'Previous 20 years';
                    /**
                     * A label for the next multi-year button (used by screen readers).
                     */
                    this.nextMultiYearLabel = 'Next 20 years';
                    /**
                     * A label for the 'switch to month view' button (used by screen readers).
                     */
                    this.switchToMonthViewLabel = 'Choose date';
                    /**
                     * A label for the 'switch to year view' button (used by screen readers).
                     */
                    this.switchToMultiYearViewLabel = 'Choose month and year';
                }
                /**
                 * Formats a range of years.
                 * @param {?} start
                 * @param {?} end
                 * @return {?}
                 */
                MatDatepickerIntl.prototype.formatYearRange = function (start, end) {
                    return start + " \u2013 " + end;
                };
                return MatDatepickerIntl;
            }());
            MatDatepickerIntl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ MatDatepickerIntl.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function MatDatepickerIntl_Factory() { return new MatDatepickerIntl(); }, token: MatDatepickerIntl, providedIn: "root" });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An internal class that represents the data corresponding to a single calendar cell.
             * \@docs-private
             */
            var MatCalendarCell = /** @class */ (function () {
                /**
                 * @param {?} value
                 * @param {?} displayValue
                 * @param {?} ariaLabel
                 * @param {?} enabled
                 * @param {?=} cssClasses
                 */
                function MatCalendarCell(value, displayValue, ariaLabel, enabled, cssClasses) {
                    this.value = value;
                    this.displayValue = displayValue;
                    this.ariaLabel = ariaLabel;
                    this.enabled = enabled;
                    this.cssClasses = cssClasses;
                }
                return MatCalendarCell;
            }());
            /**
             * An internal component used to display calendar data in a table.
             * \@docs-private
             */
            var MatCalendarBody = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _ngZone
                 */
                function MatCalendarBody(_elementRef, _ngZone) {
                    this._elementRef = _elementRef;
                    this._ngZone = _ngZone;
                    /**
                     * The number of columns in the table.
                     */
                    this.numCols = 7;
                    /**
                     * The cell number of the active cell in the table.
                     */
                    this.activeCell = 0;
                    /**
                     * The aspect ratio (width / height) to use for the cells in the table. This aspect ratio will be
                     * maintained even as the table resizes.
                     */
                    this.cellAspectRatio = 1;
                    /**
                     * Emits when a new value is selected.
                     */
                    this.selectedValueChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @param {?} cell
                 * @return {?}
                 */
                MatCalendarBody.prototype._cellClicked = function (cell) {
                    if (cell.enabled) {
                        this.selectedValueChange.emit(cell.value);
                    }
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatCalendarBody.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var columnChanges = changes['numCols'];
                    var _c = this, rows = _c.rows, numCols = _c.numCols;
                    if (changes['rows'] || columnChanges) {
                        this._firstRowOffset = rows && rows.length && rows[0].length ? numCols - rows[0].length : 0;
                    }
                    if (changes['cellAspectRatio'] || columnChanges || !this._cellPadding) {
                        this._cellPadding = 50 * this.cellAspectRatio / numCols + "%";
                    }
                    if (columnChanges || !this._cellWidth) {
                        this._cellWidth = 100 / numCols + "%";
                    }
                };
                /**
                 * @param {?} rowIndex
                 * @param {?} colIndex
                 * @return {?}
                 */
                MatCalendarBody.prototype._isActiveCell = function (rowIndex, colIndex) {
                    /** @type {?} */
                    var cellNumber = rowIndex * this.numCols + colIndex;
                    // Account for the fact that the first row may not have as many cells.
                    if (rowIndex) {
                        cellNumber -= this._firstRowOffset;
                    }
                    return cellNumber == this.activeCell;
                };
                /**
                 * Focuses the active cell after the microtask queue is empty.
                 * @return {?}
                 */
                MatCalendarBody.prototype._focusActiveCell = function () {
                    var _this = this;
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._ngZone.onStable.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["take"])(1)).subscribe(( /**
                         * @return {?}
                         */function () {
                            /** @type {?} */
                            var activeCell = _this._elementRef.nativeElement.querySelector('.mat-calendar-body-active');
                            if (activeCell) {
                                activeCell.focus();
                            }
                        }));
                    }));
                };
                return MatCalendarBody;
            }());
            MatCalendarBody.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: '[mat-calendar-body]',
                            template: "<tr *ngIf=\"_firstRowOffset < labelMinRequiredCells\" aria-hidden=\"true\"><td class=\"mat-calendar-body-label\" [attr.colspan]=\"numCols\" [style.paddingTop]=\"_cellPadding\" [style.paddingBottom]=\"_cellPadding\">{{label}}</td></tr><tr *ngFor=\"let row of rows; let rowIndex = index\" role=\"row\"><td *ngIf=\"rowIndex === 0 && _firstRowOffset\" aria-hidden=\"true\" class=\"mat-calendar-body-label\" [attr.colspan]=\"_firstRowOffset\" [style.paddingTop]=\"_cellPadding\" [style.paddingBottom]=\"_cellPadding\">{{_firstRowOffset >= labelMinRequiredCells ? label : ''}}</td><td *ngFor=\"let item of row; let colIndex = index\" role=\"gridcell\" class=\"mat-calendar-body-cell\" [ngClass]=\"item.cssClasses\" [tabindex]=\"_isActiveCell(rowIndex, colIndex) ? 0 : -1\" [class.mat-calendar-body-disabled]=\"!item.enabled\" [class.mat-calendar-body-active]=\"_isActiveCell(rowIndex, colIndex)\" [attr.aria-label]=\"item.ariaLabel\" [attr.aria-disabled]=\"!item.enabled || null\" [attr.aria-selected]=\"selectedValue === item.value\" (click)=\"_cellClicked(item)\" [style.width]=\"_cellWidth\" [style.paddingTop]=\"_cellPadding\" role=\"button\" [style.paddingBottom]=\"_cellPadding\"><div class=\"mat-calendar-body-cell-content\" [class.mat-calendar-body-selected]=\"selectedValue === item.value\" [class.mat-calendar-body-today]=\"todayValue === item.value\">{{item.displayValue}}</div></td></tr>",
                            styles: [".mat-calendar-body{min-width:224px}.mat-calendar-body-label{height:0;line-height:0;text-align:left;padding-left:4.71429%;padding-right:4.71429%}.mat-calendar-body-cell{position:relative;height:0;line-height:0;text-align:center;outline:0;cursor:pointer}.mat-calendar-body-disabled{cursor:default}.mat-calendar-body-cell-content{position:absolute;top:5%;left:5%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;line-height:1;border-width:1px;border-style:solid;border-radius:999px}@media (-ms-high-contrast:active){.mat-calendar-body-cell-content{border:none}}@media (-ms-high-contrast:active){.mat-calendar-body-selected,.mat-datepicker-popup:not(:empty){outline:solid 1px}.mat-calendar-body-today{outline:dotted 1px}.cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected),.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected){outline:dotted 2px}}[dir=rtl] .mat-calendar-body-label{text-align:right}"],
                            host: {
                                'class': 'mat-calendar-body',
                                'role': 'grid',
                                'aria-readonly': 'true'
                            },
                            exportAs: 'matCalendarBody',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatCalendarBody.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] }
            ]; };
            MatCalendarBody.propDecorators = {
                label: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                rows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                todayValue: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedValue: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                labelMinRequiredCells: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                numCols: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                activeCell: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                cellAspectRatio: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedValueChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var DAYS_PER_WEEK = 7;
            /**
             * An internal component used to display a single month in the datepicker.
             * \@docs-private
             * @template D
             */
            var MatMonthView = /** @class */ (function () {
                /**
                 * @param {?} _changeDetectorRef
                 * @param {?} _dateFormats
                 * @param {?} _dateAdapter
                 * @param {?=} _dir
                 */
                function MatMonthView(_changeDetectorRef, _dateFormats, _dateAdapter, _dir) {
                    this._changeDetectorRef = _changeDetectorRef;
                    this._dateFormats = _dateFormats;
                    this._dateAdapter = _dateAdapter;
                    this._dir = _dir;
                    /**
                     * Emits when a new date is selected.
                     */
                    this.selectedChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when any date is selected.
                     */
                    this._userSelection = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when any date is activated.
                     */
                    this.activeDateChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    if (!this._dateAdapter) {
                        throw createMissingDateImplError('DateAdapter');
                    }
                    if (!this._dateFormats) {
                        throw createMissingDateImplError('MAT_DATE_FORMATS');
                    }
                    this._activeDate = this._dateAdapter.today();
                }
                Object.defineProperty(MatMonthView.prototype, "activeDate", {
                    /**
                     * The date to display in this month view (everything other than the month and year is ignored).
                     * @return {?}
                     */
                    get: function () { return this._activeDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var oldActiveDate = this._activeDate;
                        /** @type {?} */
                        var validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
                        this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
                        if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
                            this._init();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMonthView.prototype, "selected", {
                    /**
                     * The currently selected date.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                        this._selectedDate = this._getDateInCurrentMonth(this._selected);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMonthView.prototype, "minDate", {
                    /**
                     * The minimum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._minDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMonthView.prototype, "maxDate", {
                    /**
                     * The maximum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._maxDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatMonthView.prototype.ngAfterContentInit = function () {
                    this._init();
                };
                /**
                 * Handles when a new date is selected.
                 * @param {?} date
                 * @return {?}
                 */
                MatMonthView.prototype._dateSelected = function (date) {
                    if (this._selectedDate != date) {
                        /** @type {?} */
                        var selectedYear = this._dateAdapter.getYear(this.activeDate);
                        /** @type {?} */
                        var selectedMonth = this._dateAdapter.getMonth(this.activeDate);
                        /** @type {?} */
                        var selectedDate = this._dateAdapter.createDate(selectedYear, selectedMonth, date);
                        this.selectedChange.emit(selectedDate);
                    }
                    this._userSelection.emit();
                };
                /**
                 * Handles keydown events on the calendar body when calendar is in month view.
                 * @param {?} event
                 * @return {?}
                 */
                MatMonthView.prototype._handleCalendarBodyKeydown = function (event) {
                    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
                    // disabled ones from being selected. This may not be ideal, we should look into whether
                    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
                    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
                    // disabled ones from being selected. This may not be ideal, we should look into whether
                    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
                    /** @type {?} */
                    var oldActiveDate = this._activeDate;
                    /** @type {?} */
                    var isRtl = this._isRtl();
                    switch (event.keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["LEFT_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? 1 : -1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["RIGHT_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? -1 : 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["UP_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["DOWN_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["HOME"]:
                            this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["END"]:
                            this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, (this._dateAdapter.getNumDaysInMonth(this._activeDate) -
                                this._dateAdapter.getDate(this._activeDate)));
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_UP"]:
                            this.activeDate = event.altKey ?
                                this._dateAdapter.addCalendarYears(this._activeDate, -1) :
                                this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_DOWN"]:
                            this.activeDate = event.altKey ?
                                this._dateAdapter.addCalendarYears(this._activeDate, 1) :
                                this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["ENTER"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["SPACE"]:
                            if (!this.dateFilter || this.dateFilter(this._activeDate)) {
                                this._dateSelected(this._dateAdapter.getDate(this._activeDate));
                                this._userSelection.emit();
                                // Prevent unexpected default actions such as form submission.
                                event.preventDefault();
                            }
                            return;
                        default:
                            // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                            return;
                    }
                    if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
                        this.activeDateChange.emit(this.activeDate);
                    }
                    this._focusActiveCell();
                    // Prevent unexpected default actions such as form submission.
                    event.preventDefault();
                };
                /**
                 * Initializes this month view.
                 * @return {?}
                 */
                MatMonthView.prototype._init = function () {
                    this._selectedDate = this._getDateInCurrentMonth(this.selected);
                    this._todayDate = this._getDateInCurrentMonth(this._dateAdapter.today());
                    this._monthLabel =
                        this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)]
                            .toLocaleUpperCase();
                    /** @type {?} */
                    var firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
                    this._firstWeekOffset =
                        (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) -
                            this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
                    this._initWeekdays();
                    this._createWeekCells();
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Focuses the active cell after the microtask queue is empty.
                 * @return {?}
                 */
                MatMonthView.prototype._focusActiveCell = function () {
                    this._matCalendarBody._focusActiveCell();
                };
                /**
                 * Initializes the weekdays.
                 * @private
                 * @return {?}
                 */
                MatMonthView.prototype._initWeekdays = function () {
                    /** @type {?} */
                    var firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
                    /** @type {?} */
                    var narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
                    /** @type {?} */
                    var longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
                    // Rotate the labels for days of the week based on the configured first day of the week.
                    /** @type {?} */
                    var weekdays = longWeekdays.map(( /**
                     * @param {?} long
                     * @param {?} i
                     * @return {?}
                     */function (long, i) {
                        return { long: long, narrow: narrowWeekdays[i] };
                    }));
                    this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
                };
                /**
                 * Creates MatCalendarCells for the dates in this month.
                 * @private
                 * @return {?}
                 */
                MatMonthView.prototype._createWeekCells = function () {
                    /** @type {?} */
                    var daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
                    /** @type {?} */
                    var dateNames = this._dateAdapter.getDateNames();
                    this._weeks = [[]];
                    for (var i = 0, cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
                        if (cell == DAYS_PER_WEEK) {
                            this._weeks.push([]);
                            cell = 0;
                        }
                        /** @type {?} */
                        var date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1);
                        /** @type {?} */
                        var enabled = this._shouldEnableDate(date);
                        /** @type {?} */
                        var ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
                        /** @type {?} */
                        var cellClasses = this.dateClass ? this.dateClass(date) : undefined;
                        this._weeks[this._weeks.length - 1]
                            .push(new MatCalendarCell(i + 1, dateNames[i], ariaLabel, enabled, cellClasses));
                    }
                };
                /**
                 * Date filter for the month
                 * @private
                 * @param {?} date
                 * @return {?}
                 */
                MatMonthView.prototype._shouldEnableDate = function (date) {
                    return !!date &&
                        (!this.dateFilter || this.dateFilter(date)) &&
                        (!this.minDate || this._dateAdapter.compareDate(date, this.minDate) >= 0) &&
                        (!this.maxDate || this._dateAdapter.compareDate(date, this.maxDate) <= 0);
                };
                /**
                 * Gets the date in this month that the given Date falls on.
                 * Returns null if the given Date is in another month.
                 * @private
                 * @param {?} date
                 * @return {?}
                 */
                MatMonthView.prototype._getDateInCurrentMonth = function (date) {
                    return date && this._hasSameMonthAndYear(date, this.activeDate) ?
                        this._dateAdapter.getDate(date) : null;
                };
                /**
                 * Checks whether the 2 dates are non-null and fall within the same month of the same year.
                 * @private
                 * @param {?} d1
                 * @param {?} d2
                 * @return {?}
                 */
                MatMonthView.prototype._hasSameMonthAndYear = function (d1, d2) {
                    return !!(d1 && d2 && this._dateAdapter.getMonth(d1) == this._dateAdapter.getMonth(d2) &&
                        this._dateAdapter.getYear(d1) == this._dateAdapter.getYear(d2));
                };
                /**
                 * @private
                 * @param {?} obj The object to check.
                 * @return {?} The given object if it is both a date instance and valid, otherwise null.
                 */
                MatMonthView.prototype._getValidDateOrNull = function (obj) {
                    return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
                };
                /**
                 * Determines whether the user has the RTL layout direction.
                 * @private
                 * @return {?}
                 */
                MatMonthView.prototype._isRtl = function () {
                    return this._dir && this._dir.value === 'rtl';
                };
                return MatMonthView;
            }());
            MatMonthView.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-month-view',
                            template: "<table class=\"mat-calendar-table\" role=\"presentation\"><thead class=\"mat-calendar-table-header\"><tr><th scope=\"col\" *ngFor=\"let day of _weekdays\" [attr.aria-label]=\"day.long\">{{day.narrow}}</th></tr><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"7\" aria-hidden=\"true\"></th></tr></thead><tbody mat-calendar-body [label]=\"_monthLabel\" [rows]=\"_weeks\" [todayValue]=\"_todayDate\" [selectedValue]=\"_selectedDate\" [labelMinRequiredCells]=\"3\" [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\" (selectedValueChange)=\"_dateSelected($event)\" (keydown)=\"_handleCalendarBodyKeydown($event)\"></tbody></table>",
                            exportAs: 'matMonthView',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush
                        },] },
            ];
            /** @nocollapse */
            MatMonthView.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_DATE_FORMATS"],] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatMonthView.propDecorators = {
                activeDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                minDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                maxDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateFilter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _userSelection: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                activeDateChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _matCalendarBody: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatCalendarBody, { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var yearsPerPage = 24;
            /** @type {?} */
            var yearsPerRow = 4;
            /**
             * An internal component used to display a year selector in the datepicker.
             * \@docs-private
             * @template D
             */
            var MatMultiYearView = /** @class */ (function () {
                /**
                 * @param {?} _changeDetectorRef
                 * @param {?} _dateAdapter
                 * @param {?=} _dir
                 */
                function MatMultiYearView(_changeDetectorRef, _dateAdapter, _dir) {
                    this._changeDetectorRef = _changeDetectorRef;
                    this._dateAdapter = _dateAdapter;
                    this._dir = _dir;
                    /**
                     * Emits when a new year is selected.
                     */
                    this.selectedChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits the selected year. This doesn't imply a change on the selected date
                     */
                    this.yearSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when any date is activated.
                     */
                    this.activeDateChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    if (!this._dateAdapter) {
                        throw createMissingDateImplError('DateAdapter');
                    }
                    this._activeDate = this._dateAdapter.today();
                }
                Object.defineProperty(MatMultiYearView.prototype, "activeDate", {
                    /**
                     * The date to display in this multi-year view (everything other than the year is ignored).
                     * @return {?}
                     */
                    get: function () { return this._activeDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var oldActiveDate = this._activeDate;
                        /** @type {?} */
                        var validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
                        this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
                        if (!isSameMultiYearView(this._dateAdapter, oldActiveDate, this._activeDate, this.minDate, this.maxDate)) {
                            this._init();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMultiYearView.prototype, "selected", {
                    /**
                     * The currently selected date.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                        this._selectedYear = this._selected && this._dateAdapter.getYear(this._selected);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMultiYearView.prototype, "minDate", {
                    /**
                     * The minimum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._minDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMultiYearView.prototype, "maxDate", {
                    /**
                     * The maximum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._maxDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatMultiYearView.prototype.ngAfterContentInit = function () {
                    this._init();
                };
                /**
                 * Initializes this multi-year view.
                 * @return {?}
                 */
                MatMultiYearView.prototype._init = function () {
                    var _this = this;
                    this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
                    // We want a range years such that we maximize the number of
                    // enabled dates visible at once. This prevents issues where the minimum year
                    // is the last item of a page OR the maximum year is the first item of a page.
                    // The offset from the active year to the "slot" for the starting year is the
                    // *actual* first rendered year in the multi-year view.
                    /** @type {?} */
                    var activeYear = this._dateAdapter.getYear(this._activeDate);
                    /** @type {?} */
                    var minYearOfPage = activeYear - getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
                    this._years = [];
                    for (var i = 0, row = []; i < yearsPerPage; i++) {
                        row.push(minYearOfPage + i);
                        if (row.length == yearsPerRow) {
                            this._years.push(row.map(( /**
                             * @param {?} year
                             * @return {?}
                             */function (/**
                             * @param {?} year
                             * @return {?}
                             */ year) { return _this._createCellForYear(year); })));
                            row = [];
                        }
                    }
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Handles when a new year is selected.
                 * @param {?} year
                 * @return {?}
                 */
                MatMultiYearView.prototype._yearSelected = function (year) {
                    this.yearSelected.emit(this._dateAdapter.createDate(year, 0, 1));
                    /** @type {?} */
                    var month = this._dateAdapter.getMonth(this.activeDate);
                    /** @type {?} */
                    var daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(year, month, 1));
                    this.selectedChange.emit(this._dateAdapter.createDate(year, month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
                };
                /**
                 * Handles keydown events on the calendar body when calendar is in multi-year view.
                 * @param {?} event
                 * @return {?}
                 */
                MatMultiYearView.prototype._handleCalendarBodyKeydown = function (event) {
                    /** @type {?} */
                    var oldActiveDate = this._activeDate;
                    /** @type {?} */
                    var isRtl = this._isRtl();
                    switch (event.keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["LEFT_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? 1 : -1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["RIGHT_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? -1 : 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["UP_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -yearsPerRow);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["DOWN_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerRow);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["HOME"]:
                            this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate));
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["END"]:
                            this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerPage - getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate) - 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_UP"]:
                            this.activeDate =
                                this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -yearsPerPage * 10 : -yearsPerPage);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_DOWN"]:
                            this.activeDate =
                                this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? yearsPerPage * 10 : yearsPerPage);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["ENTER"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["SPACE"]:
                            this._yearSelected(this._dateAdapter.getYear(this._activeDate));
                            break;
                        default:
                            // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                            return;
                    }
                    if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
                        this.activeDateChange.emit(this.activeDate);
                    }
                    this._focusActiveCell();
                    // Prevent unexpected default actions such as form submission.
                    event.preventDefault();
                };
                /**
                 * @return {?}
                 */
                MatMultiYearView.prototype._getActiveCell = function () {
                    return getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
                };
                /**
                 * Focuses the active cell after the microtask queue is empty.
                 * @return {?}
                 */
                MatMultiYearView.prototype._focusActiveCell = function () {
                    this._matCalendarBody._focusActiveCell();
                };
                /**
                 * Creates an MatCalendarCell for the given year.
                 * @private
                 * @param {?} year
                 * @return {?}
                 */
                MatMultiYearView.prototype._createCellForYear = function (year) {
                    /** @type {?} */
                    var yearName = this._dateAdapter.getYearName(this._dateAdapter.createDate(year, 0, 1));
                    return new MatCalendarCell(year, yearName, yearName, this._shouldEnableYear(year));
                };
                /**
                 * Whether the given year is enabled.
                 * @private
                 * @param {?} year
                 * @return {?}
                 */
                MatMultiYearView.prototype._shouldEnableYear = function (year) {
                    // disable if the year is greater than maxDate lower than minDate
                    if (year === undefined || year === null ||
                        (this.maxDate && year > this._dateAdapter.getYear(this.maxDate)) ||
                        (this.minDate && year < this._dateAdapter.getYear(this.minDate))) {
                        return false;
                    }
                    // enable if it reaches here and there's no filter defined
                    if (!this.dateFilter) {
                        return true;
                    }
                    /** @type {?} */
                    var firstOfYear = this._dateAdapter.createDate(year, 0, 1);
                    // If any date in the year is enabled count the year as enabled.
                    for (var date = firstOfYear; this._dateAdapter.getYear(date) == year; date = this._dateAdapter.addCalendarDays(date, 1)) {
                        if (this.dateFilter(date)) {
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * @private
                 * @param {?} obj The object to check.
                 * @return {?} The given object if it is both a date instance and valid, otherwise null.
                 */
                MatMultiYearView.prototype._getValidDateOrNull = function (obj) {
                    return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
                };
                /**
                 * Determines whether the user has the RTL layout direction.
                 * @private
                 * @return {?}
                 */
                MatMultiYearView.prototype._isRtl = function () {
                    return this._dir && this._dir.value === 'rtl';
                };
                return MatMultiYearView;
            }());
            MatMultiYearView.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-multi-year-view',
                            template: "<table class=\"mat-calendar-table\" role=\"presentation\"><thead class=\"mat-calendar-table-header\"><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"4\"></th></tr></thead><tbody mat-calendar-body [rows]=\"_years\" [todayValue]=\"_todayYear\" [selectedValue]=\"_selectedYear\" [numCols]=\"4\" [cellAspectRatio]=\"4 / 7\" [activeCell]=\"_getActiveCell()\" (selectedValueChange)=\"_yearSelected($event)\" (keydown)=\"_handleCalendarBodyKeydown($event)\"></tbody></table>",
                            exportAs: 'matMultiYearView',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush
                        },] },
            ];
            /** @nocollapse */
            MatMultiYearView.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatMultiYearView.propDecorators = {
                activeDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                minDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                maxDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateFilter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                yearSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                activeDateChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _matCalendarBody: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatCalendarBody, { static: false },] }]
            };
            /**
             * @template D
             * @param {?} dateAdapter
             * @param {?} date1
             * @param {?} date2
             * @param {?} minDate
             * @param {?} maxDate
             * @return {?}
             */
            function isSameMultiYearView(dateAdapter, date1, date2, minDate, maxDate) {
                /** @type {?} */
                var year1 = dateAdapter.getYear(date1);
                /** @type {?} */
                var year2 = dateAdapter.getYear(date2);
                /** @type {?} */
                var startingYear = getStartingYear(dateAdapter, minDate, maxDate);
                return Math.floor((year1 - startingYear) / yearsPerPage) ===
                    Math.floor((year2 - startingYear) / yearsPerPage);
            }
            /**
             * When the multi-year view is first opened, the active year will be in view.
             * So we compute how many years are between the active year and the *slot* where our
             * "startingYear" will render when paged into view.
             * @template D
             * @param {?} dateAdapter
             * @param {?} activeDate
             * @param {?} minDate
             * @param {?} maxDate
             * @return {?}
             */
            function getActiveOffset(dateAdapter, activeDate, minDate, maxDate) {
                /** @type {?} */
                var activeYear = dateAdapter.getYear(activeDate);
                return euclideanModulo((activeYear - getStartingYear(dateAdapter, minDate, maxDate)), yearsPerPage);
            }
            /**
             * We pick a "starting" year such that either the maximum year would be at the end
             * or the minimum year would be at the beginning of a page.
             * @template D
             * @param {?} dateAdapter
             * @param {?} minDate
             * @param {?} maxDate
             * @return {?}
             */
            function getStartingYear(dateAdapter, minDate, maxDate) {
                /** @type {?} */
                var startingYear = 0;
                if (maxDate) {
                    /** @type {?} */
                    var maxYear = dateAdapter.getYear(maxDate);
                    startingYear = maxYear - yearsPerPage + 1;
                }
                else if (minDate) {
                    startingYear = dateAdapter.getYear(minDate);
                }
                return startingYear;
            }
            /**
             * Gets remainder that is non-negative, even if first number is negative
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function euclideanModulo(a, b) {
                return (a % b + b) % b;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An internal component used to display a single year in the datepicker.
             * \@docs-private
             * @template D
             */
            var MatYearView = /** @class */ (function () {
                /**
                 * @param {?} _changeDetectorRef
                 * @param {?} _dateFormats
                 * @param {?} _dateAdapter
                 * @param {?=} _dir
                 */
                function MatYearView(_changeDetectorRef, _dateFormats, _dateAdapter, _dir) {
                    this._changeDetectorRef = _changeDetectorRef;
                    this._dateFormats = _dateFormats;
                    this._dateAdapter = _dateAdapter;
                    this._dir = _dir;
                    /**
                     * Emits when a new month is selected.
                     */
                    this.selectedChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits the selected month. This doesn't imply a change on the selected date
                     */
                    this.monthSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when any date is activated.
                     */
                    this.activeDateChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    if (!this._dateAdapter) {
                        throw createMissingDateImplError('DateAdapter');
                    }
                    if (!this._dateFormats) {
                        throw createMissingDateImplError('MAT_DATE_FORMATS');
                    }
                    this._activeDate = this._dateAdapter.today();
                }
                Object.defineProperty(MatYearView.prototype, "activeDate", {
                    /**
                     * The date to display in this year view (everything other than the year is ignored).
                     * @return {?}
                     */
                    get: function () { return this._activeDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var oldActiveDate = this._activeDate;
                        /** @type {?} */
                        var validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
                        this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
                        if (this._dateAdapter.getYear(oldActiveDate) !== this._dateAdapter.getYear(this._activeDate)) {
                            this._init();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatYearView.prototype, "selected", {
                    /**
                     * The currently selected date.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                        this._selectedMonth = this._getMonthInCurrentYear(this._selected);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatYearView.prototype, "minDate", {
                    /**
                     * The minimum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._minDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatYearView.prototype, "maxDate", {
                    /**
                     * The maximum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._maxDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatYearView.prototype.ngAfterContentInit = function () {
                    this._init();
                };
                /**
                 * Handles when a new month is selected.
                 * @param {?} month
                 * @return {?}
                 */
                MatYearView.prototype._monthSelected = function (month) {
                    /** @type {?} */
                    var normalizedDate = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
                    this.monthSelected.emit(normalizedDate);
                    /** @type {?} */
                    var daysInMonth = this._dateAdapter.getNumDaysInMonth(normalizedDate);
                    this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
                };
                /**
                 * Handles keydown events on the calendar body when calendar is in year view.
                 * @param {?} event
                 * @return {?}
                 */
                MatYearView.prototype._handleCalendarBodyKeydown = function (event) {
                    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
                    // disabled ones from being selected. This may not be ideal, we should look into whether
                    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
                    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
                    // disabled ones from being selected. This may not be ideal, we should look into whether
                    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
                    /** @type {?} */
                    var oldActiveDate = this._activeDate;
                    /** @type {?} */
                    var isRtl = this._isRtl();
                    switch (event.keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["LEFT_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? 1 : -1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["RIGHT_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? -1 : 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["UP_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -4);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["DOWN_ARROW"]:
                            this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 4);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["HOME"]:
                            this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["END"]:
                            this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_UP"]:
                            this.activeDate =
                                this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_DOWN"]:
                            this.activeDate =
                                this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["ENTER"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["SPACE"]:
                            this._monthSelected(this._dateAdapter.getMonth(this._activeDate));
                            break;
                        default:
                            // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                            return;
                    }
                    if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
                        this.activeDateChange.emit(this.activeDate);
                    }
                    this._focusActiveCell();
                    // Prevent unexpected default actions such as form submission.
                    event.preventDefault();
                };
                /**
                 * Initializes this year view.
                 * @return {?}
                 */
                MatYearView.prototype._init = function () {
                    var _this = this;
                    this._selectedMonth = this._getMonthInCurrentYear(this.selected);
                    this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
                    this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
                    /** @type {?} */
                    var monthNames = this._dateAdapter.getMonthNames('short');
                    // First row of months only contains 5 elements so we can fit the year label on the same row.
                    this._months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]].map(( /**
                     * @param {?} row
                     * @return {?}
                     */function (/**
                     * @param {?} row
                     * @return {?}
                     */ row) { return row.map(( /**
                     * @param {?} month
                     * @return {?}
                     */function (/**
                     * @param {?} month
                     * @return {?}
                     */ month) { return _this._createCellForMonth(month, monthNames[month]); })); }));
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Focuses the active cell after the microtask queue is empty.
                 * @return {?}
                 */
                MatYearView.prototype._focusActiveCell = function () {
                    this._matCalendarBody._focusActiveCell();
                };
                /**
                 * Gets the month in this year that the given Date falls on.
                 * Returns null if the given Date is in another year.
                 * @private
                 * @param {?} date
                 * @return {?}
                 */
                MatYearView.prototype._getMonthInCurrentYear = function (date) {
                    return date && this._dateAdapter.getYear(date) == this._dateAdapter.getYear(this.activeDate) ?
                        this._dateAdapter.getMonth(date) : null;
                };
                /**
                 * Creates an MatCalendarCell for the given month.
                 * @private
                 * @param {?} month
                 * @param {?} monthName
                 * @return {?}
                 */
                MatYearView.prototype._createCellForMonth = function (month, monthName) {
                    /** @type {?} */
                    var ariaLabel = this._dateAdapter.format(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1), this._dateFormats.display.monthYearA11yLabel);
                    return new MatCalendarCell(month, monthName.toLocaleUpperCase(), ariaLabel, this._shouldEnableMonth(month));
                };
                /**
                 * Whether the given month is enabled.
                 * @private
                 * @param {?} month
                 * @return {?}
                 */
                MatYearView.prototype._shouldEnableMonth = function (month) {
                    /** @type {?} */
                    var activeYear = this._dateAdapter.getYear(this.activeDate);
                    if (month === undefined || month === null ||
                        this._isYearAndMonthAfterMaxDate(activeYear, month) ||
                        this._isYearAndMonthBeforeMinDate(activeYear, month)) {
                        return false;
                    }
                    if (!this.dateFilter) {
                        return true;
                    }
                    /** @type {?} */
                    var firstOfMonth = this._dateAdapter.createDate(activeYear, month, 1);
                    // If any date in the month is enabled count the month as enabled.
                    for (var date = firstOfMonth; this._dateAdapter.getMonth(date) == month; date = this._dateAdapter.addCalendarDays(date, 1)) {
                        if (this.dateFilter(date)) {
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * Tests whether the combination month/year is after this.maxDate, considering
                 * just the month and year of this.maxDate
                 * @private
                 * @param {?} year
                 * @param {?} month
                 * @return {?}
                 */
                MatYearView.prototype._isYearAndMonthAfterMaxDate = function (year, month) {
                    if (this.maxDate) {
                        /** @type {?} */
                        var maxYear = this._dateAdapter.getYear(this.maxDate);
                        /** @type {?} */
                        var maxMonth = this._dateAdapter.getMonth(this.maxDate);
                        return year > maxYear || (year === maxYear && month > maxMonth);
                    }
                    return false;
                };
                /**
                 * Tests whether the combination month/year is before this.minDate, considering
                 * just the month and year of this.minDate
                 * @private
                 * @param {?} year
                 * @param {?} month
                 * @return {?}
                 */
                MatYearView.prototype._isYearAndMonthBeforeMinDate = function (year, month) {
                    if (this.minDate) {
                        /** @type {?} */
                        var minYear = this._dateAdapter.getYear(this.minDate);
                        /** @type {?} */
                        var minMonth = this._dateAdapter.getMonth(this.minDate);
                        return year < minYear || (year === minYear && month < minMonth);
                    }
                    return false;
                };
                /**
                 * @private
                 * @param {?} obj The object to check.
                 * @return {?} The given object if it is both a date instance and valid, otherwise null.
                 */
                MatYearView.prototype._getValidDateOrNull = function (obj) {
                    return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
                };
                /**
                 * Determines whether the user has the RTL layout direction.
                 * @private
                 * @return {?}
                 */
                MatYearView.prototype._isRtl = function () {
                    return this._dir && this._dir.value === 'rtl';
                };
                return MatYearView;
            }());
            MatYearView.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-year-view',
                            template: "<table class=\"mat-calendar-table\" role=\"presentation\"><thead class=\"mat-calendar-table-header\"><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"4\"></th></tr></thead><tbody mat-calendar-body [label]=\"_yearLabel\" [rows]=\"_months\" [todayValue]=\"_todayMonth\" [selectedValue]=\"_selectedMonth\" [labelMinRequiredCells]=\"2\" [numCols]=\"4\" [cellAspectRatio]=\"4 / 7\" [activeCell]=\"_dateAdapter.getMonth(activeDate)\" (selectedValueChange)=\"_monthSelected($event)\" (keydown)=\"_handleCalendarBodyKeydown($event)\"></tbody></table>",
                            exportAs: 'matYearView',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush
                        },] },
            ];
            /** @nocollapse */
            MatYearView.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_DATE_FORMATS"],] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatYearView.propDecorators = {
                activeDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                minDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                maxDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateFilter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                monthSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                activeDateChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _matCalendarBody: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatCalendarBody, { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Default header for MatCalendar
             * @template D
             */
            var MatCalendarHeader = /** @class */ (function () {
                /**
                 * @param {?} _intl
                 * @param {?} calendar
                 * @param {?} _dateAdapter
                 * @param {?} _dateFormats
                 * @param {?} changeDetectorRef
                 */
                function MatCalendarHeader(_intl, calendar, _dateAdapter, _dateFormats, changeDetectorRef) {
                    this._intl = _intl;
                    this.calendar = calendar;
                    this._dateAdapter = _dateAdapter;
                    this._dateFormats = _dateFormats;
                    this.calendar.stateChanges.subscribe(( /**
                     * @return {?}
                     */function () { return changeDetectorRef.markForCheck(); }));
                }
                Object.defineProperty(MatCalendarHeader.prototype, "periodButtonText", {
                    /**
                     * The label for the current calendar view.
                     * @return {?}
                     */
                    get: function () {
                        if (this.calendar.currentView == 'month') {
                            return this._dateAdapter
                                .format(this.calendar.activeDate, this._dateFormats.display.monthYearLabel)
                                .toLocaleUpperCase();
                        }
                        if (this.calendar.currentView == 'year') {
                            return this._dateAdapter.getYearName(this.calendar.activeDate);
                        }
                        // The offset from the active year to the "slot" for the starting year is the
                        // *actual* first rendered year in the multi-year view, and the last year is
                        // just yearsPerPage - 1 away.
                        /** @type {?} */
                        var activeYear = this._dateAdapter.getYear(this.calendar.activeDate);
                        /** @type {?} */
                        var minYearOfPage = activeYear - getActiveOffset(this._dateAdapter, this.calendar.activeDate, this.calendar.minDate, this.calendar.maxDate);
                        /** @type {?} */
                        var maxYearOfPage = minYearOfPage + yearsPerPage - 1;
                        /** @type {?} */
                        var minYearName = this._dateAdapter.getYearName(this._dateAdapter.createDate(minYearOfPage, 0, 1));
                        /** @type {?} */
                        var maxYearName = this._dateAdapter.getYearName(this._dateAdapter.createDate(maxYearOfPage, 0, 1));
                        return this._intl.formatYearRange(minYearName, maxYearName);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendarHeader.prototype, "periodButtonLabel", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.calendar.currentView == 'month' ?
                            this._intl.switchToMultiYearViewLabel : this._intl.switchToMonthViewLabel;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendarHeader.prototype, "prevButtonLabel", {
                    /**
                     * The label for the previous button.
                     * @return {?}
                     */
                    get: function () {
                        return {
                            'month': this._intl.prevMonthLabel,
                            'year': this._intl.prevYearLabel,
                            'multi-year': this._intl.prevMultiYearLabel
                        }[this.calendar.currentView];
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendarHeader.prototype, "nextButtonLabel", {
                    /**
                     * The label for the next button.
                     * @return {?}
                     */
                    get: function () {
                        return {
                            'month': this._intl.nextMonthLabel,
                            'year': this._intl.nextYearLabel,
                            'multi-year': this._intl.nextMultiYearLabel
                        }[this.calendar.currentView];
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Handles user clicks on the period label.
                 * @return {?}
                 */
                MatCalendarHeader.prototype.currentPeriodClicked = function () {
                    this.calendar.currentView = this.calendar.currentView == 'month' ? 'multi-year' : 'month';
                };
                /**
                 * Handles user clicks on the previous button.
                 * @return {?}
                 */
                MatCalendarHeader.prototype.previousClicked = function () {
                    this.calendar.activeDate = this.calendar.currentView == 'month' ?
                        this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1) :
                        this._dateAdapter.addCalendarYears(this.calendar.activeDate, this.calendar.currentView == 'year' ? -1 : -yearsPerPage);
                };
                /**
                 * Handles user clicks on the next button.
                 * @return {?}
                 */
                MatCalendarHeader.prototype.nextClicked = function () {
                    this.calendar.activeDate = this.calendar.currentView == 'month' ?
                        this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1) :
                        this._dateAdapter.addCalendarYears(this.calendar.activeDate, this.calendar.currentView == 'year' ? 1 : yearsPerPage);
                };
                /**
                 * Whether the previous period button is enabled.
                 * @return {?}
                 */
                MatCalendarHeader.prototype.previousEnabled = function () {
                    if (!this.calendar.minDate) {
                        return true;
                    }
                    return !this.calendar.minDate ||
                        !this._isSameView(this.calendar.activeDate, this.calendar.minDate);
                };
                /**
                 * Whether the next period button is enabled.
                 * @return {?}
                 */
                MatCalendarHeader.prototype.nextEnabled = function () {
                    return !this.calendar.maxDate ||
                        !this._isSameView(this.calendar.activeDate, this.calendar.maxDate);
                };
                /**
                 * Whether the two dates represent the same view in the current view mode (month or year).
                 * @private
                 * @param {?} date1
                 * @param {?} date2
                 * @return {?}
                 */
                MatCalendarHeader.prototype._isSameView = function (date1, date2) {
                    if (this.calendar.currentView == 'month') {
                        return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
                            this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
                    }
                    if (this.calendar.currentView == 'year') {
                        return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
                    }
                    // Otherwise we are in 'multi-year' view.
                    return isSameMultiYearView(this._dateAdapter, date1, date2, this.calendar.minDate, this.calendar.maxDate);
                };
                return MatCalendarHeader;
            }());
            MatCalendarHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-calendar-header',
                            template: "<div class=\"mat-calendar-header\"><div class=\"mat-calendar-controls\"><button mat-button type=\"button\" class=\"mat-calendar-period-button\" (click)=\"currentPeriodClicked()\" [attr.aria-label]=\"periodButtonLabel\" cdkAriaLive=\"polite\">{{periodButtonText}}<div class=\"mat-calendar-arrow\" [class.mat-calendar-invert]=\"calendar.currentView != 'month'\"></div></button><div class=\"mat-calendar-spacer\"></div><ng-content></ng-content><button mat-icon-button type=\"button\" class=\"mat-calendar-previous-button\" [disabled]=\"!previousEnabled()\" (click)=\"previousClicked()\" [attr.aria-label]=\"prevButtonLabel\"></button> <button mat-icon-button type=\"button\" class=\"mat-calendar-next-button\" [disabled]=\"!nextEnabled()\" (click)=\"nextClicked()\" [attr.aria-label]=\"nextButtonLabel\"></button></div></div>",
                            exportAs: 'matCalendarHeader',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatCalendarHeader.ctorParameters = function () { return [
                { type: MatDatepickerIntl },
                { type: MatCalendar, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return MatCalendar; })),] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_DATE_FORMATS"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            /**
             * A calendar that is used as part of the datepicker.
             * \@docs-private
             * @template D
             */
            var MatCalendar = /** @class */ (function () {
                /**
                 * @param {?} _intl
                 * @param {?} _dateAdapter
                 * @param {?} _dateFormats
                 * @param {?} _changeDetectorRef
                 */
                function MatCalendar(_intl, _dateAdapter, _dateFormats, _changeDetectorRef) {
                    var _this = this;
                    this._dateAdapter = _dateAdapter;
                    this._dateFormats = _dateFormats;
                    this._changeDetectorRef = _changeDetectorRef;
                    /**
                     * Used for scheduling that focus should be moved to the active cell on the next tick.
                     * We need to schedule it, rather than do it immediately, because we have to wait
                     * for Angular to re-evaluate the view children.
                     */
                    this._moveFocusOnNextTick = false;
                    /**
                     * Whether the calendar should be started in month or year view.
                     */
                    this.startView = 'month';
                    /**
                     * Emits when the currently selected date changes.
                     */
                    this.selectedChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits the year chosen in multiyear view.
                     * This doesn't imply a change on the selected date.
                     */
                    this.yearSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits the month chosen in year view.
                     * This doesn't imply a change on the selected date.
                     */
                    this.monthSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when any date is selected.
                     */
                    this._userSelection = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits whenever there is a state change that the header may need to respond to.
                     */
                    this.stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    if (!this._dateAdapter) {
                        throw createMissingDateImplError('DateAdapter');
                    }
                    if (!this._dateFormats) {
                        throw createMissingDateImplError('MAT_DATE_FORMATS');
                    }
                    this._intlChanges = _intl.changes.subscribe(( /**
                     * @return {?}
                     */function () {
                        _changeDetectorRef.markForCheck();
                        _this.stateChanges.next();
                    }));
                }
                Object.defineProperty(MatCalendar.prototype, "startAt", {
                    /**
                     * A date representing the period (month or year) to start the calendar in.
                     * @return {?}
                     */
                    get: function () { return this._startAt; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendar.prototype, "selected", {
                    /**
                     * The currently selected date.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendar.prototype, "minDate", {
                    /**
                     * The minimum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._minDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendar.prototype, "maxDate", {
                    /**
                     * The maximum selectable date.
                     * @return {?}
                     */
                    get: function () { return this._maxDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendar.prototype, "activeDate", {
                    /**
                     * The current active date. This determines which time period is shown and which date is
                     * highlighted when using keyboard navigation.
                     * @return {?}
                     */
                    get: function () { return this._clampedActiveDate; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
                        this.stateChanges.next();
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatCalendar.prototype, "currentView", {
                    /**
                     * Whether the calendar is in month view.
                     * @return {?}
                     */
                    get: function () { return this._currentView; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._currentView = value;
                        this._moveFocusOnNextTick = true;
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatCalendar.prototype.ngAfterContentInit = function () {
                    this._calendarHeaderPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_6__["ComponentPortal"](this.headerComponent || MatCalendarHeader);
                    this.activeDate = this.startAt || this._dateAdapter.today();
                    // Assign to the private property since we don't want to move focus on init.
                    this._currentView = this.startView;
                };
                /**
                 * @return {?}
                 */
                MatCalendar.prototype.ngAfterViewChecked = function () {
                    if (this._moveFocusOnNextTick) {
                        this._moveFocusOnNextTick = false;
                        this.focusActiveCell();
                    }
                };
                /**
                 * @return {?}
                 */
                MatCalendar.prototype.ngOnDestroy = function () {
                    this._intlChanges.unsubscribe();
                    this.stateChanges.complete();
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatCalendar.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var change = changes['minDate'] || changes['maxDate'] || changes['dateFilter'];
                    if (change && !change.firstChange) {
                        /** @type {?} */
                        var view = this._getCurrentViewComponent();
                        if (view) {
                            // We need to `detectChanges` manually here, because the `minDate`, `maxDate` etc. are
                            // passed down to the view via data bindings which won't be up-to-date when we call `_init`.
                            this._changeDetectorRef.detectChanges();
                            view._init();
                        }
                    }
                    this.stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatCalendar.prototype.focusActiveCell = function () {
                    this._getCurrentViewComponent()._focusActiveCell();
                };
                /**
                 * Updates today's date after an update of the active date
                 * @return {?}
                 */
                MatCalendar.prototype.updateTodaysDate = function () {
                    /** @type {?} */
                    var view = this.currentView == 'month' ? this.monthView :
                        (this.currentView == 'year' ? this.yearView : this.multiYearView);
                    view.ngAfterContentInit();
                };
                /**
                 * Handles date selection in the month view.
                 * @param {?} date
                 * @return {?}
                 */
                MatCalendar.prototype._dateSelected = function (date) {
                    if (!this._dateAdapter.sameDate(date, this.selected)) {
                        this.selectedChange.emit(date);
                    }
                };
                /**
                 * Handles year selection in the multiyear view.
                 * @param {?} normalizedYear
                 * @return {?}
                 */
                MatCalendar.prototype._yearSelectedInMultiYearView = function (normalizedYear) {
                    this.yearSelected.emit(normalizedYear);
                };
                /**
                 * Handles month selection in the year view.
                 * @param {?} normalizedMonth
                 * @return {?}
                 */
                MatCalendar.prototype._monthSelectedInYearView = function (normalizedMonth) {
                    this.monthSelected.emit(normalizedMonth);
                };
                /**
                 * @return {?}
                 */
                MatCalendar.prototype._userSelected = function () {
                    this._userSelection.emit();
                };
                /**
                 * Handles year/month selection in the multi-year/year views.
                 * @param {?} date
                 * @param {?} view
                 * @return {?}
                 */
                MatCalendar.prototype._goToDateInView = function (date, view) {
                    this.activeDate = date;
                    this.currentView = view;
                };
                /**
                 * @private
                 * @param {?} obj The object to check.
                 * @return {?} The given object if it is both a date instance and valid, otherwise null.
                 */
                MatCalendar.prototype._getValidDateOrNull = function (obj) {
                    return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
                };
                /**
                 * Returns the component instance that corresponds to the current calendar view.
                 * @private
                 * @return {?}
                 */
                MatCalendar.prototype._getCurrentViewComponent = function () {
                    return this.monthView || this.yearView || this.multiYearView;
                };
                return MatCalendar;
            }());
            MatCalendar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-calendar',
                            template: "<ng-template [cdkPortalOutlet]=\"_calendarHeaderPortal\"></ng-template><div class=\"mat-calendar-content\" [ngSwitch]=\"currentView\" cdkMonitorSubtreeFocus tabindex=\"-1\"><mat-month-view *ngSwitchCase=\"'month'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" [dateClass]=\"dateClass\" (selectedChange)=\"_dateSelected($event)\" (_userSelection)=\"_userSelected()\"></mat-month-view><mat-year-view *ngSwitchCase=\"'year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (monthSelected)=\"_monthSelectedInYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'month')\"></mat-year-view><mat-multi-year-view *ngSwitchCase=\"'multi-year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (yearSelected)=\"_yearSelectedInMultiYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'year')\"></mat-multi-year-view></div>",
                            styles: [".mat-calendar{display:block}.mat-calendar-header{padding:8px 8px 0 8px}.mat-calendar-content{padding:0 8px 8px 8px;outline:0}.mat-calendar-controls{display:flex;margin:5% calc(33% / 7 - 16px)}.mat-calendar-spacer{flex:1 1 auto}.mat-calendar-period-button{min-width:0}.mat-calendar-arrow{display:inline-block;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;margin:0 0 0 5px;vertical-align:middle}.mat-calendar-arrow.mat-calendar-invert{transform:rotate(180deg)}[dir=rtl] .mat-calendar-arrow{margin:0 5px 0 0}.mat-calendar-next-button,.mat-calendar-previous-button{position:relative}.mat-calendar-next-button::after,.mat-calendar-previous-button::after{top:0;left:0;right:0;bottom:0;position:absolute;content:'';margin:15.5px;border:0 solid currentColor;border-top-width:2px}[dir=rtl] .mat-calendar-next-button,[dir=rtl] .mat-calendar-previous-button{transform:rotate(180deg)}.mat-calendar-previous-button::after{border-left-width:2px;transform:translateX(2px) rotate(-45deg)}.mat-calendar-next-button::after{border-right-width:2px;transform:translateX(-2px) rotate(45deg)}.mat-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}.mat-calendar-table-header th{text-align:center;padding:0 0 8px 0}.mat-calendar-table-header-divider{position:relative;height:1px}.mat-calendar-table-header-divider::after{content:'';position:absolute;top:0;left:-8px;right:-8px;height:1px}"],
                            host: {
                                'class': 'mat-calendar',
                            },
                            exportAs: 'matCalendar',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatCalendar.ctorParameters = function () { return [
                { type: MatDatepickerIntl },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_DATE_FORMATS"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            MatCalendar.propDecorators = {
                headerComponent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                startAt: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                startView: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                minDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                maxDate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateFilter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                yearSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                monthSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _userSelection: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                monthView: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatMonthView, { static: false },] }],
                yearView: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatYearView, { static: false },] }],
                multiYearView: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatMultiYearView, { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the Material datepicker.
             * \@docs-private
             * @type {?}
             */
            var matDatepickerAnimations = {
                /**
                 * Transforms the height of the datepicker's calendar.
                 */
                transformPanel: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["trigger"])('transformPanel', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["state"])('void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({
                        opacity: 0,
                        transform: 'scale(1, 0.8)'
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["transition"])('void => enter', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["animate"])('120ms cubic-bezier(0, 0, 0.2, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({
                        opacity: 1,
                        transform: 'scale(1, 1)'
                    }))),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["transition"])('* => void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["animate"])('100ms linear', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({ opacity: 0 })))
                ]),
                /**
                 * Fades in the content of the calendar.
                 */
                fadeInCalendar: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["trigger"])('fadeInCalendar', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["state"])('void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({ opacity: 0 })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["state"])('enter', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({ opacity: 1 })),
                    // TODO(crisbeto): this animation should be removed since it isn't quite on spec, but we
                    // need to keep it until #12440 gets in, otherwise the exit animation will look glitchy.
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["transition"])('void => *', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["animate"])('120ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)'))
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to generate a unique ID for each datepicker instance.
             * @type {?}
             */
            var datepickerUid = 0;
            /**
             * Injection token that determines the scroll handling while the calendar is open.
             * @type {?}
             */
            var MAT_DATEPICKER_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-datepicker-scroll-strategy');
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.reposition(); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER = {
                provide: MAT_DATEPICKER_SCROLL_STRATEGY,
                deps: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["Overlay"]],
                useFactory: MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY,
            };
            // Boilerplate for applying mixins to MatDatepickerContent.
            /**
             * \@docs-private
             */
            var MatDatepickerContentBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatDatepickerContentBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatDatepickerContentBase;
            }());
            /** @type {?} */
            var _MatDatepickerContentMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinColor"])(MatDatepickerContentBase);
            /**
             * Component used as the content for the datepicker dialog and popup. We use this instead of using
             * MatCalendar directly as the content so we can control the initial focus. This also gives us a
             * place to put additional features of the popup that are not part of the calendar itself in the
             * future. (e.g. confirmation buttons).
             * \@docs-private
             * @template D
             */
            var MatDatepickerContent = /** @class */ (function (_super_1) {
                __extends(MatDatepickerContent, _super_1);
                /**
                 * @param {?} elementRef
                 */
                function MatDatepickerContent(elementRef) {
                    return _super_1.call(this, elementRef) || this;
                }
                /**
                 * @return {?}
                 */
                MatDatepickerContent.prototype.ngAfterViewInit = function () {
                    this._calendar.focusActiveCell();
                };
                return MatDatepickerContent;
            }(_MatDatepickerContentMixinBase));
            MatDatepickerContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-datepicker-content',
                            template: "<mat-calendar cdkTrapFocus [id]=\"datepicker.id\" [ngClass]=\"datepicker.panelClass\" [startAt]=\"datepicker.startAt\" [startView]=\"datepicker.startView\" [minDate]=\"datepicker._minDate\" [maxDate]=\"datepicker._maxDate\" [dateFilter]=\"datepicker._dateFilter\" [headerComponent]=\"datepicker.calendarHeaderComponent\" [selected]=\"datepicker._selected\" [dateClass]=\"datepicker.dateClass\" [@fadeInCalendar]=\"'enter'\" (selectedChange)=\"datepicker.select($event)\" (yearSelected)=\"datepicker._selectYear($event)\" (monthSelected)=\"datepicker._selectMonth($event)\" (_userSelection)=\"datepicker.close()\"></mat-calendar>",
                            styles: [".mat-datepicker-content{display:block;border-radius:4px}.mat-datepicker-content .mat-calendar{width:296px;height:354px}.mat-datepicker-content-touch{display:block;max-height:80vh;overflow:auto;margin:-24px}.mat-datepicker-content-touch .mat-calendar{min-width:250px;min-height:312px;max-width:750px;max-height:788px}@media all and (orientation:landscape){.mat-datepicker-content-touch .mat-calendar{width:64vh;height:80vh}}@media all and (orientation:portrait){.mat-datepicker-content-touch .mat-calendar{width:80vw;height:100vw}}"],
                            host: {
                                'class': 'mat-datepicker-content',
                                '[@transformPanel]': '"enter"',
                                '[class.mat-datepicker-content-touch]': 'datepicker.touchUi',
                            },
                            animations: [
                                matDatepickerAnimations.transformPanel,
                                matDatepickerAnimations.fadeInCalendar,
                            ],
                            exportAs: 'matDatepickerContent',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            inputs: ['color'],
                        },] },
            ];
            /** @nocollapse */
            MatDatepickerContent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            MatDatepickerContent.propDecorators = {
                _calendar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatCalendar, { static: false },] }]
            };
            // TODO(mmalerba): We use a component instead of a directive here so the user can use implicit
            // template reference variables (e.g. #d vs #d="matDatepicker"). We can change this to a directive
            // if angular adds support for `exportAs: '$implicit'` on directives.
            /**
             * Component responsible for managing the datepicker popup/dialog.
             * @template D
             */
            var MatDatepicker = /** @class */ (function () {
                /**
                 * @param {?} _dialog
                 * @param {?} _overlay
                 * @param {?} _ngZone
                 * @param {?} _viewContainerRef
                 * @param {?} scrollStrategy
                 * @param {?} _dateAdapter
                 * @param {?} _dir
                 * @param {?} _document
                 */
                function MatDatepicker(_dialog, _overlay, _ngZone, _viewContainerRef, scrollStrategy, _dateAdapter, _dir, _document) {
                    this._dialog = _dialog;
                    this._overlay = _overlay;
                    this._ngZone = _ngZone;
                    this._viewContainerRef = _viewContainerRef;
                    this._dateAdapter = _dateAdapter;
                    this._dir = _dir;
                    this._document = _document;
                    /**
                     * The view that the calendar should start in.
                     */
                    this.startView = 'month';
                    this._touchUi = false;
                    /**
                     * Emits selected year in multiyear view.
                     * This doesn't imply a change on the selected date.
                     */
                    this.yearSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits selected month in year view.
                     * This doesn't imply a change on the selected date.
                     */
                    this.monthSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when the datepicker has been opened.
                     */
                    this.openedStream = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when the datepicker has been closed.
                     */
                    this.closedStream = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this._opened = false;
                    /**
                     * The id for the datepicker calendar.
                     */
                    this.id = "mat-datepicker-" + datepickerUid++;
                    this._validSelected = null;
                    /**
                     * The element that was focused before the datepicker was opened.
                     */
                    this._focusedElementBeforeOpen = null;
                    /**
                     * Subscription to value changes in the associated input element.
                     */
                    this._inputSubscription = rxjs__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    /**
                     * Emits when the datepicker is disabled.
                     */
                    this._disabledChange = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * Emits new selected date when selected date changes.
                     */
                    this._selectedChanged = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    if (!this._dateAdapter) {
                        throw createMissingDateImplError('DateAdapter');
                    }
                    this._scrollStrategy = scrollStrategy;
                }
                Object.defineProperty(MatDatepicker.prototype, "startAt", {
                    /**
                     * The date to open the calendar to initially.
                     * @return {?}
                     */
                    get: function () {
                        // If an explicit startAt is set we start there, otherwise we start at whatever the currently
                        // selected value is.
                        return this._startAt || (this._datepickerInput ? this._datepickerInput.value : null);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "color", {
                    /**
                     * Color palette to use on the datepicker's calendar.
                     * @return {?}
                     */
                    get: function () {
                        return this._color ||
                            (this._datepickerInput ? this._datepickerInput._getThemePalette() : undefined);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._color = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "touchUi", {
                    /**
                     * Whether the calendar UI is in touch mode. In touch mode the calendar opens in a dialog rather
                     * than a popup and elements have more padding to allow for bigger touch targets.
                     * @return {?}
                     */
                    get: function () { return this._touchUi; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._touchUi = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "disabled", {
                    /**
                     * Whether the datepicker pop-up should be disabled.
                     * @return {?}
                     */
                    get: function () {
                        return this._disabled === undefined && this._datepickerInput ?
                            this._datepickerInput.disabled : !!this._disabled;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value);
                        if (newValue !== this._disabled) {
                            this._disabled = newValue;
                            this._disabledChange.next(newValue);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "opened", {
                    /**
                     * Whether the calendar is open.
                     * @return {?}
                     */
                    get: function () { return this._opened; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { value ? this.open() : this.close(); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "_selected", {
                    /**
                     * The currently selected date.
                     * @return {?}
                     */
                    get: function () { return this._validSelected; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._validSelected = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "_minDate", {
                    /**
                     * The minimum selectable date.
                     * @return {?}
                     */
                    get: function () {
                        return this._datepickerInput && this._datepickerInput.min;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "_maxDate", {
                    /**
                     * The maximum selectable date.
                     * @return {?}
                     */
                    get: function () {
                        return this._datepickerInput && this._datepickerInput.max;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepicker.prototype, "_dateFilter", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._datepickerInput && this._datepickerInput._dateFilter;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatDatepicker.prototype.ngOnDestroy = function () {
                    this.close();
                    this._inputSubscription.unsubscribe();
                    this._disabledChange.complete();
                    if (this._popupRef) {
                        this._popupRef.dispose();
                        this._popupComponentRef = null;
                    }
                };
                /**
                 * Selects the given date
                 * @param {?} date
                 * @return {?}
                 */
                MatDatepicker.prototype.select = function (date) {
                    /** @type {?} */
                    var oldValue = this._selected;
                    this._selected = date;
                    if (!this._dateAdapter.sameDate(oldValue, this._selected)) {
                        this._selectedChanged.next(date);
                    }
                };
                /**
                 * Emits the selected year in multiyear view
                 * @param {?} normalizedYear
                 * @return {?}
                 */
                MatDatepicker.prototype._selectYear = function (normalizedYear) {
                    this.yearSelected.emit(normalizedYear);
                };
                /**
                 * Emits selected month in year view
                 * @param {?} normalizedMonth
                 * @return {?}
                 */
                MatDatepicker.prototype._selectMonth = function (normalizedMonth) {
                    this.monthSelected.emit(normalizedMonth);
                };
                /**
                 * Register an input with this datepicker.
                 * @param {?} input The datepicker input to register with this datepicker.
                 * @return {?}
                 */
                MatDatepicker.prototype._registerInput = function (input) {
                    var _this = this;
                    if (this._datepickerInput) {
                        throw Error('A MatDatepicker can only be associated with a single input.');
                    }
                    this._datepickerInput = input;
                    this._inputSubscription =
                        this._datepickerInput._valueChange.subscribe(( /**
                         * @param {?} value
                         * @return {?}
                         */function (value) { return _this._selected = value; }));
                };
                /**
                 * Open the calendar.
                 * @return {?}
                 */
                MatDatepicker.prototype.open = function () {
                    if (this._opened || this.disabled) {
                        return;
                    }
                    if (!this._datepickerInput) {
                        throw Error('Attempted to open an MatDatepicker with no associated input.');
                    }
                    if (this._document) {
                        this._focusedElementBeforeOpen = this._document.activeElement;
                    }
                    this.touchUi ? this._openAsDialog() : this._openAsPopup();
                    this._opened = true;
                    this.openedStream.emit();
                };
                /**
                 * Close the calendar.
                 * @return {?}
                 */
                MatDatepicker.prototype.close = function () {
                    var _this = this;
                    if (!this._opened) {
                        return;
                    }
                    if (this._popupRef && this._popupRef.hasAttached()) {
                        this._popupRef.detach();
                    }
                    if (this._dialogRef) {
                        this._dialogRef.close();
                        this._dialogRef = null;
                    }
                    if (this._calendarPortal && this._calendarPortal.isAttached) {
                        this._calendarPortal.detach();
                    }
                    /** @type {?} */
                    var completeClose = ( /**
                     * @return {?}
                     */function () {
                        // The `_opened` could've been reset already if
                        // we got two events in quick succession.
                        if (_this._opened) {
                            _this._opened = false;
                            _this.closedStream.emit();
                            _this._focusedElementBeforeOpen = null;
                        }
                    });
                    if (this._focusedElementBeforeOpen &&
                        typeof this._focusedElementBeforeOpen.focus === 'function') {
                        // Because IE moves focus asynchronously, we can't count on it being restored before we've
                        // marked the datepicker as closed. If the event fires out of sequence and the element that
                        // we're refocusing opens the datepicker on focus, the user could be stuck with not being
                        // able to close the calendar at all. We work around it by making the logic, that marks
                        // the datepicker as closed, async as well.
                        this._focusedElementBeforeOpen.focus();
                        setTimeout(completeClose);
                    }
                    else {
                        completeClose();
                    }
                };
                /**
                 * Open the calendar as a dialog.
                 * @private
                 * @return {?}
                 */
                MatDatepicker.prototype._openAsDialog = function () {
                    var _this = this;
                    // Usually this would be handled by `open` which ensures that we can only have one overlay
                    // open at a time, however since we reset the variables in async handlers some overlays
                    // may slip through if the user opens and closes multiple times in quick succession (e.g.
                    // by holding down the enter key).
                    if (this._dialogRef) {
                        this._dialogRef.close();
                    }
                    this._dialogRef = this._dialog.open(MatDatepickerContent, {
                        direction: this._dir ? this._dir.value : 'ltr',
                        viewContainerRef: this._viewContainerRef,
                        panelClass: 'mat-datepicker-dialog',
                    });
                    this._dialogRef.afterClosed().subscribe(( /**
                     * @return {?}
                     */function () { return _this.close(); }));
                    this._dialogRef.componentInstance.datepicker = this;
                    this._setColor();
                };
                /**
                 * Open the calendar as a popup.
                 * @private
                 * @return {?}
                 */
                MatDatepicker.prototype._openAsPopup = function () {
                    var _this = this;
                    if (!this._calendarPortal) {
                        this._calendarPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_6__["ComponentPortal"](MatDatepickerContent, this._viewContainerRef);
                    }
                    if (!this._popupRef) {
                        this._createPopup();
                    }
                    if (!this._popupRef.hasAttached()) {
                        this._popupComponentRef = this._popupRef.attach(this._calendarPortal);
                        this._popupComponentRef.instance.datepicker = this;
                        this._setColor();
                        // Update the position once the calendar has rendered.
                        this._ngZone.onStable.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["take"])(1)).subscribe(( /**
                         * @return {?}
                         */function () {
                            _this._popupRef.updatePosition();
                        }));
                    }
                };
                /**
                 * Create the popup.
                 * @private
                 * @return {?}
                 */
                MatDatepicker.prototype._createPopup = function () {
                    var _this = this;
                    /** @type {?} */
                    var overlayConfig = new _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["OverlayConfig"]({
                        positionStrategy: this._createPopupPositionStrategy(),
                        hasBackdrop: true,
                        backdropClass: 'mat-overlay-transparent-backdrop',
                        direction: this._dir,
                        scrollStrategy: this._scrollStrategy(),
                        panelClass: 'mat-datepicker-popup',
                    });
                    this._popupRef = this._overlay.create(overlayConfig);
                    this._popupRef.overlayElement.setAttribute('role', 'dialog');
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["merge"])(this._popupRef.backdropClick(), this._popupRef.detachments(), this._popupRef.keydownEvents().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        // Closing on alt + up is only valid when there's an input associated with the datepicker.
                        return event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["ESCAPE"] ||
                            (_this._datepickerInput && event.altKey && event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["UP_ARROW"]);
                    })))).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        if (event) {
                            event.preventDefault();
                        }
                        _this.close();
                    }));
                };
                /**
                 * Create the popup PositionStrategy.
                 * @private
                 * @return {?}
                 */
                MatDatepicker.prototype._createPopupPositionStrategy = function () {
                    return this._overlay.position()
                        .flexibleConnectedTo(this._datepickerInput.getConnectedOverlayOrigin())
                        .withTransformOriginOn('.mat-datepicker-content')
                        .withFlexibleDimensions(false)
                        .withViewportMargin(8)
                        .withLockedPosition()
                        .withPositions([
                        {
                            originX: 'start',
                            originY: 'bottom',
                            overlayX: 'start',
                            overlayY: 'top'
                        },
                        {
                            originX: 'start',
                            originY: 'top',
                            overlayX: 'start',
                            overlayY: 'bottom'
                        },
                        {
                            originX: 'end',
                            originY: 'bottom',
                            overlayX: 'end',
                            overlayY: 'top'
                        },
                        {
                            originX: 'end',
                            originY: 'top',
                            overlayX: 'end',
                            overlayY: 'bottom'
                        }
                    ]);
                };
                /**
                 * @private
                 * @param {?} obj The object to check.
                 * @return {?} The given object if it is both a date instance and valid, otherwise null.
                 */
                MatDatepicker.prototype._getValidDateOrNull = function (obj) {
                    return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
                };
                /**
                 * Passes the current theme color along to the calendar overlay.
                 * @private
                 * @return {?}
                 */
                MatDatepicker.prototype._setColor = function () {
                    /** @type {?} */
                    var color = this.color;
                    if (this._popupComponentRef) {
                        this._popupComponentRef.instance.color = color;
                    }
                    if (this._dialogRef) {
                        this._dialogRef.componentInstance.color = color;
                    }
                };
                return MatDatepicker;
            }());
            MatDatepicker.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-datepicker',
                            template: '',
                            exportAs: 'matDatepicker',
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatDatepicker.ctorParameters = function () { return [
                { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__["MatDialog"] },
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_DATEPICKER_SCROLL_STRATEGY,] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_10__["DOCUMENT"],] }] }
            ]; };
            MatDatepicker.propDecorators = {
                calendarHeaderComponent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                startAt: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                startView: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                touchUi: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                yearSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                monthSelected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                panelClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                openedStream: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"], args: ['opened',] }],
                closedStream: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"], args: ['closed',] }],
                opened: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_DATEPICKER_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_12__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatDatepickerInput; })),
                multi: true
            };
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_DATEPICKER_VALIDATORS = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_12__["NG_VALIDATORS"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatDatepickerInput; })),
                multi: true
            };
            /**
             * An event used for datepicker input and change events. We don't always have access to a native
             * input or change event because the event may have been triggered by the user clicking on the
             * calendar popup. For consistency, we always use MatDatepickerInputEvent instead.
             * @template D
             */
            var MatDatepickerInputEvent = /** @class */ (function () {
                /**
                 * @param {?} target
                 * @param {?} targetElement
                 */
                function MatDatepickerInputEvent(target, targetElement) {
                    this.target = target;
                    this.targetElement = targetElement;
                    this.value = this.target.value;
                }
                return MatDatepickerInputEvent;
            }());
            /**
             * Directive used to connect an input to a MatDatepicker.
             * @template D
             */
            var MatDatepickerInput = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _dateAdapter
                 * @param {?} _dateFormats
                 * @param {?} _formField
                 */
                function MatDatepickerInput(_elementRef, _dateAdapter, _dateFormats, _formField) {
                    var _this = this;
                    this._elementRef = _elementRef;
                    this._dateAdapter = _dateAdapter;
                    this._dateFormats = _dateFormats;
                    this._formField = _formField;
                    /**
                     * Emits when a `change` event is fired on this `<input>`.
                     */
                    this.dateChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when an `input` event is fired on this `<input>`.
                     */
                    this.dateInput = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when the value changes (either due to user input or programmatic change).
                     */
                    this._valueChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Emits when the disabled state has changed
                     */
                    this._disabledChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    this._cvaOnChange = ( /**
                     * @return {?}
                     */function () { });
                    this._validatorOnChange = ( /**
                     * @return {?}
                     */function () { });
                    this._datepickerSubscription = rxjs__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    this._localeSubscription = rxjs__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    /**
                     * The form control validator for whether the input parses.
                     */
                    this._parseValidator = ( /**
                     * @return {?}
                     */function () {
                        return _this._lastValueValid ?
                            null : { 'matDatepickerParse': { 'text': _this._elementRef.nativeElement.value } };
                    });
                    /**
                     * The form control validator for the min date.
                     */
                    this._minValidator = ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        /** @type {?} */
                        var controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
                        return (!_this.min || !controlValue ||
                            _this._dateAdapter.compareDate(_this.min, controlValue) <= 0) ?
                            null : { 'matDatepickerMin': { 'min': _this.min, 'actual': controlValue } };
                    });
                    /**
                     * The form control validator for the max date.
                     */
                    this._maxValidator = ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        /** @type {?} */
                        var controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
                        return (!_this.max || !controlValue ||
                            _this._dateAdapter.compareDate(_this.max, controlValue) >= 0) ?
                            null : { 'matDatepickerMax': { 'max': _this.max, 'actual': controlValue } };
                    });
                    /**
                     * The form control validator for the date filter.
                     */
                    this._filterValidator = ( /**
                     * @param {?} control
                     * @return {?}
                     */function (control) {
                        /** @type {?} */
                        var controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
                        return !_this._dateFilter || !controlValue || _this._dateFilter(controlValue) ?
                            null : { 'matDatepickerFilter': true };
                    });
                    /**
                     * The combined form control validator for this input.
                     */
                    this._validator = _angular_forms__WEBPACK_IMPORTED_MODULE_12__["Validators"].compose([this._parseValidator, this._minValidator, this._maxValidator, this._filterValidator]);
                    /**
                     * Whether the last value set on the input was valid.
                     */
                    this._lastValueValid = false;
                    if (!this._dateAdapter) {
                        throw createMissingDateImplError('DateAdapter');
                    }
                    if (!this._dateFormats) {
                        throw createMissingDateImplError('MAT_DATE_FORMATS');
                    }
                    // Update the displayed date when the locale changes.
                    this._localeSubscription = _dateAdapter.localeChanges.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this.value = _this.value;
                    }));
                }
                Object.defineProperty(MatDatepickerInput.prototype, "matDatepicker", {
                    /**
                     * The datepicker that this input is associated with.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        var _this = this;
                        if (!value) {
                            return;
                        }
                        this._datepicker = value;
                        this._datepicker._registerInput(this);
                        this._datepickerSubscription.unsubscribe();
                        this._datepickerSubscription = this._datepicker._selectedChanged.subscribe(( /**
                         * @param {?} selected
                         * @return {?}
                         */function (selected) {
                            _this.value = selected;
                            _this._cvaOnChange(selected);
                            _this._onTouched();
                            _this.dateInput.emit(new MatDatepickerInputEvent(_this, _this._elementRef.nativeElement));
                            _this.dateChange.emit(new MatDatepickerInputEvent(_this, _this._elementRef.nativeElement));
                        }));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepickerInput.prototype, "matDatepickerFilter", {
                    /**
                     * Function that can be used to filter out dates within the datepicker.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._dateFilter = value;
                        this._validatorOnChange();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepickerInput.prototype, "value", {
                    /**
                     * The value of the input.
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        value = this._dateAdapter.deserialize(value);
                        this._lastValueValid = !value || this._dateAdapter.isValid(value);
                        value = this._getValidDateOrNull(value);
                        /** @type {?} */
                        var oldDate = this.value;
                        this._value = value;
                        this._formatValue(value);
                        if (!this._dateAdapter.sameDate(oldDate, value)) {
                            this._valueChange.emit(value);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepickerInput.prototype, "min", {
                    /**
                     * The minimum valid date.
                     * @return {?}
                     */
                    get: function () { return this._min; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._min = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                        this._validatorOnChange();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepickerInput.prototype, "max", {
                    /**
                     * The maximum valid date.
                     * @return {?}
                     */
                    get: function () { return this._max; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._max = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                        this._validatorOnChange();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDatepickerInput.prototype, "disabled", {
                    /**
                     * Whether the datepicker-input is disabled.
                     * @return {?}
                     */
                    get: function () { return !!this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value);
                        /** @type {?} */
                        var element = this._elementRef.nativeElement;
                        if (this._disabled !== newValue) {
                            this._disabled = newValue;
                            this._disabledChange.emit(newValue);
                        }
                        // We need to null check the `blur` method, because it's undefined during SSR.
                        if (newValue && element.blur) {
                            // Normally, native input elements automatically blur if they turn disabled. This behavior
                            // is problematic, because it would mean that it triggers another change detection cycle,
                            // which then causes a changed after checked error if the input element was focused before.
                            element.blur();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatDatepickerInput.prototype.ngOnDestroy = function () {
                    this._datepickerSubscription.unsubscribe();
                    this._localeSubscription.unsubscribe();
                    this._valueChange.complete();
                    this._disabledChange.complete();
                };
                /**
                 * \@docs-private
                 * @param {?} fn
                 * @return {?}
                 */
                MatDatepickerInput.prototype.registerOnValidatorChange = function (fn) {
                    this._validatorOnChange = fn;
                };
                /**
                 * \@docs-private
                 * @param {?} c
                 * @return {?}
                 */
                MatDatepickerInput.prototype.validate = function (c) {
                    return this._validator ? this._validator(c) : null;
                };
                /**
                 * @deprecated
                 * \@breaking-change 8.0.0 Use `getConnectedOverlayOrigin` instead
                 * @return {?}
                 */
                MatDatepickerInput.prototype.getPopupConnectionElementRef = function () {
                    return this.getConnectedOverlayOrigin();
                };
                /**
                 * Gets the element that the datepicker popup should be connected to.
                 * @return {?} The element to connect the popup to.
                 */
                MatDatepickerInput.prototype.getConnectedOverlayOrigin = function () {
                    return this._formField ? this._formField.getConnectedOverlayOrigin() : this._elementRef;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} value
                 * @return {?}
                 */
                MatDatepickerInput.prototype.writeValue = function (value) {
                    this.value = value;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatDatepickerInput.prototype.registerOnChange = function (fn) {
                    this._cvaOnChange = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                MatDatepickerInput.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                // Implemented as part of ControlValueAccessor.
                /**
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatDatepickerInput.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatDatepickerInput.prototype._onKeydown = function (event) {
                    /** @type {?} */
                    var isAltDownArrow = event.altKey && event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["DOWN_ARROW"];
                    if (this._datepicker && isAltDownArrow && !this._elementRef.nativeElement.readOnly) {
                        this._datepicker.open();
                        event.preventDefault();
                    }
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                MatDatepickerInput.prototype._onInput = function (value) {
                    /** @type {?} */
                    var date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
                    this._lastValueValid = !date || this._dateAdapter.isValid(date);
                    date = this._getValidDateOrNull(date);
                    if (!this._dateAdapter.sameDate(date, this._value)) {
                        this._value = date;
                        this._cvaOnChange(date);
                        this._valueChange.emit(date);
                        this.dateInput.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
                    }
                    else {
                        this._validatorOnChange();
                    }
                };
                /**
                 * @return {?}
                 */
                MatDatepickerInput.prototype._onChange = function () {
                    this.dateChange.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
                };
                /**
                 * Returns the palette used by the input's form field, if any.
                 * @return {?}
                 */
                MatDatepickerInput.prototype._getThemePalette = function () {
                    return this._formField ? this._formField.color : undefined;
                };
                /**
                 * Handles blur events on the input.
                 * @return {?}
                 */
                MatDatepickerInput.prototype._onBlur = function () {
                    // Reformat the input only if we have a valid value.
                    if (this.value) {
                        this._formatValue(this.value);
                    }
                    this._onTouched();
                };
                /**
                 * Formats a value and sets it on the input element.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatDatepickerInput.prototype._formatValue = function (value) {
                    this._elementRef.nativeElement.value =
                        value ? this._dateAdapter.format(value, this._dateFormats.display.dateInput) : '';
                };
                /**
                 * @private
                 * @param {?} obj The object to check.
                 * @return {?} The given object if it is both a date instance and valid, otherwise null.
                 */
                MatDatepickerInput.prototype._getValidDateOrNull = function (obj) {
                    return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
                };
                return MatDatepickerInput;
            }());
            MatDatepickerInput.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'input[matDatepicker]',
                            providers: [
                                MAT_DATEPICKER_VALUE_ACCESSOR,
                                MAT_DATEPICKER_VALIDATORS,
                                { provide: _angular_material_input__WEBPACK_IMPORTED_MODULE_14__["MAT_INPUT_VALUE_ACCESSOR"], useExisting: MatDatepickerInput },
                            ],
                            host: {
                                '[attr.aria-haspopup]': '_datepicker ? "dialog" : null',
                                '[attr.aria-owns]': '(_datepicker?.opened && _datepicker.id) || null',
                                '[attr.min]': 'min ? _dateAdapter.toIso8601(min) : null',
                                '[attr.max]': 'max ? _dateAdapter.toIso8601(max) : null',
                                '[disabled]': 'disabled',
                                '(input)': '_onInput($event.target.value)',
                                '(change)': '_onChange()',
                                '(blur)': '_onBlur()',
                                '(keydown)': '_onKeydown($event)',
                            },
                            exportAs: 'matDatepickerInput',
                        },] },
            ];
            /** @nocollapse */
            MatDatepickerInput.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["DateAdapter"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_DATE_FORMATS"],] }] },
                { type: _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatFormField"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatDatepickerInput.propDecorators = {
                matDatepicker: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                matDatepickerFilter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                min: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                max: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                dateChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                dateInput: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Can be used to override the icon of a `matDatepickerToggle`.
             */
            var MatDatepickerToggleIcon = /** @class */ (function () {
                function MatDatepickerToggleIcon() {
                }
                return MatDatepickerToggleIcon;
            }());
            MatDatepickerToggleIcon.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[matDatepickerToggleIcon]'
                        },] },
            ];
            /**
             * @template D
             */
            var MatDatepickerToggle = /** @class */ (function () {
                /**
                 * @param {?} _intl
                 * @param {?} _changeDetectorRef
                 * @param {?} defaultTabIndex
                 */
                function MatDatepickerToggle(_intl, _changeDetectorRef, defaultTabIndex) {
                    this._intl = _intl;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._stateChanges = rxjs__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    /** @type {?} */
                    var parsedTabIndex = Number(defaultTabIndex);
                    this.tabIndex = (parsedTabIndex || parsedTabIndex === 0) ? parsedTabIndex : null;
                }
                Object.defineProperty(MatDatepickerToggle.prototype, "disabled", {
                    /**
                     * Whether the toggle button is disabled.
                     * @return {?}
                     */
                    get: function () {
                        if (this._disabled === undefined && this.datepicker) {
                            return this.datepicker.disabled;
                        }
                        return !!this._disabled;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatDatepickerToggle.prototype.ngOnChanges = function (changes) {
                    if (changes['datepicker']) {
                        this._watchStateChanges();
                    }
                };
                /**
                 * @return {?}
                 */
                MatDatepickerToggle.prototype.ngOnDestroy = function () {
                    this._stateChanges.unsubscribe();
                };
                /**
                 * @return {?}
                 */
                MatDatepickerToggle.prototype.ngAfterContentInit = function () {
                    this._watchStateChanges();
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatDatepickerToggle.prototype._open = function (event) {
                    if (this.datepicker && !this.disabled) {
                        this.datepicker.open();
                        event.stopPropagation();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatDatepickerToggle.prototype._watchStateChanges = function () {
                    var _this = this;
                    /** @type {?} */
                    var datepickerDisabled = this.datepicker ? this.datepicker._disabledChange : Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["of"])();
                    /** @type {?} */
                    var inputDisabled = this.datepicker && this.datepicker._datepickerInput ?
                        this.datepicker._datepickerInput._disabledChange : Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["of"])();
                    /** @type {?} */
                    var datepickerToggled = this.datepicker ?
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["merge"])(this.datepicker.openedStream, this.datepicker.closedStream) :
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["of"])();
                    this._stateChanges.unsubscribe();
                    this._stateChanges = Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["merge"])(this._intl.changes, datepickerDisabled, inputDisabled, datepickerToggled).subscribe(( /**
                     * @return {?}
                     */function () { return _this._changeDetectorRef.markForCheck(); }));
                };
                return MatDatepickerToggle;
            }());
            MatDatepickerToggle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-datepicker-toggle',
                            template: "<button #button mat-icon-button type=\"button\" [attr.aria-haspopup]=\"datepicker ? 'dialog' : null\" [attr.aria-label]=\"_intl.openCalendarLabel\" [attr.tabindex]=\"disabled ? -1 : tabIndex\" [disabled]=\"disabled\" [disableRipple]=\"disableRipple\" (click)=\"_open($event)\"><svg *ngIf=\"!_customIcon\" class=\"mat-datepicker-toggle-default-icon\" viewBox=\"0 0 24 24\" width=\"24px\" height=\"24px\" fill=\"currentColor\" focusable=\"false\"><path d=\"M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z\"/></svg><ng-content select=\"[matDatepickerToggleIcon]\"></ng-content></button>",
                            styles: [".mat-form-field-appearance-legacy .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-datepicker-toggle-default-icon{width:1em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-datepicker-toggle-default-icon{display:block;width:1.5em;height:1.5em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-datepicker-toggle-default-icon{margin:auto}"],
                            host: {
                                'class': 'mat-datepicker-toggle',
                                // Always set the tabindex to -1 so that it doesn't overlap with any custom tabindex the
                                // consumer may have provided, while still being able to receive focus.
                                '[attr.tabindex]': '-1',
                                '[class.mat-datepicker-toggle-active]': 'datepicker && datepicker.opened',
                                '[class.mat-accent]': 'datepicker && datepicker.color === "accent"',
                                '[class.mat-warn]': 'datepicker && datepicker.color === "warn"',
                                '(focus)': '_button.focus()',
                            },
                            exportAs: 'matDatepickerToggle',
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatDatepickerToggle.ctorParameters = function () { return [
                { type: MatDatepickerIntl },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['tabindex',] }] }
            ]; };
            MatDatepickerToggle.propDecorators = {
                datepicker: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['for',] }],
                tabIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disableRipple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                _customIcon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatDatepickerToggleIcon, { static: false },] }],
                _button: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['button', { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatDatepickerModule = /** @class */ (function () {
                function MatDatepickerModule() {
                }
                return MatDatepickerModule;
            }());
            MatDatepickerModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_10__["CommonModule"],
                                _angular_material_button__WEBPACK_IMPORTED_MODULE_15__["MatButtonModule"],
                                _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__["MatDialogModule"],
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["OverlayModule"],
                                _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_16__["A11yModule"],
                                _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_6__["PortalModule"],
                            ],
                            exports: [
                                MatCalendar,
                                MatCalendarBody,
                                MatDatepicker,
                                MatDatepickerContent,
                                MatDatepickerInput,
                                MatDatepickerToggle,
                                MatDatepickerToggleIcon,
                                MatMonthView,
                                MatYearView,
                                MatMultiYearView,
                                MatCalendarHeader,
                            ],
                            declarations: [
                                MatCalendar,
                                MatCalendarBody,
                                MatDatepicker,
                                MatDatepickerContent,
                                MatDatepickerInput,
                                MatDatepickerToggle,
                                MatDatepickerToggleIcon,
                                MatMonthView,
                                MatYearView,
                                MatMultiYearView,
                                MatCalendarHeader,
                            ],
                            providers: [
                                MatDatepickerIntl,
                                MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER,
                            ],
                            entryComponents: [
                                MatDatepickerContent,
                                MatCalendarHeader,
                            ]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=datepicker.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/dialog.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/dialog.js ***!
          \**********************************************************/
        /*! exports provided: MatDialogModule, MAT_DIALOG_SCROLL_STRATEGY_FACTORY, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY, MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_SCROLL_STRATEGY, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER, MatDialog, throwMatDialogContentAlreadyAttachedError, MatDialogContainer, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogConfig, MatDialogRef, matDialogAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogModule", function () { return MatDialogModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY_FACTORY", function () { return MAT_DIALOG_SCROLL_STRATEGY_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY", function () { return MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_DATA", function () { return MAT_DIALOG_DATA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_DEFAULT_OPTIONS", function () { return MAT_DIALOG_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY", function () { return MAT_DIALOG_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY_PROVIDER", function () { return MAT_DIALOG_SCROLL_STRATEGY_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialog", function () { return MatDialog; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwMatDialogContentAlreadyAttachedError", function () { return throwMatDialogContentAlreadyAttachedError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogContainer", function () { return MatDialogContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogClose", function () { return MatDialogClose; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogTitle", function () { return MatDialogTitle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogContent", function () { return MatDialogContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogActions", function () { return MatDialogActions; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogConfig", function () { return MatDialogConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDialogRef", function () { return MatDialogRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matDialogAnimations", function () { return matDialogAnimations; });
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Configuration for opening a modal dialog with the MatDialog service.
             * @template D
             */
            var MatDialogConfig = /** @class */ (function () {
                function MatDialogConfig() {
                    /**
                     * The ARIA role of the dialog element.
                     */
                    this.role = 'dialog';
                    /**
                     * Custom class for the overlay pane.
                     */
                    this.panelClass = '';
                    /**
                     * Whether the dialog has a backdrop.
                     */
                    this.hasBackdrop = true;
                    /**
                     * Custom class for the backdrop.
                     */
                    this.backdropClass = '';
                    /**
                     * Whether the user can use escape or clicking on the backdrop to close the modal.
                     */
                    this.disableClose = false;
                    /**
                     * Width of the dialog.
                     */
                    this.width = '';
                    /**
                     * Height of the dialog.
                     */
                    this.height = '';
                    /**
                     * Max-width of the dialog. If a number is provided, assumes pixel units. Defaults to 80vw.
                     */
                    this.maxWidth = '80vw';
                    /**
                     * Data being injected into the child component.
                     */
                    this.data = null;
                    /**
                     * ID of the element that describes the dialog.
                     */
                    this.ariaDescribedBy = null;
                    /**
                     * ID of the element that labels the dialog.
                     */
                    this.ariaLabelledBy = null;
                    /**
                     * Aria label to assign to the dialog element.
                     */
                    this.ariaLabel = null;
                    /**
                     * Whether the dialog should focus the first focusable element on open.
                     */
                    this.autoFocus = true;
                    /**
                     * Whether the dialog should restore focus to the
                     * previously-focused element, after it's closed.
                     */
                    this.restoreFocus = true;
                    /**
                     * Whether the dialog should close when the user goes backwards/forwards in history.
                     * Note that this usually doesn't include clicking on links (unless the user is using
                     * the `HashLocationStrategy`).
                     */
                    this.closeOnNavigation = true;
                    // TODO(jelbourn): add configuration for lifecycle hooks, ARIA labelling.
                }
                return MatDialogConfig;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var animationBody = [
                // Note: The `enter` animation transitions to `transform: none`, because for some reason
                // specifying the transform explicitly, causes IE both to blur the dialog content and
                // decimate the animation performance. Leaving it as `none` solves both issues.
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('void, exit', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0, transform: 'scale(0.7)' })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('enter', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ transform: 'none' })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => enter', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('150ms cubic-bezier(0, 0, 0.2, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ transform: 'none', opacity: 1 }))),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => void, * => exit', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('75ms cubic-bezier(0.4, 0.0, 0.2, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0 }))),
            ];
            /**
             * Animations used by MatDialog.
             * \@docs-private
             * @type {?}
             */
            var matDialogAnimations = {
                /**
                 * Animation that is applied on the dialog container by defalt.
                 */
                dialogContainer: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('dialogContainer', animationBody),
                /**
                 * @deprecated \@breaking-change 8.0.0 Use `matDialogAnimations.dialogContainer` instead.
                 */
                slideDialog: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('slideDialog', animationBody)
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Throws an exception for the case when a ComponentPortal is
             * attached to a DomPortalOutlet without an origin.
             * \@docs-private
             * @return {?}
             */
            function throwMatDialogContentAlreadyAttachedError() {
                throw Error('Attempting to attach dialog content after content is already attached');
            }
            /**
             * Internal component that wraps user-provided dialog content.
             * Animation is based on https://material.io/guidelines/motion/choreography.html.
             * \@docs-private
             */
            var MatDialogContainer = /** @class */ (function (_super_1) {
                __extends(MatDialogContainer, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _focusTrapFactory
                 * @param {?} _changeDetectorRef
                 * @param {?} _document
                 * @param {?} _config
                 */
                function MatDialogContainer(_elementRef, _focusTrapFactory, _changeDetectorRef, _document, _config) {
                    var _this = _super_1.call(this) || this;
                    _this._elementRef = _elementRef;
                    _this._focusTrapFactory = _focusTrapFactory;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._document = _document;
                    _this._config = _config;
                    /**
                     * Element that was focused before the dialog was opened. Save this to restore upon close.
                     */
                    _this._elementFocusedBeforeDialogWasOpened = null;
                    /**
                     * State of the dialog animation.
                     */
                    _this._state = 'enter';
                    /**
                     * Emits when an animation state changes.
                     */
                    _this._animationStateChanged = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    _this._ariaLabelledBy = _config.ariaLabelledBy || null;
                    return _this;
                }
                /**
                 * Attach a ComponentPortal as content to this dialog container.
                 * @template T
                 * @param {?} portal Portal to be attached as the dialog content.
                 * @return {?}
                 */
                MatDialogContainer.prototype.attachComponentPortal = function (portal) {
                    if (this._portalOutlet.hasAttached()) {
                        throwMatDialogContentAlreadyAttachedError();
                    }
                    this._savePreviouslyFocusedElement();
                    return this._portalOutlet.attachComponentPortal(portal);
                };
                /**
                 * Attach a TemplatePortal as content to this dialog container.
                 * @template C
                 * @param {?} portal Portal to be attached as the dialog content.
                 * @return {?}
                 */
                MatDialogContainer.prototype.attachTemplatePortal = function (portal) {
                    if (this._portalOutlet.hasAttached()) {
                        throwMatDialogContentAlreadyAttachedError();
                    }
                    this._savePreviouslyFocusedElement();
                    return this._portalOutlet.attachTemplatePortal(portal);
                };
                /**
                 * Moves the focus inside the focus trap.
                 * @private
                 * @return {?}
                 */
                MatDialogContainer.prototype._trapFocus = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    if (!this._focusTrap) {
                        this._focusTrap = this._focusTrapFactory.create(element);
                    }
                    // If we were to attempt to focus immediately, then the content of the dialog would not yet be
                    // ready in instances where change detection has to run first. To deal with this, we simply
                    // wait for the microtask queue to be empty.
                    if (this._config.autoFocus) {
                        this._focusTrap.focusInitialElementWhenReady();
                    }
                    else {
                        /** @type {?} */
                        var activeElement = this._document.activeElement;
                        // Otherwise ensure that focus is on the dialog container. It's possible that a different
                        // component tried to move focus while the open animation was running. See:
                        // https://github.com/angular/components/issues/16215. Note that we only want to do this
                        // if the focus isn't inside the dialog already, because it's possible that the consumer
                        // turned off `autoFocus` in order to move focus themselves.
                        if (activeElement !== element && !element.contains(activeElement)) {
                            element.focus();
                        }
                    }
                };
                /**
                 * Restores focus to the element that was focused before the dialog opened.
                 * @private
                 * @return {?}
                 */
                MatDialogContainer.prototype._restoreFocus = function () {
                    /** @type {?} */
                    var toFocus = this._elementFocusedBeforeDialogWasOpened;
                    // We need the extra check, because IE can set the `activeElement` to null in some cases.
                    if (this._config.restoreFocus && toFocus && typeof toFocus.focus === 'function') {
                        toFocus.focus();
                    }
                    if (this._focusTrap) {
                        this._focusTrap.destroy();
                    }
                };
                /**
                 * Saves a reference to the element that was focused before the dialog was opened.
                 * @private
                 * @return {?}
                 */
                MatDialogContainer.prototype._savePreviouslyFocusedElement = function () {
                    var _this = this;
                    if (this._document) {
                        this._elementFocusedBeforeDialogWasOpened = ( /** @type {?} */(this._document.activeElement));
                        // Note that there is no focus method when rendering on the server.
                        if (this._elementRef.nativeElement.focus) {
                            // Move focus onto the dialog immediately in order to prevent the user from accidentally
                            // opening multiple dialogs at the same time. Needs to be async, because the element
                            // may not be focusable immediately.
                            Promise.resolve().then(( /**
                             * @return {?}
                             */function () { return _this._elementRef.nativeElement.focus(); }));
                        }
                    }
                };
                /**
                 * Callback, invoked whenever an animation on the host completes.
                 * @param {?} event
                 * @return {?}
                 */
                MatDialogContainer.prototype._onAnimationDone = function (event) {
                    if (event.toState === 'enter') {
                        this._trapFocus();
                    }
                    else if (event.toState === 'exit') {
                        this._restoreFocus();
                    }
                    this._animationStateChanged.emit(event);
                };
                /**
                 * Callback, invoked when an animation on the host starts.
                 * @param {?} event
                 * @return {?}
                 */
                MatDialogContainer.prototype._onAnimationStart = function (event) {
                    this._animationStateChanged.emit(event);
                };
                /**
                 * Starts the dialog exit animation.
                 * @return {?}
                 */
                MatDialogContainer.prototype._startExitAnimation = function () {
                    this._state = 'exit';
                    // Mark the container for check so it can react if the
                    // view container is using OnPush change detection.
                    this._changeDetectorRef.markForCheck();
                };
                return MatDialogContainer;
            }(_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["BasePortalOutlet"]));
            MatDialogContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-dialog-container',
                            template: "<ng-template cdkPortalOutlet></ng-template>",
                            styles: [".mat-dialog-container{display:block;padding:24px;border-radius:4px;box-sizing:border-box;overflow:auto;outline:0;width:100%;height:100%;min-height:inherit;max-height:inherit}@media (-ms-high-contrast:active){.mat-dialog-container{outline:solid 1px}}.mat-dialog-content{display:block;margin:0 -24px;padding:0 24px;max-height:65vh;overflow:auto;-webkit-overflow-scrolling:touch}.mat-dialog-title{margin:0 0 20px;display:block}.mat-dialog-actions{padding:8px 0;display:flex;flex-wrap:wrap;min-height:52px;align-items:center;margin-bottom:-24px}.mat-dialog-actions[align=end]{justify-content:flex-end}.mat-dialog-actions[align=center]{justify-content:center}.mat-dialog-actions .mat-button-base+.mat-button-base{margin-left:8px}[dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base{margin-left:0;margin-right:8px}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            // Using OnPush for dialogs caused some G3 sync issues. Disabled until we can track them down.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            animations: [matDialogAnimations.dialogContainer],
                            host: {
                                'class': 'mat-dialog-container',
                                'tabindex': '-1',
                                'aria-modal': 'true',
                                '[attr.id]': '_id',
                                '[attr.role]': '_config.role',
                                '[attr.aria-labelledby]': '_config.ariaLabel ? null : _ariaLabelledBy',
                                '[attr.aria-label]': '_config.ariaLabel',
                                '[attr.aria-describedby]': '_config.ariaDescribedBy || null',
                                '[@dialogContainer]': '_state',
                                '(@dialogContainer.start)': '_onAnimationStart($event)',
                                '(@dialogContainer.done)': '_onAnimationDone($event)',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatDialogContainer.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_4__["FocusTrapFactory"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: MatDialogConfig }
            ]; };
            MatDialogContainer.propDecorators = {
                _portalOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["CdkPortalOutlet"], { static: true },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO(jelbourn): resizing
            // Counter for unique dialog ids.
            /** @type {?} */
            var uniqueId = 0;
            /**
             * Reference to a dialog opened via the MatDialog service.
             * @template T, R
             */
            var MatDialogRef = /** @class */ (function () {
                /**
                 * @param {?} _overlayRef
                 * @param {?} _containerInstance
                 * @param {?=} _location
                 * @param {?=} id
                 */
                function MatDialogRef(_overlayRef, _containerInstance, 
                // @breaking-change 8.0.0 `_location` parameter to be removed.
                _location, id) {
                    var _this = this;
                    if (id === void 0) { id = "mat-dialog-" + uniqueId++; }
                    this._overlayRef = _overlayRef;
                    this._containerInstance = _containerInstance;
                    this.id = id;
                    /**
                     * Whether the user is allowed to close the dialog.
                     */
                    this.disableClose = this._containerInstance._config.disableClose;
                    /**
                     * Subject for notifying the user that the dialog has finished opening.
                     */
                    this._afterOpened = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    /**
                     * Subject for notifying the user that the dialog has finished closing.
                     */
                    this._afterClosed = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    /**
                     * Subject for notifying the user that the dialog has started closing.
                     */
                    this._beforeClosed = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    /**
                     * Current state of the dialog.
                     */
                    this._state = 0 /* OPEN */;
                    // Pass the id along to the container.
                    _containerInstance._id = id;
                    // Emit when opening animation completes
                    _containerInstance._animationStateChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) { return event.phaseName === 'done' && event.toState === 'enter'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["take"])(1))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._afterOpened.next();
                        _this._afterOpened.complete();
                    }));
                    // Dispose overlay when closing animation is complete
                    _containerInstance._animationStateChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) { return event.phaseName === 'done' && event.toState === 'exit'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["take"])(1)).subscribe(( /**
                     * @return {?}
                     */function () {
                        clearTimeout(_this._closeFallbackTimeout);
                        _this._overlayRef.dispose();
                    }));
                    _overlayRef.detachments().subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._beforeClosed.next(_this._result);
                        _this._beforeClosed.complete();
                        _this._afterClosed.next(_this._result);
                        _this._afterClosed.complete();
                        _this.componentInstance = ( /** @type {?} */(null));
                        _this._overlayRef.dispose();
                    }));
                    _overlayRef.keydownEvents()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["filter"])(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) {
                        return event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["ESCAPE"] && !_this.disableClose && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["hasModifierKey"])(event);
                    })))
                        .subscribe(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) {
                        event.preventDefault();
                        _this.close();
                    }));
                }
                /**
                 * Close the dialog.
                 * @param {?=} dialogResult Optional result to return to the dialog opener.
                 * @return {?}
                 */
                MatDialogRef.prototype.close = function (dialogResult) {
                    var _this = this;
                    this._result = dialogResult;
                    // Transition the backdrop in parallel to the dialog.
                    this._containerInstance._animationStateChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) { return event.phaseName === 'start'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["take"])(1))
                        .subscribe(( /**
                 * @param {?} event
                 * @return {?}
                 */function (/**
                 * @param {?} event
                 * @return {?}
                 */ event) {
                        _this._beforeClosed.next(dialogResult);
                        _this._beforeClosed.complete();
                        _this._state = 2 /* CLOSED */;
                        _this._overlayRef.detachBackdrop();
                        // The logic that disposes of the overlay depends on the exit animation completing, however
                        // it isn't guaranteed if the parent view is destroyed while it's running. Add a fallback
                        // timeout which will clean everything up if the animation hasn't fired within the specified
                        // amount of time plus 100ms. We don't need to run this outside the NgZone, because for the
                        // vast majority of cases the timeout will have been cleared before it has the chance to fire.
                        _this._closeFallbackTimeout = setTimeout(( /**
                         * @return {?}
                         */function () {
                            _this._overlayRef.dispose();
                        }), event.totalTime + 100);
                    }));
                    this._containerInstance._startExitAnimation();
                    this._state = 1 /* CLOSING */;
                };
                /**
                 * Gets an observable that is notified when the dialog is finished opening.
                 * @return {?}
                 */
                MatDialogRef.prototype.afterOpened = function () {
                    return this._afterOpened.asObservable();
                };
                /**
                 * Gets an observable that is notified when the dialog is finished closing.
                 * @return {?}
                 */
                MatDialogRef.prototype.afterClosed = function () {
                    return this._afterClosed.asObservable();
                };
                /**
                 * Gets an observable that is notified when the dialog has started closing.
                 * @return {?}
                 */
                MatDialogRef.prototype.beforeClosed = function () {
                    return this._beforeClosed.asObservable();
                };
                /**
                 * Gets an observable that emits when the overlay's backdrop has been clicked.
                 * @return {?}
                 */
                MatDialogRef.prototype.backdropClick = function () {
                    return this._overlayRef.backdropClick();
                };
                /**
                 * Gets an observable that emits when keydown events are targeted on the overlay.
                 * @return {?}
                 */
                MatDialogRef.prototype.keydownEvents = function () {
                    return this._overlayRef.keydownEvents();
                };
                /**
                 * Updates the dialog's position.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} position New dialog position.
                 * @return {THIS}
                 */
                MatDialogRef.prototype.updatePosition = function (position) {
                    /** @type {?} */
                    var strategy = ( /** @type {?} */(this))._getPositionStrategy();
                    if (position && (position.left || position.right)) {
                        position.left ? strategy.left(position.left) : strategy.right(position.right);
                    }
                    else {
                        strategy.centerHorizontally();
                    }
                    if (position && (position.top || position.bottom)) {
                        position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
                    }
                    else {
                        strategy.centerVertically();
                    }
                    ( /** @type {?} */(this))._overlayRef.updatePosition();
                    return ( /** @type {?} */(this));
                };
                /**
                 * Updates the dialog's width and height.
                 * @template THIS
                 * @this {THIS}
                 * @param {?=} width New width of the dialog.
                 * @param {?=} height New height of the dialog.
                 * @return {THIS}
                 */
                MatDialogRef.prototype.updateSize = function (width, height) {
                    if (width === void 0) { width = ''; }
                    if (height === void 0) { height = ''; }
                    ( /** @type {?} */(this))._getPositionStrategy().width(width).height(height);
                    ( /** @type {?} */(this))._overlayRef.updatePosition();
                    return ( /** @type {?} */(this));
                };
                /**
                 * Add a CSS class or an array of classes to the overlay pane.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} classes
                 * @return {THIS}
                 */
                MatDialogRef.prototype.addPanelClass = function (classes) {
                    ( /** @type {?} */(this))._overlayRef.addPanelClass(classes);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Remove a CSS class or an array of classes from the overlay pane.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} classes
                 * @return {THIS}
                 */
                MatDialogRef.prototype.removePanelClass = function (classes) {
                    ( /** @type {?} */(this))._overlayRef.removePanelClass(classes);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Gets an observable that is notified when the dialog is finished opening.
                 * @deprecated Use `afterOpened` instead.
                 * \@breaking-change 8.0.0
                 * @return {?}
                 */
                MatDialogRef.prototype.afterOpen = function () {
                    return this.afterOpened();
                };
                /**
                 * Gets an observable that is notified when the dialog has started closing.
                 * @deprecated Use `beforeClosed` instead.
                 * \@breaking-change 8.0.0
                 * @return {?}
                 */
                MatDialogRef.prototype.beforeClose = function () {
                    return this.beforeClosed();
                };
                /**
                 * Gets the current state of the dialog's lifecycle.
                 * @return {?}
                 */
                MatDialogRef.prototype.getState = function () {
                    return this._state;
                };
                /**
                 * Fetches the position strategy object from the overlay ref.
                 * @private
                 * @return {?}
                 */
                MatDialogRef.prototype._getPositionStrategy = function () {
                    return ( /** @type {?} */(this._overlayRef.getConfig().positionStrategy));
                };
                return MatDialogRef;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to access the data that was passed in to a dialog.
             * @type {?}
             */
            var MAT_DIALOG_DATA = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('MatDialogData');
            /**
             * Injection token that can be used to specify default dialog options.
             * @type {?}
             */
            var MAT_DIALOG_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('mat-dialog-default-options');
            /**
             * Injection token that determines the scroll handling while the dialog is open.
             * @type {?}
             */
            var MAT_DIALOG_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('mat-dialog-scroll-strategy');
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_DIALOG_SCROLL_STRATEGY_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.block(); });
            }
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.block(); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_DIALOG_SCROLL_STRATEGY_PROVIDER = {
                provide: MAT_DIALOG_SCROLL_STRATEGY,
                deps: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["Overlay"]],
                useFactory: MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY,
            };
            /**
             * Service to open Material Design modal dialogs.
             */
            var MatDialog = /** @class */ (function () {
                /**
                 * @param {?} _overlay
                 * @param {?} _injector
                 * @param {?} _location
                 * @param {?} _defaultOptions
                 * @param {?} scrollStrategy
                 * @param {?} _parentDialog
                 * @param {?} _overlayContainer
                 */
                function MatDialog(_overlay, _injector, _location, _defaultOptions, scrollStrategy, _parentDialog, _overlayContainer) {
                    var _this = this;
                    this._overlay = _overlay;
                    this._injector = _injector;
                    this._location = _location;
                    this._defaultOptions = _defaultOptions;
                    this._parentDialog = _parentDialog;
                    this._overlayContainer = _overlayContainer;
                    this._openDialogsAtThisLevel = [];
                    this._afterAllClosedAtThisLevel = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    this._afterOpenedAtThisLevel = new rxjs__WEBPACK_IMPORTED_MODULE_6__["Subject"]();
                    this._ariaHiddenElements = new Map();
                    // TODO (jelbourn): tighten the typing right-hand side of this expression.
                    /**
                     * Stream that emits when all open dialog have finished closing.
                     * Will emit on subscribe if there are no open dialogs to begin with.
                     */
                    this.afterAllClosed = ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["defer"])(( /**
                     * @return {?}
                     */function () { return _this.openDialogs.length ?
                        _this._afterAllClosed :
                        _this._afterAllClosed.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(undefined)); }))));
                    this._scrollStrategy = scrollStrategy;
                }
                Object.defineProperty(MatDialog.prototype, "openDialogs", {
                    /**
                     * Keeps track of the currently-open dialogs.
                     * @return {?}
                     */
                    get: function () {
                        return this._parentDialog ? this._parentDialog.openDialogs : this._openDialogsAtThisLevel;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDialog.prototype, "afterOpened", {
                    /**
                     * Stream that emits when a dialog has been opened.
                     * @return {?}
                     */
                    get: function () {
                        return this._parentDialog ? this._parentDialog.afterOpened : this._afterOpenedAtThisLevel;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDialog.prototype, "afterOpen", {
                    /**
                     * Stream that emits when a dialog has been opened.
                     * @deprecated Use `afterOpened` instead.
                     * \@breaking-change 8.0.0
                     * @return {?}
                     */
                    get: function () {
                        return this.afterOpened;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDialog.prototype, "_afterAllClosed", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var parent = this._parentDialog;
                        return parent ? parent._afterAllClosed : this._afterAllClosedAtThisLevel;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Opens a modal dialog containing the given component.
                 * @template T, D, R
                 * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
                 *     or a TemplateRef to instantiate as the dialog content.
                 * @param {?=} config Extra configuration options.
                 * @return {?} Reference to the newly-opened dialog.
                 */
                MatDialog.prototype.open = function (componentOrTemplateRef, config) {
                    var _this = this;
                    config = _applyConfigDefaults(config, this._defaultOptions || new MatDialogConfig());
                    if (config.id && this.getDialogById(config.id)) {
                        throw Error("Dialog with id \"" + config.id + "\" exists already. The dialog id must be unique.");
                    }
                    /** @type {?} */
                    var overlayRef = this._createOverlay(config);
                    /** @type {?} */
                    var dialogContainer = this._attachDialogContainer(overlayRef, config);
                    /** @type {?} */
                    var dialogRef = this._attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
                    // If this is the first dialog that we're opening, hide all the non-overlay content.
                    if (!this.openDialogs.length) {
                        this._hideNonDialogContentFromAssistiveTechnology();
                    }
                    this.openDialogs.push(dialogRef);
                    dialogRef.afterClosed().subscribe(( /**
                     * @return {?}
                     */function () { return _this._removeOpenDialog(dialogRef); }));
                    this.afterOpened.next(dialogRef);
                    return dialogRef;
                };
                /**
                 * Closes all of the currently-open dialogs.
                 * @return {?}
                 */
                MatDialog.prototype.closeAll = function () {
                    this._closeDialogs(this.openDialogs);
                };
                /**
                 * Finds an open dialog by its id.
                 * @param {?} id ID to use when looking up the dialog.
                 * @return {?}
                 */
                MatDialog.prototype.getDialogById = function (id) {
                    return this.openDialogs.find(( /**
                     * @param {?} dialog
                     * @return {?}
                     */function (/**
                     * @param {?} dialog
                     * @return {?}
                     */ dialog) { return dialog.id === id; }));
                };
                /**
                 * @return {?}
                 */
                MatDialog.prototype.ngOnDestroy = function () {
                    // Only close the dialogs at this level on destroy
                    // since the parent service may still be active.
                    this._closeDialogs(this._openDialogsAtThisLevel);
                    this._afterAllClosedAtThisLevel.complete();
                    this._afterOpenedAtThisLevel.complete();
                };
                /**
                 * Creates the overlay into which the dialog will be loaded.
                 * @private
                 * @param {?} config The dialog configuration.
                 * @return {?} A promise resolving to the OverlayRef for the created overlay.
                 */
                MatDialog.prototype._createOverlay = function (config) {
                    /** @type {?} */
                    var overlayConfig = this._getOverlayConfig(config);
                    return this._overlay.create(overlayConfig);
                };
                /**
                 * Creates an overlay config from a dialog config.
                 * @private
                 * @param {?} dialogConfig The dialog configuration.
                 * @return {?} The overlay configuration.
                 */
                MatDialog.prototype._getOverlayConfig = function (dialogConfig) {
                    /** @type {?} */
                    var state$$1 = new _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["OverlayConfig"]({
                        positionStrategy: this._overlay.position().global(),
                        scrollStrategy: dialogConfig.scrollStrategy || this._scrollStrategy(),
                        panelClass: dialogConfig.panelClass,
                        hasBackdrop: dialogConfig.hasBackdrop,
                        direction: dialogConfig.direction,
                        minWidth: dialogConfig.minWidth,
                        minHeight: dialogConfig.minHeight,
                        maxWidth: dialogConfig.maxWidth,
                        maxHeight: dialogConfig.maxHeight,
                        disposeOnNavigation: dialogConfig.closeOnNavigation
                    });
                    if (dialogConfig.backdropClass) {
                        state$$1.backdropClass = dialogConfig.backdropClass;
                    }
                    return state$$1;
                };
                /**
                 * Attaches an MatDialogContainer to a dialog's already-created overlay.
                 * @private
                 * @param {?} overlay Reference to the dialog's underlying overlay.
                 * @param {?} config The dialog configuration.
                 * @return {?} A promise resolving to a ComponentRef for the attached container.
                 */
                MatDialog.prototype._attachDialogContainer = function (overlay, config) {
                    /** @type {?} */
                    var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
                    /** @type {?} */
                    var injector = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalInjector"](userInjector || this._injector, new WeakMap([
                        [MatDialogConfig, config]
                    ]));
                    /** @type {?} */
                    var containerPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](MatDialogContainer, config.viewContainerRef, injector, config.componentFactoryResolver);
                    /** @type {?} */
                    var containerRef = overlay.attach(containerPortal);
                    return containerRef.instance;
                };
                /**
                 * Attaches the user-provided component to the already-created MatDialogContainer.
                 * @private
                 * @template T, R
                 * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
                 *     or a TemplateRef to instantiate as the content.
                 * @param {?} dialogContainer Reference to the wrapping MatDialogContainer.
                 * @param {?} overlayRef Reference to the overlay in which the dialog resides.
                 * @param {?} config The dialog configuration.
                 * @return {?} A promise resolving to the MatDialogRef that should be returned to the user.
                 */
                MatDialog.prototype._attachDialogContent = function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
                    // Create a reference to the dialog we're creating in order to give the user a handle
                    // to modify and close it.
                    /** @type {?} */
                    var dialogRef = new MatDialogRef(overlayRef, dialogContainer, this._location, config.id);
                    // When the dialog backdrop is clicked, we want to close it.
                    if (config.hasBackdrop) {
                        overlayRef.backdropClick().subscribe(( /**
                         * @return {?}
                         */function () {
                            if (!dialogRef.disableClose) {
                                dialogRef.close();
                            }
                        }));
                    }
                    if (componentOrTemplateRef instanceof _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"]) {
                        dialogContainer.attachTemplatePortal(new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["TemplatePortal"](componentOrTemplateRef, ( /** @type {?} */(null)), ( /** @type {?} */({ $implicit: config.data, dialogRef: dialogRef }))));
                    }
                    else {
                        /** @type {?} */
                        var injector = this._createInjector(config, dialogRef, dialogContainer);
                        /** @type {?} */
                        var contentRef = dialogContainer.attachComponentPortal(new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](componentOrTemplateRef, undefined, injector));
                        dialogRef.componentInstance = contentRef.instance;
                    }
                    dialogRef
                        .updateSize(config.width, config.height)
                        .updatePosition(config.position);
                    return dialogRef;
                };
                /**
                 * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
                 * of a dialog to close itself and, optionally, to return a value.
                 * @private
                 * @template T
                 * @param {?} config Config object that is used to construct the dialog.
                 * @param {?} dialogRef Reference to the dialog.
                 * @param {?} dialogContainer
                 * @return {?} The custom injector that can be used inside the dialog.
                 */
                MatDialog.prototype._createInjector = function (config, dialogRef, dialogContainer) {
                    /** @type {?} */
                    var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
                    // The MatDialogContainer is injected in the portal as the MatDialogContainer and the dialog's
                    // content are created out of the same ViewContainerRef and as such, are siblings for injector
                    // purposes. To allow the hierarchy that is expected, the MatDialogContainer is explicitly
                    // added to the injection tokens.
                    /** @type {?} */
                    var injectionTokens = new WeakMap([
                        [MatDialogContainer, dialogContainer],
                        [MAT_DIALOG_DATA, config.data],
                        [MatDialogRef, dialogRef]
                    ]);
                    if (config.direction &&
                        (!userInjector || !userInjector.get(_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_8__["Directionality"], null))) {
                        injectionTokens.set(_angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_8__["Directionality"], {
                            value: config.direction,
                            change: Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["of"])()
                        });
                    }
                    return new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalInjector"](userInjector || this._injector, injectionTokens);
                };
                /**
                 * Removes a dialog from the array of open dialogs.
                 * @private
                 * @param {?} dialogRef Dialog to be removed.
                 * @return {?}
                 */
                MatDialog.prototype._removeOpenDialog = function (dialogRef) {
                    /** @type {?} */
                    var index = this.openDialogs.indexOf(dialogRef);
                    if (index > -1) {
                        this.openDialogs.splice(index, 1);
                        // If all the dialogs were closed, remove/restore the `aria-hidden`
                        // to a the siblings and emit to the `afterAllClosed` stream.
                        if (!this.openDialogs.length) {
                            this._ariaHiddenElements.forEach(( /**
                             * @param {?} previousValue
                             * @param {?} element
                             * @return {?}
                             */function (previousValue, element) {
                                if (previousValue) {
                                    element.setAttribute('aria-hidden', previousValue);
                                }
                                else {
                                    element.removeAttribute('aria-hidden');
                                }
                            }));
                            this._ariaHiddenElements.clear();
                            this._afterAllClosed.next();
                        }
                    }
                };
                /**
                 * Hides all of the content that isn't an overlay from assistive technology.
                 * @private
                 * @return {?}
                 */
                MatDialog.prototype._hideNonDialogContentFromAssistiveTechnology = function () {
                    /** @type {?} */
                    var overlayContainer = this._overlayContainer.getContainerElement();
                    // Ensure that the overlay container is attached to the DOM.
                    if (overlayContainer.parentElement) {
                        /** @type {?} */
                        var siblings = overlayContainer.parentElement.children;
                        for (var i = siblings.length - 1; i > -1; i--) {
                            /** @type {?} */
                            var sibling = siblings[i];
                            if (sibling !== overlayContainer &&
                                sibling.nodeName !== 'SCRIPT' &&
                                sibling.nodeName !== 'STYLE' &&
                                !sibling.hasAttribute('aria-live')) {
                                this._ariaHiddenElements.set(sibling, sibling.getAttribute('aria-hidden'));
                                sibling.setAttribute('aria-hidden', 'true');
                            }
                        }
                    }
                };
                /**
                 * Closes all of the dialogs in an array.
                 * @private
                 * @param {?} dialogs
                 * @return {?}
                 */
                MatDialog.prototype._closeDialogs = function (dialogs) {
                    /** @type {?} */
                    var i = dialogs.length;
                    while (i--) {
                        // The `_openDialogs` property isn't updated after close until the rxjs subscription
                        // runs on the next microtask, in addition to modifying the array as we're going
                        // through it. We loop through all of them and call close without assuming that
                        // they'll be removed from the list instantaneously.
                        dialogs[i].close();
                    }
                };
                return MatDialog;
            }());
            MatDialog.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] },
            ];
            /** @nocollapse */
            MatDialog.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] },
                { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: MatDialogConfig, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [MAT_DIALOG_DEFAULT_OPTIONS,] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [MAT_DIALOG_SCROLL_STRATEGY,] }] },
                { type: MatDialog, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"] }] },
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["OverlayContainer"] }
            ]; };
            /**
             * Applies default options to the dialog config.
             * @param {?=} config Config to be modified.
             * @param {?=} defaultOptions Default options provided.
             * @return {?} The new configuration object.
             */
            function _applyConfigDefaults(config, defaultOptions) {
                return Object.assign({}, defaultOptions, config);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Counter used to generate unique IDs for dialog elements.
             * @type {?}
             */
            var dialogElementUid = 0;
            /**
             * Button that will close the current dialog.
             */
            var MatDialogClose = /** @class */ (function () {
                /**
                 * @param {?} dialogRef
                 * @param {?} _elementRef
                 * @param {?} _dialog
                 */
                function MatDialogClose(dialogRef, _elementRef, _dialog) {
                    this.dialogRef = dialogRef;
                    this._elementRef = _elementRef;
                    this._dialog = _dialog;
                    /**
                     * Default to "button" to prevents accidental form submits.
                     */
                    this.type = 'button';
                }
                /**
                 * @return {?}
                 */
                MatDialogClose.prototype.ngOnInit = function () {
                    if (!this.dialogRef) {
                        // When this directive is included in a dialog via TemplateRef (rather than being
                        // in a Component), the DialogRef isn't available via injection because embedded
                        // views cannot be given a custom injector. Instead, we look up the DialogRef by
                        // ID. This must occur in `onInit`, as the ID binding for the dialog container won't
                        // be resolved at constructor time.
                        this.dialogRef = ( /** @type {?} */(getClosestDialog(this._elementRef, this._dialog.openDialogs)));
                    }
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatDialogClose.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var proxiedChange = changes['_matDialogClose'] || changes['_matDialogCloseResult'];
                    if (proxiedChange) {
                        this.dialogResult = proxiedChange.currentValue;
                    }
                };
                return MatDialogClose;
            }());
            MatDialogClose.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[mat-dialog-close], [matDialogClose]',
                            exportAs: 'matDialogClose',
                            host: {
                                '(click)': 'dialogRef.close(dialogResult)',
                                '[attr.aria-label]': 'ariaLabel || null',
                                '[attr.type]': 'type',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatDialogClose.ctorParameters = function () { return [
                { type: MatDialogRef, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: MatDialog }
            ]; };
            MatDialogClose.propDecorators = {
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['aria-label',] }],
                type: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                dialogResult: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['mat-dialog-close',] }],
                _matDialogClose: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matDialogClose',] }]
            };
            /**
             * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
             */
            var MatDialogTitle = /** @class */ (function () {
                /**
                 * @param {?} _dialogRef
                 * @param {?} _elementRef
                 * @param {?} _dialog
                 */
                function MatDialogTitle(_dialogRef, _elementRef, _dialog) {
                    this._dialogRef = _dialogRef;
                    this._elementRef = _elementRef;
                    this._dialog = _dialog;
                    this.id = "mat-dialog-title-" + dialogElementUid++;
                }
                /**
                 * @return {?}
                 */
                MatDialogTitle.prototype.ngOnInit = function () {
                    var _this = this;
                    if (!this._dialogRef) {
                        this._dialogRef = ( /** @type {?} */(getClosestDialog(this._elementRef, this._dialog.openDialogs)));
                    }
                    if (this._dialogRef) {
                        Promise.resolve().then(( /**
                         * @return {?}
                         */function () {
                            /** @type {?} */
                            var container = _this._dialogRef._containerInstance;
                            if (container && !container._ariaLabelledBy) {
                                container._ariaLabelledBy = _this.id;
                            }
                        }));
                    }
                };
                return MatDialogTitle;
            }());
            MatDialogTitle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[mat-dialog-title], [matDialogTitle]',
                            exportAs: 'matDialogTitle',
                            host: {
                                'class': 'mat-dialog-title',
                                '[id]': 'id',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatDialogTitle.ctorParameters = function () { return [
                { type: MatDialogRef, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: MatDialog }
            ]; };
            MatDialogTitle.propDecorators = {
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * Scrollable content container of a dialog.
             */
            var MatDialogContent = /** @class */ (function () {
                function MatDialogContent() {
                }
                return MatDialogContent;
            }());
            MatDialogContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]",
                            host: { 'class': 'mat-dialog-content' }
                        },] },
            ];
            /**
             * Container for the bottom action buttons in a dialog.
             * Stays fixed to the bottom when scrolling.
             */
            var MatDialogActions = /** @class */ (function () {
                function MatDialogActions() {
                }
                return MatDialogActions;
            }());
            MatDialogActions.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]",
                            host: { 'class': 'mat-dialog-actions' }
                        },] },
            ];
            /**
             * Finds the closest MatDialogRef to an element by looking at the DOM.
             * @param {?} element Element relative to which to look for a dialog.
             * @param {?} openDialogs References to the currently-open dialogs.
             * @return {?}
             */
            function getClosestDialog(element, openDialogs) {
                /** @type {?} */
                var parent = element.nativeElement.parentElement;
                while (parent && !parent.classList.contains('mat-dialog-container')) {
                    parent = parent.parentElement;
                }
                return parent ? openDialogs.find(( /**
                 * @param {?} dialog
                 * @return {?}
                 */function (/**
                 * @param {?} dialog
                 * @return {?}
                 */ dialog) { return dialog.id === ( /** @type {?} */(parent)).id; })) : null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatDialogModule = /** @class */ (function () {
                function MatDialogModule() {
                }
                return MatDialogModule;
            }());
            MatDialogModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_9__["OverlayModule"],
                                _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatCommonModule"],
                            ],
                            exports: [
                                MatDialogContainer,
                                MatDialogClose,
                                MatDialogTitle,
                                MatDialogContent,
                                MatDialogActions,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatCommonModule"],
                            ],
                            declarations: [
                                MatDialogContainer,
                                MatDialogClose,
                                MatDialogTitle,
                                MatDialogActions,
                                MatDialogContent,
                            ],
                            providers: [
                                MatDialog,
                                MAT_DIALOG_SCROLL_STRATEGY_PROVIDER,
                            ],
                            entryComponents: [MatDialogContainer],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=dialog.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/divider.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/divider.js ***!
          \***********************************************************/
        /*! exports provided: MatDivider, MatDividerModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDivider", function () { return MatDivider; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDividerModule", function () { return MatDividerModule; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatDivider = /** @class */ (function () {
                function MatDivider() {
                    this._vertical = false;
                    this._inset = false;
                }
                Object.defineProperty(MatDivider.prototype, "vertical", {
                    /**
                     * Whether the divider is vertically aligned.
                     * @return {?}
                     */
                    get: function () { return this._vertical; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._vertical = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDivider.prototype, "inset", {
                    /**
                     * Whether the divider is an inset divider.
                     * @return {?}
                     */
                    get: function () { return this._inset; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._inset = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                return MatDivider;
            }());
            MatDivider.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-divider',
                            host: {
                                'role': 'separator',
                                '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
                                '[class.mat-divider-vertical]': 'vertical',
                                '[class.mat-divider-horizontal]': '!vertical',
                                '[class.mat-divider-inset]': 'inset',
                                'class': 'mat-divider'
                            },
                            template: '',
                            styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            MatDivider.propDecorators = {
                vertical: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                inset: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatDividerModule = /** @class */ (function () {
                function MatDividerModule() {
                }
                return MatDividerModule;
            }());
            MatDividerModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"], _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]],
                            exports: [MatDivider, _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"]],
                            declarations: [MatDivider],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=divider.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/expansion.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/expansion.js ***!
          \*************************************************************/
        /*! exports provided: MatExpansionModule, MatAccordion, MAT_ACCORDION, MAT_EXPANSION_PANEL_DEFAULT_OPTIONS, MatExpansionPanel, MatExpansionPanelActionRow, MatExpansionPanelHeader, MatExpansionPanelDescription, MatExpansionPanelTitle, MatExpansionPanelContent, EXPANSION_PANEL_ANIMATION_TIMING, matExpansionAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionModule", function () { return MatExpansionModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatAccordion", function () { return MatAccordion; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_ACCORDION", function () { return MAT_ACCORDION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_EXPANSION_PANEL_DEFAULT_OPTIONS", function () { return MAT_EXPANSION_PANEL_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanel", function () { return MatExpansionPanel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelActionRow", function () { return MatExpansionPanelActionRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelHeader", function () { return MatExpansionPanelHeader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelDescription", function () { return MatExpansionPanelDescription; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelTitle", function () { return MatExpansionPanelTitle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelContent", function () { return MatExpansionPanelContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPANSION_PANEL_ANIMATION_TIMING", function () { return EXPANSION_PANEL_ANIMATION_TIMING; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matExpansionAnimations", function () { return matExpansionAnimations; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/accordion */ "./node_modules/@angular/cdk/esm2015/accordion.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Token used to provide a `MatAccordion` to `MatExpansionPanel`.
             * Used primarily to avoid circular imports between `MatAccordion` and `MatExpansionPanel`.
             * @type {?}
             */
            var MAT_ACCORDION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_ACCORDION');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Time and timing curve for expansion panel animations.
             * @type {?}
             */
            var EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';
            /**
             * Animations used by the Material expansion panel.
             *
             * A bug in angular animation's `state` when ViewContainers are moved using ViewContainerRef.move()
             * causes the animation state of moved components to become `void` upon exit, and not update again
             * upon reentry into the DOM.  This can lead a to situation for the expansion panel where the state
             * of the panel is `expanded` or `collapsed` but the animation state is `void`.
             *
             * To correctly handle animating to the next state, we animate between `void` and `collapsed` which
             * are defined to have the same styles. Since angular animates from the current styles to the
             * destination state's style definition, in situations where we are moving from `void`'s styles to
             * `collapsed` this acts a noop since no style values change.
             *
             * In the case where angular's animation state is out of sync with the expansion panel's state, the
             * expansion panel being `expanded` and angular animations being `void`, the animation from the
             * `expanded`'s effective styles (though in a `void` animation state) to the collapsed state will
             * occur as expected.
             *
             * Angular Bug: https://github.com/angular/angular/issues/18847
             *
             * \@docs-private
             * @type {?}
             */
            var matExpansionAnimations = {
                /**
                 * Animation that rotates the indicator arrow.
                 */
                indicatorRotate: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('indicatorRotate', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('collapsed, void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ transform: 'rotate(0deg)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('expanded', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ transform: 'rotate(180deg)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('expanded <=> collapsed, void => collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(EXPANSION_PANEL_ANIMATION_TIMING)),
                ]),
                /**
                 * Animation that expands and collapses the panel header height.
                 */
                expansionHeaderHeight: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('expansionHeight', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('collapsed, void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
                        height: '{{collapsedHeight}}',
                    }), {
                        params: { collapsedHeight: '48px' },
                    }),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('expanded', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
                        height: '{{expandedHeight}}'
                    }), {
                        params: { expandedHeight: '64px' }
                    }),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('expanded <=> collapsed, void => collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["group"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["query"])('@indicatorRotate', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animateChild"])(), { optional: true }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(EXPANSION_PANEL_ANIMATION_TIMING),
                    ])),
                ]),
                /**
                 * Animation that expands and collapses the panel content.
                 */
                bodyExpansion: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('bodyExpansion', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('collapsed, void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ height: '0px', visibility: 'hidden' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('expanded', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ height: '*', visibility: 'visible' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('expanded <=> collapsed, void => collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(EXPANSION_PANEL_ANIMATION_TIMING)),
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Expansion panel content that will be rendered lazily
             * after the panel is opened for the first time.
             */
            var MatExpansionPanelContent = /** @class */ (function () {
                /**
                 * @param {?} _template
                 */
                function MatExpansionPanelContent(_template) {
                    this._template = _template;
                }
                return MatExpansionPanelContent;
            }());
            MatExpansionPanelContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'ng-template[matExpansionPanelContent]'
                        },] },
            ];
            /** @nocollapse */
            MatExpansionPanelContent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Counter for generating unique element ids.
             * @type {?}
             */
            var uniqueId = 0;
            /**
             * Injection token that can be used to configure the defalt
             * options for the expansion panel component.
             * @type {?}
             */
            var MAT_EXPANSION_PANEL_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_EXPANSION_PANEL_DEFAULT_OPTIONS');
            var ɵ0 = undefined;
            /**
             * `<mat-expansion-panel>`
             *
             * This component can be used as a single element to show expandable content, or as one of
             * multiple children of an element with the MatAccordion directive attached.
             */
            var MatExpansionPanel = /** @class */ (function (_super_1) {
                __extends(MatExpansionPanel, _super_1);
                /**
                 * @param {?} accordion
                 * @param {?} _changeDetectorRef
                 * @param {?} _uniqueSelectionDispatcher
                 * @param {?} _viewContainerRef
                 * @param {?} _document
                 * @param {?} _animationMode
                 * @param {?=} defaultOptions
                 */
                function MatExpansionPanel(accordion, _changeDetectorRef, _uniqueSelectionDispatcher, _viewContainerRef, _document, _animationMode, defaultOptions) {
                    var _this = _super_1.call(this, accordion, _changeDetectorRef, _uniqueSelectionDispatcher) || this;
                    _this._viewContainerRef = _viewContainerRef;
                    _this._animationMode = _animationMode;
                    _this._hideToggle = false;
                    /**
                     * An event emitted after the body's expansion animation happens.
                     */
                    _this.afterExpand = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * An event emitted after the body's collapse animation happens.
                     */
                    _this.afterCollapse = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Stream that emits for changes in `\@Input` properties.
                     */
                    _this._inputChanges = new rxjs__WEBPACK_IMPORTED_MODULE_8__["Subject"]();
                    /**
                     * ID for the associated header element. Used for a11y labelling.
                     */
                    _this._headerId = "mat-expansion-panel-header-" + uniqueId++;
                    /**
                     * Stream of body animation done events.
                     */
                    _this._bodyAnimationDone = new rxjs__WEBPACK_IMPORTED_MODULE_8__["Subject"]();
                    _this.accordion = accordion;
                    _this._document = _document;
                    // We need a Subject with distinctUntilChanged, because the `done` event
                    // fires twice on some browsers. See https://github.com/angular/angular/issues/24084
                    _this._bodyAnimationDone.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["distinctUntilChanged"])(( /**
                     * @param {?} x
                     * @param {?} y
                     * @return {?}
                     */function (x, y) {
                        return x.fromState === y.fromState && x.toState === y.toState;
                    }))).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        if (event.fromState !== 'void') {
                            if (event.toState === 'expanded') {
                                _this.afterExpand.emit();
                            }
                            else if (event.toState === 'collapsed') {
                                _this.afterCollapse.emit();
                            }
                        }
                    }));
                    if (defaultOptions) {
                        _this.hideToggle = defaultOptions.hideToggle;
                    }
                    return _this;
                }
                Object.defineProperty(MatExpansionPanel.prototype, "hideToggle", {
                    /**
                     * Whether the toggle indicator should be hidden.
                     * @return {?}
                     */
                    get: function () {
                        return this._hideToggle || (this.accordion && this.accordion.hideToggle);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._hideToggle = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatExpansionPanel.prototype, "togglePosition", {
                    /**
                     * The position of the expansion indicator.
                     * @return {?}
                     */
                    get: function () {
                        return this._togglePosition || (this.accordion && this.accordion.togglePosition);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._togglePosition = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Determines whether the expansion panel should have spacing between it and its siblings.
                 * @return {?}
                 */
                MatExpansionPanel.prototype._hasSpacing = function () {
                    if (this.accordion) {
                        // We don't need to subscribe to the `stateChanges` of the parent accordion because each time
                        // the [displayMode] input changes, the change detection will also cover the host bindings
                        // of this expansion panel.
                        return (this.expanded ? this.accordion.displayMode : this._getExpandedState()) === 'default';
                    }
                    return false;
                };
                /**
                 * Gets the expanded state string.
                 * @return {?}
                 */
                MatExpansionPanel.prototype._getExpandedState = function () {
                    return this.expanded ? 'expanded' : 'collapsed';
                };
                /**
                 * @return {?}
                 */
                MatExpansionPanel.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    if (this._lazyContent) {
                        // Render the content as soon as the panel becomes open.
                        this.opened.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["startWith"])(( /** @type {?} */(null))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                         * @return {?}
                         */function () { return _this.expanded && !_this._portal; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["take"])(1)).subscribe(( /**
                         * @return {?}
                         */function () {
                            _this._portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_5__["TemplatePortal"](_this._lazyContent._template, _this._viewContainerRef);
                        }));
                    }
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatExpansionPanel.prototype.ngOnChanges = function (changes) {
                    this._inputChanges.next(changes);
                };
                /**
                 * @return {?}
                 */
                MatExpansionPanel.prototype.ngOnDestroy = function () {
                    _super_1.prototype.ngOnDestroy.call(this);
                    this._bodyAnimationDone.complete();
                    this._inputChanges.complete();
                };
                /**
                 * Checks whether the expansion panel's content contains the currently-focused element.
                 * @return {?}
                 */
                MatExpansionPanel.prototype._containsFocus = function () {
                    if (this._body) {
                        /** @type {?} */
                        var focusedElement = this._document.activeElement;
                        /** @type {?} */
                        var bodyElement = this._body.nativeElement;
                        return focusedElement === bodyElement || bodyElement.contains(focusedElement);
                    }
                    return false;
                };
                return MatExpansionPanel;
            }(_angular_cdk_accordion__WEBPACK_IMPORTED_MODULE_2__["CdkAccordionItem"]));
            MatExpansionPanel.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ styles: [".mat-expansion-panel{box-sizing:content-box;display:block;margin:0;border-radius:4px;overflow:hidden;transition:margin 225ms cubic-bezier(.4,0,.2,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-accordion .mat-expansion-panel:not(.mat-expanded),.mat-accordion .mat-expansion-panel:not(.mat-expansion-panel-spacing){border-radius:0}.mat-accordion .mat-expansion-panel:first-of-type{border-top-right-radius:4px;border-top-left-radius:4px}.mat-accordion .mat-expansion-panel:last-of-type{border-bottom-right-radius:4px;border-bottom-left-radius:4px}@media (-ms-high-contrast:active){.mat-expansion-panel{outline:solid 1px}}.mat-expansion-panel._mat-animation-noopable,.mat-expansion-panel.ng-animate-disabled,.ng-animate-disabled .mat-expansion-panel{transition:none}.mat-expansion-panel-content{display:flex;flex-direction:column;overflow:visible}.mat-expansion-panel-body{padding:0 24px 16px}.mat-expansion-panel-spacing{margin:16px 0}.mat-accordion>.mat-expansion-panel-spacing:first-child,.mat-accordion>:first-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-top:0}.mat-accordion>.mat-expansion-panel-spacing:last-child,.mat-accordion>:last-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-bottom:0}.mat-action-row{border-top-style:solid;border-top-width:1px;display:flex;flex-direction:row;justify-content:flex-end;padding:16px 8px 16px 24px}.mat-action-row button.mat-button-base{margin-left:8px}[dir=rtl] .mat-action-row button.mat-button-base{margin-left:0;margin-right:8px}"],
                            selector: 'mat-expansion-panel',
                            exportAs: 'matExpansionPanel',
                            template: "<ng-content select=\"mat-expansion-panel-header\"></ng-content><div class=\"mat-expansion-panel-content\" role=\"region\" [@bodyExpansion]=\"_getExpandedState()\" (@bodyExpansion.done)=\"_bodyAnimationDone.next($event)\" [attr.aria-labelledby]=\"_headerId\" [id]=\"id\" #body><div class=\"mat-expansion-panel-body\"><ng-content></ng-content><ng-template [cdkPortalOutlet]=\"_portal\"></ng-template></div><ng-content select=\"mat-action-row\"></ng-content></div>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            inputs: ['disabled', 'expanded'],
                            outputs: ['opened', 'closed', 'expandedChange'],
                            animations: [matExpansionAnimations.bodyExpansion],
                            providers: [
                                // Provide MatAccordion as undefined to prevent nested expansion panels from registering
                                // to the same accordion.
                                { provide: MAT_ACCORDION, useValue: ɵ0 },
                            ],
                            host: {
                                'class': 'mat-expansion-panel',
                                '[class.mat-expanded]': 'expanded',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                                '[class.mat-expansion-panel-spacing]': '_hasSpacing()',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatExpansionPanel.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_ACCORDION,] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_4__["UniqueSelectionDispatcher"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_6__["DOCUMENT"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__["ANIMATION_MODULE_TYPE"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatExpansionPanel.propDecorators = {
                hideToggle: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                togglePosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                afterExpand: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                afterCollapse: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _lazyContent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatExpansionPanelContent, { static: false },] }],
                _body: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['body', { static: false },] }]
            };
            var MatExpansionPanelActionRow = /** @class */ (function () {
                function MatExpansionPanelActionRow() {
                }
                return MatExpansionPanelActionRow;
            }());
            MatExpansionPanelActionRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-action-row',
                            host: {
                                class: 'mat-action-row'
                            }
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * `<mat-expansion-panel-header>`
             *
             * This component corresponds to the header element of an `<mat-expansion-panel>`.
             */
            var MatExpansionPanelHeader = /** @class */ (function () {
                /**
                 * @param {?} panel
                 * @param {?} _element
                 * @param {?} _focusMonitor
                 * @param {?} _changeDetectorRef
                 * @param {?=} defaultOptions
                 */
                function MatExpansionPanelHeader(panel, _element, _focusMonitor, _changeDetectorRef, defaultOptions) {
                    var _this = this;
                    this.panel = panel;
                    this._element = _element;
                    this._focusMonitor = _focusMonitor;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._parentChangeSubscription = rxjs__WEBPACK_IMPORTED_MODULE_8__["Subscription"].EMPTY;
                    /**
                     * Whether Angular animations in the panel header should be disabled.
                     */
                    this._animationsDisabled = true;
                    /** @type {?} */
                    var accordionHideToggleChange = panel.accordion ?
                        panel.accordion._stateChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                         * @param {?} changes
                         * @return {?}
                         */function (/**
                         * @param {?} changes
                         * @return {?}
                         */ changes) { return !!(changes['hideToggle'] || changes['togglePosition']); }))) :
                        rxjs__WEBPACK_IMPORTED_MODULE_8__["EMPTY"];
                    // Since the toggle state depends on an @Input on the panel, we
                    // need to subscribe and trigger change detection manually.
                    this._parentChangeSubscription =
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["merge"])(panel.opened, panel.closed, accordionHideToggleChange, panel._inputChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                         * @param {?} changes
                         * @return {?}
                         */function (/**
                         * @param {?} changes
                         * @return {?}
                         */ changes) {
                            return !!(changes['hideToggle'] ||
                                changes['disabled'] ||
                                changes['togglePosition']);
                        }))))
                            .subscribe(( /**
                     * @return {?}
                     */function () { return _this._changeDetectorRef.markForCheck(); }));
                    // Avoids focus being lost if the panel contained the focused element and was closed.
                    panel.closed
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                 * @return {?}
                 */function () { return panel._containsFocus(); })))
                        .subscribe(( /**
                 * @return {?}
                 */function () { return _focusMonitor.focusVia(_element, 'program'); }));
                    _focusMonitor.monitor(_element).subscribe(( /**
                     * @param {?} origin
                     * @return {?}
                     */function (/**
                     * @param {?} origin
                     * @return {?}
                     */ origin) {
                        if (origin && panel.accordion) {
                            panel.accordion._handleHeaderFocus(_this);
                        }
                    }));
                    if (defaultOptions) {
                        this.expandedHeight = defaultOptions.expandedHeight;
                        this.collapsedHeight = defaultOptions.collapsedHeight;
                    }
                }
                /**
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._animationStarted = function () {
                    // Currently the `expansionHeight` animation has a `void => collapsed` transition which is
                    // there to work around a bug in Angular (see #13088), however this introduces a different
                    // issue. The new transition will cause the header to animate in on init (see #16067), if the
                    // consumer has set a header height that is different from the default one. We work around it
                    // by disabling animations on the header and re-enabling them after the first animation has run.
                    // Note that Angular dispatches animation events even if animations are disabled. Ideally this
                    // wouldn't be necessary if we remove the `void => collapsed` transition, but we have to wait
                    // for https://github.com/angular/angular/issues/18847 to be resolved.
                    this._animationsDisabled = false;
                };
                Object.defineProperty(MatExpansionPanelHeader.prototype, "disabled", {
                    /**
                     * Whether the associated panel is disabled. Implemented as a part of `FocusableOption`.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this.panel.disabled;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Toggles the expanded state of the panel.
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._toggle = function () {
                    this.panel.toggle();
                };
                /**
                 * Gets whether the panel is expanded.
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._isExpanded = function () {
                    return this.panel.expanded;
                };
                /**
                 * Gets the expanded state string of the panel.
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._getExpandedState = function () {
                    return this.panel._getExpandedState();
                };
                /**
                 * Gets the panel id.
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._getPanelId = function () {
                    return this.panel.id;
                };
                /**
                 * Gets the toggle position for the header.
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._getTogglePosition = function () {
                    return this.panel.togglePosition;
                };
                /**
                 * Gets whether the expand indicator should be shown.
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._showToggle = function () {
                    return !this.panel.hideToggle && !this.panel.disabled;
                };
                /**
                 * Handle keydown event calling to toggle() if appropriate.
                 * @param {?} event
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype._keydown = function (event) {
                    switch (event.keyCode) {
                        // Toggle for space and enter keys.
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["SPACE"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["ENTER"]:
                            if (!Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["hasModifierKey"])(event)) {
                                event.preventDefault();
                                this._toggle();
                            }
                            break;
                        default:
                            if (this.panel.accordion) {
                                this.panel.accordion._handleHeaderKeydown(event);
                            }
                            return;
                    }
                };
                /**
                 * Focuses the panel header. Implemented as a part of `FocusableOption`.
                 * \@docs-private
                 * @param {?=} origin Origin of the action that triggered the focus.
                 * @param {?=} options
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype.focus = function (origin, options) {
                    if (origin === void 0) { origin = 'program'; }
                    this._focusMonitor.focusVia(this._element, origin, options);
                };
                /**
                 * @return {?}
                 */
                MatExpansionPanelHeader.prototype.ngOnDestroy = function () {
                    this._parentChangeSubscription.unsubscribe();
                    this._focusMonitor.stopMonitoring(this._element);
                };
                return MatExpansionPanelHeader;
            }());
            MatExpansionPanelHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-expansion-panel-header',
                            styles: [".mat-expansion-panel-header{display:flex;flex-direction:row;align-items:center;padding:0 24px;border-radius:inherit}.mat-expansion-panel-header:focus,.mat-expansion-panel-header:hover{outline:0}.mat-expansion-panel-header.mat-expanded:focus,.mat-expansion-panel-header.mat-expanded:hover{background:inherit}.mat-expansion-panel-header:not([aria-disabled=true]){cursor:pointer}.mat-expansion-panel-header.mat-expansion-toggle-indicator-before{flex-direction:row-reverse}.mat-expansion-panel-header.mat-expansion-toggle-indicator-before .mat-expansion-indicator{margin:0 16px 0 0}[dir=rtl] .mat-expansion-panel-header.mat-expansion-toggle-indicator-before .mat-expansion-indicator{margin:0 0 0 16px}.mat-content{display:flex;flex:1;flex-direction:row;overflow:hidden}.mat-expansion-panel-header-description,.mat-expansion-panel-header-title{display:flex;flex-grow:1;margin-right:16px}[dir=rtl] .mat-expansion-panel-header-description,[dir=rtl] .mat-expansion-panel-header-title{margin-right:0;margin-left:16px}.mat-expansion-panel-header-description{flex-grow:2}.mat-expansion-indicator::after{border-style:solid;border-width:0 2px 2px 0;content:'';display:inline-block;padding:3px;transform:rotate(45deg);vertical-align:middle}"],
                            template: "<span class=\"mat-content\"><ng-content select=\"mat-panel-title\"></ng-content><ng-content select=\"mat-panel-description\"></ng-content><ng-content></ng-content></span><span [@indicatorRotate]=\"_getExpandedState()\" *ngIf=\"_showToggle()\" class=\"mat-expansion-indicator\"></span>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            animations: [
                                matExpansionAnimations.indicatorRotate,
                                matExpansionAnimations.expansionHeaderHeight
                            ],
                            host: {
                                'class': 'mat-expansion-panel-header',
                                'role': 'button',
                                '[attr.id]': 'panel._headerId',
                                '[attr.tabindex]': 'disabled ? -1 : 0',
                                '[attr.aria-controls]': '_getPanelId()',
                                '[attr.aria-expanded]': '_isExpanded()',
                                '[attr.aria-disabled]': 'panel.disabled',
                                '[class.mat-expanded]': '_isExpanded()',
                                '[class.mat-expansion-toggle-indicator-after]': "_getTogglePosition() === 'after'",
                                '[class.mat-expansion-toggle-indicator-before]': "_getTogglePosition() === 'before'",
                                '(click)': '_toggle()',
                                '(keydown)': '_keydown($event)',
                                '[@.disabled]': '_animationsDisabled',
                                '(@expansionHeight.start)': '_animationStarted()',
                                '[@expansionHeight]': "{\n        value: _getExpandedState(),\n        params: {\n          collapsedHeight: collapsedHeight,\n          expandedHeight: expandedHeight\n        }\n    }",
                            },
                        },] },
            ];
            /** @nocollapse */
            MatExpansionPanelHeader.ctorParameters = function () { return [
                { type: MatExpansionPanel, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Host"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__["FocusMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatExpansionPanelHeader.propDecorators = {
                expandedHeight: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                collapsedHeight: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * `<mat-panel-description>`
             *
             * This directive is to be used inside of the MatExpansionPanelHeader component.
             */
            var MatExpansionPanelDescription = /** @class */ (function () {
                function MatExpansionPanelDescription() {
                }
                return MatExpansionPanelDescription;
            }());
            MatExpansionPanelDescription.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-panel-description',
                            host: {
                                class: 'mat-expansion-panel-header-description'
                            }
                        },] },
            ];
            /**
             * `<mat-panel-title>`
             *
             * This directive is to be used inside of the MatExpansionPanelHeader component.
             */
            var MatExpansionPanelTitle = /** @class */ (function () {
                function MatExpansionPanelTitle() {
                }
                return MatExpansionPanelTitle;
            }());
            MatExpansionPanelTitle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-panel-title',
                            host: {
                                class: 'mat-expansion-panel-header-title'
                            }
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Directive for a Material Design Accordion.
             */
            var MatAccordion = /** @class */ (function (_super_1) {
                __extends(MatAccordion, _super_1);
                function MatAccordion() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this._hideToggle = false;
                    /**
                     * Display mode used for all expansion panels in the accordion. Currently two display
                     * modes exist:
                     *  default - a gutter-like spacing is placed around any expanded panel, placing the expanded
                     *     panel at a different elevation from the rest of the accordion.
                     *  flat - no spacing is placed around expanded panels, showing all panels at the same
                     *     elevation.
                     */
                    _this.displayMode = 'default';
                    /**
                     * The position of the expansion indicator.
                     */
                    _this.togglePosition = 'after';
                    return _this;
                }
                Object.defineProperty(MatAccordion.prototype, "hideToggle", {
                    /**
                     * Whether the expansion indicator should be hidden.
                     * @return {?}
                     */
                    get: function () { return this._hideToggle; },
                    /**
                     * @param {?} show
                     * @return {?}
                     */
                    set: function (show) { this._hideToggle = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(show); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatAccordion.prototype.ngAfterContentInit = function () {
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__["FocusKeyManager"](this._headers).withWrap();
                };
                /**
                 * Handles keyboard events coming in from the panel headers.
                 * @param {?} event
                 * @return {?}
                 */
                MatAccordion.prototype._handleHeaderKeydown = function (event) {
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var manager = this._keyManager;
                    if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["HOME"]) {
                        if (!Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["hasModifierKey"])(event)) {
                            manager.setFirstItemActive();
                            event.preventDefault();
                        }
                    }
                    else if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["END"]) {
                        if (!Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["hasModifierKey"])(event)) {
                            manager.setLastItemActive();
                            event.preventDefault();
                        }
                    }
                    else {
                        this._keyManager.onKeydown(event);
                    }
                };
                /**
                 * @param {?} header
                 * @return {?}
                 */
                MatAccordion.prototype._handleHeaderFocus = function (header) {
                    this._keyManager.updateActiveItem(header);
                };
                return MatAccordion;
            }(_angular_cdk_accordion__WEBPACK_IMPORTED_MODULE_2__["CdkAccordion"]));
            MatAccordion.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-accordion',
                            exportAs: 'matAccordion',
                            inputs: ['multi'],
                            providers: [{
                                    provide: MAT_ACCORDION,
                                    useExisting: MatAccordion
                                }],
                            host: {
                                class: 'mat-accordion'
                            }
                        },] },
            ];
            MatAccordion.propDecorators = {
                _headers: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatExpansionPanelHeader, { descendants: true },] }],
                hideToggle: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                displayMode: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                togglePosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatExpansionModule = /** @class */ (function () {
                function MatExpansionModule() {
                }
                return MatExpansionModule;
            }());
            MatExpansionModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_6__["CommonModule"], _angular_cdk_accordion__WEBPACK_IMPORTED_MODULE_2__["CdkAccordionModule"], _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_5__["PortalModule"]],
                            exports: [
                                MatAccordion,
                                MatExpansionPanel,
                                MatExpansionPanelActionRow,
                                MatExpansionPanelHeader,
                                MatExpansionPanelTitle,
                                MatExpansionPanelDescription,
                                MatExpansionPanelContent,
                            ],
                            declarations: [
                                MatAccordion,
                                MatExpansionPanel,
                                MatExpansionPanelActionRow,
                                MatExpansionPanelHeader,
                                MatExpansionPanelTitle,
                                MatExpansionPanelDescription,
                                MatExpansionPanelContent,
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=expansion.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/form-field.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/form-field.js ***!
          \**************************************************************/
        /*! exports provided: MatFormFieldModule, MatError, MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormField, MatFormFieldControl, getMatFormFieldPlaceholderConflictError, getMatFormFieldDuplicatedHintError, getMatFormFieldMissingControlError, MatHint, MatPlaceholder, MatPrefix, MatSuffix, MatLabel, matFormFieldAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFormFieldModule", function () { return MatFormFieldModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatError", function () { return MatError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_FORM_FIELD_DEFAULT_OPTIONS", function () { return MAT_FORM_FIELD_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFormField", function () { return MatFormField; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFormFieldControl", function () { return MatFormFieldControl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatFormFieldPlaceholderConflictError", function () { return getMatFormFieldPlaceholderConflictError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatFormFieldDuplicatedHintError", function () { return getMatFormFieldDuplicatedHintError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatFormFieldMissingControlError", function () { return getMatFormFieldMissingControlError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatHint", function () { return MatHint; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPlaceholder", function () { return MatPlaceholder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPrefix", function () { return MatPrefix; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSuffix", function () { return MatSuffix; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatLabel", function () { return MatLabel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matFormFieldAnimations", function () { return matFormFieldAnimations; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/observers */ "./node_modules/@angular/cdk/esm2015/observers.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var nextUniqueId = 0;
            /**
             * Single error message to be shown underneath the form field.
             */
            var MatError = /** @class */ (function () {
                function MatError() {
                    this.id = "mat-error-" + nextUniqueId++;
                }
                return MatError;
            }());
            MatError.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-error',
                            host: {
                                'class': 'mat-error',
                                'role': 'alert',
                                '[attr.id]': 'id',
                            }
                        },] },
            ];
            MatError.propDecorators = {
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the MatFormField.
             * \@docs-private
             * @type {?}
             */
            var matFormFieldAnimations = {
                /**
                 * Animation that transitions the form field's error and hint messages.
                 */
                transitionMessages: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('transitionMessages', [
                    // TODO(mmalerba): Use angular animations for label animation as well.
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('enter', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ opacity: 1, transform: 'translateY(0%)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('void => enter', [
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({ opacity: 0, transform: 'translateY(-100%)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
                    ]),
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An interface which allows a control to work inside of a `MatFormField`.
             * @abstract
             * @template T
             */
            var MatFormFieldControl = /** @class */ (function () {
                function MatFormFieldControl() {
                }
                return MatFormFieldControl;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             * @return {?}
             */
            function getMatFormFieldPlaceholderConflictError() {
                return Error('Placeholder attribute and child element were both specified.');
            }
            /**
             * \@docs-private
             * @param {?} align
             * @return {?}
             */
            function getMatFormFieldDuplicatedHintError(align) {
                return Error("A hint was already declared for 'align=\"" + align + "\"'.");
            }
            /**
             * \@docs-private
             * @return {?}
             */
            function getMatFormFieldMissingControlError() {
                return Error('mat-form-field must contain a MatFormFieldControl.');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var nextUniqueId$1 = 0;
            /**
             * Hint text to be shown underneath the form field control.
             */
            var MatHint = /** @class */ (function () {
                function MatHint() {
                    /**
                     * Whether to align the hint label at the start or end of the line.
                     */
                    this.align = 'start';
                    /**
                     * Unique ID for the hint. Used for the aria-describedby on the form field control.
                     */
                    this.id = "mat-hint-" + nextUniqueId$1++;
                }
                return MatHint;
            }());
            MatHint.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-hint',
                            host: {
                                'class': 'mat-hint',
                                '[class.mat-right]': 'align == "end"',
                                '[attr.id]': 'id',
                                // Remove align attribute to prevent it from interfering with layout.
                                '[attr.align]': 'null',
                            }
                        },] },
            ];
            MatHint.propDecorators = {
                align: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The floating label for a `mat-form-field`.
             */
            var MatLabel = /** @class */ (function () {
                function MatLabel() {
                }
                return MatLabel;
            }());
            MatLabel.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-label'
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The placeholder text for an `MatFormField`.
             * @deprecated Use `<mat-label>` to specify the label and the `placeholder` attribute to specify the
             *     placeholder.
             * \@breaking-change 8.0.0
             */
            var MatPlaceholder = /** @class */ (function () {
                function MatPlaceholder() {
                }
                return MatPlaceholder;
            }());
            MatPlaceholder.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-placeholder'
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Prefix to be placed in front of the form field.
             */
            var MatPrefix = /** @class */ (function () {
                function MatPrefix() {
                }
                return MatPrefix;
            }());
            MatPrefix.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[matPrefix]',
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Suffix to be placed at the end of the form field.
             */
            var MatSuffix = /** @class */ (function () {
                function MatSuffix() {
                }
                return MatSuffix;
            }());
            MatSuffix.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[matSuffix]',
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var nextUniqueId$2 = 0;
            /** @type {?} */
            var floatingLabelScale = 0.75;
            /** @type {?} */
            var outlineGapPadding = 5;
            /**
             * Boilerplate for applying mixins to MatFormField.
             * \@docs-private
             */
            var MatFormFieldBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatFormFieldBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatFormFieldBase;
            }());
            /**
             * Base class to which we're applying the form field mixins.
             * \@docs-private
             * @type {?}
             */
            var _MatFormFieldMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinColor"])(MatFormFieldBase, 'primary');
            /**
             * Injection token that can be used to configure the
             * default options for all form field within an app.
             * @type {?}
             */
            var MAT_FORM_FIELD_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_FORM_FIELD_DEFAULT_OPTIONS');
            /**
             * Container for form controls that applies Material Design styling and behavior.
             */
            var MatFormField = /** @class */ (function (_super_1) {
                __extends(MatFormField, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} labelOptions
                 * @param {?} _dir
                 * @param {?} _defaults
                 * @param {?} _platform
                 * @param {?} _ngZone
                 * @param {?} _animationMode
                 */
                function MatFormField(_elementRef, _changeDetectorRef, labelOptions, _dir, _defaults, _platform, _ngZone, _animationMode) {
                    var _this = _super_1.call(this, _elementRef) || this;
                    _this._elementRef = _elementRef;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._dir = _dir;
                    _this._defaults = _defaults;
                    _this._platform = _platform;
                    _this._ngZone = _ngZone;
                    /**
                     * Whether the outline gap needs to be calculated
                     * immediately on the next change detection run.
                     */
                    _this._outlineGapCalculationNeededImmediately = false;
                    /**
                     * Whether the outline gap needs to be calculated next time the zone has stabilized.
                     */
                    _this._outlineGapCalculationNeededOnStable = false;
                    _this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                    /**
                     * Override for the logic that disables the label animation in certain cases.
                     */
                    _this._showAlwaysAnimate = false;
                    /**
                     * State of the mat-hint and mat-error animations.
                     */
                    _this._subscriptAnimationState = '';
                    _this._hintLabel = '';
                    // Unique id for the hint label.
                    _this._hintLabelId = "mat-hint-" + nextUniqueId$2++;
                    // Unique id for the internal form field label.
                    _this._labelId = "mat-form-field-label-" + nextUniqueId$2++;
                    /* Holds the previous direction emitted by directionality service change emitter.
                         This is used in updateOutlineGap() method to update the width and position of the gap in the
                         outline. Only relevant for the outline appearance. The direction is getting updated in the
                         UI after directionality service change emission. So the outlines gaps are getting
                         updated in updateOutlineGap() method before connectionContainer child direction change
                         in UI. We may get wrong calculations. So we are storing the previous direction to get the
                         correct outline calculations*/
                    _this._previousDirection = 'ltr';
                    _this._labelOptions = labelOptions ? labelOptions : {};
                    _this.floatLabel = _this._labelOptions.float || 'auto';
                    _this._animationsEnabled = _animationMode !== 'NoopAnimations';
                    // Set the default through here so we invoke the setter on the first run.
                    _this.appearance = (_defaults && _defaults.appearance) ? _defaults.appearance : 'legacy';
                    _this._hideRequiredMarker = (_defaults && _defaults.hideRequiredMarker != null) ?
                        _defaults.hideRequiredMarker : false;
                    return _this;
                }
                Object.defineProperty(MatFormField.prototype, "appearance", {
                    /**
                     * The form-field appearance style.
                     * @return {?}
                     */
                    get: function () { return this._appearance; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var oldValue = this._appearance;
                        this._appearance = value || (this._defaults && this._defaults.appearance) || 'legacy';
                        if (this._appearance === 'outline' && oldValue !== value) {
                            this._outlineGapCalculationNeededOnStable = true;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "hideRequiredMarker", {
                    /**
                     * Whether the required marker should be hidden.
                     * @return {?}
                     */
                    get: function () { return this._hideRequiredMarker; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._hideRequiredMarker = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "_shouldAlwaysFloat", {
                    /**
                     * Whether the floating label should always float or not.
                     * @return {?}
                     */
                    get: function () {
                        return this.floatLabel === 'always' && !this._showAlwaysAnimate;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "_canLabelFloat", {
                    /**
                     * Whether the label can float or not.
                     * @return {?}
                     */
                    get: function () { return this.floatLabel !== 'never'; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "hintLabel", {
                    /**
                     * Text for the form field hint.
                     * @return {?}
                     */
                    get: function () { return this._hintLabel; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._hintLabel = value;
                        this._processHints();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "floatLabel", {
                    /**
                     * Whether the label should always float, never float or float as the user types.
                     *
                     * Note: only the legacy appearance supports the `never` option. `never` was originally added as a
                     * way to make the floating label emulate the behavior of a standard input placeholder. However
                     * the form field now supports both floating labels and placeholders. Therefore in the non-legacy
                     * appearances the `never` option has been disabled in favor of just using the placeholder.
                     * @return {?}
                     */
                    get: function () {
                        return this.appearance !== 'legacy' && this._floatLabel === 'never' ? 'auto' : this._floatLabel;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== this._floatLabel) {
                            this._floatLabel = value || this._labelOptions.float || 'auto';
                            this._changeDetectorRef.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "_control", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        // TODO(crisbeto): we need this hacky workaround in order to support both Ivy
                        // and ViewEngine. We should clean this up once Ivy is the default renderer.
                        return this._explicitFormFieldControl || this._controlNonStatic || this._controlStatic;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._explicitFormFieldControl = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatFormField.prototype, "_labelChild", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._labelChildNonStatic || this._labelChildStatic;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Gets an ElementRef for the element that a overlay attached to the form-field should be
                 * positioned relative to.
                 * @return {?}
                 */
                MatFormField.prototype.getConnectedOverlayOrigin = function () {
                    return this._connectionContainerRef || this._elementRef;
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._validateControlChild();
                    /** @type {?} */
                    var control = this._control;
                    if (control.controlType) {
                        this._elementRef.nativeElement.classList.add("mat-form-field-type-" + control.controlType);
                    }
                    // Subscribe to changes in the child control state in order to update the form field UI.
                    control.stateChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["startWith"])(( /** @type {?} */(null)))).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._validatePlaceholders();
                        _this._syncDescribedByIds();
                        _this._changeDetectorRef.markForCheck();
                    }));
                    // Run change detection if the value changes.
                    if (control.ngControl && control.ngControl.valueChanges) {
                        control.ngControl.valueChanges
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["takeUntil"])(this._destroyed))
                            .subscribe(( /**
                     * @return {?}
                     */function () { return _this._changeDetectorRef.markForCheck(); }));
                    }
                    // Note that we have to run outside of the `NgZone` explicitly,
                    // in order to avoid throwing users into an infinite loop
                    // if `zone-patch-rxjs` is included.
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        _this._ngZone.onStable.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["takeUntil"])(_this._destroyed)).subscribe(( /**
                         * @return {?}
                         */function () {
                            if (_this._outlineGapCalculationNeededOnStable) {
                                _this.updateOutlineGap();
                            }
                        }));
                    }));
                    // Run change detection and update the outline if the suffix or prefix changes.
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"])(this._prefixChildren.changes, this._suffixChildren.changes).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._outlineGapCalculationNeededOnStable = true;
                        _this._changeDetectorRef.markForCheck();
                    }));
                    // Re-validate when the number of hints changes.
                    this._hintChildren.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["startWith"])(null)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._processHints();
                        _this._changeDetectorRef.markForCheck();
                    }));
                    // Update the aria-described by when the number of errors changes.
                    this._errorChildren.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["startWith"])(null)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._syncDescribedByIds();
                        _this._changeDetectorRef.markForCheck();
                    }));
                    if (this._dir) {
                        this._dir.change.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["takeUntil"])(this._destroyed)).subscribe(( /**
                         * @return {?}
                         */function () {
                            _this.updateOutlineGap();
                            _this._previousDirection = _this._dir.value;
                        }));
                    }
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype.ngAfterContentChecked = function () {
                    this._validateControlChild();
                    if (this._outlineGapCalculationNeededImmediately) {
                        this.updateOutlineGap();
                    }
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype.ngAfterViewInit = function () {
                    // Avoid animations on load.
                    this._subscriptAnimationState = 'enter';
                    this._changeDetectorRef.detectChanges();
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Determines whether a class from the NgControl should be forwarded to the host element.
                 * @param {?} prop
                 * @return {?}
                 */
                MatFormField.prototype._shouldForward = function (prop) {
                    /** @type {?} */
                    var ngControl = this._control ? this._control.ngControl : null;
                    return ngControl && ngControl[prop];
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype._hasPlaceholder = function () {
                    return !!(this._control && this._control.placeholder || this._placeholderChild);
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype._hasLabel = function () {
                    return !!this._labelChild;
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype._shouldLabelFloat = function () {
                    return this._canLabelFloat && (this._control.shouldLabelFloat || this._shouldAlwaysFloat);
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype._hideControlPlaceholder = function () {
                    // In the legacy appearance the placeholder is promoted to a label if no label is given.
                    return this.appearance === 'legacy' && !this._hasLabel() ||
                        this._hasLabel() && !this._shouldLabelFloat();
                };
                /**
                 * @return {?}
                 */
                MatFormField.prototype._hasFloatingLabel = function () {
                    // In the legacy appearance the placeholder is promoted to a label if no label is given.
                    return this._hasLabel() || this.appearance === 'legacy' && this._hasPlaceholder();
                };
                /**
                 * Determines whether to display hints or errors.
                 * @return {?}
                 */
                MatFormField.prototype._getDisplayedMessages = function () {
                    return (this._errorChildren && this._errorChildren.length > 0 &&
                        this._control.errorState) ? 'error' : 'hint';
                };
                /**
                 * Animates the placeholder up and locks it in position.
                 * @return {?}
                 */
                MatFormField.prototype._animateAndLockLabel = function () {
                    var _this = this;
                    if (this._hasFloatingLabel() && this._canLabelFloat) {
                        // If animations are disabled, we shouldn't go in here,
                        // because the `transitionend` will never fire.
                        if (this._animationsEnabled) {
                            this._showAlwaysAnimate = true;
                            Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["fromEvent"])(this._label.nativeElement, 'transitionend').pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["take"])(1)).subscribe(( /**
                             * @return {?}
                             */function () {
                                _this._showAlwaysAnimate = false;
                            }));
                        }
                        this.floatLabel = 'always';
                        this._changeDetectorRef.markForCheck();
                    }
                };
                /**
                 * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
                 * or child element with the `mat-placeholder` directive).
                 * @private
                 * @return {?}
                 */
                MatFormField.prototype._validatePlaceholders = function () {
                    if (this._control.placeholder && this._placeholderChild) {
                        throw getMatFormFieldPlaceholderConflictError();
                    }
                };
                /**
                 * Does any extra processing that is required when handling the hints.
                 * @private
                 * @return {?}
                 */
                MatFormField.prototype._processHints = function () {
                    this._validateHints();
                    this._syncDescribedByIds();
                };
                /**
                 * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
                 * attribute being considered as `align="start"`.
                 * @private
                 * @return {?}
                 */
                MatFormField.prototype._validateHints = function () {
                    var _this = this;
                    if (this._hintChildren) {
                        /** @type {?} */
                        var startHint_1;
                        /** @type {?} */
                        var endHint_1;
                        this._hintChildren.forEach(( /**
                         * @param {?} hint
                         * @return {?}
                         */function (hint) {
                            if (hint.align === 'start') {
                                if (startHint_1 || _this.hintLabel) {
                                    throw getMatFormFieldDuplicatedHintError('start');
                                }
                                startHint_1 = hint;
                            }
                            else if (hint.align === 'end') {
                                if (endHint_1) {
                                    throw getMatFormFieldDuplicatedHintError('end');
                                }
                                endHint_1 = hint;
                            }
                        }));
                    }
                };
                /**
                 * Sets the list of element IDs that describe the child control. This allows the control to update
                 * its `aria-describedby` attribute accordingly.
                 * @private
                 * @return {?}
                 */
                MatFormField.prototype._syncDescribedByIds = function () {
                    if (this._control) {
                        /** @type {?} */
                        var ids = [];
                        if (this._getDisplayedMessages() === 'hint') {
                            /** @type {?} */
                            var startHint = this._hintChildren ?
                                this._hintChildren.find(( /**
                                 * @param {?} hint
                                 * @return {?}
                                 */function (/**
                                 * @param {?} hint
                                 * @return {?}
                                 */ hint) { return hint.align === 'start'; })) : null;
                            /** @type {?} */
                            var endHint = this._hintChildren ?
                                this._hintChildren.find(( /**
                                 * @param {?} hint
                                 * @return {?}
                                 */function (/**
                                 * @param {?} hint
                                 * @return {?}
                                 */ hint) { return hint.align === 'end'; })) : null;
                            if (startHint) {
                                ids.push(startHint.id);
                            }
                            else if (this._hintLabel) {
                                ids.push(this._hintLabelId);
                            }
                            if (endHint) {
                                ids.push(endHint.id);
                            }
                        }
                        else if (this._errorChildren) {
                            ids = this._errorChildren.map(( /**
                             * @param {?} error
                             * @return {?}
                             */function (/**
                             * @param {?} error
                             * @return {?}
                             */ error) { return error.id; }));
                        }
                        this._control.setDescribedByIds(ids);
                    }
                };
                /**
                 * Throws an error if the form field's control is missing.
                 * @protected
                 * @return {?}
                 */
                MatFormField.prototype._validateControlChild = function () {
                    if (!this._control) {
                        throw getMatFormFieldMissingControlError();
                    }
                };
                /**
                 * Updates the width and position of the gap in the outline. Only relevant for the outline
                 * appearance.
                 * @return {?}
                 */
                MatFormField.prototype.updateOutlineGap = function () {
                    /** @type {?} */
                    var labelEl = this._label ? this._label.nativeElement : null;
                    if (this.appearance !== 'outline' || !labelEl || !labelEl.children.length ||
                        !labelEl.textContent.trim()) {
                        return;
                    }
                    if (!this._platform.isBrowser) {
                        // getBoundingClientRect isn't available on the server.
                        return;
                    }
                    // If the element is not present in the DOM, the outline gap will need to be calculated
                    // the next time it is checked and in the DOM.
                    if (!( /** @type {?} */(document.documentElement)).contains(this._elementRef.nativeElement)) {
                        this._outlineGapCalculationNeededImmediately = true;
                        return;
                    }
                    /** @type {?} */
                    var startWidth = 0;
                    /** @type {?} */
                    var gapWidth = 0;
                    /** @type {?} */
                    var container = this._connectionContainerRef.nativeElement;
                    /** @type {?} */
                    var startEls = container.querySelectorAll('.mat-form-field-outline-start');
                    /** @type {?} */
                    var gapEls = container.querySelectorAll('.mat-form-field-outline-gap');
                    if (this._label && this._label.nativeElement.children.length) {
                        /** @type {?} */
                        var containerRect = container.getBoundingClientRect();
                        // If the container's width and height are zero, it means that the element is
                        // invisible and we can't calculate the outline gap. Mark the element as needing
                        // to be checked the next time the zone stabilizes. We can't do this immediately
                        // on the next change detection, because even if the element becomes visible,
                        // the `ClientRect` won't be reclaculated immediately. We reset the
                        // `_outlineGapCalculationNeededImmediately` flag some we don't run the checks twice.
                        if (containerRect.width === 0 && containerRect.height === 0) {
                            this._outlineGapCalculationNeededOnStable = true;
                            this._outlineGapCalculationNeededImmediately = false;
                            return;
                        }
                        /** @type {?} */
                        var containerStart = this._getStartEnd(containerRect);
                        /** @type {?} */
                        var labelStart = this._getStartEnd(labelEl.children[0].getBoundingClientRect());
                        /** @type {?} */
                        var labelWidth = 0;
                        for (var _c = 0, _d = labelEl.children; _c < _d.length; _c++) {
                            var child = _d[_c];
                            labelWidth += child.offsetWidth;
                        }
                        startWidth = labelStart - containerStart - outlineGapPadding;
                        gapWidth = labelWidth > 0 ? labelWidth * floatingLabelScale + outlineGapPadding * 2 : 0;
                    }
                    for (var i = 0; i < startEls.length; i++) {
                        startEls.item(i).style.width = startWidth + "px";
                    }
                    for (var i = 0; i < gapEls.length; i++) {
                        gapEls.item(i).style.width = gapWidth + "px";
                    }
                    this._outlineGapCalculationNeededOnStable =
                        this._outlineGapCalculationNeededImmediately = false;
                };
                /**
                 * Gets the start end of the rect considering the current directionality.
                 * @private
                 * @param {?} rect
                 * @return {?}
                 */
                MatFormField.prototype._getStartEnd = function (rect) {
                    return this._previousDirection === 'rtl' ? rect.right : rect.left;
                };
                return MatFormField;
            }(_MatFormFieldMixinBase));
            MatFormField.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-form-field',
                            exportAs: 'matFormField',
                            template: "<div class=\"mat-form-field-wrapper\"><div class=\"mat-form-field-flex\" #connectionContainer (click)=\"_control.onContainerClick && _control.onContainerClick($event)\"><ng-container *ngIf=\"appearance == 'outline'\"><div class=\"mat-form-field-outline\"><div class=\"mat-form-field-outline-start\"></div><div class=\"mat-form-field-outline-gap\"></div><div class=\"mat-form-field-outline-end\"></div></div><div class=\"mat-form-field-outline mat-form-field-outline-thick\"><div class=\"mat-form-field-outline-start\"></div><div class=\"mat-form-field-outline-gap\"></div><div class=\"mat-form-field-outline-end\"></div></div></ng-container><div class=\"mat-form-field-prefix\" *ngIf=\"_prefixChildren.length\"><ng-content select=\"[matPrefix]\"></ng-content></div><div class=\"mat-form-field-infix\" #inputContainer><ng-content></ng-content><span class=\"mat-form-field-label-wrapper\"><label class=\"mat-form-field-label\" (cdkObserveContent)=\"updateOutlineGap()\" [cdkObserveContentDisabled]=\"appearance != 'outline'\" [id]=\"_labelId\" [attr.for]=\"_control.id\" [attr.aria-owns]=\"_control.id\" [class.mat-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-form-field-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\" #label *ngIf=\"_hasFloatingLabel()\" [ngSwitch]=\"_hasLabel()\"><ng-container *ngSwitchCase=\"false\"><ng-content select=\"mat-placeholder\"></ng-content><span>{{_control.placeholder}}</span></ng-container><ng-content select=\"mat-label\" *ngSwitchCase=\"true\"></ng-content><span class=\"mat-placeholder-required mat-form-field-required-marker\" aria-hidden=\"true\" *ngIf=\"!hideRequiredMarker && _control.required && !_control.disabled\">&#32;*</span></label></span></div><div class=\"mat-form-field-suffix\" *ngIf=\"_suffixChildren.length\"><ng-content select=\"[matSuffix]\"></ng-content></div></div><div class=\"mat-form-field-underline\" #underline *ngIf=\"appearance != 'outline'\"><span class=\"mat-form-field-ripple\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\"></span></div><div class=\"mat-form-field-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\"><div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\"><ng-content select=\"mat-error\"></ng-content></div><div class=\"mat-form-field-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\"><div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"mat-hint\">{{hintLabel}}</div><ng-content select=\"mat-hint:not([align='end'])\"></ng-content><div class=\"mat-form-field-hint-spacer\"></div><ng-content select=\"mat-hint[align='end']\"></ng-content></div></div></div>",
                            // MatInput is a directive and can't have styles, so we need to include its styles here
                            // in form-field-input.css. The MatInput styles are fairly minimal so it shouldn't be a
                            // big deal for people who aren't using MatInput.
                            styles: [".mat-form-field{display:inline-block;position:relative;text-align:left}[dir=rtl] .mat-form-field{text-align:right}.mat-form-field-wrapper{position:relative}.mat-form-field-flex{display:inline-flex;align-items:baseline;box-sizing:border-box;width:100%}.mat-form-field-prefix,.mat-form-field-suffix{white-space:nowrap;flex:none;position:relative}.mat-form-field-infix{display:block;position:relative;flex:auto;min-width:0;width:180px}@media (-ms-high-contrast:active){.mat-form-field-infix{border-image:linear-gradient(transparent,transparent)}}.mat-form-field-label-wrapper{position:absolute;left:0;box-sizing:content-box;width:100%;height:100%;overflow:hidden;pointer-events:none}[dir=rtl] .mat-form-field-label-wrapper{left:auto;right:0}.mat-form-field-label{position:absolute;left:0;font:inherit;pointer-events:none;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1);display:none}[dir=rtl] .mat-form-field-label{transform-origin:100% 0;left:auto;right:0}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-empty.mat-form-field-label{display:block}.mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:block;transition:none}.mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-form-field-can-float .mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:block}.mat-form-field-label:not(.mat-form-field-empty){transition:none}.mat-form-field-underline{position:absolute;width:100%;pointer-events:none;transform:scaleY(1.0001)}.mat-form-field-ripple{position:absolute;left:0;width:100%;transform-origin:50%;transform:scaleX(.5);opacity:0;transition:background-color .3s cubic-bezier(.55,0,.55,.2)}.mat-form-field.mat-focused .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple{opacity:1;transform:scaleX(1);transition:transform .3s cubic-bezier(.25,.8,.25,1),opacity .1s cubic-bezier(.25,.8,.25,1),background-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-subscript-wrapper{position:absolute;box-sizing:border-box;width:100%;overflow:hidden}.mat-form-field-label-wrapper .mat-icon,.mat-form-field-subscript-wrapper .mat-icon{width:1em;height:1em;font-size:inherit;vertical-align:baseline}.mat-form-field-hint-wrapper{display:flex}.mat-form-field-hint-spacer{flex:1 0 1em}.mat-error{display:block}.mat-form-field-control-wrapper{position:relative}.mat-form-field._mat-animation-noopable .mat-form-field-label,.mat-form-field._mat-animation-noopable .mat-form-field-ripple{transition:none} .mat-form-field-appearance-fill .mat-form-field-flex{border-radius:4px 4px 0 0;padding:.75em .75em 0 .75em}@media (-ms-high-contrast:active){.mat-form-field-appearance-fill .mat-form-field-flex{outline:solid 1px}}.mat-form-field-appearance-fill .mat-form-field-underline::before{content:'';display:block;position:absolute;bottom:0;height:1px;width:100%}.mat-form-field-appearance-fill .mat-form-field-ripple{bottom:0;height:2px}@media (-ms-high-contrast:active){.mat-form-field-appearance-fill .mat-form-field-ripple{height:0;border-top:solid 2px}}.mat-form-field-appearance-fill:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-fill._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{transition:none}.mat-form-field-appearance-fill .mat-form-field-subscript-wrapper{padding:0 1em} .mat-input-element{font:inherit;background:0 0;color:currentColor;border:none;outline:0;padding:0;margin:0;width:100%;max-width:100%;vertical-align:bottom;text-align:inherit}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element::-ms-clear,.mat-input-element::-ms-reveal{display:none}.mat-input-element,.mat-input-element::-webkit-search-cancel-button,.mat-input-element::-webkit-search-decoration,.mat-input-element::-webkit-search-results-button,.mat-input-element::-webkit-search-results-decoration{-webkit-appearance:none}.mat-input-element::-webkit-caps-lock-indicator,.mat-input-element::-webkit-contacts-auto-fill-button,.mat-input-element::-webkit-credentials-auto-fill-button{visibility:hidden}.mat-input-element[type=date]::after,.mat-input-element[type=datetime-local]::after,.mat-input-element[type=datetime]::after,.mat-input-element[type=month]::after,.mat-input-element[type=time]::after,.mat-input-element[type=week]::after{content:' ';white-space:pre;width:1px}.mat-input-element::-webkit-calendar-picker-indicator,.mat-input-element::-webkit-clear-button,.mat-input-element::-webkit-inner-spin-button{font-size:.75em}.mat-input-element::placeholder{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::placeholder:-ms-input-placeholder{-ms-user-select:text}.mat-input-element::-moz-placeholder{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-moz-placeholder:-ms-input-placeholder{-ms-user-select:text}.mat-input-element::-webkit-input-placeholder{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-webkit-input-placeholder:-ms-input-placeholder{-ms-user-select:text}.mat-input-element:-ms-input-placeholder{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element:-ms-input-placeholder:-ms-input-placeholder{-ms-user-select:text}.mat-form-field-hide-placeholder .mat-input-element::placeholder{color:transparent!important;-webkit-text-fill-color:transparent;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{color:transparent!important;-webkit-text-fill-color:transparent;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{color:transparent!important;-webkit-text-fill-color:transparent;transition:none}.mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{color:transparent!important;-webkit-text-fill-color:transparent;transition:none}textarea.mat-input-element{resize:vertical;overflow:auto}textarea.mat-input-element.cdk-textarea-autosize{resize:none}textarea.mat-input-element{padding:2px 0;margin:-2px 0}select.mat-input-element{-moz-appearance:none;-webkit-appearance:none;position:relative;background-color:transparent;display:inline-flex;box-sizing:border-box;padding-top:1em;top:-1em;margin-bottom:-1em}select.mat-input-element::-ms-expand{display:none}select.mat-input-element::-moz-focus-inner{border:0}select.mat-input-element:not(:disabled){cursor:pointer}select.mat-input-element::-ms-value{color:inherit;background:0 0}@media (-ms-high-contrast:active){.mat-focused select.mat-input-element::-ms-value{color:inherit}}.mat-form-field-type-mat-native-select .mat-form-field-infix::after{content:'';width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;position:absolute;top:50%;right:0;margin-top:-2.5px;pointer-events:none}[dir=rtl] .mat-form-field-type-mat-native-select .mat-form-field-infix::after{right:auto;left:0}.mat-form-field-type-mat-native-select .mat-input-element{padding-right:15px}[dir=rtl] .mat-form-field-type-mat-native-select .mat-input-element{padding-right:0;padding-left:15px}.mat-form-field-type-mat-native-select .mat-form-field-label-wrapper{max-width:calc(100% - 10px)}.mat-form-field-type-mat-native-select.mat-form-field-appearance-outline .mat-form-field-infix::after{margin-top:-5px}.mat-form-field-type-mat-native-select.mat-form-field-appearance-fill .mat-form-field-infix::after{margin-top:-10px} .mat-form-field-appearance-legacy .mat-form-field-label{transform:perspective(100px);-ms-transform:none}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon{width:1em}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button{font:inherit;vertical-align:baseline}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button .mat-icon{font-size:inherit}.mat-form-field-appearance-legacy .mat-form-field-underline{height:1px}@media (-ms-high-contrast:active){.mat-form-field-appearance-legacy .mat-form-field-underline{height:0;border-top:solid 1px}}.mat-form-field-appearance-legacy .mat-form-field-ripple{top:0;height:2px;overflow:hidden}@media (-ms-high-contrast:active){.mat-form-field-appearance-legacy .mat-form-field-ripple{height:0;border-top:solid 2px}}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}@media (-ms-high-contrast:active){.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{border-top-style:dotted;border-top-width:2px}}.mat-form-field-appearance-legacy.mat-form-field-invalid:not(.mat-focused) .mat-form-field-ripple{height:1px} .mat-form-field-appearance-outline .mat-form-field-wrapper{margin:.25em 0}.mat-form-field-appearance-outline .mat-form-field-flex{padding:0 .75em 0 .75em;margin-top:-.25em;position:relative}.mat-form-field-appearance-outline .mat-form-field-prefix,.mat-form-field-appearance-outline .mat-form-field-suffix{top:.25em}.mat-form-field-appearance-outline .mat-form-field-outline{display:flex;position:absolute;top:.25em;left:0;right:0;bottom:0;pointer-events:none}.mat-form-field-appearance-outline .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-start{border:1px solid currentColor;min-width:5px}.mat-form-field-appearance-outline .mat-form-field-outline-start{border-radius:5px 0 0 5px;border-right-style:none}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-start{border-right-style:solid;border-left-style:none;border-radius:0 5px 5px 0}.mat-form-field-appearance-outline .mat-form-field-outline-end{border-radius:0 5px 5px 0;border-left-style:none;flex-grow:1}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-end{border-left-style:solid;border-right-style:none;border-radius:5px 0 0 5px}.mat-form-field-appearance-outline .mat-form-field-outline-gap{border-radius:.000001px;border:1px solid currentColor;border-left-style:none;border-right-style:none}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-outline-gap{border-top-color:transparent}.mat-form-field-appearance-outline .mat-form-field-outline-thick{opacity:0}.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-gap,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-start{border-width:2px;transition:border-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline{opacity:0;transition:opacity .1s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover .mat-form-field-outline{opacity:0;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover .mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline .mat-form-field-subscript-wrapper{padding:0 1em}.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-end,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-gap,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-start,.mat-form-field-appearance-outline._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline{transition:none} .mat-form-field-appearance-standard .mat-form-field-flex{padding-top:.75em}.mat-form-field-appearance-standard .mat-form-field-underline{height:1px}@media (-ms-high-contrast:active){.mat-form-field-appearance-standard .mat-form-field-underline{height:0;border-top:solid 1px}}.mat-form-field-appearance-standard .mat-form-field-ripple{bottom:0;height:2px}@media (-ms-high-contrast:active){.mat-form-field-appearance-standard .mat-form-field-ripple{height:0;border-top:2px}}.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}@media (-ms-high-contrast:active){.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{border-top-style:dotted;border-top-width:2px}}.mat-form-field-appearance-standard:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-standard._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{transition:none}"],
                            animations: [matFormFieldAnimations.transitionMessages],
                            host: {
                                'class': 'mat-form-field',
                                '[class.mat-form-field-appearance-standard]': 'appearance == "standard"',
                                '[class.mat-form-field-appearance-fill]': 'appearance == "fill"',
                                '[class.mat-form-field-appearance-outline]': 'appearance == "outline"',
                                '[class.mat-form-field-appearance-legacy]': 'appearance == "legacy"',
                                '[class.mat-form-field-invalid]': '_control.errorState',
                                '[class.mat-form-field-can-float]': '_canLabelFloat',
                                '[class.mat-form-field-should-float]': '_shouldLabelFloat()',
                                '[class.mat-form-field-has-label]': '_hasFloatingLabel()',
                                '[class.mat-form-field-hide-placeholder]': '_hideControlPlaceholder()',
                                '[class.mat-form-field-disabled]': '_control.disabled',
                                '[class.mat-form-field-autofilled]': '_control.autofilled',
                                '[class.mat-focused]': '_control.focused',
                                '[class.mat-accent]': 'color == "accent"',
                                '[class.mat-warn]': 'color == "warn"',
                                '[class.ng-untouched]': '_shouldForward("untouched")',
                                '[class.ng-touched]': '_shouldForward("touched")',
                                '[class.ng-pristine]': '_shouldForward("pristine")',
                                '[class.ng-dirty]': '_shouldForward("dirty")',
                                '[class.ng-valid]': '_shouldForward("valid")',
                                '[class.ng-invalid]': '_shouldForward("invalid")',
                                '[class.ng-pending]': '_shouldForward("pending")',
                                '[class._mat-animation-noopable]': '!_animationsEnabled',
                            },
                            inputs: ['color'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatFormField.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MAT_LABEL_GLOBAL_OPTIONS"],] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_7__["Platform"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_8__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatFormField.propDecorators = {
                appearance: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                hideRequiredMarker: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                hintLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                floatLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                underlineRef: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['underline', { static: false },] }],
                _connectionContainerRef: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['connectionContainer', { static: true },] }],
                _inputContainerRef: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['inputContainer', { static: false },] }],
                _label: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['label', { static: false },] }],
                _controlNonStatic: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatFormFieldControl, { static: false },] }],
                _controlStatic: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatFormFieldControl, { static: true },] }],
                _labelChildNonStatic: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatLabel, { static: false },] }],
                _labelChildStatic: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatLabel, { static: true },] }],
                _placeholderChild: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatPlaceholder, { static: false },] }],
                _errorChildren: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatError,] }],
                _hintChildren: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatHint,] }],
                _prefixChildren: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatPrefix,] }],
                _suffixChildren: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatSuffix,] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatFormFieldModule = /** @class */ (function () {
                function MatFormFieldModule() {
                }
                return MatFormFieldModule;
            }());
            MatFormFieldModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: [
                                MatError,
                                MatFormField,
                                MatHint,
                                MatLabel,
                                MatPlaceholder,
                                MatPrefix,
                                MatSuffix,
                            ],
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_9__["CommonModule"],
                                _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_10__["ObserversModule"],
                            ],
                            exports: [
                                MatError,
                                MatFormField,
                                MatHint,
                                MatLabel,
                                MatPlaceholder,
                                MatPrefix,
                                MatSuffix,
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=form-field.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/grid-list.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/grid-list.js ***!
          \*************************************************************/
        /*! exports provided: MatGridListModule, MatGridList, MatGridTile, MatGridTileText, MatGridAvatarCssMatStyler, MatGridTileHeaderCssMatStyler, MatGridTileFooterCssMatStyler, ɵa11 */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridListModule", function () { return MatGridListModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridList", function () { return MatGridList; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridTile", function () { return MatGridTile; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridTileText", function () { return MatGridTileText; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridAvatarCssMatStyler", function () { return MatGridAvatarCssMatStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridTileHeaderCssMatStyler", function () { return MatGridTileHeaderCssMatStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatGridTileFooterCssMatStyler", function () { return MatGridTileFooterCssMatStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa11", function () { return MAT_GRID_LIST; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token used to provide a grid list to a tile and to avoid circular imports.
             * \@docs-private
             * @type {?}
             */
            var MAT_GRID_LIST = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_GRID_LIST');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatGridTile = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?=} _gridList
                 */
                function MatGridTile(_element, _gridList) {
                    this._element = _element;
                    this._gridList = _gridList;
                    this._rowspan = 1;
                    this._colspan = 1;
                }
                Object.defineProperty(MatGridTile.prototype, "rowspan", {
                    /**
                     * Amount of rows that the grid tile takes up.
                     * @return {?}
                     */
                    get: function () { return this._rowspan; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._rowspan = Math.round(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value)); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatGridTile.prototype, "colspan", {
                    /**
                     * Amount of columns that the grid tile takes up.
                     * @return {?}
                     */
                    get: function () { return this._colspan; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._colspan = Math.round(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value)); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Sets the style of the grid-tile element.  Needs to be set manually to avoid
                 * "Changed after checked" errors that would occur with HostBinding.
                 * @param {?} property
                 * @param {?} value
                 * @return {?}
                 */
                MatGridTile.prototype._setStyle = function (property, value) {
                    (( /** @type {?} */(this._element.nativeElement.style)))[property] = value;
                };
                return MatGridTile;
            }());
            MatGridTile.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-grid-tile',
                            exportAs: 'matGridTile',
                            host: {
                                'class': 'mat-grid-tile',
                            },
                            template: "<figure class=\"mat-figure\"><ng-content></ng-content></figure>",
                            styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{top:0;left:0;right:0;bottom:0;position:absolute;display:flex;align-items:center;justify-content:center;height:100%;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatGridTile.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_GRID_LIST,] }] }
            ]; };
            MatGridTile.propDecorators = {
                rowspan: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                colspan: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            var MatGridTileText = /** @class */ (function () {
                /**
                 * @param {?} _element
                 */
                function MatGridTileText(_element) {
                    this._element = _element;
                }
                /**
                 * @return {?}
                 */
                MatGridTileText.prototype.ngAfterContentInit = function () {
                    Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["setLines"])(this._lines, this._element);
                };
                return MatGridTileText;
            }());
            MatGridTileText.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-grid-tile-header, mat-grid-tile-footer',
                            template: "<ng-content select=\"[mat-grid-avatar], [matGridAvatar]\"></ng-content><div class=\"mat-grid-list-text\"><ng-content select=\"[mat-line], [matLine]\"></ng-content></div><ng-content></ng-content>",
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatGridTileText.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            MatGridTileText.propDecorators = {
                _lines: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLine"],] }]
            };
            /**
             * Directive whose purpose is to add the mat- CSS styling to this selector.
             * \@docs-private
             */
            var MatGridAvatarCssMatStyler = /** @class */ (function () {
                function MatGridAvatarCssMatStyler() {
                }
                return MatGridAvatarCssMatStyler;
            }());
            MatGridAvatarCssMatStyler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-grid-avatar], [matGridAvatar]',
                            host: { 'class': 'mat-grid-avatar' }
                        },] },
            ];
            /**
             * Directive whose purpose is to add the mat- CSS styling to this selector.
             * \@docs-private
             */
            var MatGridTileHeaderCssMatStyler = /** @class */ (function () {
                function MatGridTileHeaderCssMatStyler() {
                }
                return MatGridTileHeaderCssMatStyler;
            }());
            MatGridTileHeaderCssMatStyler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-grid-tile-header',
                            host: { 'class': 'mat-grid-tile-header' }
                        },] },
            ];
            /**
             * Directive whose purpose is to add the mat- CSS styling to this selector.
             * \@docs-private
             */
            var MatGridTileFooterCssMatStyler = /** @class */ (function () {
                function MatGridTileFooterCssMatStyler() {
                }
                return MatGridTileFooterCssMatStyler;
            }());
            MatGridTileFooterCssMatStyler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-grid-tile-footer',
                            host: { 'class': 'mat-grid-tile-footer' }
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Class for determining, from a list of tiles, the (row, col) position of each of those tiles
             * in the grid. This is necessary (rather than just rendering the tiles in normal document flow)
             * because the tiles can have a rowspan.
             *
             * The positioning algorithm greedily places each tile as soon as it encounters a gap in the grid
             * large enough to accommodate it so that the tiles still render in the same order in which they
             * are given.
             *
             * The basis of the algorithm is the use of an array to track the already placed tiles. Each
             * element of the array corresponds to a column, and the value indicates how many cells in that
             * column are already occupied; zero indicates an empty cell. Moving "down" to the next row
             * decrements each value in the tracking array (indicating that the column is one cell closer to
             * being free).
             *
             * \@docs-private
             */
            var TileCoordinator = /** @class */ (function () {
                function TileCoordinator() {
                    /**
                     * Index at which the search for the next gap will start.
                     */
                    this.columnIndex = 0;
                    /**
                     * The current row index.
                     */
                    this.rowIndex = 0;
                }
                Object.defineProperty(TileCoordinator.prototype, "rowCount", {
                    /**
                     * Gets the total number of rows occupied by tiles
                     * @return {?}
                     */
                    get: function () { return this.rowIndex + 1; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(TileCoordinator.prototype, "rowspan", {
                    /**
                     * Gets the total span of rows occupied by tiles.
                     * Ex: A list with 1 row that contains a tile with rowspan 2 will have a total rowspan of 2.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var lastRowMax = Math.max.apply(Math, this.tracker);
                        // if any of the tiles has a rowspan that pushes it beyond the total row count,
                        // add the difference to the rowcount
                        return lastRowMax > 1 ? this.rowCount + lastRowMax - 1 : this.rowCount;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Updates the tile positions.
                 * @param {?} numColumns Amount of columns in the grid.
                 * @param {?} tiles
                 * @return {?}
                 */
                TileCoordinator.prototype.update = function (numColumns, tiles) {
                    var _this = this;
                    this.columnIndex = 0;
                    this.rowIndex = 0;
                    this.tracker = new Array(numColumns);
                    this.tracker.fill(0, 0, this.tracker.length);
                    this.positions = tiles.map(( /**
                     * @param {?} tile
                     * @return {?}
                     */function (/**
                     * @param {?} tile
                     * @return {?}
                     */ tile) { return _this._trackTile(tile); }));
                };
                /**
                 * Calculates the row and col position of a tile.
                 * @private
                 * @param {?} tile
                 * @return {?}
                 */
                TileCoordinator.prototype._trackTile = function (tile) {
                    // Find a gap large enough for this tile.
                    /** @type {?} */
                    var gapStartIndex = this._findMatchingGap(tile.colspan);
                    // Place tile in the resulting gap.
                    this._markTilePosition(gapStartIndex, tile);
                    // The next time we look for a gap, the search will start at columnIndex, which should be
                    // immediately after the tile that has just been placed.
                    this.columnIndex = gapStartIndex + tile.colspan;
                    return new TilePosition(this.rowIndex, gapStartIndex);
                };
                /**
                 * Finds the next available space large enough to fit the tile.
                 * @private
                 * @param {?} tileCols
                 * @return {?}
                 */
                TileCoordinator.prototype._findMatchingGap = function (tileCols) {
                    if (tileCols > this.tracker.length) {
                        throw Error("mat-grid-list: tile with colspan " + tileCols + " is wider than " +
                            ("grid with cols=\"" + this.tracker.length + "\"."));
                    }
                    // Start index is inclusive, end index is exclusive.
                    /** @type {?} */
                    var gapStartIndex = -1;
                    /** @type {?} */
                    var gapEndIndex = -1;
                    // Look for a gap large enough to fit the given tile. Empty spaces are marked with a zero.
                    do {
                        // If we've reached the end of the row, go to the next row.
                        if (this.columnIndex + tileCols > this.tracker.length) {
                            this._nextRow();
                            gapStartIndex = this.tracker.indexOf(0, this.columnIndex);
                            gapEndIndex = this._findGapEndIndex(gapStartIndex);
                            continue;
                        }
                        gapStartIndex = this.tracker.indexOf(0, this.columnIndex);
                        // If there are no more empty spaces in this row at all, move on to the next row.
                        if (gapStartIndex == -1) {
                            this._nextRow();
                            gapStartIndex = this.tracker.indexOf(0, this.columnIndex);
                            gapEndIndex = this._findGapEndIndex(gapStartIndex);
                            continue;
                        }
                        gapEndIndex = this._findGapEndIndex(gapStartIndex);
                        // If a gap large enough isn't found, we want to start looking immediately after the current
                        // gap on the next iteration.
                        this.columnIndex = gapStartIndex + 1;
                        // Continue iterating until we find a gap wide enough for this tile. Since gapEndIndex is
                        // exclusive, gapEndIndex is 0 means we didn't find a gap and should continue.
                    } while ((gapEndIndex - gapStartIndex < tileCols) || (gapEndIndex == 0));
                    // If we still didn't manage to find a gap, ensure that the index is
                    // at least zero so the tile doesn't get pulled out of the grid.
                    return Math.max(gapStartIndex, 0);
                };
                /**
                 * Move "down" to the next row.
                 * @private
                 * @return {?}
                 */
                TileCoordinator.prototype._nextRow = function () {
                    this.columnIndex = 0;
                    this.rowIndex++;
                    // Decrement all spaces by one to reflect moving down one row.
                    for (var i = 0; i < this.tracker.length; i++) {
                        this.tracker[i] = Math.max(0, this.tracker[i] - 1);
                    }
                };
                /**
                 * Finds the end index (exclusive) of a gap given the index from which to start looking.
                 * The gap ends when a non-zero value is found.
                 * @private
                 * @param {?} gapStartIndex
                 * @return {?}
                 */
                TileCoordinator.prototype._findGapEndIndex = function (gapStartIndex) {
                    for (var i = gapStartIndex + 1; i < this.tracker.length; i++) {
                        if (this.tracker[i] != 0) {
                            return i;
                        }
                    }
                    // The gap ends with the end of the row.
                    return this.tracker.length;
                };
                /**
                 * Update the tile tracker to account for the given tile in the given space.
                 * @private
                 * @param {?} start
                 * @param {?} tile
                 * @return {?}
                 */
                TileCoordinator.prototype._markTilePosition = function (start, tile) {
                    for (var i = 0; i < tile.colspan; i++) {
                        this.tracker[start + i] = tile.rowspan;
                    }
                };
                return TileCoordinator;
            }());
            /**
             * Simple data structure for tile position (row, col).
             * \@docs-private
             */
            var TilePosition = /** @class */ (function () {
                /**
                 * @param {?} row
                 * @param {?} col
                 */
                function TilePosition(row, col) {
                    this.row = row;
                    this.col = col;
                }
                return TilePosition;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * RegExp that can be used to check whether a value will
             * be allowed inside a CSS `calc()` expression.
             * @type {?}
             */
            var cssCalcAllowedValue = /^-?\d+((\.\d+)?[A-Za-z%$]?)+$/;
            /**
             * Sets the style properties for an individual tile, given the position calculated by the
             * Tile Coordinator.
             * \@docs-private
             * @abstract
             */
            var TileStyler = /** @class */ (function () {
                function TileStyler() {
                    this._rows = 0;
                    this._rowspan = 0;
                }
                /**
                 * Adds grid-list layout info once it is available. Cannot be processed in the constructor
                 * because these properties haven't been calculated by that point.
                 *
                 * @param {?} gutterSize Size of the grid's gutter.
                 * @param {?} tracker Instance of the TileCoordinator.
                 * @param {?} cols Amount of columns in the grid.
                 * @param {?} direction Layout direction of the grid.
                 * @return {?}
                 */
                TileStyler.prototype.init = function (gutterSize, tracker, cols, direction) {
                    this._gutterSize = normalizeUnits(gutterSize);
                    this._rows = tracker.rowCount;
                    this._rowspan = tracker.rowspan;
                    this._cols = cols;
                    this._direction = direction;
                };
                /**
                 * Computes the amount of space a single 1x1 tile would take up (width or height).
                 * Used as a basis for other calculations.
                 * @param {?} sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
                 * @param {?} gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
                 * @return {?} The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
                 */
                TileStyler.prototype.getBaseTileSize = function (sizePercent, gutterFraction) {
                    // Take the base size percent (as would be if evenly dividing the size between cells),
                    // and then subtracting the size of one gutter. However, since there are no gutters on the
                    // edges, each tile only uses a fraction (gutterShare = numGutters / numCells) of the gutter
                    // size. (Imagine having one gutter per tile, and then breaking up the extra gutter on the
                    // edge evenly among the cells).
                    return "(" + sizePercent + "% - (" + this._gutterSize + " * " + gutterFraction + "))";
                };
                /**
                 * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
                 * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
                 * @param {?} offset Number of tiles that have already been rendered in the row/column.
                 * @return {?} Position of the tile as a CSS calc() expression.
                 */
                TileStyler.prototype.getTilePosition = function (baseSize, offset) {
                    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
                    // row/column (offset).
                    return offset === 0 ? '0' : calc("(" + baseSize + " + " + this._gutterSize + ") * " + offset);
                };
                /**
                 * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
                 * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
                 * @param {?} span The tile's rowspan or colspan.
                 * @return {?} Size of the tile as a CSS calc() expression.
                 */
                TileStyler.prototype.getTileSize = function (baseSize, span) {
                    return "(" + baseSize + " * " + span + ") + (" + (span - 1) + " * " + this._gutterSize + ")";
                };
                /**
                 * Sets the style properties to be applied to a tile for the given row and column index.
                 * @param {?} tile Tile to which to apply the styling.
                 * @param {?} rowIndex Index of the tile's row.
                 * @param {?} colIndex Index of the tile's column.
                 * @return {?}
                 */
                TileStyler.prototype.setStyle = function (tile, rowIndex, colIndex) {
                    // Percent of the available horizontal space that one column takes up.
                    /** @type {?} */
                    var percentWidthPerTile = 100 / this._cols;
                    // Fraction of the vertical gutter size that each column takes up.
                    // For example, if there are 5 columns, each column uses 4/5 = 0.8 times the gutter width.
                    /** @type {?} */
                    var gutterWidthFractionPerTile = (this._cols - 1) / this._cols;
                    this.setColStyles(tile, colIndex, percentWidthPerTile, gutterWidthFractionPerTile);
                    this.setRowStyles(tile, rowIndex, percentWidthPerTile, gutterWidthFractionPerTile);
                };
                /**
                 * Sets the horizontal placement of the tile in the list.
                 * @param {?} tile
                 * @param {?} colIndex
                 * @param {?} percentWidth
                 * @param {?} gutterWidth
                 * @return {?}
                 */
                TileStyler.prototype.setColStyles = function (tile, colIndex, percentWidth, gutterWidth) {
                    // Base horizontal size of a column.
                    /** @type {?} */
                    var baseTileWidth = this.getBaseTileSize(percentWidth, gutterWidth);
                    // The width and horizontal position of each tile is always calculated the same way, but the
                    // height and vertical position depends on the rowMode.
                    /** @type {?} */
                    var side = this._direction === 'rtl' ? 'right' : 'left';
                    tile._setStyle(side, this.getTilePosition(baseTileWidth, colIndex));
                    tile._setStyle('width', calc(this.getTileSize(baseTileWidth, tile.colspan)));
                };
                /**
                 * Calculates the total size taken up by gutters across one axis of a list.
                 * @return {?}
                 */
                TileStyler.prototype.getGutterSpan = function () {
                    return this._gutterSize + " * (" + this._rowspan + " - 1)";
                };
                /**
                 * Calculates the total size taken up by tiles across one axis of a list.
                 * @param {?} tileHeight Height of the tile.
                 * @return {?}
                 */
                TileStyler.prototype.getTileSpan = function (tileHeight) {
                    return this._rowspan + " * " + this.getTileSize(tileHeight, 1);
                };
                /**
                 * Calculates the computed height and returns the correct style property to set.
                 * This method can be implemented by each type of TileStyler.
                 * \@docs-private
                 * @return {?}
                 */
                TileStyler.prototype.getComputedHeight = function () { return null; };
                return TileStyler;
            }());
            /**
             * This type of styler is instantiated when the user passes in a fixed row height.
             * Example `<mat-grid-list cols="3" rowHeight="100px">`
             * \@docs-private
             */
            var FixedTileStyler = /** @class */ (function (_super_1) {
                __extends(FixedTileStyler, _super_1);
                /**
                 * @param {?} fixedRowHeight
                 */
                function FixedTileStyler(fixedRowHeight) {
                    var _this = _super_1.call(this) || this;
                    _this.fixedRowHeight = fixedRowHeight;
                    return _this;
                }
                /**
                 * @param {?} gutterSize
                 * @param {?} tracker
                 * @param {?} cols
                 * @param {?} direction
                 * @return {?}
                 */
                FixedTileStyler.prototype.init = function (gutterSize, tracker, cols, direction) {
                    _super_1.prototype.init.call(this, gutterSize, tracker, cols, direction);
                    this.fixedRowHeight = normalizeUnits(this.fixedRowHeight);
                    if (!cssCalcAllowedValue.test(this.fixedRowHeight)) {
                        throw Error("Invalid value \"" + this.fixedRowHeight + "\" set as rowHeight.");
                    }
                };
                /**
                 * @param {?} tile
                 * @param {?} rowIndex
                 * @return {?}
                 */
                FixedTileStyler.prototype.setRowStyles = function (tile, rowIndex) {
                    tile._setStyle('top', this.getTilePosition(this.fixedRowHeight, rowIndex));
                    tile._setStyle('height', calc(this.getTileSize(this.fixedRowHeight, tile.rowspan)));
                };
                /**
                 * @return {?}
                 */
                FixedTileStyler.prototype.getComputedHeight = function () {
                    return [
                        'height', calc(this.getTileSpan(this.fixedRowHeight) + " + " + this.getGutterSpan())
                    ];
                };
                /**
                 * @param {?} list
                 * @return {?}
                 */
                FixedTileStyler.prototype.reset = function (list) {
                    list._setListStyle(['height', null]);
                    if (list._tiles) {
                        list._tiles.forEach(( /**
                         * @param {?} tile
                         * @return {?}
                         */function (/**
                         * @param {?} tile
                         * @return {?}
                         */ tile) {
                            tile._setStyle('top', null);
                            tile._setStyle('height', null);
                        }));
                    }
                };
                return FixedTileStyler;
            }(TileStyler));
            /**
             * This type of styler is instantiated when the user passes in a width:height ratio
             * for the row height.  Example `<mat-grid-list cols="3" rowHeight="3:1">`
             * \@docs-private
             */
            var RatioTileStyler = /** @class */ (function (_super_1) {
                __extends(RatioTileStyler, _super_1);
                /**
                 * @param {?} value
                 */
                function RatioTileStyler(value) {
                    var _this = _super_1.call(this) || this;
                    _this._parseRatio(value);
                    return _this;
                }
                /**
                 * @param {?} tile
                 * @param {?} rowIndex
                 * @param {?} percentWidth
                 * @param {?} gutterWidth
                 * @return {?}
                 */
                RatioTileStyler.prototype.setRowStyles = function (tile, rowIndex, percentWidth, gutterWidth) {
                    /** @type {?} */
                    var percentHeightPerTile = percentWidth / this.rowHeightRatio;
                    this.baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterWidth);
                    // Use padding-top and margin-top to maintain the given aspect ratio, as
                    // a percentage-based value for these properties is applied versus the *width* of the
                    // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
                    tile._setStyle('marginTop', this.getTilePosition(this.baseTileHeight, rowIndex));
                    tile._setStyle('paddingTop', calc(this.getTileSize(this.baseTileHeight, tile.rowspan)));
                };
                /**
                 * @return {?}
                 */
                RatioTileStyler.prototype.getComputedHeight = function () {
                    return [
                        'paddingBottom', calc(this.getTileSpan(this.baseTileHeight) + " + " + this.getGutterSpan())
                    ];
                };
                /**
                 * @param {?} list
                 * @return {?}
                 */
                RatioTileStyler.prototype.reset = function (list) {
                    list._setListStyle(['paddingBottom', null]);
                    list._tiles.forEach(( /**
                     * @param {?} tile
                     * @return {?}
                     */function (/**
                     * @param {?} tile
                     * @return {?}
                     */ tile) {
                        tile._setStyle('marginTop', null);
                        tile._setStyle('paddingTop', null);
                    }));
                };
                /**
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                RatioTileStyler.prototype._parseRatio = function (value) {
                    /** @type {?} */
                    var ratioParts = value.split(':');
                    if (ratioParts.length !== 2) {
                        throw Error("mat-grid-list: invalid ratio given for row-height: \"" + value + "\"");
                    }
                    this.rowHeightRatio = parseFloat(ratioParts[0]) / parseFloat(ratioParts[1]);
                };
                return RatioTileStyler;
            }(TileStyler));
            /**
             * This type of styler is instantiated when the user selects a "fit" row height mode.
             * In other words, the row height will reflect the total height of the container divided
             * by the number of rows.  Example `<mat-grid-list cols="3" rowHeight="fit">`
             *
             * \@docs-private
             */
            var FitTileStyler = /** @class */ (function (_super_1) {
                __extends(FitTileStyler, _super_1);
                function FitTileStyler() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @param {?} tile
                 * @param {?} rowIndex
                 * @return {?}
                 */
                FitTileStyler.prototype.setRowStyles = function (tile, rowIndex) {
                    // Percent of the available vertical space that one row takes up.
                    /** @type {?} */
                    var percentHeightPerTile = 100 / this._rowspan;
                    // Fraction of the horizontal gutter size that each column takes up.
                    /** @type {?} */
                    var gutterHeightPerTile = (this._rows - 1) / this._rows;
                    // Base vertical size of a column.
                    /** @type {?} */
                    var baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterHeightPerTile);
                    tile._setStyle('top', this.getTilePosition(baseTileHeight, rowIndex));
                    tile._setStyle('height', calc(this.getTileSize(baseTileHeight, tile.rowspan)));
                };
                /**
                 * @param {?} list
                 * @return {?}
                 */
                FitTileStyler.prototype.reset = function (list) {
                    if (list._tiles) {
                        list._tiles.forEach(( /**
                         * @param {?} tile
                         * @return {?}
                         */function (/**
                         * @param {?} tile
                         * @return {?}
                         */ tile) {
                            tile._setStyle('top', null);
                            tile._setStyle('height', null);
                        }));
                    }
                };
                return FitTileStyler;
            }(TileStyler));
            /**
             * Wraps a CSS string in a calc function
             * @param {?} exp
             * @return {?}
             */
            function calc(exp) {
                return "calc(" + exp + ")";
            }
            /**
             * Appends pixels to a CSS string if no units are given.
             * @param {?} value
             * @return {?}
             */
            function normalizeUnits(value) {
                return value.match(/([A-Za-z%]+)$/) ? value : value + "px";
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // TODO(kara): Conditional (responsive) column count / row size.
            // TODO(kara): Re-layout on window resize / media change (debounced).
            // TODO(kara): gridTileHeader and gridTileFooter.
            /** @type {?} */
            var MAT_FIT_MODE = 'fit';
            var MatGridList = /** @class */ (function () {
                /**
                 * @param {?} _element
                 * @param {?} _dir
                 */
                function MatGridList(_element, _dir) {
                    this._element = _element;
                    this._dir = _dir;
                    /**
                     * The amount of space between tiles. This will be something like '5px' or '2em'.
                     */
                    this._gutter = '1px';
                }
                Object.defineProperty(MatGridList.prototype, "cols", {
                    /**
                     * Amount of columns in the grid list.
                     * @return {?}
                     */
                    get: function () { return this._cols; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._cols = Math.max(1, Math.round(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value)));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatGridList.prototype, "gutterSize", {
                    /**
                     * Size of the grid list's gutter in pixels.
                     * @return {?}
                     */
                    get: function () { return this._gutter; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._gutter = "" + (value == null ? '' : value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatGridList.prototype, "rowHeight", {
                    /**
                     * Set internal representation of row height from the user-provided value.
                     * @return {?}
                     */
                    get: function () { return this._rowHeight; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = "" + (value == null ? '' : value);
                        if (newValue !== this._rowHeight) {
                            this._rowHeight = newValue;
                            this._setTileStyler(this._rowHeight);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatGridList.prototype.ngOnInit = function () {
                    this._checkCols();
                    this._checkRowHeight();
                };
                /**
                 * The layout calculation is fairly cheap if nothing changes, so there's little cost
                 * to run it frequently.
                 * @return {?}
                 */
                MatGridList.prototype.ngAfterContentChecked = function () {
                    this._layoutTiles();
                };
                /**
                 * Throw a friendly error if cols property is missing
                 * @private
                 * @return {?}
                 */
                MatGridList.prototype._checkCols = function () {
                    if (!this.cols) {
                        throw Error("mat-grid-list: must pass in number of columns. " +
                            "Example: <mat-grid-list cols=\"3\">");
                    }
                };
                /**
                 * Default to equal width:height if rowHeight property is missing
                 * @private
                 * @return {?}
                 */
                MatGridList.prototype._checkRowHeight = function () {
                    if (!this._rowHeight) {
                        this._setTileStyler('1:1');
                    }
                };
                /**
                 * Creates correct Tile Styler subtype based on rowHeight passed in by user
                 * @private
                 * @param {?} rowHeight
                 * @return {?}
                 */
                MatGridList.prototype._setTileStyler = function (rowHeight) {
                    if (this._tileStyler) {
                        this._tileStyler.reset(this);
                    }
                    if (rowHeight === MAT_FIT_MODE) {
                        this._tileStyler = new FitTileStyler();
                    }
                    else if (rowHeight && rowHeight.indexOf(':') > -1) {
                        this._tileStyler = new RatioTileStyler(rowHeight);
                    }
                    else {
                        this._tileStyler = new FixedTileStyler(rowHeight);
                    }
                };
                /**
                 * Computes and applies the size and position for all children grid tiles.
                 * @private
                 * @return {?}
                 */
                MatGridList.prototype._layoutTiles = function () {
                    var _this = this;
                    if (!this._tileCoordinator) {
                        this._tileCoordinator = new TileCoordinator();
                    }
                    /** @type {?} */
                    var tracker = this._tileCoordinator;
                    /** @type {?} */
                    var tiles = this._tiles.filter(( /**
                     * @param {?} tile
                     * @return {?}
                     */function (/**
                     * @param {?} tile
                     * @return {?}
                     */ tile) { return !tile._gridList || tile._gridList === _this; }));
                    /** @type {?} */
                    var direction = this._dir ? this._dir.value : 'ltr';
                    this._tileCoordinator.update(this.cols, tiles);
                    this._tileStyler.init(this.gutterSize, tracker, this.cols, direction);
                    tiles.forEach(( /**
                     * @param {?} tile
                     * @param {?} index
                     * @return {?}
                     */function (tile, index) {
                        /** @type {?} */
                        var pos = tracker.positions[index];
                        _this._tileStyler.setStyle(tile, pos.row, pos.col);
                    }));
                    this._setListStyle(this._tileStyler.getComputedHeight());
                };
                /**
                 * Sets style on the main grid-list element, given the style name and value.
                 * @param {?} style
                 * @return {?}
                 */
                MatGridList.prototype._setListStyle = function (style) {
                    if (style) {
                        (( /** @type {?} */(this._element.nativeElement.style)))[style[0]] = style[1];
                    }
                };
                return MatGridList;
            }());
            MatGridList.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-grid-list',
                            exportAs: 'matGridList',
                            template: "<div><ng-content></ng-content></div>",
                            styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{top:0;left:0;right:0;bottom:0;position:absolute;display:flex;align-items:center;justify-content:center;height:100%;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none}"],
                            host: {
                                'class': 'mat-grid-list',
                            },
                            providers: [{
                                    provide: MAT_GRID_LIST,
                                    useExisting: MatGridList
                                }],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatGridList.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_3__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatGridList.propDecorators = {
                _tiles: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatGridTile, { descendants: true },] }],
                cols: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                gutterSize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                rowHeight: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatGridListModule = /** @class */ (function () {
                function MatGridListModule() {
                }
                return MatGridListModule;
            }());
            MatGridListModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLineModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatCommonModule"]],
                            exports: [
                                MatGridList,
                                MatGridTile,
                                MatGridTileText,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLineModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatCommonModule"],
                                MatGridTileHeaderCssMatStyler,
                                MatGridTileFooterCssMatStyler,
                                MatGridAvatarCssMatStyler
                            ],
                            declarations: [
                                MatGridList,
                                MatGridTile,
                                MatGridTileText,
                                MatGridTileHeaderCssMatStyler,
                                MatGridTileFooterCssMatStyler,
                                MatGridAvatarCssMatStyler
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=grid-list.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/icon.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/icon.js ***!
          \********************************************************/
        /*! exports provided: MatIconModule, MAT_ICON_LOCATION_FACTORY, MAT_ICON_LOCATION, MatIcon, getMatIconNameNotFoundError, getMatIconNoHttpProviderError, getMatIconFailedToSanitizeUrlError, getMatIconFailedToSanitizeLiteralError, ICON_REGISTRY_PROVIDER_FACTORY, MatIconRegistry, ICON_REGISTRY_PROVIDER */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatIconModule", function () { return MatIconModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_ICON_LOCATION_FACTORY", function () { return MAT_ICON_LOCATION_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_ICON_LOCATION", function () { return MAT_ICON_LOCATION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatIcon", function () { return MatIcon; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatIconNameNotFoundError", function () { return getMatIconNameNotFoundError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatIconNoHttpProviderError", function () { return getMatIconNoHttpProviderError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatIconFailedToSanitizeUrlError", function () { return getMatIconFailedToSanitizeUrlError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatIconFailedToSanitizeLiteralError", function () { return getMatIconFailedToSanitizeLiteralError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_REGISTRY_PROVIDER_FACTORY", function () { return ICON_REGISTRY_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatIconRegistry", function () { return MatIconRegistry; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_REGISTRY_PROVIDER", function () { return ICON_REGISTRY_PROVIDER; });
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns an exception to be thrown in the case when attempting to
             * load an icon with a name that cannot be found.
             * \@docs-private
             * @param {?} iconName
             * @return {?}
             */
            function getMatIconNameNotFoundError(iconName) {
                return Error("Unable to find icon with the name \"" + iconName + "\"");
            }
            /**
             * Returns an exception to be thrown when the consumer attempts to use
             * `<mat-icon>` without including \@angular/common/http.
             * \@docs-private
             * @return {?}
             */
            function getMatIconNoHttpProviderError() {
                return Error('Could not find HttpClient provider for use with Angular Material icons. ' +
                    'Please include the HttpClientModule from @angular/common/http in your ' +
                    'app imports.');
            }
            /**
             * Returns an exception to be thrown when a URL couldn't be sanitized.
             * \@docs-private
             * @param {?} url URL that was attempted to be sanitized.
             * @return {?}
             */
            function getMatIconFailedToSanitizeUrlError(url) {
                return Error("The URL provided to MatIconRegistry was not trusted as a resource URL " +
                    ("via Angular's DomSanitizer. Attempted URL was \"" + url + "\"."));
            }
            /**
             * Returns an exception to be thrown when a HTML string couldn't be sanitized.
             * \@docs-private
             * @param {?} literal HTML that was attempted to be sanitized.
             * @return {?}
             */
            function getMatIconFailedToSanitizeLiteralError(literal) {
                return Error("The literal provided to MatIconRegistry was not trusted as safe HTML by " +
                    ("Angular's DomSanitizer. Attempted literal was \"" + literal + "\"."));
            }
            /**
             * Configuration for an icon, including the URL and possibly the cached SVG element.
             * \@docs-private
             */
            var SvgIconConfig = /** @class */ (function () {
                /**
                 * @param {?} data
                 * @param {?=} options
                 */
                function SvgIconConfig(data, options) {
                    this.options = options;
                    // Note that we can't use `instanceof SVGElement` here,
                    // because it'll break during server-side rendering.
                    if (!!(( /** @type {?} */(data))).nodeName) {
                        this.svgElement = ( /** @type {?} */(data));
                    }
                    else {
                        this.url = ( /** @type {?} */(data));
                    }
                }
                return SvgIconConfig;
            }());
            /**
             * Service to register and display icons used by the `<mat-icon>` component.
             * - Registers icon URLs by namespace and name.
             * - Registers icon set URLs by namespace.
             * - Registers aliases for CSS classes, for use with icon fonts.
             * - Loads icons from URLs and extracts individual icons from icon sets.
             */
            var MatIconRegistry = /** @class */ (function () {
                /**
                 * @param {?} _httpClient
                 * @param {?} _sanitizer
                 * @param {?} document
                 * @param {?=} _errorHandler
                 */
                function MatIconRegistry(_httpClient, _sanitizer, document, _errorHandler) {
                    this._httpClient = _httpClient;
                    this._sanitizer = _sanitizer;
                    this._errorHandler = _errorHandler;
                    /**
                     * URLs and cached SVG elements for individual icons. Keys are of the format "[namespace]:[icon]".
                     */
                    this._svgIconConfigs = new Map();
                    /**
                     * SvgIconConfig objects and cached SVG elements for icon sets, keyed by namespace.
                     * Multiple icon sets can be registered under the same namespace.
                     */
                    this._iconSetConfigs = new Map();
                    /**
                     * Cache for icons loaded by direct URLs.
                     */
                    this._cachedIconsByUrl = new Map();
                    /**
                     * In-progress icon fetches. Used to coalesce multiple requests to the same URL.
                     */
                    this._inProgressUrlFetches = new Map();
                    /**
                     * Map from font identifiers to their CSS class names. Used for icon fonts.
                     */
                    this._fontCssClassesByAlias = new Map();
                    /**
                     * The CSS class to apply when an `<mat-icon>` component has no icon name, url, or font specified.
                     * The default 'material-icons' value assumes that the material icon font has been loaded as
                     * described at http://google.github.io/material-design-icons/#icon-font-for-the-web
                     */
                    this._defaultFontSetClass = 'material-icons';
                    this._document = document;
                }
                /**
                 * Registers an icon by URL in the default namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} iconName Name under which the icon should be registered.
                 * @param {?} url
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIcon = function (iconName, url, options) {
                    return ( /** @type {?} */(this)).addSvgIconInNamespace('', iconName, url, options);
                };
                /**
                 * Registers an icon using an HTML string in the default namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} iconName Name under which the icon should be registered.
                 * @param {?} literal SVG source of the icon.
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconLiteral = function (iconName, literal, options) {
                    return ( /** @type {?} */(this)).addSvgIconLiteralInNamespace('', iconName, literal, options);
                };
                /**
                 * Registers an icon by URL in the specified namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} namespace Namespace in which the icon should be registered.
                 * @param {?} iconName Name under which the icon should be registered.
                 * @param {?} url
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconInNamespace = function (namespace, iconName, url, options) {
                    return ( /** @type {?} */(this))._addSvgIconConfig(namespace, iconName, new SvgIconConfig(url, options));
                };
                /**
                 * Registers an icon using an HTML string in the specified namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} namespace Namespace in which the icon should be registered.
                 * @param {?} iconName Name under which the icon should be registered.
                 * @param {?} literal SVG source of the icon.
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconLiteralInNamespace = function (namespace, iconName, literal, options) {
                    /** @type {?} */
                    var sanitizedLiteral = ( /** @type {?} */(this))._sanitizer.sanitize(_angular_core__WEBPACK_IMPORTED_MODULE_2__["SecurityContext"].HTML, literal);
                    if (!sanitizedLiteral) {
                        throw getMatIconFailedToSanitizeLiteralError(literal);
                    }
                    /** @type {?} */
                    var svgElement = ( /** @type {?} */(this))._createSvgElementForSingleIcon(sanitizedLiteral, options);
                    return ( /** @type {?} */(this))._addSvgIconConfig(namespace, iconName, new SvgIconConfig(svgElement, options));
                };
                /**
                 * Registers an icon set by URL in the default namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} url
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconSet = function (url, options) {
                    return ( /** @type {?} */(this)).addSvgIconSetInNamespace('', url, options);
                };
                /**
                 * Registers an icon set using an HTML string in the default namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} literal SVG source of the icon set.
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconSetLiteral = function (literal, options) {
                    return ( /** @type {?} */(this)).addSvgIconSetLiteralInNamespace('', literal, options);
                };
                /**
                 * Registers an icon set by URL in the specified namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} namespace Namespace in which to register the icon set.
                 * @param {?} url
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconSetInNamespace = function (namespace, url, options) {
                    return ( /** @type {?} */(this))._addSvgIconSetConfig(namespace, new SvgIconConfig(url, options));
                };
                /**
                 * Registers an icon set using an HTML string in the specified namespace.
                 * @template THIS
                 * @this {THIS}
                 * @param {?} namespace Namespace in which to register the icon set.
                 * @param {?} literal SVG source of the icon set.
                 * @param {?=} options
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.addSvgIconSetLiteralInNamespace = function (namespace, literal, options) {
                    /** @type {?} */
                    var sanitizedLiteral = ( /** @type {?} */(this))._sanitizer.sanitize(_angular_core__WEBPACK_IMPORTED_MODULE_2__["SecurityContext"].HTML, literal);
                    if (!sanitizedLiteral) {
                        throw getMatIconFailedToSanitizeLiteralError(literal);
                    }
                    /** @type {?} */
                    var svgElement = ( /** @type {?} */(this))._svgElementFromString(sanitizedLiteral);
                    return ( /** @type {?} */(this))._addSvgIconSetConfig(namespace, new SvgIconConfig(svgElement, options));
                };
                /**
                 * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
                 * component with the alias as the fontSet input will cause the class name to be applied
                 * to the `<mat-icon>` element.
                 *
                 * @template THIS
                 * @this {THIS}
                 * @param {?} alias Alias for the font.
                 * @param {?=} className Class name override to be used instead of the alias.
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.registerFontClassAlias = function (alias, className) {
                    if (className === void 0) { className = alias; }
                    ( /** @type {?} */(this))._fontCssClassesByAlias.set(alias, className);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Returns the CSS class name associated with the alias by a previous call to
                 * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
                 * @param {?} alias
                 * @return {?}
                 */
                MatIconRegistry.prototype.classNameForFontAlias = function (alias) {
                    return this._fontCssClassesByAlias.get(alias) || alias;
                };
                /**
                 * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
                 * have a fontSet input value, and is not loading an icon by name or URL.
                 *
                 * @template THIS
                 * @this {THIS}
                 * @param {?} className
                 * @return {THIS}
                 */
                MatIconRegistry.prototype.setDefaultFontSetClass = function (className) {
                    ( /** @type {?} */(this))._defaultFontSetClass = className;
                    return ( /** @type {?} */(this));
                };
                /**
                 * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
                 * have a fontSet input value, and is not loading an icon by name or URL.
                 * @return {?}
                 */
                MatIconRegistry.prototype.getDefaultFontSetClass = function () {
                    return this._defaultFontSetClass;
                };
                /**
                 * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
                 * The response from the URL may be cached so this will not always cause an HTTP request, but
                 * the produced element will always be a new copy of the originally fetched icon. (That is,
                 * it will not contain any modifications made to elements previously returned).
                 *
                 * @param {?} safeUrl URL from which to fetch the SVG icon.
                 * @return {?}
                 */
                MatIconRegistry.prototype.getSvgIconFromUrl = function (safeUrl) {
                    var _this = this;
                    /** @type {?} */
                    var url = this._sanitizer.sanitize(_angular_core__WEBPACK_IMPORTED_MODULE_2__["SecurityContext"].RESOURCE_URL, safeUrl);
                    if (!url) {
                        throw getMatIconFailedToSanitizeUrlError(safeUrl);
                    }
                    /** @type {?} */
                    var cachedIcon = this._cachedIconsByUrl.get(url);
                    if (cachedIcon) {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])(cloneSvg(cachedIcon));
                    }
                    return this._loadSvgIconFromConfig(new SvgIconConfig(safeUrl)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["tap"])(( /**
                     * @param {?} svg
                     * @return {?}
                     */function (/**
                     * @param {?} svg
                     * @return {?}
                     */ svg) { return _this._cachedIconsByUrl.set(( /** @type {?} */(url)), svg); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(( /**
                     * @param {?} svg
                     * @return {?}
                     */function (/**
                     * @param {?} svg
                     * @return {?}
                     */ svg) { return cloneSvg(svg); })));
                };
                /**
                 * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
                 * and namespace. The icon must have been previously registered with addIcon or addIconSet;
                 * if not, the Observable will throw an error.
                 *
                 * @param {?} name Name of the icon to be retrieved.
                 * @param {?=} namespace Namespace in which to look for the icon.
                 * @return {?}
                 */
                MatIconRegistry.prototype.getNamedSvgIcon = function (name, namespace) {
                    if (namespace === void 0) { namespace = ''; }
                    // Return (copy of) cached icon if possible.
                    /** @type {?} */
                    var key = iconKey(namespace, name);
                    /** @type {?} */
                    var config = this._svgIconConfigs.get(key);
                    if (config) {
                        return this._getSvgFromConfig(config);
                    }
                    // See if we have any icon sets registered for the namespace.
                    /** @type {?} */
                    var iconSetConfigs = this._iconSetConfigs.get(namespace);
                    if (iconSetConfigs) {
                        return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
                    }
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(getMatIconNameNotFoundError(key));
                };
                /**
                 * @return {?}
                 */
                MatIconRegistry.prototype.ngOnDestroy = function () {
                    this._svgIconConfigs.clear();
                    this._iconSetConfigs.clear();
                    this._cachedIconsByUrl.clear();
                };
                /**
                 * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
                 * @private
                 * @param {?} config
                 * @return {?}
                 */
                MatIconRegistry.prototype._getSvgFromConfig = function (config) {
                    if (config.svgElement) {
                        // We already have the SVG element for this icon, return a copy.
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])(cloneSvg(config.svgElement));
                    }
                    else {
                        // Fetch the icon from the config's URL, cache it, and return a copy.
                        return this._loadSvgIconFromConfig(config).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["tap"])(( /**
                         * @param {?} svg
                         * @return {?}
                         */function (/**
                         * @param {?} svg
                         * @return {?}
                         */ svg) { return config.svgElement = svg; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(( /**
                         * @param {?} svg
                         * @return {?}
                         */function (/**
                         * @param {?} svg
                         * @return {?}
                         */ svg) { return cloneSvg(svg); })));
                    }
                };
                /**
                 * Attempts to find an icon with the specified name in any of the SVG icon sets.
                 * First searches the available cached icons for a nested element with a matching name, and
                 * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
                 * that have not been cached, and searches again after all fetches are completed.
                 * The returned Observable produces the SVG element if possible, and throws
                 * an error if no icon with the specified name can be found.
                 * @private
                 * @param {?} name
                 * @param {?} iconSetConfigs
                 * @return {?}
                 */
                MatIconRegistry.prototype._getSvgFromIconSetConfigs = function (name, iconSetConfigs) {
                    var _this = this;
                    // For all the icon set SVG elements we've fetched, see if any contain an icon with the
                    // requested name.
                    /** @type {?} */
                    var namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
                    if (namedIcon) {
                        // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
                        // time anyway, there's probably not much advantage compared to just always extracting
                        // it from the icon set.
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])(namedIcon);
                    }
                    // Not found in any cached icon sets. If there are icon sets with URLs that we haven't
                    // fetched, fetch them now and look for iconName in the results.
                    /** @type {?} */
                    var iconSetFetchRequests = iconSetConfigs
                        .filter(( /**
                 * @param {?} iconSetConfig
                 * @return {?}
                 */function (/**
                 * @param {?} iconSetConfig
                 * @return {?}
                 */ iconSetConfig) { return !iconSetConfig.svgElement; }))
                        .map(( /**
                 * @param {?} iconSetConfig
                 * @return {?}
                 */function (/**
                 * @param {?} iconSetConfig
                 * @return {?}
                 */ iconSetConfig) {
                        return _this._loadSvgIconSetFromConfig(iconSetConfig).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(( /**
                         * @param {?} err
                         * @return {?}
                         */function (err) {
                            /** @type {?} */
                            var url = _this._sanitizer.sanitize(_angular_core__WEBPACK_IMPORTED_MODULE_2__["SecurityContext"].RESOURCE_URL, iconSetConfig.url);
                            // Swallow errors fetching individual URLs so the
                            // combined Observable won't necessarily fail.
                            /** @type {?} */
                            var errorMessage = "Loading icon set URL: " + url + " failed: " + err.message;
                            // @breaking-change 9.0.0 _errorHandler parameter to be made required
                            if (_this._errorHandler) {
                                _this._errorHandler.handleError(new Error(errorMessage));
                            }
                            else {
                                console.error(errorMessage);
                            }
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])(null);
                        })));
                    }));
                    // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
                    // cached SVG element (unless the request failed), and we can check again for the icon.
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["forkJoin"])(iconSetFetchRequests).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
                        if (!foundIcon) {
                            throw getMatIconNameNotFoundError(name);
                        }
                        return foundIcon;
                    })));
                };
                /**
                 * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
                 * tag matches the specified name. If found, copies the nested element to a new SVG element and
                 * returns it. Returns null if no matching element is found.
                 * @private
                 * @param {?} iconName
                 * @param {?} iconSetConfigs
                 * @return {?}
                 */
                MatIconRegistry.prototype._extractIconWithNameFromAnySet = function (iconName, iconSetConfigs) {
                    // Iterate backwards, so icon sets added later have precedence.
                    for (var i = iconSetConfigs.length - 1; i >= 0; i--) {
                        /** @type {?} */
                        var config = iconSetConfigs[i];
                        if (config.svgElement) {
                            /** @type {?} */
                            var foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName, config.options);
                            if (foundIcon) {
                                return foundIcon;
                            }
                        }
                    }
                    return null;
                };
                /**
                 * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
                 * from it.
                 * @private
                 * @param {?} config
                 * @return {?}
                 */
                MatIconRegistry.prototype._loadSvgIconFromConfig = function (config) {
                    var _this = this;
                    return this._fetchUrl(config.url)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(( /**
                 * @param {?} svgText
                 * @return {?}
                 */function (/**
                 * @param {?} svgText
                 * @return {?}
                 */ svgText) { return _this._createSvgElementForSingleIcon(svgText, config.options); })));
                };
                /**
                 * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
                 * from it.
                 * @private
                 * @param {?} config
                 * @return {?}
                 */
                MatIconRegistry.prototype._loadSvgIconSetFromConfig = function (config) {
                    var _this = this;
                    // If the SVG for this icon set has already been parsed, do nothing.
                    if (config.svgElement) {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])(config.svgElement);
                    }
                    return this._fetchUrl(config.url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(( /**
                     * @param {?} svgText
                     * @return {?}
                     */function (/**
                     * @param {?} svgText
                     * @return {?}
                     */ svgText) {
                        // It is possible that the icon set was parsed and cached by an earlier request, so parsing
                        // only needs to occur if the cache is yet unset.
                        if (!config.svgElement) {
                            config.svgElement = _this._svgElementFromString(svgText);
                        }
                        return config.svgElement;
                    })));
                };
                /**
                 * Creates a DOM element from the given SVG string, and adds default attributes.
                 * @private
                 * @param {?} responseText
                 * @param {?=} options
                 * @return {?}
                 */
                MatIconRegistry.prototype._createSvgElementForSingleIcon = function (responseText, options) {
                    /** @type {?} */
                    var svg = this._svgElementFromString(responseText);
                    this._setSvgAttributes(svg, options);
                    return svg;
                };
                /**
                 * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
                 * tag matches the specified name. If found, copies the nested element to a new SVG element and
                 * returns it. Returns null if no matching element is found.
                 * @private
                 * @param {?} iconSet
                 * @param {?} iconName
                 * @param {?=} options
                 * @return {?}
                 */
                MatIconRegistry.prototype._extractSvgIconFromSet = function (iconSet, iconName, options) {
                    // Use the `id="iconName"` syntax in order to escape special
                    // characters in the ID (versus using the #iconName syntax).
                    /** @type {?} */
                    var iconSource = iconSet.querySelector("[id=\"" + iconName + "\"]");
                    if (!iconSource) {
                        return null;
                    }
                    // Clone the element and remove the ID to prevent multiple elements from being added
                    // to the page with the same ID.
                    /** @type {?} */
                    var iconElement = ( /** @type {?} */(iconSource.cloneNode(true)));
                    iconElement.removeAttribute('id');
                    // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
                    // the content of a new <svg> node.
                    if (iconElement.nodeName.toLowerCase() === 'svg') {
                        return this._setSvgAttributes(( /** @type {?} */(iconElement)), options);
                    }
                    // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
                    // that the same could be achieved by referring to it via <use href="#id">, however the <use>
                    // tag is problematic on Firefox, because it needs to include the current page path.
                    if (iconElement.nodeName.toLowerCase() === 'symbol') {
                        return this._setSvgAttributes(this._toSvgElement(iconElement), options);
                    }
                    // createElement('SVG') doesn't work as expected; the DOM ends up with
                    // the correct nodes, but the SVG content doesn't render. Instead we
                    // have to create an empty SVG node using innerHTML and append its content.
                    // Elements created using DOMParser.parseFromString have the same problem.
                    // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
                    /** @type {?} */
                    var svg = this._svgElementFromString('<svg></svg>');
                    // Clone the node so we don't remove it from the parent icon set element.
                    svg.appendChild(iconElement);
                    return this._setSvgAttributes(svg, options);
                };
                /**
                 * Creates a DOM element from the given SVG string.
                 * @private
                 * @param {?} str
                 * @return {?}
                 */
                MatIconRegistry.prototype._svgElementFromString = function (str) {
                    /** @type {?} */
                    var div = this._document.createElement('DIV');
                    div.innerHTML = str;
                    /** @type {?} */
                    var svg = ( /** @type {?} */(div.querySelector('svg')));
                    if (!svg) {
                        throw Error('<svg> tag not found');
                    }
                    return svg;
                };
                /**
                 * Converts an element into an SVG node by cloning all of its children.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                MatIconRegistry.prototype._toSvgElement = function (element) {
                    /** @type {?} */
                    var svg = this._svgElementFromString('<svg></svg>');
                    /** @type {?} */
                    var attributes = element.attributes;
                    // Copy over all the attributes from the `symbol` to the new SVG, except the id.
                    for (var i = 0; i < attributes.length; i++) {
                        var _c = attributes[i], name = _c.name, value = _c.value;
                        if (name !== 'id') {
                            svg.setAttribute(name, value);
                        }
                    }
                    for (var i = 0; i < element.childNodes.length; i++) {
                        if (element.childNodes[i].nodeType === this._document.ELEMENT_NODE) {
                            svg.appendChild(element.childNodes[i].cloneNode(true));
                        }
                    }
                    return svg;
                };
                /**
                 * Sets the default attributes for an SVG element to be used as an icon.
                 * @private
                 * @param {?} svg
                 * @param {?=} options
                 * @return {?}
                 */
                MatIconRegistry.prototype._setSvgAttributes = function (svg, options) {
                    svg.setAttribute('fit', '');
                    svg.setAttribute('height', '100%');
                    svg.setAttribute('width', '100%');
                    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
                    svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
                    if (options && options.viewBox) {
                        svg.setAttribute('viewBox', options.viewBox);
                    }
                    return svg;
                };
                /**
                 * Returns an Observable which produces the string contents of the given URL. Results may be
                 * cached, so future calls with the same URL may not cause another HTTP request.
                 * @private
                 * @param {?} safeUrl
                 * @return {?}
                 */
                MatIconRegistry.prototype._fetchUrl = function (safeUrl) {
                    var _this = this;
                    if (!this._httpClient) {
                        throw getMatIconNoHttpProviderError();
                    }
                    if (safeUrl == null) {
                        throw Error("Cannot fetch icon from URL \"" + safeUrl + "\".");
                    }
                    /** @type {?} */
                    var url = this._sanitizer.sanitize(_angular_core__WEBPACK_IMPORTED_MODULE_2__["SecurityContext"].RESOURCE_URL, safeUrl);
                    if (!url) {
                        throw getMatIconFailedToSanitizeUrlError(safeUrl);
                    }
                    // Store in-progress fetches to avoid sending a duplicate request for a URL when there is
                    // already a request in progress for that URL. It's necessary to call share() on the
                    // Observable returned by http.get() so that multiple subscribers don't cause multiple XHRs.
                    /** @type {?} */
                    var inProgressFetch = this._inProgressUrlFetches.get(url);
                    if (inProgressFetch) {
                        return inProgressFetch;
                    }
                    // TODO(jelbourn): for some reason, the `finalize` operator "loses" the generic type on the
                    // Observable. Figure out why and fix it.
                    /** @type {?} */
                    var req = this._httpClient.get(url, { responseType: 'text' }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["finalize"])(( /**
                     * @return {?}
                     */function () { return _this._inProgressUrlFetches.delete(url); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["share"])());
                    this._inProgressUrlFetches.set(url, req);
                    return req;
                };
                /**
                 * Registers an icon config by name in the specified namespace.
                 * @private
                 * @template THIS
                 * @this {THIS}
                 * @param {?} namespace Namespace in which to register the icon config.
                 * @param {?} iconName Name under which to register the config.
                 * @param {?} config Config to be registered.
                 * @return {THIS}
                 */
                MatIconRegistry.prototype._addSvgIconConfig = function (namespace, iconName, config) {
                    ( /** @type {?} */(this))._svgIconConfigs.set(iconKey(namespace, iconName), config);
                    return ( /** @type {?} */(this));
                };
                /**
                 * Registers an icon set config in the specified namespace.
                 * @private
                 * @template THIS
                 * @this {THIS}
                 * @param {?} namespace Namespace in which to register the icon config.
                 * @param {?} config Config to be registered.
                 * @return {THIS}
                 */
                MatIconRegistry.prototype._addSvgIconSetConfig = function (namespace, config) {
                    /** @type {?} */
                    var configNamespace = ( /** @type {?} */(this))._iconSetConfigs.get(namespace);
                    if (configNamespace) {
                        configNamespace.push(config);
                    }
                    else {
                        ( /** @type {?} */(this))._iconSetConfigs.set(namespace, [config]);
                    }
                    return ( /** @type {?} */(this));
                };
                return MatIconRegistry;
            }());
            MatIconRegistry.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */
            MatIconRegistry.ctorParameters = function () { return [
                { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }] },
                { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ErrorHandler"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }] }
            ]; };
            /** @nocollapse */ MatIconRegistry.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ɵɵdefineInjectable"])({ factory: function MatIconRegistry_Factory() { return new MatIconRegistry(Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ɵɵinject"])(_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], 8), Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ɵɵinject"])(_angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"], 8), Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ErrorHandler"], 8)); }, token: MatIconRegistry, providedIn: "root" });
            /**
             * \@docs-private
             * @param {?} parentRegistry
             * @param {?} httpClient
             * @param {?} sanitizer
             * @param {?=} document
             * @param {?=} errorHandler
             * @return {?}
             */
            function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, sanitizer, document, errorHandler) {
                return parentRegistry || new MatIconRegistry(httpClient, sanitizer, document, errorHandler);
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var ICON_REGISTRY_PROVIDER = {
                // If there is already an MatIconRegistry available, use that. Otherwise, provide a new one.
                provide: MatIconRegistry,
                deps: [
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_2__["SkipSelf"](), MatIconRegistry],
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"](), _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]],
                    _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"],
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"](), _angular_core__WEBPACK_IMPORTED_MODULE_2__["ErrorHandler"]],
                    [new _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"](), ( /** @type {?} */(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]))],
                ],
                useFactory: ICON_REGISTRY_PROVIDER_FACTORY,
            };
            /**
             * Clones an SVGElement while preserving type information.
             * @param {?} svg
             * @return {?}
             */
            function cloneSvg(svg) {
                return ( /** @type {?} */(svg.cloneNode(true)));
            }
            /**
             * Returns the cache key to use for an icon namespace and name.
             * @param {?} namespace
             * @param {?} name
             * @return {?}
             */
            function iconKey(namespace, name) {
                return namespace + ':' + name;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatIcon.
            /**
             * \@docs-private
             */
            var MatIconBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatIconBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatIconBase;
            }());
            /** @type {?} */
            var _MatIconMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_7__["mixinColor"])(MatIconBase);
            /**
             * Injection token used to provide the current location to `MatIcon`.
             * Used to handle server-side rendering and to stub out during unit tests.
             * \@docs-private
             * @type {?}
             */
            var MAT_ICON_LOCATION = new _angular_core__WEBPACK_IMPORTED_MODULE_2__["InjectionToken"]('mat-icon-location', {
                providedIn: 'root',
                factory: MAT_ICON_LOCATION_FACTORY
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_ICON_LOCATION_FACTORY() {
                /** @type {?} */
                var _document = Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]);
                /** @type {?} */
                var _location = _document ? _document.location : null;
                return {
                    // Note that this needs to be a function, rather than a property, because Angular
                    // will only resolve it once, but we want the current path on each call.
                    getPathname: ( /**
                     * @return {?}
                     */function () { return _location ? (_location.pathname + _location.search) : ''; })
                };
            }
            /**
             * SVG attributes that accept a FuncIRI (e.g. `url(<something>)`).
             * @type {?}
             */
            var funcIriAttributes = [
                'clip-path',
                'color-profile',
                'src',
                'cursor',
                'fill',
                'filter',
                'marker',
                'marker-start',
                'marker-mid',
                'marker-end',
                'mask',
                'stroke'
            ];
            var ɵ0 = /**
             * @param {?} attr
             * @return {?}
             */ function (/**
             * @param {?} attr
             * @return {?}
             */ attr) { return "[" + attr + "]"; };
            /**
             * Selector that can be used to find all elements that are using a `FuncIRI`.
             * @type {?}
             */
            var funcIriAttributeSelector = funcIriAttributes.map((ɵ0)).join(', ');
            /**
             * Regex that can be used to extract the id out of a FuncIRI.
             * @type {?}
             */
            var funcIriPattern = /^url\(['"]?#(.*?)['"]?\)$/;
            /**
             * Component to display an icon. It can be used in the following ways:
             *
             * - Specify the svgIcon input to load an SVG icon from a URL previously registered with the
             *   addSvgIcon, addSvgIconInNamespace, addSvgIconSet, or addSvgIconSetInNamespace methods of
             *   MatIconRegistry. If the svgIcon value contains a colon it is assumed to be in the format
             *   "[namespace]:[name]", if not the value will be the name of an icon in the default namespace.
             *   Examples:
             *     `<mat-icon svgIcon="left-arrow"></mat-icon>
             *     <mat-icon svgIcon="animals:cat"></mat-icon>`
             *
             * - Use a font ligature as an icon by putting the ligature text in the content of the `<mat-icon>`
             *   component. By default the Material icons font is used as described at
             *   http://google.github.io/material-design-icons/#icon-font-for-the-web. You can specify an
             *   alternate font by setting the fontSet input to either the CSS class to apply to use the
             *   desired font, or to an alias previously registered with MatIconRegistry.registerFontClassAlias.
             *   Examples:
             *     `<mat-icon>home</mat-icon>
             *     <mat-icon fontSet="myfont">sun</mat-icon>`
             *
             * - Specify a font glyph to be included via CSS rules by setting the fontSet input to specify the
             *   font, and the fontIcon input to specify the icon. Typically the fontIcon will specify a
             *   CSS class which causes the glyph to be displayed via a :before selector, as in
             *   https://fortawesome.github.io/Font-Awesome/examples/
             *   Example:
             *     `<mat-icon fontSet="fa" fontIcon="alarm"></mat-icon>`
             */
            var MatIcon = /** @class */ (function (_super_1) {
                __extends(MatIcon, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _iconRegistry
                 * @param {?} ariaHidden
                 * @param {?=} _location
                 * @param {?=} _errorHandler
                 */
                function MatIcon(elementRef, _iconRegistry, ariaHidden, _location, _errorHandler) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._iconRegistry = _iconRegistry;
                    _this._location = _location;
                    _this._errorHandler = _errorHandler;
                    _this._inline = false;
                    // If the user has not explicitly set aria-hidden, mark the icon as hidden, as this is
                    // the right thing to do for the majority of icon use-cases.
                    if (!ariaHidden) {
                        elementRef.nativeElement.setAttribute('aria-hidden', 'true');
                    }
                    return _this;
                }
                Object.defineProperty(MatIcon.prototype, "inline", {
                    /**
                     * Whether the icon should be inlined, automatically sizing the icon to match the font size of
                     * the element the icon is contained in.
                     * @return {?}
                     */
                    get: function () {
                        return this._inline;
                    },
                    /**
                     * @param {?} inline
                     * @return {?}
                     */
                    set: function (inline) {
                        this._inline = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_6__["coerceBooleanProperty"])(inline);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatIcon.prototype, "fontSet", {
                    /**
                     * Font set that the icon is a part of.
                     * @return {?}
                     */
                    get: function () { return this._fontSet; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._fontSet = this._cleanupFontValue(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatIcon.prototype, "fontIcon", {
                    /**
                     * Name of an icon within a font set.
                     * @return {?}
                     */
                    get: function () { return this._fontIcon; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._fontIcon = this._cleanupFontValue(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Splits an svgIcon binding value into its icon set and icon name components.
                 * Returns a 2-element array of [(icon set), (icon name)].
                 * The separator for the two fields is ':'. If there is no separator, an empty
                 * string is returned for the icon set and the entire value is returned for
                 * the icon name. If the argument is falsy, returns an array of two empty strings.
                 * Throws an error if the name contains two or more ':' separators.
                 * Examples:
                 *   `'social:cake' -> ['social', 'cake']
                 *   'penguin' -> ['', 'penguin']
                 *   null -> ['', '']
                 *   'a:b:c' -> (throws Error)`
                 * @private
                 * @param {?} iconName
                 * @return {?}
                 */
                MatIcon.prototype._splitIconName = function (iconName) {
                    if (!iconName) {
                        return ['', ''];
                    }
                    /** @type {?} */
                    var parts = iconName.split(':');
                    switch (parts.length) {
                        case 1: return ['', parts[0]]; // Use default namespace.
                        case 2: return ( /** @type {?} */(parts));
                        default: throw Error("Invalid icon name: \"" + iconName + "\"");
                    }
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatIcon.prototype.ngOnChanges = function (changes) {
                    var _this = this;
                    // Only update the inline SVG icon if the inputs changed, to avoid unnecessary DOM operations.
                    /** @type {?} */
                    var svgIconChanges = changes['svgIcon'];
                    if (svgIconChanges) {
                        if (this.svgIcon) {
                            var _c = this._splitIconName(this.svgIcon), namespace_1 = _c[0], iconName_1 = _c[1];
                            this._iconRegistry.getNamedSvgIcon(iconName_1, namespace_1)
                                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["take"])(1))
                                .subscribe(( /**
                         * @param {?} svg
                         * @return {?}
                         */function (/**
                         * @param {?} svg
                         * @return {?}
                         */ svg) { return _this._setSvgElement(svg); }), ( /**
                             * @param {?} err
                             * @return {?}
                             */function (err) {
                                /** @type {?} */
                                var errorMessage = "Error retrieving icon " + namespace_1 + ":" + iconName_1 + "! " + err.message;
                                // @breaking-change 9.0.0 _errorHandler parameter to be made required.
                                if (_this._errorHandler) {
                                    _this._errorHandler.handleError(new Error(errorMessage));
                                }
                                else {
                                    console.error(errorMessage);
                                }
                            }));
                        }
                        else if (svgIconChanges.previousValue) {
                            this._clearSvgElement();
                        }
                    }
                    if (this._usingFontIcon()) {
                        this._updateFontIconClasses();
                    }
                };
                /**
                 * @return {?}
                 */
                MatIcon.prototype.ngOnInit = function () {
                    // Update font classes because ngOnChanges won't be called if none of the inputs are present,
                    // e.g. <mat-icon>arrow</mat-icon> In this case we need to add a CSS class for the default font.
                    if (this._usingFontIcon()) {
                        this._updateFontIconClasses();
                    }
                };
                /**
                 * @return {?}
                 */
                MatIcon.prototype.ngAfterViewChecked = function () {
                    /** @type {?} */
                    var cachedElements = this._elementsWithExternalReferences;
                    if (cachedElements && this._location && cachedElements.size) {
                        /** @type {?} */
                        var newPath = this._location.getPathname();
                        // We need to check whether the URL has changed on each change detection since
                        // the browser doesn't have an API that will let us react on link clicks and
                        // we can't depend on the Angular router. The references need to be updated,
                        // because while most browsers don't care whether the URL is correct after
                        // the first render, Safari will break if the user navigates to a different
                        // page and the SVG isn't re-rendered.
                        if (newPath !== this._previousPath) {
                            this._previousPath = newPath;
                            this._prependPathToReferences(newPath);
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                MatIcon.prototype.ngOnDestroy = function () {
                    if (this._elementsWithExternalReferences) {
                        this._elementsWithExternalReferences.clear();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatIcon.prototype._usingFontIcon = function () {
                    return !this.svgIcon;
                };
                /**
                 * @private
                 * @param {?} svg
                 * @return {?}
                 */
                MatIcon.prototype._setSvgElement = function (svg) {
                    this._clearSvgElement();
                    // Workaround for IE11 and Edge ignoring `style` tags inside dynamically-created SVGs.
                    // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
                    // Do this before inserting the element into the DOM, in order to avoid a style recalculation.
                    /** @type {?} */
                    var styleTags = ( /** @type {?} */(svg.querySelectorAll('style')));
                    for (var i = 0; i < styleTags.length; i++) {
                        styleTags[i].textContent += ' ';
                    }
                    // Note: we do this fix here, rather than the icon registry, because the
                    // references have to point to the URL at the time that the icon was created.
                    if (this._location) {
                        /** @type {?} */
                        var path = this._location.getPathname();
                        this._previousPath = path;
                        this._cacheChildrenWithExternalReferences(svg);
                        this._prependPathToReferences(path);
                    }
                    this._elementRef.nativeElement.appendChild(svg);
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatIcon.prototype._clearSvgElement = function () {
                    /** @type {?} */
                    var layoutElement = this._elementRef.nativeElement;
                    /** @type {?} */
                    var childCount = layoutElement.childNodes.length;
                    if (this._elementsWithExternalReferences) {
                        this._elementsWithExternalReferences.clear();
                    }
                    // Remove existing non-element child nodes and SVGs, and add the new SVG element. Note that
                    // we can't use innerHTML, because IE will throw if the element has a data binding.
                    while (childCount--) {
                        /** @type {?} */
                        var child = layoutElement.childNodes[childCount];
                        // 1 corresponds to Node.ELEMENT_NODE. We remove all non-element nodes in order to get rid
                        // of any loose text nodes, as well as any SVG elements in order to remove any old icons.
                        if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
                            layoutElement.removeChild(child);
                        }
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatIcon.prototype._updateFontIconClasses = function () {
                    if (!this._usingFontIcon()) {
                        return;
                    }
                    /** @type {?} */
                    var elem = this._elementRef.nativeElement;
                    /** @type {?} */
                    var fontSetClass = this.fontSet ?
                        this._iconRegistry.classNameForFontAlias(this.fontSet) :
                        this._iconRegistry.getDefaultFontSetClass();
                    if (fontSetClass != this._previousFontSetClass) {
                        if (this._previousFontSetClass) {
                            elem.classList.remove(this._previousFontSetClass);
                        }
                        if (fontSetClass) {
                            elem.classList.add(fontSetClass);
                        }
                        this._previousFontSetClass = fontSetClass;
                    }
                    if (this.fontIcon != this._previousFontIconClass) {
                        if (this._previousFontIconClass) {
                            elem.classList.remove(this._previousFontIconClass);
                        }
                        if (this.fontIcon) {
                            elem.classList.add(this.fontIcon);
                        }
                        this._previousFontIconClass = this.fontIcon;
                    }
                };
                /**
                 * Cleans up a value to be used as a fontIcon or fontSet.
                 * Since the value ends up being assigned as a CSS class, we
                 * have to trim the value and omit space-separated values.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatIcon.prototype._cleanupFontValue = function (value) {
                    return typeof value === 'string' ? value.trim().split(' ')[0] : value;
                };
                /**
                 * Prepends the current path to all elements that have an attribute pointing to a `FuncIRI`
                 * reference. This is required because WebKit browsers require references to be prefixed with
                 * the current path, if the page has a `base` tag.
                 * @private
                 * @param {?} path
                 * @return {?}
                 */
                MatIcon.prototype._prependPathToReferences = function (path) {
                    /** @type {?} */
                    var elements = this._elementsWithExternalReferences;
                    if (elements) {
                        elements.forEach(( /**
                         * @param {?} attrs
                         * @param {?} element
                         * @return {?}
                         */function (attrs, element) {
                            attrs.forEach(( /**
                             * @param {?} attr
                             * @return {?}
                             */function (/**
                             * @param {?} attr
                             * @return {?}
                             */ attr) {
                                element.setAttribute(attr.name, "url('" + path + "#" + attr.value + "')");
                            }));
                        }));
                    }
                };
                /**
                 * Caches the children of an SVG element that have `url()`
                 * references that we need to prefix with the current path.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                MatIcon.prototype._cacheChildrenWithExternalReferences = function (element) {
                    /** @type {?} */
                    var elementsWithFuncIri = element.querySelectorAll(funcIriAttributeSelector);
                    /** @type {?} */
                    var elements = this._elementsWithExternalReferences =
                        this._elementsWithExternalReferences || new Map();
                    var _loop_9 = function (i) {
                        funcIriAttributes.forEach(( /**
                         * @param {?} attr
                         * @return {?}
                         */function (/**
                         * @param {?} attr
                         * @return {?}
                         */ attr) {
                            /** @type {?} */
                            var elementWithReference = elementsWithFuncIri[i];
                            /** @type {?} */
                            var value = elementWithReference.getAttribute(attr);
                            /** @type {?} */
                            var match = value ? value.match(funcIriPattern) : null;
                            if (match) {
                                /** @type {?} */
                                var attributes = elements.get(elementWithReference);
                                if (!attributes) {
                                    attributes = [];
                                    elements.set(elementWithReference, attributes);
                                }
                                ( /** @type {?} */(attributes)).push({ name: attr, value: match[1] });
                            }
                        }));
                    };
                    for (var i = 0; i < elementsWithFuncIri.length; i++) {
                        _loop_9(i);
                    }
                };
                return MatIcon;
            }(_MatIconMixinBase));
            MatIcon.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"], args: [{ template: '<ng-content></ng-content>',
                            selector: 'mat-icon',
                            exportAs: 'matIcon',
                            styles: [".mat-icon{background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px}.mat-icon.mat-icon-inline{font-size:inherit;height:inherit;line-height:inherit;width:inherit}[dir=rtl] .mat-icon-rtl-mirror{transform:scale(-1,1)}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon{display:block}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-icon{margin:auto}"],
                            inputs: ['color'],
                            host: {
                                'role': 'img',
                                'class': 'mat-icon notranslate',
                                '[class.mat-icon-inline]': 'inline',
                                '[class.mat-icon-no-color]': 'color !== "primary" && color !== "accent" && color !== "warn"',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatIcon.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"] },
                { type: MatIconRegistry },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Attribute"], args: ['aria-hidden',] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [MAT_ICON_LOCATION,] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ErrorHandler"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Optional"] }] }
            ]; };
            MatIcon.propDecorators = {
                inline: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }],
                svgIcon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }],
                fontSet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }],
                fontIcon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatIconModule = /** @class */ (function () {
                function MatIconModule() {
                }
                return MatIconModule;
            }());
            MatIconModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatCommonModule"]],
                            exports: [MatIcon, _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatCommonModule"]],
                            declarations: [MatIcon],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=icon.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/input.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/input.js ***!
          \*********************************************************/
        /*! exports provided: MatTextareaAutosize, MatInput, getMatInputUnsupportedTypeError, MatInputModule, MAT_INPUT_VALUE_ACCESSOR */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTextareaAutosize", function () { return MatTextareaAutosize; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatInput", function () { return MatInput; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatInputUnsupportedTypeError", function () { return getMatInputUnsupportedTypeError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatInputModule", function () { return MatInputModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_INPUT_VALUE_ACCESSOR", function () { return MAT_INPUT_VALUE_ACCESSOR; });
            /* harmony import */ var _angular_cdk_text_field__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/text-field */ "./node_modules/@angular/cdk/esm2015/text-field.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Directive to automatically resize a textarea to fit its content.
             * @deprecated Use `cdkTextareaAutosize` from `\@angular/cdk/text-field` instead.
             * \@breaking-change 8.0.0
             */
            var MatTextareaAutosize = /** @class */ (function (_super_1) {
                __extends(MatTextareaAutosize, _super_1);
                function MatTextareaAutosize() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                Object.defineProperty(MatTextareaAutosize.prototype, "matAutosizeMinRows", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.minRows; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this.minRows = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTextareaAutosize.prototype, "matAutosizeMaxRows", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.maxRows; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this.maxRows = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTextareaAutosize.prototype, "matAutosize", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.enabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this.enabled = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTextareaAutosize.prototype, "matTextareaAutosize", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.enabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this.enabled = value; },
                    enumerable: true,
                    configurable: true
                });
                return MatTextareaAutosize;
            }(_angular_cdk_text_field__WEBPACK_IMPORTED_MODULE_0__["CdkTextareaAutosize"]));
            MatTextareaAutosize.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'textarea[mat-autosize], textarea[matTextareaAutosize]',
                            exportAs: 'matTextareaAutosize',
                            inputs: ['cdkAutosizeMinRows', 'cdkAutosizeMaxRows'],
                            host: {
                                'class': 'cdk-textarea-autosize mat-autosize',
                                // Textarea elements that have the directive applied should have a single row by default.
                                // Browsers normally show two rows by default and therefore this limits the minRows binding.
                                'rows': '1',
                                '(input)': '_noopInputHandler()',
                            },
                        },] },
            ];
            MatTextareaAutosize.propDecorators = {
                matAutosizeMinRows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                matAutosizeMaxRows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                matAutosize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['mat-autosize',] }],
                matTextareaAutosize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             * @param {?} type
             * @return {?}
             */
            function getMatInputUnsupportedTypeError(type) {
                return Error("Input type \"" + type + "\" isn't supported by matInput.");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This token is used to inject the object whose value should be set into `MatInput`. If none is
             * provided, the native `HTMLInputElement` is used. Directives like `MatDatepickerInput` can provide
             * themselves for this token, in order to make `MatInput` delegate the getting and setting of the
             * value to them.
             * @type {?}
             */
            var MAT_INPUT_VALUE_ACCESSOR = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('MAT_INPUT_VALUE_ACCESSOR');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Invalid input type. Using one of these will throw an MatInputUnsupportedTypeError.
            /** @type {?} */
            var MAT_INPUT_INVALID_TYPES = [
                'button',
                'checkbox',
                'file',
                'hidden',
                'image',
                'radio',
                'range',
                'reset',
                'submit'
            ];
            /** @type {?} */
            var nextUniqueId = 0;
            // Boilerplate for applying mixins to MatInput.
            /**
             * \@docs-private
             */
            var MatInputBase = /** @class */ (function () {
                /**
                 * @param {?} _defaultErrorStateMatcher
                 * @param {?} _parentForm
                 * @param {?} _parentFormGroup
                 * @param {?} ngControl
                 */
                function MatInputBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
                    this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
                    this._parentForm = _parentForm;
                    this._parentFormGroup = _parentFormGroup;
                    this.ngControl = ngControl;
                }
                return MatInputBase;
            }());
            /** @type {?} */
            var _MatInputMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinErrorState"])(MatInputBase);
            /**
             * Directive that allows a native input to work inside a `MatFormField`.
             */
            var MatInput = /** @class */ (function (_super_1) {
                __extends(MatInput, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _platform
                 * @param {?} ngControl
                 * @param {?} _parentForm
                 * @param {?} _parentFormGroup
                 * @param {?} _defaultErrorStateMatcher
                 * @param {?} inputValueAccessor
                 * @param {?} _autofillMonitor
                 * @param {?} ngZone
                 */
                function MatInput(_elementRef, _platform, ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, inputValueAccessor, _autofillMonitor, ngZone) {
                    var _this = _super_1.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
                    _this._elementRef = _elementRef;
                    _this._platform = _platform;
                    _this.ngControl = ngControl;
                    _this._autofillMonitor = _autofillMonitor;
                    _this._uid = "mat-input-" + nextUniqueId++;
                    /**
                     * Whether the component is being rendered on the server.
                     */
                    _this._isServer = false;
                    /**
                     * Whether the component is a native html select.
                     */
                    _this._isNativeSelect = false;
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     */
                    _this.focused = false;
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     */
                    _this.stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_7__["Subject"]();
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     */
                    _this.controlType = 'mat-input';
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     */
                    _this.autofilled = false;
                    _this._disabled = false;
                    _this._required = false;
                    _this._type = 'text';
                    _this._readonly = false;
                    _this._neverEmptyInputTypes = [
                        'date',
                        'datetime',
                        'datetime-local',
                        'month',
                        'time',
                        'week'
                    ].filter(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_3__["getSupportedInputTypes"])().has(t); }));
                    /** @type {?} */
                    var element = _this._elementRef.nativeElement;
                    // If no input value accessor was explicitly specified, use the element as the input value
                    // accessor.
                    _this._inputValueAccessor = inputValueAccessor || element;
                    _this._previousNativeValue = _this.value;
                    // Force setter to be called in case id was not specified.
                    _this.id = _this.id;
                    // On some versions of iOS the caret gets stuck in the wrong place when holding down the delete
                    // key. In order to get around this we need to "jiggle" the caret loose. Since this bug only
                    // exists on iOS, we only bother to install the listener on iOS.
                    if (_platform.IOS) {
                        ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            _elementRef.nativeElement.addEventListener('keyup', ( /**
                             * @param {?} event
                             * @return {?}
                             */function (event) {
                                /** @type {?} */
                                var el = ( /** @type {?} */(event.target));
                                if (!el.value && !el.selectionStart && !el.selectionEnd) {
                                    // Note: Just setting `0, 0` doesn't fix the issue. Setting
                                    // `1, 1` fixes it for the first time that you type text and
                                    // then hold delete. Toggling to `1, 1` and then back to
                                    // `0, 0` seems to completely fix it.
                                    el.setSelectionRange(1, 1);
                                    el.setSelectionRange(0, 0);
                                }
                            }));
                        }));
                    }
                    _this._isServer = !_this._platform.isBrowser;
                    _this._isNativeSelect = element.nodeName.toLowerCase() === 'select';
                    if (_this._isNativeSelect) {
                        _this.controlType = (( /** @type {?} */(element))).multiple ? 'mat-native-select-multiple' :
                            'mat-native-select';
                    }
                    return _this;
                }
                Object.defineProperty(MatInput.prototype, "disabled", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        if (this.ngControl && this.ngControl.disabled !== null) {
                            return this.ngControl.disabled;
                        }
                        return this._disabled;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                        // Browsers may not fire the blur event if the input is disabled too quickly.
                        // Reset from here to ensure that the element doesn't become stuck.
                        if (this.focused) {
                            this.focused = false;
                            this.stateChanges.next();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatInput.prototype, "id", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this._id; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._id = value || this._uid; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatInput.prototype, "required", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatInput.prototype, "type", {
                    /**
                     * Input type of the element.
                     * @return {?}
                     */
                    get: function () { return this._type; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._type = value || 'text';
                        this._validateType();
                        // When using Angular inputs, developers are no longer able to set the properties on the native
                        // input element. To ensure that bindings for `type` work, we need to sync the setter
                        // with the native property. Textarea elements don't support the type property or attribute.
                        if (!this._isTextarea() && Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_3__["getSupportedInputTypes"])().has(this._type)) {
                            (( /** @type {?} */(this._elementRef.nativeElement))).type = this._type;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatInput.prototype, "value", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () { return this._inputValueAccessor.value; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== this.value) {
                            this._inputValueAccessor.value = value;
                            this.stateChanges.next();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatInput.prototype, "readonly", {
                    /**
                     * Whether the element is readonly.
                     * @return {?}
                     */
                    get: function () { return this._readonly; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._readonly = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatInput.prototype.ngOnInit = function () {
                    var _this = this;
                    if (this._platform.isBrowser) {
                        this._autofillMonitor.monitor(this._elementRef.nativeElement).subscribe(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) {
                            _this.autofilled = event.isAutofilled;
                            _this.stateChanges.next();
                        }));
                    }
                };
                /**
                 * @return {?}
                 */
                MatInput.prototype.ngOnChanges = function () {
                    this.stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatInput.prototype.ngOnDestroy = function () {
                    this.stateChanges.complete();
                    if (this._platform.isBrowser) {
                        this._autofillMonitor.stopMonitoring(this._elementRef.nativeElement);
                    }
                };
                /**
                 * @return {?}
                 */
                MatInput.prototype.ngDoCheck = function () {
                    if (this.ngControl) {
                        // We need to re-evaluate this on every change detection cycle, because there are some
                        // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                        // that whatever logic is in here has to be super lean or we risk destroying the performance.
                        this.updateErrorState();
                    }
                    // We need to dirty-check the native element's value, because there are some cases where
                    // we won't be notified when it changes (e.g. the consumer isn't using forms or they're
                    // updating the value using `emitEvent: false`).
                    this._dirtyCheckNativeValue();
                };
                /**
                 * Focuses the input.
                 * @param {?=} options
                 * @return {?}
                 */
                MatInput.prototype.focus = function (options) {
                    this._elementRef.nativeElement.focus(options);
                };
                /**
                 * Callback for the cases where the focused state of the input changes.
                 * @param {?} isFocused
                 * @return {?}
                 */
                MatInput.prototype._focusChanged = function (isFocused) {
                    if (isFocused !== this.focused && (!this.readonly || !isFocused)) {
                        this.focused = isFocused;
                        this.stateChanges.next();
                    }
                };
                /**
                 * @return {?}
                 */
                MatInput.prototype._onInput = function () {
                    // This is a noop function and is used to let Angular know whenever the value changes.
                    // Angular will run a new change detection each time the `input` event has been dispatched.
                    // It's necessary that Angular recognizes the value change, because when floatingLabel
                    // is set to false and Angular forms aren't used, the placeholder won't recognize the
                    // value changes and will not disappear.
                    // Listening to the input event wouldn't be necessary when the input is using the
                    // FormsModule or ReactiveFormsModule, because Angular forms also listens to input events.
                };
                /**
                 * Does some manual dirty checking on the native input `value` property.
                 * @protected
                 * @return {?}
                 */
                MatInput.prototype._dirtyCheckNativeValue = function () {
                    /** @type {?} */
                    var newValue = this._elementRef.nativeElement.value;
                    if (this._previousNativeValue !== newValue) {
                        this._previousNativeValue = newValue;
                        this.stateChanges.next();
                    }
                };
                /**
                 * Make sure the input is a supported type.
                 * @protected
                 * @return {?}
                 */
                MatInput.prototype._validateType = function () {
                    if (MAT_INPUT_INVALID_TYPES.indexOf(this._type) > -1) {
                        throw getMatInputUnsupportedTypeError(this._type);
                    }
                };
                /**
                 * Checks whether the input type is one of the types that are never empty.
                 * @protected
                 * @return {?}
                 */
                MatInput.prototype._isNeverEmpty = function () {
                    return this._neverEmptyInputTypes.indexOf(this._type) > -1;
                };
                /**
                 * Checks whether the input is invalid based on the native validation.
                 * @protected
                 * @return {?}
                 */
                MatInput.prototype._isBadInput = function () {
                    // The `validity` property won't be present on platform-server.
                    /** @type {?} */
                    var validity = (( /** @type {?} */(this._elementRef.nativeElement))).validity;
                    return validity && validity.badInput;
                };
                /**
                 * Determines if the component host is a textarea.
                 * @protected
                 * @return {?}
                 */
                MatInput.prototype._isTextarea = function () {
                    return this._elementRef.nativeElement.nodeName.toLowerCase() === 'textarea';
                };
                Object.defineProperty(MatInput.prototype, "empty", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return !this._isNeverEmpty() && !this._elementRef.nativeElement.value && !this._isBadInput() &&
                            !this.autofilled;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatInput.prototype, "shouldLabelFloat", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        if (this._isNativeSelect) {
                            // For a single-selection `<select>`, the label should float when the selected option has
                            // a non-empty display value. For a `<select multiple>`, the label *always* floats to avoid
                            // overlapping the label with the options.
                            /** @type {?} */
                            var selectElement = ( /** @type {?} */(this._elementRef.nativeElement));
                            /** @type {?} */
                            var firstOption = selectElement.options[0];
                            // On most browsers the `selectedIndex` will always be 0, however on IE and Edge it'll be
                            // -1 if the `value` is set to something, that isn't in the list of options, at a later point.
                            return this.focused || selectElement.multiple || !this.empty ||
                                !!(selectElement.selectedIndex > -1 && firstOption && firstOption.label);
                        }
                        else {
                            return this.focused || !this.empty;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Implemented as part of MatFormFieldControl.
                 * \@docs-private
                 * @param {?} ids
                 * @return {?}
                 */
                MatInput.prototype.setDescribedByIds = function (ids) {
                    this._ariaDescribedby = ids.join(' ');
                };
                /**
                 * Implemented as part of MatFormFieldControl.
                 * \@docs-private
                 * @return {?}
                 */
                MatInput.prototype.onContainerClick = function () {
                    // Do not re-focus the input element if the element is already focused. Otherwise it can happen
                    // that someone clicks on a time input and the cursor resets to the "hours" field while the
                    // "minutes" field was actually clicked. See: https://github.com/angular/components/issues/12849
                    if (!this.focused) {
                        this.focus();
                    }
                };
                return MatInput;
            }(_MatInputMixinBase));
            MatInput.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: "input[matInput], textarea[matInput], select[matNativeControl],\n      input[matNativeControl], textarea[matNativeControl]",
                            exportAs: 'matInput',
                            host: {
                                /**
                                 * \@breaking-change 8.0.0 remove .mat-form-field-autofill-control in favor of AutofillMonitor.
                                 */
                                'class': 'mat-input-element mat-form-field-autofill-control',
                                '[class.mat-input-server]': '_isServer',
                                // Native input properties that are overwritten by Angular inputs need to be synced with
                                // the native input element. Otherwise property bindings for those don't work.
                                '[attr.id]': 'id',
                                '[attr.placeholder]': 'placeholder',
                                '[disabled]': 'disabled',
                                '[required]': 'required',
                                '[attr.readonly]': 'readonly && !_isNativeSelect || null',
                                '[attr.aria-describedby]': '_ariaDescribedby || null',
                                '[attr.aria-invalid]': 'errorState',
                                '[attr.aria-required]': 'required.toString()',
                                '(blur)': '_focusChanged(false)',
                                '(focus)': '_focusChanged(true)',
                                '(input)': '_onInput()',
                            },
                            providers: [{ provide: _angular_material_form_field__WEBPACK_IMPORTED_MODULE_6__["MatFormFieldControl"], useExisting: MatInput }],
                        },] },
            ];
            /** @nocollapse */
            MatInput.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_3__["Platform"] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NgControl"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Self"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NgForm"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroupDirective"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["ErrorStateMatcher"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [MAT_INPUT_VALUE_ACCESSOR,] }] },
                { type: _angular_cdk_text_field__WEBPACK_IMPORTED_MODULE_0__["AutofillMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
            ]; };
            MatInput.propDecorators = {
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                placeholder: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                type: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                errorStateMatcher: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                readonly: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatInputModule = /** @class */ (function () {
                function MatInputModule() {
                }
                return MatInputModule;
            }());
            MatInputModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            declarations: [MatInput, MatTextareaAutosize],
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_8__["CommonModule"],
                                _angular_cdk_text_field__WEBPACK_IMPORTED_MODULE_0__["TextFieldModule"],
                                _angular_material_form_field__WEBPACK_IMPORTED_MODULE_6__["MatFormFieldModule"],
                            ],
                            exports: [
                                _angular_cdk_text_field__WEBPACK_IMPORTED_MODULE_0__["TextFieldModule"],
                                // We re-export the `MatFormFieldModule` since `MatInput` will almost always
                                // be used together with `MatFormField`.
                                _angular_material_form_field__WEBPACK_IMPORTED_MODULE_6__["MatFormFieldModule"],
                                MatInput,
                                MatTextareaAutosize,
                            ],
                            providers: [_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["ErrorStateMatcher"]],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=input.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/list.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/list.js ***!
          \********************************************************/
        /*! exports provided: MatListModule, MatNavList, MatList, MatListAvatarCssMatStyler, MatListIconCssMatStyler, MatListSubheaderCssMatStyler, MatListItem, MAT_SELECTION_LIST_VALUE_ACCESSOR, MatSelectionListChange, MatListOption, MatSelectionList */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatListModule", function () { return MatListModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatNavList", function () { return MatNavList; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatList", function () { return MatList; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatListAvatarCssMatStyler", function () { return MatListAvatarCssMatStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatListIconCssMatStyler", function () { return MatListIconCssMatStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatListSubheaderCssMatStyler", function () { return MatListSubheaderCssMatStyler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatListItem", function () { return MatListItem; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECTION_LIST_VALUE_ACCESSOR", function () { return MAT_SELECTION_LIST_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSelectionListChange", function () { return MatSelectionListChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatListOption", function () { return MatListOption; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSelectionList", function () { return MatSelectionList; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/divider */ "./node_modules/@angular/material/esm2015/divider.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatList.
            /**
             * \@docs-private
             */
            var MatListBase = /** @class */ (function () {
                function MatListBase() {
                }
                return MatListBase;
            }());
            /** @type {?} */
            var _MatListMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["mixinDisableRipple"])(MatListBase);
            // Boilerplate for applying mixins to MatListItem.
            /**
             * \@docs-private
             */
            var MatListItemBase = /** @class */ (function () {
                function MatListItemBase() {
                }
                return MatListItemBase;
            }());
            /** @type {?} */
            var _MatListItemMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["mixinDisableRipple"])(MatListItemBase);
            var MatNavList = /** @class */ (function (_super_1) {
                __extends(MatNavList, _super_1);
                function MatNavList() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * Emits when the state of the list changes.
                     */
                    _this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatNavList.prototype.ngOnChanges = function () {
                    this._stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatNavList.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                return MatNavList;
            }(_MatListMixinBase));
            MatNavList.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-nav-list',
                            exportAs: 'matNavList',
                            host: {
                                'role': 'navigation',
                                'class': 'mat-nav-list mat-list-base'
                            },
                            template: "<ng-content></ng-content>",
                            styles: [".mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list-base .mat-subheader{margin:0}.mat-list-base{padding-top:8px;display:block;-webkit-tap-highlight-color:transparent}.mat-list-base .mat-subheader{height:48px;line-height:16px}.mat-list-base .mat-subheader:first-child{margin-top:-8px}.mat-list-base .mat-list-item,.mat-list-base .mat-list-option{display:block;height:48px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.mat-list-base .mat-list-item .mat-list-item-content,.mat-list-base .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base .mat-list-item .mat-list-item-content-reverse,.mat-list-base .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base .mat-list-item .mat-list-item-ripple,.mat-list-base .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar,.mat-list-base .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list-base .mat-list-item.mat-2-line,.mat-list-base .mat-list-option.mat-2-line{height:72px}.mat-list-base .mat-list-item.mat-3-line,.mat-list-base .mat-list-option.mat-3-line{height:88px}.mat-list-base .mat-list-item.mat-multi-line,.mat-list-base .mat-list-option.mat-multi-line{height:auto}.mat-list-base .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base .mat-list-item .mat-list-text,.mat-list-base .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base .mat-list-item .mat-list-text>*,.mat-list-base .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list-base .mat-list-item .mat-list-text:empty,.mat-list-base .mat-list-option .mat-list-text:empty{display:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base .mat-list-item .mat-list-avatar,.mat-list-base .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%;object-fit:cover}.mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list-base .mat-list-item .mat-list-icon,.mat-list-base .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list-base .mat-list-item .mat-divider,.mat-list-base .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base .mat-list-item .mat-divider,[dir=rtl] .mat-list-base .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list-base[dense]{padding-top:4px;display:block}.mat-list-base[dense] .mat-subheader{height:40px;line-height:8px}.mat-list-base[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list-base[dense] .mat-list-item,.mat-list-base[dense] .mat-list-option{display:block;height:40px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-item-content,.mat-list-base[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list-base[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base[dense] .mat-list-item .mat-list-item-ripple,.mat-list-base[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list-base[dense] .mat-list-item.mat-2-line,.mat-list-base[dense] .mat-list-option.mat-2-line{height:60px}.mat-list-base[dense] .mat-list-item.mat-3-line,.mat-list-base[dense] .mat-list-option.mat-3-line{height:76px}.mat-list-base[dense] .mat-list-item.mat-multi-line,.mat-list-base[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list-base[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base[dense] .mat-list-item .mat-list-text,.mat-list-base[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-text>*,.mat-list-base[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list-base[dense] .mat-list-item .mat-list-text:empty,.mat-list-base[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base[dense] .mat-list-item .mat-list-avatar,.mat-list-base[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%;object-fit:cover}.mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list-base[dense] .mat-list-item .mat-list-icon,.mat-list-base[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list-base[dense] .mat-list-item .mat-divider,.mat-list-base[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}mat-action-list button{background:0 0;color:inherit;border:none;font:inherit;outline:inherit;-webkit-tap-highlight-color:transparent;text-align:left}[dir=rtl] mat-action-list button{text-align:right}mat-action-list button::-moz-focus-inner{border:0}mat-action-list .mat-list-item{cursor:pointer;outline:inherit}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}@media (-ms-high-contrast:active){.mat-selection-list:focus{outline-style:dotted}.mat-list-option:focus,.mat-list-option:hover,.mat-nav-list .mat-list-item:focus,.mat-nav-list .mat-list-item:hover,mat-action-list .mat-list-item:focus,mat-action-list .mat-list-item:hover{outline:dotted 1px}}@media (hover:none){.mat-action-list .mat-list-item:not(.mat-list-item-disabled):hover,.mat-list-option:not(.mat-list-item-disabled):hover,.mat-nav-list .mat-list-item:not(.mat-list-item-disabled):hover{background:0 0}}"],
                            inputs: ['disableRipple'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            var MatList = /** @class */ (function (_super_1) {
                __extends(MatList, _super_1);
                /**
                 * @param {?} _elementRef
                 */
                function MatList(_elementRef) {
                    var _this = _super_1.call(this) || this;
                    _this._elementRef = _elementRef;
                    /**
                     * Emits when the state of the list changes.
                     */
                    _this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    if (_this._getListType() === 'action-list') {
                        _elementRef.nativeElement.classList.add('mat-action-list');
                    }
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatList.prototype._getListType = function () {
                    /** @type {?} */
                    var nodeName = this._elementRef.nativeElement.nodeName.toLowerCase();
                    if (nodeName === 'mat-list') {
                        return 'list';
                    }
                    if (nodeName === 'mat-action-list') {
                        return 'action-list';
                    }
                    return null;
                };
                /**
                 * @return {?}
                 */
                MatList.prototype.ngOnChanges = function () {
                    this._stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatList.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                return MatList;
            }(_MatListMixinBase));
            MatList.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-list, mat-action-list',
                            exportAs: 'matList',
                            template: "<ng-content></ng-content>",
                            host: {
                                'class': 'mat-list mat-list-base'
                            },
                            styles: [".mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list-base .mat-subheader{margin:0}.mat-list-base{padding-top:8px;display:block;-webkit-tap-highlight-color:transparent}.mat-list-base .mat-subheader{height:48px;line-height:16px}.mat-list-base .mat-subheader:first-child{margin-top:-8px}.mat-list-base .mat-list-item,.mat-list-base .mat-list-option{display:block;height:48px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.mat-list-base .mat-list-item .mat-list-item-content,.mat-list-base .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base .mat-list-item .mat-list-item-content-reverse,.mat-list-base .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base .mat-list-item .mat-list-item-ripple,.mat-list-base .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar,.mat-list-base .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list-base .mat-list-item.mat-2-line,.mat-list-base .mat-list-option.mat-2-line{height:72px}.mat-list-base .mat-list-item.mat-3-line,.mat-list-base .mat-list-option.mat-3-line{height:88px}.mat-list-base .mat-list-item.mat-multi-line,.mat-list-base .mat-list-option.mat-multi-line{height:auto}.mat-list-base .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base .mat-list-item .mat-list-text,.mat-list-base .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base .mat-list-item .mat-list-text>*,.mat-list-base .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list-base .mat-list-item .mat-list-text:empty,.mat-list-base .mat-list-option .mat-list-text:empty{display:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base .mat-list-item .mat-list-avatar,.mat-list-base .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%;object-fit:cover}.mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list-base .mat-list-item .mat-list-icon,.mat-list-base .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list-base .mat-list-item .mat-divider,.mat-list-base .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base .mat-list-item .mat-divider,[dir=rtl] .mat-list-base .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list-base[dense]{padding-top:4px;display:block}.mat-list-base[dense] .mat-subheader{height:40px;line-height:8px}.mat-list-base[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list-base[dense] .mat-list-item,.mat-list-base[dense] .mat-list-option{display:block;height:40px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-item-content,.mat-list-base[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list-base[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base[dense] .mat-list-item .mat-list-item-ripple,.mat-list-base[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list-base[dense] .mat-list-item.mat-2-line,.mat-list-base[dense] .mat-list-option.mat-2-line{height:60px}.mat-list-base[dense] .mat-list-item.mat-3-line,.mat-list-base[dense] .mat-list-option.mat-3-line{height:76px}.mat-list-base[dense] .mat-list-item.mat-multi-line,.mat-list-base[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list-base[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base[dense] .mat-list-item .mat-list-text,.mat-list-base[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-text>*,.mat-list-base[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list-base[dense] .mat-list-item .mat-list-text:empty,.mat-list-base[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base[dense] .mat-list-item .mat-list-avatar,.mat-list-base[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%;object-fit:cover}.mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list-base[dense] .mat-list-item .mat-list-icon,.mat-list-base[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list-base[dense] .mat-list-item .mat-divider,.mat-list-base[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}mat-action-list button{background:0 0;color:inherit;border:none;font:inherit;outline:inherit;-webkit-tap-highlight-color:transparent;text-align:left}[dir=rtl] mat-action-list button{text-align:right}mat-action-list button::-moz-focus-inner{border:0}mat-action-list .mat-list-item{cursor:pointer;outline:inherit}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}@media (-ms-high-contrast:active){.mat-selection-list:focus{outline-style:dotted}.mat-list-option:focus,.mat-list-option:hover,.mat-nav-list .mat-list-item:focus,.mat-nav-list .mat-list-item:hover,mat-action-list .mat-list-item:focus,mat-action-list .mat-list-item:hover{outline:dotted 1px}}@media (hover:none){.mat-action-list .mat-list-item:not(.mat-list-item-disabled):hover,.mat-list-option:not(.mat-list-item-disabled):hover,.mat-nav-list .mat-list-item:not(.mat-list-item-disabled):hover{background:0 0}}"],
                            inputs: ['disableRipple'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatList.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            /**
             * Directive whose purpose is to add the mat- CSS styling to this selector.
             * \@docs-private
             */
            var MatListAvatarCssMatStyler = /** @class */ (function () {
                function MatListAvatarCssMatStyler() {
                }
                return MatListAvatarCssMatStyler;
            }());
            MatListAvatarCssMatStyler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-list-avatar], [matListAvatar]',
                            host: { 'class': 'mat-list-avatar' }
                        },] },
            ];
            /**
             * Directive whose purpose is to add the mat- CSS styling to this selector.
             * \@docs-private
             */
            var MatListIconCssMatStyler = /** @class */ (function () {
                function MatListIconCssMatStyler() {
                }
                return MatListIconCssMatStyler;
            }());
            MatListIconCssMatStyler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-list-icon], [matListIcon]',
                            host: { 'class': 'mat-list-icon' }
                        },] },
            ];
            /**
             * Directive whose purpose is to add the mat- CSS styling to this selector.
             * \@docs-private
             */
            var MatListSubheaderCssMatStyler = /** @class */ (function () {
                function MatListSubheaderCssMatStyler() {
                }
                return MatListSubheaderCssMatStyler;
            }());
            MatListSubheaderCssMatStyler.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-subheader], [matSubheader]',
                            host: { 'class': 'mat-subheader' }
                        },] },
            ];
            /**
             * An item within a Material Design list.
             */
            var MatListItem = /** @class */ (function (_super_1) {
                __extends(MatListItem, _super_1);
                /**
                 * @param {?} _element
                 * @param {?} _changeDetectorRef
                 * @param {?=} navList
                 * @param {?=} list
                 */
                function MatListItem(_element, _changeDetectorRef, navList, list) {
                    var _this = _super_1.call(this) || this;
                    _this._element = _element;
                    _this._isInteractiveList = false;
                    _this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    _this._isInteractiveList = !!(navList || (list && list._getListType() === 'action-list'));
                    _this._list = navList || list;
                    // If no type attributed is specified for <button>, set it to "button".
                    // If a type attribute is already specified, do nothing.
                    /** @type {?} */
                    var element = _this._getHostElement();
                    if (element.nodeName.toLowerCase() === 'button' && !element.hasAttribute('type')) {
                        element.setAttribute('type', 'button');
                    }
                    if (_this._list) {
                        // React to changes in the state of the parent list since
                        // some of the item's properties depend on it (e.g. `disableRipple`).
                        _this._list._stateChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(_this._destroyed)).subscribe(( /**
                         * @return {?}
                         */function () {
                            _changeDetectorRef.markForCheck();
                        }));
                    }
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatListItem.prototype.ngAfterContentInit = function () {
                    Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["setLines"])(this._lines, this._element);
                };
                /**
                 * @return {?}
                 */
                MatListItem.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Whether this list item should show a ripple effect when clicked.
                 * @return {?}
                 */
                MatListItem.prototype._isRippleDisabled = function () {
                    return !this._isInteractiveList || this.disableRipple ||
                        !!(this._list && this._list.disableRipple);
                };
                /**
                 * Retrieves the DOM element of the component host.
                 * @return {?}
                 */
                MatListItem.prototype._getHostElement = function () {
                    return this._element.nativeElement;
                };
                return MatListItem;
            }(_MatListItemMixinBase));
            MatListItem.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-list-item, a[mat-list-item], button[mat-list-item]',
                            exportAs: 'matListItem',
                            host: {
                                'class': 'mat-list-item',
                                // @breaking-change 8.0.0 Remove `mat-list-item-avatar` in favor of `mat-list-item-with-avatar`.
                                '[class.mat-list-item-avatar]': '_avatar || _icon',
                                '[class.mat-list-item-with-avatar]': '_avatar || _icon',
                            },
                            inputs: ['disableRipple'],
                            template: "<div class=\"mat-list-item-content\"><div class=\"mat-list-item-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"_isRippleDisabled()\"></div><ng-content select=\"[mat-list-avatar], [mat-list-icon], [matListAvatar], [matListIcon]\"></ng-content><div class=\"mat-list-text\"><ng-content select=\"[mat-line], [matLine]\"></ng-content></div><ng-content></ng-content></div>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatListItem.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: MatNavList, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: MatList, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatListItem.propDecorators = {
                _lines: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLine"], { descendants: true },] }],
                _avatar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatListAvatarCssMatStyler, { static: false },] }],
                _icon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatListIconCssMatStyler, { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             */
            var MatSelectionListBase = /** @class */ (function () {
                function MatSelectionListBase() {
                }
                return MatSelectionListBase;
            }());
            /** @type {?} */
            var _MatSelectionListMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["mixinDisableRipple"])(MatSelectionListBase);
            /**
             * \@docs-private
             */
            var MatListOptionBase = /** @class */ (function () {
                function MatListOptionBase() {
                }
                return MatListOptionBase;
            }());
            /** @type {?} */
            var _MatListOptionMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["mixinDisableRipple"])(MatListOptionBase);
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_SELECTION_LIST_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_8__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatSelectionList; })),
                multi: true
            };
            /**
             * Change event that is being fired whenever the selected state of an option changes.
             */
            var MatSelectionListChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} option
                 */
                function MatSelectionListChange(source, option) {
                    this.source = source;
                    this.option = option;
                }
                return MatSelectionListChange;
            }());
            /**
             * Component for list-options of selection-list. Each list-option can automatically
             * generate a checkbox and can put current item into the selectionModel of selection-list
             * if the current item is selected.
             */
            var MatListOption = /** @class */ (function (_super_1) {
                __extends(MatListOption, _super_1);
                /**
                 * @param {?} _element
                 * @param {?} _changeDetector
                 * @param {?} selectionList
                 */
                function MatListOption(_element, _changeDetector, selectionList) {
                    var _this = _super_1.call(this) || this;
                    _this._element = _element;
                    _this._changeDetector = _changeDetector;
                    _this.selectionList = selectionList;
                    _this._selected = false;
                    _this._disabled = false;
                    _this._hasFocus = false;
                    /**
                     * Whether the label should appear before or after the checkbox. Defaults to 'after'
                     */
                    _this.checkboxPosition = 'after';
                    return _this;
                }
                Object.defineProperty(MatListOption.prototype, "color", {
                    /**
                     * Theme color of the list option. This sets the color of the checkbox.
                     * @return {?}
                     */
                    get: function () { return this._color || this.selectionList.color; },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) { this._color = newValue; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatListOption.prototype, "value", {
                    /**
                     * Value of the option
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) {
                        if (this.selected && newValue !== this.value) {
                            this.selected = false;
                        }
                        this._value = newValue;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatListOption.prototype, "disabled", {
                    /**
                     * Whether the option is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled || (this.selectionList && this.selectionList.disabled); },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newValue = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__["coerceBooleanProperty"])(value);
                        if (newValue !== this._disabled) {
                            this._disabled = newValue;
                            this._changeDetector.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatListOption.prototype, "selected", {
                    /**
                     * Whether the option is selected.
                     * @return {?}
                     */
                    get: function () { return this.selectionList.selectedOptions.isSelected(this); },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var isSelected = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__["coerceBooleanProperty"])(value);
                        if (isSelected !== this._selected) {
                            this._setSelected(isSelected);
                            this.selectionList._reportValueChange();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatListOption.prototype.ngOnInit = function () {
                    var _this = this;
                    /** @type {?} */
                    var list = this.selectionList;
                    if (list._value && list._value.some(( /**
                     * @param {?} value
                     * @return {?}
                     */function (/**
                     * @param {?} value
                     * @return {?}
                     */ value) { return list.compareWith(value, _this._value); }))) {
                        this._setSelected(true);
                    }
                    /** @type {?} */
                    var wasSelected = this._selected;
                    // List options that are selected at initialization can't be reported properly to the form
                    // control. This is because it takes some time until the selection-list knows about all
                    // available options. Also it can happen that the ControlValueAccessor has an initial value
                    // that should be used instead. Deferring the value change report to the next tick ensures
                    // that the form control value is not being overwritten.
                    Promise.resolve().then(( /**
                     * @return {?}
                     */function () {
                        if (_this._selected || wasSelected) {
                            _this.selected = true;
                            _this._changeDetector.markForCheck();
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                MatListOption.prototype.ngAfterContentInit = function () {
                    Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["setLines"])(this._lines, this._element);
                };
                /**
                 * @return {?}
                 */
                MatListOption.prototype.ngOnDestroy = function () {
                    var _this = this;
                    if (this.selected) {
                        // We have to delay this until the next tick in order
                        // to avoid changed after checked errors.
                        Promise.resolve().then(( /**
                         * @return {?}
                         */function () {
                            _this.selected = false;
                        }));
                    }
                    /** @type {?} */
                    var hadFocus = this._hasFocus;
                    /** @type {?} */
                    var newActiveItem = this.selectionList._removeOptionFromList(this);
                    // Only move focus if this option was focused at the time it was destroyed.
                    if (hadFocus && newActiveItem) {
                        newActiveItem.focus();
                    }
                };
                /**
                 * Toggles the selection state of the option.
                 * @return {?}
                 */
                MatListOption.prototype.toggle = function () {
                    this.selected = !this.selected;
                };
                /**
                 * Allows for programmatic focusing of the option.
                 * @return {?}
                 */
                MatListOption.prototype.focus = function () {
                    this._element.nativeElement.focus();
                };
                /**
                 * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
                 * \@docs-private
                 * @return {?}
                 */
                MatListOption.prototype.getLabel = function () {
                    return this._text ? (this._text.nativeElement.textContent || '') : '';
                };
                /**
                 * Whether this list item should show a ripple effect when clicked.
                 * @return {?}
                 */
                MatListOption.prototype._isRippleDisabled = function () {
                    return this.disabled || this.disableRipple || this.selectionList.disableRipple;
                };
                /**
                 * @return {?}
                 */
                MatListOption.prototype._handleClick = function () {
                    if (!this.disabled) {
                        this.toggle();
                        // Emit a change event if the selected state of the option changed through user interaction.
                        this.selectionList._emitChangeEvent(this);
                    }
                };
                /**
                 * @return {?}
                 */
                MatListOption.prototype._handleFocus = function () {
                    this.selectionList._setFocusedOption(this);
                    this._hasFocus = true;
                };
                /**
                 * @return {?}
                 */
                MatListOption.prototype._handleBlur = function () {
                    this.selectionList._onTouched();
                    this._hasFocus = false;
                };
                /**
                 * Retrieves the DOM element of the component host.
                 * @return {?}
                 */
                MatListOption.prototype._getHostElement = function () {
                    return this._element.nativeElement;
                };
                /**
                 * Sets the selected state of the option. Returns whether the value has changed.
                 * @param {?} selected
                 * @return {?}
                 */
                MatListOption.prototype._setSelected = function (selected) {
                    if (selected === this._selected) {
                        return false;
                    }
                    this._selected = selected;
                    if (selected) {
                        this.selectionList.selectedOptions.select(this);
                    }
                    else {
                        this.selectionList.selectedOptions.deselect(this);
                    }
                    this._changeDetector.markForCheck();
                    return true;
                };
                /**
                 * Notifies Angular that the option needs to be checked in the next change detection run. Mainly
                 * used to trigger an update of the list option if the disabled state of the selection list
                 * changed.
                 * @return {?}
                 */
                MatListOption.prototype._markForCheck = function () {
                    this._changeDetector.markForCheck();
                };
                return MatListOption;
            }(_MatListOptionMixinBase));
            MatListOption.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-list-option',
                            exportAs: 'matListOption',
                            inputs: ['disableRipple'],
                            host: {
                                'role': 'option',
                                'class': 'mat-list-item mat-list-option',
                                '(focus)': '_handleFocus()',
                                '(blur)': '_handleBlur()',
                                '(click)': '_handleClick()',
                                'tabindex': '-1',
                                '[class.mat-list-item-disabled]': 'disabled',
                                '[class.mat-list-item-with-avatar]': '_avatar || _icon',
                                // Manually set the "primary" or "warn" class if the color has been explicitly
                                // set to "primary" or "warn". The pseudo checkbox picks up these classes for
                                // its theme.
                                '[class.mat-primary]': 'color === "primary"',
                                // Even though accent is the default, we need to set this class anyway, because the  list might
                                // be placed inside a parent that has one of the other colors with a higher specificity.
                                '[class.mat-accent]': 'color !== "primary" && color !== "warn"',
                                '[class.mat-warn]': 'color === "warn"',
                                '[attr.aria-selected]': 'selected',
                                '[attr.aria-disabled]': 'disabled',
                            },
                            template: "<div class=\"mat-list-item-content\" [class.mat-list-item-content-reverse]=\"checkboxPosition == 'after'\"><div mat-ripple class=\"mat-list-item-ripple\" [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"_isRippleDisabled()\"></div><mat-pseudo-checkbox [state]=\"selected ? 'checked' : 'unchecked'\" [disabled]=\"disabled\"></mat-pseudo-checkbox><div class=\"mat-list-text\" #text><ng-content></ng-content></div><ng-content select=\"[mat-list-avatar], [mat-list-icon], [matListAvatar], [matListIcon]\"></ng-content></div>",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatListOption.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: MatSelectionList, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return MatSelectionList; })),] }] }
            ]; };
            MatListOption.propDecorators = {
                _avatar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatListAvatarCssMatStyler, { static: false },] }],
                _icon: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatListIconCssMatStyler, { static: false },] }],
                _lines: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLine"],] }],
                _text: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['text', { static: false },] }],
                checkboxPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * Material Design list component where each item is a selectable option. Behaves as a listbox.
             */
            var MatSelectionList = /** @class */ (function (_super_1) {
                __extends(MatSelectionList, _super_1);
                /**
                 * @param {?} _element
                 * @param {?} tabIndex
                 */
                function MatSelectionList(_element, tabIndex) {
                    var _this = _super_1.call(this) || this;
                    _this._element = _element;
                    /**
                     * Emits a change event whenever the selected state of an option changes.
                     */
                    _this.selectionChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Tabindex of the selection list.
                     */
                    _this.tabIndex = 0;
                    /**
                     * Theme color of the selection list. This sets the checkbox color for all list options.
                     */
                    _this.color = 'accent';
                    /**
                     * Function used for comparing an option against the selected value when determining which
                     * options should appear as selected. The first argument is the value of an options. The second
                     * one is a value from the selected value. A boolean must be returned.
                     */
                    _this.compareWith = ( /**
                     * @param {?} a1
                     * @param {?} a2
                     * @return {?}
                     */function (a1, a2) { return a1 === a2; });
                    _this._disabled = false;
                    /**
                     * The currently selected options.
                     */
                    _this.selectedOptions = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_6__["SelectionModel"](true);
                    /**
                     * View to model callback that should be called whenever the selected options change.
                     */
                    _this._onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    /**
                     * Emits when the list has been destroyed.
                     */
                    _this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * View to model callback that should be called if the list or its options lost focus.
                     */
                    _this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    _this.tabIndex = parseInt(tabIndex) || 0;
                    return _this;
                }
                Object.defineProperty(MatSelectionList.prototype, "disabled", {
                    /**
                     * Whether the selection list is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_5__["coerceBooleanProperty"])(value);
                        // The `MatSelectionList` and `MatListOption` are using the `OnPush` change detection
                        // strategy. Therefore the options will not check for any changes if the `MatSelectionList`
                        // changed its state. Since we know that a change to `disabled` property of the list affects
                        // the state of the options, we manually mark each option for check.
                        this._markOptionsForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatSelectionList.prototype.ngAfterContentInit = function () {
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_4__["FocusKeyManager"](this.options)
                        .withWrap()
                        .withTypeAhead()
                        // Allow disabled items to be focusable. For accessibility reasons, there must be a way for
                        // screenreader users, that allows reading the different options of the list.
                        .skipPredicate(( /**
                 * @return {?}
                 */function () { return false; }))
                        .withAllowedModifierKeys(['shiftKey']);
                    if (this._value) {
                        this._setOptionsFromValues(this._value);
                    }
                    // Sync external changes to the model back to the options.
                    this.selectedOptions.onChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        if (event.added) {
                            for (var _c = 0, _d = event.added; _c < _d.length; _c++) {
                                var item = _d[_c];
                                item.selected = true;
                            }
                        }
                        if (event.removed) {
                            for (var _e = 0, _f = event.removed; _e < _f.length; _e++) {
                                var item = _f[_e];
                                item.selected = false;
                            }
                        }
                    }));
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatSelectionList.prototype.ngOnChanges = function (changes) {
                    /** @type {?} */
                    var disableRippleChanges = changes['disableRipple'];
                    /** @type {?} */
                    var colorChanges = changes['color'];
                    if ((disableRippleChanges && !disableRippleChanges.firstChange) ||
                        (colorChanges && !colorChanges.firstChange)) {
                        this._markOptionsForCheck();
                    }
                };
                /**
                 * @return {?}
                 */
                MatSelectionList.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                    this._isDestroyed = true;
                };
                /**
                 * Focuses the selection list.
                 * @param {?=} options
                 * @return {?}
                 */
                MatSelectionList.prototype.focus = function (options) {
                    this._element.nativeElement.focus(options);
                };
                /**
                 * Selects all of the options.
                 * @return {?}
                 */
                MatSelectionList.prototype.selectAll = function () {
                    this._setAllOptionsSelected(true);
                };
                /**
                 * Deselects all of the options.
                 * @return {?}
                 */
                MatSelectionList.prototype.deselectAll = function () {
                    this._setAllOptionsSelected(false);
                };
                /**
                 * Sets the focused option of the selection-list.
                 * @param {?} option
                 * @return {?}
                 */
                MatSelectionList.prototype._setFocusedOption = function (option) {
                    this._keyManager.updateActiveItem(option);
                };
                /**
                 * Removes an option from the selection list and updates the active item.
                 * @param {?} option
                 * @return {?} Currently-active item.
                 */
                MatSelectionList.prototype._removeOptionFromList = function (option) {
                    /** @type {?} */
                    var optionIndex = this._getOptionIndex(option);
                    if (optionIndex > -1 && this._keyManager.activeItemIndex === optionIndex) {
                        // Check whether the option is the last item
                        if (optionIndex > 0) {
                            this._keyManager.updateActiveItem(optionIndex - 1);
                        }
                        else if (optionIndex === 0 && this.options.length > 1) {
                            this._keyManager.updateActiveItem(Math.min(optionIndex + 1, this.options.length - 1));
                        }
                    }
                    return this._keyManager.activeItem;
                };
                /**
                 * Passes relevant key presses to our key manager.
                 * @param {?} event
                 * @return {?}
                 */
                MatSelectionList.prototype._keydown = function (event) {
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var manager = this._keyManager;
                    /** @type {?} */
                    var previousFocusIndex = manager.activeItemIndex;
                    /** @type {?} */
                    var hasModifier = Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["hasModifierKey"])(event);
                    switch (keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["SPACE"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["ENTER"]:
                            if (!hasModifier) {
                                this._toggleFocusedOption();
                                // Always prevent space from scrolling the page since the list has focus
                                event.preventDefault();
                            }
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["HOME"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["END"]:
                            if (!hasModifier) {
                                keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["HOME"] ? manager.setFirstItemActive() : manager.setLastItemActive();
                                event.preventDefault();
                            }
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["A"]:
                            if (Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["hasModifierKey"])(event, 'ctrlKey')) {
                                this.options.find(( /**
                                 * @param {?} option
                                 * @return {?}
                                 */function (/**
                                 * @param {?} option
                                 * @return {?}
                                 */ option) { return !option.selected; })) ? this.selectAll() : this.deselectAll();
                                event.preventDefault();
                            }
                            break;
                        default:
                            manager.onKeydown(event);
                    }
                    if ((keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["UP_ARROW"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_7__["DOWN_ARROW"]) && event.shiftKey &&
                        manager.activeItemIndex !== previousFocusIndex) {
                        this._toggleFocusedOption();
                    }
                };
                /**
                 * Reports a value change to the ControlValueAccessor
                 * @return {?}
                 */
                MatSelectionList.prototype._reportValueChange = function () {
                    // Stop reporting value changes after the list has been destroyed. This avoids
                    // cases where the list might wrongly reset its value once it is removed, but
                    // the form control is still live.
                    if (this.options && !this._isDestroyed) {
                        /** @type {?} */
                        var value = this._getSelectedOptionValues();
                        this._onChange(value);
                        this._value = value;
                    }
                };
                /**
                 * Emits a change event if the selected state of an option changed.
                 * @param {?} option
                 * @return {?}
                 */
                MatSelectionList.prototype._emitChangeEvent = function (option) {
                    this.selectionChange.emit(new MatSelectionListChange(this, option));
                };
                /**
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} values
                 * @return {?}
                 */
                MatSelectionList.prototype.writeValue = function (values) {
                    this._value = values;
                    if (this.options) {
                        this._setOptionsFromValues(values || []);
                    }
                };
                /**
                 * Implemented as a part of ControlValueAccessor.
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatSelectionList.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                };
                /**
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn
                 * @return {?}
                 */
                MatSelectionList.prototype.registerOnChange = function (fn) {
                    this._onChange = fn;
                };
                /**
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn
                 * @return {?}
                 */
                MatSelectionList.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                /**
                 * Sets the selected options based on the specified values.
                 * @private
                 * @param {?} values
                 * @return {?}
                 */
                MatSelectionList.prototype._setOptionsFromValues = function (values) {
                    var _this = this;
                    this.options.forEach(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) { return option._setSelected(false); }));
                    values.forEach(( /**
                     * @param {?} value
                     * @return {?}
                     */function (/**
                     * @param {?} value
                     * @return {?}
                     */ value) {
                        /** @type {?} */
                        var correspondingOption = _this.options.find(( /**
                         * @param {?} option
                         * @return {?}
                         */function (/**
                         * @param {?} option
                         * @return {?}
                         */ option) {
                            // Skip options that are already in the model. This allows us to handle cases
                            // where the same primitive value is selected multiple times.
                            return option.selected ? false : _this.compareWith(option.value, value);
                        }));
                        if (correspondingOption) {
                            correspondingOption._setSelected(true);
                        }
                    }));
                };
                /**
                 * Returns the values of the selected options.
                 * @private
                 * @return {?}
                 */
                MatSelectionList.prototype._getSelectedOptionValues = function () {
                    return this.options.filter(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) { return option.selected; })).map(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) { return option.value; }));
                };
                /**
                 * Toggles the state of the currently focused option if enabled.
                 * @private
                 * @return {?}
                 */
                MatSelectionList.prototype._toggleFocusedOption = function () {
                    /** @type {?} */
                    var focusedIndex = this._keyManager.activeItemIndex;
                    if (focusedIndex != null && this._isValidIndex(focusedIndex)) {
                        /** @type {?} */
                        var focusedOption = this.options.toArray()[focusedIndex];
                        if (focusedOption && !focusedOption.disabled) {
                            focusedOption.toggle();
                            // Emit a change event because the focused option changed its state through user
                            // interaction.
                            this._emitChangeEvent(focusedOption);
                        }
                    }
                };
                /**
                 * Sets the selected state on all of the options
                 * and emits an event if anything changed.
                 * @private
                 * @param {?} isSelected
                 * @return {?}
                 */
                MatSelectionList.prototype._setAllOptionsSelected = function (isSelected) {
                    // Keep track of whether anything changed, because we only want to
                    // emit the changed event when something actually changed.
                    /** @type {?} */
                    var hasChanged = false;
                    this.options.forEach(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) {
                        if (option._setSelected(isSelected)) {
                            hasChanged = true;
                        }
                    }));
                    if (hasChanged) {
                        this._reportValueChange();
                    }
                };
                /**
                 * Utility to ensure all indexes are valid.
                 * @private
                 * @param {?} index The index to be checked.
                 * @return {?} True if the index is valid for our list of options.
                 */
                MatSelectionList.prototype._isValidIndex = function (index) {
                    return index >= 0 && index < this.options.length;
                };
                /**
                 * Returns the index of the specified list option.
                 * @private
                 * @param {?} option
                 * @return {?}
                 */
                MatSelectionList.prototype._getOptionIndex = function (option) {
                    return this.options.toArray().indexOf(option);
                };
                /**
                 * Marks all the options to be checked in the next change detection run.
                 * @private
                 * @return {?}
                 */
                MatSelectionList.prototype._markOptionsForCheck = function () {
                    if (this.options) {
                        this.options.forEach(( /**
                         * @param {?} option
                         * @return {?}
                         */function (/**
                         * @param {?} option
                         * @return {?}
                         */ option) { return option._markForCheck(); }));
                    }
                };
                return MatSelectionList;
            }(_MatSelectionListMixinBase));
            MatSelectionList.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-selection-list',
                            exportAs: 'matSelectionList',
                            inputs: ['disableRipple'],
                            host: {
                                'role': 'listbox',
                                '[tabIndex]': 'tabIndex',
                                'class': 'mat-selection-list mat-list-base',
                                '(blur)': '_onTouched()',
                                '(keydown)': '_keydown($event)',
                                'aria-multiselectable': 'true',
                                '[attr.aria-disabled]': 'disabled.toString()',
                            },
                            template: '<ng-content></ng-content>',
                            styles: [".mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list-base .mat-subheader{margin:0}.mat-list-base{padding-top:8px;display:block;-webkit-tap-highlight-color:transparent}.mat-list-base .mat-subheader{height:48px;line-height:16px}.mat-list-base .mat-subheader:first-child{margin-top:-8px}.mat-list-base .mat-list-item,.mat-list-base .mat-list-option{display:block;height:48px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.mat-list-base .mat-list-item .mat-list-item-content,.mat-list-base .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base .mat-list-item .mat-list-item-content-reverse,.mat-list-base .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base .mat-list-item .mat-list-item-ripple,.mat-list-base .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar,.mat-list-base .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list-base .mat-list-item.mat-2-line,.mat-list-base .mat-list-option.mat-2-line{height:72px}.mat-list-base .mat-list-item.mat-3-line,.mat-list-base .mat-list-option.mat-3-line{height:88px}.mat-list-base .mat-list-item.mat-multi-line,.mat-list-base .mat-list-option.mat-multi-line{height:auto}.mat-list-base .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base .mat-list-item .mat-list-text,.mat-list-base .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base .mat-list-item .mat-list-text>*,.mat-list-base .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list-base .mat-list-item .mat-list-text:empty,.mat-list-base .mat-list-option .mat-list-text:empty{display:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base .mat-list-item .mat-list-avatar,.mat-list-base .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%;object-fit:cover}.mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list-base .mat-list-item .mat-list-icon,.mat-list-base .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list-base .mat-list-item .mat-divider,.mat-list-base .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base .mat-list-item .mat-divider,[dir=rtl] .mat-list-base .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list-base[dense]{padding-top:4px;display:block}.mat-list-base[dense] .mat-subheader{height:40px;line-height:8px}.mat-list-base[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list-base[dense] .mat-list-item,.mat-list-base[dense] .mat-list-option{display:block;height:40px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-item-content,.mat-list-base[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list-base[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base[dense] .mat-list-item .mat-list-item-ripple,.mat-list-base[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list-base[dense] .mat-list-item.mat-2-line,.mat-list-base[dense] .mat-list-option.mat-2-line{height:60px}.mat-list-base[dense] .mat-list-item.mat-3-line,.mat-list-base[dense] .mat-list-option.mat-3-line{height:76px}.mat-list-base[dense] .mat-list-item.mat-multi-line,.mat-list-base[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list-base[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base[dense] .mat-list-item .mat-list-text,.mat-list-base[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-text>*,.mat-list-base[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list-base[dense] .mat-list-item .mat-list-text:empty,.mat-list-base[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base[dense] .mat-list-item .mat-list-avatar,.mat-list-base[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%;object-fit:cover}.mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list-base[dense] .mat-list-item .mat-list-icon,.mat-list-base[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list-base[dense] .mat-list-item .mat-divider,.mat-list-base[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}mat-action-list button{background:0 0;color:inherit;border:none;font:inherit;outline:inherit;-webkit-tap-highlight-color:transparent;text-align:left}[dir=rtl] mat-action-list button{text-align:right}mat-action-list button::-moz-focus-inner{border:0}mat-action-list .mat-list-item{cursor:pointer;outline:inherit}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}@media (-ms-high-contrast:active){.mat-selection-list:focus{outline-style:dotted}.mat-list-option:focus,.mat-list-option:hover,.mat-nav-list .mat-list-item:focus,.mat-nav-list .mat-list-item:hover,mat-action-list .mat-list-item:focus,mat-action-list .mat-list-item:hover{outline:dotted 1px}}@media (hover:none){.mat-action-list .mat-list-item:not(.mat-list-item-disabled):hover,.mat-list-option:not(.mat-list-item-disabled):hover,.mat-nav-list .mat-list-item:not(.mat-list-item-disabled):hover{background:0 0}}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            providers: [MAT_SELECTION_LIST_VALUE_ACCESSOR],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush
                        },] },
            ];
            /** @nocollapse */
            MatSelectionList.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['tabindex',] }] }
            ]; };
            MatSelectionList.propDecorators = {
                options: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatListOption, { descendants: true },] }],
                selectionChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                tabIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                compareWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatListModule = /** @class */ (function () {
                function MatListModule() {
                }
                return MatListModule;
            }());
            MatListModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLineModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatRippleModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatCommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatPseudoCheckboxModule"], _angular_common__WEBPACK_IMPORTED_MODULE_9__["CommonModule"]],
                            exports: [
                                MatList,
                                MatNavList,
                                MatListItem,
                                MatListAvatarCssMatStyler,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatLineModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatCommonModule"],
                                MatListIconCssMatStyler,
                                MatListSubheaderCssMatStyler,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_1__["MatPseudoCheckboxModule"],
                                MatSelectionList,
                                MatListOption,
                                _angular_material_divider__WEBPACK_IMPORTED_MODULE_10__["MatDividerModule"]
                            ],
                            declarations: [
                                MatList,
                                MatNavList,
                                MatListItem,
                                MatListAvatarCssMatStyler,
                                MatListIconCssMatStyler,
                                MatListSubheaderCssMatStyler,
                                MatSelectionList,
                                MatListOption
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=list.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/material.js": 
        /*!************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/material.js ***!
          \************************************************************/
        /*! exports provided: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY, MatAutocompleteSelectedEvent, MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocomplete, MatAutocompleteModule, MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY, getMatAutocompleteMissingPanelError, AUTOCOMPLETE_OPTION_HEIGHT, AUTOCOMPLETE_PANEL_HEIGHT, MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER, MAT_AUTOCOMPLETE_VALUE_ACCESSOR, MatAutocompleteTrigger, MatAutocompleteOrigin, MatBadgeModule, MatBadge, MatBottomSheetModule, MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, MatBottomSheet, MAT_BOTTOM_SHEET_DATA, MatBottomSheetConfig, MatBottomSheetContainer, matBottomSheetAnimations, MatBottomSheetRef, MatButtonModule, MatButton, MatAnchor, MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR, MatButtonToggleGroupMultiple, MatButtonToggleChange, MatButtonToggleGroup, MatButtonToggle, MatButtonToggleModule, MatCardContent, MatCardTitle, MatCardSubtitle, MatCardActions, MatCardFooter, MatCardImage, MatCardSmImage, MatCardMdImage, MatCardLgImage, MatCardXlImage, MatCardAvatar, MatCard, MatCardHeader, MatCardTitleGroup, MatCardModule, MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR, TransitionCheckState, MatCheckboxChange, MatCheckbox, MAT_CHECKBOX_CLICK_ACTION, _MatCheckboxRequiredValidatorModule, MatCheckboxModule, MAT_CHECKBOX_REQUIRED_VALIDATOR, MatCheckboxRequiredValidator, MatChipsModule, MatChipListChange, MatChipList, MatChipSelectionChange, MatChipAvatar, MatChipTrailingIcon, MatChip, MatChipRemove, MatChipInput, MAT_CHIPS_DEFAULT_OPTIONS, ɵa1, VERSION, AnimationCurves, AnimationDurations, MatCommonModule, MATERIAL_SANITY_CHECKS, mixinDisabled, mixinColor, mixinDisableRipple, mixinTabIndex, mixinErrorState, mixinInitialized, NativeDateModule, MatNativeDateModule, MAT_DATE_LOCALE_FACTORY, MAT_DATE_LOCALE, MAT_DATE_LOCALE_PROVIDER, DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter, MAT_NATIVE_DATE_FORMATS, ShowOnDirtyErrorStateMatcher, ErrorStateMatcher, MAT_HAMMER_OPTIONS, GestureConfig, setLines, MatLine, MatLineSetter, MatLineModule, MatOptionModule, _countGroupLabelsBeforeOption, _getOptionScrollPosition, MatOptionSelectionChange, MAT_OPTION_PARENT_COMPONENT, MatOption, MatOptgroup, MAT_LABEL_GLOBAL_OPTIONS, MatRippleModule, MAT_RIPPLE_GLOBAL_OPTIONS, MatRipple, RippleState, RippleRef, defaultRippleAnimationConfig, RippleRenderer, MatPseudoCheckboxModule, MatPseudoCheckbox, JAN, FEB, MAR, APR, MAY, JUN, JUL, AUG, SEP, OCT, NOV, DEC, MatMultiYearView, yearsPerPage, yearsPerRow, MatDatepickerModule, MatCalendarHeader, MatCalendar, MatCalendarCell, MatCalendarBody, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY, MAT_DATEPICKER_SCROLL_STRATEGY, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER, MatDatepickerContent, MatDatepicker, matDatepickerAnimations, MAT_DATEPICKER_VALUE_ACCESSOR, MAT_DATEPICKER_VALIDATORS, MatDatepickerInputEvent, MatDatepickerInput, MatDatepickerIntl, MatDatepickerToggleIcon, MatDatepickerToggle, MatMonthView, MatYearView, MatDialogModule, MAT_DIALOG_SCROLL_STRATEGY_FACTORY, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY, MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_SCROLL_STRATEGY, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER, MatDialog, throwMatDialogContentAlreadyAttachedError, MatDialogContainer, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogConfig, MatDialogRef, matDialogAnimations, MatDivider, MatDividerModule, MatExpansionModule, MatAccordion, MAT_ACCORDION, MAT_EXPANSION_PANEL_DEFAULT_OPTIONS, MatExpansionPanel, MatExpansionPanelActionRow, MatExpansionPanelHeader, MatExpansionPanelDescription, MatExpansionPanelTitle, MatExpansionPanelContent, EXPANSION_PANEL_ANIMATION_TIMING, matExpansionAnimations, MatFormFieldModule, MatError, MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormField, MatFormFieldControl, getMatFormFieldPlaceholderConflictError, getMatFormFieldDuplicatedHintError, getMatFormFieldMissingControlError, MatHint, MatPlaceholder, MatPrefix, MatSuffix, MatLabel, matFormFieldAnimations, ɵa11, MatGridListModule, MatGridList, MatGridTile, MatGridTileText, MatGridAvatarCssMatStyler, MatGridTileHeaderCssMatStyler, MatGridTileFooterCssMatStyler, MatIconModule, MAT_ICON_LOCATION_FACTORY, MAT_ICON_LOCATION, MatIcon, getMatIconNameNotFoundError, getMatIconNoHttpProviderError, getMatIconFailedToSanitizeUrlError, getMatIconFailedToSanitizeLiteralError, ICON_REGISTRY_PROVIDER_FACTORY, MatIconRegistry, ICON_REGISTRY_PROVIDER, MatTextareaAutosize, MatInput, getMatInputUnsupportedTypeError, MatInputModule, MAT_INPUT_VALUE_ACCESSOR, MatListModule, MatNavList, MatList, MatListAvatarCssMatStyler, MatListIconCssMatStyler, MatListSubheaderCssMatStyler, MatListItem, MAT_SELECTION_LIST_VALUE_ACCESSOR, MatSelectionListChange, MatListOption, MatSelectionList, ɵa22, ɵb22, ɵc22, MatMenu, MAT_MENU_DEFAULT_OPTIONS, _MatMenu, _MatMenuBase, MatMenuItem, MatMenuTrigger, MAT_MENU_SCROLL_STRATEGY, MAT_MENU_PANEL, _MatMenuDirectivesModule, MatMenuModule, matMenuAnimations, fadeInItems, transformMenu, MatMenuContent, MatPaginatorModule, PageEvent, MatPaginator, MAT_PAGINATOR_INTL_PROVIDER_FACTORY, MatPaginatorIntl, MAT_PAGINATOR_INTL_PROVIDER, MatProgressBarModule, MAT_PROGRESS_BAR_LOCATION_FACTORY, MAT_PROGRESS_BAR_LOCATION, MatProgressBar, MatProgressSpinner, MatSpinner, MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY, MatProgressSpinnerModule, MatRadioModule, MAT_RADIO_DEFAULT_OPTIONS_FACTORY, MAT_RADIO_DEFAULT_OPTIONS, MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR, MatRadioChange, MatRadioGroup, MatRadioButton, MatSelectModule, MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY, SELECT_PANEL_MAX_HEIGHT, SELECT_PANEL_PADDING_X, SELECT_PANEL_INDENT_PADDING_X, SELECT_ITEM_HEIGHT_EM, SELECT_MULTIPLE_PANEL_PADDING_X, SELECT_PANEL_VIEWPORT_PADDING, MAT_SELECT_SCROLL_STRATEGY, MAT_SELECT_SCROLL_STRATEGY_PROVIDER, MatSelectChange, MatSelectTrigger, MatSelect, matSelectAnimations, transformPanel, fadeInContent, MatSidenavModule, throwMatDuplicatedDrawerError, MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY, MAT_DRAWER_DEFAULT_AUTOSIZE, MatDrawerContent, MatDrawer, MatDrawerContainer, MatSidenavContent, MatSidenav, MatSidenavContainer, matDrawerAnimations, _MatSlideToggleRequiredValidatorModule, MatSlideToggleModule, MAT_SLIDE_TOGGLE_VALUE_ACCESSOR, MatSlideToggleChange, MatSlideToggle, MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR, MatSlideToggleRequiredValidator, MatSliderModule, MAT_SLIDER_VALUE_ACCESSOR, MatSliderChange, MatSlider, MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY, MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar, MatSnackBarContainer, MAT_SNACK_BAR_DATA, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar, matSnackBarAnimations, MatSortModule, MatSortHeader, MAT_SORT_HEADER_INTL_PROVIDER_FACTORY, MatSortHeaderIntl, MAT_SORT_HEADER_INTL_PROVIDER, MatSort, matSortAnimations, MatStepperModule, MatStepLabel, MatStep, MatStepper, MatHorizontalStepper, MatVerticalStepper, MatStepperNext, MatStepperPrevious, MatStepHeader, MAT_STEPPER_INTL_PROVIDER_FACTORY, MatStepperIntl, MAT_STEPPER_INTL_PROVIDER, matStepperAnimations, MatStepperIcon, MatTableModule, MatCellDef, MatHeaderCellDef, MatFooterCellDef, MatColumnDef, MatHeaderCell, MatFooterCell, MatCell, MatTable, MatHeaderRowDef, MatFooterRowDef, MatRowDef, MatHeaderRow, MatFooterRow, MatRow, MatTableDataSource, MatTextColumn, ɵa24, ɵb24, MatTabsModule, MatInkBar, _MAT_INK_BAR_POSITIONER, MatTabBody, _MatTabBodyBase, MatTabBodyPortal, MatTabHeader, _MatTabHeaderBase, MatTabLabelWrapper, MatTab, MatTabLabel, MatTabNav, MatTabLink, _MatTabNavBase, _MatTabLinkBase, MatTabContent, MatTabChangeEvent, MAT_TABS_CONFIG, _MatTabGroupBase, MatTabGroup, matTabsAnimations, MatToolbarModule, throwToolbarMixedModesError, MatToolbarRow, MatToolbar, MatTooltipModule, getMatTooltipInvalidPositionError, MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY, MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY, SCROLL_THROTTLE_MS, TOOLTIP_PANEL_CLASS, MAT_TOOLTIP_SCROLL_STRATEGY, MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER, MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltip, TooltipComponent, matTooltipAnimations, MatTreeNode, MatTreeNodeDef, MatNestedTreeNode, MatTreeNodePadding, MatTree, MatTreeModule, MatTreeNodeToggle, MatTreeNodeOutlet, MatTreeFlattener, MatTreeFlatDataSource, MatTreeNestedDataSource */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/material/autocomplete */ "./node_modules/@angular/material/esm2015/autocomplete.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteSelectedEvent", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MatAutocompleteSelectedEvent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_DEFAULT_OPTIONS", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MAT_AUTOCOMPLETE_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAutocomplete", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MatAutocomplete"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteModule", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MatAutocompleteModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatAutocompleteMissingPanelError", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["getMatAutocompleteMissingPanelError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AUTOCOMPLETE_OPTION_HEIGHT", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["AUTOCOMPLETE_OPTION_HEIGHT"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AUTOCOMPLETE_PANEL_HEIGHT", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["AUTOCOMPLETE_PANEL_HEIGHT"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_SCROLL_STRATEGY", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MAT_AUTOCOMPLETE_SCROLL_STRATEGY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_AUTOCOMPLETE_VALUE_ACCESSOR", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MAT_AUTOCOMPLETE_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteTrigger", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MatAutocompleteTrigger"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAutocompleteOrigin", function () { return _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_0__["MatAutocompleteOrigin"]; });
            /* harmony import */ var _angular_material_badge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/material/badge */ "./node_modules/@angular/material/esm2015/badge.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBadgeModule", function () { return _angular_material_badge__WEBPACK_IMPORTED_MODULE_1__["MatBadgeModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBadge", function () { return _angular_material_badge__WEBPACK_IMPORTED_MODULE_1__["MatBadge"]; });
            /* harmony import */ var _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/bottom-sheet */ "./node_modules/@angular/material/esm2015/bottom-sheet.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetModule", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MatBottomSheetModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_BOTTOM_SHEET_DEFAULT_OPTIONS", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MAT_BOTTOM_SHEET_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheet", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MatBottomSheet"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_BOTTOM_SHEET_DATA", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MAT_BOTTOM_SHEET_DATA"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetConfig", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MatBottomSheetConfig"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetContainer", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MatBottomSheetContainer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matBottomSheetAnimations", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["matBottomSheetAnimations"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatBottomSheetRef", function () { return _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_2__["MatBottomSheetRef"]; });
            /* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButtonModule", function () { return _angular_material_button__WEBPACK_IMPORTED_MODULE_3__["MatButtonModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButton", function () { return _angular_material_button__WEBPACK_IMPORTED_MODULE_3__["MatButton"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAnchor", function () { return _angular_material_button__WEBPACK_IMPORTED_MODULE_3__["MatAnchor"]; });
            /* harmony import */ var _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/button-toggle */ "./node_modules/@angular/material/esm2015/button-toggle.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleGroupMultiple", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MatButtonToggleGroupMultiple"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleChange", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MatButtonToggleChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleGroup", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MatButtonToggleGroup"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggle", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MatButtonToggle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatButtonToggleModule", function () { return _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_4__["MatButtonToggleModule"]; });
            /* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardContent", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardTitle", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardTitle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardSubtitle", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardSubtitle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardActions", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardActions"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardFooter", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardFooter"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardImage", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardImage"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardSmImage", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardSmImage"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardMdImage", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardMdImage"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardLgImage", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardLgImage"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardXlImage", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardXlImage"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardAvatar", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardAvatar"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCard", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCard"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardHeader", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardHeader"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardTitleGroup", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardTitleGroup"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCardModule", function () { return _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardModule"]; });
            /* harmony import */ var _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/checkbox */ "./node_modules/@angular/material/esm2015/checkbox.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransitionCheckState", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["TransitionCheckState"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCheckboxChange", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCheckbox", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckbox"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_CHECKBOX_CLICK_ACTION", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MAT_CHECKBOX_CLICK_ACTION"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatCheckboxRequiredValidatorModule", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["_MatCheckboxRequiredValidatorModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCheckboxModule", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_CHECKBOX_REQUIRED_VALIDATOR", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MAT_CHECKBOX_REQUIRED_VALIDATOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCheckboxRequiredValidator", function () { return _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxRequiredValidator"]; });
            /* harmony import */ var _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/chips */ "./node_modules/@angular/material/esm2015/chips.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipsModule", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipsModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipListChange", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipListChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipList", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipList"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipSelectionChange", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipSelectionChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipAvatar", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipAvatar"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipTrailingIcon", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipTrailingIcon"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChip", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChip"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipRemove", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipRemove"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatChipInput", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MatChipInput"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_CHIPS_DEFAULT_OPTIONS", function () { return _angular_material_chips__WEBPACK_IMPORTED_MODULE_7__["MAT_CHIPS_DEFAULT_OPTIONS"]; });
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵa1", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["ɵa1"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["VERSION"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationCurves", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["AnimationCurves"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationDurations", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["AnimationDurations"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCommonModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatCommonModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MATERIAL_SANITY_CHECKS", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MATERIAL_SANITY_CHECKS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixinDisabled", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["mixinDisabled"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixinColor", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["mixinColor"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixinDisableRipple", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["mixinDisableRipple"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixinTabIndex", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["mixinTabIndex"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixinErrorState", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["mixinErrorState"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixinInitialized", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["mixinInitialized"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NativeDateModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["NativeDateModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatNativeDateModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatNativeDateModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_LOCALE_FACTORY", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_DATE_LOCALE_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_LOCALE", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_DATE_LOCALE"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_LOCALE_PROVIDER", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_DATE_LOCALE_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateAdapter", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["DateAdapter"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATE_FORMATS", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_DATE_FORMATS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NativeDateAdapter", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["NativeDateAdapter"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_NATIVE_DATE_FORMATS", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_NATIVE_DATE_FORMATS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ShowOnDirtyErrorStateMatcher", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["ShowOnDirtyErrorStateMatcher"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorStateMatcher", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["ErrorStateMatcher"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_HAMMER_OPTIONS", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_HAMMER_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GestureConfig", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["GestureConfig"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setLines", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["setLines"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatLine", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatLine"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatLineSetter", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatLineSetter"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatLineModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatLineModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatOptionModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatOptionModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_countGroupLabelsBeforeOption", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["_countGroupLabelsBeforeOption"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_getOptionScrollPosition", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["_getOptionScrollPosition"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatOptionSelectionChange", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatOptionSelectionChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_OPTION_PARENT_COMPONENT", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_OPTION_PARENT_COMPONENT"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatOption", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatOption"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatOptgroup", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatOptgroup"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_LABEL_GLOBAL_OPTIONS", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_LABEL_GLOBAL_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRippleModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatRippleModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_RIPPLE_GLOBAL_OPTIONS", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAT_RIPPLE_GLOBAL_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRipple", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatRipple"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RippleState", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["RippleState"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RippleRef", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["RippleRef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultRippleAnimationConfig", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["defaultRippleAnimationConfig"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RippleRenderer", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["RippleRenderer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPseudoCheckboxModule", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatPseudoCheckboxModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPseudoCheckbox", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MatPseudoCheckbox"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JAN", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["JAN"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FEB", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["FEB"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAR", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "APR", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["APR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAY", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["MAY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JUN", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["JUN"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JUL", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["JUL"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AUG", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["AUG"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SEP", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["SEP"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OCT", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["OCT"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NOV", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["NOV"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DEC", function () { return _angular_material_core__WEBPACK_IMPORTED_MODULE_8__["DEC"]; });
            /* harmony import */ var _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/datepicker */ "./node_modules/@angular/material/esm2015/datepicker.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMultiYearView", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatMultiYearView"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "yearsPerPage", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["yearsPerPage"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "yearsPerRow", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["yearsPerRow"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerModule", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCalendarHeader", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatCalendarHeader"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCalendar", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatCalendar"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCalendarCell", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatCalendarCell"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCalendarBody", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatCalendarBody"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_SCROLL_STRATEGY", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MAT_DATEPICKER_SCROLL_STRATEGY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerContent", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepicker", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepicker"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matDatepickerAnimations", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["matDatepickerAnimations"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_VALUE_ACCESSOR", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MAT_DATEPICKER_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DATEPICKER_VALIDATORS", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MAT_DATEPICKER_VALIDATORS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerInputEvent", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerInputEvent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerInput", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerInput"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerIntl", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerIntl"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerToggleIcon", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerToggleIcon"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDatepickerToggle", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatDatepickerToggle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMonthView", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatMonthView"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatYearView", function () { return _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_9__["MatYearView"]; });
            /* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogModule", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY_FACTORY", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MAT_DIALOG_SCROLL_STRATEGY_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_DATA", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MAT_DIALOG_DATA"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_DEFAULT_OPTIONS", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MAT_DIALOG_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MAT_DIALOG_SCROLL_STRATEGY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DIALOG_SCROLL_STRATEGY_PROVIDER", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MAT_DIALOG_SCROLL_STRATEGY_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialog", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialog"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwMatDialogContentAlreadyAttachedError", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["throwMatDialogContentAlreadyAttachedError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogContainer", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogContainer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogClose", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogClose"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogTitle", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogTitle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogContent", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogActions", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogActions"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogConfig", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogConfig"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDialogRef", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialogRef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matDialogAnimations", function () { return _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["matDialogAnimations"]; });
            /* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/divider */ "./node_modules/@angular/material/esm2015/divider.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDivider", function () { return _angular_material_divider__WEBPACK_IMPORTED_MODULE_11__["MatDivider"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDividerModule", function () { return _angular_material_divider__WEBPACK_IMPORTED_MODULE_11__["MatDividerModule"]; });
            /* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/expansion */ "./node_modules/@angular/material/esm2015/expansion.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionModule", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatAccordion", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatAccordion"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_ACCORDION", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MAT_ACCORDION"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_EXPANSION_PANEL_DEFAULT_OPTIONS", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MAT_EXPANSION_PANEL_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanel", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionPanel"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelActionRow", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionPanelActionRow"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelHeader", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionPanelHeader"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelDescription", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionPanelDescription"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelTitle", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionPanelTitle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatExpansionPanelContent", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["MatExpansionPanelContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EXPANSION_PANEL_ANIMATION_TIMING", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["EXPANSION_PANEL_ANIMATION_TIMING"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matExpansionAnimations", function () { return _angular_material_expansion__WEBPACK_IMPORTED_MODULE_12__["matExpansionAnimations"]; });
            /* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFormFieldModule", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatFormFieldModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatError", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_FORM_FIELD_DEFAULT_OPTIONS", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MAT_FORM_FIELD_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFormField", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatFormField"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFormFieldControl", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatFormFieldControl"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatFormFieldPlaceholderConflictError", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["getMatFormFieldPlaceholderConflictError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatFormFieldDuplicatedHintError", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["getMatFormFieldDuplicatedHintError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatFormFieldMissingControlError", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["getMatFormFieldMissingControlError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatHint", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatHint"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPlaceholder", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatPlaceholder"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPrefix", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatPrefix"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSuffix", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatSuffix"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatLabel", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["MatLabel"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matFormFieldAnimations", function () { return _angular_material_form_field__WEBPACK_IMPORTED_MODULE_13__["matFormFieldAnimations"]; });
            /* harmony import */ var _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material/grid-list */ "./node_modules/@angular/material/esm2015/grid-list.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵa11", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["ɵa11"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridListModule", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridListModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridList", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridList"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridTile", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridTile"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridTileText", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridTileText"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridAvatarCssMatStyler", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridAvatarCssMatStyler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridTileHeaderCssMatStyler", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridTileHeaderCssMatStyler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatGridTileFooterCssMatStyler", function () { return _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_14__["MatGridTileFooterCssMatStyler"]; });
            /* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatIconModule", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["MatIconModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_ICON_LOCATION_FACTORY", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["MAT_ICON_LOCATION_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_ICON_LOCATION", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["MAT_ICON_LOCATION"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatIcon", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["MatIcon"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatIconNameNotFoundError", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["getMatIconNameNotFoundError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatIconNoHttpProviderError", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["getMatIconNoHttpProviderError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatIconFailedToSanitizeUrlError", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["getMatIconFailedToSanitizeUrlError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatIconFailedToSanitizeLiteralError", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["getMatIconFailedToSanitizeLiteralError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ICON_REGISTRY_PROVIDER_FACTORY", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["ICON_REGISTRY_PROVIDER_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatIconRegistry", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["MatIconRegistry"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ICON_REGISTRY_PROVIDER", function () { return _angular_material_icon__WEBPACK_IMPORTED_MODULE_15__["ICON_REGISTRY_PROVIDER"]; });
            /* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTextareaAutosize", function () { return _angular_material_input__WEBPACK_IMPORTED_MODULE_16__["MatTextareaAutosize"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatInput", function () { return _angular_material_input__WEBPACK_IMPORTED_MODULE_16__["MatInput"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatInputUnsupportedTypeError", function () { return _angular_material_input__WEBPACK_IMPORTED_MODULE_16__["getMatInputUnsupportedTypeError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatInputModule", function () { return _angular_material_input__WEBPACK_IMPORTED_MODULE_16__["MatInputModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_INPUT_VALUE_ACCESSOR", function () { return _angular_material_input__WEBPACK_IMPORTED_MODULE_16__["MAT_INPUT_VALUE_ACCESSOR"]; });
            /* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatListModule", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatNavList", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatNavList"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatList", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatList"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatListAvatarCssMatStyler", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListAvatarCssMatStyler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatListIconCssMatStyler", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListIconCssMatStyler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatListSubheaderCssMatStyler", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListSubheaderCssMatStyler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatListItem", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListItem"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECTION_LIST_VALUE_ACCESSOR", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MAT_SELECTION_LIST_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSelectionListChange", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatSelectionListChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatListOption", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListOption"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSelectionList", function () { return _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatSelectionList"]; });
            /* harmony import */ var _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/menu */ "./node_modules/@angular/material/esm2015/menu.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵa22", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["ɵa22"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵb22", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["ɵb22"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵc22", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["ɵc22"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMenu", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MatMenu"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_MENU_DEFAULT_OPTIONS", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MAT_MENU_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatMenu", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["_MatMenu"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatMenuBase", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["_MatMenuBase"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMenuItem", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MatMenuItem"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMenuTrigger", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MatMenuTrigger"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_MENU_SCROLL_STRATEGY", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MAT_MENU_SCROLL_STRATEGY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_MENU_PANEL", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MAT_MENU_PANEL"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatMenuDirectivesModule", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["_MatMenuDirectivesModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMenuModule", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MatMenuModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matMenuAnimations", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["matMenuAnimations"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fadeInItems", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["fadeInItems"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "transformMenu", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["transformMenu"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatMenuContent", function () { return _angular_material_menu__WEBPACK_IMPORTED_MODULE_18__["MatMenuContent"]; });
            /* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPaginatorModule", function () { return _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__["MatPaginatorModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PageEvent", function () { return _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__["PageEvent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPaginator", function () { return _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__["MatPaginator"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_PAGINATOR_INTL_PROVIDER_FACTORY", function () { return _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__["MAT_PAGINATOR_INTL_PROVIDER_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatPaginatorIntl", function () { return _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__["MatPaginatorIntl"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_PAGINATOR_INTL_PROVIDER", function () { return _angular_material_paginator__WEBPACK_IMPORTED_MODULE_19__["MAT_PAGINATOR_INTL_PROVIDER"]; });
            /* harmony import */ var _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/material/progress-bar */ "./node_modules/@angular/material/esm2015/progress-bar.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatProgressBarModule", function () { return _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_20__["MatProgressBarModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_BAR_LOCATION_FACTORY", function () { return _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_20__["MAT_PROGRESS_BAR_LOCATION_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_BAR_LOCATION", function () { return _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_20__["MAT_PROGRESS_BAR_LOCATION"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatProgressBar", function () { return _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_20__["MatProgressBar"]; });
            /* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/material/progress-spinner */ "./node_modules/@angular/material/esm2015/progress-spinner.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatProgressSpinner", function () { return _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_21__["MatProgressSpinner"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSpinner", function () { return _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_21__["MatSpinner"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS", function () { return _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_21__["MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY", function () { return _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_21__["MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatProgressSpinnerModule", function () { return _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_21__["MatProgressSpinnerModule"]; });
            /* harmony import */ var _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/material/radio */ "./node_modules/@angular/material/esm2015/radio.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRadioModule", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MatRadioModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_RADIO_DEFAULT_OPTIONS_FACTORY", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MAT_RADIO_DEFAULT_OPTIONS_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_RADIO_DEFAULT_OPTIONS", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MAT_RADIO_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRadioChange", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MatRadioChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRadioGroup", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MatRadioGroup"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRadioButton", function () { return _angular_material_radio__WEBPACK_IMPORTED_MODULE_22__["MatRadioButton"]; });
            /* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/select */ "./node_modules/@angular/material/esm2015/select.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSelectModule", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MatSelectModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_MAX_HEIGHT", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["SELECT_PANEL_MAX_HEIGHT"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_PADDING_X", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["SELECT_PANEL_PADDING_X"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_INDENT_PADDING_X", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["SELECT_PANEL_INDENT_PADDING_X"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SELECT_ITEM_HEIGHT_EM", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["SELECT_ITEM_HEIGHT_EM"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SELECT_MULTIPLE_PANEL_PADDING_X", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["SELECT_MULTIPLE_PANEL_PADDING_X"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_VIEWPORT_PADDING", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["SELECT_PANEL_VIEWPORT_PADDING"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECT_SCROLL_STRATEGY", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MAT_SELECT_SCROLL_STRATEGY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECT_SCROLL_STRATEGY_PROVIDER", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MAT_SELECT_SCROLL_STRATEGY_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSelectChange", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MatSelectChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSelectTrigger", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MatSelectTrigger"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSelect", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["MatSelect"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matSelectAnimations", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["matSelectAnimations"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "transformPanel", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["transformPanel"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fadeInContent", function () { return _angular_material_select__WEBPACK_IMPORTED_MODULE_23__["fadeInContent"]; });
            /* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSidenavModule", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatSidenavModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwMatDuplicatedDrawerError", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["throwMatDuplicatedDrawerError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_DRAWER_DEFAULT_AUTOSIZE", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MAT_DRAWER_DEFAULT_AUTOSIZE"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDrawerContent", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatDrawerContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDrawer", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatDrawer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatDrawerContainer", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatDrawerContainer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSidenavContent", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatSidenavContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSidenav", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatSidenav"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSidenavContainer", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatSidenavContainer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matDrawerAnimations", function () { return _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["matDrawerAnimations"]; });
            /* harmony import */ var _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/slide-toggle */ "./node_modules/@angular/material/esm2015/slide-toggle.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatSlideToggleRequiredValidatorModule", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["_MatSlideToggleRequiredValidatorModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggleModule", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MatSlideToggleModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDE_TOGGLE_VALUE_ACCESSOR", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MAT_SLIDE_TOGGLE_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggleChange", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MatSlideToggleChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggle", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MatSlideToggle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggleRequiredValidator", function () { return _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_25__["MatSlideToggleRequiredValidator"]; });
            /* harmony import */ var _angular_material_slider__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @angular/material/slider */ "./node_modules/@angular/material/esm2015/slider.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSliderModule", function () { return _angular_material_slider__WEBPACK_IMPORTED_MODULE_26__["MatSliderModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDER_VALUE_ACCESSOR", function () { return _angular_material_slider__WEBPACK_IMPORTED_MODULE_26__["MAT_SLIDER_VALUE_ACCESSOR"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSliderChange", function () { return _angular_material_slider__WEBPACK_IMPORTED_MODULE_26__["MatSliderChange"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSlider", function () { return _angular_material_slider__WEBPACK_IMPORTED_MODULE_26__["MatSlider"]; });
            /* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarModule", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MatSnackBarModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SNACK_BAR_DEFAULT_OPTIONS", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MAT_SNACK_BAR_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSnackBar", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MatSnackBar"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarContainer", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MatSnackBarContainer"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SNACK_BAR_DATA", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MAT_SNACK_BAR_DATA"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarConfig", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MatSnackBarConfig"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarRef", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["MatSnackBarRef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleSnackBar", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["SimpleSnackBar"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matSnackBarAnimations", function () { return _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_27__["matSnackBarAnimations"]; });
            /* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSortModule", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["MatSortModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSortHeader", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["MatSortHeader"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SORT_HEADER_INTL_PROVIDER_FACTORY", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["MAT_SORT_HEADER_INTL_PROVIDER_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSortHeaderIntl", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["MatSortHeaderIntl"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_SORT_HEADER_INTL_PROVIDER", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["MAT_SORT_HEADER_INTL_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatSort", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["MatSort"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matSortAnimations", function () { return _angular_material_sort__WEBPACK_IMPORTED_MODULE_28__["matSortAnimations"]; });
            /* harmony import */ var _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @angular/material/stepper */ "./node_modules/@angular/material/esm2015/stepper.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepperModule", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepperModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepLabel", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepLabel"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStep", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStep"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepper", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepper"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatHorizontalStepper", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatHorizontalStepper"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatVerticalStepper", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatVerticalStepper"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepperNext", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepperNext"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepperPrevious", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepperPrevious"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepHeader", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepHeader"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_STEPPER_INTL_PROVIDER_FACTORY", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MAT_STEPPER_INTL_PROVIDER_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepperIntl", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepperIntl"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_STEPPER_INTL_PROVIDER", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MAT_STEPPER_INTL_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matStepperAnimations", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["matStepperAnimations"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatStepperIcon", function () { return _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepperIcon"]; });
            /* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTableModule", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatTableModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCellDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatCellDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatHeaderCellDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatHeaderCellDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFooterCellDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatFooterCellDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatColumnDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatColumnDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatHeaderCell", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatHeaderCell"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFooterCell", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatFooterCell"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatCell", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatCell"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTable", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatTable"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatHeaderRowDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatHeaderRowDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFooterRowDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatFooterRowDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRowDef", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatRowDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatHeaderRow", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatHeaderRow"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatFooterRow", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatFooterRow"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatRow", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatRow"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTableDataSource", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatTableDataSource"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTextColumn", function () { return _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatTextColumn"]; });
            /* harmony import */ var _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @angular/material/tabs */ "./node_modules/@angular/material/esm2015/tabs.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵa24", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["ɵa24"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ɵb24", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["ɵb24"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabsModule", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabsModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatInkBar", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatInkBar"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MAT_INK_BAR_POSITIONER", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["_MAT_INK_BAR_POSITIONER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabBody", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabBody"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatTabBodyBase", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["_MatTabBodyBase"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabBodyPortal", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabBodyPortal"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabHeader", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabHeader"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatTabHeaderBase", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["_MatTabHeaderBase"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabLabelWrapper", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabLabelWrapper"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTab", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTab"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabLabel", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabLabel"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabNav", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabNav"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabLink", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabLink"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatTabNavBase", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["_MatTabNavBase"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatTabLinkBase", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["_MatTabLinkBase"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabContent", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabContent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabChangeEvent", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabChangeEvent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_TABS_CONFIG", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MAT_TABS_CONFIG"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_MatTabGroupBase", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["_MatTabGroupBase"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTabGroup", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["MatTabGroup"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matTabsAnimations", function () { return _angular_material_tabs__WEBPACK_IMPORTED_MODULE_31__["matTabsAnimations"]; });
            /* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatToolbarModule", function () { return _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_32__["MatToolbarModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwToolbarMixedModesError", function () { return _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_32__["throwToolbarMixedModesError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatToolbarRow", function () { return _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_32__["MatToolbarRow"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatToolbar", function () { return _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_32__["MatToolbar"]; });
            /* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @angular/material/tooltip */ "./node_modules/@angular/material/esm2015/tooltip.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTooltipModule", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MatTooltipModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMatTooltipInvalidPositionError", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["getMatTooltipInvalidPositionError"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SCROLL_THROTTLE_MS", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["SCROLL_THROTTLE_MS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TOOLTIP_PANEL_CLASS", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["TOOLTIP_PANEL_CLASS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_SCROLL_STRATEGY", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MAT_TOOLTIP_SCROLL_STRATEGY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_DEFAULT_OPTIONS", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MAT_TOOLTIP_DEFAULT_OPTIONS"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTooltip", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["MatTooltip"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TooltipComponent", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["TooltipComponent"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matTooltipAnimations", function () { return _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_33__["matTooltipAnimations"]; });
            /* harmony import */ var _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @angular/material/tree */ "./node_modules/@angular/material/esm2015/tree.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeNode", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeNode"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodeDef", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeNodeDef"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatNestedTreeNode", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatNestedTreeNode"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodePadding", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeNodePadding"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTree", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTree"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeModule", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeModule"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodeToggle", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeNodeToggle"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodeOutlet", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeNodeOutlet"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeFlattener", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeFlattener"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeFlatDataSource", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeFlatDataSource"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatTreeNestedDataSource", function () { return _angular_material_tree__WEBPACK_IMPORTED_MODULE_34__["MatTreeNestedDataSource"]; });
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=material.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/menu.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/menu.js ***!
          \********************************************************/
        /*! exports provided: MatMenu, MAT_MENU_DEFAULT_OPTIONS, _MatMenu, _MatMenuBase, MatMenuItem, MatMenuTrigger, MAT_MENU_SCROLL_STRATEGY, MAT_MENU_PANEL, _MatMenuDirectivesModule, MatMenuModule, matMenuAnimations, fadeInItems, transformMenu, MatMenuContent, ɵa22, ɵb22, ɵc22 */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMenu", function () { return MatMenu; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_MENU_DEFAULT_OPTIONS", function () { return MAT_MENU_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatMenu", function () { return _MatMenu; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatMenuBase", function () { return _MatMenuBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMenuItem", function () { return MatMenuItem; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMenuTrigger", function () { return MatMenuTrigger; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_MENU_SCROLL_STRATEGY", function () { return MAT_MENU_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_MENU_PANEL", function () { return MAT_MENU_PANEL; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatMenuDirectivesModule", function () { return _MatMenuDirectivesModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMenuModule", function () { return MatMenuModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matMenuAnimations", function () { return matMenuAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fadeInItems", function () { return fadeInItems; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformMenu", function () { return transformMenu; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatMenuContent", function () { return MatMenuContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa22", function () { return MAT_MENU_DEFAULT_OPTIONS_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb22", function () { return MAT_MENU_SCROLL_STRATEGY_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc22", function () { return MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER; });
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the mat-menu component.
             * Animation duration and timing values are based on:
             * https://material.io/guidelines/components/menus.html#menus-usage
             * \@docs-private
             * @type {?}
             */
            var matMenuAnimations = {
                /**
                 * This animation controls the menu panel's entry and exit from the page.
                 *
                 * When the menu panel is added to the DOM, it scales in and fades in its border.
                 *
                 * When the menu panel is removed from the DOM, it simply fades out after a brief
                 * delay to display the ripple.
                 */
                transformMenu: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('transformMenu', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                        opacity: 0,
                        transform: 'scale(0.8)'
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('void => enter', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["group"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["query"])('.mat-menu-content, .mat-mdc-menu-content', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('100ms linear', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                            opacity: 1
                        }))),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('120ms cubic-bezier(0, 0, 0.2, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ transform: 'scale(1)' })),
                    ])),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('100ms 25ms linear', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0 })))
                ]),
                /**
                 * This animation fades in the background color and content of the menu panel
                 * after its containing element is scaled in.
                 */
                fadeInItems: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('fadeInItems', [
                    // TODO(crisbeto): this is inside the `transformMenu`
                    // now. Remove next time we do breaking changes.
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('showing', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 1 })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('void => *', [
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0 }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('400ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
                    ])
                ])
            };
            /**
             * @deprecated
             * \@breaking-change 8.0.0
             * \@docs-private
             * @type {?}
             */
            var fadeInItems = matMenuAnimations.fadeInItems;
            /**
             * @deprecated
             * \@breaking-change 8.0.0
             * \@docs-private
             * @type {?}
             */
            var transformMenu = matMenuAnimations.transformMenu;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Menu content that will be rendered lazily once the menu is opened.
             */
            var MatMenuContent = /** @class */ (function () {
                /**
                 * @param {?} _template
                 * @param {?} _componentFactoryResolver
                 * @param {?} _appRef
                 * @param {?} _injector
                 * @param {?} _viewContainerRef
                 * @param {?} _document
                 * @param {?=} _changeDetectorRef
                 */
                function MatMenuContent(_template, _componentFactoryResolver, _appRef, _injector, _viewContainerRef, _document, _changeDetectorRef) {
                    this._template = _template;
                    this._componentFactoryResolver = _componentFactoryResolver;
                    this._appRef = _appRef;
                    this._injector = _injector;
                    this._viewContainerRef = _viewContainerRef;
                    this._document = _document;
                    this._changeDetectorRef = _changeDetectorRef;
                    /**
                     * Emits when the menu content has been attached.
                     */
                    this._attached = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                }
                /**
                 * Attaches the content with a particular context.
                 * \@docs-private
                 * @param {?=} context
                 * @return {?}
                 */
                MatMenuContent.prototype.attach = function (context) {
                    if (context === void 0) { context = {}; }
                    if (!this._portal) {
                        this._portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_1__["TemplatePortal"](this._template, this._viewContainerRef);
                    }
                    this.detach();
                    if (!this._outlet) {
                        this._outlet = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_1__["DomPortalOutlet"](this._document.createElement('div'), this._componentFactoryResolver, this._appRef, this._injector);
                    }
                    /** @type {?} */
                    var element = this._template.elementRef.nativeElement;
                    // Because we support opening the same menu from different triggers (which in turn have their
                    // own `OverlayRef` panel), we have to re-insert the host element every time, otherwise we
                    // risk it staying attached to a pane that's no longer in the DOM.
                    ( /** @type {?} */(element.parentNode)).insertBefore(this._outlet.outletElement, element);
                    // When `MatMenuContent` is used in an `OnPush` component, the insertion of the menu
                    // content via `createEmbeddedView` does not cause the content to be seen as "dirty"
                    // by Angular. This causes the `@ContentChildren` for menu items within the menu to
                    // not be updated by Angular. By explicitly marking for check here, we tell Angular that
                    // it needs to check for new menu items and update the `@ContentChild` in `MatMenu`.
                    // @breaking-change 9.0.0 Make change detector ref required
                    if (this._changeDetectorRef) {
                        this._changeDetectorRef.markForCheck();
                    }
                    this._portal.attach(this._outlet, context);
                    this._attached.next();
                };
                /**
                 * Detaches the content.
                 * \@docs-private
                 * @return {?}
                 */
                MatMenuContent.prototype.detach = function () {
                    if (this._portal.isAttached) {
                        this._portal.detach();
                    }
                };
                /**
                 * @return {?}
                 */
                MatMenuContent.prototype.ngOnDestroy = function () {
                    if (this._outlet) {
                        this._outlet.dispose();
                    }
                };
                return MatMenuContent;
            }());
            MatMenuContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'ng-template[matMenuContent]'
                        },] },
            ];
            /** @nocollapse */
            MatMenuContent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["TemplateRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ComponentFactoryResolver"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ApplicationRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injector"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Throws an exception for the case when menu trigger doesn't have a valid mat-menu instance
             * \@docs-private
             * @return {?}
             */
            function throwMatMenuMissingError() {
                throw Error("matMenuTriggerFor: must pass in an mat-menu instance.\n\n    Example:\n      <mat-menu #menu=\"matMenu\"></mat-menu>\n      <button [matMenuTriggerFor]=\"menu\"></button>");
            }
            /**
             * Throws an exception for the case when menu's x-position value isn't valid.
             * In other words, it doesn't match 'before' or 'after'.
             * \@docs-private
             * @return {?}
             */
            function throwMatMenuInvalidPositionX() {
                throw Error("xPosition value must be either 'before' or after'.\n      Example: <mat-menu xPosition=\"before\" #menu=\"matMenu\"></mat-menu>");
            }
            /**
             * Throws an exception for the case when menu's y-position value isn't valid.
             * In other words, it doesn't match 'above' or 'below'.
             * \@docs-private
             * @return {?}
             */
            function throwMatMenuInvalidPositionY() {
                throw Error("yPosition value must be either 'above' or below'.\n      Example: <mat-menu yPosition=\"above\" #menu=\"matMenu\"></mat-menu>");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token used to provide the parent menu to menu-specific components.
             * \@docs-private
             * @type {?}
             */
            var MAT_MENU_PANEL = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('MAT_MENU_PANEL');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatMenuItem.
            /**
             * \@docs-private
             */
            var MatMenuItemBase = /** @class */ (function () {
                function MatMenuItemBase() {
                }
                return MatMenuItemBase;
            }());
            /** @type {?} */
            var _MatMenuItemMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["mixinDisabled"])(MatMenuItemBase));
            /**
             * This directive is intended to be used inside an mat-menu tag.
             * It exists mostly to set the role attribute.
             */
            var MatMenuItem = /** @class */ (function (_super_1) {
                __extends(MatMenuItem, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?=} document
                 * @param {?=} _focusMonitor
                 * @param {?=} _parentMenu
                 */
                function MatMenuItem(_elementRef, document, _focusMonitor, _parentMenu) {
                    var _this = 
                    // @breaking-change 8.0.0 make `_focusMonitor` and `document` required params.
                    _super_1.call(this) || this;
                    _this._elementRef = _elementRef;
                    _this._focusMonitor = _focusMonitor;
                    _this._parentMenu = _parentMenu;
                    /**
                     * ARIA role for the menu item.
                     */
                    _this.role = 'menuitem';
                    /**
                     * Stream that emits when the menu item is hovered.
                     */
                    _this._hovered = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * Whether the menu item is highlighted.
                     */
                    _this._highlighted = false;
                    /**
                     * Whether the menu item acts as a trigger for a sub-menu.
                     */
                    _this._triggersSubmenu = false;
                    if (_focusMonitor) {
                        // Start monitoring the element so it gets the appropriate focused classes. We want
                        // to show the focus style for menu items only when the focus was not caused by a
                        // mouse or touch interaction.
                        _focusMonitor.monitor(_this._elementRef, false);
                    }
                    if (_parentMenu && _parentMenu.addItem) {
                        _parentMenu.addItem(_this);
                    }
                    _this._document = document;
                    return _this;
                }
                /**
                 * Focuses the menu item.
                 * @param {?=} origin
                 * @param {?=} options
                 * @return {?}
                 */
                MatMenuItem.prototype.focus = function (origin, options) {
                    if (origin === void 0) { origin = 'program'; }
                    if (this._focusMonitor) {
                        this._focusMonitor.focusVia(this._getHostElement(), origin, options);
                    }
                    else {
                        this._getHostElement().focus(options);
                    }
                };
                /**
                 * @return {?}
                 */
                MatMenuItem.prototype.ngOnDestroy = function () {
                    if (this._focusMonitor) {
                        this._focusMonitor.stopMonitoring(this._elementRef);
                    }
                    if (this._parentMenu && this._parentMenu.removeItem) {
                        this._parentMenu.removeItem(this);
                    }
                    this._hovered.complete();
                };
                /**
                 * Used to set the `tabindex`.
                 * @return {?}
                 */
                MatMenuItem.prototype._getTabIndex = function () {
                    return this.disabled ? '-1' : '0';
                };
                /**
                 * Returns the host DOM element.
                 * @return {?}
                 */
                MatMenuItem.prototype._getHostElement = function () {
                    return this._elementRef.nativeElement;
                };
                /**
                 * Prevents the default element actions if it is disabled.
                 * @param {?} event
                 * @return {?}
                 */
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                MatMenuItem.prototype._checkDisabled = function (event) {
                    if (this.disabled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };
                /**
                 * Emits to the hover stream.
                 * @return {?}
                 */
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                MatMenuItem.prototype._handleMouseEnter = function () {
                    this._hovered.next(this);
                };
                /**
                 * Gets the label to be used when determining whether the option should be focused.
                 * @return {?}
                 */
                MatMenuItem.prototype.getLabel = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    /** @type {?} */
                    var textNodeType = this._document ? this._document.TEXT_NODE : 3;
                    /** @type {?} */
                    var output = '';
                    if (element.childNodes) {
                        /** @type {?} */
                        var length = element.childNodes.length;
                        // Go through all the top-level text nodes and extract their text.
                        // We skip anything that's not a text node to prevent the text from
                        // being thrown off by something like an icon.
                        for (var i = 0; i < length; i++) {
                            if (element.childNodes[i].nodeType === textNodeType) {
                                output += element.childNodes[i].textContent;
                            }
                        }
                    }
                    return output.trim();
                };
                return MatMenuItem;
            }(_MatMenuItemMixinBase));
            MatMenuItem.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: '[mat-menu-item]',
                            exportAs: 'matMenuItem',
                            inputs: ['disabled', 'disableRipple'],
                            host: {
                                '[attr.role]': 'role',
                                'class': 'mat-menu-item',
                                '[class.mat-menu-item-highlighted]': '_highlighted',
                                '[class.mat-menu-item-submenu-trigger]': '_triggersSubmenu',
                                '[attr.tabindex]': '_getTabIndex()',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '[attr.disabled]': 'disabled || null',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                            template: "<ng-content></ng-content><div class=\"mat-menu-ripple\" matRipple [matRippleDisabled]=\"disableRipple || disabled\" [matRippleTrigger]=\"_getHostElement()\"></div>",
                        },] },
            ];
            /** @nocollapse */
            MatMenuItem.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_5__["FocusMonitor"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_MENU_PANEL,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] }
            ]; };
            MatMenuItem.propDecorators = {
                role: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                _checkDisabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["HostListener"], args: ['click', ['$event'],] }],
                _handleMouseEnter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["HostListener"], args: ['mouseenter',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token to be used to override the default options for `mat-menu`.
             * @type {?}
             */
            var MAT_MENU_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('mat-menu-default-options', {
                providedIn: 'root',
                factory: MAT_MENU_DEFAULT_OPTIONS_FACTORY
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_MENU_DEFAULT_OPTIONS_FACTORY() {
                return {
                    overlapTrigger: false,
                    xPosition: 'after',
                    yPosition: 'below',
                    backdropClass: 'cdk-overlay-transparent-backdrop',
                };
            }
            /**
             * Start elevation for the menu panel.
             * \@docs-private
             * @type {?}
             */
            var MAT_MENU_BASE_ELEVATION = 4;
            /**
             * Base class with all of the `MatMenu` functionality.
             */
            // tslint:disable-next-line:class-name
            var _MatMenuBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _ngZone
                 * @param {?} _defaultOptions
                 */
                function _MatMenuBase(_elementRef, _ngZone, _defaultOptions) {
                    this._elementRef = _elementRef;
                    this._ngZone = _ngZone;
                    this._defaultOptions = _defaultOptions;
                    this._xPosition = this._defaultOptions.xPosition;
                    this._yPosition = this._defaultOptions.yPosition;
                    /**
                     * Only the direct descendant menu items.
                     */
                    this._directDescendantItems = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["QueryList"]();
                    /**
                     * Subscription to tab events on the menu panel
                     */
                    this._tabSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Config object to be passed into the menu's ngClass
                     */
                    this._classList = {};
                    /**
                     * Current state of the panel animation.
                     */
                    this._panelAnimationState = 'void';
                    /**
                     * Emits whenever an animation on the menu completes.
                     */
                    this._animationDone = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * Class to be added to the backdrop element.
                     */
                    this.backdropClass = this._defaultOptions.backdropClass;
                    this._overlapTrigger = this._defaultOptions.overlapTrigger;
                    this._hasBackdrop = this._defaultOptions.hasBackdrop;
                    /**
                     * Event emitted when the menu is closed.
                     */
                    this.closed = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the menu is closed.
                     * @deprecated Switch to `closed` instead
                     * \@breaking-change 8.0.0
                     */
                    this.close = this.closed;
                }
                Object.defineProperty(_MatMenuBase.prototype, "xPosition", {
                    /**
                     * Position of the menu in the X axis.
                     * @return {?}
                     */
                    get: function () { return this._xPosition; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== 'before' && value !== 'after') {
                            throwMatMenuInvalidPositionX();
                        }
                        this._xPosition = value;
                        this.setPositionClasses();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatMenuBase.prototype, "yPosition", {
                    /**
                     * Position of the menu in the Y axis.
                     * @return {?}
                     */
                    get: function () { return this._yPosition; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== 'above' && value !== 'below') {
                            throwMatMenuInvalidPositionY();
                        }
                        this._yPosition = value;
                        this.setPositionClasses();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatMenuBase.prototype, "overlapTrigger", {
                    /**
                     * Whether the menu should overlap its trigger.
                     * @return {?}
                     */
                    get: function () { return this._overlapTrigger; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._overlapTrigger = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_7__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatMenuBase.prototype, "hasBackdrop", {
                    /**
                     * Whether the menu has a backdrop.
                     * @return {?}
                     */
                    get: function () { return this._hasBackdrop; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._hasBackdrop = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_7__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatMenuBase.prototype, "panelClass", {
                    /**
                     * This method takes classes set on the host mat-menu element and applies them on the
                     * menu template that displays in the overlay container.  Otherwise, it's difficult
                     * to style the containing menu from outside the component.
                     * @param {?} classes list of class names
                     * @return {?}
                     */
                    set: function (classes) {
                        var _this = this;
                        /** @type {?} */
                        var previousPanelClass = this._previousPanelClass;
                        if (previousPanelClass && previousPanelClass.length) {
                            previousPanelClass.split(' ').forEach(( /**
                             * @param {?} className
                             * @return {?}
                             */function (className) {
                                _this._classList[className] = false;
                            }));
                        }
                        this._previousPanelClass = classes;
                        if (classes && classes.length) {
                            classes.split(' ').forEach(( /**
                             * @param {?} className
                             * @return {?}
                             */function (className) {
                                _this._classList[className] = true;
                            }));
                            this._elementRef.nativeElement.className = '';
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatMenuBase.prototype, "classList", {
                    /**
                     * This method takes classes set on the host mat-menu element and applies them on the
                     * menu template that displays in the overlay container.  Otherwise, it's difficult
                     * to style the containing menu from outside the component.
                     * @deprecated Use `panelClass` instead.
                     * \@breaking-change 8.0.0
                     * @return {?}
                     */
                    get: function () { return this.panelClass; },
                    /**
                     * @param {?} classes
                     * @return {?}
                     */
                    set: function (classes) { this.panelClass = classes; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                _MatMenuBase.prototype.ngOnInit = function () {
                    this.setPositionClasses();
                };
                /**
                 * @return {?}
                 */
                _MatMenuBase.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._updateDirectDescendants();
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_5__["FocusKeyManager"](this._directDescendantItems).withWrap().withTypeAhead();
                    this._tabSubscription = this._keyManager.tabOut.subscribe(( /**
                     * @return {?}
                     */function () { return _this.closed.emit('tab'); }));
                };
                /**
                 * @return {?}
                 */
                _MatMenuBase.prototype.ngOnDestroy = function () {
                    this._directDescendantItems.destroy();
                    this._tabSubscription.unsubscribe();
                    this.closed.complete();
                };
                /**
                 * Stream that emits whenever the hovered menu item changes.
                 * @return {?}
                 */
                _MatMenuBase.prototype._hovered = function () {
                    // Coerce the `changes` property because Angular types it as `Observable<any>`
                    /** @type {?} */
                    var itemChanges = ( /** @type {?} */(this._directDescendantItems.changes));
                    return itemChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["startWith"])(this._directDescendantItems), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["switchMap"])(( /**
                     * @param {?} items
                     * @return {?}
                     */function (/**
                     * @param {?} items
                     * @return {?}
                     */ items) { return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["merge"]).apply(void 0, items.map(( /**
                     * @param {?} item
                     * @return {?}
                     */function (item) { return item._hovered; }))); })));
                };
                /*
                   * Registers a menu item with the menu.
                   * @docs-private
                   * @deprecated No longer being used. To be removed.
                   * @breaking-change 9.0.0
                   */
                /**
                 * @param {?} _item
                 * @return {?}
                 */
                _MatMenuBase.prototype.addItem = function (_item) { };
                /**
                 * Removes an item from the menu.
                 * \@docs-private
                 * @deprecated No longer being used. To be removed.
                 * \@breaking-change 9.0.0
                 * @param {?} _item
                 * @return {?}
                 */
                _MatMenuBase.prototype.removeItem = function (_item) { };
                /**
                 * Handle a keyboard event from the menu, delegating to the appropriate action.
                 * @param {?} event
                 * @return {?}
                 */
                _MatMenuBase.prototype._handleKeydown = function (event) {
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var manager = this._keyManager;
                    switch (keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["ESCAPE"]:
                            if (!Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["hasModifierKey"])(event)) {
                                event.preventDefault();
                                this.closed.emit('keydown');
                            }
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["LEFT_ARROW"]:
                            if (this.parentMenu && this.direction === 'ltr') {
                                this.closed.emit('keydown');
                            }
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["RIGHT_ARROW"]:
                            if (this.parentMenu && this.direction === 'rtl') {
                                this.closed.emit('keydown');
                            }
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["HOME"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["END"]:
                            if (!Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["hasModifierKey"])(event)) {
                                keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["HOME"] ? manager.setFirstItemActive() : manager.setLastItemActive();
                                event.preventDefault();
                            }
                            break;
                        default:
                            if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["UP_ARROW"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["DOWN_ARROW"]) {
                                manager.setFocusOrigin('keyboard');
                            }
                            manager.onKeydown(event);
                    }
                };
                /**
                 * Focus the first item in the menu.
                 * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
                 * @return {?}
                 */
                _MatMenuBase.prototype.focusFirstItem = function (origin) {
                    if (origin === void 0) { origin = 'program'; }
                    /** @type {?} */
                    var manager = this._keyManager;
                    // When the content is rendered lazily, it takes a bit before the items are inside the DOM.
                    if (this.lazyContent) {
                        this._ngZone.onStable.asObservable()
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["take"])(1))
                            .subscribe(( /**
                     * @return {?}
                     */function () { return manager.setFocusOrigin(origin).setFirstItemActive(); }));
                    }
                    else {
                        manager.setFocusOrigin(origin).setFirstItemActive();
                    }
                    // If there's no active item at this point, it means that all the items are disabled.
                    // Move focus to the menu panel so keyboard events like Escape still work. Also this will
                    // give _some_ feedback to screen readers.
                    if (!manager.activeItem && this._directDescendantItems.length) {
                        /** @type {?} */
                        var element = this._directDescendantItems.first._getHostElement().parentElement;
                        // Because the `mat-menu` is at the DOM insertion point, not inside the overlay, we don't
                        // have a nice way of getting a hold of the menu panel. We can't use a `ViewChild` either
                        // because the panel is inside an `ng-template`. We work around it by starting from one of
                        // the items and walking up the DOM.
                        while (element) {
                            if (element.getAttribute('role') === 'menu') {
                                element.focus();
                                break;
                            }
                            else {
                                element = element.parentElement;
                            }
                        }
                    }
                };
                /**
                 * Resets the active item in the menu. This is used when the menu is opened, allowing
                 * the user to start from the first option when pressing the down arrow.
                 * @return {?}
                 */
                _MatMenuBase.prototype.resetActiveItem = function () {
                    this._keyManager.setActiveItem(-1);
                };
                /**
                 * Sets the menu panel elevation.
                 * @param {?} depth Number of parent menus that come before the menu.
                 * @return {?}
                 */
                _MatMenuBase.prototype.setElevation = function (depth) {
                    // The elevation starts at the base and increases by one for each level.
                    /** @type {?} */
                    var newElevation = "mat-elevation-z" + (MAT_MENU_BASE_ELEVATION + depth);
                    /** @type {?} */
                    var customElevation = Object.keys(this._classList).find(( /**
                     * @param {?} c
                     * @return {?}
                     */function (/**
                     * @param {?} c
                     * @return {?}
                     */ c) { return c.startsWith('mat-elevation-z'); }));
                    if (!customElevation || customElevation === this._previousElevation) {
                        if (this._previousElevation) {
                            this._classList[this._previousElevation] = false;
                        }
                        this._classList[newElevation] = true;
                        this._previousElevation = newElevation;
                    }
                };
                /**
                 * Adds classes to the menu panel based on its position. Can be used by
                 * consumers to add specific styling based on the position.
                 * \@docs-private
                 * @param {?=} posX Position of the menu along the x axis.
                 * @param {?=} posY Position of the menu along the y axis.
                 * @return {?}
                 */
                _MatMenuBase.prototype.setPositionClasses = function (posX, posY) {
                    if (posX === void 0) { posX = this.xPosition; }
                    if (posY === void 0) { posY = this.yPosition; }
                    /** @type {?} */
                    var classes = this._classList;
                    classes['mat-menu-before'] = posX === 'before';
                    classes['mat-menu-after'] = posX === 'after';
                    classes['mat-menu-above'] = posY === 'above';
                    classes['mat-menu-below'] = posY === 'below';
                };
                /**
                 * Starts the enter animation.
                 * @return {?}
                 */
                _MatMenuBase.prototype._startAnimation = function () {
                    // @breaking-change 8.0.0 Combine with _resetAnimation.
                    this._panelAnimationState = 'enter';
                };
                /**
                 * Resets the panel animation to its initial state.
                 * @return {?}
                 */
                _MatMenuBase.prototype._resetAnimation = function () {
                    // @breaking-change 8.0.0 Combine with _startAnimation.
                    this._panelAnimationState = 'void';
                };
                /**
                 * Callback that is invoked when the panel animation completes.
                 * @param {?} event
                 * @return {?}
                 */
                _MatMenuBase.prototype._onAnimationDone = function (event) {
                    this._animationDone.next(event);
                    this._isAnimating = false;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                _MatMenuBase.prototype._onAnimationStart = function (event) {
                    this._isAnimating = true;
                    // Scroll the content element to the top as soon as the animation starts. This is necessary,
                    // because we move focus to the first item while it's still being animated, which can throw
                    // the browser off when it determines the scroll position. Alternatively we can move focus
                    // when the animation is done, however moving focus asynchronously will interrupt screen
                    // readers which are in the process of reading out the menu already. We take the `element`
                    // from the `event` since we can't use a `ViewChild` to access the pane.
                    if (event.toState === 'enter' && this._keyManager.activeItemIndex === 0) {
                        event.element.scrollTop = 0;
                    }
                };
                /**
                 * Sets up a stream that will keep track of any newly-added menu items and will update the list
                 * of direct descendants. We collect the descendants this way, because `_allItems` can include
                 * items that are part of child menus, and using a custom way of registering items is unreliable
                 * when it comes to maintaining the item order.
                 * @private
                 * @return {?}
                 */
                _MatMenuBase.prototype._updateDirectDescendants = function () {
                    var _this = this;
                    this._allItems.changes
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["startWith"])(this._allItems))
                        .subscribe(( /**
                 * @param {?} items
                 * @return {?}
                 */function (items) {
                        _this._directDescendantItems.reset(items.filter(( /**
                         * @param {?} item
                         * @return {?}
                         */function (/**
                         * @param {?} item
                         * @return {?}
                         */ item) { return item._parentMenu === _this; })));
                        _this._directDescendantItems.notifyOnChanges();
                    }));
                };
                return _MatMenuBase;
            }());
            /** @nocollapse */
            _MatMenuBase.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_MENU_DEFAULT_OPTIONS,] }] }
            ]; };
            _MatMenuBase.propDecorators = {
                _allItems: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [MatMenuItem, { descendants: true },] }],
                backdropClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                xPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                yPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                templateRef: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_3__["TemplateRef"], { static: false },] }],
                items: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [MatMenuItem,] }],
                lazyContent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChild"], args: [MatMenuContent, { static: false },] }],
                overlapTrigger: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                hasBackdrop: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                panelClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['class',] }],
                classList: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                closed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                close: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }]
            };
            /**
             * \@docs-private We show the "_MatMenu" class as "MatMenu" in the docs.
             */
            var MatMenu = /** @class */ (function (_super_1) {
                __extends(MatMenu, _super_1);
                function MatMenu() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatMenu;
            }(_MatMenuBase));
            // Note on the weird inheritance setup: we need three classes, because the MDC-based menu has to
            // extend `MatMenu`, however keeping a reference to it will cause the inlined template and styles
            // to be retained as well. The MDC menu also has to provide itself as a `MatMenu` in order for
            // queries and DI to work correctly, while still not referencing the actual menu class.
            // Class responsibility is split up as follows:
            // * _MatMenuBase - provides all the functionality without any of the Angular metadata.
            // * MatMenu - keeps the same name symbol name as the current menu and
            // is used as a provider for DI and query purposes.
            // * _MatMenu - the actual menu component implementation with the Angular metadata that should
            // be tree shaken away for MDC.
            /**
             * \@docs-public MatMenu
             */
            // tslint:disable-next-line:class-name
            var _MatMenu = /** @class */ (function (_super_1) {
                __extends(_MatMenu, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} ngZone
                 * @param {?} defaultOptions
                 */
                function _MatMenu(elementRef, ngZone, defaultOptions) {
                    return _super_1.call(this, elementRef, ngZone, defaultOptions) || this;
                }
                return _MatMenu;
            }(MatMenu));
            _MatMenu.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'mat-menu',
                            template: "<ng-template><div class=\"mat-menu-panel\" [ngClass]=\"_classList\" (keydown)=\"_handleKeydown($event)\" (click)=\"closed.emit('click')\" [@transformMenu]=\"_panelAnimationState\" (@transformMenu.start)=\"_onAnimationStart($event)\" (@transformMenu.done)=\"_onAnimationDone($event)\" tabindex=\"-1\" role=\"menu\"><div class=\"mat-menu-content\"><ng-content></ng-content></div></div></ng-template>",
                            styles: [".mat-menu-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 48px);border-radius:4px;outline:0;min-height:64px}.mat-menu-panel.ng-animating{pointer-events:none}@media (-ms-high-contrast:active){.mat-menu-panel{outline:solid 1px}}.mat-menu-content:not(:empty){padding-top:8px;padding-bottom:8px}.mat-menu-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;max-width:100%;position:relative}.mat-menu-item::-moz-focus-inner{border:0}.mat-menu-item[disabled]{cursor:default}[dir=rtl] .mat-menu-item{text-align:right}.mat-menu-item .mat-icon{margin-right:16px;vertical-align:middle}.mat-menu-item .mat-icon svg{vertical-align:top}[dir=rtl] .mat-menu-item .mat-icon{margin-left:16px;margin-right:0}.mat-menu-item[disabled]{pointer-events:none}@media (-ms-high-contrast:active){.mat-menu-item-highlighted,.mat-menu-item.cdk-keyboard-focused,.mat-menu-item.cdk-program-focused{outline:dotted 1px}}.mat-menu-item-submenu-trigger{padding-right:32px}.mat-menu-item-submenu-trigger::after{width:0;height:0;border-style:solid;border-width:5px 0 5px 5px;border-color:transparent transparent transparent currentColor;content:'';display:inline-block;position:absolute;top:50%;right:16px;transform:translateY(-50%)}[dir=rtl] .mat-menu-item-submenu-trigger{padding-right:16px;padding-left:32px}[dir=rtl] .mat-menu-item-submenu-trigger::after{right:auto;left:16px;transform:rotateY(180deg) translateY(-50%)}button.mat-menu-item{width:100%}.mat-menu-item .mat-menu-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                            exportAs: 'matMenu',
                            animations: [
                                matMenuAnimations.transformMenu,
                                matMenuAnimations.fadeInItems
                            ],
                            providers: [
                                { provide: MAT_MENU_PANEL, useExisting: MatMenu },
                                { provide: MatMenu, useExisting: _MatMenu }
                            ]
                        },] },
            ];
            /** @nocollapse */
            _MatMenu.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_MENU_DEFAULT_OPTIONS,] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that determines the scroll handling while the menu is open.
             * @type {?}
             */
            var MAT_MENU_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('mat-menu-scroll-strategy');
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_MENU_SCROLL_STRATEGY_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.reposition(); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER = {
                provide: MAT_MENU_SCROLL_STRATEGY,
                deps: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_11__["Overlay"]],
                useFactory: MAT_MENU_SCROLL_STRATEGY_FACTORY,
            };
            /**
             * Default top padding of the menu panel.
             * @type {?}
             */
            var MENU_PANEL_TOP_PADDING = 8;
            /**
             * Options for binding a passive event listener.
             * @type {?}
             */
            var passiveEventListenerOptions = Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["normalizePassiveListenerOptions"])({ passive: true });
            // TODO(andrewseguin): Remove the kebab versions in favor of camelCased attribute selectors
            /**
             * This directive is intended to be used in conjunction with an mat-menu tag.  It is
             * responsible for toggling the display of the provided menu instance.
             */
            var MatMenuTrigger = /** @class */ (function () {
                /**
                 * @param {?} _overlay
                 * @param {?} _element
                 * @param {?} _viewContainerRef
                 * @param {?} scrollStrategy
                 * @param {?} _parentMenu
                 * @param {?} _menuItemInstance
                 * @param {?} _dir
                 * @param {?=} _focusMonitor
                 */
                function MatMenuTrigger(_overlay, _element, _viewContainerRef, scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) {
                    var _this = this;
                    this._overlay = _overlay;
                    this._element = _element;
                    this._viewContainerRef = _viewContainerRef;
                    this._parentMenu = _parentMenu;
                    this._menuItemInstance = _menuItemInstance;
                    this._dir = _dir;
                    this._focusMonitor = _focusMonitor;
                    this._overlayRef = null;
                    this._menuOpen = false;
                    this._closingActionsSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    this._hoverSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    this._menuCloseSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Handles touch start events on the trigger.
                     * Needs to be an arrow function so we can easily use addEventListener and removeEventListener.
                     */
                    this._handleTouchStart = ( /**
                     * @return {?}
                     */function () { return _this._openedBy = 'touch'; });
                    // Tracking input type is necessary so it's possible to only auto-focus
                    // the first item of the list when the menu is opened via the keyboard
                    this._openedBy = null;
                    /**
                     * Whether focus should be restored when the menu is closed.
                     * Note that disabling this option can have accessibility implications
                     * and it's up to you to manage focus, if you decide to turn it off.
                     */
                    this.restoreFocus = true;
                    /**
                     * Event emitted when the associated menu is opened.
                     */
                    this.menuOpened = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the associated menu is opened.
                     * @deprecated Switch to `menuOpened` instead
                     * \@breaking-change 8.0.0
                     */
                    // tslint:disable-next-line:no-output-on-prefix
                    this.onMenuOpen = this.menuOpened;
                    /**
                     * Event emitted when the associated menu is closed.
                     */
                    this.menuClosed = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Event emitted when the associated menu is closed.
                     * @deprecated Switch to `menuClosed` instead
                     * \@breaking-change 8.0.0
                     */
                    // tslint:disable-next-line:no-output-on-prefix
                    this.onMenuClose = this.menuClosed;
                    _element.nativeElement.addEventListener('touchstart', this._handleTouchStart, passiveEventListenerOptions);
                    if (_menuItemInstance) {
                        _menuItemInstance._triggersSubmenu = this.triggersSubmenu();
                    }
                    this._scrollStrategy = scrollStrategy;
                }
                Object.defineProperty(MatMenuTrigger.prototype, "_deprecatedMatMenuTriggerFor", {
                    /**
                     * @deprecated
                     * \@breaking-change 8.0.0
                     * @return {?}
                     */
                    get: function () { return this.menu; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this.menu = v;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMenuTrigger.prototype, "menu", {
                    /**
                     * References the menu instance that the trigger is associated with.
                     * @return {?}
                     */
                    get: function () { return this._menu; },
                    /**
                     * @param {?} menu
                     * @return {?}
                     */
                    set: function (menu) {
                        var _this = this;
                        if (menu === this._menu) {
                            return;
                        }
                        this._menu = menu;
                        this._menuCloseSubscription.unsubscribe();
                        if (menu) {
                            this._menuCloseSubscription = menu.close.asObservable().subscribe(( /**
                             * @param {?} reason
                             * @return {?}
                             */function (/**
                             * @param {?} reason
                             * @return {?}
                             */ reason) {
                                _this._destroyMenu();
                                // If a click closed the menu, we should close the entire chain of nested menus.
                                if ((reason === 'click' || reason === 'tab') && _this._parentMenu) {
                                    _this._parentMenu.closed.emit(reason);
                                }
                            }));
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatMenuTrigger.prototype.ngAfterContentInit = function () {
                    this._checkMenu();
                    this._handleHover();
                };
                /**
                 * @return {?}
                 */
                MatMenuTrigger.prototype.ngOnDestroy = function () {
                    if (this._overlayRef) {
                        this._overlayRef.dispose();
                        this._overlayRef = null;
                    }
                    this._element.nativeElement.removeEventListener('touchstart', this._handleTouchStart, passiveEventListenerOptions);
                    this._menuCloseSubscription.unsubscribe();
                    this._closingActionsSubscription.unsubscribe();
                    this._hoverSubscription.unsubscribe();
                };
                Object.defineProperty(MatMenuTrigger.prototype, "menuOpen", {
                    /**
                     * Whether the menu is open.
                     * @return {?}
                     */
                    get: function () {
                        return this._menuOpen;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatMenuTrigger.prototype, "dir", {
                    /**
                     * The text direction of the containing app.
                     * @return {?}
                     */
                    get: function () {
                        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Whether the menu triggers a sub-menu or a top-level one.
                 * @return {?}
                 */
                MatMenuTrigger.prototype.triggersSubmenu = function () {
                    return !!(this._menuItemInstance && this._parentMenu);
                };
                /**
                 * Toggles the menu between the open and closed states.
                 * @return {?}
                 */
                MatMenuTrigger.prototype.toggleMenu = function () {
                    return this._menuOpen ? this.closeMenu() : this.openMenu();
                };
                /**
                 * Opens the menu.
                 * @return {?}
                 */
                MatMenuTrigger.prototype.openMenu = function () {
                    var _this = this;
                    if (this._menuOpen) {
                        return;
                    }
                    this._checkMenu();
                    /** @type {?} */
                    var overlayRef = this._createOverlay();
                    /** @type {?} */
                    var overlayConfig = overlayRef.getConfig();
                    this._setPosition(( /** @type {?} */(overlayConfig.positionStrategy)));
                    overlayConfig.hasBackdrop = this.menu.hasBackdrop == null ? !this.triggersSubmenu() :
                        this.menu.hasBackdrop;
                    overlayRef.attach(this._getPortal());
                    if (this.menu.lazyContent) {
                        this.menu.lazyContent.attach(this.menuData);
                    }
                    this._closingActionsSubscription = this._menuClosingActions().subscribe(( /**
                     * @return {?}
                     */function () { return _this.closeMenu(); }));
                    this._initMenu();
                    if (this.menu instanceof MatMenu) {
                        this.menu._startAnimation();
                    }
                };
                /**
                 * Closes the menu.
                 * @return {?}
                 */
                MatMenuTrigger.prototype.closeMenu = function () {
                    this.menu.close.emit();
                };
                /**
                 * Focuses the menu trigger.
                 * @param {?=} origin Source of the menu trigger's focus.
                 * @param {?=} options
                 * @return {?}
                 */
                MatMenuTrigger.prototype.focus = function (origin, options) {
                    if (origin === void 0) { origin = 'program'; }
                    if (this._focusMonitor) {
                        this._focusMonitor.focusVia(this._element, origin, options);
                    }
                    else {
                        this._element.nativeElement.focus(options);
                    }
                };
                /**
                 * Closes the menu and does the necessary cleanup.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._destroyMenu = function () {
                    var _this = this;
                    if (!this._overlayRef || !this.menuOpen) {
                        return;
                    }
                    /** @type {?} */
                    var menu = this.menu;
                    this._closingActionsSubscription.unsubscribe();
                    this._overlayRef.detach();
                    if (menu instanceof MatMenu) {
                        menu._resetAnimation();
                        if (menu.lazyContent) {
                            // Wait for the exit animation to finish before detaching the content.
                            menu._animationDone
                                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) { return event.toState === 'void'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["take"])(1), 
                            // Interrupt if the content got re-attached.
                            Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["takeUntil"])(menu.lazyContent._attached))
                                .subscribe({
                                next: ( /**
                                 * @return {?}
                                 */function () { return ( /** @type {?} */(menu.lazyContent)).detach(); }),
                                // No matter whether the content got re-attached, reset the menu.
                                complete: ( /**
                                 * @return {?}
                                 */function () { return _this._setIsMenuOpen(false); })
                            });
                        }
                        else {
                            this._setIsMenuOpen(false);
                        }
                    }
                    else {
                        this._setIsMenuOpen(false);
                        if (menu.lazyContent) {
                            menu.lazyContent.detach();
                        }
                    }
                    this._restoreFocus();
                };
                /**
                 * This method sets the menu state to open and focuses the first item if
                 * the menu was opened via the keyboard.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._initMenu = function () {
                    this.menu.parentMenu = this.triggersSubmenu() ? this._parentMenu : undefined;
                    this.menu.direction = this.dir;
                    this._setMenuElevation();
                    this._setIsMenuOpen(true);
                    this.menu.focusFirstItem(this._openedBy || 'program');
                };
                /**
                 * Updates the menu elevation based on the amount of parent menus that it has.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._setMenuElevation = function () {
                    if (this.menu.setElevation) {
                        /** @type {?} */
                        var depth = 0;
                        /** @type {?} */
                        var parentMenu = this.menu.parentMenu;
                        while (parentMenu) {
                            depth++;
                            parentMenu = parentMenu.parentMenu;
                        }
                        this.menu.setElevation(depth);
                    }
                };
                /**
                 * Restores focus to the element that was focused before the menu was open.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._restoreFocus = function () {
                    // We should reset focus if the user is navigating using a keyboard or
                    // if we have a top-level trigger which might cause focus to be lost
                    // when clicking on the backdrop.
                    if (this.restoreFocus) {
                        if (!this._openedBy) {
                            // Note that the focus style will show up both for `program` and
                            // `keyboard` so we don't have to specify which one it is.
                            this.focus();
                        }
                        else if (!this.triggersSubmenu()) {
                            this.focus(this._openedBy);
                        }
                    }
                    this._openedBy = null;
                };
                // set state rather than toggle to support triggers sharing a menu
                /**
                 * @private
                 * @param {?} isOpen
                 * @return {?}
                 */
                MatMenuTrigger.prototype._setIsMenuOpen = function (isOpen) {
                    this._menuOpen = isOpen;
                    this._menuOpen ? this.menuOpened.emit() : this.menuClosed.emit();
                    if (this.triggersSubmenu()) {
                        this._menuItemInstance._highlighted = isOpen;
                    }
                };
                /**
                 * This method checks that a valid instance of MatMenu has been passed into
                 * matMenuTriggerFor. If not, an exception is thrown.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._checkMenu = function () {
                    if (!this.menu) {
                        throwMatMenuMissingError();
                    }
                };
                /**
                 * This method creates the overlay from the provided menu's template and saves its
                 * OverlayRef so that it can be attached to the DOM when openMenu is called.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._createOverlay = function () {
                    if (!this._overlayRef) {
                        /** @type {?} */
                        var config = this._getOverlayConfig();
                        this._subscribeToPositions(( /** @type {?} */(config.positionStrategy)));
                        this._overlayRef = this._overlay.create(config);
                        // Consume the `keydownEvents` in order to prevent them from going to another overlay.
                        // Ideally we'd also have our keyboard event logic in here, however doing so will
                        // break anybody that may have implemented the `MatMenuPanel` themselves.
                        this._overlayRef.keydownEvents().subscribe();
                    }
                    return this._overlayRef;
                };
                /**
                 * This method builds the configuration object needed to create the overlay, the OverlayState.
                 * @private
                 * @return {?} OverlayConfig
                 */
                MatMenuTrigger.prototype._getOverlayConfig = function () {
                    return new _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_11__["OverlayConfig"]({
                        positionStrategy: this._overlay.position()
                            .flexibleConnectedTo(this._element)
                            .withLockedPosition()
                            .withTransformOriginOn('.mat-menu-panel, .mat-mdc-menu-panel'),
                        backdropClass: this.menu.backdropClass || 'cdk-overlay-transparent-backdrop',
                        scrollStrategy: this._scrollStrategy(),
                        direction: this._dir
                    });
                };
                /**
                 * Listens to changes in the position of the overlay and sets the correct classes
                 * on the menu based on the new position. This ensures the animation origin is always
                 * correct, even if a fallback position is used for the overlay.
                 * @private
                 * @param {?} position
                 * @return {?}
                 */
                MatMenuTrigger.prototype._subscribeToPositions = function (position) {
                    var _this = this;
                    if (this.menu.setPositionClasses) {
                        position.positionChanges.subscribe(( /**
                         * @param {?} change
                         * @return {?}
                         */function (/**
                         * @param {?} change
                         * @return {?}
                         */ change) {
                            /** @type {?} */
                            var posX = change.connectionPair.overlayX === 'start' ? 'after' : 'before';
                            /** @type {?} */
                            var posY = change.connectionPair.overlayY === 'top' ? 'below' : 'above';
                            ( /** @type {?} */(_this.menu.setPositionClasses))(posX, posY);
                        }));
                    }
                };
                /**
                 * Sets the appropriate positions on a position strategy
                 * so the overlay connects with the trigger correctly.
                 * @private
                 * @param {?} positionStrategy Strategy whose position to update.
                 * @return {?}
                 */
                MatMenuTrigger.prototype._setPosition = function (positionStrategy) {
                    var _c = this.menu.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'], originX = _c[0], originFallbackX = _c[1];
                    var _d = this.menu.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'], overlayY = _d[0], overlayFallbackY = _d[1];
                    var _e = [overlayY, overlayFallbackY], originY = _e[0], originFallbackY = _e[1];
                    var _f = [originX, originFallbackX], overlayX = _f[0], overlayFallbackX = _f[1];
                    /** @type {?} */
                    var offsetY = 0;
                    if (this.triggersSubmenu()) {
                        // When the menu is a sub-menu, it should always align itself
                        // to the edges of the trigger, instead of overlapping it.
                        overlayFallbackX = originX = this.menu.xPosition === 'before' ? 'start' : 'end';
                        originFallbackX = overlayX = originX === 'end' ? 'start' : 'end';
                        offsetY = overlayY === 'bottom' ? MENU_PANEL_TOP_PADDING : -MENU_PANEL_TOP_PADDING;
                    }
                    else if (!this.menu.overlapTrigger) {
                        originY = overlayY === 'top' ? 'bottom' : 'top';
                        originFallbackY = overlayFallbackY === 'top' ? 'bottom' : 'top';
                    }
                    positionStrategy.withPositions([
                        { originX: originX, originY: originY, overlayX: overlayX, overlayY: overlayY, offsetY: offsetY },
                        { originX: originFallbackX, originY: originY, overlayX: overlayFallbackX, overlayY: overlayY, offsetY: offsetY },
                        {
                            originX: originX,
                            originY: originFallbackY,
                            overlayX: overlayX,
                            overlayY: overlayFallbackY,
                            offsetY: -offsetY
                        },
                        {
                            originX: originFallbackX,
                            originY: originFallbackY,
                            overlayX: overlayFallbackX,
                            overlayY: overlayFallbackY,
                            offsetY: -offsetY
                        }
                    ]);
                };
                /**
                 * Returns a stream that emits whenever an action that should close the menu occurs.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._menuClosingActions = function () {
                    var _this = this;
                    /** @type {?} */
                    var backdrop = ( /** @type {?} */(this._overlayRef)).backdropClick();
                    /** @type {?} */
                    var detachments = ( /** @type {?} */(this._overlayRef)).detachments();
                    /** @type {?} */
                    var parentClose = this._parentMenu ? this._parentMenu.closed : Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])();
                    /** @type {?} */
                    var hover = this._parentMenu ? this._parentMenu._hovered().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                     * @param {?} active
                     * @return {?}
                     */function (/**
                     * @param {?} active
                     * @return {?}
                     */ active) { return active !== _this._menuItemInstance; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                     * @return {?}
                     */function () { return _this._menuOpen; }))) : Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])();
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["merge"])(backdrop, parentClose, hover, detachments);
                };
                /**
                 * Handles mouse presses on the trigger.
                 * @param {?} event
                 * @return {?}
                 */
                MatMenuTrigger.prototype._handleMousedown = function (event) {
                    if (!Object(_angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_5__["isFakeMousedownFromScreenReader"])(event)) {
                        // Since right or middle button clicks won't trigger the `click` event,
                        // we shouldn't consider the menu as opened by mouse in those cases.
                        this._openedBy = event.button === 0 ? 'mouse' : null;
                        // Since clicking on the trigger won't close the menu if it opens a sub-menu,
                        // we should prevent focus from moving onto it via click to avoid the
                        // highlight from lingering on the menu item.
                        if (this.triggersSubmenu()) {
                            event.preventDefault();
                        }
                    }
                };
                /**
                 * Handles key presses on the trigger.
                 * @param {?} event
                 * @return {?}
                 */
                MatMenuTrigger.prototype._handleKeydown = function (event) {
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    if (this.triggersSubmenu() && ((keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["RIGHT_ARROW"] && this.dir === 'ltr') ||
                        (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_8__["LEFT_ARROW"] && this.dir === 'rtl'))) {
                        this.openMenu();
                    }
                };
                /**
                 * Handles click events on the trigger.
                 * @param {?} event
                 * @return {?}
                 */
                MatMenuTrigger.prototype._handleClick = function (event) {
                    if (this.triggersSubmenu()) {
                        // Stop event propagation to avoid closing the parent menu.
                        event.stopPropagation();
                        this.openMenu();
                    }
                    else {
                        this.toggleMenu();
                    }
                };
                /**
                 * Handles the cases where the user hovers over the trigger.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._handleHover = function () {
                    var _this = this;
                    // Subscribe to changes in the hovered item in order to toggle the panel.
                    if (!this.triggersSubmenu()) {
                        return;
                    }
                    this._hoverSubscription = this._parentMenu._hovered()
                        // Since we might have multiple competing triggers for the same menu (e.g. a sub-menu
                        // with different data and triggers), we have to delay it by a tick to ensure that
                        // it won't be closed immediately after it is opened.
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["filter"])(( /**
                 * @param {?} active
                 * @return {?}
                 */function (/**
                 * @param {?} active
                 * @return {?}
                 */ active) { return active === _this._menuItemInstance && !active.disabled; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["delay"])(0, rxjs__WEBPACK_IMPORTED_MODULE_4__["asapScheduler"]))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._openedBy = 'mouse';
                        // If the same menu is used between multiple triggers, it might still be animating
                        // while the new trigger tries to re-open it. Wait for the animation to finish
                        // before doing so. Also interrupt if the user moves to another item.
                        if (_this.menu instanceof MatMenu && _this.menu._isAnimating) {
                            // We need the `delay(0)` here in order to avoid
                            // 'changed after checked' errors in some cases. See #12194.
                            _this.menu._animationDone
                                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["delay"])(0, rxjs__WEBPACK_IMPORTED_MODULE_4__["asapScheduler"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["takeUntil"])(_this._parentMenu._hovered()))
                                .subscribe(( /**
                         * @return {?}
                         */function () { return _this.openMenu(); }));
                        }
                        else {
                            _this.openMenu();
                        }
                    }));
                };
                /**
                 * Gets the portal that should be attached to the overlay.
                 * @private
                 * @return {?}
                 */
                MatMenuTrigger.prototype._getPortal = function () {
                    // Note that we can avoid this check by keeping the portal on the menu panel.
                    // While it would be cleaner, we'd have to introduce another required method on
                    // `MatMenuPanel`, making it harder to consume.
                    if (!this._portal || this._portal.templateRef !== this.menu.templateRef) {
                        this._portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_1__["TemplatePortal"](this.menu.templateRef, this._viewContainerRef);
                    }
                    return this._portal;
                };
                return MatMenuTrigger;
            }());
            MatMenuTrigger.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: "[mat-menu-trigger-for], [matMenuTriggerFor]",
                            host: {
                                'class': 'mat-menu-trigger',
                                'aria-haspopup': 'true',
                                '[attr.aria-expanded]': 'menuOpen || null',
                                '(mousedown)': '_handleMousedown($event)',
                                '(keydown)': '_handleKeydown($event)',
                                '(click)': '_handleClick($event)',
                            },
                            exportAs: 'matMenuTrigger'
                        },] },
            ];
            /** @nocollapse */
            MatMenuTrigger.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_11__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_MENU_SCROLL_STRATEGY,] }] },
                { type: MatMenu, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: MatMenuItem, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Self"] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_10__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_5__["FocusMonitor"] }
            ]; };
            MatMenuTrigger.propDecorators = {
                _deprecatedMatMenuTriggerFor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['mat-menu-trigger-for',] }],
                menu: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['matMenuTriggerFor',] }],
                menuData: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['matMenuTriggerData',] }],
                restoreFocus: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['matMenuTriggerRestoreFocus',] }],
                menuOpened: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                onMenuOpen: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                menuClosed: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                onMenuClose: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used by both the current `MatMenuModule` and the MDC `MatMenuModule`
             * to declare the menu-related directives.
             */
            // tslint:disable-next-line:class-name
            var _MatMenuDirectivesModule = /** @class */ (function () {
                function _MatMenuDirectivesModule() {
                }
                return _MatMenuDirectivesModule;
            }());
            _MatMenuDirectivesModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            exports: [MatMenuTrigger, MatMenuContent, _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MatCommonModule"]],
                            declarations: [MatMenuTrigger, MatMenuContent],
                            providers: [MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER]
                        },] },
            ];
            var MatMenuModule = /** @class */ (function () {
                function MatMenuModule() {
                }
                return MatMenuModule;
            }());
            MatMenuModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MatCommonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MatRippleModule"],
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_11__["OverlayModule"],
                                _MatMenuDirectivesModule,
                            ],
                            exports: [_MatMenu, MatMenuItem, _MatMenuDirectivesModule],
                            declarations: [_MatMenu, MatMenuItem],
                            providers: [MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=menu.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/paginator.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/paginator.js ***!
          \*************************************************************/
        /*! exports provided: MatPaginatorModule, PageEvent, MatPaginator, MAT_PAGINATOR_INTL_PROVIDER_FACTORY, MatPaginatorIntl, MAT_PAGINATOR_INTL_PROVIDER */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPaginatorModule", function () { return MatPaginatorModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageEvent", function () { return PageEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPaginator", function () { return MatPaginator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_PAGINATOR_INTL_PROVIDER_FACTORY", function () { return MAT_PAGINATOR_INTL_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatPaginatorIntl", function () { return MatPaginatorIntl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_PAGINATOR_INTL_PROVIDER", function () { return MAT_PAGINATOR_INTL_PROVIDER; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
            /* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/select */ "./node_modules/@angular/material/esm2015/select.js");
            /* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/tooltip */ "./node_modules/@angular/material/esm2015/tooltip.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * To modify the labels and text displayed, create a new instance of MatPaginatorIntl and
             * include it in a custom provider
             */
            var MatPaginatorIntl = /** @class */ (function () {
                function MatPaginatorIntl() {
                    /**
                     * Stream to emit from when labels are changed. Use this to notify components when the labels have
                     * changed after initialization.
                     */
                    this.changes = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                    /**
                     * A label for the page size selector.
                     */
                    this.itemsPerPageLabel = 'Items per page:';
                    /**
                     * A label for the button that increments the current page.
                     */
                    this.nextPageLabel = 'Next page';
                    /**
                     * A label for the button that decrements the current page.
                     */
                    this.previousPageLabel = 'Previous page';
                    /**
                     * A label for the button that moves to the first page.
                     */
                    this.firstPageLabel = 'First page';
                    /**
                     * A label for the button that moves to the last page.
                     */
                    this.lastPageLabel = 'Last page';
                    /**
                     * A label for the range of items within the current page and the length of the whole list.
                     */
                    this.getRangeLabel = ( /**
                     * @param {?} page
                     * @param {?} pageSize
                     * @param {?} length
                     * @return {?}
                     */function (page, pageSize, length) {
                        if (length == 0 || pageSize == 0) {
                            return "0 of " + length;
                        }
                        length = Math.max(length, 0);
                        /** @type {?} */
                        var startIndex = page * pageSize;
                        // If the start index exceeds the list length, do not try and fix the end index to the end.
                        /** @type {?} */
                        var endIndex = startIndex < length ?
                            Math.min(startIndex + pageSize, length) :
                            startIndex + pageSize;
                        return startIndex + 1 + " \u2013 " + endIndex + " of " + length;
                    });
                }
                return MatPaginatorIntl;
            }());
            MatPaginatorIntl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ MatPaginatorIntl.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function MatPaginatorIntl_Factory() { return new MatPaginatorIntl(); }, token: MatPaginatorIntl, providedIn: "root" });
            /**
             * \@docs-private
             * @param {?} parentIntl
             * @return {?}
             */
            function MAT_PAGINATOR_INTL_PROVIDER_FACTORY(parentIntl) {
                return parentIntl || new MatPaginatorIntl();
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_PAGINATOR_INTL_PROVIDER = {
                // If there is already an MatPaginatorIntl available, use that. Otherwise, provide a new one.
                provide: MatPaginatorIntl,
                deps: [[new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"](), MatPaginatorIntl]],
                useFactory: MAT_PAGINATOR_INTL_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The default page size if there is no page size and there are no provided page size options.
             * @type {?}
             */
            var DEFAULT_PAGE_SIZE = 50;
            /**
             * Change event object that is emitted when the user selects a
             * different page size or navigates to another page.
             */
            var PageEvent = /** @class */ (function () {
                function PageEvent() {
                }
                return PageEvent;
            }());
            // Boilerplate for applying mixins to MatPaginator.
            /**
             * \@docs-private
             */
            var MatPaginatorBase = /** @class */ (function () {
                function MatPaginatorBase() {
                }
                return MatPaginatorBase;
            }());
            /** @type {?} */
            var _MatPaginatorBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisabled"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinInitialized"])(MatPaginatorBase));
            /**
             * Component to provide navigation between paged information. Displays the size of the current
             * page, user-selectable options to change that size, what items are being shown, and
             * navigational button to go to the previous or next page.
             */
            var MatPaginator = /** @class */ (function (_super_1) {
                __extends(MatPaginator, _super_1);
                /**
                 * @param {?} _intl
                 * @param {?} _changeDetectorRef
                 */
                function MatPaginator(_intl, _changeDetectorRef) {
                    var _this = _super_1.call(this) || this;
                    _this._intl = _intl;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._pageIndex = 0;
                    _this._length = 0;
                    _this._pageSizeOptions = [];
                    _this._hidePageSize = false;
                    _this._showFirstLastButtons = false;
                    /**
                     * Event emitted when the paginator changes the page size or page index.
                     */
                    _this.page = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    _this._intlChanges = _intl.changes.subscribe(( /**
                     * @return {?}
                     */function () { return _this._changeDetectorRef.markForCheck(); }));
                    return _this;
                }
                Object.defineProperty(MatPaginator.prototype, "pageIndex", {
                    /**
                     * The zero-based page index of the displayed list of items. Defaulted to 0.
                     * @return {?}
                     */
                    get: function () { return this._pageIndex; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._pageIndex = Math.max(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value), 0);
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatPaginator.prototype, "length", {
                    /**
                     * The length of the total number of items that are being paginated. Defaulted to 0.
                     * @return {?}
                     */
                    get: function () { return this._length; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._length = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value);
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatPaginator.prototype, "pageSize", {
                    /**
                     * Number of items to display on a page. By default set to 50.
                     * @return {?}
                     */
                    get: function () { return this._pageSize; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._pageSize = Math.max(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value), 0);
                        this._updateDisplayedPageSizeOptions();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatPaginator.prototype, "pageSizeOptions", {
                    /**
                     * The set of provided page size options to display to the user.
                     * @return {?}
                     */
                    get: function () { return this._pageSizeOptions; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._pageSizeOptions = (value || []).map(( /**
                         * @param {?} p
                         * @return {?}
                         */function (/**
                         * @param {?} p
                         * @return {?}
                         */ p) { return Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(p); }));
                        this._updateDisplayedPageSizeOptions();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatPaginator.prototype, "hidePageSize", {
                    /**
                     * Whether to hide the page size selection UI from the user.
                     * @return {?}
                     */
                    get: function () { return this._hidePageSize; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._hidePageSize = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatPaginator.prototype, "showFirstLastButtons", {
                    /**
                     * Whether to show the first/last buttons UI to the user.
                     * @return {?}
                     */
                    get: function () { return this._showFirstLastButtons; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._showFirstLastButtons = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatPaginator.prototype.ngOnInit = function () {
                    this._initialized = true;
                    this._updateDisplayedPageSizeOptions();
                    this._markInitialized();
                };
                /**
                 * @return {?}
                 */
                MatPaginator.prototype.ngOnDestroy = function () {
                    this._intlChanges.unsubscribe();
                };
                /**
                 * Advances to the next page if it exists.
                 * @return {?}
                 */
                MatPaginator.prototype.nextPage = function () {
                    if (!this.hasNextPage()) {
                        return;
                    }
                    /** @type {?} */
                    var previousPageIndex = this.pageIndex;
                    this.pageIndex++;
                    this._emitPageEvent(previousPageIndex);
                };
                /**
                 * Move back to the previous page if it exists.
                 * @return {?}
                 */
                MatPaginator.prototype.previousPage = function () {
                    if (!this.hasPreviousPage()) {
                        return;
                    }
                    /** @type {?} */
                    var previousPageIndex = this.pageIndex;
                    this.pageIndex--;
                    this._emitPageEvent(previousPageIndex);
                };
                /**
                 * Move to the first page if not already there.
                 * @return {?}
                 */
                MatPaginator.prototype.firstPage = function () {
                    // hasPreviousPage being false implies at the start
                    if (!this.hasPreviousPage()) {
                        return;
                    }
                    /** @type {?} */
                    var previousPageIndex = this.pageIndex;
                    this.pageIndex = 0;
                    this._emitPageEvent(previousPageIndex);
                };
                /**
                 * Move to the last page if not already there.
                 * @return {?}
                 */
                MatPaginator.prototype.lastPage = function () {
                    // hasNextPage being false implies at the end
                    if (!this.hasNextPage()) {
                        return;
                    }
                    /** @type {?} */
                    var previousPageIndex = this.pageIndex;
                    this.pageIndex = this.getNumberOfPages() - 1;
                    this._emitPageEvent(previousPageIndex);
                };
                /**
                 * Whether there is a previous page.
                 * @return {?}
                 */
                MatPaginator.prototype.hasPreviousPage = function () {
                    return this.pageIndex >= 1 && this.pageSize != 0;
                };
                /**
                 * Whether there is a next page.
                 * @return {?}
                 */
                MatPaginator.prototype.hasNextPage = function () {
                    /** @type {?} */
                    var maxPageIndex = this.getNumberOfPages() - 1;
                    return this.pageIndex < maxPageIndex && this.pageSize != 0;
                };
                /**
                 * Calculate the number of pages
                 * @return {?}
                 */
                MatPaginator.prototype.getNumberOfPages = function () {
                    if (!this.pageSize) {
                        return 0;
                    }
                    return Math.ceil(this.length / this.pageSize);
                };
                /**
                 * Changes the page size so that the first item displayed on the page will still be
                 * displayed using the new page size.
                 *
                 * For example, if the page size is 10 and on the second page (items indexed 10-19) then
                 * switching so that the page size is 5 will set the third page as the current page so
                 * that the 10th item will still be displayed.
                 * @param {?} pageSize
                 * @return {?}
                 */
                MatPaginator.prototype._changePageSize = function (pageSize) {
                    // Current page needs to be updated to reflect the new page size. Navigate to the page
                    // containing the previous page's first item.
                    /** @type {?} */
                    var startIndex = this.pageIndex * this.pageSize;
                    /** @type {?} */
                    var previousPageIndex = this.pageIndex;
                    this.pageIndex = Math.floor(startIndex / pageSize) || 0;
                    this.pageSize = pageSize;
                    this._emitPageEvent(previousPageIndex);
                };
                /**
                 * Checks whether the buttons for going forwards should be disabled.
                 * @return {?}
                 */
                MatPaginator.prototype._nextButtonsDisabled = function () {
                    return this.disabled || !this.hasNextPage();
                };
                /**
                 * Checks whether the buttons for going backwards should be disabled.
                 * @return {?}
                 */
                MatPaginator.prototype._previousButtonsDisabled = function () {
                    return this.disabled || !this.hasPreviousPage();
                };
                /**
                 * Updates the list of page size options to display to the user. Includes making sure that
                 * the page size is an option and that the list is sorted.
                 * @private
                 * @return {?}
                 */
                MatPaginator.prototype._updateDisplayedPageSizeOptions = function () {
                    if (!this._initialized) {
                        return;
                    }
                    // If no page size is provided, use the first page size option or the default page size.
                    if (!this.pageSize) {
                        this._pageSize = this.pageSizeOptions.length != 0 ?
                            this.pageSizeOptions[0] :
                            DEFAULT_PAGE_SIZE;
                    }
                    this._displayedPageSizeOptions = this.pageSizeOptions.slice();
                    if (this._displayedPageSizeOptions.indexOf(this.pageSize) === -1) {
                        this._displayedPageSizeOptions.push(this.pageSize);
                    }
                    // Sort the numbers using a number-specific sort function.
                    this._displayedPageSizeOptions.sort(( /**
                     * @param {?} a
                     * @param {?} b
                     * @return {?}
                     */function (a, b) { return a - b; }));
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Emits an event notifying that a change of the paginator's properties has been triggered.
                 * @private
                 * @param {?} previousPageIndex
                 * @return {?}
                 */
                MatPaginator.prototype._emitPageEvent = function (previousPageIndex) {
                    this.page.emit({
                        previousPageIndex: previousPageIndex,
                        pageIndex: this.pageIndex,
                        pageSize: this.pageSize,
                        length: this.length
                    });
                };
                return MatPaginator;
            }(_MatPaginatorBase));
            MatPaginator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-paginator',
                            exportAs: 'matPaginator',
                            template: "<div class=\"mat-paginator-outer-container\"><div class=\"mat-paginator-container\"><div class=\"mat-paginator-page-size\" *ngIf=\"!hidePageSize\"><div class=\"mat-paginator-page-size-label\">{{_intl.itemsPerPageLabel}}</div><mat-form-field *ngIf=\"_displayedPageSizeOptions.length > 1\" [color]=\"color\" class=\"mat-paginator-page-size-select\"><mat-select [value]=\"pageSize\" [disabled]=\"disabled\" [aria-label]=\"_intl.itemsPerPageLabel\" (selectionChange)=\"_changePageSize($event.value)\"><mat-option *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\" [value]=\"pageSizeOption\">{{pageSizeOption}}</mat-option></mat-select></mat-form-field><div *ngIf=\"_displayedPageSizeOptions.length <= 1\">{{pageSize}}</div></div><div class=\"mat-paginator-range-actions\"><div class=\"mat-paginator-range-label\">{{_intl.getRangeLabel(pageIndex, pageSize, length)}}</div><button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-first\" (click)=\"firstPage()\" [attr.aria-label]=\"_intl.firstPageLabel\" [matTooltip]=\"_intl.firstPageLabel\" [matTooltipDisabled]=\"_previousButtonsDisabled()\" [matTooltipPosition]=\"'above'\" [disabled]=\"_previousButtonsDisabled()\" *ngIf=\"showFirstLastButtons\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-previous\" (click)=\"previousPage()\" [attr.aria-label]=\"_intl.previousPageLabel\" [matTooltip]=\"_intl.previousPageLabel\" [matTooltipDisabled]=\"_previousButtonsDisabled()\" [matTooltipPosition]=\"'above'\" [disabled]=\"_previousButtonsDisabled()\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-next\" (click)=\"nextPage()\" [attr.aria-label]=\"_intl.nextPageLabel\" [matTooltip]=\"_intl.nextPageLabel\" [matTooltipDisabled]=\"_nextButtonsDisabled()\" [matTooltipPosition]=\"'above'\" [disabled]=\"_nextButtonsDisabled()\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-last\" (click)=\"lastPage()\" [attr.aria-label]=\"_intl.lastPageLabel\" [matTooltip]=\"_intl.lastPageLabel\" [matTooltipDisabled]=\"_nextButtonsDisabled()\" [matTooltipPosition]=\"'above'\" [disabled]=\"_nextButtonsDisabled()\" *ngIf=\"showFirstLastButtons\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z\"/></svg></button></div></div></div>",
                            styles: [".mat-paginator{display:block}.mat-paginator-outer-container{display:flex}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse;width:100%}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}[dir=rtl] .mat-paginator-page-size{margin-right:0;margin-left:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0 4px;width:56px}.mat-paginator-page-size-select.mat-form-field-appearance-outline{width:64px}.mat-paginator-page-size-select.mat-form-field-appearance-fill{width:64px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center}.mat-paginator-icon{width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}"],
                            inputs: ['disabled'],
                            host: {
                                'class': 'mat-paginator',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatPaginator.ctorParameters = function () { return [
                { type: MatPaginatorIntl },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            MatPaginator.propDecorators = {
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                pageIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                length: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                pageSize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                pageSizeOptions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                hidePageSize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                showFirstLastButtons: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                page: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatPaginatorModule = /** @class */ (function () {
                function MatPaginatorModule() {
                }
                return MatPaginatorModule;
            }());
            MatPaginatorModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"],
                                _angular_material_button__WEBPACK_IMPORTED_MODULE_5__["MatButtonModule"],
                                _angular_material_select__WEBPACK_IMPORTED_MODULE_6__["MatSelectModule"],
                                _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_7__["MatTooltipModule"],
                            ],
                            exports: [MatPaginator],
                            declarations: [MatPaginator],
                            providers: [MAT_PAGINATOR_INTL_PROVIDER],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=paginator.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/progress-bar.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/progress-bar.js ***!
          \****************************************************************/
        /*! exports provided: MatProgressBarModule, MAT_PROGRESS_BAR_LOCATION_FACTORY, MAT_PROGRESS_BAR_LOCATION, MatProgressBar */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatProgressBarModule", function () { return MatProgressBarModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_BAR_LOCATION_FACTORY", function () { return MAT_PROGRESS_BAR_LOCATION_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_BAR_LOCATION", function () { return MAT_PROGRESS_BAR_LOCATION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatProgressBar", function () { return MatProgressBar; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatProgressBar.
            /**
             * \@docs-private
             */
            var MatProgressBarBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatProgressBarBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatProgressBarBase;
            }());
            /** @type {?} */
            var _MatProgressBarMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinColor"])(MatProgressBarBase, 'primary');
            /**
             * Injection token used to provide the current location to `MatProgressBar`.
             * Used to handle server-side rendering and to stub out during unit tests.
             * \@docs-private
             * @type {?}
             */
            var MAT_PROGRESS_BAR_LOCATION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-progress-bar-location', { providedIn: 'root', factory: MAT_PROGRESS_BAR_LOCATION_FACTORY });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_PROGRESS_BAR_LOCATION_FACTORY() {
                /** @type {?} */
                var _document = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_5__["DOCUMENT"]);
                /** @type {?} */
                var _location = _document ? _document.location : null;
                return {
                    // Note that this needs to be a function, rather than a property, because Angular
                    // will only resolve it once, but we want the current path on each call.
                    getPathname: ( /**
                     * @return {?}
                     */function () { return _location ? (_location.pathname + _location.search) : ''; })
                };
            }
            /**
             * Counter used to generate unique IDs for progress bars.
             * @type {?}
             */
            var progressbarId = 0;
            /**
             * `<mat-progress-bar>` component.
             */
            var MatProgressBar = /** @class */ (function (_super_1) {
                __extends(MatProgressBar, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _ngZone
                 * @param {?=} _animationMode
                 * @param {?=} location
                 */
                function MatProgressBar(_elementRef, _ngZone, _animationMode, 
                /**
                 * @deprecated `location` parameter to be made required.
                 * @breaking-change 8.0.0
                 */
                location) {
                    var _this = _super_1.call(this, _elementRef) || this;
                    _this._elementRef = _elementRef;
                    _this._ngZone = _ngZone;
                    _this._animationMode = _animationMode;
                    /**
                     * Flag that indicates whether NoopAnimations mode is set to true.
                     */
                    _this._isNoopAnimation = false;
                    _this._value = 0;
                    _this._bufferValue = 0;
                    /**
                     * Event emitted when animation of the primary progress bar completes. This event will not
                     * be emitted when animations are disabled, nor will it be emitted for modes with continuous
                     * animations (indeterminate and query).
                     */
                    _this.animationEnd = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Reference to animation end subscription to be unsubscribed on destroy.
                     */
                    _this._animationEndSubscription = rxjs__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    /**
                     * Mode of the progress bar.
                     *
                     * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to
                     * 'determinate'.
                     * Mirrored to mode attribute.
                     */
                    _this.mode = 'determinate';
                    /**
                     * ID of the progress bar.
                     */
                    _this.progressbarId = "mat-progress-bar-" + progressbarId++;
                    // We need to prefix the SVG reference with the current path, otherwise they won't work
                    // in Safari if the page has a `<base>` tag. Note that we need quotes inside the `url()`,
                    // because named route URLs can contain parentheses (see #12338). Also we don't use since
                    // we can't tell the difference between whether
                    // the consumer is using the hash location strategy or not, because `Location` normalizes
                    // both `/#/foo/bar` and `/foo/bar` to the same thing.
                    /** @type {?} */
                    var path = location ? location.getPathname().split('#')[0] : '';
                    _this._rectangleFillValue = "url('" + path + "#" + _this.progressbarId + "')";
                    _this._isNoopAnimation = _animationMode === 'NoopAnimations';
                    return _this;
                }
                Object.defineProperty(MatProgressBar.prototype, "value", {
                    /**
                     * Value of the progress bar. Defaults to zero. Mirrored to aria-valuenow.
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this._value = clamp(v || 0);
                        // When noop animation is set to true, trigger animationEnd directly.
                        if (this._isNoopAnimation) {
                            this._emitAnimationEnd();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressBar.prototype, "bufferValue", {
                    /**
                     * Buffer value of the progress bar. Defaults to zero.
                     * @return {?}
                     */
                    get: function () { return this._bufferValue; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) { this._bufferValue = clamp(v || 0); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Gets the current transform value for the progress bar's primary indicator.
                 * @return {?}
                 */
                MatProgressBar.prototype._primaryTransform = function () {
                    /** @type {?} */
                    var scale = this.value / 100;
                    return { transform: "scaleX(" + scale + ")" };
                };
                /**
                 * Gets the current transform value for the progress bar's buffer indicator. Only used if the
                 * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
                 * @return {?}
                 */
                MatProgressBar.prototype._bufferTransform = function () {
                    if (this.mode === 'buffer') {
                        /** @type {?} */
                        var scale = this.bufferValue / 100;
                        return { transform: "scaleX(" + scale + ")" };
                    }
                    return undefined;
                };
                /**
                 * @return {?}
                 */
                MatProgressBar.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    if (!this._isNoopAnimation) {
                        // Run outside angular so change detection didn't get triggered on every transition end
                        // instead only on the animation that we care about (primary value bar's transitionend)
                        this._ngZone.runOutsideAngular((( /**
                         * @return {?}
                         */function () {
                            /** @type {?} */
                            var element = _this._primaryValueBar.nativeElement;
                            _this._animationEndSubscription =
                                (( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["fromEvent"])(element, 'transitionend'))))
                                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["filter"])((( /**
                             * @param {?} e
                             * @return {?}
                             */function (e) { return e.target === element; }))))
                                    .subscribe(( /**
                             * @return {?}
                             */function () { return _this._ngZone.run(( /**
                                 * @return {?}
                                 */function () { return _this._emitAnimationEnd(); })); }));
                        })));
                    }
                };
                /**
                 * @return {?}
                 */
                MatProgressBar.prototype.ngOnDestroy = function () {
                    this._animationEndSubscription.unsubscribe();
                };
                /**
                 * Emit an animationEnd event if in determinate or buffer mode.
                 * @private
                 * @return {?}
                 */
                MatProgressBar.prototype._emitAnimationEnd = function () {
                    if (this.mode === 'determinate' || this.mode === 'buffer') {
                        this.animationEnd.next({ value: this.value });
                    }
                };
                return MatProgressBar;
            }(_MatProgressBarMixinBase));
            MatProgressBar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-progress-bar',
                            exportAs: 'matProgressBar',
                            host: {
                                'role': 'progressbar',
                                'aria-valuemin': '0',
                                'aria-valuemax': '100',
                                '[attr.aria-valuenow]': '(mode === "indeterminate" || mode === "query") ? null : value',
                                '[attr.mode]': 'mode',
                                'class': 'mat-progress-bar',
                                '[class._mat-animation-noopable]': '_isNoopAnimation',
                            },
                            inputs: ['color'],
                            template: "<svg width=\"100%\" height=\"4\" focusable=\"false\" class=\"mat-progress-bar-background mat-progress-bar-element\"><defs><pattern [id]=\"progressbarId\" x=\"4\" y=\"0\" width=\"8\" height=\"4\" patternUnits=\"userSpaceOnUse\"><circle cx=\"2\" cy=\"2\" r=\"2\"/></pattern></defs><rect [attr.fill]=\"_rectangleFillValue\" width=\"100%\" height=\"100%\"/></svg><div class=\"mat-progress-bar-buffer mat-progress-bar-element\" [ngStyle]=\"_bufferTransform()\"></div><div class=\"mat-progress-bar-primary mat-progress-bar-fill mat-progress-bar-element\" [ngStyle]=\"_primaryTransform()\" #primaryValueBar></div><div class=\"mat-progress-bar-secondary mat-progress-bar-fill mat-progress-bar-element\"></div>",
                            styles: [".mat-progress-bar{display:block;height:4px;overflow:hidden;position:relative;transition:opacity 250ms linear;width:100%}._mat-animation-noopable.mat-progress-bar{transition:none;animation:none}.mat-progress-bar .mat-progress-bar-element,.mat-progress-bar .mat-progress-bar-fill::after{height:100%;position:absolute;width:100%}.mat-progress-bar .mat-progress-bar-background{width:calc(100% + 10px)}@media (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-background{display:none}}.mat-progress-bar .mat-progress-bar-buffer{transform-origin:top left;transition:transform 250ms ease}@media (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-buffer{border-top:solid 5px;opacity:.5}}.mat-progress-bar .mat-progress-bar-secondary{display:none}.mat-progress-bar .mat-progress-bar-fill{animation:none;transform-origin:top left;transition:transform 250ms ease}@media (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-fill{border-top:solid 4px}}.mat-progress-bar .mat-progress-bar-fill::after{animation:none;content:'';display:inline-block;left:0}.mat-progress-bar[dir=rtl],[dir=rtl] .mat-progress-bar{transform:rotateY(180deg)}.mat-progress-bar[mode=query]{transform:rotateZ(180deg)}.mat-progress-bar[mode=query][dir=rtl],[dir=rtl] .mat-progress-bar[mode=query]{transform:rotateZ(180deg) rotateY(180deg)}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-fill,.mat-progress-bar[mode=query] .mat-progress-bar-fill{transition:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary,.mat-progress-bar[mode=query] .mat-progress-bar-primary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-primary-indeterminate-translate 2s infinite linear;left:-145.166611%}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-primary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-primary-indeterminate-scale 2s infinite linear}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary,.mat-progress-bar[mode=query] .mat-progress-bar-secondary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-secondary-indeterminate-translate 2s infinite linear;left:-54.888891%;display:block}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-secondary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-secondary-indeterminate-scale 2s infinite linear}.mat-progress-bar[mode=buffer] .mat-progress-bar-background{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-background-scroll 250ms infinite linear;display:block}.mat-progress-bar._mat-animation-noopable .mat-progress-bar-background,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-buffer,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-fill,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-fill::after,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-primary,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-secondary,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-secondary.mat-progress-bar-fill::after{animation:none;transition:none}@keyframes mat-progress-bar-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(.5,0,.70173,.49582);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);transform:translateX(83.67142%)}100%{transform:translateX(200.61106%)}}@keyframes mat-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.66148)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:translateX(37.65191%)}48.35%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:translateX(84.38617%)}100%{transform:translateX(160.27778%)}}@keyframes mat-progress-bar-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:scaleX(.4571)}44.15%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:scaleX(.72796)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-background-scroll{to{transform:translateX(-8px)}}"],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatProgressBar.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__["ANIMATION_MODULE_TYPE"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_PROGRESS_BAR_LOCATION,] }] }
            ]; };
            MatProgressBar.propDecorators = {
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                bufferValue: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                _primaryValueBar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['primaryValueBar', { static: false },] }],
                animationEnd: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                mode: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * Clamps a value to be between two numbers, by default 0 and 100.
             * @param {?} v
             * @param {?=} min
             * @param {?=} max
             * @return {?}
             */
            function clamp(v, min, max) {
                if (min === void 0) { min = 0; }
                if (max === void 0) { max = 100; }
                return Math.max(min, Math.min(max, v));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatProgressBarModule = /** @class */ (function () {
                function MatProgressBarModule() {
                }
                return MatProgressBarModule;
            }());
            MatProgressBarModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatCommonModule"]],
                            exports: [MatProgressBar, _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatCommonModule"]],
                            declarations: [MatProgressBar],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=progress-bar.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/progress-spinner.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/progress-spinner.js ***!
          \********************************************************************/
        /*! exports provided: MatProgressSpinner, MatSpinner, MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY, MatProgressSpinnerModule */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatProgressSpinner", function () { return MatProgressSpinner; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSpinner", function () { return MatSpinner; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS", function () { return MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY", function () { return MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatProgressSpinnerModule", function () { return MatProgressSpinnerModule; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Base reference size of the spinner.
             * \@docs-private
             * @type {?}
             */
            var BASE_SIZE = 100;
            /**
             * Base reference stroke width of the spinner.
             * \@docs-private
             * @type {?}
             */
            var BASE_STROKE_WIDTH = 10;
            // Boilerplate for applying mixins to MatProgressSpinner.
            /**
             * \@docs-private
             */
            var MatProgressSpinnerBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatProgressSpinnerBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatProgressSpinnerBase;
            }());
            /** @type {?} */
            var _MatProgressSpinnerMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["mixinColor"])(MatProgressSpinnerBase, 'primary');
            /**
             * Injection token to be used to override the default options for `mat-progress-spinner`.
             * @type {?}
             */
            var MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('mat-progress-spinner-default-options', {
                providedIn: 'root',
                factory: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY() {
                return { diameter: BASE_SIZE };
            }
            // .0001 percentage difference is necessary in order to avoid unwanted animation frames
            // for example because the animation duration is 4 seconds, .1% accounts to 4ms
            // which are enough to see the flicker described in
            // https://github.com/angular/components/issues/8984
            /** @type {?} */
            var INDETERMINATE_ANIMATION_TEMPLATE = "\n @keyframes mat-progress-spinner-stroke-rotate-DIAMETER {\n    0%      { stroke-dashoffset: START_VALUE;  transform: rotate(0); }\n    12.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(0); }\n    12.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(72.5deg); }\n    25%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(72.5deg); }\n\n    25.0001%   { stroke-dashoffset: START_VALUE;  transform: rotate(270deg); }\n    37.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(270deg); }\n    37.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(161.5deg); }\n    50%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(161.5deg); }\n\n    50.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(180deg); }\n    62.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(180deg); }\n    62.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(251.5deg); }\n    75%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(251.5deg); }\n\n    75.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(90deg); }\n    87.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(90deg); }\n    87.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(341.5deg); }\n    100%    { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(341.5deg); }\n  }\n";
            /**
             * `<mat-progress-spinner>` component.
             */
            var MatProgressSpinner = /** @class */ (function (_super_1) {
                __extends(MatProgressSpinner, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} platform
                 * @param {?} _document
                 * @param {?} animationMode
                 * @param {?=} defaults
                 */
                function MatProgressSpinner(_elementRef, platform, _document, animationMode, defaults) {
                    var _this = _super_1.call(this, _elementRef) || this;
                    _this._elementRef = _elementRef;
                    _this._document = _document;
                    _this._diameter = BASE_SIZE;
                    _this._value = 0;
                    _this._fallbackAnimation = false;
                    /**
                     * Mode of the progress circle
                     */
                    _this.mode = 'determinate';
                    /** @type {?} */
                    var trackedDiameters = MatProgressSpinner._diameters;
                    // The base size is already inserted via the component's structural styles. We still
                    // need to track it so we don't end up adding the same styles again.
                    if (!trackedDiameters.has(_document.head)) {
                        trackedDiameters.set(_document.head, new Set([BASE_SIZE]));
                    }
                    _this._fallbackAnimation = platform.EDGE || platform.TRIDENT;
                    _this._noopAnimations = animationMode === 'NoopAnimations' &&
                        (!!defaults && !defaults._forceAnimations);
                    if (defaults) {
                        if (defaults.diameter) {
                            _this.diameter = defaults.diameter;
                        }
                        if (defaults.strokeWidth) {
                            _this.strokeWidth = defaults.strokeWidth;
                        }
                    }
                    return _this;
                }
                Object.defineProperty(MatProgressSpinner.prototype, "diameter", {
                    /**
                     * The diameter of the progress spinner (will set width and height of svg).
                     * @return {?}
                     */
                    get: function () { return this._diameter; },
                    /**
                     * @param {?} size
                     * @return {?}
                     */
                    set: function (size) {
                        this._diameter = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceNumberProperty"])(size);
                        // If this is set before `ngOnInit`, the style root may not have been resolved yet.
                        if (!this._fallbackAnimation && this._styleRoot) {
                            this._attachStyleNode();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressSpinner.prototype, "strokeWidth", {
                    /**
                     * Stroke width of the progress spinner.
                     * @return {?}
                     */
                    get: function () {
                        return this._strokeWidth || this.diameter / 10;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._strokeWidth = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceNumberProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressSpinner.prototype, "value", {
                    /**
                     * Value of the progress circle.
                     * @return {?}
                     */
                    get: function () {
                        return this.mode === 'determinate' ? this._value : 0;
                    },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) {
                        this._value = Math.max(0, Math.min(100, Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceNumberProperty"])(newValue)));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatProgressSpinner.prototype.ngOnInit = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    // Note that we need to look up the root node in ngOnInit, rather than the constructor, because
                    // Angular seems to create the element outside the shadow root and then moves it inside, if the
                    // node is inside an `ngIf` and a ShadowDom-encapsulated component.
                    this._styleRoot = _getShadowRoot(element, this._document) || this._document.head;
                    this._attachStyleNode();
                    // On IE and Edge, we can't animate the `stroke-dashoffset`
                    // reliably so we fall back to a non-spec animation.
                    /** @type {?} */
                    var animationClass = "mat-progress-spinner-indeterminate" + (this._fallbackAnimation ? '-fallback' : '') + "-animation";
                    element.classList.add(animationClass);
                };
                Object.defineProperty(MatProgressSpinner.prototype, "_circleRadius", {
                    /**
                     * The radius of the spinner, adjusted for stroke width.
                     * @return {?}
                     */
                    get: function () {
                        return (this.diameter - BASE_STROKE_WIDTH) / 2;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressSpinner.prototype, "_viewBox", {
                    /**
                     * The view box of the spinner's svg element.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var viewBox = this._circleRadius * 2 + this.strokeWidth;
                        return "0 0 " + viewBox + " " + viewBox;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressSpinner.prototype, "_strokeCircumference", {
                    /**
                     * The stroke circumference of the svg circle.
                     * @return {?}
                     */
                    get: function () {
                        return 2 * Math.PI * this._circleRadius;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressSpinner.prototype, "_strokeDashOffset", {
                    /**
                     * The dash offset of the svg circle.
                     * @return {?}
                     */
                    get: function () {
                        if (this.mode === 'determinate') {
                            return this._strokeCircumference * (100 - this._value) / 100;
                        }
                        // In fallback mode set the circle to 80% and rotate it with CSS.
                        if (this._fallbackAnimation && this.mode === 'indeterminate') {
                            return this._strokeCircumference * 0.2;
                        }
                        return null;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatProgressSpinner.prototype, "_circleStrokeWidth", {
                    /**
                     * Stroke width of the circle in percent.
                     * @return {?}
                     */
                    get: function () {
                        return this.strokeWidth / this.diameter * 100;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Dynamically generates a style tag containing the correct animation for this diameter.
                 * @private
                 * @return {?}
                 */
                MatProgressSpinner.prototype._attachStyleNode = function () {
                    /** @type {?} */
                    var styleRoot = this._styleRoot;
                    /** @type {?} */
                    var currentDiameter = this._diameter;
                    /** @type {?} */
                    var diameters = MatProgressSpinner._diameters;
                    /** @type {?} */
                    var diametersForElement = diameters.get(styleRoot);
                    if (!diametersForElement || !diametersForElement.has(currentDiameter)) {
                        /** @type {?} */
                        var styleTag = this._document.createElement('style');
                        styleTag.setAttribute('mat-spinner-animation', currentDiameter + '');
                        styleTag.textContent = this._getAnimationText();
                        styleRoot.appendChild(styleTag);
                        if (!diametersForElement) {
                            diametersForElement = new Set();
                            diameters.set(styleRoot, diametersForElement);
                        }
                        diametersForElement.add(currentDiameter);
                    }
                };
                /**
                 * Generates animation styles adjusted for the spinner's diameter.
                 * @private
                 * @return {?}
                 */
                MatProgressSpinner.prototype._getAnimationText = function () {
                    return INDETERMINATE_ANIMATION_TEMPLATE
                        // Animation should begin at 5% and end at 80%
                        .replace(/START_VALUE/g, "" + 0.95 * this._strokeCircumference)
                        .replace(/END_VALUE/g, "" + 0.2 * this._strokeCircumference)
                        .replace(/DIAMETER/g, "" + this.diameter);
                };
                return MatProgressSpinner;
            }(_MatProgressSpinnerMixinBase));
            /**
             * Tracks diameters of existing instances to de-dupe generated styles (default d = 100).
             * We need to keep track of which elements the diameters were attached to, because for
             * elements in the Shadow DOM the style tags are attached to the shadow root, rather
             * than the document head.
             */
            MatProgressSpinner._diameters = new WeakMap();
            MatProgressSpinner.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'mat-progress-spinner',
                            exportAs: 'matProgressSpinner',
                            host: {
                                'role': 'progressbar',
                                'class': 'mat-progress-spinner',
                                '[class._mat-animation-noopable]': "_noopAnimations",
                                '[style.width.px]': 'diameter',
                                '[style.height.px]': 'diameter',
                                '[attr.aria-valuemin]': 'mode === "determinate" ? 0 : null',
                                '[attr.aria-valuemax]': 'mode === "determinate" ? 100 : null',
                                '[attr.aria-valuenow]': 'mode === "determinate" ? value : null',
                                '[attr.mode]': 'mode',
                            },
                            inputs: ['color'],
                            template: "<svg [style.width.px]=\"diameter\" [style.height.px]=\"diameter\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\" [ngSwitch]=\"mode === 'indeterminate'\"><circle *ngSwitchCase=\"true\" cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle><circle *ngSwitchCase=\"false\" cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
                            styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}._mat-animation-noopable.mat-progress-spinner circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition:none;animation:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatProgressSpinner.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_1__["Platform"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__["ANIMATION_MODULE_TYPE"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,] }] }
            ]; };
            MatProgressSpinner.propDecorators = {
                diameter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                strokeWidth: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                mode: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }]
            };
            /**
             * `<mat-spinner>` component.
             *
             * This is a component definition to be used as a convenience reference to create an
             * indeterminate `<mat-progress-spinner>` instance.
             */
            var MatSpinner = /** @class */ (function (_super_1) {
                __extends(MatSpinner, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} platform
                 * @param {?} document
                 * @param {?} animationMode
                 * @param {?=} defaults
                 */
                function MatSpinner(elementRef, platform, document, animationMode, defaults) {
                    var _this = _super_1.call(this, elementRef, platform, document, animationMode, defaults) || this;
                    _this.mode = 'indeterminate';
                    return _this;
                }
                return MatSpinner;
            }(MatProgressSpinner));
            MatSpinner.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'mat-spinner',
                            host: {
                                'role': 'progressbar',
                                'mode': 'indeterminate',
                                'class': 'mat-spinner mat-progress-spinner',
                                '[class._mat-animation-noopable]': "_noopAnimations",
                                '[style.width.px]': 'diameter',
                                '[style.height.px]': 'diameter',
                            },
                            inputs: ['color'],
                            template: "<svg [style.width.px]=\"diameter\" [style.height.px]=\"diameter\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\" [ngSwitch]=\"mode === 'indeterminate'\"><circle *ngSwitchCase=\"true\" cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle><circle *ngSwitchCase=\"false\" cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
                            styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}._mat-animation-noopable.mat-progress-spinner circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition:none;animation:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatSpinner.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_1__["Platform"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__["ANIMATION_MODULE_TYPE"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,] }] }
            ]; };
            /**
             * Gets the shadow root of an element, if supported and the element is inside the Shadow DOM.
             * @param {?} element
             * @param {?} _document
             * @return {?}
             */
            function _getShadowRoot(element, _document) {
                // TODO(crisbeto): see whether we should move this into the CDK
                // feature detection utilities once #15616 gets merged in.
                if (typeof window !== 'undefined') {
                    /** @type {?} */
                    var head = _document.head;
                    // Check whether the browser supports Shadow DOM.
                    if (head && ((( /** @type {?} */(head))).createShadowRoot || head.attachShadow)) {
                        /** @type {?} */
                        var rootNode = element.getRootNode ? element.getRootNode() : null;
                        // We need to take the `ShadowRoot` off of `window`, because the built-in types are
                        // incorrect. See https://github.com/Microsoft/TypeScript/issues/27929.
                        if (rootNode instanceof (( /** @type {?} */(window))).ShadowRoot) {
                            return rootNode;
                        }
                    }
                }
                return null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatProgressSpinnerModule = /** @class */ (function () {
                function MatProgressSpinnerModule() {
                }
                return MatProgressSpinnerModule;
            }());
            MatProgressSpinnerModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatCommonModule"], _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]],
                            exports: [
                                MatProgressSpinner,
                                MatSpinner,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_4__["MatCommonModule"]
                            ],
                            declarations: [
                                MatProgressSpinner,
                                MatSpinner
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=progress-spinner.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/radio.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/radio.js ***!
          \*********************************************************/
        /*! exports provided: MatRadioModule, MAT_RADIO_DEFAULT_OPTIONS_FACTORY, MAT_RADIO_DEFAULT_OPTIONS, MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR, MatRadioChange, MatRadioGroup, MatRadioButton */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRadioModule", function () { return MatRadioModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_RADIO_DEFAULT_OPTIONS_FACTORY", function () { return MAT_RADIO_DEFAULT_OPTIONS_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_RADIO_DEFAULT_OPTIONS", function () { return MAT_RADIO_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR", function () { return MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRadioChange", function () { return MatRadioChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRadioGroup", function () { return MatRadioGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRadioButton", function () { return MatRadioButton; });
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAT_RADIO_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["InjectionToken"]('mat-radio-default-options', {
                providedIn: 'root',
                factory: MAT_RADIO_DEFAULT_OPTIONS_FACTORY
            });
            /**
             * @return {?}
             */
            function MAT_RADIO_DEFAULT_OPTIONS_FACTORY() {
                return {
                    color: 'accent'
                };
            }
            // Increasing integer for generating unique ids for radio components.
            /** @type {?} */
            var nextUniqueId = 0;
            /**
             * Provider Expression that allows mat-radio-group to register as a ControlValueAccessor. This
             * allows it to support [(ngModel)] and ngControl.
             * \@docs-private
             * @type {?}
             */
            var MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatRadioGroup; })),
                multi: true
            };
            /**
             * Change event object emitted by MatRadio and MatRadioGroup.
             */
            var MatRadioChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} value
                 */
                function MatRadioChange(source, value) {
                    this.source = source;
                    this.value = value;
                }
                return MatRadioChange;
            }());
            /**
             * A group of radio buttons. May contain one or more `<mat-radio-button>` elements.
             */
            var MatRadioGroup = /** @class */ (function () {
                /**
                 * @param {?} _changeDetector
                 */
                function MatRadioGroup(_changeDetector) {
                    this._changeDetector = _changeDetector;
                    /**
                     * Selected value for the radio group.
                     */
                    this._value = null;
                    /**
                     * The HTML name attribute applied to radio buttons in this group.
                     */
                    this._name = "mat-radio-group-" + nextUniqueId++;
                    /**
                     * The currently selected radio button. Should match value.
                     */
                    this._selected = null;
                    /**
                     * Whether the `value` has been set to its initial value.
                     */
                    this._isInitialized = false;
                    /**
                     * Whether the labels should appear after or before the radio-buttons. Defaults to 'after'
                     */
                    this._labelPosition = 'after';
                    /**
                     * Whether the radio group is disabled.
                     */
                    this._disabled = false;
                    /**
                     * Whether the radio group is required.
                     */
                    this._required = false;
                    /**
                     * The method to be called in order to update ngModel
                     */
                    this._controlValueAccessorChangeFn = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * onTouch function registered via registerOnTouch (ControlValueAccessor).
                     * \@docs-private
                     */
                    this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * Event emitted when the group value changes.
                     * Change events are only emitted when the value changes due to user interaction with
                     * a radio button (the same behavior as `<input type-"radio">`).
                     */
                    this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                }
                Object.defineProperty(MatRadioGroup.prototype, "name", {
                    /**
                     * Name of the radio button group. All radio buttons inside this group will use this name.
                     * @return {?}
                     */
                    get: function () { return this._name; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._name = value;
                        this._updateRadioButtonNames();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioGroup.prototype, "labelPosition", {
                    /**
                     * Whether the labels should appear after or before the radio-buttons. Defaults to 'after'
                     * @return {?}
                     */
                    get: function () {
                        return this._labelPosition;
                    },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this._labelPosition = v === 'before' ? 'before' : 'after';
                        this._markRadiosForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioGroup.prototype, "value", {
                    /**
                     * Value for the radio-group. Should equal the value of the selected radio button if there is
                     * a corresponding radio button with a matching value. If there is not such a corresponding
                     * radio button, this value persists to be applied in case a new radio button is added with a
                     * matching value.
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) {
                        if (this._value !== newValue) {
                            // Set this before proceeding to ensure no circular loop occurs with selection.
                            this._value = newValue;
                            this._updateSelectedRadioFromValue();
                            this._checkSelectedRadioButton();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatRadioGroup.prototype._checkSelectedRadioButton = function () {
                    if (this._selected && !this._selected.checked) {
                        this._selected.checked = true;
                    }
                };
                Object.defineProperty(MatRadioGroup.prototype, "selected", {
                    /**
                     * The currently selected radio button. If set to a new radio button, the radio group value
                     * will be updated to match the new selected button.
                     * @return {?}
                     */
                    get: function () { return this._selected; },
                    /**
                     * @param {?} selected
                     * @return {?}
                     */
                    set: function (selected) {
                        this._selected = selected;
                        this.value = selected ? selected.value : null;
                        this._checkSelectedRadioButton();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioGroup.prototype, "disabled", {
                    /**
                     * Whether the radio group is disabled
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        this._markRadiosForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioGroup.prototype, "required", {
                    /**
                     * Whether the radio group is required
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        this._markRadiosForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Initialize properties once content children are available.
                 * This allows us to propagate relevant attributes to associated buttons.
                 * @return {?}
                 */
                MatRadioGroup.prototype.ngAfterContentInit = function () {
                    // Mark this component as initialized in AfterContentInit because the initial value can
                    // possibly be set by NgModel on MatRadioGroup, and it is possible that the OnInit of the
                    // NgModel occurs *after* the OnInit of the MatRadioGroup.
                    this._isInitialized = true;
                };
                /**
                 * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
                 * radio buttons upon their blur.
                 * @return {?}
                 */
                MatRadioGroup.prototype._touch = function () {
                    if (this.onTouched) {
                        this.onTouched();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                MatRadioGroup.prototype._updateRadioButtonNames = function () {
                    var _this = this;
                    if (this._radios) {
                        this._radios.forEach(( /**
                         * @param {?} radio
                         * @return {?}
                         */function (/**
                         * @param {?} radio
                         * @return {?}
                         */ radio) {
                            radio.name = _this.name;
                            radio._markForCheck();
                        }));
                    }
                };
                /**
                 * Updates the `selected` radio button from the internal _value state.
                 * @private
                 * @return {?}
                 */
                MatRadioGroup.prototype._updateSelectedRadioFromValue = function () {
                    var _this = this;
                    // If the value already matches the selected radio, do nothing.
                    /** @type {?} */
                    var isAlreadySelected = this._selected !== null && this._selected.value === this._value;
                    if (this._radios && !isAlreadySelected) {
                        this._selected = null;
                        this._radios.forEach(( /**
                         * @param {?} radio
                         * @return {?}
                         */function (/**
                         * @param {?} radio
                         * @return {?}
                         */ radio) {
                            radio.checked = _this.value === radio.value;
                            if (radio.checked) {
                                _this._selected = radio;
                            }
                        }));
                    }
                };
                /**
                 * Dispatch change event with current selection and group value.
                 * @return {?}
                 */
                MatRadioGroup.prototype._emitChangeEvent = function () {
                    if (this._isInitialized) {
                        this.change.emit(new MatRadioChange(( /** @type {?} */(this._selected)), this._value));
                    }
                };
                /**
                 * @return {?}
                 */
                MatRadioGroup.prototype._markRadiosForCheck = function () {
                    if (this._radios) {
                        this._radios.forEach(( /**
                         * @param {?} radio
                         * @return {?}
                         */function (/**
                         * @param {?} radio
                         * @return {?}
                         */ radio) { return radio._markForCheck(); }));
                    }
                };
                /**
                 * Sets the model value. Implemented as part of ControlValueAccessor.
                 * @param {?} value
                 * @return {?}
                 */
                MatRadioGroup.prototype.writeValue = function (value) {
                    this.value = value;
                    this._changeDetector.markForCheck();
                };
                /**
                 * Registers a callback to be triggered when the model value changes.
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn Callback to be registered.
                 * @return {?}
                 */
                MatRadioGroup.prototype.registerOnChange = function (fn) {
                    this._controlValueAccessorChangeFn = fn;
                };
                /**
                 * Registers a callback to be triggered when the control is touched.
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn Callback to be registered.
                 * @return {?}
                 */
                MatRadioGroup.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                /**
                 * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
                 * @param {?} isDisabled Whether the control should be disabled.
                 * @return {?}
                 */
                MatRadioGroup.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                    this._changeDetector.markForCheck();
                };
                return MatRadioGroup;
            }());
            MatRadioGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Directive"], args: [{
                            selector: 'mat-radio-group',
                            exportAs: 'matRadioGroup',
                            providers: [MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                            host: {
                                'role': 'radiogroup',
                                'class': 'mat-radio-group',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatRadioGroup.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] }
            ]; };
            MatRadioGroup.propDecorators = {
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                _radios: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ContentChildren"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["forwardRef"])(( /**
                                         * @return {?}
                                         */function () { return MatRadioButton; })), { descendants: true },] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                labelPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }]
            };
            // Boilerplate for applying mixins to MatRadioButton.
            /**
             * \@docs-private
             */
            var MatRadioButtonBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatRadioButtonBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatRadioButtonBase;
            }());
            // As per Material design specifications the selection control radio should use the accent color
            // palette by default. https://material.io/guidelines/components/selection-controls.html
            /** @type {?} */
            var _MatRadioButtonMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinTabIndex"])(MatRadioButtonBase));
            /**
             * A Material design radio-button. Typically placed inside of `<mat-radio-group>` elements.
             */
            var MatRadioButton = /** @class */ (function (_super_1) {
                __extends(MatRadioButton, _super_1);
                /**
                 * @param {?} radioGroup
                 * @param {?} elementRef
                 * @param {?} _changeDetector
                 * @param {?} _focusMonitor
                 * @param {?} _radioDispatcher
                 * @param {?=} _animationMode
                 * @param {?=} _providerOverride
                 */
                function MatRadioButton(radioGroup, elementRef, _changeDetector, _focusMonitor, _radioDispatcher, _animationMode, _providerOverride) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._changeDetector = _changeDetector;
                    _this._focusMonitor = _focusMonitor;
                    _this._radioDispatcher = _radioDispatcher;
                    _this._animationMode = _animationMode;
                    _this._providerOverride = _providerOverride;
                    _this._uniqueId = "mat-radio-" + ++nextUniqueId;
                    /**
                     * The unique ID for the radio button.
                     */
                    _this.id = _this._uniqueId;
                    /**
                     * Event emitted when the checked state of this radio button changes.
                     * Change events are only emitted when the value changes due to user interaction with
                     * the radio button (the same behavior as `<input type-"radio">`).
                     */
                    _this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                    /**
                     * Whether this radio is checked.
                     */
                    _this._checked = false;
                    /**
                     * Value assigned to this radio.
                     */
                    _this._value = null;
                    /**
                     * Unregister function for _radioDispatcher
                     */
                    _this._removeUniqueSelectionListener = ( /**
                     * @return {?}
                     */function () { });
                    // Assertions. Ideally these should be stripped out by the compiler.
                    // TODO(jelbourn): Assert that there's no name binding AND a parent radio group.
                    _this.radioGroup = radioGroup;
                    _this._removeUniqueSelectionListener =
                        _radioDispatcher.listen(( /**
                         * @param {?} id
                         * @param {?} name
                         * @return {?}
                         */function (id, name) {
                            if (id !== _this.id && name === _this.name) {
                                _this.checked = false;
                            }
                        }));
                    return _this;
                }
                Object.defineProperty(MatRadioButton.prototype, "checked", {
                    /**
                     * Whether this radio button is checked.
                     * @return {?}
                     */
                    get: function () { return this._checked; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newCheckedState = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        if (this._checked !== newCheckedState) {
                            this._checked = newCheckedState;
                            if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                                this.radioGroup.selected = this;
                            }
                            else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                                // When unchecking the selected radio button, update the selected radio
                                // property on the group.
                                this.radioGroup.selected = null;
                            }
                            if (newCheckedState) {
                                // Notify all radio buttons with the same name to un-check.
                                this._radioDispatcher.notify(this.id, this.name);
                            }
                            this._changeDetector.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioButton.prototype, "value", {
                    /**
                     * The value of this radio button.
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._value !== value) {
                            this._value = value;
                            if (this.radioGroup !== null) {
                                if (!this.checked) {
                                    // Update checked when the value changed to match the radio group's value
                                    this.checked = this.radioGroup.value === value;
                                }
                                if (this.checked) {
                                    this.radioGroup.selected = this;
                                }
                            }
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioButton.prototype, "labelPosition", {
                    /**
                     * Whether the label should appear after or before the radio button. Defaults to 'after'
                     * @return {?}
                     */
                    get: function () {
                        return this._labelPosition || (this.radioGroup && this.radioGroup.labelPosition) || 'after';
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._labelPosition = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioButton.prototype, "disabled", {
                    /**
                     * Whether the radio button is disabled.
                     * @return {?}
                     */
                    get: function () {
                        return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var newDisabledState = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                        if (this._disabled !== newDisabledState) {
                            this._disabled = newDisabledState;
                            this._changeDetector.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioButton.prototype, "required", {
                    /**
                     * Whether the radio button is required.
                     * @return {?}
                     */
                    get: function () {
                        return this._required || (this.radioGroup && this.radioGroup.required);
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_1__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioButton.prototype, "color", {
                    /**
                     * Theme color of the radio button.
                     * @return {?}
                     */
                    get: function () {
                        return this._color ||
                            (this.radioGroup && this.radioGroup.color) ||
                            this._providerOverride && this._providerOverride.color || 'accent';
                    },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) { this._color = newValue; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatRadioButton.prototype, "inputId", {
                    /**
                     * ID of the native input element inside `<mat-radio-button>`
                     * @return {?}
                     */
                    get: function () { return (this.id || this._uniqueId) + "-input"; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Focuses the radio button.
                 * @param {?=} options
                 * @return {?}
                 */
                MatRadioButton.prototype.focus = function (options) {
                    this._focusMonitor.focusVia(this._inputElement, 'keyboard', options);
                };
                /**
                 * Marks the radio button as needing checking for change detection.
                 * This method is exposed because the parent radio group will directly
                 * update bound properties of the radio button.
                 * @return {?}
                 */
                MatRadioButton.prototype._markForCheck = function () {
                    // When group value changes, the button will not be notified. Use `markForCheck` to explicit
                    // update radio button's status
                    this._changeDetector.markForCheck();
                };
                /**
                 * @return {?}
                 */
                MatRadioButton.prototype.ngOnInit = function () {
                    if (this.radioGroup) {
                        // If the radio is inside a radio group, determine if it should be checked
                        this.checked = this.radioGroup.value === this._value;
                        // Copy name from parent radio group
                        this.name = this.radioGroup.name;
                    }
                };
                /**
                 * @return {?}
                 */
                MatRadioButton.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    this._focusMonitor
                        .monitor(this._elementRef, true)
                        .subscribe(( /**
                 * @param {?} focusOrigin
                 * @return {?}
                 */function (/**
                 * @param {?} focusOrigin
                 * @return {?}
                 */ focusOrigin) {
                        if (!focusOrigin && _this.radioGroup) {
                            _this.radioGroup._touch();
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                MatRadioButton.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this._elementRef);
                    this._removeUniqueSelectionListener();
                };
                /**
                 * Dispatch change event with current value.
                 * @private
                 * @return {?}
                 */
                MatRadioButton.prototype._emitChangeEvent = function () {
                    this.change.emit(new MatRadioChange(this, this._value));
                };
                /**
                 * @return {?}
                 */
                MatRadioButton.prototype._isRippleDisabled = function () {
                    return this.disableRipple || this.disabled;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatRadioButton.prototype._onInputClick = function (event) {
                    // We have to stop propagation for click events on the visual hidden input element.
                    // By default, when a user clicks on a label element, a generated click event will be
                    // dispatched on the associated input element. Since we are using a label element as our
                    // root container, the click event on the `radio-button` will be executed twice.
                    // The real click event will bubble up, and the generated click event also tries to bubble up.
                    // This will lead to multiple click events.
                    // Preventing bubbling for the second event will solve that issue.
                    event.stopPropagation();
                };
                /**
                 * Triggered when the radio button received a click or the input recognized any change.
                 * Clicking on a label element, will trigger a change event on the associated input.
                 * @param {?} event
                 * @return {?}
                 */
                MatRadioButton.prototype._onInputChange = function (event) {
                    // We always have to stop propagation on the change event.
                    // Otherwise the change event, from the input element, will bubble up and
                    // emit its event object to the `change` output.
                    event.stopPropagation();
                    /** @type {?} */
                    var groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
                    this.checked = true;
                    this._emitChangeEvent();
                    if (this.radioGroup) {
                        this.radioGroup._controlValueAccessorChangeFn(this.value);
                        if (groupValueChanged) {
                            this.radioGroup._emitChangeEvent();
                        }
                    }
                };
                return MatRadioButton;
            }(_MatRadioButtonMixinBase));
            MatRadioButton.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"], args: [{ selector: 'mat-radio-button',
                            template: "<label [attr.for]=\"inputId\" class=\"mat-radio-label\" #label><div class=\"mat-radio-container\"><div class=\"mat-radio-outer-circle\"></div><div class=\"mat-radio-inner-circle\"></div><div mat-ripple class=\"mat-radio-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"true\" [matRippleRadius]=\"20\" [matRippleAnimation]=\"{enterDuration: 150}\"><div class=\"mat-ripple-element mat-radio-persistent-ripple\"></div></div><input #input class=\"mat-radio-input cdk-visually-hidden\" type=\"radio\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled\" [tabIndex]=\"tabIndex\" [attr.name]=\"name\" [attr.value]=\"value\" [required]=\"required\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-describedby]=\"ariaDescribedby\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"></div><div class=\"mat-radio-label-content\" [class.mat-radio-label-before]=\"labelPosition == 'before'\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></div></label>",
                            styles: [".mat-radio-button{display:inline-block;-webkit-tap-highlight-color:transparent;outline:0}.mat-radio-label{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;display:inline-flex;align-items:center;white-space:nowrap;vertical-align:middle;width:100%}.mat-radio-container{box-sizing:border-box;display:inline-block;position:relative;width:20px;height:20px;flex-shrink:0}.mat-radio-outer-circle{box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:border-color ease 280ms;width:20px;border-width:2px;border-style:solid;border-radius:50%}._mat-animation-noopable .mat-radio-outer-circle{transition:none}.mat-radio-inner-circle{border-radius:50%;box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:transform ease 280ms,background-color ease 280ms;width:20px;transform:scale(.001)}._mat-animation-noopable .mat-radio-inner-circle{transition:none}.mat-radio-checked .mat-radio-inner-circle{transform:scale(.5)}@media (-ms-high-contrast:active){.mat-radio-checked .mat-radio-inner-circle{border:solid 10px}}.mat-radio-label-content{-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto;display:inline-block;order:0;line-height:inherit;padding-left:8px;padding-right:0}[dir=rtl] .mat-radio-label-content{padding-right:8px;padding-left:0}.mat-radio-label-content.mat-radio-label-before{order:-1;padding-left:0;padding-right:8px}[dir=rtl] .mat-radio-label-content.mat-radio-label-before{padding-right:0;padding-left:8px}.mat-radio-disabled,.mat-radio-disabled .mat-radio-label{cursor:default}.mat-radio-button .mat-radio-ripple{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none}.mat-radio-button .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple){opacity:.16}.mat-radio-persistent-ripple{width:100%;height:100%;transform:none}.mat-radio-container:hover .mat-radio-persistent-ripple{opacity:.04}.mat-radio-button:not(.mat-radio-disabled).cdk-keyboard-focused .mat-radio-persistent-ripple,.mat-radio-button:not(.mat-radio-disabled).cdk-program-focused .mat-radio-persistent-ripple{opacity:.12}.mat-radio-disabled .mat-radio-container:hover .mat-radio-persistent-ripple,.mat-radio-persistent-ripple{opacity:0}@media (hover:none){.mat-radio-container:hover .mat-radio-persistent-ripple{display:none}}.mat-radio-input{bottom:0;left:50%}@media (-ms-high-contrast:active){.mat-radio-disabled{opacity:.5}}"],
                            inputs: ['disableRipple', 'tabIndex'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewEncapsulation"].None,
                            exportAs: 'matRadioButton',
                            host: {
                                'class': 'mat-radio-button',
                                '[class.mat-radio-checked]': 'checked',
                                '[class.mat-radio-disabled]': 'disabled',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                                '[class.mat-primary]': 'color === "primary"',
                                '[class.mat-accent]': 'color === "accent"',
                                '[class.mat-warn]': 'color === "warn"',
                                // Needs to be -1 so the `focus` event still fires.
                                '[attr.tabindex]': '-1',
                                '[attr.id]': 'id',
                                '[attr.aria-label]': 'null',
                                '[attr.aria-labelledby]': 'null',
                                '[attr.aria-describedby]': 'null',
                                // Note: under normal conditions focus shouldn't land on this element, however it may be
                                // programmatically set, for example inside of a focus trap, in this case we want to forward
                                // the focus to the native element.
                                '(focus)': '_inputElement.nativeElement.focus()',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatRadioButton.ctorParameters = function () { return [
                { type: MatRadioGroup, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ChangeDetectorRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["FocusMonitor"] },
                { type: _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_2__["UniqueSelectionDispatcher"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__["ANIMATION_MODULE_TYPE"],] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [MAT_RADIO_DEFAULT_OPTIONS,] }] }
            ]; };
            MatRadioButton.propDecorators = {
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['aria-labelledby',] }],
                ariaDescribedby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"], args: ['aria-describedby',] }],
                checked: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                labelPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Output"] }],
                _inputElement: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"], args: ['input', { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatRadioModule = /** @class */ (function () {
                function MatRadioModule() {
                }
                return MatRadioModule;
            }());
            MatRadioModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_7__["CommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatRippleModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatCommonModule"]],
                            exports: [MatRadioGroup, MatRadioButton, _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatCommonModule"]],
                            declarations: [MatRadioGroup, MatRadioButton],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=radio.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/select.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/select.js ***!
          \**********************************************************/
        /*! exports provided: MatSelectModule, MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY, SELECT_PANEL_MAX_HEIGHT, SELECT_PANEL_PADDING_X, SELECT_PANEL_INDENT_PADDING_X, SELECT_ITEM_HEIGHT_EM, SELECT_MULTIPLE_PANEL_PADDING_X, SELECT_PANEL_VIEWPORT_PADDING, MAT_SELECT_SCROLL_STRATEGY, MAT_SELECT_SCROLL_STRATEGY_PROVIDER, MatSelectChange, MatSelectTrigger, MatSelect, matSelectAnimations, transformPanel, fadeInContent */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSelectModule", function () { return MatSelectModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY", function () { return MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_MAX_HEIGHT", function () { return SELECT_PANEL_MAX_HEIGHT; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_PADDING_X", function () { return SELECT_PANEL_PADDING_X; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_INDENT_PADDING_X", function () { return SELECT_PANEL_INDENT_PADDING_X; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_ITEM_HEIGHT_EM", function () { return SELECT_ITEM_HEIGHT_EM; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_MULTIPLE_PANEL_PADDING_X", function () { return SELECT_MULTIPLE_PANEL_PADDING_X; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_PANEL_VIEWPORT_PADDING", function () { return SELECT_PANEL_VIEWPORT_PADDING; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECT_SCROLL_STRATEGY", function () { return MAT_SELECT_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SELECT_SCROLL_STRATEGY_PROVIDER", function () { return MAT_SELECT_SCROLL_STRATEGY_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSelectChange", function () { return MatSelectChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSelectTrigger", function () { return MatSelectTrigger; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSelect", function () { return MatSelect; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matSelectAnimations", function () { return matSelectAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformPanel", function () { return transformPanel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fadeInContent", function () { return fadeInContent; });
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The following are all the animations for the mat-select component, with each
             * const containing the metadata for one animation.
             *
             * The values below match the implementation of the AngularJS Material mat-select animation.
             * \@docs-private
             * @type {?}
             */
            var matSelectAnimations = {
                /**
                 * This animation ensures the select's overlay panel animation (transformPanel) is called when
                 * closing the select.
                 * This is needed due to https://github.com/angular/angular/issues/23302
                 */
                transformPanelWrap: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('transformPanelWrap', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["query"])('@transformPanel', [Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animateChild"])()], { optional: true }))
                ]),
                /**
                 * This animation transforms the select's overlay panel on and off the page.
                 *
                 * When the panel is attached to the DOM, it expands its width by the amount of padding, scales it
                 * up to 100% on the Y axis, fades in its border, and translates slightly up and to the
                 * side to ensure the option text correctly overlaps the trigger text.
                 *
                 * When the panel is removed from the DOM, it simply fades out linearly.
                 */
                transformPanel: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('transformPanel', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                        transform: 'scaleY(0.8)',
                        minWidth: '100%',
                        opacity: 0
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('showing', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                        opacity: 1,
                        minWidth: 'calc(100% + 32px)',
                        // 32px = 2 * 16px padding
                        transform: 'scaleY(1)'
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('showing-multiple', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                        opacity: 1,
                        minWidth: 'calc(100% + 64px)',
                        // 64px = 48px padding on the left + 16px padding on the right
                        transform: 'scaleY(1)'
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('void => *', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('120ms cubic-bezier(0, 0, 0.2, 1)')),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('100ms 25ms linear', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0 })))
                ]),
                /**
                 * This animation fades in the background color and text content of the
                 * select's options. It is time delayed to occur 100ms after the overlay
                 * panel has transformed in.
                 * @deprecated Not used anymore. To be removed.
                 * \@breaking-change 8.0.0
                 */
                fadeInContent: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('fadeInContent', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('showing', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 1 })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('void => showing', [
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0 }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('150ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
                    ])
                ])
            };
            /**
             * @deprecated
             * \@breaking-change 8.0.0
             * \@docs-private
             * @type {?}
             */
            var transformPanel = matSelectAnimations.transformPanel;
            /**
             * @deprecated
             * \@breaking-change 8.0.0
             * \@docs-private
             * @type {?}
             */
            var fadeInContent = matSelectAnimations.fadeInContent;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Returns an exception to be thrown when attempting to change a select's `multiple` option
             * after initialization.
             * \@docs-private
             * @return {?}
             */
            function getMatSelectDynamicMultipleError() {
                return Error('Cannot change `multiple` mode of select after initialization.');
            }
            /**
             * Returns an exception to be thrown when attempting to assign a non-array value to a select
             * in `multiple` mode. Note that `undefined` and `null` are still valid values to allow for
             * resetting the value.
             * \@docs-private
             * @return {?}
             */
            function getMatSelectNonArrayValueError() {
                return Error('Value must be an array in multiple-selection mode.');
            }
            /**
             * Returns an exception to be thrown when assigning a non-function value to the comparator
             * used to determine if a value corresponds to an option. Note that whether the function
             * actually takes two values and returns a boolean is not checked.
             * @return {?}
             */
            function getMatSelectNonFunctionValueError() {
                return Error('`compareWith` must be a function.');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var nextUniqueId = 0;
            /**
             * The max height of the select's overlay panel
             * @type {?}
             */
            var SELECT_PANEL_MAX_HEIGHT = 256;
            /**
             * The panel's padding on the x-axis
             * @type {?}
             */
            var SELECT_PANEL_PADDING_X = 16;
            /**
             * The panel's x axis padding if it is indented (e.g. there is an option group).
             * @type {?}
             */
            var SELECT_PANEL_INDENT_PADDING_X = SELECT_PANEL_PADDING_X * 2;
            /**
             * The height of the select items in `em` units.
             * @type {?}
             */
            var SELECT_ITEM_HEIGHT_EM = 3;
            // TODO(josephperrott): Revert to a constant after 2018 spec updates are fully merged.
            /**
             * Distance between the panel edge and the option text in
             * multi-selection mode.
             *
             * Calculated as:
             * (SELECT_PANEL_PADDING_X * 1.5) + 16 = 40
             * The padding is multiplied by 1.5 because the checkbox's margin is half the padding.
             * The checkbox width is 16px.
             * @type {?}
             */
            var SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_PANEL_PADDING_X * 1.5 + 16;
            /**
             * The select panel will only "fit" inside the viewport if it is positioned at
             * this value or more away from the viewport boundary.
             * @type {?}
             */
            var SELECT_PANEL_VIEWPORT_PADDING = 8;
            /**
             * Injection token that determines the scroll handling while a select is open.
             * @type {?}
             */
            var MAT_SELECT_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["InjectionToken"]('mat-select-scroll-strategy');
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.reposition(); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_SELECT_SCROLL_STRATEGY_PROVIDER = {
                provide: MAT_SELECT_SCROLL_STRATEGY,
                deps: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["Overlay"]],
                useFactory: MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY,
            };
            /**
             * Change event object that is emitted when the select value has changed.
             */
            var MatSelectChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} value
                 */
                function MatSelectChange(source, value) {
                    this.source = source;
                    this.value = value;
                }
                return MatSelectChange;
            }());
            // Boilerplate for applying mixins to MatSelect.
            /**
             * \@docs-private
             */
            var MatSelectBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _defaultErrorStateMatcher
                 * @param {?} _parentForm
                 * @param {?} _parentFormGroup
                 * @param {?} ngControl
                 */
                function MatSelectBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
                    this._elementRef = _elementRef;
                    this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
                    this._parentForm = _parentForm;
                    this._parentFormGroup = _parentFormGroup;
                    this.ngControl = ngControl;
                }
                return MatSelectBase;
            }());
            /** @type {?} */
            var _MatSelectMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["mixinTabIndex"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["mixinDisabled"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["mixinErrorState"])(MatSelectBase))));
            /**
             * Allows the user to customize the trigger that is displayed when the select has a value.
             */
            var MatSelectTrigger = /** @class */ (function () {
                function MatSelectTrigger() {
                }
                return MatSelectTrigger;
            }());
            MatSelectTrigger.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Directive"], args: [{
                            selector: 'mat-select-trigger'
                        },] },
            ];
            var MatSelect = /** @class */ (function (_super_1) {
                __extends(MatSelect, _super_1);
                /**
                 * @param {?} _viewportRuler
                 * @param {?} _changeDetectorRef
                 * @param {?} _ngZone
                 * @param {?} _defaultErrorStateMatcher
                 * @param {?} elementRef
                 * @param {?} _dir
                 * @param {?} _parentForm
                 * @param {?} _parentFormGroup
                 * @param {?} _parentFormField
                 * @param {?} ngControl
                 * @param {?} tabIndex
                 * @param {?} scrollStrategyFactory
                 * @param {?=} _liveAnnouncer
                 */
                function MatSelect(_viewportRuler, _changeDetectorRef, _ngZone, _defaultErrorStateMatcher, elementRef, _dir, _parentForm, _parentFormGroup, _parentFormField, ngControl, tabIndex, scrollStrategyFactory, _liveAnnouncer) {
                    var _this = _super_1.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
                    _this._viewportRuler = _viewportRuler;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._ngZone = _ngZone;
                    _this._dir = _dir;
                    _this._parentFormField = _parentFormField;
                    _this.ngControl = ngControl;
                    _this._liveAnnouncer = _liveAnnouncer;
                    /**
                     * Whether or not the overlay panel is open.
                     */
                    _this._panelOpen = false;
                    /**
                     * Whether filling out the select is required in the form.
                     */
                    _this._required = false;
                    /**
                     * The scroll position of the overlay panel, calculated to center the selected option.
                     */
                    _this._scrollTop = 0;
                    /**
                     * Whether the component is in multiple selection mode.
                     */
                    _this._multiple = false;
                    /**
                     * Comparison function to specify which option is displayed. Defaults to object equality.
                     */
                    _this._compareWith = ( /**
                     * @param {?} o1
                     * @param {?} o2
                     * @return {?}
                     */function (o1, o2) { return o1 === o2; });
                    /**
                     * Unique id for this input.
                     */
                    _this._uid = "mat-select-" + nextUniqueId++;
                    /**
                     * Emits whenever the component is destroyed.
                     */
                    _this._destroy = new rxjs__WEBPACK_IMPORTED_MODULE_12__["Subject"]();
                    /**
                     * The cached font-size of the trigger element.
                     */
                    _this._triggerFontSize = 0;
                    /**
                     * `View -> model callback called when value changes`
                     */
                    _this._onChange = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * `View -> model callback called when select has been touched`
                     */
                    _this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * The IDs of child options to be passed to the aria-owns attribute.
                     */
                    _this._optionIds = '';
                    /**
                     * The value of the select panel's transform-origin property.
                     */
                    _this._transformOrigin = 'top';
                    /**
                     * Emits when the panel element is finished transforming in.
                     */
                    _this._panelDoneAnimatingStream = new rxjs__WEBPACK_IMPORTED_MODULE_12__["Subject"]();
                    /**
                     * The y-offset of the overlay panel in relation to the trigger's top start corner.
                     * This must be adjusted to align the selected option text over the trigger text.
                     * when the panel opens. Will change based on the y-position of the selected option.
                     */
                    _this._offsetY = 0;
                    /**
                     * This position config ensures that the top "start" corner of the overlay
                     * is aligned with with the top "start" of the origin by default (overlapping
                     * the trigger completely). If the panel cannot fit below the trigger, it
                     * will fall back to a position above the trigger.
                     */
                    _this._positions = [
                        {
                            originX: 'start',
                            originY: 'top',
                            overlayX: 'start',
                            overlayY: 'top',
                        },
                        {
                            originX: 'start',
                            originY: 'bottom',
                            overlayX: 'start',
                            overlayY: 'bottom',
                        },
                    ];
                    /**
                     * Whether the component is disabling centering of the active option over the trigger.
                     */
                    _this._disableOptionCentering = false;
                    _this._focused = false;
                    /**
                     * A name for this control that can be used by `mat-form-field`.
                     */
                    _this.controlType = 'mat-select';
                    /**
                     * Aria label of the select. If not specified, the placeholder will be used as label.
                     */
                    _this.ariaLabel = '';
                    /**
                     * Combined stream of all of the child options' change events.
                     */
                    _this.optionSelectionChanges = ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_12__["defer"])(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var options = _this.options;
                        if (options) {
                            return options.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["startWith"])(options), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["switchMap"])(( /**
                             * @return {?}
                             */function () { return Object(rxjs__WEBPACK_IMPORTED_MODULE_12__["merge"]).apply(void 0, options.map(( /**
                             * @param {?} option
                             * @return {?}
                             */function (/**
                             * @param {?} option
                             * @return {?}
                             */ option) { return option.onSelectionChange; }))); })));
                        }
                        return _this._ngZone.onStable
                            .asObservable()
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["switchMap"])(( /**
                     * @return {?}
                     */function () { return _this.optionSelectionChanges; })));
                    }))));
                    /**
                     * Event emitted when the select panel has been toggled.
                     */
                    _this.openedChange = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"]();
                    /**
                     * Event emitted when the select has been opened.
                     */
                    _this._openedStream = _this.openedChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["filter"])(( /**
                     * @param {?} o
                     * @return {?}
                     */function (/**
                     * @param {?} o
                     * @return {?}
                     */ o) { return o; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["map"])(( /**
                     * @return {?}
                     */function () { })));
                    /**
                     * Event emitted when the select has been closed.
                     */
                    _this._closedStream = _this.openedChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["filter"])(( /**
                     * @param {?} o
                     * @return {?}
                     */function (/**
                     * @param {?} o
                     * @return {?}
                     */ o) { return !o; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["map"])(( /**
                     * @return {?}
                     */function () { })));
                    /**
                     * Event emitted when the selected value has been changed by the user.
                     */
                    _this.selectionChange = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"]();
                    /**
                     * Event that emits whenever the raw value of the select changes. This is here primarily
                     * to facilitate the two-way binding for the `value` input.
                     * \@docs-private
                     */
                    _this.valueChange = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"]();
                    if (_this.ngControl) {
                        // Note: we provide the value accessor through here, instead of
                        // the `providers` to avoid running into a circular import.
                        _this.ngControl.valueAccessor = _this;
                    }
                    _this._scrollStrategyFactory = scrollStrategyFactory;
                    _this._scrollStrategy = _this._scrollStrategyFactory();
                    _this.tabIndex = parseInt(tabIndex) || 0;
                    // Force setter to be called in case id was not specified.
                    _this.id = _this.id;
                    return _this;
                }
                Object.defineProperty(MatSelect.prototype, "focused", {
                    /**
                     * Whether the select is focused.
                     * @return {?}
                     */
                    get: function () {
                        return this._focused || this._panelOpen;
                    },
                    /**
                     * @deprecated Setter to be removed as this property is intended to be readonly.
                     * \@breaking-change 8.0.0
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._focused = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "placeholder", {
                    /**
                     * Placeholder to be shown if no value has been selected.
                     * @return {?}
                     */
                    get: function () { return this._placeholder; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._placeholder = value;
                        this.stateChanges.next();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "required", {
                    /**
                     * Whether the component is required.
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                        this.stateChanges.next();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "multiple", {
                    /**
                     * Whether the user should be allowed to select multiple options.
                     * @return {?}
                     */
                    get: function () { return this._multiple; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._selectionModel) {
                            throw getMatSelectDynamicMultipleError();
                        }
                        this._multiple = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "disableOptionCentering", {
                    /**
                     * Whether to center the active option over the trigger.
                     * @return {?}
                     */
                    get: function () { return this._disableOptionCentering; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disableOptionCentering = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "compareWith", {
                    /**
                     * Function to compare the option values with the selected values. The first argument
                     * is a value from an option. The second is a value from the selection. A boolean
                     * should be returned.
                     * @return {?}
                     */
                    get: function () { return this._compareWith; },
                    /**
                     * @param {?} fn
                     * @return {?}
                     */
                    set: function (fn) {
                        if (typeof fn !== 'function') {
                            throw getMatSelectNonFunctionValueError();
                        }
                        this._compareWith = fn;
                        if (this._selectionModel) {
                            // A different comparator means the selection could change.
                            this._initializeSelection();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "value", {
                    /**
                     * Value of the select control.
                     * @return {?}
                     */
                    get: function () { return this._value; },
                    /**
                     * @param {?} newValue
                     * @return {?}
                     */
                    set: function (newValue) {
                        if (newValue !== this._value) {
                            this.writeValue(newValue);
                            this._value = newValue;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "id", {
                    /**
                     * Unique id of the element.
                     * @return {?}
                     */
                    get: function () { return this._id; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._id = value || this._uid;
                        this.stateChanges.next();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatSelect.prototype.ngOnInit = function () {
                    var _this = this;
                    this._selectionModel = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_4__["SelectionModel"](this.multiple);
                    this.stateChanges.next();
                    // We need `distinctUntilChanged` here, because some browsers will
                    // fire the animation end event twice for the same animation. See:
                    // https://github.com/angular/angular/issues/24084
                    this._panelDoneAnimatingStream
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["distinctUntilChanged"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroy))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        if (_this.panelOpen) {
                            _this._scrollTop = 0;
                            _this.openedChange.emit(true);
                        }
                        else {
                            _this.openedChange.emit(false);
                            _this.overlayDir.offsetX = 0;
                            _this._changeDetectorRef.markForCheck();
                        }
                    }));
                    this._viewportRuler.change()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroy))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        if (_this._panelOpen) {
                            _this._triggerRect = _this.trigger.nativeElement.getBoundingClientRect();
                            _this._changeDetectorRef.markForCheck();
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                MatSelect.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._initKeyManager();
                    this._selectionModel.onChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroy)).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        event.added.forEach(( /**
                         * @param {?} option
                         * @return {?}
                         */function (/**
                         * @param {?} option
                         * @return {?}
                         */ option) { return option.select(); }));
                        event.removed.forEach(( /**
                         * @param {?} option
                         * @return {?}
                         */function (/**
                         * @param {?} option
                         * @return {?}
                         */ option) { return option.deselect(); }));
                    }));
                    this.options.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["startWith"])(null), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroy)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._resetOptions();
                        _this._initializeSelection();
                    }));
                };
                /**
                 * @return {?}
                 */
                MatSelect.prototype.ngDoCheck = function () {
                    if (this.ngControl) {
                        this.updateErrorState();
                    }
                };
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatSelect.prototype.ngOnChanges = function (changes) {
                    // Updating the disabled state is handled by `mixinDisabled`, but we need to additionally let
                    // the parent form field know to run change detection when the disabled state changes.
                    if (changes['disabled']) {
                        this.stateChanges.next();
                    }
                    if (changes['typeaheadDebounceInterval'] && this._keyManager) {
                        this._keyManager.withTypeAhead(this.typeaheadDebounceInterval);
                    }
                };
                /**
                 * @return {?}
                 */
                MatSelect.prototype.ngOnDestroy = function () {
                    this._destroy.next();
                    this._destroy.complete();
                    this.stateChanges.complete();
                };
                /**
                 * Toggles the overlay panel open or closed.
                 * @return {?}
                 */
                MatSelect.prototype.toggle = function () {
                    this.panelOpen ? this.close() : this.open();
                };
                /**
                 * Opens the overlay panel.
                 * @return {?}
                 */
                MatSelect.prototype.open = function () {
                    var _this = this;
                    if (this.disabled || !this.options || !this.options.length || this._panelOpen) {
                        return;
                    }
                    this._triggerRect = this.trigger.nativeElement.getBoundingClientRect();
                    // Note: The computed font-size will be a string pixel value (e.g. "16px").
                    // `parseInt` ignores the trailing 'px' and converts this to a number.
                    this._triggerFontSize = parseInt(getComputedStyle(this.trigger.nativeElement).fontSize || '0');
                    this._panelOpen = true;
                    this._keyManager.withHorizontalOrientation(null);
                    this._calculateOverlayPosition();
                    this._highlightCorrectOption();
                    this._changeDetectorRef.markForCheck();
                    // Set the font size on the panel element once it exists.
                    this._ngZone.onStable.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["take"])(1)).subscribe(( /**
                     * @return {?}
                     */function () {
                        if (_this._triggerFontSize && _this.overlayDir.overlayRef &&
                            _this.overlayDir.overlayRef.overlayElement) {
                            _this.overlayDir.overlayRef.overlayElement.style.fontSize = _this._triggerFontSize + "px";
                        }
                    }));
                };
                /**
                 * Closes the overlay panel and focuses the host element.
                 * @return {?}
                 */
                MatSelect.prototype.close = function () {
                    if (this._panelOpen) {
                        this._panelOpen = false;
                        this._keyManager.withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
                        this._changeDetectorRef.markForCheck();
                        this._onTouched();
                    }
                };
                /**
                 * Sets the select's value. Part of the ControlValueAccessor interface
                 * required to integrate with Angular's core forms API.
                 *
                 * @param {?} value New value to be written to the model.
                 * @return {?}
                 */
                MatSelect.prototype.writeValue = function (value) {
                    if (this.options) {
                        this._setSelectionByValue(value);
                    }
                };
                /**
                 * Saves a callback function to be invoked when the select's value
                 * changes from user input. Part of the ControlValueAccessor interface
                 * required to integrate with Angular's core forms API.
                 *
                 * @param {?} fn Callback to be triggered when the value changes.
                 * @return {?}
                 */
                MatSelect.prototype.registerOnChange = function (fn) {
                    this._onChange = fn;
                };
                /**
                 * Saves a callback function to be invoked when the select is blurred
                 * by the user. Part of the ControlValueAccessor interface required
                 * to integrate with Angular's core forms API.
                 *
                 * @param {?} fn Callback to be triggered when the component has been touched.
                 * @return {?}
                 */
                MatSelect.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                /**
                 * Disables the select. Part of the ControlValueAccessor interface required
                 * to integrate with Angular's core forms API.
                 *
                 * @param {?} isDisabled Sets whether the component is disabled.
                 * @return {?}
                 */
                MatSelect.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                    this._changeDetectorRef.markForCheck();
                    this.stateChanges.next();
                };
                Object.defineProperty(MatSelect.prototype, "panelOpen", {
                    /**
                     * Whether or not the overlay panel is open.
                     * @return {?}
                     */
                    get: function () {
                        return this._panelOpen;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "selected", {
                    /**
                     * The currently selected option.
                     * @return {?}
                     */
                    get: function () {
                        return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSelect.prototype, "triggerValue", {
                    /**
                     * The value displayed in the trigger.
                     * @return {?}
                     */
                    get: function () {
                        if (this.empty) {
                            return '';
                        }
                        if (this._multiple) {
                            /** @type {?} */
                            var selectedOptions = this._selectionModel.selected.map(( /**
                             * @param {?} option
                             * @return {?}
                             */function (/**
                             * @param {?} option
                             * @return {?}
                             */ option) { return option.viewValue; }));
                            if (this._isRtl()) {
                                selectedOptions.reverse();
                            }
                            // TODO(crisbeto): delimiter should be configurable for proper localization.
                            return selectedOptions.join(', ');
                        }
                        return this._selectionModel.selected[0].viewValue;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Whether the element is in RTL mode.
                 * @return {?}
                 */
                MatSelect.prototype._isRtl = function () {
                    return this._dir ? this._dir.value === 'rtl' : false;
                };
                /**
                 * Handles all keydown events on the select.
                 * @param {?} event
                 * @return {?}
                 */
                MatSelect.prototype._handleKeydown = function (event) {
                    if (!this.disabled) {
                        this.panelOpen ? this._handleOpenKeydown(event) : this._handleClosedKeydown(event);
                    }
                };
                /**
                 * Handles keyboard events while the select is closed.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                MatSelect.prototype._handleClosedKeydown = function (event) {
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var isArrowKey = keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["DOWN_ARROW"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["UP_ARROW"] ||
                        keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["LEFT_ARROW"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["RIGHT_ARROW"];
                    /** @type {?} */
                    var isOpenKey = keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["ENTER"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["SPACE"];
                    /** @type {?} */
                    var manager = this._keyManager;
                    // Open the select on ALT + arrow key to match the native <select>
                    if ((isOpenKey && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["hasModifierKey"])(event)) || ((this.multiple || event.altKey) && isArrowKey)) {
                        event.preventDefault(); // prevents the page from scrolling down when pressing space
                        this.open();
                    }
                    else if (!this.multiple) {
                        /** @type {?} */
                        var previouslySelectedOption = this.selected;
                        if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["HOME"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["END"]) {
                            keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["HOME"] ? manager.setFirstItemActive() : manager.setLastItemActive();
                            event.preventDefault();
                        }
                        else {
                            manager.onKeydown(event);
                        }
                        /** @type {?} */
                        var selectedOption = this.selected;
                        // Since the value has changed, we need to announce it ourselves.
                        // @breaking-change 8.0.0 remove null check for _liveAnnouncer.
                        if (this._liveAnnouncer && selectedOption && previouslySelectedOption !== selectedOption) {
                            // We set a duration on the live announcement, because we want the live element to be
                            // cleared after a while so that users can't navigate to it using the arrow keys.
                            this._liveAnnouncer.announce((( /** @type {?} */(selectedOption))).viewValue, 10000);
                        }
                    }
                };
                /**
                 * Handles keyboard events when the selected is open.
                 * @private
                 * @param {?} event
                 * @return {?}
                 */
                MatSelect.prototype._handleOpenKeydown = function (event) {
                    /** @type {?} */
                    var keyCode = event.keyCode;
                    /** @type {?} */
                    var isArrowKey = keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["DOWN_ARROW"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["UP_ARROW"];
                    /** @type {?} */
                    var manager = this._keyManager;
                    if (keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["HOME"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["END"]) {
                        event.preventDefault();
                        keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["HOME"] ? manager.setFirstItemActive() : manager.setLastItemActive();
                    }
                    else if (isArrowKey && event.altKey) {
                        // Close the select on ALT + arrow key to match the native <select>
                        event.preventDefault();
                        this.close();
                    }
                    else if ((keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["ENTER"] || keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["SPACE"]) && manager.activeItem &&
                        !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["hasModifierKey"])(event)) {
                        event.preventDefault();
                        manager.activeItem._selectViaInteraction();
                    }
                    else if (this._multiple && keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_5__["A"] && event.ctrlKey) {
                        event.preventDefault();
                        /** @type {?} */
                        var hasDeselectedOptions_1 = this.options.some(( /**
                         * @param {?} opt
                         * @return {?}
                         */function (/**
                         * @param {?} opt
                         * @return {?}
                         */ opt) { return !opt.disabled && !opt.selected; }));
                        this.options.forEach(( /**
                         * @param {?} option
                         * @return {?}
                         */function (/**
                         * @param {?} option
                         * @return {?}
                         */ option) {
                            if (!option.disabled) {
                                hasDeselectedOptions_1 ? option.select() : option.deselect();
                            }
                        }));
                    }
                    else {
                        /** @type {?} */
                        var previouslyFocusedIndex = manager.activeItemIndex;
                        manager.onKeydown(event);
                        if (this._multiple && isArrowKey && event.shiftKey && manager.activeItem &&
                            manager.activeItemIndex !== previouslyFocusedIndex) {
                            manager.activeItem._selectViaInteraction();
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                MatSelect.prototype._onFocus = function () {
                    if (!this.disabled) {
                        this._focused = true;
                        this.stateChanges.next();
                    }
                };
                /**
                 * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
                 * "blur" to the panel when it opens, causing a false positive.
                 * @return {?}
                 */
                MatSelect.prototype._onBlur = function () {
                    this._focused = false;
                    if (!this.disabled && !this.panelOpen) {
                        this._onTouched();
                        this._changeDetectorRef.markForCheck();
                        this.stateChanges.next();
                    }
                };
                /**
                 * Callback that is invoked when the overlay panel has been attached.
                 * @return {?}
                 */
                MatSelect.prototype._onAttached = function () {
                    var _this = this;
                    this.overlayDir.positionChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["take"])(1)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._changeDetectorRef.detectChanges();
                        _this._calculateOverlayOffsetX();
                        _this.panel.nativeElement.scrollTop = _this._scrollTop;
                    }));
                };
                /**
                 * Returns the theme to be used on the panel.
                 * @return {?}
                 */
                MatSelect.prototype._getPanelTheme = function () {
                    return this._parentFormField ? "mat-" + this._parentFormField.color : '';
                };
                Object.defineProperty(MatSelect.prototype, "empty", {
                    /**
                     * Whether the select has a value.
                     * @return {?}
                     */
                    get: function () {
                        return !this._selectionModel || this._selectionModel.isEmpty();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._initializeSelection = function () {
                    var _this = this;
                    // Defer setting the value in order to avoid the "Expression
                    // has changed after it was checked" errors from Angular.
                    Promise.resolve().then(( /**
                     * @return {?}
                     */function () {
                        _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value);
                        _this.stateChanges.next();
                    }));
                };
                /**
                 * Sets the selected option based on a value. If no option can be
                 * found with the designated value, the select trigger is cleared.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatSelect.prototype._setSelectionByValue = function (value) {
                    var _this = this;
                    if (this.multiple && value) {
                        if (!Array.isArray(value)) {
                            throw getMatSelectNonArrayValueError();
                        }
                        this._selectionModel.clear();
                        value.forEach(( /**
                         * @param {?} currentValue
                         * @return {?}
                         */function (currentValue) { return _this._selectValue(currentValue); }));
                        this._sortValues();
                    }
                    else {
                        this._selectionModel.clear();
                        /** @type {?} */
                        var correspondingOption = this._selectValue(value);
                        // Shift focus to the active item. Note that we shouldn't do this in multiple
                        // mode, because we don't know what option the user interacted with last.
                        if (correspondingOption) {
                            this._keyManager.setActiveItem(correspondingOption);
                        }
                        else if (!this.panelOpen) {
                            // Otherwise reset the highlighted option. Note that we only want to do this while
                            // closed, because doing it while open can shift the user's focus unnecessarily.
                            this._keyManager.setActiveItem(-1);
                        }
                    }
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Finds and selects and option based on its value.
                 * @private
                 * @param {?} value
                 * @return {?} Option that has the corresponding value.
                 */
                MatSelect.prototype._selectValue = function (value) {
                    var _this = this;
                    /** @type {?} */
                    var correspondingOption = this.options.find(( /**
                     * @param {?} option
                     * @return {?}
                     */function (option) {
                        try {
                            // Treat null as a special reset value.
                            return option.value != null && _this._compareWith(option.value, value);
                        }
                        catch (error) {
                            if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["isDevMode"])()) {
                                // Notify developers of errors in their comparator.
                                console.warn(error);
                            }
                            return false;
                        }
                    }));
                    if (correspondingOption) {
                        this._selectionModel.select(correspondingOption);
                    }
                    return correspondingOption;
                };
                /**
                 * Sets up a key manager to listen to keyboard events on the overlay panel.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._initKeyManager = function () {
                    var _this = this;
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["ActiveDescendantKeyManager"](this.options)
                        .withTypeAhead(this.typeaheadDebounceInterval)
                        .withVerticalOrientation()
                        .withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr')
                        .withAllowedModifierKeys(['shiftKey']);
                    this._keyManager.tabOut.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroy)).subscribe(( /**
                     * @return {?}
                     */function () {
                        // Restore focus to the trigger before closing. Ensures that the focus
                        // position won't be lost if the user got focus into the overlay.
                        _this.focus();
                        _this.close();
                    }));
                    this._keyManager.change.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroy)).subscribe(( /**
                     * @return {?}
                     */function () {
                        if (_this._panelOpen && _this.panel) {
                            _this._scrollActiveOptionIntoView();
                        }
                        else if (!_this._panelOpen && !_this.multiple && _this._keyManager.activeItem) {
                            _this._keyManager.activeItem._selectViaInteraction();
                        }
                    }));
                };
                /**
                 * Drops current option subscriptions and IDs and resets from scratch.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._resetOptions = function () {
                    var _this = this;
                    /** @type {?} */
                    var changedOrDestroyed = Object(rxjs__WEBPACK_IMPORTED_MODULE_12__["merge"])(this.options.changes, this._destroy);
                    this.optionSelectionChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(changedOrDestroyed)).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this._onSelect(event.source, event.isUserInput);
                        if (event.isUserInput && !_this.multiple && _this._panelOpen) {
                            _this.close();
                            _this.focus();
                        }
                    }));
                    // Listen to changes in the internal state of the options and react accordingly.
                    // Handles cases like the labels of the selected options changing.
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_12__["merge"]).apply(void 0, this.options.map(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) { return option._stateChanges; }))).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(changedOrDestroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._changeDetectorRef.markForCheck();
                        _this.stateChanges.next();
                    }));
                    this._setOptionIds();
                };
                /**
                 * Invoked when an option is clicked.
                 * @private
                 * @param {?} option
                 * @param {?} isUserInput
                 * @return {?}
                 */
                MatSelect.prototype._onSelect = function (option, isUserInput) {
                    /** @type {?} */
                    var wasSelected = this._selectionModel.isSelected(option);
                    if (option.value == null && !this._multiple) {
                        option.deselect();
                        this._selectionModel.clear();
                        this._propagateChanges(option.value);
                    }
                    else {
                        if (wasSelected !== option.selected) {
                            option.selected ? this._selectionModel.select(option) :
                                this._selectionModel.deselect(option);
                        }
                        if (isUserInput) {
                            this._keyManager.setActiveItem(option);
                        }
                        if (this.multiple) {
                            this._sortValues();
                            if (isUserInput) {
                                // In case the user selected the option with their mouse, we
                                // want to restore focus back to the trigger, in order to
                                // prevent the select keyboard controls from clashing with
                                // the ones from `mat-option`.
                                this.focus();
                            }
                        }
                    }
                    if (wasSelected !== this._selectionModel.isSelected(option)) {
                        this._propagateChanges();
                    }
                    this.stateChanges.next();
                };
                /**
                 * Sorts the selected values in the selected based on their order in the panel.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._sortValues = function () {
                    var _this = this;
                    if (this.multiple) {
                        /** @type {?} */
                        var options_1 = this.options.toArray();
                        this._selectionModel.sort(( /**
                         * @param {?} a
                         * @param {?} b
                         * @return {?}
                         */function (a, b) {
                            return _this.sortComparator ? _this.sortComparator(a, b, options_1) :
                                options_1.indexOf(a) - options_1.indexOf(b);
                        }));
                        this.stateChanges.next();
                    }
                };
                /**
                 * Emits change event to set the model value.
                 * @private
                 * @param {?=} fallbackValue
                 * @return {?}
                 */
                MatSelect.prototype._propagateChanges = function (fallbackValue) {
                    /** @type {?} */
                    var valueToEmit = null;
                    if (this.multiple) {
                        valueToEmit = (( /** @type {?} */(this.selected))).map(( /**
                         * @param {?} option
                         * @return {?}
                         */function (/**
                         * @param {?} option
                         * @return {?}
                         */ option) { return option.value; }));
                    }
                    else {
                        valueToEmit = this.selected ? (( /** @type {?} */(this.selected))).value : fallbackValue;
                    }
                    this._value = valueToEmit;
                    this.valueChange.emit(valueToEmit);
                    this._onChange(valueToEmit);
                    this.selectionChange.emit(new MatSelectChange(this, valueToEmit));
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Records option IDs to pass to the aria-owns property.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._setOptionIds = function () {
                    this._optionIds = this.options.map(( /**
                     * @param {?} option
                     * @return {?}
                     */function (/**
                     * @param {?} option
                     * @return {?}
                     */ option) { return option.id; })).join(' ');
                };
                /**
                 * Highlights the selected item. If no option is selected, it will highlight
                 * the first item instead.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._highlightCorrectOption = function () {
                    if (this._keyManager) {
                        if (this.empty) {
                            this._keyManager.setFirstItemActive();
                        }
                        else {
                            this._keyManager.setActiveItem(this._selectionModel.selected[0]);
                        }
                    }
                };
                /**
                 * Scrolls the active option into view.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._scrollActiveOptionIntoView = function () {
                    /** @type {?} */
                    var activeOptionIndex = this._keyManager.activeItemIndex || 0;
                    /** @type {?} */
                    var labelCount = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["_countGroupLabelsBeforeOption"])(activeOptionIndex, this.options, this.optionGroups);
                    this.panel.nativeElement.scrollTop = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["_getOptionScrollPosition"])(activeOptionIndex + labelCount, this._getItemHeight(), this.panel.nativeElement.scrollTop, SELECT_PANEL_MAX_HEIGHT);
                };
                /**
                 * Focuses the select element.
                 * @param {?=} options
                 * @return {?}
                 */
                MatSelect.prototype.focus = function (options) {
                    this._elementRef.nativeElement.focus(options);
                };
                /**
                 * Gets the index of the provided option in the option list.
                 * @private
                 * @param {?} option
                 * @return {?}
                 */
                MatSelect.prototype._getOptionIndex = function (option) {
                    return this.options.reduce(( /**
                     * @param {?} result
                     * @param {?} current
                     * @param {?} index
                     * @return {?}
                     */function (result, current, index) {
                        return result === undefined ? (option === current ? index : undefined) : result;
                    }), undefined);
                };
                /**
                 * Calculates the scroll position and x- and y-offsets of the overlay panel.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._calculateOverlayPosition = function () {
                    /** @type {?} */
                    var itemHeight = this._getItemHeight();
                    /** @type {?} */
                    var items = this._getItemCount();
                    /** @type {?} */
                    var panelHeight = Math.min(items * itemHeight, SELECT_PANEL_MAX_HEIGHT);
                    /** @type {?} */
                    var scrollContainerHeight = items * itemHeight;
                    // The farthest the panel can be scrolled before it hits the bottom
                    /** @type {?} */
                    var maxScroll = scrollContainerHeight - panelHeight;
                    // If no value is selected we open the popup to the first item.
                    /** @type {?} */
                    var selectedOptionOffset = this.empty ? 0 : ( /** @type {?} */(this._getOptionIndex(this._selectionModel.selected[0])));
                    selectedOptionOffset += Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["_countGroupLabelsBeforeOption"])(selectedOptionOffset, this.options, this.optionGroups);
                    // We must maintain a scroll buffer so the selected option will be scrolled to the
                    // center of the overlay panel rather than the top.
                    /** @type {?} */
                    var scrollBuffer = panelHeight / 2;
                    this._scrollTop = this._calculateOverlayScroll(selectedOptionOffset, scrollBuffer, maxScroll);
                    this._offsetY = this._calculateOverlayOffsetY(selectedOptionOffset, scrollBuffer, maxScroll);
                    this._checkOverlayWithinViewport(maxScroll);
                };
                /**
                 * Calculates the scroll position of the select's overlay panel.
                 *
                 * Attempts to center the selected option in the panel. If the option is
                 * too high or too low in the panel to be scrolled to the center, it clamps the
                 * scroll position to the min or max scroll positions respectively.
                 * @param {?} selectedIndex
                 * @param {?} scrollBuffer
                 * @param {?} maxScroll
                 * @return {?}
                 */
                MatSelect.prototype._calculateOverlayScroll = function (selectedIndex, scrollBuffer, maxScroll) {
                    /** @type {?} */
                    var itemHeight = this._getItemHeight();
                    /** @type {?} */
                    var optionOffsetFromScrollTop = itemHeight * selectedIndex;
                    /** @type {?} */
                    var halfOptionHeight = itemHeight / 2;
                    // Starts at the optionOffsetFromScrollTop, which scrolls the option to the top of the
                    // scroll container, then subtracts the scroll buffer to scroll the option down to
                    // the center of the overlay panel. Half the option height must be re-added to the
                    // scrollTop so the option is centered based on its middle, not its top edge.
                    /** @type {?} */
                    var optimalScrollPosition = optionOffsetFromScrollTop - scrollBuffer + halfOptionHeight;
                    return Math.min(Math.max(0, optimalScrollPosition), maxScroll);
                };
                /**
                 * Returns the aria-label of the select component.
                 * @return {?}
                 */
                MatSelect.prototype._getAriaLabel = function () {
                    // If an ariaLabelledby value has been set by the consumer, the select should not overwrite the
                    // `aria-labelledby` value by setting the ariaLabel to the placeholder.
                    return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
                };
                /**
                 * Returns the aria-labelledby of the select component.
                 * @return {?}
                 */
                MatSelect.prototype._getAriaLabelledby = function () {
                    if (this.ariaLabelledby) {
                        return this.ariaLabelledby;
                    }
                    // Note: we use `_getAriaLabel` here, because we want to check whether there's a
                    // computed label. `this.ariaLabel` is only the user-specified label.
                    if (!this._parentFormField || !this._parentFormField._hasFloatingLabel() ||
                        this._getAriaLabel()) {
                        return null;
                    }
                    return this._parentFormField._labelId || null;
                };
                /**
                 * Determines the `aria-activedescendant` to be set on the host.
                 * @return {?}
                 */
                MatSelect.prototype._getAriaActiveDescendant = function () {
                    if (this.panelOpen && this._keyManager && this._keyManager.activeItem) {
                        return this._keyManager.activeItem.id;
                    }
                    return null;
                };
                /**
                 * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
                 * This must be adjusted to align the selected option text over the trigger text when
                 * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
                 * can't be calculated until the panel has been attached, because we need to know the
                 * content width in order to constrain the panel within the viewport.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._calculateOverlayOffsetX = function () {
                    /** @type {?} */
                    var overlayRect = this.overlayDir.overlayRef.overlayElement.getBoundingClientRect();
                    /** @type {?} */
                    var viewportSize = this._viewportRuler.getViewportSize();
                    /** @type {?} */
                    var isRtl = this._isRtl();
                    /** @type {?} */
                    var paddingWidth = this.multiple ? SELECT_MULTIPLE_PANEL_PADDING_X + SELECT_PANEL_PADDING_X :
                        SELECT_PANEL_PADDING_X * 2;
                    /** @type {?} */
                    var offsetX;
                    // Adjust the offset, depending on the option padding.
                    if (this.multiple) {
                        offsetX = SELECT_MULTIPLE_PANEL_PADDING_X;
                    }
                    else {
                        /** @type {?} */
                        var selected = this._selectionModel.selected[0] || this.options.first;
                        offsetX = selected && selected.group ? SELECT_PANEL_INDENT_PADDING_X : SELECT_PANEL_PADDING_X;
                    }
                    // Invert the offset in LTR.
                    if (!isRtl) {
                        offsetX *= -1;
                    }
                    // Determine how much the select overflows on each side.
                    /** @type {?} */
                    var leftOverflow = 0 - (overlayRect.left + offsetX - (isRtl ? paddingWidth : 0));
                    /** @type {?} */
                    var rightOverflow = overlayRect.right + offsetX - viewportSize.width
                        + (isRtl ? 0 : paddingWidth);
                    // If the element overflows on either side, reduce the offset to allow it to fit.
                    if (leftOverflow > 0) {
                        offsetX += leftOverflow + SELECT_PANEL_VIEWPORT_PADDING;
                    }
                    else if (rightOverflow > 0) {
                        offsetX -= rightOverflow + SELECT_PANEL_VIEWPORT_PADDING;
                    }
                    // Set the offset directly in order to avoid having to go through change detection and
                    // potentially triggering "changed after it was checked" errors. Round the value to avoid
                    // blurry content in some browsers.
                    this.overlayDir.offsetX = Math.round(offsetX);
                    this.overlayDir.overlayRef.updatePosition();
                };
                /**
                 * Calculates the y-offset of the select's overlay panel in relation to the
                 * top start corner of the trigger. It has to be adjusted in order for the
                 * selected option to be aligned over the trigger when the panel opens.
                 * @private
                 * @param {?} selectedIndex
                 * @param {?} scrollBuffer
                 * @param {?} maxScroll
                 * @return {?}
                 */
                MatSelect.prototype._calculateOverlayOffsetY = function (selectedIndex, scrollBuffer, maxScroll) {
                    /** @type {?} */
                    var itemHeight = this._getItemHeight();
                    /** @type {?} */
                    var optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
                    /** @type {?} */
                    var maxOptionsDisplayed = Math.floor(SELECT_PANEL_MAX_HEIGHT / itemHeight);
                    /** @type {?} */
                    var optionOffsetFromPanelTop;
                    // Disable offset if requested by user by returning 0 as value to offset
                    if (this._disableOptionCentering) {
                        return 0;
                    }
                    if (this._scrollTop === 0) {
                        optionOffsetFromPanelTop = selectedIndex * itemHeight;
                    }
                    else if (this._scrollTop === maxScroll) {
                        /** @type {?} */
                        var firstDisplayedIndex = this._getItemCount() - maxOptionsDisplayed;
                        /** @type {?} */
                        var selectedDisplayIndex = selectedIndex - firstDisplayedIndex;
                        // The first item is partially out of the viewport. Therefore we need to calculate what
                        // portion of it is shown in the viewport and account for it in our offset.
                        /** @type {?} */
                        var partialItemHeight = itemHeight - (this._getItemCount() * itemHeight - SELECT_PANEL_MAX_HEIGHT) % itemHeight;
                        // Because the panel height is longer than the height of the options alone,
                        // there is always extra padding at the top or bottom of the panel. When
                        // scrolled to the very bottom, this padding is at the top of the panel and
                        // must be added to the offset.
                        optionOffsetFromPanelTop = selectedDisplayIndex * itemHeight + partialItemHeight;
                    }
                    else {
                        // If the option was scrolled to the middle of the panel using a scroll buffer,
                        // its offset will be the scroll buffer minus the half height that was added to
                        // center it.
                        optionOffsetFromPanelTop = scrollBuffer - itemHeight / 2;
                    }
                    // The final offset is the option's offset from the top, adjusted for the height difference,
                    // multiplied by -1 to ensure that the overlay moves in the correct direction up the page.
                    // The value is rounded to prevent some browsers from blurring the content.
                    return Math.round(optionOffsetFromPanelTop * -1 - optionHeightAdjustment);
                };
                /**
                 * Checks that the attempted overlay position will fit within the viewport.
                 * If it will not fit, tries to adjust the scroll position and the associated
                 * y-offset so the panel can open fully on-screen. If it still won't fit,
                 * sets the offset back to 0 to allow the fallback position to take over.
                 * @private
                 * @param {?} maxScroll
                 * @return {?}
                 */
                MatSelect.prototype._checkOverlayWithinViewport = function (maxScroll) {
                    /** @type {?} */
                    var itemHeight = this._getItemHeight();
                    /** @type {?} */
                    var viewportSize = this._viewportRuler.getViewportSize();
                    /** @type {?} */
                    var topSpaceAvailable = this._triggerRect.top - SELECT_PANEL_VIEWPORT_PADDING;
                    /** @type {?} */
                    var bottomSpaceAvailable = viewportSize.height - this._triggerRect.bottom - SELECT_PANEL_VIEWPORT_PADDING;
                    /** @type {?} */
                    var panelHeightTop = Math.abs(this._offsetY);
                    /** @type {?} */
                    var totalPanelHeight = Math.min(this._getItemCount() * itemHeight, SELECT_PANEL_MAX_HEIGHT);
                    /** @type {?} */
                    var panelHeightBottom = totalPanelHeight - panelHeightTop - this._triggerRect.height;
                    if (panelHeightBottom > bottomSpaceAvailable) {
                        this._adjustPanelUp(panelHeightBottom, bottomSpaceAvailable);
                    }
                    else if (panelHeightTop > topSpaceAvailable) {
                        this._adjustPanelDown(panelHeightTop, topSpaceAvailable, maxScroll);
                    }
                    else {
                        this._transformOrigin = this._getOriginBasedOnOption();
                    }
                };
                /**
                 * Adjusts the overlay panel up to fit in the viewport.
                 * @private
                 * @param {?} panelHeightBottom
                 * @param {?} bottomSpaceAvailable
                 * @return {?}
                 */
                MatSelect.prototype._adjustPanelUp = function (panelHeightBottom, bottomSpaceAvailable) {
                    // Browsers ignore fractional scroll offsets, so we need to round.
                    /** @type {?} */
                    var distanceBelowViewport = Math.round(panelHeightBottom - bottomSpaceAvailable);
                    // Scrolls the panel up by the distance it was extending past the boundary, then
                    // adjusts the offset by that amount to move the panel up into the viewport.
                    this._scrollTop -= distanceBelowViewport;
                    this._offsetY -= distanceBelowViewport;
                    this._transformOrigin = this._getOriginBasedOnOption();
                    // If the panel is scrolled to the very top, it won't be able to fit the panel
                    // by scrolling, so set the offset to 0 to allow the fallback position to take
                    // effect.
                    if (this._scrollTop <= 0) {
                        this._scrollTop = 0;
                        this._offsetY = 0;
                        this._transformOrigin = "50% bottom 0px";
                    }
                };
                /**
                 * Adjusts the overlay panel down to fit in the viewport.
                 * @private
                 * @param {?} panelHeightTop
                 * @param {?} topSpaceAvailable
                 * @param {?} maxScroll
                 * @return {?}
                 */
                MatSelect.prototype._adjustPanelDown = function (panelHeightTop, topSpaceAvailable, maxScroll) {
                    // Browsers ignore fractional scroll offsets, so we need to round.
                    /** @type {?} */
                    var distanceAboveViewport = Math.round(panelHeightTop - topSpaceAvailable);
                    // Scrolls the panel down by the distance it was extending past the boundary, then
                    // adjusts the offset by that amount to move the panel down into the viewport.
                    this._scrollTop += distanceAboveViewport;
                    this._offsetY += distanceAboveViewport;
                    this._transformOrigin = this._getOriginBasedOnOption();
                    // If the panel is scrolled to the very bottom, it won't be able to fit the
                    // panel by scrolling, so set the offset to 0 to allow the fallback position
                    // to take effect.
                    if (this._scrollTop >= maxScroll) {
                        this._scrollTop = maxScroll;
                        this._offsetY = 0;
                        this._transformOrigin = "50% top 0px";
                        return;
                    }
                };
                /**
                 * Sets the transform origin point based on the selected option.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._getOriginBasedOnOption = function () {
                    /** @type {?} */
                    var itemHeight = this._getItemHeight();
                    /** @type {?} */
                    var optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
                    /** @type {?} */
                    var originY = Math.abs(this._offsetY) - optionHeightAdjustment + itemHeight / 2;
                    return "50% " + originY + "px 0px";
                };
                /**
                 * Calculates the amount of items in the select. This includes options and group labels.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._getItemCount = function () {
                    return this.options.length + this.optionGroups.length;
                };
                /**
                 * Calculates the height of the select's options.
                 * @private
                 * @return {?}
                 */
                MatSelect.prototype._getItemHeight = function () {
                    return this._triggerFontSize * SELECT_ITEM_HEIGHT_EM;
                };
                /**
                 * Implemented as part of MatFormFieldControl.
                 * \@docs-private
                 * @param {?} ids
                 * @return {?}
                 */
                MatSelect.prototype.setDescribedByIds = function (ids) {
                    this._ariaDescribedby = ids.join(' ');
                };
                /**
                 * Implemented as part of MatFormFieldControl.
                 * \@docs-private
                 * @return {?}
                 */
                MatSelect.prototype.onContainerClick = function () {
                    this.focus();
                    this.open();
                };
                Object.defineProperty(MatSelect.prototype, "shouldLabelFloat", {
                    /**
                     * Implemented as part of MatFormFieldControl.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this._panelOpen || !this.empty;
                    },
                    enumerable: true,
                    configurable: true
                });
                return MatSelect;
            }(_MatSelectMixinBase));
            MatSelect.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-select',
                            exportAs: 'matSelect',
                            template: "<div cdk-overlay-origin class=\"mat-select-trigger\" aria-hidden=\"true\" (click)=\"toggle()\" #origin=\"cdkOverlayOrigin\" #trigger><div class=\"mat-select-value\" [ngSwitch]=\"empty\"><span class=\"mat-select-placeholder\" *ngSwitchCase=\"true\">{{placeholder || '\u00A0'}}</span> <span class=\"mat-select-value-text\" *ngSwitchCase=\"false\" [ngSwitch]=\"!!customTrigger\"><span *ngSwitchDefault>{{triggerValue || '\u00A0'}}</span><ng-content select=\"mat-select-trigger\" *ngSwitchCase=\"true\"></ng-content></span></div><div class=\"mat-select-arrow-wrapper\"><div class=\"mat-select-arrow\"></div></div></div><ng-template cdk-connected-overlay cdkConnectedOverlayLockPosition cdkConnectedOverlayHasBackdrop cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" [cdkConnectedOverlayScrollStrategy]=\"_scrollStrategy\" [cdkConnectedOverlayOrigin]=\"origin\" [cdkConnectedOverlayOpen]=\"panelOpen\" [cdkConnectedOverlayPositions]=\"_positions\" [cdkConnectedOverlayMinWidth]=\"_triggerRect?.width\" [cdkConnectedOverlayOffsetY]=\"_offsetY\" (backdropClick)=\"close()\" (attach)=\"_onAttached()\" (detach)=\"close()\"><div class=\"mat-select-panel-wrap\" [@transformPanelWrap]><div #panel class=\"mat-select-panel {{ _getPanelTheme() }}\" [ngClass]=\"panelClass\" [@transformPanel]=\"multiple ? 'showing-multiple' : 'showing'\" (@transformPanel.done)=\"_panelDoneAnimatingStream.next($event.toState)\" [style.transformOrigin]=\"_transformOrigin\" [style.font-size.px]=\"_triggerFontSize\" (keydown)=\"_handleKeydown($event)\"><ng-content></ng-content></div></div></ng-template>",
                            styles: [".mat-select{display:inline-block;width:100%;outline:0}.mat-select-trigger{display:inline-table;cursor:pointer;position:relative;box-sizing:border-box}.mat-select-disabled .mat-select-trigger{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-select-value{display:table-cell;max-width:0;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-select-arrow-wrapper{display:table-cell;vertical-align:middle}.mat-form-field-appearance-fill .mat-select-arrow-wrapper{transform:translateY(-50%)}.mat-form-field-appearance-outline .mat-select-arrow-wrapper{transform:translateY(-25%)}.mat-form-field-appearance-standard.mat-form-field-has-label .mat-select:not(.mat-select-empty) .mat-select-arrow-wrapper{transform:translateY(-50%)}.mat-form-field-appearance-standard .mat-select.mat-select-empty .mat-select-arrow-wrapper{transition:transform .4s cubic-bezier(.25,.8,.25,1)}._mat-animation-noopable.mat-form-field-appearance-standard .mat-select.mat-select-empty .mat-select-arrow-wrapper{transition:none}.mat-select-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px}.mat-select-panel-wrap{flex-basis:100%}.mat-select-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%;border-radius:4px}@media (-ms-high-contrast:active){.mat-select-panel{outline:solid 1px}}.mat-select-panel .mat-optgroup-label,.mat-select-panel .mat-option{font-size:inherit;line-height:3em;height:3em}.mat-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-form-field-flex{cursor:pointer}.mat-form-field-type-mat-select .mat-form-field-label{width:calc(100% - 18px)}.mat-select-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}._mat-animation-noopable .mat-select-placeholder{transition:none}.mat-form-field-hide-placeholder .mat-select-placeholder{color:transparent;-webkit-text-fill-color:transparent;transition:none;display:block}"],
                            inputs: ['disabled', 'disableRipple', 'tabIndex'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            host: {
                                'role': 'listbox',
                                '[attr.id]': 'id',
                                '[attr.tabindex]': 'tabIndex',
                                '[attr.aria-label]': '_getAriaLabel()',
                                '[attr.aria-labelledby]': '_getAriaLabelledby()',
                                '[attr.aria-required]': 'required.toString()',
                                '[attr.aria-disabled]': 'disabled.toString()',
                                '[attr.aria-invalid]': 'errorState',
                                '[attr.aria-owns]': 'panelOpen ? _optionIds : null',
                                '[attr.aria-multiselectable]': 'multiple',
                                '[attr.aria-describedby]': '_ariaDescribedby || null',
                                '[attr.aria-activedescendant]': '_getAriaActiveDescendant()',
                                '[class.mat-select-disabled]': 'disabled',
                                '[class.mat-select-invalid]': 'errorState',
                                '[class.mat-select-required]': 'required',
                                '[class.mat-select-empty]': 'empty',
                                'class': 'mat-select',
                                '(keydown)': '_handleKeydown($event)',
                                '(focus)': '_onFocus()',
                                '(blur)': '_onBlur()',
                            },
                            animations: [
                                matSelectAnimations.transformPanelWrap,
                                matSelectAnimations.transformPanel
                            ],
                            providers: [
                                { provide: _angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__["MatFormFieldControl"], useExisting: MatSelect },
                                { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MAT_OPTION_PARENT_COMPONENT"], useExisting: MatSelect }
                            ],
                        },] },
            ];
            /** @nocollapse */
            MatSelect.ctorParameters = function () { return [
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_7__["ViewportRuler"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgZone"] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["ErrorStateMatcher"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_9__["NgForm"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormGroupDirective"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }] },
                { type: _angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__["MatFormField"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }] },
                { type: _angular_forms__WEBPACK_IMPORTED_MODULE_9__["NgControl"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Self"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Attribute"], args: ['tabindex',] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Inject"], args: [MAT_SELECT_SCROLL_STRATEGY,] }] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["LiveAnnouncer"] }
            ]; };
            MatSelect.propDecorators = {
                trigger: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewChild"], args: ['trigger', { static: false },] }],
                panel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewChild"], args: ['panel', { static: false },] }],
                overlayDir: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewChild"], args: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["CdkConnectedOverlay"], { static: false },] }],
                options: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatOption"], { descendants: true },] }],
                optionGroups: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChildren"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatOptgroup"],] }],
                panelClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                customTrigger: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChild"], args: [MatSelectTrigger, { static: false },] }],
                placeholder: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                multiple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                disableOptionCentering: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                compareWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"], args: ['aria-labelledby',] }],
                errorStateMatcher: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                typeaheadDebounceInterval: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                sortComparator: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                openedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }],
                _openedStream: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"], args: ['opened',] }],
                _closedStream: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"], args: ['closed',] }],
                selectionChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }],
                valueChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatSelectModule = /** @class */ (function () {
                function MatSelectModule() {
                }
                return MatSelectModule;
            }());
            MatSelectModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_14__["CommonModule"],
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["OverlayModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatOptionModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatCommonModule"],
                            ],
                            exports: [_angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__["MatFormFieldModule"], MatSelect, MatSelectTrigger, _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatOptionModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatCommonModule"]],
                            declarations: [MatSelect, MatSelectTrigger],
                            providers: [MAT_SELECT_SCROLL_STRATEGY_PROVIDER]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=select.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/sidenav.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/sidenav.js ***!
          \***********************************************************/
        /*! exports provided: MatSidenavModule, throwMatDuplicatedDrawerError, MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY, MAT_DRAWER_DEFAULT_AUTOSIZE, MatDrawerContent, MatDrawer, MatDrawerContainer, MatSidenavContent, MatSidenav, MatSidenavContainer, matDrawerAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSidenavModule", function () { return MatSidenavModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwMatDuplicatedDrawerError", function () { return throwMatDuplicatedDrawerError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY", function () { return MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_DRAWER_DEFAULT_AUTOSIZE", function () { return MAT_DRAWER_DEFAULT_AUTOSIZE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDrawerContent", function () { return MatDrawerContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDrawer", function () { return MatDrawer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatDrawerContainer", function () { return MatDrawerContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSidenavContent", function () { return MatSidenavContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSidenav", function () { return MatSidenav; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSidenavContainer", function () { return MatSidenavContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matDrawerAnimations", function () { return matDrawerAnimations; });
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the Material drawers.
             * \@docs-private
             * @type {?}
             */
            var matDrawerAnimations = {
                /**
                 * Animation that slides a drawer in and out.
                 */
                transformDrawer: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('transform', [
                    // We remove the `transform` here completely, rather than setting it to zero, because:
                    // 1. Having a transform can cause elements with ripples or an animated
                    //    transform to shift around in Chrome with an RTL layout (see #10023).
                    // 2. 3d transforms causes text to appear blurry on IE and Edge.
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('open, open-instant', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                        'transform': 'none',
                        'visibility': 'visible',
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({
                        // Avoids the shadow showing up when closed in SSR.
                        'box-shadow': 'none',
                        'visibility': 'hidden',
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('void => open-instant', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('0ms')),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('void <=> open, open-instant => void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Throws an exception when two MatDrawer are matching the same position.
             * \@docs-private
             * @param {?} position
             * @return {?}
             */
            function throwMatDuplicatedDrawerError(position) {
                throw Error("A drawer was already declared for 'position=\"" + position + "\"'");
            }
            /**
             * Configures whether drawers should use auto sizing by default.
             * @type {?}
             */
            var MAT_DRAWER_DEFAULT_AUTOSIZE = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["InjectionToken"]('MAT_DRAWER_DEFAULT_AUTOSIZE', {
                providedIn: 'root',
                factory: MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY() {
                return false;
            }
            var MatDrawerContent = /** @class */ (function (_super_1) {
                __extends(MatDrawerContent, _super_1);
                /**
                 * @param {?} _changeDetectorRef
                 * @param {?} _container
                 * @param {?} elementRef
                 * @param {?} scrollDispatcher
                 * @param {?} ngZone
                 */
                function MatDrawerContent(_changeDetectorRef, _container, elementRef, scrollDispatcher, ngZone) {
                    var _this = _super_1.call(this, elementRef, scrollDispatcher, ngZone) || this;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._container = _container;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatDrawerContent.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._container._contentMarginChanges.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._changeDetectorRef.markForCheck();
                    }));
                };
                return MatDrawerContent;
            }(_angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["CdkScrollable"]));
            MatDrawerContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-drawer-content',
                            template: '<ng-content></ng-content>',
                            host: {
                                'class': 'mat-drawer-content',
                                '[style.margin-left.px]': '_container._contentMargins.left',
                                '[style.margin-right.px]': '_container._contentMargins.right',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatDrawerContent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectorRef"] },
                { type: MatDrawerContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return MatDrawerContainer; })),] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ElementRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["ScrollDispatcher"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgZone"] }
            ]; };
            /**
             * This component corresponds to a drawer that can be opened on the drawer container.
             */
            var MatDrawer = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _focusTrapFactory
                 * @param {?} _focusMonitor
                 * @param {?} _platform
                 * @param {?} _ngZone
                 * @param {?} _doc
                 */
                function MatDrawer(_elementRef, _focusTrapFactory, _focusMonitor, _platform, _ngZone, _doc) {
                    var _this = this;
                    this._elementRef = _elementRef;
                    this._focusTrapFactory = _focusTrapFactory;
                    this._focusMonitor = _focusMonitor;
                    this._platform = _platform;
                    this._ngZone = _ngZone;
                    this._doc = _doc;
                    this._elementFocusedBeforeDrawerWasOpened = null;
                    /**
                     * Whether the drawer is initialized. Used for disabling the initial animation.
                     */
                    this._enableAnimations = false;
                    this._position = 'start';
                    this._mode = 'over';
                    this._disableClose = false;
                    this._autoFocus = true;
                    /**
                     * Emits whenever the drawer has started animating.
                     */
                    this._animationStarted = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    /**
                     * Emits whenever the drawer is done animating.
                     */
                    this._animationEnd = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    /**
                     * Current state of the sidenav animation.
                     */
                    // @HostBinding is used in the class as it is expected to be extended.  Since @Component decorator
                    // metadata is not inherited by child classes, instead the host binding data is defined in a way
                    // that can be inherited.
                    // tslint:disable:no-host-decorator-in-concrete
                    this._animationState = 'void';
                    /**
                     * Event emitted when the drawer open state is changed.
                     */
                    this.openedChange =
                        // Note this has to be async in order to avoid some issues with two-bindings (see #8872).
                        new _angular_core__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"](/* isAsync */ true);
                    /**
                     * Emits when the component is destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    /**
                     * Event emitted when the drawer's position changes.
                     */
                    // tslint:disable-next-line:no-output-on-prefix
                    this.onPositionChanged = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"]();
                    /**
                     * An observable that emits when the drawer mode changes. This is used by the drawer container to
                     * to know when to when the mode changes so it can adapt the margins on the content.
                     */
                    this._modeChanged = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    this._opened = false;
                    this.openedChange.subscribe(( /**
                     * @param {?} opened
                     * @return {?}
                     */function (opened) {
                        if (opened) {
                            if (_this._doc) {
                                _this._elementFocusedBeforeDrawerWasOpened = ( /** @type {?} */(_this._doc.activeElement));
                            }
                            if (_this._isFocusTrapEnabled && _this._focusTrap) {
                                _this._trapFocus();
                            }
                        }
                        else {
                            _this._restoreFocus();
                        }
                    }));
                    /**
                     * Listen to `keydown` events outside the zone so that change detection is not run every
                     * time a key is pressed. Instead we re-enter the zone only if the `ESC` key is pressed
                     * and we don't have close disabled.
                     */
                    this._ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        (( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["fromEvent"])(_this._elementRef.nativeElement, 'keydown')))).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) {
                            return event.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["ESCAPE"] && !_this.disableClose && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["hasModifierKey"])(event);
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(_this._destroyed)).subscribe(( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) { return _this._ngZone.run(( /**
                         * @return {?}
                         */function () {
                            _this.close();
                            event.stopPropagation();
                            event.preventDefault();
                        })); }));
                    }));
                    // We need a Subject with distinctUntilChanged, because the `done` event
                    // fires twice on some browsers. See https://github.com/angular/angular/issues/24084
                    this._animationEnd.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["distinctUntilChanged"])(( /**
                     * @param {?} x
                     * @param {?} y
                     * @return {?}
                     */function (x, y) {
                        return x.fromState === y.fromState && x.toState === y.toState;
                    }))).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) {
                        var fromState = event.fromState, toState = event.toState;
                        if ((toState.indexOf('open') === 0 && fromState === 'void') ||
                            (toState === 'void' && fromState.indexOf('open') === 0)) {
                            _this.openedChange.emit(_this._opened);
                        }
                    }));
                }
                Object.defineProperty(MatDrawer.prototype, "position", {
                    /**
                     * The side that the drawer is attached to.
                     * @return {?}
                     */
                    get: function () { return this._position; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        // Make sure we have a valid value.
                        value = value === 'end' ? 'end' : 'start';
                        if (value != this._position) {
                            this._position = value;
                            this.onPositionChanged.emit();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "mode", {
                    /**
                     * Mode of the drawer; one of 'over', 'push' or 'side'.
                     * @return {?}
                     */
                    get: function () { return this._mode; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._mode = value;
                        this._updateFocusTrapState();
                        this._modeChanged.next();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "disableClose", {
                    /**
                     * Whether the drawer can be closed with the escape key or by clicking on the backdrop.
                     * @return {?}
                     */
                    get: function () { return this._disableClose; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disableClose = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "autoFocus", {
                    /**
                     * Whether the drawer should focus the first focusable element automatically when opened.
                     * @return {?}
                     */
                    get: function () { return this._autoFocus; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._autoFocus = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "_openedStream", {
                    /**
                     * Event emitted when the drawer has been opened.
                     * @return {?}
                     */
                    get: function () {
                        return this.openedChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                         * @param {?} o
                         * @return {?}
                         */function (/**
                         * @param {?} o
                         * @return {?}
                         */ o) { return o; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["map"])(( /**
                         * @return {?}
                         */function () { })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "openedStart", {
                    /**
                     * Event emitted when the drawer has started opening.
                     * @return {?}
                     */
                    get: function () {
                        return this._animationStarted.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                         * @param {?} e
                         * @return {?}
                         */function (/**
                         * @param {?} e
                         * @return {?}
                         */ e) { return e.fromState !== e.toState && e.toState.indexOf('open') === 0; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["map"])(( /**
                         * @return {?}
                         */function () { })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "_closedStream", {
                    /**
                     * Event emitted when the drawer has been closed.
                     * @return {?}
                     */
                    get: function () {
                        return this.openedChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                         * @param {?} o
                         * @return {?}
                         */function (/**
                         * @param {?} o
                         * @return {?}
                         */ o) { return !o; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["map"])(( /**
                         * @return {?}
                         */function () { })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "closedStart", {
                    /**
                     * Event emitted when the drawer has started closing.
                     * @return {?}
                     */
                    get: function () {
                        return this._animationStarted.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                         * @param {?} e
                         * @return {?}
                         */function (/**
                         * @param {?} e
                         * @return {?}
                         */ e) { return e.fromState !== e.toState && e.toState === 'void'; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["map"])(( /**
                         * @return {?}
                         */function () { })));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawer.prototype, "_isFocusTrapEnabled", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        // The focus trap is only enabled when the drawer is open in any mode other than side.
                        return this.opened && this.mode !== 'side';
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Traps focus inside the drawer.
                 * @private
                 * @return {?}
                 */
                MatDrawer.prototype._trapFocus = function () {
                    var _this = this;
                    if (!this.autoFocus) {
                        return;
                    }
                    this._focusTrap.focusInitialElementWhenReady().then(( /**
                     * @param {?} hasMovedFocus
                     * @return {?}
                     */function (/**
                     * @param {?} hasMovedFocus
                     * @return {?}
                     */ hasMovedFocus) {
                        // If there were no focusable elements, focus the sidenav itself so the keyboard navigation
                        // still works. We need to check that `focus` is a function due to Universal.
                        if (!hasMovedFocus && typeof _this._elementRef.nativeElement.focus === 'function') {
                            _this._elementRef.nativeElement.focus();
                        }
                    }));
                };
                /**
                 * If focus is currently inside the drawer, restores it to where it was before the drawer
                 * opened.
                 * @private
                 * @return {?}
                 */
                MatDrawer.prototype._restoreFocus = function () {
                    if (!this.autoFocus) {
                        return;
                    }
                    /** @type {?} */
                    var activeEl = this._doc && this._doc.activeElement;
                    if (activeEl && this._elementRef.nativeElement.contains(activeEl)) {
                        if (this._elementFocusedBeforeDrawerWasOpened instanceof HTMLElement) {
                            this._focusMonitor.focusVia(this._elementFocusedBeforeDrawerWasOpened, this._openedVia);
                        }
                        else {
                            this._elementRef.nativeElement.blur();
                        }
                    }
                    this._elementFocusedBeforeDrawerWasOpened = null;
                    this._openedVia = null;
                };
                /**
                 * @return {?}
                 */
                MatDrawer.prototype.ngAfterContentInit = function () {
                    this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
                    this._updateFocusTrapState();
                };
                /**
                 * @return {?}
                 */
                MatDrawer.prototype.ngAfterContentChecked = function () {
                    // Enable the animations after the lifecycle hooks have run, in order to avoid animating
                    // drawers that are open by default. When we're on the server, we shouldn't enable the
                    // animations, because we don't want the drawer to animate the first time the user sees
                    // the page.
                    if (this._platform.isBrowser) {
                        this._enableAnimations = true;
                    }
                };
                /**
                 * @return {?}
                 */
                MatDrawer.prototype.ngOnDestroy = function () {
                    if (this._focusTrap) {
                        this._focusTrap.destroy();
                    }
                    this._animationStarted.complete();
                    this._animationEnd.complete();
                    this._modeChanged.complete();
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                Object.defineProperty(MatDrawer.prototype, "opened", {
                    /**
                     * Whether the drawer is opened. We overload this because we trigger an event when it
                     * starts or end.
                     * @return {?}
                     */
                    get: function () { return this._opened; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this.toggle(Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value)); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Open the drawer.
                 * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
                 * Used for focus management after the sidenav is closed.
                 * @return {?}
                 */
                MatDrawer.prototype.open = function (openedVia) {
                    return this.toggle(true, openedVia);
                };
                /**
                 * Close the drawer.
                 * @return {?}
                 */
                MatDrawer.prototype.close = function () {
                    return this.toggle(false);
                };
                /**
                 * Toggle this drawer.
                 * @param {?=} isOpen Whether the drawer should be open.
                 * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
                 * Used for focus management after the sidenav is closed.
                 * @return {?}
                 */
                MatDrawer.prototype.toggle = function (isOpen, openedVia) {
                    var _this = this;
                    if (isOpen === void 0) { isOpen = !this.opened; }
                    if (openedVia === void 0) { openedVia = 'program'; }
                    this._opened = isOpen;
                    if (isOpen) {
                        this._animationState = this._enableAnimations ? 'open' : 'open-instant';
                        this._openedVia = openedVia;
                    }
                    else {
                        this._animationState = 'void';
                        this._restoreFocus();
                    }
                    this._updateFocusTrapState();
                    return new Promise(( /**
                     * @param {?} resolve
                     * @return {?}
                     */function (/**
                     * @param {?} resolve
                     * @return {?}
                     */ resolve) {
                        _this.openedChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["take"])(1)).subscribe(( /**
                         * @param {?} open
                         * @return {?}
                         */function (/**
                         * @param {?} open
                         * @return {?}
                         */ open) { return resolve(open ? 'open' : 'close'); }));
                    }));
                };
                Object.defineProperty(MatDrawer.prototype, "_width", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._elementRef.nativeElement ? (this._elementRef.nativeElement.offsetWidth || 0) : 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Updates the enabled state of the focus trap.
                 * @private
                 * @return {?}
                 */
                MatDrawer.prototype._updateFocusTrapState = function () {
                    if (this._focusTrap) {
                        this._focusTrap.enabled = this._isFocusTrapEnabled;
                    }
                };
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatDrawer.prototype._animationStartListener = function (event) {
                    this._animationStarted.next(event);
                };
                // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
                // In Ivy the `host` bindings will be merged when this class is extended, whereas in
                // ViewEngine they're overwritten.
                // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
                // tslint:disable-next-line:no-host-decorator-in-concrete
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatDrawer.prototype._animationDoneListener = function (event) {
                    this._animationEnd.next(event);
                };
                return MatDrawer;
            }());
            MatDrawer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-drawer',
                            exportAs: 'matDrawer',
                            template: "<div class=\"mat-drawer-inner-container\"><ng-content></ng-content></div>",
                            animations: [matDrawerAnimations.transformDrawer],
                            host: {
                                'class': 'mat-drawer',
                                // must prevent the browser from aligning text based on value
                                '[attr.align]': 'null',
                                '[class.mat-drawer-end]': 'position === "end"',
                                '[class.mat-drawer-over]': 'mode === "over"',
                                '[class.mat-drawer-push]': 'mode === "push"',
                                '[class.mat-drawer-side]': 'mode === "side"',
                                '[class.mat-drawer-opened]': 'opened',
                                'tabIndex': '-1',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatDrawer.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["FocusTrapFactory"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["FocusMonitor"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["Platform"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_7__["DOCUMENT"],] }] }
            ]; };
            MatDrawer.propDecorators = {
                position: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                mode: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                disableClose: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                autoFocus: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                _animationState: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["HostBinding"], args: ['@transform',] }],
                openedChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }],
                _openedStream: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"], args: ['opened',] }],
                openedStart: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }],
                _closedStream: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"], args: ['closed',] }],
                closedStart: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }],
                onPositionChanged: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"], args: ['positionChanged',] }],
                opened: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                _animationStartListener: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["HostListener"], args: ['@transform.start', ['$event'],] }],
                _animationDoneListener: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["HostListener"], args: ['@transform.done', ['$event'],] }]
            };
            /**
             * `<mat-drawer-container>` component.
             *
             * This is the parent component to one or two `<mat-drawer>`s that validates the state internally
             * and coordinates the backdrop and content styling.
             */
            var MatDrawerContainer = /** @class */ (function () {
                /**
                 * @param {?} _dir
                 * @param {?} _element
                 * @param {?} _ngZone
                 * @param {?} _changeDetectorRef
                 * @param {?} viewportRuler
                 * @param {?=} defaultAutosize
                 * @param {?=} _animationMode
                 */
                function MatDrawerContainer(_dir, _element, _ngZone, _changeDetectorRef, viewportRuler, defaultAutosize, _animationMode) {
                    var _this = this;
                    if (defaultAutosize === void 0) { defaultAutosize = false; }
                    this._dir = _dir;
                    this._element = _element;
                    this._ngZone = _ngZone;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._animationMode = _animationMode;
                    /**
                     * Event emitted when the drawer backdrop is clicked.
                     */
                    this.backdropClick = new _angular_core__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"]();
                    /**
                     * Emits when the component is destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    /**
                     * Emits on every ngDoCheck. Used for debouncing reflows.
                     */
                    this._doCheckSubject = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    /**
                     * Margins to be applied to the content. These are used to push / shrink the drawer content when a
                     * drawer is open. We use margin rather than transform even for push mode because transform breaks
                     * fixed position elements inside of the transformed element.
                     */
                    this._contentMargins = { left: null, right: null };
                    this._contentMarginChanges = new rxjs__WEBPACK_IMPORTED_MODULE_9__["Subject"]();
                    // If a `Dir` directive exists up the tree, listen direction changes
                    // and update the left/right properties to point to the proper start/end.
                    if (_dir) {
                        _dir.change.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(this._destroyed)).subscribe(( /**
                         * @return {?}
                         */function () {
                            _this._validateDrawers();
                            _this.updateContentMargins();
                        }));
                    }
                    // Since the minimum width of the sidenav depends on the viewport width,
                    // we need to recompute the margins if the viewport changes.
                    viewportRuler.change()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () { return _this.updateContentMargins(); }));
                    this._autosize = defaultAutosize;
                }
                Object.defineProperty(MatDrawerContainer.prototype, "start", {
                    /**
                     * The drawer child with the `start` position.
                     * @return {?}
                     */
                    get: function () { return this._start; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawerContainer.prototype, "end", {
                    /**
                     * The drawer child with the `end` position.
                     * @return {?}
                     */
                    get: function () { return this._end; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawerContainer.prototype, "autosize", {
                    /**
                     * Whether to automatically resize the container whenever
                     * the size of any of its drawers changes.
                     *
                     * **Use at your own risk!** Enabling this option can cause layout thrashing by measuring
                     * the drawers on every change detection cycle. Can be configured globally via the
                     * `MAT_DRAWER_DEFAULT_AUTOSIZE` token.
                     * @return {?}
                     */
                    get: function () { return this._autosize; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._autosize = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawerContainer.prototype, "hasBackdrop", {
                    /**
                     * Whether the drawer container should have a backdrop while one of the sidenavs is open.
                     * If explicitly set to `true`, the backdrop will be enabled for drawers in the `side`
                     * mode as well.
                     * @return {?}
                     */
                    get: function () {
                        if (this._backdropOverride == null) {
                            return !this._start || this._start.mode !== 'side' || !this._end || this._end.mode !== 'side';
                        }
                        return this._backdropOverride;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._backdropOverride = value == null ? null : Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatDrawerContainer.prototype, "scrollable", {
                    /**
                     * Reference to the CdkScrollable instance that wraps the scrollable content.
                     * @return {?}
                     */
                    get: function () {
                        return this._userContent || this._content;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatDrawerContainer.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._drawers.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["startWith"])(null)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._validateDrawers();
                        _this._drawers.forEach(( /**
                         * @param {?} drawer
                         * @return {?}
                         */function (drawer) {
                            _this._watchDrawerToggle(drawer);
                            _this._watchDrawerPosition(drawer);
                            _this._watchDrawerMode(drawer);
                        }));
                        if (!_this._drawers.length ||
                            _this._isDrawerOpen(_this._start) ||
                            _this._isDrawerOpen(_this._end)) {
                            _this.updateContentMargins();
                        }
                        _this._changeDetectorRef.markForCheck();
                    }));
                    this._doCheckSubject.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["debounceTime"])(10), // Arbitrary debounce time, less than a frame at 60fps
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () { return _this.updateContentMargins(); }));
                };
                /**
                 * @return {?}
                 */
                MatDrawerContainer.prototype.ngOnDestroy = function () {
                    this._contentMarginChanges.complete();
                    this._doCheckSubject.complete();
                    this._destroyed.next();
                    this._destroyed.complete();
                };
                /**
                 * Calls `open` of both start and end drawers
                 * @return {?}
                 */
                MatDrawerContainer.prototype.open = function () {
                    this._drawers.forEach(( /**
                     * @param {?} drawer
                     * @return {?}
                     */function (/**
                     * @param {?} drawer
                     * @return {?}
                     */ drawer) { return drawer.open(); }));
                };
                /**
                 * Calls `close` of both start and end drawers
                 * @return {?}
                 */
                MatDrawerContainer.prototype.close = function () {
                    this._drawers.forEach(( /**
                     * @param {?} drawer
                     * @return {?}
                     */function (/**
                     * @param {?} drawer
                     * @return {?}
                     */ drawer) { return drawer.close(); }));
                };
                /**
                 * Recalculates and updates the inline styles for the content. Note that this should be used
                 * sparingly, because it causes a reflow.
                 * @return {?}
                 */
                MatDrawerContainer.prototype.updateContentMargins = function () {
                    var _this = this;
                    // 1. For drawers in `over` mode, they don't affect the content.
                    // 2. For drawers in `side` mode they should shrink the content. We do this by adding to the
                    //    left margin (for left drawer) or right margin (for right the drawer).
                    // 3. For drawers in `push` mode the should shift the content without resizing it. We do this by
                    //    adding to the left or right margin and simultaneously subtracting the same amount of
                    //    margin from the other side.
                    /** @type {?} */
                    var left = 0;
                    /** @type {?} */
                    var right = 0;
                    if (this._left && this._left.opened) {
                        if (this._left.mode == 'side') {
                            left += this._left._width;
                        }
                        else if (this._left.mode == 'push') {
                            /** @type {?} */
                            var width = this._left._width;
                            left += width;
                            right -= width;
                        }
                    }
                    if (this._right && this._right.opened) {
                        if (this._right.mode == 'side') {
                            right += this._right._width;
                        }
                        else if (this._right.mode == 'push') {
                            /** @type {?} */
                            var width = this._right._width;
                            right += width;
                            left -= width;
                        }
                    }
                    // If either `right` or `left` is zero, don't set a style to the element. This
                    // allows users to specify a custom size via CSS class in SSR scenarios where the
                    // measured widths will always be zero. Note that we reset to `null` here, rather
                    // than below, in order to ensure that the types in the `if` below are consistent.
                    left = left || ( /** @type {?} */(null));
                    right = right || ( /** @type {?} */(null));
                    if (left !== this._contentMargins.left || right !== this._contentMargins.right) {
                        this._contentMargins = { left: left, right: right };
                        // Pull back into the NgZone since in some cases we could be outside. We need to be careful
                        // to do it only when something changed, otherwise we can end up hitting the zone too often.
                        this._ngZone.run(( /**
                         * @return {?}
                         */function () { return _this._contentMarginChanges.next(_this._contentMargins); }));
                    }
                };
                /**
                 * @return {?}
                 */
                MatDrawerContainer.prototype.ngDoCheck = function () {
                    var _this = this;
                    // If users opted into autosizing, do a check every change detection cycle.
                    if (this._autosize && this._isPushed()) {
                        // Run outside the NgZone, otherwise the debouncer will throw us into an infinite loop.
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return _this._doCheckSubject.next(); }));
                    }
                };
                /**
                 * Subscribes to drawer events in order to set a class on the main container element when the
                 * drawer is open and the backdrop is visible. This ensures any overflow on the container element
                 * is properly hidden.
                 * @private
                 * @param {?} drawer
                 * @return {?}
                 */
                MatDrawerContainer.prototype._watchDrawerToggle = function (drawer) {
                    var _this = this;
                    drawer._animationStarted.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["filter"])(( /**
                     * @param {?} event
                     * @return {?}
                     */function (event) { return event.fromState !== event.toState; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(this._drawers.changes))
                        .subscribe(( /**
                 * @param {?} event
                 * @return {?}
                 */function (event) {
                        // Set the transition class on the container so that the animations occur. This should not
                        // be set initially because animations should only be triggered via a change in state.
                        if (event.toState !== 'open-instant' && _this._animationMode !== 'NoopAnimations') {
                            _this._element.nativeElement.classList.add('mat-drawer-transition');
                        }
                        _this.updateContentMargins();
                        _this._changeDetectorRef.markForCheck();
                    }));
                    if (drawer.mode !== 'side') {
                        drawer.openedChange.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(this._drawers.changes)).subscribe(( /**
                         * @return {?}
                         */function () { return _this._setContainerClass(drawer.opened); }));
                    }
                };
                /**
                 * Subscribes to drawer onPositionChanged event in order to
                 * re-validate drawers when the position changes.
                 * @private
                 * @param {?} drawer
                 * @return {?}
                 */
                MatDrawerContainer.prototype._watchDrawerPosition = function (drawer) {
                    var _this = this;
                    if (!drawer) {
                        return;
                    }
                    // NOTE: We need to wait for the microtask queue to be empty before validating,
                    // since both drawers may be swapping positions at the same time.
                    drawer.onPositionChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(this._drawers.changes)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._ngZone.onMicrotaskEmpty.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["take"])(1)).subscribe(( /**
                         * @return {?}
                         */function () {
                            _this._validateDrawers();
                        }));
                    }));
                };
                /**
                 * Subscribes to changes in drawer mode so we can run change detection.
                 * @private
                 * @param {?} drawer
                 * @return {?}
                 */
                MatDrawerContainer.prototype._watchDrawerMode = function (drawer) {
                    var _this = this;
                    if (drawer) {
                        drawer._modeChanged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["takeUntil"])(Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(this._drawers.changes, this._destroyed)))
                            .subscribe(( /**
                     * @return {?}
                     */function () {
                            _this.updateContentMargins();
                            _this._changeDetectorRef.markForCheck();
                        }));
                    }
                };
                /**
                 * Toggles the 'mat-drawer-opened' class on the main 'mat-drawer-container' element.
                 * @private
                 * @param {?} isAdd
                 * @return {?}
                 */
                MatDrawerContainer.prototype._setContainerClass = function (isAdd) {
                    /** @type {?} */
                    var classList = this._element.nativeElement.classList;
                    /** @type {?} */
                    var className = 'mat-drawer-container-has-open';
                    if (isAdd) {
                        classList.add(className);
                    }
                    else {
                        classList.remove(className);
                    }
                };
                /**
                 * Validate the state of the drawer children components.
                 * @private
                 * @return {?}
                 */
                MatDrawerContainer.prototype._validateDrawers = function () {
                    var _this = this;
                    this._start = this._end = null;
                    // Ensure that we have at most one start and one end drawer.
                    this._drawers.forEach(( /**
                     * @param {?} drawer
                     * @return {?}
                     */function (/**
                     * @param {?} drawer
                     * @return {?}
                     */ drawer) {
                        if (drawer.position == 'end') {
                            if (_this._end != null) {
                                throwMatDuplicatedDrawerError('end');
                            }
                            _this._end = drawer;
                        }
                        else {
                            if (_this._start != null) {
                                throwMatDuplicatedDrawerError('start');
                            }
                            _this._start = drawer;
                        }
                    }));
                    this._right = this._left = null;
                    // Detect if we're LTR or RTL.
                    if (this._dir && this._dir.value === 'rtl') {
                        this._left = this._end;
                        this._right = this._start;
                    }
                    else {
                        this._left = this._start;
                        this._right = this._end;
                    }
                };
                /**
                 * Whether the container is being pushed to the side by one of the drawers.
                 * @private
                 * @return {?}
                 */
                MatDrawerContainer.prototype._isPushed = function () {
                    return (this._isDrawerOpen(this._start) && this._start.mode != 'over') ||
                        (this._isDrawerOpen(this._end) && this._end.mode != 'over');
                };
                /**
                 * @return {?}
                 */
                MatDrawerContainer.prototype._onBackdropClicked = function () {
                    this.backdropClick.emit();
                    this._closeModalDrawer();
                };
                /**
                 * @return {?}
                 */
                MatDrawerContainer.prototype._closeModalDrawer = function () {
                    var _this = this;
                    // Close all open drawers where closing is not disabled and the mode is not `side`.
                    [this._start, this._end]
                        .filter(( /**
                 * @param {?} drawer
                 * @return {?}
                 */function (/**
                 * @param {?} drawer
                 * @return {?}
                 */ drawer) { return drawer && !drawer.disableClose && _this._canHaveBackdrop(drawer); }))
                        .forEach(( /**
                 * @param {?} drawer
                 * @return {?}
                 */function (/**
                 * @param {?} drawer
                 * @return {?}
                 */ drawer) { return ( /** @type {?} */(drawer)).close(); }));
                };
                /**
                 * @return {?}
                 */
                MatDrawerContainer.prototype._isShowingBackdrop = function () {
                    return (this._isDrawerOpen(this._start) && this._canHaveBackdrop(this._start)) ||
                        (this._isDrawerOpen(this._end) && this._canHaveBackdrop(this._end));
                };
                /**
                 * @private
                 * @param {?} drawer
                 * @return {?}
                 */
                MatDrawerContainer.prototype._canHaveBackdrop = function (drawer) {
                    return drawer.mode !== 'side' || !!this._backdropOverride;
                };
                /**
                 * @private
                 * @param {?} drawer
                 * @return {?}
                 */
                MatDrawerContainer.prototype._isDrawerOpen = function (drawer) {
                    return drawer != null && drawer.opened;
                };
                return MatDrawerContainer;
            }());
            MatDrawerContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-drawer-container',
                            exportAs: 'matDrawerContainer',
                            template: "<div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" *ngIf=\"hasBackdrop\" [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div><ng-content select=\"mat-drawer\"></ng-content><ng-content select=\"mat-drawer-content\"></ng-content><mat-drawer-content *ngIf=\"!_content\"><ng-content></ng-content></mat-drawer-content>",
                            styles: [".mat-drawer-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-container-has-open{overflow:hidden}.mat-drawer-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.mat-drawer-container.ng-animate-disabled .mat-drawer-backdrop,.mat-drawer-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .mat-drawer-container .mat-drawer-backdrop,.ng-animate-disabled .mat-drawer-container .mat-drawer-content{transition:none}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:background-color,visibility}@media (-ms-high-contrast:active){.mat-drawer-backdrop{opacity:.5}}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}@media (-ms-high-contrast:active){.mat-drawer,[dir=rtl] .mat-drawer.mat-drawer-end{border-right:solid 1px currentColor}}@media (-ms-high-contrast:active){.mat-drawer.mat-drawer-end,[dir=rtl] .mat-drawer{border-left:solid 1px currentColor;border-right:none}}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer{transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer.mat-drawer-end{left:0;right:auto;transform:translate3d(-100%,0,0)}.mat-drawer-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.mat-sidenav-fixed{position:fixed}"],
                            host: {
                                'class': 'mat-drawer-container',
                                '[class.mat-drawer-container-explicit-backdrop]': '_backdropOverride',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatDrawerContainer.ctorParameters = function () { return [
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectorRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["ViewportRuler"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Inject"], args: [MAT_DRAWER_DEFAULT_AUTOSIZE,] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatDrawerContainer.propDecorators = {
                _drawers: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChildren"], args: [MatDrawer,] }],
                _content: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChild"], args: [MatDrawerContent, { static: false },] }],
                _userContent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewChild"], args: [MatDrawerContent, { static: false },] }],
                autosize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                hasBackdrop: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                backdropClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Output"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatSidenavContent = /** @class */ (function (_super_1) {
                __extends(MatSidenavContent, _super_1);
                /**
                 * @param {?} changeDetectorRef
                 * @param {?} container
                 * @param {?} elementRef
                 * @param {?} scrollDispatcher
                 * @param {?} ngZone
                 */
                function MatSidenavContent(changeDetectorRef, container, elementRef, scrollDispatcher, ngZone) {
                    return _super_1.call(this, changeDetectorRef, container, elementRef, scrollDispatcher, ngZone) || this;
                }
                return MatSidenavContent;
            }(MatDrawerContent));
            MatSidenavContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-sidenav-content',
                            template: '<ng-content></ng-content>',
                            host: {
                                'class': 'mat-drawer-content mat-sidenav-content',
                                '[style.margin-left.px]': '_container._contentMargins.left',
                                '[style.margin-right.px]': '_container._contentMargins.right',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatSidenavContent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectorRef"] },
                { type: MatSidenavContainer, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return MatSidenavContainer; })),] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ElementRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["ScrollDispatcher"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgZone"] }
            ]; };
            var MatSidenav = /** @class */ (function (_super_1) {
                __extends(MatSidenav, _super_1);
                function MatSidenav() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this._fixedInViewport = false;
                    _this._fixedTopGap = 0;
                    _this._fixedBottomGap = 0;
                    return _this;
                }
                Object.defineProperty(MatSidenav.prototype, "fixedInViewport", {
                    /**
                     * Whether the sidenav is fixed in the viewport.
                     * @return {?}
                     */
                    get: function () { return this._fixedInViewport; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._fixedInViewport = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSidenav.prototype, "fixedTopGap", {
                    /**
                     * The gap between the top of the sidenav and the top of the viewport when the sidenav is in fixed
                     * mode.
                     * @return {?}
                     */
                    get: function () { return this._fixedTopGap; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._fixedTopGap = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceNumberProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSidenav.prototype, "fixedBottomGap", {
                    /**
                     * The gap between the bottom of the sidenav and the bottom of the viewport when the sidenav is in
                     * fixed mode.
                     * @return {?}
                     */
                    get: function () { return this._fixedBottomGap; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._fixedBottomGap = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceNumberProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                return MatSidenav;
            }(MatDrawer));
            MatSidenav.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-sidenav',
                            exportAs: 'matSidenav',
                            template: "<div class=\"mat-drawer-inner-container\"><ng-content></ng-content></div>",
                            animations: [matDrawerAnimations.transformDrawer],
                            host: {
                                'class': 'mat-drawer mat-sidenav',
                                'tabIndex': '-1',
                                // must prevent the browser from aligning text based on value
                                '[attr.align]': 'null',
                                '[class.mat-drawer-end]': 'position === "end"',
                                '[class.mat-drawer-over]': 'mode === "over"',
                                '[class.mat-drawer-push]': 'mode === "push"',
                                '[class.mat-drawer-side]': 'mode === "side"',
                                '[class.mat-drawer-opened]': 'opened',
                                '[class.mat-sidenav-fixed]': 'fixedInViewport',
                                '[style.top.px]': 'fixedInViewport ? fixedTopGap : null',
                                '[style.bottom.px]': 'fixedInViewport ? fixedBottomGap : null',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                        },] },
            ];
            MatSidenav.propDecorators = {
                fixedInViewport: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                fixedTopGap: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }],
                fixedBottomGap: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Input"] }]
            };
            var MatSidenavContainer = /** @class */ (function (_super_1) {
                __extends(MatSidenavContainer, _super_1);
                function MatSidenavContainer() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatSidenavContainer;
            }(MatDrawerContainer));
            MatSidenavContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"], args: [{ selector: 'mat-sidenav-container',
                            exportAs: 'matSidenavContainer',
                            template: "<div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" *ngIf=\"hasBackdrop\" [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div><ng-content select=\"mat-sidenav\"></ng-content><ng-content select=\"mat-sidenav-content\"></ng-content><mat-sidenav-content *ngIf=\"!_content\" cdkScrollable><ng-content></ng-content></mat-sidenav-content>",
                            styles: [".mat-drawer-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-container-has-open{overflow:hidden}.mat-drawer-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.mat-drawer-container.ng-animate-disabled .mat-drawer-backdrop,.mat-drawer-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .mat-drawer-container .mat-drawer-backdrop,.ng-animate-disabled .mat-drawer-container .mat-drawer-content{transition:none}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:background-color,visibility}@media (-ms-high-contrast:active){.mat-drawer-backdrop{opacity:.5}}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}@media (-ms-high-contrast:active){.mat-drawer,[dir=rtl] .mat-drawer.mat-drawer-end{border-right:solid 1px currentColor}}@media (-ms-high-contrast:active){.mat-drawer.mat-drawer-end,[dir=rtl] .mat-drawer{border-left:solid 1px currentColor;border-right:none}}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer{transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer.mat-drawer-end{left:0;right:auto;transform:translate3d(-100%,0,0)}.mat-drawer-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.mat-sidenav-fixed{position:fixed}"],
                            host: {
                                'class': 'mat-drawer-container mat-sidenav-container',
                                '[class.mat-drawer-container-explicit-backdrop]': '_backdropOverride',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ViewEncapsulation"].None,
                        },] },
            ];
            MatSidenavContainer.propDecorators = {
                _drawers: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChildren"], args: [MatSidenav,] }],
                _content: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["ContentChild"], args: [MatSidenavContent, { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatSidenavModule = /** @class */ (function () {
                function MatSidenavModule() {
                }
                return MatSidenavModule;
            }());
            MatSidenavModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_7__["CommonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_12__["MatCommonModule"],
                                _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_6__["ScrollingModule"],
                                _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_5__["PlatformModule"],
                            ],
                            exports: [
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_12__["MatCommonModule"],
                                MatDrawer,
                                MatDrawerContainer,
                                MatDrawerContent,
                                MatSidenav,
                                MatSidenavContainer,
                                MatSidenavContent,
                            ],
                            declarations: [
                                MatDrawer,
                                MatDrawerContainer,
                                MatDrawerContent,
                                MatSidenav,
                                MatSidenavContainer,
                                MatSidenavContent,
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=sidenav.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/slide-toggle.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/slide-toggle.js ***!
          \****************************************************************/
        /*! exports provided: _MatSlideToggleRequiredValidatorModule, MatSlideToggleModule, MAT_SLIDE_TOGGLE_VALUE_ACCESSOR, MatSlideToggleChange, MatSlideToggle, MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR, MatSlideToggleRequiredValidator */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatSlideToggleRequiredValidatorModule", function () { return _MatSlideToggleRequiredValidatorModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggleModule", function () { return MatSlideToggleModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDE_TOGGLE_VALUE_ACCESSOR", function () { return MAT_SLIDE_TOGGLE_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggleChange", function () { return MatSlideToggleChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggle", function () { return MatSlideToggle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS", function () { return MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR", function () { return MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSlideToggleRequiredValidator", function () { return MatSlideToggleRequiredValidator; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/observers */ "./node_modules/@angular/cdk/esm2015/observers.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token to be used to override the default options for `mat-slide-toggle`.
             * @type {?}
             */
            var MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('mat-slide-toggle-default-options', {
                providedIn: 'root',
                factory: ( /**
                 * @return {?}
                 */function () { return ({ disableToggleValue: false, disableDragValue: false }); })
            });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Increasing integer for generating unique ids for slide-toggle components.
            /** @type {?} */
            var nextUniqueId = 0;
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_SLIDE_TOGGLE_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatSlideToggle; })),
                multi: true
            };
            /**
             * Change event object emitted by a MatSlideToggle.
             */
            var MatSlideToggleChange = /** @class */ (function () {
                /**
                 * @param {?} source
                 * @param {?} checked
                 */
                function MatSlideToggleChange(source, checked) {
                    this.source = source;
                    this.checked = checked;
                }
                return MatSlideToggleChange;
            }());
            // Boilerplate for applying mixins to MatSlideToggle.
            /**
             * \@docs-private
             */
            var MatSlideToggleBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatSlideToggleBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatSlideToggleBase;
            }());
            /** @type {?} */
            var _MatSlideToggleMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinTabIndex"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinColor"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["mixinDisabled"])(MatSlideToggleBase)), 'accent'));
            /**
             * Represents a slidable "switch" toggle that can be moved between on and off.
             */
            var MatSlideToggle = /** @class */ (function (_super_1) {
                __extends(MatSlideToggle, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _focusMonitor
                 * @param {?} _changeDetectorRef
                 * @param {?} tabIndex
                 * @param {?} _ngZone
                 * @param {?} defaults
                 * @param {?=} _animationMode
                 * @param {?=} _dir
                 */
                function MatSlideToggle(elementRef, _focusMonitor, _changeDetectorRef, tabIndex, _ngZone, defaults, _animationMode, _dir) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._focusMonitor = _focusMonitor;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._ngZone = _ngZone;
                    _this.defaults = defaults;
                    _this._animationMode = _animationMode;
                    _this._dir = _dir;
                    _this._onChange = ( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { });
                    _this._onTouched = ( /**
                     * @return {?}
                     */function () { });
                    _this._uniqueId = "mat-slide-toggle-" + ++nextUniqueId;
                    _this._required = false;
                    _this._checked = false;
                    /**
                     * Whether the thumb is currently being dragged.
                     */
                    _this._dragging = false;
                    /**
                     * Name value will be applied to the input element if present.
                     */
                    _this.name = null;
                    /**
                     * A unique id for the slide-toggle input. If none is supplied, it will be auto-generated.
                     */
                    _this.id = _this._uniqueId;
                    /**
                     * Whether the label should appear after or before the slide-toggle. Defaults to 'after'.
                     */
                    _this.labelPosition = 'after';
                    /**
                     * Used to set the aria-label attribute on the underlying input element.
                     */
                    _this.ariaLabel = null;
                    /**
                     * Used to set the aria-labelledby attribute on the underlying input element.
                     */
                    _this.ariaLabelledby = null;
                    /**
                     * An event will be dispatched each time the slide-toggle changes its value.
                     */
                    _this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * An event will be dispatched each time the slide-toggle input is toggled.
                     * This event is always emitted when the user toggles the slide toggle, but this does not mean
                     * the slide toggle's value has changed. The event does not fire when the user drags to change
                     * the slide toggle value.
                     */
                    _this.toggleChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * An event will be dispatched each time the slide-toggle is dragged.
                     * This event is always emitted when the user drags the slide toggle to make a change greater
                     * than 50%. It does not mean the slide toggle's value is changed. The event is not emitted when
                     * the user toggles the slide toggle to change its value.
                     */
                    _this.dragChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    _this.tabIndex = parseInt(tabIndex) || 0;
                    return _this;
                }
                Object.defineProperty(MatSlideToggle.prototype, "required", {
                    /**
                     * Whether the slide-toggle is required.
                     * @return {?}
                     */
                    get: function () { return this._required; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._required = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlideToggle.prototype, "checked", {
                    /**
                     * Whether the slide-toggle element is checked or not.
                     * @return {?}
                     */
                    get: function () { return this._checked; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._checked = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlideToggle.prototype, "inputId", {
                    /**
                     * Returns the unique id for the visual hidden input.
                     * @return {?}
                     */
                    get: function () { return (this.id || this._uniqueId) + "-input"; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatSlideToggle.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._focusMonitor
                        .monitor(this._elementRef, true)
                        .subscribe(( /**
                 * @param {?} focusOrigin
                 * @return {?}
                 */function (/**
                 * @param {?} focusOrigin
                 * @return {?}
                 */ focusOrigin) {
                        if (!focusOrigin) {
                            // When a focused element becomes disabled, the browser *immediately* fires a blur event.
                            // Angular does not expect events to be raised during change detection, so any state
                            // change (such as a form control's 'ng-touched') will cause a changed-after-checked
                            // error. See https://github.com/angular/angular/issues/17793. To work around this,
                            // we defer telling the form control it has been touched until the next tick.
                            Promise.resolve().then(( /**
                             * @return {?}
                             */function () { return _this._onTouched(); }));
                        }
                    }));
                };
                /**
                 * @return {?}
                 */
                MatSlideToggle.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this._elementRef);
                };
                /**
                 * Method being called whenever the underlying input emits a change event.
                 * @param {?} event
                 * @return {?}
                 */
                MatSlideToggle.prototype._onChangeEvent = function (event) {
                    // We always have to stop propagation on the change event.
                    // Otherwise the change event, from the input element, will bubble up and
                    // emit its event object to the component's `change` output.
                    event.stopPropagation();
                    if (!this._dragging) {
                        this.toggleChange.emit();
                    }
                    // Releasing the pointer over the `<label>` element while dragging triggers another
                    // click event on the `<label>` element. This means that the checked state of the underlying
                    // input changed unintentionally and needs to be changed back. Or when the slide toggle's config
                    // disabled toggle change event by setting `disableToggleValue: true`, the slide toggle's value
                    // does not change, and the checked state of the underlying input needs to be changed back.
                    if (this._dragging || this.defaults.disableToggleValue) {
                        this._inputElement.nativeElement.checked = this.checked;
                        return;
                    }
                    // Sync the value from the underlying input element with the component instance.
                    this.checked = this._inputElement.nativeElement.checked;
                    // Emit our custom change event only if the underlying input emitted one. This ensures that
                    // there is no change event, when the checked state changes programmatically.
                    this._emitChangeEvent();
                };
                /**
                 * Method being called whenever the slide-toggle has been clicked.
                 * @param {?} event
                 * @return {?}
                 */
                MatSlideToggle.prototype._onInputClick = function (event) {
                    // We have to stop propagation for click events on the visual hidden input element.
                    // By default, when a user clicks on a label element, a generated click event will be
                    // dispatched on the associated input element. Since we are using a label element as our
                    // root container, the click event on the `slide-toggle` will be executed twice.
                    // The real click event will bubble up, and the generated click event also tries to bubble up.
                    // This will lead to multiple click events.
                    // Preventing bubbling for the second event will solve that issue.
                    event.stopPropagation();
                };
                /**
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} value
                 * @return {?}
                 */
                MatSlideToggle.prototype.writeValue = function (value) {
                    this.checked = !!value;
                };
                /**
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn
                 * @return {?}
                 */
                MatSlideToggle.prototype.registerOnChange = function (fn) {
                    this._onChange = fn;
                };
                /**
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn
                 * @return {?}
                 */
                MatSlideToggle.prototype.registerOnTouched = function (fn) {
                    this._onTouched = fn;
                };
                /**
                 * Implemented as a part of ControlValueAccessor.
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatSlideToggle.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Focuses the slide-toggle.
                 * @param {?=} options
                 * @return {?}
                 */
                MatSlideToggle.prototype.focus = function (options) {
                    this._focusMonitor.focusVia(this._inputElement, 'keyboard', options);
                };
                /**
                 * Toggles the checked state of the slide-toggle.
                 * @return {?}
                 */
                MatSlideToggle.prototype.toggle = function () {
                    this.checked = !this.checked;
                    this._onChange(this.checked);
                };
                /**
                 * Emits a change event on the `change` output. Also notifies the FormControl about the change.
                 * @private
                 * @return {?}
                 */
                MatSlideToggle.prototype._emitChangeEvent = function () {
                    this._onChange(this.checked);
                    this.change.emit(new MatSlideToggleChange(this, this.checked));
                };
                /**
                 * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
                 * @private
                 * @param {?} distance
                 * @return {?}
                 */
                MatSlideToggle.prototype._getDragPercentage = function (distance) {
                    /** @type {?} */
                    var percentage = (distance / this._thumbBarWidth) * 100;
                    // When the toggle was initially checked, then we have to start the drag at the end.
                    if (this._previousChecked) {
                        percentage += 100;
                    }
                    return Math.max(0, Math.min(percentage, 100));
                };
                /**
                 * @return {?}
                 */
                MatSlideToggle.prototype._onDragStart = function () {
                    if (!this.disabled && !this._dragging) {
                        /** @type {?} */
                        var thumbEl = this._thumbEl.nativeElement;
                        this._thumbBarWidth = this._thumbBarEl.nativeElement.clientWidth - thumbEl.clientWidth;
                        thumbEl.classList.add('mat-dragging');
                        this._previousChecked = this.checked;
                        this._dragging = true;
                    }
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatSlideToggle.prototype._onDrag = function (event) {
                    if (this._dragging) {
                        /** @type {?} */
                        var direction = this._dir && this._dir.value === 'rtl' ? -1 : 1;
                        this._dragPercentage = this._getDragPercentage(event.deltaX * direction);
                        // Calculate the moved distance based on the thumb bar width.
                        /** @type {?} */
                        var dragX = (this._dragPercentage / 100) * this._thumbBarWidth * direction;
                        this._thumbEl.nativeElement.style.transform = "translate3d(" + dragX + "px, 0, 0)";
                    }
                };
                /**
                 * @return {?}
                 */
                MatSlideToggle.prototype._onDragEnd = function () {
                    var _this = this;
                    if (this._dragging) {
                        /** @type {?} */
                        var newCheckedValue = this._dragPercentage > 50;
                        if (newCheckedValue !== this.checked) {
                            this.dragChange.emit();
                            if (!this.defaults.disableDragValue) {
                                this.checked = newCheckedValue;
                                this._emitChangeEvent();
                            }
                        }
                        // The drag should be stopped outside of the current event handler, otherwise the
                        // click event will be fired before it and will revert the drag change.
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return setTimeout(( /**
                         * @return {?}
                         */function () {
                            if (_this._dragging) {
                                _this._dragging = false;
                                _this._thumbEl.nativeElement.classList.remove('mat-dragging');
                                // Reset the transform because the component will take care
                                // of the thumb position after drag.
                                _this._thumbEl.nativeElement.style.transform = '';
                            }
                        })); }));
                    }
                };
                /**
                 * Method being called whenever the label text changes.
                 * @return {?}
                 */
                MatSlideToggle.prototype._onLabelTextChange = function () {
                    // Since the event of the `cdkObserveContent` directive runs outside of the zone, the
                    // slide-toggle component will be only marked for check, but no actual change detection runs
                    // automatically. Instead of going back into the zone in order to trigger a change detection
                    // which causes *all* components to be checked (if explicitly marked or not using OnPush),
                    // we only trigger an explicit change detection for the slide-toggle view and its children.
                    this._changeDetectorRef.detectChanges();
                };
                return MatSlideToggle;
            }(_MatSlideToggleMixinBase));
            MatSlideToggle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-slide-toggle',
                            exportAs: 'matSlideToggle',
                            host: {
                                'class': 'mat-slide-toggle',
                                '[id]': 'id',
                                // Needs to be `-1` so it can still receive programmatic focus.
                                '[attr.tabindex]': 'disabled ? null : -1',
                                '[attr.aria-label]': 'null',
                                '[attr.aria-labelledby]': 'null',
                                '[class.mat-checked]': 'checked',
                                '[class.mat-disabled]': 'disabled',
                                '[class.mat-slide-toggle-label-before]': 'labelPosition == "before"',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                                '(focus)': '_inputElement.nativeElement.focus()',
                            },
                            template: "<label [attr.for]=\"inputId\" class=\"mat-slide-toggle-label\" #label><div #toggleBar class=\"mat-slide-toggle-bar\" [class.mat-slide-toggle-bar-no-side-margin]=\"!labelContent.textContent || !labelContent.textContent.trim()\"><input #input class=\"mat-slide-toggle-input cdk-visually-hidden\" type=\"checkbox\" role=\"switch\" [id]=\"inputId\" [required]=\"required\" [tabIndex]=\"tabIndex\" [checked]=\"checked\" [disabled]=\"disabled\" [attr.name]=\"name\" [attr.aria-checked]=\"checked.toString()\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-slide-toggle-thumb-container\" #thumbContainer (slidestart)=\"_onDragStart()\" (slide)=\"_onDrag($event)\" (slideend)=\"_onDragEnd()\"><div class=\"mat-slide-toggle-thumb\"></div><div class=\"mat-slide-toggle-ripple\" mat-ripple [matRippleTrigger]=\"label\" [matRippleDisabled]=\"disableRipple || disabled\" [matRippleCentered]=\"true\" [matRippleRadius]=\"20\" [matRippleAnimation]=\"{enterDuration: 150}\"><div class=\"mat-ripple-element mat-slide-toggle-persistent-ripple\"></div></div></div></div><span class=\"mat-slide-toggle-content\" #labelContent (cdkObserveContent)=\"_onLabelTextChange()\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></span></label>",
                            styles: [".mat-slide-toggle{display:inline-block;height:24px;max-width:100%;line-height:24px;white-space:nowrap;outline:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(16px,0,0)}[dir=rtl] .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(-16px,0,0)}.mat-slide-toggle.mat-disabled{opacity:.38}.mat-slide-toggle.mat-disabled .mat-slide-toggle-label,.mat-slide-toggle.mat-disabled .mat-slide-toggle-thumb-container{cursor:default}.mat-slide-toggle-label{display:flex;flex:1;flex-direction:row;align-items:center;height:inherit;cursor:pointer}.mat-slide-toggle-content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-slide-toggle-label-before .mat-slide-toggle-label{order:1}.mat-slide-toggle-label-before .mat-slide-toggle-bar{order:2}.mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-label-before .mat-slide-toggle-bar{margin-right:8px;margin-left:0}.mat-slide-toggle-label-before .mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-bar{margin-left:8px;margin-right:0}.mat-slide-toggle-bar-no-side-margin{margin-left:0;margin-right:0}.mat-slide-toggle-thumb-container{position:absolute;z-index:1;width:20px;height:20px;top:-3px;left:0;transform:translate3d(0,0,0);transition:all 80ms linear;transition-property:transform;cursor:-webkit-grab;cursor:grab}.mat-slide-toggle-thumb-container.mat-dragging{transition-duration:0s}.mat-slide-toggle-thumb-container:active{cursor:-webkit-grabbing;cursor:grabbing}._mat-animation-noopable .mat-slide-toggle-thumb-container{transition:none}[dir=rtl] .mat-slide-toggle-thumb-container{left:auto;right:0}.mat-slide-toggle-thumb{height:20px;width:20px;border-radius:50%}.mat-slide-toggle-bar{position:relative;width:36px;height:14px;flex-shrink:0;border-radius:8px}.mat-slide-toggle-input{bottom:0;left:10px}[dir=rtl] .mat-slide-toggle-input{left:auto;right:10px}.mat-slide-toggle-bar,.mat-slide-toggle-thumb{transition:all 80ms linear;transition-property:background-color;transition-delay:50ms}._mat-animation-noopable .mat-slide-toggle-bar,._mat-animation-noopable .mat-slide-toggle-thumb{transition:none}.mat-slide-toggle .mat-slide-toggle-ripple{position:absolute;top:calc(50% - 20px);left:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none}.mat-slide-toggle .mat-slide-toggle-ripple .mat-ripple-element:not(.mat-slide-toggle-persistent-ripple){opacity:.12}.mat-slide-toggle-persistent-ripple{width:100%;height:100%;transform:none}.mat-slide-toggle-bar:hover .mat-slide-toggle-persistent-ripple{opacity:.04}.mat-slide-toggle:not(.mat-disabled).cdk-keyboard-focused .mat-slide-toggle-persistent-ripple{opacity:.12}.mat-slide-toggle-persistent-ripple,.mat-slide-toggle.mat-disabled .mat-slide-toggle-bar:hover .mat-slide-toggle-persistent-ripple{opacity:0}@media (hover:none){.mat-slide-toggle-bar:hover .mat-slide-toggle-persistent-ripple{display:none}}@media (-ms-high-contrast:active){.mat-slide-toggle-thumb{background:#fff;border:1px solid #000}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background:#000;border:1px solid #fff}.mat-slide-toggle-bar{background:#fff}.mat-slide-toggle.cdk-keyboard-focused .mat-slide-toggle-bar{outline:1px dotted;outline-offset:5px}}@media (-ms-high-contrast:black-on-white){.mat-slide-toggle-bar{border:1px solid #000}}"],
                            providers: [MAT_SLIDE_TOGGLE_VALUE_ACCESSOR],
                            inputs: ['disabled', 'disableRipple', 'color', 'tabIndex'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatSlideToggle.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["FocusMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['tabindex',] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__["ANIMATION_MODULE_TYPE"],] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] }
            ]; };
            MatSlideToggle.propDecorators = {
                _thumbEl: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['thumbContainer', { static: false },] }],
                _thumbBarEl: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['toggleBar', { static: false },] }],
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                labelPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-labelledby',] }],
                required: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                checked: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                toggleChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                dragChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _inputElement: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['input', { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NG_VALIDATORS"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatSlideToggleRequiredValidator; })),
                multi: true
            };
            /**
             * Validator for Material slide-toggle components with the required attribute in a
             * template-driven form. The default validator for required form controls asserts
             * that the control value is not undefined but that is not appropriate for a slide-toggle
             * where the value is always defined.
             *
             * Required slide-toggle form controls are valid when checked.
             */
            var MatSlideToggleRequiredValidator = /** @class */ (function (_super_1) {
                __extends(MatSlideToggleRequiredValidator, _super_1);
                function MatSlideToggleRequiredValidator() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatSlideToggleRequiredValidator;
            }(_angular_forms__WEBPACK_IMPORTED_MODULE_4__["CheckboxRequiredValidator"]));
            MatSlideToggleRequiredValidator.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: "mat-slide-toggle[required][formControlName],\n             mat-slide-toggle[required][formControl], mat-slide-toggle[required][ngModel]",
                            providers: [MAT_SLIDE_TOGGLE_REQUIRED_VALIDATOR],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This module is used by both original and MDC-based slide-toggle implementations.
             */
            // tslint:disable-next-line:class-name
            var _MatSlideToggleRequiredValidatorModule = /** @class */ (function () {
                function _MatSlideToggleRequiredValidatorModule() {
                }
                return _MatSlideToggleRequiredValidatorModule;
            }());
            _MatSlideToggleRequiredValidatorModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            exports: [MatSlideToggleRequiredValidator],
                            declarations: [MatSlideToggleRequiredValidator],
                        },] },
            ];
            var MatSlideToggleModule = /** @class */ (function () {
                function MatSlideToggleModule() {
                }
                return MatSlideToggleModule;
            }());
            MatSlideToggleModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _MatSlideToggleRequiredValidatorModule,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatRippleModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatCommonModule"],
                                _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_7__["ObserversModule"],
                            ],
                            exports: [
                                _MatSlideToggleRequiredValidatorModule,
                                MatSlideToggle,
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MatCommonModule"]
                            ],
                            declarations: [MatSlideToggle],
                            providers: [
                                { provide: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__["HAMMER_GESTURE_CONFIG"], useClass: _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["GestureConfig"] }
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=slide-toggle.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/slider.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/slider.js ***!
          \**********************************************************/
        /*! exports provided: MatSliderModule, MAT_SLIDER_VALUE_ACCESSOR, MatSliderChange, MatSlider */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSliderModule", function () { return MatSliderModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SLIDER_VALUE_ACCESSOR", function () { return MAT_SLIDER_VALUE_ACCESSOR; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSliderChange", function () { return MatSliderChange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSlider", function () { return MatSlider; });
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Visually, a 30px separation between tick marks looks best. This is very subjective but it is
             * the default separation we chose.
             * @type {?}
             */
            var MIN_AUTO_TICK_SEPARATION = 30;
            /**
             * The thumb gap size for a disabled slider.
             * @type {?}
             */
            var DISABLED_THUMB_GAP = 7;
            /**
             * The thumb gap size for a non-active slider at its minimum value.
             * @type {?}
             */
            var MIN_VALUE_NONACTIVE_THUMB_GAP = 7;
            /**
             * The thumb gap size for an active slider at its minimum value.
             * @type {?}
             */
            var MIN_VALUE_ACTIVE_THUMB_GAP = 10;
            /**
             * Provider Expression that allows mat-slider to register as a ControlValueAccessor.
             * This allows it to support [(ngModel)] and [formControl].
             * \@docs-private
             * @type {?}
             */
            var MAT_SLIDER_VALUE_ACCESSOR = {
                provide: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["NG_VALUE_ACCESSOR"],
                useExisting: Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["forwardRef"])(( /**
                 * @return {?}
                 */function () { return MatSlider; })),
                multi: true
            };
            /**
             * A simple change event emitted by the MatSlider component.
             */
            var MatSliderChange = /** @class */ (function () {
                function MatSliderChange() {
                }
                return MatSliderChange;
            }());
            // Boilerplate for applying mixins to MatSlider.
            /**
             * \@docs-private
             */
            var MatSliderBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatSliderBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatSliderBase;
            }());
            /** @type {?} */
            var _MatSliderMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["mixinTabIndex"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["mixinColor"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["mixinDisabled"])(MatSliderBase), 'accent'));
            /**
             * Allows users to select from a range of values by moving the slider thumb. It is similar in
             * behavior to the native `<input type="range">` element.
             */
            var MatSlider = /** @class */ (function (_super_1) {
                __extends(MatSlider, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _focusMonitor
                 * @param {?} _changeDetectorRef
                 * @param {?} _dir
                 * @param {?} tabIndex
                 * @param {?=} _animationMode
                 */
                function MatSlider(elementRef, _focusMonitor, _changeDetectorRef, _dir, tabIndex, _animationMode) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._focusMonitor = _focusMonitor;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._dir = _dir;
                    _this._animationMode = _animationMode;
                    _this._invert = false;
                    _this._max = 100;
                    _this._min = 0;
                    _this._step = 1;
                    _this._thumbLabel = false;
                    _this._tickInterval = 0;
                    _this._value = null;
                    _this._vertical = false;
                    /**
                     * Event emitted when the slider value has changed.
                     */
                    _this.change = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Event emitted when the slider thumb moves.
                     */
                    _this.input = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * Emits when the raw value of the slider changes. This is here primarily
                     * to facilitate the two-way binding for the `value` input.
                     * \@docs-private
                     */
                    _this.valueChange = new _angular_core__WEBPACK_IMPORTED_MODULE_4__["EventEmitter"]();
                    /**
                     * onTouch function registered via registerOnTouch (ControlValueAccessor).
                     */
                    _this.onTouched = ( /**
                     * @return {?}
                     */function () { });
                    _this._percent = 0;
                    /**
                     * Whether or not the thumb is sliding.
                     * Used to determine if there should be a transition for the thumb and fill track.
                     */
                    _this._isSliding = false;
                    /**
                     * Whether or not the slider is active (clicked or sliding).
                     * Used to shrink and grow the thumb as according to the Material Design spec.
                     */
                    _this._isActive = false;
                    /**
                     * The size of a tick interval as a percentage of the size of the track.
                     */
                    _this._tickIntervalPercent = 0;
                    /**
                     * The dimensions of the slider.
                     */
                    _this._sliderDimensions = null;
                    _this._controlValueAccessorChangeFn = ( /**
                     * @return {?}
                     */function () { });
                    /**
                     * Subscription to the Directionality change EventEmitter.
                     */
                    _this._dirChangeSubscription = rxjs__WEBPACK_IMPORTED_MODULE_8__["Subscription"].EMPTY;
                    _this.tabIndex = parseInt(tabIndex) || 0;
                    return _this;
                }
                Object.defineProperty(MatSlider.prototype, "invert", {
                    /**
                     * Whether the slider is inverted.
                     * @return {?}
                     */
                    get: function () { return this._invert; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._invert = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "max", {
                    /**
                     * The maximum value that the slider can have.
                     * @return {?}
                     */
                    get: function () { return this._max; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this._max = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(v, this._max);
                        this._percent = this._calculatePercentage(this._value);
                        // Since this also modifies the percentage, we need to let the change detection know.
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "min", {
                    /**
                     * The minimum value that the slider can have.
                     * @return {?}
                     */
                    get: function () { return this._min; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this._min = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(v, this._min);
                        // If the value wasn't explicitly set by the user, set it to the min.
                        if (this._value === null) {
                            this.value = this._min;
                        }
                        this._percent = this._calculatePercentage(this._value);
                        // Since this also modifies the percentage, we need to let the change detection know.
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "step", {
                    /**
                     * The values at which the thumb will snap.
                     * @return {?}
                     */
                    get: function () { return this._step; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        this._step = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(v, this._step);
                        if (this._step % 1 !== 0) {
                            this._roundToDecimal = ( /** @type {?} */(this._step.toString().split('.').pop())).length;
                        }
                        // Since this could modify the label, we need to notify the change detection.
                        this._changeDetectorRef.markForCheck();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "thumbLabel", {
                    /**
                     * Whether or not to show the thumb label.
                     * @return {?}
                     */
                    get: function () { return this._thumbLabel; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._thumbLabel = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "tickInterval", {
                    /**
                     * How often to show ticks. Relative to the step so that a tick always appears on a step.
                     * Ex: Tick interval of 4 with a step of 3 will draw a tick every 4 steps (every 12 values).
                     * @return {?}
                     */
                    get: function () { return this._tickInterval; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value === 'auto') {
                            this._tickInterval = 'auto';
                        }
                        else if (typeof value === 'number' || typeof value === 'string') {
                            this._tickInterval = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(value, ( /** @type {?} */(this._tickInterval)));
                        }
                        else {
                            this._tickInterval = 0;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "value", {
                    /**
                     * Value of the slider.
                     * @return {?}
                     */
                    get: function () {
                        // If the value needs to be read and it is still uninitialized, initialize it to the min.
                        if (this._value === null) {
                            this.value = this._min;
                        }
                        return this._value;
                    },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) {
                        if (v !== this._value) {
                            /** @type {?} */
                            var value = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceNumberProperty"])(v);
                            // While incrementing by a decimal we can end up with values like 33.300000000000004.
                            // Truncate it to ensure that it matches the label and to make it easier to work with.
                            if (this._roundToDecimal) {
                                value = parseFloat(value.toFixed(this._roundToDecimal));
                            }
                            this._value = value;
                            this._percent = this._calculatePercentage(this._value);
                            // Since this also modifies the percentage, we need to let the change detection know.
                            this._changeDetectorRef.markForCheck();
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "vertical", {
                    /**
                     * Whether the slider is vertical.
                     * @return {?}
                     */
                    get: function () { return this._vertical; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._vertical = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_2__["coerceBooleanProperty"])(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "displayValue", {
                    /**
                     * The value to be used for display purposes.
                     * @return {?}
                     */
                    get: function () {
                        if (this.displayWith) {
                            // Value is never null but since setters and getters cannot have
                            // different types, the value getter is also typed to return null.
                            return this.displayWith(( /** @type {?} */(this.value)));
                        }
                        // Note that this could be improved further by rounding something like 0.999 to 1 or
                        // 0.899 to 0.9, however it is very performance sensitive, because it gets called on
                        // every change detection cycle.
                        if (this._roundToDecimal && this.value && this.value % 1 !== 0) {
                            return this.value.toFixed(this._roundToDecimal);
                        }
                        return this.value || 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * set focus to the host element
                 * @param {?=} options
                 * @return {?}
                 */
                MatSlider.prototype.focus = function (options) {
                    this._focusHostElement(options);
                };
                /**
                 * blur the host element
                 * @return {?}
                 */
                MatSlider.prototype.blur = function () {
                    this._blurHostElement();
                };
                Object.defineProperty(MatSlider.prototype, "percent", {
                    /**
                     * The percentage of the slider that coincides with the value.
                     * @return {?}
                     */
                    get: function () { return this._clamp(this._percent); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_invertAxis", {
                    /**
                     * Whether the axis of the slider is inverted.
                     * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
                     * @return {?}
                     */
                    get: function () {
                        // Standard non-inverted mode for a vertical slider should be dragging the thumb from bottom to
                        // top. However from a y-axis standpoint this is inverted.
                        return this.vertical ? !this.invert : this.invert;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_isMinValue", {
                    /**
                     * Whether the slider is at its minimum value.
                     * @return {?}
                     */
                    get: function () {
                        return this.percent === 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_thumbGap", {
                    /**
                     * The amount of space to leave between the slider thumb and the track fill & track background
                     * elements.
                     * @return {?}
                     */
                    get: function () {
                        if (this.disabled) {
                            return DISABLED_THUMB_GAP;
                        }
                        if (this._isMinValue && !this.thumbLabel) {
                            return this._isActive ? MIN_VALUE_ACTIVE_THUMB_GAP : MIN_VALUE_NONACTIVE_THUMB_GAP;
                        }
                        return 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_trackBackgroundStyles", {
                    /**
                     * CSS styles for the track background element.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var axis = this.vertical ? 'Y' : 'X';
                        /** @type {?} */
                        var scale = this.vertical ? "1, " + (1 - this.percent) + ", 1" : 1 - this.percent + ", 1, 1";
                        /** @type {?} */
                        var sign = this._shouldInvertMouseCoords() ? '-' : '';
                        return {
                            // scale3d avoids some rendering issues in Chrome. See #12071.
                            transform: "translate" + axis + "(" + sign + this._thumbGap + "px) scale3d(" + scale + ")"
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_trackFillStyles", {
                    /**
                     * CSS styles for the track fill element.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var axis = this.vertical ? 'Y' : 'X';
                        /** @type {?} */
                        var scale = this.vertical ? "1, " + this.percent + ", 1" : this.percent + ", 1, 1";
                        /** @type {?} */
                        var sign = this._shouldInvertMouseCoords() ? '' : '-';
                        return {
                            // scale3d avoids some rendering issues in Chrome. See #12071.
                            transform: "translate" + axis + "(" + sign + this._thumbGap + "px) scale3d(" + scale + ")"
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_ticksContainerStyles", {
                    /**
                     * CSS styles for the ticks container element.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var axis = this.vertical ? 'Y' : 'X';
                        // For a horizontal slider in RTL languages we push the ticks container off the left edge
                        // instead of the right edge to avoid causing a horizontal scrollbar to appear.
                        /** @type {?} */
                        var sign = !this.vertical && this._getDirection() == 'rtl' ? '' : '-';
                        /** @type {?} */
                        var offset = this._tickIntervalPercent / 2 * 100;
                        return {
                            'transform': "translate" + axis + "(" + sign + offset + "%)"
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_ticksStyles", {
                    /**
                     * CSS styles for the ticks element.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var tickSize = this._tickIntervalPercent * 100;
                        /** @type {?} */
                        var backgroundSize = this.vertical ? "2px " + tickSize + "%" : tickSize + "% 2px";
                        /** @type {?} */
                        var axis = this.vertical ? 'Y' : 'X';
                        // Depending on the direction we pushed the ticks container, push the ticks the opposite
                        // direction to re-center them but clip off the end edge. In RTL languages we need to flip the
                        // ticks 180 degrees so we're really cutting off the end edge abd not the start.
                        /** @type {?} */
                        var sign = !this.vertical && this._getDirection() == 'rtl' ? '-' : '';
                        /** @type {?} */
                        var rotate = !this.vertical && this._getDirection() == 'rtl' ? ' rotate(180deg)' : '';
                        /** @type {?} */
                        var styles = {
                            'backgroundSize': backgroundSize,
                            // Without translateZ ticks sometimes jitter as the slider moves on Chrome & Firefox.
                            'transform': "translateZ(0) translate" + axis + "(" + sign + tickSize / 2 + "%)" + rotate
                        };
                        if (this._isMinValue && this._thumbGap) {
                            /** @type {?} */
                            var side = this.vertical ?
                                (this._invertAxis ? 'Bottom' : 'Top') :
                                (this._invertAxis ? 'Right' : 'Left');
                            styles["padding" + side] = this._thumbGap + "px";
                        }
                        return styles;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSlider.prototype, "_thumbContainerStyles", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var axis = this.vertical ? 'Y' : 'X';
                        // For a horizontal slider in RTL languages we push the thumb container off the left edge
                        // instead of the right edge to avoid causing a horizontal scrollbar to appear.
                        /** @type {?} */
                        var invertOffset = (this._getDirection() == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
                        /** @type {?} */
                        var offset = (invertOffset ? this.percent : 1 - this.percent) * 100;
                        return {
                            'transform': "translate" + axis + "(-" + offset + "%)"
                        };
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Whether mouse events should be converted to a slider position by calculating their distance
                 * from the right or bottom edge of the slider as opposed to the top or left.
                 * @return {?}
                 */
                MatSlider.prototype._shouldInvertMouseCoords = function () {
                    return (this._getDirection() == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
                };
                /**
                 * The language direction for this slider element.
                 * @private
                 * @return {?}
                 */
                MatSlider.prototype._getDirection = function () {
                    return (this._dir && this._dir.value == 'rtl') ? 'rtl' : 'ltr';
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype.ngOnInit = function () {
                    var _this = this;
                    this._focusMonitor
                        .monitor(this._elementRef, true)
                        .subscribe(( /**
                 * @param {?} origin
                 * @return {?}
                 */function (origin) {
                        _this._isActive = !!origin && origin !== 'keyboard';
                        _this._changeDetectorRef.detectChanges();
                    }));
                    if (this._dir) {
                        this._dirChangeSubscription = this._dir.change.subscribe(( /**
                         * @return {?}
                         */function () {
                            _this._changeDetectorRef.markForCheck();
                        }));
                    }
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this._elementRef);
                    this._dirChangeSubscription.unsubscribe();
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype._onMouseenter = function () {
                    if (this.disabled) {
                        return;
                    }
                    // We save the dimensions of the slider here so we can use them to update the spacing of the
                    // ticks and determine where on the slider click and slide events happen.
                    this._sliderDimensions = this._getSliderDimensions();
                    this._updateTickIntervalPercent();
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatSlider.prototype._onMousedown = function (event) {
                    // Don't do anything if the slider is disabled or the
                    // user is using anything other than the main mouse button.
                    if (this.disabled || event.button !== 0) {
                        return;
                    }
                    /** @type {?} */
                    var oldValue = this.value;
                    this._isSliding = false;
                    this._focusHostElement();
                    this._updateValueFromPosition({ x: event.clientX, y: event.clientY });
                    // Emit a change and input event if the value changed.
                    if (oldValue != this.value) {
                        this._emitInputEvent();
                        this._emitChangeEvent();
                    }
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatSlider.prototype._onSlide = function (event) {
                    if (this.disabled) {
                        return;
                    }
                    // The slide start event sometimes fails to fire on iOS, so if we're not already in the sliding
                    // state, call the slide start handler manually.
                    if (!this._isSliding) {
                        this._onSlideStart(null);
                    }
                    // Prevent the slide from selecting anything else.
                    event.preventDefault();
                    /** @type {?} */
                    var oldValue = this.value;
                    this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
                    // Native range elements always emit `input` events when the value changed while sliding.
                    if (oldValue != this.value) {
                        this._emitInputEvent();
                    }
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatSlider.prototype._onSlideStart = function (event) {
                    if (this.disabled || this._isSliding) {
                        return;
                    }
                    // Simulate mouseenter in case this is a mobile device.
                    this._onMouseenter();
                    this._isSliding = true;
                    this._focusHostElement();
                    this._valueOnSlideStart = this.value;
                    if (event) {
                        this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
                        event.preventDefault();
                    }
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype._onSlideEnd = function () {
                    this._isSliding = false;
                    if (this._valueOnSlideStart != this.value && !this.disabled) {
                        this._emitChangeEvent();
                    }
                    this._valueOnSlideStart = null;
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype._onFocus = function () {
                    // We save the dimensions of the slider here so we can use them to update the spacing of the
                    // ticks and determine where on the slider click and slide events happen.
                    this._sliderDimensions = this._getSliderDimensions();
                    this._updateTickIntervalPercent();
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype._onBlur = function () {
                    this.onTouched();
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                MatSlider.prototype._onKeydown = function (event) {
                    if (this.disabled || Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["hasModifierKey"])(event)) {
                        return;
                    }
                    /** @type {?} */
                    var oldValue = this.value;
                    switch (event.keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_UP"]:
                            this._increment(10);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["PAGE_DOWN"]:
                            this._increment(-10);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["END"]:
                            this.value = this.max;
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["HOME"]:
                            this.value = this.min;
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["LEFT_ARROW"]:
                            // NOTE: For a sighted user it would make more sense that when they press an arrow key on an
                            // inverted slider the thumb moves in that direction. However for a blind user, nothing
                            // about the slider indicates that it is inverted. They will expect left to be decrement,
                            // regardless of how it appears on the screen. For speakers ofRTL languages, they probably
                            // expect left to mean increment. Therefore we flip the meaning of the side arrow keys for
                            // RTL. For inverted sliders we prefer a good a11y experience to having it "look right" for
                            // sighted users, therefore we do not swap the meaning.
                            this._increment(this._getDirection() == 'rtl' ? 1 : -1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["UP_ARROW"]:
                            this._increment(1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["RIGHT_ARROW"]:
                            // See comment on LEFT_ARROW about the conditions under which we flip the meaning.
                            this._increment(this._getDirection() == 'rtl' ? -1 : 1);
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_3__["DOWN_ARROW"]:
                            this._increment(-1);
                            break;
                        default:
                            // Return if the key is not one that we explicitly handle to avoid calling preventDefault on
                            // it.
                            return;
                    }
                    if (oldValue != this.value) {
                        this._emitInputEvent();
                        this._emitChangeEvent();
                    }
                    this._isSliding = true;
                    event.preventDefault();
                };
                /**
                 * @return {?}
                 */
                MatSlider.prototype._onKeyup = function () {
                    this._isSliding = false;
                };
                /**
                 * Increments the slider by the given number of steps (negative number decrements).
                 * @private
                 * @param {?} numSteps
                 * @return {?}
                 */
                MatSlider.prototype._increment = function (numSteps) {
                    this.value = this._clamp((this.value || 0) + this.step * numSteps, this.min, this.max);
                };
                /**
                 * Calculate the new value from the new physical location. The value will always be snapped.
                 * @private
                 * @param {?} pos
                 * @return {?}
                 */
                MatSlider.prototype._updateValueFromPosition = function (pos) {
                    if (!this._sliderDimensions) {
                        return;
                    }
                    /** @type {?} */
                    var offset = this.vertical ? this._sliderDimensions.top : this._sliderDimensions.left;
                    /** @type {?} */
                    var size = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
                    /** @type {?} */
                    var posComponent = this.vertical ? pos.y : pos.x;
                    // The exact value is calculated from the event and used to find the closest snap value.
                    /** @type {?} */
                    var percent = this._clamp((posComponent - offset) / size);
                    if (this._shouldInvertMouseCoords()) {
                        percent = 1 - percent;
                    }
                    // Since the steps may not divide cleanly into the max value, if the user
                    // slid to 0 or 100 percent, we jump to the min/max value. This approach
                    // is slightly more intuitive than using `Math.ceil` below, because it
                    // follows the user's pointer closer.
                    if (percent === 0) {
                        this.value = this.min;
                    }
                    else if (percent === 1) {
                        this.value = this.max;
                    }
                    else {
                        /** @type {?} */
                        var exactValue = this._calculateValue(percent);
                        // This calculation finds the closest step by finding the closest
                        // whole number divisible by the step relative to the min.
                        /** @type {?} */
                        var closestValue = Math.round((exactValue - this.min) / this.step) * this.step + this.min;
                        // The value needs to snap to the min and max.
                        this.value = this._clamp(closestValue, this.min, this.max);
                    }
                };
                /**
                 * Emits a change event if the current value is different from the last emitted value.
                 * @private
                 * @return {?}
                 */
                MatSlider.prototype._emitChangeEvent = function () {
                    this._controlValueAccessorChangeFn(this.value);
                    this.valueChange.emit(this.value);
                    this.change.emit(this._createChangeEvent());
                };
                /**
                 * Emits an input event when the current value is different from the last emitted value.
                 * @private
                 * @return {?}
                 */
                MatSlider.prototype._emitInputEvent = function () {
                    this.input.emit(this._createChangeEvent());
                };
                /**
                 * Updates the amount of space between ticks as a percentage of the width of the slider.
                 * @private
                 * @return {?}
                 */
                MatSlider.prototype._updateTickIntervalPercent = function () {
                    if (!this.tickInterval || !this._sliderDimensions) {
                        return;
                    }
                    if (this.tickInterval == 'auto') {
                        /** @type {?} */
                        var trackSize = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
                        /** @type {?} */
                        var pixelsPerStep = trackSize * this.step / (this.max - this.min);
                        /** @type {?} */
                        var stepsPerTick = Math.ceil(MIN_AUTO_TICK_SEPARATION / pixelsPerStep);
                        /** @type {?} */
                        var pixelsPerTick = stepsPerTick * this.step;
                        this._tickIntervalPercent = pixelsPerTick / trackSize;
                    }
                    else {
                        this._tickIntervalPercent = this.tickInterval * this.step / (this.max - this.min);
                    }
                };
                /**
                 * Creates a slider change object from the specified value.
                 * @private
                 * @param {?=} value
                 * @return {?}
                 */
                MatSlider.prototype._createChangeEvent = function (value) {
                    if (value === void 0) { value = this.value; }
                    /** @type {?} */
                    var event = new MatSliderChange();
                    event.source = this;
                    event.value = value;
                    return event;
                };
                /**
                 * Calculates the percentage of the slider that a value is.
                 * @private
                 * @param {?} value
                 * @return {?}
                 */
                MatSlider.prototype._calculatePercentage = function (value) {
                    return ((value || 0) - this.min) / (this.max - this.min);
                };
                /**
                 * Calculates the value a percentage of the slider corresponds to.
                 * @private
                 * @param {?} percentage
                 * @return {?}
                 */
                MatSlider.prototype._calculateValue = function (percentage) {
                    return this.min + percentage * (this.max - this.min);
                };
                /**
                 * Return a number between two numbers.
                 * @private
                 * @param {?} value
                 * @param {?=} min
                 * @param {?=} max
                 * @return {?}
                 */
                MatSlider.prototype._clamp = function (value, min, max) {
                    if (min === void 0) { min = 0; }
                    if (max === void 0) { max = 1; }
                    return Math.max(min, Math.min(value, max));
                };
                /**
                 * Get the bounding client rect of the slider track element.
                 * The track is used rather than the native element to ignore the extra space that the thumb can
                 * take up.
                 * @private
                 * @return {?}
                 */
                MatSlider.prototype._getSliderDimensions = function () {
                    return this._sliderWrapper ? this._sliderWrapper.nativeElement.getBoundingClientRect() : null;
                };
                /**
                 * Focuses the native element.
                 * Currently only used to allow a blur event to fire but will be used with keyboard input later.
                 * @private
                 * @param {?=} options
                 * @return {?}
                 */
                MatSlider.prototype._focusHostElement = function (options) {
                    this._elementRef.nativeElement.focus(options);
                };
                /**
                 * Blurs the native element.
                 * @private
                 * @return {?}
                 */
                MatSlider.prototype._blurHostElement = function () {
                    this._elementRef.nativeElement.blur();
                };
                /**
                 * Sets the model value. Implemented as part of ControlValueAccessor.
                 * @param {?} value
                 * @return {?}
                 */
                MatSlider.prototype.writeValue = function (value) {
                    this.value = value;
                };
                /**
                 * Registers a callback to be triggered when the value has changed.
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn Callback to be registered.
                 * @return {?}
                 */
                MatSlider.prototype.registerOnChange = function (fn) {
                    this._controlValueAccessorChangeFn = fn;
                };
                /**
                 * Registers a callback to be triggered when the component is touched.
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} fn Callback to be registered.
                 * @return {?}
                 */
                MatSlider.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                /**
                 * Sets whether the component should be disabled.
                 * Implemented as part of ControlValueAccessor.
                 * @param {?} isDisabled
                 * @return {?}
                 */
                MatSlider.prototype.setDisabledState = function (isDisabled) {
                    this.disabled = isDisabled;
                };
                return MatSlider;
            }(_MatSliderMixinBase));
            MatSlider.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"], args: [{ selector: 'mat-slider',
                            exportAs: 'matSlider',
                            providers: [MAT_SLIDER_VALUE_ACCESSOR],
                            host: {
                                '(focus)': '_onFocus()',
                                '(blur)': '_onBlur()',
                                '(mousedown)': '_onMousedown($event)',
                                '(keydown)': '_onKeydown($event)',
                                '(keyup)': '_onKeyup()',
                                '(mouseenter)': '_onMouseenter()',
                                '(slide)': '_onSlide($event)',
                                '(slideend)': '_onSlideEnd()',
                                '(slidestart)': '_onSlideStart($event)',
                                // On Safari starting to slide temporarily triggers text selection mode which
                                // show the wrong cursor. We prevent it by stopping the `selectstart` event.
                                '(selectstart)': '$event.preventDefault()',
                                'class': 'mat-slider',
                                'role': 'slider',
                                '[tabIndex]': 'tabIndex',
                                '[attr.aria-disabled]': 'disabled',
                                '[attr.aria-valuemax]': 'max',
                                '[attr.aria-valuemin]': 'min',
                                '[attr.aria-valuenow]': 'value',
                                '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
                                '[class.mat-slider-disabled]': 'disabled',
                                '[class.mat-slider-has-ticks]': 'tickInterval',
                                '[class.mat-slider-horizontal]': '!vertical',
                                '[class.mat-slider-axis-inverted]': '_invertAxis',
                                // Class binding which is only used by the test harness as there is no other
                                // way for the harness to detect if mouse coordinates need to be inverted.
                                '[class.mat-slider-invert-mouse-coords]': '_shouldInvertMouseCoords()',
                                '[class.mat-slider-sliding]': '_isSliding',
                                '[class.mat-slider-thumb-label-showing]': 'thumbLabel',
                                '[class.mat-slider-vertical]': 'vertical',
                                '[class.mat-slider-min-value]': '_isMinValue',
                                '[class.mat-slider-hide-last-tick]': 'disabled || _isMinValue && _thumbGap && _invertAxis',
                                '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                            },
                            template: "<div class=\"mat-slider-wrapper\" #sliderWrapper><div class=\"mat-slider-track-wrapper\"><div class=\"mat-slider-track-background\" [ngStyle]=\"_trackBackgroundStyles\"></div><div class=\"mat-slider-track-fill\" [ngStyle]=\"_trackFillStyles\"></div></div><div class=\"mat-slider-ticks-container\" [ngStyle]=\"_ticksContainerStyles\"><div class=\"mat-slider-ticks\" [ngStyle]=\"_ticksStyles\"></div></div><div class=\"mat-slider-thumb-container\" [ngStyle]=\"_thumbContainerStyles\"><div class=\"mat-slider-focus-ring\"></div><div class=\"mat-slider-thumb\"></div><div class=\"mat-slider-thumb-label\"><span class=\"mat-slider-thumb-label-text\">{{displayValue}}</span></div></div></div>",
                            styles: [".mat-slider{display:inline-block;position:relative;box-sizing:border-box;padding:8px;outline:0;vertical-align:middle}.mat-slider.mat-slider-sliding:not(.mat-slider-disabled),.mat-slider:not(.mat-slider-disabled):active{cursor:-webkit-grabbing;cursor:grabbing}.mat-slider-wrapper{position:absolute}.mat-slider-track-wrapper{position:absolute;top:0;left:0;overflow:hidden}.mat-slider-track-fill{position:absolute;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-track-background{position:absolute;transform-origin:100% 100%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-ticks-container{position:absolute;left:0;top:0;overflow:hidden}.mat-slider-ticks{background-repeat:repeat;background-clip:content-box;box-sizing:border-box;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-container{position:absolute;z-index:1;transition:transform .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-focus-ring{position:absolute;width:30px;height:30px;border-radius:50%;transform:scale(0);opacity:0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider.cdk-keyboard-focused .mat-slider-focus-ring,.mat-slider.cdk-program-focused .mat-slider-focus-ring{transform:scale(1);opacity:1}.mat-slider:not(.mat-slider-disabled):not(.mat-slider-sliding) .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled):not(.mat-slider-sliding) .mat-slider-thumb-label{cursor:-webkit-grab;cursor:grab}.mat-slider-thumb{position:absolute;right:-10px;bottom:-10px;box-sizing:border-box;width:20px;height:20px;border:3px solid transparent;border-radius:50%;transform:scale(.7);transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),border-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label{display:none;align-items:center;justify-content:center;position:absolute;width:28px;height:28px;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),border-radius .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}@media (-ms-high-contrast:active){.mat-slider-thumb-label{outline:solid 1px}}.mat-slider-thumb-label-text{z-index:1;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-sliding .mat-slider-thumb-container,.mat-slider-sliding .mat-slider-track-background,.mat-slider-sliding .mat-slider-track-fill{transition-duration:0s}.mat-slider-has-ticks .mat-slider-wrapper::after{content:'';position:absolute;border-width:0;border-style:solid;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after,.mat-slider-has-ticks:hover:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after{opacity:1}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-disabled) .mat-slider-ticks,.mat-slider-has-ticks:hover:not(.mat-slider-disabled) .mat-slider-ticks{opacity:1}.mat-slider-thumb-label-showing .mat-slider-focus-ring{display:none}.mat-slider-thumb-label-showing .mat-slider-thumb-label{display:flex}.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:100% 100%}.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:0 0}.mat-slider:not(.mat-slider-disabled).cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{transform:scale(0)}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label{border-radius:50% 50% 0}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label-text{opacity:1}.mat-slider:not(.mat-slider-disabled).cdk-mouse-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-program-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-touch-focused .mat-slider-thumb{border-width:2px;transform:scale(1)}.mat-slider-disabled .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-disabled .mat-slider-thumb{border-width:4px;transform:scale(.5)}.mat-slider-disabled .mat-slider-thumb-label{display:none}.mat-slider-horizontal{height:48px;min-width:128px}.mat-slider-horizontal .mat-slider-wrapper{height:2px;top:23px;left:8px;right:8px}.mat-slider-horizontal .mat-slider-wrapper::after{height:2px;border-left-width:2px;right:0;top:0}.mat-slider-horizontal .mat-slider-track-wrapper{height:2px;width:100%}.mat-slider-horizontal .mat-slider-track-fill{height:2px;width:100%;transform:scaleX(0)}.mat-slider-horizontal .mat-slider-track-background{height:2px;width:100%;transform:scaleX(1)}.mat-slider-horizontal .mat-slider-ticks-container{height:2px;width:100%}@media (-ms-high-contrast:active){.mat-slider-horizontal .mat-slider-ticks-container{height:0;outline:solid 2px;top:1px}}.mat-slider-horizontal .mat-slider-ticks{height:2px;width:100%}.mat-slider-horizontal .mat-slider-thumb-container{width:100%;height:0;top:50%}.mat-slider-horizontal .mat-slider-focus-ring{top:-15px;right:-15px}.mat-slider-horizontal .mat-slider-thumb-label{right:-14px;top:-40px;transform:translateY(26px) scale(.01) rotate(45deg)}.mat-slider-horizontal .mat-slider-thumb-label-text{transform:rotate(-45deg)}.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label{transform:rotate(45deg)}@media (-ms-high-contrast:active){.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label,.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label-text{transform:none}}.mat-slider-vertical{width:48px;min-height:128px}.mat-slider-vertical .mat-slider-wrapper{width:2px;top:8px;bottom:8px;left:23px}.mat-slider-vertical .mat-slider-wrapper::after{width:2px;border-top-width:2px;bottom:0;left:0}.mat-slider-vertical .mat-slider-track-wrapper{height:100%;width:2px}.mat-slider-vertical .mat-slider-track-fill{height:100%;width:2px;transform:scaleY(0)}.mat-slider-vertical .mat-slider-track-background{height:100%;width:2px;transform:scaleY(1)}.mat-slider-vertical .mat-slider-ticks-container{width:2px;height:100%}@media (-ms-high-contrast:active){.mat-slider-vertical .mat-slider-ticks-container{width:0;outline:solid 2px;left:1px}}.mat-slider-vertical .mat-slider-focus-ring{bottom:-15px;left:-15px}.mat-slider-vertical .mat-slider-ticks{width:2px;height:100%}.mat-slider-vertical .mat-slider-thumb-container{height:100%;width:0;left:50%}.mat-slider-vertical .mat-slider-thumb{-webkit-backface-visibility:hidden;backface-visibility:hidden}.mat-slider-vertical .mat-slider-thumb-label{bottom:-14px;left:-40px;transform:translateX(26px) scale(.01) rotate(-45deg)}.mat-slider-vertical .mat-slider-thumb-label-text{transform:rotate(45deg)}.mat-slider-vertical.cdk-focused .mat-slider-thumb-label{transform:rotate(-45deg)}[dir=rtl] .mat-slider-wrapper::after{left:0;right:auto}[dir=rtl] .mat-slider-horizontal .mat-slider-track-fill{transform-origin:100% 100%}[dir=rtl] .mat-slider-horizontal .mat-slider-track-background{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:100% 100%}.mat-slider._mat-animation-noopable .mat-slider-focus-ring,.mat-slider._mat-animation-noopable .mat-slider-has-ticks .mat-slider-wrapper::after,.mat-slider._mat-animation-noopable .mat-slider-thumb,.mat-slider._mat-animation-noopable .mat-slider-thumb-container,.mat-slider._mat-animation-noopable .mat-slider-thumb-label,.mat-slider._mat-animation-noopable .mat-slider-thumb-label-text,.mat-slider._mat-animation-noopable .mat-slider-ticks,.mat-slider._mat-animation-noopable .mat-slider-track-background,.mat-slider._mat-animation-noopable .mat-slider-track-fill{transition:none}"],
                            inputs: ['disabled', 'color', 'tabIndex'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatSlider.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ElementRef"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_0__["FocusMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ChangeDetectorRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_1__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Attribute"], args: ['tabindex',] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatSlider.propDecorators = {
                invert: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                max: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                min: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                step: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                thumbLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                tickInterval: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                value: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                displayWith: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                vertical: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Input"] }],
                change: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"] }],
                input: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"] }],
                valueChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Output"] }],
                _sliderWrapper: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["ViewChild"], args: ['sliderWrapper', { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatSliderModule = /** @class */ (function () {
                function MatSliderModule() {
                }
                return MatSliderModule;
            }());
            MatSliderModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_9__["CommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MatCommonModule"]],
                            exports: [MatSlider, _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MatCommonModule"]],
                            declarations: [MatSlider],
                            providers: [{ provide: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__["HAMMER_GESTURE_CONFIG"], useClass: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["GestureConfig"] }]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=slider.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/snack-bar.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/snack-bar.js ***!
          \*************************************************************/
        /*! exports provided: MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY, MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar, MatSnackBarContainer, MAT_SNACK_BAR_DATA, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar, matSnackBarAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarModule", function () { return MatSnackBarModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY", function () { return MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SNACK_BAR_DEFAULT_OPTIONS", function () { return MAT_SNACK_BAR_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSnackBar", function () { return MatSnackBar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarContainer", function () { return MatSnackBarContainer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SNACK_BAR_DATA", function () { return MAT_SNACK_BAR_DATA; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarConfig", function () { return MatSnackBarConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSnackBarRef", function () { return MatSnackBarRef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleSnackBar", function () { return SimpleSnackBar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matSnackBarAnimations", function () { return matSnackBarAnimations; });
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/layout */ "./node_modules/@angular/cdk/esm2015/layout.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Reference to a snack bar dispatched from the snack bar service.
             * @template T
             */
            var MatSnackBarRef = /** @class */ (function () {
                /**
                 * @param {?} containerInstance
                 * @param {?} _overlayRef
                 */
                function MatSnackBarRef(containerInstance, _overlayRef) {
                    var _this = this;
                    this._overlayRef = _overlayRef;
                    /**
                     * Subject for notifying the user that the snack bar has been dismissed.
                     */
                    this._afterDismissed = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    /**
                     * Subject for notifying the user that the snack bar has opened and appeared.
                     */
                    this._afterOpened = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    /**
                     * Subject for notifying the user that the snack bar action was called.
                     */
                    this._onAction = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    /**
                     * Whether the snack bar was dismissed using the action button.
                     */
                    this._dismissedByAction = false;
                    this.containerInstance = containerInstance;
                    // Dismiss snackbar on action.
                    this.onAction().subscribe(( /**
                     * @return {?}
                     */function () { return _this.dismiss(); }));
                    containerInstance._onExit.subscribe(( /**
                     * @return {?}
                     */function () { return _this._finishDismiss(); }));
                }
                /**
                 * Dismisses the snack bar.
                 * @return {?}
                 */
                MatSnackBarRef.prototype.dismiss = function () {
                    if (!this._afterDismissed.closed) {
                        this.containerInstance.exit();
                    }
                    clearTimeout(this._durationTimeoutId);
                };
                /**
                 * Marks the snackbar action clicked.
                 * @return {?}
                 */
                MatSnackBarRef.prototype.dismissWithAction = function () {
                    if (!this._onAction.closed) {
                        this._dismissedByAction = true;
                        this._onAction.next();
                        this._onAction.complete();
                    }
                };
                /**
                 * Marks the snackbar action clicked.
                 * @deprecated Use `dismissWithAction` instead.
                 * \@breaking-change 8.0.0
                 * @return {?}
                 */
                MatSnackBarRef.prototype.closeWithAction = function () {
                    this.dismissWithAction();
                };
                /**
                 * Dismisses the snack bar after some duration
                 * @param {?} duration
                 * @return {?}
                 */
                MatSnackBarRef.prototype._dismissAfter = function (duration) {
                    var _this = this;
                    this._durationTimeoutId = setTimeout(( /**
                     * @return {?}
                     */function () { return _this.dismiss(); }), duration);
                };
                /**
                 * Marks the snackbar as opened
                 * @return {?}
                 */
                MatSnackBarRef.prototype._open = function () {
                    if (!this._afterOpened.closed) {
                        this._afterOpened.next();
                        this._afterOpened.complete();
                    }
                };
                /**
                 * Cleans up the DOM after closing.
                 * @private
                 * @return {?}
                 */
                MatSnackBarRef.prototype._finishDismiss = function () {
                    this._overlayRef.dispose();
                    if (!this._onAction.closed) {
                        this._onAction.complete();
                    }
                    this._afterDismissed.next({ dismissedByAction: this._dismissedByAction });
                    this._afterDismissed.complete();
                    this._dismissedByAction = false;
                };
                /**
                 * Gets an observable that is notified when the snack bar is finished closing.
                 * @return {?}
                 */
                MatSnackBarRef.prototype.afterDismissed = function () {
                    return this._afterDismissed.asObservable();
                };
                /**
                 * Gets an observable that is notified when the snack bar has opened and appeared.
                 * @return {?}
                 */
                MatSnackBarRef.prototype.afterOpened = function () {
                    return this.containerInstance._onEnter;
                };
                /**
                 * Gets an observable that is notified when the snack bar action is called.
                 * @return {?}
                 */
                MatSnackBarRef.prototype.onAction = function () {
                    return this._onAction.asObservable();
                };
                return MatSnackBarRef;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to access the data that was passed in to a snack bar.
             * @type {?}
             */
            var MAT_SNACK_BAR_DATA = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('MatSnackBarData');
            /**
             * Configuration used when opening a snack-bar.
             * @template D
             */
            var MatSnackBarConfig = /** @class */ (function () {
                function MatSnackBarConfig() {
                    /**
                     * The politeness level for the MatAriaLiveAnnouncer announcement.
                     */
                    this.politeness = 'assertive';
                    /**
                     * Message to be announced by the LiveAnnouncer. When opening a snackbar without a custom
                     * component or template, the announcement message will default to the specified message.
                     */
                    this.announcementMessage = '';
                    /**
                     * The length of time in milliseconds to wait before automatically dismissing the snack bar.
                     */
                    this.duration = 0;
                    /**
                     * Data being injected into the child component.
                     */
                    this.data = null;
                    /**
                     * The horizontal position to place the snack bar.
                     */
                    this.horizontalPosition = 'center';
                    /**
                     * The vertical position to place the snack bar.
                     */
                    this.verticalPosition = 'bottom';
                }
                return MatSnackBarConfig;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A component used to open as the default snack bar, matching material spec.
             * This should only be used internally by the snack bar service.
             */
            var SimpleSnackBar = /** @class */ (function () {
                /**
                 * @param {?} snackBarRef
                 * @param {?} data
                 */
                function SimpleSnackBar(snackBarRef, data) {
                    this.snackBarRef = snackBarRef;
                    this.data = data;
                }
                /**
                 * Performs the action on the snack bar.
                 * @return {?}
                 */
                SimpleSnackBar.prototype.action = function () {
                    this.snackBarRef.dismissWithAction();
                };
                Object.defineProperty(SimpleSnackBar.prototype, "hasAction", {
                    /**
                     * If the action button should be shown.
                     * @return {?}
                     */
                    get: function () {
                        return !!this.data.action;
                    },
                    enumerable: true,
                    configurable: true
                });
                return SimpleSnackBar;
            }());
            SimpleSnackBar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'simple-snack-bar',
                            template: "<span>{{data.message}}</span><div class=\"mat-simple-snackbar-action\" *ngIf=\"hasAction\"><button mat-button (click)=\"action()\">{{data.action}}</button></div>",
                            styles: [".mat-simple-snackbar{display:flex;justify-content:space-between;align-items:center;line-height:20px;opacity:1}.mat-simple-snackbar-action{flex-shrink:0;margin:-8px -8px -8px 8px}.mat-simple-snackbar-action button{max-height:36px;min-width:0}[dir=rtl] .mat-simple-snackbar-action{margin-left:-8px;margin-right:8px}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
                            host: {
                                'class': 'mat-simple-snackbar',
                            }
                        },] },
            ];
            /** @nocollapse */
            SimpleSnackBar.ctorParameters = function () { return [
                { type: MatSnackBarRef },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [MAT_SNACK_BAR_DATA,] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the Material snack bar.
             * \@docs-private
             * @type {?}
             */
            var matSnackBarAnimations = {
                /**
                 * Animation that shows and hides a snack bar.
                 */
                snackBarState: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["trigger"])('state', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["state"])('void, hidden', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({
                        transform: 'scale(0.8)',
                        opacity: 0,
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["state"])('visible', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({
                        transform: 'scale(1)',
                        opacity: 1,
                    })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])('* => visible', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])('150ms cubic-bezier(0, 0, 0.2, 1)')),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])('* => void, * => hidden', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])('75ms cubic-bezier(0.4, 0.0, 1, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({
                        opacity: 0
                    }))),
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Internal component that wraps user-provided snack bar content.
             * \@docs-private
             */
            var MatSnackBarContainer = /** @class */ (function (_super_1) {
                __extends(MatSnackBarContainer, _super_1);
                /**
                 * @param {?} _ngZone
                 * @param {?} _elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} snackBarConfig
                 */
                function MatSnackBarContainer(_ngZone, _elementRef, _changeDetectorRef, snackBarConfig) {
                    var _this = _super_1.call(this) || this;
                    _this._ngZone = _ngZone;
                    _this._elementRef = _elementRef;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this.snackBarConfig = snackBarConfig;
                    /**
                     * Whether the component has been destroyed.
                     */
                    _this._destroyed = false;
                    /**
                     * Subject for notifying that the snack bar has exited from view.
                     */
                    _this._onExit = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    /**
                     * Subject for notifying that the snack bar has finished entering the view.
                     */
                    _this._onEnter = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    /**
                     * The state of the snack bar animations.
                     */
                    _this._animationState = 'void';
                    // Based on the ARIA spec, `alert` and `status` roles have an
                    // implicit `assertive` and `polite` politeness respectively.
                    if (snackBarConfig.politeness === 'assertive' && !snackBarConfig.announcementMessage) {
                        _this._role = 'alert';
                    }
                    else if (snackBarConfig.politeness === 'off') {
                        _this._role = null;
                    }
                    else {
                        _this._role = 'status';
                    }
                    return _this;
                }
                /**
                 * Attach a component portal as content to this snack bar container.
                 * @template T
                 * @param {?} portal
                 * @return {?}
                 */
                MatSnackBarContainer.prototype.attachComponentPortal = function (portal) {
                    this._assertNotAttached();
                    this._applySnackBarClasses();
                    return this._portalOutlet.attachComponentPortal(portal);
                };
                /**
                 * Attach a template portal as content to this snack bar container.
                 * @template C
                 * @param {?} portal
                 * @return {?}
                 */
                MatSnackBarContainer.prototype.attachTemplatePortal = function (portal) {
                    this._assertNotAttached();
                    this._applySnackBarClasses();
                    return this._portalOutlet.attachTemplatePortal(portal);
                };
                /**
                 * Handle end of animations, updating the state of the snackbar.
                 * @param {?} event
                 * @return {?}
                 */
                MatSnackBarContainer.prototype.onAnimationEnd = function (event) {
                    var fromState = event.fromState, toState = event.toState;
                    if ((toState === 'void' && fromState !== 'void') || toState === 'hidden') {
                        this._completeExit();
                    }
                    if (toState === 'visible') {
                        // Note: we shouldn't use `this` inside the zone callback,
                        // because it can cause a memory leak.
                        /** @type {?} */
                        var onEnter_1 = this._onEnter;
                        this._ngZone.run(( /**
                         * @return {?}
                         */function () {
                            onEnter_1.next();
                            onEnter_1.complete();
                        }));
                    }
                };
                /**
                 * Begin animation of snack bar entrance into view.
                 * @return {?}
                 */
                MatSnackBarContainer.prototype.enter = function () {
                    if (!this._destroyed) {
                        this._animationState = 'visible';
                        this._changeDetectorRef.detectChanges();
                    }
                };
                /**
                 * Begin animation of the snack bar exiting from view.
                 * @return {?}
                 */
                MatSnackBarContainer.prototype.exit = function () {
                    // Note: this one transitions to `hidden`, rather than `void`, in order to handle the case
                    // where multiple snack bars are opened in quick succession (e.g. two consecutive calls to
                    // `MatSnackBar.open`).
                    this._animationState = 'hidden';
                    return this._onExit;
                };
                /**
                 * Makes sure the exit callbacks have been invoked when the element is destroyed.
                 * @return {?}
                 */
                MatSnackBarContainer.prototype.ngOnDestroy = function () {
                    this._destroyed = true;
                    this._completeExit();
                };
                /**
                 * Waits for the zone to settle before removing the element. Helps prevent
                 * errors where we end up removing an element which is in the middle of an animation.
                 * @private
                 * @return {?}
                 */
                MatSnackBarContainer.prototype._completeExit = function () {
                    var _this = this;
                    this._ngZone.onMicrotaskEmpty.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this._onExit.next();
                        _this._onExit.complete();
                    }));
                };
                /**
                 * Applies the various positioning and user-configured CSS classes to the snack bar.
                 * @private
                 * @return {?}
                 */
                MatSnackBarContainer.prototype._applySnackBarClasses = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    /** @type {?} */
                    var panelClasses = this.snackBarConfig.panelClass;
                    if (panelClasses) {
                        if (Array.isArray(panelClasses)) {
                            // Note that we can't use a spread here, because IE doesn't support multiple arguments.
                            panelClasses.forEach(( /**
                             * @param {?} cssClass
                             * @return {?}
                             */function (/**
                             * @param {?} cssClass
                             * @return {?}
                             */ cssClass) { return element.classList.add(cssClass); }));
                        }
                        else {
                            element.classList.add(panelClasses);
                        }
                    }
                    if (this.snackBarConfig.horizontalPosition === 'center') {
                        element.classList.add('mat-snack-bar-center');
                    }
                    if (this.snackBarConfig.verticalPosition === 'top') {
                        element.classList.add('mat-snack-bar-top');
                    }
                };
                /**
                 * Asserts that no content is already attached to the container.
                 * @private
                 * @return {?}
                 */
                MatSnackBarContainer.prototype._assertNotAttached = function () {
                    if (this._portalOutlet.hasAttached()) {
                        throw Error('Attempting to attach snack bar content after content is already attached');
                    }
                };
                return MatSnackBarContainer;
            }(_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["BasePortalOutlet"]));
            MatSnackBarContainer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'snack-bar-container',
                            template: "<ng-template cdkPortalOutlet></ng-template>",
                            styles: [".mat-snack-bar-container{border-radius:4px;box-sizing:border-box;display:block;margin:24px;max-width:33vw;min-width:344px;padding:14px 16px;min-height:48px;transform-origin:center}@media (-ms-high-contrast:active){.mat-snack-bar-container{border:solid 1px}}.mat-snack-bar-handset{width:100%}.mat-snack-bar-handset .mat-snack-bar-container{margin:8px;max-width:100%;min-width:0;width:100%}"],
                            // In Ivy embedded views will be change detected from their declaration place, rather than
                            // where they were stamped out. This means that we can't have the snack bar container be OnPush,
                            // because it might cause snack bars that were opened from a template not to be out of date.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            animations: [matSnackBarAnimations.snackBarState],
                            host: {
                                '[attr.role]': '_role',
                                'class': 'mat-snack-bar-container',
                                '[@state]': '_animationState',
                                '(@state.done)': 'onAnimationEnd($event)'
                            },
                        },] },
            ];
            /** @nocollapse */
            MatSnackBarContainer.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
                { type: MatSnackBarConfig }
            ]; };
            MatSnackBarContainer.propDecorators = {
                _portalOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["CdkPortalOutlet"], { static: true },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatSnackBarModule = /** @class */ (function () {
                function MatSnackBarModule() {
                }
                return MatSnackBarModule;
            }());
            MatSnackBarModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_5__["OverlayModule"],
                                _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalModule"],
                                _angular_common__WEBPACK_IMPORTED_MODULE_6__["CommonModule"],
                                _angular_material_button__WEBPACK_IMPORTED_MODULE_8__["MatButtonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatCommonModule"],
                            ],
                            exports: [MatSnackBarContainer, _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatCommonModule"]],
                            declarations: [MatSnackBarContainer, SimpleSnackBar],
                            entryComponents: [MatSnackBarContainer, SimpleSnackBar],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token that can be used to specify default snack bar.
             * @type {?}
             */
            var MAT_SNACK_BAR_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('mat-snack-bar-default-options', {
                providedIn: 'root',
                factory: MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY,
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY() {
                return new MatSnackBarConfig();
            }
            /**
             * Service to dispatch Material Design snack bar messages.
             */
            var MatSnackBar = /** @class */ (function () {
                /**
                 * @param {?} _overlay
                 * @param {?} _live
                 * @param {?} _injector
                 * @param {?} _breakpointObserver
                 * @param {?} _parentSnackBar
                 * @param {?} _defaultConfig
                 */
                function MatSnackBar(_overlay, _live, _injector, _breakpointObserver, _parentSnackBar, _defaultConfig) {
                    this._overlay = _overlay;
                    this._live = _live;
                    this._injector = _injector;
                    this._breakpointObserver = _breakpointObserver;
                    this._parentSnackBar = _parentSnackBar;
                    this._defaultConfig = _defaultConfig;
                    /**
                     * Reference to the current snack bar in the view *at this level* (in the Angular injector tree).
                     * If there is a parent snack-bar service, all operations should delegate to that parent
                     * via `_openedSnackBarRef`.
                     */
                    this._snackBarRefAtThisLevel = null;
                }
                Object.defineProperty(MatSnackBar.prototype, "_openedSnackBarRef", {
                    /**
                     * Reference to the currently opened snackbar at *any* level.
                     * @return {?}
                     */
                    get: function () {
                        /** @type {?} */
                        var parent = this._parentSnackBar;
                        return parent ? parent._openedSnackBarRef : this._snackBarRefAtThisLevel;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (this._parentSnackBar) {
                            this._parentSnackBar._openedSnackBarRef = value;
                        }
                        else {
                            this._snackBarRefAtThisLevel = value;
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Creates and dispatches a snack bar with a custom component for the content, removing any
                 * currently opened snack bars.
                 *
                 * @template T
                 * @param {?} component Component to be instantiated.
                 * @param {?=} config Extra configuration for the snack bar.
                 * @return {?}
                 */
                MatSnackBar.prototype.openFromComponent = function (component, config) {
                    return ( /** @type {?} */(this._attach(component, config)));
                };
                /**
                 * Creates and dispatches a snack bar with a custom template for the content, removing any
                 * currently opened snack bars.
                 *
                 * @param {?} template Template to be instantiated.
                 * @param {?=} config Extra configuration for the snack bar.
                 * @return {?}
                 */
                MatSnackBar.prototype.openFromTemplate = function (template, config) {
                    return this._attach(template, config);
                };
                /**
                 * Opens a snackbar with a message and an optional action.
                 * @param {?} message The message to show in the snackbar.
                 * @param {?=} action The label for the snackbar action.
                 * @param {?=} config Additional configuration options for the snackbar.
                 * @return {?}
                 */
                MatSnackBar.prototype.open = function (message, action, config) {
                    if (action === void 0) { action = ''; }
                    /** @type {?} */
                    var _config = Object.assign({}, this._defaultConfig, config);
                    // Since the user doesn't have access to the component, we can
                    // override the data to pass in our own message and action.
                    _config.data = { message: message, action: action };
                    if (!_config.announcementMessage) {
                        _config.announcementMessage = message;
                    }
                    return this.openFromComponent(SimpleSnackBar, _config);
                };
                /**
                 * Dismisses the currently-visible snack bar.
                 * @return {?}
                 */
                MatSnackBar.prototype.dismiss = function () {
                    if (this._openedSnackBarRef) {
                        this._openedSnackBarRef.dismiss();
                    }
                };
                /**
                 * @return {?}
                 */
                MatSnackBar.prototype.ngOnDestroy = function () {
                    // Only dismiss the snack bar at the current level on destroy.
                    if (this._snackBarRefAtThisLevel) {
                        this._snackBarRefAtThisLevel.dismiss();
                    }
                };
                /**
                 * Attaches the snack bar container component to the overlay.
                 * @private
                 * @param {?} overlayRef
                 * @param {?} config
                 * @return {?}
                 */
                MatSnackBar.prototype._attachSnackBarContainer = function (overlayRef, config) {
                    /** @type {?} */
                    var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
                    /** @type {?} */
                    var injector = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalInjector"](userInjector || this._injector, new WeakMap([
                        [MatSnackBarConfig, config]
                    ]));
                    /** @type {?} */
                    var containerPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](MatSnackBarContainer, config.viewContainerRef, injector);
                    /** @type {?} */
                    var containerRef = overlayRef.attach(containerPortal);
                    containerRef.instance.snackBarConfig = config;
                    return containerRef.instance;
                };
                /**
                 * Places a new component or a template as the content of the snack bar container.
                 * @private
                 * @template T
                 * @param {?} content
                 * @param {?=} userConfig
                 * @return {?}
                 */
                MatSnackBar.prototype._attach = function (content, userConfig) {
                    /** @type {?} */
                    var config = Object.assign({}, new MatSnackBarConfig(), this._defaultConfig, userConfig);
                    /** @type {?} */
                    var overlayRef = this._createOverlay(config);
                    /** @type {?} */
                    var container = this._attachSnackBarContainer(overlayRef, config);
                    /** @type {?} */
                    var snackBarRef = new MatSnackBarRef(container, overlayRef);
                    if (content instanceof _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"]) {
                        /** @type {?} */
                        var portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["TemplatePortal"](content, ( /** @type {?} */(null)), ( /** @type {?} */({
                            $implicit: config.data,
                            snackBarRef: snackBarRef
                        })));
                        snackBarRef.instance = container.attachTemplatePortal(portal);
                    }
                    else {
                        /** @type {?} */
                        var injector = this._createInjector(config, snackBarRef);
                        /** @type {?} */
                        var portal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](content, undefined, injector);
                        /** @type {?} */
                        var contentRef = container.attachComponentPortal(portal);
                        // We can't pass this via the injector, because the injector is created earlier.
                        snackBarRef.instance = contentRef.instance;
                    }
                    // Subscribe to the breakpoint observer and attach the mat-snack-bar-handset class as
                    // appropriate. This class is applied to the overlay element because the overlay must expand to
                    // fill the width of the screen for full width snackbars.
                    this._breakpointObserver.observe(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_10__["Breakpoints"].HandsetPortrait).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["takeUntil"])(overlayRef.detachments())).subscribe(( /**
                     * @param {?} state
                     * @return {?}
                     */function (/**
                     * @param {?} state
                     * @return {?}
                     */ state$$1) {
                        /** @type {?} */
                        var classList = overlayRef.overlayElement.classList;
                        /** @type {?} */
                        var className = 'mat-snack-bar-handset';
                        state$$1.matches ? classList.add(className) : classList.remove(className);
                    }));
                    this._animateSnackBar(snackBarRef, config);
                    this._openedSnackBarRef = snackBarRef;
                    return this._openedSnackBarRef;
                };
                /**
                 * Animates the old snack bar out and the new one in.
                 * @private
                 * @param {?} snackBarRef
                 * @param {?} config
                 * @return {?}
                 */
                MatSnackBar.prototype._animateSnackBar = function (snackBarRef, config) {
                    var _this = this;
                    // When the snackbar is dismissed, clear the reference to it.
                    snackBarRef.afterDismissed().subscribe(( /**
                     * @return {?}
                     */function () {
                        // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
                        if (_this._openedSnackBarRef == snackBarRef) {
                            _this._openedSnackBarRef = null;
                        }
                        if (config.announcementMessage) {
                            _this._live.clear();
                        }
                    }));
                    if (this._openedSnackBarRef) {
                        // If a snack bar is already in view, dismiss it and enter the
                        // new snack bar after exit animation is complete.
                        this._openedSnackBarRef.afterDismissed().subscribe(( /**
                         * @return {?}
                         */function () {
                            snackBarRef.containerInstance.enter();
                        }));
                        this._openedSnackBarRef.dismiss();
                    }
                    else {
                        // If no snack bar is in view, enter the new snack bar.
                        snackBarRef.containerInstance.enter();
                    }
                    // If a dismiss timeout is provided, set up dismiss based on after the snackbar is opened.
                    if (config.duration && config.duration > 0) {
                        snackBarRef.afterOpened().subscribe(( /**
                         * @return {?}
                         */function () { return snackBarRef._dismissAfter(( /** @type {?} */(config.duration))); }));
                    }
                    if (config.announcementMessage) {
                        this._live.announce(config.announcementMessage, config.politeness);
                    }
                };
                /**
                 * Creates a new overlay and places it in the correct location.
                 * @private
                 * @param {?} config The user-specified snack bar config.
                 * @return {?}
                 */
                MatSnackBar.prototype._createOverlay = function (config) {
                    /** @type {?} */
                    var overlayConfig = new _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_5__["OverlayConfig"]();
                    overlayConfig.direction = config.direction;
                    /** @type {?} */
                    var positionStrategy = this._overlay.position().global();
                    // Set horizontal position.
                    /** @type {?} */
                    var isRtl = config.direction === 'rtl';
                    /** @type {?} */
                    var isLeft = (config.horizontalPosition === 'left' ||
                        (config.horizontalPosition === 'start' && !isRtl) ||
                        (config.horizontalPosition === 'end' && isRtl));
                    /** @type {?} */
                    var isRight = !isLeft && config.horizontalPosition !== 'center';
                    if (isLeft) {
                        positionStrategy.left('0');
                    }
                    else if (isRight) {
                        positionStrategy.right('0');
                    }
                    else {
                        positionStrategy.centerHorizontally();
                    }
                    // Set horizontal position.
                    if (config.verticalPosition === 'top') {
                        positionStrategy.top('0');
                    }
                    else {
                        positionStrategy.bottom('0');
                    }
                    overlayConfig.positionStrategy = positionStrategy;
                    return this._overlay.create(overlayConfig);
                };
                /**
                 * Creates an injector to be used inside of a snack bar component.
                 * @private
                 * @template T
                 * @param {?} config Config that was used to create the snack bar.
                 * @param {?} snackBarRef Reference to the snack bar.
                 * @return {?}
                 */
                MatSnackBar.prototype._createInjector = function (config, snackBarRef) {
                    /** @type {?} */
                    var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
                    return new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["PortalInjector"](userInjector || this._injector, new WeakMap([
                        [MatSnackBarRef, snackBarRef],
                        [MAT_SNACK_BAR_DATA, config.data]
                    ]));
                };
                return MatSnackBar;
            }());
            MatSnackBar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: MatSnackBarModule },] },
            ];
            /** @nocollapse */
            MatSnackBar.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_5__["Overlay"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_9__["LiveAnnouncer"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] },
                { type: _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_10__["BreakpointObserver"] },
                { type: MatSnackBar, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"] }] },
                { type: MatSnackBarConfig, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [MAT_SNACK_BAR_DEFAULT_OPTIONS,] }] }
            ]; };
            /** @nocollapse */ MatSnackBar.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function MatSnackBar_Factory() { return new MatSnackBar(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_5__["Overlay"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_9__["LiveAnnouncer"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["INJECTOR"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_10__["BreakpointObserver"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(MatSnackBar, 12), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(MAT_SNACK_BAR_DEFAULT_OPTIONS)); }, token: MatSnackBar, providedIn: MatSnackBarModule });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=snack-bar.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/sort.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/sort.js ***!
          \********************************************************/
        /*! exports provided: MatSortModule, MatSortHeader, MAT_SORT_HEADER_INTL_PROVIDER_FACTORY, MatSortHeaderIntl, MAT_SORT_HEADER_INTL_PROVIDER, MatSort, matSortAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSortModule", function () { return MatSortModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSortHeader", function () { return MatSortHeader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SORT_HEADER_INTL_PROVIDER_FACTORY", function () { return MAT_SORT_HEADER_INTL_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSortHeaderIntl", function () { return MatSortHeaderIntl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_SORT_HEADER_INTL_PROVIDER", function () { return MAT_SORT_HEADER_INTL_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatSort", function () { return MatSort; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matSortAnimations", function () { return matSortAnimations; });
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@docs-private
             * @param {?} id
             * @return {?}
             */
            function getSortDuplicateSortableIdError(id) {
                return Error("Cannot have two MatSortables with the same id (" + id + ").");
            }
            /**
             * \@docs-private
             * @return {?}
             */
            function getSortHeaderNotContainedWithinSortError() {
                return Error("MatSortHeader must be placed within a parent element with the MatSort directive.");
            }
            /**
             * \@docs-private
             * @return {?}
             */
            function getSortHeaderMissingIdError() {
                return Error("MatSortHeader must be provided with a unique id.");
            }
            /**
             * \@docs-private
             * @param {?} direction
             * @return {?}
             */
            function getSortInvalidDirectionError(direction) {
                return Error(direction + " is not a valid sort direction ('asc' or 'desc').");
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatSort.
            /**
             * \@docs-private
             */
            var MatSortBase = /** @class */ (function () {
                function MatSortBase() {
                }
                return MatSortBase;
            }());
            /** @type {?} */
            var _MatSortMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinInitialized"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinDisabled"])(MatSortBase));
            /**
             * Container for MatSortables to manage the sort state and provide default sort parameters.
             */
            var MatSort = /** @class */ (function (_super_1) {
                __extends(MatSort, _super_1);
                function MatSort() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * Collection of all registered sortables that this directive manages.
                     */
                    _this.sortables = new Map();
                    /**
                     * Used to notify any child components listening to state changes.
                     */
                    _this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
                    /**
                     * The direction to set when an MatSortable is initially sorted.
                     * May be overriden by the MatSortable's sort start.
                     */
                    _this.start = 'asc';
                    _this._direction = '';
                    /**
                     * Event emitted when the user changes either the active sort or sort direction.
                     */
                    _this.sortChange = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    return _this;
                }
                Object.defineProperty(MatSort.prototype, "direction", {
                    /**
                     * The sort direction of the currently active MatSortable.
                     * @return {?}
                     */
                    get: function () { return this._direction; },
                    /**
                     * @param {?} direction
                     * @return {?}
                     */
                    set: function (direction) {
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && direction && direction !== 'asc' && direction !== 'desc') {
                            throw getSortInvalidDirectionError(direction);
                        }
                        this._direction = direction;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatSort.prototype, "disableClear", {
                    /**
                     * Whether to disable the user from clearing the sort by finishing the sort direction cycle.
                     * May be overriden by the MatSortable's disable clear input.
                     * @return {?}
                     */
                    get: function () { return this._disableClear; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) { this._disableClear = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(v); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Register function to be used by the contained MatSortables. Adds the MatSortable to the
                 * collection of MatSortables.
                 * @param {?} sortable
                 * @return {?}
                 */
                MatSort.prototype.register = function (sortable) {
                    if (!sortable.id) {
                        throw getSortHeaderMissingIdError();
                    }
                    if (this.sortables.has(sortable.id)) {
                        throw getSortDuplicateSortableIdError(sortable.id);
                    }
                    this.sortables.set(sortable.id, sortable);
                };
                /**
                 * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
                 * collection of contained MatSortables.
                 * @param {?} sortable
                 * @return {?}
                 */
                MatSort.prototype.deregister = function (sortable) {
                    this.sortables.delete(sortable.id);
                };
                /**
                 * Sets the active sort id and determines the new sort direction.
                 * @param {?} sortable
                 * @return {?}
                 */
                MatSort.prototype.sort = function (sortable) {
                    if (this.active != sortable.id) {
                        this.active = sortable.id;
                        this.direction = sortable.start ? sortable.start : this.start;
                    }
                    else {
                        this.direction = this.getNextSortDirection(sortable);
                    }
                    this.sortChange.emit({ active: this.active, direction: this.direction });
                };
                /**
                 * Returns the next sort direction of the active sortable, checking for potential overrides.
                 * @param {?} sortable
                 * @return {?}
                 */
                MatSort.prototype.getNextSortDirection = function (sortable) {
                    if (!sortable) {
                        return '';
                    }
                    // Get the sort direction cycle with the potential sortable overrides.
                    /** @type {?} */
                    var disableClear = sortable.disableClear != null ? sortable.disableClear : this.disableClear;
                    /** @type {?} */
                    var sortDirectionCycle = getSortDirectionCycle(sortable.start || this.start, disableClear);
                    // Get and return the next direction in the cycle
                    /** @type {?} */
                    var nextDirectionIndex = sortDirectionCycle.indexOf(this.direction) + 1;
                    if (nextDirectionIndex >= sortDirectionCycle.length) {
                        nextDirectionIndex = 0;
                    }
                    return sortDirectionCycle[nextDirectionIndex];
                };
                /**
                 * @return {?}
                 */
                MatSort.prototype.ngOnInit = function () {
                    this._markInitialized();
                };
                /**
                 * @return {?}
                 */
                MatSort.prototype.ngOnChanges = function () {
                    this._stateChanges.next();
                };
                /**
                 * @return {?}
                 */
                MatSort.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                return MatSort;
            }(_MatSortMixinBase));
            MatSort.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matSort]',
                            exportAs: 'matSort',
                            inputs: ['disabled: matSortDisabled']
                        },] },
            ];
            MatSort.propDecorators = {
                active: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matSortActive',] }],
                start: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matSortStart',] }],
                direction: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matSortDirection',] }],
                disableClear: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matSortDisableClear',] }],
                sortChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['matSortChange',] }]
            };
            /**
             * Returns the sort direction cycle to use given the provided parameters of order and clear.
             * @param {?} start
             * @param {?} disableClear
             * @return {?}
             */
            function getSortDirectionCycle(start, disableClear) {
                /** @type {?} */
                var sortOrder = ['asc', 'desc'];
                if (start == 'desc') {
                    sortOrder.reverse();
                }
                if (!disableClear) {
                    sortOrder.push('');
                }
                return sortOrder;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var SORT_ANIMATION_TRANSITION = _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["AnimationDurations"].ENTERING + ' ' +
                _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["AnimationCurves"].STANDARD_CURVE;
            /**
             * Animations used by MatSort.
             * \@docs-private
             * @type {?}
             */
            var matSortAnimations = {
                /**
                 * Animation that moves the sort indicator.
                 */
                indicator: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('indicator', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('active-asc, asc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(0px)' })),
                    // 10px is the height of the sort indicator, minus the width of the pointers
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('active-desc, desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(10px)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('active-asc <=> active-desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION))
                ]),
                /**
                 * Animation that rotates the left pointer of the indicator based on the sorting direction.
                 */
                leftPointer: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('leftPointer', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('active-asc, asc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'rotate(-45deg)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('active-desc, desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'rotate(45deg)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('active-asc <=> active-desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION))
                ]),
                /**
                 * Animation that rotates the right pointer of the indicator based on the sorting direction.
                 */
                rightPointer: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('rightPointer', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('active-asc, asc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'rotate(45deg)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('active-desc, desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'rotate(-45deg)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('active-asc <=> active-desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION))
                ]),
                /**
                 * Animation that controls the arrow opacity.
                 */
                arrowOpacity: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('arrowOpacity', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('desc-to-active, asc-to-active, active', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ opacity: 1 })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('desc-to-hint, asc-to-hint, hint', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ opacity: .54 })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('hint-to-desc, active-to-desc, desc, hint-to-asc, active-to-asc, asc, void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ opacity: 0 })),
                    // Transition between all states except for immediate transitions
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => asc, * => desc, * => active, * => hint, * => void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])('0ms')),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* <=> *', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION)),
                ]),
                /**
                 * Animation for the translation of the arrow as a whole. States are separated into two
                 * groups: ones with animations and others that are immediate. Immediate states are asc, desc,
                 * peek, and active. The other states define a specific animation (source-to-destination)
                 * and are determined as a function of their prev user-perceived state and what the next state
                 * should be.
                 */
                arrowPosition: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('arrowPosition', [
                    // Hidden Above => Hint Center
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => desc-to-hint, * => desc-to-active', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION, Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["keyframes"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(-25%)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(0)' })
                    ]))),
                    // Hint Center => Hidden Below
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => hint-to-desc, * => active-to-desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION, Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["keyframes"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(0)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(25%)' })
                    ]))),
                    // Hidden Below => Hint Center
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => asc-to-hint, * => asc-to-active', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION, Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["keyframes"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(25%)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(0)' })
                    ]))),
                    // Hint Center => Hidden Above
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => hint-to-asc, * => active-to-asc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])(SORT_ANIMATION_TRANSITION, Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["keyframes"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(0)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(-25%)' })
                    ]))),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('desc-to-hint, asc-to-hint, hint, desc-to-active, asc-to-active, active', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(0)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('hint-to-desc, active-to-desc, desc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(-25%)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('hint-to-asc, active-to-asc, asc', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translateY(25%)' })),
                ]),
                /**
                 * Necessary trigger that calls animate on children animations.
                 */
                allowChildren: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('allowChildren', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* <=> *', [
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["query"])('@*', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animateChild"])(), { optional: true })
                    ])
                ]),
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * To modify the labels and text displayed, create a new instance of MatSortHeaderIntl and
             * include it in a custom provider.
             */
            var MatSortHeaderIntl = /** @class */ (function () {
                function MatSortHeaderIntl() {
                    /**
                     * Stream that emits whenever the labels here are changed. Use this to notify
                     * components if the labels have changed after initialization.
                     */
                    this.changes = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
                    /**
                     * ARIA label for the sorting button.
                     */
                    this.sortButtonLabel = ( /**
                     * @param {?} id
                     * @return {?}
                     */function (id) {
                        return "Change sorting for " + id;
                    });
                }
                return MatSortHeaderIntl;
            }());
            MatSortHeaderIntl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ MatSortHeaderIntl.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function MatSortHeaderIntl_Factory() { return new MatSortHeaderIntl(); }, token: MatSortHeaderIntl, providedIn: "root" });
            /**
             * \@docs-private
             * @param {?} parentIntl
             * @return {?}
             */
            function MAT_SORT_HEADER_INTL_PROVIDER_FACTORY(parentIntl) {
                return parentIntl || new MatSortHeaderIntl();
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_SORT_HEADER_INTL_PROVIDER = {
                // If there is already an MatSortHeaderIntl available, use that. Otherwise, provide a new one.
                provide: MatSortHeaderIntl,
                deps: [[new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"](), MatSortHeaderIntl]],
                useFactory: MAT_SORT_HEADER_INTL_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to the sort header.
            /**
             * \@docs-private
             */
            var MatSortHeaderBase = /** @class */ (function () {
                function MatSortHeaderBase() {
                }
                return MatSortHeaderBase;
            }());
            /** @type {?} */
            var _MatSortHeaderMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinDisabled"])(MatSortHeaderBase);
            /**
             * Applies sorting behavior (click to change sort) and styles to an element, including an
             * arrow to display the current sort direction.
             *
             * Must be provided with an id and contained within a parent MatSort directive.
             *
             * If used on header cells in a CdkTable, it will automatically default its id from its containing
             * column definition.
             */
            var MatSortHeader = /** @class */ (function (_super_1) {
                __extends(MatSortHeader, _super_1);
                /**
                 * @param {?} _intl
                 * @param {?} changeDetectorRef
                 * @param {?} _sort
                 * @param {?} _columnDef
                 */
                function MatSortHeader(_intl, changeDetectorRef, _sort, _columnDef) {
                    var _this = 
                    // Note that we use a string token for the `_columnDef`, because the value is provided both by
                    // `material/table` and `cdk/table` and we can't have the CDK depending on Material,
                    // and we want to avoid having the sort header depending on the CDK table because
                    // of this single reference.
                    _super_1.call(this) || this;
                    _this._intl = _intl;
                    _this._sort = _sort;
                    _this._columnDef = _columnDef;
                    /**
                     * Flag set to true when the indicator should be displayed while the sort is not active. Used to
                     * provide an affordance that the header is sortable by showing on focus and hover.
                     */
                    _this._showIndicatorHint = false;
                    /**
                     * The direction the arrow should be facing according to the current state.
                     */
                    _this._arrowDirection = '';
                    /**
                     * Whether the view state animation should show the transition between the `from` and `to` states.
                     */
                    _this._disableViewStateAnimation = false;
                    /**
                     * Sets the position of the arrow that displays when sorted.
                     */
                    _this.arrowPosition = 'after';
                    if (!_sort) {
                        throw getSortHeaderNotContainedWithinSortError();
                    }
                    _this._rerenderSubscription = Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["merge"])(_sort.sortChange, _sort._stateChanges, _intl.changes)
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        if (_this._isSorted()) {
                            _this._updateArrowDirection();
                        }
                        // If this header was recently active and now no longer sorted, animate away the arrow.
                        if (!_this._isSorted() && _this._viewState && _this._viewState.toState === 'active') {
                            _this._disableViewStateAnimation = false;
                            _this._setAnimationTransitionState({ fromState: 'active', toState: _this._arrowDirection });
                        }
                        changeDetectorRef.markForCheck();
                    }));
                    return _this;
                }
                Object.defineProperty(MatSortHeader.prototype, "disableClear", {
                    /**
                     * Overrides the disable clear value of the containing MatSort for this MatSortable.
                     * @return {?}
                     */
                    get: function () { return this._disableClear; },
                    /**
                     * @param {?} v
                     * @return {?}
                     */
                    set: function (v) { this._disableClear = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_0__["coerceBooleanProperty"])(v); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatSortHeader.prototype.ngOnInit = function () {
                    if (!this.id && this._columnDef) {
                        this.id = this._columnDef.name;
                    }
                    // Initialize the direction of the arrow and set the view state to be immediately that state.
                    this._updateArrowDirection();
                    this._setAnimationTransitionState({ toState: this._isSorted() ? 'active' : this._arrowDirection });
                    this._sort.register(this);
                };
                /**
                 * @return {?}
                 */
                MatSortHeader.prototype.ngOnDestroy = function () {
                    this._sort.deregister(this);
                    this._rerenderSubscription.unsubscribe();
                };
                /**
                 * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
                 * user showing what the active sort will become. If set to false, the arrow will fade away.
                 * @param {?} visible
                 * @return {?}
                 */
                MatSortHeader.prototype._setIndicatorHintVisible = function (visible) {
                    // No-op if the sort header is disabled - should not make the hint visible.
                    if (this._isDisabled() && visible) {
                        return;
                    }
                    this._showIndicatorHint = visible;
                    if (!this._isSorted()) {
                        this._updateArrowDirection();
                        if (this._showIndicatorHint) {
                            this._setAnimationTransitionState({ fromState: this._arrowDirection, toState: 'hint' });
                        }
                        else {
                            this._setAnimationTransitionState({ fromState: 'hint', toState: this._arrowDirection });
                        }
                    }
                };
                /**
                 * Sets the animation transition view state for the arrow's position and opacity. If the
                 * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
                 * no animation appears.
                 * @param {?} viewState
                 * @return {?}
                 */
                MatSortHeader.prototype._setAnimationTransitionState = function (viewState) {
                    this._viewState = viewState;
                    // If the animation for arrow position state (opacity/translation) should be disabled,
                    // remove the fromState so that it jumps right to the toState.
                    if (this._disableViewStateAnimation) {
                        this._viewState = { toState: viewState.toState };
                    }
                };
                /**
                 * Triggers the sort on this sort header and removes the indicator hint.
                 * @return {?}
                 */
                MatSortHeader.prototype._handleClick = function () {
                    if (this._isDisabled()) {
                        return;
                    }
                    this._sort.sort(this);
                    // Do not show the animation if the header was already shown in the right position.
                    if (this._viewState.toState === 'hint' || this._viewState.toState === 'active') {
                        this._disableViewStateAnimation = true;
                    }
                    // If the arrow is now sorted, animate the arrow into place. Otherwise, animate it away into
                    // the direction it is facing.
                    /** @type {?} */
                    var viewState = this._isSorted() ?
                        { fromState: this._arrowDirection, toState: 'active' } :
                        { fromState: 'active', toState: this._arrowDirection };
                    this._setAnimationTransitionState(viewState);
                    this._showIndicatorHint = false;
                };
                /**
                 * Whether this MatSortHeader is currently sorted in either ascending or descending order.
                 * @return {?}
                 */
                MatSortHeader.prototype._isSorted = function () {
                    return this._sort.active == this.id &&
                        (this._sort.direction === 'asc' || this._sort.direction === 'desc');
                };
                /**
                 * Returns the animation state for the arrow direction (indicator and pointers).
                 * @return {?}
                 */
                MatSortHeader.prototype._getArrowDirectionState = function () {
                    return "" + (this._isSorted() ? 'active-' : '') + this._arrowDirection;
                };
                /**
                 * Returns the arrow position state (opacity, translation).
                 * @return {?}
                 */
                MatSortHeader.prototype._getArrowViewState = function () {
                    /** @type {?} */
                    var fromState = this._viewState.fromState;
                    return (fromState ? fromState + "-to-" : '') + this._viewState.toState;
                };
                /**
                 * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
                 * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
                 * active sorted direction. The reason this is updated through a function is because the direction
                 * should only be changed at specific times - when deactivated but the hint is displayed and when
                 * the sort is active and the direction changes. Otherwise the arrow's direction should linger
                 * in cases such as the sort becoming deactivated but we want to animate the arrow away while
                 * preserving its direction, even though the next sort direction is actually different and should
                 * only be changed once the arrow displays again (hint or activation).
                 * @return {?}
                 */
                MatSortHeader.prototype._updateArrowDirection = function () {
                    this._arrowDirection = this._isSorted() ?
                        this._sort.direction :
                        (this.start || this._sort.start);
                };
                /**
                 * @return {?}
                 */
                MatSortHeader.prototype._isDisabled = function () {
                    return this._sort.disabled || this.disabled;
                };
                /**
                 * Gets the aria-sort attribute that should be applied to this sort header. If this header
                 * is not sorted, returns null so that the attribute is removed from the host element. Aria spec
                 * says that the aria-sort property should only be present on one header at a time, so removing
                 * ensures this is true.
                 * @return {?}
                 */
                MatSortHeader.prototype._getAriaSortAttribute = function () {
                    if (!this._isSorted()) {
                        return null;
                    }
                    return this._sort.direction == 'asc' ? 'ascending' : 'descending';
                };
                /**
                 * Whether the arrow inside the sort header should be rendered.
                 * @return {?}
                 */
                MatSortHeader.prototype._renderArrow = function () {
                    return !this._isDisabled() || this._isSorted();
                };
                return MatSortHeader;
            }(_MatSortHeaderMixinBase));
            MatSortHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: '[mat-sort-header]',
                            exportAs: 'matSortHeader',
                            template: "<div class=\"mat-sort-header-container\" [class.mat-sort-header-sorted]=\"_isSorted()\" [class.mat-sort-header-position-before]=\"arrowPosition == 'before'\"><button class=\"mat-sort-header-button\" type=\"button\" [attr.disabled]=\"_isDisabled() || null\" [attr.aria-label]=\"_intl.sortButtonLabel(id)\" (focus)=\"_setIndicatorHintVisible(true)\" (blur)=\"_setIndicatorHintVisible(false)\"><ng-content></ng-content></button><div class=\"mat-sort-header-arrow\" *ngIf=\"_renderArrow()\" [@arrowOpacity]=\"_getArrowViewState()\" [@arrowPosition]=\"_getArrowViewState()\" [@allowChildren]=\"_getArrowDirectionState()\" (@arrowPosition.start)=\"_disableViewStateAnimation = true\" (@arrowPosition.done)=\"_disableViewStateAnimation = false\"><div class=\"mat-sort-header-stem\"></div><div class=\"mat-sort-header-indicator\" [@indicator]=\"_getArrowDirectionState()\"><div class=\"mat-sort-header-pointer-left\" [@leftPointer]=\"_getArrowDirectionState()\"></div><div class=\"mat-sort-header-pointer-right\" [@rightPointer]=\"_getArrowDirectionState()\"></div><div class=\"mat-sort-header-pointer-middle\"></div></div></div></div>",
                            styles: [".mat-sort-header-container{display:flex;cursor:pointer;align-items:center}.mat-sort-header-disabled .mat-sort-header-container{cursor:default}.mat-sort-header-position-before{flex-direction:row-reverse}.mat-sort-header-button{border:none;background:0 0;display:flex;align-items:center;padding:0;cursor:inherit;outline:0;font:inherit;color:currentColor}.mat-sort-header-button::-moz-focus-inner{border:0}.mat-sort-header-arrow{height:12px;width:12px;min-width:12px;position:relative;display:flex;opacity:0}.mat-sort-header-arrow,[dir=rtl] .mat-sort-header-position-before .mat-sort-header-arrow{margin:0 0 0 6px}.mat-sort-header-position-before .mat-sort-header-arrow,[dir=rtl] .mat-sort-header-arrow{margin:0 6px 0 0}.mat-sort-header-stem{background:currentColor;height:10px;width:2px;margin:auto;display:flex;align-items:center}@media (-ms-high-contrast:active){.mat-sort-header-stem{width:0;border-left:solid 2px}}.mat-sort-header-indicator{width:100%;height:2px;display:flex;align-items:center;position:absolute;top:0;left:0}.mat-sort-header-pointer-middle{margin:auto;height:2px;width:2px;background:currentColor;transform:rotate(45deg)}@media (-ms-high-contrast:active){.mat-sort-header-pointer-middle{width:0;height:0;border-top:solid 2px;border-left:solid 2px}}.mat-sort-header-pointer-left,.mat-sort-header-pointer-right{background:currentColor;width:6px;height:2px;position:absolute;top:0}@media (-ms-high-contrast:active){.mat-sort-header-pointer-left,.mat-sort-header-pointer-right{width:0;height:0;border-left:solid 6px;border-top:solid 2px}}.mat-sort-header-pointer-left{transform-origin:right;left:0}.mat-sort-header-pointer-right{transform-origin:left;right:0}"],
                            host: {
                                '(click)': '_handleClick()',
                                '(mouseenter)': '_setIndicatorHintVisible(true)',
                                '(mouseleave)': '_setIndicatorHintVisible(false)',
                                '[attr.aria-sort]': '_getAriaSortAttribute()',
                                '[class.mat-sort-header-disabled]': '_isDisabled()',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
                            inputs: ['disabled'],
                            animations: [
                                matSortAnimations.indicator,
                                matSortAnimations.leftPointer,
                                matSortAnimations.rightPointer,
                                matSortAnimations.arrowOpacity,
                                matSortAnimations.arrowPosition,
                                matSortAnimations.allowChildren,
                            ]
                        },] },
            ];
            /** @nocollapse */
            MatSortHeader.ctorParameters = function () { return [
                { type: MatSortHeaderIntl },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
                { type: MatSort, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: ['MAT_SORT_HEADER_COLUMN_DEF',] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] }
            ]; };
            MatSortHeader.propDecorators = {
                id: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['mat-sort-header',] }],
                arrowPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                start: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                disableClear: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatSortModule = /** @class */ (function () {
                function MatSortModule() {
                }
                return MatSortModule;
            }());
            MatSortModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [_angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"]],
                            exports: [MatSort, MatSortHeader],
                            declarations: [MatSort, MatSortHeader],
                            providers: [MAT_SORT_HEADER_INTL_PROVIDER]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=sort.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/stepper.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/stepper.js ***!
          \***********************************************************/
        /*! exports provided: MatStepperModule, MatStepLabel, MatStep, MatStepper, MatHorizontalStepper, MatVerticalStepper, MatStepperNext, MatStepperPrevious, MatStepHeader, MAT_STEPPER_INTL_PROVIDER_FACTORY, MatStepperIntl, MAT_STEPPER_INTL_PROVIDER, matStepperAnimations, MatStepperIcon */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepperModule", function () { return MatStepperModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepLabel", function () { return MatStepLabel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStep", function () { return MatStep; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepper", function () { return MatStepper; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatHorizontalStepper", function () { return MatHorizontalStepper; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatVerticalStepper", function () { return MatVerticalStepper; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepperNext", function () { return MatStepperNext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepperPrevious", function () { return MatStepperPrevious; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepHeader", function () { return MatStepHeader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_STEPPER_INTL_PROVIDER_FACTORY", function () { return MAT_STEPPER_INTL_PROVIDER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepperIntl", function () { return MatStepperIntl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_STEPPER_INTL_PROVIDER", function () { return MAT_STEPPER_INTL_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matStepperAnimations", function () { return matStepperAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatStepperIcon", function () { return MatStepperIcon; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/stepper */ "./node_modules/@angular/cdk/esm2015/stepper.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
            /* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatStepLabel = /** @class */ (function (_super_1) {
                __extends(MatStepLabel, _super_1);
                function MatStepLabel() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatStepLabel;
            }(_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepLabel"]));
            MatStepLabel.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[matStepLabel]',
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Stepper data that is required for internationalization.
             */
            var MatStepperIntl = /** @class */ (function () {
                function MatStepperIntl() {
                    /**
                     * Stream that emits whenever the labels here are changed. Use this to notify
                     * components if the labels have changed after initialization.
                     */
                    this.changes = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * Label that is rendered below optional steps.
                     */
                    this.optionalLabel = 'Optional';
                }
                return MatStepperIntl;
            }());
            MatStepperIntl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{ providedIn: 'root' },] },
            ];
            /** @nocollapse */ MatStepperIntl.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function MatStepperIntl_Factory() { return new MatStepperIntl(); }, token: MatStepperIntl, providedIn: "root" });
            /**
             * \@docs-private
             * @param {?} parentIntl
             * @return {?}
             */
            function MAT_STEPPER_INTL_PROVIDER_FACTORY(parentIntl) {
                return parentIntl || new MatStepperIntl();
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_STEPPER_INTL_PROVIDER = {
                provide: MatStepperIntl,
                deps: [[new _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"](), MatStepperIntl]],
                useFactory: MAT_STEPPER_INTL_PROVIDER_FACTORY
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatStepHeader = /** @class */ (function (_super_1) {
                __extends(MatStepHeader, _super_1);
                /**
                 * @param {?} _intl
                 * @param {?} _focusMonitor
                 * @param {?} _elementRef
                 * @param {?} changeDetectorRef
                 */
                function MatStepHeader(_intl, _focusMonitor, _elementRef, changeDetectorRef) {
                    var _this = _super_1.call(this, _elementRef) || this;
                    _this._intl = _intl;
                    _this._focusMonitor = _focusMonitor;
                    _focusMonitor.monitor(_elementRef, true);
                    _this._intlSubscription = _intl.changes.subscribe(( /**
                     * @return {?}
                     */function () { return changeDetectorRef.markForCheck(); }));
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatStepHeader.prototype.ngOnDestroy = function () {
                    this._intlSubscription.unsubscribe();
                    this._focusMonitor.stopMonitoring(this._elementRef);
                };
                /**
                 * Focuses the step header.
                 * @return {?}
                 */
                MatStepHeader.prototype.focus = function () {
                    this._focusMonitor.focusVia(this._elementRef, 'program');
                };
                /**
                 * Returns string label of given step if it is a text label.
                 * @return {?}
                 */
                MatStepHeader.prototype._stringLabel = function () {
                    return this.label instanceof MatStepLabel ? null : this.label;
                };
                /**
                 * Returns MatStepLabel if the label of given step is a template label.
                 * @return {?}
                 */
                MatStepHeader.prototype._templateLabel = function () {
                    return this.label instanceof MatStepLabel ? this.label : null;
                };
                /**
                 * Returns the host HTML element.
                 * @return {?}
                 */
                MatStepHeader.prototype._getHostElement = function () {
                    return this._elementRef.nativeElement;
                };
                /**
                 * Template context variables that are exposed to the `matStepperIcon` instances.
                 * @return {?}
                 */
                MatStepHeader.prototype._getIconContext = function () {
                    return {
                        index: this.index,
                        active: this.active,
                        optional: this.optional
                    };
                };
                /**
                 * @param {?} state
                 * @return {?}
                 */
                MatStepHeader.prototype._getDefaultTextForState = function (state$$1) {
                    if (state$$1 == 'number') {
                        return "" + (this.index + 1);
                    }
                    if (state$$1 == 'edit') {
                        return 'create';
                    }
                    if (state$$1 == 'error') {
                        return 'warning';
                    }
                    return state$$1;
                };
                return MatStepHeader;
            }(_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepHeader"]));
            MatStepHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-step-header',
                            template: "<div class=\"mat-step-header-ripple\" matRipple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"disableRipple\"></div><div class=\"mat-step-icon-state-{{state}} mat-step-icon\" [class.mat-step-icon-selected]=\"selected\"><div class=\"mat-step-icon-content\" [ngSwitch]=\"!!(iconOverrides && iconOverrides[state])\"><ng-container *ngSwitchCase=\"true\" [ngTemplateOutlet]=\"iconOverrides[state]\" [ngTemplateOutletContext]=\"_getIconContext()\"></ng-container><ng-container *ngSwitchDefault [ngSwitch]=\"state\"><span *ngSwitchCase=\"'number'\">{{_getDefaultTextForState(state)}}</span><mat-icon *ngSwitchDefault>{{_getDefaultTextForState(state)}}</mat-icon></ng-container></div></div><div class=\"mat-step-label\" [class.mat-step-label-active]=\"active\" [class.mat-step-label-selected]=\"selected\" [class.mat-step-label-error]=\"state == 'error'\"><ng-container *ngIf=\"_templateLabel()\" [ngTemplateOutlet]=\"_templateLabel()!.template\"></ng-container><div class=\"mat-step-text-label\" *ngIf=\"_stringLabel()\">{{label}}</div><div class=\"mat-step-optional\" *ngIf=\"optional && state != 'error'\">{{_intl.optionalLabel}}</div><div class=\"mat-step-sub-label-error\" *ngIf=\"state == 'error'\">{{errorMessage}}</div></div>",
                            styles: [".mat-step-header{overflow:hidden;outline:0;cursor:pointer;position:relative;box-sizing:content-box;-webkit-tap-highlight-color:transparent}.mat-step-optional,.mat-step-sub-label-error{font-size:12px}.mat-step-icon{border-radius:50%;height:24px;width:24px;flex-shrink:0;position:relative}.mat-step-icon .mat-icon,.mat-step-icon-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.mat-step-icon .mat-icon{font-size:16px;height:16px;width:16px}.mat-step-icon-state-error .mat-icon{font-size:24px;height:24px;width:24px}.mat-step-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:50px;vertical-align:middle}.mat-step-text-label{text-overflow:ellipsis;overflow:hidden}.mat-step-header .mat-step-header-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
                            host: {
                                'class': 'mat-step-header',
                                'role': 'tab',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatStepHeader.ctorParameters = function () { return [
                { type: MatStepperIntl },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_3__["FocusMonitor"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            MatStepHeader.propDecorators = {
                state: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                label: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                errorMessage: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                iconOverrides: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                index: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selected: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                active: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                optional: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disableRipple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the Material steppers.
             * \@docs-private
             * @type {?}
             */
            var matStepperAnimations = {
                /**
                 * Animation that transitions the step along the X axis in a horizontal stepper.
                 */
                horizontalStepTransition: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('stepTransition', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('previous', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translate3d(-100%, 0, 0)', visibility: 'hidden' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('current', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'none', visibility: 'visible' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('next', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => *', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])('500ms cubic-bezier(0.35, 0, 0.25, 1)'))
                ]),
                /**
                 * Animation that transitions the step along the Y axis in a vertical stepper.
                 */
                verticalStepTransition: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('stepTransition', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('previous', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ height: '0px', visibility: 'hidden' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('next', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ height: '0px', visibility: 'hidden' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('current', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({ height: '*', visibility: 'visible' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* <=> current', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Template to be used to override the icons inside the step header.
             */
            var MatStepperIcon = /** @class */ (function () {
                /**
                 * @param {?} templateRef
                 */
                function MatStepperIcon(templateRef) {
                    this.templateRef = templateRef;
                }
                return MatStepperIcon;
            }());
            MatStepperIcon.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'ng-template[matStepperIcon]',
                        },] },
            ];
            /** @nocollapse */
            MatStepperIcon.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] }
            ]; };
            MatStepperIcon.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['matStepperIcon',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatStep = /** @class */ (function (_super_1) {
                __extends(MatStep, _super_1);
                /**
                 * \@breaking-change 8.0.0 remove the `?` after `stepperOptions`
                 * @param {?} stepper
                 * @param {?} _errorStateMatcher
                 * @param {?=} stepperOptions
                 */
                function MatStep(stepper, _errorStateMatcher, stepperOptions) {
                    var _this = _super_1.call(this, stepper, stepperOptions) || this;
                    _this._errorStateMatcher = _errorStateMatcher;
                    return _this;
                }
                /**
                 * Custom error state matcher that additionally checks for validity of interacted form.
                 * @param {?} control
                 * @param {?} form
                 * @return {?}
                 */
                MatStep.prototype.isErrorState = function (control, form) {
                    /** @type {?} */
                    var originalErrorState = this._errorStateMatcher.isErrorState(control, form);
                    // Custom error state checks for the validity of form that is not submitted or touched
                    // since user can trigger a form change by calling for another step without directly
                    // interacting with the current form.
                    /** @type {?} */
                    var customErrorState = !!(control && control.invalid && this.interacted);
                    return originalErrorState || customErrorState;
                };
                return MatStep;
            }(_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStep"]));
            MatStep.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-step',
                            template: "<ng-template><ng-content></ng-content></ng-template>",
                            providers: [{ provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["ErrorStateMatcher"], useExisting: MatStep }],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            exportAs: 'matStep',
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatStep.ctorParameters = function () { return [
                { type: MatStepper, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return MatStepper; })),] }] },
                { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["ErrorStateMatcher"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["SkipSelf"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["STEPPER_GLOBAL_OPTIONS"],] }] }
            ]; };
            MatStep.propDecorators = {
                stepLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatStepLabel, { static: false },] }]
            };
            var MatStepper = /** @class */ (function (_super_1) {
                __extends(MatStepper, _super_1);
                function MatStepper() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * Event emitted when the current step is done transitioning in.
                     */
                    _this.animationDone = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Consumer-specified template-refs to be used to override the header icons.
                     */
                    _this._iconOverrides = {};
                    /**
                     * Stream of animation `done` events when the body expands/collapses.
                     */
                    _this._animationDone = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatStepper.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._icons.forEach(( /**
                     * @param {?} __0
                     * @return {?}
                     */function (_c) {
                        var name = _c.name, templateRef = _c.templateRef;
                        return _this._iconOverrides[name] = templateRef;
                    }));
                    // Mark the component for change detection whenever the content children query changes
                    this._steps.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () { return _this._stateChanged(); }));
                    this._animationDone.pipe(
                    // This needs a `distinctUntilChanged` in order to avoid emitting the same event twice due
                    // to a bug in animations where the `.done` callback gets invoked twice on some browsers.
                    // See https://github.com/angular/angular/issues/24084
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["distinctUntilChanged"])(( /**
                     * @param {?} x
                     * @param {?} y
                     * @return {?}
                     */function (x, y) { return x.fromState === y.fromState && x.toState === y.toState; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        if ((( /** @type {?} */(event.toState))) === 'current') {
                            _this.animationDone.emit();
                        }
                    }));
                };
                return MatStepper;
            }(_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepper"]));
            MatStepper.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[matStepper]', providers: [{ provide: _angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepper"], useExisting: MatStepper }] },] },
            ];
            MatStepper.propDecorators = {
                _stepHeader: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChildren"], args: [MatStepHeader,] }],
                _steps: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatStep,] }],
                _icons: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatStepperIcon,] }],
                animationDone: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                disableRipple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            var MatHorizontalStepper = /** @class */ (function (_super_1) {
                __extends(MatHorizontalStepper, _super_1);
                function MatHorizontalStepper() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * Whether the label should display in bottom or end position.
                     */
                    _this.labelPosition = 'end';
                    return _this;
                }
                return MatHorizontalStepper;
            }(MatStepper));
            MatHorizontalStepper.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-horizontal-stepper',
                            exportAs: 'matHorizontalStepper',
                            template: "<div class=\"mat-horizontal-stepper-header-container\"><ng-container *ngFor=\"let step of steps; let i = index; let isLast = last\"><mat-step-header class=\"mat-horizontal-stepper-header\" (click)=\"step.select()\" (keydown)=\"_onKeydown($event)\" [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\" [id]=\"_getStepLabelId(i)\" [attr.aria-posinset]=\"i + 1\" [attr.aria-setsize]=\"steps.length\" [attr.aria-controls]=\"_getStepContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [attr.aria-label]=\"step.ariaLabel || null\" [attr.aria-labelledby]=\"(!step.ariaLabel && step.ariaLabelledby) ? step.ariaLabelledby : null\" [index]=\"i\" [state]=\"_getIndicatorType(i, step.state)\" [label]=\"step.stepLabel || step.label\" [selected]=\"selectedIndex === i\" [active]=\"step.completed || selectedIndex === i || !linear\" [optional]=\"step.optional\" [errorMessage]=\"step.errorMessage\" [iconOverrides]=\"_iconOverrides\" [disableRipple]=\"disableRipple\"></mat-step-header><div *ngIf=\"!isLast\" class=\"mat-stepper-horizontal-line\"></div></ng-container></div><div class=\"mat-horizontal-content-container\"><div *ngFor=\"let step of steps; let i = index\" [attr.tabindex]=\"selectedIndex === i ? 0 : null\" class=\"mat-horizontal-stepper-content\" role=\"tabpanel\" [@stepTransition]=\"_getAnimationDirection(i)\" (@stepTransition.done)=\"_animationDone.next($event)\" [id]=\"_getStepContentId(i)\" [attr.aria-labelledby]=\"_getStepLabelId(i)\" [attr.aria-expanded]=\"selectedIndex === i\"><ng-container [ngTemplateOutlet]=\"step.content\"></ng-container></div></div>",
                            styles: [".mat-stepper-horizontal,.mat-stepper-vertical{display:block}.mat-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header-container{align-items:flex-start}.mat-stepper-horizontal-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -16px;min-width:32px}.mat-stepper-label-position-bottom .mat-stepper-horizontal-line{margin:0;min-width:0;position:relative;top:36px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::before,.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::before{border-top-width:1px;border-top-style:solid;content:'';display:inline-block;height:0;position:absolute;top:36px;width:calc(50% - 20px)}.mat-horizontal-stepper-header{display:flex;height:72px;overflow:hidden;align-items:center;padding:0 24px}.mat-horizontal-stepper-header .mat-step-icon{margin-right:8px;flex:none}[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon{margin-right:0;margin-left:8px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header{box-sizing:border-box;flex-direction:column;height:auto;padding:24px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::after{right:0}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::before,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::before{left:0}[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:first-child::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:last-child::before{display:none}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header .mat-step-icon{margin-right:0;margin-left:0}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header .mat-step-label{padding:16px 0 0 0;text-align:center;width:100%}.mat-vertical-stepper-header{display:flex;align-items:center;padding:24px;height:24px}.mat-vertical-stepper-header .mat-step-icon{margin-right:12px}[dir=rtl] .mat-vertical-stepper-header .mat-step-icon{margin-right:0;margin-left:12px}.mat-horizontal-stepper-content{outline:0}.mat-horizontal-stepper-content[aria-expanded=false]{height:0;overflow:hidden}.mat-horizontal-content-container{overflow:hidden;padding:0 24px 24px 24px}.mat-vertical-content-container{margin-left:36px;border:0;position:relative}[dir=rtl] .mat-vertical-content-container{margin-left:0;margin-right:36px}.mat-stepper-vertical-line::before{content:'';position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid}[dir=rtl] .mat-stepper-vertical-line::before{left:auto;right:0}.mat-vertical-stepper-content{overflow:hidden;outline:0}.mat-vertical-content{padding:0 24px 24px 24px}.mat-step:last-child .mat-vertical-content-container{border:none}"],
                            inputs: ['selectedIndex'],
                            host: {
                                'class': 'mat-stepper-horizontal',
                                '[class.mat-stepper-label-position-end]': 'labelPosition == "end"',
                                '[class.mat-stepper-label-position-bottom]': 'labelPosition == "bottom"',
                                'aria-orientation': 'horizontal',
                                'role': 'tablist',
                            },
                            animations: [matStepperAnimations.horizontalStepTransition],
                            providers: [
                                { provide: MatStepper, useExisting: MatHorizontalStepper },
                                { provide: _angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepper"], useExisting: MatHorizontalStepper }
                            ],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            MatHorizontalStepper.propDecorators = {
                labelPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            var MatVerticalStepper = /** @class */ (function (_super_1) {
                __extends(MatVerticalStepper, _super_1);
                /**
                 * @param {?} dir
                 * @param {?} changeDetectorRef
                 * @param {?=} elementRef
                 * @param {?=} _document
                 */
                function MatVerticalStepper(dir, changeDetectorRef, 
                // @breaking-change 8.0.0 `elementRef` and `_document` parameters to become required.
                elementRef, _document) {
                    var _this = _super_1.call(this, dir, changeDetectorRef, elementRef, _document) || this;
                    _this._orientation = 'vertical';
                    return _this;
                }
                return MatVerticalStepper;
            }(MatStepper));
            MatVerticalStepper.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-vertical-stepper',
                            exportAs: 'matVerticalStepper',
                            template: "<div class=\"mat-step\" *ngFor=\"let step of steps; let i = index; let isLast = last\"><mat-step-header class=\"mat-vertical-stepper-header\" (click)=\"step.select()\" (keydown)=\"_onKeydown($event)\" [tabIndex]=\"_getFocusIndex() == i ? 0 : -1\" [id]=\"_getStepLabelId(i)\" [attr.aria-posinset]=\"i + 1\" [attr.aria-setsize]=\"steps.length\" [attr.aria-controls]=\"_getStepContentId(i)\" [attr.aria-selected]=\"selectedIndex === i\" [attr.aria-label]=\"step.ariaLabel || null\" [attr.aria-labelledby]=\"(!step.ariaLabel && step.ariaLabelledby) ? step.ariaLabelledby : null\" [index]=\"i\" [state]=\"_getIndicatorType(i, step.state)\" [label]=\"step.stepLabel || step.label\" [selected]=\"selectedIndex === i\" [active]=\"step.completed || selectedIndex === i || !linear\" [optional]=\"step.optional\" [errorMessage]=\"step.errorMessage\" [iconOverrides]=\"_iconOverrides\" [disableRipple]=\"disableRipple\"></mat-step-header><div class=\"mat-vertical-content-container\" [class.mat-stepper-vertical-line]=\"!isLast\"><div class=\"mat-vertical-stepper-content\" role=\"tabpanel\" [attr.tabindex]=\"selectedIndex === i ? 0 : null\" [@stepTransition]=\"_getAnimationDirection(i)\" (@stepTransition.done)=\"_animationDone.next($event)\" [id]=\"_getStepContentId(i)\" [attr.aria-labelledby]=\"_getStepLabelId(i)\" [attr.aria-expanded]=\"selectedIndex === i\"><div class=\"mat-vertical-content\"><ng-container [ngTemplateOutlet]=\"step.content\"></ng-container></div></div></div></div>",
                            styles: [".mat-stepper-horizontal,.mat-stepper-vertical{display:block}.mat-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header-container{align-items:flex-start}.mat-stepper-horizontal-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -16px;min-width:32px}.mat-stepper-label-position-bottom .mat-stepper-horizontal-line{margin:0;min-width:0;position:relative;top:36px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::before,.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::before{border-top-width:1px;border-top-style:solid;content:'';display:inline-block;height:0;position:absolute;top:36px;width:calc(50% - 20px)}.mat-horizontal-stepper-header{display:flex;height:72px;overflow:hidden;align-items:center;padding:0 24px}.mat-horizontal-stepper-header .mat-step-icon{margin-right:8px;flex:none}[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon{margin-right:0;margin-left:8px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header{box-sizing:border-box;flex-direction:column;height:auto;padding:24px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::after{right:0}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::before,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::before{left:0}[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:first-child::after,[dir=rtl] .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:last-child::before{display:none}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header .mat-step-icon{margin-right:0;margin-left:0}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header .mat-step-label{padding:16px 0 0 0;text-align:center;width:100%}.mat-vertical-stepper-header{display:flex;align-items:center;padding:24px;height:24px}.mat-vertical-stepper-header .mat-step-icon{margin-right:12px}[dir=rtl] .mat-vertical-stepper-header .mat-step-icon{margin-right:0;margin-left:12px}.mat-horizontal-stepper-content{outline:0}.mat-horizontal-stepper-content[aria-expanded=false]{height:0;overflow:hidden}.mat-horizontal-content-container{overflow:hidden;padding:0 24px 24px 24px}.mat-vertical-content-container{margin-left:36px;border:0;position:relative}[dir=rtl] .mat-vertical-content-container{margin-left:0;margin-right:36px}.mat-stepper-vertical-line::before{content:'';position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid}[dir=rtl] .mat-stepper-vertical-line::before{left:auto;right:0}.mat-vertical-stepper-content{overflow:hidden;outline:0}.mat-vertical-content{padding:0 24px 24px 24px}.mat-step:last-child .mat-vertical-content-container{border:none}"],
                            inputs: ['selectedIndex'],
                            host: {
                                'class': 'mat-stepper-vertical',
                                'aria-orientation': 'vertical',
                                'role': 'tablist',
                            },
                            animations: [matStepperAnimations.verticalStepTransition],
                            providers: [
                                { provide: MatStepper, useExisting: MatVerticalStepper },
                                { provide: _angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepper"], useExisting: MatVerticalStepper }
                            ],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatVerticalStepper.ctorParameters = function () { return [
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_5__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_6__["DOCUMENT"],] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Button that moves to the next step in a stepper workflow.
             */
            var MatStepperNext = /** @class */ (function (_super_1) {
                __extends(MatStepperNext, _super_1);
                function MatStepperNext() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatStepperNext;
            }(_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepperNext"]));
            MatStepperNext.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'button[matStepperNext]',
                            host: {
                                '[type]': 'type',
                            },
                            inputs: ['type']
                        },] },
            ];
            /**
             * Button that moves to the previous step in a stepper workflow.
             */
            var MatStepperPrevious = /** @class */ (function (_super_1) {
                __extends(MatStepperPrevious, _super_1);
                function MatStepperPrevious() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatStepperPrevious;
            }(_angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepperPrevious"]));
            MatStepperPrevious.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'button[matStepperPrevious]',
                            host: {
                                '[type]': 'type',
                            },
                            inputs: ['type']
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatStepperModule = /** @class */ (function () {
                function MatStepperModule() {
                }
                return MatStepperModule;
            }());
            MatStepperModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatCommonModule"],
                                _angular_common__WEBPACK_IMPORTED_MODULE_6__["CommonModule"],
                                _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_9__["PortalModule"],
                                _angular_material_button__WEBPACK_IMPORTED_MODULE_10__["MatButtonModule"],
                                _angular_cdk_stepper__WEBPACK_IMPORTED_MODULE_1__["CdkStepperModule"],
                                _angular_material_icon__WEBPACK_IMPORTED_MODULE_11__["MatIconModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatRippleModule"],
                            ],
                            exports: [
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatCommonModule"],
                                MatHorizontalStepper,
                                MatVerticalStepper,
                                MatStep,
                                MatStepLabel,
                                MatStepper,
                                MatStepperNext,
                                MatStepperPrevious,
                                MatStepHeader,
                                MatStepperIcon,
                            ],
                            declarations: [
                                MatHorizontalStepper,
                                MatVerticalStepper,
                                MatStep,
                                MatStepLabel,
                                MatStepper,
                                MatStepperNext,
                                MatStepperPrevious,
                                MatStepHeader,
                                MatStepperIcon,
                            ],
                            providers: [MAT_STEPPER_INTL_PROVIDER, _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["ErrorStateMatcher"]],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=stepper.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/table.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/table.js ***!
          \*********************************************************/
        /*! exports provided: MatTableModule, MatCellDef, MatHeaderCellDef, MatFooterCellDef, MatColumnDef, MatHeaderCell, MatFooterCell, MatCell, MatTable, MatHeaderRowDef, MatFooterRowDef, MatRowDef, MatHeaderRow, MatFooterRow, MatRow, MatTableDataSource, MatTextColumn */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTableModule", function () { return MatTableModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCellDef", function () { return MatCellDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatHeaderCellDef", function () { return MatHeaderCellDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFooterCellDef", function () { return MatFooterCellDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatColumnDef", function () { return MatColumnDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatHeaderCell", function () { return MatHeaderCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFooterCell", function () { return MatFooterCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatCell", function () { return MatCell; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTable", function () { return MatTable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatHeaderRowDef", function () { return MatHeaderRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFooterRowDef", function () { return MatFooterRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRowDef", function () { return MatRowDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatHeaderRow", function () { return MatHeaderRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatFooterRow", function () { return MatFooterRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatRow", function () { return MatRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTableDataSource", function () { return MatTableDataSource; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTextColumn", function () { return MatTextColumn; });
            /* harmony import */ var _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/table */ "./node_modules/@angular/cdk/esm2015/table.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Wrapper for the CdkTable with Material design styles.
             * @template T
             */
            var MatTable = /** @class */ (function (_super_1) {
                __extends(MatTable, _super_1);
                function MatTable() {
                    var _this = _super_1.apply(this, arguments) || this;
                    /**
                     * Overrides the sticky CSS class set by the `CdkTable`.
                     */
                    _this.stickyCssClass = 'mat-table-sticky';
                    return _this;
                }
                return MatTable;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkTable"]));
            MatTable.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-table, table[mat-table]',
                            exportAs: 'matTable',
                            template: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CDK_TABLE_TEMPLATE"],
                            styles: ["mat-table{display:block}mat-header-row{min-height:56px}mat-footer-row,mat-row{min-height:48px}mat-footer-row,mat-header-row,mat-row{display:flex;border-width:0;border-bottom-width:1px;border-style:solid;align-items:center;box-sizing:border-box}mat-footer-row::after,mat-header-row::after,mat-row::after{display:inline-block;min-height:inherit;content:''}mat-cell:first-of-type,mat-footer-cell:first-of-type,mat-header-cell:first-of-type{padding-left:24px}[dir=rtl] mat-cell:first-of-type,[dir=rtl] mat-footer-cell:first-of-type,[dir=rtl] mat-header-cell:first-of-type{padding-left:0;padding-right:24px}mat-cell:last-of-type,mat-footer-cell:last-of-type,mat-header-cell:last-of-type{padding-right:24px}[dir=rtl] mat-cell:last-of-type,[dir=rtl] mat-footer-cell:last-of-type,[dir=rtl] mat-header-cell:last-of-type{padding-right:0;padding-left:24px}mat-cell,mat-footer-cell,mat-header-cell{flex:1;display:flex;align-items:center;overflow:hidden;word-wrap:break-word;min-height:inherit}table.mat-table{border-spacing:0}tr.mat-header-row{height:56px}tr.mat-footer-row,tr.mat-row{height:48px}th.mat-header-cell{text-align:left}[dir=rtl] th.mat-header-cell{text-align:right}td.mat-cell,td.mat-footer-cell,th.mat-header-cell{padding:0;border-bottom-width:1px;border-bottom-style:solid}td.mat-cell:first-of-type,td.mat-footer-cell:first-of-type,th.mat-header-cell:first-of-type{padding-left:24px}[dir=rtl] td.mat-cell:first-of-type,[dir=rtl] td.mat-footer-cell:first-of-type,[dir=rtl] th.mat-header-cell:first-of-type{padding-left:0;padding-right:24px}td.mat-cell:last-of-type,td.mat-footer-cell:last-of-type,th.mat-header-cell:last-of-type{padding-right:24px}[dir=rtl] td.mat-cell:last-of-type,[dir=rtl] td.mat-footer-cell:last-of-type,[dir=rtl] th.mat-header-cell:last-of-type{padding-right:0;padding-left:24px}"],
                            host: {
                                'class': 'mat-table',
                            },
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkTable"], useExisting: MatTable }],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Cell definition for the mat-table.
             * Captures the template of a column's data row cell as well as cell-specific properties.
             */
            var MatCellDef = /** @class */ (function (_super_1) {
                __extends(MatCellDef, _super_1);
                function MatCellDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatCellDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkCellDef"]));
            MatCellDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matCellDef]',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkCellDef"], useExisting: MatCellDef }]
                        },] },
            ];
            /**
             * Header cell definition for the mat-table.
             * Captures the template of a column's header cell and as well as cell-specific properties.
             */
            var MatHeaderCellDef = /** @class */ (function (_super_1) {
                __extends(MatHeaderCellDef, _super_1);
                function MatHeaderCellDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatHeaderCellDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderCellDef"]));
            MatHeaderCellDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matHeaderCellDef]',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderCellDef"], useExisting: MatHeaderCellDef }]
                        },] },
            ];
            /**
             * Footer cell definition for the mat-table.
             * Captures the template of a column's footer cell and as well as cell-specific properties.
             */
            var MatFooterCellDef = /** @class */ (function (_super_1) {
                __extends(MatFooterCellDef, _super_1);
                function MatFooterCellDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatFooterCellDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterCellDef"]));
            MatFooterCellDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matFooterCellDef]',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterCellDef"], useExisting: MatFooterCellDef }]
                        },] },
            ];
            /**
             * Column definition for the mat-table.
             * Defines a set of cells available for a table column.
             */
            var MatColumnDef = /** @class */ (function (_super_1) {
                __extends(MatColumnDef, _super_1);
                function MatColumnDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatColumnDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkColumnDef"]));
            MatColumnDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matColumnDef]',
                            providers: [
                                { provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkColumnDef"], useExisting: MatColumnDef },
                                { provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: MatColumnDef }
                            ],
                        },] },
            ];
            MatColumnDef.propDecorators = {
                name: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matColumnDef',] }],
                sticky: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                stickyEnd: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * Header cell template container that adds the right classes and role.
             */
            var MatHeaderCell = /** @class */ (function (_super_1) {
                __extends(MatHeaderCell, _super_1);
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function MatHeaderCell(columnDef, elementRef) {
                    var _this = _super_1.call(this, columnDef, elementRef) || this;
                    elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
                    return _this;
                }
                return MatHeaderCell;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderCell"]));
            MatHeaderCell.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'mat-header-cell, th[mat-header-cell]',
                            host: {
                                'class': 'mat-header-cell',
                                'role': 'columnheader',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatHeaderCell.ctorParameters = function () { return [
                { type: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkColumnDef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * Footer cell template container that adds the right classes and role.
             */
            var MatFooterCell = /** @class */ (function (_super_1) {
                __extends(MatFooterCell, _super_1);
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function MatFooterCell(columnDef, elementRef) {
                    var _this = _super_1.call(this, columnDef, elementRef) || this;
                    elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
                    return _this;
                }
                return MatFooterCell;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterCell"]));
            MatFooterCell.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'mat-footer-cell, td[mat-footer-cell]',
                            host: {
                                'class': 'mat-footer-cell',
                                'role': 'gridcell',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatFooterCell.ctorParameters = function () { return [
                { type: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkColumnDef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * Cell template container that adds the right classes and role.
             */
            var MatCell = /** @class */ (function (_super_1) {
                __extends(MatCell, _super_1);
                /**
                 * @param {?} columnDef
                 * @param {?} elementRef
                 */
                function MatCell(columnDef, elementRef) {
                    var _this = _super_1.call(this, columnDef, elementRef) || this;
                    elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
                    return _this;
                }
                return MatCell;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkCell"]));
            MatCell.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'mat-cell, td[mat-cell]',
                            host: {
                                'class': 'mat-cell',
                                'role': 'gridcell',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatCell.ctorParameters = function () { return [
                { type: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkColumnDef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Header row definition for the mat-table.
             * Captures the header row's template and other header properties such as the columns to display.
             */
            var MatHeaderRowDef = /** @class */ (function (_super_1) {
                __extends(MatHeaderRowDef, _super_1);
                function MatHeaderRowDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatHeaderRowDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderRowDef"]));
            MatHeaderRowDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matHeaderRowDef]',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderRowDef"], useExisting: MatHeaderRowDef }],
                            inputs: ['columns: matHeaderRowDef', 'sticky: matHeaderRowDefSticky'],
                        },] },
            ];
            /**
             * Footer row definition for the mat-table.
             * Captures the footer row's template and other footer properties such as the columns to display.
             */
            var MatFooterRowDef = /** @class */ (function (_super_1) {
                __extends(MatFooterRowDef, _super_1);
                function MatFooterRowDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatFooterRowDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterRowDef"]));
            MatFooterRowDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matFooterRowDef]',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterRowDef"], useExisting: MatFooterRowDef }],
                            inputs: ['columns: matFooterRowDef', 'sticky: matFooterRowDefSticky'],
                        },] },
            ];
            /**
             * Data row definition for the mat-table.
             * Captures the data row's template and other properties such as the columns to display and
             * a when predicate that describes when this row should be used.
             * @template T
             */
            var MatRowDef = /** @class */ (function (_super_1) {
                __extends(MatRowDef, _super_1);
                function MatRowDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatRowDef;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkRowDef"]));
            MatRowDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matRowDef]',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkRowDef"], useExisting: MatRowDef }],
                            inputs: ['columns: matRowDefColumns', 'when: matRowDefWhen'],
                        },] },
            ];
            /**
             * Footer template container that contains the cell outlet. Adds the right class and role.
             */
            var MatHeaderRow = /** @class */ (function (_super_1) {
                __extends(MatHeaderRow, _super_1);
                function MatHeaderRow() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatHeaderRow;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderRow"]));
            MatHeaderRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-header-row, tr[mat-header-row]',
                            template: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CDK_ROW_TEMPLATE"],
                            host: {
                                'class': 'mat-header-row',
                                'role': 'row',
                            },
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            exportAs: 'matHeaderRow',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkHeaderRow"], useExisting: MatHeaderRow }],
                        },] },
            ];
            /**
             * Footer template container that contains the cell outlet. Adds the right class and role.
             */
            var MatFooterRow = /** @class */ (function (_super_1) {
                __extends(MatFooterRow, _super_1);
                function MatFooterRow() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatFooterRow;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterRow"]));
            MatFooterRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-footer-row, tr[mat-footer-row]',
                            template: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CDK_ROW_TEMPLATE"],
                            host: {
                                'class': 'mat-footer-row',
                                'role': 'row',
                            },
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            exportAs: 'matFooterRow',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkFooterRow"], useExisting: MatFooterRow }],
                        },] },
            ];
            /**
             * Data row template container that contains the cell outlet. Adds the right class and role.
             */
            var MatRow = /** @class */ (function (_super_1) {
                __extends(MatRow, _super_1);
                function MatRow() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatRow;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkRow"]));
            MatRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-row, tr[mat-row]',
                            template: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CDK_ROW_TEMPLATE"],
                            host: {
                                'class': 'mat-row',
                                'role': 'row',
                            },
                            // See note on CdkTable for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            exportAs: 'matRow',
                            providers: [{ provide: _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkRow"], useExisting: MatRow }],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Column that simply shows text content for the header and row cells. Assumes that the table
             * is using the native table implementation (`<table>`).
             *
             * By default, the name of this column will be the header text and data property accessor.
             * The header text can be overridden with the `headerText` input. Cell values can be overridden with
             * the `dataAccessor` input. Change the text justification to the start or end using the `justify`
             * input.
             * @template T
             */
            var MatTextColumn = /** @class */ (function (_super_1) {
                __extends(MatTextColumn, _super_1);
                function MatTextColumn() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatTextColumn;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkTextColumn"]));
            MatTextColumn.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-text-column',
                            template: "\n    <ng-container matColumnDef>\n      <th mat-header-cell *matHeaderCellDef [style.text-align]=\"justify\">\n        {{headerText}}\n      </th>\n      <td mat-cell *matCellDef=\"let data\" [style.text-align]=\"justify\">\n        {{dataAccessor(data, name)}}\n      </td>\n    </ng-container>\n  ",
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            // Change detection is intentionally not set to OnPush. This component's template will be provided
                            // to the table to be inserted into its view. This is problematic when change detection runs since
                            // the bindings in this template will be evaluated _after_ the table's view is evaluated, which
                            // mean's the template in the table's view will not have the updated value (and in fact will cause
                            // an ExpressionChangedAfterItHasBeenCheckedError).
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var EXPORTED_DECLARATIONS = [
                // Table
                MatTable,
                // Template defs
                MatHeaderCellDef,
                MatHeaderRowDef,
                MatColumnDef,
                MatCellDef,
                MatRowDef,
                MatFooterCellDef,
                MatFooterRowDef,
                // Cell directives
                MatHeaderCell,
                MatCell,
                MatFooterCell,
                // Row directives
                MatHeaderRow,
                MatRow,
                MatFooterRow,
                MatTextColumn,
            ];
            var MatTableModule = /** @class */ (function () {
                function MatTableModule() {
                }
                return MatTableModule;
            }());
            MatTableModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [
                                _angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["CdkTableModule"],
                                _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"],
                            ],
                            exports: EXPORTED_DECLARATIONS,
                            declarations: EXPORTED_DECLARATIONS,
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Corresponds to `Number.MAX_SAFE_INTEGER`. Moved out into a variable here due to
             * flaky browser support and the value not being defined in Closure's typings.
             * @type {?}
             */
            var MAX_SAFE_INTEGER = 9007199254740991;
            /**
             * Data source that accepts a client-side data array and includes native support of filtering,
             * sorting (using MatSort), and pagination (using MatPaginator).
             *
             * Allows for sort customization by overriding sortingDataAccessor, which defines how data
             * properties are accessed. Also allows for filter customization by overriding filterTermAccessor,
             * which defines how row data is converted to a string for filter matching.
             *
             * **Note:** This class is meant to be a simple data source to help you get started. As such
             * it isn't equipped to handle some more advanced cases like robust i18n support or server-side
             * interactions. If your app needs to support more advanced use cases, consider implementing your
             * own `DataSource`.
             * @template T
             */
            var MatTableDataSource = /** @class */ (function (_super_1) {
                __extends(MatTableDataSource, _super_1);
                /**
                 * @param {?=} initialData
                 */
                function MatTableDataSource(initialData) {
                    if (initialData === void 0) { initialData = []; }
                    var _this = _super_1.call(this) || this;
                    /**
                     * Stream emitting render data to the table (depends on ordered data changes).
                     */
                    _this._renderData = new rxjs__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"]([]);
                    /**
                     * Stream that emits when a new filter string is set on the data source.
                     */
                    _this._filter = new rxjs__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"]('');
                    /**
                     * Used to react to internal changes of the paginator that are made by the data source itself.
                     */
                    _this._internalPageChanges = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
                    /**
                     * Subscription to the changes that should trigger an update to the table's rendered rows, such
                     * as filtering, sorting, pagination, or base data changes.
                     */
                    _this._renderChangesSubscription = rxjs__WEBPACK_IMPORTED_MODULE_5__["Subscription"].EMPTY;
                    /**
                     * Data accessor function that is used for accessing data properties for sorting through
                     * the default sortData function.
                     * This default function assumes that the sort header IDs (which defaults to the column name)
                     * matches the data's properties (e.g. column Xyz represents data['Xyz']).
                     * May be set to a custom function for different behavior.
                     * @param data Data object that is being accessed.
                     * @param sortHeaderId The name of the column that represents the data.
                     */
                    _this.sortingDataAccessor = ( /**
                     * @param {?} data
                     * @param {?} sortHeaderId
                     * @return {?}
                     */function (data, sortHeaderId) {
                        /** @type {?} */
                        var value = (( /** @type {?} */(data)))[sortHeaderId];
                        if (Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_4__["_isNumberValue"])(value)) {
                            /** @type {?} */
                            var numberValue = Number(value);
                            // Numbers beyond `MAX_SAFE_INTEGER` can't be compared reliably so we
                            // leave them as strings. For more info: https://goo.gl/y5vbSg
                            return numberValue < MAX_SAFE_INTEGER ? numberValue : value;
                        }
                        return value;
                    });
                    /**
                     * Gets a sorted copy of the data array based on the state of the MatSort. Called
                     * after changes are made to the filtered data or when sort changes are emitted from MatSort.
                     * By default, the function retrieves the active sort and its direction and compares data
                     * by retrieving data using the sortingDataAccessor. May be overridden for a custom implementation
                     * of data ordering.
                     * @param data The array of data that should be sorted.
                     * @param sort The connected MatSort that holds the current sort state.
                     */
                    _this.sortData = ( /**
                     * @param {?} data
                     * @param {?} sort
                     * @return {?}
                     */function (data, sort) {
                        /** @type {?} */
                        var active = sort.active;
                        /** @type {?} */
                        var direction = sort.direction;
                        if (!active || direction == '') {
                            return data;
                        }
                        return data.sort(( /**
                         * @param {?} a
                         * @param {?} b
                         * @return {?}
                         */function (a, b) {
                            /** @type {?} */
                            var valueA = _this.sortingDataAccessor(a, active);
                            /** @type {?} */
                            var valueB = _this.sortingDataAccessor(b, active);
                            // If both valueA and valueB exist (truthy), then compare the two. Otherwise, check if
                            // one value exists while the other doesn't. In this case, existing value should come last.
                            // This avoids inconsistent results when comparing values to undefined/null.
                            // If neither value exists, return 0 (equal).
                            /** @type {?} */
                            var comparatorResult = 0;
                            if (valueA != null && valueB != null) {
                                // Check if one value is greater than the other; if equal, comparatorResult should remain 0.
                                if (valueA > valueB) {
                                    comparatorResult = 1;
                                }
                                else if (valueA < valueB) {
                                    comparatorResult = -1;
                                }
                            }
                            else if (valueA != null) {
                                comparatorResult = 1;
                            }
                            else if (valueB != null) {
                                comparatorResult = -1;
                            }
                            return comparatorResult * (direction == 'asc' ? 1 : -1);
                        }));
                    });
                    /**
                     * Checks if a data object matches the data source's filter string. By default, each data object
                     * is converted to a string of its properties and returns true if the filter has
                     * at least one occurrence in that string. By default, the filter string has its whitespace
                     * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
                     * filter matching.
                     * @param data Data object used to check against the filter.
                     * @param filter Filter string that has been set on the data source.
                     * @return Whether the filter matches against the data
                     */
                    _this.filterPredicate = ( /**
                     * @param {?} data
                     * @param {?} filter
                     * @return {?}
                     */function (data, filter) {
                        // Transform the data into a lowercase string of all property values.
                        /** @type {?} */
                        var dataStr = Object.keys(data).reduce(( /**
                         * @param {?} currentTerm
                         * @param {?} key
                         * @return {?}
                         */function (currentTerm, key) {
                            // Use an obscure Unicode character to delimit the words in the concatenated string.
                            // This avoids matches where the values of two columns combined will match the user's query
                            // (e.g. `Flute` and `Stop` will match `Test`). The character is intended to be something
                            // that has a very low chance of being typed in by somebody in a text field. This one in
                            // particular is "White up-pointing triangle with dot" from
                            // https://en.wikipedia.org/wiki/List_of_Unicode_characters
                            return currentTerm + (( /** @type {?} */(data)))[key] + '◬';
                        }), '').toLowerCase();
                        // Transform the filter by converting it to lowercase and removing whitespace.
                        /** @type {?} */
                        var transformedFilter = filter.trim().toLowerCase();
                        return dataStr.indexOf(transformedFilter) != -1;
                    });
                    _this._data = new rxjs__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"](initialData);
                    _this._updateChangeSubscription();
                    return _this;
                }
                Object.defineProperty(MatTableDataSource.prototype, "data", {
                    /**
                     * Array of data that should be rendered by the table, where each object represents one row.
                     * @return {?}
                     */
                    get: function () { return this._data.value; },
                    /**
                     * @param {?} data
                     * @return {?}
                     */
                    set: function (data) { this._data.next(data); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTableDataSource.prototype, "filter", {
                    /**
                     * Filter term that should be used to filter out objects from the data array. To override how
                     * data objects match to this filter string, provide a custom function for filterPredicate.
                     * @return {?}
                     */
                    get: function () { return this._filter.value; },
                    /**
                     * @param {?} filter
                     * @return {?}
                     */
                    set: function (filter) { this._filter.next(filter); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTableDataSource.prototype, "sort", {
                    /**
                     * Instance of the MatSort directive used by the table to control its sorting. Sort changes
                     * emitted by the MatSort will trigger an update to the table's rendered data.
                     * @return {?}
                     */
                    get: function () { return this._sort; },
                    /**
                     * @param {?} sort
                     * @return {?}
                     */
                    set: function (sort) {
                        this._sort = sort;
                        this._updateChangeSubscription();
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTableDataSource.prototype, "paginator", {
                    /**
                     * Instance of the MatPaginator component used by the table to control what page of the data is
                     * displayed. Page changes emitted by the MatPaginator will trigger an update to the
                     * table's rendered data.
                     *
                     * Note that the data source uses the paginator's properties to calculate which page of data
                     * should be displayed. If the paginator receives its properties as template inputs,
                     * e.g. `[pageLength]=100` or `[pageIndex]=1`, then be sure that the paginator's view has been
                     * initialized before assigning it to this data source.
                     * @return {?}
                     */
                    get: function () { return this._paginator; },
                    /**
                     * @param {?} paginator
                     * @return {?}
                     */
                    set: function (paginator) {
                        this._paginator = paginator;
                        this._updateChangeSubscription();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Subscribe to changes that should trigger an update to the table's rendered rows. When the
                 * changes occur, process the current state of the filter, sort, and pagination along with
                 * the provided base data and send it to the table for rendering.
                 * @return {?}
                 */
                MatTableDataSource.prototype._updateChangeSubscription = function () {
                    var _this = this;
                    // Sorting and/or pagination should be watched if MatSort and/or MatPaginator are provided.
                    // The events should emit whenever the component emits a change or initializes, or if no
                    // component is provided, a stream with just a null event should be provided.
                    // The `sortChange` and `pageChange` acts as a signal to the combineLatests below so that the
                    // pipeline can progress to the next step. Note that the value from these streams are not used,
                    // they purely act as a signal to progress in the pipeline.
                    /** @type {?} */
                    var sortChange = this._sort ?
                        ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"])(this._sort.sortChange, this._sort.initialized))) :
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])(null);
                    /** @type {?} */
                    var pageChange = this._paginator ?
                        ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["merge"])(this._paginator.page, this._internalPageChanges, this._paginator.initialized))) :
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])(null);
                    /** @type {?} */
                    var dataStream = this._data;
                    // Watch for base data or filter changes to provide a filtered set of data.
                    /** @type {?} */
                    var filteredData = Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["combineLatest"])([dataStream, this._filter])
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                        var data = _c[0];
                        return _this._filterData(data);
                    })));
                    // Watch for filtered data or sort changes to provide an ordered set of data.
                    /** @type {?} */
                    var orderedData = Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["combineLatest"])([filteredData, sortChange])
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                        var data = _c[0];
                        return _this._orderData(data);
                    })));
                    // Watch for ordered data or page changes to provide a paged set of data.
                    /** @type {?} */
                    var paginatedData = Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["combineLatest"])([orderedData, pageChange])
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(( /**
                 * @param {?} __0
                 * @return {?}
                 */function (_c) {
                        var data = _c[0];
                        return _this._pageData(data);
                    })));
                    // Watched for paged data changes and send the result to the table to render.
                    this._renderChangesSubscription.unsubscribe();
                    this._renderChangesSubscription = paginatedData.subscribe(( /**
                     * @param {?} data
                     * @return {?}
                     */function (/**
                     * @param {?} data
                     * @return {?}
                     */ data) { return _this._renderData.next(data); }));
                };
                /**
                 * Returns a filtered data array where each filter object contains the filter string within
                 * the result of the filterTermAccessor function. If no filter is set, returns the data array
                 * as provided.
                 * @param {?} data
                 * @return {?}
                 */
                MatTableDataSource.prototype._filterData = function (data) {
                    var _this = this;
                    // If there is a filter string, filter out data that does not contain it.
                    // Each data object is converted to a string using the function defined by filterTermAccessor.
                    // May be overridden for customization.
                    this.filteredData =
                        !this.filter ? data : data.filter(( /**
                         * @param {?} obj
                         * @return {?}
                         */function (/**
                         * @param {?} obj
                         * @return {?}
                         */ obj) { return _this.filterPredicate(obj, _this.filter); }));
                    if (this.paginator) {
                        this._updatePaginator(this.filteredData.length);
                    }
                    return this.filteredData;
                };
                /**
                 * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
                 * data array as provided. Uses the default data accessor for data lookup, unless a
                 * sortDataAccessor function is defined.
                 * @param {?} data
                 * @return {?}
                 */
                MatTableDataSource.prototype._orderData = function (data) {
                    // If there is no active sort or direction, return the data without trying to sort.
                    if (!this.sort) {
                        return data;
                    }
                    return this.sortData(data.slice(), this.sort);
                };
                /**
                 * Returns a paged slice of the provided data array according to the provided MatPaginator's page
                 * index and length. If there is no paginator provided, returns the data array as provided.
                 * @param {?} data
                 * @return {?}
                 */
                MatTableDataSource.prototype._pageData = function (data) {
                    if (!this.paginator) {
                        return data;
                    }
                    /** @type {?} */
                    var startIndex = this.paginator.pageIndex * this.paginator.pageSize;
                    return data.slice(startIndex, startIndex + this.paginator.pageSize);
                };
                /**
                 * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
                 * index does not exceed the paginator's last page. Values are changed in a resolved promise to
                 * guard against making property changes within a round of change detection.
                 * @param {?} filteredDataLength
                 * @return {?}
                 */
                MatTableDataSource.prototype._updatePaginator = function (filteredDataLength) {
                    var _this = this;
                    Promise.resolve().then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var paginator = _this.paginator;
                        if (!paginator) {
                            return;
                        }
                        paginator.length = filteredDataLength;
                        // If the page index is set beyond the page, reduce it to the last page.
                        if (paginator.pageIndex > 0) {
                            /** @type {?} */
                            var lastPageIndex = Math.ceil(paginator.length / paginator.pageSize) - 1 || 0;
                            /** @type {?} */
                            var newPageIndex = Math.min(paginator.pageIndex, lastPageIndex);
                            if (newPageIndex !== paginator.pageIndex) {
                                paginator.pageIndex = newPageIndex;
                                // Since the paginator only emits after user-generated changes,
                                // we need our own stream so we know to should re-render the data.
                                _this._internalPageChanges.next();
                            }
                        }
                    }));
                };
                /**
                 * Used by the MatTable. Called when it connects to the data source.
                 * \@docs-private
                 * @return {?}
                 */
                MatTableDataSource.prototype.connect = function () { return this._renderData; };
                /**
                 * Used by the MatTable. Called when it is destroyed. No-op.
                 * \@docs-private
                 * @return {?}
                 */
                MatTableDataSource.prototype.disconnect = function () { };
                return MatTableDataSource;
            }(_angular_cdk_table__WEBPACK_IMPORTED_MODULE_0__["DataSource"]));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=table.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/tabs.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/tabs.js ***!
          \********************************************************/
        /*! exports provided: MatTabsModule, MatInkBar, _MAT_INK_BAR_POSITIONER, MatTabBody, _MatTabBodyBase, MatTabBodyPortal, MatTabHeader, _MatTabHeaderBase, MatTabLabelWrapper, MatTab, MatTabLabel, MatTabNav, MatTabLink, _MatTabNavBase, _MatTabLinkBase, MatTabContent, MatTabChangeEvent, MAT_TABS_CONFIG, _MatTabGroupBase, MatTabGroup, matTabsAnimations, ɵa24, ɵb24 */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabsModule", function () { return MatTabsModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatInkBar", function () { return MatInkBar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MAT_INK_BAR_POSITIONER", function () { return _MAT_INK_BAR_POSITIONER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabBody", function () { return MatTabBody; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatTabBodyBase", function () { return _MatTabBodyBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabBodyPortal", function () { return MatTabBodyPortal; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabHeader", function () { return MatTabHeader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatTabHeaderBase", function () { return _MatTabHeaderBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabLabelWrapper", function () { return MatTabLabelWrapper; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTab", function () { return MatTab; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabLabel", function () { return MatTabLabel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabNav", function () { return MatTabNav; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabLink", function () { return MatTabLink; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatTabNavBase", function () { return _MatTabNavBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatTabLinkBase", function () { return _MatTabLinkBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabContent", function () { return MatTabContent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabChangeEvent", function () { return MatTabChangeEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_TABS_CONFIG", function () { return MAT_TABS_CONFIG; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_MatTabGroupBase", function () { return _MatTabGroupBase; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTabGroup", function () { return MatTabGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matTabsAnimations", function () { return matTabsAnimations; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa24", function () { return _MAT_INK_BAR_POSITIONER_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb24", function () { return MatPaginatedTabHeader; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/cdk/observers */ "./node_modules/@angular/cdk/esm2015/observers.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Injection token for the MatInkBar's Positioner.
             * @type {?}
             */
            var _MAT_INK_BAR_POSITIONER = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MatInkBarPositioner', {
                providedIn: 'root',
                factory: _MAT_INK_BAR_POSITIONER_FACTORY
            });
            /**
             * The default positioner function for the MatInkBar.
             * \@docs-private
             * @return {?}
             */
            function _MAT_INK_BAR_POSITIONER_FACTORY() {
                /** @type {?} */
                var method = ( /**
                 * @param {?} element
                 * @return {?}
                 */function (element) { return ({
                    left: element ? (element.offsetLeft || 0) + 'px' : '0',
                    width: element ? (element.offsetWidth || 0) + 'px' : '0',
                }); });
                return method;
            }
            /**
             * The ink-bar is used to display and animate the line underneath the current active tab label.
             * \@docs-private
             */
            var MatInkBar = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _ngZone
                 * @param {?} _inkBarPositioner
                 * @param {?=} _animationMode
                 */
                function MatInkBar(_elementRef, _ngZone, _inkBarPositioner, _animationMode) {
                    this._elementRef = _elementRef;
                    this._ngZone = _ngZone;
                    this._inkBarPositioner = _inkBarPositioner;
                    this._animationMode = _animationMode;
                }
                /**
                 * Calculates the styles from the provided element in order to align the ink-bar to that element.
                 * Shows the ink bar if previously set as hidden.
                 * @param {?} element
                 * @return {?}
                 */
                MatInkBar.prototype.alignToElement = function (element) {
                    var _this = this;
                    this.show();
                    if (typeof requestAnimationFrame !== 'undefined') {
                        this._ngZone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            requestAnimationFrame(( /**
                             * @return {?}
                             */function () { return _this._setStyles(element); }));
                        }));
                    }
                    else {
                        this._setStyles(element);
                    }
                };
                /**
                 * Shows the ink bar.
                 * @return {?}
                 */
                MatInkBar.prototype.show = function () {
                    this._elementRef.nativeElement.style.visibility = 'visible';
                };
                /**
                 * Hides the ink bar.
                 * @return {?}
                 */
                MatInkBar.prototype.hide = function () {
                    this._elementRef.nativeElement.style.visibility = 'hidden';
                };
                /**
                 * Sets the proper styles to the ink bar element.
                 * @private
                 * @param {?} element
                 * @return {?}
                 */
                MatInkBar.prototype._setStyles = function (element) {
                    /** @type {?} */
                    var positions = this._inkBarPositioner(element);
                    /** @type {?} */
                    var inkBar = this._elementRef.nativeElement;
                    inkBar.style.left = positions.left;
                    inkBar.style.width = positions.width;
                };
                return MatInkBar;
            }());
            MatInkBar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: 'mat-ink-bar',
                            host: {
                                'class': 'mat-ink-bar',
                                '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                            },
                        },] },
            ];
            /** @nocollapse */
            MatInkBar.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_MAT_INK_BAR_POSITIONER,] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Decorates the `ng-template` tags and reads out the template from it.
             */
            var MatTabContent = /** @class */ (function () {
                /**
                 * @param {?} template
                 */
                function MatTabContent(template) {
                    this.template = template;
                }
                return MatTabContent;
            }());
            MatTabContent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[matTabContent]' },] },
            ];
            /** @nocollapse */
            MatTabContent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to flag tab labels for use with the portal directive
             */
            var MatTabLabel = /** @class */ (function (_super_1) {
                __extends(MatTabLabel, _super_1);
                function MatTabLabel() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatTabLabel;
            }(_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_2__["CdkPortal"]));
            MatTabLabel.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-tab-label], [matTabLabel]',
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatTab.
            /**
             * \@docs-private
             */
            var MatTabBase = /** @class */ (function () {
                function MatTabBase() {
                }
                return MatTabBase;
            }());
            /** @type {?} */
            var _MatTabMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisabled"])(MatTabBase);
            var MatTab = /** @class */ (function (_super_1) {
                __extends(MatTab, _super_1);
                /**
                 * @param {?} _viewContainerRef
                 */
                function MatTab(_viewContainerRef) {
                    var _this = _super_1.call(this) || this;
                    _this._viewContainerRef = _viewContainerRef;
                    /**
                     * Plain text label for the tab, used when there is no template label.
                     */
                    _this.textLabel = '';
                    /**
                     * Portal that will be the hosted content of the tab
                     */
                    _this._contentPortal = null;
                    /**
                     * Emits whenever the internal state of the tab changes.
                     */
                    _this._stateChanges = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * The relatively indexed position where 0 represents the center, negative is left, and positive
                     * represents the right.
                     */
                    _this.position = null;
                    /**
                     * The initial relatively index origin of the tab if it was created and selected after there
                     * was already a selected tab. Provides context of what position the tab should originate from.
                     */
                    _this.origin = null;
                    /**
                     * Whether the tab is currently active.
                     */
                    _this.isActive = false;
                    return _this;
                }
                Object.defineProperty(MatTab.prototype, "content", {
                    /**
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this._contentPortal;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                MatTab.prototype.ngOnChanges = function (changes) {
                    if (changes.hasOwnProperty('textLabel') || changes.hasOwnProperty('disabled')) {
                        this._stateChanges.next();
                    }
                };
                /**
                 * @return {?}
                 */
                MatTab.prototype.ngOnDestroy = function () {
                    this._stateChanges.complete();
                };
                /**
                 * @return {?}
                 */
                MatTab.prototype.ngOnInit = function () {
                    this._contentPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_2__["TemplatePortal"](this._explicitContent || this._implicitContent, this._viewContainerRef);
                };
                return MatTab;
            }(_MatTabMixinBase));
            MatTab.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-tab',
                            template: "<ng-template><ng-content></ng-content></ng-template>",
                            inputs: ['disabled'],
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            exportAs: 'matTab',
                        },] },
            ];
            /** @nocollapse */
            MatTab.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] }
            ]; };
            MatTab.propDecorators = {
                templateLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatTabLabel, { static: false },] }],
                _explicitContent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChild"], args: [MatTabContent, { read: _angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"], static: true },] }],
                _implicitContent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_0__["TemplateRef"], { static: true },] }],
                textLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['label',] }],
                ariaLabel: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-label',] }],
                ariaLabelledby: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['aria-labelledby',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by the Material tabs.
             * \@docs-private
             * @type {?}
             */
            var matTabsAnimations = {
                /**
                 * Animation translates a tab along the X axis.
                 */
                translateTab: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["trigger"])('translateTab', [
                    // Note: transitions to `none` instead of 0, because some browsers might blur the content.
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["state"])('center, void, left-origin-center, right-origin-center', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["style"])({ transform: 'none' })),
                    // If the tab is either on the left or right, we additionally add a `min-height` of 1px
                    // in order to ensure that the element has a height before its state changes. This is
                    // necessary because Chrome does seem to skip the transition in RTL mode if the element does
                    // not have a static height and is not rendered. See related issue: #9465
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["state"])('left', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["style"])({ transform: 'translate3d(-100%, 0, 0)', minHeight: '1px' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["state"])('right', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["style"])({ transform: 'translate3d(100%, 0, 0)', minHeight: '1px' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["transition"])('* => left, * => right, left => center, right => center', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["animate"])('{{animationDuration}} cubic-bezier(0.35, 0, 0.25, 1)')),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["transition"])('void => left-origin-center', [
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["style"])({ transform: 'translate3d(-100%, 0, 0)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["animate"])('{{animationDuration}} cubic-bezier(0.35, 0, 0.25, 1)')
                    ]),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["transition"])('void => right-origin-center', [
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["style"])({ transform: 'translate3d(100%, 0, 0)' }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_5__["animate"])('{{animationDuration}} cubic-bezier(0.35, 0, 0.25, 1)')
                    ])
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The portal host directive for the contents of the tab.
             * \@docs-private
             */
            var MatTabBodyPortal = /** @class */ (function (_super_1) {
                __extends(MatTabBodyPortal, _super_1);
                /**
                 * @param {?} componentFactoryResolver
                 * @param {?} viewContainerRef
                 * @param {?} _host
                 */
                function MatTabBodyPortal(componentFactoryResolver, viewContainerRef, _host) {
                    var _this = _super_1.call(this, componentFactoryResolver, viewContainerRef) || this;
                    _this._host = _host;
                    /**
                     * Subscription to events for when the tab body begins centering.
                     */
                    _this._centeringSub = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Subscription to events for when the tab body finishes leaving from center position.
                     */
                    _this._leavingSub = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    return _this;
                }
                /**
                 * Set initial visibility or set up subscription for changing visibility.
                 * @return {?}
                 */
                MatTabBodyPortal.prototype.ngOnInit = function () {
                    var _this = this;
                    _super_1.prototype.ngOnInit.call(this);
                    this._centeringSub = this._host._beforeCentering
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(this._host._isCenterPosition(this._host._position)))
                        .subscribe(( /**
                 * @param {?} isCentering
                 * @return {?}
                 */function (isCentering) {
                        if (isCentering && !_this.hasAttached()) {
                            _this.attach(_this._host._content);
                        }
                    }));
                    this._leavingSub = this._host._afterLeavingCenter.subscribe(( /**
                     * @return {?}
                     */function () {
                        _this.detach();
                    }));
                };
                /**
                 * Clean up centering subscription.
                 * @return {?}
                 */
                MatTabBodyPortal.prototype.ngOnDestroy = function () {
                    _super_1.prototype.ngOnDestroy.call(this);
                    this._centeringSub.unsubscribe();
                    this._leavingSub.unsubscribe();
                };
                return MatTabBodyPortal;
            }(_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_2__["CdkPortalOutlet"]));
            MatTabBodyPortal.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[matTabBodyHost]'
                        },] },
            ];
            /** @nocollapse */
            MatTabBodyPortal.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ComponentFactoryResolver"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewContainerRef"] },
                { type: MatTabBody, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                                 * @return {?}
                                                 */function () { return MatTabBody; })),] }] }
            ]; };
            /**
             * Base class with all of the `MatTabBody` functionality.
             * \@docs-private
             * @abstract
             */
            // tslint:disable-next-line:class-name
            var _MatTabBodyBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _dir
                 * @param {?} changeDetectorRef
                 */
                function _MatTabBodyBase(_elementRef, _dir, changeDetectorRef) {
                    var _this = this;
                    this._elementRef = _elementRef;
                    this._dir = _dir;
                    /**
                     * Subscription to the directionality change observable.
                     */
                    this._dirChangeSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Emits when an animation on the tab is complete.
                     */
                    this._translateTabComplete = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * Event emitted when the tab begins to animate towards the center as the active tab.
                     */
                    this._onCentering = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted before the centering of the tab begins.
                     */
                    this._beforeCentering = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted before the centering of the tab begins.
                     */
                    this._afterLeavingCenter = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted when the tab completes its animation towards the center.
                     */
                    this._onCentered = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"](true);
                    // Note that the default value will always be overwritten by `MatTabBody`, but we need one
                    // anyway to prevent the animations module from throwing an error if the body is used on its own.
                    /**
                     * Duration for the tab's animation.
                     */
                    this.animationDuration = '500ms';
                    if (_dir) {
                        this._dirChangeSubscription = _dir.change.subscribe(( /**
                         * @param {?} dir
                         * @return {?}
                         */function (dir) {
                            _this._computePositionAnimationState(dir);
                            changeDetectorRef.markForCheck();
                        }));
                    }
                    // Ensure that we get unique animation events, because the `.done` callback can get
                    // invoked twice in some browsers. See https://github.com/angular/angular/issues/24084.
                    this._translateTabComplete.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["distinctUntilChanged"])(( /**
                     * @param {?} x
                     * @param {?} y
                     * @return {?}
                     */function (x, y) {
                        return x.fromState === y.fromState && x.toState === y.toState;
                    }))).subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        // If the transition to the center is complete, emit an event.
                        if (_this._isCenterPosition(event.toState) && _this._isCenterPosition(_this._position)) {
                            _this._onCentered.emit();
                        }
                        if (_this._isCenterPosition(event.fromState) && !_this._isCenterPosition(_this._position)) {
                            _this._afterLeavingCenter.emit();
                        }
                    }));
                }
                Object.defineProperty(_MatTabBodyBase.prototype, "position", {
                    /**
                     * The shifted index position of the tab body, where zero represents the active center tab.
                     * @param {?} position
                     * @return {?}
                     */
                    set: function (position) {
                        this._positionIndex = position;
                        this._computePositionAnimationState();
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * After initialized, check if the content is centered and has an origin. If so, set the
                 * special position states that transition the tab from the left or right before centering.
                 * @return {?}
                 */
                _MatTabBodyBase.prototype.ngOnInit = function () {
                    if (this._position == 'center' && this.origin != null) {
                        this._position = this._computePositionFromOrigin();
                    }
                };
                /**
                 * @return {?}
                 */
                _MatTabBodyBase.prototype.ngOnDestroy = function () {
                    this._dirChangeSubscription.unsubscribe();
                    this._translateTabComplete.complete();
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                _MatTabBodyBase.prototype._onTranslateTabStarted = function (event) {
                    /** @type {?} */
                    var isCentering = this._isCenterPosition(event.toState);
                    this._beforeCentering.emit(isCentering);
                    if (isCentering) {
                        this._onCentering.emit(this._elementRef.nativeElement.clientHeight);
                    }
                };
                /**
                 * The text direction of the containing app.
                 * @return {?}
                 */
                _MatTabBodyBase.prototype._getLayoutDirection = function () {
                    return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
                };
                /**
                 * Whether the provided position state is considered center, regardless of origin.
                 * @param {?} position
                 * @return {?}
                 */
                _MatTabBodyBase.prototype._isCenterPosition = function (position) {
                    return position == 'center' ||
                        position == 'left-origin-center' ||
                        position == 'right-origin-center';
                };
                /**
                 * Computes the position state that will be used for the tab-body animation trigger.
                 * @private
                 * @param {?=} dir
                 * @return {?}
                 */
                _MatTabBodyBase.prototype._computePositionAnimationState = function (dir) {
                    if (dir === void 0) { dir = this._getLayoutDirection(); }
                    if (this._positionIndex < 0) {
                        this._position = dir == 'ltr' ? 'left' : 'right';
                    }
                    else if (this._positionIndex > 0) {
                        this._position = dir == 'ltr' ? 'right' : 'left';
                    }
                    else {
                        this._position = 'center';
                    }
                };
                /**
                 * Computes the position state based on the specified origin position. This is used if the
                 * tab is becoming visible immediately after creation.
                 * @private
                 * @return {?}
                 */
                _MatTabBodyBase.prototype._computePositionFromOrigin = function () {
                    /** @type {?} */
                    var dir = this._getLayoutDirection();
                    if ((dir == 'ltr' && this.origin <= 0) || (dir == 'rtl' && this.origin > 0)) {
                        return 'left-origin-center';
                    }
                    return 'right-origin-center';
                };
                return _MatTabBodyBase;
            }());
            _MatTabBodyBase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            // TODO(crisbeto): this selector can be removed when we update to Angular 9.0.
                            selector: 'do-not-use-abstract-mat-tab-body-base'
                        },] },
            ];
            /** @nocollapse */
            _MatTabBodyBase.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            _MatTabBodyBase.propDecorators = {
                _onCentering: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _beforeCentering: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _afterLeavingCenter: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _onCentered: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                _content: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ['content',] }],
                origin: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                animationDuration: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                position: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * Wrapper for the contents of a tab.
             * \@docs-private
             */
            var MatTabBody = /** @class */ (function (_super_1) {
                __extends(MatTabBody, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} dir
                 * @param {?} changeDetectorRef
                 */
                function MatTabBody(elementRef, dir, changeDetectorRef) {
                    return _super_1.call(this, elementRef, dir, changeDetectorRef) || this;
                }
                return MatTabBody;
            }(_MatTabBodyBase));
            MatTabBody.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-tab-body',
                            template: "<div class=\"mat-tab-body-content\" #content [@translateTab]=\"{ value: _position, params: {animationDuration: animationDuration} }\" (@translateTab.start)=\"_onTranslateTabStarted($event)\" (@translateTab.done)=\"_translateTabComplete.next($event)\"><ng-template matTabBodyHost></ng-template></div>",
                            styles: [".mat-tab-body-content{height:100%;overflow:auto}.mat-tab-group-dynamic-height .mat-tab-body-content{overflow:hidden}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            animations: [matTabsAnimations.translateTab],
                            host: {
                                'class': 'mat-tab-body',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatTabBody.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            MatTabBody.propDecorators = {
                _portalHost: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [_angular_cdk_portal__WEBPACK_IMPORTED_MODULE_2__["PortalHostDirective"], { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Used to generate unique ID's for each tab component
             * @type {?}
             */
            var nextId = 0;
            /**
             * A simple change event emitted on focus or selection changes.
             */
            var MatTabChangeEvent = /** @class */ (function () {
                function MatTabChangeEvent() {
                }
                return MatTabChangeEvent;
            }());
            /**
             * Injection token that can be used to provide the default options the tabs module.
             * @type {?}
             */
            var MAT_TABS_CONFIG = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('MAT_TABS_CONFIG');
            // Boilerplate for applying mixins to MatTabGroup.
            /**
             * \@docs-private
             */
            var MatTabGroupMixinBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatTabGroupMixinBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatTabGroupMixinBase;
            }());
            /** @type {?} */
            var _MatTabGroupMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinColor"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisableRipple"])(MatTabGroupMixinBase), 'primary');
            /**
             * Base class with all of the `MatTabGroupBase` functionality.
             * \@docs-private
             * @abstract
             */
            // tslint:disable-next-line:class-name
            var _MatTabGroupBase = /** @class */ (function (_super_1) {
                __extends(_MatTabGroupBase, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?=} defaultConfig
                 * @param {?=} _animationMode
                 */
                function _MatTabGroupBase(elementRef, _changeDetectorRef, defaultConfig, _animationMode) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._changeDetectorRef = _changeDetectorRef;
                    _this._animationMode = _animationMode;
                    /**
                     * The tab index that should be selected after the content has been checked.
                     */
                    _this._indexToSelect = 0;
                    /**
                     * Snapshot of the height of the tab body wrapper before another tab is activated.
                     */
                    _this._tabBodyWrapperHeight = 0;
                    /**
                     * Subscription to tabs being added/removed.
                     */
                    _this._tabsSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    /**
                     * Subscription to changes in the tab labels.
                     */
                    _this._tabLabelSubscription = rxjs__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
                    _this._dynamicHeight = false;
                    _this._selectedIndex = null;
                    /**
                     * Position of the tab header.
                     */
                    _this.headerPosition = 'above';
                    /**
                     * Output to enable support for two-way binding on `[(selectedIndex)]`
                     */
                    _this.selectedIndexChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted when focus has changed within a tab group.
                     */
                    _this.focusChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted when the body animation has completed
                     */
                    _this.animationDone = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted when the tab selection has changed.
                     */
                    _this.selectedTabChange = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"](true);
                    _this._groupId = nextId++;
                    _this.animationDuration = defaultConfig && defaultConfig.animationDuration ?
                        defaultConfig.animationDuration : '500ms';
                    return _this;
                }
                Object.defineProperty(_MatTabGroupBase.prototype, "dynamicHeight", {
                    /**
                     * Whether the tab group should grow to the size of the active tab.
                     * @return {?}
                     */
                    get: function () { return this._dynamicHeight; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._dynamicHeight = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatTabGroupBase.prototype, "selectedIndex", {
                    /**
                     * The index of the active tab.
                     * @return {?}
                     */
                    get: function () { return this._selectedIndex; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._indexToSelect = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceNumberProperty"])(value, null);
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatTabGroupBase.prototype, "animationDuration", {
                    /**
                     * Duration for the tab animation. Will be normalized to milliseconds if no units are set.
                     * @return {?}
                     */
                    get: function () { return this._animationDuration; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._animationDuration = /^\d+$/.test(value) ? value + 'ms' : value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatTabGroupBase.prototype, "backgroundColor", {
                    /**
                     * Background color of the tab group.
                     * @return {?}
                     */
                    get: function () { return this._backgroundColor; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var nativeElement = this._elementRef.nativeElement;
                        nativeElement.classList.remove("mat-background-" + this.backgroundColor);
                        if (value) {
                            nativeElement.classList.add("mat-background-" + value);
                        }
                        this._backgroundColor = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * After the content is checked, this component knows what tabs have been defined
                 * and what the selected index should be. This is where we can know exactly what position
                 * each tab should be in according to the new selected index, and additionally we know how
                 * a new selected tab should transition in (from the left or right).
                 * @return {?}
                 */
                _MatTabGroupBase.prototype.ngAfterContentChecked = function () {
                    var _this = this;
                    // Don't clamp the `indexToSelect` immediately in the setter because it can happen that
                    // the amount of tabs changes before the actual change detection runs.
                    /** @type {?} */
                    var indexToSelect = this._indexToSelect = this._clampTabIndex(this._indexToSelect);
                    // If there is a change in selected index, emit a change event. Should not trigger if
                    // the selected index has not yet been initialized.
                    if (this._selectedIndex != indexToSelect) {
                        /** @type {?} */
                        var isFirstRun_1 = this._selectedIndex == null;
                        if (!isFirstRun_1) {
                            this.selectedTabChange.emit(this._createChangeEvent(indexToSelect));
                        }
                        // Changing these values after change detection has run
                        // since the checked content may contain references to them.
                        Promise.resolve().then(( /**
                         * @return {?}
                         */function () {
                            _this._tabs.forEach(( /**
                             * @param {?} tab
                             * @param {?} index
                             * @return {?}
                             */function (tab, index) { return tab.isActive = index === indexToSelect; }));
                            if (!isFirstRun_1) {
                                _this.selectedIndexChange.emit(indexToSelect);
                            }
                        }));
                    }
                    // Setup the position for each tab and optionally setup an origin on the next selected tab.
                    this._tabs.forEach(( /**
                     * @param {?} tab
                     * @param {?} index
                     * @return {?}
                     */function (tab, index) {
                        tab.position = index - indexToSelect;
                        // If there is already a selected tab, then set up an origin for the next selected tab
                        // if it doesn't have one already.
                        if (_this._selectedIndex != null && tab.position == 0 && !tab.origin) {
                            tab.origin = indexToSelect - _this._selectedIndex;
                        }
                    }));
                    if (this._selectedIndex !== indexToSelect) {
                        this._selectedIndex = indexToSelect;
                        this._changeDetectorRef.markForCheck();
                    }
                };
                /**
                 * @return {?}
                 */
                _MatTabGroupBase.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this._subscribeToTabLabels();
                    // Subscribe to changes in the amount of tabs, in order to be
                    // able to re-render the content as new tabs are added or removed.
                    this._tabsSubscription = this._tabs.changes.subscribe(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var indexToSelect = _this._clampTabIndex(_this._indexToSelect);
                        // Maintain the previously-selected tab if a new tab is added or removed and there is no
                        // explicit change that selects a different tab.
                        if (indexToSelect === _this._selectedIndex) {
                            /** @type {?} */
                            var tabs = _this._tabs.toArray();
                            for (var i = 0; i < tabs.length; i++) {
                                if (tabs[i].isActive) {
                                    // Assign both to the `_indexToSelect` and `_selectedIndex` so we don't fire a changed
                                    // event, otherwise the consumer may end up in an infinite loop in some edge cases like
                                    // adding a tab within the `selectedIndexChange` event.
                                    _this._indexToSelect = _this._selectedIndex = i;
                                    break;
                                }
                            }
                        }
                        _this._subscribeToTabLabels();
                        _this._changeDetectorRef.markForCheck();
                    }));
                };
                /**
                 * @return {?}
                 */
                _MatTabGroupBase.prototype.ngOnDestroy = function () {
                    this._tabsSubscription.unsubscribe();
                    this._tabLabelSubscription.unsubscribe();
                };
                /**
                 * Re-aligns the ink bar to the selected tab element.
                 * @return {?}
                 */
                _MatTabGroupBase.prototype.realignInkBar = function () {
                    if (this._tabHeader) {
                        this._tabHeader._alignInkBarToSelectedTab();
                    }
                };
                /**
                 * @param {?} index
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._focusChanged = function (index) {
                    this.focusChange.emit(this._createChangeEvent(index));
                };
                /**
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._createChangeEvent = function (index) {
                    /** @type {?} */
                    var event = new MatTabChangeEvent;
                    event.index = index;
                    if (this._tabs && this._tabs.length) {
                        event.tab = this._tabs.toArray()[index];
                    }
                    return event;
                };
                /**
                 * Subscribes to changes in the tab labels. This is needed, because the \@Input for the label is
                 * on the MatTab component, whereas the data binding is inside the MatTabGroup. In order for the
                 * binding to be updated, we need to subscribe to changes in it and trigger change detection
                 * manually.
                 * @private
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._subscribeToTabLabels = function () {
                    var _this = this;
                    if (this._tabLabelSubscription) {
                        this._tabLabelSubscription.unsubscribe();
                    }
                    this._tabLabelSubscription = Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["merge"]).apply(void 0, this._tabs.map(( /**
                     * @param {?} tab
                     * @return {?}
                     */function (/**
                     * @param {?} tab
                     * @return {?}
                     */ tab) { return tab._stateChanges; }))).subscribe(( /**
                 * @return {?}
                 */function () { return _this._changeDetectorRef.markForCheck(); }));
                };
                /**
                 * Clamps the given index to the bounds of 0 and the tabs length.
                 * @private
                 * @param {?} index
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._clampTabIndex = function (index) {
                    // Note the `|| 0`, which ensures that values like NaN can't get through
                    // and which would otherwise throw the component into an infinite loop
                    // (since Math.max(NaN, 0) === NaN).
                    return Math.min(this._tabs.length - 1, Math.max(index || 0, 0));
                };
                /**
                 * Returns a unique id for each tab label element
                 * @param {?} i
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._getTabLabelId = function (i) {
                    return "mat-tab-label-" + this._groupId + "-" + i;
                };
                /**
                 * Returns a unique id for each tab content element
                 * @param {?} i
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._getTabContentId = function (i) {
                    return "mat-tab-content-" + this._groupId + "-" + i;
                };
                /**
                 * Sets the height of the body wrapper to the height of the activating tab if dynamic
                 * height property is true.
                 * @param {?} tabHeight
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._setTabBodyWrapperHeight = function (tabHeight) {
                    if (!this._dynamicHeight || !this._tabBodyWrapperHeight) {
                        return;
                    }
                    /** @type {?} */
                    var wrapper = this._tabBodyWrapper.nativeElement;
                    wrapper.style.height = this._tabBodyWrapperHeight + 'px';
                    // This conditional forces the browser to paint the height so that
                    // the animation to the new height can have an origin.
                    if (this._tabBodyWrapper.nativeElement.offsetHeight) {
                        wrapper.style.height = tabHeight + 'px';
                    }
                };
                /**
                 * Removes the height of the tab body wrapper.
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._removeTabBodyWrapperHeight = function () {
                    /** @type {?} */
                    var wrapper = this._tabBodyWrapper.nativeElement;
                    this._tabBodyWrapperHeight = wrapper.clientHeight;
                    wrapper.style.height = '';
                    this.animationDone.emit();
                };
                /**
                 * Handle click events, setting new selected index if appropriate.
                 * @param {?} tab
                 * @param {?} tabHeader
                 * @param {?} index
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._handleClick = function (tab, tabHeader, index) {
                    if (!tab.disabled) {
                        this.selectedIndex = tabHeader.focusIndex = index;
                    }
                };
                /**
                 * Retrieves the tabindex for the tab.
                 * @param {?} tab
                 * @param {?} idx
                 * @return {?}
                 */
                _MatTabGroupBase.prototype._getTabIndex = function (tab, idx) {
                    if (tab.disabled) {
                        return null;
                    }
                    return this.selectedIndex === idx ? 0 : -1;
                };
                return _MatTabGroupBase;
            }(_MatTabGroupMixinBase));
            _MatTabGroupBase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            // TODO(crisbeto): this selector can be removed when we update to Angular 9.0.
                            selector: 'do-not-use-abstract-mat-tab-group-base'
                        },] },
            ];
            /** @nocollapse */
            _MatTabGroupBase.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_TABS_CONFIG,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            _MatTabGroupBase.propDecorators = {
                dynamicHeight: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                headerPosition: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                animationDuration: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                backgroundColor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                selectedIndexChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                focusChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                animationDone: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                selectedTabChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            /**
             * Material design tab-group component. Supports basic tab pairs (label + content) and includes
             * animated ink-bar, keyboard navigation, and screen reader.
             * See: https://material.io/design/components/tabs.html
             */
            var MatTabGroup = /** @class */ (function (_super_1) {
                __extends(MatTabGroup, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} changeDetectorRef
                 * @param {?=} defaultConfig
                 * @param {?=} animationMode
                 */
                function MatTabGroup(elementRef, changeDetectorRef, defaultConfig, animationMode) {
                    return _super_1.call(this, elementRef, changeDetectorRef, defaultConfig, animationMode) || this;
                }
                return MatTabGroup;
            }(_MatTabGroupBase));
            MatTabGroup.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-tab-group',
                            exportAs: 'matTabGroup',
                            template: "<mat-tab-header #tabHeader [selectedIndex]=\"selectedIndex\" [disableRipple]=\"disableRipple\" (indexFocused)=\"_focusChanged($event)\" (selectFocusedIndex)=\"selectedIndex = $event\"><div class=\"mat-tab-label\" role=\"tab\" matTabLabelWrapper mat-ripple cdkMonitorElementFocus *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabLabelId(i)\" [attr.tabIndex]=\"_getTabIndex(tab, i)\" [attr.aria-posinset]=\"i + 1\" [attr.aria-setsize]=\"_tabs.length\" [attr.aria-controls]=\"_getTabContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [attr.aria-label]=\"tab.ariaLabel || null\" [attr.aria-labelledby]=\"(!tab.ariaLabel && tab.ariaLabelledby) ? tab.ariaLabelledby : null\" [class.mat-tab-label-active]=\"selectedIndex == i\" [disabled]=\"tab.disabled\" [matRippleDisabled]=\"tab.disabled || disableRipple\" (click)=\"_handleClick(tab, tabHeader, i)\"><div class=\"mat-tab-label-content\"><ng-template [ngIf]=\"tab.templateLabel\"><ng-template [cdkPortalOutlet]=\"tab.templateLabel\"></ng-template></ng-template><ng-template [ngIf]=\"!tab.templateLabel\">{{tab.textLabel}}</ng-template></div></div></mat-tab-header><div class=\"mat-tab-body-wrapper\" [class._mat-animation-noopable]=\"_animationMode === 'NoopAnimations'\" #tabBodyWrapper><mat-tab-body role=\"tabpanel\" *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabContentId(i)\" [attr.aria-labelledby]=\"_getTabLabelId(i)\" [class.mat-tab-body-active]=\"selectedIndex == i\" [content]=\"tab.content\" [position]=\"tab.position\" [origin]=\"tab.origin\" [animationDuration]=\"animationDuration\" (_onCentered)=\"_removeTabBodyWrapperHeight()\" (_onCentering)=\"_setTabBodyWrapperHeight($event)\"></mat-tab-body></div>",
                            styles: [".mat-tab-group{display:flex;flex-direction:column}.mat-tab-group.mat-tab-group-inverted-header{flex-direction:column-reverse}.mat-tab-label{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;position:relative}.mat-tab-label:focus{outline:0}.mat-tab-label:focus:not(.mat-tab-disabled){opacity:1}@media (-ms-high-contrast:active){.mat-tab-label:focus{outline:dotted 2px}}.mat-tab-label.mat-tab-disabled{cursor:default}@media (-ms-high-contrast:active){.mat-tab-label.mat-tab-disabled{opacity:.5}}.mat-tab-label .mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (-ms-high-contrast:active){.mat-tab-label{opacity:1}}@media (max-width:599px){.mat-tab-label{padding:0 12px}}@media (max-width:959px){.mat-tab-label{padding:0 12px}}.mat-tab-group[mat-stretch-tabs]>.mat-tab-header .mat-tab-label{flex-basis:0;flex-grow:1}.mat-tab-body-wrapper{position:relative;overflow:hidden;display:flex;transition:height .5s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable.mat-tab-body-wrapper{transition:none;animation:none}.mat-tab-body{top:0;left:0;right:0;bottom:0;position:absolute;display:block;overflow:hidden;flex-basis:100%}.mat-tab-body.mat-tab-body-active{position:relative;overflow-x:hidden;overflow-y:auto;z-index:1;flex-grow:1}.mat-tab-group.mat-tab-group-dynamic-height .mat-tab-body.mat-tab-body-active{overflow-y:hidden}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            inputs: ['color', 'disableRipple'],
                            host: {
                                'class': 'mat-tab-group',
                                '[class.mat-tab-group-dynamic-height]': 'dynamicHeight',
                                '[class.mat-tab-group-inverted-header]': 'headerPosition === "below"',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatTabGroup.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [MAT_TABS_CONFIG,] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatTabGroup.propDecorators = {
                _tabs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatTab,] }],
                _tabBodyWrapper: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['tabBodyWrapper', { static: false },] }],
                _tabHeader: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['tabHeader', { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatTabLabelWrapper.
            /**
             * \@docs-private
             */
            var MatTabLabelWrapperBase = /** @class */ (function () {
                function MatTabLabelWrapperBase() {
                }
                return MatTabLabelWrapperBase;
            }());
            /** @type {?} */
            var _MatTabLabelWrapperMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisabled"])(MatTabLabelWrapperBase);
            /**
             * Used in the `mat-tab-group` view to display tab labels.
             * \@docs-private
             */
            var MatTabLabelWrapper = /** @class */ (function (_super_1) {
                __extends(MatTabLabelWrapper, _super_1);
                /**
                 * @param {?} elementRef
                 */
                function MatTabLabelWrapper(elementRef) {
                    var _this = _super_1.call(this) || this;
                    _this.elementRef = elementRef;
                    return _this;
                }
                /**
                 * Sets focus on the wrapper element
                 * @return {?}
                 */
                MatTabLabelWrapper.prototype.focus = function () {
                    this.elementRef.nativeElement.focus();
                };
                /**
                 * @return {?}
                 */
                MatTabLabelWrapper.prototype.getOffsetLeft = function () {
                    return this.elementRef.nativeElement.offsetLeft;
                };
                /**
                 * @return {?}
                 */
                MatTabLabelWrapper.prototype.getOffsetWidth = function () {
                    return this.elementRef.nativeElement.offsetWidth;
                };
                return MatTabLabelWrapper;
            }(_MatTabLabelWrapperMixinBase));
            MatTabLabelWrapper.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[matTabLabelWrapper]',
                            inputs: ['disabled'],
                            host: {
                                '[class.mat-tab-disabled]': 'disabled',
                                '[attr.aria-disabled]': '!!disabled',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatTabLabelWrapper.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Config used to bind passive event listeners
             * @type {?}
             */
            var passiveEventListenerOptions = ( /** @type {?} */(Object(_angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["normalizePassiveListenerOptions"])({ passive: true })));
            /**
             * The distance in pixels that will be overshot when scrolling a tab label into view. This helps
             * provide a small affordance to the label next to it.
             * @type {?}
             */
            var EXAGGERATED_OVERSCROLL = 60;
            /**
             * Amount of milliseconds to wait before starting to scroll the header automatically.
             * Set a little conservatively in order to handle fake events dispatched on touch devices.
             * @type {?}
             */
            var HEADER_SCROLL_DELAY = 650;
            /**
             * Interval in milliseconds at which to scroll the header
             * while the user is holding their pointer.
             * @type {?}
             */
            var HEADER_SCROLL_INTERVAL = 100;
            /**
             * Base class for a tab header that supported pagination.
             * \@docs-private
             * @abstract
             */
            var MatPaginatedTabHeader = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 * @param {?} _changeDetectorRef
                 * @param {?} _viewportRuler
                 * @param {?} _dir
                 * @param {?} _ngZone
                 * @param {?=} _platform
                 * @param {?=} _animationMode
                 */
                function MatPaginatedTabHeader(_elementRef, _changeDetectorRef, _viewportRuler, _dir, _ngZone, _platform, _animationMode) {
                    var _this = this;
                    this._elementRef = _elementRef;
                    this._changeDetectorRef = _changeDetectorRef;
                    this._viewportRuler = _viewportRuler;
                    this._dir = _dir;
                    this._ngZone = _ngZone;
                    this._platform = _platform;
                    this._animationMode = _animationMode;
                    /**
                     * The distance in pixels that the tab labels should be translated to the left.
                     */
                    this._scrollDistance = 0;
                    /**
                     * Whether the header should scroll to the selected index after the view has been checked.
                     */
                    this._selectedIndexChanged = false;
                    /**
                     * Emits when the component is destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    /**
                     * Whether the controls for pagination should be displayed
                     */
                    this._showPaginationControls = false;
                    /**
                     * Whether the tab list can be scrolled more towards the end of the tab label list.
                     */
                    this._disableScrollAfter = true;
                    /**
                     * Whether the tab list can be scrolled more towards the beginning of the tab label list.
                     */
                    this._disableScrollBefore = true;
                    /**
                     * Stream that will stop the automated scrolling.
                     */
                    this._stopScrolling = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
                    this._selectedIndex = 0;
                    /**
                     * Event emitted when the option is selected.
                     */
                    this.selectFocusedIndex = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    /**
                     * Event emitted when a label is focused.
                     */
                    this.indexFocused = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    // Bind the `mouseleave` event on the outside since it doesn't change anything in the view.
                    _ngZone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["fromEvent"])(_elementRef.nativeElement, 'mouseleave')
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(_this._destroyed))
                            .subscribe(( /**
                     * @return {?}
                     */function () {
                            _this._stopInterval();
                        }));
                    }));
                }
                Object.defineProperty(MatPaginatedTabHeader.prototype, "selectedIndex", {
                    /**
                     * The index of the active tab.
                     * @return {?}
                     */
                    get: function () { return this._selectedIndex; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        value = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceNumberProperty"])(value);
                        if (this._selectedIndex != value) {
                            this._selectedIndexChanged = true;
                            this._selectedIndex = value;
                            if (this._keyManager) {
                                this._keyManager.updateActiveItemIndex(value);
                            }
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    // We need to handle these events manually, because we want to bind passive event listeners.
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["fromEvent"])(this._previousPaginator.nativeElement, 'touchstart', passiveEventListenerOptions)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._handlePaginatorPress('before');
                    }));
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["fromEvent"])(this._nextPaginator.nativeElement, 'touchstart', passiveEventListenerOptions)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        _this._handlePaginatorPress('after');
                    }));
                };
                /**
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    /** @type {?} */
                    var dirChange = this._dir ? this._dir.change : Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])(null);
                    /** @type {?} */
                    var resize = this._viewportRuler.change(150);
                    /** @type {?} */
                    var realign = ( /**
                     * @return {?}
                     */function () {
                        _this.updatePagination();
                        _this._alignInkBarToSelectedTab();
                    });
                    this._keyManager = new _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__["FocusKeyManager"](this._items)
                        .withHorizontalOrientation(this._getLayoutDirection())
                        .withWrap();
                    this._keyManager.updateActiveItem(0);
                    // Defer the first call in order to allow for slower browsers to lay out the elements.
                    // This helps in cases where the user lands directly on a page with paginated tabs.
                    typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame(realign) : realign();
                    // On dir change or window resize, realign the ink bar and update the orientation of
                    // the key manager if the direction has changed.
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["merge"])(dirChange, resize, this._items.changes).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () {
                        realign();
                        _this._keyManager.withHorizontalOrientation(_this._getLayoutDirection());
                    }));
                    // If there is a change in the focus key manager we need to emit the `indexFocused`
                    // event in order to provide a public event that notifies about focus changes. Also we realign
                    // the tabs container by scrolling the new focused tab into the visible section.
                    this._keyManager.change.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @param {?} newFocusIndex
                     * @return {?}
                     */function (/**
                     * @param {?} newFocusIndex
                     * @return {?}
                     */ newFocusIndex) {
                        _this.indexFocused.emit(newFocusIndex);
                        _this._setTabFocus(newFocusIndex);
                    }));
                };
                /**
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype.ngAfterContentChecked = function () {
                    // If the number of tab labels have changed, check if scrolling should be enabled
                    if (this._tabLabelCount != this._items.length) {
                        this.updatePagination();
                        this._tabLabelCount = this._items.length;
                        this._changeDetectorRef.markForCheck();
                    }
                    // If the selected index has changed, scroll to the label and check if the scrolling controls
                    // should be disabled.
                    if (this._selectedIndexChanged) {
                        this._scrollToLabel(this._selectedIndex);
                        this._checkScrollingControls();
                        this._alignInkBarToSelectedTab();
                        this._selectedIndexChanged = false;
                        this._changeDetectorRef.markForCheck();
                    }
                    // If the scroll distance has been changed (tab selected, focused, scroll controls activated),
                    // then translate the header to reflect this.
                    if (this._scrollDistanceChanged) {
                        this._updateTabScrollPosition();
                        this._scrollDistanceChanged = false;
                        this._changeDetectorRef.markForCheck();
                    }
                };
                /**
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype.ngOnDestroy = function () {
                    this._destroyed.next();
                    this._destroyed.complete();
                    this._stopScrolling.complete();
                };
                /**
                 * Handles keyboard events on the header.
                 * @param {?} event
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._handleKeydown = function (event) {
                    // We don't handle any key bindings with a modifier key.
                    if (Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["hasModifierKey"])(event)) {
                        return;
                    }
                    switch (event.keyCode) {
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["HOME"]:
                            this._keyManager.setFirstItemActive();
                            event.preventDefault();
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["END"]:
                            this._keyManager.setLastItemActive();
                            event.preventDefault();
                            break;
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["ENTER"]:
                        case _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_11__["SPACE"]:
                            this.selectFocusedIndex.emit(this.focusIndex);
                            this._itemSelected(event);
                            break;
                        default:
                            this._keyManager.onKeydown(event);
                    }
                };
                /**
                 * Callback for when the MutationObserver detects that the content has changed.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._onContentChanges = function () {
                    var _this = this;
                    /** @type {?} */
                    var textContent = this._elementRef.nativeElement.textContent;
                    // We need to diff the text content of the header, because the MutationObserver callback
                    // will fire even if the text content didn't change which is inefficient and is prone
                    // to infinite loops if a poorly constructed expression is passed in (see #14249).
                    if (textContent !== this._currentTextContent) {
                        this._currentTextContent = textContent || '';
                        // The content observer runs outside the `NgZone` by default, which
                        // means that we need to bring the callback back in ourselves.
                        this._ngZone.run(( /**
                         * @return {?}
                         */function () {
                            _this.updatePagination();
                            _this._alignInkBarToSelectedTab();
                            _this._changeDetectorRef.markForCheck();
                        }));
                    }
                };
                /**
                 * Updates the view whether pagination should be enabled or not.
                 *
                 * WARNING: Calling this method can be very costly in terms of performance. It should be called
                 * as infrequently as possible from outside of the Tabs component as it causes a reflow of the
                 * page.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype.updatePagination = function () {
                    this._checkPaginationEnabled();
                    this._checkScrollingControls();
                    this._updateTabScrollPosition();
                };
                Object.defineProperty(MatPaginatedTabHeader.prototype, "focusIndex", {
                    /**
                     * Tracks which element has focus; used for keyboard navigation
                     * @return {?}
                     */
                    get: function () {
                        return this._keyManager ? ( /** @type {?} */(this._keyManager.activeItemIndex)) : 0;
                    },
                    /**
                     * When the focus index is set, we must manually send focus to the correct label
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (!this._isValidIndex(value) || this.focusIndex === value || !this._keyManager) {
                            return;
                        }
                        this._keyManager.setActiveItem(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
                 * providing a valid index and return true.
                 * @param {?} index
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._isValidIndex = function (index) {
                    if (!this._items) {
                        return true;
                    }
                    /** @type {?} */
                    var tab = this._items ? this._items.toArray()[index] : null;
                    return !!tab && !tab.disabled;
                };
                /**
                 * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
                 * scrolling is enabled.
                 * @param {?} tabIndex
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._setTabFocus = function (tabIndex) {
                    if (this._showPaginationControls) {
                        this._scrollToLabel(tabIndex);
                    }
                    if (this._items && this._items.length) {
                        this._items.toArray()[tabIndex].focus();
                        // Do not let the browser manage scrolling to focus the element, this will be handled
                        // by using translation. In LTR, the scroll left should be 0. In RTL, the scroll width
                        // should be the full width minus the offset width.
                        /** @type {?} */
                        var containerEl = this._tabListContainer.nativeElement;
                        /** @type {?} */
                        var dir = this._getLayoutDirection();
                        if (dir == 'ltr') {
                            containerEl.scrollLeft = 0;
                        }
                        else {
                            containerEl.scrollLeft = containerEl.scrollWidth - containerEl.offsetWidth;
                        }
                    }
                };
                /**
                 * The layout direction of the containing app.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._getLayoutDirection = function () {
                    return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
                };
                /**
                 * Performs the CSS transformation on the tab list that will cause the list to scroll.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._updateTabScrollPosition = function () {
                    /** @type {?} */
                    var scrollDistance = this.scrollDistance;
                    /** @type {?} */
                    var platform = this._platform;
                    /** @type {?} */
                    var translateX = this._getLayoutDirection() === 'ltr' ? -scrollDistance : scrollDistance;
                    // Don't use `translate3d` here because we don't want to create a new layer. A new layer
                    // seems to cause flickering and overflow in Internet Explorer. For example, the ink bar
                    // and ripples will exceed the boundaries of the visible tab bar.
                    // See: https://github.com/angular/components/issues/10276
                    // We round the `transform` here, because transforms with sub-pixel precision cause some
                    // browsers to blur the content of the element.
                    this._tabList.nativeElement.style.transform = "translateX(" + Math.round(translateX) + "px)";
                    // Setting the `transform` on IE will change the scroll offset of the parent, causing the
                    // position to be thrown off in some cases. We have to reset it ourselves to ensure that
                    // it doesn't get thrown off. Note that we scope it only to IE and Edge, because messing
                    // with the scroll position throws off Chrome 71+ in RTL mode (see #14689).
                    // @breaking-change 9.0.0 Remove null check for `platform` after it can no longer be undefined.
                    if (platform && (platform.TRIDENT || platform.EDGE)) {
                        this._tabListContainer.nativeElement.scrollLeft = 0;
                    }
                };
                Object.defineProperty(MatPaginatedTabHeader.prototype, "scrollDistance", {
                    /**
                     * Sets the distance in pixels that the tab header should be transformed in the X-axis.
                     * @return {?}
                     */
                    get: function () { return this._scrollDistance; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._scrollTo(value);
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
                 * the end of the list, respectively). The distance to scroll is computed to be a third of the
                 * length of the tab list view window.
                 *
                 * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
                 * should be called sparingly.
                 * @param {?} direction
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._scrollHeader = function (direction) {
                    /** @type {?} */
                    var viewLength = this._tabListContainer.nativeElement.offsetWidth;
                    // Move the scroll distance one-third the length of the tab list's viewport.
                    /** @type {?} */
                    var scrollAmount = (direction == 'before' ? -1 : 1) * viewLength / 3;
                    return this._scrollTo(this._scrollDistance + scrollAmount);
                };
                /**
                 * Handles click events on the pagination arrows.
                 * @param {?} direction
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._handlePaginatorClick = function (direction) {
                    this._stopInterval();
                    this._scrollHeader(direction);
                };
                /**
                 * Moves the tab list such that the desired tab label (marked by index) is moved into view.
                 *
                 * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
                 * should be called sparingly.
                 * @param {?} labelIndex
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._scrollToLabel = function (labelIndex) {
                    /** @type {?} */
                    var selectedLabel = this._items ? this._items.toArray()[labelIndex] : null;
                    if (!selectedLabel) {
                        return;
                    }
                    // The view length is the visible width of the tab labels.
                    /** @type {?} */
                    var viewLength = this._tabListContainer.nativeElement.offsetWidth;
                    var _c = selectedLabel.elementRef.nativeElement, offsetLeft = _c.offsetLeft, offsetWidth = _c.offsetWidth;
                    /** @type {?} */
                    var labelBeforePos;
                    /** @type {?} */
                    var labelAfterPos;
                    if (this._getLayoutDirection() == 'ltr') {
                        labelBeforePos = offsetLeft;
                        labelAfterPos = labelBeforePos + offsetWidth;
                    }
                    else {
                        labelAfterPos = this._tabList.nativeElement.offsetWidth - offsetLeft;
                        labelBeforePos = labelAfterPos - offsetWidth;
                    }
                    /** @type {?} */
                    var beforeVisiblePos = this.scrollDistance;
                    /** @type {?} */
                    var afterVisiblePos = this.scrollDistance + viewLength;
                    if (labelBeforePos < beforeVisiblePos) {
                        // Scroll header to move label to the before direction
                        this.scrollDistance -= beforeVisiblePos - labelBeforePos + EXAGGERATED_OVERSCROLL;
                    }
                    else if (labelAfterPos > afterVisiblePos) {
                        // Scroll header to move label to the after direction
                        this.scrollDistance += labelAfterPos - afterVisiblePos + EXAGGERATED_OVERSCROLL;
                    }
                };
                /**
                 * Evaluate whether the pagination controls should be displayed. If the scroll width of the
                 * tab list is wider than the size of the header container, then the pagination controls should
                 * be shown.
                 *
                 * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
                 * should be called sparingly.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._checkPaginationEnabled = function () {
                    /** @type {?} */
                    var isEnabled = this._tabList.nativeElement.scrollWidth > this._elementRef.nativeElement.offsetWidth;
                    if (!isEnabled) {
                        this.scrollDistance = 0;
                    }
                    if (isEnabled !== this._showPaginationControls) {
                        this._changeDetectorRef.markForCheck();
                    }
                    this._showPaginationControls = isEnabled;
                };
                /**
                 * Evaluate whether the before and after controls should be enabled or disabled.
                 * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
                 * before button. If the header is at the end of the list (scroll distance is equal to the
                 * maximum distance we can scroll), then disable the after button.
                 *
                 * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
                 * should be called sparingly.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._checkScrollingControls = function () {
                    // Check if the pagination arrows should be activated.
                    this._disableScrollBefore = this.scrollDistance == 0;
                    this._disableScrollAfter = this.scrollDistance == this._getMaxScrollDistance();
                    this._changeDetectorRef.markForCheck();
                };
                /**
                 * Determines what is the maximum length in pixels that can be set for the scroll distance. This
                 * is equal to the difference in width between the tab list container and tab header container.
                 *
                 * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
                 * should be called sparingly.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._getMaxScrollDistance = function () {
                    /** @type {?} */
                    var lengthOfTabList = this._tabList.nativeElement.scrollWidth;
                    /** @type {?} */
                    var viewLength = this._tabListContainer.nativeElement.offsetWidth;
                    return (lengthOfTabList - viewLength) || 0;
                };
                /**
                 * Tells the ink-bar to align itself to the current label wrapper
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._alignInkBarToSelectedTab = function () {
                    /** @type {?} */
                    var selectedItem = this._items && this._items.length ?
                        this._items.toArray()[this.selectedIndex] : null;
                    /** @type {?} */
                    var selectedLabelWrapper = selectedItem ? selectedItem.elementRef.nativeElement : null;
                    if (selectedLabelWrapper) {
                        this._inkBar.alignToElement(selectedLabelWrapper);
                    }
                    else {
                        this._inkBar.hide();
                    }
                };
                /**
                 * Stops the currently-running paginator interval.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._stopInterval = function () {
                    this._stopScrolling.next();
                };
                /**
                 * Handles the user pressing down on one of the paginators.
                 * Starts scrolling the header after a certain amount of time.
                 * @param {?} direction In which direction the paginator should be scrolled.
                 * @return {?}
                 */
                MatPaginatedTabHeader.prototype._handlePaginatorPress = function (direction) {
                    var _this = this;
                    // Avoid overlapping timers.
                    this._stopInterval();
                    // Start a timer after the delay and keep firing based on the interval.
                    Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["timer"])(HEADER_SCROLL_DELAY, HEADER_SCROLL_INTERVAL)
                        // Keep the timer going until something tells it to stop or the component is destroyed.
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["merge"])(this._stopScrolling, this._destroyed)))
                        .subscribe(( /**
                 * @return {?}
                 */function () {
                        var _c = _this._scrollHeader(direction), maxScrollDistance = _c.maxScrollDistance, distance = _c.distance;
                        // Stop the timer if we've reached the start or the end.
                        if (distance === 0 || distance >= maxScrollDistance) {
                            _this._stopInterval();
                        }
                    }));
                };
                /**
                 * Scrolls the header to a given position.
                 * @private
                 * @param {?} position Position to which to scroll.
                 * @return {?} Information on the current scroll distance and the maximum.
                 */
                MatPaginatedTabHeader.prototype._scrollTo = function (position) {
                    /** @type {?} */
                    var maxScrollDistance = this._getMaxScrollDistance();
                    this._scrollDistance = Math.max(0, Math.min(maxScrollDistance, position));
                    // Mark that the scroll distance has changed so that after the view is checked, the CSS
                    // transformation can move the header.
                    this._scrollDistanceChanged = true;
                    this._checkScrollingControls();
                    return { maxScrollDistance: maxScrollDistance, distance: this._scrollDistance };
                };
                return MatPaginatedTabHeader;
            }());
            MatPaginatedTabHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            // TODO(crisbeto): this selector can be removed when we update to Angular 9.0.
                            selector: 'do-not-use-abstract-mat-paginated-tab-header'
                        },] },
            ];
            /** @nocollapse */
            MatPaginatedTabHeader.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ViewportRuler"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["Platform"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Base class with all of the `MatTabHeader` functionality.
             * \@docs-private
             * @abstract
             */
            // tslint:disable-next-line:class-name
            var _MatTabHeaderBase = /** @class */ (function (_super_1) {
                __extends(_MatTabHeaderBase, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} changeDetectorRef
                 * @param {?} viewportRuler
                 * @param {?} dir
                 * @param {?} ngZone
                 * @param {?} platform
                 * @param {?=} animationMode
                 */
                function _MatTabHeaderBase(elementRef, changeDetectorRef, viewportRuler, dir, ngZone, platform, 
                // @breaking-change 9.0.0 `_animationMode` parameter to be made required.
                animationMode) {
                    var _this = _super_1.call(this, elementRef, changeDetectorRef, viewportRuler, dir, ngZone, platform, animationMode) || this;
                    _this._disableRipple = false;
                    return _this;
                }
                Object.defineProperty(_MatTabHeaderBase.prototype, "disableRipple", {
                    /**
                     * Whether the ripple effect is disabled or not.
                     * @return {?}
                     */
                    get: function () { return this._disableRipple; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disableRipple = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @protected
                 * @param {?} event
                 * @return {?}
                 */
                _MatTabHeaderBase.prototype._itemSelected = function (event) {
                    event.preventDefault();
                };
                return _MatTabHeaderBase;
            }(MatPaginatedTabHeader));
            _MatTabHeaderBase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            // TODO(crisbeto): this selector can be removed when we update to Angular 9.0.
                            selector: 'do-not-use-abstract-mat-tab-header-base'
                        },] },
            ];
            /** @nocollapse */
            _MatTabHeaderBase.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ViewportRuler"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["Platform"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            _MatTabHeaderBase.propDecorators = {
                disableRipple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * The header of the tab group which displays a list of all the tabs in the tab group. Includes
             * an ink bar that follows the currently selected tab. When the tabs list's width exceeds the
             * width of the header container, then arrows will be displayed to allow the user to scroll
             * left and right across the header.
             * \@docs-private
             */
            var MatTabHeader = /** @class */ (function (_super_1) {
                __extends(MatTabHeader, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} changeDetectorRef
                 * @param {?} viewportRuler
                 * @param {?} dir
                 * @param {?} ngZone
                 * @param {?} platform
                 * @param {?=} animationMode
                 */
                function MatTabHeader(elementRef, changeDetectorRef, viewportRuler, dir, ngZone, platform, 
                // @breaking-change 9.0.0 `_animationMode` parameter to be made required.
                animationMode) {
                    return _super_1.call(this, elementRef, changeDetectorRef, viewportRuler, dir, ngZone, platform, animationMode) || this;
                }
                return MatTabHeader;
            }(_MatTabHeaderBase));
            MatTabHeader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: 'mat-tab-header',
                            template: "<div class=\"mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4\" #previousPaginator aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollBefore || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollBefore\" (click)=\"_handlePaginatorClick('before')\" (mousedown)=\"_handlePaginatorPress('before')\" (touchend)=\"_stopInterval()\"><div class=\"mat-tab-header-pagination-chevron\"></div></div><div class=\"mat-tab-label-container\" #tabListContainer (keydown)=\"_handleKeydown($event)\"><div #tabList class=\"mat-tab-list\" [class._mat-animation-noopable]=\"_animationMode === 'NoopAnimations'\" role=\"tablist\" (cdkObserveContent)=\"_onContentChanges()\"><div class=\"mat-tab-labels\"><ng-content></ng-content></div><mat-ink-bar></mat-ink-bar></div></div><div class=\"mat-tab-header-pagination mat-tab-header-pagination-after mat-elevation-z4\" #nextPaginator aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollAfter || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollAfter\" (mousedown)=\"_handlePaginatorPress('after')\" (click)=\"_handlePaginatorClick('after')\" (touchend)=\"_stopInterval()\"><div class=\"mat-tab-header-pagination-chevron\"></div></div>",
                            styles: [".mat-tab-header{display:flex;overflow:hidden;position:relative;flex-shrink:0}.mat-tab-header-pagination{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;display:none;justify-content:center;align-items:center;min-width:32px;cursor:pointer;z-index:2;-webkit-tap-highlight-color:transparent;touch-action:none}.mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination{display:flex}.mat-tab-header-pagination-before,.mat-tab-header-rtl .mat-tab-header-pagination-after{padding-left:4px}.mat-tab-header-pagination-before .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-after .mat-tab-header-pagination-chevron{transform:rotate(-135deg)}.mat-tab-header-pagination-after,.mat-tab-header-rtl .mat-tab-header-pagination-before{padding-right:4px}.mat-tab-header-pagination-after .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-before .mat-tab-header-pagination-chevron{transform:rotate(45deg)}.mat-tab-header-pagination-chevron{border-style:solid;border-width:2px 2px 0 0;content:'';height:8px;width:8px}.mat-tab-header-pagination-disabled{box-shadow:none;cursor:default}.mat-tab-list{flex-grow:1;position:relative;transition:transform .5s cubic-bezier(.35,0,.25,1)}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable.mat-ink-bar{transition:none;animation:none}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}@media (-ms-high-contrast:active){.mat-ink-bar{outline:solid 2px;height:0}}.mat-tab-labels{display:flex}[mat-align-tabs=center] .mat-tab-labels{justify-content:center}[mat-align-tabs=end] .mat-tab-labels{justify-content:flex-end}.mat-tab-label-container{display:flex;flex-grow:1;overflow:hidden;z-index:1}._mat-animation-noopable.mat-tab-list{transition:none;animation:none}.mat-tab-label{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;position:relative}.mat-tab-label:focus{outline:0}.mat-tab-label:focus:not(.mat-tab-disabled){opacity:1}@media (-ms-high-contrast:active){.mat-tab-label:focus{outline:dotted 2px}}.mat-tab-label.mat-tab-disabled{cursor:default}@media (-ms-high-contrast:active){.mat-tab-label.mat-tab-disabled{opacity:.5}}.mat-tab-label .mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (-ms-high-contrast:active){.mat-tab-label{opacity:1}}@media (max-width:599px){.mat-tab-label{min-width:72px}}"],
                            inputs: ['selectedIndex'],
                            outputs: ['selectFocusedIndex', 'indexFocused'],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            host: {
                                'class': 'mat-tab-header',
                                '[class.mat-tab-header-pagination-controls-enabled]': '_showPaginationControls',
                                '[class.mat-tab-header-rtl]': "_getLayoutDirection() == 'rtl'",
                            },
                        },] },
            ];
            /** @nocollapse */
            MatTabHeader.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ViewportRuler"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["Platform"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatTabHeader.propDecorators = {
                _items: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [MatTabLabelWrapper,] }],
                _inkBar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatInkBar, { static: true },] }],
                _tabListContainer: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['tabListContainer', { static: true },] }],
                _tabList: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['tabList', { static: true },] }],
                _nextPaginator: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['nextPaginator', { static: false },] }],
                _previousPaginator: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['previousPaginator', { static: false },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Base class with all of the `MatTabNav` functionality.
             * \@docs-private
             * @abstract
             */
            // tslint:disable-next-line:class-name
            var _MatTabNavBase = /** @class */ (function (_super_1) {
                __extends(_MatTabNavBase, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} dir
                 * @param {?} ngZone
                 * @param {?} changeDetectorRef
                 * @param {?} viewportRuler
                 * @param {?=} platform
                 * @param {?=} animationMode
                 */
                function _MatTabNavBase(elementRef, dir, ngZone, changeDetectorRef, viewportRuler, 
                /**
                 * @deprecated @breaking-change 9.0.0 `platform` parameter to become required.
                 */
                platform, animationMode) {
                    var _this = _super_1.call(this, elementRef, changeDetectorRef, viewportRuler, dir, ngZone, platform, animationMode) || this;
                    _this._disableRipple = false;
                    /**
                     * Theme color of the nav bar.
                     */
                    _this.color = 'primary';
                    return _this;
                }
                Object.defineProperty(_MatTabNavBase.prototype, "backgroundColor", {
                    /**
                     * Background color of the tab nav.
                     * @return {?}
                     */
                    get: function () { return this._backgroundColor; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        /** @type {?} */
                        var classList = this._elementRef.nativeElement.classList;
                        classList.remove("mat-background-" + this.backgroundColor);
                        if (value) {
                            classList.add("mat-background-" + value);
                        }
                        this._backgroundColor = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatTabNavBase.prototype, "disableRipple", {
                    /**
                     * Whether the ripple effect is disabled or not.
                     * @return {?}
                     */
                    get: function () { return this._disableRipple; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disableRipple = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_8__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @protected
                 * @return {?}
                 */
                _MatTabNavBase.prototype._itemSelected = function () {
                    // noop
                };
                /**
                 * @return {?}
                 */
                _MatTabNavBase.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    // We need this to run before the `changes` subscription in parent to ensure that the
                    // selectedIndex is up-to-date by the time the super class starts looking for it.
                    this._items.changes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(null), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @return {?}
                     */function () {
                        _this.updateActiveLink();
                    }));
                    _super_1.prototype.ngAfterContentInit.call(this);
                };
                /**
                 * Notifies the component that the active link has been changed.
                 * \@breaking-change 8.0.0 `element` parameter to be removed.
                 * @param {?=} _element
                 * @return {?}
                 */
                _MatTabNavBase.prototype.updateActiveLink = function (_element) {
                    if (!this._items) {
                        return;
                    }
                    /** @type {?} */
                    var items = this._items.toArray();
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].active) {
                            this.selectedIndex = i;
                            this._changeDetectorRef.markForCheck();
                            return;
                        }
                    }
                    // The ink bar should hide itself if no items are active.
                    this.selectedIndex = -1;
                    this._inkBar.hide();
                };
                return _MatTabNavBase;
            }(MatPaginatedTabHeader));
            _MatTabNavBase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            // TODO(crisbeto): this selector can be removed when we update to Angular 9.0.
                            selector: 'do-not-use-abstract-mat-tab-nav-base'
                        },] },
            ];
            /** @nocollapse */
            _MatTabNavBase.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ViewportRuler"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["Platform"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            _MatTabNavBase.propDecorators = {
                backgroundColor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                disableRipple: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * Navigation component matching the styles of the tab group header.
             * Provides anchored navigation with animated ink bar.
             */
            var MatTabNav = /** @class */ (function (_super_1) {
                __extends(MatTabNav, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} dir
                 * @param {?} ngZone
                 * @param {?} changeDetectorRef
                 * @param {?} viewportRuler
                 * @param {?=} platform
                 * @param {?=} animationMode
                 */
                function MatTabNav(elementRef, dir, ngZone, changeDetectorRef, viewportRuler, 
                /**
                 * @deprecated @breaking-change 9.0.0 `platform` parameter to become required.
                 */
                platform, animationMode) {
                    return _super_1.call(this, elementRef, dir, ngZone, changeDetectorRef, viewportRuler, platform, animationMode) || this;
                }
                return MatTabNav;
            }(_MatTabNavBase));
            MatTabNav.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{ selector: '[mat-tab-nav-bar]',
                            exportAs: 'matTabNavBar, matTabNav',
                            inputs: ['color'],
                            template: "<div class=\"mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4\" #previousPaginator aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollBefore || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollBefore\" (click)=\"_handlePaginatorClick('before')\" (mousedown)=\"_handlePaginatorPress('before')\" (touchend)=\"_stopInterval()\"><div class=\"mat-tab-header-pagination-chevron\"></div></div><div class=\"mat-tab-link-container\" #tabListContainer (keydown)=\"_handleKeydown($event)\"><div class=\"mat-tab-list\" #tabList (cdkObserveContent)=\"_onContentChanges()\"><div class=\"mat-tab-links\"><ng-content></ng-content></div><mat-ink-bar></mat-ink-bar></div></div><div class=\"mat-tab-header-pagination mat-tab-header-pagination-after mat-elevation-z4\" #nextPaginator aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollAfter || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollAfter\" (mousedown)=\"_handlePaginatorPress('after')\" (click)=\"_handlePaginatorClick('after')\" (touchend)=\"_stopInterval()\"><div class=\"mat-tab-header-pagination-chevron\"></div></div>",
                            styles: [".mat-tab-header{display:flex;overflow:hidden;position:relative;flex-shrink:0}.mat-tab-header-pagination{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;display:none;justify-content:center;align-items:center;min-width:32px;cursor:pointer;z-index:2;-webkit-tap-highlight-color:transparent;touch-action:none}.mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination{display:flex}.mat-tab-header-pagination-before,.mat-tab-header-rtl .mat-tab-header-pagination-after{padding-left:4px}.mat-tab-header-pagination-before .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-after .mat-tab-header-pagination-chevron{transform:rotate(-135deg)}.mat-tab-header-pagination-after,.mat-tab-header-rtl .mat-tab-header-pagination-before{padding-right:4px}.mat-tab-header-pagination-after .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-before .mat-tab-header-pagination-chevron{transform:rotate(45deg)}.mat-tab-header-pagination-chevron{border-style:solid;border-width:2px 2px 0 0;content:'';height:8px;width:8px}.mat-tab-header-pagination-disabled{box-shadow:none;cursor:default}.mat-tab-list{flex-grow:1;position:relative;transition:transform .5s cubic-bezier(.35,0,.25,1)}.mat-tab-links{display:flex}[mat-align-tabs=center] .mat-tab-links{justify-content:center}[mat-align-tabs=end] .mat-tab-links{justify-content:flex-end}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable.mat-ink-bar{transition:none;animation:none}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}@media (-ms-high-contrast:active){.mat-ink-bar{outline:solid 2px;height:0}}.mat-tab-link-container{display:flex;flex-grow:1;overflow:hidden;z-index:1}.mat-tab-link{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;vertical-align:top;text-decoration:none;position:relative;overflow:hidden;-webkit-tap-highlight-color:transparent}.mat-tab-link:focus{outline:0}.mat-tab-link:focus:not(.mat-tab-disabled){opacity:1}@media (-ms-high-contrast:active){.mat-tab-link:focus{outline:dotted 2px}}.mat-tab-link.mat-tab-disabled{cursor:default}@media (-ms-high-contrast:active){.mat-tab-link.mat-tab-disabled{opacity:.5}}.mat-tab-link .mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (-ms-high-contrast:active){.mat-tab-link{opacity:1}}[mat-stretch-tabs] .mat-tab-link{flex-basis:0;flex-grow:1}.mat-tab-link.mat-tab-disabled{pointer-events:none}@media (max-width:599px){.mat-tab-link{min-width:72px}}"],
                            host: {
                                'class': 'mat-tab-nav-bar mat-tab-header',
                                '[class.mat-tab-header-pagination-controls-enabled]': '_showPaginationControls',
                                '[class.mat-tab-header-rtl]': "_getLayoutDirection() == 'rtl'",
                                '[class.mat-primary]': 'color !== "warn" && color !== "accent"',
                                '[class.mat-accent]': 'color === "accent"',
                                '[class.mat-warn]': 'color === "warn"',
                            },
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                        },] },
            ];
            /** @nocollapse */
            MatTabNav.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_6__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ViewportRuler"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["Platform"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            MatTabNav.propDecorators = {
                _items: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ContentChildren"], args: [Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(( /**
                                         * @return {?}
                                         */function () { return MatTabLink; })), { descendants: true },] }],
                _inkBar: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: [MatInkBar, { static: true },] }],
                _tabListContainer: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['tabListContainer', { static: true },] }],
                _tabList: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['tabList', { static: true },] }],
                _nextPaginator: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['nextPaginator', { static: false },] }],
                _previousPaginator: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['previousPaginator', { static: false },] }]
            };
            // Boilerplate for applying mixins to MatTabLink.
            var MatTabLinkMixinBase = /** @class */ (function () {
                function MatTabLinkMixinBase() {
                }
                return MatTabLinkMixinBase;
            }());
            /** @type {?} */
            var _MatTabLinkMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinTabIndex"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisableRipple"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinDisabled"])(MatTabLinkMixinBase)));
            /**
             * Base class with all of the `MatTabLink` functionality.
             */
            // tslint:disable-next-line:class-name
            var _MatTabLinkBase = /** @class */ (function (_super_1) {
                __extends(_MatTabLinkBase, _super_1);
                /**
                 * @param {?} _tabNavBar
                 * @param {?} elementRef
                 * @param {?} globalRippleOptions
                 * @param {?} tabIndex
                 * @param {?} _focusMonitor
                 * @param {?=} animationMode
                 */
                function _MatTabLinkBase(_tabNavBar, elementRef, globalRippleOptions, tabIndex, _focusMonitor, animationMode) {
                    var _this = _super_1.call(this) || this;
                    _this._tabNavBar = _tabNavBar;
                    _this.elementRef = elementRef;
                    _this._focusMonitor = _focusMonitor;
                    /**
                     * Whether the tab link is active or not.
                     */
                    _this._isActive = false;
                    _this.rippleConfig = globalRippleOptions || {};
                    _this.tabIndex = parseInt(tabIndex) || 0;
                    if (animationMode === 'NoopAnimations') {
                        _this.rippleConfig.animation = { enterDuration: 0, exitDuration: 0 };
                    }
                    _focusMonitor.monitor(elementRef);
                    return _this;
                }
                Object.defineProperty(_MatTabLinkBase.prototype, "active", {
                    /**
                     * Whether the link is active.
                     * @return {?}
                     */
                    get: function () { return this._isActive; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== this._isActive) {
                            this._isActive = value;
                            this._tabNavBar.updateActiveLink(this.elementRef);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(_MatTabLinkBase.prototype, "rippleDisabled", {
                    /**
                     * Whether ripples are disabled on interaction.
                     * \@docs-private
                     * @return {?}
                     */
                    get: function () {
                        return this.disabled || this.disableRipple || this._tabNavBar.disableRipple ||
                            !!this.rippleConfig.disabled;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                _MatTabLinkBase.prototype.focus = function () {
                    this.elementRef.nativeElement.focus();
                };
                /**
                 * @return {?}
                 */
                _MatTabLinkBase.prototype.ngOnDestroy = function () {
                    this._focusMonitor.stopMonitoring(this.elementRef);
                };
                return _MatTabLinkBase;
            }(_MatTabLinkMixinBase));
            _MatTabLinkBase.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            // TODO(crisbeto): this selector can be removed when we update to Angular 9.0.
                            selector: 'do-not-use-abstract-mat-tab-link-base'
                        },] },
            ];
            /** @nocollapse */
            _MatTabLinkBase.ctorParameters = function () { return [
                { type: _MatTabNavBase },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MAT_RIPPLE_GLOBAL_OPTIONS"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['tabindex',] }] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__["FocusMonitor"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            _MatTabLinkBase.propDecorators = {
                active: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            /**
             * Link inside of a `mat-tab-nav-bar`.
             */
            var MatTabLink = /** @class */ (function (_super_1) {
                __extends(MatTabLink, _super_1);
                /**
                 * @param {?} tabNavBar
                 * @param {?} elementRef
                 * @param {?} ngZone
                 * @param {?} platform
                 * @param {?} globalRippleOptions
                 * @param {?} tabIndex
                 * @param {?} focusMonitor
                 * @param {?=} animationMode
                 */
                function MatTabLink(tabNavBar, elementRef, ngZone, platform, globalRippleOptions, tabIndex, focusMonitor, animationMode) {
                    var _this = _super_1.call(this, tabNavBar, elementRef, globalRippleOptions, tabIndex, focusMonitor, animationMode) || this;
                    _this._tabLinkRipple = new _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["RippleRenderer"](_this, ngZone, elementRef, platform);
                    _this._tabLinkRipple.setupTriggerEvents(elementRef.nativeElement);
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatTabLink.prototype.ngOnDestroy = function () {
                    _super_1.prototype.ngOnDestroy.call(this);
                    this._tabLinkRipple._removeTriggerEvents();
                };
                return MatTabLink;
            }(_MatTabLinkBase));
            MatTabLink.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[mat-tab-link], [matTabLink]',
                            exportAs: 'matTabLink',
                            inputs: ['disabled', 'disableRipple', 'tabIndex'],
                            host: {
                                'class': 'mat-tab-link',
                                '[attr.aria-current]': 'active ? "page" : null',
                                '[attr.aria-disabled]': 'disabled',
                                '[attr.tabIndex]': 'tabIndex',
                                '[class.mat-tab-disabled]': 'disabled',
                                '[class.mat-tab-label-active]': 'active',
                            }
                        },] },
            ];
            /** @nocollapse */
            MatTabLink.ctorParameters = function () { return [
                { type: MatTabNav },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_12__["Platform"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MAT_RIPPLE_GLOBAL_OPTIONS"],] }] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Attribute"], args: ['tabindex',] }] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__["FocusMonitor"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_1__["ANIMATION_MODULE_TYPE"],] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatTabsModule = /** @class */ (function () {
                function MatTabsModule() {
                }
                return MatTabsModule;
            }());
            MatTabsModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_14__["CommonModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"],
                                _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_2__["PortalModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatRippleModule"],
                                _angular_cdk_observers__WEBPACK_IMPORTED_MODULE_13__["ObserversModule"],
                                _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_10__["A11yModule"],
                            ],
                            // Don't export all components because some are only to be used internally.
                            exports: [
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"],
                                MatTabGroup,
                                MatTabLabel,
                                MatTab,
                                MatTabNav,
                                MatTabLink,
                                MatTabContent,
                            ],
                            declarations: [
                                MatTabGroup,
                                MatTabLabel,
                                MatTab,
                                MatInkBar,
                                MatTabLabelWrapper,
                                MatTabNav,
                                MatTabLink,
                                MatTabBody,
                                MatTabBodyPortal,
                                MatTabHeader,
                                MatTabContent,
                                ( /** @type {?} */(
                                // TODO(crisbeto): these can be removed once they're turned into selector-less directives.
                                MatPaginatedTabHeader)),
                                ( /** @type {?} */(_MatTabGroupBase)),
                                ( /** @type {?} */(_MatTabNavBase)),
                                ( /** @type {?} */(_MatTabBodyBase)),
                                ( /** @type {?} */(_MatTabHeaderBase)),
                                ( /** @type {?} */(_MatTabLinkBase)),
                            ],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=tabs.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/toolbar.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/toolbar.js ***!
          \***********************************************************/
        /*! exports provided: MatToolbarModule, throwToolbarMixedModesError, MatToolbarRow, MatToolbar */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatToolbarModule", function () { return MatToolbarModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwToolbarMixedModesError", function () { return throwToolbarMixedModesError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatToolbarRow", function () { return MatToolbarRow; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatToolbar", function () { return MatToolbar; });
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // Boilerplate for applying mixins to MatToolbar.
            /**
             * \@docs-private
             */
            var MatToolbarBase = /** @class */ (function () {
                /**
                 * @param {?} _elementRef
                 */
                function MatToolbarBase(_elementRef) {
                    this._elementRef = _elementRef;
                }
                return MatToolbarBase;
            }());
            /** @type {?} */
            var _MatToolbarMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["mixinColor"])(MatToolbarBase);
            var MatToolbarRow = /** @class */ (function () {
                function MatToolbarRow() {
                }
                return MatToolbarRow;
            }());
            MatToolbarRow.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Directive"], args: [{
                            selector: 'mat-toolbar-row',
                            exportAs: 'matToolbarRow',
                            host: { 'class': 'mat-toolbar-row' },
                        },] },
            ];
            var MatToolbar = /** @class */ (function (_super_1) {
                __extends(MatToolbar, _super_1);
                /**
                 * @param {?} elementRef
                 * @param {?} _platform
                 * @param {?=} document
                 */
                function MatToolbar(elementRef, _platform, document) {
                    var _this = _super_1.call(this, elementRef) || this;
                    _this._platform = _platform;
                    // TODO: make the document a required param when doing breaking changes.
                    _this._document = document;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                MatToolbar.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    if (!Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["isDevMode"])() || !this._platform.isBrowser) {
                        return;
                    }
                    this._checkToolbarMixedModes();
                    this._toolbarRows.changes.subscribe(( /**
                     * @return {?}
                     */function () { return _this._checkToolbarMixedModes(); }));
                };
                /**
                 * Throws an exception when developers are attempting to combine the different toolbar row modes.
                 * @private
                 * @return {?}
                 */
                MatToolbar.prototype._checkToolbarMixedModes = function () {
                    var _this = this;
                    if (!this._toolbarRows.length) {
                        return;
                    }
                    // Check if there are any other DOM nodes that can display content but aren't inside of
                    // a <mat-toolbar-row> element.
                    /** @type {?} */
                    var isCombinedUsage = Array.from(this._elementRef.nativeElement.childNodes)
                        .filter(( /**
                 * @param {?} node
                 * @return {?}
                 */function (/**
                 * @param {?} node
                 * @return {?}
                 */ node) { return !(node.classList && node.classList.contains('mat-toolbar-row')); }))
                        .filter(( /**
                 * @param {?} node
                 * @return {?}
                 */function (/**
                 * @param {?} node
                 * @return {?}
                 */ node) { return node.nodeType !== (_this._document ? _this._document.COMMENT_NODE : 8); }))
                        .some(( /**
                 * @param {?} node
                 * @return {?}
                 */function (/**
                 * @param {?} node
                 * @return {?}
                 */ node) { return !!(node.textContent && node.textContent.trim()); }));
                    if (isCombinedUsage) {
                        throwToolbarMixedModesError();
                    }
                };
                return MatToolbar;
            }(_MatToolbarMixinBase));
            MatToolbar.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"], args: [{ selector: 'mat-toolbar',
                            exportAs: 'matToolbar',
                            template: "<ng-content></ng-content><ng-content select=\"mat-toolbar-row\"></ng-content>",
                            styles: ["@media (-ms-high-contrast:active){.mat-toolbar{outline:solid 1px}}.mat-toolbar-row,.mat-toolbar-single-row{display:flex;box-sizing:border-box;padding:0 16px;width:100%;flex-direction:row;align-items:center;white-space:nowrap}.mat-toolbar-multiple-rows{display:flex;box-sizing:border-box;flex-direction:column;width:100%}.mat-toolbar-multiple-rows{min-height:64px}.mat-toolbar-row,.mat-toolbar-single-row{height:64px}@media (max-width:599px){.mat-toolbar-multiple-rows{min-height:56px}.mat-toolbar-row,.mat-toolbar-single-row{height:56px}}"],
                            inputs: ['color'],
                            host: {
                                'class': 'mat-toolbar',
                                '[class.mat-toolbar-multiple-rows]': '_toolbarRows.length > 0',
                                '[class.mat-toolbar-single-row]': '_toolbarRows.length === 0',
                            },
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectionStrategy"].OnPush,
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewEncapsulation"].None,
                        },] },
            ];
            /** @nocollapse */
            MatToolbar.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_0__["Platform"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_1__["DOCUMENT"],] }] }
            ]; };
            MatToolbar.propDecorators = {
                _toolbarRows: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ContentChildren"], args: [MatToolbarRow,] }]
            };
            /**
             * Throws an exception when attempting to combine the different toolbar row modes.
             * \@docs-private
             * @return {?}
             */
            function throwToolbarMixedModesError() {
                throw Error('MatToolbar: Attempting to combine different toolbar modes. ' +
                    'Either specify multiple `<mat-toolbar-row>` elements explicitly or just place content ' +
                    'inside of a `<mat-toolbar>` for a single row.');
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatToolbarModule = /** @class */ (function () {
                function MatToolbarModule() {
                }
                return MatToolbarModule;
            }());
            MatToolbarModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"], args: [{
                            imports: [_angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"]],
                            exports: [MatToolbar, MatToolbarRow, _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["MatCommonModule"]],
                            declarations: [MatToolbar, MatToolbarRow],
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=toolbar.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/tooltip.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/tooltip.js ***!
          \***********************************************************/
        /*! exports provided: MatTooltipModule, getMatTooltipInvalidPositionError, MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY, MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY, SCROLL_THROTTLE_MS, TOOLTIP_PANEL_CLASS, MAT_TOOLTIP_SCROLL_STRATEGY, MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER, MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltip, TooltipComponent, matTooltipAnimations */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTooltipModule", function () { return MatTooltipModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatTooltipInvalidPositionError", function () { return getMatTooltipInvalidPositionError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY", function () { return MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY", function () { return MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCROLL_THROTTLE_MS", function () { return SCROLL_THROTTLE_MS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOOLTIP_PANEL_CLASS", function () { return TOOLTIP_PANEL_CLASS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_SCROLL_STRATEGY", function () { return MAT_TOOLTIP_SCROLL_STRATEGY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER", function () { return MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAT_TOOLTIP_DEFAULT_OPTIONS", function () { return MAT_TOOLTIP_DEFAULT_OPTIONS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTooltip", function () { return MatTooltip; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TooltipComponent", function () { return TooltipComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matTooltipAnimations", function () { return matTooltipAnimations; });
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/a11y */ "./node_modules/@angular/cdk/esm2015/a11y.js");
            /* harmony import */ var _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/bidi */ "./node_modules/@angular/cdk/esm2015/bidi.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/cdk/keycodes */ "./node_modules/@angular/cdk/esm2015/keycodes.js");
            /* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/layout */ "./node_modules/@angular/cdk/esm2015/layout.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/cdk/platform */ "./node_modules/@angular/cdk/esm2015/platform.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/cdk/scrolling */ "./node_modules/@angular/cdk/esm2015/scrolling.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Animations used by MatTooltip.
             * \@docs-private
             * @type {?}
             */
            var matTooltipAnimations = {
                /**
                 * Animation that transitions a tooltip in and out.
                 */
                tooltipState: Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["trigger"])('state', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('initial, void, hidden', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0, transform: 'scale(0)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["state"])('visible', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ transform: 'scale(1)' })),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => visible', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('200ms cubic-bezier(0, 0, 0.2, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["keyframes"])([
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0, transform: 'scale(0)', offset: 0 }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0.5, transform: 'scale(0.99)', offset: 0.5 }),
                        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 1, transform: 'scale(1)', offset: 1 })
                    ]))),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["transition"])('* => hidden', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["animate"])('100ms cubic-bezier(0, 0, 0.2, 1)', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_0__["style"])({ opacity: 0 }))),
                ])
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Time in ms to throttle repositioning after scroll events.
             * @type {?}
             */
            var SCROLL_THROTTLE_MS = 20;
            /**
             * CSS class that will be attached to the overlay panel.
             * @type {?}
             */
            var TOOLTIP_PANEL_CLASS = 'mat-tooltip-panel';
            /**
             * Creates an error to be thrown if the user supplied an invalid tooltip position.
             * \@docs-private
             * @param {?} position
             * @return {?}
             */
            function getMatTooltipInvalidPositionError(position) {
                return Error("Tooltip position \"" + position + "\" is invalid.");
            }
            /**
             * Injection token that determines the scroll handling while a tooltip is visible.
             * @type {?}
             */
            var MAT_TOOLTIP_SCROLL_STRATEGY = new _angular_core__WEBPACK_IMPORTED_MODULE_10__["InjectionToken"]('mat-tooltip-scroll-strategy');
            /**
             * \@docs-private
             * @param {?} overlay
             * @return {?}
             */
            function MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY(overlay) {
                return ( /**
                 * @return {?}
                 */function () { return overlay.scrollStrategies.reposition({ scrollThrottle: SCROLL_THROTTLE_MS }); });
            }
            /**
             * \@docs-private
             * @type {?}
             */
            var MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER = {
                provide: MAT_TOOLTIP_SCROLL_STRATEGY,
                deps: [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["Overlay"]],
                useFactory: MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY,
            };
            /**
             * Injection token to be used to override the default options for `matTooltip`.
             * @type {?}
             */
            var MAT_TOOLTIP_DEFAULT_OPTIONS = new _angular_core__WEBPACK_IMPORTED_MODULE_10__["InjectionToken"]('mat-tooltip-default-options', {
                providedIn: 'root',
                factory: MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY
            });
            /**
             * \@docs-private
             * @return {?}
             */
            function MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY() {
                return {
                    showDelay: 0,
                    hideDelay: 0,
                    touchendHideDelay: 1500,
                };
            }
            /**
             * Directive that attaches a material design tooltip to the host element. Animates the showing and
             * hiding of a tooltip provided position (defaults to below the element).
             *
             * https://material.io/design/components/tooltips.html
             */
            var MatTooltip = /** @class */ (function () {
                /**
                 * @param {?} _overlay
                 * @param {?} _elementRef
                 * @param {?} _scrollDispatcher
                 * @param {?} _viewContainerRef
                 * @param {?} _ngZone
                 * @param {?} platform
                 * @param {?} _ariaDescriber
                 * @param {?} _focusMonitor
                 * @param {?} scrollStrategy
                 * @param {?} _dir
                 * @param {?} _defaultOptions
                 * @param {?=} hammerLoader
                 */
                function MatTooltip(_overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, platform, _ariaDescriber, _focusMonitor, scrollStrategy, _dir, _defaultOptions, hammerLoader) {
                    var _this = this;
                    this._overlay = _overlay;
                    this._elementRef = _elementRef;
                    this._scrollDispatcher = _scrollDispatcher;
                    this._viewContainerRef = _viewContainerRef;
                    this._ngZone = _ngZone;
                    this._ariaDescriber = _ariaDescriber;
                    this._focusMonitor = _focusMonitor;
                    this._dir = _dir;
                    this._defaultOptions = _defaultOptions;
                    this._position = 'below';
                    this._disabled = false;
                    /**
                     * The default delay in ms before showing the tooltip after show is called
                     */
                    this.showDelay = this._defaultOptions.showDelay;
                    /**
                     * The default delay in ms before hiding the tooltip after hide is called
                     */
                    this.hideDelay = this._defaultOptions.hideDelay;
                    this._message = '';
                    this._manualListeners = new Map();
                    /**
                     * Emits when the component is destroyed.
                     */
                    this._destroyed = new rxjs__WEBPACK_IMPORTED_MODULE_12__["Subject"]();
                    this._scrollStrategy = scrollStrategy;
                    /** @type {?} */
                    var element = _elementRef.nativeElement;
                    /** @type {?} */
                    var hasGestures = typeof window === 'undefined' || (( /** @type {?} */(window))).Hammer || hammerLoader;
                    // The mouse events shouldn't be bound on mobile devices, because they can prevent the
                    // first tap from firing its click event or can cause the tooltip to open for clicks.
                    if (!platform.IOS && !platform.ANDROID) {
                        this._manualListeners
                            .set('mouseenter', ( /**
                     * @return {?}
                     */function () { return _this.show(); }))
                            .set('mouseleave', ( /**
                     * @return {?}
                     */function () { return _this.hide(); }));
                    }
                    else if (!hasGestures) {
                        // If Hammerjs isn't loaded, fall back to showing on `touchstart`, otherwise
                        // there's no way for the user to trigger the tooltip on a touch device.
                        this._manualListeners.set('touchstart', ( /**
                         * @return {?}
                         */function () { return _this.show(); }));
                    }
                    this._manualListeners.forEach(( /**
                     * @param {?} listener
                     * @param {?} event
                     * @return {?}
                     */function (listener, event) { return element.addEventListener(event, listener); }));
                    _focusMonitor.monitor(_elementRef).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @param {?} origin
                     * @return {?}
                     */function (/**
                     * @param {?} origin
                     * @return {?}
                     */ origin) {
                        // Note that the focus monitor runs outside the Angular zone.
                        if (!origin) {
                            _ngZone.run(( /**
                             * @return {?}
                             */function () { return _this.hide(0); }));
                        }
                        else if (origin === 'keyboard') {
                            _ngZone.run(( /**
                             * @return {?}
                             */function () { return _this.show(); }));
                        }
                    }));
                    if (_defaultOptions && _defaultOptions.position) {
                        this.position = _defaultOptions.position;
                    }
                }
                Object.defineProperty(MatTooltip.prototype, "position", {
                    /**
                     * Allows the user to define the position of the tooltip relative to the parent element
                     * @return {?}
                     */
                    get: function () { return this._position; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (value !== this._position) {
                            this._position = value;
                            if (this._overlayRef) {
                                this._updatePosition();
                                if (this._tooltipInstance) {
                                    ( /** @type {?} */(this._tooltipInstance)).show(0);
                                }
                                this._overlayRef.updatePosition();
                            }
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTooltip.prototype, "disabled", {
                    /**
                     * Disables the display of the tooltip.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value);
                        // If tooltip is disabled, hide immediately.
                        if (this._disabled) {
                            this.hide(0);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTooltip.prototype, "message", {
                    /**
                     * The message to be displayed in the tooltip
                     * @return {?}
                     */
                    get: function () { return this._message; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        var _this = this;
                        this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this._message);
                        // If the message is not a string (e.g. number), convert it to a string and trim it.
                        this._message = value != null ? ("" + value).trim() : '';
                        if (!this._message && this._isTooltipVisible()) {
                            this.hide(0);
                        }
                        else {
                            this._updateTooltipMessage();
                            this._ngZone.runOutsideAngular(( /**
                             * @return {?}
                             */function () {
                                // The `AriaDescriber` has some functionality that avoids adding a description if it's the
                                // same as the `aria-label` of an element, however we can't know whether the tooltip trigger
                                // has a data-bound `aria-label` or when it'll be set for the first time. We can avoid the
                                // issue by deferring the description by a tick so Angular has time to set the `aria-label`.
                                Promise.resolve().then(( /**
                                 * @return {?}
                                 */function () {
                                    _this._ariaDescriber.describe(_this._elementRef.nativeElement, _this.message);
                                }));
                            }));
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatTooltip.prototype, "tooltipClass", {
                    /**
                     * Classes to be passed to the tooltip. Supports the same syntax as `ngClass`.
                     * @return {?}
                     */
                    get: function () { return this._tooltipClass; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._tooltipClass = value;
                        if (this._tooltipInstance) {
                            this._setTooltipClass(this._tooltipClass);
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Setup styling-specific things
                 * @return {?}
                 */
                MatTooltip.prototype.ngOnInit = function () {
                    /** @type {?} */
                    var element = this._elementRef.nativeElement;
                    /** @type {?} */
                    var elementStyle = ( /** @type {?} */(element.style));
                    if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                        // When we bind a gesture event on an element (in this case `longpress`), HammerJS
                        // will add some inline styles by default, including `user-select: none`. This is
                        // problematic on iOS and in Safari, because it will prevent users from typing in inputs.
                        // Since `user-select: none` is not needed for the `longpress` event and can cause unexpected
                        // behavior for text fields, we always clear the `user-select` to avoid such issues.
                        elementStyle.webkitUserSelect = elementStyle.userSelect = elementStyle.msUserSelect = '';
                    }
                    // Hammer applies `-webkit-user-drag: none` on all elements by default,
                    // which breaks the native drag&drop. If the consumer explicitly made
                    // the element draggable, clear the `-webkit-user-drag`.
                    if (element.draggable && elementStyle.webkitUserDrag === 'none') {
                        elementStyle.webkitUserDrag = '';
                    }
                };
                /**
                 * Dispose the tooltip when destroyed.
                 * @return {?}
                 */
                MatTooltip.prototype.ngOnDestroy = function () {
                    var _this = this;
                    if (this._overlayRef) {
                        this._overlayRef.dispose();
                        this._tooltipInstance = null;
                    }
                    // Clean up the event listeners set in the constructor
                    this._manualListeners.forEach(( /**
                     * @param {?} listener
                     * @param {?} event
                     * @return {?}
                     */function (listener, event) {
                        _this._elementRef.nativeElement.removeEventListener(event, listener);
                    }));
                    this._manualListeners.clear();
                    this._destroyed.next();
                    this._destroyed.complete();
                    this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this.message);
                    this._focusMonitor.stopMonitoring(this._elementRef);
                };
                /**
                 * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
                 * @param {?=} delay
                 * @return {?}
                 */
                MatTooltip.prototype.show = function (delay) {
                    var _this = this;
                    if (delay === void 0) { delay = this.showDelay; }
                    if (this.disabled || !this.message || (this._isTooltipVisible() &&
                        !( /** @type {?} */(this._tooltipInstance))._showTimeoutId && !( /** @type {?} */(this._tooltipInstance))._hideTimeoutId)) {
                        return;
                    }
                    /** @type {?} */
                    var overlayRef = this._createOverlay();
                    this._detach();
                    this._portal = this._portal || new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_8__["ComponentPortal"](TooltipComponent, this._viewContainerRef);
                    this._tooltipInstance = overlayRef.attach(this._portal).instance;
                    this._tooltipInstance.afterHidden()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () { return _this._detach(); }));
                    this._setTooltipClass(this._tooltipClass);
                    this._updateTooltipMessage();
                    ( /** @type {?} */(this._tooltipInstance)).show(delay);
                };
                /**
                 * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
                 * @param {?=} delay
                 * @return {?}
                 */
                MatTooltip.prototype.hide = function (delay) {
                    if (delay === void 0) { delay = this.hideDelay; }
                    if (this._tooltipInstance) {
                        this._tooltipInstance.hide(delay);
                    }
                };
                /**
                 * Shows/hides the tooltip
                 * @return {?}
                 */
                MatTooltip.prototype.toggle = function () {
                    this._isTooltipVisible() ? this.hide() : this.show();
                };
                /**
                 * Returns true if the tooltip is currently visible to the user
                 * @return {?}
                 */
                MatTooltip.prototype._isTooltipVisible = function () {
                    return !!this._tooltipInstance && this._tooltipInstance.isVisible();
                };
                /**
                 * Handles the keydown events on the host element.
                 * @param {?} e
                 * @return {?}
                 */
                MatTooltip.prototype._handleKeydown = function (e) {
                    if (this._isTooltipVisible() && e.keyCode === _angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["ESCAPE"] && !Object(_angular_cdk_keycodes__WEBPACK_IMPORTED_MODULE_4__["hasModifierKey"])(e)) {
                        e.preventDefault();
                        e.stopPropagation();
                        this.hide(0);
                    }
                };
                /**
                 * Handles the touchend events on the host element.
                 * @return {?}
                 */
                MatTooltip.prototype._handleTouchend = function () {
                    this.hide(this._defaultOptions.touchendHideDelay);
                };
                /**
                 * Create the overlay config and position strategy
                 * @private
                 * @return {?}
                 */
                MatTooltip.prototype._createOverlay = function () {
                    var _this = this;
                    if (this._overlayRef) {
                        return this._overlayRef;
                    }
                    /** @type {?} */
                    var scrollableAncestors = this._scrollDispatcher.getAncestorScrollContainers(this._elementRef);
                    // Create connected position strategy that listens for scroll events to reposition.
                    /** @type {?} */
                    var strategy = this._overlay.position()
                        .flexibleConnectedTo(this._elementRef)
                        .withTransformOriginOn('.mat-tooltip')
                        .withFlexibleDimensions(false)
                        .withViewportMargin(8)
                        .withScrollableContainers(scrollableAncestors);
                    strategy.positionChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroyed)).subscribe(( /**
                     * @param {?} change
                     * @return {?}
                     */function (/**
                     * @param {?} change
                     * @return {?}
                     */ change) {
                        if (_this._tooltipInstance) {
                            if (change.scrollableViewProperties.isOverlayClipped && _this._tooltipInstance.isVisible()) {
                                // After position changes occur and the overlay is clipped by
                                // a parent scrollable then close the tooltip.
                                _this._ngZone.run(( /**
                                 * @return {?}
                                 */function () { return _this.hide(0); }));
                            }
                        }
                    }));
                    this._overlayRef = this._overlay.create({
                        direction: this._dir,
                        positionStrategy: strategy,
                        panelClass: TOOLTIP_PANEL_CLASS,
                        scrollStrategy: this._scrollStrategy()
                    });
                    this._updatePosition();
                    this._overlayRef.detachments()
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroyed))
                        .subscribe(( /**
                 * @return {?}
                 */function () { return _this._detach(); }));
                    return this._overlayRef;
                };
                /**
                 * Detaches the currently-attached tooltip.
                 * @private
                 * @return {?}
                 */
                MatTooltip.prototype._detach = function () {
                    if (this._overlayRef && this._overlayRef.hasAttached()) {
                        this._overlayRef.detach();
                    }
                    this._tooltipInstance = null;
                };
                /**
                 * Updates the position of the current tooltip.
                 * @private
                 * @return {?}
                 */
                MatTooltip.prototype._updatePosition = function () {
                    /** @type {?} */
                    var position = ( /** @type {?} */(( /** @type {?} */(this._overlayRef)).getConfig().positionStrategy));
                    /** @type {?} */
                    var origin = this._getOrigin();
                    /** @type {?} */
                    var overlay = this._getOverlayPosition();
                    position.withPositions([
                        Object.assign({}, origin.main, overlay.main),
                        Object.assign({}, origin.fallback, overlay.fallback)
                    ]);
                };
                /**
                 * Returns the origin position and a fallback position based on the user's position preference.
                 * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
                 * @return {?}
                 */
                MatTooltip.prototype._getOrigin = function () {
                    /** @type {?} */
                    var isLtr = !this._dir || this._dir.value == 'ltr';
                    /** @type {?} */
                    var position = this.position;
                    /** @type {?} */
                    var originPosition;
                    if (position == 'above' || position == 'below') {
                        originPosition = { originX: 'center', originY: position == 'above' ? 'top' : 'bottom' };
                    }
                    else if (position == 'before' ||
                        (position == 'left' && isLtr) ||
                        (position == 'right' && !isLtr)) {
                        originPosition = { originX: 'start', originY: 'center' };
                    }
                    else if (position == 'after' ||
                        (position == 'right' && isLtr) ||
                        (position == 'left' && !isLtr)) {
                        originPosition = { originX: 'end', originY: 'center' };
                    }
                    else {
                        throw getMatTooltipInvalidPositionError(position);
                    }
                    var _c = this._invertPosition(originPosition.originX, originPosition.originY), x = _c.x, y = _c.y;
                    return {
                        main: originPosition,
                        fallback: { originX: x, originY: y }
                    };
                };
                /**
                 * Returns the overlay position and a fallback position based on the user's preference
                 * @return {?}
                 */
                MatTooltip.prototype._getOverlayPosition = function () {
                    /** @type {?} */
                    var isLtr = !this._dir || this._dir.value == 'ltr';
                    /** @type {?} */
                    var position = this.position;
                    /** @type {?} */
                    var overlayPosition;
                    if (position == 'above') {
                        overlayPosition = { overlayX: 'center', overlayY: 'bottom' };
                    }
                    else if (position == 'below') {
                        overlayPosition = { overlayX: 'center', overlayY: 'top' };
                    }
                    else if (position == 'before' ||
                        (position == 'left' && isLtr) ||
                        (position == 'right' && !isLtr)) {
                        overlayPosition = { overlayX: 'end', overlayY: 'center' };
                    }
                    else if (position == 'after' ||
                        (position == 'right' && isLtr) ||
                        (position == 'left' && !isLtr)) {
                        overlayPosition = { overlayX: 'start', overlayY: 'center' };
                    }
                    else {
                        throw getMatTooltipInvalidPositionError(position);
                    }
                    var _c = this._invertPosition(overlayPosition.overlayX, overlayPosition.overlayY), x = _c.x, y = _c.y;
                    return {
                        main: overlayPosition,
                        fallback: { overlayX: x, overlayY: y }
                    };
                };
                /**
                 * Updates the tooltip message and repositions the overlay according to the new message length
                 * @private
                 * @return {?}
                 */
                MatTooltip.prototype._updateTooltipMessage = function () {
                    var _this = this;
                    // Must wait for the message to be painted to the tooltip so that the overlay can properly
                    // calculate the correct positioning based on the size of the text.
                    if (this._tooltipInstance) {
                        this._tooltipInstance.message = this.message;
                        this._tooltipInstance._markForCheck();
                        this._ngZone.onMicrotaskEmpty.asObservable().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_13__["takeUntil"])(this._destroyed)).subscribe(( /**
                         * @return {?}
                         */function () {
                            if (_this._tooltipInstance) {
                                ( /** @type {?} */(_this._overlayRef)).updatePosition();
                            }
                        }));
                    }
                };
                /**
                 * Updates the tooltip class
                 * @private
                 * @param {?} tooltipClass
                 * @return {?}
                 */
                MatTooltip.prototype._setTooltipClass = function (tooltipClass) {
                    if (this._tooltipInstance) {
                        this._tooltipInstance.tooltipClass = tooltipClass;
                        this._tooltipInstance._markForCheck();
                    }
                };
                /**
                 * Inverts an overlay position.
                 * @private
                 * @param {?} x
                 * @param {?} y
                 * @return {?}
                 */
                MatTooltip.prototype._invertPosition = function (x, y) {
                    if (this.position === 'above' || this.position === 'below') {
                        if (y === 'top') {
                            y = 'bottom';
                        }
                        else if (y === 'bottom') {
                            y = 'top';
                        }
                    }
                    else {
                        if (x === 'end') {
                            x = 'start';
                        }
                        else if (x === 'start') {
                            x = 'end';
                        }
                    }
                    return { x: x, y: y };
                };
                return MatTooltip;
            }());
            MatTooltip.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Directive"], args: [{
                            selector: '[matTooltip]',
                            exportAs: 'matTooltip',
                            host: {
                                '(longpress)': 'show()',
                                '(keydown)': '_handleKeydown($event)',
                                '(touchend)': '_handleTouchend()',
                            },
                        },] },
            ];
            /** @nocollapse */
            MatTooltip.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["ElementRef"] },
                { type: _angular_cdk_scrolling__WEBPACK_IMPORTED_MODULE_9__["ScrollDispatcher"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["NgZone"] },
                { type: _angular_cdk_platform__WEBPACK_IMPORTED_MODULE_7__["Platform"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["AriaDescriber"] },
                { type: _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["FocusMonitor"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Inject"], args: [MAT_TOOLTIP_SCROLL_STRATEGY,] }] },
                { type: _angular_cdk_bidi__WEBPACK_IMPORTED_MODULE_2__["Directionality"], decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Optional"] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Inject"], args: [MAT_TOOLTIP_DEFAULT_OPTIONS,] }] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Inject"], args: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_11__["HAMMER_LOADER"],] }] }
            ]; };
            MatTooltip.propDecorators = {
                position: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Input"], args: ['matTooltipPosition',] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Input"], args: ['matTooltipDisabled',] }],
                showDelay: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Input"], args: ['matTooltipShowDelay',] }],
                hideDelay: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Input"], args: ['matTooltipHideDelay',] }],
                message: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Input"], args: ['matTooltip',] }],
                tooltipClass: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Input"], args: ['matTooltipClass',] }]
            };
            /**
             * Internal component that wraps the tooltip's content.
             * \@docs-private
             */
            var TooltipComponent = /** @class */ (function () {
                /**
                 * @param {?} _changeDetectorRef
                 * @param {?} _breakpointObserver
                 */
                function TooltipComponent(_changeDetectorRef, _breakpointObserver) {
                    this._changeDetectorRef = _changeDetectorRef;
                    this._breakpointObserver = _breakpointObserver;
                    /**
                     * Property watched by the animation framework to show or hide the tooltip
                     */
                    this._visibility = 'initial';
                    /**
                     * Whether interactions on the page should close the tooltip
                     */
                    this._closeOnInteraction = false;
                    /**
                     * Subject for notifying that the tooltip has been hidden from the view
                     */
                    this._onHide = new rxjs__WEBPACK_IMPORTED_MODULE_12__["Subject"]();
                    /**
                     * Stream that emits whether the user has a handset-sized display.
                     */
                    this._isHandset = this._breakpointObserver.observe(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_5__["Breakpoints"].Handset);
                }
                /**
                 * Shows the tooltip with an animation originating from the provided origin
                 * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
                 * @return {?}
                 */
                TooltipComponent.prototype.show = function (delay) {
                    var _this = this;
                    // Cancel the delayed hide if it is scheduled
                    if (this._hideTimeoutId) {
                        clearTimeout(this._hideTimeoutId);
                        this._hideTimeoutId = null;
                    }
                    // Body interactions should cancel the tooltip if there is a delay in showing.
                    this._closeOnInteraction = true;
                    this._showTimeoutId = setTimeout(( /**
                     * @return {?}
                     */function () {
                        _this._visibility = 'visible';
                        _this._showTimeoutId = null;
                        // Mark for check so if any parent component has set the
                        // ChangeDetectionStrategy to OnPush it will be checked anyways
                        _this._markForCheck();
                    }), delay);
                };
                /**
                 * Begins the animation to hide the tooltip after the provided delay in ms.
                 * @param {?} delay Amount of milliseconds to delay showing the tooltip.
                 * @return {?}
                 */
                TooltipComponent.prototype.hide = function (delay) {
                    var _this = this;
                    // Cancel the delayed show if it is scheduled
                    if (this._showTimeoutId) {
                        clearTimeout(this._showTimeoutId);
                        this._showTimeoutId = null;
                    }
                    this._hideTimeoutId = setTimeout(( /**
                     * @return {?}
                     */function () {
                        _this._visibility = 'hidden';
                        _this._hideTimeoutId = null;
                        // Mark for check so if any parent component has set the
                        // ChangeDetectionStrategy to OnPush it will be checked anyways
                        _this._markForCheck();
                    }), delay);
                };
                /**
                 * Returns an observable that notifies when the tooltip has been hidden from view.
                 * @return {?}
                 */
                TooltipComponent.prototype.afterHidden = function () {
                    return this._onHide.asObservable();
                };
                /**
                 * Whether the tooltip is being displayed.
                 * @return {?}
                 */
                TooltipComponent.prototype.isVisible = function () {
                    return this._visibility === 'visible';
                };
                /**
                 * @return {?}
                 */
                TooltipComponent.prototype.ngOnDestroy = function () {
                    this._onHide.complete();
                };
                /**
                 * @return {?}
                 */
                TooltipComponent.prototype._animationStart = function () {
                    this._closeOnInteraction = false;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                TooltipComponent.prototype._animationDone = function (event) {
                    /** @type {?} */
                    var toState = ( /** @type {?} */(event.toState));
                    if (toState === 'hidden' && !this.isVisible()) {
                        this._onHide.next();
                    }
                    if (toState === 'visible' || toState === 'hidden') {
                        this._closeOnInteraction = true;
                    }
                };
                /**
                 * Interactions on the HTML body should close the tooltip immediately as defined in the
                 * material design spec.
                 * https://material.io/design/components/tooltips.html#behavior
                 * @return {?}
                 */
                TooltipComponent.prototype._handleBodyInteraction = function () {
                    if (this._closeOnInteraction) {
                        this.hide(0);
                    }
                };
                /**
                 * Marks that the tooltip needs to be checked in the next change detection run.
                 * Mainly used for rendering the initial text before positioning a tooltip, which
                 * can be problematic in components with OnPush change detection.
                 * @return {?}
                 */
                TooltipComponent.prototype._markForCheck = function () {
                    this._changeDetectorRef.markForCheck();
                };
                return TooltipComponent;
            }());
            TooltipComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Component"], args: [{ selector: 'mat-tooltip-component',
                            template: "<div class=\"mat-tooltip\" [ngClass]=\"tooltipClass\" [class.mat-tooltip-handset]=\"(_isHandset | async)?.matches\" [@state]=\"_visibility\" (@state.start)=\"_animationStart()\" (@state.done)=\"_animationDone($event)\">{{message}}</div>",
                            styles: [".mat-tooltip-panel{pointer-events:none!important}.mat-tooltip{color:#fff;border-radius:4px;margin:14px;max-width:250px;padding-left:8px;padding-right:8px;overflow:hidden;text-overflow:ellipsis}@media (-ms-high-contrast:active){.mat-tooltip{outline:solid 1px}}.mat-tooltip-handset{margin:24px;padding-left:16px;padding-right:16px}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_10__["ViewEncapsulation"].None,
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_10__["ChangeDetectionStrategy"].OnPush,
                            animations: [matTooltipAnimations.tooltipState],
                            host: {
                                // Forces the element to have a layout in IE and Edge. This fixes issues where the element
                                // won't be rendered if the animations are disabled or there is no web animations polyfill.
                                '[style.zoom]': '_visibility === "visible" ? 1 : null',
                                '(body:click)': 'this._handleBodyInteraction()',
                                'aria-hidden': 'true',
                            }
                        },] },
            ];
            /** @nocollapse */
            TooltipComponent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["ChangeDetectorRef"] },
                { type: _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_5__["BreakpointObserver"] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var MatTooltipModule = /** @class */ (function () {
                function MatTooltipModule() {
                }
                return MatTooltipModule;
            }());
            MatTooltipModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["NgModule"], args: [{
                            imports: [
                                _angular_cdk_a11y__WEBPACK_IMPORTED_MODULE_1__["A11yModule"],
                                _angular_common__WEBPACK_IMPORTED_MODULE_14__["CommonModule"],
                                _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_6__["OverlayModule"],
                                _angular_material_core__WEBPACK_IMPORTED_MODULE_15__["MatCommonModule"],
                            ],
                            exports: [MatTooltip, TooltipComponent, _angular_material_core__WEBPACK_IMPORTED_MODULE_15__["MatCommonModule"]],
                            declarations: [MatTooltip, TooltipComponent],
                            entryComponents: [TooltipComponent],
                            providers: [
                                MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
                                { provide: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_11__["HAMMER_GESTURE_CONFIG"], useClass: _angular_material_core__WEBPACK_IMPORTED_MODULE_15__["GestureConfig"] },
                            ]
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=tooltip.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/material/esm2015/tree.js": 
        /*!********************************************************!*\
          !*** ./node_modules/@angular/material/esm2015/tree.js ***!
          \********************************************************/
        /*! exports provided: MatTreeNode, MatTreeNodeDef, MatNestedTreeNode, MatTreeNodePadding, MatTree, MatTreeModule, MatTreeNodeToggle, MatTreeNodeOutlet, MatTreeFlattener, MatTreeFlatDataSource, MatTreeNestedDataSource */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeNode", function () { return MatTreeNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodeDef", function () { return MatTreeNodeDef; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatNestedTreeNode", function () { return MatNestedTreeNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodePadding", function () { return MatTreeNodePadding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTree", function () { return MatTree; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeModule", function () { return MatTreeModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodeToggle", function () { return MatTreeNodeToggle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeNodeOutlet", function () { return MatTreeNodeOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeFlattener", function () { return MatTreeFlattener; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeFlatDataSource", function () { return MatTreeFlatDataSource; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatTreeNestedDataSource", function () { return MatTreeNestedDataSource; });
            /* harmony import */ var _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/tree */ "./node_modules/@angular/cdk/esm2015/tree.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
            /* harmony import */ var _angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/coercion */ "./node_modules/@angular/cdk/esm2015/coercion.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _MatTreeNodeMixinBase = Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinTabIndex"])(Object(_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["mixinDisabled"])(_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNode"]));
            /**
             * Wrapper for the CdkTree node with Material design styles.
             * @template T
             */
            var MatTreeNode = /** @class */ (function (_super_1) {
                __extends(MatTreeNode, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _tree
                 * @param {?} tabIndex
                 */
                function MatTreeNode(_elementRef, _tree, tabIndex) {
                    var _this = _super_1.call(this, _elementRef, _tree) || this;
                    _this._elementRef = _elementRef;
                    _this._tree = _tree;
                    _this.role = 'treeitem';
                    _this.tabIndex = Number(tabIndex) || 0;
                    return _this;
                }
                return MatTreeNode;
            }(_MatTreeNodeMixinBase));
            MatTreeNode.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'mat-tree-node',
                            exportAs: 'matTreeNode',
                            inputs: ['disabled', 'tabIndex'],
                            host: {
                                '[attr.aria-expanded]': 'isExpanded',
                                '[attr.aria-level]': 'role === "treeitem" ? level : null',
                                '[attr.role]': 'role',
                                'class': 'mat-tree-node'
                            },
                            providers: [{ provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNode"], useExisting: MatTreeNode }]
                        },] },
            ];
            /** @nocollapse */
            MatTreeNode.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTree"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Attribute"], args: ['tabindex',] }] }
            ]; };
            MatTreeNode.propDecorators = {
                role: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * Wrapper for the CdkTree node definition with Material design styles.
             * @template T
             */
            var MatTreeNodeDef = /** @class */ (function (_super_1) {
                __extends(MatTreeNodeDef, _super_1);
                function MatTreeNodeDef() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatTreeNodeDef;
            }(_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodeDef"]));
            MatTreeNodeDef.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matTreeNodeDef]',
                            inputs: [
                                'when: matTreeNodeDefWhen'
                            ],
                            providers: [{ provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodeDef"], useExisting: MatTreeNodeDef }]
                        },] },
            ];
            MatTreeNodeDef.propDecorators = {
                data: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matTreeNode',] }]
            };
            /**
             * Wrapper for the CdkTree nested node with Material design styles.
             * @template T
             */
            var MatNestedTreeNode = /** @class */ (function (_super_1) {
                __extends(MatNestedTreeNode, _super_1);
                /**
                 * @param {?} _elementRef
                 * @param {?} _tree
                 * @param {?} _differs
                 * @param {?} tabIndex
                 */
                function MatNestedTreeNode(_elementRef, _tree, _differs, tabIndex) {
                    var _this = _super_1.call(this, _elementRef, _tree, _differs) || this;
                    _this._elementRef = _elementRef;
                    _this._tree = _tree;
                    _this._differs = _differs;
                    _this._disabled = false;
                    _this.tabIndex = Number(tabIndex) || 0;
                    return _this;
                }
                Object.defineProperty(MatNestedTreeNode.prototype, "disabled", {
                    /**
                     * Whether the node is disabled.
                     * @return {?}
                     */
                    get: function () { return this._disabled; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._disabled = Object(_angular_cdk_coercion__WEBPACK_IMPORTED_MODULE_3__["coerceBooleanProperty"])(value); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(MatNestedTreeNode.prototype, "tabIndex", {
                    /**
                     * Tabindex for the node.
                     * @return {?}
                     */
                    get: function () { return this.disabled ? -1 : this._tabIndex; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        // If the specified tabIndex value is null or undefined, fall back to the default value.
                        this._tabIndex = value != null ? value : 0;
                    },
                    enumerable: true,
                    configurable: true
                });
                // This is a workaround for https://github.com/angular/angular/issues/23091
                // In aot mode, the lifecycle hooks from parent class are not called.
                // TODO(tinayuangao): Remove when the angular issue #23091 is fixed
                /**
                 * @return {?}
                 */
                MatNestedTreeNode.prototype.ngAfterContentInit = function () {
                    _super_1.prototype.ngAfterContentInit.call(this);
                };
                /**
                 * @return {?}
                 */
                MatNestedTreeNode.prototype.ngOnDestroy = function () {
                    _super_1.prototype.ngOnDestroy.call(this);
                };
                return MatNestedTreeNode;
            }(_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkNestedTreeNode"]));
            MatNestedTreeNode.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: 'mat-nested-tree-node',
                            exportAs: 'matNestedTreeNode',
                            host: {
                                '[attr.aria-expanded]': 'isExpanded',
                                '[attr.role]': 'role',
                                'class': 'mat-nested-tree-node',
                            },
                            providers: [
                                { provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkNestedTreeNode"], useExisting: MatNestedTreeNode },
                                { provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNode"], useExisting: MatNestedTreeNode },
                                { provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CDK_TREE_NODE_OUTLET_NODE"], useExisting: MatNestedTreeNode }
                            ]
                        },] },
            ];
            /** @nocollapse */
            MatNestedTreeNode.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTree"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["IterableDiffers"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Attribute"], args: ['tabindex',] }] }
            ]; };
            MatNestedTreeNode.propDecorators = {
                node: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matNestedTreeNode',] }],
                disabled: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                tabIndex: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Wrapper for the CdkTree padding with Material design styles.
             * @template T
             */
            var MatTreeNodePadding = /** @class */ (function (_super_1) {
                __extends(MatTreeNodePadding, _super_1);
                function MatTreeNodePadding() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatTreeNodePadding;
            }(_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodePadding"]));
            MatTreeNodePadding.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matTreeNodePadding]',
                            providers: [{ provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodePadding"], useExisting: MatTreeNodePadding }]
                        },] },
            ];
            MatTreeNodePadding.propDecorators = {
                level: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matTreeNodePadding',] }],
                indent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matTreeNodePaddingIndent',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Outlet for nested CdkNode. Put `[matTreeNodeOutlet]` on a tag to place children dataNodes
             * inside the outlet.
             */
            var MatTreeNodeOutlet = /** @class */ (function () {
                /**
                 * @param {?} viewContainer
                 * @param {?=} _node
                 */
                function MatTreeNodeOutlet(viewContainer, _node) {
                    this.viewContainer = viewContainer;
                    this._node = _node;
                }
                return MatTreeNodeOutlet;
            }());
            MatTreeNodeOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matTreeNodeOutlet]',
                            providers: [{
                                    provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodeOutlet"],
                                    useExisting: MatTreeNodeOutlet
                                }]
                        },] },
            ];
            /** @nocollapse */
            MatTreeNodeOutlet.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CDK_TREE_NODE_OUTLET_NODE"],] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Wrapper for the CdkTable with Material design styles.
             * @template T
             */
            var MatTree = /** @class */ (function (_super_1) {
                __extends(MatTree, _super_1);
                function MatTree() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return MatTree;
            }(_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTree"]));
            MatTree.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ selector: 'mat-tree',
                            exportAs: 'matTree',
                            template: "<ng-container matTreeNodeOutlet></ng-container>",
                            host: {
                                'class': 'mat-tree',
                                'role': 'tree',
                            },
                            styles: [".mat-tree{display:block}.mat-tree-node{display:flex;align-items:center;min-height:48px;flex:1;overflow:hidden;word-wrap:break-word}.mat-nested-tree-ndoe{border-bottom-width:0}"],
                            encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
                            // See note on CdkTree for explanation on why this uses the default change detection strategy.
                            // tslint:disable-next-line:validate-decorators
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].Default,
                            providers: [{ provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTree"], useExisting: MatTree }]
                        },] },
            ];
            MatTree.propDecorators = {
                _nodeOutlet: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [MatTreeNodeOutlet, { static: true },] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Wrapper for the CdkTree's toggle with Material design styles.
             * @template T
             */
            var MatTreeNodeToggle = /** @class */ (function (_super_1) {
                __extends(MatTreeNodeToggle, _super_1);
                function MatTreeNodeToggle() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this.recursive = false;
                    return _this;
                }
                return MatTreeNodeToggle;
            }(_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodeToggle"]));
            MatTreeNodeToggle.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[matTreeNodeToggle]',
                            providers: [{ provide: _angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeNodeToggle"], useExisting: MatTreeNodeToggle }]
                        },] },
            ];
            MatTreeNodeToggle.propDecorators = {
                recursive: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['matTreeNodeToggleRecursive',] }]
            };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MAT_TREE_DIRECTIVES = [
                MatNestedTreeNode,
                MatTreeNodeDef,
                MatTreeNodePadding,
                MatTreeNodeToggle,
                MatTree,
                MatTreeNode,
                MatTreeNodeOutlet
            ];
            var MatTreeModule = /** @class */ (function () {
                function MatTreeModule() {
                }
                return MatTreeModule;
            }());
            MatTreeModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            imports: [_angular_cdk_tree__WEBPACK_IMPORTED_MODULE_0__["CdkTreeModule"], _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"], _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MatCommonModule"]],
                            exports: MAT_TREE_DIRECTIVES,
                            declarations: MAT_TREE_DIRECTIVES,
                        },] },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Tree flattener to convert a normal type of node to node with children & level information.
             * Transform nested nodes of type `T` to flattened nodes of type `F`.
             *
             * For example, the input data of type `T` is nested, and contains its children data:
             *   SomeNode: {
             *     key: 'Fruits',
             *     children: [
             *       NodeOne: {
             *         key: 'Apple',
             *       },
             *       NodeTwo: {
             *        key: 'Pear',
             *      }
             *    ]
             *  }
             *  After flattener flatten the tree, the structure will become
             *  SomeNode: {
             *    key: 'Fruits',
             *    expandable: true,
             *    level: 1
             *  },
             *  NodeOne: {
             *    key: 'Apple',
             *    expandable: false,
             *    level: 2
             *  },
             *  NodeTwo: {
             *   key: 'Pear',
             *   expandable: false,
             *   level: 2
             * }
             * and the output flattened type is `F` with additional information.
             * @template T, F
             */
            var MatTreeFlattener = /** @class */ (function () {
                /**
                 * @param {?} transformFunction
                 * @param {?} getLevel
                 * @param {?} isExpandable
                 * @param {?} getChildren
                 */
                function MatTreeFlattener(transformFunction, getLevel, isExpandable, getChildren) {
                    this.transformFunction = transformFunction;
                    this.getLevel = getLevel;
                    this.isExpandable = isExpandable;
                    this.getChildren = getChildren;
                }
                /**
                 * @param {?} node
                 * @param {?} level
                 * @param {?} resultNodes
                 * @param {?} parentMap
                 * @return {?}
                 */
                MatTreeFlattener.prototype._flattenNode = function (node, level, resultNodes, parentMap) {
                    var _this = this;
                    /** @type {?} */
                    var flatNode = this.transformFunction(node, level);
                    resultNodes.push(flatNode);
                    if (this.isExpandable(flatNode)) {
                        /** @type {?} */
                        var childrenNodes = this.getChildren(node);
                        if (childrenNodes) {
                            if (Array.isArray(childrenNodes)) {
                                this._flattenChildren(childrenNodes, level, resultNodes, parentMap);
                            }
                            else {
                                childrenNodes.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["take"])(1)).subscribe(( /**
                                 * @param {?} children
                                 * @return {?}
                                 */function (/**
                                 * @param {?} children
                                 * @return {?}
                                 */ children) {
                                    _this._flattenChildren(children, level, resultNodes, parentMap);
                                }));
                            }
                        }
                    }
                    return resultNodes;
                };
                /**
                 * @param {?} children
                 * @param {?} level
                 * @param {?} resultNodes
                 * @param {?} parentMap
                 * @return {?}
                 */
                MatTreeFlattener.prototype._flattenChildren = function (children, level, resultNodes, parentMap) {
                    var _this = this;
                    children.forEach(( /**
                     * @param {?} child
                     * @param {?} index
                     * @return {?}
                     */function (child, index) {
                        /** @type {?} */
                        var childParentMap = parentMap.slice();
                        childParentMap.push(index != children.length - 1);
                        _this._flattenNode(child, level + 1, resultNodes, childParentMap);
                    }));
                };
                /**
                 * Flatten a list of node type T to flattened version of node F.
                 * Please note that type T may be nested, and the length of `structuredData` may be different
                 * from that of returned list `F[]`.
                 * @param {?} structuredData
                 * @return {?}
                 */
                MatTreeFlattener.prototype.flattenNodes = function (structuredData) {
                    var _this = this;
                    /** @type {?} */
                    var resultNodes = [];
                    structuredData.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) { return _this._flattenNode(node, 0, resultNodes, []); }));
                    return resultNodes;
                };
                /**
                 * Expand flattened node with current expansion status.
                 * The returned list may have different length.
                 * @param {?} nodes
                 * @param {?} treeControl
                 * @return {?}
                 */
                MatTreeFlattener.prototype.expandFlattenedNodes = function (nodes, treeControl) {
                    var _this = this;
                    /** @type {?} */
                    var results = [];
                    /** @type {?} */
                    var currentExpand = [];
                    currentExpand[0] = true;
                    nodes.forEach(( /**
                     * @param {?} node
                     * @return {?}
                     */function (/**
                     * @param {?} node
                     * @return {?}
                     */ node) {
                        /** @type {?} */
                        var expand = true;
                        for (var i = 0; i <= _this.getLevel(node); i++) {
                            expand = expand && currentExpand[i];
                        }
                        if (expand) {
                            results.push(node);
                        }
                        if (_this.isExpandable(node)) {
                            currentExpand[_this.getLevel(node) + 1] = treeControl.isExpanded(node);
                        }
                    }));
                    return results;
                };
                return MatTreeFlattener;
            }());
            /**
             * Data source for flat tree.
             * The data source need to handle expansion/collapsion of the tree node and change the data feed
             * to `MatTree`.
             * The nested tree nodes of type `T` are flattened through `MatTreeFlattener`, and converted
             * to type `F` for `MatTree` to consume.
             * @template T, F
             */
            var MatTreeFlatDataSource = /** @class */ (function (_super_1) {
                __extends(MatTreeFlatDataSource, _super_1);
                /**
                 * @param {?} _treeControl
                 * @param {?} _treeFlattener
                 * @param {?=} initialData
                 */
                function MatTreeFlatDataSource(_treeControl, _treeFlattener, initialData) {
                    if (initialData === void 0) { initialData = []; }
                    var _this = _super_1.call(this) || this;
                    _this._treeControl = _treeControl;
                    _this._treeFlattener = _treeFlattener;
                    _this._flattenedData = new rxjs__WEBPACK_IMPORTED_MODULE_6__["BehaviorSubject"]([]);
                    _this._expandedData = new rxjs__WEBPACK_IMPORTED_MODULE_6__["BehaviorSubject"]([]);
                    _this._data = new rxjs__WEBPACK_IMPORTED_MODULE_6__["BehaviorSubject"](initialData);
                    return _this;
                }
                Object.defineProperty(MatTreeFlatDataSource.prototype, "data", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._data.value; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._data.next(value);
                        this._flattenedData.next(this._treeFlattener.flattenNodes(this.data));
                        this._treeControl.dataNodes = this._flattenedData.value;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} collectionViewer
                 * @return {?}
                 */
                MatTreeFlatDataSource.prototype.connect = function (collectionViewer) {
                    var _this = this;
                    /** @type {?} */
                    var changes = [
                        collectionViewer.viewChange,
                        this._treeControl.expansionModel.onChange,
                        this._flattenedData
                    ];
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["merge"]).apply(void 0, changes).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])(( /**
                     * @return {?}
                     */function () {
                        _this._expandedData.next(_this._treeFlattener.expandFlattenedNodes(_this._flattenedData.value, _this._treeControl));
                        return _this._expandedData.value;
                    })));
                };
                /**
                 * @return {?}
                 */
                MatTreeFlatDataSource.prototype.disconnect = function () {
                    // no op
                };
                return MatTreeFlatDataSource;
            }(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_5__["DataSource"]));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Data source for nested tree.
             *
             * The data source for nested tree doesn't have to consider node flattener, or the way to expand
             * or collapse. The expansion/collapsion will be handled by TreeControl and each non-leaf node.
             * @template T
             */
            var MatTreeNestedDataSource = /** @class */ (function (_super_1) {
                __extends(MatTreeNestedDataSource, _super_1);
                function MatTreeNestedDataSource() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this._data = new rxjs__WEBPACK_IMPORTED_MODULE_6__["BehaviorSubject"]([]);
                    return _this;
                }
                Object.defineProperty(MatTreeNestedDataSource.prototype, "data", {
                    /**
                     * Data for the nested tree
                     * @return {?}
                     */
                    get: function () { return this._data.value; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._data.next(value); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} collectionViewer
                 * @return {?}
                 */
                MatTreeNestedDataSource.prototype.connect = function (collectionViewer) {
                    var _this = this;
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["merge"]).apply(void 0, [collectionViewer.viewChange, this._data]).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])(( /**
                 * @return {?}
                 */function () {
                        return _this.data;
                    })));
                };
                /**
                 * @return {?}
                 */
                MatTreeNestedDataSource.prototype.disconnect = function () {
                    // no op
                };
                return MatTreeNestedDataSource;
            }(_angular_cdk_collections__WEBPACK_IMPORTED_MODULE_5__["DataSource"]));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=tree.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js": 
        /*!*********************************************************************************************!*\
          !*** ./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js ***!
          \*********************************************************************************************/
        /*! exports provided: ɵangular_packages_platform_browser_dynamic_platform_browser_dynamic_a, VERSION, JitCompilerFactory, RESOURCE_CACHE_PROVIDER, platformBrowserDynamic, ɵCompilerImpl, ɵplatformCoreDynamic, ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS, ɵResourceLoaderImpl */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_dynamic_platform_browser_dynamic_a", function () { return CachedResourceLoader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JitCompilerFactory", function () { return JitCompilerFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESOURCE_CACHE_PROVIDER", function () { return RESOURCE_CACHE_PROVIDER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformBrowserDynamic", function () { return platformBrowserDynamic; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCompilerImpl", function () { return CompilerImpl; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵplatformCoreDynamic", function () { return platformCoreDynamic; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS", function () { return INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵResourceLoaderImpl", function () { return ResourceLoaderImpl; });
            /* harmony import */ var _angular_compiler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/compiler */ "./node_modules/@angular/compiler/fesm2015/compiler.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var MODULE_SUFFIX = '';
            /** @type {?} */
            var builtinExternalReferences = createBuiltinExternalReferencesMap();
            var JitReflector = /** @class */ (function () {
                function JitReflector() {
                    this.reflectionCapabilities = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵReflectionCapabilities"]();
                }
                /**
                 * @param {?} type
                 * @param {?} cmpMetadata
                 * @return {?}
                 */
                JitReflector.prototype.componentModuleUrl = function (type, cmpMetadata) {
                    /** @type {?} */
                    var moduleId = cmpMetadata.moduleId;
                    if (typeof moduleId === 'string') {
                        /** @type {?} */
                        var scheme = Object(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["getUrlScheme"])(moduleId);
                        return scheme ? moduleId : "package:" + moduleId + MODULE_SUFFIX;
                    }
                    else if (moduleId !== null && moduleId !== void 0) {
                        throw Object(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["syntaxError"])("moduleId should be a string in \"" + Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵstringify"])(type) + "\". See https://goo.gl/wIDDiL for more information.\n" +
                            "If you're using Webpack you should inline the template and the styles, see https://goo.gl/X2J8zc.");
                    }
                    return "./" + Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵstringify"])(type);
                };
                /**
                 * @param {?} typeOrFunc
                 * @return {?}
                 */
                JitReflector.prototype.parameters = function (typeOrFunc) {
                    return this.reflectionCapabilities.parameters(typeOrFunc);
                };
                /**
                 * @param {?} typeOrFunc
                 * @return {?}
                 */
                JitReflector.prototype.tryAnnotations = function (typeOrFunc) { return this.annotations(typeOrFunc); };
                /**
                 * @param {?} typeOrFunc
                 * @return {?}
                 */
                JitReflector.prototype.annotations = function (typeOrFunc) {
                    return this.reflectionCapabilities.annotations(typeOrFunc);
                };
                /**
                 * @param {?} typeOrFunc
                 * @return {?}
                 */
                JitReflector.prototype.shallowAnnotations = function (typeOrFunc) {
                    throw new Error('Not supported in JIT mode');
                };
                /**
                 * @param {?} typeOrFunc
                 * @return {?}
                 */
                JitReflector.prototype.propMetadata = function (typeOrFunc) {
                    return this.reflectionCapabilities.propMetadata(typeOrFunc);
                };
                /**
                 * @param {?} type
                 * @param {?} lcProperty
                 * @return {?}
                 */
                JitReflector.prototype.hasLifecycleHook = function (type, lcProperty) {
                    return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
                };
                /**
                 * @param {?} type
                 * @return {?}
                 */
                JitReflector.prototype.guards = function (type) { return this.reflectionCapabilities.guards(type); };
                /**
                 * @param {?} ref
                 * @return {?}
                 */
                JitReflector.prototype.resolveExternalReference = function (ref) {
                    return builtinExternalReferences.get(ref) || ref.runtime;
                };
                return JitReflector;
            }());
            if (false) { }
            /**
             * @return {?}
             */
            function createBuiltinExternalReferencesMap() {
                /** @type {?} */
                var map = new Map();
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ANALYZE_FOR_ENTRY_COMPONENTS, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ANALYZE_FOR_ENTRY_COMPONENTS"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ElementRef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].NgModuleRef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleRef"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ViewContainerRef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ChangeDetectorRef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].Renderer2, _angular_core__WEBPACK_IMPORTED_MODULE_1__["Renderer2"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].QueryList, _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].TemplateRef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["TemplateRef"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].CodegenComponentFactoryResolver, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵCodegenComponentFactoryResolver"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ComponentFactoryResolver, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactoryResolver"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ComponentFactory, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactory"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ComponentRef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentRef"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].NgModuleFactory, _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleFactory"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].createModuleFactory, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵcmf"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].moduleDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵmod"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].moduleProviderDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵmpd"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].RegisterModuleFactoryFn, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵregisterModuleFactory"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].Injector, _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ViewEncapsulation, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ChangeDetectionStrategy, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].SecurityContext, _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].LOCALE_ID, _angular_core__WEBPACK_IMPORTED_MODULE_1__["LOCALE_ID"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].TRANSLATIONS_FORMAT, _angular_core__WEBPACK_IMPORTED_MODULE_1__["TRANSLATIONS_FORMAT"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].inlineInterpolate, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵinlineInterpolate"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].interpolate, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵinterpolate"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].EMPTY_ARRAY, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵEMPTY_ARRAY"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].EMPTY_MAP, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵEMPTY_MAP"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].Renderer, _angular_core__WEBPACK_IMPORTED_MODULE_1__["Renderer"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].viewDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵvid"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].elementDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵeld"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].anchorDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵand"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].textDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵted"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].directiveDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵdid"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].providerDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵprd"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].queryDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵqud"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].pureArrayDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵpad"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].pureObjectDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵpod"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].purePipeDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵppd"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].pipeDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵpid"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].nodeValue, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵnov"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].ngContentDef, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵncd"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].unwrapValue, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵunv"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].createRendererType2, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵcrt"]);
                map.set(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Identifiers"].createComponentFactory, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵccf"]);
                return map;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var ERROR_COLLECTOR_TOKEN = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('ErrorCollector');
            /**
             * A default provider for {\@link PACKAGE_ROOT_URL} that maps to '/'.
             * @type {?}
             */
            var DEFAULT_PACKAGE_URL_PROVIDER = {
                provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["PACKAGE_ROOT_URL"],
                useValue: '/'
            };
            /** @type {?} */
            var _NO_RESOURCE_LOADER = {
                /**
                 * @param {?} url
                 * @return {?}
                 */
                get: function (url) {
                    throw new Error("No ResourceLoader implementation has been provided. Can't read the url \"" + url + "\"");
                }
            };
            /** @type {?} */
            var baseHtmlParser = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('HtmlParser');
            var CompilerImpl = /** @class */ (function () {
                /**
                 * @param {?} injector
                 * @param {?} _metadataResolver
                 * @param {?} templateParser
                 * @param {?} styleCompiler
                 * @param {?} viewCompiler
                 * @param {?} ngModuleCompiler
                 * @param {?} summaryResolver
                 * @param {?} compileReflector
                 * @param {?} jitEvaluator
                 * @param {?} compilerConfig
                 * @param {?} console
                 */
                function CompilerImpl(injector, _metadataResolver, templateParser, styleCompiler, viewCompiler, ngModuleCompiler, summaryResolver, compileReflector, jitEvaluator, compilerConfig, console) {
                    this._metadataResolver = _metadataResolver;
                    this._delegate = new _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["JitCompiler"](_metadataResolver, templateParser, styleCompiler, viewCompiler, ngModuleCompiler, summaryResolver, compileReflector, jitEvaluator, compilerConfig, console, this.getExtraNgModuleProviders.bind(this));
                    this.injector = injector;
                }
                /**
                 * @private
                 * @return {?}
                 */
                CompilerImpl.prototype.getExtraNgModuleProviders = function () {
                    return [this._metadataResolver.getProviderMetadata(new _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ProviderMeta"](_angular_core__WEBPACK_IMPORTED_MODULE_1__["Compiler"], { useValue: this }))];
                };
                /**
                 * @template T
                 * @param {?} moduleType
                 * @return {?}
                 */
                CompilerImpl.prototype.compileModuleSync = function (moduleType) {
                    return ( /** @type {?} */(this._delegate.compileModuleSync(moduleType)));
                };
                /**
                 * @template T
                 * @param {?} moduleType
                 * @return {?}
                 */
                CompilerImpl.prototype.compileModuleAsync = function (moduleType) {
                    return ( /** @type {?} */(this._delegate.compileModuleAsync(moduleType)));
                };
                /**
                 * @template T
                 * @param {?} moduleType
                 * @return {?}
                 */
                CompilerImpl.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
                    /** @type {?} */
                    var result = this._delegate.compileModuleAndAllComponentsSync(moduleType);
                    return {
                        ngModuleFactory: ( /** @type {?} */(result.ngModuleFactory)),
                        componentFactories: ( /** @type {?} */(result.componentFactories)),
                    };
                };
                /**
                 * @template T
                 * @param {?} moduleType
                 * @return {?}
                 */
                CompilerImpl.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
                    return this._delegate.compileModuleAndAllComponentsAsync(moduleType)
                        .then(( /**
                 * @param {?} result
                 * @return {?}
                 */function (result) { return ({
                        ngModuleFactory: ( /** @type {?} */(result.ngModuleFactory)),
                        componentFactories: ( /** @type {?} */(result.componentFactories)),
                    }); }));
                };
                /**
                 * @param {?} summaries
                 * @return {?}
                 */
                CompilerImpl.prototype.loadAotSummaries = function (summaries) { this._delegate.loadAotSummaries(summaries); };
                /**
                 * @param {?} ref
                 * @return {?}
                 */
                CompilerImpl.prototype.hasAotSummary = function (ref) { return this._delegate.hasAotSummary(ref); };
                /**
                 * @template T
                 * @param {?} component
                 * @return {?}
                 */
                CompilerImpl.prototype.getComponentFactory = function (component) {
                    return ( /** @type {?} */(this._delegate.getComponentFactory(component)));
                };
                /**
                 * @return {?}
                 */
                CompilerImpl.prototype.clearCache = function () { this._delegate.clearCache(); };
                /**
                 * @param {?} type
                 * @return {?}
                 */
                CompilerImpl.prototype.clearCacheFor = function (type) { this._delegate.clearCacheFor(type); };
                /**
                 * @param {?} moduleType
                 * @return {?}
                 */
                CompilerImpl.prototype.getModuleId = function (moduleType) {
                    /** @type {?} */
                    var meta = this._metadataResolver.getNgModuleMetadata(moduleType);
                    return meta && meta.id || undefined;
                };
                return CompilerImpl;
            }());
            if (false) { }
            /**
             * A set of providers that provide `JitCompiler` and its dependencies to use for
             * template compilation.
             * @type {?}
             */
            var COMPILER_PROVIDERS = ( /** @type {?} */([
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"], useValue: new JitReflector() },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ResourceLoader"], useValue: _NO_RESOURCE_LOADER },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["JitSummaryResolver"], deps: [] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["SummaryResolver"], useExisting: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["JitSummaryResolver"] },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"], deps: [] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Lexer"], deps: [] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Parser"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Lexer"]] },
                {
                    provide: baseHtmlParser,
                    useClass: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["HtmlParser"],
                    deps: [],
                },
                {
                    provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["I18NHtmlParser"],
                    useFactory: ( /**
                     * @param {?} parser
                     * @param {?} translations
                     * @param {?} format
                     * @param {?} config
                     * @param {?} console
                     * @return {?}
                     */function (parser, translations, format, config, console) {
                        translations = translations || '';
                        /** @type {?} */
                        var missingTranslation = translations ? ( /** @type {?} */(config.missingTranslation)) : _angular_core__WEBPACK_IMPORTED_MODULE_1__["MissingTranslationStrategy"].Ignore;
                        return new _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["I18NHtmlParser"](parser, translations, format, missingTranslation, console);
                    }),
                    deps: [
                        baseHtmlParser,
                        [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"](_angular_core__WEBPACK_IMPORTED_MODULE_1__["TRANSLATIONS"])],
                        [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"](_angular_core__WEBPACK_IMPORTED_MODULE_1__["TRANSLATIONS_FORMAT"])],
                        [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"]],
                        [_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"]],
                    ]
                },
                {
                    provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["HtmlParser"],
                    useExisting: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["I18NHtmlParser"],
                },
                {
                    provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["TemplateParser"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["Parser"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ElementSchemaRegistry"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["I18NHtmlParser"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"]]
                },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["JitEvaluator"], useClass: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["JitEvaluator"], deps: [] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["DirectiveNormalizer"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ResourceLoader"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["UrlResolver"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["HtmlParser"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileMetadataResolver"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["HtmlParser"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["NgModuleResolver"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["DirectiveResolver"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["PipeResolver"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["SummaryResolver"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ElementSchemaRegistry"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["DirectiveNormalizer"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"],
                        [_angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["StaticSymbolCache"]],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"],
                        [_angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"], ERROR_COLLECTOR_TOKEN]] },
                DEFAULT_PACKAGE_URL_PROVIDER,
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["StyleCompiler"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["UrlResolver"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ViewCompiler"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["NgModuleCompiler"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"], useValue: new _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"]() },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Compiler"], useClass: CompilerImpl, deps: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileMetadataResolver"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["TemplateParser"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["StyleCompiler"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ViewCompiler"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["NgModuleCompiler"],
                        _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["SummaryResolver"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["JitEvaluator"], _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"],
                        _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["DomElementSchemaRegistry"], deps: [] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ElementSchemaRegistry"], useExisting: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["DomElementSchemaRegistry"] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["UrlResolver"], deps: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PACKAGE_ROOT_URL"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["DirectiveResolver"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["PipeResolver"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"]] },
                { provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["NgModuleResolver"], deps: [_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompileReflector"]] },
            ]));
            /**
             * \@publicApi
             */
            var JitCompilerFactory = /** @class */ (function () {
                /* @internal */
                /**
                 * @param {?} defaultOptions
                 */
                function JitCompilerFactory(defaultOptions) {
                    /** @type {?} */
                    var compilerOptions = {
                        useJit: true,
                        defaultEncapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].Emulated,
                        missingTranslation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["MissingTranslationStrategy"].Warning,
                    };
                    this._defaultOptions = [compilerOptions].concat(defaultOptions);
                }
                /**
                 * @param {?=} options
                 * @return {?}
                 */
                JitCompilerFactory.prototype.createCompiler = function (options) {
                    if (options === void 0) { options = []; }
                    /** @type {?} */
                    var opts = _mergeOptions(this._defaultOptions.concat(options));
                    /** @type {?} */
                    var injector = _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"].create([
                        COMPILER_PROVIDERS, {
                            provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"],
                            useFactory: ( /**
                             * @return {?}
                             */function () {
                                return new _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["CompilerConfig"]({
                                    // let explicit values from the compiler options overwrite options
                                    // from the app providers
                                    useJit: opts.useJit,
                                    jitDevMode: Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])(),
                                    // let explicit values from the compiler options overwrite options
                                    // from the app providers
                                    defaultEncapsulation: opts.defaultEncapsulation,
                                    missingTranslation: opts.missingTranslation,
                                    preserveWhitespaces: opts.preserveWhitespaces,
                                });
                            }),
                            deps: []
                        },
                        ( /** @type {?} */(opts.providers))
                    ]);
                    return injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Compiler"]);
                };
                return JitCompilerFactory;
            }());
            if (false) { }
            /**
             * @param {?} optionsArr
             * @return {?}
             */
            function _mergeOptions(optionsArr) {
                return {
                    useJit: _lastDefined(optionsArr.map(( /**
                     * @param {?} options
                     * @return {?}
                     */function (/**
                     * @param {?} options
                     * @return {?}
                     */ options) { return options.useJit; }))),
                    defaultEncapsulation: _lastDefined(optionsArr.map(( /**
                     * @param {?} options
                     * @return {?}
                     */function (/**
                     * @param {?} options
                     * @return {?}
                     */ options) { return options.defaultEncapsulation; }))),
                    providers: _mergeArrays(optionsArr.map(( /**
                     * @param {?} options
                     * @return {?}
                     */function (/**
                     * @param {?} options
                     * @return {?}
                     */ options) { return ( /** @type {?} */(options.providers)); }))),
                    missingTranslation: _lastDefined(optionsArr.map(( /**
                     * @param {?} options
                     * @return {?}
                     */function (/**
                     * @param {?} options
                     * @return {?}
                     */ options) { return options.missingTranslation; }))),
                    preserveWhitespaces: _lastDefined(optionsArr.map(( /**
                     * @param {?} options
                     * @return {?}
                     */function (/**
                     * @param {?} options
                     * @return {?}
                     */ options) { return options.preserveWhitespaces; }))),
                };
            }
            /**
             * @template T
             * @param {?} args
             * @return {?}
             */
            function _lastDefined(args) {
                for (var i = args.length - 1; i >= 0; i--) {
                    if (args[i] !== undefined) {
                        return args[i];
                    }
                }
                return undefined;
            }
            /**
             * @param {?} parts
             * @return {?}
             */
            function _mergeArrays(parts) {
                /** @type {?} */
                var result = [];
                parts.forEach(( /**
                 * @param {?} part
                 * @return {?}
                 */function (part) { return part && result.push.apply(result, part); }));
                return result;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0 = {};
            /**
             * A platform that included corePlatform and the compiler.
             *
             * \@publicApi
             * @type {?}
             */
            var platformCoreDynamic = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["createPlatformFactory"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["platformCore"], 'coreDynamic', [
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["COMPILER_OPTIONS"], useValue: ɵ0, multi: true },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["CompilerFactory"], useClass: JitCompilerFactory, deps: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["COMPILER_OPTIONS"]] },
            ]);
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ResourceLoaderImpl = /** @class */ (function (_super_1) {
                __extends(ResourceLoaderImpl, _super_1);
                function ResourceLoaderImpl() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @param {?} url
                 * @return {?}
                 */
                ResourceLoaderImpl.prototype.get = function (url) {
                    /** @type {?} */
                    var resolve;
                    /** @type {?} */
                    var reject;
                    /** @type {?} */
                    var promise = new Promise(( /**
                     * @param {?} res
                     * @param {?} rej
                     * @return {?}
                     */function (res, rej) {
                        resolve = res;
                        reject = rej;
                    }));
                    /** @type {?} */
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', url, true);
                    xhr.responseType = 'text';
                    xhr.onload = ( /**
                     * @return {?}
                     */function () {
                        // responseText is the old-school way of retrieving response (supported by IE8 & 9)
                        // response/responseType properties were introduced in ResourceLoader Level2 spec (supported
                        // by IE10)
                        /** @type {?} */
                        var response = xhr.response || xhr.responseText;
                        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                        /** @type {?} */
                        var status = xhr.status === 1223 ? 204 : xhr.status;
                        // fix status code when it is 0 (0 status is undocumented).
                        // Occurs when accessing file resources or on Android 4.1 stock browser
                        // while retrieving files from application cache.
                        if (status === 0) {
                            status = response ? 200 : 0;
                        }
                        if (200 <= status && status <= 300) {
                            resolve(response);
                        }
                        else {
                            reject("Failed to load " + url);
                        }
                    });
                    xhr.onerror = ( /**
                     * @return {?}
                     */function () { reject("Failed to load " + url); });
                    xhr.send();
                    return promise;
                };
                return ResourceLoaderImpl;
            }(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ResourceLoader"]));
            ResourceLoaderImpl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$1 = { providers: [{ provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ResourceLoader"], useClass: ResourceLoaderImpl, deps: [] }] }, ɵ1 = _angular_common__WEBPACK_IMPORTED_MODULE_2__["ɵPLATFORM_BROWSER_ID"];
            /**
             * \@publicApi
             * @type {?}
             */
            var INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS = [
                _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS"],
                {
                    provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["COMPILER_OPTIONS"],
                    useValue: ɵ0$1,
                    multi: true
                },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"], useValue: ɵ1 },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An implementation of ResourceLoader that uses a template cache to avoid doing an actual
             * ResourceLoader.
             *
             * The template cache needs to be built and loaded into window.$templateCache
             * via a separate mechanism.
             *
             * \@publicApi
             */
            var CachedResourceLoader = /** @class */ (function (_super_1) {
                __extends(CachedResourceLoader, _super_1);
                function CachedResourceLoader() {
                    var _this = _super_1.call(this) || this;
                    _this._cache = (( /** @type {?} */(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]))).$templateCache;
                    if (_this._cache == null) {
                        throw new Error('CachedResourceLoader: Template cache was not found in $templateCache.');
                    }
                    return _this;
                }
                /**
                 * @param {?} url
                 * @return {?}
                 */
                CachedResourceLoader.prototype.get = function (url) {
                    if (this._cache.hasOwnProperty(url)) {
                        return Promise.resolve(this._cache[url]);
                    }
                    else {
                        return ( /** @type {?} */(Promise.reject('CachedResourceLoader: Did not find cached template for ' + url)));
                    }
                };
                return CachedResourceLoader;
            }(_angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ResourceLoader"]));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Version"]('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var RESOURCE_CACHE_PROVIDER = [{ provide: _angular_compiler__WEBPACK_IMPORTED_MODULE_0__["ResourceLoader"], useClass: CachedResourceLoader, deps: [] }];
            /**
             * \@publicApi
             * @type {?}
             */
            var platformBrowserDynamic = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["createPlatformFactory"])(platformCoreDynamic, 'browserDynamic', INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS);
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=platform-browser-dynamic.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/platform-browser/fesm2015/animations.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/@angular/platform-browser/fesm2015/animations.js ***!
          \***********************************************************************/
        /*! exports provided: ɵangular_packages_platform_browser_animations_animations_f, ɵangular_packages_platform_browser_animations_animations_d, ɵangular_packages_platform_browser_animations_animations_e, ɵangular_packages_platform_browser_animations_animations_b, ɵangular_packages_platform_browser_animations_animations_c, ɵangular_packages_platform_browser_animations_animations_a, BrowserAnimationsModule, NoopAnimationsModule, ANIMATION_MODULE_TYPE, ɵBrowserAnimationBuilder, ɵBrowserAnimationFactory, ɵAnimationRenderer, ɵAnimationRendererFactory, ɵInjectableAnimationEngine */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_f", function () { return BaseAnimationRenderer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_d", function () { return BROWSER_ANIMATIONS_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_e", function () { return BROWSER_NOOP_ANIMATIONS_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_b", function () { return instantiateDefaultStyleNormalizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_c", function () { return instantiateRendererFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_a", function () { return instantiateSupportedAnimationDriver; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserAnimationsModule", function () { return BrowserAnimationsModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoopAnimationsModule", function () { return NoopAnimationsModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATION_MODULE_TYPE", function () { return ANIMATION_MODULE_TYPE; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserAnimationBuilder", function () { return BrowserAnimationBuilder; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserAnimationFactory", function () { return BrowserAnimationFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationRenderer", function () { return AnimationRenderer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationRendererFactory", function () { return AnimationRendererFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵInjectableAnimationEngine", function () { return InjectableAnimationEngine; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
            /* harmony import */ var _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/animations/browser */ "./node_modules/@angular/animations/fesm2015/browser.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var BrowserAnimationBuilder = /** @class */ (function (_super_1) {
                __extends(BrowserAnimationBuilder, _super_1);
                /**
                 * @param {?} rootRenderer
                 * @param {?} doc
                 */
                function BrowserAnimationBuilder(rootRenderer, doc) {
                    var _this = _super_1.call(this) || this;
                    _this._nextAnimationId = 0;
                    /** @type {?} */
                    var typeData = ( /** @type {?} */({
                        id: '0',
                        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewEncapsulation"].None,
                        styles: [],
                        data: { animation: [] }
                    }));
                    _this._renderer = ( /** @type {?} */(rootRenderer.createRenderer(doc.body, typeData)));
                    return _this;
                }
                /**
                 * @param {?} animation
                 * @return {?}
                 */
                BrowserAnimationBuilder.prototype.build = function (animation) {
                    /** @type {?} */
                    var id = this._nextAnimationId.toString();
                    this._nextAnimationId++;
                    /** @type {?} */
                    var entry = Array.isArray(animation) ? Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["sequence"])(animation) : animation;
                    issueAnimationCommand(this._renderer, null, id, 'register', [entry]);
                    return new BrowserAnimationFactory(id, this._renderer);
                };
                return BrowserAnimationBuilder;
            }(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["AnimationBuilder"]));
            BrowserAnimationBuilder.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            BrowserAnimationBuilder.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["RendererFactory2"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_4__["DOCUMENT"],] }] }
            ]; };
            if (false) { }
            var BrowserAnimationFactory = /** @class */ (function (_super_1) {
                __extends(BrowserAnimationFactory, _super_1);
                /**
                 * @param {?} _id
                 * @param {?} _renderer
                 */
                function BrowserAnimationFactory(_id, _renderer) {
                    var _this = _super_1.call(this) || this;
                    _this._id = _id;
                    _this._renderer = _renderer;
                    return _this;
                }
                /**
                 * @param {?} element
                 * @param {?=} options
                 * @return {?}
                 */
                BrowserAnimationFactory.prototype.create = function (element, options) {
                    return new RendererAnimationPlayer(this._id, element, options || {}, this._renderer);
                };
                return BrowserAnimationFactory;
            }(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["AnimationFactory"]));
            if (false) { }
            var RendererAnimationPlayer = /** @class */ (function () {
                /**
                 * @param {?} id
                 * @param {?} element
                 * @param {?} options
                 * @param {?} _renderer
                 */
                function RendererAnimationPlayer(id, element, options, _renderer) {
                    this.id = id;
                    this.element = element;
                    this._renderer = _renderer;
                    this.parentPlayer = null;
                    this._started = false;
                    this.totalTime = 0;
                    this._command('create', options);
                }
                /**
                 * @private
                 * @param {?} eventName
                 * @param {?} callback
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype._listen = function (eventName, callback) {
                    return this._renderer.listen(this.element, "@@" + this.id + ":" + eventName, callback);
                };
                /**
                 * @private
                 * @param {?} command
                 * @param {...?} args
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype._command = function (command) {
                    var args = [];
                    for (var _c = 1; _c < arguments.length; _c++) {
                        args[_c - 1] = arguments[_c];
                    }
                    return issueAnimationCommand(this._renderer, this.element, this.id, command, args);
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.onDone = function (fn) { this._listen('done', fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.onStart = function (fn) { this._listen('start', fn); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.onDestroy = function (fn) { this._listen('destroy', fn); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.init = function () { this._command('init'); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.hasStarted = function () { return this._started; };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.play = function () {
                    this._command('play');
                    this._started = true;
                };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.pause = function () { this._command('pause'); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.restart = function () { this._command('restart'); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.finish = function () { this._command('finish'); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.destroy = function () { this._command('destroy'); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.reset = function () { this._command('reset'); };
                /**
                 * @param {?} p
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.setPosition = function (p) { this._command('setPosition', p); };
                /**
                 * @return {?}
                 */
                RendererAnimationPlayer.prototype.getPosition = function () { return 0; };
                return RendererAnimationPlayer;
            }());
            if (false) { }
            /**
             * @param {?} renderer
             * @param {?} element
             * @param {?} id
             * @param {?} command
             * @param {?} args
             * @return {?}
             */
            function issueAnimationCommand(renderer, element, id, command, args) {
                return renderer.setProperty(element, "@@" + id + ":" + command, args);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var ANIMATION_PREFIX = '@';
            /** @type {?} */
            var DISABLE_ANIMATIONS_FLAG = '@.disabled';
            var AnimationRendererFactory = /** @class */ (function () {
                /**
                 * @param {?} delegate
                 * @param {?} engine
                 * @param {?} _zone
                 */
                function AnimationRendererFactory(delegate, engine, _zone) {
                    this.delegate = delegate;
                    this.engine = engine;
                    this._zone = _zone;
                    this._currentId = 0;
                    this._microtaskId = 1;
                    this._animationCallbacksBuffer = [];
                    this._rendererCache = new Map();
                    this._cdRecurDepth = 0;
                    this.promise = Promise.resolve(0);
                    engine.onRemovalComplete = ( /**
                     * @param {?} element
                     * @param {?} delegate
                     * @return {?}
                     */function (element, delegate) {
                        // Note: if an component element has a leave animation, and the component
                        // a host leave animation, the view engine will call `removeChild` for the parent
                        // component renderer as well as for the child component renderer.
                        // Therefore, we need to check if we already removed the element.
                        if (delegate && delegate.parentNode(element)) {
                            delegate.removeChild(element.parentNode, element);
                        }
                    });
                }
                /**
                 * @param {?} hostElement
                 * @param {?} type
                 * @return {?}
                 */
                AnimationRendererFactory.prototype.createRenderer = function (hostElement, type) {
                    var _this = this;
                    /** @type {?} */
                    var EMPTY_NAMESPACE_ID = '';
                    // cache the delegates to find out which cached delegate can
                    // be used by which cached renderer
                    /** @type {?} */
                    var delegate = this.delegate.createRenderer(hostElement, type);
                    if (!hostElement || !type || !type.data || !type.data['animation']) {
                        /** @type {?} */
                        var renderer = this._rendererCache.get(delegate);
                        if (!renderer) {
                            renderer = new BaseAnimationRenderer(EMPTY_NAMESPACE_ID, delegate, this.engine);
                            // only cache this result when the base renderer is used
                            this._rendererCache.set(delegate, renderer);
                        }
                        return renderer;
                    }
                    /** @type {?} */
                    var componentId = type.id;
                    /** @type {?} */
                    var namespaceId = type.id + '-' + this._currentId;
                    this._currentId++;
                    this.engine.register(namespaceId, hostElement);
                    /** @type {?} */
                    var animationTriggers = ( /** @type {?} */(type.data['animation']));
                    animationTriggers.forEach(( /**
                     * @param {?} trigger
                     * @return {?}
                     */function (/**
                     * @param {?} trigger
                     * @return {?}
                     */ trigger) { return _this.engine.registerTrigger(componentId, namespaceId, hostElement, trigger.name, trigger); }));
                    return new AnimationRenderer(this, namespaceId, delegate, this.engine);
                };
                /**
                 * @return {?}
                 */
                AnimationRendererFactory.prototype.begin = function () {
                    this._cdRecurDepth++;
                    if (this.delegate.begin) {
                        this.delegate.begin();
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                AnimationRendererFactory.prototype._scheduleCountTask = function () {
                    var _this = this;
                    // always use promise to schedule microtask instead of use Zone
                    this.promise.then(( /**
                     * @return {?}
                     */function () { _this._microtaskId++; }));
                };
                /**
                 * \@internal
                 * @param {?} count
                 * @param {?} fn
                 * @param {?} data
                 * @return {?}
                 */
                AnimationRendererFactory.prototype.scheduleListenerCallback = function (count, fn, data) {
                    var _this = this;
                    if (count >= 0 && count < this._microtaskId) {
                        this._zone.run(( /**
                         * @return {?}
                         */function () { return fn(data); }));
                        return;
                    }
                    if (this._animationCallbacksBuffer.length == 0) {
                        Promise.resolve(null).then(( /**
                         * @return {?}
                         */function () {
                            _this._zone.run(( /**
                             * @return {?}
                             */function () {
                                _this._animationCallbacksBuffer.forEach(( /**
                                 * @param {?} tuple
                                 * @return {?}
                                 */function (/**
                                 * @param {?} tuple
                                 * @return {?}
                                 */ tuple) {
                                    var fn = tuple[0], data = tuple[1];
                                    fn(data);
                                }));
                                _this._animationCallbacksBuffer = [];
                            }));
                        }));
                    }
                    this._animationCallbacksBuffer.push([fn, data]);
                };
                /**
                 * @return {?}
                 */
                AnimationRendererFactory.prototype.end = function () {
                    var _this = this;
                    this._cdRecurDepth--;
                    // this is to prevent animations from running twice when an inner
                    // component does CD when a parent component instead has inserted it
                    if (this._cdRecurDepth == 0) {
                        this._zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () {
                            _this._scheduleCountTask();
                            _this.engine.flush(_this._microtaskId);
                        }));
                    }
                    if (this.delegate.end) {
                        this.delegate.end();
                    }
                };
                /**
                 * @return {?}
                 */
                AnimationRendererFactory.prototype.whenRenderingDone = function () { return this.engine.whenRenderingDone(); };
                return AnimationRendererFactory;
            }());
            AnimationRendererFactory.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            AnimationRendererFactory.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["RendererFactory2"] },
                { type: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵAnimationEngine"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] }
            ]; };
            if (false) { }
            var BaseAnimationRenderer = /** @class */ (function () {
                /**
                 * @param {?} namespaceId
                 * @param {?} delegate
                 * @param {?} engine
                 */
                function BaseAnimationRenderer(namespaceId, delegate, engine) {
                    this.namespaceId = namespaceId;
                    this.delegate = delegate;
                    this.engine = engine;
                    this.destroyNode = this.delegate.destroyNode ? ( /**
                     * @param {?} n
                     * @return {?}
                     */function (n) { return ( /** @type {?} */(delegate.destroyNode))(n); }) : null;
                }
                Object.defineProperty(BaseAnimationRenderer.prototype, "data", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.delegate.data; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.destroy = function () {
                    this.engine.destroy(this.namespaceId, this.delegate);
                    this.delegate.destroy();
                };
                /**
                 * @param {?} name
                 * @param {?=} namespace
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.createElement = function (name, namespace) {
                    return this.delegate.createElement(name, namespace);
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.createComment = function (value) { return this.delegate.createComment(value); };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.createText = function (value) { return this.delegate.createText(value); };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.appendChild = function (parent, newChild) {
                    this.delegate.appendChild(parent, newChild);
                    this.engine.onInsert(this.namespaceId, newChild, parent, false);
                };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @param {?} refChild
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
                    this.delegate.insertBefore(parent, newChild, refChild);
                    this.engine.onInsert(this.namespaceId, newChild, parent, true);
                };
                /**
                 * @param {?} parent
                 * @param {?} oldChild
                 * @param {?} isHostElement
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.removeChild = function (parent, oldChild, isHostElement) {
                    this.engine.onRemove(this.namespaceId, oldChild, this.delegate, isHostElement);
                };
                /**
                 * @param {?} selectorOrNode
                 * @param {?=} preserveContent
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.selectRootElement = function (selectorOrNode, preserveContent) {
                    return this.delegate.selectRootElement(selectorOrNode, preserveContent);
                };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @param {?=} namespace
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.setAttribute = function (el, name, value, namespace) {
                    this.delegate.setAttribute(el, name, value, namespace);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?=} namespace
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.removeAttribute = function (el, name, namespace) {
                    this.delegate.removeAttribute(el, name, namespace);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.addClass = function (el, name) { this.delegate.addClass(el, name); };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.removeClass = function (el, name) { this.delegate.removeClass(el, name); };
                /**
                 * @param {?} el
                 * @param {?} style
                 * @param {?} value
                 * @param {?=} flags
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.setStyle = function (el, style, value, flags) {
                    this.delegate.setStyle(el, style, value, flags);
                };
                /**
                 * @param {?} el
                 * @param {?} style
                 * @param {?=} flags
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.removeStyle = function (el, style, flags) {
                    this.delegate.removeStyle(el, style, flags);
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.setProperty = function (el, name, value) {
                    if (name.charAt(0) == ANIMATION_PREFIX && name == DISABLE_ANIMATIONS_FLAG) {
                        this.disableAnimations(el, !!value);
                    }
                    else {
                        this.delegate.setProperty(el, name, value);
                    }
                };
                /**
                 * @param {?} node
                 * @param {?} value
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.setValue = function (node, value) { this.delegate.setValue(node, value); };
                /**
                 * @param {?} target
                 * @param {?} eventName
                 * @param {?} callback
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.listen = function (target, eventName, callback) {
                    return this.delegate.listen(target, eventName, callback);
                };
                /**
                 * @protected
                 * @param {?} element
                 * @param {?} value
                 * @return {?}
                 */
                BaseAnimationRenderer.prototype.disableAnimations = function (element, value) {
                    this.engine.disableAnimations(element, value);
                };
                return BaseAnimationRenderer;
            }());
            if (false) { }
            var AnimationRenderer = /** @class */ (function (_super_1) {
                __extends(AnimationRenderer, _super_1);
                /**
                 * @param {?} factory
                 * @param {?} namespaceId
                 * @param {?} delegate
                 * @param {?} engine
                 */
                function AnimationRenderer(factory, namespaceId, delegate, engine) {
                    var _this = _super_1.call(this, namespaceId, delegate, engine) || this;
                    _this.factory = factory;
                    _this.namespaceId = namespaceId;
                    return _this;
                }
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                AnimationRenderer.prototype.setProperty = function (el, name, value) {
                    if (name.charAt(0) == ANIMATION_PREFIX) {
                        if (name.charAt(1) == '.' && name == DISABLE_ANIMATIONS_FLAG) {
                            value = value === undefined ? true : !!value;
                            this.disableAnimations(el, ( /** @type {?} */(value)));
                        }
                        else {
                            this.engine.process(this.namespaceId, el, name.substr(1), value);
                        }
                    }
                    else {
                        this.delegate.setProperty(el, name, value);
                    }
                };
                /**
                 * @param {?} target
                 * @param {?} eventName
                 * @param {?} callback
                 * @return {?}
                 */
                AnimationRenderer.prototype.listen = function (target, eventName, callback) {
                    var _c;
                    var _this = this;
                    if (eventName.charAt(0) == ANIMATION_PREFIX) {
                        /** @type {?} */
                        var element = resolveElementFromTarget(target);
                        /** @type {?} */
                        var name = eventName.substr(1);
                        /** @type {?} */
                        var phase = '';
                        // @listener.phase is for trigger animation callbacks
                        // @@listener is for animation builder callbacks
                        if (name.charAt(0) != ANIMATION_PREFIX) {
                            _c = parseTriggerCallbackName(name), name = _c[0], phase = _c[1];
                        }
                        return this.engine.listen(this.namespaceId, element, name, phase, ( /**
                         * @param {?} event
                         * @return {?}
                         */function (/**
                         * @param {?} event
                         * @return {?}
                         */ event) {
                            /** @type {?} */
                            var countId = (( /** @type {?} */(event)))['_data'] || -1;
                            _this.factory.scheduleListenerCallback(countId, callback, event);
                        }));
                    }
                    return this.delegate.listen(target, eventName, callback);
                };
                return AnimationRenderer;
            }(BaseAnimationRenderer));
            if (false) { }
            /**
             * @param {?} target
             * @return {?}
             */
            function resolveElementFromTarget(target) {
                switch (target) {
                    case 'body':
                        return document.body;
                    case 'document':
                        return document;
                    case 'window':
                        return window;
                    default:
                        return target;
                }
            }
            /**
             * @param {?} triggerName
             * @return {?}
             */
            function parseTriggerCallbackName(triggerName) {
                /** @type {?} */
                var dotIndex = triggerName.indexOf('.');
                /** @type {?} */
                var trigger = triggerName.substring(0, dotIndex);
                /** @type {?} */
                var phase = triggerName.substr(dotIndex + 1);
                return [trigger, phase];
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var InjectableAnimationEngine = /** @class */ (function (_super_1) {
                __extends(InjectableAnimationEngine, _super_1);
                /**
                 * @param {?} doc
                 * @param {?} driver
                 * @param {?} normalizer
                 */
                function InjectableAnimationEngine(doc, driver, normalizer) {
                    return _super_1.call(this, doc.body, driver, normalizer) || this;
                }
                return InjectableAnimationEngine;
            }(_angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵAnimationEngine"]));
            InjectableAnimationEngine.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            InjectableAnimationEngine.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_4__["DOCUMENT"],] }] },
                { type: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["AnimationDriver"] },
                { type: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵAnimationStyleNormalizer"] }
            ]; };
            /**
             * @return {?}
             */
            function instantiateSupportedAnimationDriver() {
                return Object(_angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵsupportsWebAnimations"])() ? new _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵWebAnimationsDriver"]() : new _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵCssKeyframesDriver"]();
            }
            /**
             * @return {?}
             */
            function instantiateDefaultStyleNormalizer() {
                return new _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵWebAnimationsStyleNormalizer"]();
            }
            /**
             * @param {?} renderer
             * @param {?} engine
             * @param {?} zone
             * @return {?}
             */
            function instantiateRendererFactory(renderer, engine, zone) {
                return new AnimationRendererFactory(renderer, engine, zone);
            }
            /**
             * \@publicApi
             * @type {?}
             */
            var ANIMATION_MODULE_TYPE = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('AnimationModuleType');
            /** @type {?} */
            var SHARED_ANIMATION_PROVIDERS = [
                { provide: _angular_animations__WEBPACK_IMPORTED_MODULE_2__["AnimationBuilder"], useClass: BrowserAnimationBuilder },
                { provide: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵAnimationStyleNormalizer"], useFactory: instantiateDefaultStyleNormalizer },
                { provide: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵAnimationEngine"], useClass: InjectableAnimationEngine }, {
                    provide: _angular_core__WEBPACK_IMPORTED_MODULE_0__["RendererFactory2"],
                    useFactory: instantiateRendererFactory,
                    deps: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["ɵDomRendererFactory2"], _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵAnimationEngine"], _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"]]
                }
            ];
            /**
             * Separate providers from the actual module so that we can do a local modification in Google3 to
             * include them in the BrowserModule.
             * @type {?}
             */
            var BROWSER_ANIMATIONS_PROVIDERS = [
                { provide: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["AnimationDriver"], useFactory: instantiateSupportedAnimationDriver },
                { provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }
            ].concat(SHARED_ANIMATION_PROVIDERS);
            /**
             * Separate providers from the actual module so that we can do a local modification in Google3 to
             * include them in the BrowserTestingModule.
             * @type {?}
             */
            var BROWSER_NOOP_ANIMATIONS_PROVIDERS = [
                { provide: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["AnimationDriver"], useClass: _angular_animations_browser__WEBPACK_IMPORTED_MODULE_3__["ɵNoopAnimationDriver"] },
                { provide: ANIMATION_MODULE_TYPE, useValue: 'NoopAnimations' }
            ].concat(SHARED_ANIMATION_PROVIDERS);
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Exports `BrowserModule` with additional [dependency-injection providers](guide/glossary#provider)
             * for use with animations. See [Animations](guide/animations).
             * \@publicApi
             */
            var BrowserAnimationsModule = /** @class */ (function () {
                function BrowserAnimationsModule() {
                }
                return BrowserAnimationsModule;
            }());
            BrowserAnimationsModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            exports: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"]],
                            providers: BROWSER_ANIMATIONS_PROVIDERS,
                        },] }
            ];
            /**
             * A null player that must be imported to allow disabling of animations.
             * \@publicApi
             */
            var NoopAnimationsModule = /** @class */ (function () {
                function NoopAnimationsModule() {
                }
                return NoopAnimationsModule;
            }());
            NoopAnimationsModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            exports: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"]],
                            providers: BROWSER_NOOP_ANIMATIONS_PROVIDERS,
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=animations.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/@angular/platform-browser/fesm2015/platform-browser.js ***!
          \*****************************************************************************/
        /*! exports provided: ɵangular_packages_platform_browser_platform_browser_c, ɵangular_packages_platform_browser_platform_browser_b, ɵangular_packages_platform_browser_platform_browser_a, ɵangular_packages_platform_browser_platform_browser_l, ɵangular_packages_platform_browser_platform_browser_d, ɵangular_packages_platform_browser_platform_browser_i, ɵangular_packages_platform_browser_platform_browser_h, ɵangular_packages_platform_browser_platform_browser_e, ɵangular_packages_platform_browser_platform_browser_f, ɵangular_packages_platform_browser_platform_browser_k, ɵangular_packages_platform_browser_platform_browser_j, ɵangular_packages_platform_browser_platform_browser_g, BrowserModule, platformBrowser, Meta, Title, disableDebugTools, enableDebugTools, BrowserTransferStateModule, TransferState, makeStateKey, By, EVENT_MANAGER_PLUGINS, EventManager, HAMMER_GESTURE_CONFIG, HAMMER_LOADER, HammerGestureConfig, DomSanitizer, VERSION, ɵELEMENT_PROBE_PROVIDERS__POST_R3__, ɵBROWSER_SANITIZATION_PROVIDERS, ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS, ɵinitDomAdapter, ɵBrowserDomAdapter, ɵBrowserPlatformLocation, ɵTRANSITION_ID, ɵBrowserGetTestability, ɵescapeHtml, ɵELEMENT_PROBE_PROVIDERS, ɵDomAdapter, ɵgetDOM, ɵsetRootDomAdapter, ɵDomRendererFactory2, ɵNAMESPACE_URIS, ɵflattenStyles, ɵshimContentAttribute, ɵshimHostAttribute, ɵDomEventsPlugin, ɵHammerGesturesPlugin, ɵKeyEventsPlugin, ɵDomSharedStylesHost, ɵSharedStylesHost, ɵDomSanitizerImpl */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_c", function () { return BROWSER_MODULE_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_b", function () { return _document; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_a", function () { return errorHandler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_l", function () { return GenericBrowserDomAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_d", function () { return createMeta; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_i", function () { return SERVER_TRANSITION_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_h", function () { return appInitializerFactory; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_e", function () { return createTitle; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_f", function () { return initTransferState; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_k", function () { return ELEMENT_PROBE_PROVIDERS__PRE_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_j", function () { return _createNgProbe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_platform_browser_g", function () { return EventManagerPlugin; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserModule", function () { return BrowserModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformBrowser", function () { return platformBrowser; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Meta", function () { return Meta; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Title", function () { return Title; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableDebugTools", function () { return disableDebugTools; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDebugTools", function () { return enableDebugTools; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserTransferStateModule", function () { return BrowserTransferStateModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransferState", function () { return TransferState; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStateKey", function () { return makeStateKey; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "By", function () { return By; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_MANAGER_PLUGINS", function () { return EVENT_MANAGER_PLUGINS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventManager", function () { return EventManager; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMMER_GESTURE_CONFIG", function () { return HAMMER_GESTURE_CONFIG; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMMER_LOADER", function () { return HAMMER_LOADER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HammerGestureConfig", function () { return HammerGestureConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomSanitizer", function () { return DomSanitizer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵELEMENT_PROBE_PROVIDERS__POST_R3__", function () { return ELEMENT_PROBE_PROVIDERS__POST_R3__; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBROWSER_SANITIZATION_PROVIDERS", function () { return BROWSER_SANITIZATION_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS", function () { return INTERNAL_BROWSER_PLATFORM_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinitDomAdapter", function () { return initDomAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserDomAdapter", function () { return BrowserDomAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserPlatformLocation", function () { return BrowserPlatformLocation; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵTRANSITION_ID", function () { return TRANSITION_ID; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserGetTestability", function () { return BrowserGetTestability; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵescapeHtml", function () { return escapeHtml; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵELEMENT_PROBE_PROVIDERS", function () { return ELEMENT_PROBE_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomAdapter", function () { return DomAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetDOM", function () { return getDOM; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetRootDomAdapter", function () { return setRootDomAdapter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomRendererFactory2", function () { return DomRendererFactory2; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNAMESPACE_URIS", function () { return NAMESPACE_URIS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵflattenStyles", function () { return flattenStyles; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵshimContentAttribute", function () { return shimContentAttribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵshimHostAttribute", function () { return shimHostAttribute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomEventsPlugin", function () { return DomEventsPlugin; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵHammerGesturesPlugin", function () { return HammerGesturesPlugin; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵKeyEventsPlugin", function () { return KeyEventsPlugin; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomSharedStylesHost", function () { return DomSharedStylesHost; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSharedStylesHost", function () { return SharedStylesHost; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomSanitizerImpl", function () { return DomSanitizerImpl; });
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var _DOM = ( /** @type {?} */(null));
            /**
             * @return {?}
             */
            function getDOM() {
                return _DOM;
            }
            /**
             * @param {?} adapter
             * @return {?}
             */
            function setDOM(adapter) {
                _DOM = adapter;
            }
            /**
             * @param {?} adapter
             * @return {?}
             */
            function setRootDomAdapter(adapter) {
                if (!_DOM) {
                    _DOM = adapter;
                }
            }
            /* tslint:disable:requireParameterType */
            /**
             * Provides DOM operations in an environment-agnostic way.
             *
             * \@security Tread carefully! Interacting with the DOM directly is dangerous and
             * can introduce XSS risks.
             * @abstract
             */
            var DomAdapter = /** @class */ (function () {
                function DomAdapter() {
                    this.resourceLoaderType = ( /** @type {?} */(null));
                }
                Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
                    /**
                     * Maps attribute names to their corresponding property names for cases
                     * where attribute name doesn't match property name.
                     * @return {?}
                     */
                    get: function () { return this._attrToPropMap; },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) { this._attrToPropMap = value; },
                    enumerable: true,
                    configurable: true
                });
                return DomAdapter;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Provides DOM operations in any browser environment.
             *
             * \@security Tread carefully! Interacting with the DOM directly is dangerous and
             * can introduce XSS risks.
             * @abstract
             */
            var GenericBrowserDomAdapter = /** @class */ (function (_super_1) {
                __extends(GenericBrowserDomAdapter, _super_1);
                function GenericBrowserDomAdapter() {
                    var _this = _super_1.call(this) || this;
                    _this._animationPrefix = null;
                    _this._transitionEnd = null;
                    try {
                        /** @type {?} */
                        var element_1 = _this.createElement('div', document);
                        if (_this.getStyle(element_1, 'animationName') != null) {
                            _this._animationPrefix = '';
                        }
                        else {
                            /** @type {?} */
                            var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                            for (var i = 0; i < domPrefixes.length; i++) {
                                if (_this.getStyle(element_1, domPrefixes[i] + 'AnimationName') != null) {
                                    _this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                                    break;
                                }
                            }
                        }
                        /** @type {?} */
                        var transEndEventNames_1 = {
                            WebkitTransition: 'webkitTransitionEnd',
                            MozTransition: 'transitionend',
                            OTransition: 'oTransitionEnd otransitionend',
                            transition: 'transitionend'
                        };
                        Object.keys(transEndEventNames_1).forEach(( /**
                         * @param {?} key
                         * @return {?}
                         */function (key) {
                            if (_this.getStyle(element_1, key) != null) {
                                _this._transitionEnd = transEndEventNames_1[key];
                            }
                        }));
                    }
                    catch (_a) {
                        _this._animationPrefix = null;
                        _this._transitionEnd = null;
                    }
                    return _this;
                }
                /**
                 * @param {?} el
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.getDistributedNodes = function (el) { return (( /** @type {?} */(el))).getDistributedNodes(); };
                /**
                 * @param {?} el
                 * @param {?} baseUrl
                 * @param {?} href
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.resolveAndSetHref = function (el, baseUrl, href) {
                    el.href = href == null ? baseUrl : baseUrl + '/../' + href;
                };
                /**
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.supportsDOMEvents = function () { return true; };
                /**
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = function () {
                    return typeof (( /** @type {?} */(document.body))).createShadowRoot === 'function';
                };
                /**
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.getAnimationPrefix = function () { return this._animationPrefix ? this._animationPrefix : ''; };
                /**
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.getTransitionEnd = function () { return this._transitionEnd ? this._transitionEnd : ''; };
                /**
                 * @return {?}
                 */
                GenericBrowserDomAdapter.prototype.supportsAnimation = function () {
                    return this._animationPrefix != null && this._transitionEnd != null;
                };
                return GenericBrowserDomAdapter;
            }(DomAdapter));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var _attrToPropMap = {
                'class': 'className',
                'innerHtml': 'innerHTML',
                'readonly': 'readOnly',
                'tabindex': 'tabIndex',
            };
            /** @type {?} */
            var DOM_KEY_LOCATION_NUMPAD = 3;
            // Map to convert some key or keyIdentifier values to what will be returned by getEventKey
            /** @type {?} */
            var _keyMap = {
                // The following values are here for cross-browser compatibility and to match the W3C standard
                // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
                '\b': 'Backspace',
                '\t': 'Tab',
                '\x7F': 'Delete',
                '\x1B': 'Escape',
                'Del': 'Delete',
                'Esc': 'Escape',
                'Left': 'ArrowLeft',
                'Right': 'ArrowRight',
                'Up': 'ArrowUp',
                'Down': 'ArrowDown',
                'Menu': 'ContextMenu',
                'Scroll': 'ScrollLock',
                'Win': 'OS'
            };
            // There is a bug in Chrome for numeric keypad keys:
            // https://code.google.com/p/chromium/issues/detail?id=155654
            // 1, 2, 3 ... are reported as A, B, C ...
            /** @type {?} */
            var _chromeNumKeyPadMap = {
                'A': '1',
                'B': '2',
                'C': '3',
                'D': '4',
                'E': '5',
                'F': '6',
                'G': '7',
                'H': '8',
                'I': '9',
                'J': '*',
                'K': '+',
                'M': '-',
                'N': '.',
                'O': '/',
                '\x60': '0',
                '\x90': 'NumLock'
            };
            var ɵ0 = /**
             * @return {?}
             */ function () {
                if (_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['Node']) {
                    return _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['Node'].prototype.contains || ( /**
                     * @this {?}
                     * @param {?} node
                     * @return {?}
                     */function (node) {
                        return !!(this.compareDocumentPosition(node) & 16);
                    });
                }
                return ( /** @type {?} */(undefined));
            };
            /** @type {?} */
            var nodeContains = ((ɵ0))();
            /**
             * A `DomAdapter` powered by full browser DOM APIs.
             *
             * \@security Tread carefully! Interacting with the DOM directly is dangerous and
             * can introduce XSS risks.
             */
            /* tslint:disable:requireParameterType no-console */
            var BrowserDomAdapter = /** @class */ (function (_super_1) {
                __extends(BrowserDomAdapter, _super_1);
                function BrowserDomAdapter() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @param {?} templateHtml
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.parse = function (templateHtml) { throw new Error('parse not implemented'); };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.makeCurrent = function () { setRootDomAdapter(new BrowserDomAdapter()); };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.hasProperty = function (element, name) { return name in element; };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setProperty = function (el, name, value) { (( /** @type {?} */(el)))[name] = value; };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getProperty = function (el, name) { return (( /** @type {?} */(el)))[name]; };
                /**
                 * @param {?} el
                 * @param {?} methodName
                 * @param {?} args
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.invoke = function (el, methodName, args) { (( /** @type {?} */(el)))[methodName].apply((( /** @type {?} */(el))), args); };
                // TODO(tbosch): move this into a separate environment class once we have it
                /**
                 * @param {?} error
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.logError = function (error) {
                    if (window.console) {
                        if (console.error) {
                            console.error(error);
                        }
                        else {
                            console.log(error);
                        }
                    }
                };
                /**
                 * @param {?} error
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.log = function (error) {
                    if (window.console) {
                        window.console.log && window.console.log(error);
                    }
                };
                /**
                 * @param {?} error
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.logGroup = function (error) {
                    if (window.console) {
                        window.console.group && window.console.group(error);
                    }
                };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.logGroupEnd = function () {
                    if (window.console) {
                        window.console.groupEnd && window.console.groupEnd();
                    }
                };
                Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
                    /**
                     * @return {?}
                     */
                    get: function () { return _attrToPropMap; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} nodeA
                 * @param {?} nodeB
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.contains = function (nodeA, nodeB) { return nodeContains.call(nodeA, nodeB); };
                /**
                 * @param {?} el
                 * @param {?} selector
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.querySelector = function (el, selector) { return el.querySelector(selector); };
                /**
                 * @param {?} el
                 * @param {?} selector
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.querySelectorAll = function (el, selector) { return el.querySelectorAll(selector); };
                /**
                 * @param {?} el
                 * @param {?} evt
                 * @param {?} listener
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.on = function (el, evt, listener) { el.addEventListener(evt, listener, false); };
                /**
                 * @param {?} el
                 * @param {?} evt
                 * @param {?} listener
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.onAndCancel = function (el, evt, listener) {
                    el.addEventListener(evt, listener, false);
                    // Needed to follow Dart's subscription semantic, until fix of
                    // https://code.google.com/p/dart/issues/detail?id=17406
                    return ( /**
                     * @return {?}
                     */function () { el.removeEventListener(evt, listener, false); });
                };
                /**
                 * @param {?} el
                 * @param {?} evt
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.dispatchEvent = function (el, evt) { el.dispatchEvent(evt); };
                /**
                 * @param {?} eventType
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createMouseEvent = function (eventType) {
                    /** @type {?} */
                    var evt = this.getDefaultDocument().createEvent('MouseEvent');
                    evt.initEvent(eventType, true, true);
                    return evt;
                };
                /**
                 * @param {?} eventType
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createEvent = function (eventType) {
                    /** @type {?} */
                    var evt = this.getDefaultDocument().createEvent('Event');
                    evt.initEvent(eventType, true, true);
                    return evt;
                };
                /**
                 * @param {?} evt
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.preventDefault = function (evt) {
                    evt.preventDefault();
                    evt.returnValue = false;
                };
                /**
                 * @param {?} evt
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.isPrevented = function (evt) {
                    return evt.defaultPrevented || evt.returnValue != null && !evt.returnValue;
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getInnerHTML = function (el) { return el.innerHTML; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getTemplateContent = function (el) {
                    return 'content' in el && this.isTemplateElement(el) ? (( /** @type {?} */(el))).content : null;
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getOuterHTML = function (el) { return el.outerHTML; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.nodeName = function (node) { return node.nodeName; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.nodeValue = function (node) { return node.nodeValue; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.type = function (node) { return node.type; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.content = function (node) {
                    if (this.hasProperty(node, 'content')) {
                        return (( /** @type {?} */(node))).content;
                    }
                    else {
                        return node;
                    }
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.firstChild = function (el) { return el.firstChild; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.nextSibling = function (el) { return el.nextSibling; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.parentElement = function (el) { return el.parentNode; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.childNodes = function (el) { return el.childNodes; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.childNodesAsList = function (el) {
                    /** @type {?} */
                    var childNodes = el.childNodes;
                    /** @type {?} */
                    var res = new Array(childNodes.length);
                    for (var i = 0; i < childNodes.length; i++) {
                        res[i] = childNodes[i];
                    }
                    return res;
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.clearNodes = function (el) {
                    while (el.firstChild) {
                        el.removeChild(el.firstChild);
                    }
                };
                /**
                 * @param {?} el
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.appendChild = function (el, node) { el.appendChild(node); };
                /**
                 * @param {?} el
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.removeChild = function (el, node) { el.removeChild(node); };
                /**
                 * @param {?} el
                 * @param {?} newChild
                 * @param {?} oldChild
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.replaceChild = function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.remove = function (node) {
                    if (node.parentNode) {
                        node.parentNode.removeChild(node);
                    }
                    return node;
                };
                /**
                 * @param {?} parent
                 * @param {?} ref
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.insertBefore = function (parent, ref, node) { parent.insertBefore(node, ref); };
                /**
                 * @param {?} parent
                 * @param {?} ref
                 * @param {?} nodes
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.insertAllBefore = function (parent, ref, nodes) {
                    nodes.forEach(( /**
                     * @param {?} n
                     * @return {?}
                     */function (n) { return parent.insertBefore(n, ref); }));
                };
                /**
                 * @param {?} parent
                 * @param {?} ref
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.insertAfter = function (parent, ref, node) { parent.insertBefore(node, ref.nextSibling); };
                /**
                 * @param {?} el
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setInnerHTML = function (el, value) { el.innerHTML = value; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getText = function (el) { return el.textContent; };
                /**
                 * @param {?} el
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setText = function (el, value) { el.textContent = value; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getValue = function (el) { return el.value; };
                /**
                 * @param {?} el
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setValue = function (el, value) { el.value = value; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getChecked = function (el) { return el.checked; };
                /**
                 * @param {?} el
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setChecked = function (el, value) { el.checked = value; };
                /**
                 * @param {?} text
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createComment = function (text) { return this.getDefaultDocument().createComment(text); };
                /**
                 * @param {?} html
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createTemplate = function (html) {
                    /** @type {?} */
                    var t = this.getDefaultDocument().createElement('template');
                    t.innerHTML = html;
                    return t;
                };
                /**
                 * @param {?} tagName
                 * @param {?=} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createElement = function (tagName, doc) {
                    doc = doc || this.getDefaultDocument();
                    return doc.createElement(tagName);
                };
                /**
                 * @param {?} ns
                 * @param {?} tagName
                 * @param {?=} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createElementNS = function (ns, tagName, doc) {
                    doc = doc || this.getDefaultDocument();
                    return doc.createElementNS(ns, tagName);
                };
                /**
                 * @param {?} text
                 * @param {?=} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createTextNode = function (text, doc) {
                    doc = doc || this.getDefaultDocument();
                    return doc.createTextNode(text);
                };
                /**
                 * @param {?} attrName
                 * @param {?} attrValue
                 * @param {?=} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) {
                    doc = doc || this.getDefaultDocument();
                    /** @type {?} */
                    var el = ( /** @type {?} */(doc.createElement('SCRIPT')));
                    el.setAttribute(attrName, attrValue);
                    return el;
                };
                /**
                 * @param {?} css
                 * @param {?=} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createStyleElement = function (css, doc) {
                    doc = doc || this.getDefaultDocument();
                    /** @type {?} */
                    var style = ( /** @type {?} */(doc.createElement('style')));
                    this.appendChild(style, this.createTextNode(css, doc));
                    return style;
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createShadowRoot = function (el) { return (( /** @type {?} */(el))).createShadowRoot(); };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getShadowRoot = function (el) { return (( /** @type {?} */(el))).shadowRoot; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getHost = function (el) { return (( /** @type {?} */(el))).host; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.clone = function (node) { return node.cloneNode(true); };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getElementsByClassName = function (element, name) {
                    return element.getElementsByClassName(name);
                };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getElementsByTagName = function (element, name) {
                    return element.getElementsByTagName(name);
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.classList = function (element) { return Array.prototype.slice.call(element.classList, 0); };
                /**
                 * @param {?} element
                 * @param {?} className
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.addClass = function (element, className) { element.classList.add(className); };
                /**
                 * @param {?} element
                 * @param {?} className
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.removeClass = function (element, className) { element.classList.remove(className); };
                /**
                 * @param {?} element
                 * @param {?} className
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.hasClass = function (element, className) {
                    return element.classList.contains(className);
                };
                /**
                 * @param {?} element
                 * @param {?} styleName
                 * @param {?} styleValue
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setStyle = function (element, styleName, styleValue) {
                    element.style[styleName] = styleValue;
                };
                /**
                 * @param {?} element
                 * @param {?} stylename
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.removeStyle = function (element, stylename) {
                    // IE requires '' instead of null
                    // see https://github.com/angular/angular/issues/7916
                    element.style[stylename] = '';
                };
                /**
                 * @param {?} element
                 * @param {?} stylename
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getStyle = function (element, stylename) { return element.style[stylename]; };
                /**
                 * @param {?} element
                 * @param {?} styleName
                 * @param {?=} styleValue
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.hasStyle = function (element, styleName, styleValue) {
                    /** @type {?} */
                    var value = this.getStyle(element, styleName) || '';
                    return styleValue ? value == styleValue : value.length > 0;
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.tagName = function (element) { return element.tagName; };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.attributeMap = function (element) {
                    /** @type {?} */
                    var res = new Map();
                    /** @type {?} */
                    var elAttrs = element.attributes;
                    for (var i = 0; i < elAttrs.length; i++) {
                        /** @type {?} */
                        var attrib = elAttrs.item(i);
                        res.set(attrib.name, attrib.value);
                    }
                    return res;
                };
                /**
                 * @param {?} element
                 * @param {?} attribute
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.hasAttribute = function (element, attribute) {
                    return element.hasAttribute(attribute);
                };
                /**
                 * @param {?} element
                 * @param {?} ns
                 * @param {?} attribute
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) {
                    return element.hasAttributeNS(ns, attribute);
                };
                /**
                 * @param {?} element
                 * @param {?} attribute
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getAttribute = function (element, attribute) {
                    return element.getAttribute(attribute);
                };
                /**
                 * @param {?} element
                 * @param {?} ns
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getAttributeNS = function (element, ns, name) {
                    return element.getAttributeNS(ns, name);
                };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setAttribute = function (element, name, value) { element.setAttribute(name, value); };
                /**
                 * @param {?} element
                 * @param {?} ns
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setAttributeNS = function (element, ns, name, value) {
                    element.setAttributeNS(ns, name, value);
                };
                /**
                 * @param {?} element
                 * @param {?} attribute
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.removeAttribute = function (element, attribute) { element.removeAttribute(attribute); };
                /**
                 * @param {?} element
                 * @param {?} ns
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.removeAttributeNS = function (element, ns, name) {
                    element.removeAttributeNS(ns, name);
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.templateAwareRoot = function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.createHtmlDocument = function () {
                    return document.implementation.createHTMLDocument('fakeTitle');
                };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getDefaultDocument = function () { return document; };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getBoundingClientRect = function (el) {
                    try {
                        return el.getBoundingClientRect();
                    }
                    catch (_a) {
                        return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
                    }
                };
                /**
                 * @param {?} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getTitle = function (doc) { return doc.title; };
                /**
                 * @param {?} doc
                 * @param {?} newTitle
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setTitle = function (doc, newTitle) { doc.title = newTitle || ''; };
                /**
                 * @param {?} n
                 * @param {?} selector
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.elementMatches = function (n, selector) {
                    if (this.isElementNode(n)) {
                        return n.matches && n.matches(selector) ||
                            n.msMatchesSelector && n.msMatchesSelector(selector) ||
                            n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
                    }
                    return false;
                };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.isTemplateElement = function (el) {
                    return this.isElementNode(el) && el.nodeName === 'TEMPLATE';
                };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.isCommentNode = function (node) { return node.nodeType === Node.COMMENT_NODE; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.hasShadowRoot = function (node) {
                    return node.shadowRoot != null && node instanceof HTMLElement;
                };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.isShadowRoot = function (node) { return node instanceof DocumentFragment; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.importIntoDoc = function (node) { return document.importNode(this.templateAwareRoot(node), true); };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.adoptNode = function (node) { return document.adoptNode(node); };
                /**
                 * @param {?} el
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getHref = function (el) { return ( /** @type {?} */(el.getAttribute('href'))); };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getEventKey = function (event) {
                    /** @type {?} */
                    var key = event.key;
                    if (key == null) {
                        key = event.keyIdentifier;
                        // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
                        // Safari cf
                        // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
                        if (key == null) {
                            return 'Unidentified';
                        }
                        if (key.startsWith('U+')) {
                            key = String.fromCharCode(parseInt(key.substring(2), 16));
                            if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                                // There is a bug in Chrome for numeric keypad keys:
                                // https://code.google.com/p/chromium/issues/detail?id=155654
                                // 1, 2, 3 ... are reported as A, B, C ...
                                key = (( /** @type {?} */(_chromeNumKeyPadMap)))[key];
                            }
                        }
                    }
                    return _keyMap[key] || key;
                };
                /**
                 * @param {?} doc
                 * @param {?} target
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getGlobalEventTarget = function (doc, target) {
                    if (target === 'window') {
                        return window;
                    }
                    if (target === 'document') {
                        return doc;
                    }
                    if (target === 'body') {
                        return doc.body;
                    }
                    return null;
                };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getHistory = function () { return window.history; };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getLocation = function () { return window.location; };
                /**
                 * @param {?} doc
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getBaseHref = function (doc) {
                    /** @type {?} */
                    var href = getBaseElementHref();
                    return href == null ? null : relativePath(href);
                };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.resetBaseElement = function () { baseElement = null; };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getUserAgent = function () { return window.navigator.userAgent; };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setData = function (element, name, value) {
                    this.setAttribute(element, 'data-' + name, value);
                };
                /**
                 * @param {?} element
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getData = function (element, name) {
                    return this.getAttribute(element, 'data-' + name);
                };
                /**
                 * @param {?} element
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getComputedStyle = function (element) { return getComputedStyle(element); };
                // TODO(tbosch): move this into a separate environment class once we have it
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.supportsWebAnimation = function () {
                    return typeof (( /** @type {?} */(Element))).prototype['animate'] === 'function';
                };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.performanceNow = function () {
                    // performance.now() is not available in all browsers, see
                    // http://caniuse.com/#search=performance.now
                    return window.performance && window.performance.now ? window.performance.now() :
                        new Date().getTime();
                };
                /**
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.supportsCookies = function () { return true; };
                /**
                 * @param {?} name
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.getCookie = function (name) { return Object(_angular_common__WEBPACK_IMPORTED_MODULE_0__["ɵparseCookieValue"])(document.cookie, name); };
                /**
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                BrowserDomAdapter.prototype.setCookie = function (name, value) {
                    // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
                    // not clear other cookies.
                    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
                };
                return BrowserDomAdapter;
            }(GenericBrowserDomAdapter));
            /** @type {?} */
            var baseElement = null;
            /**
             * @return {?}
             */
            function getBaseElementHref() {
                if (!baseElement) {
                    baseElement = ( /** @type {?} */(document.querySelector('base')));
                    if (!baseElement) {
                        return null;
                    }
                }
                return baseElement.getAttribute('href');
            }
            // based on urlUtils.js in AngularJS 1
            /** @type {?} */
            var urlParsingNode;
            /**
             * @param {?} url
             * @return {?}
             */
            function relativePath(url) {
                if (!urlParsingNode) {
                    urlParsingNode = document.createElement('a');
                }
                urlParsingNode.setAttribute('href', url);
                return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
                    '/' + urlParsingNode.pathname;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @return {?}
             */
            function supportsState() {
                return !!window.history.pushState;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
             * This class should not be used directly by an application developer. Instead, use
             * {\@link Location}.
             */
            var BrowserPlatformLocation = /** @class */ (function (_super_1) {
                __extends(BrowserPlatformLocation, _super_1);
                /**
                 * @param {?} _doc
                 */
                function BrowserPlatformLocation(_doc) {
                    var _this = _super_1.call(this) || this;
                    _this._doc = _doc;
                    _this._init();
                    return _this;
                }
                // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
                /**
                 * \@internal
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype._init = function () {
                    (( /** @type {?} */(this))).location = getDOM().getLocation();
                    this._history = getDOM().getHistory();
                };
                /**
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.getBaseHrefFromDOM = function () { return ( /** @type {?} */(getDOM().getBaseHref(this._doc))); };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.onPopState = function (fn) {
                    getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('popstate', fn, false);
                };
                /**
                 * @param {?} fn
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.onHashChange = function (fn) {
                    getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('hashchange', fn, false);
                };
                Object.defineProperty(BrowserPlatformLocation.prototype, "href", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.href; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(BrowserPlatformLocation.prototype, "protocol", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.protocol; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(BrowserPlatformLocation.prototype, "hostname", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.hostname; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(BrowserPlatformLocation.prototype, "port", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.port; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.pathname; },
                    /**
                     * @param {?} newPath
                     * @return {?}
                     */
                    set: function (newPath) { this.location.pathname = newPath; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.search; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this.location.hash; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} state
                 * @param {?} title
                 * @param {?} url
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.pushState = function (state, title, url) {
                    if (supportsState()) {
                        this._history.pushState(state, title, url);
                    }
                    else {
                        this.location.hash = url;
                    }
                };
                /**
                 * @param {?} state
                 * @param {?} title
                 * @param {?} url
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.replaceState = function (state, title, url) {
                    if (supportsState()) {
                        this._history.replaceState(state, title, url);
                    }
                    else {
                        this.location.hash = url;
                    }
                };
                /**
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.forward = function () { this._history.forward(); };
                /**
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.back = function () { this._history.back(); };
                /**
                 * @return {?}
                 */
                BrowserPlatformLocation.prototype.getState = function () { return this._history.state; };
                return BrowserPlatformLocation;
            }(_angular_common__WEBPACK_IMPORTED_MODULE_0__["PlatformLocation"]));
            BrowserPlatformLocation.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            BrowserPlatformLocation.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * An id that identifies a particular application being bootstrapped, that should
             * match across the client/server boundary.
             * @type {?}
             */
            var TRANSITION_ID = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('TRANSITION_ID');
            /**
             * @param {?} transitionId
             * @param {?} document
             * @param {?} injector
             * @return {?}
             */
            function appInitializerFactory(transitionId, document, injector) {
                return ( /**
                 * @return {?}
                 */function () {
                    // Wait for all application initializers to be completed before removing the styles set by
                    // the server.
                    injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ApplicationInitStatus"]).donePromise.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var dom = getDOM();
                        /** @type {?} */
                        var styles = Array.prototype.slice.apply(dom.querySelectorAll(document, "style[ng-transition]"));
                        styles.filter(( /**
                         * @param {?} el
                         * @return {?}
                         */function (/**
                         * @param {?} el
                         * @return {?}
                         */ el) { return dom.getAttribute(el, 'ng-transition') === transitionId; }))
                            .forEach(( /**
                     * @param {?} el
                     * @return {?}
                     */function (/**
                     * @param {?} el
                     * @return {?}
                     */ el) { return dom.remove(el); }));
                    }));
                });
            }
            /** @type {?} */
            var SERVER_TRANSITION_PROVIDERS = [
                {
                    provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_INITIALIZER"],
                    useFactory: appInitializerFactory,
                    deps: [TRANSITION_ID, _angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"]],
                    multi: true
                },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var BrowserGetTestability = /** @class */ (function () {
                function BrowserGetTestability() {
                }
                /**
                 * @return {?}
                 */
                BrowserGetTestability.init = function () { Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["setTestabilityGetter"])(new BrowserGetTestability()); };
                /**
                 * @param {?} registry
                 * @return {?}
                 */
                BrowserGetTestability.prototype.addToWindow = function (registry) {
                    _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['getAngularTestability'] = ( /**
                     * @param {?} elem
                     * @param {?=} findInAncestors
                     * @return {?}
                     */function (elem, findInAncestors) {
                        if (findInAncestors === void 0) { findInAncestors = true; }
                        /** @type {?} */
                        var testability = registry.findTestabilityInTree(elem, findInAncestors);
                        if (testability == null) {
                            throw new Error('Could not find testability for element.');
                        }
                        return testability;
                    });
                    _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['getAllAngularTestabilities'] = ( /**
                     * @return {?}
                     */function () { return registry.getAllTestabilities(); });
                    _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['getAllAngularRootElements'] = ( /**
                     * @return {?}
                     */function () { return registry.getAllRootElements(); });
                    /** @type {?} */
                    var whenAllStable = ( /**
                     * @param {?} callback
                     * @return {?}
                     */function (callback /** TODO #9100 */) {
                        /** @type {?} */
                        var testabilities = _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['getAllAngularTestabilities']();
                        /** @type {?} */
                        var count = testabilities.length;
                        /** @type {?} */
                        var didWork = false;
                        /** @type {?} */
                        var decrement = ( /**
                         * @param {?} didWork_
                         * @return {?}
                         */function (didWork_ /** TODO #9100 */) {
                            didWork = didWork || didWork_;
                            count--;
                            if (count == 0) {
                                callback(didWork);
                            }
                        });
                        testabilities.forEach(( /**
                         * @param {?} testability
                         * @return {?}
                         */function (testability /** TODO #9100 */) {
                            testability.whenStable(decrement);
                        }));
                    });
                    if (!_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['frameworkStabilizers']) {
                        _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['frameworkStabilizers'] = [];
                    }
                    _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['frameworkStabilizers'].push(whenAllStable);
                };
                /**
                 * @param {?} registry
                 * @param {?} elem
                 * @param {?} findInAncestors
                 * @return {?}
                 */
                BrowserGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
                    if (elem == null) {
                        return null;
                    }
                    /** @type {?} */
                    var t = registry.getTestability(elem);
                    if (t != null) {
                        return t;
                    }
                    else if (!findInAncestors) {
                        return null;
                    }
                    if (getDOM().isShadowRoot(elem)) {
                        return this.findTestabilityInTree(registry, getDOM().getHost(elem), true);
                    }
                    return this.findTestabilityInTree(registry, getDOM().parentElement(elem), true);
                };
                return BrowserGetTestability;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var CAMEL_CASE_REGEXP = /([A-Z])/g;
            /** @type {?} */
            var DASH_CASE_REGEXP = /-([a-z])/g;
            /**
             * @param {?} input
             * @return {?}
             */
            function camelCaseToDashCase(input) {
                return input.replace(CAMEL_CASE_REGEXP, ( /**
                 * @param {...?} m
                 * @return {?}
                 */function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    return '-' + m[1].toLowerCase();
                }));
            }
            /**
             * @param {?} input
             * @return {?}
             */
            function dashCaseToCamelCase(input) {
                return input.replace(DASH_CASE_REGEXP, ( /**
                 * @param {...?} m
                 * @return {?}
                 */function () {
                    var m = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        m[_c] = arguments[_c];
                    }
                    return m[1].toUpperCase();
                }));
            }
            /**
             * Exports the value under a given `name` in the global property `ng`. For example `ng.probe` if
             * `name` is `'probe'`.
             * @param {?} name Name under which it will be exported. Keep in mind this will be a property of the
             * global `ng` object.
             * @param {?} value The value to export.
             * @return {?}
             */
            function exportNgVar(name, value) {
                if (typeof COMPILED === 'undefined' || !COMPILED) {
                    // Note: we can't export `ng` when using closure enhanced optimization as:
                    // - closure declares globals itself for minified names, which sometimes clobber our `ng` global
                    // - we can't declare a closure extern as the namespace `ng` is already used within Google
                    //   for typings for angularJS (via `goog.provide('ng....')`).
                    /** @type {?} */
                    var ng = _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['ng'] = (( /** @type {?} */(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵglobal"]['ng']))) || {};
                    ng[name] = value;
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$1 = /**
             * @return {?}
             */ function () { return ({
                'ApplicationRef': _angular_core__WEBPACK_IMPORTED_MODULE_1__["ApplicationRef"],
                'NgZone': _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"],
            }); };
            /** @type {?} */
            var CORE_TOKENS = ((ɵ0$1))();
            /** @type {?} */
            var INSPECT_GLOBAL_NAME = 'probe';
            /** @type {?} */
            var CORE_TOKENS_GLOBAL_NAME = 'coreTokens';
            /**
             * Returns a {\@link DebugElement} for the given native DOM element, or
             * null if the given native element does not have an Angular view associated
             * with it.
             * @param {?} element
             * @return {?}
             */
            function inspectNativeElement(element) {
                return Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["getDebugNode"])(element);
            }
            /**
             * @param {?} coreTokens
             * @return {?}
             */
            function _createNgProbe(coreTokens) {
                exportNgVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
                exportNgVar(CORE_TOKENS_GLOBAL_NAME, Object.assign({}, CORE_TOKENS, _ngProbeTokensToMap(coreTokens || [])));
                return ( /**
                 * @return {?}
                 */function () { return inspectNativeElement; });
            }
            /**
             * @param {?} tokens
             * @return {?}
             */
            function _ngProbeTokensToMap(tokens) {
                return tokens.reduce(( /**
                 * @param {?} prev
                 * @param {?} t
                 * @return {?}
                 */function (prev, t) { return (prev[t.name] = t.token, prev); }), {});
            }
            /**
             * In Ivy, we don't support NgProbe because we have our own set of testing utilities
             * with more robust functionality.
             *
             * We shouldn't bring in NgProbe because it prevents DebugNode and friends from
             * tree-shaking properly.
             * @type {?}
             */
            var ELEMENT_PROBE_PROVIDERS__POST_R3__ = [];
            /**
             * Providers which support debugging Angular applications (e.g. via `ng.probe`).
             * @type {?}
             */
            var ELEMENT_PROBE_PROVIDERS__PRE_R3__ = [
                {
                    provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_INITIALIZER"],
                    useFactory: _createNgProbe,
                    deps: [
                        [_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgProbeToken"], new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"]()],
                    ],
                    multi: true,
                },
            ];
            /** @type {?} */
            var ELEMENT_PROBE_PROVIDERS = ELEMENT_PROBE_PROVIDERS__PRE_R3__;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The injection token for the event-manager plug-in service.
             *
             * \@publicApi
             * @type {?}
             */
            var EVENT_MANAGER_PLUGINS = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('EventManagerPlugins');
            /**
             * An injectable service that provides event management for Angular
             * through a browser plug-in.
             *
             * \@publicApi
             */
            var EventManager = /** @class */ (function () {
                /**
                 * Initializes an instance of the event-manager service.
                 * @param {?} plugins
                 * @param {?} _zone
                 */
                function EventManager(plugins, _zone) {
                    var _this = this;
                    this._zone = _zone;
                    this._eventNameToPlugin = new Map();
                    plugins.forEach(( /**
                     * @template THIS
                     * @this {THIS}
                     * @param {?} p
                     * @return {THIS}
                     */function (/**
                     * @template THIS
                     * @this {THIS}
                     * @param {?} p
                     * @return {THIS}
                     */ p) { return p.manager = _this; }));
                    this._plugins = plugins.slice().reverse();
                }
                /**
                 * Registers a handler for a specific element and event.
                 *
                 * @param {?} element The HTML element to receive event notifications.
                 * @param {?} eventName The name of the event to listen for.
                 * @param {?} handler A function to call when the notification occurs. Receives the
                 * event object as an argument.
                 * @return {?} A callback function that can be used to remove the handler.
                 */
                EventManager.prototype.addEventListener = function (element, eventName, handler) {
                    /** @type {?} */
                    var plugin = this._findPluginFor(eventName);
                    return plugin.addEventListener(element, eventName, handler);
                };
                /**
                 * Registers a global handler for an event in a target view.
                 *
                 * @param {?} target A target for global event notifications. One of "window", "document", or "body".
                 * @param {?} eventName The name of the event to listen for.
                 * @param {?} handler A function to call when the notification occurs. Receives the
                 * event object as an argument.
                 * @return {?} A callback function that can be used to remove the handler.
                 */
                EventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
                    /** @type {?} */
                    var plugin = this._findPluginFor(eventName);
                    return plugin.addGlobalEventListener(target, eventName, handler);
                };
                /**
                 * Retrieves the compilation zone in which event listeners are registered.
                 * @return {?}
                 */
                EventManager.prototype.getZone = function () { return this._zone; };
                /**
                 * \@internal
                 * @param {?} eventName
                 * @return {?}
                 */
                EventManager.prototype._findPluginFor = function (eventName) {
                    /** @type {?} */
                    var plugin = this._eventNameToPlugin.get(eventName);
                    if (plugin) {
                        return plugin;
                    }
                    /** @type {?} */
                    var plugins = this._plugins;
                    for (var i = 0; i < plugins.length; i++) {
                        /** @type {?} */
                        var plugin_1 = plugins[i];
                        if (plugin_1.supports(eventName)) {
                            this._eventNameToPlugin.set(eventName, plugin_1);
                            return plugin_1;
                        }
                    }
                    throw new Error("No event manager plugin found for event " + eventName);
                };
                return EventManager;
            }());
            EventManager.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            EventManager.ctorParameters = function () { return [
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [EVENT_MANAGER_PLUGINS,] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
            ]; };
            if (false) { }
            /**
             * @abstract
             */
            var EventManagerPlugin = /** @class */ (function () {
                /**
                 * @param {?} _doc
                 */
                function EventManagerPlugin(_doc) {
                    this._doc = _doc;
                }
                /**
                 * @param {?} element
                 * @param {?} eventName
                 * @param {?} handler
                 * @return {?}
                 */
                EventManagerPlugin.prototype.addGlobalEventListener = function (element, eventName, handler) {
                    /** @type {?} */
                    var target = getDOM().getGlobalEventTarget(this._doc, element);
                    if (!target) {
                        throw new Error("Unsupported event target " + target + " for event " + eventName);
                    }
                    return this.addEventListener(target, eventName, handler);
                };
                return EventManagerPlugin;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var SharedStylesHost = /** @class */ (function () {
                function SharedStylesHost() {
                    /**
                     * \@internal
                     */
                    this._stylesSet = new Set();
                }
                /**
                 * @param {?} styles
                 * @return {?}
                 */
                SharedStylesHost.prototype.addStyles = function (styles) {
                    var _this = this;
                    /** @type {?} */
                    var additions = new Set();
                    styles.forEach(( /**
                     * @param {?} style
                     * @return {?}
                     */function (/**
                     * @param {?} style
                     * @return {?}
                     */ style) {
                        if (!_this._stylesSet.has(style)) {
                            _this._stylesSet.add(style);
                            additions.add(style);
                        }
                    }));
                    this.onStylesAdded(additions);
                };
                /**
                 * @param {?} additions
                 * @return {?}
                 */
                SharedStylesHost.prototype.onStylesAdded = function (additions) { };
                /**
                 * @return {?}
                 */
                SharedStylesHost.prototype.getAllStyles = function () { return Array.from(this._stylesSet); };
                return SharedStylesHost;
            }());
            SharedStylesHost.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            if (false) { }
            var DomSharedStylesHost = /** @class */ (function (_super_1) {
                __extends(DomSharedStylesHost, _super_1);
                /**
                 * @param {?} _doc
                 */
                function DomSharedStylesHost(_doc) {
                    var _this = _super_1.call(this) || this;
                    _this._doc = _doc;
                    _this._hostNodes = new Set();
                    _this._styleNodes = new Set();
                    _this._hostNodes.add(_doc.head);
                    return _this;
                }
                /**
                 * @private
                 * @param {?} styles
                 * @param {?} host
                 * @return {?}
                 */
                DomSharedStylesHost.prototype._addStylesToHost = function (styles, host) {
                    var _this = this;
                    styles.forEach(( /**
                     * @param {?} style
                     * @return {?}
                     */function (style) {
                        /** @type {?} */
                        var styleEl = _this._doc.createElement('style');
                        styleEl.textContent = style;
                        _this._styleNodes.add(host.appendChild(styleEl));
                    }));
                };
                /**
                 * @param {?} hostNode
                 * @return {?}
                 */
                DomSharedStylesHost.prototype.addHost = function (hostNode) {
                    this._addStylesToHost(this._stylesSet, hostNode);
                    this._hostNodes.add(hostNode);
                };
                /**
                 * @param {?} hostNode
                 * @return {?}
                 */
                DomSharedStylesHost.prototype.removeHost = function (hostNode) { this._hostNodes.delete(hostNode); };
                /**
                 * @param {?} additions
                 * @return {?}
                 */
                DomSharedStylesHost.prototype.onStylesAdded = function (additions) {
                    var _this = this;
                    this._hostNodes.forEach(( /**
                     * @param {?} hostNode
                     * @return {?}
                     */function (/**
                     * @param {?} hostNode
                     * @return {?}
                     */ hostNode) { return _this._addStylesToHost(additions, hostNode); }));
                };
                /**
                 * @return {?}
                 */
                DomSharedStylesHost.prototype.ngOnDestroy = function () {
                    this._styleNodes.forEach(( /**
                     * @param {?} styleNode
                     * @return {?}
                     */function (/**
                     * @param {?} styleNode
                     * @return {?}
                     */ styleNode) { return getDOM().remove(styleNode); }));
                };
                return DomSharedStylesHost;
            }(SharedStylesHost));
            DomSharedStylesHost.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            DomSharedStylesHost.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var NAMESPACE_URIS = {
                'svg': 'http://www.w3.org/2000/svg',
                'xhtml': 'http://www.w3.org/1999/xhtml',
                'xlink': 'http://www.w3.org/1999/xlink',
                'xml': 'http://www.w3.org/XML/1998/namespace',
                'xmlns': 'http://www.w3.org/2000/xmlns/',
            };
            /** @type {?} */
            var COMPONENT_REGEX = /%COMP%/g;
            /** @type {?} */
            var COMPONENT_VARIABLE = '%COMP%';
            /** @type {?} */
            var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
            /** @type {?} */
            var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
            /**
             * @param {?} componentShortId
             * @return {?}
             */
            function shimContentAttribute(componentShortId) {
                return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
            }
            /**
             * @param {?} componentShortId
             * @return {?}
             */
            function shimHostAttribute(componentShortId) {
                return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
            }
            /**
             * @param {?} compId
             * @param {?} styles
             * @param {?} target
             * @return {?}
             */
            function flattenStyles(compId, styles, target) {
                for (var i = 0; i < styles.length; i++) {
                    /** @type {?} */
                    var style = styles[i];
                    if (Array.isArray(style)) {
                        flattenStyles(compId, style, target);
                    }
                    else {
                        style = style.replace(COMPONENT_REGEX, compId);
                        target.push(style);
                    }
                }
                return target;
            }
            /**
             * @param {?} eventHandler
             * @return {?}
             */
            function decoratePreventDefault(eventHandler) {
                return ( /**
                 * @param {?} event
                 * @return {?}
                 */function (event) {
                    /** @type {?} */
                    var allowDefaultBehavior = eventHandler(event);
                    if (allowDefaultBehavior === false) {
                        // TODO(tbosch): move preventDefault into event plugins...
                        event.preventDefault();
                        event.returnValue = false;
                    }
                });
            }
            var DomRendererFactory2 = /** @class */ (function () {
                /**
                 * @param {?} eventManager
                 * @param {?} sharedStylesHost
                 * @param {?} appId
                 */
                function DomRendererFactory2(eventManager, sharedStylesHost, appId) {
                    this.eventManager = eventManager;
                    this.sharedStylesHost = sharedStylesHost;
                    this.appId = appId;
                    this.rendererByCompId = new Map();
                    this.defaultRenderer = new DefaultDomRenderer2(eventManager);
                }
                /**
                 * @param {?} element
                 * @param {?} type
                 * @return {?}
                 */
                DomRendererFactory2.prototype.createRenderer = function (element, type) {
                    if (!element || !type) {
                        return this.defaultRenderer;
                    }
                    switch (type.encapsulation) {
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].Emulated: {
                            /** @type {?} */
                            var renderer = this.rendererByCompId.get(type.id);
                            if (!renderer) {
                                renderer = new EmulatedEncapsulationDomRenderer2(this.eventManager, this.sharedStylesHost, type, this.appId);
                                this.rendererByCompId.set(type.id, renderer);
                            }
                            (( /** @type {?} */(renderer))).applyToHost(element);
                            return renderer;
                        }
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].Native:
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].ShadowDom:
                            return new ShadowDomRenderer(this.eventManager, this.sharedStylesHost, element, type);
                        default: {
                            if (!this.rendererByCompId.has(type.id)) {
                                /** @type {?} */
                                var styles = flattenStyles(type.id, type.styles, []);
                                this.sharedStylesHost.addStyles(styles);
                                this.rendererByCompId.set(type.id, this.defaultRenderer);
                            }
                            return this.defaultRenderer;
                        }
                    }
                };
                /**
                 * @return {?}
                 */
                DomRendererFactory2.prototype.begin = function () { };
                /**
                 * @return {?}
                 */
                DomRendererFactory2.prototype.end = function () { };
                return DomRendererFactory2;
            }());
            DomRendererFactory2.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            DomRendererFactory2.ctorParameters = function () { return [
                { type: EventManager },
                { type: DomSharedStylesHost },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_ID"],] }] }
            ]; };
            if (false) { }
            var DefaultDomRenderer2 = /** @class */ (function () {
                /**
                 * @param {?} eventManager
                 */
                function DefaultDomRenderer2(eventManager) {
                    this.eventManager = eventManager;
                    this.data = Object.create(null);
                }
                /**
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.destroy = function () { };
                /**
                 * @param {?} name
                 * @param {?=} namespace
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.createElement = function (name, namespace) {
                    if (namespace) {
                        // In cases where Ivy (not ViewEngine) is giving us the actual namespace, the look up by key
                        // will result in undefined, so we just return the namespace here.
                        return document.createElementNS(NAMESPACE_URIS[namespace] || namespace, name);
                    }
                    return document.createElement(name);
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.createComment = function (value) { return document.createComment(value); };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.createText = function (value) { return document.createTextNode(value); };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.appendChild = function (parent, newChild) { parent.appendChild(newChild); };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @param {?} refChild
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
                    if (parent) {
                        parent.insertBefore(newChild, refChild);
                    }
                };
                /**
                 * @param {?} parent
                 * @param {?} oldChild
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.removeChild = function (parent, oldChild) {
                    if (parent) {
                        parent.removeChild(oldChild);
                    }
                };
                /**
                 * @param {?} selectorOrNode
                 * @param {?=} preserveContent
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.selectRootElement = function (selectorOrNode, preserveContent) {
                    /** @type {?} */
                    var el = typeof selectorOrNode === 'string' ? document.querySelector(selectorOrNode) :
                        selectorOrNode;
                    if (!el) {
                        throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
                    }
                    if (!preserveContent) {
                        el.textContent = '';
                    }
                    return el;
                };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.parentNode = function (node) { return node.parentNode; };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.nextSibling = function (node) { return node.nextSibling; };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @param {?=} namespace
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
                    if (namespace) {
                        name = namespace + ':' + name;
                        // TODO(benlesh): Ivy may cause issues here because it's passing around
                        // full URIs for namespaces, therefore this lookup will fail.
                        /** @type {?} */
                        var namespaceUri = NAMESPACE_URIS[namespace];
                        if (namespaceUri) {
                            el.setAttributeNS(namespaceUri, name, value);
                        }
                        else {
                            el.setAttribute(name, value);
                        }
                    }
                    else {
                        el.setAttribute(name, value);
                    }
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?=} namespace
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.removeAttribute = function (el, name, namespace) {
                    if (namespace) {
                        // TODO(benlesh): Ivy may cause issues here because it's passing around
                        // full URIs for namespaces, therefore this lookup will fail.
                        /** @type {?} */
                        var namespaceUri = NAMESPACE_URIS[namespace];
                        if (namespaceUri) {
                            el.removeAttributeNS(namespaceUri, name);
                        }
                        else {
                            // TODO(benlesh): Since ivy is passing around full URIs for namespaces
                            // this could result in properties like `http://www.w3.org/2000/svg:cx="123"`,
                            // which is wrong.
                            el.removeAttribute(namespace + ":" + name);
                        }
                    }
                    else {
                        el.removeAttribute(name);
                    }
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.addClass = function (el, name) { el.classList.add(name); };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.removeClass = function (el, name) { el.classList.remove(name); };
                /**
                 * @param {?} el
                 * @param {?} style
                 * @param {?} value
                 * @param {?} flags
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.setStyle = function (el, style, value, flags) {
                    if (flags & _angular_core__WEBPACK_IMPORTED_MODULE_1__["RendererStyleFlags2"].DashCase) {
                        el.style.setProperty(style, value, !!(flags & _angular_core__WEBPACK_IMPORTED_MODULE_1__["RendererStyleFlags2"].Important) ? 'important' : '');
                    }
                    else {
                        el.style[style] = value;
                    }
                };
                /**
                 * @param {?} el
                 * @param {?} style
                 * @param {?} flags
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.removeStyle = function (el, style, flags) {
                    if (flags & _angular_core__WEBPACK_IMPORTED_MODULE_1__["RendererStyleFlags2"].DashCase) {
                        el.style.removeProperty(style);
                    }
                    else {
                        // IE requires '' instead of null
                        // see https://github.com/angular/angular/issues/7916
                        el.style[style] = '';
                    }
                };
                /**
                 * @param {?} el
                 * @param {?} name
                 * @param {?} value
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.setProperty = function (el, name, value) {
                    checkNoSyntheticProp(name, 'property');
                    el[name] = value;
                };
                /**
                 * @param {?} node
                 * @param {?} value
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.setValue = function (node, value) { node.nodeValue = value; };
                /**
                 * @param {?} target
                 * @param {?} event
                 * @param {?} callback
                 * @return {?}
                 */
                DefaultDomRenderer2.prototype.listen = function (target, event, callback) {
                    checkNoSyntheticProp(event, 'listener');
                    if (typeof target === 'string') {
                        return ( /** @type {?} */(this.eventManager.addGlobalEventListener(target, event, decoratePreventDefault(callback))));
                    }
                    return ( /** @type {?} */(( /** @type {?} */(this.eventManager.addEventListener(target, event, decoratePreventDefault(callback))))));
                };
                return DefaultDomRenderer2;
            }());
            if (false) { }
            var ɵ0$2 = /**
             * @return {?}
             */ function () { return '@'.charCodeAt(0); };
            /** @type {?} */
            var AT_CHARCODE = ((ɵ0$2))();
            /**
             * @param {?} name
             * @param {?} nameKind
             * @return {?}
             */
            function checkNoSyntheticProp(name, nameKind) {
                if (name.charCodeAt(0) === AT_CHARCODE) {
                    throw new Error("Found the synthetic " + nameKind + " " + name + ". Please include either \"BrowserAnimationsModule\" or \"NoopAnimationsModule\" in your application.");
                }
            }
            var EmulatedEncapsulationDomRenderer2 = /** @class */ (function (_super_1) {
                __extends(EmulatedEncapsulationDomRenderer2, _super_1);
                /**
                 * @param {?} eventManager
                 * @param {?} sharedStylesHost
                 * @param {?} component
                 * @param {?} appId
                 */
                function EmulatedEncapsulationDomRenderer2(eventManager, sharedStylesHost, component, appId) {
                    var _this = _super_1.call(this, eventManager) || this;
                    _this.component = component;
                    /** @type {?} */
                    var styles = flattenStyles(appId + '-' + component.id, component.styles, []);
                    sharedStylesHost.addStyles(styles);
                    _this.contentAttr = shimContentAttribute(appId + '-' + component.id);
                    _this.hostAttr = shimHostAttribute(appId + '-' + component.id);
                    return _this;
                }
                /**
                 * @param {?} element
                 * @return {?}
                 */
                EmulatedEncapsulationDomRenderer2.prototype.applyToHost = function (element) { _super_1.prototype.setAttribute.call(this, element, this.hostAttr, ''); };
                /**
                 * @param {?} parent
                 * @param {?} name
                 * @return {?}
                 */
                EmulatedEncapsulationDomRenderer2.prototype.createElement = function (parent, name) {
                    /** @type {?} */
                    var el = _super_1.prototype.createElement.call(this, parent, name);
                    _super_1.prototype.setAttribute.call(this, el, this.contentAttr, '');
                    return el;
                };
                return EmulatedEncapsulationDomRenderer2;
            }(DefaultDomRenderer2));
            if (false) { }
            var ShadowDomRenderer = /** @class */ (function (_super_1) {
                __extends(ShadowDomRenderer, _super_1);
                /**
                 * @param {?} eventManager
                 * @param {?} sharedStylesHost
                 * @param {?} hostEl
                 * @param {?} component
                 */
                function ShadowDomRenderer(eventManager, sharedStylesHost, hostEl, component) {
                    var _this = _super_1.call(this, eventManager) || this;
                    _this.sharedStylesHost = sharedStylesHost;
                    _this.hostEl = hostEl;
                    _this.component = component;
                    if (component.encapsulation === _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].ShadowDom) {
                        _this.shadowRoot = (( /** @type {?} */(hostEl))).attachShadow({ mode: 'open' });
                    }
                    else {
                        _this.shadowRoot = (( /** @type {?} */(hostEl))).createShadowRoot();
                    }
                    _this.sharedStylesHost.addHost(_this.shadowRoot);
                    /** @type {?} */
                    var styles = flattenStyles(component.id, component.styles, []);
                    for (var i = 0; i < styles.length; i++) {
                        /** @type {?} */
                        var styleEl = document.createElement('style');
                        styleEl.textContent = styles[i];
                        _this.shadowRoot.appendChild(styleEl);
                    }
                    return _this;
                }
                /**
                 * @private
                 * @param {?} node
                 * @return {?}
                 */
                ShadowDomRenderer.prototype.nodeOrShadowRoot = function (node) { return node === this.hostEl ? this.shadowRoot : node; };
                /**
                 * @return {?}
                 */
                ShadowDomRenderer.prototype.destroy = function () { this.sharedStylesHost.removeHost(this.shadowRoot); };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @return {?}
                 */
                ShadowDomRenderer.prototype.appendChild = function (parent, newChild) {
                    return _super_1.prototype.appendChild.call(this, this.nodeOrShadowRoot(parent), newChild);
                };
                /**
                 * @param {?} parent
                 * @param {?} newChild
                 * @param {?} refChild
                 * @return {?}
                 */
                ShadowDomRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
                    return _super_1.prototype.insertBefore.call(this, this.nodeOrShadowRoot(parent), newChild, refChild);
                };
                /**
                 * @param {?} parent
                 * @param {?} oldChild
                 * @return {?}
                 */
                ShadowDomRenderer.prototype.removeChild = function (parent, oldChild) {
                    return _super_1.prototype.removeChild.call(this, this.nodeOrShadowRoot(parent), oldChild);
                };
                /**
                 * @param {?} node
                 * @return {?}
                 */
                ShadowDomRenderer.prototype.parentNode = function (node) {
                    return this.nodeOrShadowRoot(_super_1.prototype.parentNode.call(this, this.nodeOrShadowRoot(node)));
                };
                return ShadowDomRenderer;
            }(DefaultDomRenderer2));
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$3 = /**
             * @return {?}
             */ function () { return (typeof Zone !== 'undefined') && (( /** @type {?} */(Zone)))['__symbol__'] ||
                ( /**
                 * @param {?} v
                 * @return {?}
                 */function (v) { return '__zone_symbol__' + v; }); };
            /**
             * Detect if Zone is present. If it is then use simple zone aware 'addEventListener'
             * since Angular can do much more
             * efficient bookkeeping than Zone can, because we have additional information. This speeds up
             * addEventListener by 3x.
             * @type {?}
             */
            var __symbol__ = ((ɵ0$3))();
            /** @type {?} */
            var ADD_EVENT_LISTENER = __symbol__('addEventListener');
            /** @type {?} */
            var REMOVE_EVENT_LISTENER = __symbol__('removeEventListener');
            /** @type {?} */
            var symbolNames = {};
            /** @type {?} */
            var FALSE = 'FALSE';
            /** @type {?} */
            var ANGULAR = 'ANGULAR';
            /** @type {?} */
            var NATIVE_ADD_LISTENER = 'addEventListener';
            /** @type {?} */
            var NATIVE_REMOVE_LISTENER = 'removeEventListener';
            // use the same symbol string which is used in zone.js
            /** @type {?} */
            var stopSymbol = '__zone_symbol__propagationStopped';
            /** @type {?} */
            var stopMethodSymbol = '__zone_symbol__stopImmediatePropagation';
            var ɵ1 = /**
             * @return {?}
             */ function () {
                /** @type {?} */
                var blackListedEvents = (typeof Zone !== 'undefined') && (( /** @type {?} */(Zone)))[__symbol__('BLACK_LISTED_EVENTS')];
                if (blackListedEvents) {
                    /** @type {?} */
                    var res_2 = {};
                    blackListedEvents.forEach(( /**
                     * @param {?} eventName
                     * @return {?}
                     */function (/**
                     * @param {?} eventName
                     * @return {?}
                     */ eventName) { res_2[eventName] = eventName; }));
                    return res_2;
                }
                return undefined;
            };
            /** @type {?} */
            var blackListedMap = ((ɵ1))();
            /** @type {?} */
            var isBlackListedEvent = ( /**
             * @param {?} eventName
             * @return {?}
             */function (eventName) {
                if (!blackListedMap) {
                    return false;
                }
                return blackListedMap.hasOwnProperty(eventName);
            });
            var ɵ2 = isBlackListedEvent;
            /**
             * @record
             */
            function TaskData() { }
            if (false) { }
            // a global listener to handle all dom event,
            // so we do not need to create a closure every time
            /** @type {?} */
            var globalListener = ( /**
             * @this {?}
             * @param {?} event
             * @return {?}
             */function (event) {
                /** @type {?} */
                var symbolName = symbolNames[event.type];
                if (!symbolName) {
                    return;
                }
                /** @type {?} */
                var taskDatas = this[symbolName];
                if (!taskDatas) {
                    return;
                }
                /** @type {?} */
                var args = [event];
                if (taskDatas.length === 1) {
                    // if taskDatas only have one element, just invoke it
                    /** @type {?} */
                    var taskData = taskDatas[0];
                    if (taskData.zone !== Zone.current) {
                        // only use Zone.run when Zone.current not equals to stored zone
                        return taskData.zone.run(taskData.handler, this, args);
                    }
                    else {
                        return taskData.handler.apply(this, args);
                    }
                }
                else {
                    // copy tasks as a snapshot to avoid event handlers remove
                    // itself or others
                    /** @type {?} */
                    var copiedTasks = taskDatas.slice();
                    for (var i = 0; i < copiedTasks.length; i++) {
                        // if other listener call event.stopImmediatePropagation
                        // just break
                        if ((( /** @type {?} */(event)))[stopSymbol] === true) {
                            break;
                        }
                        /** @type {?} */
                        var taskData = copiedTasks[i];
                        if (taskData.zone !== Zone.current) {
                            // only use Zone.run when Zone.current not equals to stored zone
                            taskData.zone.run(taskData.handler, this, args);
                        }
                        else {
                            taskData.handler.apply(this, args);
                        }
                    }
                }
            });
            var ɵ3 = globalListener;
            var DomEventsPlugin = /** @class */ (function (_super_1) {
                __extends(DomEventsPlugin, _super_1);
                /**
                 * @param {?} doc
                 * @param {?} ngZone
                 * @param {?} platformId
                 */
                function DomEventsPlugin(doc, ngZone, platformId) {
                    var _this = _super_1.call(this, doc) || this;
                    _this.ngZone = ngZone;
                    if (!platformId || !Object(_angular_common__WEBPACK_IMPORTED_MODULE_0__["isPlatformServer"])(platformId)) {
                        _this.patchEvent();
                    }
                    return _this;
                }
                /**
                 * @private
                 * @return {?}
                 */
                DomEventsPlugin.prototype.patchEvent = function () {
                    if (typeof Event === 'undefined' || !Event || !Event.prototype) {
                        return;
                    }
                    if ((( /** @type {?} */(Event.prototype)))[stopMethodSymbol]) {
                        // already patched by zone.js
                        return;
                    }
                    /** @type {?} */
                    var delegate = (( /** @type {?} */(Event.prototype)))[stopMethodSymbol] =
                        Event.prototype.stopImmediatePropagation;
                    Event.prototype.stopImmediatePropagation = ( /**
                     * @this {?}
                     * @return {?}
                     */function () {
                        if (this) {
                            this[stopSymbol] = true;
                        }
                        // We should call native delegate in case in some environment part of
                        // the application will not use the patched Event. Also we cast the
                        // "arguments" to any since "stopImmediatePropagation" technically does not
                        // accept any arguments, but we don't know what developers pass through the
                        // function and we want to not break these calls.
                        delegate && delegate.apply(this, ( /** @type {?} */(arguments)));
                    });
                };
                // This plugin should come last in the list of plugins, because it accepts all
                // events.
                /**
                 * @param {?} eventName
                 * @return {?}
                 */
                DomEventsPlugin.prototype.supports = function (eventName) { return true; };
                /**
                 * @param {?} element
                 * @param {?} eventName
                 * @param {?} handler
                 * @return {?}
                 */
                DomEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
                    var _this = this;
                    /**
                     * This code is about to add a listener to the DOM. If Zone.js is present, than
                     * `addEventListener` has been patched. The patched code adds overhead in both
                     * memory and speed (3x slower) than native. For this reason if we detect that
                     * Zone.js is present we use a simple version of zone aware addEventListener instead.
                     * The result is faster registration and the zone will be restored.
                     * But ZoneSpec.onScheduleTask, ZoneSpec.onInvokeTask, ZoneSpec.onCancelTask
                     * will not be invoked
                     * We also do manual zone restoration in element.ts renderEventHandlerClosure method.
                     *
                     * NOTE: it is possible that the element is from different iframe, and so we
                     * have to check before we execute the method.
                     * @type {?}
                     */
                    var self = this;
                    /** @type {?} */
                    var zoneJsLoaded = element[ADD_EVENT_LISTENER];
                    /** @type {?} */
                    var callback = ( /** @type {?} */(handler));
                    // if zonejs is loaded and current zone is not ngZone
                    // we keep Zone.current on target for later restoration.
                    if (zoneJsLoaded && (!_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"].isInAngularZone() || isBlackListedEvent(eventName))) {
                        /** @type {?} */
                        var symbolName = symbolNames[eventName];
                        if (!symbolName) {
                            symbolName = symbolNames[eventName] = __symbol__(ANGULAR + eventName + FALSE);
                        }
                        /** @type {?} */
                        var taskDatas = (( /** @type {?} */(element)))[symbolName];
                        /** @type {?} */
                        var globalListenerRegistered = taskDatas && taskDatas.length > 0;
                        if (!taskDatas) {
                            taskDatas = (( /** @type {?} */(element)))[symbolName] = [];
                        }
                        /** @type {?} */
                        var zone = isBlackListedEvent(eventName) ? Zone.root : Zone.current;
                        if (taskDatas.length === 0) {
                            taskDatas.push({ zone: zone, handler: callback });
                        }
                        else {
                            /** @type {?} */
                            var callbackRegistered = false;
                            for (var i = 0; i < taskDatas.length; i++) {
                                if (taskDatas[i].handler === callback) {
                                    callbackRegistered = true;
                                    break;
                                }
                            }
                            if (!callbackRegistered) {
                                taskDatas.push({ zone: zone, handler: callback });
                            }
                        }
                        if (!globalListenerRegistered) {
                            element[ADD_EVENT_LISTENER](eventName, globalListener, false);
                        }
                    }
                    else {
                        element[NATIVE_ADD_LISTENER](eventName, callback, false);
                    }
                    return ( /**
                     * @return {?}
                     */function () { return _this.removeEventListener(element, eventName, callback); });
                };
                /**
                 * @param {?} target
                 * @param {?} eventName
                 * @param {?} callback
                 * @return {?}
                 */
                DomEventsPlugin.prototype.removeEventListener = function (target, eventName, callback) {
                    /** @type {?} */
                    var underlyingRemove = target[REMOVE_EVENT_LISTENER];
                    // zone.js not loaded, use native removeEventListener
                    if (!underlyingRemove) {
                        return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
                    }
                    /** @type {?} */
                    var symbolName = symbolNames[eventName];
                    /** @type {?} */
                    var taskDatas = symbolName && target[symbolName];
                    if (!taskDatas) {
                        // addEventListener not using patched version
                        // just call native removeEventListener
                        return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
                    }
                    // fix issue 20532, should be able to remove
                    // listener which was added inside of ngZone
                    /** @type {?} */
                    var found = false;
                    for (var i = 0; i < taskDatas.length; i++) {
                        // remove listener from taskDatas if the callback equals
                        if (taskDatas[i].handler === callback) {
                            found = true;
                            taskDatas.splice(i, 1);
                            break;
                        }
                    }
                    if (found) {
                        if (taskDatas.length === 0) {
                            // all listeners are removed, we can remove the globalListener from target
                            underlyingRemove.apply(target, [eventName, globalListener, false]);
                        }
                    }
                    else {
                        // not found in taskDatas, the callback may be added inside of ngZone
                        // use native remove listener to remove the callback
                        target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
                    }
                };
                return DomEventsPlugin;
            }(EventManagerPlugin));
            DomEventsPlugin.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            DomEventsPlugin.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"],] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Supported HammerJS recognizer event names.
             * @type {?}
             */
            var EVENT_NAMES = {
                // pan
                'pan': true,
                'panstart': true,
                'panmove': true,
                'panend': true,
                'pancancel': true,
                'panleft': true,
                'panright': true,
                'panup': true,
                'pandown': true,
                // pinch
                'pinch': true,
                'pinchstart': true,
                'pinchmove': true,
                'pinchend': true,
                'pinchcancel': true,
                'pinchin': true,
                'pinchout': true,
                // press
                'press': true,
                'pressup': true,
                // rotate
                'rotate': true,
                'rotatestart': true,
                'rotatemove': true,
                'rotateend': true,
                'rotatecancel': true,
                // swipe
                'swipe': true,
                'swipeleft': true,
                'swiperight': true,
                'swipeup': true,
                'swipedown': true,
                // tap
                'tap': true,
            };
            /**
             * DI token for providing [HammerJS](http://hammerjs.github.io/) support to Angular.
             * @see `HammerGestureConfig`
             *
             * \@publicApi
             * @type {?}
             */
            var HAMMER_GESTURE_CONFIG = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('HammerGestureConfig');
            /**
             * Injection token used to provide a {\@link HammerLoader} to Angular.
             *
             * \@publicApi
             * @type {?}
             */
            var HAMMER_LOADER = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('HammerLoader');
            /**
             * @record
             */
            function HammerInstance() { }
            if (false) { }
            /**
             * An injectable [HammerJS Manager](http://hammerjs.github.io/api/#hammer.manager)
             * for gesture recognition. Configures specific event recognition.
             * \@publicApi
             */
            var HammerGestureConfig = /** @class */ (function () {
                function HammerGestureConfig() {
                    /**
                     * A set of supported event names for gestures to be used in Angular.
                     * Angular supports all built-in recognizers, as listed in
                     * [HammerJS documentation](http://hammerjs.github.io/).
                     */
                    this.events = [];
                    /**
                     * Maps gesture event names to a set of configuration options
                     * that specify overrides to the default values for specific properties.
                     *
                     * The key is a supported event name to be configured,
                     * and the options object contains a set of properties, with override values
                     * to be applied to the named recognizer event.
                     * For example, to disable recognition of the rotate event, specify
                     *  `{"rotate": {"enable": false}}`.
                     *
                     * Properties that are not present take the HammerJS default values.
                     * For information about which properties are supported for which events,
                     * and their allowed and default values, see
                     * [HammerJS documentation](http://hammerjs.github.io/).
                     *
                     */
                    this.overrides = {};
                }
                /**
                 * Creates a [HammerJS Manager](http://hammerjs.github.io/api/#hammer.manager)
                 * and attaches it to a given HTML element.
                 * @param {?} element The element that will recognize gestures.
                 * @return {?} A HammerJS event-manager object.
                 */
                HammerGestureConfig.prototype.buildHammer = function (element) {
                    /** @type {?} */
                    var mc = new ( /** @type {?} */(Hammer))(element, this.options);
                    mc.get('pinch').set({ enable: true });
                    mc.get('rotate').set({ enable: true });
                    for (var eventName in this.overrides) {
                        mc.get(eventName).set(this.overrides[eventName]);
                    }
                    return mc;
                };
                return HammerGestureConfig;
            }());
            HammerGestureConfig.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            if (false) { }
            var HammerGesturesPlugin = /** @class */ (function (_super_1) {
                __extends(HammerGesturesPlugin, _super_1);
                /**
                 * @param {?} doc
                 * @param {?} _config
                 * @param {?} console
                 * @param {?=} loader
                 */
                function HammerGesturesPlugin(doc, _config, console, loader) {
                    var _this = _super_1.call(this, doc) || this;
                    _this._config = _config;
                    _this.console = console;
                    _this.loader = loader;
                    return _this;
                }
                /**
                 * @param {?} eventName
                 * @return {?}
                 */
                HammerGesturesPlugin.prototype.supports = function (eventName) {
                    if (!EVENT_NAMES.hasOwnProperty(eventName.toLowerCase()) && !this.isCustomEvent(eventName)) {
                        return false;
                    }
                    if (!(( /** @type {?} */(window))).Hammer && !this.loader) {
                        this.console.warn("The \"" + eventName + "\" event cannot be bound because Hammer.JS is not " +
                            "loaded and no custom loader has been specified.");
                        return false;
                    }
                    return true;
                };
                /**
                 * @param {?} element
                 * @param {?} eventName
                 * @param {?} handler
                 * @return {?}
                 */
                HammerGesturesPlugin.prototype.addEventListener = function (element, eventName, handler) {
                    var _this = this;
                    /** @type {?} */
                    var zone = this.manager.getZone();
                    eventName = eventName.toLowerCase();
                    // If Hammer is not present but a loader is specified, we defer adding the event listener
                    // until Hammer is loaded.
                    if (!(( /** @type {?} */(window))).Hammer && this.loader) {
                        // This `addEventListener` method returns a function to remove the added listener.
                        // Until Hammer is loaded, the returned function needs to *cancel* the registration rather
                        // than remove anything.
                        /** @type {?} */
                        var cancelRegistration_1 = false;
                        /** @type {?} */
                        var deregister_1 = ( /**
                         * @return {?}
                         */function () { cancelRegistration_1 = true; });
                        this.loader()
                            .then(( /**
                     * @return {?}
                     */function () {
                            // If Hammer isn't actually loaded when the custom loader resolves, give up.
                            if (!(( /** @type {?} */(window))).Hammer) {
                                _this.console.warn("The custom HAMMER_LOADER completed, but Hammer.JS is not present.");
                                deregister_1 = ( /**
                                 * @return {?}
                                 */function () { });
                                return;
                            }
                            if (!cancelRegistration_1) {
                                // Now that Hammer is loaded and the listener is being loaded for real,
                                // the deregistration function changes from canceling registration to removal.
                                deregister_1 = _this.addEventListener(element, eventName, handler);
                            }
                        }))
                            .catch(( /**
                     * @return {?}
                     */function () {
                            _this.console.warn("The \"" + eventName + "\" event cannot be bound because the custom " +
                                "Hammer.JS loader failed.");
                            deregister_1 = ( /**
                             * @return {?}
                             */function () { });
                        }));
                        // Return a function that *executes* `deregister` (and not `deregister` itself) so that we
                        // can change the behavior of `deregister` once the listener is added. Using a closure in
                        // this way allows us to avoid any additional data structures to track listener removal.
                        return ( /**
                         * @return {?}
                         */function () { deregister_1(); });
                    }
                    return zone.runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        // Creating the manager bind events, must be done outside of angular
                        /** @type {?} */
                        var mc = _this._config.buildHammer(element);
                        /** @type {?} */
                        var callback = ( /**
                         * @param {?} eventObj
                         * @return {?}
                         */function (eventObj) {
                            zone.runGuarded(( /**
                             * @return {?}
                             */function () { handler(eventObj); }));
                        });
                        mc.on(eventName, callback);
                        return ( /**
                         * @return {?}
                         */function () {
                            mc.off(eventName, callback);
                            // destroy mc to prevent memory leak
                            if (typeof mc.destroy === 'function') {
                                mc.destroy();
                            }
                        });
                    }));
                };
                /**
                 * @param {?} eventName
                 * @return {?}
                 */
                HammerGesturesPlugin.prototype.isCustomEvent = function (eventName) { return this._config.events.indexOf(eventName) > -1; };
                return HammerGesturesPlugin;
            }(EventManagerPlugin));
            HammerGesturesPlugin.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            HammerGesturesPlugin.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] },
                { type: HammerGestureConfig, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [HAMMER_GESTURE_CONFIG,] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"] },
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [HAMMER_LOADER,] }] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Defines supported modifiers for key events.
             * @type {?}
             */
            var MODIFIER_KEYS = ['alt', 'control', 'meta', 'shift'];
            var ɵ0$4 = /**
             * @param {?} event
             * @return {?}
             */ function (event) { return event.altKey; }, ɵ1$1 = /**
             * @param {?} event
             * @return {?}
             */ function (event) { return event.ctrlKey; }, ɵ2$1 = /**
             * @param {?} event
             * @return {?}
             */ function (event) { return event.metaKey; }, ɵ3$1 = /**
             * @param {?} event
             * @return {?}
             */ function (event) { return event.shiftKey; };
            /**
             * Retrieves modifiers from key-event objects.
             * @type {?}
             */
            var MODIFIER_KEY_GETTERS = {
                'alt': (ɵ0$4),
                'control': (ɵ1$1),
                'meta': (ɵ2$1),
                'shift': (ɵ3$1)
            };
            /**
             * \@publicApi
             * A browser plug-in that provides support for handling of key events in Angular.
             */
            var KeyEventsPlugin = /** @class */ (function (_super_1) {
                __extends(KeyEventsPlugin, _super_1);
                /**
                 * Initializes an instance of the browser plug-in.
                 * @param {?} doc The document in which key events will be detected.
                 */
                function KeyEventsPlugin(doc) {
                    return _super_1.call(this, doc) || this;
                }
                /**
                 * Reports whether a named key event is supported.
                 * @param {?} eventName The event name to query.
                 * @return {?} True if the named key event is supported.
                 */
                KeyEventsPlugin.prototype.supports = function (eventName) { return KeyEventsPlugin.parseEventName(eventName) != null; };
                /**
                 * Registers a handler for a specific element and key event.
                 * @param {?} element The HTML element to receive event notifications.
                 * @param {?} eventName The name of the key event to listen for.
                 * @param {?} handler A function to call when the notification occurs. Receives the
                 * event object as an argument.
                 * @return {?} The key event that was registered.
                 */
                KeyEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
                    /** @type {?} */
                    var parsedEvent = ( /** @type {?} */(KeyEventsPlugin.parseEventName(eventName)));
                    /** @type {?} */
                    var outsideHandler = KeyEventsPlugin.eventCallback(parsedEvent['fullKey'], handler, this.manager.getZone());
                    return this.manager.getZone().runOutsideAngular(( /**
                     * @return {?}
                     */function () {
                        return getDOM().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
                    }));
                };
                /**
                 * @param {?} eventName
                 * @return {?}
                 */
                KeyEventsPlugin.parseEventName = function (eventName) {
                    /** @type {?} */
                    var parts = eventName.toLowerCase().split('.');
                    /** @type {?} */
                    var domEventName = parts.shift();
                    if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
                        return null;
                    }
                    /** @type {?} */
                    var key = KeyEventsPlugin._normalizeKey(( /** @type {?} */(parts.pop())));
                    /** @type {?} */
                    var fullKey = '';
                    MODIFIER_KEYS.forEach(( /**
                     * @param {?} modifierName
                     * @return {?}
                     */function (/**
                     * @param {?} modifierName
                     * @return {?}
                     */ modifierName) {
                        /** @type {?} */
                        var index = parts.indexOf(modifierName);
                        if (index > -1) {
                            parts.splice(index, 1);
                            fullKey += modifierName + '.';
                        }
                    }));
                    fullKey += key;
                    if (parts.length != 0 || key.length === 0) {
                        // returning null instead of throwing to let another plugin process the event
                        return null;
                    }
                    /** @type {?} */
                    var result = {};
                    result['domEventName'] = domEventName;
                    result['fullKey'] = fullKey;
                    return result;
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                KeyEventsPlugin.getEventFullKey = function (event) {
                    /** @type {?} */
                    var fullKey = '';
                    /** @type {?} */
                    var key = getDOM().getEventKey(event);
                    key = key.toLowerCase();
                    if (key === ' ') {
                        key = 'space'; // for readability
                    }
                    else if (key === '.') {
                        key = 'dot'; // because '.' is used as a separator in event names
                    }
                    MODIFIER_KEYS.forEach(( /**
                     * @param {?} modifierName
                     * @return {?}
                     */function (/**
                     * @param {?} modifierName
                     * @return {?}
                     */ modifierName) {
                        if (modifierName != key) {
                            /** @type {?} */
                            var modifierGetter = MODIFIER_KEY_GETTERS[modifierName];
                            if (modifierGetter(event)) {
                                fullKey += modifierName + '.';
                            }
                        }
                    }));
                    fullKey += key;
                    return fullKey;
                };
                /**
                 * Configures a handler callback for a key event.
                 * @param {?} fullKey The event name that combines all simultaneous keystrokes.
                 * @param {?} handler The function that responds to the key event.
                 * @param {?} zone The zone in which the event occurred.
                 * @return {?} A callback function.
                 */
                KeyEventsPlugin.eventCallback = function (fullKey, handler, zone) {
                    return ( /**
                     * @param {?} event
                     * @return {?}
                     */function (event /** TODO #9100 */) {
                        if (KeyEventsPlugin.getEventFullKey(event) === fullKey) {
                            zone.runGuarded(( /**
                             * @return {?}
                             */function () { return handler(event); }));
                        }
                    });
                };
                /**
                 * \@internal
                 * @param {?} keyName
                 * @return {?}
                 */
                KeyEventsPlugin._normalizeKey = function (keyName) {
                    // TODO: switch to a Map if the mapping grows too much
                    switch (keyName) {
                        case 'esc':
                            return 'escape';
                        default:
                            return keyName;
                    }
                };
                return KeyEventsPlugin;
            }(EventManagerPlugin));
            KeyEventsPlugin.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            KeyEventsPlugin.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Marker interface for a value that's safe to use in a particular context.
             *
             * \@publicApi
             * @record
             */
            function SafeValue() { }
            /**
             * Marker interface for a value that's safe to use as HTML.
             *
             * \@publicApi
             * @record
             */
            function SafeHtml() { }
            /**
             * Marker interface for a value that's safe to use as style (CSS).
             *
             * \@publicApi
             * @record
             */
            function SafeStyle() { }
            /**
             * Marker interface for a value that's safe to use as JavaScript.
             *
             * \@publicApi
             * @record
             */
            function SafeScript() { }
            /**
             * Marker interface for a value that's safe to use as a URL linking to a document.
             *
             * \@publicApi
             * @record
             */
            function SafeUrl() { }
            /**
             * Marker interface for a value that's safe to use as a URL to load executable code from.
             *
             * \@publicApi
             * @record
             */
            function SafeResourceUrl() { }
            /**
             * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
             * values to be safe to use in the different DOM contexts.
             *
             * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
             * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
             * the website.
             *
             * In specific situations, it might be necessary to disable sanitization, for example if the
             * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
             * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
             * methods, and then binding to that value from the template.
             *
             * These situations should be very rare, and extraordinary care must be taken to avoid creating a
             * Cross Site Scripting (XSS) security bug!
             *
             * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
             * close as possible to the source of the value, to make it easy to verify no security bug is
             * created by its use.
             *
             * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
             * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
             * code. The sanitizer leaves safe values intact.
             *
             * \@security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
             * sanitization for the value passed in. Carefully check and audit all values and code paths going
             * into this call. Make sure any user data is appropriately escaped for this security context.
             * For more detail, see the [Security Guide](http://g.co/ng/security).
             *
             * \@publicApi
             * @abstract
             */
            var DomSanitizer = /** @class */ (function () {
                function DomSanitizer() {
                }
                return DomSanitizer;
            }());
            if (false) { }
            var DomSanitizerImpl = /** @class */ (function (_super_1) {
                __extends(DomSanitizerImpl, _super_1);
                /**
                 * @param {?} _doc
                 */
                function DomSanitizerImpl(_doc) {
                    var _this = _super_1.call(this) || this;
                    _this._doc = _doc;
                    return _this;
                }
                /**
                 * @param {?} ctx
                 * @param {?} value
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.sanitize = function (ctx, value) {
                    if (value == null)
                        return null;
                    switch (ctx) {
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"].NONE:
                            return ( /** @type {?} */(value));
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"].HTML:
                            if (value instanceof SafeHtmlImpl)
                                return value.changingThisBreaksApplicationSecurity;
                            this.checkNotSafeValue(value, 'HTML');
                            return Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵ_sanitizeHtml"])(this._doc, String(value));
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"].STYLE:
                            if (value instanceof SafeStyleImpl)
                                return value.changingThisBreaksApplicationSecurity;
                            this.checkNotSafeValue(value, 'Style');
                            return Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵ_sanitizeStyle"])(( /** @type {?} */(value)));
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"].SCRIPT:
                            if (value instanceof SafeScriptImpl)
                                return value.changingThisBreaksApplicationSecurity;
                            this.checkNotSafeValue(value, 'Script');
                            throw new Error('unsafe value used in a script context');
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"].URL:
                            if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
                                // Allow resource URLs in URL contexts, they are strictly more trusted.
                                return value.changingThisBreaksApplicationSecurity;
                            }
                            this.checkNotSafeValue(value, 'URL');
                            return Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵ_sanitizeUrl"])(String(value));
                        case _angular_core__WEBPACK_IMPORTED_MODULE_1__["SecurityContext"].RESOURCE_URL:
                            if (value instanceof SafeResourceUrlImpl) {
                                return value.changingThisBreaksApplicationSecurity;
                            }
                            this.checkNotSafeValue(value, 'ResourceURL');
                            throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
                        default:
                            throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
                    }
                };
                /**
                 * @private
                 * @param {?} value
                 * @param {?} expectedType
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.checkNotSafeValue = function (value, expectedType) {
                    if (value instanceof SafeValueImpl) {
                        throw new Error("Required a safe " + expectedType + ", got a " + value.getTypeName() + " " +
                            "(see http://g.co/ng/security#xss)");
                    }
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.bypassSecurityTrustHtml = function (value) { return new SafeHtmlImpl(value); };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.bypassSecurityTrustStyle = function (value) { return new SafeStyleImpl(value); };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.bypassSecurityTrustScript = function (value) { return new SafeScriptImpl(value); };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.bypassSecurityTrustUrl = function (value) { return new SafeUrlImpl(value); };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = function (value) {
                    return new SafeResourceUrlImpl(value);
                };
                return DomSanitizerImpl;
            }(DomSanitizer));
            DomSanitizerImpl.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            DomSanitizerImpl.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            if (false) { }
            /**
             * @abstract
             */
            var SafeValueImpl = /** @class */ (function () {
                /**
                 * @param {?} changingThisBreaksApplicationSecurity
                 */
                function SafeValueImpl(changingThisBreaksApplicationSecurity) {
                    this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
                    // empty
                }
                /**
                 * @return {?}
                 */
                SafeValueImpl.prototype.toString = function () {
                    return "SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity +
                        " (see http://g.co/ng/security#xss)";
                };
                return SafeValueImpl;
            }());
            if (false) { }
            var SafeHtmlImpl = /** @class */ (function (_super_1) {
                __extends(SafeHtmlImpl, _super_1);
                function SafeHtmlImpl() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @return {?}
                 */
                SafeHtmlImpl.prototype.getTypeName = function () { return 'HTML'; };
                return SafeHtmlImpl;
            }(SafeValueImpl));
            var SafeStyleImpl = /** @class */ (function (_super_1) {
                __extends(SafeStyleImpl, _super_1);
                function SafeStyleImpl() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @return {?}
                 */
                SafeStyleImpl.prototype.getTypeName = function () { return 'Style'; };
                return SafeStyleImpl;
            }(SafeValueImpl));
            var SafeScriptImpl = /** @class */ (function (_super_1) {
                __extends(SafeScriptImpl, _super_1);
                function SafeScriptImpl() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @return {?}
                 */
                SafeScriptImpl.prototype.getTypeName = function () { return 'Script'; };
                return SafeScriptImpl;
            }(SafeValueImpl));
            var SafeUrlImpl = /** @class */ (function (_super_1) {
                __extends(SafeUrlImpl, _super_1);
                function SafeUrlImpl() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @return {?}
                 */
                SafeUrlImpl.prototype.getTypeName = function () { return 'URL'; };
                return SafeUrlImpl;
            }(SafeValueImpl));
            var SafeResourceUrlImpl = /** @class */ (function (_super_1) {
                __extends(SafeResourceUrlImpl, _super_1);
                function SafeResourceUrlImpl() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @return {?}
                 */
                SafeResourceUrlImpl.prototype.getTypeName = function () { return 'ResourceURL'; };
                return SafeResourceUrlImpl;
            }(SafeValueImpl));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ɵ0$5 = _angular_common__WEBPACK_IMPORTED_MODULE_0__["ɵPLATFORM_BROWSER_ID"];
            /** @type {?} */
            var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"], useValue: ɵ0$5 },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_INITIALIZER"], useValue: initDomAdapter, multi: true },
                { provide: _angular_common__WEBPACK_IMPORTED_MODULE_0__["PlatformLocation"], useClass: BrowserPlatformLocation, deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]] },
                { provide: _angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"], useFactory: _document, deps: [] },
            ];
            /**
             * \@security Replacing built-in sanitization providers exposes the application to XSS risks.
             * Attacker-controlled data introduced by an unsanitized provider could expose your
             * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
             * \@publicApi
             * @type {?}
             */
            var BROWSER_SANITIZATION_PROVIDERS = [
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Sanitizer"], useExisting: DomSanitizer },
                { provide: DomSanitizer, useClass: DomSanitizerImpl, deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]] },
            ];
            /**
             * \@publicApi
             * @type {?}
             */
            var platformBrowser = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["createPlatformFactory"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["platformCore"], 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
            /**
             * @return {?}
             */
            function initDomAdapter() {
                BrowserDomAdapter.makeCurrent();
                BrowserGetTestability.init();
            }
            /**
             * @return {?}
             */
            function errorHandler() {
                return new _angular_core__WEBPACK_IMPORTED_MODULE_1__["ErrorHandler"]();
            }
            /**
             * @return {?}
             */
            function _document() {
                return document;
            }
            /** @type {?} */
            var BROWSER_MODULE_PROVIDERS = [
                BROWSER_SANITIZATION_PROVIDERS,
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵAPP_ROOT"], useValue: true },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ErrorHandler"], useFactory: errorHandler, deps: [] },
                {
                    provide: EVENT_MANAGER_PLUGINS,
                    useClass: DomEventsPlugin,
                    multi: true,
                    deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"]]
                },
                { provide: EVENT_MANAGER_PLUGINS, useClass: KeyEventsPlugin, multi: true, deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]] },
                {
                    provide: EVENT_MANAGER_PLUGINS,
                    useClass: HammerGesturesPlugin,
                    multi: true,
                    deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"], HAMMER_GESTURE_CONFIG, _angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"], [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), HAMMER_LOADER]]
                },
                { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig, deps: [] },
                {
                    provide: DomRendererFactory2,
                    useClass: DomRendererFactory2,
                    deps: [EventManager, DomSharedStylesHost, _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_ID"]]
                },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["RendererFactory2"], useExisting: DomRendererFactory2 },
                { provide: SharedStylesHost, useExisting: DomSharedStylesHost },
                { provide: DomSharedStylesHost, useClass: DomSharedStylesHost, deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]] },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Testability"], useClass: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Testability"], deps: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]] },
                { provide: EventManager, useClass: EventManager, deps: [EVENT_MANAGER_PLUGINS, _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]] },
                ELEMENT_PROBE_PROVIDERS,
            ];
            /**
             * Exports required infrastructure for all Angular apps.
             * Included by default in all Angular apps created with the CLI
             * `new` command.
             * Re-exports `CommonModule` and `ApplicationModule`, making their
             * exports and providers available to all apps.
             *
             * \@publicApi
             */
            var BrowserModule = /** @class */ (function () {
                /**
                 * @param {?} parentModule
                 */
                function BrowserModule(parentModule) {
                    if (parentModule) {
                        throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.");
                    }
                }
                /**
                 * Configures a browser-based app to transition from a server-rendered app, if
                 * one is present on the page.
                 *
                 * @param {?} params An object containing an identifier for the app to transition.
                 * The ID must match between the client and server versions of the app.
                 * @return {?} The reconfigured `BrowserModule` to import into the app's root `AppModule`.
                 */
                BrowserModule.withServerTransition = function (params) {
                    return {
                        ngModule: BrowserModule,
                        providers: [
                            { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_ID"], useValue: params.appId },
                            { provide: TRANSITION_ID, useExisting: _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_ID"] },
                            SERVER_TRANSITION_PROVIDERS,
                        ],
                    };
                };
                return BrowserModule;
            }());
            BrowserModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{ providers: BROWSER_MODULE_PROVIDERS, exports: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["CommonModule"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["ApplicationModule"]] },] }
            ];
            /** @nocollapse */
            BrowserModule.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [BrowserModule,] }] }
            ]; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Factory to create Meta service.
             * @return {?}
             */
            function createMeta() {
                return new Meta(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]));
            }
            /**
             * A service that can be used to get and add meta tags.
             *
             * \@publicApi
             */
            var Meta = /** @class */ (function () {
                /**
                 * @param {?} _doc
                 */
                function Meta(_doc) {
                    this._doc = _doc;
                    this._dom = getDOM();
                }
                /**
                 * @param {?} tag
                 * @param {?=} forceCreation
                 * @return {?}
                 */
                Meta.prototype.addTag = function (tag, forceCreation) {
                    if (forceCreation === void 0) { forceCreation = false; }
                    if (!tag)
                        return null;
                    return this._getOrCreateElement(tag, forceCreation);
                };
                /**
                 * @param {?} tags
                 * @param {?=} forceCreation
                 * @return {?}
                 */
                Meta.prototype.addTags = function (tags, forceCreation) {
                    var _this = this;
                    if (forceCreation === void 0) { forceCreation = false; }
                    if (!tags)
                        return [];
                    return tags.reduce(( /**
                     * @param {?} result
                     * @param {?} tag
                     * @return {?}
                     */function (result, tag) {
                        if (tag) {
                            result.push(_this._getOrCreateElement(tag, forceCreation));
                        }
                        return result;
                    }), []);
                };
                /**
                 * @param {?} attrSelector
                 * @return {?}
                 */
                Meta.prototype.getTag = function (attrSelector) {
                    if (!attrSelector)
                        return null;
                    return this._dom.querySelector(this._doc, "meta[" + attrSelector + "]") || null;
                };
                /**
                 * @param {?} attrSelector
                 * @return {?}
                 */
                Meta.prototype.getTags = function (attrSelector) {
                    if (!attrSelector)
                        return [];
                    /** @type {?} */
                    var list /*NodeList*/ = this._dom.querySelectorAll(this._doc, "meta[" + attrSelector + "]");
                    return list ? [].slice.call(list) : [];
                };
                /**
                 * @param {?} tag
                 * @param {?=} selector
                 * @return {?}
                 */
                Meta.prototype.updateTag = function (tag, selector) {
                    if (!tag)
                        return null;
                    selector = selector || this._parseSelector(tag);
                    /** @type {?} */
                    var meta = ( /** @type {?} */(this.getTag(selector)));
                    if (meta) {
                        return this._setMetaElementAttributes(tag, meta);
                    }
                    return this._getOrCreateElement(tag, true);
                };
                /**
                 * @param {?} attrSelector
                 * @return {?}
                 */
                Meta.prototype.removeTag = function (attrSelector) { this.removeTagElement(( /** @type {?} */(this.getTag(attrSelector)))); };
                /**
                 * @param {?} meta
                 * @return {?}
                 */
                Meta.prototype.removeTagElement = function (meta) {
                    if (meta) {
                        this._dom.remove(meta);
                    }
                };
                /**
                 * @private
                 * @param {?} meta
                 * @param {?=} forceCreation
                 * @return {?}
                 */
                Meta.prototype._getOrCreateElement = function (meta, forceCreation) {
                    if (forceCreation === void 0) { forceCreation = false; }
                    if (!forceCreation) {
                        /** @type {?} */
                        var selector = this._parseSelector(meta);
                        /** @type {?} */
                        var elem = ( /** @type {?} */(this.getTag(selector)));
                        // It's allowed to have multiple elements with the same name so it's not enough to
                        // just check that element with the same name already present on the page. We also need to
                        // check if element has tag attributes
                        if (elem && this._containsAttributes(meta, elem))
                            return elem;
                    }
                    /** @type {?} */
                    var element = ( /** @type {?} */(this._dom.createElement('meta')));
                    this._setMetaElementAttributes(meta, element);
                    /** @type {?} */
                    var head = this._dom.getElementsByTagName(this._doc, 'head')[0];
                    this._dom.appendChild(head, element);
                    return element;
                };
                /**
                 * @private
                 * @param {?} tag
                 * @param {?} el
                 * @return {?}
                 */
                Meta.prototype._setMetaElementAttributes = function (tag, el) {
                    var _this = this;
                    Object.keys(tag).forEach(( /**
                     * @param {?} prop
                     * @return {?}
                     */function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); }));
                    return el;
                };
                /**
                 * @private
                 * @param {?} tag
                 * @return {?}
                 */
                Meta.prototype._parseSelector = function (tag) {
                    /** @type {?} */
                    var attr = tag.name ? 'name' : 'property';
                    return attr + "=\"" + tag[attr] + "\"";
                };
                /**
                 * @private
                 * @param {?} tag
                 * @param {?} elem
                 * @return {?}
                 */
                Meta.prototype._containsAttributes = function (tag, elem) {
                    var _this = this;
                    return Object.keys(tag).every(( /**
                     * @param {?} key
                     * @return {?}
                     */function (key) { return _this._dom.getAttribute(elem, key) === tag[key]; }));
                };
                return Meta;
            }());
            Meta.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root', useFactory: createMeta, deps: [] },] }
            ];
            /** @nocollapse */
            Meta.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ Meta.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: createMeta, token: Meta, providedIn: "root" });
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Factory to create Title service.
             * @return {?}
             */
            function createTitle() {
                return new Title(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"]));
            }
            /**
             * A service that can be used to get and set the title of a current HTML document.
             *
             * Since an Angular application can't be bootstrapped on the entire HTML document (`<html>` tag)
             * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
             * (representing the `<title>` tag). Instead, this service can be used to set and get the current
             * title value.
             *
             * \@publicApi
             */
            var Title = /** @class */ (function () {
                /**
                 * @param {?} _doc
                 */
                function Title(_doc) {
                    this._doc = _doc;
                }
                /**
                 * Get the title of the current HTML document.
                 * @return {?}
                 */
                Title.prototype.getTitle = function () { return getDOM().getTitle(this._doc); };
                /**
                 * Set the title of the current HTML document.
                 * @param {?} newTitle
                 * @return {?}
                 */
                Title.prototype.setTitle = function (newTitle) { getDOM().setTitle(this._doc, newTitle); };
                return Title;
            }());
            Title.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{ providedIn: 'root', useFactory: createTitle, deps: [] },] }
            ];
            /** @nocollapse */
            Title.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"],] }] }
            ]; };
            /** @nocollapse */ Title.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: createTitle, token: Title, providedIn: "root" });
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /** @type {?} */
            var win = typeof window !== 'undefined' && window || ( /** @type {?} */({}));
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ChangeDetectionPerfRecord = /** @class */ (function () {
                /**
                 * @param {?} msPerTick
                 * @param {?} numTicks
                 */
                function ChangeDetectionPerfRecord(msPerTick, numTicks) {
                    this.msPerTick = msPerTick;
                    this.numTicks = numTicks;
                }
                return ChangeDetectionPerfRecord;
            }());
            if (false) { }
            /**
             * Entry point for all Angular profiling-related debug tools. This object
             * corresponds to the `ng.profiler` in the dev console.
             */
            var AngularProfiler = /** @class */ (function () {
                /**
                 * @param {?} ref
                 */
                function AngularProfiler(ref) {
                    this.appRef = ref.injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ApplicationRef"]);
                }
                // tslint:disable:no-console
                /**
                 * Exercises change detection in a loop and then prints the average amount of
                 * time in milliseconds how long a single round of change detection takes for
                 * the current state of the UI. It runs a minimum of 5 rounds for a minimum
                 * of 500 milliseconds.
                 *
                 * Optionally, a user may pass a `config` parameter containing a map of
                 * options. Supported options are:
                 *
                 * `record` (boolean) - causes the profiler to record a CPU profile while
                 * it exercises the change detector. Example:
                 *
                 * ```
                 * ng.profiler.timeChangeDetection({record: true})
                 * ```
                 * @param {?} config
                 * @return {?}
                 */
                AngularProfiler.prototype.timeChangeDetection = function (config) {
                    /** @type {?} */
                    var record = config && config['record'];
                    /** @type {?} */
                    var profileName = 'Change Detection';
                    // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
                    /** @type {?} */
                    var isProfilerAvailable = win.console.profile != null;
                    if (record && isProfilerAvailable) {
                        win.console.profile(profileName);
                    }
                    /** @type {?} */
                    var start = getDOM().performanceNow();
                    /** @type {?} */
                    var numTicks = 0;
                    while (numTicks < 5 || (getDOM().performanceNow() - start) < 500) {
                        this.appRef.tick();
                        numTicks++;
                    }
                    /** @type {?} */
                    var end = getDOM().performanceNow();
                    if (record && isProfilerAvailable) {
                        win.console.profileEnd(profileName);
                    }
                    /** @type {?} */
                    var msPerTick = (end - start) / numTicks;
                    win.console.log("ran " + numTicks + " change detection cycles");
                    win.console.log(msPerTick.toFixed(2) + " ms per check");
                    return new ChangeDetectionPerfRecord(msPerTick, numTicks);
                };
                return AngularProfiler;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var PROFILER_GLOBAL_NAME = 'profiler';
            /**
             * Enabled Angular debug tools that are accessible via your browser's
             * developer console.
             *
             * Usage:
             *
             * 1. Open developer console (e.g. in Chrome Ctrl + Shift + j)
             * 1. Type `ng.` (usually the console will show auto-complete suggestion)
             * 1. Try the change detection profiler `ng.profiler.timeChangeDetection()`
             *    then hit Enter.
             *
             * \@publicApi
             * @template T
             * @param {?} ref
             * @return {?}
             */
            function enableDebugTools(ref) {
                exportNgVar(PROFILER_GLOBAL_NAME, new AngularProfiler(ref));
                return ref;
            }
            /**
             * Disables Angular tools.
             *
             * \@publicApi
             * @return {?}
             */
            function disableDebugTools() {
                exportNgVar(PROFILER_GLOBAL_NAME, null);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} text
             * @return {?}
             */
            function escapeHtml(text) {
                /** @type {?} */
                var escapedText = {
                    '&': '&a;',
                    '"': '&q;',
                    '\'': '&s;',
                    '<': '&l;',
                    '>': '&g;',
                };
                return text.replace(/[&"'<>]/g, ( /**
                 * @param {?} s
                 * @return {?}
                 */function (/**
                 * @param {?} s
                 * @return {?}
                 */ s) { return escapedText[s]; }));
            }
            /**
             * @param {?} text
             * @return {?}
             */
            function unescapeHtml(text) {
                /** @type {?} */
                var unescapedText = {
                    '&a;': '&',
                    '&q;': '"',
                    '&s;': '\'',
                    '&l;': '<',
                    '&g;': '>',
                };
                return text.replace(/&[^;]+;/g, ( /**
                 * @param {?} s
                 * @return {?}
                 */function (/**
                 * @param {?} s
                 * @return {?}
                 */ s) { return unescapedText[s]; }));
            }
            /**
             * Create a `StateKey<T>` that can be used to store value of type T with `TransferState`.
             *
             * Example:
             *
             * ```
             * const COUNTER_KEY = makeStateKey<number>('counter');
             * let value = 10;
             *
             * transferState.set(COUNTER_KEY, value);
             * ```
             *
             * \@publicApi
             * @template T
             * @param {?} key
             * @return {?}
             */
            function makeStateKey(key) {
                return ( /** @type {?} */(key));
            }
            /**
             * A key value store that is transferred from the application on the server side to the application
             * on the client side.
             *
             * `TransferState` will be available as an injectable token. To use it import
             * `ServerTransferStateModule` on the server and `BrowserTransferStateModule` on the client.
             *
             * The values in the store are serialized/deserialized using JSON.stringify/JSON.parse. So only
             * boolean, number, string, null and non-class objects will be serialized and deserialzied in a
             * non-lossy manner.
             *
             * \@publicApi
             */
            var TransferState = /** @class */ (function () {
                function TransferState() {
                    this.store = {};
                    this.onSerializeCallbacks = {};
                }
                /**
                 * \@internal
                 * @param {?} initState
                 * @return {?}
                 */
                TransferState.init = function (initState) {
                    /** @type {?} */
                    var transferState = new TransferState();
                    transferState.store = initState;
                    return transferState;
                };
                /**
                 * Get the value corresponding to a key. Return `defaultValue` if key is not found.
                 * @template T
                 * @param {?} key
                 * @param {?} defaultValue
                 * @return {?}
                 */
                TransferState.prototype.get = function (key, defaultValue) {
                    return this.store[key] !== undefined ? ( /** @type {?} */(this.store[key])) : defaultValue;
                };
                /**
                 * Set the value corresponding to a key.
                 * @template T
                 * @param {?} key
                 * @param {?} value
                 * @return {?}
                 */
                TransferState.prototype.set = function (key, value) { this.store[key] = value; };
                /**
                 * Remove a key from the store.
                 * @template T
                 * @param {?} key
                 * @return {?}
                 */
                TransferState.prototype.remove = function (key) { delete this.store[key]; };
                /**
                 * Test whether a key exists in the store.
                 * @template T
                 * @param {?} key
                 * @return {?}
                 */
                TransferState.prototype.hasKey = function (key) { return this.store.hasOwnProperty(key); };
                /**
                 * Register a callback to provide the value for a key when `toJson` is called.
                 * @template T
                 * @param {?} key
                 * @param {?} callback
                 * @return {?}
                 */
                TransferState.prototype.onSerialize = function (key, callback) {
                    this.onSerializeCallbacks[key] = callback;
                };
                /**
                 * Serialize the current state of the store to JSON.
                 * @return {?}
                 */
                TransferState.prototype.toJson = function () {
                    // Call the onSerialize callbacks and put those values into the store.
                    for (var key in this.onSerializeCallbacks) {
                        if (this.onSerializeCallbacks.hasOwnProperty(key)) {
                            try {
                                this.store[key] = this.onSerializeCallbacks[key]();
                            }
                            catch (e) {
                                console.warn('Exception in onSerialize callback: ', e);
                            }
                        }
                    }
                    return JSON.stringify(this.store);
                };
                return TransferState;
            }());
            TransferState.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            if (false) { }
            /**
             * @param {?} doc
             * @param {?} appId
             * @return {?}
             */
            function initTransferState(doc, appId) {
                // Locate the script tag with the JSON data transferred from the server.
                // The id of the script tag is set to the Angular appId + 'state'.
                /** @type {?} */
                var script = doc.getElementById(appId + '-state');
                /** @type {?} */
                var initialState = {};
                if (script && script.textContent) {
                    try {
                        initialState = JSON.parse(unescapeHtml(script.textContent));
                    }
                    catch (e) {
                        console.warn('Exception while restoring TransferState for app ' + appId, e);
                    }
                }
                return TransferState.init(initialState);
            }
            /**
             * NgModule to install on the client side while using the `TransferState` to transfer state from
             * server to client.
             *
             * \@publicApi
             */
            var BrowserTransferStateModule = /** @class */ (function () {
                function BrowserTransferStateModule() {
                }
                return BrowserTransferStateModule;
            }());
            BrowserTransferStateModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            providers: [{ provide: TransferState, useFactory: initTransferState, deps: [_angular_common__WEBPACK_IMPORTED_MODULE_0__["DOCUMENT"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_ID"]] }],
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Predicates for use with {\@link DebugElement}'s query functions.
             *
             * \@publicApi
             */
            var By = /** @class */ (function () {
                function By() {
                }
                /**
                 * Match all nodes.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_all'}
                 * @return {?}
                 */
                By.all = function () {
                    return ( /**
                     * @return {?}
                     */function () { return true; });
                };
                /**
                 * Match elements by the given CSS selector.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_css'}
                 * @param {?} selector
                 * @return {?}
                 */
                By.css = function (selector) {
                    return ( /**
                     * @param {?} debugElement
                     * @return {?}
                     */function (debugElement) {
                        return debugElement.nativeElement != null ?
                            getDOM().elementMatches(debugElement.nativeElement, selector) :
                            false;
                    });
                };
                /**
                 * Match nodes that have the given directive present.
                 *
                 * \@usageNotes
                 * ### Example
                 *
                 * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_directive'}
                 * @param {?} type
                 * @return {?}
                 */
                By.directive = function (type) {
                    return ( /**
                     * @param {?} debugNode
                     * @return {?}
                     */function (debugNode) { return ( /** @type {?} */(debugNode.providerTokens)).indexOf(type) !== -1; });
                };
                return By;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Version"]('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=platform-browser.js.map
            /***/ 
        }),
        /***/ "./node_modules/@angular/router/fesm2015/router.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/@angular/router/fesm2015/router.js ***!
          \*********************************************************/
        /*! exports provided: ɵangular_packages_router_router_l, ɵEmptyOutletComponent, ɵangular_packages_router_router_a, ɵangular_packages_router_router_h, ɵangular_packages_router_router_c, ɵangular_packages_router_router_i, ɵangular_packages_router_router_j, ɵangular_packages_router_router_e, ɵangular_packages_router_router_d, ɵangular_packages_router_router_k, ɵangular_packages_router_router_g, ɵangular_packages_router_router_b, ɵangular_packages_router_router_f, ɵangular_packages_router_router_o, ɵangular_packages_router_router_m, ɵangular_packages_router_router_n, RouterLink, RouterLinkWithHref, RouterLinkActive, RouterOutlet, ActivationEnd, ActivationStart, ChildActivationEnd, ChildActivationStart, GuardsCheckEnd, GuardsCheckStart, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, ResolveEnd, ResolveStart, RouteConfigLoadEnd, RouteConfigLoadStart, RouterEvent, RoutesRecognized, Scroll, RouteReuseStrategy, Router, ROUTES, ROUTER_CONFIGURATION, ROUTER_INITIALIZER, RouterModule, provideRoutes, ChildrenOutletContexts, OutletContext, NoPreloading, PreloadAllModules, PreloadingStrategy, RouterPreloader, ActivatedRoute, ActivatedRouteSnapshot, RouterState, RouterStateSnapshot, PRIMARY_OUTLET, convertToParamMap, UrlHandlingStrategy, DefaultUrlSerializer, UrlSegment, UrlSegmentGroup, UrlSerializer, UrlTree, VERSION, ɵROUTER_PROVIDERS, ɵflatten */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_l", function () { return ɵEmptyOutletComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEmptyOutletComponent", function () { return ɵEmptyOutletComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_a", function () { return ROUTER_FORROOT_GUARD; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_h", function () { return RouterInitializer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_c", function () { return createRouterScroller; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_i", function () { return getAppInitializer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_j", function () { return getBootstrapListener; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_e", function () { return provideForRootGuard; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_d", function () { return provideLocationStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_k", function () { return provideRouterInitializer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_g", function () { return rootRoute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_b", function () { return routerNgProbeToken; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_f", function () { return setupRouter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_o", function () { return RouterScroller; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_m", function () { return Tree; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_router_router_n", function () { return TreeNode; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterLink", function () { return RouterLink; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterLinkWithHref", function () { return RouterLinkWithHref; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterLinkActive", function () { return RouterLinkActive; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterOutlet", function () { return RouterOutlet; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivationEnd", function () { return ActivationEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivationStart", function () { return ActivationStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChildActivationEnd", function () { return ChildActivationEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChildActivationStart", function () { return ChildActivationStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GuardsCheckEnd", function () { return GuardsCheckEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GuardsCheckStart", function () { return GuardsCheckStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationCancel", function () { return NavigationCancel; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationEnd", function () { return NavigationEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationError", function () { return NavigationError; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationStart", function () { return NavigationStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolveEnd", function () { return ResolveEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolveStart", function () { return ResolveStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouteConfigLoadEnd", function () { return RouteConfigLoadEnd; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouteConfigLoadStart", function () { return RouteConfigLoadStart; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterEvent", function () { return RouterEvent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RoutesRecognized", function () { return RoutesRecognized; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function () { return Scroll; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouteReuseStrategy", function () { return RouteReuseStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function () { return Router; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUTES", function () { return ROUTES; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUTER_CONFIGURATION", function () { return ROUTER_CONFIGURATION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUTER_INITIALIZER", function () { return ROUTER_INITIALIZER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterModule", function () { return RouterModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "provideRoutes", function () { return provideRoutes; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChildrenOutletContexts", function () { return ChildrenOutletContexts; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OutletContext", function () { return OutletContext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoPreloading", function () { return NoPreloading; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreloadAllModules", function () { return PreloadAllModules; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreloadingStrategy", function () { return PreloadingStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterPreloader", function () { return RouterPreloader; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivatedRoute", function () { return ActivatedRoute; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivatedRouteSnapshot", function () { return ActivatedRouteSnapshot; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterState", function () { return RouterState; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterStateSnapshot", function () { return RouterStateSnapshot; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRIMARY_OUTLET", function () { return PRIMARY_OUTLET; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToParamMap", function () { return convertToParamMap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlHandlingStrategy", function () { return UrlHandlingStrategy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultUrlSerializer", function () { return DefaultUrlSerializer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlSegment", function () { return UrlSegment; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlSegmentGroup", function () { return UrlSegmentGroup; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlSerializer", function () { return UrlSerializer; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlTree", function () { return UrlTree; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function () { return VERSION; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵROUTER_PROVIDERS", function () { return ROUTER_PROVIDERS; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵflatten", function () { return flatten; });
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
            /* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /**
             * @license Angular v8.2.13
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Base for events the router goes through, as opposed to events tied to a specific
             * route. Fired one time for any given navigation.
             *
             * \@usageNotes
             *
             * ```ts
             * class MyService {
             *   constructor(public router: Router, logger: Logger) {
             *     router.events.pipe(
             *       filter(e => e instanceof RouterEvent)
             *     ).subscribe(e => {
             *       logger.log(e.id, e.url);
             *     });
             *   }
             * }
             * ```
             *
             * @see `Event`
             * \@publicApi
             */
            var RouterEvent = /** @class */ (function () {
                /**
                 * @param {?} id
                 * @param {?} url
                 */
                function RouterEvent(id, url) {
                    this.id = id;
                    this.url = url;
                }
                return RouterEvent;
            }());
            if (false) { }
            /**
             * An event triggered when a navigation starts.
             *
             * \@publicApi
             */
            var NavigationStart = /** @class */ (function (_super_1) {
                __extends(NavigationStart, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?=} navigationTrigger
                 * @param {?=} restoredState
                 */
                function NavigationStart(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, 
                /** @docsNotRequired */
                navigationTrigger, 
                /** @docsNotRequired */
                restoredState) {
                    if (navigationTrigger === void 0) { navigationTrigger = 'imperative'; }
                    if (restoredState === void 0) { restoredState = null; }
                    var _this = _super_1.call(this, id, url) || this;
                    _this.navigationTrigger = navigationTrigger;
                    _this.restoredState = restoredState;
                    return _this;
                }
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                NavigationStart.prototype.toString = function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
                return NavigationStart;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered when a navigation ends successfully.
             *
             * \@publicApi
             */
            var NavigationEnd = /** @class */ (function (_super_1) {
                __extends(NavigationEnd, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} urlAfterRedirects
                 */
                function NavigationEnd(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, urlAfterRedirects) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.urlAfterRedirects = urlAfterRedirects;
                    return _this;
                }
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                NavigationEnd.prototype.toString = function () {
                    return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
                };
                return NavigationEnd;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered when a navigation is canceled, directly or indirectly.
             *
             * This can happen when a [route guard](guide/router#milestone-5-route-guards)
             * returns `false` or initiates a redirect by returning a `UrlTree`.
             *
             * \@publicApi
             */
            var NavigationCancel = /** @class */ (function (_super_1) {
                __extends(NavigationCancel, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} reason
                 */
                function NavigationCancel(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, reason) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.reason = reason;
                    return _this;
                }
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                NavigationCancel.prototype.toString = function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
                return NavigationCancel;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered when a navigation fails due to an unexpected error.
             *
             * \@publicApi
             */
            var NavigationError = /** @class */ (function (_super_1) {
                __extends(NavigationError, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} error
                 */
                function NavigationError(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, error) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.error = error;
                    return _this;
                }
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                NavigationError.prototype.toString = function () {
                    return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
                };
                return NavigationError;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered when routes are recognized.
             *
             * \@publicApi
             */
            var RoutesRecognized = /** @class */ (function (_super_1) {
                __extends(RoutesRecognized, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} urlAfterRedirects
                 * @param {?} state
                 */
                function RoutesRecognized(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, urlAfterRedirects, state) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.urlAfterRedirects = urlAfterRedirects;
                    _this.state = state;
                    return _this;
                }
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                RoutesRecognized.prototype.toString = function () {
                    return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
                };
                return RoutesRecognized;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered at the start of the Guard phase of routing.
             *
             * \@publicApi
             */
            var GuardsCheckStart = /** @class */ (function (_super_1) {
                __extends(GuardsCheckStart, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} urlAfterRedirects
                 * @param {?} state
                 */
                function GuardsCheckStart(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, urlAfterRedirects, state) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.urlAfterRedirects = urlAfterRedirects;
                    _this.state = state;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                GuardsCheckStart.prototype.toString = function () {
                    return "GuardsCheckStart(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
                };
                return GuardsCheckStart;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered at the end of the Guard phase of routing.
             *
             * \@publicApi
             */
            var GuardsCheckEnd = /** @class */ (function (_super_1) {
                __extends(GuardsCheckEnd, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} urlAfterRedirects
                 * @param {?} state
                 * @param {?} shouldActivate
                 */
                function GuardsCheckEnd(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, urlAfterRedirects, state, shouldActivate) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.urlAfterRedirects = urlAfterRedirects;
                    _this.state = state;
                    _this.shouldActivate = shouldActivate;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                GuardsCheckEnd.prototype.toString = function () {
                    return "GuardsCheckEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ", shouldActivate: " + this.shouldActivate + ")";
                };
                return GuardsCheckEnd;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered at the the start of the Resolve phase of routing.
             *
             * Runs in the "resolve" phase whether or not there is anything to resolve.
             * In future, may change to only run when there are things to be resolved.
             *
             * \@publicApi
             */
            var ResolveStart = /** @class */ (function (_super_1) {
                __extends(ResolveStart, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} urlAfterRedirects
                 * @param {?} state
                 */
                function ResolveStart(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, urlAfterRedirects, state) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.urlAfterRedirects = urlAfterRedirects;
                    _this.state = state;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                ResolveStart.prototype.toString = function () {
                    return "ResolveStart(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
                };
                return ResolveStart;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered at the end of the Resolve phase of routing.
             * @see `ResolveStart`.
             *
             * \@publicApi
             */
            var ResolveEnd = /** @class */ (function (_super_1) {
                __extends(ResolveEnd, _super_1);
                /**
                 * @param {?} id
                 * @param {?} url
                 * @param {?} urlAfterRedirects
                 * @param {?} state
                 */
                function ResolveEnd(
                /** @docsNotRequired */
                id, 
                /** @docsNotRequired */
                url, urlAfterRedirects, state) {
                    var _this = _super_1.call(this, id, url) || this;
                    _this.urlAfterRedirects = urlAfterRedirects;
                    _this.state = state;
                    return _this;
                }
                /**
                 * @return {?}
                 */
                ResolveEnd.prototype.toString = function () {
                    return "ResolveEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
                };
                return ResolveEnd;
            }(RouterEvent));
            if (false) { }
            /**
             * An event triggered before lazy loading a route configuration.
             *
             * \@publicApi
             */
            var RouteConfigLoadStart = /** @class */ (function () {
                /**
                 * @param {?} route
                 */
                function RouteConfigLoadStart(route) {
                    this.route = route;
                }
                /**
                 * @return {?}
                 */
                RouteConfigLoadStart.prototype.toString = function () { return "RouteConfigLoadStart(path: " + this.route.path + ")"; };
                return RouteConfigLoadStart;
            }());
            if (false) { }
            /**
             * An event triggered when a route has been lazy loaded.
             *
             * \@publicApi
             */
            var RouteConfigLoadEnd = /** @class */ (function () {
                /**
                 * @param {?} route
                 */
                function RouteConfigLoadEnd(route) {
                    this.route = route;
                }
                /**
                 * @return {?}
                 */
                RouteConfigLoadEnd.prototype.toString = function () { return "RouteConfigLoadEnd(path: " + this.route.path + ")"; };
                return RouteConfigLoadEnd;
            }());
            if (false) { }
            /**
             * An event triggered at the start of the child-activation
             * part of the Resolve phase of routing.
             * @see `ChildActivationEnd`
             * @see `ResolveStart`
             *
             * \@publicApi
             */
            var ChildActivationStart = /** @class */ (function () {
                /**
                 * @param {?} snapshot
                 */
                function ChildActivationStart(snapshot) {
                    this.snapshot = snapshot;
                }
                /**
                 * @return {?}
                 */
                ChildActivationStart.prototype.toString = function () {
                    /** @type {?} */
                    var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
                    return "ChildActivationStart(path: '" + path + "')";
                };
                return ChildActivationStart;
            }());
            if (false) { }
            /**
             * An event triggered at the end of the child-activation part
             * of the Resolve phase of routing.
             * @see `ChildActivationStart`
             * @see `ResolveStart` *
             * \@publicApi
             */
            var ChildActivationEnd = /** @class */ (function () {
                /**
                 * @param {?} snapshot
                 */
                function ChildActivationEnd(snapshot) {
                    this.snapshot = snapshot;
                }
                /**
                 * @return {?}
                 */
                ChildActivationEnd.prototype.toString = function () {
                    /** @type {?} */
                    var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
                    return "ChildActivationEnd(path: '" + path + "')";
                };
                return ChildActivationEnd;
            }());
            if (false) { }
            /**
             * An event triggered at the start of the activation part
             * of the Resolve phase of routing.
             * @see ActivationEnd`
             * @see `ResolveStart`
             *
             * \@publicApi
             */
            var ActivationStart = /** @class */ (function () {
                /**
                 * @param {?} snapshot
                 */
                function ActivationStart(snapshot) {
                    this.snapshot = snapshot;
                }
                /**
                 * @return {?}
                 */
                ActivationStart.prototype.toString = function () {
                    /** @type {?} */
                    var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
                    return "ActivationStart(path: '" + path + "')";
                };
                return ActivationStart;
            }());
            if (false) { }
            /**
             * An event triggered at the end of the activation part
             * of the Resolve phase of routing.
             * @see `ActivationStart`
             * @see `ResolveStart`
             *
             * \@publicApi
             */
            var ActivationEnd = /** @class */ (function () {
                /**
                 * @param {?} snapshot
                 */
                function ActivationEnd(snapshot) {
                    this.snapshot = snapshot;
                }
                /**
                 * @return {?}
                 */
                ActivationEnd.prototype.toString = function () {
                    /** @type {?} */
                    var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
                    return "ActivationEnd(path: '" + path + "')";
                };
                return ActivationEnd;
            }());
            if (false) { }
            /**
             * An event triggered by scrolling.
             *
             * \@publicApi
             */
            var Scroll = /** @class */ (function () {
                /**
                 * @param {?} routerEvent
                 * @param {?} position
                 * @param {?} anchor
                 */
                function Scroll(routerEvent, position, anchor) {
                    this.routerEvent = routerEvent;
                    this.position = position;
                    this.anchor = anchor;
                }
                /**
                 * @return {?}
                 */
                Scroll.prototype.toString = function () {
                    /** @type {?} */
                    var pos = this.position ? this.position[0] + ", " + this.position[1] : null;
                    return "Scroll(anchor: '" + this.anchor + "', position: '" + pos + "')";
                };
                return Scroll;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * This component is used internally within the router to be a placeholder when an empty
             * router-outlet is needed. For example, with a config such as:
             *
             * `{path: 'parent', outlet: 'nav', children: [...]}`
             *
             * In order to render, there needs to be a component on this config, which will default
             * to this `EmptyOutletComponent`.
             */
            var ɵEmptyOutletComponent = /** @class */ (function () {
                function ɵEmptyOutletComponent() {
                }
                return ɵEmptyOutletComponent;
            }());
            ɵEmptyOutletComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{ template: "<router-outlet></router-outlet>" }] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * The primary routing outlet.
             *
             * \@publicApi
             * @type {?}
             */
            var PRIMARY_OUTLET = 'primary';
            /**
             * A map that provides access to the required and optional parameters
             * specific to a route.
             * The map supports retrieving a single value with `get()`
             * or multiple values with `getAll()`.
             *
             * @see [URLSearchParams](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
             *
             * \@publicApi
             * @record
             */
            function ParamMap() { }
            if (false) { }
            var ParamsAsMap = /** @class */ (function () {
                /**
                 * @param {?} params
                 */
                function ParamsAsMap(params) {
                    this.params = params || {};
                }
                /**
                 * @param {?} name
                 * @return {?}
                 */
                ParamsAsMap.prototype.has = function (name) { return this.params.hasOwnProperty(name); };
                /**
                 * @param {?} name
                 * @return {?}
                 */
                ParamsAsMap.prototype.get = function (name) {
                    if (this.has(name)) {
                        /** @type {?} */
                        var v = this.params[name];
                        return Array.isArray(v) ? v[0] : v;
                    }
                    return null;
                };
                /**
                 * @param {?} name
                 * @return {?}
                 */
                ParamsAsMap.prototype.getAll = function (name) {
                    if (this.has(name)) {
                        /** @type {?} */
                        var v = this.params[name];
                        return Array.isArray(v) ? v : [v];
                    }
                    return [];
                };
                Object.defineProperty(ParamsAsMap.prototype, "keys", {
                    /**
                     * @return {?}
                     */
                    get: function () { return Object.keys(this.params); },
                    enumerable: true,
                    configurable: true
                });
                return ParamsAsMap;
            }());
            if (false) { }
            /**
             * Converts a `Params` instance to a `ParamMap`.
             * \@publicApi
             * @param {?} params The instance to convert.
             * @return {?} The new map instance.
             *
             */
            function convertToParamMap(params) {
                return new ParamsAsMap(params);
            }
            /** @type {?} */
            var NAVIGATION_CANCELING_ERROR = 'ngNavigationCancelingError';
            /**
             * @param {?} message
             * @return {?}
             */
            function navigationCancelingError(message) {
                /** @type {?} */
                var error = Error('NavigationCancelingError: ' + message);
                (( /** @type {?} */(error)))[NAVIGATION_CANCELING_ERROR] = true;
                return error;
            }
            /**
             * @param {?} error
             * @return {?}
             */
            function isNavigationCancelingError(error) {
                return error && (( /** @type {?} */(error)))[NAVIGATION_CANCELING_ERROR];
            }
            // Matches the route configuration (`route`) against the actual URL (`segments`).
            /**
             * @param {?} segments
             * @param {?} segmentGroup
             * @param {?} route
             * @return {?}
             */
            function defaultUrlMatcher(segments, segmentGroup, route) {
                /** @type {?} */
                var parts = ( /** @type {?} */(route.path)).split('/');
                if (parts.length > segments.length) {
                    // The actual URL is shorter than the config, no match
                    return null;
                }
                if (route.pathMatch === 'full' &&
                    (segmentGroup.hasChildren() || parts.length < segments.length)) {
                    // The config is longer than the actual URL but we are looking for a full match, return null
                    return null;
                }
                /** @type {?} */
                var posParams = {};
                // Check each config part against the actual URL
                for (var index = 0; index < parts.length; index++) {
                    /** @type {?} */
                    var part = parts[index];
                    /** @type {?} */
                    var segment = segments[index];
                    /** @type {?} */
                    var isParameter = part.startsWith(':');
                    if (isParameter) {
                        posParams[part.substring(1)] = segment;
                    }
                    else if (part !== segment.path) {
                        // The actual URL part does not match the config, no match
                        return null;
                    }
                }
                return { consumed: segments.slice(0, parts.length), posParams: posParams };
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * A configuration object that defines a single route.
             * A set of routes are collected in a `Routes` array to define a `Router` configuration.
             * The router attempts to match segments of a given URL against each route,
             * using the configuration options defined in this object.
             *
             * Supports static, parameterized, redirect, and wildcard routes, as well as
             * custom route data and resolve methods.
             *
             * For detailed usage information, see the [Routing Guide](guide/router).
             *
             * \@usageNotes
             *
             * ### Simple Configuration
             *
             * The following route specifies that when navigating to, for example,
             * `/team/11/user/bob`, the router creates the 'Team' component
             * with the 'User' child component in it.
             *
             * ```
             * [{
             *   path: 'team/:id',
             *  component: Team,
             *   children: [{
             *     path: 'user/:name',
             *     component: User
             *   }]
             * }]
             * ```
             *
             * ### Multiple Outlets
             *
             * The following route creates sibling components with multiple outlets.
             * When navigating to `/team/11(aux:chat/jim)`, the router creates the 'Team' component next to
             * the 'Chat' component. The 'Chat' component is placed into the 'aux' outlet.
             *
             * ```
             * [{
             *   path: 'team/:id',
             *   component: Team
             * }, {
             *   path: 'chat/:user',
             *   component: Chat
             *   outlet: 'aux'
             * }]
             * ```
             *
             * ### Wild Cards
             *
             * The following route uses wild-card notation to specify a component
             * that is always instantiated regardless of where you navigate to.
             *
             * ```
             * [{
             *   path: '**',
             *   component: WildcardComponent
             * }]
             * ```
             *
             * ### Redirects
             *
             * The following route uses the `redirectTo` property to ignore a segment of
             * a given URL when looking for a child path.
             *
             * When navigating to '/team/11/legacy/user/jim', the router changes the URL segment
             * '/team/11/legacy/user/jim' to '/team/11/user/jim', and then instantiates
             * the Team component with the User child component in it.
             *
             * ```
             * [{
             *   path: 'team/:id',
             *   component: Team,
             *   children: [{
             *     path: 'legacy/user/:name',
             *     redirectTo: 'user/:name'
             *   }, {
             *     path: 'user/:name',
             *     component: User
             *   }]
             * }]
             * ```
             *
             * The redirect path can be relative, as shown in this example, or absolute.
             * If we change the `redirectTo` value in the example to the absolute URL segment '/user/:name',
             * the result URL is also absolute, '/user/jim'.
             * ### Empty Path
             *
             * Empty-path route configurations can be used to instantiate components that do not 'consume'
             * any URL segments.
             *
             * In the following configuration, when navigating to
             * `/team/11`, the router instantiates the 'AllUsers' component.
             *
             * ```
             * [{
             *   path: 'team/:id',
             *   component: Team,
             *   children: [{
             *     path: '',
             *     component: AllUsers
             *   }, {
             *     path: 'user/:name',
             *     component: User
             *   }]
             * }]
             * ```
             *
             * Empty-path routes can have children. In the following example, when navigating
             * to `/team/11/user/jim`, the router instantiates the wrapper component with
             * the user component in it.
             *
             * Note that an empty path route inherits its parent's parameters and data.
             *
             * ```
             * [{
             *   path: 'team/:id',
             *   component: Team,
             *   children: [{
             *     path: '',
             *     component: WrapperCmp,
             *     children: [{
             *       path: 'user/:name',
             *       component: User
             *     }]
             *   }]
             * }]
             * ```
             *
             * ### Matching Strategy
             *
             * The default path-match strategy is 'prefix', which means that the router
             * checks URL elements from the left to see if the URL matches a specified path.
             * For example, '/team/11/user' matches 'team/:id'.
             *
             * ```
             * [{
             *   path: '',
             *   pathMatch: 'prefix', //default
             *   redirectTo: 'main'
             * }, {
             *   path: 'main',
             *   component: Main
             * }]
             * ```
             *
             * You can specify the path-match strategy 'full' to make sure that the path
             * covers the whole unconsumed URL. It is important to do this when redirecting
             * empty-path routes. Otherwise, because an empty path is a prefix of any URL,
             * the router would apply the redirect even when navigating to the redirect destination,
             * creating an endless loop.
             *
             * In the following example, supplying the 'full' `pathMatch` strategy ensures
             * that the router applies the redirect if and only if navigating to '/'.
             *
             * ```
             * [{
             *   path: '',
             *   pathMatch: 'full',
             *   redirectTo: 'main'
             * }, {
             *   path: 'main',
             *   component: Main
             * }]
             * ```
             *
             * ### Componentless Routes
             *
             * You can share parameters between sibling components.
             * For example, suppose that two sibling components should go next to each other,
             * and both of them require an ID parameter. You can accomplish this using a route
             * that does not specify a component at the top level.
             *
             * In the following example, 'MainChild' and 'AuxChild' are siblings.
             * When navigating to 'parent/10/(a//aux:b)', the route instantiates
             * the main child and aux child components next to each other.
             * For this to work, the application component must have the primary and aux outlets defined.
             *
             * ```
             * [{
             *    path: 'parent/:id',
             *    children: [
             *      { path: 'a', component: MainChild },
             *      { path: 'b', component: AuxChild, outlet: 'aux' }
             *    ]
             * }]
             * ```
             *
             * The router merges the parameters, data, and resolve of the componentless
             * parent into the parameters, data, and resolve of the children.
             *
             * This is especially useful when child components are defined
             * with an empty path string, as in the following example.
             * With this configuration, navigating to '/parent/10' creates
             * the main child and aux components.
             *
             * ```
             * [{
             *    path: 'parent/:id',
             *    children: [
             *      { path: '', component: MainChild },
             *      { path: '', component: AuxChild, outlet: 'aux' }
             *    ]
             * }]
             * ```
             *
             * ### Lazy Loading
             *
             * Lazy loading speeds up application load time by splitting the application
             * into multiple bundles and loading them on demand.
             * To use lazy loading, provide the `loadChildren` property  instead of the `children` property.
             *
             * Given the following example route, the router will lazy load
             * the associated module on demand using the browser native import system.
             *
             * ```
             * [{
             *   path: 'lazy',
             *   loadChildren: () => import('./lazy-route/lazy.module').then(mod => mod.LazyModule),
             * }];
             * ```
             *
             * \@publicApi
             * @record
             */
            function Route() { }
            if (false) { }
            var LoadedRouterConfig = /** @class */ (function () {
                /**
                 * @param {?} routes
                 * @param {?} module
                 */
                function LoadedRouterConfig(routes, module) {
                    this.routes = routes;
                    this.module = module;
                }
                return LoadedRouterConfig;
            }());
            if (false) { }
            /**
             * @param {?} config
             * @param {?=} parentPath
             * @return {?}
             */
            function validateConfig(config, parentPath) {
                if (parentPath === void 0) { parentPath = ''; }
                // forEach doesn't iterate undefined values
                for (var i = 0; i < config.length; i++) {
                    /** @type {?} */
                    var route = config[i];
                    /** @type {?} */
                    var fullPath = getFullPath(parentPath, route);
                    validateNode(route, fullPath);
                }
            }
            /**
             * @param {?} route
             * @param {?} fullPath
             * @return {?}
             */
            function validateNode(route, fullPath) {
                if (!route) {
                    throw new Error("\n      Invalid configuration of route '" + fullPath + "': Encountered undefined route.\n      The reason might be an extra comma.\n\n      Example:\n      const routes: Routes = [\n        { path: '', redirectTo: '/dashboard', pathMatch: 'full' },\n        { path: 'dashboard',  component: DashboardComponent },, << two commas\n        { path: 'detail/:id', component: HeroDetailComponent }\n      ];\n    ");
                }
                if (Array.isArray(route)) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': Array cannot be specified");
                }
                if (!route.component && !route.children && !route.loadChildren &&
                    (route.outlet && route.outlet !== PRIMARY_OUTLET)) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': a componentless route without children or loadChildren cannot have a named outlet set");
                }
                if (route.redirectTo && route.children) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and children cannot be used together");
                }
                if (route.redirectTo && route.loadChildren) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and loadChildren cannot be used together");
                }
                if (route.children && route.loadChildren) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': children and loadChildren cannot be used together");
                }
                if (route.redirectTo && route.component) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and component cannot be used together");
                }
                if (route.path && route.matcher) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': path and matcher cannot be used together");
                }
                if (route.redirectTo === void 0 && !route.component && !route.children && !route.loadChildren) {
                    throw new Error("Invalid configuration of route '" + fullPath + "'. One of the following must be provided: component, redirectTo, children or loadChildren");
                }
                if (route.path === void 0 && route.matcher === void 0) {
                    throw new Error("Invalid configuration of route '" + fullPath + "': routes must have either a path or a matcher specified");
                }
                if (typeof route.path === 'string' && route.path.charAt(0) === '/') {
                    throw new Error("Invalid configuration of route '" + fullPath + "': path cannot start with a slash");
                }
                if (route.path === '' && route.redirectTo !== void 0 && route.pathMatch === void 0) {
                    /** @type {?} */
                    var exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
                    throw new Error("Invalid configuration of route '{path: \"" + fullPath + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
                }
                if (route.pathMatch !== void 0 && route.pathMatch !== 'full' && route.pathMatch !== 'prefix') {
                    throw new Error("Invalid configuration of route '" + fullPath + "': pathMatch can only be set to 'prefix' or 'full'");
                }
                if (route.children) {
                    validateConfig(route.children, fullPath);
                }
            }
            /**
             * @param {?} parentPath
             * @param {?} currentRoute
             * @return {?}
             */
            function getFullPath(parentPath, currentRoute) {
                if (!currentRoute) {
                    return parentPath;
                }
                if (!parentPath && !currentRoute.path) {
                    return '';
                }
                else if (parentPath && !currentRoute.path) {
                    return parentPath + "/";
                }
                else if (!parentPath && currentRoute.path) {
                    return currentRoute.path;
                }
                else {
                    return parentPath + "/" + currentRoute.path;
                }
            }
            /**
             * Makes a copy of the config and adds any default required properties.
             * @param {?} r
             * @return {?}
             */
            function standardizeConfig(r) {
                /** @type {?} */
                var children = r.children && r.children.map(standardizeConfig);
                /** @type {?} */
                var c = children ? Object.assign({}, r, { children: children }) : Object.assign({}, r);
                if (!c.component && (children || c.loadChildren) && (c.outlet && c.outlet !== PRIMARY_OUTLET)) {
                    c.component = ɵEmptyOutletComponent;
                }
                return c;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function shallowEqualArrays(a, b) {
                if (a.length !== b.length)
                    return false;
                for (var i = 0; i < a.length; ++i) {
                    if (!shallowEqual(a[i], b[i]))
                        return false;
                }
                return true;
            }
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function shallowEqual(a, b) {
                // Casting Object.keys return values to include `undefined` as there are some cases
                // in IE 11 where this can happen. Cannot provide a test because the behavior only
                // exists in certain circumstances in IE 11, therefore doing this cast ensures the
                // logic is correct for when this edge case is hit.
                /** @type {?} */
                var k1 = ( /** @type {?} */(Object.keys(a)));
                /** @type {?} */
                var k2 = ( /** @type {?} */(Object.keys(b)));
                if (!k1 || !k2 || k1.length != k2.length) {
                    return false;
                }
                /** @type {?} */
                var key;
                for (var i = 0; i < k1.length; i++) {
                    key = k1[i];
                    if (a[key] !== b[key]) {
                        return false;
                    }
                }
                return true;
            }
            /**
             * Flattens single-level nested arrays.
             * @template T
             * @param {?} arr
             * @return {?}
             */
            function flatten(arr) {
                return Array.prototype.concat.apply([], arr);
            }
            /**
             * Return the last element of an array.
             * @template T
             * @param {?} a
             * @return {?}
             */
            function last(a) {
                return a.length > 0 ? a[a.length - 1] : null;
            }
            /**
             * Verifys all booleans in an array are `true`.
             * @param {?} bools
             * @return {?}
             */
            function and(bools) {
                return !bools.some(( /**
                 * @param {?} v
                 * @return {?}
                 */function (/**
                 * @param {?} v
                 * @return {?}
                 */ v) { return !v; }));
            }
            /**
             * @template K, V
             * @param {?} map
             * @param {?} callback
             * @return {?}
             */
            function forEach(map, callback) {
                for (var prop in map) {
                    if (map.hasOwnProperty(prop)) {
                        callback(map[prop], prop);
                    }
                }
            }
            /**
             * @template A, B
             * @param {?} obj
             * @param {?} fn
             * @return {?}
             */
            function waitForMap(obj, fn) {
                if (Object.keys(obj).length === 0) {
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])({});
                }
                /** @type {?} */
                var waitHead = [];
                /** @type {?} */
                var waitTail = [];
                /** @type {?} */
                var res = {};
                forEach(obj, ( /**
                 * @param {?} a
                 * @param {?} k
                 * @return {?}
                 */function (a, k) {
                    /** @type {?} */
                    var mapped = fn(k, a).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) { return res[k] = r; })));
                    if (k === PRIMARY_OUTLET) {
                        waitHead.push(mapped);
                    }
                    else {
                        waitTail.push(mapped);
                    }
                }));
                // Closure compiler has problem with using spread operator here. So we use "Array.concat".
                // Note that we also need to cast the new promise because TypeScript cannot infer the type
                // when calling the "of" function through "Function.apply"
                return (( /** @type {?} */(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"].apply(null, waitHead.concat(waitTail)))))
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatAll"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["last"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
             * @return {?}
             */function () { return res; })));
            }
            /**
             * @template T
             * @param {?} value
             * @return {?}
             */
            function wrapIntoObservable(value) {
                if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵisObservable"])(value)) {
                    return value;
                }
                if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵisPromise"])(value)) {
                    // Use `Promise.resolve()` to wrap promise-like instances.
                    // Required ie when a Resolver returns a AngularJS `$q` promise to correctly trigger the
                    // change detection.
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(Promise.resolve(value));
                }
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(value);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @return {?}
             */
            function createEmptyUrlTree() {
                return new UrlTree(new UrlSegmentGroup([], {}), {}, null);
            }
            /**
             * @param {?} container
             * @param {?} containee
             * @param {?} exact
             * @return {?}
             */
            function containsTree(container, containee, exact) {
                if (exact) {
                    return equalQueryParams(container.queryParams, containee.queryParams) &&
                        equalSegmentGroups(container.root, containee.root);
                }
                return containsQueryParams(container.queryParams, containee.queryParams) &&
                    containsSegmentGroup(container.root, containee.root);
            }
            /**
             * @param {?} container
             * @param {?} containee
             * @return {?}
             */
            function equalQueryParams(container, containee) {
                // TODO: This does not handle array params correctly.
                return shallowEqual(container, containee);
            }
            /**
             * @param {?} container
             * @param {?} containee
             * @return {?}
             */
            function equalSegmentGroups(container, containee) {
                if (!equalPath(container.segments, containee.segments))
                    return false;
                if (container.numberOfChildren !== containee.numberOfChildren)
                    return false;
                for (var c in containee.children) {
                    if (!container.children[c])
                        return false;
                    if (!equalSegmentGroups(container.children[c], containee.children[c]))
                        return false;
                }
                return true;
            }
            /**
             * @param {?} container
             * @param {?} containee
             * @return {?}
             */
            function containsQueryParams(container, containee) {
                // TODO: This does not handle array params correctly.
                return Object.keys(containee).length <= Object.keys(container).length &&
                    Object.keys(containee).every(( /**
                     * @param {?} key
                     * @return {?}
                     */function (/**
                     * @param {?} key
                     * @return {?}
                     */ key) { return containee[key] === container[key]; }));
            }
            /**
             * @param {?} container
             * @param {?} containee
             * @return {?}
             */
            function containsSegmentGroup(container, containee) {
                return containsSegmentGroupHelper(container, containee, containee.segments);
            }
            /**
             * @param {?} container
             * @param {?} containee
             * @param {?} containeePaths
             * @return {?}
             */
            function containsSegmentGroupHelper(container, containee, containeePaths) {
                if (container.segments.length > containeePaths.length) {
                    /** @type {?} */
                    var current = container.segments.slice(0, containeePaths.length);
                    if (!equalPath(current, containeePaths))
                        return false;
                    if (containee.hasChildren())
                        return false;
                    return true;
                }
                else if (container.segments.length === containeePaths.length) {
                    if (!equalPath(container.segments, containeePaths))
                        return false;
                    for (var c in containee.children) {
                        if (!container.children[c])
                            return false;
                        if (!containsSegmentGroup(container.children[c], containee.children[c]))
                            return false;
                    }
                    return true;
                }
                else {
                    /** @type {?} */
                    var current = containeePaths.slice(0, container.segments.length);
                    /** @type {?} */
                    var next = containeePaths.slice(container.segments.length);
                    if (!equalPath(container.segments, current))
                        return false;
                    if (!container.children[PRIMARY_OUTLET])
                        return false;
                    return containsSegmentGroupHelper(container.children[PRIMARY_OUTLET], containee, next);
                }
            }
            /**
             * \@description
             *
             * Represents the parsed URL.
             *
             * Since a router state is a tree, and the URL is nothing but a serialized state, the URL is a
             * serialized tree.
             * UrlTree is a data structure that provides a lot of affordances in dealing with URLs
             *
             * \@usageNotes
             * ### Example
             *
             * ```
             * \@Component({templateUrl:'template.html'})
             * class MyComponent {
             *   constructor(router: Router) {
             *     const tree: UrlTree =
             *       router.parseUrl('/team/33/(user/victor//support:help)?debug=true#fragment');
             *     const f = tree.fragment; // return 'fragment'
             *     const q = tree.queryParams; // returns {debug: 'true'}
             *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
             *     const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'
             *     g.children[PRIMARY_OUTLET].segments; // returns 2 segments 'user' and 'victor'
             *     g.children['support'].segments; // return 1 segment 'help'
             *   }
             * }
             * ```
             *
             * \@publicApi
             */
            var UrlTree = /** @class */ (function () {
                /**
                 * \@internal
                 * @param {?} root
                 * @param {?} queryParams
                 * @param {?} fragment
                 */
                function UrlTree(root, queryParams, fragment) {
                    this.root = root;
                    this.queryParams = queryParams;
                    this.fragment = fragment;
                }
                Object.defineProperty(UrlTree.prototype, "queryParamMap", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (!this._queryParamMap) {
                            this._queryParamMap = convertToParamMap(this.queryParams);
                        }
                        return this._queryParamMap;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                UrlTree.prototype.toString = function () { return DEFAULT_SERIALIZER.serialize(this); };
                return UrlTree;
            }());
            if (false) { }
            /**
             * \@description
             *
             * Represents the parsed URL segment group.
             *
             * See `UrlTree` for more information.
             *
             * \@publicApi
             */
            var UrlSegmentGroup = /** @class */ (function () {
                /**
                 * @param {?} segments
                 * @param {?} children
                 */
                function UrlSegmentGroup(segments, children) {
                    var _this = this;
                    this.segments = segments;
                    this.children = children;
                    /**
                     * The parent node in the url tree
                     */
                    this.parent = null;
                    forEach(children, ( /**
                     * @template THIS
                     * @this {THIS}
                     * @param {?} v
                     * @param {?} k
                     * @return {THIS}
                     */function (v, k) { return v.parent = _this; }));
                }
                /**
                 * Whether the segment has child segments
                 * @return {?}
                 */
                UrlSegmentGroup.prototype.hasChildren = function () { return this.numberOfChildren > 0; };
                Object.defineProperty(UrlSegmentGroup.prototype, "numberOfChildren", {
                    /**
                     * Number of child segments
                     * @return {?}
                     */
                    get: function () { return Object.keys(this.children).length; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                UrlSegmentGroup.prototype.toString = function () { return serializePaths(this); };
                return UrlSegmentGroup;
            }());
            if (false) { }
            /**
             * \@description
             *
             * Represents a single URL segment.
             *
             * A UrlSegment is a part of a URL between the two slashes. It contains a path and the matrix
             * parameters associated with the segment.
             *
             * \@usageNotes
             *  ### Example
             *
             * ```
             * \@Component({templateUrl:'template.html'})
             * class MyComponent {
             *   constructor(router: Router) {
             *     const tree: UrlTree = router.parseUrl('/team;id=33');
             *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
             *     const s: UrlSegment[] = g.segments;
             *     s[0].path; // returns 'team'
             *     s[0].parameters; // returns {id: 33}
             *   }
             * }
             * ```
             *
             * \@publicApi
             */
            var UrlSegment = /** @class */ (function () {
                /**
                 * @param {?} path
                 * @param {?} parameters
                 */
                function UrlSegment(path, parameters) {
                    this.path = path;
                    this.parameters = parameters;
                }
                Object.defineProperty(UrlSegment.prototype, "parameterMap", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (!this._parameterMap) {
                            this._parameterMap = convertToParamMap(this.parameters);
                        }
                        return this._parameterMap;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                UrlSegment.prototype.toString = function () { return serializePath(this); };
                return UrlSegment;
            }());
            if (false) { }
            /**
             * @param {?} as
             * @param {?} bs
             * @return {?}
             */
            function equalSegments(as, bs) {
                return equalPath(as, bs) && as.every(( /**
                 * @param {?} a
                 * @param {?} i
                 * @return {?}
                 */function (a, i) { return shallowEqual(a.parameters, bs[i].parameters); }));
            }
            /**
             * @param {?} as
             * @param {?} bs
             * @return {?}
             */
            function equalPath(as, bs) {
                if (as.length !== bs.length)
                    return false;
                return as.every(( /**
                 * @param {?} a
                 * @param {?} i
                 * @return {?}
                 */function (a, i) { return a.path === bs[i].path; }));
            }
            /**
             * @template T
             * @param {?} segment
             * @param {?} fn
             * @return {?}
             */
            function mapChildrenIntoArray(segment, fn) {
                /** @type {?} */
                var res = [];
                forEach(segment.children, ( /**
                 * @param {?} child
                 * @param {?} childOutlet
                 * @return {?}
                 */function (child, childOutlet) {
                    if (childOutlet === PRIMARY_OUTLET) {
                        res = res.concat(fn(child, childOutlet));
                    }
                }));
                forEach(segment.children, ( /**
                 * @param {?} child
                 * @param {?} childOutlet
                 * @return {?}
                 */function (child, childOutlet) {
                    if (childOutlet !== PRIMARY_OUTLET) {
                        res = res.concat(fn(child, childOutlet));
                    }
                }));
                return res;
            }
            /**
             * \@description
             *
             * Serializes and deserializes a URL string into a URL tree.
             *
             * The url serialization strategy is customizable. You can
             * make all URLs case insensitive by providing a custom UrlSerializer.
             *
             * See `DefaultUrlSerializer` for an example of a URL serializer.
             *
             * \@publicApi
             * @abstract
             */
            var UrlSerializer = /** @class */ (function () {
                function UrlSerializer() {
                }
                return UrlSerializer;
            }());
            if (false) { }
            /**
             * \@description
             *
             * A default implementation of the `UrlSerializer`.
             *
             * Example URLs:
             *
             * ```
             * /inbox/33(popup:compose)
             * /inbox/33;open=true/messages/44
             * ```
             *
             * DefaultUrlSerializer uses parentheses to serialize secondary segments (e.g., popup:compose), the
             * colon syntax to specify the outlet, and the ';parameter=value' syntax (e.g., open=true) to
             * specify route specific parameters.
             *
             * \@publicApi
             */
            var DefaultUrlSerializer = /** @class */ (function () {
                function DefaultUrlSerializer() {
                }
                /**
                 * Parses a url into a `UrlTree`
                 * @param {?} url
                 * @return {?}
                 */
                DefaultUrlSerializer.prototype.parse = function (url) {
                    /** @type {?} */
                    var p = new UrlParser(url);
                    return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
                };
                /**
                 * Converts a `UrlTree` into a url
                 * @param {?} tree
                 * @return {?}
                 */
                DefaultUrlSerializer.prototype.serialize = function (tree) {
                    /** @type {?} */
                    var segment = "/" + serializeSegment(tree.root, true);
                    /** @type {?} */
                    var query = serializeQueryParams(tree.queryParams);
                    /** @type {?} */
                    var fragment = typeof tree.fragment === "string" ? "#" + encodeUriFragment(( /** @type {?} */(tree.fragment))) : '';
                    return "" + segment + query + fragment;
                };
                return DefaultUrlSerializer;
            }());
            /** @type {?} */
            var DEFAULT_SERIALIZER = new DefaultUrlSerializer();
            /**
             * @param {?} segment
             * @return {?}
             */
            function serializePaths(segment) {
                return segment.segments.map(( /**
                 * @param {?} p
                 * @return {?}
                 */function (/**
                 * @param {?} p
                 * @return {?}
                 */ p) { return serializePath(p); })).join('/');
            }
            /**
             * @param {?} segment
             * @param {?} root
             * @return {?}
             */
            function serializeSegment(segment, root) {
                if (!segment.hasChildren()) {
                    return serializePaths(segment);
                }
                if (root) {
                    /** @type {?} */
                    var primary = segment.children[PRIMARY_OUTLET] ?
                        serializeSegment(segment.children[PRIMARY_OUTLET], false) :
                        '';
                    /** @type {?} */
                    var children_2 = [];
                    forEach(segment.children, ( /**
                     * @param {?} v
                     * @param {?} k
                     * @return {?}
                     */function (v, k) {
                        if (k !== PRIMARY_OUTLET) {
                            children_2.push(k + ":" + serializeSegment(v, false));
                        }
                    }));
                    return children_2.length > 0 ? primary + "(" + children_2.join('//') + ")" : primary;
                }
                else {
                    /** @type {?} */
                    var children = mapChildrenIntoArray(segment, ( /**
                     * @param {?} v
                     * @param {?} k
                     * @return {?}
                     */function (v, k) {
                        if (k === PRIMARY_OUTLET) {
                            return [serializeSegment(segment.children[PRIMARY_OUTLET], false)];
                        }
                        return [k + ":" + serializeSegment(v, false)];
                    }));
                    return serializePaths(segment) + "/(" + children.join('//') + ")";
                }
            }
            /**
             * Encodes a URI string with the default encoding. This function will only ever be called from
             * `encodeUriQuery` or `encodeUriSegment` as it's the base set of encodings to be used. We need
             * a custom encoding because encodeURIComponent is too aggressive and encodes stuff that doesn't
             * have to be encoded per https://url.spec.whatwg.org.
             * @param {?} s
             * @return {?}
             */
            function encodeUriString(s) {
                return encodeURIComponent(s)
                    .replace(/%40/g, '@')
                    .replace(/%3A/gi, ':')
                    .replace(/%24/g, '$')
                    .replace(/%2C/gi, ',');
            }
            /**
             * This function should be used to encode both keys and values in a query string key/value. In
             * the following URL, you need to call encodeUriQuery on "k" and "v":
             *
             * http://www.site.org/html;mk=mv?k=v#f
             * @param {?} s
             * @return {?}
             */
            function encodeUriQuery(s) {
                return encodeUriString(s).replace(/%3B/gi, ';');
            }
            /**
             * This function should be used to encode a URL fragment. In the following URL, you need to call
             * encodeUriFragment on "f":
             *
             * http://www.site.org/html;mk=mv?k=v#f
             * @param {?} s
             * @return {?}
             */
            function encodeUriFragment(s) {
                return encodeURI(s);
            }
            /**
             * This function should be run on any URI segment as well as the key and value in a key/value
             * pair for matrix params. In the following URL, you need to call encodeUriSegment on "html",
             * "mk", and "mv":
             *
             * http://www.site.org/html;mk=mv?k=v#f
             * @param {?} s
             * @return {?}
             */
            function encodeUriSegment(s) {
                return encodeUriString(s).replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/%26/gi, '&');
            }
            /**
             * @param {?} s
             * @return {?}
             */
            function decode(s) {
                return decodeURIComponent(s);
            }
            // Query keys/values should have the "+" replaced first, as "+" in a query string is " ".
            // decodeURIComponent function will not decode "+" as a space.
            /**
             * @param {?} s
             * @return {?}
             */
            function decodeQuery(s) {
                return decode(s.replace(/\+/g, '%20'));
            }
            /**
             * @param {?} path
             * @return {?}
             */
            function serializePath(path) {
                return "" + encodeUriSegment(path.path) + serializeMatrixParams(path.parameters);
            }
            /**
             * @param {?} params
             * @return {?}
             */
            function serializeMatrixParams(params) {
                return Object.keys(params)
                    .map(( /**
             * @param {?} key
             * @return {?}
             */function (/**
             * @param {?} key
             * @return {?}
             */ key) { return ";" + encodeUriSegment(key) + "=" + encodeUriSegment(params[key]); }))
                    .join('');
            }
            /**
             * @param {?} params
             * @return {?}
             */
            function serializeQueryParams(params) {
                /** @type {?} */
                var strParams = Object.keys(params).map(( /**
                 * @param {?} name
                 * @return {?}
                 */function (name) {
                    /** @type {?} */
                    var value = params[name];
                    return Array.isArray(value) ?
                        value.map(( /**
                         * @param {?} v
                         * @return {?}
                         */function (/**
                         * @param {?} v
                         * @return {?}
                         */ v) { return encodeUriQuery(name) + "=" + encodeUriQuery(v); })).join('&') :
                        encodeUriQuery(name) + "=" + encodeUriQuery(value);
                }));
                return strParams.length ? "?" + strParams.join("&") : '';
            }
            /** @type {?} */
            var SEGMENT_RE = /^[^\/()?;=#]+/;
            /**
             * @param {?} str
             * @return {?}
             */
            function matchSegments(str) {
                /** @type {?} */
                var match = str.match(SEGMENT_RE);
                return match ? match[0] : '';
            }
            /** @type {?} */
            var QUERY_PARAM_RE = /^[^=?&#]+/;
            // Return the name of the query param at the start of the string or an empty string
            /**
             * @param {?} str
             * @return {?}
             */
            function matchQueryParams(str) {
                /** @type {?} */
                var match = str.match(QUERY_PARAM_RE);
                return match ? match[0] : '';
            }
            /** @type {?} */
            var QUERY_PARAM_VALUE_RE = /^[^?&#]+/;
            // Return the value of the query param at the start of the string or an empty string
            /**
             * @param {?} str
             * @return {?}
             */
            function matchUrlQueryParamValue(str) {
                /** @type {?} */
                var match = str.match(QUERY_PARAM_VALUE_RE);
                return match ? match[0] : '';
            }
            var UrlParser = /** @class */ (function () {
                /**
                 * @param {?} url
                 */
                function UrlParser(url) {
                    this.url = url;
                    this.remaining = url;
                }
                /**
                 * @return {?}
                 */
                UrlParser.prototype.parseRootSegment = function () {
                    this.consumeOptional('/');
                    if (this.remaining === '' || this.peekStartsWith('?') || this.peekStartsWith('#')) {
                        return new UrlSegmentGroup([], {});
                    }
                    // The root segment group never has segments
                    return new UrlSegmentGroup([], this.parseChildren());
                };
                /**
                 * @return {?}
                 */
                UrlParser.prototype.parseQueryParams = function () {
                    /** @type {?} */
                    var params = {};
                    if (this.consumeOptional('?')) {
                        do {
                            this.parseQueryParam(params);
                        } while (this.consumeOptional('&'));
                    }
                    return params;
                };
                /**
                 * @return {?}
                 */
                UrlParser.prototype.parseFragment = function () {
                    return this.consumeOptional('#') ? decodeURIComponent(this.remaining) : null;
                };
                /**
                 * @private
                 * @return {?}
                 */
                UrlParser.prototype.parseChildren = function () {
                    if (this.remaining === '') {
                        return {};
                    }
                    this.consumeOptional('/');
                    /** @type {?} */
                    var segments = [];
                    if (!this.peekStartsWith('(')) {
                        segments.push(this.parseSegment());
                    }
                    while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
                        this.capture('/');
                        segments.push(this.parseSegment());
                    }
                    /** @type {?} */
                    var children = {};
                    if (this.peekStartsWith('/(')) {
                        this.capture('/');
                        children = this.parseParens(true);
                    }
                    /** @type {?} */
                    var res = {};
                    if (this.peekStartsWith('(')) {
                        res = this.parseParens(false);
                    }
                    if (segments.length > 0 || Object.keys(children).length > 0) {
                        res[PRIMARY_OUTLET] = new UrlSegmentGroup(segments, children);
                    }
                    return res;
                };
                // parse a segment with its matrix parameters
                // ie `name;k1=v1;k2`
                /**
                 * @private
                 * @return {?}
                 */
                UrlParser.prototype.parseSegment = function () {
                    /** @type {?} */
                    var path = matchSegments(this.remaining);
                    if (path === '' && this.peekStartsWith(';')) {
                        throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
                    }
                    this.capture(path);
                    return new UrlSegment(decode(path), this.parseMatrixParams());
                };
                /**
                 * @private
                 * @return {?}
                 */
                UrlParser.prototype.parseMatrixParams = function () {
                    /** @type {?} */
                    var params = {};
                    while (this.consumeOptional(';')) {
                        this.parseParam(params);
                    }
                    return params;
                };
                /**
                 * @private
                 * @param {?} params
                 * @return {?}
                 */
                UrlParser.prototype.parseParam = function (params) {
                    /** @type {?} */
                    var key = matchSegments(this.remaining);
                    if (!key) {
                        return;
                    }
                    this.capture(key);
                    /** @type {?} */
                    var value = '';
                    if (this.consumeOptional('=')) {
                        /** @type {?} */
                        var valueMatch = matchSegments(this.remaining);
                        if (valueMatch) {
                            value = valueMatch;
                            this.capture(value);
                        }
                    }
                    params[decode(key)] = decode(value);
                };
                // Parse a single query parameter `name[=value]`
                /**
                 * @private
                 * @param {?} params
                 * @return {?}
                 */
                UrlParser.prototype.parseQueryParam = function (params) {
                    /** @type {?} */
                    var key = matchQueryParams(this.remaining);
                    if (!key) {
                        return;
                    }
                    this.capture(key);
                    /** @type {?} */
                    var value = '';
                    if (this.consumeOptional('=')) {
                        /** @type {?} */
                        var valueMatch = matchUrlQueryParamValue(this.remaining);
                        if (valueMatch) {
                            value = valueMatch;
                            this.capture(value);
                        }
                    }
                    /** @type {?} */
                    var decodedKey = decodeQuery(key);
                    /** @type {?} */
                    var decodedVal = decodeQuery(value);
                    if (params.hasOwnProperty(decodedKey)) {
                        // Append to existing values
                        /** @type {?} */
                        var currentVal = params[decodedKey];
                        if (!Array.isArray(currentVal)) {
                            currentVal = [currentVal];
                            params[decodedKey] = currentVal;
                        }
                        currentVal.push(decodedVal);
                    }
                    else {
                        // Create a new value
                        params[decodedKey] = decodedVal;
                    }
                };
                // parse `(a/b//outlet_name:c/d)`
                /**
                 * @private
                 * @param {?} allowPrimary
                 * @return {?}
                 */
                UrlParser.prototype.parseParens = function (allowPrimary) {
                    /** @type {?} */
                    var segments = {};
                    this.capture('(');
                    while (!this.consumeOptional(')') && this.remaining.length > 0) {
                        /** @type {?} */
                        var path = matchSegments(this.remaining);
                        /** @type {?} */
                        var next = this.remaining[path.length];
                        // if is is not one of these characters, then the segment was unescaped
                        // or the group was not closed
                        if (next !== '/' && next !== ')' && next !== ';') {
                            throw new Error("Cannot parse url '" + this.url + "'");
                        }
                        /** @type {?} */
                        var outletName = ( /** @type {?} */(undefined));
                        if (path.indexOf(':') > -1) {
                            outletName = path.substr(0, path.indexOf(':'));
                            this.capture(outletName);
                            this.capture(':');
                        }
                        else if (allowPrimary) {
                            outletName = PRIMARY_OUTLET;
                        }
                        /** @type {?} */
                        var children = this.parseChildren();
                        segments[outletName] = Object.keys(children).length === 1 ? children[PRIMARY_OUTLET] :
                            new UrlSegmentGroup([], children);
                        this.consumeOptional('//');
                    }
                    return segments;
                };
                /**
                 * @private
                 * @param {?} str
                 * @return {?}
                 */
                UrlParser.prototype.peekStartsWith = function (str) { return this.remaining.startsWith(str); };
                // Consumes the prefix when it is present and returns whether it has been consumed
                /**
                 * @private
                 * @param {?} str
                 * @return {?}
                 */
                UrlParser.prototype.consumeOptional = function (str) {
                    if (this.peekStartsWith(str)) {
                        this.remaining = this.remaining.substring(str.length);
                        return true;
                    }
                    return false;
                };
                /**
                 * @private
                 * @param {?} str
                 * @return {?}
                 */
                UrlParser.prototype.capture = function (str) {
                    if (!this.consumeOptional(str)) {
                        throw new Error("Expected \"" + str + "\".");
                    }
                };
                return UrlParser;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * @template T
             */
            var Tree = /** @class */ (function () {
                /**
                 * @param {?} root
                 */
                function Tree(root) {
                    this._root = root;
                }
                Object.defineProperty(Tree.prototype, "root", {
                    /**
                     * @return {?}
                     */
                    get: function () { return this._root.value; },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * \@internal
                 * @param {?} t
                 * @return {?}
                 */
                Tree.prototype.parent = function (t) {
                    /** @type {?} */
                    var p = this.pathFromRoot(t);
                    return p.length > 1 ? p[p.length - 2] : null;
                };
                /**
                 * \@internal
                 * @param {?} t
                 * @return {?}
                 */
                Tree.prototype.children = function (t) {
                    /** @type {?} */
                    var n = findNode(t, this._root);
                    return n ? n.children.map(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return t.value; })) : [];
                };
                /**
                 * \@internal
                 * @param {?} t
                 * @return {?}
                 */
                Tree.prototype.firstChild = function (t) {
                    /** @type {?} */
                    var n = findNode(t, this._root);
                    return n && n.children.length > 0 ? n.children[0].value : null;
                };
                /**
                 * \@internal
                 * @param {?} t
                 * @return {?}
                 */
                Tree.prototype.siblings = function (t) {
                    /** @type {?} */
                    var p = findPath(t, this._root);
                    if (p.length < 2)
                        return [];
                    /** @type {?} */
                    var c = p[p.length - 2].children.map(( /**
                     * @param {?} c
                     * @return {?}
                     */function (/**
                     * @param {?} c
                     * @return {?}
                     */ c) { return c.value; }));
                    return c.filter(( /**
                     * @param {?} cc
                     * @return {?}
                     */function (/**
                     * @param {?} cc
                     * @return {?}
                     */ cc) { return cc !== t; }));
                };
                /**
                 * \@internal
                 * @param {?} t
                 * @return {?}
                 */
                Tree.prototype.pathFromRoot = function (t) {
                    return findPath(t, this._root).map(( /**
                     * @param {?} s
                     * @return {?}
                     */function (/**
                     * @param {?} s
                     * @return {?}
                     */ s) { return s.value; }));
                };
                return Tree;
            }());
            if (false) { }
            // DFS for the node matching the value
            /**
             * @template T
             * @param {?} value
             * @param {?} node
             * @return {?}
             */
            function findNode(value, node) {
                if (value === node.value)
                    return node;
                for (var _c = 0, _d = node.children; _c < _d.length; _c++) {
                    var child = _d[_c];
                    /** @type {?} */
                    var node_1 = findNode(value, child);
                    if (node_1)
                        return node_1;
                }
                return null;
            }
            // Return the path to the node with the given value using DFS
            /**
             * @template T
             * @param {?} value
             * @param {?} node
             * @return {?}
             */
            function findPath(value, node) {
                if (value === node.value)
                    return [node];
                for (var _c = 0, _d = node.children; _c < _d.length; _c++) {
                    var child = _d[_c];
                    /** @type {?} */
                    var path = findPath(value, child);
                    if (path.length) {
                        path.unshift(node);
                        return path;
                    }
                }
                return [];
            }
            /**
             * @template T
             */
            var TreeNode = /** @class */ (function () {
                /**
                 * @param {?} value
                 * @param {?} children
                 */
                function TreeNode(value, children) {
                    this.value = value;
                    this.children = children;
                }
                /**
                 * @return {?}
                 */
                TreeNode.prototype.toString = function () { return "TreeNode(" + this.value + ")"; };
                return TreeNode;
            }());
            if (false) { }
            // Return the list of T indexed by outlet name
            /**
             * @template T
             * @param {?} node
             * @return {?}
             */
            function nodeChildrenAsMap(node) {
                /** @type {?} */
                var map = {};
                if (node) {
                    node.children.forEach(( /**
                     * @param {?} child
                     * @return {?}
                     */function (/**
                     * @param {?} child
                     * @return {?}
                     */ child) { return map[child.value.outlet] = child; }));
                }
                return map;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Represents the state of the router as a tree of activated routes.
             *
             * \@usageNotes
             *
             * Every node in the route tree is an `ActivatedRoute` instance
             * that knows about the "consumed" URL segments, the extracted parameters,
             * and the resolved data.
             * Use the `ActivatedRoute` properties to traverse the tree from any node.
             *
             * ### Example
             *
             * ```
             * \@Component({templateUrl:'template.html'})
             * class MyComponent {
             *   constructor(router: Router) {
             *     const state: RouterState = router.routerState;
             *     const root: ActivatedRoute = state.root;
             *     const child = root.firstChild;
             *     const id: Observable<string> = child.params.map(p => p.id);
             *     //...
             *   }
             * }
             * ```
             *
             * @see `ActivatedRoute`
             *
             * \@publicApi
             */
            var RouterState = /** @class */ (function (_super_1) {
                __extends(RouterState, _super_1);
                /**
                 * \@internal
                 * @param {?} root
                 * @param {?} snapshot
                 */
                function RouterState(root, snapshot) {
                    var _this = _super_1.call(this, root) || this;
                    _this.snapshot = snapshot;
                    setRouterState(( /** @type {?} */(_this)), root);
                    return _this;
                }
                /**
                 * @return {?}
                 */
                RouterState.prototype.toString = function () { return this.snapshot.toString(); };
                return RouterState;
            }(Tree));
            if (false) { }
            /**
             * @param {?} urlTree
             * @param {?} rootComponent
             * @return {?}
             */
            function createEmptyState(urlTree, rootComponent) {
                /** @type {?} */
                var snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
                /** @type {?} */
                var emptyUrl = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]([new UrlSegment('', {})]);
                /** @type {?} */
                var emptyParams = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
                /** @type {?} */
                var emptyData = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
                /** @type {?} */
                var emptyQueryParams = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
                /** @type {?} */
                var fragment = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]('');
                /** @type {?} */
                var activated = new ActivatedRoute(emptyUrl, emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, snapshot.root);
                activated.snapshot = snapshot.root;
                return new RouterState(new TreeNode(activated, []), snapshot);
            }
            /**
             * @param {?} urlTree
             * @param {?} rootComponent
             * @return {?}
             */
            function createEmptyStateSnapshot(urlTree, rootComponent) {
                /** @type {?} */
                var emptyParams = {};
                /** @type {?} */
                var emptyData = {};
                /** @type {?} */
                var emptyQueryParams = {};
                /** @type {?} */
                var fragment = '';
                /** @type {?} */
                var activated = new ActivatedRouteSnapshot([], emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, null, urlTree.root, -1, {});
                return new RouterStateSnapshot('', new TreeNode(activated, []));
            }
            /**
             * Provides access to information about a route associated with a component
             * that is loaded in an outlet.
             * Use to traverse the `RouterState` tree and extract information from nodes.
             *
             * {\@example router/activated-route/module.ts region="activated-route"
             *     header="activated-route.component.ts"}
             *
             * \@publicApi
             */
            var ActivatedRoute = /** @class */ (function () {
                /**
                 * \@internal
                 * @param {?} url
                 * @param {?} params
                 * @param {?} queryParams
                 * @param {?} fragment
                 * @param {?} data
                 * @param {?} outlet
                 * @param {?} component
                 * @param {?} futureSnapshot
                 */
                function ActivatedRoute(url, params, queryParams, fragment, data, outlet, component, futureSnapshot) {
                    this.url = url;
                    this.params = params;
                    this.queryParams = queryParams;
                    this.fragment = fragment;
                    this.data = data;
                    this.outlet = outlet;
                    this.component = component;
                    this._futureSnapshot = futureSnapshot;
                }
                Object.defineProperty(ActivatedRoute.prototype, "routeConfig", {
                    /**
                     * The configuration used to match this route.
                     * @return {?}
                     */
                    get: function () { return this._futureSnapshot.routeConfig; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "root", {
                    /**
                     * The root of the router state.
                     * @return {?}
                     */
                    get: function () { return this._routerState.root; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "parent", {
                    /**
                     * The parent of this route in the router state tree.
                     * @return {?}
                     */
                    get: function () { return this._routerState.parent(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "firstChild", {
                    /**
                     * The first child of this route in the router state tree.
                     * @return {?}
                     */
                    get: function () { return this._routerState.firstChild(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "children", {
                    /**
                     * The children of this route in the router state tree.
                     * @return {?}
                     */
                    get: function () { return this._routerState.children(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "pathFromRoot", {
                    /**
                     * The path from the root of the router state tree to this route.
                     * @return {?}
                     */
                    get: function () { return this._routerState.pathFromRoot(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "paramMap", {
                    /**
                     * An Observable that contains a map of the required and optional parameters
                     * specific to the route.
                     * The map supports retrieving single and multiple values from the same parameter.
                     * @return {?}
                     */
                    get: function () {
                        if (!this._paramMap) {
                            this._paramMap = this.params.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                             * @param {?} p
                             * @return {?}
                             */function (p) { return convertToParamMap(p); })));
                        }
                        return this._paramMap;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRoute.prototype, "queryParamMap", {
                    /**
                     * An Observable that contains a map of the query parameters available to all routes.
                     * The map supports retrieving single and multiple values from the query parameter.
                     * @return {?}
                     */
                    get: function () {
                        if (!this._queryParamMap) {
                            this._queryParamMap =
                                this.queryParams.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                                 * @param {?} p
                                 * @return {?}
                                 */function (p) { return convertToParamMap(p); })));
                        }
                        return this._queryParamMap;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ActivatedRoute.prototype.toString = function () {
                    return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
                };
                return ActivatedRoute;
            }());
            if (false) { }
            /**
             * Returns the inherited params, data, and resolve for a given route.
             * By default, this only inherits values up to the nearest path-less or component-less route.
             * \@internal
             * @param {?} route
             * @param {?=} paramsInheritanceStrategy
             * @return {?}
             */
            function inheritedParamsDataResolve(route, paramsInheritanceStrategy) {
                if (paramsInheritanceStrategy === void 0) { paramsInheritanceStrategy = 'emptyOnly'; }
                /** @type {?} */
                var pathFromRoot = route.pathFromRoot;
                /** @type {?} */
                var inheritingStartingFrom = 0;
                if (paramsInheritanceStrategy !== 'always') {
                    inheritingStartingFrom = pathFromRoot.length - 1;
                    while (inheritingStartingFrom >= 1) {
                        /** @type {?} */
                        var current = pathFromRoot[inheritingStartingFrom];
                        /** @type {?} */
                        var parent = pathFromRoot[inheritingStartingFrom - 1];
                        // current route is an empty path => inherits its parent's params and data
                        if (current.routeConfig && current.routeConfig.path === '') {
                            inheritingStartingFrom--;
                            // parent is componentless => current route should inherit its params and data
                        }
                        else if (!parent.component) {
                            inheritingStartingFrom--;
                        }
                        else {
                            break;
                        }
                    }
                }
                return flattenInherited(pathFromRoot.slice(inheritingStartingFrom));
            }
            /**
             * \@internal
             * @param {?} pathFromRoot
             * @return {?}
             */
            function flattenInherited(pathFromRoot) {
                return pathFromRoot.reduce(( /**
                 * @param {?} res
                 * @param {?} curr
                 * @return {?}
                 */function (res, curr) {
                    /** @type {?} */
                    var params = Object.assign({}, res.params, curr.params);
                    /** @type {?} */
                    var data = Object.assign({}, res.data, curr.data);
                    /** @type {?} */
                    var resolve = Object.assign({}, res.resolve, curr._resolvedData);
                    return { params: params, data: data, resolve: resolve };
                }), ( /** @type {?} */({ params: {}, data: {}, resolve: {} })));
            }
            /**
             * \@description
             *
             * Contains the information about a route associated with a component loaded in an
             * outlet at a particular moment in time. ActivatedRouteSnapshot can also be used to
             * traverse the router state tree.
             *
             * ```
             * \@Component({templateUrl:'./my-component.html'})
             * class MyComponent {
             *   constructor(route: ActivatedRoute) {
             *     const id: string = route.snapshot.params.id;
             *     const url: string = route.snapshot.url.join('');
             *     const user = route.snapshot.data.user;
             *   }
             * }
             * ```
             *
             * \@publicApi
             */
            var ActivatedRouteSnapshot = /** @class */ (function () {
                /**
                 * \@internal
                 * @param {?} url
                 * @param {?} params
                 * @param {?} queryParams
                 * @param {?} fragment
                 * @param {?} data
                 * @param {?} outlet
                 * @param {?} component
                 * @param {?} routeConfig
                 * @param {?} urlSegment
                 * @param {?} lastPathIndex
                 * @param {?} resolve
                 */
                function ActivatedRouteSnapshot(url, params, queryParams, fragment, data, outlet, component, routeConfig, urlSegment, lastPathIndex, resolve) {
                    this.url = url;
                    this.params = params;
                    this.queryParams = queryParams;
                    this.fragment = fragment;
                    this.data = data;
                    this.outlet = outlet;
                    this.component = component;
                    this.routeConfig = routeConfig;
                    this._urlSegment = urlSegment;
                    this._lastPathIndex = lastPathIndex;
                    this._resolve = resolve;
                }
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "root", {
                    /**
                     * The root of the router state
                     * @return {?}
                     */
                    get: function () { return this._routerState.root; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "parent", {
                    /**
                     * The parent of this route in the router state tree
                     * @return {?}
                     */
                    get: function () { return this._routerState.parent(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "firstChild", {
                    /**
                     * The first child of this route in the router state tree
                     * @return {?}
                     */
                    get: function () { return this._routerState.firstChild(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "children", {
                    /**
                     * The children of this route in the router state tree
                     * @return {?}
                     */
                    get: function () { return this._routerState.children(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "pathFromRoot", {
                    /**
                     * The path from the root of the router state tree to this route
                     * @return {?}
                     */
                    get: function () { return this._routerState.pathFromRoot(this); },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "paramMap", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (!this._paramMap) {
                            this._paramMap = convertToParamMap(this.params);
                        }
                        return this._paramMap;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(ActivatedRouteSnapshot.prototype, "queryParamMap", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (!this._queryParamMap) {
                            this._queryParamMap = convertToParamMap(this.queryParams);
                        }
                        return this._queryParamMap;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                ActivatedRouteSnapshot.prototype.toString = function () {
                    /** @type {?} */
                    var url = this.url.map(( /**
                     * @param {?} segment
                     * @return {?}
                     */function (/**
                     * @param {?} segment
                     * @return {?}
                     */ segment) { return segment.toString(); })).join('/');
                    /** @type {?} */
                    var matched = this.routeConfig ? this.routeConfig.path : '';
                    return "Route(url:'" + url + "', path:'" + matched + "')";
                };
                return ActivatedRouteSnapshot;
            }());
            if (false) { }
            /**
             * \@description
             *
             * Represents the state of the router at a moment in time.
             *
             * This is a tree of activated route snapshots. Every node in this tree knows about
             * the "consumed" URL segments, the extracted parameters, and the resolved data.
             *
             * \@usageNotes
             * ### Example
             *
             * ```
             * \@Component({templateUrl:'template.html'})
             * class MyComponent {
             *   constructor(router: Router) {
             *     const state: RouterState = router.routerState;
             *     const snapshot: RouterStateSnapshot = state.snapshot;
             *     const root: ActivatedRouteSnapshot = snapshot.root;
             *     const child = root.firstChild;
             *     const id: Observable<string> = child.params.map(p => p.id);
             *     //...
             *   }
             * }
             * ```
             *
             * \@publicApi
             */
            var RouterStateSnapshot = /** @class */ (function (_super_1) {
                __extends(RouterStateSnapshot, _super_1);
                /**
                 * \@internal
                 * @param {?} url
                 * @param {?} root
                 */
                function RouterStateSnapshot(url, root) {
                    var _this = _super_1.call(this, root) || this;
                    _this.url = url;
                    setRouterState(( /** @type {?} */(_this)), root);
                    return _this;
                }
                /**
                 * @return {?}
                 */
                RouterStateSnapshot.prototype.toString = function () { return serializeNode(this._root); };
                return RouterStateSnapshot;
            }(Tree));
            if (false) { }
            /**
             * @template U, T
             * @param {?} state
             * @param {?} node
             * @return {?}
             */
            function setRouterState(state, node) {
                node.value._routerState = state;
                node.children.forEach(( /**
                 * @param {?} c
                 * @return {?}
                 */function (/**
                 * @param {?} c
                 * @return {?}
                 */ c) { return setRouterState(state, c); }));
            }
            /**
             * @param {?} node
             * @return {?}
             */
            function serializeNode(node) {
                /** @type {?} */
                var c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(', ') + " } " : '';
                return "" + node.value + c;
            }
            /**
             * The expectation is that the activate route is created with the right set of parameters.
             * So we push new values into the observables only when they are not the initial values.
             * And we detect that by checking if the snapshot field is set.
             * @param {?} route
             * @return {?}
             */
            function advanceActivatedRoute(route) {
                if (route.snapshot) {
                    /** @type {?} */
                    var currentSnapshot = route.snapshot;
                    /** @type {?} */
                    var nextSnapshot = route._futureSnapshot;
                    route.snapshot = nextSnapshot;
                    if (!shallowEqual(currentSnapshot.queryParams, nextSnapshot.queryParams)) {
                        (( /** @type {?} */(route.queryParams))).next(nextSnapshot.queryParams);
                    }
                    if (currentSnapshot.fragment !== nextSnapshot.fragment) {
                        (( /** @type {?} */(route.fragment))).next(nextSnapshot.fragment);
                    }
                    if (!shallowEqual(currentSnapshot.params, nextSnapshot.params)) {
                        (( /** @type {?} */(route.params))).next(nextSnapshot.params);
                    }
                    if (!shallowEqualArrays(currentSnapshot.url, nextSnapshot.url)) {
                        (( /** @type {?} */(route.url))).next(nextSnapshot.url);
                    }
                    if (!shallowEqual(currentSnapshot.data, nextSnapshot.data)) {
                        (( /** @type {?} */(route.data))).next(nextSnapshot.data);
                    }
                }
                else {
                    route.snapshot = route._futureSnapshot;
                    // this is for resolved data
                    (( /** @type {?} */(route.data))).next(route._futureSnapshot.data);
                }
            }
            /**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function equalParamsAndUrlSegments(a, b) {
                /** @type {?} */
                var equalUrlParams = shallowEqual(a.params, b.params) && equalSegments(a.url, b.url);
                /** @type {?} */
                var parentsMismatch = !a.parent !== !b.parent;
                return equalUrlParams && !parentsMismatch &&
                    (!a.parent || equalParamsAndUrlSegments(a.parent, ( /** @type {?} */(b.parent))));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} routeReuseStrategy
             * @param {?} curr
             * @param {?} prevState
             * @return {?}
             */
            function createRouterState(routeReuseStrategy, curr, prevState) {
                /** @type {?} */
                var root = createNode(routeReuseStrategy, curr._root, prevState ? prevState._root : undefined);
                return new RouterState(root, curr);
            }
            /**
             * @param {?} routeReuseStrategy
             * @param {?} curr
             * @param {?=} prevState
             * @return {?}
             */
            function createNode(routeReuseStrategy, curr, prevState) {
                // reuse an activated route that is currently displayed on the screen
                if (prevState && routeReuseStrategy.shouldReuseRoute(curr.value, prevState.value.snapshot)) {
                    /** @type {?} */
                    var value = prevState.value;
                    value._futureSnapshot = curr.value;
                    /** @type {?} */
                    var children = createOrReuseChildren(routeReuseStrategy, curr, prevState);
                    return new TreeNode(value, children);
                    // retrieve an activated route that is used to be displayed, but is not currently displayed
                }
                else {
                    /** @type {?} */
                    var detachedRouteHandle = ( /** @type {?} */(routeReuseStrategy.retrieve(curr.value)));
                    if (detachedRouteHandle) {
                        /** @type {?} */
                        var tree_1 = detachedRouteHandle.route;
                        setFutureSnapshotsOfActivatedRoutes(curr, tree_1);
                        return tree_1;
                    }
                    else {
                        /** @type {?} */
                        var value = createActivatedRoute(curr.value);
                        /** @type {?} */
                        var children = curr.children.map(( /**
                         * @param {?} c
                         * @return {?}
                         */function (/**
                         * @param {?} c
                         * @return {?}
                         */ c) { return createNode(routeReuseStrategy, c); }));
                        return new TreeNode(value, children);
                    }
                }
            }
            /**
             * @param {?} curr
             * @param {?} result
             * @return {?}
             */
            function setFutureSnapshotsOfActivatedRoutes(curr, result) {
                if (curr.value.routeConfig !== result.value.routeConfig) {
                    throw new Error('Cannot reattach ActivatedRouteSnapshot created from a different route');
                }
                if (curr.children.length !== result.children.length) {
                    throw new Error('Cannot reattach ActivatedRouteSnapshot with a different number of children');
                }
                result.value._futureSnapshot = curr.value;
                for (var i = 0; i < curr.children.length; ++i) {
                    setFutureSnapshotsOfActivatedRoutes(curr.children[i], result.children[i]);
                }
            }
            /**
             * @param {?} routeReuseStrategy
             * @param {?} curr
             * @param {?} prevState
             * @return {?}
             */
            function createOrReuseChildren(routeReuseStrategy, curr, prevState) {
                return curr.children.map(( /**
                 * @param {?} child
                 * @return {?}
                 */function (/**
                 * @param {?} child
                 * @return {?}
                 */ child) {
                    for (var _c = 0, _d = prevState.children; _c < _d.length; _c++) {
                        var p = _d[_c];
                        if (routeReuseStrategy.shouldReuseRoute(p.value.snapshot, child.value)) {
                            return createNode(routeReuseStrategy, child, p);
                        }
                    }
                    return createNode(routeReuseStrategy, child);
                }));
            }
            /**
             * @param {?} c
             * @return {?}
             */
            function createActivatedRoute(c) {
                return new ActivatedRoute(new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](c.url), new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](c.params), new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](c.queryParams), new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](c.fragment), new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](c.data), c.outlet, c.component, c);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} route
             * @param {?} urlTree
             * @param {?} commands
             * @param {?} queryParams
             * @param {?} fragment
             * @return {?}
             */
            function createUrlTree(route, urlTree, commands, queryParams, fragment) {
                if (commands.length === 0) {
                    return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
                }
                /** @type {?} */
                var nav = computeNavigation(commands);
                if (nav.toRoot()) {
                    return tree(urlTree.root, new UrlSegmentGroup([], {}), urlTree, queryParams, fragment);
                }
                /** @type {?} */
                var startingPosition = findStartingPosition(nav, urlTree, route);
                /** @type {?} */
                var segmentGroup = startingPosition.processChildren ?
                    updateSegmentGroupChildren(startingPosition.segmentGroup, startingPosition.index, nav.commands) :
                    updateSegmentGroup(startingPosition.segmentGroup, startingPosition.index, nav.commands);
                return tree(startingPosition.segmentGroup, segmentGroup, urlTree, queryParams, fragment);
            }
            /**
             * @param {?} command
             * @return {?}
             */
            function isMatrixParams(command) {
                return typeof command === 'object' && command != null && !command.outlets && !command.segmentPath;
            }
            /**
             * @param {?} oldSegmentGroup
             * @param {?} newSegmentGroup
             * @param {?} urlTree
             * @param {?} queryParams
             * @param {?} fragment
             * @return {?}
             */
            function tree(oldSegmentGroup, newSegmentGroup, urlTree, queryParams, fragment) {
                /** @type {?} */
                var qp = {};
                if (queryParams) {
                    forEach(queryParams, ( /**
                     * @param {?} value
                     * @param {?} name
                     * @return {?}
                     */function (value, name) {
                        qp[name] = Array.isArray(value) ? value.map(( /**
                         * @param {?} v
                         * @return {?}
                         */function (v) { return "" + v; })) : "" + value;
                    }));
                }
                if (urlTree.root === oldSegmentGroup) {
                    return new UrlTree(newSegmentGroup, qp, fragment);
                }
                return new UrlTree(replaceSegment(urlTree.root, oldSegmentGroup, newSegmentGroup), qp, fragment);
            }
            /**
             * @param {?} current
             * @param {?} oldSegment
             * @param {?} newSegment
             * @return {?}
             */
            function replaceSegment(current, oldSegment, newSegment) {
                /** @type {?} */
                var children = {};
                forEach(current.children, ( /**
                 * @param {?} c
                 * @param {?} outletName
                 * @return {?}
                 */function (c, outletName) {
                    if (c === oldSegment) {
                        children[outletName] = newSegment;
                    }
                    else {
                        children[outletName] = replaceSegment(c, oldSegment, newSegment);
                    }
                }));
                return new UrlSegmentGroup(current.segments, children);
            }
            var Navigation = /** @class */ (function () {
                /**
                 * @param {?} isAbsolute
                 * @param {?} numberOfDoubleDots
                 * @param {?} commands
                 */
                function Navigation(isAbsolute, numberOfDoubleDots, commands) {
                    this.isAbsolute = isAbsolute;
                    this.numberOfDoubleDots = numberOfDoubleDots;
                    this.commands = commands;
                    if (isAbsolute && commands.length > 0 && isMatrixParams(commands[0])) {
                        throw new Error('Root segment cannot have matrix parameters');
                    }
                    /** @type {?} */
                    var cmdWithOutlet = commands.find(( /**
                     * @param {?} c
                     * @return {?}
                     */function (/**
                     * @param {?} c
                     * @return {?}
                     */ c) { return typeof c === 'object' && c != null && c.outlets; }));
                    if (cmdWithOutlet && cmdWithOutlet !== last(commands)) {
                        throw new Error('{outlets:{}} has to be the last command');
                    }
                }
                /**
                 * @return {?}
                 */
                Navigation.prototype.toRoot = function () {
                    return this.isAbsolute && this.commands.length === 1 && this.commands[0] == '/';
                };
                return Navigation;
            }());
            if (false) { }
            /**
             * Transforms commands to a normalized `Navigation`
             * @param {?} commands
             * @return {?}
             */
            function computeNavigation(commands) {
                if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] === '/') {
                    return new Navigation(true, 0, commands);
                }
                /** @type {?} */
                var numberOfDoubleDots = 0;
                /** @type {?} */
                var isAbsolute = false;
                /** @type {?} */
                var res = commands.reduce(( /**
                 * @param {?} res
                 * @param {?} cmd
                 * @param {?} cmdIdx
                 * @return {?}
                 */function (res, cmd, cmdIdx) {
                    if (typeof cmd === 'object' && cmd != null) {
                        if (cmd.outlets) {
                            /** @type {?} */
                            var outlets_1 = {};
                            forEach(cmd.outlets, ( /**
                             * @param {?} commands
                             * @param {?} name
                             * @return {?}
                             */function (commands, name) {
                                outlets_1[name] = typeof commands === 'string' ? commands.split('/') : commands;
                            }));
                            return res.concat([{ outlets: outlets_1 }]);
                        }
                        if (cmd.segmentPath) {
                            return res.concat([cmd.segmentPath]);
                        }
                    }
                    if (!(typeof cmd === 'string')) {
                        return res.concat([cmd]);
                    }
                    if (cmdIdx === 0) {
                        cmd.split('/').forEach(( /**
                         * @param {?} urlPart
                         * @param {?} partIndex
                         * @return {?}
                         */function (urlPart, partIndex) {
                            if (partIndex == 0 && urlPart === '.') {
                                // skip './a'
                            }
                            else if (partIndex == 0 && urlPart === '') { //  '/a'
                                isAbsolute = true;
                            }
                            else if (urlPart === '..') { //  '../a'
                                numberOfDoubleDots++;
                            }
                            else if (urlPart != '') {
                                res.push(urlPart);
                            }
                        }));
                        return res;
                    }
                    return res.concat([cmd]);
                }), []);
                return new Navigation(isAbsolute, numberOfDoubleDots, res);
            }
            var Position = /** @class */ (function () {
                /**
                 * @param {?} segmentGroup
                 * @param {?} processChildren
                 * @param {?} index
                 */
                function Position(segmentGroup, processChildren, index) {
                    this.segmentGroup = segmentGroup;
                    this.processChildren = processChildren;
                    this.index = index;
                }
                return Position;
            }());
            if (false) { }
            /**
             * @param {?} nav
             * @param {?} tree
             * @param {?} route
             * @return {?}
             */
            function findStartingPosition(nav, tree, route) {
                if (nav.isAbsolute) {
                    return new Position(tree.root, true, 0);
                }
                if (route.snapshot._lastPathIndex === -1) {
                    return new Position(route.snapshot._urlSegment, true, 0);
                }
                /** @type {?} */
                var modifier = isMatrixParams(nav.commands[0]) ? 0 : 1;
                /** @type {?} */
                var index = route.snapshot._lastPathIndex + modifier;
                return createPositionApplyingDoubleDots(route.snapshot._urlSegment, index, nav.numberOfDoubleDots);
            }
            /**
             * @param {?} group
             * @param {?} index
             * @param {?} numberOfDoubleDots
             * @return {?}
             */
            function createPositionApplyingDoubleDots(group, index, numberOfDoubleDots) {
                /** @type {?} */
                var g = group;
                /** @type {?} */
                var ci = index;
                /** @type {?} */
                var dd = numberOfDoubleDots;
                while (dd > ci) {
                    dd -= ci;
                    g = ( /** @type {?} */(g.parent));
                    if (!g) {
                        throw new Error('Invalid number of \'../\'');
                    }
                    ci = g.segments.length;
                }
                return new Position(g, false, ci - dd);
            }
            /**
             * @param {?} command
             * @return {?}
             */
            function getPath(command) {
                if (typeof command === 'object' && command != null && command.outlets) {
                    return command.outlets[PRIMARY_OUTLET];
                }
                return "" + command;
            }
            /**
             * @param {?} commands
             * @return {?}
             */
            function getOutlets(commands) {
                var _c, _d;
                if (!(typeof commands[0] === 'object'))
                    return _c = {}, _c[PRIMARY_OUTLET] = commands, _c;
                if (commands[0].outlets === undefined)
                    return _d = {}, _d[PRIMARY_OUTLET] = commands, _d;
                return commands[0].outlets;
            }
            /**
             * @param {?} segmentGroup
             * @param {?} startIndex
             * @param {?} commands
             * @return {?}
             */
            function updateSegmentGroup(segmentGroup, startIndex, commands) {
                if (!segmentGroup) {
                    segmentGroup = new UrlSegmentGroup([], {});
                }
                if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
                    return updateSegmentGroupChildren(segmentGroup, startIndex, commands);
                }
                /** @type {?} */
                var m = prefixedWith(segmentGroup, startIndex, commands);
                /** @type {?} */
                var slicedCommands = commands.slice(m.commandIndex);
                if (m.match && m.pathIndex < segmentGroup.segments.length) {
                    /** @type {?} */
                    var g = new UrlSegmentGroup(segmentGroup.segments.slice(0, m.pathIndex), {});
                    g.children[PRIMARY_OUTLET] =
                        new UrlSegmentGroup(segmentGroup.segments.slice(m.pathIndex), segmentGroup.children);
                    return updateSegmentGroupChildren(g, 0, slicedCommands);
                }
                else if (m.match && slicedCommands.length === 0) {
                    return new UrlSegmentGroup(segmentGroup.segments, {});
                }
                else if (m.match && !segmentGroup.hasChildren()) {
                    return createNewSegmentGroup(segmentGroup, startIndex, commands);
                }
                else if (m.match) {
                    return updateSegmentGroupChildren(segmentGroup, 0, slicedCommands);
                }
                else {
                    return createNewSegmentGroup(segmentGroup, startIndex, commands);
                }
            }
            /**
             * @param {?} segmentGroup
             * @param {?} startIndex
             * @param {?} commands
             * @return {?}
             */
            function updateSegmentGroupChildren(segmentGroup, startIndex, commands) {
                if (commands.length === 0) {
                    return new UrlSegmentGroup(segmentGroup.segments, {});
                }
                else {
                    /** @type {?} */
                    var outlets_2 = getOutlets(commands);
                    /** @type {?} */
                    var children_3 = {};
                    forEach(outlets_2, ( /**
                     * @param {?} commands
                     * @param {?} outlet
                     * @return {?}
                     */function (commands, outlet) {
                        if (commands !== null) {
                            children_3[outlet] = updateSegmentGroup(segmentGroup.children[outlet], startIndex, commands);
                        }
                    }));
                    forEach(segmentGroup.children, ( /**
                     * @param {?} child
                     * @param {?} childOutlet
                     * @return {?}
                     */function (child, childOutlet) {
                        if (outlets_2[childOutlet] === undefined) {
                            children_3[childOutlet] = child;
                        }
                    }));
                    return new UrlSegmentGroup(segmentGroup.segments, children_3);
                }
            }
            /**
             * @param {?} segmentGroup
             * @param {?} startIndex
             * @param {?} commands
             * @return {?}
             */
            function prefixedWith(segmentGroup, startIndex, commands) {
                /** @type {?} */
                var currentCommandIndex = 0;
                /** @type {?} */
                var currentPathIndex = startIndex;
                /** @type {?} */
                var noMatch = { match: false, pathIndex: 0, commandIndex: 0 };
                while (currentPathIndex < segmentGroup.segments.length) {
                    if (currentCommandIndex >= commands.length)
                        return noMatch;
                    /** @type {?} */
                    var path = segmentGroup.segments[currentPathIndex];
                    /** @type {?} */
                    var curr = getPath(commands[currentCommandIndex]);
                    /** @type {?} */
                    var next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
                    if (currentPathIndex > 0 && curr === undefined)
                        break;
                    if (curr && next && (typeof next === 'object') && next.outlets === undefined) {
                        if (!compare(curr, next, path))
                            return noMatch;
                        currentCommandIndex += 2;
                    }
                    else {
                        if (!compare(curr, {}, path))
                            return noMatch;
                        currentCommandIndex++;
                    }
                    currentPathIndex++;
                }
                return { match: true, pathIndex: currentPathIndex, commandIndex: currentCommandIndex };
            }
            /**
             * @param {?} segmentGroup
             * @param {?} startIndex
             * @param {?} commands
             * @return {?}
             */
            function createNewSegmentGroup(segmentGroup, startIndex, commands) {
                /** @type {?} */
                var paths = segmentGroup.segments.slice(0, startIndex);
                /** @type {?} */
                var i = 0;
                while (i < commands.length) {
                    if (typeof commands[i] === 'object' && commands[i].outlets !== undefined) {
                        /** @type {?} */
                        var children = createNewSegmentChildren(commands[i].outlets);
                        return new UrlSegmentGroup(paths, children);
                    }
                    // if we start with an object literal, we need to reuse the path part from the segment
                    if (i === 0 && isMatrixParams(commands[0])) {
                        /** @type {?} */
                        var p = segmentGroup.segments[startIndex];
                        paths.push(new UrlSegment(p.path, commands[0]));
                        i++;
                        continue;
                    }
                    /** @type {?} */
                    var curr = getPath(commands[i]);
                    /** @type {?} */
                    var next = (i < commands.length - 1) ? commands[i + 1] : null;
                    if (curr && next && isMatrixParams(next)) {
                        paths.push(new UrlSegment(curr, stringify(next)));
                        i += 2;
                    }
                    else {
                        paths.push(new UrlSegment(curr, {}));
                        i++;
                    }
                }
                return new UrlSegmentGroup(paths, {});
            }
            /**
             * @param {?} outlets
             * @return {?}
             */
            function createNewSegmentChildren(outlets) {
                /** @type {?} */
                var children = {};
                forEach(outlets, ( /**
                 * @param {?} commands
                 * @param {?} outlet
                 * @return {?}
                 */function (commands, outlet) {
                    if (commands !== null) {
                        children[outlet] = createNewSegmentGroup(new UrlSegmentGroup([], {}), 0, commands);
                    }
                }));
                return children;
            }
            /**
             * @param {?} params
             * @return {?}
             */
            function stringify(params) {
                /** @type {?} */
                var res = {};
                forEach(params, ( /**
                 * @param {?} v
                 * @param {?} k
                 * @return {?}
                 */function (v, k) { return res[k] = "" + v; }));
                return res;
            }
            /**
             * @param {?} path
             * @param {?} params
             * @param {?} segment
             * @return {?}
             */
            function compare(path, params, segment) {
                return path == segment.path && shallowEqual(params, segment.parameters);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var activateRoutes = ( /**
             * @param {?} rootContexts
             * @param {?} routeReuseStrategy
             * @param {?} forwardEvent
             * @return {?}
             */function (rootContexts, routeReuseStrategy, forwardEvent) { return Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
             * @param {?} t
             * @return {?}
             */function (/**
             * @param {?} t
             * @return {?}
             */ t) {
                new ActivateRoutes(routeReuseStrategy, ( /** @type {?} */(t.targetRouterState)), t.currentRouterState, forwardEvent)
                    .activate(rootContexts);
                return t;
            })); });
            var ActivateRoutes = /** @class */ (function () {
                /**
                 * @param {?} routeReuseStrategy
                 * @param {?} futureState
                 * @param {?} currState
                 * @param {?} forwardEvent
                 */
                function ActivateRoutes(routeReuseStrategy, futureState, currState, forwardEvent) {
                    this.routeReuseStrategy = routeReuseStrategy;
                    this.futureState = futureState;
                    this.currState = currState;
                    this.forwardEvent = forwardEvent;
                }
                /**
                 * @param {?} parentContexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.activate = function (parentContexts) {
                    /** @type {?} */
                    var futureRoot = this.futureState._root;
                    /** @type {?} */
                    var currRoot = this.currState ? this.currState._root : null;
                    this.deactivateChildRoutes(futureRoot, currRoot, parentContexts);
                    advanceActivatedRoute(this.futureState.root);
                    this.activateChildRoutes(futureRoot, currRoot, parentContexts);
                };
                // De-activate the child route that are not re-used for the future state
                /**
                 * @private
                 * @param {?} futureNode
                 * @param {?} currNode
                 * @param {?} contexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.deactivateChildRoutes = function (futureNode, currNode, contexts) {
                    var _this = this;
                    /** @type {?} */
                    var children = nodeChildrenAsMap(currNode);
                    // Recurse on the routes active in the future state to de-activate deeper children
                    futureNode.children.forEach(( /**
                     * @param {?} futureChild
                     * @return {?}
                     */function (/**
                     * @param {?} futureChild
                     * @return {?}
                     */ futureChild) {
                        /** @type {?} */
                        var childOutletName = futureChild.value.outlet;
                        _this.deactivateRoutes(futureChild, children[childOutletName], contexts);
                        delete children[childOutletName];
                    }));
                    // De-activate the routes that will not be re-used
                    forEach(children, ( /**
                     * @param {?} v
                     * @param {?} childName
                     * @return {?}
                     */function (v, childName) {
                        _this.deactivateRouteAndItsChildren(v, contexts);
                    }));
                };
                /**
                 * @private
                 * @param {?} futureNode
                 * @param {?} currNode
                 * @param {?} parentContext
                 * @return {?}
                 */
                ActivateRoutes.prototype.deactivateRoutes = function (futureNode, currNode, parentContext) {
                    /** @type {?} */
                    var future = futureNode.value;
                    /** @type {?} */
                    var curr = currNode ? currNode.value : null;
                    if (future === curr) {
                        // Reusing the node, check to see if the children need to be de-activated
                        if (future.component) {
                            // If we have a normal route, we need to go through an outlet.
                            /** @type {?} */
                            var context = parentContext.getContext(future.outlet);
                            if (context) {
                                this.deactivateChildRoutes(futureNode, currNode, context.children);
                            }
                        }
                        else {
                            // if we have a componentless route, we recurse but keep the same outlet map.
                            this.deactivateChildRoutes(futureNode, currNode, parentContext);
                        }
                    }
                    else {
                        if (curr) {
                            // Deactivate the current route which will not be re-used
                            this.deactivateRouteAndItsChildren(currNode, parentContext);
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} route
                 * @param {?} parentContexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.deactivateRouteAndItsChildren = function (route, parentContexts) {
                    if (this.routeReuseStrategy.shouldDetach(route.value.snapshot)) {
                        this.detachAndStoreRouteSubtree(route, parentContexts);
                    }
                    else {
                        this.deactivateRouteAndOutlet(route, parentContexts);
                    }
                };
                /**
                 * @private
                 * @param {?} route
                 * @param {?} parentContexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.detachAndStoreRouteSubtree = function (route, parentContexts) {
                    /** @type {?} */
                    var context = parentContexts.getContext(route.value.outlet);
                    if (context && context.outlet) {
                        /** @type {?} */
                        var componentRef = context.outlet.detach();
                        /** @type {?} */
                        var contexts = context.children.onOutletDeactivated();
                        this.routeReuseStrategy.store(route.value.snapshot, { componentRef: componentRef, route: route, contexts: contexts });
                    }
                };
                /**
                 * @private
                 * @param {?} route
                 * @param {?} parentContexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.deactivateRouteAndOutlet = function (route, parentContexts) {
                    var _this = this;
                    /** @type {?} */
                    var context = parentContexts.getContext(route.value.outlet);
                    if (context) {
                        /** @type {?} */
                        var children = nodeChildrenAsMap(route);
                        /** @type {?} */
                        var contexts_1 = route.value.component ? context.children : parentContexts;
                        forEach(children, ( /**
                         * @param {?} v
                         * @param {?} k
                         * @return {?}
                         */function (v, k) { return _this.deactivateRouteAndItsChildren(v, contexts_1); }));
                        if (context.outlet) {
                            // Destroy the component
                            context.outlet.deactivate();
                            // Destroy the contexts for all the outlets that were in the component
                            context.children.onOutletDeactivated();
                        }
                    }
                };
                /**
                 * @private
                 * @param {?} futureNode
                 * @param {?} currNode
                 * @param {?} contexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.activateChildRoutes = function (futureNode, currNode, contexts) {
                    var _this = this;
                    /** @type {?} */
                    var children = nodeChildrenAsMap(currNode);
                    futureNode.children.forEach(( /**
                     * @param {?} c
                     * @return {?}
                     */function (/**
                     * @param {?} c
                     * @return {?}
                     */ c) {
                        _this.activateRoutes(c, children[c.value.outlet], contexts);
                        _this.forwardEvent(new ActivationEnd(c.value.snapshot));
                    }));
                    if (futureNode.children.length) {
                        this.forwardEvent(new ChildActivationEnd(futureNode.value.snapshot));
                    }
                };
                /**
                 * @private
                 * @param {?} futureNode
                 * @param {?} currNode
                 * @param {?} parentContexts
                 * @return {?}
                 */
                ActivateRoutes.prototype.activateRoutes = function (futureNode, currNode, parentContexts) {
                    /** @type {?} */
                    var future = futureNode.value;
                    /** @type {?} */
                    var curr = currNode ? currNode.value : null;
                    advanceActivatedRoute(future);
                    // reusing the node
                    if (future === curr) {
                        if (future.component) {
                            // If we have a normal route, we need to go through an outlet.
                            /** @type {?} */
                            var context = parentContexts.getOrCreateContext(future.outlet);
                            this.activateChildRoutes(futureNode, currNode, context.children);
                        }
                        else {
                            // if we have a componentless route, we recurse but keep the same outlet map.
                            this.activateChildRoutes(futureNode, currNode, parentContexts);
                        }
                    }
                    else {
                        if (future.component) {
                            // if we have a normal route, we need to place the component into the outlet and recurse.
                            /** @type {?} */
                            var context = parentContexts.getOrCreateContext(future.outlet);
                            if (this.routeReuseStrategy.shouldAttach(future.snapshot)) {
                                /** @type {?} */
                                var stored = (( /** @type {?} */(this.routeReuseStrategy.retrieve(future.snapshot))));
                                this.routeReuseStrategy.store(future.snapshot, null);
                                context.children.onOutletReAttached(stored.contexts);
                                context.attachRef = stored.componentRef;
                                context.route = stored.route.value;
                                if (context.outlet) {
                                    // Attach right away when the outlet has already been instantiated
                                    // Otherwise attach from `RouterOutlet.ngOnInit` when it is instantiated
                                    context.outlet.attach(stored.componentRef, stored.route.value);
                                }
                                advanceActivatedRouteNodeAndItsChildren(stored.route);
                            }
                            else {
                                /** @type {?} */
                                var config = parentLoadedConfig(future.snapshot);
                                /** @type {?} */
                                var cmpFactoryResolver = config ? config.module.componentFactoryResolver : null;
                                context.attachRef = null;
                                context.route = future;
                                context.resolver = cmpFactoryResolver;
                                if (context.outlet) {
                                    // Activate the outlet when it has already been instantiated
                                    // Otherwise it will get activated from its `ngOnInit` when instantiated
                                    context.outlet.activateWith(future, cmpFactoryResolver);
                                }
                                this.activateChildRoutes(futureNode, null, context.children);
                            }
                        }
                        else {
                            // if we have a componentless route, we recurse but keep the same outlet map.
                            this.activateChildRoutes(futureNode, null, parentContexts);
                        }
                    }
                };
                return ActivateRoutes;
            }());
            if (false) { }
            /**
             * @param {?} node
             * @return {?}
             */
            function advanceActivatedRouteNodeAndItsChildren(node) {
                advanceActivatedRoute(node.value);
                node.children.forEach(advanceActivatedRouteNodeAndItsChildren);
            }
            /**
             * @param {?} snapshot
             * @return {?}
             */
            function parentLoadedConfig(snapshot) {
                for (var s = snapshot.parent; s; s = s.parent) {
                    /** @type {?} */
                    var route = s.routeConfig;
                    if (route && route._loadedConfig)
                        return route._loadedConfig;
                    if (route && route.component)
                        return null;
                }
                return null;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Simple function check, but generic so type inference will flow. Example:
             *
             * function product(a: number, b: number) {
             *   return a * b;
             * }
             *
             * if (isFunction<product>(fn)) {
             *   return fn(1, 2);
             * } else {
             *   throw "Must provide the `product` function";
             * }
             * @template T
             * @param {?} v
             * @return {?}
             */
            function isFunction(v) {
                return typeof v === 'function';
            }
            /**
             * @param {?} v
             * @return {?}
             */
            function isBoolean(v) {
                return typeof v === 'boolean';
            }
            /**
             * @param {?} v
             * @return {?}
             */
            function isUrlTree(v) {
                return v instanceof UrlTree;
            }
            /**
             * @param {?} guard
             * @return {?}
             */
            function isCanLoad(guard) {
                return guard && isFunction(guard.canLoad);
            }
            /**
             * @param {?} guard
             * @return {?}
             */
            function isCanActivate(guard) {
                return guard && isFunction(guard.canActivate);
            }
            /**
             * @param {?} guard
             * @return {?}
             */
            function isCanActivateChild(guard) {
                return guard && isFunction(guard.canActivateChild);
            }
            /**
             * @template T
             * @param {?} guard
             * @return {?}
             */
            function isCanDeactivate(guard) {
                return guard && isFunction(guard.canDeactivate);
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NoMatch = /** @class */ (function () {
                /**
                 * @param {?=} segmentGroup
                 */
                function NoMatch(segmentGroup) {
                    this.segmentGroup = segmentGroup || null;
                }
                return NoMatch;
            }());
            if (false) { }
            var AbsoluteRedirect = /** @class */ (function () {
                /**
                 * @param {?} urlTree
                 */
                function AbsoluteRedirect(urlTree) {
                    this.urlTree = urlTree;
                }
                return AbsoluteRedirect;
            }());
            if (false) { }
            /**
             * @param {?} segmentGroup
             * @return {?}
             */
            function noMatch(segmentGroup) {
                return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                 * @param {?} obs
                 * @return {?}
                 */function (obs) { return obs.error(new NoMatch(segmentGroup)); }));
            }
            /**
             * @param {?} newTree
             * @return {?}
             */
            function absoluteRedirect(newTree) {
                return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                 * @param {?} obs
                 * @return {?}
                 */function (obs) { return obs.error(new AbsoluteRedirect(newTree)); }));
            }
            /**
             * @param {?} redirectTo
             * @return {?}
             */
            function namedOutletsRedirect(redirectTo) {
                return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                 * @param {?} obs
                 * @return {?}
                 */function (obs) { return obs.error(new Error("Only absolute redirects can have named outlets. redirectTo: '" + redirectTo + "'")); }));
            }
            /**
             * @param {?} route
             * @return {?}
             */
            function canLoadFails(route) {
                return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                 * @param {?} obs
                 * @return {?}
                 */function (obs) { return obs.error(navigationCancelingError("Cannot load children because the guard of the route \"path: '" + route.path + "'\" returned false")); }));
            }
            /**
             * Returns the `UrlTree` with the redirection applied.
             *
             * Lazy modules are loaded along the way.
             * @param {?} moduleInjector
             * @param {?} configLoader
             * @param {?} urlSerializer
             * @param {?} urlTree
             * @param {?} config
             * @return {?}
             */
            function applyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
                return new ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config).apply();
            }
            var ApplyRedirects = /** @class */ (function () {
                /**
                 * @param {?} moduleInjector
                 * @param {?} configLoader
                 * @param {?} urlSerializer
                 * @param {?} urlTree
                 * @param {?} config
                 */
                function ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
                    this.configLoader = configLoader;
                    this.urlSerializer = urlSerializer;
                    this.urlTree = urlTree;
                    this.config = config;
                    this.allowRedirects = true;
                    this.ngModule = moduleInjector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleRef"]);
                }
                /**
                 * @return {?}
                 */
                ApplyRedirects.prototype.apply = function () {
                    var _this = this;
                    /** @type {?} */
                    var expanded$ = this.expandSegmentGroup(this.ngModule, this.config, this.urlTree.root, PRIMARY_OUTLET);
                    /** @type {?} */
                    var urlTrees$ = expanded$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} rootSegmentGroup
                     * @return {?}
                     */function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup, _this.urlTree.queryParams, ( /** @type {?} */(_this.urlTree.fragment))); })));
                    return urlTrees$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(( /**
                     * @param {?} e
                     * @return {?}
                     */function (e) {
                        if (e instanceof AbsoluteRedirect) {
                            // after an absolute redirect we do not apply any more redirects!
                            _this.allowRedirects = false;
                            // we need to run matching, so we can fetch all lazy-loaded modules
                            return _this.match(e.urlTree);
                        }
                        if (e instanceof NoMatch) {
                            throw _this.noMatchError(e);
                        }
                        throw e;
                    })));
                };
                /**
                 * @private
                 * @param {?} tree
                 * @return {?}
                 */
                ApplyRedirects.prototype.match = function (tree) {
                    var _this = this;
                    /** @type {?} */
                    var expanded$ = this.expandSegmentGroup(this.ngModule, this.config, tree.root, PRIMARY_OUTLET);
                    /** @type {?} */
                    var mapped$ = expanded$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} rootSegmentGroup
                     * @return {?}
                     */function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup, tree.queryParams, ( /** @type {?} */(tree.fragment))); })));
                    return mapped$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(( /**
                     * @param {?} e
                     * @return {?}
                     */function (e) {
                        if (e instanceof NoMatch) {
                            throw _this.noMatchError(e);
                        }
                        throw e;
                    })));
                };
                /**
                 * @private
                 * @param {?} e
                 * @return {?}
                 */
                ApplyRedirects.prototype.noMatchError = function (e) {
                    return new Error("Cannot match any routes. URL Segment: '" + e.segmentGroup + "'");
                };
                /**
                 * @private
                 * @param {?} rootCandidate
                 * @param {?} queryParams
                 * @param {?} fragment
                 * @return {?}
                 */
                ApplyRedirects.prototype.createUrlTree = function (rootCandidate, queryParams, fragment) {
                    var _c;
                    /** @type {?} */
                    var root = rootCandidate.segments.length > 0 ?
                        new UrlSegmentGroup([], (_c = {}, _c[PRIMARY_OUTLET] = rootCandidate, _c)) :
                        rootCandidate;
                    return new UrlTree(root, queryParams, fragment);
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} routes
                 * @param {?} segmentGroup
                 * @param {?} outlet
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandSegmentGroup = function (ngModule, routes, segmentGroup, outlet) {
                    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
                        return this.expandChildren(ngModule, routes, segmentGroup)
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} children
                     * @return {?}
                     */function (children) { return new UrlSegmentGroup([], children); })));
                    }
                    return this.expandSegment(ngModule, segmentGroup, routes, segmentGroup.segments, outlet, true);
                };
                // Recursively expand segment groups for all the child outlets
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} routes
                 * @param {?} segmentGroup
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandChildren = function (ngModule, routes, segmentGroup) {
                    var _this = this;
                    return waitForMap(segmentGroup.children, ( /**
                     * @param {?} childOutlet
                     * @param {?} child
                     * @return {?}
                     */function (childOutlet, child) { return _this.expandSegmentGroup(ngModule, routes, child, childOutlet); }));
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} segmentGroup
                 * @param {?} routes
                 * @param {?} segments
                 * @param {?} outlet
                 * @param {?} allowRedirects
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandSegment = function (ngModule, segmentGroup, routes, segments, outlet, allowRedirects) {
                    var _this = this;
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"]).apply(void 0, routes).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) {
                        /** @type {?} */
                        var expanded$ = _this.expandSegmentAgainstRoute(ngModule, segmentGroup, routes, r, segments, outlet, allowRedirects);
                        return expanded$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(( /**
                         * @param {?} e
                         * @return {?}
                         */function (e) {
                            if (e instanceof NoMatch) {
                                // TODO(i): this return type doesn't match the declared Observable<UrlSegmentGroup> -
                                // talk to Jason
                                return ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null)));
                            }
                            throw e;
                        })));
                    })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatAll"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])(( /**
                     * @param {?} s
                     * @return {?}
                     */function (s) { return !!s; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(( /**
                     * @param {?} e
                     * @param {?} _
                     * @return {?}
                     */function (e, _) {
                        if (e instanceof rxjs__WEBPACK_IMPORTED_MODULE_2__["EmptyError"] || e.name === 'EmptyError') {
                            if (_this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
                                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(new UrlSegmentGroup([], {}));
                            }
                            throw new NoMatch(segmentGroup);
                        }
                        throw e;
                    })));
                };
                /**
                 * @private
                 * @param {?} segmentGroup
                 * @param {?} segments
                 * @param {?} outlet
                 * @return {?}
                 */
                ApplyRedirects.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
                    return segments.length === 0 && !segmentGroup.children[outlet];
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} segmentGroup
                 * @param {?} routes
                 * @param {?} route
                 * @param {?} paths
                 * @param {?} outlet
                 * @param {?} allowRedirects
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandSegmentAgainstRoute = function (ngModule, segmentGroup, routes, route, paths, outlet, allowRedirects) {
                    if (getOutlet(route) !== outlet) {
                        return noMatch(segmentGroup);
                    }
                    if (route.redirectTo === undefined) {
                        return this.matchSegmentAgainstRoute(ngModule, segmentGroup, route, paths);
                    }
                    if (allowRedirects && this.allowRedirects) {
                        return this.expandSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, paths, outlet);
                    }
                    return noMatch(segmentGroup);
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} segmentGroup
                 * @param {?} routes
                 * @param {?} route
                 * @param {?} segments
                 * @param {?} outlet
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandSegmentAgainstRouteUsingRedirect = function (ngModule, segmentGroup, routes, route, segments, outlet) {
                    if (route.path === '**') {
                        return this.expandWildCardWithParamsAgainstRouteUsingRedirect(ngModule, routes, route, outlet);
                    }
                    return this.expandRegularSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, segments, outlet);
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} routes
                 * @param {?} route
                 * @param {?} outlet
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandWildCardWithParamsAgainstRouteUsingRedirect = function (ngModule, routes, route, outlet) {
                    var _this = this;
                    /** @type {?} */
                    var newTree = this.applyRedirectCommands([], ( /** @type {?} */(route.redirectTo)), {});
                    if (( /** @type {?} */(route.redirectTo)).startsWith('/')) {
                        return absoluteRedirect(newTree);
                    }
                    return this.lineralizeSegments(route, newTree).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} newSegments
                     * @return {?}
                     */function (newSegments) {
                        /** @type {?} */
                        var group = new UrlSegmentGroup(newSegments, {});
                        return _this.expandSegment(ngModule, group, routes, newSegments, outlet, false);
                    })));
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} segmentGroup
                 * @param {?} routes
                 * @param {?} route
                 * @param {?} segments
                 * @param {?} outlet
                 * @return {?}
                 */
                ApplyRedirects.prototype.expandRegularSegmentAgainstRouteUsingRedirect = function (ngModule, segmentGroup, routes, route, segments, outlet) {
                    var _this = this;
                    var _c = match(segmentGroup, route, segments), matched = _c.matched, consumedSegments = _c.consumedSegments, lastChild = _c.lastChild, positionalParamSegments = _c.positionalParamSegments;
                    if (!matched)
                        return noMatch(segmentGroup);
                    /** @type {?} */
                    var newTree = this.applyRedirectCommands(consumedSegments, ( /** @type {?} */(route.redirectTo)), ( /** @type {?} */(positionalParamSegments)));
                    if (( /** @type {?} */(route.redirectTo)).startsWith('/')) {
                        return absoluteRedirect(newTree);
                    }
                    return this.lineralizeSegments(route, newTree).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} newSegments
                     * @return {?}
                     */function (newSegments) {
                        return _this.expandSegment(ngModule, segmentGroup, routes, newSegments.concat(segments.slice(lastChild)), outlet, false);
                    })));
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} rawSegmentGroup
                 * @param {?} route
                 * @param {?} segments
                 * @return {?}
                 */
                ApplyRedirects.prototype.matchSegmentAgainstRoute = function (ngModule, rawSegmentGroup, route, segments) {
                    var _this = this;
                    if (route.path === '**') {
                        if (route.loadChildren) {
                            return this.configLoader.load(ngModule.injector, route)
                                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} cfg
                         * @return {?}
                         */function (cfg) {
                                route._loadedConfig = cfg;
                                return new UrlSegmentGroup(segments, {});
                            })));
                        }
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(new UrlSegmentGroup(segments, {}));
                    }
                    var _c = match(rawSegmentGroup, route, segments), matched = _c.matched, consumedSegments = _c.consumedSegments, lastChild = _c.lastChild;
                    if (!matched)
                        return noMatch(rawSegmentGroup);
                    /** @type {?} */
                    var rawSlicedSegments = segments.slice(lastChild);
                    /** @type {?} */
                    var childConfig$ = this.getChildConfig(ngModule, route, segments);
                    return childConfig$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} routerConfig
                     * @return {?}
                     */function (routerConfig) {
                        /** @type {?} */
                        var childModule = routerConfig.module;
                        /** @type {?} */
                        var childConfig = routerConfig.routes;
                        var _c = split(rawSegmentGroup, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _c.segmentGroup, slicedSegments = _c.slicedSegments;
                        if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
                            /** @type {?} */
                            var expanded$_1 = _this.expandChildren(childModule, childConfig, segmentGroup);
                            return expanded$_1.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                             * @param {?} children
                             * @return {?}
                             */function (children) { return new UrlSegmentGroup(consumedSegments, children); })));
                        }
                        if (childConfig.length === 0 && slicedSegments.length === 0) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(new UrlSegmentGroup(consumedSegments, {}));
                        }
                        /** @type {?} */
                        var expanded$ = _this.expandSegment(childModule, segmentGroup, childConfig, slicedSegments, PRIMARY_OUTLET, true);
                        return expanded$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} cs
                         * @return {?}
                         */function (cs) { return new UrlSegmentGroup(consumedSegments.concat(cs.segments), cs.children); })));
                    })));
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} route
                 * @param {?} segments
                 * @return {?}
                 */
                ApplyRedirects.prototype.getChildConfig = function (ngModule, route, segments) {
                    var _this = this;
                    if (route.children) {
                        // The children belong to the same module
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(new LoadedRouterConfig(route.children, ngModule));
                    }
                    if (route.loadChildren) {
                        // lazy children belong to the loaded module
                        if (route._loadedConfig !== undefined) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(route._loadedConfig);
                        }
                        return runCanLoadGuard(ngModule.injector, route, segments)
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} shouldLoad
                     * @return {?}
                     */function (shouldLoad) {
                            if (shouldLoad) {
                                return _this.configLoader.load(ngModule.injector, route)
                                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                             * @param {?} cfg
                             * @return {?}
                             */function (cfg) {
                                    route._loadedConfig = cfg;
                                    return cfg;
                                })));
                            }
                            return canLoadFails(route);
                        })));
                    }
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(new LoadedRouterConfig([], ngModule));
                };
                /**
                 * @private
                 * @param {?} route
                 * @param {?} urlTree
                 * @return {?}
                 */
                ApplyRedirects.prototype.lineralizeSegments = function (route, urlTree) {
                    /** @type {?} */
                    var res = [];
                    /** @type {?} */
                    var c = urlTree.root;
                    while (true) {
                        res = res.concat(c.segments);
                        if (c.numberOfChildren === 0) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(res);
                        }
                        if (c.numberOfChildren > 1 || !c.children[PRIMARY_OUTLET]) {
                            return namedOutletsRedirect(( /** @type {?} */(route.redirectTo)));
                        }
                        c = c.children[PRIMARY_OUTLET];
                    }
                };
                /**
                 * @private
                 * @param {?} segments
                 * @param {?} redirectTo
                 * @param {?} posParams
                 * @return {?}
                 */
                ApplyRedirects.prototype.applyRedirectCommands = function (segments, redirectTo, posParams) {
                    return this.applyRedirectCreatreUrlTree(redirectTo, this.urlSerializer.parse(redirectTo), segments, posParams);
                };
                /**
                 * @private
                 * @param {?} redirectTo
                 * @param {?} urlTree
                 * @param {?} segments
                 * @param {?} posParams
                 * @return {?}
                 */
                ApplyRedirects.prototype.applyRedirectCreatreUrlTree = function (redirectTo, urlTree, segments, posParams) {
                    /** @type {?} */
                    var newRoot = this.createSegmentGroup(redirectTo, urlTree.root, segments, posParams);
                    return new UrlTree(newRoot, this.createQueryParams(urlTree.queryParams, this.urlTree.queryParams), urlTree.fragment);
                };
                /**
                 * @private
                 * @param {?} redirectToParams
                 * @param {?} actualParams
                 * @return {?}
                 */
                ApplyRedirects.prototype.createQueryParams = function (redirectToParams, actualParams) {
                    /** @type {?} */
                    var res = {};
                    forEach(redirectToParams, ( /**
                     * @param {?} v
                     * @param {?} k
                     * @return {?}
                     */function (v, k) {
                        /** @type {?} */
                        var copySourceValue = typeof v === 'string' && v.startsWith(':');
                        if (copySourceValue) {
                            /** @type {?} */
                            var sourceName = v.substring(1);
                            res[k] = actualParams[sourceName];
                        }
                        else {
                            res[k] = v;
                        }
                    }));
                    return res;
                };
                /**
                 * @private
                 * @param {?} redirectTo
                 * @param {?} group
                 * @param {?} segments
                 * @param {?} posParams
                 * @return {?}
                 */
                ApplyRedirects.prototype.createSegmentGroup = function (redirectTo, group, segments, posParams) {
                    var _this = this;
                    /** @type {?} */
                    var updatedSegments = this.createSegments(redirectTo, group.segments, segments, posParams);
                    /** @type {?} */
                    var children = {};
                    forEach(group.children, ( /**
                     * @param {?} child
                     * @param {?} name
                     * @return {?}
                     */function (child, name) {
                        children[name] = _this.createSegmentGroup(redirectTo, child, segments, posParams);
                    }));
                    return new UrlSegmentGroup(updatedSegments, children);
                };
                /**
                 * @private
                 * @param {?} redirectTo
                 * @param {?} redirectToSegments
                 * @param {?} actualSegments
                 * @param {?} posParams
                 * @return {?}
                 */
                ApplyRedirects.prototype.createSegments = function (redirectTo, redirectToSegments, actualSegments, posParams) {
                    var _this = this;
                    return redirectToSegments.map(( /**
                     * @param {?} s
                     * @return {?}
                     */function (/**
                     * @param {?} s
                     * @return {?}
                     */ s) { return s.path.startsWith(':') ? _this.findPosParam(redirectTo, s, posParams) :
                        _this.findOrReturn(s, actualSegments); }));
                };
                /**
                 * @private
                 * @param {?} redirectTo
                 * @param {?} redirectToUrlSegment
                 * @param {?} posParams
                 * @return {?}
                 */
                ApplyRedirects.prototype.findPosParam = function (redirectTo, redirectToUrlSegment, posParams) {
                    /** @type {?} */
                    var pos = posParams[redirectToUrlSegment.path.substring(1)];
                    if (!pos)
                        throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + redirectToUrlSegment.path + "'.");
                    return pos;
                };
                /**
                 * @private
                 * @param {?} redirectToUrlSegment
                 * @param {?} actualSegments
                 * @return {?}
                 */
                ApplyRedirects.prototype.findOrReturn = function (redirectToUrlSegment, actualSegments) {
                    /** @type {?} */
                    var idx = 0;
                    for (var _c = 0, actualSegments_1 = actualSegments; _c < actualSegments_1.length; _c++) {
                        var s = actualSegments_1[_c];
                        if (s.path === redirectToUrlSegment.path) {
                            actualSegments.splice(idx);
                            return s;
                        }
                        idx++;
                    }
                    return redirectToUrlSegment;
                };
                return ApplyRedirects;
            }());
            if (false) { }
            /**
             * @param {?} moduleInjector
             * @param {?} route
             * @param {?} segments
             * @return {?}
             */
            function runCanLoadGuard(moduleInjector, route, segments) {
                /** @type {?} */
                var canLoad = route.canLoad;
                if (!canLoad || canLoad.length === 0)
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(true);
                /** @type {?} */
                var obs = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(canLoad).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                 * @param {?} injectionToken
                 * @return {?}
                 */function (injectionToken) {
                    /** @type {?} */
                    var guard = moduleInjector.get(injectionToken);
                    /** @type {?} */
                    var guardVal;
                    if (isCanLoad(guard)) {
                        guardVal = guard.canLoad(route, segments);
                    }
                    else if (isFunction(guard)) {
                        guardVal = guard(route, segments);
                    }
                    else {
                        throw new Error('Invalid CanLoad guard');
                    }
                    return wrapIntoObservable(guardVal);
                })));
                return obs.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatAll"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["every"])(( /**
                 * @param {?} result
                 * @return {?}
                 */function (/**
                 * @param {?} result
                 * @return {?}
                 */ result) { return result === true; })));
            }
            /**
             * @param {?} segmentGroup
             * @param {?} route
             * @param {?} segments
             * @return {?}
             */
            function match(segmentGroup, route, segments) {
                if (route.path === '') {
                    if ((route.pathMatch === 'full') && (segmentGroup.hasChildren() || segments.length > 0)) {
                        return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
                    }
                    return { matched: true, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
                }
                /** @type {?} */
                var matcher = route.matcher || defaultUrlMatcher;
                /** @type {?} */
                var res = matcher(segments, segmentGroup, route);
                if (!res) {
                    return {
                        matched: false,
                        consumedSegments: ( /** @type {?} */([])),
                        lastChild: 0,
                        positionalParamSegments: {},
                    };
                }
                return {
                    matched: true,
                    consumedSegments: ( /** @type {?} */(res.consumed)),
                    lastChild: ( /** @type {?} */(res.consumed.length)),
                    positionalParamSegments: ( /** @type {?} */(res.posParams)),
                };
            }
            /**
             * @param {?} segmentGroup
             * @param {?} consumedSegments
             * @param {?} slicedSegments
             * @param {?} config
             * @return {?}
             */
            function split(segmentGroup, consumedSegments, slicedSegments, config) {
                if (slicedSegments.length > 0 &&
                    containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, config)) {
                    /** @type {?} */
                    var s = new UrlSegmentGroup(consumedSegments, createChildrenForEmptySegments(config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
                    return { segmentGroup: mergeTrivialChildren(s), slicedSegments: [] };
                }
                if (slicedSegments.length === 0 &&
                    containsEmptyPathRedirects(segmentGroup, slicedSegments, config)) {
                    /** @type {?} */
                    var s = new UrlSegmentGroup(segmentGroup.segments, addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
                    return { segmentGroup: mergeTrivialChildren(s), slicedSegments: slicedSegments };
                }
                return { segmentGroup: segmentGroup, slicedSegments: slicedSegments };
            }
            /**
             * @param {?} s
             * @return {?}
             */
            function mergeTrivialChildren(s) {
                if (s.numberOfChildren === 1 && s.children[PRIMARY_OUTLET]) {
                    /** @type {?} */
                    var c = s.children[PRIMARY_OUTLET];
                    return new UrlSegmentGroup(s.segments.concat(c.segments), c.children);
                }
                return s;
            }
            /**
             * @param {?} segmentGroup
             * @param {?} slicedSegments
             * @param {?} routes
             * @param {?} children
             * @return {?}
             */
            function addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
                /** @type {?} */
                var res = {};
                for (var _c = 0, routes_2 = routes; _c < routes_2.length; _c++) {
                    var r = routes_2[_c];
                    if (isEmptyPathRedirect(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
                        res[getOutlet(r)] = new UrlSegmentGroup([], {});
                    }
                }
                return Object.assign({}, children, res);
            }
            /**
             * @param {?} routes
             * @param {?} primarySegmentGroup
             * @return {?}
             */
            function createChildrenForEmptySegments(routes, primarySegmentGroup) {
                /** @type {?} */
                var res = {};
                res[PRIMARY_OUTLET] = primarySegmentGroup;
                for (var _c = 0, routes_3 = routes; _c < routes_3.length; _c++) {
                    var r = routes_3[_c];
                    if (r.path === '' && getOutlet(r) !== PRIMARY_OUTLET) {
                        res[getOutlet(r)] = new UrlSegmentGroup([], {});
                    }
                }
                return res;
            }
            /**
             * @param {?} segmentGroup
             * @param {?} segments
             * @param {?} routes
             * @return {?}
             */
            function containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, segments, routes) {
                return routes.some(( /**
                 * @param {?} r
                 * @return {?}
                 */function (/**
                 * @param {?} r
                 * @return {?}
                 */ r) { return isEmptyPathRedirect(segmentGroup, segments, r) && getOutlet(r) !== PRIMARY_OUTLET; }));
            }
            /**
             * @param {?} segmentGroup
             * @param {?} segments
             * @param {?} routes
             * @return {?}
             */
            function containsEmptyPathRedirects(segmentGroup, segments, routes) {
                return routes.some(( /**
                 * @param {?} r
                 * @return {?}
                 */function (/**
                 * @param {?} r
                 * @return {?}
                 */ r) { return isEmptyPathRedirect(segmentGroup, segments, r); }));
            }
            /**
             * @param {?} segmentGroup
             * @param {?} segments
             * @param {?} r
             * @return {?}
             */
            function isEmptyPathRedirect(segmentGroup, segments, r) {
                if ((segmentGroup.hasChildren() || segments.length > 0) && r.pathMatch === 'full') {
                    return false;
                }
                return r.path === '' && r.redirectTo !== undefined;
            }
            /**
             * @param {?} route
             * @return {?}
             */
            function getOutlet(route) {
                return route.outlet || PRIMARY_OUTLET;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} moduleInjector
             * @param {?} configLoader
             * @param {?} urlSerializer
             * @param {?} config
             * @return {?}
             */
            function applyRedirects$1(moduleInjector, configLoader, urlSerializer, config) {
                return ( /**
                 * @param {?} source
                 * @return {?}
                 */function (source) {
                    return source.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return applyRedirects(moduleInjector, configLoader, urlSerializer, t.extractedUrl, config)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                 * @param {?} urlAfterRedirects
                 * @return {?}
                 */function (/**
                 * @param {?} urlAfterRedirects
                 * @return {?}
                 */ urlAfterRedirects) { return (Object.assign({}, t, { urlAfterRedirects: urlAfterRedirects })); }))); })));
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var CanActivate = /** @class */ (function () {
                /**
                 * @param {?} path
                 */
                function CanActivate(path) {
                    this.path = path;
                    this.route = this.path[this.path.length - 1];
                }
                return CanActivate;
            }());
            if (false) { }
            var CanDeactivate = /** @class */ (function () {
                /**
                 * @param {?} component
                 * @param {?} route
                 */
                function CanDeactivate(component, route) {
                    this.component = component;
                    this.route = route;
                }
                return CanDeactivate;
            }());
            if (false) { }
            /**
             * @param {?} future
             * @param {?} curr
             * @param {?} parentContexts
             * @return {?}
             */
            function getAllRouteGuards(future, curr, parentContexts) {
                /** @type {?} */
                var futureRoot = future._root;
                /** @type {?} */
                var currRoot = curr ? curr._root : null;
                return getChildRouteGuards(futureRoot, currRoot, parentContexts, [futureRoot.value]);
            }
            /**
             * @param {?} p
             * @return {?}
             */
            function getCanActivateChild(p) {
                /** @type {?} */
                var canActivateChild = p.routeConfig ? p.routeConfig.canActivateChild : null;
                if (!canActivateChild || canActivateChild.length === 0)
                    return null;
                return { node: p, guards: canActivateChild };
            }
            /**
             * @param {?} token
             * @param {?} snapshot
             * @param {?} moduleInjector
             * @return {?}
             */
            function getToken(token, snapshot, moduleInjector) {
                /** @type {?} */
                var config = getClosestLoadedConfig(snapshot);
                /** @type {?} */
                var injector = config ? config.module.injector : moduleInjector;
                return injector.get(token);
            }
            /**
             * @param {?} snapshot
             * @return {?}
             */
            function getClosestLoadedConfig(snapshot) {
                if (!snapshot)
                    return null;
                for (var s = snapshot.parent; s; s = s.parent) {
                    /** @type {?} */
                    var route = s.routeConfig;
                    if (route && route._loadedConfig)
                        return route._loadedConfig;
                }
                return null;
            }
            /**
             * @param {?} futureNode
             * @param {?} currNode
             * @param {?} contexts
             * @param {?} futurePath
             * @param {?=} checks
             * @return {?}
             */
            function getChildRouteGuards(futureNode, currNode, contexts, futurePath, checks) {
                if (checks === void 0) { checks = {
                    canDeactivateChecks: [],
                    canActivateChecks: []
                }; }
                /** @type {?} */
                var prevChildren = nodeChildrenAsMap(currNode);
                // Process the children of the future route
                futureNode.children.forEach(( /**
                 * @param {?} c
                 * @return {?}
                 */function (/**
                 * @param {?} c
                 * @return {?}
                 */ c) {
                    getRouteGuards(c, prevChildren[c.value.outlet], contexts, futurePath.concat([c.value]), checks);
                    delete prevChildren[c.value.outlet];
                }));
                // Process any children left from the current route (not active for the future route)
                forEach(prevChildren, ( /**
                 * @param {?} v
                 * @param {?} k
                 * @return {?}
                 */function (v, k) { return deactivateRouteAndItsChildren(v, ( /** @type {?} */(contexts)).getContext(k), checks); }));
                return checks;
            }
            /**
             * @param {?} futureNode
             * @param {?} currNode
             * @param {?} parentContexts
             * @param {?} futurePath
             * @param {?=} checks
             * @return {?}
             */
            function getRouteGuards(futureNode, currNode, parentContexts, futurePath, checks) {
                if (checks === void 0) { checks = {
                    canDeactivateChecks: [],
                    canActivateChecks: []
                }; }
                /** @type {?} */
                var future = futureNode.value;
                /** @type {?} */
                var curr = currNode ? currNode.value : null;
                /** @type {?} */
                var context = parentContexts ? parentContexts.getContext(futureNode.value.outlet) : null;
                // reusing the node
                if (curr && future.routeConfig === curr.routeConfig) {
                    /** @type {?} */
                    var shouldRun = shouldRunGuardsAndResolvers(curr, future, ( /** @type {?} */(future.routeConfig)).runGuardsAndResolvers);
                    if (shouldRun) {
                        checks.canActivateChecks.push(new CanActivate(futurePath));
                    }
                    else {
                        // we need to set the data
                        future.data = curr.data;
                        future._resolvedData = curr._resolvedData;
                    }
                    // If we have a component, we need to go through an outlet.
                    if (future.component) {
                        getChildRouteGuards(futureNode, currNode, context ? context.children : null, futurePath, checks);
                        // if we have a componentless route, we recurse but keep the same outlet map.
                    }
                    else {
                        getChildRouteGuards(futureNode, currNode, parentContexts, futurePath, checks);
                    }
                    if (shouldRun) {
                        /** @type {?} */
                        var component = context && context.outlet && context.outlet.component || null;
                        checks.canDeactivateChecks.push(new CanDeactivate(component, curr));
                    }
                }
                else {
                    if (curr) {
                        deactivateRouteAndItsChildren(currNode, context, checks);
                    }
                    checks.canActivateChecks.push(new CanActivate(futurePath));
                    // If we have a component, we need to go through an outlet.
                    if (future.component) {
                        getChildRouteGuards(futureNode, null, context ? context.children : null, futurePath, checks);
                        // if we have a componentless route, we recurse but keep the same outlet map.
                    }
                    else {
                        getChildRouteGuards(futureNode, null, parentContexts, futurePath, checks);
                    }
                }
                return checks;
            }
            /**
             * @param {?} curr
             * @param {?} future
             * @param {?} mode
             * @return {?}
             */
            function shouldRunGuardsAndResolvers(curr, future, mode) {
                if (typeof mode === 'function') {
                    return mode(curr, future);
                }
                switch (mode) {
                    case 'pathParamsChange':
                        return !equalPath(curr.url, future.url);
                    case 'pathParamsOrQueryParamsChange':
                        return !equalPath(curr.url, future.url) ||
                            !shallowEqual(curr.queryParams, future.queryParams);
                    case 'always':
                        return true;
                    case 'paramsOrQueryParamsChange':
                        return !equalParamsAndUrlSegments(curr, future) ||
                            !shallowEqual(curr.queryParams, future.queryParams);
                    case 'paramsChange':
                    default:
                        return !equalParamsAndUrlSegments(curr, future);
                }
            }
            /**
             * @param {?} route
             * @param {?} context
             * @param {?} checks
             * @return {?}
             */
            function deactivateRouteAndItsChildren(route, context, checks) {
                /** @type {?} */
                var children = nodeChildrenAsMap(route);
                /** @type {?} */
                var r = route.value;
                forEach(children, ( /**
                 * @param {?} node
                 * @param {?} childName
                 * @return {?}
                 */function (node, childName) {
                    if (!r.component) {
                        deactivateRouteAndItsChildren(node, context, checks);
                    }
                    else if (context) {
                        deactivateRouteAndItsChildren(node, context.children.getContext(childName), checks);
                    }
                    else {
                        deactivateRouteAndItsChildren(node, null, checks);
                    }
                }));
                if (!r.component) {
                    checks.canDeactivateChecks.push(new CanDeactivate(null, r));
                }
                else if (context && context.outlet && context.outlet.isActivated) {
                    checks.canDeactivateChecks.push(new CanDeactivate(context.outlet.component, r));
                }
                else {
                    checks.canDeactivateChecks.push(new CanDeactivate(null, r));
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var INITIAL_VALUE = Symbol('INITIAL_VALUE');
            /**
             * @return {?}
             */
            function prioritizedGuardValue() {
                return Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                 * @param {?} obs
                 * @return {?}
                 */function (/**
                 * @param {?} obs
                 * @return {?}
                 */ obs) {
                    return ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["combineLatest"]).apply(void 0, obs.map(( /**
                     * @param {?} o
                     * @return {?}
                     */function (/**
                     * @param {?} o
                     * @return {?}
                     */ o) { return o.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(( /** @type {?} */(INITIAL_VALUE)))); }))).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["scan"])(( /**
                 * @param {?} acc
                 * @param {?} list
                 * @return {?}
                 */function (acc, list) {
                        /** @type {?} */
                        var isPending = false;
                        return list.reduce(( /**
                         * @param {?} innerAcc
                         * @param {?} val
                         * @param {?} i
                         * @return {?}
                         */function (innerAcc, val, i) {
                            if (innerAcc !== INITIAL_VALUE)
                                return innerAcc;
                            // Toggle pending flag if any values haven't been set yet
                            if (val === INITIAL_VALUE)
                                isPending = true;
                            // Any other return values are only valid if we haven't yet hit a pending call.
                            // This guarantees that in the case of a guard at the bottom of the tree that
                            // returns a redirect, we will wait for the higher priority guard at the top to
                            // finish before performing the redirect.
                            if (!isPending) {
                                // Early return when we hit a `false` value as that should always cancel
                                // navigation
                                if (val === false)
                                    return val;
                                if (i === list.length - 1 || isUrlTree(val)) {
                                    return val;
                                }
                            }
                            return innerAcc;
                        }), acc);
                    }), INITIAL_VALUE), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(( /**
                     * @param {?} item
                     * @return {?}
                     */function (/**
                     * @param {?} item
                     * @return {?}
                     */ item) { return item !== INITIAL_VALUE; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} item
                     * @return {?}
                     */function (/**
                     * @param {?} item
                     * @return {?}
                     */ item) { return isUrlTree(item) ? item : item === true; })), //
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["take"])(1))));
                }));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} moduleInjector
             * @param {?=} forwardEvent
             * @return {?}
             */
            function checkGuards(moduleInjector, forwardEvent) {
                return ( /**
                 * @param {?} source
                 * @return {?}
                 */function (source) {
                    return source.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) {
                        var targetSnapshot = t.targetSnapshot, currentSnapshot = t.currentSnapshot, _c = t.guards, canActivateChecks = _c.canActivateChecks, canDeactivateChecks = _c.canDeactivateChecks;
                        if (canDeactivateChecks.length === 0 && canActivateChecks.length === 0) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(Object.assign({}, t, { guardsResult: true }));
                        }
                        return runCanDeactivateChecks(canDeactivateChecks, ( /** @type {?} */(targetSnapshot)), currentSnapshot, moduleInjector)
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} canDeactivate
                     * @return {?}
                     */function (/**
                     * @param {?} canDeactivate
                     * @return {?}
                     */ canDeactivate) {
                            return canDeactivate && isBoolean(canDeactivate) ?
                                runCanActivateChecks(( /** @type {?} */(targetSnapshot)), canActivateChecks, moduleInjector, forwardEvent) :
                                Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(canDeactivate);
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} guardsResult
                         * @return {?}
                         */function (/**
                         * @param {?} guardsResult
                         * @return {?}
                         */ guardsResult) { return (Object.assign({}, t, { guardsResult: guardsResult })); })));
                    })));
                });
            }
            /**
             * @param {?} checks
             * @param {?} futureRSS
             * @param {?} currRSS
             * @param {?} moduleInjector
             * @return {?}
             */
            function runCanDeactivateChecks(checks, futureRSS, currRSS, moduleInjector) {
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(checks).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                 * @param {?} check
                 * @return {?}
                 */function (/**
                 * @param {?} check
                 * @return {?}
                 */ check) { return runCanDeactivate(check.component, check.route, currRSS, futureRSS, moduleInjector); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])(( /**
                 * @param {?} result
                 * @return {?}
                 */function (/**
                 * @param {?} result
                 * @return {?}
                 */ result) { return result !== true; }), ( /** @type {?} */(true))));
            }
            /**
             * @param {?} futureSnapshot
             * @param {?} checks
             * @param {?} moduleInjector
             * @param {?=} forwardEvent
             * @return {?}
             */
            function runCanActivateChecks(futureSnapshot, checks, moduleInjector, forwardEvent) {
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(checks).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatMap"])(( /**
                 * @param {?} check
                 * @return {?}
                 */function (check) {
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])([
                        fireChildActivationStart(check.route.parent, forwardEvent),
                        fireActivationStart(check.route, forwardEvent),
                        runCanActivateChild(futureSnapshot, check.path, moduleInjector),
                        runCanActivate(futureSnapshot, check.route, moduleInjector)
                    ])
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatAll"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])(( /**
                 * @param {?} result
                 * @return {?}
                 */function (/**
                 * @param {?} result
                 * @return {?}
                 */ result) {
                        return result !== true;
                    }), ( /** @type {?} */(true))));
                })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])(( /**
                 * @param {?} result
                 * @return {?}
                 */function (/**
                 * @param {?} result
                 * @return {?}
                 */ result) { return result !== true; }), ( /** @type {?} */(true))));
            }
            /**
             * This should fire off `ActivationStart` events for each route being activated at this
             * level.
             * In other words, if you're activating `a` and `b` below, `path` will contain the
             * `ActivatedRouteSnapshot`s for both and we will fire `ActivationStart` for both. Always
             * return
             * `true` so checks continue to run.
             * @param {?} snapshot
             * @param {?=} forwardEvent
             * @return {?}
             */
            function fireActivationStart(snapshot, forwardEvent) {
                if (snapshot !== null && forwardEvent) {
                    forwardEvent(new ActivationStart(snapshot));
                }
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(true);
            }
            /**
             * This should fire off `ChildActivationStart` events for each route being activated at this
             * level.
             * In other words, if you're activating `a` and `b` below, `path` will contain the
             * `ActivatedRouteSnapshot`s for both and we will fire `ChildActivationStart` for both. Always
             * return
             * `true` so checks continue to run.
             * @param {?} snapshot
             * @param {?=} forwardEvent
             * @return {?}
             */
            function fireChildActivationStart(snapshot, forwardEvent) {
                if (snapshot !== null && forwardEvent) {
                    forwardEvent(new ChildActivationStart(snapshot));
                }
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(true);
            }
            /**
             * @param {?} futureRSS
             * @param {?} futureARS
             * @param {?} moduleInjector
             * @return {?}
             */
            function runCanActivate(futureRSS, futureARS, moduleInjector) {
                /** @type {?} */
                var canActivate = futureARS.routeConfig ? futureARS.routeConfig.canActivate : null;
                if (!canActivate || canActivate.length === 0)
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(true);
                /** @type {?} */
                var canActivateObservables = canActivate.map(( /**
                 * @param {?} c
                 * @return {?}
                 */function (c) {
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["defer"])(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var guard = getToken(c, futureARS, moduleInjector);
                        /** @type {?} */
                        var observable;
                        if (isCanActivate(guard)) {
                            observable = wrapIntoObservable(guard.canActivate(futureARS, futureRSS));
                        }
                        else if (isFunction(guard)) {
                            observable = wrapIntoObservable(guard(futureARS, futureRSS));
                        }
                        else {
                            throw new Error('Invalid CanActivate guard');
                        }
                        return observable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])());
                    }));
                }));
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(canActivateObservables).pipe(prioritizedGuardValue());
            }
            /**
             * @param {?} futureRSS
             * @param {?} path
             * @param {?} moduleInjector
             * @return {?}
             */
            function runCanActivateChild(futureRSS, path, moduleInjector) {
                /** @type {?} */
                var futureARS = path[path.length - 1];
                /** @type {?} */
                var canActivateChildGuards = path.slice(0, path.length - 1)
                    .reverse()
                    .map(( /**
             * @param {?} p
             * @return {?}
             */function (/**
             * @param {?} p
             * @return {?}
             */ p) { return getCanActivateChild(p); }))
                    .filter(( /**
             * @param {?} _
             * @return {?}
             */function (/**
             * @param {?} _
             * @return {?}
             */ _) { return _ !== null; }));
                /** @type {?} */
                var canActivateChildGuardsMapped = canActivateChildGuards.map(( /**
                 * @param {?} d
                 * @return {?}
                 */function (d) {
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["defer"])(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var guardsMapped = d.guards.map(( /**
                         * @param {?} c
                         * @return {?}
                         */function (c) {
                            /** @type {?} */
                            var guard = getToken(c, d.node, moduleInjector);
                            /** @type {?} */
                            var observable;
                            if (isCanActivateChild(guard)) {
                                observable = wrapIntoObservable(guard.canActivateChild(futureARS, futureRSS));
                            }
                            else if (isFunction(guard)) {
                                observable = wrapIntoObservable(guard(futureARS, futureRSS));
                            }
                            else {
                                throw new Error('Invalid CanActivateChild guard');
                            }
                            return observable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])());
                        }));
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(guardsMapped).pipe(prioritizedGuardValue());
                    }));
                }));
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(canActivateChildGuardsMapped).pipe(prioritizedGuardValue());
            }
            /**
             * @param {?} component
             * @param {?} currARS
             * @param {?} currRSS
             * @param {?} futureRSS
             * @param {?} moduleInjector
             * @return {?}
             */
            function runCanDeactivate(component, currARS, currRSS, futureRSS, moduleInjector) {
                /** @type {?} */
                var canDeactivate = currARS && currARS.routeConfig ? currARS.routeConfig.canDeactivate : null;
                if (!canDeactivate || canDeactivate.length === 0)
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(true);
                /** @type {?} */
                var canDeactivateObservables = canDeactivate.map(( /**
                 * @param {?} c
                 * @return {?}
                 */function (c) {
                    /** @type {?} */
                    var guard = getToken(c, currARS, moduleInjector);
                    /** @type {?} */
                    var observable;
                    if (isCanDeactivate(guard)) {
                        observable =
                            wrapIntoObservable(guard.canDeactivate(( /** @type {?} */(component)), currARS, currRSS, futureRSS));
                    }
                    else if (isFunction(guard)) {
                        observable = wrapIntoObservable(guard(component, currARS, currRSS, futureRSS));
                    }
                    else {
                        throw new Error('Invalid CanDeactivate guard');
                    }
                    return observable.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])());
                }));
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(canDeactivateObservables).pipe(prioritizedGuardValue());
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NoMatch$1 = /** @class */ (function () {
                function NoMatch$1() {
                }
                return NoMatch$1;
            }());
            /**
             * @param {?} rootComponentType
             * @param {?} config
             * @param {?} urlTree
             * @param {?} url
             * @param {?=} paramsInheritanceStrategy
             * @param {?=} relativeLinkResolution
             * @return {?}
             */
            function recognize(rootComponentType, config, urlTree, url, paramsInheritanceStrategy, relativeLinkResolution) {
                if (paramsInheritanceStrategy === void 0) { paramsInheritanceStrategy = 'emptyOnly'; }
                if (relativeLinkResolution === void 0) { relativeLinkResolution = 'legacy'; }
                return new Recognizer(rootComponentType, config, urlTree, url, paramsInheritanceStrategy, relativeLinkResolution)
                    .recognize();
            }
            var Recognizer = /** @class */ (function () {
                /**
                 * @param {?} rootComponentType
                 * @param {?} config
                 * @param {?} urlTree
                 * @param {?} url
                 * @param {?} paramsInheritanceStrategy
                 * @param {?} relativeLinkResolution
                 */
                function Recognizer(rootComponentType, config, urlTree, url, paramsInheritanceStrategy, relativeLinkResolution) {
                    this.rootComponentType = rootComponentType;
                    this.config = config;
                    this.urlTree = urlTree;
                    this.url = url;
                    this.paramsInheritanceStrategy = paramsInheritanceStrategy;
                    this.relativeLinkResolution = relativeLinkResolution;
                }
                /**
                 * @return {?}
                 */
                Recognizer.prototype.recognize = function () {
                    try {
                        /** @type {?} */
                        var rootSegmentGroup = split$1(this.urlTree.root, [], [], this.config, this.relativeLinkResolution).segmentGroup;
                        /** @type {?} */
                        var children = this.processSegmentGroup(this.config, rootSegmentGroup, PRIMARY_OUTLET);
                        /** @type {?} */
                        var root = new ActivatedRouteSnapshot([], Object.freeze({}), Object.freeze(Object.assign({}, this.urlTree.queryParams)), ( /** @type {?} */(this.urlTree.fragment)), {}, PRIMARY_OUTLET, this.rootComponentType, null, this.urlTree.root, -1, {});
                        /** @type {?} */
                        var rootNode = new TreeNode(root, children);
                        /** @type {?} */
                        var routeState = new RouterStateSnapshot(this.url, rootNode);
                        this.inheritParamsAndData(routeState._root);
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(routeState);
                    }
                    catch (e) {
                        return new rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"](( /**
                         * @param {?} obs
                         * @return {?}
                         */function (obs) { return obs.error(e); }));
                    }
                };
                /**
                 * @param {?} routeNode
                 * @return {?}
                 */
                Recognizer.prototype.inheritParamsAndData = function (routeNode) {
                    var _this = this;
                    /** @type {?} */
                    var route = routeNode.value;
                    /** @type {?} */
                    var i = inheritedParamsDataResolve(route, this.paramsInheritanceStrategy);
                    route.params = Object.freeze(i.params);
                    route.data = Object.freeze(i.data);
                    routeNode.children.forEach(( /**
                     * @param {?} n
                     * @return {?}
                     */function (/**
                     * @param {?} n
                     * @return {?}
                     */ n) { return _this.inheritParamsAndData(n); }));
                };
                /**
                 * @param {?} config
                 * @param {?} segmentGroup
                 * @param {?} outlet
                 * @return {?}
                 */
                Recognizer.prototype.processSegmentGroup = function (config, segmentGroup, outlet) {
                    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
                        return this.processChildren(config, segmentGroup);
                    }
                    return this.processSegment(config, segmentGroup, segmentGroup.segments, outlet);
                };
                /**
                 * @param {?} config
                 * @param {?} segmentGroup
                 * @return {?}
                 */
                Recognizer.prototype.processChildren = function (config, segmentGroup) {
                    var _this = this;
                    /** @type {?} */
                    var children = mapChildrenIntoArray(segmentGroup, ( /**
                     * @param {?} child
                     * @param {?} childOutlet
                     * @return {?}
                     */function (child, childOutlet) { return _this.processSegmentGroup(config, child, childOutlet); }));
                    checkOutletNameUniqueness(children);
                    sortActivatedRouteSnapshots(children);
                    return children;
                };
                /**
                 * @param {?} config
                 * @param {?} segmentGroup
                 * @param {?} segments
                 * @param {?} outlet
                 * @return {?}
                 */
                Recognizer.prototype.processSegment = function (config, segmentGroup, segments, outlet) {
                    for (var _c = 0, config_1 = config; _c < config_1.length; _c++) {
                        var r = config_1[_c];
                        try {
                            return this.processSegmentAgainstRoute(r, segmentGroup, segments, outlet);
                        }
                        catch (e) {
                            if (!(e instanceof NoMatch$1))
                                throw e;
                        }
                    }
                    if (this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
                        return [];
                    }
                    throw new NoMatch$1();
                };
                /**
                 * @private
                 * @param {?} segmentGroup
                 * @param {?} segments
                 * @param {?} outlet
                 * @return {?}
                 */
                Recognizer.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
                    return segments.length === 0 && !segmentGroup.children[outlet];
                };
                /**
                 * @param {?} route
                 * @param {?} rawSegment
                 * @param {?} segments
                 * @param {?} outlet
                 * @return {?}
                 */
                Recognizer.prototype.processSegmentAgainstRoute = function (route, rawSegment, segments, outlet) {
                    if (route.redirectTo)
                        throw new NoMatch$1();
                    if ((route.outlet || PRIMARY_OUTLET) !== outlet)
                        throw new NoMatch$1();
                    /** @type {?} */
                    var snapshot;
                    /** @type {?} */
                    var consumedSegments = [];
                    /** @type {?} */
                    var rawSlicedSegments = [];
                    if (route.path === '**') {
                        /** @type {?} */
                        var params = segments.length > 0 ? ( /** @type {?} */(last(segments))).parameters : {};
                        snapshot = new ActivatedRouteSnapshot(segments, params, Object.freeze(Object.assign({}, this.urlTree.queryParams)), ( /** @type {?} */(this.urlTree.fragment)), getData(route), outlet, ( /** @type {?} */(route.component)), route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + segments.length, getResolve(route));
                    }
                    else {
                        /** @type {?} */
                        var result = match$1(rawSegment, route, segments);
                        consumedSegments = result.consumedSegments;
                        rawSlicedSegments = segments.slice(result.lastChild);
                        snapshot = new ActivatedRouteSnapshot(consumedSegments, result.parameters, Object.freeze(Object.assign({}, this.urlTree.queryParams)), ( /** @type {?} */(this.urlTree.fragment)), getData(route), outlet, ( /** @type {?} */(route.component)), route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + consumedSegments.length, getResolve(route));
                    }
                    /** @type {?} */
                    var childConfig = getChildConfig(route);
                    var _c = split$1(rawSegment, consumedSegments, rawSlicedSegments, childConfig, this.relativeLinkResolution), segmentGroup = _c.segmentGroup, slicedSegments = _c.slicedSegments;
                    if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
                        /** @type {?} */
                        var children_4 = this.processChildren(childConfig, segmentGroup);
                        return [new TreeNode(snapshot, children_4)];
                    }
                    if (childConfig.length === 0 && slicedSegments.length === 0) {
                        return [new TreeNode(snapshot, [])];
                    }
                    /** @type {?} */
                    var children = this.processSegment(childConfig, segmentGroup, slicedSegments, PRIMARY_OUTLET);
                    return [new TreeNode(snapshot, children)];
                };
                return Recognizer;
            }());
            if (false) { }
            /**
             * @param {?} nodes
             * @return {?}
             */
            function sortActivatedRouteSnapshots(nodes) {
                nodes.sort(( /**
                 * @param {?} a
                 * @param {?} b
                 * @return {?}
                 */function (a, b) {
                    if (a.value.outlet === PRIMARY_OUTLET)
                        return -1;
                    if (b.value.outlet === PRIMARY_OUTLET)
                        return 1;
                    return a.value.outlet.localeCompare(b.value.outlet);
                }));
            }
            /**
             * @param {?} route
             * @return {?}
             */
            function getChildConfig(route) {
                if (route.children) {
                    return route.children;
                }
                if (route.loadChildren) {
                    return ( /** @type {?} */(route._loadedConfig)).routes;
                }
                return [];
            }
            /**
             * @record
             */
            function MatchResult() { }
            if (false) { }
            /**
             * @param {?} segmentGroup
             * @param {?} route
             * @param {?} segments
             * @return {?}
             */
            function match$1(segmentGroup, route, segments) {
                if (route.path === '') {
                    if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || segments.length > 0)) {
                        throw new NoMatch$1();
                    }
                    return { consumedSegments: [], lastChild: 0, parameters: {} };
                }
                /** @type {?} */
                var matcher = route.matcher || defaultUrlMatcher;
                /** @type {?} */
                var res = matcher(segments, segmentGroup, route);
                if (!res)
                    throw new NoMatch$1();
                /** @type {?} */
                var posParams = {};
                forEach(( /** @type {?} */(res.posParams)), ( /**
                 * @param {?} v
                 * @param {?} k
                 * @return {?}
                 */function (v, k) { posParams[k] = v.path; }));
                /** @type {?} */
                var parameters = res.consumed.length > 0 ? Object.assign({}, posParams, res.consumed[res.consumed.length - 1].parameters) :
                    posParams;
                return { consumedSegments: res.consumed, lastChild: res.consumed.length, parameters: parameters };
            }
            /**
             * @param {?} nodes
             * @return {?}
             */
            function checkOutletNameUniqueness(nodes) {
                /** @type {?} */
                var names = {};
                nodes.forEach(( /**
                 * @param {?} n
                 * @return {?}
                 */function (/**
                 * @param {?} n
                 * @return {?}
                 */ n) {
                    /** @type {?} */
                    var routeWithSameOutletName = names[n.value.outlet];
                    if (routeWithSameOutletName) {
                        /** @type {?} */
                        var p = routeWithSameOutletName.url.map(( /**
                         * @param {?} s
                         * @return {?}
                         */function (/**
                         * @param {?} s
                         * @return {?}
                         */ s) { return s.toString(); })).join('/');
                        /** @type {?} */
                        var c = n.value.url.map(( /**
                         * @param {?} s
                         * @return {?}
                         */function (/**
                         * @param {?} s
                         * @return {?}
                         */ s) { return s.toString(); })).join('/');
                        throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
                    }
                    names[n.value.outlet] = n.value;
                }));
            }
            /**
             * @param {?} segmentGroup
             * @return {?}
             */
            function getSourceSegmentGroup(segmentGroup) {
                /** @type {?} */
                var s = segmentGroup;
                while (s._sourceSegment) {
                    s = s._sourceSegment;
                }
                return s;
            }
            /**
             * @param {?} segmentGroup
             * @return {?}
             */
            function getPathIndexShift(segmentGroup) {
                /** @type {?} */
                var s = segmentGroup;
                /** @type {?} */
                var res = (s._segmentIndexShift ? s._segmentIndexShift : 0);
                while (s._sourceSegment) {
                    s = s._sourceSegment;
                    res += (s._segmentIndexShift ? s._segmentIndexShift : 0);
                }
                return res - 1;
            }
            /**
             * @param {?} segmentGroup
             * @param {?} consumedSegments
             * @param {?} slicedSegments
             * @param {?} config
             * @param {?} relativeLinkResolution
             * @return {?}
             */
            function split$1(segmentGroup, consumedSegments, slicedSegments, config, relativeLinkResolution) {
                if (slicedSegments.length > 0 &&
                    containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, config)) {
                    /** @type {?} */
                    var s_1 = new UrlSegmentGroup(consumedSegments, createChildrenForEmptyPaths(segmentGroup, consumedSegments, config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
                    s_1._sourceSegment = segmentGroup;
                    s_1._segmentIndexShift = consumedSegments.length;
                    return { segmentGroup: s_1, slicedSegments: [] };
                }
                if (slicedSegments.length === 0 &&
                    containsEmptyPathMatches(segmentGroup, slicedSegments, config)) {
                    /** @type {?} */
                    var s_2 = new UrlSegmentGroup(segmentGroup.segments, addEmptyPathsToChildrenIfNeeded(segmentGroup, consumedSegments, slicedSegments, config, segmentGroup.children, relativeLinkResolution));
                    s_2._sourceSegment = segmentGroup;
                    s_2._segmentIndexShift = consumedSegments.length;
                    return { segmentGroup: s_2, slicedSegments: slicedSegments };
                }
                /** @type {?} */
                var s = new UrlSegmentGroup(segmentGroup.segments, segmentGroup.children);
                s._sourceSegment = segmentGroup;
                s._segmentIndexShift = consumedSegments.length;
                return { segmentGroup: s, slicedSegments: slicedSegments };
            }
            /**
             * @param {?} segmentGroup
             * @param {?} consumedSegments
             * @param {?} slicedSegments
             * @param {?} routes
             * @param {?} children
             * @param {?} relativeLinkResolution
             * @return {?}
             */
            function addEmptyPathsToChildrenIfNeeded(segmentGroup, consumedSegments, slicedSegments, routes, children, relativeLinkResolution) {
                /** @type {?} */
                var res = {};
                for (var _c = 0, routes_4 = routes; _c < routes_4.length; _c++) {
                    var r = routes_4[_c];
                    if (emptyPathMatch(segmentGroup, slicedSegments, r) && !children[getOutlet$1(r)]) {
                        /** @type {?} */
                        var s = new UrlSegmentGroup([], {});
                        s._sourceSegment = segmentGroup;
                        if (relativeLinkResolution === 'legacy') {
                            s._segmentIndexShift = segmentGroup.segments.length;
                        }
                        else {
                            s._segmentIndexShift = consumedSegments.length;
                        }
                        res[getOutlet$1(r)] = s;
                    }
                }
                return Object.assign({}, children, res);
            }
            /**
             * @param {?} segmentGroup
             * @param {?} consumedSegments
             * @param {?} routes
             * @param {?} primarySegment
             * @return {?}
             */
            function createChildrenForEmptyPaths(segmentGroup, consumedSegments, routes, primarySegment) {
                /** @type {?} */
                var res = {};
                res[PRIMARY_OUTLET] = primarySegment;
                primarySegment._sourceSegment = segmentGroup;
                primarySegment._segmentIndexShift = consumedSegments.length;
                for (var _c = 0, routes_5 = routes; _c < routes_5.length; _c++) {
                    var r = routes_5[_c];
                    if (r.path === '' && getOutlet$1(r) !== PRIMARY_OUTLET) {
                        /** @type {?} */
                        var s = new UrlSegmentGroup([], {});
                        s._sourceSegment = segmentGroup;
                        s._segmentIndexShift = consumedSegments.length;
                        res[getOutlet$1(r)] = s;
                    }
                }
                return res;
            }
            /**
             * @param {?} segmentGroup
             * @param {?} slicedSegments
             * @param {?} routes
             * @return {?}
             */
            function containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, routes) {
                return routes.some(( /**
                 * @param {?} r
                 * @return {?}
                 */function (/**
                 * @param {?} r
                 * @return {?}
                 */ r) { return emptyPathMatch(segmentGroup, slicedSegments, r) && getOutlet$1(r) !== PRIMARY_OUTLET; }));
            }
            /**
             * @param {?} segmentGroup
             * @param {?} slicedSegments
             * @param {?} routes
             * @return {?}
             */
            function containsEmptyPathMatches(segmentGroup, slicedSegments, routes) {
                return routes.some(( /**
                 * @param {?} r
                 * @return {?}
                 */function (/**
                 * @param {?} r
                 * @return {?}
                 */ r) { return emptyPathMatch(segmentGroup, slicedSegments, r); }));
            }
            /**
             * @param {?} segmentGroup
             * @param {?} slicedSegments
             * @param {?} r
             * @return {?}
             */
            function emptyPathMatch(segmentGroup, slicedSegments, r) {
                if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full') {
                    return false;
                }
                return r.path === '' && r.redirectTo === undefined;
            }
            /**
             * @param {?} route
             * @return {?}
             */
            function getOutlet$1(route) {
                return route.outlet || PRIMARY_OUTLET;
            }
            /**
             * @param {?} route
             * @return {?}
             */
            function getData(route) {
                return route.data || {};
            }
            /**
             * @param {?} route
             * @return {?}
             */
            function getResolve(route) {
                return route.resolve || {};
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} rootComponentType
             * @param {?} config
             * @param {?} serializer
             * @param {?} paramsInheritanceStrategy
             * @param {?} relativeLinkResolution
             * @return {?}
             */
            function recognize$1(rootComponentType, config, serializer, paramsInheritanceStrategy, relativeLinkResolution) {
                return ( /**
                 * @param {?} source
                 * @return {?}
                 */function (source) {
                    return source.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return recognize(rootComponentType, config, t.urlAfterRedirects, serializer(t.urlAfterRedirects), paramsInheritanceStrategy, relativeLinkResolution)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                 * @param {?} targetSnapshot
                 * @return {?}
                 */function (/**
                 * @param {?} targetSnapshot
                 * @return {?}
                 */ targetSnapshot) { return (Object.assign({}, t, { targetSnapshot: targetSnapshot })); }))); })));
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @param {?} paramsInheritanceStrategy
             * @param {?} moduleInjector
             * @return {?}
             */
            function resolveData(paramsInheritanceStrategy, moduleInjector) {
                return ( /**
                 * @param {?} source
                 * @return {?}
                 */function (source) {
                    return source.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) {
                        var targetSnapshot = t.targetSnapshot, canActivateChecks = t.guards.canActivateChecks;
                        if (!canActivateChecks.length) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(t);
                        }
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(canActivateChecks)
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatMap"])(( /**
                     * @param {?} check
                     * @return {?}
                     */function (/**
                     * @param {?} check
                     * @return {?}
                     */ check) { return runResolve(check.route, ( /** @type {?} */(targetSnapshot)), paramsInheritanceStrategy, moduleInjector); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["reduce"])(( /**
                         * @param {?} _
                         * @param {?} __
                         * @return {?}
                         */function (_, __) { return _; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} _
                         * @return {?}
                         */function (/**
                         * @param {?} _
                         * @return {?}
                         */ _) { return t; })));
                    })));
                });
            }
            /**
             * @param {?} futureARS
             * @param {?} futureRSS
             * @param {?} paramsInheritanceStrategy
             * @param {?} moduleInjector
             * @return {?}
             */
            function runResolve(futureARS, futureRSS, paramsInheritanceStrategy, moduleInjector) {
                /** @type {?} */
                var resolve = futureARS._resolve;
                return resolveNode(resolve, futureARS, futureRSS, moduleInjector)
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
             * @param {?} resolvedData
             * @return {?}
             */function (resolvedData) {
                    futureARS._resolvedData = resolvedData;
                    futureARS.data = Object.assign({}, futureARS.data, inheritedParamsDataResolve(futureARS, paramsInheritanceStrategy).resolve);
                    return null;
                })));
            }
            /**
             * @param {?} resolve
             * @param {?} futureARS
             * @param {?} futureRSS
             * @param {?} moduleInjector
             * @return {?}
             */
            function resolveNode(resolve, futureARS, futureRSS, moduleInjector) {
                /** @type {?} */
                var keys = Object.keys(resolve);
                if (keys.length === 0) {
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])({});
                }
                if (keys.length === 1) {
                    /** @type {?} */
                    var key_1 = keys[0];
                    return getResolver(resolve[key_1], futureARS, futureRSS, moduleInjector)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                 * @param {?} value
                 * @return {?}
                 */function (value) {
                        var _c;
                        return _c = {}, _c[key_1] = value, _c;
                    })));
                }
                /** @type {?} */
                var data = {};
                /** @type {?} */
                var runningResolvers$ = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(keys).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                 * @param {?} key
                 * @return {?}
                 */function (key) {
                    return getResolver(resolve[key], futureARS, futureRSS, moduleInjector)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                 * @param {?} value
                 * @return {?}
                 */function (value) {
                        data[key] = value;
                        return value;
                    })));
                })));
                return runningResolvers$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["last"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                 * @return {?}
                 */function () { return data; })));
            }
            /**
             * @param {?} injectionToken
             * @param {?} futureARS
             * @param {?} futureRSS
             * @param {?} moduleInjector
             * @return {?}
             */
            function getResolver(injectionToken, futureARS, futureRSS, moduleInjector) {
                /** @type {?} */
                var resolver = getToken(injectionToken, futureARS, moduleInjector);
                return resolver.resolve ? wrapIntoObservable(resolver.resolve(futureARS, futureRSS)) :
                    wrapIntoObservable(resolver(futureARS, futureRSS));
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Perform a side effect through a switchMap for every emission on the source Observable,
             * but return an Observable that is identical to the source. It's essentially the same as
             * the `tap` operator, but if the side effectful `next` function returns an ObservableInput,
             * it will wait before continuing with the original value.
             * @template T
             * @param {?} next
             * @return {?}
             */
            function switchTap(next) {
                return ( /**
                 * @param {?} source
                 * @return {?}
                 */function (source) {
                    return source.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                     * @param {?} v
                     * @return {?}
                     */function (/**
                     * @param {?} v
                     * @return {?}
                     */ v) {
                        /** @type {?} */
                        var nextResult = next(v);
                        if (nextResult) {
                            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(nextResult).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                             * @return {?}
                             */function () { return v; })));
                        }
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])([v]);
                    })));
                });
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * \@description
             *
             * Provides a way to customize when activated routes get reused.
             *
             * \@publicApi
             * @abstract
             */
            var RouteReuseStrategy = /** @class */ (function () {
                function RouteReuseStrategy() {
                }
                return RouteReuseStrategy;
            }());
            if (false) { }
            /**
             * Does not detach any subtrees. Reuses routes as long as their route config is the same.
             */
            var DefaultRouteReuseStrategy = /** @class */ (function () {
                function DefaultRouteReuseStrategy() {
                }
                /**
                 * @param {?} route
                 * @return {?}
                 */
                DefaultRouteReuseStrategy.prototype.shouldDetach = function (route) { return false; };
                /**
                 * @param {?} route
                 * @param {?} detachedTree
                 * @return {?}
                 */
                DefaultRouteReuseStrategy.prototype.store = function (route, detachedTree) { };
                /**
                 * @param {?} route
                 * @return {?}
                 */
                DefaultRouteReuseStrategy.prototype.shouldAttach = function (route) { return false; };
                /**
                 * @param {?} route
                 * @return {?}
                 */
                DefaultRouteReuseStrategy.prototype.retrieve = function (route) { return null; };
                /**
                 * @param {?} future
                 * @param {?} curr
                 * @return {?}
                 */
                DefaultRouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
                    return future.routeConfig === curr.routeConfig;
                };
                return DefaultRouteReuseStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The [DI token](guide/glossary/#di-token) for a router configuration.
             * @see `ROUTES`
             * \@publicApi
             * @type {?}
             */
            var ROUTES = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('ROUTES');
            var RouterConfigLoader = /** @class */ (function () {
                /**
                 * @param {?} loader
                 * @param {?} compiler
                 * @param {?=} onLoadStartListener
                 * @param {?=} onLoadEndListener
                 */
                function RouterConfigLoader(loader, compiler, onLoadStartListener, onLoadEndListener) {
                    this.loader = loader;
                    this.compiler = compiler;
                    this.onLoadStartListener = onLoadStartListener;
                    this.onLoadEndListener = onLoadEndListener;
                }
                /**
                 * @param {?} parentInjector
                 * @param {?} route
                 * @return {?}
                 */
                RouterConfigLoader.prototype.load = function (parentInjector, route) {
                    var _this = this;
                    if (this.onLoadStartListener) {
                        this.onLoadStartListener(route);
                    }
                    /** @type {?} */
                    var moduleFactory$ = this.loadModuleFactory(( /** @type {?} */(route.loadChildren)));
                    return moduleFactory$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} factory
                     * @return {?}
                     */function (factory) {
                        if (_this.onLoadEndListener) {
                            _this.onLoadEndListener(route);
                        }
                        /** @type {?} */
                        var module = factory.create(parentInjector);
                        return new LoadedRouterConfig(flatten(module.injector.get(ROUTES)).map(standardizeConfig), module);
                    })));
                };
                /**
                 * @private
                 * @param {?} loadChildren
                 * @return {?}
                 */
                RouterConfigLoader.prototype.loadModuleFactory = function (loadChildren) {
                    var _this = this;
                    if (typeof loadChildren === 'string') {
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(this.loader.load(loadChildren));
                    }
                    else {
                        return wrapIntoObservable(loadChildren()).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (t) {
                            if (t instanceof _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleFactory"]) {
                                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(t);
                            }
                            else {
                                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(_this.compiler.compileModuleAsync(t));
                            }
                        })));
                    }
                };
                return RouterConfigLoader;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * \@description
             *
             * Provides a way to migrate AngularJS applications to Angular.
             *
             * \@publicApi
             * @abstract
             */
            var UrlHandlingStrategy = /** @class */ (function () {
                function UrlHandlingStrategy() {
                }
                return UrlHandlingStrategy;
            }());
            if (false) { }
            /**
             * \@publicApi
             */
            var DefaultUrlHandlingStrategy = /** @class */ (function () {
                function DefaultUrlHandlingStrategy() {
                }
                /**
                 * @param {?} url
                 * @return {?}
                 */
                DefaultUrlHandlingStrategy.prototype.shouldProcessUrl = function (url) { return true; };
                /**
                 * @param {?} url
                 * @return {?}
                 */
                DefaultUrlHandlingStrategy.prototype.extract = function (url) { return url; };
                /**
                 * @param {?} newUrlPart
                 * @param {?} wholeUrl
                 * @return {?}
                 */
                DefaultUrlHandlingStrategy.prototype.merge = function (newUrlPart, wholeUrl) { return newUrlPart; };
                return DefaultUrlHandlingStrategy;
            }());
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             *
             * Options that modify the navigation strategy.
             *
             * \@publicApi
             * @record
             */
            function NavigationExtras() { }
            if (false) { }
            /**
             * @param {?} error
             * @return {?}
             */
            function defaultErrorHandler(error) {
                throw error;
            }
            /**
             * @param {?} error
             * @param {?} urlSerializer
             * @param {?} url
             * @return {?}
             */
            function defaultMalformedUriErrorHandler(error, urlSerializer, url) {
                return urlSerializer.parse('/');
            }
            /**
             * \@internal
             * @param {?} snapshot
             * @param {?} runExtras
             * @return {?}
             */
            function defaultRouterHook(snapshot, runExtras) {
                return ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null)));
            }
            /**
             * \@description
             *
             * A service that provides navigation and URL manipulation capabilities.
             *
             * @see `Route`.
             * @see [Routing and Navigation Guide](guide/router).
             *
             * \@ngModule RouterModule
             *
             * \@publicApi
             */
            var Router = /** @class */ (function () {
                /**
                 * Creates the router service.
                 * @param {?} rootComponentType
                 * @param {?} urlSerializer
                 * @param {?} rootContexts
                 * @param {?} location
                 * @param {?} injector
                 * @param {?} loader
                 * @param {?} compiler
                 * @param {?} config
                 */
                // TODO: vsavkin make internal after the final is out.
                function Router(rootComponentType, urlSerializer, rootContexts, location, injector, loader, compiler, config) {
                    var _this = this;
                    this.rootComponentType = rootComponentType;
                    this.urlSerializer = urlSerializer;
                    this.rootContexts = rootContexts;
                    this.location = location;
                    this.config = config;
                    this.lastSuccessfulNavigation = null;
                    this.currentNavigation = null;
                    this.navigationId = 0;
                    this.isNgZoneEnabled = false;
                    /**
                     * An event stream for routing events in this NgModule.
                     */
                    this.events = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                    /**
                     * A handler for navigation errors in this NgModule.
                     */
                    this.errorHandler = defaultErrorHandler;
                    /**
                     * A handler for errors thrown by `Router.parseUrl(url)`
                     * when `url` contains an invalid character.
                     * The most common case is a `%` sign
                     * that's not encoded and is not part of a percent encoded sequence.
                     */
                    this.malformedUriErrorHandler = defaultMalformedUriErrorHandler;
                    /**
                     * True if at least one navigation event has occurred,
                     * false otherwise.
                     */
                    this.navigated = false;
                    this.lastSuccessfulId = -1;
                    /**
                     * Hooks that enable you to pause navigation,
                     * either before or after the preactivation phase.
                     * Used by `RouterModule`.
                     *
                     * \@internal
                     */
                    this.hooks = {
                        beforePreactivation: defaultRouterHook,
                        afterPreactivation: defaultRouterHook
                    };
                    /**
                     * A strategy for extracting and merging URLs.
                     * Used for AngularJS to Angular migrations.
                     */
                    this.urlHandlingStrategy = new DefaultUrlHandlingStrategy();
                    /**
                     * A strategy for re-using routes.
                     */
                    this.routeReuseStrategy = new DefaultRouteReuseStrategy();
                    /**
                     * How to handle a navigation request to the current URL. One of:
                     * - `'ignore'` :  The router ignores the request.
                     * - `'reload'` : The router reloads the URL. Use to implement a "refresh" feature.
                     */
                    this.onSameUrlNavigation = 'ignore';
                    /**
                     * How to merge parameters, data, and resolved data from parent to child
                     * routes. One of:
                     *
                     * - `'emptyOnly'` : Inherit parent parameters, data, and resolved data
                     * for path-less or component-less routes.
                     * - `'always'` : Inherit parent parameters, data, and resolved data
                     * for all child routes.
                     */
                    this.paramsInheritanceStrategy = 'emptyOnly';
                    /**
                     * Determines when the router updates the browser URL.
                     * By default (`"deferred"`), updates the browser URL after navigation has finished.
                     * Set to `'eager'` to update the browser URL at the beginning of navigation.
                     * You can choose to update early so that, if navigation fails,
                     * you can show an error message with the URL that failed.
                     */
                    this.urlUpdateStrategy = 'deferred';
                    /**
                     * Enables a bug fix that corrects relative link resolution in components with empty paths.
                     * @see `RouterModule`
                     */
                    this.relativeLinkResolution = 'legacy';
                    /** @type {?} */
                    var onLoadStart = ( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) { return _this.triggerEvent(new RouteConfigLoadStart(r)); });
                    /** @type {?} */
                    var onLoadEnd = ( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) { return _this.triggerEvent(new RouteConfigLoadEnd(r)); });
                    this.ngModule = injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleRef"]);
                    this.console = injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵConsole"]);
                    /** @type {?} */
                    var ngZone = injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]);
                    this.isNgZoneEnabled = ngZone instanceof _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"];
                    this.resetConfig(config);
                    this.currentUrlTree = createEmptyUrlTree();
                    this.rawUrlTree = this.currentUrlTree;
                    this.browserUrlTree = this.currentUrlTree;
                    this.configLoader = new RouterConfigLoader(loader, compiler, onLoadStart, onLoadEnd);
                    this.routerState = createEmptyState(this.currentUrlTree, this.rootComponentType);
                    this.transitions = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({
                        id: 0,
                        currentUrlTree: this.currentUrlTree,
                        currentRawUrl: this.currentUrlTree,
                        extractedUrl: this.urlHandlingStrategy.extract(this.currentUrlTree),
                        urlAfterRedirects: this.urlHandlingStrategy.extract(this.currentUrlTree),
                        rawUrl: this.currentUrlTree,
                        extras: {},
                        resolve: null,
                        reject: null,
                        promise: Promise.resolve(true),
                        source: 'imperative',
                        restoredState: null,
                        currentSnapshot: this.routerState.snapshot,
                        targetSnapshot: null,
                        currentRouterState: this.routerState,
                        targetRouterState: null,
                        guards: { canActivateChecks: [], canDeactivateChecks: [] },
                        guardsResult: null,
                    });
                    this.navigations = this.setupNavigations(this.transitions);
                    this.processNavigations();
                }
                /**
                 * @private
                 * @param {?} transitions
                 * @return {?}
                 */
                Router.prototype.setupNavigations = function (transitions) {
                    var _this = this;
                    /** @type {?} */
                    var eventsSubject = (( /** @type {?} */(this.events)));
                    return ( /** @type {?} */(( /** @type {?} */(transitions.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return t.id !== 0; })), 
                    // Extract URL
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) { return (( /** @type {?} */(Object.assign({}, t, { extractedUrl: _this.urlHandlingStrategy.extract(t.rawUrl) })))); })), 
                    // Using switchMap so we cancel executing navigations when a new one comes in
                    Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) {
                        /** @type {?} */
                        var completed = false;
                        /** @type {?} */
                        var errored = false;
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(t).pipe(
                        // Store the Navigation object
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            _this.currentNavigation = {
                                id: t.id,
                                initialUrl: t.currentRawUrl,
                                extractedUrl: t.extractedUrl,
                                trigger: t.source,
                                extras: t.extras,
                                previousNavigation: _this.lastSuccessfulNavigation ? Object.assign({}, _this.lastSuccessfulNavigation, { previousNavigation: null }) :
                                    null
                            };
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            /** @type {?} */
                            var urlTransition = !_this.navigated || t.extractedUrl.toString() !== _this.browserUrlTree.toString();
                            /** @type {?} */
                            var processCurrentUrl = (_this.onSameUrlNavigation === 'reload' ? true : urlTransition) &&
                                _this.urlHandlingStrategy.shouldProcessUrl(t.rawUrl);
                            if (processCurrentUrl) {
                                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(t).pipe(
                                // Fire NavigationStart event
                                Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) {
                                    /** @type {?} */
                                    var transition = _this.transitions.getValue();
                                    eventsSubject.next(new NavigationStart(t.id, _this.serializeUrl(t.extractedUrl), t.source, t.restoredState));
                                    if (transition !== _this.transitions.getValue()) {
                                        return rxjs__WEBPACK_IMPORTED_MODULE_2__["EMPTY"];
                                    }
                                    return [t];
                                })), 
                                // This delay is required to match old behavior that forced navigation to
                                // always be async
                                Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) { return Promise.resolve(t); })), 
                                // ApplyRedirects
                                applyRedirects$1(_this.ngModule.injector, _this.configLoader, _this.urlSerializer, _this.config), 
                                // Update the currentNavigation
                                Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) {
                                    _this.currentNavigation = Object.assign({}, ( /** @type {?} */(_this.currentNavigation)), { finalUrl: t.urlAfterRedirects });
                                })), 
                                // Recognize
                                recognize$1(_this.rootComponentType, _this.config, ( /**
                                 * @param {?} url
                                 * @return {?}
                                 */function (url) { return _this.serializeUrl(url); }), _this.paramsInheritanceStrategy, _this.relativeLinkResolution), 
                                // Update URL if in `eager` update mode
                                Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) {
                                    if (_this.urlUpdateStrategy === 'eager') {
                                        if (!t.extras.skipLocationChange) {
                                            _this.setBrowserUrl(t.urlAfterRedirects, !!t.extras.replaceUrl, t.id, t.extras.state);
                                        }
                                        _this.browserUrlTree = t.urlAfterRedirects;
                                    }
                                })), 
                                // Fire RoutesRecognized
                                Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) {
                                    /** @type {?} */
                                    var routesRecognized = new RoutesRecognized(t.id, _this.serializeUrl(t.extractedUrl), _this.serializeUrl(t.urlAfterRedirects), ( /** @type {?} */(t.targetSnapshot)));
                                    eventsSubject.next(routesRecognized);
                                })));
                            }
                            else {
                                /** @type {?} */
                                var processPreviousUrl = urlTransition && _this.rawUrlTree &&
                                    _this.urlHandlingStrategy.shouldProcessUrl(_this.rawUrlTree);
                                /* When the current URL shouldn't be processed, but the previous one was, we
                                 * handle this "error condition" by navigating to the previously successful URL,
                                 * but leaving the URL intact.*/
                                if (processPreviousUrl) {
                                    var id = t.id, extractedUrl = t.extractedUrl, source = t.source, restoredState = t.restoredState, extras = t.extras;
                                    /** @type {?} */
                                    var navStart = new NavigationStart(id, _this.serializeUrl(extractedUrl), source, restoredState);
                                    eventsSubject.next(navStart);
                                    /** @type {?} */
                                    var targetSnapshot = createEmptyState(extractedUrl, _this.rootComponentType).snapshot;
                                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(Object.assign({}, t, { targetSnapshot: targetSnapshot, urlAfterRedirects: extractedUrl, extras: Object.assign({}, extras, { skipLocationChange: false, replaceUrl: false }) }));
                                }
                                else {
                                    /* When neither the current or previous URL can be processed, do nothing other
                                     * than update router's internal reference to the current "settled" URL. This
                                     * way the next navigation will be coming from the current URL in the browser.
                                     */
                                    _this.rawUrlTree = t.rawUrl;
                                    _this.browserUrlTree = t.urlAfterRedirects;
                                    t.resolve(null);
                                    return rxjs__WEBPACK_IMPORTED_MODULE_2__["EMPTY"];
                                }
                            }
                        })), 
                        // Before Preactivation
                        switchTap(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            var targetSnapshot = t.targetSnapshot, navigationId = t.id, appliedUrlTree = t.extractedUrl, rawUrlTree = t.rawUrl, _c = t.extras, skipLocationChange = _c.skipLocationChange, replaceUrl = _c.replaceUrl;
                            return _this.hooks.beforePreactivation(( /** @type {?} */(targetSnapshot)), {
                                navigationId: navigationId,
                                appliedUrlTree: appliedUrlTree,
                                rawUrlTree: rawUrlTree,
                                skipLocationChange: !!skipLocationChange,
                                replaceUrl: !!replaceUrl,
                            });
                        })), 
                        // --- GUARDS ---
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            /** @type {?} */
                            var guardsStart = new GuardsCheckStart(t.id, _this.serializeUrl(t.extractedUrl), _this.serializeUrl(t.urlAfterRedirects), ( /** @type {?} */(t.targetSnapshot)));
                            _this.triggerEvent(guardsStart);
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) { return (Object.assign({}, t, { guards: getAllRouteGuards(( /** @type {?} */(t.targetSnapshot)), t.currentSnapshot, _this.rootContexts) })); })), checkGuards(_this.ngModule.injector, ( /**
                         * @param {?} evt
                         * @return {?}
                         */function (evt) { return _this.triggerEvent(evt); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            if (isUrlTree(t.guardsResult)) {
                                /** @type {?} */
                                var error = navigationCancelingError("Redirecting to \"" + _this.serializeUrl(t.guardsResult) + "\"");
                                error.url = t.guardsResult;
                                throw error;
                            }
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            /** @type {?} */
                            var guardsEnd = new GuardsCheckEnd(t.id, _this.serializeUrl(t.extractedUrl), _this.serializeUrl(t.urlAfterRedirects), ( /** @type {?} */(t.targetSnapshot)), !!t.guardsResult);
                            _this.triggerEvent(guardsEnd);
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            if (!t.guardsResult) {
                                _this.resetUrlToCurrentUrlTree();
                                /** @type {?} */
                                var navCancel = new NavigationCancel(t.id, _this.serializeUrl(t.extractedUrl), '');
                                eventsSubject.next(navCancel);
                                t.resolve(false);
                                return false;
                            }
                            return true;
                        })), 
                        // --- RESOLVE ---
                        switchTap(( /**
                         * @param {?} t
                         * @return {?}
                         */function (/**
                         * @param {?} t
                         * @return {?}
                         */ t) {
                            if (t.guards.canActivateChecks.length) {
                                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(t).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) {
                                    /** @type {?} */
                                    var resolveStart = new ResolveStart(t.id, _this.serializeUrl(t.extractedUrl), _this.serializeUrl(t.urlAfterRedirects), ( /** @type {?} */(t.targetSnapshot)));
                                    _this.triggerEvent(resolveStart);
                                })), resolveData(_this.paramsInheritanceStrategy, _this.ngModule.injector), //
                                Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                                 * @param {?} t
                                 * @return {?}
                                 */function (/**
                                 * @param {?} t
                                 * @return {?}
                                 */ t) {
                                    /** @type {?} */
                                    var resolveEnd = new ResolveEnd(t.id, _this.serializeUrl(t.extractedUrl), _this.serializeUrl(t.urlAfterRedirects), ( /** @type {?} */(t.targetSnapshot)));
                                    _this.triggerEvent(resolveEnd);
                                })));
                            }
                            return undefined;
                        })), 
                        // --- AFTER PREACTIVATION ---
                        switchTap(( /**
                         * @param {?} t
                         * @return {?}
                         */function (t) {
                            var targetSnapshot = t.targetSnapshot, navigationId = t.id, appliedUrlTree = t.extractedUrl, rawUrlTree = t.rawUrl, _c = t.extras, skipLocationChange = _c.skipLocationChange, replaceUrl = _c.replaceUrl;
                            return _this.hooks.afterPreactivation(( /** @type {?} */(targetSnapshot)), {
                                navigationId: navigationId,
                                appliedUrlTree: appliedUrlTree,
                                rawUrlTree: rawUrlTree,
                                skipLocationChange: !!skipLocationChange,
                                replaceUrl: !!replaceUrl,
                            });
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (t) {
                            /** @type {?} */
                            var targetRouterState = createRouterState(_this.routeReuseStrategy, ( /** @type {?} */(t.targetSnapshot)), t.currentRouterState);
                            return (Object.assign({}, t, { targetRouterState: targetRouterState }));
                        })), 
                        /* Once here, we are about to activate syncronously. The assumption is this will
                           succeed, and user code may read from the Router service. Therefore before
                           activation, we need to update router properties storing the current URL and the
                           RouterState, as well as updated the browser URL. All this should happen *before*
                           activating. */
                        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(( /**
                         * @param {?} t
                         * @return {?}
                         */function (t) {
                            _this.currentUrlTree = t.urlAfterRedirects;
                            _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, t.rawUrl);
                            (( /** @type {?} */(_this))).routerState = ( /** @type {?} */(t.targetRouterState));
                            if (_this.urlUpdateStrategy === 'deferred') {
                                if (!t.extras.skipLocationChange) {
                                    _this.setBrowserUrl(_this.rawUrlTree, !!t.extras.replaceUrl, t.id, t.extras.state);
                                }
                                _this.browserUrlTree = t.urlAfterRedirects;
                            }
                        })), activateRoutes(_this.rootContexts, _this.routeReuseStrategy, ( /**
                         * @param {?} evt
                         * @return {?}
                         */function (evt) { return _this.triggerEvent(evt); })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])({
                            next: function () { completed = true; },
                            complete: function () { completed = true; }
                        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["finalize"])(( /**
                     * @return {?}
                     */function () {
                            /* When the navigation stream finishes either through error or success, we set the
                             * `completed` or `errored` flag. However, there are some situations where we could
                             * get here without either of those being set. For instance, a redirect during
                             * NavigationStart. Therefore, this is a catch-all to make sure the NavigationCancel
                             * event is fired when a navigation gets cancelled but not caught by other means. */
                            if (!completed && !errored) {
                                // Must reset to current URL tree here to ensure history.state is set. On a fresh
                                // page load, if a new navigation comes in before a successful navigation
                                // completes, there will be nothing in history.state.navigationId. This can cause
                                // sync problems with AngularJS sync code which looks for a value here in order
                                // to determine whether or not to handle a given popstate event or to leave it
                                // to the Angualr router.
                                _this.resetUrlToCurrentUrlTree();
                                /** @type {?} */
                                var navCancel = new NavigationCancel(t.id, _this.serializeUrl(t.extractedUrl), "Navigation ID " + t.id + " is not equal to the current navigation id " + _this.navigationId);
                                eventsSubject.next(navCancel);
                                t.resolve(false);
                            }
                            // currentNavigation should always be reset to null here. If navigation was
                            // successful, lastSuccessfulTransition will have already been set. Therefore we
                            // can safely set currentNavigation to null here.
                            _this.currentNavigation = null;
                        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(( /**
                         * @param {?} e
                         * @return {?}
                         */function (e) {
                            errored = true;
                            /* This error type is issued during Redirect, and is handled as a cancellation
                             * rather than an error. */
                            if (isNavigationCancelingError(e)) {
                                /** @type {?} */
                                var redirecting = isUrlTree(e.url);
                                if (!redirecting) {
                                    // Set property only if we're not redirecting. If we landed on a page and
                                    // redirect to `/` route, the new navigation is going to see the `/` isn't
                                    // a change from the default currentUrlTree and won't navigate. This is
                                    // only applicable with initial navigation, so setting `navigated` only when
                                    // not redirecting resolves this scenario.
                                    _this.navigated = true;
                                    _this.resetStateAndUrl(t.currentRouterState, t.currentUrlTree, t.rawUrl);
                                }
                                /** @type {?} */
                                var navCancel = new NavigationCancel(t.id, _this.serializeUrl(t.extractedUrl), e.message);
                                eventsSubject.next(navCancel);
                                t.resolve(false);
                                if (redirecting) {
                                    _this.navigateByUrl(e.url);
                                }
                                /* All other errors should reset to the router's internal URL reference to the
                                 * pre-error state. */
                            }
                            else {
                                _this.resetStateAndUrl(t.currentRouterState, t.currentUrlTree, t.rawUrl);
                                /** @type {?} */
                                var navError = new NavigationError(t.id, _this.serializeUrl(t.extractedUrl), e);
                                eventsSubject.next(navError);
                                try {
                                    t.resolve(_this.errorHandler(e));
                                }
                                catch (ee) {
                                    t.reject(ee);
                                }
                            }
                            return rxjs__WEBPACK_IMPORTED_MODULE_2__["EMPTY"];
                        })));
                        // TODO(jasonaden): remove cast once g3 is on updated TypeScript
                    })))))));
                };
                /**
                 * \@internal
                 * TODO: this should be removed once the constructor of the router made internal
                 * @param {?} rootComponentType
                 * @return {?}
                 */
                Router.prototype.resetRootComponentType = function (rootComponentType) {
                    this.rootComponentType = rootComponentType;
                    // TODO: vsavkin router 4.0 should make the root component set to null
                    // this will simplify the lifecycle of the router.
                    this.routerState.root.component = this.rootComponentType;
                };
                /**
                 * @private
                 * @return {?}
                 */
                Router.prototype.getTransition = function () {
                    /** @type {?} */
                    var transition = this.transitions.value;
                    // This value needs to be set. Other values such as extractedUrl are set on initial navigation
                    // but the urlAfterRedirects may not get set if we aren't processing the new URL *and* not
                    // processing the previous URL.
                    transition.urlAfterRedirects = this.browserUrlTree;
                    return transition;
                };
                /**
                 * @private
                 * @param {?} t
                 * @return {?}
                 */
                Router.prototype.setTransition = function (t) {
                    this.transitions.next(Object.assign({}, this.getTransition(), t));
                };
                /**
                 * Sets up the location change listener and performs the initial navigation.
                 * @return {?}
                 */
                Router.prototype.initialNavigation = function () {
                    this.setUpLocationChangeListener();
                    if (this.navigationId === 0) {
                        this.navigateByUrl(this.location.path(true), { replaceUrl: true });
                    }
                };
                /**
                 * Sets up the location change listener.
                 * @return {?}
                 */
                Router.prototype.setUpLocationChangeListener = function () {
                    var _this = this;
                    // Don't need to use Zone.wrap any more, because zone.js
                    // already patch onPopState, so location change callback will
                    // run into ngZone
                    if (!this.locationSubscription) {
                        this.locationSubscription = ( /** @type {?} */(this.location.subscribe(( /**
                         * @param {?} change
                         * @return {?}
                         */function (change) {
                            /** @type {?} */
                            var rawUrlTree = _this.parseUrl(change['url']);
                            /** @type {?} */
                            var source = change['type'] === 'popstate' ? 'popstate' : 'hashchange';
                            // Navigations coming from Angular router have a navigationId state property. When this
                            // exists, restore the state.
                            /** @type {?} */
                            var state = change.state && change.state.navigationId ? change.state : null;
                            setTimeout(( /**
                             * @return {?}
                             */function () { _this.scheduleNavigation(rawUrlTree, source, state, { replaceUrl: true }); }), 0);
                        }))));
                    }
                };
                Object.defineProperty(Router.prototype, "url", {
                    /**
                     * The current URL.
                     * @return {?}
                     */
                    get: function () { return this.serializeUrl(this.currentUrlTree); },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * The current Navigation object if one exists
                 * @return {?}
                 */
                Router.prototype.getCurrentNavigation = function () { return this.currentNavigation; };
                /**
                 * \@internal
                 * @param {?} event
                 * @return {?}
                 */
                Router.prototype.triggerEvent = function (event) { (( /** @type {?} */(this.events))).next(event); };
                /**
                 * Resets the configuration used for navigation and generating links.
                 *
                 * \@usageNotes
                 *
                 * ```
                 * router.resetConfig([
                 *  { path: 'team/:id', component: TeamCmp, children: [
                 *    { path: 'simple', component: SimpleCmp },
                 *    { path: 'user/:name', component: UserCmp }
                 *  ]}
                 * ]);
                 * ```
                 * @param {?} config The route array for the new configuration.
                 *
                 * @return {?}
                 */
                Router.prototype.resetConfig = function (config) {
                    validateConfig(config);
                    this.config = config.map(standardizeConfig);
                    this.navigated = false;
                    this.lastSuccessfulId = -1;
                };
                /**
                 * \@docsNotRequired
                 * @return {?}
                 */
                Router.prototype.ngOnDestroy = function () { this.dispose(); };
                /**
                 * Disposes of the router.
                 * @return {?}
                 */
                Router.prototype.dispose = function () {
                    if (this.locationSubscription) {
                        this.locationSubscription.unsubscribe();
                        this.locationSubscription = ( /** @type {?} */(null));
                    }
                };
                /**
                 * Applies an array of commands to the current URL tree and creates a new URL tree.
                 *
                 * When given an activated route, applies the given commands starting from the route.
                 * Otherwise, applies the given command starting from the root.
                 *
                 * \@usageNotes
                 *
                 * ```
                 * // create /team/33/user/11
                 * router.createUrlTree(['/team', 33, 'user', 11]);
                 *
                 * // create /team/33;expand=true/user/11
                 * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
                 *
                 * // you can collapse static segments like this (this works only with the first passed-in value):
                 * router.createUrlTree(['/team/33/user', userId]);
                 *
                 * // If the first segment can contain slashes, and you do not want the router to split it,
                 * // you can do the following:
                 * router.createUrlTree([{segmentPath: '/one/two'}]);
                 *
                 * // create /team/33/(user/11//right:chat)
                 * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
                 *
                 * // remove the right secondary node
                 * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
                 *
                 * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
                 *
                 * // navigate to /team/33/user/11/details
                 * router.createUrlTree(['details'], {relativeTo: route});
                 *
                 * // navigate to /team/33/user/22
                 * router.createUrlTree(['../22'], {relativeTo: route});
                 *
                 * // navigate to /team/44/user/22
                 * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
                 * ```
                 * @param {?} commands An array of commands to apply.
                 * @param {?=} navigationExtras Options that control the navigation strategy.
                 * @return {?} The new URL tree.
                 *
                 */
                Router.prototype.createUrlTree = function (commands, navigationExtras) {
                    if (navigationExtras === void 0) { navigationExtras = {}; }
                    var relativeTo = navigationExtras.relativeTo, queryParams = navigationExtras.queryParams, fragment = navigationExtras.fragment, preserveQueryParams = navigationExtras.preserveQueryParams, queryParamsHandling = navigationExtras.queryParamsHandling, preserveFragment = navigationExtras.preserveFragment;
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && preserveQueryParams && ( /** @type {?} */(console)) && ( /** @type {?} */(console.warn))) {
                        console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
                    }
                    /** @type {?} */
                    var a = relativeTo || this.routerState.root;
                    /** @type {?} */
                    var f = preserveFragment ? this.currentUrlTree.fragment : fragment;
                    /** @type {?} */
                    var q = null;
                    if (queryParamsHandling) {
                        switch (queryParamsHandling) {
                            case 'merge':
                                q = Object.assign({}, this.currentUrlTree.queryParams, queryParams);
                                break;
                            case 'preserve':
                                q = this.currentUrlTree.queryParams;
                                break;
                            default:
                                q = queryParams || null;
                        }
                    }
                    else {
                        q = preserveQueryParams ? this.currentUrlTree.queryParams : queryParams || null;
                    }
                    if (q !== null) {
                        q = this.removeEmptyProps(q);
                    }
                    return createUrlTree(a, this.currentUrlTree, commands, ( /** @type {?} */(q)), ( /** @type {?} */(f)));
                };
                /**
                 * Navigate based on the provided URL, which must be absolute.
                 *
                 * \@usageNotes
                 *
                 * ```
                 * router.navigateByUrl("/team/33/user/11");
                 *
                 * // Navigate without updating the URL
                 * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
                 * ```
                 *
                 * @param {?} url An absolute URL. The function does not apply any delta to the current URL.
                 * @param {?=} extras An object containing properties that modify the navigation strategy.
                 * The function ignores any properties in the `NavigationExtras` that would change the
                 * provided URL.
                 *
                 * @return {?} A Promise that resolves to 'true' when navigation succeeds,
                 * to 'false' when navigation fails, or is rejected on error.
                 *
                 */
                Router.prototype.navigateByUrl = function (url, extras) {
                    if (extras === void 0) { extras = { skipLocationChange: false }; }
                    if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && this.isNgZoneEnabled && !_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"].isInAngularZone()) {
                        this.console.warn("Navigation triggered outside Angular zone, did you forget to call 'ngZone.run()'?");
                    }
                    /** @type {?} */
                    var urlTree = isUrlTree(url) ? url : this.parseUrl(url);
                    /** @type {?} */
                    var mergedTree = this.urlHandlingStrategy.merge(urlTree, this.rawUrlTree);
                    return this.scheduleNavigation(mergedTree, 'imperative', null, extras);
                };
                /**
                 * Navigate based on the provided array of commands and a starting point.
                 * If no starting route is provided, the navigation is absolute.
                 *
                 * Returns a promise that:
                 * - resolves to 'true' when navigation succeeds,
                 * - resolves to 'false' when navigation fails,
                 * - is rejected when an error happens.
                 *
                 * \@usageNotes
                 *
                 * ```
                 * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
                 *
                 * // Navigate without updating the URL
                 * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
                 * ```
                 *
                 * The first parameter of `navigate()` is a delta to be applied to the current URL
                 * or the one provided in the `relativeTo` property of the second parameter (the
                 * `NavigationExtras`).
                 *
                 * In order to affect this browser's `history.state` entry, the `state`
                 * parameter can be passed. This must be an object because the router
                 * will add the `navigationId` property to this object before creating
                 * the new history item.
                 * @param {?} commands
                 * @param {?=} extras
                 * @return {?}
                 */
                Router.prototype.navigate = function (commands, extras) {
                    if (extras === void 0) { extras = { skipLocationChange: false }; }
                    validateCommands(commands);
                    return this.navigateByUrl(this.createUrlTree(commands, extras), extras);
                };
                /**
                 * Serializes a `UrlTree` into a string
                 * @param {?} url
                 * @return {?}
                 */
                Router.prototype.serializeUrl = function (url) { return this.urlSerializer.serialize(url); };
                /**
                 * Parses a string into a `UrlTree`
                 * @param {?} url
                 * @return {?}
                 */
                Router.prototype.parseUrl = function (url) {
                    /** @type {?} */
                    var urlTree;
                    try {
                        urlTree = this.urlSerializer.parse(url);
                    }
                    catch (e) {
                        urlTree = this.malformedUriErrorHandler(e, this.urlSerializer, url);
                    }
                    return urlTree;
                };
                /**
                 * Returns whether the url is activated
                 * @param {?} url
                 * @param {?} exact
                 * @return {?}
                 */
                Router.prototype.isActive = function (url, exact) {
                    if (isUrlTree(url)) {
                        return containsTree(this.currentUrlTree, url, exact);
                    }
                    /** @type {?} */
                    var urlTree = this.parseUrl(url);
                    return containsTree(this.currentUrlTree, urlTree, exact);
                };
                /**
                 * @private
                 * @param {?} params
                 * @return {?}
                 */
                Router.prototype.removeEmptyProps = function (params) {
                    return Object.keys(params).reduce(( /**
                     * @param {?} result
                     * @param {?} key
                     * @return {?}
                     */function (result, key) {
                        /** @type {?} */
                        var value = params[key];
                        if (value !== null && value !== undefined) {
                            result[key] = value;
                        }
                        return result;
                    }), {});
                };
                /**
                 * @private
                 * @return {?}
                 */
                Router.prototype.processNavigations = function () {
                    var _this = this;
                    this.navigations.subscribe(( /**
                     * @param {?} t
                     * @return {?}
                     */function (/**
                     * @param {?} t
                     * @return {?}
                     */ t) {
                        _this.navigated = true;
                        _this.lastSuccessfulId = t.id;
                        (( /** @type {?} */(_this.events)))
                            .next(new NavigationEnd(t.id, _this.serializeUrl(t.extractedUrl), _this.serializeUrl(_this.currentUrlTree)));
                        _this.lastSuccessfulNavigation = _this.currentNavigation;
                        _this.currentNavigation = null;
                        t.resolve(true);
                    }), ( /**
                     * @param {?} e
                     * @return {?}
                     */function (/**
                     * @param {?} e
                     * @return {?}
                     */ e) { _this.console.warn("Unhandled Navigation Error: "); }));
                };
                /**
                 * @private
                 * @param {?} rawUrl
                 * @param {?} source
                 * @param {?} restoredState
                 * @param {?} extras
                 * @return {?}
                 */
                Router.prototype.scheduleNavigation = function (rawUrl, source, restoredState, extras) {
                    /** @type {?} */
                    var lastNavigation = this.getTransition();
                    // If the user triggers a navigation imperatively (e.g., by using navigateByUrl),
                    // and that navigation results in 'replaceState' that leads to the same URL,
                    // we should skip those.
                    if (lastNavigation && source !== 'imperative' && lastNavigation.source === 'imperative' &&
                        lastNavigation.rawUrl.toString() === rawUrl.toString()) {
                        return Promise.resolve(true); // return value is not used
                    }
                    // Because of a bug in IE and Edge, the location class fires two events (popstate and
                    // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
                    // flicker. Handles the case when a popstate was emitted first.
                    if (lastNavigation && source == 'hashchange' && lastNavigation.source === 'popstate' &&
                        lastNavigation.rawUrl.toString() === rawUrl.toString()) {
                        return Promise.resolve(true); // return value is not used
                    }
                    // Because of a bug in IE and Edge, the location class fires two events (popstate and
                    // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
                    // flicker. Handles the case when a hashchange was emitted first.
                    if (lastNavigation && source == 'popstate' && lastNavigation.source === 'hashchange' &&
                        lastNavigation.rawUrl.toString() === rawUrl.toString()) {
                        return Promise.resolve(true); // return value is not used
                    }
                    /** @type {?} */
                    var resolve = null;
                    /** @type {?} */
                    var reject = null;
                    /** @type {?} */
                    var promise = new Promise(( /**
                     * @param {?} res
                     * @param {?} rej
                     * @return {?}
                     */function (res, rej) {
                        resolve = res;
                        reject = rej;
                    }));
                    /** @type {?} */
                    var id = ++this.navigationId;
                    this.setTransition({
                        id: id,
                        source: source,
                        restoredState: restoredState,
                        currentUrlTree: this.currentUrlTree,
                        currentRawUrl: this.rawUrlTree, rawUrl: rawUrl, extras: extras, resolve: resolve, reject: reject, promise: promise,
                        currentSnapshot: this.routerState.snapshot,
                        currentRouterState: this.routerState
                    });
                    // Make sure that the error is propagated even though `processNavigations` catch
                    // handler does not rethrow
                    return promise.catch(( /**
                     * @param {?} e
                     * @return {?}
                     */function (e) { return Promise.reject(e); }));
                };
                /**
                 * @private
                 * @param {?} url
                 * @param {?} replaceUrl
                 * @param {?} id
                 * @param {?=} state
                 * @return {?}
                 */
                Router.prototype.setBrowserUrl = function (url, replaceUrl, id, state) {
                    /** @type {?} */
                    var path = this.urlSerializer.serialize(url);
                    state = state || {};
                    if (this.location.isCurrentPathEqualTo(path) || replaceUrl) {
                        // TODO(jasonaden): Remove first `navigationId` and rely on `ng` namespace.
                        this.location.replaceState(path, '', Object.assign({}, state, { navigationId: id }));
                    }
                    else {
                        this.location.go(path, '', Object.assign({}, state, { navigationId: id }));
                    }
                };
                /**
                 * @private
                 * @param {?} storedState
                 * @param {?} storedUrl
                 * @param {?} rawUrl
                 * @return {?}
                 */
                Router.prototype.resetStateAndUrl = function (storedState, storedUrl, rawUrl) {
                    (( /** @type {?} */(this))).routerState = storedState;
                    this.currentUrlTree = storedUrl;
                    this.rawUrlTree = this.urlHandlingStrategy.merge(this.currentUrlTree, rawUrl);
                    this.resetUrlToCurrentUrlTree();
                };
                /**
                 * @private
                 * @return {?}
                 */
                Router.prototype.resetUrlToCurrentUrlTree = function () {
                    this.location.replaceState(this.urlSerializer.serialize(this.rawUrlTree), '', { navigationId: this.lastSuccessfulId });
                };
                return Router;
            }());
            if (false) { }
            /**
             * @param {?} commands
             * @return {?}
             */
            function validateCommands(commands) {
                for (var i = 0; i < commands.length; i++) {
                    /** @type {?} */
                    var cmd = commands[i];
                    if (cmd == null) {
                        throw new Error("The requested path contains " + cmd + " segment at index " + i);
                    }
                }
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             *
             * Lets you link to specific routes in your app.
             *
             * Consider the following route configuration:
             * `[{ path: 'user/:name', component: UserCmp }]`.
             * When linking to this `user/:name` route, you use the `RouterLink` directive.
             *
             * If the link is static, you can use the directive as follows:
             * `<a routerLink="/user/bob">link to user component</a>`
             *
             * If you use dynamic values to generate the link, you can pass an array of path
             * segments, followed by the params for each segment.
             *
             * For instance `['/team', teamId, 'user', userName, {details: true}]`
             * means that we want to generate a link to `/team/11/user/bob;details=true`.
             *
             * Multiple static segments can be merged into one
             * (e.g., `['/team/11/user', userName, {details: true}]`).
             *
             * The first segment name can be prepended with `/`, `./`, or `../`:
             * * If the first segment begins with `/`, the router will look up the route from the root of the
             *   app.
             * * If the first segment begins with `./`, or doesn't begin with a slash, the router will
             *   instead look in the children of the current activated route.
             * * And if the first segment begins with `../`, the router will go up one level.
             *
             * You can set query params and fragment as follows:
             *
             * ```
             * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" fragment="education">
             *   link to user component
             * </a>
             * ```
             * RouterLink will use these to generate this link: `/user/bob#education?debug=true`.
             *
             * (Deprecated in v4.0.0 use `queryParamsHandling` instead) You can also tell the
             * directive to preserve the current query params and fragment:
             *
             * ```
             * <a [routerLink]="['/user/bob']" preserveQueryParams preserveFragment>
             *   link to user component
             * </a>
             * ```
             *
             * You can tell the directive how to handle queryParams. Available options are:
             *  - `'merge'`: merge the queryParams into the current queryParams
             *  - `'preserve'`: preserve the current queryParams
             *  - default/`''`: use the queryParams only
             *
             * Same options for {\@link NavigationExtras#queryParamsHandling
             * NavigationExtras#queryParamsHandling}.
             *
             * ```
             * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" queryParamsHandling="merge">
             *   link to user component
             * </a>
             * ```
             *
             * You can provide a `state` value to be persisted to the browser's History.state
             * property (See https://developer.mozilla.org/en-US/docs/Web/API/History#Properties). It's
             * used as follows:
             *
             * ```
             * <a [routerLink]="['/user/bob']" [state]="{tracingId: 123}">
             *   link to user component
             * </a>
             * ```
             *
             * And later the value can be read from the router through `router.getCurrentNavigation`.
             * For example, to capture the `tracingId` above during the `NavigationStart` event:
             *
             * ```
             * // Get NavigationStart events
             * router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(e => {
             *   const navigation = router.getCurrentNavigation();
             *   tracingService.trace({id: navigation.extras.state.tracingId});
             * });
             * ```
             *
             * The router link directive always treats the provided input as a delta to the current url.
             *
             * For instance, if the current url is `/user/(box//aux:team)`.
             *
             * Then the following link `<a [routerLink]="['/user/jim']">Jim</a>` will generate the link
             * `/user/(jim//aux:team)`.
             *
             * See {\@link Router#createUrlTree createUrlTree} for more information.
             *
             * \@ngModule RouterModule
             *
             * \@publicApi
             */
            var RouterLink = /** @class */ (function () {
                /**
                 * @param {?} router
                 * @param {?} route
                 * @param {?} tabIndex
                 * @param {?} renderer
                 * @param {?} el
                 */
                function RouterLink(router, route, tabIndex, renderer, el) {
                    this.router = router;
                    this.route = route;
                    this.commands = [];
                    if (tabIndex == null) {
                        renderer.setAttribute(el.nativeElement, 'tabindex', '0');
                    }
                }
                Object.defineProperty(RouterLink.prototype, "routerLink", {
                    /**
                     * @param {?} commands
                     * @return {?}
                     */
                    set: function (commands) {
                        if (commands != null) {
                            this.commands = Array.isArray(commands) ? commands : [commands];
                        }
                        else {
                            this.commands = [];
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(RouterLink.prototype, "preserveQueryParams", {
                    /**
                     * @deprecated 4.0.0 use `queryParamsHandling` instead.
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && ( /** @type {?} */(console)) && ( /** @type {?} */(console.warn))) {
                            console.warn('preserveQueryParams is deprecated!, use queryParamsHandling instead.');
                        }
                        this.preserve = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                RouterLink.prototype.onClick = function () {
                    /** @type {?} */
                    var extras = {
                        skipLocationChange: attrBoolValue(this.skipLocationChange),
                        replaceUrl: attrBoolValue(this.replaceUrl),
                    };
                    this.router.navigateByUrl(this.urlTree, extras);
                    return true;
                };
                Object.defineProperty(RouterLink.prototype, "urlTree", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.router.createUrlTree(this.commands, {
                            relativeTo: this.route,
                            queryParams: this.queryParams,
                            fragment: this.fragment,
                            preserveQueryParams: attrBoolValue(this.preserve),
                            queryParamsHandling: this.queryParamsHandling,
                            preserveFragment: attrBoolValue(this.preserveFragment),
                        });
                    },
                    enumerable: true,
                    configurable: true
                });
                return RouterLink;
            }());
            RouterLink.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: ':not(a):not(area)[routerLink]' },] }
            ];
            /** @nocollapse */
            RouterLink.ctorParameters = function () { return [
                { type: Router },
                { type: ActivatedRoute },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Attribute"], args: ['tabindex',] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Renderer2"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
            ]; };
            RouterLink.propDecorators = {
                queryParams: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                fragment: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                queryParamsHandling: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                preserveFragment: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                skipLocationChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                replaceUrl: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                state: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                routerLink: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                preserveQueryParams: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                onClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"], args: ['click',] }]
            };
            if (false) { }
            /**
             * \@description
             *
             * Lets you link to specific routes in your app.
             *
             * See `RouterLink` for more information.
             *
             * \@ngModule RouterModule
             *
             * \@publicApi
             */
            var RouterLinkWithHref = /** @class */ (function () {
                /**
                 * @param {?} router
                 * @param {?} route
                 * @param {?} locationStrategy
                 */
                function RouterLinkWithHref(router, route, locationStrategy) {
                    var _this = this;
                    this.router = router;
                    this.route = route;
                    this.locationStrategy = locationStrategy;
                    this.commands = [];
                    this.subscription = router.events.subscribe(( /**
                     * @param {?} s
                     * @return {?}
                     */function (s) {
                        if (s instanceof NavigationEnd) {
                            _this.updateTargetUrlAndHref();
                        }
                    }));
                }
                Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
                    /**
                     * @param {?} commands
                     * @return {?}
                     */
                    set: function (commands) {
                        if (commands != null) {
                            this.commands = Array.isArray(commands) ? commands : [commands];
                        }
                        else {
                            this.commands = [];
                        }
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(RouterLinkWithHref.prototype, "preserveQueryParams", {
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        if (Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["isDevMode"])() && ( /** @type {?} */(console)) && ( /** @type {?} */(console.warn))) {
                            console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
                        }
                        this.preserve = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                RouterLinkWithHref.prototype.ngOnChanges = function (changes) { this.updateTargetUrlAndHref(); };
                /**
                 * @return {?}
                 */
                RouterLinkWithHref.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
                /**
                 * @param {?} button
                 * @param {?} ctrlKey
                 * @param {?} metaKey
                 * @param {?} shiftKey
                 * @return {?}
                 */
                RouterLinkWithHref.prototype.onClick = function (button, ctrlKey, metaKey, shiftKey) {
                    if (button !== 0 || ctrlKey || metaKey || shiftKey) {
                        return true;
                    }
                    if (typeof this.target === 'string' && this.target != '_self') {
                        return true;
                    }
                    /** @type {?} */
                    var extras = {
                        skipLocationChange: attrBoolValue(this.skipLocationChange),
                        replaceUrl: attrBoolValue(this.replaceUrl),
                        state: this.state
                    };
                    this.router.navigateByUrl(this.urlTree, extras);
                    return false;
                };
                /**
                 * @private
                 * @return {?}
                 */
                RouterLinkWithHref.prototype.updateTargetUrlAndHref = function () {
                    this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
                };
                Object.defineProperty(RouterLinkWithHref.prototype, "urlTree", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.router.createUrlTree(this.commands, {
                            relativeTo: this.route,
                            queryParams: this.queryParams,
                            fragment: this.fragment,
                            preserveQueryParams: attrBoolValue(this.preserve),
                            queryParamsHandling: this.queryParamsHandling,
                            preserveFragment: attrBoolValue(this.preserveFragment),
                        });
                    },
                    enumerable: true,
                    configurable: true
                });
                return RouterLinkWithHref;
            }());
            RouterLinkWithHref.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: 'a[routerLink],area[routerLink]' },] }
            ];
            /** @nocollapse */
            RouterLinkWithHref.ctorParameters = function () { return [
                { type: Router },
                { type: ActivatedRoute },
                { type: _angular_common__WEBPACK_IMPORTED_MODULE_0__["LocationStrategy"] }
            ]; };
            RouterLinkWithHref.propDecorators = {
                target: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["HostBinding"], args: ['attr.target',] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                queryParams: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                fragment: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                queryParamsHandling: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                preserveFragment: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                skipLocationChange: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                replaceUrl: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                state: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                href: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["HostBinding"] }],
                routerLink: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                preserveQueryParams: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                onClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"], args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey', '$event.shiftKey'],] }]
            };
            if (false) { }
            /**
             * @param {?} s
             * @return {?}
             */
            function attrBoolValue(s) {
                return s === '' || !!s;
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             *
             * \@description
             *
             * Lets you add a CSS class to an element when the link's route becomes active.
             *
             * This directive lets you add a CSS class to an element when the link's route
             * becomes active.
             *
             * Consider the following example:
             *
             * ```
             * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
             * ```
             *
             * When the url is either '/user' or '/user/bob', the active-link class will
             * be added to the `a` tag. If the url changes, the class will be removed.
             *
             * You can set more than one class, as follows:
             *
             * ```
             * <a routerLink="/user/bob" routerLinkActive="class1 class2">Bob</a>
             * <a routerLink="/user/bob" [routerLinkActive]="['class1', 'class2']">Bob</a>
             * ```
             *
             * You can configure RouterLinkActive by passing `exact: true`. This will add the classes
             * only when the url matches the link exactly.
             *
             * ```
             * <a routerLink="/user/bob" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:
             * true}">Bob</a>
             * ```
             *
             * You can assign the RouterLinkActive instance to a template variable and directly check
             * the `isActive` status.
             * ```
             * <a routerLink="/user/bob" routerLinkActive #rla="routerLinkActive">
             *   Bob {{ rla.isActive ? '(already open)' : ''}}
             * </a>
             * ```
             *
             * Finally, you can apply the RouterLinkActive directive to an ancestor of a RouterLink.
             *
             * ```
             * <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
             *   <a routerLink="/user/jim">Jim</a>
             *   <a routerLink="/user/bob">Bob</a>
             * </div>
             * ```
             *
             * This will set the active-link class on the div tag if the url is either '/user/jim' or
             * '/user/bob'.
             *
             * \@ngModule RouterModule
             *
             * \@publicApi
             */
            var RouterLinkActive = /** @class */ (function () {
                /**
                 * @param {?} router
                 * @param {?} element
                 * @param {?} renderer
                 * @param {?=} link
                 * @param {?=} linkWithHref
                 */
                function RouterLinkActive(router, element, renderer, link, linkWithHref) {
                    var _this = this;
                    this.router = router;
                    this.element = element;
                    this.renderer = renderer;
                    this.link = link;
                    this.linkWithHref = linkWithHref;
                    this.classes = [];
                    this.isActive = false;
                    this.routerLinkActiveOptions = { exact: false };
                    this.subscription = router.events.subscribe(( /**
                     * @param {?} s
                     * @return {?}
                     */function (s) {
                        if (s instanceof NavigationEnd) {
                            _this.update();
                        }
                    }));
                }
                /**
                 * @return {?}
                 */
                RouterLinkActive.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    this.links.changes.subscribe(( /**
                     * @param {?} _
                     * @return {?}
                     */function (/**
                     * @param {?} _
                     * @return {?}
                     */ _) { return _this.update(); }));
                    this.linksWithHrefs.changes.subscribe(( /**
                     * @param {?} _
                     * @return {?}
                     */function (/**
                     * @param {?} _
                     * @return {?}
                     */ _) { return _this.update(); }));
                    this.update();
                };
                Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
                    /**
                     * @param {?} data
                     * @return {?}
                     */
                    set: function (data) {
                        /** @type {?} */
                        var classes = Array.isArray(data) ? data : data.split(' ');
                        this.classes = classes.filter(( /**
                         * @param {?} c
                         * @return {?}
                         */function (/**
                         * @param {?} c
                         * @return {?}
                         */ c) { return !!c; }));
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                RouterLinkActive.prototype.ngOnChanges = function (changes) { this.update(); };
                /**
                 * @return {?}
                 */
                RouterLinkActive.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
                /**
                 * @private
                 * @return {?}
                 */
                RouterLinkActive.prototype.update = function () {
                    var _this = this;
                    if (!this.links || !this.linksWithHrefs || !this.router.navigated)
                        return;
                    Promise.resolve().then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var hasActiveLinks = _this.hasActiveLinks();
                        if (_this.isActive !== hasActiveLinks) {
                            (( /** @type {?} */(_this))).isActive = hasActiveLinks;
                            _this.classes.forEach(( /**
                             * @param {?} c
                             * @return {?}
                             */function (c) {
                                if (hasActiveLinks) {
                                    _this.renderer.addClass(_this.element.nativeElement, c);
                                }
                                else {
                                    _this.renderer.removeClass(_this.element.nativeElement, c);
                                }
                            }));
                        }
                    }));
                };
                /**
                 * @private
                 * @param {?} router
                 * @return {?}
                 */
                RouterLinkActive.prototype.isLinkActive = function (router) {
                    var _this = this;
                    return ( /**
                     * @param {?} link
                     * @return {?}
                     */function (link) { return router.isActive(link.urlTree, _this.routerLinkActiveOptions.exact); });
                };
                /**
                 * @private
                 * @return {?}
                 */
                RouterLinkActive.prototype.hasActiveLinks = function () {
                    /** @type {?} */
                    var isActiveCheckFn = this.isLinkActive(this.router);
                    return this.link && isActiveCheckFn(this.link) ||
                        this.linkWithHref && isActiveCheckFn(this.linkWithHref) ||
                        this.links.some(isActiveCheckFn) || this.linksWithHrefs.some(isActiveCheckFn);
                };
                return RouterLinkActive;
            }());
            RouterLinkActive.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{
                            selector: '[routerLinkActive]',
                            exportAs: 'routerLinkActive',
                        },] }
            ];
            /** @nocollapse */
            RouterLinkActive.ctorParameters = function () { return [
                { type: Router },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Renderer2"] },
                { type: RouterLink, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] },
                { type: RouterLinkWithHref, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] }
            ]; };
            RouterLinkActive.propDecorators = {
                links: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChildren"], args: [RouterLink, { descendants: true },] }],
                linksWithHrefs: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChildren"], args: [RouterLinkWithHref, { descendants: true },] }],
                routerLinkActiveOptions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }],
                routerLinkActive: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /**
             * Store contextual information about a `RouterOutlet`
             *
             * \@publicApi
             */
            var OutletContext = /** @class */ (function () {
                function OutletContext() {
                    this.outlet = null;
                    this.route = null;
                    this.resolver = null;
                    this.children = new ChildrenOutletContexts();
                    this.attachRef = null;
                }
                return OutletContext;
            }());
            if (false) { }
            /**
             * Store contextual information about the children (= nested) `RouterOutlet`
             *
             * \@publicApi
             */
            var ChildrenOutletContexts = /** @class */ (function () {
                function ChildrenOutletContexts() {
                    // contexts for child outlets, by name.
                    this.contexts = new Map();
                }
                /**
                 * Called when a `RouterOutlet` directive is instantiated
                 * @param {?} childName
                 * @param {?} outlet
                 * @return {?}
                 */
                ChildrenOutletContexts.prototype.onChildOutletCreated = function (childName, outlet) {
                    /** @type {?} */
                    var context = this.getOrCreateContext(childName);
                    context.outlet = outlet;
                    this.contexts.set(childName, context);
                };
                /**
                 * Called when a `RouterOutlet` directive is destroyed.
                 * We need to keep the context as the outlet could be destroyed inside a NgIf and might be
                 * re-created later.
                 * @param {?} childName
                 * @return {?}
                 */
                ChildrenOutletContexts.prototype.onChildOutletDestroyed = function (childName) {
                    /** @type {?} */
                    var context = this.getContext(childName);
                    if (context) {
                        context.outlet = null;
                    }
                };
                /**
                 * Called when the corresponding route is deactivated during navigation.
                 * Because the component get destroyed, all children outlet are destroyed.
                 * @return {?}
                 */
                ChildrenOutletContexts.prototype.onOutletDeactivated = function () {
                    /** @type {?} */
                    var contexts = this.contexts;
                    this.contexts = new Map();
                    return contexts;
                };
                /**
                 * @param {?} contexts
                 * @return {?}
                 */
                ChildrenOutletContexts.prototype.onOutletReAttached = function (contexts) { this.contexts = contexts; };
                /**
                 * @param {?} childName
                 * @return {?}
                 */
                ChildrenOutletContexts.prototype.getOrCreateContext = function (childName) {
                    /** @type {?} */
                    var context = this.getContext(childName);
                    if (!context) {
                        context = new OutletContext();
                        this.contexts.set(childName, context);
                    }
                    return context;
                };
                /**
                 * @param {?} childName
                 * @return {?}
                 */
                ChildrenOutletContexts.prototype.getContext = function (childName) { return this.contexts.get(childName) || null; };
                return ChildrenOutletContexts;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             *
             * Acts as a placeholder that Angular dynamically fills based on the current router state.
             *
             * Each outlet can have a unique name, determined by the optional `name` attribute.
             * The name cannot be set or changed dynamically. If not set, default value is "primary".
             *
             * ```
             * <router-outlet></router-outlet>
             * <router-outlet name='left'></router-outlet>
             * <router-outlet name='right'></router-outlet>
             * ```
             *
             * A router outlet emits an activate event when a new component is instantiated,
             * and a deactivate event when a component is destroyed.
             *
             * ```
             * <router-outlet
             *   (activate)='onActivate($event)'
             *   (deactivate)='onDeactivate($event)'></router-outlet>
             * ```
             * \@ngModule RouterModule
             *
             * \@publicApi
             */
            var RouterOutlet = /** @class */ (function () {
                /**
                 * @param {?} parentContexts
                 * @param {?} location
                 * @param {?} resolver
                 * @param {?} name
                 * @param {?} changeDetector
                 */
                function RouterOutlet(parentContexts, location, resolver, name, changeDetector) {
                    this.parentContexts = parentContexts;
                    this.location = location;
                    this.resolver = resolver;
                    this.changeDetector = changeDetector;
                    this.activated = null;
                    this._activatedRoute = null;
                    this.activateEvents = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    this.deactivateEvents = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
                    this.name = name || PRIMARY_OUTLET;
                    parentContexts.onChildOutletCreated(this.name, this);
                }
                /**
                 * @return {?}
                 */
                RouterOutlet.prototype.ngOnDestroy = function () { this.parentContexts.onChildOutletDestroyed(this.name); };
                /**
                 * @return {?}
                 */
                RouterOutlet.prototype.ngOnInit = function () {
                    if (!this.activated) {
                        // If the outlet was not instantiated at the time the route got activated we need to populate
                        // the outlet when it is initialized (ie inside a NgIf)
                        /** @type {?} */
                        var context = this.parentContexts.getContext(this.name);
                        if (context && context.route) {
                            if (context.attachRef) {
                                // `attachRef` is populated when there is an existing component to mount
                                this.attach(context.attachRef, context.route);
                            }
                            else {
                                // otherwise the component defined in the configuration is created
                                this.activateWith(context.route, context.resolver || null);
                            }
                        }
                    }
                };
                Object.defineProperty(RouterOutlet.prototype, "isActivated", {
                    /**
                     * @return {?}
                     */
                    get: function () { return !!this.activated; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(RouterOutlet.prototype, "component", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (!this.activated)
                            throw new Error('Outlet is not activated');
                        return this.activated.instance;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (!this.activated)
                            throw new Error('Outlet is not activated');
                        return ( /** @type {?} */(this._activatedRoute));
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(RouterOutlet.prototype, "activatedRouteData", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        if (this._activatedRoute) {
                            return this._activatedRoute.snapshot.data;
                        }
                        return {};
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * Called when the `RouteReuseStrategy` instructs to detach the subtree
                 * @return {?}
                 */
                RouterOutlet.prototype.detach = function () {
                    if (!this.activated)
                        throw new Error('Outlet is not activated');
                    this.location.detach();
                    /** @type {?} */
                    var cmp = this.activated;
                    this.activated = null;
                    this._activatedRoute = null;
                    return cmp;
                };
                /**
                 * Called when the `RouteReuseStrategy` instructs to re-attach a previously detached subtree
                 * @param {?} ref
                 * @param {?} activatedRoute
                 * @return {?}
                 */
                RouterOutlet.prototype.attach = function (ref, activatedRoute) {
                    this.activated = ref;
                    this._activatedRoute = activatedRoute;
                    this.location.insert(ref.hostView);
                };
                /**
                 * @return {?}
                 */
                RouterOutlet.prototype.deactivate = function () {
                    if (this.activated) {
                        /** @type {?} */
                        var c = this.component;
                        this.activated.destroy();
                        this.activated = null;
                        this._activatedRoute = null;
                        this.deactivateEvents.emit(c);
                    }
                };
                /**
                 * @param {?} activatedRoute
                 * @param {?} resolver
                 * @return {?}
                 */
                RouterOutlet.prototype.activateWith = function (activatedRoute, resolver) {
                    if (this.isActivated) {
                        throw new Error('Cannot activate an already activated outlet');
                    }
                    this._activatedRoute = activatedRoute;
                    /** @type {?} */
                    var snapshot = activatedRoute._futureSnapshot;
                    /** @type {?} */
                    var component = ( /** @type {?} */(( /** @type {?} */(snapshot.routeConfig)).component));
                    resolver = resolver || this.resolver;
                    /** @type {?} */
                    var factory = resolver.resolveComponentFactory(component);
                    /** @type {?} */
                    var childContexts = this.parentContexts.getOrCreateContext(this.name).children;
                    /** @type {?} */
                    var injector = new OutletInjector(activatedRoute, childContexts, this.location.injector);
                    this.activated = this.location.createComponent(factory, this.location.length, injector);
                    // Calling `markForCheck` to make sure we will run the change detection when the
                    // `RouterOutlet` is inside a `ChangeDetectionStrategy.OnPush` component.
                    this.changeDetector.markForCheck();
                    this.activateEvents.emit(this.activated.instance);
                };
                return RouterOutlet;
            }());
            RouterOutlet.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"], args: [{ selector: 'router-outlet', exportAs: 'outlet' },] }
            ];
            /** @nocollapse */
            RouterOutlet.ctorParameters = function () { return [
                { type: ChildrenOutletContexts },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactoryResolver"] },
                { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Attribute"], args: ['name',] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] }
            ]; };
            RouterOutlet.propDecorators = {
                activateEvents: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['activate',] }],
                deactivateEvents: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['deactivate',] }]
            };
            if (false) { }
            var OutletInjector = /** @class */ (function () {
                /**
                 * @param {?} route
                 * @param {?} childContexts
                 * @param {?} parent
                 */
                function OutletInjector(route, childContexts, parent) {
                    this.route = route;
                    this.childContexts = childContexts;
                    this.parent = parent;
                }
                /**
                 * @param {?} token
                 * @param {?=} notFoundValue
                 * @return {?}
                 */
                OutletInjector.prototype.get = function (token, notFoundValue) {
                    if (token === ActivatedRoute) {
                        return this.route;
                    }
                    if (token === ChildrenOutletContexts) {
                        return this.childContexts;
                    }
                    return this.parent.get(token, notFoundValue);
                };
                return OutletInjector;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@description
             *
             * Provides a preloading strategy.
             *
             * \@publicApi
             * @abstract
             */
            var PreloadingStrategy = /** @class */ (function () {
                function PreloadingStrategy() {
                }
                return PreloadingStrategy;
            }());
            if (false) { }
            /**
             * \@description
             *
             * Provides a preloading strategy that preloads all modules as quickly as possible.
             *
             * ```
             * RouteModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules})
             * ```
             *
             * \@publicApi
             */
            var PreloadAllModules = /** @class */ (function () {
                function PreloadAllModules() {
                }
                /**
                 * @param {?} route
                 * @param {?} fn
                 * @return {?}
                 */
                PreloadAllModules.prototype.preload = function (route, fn) {
                    return fn().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(( /**
                     * @return {?}
                     */function () { return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null); })));
                };
                return PreloadAllModules;
            }());
            /**
             * \@description
             *
             * Provides a preloading strategy that does not preload any modules.
             *
             * This strategy is enabled by default.
             *
             * \@publicApi
             */
            var NoPreloading = /** @class */ (function () {
                function NoPreloading() {
                }
                /**
                 * @param {?} route
                 * @param {?} fn
                 * @return {?}
                 */
                NoPreloading.prototype.preload = function (route, fn) { return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null); };
                return NoPreloading;
            }());
            /**
             * The preloader optimistically loads all router configurations to
             * make navigations into lazily-loaded sections of the application faster.
             *
             * The preloader runs in the background. When the router bootstraps, the preloader
             * starts listening to all navigation events. After every such event, the preloader
             * will check if any configurations can be loaded lazily.
             *
             * If a route is protected by `canLoad` guards, the preloaded will not load it.
             *
             * \@publicApi
             */
            var RouterPreloader = /** @class */ (function () {
                /**
                 * @param {?} router
                 * @param {?} moduleLoader
                 * @param {?} compiler
                 * @param {?} injector
                 * @param {?} preloadingStrategy
                 */
                function RouterPreloader(router, moduleLoader, compiler, injector, preloadingStrategy) {
                    this.router = router;
                    this.injector = injector;
                    this.preloadingStrategy = preloadingStrategy;
                    /** @type {?} */
                    var onStartLoad = ( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) { return router.triggerEvent(new RouteConfigLoadStart(r)); });
                    /** @type {?} */
                    var onEndLoad = ( /**
                     * @param {?} r
                     * @return {?}
                     */function (r) { return router.triggerEvent(new RouteConfigLoadEnd(r)); });
                    this.loader = new RouterConfigLoader(moduleLoader, compiler, onStartLoad, onEndLoad);
                }
                /**
                 * @return {?}
                 */
                RouterPreloader.prototype.setUpPreloading = function () {
                    var _this = this;
                    this.subscription =
                        this.router.events
                            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(( /**
                     * @param {?} e
                     * @return {?}
                     */function (e) { return e instanceof NavigationEnd; })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["concatMap"])(( /**
                         * @return {?}
                         */function () { return _this.preload(); })))
                            .subscribe(( /**
                     * @return {?}
                     */function () { }));
                };
                /**
                 * @return {?}
                 */
                RouterPreloader.prototype.preload = function () {
                    /** @type {?} */
                    var ngModule = this.injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleRef"]);
                    return this.processRoutes(ngModule, this.router.config);
                };
                // TODO(jasonaden): This class relies on code external to the class to call setUpPreloading. If
                // this hasn't been done, ngOnDestroy will fail as this.subscription will be undefined. This
                // should be refactored.
                /**
                 * @return {?}
                 */
                RouterPreloader.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} routes
                 * @return {?}
                 */
                RouterPreloader.prototype.processRoutes = function (ngModule, routes) {
                    /** @type {?} */
                    var res = [];
                    for (var _c = 0, routes_6 = routes; _c < routes_6.length; _c++) {
                        var route = routes_6[_c];
                        // we already have the config loaded, just recurse
                        if (route.loadChildren && !route.canLoad && route._loadedConfig) {
                            /** @type {?} */
                            var childConfig = route._loadedConfig;
                            res.push(this.processRoutes(childConfig.module, childConfig.routes));
                            // no config loaded, fetch the config
                        }
                        else if (route.loadChildren && !route.canLoad) {
                            res.push(this.preloadConfig(ngModule, route));
                            // recurse into children
                        }
                        else if (route.children) {
                            res.push(this.processRoutes(ngModule, route.children));
                        }
                    }
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(res).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeAll"])(), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(( /**
                     * @param {?} _
                     * @return {?}
                     */function (_) { return void 0; })));
                };
                /**
                 * @private
                 * @param {?} ngModule
                 * @param {?} route
                 * @return {?}
                 */
                RouterPreloader.prototype.preloadConfig = function (ngModule, route) {
                    var _this = this;
                    return this.preloadingStrategy.preload(route, ( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var loaded$ = _this.loader.load(ngModule.injector, route);
                        return loaded$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(( /**
                         * @param {?} config
                         * @return {?}
                         */function (config) {
                            route._loadedConfig = config;
                            return _this.processRoutes(config.module, config.routes);
                        })));
                    }));
                };
                return RouterPreloader;
            }());
            RouterPreloader.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            RouterPreloader.ctorParameters = function () { return [
                { type: Router },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleFactoryLoader"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Compiler"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] },
                { type: PreloadingStrategy }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var RouterScroller = /** @class */ (function () {
                /**
                 * @param {?} router
                 * @param {?} viewportScroller
                 * @param {?=} options
                 */
                function RouterScroller(router, viewportScroller, options) {
                    if (options === void 0) { options = {}; }
                    this.router = router;
                    this.viewportScroller = viewportScroller;
                    this.options = options;
                    this.lastId = 0;
                    this.lastSource = 'imperative';
                    this.restoredId = 0;
                    this.store = {};
                    // Default both options to 'disabled'
                    options.scrollPositionRestoration = options.scrollPositionRestoration || 'disabled';
                    options.anchorScrolling = options.anchorScrolling || 'disabled';
                }
                /**
                 * @return {?}
                 */
                RouterScroller.prototype.init = function () {
                    // we want to disable the automatic scrolling because having two places
                    // responsible for scrolling results race conditions, especially given
                    // that browser don't implement this behavior consistently
                    if (this.options.scrollPositionRestoration !== 'disabled') {
                        this.viewportScroller.setHistoryScrollRestoration('manual');
                    }
                    this.routerEventsSubscription = this.createScrollEvents();
                    this.scrollEventsSubscription = this.consumeScrollEvents();
                };
                /**
                 * @private
                 * @return {?}
                 */
                RouterScroller.prototype.createScrollEvents = function () {
                    var _this = this;
                    return this.router.events.subscribe(( /**
                     * @param {?} e
                     * @return {?}
                     */function (/**
                     * @param {?} e
                     * @return {?}
                     */ e) {
                        if (e instanceof NavigationStart) {
                            // store the scroll position of the current stable navigations.
                            _this.store[_this.lastId] = _this.viewportScroller.getScrollPosition();
                            _this.lastSource = e.navigationTrigger;
                            _this.restoredId = e.restoredState ? e.restoredState.navigationId : 0;
                        }
                        else if (e instanceof NavigationEnd) {
                            _this.lastId = e.id;
                            _this.scheduleScrollEvent(e, _this.router.parseUrl(e.urlAfterRedirects).fragment);
                        }
                    }));
                };
                /**
                 * @private
                 * @return {?}
                 */
                RouterScroller.prototype.consumeScrollEvents = function () {
                    var _this = this;
                    return this.router.events.subscribe(( /**
                     * @param {?} e
                     * @return {?}
                     */function (/**
                     * @param {?} e
                     * @return {?}
                     */ e) {
                        if (!(e instanceof Scroll))
                            return;
                        // a popstate event. The pop state event will always ignore anchor scrolling.
                        if (e.position) {
                            if (_this.options.scrollPositionRestoration === 'top') {
                                _this.viewportScroller.scrollToPosition([0, 0]);
                            }
                            else if (_this.options.scrollPositionRestoration === 'enabled') {
                                _this.viewportScroller.scrollToPosition(e.position);
                            }
                            // imperative navigation "forward"
                        }
                        else {
                            if (e.anchor && _this.options.anchorScrolling === 'enabled') {
                                _this.viewportScroller.scrollToAnchor(e.anchor);
                            }
                            else if (_this.options.scrollPositionRestoration !== 'disabled') {
                                _this.viewportScroller.scrollToPosition([0, 0]);
                            }
                        }
                    }));
                };
                /**
                 * @private
                 * @param {?} routerEvent
                 * @param {?} anchor
                 * @return {?}
                 */
                RouterScroller.prototype.scheduleScrollEvent = function (routerEvent, anchor) {
                    this.router.triggerEvent(new Scroll(routerEvent, this.lastSource === 'popstate' ? this.store[this.restoredId] : null, anchor));
                };
                /**
                 * @return {?}
                 */
                RouterScroller.prototype.ngOnDestroy = function () {
                    if (this.routerEventsSubscription) {
                        this.routerEventsSubscription.unsubscribe();
                    }
                    if (this.scrollEventsSubscription) {
                        this.scrollEventsSubscription.unsubscribe();
                    }
                };
                return RouterScroller;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * The directives defined in the `RouterModule`.
             * @type {?}
             */
            var ROUTER_DIRECTIVES = [RouterOutlet, RouterLink, RouterLinkWithHref, RouterLinkActive, ɵEmptyOutletComponent];
            /**
             * A [DI token](guide/glossary/#di-token) for the router service.
             *
             * \@publicApi
             * @type {?}
             */
            var ROUTER_CONFIGURATION = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('ROUTER_CONFIGURATION');
            /**
             * \@docsNotRequired
             * @type {?}
             */
            var ROUTER_FORROOT_GUARD = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('ROUTER_FORROOT_GUARD');
            var ɵ0 = { enableTracing: false };
            /** @type {?} */
            var ROUTER_PROVIDERS = [
                _angular_common__WEBPACK_IMPORTED_MODULE_0__["Location"],
                { provide: UrlSerializer, useClass: DefaultUrlSerializer },
                {
                    provide: Router,
                    useFactory: setupRouter,
                    deps: [
                        _angular_core__WEBPACK_IMPORTED_MODULE_1__["ApplicationRef"], UrlSerializer, ChildrenOutletContexts, _angular_common__WEBPACK_IMPORTED_MODULE_0__["Location"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"],
                        _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleFactoryLoader"], _angular_core__WEBPACK_IMPORTED_MODULE_1__["Compiler"], ROUTES, ROUTER_CONFIGURATION,
                        [UrlHandlingStrategy, new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"]()], [RouteReuseStrategy, new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"]()]
                    ]
                },
                ChildrenOutletContexts,
                { provide: ActivatedRoute, useFactory: rootRoute, deps: [Router] },
                { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModuleFactoryLoader"], useClass: _angular_core__WEBPACK_IMPORTED_MODULE_1__["SystemJsNgModuleLoader"] },
                RouterPreloader,
                NoPreloading,
                PreloadAllModules,
                { provide: ROUTER_CONFIGURATION, useValue: ɵ0 },
            ];
            /**
             * @return {?}
             */
            function routerNgProbeToken() {
                return new _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgProbeToken"]('Router', Router);
            }
            /**
             * \@usageNotes
             *
             * RouterModule can be imported multiple times: once per lazily-loaded bundle.
             * Since the router deals with a global shared resource--location, we cannot have
             * more than one router service active.
             *
             * That is why there are two ways to create the module: `RouterModule.forRoot` and
             * `RouterModule.forChild`.
             *
             * * `forRoot` creates a module that contains all the directives, the given routes, and the router
             *   service itself.
             * * `forChild` creates a module that contains all the directives and the given routes, but does not
             *   include the router service.
             *
             * When registered at the root, the module should be used as follows
             *
             * ```
             * \@NgModule({
             *   imports: [RouterModule.forRoot(ROUTES)]
             * })
             * class MyNgModule {}
             * ```
             *
             * For submodules and lazy loaded submodules the module should be used as follows:
             *
             * ```
             * \@NgModule({
             *   imports: [RouterModule.forChild(ROUTES)]
             * })
             * class MyNgModule {}
             * ```
             *
             * \@description
             *
             * Adds router directives and providers.
             *
             * Managing state transitions is one of the hardest parts of building applications. This is
             * especially true on the web, where you also need to ensure that the state is reflected in the URL.
             * In addition, we often want to split applications into multiple bundles and load them on demand.
             * Doing this transparently is not trivial.
             *
             * The Angular router service solves these problems. Using the router, you can declaratively specify
             * application states, manage state transitions while taking care of the URL, and load bundles on
             * demand.
             *
             * @see [Routing and Navigation](guide/router.html) for an
             * overview of how the router service should be used.
             *
             * \@publicApi
             */
            var RouterModule = /** @class */ (function () {
                // Note: We are injecting the Router so it gets created eagerly...
                /**
                 * @param {?} guard
                 * @param {?} router
                 */
                function RouterModule(guard, router) {
                }
                /**
                 * Creates and configures a module with all the router providers and directives.
                 * Optionally sets up an application listener to perform an initial navigation.
                 *
                 * @param {?} routes An array of `Route` objects that define the navigation paths for the application.
                 * @param {?=} config An `ExtraOptions` configuration object that controls how navigation is performed.
                 * @return {?} The new router module.
                 */
                RouterModule.forRoot = function (routes, config) {
                    return {
                        ngModule: RouterModule,
                        providers: [
                            ROUTER_PROVIDERS,
                            provideRoutes(routes),
                            {
                                provide: ROUTER_FORROOT_GUARD,
                                useFactory: provideForRootGuard,
                                deps: [[Router, new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"](), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["SkipSelf"]()]]
                            },
                            { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} },
                            {
                                provide: _angular_common__WEBPACK_IMPORTED_MODULE_0__["LocationStrategy"],
                                useFactory: provideLocationStrategy,
                                deps: [
                                    _angular_common__WEBPACK_IMPORTED_MODULE_0__["PlatformLocation"], [new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"](_angular_common__WEBPACK_IMPORTED_MODULE_0__["APP_BASE_HREF"]), new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"]()], ROUTER_CONFIGURATION
                                ]
                            },
                            {
                                provide: RouterScroller,
                                useFactory: createRouterScroller,
                                deps: [Router, _angular_common__WEBPACK_IMPORTED_MODULE_0__["ViewportScroller"], ROUTER_CONFIGURATION]
                            },
                            {
                                provide: PreloadingStrategy,
                                useExisting: config && config.preloadingStrategy ? config.preloadingStrategy :
                                    NoPreloading
                            },
                            { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgProbeToken"], multi: true, useFactory: routerNgProbeToken },
                            provideRouterInitializer(),
                        ],
                    };
                };
                /**
                 * Creates a module with all the router directives and a provider registering routes.
                 * @param {?} routes
                 * @return {?}
                 */
                RouterModule.forChild = function (routes) {
                    return { ngModule: RouterModule, providers: [provideRoutes(routes)] };
                };
                return RouterModule;
            }());
            RouterModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                            declarations: ROUTER_DIRECTIVES,
                            exports: ROUTER_DIRECTIVES,
                            entryComponents: [ɵEmptyOutletComponent]
                        },] }
            ];
            /** @nocollapse */
            RouterModule.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [ROUTER_FORROOT_GUARD,] }] },
                { type: Router, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Optional"] }] }
            ]; };
            /**
             * @param {?} router
             * @param {?} viewportScroller
             * @param {?} config
             * @return {?}
             */
            function createRouterScroller(router, viewportScroller, config) {
                if (config.scrollOffset) {
                    viewportScroller.setOffset(config.scrollOffset);
                }
                return new RouterScroller(router, viewportScroller, config);
            }
            /**
             * @param {?} platformLocationStrategy
             * @param {?} baseHref
             * @param {?=} options
             * @return {?}
             */
            function provideLocationStrategy(platformLocationStrategy, baseHref, options) {
                if (options === void 0) { options = {}; }
                return options.useHash ? new _angular_common__WEBPACK_IMPORTED_MODULE_0__["HashLocationStrategy"](platformLocationStrategy, baseHref) :
                    new _angular_common__WEBPACK_IMPORTED_MODULE_0__["PathLocationStrategy"](platformLocationStrategy, baseHref);
            }
            /**
             * @param {?} router
             * @return {?}
             */
            function provideForRootGuard(router) {
                if (router) {
                    throw new Error("RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead.");
                }
                return 'guarded';
            }
            /**
             * Registers a [DI provider](guide/glossary#provider) for a set of routes.
             * \@usageNotes
             *
             * ```
             * \@NgModule({
             *   imports: [RouterModule.forChild(ROUTES)],
             *   providers: [provideRoutes(EXTRA_ROUTES)]
             * })
             * class MyNgModule {}
             * ```
             *
             * \@publicApi
             * @param {?} routes The route configuration to provide.
             *
             * @return {?}
             */
            function provideRoutes(routes) {
                return [
                    { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ANALYZE_FOR_ENTRY_COMPONENTS"], multi: true, useValue: routes },
                    { provide: ROUTES, multi: true, useValue: routes },
                ];
            }
            /**
             * A set of configuration options for a router module, provided in the
             * `forRoot()` method.
             *
             * \@publicApi
             * @record
             */
            function ExtraOptions() { }
            if (false) { }
            /**
             * @param {?} ref
             * @param {?} urlSerializer
             * @param {?} contexts
             * @param {?} location
             * @param {?} injector
             * @param {?} loader
             * @param {?} compiler
             * @param {?} config
             * @param {?=} opts
             * @param {?=} urlHandlingStrategy
             * @param {?=} routeReuseStrategy
             * @return {?}
             */
            function setupRouter(ref, urlSerializer, contexts, location, injector, loader, compiler, config, opts, urlHandlingStrategy, routeReuseStrategy) {
                if (opts === void 0) { opts = {}; }
                /** @type {?} */
                var router = new Router(null, urlSerializer, contexts, location, injector, loader, compiler, flatten(config));
                if (urlHandlingStrategy) {
                    router.urlHandlingStrategy = urlHandlingStrategy;
                }
                if (routeReuseStrategy) {
                    router.routeReuseStrategy = routeReuseStrategy;
                }
                if (opts.errorHandler) {
                    router.errorHandler = opts.errorHandler;
                }
                if (opts.malformedUriErrorHandler) {
                    router.malformedUriErrorHandler = opts.malformedUriErrorHandler;
                }
                if (opts.enableTracing) {
                    /** @type {?} */
                    var dom_1 = Object(_angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["ɵgetDOM"])();
                    router.events.subscribe(( /**
                     * @param {?} e
                     * @return {?}
                     */function (e) {
                        dom_1.logGroup("Router Event: " + (( /** @type {?} */(e.constructor))).name);
                        dom_1.log(e.toString());
                        dom_1.log(e);
                        dom_1.logGroupEnd();
                    }));
                }
                if (opts.onSameUrlNavigation) {
                    router.onSameUrlNavigation = opts.onSameUrlNavigation;
                }
                if (opts.paramsInheritanceStrategy) {
                    router.paramsInheritanceStrategy = opts.paramsInheritanceStrategy;
                }
                if (opts.urlUpdateStrategy) {
                    router.urlUpdateStrategy = opts.urlUpdateStrategy;
                }
                if (opts.relativeLinkResolution) {
                    router.relativeLinkResolution = opts.relativeLinkResolution;
                }
                return router;
            }
            /**
             * @param {?} router
             * @return {?}
             */
            function rootRoute(router) {
                return router.routerState.root;
            }
            /**
             * Router initialization requires two steps:
             *
             * First, we start the navigation in a `APP_INITIALIZER` to block the bootstrap if
             * a resolver or a guard executes asynchronously.
             *
             * Next, we actually run activation in a `BOOTSTRAP_LISTENER`, using the
             * `afterPreactivation` hook provided by the router.
             * The router navigation starts, reaches the point when preactivation is done, and then
             * pauses. It waits for the hook to be resolved. We then resolve it only in a bootstrap listener.
             */
            var RouterInitializer = /** @class */ (function () {
                /**
                 * @param {?} injector
                 */
                function RouterInitializer(injector) {
                    this.injector = injector;
                    this.initNavigation = false;
                    this.resultOfPreactivationDone = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
                }
                /**
                 * @return {?}
                 */
                RouterInitializer.prototype.appInitializer = function () {
                    var _this = this;
                    /** @type {?} */
                    var p = this.injector.get(_angular_common__WEBPACK_IMPORTED_MODULE_0__["LOCATION_INITIALIZED"], Promise.resolve(null));
                    return p.then(( /**
                     * @return {?}
                     */function () {
                        /** @type {?} */
                        var resolve = ( /** @type {?} */(null));
                        /** @type {?} */
                        var res = new Promise(( /**
                         * @param {?} r
                         * @return {?}
                         */function (/**
                         * @param {?} r
                         * @return {?}
                         */ r) { return resolve = r; }));
                        /** @type {?} */
                        var router = _this.injector.get(Router);
                        /** @type {?} */
                        var opts = _this.injector.get(ROUTER_CONFIGURATION);
                        if (_this.isLegacyDisabled(opts) || _this.isLegacyEnabled(opts)) {
                            resolve(true);
                        }
                        else if (opts.initialNavigation === 'disabled') {
                            router.setUpLocationChangeListener();
                            resolve(true);
                        }
                        else if (opts.initialNavigation === 'enabled') {
                            router.hooks.afterPreactivation = ( /**
                             * @return {?}
                             */function () {
                                // only the initial navigation should be delayed
                                if (!_this.initNavigation) {
                                    _this.initNavigation = true;
                                    resolve(true);
                                    return _this.resultOfPreactivationDone;
                                    // subsequent navigations should not be delayed
                                }
                                else {
                                    return ( /** @type {?} */(Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null)));
                                }
                            });
                            router.initialNavigation();
                        }
                        else {
                            throw new Error("Invalid initialNavigation options: '" + opts.initialNavigation + "'");
                        }
                        return res;
                    }));
                };
                /**
                 * @param {?} bootstrappedComponentRef
                 * @return {?}
                 */
                RouterInitializer.prototype.bootstrapListener = function (bootstrappedComponentRef) {
                    /** @type {?} */
                    var opts = this.injector.get(ROUTER_CONFIGURATION);
                    /** @type {?} */
                    var preloader = this.injector.get(RouterPreloader);
                    /** @type {?} */
                    var routerScroller = this.injector.get(RouterScroller);
                    /** @type {?} */
                    var router = this.injector.get(Router);
                    /** @type {?} */
                    var ref = this.injector.get(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ApplicationRef"]);
                    if (bootstrappedComponentRef !== ref.components[0]) {
                        return;
                    }
                    if (this.isLegacyEnabled(opts)) {
                        router.initialNavigation();
                    }
                    else if (this.isLegacyDisabled(opts)) {
                        router.setUpLocationChangeListener();
                    }
                    preloader.setUpPreloading();
                    routerScroller.init();
                    router.resetRootComponentType(ref.componentTypes[0]);
                    this.resultOfPreactivationDone.next(( /** @type {?} */(null)));
                    this.resultOfPreactivationDone.complete();
                };
                /**
                 * @private
                 * @param {?} opts
                 * @return {?}
                 */
                RouterInitializer.prototype.isLegacyEnabled = function (opts) {
                    return opts.initialNavigation === 'legacy_enabled' || opts.initialNavigation === true ||
                        opts.initialNavigation === undefined;
                };
                /**
                 * @private
                 * @param {?} opts
                 * @return {?}
                 */
                RouterInitializer.prototype.isLegacyDisabled = function (opts) {
                    return opts.initialNavigation === 'legacy_disabled' || opts.initialNavigation === false;
                };
                return RouterInitializer;
            }());
            RouterInitializer.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"] }
            ];
            /** @nocollapse */
            RouterInitializer.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] }
            ]; };
            if (false) { }
            /**
             * @param {?} r
             * @return {?}
             */
            function getAppInitializer(r) {
                return r.appInitializer.bind(r);
            }
            /**
             * @param {?} r
             * @return {?}
             */
            function getBootstrapListener(r) {
                return r.bootstrapListener.bind(r);
            }
            /**
             * A [DI token](guide/glossary/#di-token) for the router initializer that
             * is called after the app is bootstrapped.
             *
             * \@publicApi
             * @type {?}
             */
            var ROUTER_INITIALIZER = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('Router Initializer');
            /**
             * @return {?}
             */
            function provideRouterInitializer() {
                return [
                    RouterInitializer,
                    {
                        provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_INITIALIZER"],
                        multi: true,
                        useFactory: getAppInitializer,
                        deps: [RouterInitializer]
                    },
                    { provide: ROUTER_INITIALIZER, useFactory: getBootstrapListener, deps: [RouterInitializer] },
                    { provide: _angular_core__WEBPACK_IMPORTED_MODULE_1__["APP_BOOTSTRAP_LISTENER"], multi: true, useExisting: ROUTER_INITIALIZER },
                ];
            }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * \@publicApi
             * @type {?}
             */
            var VERSION = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["Version"]('8.2.13');
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Generated bundle index. Do not edit.
             */
            //# sourceMappingURL=router.js.map
            /***/ 
        }),
        /***/ "./node_modules/@nt-tech/nt-core/fesm2015/nt-tech-nt-core.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/@nt-tech/nt-core/fesm2015/nt-tech-nt-core.js ***!
          \*******************************************************************/
        /*! exports provided: ColumnsNamePipe, MonthEnum, NotificationIconPipe, NotificationNamePipe, NtCoreModule, NtImageProfileComponent, NtNotificationComponent, NtPaginatorComponent, NtRightClickMenuComponent, NtRightClickMenuDirective, NtSidebarInfo90Component, NtSidebarLargeComponent, NtSidebarProfileComponent, NtSidebarSmallComponent, NtSwitcherComponent, NtTableDisplayComponent, NtToolbarComponent, NtTooltipComponent, NtTooltipDirective, NtTranslatePipe, NtTranslateService, Shift, Time, WeekEnum, isAfter, isBefore, isDateInRange, lineHeight, ntEndOfWeek, ntGetDay, ntGetWeek, ntStartOfWeek, padding, ɵa, ɵc, ɵd */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnsNamePipe", function () { return ColumnsNamePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MonthEnum", function () { return MonthEnum; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationIconPipe", function () { return NotificationIconPipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationNamePipe", function () { return NotificationNamePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtCoreModule", function () { return NtCoreModule; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtImageProfileComponent", function () { return NtImageProfileComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtNotificationComponent", function () { return NtNotificationComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtPaginatorComponent", function () { return NtPaginatorComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtRightClickMenuComponent", function () { return NtRightClickMenuComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtRightClickMenuDirective", function () { return NtRightClickMenuDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtSidebarInfo90Component", function () { return NtSidebarInfo90Component; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtSidebarLargeComponent", function () { return NtSidebarLargeComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtSidebarProfileComponent", function () { return NtSidebarProfileComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtSidebarSmallComponent", function () { return NtSidebarSmallComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtSwitcherComponent", function () { return NtSwitcherComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtTableDisplayComponent", function () { return NtTableDisplayComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtToolbarComponent", function () { return NtToolbarComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtTooltipComponent", function () { return NtTooltipComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtTooltipDirective", function () { return NtTooltipDirective; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtTranslatePipe", function () { return NtTranslatePipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NtTranslateService", function () { return NtTranslateService; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Shift", function () { return Shift; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Time", function () { return Time; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeekEnum", function () { return WeekEnum; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAfter", function () { return isAfter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBefore", function () { return isBefore; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDateInRange", function () { return isDateInRange; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineHeight", function () { return lineHeight; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ntEndOfWeek", function () { return ntEndOfWeek; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ntGetDay", function () { return ntGetDay; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ntGetWeek", function () { return ntGetWeek; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ntStartOfWeek", function () { return ntStartOfWeek; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "padding", function () { return padding; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function () { return NtCenterTextComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function () { return NtChangeWorkspaceComponent; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function () { return CustomEventManager; });
            /* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
            /* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
            /* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
            /* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/tooltip */ "./node_modules/@angular/material/esm2015/tooltip.js");
            /* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/select */ "./node_modules/@angular/material/esm2015/select.js");
            /* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
            /* harmony import */ var _angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/cdk/drag-drop */ "./node_modules/@angular/cdk/esm2015/drag-drop.js");
            /* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
            /* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
            /* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
            /* harmony import */ var _angular_material_menu__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/menu */ "./node_modules/@angular/material/esm2015/menu.js");
            /* harmony import */ var _angular_material_badge__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/badge */ "./node_modules/@angular/material/esm2015/badge.js");
            /* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
            /* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
            /* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! date-fns */ "./node_modules/date-fns/esm/index.js");
            /* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
            /* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var ColumnsNamePipe = /** @class */ (function () {
                function ColumnsNamePipe() {
                }
                /**
                 * @param {?} value
                 * @return {?}
                 */
                ColumnsNamePipe.prototype.transform = function (value) {
                    switch (value) {
                        case 'select':
                            return 'Selection';
                        case 'date':
                            return 'Date';
                        case 'interventionNumber':
                            return 'N° intervention';
                        case 'technician':
                            return 'Technicien';
                        case 'affairRef':
                            return 'Réf. affaire';
                        case 'client':
                            return 'Client';
                        case 'site':
                            return 'Site';
                        case 'equipment':
                            return 'Équipement';
                        case 'nature':
                            return 'Nature';
                        case 'category':
                            return 'Catégorie';
                        case 'container':
                            return 'Contenant';
                        case 'abc':
                            return 'A+B+C';
                        case 'a':
                            return 'A';
                        case 'b':
                            return 'B';
                        case 'c':
                            return 'C';
                        case 'de':
                            return 'D+E';
                        case 'd':
                            return 'D';
                        case 'e':
                            return 'E';
                        case 'validated':
                            return 'Validation';
                        case 'pdf':
                            return 'Exporter en PDF';
                        default:
                            return value;
                    }
                };
                return ColumnsNamePipe;
            }());
            ColumnsNamePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{
                            name: 'columnsName',
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NotificationIconPipe = /** @class */ (function () {
                function NotificationIconPipe() {
                }
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NotificationIconPipe.prototype.transform = function (value) {
                    switch (value) {
                        case 'ArchiveCreated':
                            return 'package-down';
                        case 'ExcelCreated':
                            return 'file-excel';
                        case 'PDFsCreated':
                            return 'file-pdf';
                        default:
                            return value;
                    }
                };
                return NotificationIconPipe;
            }());
            NotificationIconPipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{
                            name: 'notificationIcon',
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NotificationNamePipe = /** @class */ (function () {
                function NotificationNamePipe() {
                }
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NotificationNamePipe.prototype.transform = function (value) {
                    switch (value) {
                        case 'ArchiveCreated':
                            return 'Export fichier ZIP terminé';
                        case 'ExcelCreated':
                            return 'Export(s) tableur terminé(s)';
                        case 'PDFsCreated':
                            return 'Export(s) PDF terminé(s)';
                        default:
                            return value;
                    }
                };
                return NotificationNamePipe;
            }());
            NotificationNamePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{
                            name: 'notificationName',
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtNotificationComponent = /** @class */ (function () {
                function NtNotificationComponent() {
                    this.clickNotification = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.clickAllRead = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtNotificationComponent.prototype.ngOnInit = function () { };
                return NtNotificationComponent;
            }());
            NtNotificationComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-notification',
                            template: "<button mat-icon-button [disableRipple]=\"true\" [matMenuTriggerFor]=\"appNotification\" class=\"button\">\n  <div class=\"button-notification\">\n    <div>\n      <i class=\"mdi mdi-bell mdi-24px\"></i>\n    </div>\n    <div>\n      <i class=\"mdi mdi-mdiBell notification-icon mdi-18px\" matBadge=\"{{ notificationCount }}\" matBadgeColor=\"warn\"></i>\n    </div>\n  </div>\n</button>\n<mat-menu #appNotification=\"matMenu\">\n  <div class=\"p-notification\">\n    <p *ngIf=\"notificationCount === 0\">\n      {{ 'Aucune notification' | uppercase }}\n    </p>\n    <p *ngIf=\"notificationCount > 0\">\n      <span matBadge=\"{{ notificationCount }}\" matBadgeOverlap=\"false\" matBadgeColor=\"warn\"\n        >{{ 'notifications' | uppercase }}\n      </span>\n    </p>\n  </div>\n  <div *ngFor=\"let notif of notifications\">\n    <button mat-menu-item (click)=\"clickNotification.emit(notif)\" class=\"button-inside-notification noread\">\n      <div class=\"left\" style=\"width:20%;text-align: center;\">\n        <i class=\"mdi mdi-{{ notif.message.event | notificationIcon }} mdi-24px\" style=\"line-height: 30px;\"></i>\n      </div>\n      <div class=\"left\" style=\"width:80%;\">\n        <div class=\"\">{{ notif.message.event | notificationName }}</div>\n        <div class=\"\"><i class=\"mdi mdi-clock mdi-12px\"></i> {{ notif.createdAt | date: 'medium' }}</div>\n      </div>\n    </button>\n  </div>\n\n  <a class=\"buttons-read\" *ngIf=\"notificationCount > 0\" mat-menu-item (click)=\"clickAllRead.emit($event)\">\n    Marquer tout comme lu <i class=\"mdi mdi-check-all mdi-16px\"></i>\n  </a>\n  <div *ngFor=\"let notif of allNotifications\">\n    <button mat-menu-item (click)=\"clickNotification.emit(notif)\" class=\"button-inside-notification\">\n      <div class=\"left\" style=\"width:20%;text-align: center;\">\n        <i class=\"mdi mdi-{{ notif.message.event | notificationIcon }} mdi-24px\" style=\"line-height: 30px;\"></i>\n      </div>\n      <div class=\"left\" style=\"width:80%;\">\n        <div class=\"\">{{ notif.message.event | notificationName }}</div>\n        <div class=\"\"><i class=\"mdi mdi-clock mdi-12px\"></i> {{ notif.createdAt | date: 'medium' }}</div>\n      </div>\n    </button>\n  </div>\n</mat-menu>\n",
                            styles: [".notification-icon{font-size:7px;margin-bottom:155px}.material-icons{font-size:24px}.buttons-read{background-color:#fff;padding:1px;text-align:center;color:#3c4144;font-size:15px;font-weight:700;margin-bottom:0}.buttons-read:hover{background-color:#f9f9f9}.p-notification{text-align:center;color:#fff;background-color:#1565c0;margin:-10px 0 0;padding:1px;width:260px}::ng-deep .mat-menu-content{max-height:250px}.button-notification{display:flex}.button-inside-notification{padding-right:0;padding-left:0;height:78px;border-bottom:1px solid #f9f9f9;line-height:normal}.button{margin-top:10px}.noread{background-color:#f9f9f9;color:#1565c0}.noread:hover{background-color:#f9f9f9}.left{float:left}"]
                        }] }
            ];
            /** @nocollapse */
            NtNotificationComponent.ctorParameters = function () { return []; };
            NtNotificationComponent.propDecorators = {
                notificationCount: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                notifications: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                allNotifications: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                clickNotification: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                clickAllRead: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * Ce component gere la pagination
             * \@example
             * <mwl-calendar-day-view
             *             [viewDate]="viewDate"
             *             [events]="events">
             * </mwl-calendar-day-view>
             */
            var NtPaginatorComponent = /** @class */ (function (_super_1) {
                __extends(NtPaginatorComponent, _super_1);
                function NtPaginatorComponent() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                /**
                 * @return {?}
                 */
                NtPaginatorComponent.prototype.ngOnInit = function () {
                    _super_1.prototype.ngOnInit.call(this);
                    this._displayedPageSizeOptions = this.pageSizeOptions;
                    this.countOfPage = this.boutonPaginator();
                };
                /**
                 * @return {?}
                 */
                NtPaginatorComponent.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    setTimeout(( /**
                     * @return {?}
                     */function () {
                        _this.countOfPage = _this.boutonPaginator();
                    }));
                };
                /**
                 * @param {?} value
                 * @return {?}
                 */
                NtPaginatorComponent.prototype.manualChangePage = function (value) {
                    this.pageIndex = value;
                    this.emitPageEvent();
                    return this.boutonPaginator();
                };
                /**
                 * @return {?}
                 */
                NtPaginatorComponent.prototype.boutonPaginator = function () {
                    this.countOfPage = [];
                    /** @type {?} */
                    var page = this.pageIndex;
                    /** @type {?} */
                    var maxPage = this.getNumberOfPages();
                    if (maxPage > 5) {
                        if (page - 2 >= 0) {
                            this.countOfPage.push(page - 2);
                        }
                        if (page - 1 >= 0) {
                            this.countOfPage.push(page - 1);
                        }
                        this.countOfPage.push(page);
                        if (page + 1 <= maxPage) {
                            this.countOfPage.push(page + 1);
                            if (page + 2 <= maxPage) {
                                this.countOfPage.push(page + 2);
                                if (page === 0) {
                                    if (page + 3 <= maxPage) {
                                        this.countOfPage.push(page + 3);
                                        if (page + 4 <= maxPage) {
                                            this.countOfPage.push(page + 4);
                                        }
                                    }
                                }
                                if (page === 1) {
                                    this.countOfPage.push(page + 3);
                                }
                            }
                        }
                        if (page === maxPage - 1 || page === maxPage - 2) {
                            this.countOfPage.splice(0, 0, page - 3);
                            if (page === maxPage - 1) {
                                this.countOfPage.splice(0, 0, page - 4);
                            }
                        }
                        if (this.countOfPage.length > 5) {
                            this.countOfPage.pop();
                        }
                    }
                    else {
                        for (var i = 0; i < maxPage; i++) {
                            this.countOfPage.push(i);
                        }
                    }
                    return this.countOfPage;
                };
                /**
                 * @private
                 * @return {?}
                 */
                NtPaginatorComponent.prototype.emitPageEvent = function () {
                    return this.page.emit({
                        pageIndex: this.pageIndex,
                        pageSize: this.pageSize,
                        length: this.length,
                    });
                };
                return NtPaginatorComponent;
            }(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatPaginator"]));
            NtPaginatorComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-paginator',
                            template: "<div class=\"mat-paginator-outer-container\" [ngStyle]=\"{ 'background-color': color }\">\n  <div class=\"mat-paginator-container\">\n    <div class=\"mat-paginator-page-size\" *ngIf=\"!hidePageSize\">\n      <div class=\"mat-paginator-page-size-label\">\n        {{ _intl.itemsPerPageLabel }}\n      </div>\n\n      <mat-form-field\n        *ngIf=\"_displayedPageSizeOptions.length > 1\"\n        [color]=\"color\"\n        class=\"mat-paginator-page-size-select\"\n      >\n        <mat-select\n          [value]=\"pageSize\"\n          [disabled]=\"disabled\"\n          [aria-label]=\"_intl.itemsPerPageLabel\"\n          (selectionChange)=\"_changePageSize($event.value); boutonPaginator()\"\n        >\n          <mat-option *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\" [value]=\"pageSizeOption\">\n            {{ pageSizeOption }}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n      <div *ngIf=\"_displayedPageSizeOptions.length <= 1\">{{ pageSize }}</div>\n    </div>\n\n    <div class=\"mat-paginator-range-actions\">\n      <div class=\"mat-paginator-range-label\" (change)=\"boutonPaginator()\">\n        {{ _intl.getRangeLabel(pageIndex, pageSize, length) }}\n      </div>\n\n      <button\n        mat-icon-button\n        type=\"button\"\n        class=\"mat-paginator-navigation-first\"\n        (click)=\"firstPage(); boutonPaginator()\"\n        [attr.aria-label]=\"_intl.firstPageLabel\"\n        [matTooltip]=\"_intl.firstPageLabel\"\n        [matTooltipDisabled]=\"_previousButtonsDisabled()\"\n        [matTooltipPosition]=\"'above'\"\n        [disabled]=\"_previousButtonsDisabled()\"\n        *ngIf=\"showFirstLastButtons\"\n      >\n        <i aria-label=\"Side nav toggle icon\" class=\"mdi mdi-page-first mdi-24px\"></i>\n      </button>\n      <button\n        mat-icon-button\n        type=\"button\"\n        class=\"mat-paginator-navigation-previous\"\n        (click)=\"previousPage(); boutonPaginator()\"\n        [attr.aria-label]=\"_intl.previousPageLabel\"\n        [matTooltip]=\"_intl.previousPageLabel\"\n        [matTooltipDisabled]=\"_previousButtonsDisabled()\"\n        [matTooltipPosition]=\"'above'\"\n        [disabled]=\"_previousButtonsDisabled()\"\n      >\n        <i aria-label=\"Side nav toggle icon\" class=\"mdi mdi-chevron-left mdi-24px\"></i>\n      </button>\n      <div class=\"all-button-paginator\" (change)=\"boutonPaginator()\">\n        <div *ngFor=\"let button of countOfPage\">\n          <button mat-button [disabled]=\"pageIndex === button\" (click)=\"manualChangePage(button)\">\n            {{ button + 1 }}\n          </button>\n        </div>\n      </div>\n      <button\n        mat-icon-button\n        type=\"button\"\n        class=\"mat-paginator-navigation-next\"\n        (click)=\"nextPage(); boutonPaginator()\"\n        [attr.aria-label]=\"_intl.nextPageLabel\"\n        [matTooltip]=\"_intl.nextPageLabel\"\n        [matTooltipDisabled]=\"_nextButtonsDisabled()\"\n        [matTooltipPosition]=\"'above'\"\n        [disabled]=\"_nextButtonsDisabled()\"\n      >\n        <i aria-label=\"Side nav toggle icon\" class=\"mdi mdi-chevron-right mdi-24px\"></i>\n      </button>\n      <button\n        mat-icon-button\n        type=\"button\"\n        class=\"mat-paginator-navigation-last\"\n        (click)=\"lastPage(); boutonPaginator()\"\n        [attr.aria-label]=\"_intl.lastPageLabel\"\n        [matTooltip]=\"_intl.lastPageLabel\"\n        [matTooltipDisabled]=\"_nextButtonsDisabled()\"\n        [matTooltipPosition]=\"'above'\"\n        [disabled]=\"_nextButtonsDisabled()\"\n        *ngIf=\"showFirstLastButtons\"\n      >\n        <i aria-label=\"Side nav toggle icon\" class=\"mdi mdi-page-last mdi-24px\"></i>\n      </button>\n    </div>\n  </div>\n</div>\n",
                            styles: [".mat-paginator{display:block}.mat-paginator-outer-container{display:flex}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse;width:100%}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}[dir=rtl] .mat-paginator-page-size{margin-right:0;margin-left:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0;width:56px}.mat-paginator-page-size-select.mat-form-field-appearance-fill,.mat-paginator-page-size-select.mat-form-field-appearance-outline{width:64px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center}.mat-paginator-icon{width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}.all-button-paginator{display:flex}"]
                        }] }
            ];
            NtPaginatorComponent.propDecorators = {
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                length: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                pageSizeOptions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                pageSize: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                showFirstLastButtons: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtRightClickMenuComponent = /** @class */ (function () {
                /**
                 * @param {?} change
                 */
                function NtRightClickMenuComponent(change) {
                    this.change = change;
                    this.viewLoaded = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.actionClick = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtRightClickMenuComponent.prototype.ngAfterViewInit = function () {
                    this.viewLoaded.emit({
                        height: this.self.nativeElement.offsetHeight,
                        width: this.self.nativeElement.offsetWidth,
                    });
                };
                return NtRightClickMenuComponent;
            }());
            NtRightClickMenuComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-right-click-menu',
                            template: "<div\n  #self\n  class=\"nt-right-click-menu-container\"\n  [ngStyle]=\"{\n    'max-width': width + 'px',\n    'max-height': height + 'px'\n  }\"\n>\n  <ng-container *ngFor=\"let action of actions; let i = index\">\n    <div class=\"nt-right-click-menu-action\" (click)=\"actionClick.emit(action)\">\n      <i class=\"mdi mdi-{{ action.icon || 'chevron-down' }} nt-right-click-menu-action-icon\"> </i>\n      <div class=\"nt-right-click-menu-action-text\">\n        {{ action.label }}\n      </div>\n    </div>\n  </ng-container>\n</div>\n",
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            styles: ["body{--nt-padding:10px;--nt-line-height:13px;--nt-lightgrey:lightgrey;--nt-shadow:grey;--nt-hover-grey:#f1f1f1}.nt-parent100{height:100%;width:100%}.fleft{float:left}.bclear{clear:both;clear-after:both}.nt-triangle-on-top:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;width:0;height:0;border-top:8px solid #fff;border-left:8px solid transparent;border-right:8px solid transparent}.nt-triangle-on-bottom:after{content:\"\";position:absolute;bottom:100%;left:50%;margin-left:5px;width:0;height:0;border-bottom:8px solid #fff;border-left:8px solid transparent;border-right:8px solid transparent}.nt-triangle-on-left:after{content:\"\";position:absolute;top:50%;right:-8px;width:0;height:0;border-left:8px solid #fff;border-top:8px solid transparent;border-bottom:8px solid transparent}.nt-triangle-on-right:after{content:\"\";position:absolute;top:50%;left:-8px;width:0;height:0;border-right:8px solid #fff;border-top:8px solid transparent;border-bottom:8px solid transparent}.nt-right-click-menu-container{background:#fff;box-shadow:0 0 1px var(--nt-shadow);overflow-y:scroll;overflow-x:hidden;text-overflow:ellipsis;box-sizing:content-box!important}.nt-right-click-menu-action{height:calc(var(--nt-line-height) + 1px + var(--nt-padding));padding:5px}.nt-right-click-menu-action:hover{cursor:pointer;background-color:var(--nt-hover-grey)}.nt-right-click-menu-action-icon{height:100%;width:25px;text-align:center;float:left}.nt-right-click-menu-action-text{height:100%;width:calc(100% - 25px);float:left;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis}"]
                        }] }
            ];
            /** @nocollapse */
            NtRightClickMenuComponent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            NtRightClickMenuComponent.propDecorators = {
                height: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                width: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                actions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                viewLoaded: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                actionClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                self: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['self', { static: false },] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var width = 300;
            /** @type {?} */
            var height = 150;
            var NtRightClickMenuDirective = /** @class */ (function () {
                /**
                 * @param {?} overlayPositionBuilder
                 * @param {?} elementRef
                 * @param {?} overlay
                 * @param {?} cd
                 */
                function NtRightClickMenuDirective(overlayPositionBuilder, elementRef, overlay, cd) {
                    this.overlayPositionBuilder = overlayPositionBuilder;
                    this.elementRef = elementRef;
                    this.overlay = overlay;
                    this.cd = cd;
                    this.overflowStyle = {};
                    this.ntRightClickMenuActions = [];
                    this.ntMenuPreventScrollIds = [];
                    this.ntMenuOnActionClick = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @private
                 * @param {?} x
                 * @param {?} y
                 * @param {?=} cw
                 * @param {?=} ch
                 * @return {?}
                 */
                NtRightClickMenuDirective.prototype.computePosition = function (x, y, cw, ch) {
                    /** @type {?} */
                    var wx = window.innerWidth;
                    /** @type {?} */
                    var wh = window.innerHeight;
                    // default size or loaded size
                    /** @type {?} */
                    var w = cw || width;
                    /** @type {?} */
                    var h = ch || height;
                    /** @type {?} */
                    var posx;
                    /** @type {?} */
                    var posy;
                    switch (true) {
                        case x + 10 + w > wx && y + 10 + h > wh:
                            posx = x - w + 'px';
                            posy = y - h + 'px';
                            break;
                        case x + 10 + w <= wx && y + 10 + h > wh:
                            posx = x + 'px';
                            posy = y - h + 'px';
                            break;
                        case x + 10 + w > wx && y + 10 + h <= wh:
                            posx = x - w + 'px';
                            posy = y + 10 + 'px'; // 10px for cursor size
                            break;
                        default:
                            posx = x + 10 + 'px'; // 10px for cursor siz
                            posy = y + 10 + 'px'; // 10px for cursor size
                    }
                    return this.overlayPositionBuilder
                        .global()
                        .left(posx)
                        .top(posy);
                };
                /**
                 * @param {?} $event
                 * @return {?}
                 */
                NtRightClickMenuDirective.prototype.show = function ($event) {
                    var _this = this;
                    // no classical chrome menu
                    $event.preventDefault();
                    $event.stopPropagation();
                    if (this.overlayRef && this.overlayRef.hasAttached()) {
                        this.destroyComponent();
                    }
                    else {
                        this.overlayRef = this.overlay.create();
                        if (this.ntRightClickMenuActions && this.ntRightClickMenuActions.length) {
                            // Create tooltip portal
                            /** @type {?} */
                            var menuPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_13__["ComponentPortal"](NtRightClickMenuComponent);
                            // position
                            /** @type {?} */
                            var pos = this.computePosition($event.clientX, $event.clientY);
                            this.overlayRef.updatePositionStrategy(pos);
                            // Attach tooltip portal to overlay
                            /** @type {?} */
                            var menuRef = this.overlayRef.attach(menuPortal);
                            // Pass content to tooltip component instance
                            menuRef.instance.actions = this.ntRightClickMenuActions;
                            menuRef.instance.actionClick.subscribe(( /**
                             * @param {?} event
                             * @return {?}
                             */function (/**
                             * @param {?} event
                             * @return {?}
                             */ event) {
                                _this.ntMenuOnActionClick.emit(event);
                                _this.destroyComponent();
                            }));
                            menuRef.instance.height = height;
                            menuRef.instance.width = width;
                            menuRef.instance.viewLoaded.subscribe(( /**
                             * @param {?} e
                             * @return {?}
                             */function (e) {
                                _this.overlayRef.updatePositionStrategy(_this.computePosition($event.clientX, $event.clientY, e.width, e.height));
                            }));
                            // we are oustide zone, we force detection after changing input of instance
                            menuRef.changeDetectorRef.detectChanges();
                            // still oustide zone, overlay ref depend on zone so we force position
                            this.overlayRef.updatePosition();
                            // disable scroll on list sent
                            this.ntMenuPreventScrollIds.forEach(( /**
                             * @param {?} id
                             * @return {?}
                             */function (/**
                             * @param {?} id
                             * @return {?}
                             */ id) {
                                /** @type {?} */
                                var el = document.getElementById(id);
                                if (el) {
                                    // save previous state
                                    _this.overflowStyle[id] = {
                                        x: document.getElementById(id).style.overflowX,
                                        y: document.getElementById(id).style.overflowY,
                                        both: document.getElementById(id).style.overflow,
                                    };
                                    // disable scroll
                                    document.getElementById(id).style.overflow = 'hidden';
                                    document.getElementById(id).style.overflowX = 'hidden';
                                    document.getElementById(id).style.overflowY = 'hidden';
                                }
                            }));
                            /** @type {?} */
                            var self_1 = this;
                            document.addEventListener('mousedown', ( /**
                             * @param {?} documentClickEvent
                             * @return {?}
                             */function toDeleteAfterClick(documentClickEvent) {
                                if (!self_1.overlayRef.hostElement.contains(( /** @type {?} */(documentClickEvent.target)))) {
                                    self_1.destroyComponent();
                                }
                                document.removeEventListener('mousedown', toDeleteAfterClick);
                            }));
                        }
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                NtRightClickMenuDirective.prototype.destroyComponent = function () {
                    var _this = this;
                    // put overflow style like before
                    this.ntMenuPreventScrollIds.forEach(( /**
                     * @param {?} id
                     * @return {?}
                     */function (/**
                     * @param {?} id
                     * @return {?}
                     */ id) {
                        if (_this.overflowStyle[id]) {
                            /** @type {?} */
                            var did = document.getElementById(id);
                            if (did) {
                                did.style.overflowX = _this.overflowStyle[id].x;
                                did.style.overflowY = _this.overflowStyle[id].y;
                                did.style.overflow = _this.overflowStyle[id].both;
                            }
                        }
                    }));
                    if (this.overlayRef) {
                        this.overlayRef.detach();
                        this.overlayRef.dispose();
                        delete this.overlayRef;
                        this.cd.detectChanges();
                    }
                };
                return NtRightClickMenuDirective;
            }());
            NtRightClickMenuDirective.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{
                            selector: '[ntRightClickMenu]',
                        },] }
            ];
            /** @nocollapse */
            NtRightClickMenuDirective.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_12__["OverlayPositionBuilder"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_12__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            NtRightClickMenuDirective.propDecorators = {
                ntRightClickMenuActions: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntMenuPreventScrollIds: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntMenuOnActionClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                show: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"], args: ['contextmenu.out-zone', ['$event'],] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtSidebarSmallComponent = /** @class */ (function () {
                function NtSidebarSmallComponent() {
                }
                /**
                 * @return {?}
                 */
                NtSidebarSmallComponent.prototype.ngOnInit = function () { };
                return NtSidebarSmallComponent;
            }());
            NtSidebarSmallComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-sidebar-small',
                            template: "<mat-sidenav-container class=\"sidenav-container\">\n  <mat-sidenav\n    class=\"sidenav\"\n    mode=\"side\"\n    [disableClose]=\"true\"\n    [attr.role]=\"(isHandset$ | async) ? 'dialog' : 'navigation'\"\n    [opened]=\"true\"\n    [ngStyle]=\"{ 'width.em': sidenavWidth }\"\n    *ngIf=\"sidenavWidth === 4\"\n  >\n    <div *ngIf=\"loggedIn\">\n      <div class=\"sidenav-small\">\n        <a\n          *ngFor=\"let route of router\"\n          mat-list-item\n          routerLinkActive=\"router-link-active\"\n          [routerLink]=\"route.routerLink\"\n          class=\"route-icon\"\n        >\n          <i\n            class=\"mdi mdi-{{ route.icon }} mdi-24px icon-small\"\n            matTooltip=\"{{ route.tooltip }}\"\n            matTooltipPosition=\"right\"\n            matTooltipClass=\"tooltip-blue\"\n          >\n          </i>\n        </a>\n      </div>\n    </div>\n  </mat-sidenav>\n</mat-sidenav-container>\n",
                            styles: ["::ng-deep .mat-drawer-inner-container{margin-top:64px;z-index:9999!important}.nav{position:fixed;z-index:2}.route-icon{color:#000;margin-left:15px;height:48px}.sidenav-small{position:fixed;z-index:9999}.icon-small{margin-left:15px!important}"]
                        }] }
            ];
            /** @nocollapse */
            NtSidebarSmallComponent.ctorParameters = function () { return []; };
            NtSidebarSmallComponent.propDecorators = {
                loggedIn: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                isHandset$: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                sidenavWidth: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                router: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtSidebarProfileComponent = /** @class */ (function () {
                function NtSidebarProfileComponent() {
                    this.profile = {};
                    this.$onLogOff = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.$switchTravelSpace = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtSidebarProfileComponent.prototype.ngOnInit = function () { };
                return NtSidebarProfileComponent;
            }());
            NtSidebarProfileComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-sidebar-profile',
                            template: "<button mat-icon-button [disableRipple]=\"false\" [matMenuTriggerFor]=\"appProfile\">\n  <i class=\"mdi mdi-account-circle mdi-24px\" style=\"line-height:40px\"></i>\n</button>\n<mat-menu #appProfile class=\"mat-menu-all-profile\">\n  <div class=\"mat-menu-profile\">\n    <div class=\"profil\">\n      <div class=\"left\" style=\"width:30%\">\n        <div class=\"img-rounded\">{{ profile?.firstname | slice: 0:1 }}{{ profile?.lastname | slice: 0:1 }}</div>\n      </div>\n      <div class=\"left\" style=\"width:70%\">\n        <div class=\"profile-fullname\">{{ profile?.fullname }}</div>\n        <div class=\"profile-email\">{{ profile?.email }}</div>\n      </div>\n    </div>\n    <div\n      class=\"action-button profil\"\n      (click)=\"$switchTravelSpace.emit($event)\"\n      matTooltipPosition=\"right\"\n      matTooltip=\"Changer d'espace de travail\"\n    >\n      {{ profile?.currentCompany }} <i class=\"mdi mdi-account-convert mdi-18px right\"></i>\n    </div>\n    <div class=\"action-button\" (click)=\"$onLogOff.emit($event)\">\n      D\u00E9connexion <i class=\"mdi mdi-account-off mdi-18px right\"></i>\n    </div>\n  </div>\n</mat-menu>\n",
                            styles: [".mat-menu-profile{display:flex;flex-direction:column;height:176px!important;width:250px;color:#000;align-items:stretch;padding-left:0}.mat-menu-profile .profile-fullname{font-size:15px;text-overflow:ellipsis!important;white-space:nowrap;overflow:hidden;margin-top:10px;margin-bottom:0;height:100%;width:100%}.mat-menu-profile .button-logoff{color:#fff;background-color:transparent;box-shadow:none!important;text-align:right;bottom:10px}.mat-menu-profile .profile-email{font-size:12px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%;height:100%;margin-bottom:0!important;margin-top:0}.mat-menu-profile .companies-name{font-size:10px;height:15px}.mat-menu-profile .companies-name0{margin-top:-10px}.mat-menu-profile .profile-name-and-button{display:flex;justify-content:space-between;height:24px}.mat-menu-profile .img-rounded{height:56px;width:56px;color:#fff;border-radius:50%;font-size:28px;line-height:56px;text-align:center;background-color:#7da6cf;cursor:default;display:inline-block;margin-left:10px;margin-right:5px}.mat-menu-profile .mat-menu-all-profile{overflow:hidden}.mat-menu-profile .email-flex{display:flex;justify-content:space-between;height:25px}.mat-menu-profile .button-companies{color:#fff;background-color:transparent;box-shadow:none!important;text-align:right;bottom:10px}.mat-menu-profile .action-button{padding:10px 15px}.mat-menu-profile .action-button:hover{background-color:#ccc}.mat-menu-profile .profil{border-bottom:1px solid #ccc;padding-bottom:10px}.mat-menu-profile .right{float:right}.mat-menu-profile .left{float:left}"]
                        }] }
            ];
            /** @nocollapse */
            NtSidebarProfileComponent.ctorParameters = function () { return []; };
            NtSidebarProfileComponent.propDecorators = {
                profile: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                backgroundColor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                $onLogOff: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                $switchTravelSpace: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtSidebarLargeComponent = /** @class */ (function () {
                function NtSidebarLargeComponent() {
                    this.$onLogOff = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.$decrease = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtSidebarLargeComponent.prototype.ngOnInit = function () { };
                return NtSidebarLargeComponent;
            }());
            NtSidebarLargeComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-sidebar-large',
                            template: "<mat-sidenav-container class=\"sidenav-container\">\n  <mat-sidenav\n    #drawer\n    class=\"sidenav\"\n    *ngIf=\"sidenavWidth === 18\"\n    mode=\"side\"\n    [disableClose]=\"true\"\n    [attr.role]=\"(isHandset$ | async) ? 'dialog' : 'navigation'\"\n    [opened]=\"true\"\n    [ngStyle]=\"{ 'width.em': sidenavWidth }\"\n    (mouseleave)=\"$decrease.emit($event)\"\n  >\n    <div *ngIf=\"loggedIn\">\n      <mat-nav-list (click)=\"drawer.close()\">\n        <a mat-list-item *ngIf=\"!loggedIn\" routerLink=\"/login\">{{ loggedIn ? 'Changement de compte' : 'Connexion' }}</a>\n        <div *ngIf=\"loggedIn\">\n          <a\n            *ngFor=\"let route of router\"\n            mat-list-item\n            routerLinkActive=\"router-link-active\"\n            [routerLink]=\"route.routerLink\"\n          >\n            <div class=\"all-link\">\n              <i class=\"mdi mdi-{{ route.icon }} mdi-24px icon-link\"></i>\n              <p>{{ route.name }}</p>\n              <i class=\"mdi mdi-{{ route.iconBis }} mdi-24px icon-link\"></i>\n            </div>\n          </a>\n          <nt-sidenav-info-90 [appName]=\"appName\" [version]=\"version\"></nt-sidenav-info-90>\n        </div>\n      </mat-nav-list>\n    </div>\n  </mat-sidenav>\n</mat-sidenav-container>\n",
                            styles: [".all-link{display:flex;justify-content:space-between;width:250px;padding-left:0;padding-right:0}.sidenav-container ::ng-deep .mat-drawer-content{margin-left:56px}.icon-link{margin-top:10px}.sidenav{position:fixed;width:250px!important;visibility:visible!important;overflow:hidden!important}.sidenav .mat-toolbar{background:inherit}::ng-deep .mat-drawer-inner-container{margin-top:64px;z-index:9999!important}"]
                        }] }
            ];
            /** @nocollapse */
            NtSidebarLargeComponent.ctorParameters = function () { return []; };
            NtSidebarLargeComponent.propDecorators = {
                sidenavWidth: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                loggedIn: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                appName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                version: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                isHandset$: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                router: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                $onLogOff: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                $decrease: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtSidebarInfo90Component = /** @class */ (function () {
                function NtSidebarInfo90Component() {
                }
                /**
                 * @return {?}
                 */
                NtSidebarInfo90Component.prototype.ngOnInit = function () { };
                return NtSidebarInfo90Component;
            }());
            NtSidebarInfo90Component.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-sidenav-info-90',
                            template: "<hr />\n<div class=\"all-info90\">\n  <a href=\"https://www.90tech.fr\">\n    <div>{{ appName }} - v{{ version }}<br />'Propuls\u00E9 par</div>\n    <div><img class=\"img-info\" alt=\"90tech\" src=\"https://assets.90tech.fr/logo-90tech.svg\" /></div>\n  </a>\n</div>\n",
                            styles: ["hr{width:250px;margin-left:0}.all-info90{width:250px;margin-top:100px;display:flex;justify-content:center;text-align:center;text-decoration:none}.all-info90 a{text-decoration:none}.all-info90 img{margin-top:5px;height:100px}"]
                        }] }
            ];
            /** @nocollapse */
            NtSidebarInfo90Component.ctorParameters = function () { return []; };
            NtSidebarInfo90Component.propDecorators = {
                appName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                version: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtSwitcherComponent = /** @class */ (function () {
                function NtSwitcherComponent() {
                    this.navigate = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtSwitcherComponent.prototype.ngOnInit = function () { };
                return NtSwitcherComponent;
            }());
            NtSwitcherComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-switcher',
                            template: "<button mat-button [disableRipple]=\"true\" class=\"switcher-button\" [matMenuTriggerFor]=\"appMenuSwitch\">\n  <span class=\"app-name\"\n    >{{ appName }}\n    <i class=\"mdi mdi-chevron-down\"></i>\n  </span>\n</button>\n<mat-menu #appMenuSwitch=\"matMenu\" yPosition=\"below\">\n  <button mat-menu-item class=\"switcher-buttons\" *ngFor=\"let app of accessibleApps\" (click)=\"navigate.emit(app)\">\n    <img *ngIf=\"app.logoUrl\" class=\"logo-url text-center\" alt=\"\" src=\"{{ app.logoUrl }}\" />\n    <img\n      *ngIf=\"!app.logoUrl\"\n      class=\"logo-url text-center\"\n      alt=\"\"\n      src=\"https://s3-eu-west-1.amazonaws.com/marketplace-images-storage/solitech-contour-web.svg\"\n    />\n    <p class=\"text-center\">\n      {{ app.name }}\n    </p>\n  </button>\n</mat-menu>\n",
                            styles: [".logo-switcher{width:210%}.switcher-buttons{margin-top:0;transition:background-color .3s,color .3s;color:#000;max-height:350px;overflow:auto;width:250px;height:48px;position:relative;padding-left:5px;padding-right:5px}.switcher-buttons:hover{background-color:#ccc}::ng-deep .mat-button{border-radius:inherit}.app-name{font-size:19px}.switch{display:flex}.icon-switch{margin-top:5px}.logo-url{height:36px;width:36px;margin-right:10px}.switcher-button{margin-bottom:0}.text-center{margin:0;position:absolute;top:50%;transform:translateY(-50%)}p{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:200px}p.text-center{margin-left:40px}"]
                        }] }
            ];
            /** @nocollapse */
            NtSwitcherComponent.ctorParameters = function () { return []; };
            NtSwitcherComponent.propDecorators = {
                appName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                accessibleApps: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                navigate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtTableDisplayComponent = /** @class */ (function () {
                function NtTableDisplayComponent() {
                    this.dropList = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtTableDisplayComponent.prototype.ngOnInit = function () { };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                NtTableDisplayComponent.prototype.drop = function (event) {
                    if (event.previousContainer === event.container) {
                        Object(_angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_6__["moveItemInArray"])(this.columnsForChoise, event.previousIndex, event.currentIndex);
                        return this.dropList.emit(this.columnsNotChoise);
                    }
                    else {
                        Object(_angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_6__["transferArrayItem"])(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
                    }
                };
                /**
                 * @return {?}
                 */
                NtTableDisplayComponent.prototype.selectAll = function () {
                    for (var _c = 0, _d = this.columnsNotChoise; _c < _d.length; _c++) {
                        var column = _d[_c];
                        if (column === 'select') {
                            this.columnsForChoise.unshift(column);
                        }
                        else {
                            this.columnsForChoise.push(column);
                        }
                    }
                    return this.dropList.emit((this.columnsNotChoise = []));
                };
                return NtTableDisplayComponent;
            }());
            NtTableDisplayComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-table-display',
                            template: "<div cdkDropListGroup class=\"dialog-columns\">\n  <h2>{{ 'editColumns' | ntTranslate: 'Modification des colonnes' }}</h2>\n  <div class=\"columns-drop\">\n    <p class=\"columns-name\">\n      {{ 'availableColumns' | ntTranslate: 'colonnes disponible' | uppercase }}\n      <button mat-raised-button [disabled]=\"columnsNotChoise.length === 0\" (click)=\"selectAll()\">\n        {{ 'selectAll' | ntTranslate: 'Tout s\u00E9lectionner' }}\n      </button>\n    </p>\n    <div\n      cdkDropList\n      class=\"columns-list\"\n      [cdkDropListData]=\"columnsNotChoise\"\n      cdkDropListSortingDisabled\n      (cdkDropListDropped)=\"drop($event)\"\n    >\n      <div *ngFor=\"let element of columnsNotChoise\" cdkDrag class=\"columns-element\">\n        {{ element | columnsName }}\n      </div>\n    </div>\n  </div>\n  <div class=\"columns-drop\">\n    <p class=\"columns-name\">{{ 'usedColumns' | ntTranslate: 'colonnes utilis\u00E9es' | uppercase }}</p>\n    <div cdkDropList class=\"columns-list\" (cdkDropListDropped)=\"drop($event)\" [cdkDropListData]=\"columnsForChoise\">\n      <div *ngFor=\"let element of columnsForChoise\" cdkDrag class=\"columns-element\">\n        {{ element | columnsName }}\n      </div>\n    </div>\n  </div>\n</div>\n",
                            styles: [".dialog-columns{text-align:center;width:900px;height:600px}.dialog-columns .columns-drop{width:400px;max-width:100%;margin:0 25px 25px 0;display:inline-block;vertical-align:top}.dialog-columns .columns-list{border:1px solid #ccc;min-height:60px;background:#fff;border-radius:4px;overflow-y:scroll;overflow-x:hidden;display:block;height:450px}.dialog-columns .columns-element{padding:20px 10px;border-bottom:1px solid #ccc;color:rgba(0,0,0,.87);display:flex;flex-direction:row;align-items:center;justify-content:space-between;box-sizing:border-box;cursor:move;background:#fff;font-size:14px;text-overflow:ellipsis!important}.dialog-columns .cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.dialog-columns .cdk-drag-placeholder{opacity:1;background-color:#7f7f7f}.dialog-columns .cdk-drag-animating{transition:transform 250ms cubic-bezier(0,0,.2,1)}.dialog-columns .columns-element:last-child{border:none}.dialog-columns .columns-list.cdk-drop-list-dragging .columns-element:not(.cdk-drag-placeholder){transition:transform 250ms cubic-bezier(0,0,.2,1)}.dialog-columns .columns-name{height:36px}"]
                        }] }
            ];
            /** @nocollapse */
            NtTableDisplayComponent.ctorParameters = function () { return []; };
            NtTableDisplayComponent.propDecorators = {
                columnsForChoise: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                columnsNotChoise: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtToolbarComponent = /** @class */ (function () {
                function NtToolbarComponent() {
                    this.$onLogOff = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.$switchTravelSpace = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.clickNotification = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.clicAllRead = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.navigate = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.$increase = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.$decrease = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @return {?}
                 */
                NtToolbarComponent.prototype.ngOnInit = function () { };
                return NtToolbarComponent;
            }());
            NtToolbarComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-toolbar',
                            template: "<mat-toolbar color=\"primary\" class=\"nav\">\n  <div *ngIf=\"sidenavWidth === 4\">\n    <button mat-icon-button aria-label=\"Toggle sidenav\" (click)=\"$increase.emit($event)\">\n      <i aria-label=\"Side nav toggle icon\" class=\"mdi mdi-menu mdi-24px center-vert\"></i>\n    </button>\n  </div>\n  <div *ngIf=\"sidenavWidth === 18\">\n    <button mat-icon-button aria-label=\"Toggle sidenav\" (click)=\"$decrease.emit($event)\">\n      <i aria-label=\"Side nav toggle icon\" class=\"mdi mdi-menu mdi-24px center-vert\"></i>\n    </button>\n  </div>\n  <nt-sidebar-profile\n    [profile]=\"profile\"\n    ($onLogOff)=\"$onLogOff.emit($event)\"\n    [backgroundColor]=\"backgroundColor\"\n    [color]=\"colorProfile\"\n    ($switchTravelSpace)=\"$switchTravelSpace.emit($event)\"\n  ></nt-sidebar-profile>\n  <nt-switcher [appName]=\"appName\" [accessibleApps]=\"accessibleApps\" (navigate)=\"navigate.emit($event)\"></nt-switcher>\n  <nt-notification\n    [notifications]=\"notifications\"\n    [notificationCount]=\"notificationCount\"\n    [allNotifications]=\"allNotifications\"\n    (clickAllRead)=\"clicAllRead.emit($event)\"\n    (clickNotification)=\"clickNotification.emit($event)\"\n  ></nt-notification>\n</mat-toolbar>\n",
                            styles: [".nav{position:fixed;z-index:2;padding-left:8px}.center-vert{line-height:40px}"]
                        }] }
            ];
            /** @nocollapse */
            NtToolbarComponent.ctorParameters = function () { return []; };
            NtToolbarComponent.propDecorators = {
                sidenavWidth: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                appName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                profile: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                accessibleApps: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                notifications: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                notificationCount: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                allNotifications: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                backgroundColor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                colorProfile: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                $onLogOff: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                $switchTravelSpace: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                clickNotification: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                clicAllRead: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                navigate: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                $increase: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                $decrease: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtImageProfileComponent = /** @class */ (function () {
                function NtImageProfileComponent() {
                }
                /**
                 * @return {?}
                 */
                NtImageProfileComponent.prototype.ngOnInit = function () { };
                return NtImageProfileComponent;
            }());
            NtImageProfileComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-image-profile',
                            template: "<img class=\"img-rounded\" alt=\"M.B\" src=\"https://via.placeholder.com/150\" />\n",
                            styles: [".img-rounded{height:56px;width:56px;color:#fff;border-radius:50%;font-size:28px;line-height:56px;background-color:#7da6cf;cursor:default;display:inline-block;margin-top:10px;margin-right:150px}"]
                        }] }
            ];
            /** @nocollapse */
            NtImageProfileComponent.ctorParameters = function () { return []; };
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // height of one line of text in pixel
            /** @type {?} */
            var lineHeight = 18;
            /** @type {?} */
            var padding = 10;
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var WeekEnum = [
                { key: 'monday', fr: 'lundi' },
                { key: 'tuesday', fr: 'mardi' },
                { key: 'wenesday', fr: 'mercredi' },
                { key: 'thursday', fr: 'jeudi' },
                { key: 'friday', fr: 'vendredi' },
                { key: 'saturday', fr: 'samedi' },
                { key: 'sunday', fr: 'dimanche' },
            ];
            /** @type {?} */
            var MonthEnum = [
                { key: 'january', fr: 'janvier' },
                { key: 'february', fr: 'février' },
                { key: 'march', fr: 'mars' },
                { key: 'april', fr: 'avril' },
                { key: 'may', fr: 'mai' },
                { key: 'june', fr: 'juin' },
                { key: 'july', fr: 'juillet' },
                { key: 'august', fr: 'aout' },
                { key: 'september', fr: 'septembre' },
                { key: 'october', fr: 'octobre' },
                { key: 'november', fr: 'novembre' },
                { key: 'december', fr: 'décembre' },
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var Time = /** @class */ (function () {
                /**
                 * @param {?=} str
                 */
                function Time(str) {
                    // tslint:disable-next-line:variable-name
                    this._hour = 0;
                    // tslint:disable-next-line:variable-name
                    this._minute = 0;
                    if (str) {
                        /** @type {?} */
                        var split = str.split(':');
                        if (!split || split.length !== 2) {
                            throw new Error('Format of string must be "XX:XX"');
                        }
                        this._hour = parseInt(split[0], 10) || 0;
                        if (this._hour < 0 || this._hour > 23) {
                            throw new Error('Hour must be between 0 and 23');
                        }
                        this._minute = parseInt(split[1], 10) || 0;
                        if (this._minute < 0 || this._minute > 59) {
                            throw new Error('Minute must be between 0 and 59');
                        }
                    }
                }
                Object.defineProperty(Time.prototype, "hour", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._hour;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._hour = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Time.prototype, "minute", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._minute;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._minute = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                // ====================== STATIC
                /**
                 * @param {?} t
                 * @return {?}
                 */
                Time.fromInterface = function (t) {
                    return new Time(t.hour + ':' + t.minute);
                };
                /**
                 * @param {?} d
                 * @return {?}
                 */
                Time.fromDate = function (d) {
                    return new Time(d.getHours() + ':' + d.getMinutes());
                };
                // ====================== PRIVATE
                /**
                 * @private
                 * @return {?}
                 */
                Time.prototype.hourToStr = function () {
                    return this._hour > 9 ? '' + this._hour : '0' + this._hour;
                };
                /**
                 * @private
                 * @return {?}
                 */
                Time.prototype.minuteToStr = function () {
                    return this._minute > 9 ? '' + this._minute : '0' + this._minute;
                };
                // ====================== PUBLIC
                /**
                 * @return {?}
                 */
                Time.prototype.toString = function () {
                    return this.hourToStr() + ':' + this.minuteToStr();
                };
                /**
                 * @param {?} time
                 * @return {?}
                 */
                Time.prototype.isEqual = function (time) {
                    return this.hour === time.hour && this.minute === time.minute;
                };
                /**
                 * @param {?} time
                 * @param {?=} strictly
                 * @return {?}
                 */
                Time.prototype.isBefore = function (time, strictly) {
                    if (!strictly && this.isEqual(time)) {
                        return true;
                    }
                    if (time.hour === this.hour) {
                        return this.minute < time.minute;
                    }
                    return this.hour < time.hour;
                };
                /**
                 * @param {?} timeRange
                 * @param {?=} strictly
                 * @return {?}
                 */
                Time.prototype.isInsideTimeRange = function (timeRange, strictly) {
                    return this.isAfter(timeRange.from, strictly) && this.isBefore(timeRange.to, strictly);
                };
                /**
                 * @param {?} time
                 * @param {?=} strictly
                 * @return {?}
                 */
                Time.prototype.isAfter = function (time, strictly) {
                    if (!strictly && this.isEqual(time)) {
                        return true;
                    }
                    return !this.isBefore(time);
                };
                /**
                 * @param {?} h
                 * @return {?}
                 */
                Time.prototype.addHour = function (h) {
                    this.hour = (this.hour + h) % 24;
                    if (this.hour < 0) {
                        this.hour = 24 + this.hour;
                    }
                };
                /**
                 * @param {?} m
                 * @return {?}
                 */
                Time.prototype.addMinute = function (m) {
                    /** @type {?} */
                    var total = this.minute + m;
                    if (total < 0) {
                        this.minute = 60 + (total % 60);
                        this.addHour(24 + Math.floor(total / 60));
                    }
                    else {
                        this.minute = total % 60;
                        this.addHour(Math.floor(total / 60));
                    }
                };
                return Time;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var Shift = /** @class */ (function () {
                /**
                 * @param {?} s
                 * @param {?} e
                 * @param {?=} en
                 * @param {?=} b
                 */
                function Shift(s, e, en, b) {
                    var _this = this;
                    // is time in shift and not in breaks
                    this.isTimeInShift = ( /**
                     * @param {?} time
                     * @param {?=} strictly
                     * @return {?}
                     */function (time, strictly) {
                        if (!_this.enabled) {
                            return false;
                        }
                        if (time.isBefore(_this.start, !strictly)) {
                            return false;
                        }
                        if (time.isAfter(_this.end, !strictly)) {
                            return false;
                        }
                        for (var _c = 0, _d = _this.breaks; _c < _d.length; _c++) {
                            var b_1 = _d[_c];
                            if (time.isAfter(b_1.from, !strictly) && time.isBefore(b_1.to, !strictly)) {
                                return false;
                            }
                        }
                        return true;
                    });
                    // any intersection between timeRange and breaks or out shift would return false
                    this.isTimeRangeInShift = ( /**
                     * @param {?} r
                     * @param {?=} strictly
                     * @return {?}
                     */function (r, strictly) {
                        if (!_this.enabled) {
                            return false;
                        }
                        /** @type {?} */
                        var res = false;
                        if (_this.isTimeInShift(r.from, strictly) && _this.isTimeInShift(r.to, strictly)) {
                            res = true;
                            _this.breaks.forEach(( /**
                             * @param {?} b
                             * @return {?}
                             */function (b) {
                                /** @type {?} */
                                var p = b.from.isBefore(r.to, !strictly);
                                /** @type {?} */
                                var q = b.from.isAfter(r.from, strictly);
                                /** @type {?} */
                                var m = b.to.isAfter(r.from, !strictly);
                                /** @type {?} */
                                var n = b.to.isBefore(r.to, strictly);
                                if ((p && q) || (m && n)) {
                                    res = false;
                                }
                            }));
                        }
                        return res;
                    });
                    this.start = s;
                    this.end = e;
                    if (!this.end || !this.start) {
                        throw new Error('start and end Time must be defined.');
                    }
                    if (this.end.isBefore(this.start)) {
                        throw new Error('end of shift must be after start');
                    }
                    if (en === undefined) {
                        this.enabled = true;
                    }
                    else {
                        this.enabled = en;
                    }
                    this.breaks = b || [];
                }
                Object.defineProperty(Shift.prototype, "breaks", {
                    // tslint:enable
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._breaks;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._breaks = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Shift.prototype, "enabled", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._enabled;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._enabled = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Shift.prototype, "end", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._end;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._end = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Shift.prototype, "start", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._start;
                    },
                    /**
                     * @param {?} value
                     * @return {?}
                     */
                    set: function (value) {
                        this._start = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                // ====================== STATIC
                /**
                 * @param {?} t
                 * @return {?}
                 */
                Shift.fromInterface = function (t) {
                    return new Shift(t.start, t.end, t.enabled, t.breaks);
                };
                return Shift;
            }());
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // fu** american
            /** @type {?} */
            var ntStartOfWeek = ( /**
             * @param {?} date
             * @param {?=} options
             * @return {?}
             */function (date, options) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["startOfWeek"])(date, Object.assign({}, options, { weekStartsOn: 1 })); });
            /** @type {?} */
            var ntEndOfWeek = ( /**
             * @param {?} date
             * @param {?=} options
             * @return {?}
             */function (date, options) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["endOfWeek"])(date, Object.assign({}, options, { weekStartsOn: 1 })); });
            /** @type {?} */
            var ntGetWeek = ( /**
             * @param {?} date
             * @param {?=} options
             * @return {?}
             */function (date, options) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["getWeek"])(date, Object.assign({}, options, { weekStartsOn: 1, firstWeekContainsDate: 4 })); });
            /** @type {?} */
            var ntGetDay = ( /**
             * @param {?} date
             * @return {?}
             */function (/**
             * @param {?} date
             * @return {?}
             */ date) {
                /** @type {?} */
                var americanDay = Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["getDay"])(date);
                return americanDay === 0 ? 6 : americanDay - 1;
            });
            // isAfter or Equal, isBefore or Equal
            /** @type {?} */
            var isAfter = ( /**
             * @param {?} a
             * @param {?} b
             * @param {?=} strictly
             * @return {?}
             */function (a, b, strictly) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["isAfter"])(a, b) || (strictly ? false : Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["isEqual"])(a, b)); });
            /** @type {?} */
            var isBefore = ( /**
             * @param {?} a
             * @param {?} b
             * @param {?=} strictly
             * @return {?}
             */function (a, b, strictly) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["isBefore"])(a, b) || (strictly ? false : Object(date_fns__WEBPACK_IMPORTED_MODULE_14__["isEqual"])(a, b)); });
            /** @type {?} */
            var isDateInRange = ( /**
             * @param {?} date
             * @param {?} range
             * @param {?=} strictly
             * @return {?}
             */function (date, range, strictly) {
                return isAfter(date, range.from, strictly) && isBefore(date, range.to, strictly);
            });
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtTooltipComponent = /** @class */ (function () {
                function NtTooltipComponent() {
                    this.buttonClick = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                    this.tooltipClick = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                Object.defineProperty(NtTooltipComponent.prototype, "lineHeight", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return lineHeight;
                    },
                    enumerable: true,
                    configurable: true
                });
                return NtTooltipComponent;
            }());
            NtTooltipComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-tooltip',
                            template: "<div class=\"nt-tooltip-container\">\n  <!--LINES-->\n  <div\n    class=\"nt-tooltip-lines-container\"\n    [ngClass]=\"{ 'nt-tooltip-lines-container-no-button': !buttonName }\"\n    (click)=\"tooltipClick.emit($event)\"\n  >\n    <ng-container *ngFor=\"let line of lines; index as i\">\n      <!--FOR ONE LINE-->\n      <div\n        class=\"nt-tooltip-one-line\"\n        [ngStyle]=\"{\n          height: (line.nbrLine || 1) * lineHeight + 'px',\n          'margin-top': line.withoutSpace ? '' : '10px'\n        }\"\n      >\n        <!--TODO: icon management-->\n        <!-- ICON -->\n        <div class=\"nt-tooltip-icon\" [ngStyle]=\"{ height: lineHeight + 'px' }\">\n          <i *ngIf=\"line.icon\" class=\"mdi {{ line.icon }}\"> </i>\n        </div>\n\n        <!--TEXT-->\n        <div\n          class=\"nt-tooltip-text\"\n          [ngStyle]=\"{\n            height: (line.nbrLine || 1) * lineHeight + 'px',\n            color: line.withColor || 'black'\n          }\"\n        >\n          <strong *ngIf=\"line.strong\">\n            {{ line.text }}\n          </strong>\n          <ng-container *ngIf=\"!line.strong\">\n            {{ line.text }}\n          </ng-container>\n        </div>\n      </div>\n\n      <!--SEPARATION-->\n      <hr *ngIf=\"line.lineAfter\" />\n    </ng-container>\n  </div>\n\n  <!-- BUTTON -->\n  <div class=\"nt-tooltip-button-container\" [ngStyle]=\"{ 'background-color': color }\" *ngIf=\"buttonName\">\n    <div (click)=\"buttonClick.emit($event)\">\n      {{ buttonName }}\n    </div>\n  </div>\n</div>\n",
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            styles: [".nt-tooltip-top-of-the-world{z-index:1042}.nt-tooltip-container{box-shadow:0 0 5px var(--nt-shadow);width:250px;height:300px;background:#fff;border-radius:var(--nt-padding);box-sizing:content-box!important}.nt-tooltip-lines-container{width:230px;height:230px;padding:10px;overflow:hidden;box-sizing:content-box!important;border-radius:var(--nt-padding) var(--nt-padding) 0 0}.nt-tooltip-lines-container hr{width:248px!important;margin-left:-10px}.nt-tooltip-lines-container-no-button{height:270px!important}.nt-tooltip-one-line{width:230px;overflow:hidden;position:relative}.nt-tooltip-one-line .nt-tooltip-icon{width:30px;color:#a9a9a9;position:absolute;left:0}.nt-tooltip-one-line .nt-tooltip-text{width:200px;position:absolute;right:0}.nt-tooltip-button-container{width:250px;color:#fff;height:50px;line-height:50px;text-align:center;border-radius:0 0 var(--nt-padding) var(--nt-padding)}.nt-tooltip-button-container:hover{cursor:pointer}"]
                        }] }
            ];
            /** @nocollapse */
            NtTooltipComponent.ctorParameters = function () { return []; };
            NtTooltipComponent.propDecorators = {
                buttonName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                color: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                lines: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                buttonClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                tooltipClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtTranslateService = /** @class */ (function () {
                /**
                 * @param {?} config
                 * @param {?} http
                 */
                function NtTranslateService(config, http) {
                    this.http = http;
                    /* tslint:disable:variable-name */
                    this._dictionary = {};
                    this.url = config.urls.public90techAssetsUrl + '/dictionaries';
                }
                Object.defineProperty(NtTranslateService.prototype, "dictionary", {
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this._dictionary;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @param {?} lang
                 * @return {?}
                 */
                NtTranslateService.prototype.loadDictionnary = function (lang) {
                    var _this = this;
                    // return this.http.get(this.url + '/' + lang + '.json').toPromise().then((data: any) => {
                    return this.http
                        .get(this.url + '/' + lang)
                        .toPromise()
                        .then(( /**
                 * @param {?} data
                 * @return {?}
                 */function (data) {
                        _this._dictionary = data;
                    }));
                };
                return NtTranslateService;
            }());
            NtTranslateService.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                            providedIn: 'root',
                        },] }
            ];
            /** @nocollapse */
            NtTranslateService.ctorParameters = function () { return [
                { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['NtCoreConfig',] }] },
                { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_15__["HttpClient"] }
            ]; };
            /** @nocollapse */ NtTranslateService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function NtTranslateService_Factory() { return new NtTranslateService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])("NtCoreConfig"), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_common_http__WEBPACK_IMPORTED_MODULE_15__["HttpClient"])); }, token: NtTranslateService, providedIn: "root" });
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtTranslatePipe = /** @class */ (function () {
                /**
                 * @param {?} trad
                 */
                function NtTranslatePipe(trad) {
                    this.trad = trad;
                }
                /**
                 * @param {?} value
                 * @param {?} fallback
                 * @return {?}
                 */
                NtTranslatePipe.prototype.transform = function (value, fallback) {
                    return this.trad.dictionary[value] || fallback;
                };
                return NtTranslatePipe;
            }());
            NtTranslatePipe.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                            providedIn: 'root',
                        },] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"], args: [{
                            name: 'ntTranslate',
                        },] }
            ];
            /** @nocollapse */
            NtTranslatePipe.ctorParameters = function () { return [
                { type: NtTranslateService }
            ]; };
            /** @nocollapse */ NtTranslatePipe.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function NtTranslatePipe_Factory() { return new NtTranslatePipe(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(NtTranslateService)); }, token: NtTranslatePipe, providedIn: "root" });
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            // directive that take html into input and create a tooltip
            var NtTooltipDirective = /** @class */ (function () {
                /**
                 * @param {?} overlayPositionBuilder
                 * @param {?} elementRef
                 * @param {?} overlay
                 * @param {?} cd
                 */
                function NtTooltipDirective(overlayPositionBuilder, elementRef, overlay, cd) {
                    this.overlayPositionBuilder = overlayPositionBuilder;
                    this.elementRef = elementRef;
                    this.overlay = overlay;
                    this.cd = cd;
                    this.overflowStyle = {};
                    this.ntTooltipListenToClick = false;
                    this.ntTooltipEnable = true;
                    this.ntTooltipColor = '';
                    this.ntTooltipPreventScrollIds = [];
                    this.ntTooltipLines = [];
                    this.ntTooltipOnButtonClick = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
                }
                /**
                 * @param {?} changes
                 * @return {?}
                 */
                NtTooltipDirective.prototype.ngOnChanges = function (changes) {
                    if (changes.ntTooltipEnable &&
                        !changes.ntTooltipEnable.currentValue &&
                        this.overlayRef &&
                        this.overlayRef.hasAttached()) {
                        this.destroyComponent();
                    }
                };
                /**
                 * @return {?}
                 */
                NtTooltipDirective.prototype.ngOnInit = function () {
                    // if the content is empty, we dont print anything
                    if (!this.ntTooltipLines.length) {
                        this.ntTooltipEnable = false;
                    }
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                NtTooltipDirective.prototype.mouseOver = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!this.ntTooltipListenToClick && this.ntTooltipEnable) {
                        this.buildComponent();
                    }
                };
                /**
                 * @param {?} event
                 * @return {?}
                 */
                NtTooltipDirective.prototype.mouseOut = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!this.ntTooltipListenToClick && this.overlayRef && this.overlayRef.hasAttached()) {
                        this.destroyComponent();
                    }
                };
                // outside angular zone for performance (need customEvent in provider)
                /**
                 * @param {?} directiveClickEvent
                 * @return {?}
                 */
                NtTooltipDirective.prototype.click = function (directiveClickEvent) {
                    directiveClickEvent.preventDefault();
                    directiveClickEvent.stopPropagation();
                    if (this.ntTooltipListenToClick && this.ntTooltipEnable) {
                        if (this.overlayRef && this.overlayRef.hasAttached()) {
                            this.destroyComponent();
                        }
                        else {
                            this.buildComponent();
                            /** @type {?} */
                            var self_2 = this;
                            document.addEventListener('mousedown', ( /**
                             * @param {?} documentClickEvent
                             * @return {?}
                             */function toDeleteAfterClick(documentClickEvent) {
                                if (!self_2.overlayRef.hostElement.contains(( /** @type {?} */(documentClickEvent.target)))) {
                                    self_2.destroyComponent();
                                }
                                document.removeEventListener('mousedown', toDeleteAfterClick);
                            }));
                        }
                    }
                };
                /**
                 * @private
                 * @return {?}
                 */
                NtTooltipDirective.prototype.buildPosition = function () {
                    return (this.overlayPositionBuilder
                        // Create position attached to the elementRef
                        .flexibleConnectedTo(this.elementRef.nativeElement)
                        .withFlexibleDimensions(false)
                        // .withLockedPosition(false)
                        .withPositions([
                        // bottom is default position to prevent overlapping header
                        {
                            originX: 'center',
                            originY: 'bottom',
                            overlayX: 'center',
                            overlayY: 'top',
                            offsetY: 5,
                            panelClass: ['nt-tooltip-top-of-the-world', 'nt-triangle-on-bottom'],
                        },
                        // default position is right
                        {
                            originX: 'end',
                            originY: 'center',
                            overlayX: 'start',
                            overlayY: 'center',
                            offsetX: 5,
                            panelClass: ['nt-tooltip-top-of-the-world', 'nt-triangle-on-right'],
                        },
                        // then left
                        {
                            originX: 'start',
                            originY: 'center',
                            overlayX: 'end',
                            overlayY: 'center',
                            offsetX: -5,
                            panelClass: ['nt-tooltip-top-of-the-world', 'nt-triangle-on-left'],
                        },
                        // last position is top
                        {
                            originX: 'center',
                            originY: 'top',
                            overlayX: 'center',
                            overlayY: 'bottom',
                            offsetY: -5,
                            panelClass: ['nt-tooltip-top-of-the-world', 'nt-triangle-on-top'],
                        },
                    ]));
                };
                /**
                 * @private
                 * @return {?}
                 */
                NtTooltipDirective.prototype.buildComponent = function () {
                    var _this = this;
                    this.overlayRef = this.overlay.create({ positionStrategy: this.buildPosition(), maxWidth: 500 });
                    // disable scroll on list sent
                    this.ntTooltipPreventScrollIds.forEach(( /**
                     * @param {?} id
                     * @return {?}
                     */function (/**
                     * @param {?} id
                     * @return {?}
                     */ id) {
                        /** @type {?} */
                        var el = document.getElementById(id);
                        if (el) {
                            // save previous state
                            _this.overflowStyle[id] = {
                                x: document.getElementById(id).style.overflowX,
                                y: document.getElementById(id).style.overflowY,
                                both: document.getElementById(id).style.overflow,
                            };
                            // disable scroll
                            document.getElementById(id).style.overflow = 'hidden';
                            document.getElementById(id).style.overflowX = 'hidden';
                            document.getElementById(id).style.overflowY = 'hidden';
                        }
                    }));
                    // Create tooltip portal
                    /** @type {?} */
                    var tooltipPortal = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_13__["ComponentPortal"](NtTooltipComponent);
                    // Attach tooltip portal to overlay
                    /** @type {?} */
                    var tooltipRef = this.overlayRef.attach(tooltipPortal);
                    // Pass content to tooltip component instance
                    tooltipRef.instance.lines = this.ntTooltipLines;
                    tooltipRef.instance.color = this.ntTooltipColor;
                    tooltipRef.instance.buttonName = this.ntTooltipButtonName;
                    tooltipRef.instance.tooltipClick.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.destroyComponent();
                    }));
                    tooltipRef.instance.buttonClick.subscribe(( /**
                     * @param {?} event
                     * @return {?}
                     */function (/**
                     * @param {?} event
                     * @return {?}
                     */ event) {
                        _this.destroyComponent();
                        _this.ntTooltipOnButtonClick.emit(event);
                    }));
                    // we are oustide zone, we force detection after changing input of instance
                    tooltipRef.changeDetectorRef.detectChanges();
                    // still oustide zone, overlay ref depend on zone so we force position
                    this.overlayRef.updatePosition();
                };
                /**
                 * @private
                 * @return {?}
                 */
                NtTooltipDirective.prototype.destroyComponent = function () {
                    var _this = this;
                    // put overflow style like before
                    this.ntTooltipPreventScrollIds.forEach(( /**
                     * @param {?} id
                     * @return {?}
                     */function (/**
                     * @param {?} id
                     * @return {?}
                     */ id) {
                        if (_this.overflowStyle[id] && _this.ntTooltipEnable) {
                            /** @type {?} */
                            var did = document.getElementById(id);
                            if (did) {
                                did.style.overflowX = _this.overflowStyle[id].x;
                                did.style.overflowY = _this.overflowStyle[id].y;
                                did.style.overflow = _this.overflowStyle[id].both;
                            }
                        }
                    }));
                    if (this.overlayRef) {
                        this.overlayRef.detach();
                        this.overlayRef.dispose();
                        delete this.overlayRef;
                        this.cd.detectChanges();
                    }
                };
                return NtTooltipDirective;
            }());
            NtTooltipDirective.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"], args: [{ selector: '[ntTooltip]' },] }
            ];
            /** @nocollapse */
            NtTooltipDirective.ctorParameters = function () { return [
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_12__["OverlayPositionBuilder"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"] },
                { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_12__["Overlay"] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            NtTooltipDirective.propDecorators = {
                ntTooltipButtonName: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntTooltipListenToClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntTooltipEnable: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntTooltipColor: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntTooltipPreventScrollIds: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntTooltipLines: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                ntTooltipOnButtonClick: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"] }],
                mouseOver: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"], args: ['mouseenter.out-zone', ['$event'],] }],
                mouseOut: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"], args: ['mouseout.out-zone', ['$event'],] }],
                click: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"], args: ['click.out-zone', ['$event'],] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /** @type {?} */
            var maxPadding = padding;
            // center text in center of div managing padding and overflow depending on size
            var NtCenterTextComponent = /** @class */ (function () {
                /**
                 * @param {?} cd
                 */
                function NtCenterTextComponent(cd) {
                    this.cd = cd;
                    this.offsetX = 0;
                    this.offsetY = 0;
                    this.lineHeight = lineHeight;
                }
                Object.defineProperty(NtCenterTextComponent.prototype, "height", {
                    // convenience
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.elementView.nativeElement.offsetHeight;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(NtCenterTextComponent.prototype, "width", {
                    // convenience
                    /**
                     * @return {?}
                     */
                    get: function () {
                        return this.elementView.nativeElement.offsetWidth;
                    },
                    enumerable: true,
                    configurable: true
                });
                /**
                 * @return {?}
                 */
                NtCenterTextComponent.prototype.ngOnInit = function () { };
                /**
                 * @return {?}
                 */
                NtCenterTextComponent.prototype.ngAfterViewInit = function () {
                    this.applyPadding();
                    this.cd.detectChanges();
                };
                /**
                 * @return {?}
                 */
                NtCenterTextComponent.prototype.applyPadding = function () {
                    if (this.height < this.lineHeight) {
                        this.lineHeight = this.height;
                        if (this.height < 10) {
                            this.fontSize = this.lineHeight < 8 ? 8 : this.lineHeight;
                        }
                    }
                    else {
                        /** @type {?} */
                        var diff = Math.floor((this.height - this.lineHeight) / 2);
                        this.offsetY = diff < maxPadding ? diff : maxPadding;
                    }
                    if (this.width < 50) {
                        if (this.width > 25) {
                            this.offsetX = 5;
                        }
                        else {
                            this.offsetX = 1;
                        }
                    }
                    else {
                        this.offsetX = maxPadding;
                    }
                    this.widthChild = this.width - this.offsetX * 2;
                    this.heightChild = this.height - this.offsetY * 2;
                    this.textMaxHeight = this.heightChild - (this.heightChild % this.lineHeight);
                };
                return NtCenterTextComponent;
            }());
            NtCenterTextComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-center-text',
                            template: "<div class=\"center-content-container\" #container>\n  <div\n    class=\"center-content-padded\"\n    [style.height]=\"heightChild ? heightChild + 'px' : '100%'\"\n    [style.width]=\"widthChild ? widthChild + 'px' : '100%'\"\n    [style.margin]=\"offsetY + 'px ' + offsetX + 'px'\"\n  >\n    <div\n      class=\"center-content-middle\"\n      [style.fontSize]=\"fontSize ? fontSize + 'px' : 'inherit'\"\n      [style.maxHeight]=\"textMaxHeight ? textMaxHeight + 'px' : '100%'\"\n      [style.lineHeight]=\"lineHeight + 'px'\"\n    >\n      {{ text }}\n    </div>\n  </div>\n</div>\n",
                            changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectionStrategy"].OnPush,
                            styles: [".center-content-container{height:100%;width:100%;pointer-events:none}.center-content-padded{height:100%;width:100%;float:left;position:relative}.center-content-middle{max-height:100%;max-width:100%;position:absolute;margin:auto;top:0;bottom:0;left:0;right:0;width:-webkit-max-content;width:-moz-max-content;width:max-content;height:-webkit-max-content;height:-moz-max-content;height:max-content;overflow:hidden}"]
                        }] }
            ];
            /** @nocollapse */
            NtCenterTextComponent.ctorParameters = function () { return [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ChangeDetectorRef"] }
            ]; };
            NtCenterTextComponent.propDecorators = {
                text: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                lineHeight: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }],
                elementView: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"], args: ['container', { static: false },] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtChangeWorkspaceComponent = /** @class */ (function () {
                function NtChangeWorkspaceComponent() {
                }
                /**
                 * @return {?}
                 */
                NtChangeWorkspaceComponent.prototype.ngOnInit = function () { };
                return NtChangeWorkspaceComponent;
            }());
            NtChangeWorkspaceComponent.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                            selector: 'nt-change-workspace',
                            template: "<div class=\"all-workspace\">\n  <p class=\"title-workspace\">{{ 'mes espaces de travail disponibles' | uppercase }}</p>\n  <div class=\"buttons-workspace\">\n    <div *ngFor=\"let button of buttons\">\n      <button class=\"button-workspace\" mat-icon-button>{{ button }}</button>\n    </div>\n  </div>\n</div>\n",
                            styles: [".all-workspace{max-width:900px;max-height:150px}.title-workspace{text-align:center}.buttons-workspace{display:flex}.button-workspace{margin-right:10px}"]
                        }] }
            ];
            /** @nocollapse */
            NtChangeWorkspaceComponent.ctorParameters = function () { return []; };
            NtChangeWorkspaceComponent.propDecorators = {
                buttons: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"] }]
            };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var CustomEventManager = /** @class */ (function (_super_1) {
                __extends(CustomEventManager, _super_1);
                /**
                 * @param {?} plugins
                 * @param {?} zone
                 */
                function CustomEventManager(plugins, zone) {
                    var _this = _super_1.call(this, plugins, zone) || this;
                    _this.zone = zone;
                    return _this;
                }
                /* tslint:disable */
                /**
                 * @param {?} target
                 * @param {?} eventName
                 * @param {?} handler
                 * @return {?}
                 */
                CustomEventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
                    var _this = this;
                    if (eventName.endsWith('out-zone')) {
                        eventName = eventName.split('.')[0];
                        return this.zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return _super_1.prototype.addGlobalEventListener.call(_this, target, eventName, handler); }));
                    }
                    return _super_1.prototype.addGlobalEventListener.call(this, target, eventName, handler);
                };
                // @ts-ignore
                /**
                 * @param {?} target
                 * @param {?} eventName
                 * @param {?} handler
                 * @return {?}
                 */
                CustomEventManager.prototype.addEventListener = function (target, eventName, handler) {
                    var _this = this;
                    if (eventName.endsWith('out-zone')) {
                        eventName = eventName.split('.')[0];
                        return this.zone.runOutsideAngular(( /**
                         * @return {?}
                         */function () { return _super_1.prototype.addEventListener.call(_this, target, eventName, handler); }));
                    }
                    return _super_1.prototype.addEventListener.call(this, target, eventName, handler);
                };
                return CustomEventManager;
            }(_angular_platform_browser__WEBPACK_IMPORTED_MODULE_16__["EventManager"]));
            CustomEventManager.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
            ];
            /** @nocollapse */
            CustomEventManager.ctorParameters = function () { return [
                { type: Array, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_16__["EVENT_MANAGER_PLUGINS"],] }] },
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgZone"] }
            ]; };
            if (false) { }
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            var NtCoreModule = /** @class */ (function () {
                function NtCoreModule() {
                }
                /**
                 * @param {?} config
                 * @return {?}
                 */
                NtCoreModule.forRoot = function (config) {
                    return {
                        ngModule: NtCoreModule,
                        providers: [
                            {
                                provide: 'NtCoreConfig',
                                useValue: config,
                            },
                        ],
                    };
                };
                return NtCoreModule;
            }());
            NtCoreModule.decorators = [
                { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                            declarations: [
                                // COMPONENT
                                NtImageProfileComponent,
                                NtNotificationComponent,
                                NtPaginatorComponent,
                                NtRightClickMenuComponent,
                                NtSidebarInfo90Component,
                                NtSidebarLargeComponent,
                                NtSidebarProfileComponent,
                                NtSidebarSmallComponent,
                                NtSwitcherComponent,
                                NtTableDisplayComponent,
                                NtToolbarComponent,
                                NtCenterTextComponent,
                                // DIRECTIVE
                                NtTooltipDirective,
                                NtTooltipComponent,
                                NtRightClickMenuDirective,
                                // PIPES
                                NtTranslatePipe,
                                ColumnsNamePipe,
                                NotificationIconPipe,
                                NotificationNamePipe,
                                NtChangeWorkspaceComponent,
                            ],
                            imports: [
                                _angular_common__WEBPACK_IMPORTED_MODULE_1__["CommonModule"],
                                _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatButtonModule"],
                                _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatToolbarModule"],
                                _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_3__["MatTooltipModule"],
                                _angular_material_select__WEBPACK_IMPORTED_MODULE_4__["MatSelectModule"],
                                _angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__["MatPaginatorModule"],
                                _angular_cdk_drag_drop__WEBPACK_IMPORTED_MODULE_6__["DragDropModule"],
                                _angular_material_list__WEBPACK_IMPORTED_MODULE_7__["MatListModule"],
                                _angular_router__WEBPACK_IMPORTED_MODULE_8__["RouterModule"],
                                _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_9__["MatSidenavModule"],
                                _angular_material_menu__WEBPACK_IMPORTED_MODULE_10__["MatMenuModule"],
                                _angular_material_badge__WEBPACK_IMPORTED_MODULE_11__["MatBadgeModule"],
                            ],
                            providers: [{ provide: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_16__["EventManager"], useClass: CustomEventManager }],
                            exports: [
                                NtImageProfileComponent,
                                NtNotificationComponent,
                                NtPaginatorComponent,
                                NtSidebarInfo90Component,
                                NtSidebarLargeComponent,
                                NtSidebarProfileComponent,
                                NtSidebarSmallComponent,
                                NtSwitcherComponent,
                                NtTableDisplayComponent,
                                NtToolbarComponent,
                                NtCenterTextComponent,
                                // DIRECTIVE
                                NtTooltipDirective,
                                NtTooltipComponent,
                                NtRightClickMenuDirective,
                                NtRightClickMenuComponent,
                                // PIPES
                                NtTranslatePipe,
                                ColumnsNamePipe,
                                NotificationIconPipe,
                                NotificationNamePipe,
                            ],
                            entryComponents: [NtTooltipComponent, NtRightClickMenuComponent],
                        },] }
            ];
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            /**
             * @fileoverview added by tsickle
             * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
             */
            //# sourceMappingURL=nt-tech-nt-core.js.map
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js ***!
          \*****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addLeadingZeros; });
            function addLeadingZeros(number, targetLength) {
                var sign = number < 0 ? '-' : '';
                var output = Math.abs(number).toString();
                while (output.length < targetLength) {
                    output = '0' + output;
                }
                return sign + output;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/assign/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/assign/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return assign; });
            function assign(target, dirtyObject) {
                if (target == null) {
                    throw new TypeError('assign requires that input parameter not be null or undefined');
                }
                dirtyObject = dirtyObject || {};
                for (var property in dirtyObject) {
                    if (dirtyObject.hasOwnProperty(property)) {
                        target[property] = dirtyObject[property];
                    }
                }
                return target;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/cloneObject/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/cloneObject/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return cloneObject; });
            /* harmony import */ var _assign_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../assign/index.js */ "./node_modules/date-fns/esm/_lib/assign/index.js");
            function cloneObject(dirtyObject) {
                return Object(_assign_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({}, dirtyObject);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/format/formatters/index.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/format/formatters/index.js ***!
          \*******************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lightFormatters/index.js */ "./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js");
            /* harmony import */ var _lib_getUTCDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../_lib/getUTCDayOfYear/index.js */ "./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js");
            /* harmony import */ var _lib_getUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../_lib/getUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js");
            /* harmony import */ var _lib_getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../_lib/getUTCISOWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js");
            /* harmony import */ var _lib_getUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../_lib/getUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/getUTCWeek/index.js");
            /* harmony import */ var _lib_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../_lib/getUTCWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js");
            /* harmony import */ var _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../addLeadingZeros/index.js */ "./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js");
            var dayPeriodEnum = {
                am: 'am',
                pm: 'pm',
                midnight: 'midnight',
                noon: 'noon',
                morning: 'morning',
                afternoon: 'afternoon',
                evening: 'evening',
                night: 'night'
                /*
                 * |     | Unit                           |     | Unit                           |
                 * |-----|--------------------------------|-----|--------------------------------|
                 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
                 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
                 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
                 * |  d  | Day of month                   |  D  | Day of year                    |
                 * |  e  | Local day of week              |  E  | Day of week                    |
                 * |  f  |                                |  F* | Day of week in month           |
                 * |  g* | Modified Julian day            |  G  | Era                            |
                 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
                 * |  i! | ISO day of week                |  I! | ISO week of year               |
                 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
                 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
                 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
                 * |  m  | Minute                         |  M  | Month                          |
                 * |  n  |                                |  N  |                                |
                 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
                 * |  p! | Long localized time            |  P! | Long localized date            |
                 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
                 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
                 * |  s  | Second                         |  S  | Fraction of second             |
                 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
                 * |  u  | Extended year                  |  U* | Cyclic year                    |
                 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
                 * |  w  | Local week of year             |  W* | Week of month                  |
                 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
                 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
                 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
                 *
                 * Letters marked by * are not implemented but reserved by Unicode standard.
                 *
                 * Letters marked by ! are non-standard, but implemented by date-fns:
                 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
                 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
                 *   i.e. 7 for Sunday, 1 for Monday, etc.
                 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
                 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
                 *   `R` is supposed to be used in conjunction with `I` and `i`
                 *   for universal ISO week-numbering date, whereas
                 *   `Y` is supposed to be used in conjunction with `w` and `e`
                 *   for week-numbering date specific to the locale.
                 * - `P` is long localized date format
                 * - `p` is long localized time format
                 */
            };
            var formatters = {
                // Era
                G: function (date, token, localize) {
                    var era = date.getUTCFullYear() > 0 ? 1 : 0;
                    switch (token) {
                        // AD, BC
                        case 'G':
                        case 'GG':
                        case 'GGG':
                            return localize.era(era, {
                                width: 'abbreviated'
                            });
                        // A, B
                        case 'GGGGG':
                            return localize.era(era, {
                                width: 'narrow'
                            });
                        // Anno Domini, Before Christ
                        case 'GGGG':
                        default:
                            return localize.era(era, {
                                width: 'wide'
                            });
                    }
                },
                // Year
                y: function (date, token, localize) {
                    // Ordinal number
                    if (token === 'yo') {
                        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
                        var year = signedYear > 0 ? signedYear : 1 - signedYear;
                        return localize.ordinalNumber(year, {
                            unit: 'year'
                        });
                    }
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].y(date, token);
                },
                // Local week-numbering year
                Y: function (date, token, localize, options) {
                    var signedWeekYear = Object(_lib_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
                    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
                    if (token === 'YY') {
                        var twoDigitYear = weekYear % 100;
                        return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(twoDigitYear, 2);
                    } // Ordinal number
                    if (token === 'Yo') {
                        return localize.ordinalNumber(weekYear, {
                            unit: 'year'
                        });
                    } // Padding
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(weekYear, token.length);
                },
                // ISO week-numbering year
                R: function (date, token) {
                    var isoWeekYear = Object(_lib_getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date); // Padding
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(isoWeekYear, token.length);
                },
                // Extended year. This is a single number designating the year of this calendar system.
                // The main difference between `y` and `u` localizers are B.C. years:
                // | Year | `y` | `u` |
                // |------|-----|-----|
                // | AC 1 |   1 |   1 |
                // | BC 1 |   1 |   0 |
                // | BC 2 |   2 |  -1 |
                // Also `yy` always returns the last two digits of a year,
                // while `uu` pads single digit years to 2 characters and returns other years unchanged.
                u: function (date, token) {
                    var year = date.getUTCFullYear();
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(year, token.length);
                },
                // Quarter
                Q: function (date, token, localize) {
                    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
                    switch (token) {
                        // 1, 2, 3, 4
                        case 'Q':
                            return String(quarter);
                        // 01, 02, 03, 04
                        case 'QQ':
                            return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(quarter, 2);
                        // 1st, 2nd, 3rd, 4th
                        case 'Qo':
                            return localize.ordinalNumber(quarter, {
                                unit: 'quarter'
                            });
                        // Q1, Q2, Q3, Q4
                        case 'QQQ':
                            return localize.quarter(quarter, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                        case 'QQQQQ':
                            return localize.quarter(quarter, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        // 1st quarter, 2nd quarter, ...
                        case 'QQQQ':
                        default:
                            return localize.quarter(quarter, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // Stand-alone quarter
                q: function (date, token, localize) {
                    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
                    switch (token) {
                        // 1, 2, 3, 4
                        case 'q':
                            return String(quarter);
                        // 01, 02, 03, 04
                        case 'qq':
                            return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(quarter, 2);
                        // 1st, 2nd, 3rd, 4th
                        case 'qo':
                            return localize.ordinalNumber(quarter, {
                                unit: 'quarter'
                            });
                        // Q1, Q2, Q3, Q4
                        case 'qqq':
                            return localize.quarter(quarter, {
                                width: 'abbreviated',
                                context: 'standalone'
                            });
                        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                        case 'qqqqq':
                            return localize.quarter(quarter, {
                                width: 'narrow',
                                context: 'standalone'
                            });
                        // 1st quarter, 2nd quarter, ...
                        case 'qqqq':
                        default:
                            return localize.quarter(quarter, {
                                width: 'wide',
                                context: 'standalone'
                            });
                    }
                },
                // Month
                M: function (date, token, localize) {
                    var month = date.getUTCMonth();
                    switch (token) {
                        case 'M':
                        case 'MM':
                            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].M(date, token);
                        // 1st, 2nd, ..., 12th
                        case 'Mo':
                            return localize.ordinalNumber(month + 1, {
                                unit: 'month'
                            });
                        // Jan, Feb, ..., Dec
                        case 'MMM':
                            return localize.month(month, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        // J, F, ..., D
                        case 'MMMMM':
                            return localize.month(month, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        // January, February, ..., December
                        case 'MMMM':
                        default:
                            return localize.month(month, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // Stand-alone month
                L: function (date, token, localize) {
                    var month = date.getUTCMonth();
                    switch (token) {
                        // 1, 2, ..., 12
                        case 'L':
                            return String(month + 1);
                        // 01, 02, ..., 12
                        case 'LL':
                            return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(month + 1, 2);
                        // 1st, 2nd, ..., 12th
                        case 'Lo':
                            return localize.ordinalNumber(month + 1, {
                                unit: 'month'
                            });
                        // Jan, Feb, ..., Dec
                        case 'LLL':
                            return localize.month(month, {
                                width: 'abbreviated',
                                context: 'standalone'
                            });
                        // J, F, ..., D
                        case 'LLLLL':
                            return localize.month(month, {
                                width: 'narrow',
                                context: 'standalone'
                            });
                        // January, February, ..., December
                        case 'LLLL':
                        default:
                            return localize.month(month, {
                                width: 'wide',
                                context: 'standalone'
                            });
                    }
                },
                // Local week of year
                w: function (date, token, localize, options) {
                    var week = Object(_lib_getUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(date, options);
                    if (token === 'wo') {
                        return localize.ordinalNumber(week, {
                            unit: 'week'
                        });
                    }
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(week, token.length);
                },
                // ISO week of year
                I: function (date, token, localize) {
                    var isoWeek = Object(_lib_getUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date);
                    if (token === 'Io') {
                        return localize.ordinalNumber(isoWeek, {
                            unit: 'week'
                        });
                    }
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(isoWeek, token.length);
                },
                // Day of the month
                d: function (date, token, localize) {
                    if (token === 'do') {
                        return localize.ordinalNumber(date.getUTCDate(), {
                            unit: 'date'
                        });
                    }
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].d(date, token);
                },
                // Day of year
                D: function (date, token, localize) {
                    var dayOfYear = Object(_lib_getUTCDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date);
                    if (token === 'Do') {
                        return localize.ordinalNumber(dayOfYear, {
                            unit: 'dayOfYear'
                        });
                    }
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(dayOfYear, token.length);
                },
                // Day of week
                E: function (date, token, localize) {
                    var dayOfWeek = date.getUTCDay();
                    switch (token) {
                        // Tue
                        case 'E':
                        case 'EE':
                        case 'EEE':
                            return localize.day(dayOfWeek, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        // T
                        case 'EEEEE':
                            return localize.day(dayOfWeek, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        // Tu
                        case 'EEEEEE':
                            return localize.day(dayOfWeek, {
                                width: 'short',
                                context: 'formatting'
                            });
                        // Tuesday
                        case 'EEEE':
                        default:
                            return localize.day(dayOfWeek, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // Local day of week
                e: function (date, token, localize, options) {
                    var dayOfWeek = date.getUTCDay();
                    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
                    switch (token) {
                        // Numerical value (Nth day of week with current locale or weekStartsOn)
                        case 'e':
                            return String(localDayOfWeek);
                        // Padded numerical value
                        case 'ee':
                            return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(localDayOfWeek, 2);
                        // 1st, 2nd, ..., 7th
                        case 'eo':
                            return localize.ordinalNumber(localDayOfWeek, {
                                unit: 'day'
                            });
                        case 'eee':
                            return localize.day(dayOfWeek, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        // T
                        case 'eeeee':
                            return localize.day(dayOfWeek, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        // Tu
                        case 'eeeeee':
                            return localize.day(dayOfWeek, {
                                width: 'short',
                                context: 'formatting'
                            });
                        // Tuesday
                        case 'eeee':
                        default:
                            return localize.day(dayOfWeek, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // Stand-alone local day of week
                c: function (date, token, localize, options) {
                    var dayOfWeek = date.getUTCDay();
                    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
                    switch (token) {
                        // Numerical value (same as in `e`)
                        case 'c':
                            return String(localDayOfWeek);
                        // Padded numerical value
                        case 'cc':
                            return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(localDayOfWeek, token.length);
                        // 1st, 2nd, ..., 7th
                        case 'co':
                            return localize.ordinalNumber(localDayOfWeek, {
                                unit: 'day'
                            });
                        case 'ccc':
                            return localize.day(dayOfWeek, {
                                width: 'abbreviated',
                                context: 'standalone'
                            });
                        // T
                        case 'ccccc':
                            return localize.day(dayOfWeek, {
                                width: 'narrow',
                                context: 'standalone'
                            });
                        // Tu
                        case 'cccccc':
                            return localize.day(dayOfWeek, {
                                width: 'short',
                                context: 'standalone'
                            });
                        // Tuesday
                        case 'cccc':
                        default:
                            return localize.day(dayOfWeek, {
                                width: 'wide',
                                context: 'standalone'
                            });
                    }
                },
                // ISO day of week
                i: function (date, token, localize) {
                    var dayOfWeek = date.getUTCDay();
                    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
                    switch (token) {
                        // 2
                        case 'i':
                            return String(isoDayOfWeek);
                        // 02
                        case 'ii':
                            return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(isoDayOfWeek, token.length);
                        // 2nd
                        case 'io':
                            return localize.ordinalNumber(isoDayOfWeek, {
                                unit: 'day'
                            });
                        // Tue
                        case 'iii':
                            return localize.day(dayOfWeek, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        // T
                        case 'iiiii':
                            return localize.day(dayOfWeek, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        // Tu
                        case 'iiiiii':
                            return localize.day(dayOfWeek, {
                                width: 'short',
                                context: 'formatting'
                            });
                        // Tuesday
                        case 'iiii':
                        default:
                            return localize.day(dayOfWeek, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // AM or PM
                a: function (date, token, localize) {
                    var hours = date.getUTCHours();
                    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
                    switch (token) {
                        case 'a':
                        case 'aa':
                        case 'aaa':
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        case 'aaaaa':
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        case 'aaaa':
                        default:
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // AM, PM, midnight, noon
                b: function (date, token, localize) {
                    var hours = date.getUTCHours();
                    var dayPeriodEnumValue;
                    if (hours === 12) {
                        dayPeriodEnumValue = dayPeriodEnum.noon;
                    }
                    else if (hours === 0) {
                        dayPeriodEnumValue = dayPeriodEnum.midnight;
                    }
                    else {
                        dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
                    }
                    switch (token) {
                        case 'b':
                        case 'bb':
                        case 'bbb':
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        case 'bbbbb':
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        case 'bbbb':
                        default:
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // in the morning, in the afternoon, in the evening, at night
                B: function (date, token, localize) {
                    var hours = date.getUTCHours();
                    var dayPeriodEnumValue;
                    if (hours >= 17) {
                        dayPeriodEnumValue = dayPeriodEnum.evening;
                    }
                    else if (hours >= 12) {
                        dayPeriodEnumValue = dayPeriodEnum.afternoon;
                    }
                    else if (hours >= 4) {
                        dayPeriodEnumValue = dayPeriodEnum.morning;
                    }
                    else {
                        dayPeriodEnumValue = dayPeriodEnum.night;
                    }
                    switch (token) {
                        case 'B':
                        case 'BB':
                        case 'BBB':
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'abbreviated',
                                context: 'formatting'
                            });
                        case 'BBBBB':
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'narrow',
                                context: 'formatting'
                            });
                        case 'BBBB':
                        default:
                            return localize.dayPeriod(dayPeriodEnumValue, {
                                width: 'wide',
                                context: 'formatting'
                            });
                    }
                },
                // Hour [1-12]
                h: function (date, token, localize) {
                    if (token === 'ho') {
                        var hours = date.getUTCHours() % 12;
                        if (hours === 0)
                            hours = 12;
                        return localize.ordinalNumber(hours, {
                            unit: 'hour'
                        });
                    }
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].h(date, token);
                },
                // Hour [0-23]
                H: function (date, token, localize) {
                    if (token === 'Ho') {
                        return localize.ordinalNumber(date.getUTCHours(), {
                            unit: 'hour'
                        });
                    }
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].H(date, token);
                },
                // Hour [0-11]
                K: function (date, token, localize) {
                    var hours = date.getUTCHours() % 12;
                    if (token === 'Ko') {
                        return localize.ordinalNumber(hours, {
                            unit: 'hour'
                        });
                    }
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(hours, token.length);
                },
                // Hour [1-24]
                k: function (date, token, localize) {
                    var hours = date.getUTCHours();
                    if (hours === 0)
                        hours = 24;
                    if (token === 'ko') {
                        return localize.ordinalNumber(hours, {
                            unit: 'hour'
                        });
                    }
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(hours, token.length);
                },
                // Minute
                m: function (date, token, localize) {
                    if (token === 'mo') {
                        return localize.ordinalNumber(date.getUTCMinutes(), {
                            unit: 'minute'
                        });
                    }
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].m(date, token);
                },
                // Second
                s: function (date, token, localize) {
                    if (token === 'so') {
                        return localize.ordinalNumber(date.getUTCSeconds(), {
                            unit: 'second'
                        });
                    }
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].s(date, token);
                },
                // Fraction of second
                S: function (date, token) {
                    return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].S(date, token);
                },
                // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
                X: function (date, token, _localize, options) {
                    var originalDate = options._originalDate || date;
                    var timezoneOffset = originalDate.getTimezoneOffset();
                    if (timezoneOffset === 0) {
                        return 'Z';
                    }
                    switch (token) {
                        // Hours and optional minutes
                        case 'X':
                            return formatTimezoneWithOptionalMinutes(timezoneOffset);
                        // Hours, minutes and optional seconds without `:` delimiter
                        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
                        // so this token always has the same output as `XX`
                        case 'XXXX':
                        case 'XX':
                            // Hours and minutes without `:` delimiter
                            return formatTimezone(timezoneOffset);
                        // Hours, minutes and optional seconds with `:` delimiter
                        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
                        // so this token always has the same output as `XXX`
                        case 'XXXXX':
                        case 'XXX': // Hours and minutes with `:` delimiter
                        default:
                            return formatTimezone(timezoneOffset, ':');
                    }
                },
                // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
                x: function (date, token, _localize, options) {
                    var originalDate = options._originalDate || date;
                    var timezoneOffset = originalDate.getTimezoneOffset();
                    switch (token) {
                        // Hours and optional minutes
                        case 'x':
                            return formatTimezoneWithOptionalMinutes(timezoneOffset);
                        // Hours, minutes and optional seconds without `:` delimiter
                        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
                        // so this token always has the same output as `xx`
                        case 'xxxx':
                        case 'xx':
                            // Hours and minutes without `:` delimiter
                            return formatTimezone(timezoneOffset);
                        // Hours, minutes and optional seconds with `:` delimiter
                        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
                        // so this token always has the same output as `xxx`
                        case 'xxxxx':
                        case 'xxx': // Hours and minutes with `:` delimiter
                        default:
                            return formatTimezone(timezoneOffset, ':');
                    }
                },
                // Timezone (GMT)
                O: function (date, token, _localize, options) {
                    var originalDate = options._originalDate || date;
                    var timezoneOffset = originalDate.getTimezoneOffset();
                    switch (token) {
                        // Short
                        case 'O':
                        case 'OO':
                        case 'OOO':
                            return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
                        // Long
                        case 'OOOO':
                        default:
                            return 'GMT' + formatTimezone(timezoneOffset, ':');
                    }
                },
                // Timezone (specific non-location)
                z: function (date, token, _localize, options) {
                    var originalDate = options._originalDate || date;
                    var timezoneOffset = originalDate.getTimezoneOffset();
                    switch (token) {
                        // Short
                        case 'z':
                        case 'zz':
                        case 'zzz':
                            return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
                        // Long
                        case 'zzzz':
                        default:
                            return 'GMT' + formatTimezone(timezoneOffset, ':');
                    }
                },
                // Seconds timestamp
                t: function (date, token, _localize, options) {
                    var originalDate = options._originalDate || date;
                    var timestamp = Math.floor(originalDate.getTime() / 1000);
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(timestamp, token.length);
                },
                // Milliseconds timestamp
                T: function (date, token, _localize, options) {
                    var originalDate = options._originalDate || date;
                    var timestamp = originalDate.getTime();
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(timestamp, token.length);
                }
            };
            function formatTimezoneShort(offset, dirtyDelimiter) {
                var sign = offset > 0 ? '-' : '+';
                var absOffset = Math.abs(offset);
                var hours = Math.floor(absOffset / 60);
                var minutes = absOffset % 60;
                if (minutes === 0) {
                    return sign + String(hours);
                }
                var delimiter = dirtyDelimiter || '';
                return sign + String(hours) + delimiter + Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(minutes, 2);
            }
            function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
                if (offset % 60 === 0) {
                    var sign = offset > 0 ? '-' : '+';
                    return sign + Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(Math.abs(offset) / 60, 2);
                }
                return formatTimezone(offset, dirtyDelimiter);
            }
            function formatTimezone(offset, dirtyDelimiter) {
                var delimiter = dirtyDelimiter || '';
                var sign = offset > 0 ? '-' : '+';
                var absOffset = Math.abs(offset);
                var hours = Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(Math.floor(absOffset / 60), 2);
                var minutes = Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(absOffset % 60, 2);
                return sign + hours + delimiter + minutes;
            }
            /* harmony default export */ __webpack_exports__["default"] = (formatters);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js ***!
          \************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../addLeadingZeros/index.js */ "./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js");
            /*
             * |     | Unit                           |     | Unit                           |
             * |-----|--------------------------------|-----|--------------------------------|
             * |  a  | AM, PM                         |  A* |                                |
             * |  d  | Day of month                   |  D  |                                |
             * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
             * |  m  | Minute                         |  M  | Month                          |
             * |  s  | Second                         |  S  | Fraction of second             |
             * |  y  | Year (abs)                     |  Y  |                                |
             *
             * Letters marked by * are not implemented but reserved by Unicode standard.
             */
            var formatters = {
                // Year
                y: function (date, token) {
                    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
                    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
                    // |----------|-------|----|-------|-------|-------|
                    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
                    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
                    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
                    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
                    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
                    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
                    var year = signedYear > 0 ? signedYear : 1 - signedYear;
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(token === 'yy' ? year % 100 : year, token.length);
                },
                // Month
                M: function (date, token) {
                    var month = date.getUTCMonth();
                    return token === 'M' ? String(month + 1) : Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(month + 1, 2);
                },
                // Day of the month
                d: function (date, token) {
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date.getUTCDate(), token.length);
                },
                // AM or PM
                a: function (date, token) {
                    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
                    switch (token) {
                        case 'a':
                        case 'aa':
                        case 'aaa':
                            return dayPeriodEnumValue.toUpperCase();
                        case 'aaaaa':
                            return dayPeriodEnumValue[0];
                        case 'aaaa':
                        default:
                            return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
                    }
                },
                // Hour [1-12]
                h: function (date, token) {
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date.getUTCHours() % 12 || 12, token.length);
                },
                // Hour [0-23]
                H: function (date, token) {
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date.getUTCHours(), token.length);
                },
                // Minute
                m: function (date, token) {
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date.getUTCMinutes(), token.length);
                },
                // Second
                s: function (date, token) {
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date.getUTCSeconds(), token.length);
                },
                // Fraction of second
                S: function (date, token) {
                    var numberOfDigits = token.length;
                    var milliseconds = date.getUTCMilliseconds();
                    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
                    return Object(_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(fractionalSeconds, token.length);
                }
            };
            /* harmony default export */ __webpack_exports__["default"] = (formatters);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/format/longFormatters/index.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js ***!
          \***********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            function dateLongFormatter(pattern, formatLong) {
                switch (pattern) {
                    case 'P':
                        return formatLong.date({
                            width: 'short'
                        });
                    case 'PP':
                        return formatLong.date({
                            width: 'medium'
                        });
                    case 'PPP':
                        return formatLong.date({
                            width: 'long'
                        });
                    case 'PPPP':
                    default:
                        return formatLong.date({
                            width: 'full'
                        });
                }
            }
            function timeLongFormatter(pattern, formatLong) {
                switch (pattern) {
                    case 'p':
                        return formatLong.time({
                            width: 'short'
                        });
                    case 'pp':
                        return formatLong.time({
                            width: 'medium'
                        });
                    case 'ppp':
                        return formatLong.time({
                            width: 'long'
                        });
                    case 'pppp':
                    default:
                        return formatLong.time({
                            width: 'full'
                        });
                }
            }
            function dateTimeLongFormatter(pattern, formatLong) {
                var matchResult = pattern.match(/(P+)(p+)?/);
                var datePattern = matchResult[1];
                var timePattern = matchResult[2];
                if (!timePattern) {
                    return dateLongFormatter(pattern, formatLong);
                }
                var dateTimeFormat;
                switch (datePattern) {
                    case 'P':
                        dateTimeFormat = formatLong.dateTime({
                            width: 'short'
                        });
                        break;
                    case 'PP':
                        dateTimeFormat = formatLong.dateTime({
                            width: 'medium'
                        });
                        break;
                    case 'PPP':
                        dateTimeFormat = formatLong.dateTime({
                            width: 'long'
                        });
                        break;
                    case 'PPPP':
                    default:
                        dateTimeFormat = formatLong.dateTime({
                            width: 'full'
                        });
                        break;
                }
                return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
            }
            var longFormatters = {
                p: timeLongFormatter,
                P: dateTimeLongFormatter
            };
            /* harmony default export */ __webpack_exports__["default"] = (longFormatters);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js": 
        /*!*********************************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js ***!
          \*********************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getTimezoneOffsetInMilliseconds; });
            var MILLISECONDS_IN_MINUTE = 60000;
            /**
             * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
             * They usually appear for dates that denote time before the timezones were introduced
             * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
             * and GMT+01:00:00 after that date)
             *
             * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
             * which would lead to incorrect calculations.
             *
             * This function returns the timezone offset in milliseconds that takes seconds in account.
             */
            function getTimezoneOffsetInMilliseconds(dirtyDate) {
                var date = new Date(dirtyDate.getTime());
                var baseTimezoneOffset = date.getTimezoneOffset();
                date.setSeconds(0, 0);
                var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
                return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js ***!
          \*****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getUTCDayOfYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function getUTCDayOfYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var timestamp = date.getTime();
                date.setUTCMonth(0, 1);
                date.setUTCHours(0, 0, 0, 0);
                var startOfYearTimestamp = date.getTime();
                var difference = timestamp - startOfYearTimestamp;
                return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getUTCISOWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
            /* harmony import */ var _startOfUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCISOWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js");
            var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function getUTCISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var diff = Object(_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date).getTime() - Object(_startOfUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date).getTime(); // Round the number of days to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js ***!
          \*******************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getUTCISOWeekYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function getUTCISOWeekYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getUTCFullYear();
                var fourthOfJanuaryOfNextYear = new Date(0);
                fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
                fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
                var startOfNextYear = Object(_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuaryOfNextYear);
                var fourthOfJanuaryOfThisYear = new Date(0);
                fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
                fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
                var startOfThisYear = Object(_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuaryOfThisYear);
                if (date.getTime() >= startOfNextYear.getTime()) {
                    return year + 1;
                }
                else if (date.getTime() >= startOfThisYear.getTime()) {
                    return year;
                }
                else {
                    return year - 1;
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/getUTCWeek/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getUTCWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
            /* harmony import */ var _startOfUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js");
            var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function getUTCWeek(dirtyDate, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var diff = Object(_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, options).getTime() - Object(_startOfUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date, options).getTime(); // Round the number of days to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js ***!
          \****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getUTCWeekYear; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function getUTCWeekYear(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, dirtyOptions);
                var year = date.getUTCFullYear();
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
                if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
                    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                }
                var firstWeekOfNextYear = new Date(0);
                firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
                firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
                var startOfNextYear = Object(_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(firstWeekOfNextYear, dirtyOptions);
                var firstWeekOfThisYear = new Date(0);
                firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
                firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
                var startOfThisYear = Object(_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(firstWeekOfThisYear, dirtyOptions);
                if (date.getTime() >= startOfNextYear.getTime()) {
                    return year + 1;
                }
                else if (date.getTime() >= startOfThisYear.getTime()) {
                    return year;
                }
                else {
                    return year - 1;
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/protectedTokens/index.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/protectedTokens/index.js ***!
          \*****************************************************************/
        /*! exports provided: isProtectedDayOfYearToken, isProtectedWeekYearToken, throwProtectedError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProtectedDayOfYearToken", function () { return isProtectedDayOfYearToken; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProtectedWeekYearToken", function () { return isProtectedWeekYearToken; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwProtectedError", function () { return throwProtectedError; });
            var protectedDayOfYearTokens = ['D', 'DD'];
            var protectedWeekYearTokens = ['YY', 'YYYY'];
            function isProtectedDayOfYearToken(token) {
                return protectedDayOfYearTokens.indexOf(token) !== -1;
            }
            function isProtectedWeekYearToken(token) {
                return protectedWeekYearTokens.indexOf(token) !== -1;
            }
            function throwProtectedError(token) {
                if (token === 'YYYY') {
                    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
                }
                else if (token === 'YY') {
                    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
                }
                else if (token === 'D') {
                    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
                }
                else if (token === 'DD') {
                    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/setUTCDay/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/setUTCDay/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setUTCDay; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var day = Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDay);
                var currentDay = date.getUTCDay();
                var remainder = day % 7;
                var dayIndex = (remainder + 7) % 7;
                var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
                date.setUTCDate(date.getUTCDate() + diff);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/setUTCISODay/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setUTCISODay; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function setUTCISODay(dirtyDate, dirtyDay) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var day = Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDay);
                if (day % 7 === 0) {
                    day = day - 7;
                }
                var weekStartsOn = 1;
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var currentDay = date.getUTCDay();
                var remainder = day % 7;
                var dayIndex = (remainder + 7) % 7;
                var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
                date.setUTCDate(date.getUTCDate() + diff);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setUTCISOWeek; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _getUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../getUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var isoWeek = Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyISOWeek);
                var diff = Object(_getUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date) - isoWeek;
                date.setUTCDate(date.getUTCDate() - diff * 7);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/setUTCWeek/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setUTCWeek; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _getUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../getUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/getUTCWeek/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function setUTCWeek(dirtyDate, dirtyWeek, options) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var week = Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyWeek);
                var diff = Object(_getUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date, options) - week;
                date.setUTCDate(date.getUTCDate() - diff * 7);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js ***!
          \*******************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfUTCISOWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function startOfUTCISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var weekStartsOn = 1;
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getUTCDay();
                var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
                date.setUTCDate(date.getUTCDate() - diff);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js ***!
          \***********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfUTCISOWeekYear; });
            /* harmony import */ var _getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getUTCISOWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js");
            /* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function startOfUTCISOWeekYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var year = Object(_getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var fourthOfJanuary = new Date(0);
                fourthOfJanuary.setUTCFullYear(year, 0, 4);
                fourthOfJanuary.setUTCHours(0, 0, 0, 0);
                var date = Object(_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuary);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js ***!
          \****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfUTCWeek; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function startOfUTCWeek(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var day = date.getUTCDay();
                var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
                date.setUTCDate(date.getUTCDate() - diff);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js ***!
          \********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfUTCWeekYear; });
            /* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../getUTCWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js");
            /* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
            // This function will be a part of public API when UTC function will be implemented.
            // See issue: https://github.com/date-fns/date-fns/issues/376
            function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(options.firstWeekContainsDate);
                var year = Object(_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, dirtyOptions);
                var firstWeek = new Date(0);
                firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
                firstWeek.setUTCHours(0, 0, 0, 0);
                var date = Object(_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(firstWeek, dirtyOptions);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/_lib/toInteger/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/_lib/toInteger/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return toInteger; });
            function toInteger(dirtyNumber) {
                if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
                    return NaN;
                }
                var number = Number(dirtyNumber);
                if (isNaN(number)) {
                    return number;
                }
                return number < 0 ? Math.ceil(number) : Math.floor(number);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addBusinessDays/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/addBusinessDays/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addBusinessDays; });
            /* harmony import */ var _isWeekend_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isWeekend/index.js */ "./node_modules/date-fns/esm/isWeekend/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name addBusinessDays
             * @category Day Helpers
             * @summary Add the specified number of business days (mon - fri) to the given date.
             *
             * @description
             * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of business days to be added
             * @returns {Date} the new date with the business days added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 10 business days to 1 September 2014:
             * var result = addBusinessDays(new Date(2014, 8, 1), 10)
             * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
             */
            function addBusinessDays(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyAmount);
                if (isNaN(amount))
                    return new Date(NaN);
                var hours = date.getHours();
                var sign = amount < 0 ? -1 : 1;
                date.setDate(date.getDate() + Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(amount / 5) * 7);
                amount %= 5; // to get remaining days not part of a full week
                var shiftSize = Math.abs(amount); // only loops over remaining days or if day is a weekend, ensures a business day is returned
                while (shiftSize > 0 || Object(_isWeekend_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date)) {
                    if (!Object(_isWeekend_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date))
                        shiftSize -= 1;
                    date.setDate(date.getDate() + sign);
                }
                date.setHours(hours);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addDays/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/addDays/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addDays; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name addDays
             * @category Day Helpers
             * @summary Add the specified number of days to the given date.
             *
             * @description
             * Add the specified number of days to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of days to be added
             * @returns {Date} the new date with the days added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 10 days to 1 September 2014:
             * var result = addDays(new Date(2014, 8, 1), 10)
             * //=> Thu Sep 11 2014 00:00:00
             */
            function addDays(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                date.setDate(date.getDate() + amount);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addHours/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/addHours/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addHours; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMilliseconds/index.js */ "./node_modules/date-fns/esm/addMilliseconds/index.js");
            var MILLISECONDS_IN_HOUR = 3600000;
            /**
             * @name addHours
             * @category Hour Helpers
             * @summary Add the specified number of hours to the given date.
             *
             * @description
             * Add the specified number of hours to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of hours to be added
             * @returns {Date} the new date with the hours added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 2 hours to 10 July 2014 23:00:00:
             * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
             * //=> Fri Jul 11 2014 01:00:00
             */
            function addHours(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addISOWeekYears/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/addISOWeekYears/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addISOWeekYears; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../getISOWeekYear/index.js */ "./node_modules/date-fns/esm/getISOWeekYear/index.js");
            /* harmony import */ var _setISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../setISOWeekYear/index.js */ "./node_modules/date-fns/esm/setISOWeekYear/index.js");
            /**
             * @name addISOWeekYears
             * @category ISO Week-Numbering Year Helpers
             * @summary Add the specified number of ISO week-numbering years to the given date.
             *
             * @description
             * Add the specified number of ISO week-numbering years to the given date.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `addISOYears` to `addISOWeekYears`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of ISO week-numbering years to be added
             * @returns {Date} the new date with the ISO week-numbering years added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 5 ISO week-numbering years to 2 July 2010:
             * var result = addISOWeekYears(new Date(2010, 6, 2), 5)
             * //=> Fri Jun 26 2015 00:00:00
             */
            function addISOWeekYears(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_setISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, Object(_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate) + amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addMilliseconds/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/addMilliseconds/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addMilliseconds; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name addMilliseconds
             * @category Millisecond Helpers
             * @summary Add the specified number of milliseconds to the given date.
             *
             * @description
             * Add the specified number of milliseconds to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of milliseconds to be added
             * @returns {Date} the new date with the milliseconds added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
             * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
             * //=> Thu Jul 10 2014 12:45:30.750
             */
            function addMilliseconds(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var timestamp = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return new Date(timestamp + amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addMinutes/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/addMinutes/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addMinutes; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMilliseconds/index.js */ "./node_modules/date-fns/esm/addMilliseconds/index.js");
            var MILLISECONDS_IN_MINUTE = 60000;
            /**
             * @name addMinutes
             * @category Minute Helpers
             * @summary Add the specified number of minutes to the given date.
             *
             * @description
             * Add the specified number of minutes to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of minutes to be added
             * @returns {Date} the new date with the minutes added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 30 minutes to 10 July 2014 12:00:00:
             * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
             * //=> Thu Jul 10 2014 12:30:00
             */
            function addMinutes(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addMonths/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/addMonths/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addMonths; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../getDaysInMonth/index.js */ "./node_modules/date-fns/esm/getDaysInMonth/index.js");
            /**
             * @name addMonths
             * @category Month Helpers
             * @summary Add the specified number of months to the given date.
             *
             * @description
             * Add the specified number of months to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of months to be added
             * @returns {Date} the new date with the months added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 5 months to 1 September 2014:
             * var result = addMonths(new Date(2014, 8, 1), 5)
             * //=> Sun Feb 01 2015 00:00:00
             */
            function addMonths(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                var desiredMonth = date.getMonth() + amount;
                var dateWithDesiredMonth = new Date(0);
                dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
                dateWithDesiredMonth.setHours(0, 0, 0, 0);
                var daysInMonth = Object(_getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateWithDesiredMonth); // Set the last day of the new month
                // if the original date was the last day of the longer month
                date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addQuarters/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/addQuarters/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addQuarters; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMonths/index.js */ "./node_modules/date-fns/esm/addMonths/index.js");
            /**
             * @name addQuarters
             * @category Quarter Helpers
             * @summary Add the specified number of year quarters to the given date.
             *
             * @description
             * Add the specified number of year quarters to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of quarters to be added
             * @returns {Date} the new date with the quarters added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 1 quarter to 1 September 2014:
             * var result = addQuarters(new Date(2014, 8, 1), 1)
             * //=> Mon Dec 01 2014 00:00:00
             */
            function addQuarters(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                var months = amount * 3;
                return Object(_addMonths_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, months);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addSeconds/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/addSeconds/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addSeconds; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMilliseconds/index.js */ "./node_modules/date-fns/esm/addMilliseconds/index.js");
            /**
             * @name addSeconds
             * @category Second Helpers
             * @summary Add the specified number of seconds to the given date.
             *
             * @description
             * Add the specified number of seconds to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of seconds to be added
             * @returns {Date} the new date with the seconds added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 30 seconds to 10 July 2014 12:45:00:
             * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
             * //=> Thu Jul 10 2014 12:45:30
             */
            function addSeconds(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, amount * 1000);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addWeeks/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/addWeeks/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addWeeks; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /**
             * @name addWeeks
             * @category Week Helpers
             * @summary Add the specified number of weeks to the given date.
             *
             * @description
             * Add the specified number of week to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of weeks to be added
             * @returns {Date} the new date with the weeks added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 4 weeks to 1 September 2014:
             * var result = addWeeks(new Date(2014, 8, 1), 4)
             * //=> Mon Sep 29 2014 00:00:00
             */
            function addWeeks(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                var days = amount * 7;
                return Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, days);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/addYears/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/addYears/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return addYears; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMonths/index.js */ "./node_modules/date-fns/esm/addMonths/index.js");
            /**
             * @name addYears
             * @category Year Helpers
             * @summary Add the specified number of years to the given date.
             *
             * @description
             * Add the specified number of years to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of years to be added
             * @returns {Date} the new date with the years added
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Add 5 years to 1 September 2014:
             * var result = addYears(new Date(2014, 8, 1), 5)
             * //=> Sun Sep 01 2019 00:00:00
             */
            function addYears(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMonths_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, amount * 12);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/areIntervalsOverlapping/index.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/date-fns/esm/areIntervalsOverlapping/index.js ***!
          \********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return areIntervalsOverlapping; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name areIntervalsOverlapping
             * @category Interval Helpers
             * @summary Is the given time interval overlapping with another time interval?
             *
             * @description
             * Is the given time interval overlapping with another time interval?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
             *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
             *
             *   ```
             *   2.1.3
             *   time interval
             *   part of the time axis limited by two instants
             *   ```
             *
             *   Also, this function now accepts an object with `start` and `end` properties
             *   instead of two arguments as an interval.
             *   This function now throws `RangeError` if the start of the interval is after its end
             *   or if any date in the interval is `Invalid Date`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   areRangesOverlapping(
             *     new Date(2014, 0, 10), new Date(2014, 0, 20),
             *     new Date(2014, 0, 17), new Date(2014, 0, 21)
             *   )
             *
             *   // v2.0.0 onward
             *
             *   areIntervalsOverlapping(
             *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
             *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
             *   )
             *   ```
             *
             * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
             * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
             * @returns {Boolean} whether the time intervals are overlapping
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} The start of an interval cannot be after its end
             * @throws {RangeError} Date in interval cannot be `Invalid Date`
             *
             * @example
             * // For overlapping time intervals:
             * areIntervalsOverlapping(
             *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
             *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
             * )
             * //=> true
             *
             * @example
             * // For non-overlapping time intervals:
             * areIntervalsOverlapping(
             *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
             *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
             * )
             * //=> false
             */
            function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var intervalLeft = dirtyIntervalLeft || {};
                var intervalRight = dirtyIntervalRight || {};
                var leftStartTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalLeft.start).getTime();
                var leftEndTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalLeft.end).getTime();
                var rightStartTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalRight.start).getTime();
                var rightEndTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
                if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
                    throw new RangeError('Invalid interval');
                }
                return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/closestIndexTo/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/closestIndexTo/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return closestIndexTo; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name closestIndexTo
             * @category Common Helpers
             * @summary Return an index of the closest date from the array comparing to the given date.
             *
             * @description
             * Return an index of the closest date from the array comparing to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - Now, `closestIndexTo` doesn't throw an exception
             *   when the second argument is not an array, and returns Invalid Date instead.
             *
             * @param {Date|Number} dateToCompare - the date to compare with
             * @param {Date[]|Number[]} datesArray - the array to search
             * @returns {Number} an index of the date closest to the given date
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Which date is closer to 6 September 2015?
             * var dateToCompare = new Date(2015, 8, 6)
             * var datesArray = [
             *   new Date(2015, 0, 1),
             *   new Date(2016, 0, 1),
             *   new Date(2017, 0, 1)
             * ]
             * var result = closestIndexTo(dateToCompare, datesArray)
             * //=> 1
             */
            function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateToCompare = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateToCompare);
                if (isNaN(dateToCompare)) {
                    return NaN;
                }
                var timeToCompare = dateToCompare.getTime();
                var datesArray; // `dirtyDatesArray` is undefined or null
                if (dirtyDatesArray == null) {
                    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
                }
                else if (typeof dirtyDatesArray.forEach === 'function') {
                    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
                }
                else {
                    datesArray = Array.prototype.slice.call(dirtyDatesArray);
                }
                var result;
                var minDistance;
                datesArray.forEach(function (dirtyDate, index) {
                    var currentDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                    if (isNaN(currentDate)) {
                        result = NaN;
                        minDistance = NaN;
                        return;
                    }
                    var distance = Math.abs(timeToCompare - currentDate.getTime());
                    if (result == null || distance < minDistance) {
                        result = index;
                        minDistance = distance;
                    }
                });
                return result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/closestTo/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/closestTo/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return closestTo; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name closestTo
             * @category Common Helpers
             * @summary Return a date from the array closest to the given date.
             *
             * @description
             * Return a date from the array closest to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - Now, `closestTo` doesn't throw an exception
             *   when the second argument is not an array, and returns Invalid Date instead.
             *
             * @param {Date|Number} dateToCompare - the date to compare with
             * @param {Date[]|Number[]} datesArray - the array to search
             * @returns {Date} the date from the array closest to the given date
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
             * var dateToCompare = new Date(2015, 8, 6)
             * var result = closestTo(dateToCompare, [
             *   new Date(2000, 0, 1),
             *   new Date(2030, 0, 1)
             * ])
             * //=> Tue Jan 01 2030 00:00:00
             */
            function closestTo(dirtyDateToCompare, dirtyDatesArray) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateToCompare = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateToCompare);
                if (isNaN(dateToCompare)) {
                    return new Date(NaN);
                }
                var timeToCompare = dateToCompare.getTime();
                var datesArray; // `dirtyDatesArray` is undefined or null
                if (dirtyDatesArray == null) {
                    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
                }
                else if (typeof dirtyDatesArray.forEach === 'function') {
                    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
                }
                else {
                    datesArray = Array.prototype.slice.call(dirtyDatesArray);
                }
                var result;
                var minDistance;
                datesArray.forEach(function (dirtyDate) {
                    var currentDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                    if (isNaN(currentDate)) {
                        result = new Date(NaN);
                        minDistance = NaN;
                        return;
                    }
                    var distance = Math.abs(timeToCompare - currentDate.getTime());
                    if (result == null || distance < minDistance) {
                        result = currentDate;
                        minDistance = distance;
                    }
                });
                return result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/compareAsc/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/compareAsc/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return compareAsc; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name compareAsc
             * @category Common Helpers
             * @summary Compare the two dates and return -1, 0 or 1.
             *
             * @description
             * Compare the two dates and return 1 if the first date is after the second,
             * -1 if the first date is before the second or 0 if dates are equal.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to compare
             * @param {Date|Number} dateRight - the second date to compare
             * @returns {Number} the result of the comparison
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Compare 11 February 1987 and 10 July 1989:
             * var result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
             * //=> -1
             *
             * @example
             * // Sort the array of dates:
             * var result = [
             *   new Date(1995, 6, 2),
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * ].sort(compareAsc)
             * //=> [
             * //   Wed Feb 11 1987 00:00:00,
             * //   Mon Jul 10 1989 00:00:00,
             * //   Sun Jul 02 1995 00:00:00
             * // ]
             */
            function compareAsc(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var diff = dateLeft.getTime() - dateRight.getTime();
                if (diff < 0) {
                    return -1;
                }
                else if (diff > 0) {
                    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
                }
                else {
                    return diff;
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/compareDesc/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/compareDesc/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return compareDesc; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name compareDesc
             * @category Common Helpers
             * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
             *
             * @description
             * Compare the two dates and return -1 if the first date is after the second,
             * 1 if the first date is before the second or 0 if dates are equal.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to compare
             * @param {Date|Number} dateRight - the second date to compare
             * @returns {Number} the result of the comparison
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
             * var result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
             * //=> 1
             *
             * @example
             * // Sort the array of dates in reverse chronological order:
             * var result = [
             *   new Date(1995, 6, 2),
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * ].sort(compareDesc)
             * //=> [
             * //   Sun Jul 02 1995 00:00:00,
             * //   Mon Jul 10 1989 00:00:00,
             * //   Wed Feb 11 1987 00:00:00
             * // ]
             */
            function compareDesc(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var diff = dateLeft.getTime() - dateRight.getTime();
                if (diff > 0) {
                    return -1;
                }
                else if (diff < 0) {
                    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
                }
                else {
                    return diff;
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/constants/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/constants/index.js ***!
          \******************************************************/
        /*! exports provided: maxTime, minTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxTime", function () { return maxTime; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minTime", function () { return minTime; });
            /**
             *  Maximum allowed time.
             *  @constant
             *  @type {number}
             *  @default
             */
            var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
            /**
             *  Minimum allowed time.
             *  @constant
             *  @type {number}
             *  @default
             */
            var minTime = -maxTime;
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInBusinessDays/index.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInBusinessDays/index.js ***!
          \*********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInBusinessDays; });
            /* harmony import */ var _isValid_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isValid/index.js */ "./node_modules/date-fns/esm/isValid/index.js");
            /* harmony import */ var _isWeekend_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../isWeekend/index.js */ "./node_modules/date-fns/esm/isWeekend/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../isSameDay/index.js */ "./node_modules/date-fns/esm/isSameDay/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name differenceInBusinessDays
             * @category Day Helpers
             * @summary Get the number of business days between the given dates.
             *
             * @description
             * Get the number of business day periods between the given dates.
             * Business days being days that arent in the weekend.
             * Like `differenceInCalendarDays`, the function removes the times from
             * the dates before calculating the difference.
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of business days
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many business days are between
             * // 10 January 2014 and 20 July 2014?
             * var result = differenceInBusinessDays(
             *   new Date(2014, 6, 20),
             *   new Date(2014, 0, 10)
             * )
             * //=> 136
             */
            function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDateRight);
                if (!Object(_isValid_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dateLeft) || !Object(_isValid_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dateRight))
                    return new Date(NaN);
                var calendarDifference = Object(_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dateLeft, dateRight);
                var sign = calendarDifference < 0 ? -1 : 1;
                var weeks = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(calendarDifference / 7);
                var result = weeks * 5;
                dateRight = Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
                while (!Object(_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(dateLeft, dateRight)) {
                    // sign is used to account for both negative and positive differences
                    result += Object(_isWeekend_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dateRight) ? 0 : sign;
                    dateRight = Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dateRight, sign);
                }
                return result === 0 ? 0 : result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarDays/index.js ***!
          \*********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarDays; });
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfDay/index.js */ "./node_modules/date-fns/esm/startOfDay/index.js");
            var MILLISECONDS_IN_DAY = 86400000;
            /**
             * @name differenceInCalendarDays
             * @category Day Helpers
             * @summary Get the number of calendar days between the given dates.
             *
             * @description
             * Get the number of calendar days between the given dates. This means that the times are removed
             * from the dates and then the difference in days is calculated.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar days
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many calendar days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInCalendarDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 366
             * // How many calendar days are between
             * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
             * var result = differenceInCalendarDays(
             *   new Date(2011, 6, 3, 0, 1),
             *   new Date(2011, 6, 2, 23, 59)
             * )
             * //=> 1
             */
            function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var startOfDayLeft = Object(_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
                var startOfDayRight = Object(_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
                var timestampLeft = startOfDayLeft.getTime() - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(startOfDayLeft);
                var timestampRight = startOfDayRight.getTime() - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(startOfDayRight); // Round the number of days to the nearest integer
                // because the number of milliseconds in a day is not constant
                // (e.g. it's different in the day of the daylight saving time clock shift)
                return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js ***!
          \*****************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarISOWeekYears; });
            /* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getISOWeekYear/index.js */ "./node_modules/date-fns/esm/getISOWeekYear/index.js");
            /**
             * @name differenceInCalendarISOWeekYears
             * @category ISO Week-Numbering Year Helpers
             * @summary Get the number of calendar ISO week-numbering years between the given dates.
             *
             * @description
             * Get the number of calendar ISO week-numbering years between the given dates.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar ISO week-numbering years
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
             * var result = differenceInCalendarISOWeekYears(
             *   new Date(2012, 0, 1),
             *   new Date(2010, 0, 1)
             * )
             * //=> 2
             */
            function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                return Object(_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft) - Object(_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js ***!
          \*************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarISOWeeks; });
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            var MILLISECONDS_IN_WEEK = 604800000;
            /**
             * @name differenceInCalendarISOWeeks
             * @category ISO Week Helpers
             * @summary Get the number of calendar ISO weeks between the given dates.
             *
             * @description
             * Get the number of calendar ISO weeks between the given dates.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar ISO weeks
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
             * var result = differenceInCalendarISOWeeks(
             *   new Date(2014, 6, 21),
             *   new Date(2014, 6, 6)
             * )
             * //=> 3
             */
            function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var startOfISOWeekLeft = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
                var startOfISOWeekRight = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
                var timestampLeft = startOfISOWeekLeft.getTime() - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(startOfISOWeekLeft);
                var timestampRight = startOfISOWeekRight.getTime() - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(startOfISOWeekRight); // Round the number of days to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarMonths/index.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarMonths/index.js ***!
          \***********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarMonths; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name differenceInCalendarMonths
             * @category Month Helpers
             * @summary Get the number of calendar months between the given dates.
             *
             * @description
             * Get the number of calendar months between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar months
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many calendar months are between 31 January 2014 and 1 September 2014?
             * var result = differenceInCalendarMonths(
             *   new Date(2014, 8, 1),
             *   new Date(2014, 0, 31)
             * )
             * //=> 8
             */
            function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
                var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
                return yearDiff * 12 + monthDiff;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarQuarters/index.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarQuarters/index.js ***!
          \*************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarQuarters; });
            /* harmony import */ var _getQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getQuarter/index.js */ "./node_modules/date-fns/esm/getQuarter/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name differenceInCalendarQuarters
             * @category Quarter Helpers
             * @summary Get the number of calendar quarters between the given dates.
             *
             * @description
             * Get the number of calendar quarters between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar quarters
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
             * var result = differenceInCalendarQuarters(
             *   new Date(2014, 6, 2),
             *   new Date(2013, 11, 31)
             * )
             * //=> 3
             */
            function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
                var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
                var quarterDiff = Object(_getQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dateLeft) - Object(_getQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dateRight);
                return yearDiff * 4 + quarterDiff;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js ***!
          \**********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarWeeks; });
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            var MILLISECONDS_IN_WEEK = 604800000;
            /**
             * @name differenceInCalendarWeeks
             * @category Week Helpers
             * @summary Get the number of calendar weeks between the given dates.
             *
             * @description
             * Get the number of calendar weeks between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Number} the number of calendar weeks
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
             * var result = differenceInCalendarWeeks(
             *   new Date(2014, 6, 20),
             *   new Date(2014, 6, 5)
             * )
             * //=> 3
             *
             * @example
             * // If the week starts on Monday,
             * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
             * var result = differenceInCalendarWeeks(
             *   new Date(2014, 6, 20),
             *   new Date(2014, 6, 5),
             *   { weekStartsOn: 1 }
             * )
             * //=> 2
             */
            function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var startOfWeekLeft = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyOptions);
                var startOfWeekRight = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight, dirtyOptions);
                var timestampLeft = startOfWeekLeft.getTime() - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(startOfWeekLeft);
                var timestampRight = startOfWeekRight.getTime() - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(startOfWeekRight); // Round the number of days to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInCalendarYears/index.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInCalendarYears/index.js ***!
          \**********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInCalendarYears; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name differenceInCalendarYears
             * @category Year Helpers
             * @summary Get the number of calendar years between the given dates.
             *
             * @description
             * Get the number of calendar years between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar years
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many calendar years are between 31 December 2013 and 11 February 2015?
             * var result = differenceInCalendarYears(
             *   new Date(2015, 1, 11),
             *   new Date(2013, 11, 31)
             * )
             * //=> 2
             */
            function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeft.getFullYear() - dateRight.getFullYear();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInDays/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInDays/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInDays; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /**
             * @name differenceInDays
             * @category Day Helpers
             * @summary Get the number of full days between the given dates.
             *
             * @description
             * Get the number of full day periods between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of full days
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many full days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 365
             * // How many days are between
             * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
             * var result = differenceInDays(
             *   new Date(2011, 6, 3, 0, 1),
             *   new Date(2011, 6, 2, 23, 59)
             * )
             * //=> 0
             */
            function differenceInDays(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var sign = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight);
                var difference = Math.abs(Object(_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dateLeft, dateRight));
                dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastDayNotFull = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight) === -sign;
                var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
                return result === 0 ? 0 : result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInHours/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInHours/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInHours; });
            /* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInMilliseconds/index.js */ "./node_modules/date-fns/esm/differenceInMilliseconds/index.js");
            var MILLISECONDS_IN_HOUR = 3600000;
            /**
             * @name differenceInHours
             * @category Hour Helpers
             * @summary Get the number of hours between the given dates.
             *
             * @description
             * Get the number of hours between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of hours
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
             * var result = differenceInHours(
             *   new Date(2014, 6, 2, 19, 0),
             *   new Date(2014, 6, 2, 6, 50)
             * )
             * //=> 12
             */
            function differenceInHours(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var diff = Object(_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInISOWeekYears/index.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInISOWeekYears/index.js ***!
          \*********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInISOWeekYears; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _differenceInCalendarISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../differenceInCalendarISOWeekYears/index.js */ "./node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js");
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /* harmony import */ var _subISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../subISOWeekYears/index.js */ "./node_modules/date-fns/esm/subISOWeekYears/index.js");
            /**
             * @name differenceInISOWeekYears
             * @category ISO Week-Numbering Year Helpers
             * @summary Get the number of full ISO week-numbering years between the given dates.
             *
             * @description
             * Get the number of full ISO week-numbering years between the given dates.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of full ISO week-numbering years
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
             * var result = differenceInISOWeekYears(
             *   new Date(2012, 0, 1),
             *   new Date(2010, 0, 1)
             * )
             * //=> 1
             */
            function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var sign = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight);
                var difference = Math.abs(Object(_differenceInCalendarISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dateLeft, dateRight));
                dateLeft = Object(_subISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
                // if last calendar ISO year is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastISOWeekYearNotFull = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight) === -sign;
                var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero
                return result === 0 ? 0 : result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInMilliseconds/index.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInMilliseconds/index.js ***!
          \*********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInMilliseconds; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name differenceInMilliseconds
             * @category Millisecond Helpers
             * @summary Get the number of milliseconds between the given dates.
             *
             * @description
             * Get the number of milliseconds between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of milliseconds
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many milliseconds are between
             * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
             * var result = differenceInMilliseconds(
             *   new Date(2014, 6, 2, 12, 30, 21, 700),
             *   new Date(2014, 6, 2, 12, 30, 20, 600)
             * )
             * //=> 1100
             */
            function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeft.getTime() - dateRight.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInMinutes/index.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInMinutes/index.js ***!
          \****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInMinutes; });
            /* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInMilliseconds/index.js */ "./node_modules/date-fns/esm/differenceInMilliseconds/index.js");
            var MILLISECONDS_IN_MINUTE = 60000;
            /**
             * @name differenceInMinutes
             * @category Minute Helpers
             * @summary Get the number of minutes between the given dates.
             *
             * @description
             * Get the number of minutes between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of minutes
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
             * var result = differenceInMinutes(
             *   new Date(2014, 6, 2, 12, 20, 0),
             *   new Date(2014, 6, 2, 12, 7, 59)
             * )
             * //=> 12
             */
            function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var diff = Object(_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInMonths/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInMonths/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInMonths; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _differenceInCalendarMonths_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../differenceInCalendarMonths/index.js */ "./node_modules/date-fns/esm/differenceInCalendarMonths/index.js");
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /**
             * @name differenceInMonths
             * @category Month Helpers
             * @summary Get the number of full months between the given dates.
             *
             * @description
             * Get the number of full months between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of full months
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many full months are between 31 January 2014 and 1 September 2014?
             * var result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
             * //=> 7
             */
            function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var sign = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight);
                var difference = Math.abs(Object(_differenceInCalendarMonths_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dateLeft, dateRight));
                dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastMonthNotFull = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight) === -sign;
                var result = sign * (difference - isLastMonthNotFull); // Prevent negative zero
                return result === 0 ? 0 : result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInQuarters/index.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInQuarters/index.js ***!
          \*****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInQuarters; });
            /* harmony import */ var _differenceInMonths_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInMonths/index.js */ "./node_modules/date-fns/esm/differenceInMonths/index.js");
            /**
             * @name differenceInQuarters
             * @category Quarter Helpers
             * @summary Get the number of full quarters between the given dates.
             *
             * @description
             * Get the number of full quarters between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of full quarters
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many full quarters are between 31 December 2013 and 2 July 2014?
             * var result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
             * //=> 2
             */
            function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var diff = Object(_differenceInMonths_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyDateRight) / 3;
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInSeconds/index.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInSeconds/index.js ***!
          \****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInSeconds; });
            /* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInMilliseconds/index.js */ "./node_modules/date-fns/esm/differenceInMilliseconds/index.js");
            /**
             * @name differenceInSeconds
             * @category Second Helpers
             * @summary Get the number of seconds between the given dates.
             *
             * @description
             * Get the number of seconds between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of seconds
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many seconds are between
             * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
             * var result = differenceInSeconds(
             *   new Date(2014, 6, 2, 12, 30, 20, 0),
             *   new Date(2014, 6, 2, 12, 30, 7, 999)
             * )
             * //=> 12
             */
            function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var diff = Object(_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyDateRight) / 1000;
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInWeeks/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInWeeks/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInWeeks; });
            /* harmony import */ var _differenceInDays_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInDays/index.js */ "./node_modules/date-fns/esm/differenceInDays/index.js");
            /**
             * @name differenceInWeeks
             * @category Week Helpers
             * @summary Get the number of full weeks between the given dates.
             *
             * @description
             * Get the number of full weeks between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of full weeks
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many full weeks are between 5 July 2014 and 20 July 2014?
             * var result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
             * //=> 2
             */
            function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var diff = Object(_differenceInDays_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyDateRight) / 7;
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/differenceInYears/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/differenceInYears/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return differenceInYears; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _differenceInCalendarYears_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../differenceInCalendarYears/index.js */ "./node_modules/date-fns/esm/differenceInCalendarYears/index.js");
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /**
             * @name differenceInYears
             * @category Year Helpers
             * @summary Get the number of full years between the given dates.
             *
             * @description
             * Get the number of full years between the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the later date
             * @param {Date|Number} dateRight - the earlier date
             * @returns {Number} the number of full years
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // How many full years are between 31 December 2013 and 11 February 2015?
             * var result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
             * //=> 1
             */
            function differenceInYears(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                var sign = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight);
                var difference = Math.abs(Object(_differenceInCalendarYears_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dateLeft, dateRight));
                dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastYearNotFull = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateLeft, dateRight) === -sign;
                var result = sign * (difference - isLastYearNotFull); // Prevent negative zero
                return result === 0 ? 0 : result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/eachDayOfInterval/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/eachDayOfInterval/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return eachDayOfInterval; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name eachDayOfInterval
             * @category Interval Helpers
             * @summary Return the array of dates within the specified time interval.
             *
             * @description
             * Return the array of dates within the specified time interval.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `eachDay` to `eachDayOfInterval`.
             *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
             *
             *   ```
             *   2.1.3
             *   time interval
             *   part of the time axis limited by two instants
             *   ```
             *
             *   Also, this function now accepts an object with `start` and `end` properties
             *   instead of two arguments as an interval.
             *   This function now throws `RangeError` if the start of the interval is after its end
             *   or if any date in the interval is `Invalid Date`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
             *
             *   // v2.0.0 onward
             *
             *   eachDayOfInterval(
             *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
             *   )
             *   ```
             *
             * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
             * @param {Object} [options] - an object with options.
             * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
             * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.step` must be a number greater than 1
             * @throws {RangeError} The start of an interval cannot be after its end
             * @throws {RangeError} Date in interval cannot be `Invalid Date`
             *
             * @example
             * // Each day between 6 October 2014 and 10 October 2014:
             * var result = eachDayOfInterval({
             *   start: new Date(2014, 9, 6),
             *   end: new Date(2014, 9, 10)
             * })
             * //=> [
             * //   Mon Oct 06 2014 00:00:00,
             * //   Tue Oct 07 2014 00:00:00,
             * //   Wed Oct 08 2014 00:00:00,
             * //   Thu Oct 09 2014 00:00:00,
             * //   Fri Oct 10 2014 00:00:00
             * // ]
             */
            function eachDayOfInterval(dirtyInterval, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var interval = dirtyInterval || {};
                var startDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(interval.start);
                var endDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(interval.end);
                var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
                if (!(startDate.getTime() <= endTime)) {
                    throw new RangeError('Invalid interval');
                }
                var dates = [];
                var currentDate = startDate;
                currentDate.setHours(0, 0, 0, 0);
                var step = options && 'step' in options ? Number(options.step) : 1;
                if (step < 1 || isNaN(step))
                    throw new RangeError('`options.step` must be a number greater than 1');
                while (currentDate.getTime() <= endTime) {
                    dates.push(Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(currentDate));
                    currentDate.setDate(currentDate.getDate() + step);
                    currentDate.setHours(0, 0, 0, 0);
                }
                return dates;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/eachWeekOfInterval/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/eachWeekOfInterval/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return eachWeekOfInterval; });
            /* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../addWeeks/index.js */ "./node_modules/date-fns/esm/addWeeks/index.js");
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name eachWeekOfInterval
             * @category Interval Helpers
             * @summary Return the array of weeks within the specified time interval.
             *
             * @description
             * Return the array of weeks within the specified time interval.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
             * @throws {RangeError} The start of an interval cannot be after its end
             * @throws {RangeError} Date in interval cannot be `Invalid Date`
             *
             * @example
             * // Each week within interval 6 October 2014 - 23 November 2014:
             * var result = eachWeekOfInterval({
             *   start: new Date(2014, 9, 6),
             *   end: new Date(2014, 10, 23)
             * })
             * //=> [
             * //   Sun Oct 05 2014 00:00:00,
             * //   Sun Oct 12 2014 00:00:00,
             * //   Sun Oct 19 2014 00:00:00,
             * //   Sun Oct 26 2014 00:00:00,
             * //   Sun Nov 02 2014 00:00:00,
             * //   Sun Nov 09 2014 00:00:00,
             * //   Sun Nov 16 2014 00:00:00,
             * //   Sun Nov 23 2014 00:00:00
             * // ]
             */
            function eachWeekOfInterval(dirtyInterval, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var interval = dirtyInterval || {};
                var startDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(interval.start);
                var endDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(interval.end);
                var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
                if (!(startDate.getTime() <= endTime)) {
                    throw new RangeError('Invalid interval');
                }
                var startDateWeek = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(startDate, options);
                var endDateWeek = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
                startDateWeek.setHours(15);
                endDateWeek.setHours(15);
                endTime = endDateWeek.getTime();
                var weeks = [];
                var currentWeek = startDateWeek;
                while (currentWeek.getTime() <= endTime) {
                    currentWeek.setHours(0);
                    weeks.push(Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(currentWeek));
                    currentWeek = Object(_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(currentWeek, 1);
                    currentWeek.setHours(15);
                }
                return weeks;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/eachWeekendOfInterval/index.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/date-fns/esm/eachWeekendOfInterval/index.js ***!
          \******************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return eachWeekendOfInterval; });
            /* harmony import */ var _eachDayOfInterval_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../eachDayOfInterval/index.js */ "./node_modules/date-fns/esm/eachDayOfInterval/index.js");
            /* harmony import */ var _isSunday_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../isSunday/index.js */ "./node_modules/date-fns/esm/isSunday/index.js");
            /* harmony import */ var _isWeekend_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../isWeekend/index.js */ "./node_modules/date-fns/esm/isWeekend/index.js");
            /**
             * @name eachWeekendOfInterval
             * @category Interval Helpers
             * @summary List all the Saturdays and Sundays in the given date interval.
             *
             * @description
             * Get all the Saturdays and Sundays in the given date interval.
             *
             * @param {Interval} interval - the given interval. See [Interval]{@link docs/types/Interval}
             * @returns {Date[]} an array containing all the Saturdays and Sundays
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} The start of an interval cannot be after its end
             * @throws {RangeError} Date in interval cannot be `Invalid Date`
             *
             * @example
             * // Lists all Saturdays and Sundays in the given date interval
             * var result = eachWeekendOfInterval({
             *   start: new Date(2018, 8, 17),
             *   end: new Date(2018, 8, 30)
             * })
             * //=> [
             * //   Sat Sep 22 2018 00:00:00,
             * //   Sun Sep 23 2018 00:00:00,
             * //   Sat Sep 29 2018 00:00:00,
             * //   Sun Sep 30 2018 00:00:00
             * // ]
             */
            function eachWeekendOfInterval(interval) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var dateInterval = Object(_eachDayOfInterval_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(interval);
                var weekends = [];
                var index = 0;
                while (index < dateInterval.length) {
                    var date = dateInterval[index++];
                    if (Object(_isWeekend_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date)) {
                        weekends.push(date);
                        if (Object(_isSunday_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date))
                            index = index + 5;
                    }
                }
                return weekends;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/eachWeekendOfMonth/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/eachWeekendOfMonth/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return eachWeekendOfMonth; });
            /* harmony import */ var _eachWeekendOfInterval_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../eachWeekendOfInterval/index.js */ "./node_modules/date-fns/esm/eachWeekendOfInterval/index.js");
            /* harmony import */ var _startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfMonth/index.js */ "./node_modules/date-fns/esm/startOfMonth/index.js");
            /* harmony import */ var _endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../endOfMonth/index.js */ "./node_modules/date-fns/esm/endOfMonth/index.js");
            /**
             * @name eachWeekendOfMonth
             * @category Month Helpers
             * @summary List all the Saturdays and Sundays in the given month.
             *
             * @description
             * Get all the Saturdays and Sundays in the given month.
             *
             * @param {Date|Number} date - the given month
             * @returns {Date[]} an array containing all the Saturdays and Sundays
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} The passed date is invalid
             *
             * @example
             * // Lists all Saturdays and Sundays in the given month
             * var result = eachWeekendOfMonth(new Date(2022, 1, 1))
             * //=> [
             * //   Sat Feb 05 2022 00:00:00,
             * //   Sun Feb 06 2022 00:00:00,
             * //   Sat Feb 12 2022 00:00:00,
             * //   Sun Feb 13 2022 00:00:00,
             * //   Sat Feb 19 2022 00:00:00,
             * //   Sun Feb 20 2022 00:00:00,
             * //   Sat Feb 26 2022 00:00:00,
             * //   Sun Feb 27 2022 00:00:00
             * // ]
             */
            function eachWeekendOfMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 arguments required, but only ' + arguments.length + ' present');
                }
                var startDate = Object(_startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                if (isNaN(startDate))
                    throw new RangeError('The passed date is invalid');
                var endDate = Object(_endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
                return Object(_eachWeekendOfInterval_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    start: startDate,
                    end: endDate
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/eachWeekendOfYear/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/eachWeekendOfYear/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return eachWeekendOfYear; });
            /* harmony import */ var _eachWeekendOfInterval_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../eachWeekendOfInterval/index.js */ "./node_modules/date-fns/esm/eachWeekendOfInterval/index.js");
            /* harmony import */ var _startOfYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfYear/index.js */ "./node_modules/date-fns/esm/startOfYear/index.js");
            /* harmony import */ var _endOfYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../endOfYear/index.js */ "./node_modules/date-fns/esm/endOfYear/index.js");
            /**
             * @name eachWeekendOfYear
             * @category Year Helpers
             * @summary List all the Saturdays and Sundays in the year.
             *
             * @description
             * Get all the Saturdays and Sundays in the year.
             *
             * @param {Date|Number} date - the given year
             * @returns {Date[]} an array containing all the Saturdays and Sundays
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} The passed date is invalid
             *
             * @example
             * // Lists all Saturdays and Sundays in the year
             * var result = eachWeekendOfYear(new Date(2020, 1, 1))
             * //=> [
             * //   Sat Jan 03 2020 00:00:00,
             * //   Sun Jan 04 2020 00:00:00,
             * //   ...
             * //   Sun Dec 27 2020 00:00:00
             * // ]
             * ]
             */
            function eachWeekendOfYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 arguments required, but only ' + arguments.length + ' present');
                }
                var startDate = Object(_startOfYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                if (isNaN(startDate))
                    throw new RangeError('The passed date is invalid');
                var endDate = Object(_endOfYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
                return Object(_eachWeekendOfInterval_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    start: startDate,
                    end: endDate
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfDay/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfDay/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfDay; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfDay
             * @category Day Helpers
             * @summary Return the end of a day for the given date.
             *
             * @description
             * Return the end of a day for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a day
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of a day for 2 September 2014 11:55:00:
             * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 23:59:59.999
             */
            function endOfDay(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfDecade/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfDecade/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfDecade; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfDecade
             * @category Decade Helpers
             * @summary Return the end of a decade for the given date.
             *
             * @description
             * Return the end of a decade for the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a decade
             * @param {Object} [options] - an object with options.
             * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
             *
             * @example
             * // The end of a decade for 12 May 1984 00:00:00:
             * var result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
             * //=> Dec 31 1989 23:59:59.999
             */
            function endOfDecade(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                var decade = 9 + Math.floor(year / 10) * 10;
                date.setFullYear(decade, 11, 31);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfHour/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfHour/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfHour; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfHour
             * @category Hour Helpers
             * @summary Return the end of an hour for the given date.
             *
             * @description
             * Return the end of an hour for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of an hour
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of an hour for 2 September 2014 11:55:00:
             * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
             * //=> Tue Sep 02 2014 11:59:59.999
             */
            function endOfHour(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setMinutes(59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfISOWeek/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfISOWeek/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfISOWeek; });
            /* harmony import */ var _endOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../endOfWeek/index.js */ "./node_modules/date-fns/esm/endOfWeek/index.js");
            /**
             * @name endOfISOWeek
             * @category ISO Week Helpers
             * @summary Return the end of an ISO week for the given date.
             *
             * @description
             * Return the end of an ISO week for the given date.
             * The result will be in the local timezone.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of an ISO week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of an ISO week for 2 September 2014 11:55:00:
             * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sun Sep 07 2014 23:59:59.999
             */
            function endOfISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_endOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, {
                    weekStartsOn: 1
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfISOWeekYear/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfISOWeekYear/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfISOWeekYear; });
            /* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getISOWeekYear/index.js */ "./node_modules/date-fns/esm/getISOWeekYear/index.js");
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            /**
             * @name endOfISOWeekYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Return the end of an ISO week-numbering year for the given date.
             *
             * @description
             * Return the end of an ISO week-numbering year,
             * which always starts 3 days before the year's first Thursday.
             * The result will be in the local timezone.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of an ISO week-numbering year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of an ISO week-numbering year for 2 July 2005:
             * var result = endOfISOWeekYear(new Date(2005, 6, 2))
             * //=> Sun Jan 01 2006 23:59:59.999
             */
            function endOfISOWeekYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var year = Object(_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var fourthOfJanuaryOfNextYear = new Date(0);
                fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
                fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
                var date = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuaryOfNextYear);
                date.setMilliseconds(date.getMilliseconds() - 1);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfMinute/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfMinute/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfMinute; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfMinute
             * @category Minute Helpers
             * @summary Return the end of a minute for the given date.
             *
             * @description
             * Return the end of a minute for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a minute
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of a minute for 1 December 2014 22:15:45.400:
             * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:59.999
             */
            function endOfMinute(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setSeconds(59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfMonth/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfMonth/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfMonth
             * @category Month Helpers
             * @summary Return the end of a month for the given date.
             *
             * @description
             * Return the end of a month for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of a month for 2 September 2014 11:55:00:
             * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 23:59:59.999
             */
            function endOfMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var month = date.getMonth();
                date.setFullYear(date.getFullYear(), month + 1, 0);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfQuarter/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfQuarter/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfQuarter; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfQuarter
             * @category Quarter Helpers
             * @summary Return the end of a year quarter for the given date.
             *
             * @description
             * Return the end of a year quarter for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a quarter
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of a quarter for 2 September 2014 11:55:00:
             * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 23:59:59.999
             */
            function endOfQuarter(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var currentMonth = date.getMonth();
                var month = currentMonth - currentMonth % 3 + 3;
                date.setMonth(month, 0);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfSecond/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfSecond/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfSecond; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfSecond
             * @category Second Helpers
             * @summary Return the end of a second for the given date.
             *
             * @description
             * Return the end of a second for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a second
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of a second for 1 December 2014 22:15:45.400:
             * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:45.999
             */
            function endOfSecond(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setMilliseconds(999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfToday/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfToday/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfToday; });
            /* harmony import */ var _endOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../endOfDay/index.js */ "./node_modules/date-fns/esm/endOfDay/index.js");
            /**
             * @name endOfToday
             * @category Day Helpers
             * @summary Return the end of today.
             * @pure false
             *
             * @description
             * Return the end of today.
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @returns {Date} the end of today
             *
             * @example
             * // If today is 6 October 2014:
             * var result = endOfToday()
             * //=> Mon Oct 6 2014 23:59:59.999
             */
            function endOfToday() {
                return Object(_endOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now());
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfTomorrow/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfTomorrow/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfTomorrow; });
            /**
             * @name endOfTomorrow
             * @category Day Helpers
             * @summary Return the end of tomorrow.
             * @pure false
             *
             * @description
             * Return the end of tomorrow.
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @returns {Date} the end of tomorrow
             *
             * @example
             * // If today is 6 October 2014:
             * var result = endOfTomorrow()
             * //=> Tue Oct 7 2014 23:59:59.999
             */
            function endOfTomorrow() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var day = now.getDate();
                var date = new Date(0);
                date.setFullYear(year, month, day + 1);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfWeek/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfWeek/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name endOfWeek
             * @category Week Helpers
             * @summary Return the end of a week for the given date.
             *
             * @description
             * Return the end of a week for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the end of a week
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // The end of a week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sat Sep 06 2014 23:59:59.999
             *
             * @example
             * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
             * //=> Sun Sep 07 2014 23:59:59.999
             */
            function endOfWeek(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getDay();
                var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
                date.setDate(date.getDate() + diff);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfYear/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfYear/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name endOfYear
             * @category Year Helpers
             * @summary Return the end of a year for the given date.
             *
             * @description
             * Return the end of a year for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of a year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The end of a year for 2 September 2014 11:55:00:
             * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
             * //=> Wed Dec 31 2014 23:59:59.999
             */
            function endOfYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                date.setFullYear(year + 1, 0, 0);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/endOfYesterday/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/endOfYesterday/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return endOfYesterday; });
            /**
             * @name endOfYesterday
             * @category Day Helpers
             * @summary Return the end of yesterday.
             * @pure false
             *
             * @description
             * Return the end of yesterday.
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @returns {Date} the end of yesterday
             *
             * @example
             * // If today is 6 October 2014:
             * var result = endOfYesterday()
             * //=> Sun Oct 5 2014 23:59:59.999
             */
            function endOfYesterday() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var day = now.getDate();
                var date = new Date(0);
                date.setFullYear(year, month, day - 1);
                date.setHours(23, 59, 59, 999);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/format/index.js": 
        /*!***************************************************!*\
          !*** ./node_modules/date-fns/esm/format/index.js ***!
          \***************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return format; });
            /* harmony import */ var _isValid_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isValid/index.js */ "./node_modules/date-fns/esm/isValid/index.js");
            /* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../locale/en-US/index.js */ "./node_modules/date-fns/esm/locale/en-US/index.js");
            /* harmony import */ var _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../subMilliseconds/index.js */ "./node_modules/date-fns/esm/subMilliseconds/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_format_formatters_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../_lib/format/formatters/index.js */ "./node_modules/date-fns/esm/_lib/format/formatters/index.js");
            /* harmony import */ var _lib_format_longFormatters_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_lib/format/longFormatters/index.js */ "./node_modules/date-fns/esm/_lib/format/longFormatters/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /* harmony import */ var _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../_lib/protectedTokens/index.js */ "./node_modules/date-fns/esm/_lib/protectedTokens/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            // This RegExp consists of three parts separated by `|`:
            // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
            //   (one of the certain letters followed by `o`)
            // - (\w)\1* matches any sequences of the same letter
            // - '' matches two quote characters in a row
            // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
            //   except a single quote symbol, which ends the sequence.
            //   Two quote characters do not end the sequence.
            //   If there is no matching single quote
            //   then the sequence will continue until the end of the string.
            // - . matches any single character unmatched by previous parts of the RegExps
            var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
            // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
            var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            var escapedStringRegExp = /^'([^]*?)'?$/;
            var doubleQuoteRegExp = /''/g;
            var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
            /**
             * @name format
             * @category Common Helpers
             * @summary Format the date.
             *
             * @description
             * Return the formatted date string in the given format. The result may vary by locale.
             *
             * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
             * > See: https://git.io/fxCyr
             *
             * The characters wrapped between two single quotes characters (') are escaped.
             * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
             * (see the last example)
             *
             * Format of the string is based on Unicode Technical Standard #35:
             * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
             * with a few additions (see note 7 below the table).
             *
             * Accepted patterns:
             * | Unit                            | Pattern | Result examples                   | Notes |
             * |---------------------------------|---------|-----------------------------------|-------|
             * | Era                             | G..GGG  | AD, BC                            |       |
             * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
             * |                                 | GGGGG   | A, B                              |       |
             * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
             * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
             * |                                 | yy      | 44, 01, 00, 17                    | 5     |
             * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
             * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
             * |                                 | yyyyy   | ...                               | 3,5   |
             * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
             * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
             * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
             * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
             * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
             * |                                 | YYYYY   | ...                               | 3,5   |
             * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
             * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
             * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
             * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
             * |                                 | RRRRR   | ...                               | 3,5,7 |
             * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
             * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
             * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
             * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
             * |                                 | uuuuu   | ...                               | 3,5   |
             * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
             * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
             * |                                 | QQ      | 01, 02, 03, 04                    |       |
             * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
             * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
             * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
             * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
             * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
             * |                                 | qq      | 01, 02, 03, 04                    |       |
             * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
             * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
             * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
             * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
             * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
             * |                                 | MM      | 01, 02, ..., 12                   |       |
             * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
             * |                                 | MMMM    | January, February, ..., December  | 2     |
             * |                                 | MMMMM   | J, F, ..., D                      |       |
             * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
             * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
             * |                                 | LL      | 01, 02, ..., 12                   |       |
             * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
             * |                                 | LLLL    | January, February, ..., December  | 2     |
             * |                                 | LLLLL   | J, F, ..., D                      |       |
             * | Local week of year              | w       | 1, 2, ..., 53                     |       |
             * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
             * |                                 | ww      | 01, 02, ..., 53                   |       |
             * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
             * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
             * |                                 | II      | 01, 02, ..., 53                   | 7     |
             * | Day of month                    | d       | 1, 2, ..., 31                     |       |
             * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
             * |                                 | dd      | 01, 02, ..., 31                   |       |
             * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
             * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
             * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
             * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
             * |                                 | DDDD    | ...                               | 3     |
             * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
             * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
             * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
             * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
             * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
             * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
             * |                                 | ii      | 01, 02, ..., 07                   | 7     |
             * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
             * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
             * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
             * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
             * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
             * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
             * |                                 | ee      | 02, 03, ..., 01                   |       |
             * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
             * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
             * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
             * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
             * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
             * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
             * |                                 | cc      | 02, 03, ..., 01                   |       |
             * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
             * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
             * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
             * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
             * | AM, PM                          | a..aaa  | AM, PM                            |       |
             * |                                 | aaaa    | a.m., p.m.                        | 2     |
             * |                                 | aaaaa   | a, p                              |       |
             * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
             * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
             * |                                 | bbbbb   | a, p, n, mi                       |       |
             * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
             * |                                 | BBBB    | at night, in the morning, ...     | 2     |
             * |                                 | BBBBB   | at night, in the morning, ...     |       |
             * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
             * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
             * |                                 | hh      | 01, 02, ..., 11, 12               |       |
             * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
             * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
             * |                                 | HH      | 00, 01, 02, ..., 23               |       |
             * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
             * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
             * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
             * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
             * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
             * |                                 | kk      | 24, 01, 02, ..., 23               |       |
             * | Minute                          | m       | 0, 1, ..., 59                     |       |
             * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
             * |                                 | mm      | 00, 01, ..., 59                   |       |
             * | Second                          | s       | 0, 1, ..., 59                     |       |
             * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
             * |                                 | ss      | 00, 01, ..., 59                   |       |
             * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
             * |                                 | SS      | 00, 01, ..., 99                   |       |
             * |                                 | SSS     | 000, 0001, ..., 999               |       |
             * |                                 | SSSS    | ...                               | 3     |
             * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
             * |                                 | XX      | -0800, +0530, Z                   |       |
             * |                                 | XXX     | -08:00, +05:30, Z                 |       |
             * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
             * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
             * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
             * |                                 | xx      | -0800, +0530, +0000               |       |
             * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
             * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
             * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
             * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
             * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
             * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
             * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
             * | Seconds timestamp               | t       | 512969520                         | 7     |
             * |                                 | tt      | ...                               | 3,7   |
             * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
             * |                                 | TT      | ...                               | 3,7   |
             * | Long localized date             | P       | 05/29/1453                        | 7     |
             * |                                 | PP      | May 29, 1453                      | 7     |
             * |                                 | PPP     | May 29th, 1453                    | 7     |
             * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
             * | Long localized time             | p       | 12:00 AM                          | 7     |
             * |                                 | pp      | 12:00:00 AM                       | 7     |
             * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
             * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
             * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
             * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
             * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
             * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
             * Notes:
             * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
             *    are the same as "stand-alone" units, but are different in some languages.
             *    "Formatting" units are declined according to the rules of the language
             *    in the context of a date. "Stand-alone" units are always nominative singular:
             *
             *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
             *
             *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
             *
             * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
             *    the single quote characters (see below).
             *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
             *    the output will be the same as default pattern for this unit, usually
             *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
             *    are marked with "2" in the last column of the table.
             *
             *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
             *
             *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
             *
             *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
             *
             *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
             *
             *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
             *
             * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
             *    The output will be padded with zeros to match the length of the pattern.
             *
             *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
             *
             * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
             *    These tokens represent the shortest form of the quarter.
             *
             * 5. The main difference between `y` and `u` patterns are B.C. years:
             *
             *    | Year | `y` | `u` |
             *    |------|-----|-----|
             *    | AC 1 |   1 |   1 |
             *    | BC 1 |   1 |   0 |
             *    | BC 2 |   2 |  -1 |
             *
             *    Also `yy` always returns the last two digits of a year,
             *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
             *
             *    | Year | `yy` | `uu` |
             *    |------|------|------|
             *    | 1    |   01 |   01 |
             *    | 14   |   14 |   14 |
             *    | 376  |   76 |  376 |
             *    | 1453 |   53 | 1453 |
             *
             *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
             *    except local week-numbering years are dependent on `options.weekStartsOn`
             *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
             *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
             *
             * 6. Specific non-location timezones are currently unavailable in `date-fns`,
             *    so right now these tokens fall back to GMT timezones.
             *
             * 7. These patterns are not in the Unicode Technical Standard #35:
             *    - `i`: ISO day of week
             *    - `I`: ISO week of year
             *    - `R`: ISO week-numbering year
             *    - `t`: seconds timestamp
             *    - `T`: milliseconds timestamp
             *    - `o`: ordinal number modifier
             *    - `P`: long localized date
             *    - `p`: long localized time
             *
             * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
             *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
             *
             * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
             *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The second argument is now required for the sake of explicitness.
             *
             *   ```javascript
             *   // Before v2.0.0
             *   format(new Date(2016, 0, 1))
             *
             *   // v2.0.0 onward
             *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
             *   ```
             *
             * - New format string API for `format` function
             *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
             *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
             *
             * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
             *
             * @param {Date|Number} date - the original date
             * @param {String} format - the string of tokens
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
             * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
             *   see: https://git.io/fxCyr
             * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
             *   see: https://git.io/fxCyr
             * @returns {String} the formatted date string
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.locale` must contain `localize` property
             * @throws {RangeError} `options.locale` must contain `formatLong` property
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
             * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
             * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
             * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
             * @throws {RangeError} format string contains an unescaped latin alphabet character
             *
             * @example
             * // Represent 11 February 2014 in middle-endian format:
             * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
             * //=> '02/11/2014'
             *
             * @example
             * // Represent 2 July 2014 in Esperanto:
             * import { eoLocale } from 'date-fns/locale/eo'
             * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
             *   locale: eoLocale
             * })
             * //=> '2-a de julio 2014'
             *
             * @example
             * // Escape string by single quote characters:
             * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
             * //=> "3 o'clock"
             */
            function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var formatStr = String(dirtyFormatStr);
                var options = dirtyOptions || {};
                var locale = options.locale || _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_1__["default"];
                var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_8__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_8__["default"])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
                if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
                    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                }
                var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_8__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_8__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                if (!locale.localize) {
                    throw new RangeError('locale must contain localize property');
                }
                if (!locale.formatLong) {
                    throw new RangeError('locale must contain formatLong property');
                }
                var originalDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
                if (!Object(_isValid_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(originalDate)) {
                    throw new RangeError('Invalid time value');
                } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
                // This ensures that when UTC functions will be implemented, locales will be compatible with them.
                // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
                var timezoneOffset = Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(originalDate);
                var utcDate = Object(_subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(originalDate, timezoneOffset);
                var formatterOptions = {
                    firstWeekContainsDate: firstWeekContainsDate,
                    weekStartsOn: weekStartsOn,
                    locale: locale,
                    _originalDate: originalDate
                };
                var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
                    var firstCharacter = substring[0];
                    if (firstCharacter === 'p' || firstCharacter === 'P') {
                        var longFormatter = _lib_format_longFormatters_index_js__WEBPACK_IMPORTED_MODULE_5__["default"][firstCharacter];
                        return longFormatter(substring, locale.formatLong, formatterOptions);
                    }
                    return substring;
                }).join('').match(formattingTokensRegExp).map(function (substring) {
                    // Replace two single quote characters with one single quote character
                    if (substring === "''") {
                        return "'";
                    }
                    var firstCharacter = substring[0];
                    if (firstCharacter === "'") {
                        return cleanEscapedString(substring);
                    }
                    var formatter = _lib_format_formatters_index_js__WEBPACK_IMPORTED_MODULE_4__["default"][firstCharacter];
                    if (formatter) {
                        if (!options.useAdditionalWeekYearTokens && Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_7__["isProtectedWeekYearToken"])(substring)) {
                            Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_7__["throwProtectedError"])(substring);
                        }
                        if (!options.useAdditionalDayOfYearTokens && Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_7__["isProtectedDayOfYearToken"])(substring)) {
                            Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_7__["throwProtectedError"])(substring);
                        }
                        return formatter(utcDate, substring, locale.localize, formatterOptions);
                    }
                    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
                        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                    }
                    return substring;
                }).join('');
                return result;
            }
            function cleanEscapedString(input) {
                return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/formatDistance/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/formatDistance/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return formatDistance; });
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /* harmony import */ var _differenceInMonths_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../differenceInMonths/index.js */ "./node_modules/date-fns/esm/differenceInMonths/index.js");
            /* harmony import */ var _differenceInSeconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../differenceInSeconds/index.js */ "./node_modules/date-fns/esm/differenceInSeconds/index.js");
            /* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../locale/en-US/index.js */ "./node_modules/date-fns/esm/locale/en-US/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_cloneObject_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_lib/cloneObject/index.js */ "./node_modules/date-fns/esm/_lib/cloneObject/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            var MINUTES_IN_DAY = 1440;
            var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
            var MINUTES_IN_MONTH = 43200;
            var MINUTES_IN_TWO_MONTHS = 86400;
            /**
             * @name formatDistance
             * @category Common Helpers
             * @summary Return the distance between the given dates in words.
             *
             * @description
             * Return the distance between the given dates in words.
             *
             * | Distance between dates                                            | Result              |
             * |-------------------------------------------------------------------|---------------------|
             * | 0 ... 30 secs                                                     | less than a minute  |
             * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
             * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
             * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
             * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
             * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
             * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
             * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
             * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
             * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
             * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
             * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
             * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
             * | N yrs ... N yrs 3 months                                          | about N years       |
             * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
             * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
             *
             * With `options.includeSeconds == true`:
             * | Distance between dates | Result               |
             * |------------------------|----------------------|
             * | 0 secs ... 5 secs      | less than 5 seconds  |
             * | 5 secs ... 10 secs     | less than 10 seconds |
             * | 10 secs ... 20 secs    | less than 20 seconds |
             * | 20 secs ... 40 secs    | half a minute        |
             * | 40 secs ... 60 secs    | less than a minute   |
             * | 60 secs ... 90 secs    | 1 minute             |
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `distanceInWords ` to `formatDistance`
             *   to make its name consistent with `format` and `formatRelative`.
             *
             * - The order of arguments is swapped to make the function
             *   consistent with `differenceIn...` functions.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   distanceInWords(
             *     new Date(1986, 3, 4, 10, 32, 0),
             *     new Date(1986, 3, 4, 11, 32, 0),
             *     { addSuffix: true }
             *   ) //=> 'in about 1 hour'
             *
             *   // v2.0.0 onward
             *
             *   formatDistance(
             *     new Date(1986, 3, 4, 11, 32, 0),
             *     new Date(1986, 3, 4, 10, 32, 0),
             *     { addSuffix: true }
             *   ) //=> 'in about 1 hour'
             *   ```
             *
             * @param {Date|Number} date - the date
             * @param {Date|Number} baseDate - the date to compare with
             * @param {Object} [options] - an object with options.
             * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
             * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @returns {String} the distance in words
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.locale` must contain `formatDistance` property
             *
             * @example
             * // What is the distance between 2 July 2014 and 1 January 2015?
             * var result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
             * //=> '6 months'
             *
             * @example
             * // What is the distance between 1 January 2015 00:00:15
             * // and 1 January 2015 00:00:00, including seconds?
             * var result = formatDistance(
             *   new Date(2015, 0, 1, 0, 0, 15),
             *   new Date(2015, 0, 1, 0, 0, 0),
             *   { includeSeconds: true }
             * )
             * //=> 'less than 20 seconds'
             *
             * @example
             * // What is the distance from 1 January 2016
             * // to 1 January 2015, with a suffix?
             * var result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
             *   addSuffix: true
             * })
             * //=> 'about 1 year ago'
             *
             * @example
             * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
             * import { eoLocale } from 'date-fns/locale/eo'
             * var result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
             *   locale: eoLocale
             * })
             * //=> 'pli ol 1 jaro'
             */
            function formatDistance(dirtyDate, dirtyBaseDate, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale || _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_3__["default"];
                if (!locale.formatDistance) {
                    throw new RangeError('locale must contain formatDistance property');
                }
                var comparison = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, dirtyBaseDate);
                if (isNaN(comparison)) {
                    throw new RangeError('Invalid time value');
                }
                var localizeOptions = Object(_lib_cloneObject_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(options);
                localizeOptions.addSuffix = Boolean(options.addSuffix);
                localizeOptions.comparison = comparison;
                var dateLeft;
                var dateRight;
                if (comparison > 0) {
                    dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyBaseDate);
                    dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyDate);
                }
                else {
                    dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyDate);
                    dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyBaseDate);
                }
                var seconds = Object(_differenceInSeconds_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateRight, dateLeft);
                var offsetInSeconds = (Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(dateRight) - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(dateLeft)) / 1000;
                var minutes = Math.round((seconds - offsetInSeconds) / 60);
                var months; // 0 up to 2 mins
                if (minutes < 2) {
                    if (options.includeSeconds) {
                        if (seconds < 5) {
                            return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
                        }
                        else if (seconds < 10) {
                            return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
                        }
                        else if (seconds < 20) {
                            return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
                        }
                        else if (seconds < 40) {
                            return locale.formatDistance('halfAMinute', null, localizeOptions);
                        }
                        else if (seconds < 60) {
                            return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
                        }
                        else {
                            return locale.formatDistance('xMinutes', 1, localizeOptions);
                        }
                    }
                    else {
                        if (minutes === 0) {
                            return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
                        }
                        else {
                            return locale.formatDistance('xMinutes', minutes, localizeOptions);
                        }
                    } // 2 mins up to 0.75 hrs
                }
                else if (minutes < 45) {
                    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
                }
                else if (minutes < 90) {
                    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
                }
                else if (minutes < MINUTES_IN_DAY) {
                    var hours = Math.round(minutes / 60);
                    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
                }
                else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
                    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
                }
                else if (minutes < MINUTES_IN_MONTH) {
                    var days = Math.round(minutes / MINUTES_IN_DAY);
                    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
                }
                else if (minutes < MINUTES_IN_TWO_MONTHS) {
                    months = Math.round(minutes / MINUTES_IN_MONTH);
                    return locale.formatDistance('aboutXMonths', months, localizeOptions);
                }
                months = Object(_differenceInMonths_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dateRight, dateLeft); // 2 months up to 12 months
                if (months < 12) {
                    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
                    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
                }
                else {
                    var monthsSinceStartOfYear = months % 12;
                    var years = Math.floor(months / 12); // N years up to 1 years 3 months
                    if (monthsSinceStartOfYear < 3) {
                        return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
                    }
                    else if (monthsSinceStartOfYear < 9) {
                        return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
                    }
                    else {
                        return locale.formatDistance('almostXYears', years + 1, localizeOptions);
                    }
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/formatDistanceStrict/index.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/date-fns/esm/formatDistanceStrict/index.js ***!
          \*****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return formatDistanceStrict; });
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _differenceInSeconds_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../differenceInSeconds/index.js */ "./node_modules/date-fns/esm/differenceInSeconds/index.js");
            /* harmony import */ var _lib_cloneObject_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../_lib/cloneObject/index.js */ "./node_modules/date-fns/esm/_lib/cloneObject/index.js");
            /* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../locale/en-US/index.js */ "./node_modules/date-fns/esm/locale/en-US/index.js");
            var MINUTES_IN_DAY = 1440;
            var MINUTES_IN_MONTH = 43200;
            var MINUTES_IN_YEAR = 525600;
            /**
             * @name formatDistanceStrict
             * @category Common Helpers
             * @summary Return the distance between the given dates in words.
             *
             * @description
             * Return the distance between the given dates in words, using strict units.
             * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
             * 'less than' and the like.
             *
             * | Distance between dates | Result              |
             * |------------------------|---------------------|
             * | 0 ... 59 secs          | [0..59] seconds     |
             * | 1 ... 59 mins          | [1..59] minutes     |
             * | 1 ... 23 hrs           | [1..23] hours       |
             * | 1 ... 29 days          | [1..29] days        |
             * | 1 ... 11 months        | [1..11] months      |
             * | 1 ... N years          | [1..N]  years       |
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
             *   to make its name consistent with `format` and `formatRelative`.
             *
             * - The order of arguments is swapped to make the function
             *   consistent with `differenceIn...` functions.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   distanceInWordsStrict(
             *     new Date(2015, 0, 2),
             *     new Date(2014, 6, 2)
             *   ) //=> '6 months'
             *
             *   // v2.0.0 onward
             *
             *   formatDistanceStrict(
             *     new Date(2014, 6, 2),
             *     new Date(2015, 0, 2)
             *   ) //=> '6 months'
             *   ```
             *
             * - `partialMethod` option is renamed to `roundingMethod`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   distanceInWordsStrict(
             *     new Date(1986, 3, 4, 10, 32, 0),
             *     new Date(1986, 3, 4, 10, 33, 1),
             *     { partialMethod: 'ceil' }
             *   ) //=> '2 minutes'
             *
             *   // v2.0.0 onward
             *
             *   formatDistanceStrict(
             *     new Date(1986, 3, 4, 10, 33, 1),
             *     new Date(1986, 3, 4, 10, 32, 0),
             *     { roundingMethod: 'ceil' }
             *   ) //=> '2 minutes'
             *   ```
             *
             * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
             *
             * - `unit` option now accepts one of the strings:
             *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   distanceInWordsStrict(
             *     new Date(1986, 3, 4, 10, 32, 0),
             *     new Date(1986, 3, 4, 10, 33, 1),
             *     { unit: 'm' }
             *   )
             *
             *   // v2.0.0 onward
             *
             *   formatDistanceStrict(
             *     new Date(1986, 3, 4, 10, 33, 1),
             *     new Date(1986, 3, 4, 10, 32, 0),
             *     { unit: 'minute' }
             *   )
             *   ```
             *
             * @param {Date|Number} date - the date
             * @param {Date|Number} baseDate - the date to compare with
             * @param {Object} [options] - an object with options.
             * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
             * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
             * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @returns {String} the distance in words
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
             * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
             * @throws {RangeError} `options.locale` must contain `formatDistance` property
             *
             * @example
             * // What is the distance between 2 July 2014 and 1 January 2015?
             * var result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
             * //=> '6 months'
             *
             * @example
             * // What is the distance between 1 January 2015 00:00:15
             * // and 1 January 2015 00:00:00?
             * var result = formatDistanceStrict(
             *   new Date(2015, 0, 1, 0, 0, 15),
             *   new Date(2015, 0, 1, 0, 0, 0)
             * )
             * //=> '15 seconds'
             *
             * @example
             * // What is the distance from 1 January 2016
             * // to 1 January 2015, with a suffix?
             * var result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
             *   addSuffix: true
             * })
             * //=> '1 year ago'
             *
             * @example
             * // What is the distance from 1 January 2016
             * // to 1 January 2015, in minutes?
             * var result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
             *   unit: 'minute'
             * })
             * //=> '525600 minutes'
             *
             * @example
             * // What is the distance from 1 January 2015
             * // to 28 January 2015, in months, rounded up?
             * var result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
             *   unit: 'month',
             *   roundingMethod: 'ceil'
             * })
             * //=> '1 month'
             *
             * @example
             * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
             * import { eoLocale } from 'date-fns/locale/eo'
             * var result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
             *   locale: eoLocale
             * })
             * //=> '1 jaro'
             */
            function formatDistanceStrict(dirtyDate, dirtyBaseDate, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale || _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_5__["default"];
                if (!locale.formatDistance) {
                    throw new RangeError('locale must contain localize.formatDistance property');
                }
                var comparison = Object(_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, dirtyBaseDate);
                if (isNaN(comparison)) {
                    throw new RangeError('Invalid time value');
                }
                var localizeOptions = Object(_lib_cloneObject_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(options);
                localizeOptions.addSuffix = Boolean(options.addSuffix);
                localizeOptions.comparison = comparison;
                var dateLeft;
                var dateRight;
                if (comparison > 0) {
                    dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyBaseDate);
                    dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
                }
                else {
                    dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
                    dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyBaseDate);
                }
                var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
                var roundingMethodFn;
                if (roundingMethod === 'floor') {
                    roundingMethodFn = Math.floor;
                }
                else if (roundingMethod === 'ceil') {
                    roundingMethodFn = Math.ceil;
                }
                else if (roundingMethod === 'round') {
                    roundingMethodFn = Math.round;
                }
                else {
                    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
                }
                var seconds = Object(_differenceInSeconds_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dateRight, dateLeft);
                var offsetInSeconds = (Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dateRight) - Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dateLeft)) / 1000;
                var minutes = roundingMethodFn((seconds - offsetInSeconds) / 60);
                var unit;
                if (options.unit == null) {
                    if (minutes < 1) {
                        unit = 'second';
                    }
                    else if (minutes < 60) {
                        unit = 'minute';
                    }
                    else if (minutes < MINUTES_IN_DAY) {
                        unit = 'hour';
                    }
                    else if (minutes < MINUTES_IN_MONTH) {
                        unit = 'day';
                    }
                    else if (minutes < MINUTES_IN_YEAR) {
                        unit = 'month';
                    }
                    else {
                        unit = 'year';
                    }
                }
                else {
                    unit = String(options.unit);
                } // 0 up to 60 seconds
                if (unit === 'second') {
                    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
                }
                else if (unit === 'minute') {
                    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 1 up to 24 hours
                }
                else if (unit === 'hour') {
                    var hours = roundingMethodFn(minutes / 60);
                    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
                }
                else if (unit === 'day') {
                    var days = roundingMethodFn(minutes / MINUTES_IN_DAY);
                    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
                }
                else if (unit === 'month') {
                    var months = roundingMethodFn(minutes / MINUTES_IN_MONTH);
                    return locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
                }
                else if (unit === 'year') {
                    var years = roundingMethodFn(minutes / MINUTES_IN_YEAR);
                    return locale.formatDistance('xYears', years, localizeOptions);
                }
                throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/formatDistanceToNow/index.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/date-fns/esm/formatDistanceToNow/index.js ***!
          \****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return formatDistanceToNow; });
            /* harmony import */ var _formatDistance_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../formatDistance/index.js */ "./node_modules/date-fns/esm/formatDistance/index.js");
            /**
             * @name formatDistanceToNow
             * @category Common Helpers
             * @summary Return the distance between the given date and now in words.
             * @pure false
             *
             * @description
             * Return the distance between the given date and now in words.
             *
             * | Distance to now                                                   | Result              |
             * |-------------------------------------------------------------------|---------------------|
             * | 0 ... 30 secs                                                     | less than a minute  |
             * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
             * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
             * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
             * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
             * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
             * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
             * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
             * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
             * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
             * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
             * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
             * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
             * | N yrs ... N yrs 3 months                                          | about N years       |
             * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
             * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
             *
             * With `options.includeSeconds == true`:
             * | Distance to now     | Result               |
             * |---------------------|----------------------|
             * | 0 secs ... 5 secs   | less than 5 seconds  |
             * | 5 secs ... 10 secs  | less than 10 seconds |
             * | 10 secs ... 20 secs | less than 20 seconds |
             * | 20 secs ... 40 secs | half a minute        |
             * | 40 secs ... 60 secs | less than a minute   |
             * | 60 secs ... 90 secs | 1 minute             |
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
             *   to make its name consistent with `format` and `formatRelative`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
             *   //=> 'in 6 months'
             *
             *   // v2.0.0 onward
             *
             *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
             *   //=> 'in 6 months'
             *   ```
             *
             * @param {Date|Number} date - the given date
             * @param {Object} [options] - the object with options
             * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
             * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @returns {String} the distance in words
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.locale` must contain `formatDistance` property
             *
             * @example
             * // If today is 1 January 2015, what is the distance to 2 July 2014?
             * var result = formatDistanceToNow(
             *   new Date(2014, 6, 2)
             * )
             * //=> '6 months'
             *
             * @example
             * // If now is 1 January 2015 00:00:00,
             * // what is the distance to 1 January 2015 00:00:15, including seconds?
             * var result = formatDistanceToNow(
             *   new Date(2015, 0, 1, 0, 0, 15),
             *   {includeSeconds: true}
             * )
             * //=> 'less than 20 seconds'
             *
             * @example
             * // If today is 1 January 2015,
             * // what is the distance to 1 January 2016, with a suffix?
             * var result = formatDistanceToNow(
             *   new Date(2016, 0, 1),
             *   {addSuffix: true}
             * )
             * //=> 'in about 1 year'
             *
             * @example
             * // If today is 1 January 2015,
             * // what is the distance to 1 August 2016 in Esperanto?
             * var eoLocale = require('date-fns/locale/eo')
             * var result = formatDistanceToNow(
             *   new Date(2016, 7, 1),
             *   {locale: eoLocale}
             * )
             * //=> 'pli ol 1 jaro'
             */
            function formatDistanceToNow(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_formatDistance_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, Date.now(), dirtyOptions);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/formatRelative/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/formatRelative/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return formatRelative; });
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /* harmony import */ var _format_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../format/index.js */ "./node_modules/date-fns/esm/format/index.js");
            /* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../locale/en-US/index.js */ "./node_modules/date-fns/esm/locale/en-US/index.js");
            /* harmony import */ var _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../subMilliseconds/index.js */ "./node_modules/date-fns/esm/subMilliseconds/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /**
             * @name formatRelative
             * @category Common Helpers
             * @summary Represent the date in words relative to the given base date.
             *
             * @description
             * Represent the date in words relative to the given base date.
             *
             * | Distance to the base date | Result                    |
             * |---------------------------|---------------------------|
             * | Previous 6 days           | last Sunday at 04:30 AM   |
             * | Last day                  | yesterday at 04:30 AM     |
             * | Same day                  | today at 04:30 AM         |
             * | Next day                  | tomorrow at 04:30 AM      |
             * | Next 6 days               | Sunday at 04:30 AM        |
             * | Other                     | 12/31/2017                |
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to format
             * @param {Date|Number} baseDate - the date to compare with
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {String} the date in words
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.locale` must contain `localize` property
             * @throws {RangeError} `options.locale` must contain `formatLong` property
             * @throws {RangeError} `options.locale` must contain `formatRelative` property
             */
            function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyDate);
                var baseDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyBaseDate);
                var options = dirtyOptions || {};
                var locale = options.locale || _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_2__["default"];
                if (!locale.localize) {
                    throw new RangeError('locale must contain localize property');
                }
                if (!locale.formatLong) {
                    throw new RangeError('locale must contain formatLong property');
                }
                if (!locale.formatRelative) {
                    throw new RangeError('locale must contain formatRelative property');
                }
                var diff = Object(_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date, baseDate);
                if (isNaN(diff)) {
                    throw new RangeError('Invalid time value');
                }
                var token;
                if (diff < -6) {
                    token = 'other';
                }
                else if (diff < -1) {
                    token = 'lastWeek';
                }
                else if (diff < 0) {
                    token = 'yesterday';
                }
                else if (diff < 1) {
                    token = 'today';
                }
                else if (diff < 2) {
                    token = 'tomorrow';
                }
                else if (diff < 7) {
                    token = 'nextWeek';
                }
                else {
                    token = 'other';
                }
                var utcDate = Object(_subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(date));
                var utcBaseDate = Object(_subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(baseDate, Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(baseDate));
                var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, options);
                return Object(_format_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, formatStr, options);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/fromUnixTime/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/fromUnixTime/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return fromUnixTime; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name fromUnixTime
             * @category Timestamp Helpers
             * @summary Create a date from a Unix timestamp.
             *
             * @description
             * Create a date from a Unix timestamp.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Number} unixTime - the given Unix timestamp
             * @returns {Date} the date
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Create the date 29 February 2012 11:45:05:
             * var result = fromUnixTime(1330515905)
             * //=> Wed Feb 29 2012 11:45:05
             */
            function fromUnixTime(dirtyUnixTime) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var unixTime = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyUnixTime);
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(unixTime * 1000);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getDate/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/getDate/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getDate; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getDate
             * @category Day Helpers
             * @summary Get the day of the month of the given date.
             *
             * @description
             * Get the day of the month of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the day of month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which day of the month is 29 February 2012?
             * var result = getDate(new Date(2012, 1, 29))
             * //=> 29
             */
            function getDate(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var dayOfMonth = date.getDate();
                return dayOfMonth;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getDay/index.js": 
        /*!***************************************************!*\
          !*** ./node_modules/date-fns/esm/getDay/index.js ***!
          \***************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getDay; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getDay
             * @category Weekday Helpers
             * @summary Get the day of the week of the given date.
             *
             * @description
             * Get the day of the week of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the day of week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which day of the week is 29 February 2012?
             * var result = getDay(new Date(2012, 1, 29))
             * //=> 3
             */
            function getDay(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getDay();
                return day;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getDayOfYear/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/getDayOfYear/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getDayOfYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfYear/index.js */ "./node_modules/date-fns/esm/startOfYear/index.js");
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /**
             * @name getDayOfYear
             * @category Day Helpers
             * @summary Get the day of the year of the given date.
             *
             * @description
             * Get the day of the year of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the day of year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which day of the year is 2 July 2014?
             * var result = getDayOfYear(new Date(2014, 6, 2))
             * //=> 183
             */
            function getDayOfYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var diff = Object(_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date, Object(_startOfYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date));
                var dayOfYear = diff + 1;
                return dayOfYear;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getDaysInMonth/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/getDaysInMonth/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getDaysInMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getDaysInMonth
             * @category Month Helpers
             * @summary Get the number of days in a month of the given date.
             *
             * @description
             * Get the number of days in a month of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the number of days in a month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // How many days are in February 2000?
             * var result = getDaysInMonth(new Date(2000, 1))
             * //=> 29
             */
            function getDaysInMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                var monthIndex = date.getMonth();
                var lastDayOfMonth = new Date(0);
                lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
                lastDayOfMonth.setHours(0, 0, 0, 0);
                return lastDayOfMonth.getDate();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getDaysInYear/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/getDaysInYear/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getDaysInYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _isLeapYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../isLeapYear/index.js */ "./node_modules/date-fns/esm/isLeapYear/index.js");
            /**
             * @name getDaysInYear
             * @category Year Helpers
             * @summary Get the number of days in a year of the given date.
             *
             * @description
             * Get the number of days in a year of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the number of days in a year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // How many days are in 2012?
             * var result = getDaysInYear(new Date(2012, 0, 1))
             * //=> 366
             */
            function getDaysInYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                if (isNaN(date)) {
                    return NaN;
                }
                return Object(_isLeapYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date) ? 366 : 365;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getDecade/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/getDecade/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getDecade; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getDecade
             * @category Decade Helpers
             * @summary Get the decade of the given date.
             *
             * @description
             * Get the decade of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the year of decade
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which decade belongs 27 November 1942?
             * var result = getDecade(new Date(1942, 10, 27))
             * //=> 1940
             */
            function getDecade(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                var decade = Math.floor(year / 10) * 10;
                return decade;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getHours/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/getHours/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getHours; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getHours
             * @category Hour Helpers
             * @summary Get the hours of the given date.
             *
             * @description
             * Get the hours of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the hours
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Get the hours of 29 February 2012 11:45:00:
             * var result = getHours(new Date(2012, 1, 29, 11, 45))
             * //=> 11
             */
            function getHours(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var hours = date.getHours();
                return hours;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getISODay/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/getISODay/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getISODay; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getISODay
             * @category Weekday Helpers
             * @summary Get the day of the ISO week of the given date.
             *
             * @description
             * Get the day of the ISO week of the given date,
             * which is 7 for Sunday, 1 for Monday etc.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the day of ISO week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which day of the ISO week is 26 February 2012?
             * var result = getISODay(new Date(2012, 1, 26))
             * //=> 7
             */
            function getISODay(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getDay();
                if (day === 0) {
                    day = 7;
                }
                return day;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getISOWeek/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/getISOWeek/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getISOWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            /* harmony import */ var _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/startOfISOWeekYear/index.js");
            var MILLISECONDS_IN_WEEK = 604800000;
            /**
             * @name getISOWeek
             * @category ISO Week Helpers
             * @summary Get the ISO week of the given date.
             *
             * @description
             * Get the ISO week of the given date.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the ISO week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which week of the ISO-week numbering year is 2 January 2005?
             * var result = getISOWeek(new Date(2005, 0, 2))
             * //=> 53
             */
            function getISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var diff = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date).getTime() - Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date).getTime(); // Round the number of days to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getISOWeekYear/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/getISOWeekYear/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getISOWeekYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            /**
             * @name getISOWeekYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Get the ISO week-numbering year of the given date.
             *
             * @description
             * Get the ISO week-numbering year of the given date,
             * which always starts 3 days before the year's first Thursday.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `getISOYear` to `getISOWeekYear`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the ISO week-numbering year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which ISO-week numbering year is 2 January 2005?
             * var result = getISOWeekYear(new Date(2005, 0, 2))
             * //=> 2004
             */
            function getISOWeekYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                var fourthOfJanuaryOfNextYear = new Date(0);
                fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
                fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
                var startOfNextYear = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuaryOfNextYear);
                var fourthOfJanuaryOfThisYear = new Date(0);
                fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
                fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
                var startOfThisYear = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuaryOfThisYear);
                if (date.getTime() >= startOfNextYear.getTime()) {
                    return year + 1;
                }
                else if (date.getTime() >= startOfThisYear.getTime()) {
                    return year;
                }
                else {
                    return year - 1;
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getISOWeeksInYear/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/getISOWeeksInYear/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getISOWeeksInYear; });
            /* harmony import */ var _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/startOfISOWeekYear/index.js");
            /* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addWeeks/index.js */ "./node_modules/date-fns/esm/addWeeks/index.js");
            var MILLISECONDS_IN_WEEK = 604800000;
            /**
             * @name getISOWeeksInYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Get the number of weeks in an ISO week-numbering year of the given date.
             *
             * @description
             * Get the number of weeks in an ISO week-numbering year of the given date.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the number of ISO weeks in a year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // How many weeks are in ISO week-numbering year 2015?
             * var result = getISOWeeksInYear(new Date(2015, 1, 11))
             * //=> 53
             */
            function getISOWeeksInYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var thisYear = Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var nextYear = Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Object(_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(thisYear, 60));
                var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round(diff / MILLISECONDS_IN_WEEK);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getMilliseconds/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/getMilliseconds/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getMilliseconds; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getMilliseconds
             * @category Millisecond Helpers
             * @summary Get the milliseconds of the given date.
             *
             * @description
             * Get the milliseconds of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the milliseconds
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Get the milliseconds of 29 February 2012 11:45:05.123:
             * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
             * //=> 123
             */
            function getMilliseconds(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var milliseconds = date.getMilliseconds();
                return milliseconds;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getMinutes/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/getMinutes/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getMinutes; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getMinutes
             * @category Minute Helpers
             * @summary Get the minutes of the given date.
             *
             * @description
             * Get the minutes of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the minutes
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Get the minutes of 29 February 2012 11:45:05:
             * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
             * //=> 45
             */
            function getMinutes(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var minutes = date.getMinutes();
                return minutes;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getMonth/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/getMonth/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getMonth
             * @category Month Helpers
             * @summary Get the month of the given date.
             *
             * @description
             * Get the month of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which month is 29 February 2012?
             * var result = getMonth(new Date(2012, 1, 29))
             * //=> 1
             */
            function getMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var month = date.getMonth();
                return month;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js": 
        /*!**************************************************************************!*\
          !*** ./node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js ***!
          \**************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getOverlappingDaysInIntervals; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
            /**
             * @name getOverlappingDaysInIntervals
             * @category Interval Helpers
             * @summary Get the number of days that overlap in two time intervals
             *
             * @description
             * Get the number of days that overlap in two time intervals
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
             *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
             *
             *   ```
             *   2.1.3
             *   time interval
             *   part of the time axis limited by two instants
             *   ```
             *
             *   Also, this function now accepts an object with `start` and `end` properties
             *   instead of two arguments as an interval.
             *   This function now throws `RangeError` if the start of the interval is after its end
             *   or if any date in the interval is `Invalid Date`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   getOverlappingDaysInRanges(
             *     new Date(2014, 0, 10), new Date(2014, 0, 20),
             *     new Date(2014, 0, 17), new Date(2014, 0, 21)
             *   )
             *
             *   // v2.0.0 onward
             *
             *   getOverlappingDaysInIntervals(
             *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
             *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
             *   )
             *   ```
             *
             * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
             * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
             * @returns {Number} the number of days that overlap in two time intervals
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} The start of an interval cannot be after its end
             * @throws {RangeError} Date in interval cannot be `Invalid Date`
             *
             * @example
             * // For overlapping time intervals adds 1 for each started overlapping day:
             * getOverlappingDaysInIntervals(
             *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
             *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
             * )
             * //=> 3
             *
             * @example
             * // For non-overlapping time intervals returns 0:
             * getOverlappingDaysInIntervals(
             *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
             *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
             * )
             * //=> 0
             */
            function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var intervalLeft = dirtyIntervalLeft || {};
                var intervalRight = dirtyIntervalRight || {};
                var leftStartTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalLeft.start).getTime();
                var leftEndTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalLeft.end).getTime();
                var rightStartTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalRight.start).getTime();
                var rightEndTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
                if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
                    throw new RangeError('Invalid interval');
                }
                var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
                if (!isOverlapping) {
                    return 0;
                }
                var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
                var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
                var differenceInMs = overlapEndDate - overlapStartDate;
                return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getQuarter/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/getQuarter/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getQuarter; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getQuarter
             * @category Quarter Helpers
             * @summary Get the year quarter of the given date.
             *
             * @description
             * Get the year quarter of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the quarter
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which quarter is 2 July 2014?
             * var result = getQuarter(new Date(2014, 6, 2))
             * //=> 3
             */
            function getQuarter(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var quarter = Math.floor(date.getMonth() / 3) + 1;
                return quarter;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getSeconds/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/getSeconds/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getSeconds; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getSeconds
             * @category Second Helpers
             * @summary Get the seconds of the given date.
             *
             * @description
             * Get the seconds of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the seconds
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Get the seconds of 29 February 2012 11:45:05.123:
             * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
             * //=> 5
             */
            function getSeconds(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var seconds = date.getSeconds();
                return seconds;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getTime/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/getTime/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getTime; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getTime
             * @category Timestamp Helpers
             * @summary Get the milliseconds timestamp of the given date.
             *
             * @description
             * Get the milliseconds timestamp of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the timestamp
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Get the timestamp of 29 February 2012 11:45:05.123:
             * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
             * //=> 1330515905123
             */
            function getTime(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var timestamp = date.getTime();
                return timestamp;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getUnixTime/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/getUnixTime/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getUnixTime; });
            /* harmony import */ var _getTime_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getTime/index.js */ "./node_modules/date-fns/esm/getTime/index.js");
            /**
             * @name getUnixTime
             * @category Timestamp Helpers
             * @summary Get the seconds timestamp of the given date.
             *
             * @description
             * Get the seconds timestamp of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the timestamp
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Get the timestamp of 29 February 2012 11:45:05 CET:
             * var result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
             * //=> 1330512305
             */
            function getUnixTime(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Math.floor(Object(_getTime_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate) / 1000);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getWeek/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/getWeek/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getWeek; });
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /* harmony import */ var _startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfWeekYear/index.js */ "./node_modules/date-fns/esm/startOfWeekYear/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            var MILLISECONDS_IN_WEEK = 604800000;
            /**
             * @name getWeek
             * @category Week Helpers
             * @summary Get the local week index of the given date.
             *
             * @description
             * Get the local week index of the given date.
             * The exact calculation depends on the values of
             * `options.weekStartsOn` (which is the index of the first day of the week)
             * and `options.firstWeekContainsDate` (which is the day of January, which is always in
             * the first week of the week-numbering year)
             *
             * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
             * @returns {Number} the week
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             *
             * @example
             * // Which week of the local week numbering year is 2 January 2005 with default options?
             * var result = getISOWeek(new Date(2005, 0, 2))
             * //=> 2
             *
             * // Which week of the local week numbering year is 2 January 2005,
             * // if Monday is the first day of the week,
             * // and the first week of the year always contains 4 January?
             * var result = getISOWeek(new Date(2005, 0, 2), {
             *   weekStartsOn: 1,
             *   firstWeekContainsDate: 4
             * })
             * //=> 53
             */
            function getWeek(dirtyDate, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
                var diff = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date, options).getTime() - Object(_startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, options).getTime(); // Round the number of days to the nearest integer
                // because the number of milliseconds in a week is not constant
                // (e.g. it's different in the week of the daylight saving time clock shift)
                return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getWeekOfMonth/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/getWeekOfMonth/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getWeekOfMonth; });
            /* harmony import */ var _getDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getDate/index.js */ "./node_modules/date-fns/esm/getDate/index.js");
            /* harmony import */ var _getDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../getDay/index.js */ "./node_modules/date-fns/esm/getDay/index.js");
            /* harmony import */ var _startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfMonth/index.js */ "./node_modules/date-fns/esm/startOfMonth/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name getWeekOfMonth
             * @category Week Helpers
             * @summary Get the week of the month of the given date.
             *
             * @description
             * Get the week of the month of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Number} the week of month
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // Which week of the month is 9 November 2017?
             * var result = getWeekOfMonth(new Date(2017, 10, 9))
             * //=> 2
             */
            function getWeekOfMonth(date, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                var currentDayOfMonth = Object(_getDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date);
                if (isNaN(currentDayOfMonth)) {
                    return currentDayOfMonth;
                }
                var startWeekDay = Object(_getDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(Object(_startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date));
                var lastDayOfFirstWeek = 0;
                if (startWeekDay >= weekStartsOn) {
                    lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
                }
                else {
                    lastDayOfFirstWeek = weekStartsOn - startWeekDay;
                }
                var weekNumber = 1;
                if (currentDayOfMonth > lastDayOfFirstWeek) {
                    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
                    weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
                }
                return weekNumber;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getWeekYear/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/getWeekYear/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getWeekYear; });
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name getWeekYear
             * @category Week-Numbering Year Helpers
             * @summary Get the local week-numbering year of the given date.
             *
             * @description
             * Get the local week-numbering year of the given date.
             * The exact calculation depends on the values of
             * `options.weekStartsOn` (which is the index of the first day of the week)
             * and `options.firstWeekContainsDate` (which is the day of January, which is always in
             * the first week of the week-numbering year)
             *
             * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
             * @returns {Number} the local week-numbering year
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             *
             * @example
             * // Which week numbering year is 26 December 2004 with the default settings?
             * var result = getWeekYear(new Date(2004, 11, 26))
             * //=> 2005
             *
             * @example
             * // Which week numbering year is 26 December 2004 if week starts on Saturday?
             * var result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
             * //=> 2004
             *
             * @example
             * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
             * var result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
             * //=> 2004
             */
            function getWeekYear(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var year = date.getFullYear();
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
                if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
                    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                }
                var firstWeekOfNextYear = new Date(0);
                firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
                firstWeekOfNextYear.setHours(0, 0, 0, 0);
                var startOfNextYear = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(firstWeekOfNextYear, dirtyOptions);
                var firstWeekOfThisYear = new Date(0);
                firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
                firstWeekOfThisYear.setHours(0, 0, 0, 0);
                var startOfThisYear = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(firstWeekOfThisYear, dirtyOptions);
                if (date.getTime() >= startOfNextYear.getTime()) {
                    return year + 1;
                }
                else if (date.getTime() >= startOfThisYear.getTime()) {
                    return year;
                }
                else {
                    return year - 1;
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getWeeksInMonth/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/getWeeksInMonth/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getWeeksInMonth; });
            /* harmony import */ var _differenceInCalendarWeeks_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInCalendarWeeks/index.js */ "./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js");
            /* harmony import */ var _lastDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lastDayOfMonth/index.js */ "./node_modules/date-fns/esm/lastDayOfMonth/index.js");
            /* harmony import */ var _startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfMonth/index.js */ "./node_modules/date-fns/esm/startOfMonth/index.js");
            /**
             * @name getWeeksInMonth
             * @category Week Helpers
             * @summary Get the number of calendar weeks a month spans.
             *
             * @description
             * Get the number of calendar weeks the month in the given date spans.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Number} the number of calendar weeks
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // How many calendar weeks does February 2015 span?
             * var result = getWeeksInMonth(new Date(2015, 1, 8))
             * //=> 4
             *
             * @example
             * // If the week starts on Monday,
             * // how many calendar weeks does July 2017 span?
             * var result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
             * //=> 6
             */
            function getWeeksInMonth(date, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_differenceInCalendarWeeks_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Object(_lastDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date), Object(_startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date), options) + 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/getYear/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/getYear/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return getYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name getYear
             * @category Year Helpers
             * @summary Get the year of the given date.
             *
             * @description
             * Get the year of the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the given date
             * @returns {Number} the year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which year is 2 July 2014?
             * var result = getYear(new Date(2014, 6, 2))
             * //=> 2014
             */
            function getYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                return year;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/index.js": 
        /*!********************************************!*\
          !*** ./node_modules/date-fns/esm/index.js ***!
          \********************************************/
        /*! exports provided: addBusinessDays, addDays, addHours, addISOWeekYears, addMilliseconds, addMinutes, addMonths, addQuarters, addSeconds, addWeeks, addYears, areIntervalsOverlapping, closestIndexTo, closestTo, compareAsc, compareDesc, differenceInBusinessDays, differenceInCalendarDays, differenceInCalendarISOWeekYears, differenceInCalendarISOWeeks, differenceInCalendarMonths, differenceInCalendarQuarters, differenceInCalendarWeeks, differenceInCalendarYears, differenceInDays, differenceInHours, differenceInISOWeekYears, differenceInMilliseconds, differenceInMinutes, differenceInMonths, differenceInQuarters, differenceInSeconds, differenceInWeeks, differenceInYears, eachDayOfInterval, eachWeekOfInterval, eachWeekendOfInterval, eachWeekendOfMonth, eachWeekendOfYear, endOfDay, endOfDecade, endOfHour, endOfISOWeek, endOfISOWeekYear, endOfMinute, endOfMonth, endOfQuarter, endOfSecond, endOfToday, endOfTomorrow, endOfWeek, endOfYear, endOfYesterday, format, formatDistance, formatDistanceStrict, formatDistanceToNow, formatRelative, fromUnixTime, getDate, getDay, getDayOfYear, getDaysInMonth, getDaysInYear, getDecade, getHours, getISODay, getISOWeek, getISOWeekYear, getISOWeeksInYear, getMilliseconds, getMinutes, getMonth, getOverlappingDaysInIntervals, getQuarter, getSeconds, getTime, getUnixTime, getWeek, getWeekOfMonth, getWeekYear, getWeeksInMonth, getYear, isAfter, isBefore, isDate, isEqual, isFirstDayOfMonth, isFriday, isFuture, isLastDayOfMonth, isLeapYear, isMonday, isPast, isSameDay, isSameHour, isSameISOWeek, isSameISOWeekYear, isSameMinute, isSameMonth, isSameQuarter, isSameSecond, isSameWeek, isSameYear, isSaturday, isSunday, isThisHour, isThisISOWeek, isThisMinute, isThisMonth, isThisQuarter, isThisSecond, isThisWeek, isThisYear, isThursday, isToday, isTomorrow, isTuesday, isValid, isWednesday, isWeekend, isWithinInterval, isYesterday, lastDayOfDecade, lastDayOfISOWeek, lastDayOfISOWeekYear, lastDayOfMonth, lastDayOfQuarter, lastDayOfWeek, lastDayOfYear, lightFormat, max, min, parse, parseISO, parseJSON, roundToNearestMinutes, set, setDate, setDay, setDayOfYear, setHours, setISODay, setISOWeek, setISOWeekYear, setMilliseconds, setMinutes, setMonth, setQuarter, setSeconds, setWeek, setWeekYear, setYear, startOfDay, startOfDecade, startOfHour, startOfISOWeek, startOfISOWeekYear, startOfMinute, startOfMonth, startOfQuarter, startOfSecond, startOfToday, startOfTomorrow, startOfWeek, startOfWeekYear, startOfYear, startOfYesterday, subBusinessDays, subDays, subHours, subISOWeekYears, subMilliseconds, subMinutes, subMonths, subQuarters, subSeconds, subWeeks, subYears, toDate, maxTime, minTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _addBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./addBusinessDays/index.js */ "./node_modules/date-fns/esm/addBusinessDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addBusinessDays", function () { return _addBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addDays", function () { return _addDays_index_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });
            /* harmony import */ var _addHours_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./addHours/index.js */ "./node_modules/date-fns/esm/addHours/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addHours", function () { return _addHours_index_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });
            /* harmony import */ var _addISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./addISOWeekYears/index.js */ "./node_modules/date-fns/esm/addISOWeekYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addISOWeekYears", function () { return _addISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });
            /* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./addMilliseconds/index.js */ "./node_modules/date-fns/esm/addMilliseconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addMilliseconds", function () { return _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });
            /* harmony import */ var _addMinutes_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./addMinutes/index.js */ "./node_modules/date-fns/esm/addMinutes/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addMinutes", function () { return _addMinutes_index_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });
            /* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./addMonths/index.js */ "./node_modules/date-fns/esm/addMonths/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addMonths", function () { return _addMonths_index_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });
            /* harmony import */ var _addQuarters_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./addQuarters/index.js */ "./node_modules/date-fns/esm/addQuarters/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addQuarters", function () { return _addQuarters_index_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });
            /* harmony import */ var _addSeconds_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./addSeconds/index.js */ "./node_modules/date-fns/esm/addSeconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addSeconds", function () { return _addSeconds_index_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });
            /* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./addWeeks/index.js */ "./node_modules/date-fns/esm/addWeeks/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addWeeks", function () { return _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });
            /* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./addYears/index.js */ "./node_modules/date-fns/esm/addYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addYears", function () { return _addYears_index_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });
            /* harmony import */ var _areIntervalsOverlapping_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./areIntervalsOverlapping/index.js */ "./node_modules/date-fns/esm/areIntervalsOverlapping/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "areIntervalsOverlapping", function () { return _areIntervalsOverlapping_index_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });
            /* harmony import */ var _closestIndexTo_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./closestIndexTo/index.js */ "./node_modules/date-fns/esm/closestIndexTo/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "closestIndexTo", function () { return _closestIndexTo_index_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });
            /* harmony import */ var _closestTo_index_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./closestTo/index.js */ "./node_modules/date-fns/esm/closestTo/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "closestTo", function () { return _closestTo_index_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });
            /* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./compareAsc/index.js */ "./node_modules/date-fns/esm/compareAsc/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "compareAsc", function () { return _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });
            /* harmony import */ var _compareDesc_index_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./compareDesc/index.js */ "./node_modules/date-fns/esm/compareDesc/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "compareDesc", function () { return _compareDesc_index_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });
            /* harmony import */ var _differenceInBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./differenceInBusinessDays/index.js */ "./node_modules/date-fns/esm/differenceInBusinessDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInBusinessDays", function () { return _differenceInBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarDays", function () { return _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });
            /* harmony import */ var _differenceInCalendarISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./differenceInCalendarISOWeekYears/index.js */ "./node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarISOWeekYears", function () { return _differenceInCalendarISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });
            /* harmony import */ var _differenceInCalendarISOWeeks_index_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./differenceInCalendarISOWeeks/index.js */ "./node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarISOWeeks", function () { return _differenceInCalendarISOWeeks_index_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });
            /* harmony import */ var _differenceInCalendarMonths_index_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./differenceInCalendarMonths/index.js */ "./node_modules/date-fns/esm/differenceInCalendarMonths/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarMonths", function () { return _differenceInCalendarMonths_index_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });
            /* harmony import */ var _differenceInCalendarQuarters_index_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./differenceInCalendarQuarters/index.js */ "./node_modules/date-fns/esm/differenceInCalendarQuarters/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarQuarters", function () { return _differenceInCalendarQuarters_index_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });
            /* harmony import */ var _differenceInCalendarWeeks_index_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./differenceInCalendarWeeks/index.js */ "./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarWeeks", function () { return _differenceInCalendarWeeks_index_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });
            /* harmony import */ var _differenceInCalendarYears_index_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./differenceInCalendarYears/index.js */ "./node_modules/date-fns/esm/differenceInCalendarYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarYears", function () { return _differenceInCalendarYears_index_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });
            /* harmony import */ var _differenceInDays_index_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./differenceInDays/index.js */ "./node_modules/date-fns/esm/differenceInDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInDays", function () { return _differenceInDays_index_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });
            /* harmony import */ var _differenceInHours_index_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./differenceInHours/index.js */ "./node_modules/date-fns/esm/differenceInHours/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInHours", function () { return _differenceInHours_index_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });
            /* harmony import */ var _differenceInISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./differenceInISOWeekYears/index.js */ "./node_modules/date-fns/esm/differenceInISOWeekYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInISOWeekYears", function () { return _differenceInISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });
            /* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./differenceInMilliseconds/index.js */ "./node_modules/date-fns/esm/differenceInMilliseconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInMilliseconds", function () { return _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_27__["default"]; });
            /* harmony import */ var _differenceInMinutes_index_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./differenceInMinutes/index.js */ "./node_modules/date-fns/esm/differenceInMinutes/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInMinutes", function () { return _differenceInMinutes_index_js__WEBPACK_IMPORTED_MODULE_28__["default"]; });
            /* harmony import */ var _differenceInMonths_index_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./differenceInMonths/index.js */ "./node_modules/date-fns/esm/differenceInMonths/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInMonths", function () { return _differenceInMonths_index_js__WEBPACK_IMPORTED_MODULE_29__["default"]; });
            /* harmony import */ var _differenceInQuarters_index_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./differenceInQuarters/index.js */ "./node_modules/date-fns/esm/differenceInQuarters/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInQuarters", function () { return _differenceInQuarters_index_js__WEBPACK_IMPORTED_MODULE_30__["default"]; });
            /* harmony import */ var _differenceInSeconds_index_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./differenceInSeconds/index.js */ "./node_modules/date-fns/esm/differenceInSeconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInSeconds", function () { return _differenceInSeconds_index_js__WEBPACK_IMPORTED_MODULE_31__["default"]; });
            /* harmony import */ var _differenceInWeeks_index_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./differenceInWeeks/index.js */ "./node_modules/date-fns/esm/differenceInWeeks/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInWeeks", function () { return _differenceInWeeks_index_js__WEBPACK_IMPORTED_MODULE_32__["default"]; });
            /* harmony import */ var _differenceInYears_index_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./differenceInYears/index.js */ "./node_modules/date-fns/esm/differenceInYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "differenceInYears", function () { return _differenceInYears_index_js__WEBPACK_IMPORTED_MODULE_33__["default"]; });
            /* harmony import */ var _eachDayOfInterval_index_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./eachDayOfInterval/index.js */ "./node_modules/date-fns/esm/eachDayOfInterval/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "eachDayOfInterval", function () { return _eachDayOfInterval_index_js__WEBPACK_IMPORTED_MODULE_34__["default"]; });
            /* harmony import */ var _eachWeekOfInterval_index_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./eachWeekOfInterval/index.js */ "./node_modules/date-fns/esm/eachWeekOfInterval/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "eachWeekOfInterval", function () { return _eachWeekOfInterval_index_js__WEBPACK_IMPORTED_MODULE_35__["default"]; });
            /* harmony import */ var _eachWeekendOfInterval_index_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./eachWeekendOfInterval/index.js */ "./node_modules/date-fns/esm/eachWeekendOfInterval/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "eachWeekendOfInterval", function () { return _eachWeekendOfInterval_index_js__WEBPACK_IMPORTED_MODULE_36__["default"]; });
            /* harmony import */ var _eachWeekendOfMonth_index_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./eachWeekendOfMonth/index.js */ "./node_modules/date-fns/esm/eachWeekendOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "eachWeekendOfMonth", function () { return _eachWeekendOfMonth_index_js__WEBPACK_IMPORTED_MODULE_37__["default"]; });
            /* harmony import */ var _eachWeekendOfYear_index_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./eachWeekendOfYear/index.js */ "./node_modules/date-fns/esm/eachWeekendOfYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "eachWeekendOfYear", function () { return _eachWeekendOfYear_index_js__WEBPACK_IMPORTED_MODULE_38__["default"]; });
            /* harmony import */ var _endOfDay_index_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./endOfDay/index.js */ "./node_modules/date-fns/esm/endOfDay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfDay", function () { return _endOfDay_index_js__WEBPACK_IMPORTED_MODULE_39__["default"]; });
            /* harmony import */ var _endOfDecade_index_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./endOfDecade/index.js */ "./node_modules/date-fns/esm/endOfDecade/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfDecade", function () { return _endOfDecade_index_js__WEBPACK_IMPORTED_MODULE_40__["default"]; });
            /* harmony import */ var _endOfHour_index_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./endOfHour/index.js */ "./node_modules/date-fns/esm/endOfHour/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfHour", function () { return _endOfHour_index_js__WEBPACK_IMPORTED_MODULE_41__["default"]; });
            /* harmony import */ var _endOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./endOfISOWeek/index.js */ "./node_modules/date-fns/esm/endOfISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfISOWeek", function () { return _endOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_42__["default"]; });
            /* harmony import */ var _endOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./endOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/endOfISOWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfISOWeekYear", function () { return _endOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_43__["default"]; });
            /* harmony import */ var _endOfMinute_index_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./endOfMinute/index.js */ "./node_modules/date-fns/esm/endOfMinute/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfMinute", function () { return _endOfMinute_index_js__WEBPACK_IMPORTED_MODULE_44__["default"]; });
            /* harmony import */ var _endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./endOfMonth/index.js */ "./node_modules/date-fns/esm/endOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfMonth", function () { return _endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_45__["default"]; });
            /* harmony import */ var _endOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./endOfQuarter/index.js */ "./node_modules/date-fns/esm/endOfQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfQuarter", function () { return _endOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_46__["default"]; });
            /* harmony import */ var _endOfSecond_index_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./endOfSecond/index.js */ "./node_modules/date-fns/esm/endOfSecond/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfSecond", function () { return _endOfSecond_index_js__WEBPACK_IMPORTED_MODULE_47__["default"]; });
            /* harmony import */ var _endOfToday_index_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./endOfToday/index.js */ "./node_modules/date-fns/esm/endOfToday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfToday", function () { return _endOfToday_index_js__WEBPACK_IMPORTED_MODULE_48__["default"]; });
            /* harmony import */ var _endOfTomorrow_index_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./endOfTomorrow/index.js */ "./node_modules/date-fns/esm/endOfTomorrow/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfTomorrow", function () { return _endOfTomorrow_index_js__WEBPACK_IMPORTED_MODULE_49__["default"]; });
            /* harmony import */ var _endOfWeek_index_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./endOfWeek/index.js */ "./node_modules/date-fns/esm/endOfWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfWeek", function () { return _endOfWeek_index_js__WEBPACK_IMPORTED_MODULE_50__["default"]; });
            /* harmony import */ var _endOfYear_index_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./endOfYear/index.js */ "./node_modules/date-fns/esm/endOfYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfYear", function () { return _endOfYear_index_js__WEBPACK_IMPORTED_MODULE_51__["default"]; });
            /* harmony import */ var _endOfYesterday_index_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./endOfYesterday/index.js */ "./node_modules/date-fns/esm/endOfYesterday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endOfYesterday", function () { return _endOfYesterday_index_js__WEBPACK_IMPORTED_MODULE_52__["default"]; });
            /* harmony import */ var _format_index_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./format/index.js */ "./node_modules/date-fns/esm/format/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "format", function () { return _format_index_js__WEBPACK_IMPORTED_MODULE_53__["default"]; });
            /* harmony import */ var _formatDistance_index_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./formatDistance/index.js */ "./node_modules/date-fns/esm/formatDistance/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatDistance", function () { return _formatDistance_index_js__WEBPACK_IMPORTED_MODULE_54__["default"]; });
            /* harmony import */ var _formatDistanceStrict_index_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./formatDistanceStrict/index.js */ "./node_modules/date-fns/esm/formatDistanceStrict/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatDistanceStrict", function () { return _formatDistanceStrict_index_js__WEBPACK_IMPORTED_MODULE_55__["default"]; });
            /* harmony import */ var _formatDistanceToNow_index_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./formatDistanceToNow/index.js */ "./node_modules/date-fns/esm/formatDistanceToNow/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatDistanceToNow", function () { return _formatDistanceToNow_index_js__WEBPACK_IMPORTED_MODULE_56__["default"]; });
            /* harmony import */ var _formatRelative_index_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./formatRelative/index.js */ "./node_modules/date-fns/esm/formatRelative/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatRelative", function () { return _formatRelative_index_js__WEBPACK_IMPORTED_MODULE_57__["default"]; });
            /* harmony import */ var _fromUnixTime_index_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./fromUnixTime/index.js */ "./node_modules/date-fns/esm/fromUnixTime/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromUnixTime", function () { return _fromUnixTime_index_js__WEBPACK_IMPORTED_MODULE_58__["default"]; });
            /* harmony import */ var _getDate_index_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./getDate/index.js */ "./node_modules/date-fns/esm/getDate/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDate", function () { return _getDate_index_js__WEBPACK_IMPORTED_MODULE_59__["default"]; });
            /* harmony import */ var _getDay_index_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./getDay/index.js */ "./node_modules/date-fns/esm/getDay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDay", function () { return _getDay_index_js__WEBPACK_IMPORTED_MODULE_60__["default"]; });
            /* harmony import */ var _getDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./getDayOfYear/index.js */ "./node_modules/date-fns/esm/getDayOfYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDayOfYear", function () { return _getDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_61__["default"]; });
            /* harmony import */ var _getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./getDaysInMonth/index.js */ "./node_modules/date-fns/esm/getDaysInMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDaysInMonth", function () { return _getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_62__["default"]; });
            /* harmony import */ var _getDaysInYear_index_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./getDaysInYear/index.js */ "./node_modules/date-fns/esm/getDaysInYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDaysInYear", function () { return _getDaysInYear_index_js__WEBPACK_IMPORTED_MODULE_63__["default"]; });
            /* harmony import */ var _getDecade_index_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./getDecade/index.js */ "./node_modules/date-fns/esm/getDecade/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDecade", function () { return _getDecade_index_js__WEBPACK_IMPORTED_MODULE_64__["default"]; });
            /* harmony import */ var _getHours_index_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./getHours/index.js */ "./node_modules/date-fns/esm/getHours/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getHours", function () { return _getHours_index_js__WEBPACK_IMPORTED_MODULE_65__["default"]; });
            /* harmony import */ var _getISODay_index_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./getISODay/index.js */ "./node_modules/date-fns/esm/getISODay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getISODay", function () { return _getISODay_index_js__WEBPACK_IMPORTED_MODULE_66__["default"]; });
            /* harmony import */ var _getISOWeek_index_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./getISOWeek/index.js */ "./node_modules/date-fns/esm/getISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getISOWeek", function () { return _getISOWeek_index_js__WEBPACK_IMPORTED_MODULE_67__["default"]; });
            /* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./getISOWeekYear/index.js */ "./node_modules/date-fns/esm/getISOWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getISOWeekYear", function () { return _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_68__["default"]; });
            /* harmony import */ var _getISOWeeksInYear_index_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./getISOWeeksInYear/index.js */ "./node_modules/date-fns/esm/getISOWeeksInYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getISOWeeksInYear", function () { return _getISOWeeksInYear_index_js__WEBPACK_IMPORTED_MODULE_69__["default"]; });
            /* harmony import */ var _getMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./getMilliseconds/index.js */ "./node_modules/date-fns/esm/getMilliseconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMilliseconds", function () { return _getMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_70__["default"]; });
            /* harmony import */ var _getMinutes_index_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./getMinutes/index.js */ "./node_modules/date-fns/esm/getMinutes/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMinutes", function () { return _getMinutes_index_js__WEBPACK_IMPORTED_MODULE_71__["default"]; });
            /* harmony import */ var _getMonth_index_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ./getMonth/index.js */ "./node_modules/date-fns/esm/getMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getMonth", function () { return _getMonth_index_js__WEBPACK_IMPORTED_MODULE_72__["default"]; });
            /* harmony import */ var _getOverlappingDaysInIntervals_index_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ./getOverlappingDaysInIntervals/index.js */ "./node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getOverlappingDaysInIntervals", function () { return _getOverlappingDaysInIntervals_index_js__WEBPACK_IMPORTED_MODULE_73__["default"]; });
            /* harmony import */ var _getQuarter_index_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ./getQuarter/index.js */ "./node_modules/date-fns/esm/getQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getQuarter", function () { return _getQuarter_index_js__WEBPACK_IMPORTED_MODULE_74__["default"]; });
            /* harmony import */ var _getSeconds_index_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ./getSeconds/index.js */ "./node_modules/date-fns/esm/getSeconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getSeconds", function () { return _getSeconds_index_js__WEBPACK_IMPORTED_MODULE_75__["default"]; });
            /* harmony import */ var _getTime_index_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ./getTime/index.js */ "./node_modules/date-fns/esm/getTime/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getTime", function () { return _getTime_index_js__WEBPACK_IMPORTED_MODULE_76__["default"]; });
            /* harmony import */ var _getUnixTime_index_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ./getUnixTime/index.js */ "./node_modules/date-fns/esm/getUnixTime/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getUnixTime", function () { return _getUnixTime_index_js__WEBPACK_IMPORTED_MODULE_77__["default"]; });
            /* harmony import */ var _getWeek_index_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ./getWeek/index.js */ "./node_modules/date-fns/esm/getWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getWeek", function () { return _getWeek_index_js__WEBPACK_IMPORTED_MODULE_78__["default"]; });
            /* harmony import */ var _getWeekOfMonth_index_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ./getWeekOfMonth/index.js */ "./node_modules/date-fns/esm/getWeekOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getWeekOfMonth", function () { return _getWeekOfMonth_index_js__WEBPACK_IMPORTED_MODULE_79__["default"]; });
            /* harmony import */ var _getWeekYear_index_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ./getWeekYear/index.js */ "./node_modules/date-fns/esm/getWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getWeekYear", function () { return _getWeekYear_index_js__WEBPACK_IMPORTED_MODULE_80__["default"]; });
            /* harmony import */ var _getWeeksInMonth_index_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ./getWeeksInMonth/index.js */ "./node_modules/date-fns/esm/getWeeksInMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getWeeksInMonth", function () { return _getWeeksInMonth_index_js__WEBPACK_IMPORTED_MODULE_81__["default"]; });
            /* harmony import */ var _getYear_index_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ./getYear/index.js */ "./node_modules/date-fns/esm/getYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getYear", function () { return _getYear_index_js__WEBPACK_IMPORTED_MODULE_82__["default"]; });
            /* harmony import */ var _isAfter_index_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ./isAfter/index.js */ "./node_modules/date-fns/esm/isAfter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isAfter", function () { return _isAfter_index_js__WEBPACK_IMPORTED_MODULE_83__["default"]; });
            /* harmony import */ var _isBefore_index_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ./isBefore/index.js */ "./node_modules/date-fns/esm/isBefore/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isBefore", function () { return _isBefore_index_js__WEBPACK_IMPORTED_MODULE_84__["default"]; });
            /* harmony import */ var _isDate_index_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ./isDate/index.js */ "./node_modules/date-fns/esm/isDate/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isDate", function () { return _isDate_index_js__WEBPACK_IMPORTED_MODULE_85__["default"]; });
            /* harmony import */ var _isEqual_index_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ./isEqual/index.js */ "./node_modules/date-fns/esm/isEqual/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isEqual", function () { return _isEqual_index_js__WEBPACK_IMPORTED_MODULE_86__["default"]; });
            /* harmony import */ var _isFirstDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ./isFirstDayOfMonth/index.js */ "./node_modules/date-fns/esm/isFirstDayOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isFirstDayOfMonth", function () { return _isFirstDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_87__["default"]; });
            /* harmony import */ var _isFriday_index_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ./isFriday/index.js */ "./node_modules/date-fns/esm/isFriday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isFriday", function () { return _isFriday_index_js__WEBPACK_IMPORTED_MODULE_88__["default"]; });
            /* harmony import */ var _isFuture_index_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ./isFuture/index.js */ "./node_modules/date-fns/esm/isFuture/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isFuture", function () { return _isFuture_index_js__WEBPACK_IMPORTED_MODULE_89__["default"]; });
            /* harmony import */ var _isLastDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ./isLastDayOfMonth/index.js */ "./node_modules/date-fns/esm/isLastDayOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isLastDayOfMonth", function () { return _isLastDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_90__["default"]; });
            /* harmony import */ var _isLeapYear_index_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ./isLeapYear/index.js */ "./node_modules/date-fns/esm/isLeapYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isLeapYear", function () { return _isLeapYear_index_js__WEBPACK_IMPORTED_MODULE_91__["default"]; });
            /* harmony import */ var _isMonday_index_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ./isMonday/index.js */ "./node_modules/date-fns/esm/isMonday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isMonday", function () { return _isMonday_index_js__WEBPACK_IMPORTED_MODULE_92__["default"]; });
            /* harmony import */ var _isPast_index_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ./isPast/index.js */ "./node_modules/date-fns/esm/isPast/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isPast", function () { return _isPast_index_js__WEBPACK_IMPORTED_MODULE_93__["default"]; });
            /* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ./isSameDay/index.js */ "./node_modules/date-fns/esm/isSameDay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameDay", function () { return _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_94__["default"]; });
            /* harmony import */ var _isSameHour_index_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ./isSameHour/index.js */ "./node_modules/date-fns/esm/isSameHour/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameHour", function () { return _isSameHour_index_js__WEBPACK_IMPORTED_MODULE_95__["default"]; });
            /* harmony import */ var _isSameISOWeek_index_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ./isSameISOWeek/index.js */ "./node_modules/date-fns/esm/isSameISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameISOWeek", function () { return _isSameISOWeek_index_js__WEBPACK_IMPORTED_MODULE_96__["default"]; });
            /* harmony import */ var _isSameISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ./isSameISOWeekYear/index.js */ "./node_modules/date-fns/esm/isSameISOWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameISOWeekYear", function () { return _isSameISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_97__["default"]; });
            /* harmony import */ var _isSameMinute_index_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ./isSameMinute/index.js */ "./node_modules/date-fns/esm/isSameMinute/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameMinute", function () { return _isSameMinute_index_js__WEBPACK_IMPORTED_MODULE_98__["default"]; });
            /* harmony import */ var _isSameMonth_index_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ./isSameMonth/index.js */ "./node_modules/date-fns/esm/isSameMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameMonth", function () { return _isSameMonth_index_js__WEBPACK_IMPORTED_MODULE_99__["default"]; });
            /* harmony import */ var _isSameQuarter_index_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ./isSameQuarter/index.js */ "./node_modules/date-fns/esm/isSameQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameQuarter", function () { return _isSameQuarter_index_js__WEBPACK_IMPORTED_MODULE_100__["default"]; });
            /* harmony import */ var _isSameSecond_index_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ./isSameSecond/index.js */ "./node_modules/date-fns/esm/isSameSecond/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameSecond", function () { return _isSameSecond_index_js__WEBPACK_IMPORTED_MODULE_101__["default"]; });
            /* harmony import */ var _isSameWeek_index_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ./isSameWeek/index.js */ "./node_modules/date-fns/esm/isSameWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameWeek", function () { return _isSameWeek_index_js__WEBPACK_IMPORTED_MODULE_102__["default"]; });
            /* harmony import */ var _isSameYear_index_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(/*! ./isSameYear/index.js */ "./node_modules/date-fns/esm/isSameYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSameYear", function () { return _isSameYear_index_js__WEBPACK_IMPORTED_MODULE_103__["default"]; });
            /* harmony import */ var _isSaturday_index_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(/*! ./isSaturday/index.js */ "./node_modules/date-fns/esm/isSaturday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSaturday", function () { return _isSaturday_index_js__WEBPACK_IMPORTED_MODULE_104__["default"]; });
            /* harmony import */ var _isSunday_index_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(/*! ./isSunday/index.js */ "./node_modules/date-fns/esm/isSunday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSunday", function () { return _isSunday_index_js__WEBPACK_IMPORTED_MODULE_105__["default"]; });
            /* harmony import */ var _isThisHour_index_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(/*! ./isThisHour/index.js */ "./node_modules/date-fns/esm/isThisHour/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisHour", function () { return _isThisHour_index_js__WEBPACK_IMPORTED_MODULE_106__["default"]; });
            /* harmony import */ var _isThisISOWeek_index_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(/*! ./isThisISOWeek/index.js */ "./node_modules/date-fns/esm/isThisISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisISOWeek", function () { return _isThisISOWeek_index_js__WEBPACK_IMPORTED_MODULE_107__["default"]; });
            /* harmony import */ var _isThisMinute_index_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(/*! ./isThisMinute/index.js */ "./node_modules/date-fns/esm/isThisMinute/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisMinute", function () { return _isThisMinute_index_js__WEBPACK_IMPORTED_MODULE_108__["default"]; });
            /* harmony import */ var _isThisMonth_index_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(/*! ./isThisMonth/index.js */ "./node_modules/date-fns/esm/isThisMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisMonth", function () { return _isThisMonth_index_js__WEBPACK_IMPORTED_MODULE_109__["default"]; });
            /* harmony import */ var _isThisQuarter_index_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(/*! ./isThisQuarter/index.js */ "./node_modules/date-fns/esm/isThisQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisQuarter", function () { return _isThisQuarter_index_js__WEBPACK_IMPORTED_MODULE_110__["default"]; });
            /* harmony import */ var _isThisSecond_index_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(/*! ./isThisSecond/index.js */ "./node_modules/date-fns/esm/isThisSecond/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisSecond", function () { return _isThisSecond_index_js__WEBPACK_IMPORTED_MODULE_111__["default"]; });
            /* harmony import */ var _isThisWeek_index_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(/*! ./isThisWeek/index.js */ "./node_modules/date-fns/esm/isThisWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisWeek", function () { return _isThisWeek_index_js__WEBPACK_IMPORTED_MODULE_112__["default"]; });
            /* harmony import */ var _isThisYear_index_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(/*! ./isThisYear/index.js */ "./node_modules/date-fns/esm/isThisYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThisYear", function () { return _isThisYear_index_js__WEBPACK_IMPORTED_MODULE_113__["default"]; });
            /* harmony import */ var _isThursday_index_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(/*! ./isThursday/index.js */ "./node_modules/date-fns/esm/isThursday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isThursday", function () { return _isThursday_index_js__WEBPACK_IMPORTED_MODULE_114__["default"]; });
            /* harmony import */ var _isToday_index_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(/*! ./isToday/index.js */ "./node_modules/date-fns/esm/isToday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isToday", function () { return _isToday_index_js__WEBPACK_IMPORTED_MODULE_115__["default"]; });
            /* harmony import */ var _isTomorrow_index_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(/*! ./isTomorrow/index.js */ "./node_modules/date-fns/esm/isTomorrow/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isTomorrow", function () { return _isTomorrow_index_js__WEBPACK_IMPORTED_MODULE_116__["default"]; });
            /* harmony import */ var _isTuesday_index_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(/*! ./isTuesday/index.js */ "./node_modules/date-fns/esm/isTuesday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isTuesday", function () { return _isTuesday_index_js__WEBPACK_IMPORTED_MODULE_117__["default"]; });
            /* harmony import */ var _isValid_index_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(/*! ./isValid/index.js */ "./node_modules/date-fns/esm/isValid/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isValid", function () { return _isValid_index_js__WEBPACK_IMPORTED_MODULE_118__["default"]; });
            /* harmony import */ var _isWednesday_index_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(/*! ./isWednesday/index.js */ "./node_modules/date-fns/esm/isWednesday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isWednesday", function () { return _isWednesday_index_js__WEBPACK_IMPORTED_MODULE_119__["default"]; });
            /* harmony import */ var _isWeekend_index_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(/*! ./isWeekend/index.js */ "./node_modules/date-fns/esm/isWeekend/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isWeekend", function () { return _isWeekend_index_js__WEBPACK_IMPORTED_MODULE_120__["default"]; });
            /* harmony import */ var _isWithinInterval_index_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(/*! ./isWithinInterval/index.js */ "./node_modules/date-fns/esm/isWithinInterval/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isWithinInterval", function () { return _isWithinInterval_index_js__WEBPACK_IMPORTED_MODULE_121__["default"]; });
            /* harmony import */ var _isYesterday_index_js__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(/*! ./isYesterday/index.js */ "./node_modules/date-fns/esm/isYesterday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isYesterday", function () { return _isYesterday_index_js__WEBPACK_IMPORTED_MODULE_122__["default"]; });
            /* harmony import */ var _lastDayOfDecade_index_js__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(/*! ./lastDayOfDecade/index.js */ "./node_modules/date-fns/esm/lastDayOfDecade/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfDecade", function () { return _lastDayOfDecade_index_js__WEBPACK_IMPORTED_MODULE_123__["default"]; });
            /* harmony import */ var _lastDayOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(/*! ./lastDayOfISOWeek/index.js */ "./node_modules/date-fns/esm/lastDayOfISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfISOWeek", function () { return _lastDayOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_124__["default"]; });
            /* harmony import */ var _lastDayOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(/*! ./lastDayOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfISOWeekYear", function () { return _lastDayOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_125__["default"]; });
            /* harmony import */ var _lastDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(/*! ./lastDayOfMonth/index.js */ "./node_modules/date-fns/esm/lastDayOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfMonth", function () { return _lastDayOfMonth_index_js__WEBPACK_IMPORTED_MODULE_126__["default"]; });
            /* harmony import */ var _lastDayOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(/*! ./lastDayOfQuarter/index.js */ "./node_modules/date-fns/esm/lastDayOfQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfQuarter", function () { return _lastDayOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_127__["default"]; });
            /* harmony import */ var _lastDayOfWeek_index_js__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(/*! ./lastDayOfWeek/index.js */ "./node_modules/date-fns/esm/lastDayOfWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfWeek", function () { return _lastDayOfWeek_index_js__WEBPACK_IMPORTED_MODULE_128__["default"]; });
            /* harmony import */ var _lastDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(/*! ./lastDayOfYear/index.js */ "./node_modules/date-fns/esm/lastDayOfYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lastDayOfYear", function () { return _lastDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_129__["default"]; });
            /* harmony import */ var _lightFormat_index_js__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(/*! ./lightFormat/index.js */ "./node_modules/date-fns/esm/lightFormat/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lightFormat", function () { return _lightFormat_index_js__WEBPACK_IMPORTED_MODULE_130__["default"]; });
            /* harmony import */ var _max_index_js__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(/*! ./max/index.js */ "./node_modules/date-fns/esm/max/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "max", function () { return _max_index_js__WEBPACK_IMPORTED_MODULE_131__["default"]; });
            /* harmony import */ var _min_index_js__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(/*! ./min/index.js */ "./node_modules/date-fns/esm/min/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "min", function () { return _min_index_js__WEBPACK_IMPORTED_MODULE_132__["default"]; });
            /* harmony import */ var _parse_index_js__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(/*! ./parse/index.js */ "./node_modules/date-fns/esm/parse/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "parse", function () { return _parse_index_js__WEBPACK_IMPORTED_MODULE_133__["default"]; });
            /* harmony import */ var _parseISO_index_js__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(/*! ./parseISO/index.js */ "./node_modules/date-fns/esm/parseISO/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "parseISO", function () { return _parseISO_index_js__WEBPACK_IMPORTED_MODULE_134__["default"]; });
            /* harmony import */ var _parseJSON_index_js__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(/*! ./parseJSON/index.js */ "./node_modules/date-fns/esm/parseJSON/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "parseJSON", function () { return _parseJSON_index_js__WEBPACK_IMPORTED_MODULE_135__["default"]; });
            /* harmony import */ var _roundToNearestMinutes_index_js__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(/*! ./roundToNearestMinutes/index.js */ "./node_modules/date-fns/esm/roundToNearestMinutes/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "roundToNearestMinutes", function () { return _roundToNearestMinutes_index_js__WEBPACK_IMPORTED_MODULE_136__["default"]; });
            /* harmony import */ var _set_index_js__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(/*! ./set/index.js */ "./node_modules/date-fns/esm/set/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "set", function () { return _set_index_js__WEBPACK_IMPORTED_MODULE_137__["default"]; });
            /* harmony import */ var _setDate_index_js__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(/*! ./setDate/index.js */ "./node_modules/date-fns/esm/setDate/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setDate", function () { return _setDate_index_js__WEBPACK_IMPORTED_MODULE_138__["default"]; });
            /* harmony import */ var _setDay_index_js__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(/*! ./setDay/index.js */ "./node_modules/date-fns/esm/setDay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setDay", function () { return _setDay_index_js__WEBPACK_IMPORTED_MODULE_139__["default"]; });
            /* harmony import */ var _setDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(/*! ./setDayOfYear/index.js */ "./node_modules/date-fns/esm/setDayOfYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setDayOfYear", function () { return _setDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_140__["default"]; });
            /* harmony import */ var _setHours_index_js__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(/*! ./setHours/index.js */ "./node_modules/date-fns/esm/setHours/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setHours", function () { return _setHours_index_js__WEBPACK_IMPORTED_MODULE_141__["default"]; });
            /* harmony import */ var _setISODay_index_js__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(/*! ./setISODay/index.js */ "./node_modules/date-fns/esm/setISODay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setISODay", function () { return _setISODay_index_js__WEBPACK_IMPORTED_MODULE_142__["default"]; });
            /* harmony import */ var _setISOWeek_index_js__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(/*! ./setISOWeek/index.js */ "./node_modules/date-fns/esm/setISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setISOWeek", function () { return _setISOWeek_index_js__WEBPACK_IMPORTED_MODULE_143__["default"]; });
            /* harmony import */ var _setISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(/*! ./setISOWeekYear/index.js */ "./node_modules/date-fns/esm/setISOWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setISOWeekYear", function () { return _setISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_144__["default"]; });
            /* harmony import */ var _setMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(/*! ./setMilliseconds/index.js */ "./node_modules/date-fns/esm/setMilliseconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setMilliseconds", function () { return _setMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_145__["default"]; });
            /* harmony import */ var _setMinutes_index_js__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(/*! ./setMinutes/index.js */ "./node_modules/date-fns/esm/setMinutes/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setMinutes", function () { return _setMinutes_index_js__WEBPACK_IMPORTED_MODULE_146__["default"]; });
            /* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(/*! ./setMonth/index.js */ "./node_modules/date-fns/esm/setMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setMonth", function () { return _setMonth_index_js__WEBPACK_IMPORTED_MODULE_147__["default"]; });
            /* harmony import */ var _setQuarter_index_js__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(/*! ./setQuarter/index.js */ "./node_modules/date-fns/esm/setQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setQuarter", function () { return _setQuarter_index_js__WEBPACK_IMPORTED_MODULE_148__["default"]; });
            /* harmony import */ var _setSeconds_index_js__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(/*! ./setSeconds/index.js */ "./node_modules/date-fns/esm/setSeconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setSeconds", function () { return _setSeconds_index_js__WEBPACK_IMPORTED_MODULE_149__["default"]; });
            /* harmony import */ var _setWeek_index_js__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(/*! ./setWeek/index.js */ "./node_modules/date-fns/esm/setWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setWeek", function () { return _setWeek_index_js__WEBPACK_IMPORTED_MODULE_150__["default"]; });
            /* harmony import */ var _setWeekYear_index_js__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(/*! ./setWeekYear/index.js */ "./node_modules/date-fns/esm/setWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setWeekYear", function () { return _setWeekYear_index_js__WEBPACK_IMPORTED_MODULE_151__["default"]; });
            /* harmony import */ var _setYear_index_js__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(/*! ./setYear/index.js */ "./node_modules/date-fns/esm/setYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setYear", function () { return _setYear_index_js__WEBPACK_IMPORTED_MODULE_152__["default"]; });
            /* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(/*! ./startOfDay/index.js */ "./node_modules/date-fns/esm/startOfDay/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfDay", function () { return _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_153__["default"]; });
            /* harmony import */ var _startOfDecade_index_js__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(/*! ./startOfDecade/index.js */ "./node_modules/date-fns/esm/startOfDecade/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfDecade", function () { return _startOfDecade_index_js__WEBPACK_IMPORTED_MODULE_154__["default"]; });
            /* harmony import */ var _startOfHour_index_js__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(/*! ./startOfHour/index.js */ "./node_modules/date-fns/esm/startOfHour/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfHour", function () { return _startOfHour_index_js__WEBPACK_IMPORTED_MODULE_155__["default"]; });
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(/*! ./startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfISOWeek", function () { return _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_156__["default"]; });
            /* harmony import */ var _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(/*! ./startOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/startOfISOWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfISOWeekYear", function () { return _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_157__["default"]; });
            /* harmony import */ var _startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(/*! ./startOfMinute/index.js */ "./node_modules/date-fns/esm/startOfMinute/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfMinute", function () { return _startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_158__["default"]; });
            /* harmony import */ var _startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(/*! ./startOfMonth/index.js */ "./node_modules/date-fns/esm/startOfMonth/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfMonth", function () { return _startOfMonth_index_js__WEBPACK_IMPORTED_MODULE_159__["default"]; });
            /* harmony import */ var _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(/*! ./startOfQuarter/index.js */ "./node_modules/date-fns/esm/startOfQuarter/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfQuarter", function () { return _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_160__["default"]; });
            /* harmony import */ var _startOfSecond_index_js__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(/*! ./startOfSecond/index.js */ "./node_modules/date-fns/esm/startOfSecond/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfSecond", function () { return _startOfSecond_index_js__WEBPACK_IMPORTED_MODULE_161__["default"]; });
            /* harmony import */ var _startOfToday_index_js__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(/*! ./startOfToday/index.js */ "./node_modules/date-fns/esm/startOfToday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfToday", function () { return _startOfToday_index_js__WEBPACK_IMPORTED_MODULE_162__["default"]; });
            /* harmony import */ var _startOfTomorrow_index_js__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(/*! ./startOfTomorrow/index.js */ "./node_modules/date-fns/esm/startOfTomorrow/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfTomorrow", function () { return _startOfTomorrow_index_js__WEBPACK_IMPORTED_MODULE_163__["default"]; });
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(/*! ./startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfWeek", function () { return _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_164__["default"]; });
            /* harmony import */ var _startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(/*! ./startOfWeekYear/index.js */ "./node_modules/date-fns/esm/startOfWeekYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfWeekYear", function () { return _startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_165__["default"]; });
            /* harmony import */ var _startOfYear_index_js__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(/*! ./startOfYear/index.js */ "./node_modules/date-fns/esm/startOfYear/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfYear", function () { return _startOfYear_index_js__WEBPACK_IMPORTED_MODULE_166__["default"]; });
            /* harmony import */ var _startOfYesterday_index_js__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(/*! ./startOfYesterday/index.js */ "./node_modules/date-fns/esm/startOfYesterday/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startOfYesterday", function () { return _startOfYesterday_index_js__WEBPACK_IMPORTED_MODULE_167__["default"]; });
            /* harmony import */ var _subBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(/*! ./subBusinessDays/index.js */ "./node_modules/date-fns/esm/subBusinessDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subBusinessDays", function () { return _subBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_168__["default"]; });
            /* harmony import */ var _subDays_index_js__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(/*! ./subDays/index.js */ "./node_modules/date-fns/esm/subDays/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subDays", function () { return _subDays_index_js__WEBPACK_IMPORTED_MODULE_169__["default"]; });
            /* harmony import */ var _subHours_index_js__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(/*! ./subHours/index.js */ "./node_modules/date-fns/esm/subHours/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subHours", function () { return _subHours_index_js__WEBPACK_IMPORTED_MODULE_170__["default"]; });
            /* harmony import */ var _subISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(/*! ./subISOWeekYears/index.js */ "./node_modules/date-fns/esm/subISOWeekYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subISOWeekYears", function () { return _subISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_171__["default"]; });
            /* harmony import */ var _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(/*! ./subMilliseconds/index.js */ "./node_modules/date-fns/esm/subMilliseconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subMilliseconds", function () { return _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_172__["default"]; });
            /* harmony import */ var _subMinutes_index_js__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(/*! ./subMinutes/index.js */ "./node_modules/date-fns/esm/subMinutes/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subMinutes", function () { return _subMinutes_index_js__WEBPACK_IMPORTED_MODULE_173__["default"]; });
            /* harmony import */ var _subMonths_index_js__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(/*! ./subMonths/index.js */ "./node_modules/date-fns/esm/subMonths/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subMonths", function () { return _subMonths_index_js__WEBPACK_IMPORTED_MODULE_174__["default"]; });
            /* harmony import */ var _subQuarters_index_js__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(/*! ./subQuarters/index.js */ "./node_modules/date-fns/esm/subQuarters/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subQuarters", function () { return _subQuarters_index_js__WEBPACK_IMPORTED_MODULE_175__["default"]; });
            /* harmony import */ var _subSeconds_index_js__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(/*! ./subSeconds/index.js */ "./node_modules/date-fns/esm/subSeconds/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subSeconds", function () { return _subSeconds_index_js__WEBPACK_IMPORTED_MODULE_176__["default"]; });
            /* harmony import */ var _subWeeks_index_js__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(/*! ./subWeeks/index.js */ "./node_modules/date-fns/esm/subWeeks/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subWeeks", function () { return _subWeeks_index_js__WEBPACK_IMPORTED_MODULE_177__["default"]; });
            /* harmony import */ var _subYears_index_js__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(/*! ./subYears/index.js */ "./node_modules/date-fns/esm/subYears/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subYears", function () { return _subYears_index_js__WEBPACK_IMPORTED_MODULE_178__["default"]; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(/*! ./toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toDate", function () { return _toDate_index_js__WEBPACK_IMPORTED_MODULE_179__["default"]; });
            /* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(/*! ./constants/index.js */ "./node_modules/date-fns/esm/constants/index.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "maxTime", function () { return _constants_index_js__WEBPACK_IMPORTED_MODULE_180__["maxTime"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "minTime", function () { return _constants_index_js__WEBPACK_IMPORTED_MODULE_180__["minTime"]; });
            // This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isAfter/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/isAfter/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isAfter; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isAfter
             * @category Common Helpers
             * @summary Is the first date after the second one?
             *
             * @description
             * Is the first date after the second one?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date that should be after the other one to return true
             * @param {Date|Number} dateToCompare - the date to compare with
             * @returns {Boolean} the first date is after the second date
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Is 10 July 1989 after 11 February 1987?
             * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
             * //=> true
             */
            function isAfter(dirtyDate, dirtyDateToCompare) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var dateToCompare = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateToCompare);
                return date.getTime() > dateToCompare.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isBefore/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/isBefore/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isBefore; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isBefore
             * @category Common Helpers
             * @summary Is the first date before the second one?
             *
             * @description
             * Is the first date before the second one?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date that should be before the other one to return true
             * @param {Date|Number} dateToCompare - the date to compare with
             * @returns {Boolean} the first date is before the second date
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Is 10 July 1989 before 11 February 1987?
             * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
             * //=> false
             */
            function isBefore(dirtyDate, dirtyDateToCompare) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var dateToCompare = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateToCompare);
                return date.getTime() < dateToCompare.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isDate/index.js": 
        /*!***************************************************!*\
          !*** ./node_modules/date-fns/esm/isDate/index.js ***!
          \***************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isDate; });
            /**
             * @name isDate
             * @category Common Helpers
             * @summary Is the given value a date?
             *
             * @description
             * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {*} value - the value to check
             * @returns {boolean} true if the given value is a date
             * @throws {TypeError} 1 arguments required
             *
             * @example
             * // For a valid date:
             * var result = isDate(new Date())
             * //=> true
             *
             * @example
             * // For an invalid date:
             * var result = isDate(new Date(NaN))
             * //=> true
             *
             * @example
             * // For some value:
             * var result = isDate('2014-02-31')
             * //=> false
             *
             * @example
             * // For an object:
             * var result = isDate({})
             * //=> false
             */
            function isDate(value) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isEqual/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/isEqual/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isEqual; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isEqual
             * @category Common Helpers
             * @summary Are the given dates equal?
             *
             * @description
             * Are the given dates equal?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to compare
             * @param {Date|Number} dateRight - the second date to compare
             * @returns {Boolean} the dates are equal
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
             * var result = isEqual(
             *   new Date(2014, 6, 2, 6, 30, 45, 0),
             *   new Date(2014, 6, 2, 6, 30, 45, 500)
             * )
             * //=> false
             */
            function isEqual(dirtyLeftDate, dirtyRightDate) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyLeftDate);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyRightDate);
                return dateLeft.getTime() === dateRight.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isFirstDayOfMonth/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/isFirstDayOfMonth/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isFirstDayOfMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isFirstDayOfMonth
             * @category Month Helpers
             * @summary Is the given date the first day of a month?
             *
             * @description
             * Is the given date the first day of a month?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is the first day of a month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 1 September 2014 the first day of a month?
             * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
             * //=> true
             */
            function isFirstDayOfMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDate() === 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isFriday/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/isFriday/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isFriday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isFriday
             * @category Weekday Helpers
             * @summary Is the given date Friday?
             *
             * @description
             * Is the given date Friday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Friday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 26 September 2014 Friday?
             * var result = isFriday(new Date(2014, 8, 26))
             * //=> true
             */
            function isFriday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 5;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isFuture/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/isFuture/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isFuture; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isFuture
             * @category Common Helpers
             * @summary Is the given date in the future?
             * @pure false
             *
             * @description
             * Is the given date in the future?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in the future
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 6 October 2014, is 31 December 2014 in the future?
             * var result = isFuture(new Date(2014, 11, 31))
             * //=> true
             */
            function isFuture(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getTime() > Date.now();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isLastDayOfMonth/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/isLastDayOfMonth/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isLastDayOfMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _endOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../endOfDay/index.js */ "./node_modules/date-fns/esm/endOfDay/index.js");
            /* harmony import */ var _endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../endOfMonth/index.js */ "./node_modules/date-fns/esm/endOfMonth/index.js");
            /**
             * @name isLastDayOfMonth
             * @category Month Helpers
             * @summary Is the given date the last day of a month?
             *
             * @description
             * Is the given date the last day of a month?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is the last day of a month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 28 February 2014 the last day of a month?
             * var result = isLastDayOfMonth(new Date(2014, 1, 28))
             * //=> true
             */
            function isLastDayOfMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                return Object(_endOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date).getTime() === Object(_endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date).getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isLeapYear/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isLeapYear/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isLeapYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isLeapYear
             * @category Year Helpers
             * @summary Is the given date in the leap year?
             *
             * @description
             * Is the given date in the leap year?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in the leap year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 1 September 2012 in the leap year?
             * var result = isLeapYear(new Date(2012, 8, 1))
             * //=> true
             */
            function isLeapYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isMonday/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/isMonday/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isMonday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isMonday
             * @category Weekday Helpers
             * @summary Is the given date Monday?
             *
             * @description
             * Is the given date Monday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Monday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 22 September 2014 Monday?
             * var result = isMonday(new Date(2014, 8, 22))
             * //=> true
             */
            function isMonday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 1;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isPast/index.js": 
        /*!***************************************************!*\
          !*** ./node_modules/date-fns/esm/isPast/index.js ***!
          \***************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isPast; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isPast
             * @category Common Helpers
             * @summary Is the given date in the past?
             * @pure false
             *
             * @description
             * Is the given date in the past?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in the past
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 6 October 2014, is 2 July 2014 in the past?
             * var result = isPast(new Date(2014, 6, 2))
             * //=> true
             */
            function isPast(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getTime() < Date.now();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameDay/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameDay/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameDay; });
            /* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfDay/index.js */ "./node_modules/date-fns/esm/startOfDay/index.js");
            /**
             * @name isSameDay
             * @category Day Helpers
             * @summary Are the given dates in the same day?
             *
             * @description
             * Are the given dates in the same day?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same day
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
             * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
             * //=> true
             */
            function isSameDay(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfDay = Object(_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRightStartOfDay = Object(_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameHour/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameHour/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameHour; });
            /* harmony import */ var _startOfHour_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfHour/index.js */ "./node_modules/date-fns/esm/startOfHour/index.js");
            /**
             * @name isSameHour
             * @category Hour Helpers
             * @summary Are the given dates in the same hour?
             *
             * @description
             * Are the given dates in the same hour?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same hour
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
             * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
             * //=> true
             */
            function isSameHour(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfHour = Object(_startOfHour_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRightStartOfHour = Object(_startOfHour_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameISOWeek/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameISOWeek/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameISOWeek; });
            /* harmony import */ var _isSameWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameWeek/index.js */ "./node_modules/date-fns/esm/isSameWeek/index.js");
            /**
             * @name isSameISOWeek
             * @category ISO Week Helpers
             * @summary Are the given dates in the same ISO week?
             *
             * @description
             * Are the given dates in the same ISO week?
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same ISO week
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
             * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
             * //=> true
             */
            function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyDateRight, {
                    weekStartsOn: 1
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameISOWeekYear/index.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameISOWeekYear/index.js ***!
          \**************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameISOWeekYear; });
            /* harmony import */ var _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/startOfISOWeekYear/index.js");
            /**
             * @name isSameISOWeekYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Are the given dates in the same ISO week-numbering year?
             *
             * @description
             * Are the given dates in the same ISO week-numbering year?
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same ISO week-numbering year
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
             * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
             * //=> true
             */
            function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfYear = Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRightStartOfYear = Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameMinute/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameMinute/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameMinute; });
            /* harmony import */ var _startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfMinute/index.js */ "./node_modules/date-fns/esm/startOfMinute/index.js");
            /**
             * @name isSameMinute
             * @category Minute Helpers
             * @summary Are the given dates in the same minute?
             *
             * @description
             * Are the given dates in the same minute?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same minute
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
             * // in the same minute?
             * var result = isSameMinute(
             *   new Date(2014, 8, 4, 6, 30),
             *   new Date(2014, 8, 4, 6, 30, 15)
             * )
             * //=> true
             */
            function isSameMinute(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfMinute = Object(_startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRightStartOfMinute = Object(_startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameMonth/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameMonth/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isSameMonth
             * @category Month Helpers
             * @summary Are the given dates in the same month?
             *
             * @description
             * Are the given dates in the same month?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same month
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 2 September 2014 and 25 September 2014 in the same month?
             * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
             * //=> true
             */
            function isSameMonth(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameQuarter/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameQuarter/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameQuarter; });
            /* harmony import */ var _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfQuarter/index.js */ "./node_modules/date-fns/esm/startOfQuarter/index.js");
            /**
             * @name isSameQuarter
             * @category Quarter Helpers
             * @summary Are the given dates in the same year quarter?
             *
             * @description
             * Are the given dates in the same year quarter?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same quarter
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 1 January 2014 and 8 March 2014 in the same quarter?
             * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
             * //=> true
             */
            function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfQuarter = Object(_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRightStartOfQuarter = Object(_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameSecond/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameSecond/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameSecond; });
            /* harmony import */ var _startOfSecond_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfSecond/index.js */ "./node_modules/date-fns/esm/startOfSecond/index.js");
            /**
             * @name isSameSecond
             * @category Second Helpers
             * @summary Are the given dates in the same second?
             *
             * @description
             * Are the given dates in the same second?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same second
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
             * // in the same second?
             * var result = isSameSecond(
             *   new Date(2014, 8, 4, 6, 30, 15),
             *   new Date(2014, 8, 4, 6, 30, 15, 500)
             * )
             * //=> true
             */
            function isSameSecond(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfSecond = Object(_startOfSecond_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRightStartOfSecond = Object(_startOfSecond_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameWeek/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameWeek/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameWeek; });
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /**
             * @name isSameWeek
             * @category Week Helpers
             * @summary Are the given dates in the same week?
             *
             * @description
             * Are the given dates in the same week?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Boolean} the dates are in the same week
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // Are 31 August 2014 and 4 September 2014 in the same week?
             * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
             * //=> true
             *
             * @example
             * // If week starts with Monday,
             * // are 31 August 2014 and 4 September 2014 in the same week?
             * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
             *   weekStartsOn: 1
             * })
             * //=> false
             */
            function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeftStartOfWeek = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft, dirtyOptions);
                var dateRightStartOfWeek = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight, dirtyOptions);
                return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSameYear/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isSameYear/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSameYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isSameYear
             * @category Year Helpers
             * @summary Are the given dates in the same year?
             *
             * @description
             * Are the given dates in the same year?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} dateLeft - the first date to check
             * @param {Date|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same year
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Are 2 September 2014 and 25 September 2014 in the same year?
             * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
             * //=> true
             */
            function isSameYear(dirtyDateLeft, dirtyDateRight) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var dateLeft = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateLeft);
                var dateRight = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDateRight);
                return dateLeft.getFullYear() === dateRight.getFullYear();
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSaturday/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isSaturday/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSaturday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isSaturday
             * @category Weekday Helpers
             * @summary Is the given date Saturday?
             *
             * @description
             * Is the given date Saturday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Saturday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 27 September 2014 Saturday?
             * var result = isSaturday(new Date(2014, 8, 27))
             * //=> true
             */
            function isSaturday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 6;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isSunday/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/isSunday/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isSunday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isSunday
             * @category Weekday Helpers
             * @summary Is the given date Sunday?
             *
             * @description
             * Is the given date Sunday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Sunday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 21 September 2014 Sunday?
             * var result = isSunday(new Date(2014, 8, 21))
             * //=> true
             */
            function isSunday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 0;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisHour/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisHour/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisHour; });
            /* harmony import */ var _isSameHour_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameHour/index.js */ "./node_modules/date-fns/esm/isSameHour/index.js");
            /**
             * @name isThisHour
             * @category Hour Helpers
             * @summary Is the given date in the same hour as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same hour as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this hour
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If now is 25 September 2014 18:30:15.500,
             * // is 25 September 2014 18:00:00 in this hour?
             * var result = isThisHour(new Date(2014, 8, 25, 18))
             * //=> true
             */
            function isThisHour(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameHour_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now(), dirtyDate);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisISOWeek/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisISOWeek/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisISOWeek; });
            /* harmony import */ var _isSameISOWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameISOWeek/index.js */ "./node_modules/date-fns/esm/isSameISOWeek/index.js");
            /**
             * @name isThisISOWeek
             * @category ISO Week Helpers
             * @summary Is the given date in the same ISO week as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same ISO week as the current date?
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this ISO week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
             * var result = isThisISOWeek(new Date(2014, 8, 22))
             * //=> true
             */
            function isThisISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameISOWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, Date.now());
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisMinute/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisMinute/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisMinute; });
            /* harmony import */ var _isSameMinute_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameMinute/index.js */ "./node_modules/date-fns/esm/isSameMinute/index.js");
            /**
             * @name isThisMinute
             * @category Minute Helpers
             * @summary Is the given date in the same minute as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same minute as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this minute
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If now is 25 September 2014 18:30:15.500,
             * // is 25 September 2014 18:30:00 in this minute?
             * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
             * //=> true
             */
            function isThisMinute(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameMinute_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now(), dirtyDate);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisMonth/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisMonth/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisMonth; });
            /* harmony import */ var _isSameMonth_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameMonth/index.js */ "./node_modules/date-fns/esm/isSameMonth/index.js");
            /**
             * @name isThisMonth
             * @category Month Helpers
             * @summary Is the given date in the same month as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same month as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 25 September 2014, is 15 September 2014 in this month?
             * var result = isThisMonth(new Date(2014, 8, 15))
             * //=> true
             */
            function isThisMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameMonth_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now(), dirtyDate);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisQuarter/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisQuarter/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisQuarter; });
            /* harmony import */ var _isSameQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameQuarter/index.js */ "./node_modules/date-fns/esm/isSameQuarter/index.js");
            /**
             * @name isThisQuarter
             * @category Quarter Helpers
             * @summary Is the given date in the same quarter as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same quarter as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this quarter
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 25 September 2014, is 2 July 2014 in this quarter?
             * var result = isThisQuarter(new Date(2014, 6, 2))
             * //=> true
             */
            function isThisQuarter(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameQuarter_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now(), dirtyDate);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisSecond/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisSecond/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisSecond; });
            /* harmony import */ var _isSameSecond_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameSecond/index.js */ "./node_modules/date-fns/esm/isSameSecond/index.js");
            /**
             * @name isThisSecond
             * @category Second Helpers
             * @summary Is the given date in the same second as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same second as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this second
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If now is 25 September 2014 18:30:15.500,
             * // is 25 September 2014 18:30:15.000 in this second?
             * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
             * //=> true
             */
            function isThisSecond(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameSecond_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now(), dirtyDate);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisWeek/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisWeek/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisWeek; });
            /* harmony import */ var _isSameWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameWeek/index.js */ "./node_modules/date-fns/esm/isSameWeek/index.js");
            /**
             * @name isThisWeek
             * @category Week Helpers
             * @summary Is the given date in the same week as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same week as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @param {Object} [options] - the object with options
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Boolean} the date is in this week
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // If today is 25 September 2014, is 21 September 2014 in this week?
             * var result = isThisWeek(new Date(2014, 8, 21))
             * //=> true
             *
             * @example
             * // If today is 25 September 2014 and week starts with Monday
             * // is 21 September 2014 in this week?
             * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
             * //=> false
             */
            function isThisWeek(dirtyDate, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, Date.now(), options);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThisYear/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isThisYear/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThisYear; });
            /* harmony import */ var _isSameYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameYear/index.js */ "./node_modules/date-fns/esm/isSameYear/index.js");
            /**
             * @name isThisYear
             * @category Year Helpers
             * @summary Is the given date in the same year as the current date?
             * @pure false
             *
             * @description
             * Is the given date in the same year as the current date?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is in this year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 25 September 2014, is 2 July 2014 in this year?
             * var result = isThisYear(new Date(2014, 6, 2))
             * //=> true
             */
            function isThisYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, Date.now());
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isThursday/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isThursday/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isThursday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isThursday
             * @category Weekday Helpers
             * @summary Is the given date Thursday?
             *
             * @description
             * Is the given date Thursday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Thursday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 25 September 2014 Thursday?
             * var result = isThursday(new Date(2014, 8, 25))
             * //=> true
             */
            function isThursday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 4;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isToday/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/isToday/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isToday; });
            /* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameDay/index.js */ "./node_modules/date-fns/esm/isSameDay/index.js");
            /**
             * @name isToday
             * @category Day Helpers
             * @summary Is the given date today?
             * @pure false
             *
             * @description
             * Is the given date today?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is today
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 6 October 2014, is 6 October 14:00:00 today?
             * var result = isToday(new Date(2014, 9, 6, 14, 0))
             * //=> true
             */
            function isToday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, Date.now());
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isTomorrow/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/isTomorrow/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isTomorrow; });
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../isSameDay/index.js */ "./node_modules/date-fns/esm/isSameDay/index.js");
            /**
             * @name isTomorrow
             * @category Day Helpers
             * @summary Is the given date tomorrow?
             * @pure false
             *
             * @description
             * Is the given date tomorrow?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is tomorrow
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
             * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
             * //=> true
             */
            function isTomorrow(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now(), 1));
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isTuesday/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/isTuesday/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isTuesday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isTuesday
             * @category Weekday Helpers
             * @summary Is the given date Tuesday?
             *
             * @description
             * Is the given date Tuesday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Tuesday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 23 September 2014 Tuesday?
             * var result = isTuesday(new Date(2014, 8, 23))
             * //=> true
             */
            function isTuesday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 2;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isValid/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/isValid/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isValid; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isValid
             * @category Common Helpers
             * @summary Is the given date valid?
             *
             * @description
             * Returns false if argument is Invalid Date and true otherwise.
             * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
             * Invalid Date is a Date, whose time value is NaN.
             *
             * Time value of Date: http://es5.github.io/#x15.9.1.1
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - Now `isValid` doesn't throw an exception
             *   if the first argument is not an instance of Date.
             *   Instead, argument is converted beforehand using `toDate`.
             *
             *   Examples:
             *
             *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
             *   |---------------------------|---------------|---------------|
             *   | `new Date()`              | `true`        | `true`        |
             *   | `new Date('2016-01-01')`  | `true`        | `true`        |
             *   | `new Date('')`            | `false`       | `false`       |
             *   | `new Date(1488370835081)` | `true`        | `true`        |
             *   | `new Date(NaN)`           | `false`       | `false`       |
             *   | `'2016-01-01'`            | `TypeError`   | `false`       |
             *   | `''`                      | `TypeError`   | `false`       |
             *   | `1488370835081`           | `TypeError`   | `true`        |
             *   | `NaN`                     | `TypeError`   | `false`       |
             *
             *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
             *   that try to coerce arguments to the expected type
             *   (which is also the case with other *date-fns* functions).
             *
             * @param {*} date - the date to check
             * @returns {Boolean} the date is valid
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // For the valid date:
             * var result = isValid(new Date(2014, 1, 31))
             * //=> true
             *
             * @example
             * // For the value, convertable into a date:
             * var result = isValid(1393804800000)
             * //=> true
             *
             * @example
             * // For the invalid date:
             * var result = isValid(new Date(''))
             * //=> false
             */
            function isValid(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                return !isNaN(date);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isWednesday/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/isWednesday/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isWednesday; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isWednesday
             * @category Weekday Helpers
             * @summary Is the given date Wednesday?
             *
             * @description
             * Is the given date Wednesday?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is Wednesday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Is 24 September 2014 Wednesday?
             * var result = isWednesday(new Date(2014, 8, 24))
             * //=> true
             */
            function isWednesday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getDay() === 3;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isWeekend/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/isWeekend/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isWeekend; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isWeekend
             * @category Weekday Helpers
             * @summary Does the given date fall on a weekend?
             *
             * @description
             * Does the given date fall on a weekend?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date falls on a weekend
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Does 5 October 2014 fall on a weekend?
             * var result = isWeekend(new Date(2014, 9, 5))
             * //=> true
             */
            function isWeekend(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getDay();
                return day === 0 || day === 6;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isWithinInterval/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/isWithinInterval/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isWithinInterval; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name isWithinInterval
             * @category Interval Helpers
             * @summary Is the given date within the interval?
             *
             * @description
             * Is the given date within the interval?
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `isWithinRange` to `isWithinInterval`.
             *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
             *
             *   ```
             *   2.1.3
             *   time interval
             *   part of the time axis limited by two instants
             *   ```
             *
             *   Also, this function now accepts an object with `start` and `end` properties
             *   instead of two arguments as an interval.
             *   This function now throws `RangeError` if the start of the interval is after its end
             *   or if any date in the interval is `Invalid Date`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *
             *   isWithinRange(
             *     new Date(2014, 0, 3),
             *     new Date(2014, 0, 1), new Date(2014, 0, 7)
             *   )
             *
             *   // v2.0.0 onward
             *
             *   isWithinInterval(
             *     new Date(2014, 0, 3),
             *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
             *   )
             *   ```
             *
             * @param {Date|Number} date - the date to check
             * @param {Interval} interval - the interval to check
             * @returns {Boolean} the date is within the interval
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} The start of an interval cannot be after its end
             * @throws {RangeError} Date in interval cannot be `Invalid Date`
             *
             * @example
             * // For the date within the interval:
             * isWithinInterval(new Date(2014, 0, 3), {
             *   start: new Date(2014, 0, 1),
             *   end: new Date(2014, 0, 7)
             * })
             * //=> true
             *
             * @example
             * // For the date outside of the interval:
             * isWithinInterval(new Date(2014, 0, 10), {
             *   start: new Date(2014, 0, 1),
             *   end: new Date(2014, 0, 7)
             * })
             * //=> false
             */
            function isWithinInterval(dirtyDate, dirtyInterval) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var interval = dirtyInterval || {};
                var time = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate).getTime();
                var startTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(interval.start).getTime();
                var endTime = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
                if (!(startTime <= endTime)) {
                    throw new RangeError('Invalid interval');
                }
                return time >= startTime && time <= endTime;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/isYesterday/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/isYesterday/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return isYesterday; });
            /* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../isSameDay/index.js */ "./node_modules/date-fns/esm/isSameDay/index.js");
            /* harmony import */ var _subDays_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../subDays/index.js */ "./node_modules/date-fns/esm/subDays/index.js");
            /**
             * @name isYesterday
             * @category Day Helpers
             * @summary Is the given date yesterday?
             * @pure false
             *
             * @description
             * Is the given date yesterday?
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to check
             * @returns {Boolean} the date is yesterday
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
             * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
             * //=> true
             */
            function isYesterday(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, Object(_subDays_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(Date.now(), 1));
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfDecade/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfDecade/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfDecade; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name lastDayOfDecade
             * @category Decade Helpers
             * @summary Return the last day of a decade for the given date.
             *
             * @description
             * Return the last day of a decade for the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the last day of a decade
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The last day of a decade for 21 December 2012 21:12:00:
             * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
             * //=> Wed Dec 31 2019 00:00:00
             */
            function lastDayOfDecade(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                var decade = 9 + Math.floor(year / 10) * 10;
                date.setFullYear(decade + 1, 0, 0);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfISOWeek/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfISOWeek/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfISOWeek; });
            /* harmony import */ var _lastDayOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lastDayOfWeek/index.js */ "./node_modules/date-fns/esm/lastDayOfWeek/index.js");
            /**
             * @name lastDayOfISOWeek
             * @category ISO Week Helpers
             * @summary Return the last day of an ISO week for the given date.
             *
             * @description
             * Return the last day of an ISO week for the given date.
             * The result will be in the local timezone.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the last day of an ISO week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The last day of an ISO week for 2 September 2014 11:55:00:
             * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sun Sep 07 2014 00:00:00
             */
            function lastDayOfISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_lastDayOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, {
                    weekStartsOn: 1
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js ***!
          \*****************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfISOWeekYear; });
            /* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getISOWeekYear/index.js */ "./node_modules/date-fns/esm/getISOWeekYear/index.js");
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            /**
             * @name lastDayOfISOWeekYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Return the last day of an ISO week-numbering year for the given date.
             *
             * @description
             * Return the last day of an ISO week-numbering year,
             * which always starts 3 days before the year's first Thursday.
             * The result will be in the local timezone.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the end of an ISO week-numbering year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The last day of an ISO week-numbering year for 2 July 2005:
             * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
             * //=> Sun Jan 01 2006 00:00:00
             */
            function lastDayOfISOWeekYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var year = Object(_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var fourthOfJanuary = new Date(0);
                fourthOfJanuary.setFullYear(year + 1, 0, 4);
                fourthOfJanuary.setHours(0, 0, 0, 0);
                var date = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuary);
                date.setDate(date.getDate() - 1);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfMonth/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfMonth/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name lastDayOfMonth
             * @category Month Helpers
             * @summary Return the last day of a month for the given date.
             *
             * @description
             * Return the last day of a month for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the last day of a month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The last day of a month for 2 September 2014 11:55:00:
             * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 00:00:00
             */
            function lastDayOfMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var month = date.getMonth();
                date.setFullYear(date.getFullYear(), month + 1, 0);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfQuarter/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfQuarter/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfQuarter; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name lastDayOfQuarter
             * @category Quarter Helpers
             * @summary Return the last day of a year quarter for the given date.
             *
             * @description
             * Return the last day of a year quarter for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @param {Object} [options] - an object with options.
             * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
             * @returns {Date} the last day of a quarter
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
             *
             * @example
             * // The last day of a quarter for 2 September 2014 11:55:00:
             * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 00:00:00
             */
            function lastDayOfQuarter(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var currentMonth = date.getMonth();
                var month = currentMonth - currentMonth % 3 + 3;
                date.setMonth(month, 0);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfWeek/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfWeek/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name lastDayOfWeek
             * @category Week Helpers
             * @summary Return the last day of a week for the given date.
             *
             * @description
             * Return the last day of a week for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the last day of a week
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // The last day of a week for 2 September 2014 11:55:00:
             * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sat Sep 06 2014 00:00:00
             *
             * @example
             * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
             * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
             * //=> Sun Sep 07 2014 00:00:00
             */
            function lastDayOfWeek(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getDay();
                var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() + diff);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lastDayOfYear/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/lastDayOfYear/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lastDayOfYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name lastDayOfYear
             * @category Year Helpers
             * @summary Return the last day of a year for the given date.
             *
             * @description
             * Return the last day of a year for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the last day of a year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The last day of a year for 2 September 2014 11:55:00:
             * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
             * //=> Wed Dec 31 2014 00:00:00
             */
            function lastDayOfYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                date.setFullYear(year + 1, 0, 0);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/lightFormat/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/lightFormat/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return lightFormat; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_format_lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/format/lightFormatters/index.js */ "./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /* harmony import */ var _isValid_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../isValid/index.js */ "./node_modules/date-fns/esm/isValid/index.js");
            /* harmony import */ var _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../subMilliseconds/index.js */ "./node_modules/date-fns/esm/subMilliseconds/index.js");
            // This RegExp consists of three parts separated by `|`:
            // - (\w)\1* matches any sequences of the same letter
            // - '' matches two quote characters in a row
            // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
            //   except a single quote symbol, which ends the sequence.
            //   Two quote characters do not end the sequence.
            //   If there is no matching single quote
            //   then the sequence will continue until the end of the string.
            // - . matches any single character unmatched by previous parts of the RegExps
            var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
            var escapedStringRegExp = /^'([^]*?)'?$/;
            var doubleQuoteRegExp = /''/g;
            var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
            /**
             * @name lightFormat
             * @category Common Helpers
             * @summary Format the date.
             *
             * @description
             * Return the formatted date string in the given format. Unlike `format`,
             * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
             *
             * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
             * > See: https://git.io/fxCyr
             *
             * The characters wrapped between two single quotes characters (') are escaped.
             * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
             *
             * Format of the string is based on Unicode Technical Standard #35:
             * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
             *
             * Accepted patterns:
             * | Unit                            | Pattern | Result examples                   |
             * |---------------------------------|---------|-----------------------------------|
             * | AM, PM                          | a..aaa  | AM, PM                            |
             * |                                 | aaaa    | a.m., p.m.                        |
             * |                                 | aaaaa   | a, p                              |
             * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
             * |                                 | yy      | 44, 01, 00, 17                    |
             * |                                 | yyy     | 044, 001, 000, 017                |
             * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
             * | Month (formatting)              | M       | 1, 2, ..., 12                     |
             * |                                 | MM      | 01, 02, ..., 12                   |
             * | Day of month                    | d       | 1, 2, ..., 31                     |
             * |                                 | dd      | 01, 02, ..., 31                   |
             * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
             * |                                 | hh      | 01, 02, ..., 11, 12               |
             * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
             * |                                 | HH      | 00, 01, 02, ..., 23               |
             * | Minute                          | m       | 0, 1, ..., 59                     |
             * |                                 | mm      | 00, 01, ..., 59                   |
             * | Second                          | s       | 0, 1, ..., 59                     |
             * |                                 | ss      | 00, 01, ..., 59                   |
             * | Fraction of second              | S       | 0, 1, ..., 9                      |
             * |                                 | SS      | 00, 01, ..., 99                   |
             * |                                 | SSS     | 000, 0001, ..., 999               |
             * |                                 | SSSS    | ...                               |
             *
             * @param {Date|Number} date - the original date
             * @param {String} format - the string of tokens
             * @returns {String} the formatted date string
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} format string contains an unescaped latin alphabet character
             *
             * @example
             * var result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
             * //=> '1987-02-11'
             */
            function lightFormat(dirtyDate, dirtyFormatStr) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var formatStr = String(dirtyFormatStr);
                var originalDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                if (!Object(_isValid_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(originalDate)) {
                    throw new RangeError('Invalid time value');
                } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
                // This ensures that when UTC functions will be implemented, locales will be compatible with them.
                // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
                var timezoneOffset = Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(originalDate);
                var utcDate = Object(_subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(originalDate, timezoneOffset);
                var result = formatStr.match(formattingTokensRegExp).map(function (substring) {
                    // Replace two single quote characters with one single quote character
                    if (substring === "''") {
                        return "'";
                    }
                    var firstCharacter = substring[0];
                    if (firstCharacter === "'") {
                        return cleanEscapedString(substring);
                    }
                    var formatter = _lib_format_lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_1__["default"][firstCharacter];
                    if (formatter) {
                        return formatter(utcDate, substring, null, {});
                    }
                    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
                        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                    }
                    return substring;
                }).join('');
                return result;
            }
            function cleanEscapedString(input) {
                return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js": 
        /*!**************************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js ***!
          \**************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return buildFormatLongFn; });
            function buildFormatLongFn(args) {
                return function (dirtyOptions) {
                    var options = dirtyOptions || {};
                    var width = options.width ? String(options.width) : args.defaultWidth;
                    var format = args.formats[width] || args.formats[args.defaultWidth];
                    return format;
                };
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js ***!
          \************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return buildLocalizeFn; });
            function buildLocalizeFn(args) {
                return function (dirtyIndex, dirtyOptions) {
                    var options = dirtyOptions || {};
                    var context = options.context ? String(options.context) : 'standalone';
                    var valuesArray;
                    if (context === 'formatting' && args.formattingValues) {
                        var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
                        var width = options.width ? String(options.width) : defaultWidth;
                        valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
                    }
                    else {
                        var _defaultWidth = args.defaultWidth;
                        var _width = options.width ? String(options.width) : args.defaultWidth;
                        valuesArray = args.values[_width] || args.values[_defaultWidth];
                    }
                    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
                    return valuesArray[index];
                };
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js ***!
          \*********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return buildMatchFn; });
            function buildMatchFn(args) {
                return function (dirtyString, dirtyOptions) {
                    var string = String(dirtyString);
                    var options = dirtyOptions || {};
                    var width = options.width;
                    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
                    var matchResult = string.match(matchPattern);
                    if (!matchResult) {
                        return null;
                    }
                    var matchedString = matchResult[0];
                    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
                    var value;
                    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
                        value = findIndex(parsePatterns, function (pattern) {
                            return pattern.test(string);
                        });
                    }
                    else {
                        value = findKey(parsePatterns, function (pattern) {
                            return pattern.test(string);
                        });
                    }
                    value = args.valueCallback ? args.valueCallback(value) : value;
                    value = options.valueCallback ? options.valueCallback(value) : value;
                    return {
                        value: value,
                        rest: string.slice(matchedString.length)
                    };
                };
            }
            function findKey(object, predicate) {
                for (var key in object) {
                    if (object.hasOwnProperty(key) && predicate(object[key])) {
                        return key;
                    }
                }
            }
            function findIndex(array, predicate) {
                for (var key = 0; key < array.length; key++) {
                    if (predicate(array[key])) {
                        return key;
                    }
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js": 
        /*!****************************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js ***!
          \****************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return buildMatchPatternFn; });
            function buildMatchPatternFn(args) {
                return function (dirtyString, dirtyOptions) {
                    var string = String(dirtyString);
                    var options = dirtyOptions || {};
                    var matchResult = string.match(args.matchPattern);
                    if (!matchResult) {
                        return null;
                    }
                    var matchedString = matchResult[0];
                    var parseResult = string.match(args.parsePattern);
                    if (!parseResult) {
                        return null;
                    }
                    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
                    value = options.valueCallback ? options.valueCallback(value) : value;
                    return {
                        value: value,
                        rest: string.slice(matchedString.length)
                    };
                };
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js ***!
          \*****************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return formatDistance; });
            var formatDistanceLocale = {
                lessThanXSeconds: {
                    one: 'less than a second',
                    other: 'less than {{count}} seconds'
                },
                xSeconds: {
                    one: '1 second',
                    other: '{{count}} seconds'
                },
                halfAMinute: 'half a minute',
                lessThanXMinutes: {
                    one: 'less than a minute',
                    other: 'less than {{count}} minutes'
                },
                xMinutes: {
                    one: '1 minute',
                    other: '{{count}} minutes'
                },
                aboutXHours: {
                    one: 'about 1 hour',
                    other: 'about {{count}} hours'
                },
                xHours: {
                    one: '1 hour',
                    other: '{{count}} hours'
                },
                xDays: {
                    one: '1 day',
                    other: '{{count}} days'
                },
                aboutXMonths: {
                    one: 'about 1 month',
                    other: 'about {{count}} months'
                },
                xMonths: {
                    one: '1 month',
                    other: '{{count}} months'
                },
                aboutXYears: {
                    one: 'about 1 year',
                    other: 'about {{count}} years'
                },
                xYears: {
                    one: '1 year',
                    other: '{{count}} years'
                },
                overXYears: {
                    one: 'over 1 year',
                    other: 'over {{count}} years'
                },
                almostXYears: {
                    one: 'almost 1 year',
                    other: 'almost {{count}} years'
                }
            };
            function formatDistance(token, count, options) {
                options = options || {};
                var result;
                if (typeof formatDistanceLocale[token] === 'string') {
                    result = formatDistanceLocale[token];
                }
                else if (count === 1) {
                    result = formatDistanceLocale[token].one;
                }
                else {
                    result = formatDistanceLocale[token].other.replace('{{count}}', count);
                }
                if (options.addSuffix) {
                    if (options.comparison > 0) {
                        return 'in ' + result;
                    }
                    else {
                        return result + ' ago';
                    }
                }
                return result;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js ***!
          \*************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/buildFormatLongFn/index.js */ "./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js");
            var dateFormats = {
                full: 'EEEE, MMMM do, y',
                long: 'MMMM do, y',
                medium: 'MMM d, y',
                short: 'MM/dd/yyyy'
            };
            var timeFormats = {
                full: 'h:mm:ss a zzzz',
                long: 'h:mm:ss a z',
                medium: 'h:mm:ss a',
                short: 'h:mm a'
            };
            var dateTimeFormats = {
                full: "{{date}} 'at' {{time}}",
                long: "{{date}} 'at' {{time}}",
                medium: '{{date}}, {{time}}',
                short: '{{date}}, {{time}}'
            };
            var formatLong = {
                date: Object(_lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    formats: dateFormats,
                    defaultWidth: 'full'
                }),
                time: Object(_lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    formats: timeFormats,
                    defaultWidth: 'full'
                }),
                dateTime: Object(_lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    formats: dateTimeFormats,
                    defaultWidth: 'full'
                })
            };
            /* harmony default export */ __webpack_exports__["default"] = (formatLong);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js ***!
          \*****************************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return formatRelative; });
            var formatRelativeLocale = {
                lastWeek: "'last' eeee 'at' p",
                yesterday: "'yesterday at' p",
                today: "'today at' p",
                tomorrow: "'tomorrow at' p",
                nextWeek: "eeee 'at' p",
                other: 'P'
            };
            function formatRelative(token, _date, _baseDate, _options) {
                return formatRelativeLocale[token];
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js ***!
          \***********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/buildLocalizeFn/index.js */ "./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js");
            var eraValues = {
                narrow: ['B', 'A'],
                abbreviated: ['BC', 'AD'],
                wide: ['Before Christ', 'Anno Domini']
            };
            var quarterValues = {
                narrow: ['1', '2', '3', '4'],
                abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
                wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
                // If you are making a new locale based on this one, check if the same is true for the language you're working on.
                // Generally, formatted dates should look like they are in the middle of a sentence,
                // e.g. in Spanish language the weekdays and months should be in the lowercase.
            };
            var monthValues = {
                narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            };
            var dayValues = {
                narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
            };
            var dayPeriodValues = {
                narrow: {
                    am: 'a',
                    pm: 'p',
                    midnight: 'mi',
                    noon: 'n',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                },
                abbreviated: {
                    am: 'AM',
                    pm: 'PM',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                },
                wide: {
                    am: 'a.m.',
                    pm: 'p.m.',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                }
            };
            var formattingDayPeriodValues = {
                narrow: {
                    am: 'a',
                    pm: 'p',
                    midnight: 'mi',
                    noon: 'n',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                },
                abbreviated: {
                    am: 'AM',
                    pm: 'PM',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                },
                wide: {
                    am: 'a.m.',
                    pm: 'p.m.',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                }
            };
            function ordinalNumber(dirtyNumber, _dirtyOptions) {
                var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
                // if they are different for different grammatical genders,
                // use `options.unit`:
                //
                //   var options = dirtyOptions || {}
                //   var unit = String(options.unit)
                //
                // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
                // 'day', 'hour', 'minute', 'second'
                var rem100 = number % 100;
                if (rem100 > 20 || rem100 < 10) {
                    switch (rem100 % 10) {
                        case 1:
                            return number + 'st';
                        case 2:
                            return number + 'nd';
                        case 3:
                            return number + 'rd';
                    }
                }
                return number + 'th';
            }
            var localize = {
                ordinalNumber: ordinalNumber,
                era: Object(_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    values: eraValues,
                    defaultWidth: 'wide'
                }),
                quarter: Object(_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    values: quarterValues,
                    defaultWidth: 'wide',
                    argumentCallback: function (quarter) {
                        return Number(quarter) - 1;
                    }
                }),
                month: Object(_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    values: monthValues,
                    defaultWidth: 'wide'
                }),
                day: Object(_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    values: dayValues,
                    defaultWidth: 'wide'
                }),
                dayPeriod: Object(_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    values: dayPeriodValues,
                    defaultWidth: 'wide',
                    formattingValues: formattingDayPeriodValues,
                    defaultFormattingWidth: 'wide'
                })
            };
            /* harmony default export */ __webpack_exports__["default"] = (localize);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js ***!
          \********************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/buildMatchPatternFn/index.js */ "./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js");
            /* harmony import */ var _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../_lib/buildMatchFn/index.js */ "./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js");
            var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
            var parseOrdinalNumberPattern = /\d+/i;
            var matchEraPatterns = {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
            };
            var parseEraPatterns = {
                any: [/^b/i, /^(a|c)/i]
            };
            var matchQuarterPatterns = {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
            };
            var parseQuarterPatterns = {
                any: [/1/i, /2/i, /3/i, /4/i]
            };
            var matchMonthPatterns = {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            };
            var parseMonthPatterns = {
                narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
                any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
            };
            var matchDayPatterns = {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            };
            var parseDayPatterns = {
                narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
                any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
            };
            var matchDayPeriodPatterns = {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            };
            var parseDayPeriodPatterns = {
                any: {
                    am: /^a/i,
                    pm: /^p/i,
                    midnight: /^mi/i,
                    noon: /^no/i,
                    morning: /morning/i,
                    afternoon: /afternoon/i,
                    evening: /evening/i,
                    night: /night/i
                }
            };
            var match = {
                ordinalNumber: Object(_lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
                    matchPattern: matchOrdinalNumberPattern,
                    parsePattern: parseOrdinalNumberPattern,
                    valueCallback: function (value) {
                        return parseInt(value, 10);
                    }
                }),
                era: Object(_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
                    matchPatterns: matchEraPatterns,
                    defaultMatchWidth: 'wide',
                    parsePatterns: parseEraPatterns,
                    defaultParseWidth: 'any'
                }),
                quarter: Object(_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
                    matchPatterns: matchQuarterPatterns,
                    defaultMatchWidth: 'wide',
                    parsePatterns: parseQuarterPatterns,
                    defaultParseWidth: 'any',
                    valueCallback: function (index) {
                        return index + 1;
                    }
                }),
                month: Object(_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
                    matchPatterns: matchMonthPatterns,
                    defaultMatchWidth: 'wide',
                    parsePatterns: parseMonthPatterns,
                    defaultParseWidth: 'any'
                }),
                day: Object(_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
                    matchPatterns: matchDayPatterns,
                    defaultMatchWidth: 'wide',
                    parsePatterns: parseDayPatterns,
                    defaultParseWidth: 'any'
                }),
                dayPeriod: Object(_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
                    matchPatterns: matchDayPeriodPatterns,
                    defaultMatchWidth: 'any',
                    parsePatterns: parseDayPeriodPatterns,
                    defaultParseWidth: 'any'
                })
            };
            /* harmony default export */ __webpack_exports__["default"] = (match);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/locale/en-US/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/locale/en-US/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _lib_formatDistance_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_lib/formatDistance/index.js */ "./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js");
            /* harmony import */ var _lib_formatLong_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./_lib/formatLong/index.js */ "./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js");
            /* harmony import */ var _lib_formatRelative_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./_lib/formatRelative/index.js */ "./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js");
            /* harmony import */ var _lib_localize_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./_lib/localize/index.js */ "./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js");
            /* harmony import */ var _lib_match_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./_lib/match/index.js */ "./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js");
            /**
             * @type {Locale}
             * @category Locales
             * @summary English locale (United States).
             * @language English
             * @iso-639-2 eng
             * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
             * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
             */
            var locale = {
                code: 'en-US',
                formatDistance: _lib_formatDistance_index_js__WEBPACK_IMPORTED_MODULE_0__["default"],
                formatLong: _lib_formatLong_index_js__WEBPACK_IMPORTED_MODULE_1__["default"],
                formatRelative: _lib_formatRelative_index_js__WEBPACK_IMPORTED_MODULE_2__["default"],
                localize: _lib_localize_index_js__WEBPACK_IMPORTED_MODULE_3__["default"],
                match: _lib_match_index_js__WEBPACK_IMPORTED_MODULE_4__["default"],
                options: {
                    weekStartsOn: 0
                    /* Sunday */
                    ,
                    firstWeekContainsDate: 1
                }
            };
            /* harmony default export */ __webpack_exports__["default"] = (locale);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/max/index.js": 
        /*!************************************************!*\
          !*** ./node_modules/date-fns/esm/max/index.js ***!
          \************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return max; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name max
             * @category Common Helpers
             * @summary Return the latest of the given dates.
             *
             * @description
             * Return the latest of the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - `max` function now accepts an array of dates rather than spread arguments.
             *
             *   ```javascript
             *   // Before v2.0.0
             *   var date1 = new Date(1989, 6, 10)
             *   var date2 = new Date(1987, 1, 11)
             *   var maxDate = max(date1, date2)
             *
             *   // v2.0.0 onward:
             *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
             *   var maxDate = max(dates)
             *   ```
             *
             * @param {Date[]|Number[]} datesArray - the dates to compare
             * @returns {Date} the latest of the dates
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which of these dates is the latest?
             * var result = max([
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * ])
             * //=> Sun Jul 02 1995 00:00:00
             */
            function max(dirtyDatesArray) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
                if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
                    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
                }
                else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
                    datesArray = Array.prototype.slice.call(dirtyDatesArray);
                }
                else {
                    // `dirtyDatesArray` is non-iterable, return Invalid Date
                    return new Date(NaN);
                }
                var result;
                datesArray.forEach(function (dirtyDate) {
                    var currentDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                    if (result === undefined || result < currentDate || isNaN(currentDate)) {
                        result = currentDate;
                    }
                });
                return result || new Date(NaN);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/min/index.js": 
        /*!************************************************!*\
          !*** ./node_modules/date-fns/esm/min/index.js ***!
          \************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return min; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name min
             * @category Common Helpers
             * @summary Return the earliest of the given dates.
             *
             * @description
             * Return the earliest of the given dates.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - `min` function now accepts an array of dates rather than spread arguments.
             *
             *   ```javascript
             *   // Before v2.0.0
             *   var date1 = new Date(1989, 6, 10)
             *   var date2 = new Date(1987, 1, 11)
             *   var minDate = min(date1, date2)
             *
             *   // v2.0.0 onward:
             *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
             *   var minDate = min(dates)
             *   ```
             *
             * @param {Date[]|Number[]} datesArray - the dates to compare
             * @returns {Date} the earliest of the dates
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Which of these dates is the earliest?
             * var result = min([
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * ])
             * //=> Wed Feb 11 1987 00:00:00
             */
            function min(dirtyDatesArray) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
                if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
                    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
                }
                else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
                    datesArray = Array.prototype.slice.call(dirtyDatesArray);
                }
                else {
                    // `dirtyDatesArray` is non-iterable, return Invalid Date
                    return new Date(NaN);
                }
                var result;
                datesArray.forEach(function (dirtyDate) {
                    var currentDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                    if (result === undefined || result > currentDate || isNaN(currentDate)) {
                        result = currentDate;
                    }
                });
                return result || new Date(NaN);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/parse/_lib/parsers/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/parse/_lib/parsers/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _lib_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/getUTCWeekYear/index.js */ "./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js");
            /* harmony import */ var _lib_setUTCDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../_lib/setUTCDay/index.js */ "./node_modules/date-fns/esm/_lib/setUTCDay/index.js");
            /* harmony import */ var _lib_setUTCISODay_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../_lib/setUTCISODay/index.js */ "./node_modules/date-fns/esm/_lib/setUTCISODay/index.js");
            /* harmony import */ var _lib_setUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../_lib/setUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js");
            /* harmony import */ var _lib_setUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../_lib/setUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/setUTCWeek/index.js");
            /* harmony import */ var _lib_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../_lib/startOfUTCISOWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
            /* harmony import */ var _lib_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../_lib/startOfUTCWeek/index.js */ "./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
            var MILLISECONDS_IN_HOUR = 3600000;
            var MILLISECONDS_IN_MINUTE = 60000;
            var MILLISECONDS_IN_SECOND = 1000;
            var numericPatterns = {
                month: /^(1[0-2]|0?\d)/,
                // 0 to 12
                date: /^(3[0-1]|[0-2]?\d)/,
                // 0 to 31
                dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
                // 0 to 366
                week: /^(5[0-3]|[0-4]?\d)/,
                // 0 to 53
                hour23h: /^(2[0-3]|[0-1]?\d)/,
                // 0 to 23
                hour24h: /^(2[0-4]|[0-1]?\d)/,
                // 0 to 24
                hour11h: /^(1[0-1]|0?\d)/,
                // 0 to 11
                hour12h: /^(1[0-2]|0?\d)/,
                // 0 to 12
                minute: /^[0-5]?\d/,
                // 0 to 59
                second: /^[0-5]?\d/,
                // 0 to 59
                singleDigit: /^\d/,
                // 0 to 9
                twoDigits: /^\d{1,2}/,
                // 0 to 99
                threeDigits: /^\d{1,3}/,
                // 0 to 999
                fourDigits: /^\d{1,4}/,
                // 0 to 9999
                anyDigitsSigned: /^-?\d+/,
                singleDigitSigned: /^-?\d/,
                // 0 to 9, -0 to -9
                twoDigitsSigned: /^-?\d{1,2}/,
                // 0 to 99, -0 to -99
                threeDigitsSigned: /^-?\d{1,3}/,
                // 0 to 999, -0 to -999
                fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
            };
            var timezonePatterns = {
                basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
                basic: /^([+-])(\d{2})(\d{2})|Z/,
                basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
                extended: /^([+-])(\d{2}):(\d{2})|Z/,
                extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
            };
            function parseNumericPattern(pattern, string, valueCallback) {
                var matchResult = string.match(pattern);
                if (!matchResult) {
                    return null;
                }
                var value = parseInt(matchResult[0], 10);
                return {
                    value: valueCallback ? valueCallback(value) : value,
                    rest: string.slice(matchResult[0].length)
                };
            }
            function parseTimezonePattern(pattern, string) {
                var matchResult = string.match(pattern);
                if (!matchResult) {
                    return null;
                } // Input is 'Z'
                if (matchResult[0] === 'Z') {
                    return {
                        value: 0,
                        rest: string.slice(1)
                    };
                }
                var sign = matchResult[1] === '+' ? 1 : -1;
                var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
                var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
                var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
                return {
                    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
                    rest: string.slice(matchResult[0].length)
                };
            }
            function parseAnyDigitsSigned(string, valueCallback) {
                return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
            }
            function parseNDigits(n, string, valueCallback) {
                switch (n) {
                    case 1:
                        return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
                    case 2:
                        return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
                    case 3:
                        return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
                    case 4:
                        return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
                    default:
                        return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
                }
            }
            function parseNDigitsSigned(n, string, valueCallback) {
                switch (n) {
                    case 1:
                        return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
                    case 2:
                        return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
                    case 3:
                        return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
                    case 4:
                        return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
                    default:
                        return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
                }
            }
            function dayPeriodEnumToHours(enumValue) {
                switch (enumValue) {
                    case 'morning':
                        return 4;
                    case 'evening':
                        return 17;
                    case 'pm':
                    case 'noon':
                    case 'afternoon':
                        return 12;
                    case 'am':
                    case 'midnight':
                    case 'night':
                    default:
                        return 0;
                }
            }
            function normalizeTwoDigitYear(twoDigitYear, currentYear) {
                var isCommonEra = currentYear > 0; // Absolute number of the current year:
                // 1 -> 1 AC
                // 0 -> 1 BC
                // -1 -> 2 BC
                var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
                var result;
                if (absCurrentYear <= 50) {
                    result = twoDigitYear || 100;
                }
                else {
                    var rangeEnd = absCurrentYear + 50;
                    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
                    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
                    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
                }
                return isCommonEra ? result : 1 - result;
            }
            var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
            function isLeapYearIndex(year) {
                return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
            }
            /*
             * |     | Unit                           |     | Unit                           |
             * |-----|--------------------------------|-----|--------------------------------|
             * |  a  | AM, PM                         |  A* | Milliseconds in day            |
             * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
             * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
             * |  d  | Day of month                   |  D  | Day of year                    |
             * |  e  | Local day of week              |  E  | Day of week                    |
             * |  f  |                                |  F* | Day of week in month           |
             * |  g* | Modified Julian day            |  G  | Era                            |
             * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
             * |  i! | ISO day of week                |  I! | ISO week of year               |
             * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
             * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
             * |  l* | (deprecated)                   |  L  | Stand-alone month              |
             * |  m  | Minute                         |  M  | Month                          |
             * |  n  |                                |  N  |                                |
             * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
             * |  p  |                                |  P  |                                |
             * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
             * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
             * |  s  | Second                         |  S  | Fraction of second             |
             * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
             * |  u  | Extended year                  |  U* | Cyclic year                    |
             * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
             * |  w  | Local week of year             |  W* | Week of month                  |
             * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
             * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
             * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
             *
             * Letters marked by * are not implemented but reserved by Unicode standard.
             *
             * Letters marked by ! are non-standard, but implemented by date-fns:
             * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
             * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
             *   i.e. 7 for Sunday, 1 for Monday, etc.
             * - `I` is ISO week of year, as opposed to `w` which is local week of year.
             * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
             *   `R` is supposed to be used in conjunction with `I` and `i`
             *   for universal ISO week-numbering date, whereas
             *   `Y` is supposed to be used in conjunction with `w` and `e`
             *   for week-numbering date specific to the locale.
             */
            var parsers = {
                // Era
                G: {
                    priority: 140,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            // AD, BC
                            case 'G':
                            case 'GG':
                            case 'GGG':
                                return match.era(string, {
                                    width: 'abbreviated'
                                }) || match.era(string, {
                                    width: 'narrow'
                                });
                            // A, B
                            case 'GGGGG':
                                return match.era(string, {
                                    width: 'narrow'
                                });
                            // Anno Domini, Before Christ
                            case 'GGGG':
                            default:
                                return match.era(string, {
                                    width: 'wide'
                                }) || match.era(string, {
                                    width: 'abbreviated'
                                }) || match.era(string, {
                                    width: 'narrow'
                                });
                        }
                    },
                    set: function (date, flags, value, _options) {
                        flags.era = value;
                        date.setUTCFullYear(value, 0, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['R', 'u', 't', 'T']
                },
                // Year
                y: {
                    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
                    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
                    // |----------|-------|----|-------|-------|-------|
                    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
                    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
                    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
                    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
                    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
                    priority: 130,
                    parse: function (string, token, match, _options) {
                        var valueCallback = function (year) {
                            return {
                                year: year,
                                isTwoDigitYear: token === 'yy'
                            };
                        };
                        switch (token) {
                            case 'y':
                                return parseNDigits(4, string, valueCallback);
                            case 'yo':
                                return match.ordinalNumber(string, {
                                    unit: 'year',
                                    valueCallback: valueCallback
                                });
                            default:
                                return parseNDigits(token.length, string, valueCallback);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value.isTwoDigitYear || value.year > 0;
                    },
                    set: function (date, flags, value, _options) {
                        var currentYear = date.getUTCFullYear();
                        if (value.isTwoDigitYear) {
                            var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
                            date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                            date.setUTCHours(0, 0, 0, 0);
                            return date;
                        }
                        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                        date.setUTCFullYear(year, 0, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
                },
                // Local week-numbering year
                Y: {
                    priority: 130,
                    parse: function (string, token, match, _options) {
                        var valueCallback = function (year) {
                            return {
                                year: year,
                                isTwoDigitYear: token === 'YY'
                            };
                        };
                        switch (token) {
                            case 'Y':
                                return parseNDigits(4, string, valueCallback);
                            case 'Yo':
                                return match.ordinalNumber(string, {
                                    unit: 'year',
                                    valueCallback: valueCallback
                                });
                            default:
                                return parseNDigits(token.length, string, valueCallback);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value.isTwoDigitYear || value.year > 0;
                    },
                    set: function (date, flags, value, options) {
                        var currentYear = Object(_lib_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date, options);
                        if (value.isTwoDigitYear) {
                            var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
                            date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                            date.setUTCHours(0, 0, 0, 0);
                            return Object(_lib_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(date, options);
                        }
                        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                        date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                        date.setUTCHours(0, 0, 0, 0);
                        return Object(_lib_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(date, options);
                    },
                    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
                },
                // ISO week-numbering year
                R: {
                    priority: 130,
                    parse: function (string, token, _match, _options) {
                        if (token === 'R') {
                            return parseNDigitsSigned(4, string);
                        }
                        return parseNDigitsSigned(token.length, string);
                    },
                    set: function (_date, _flags, value, _options) {
                        var firstWeekOfYear = new Date(0);
                        firstWeekOfYear.setUTCFullYear(value, 0, 4);
                        firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                        return Object(_lib_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(firstWeekOfYear);
                    },
                    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
                },
                // Extended year
                u: {
                    priority: 130,
                    parse: function (string, token, _match, _options) {
                        if (token === 'u') {
                            return parseNDigitsSigned(4, string);
                        }
                        return parseNDigitsSigned(token.length, string);
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCFullYear(value, 0, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
                },
                // Quarter
                Q: {
                    priority: 120,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            // 1, 2, 3, 4
                            case 'Q':
                            case 'QQ':
                                // 01, 02, 03, 04
                                return parseNDigits(token.length, string);
                            // 1st, 2nd, 3rd, 4th
                            case 'Qo':
                                return match.ordinalNumber(string, {
                                    unit: 'quarter'
                                });
                            // Q1, Q2, Q3, Q4
                            case 'QQQ':
                                return match.quarter(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.quarter(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                            case 'QQQQQ':
                                return match.quarter(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // 1st quarter, 2nd quarter, ...
                            case 'QQQQ':
                            default:
                                return match.quarter(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.quarter(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.quarter(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 4;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMonth((value - 1) * 3, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
                },
                // Stand-alone quarter
                q: {
                    priority: 120,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            // 1, 2, 3, 4
                            case 'q':
                            case 'qq':
                                // 01, 02, 03, 04
                                return parseNDigits(token.length, string);
                            // 1st, 2nd, 3rd, 4th
                            case 'qo':
                                return match.ordinalNumber(string, {
                                    unit: 'quarter'
                                });
                            // Q1, Q2, Q3, Q4
                            case 'qqq':
                                return match.quarter(string, {
                                    width: 'abbreviated',
                                    context: 'standalone'
                                }) || match.quarter(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                            case 'qqqqq':
                                return match.quarter(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // 1st quarter, 2nd quarter, ...
                            case 'qqqq':
                            default:
                                return match.quarter(string, {
                                    width: 'wide',
                                    context: 'standalone'
                                }) || match.quarter(string, {
                                    width: 'abbreviated',
                                    context: 'standalone'
                                }) || match.quarter(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 4;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMonth((value - 1) * 3, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
                },
                // Month
                M: {
                    priority: 110,
                    parse: function (string, token, match, _options) {
                        var valueCallback = function (value) {
                            return value - 1;
                        };
                        switch (token) {
                            // 1, 2, ..., 12
                            case 'M':
                                return parseNumericPattern(numericPatterns.month, string, valueCallback);
                            // 01, 02, ..., 12
                            case 'MM':
                                return parseNDigits(2, string, valueCallback);
                            // 1st, 2nd, ..., 12th
                            case 'Mo':
                                return match.ordinalNumber(string, {
                                    unit: 'month',
                                    valueCallback: valueCallback
                                });
                            // Jan, Feb, ..., Dec
                            case 'MMM':
                                return match.month(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.month(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // J, F, ..., D
                            case 'MMMMM':
                                return match.month(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // January, February, ..., December
                            case 'MMMM':
                            default:
                                return match.month(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.month(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.month(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 11;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMonth(value, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
                },
                // Stand-alone month
                L: {
                    priority: 110,
                    parse: function (string, token, match, _options) {
                        var valueCallback = function (value) {
                            return value - 1;
                        };
                        switch (token) {
                            // 1, 2, ..., 12
                            case 'L':
                                return parseNumericPattern(numericPatterns.month, string, valueCallback);
                            // 01, 02, ..., 12
                            case 'LL':
                                return parseNDigits(2, string, valueCallback);
                            // 1st, 2nd, ..., 12th
                            case 'Lo':
                                return match.ordinalNumber(string, {
                                    unit: 'month',
                                    valueCallback: valueCallback
                                });
                            // Jan, Feb, ..., Dec
                            case 'LLL':
                                return match.month(string, {
                                    width: 'abbreviated',
                                    context: 'standalone'
                                }) || match.month(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // J, F, ..., D
                            case 'LLLLL':
                                return match.month(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // January, February, ..., December
                            case 'LLLL':
                            default:
                                return match.month(string, {
                                    width: 'wide',
                                    context: 'standalone'
                                }) || match.month(string, {
                                    width: 'abbreviated',
                                    context: 'standalone'
                                }) || match.month(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 11;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMonth(value, 1);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
                },
                // Local week of year
                w: {
                    priority: 100,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'w':
                                return parseNumericPattern(numericPatterns.week, string);
                            case 'wo':
                                return match.ordinalNumber(string, {
                                    unit: 'week'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 53;
                    },
                    set: function (date, _flags, value, options) {
                        return Object(_lib_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_6__["default"])(Object(_lib_setUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(date, value, options), options);
                    },
                    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
                },
                // ISO week of year
                I: {
                    priority: 100,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'I':
                                return parseNumericPattern(numericPatterns.week, string);
                            case 'Io':
                                return match.ordinalNumber(string, {
                                    unit: 'week'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 53;
                    },
                    set: function (date, _flags, value, options) {
                        return Object(_lib_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(Object(_lib_setUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, value, options), options);
                    },
                    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
                },
                // Day of the month
                d: {
                    priority: 90,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'd':
                                return parseNumericPattern(numericPatterns.date, string);
                            case 'do':
                                return match.ordinalNumber(string, {
                                    unit: 'date'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (date, value, _options) {
                        var year = date.getUTCFullYear();
                        var isLeapYear = isLeapYearIndex(year);
                        var month = date.getUTCMonth();
                        if (isLeapYear) {
                            return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                        }
                        else {
                            return value >= 1 && value <= DAYS_IN_MONTH[month];
                        }
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCDate(value);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
                },
                // Day of year
                D: {
                    priority: 90,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'D':
                            case 'DD':
                                return parseNumericPattern(numericPatterns.dayOfYear, string);
                            case 'Do':
                                return match.ordinalNumber(string, {
                                    unit: 'date'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (date, value, _options) {
                        var year = date.getUTCFullYear();
                        var isLeapYear = isLeapYearIndex(year);
                        if (isLeapYear) {
                            return value >= 1 && value <= 366;
                        }
                        else {
                            return value >= 1 && value <= 365;
                        }
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMonth(0, value);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
                },
                // Day of week
                E: {
                    priority: 90,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            // Tue
                            case 'E':
                            case 'EE':
                            case 'EEE':
                                return match.day(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // T
                            case 'EEEEE':
                                return match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // Tu
                            case 'EEEEEE':
                                return match.day(string, {
                                    width: 'short',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // Tuesday
                            case 'EEEE':
                            default:
                                return match.day(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 6;
                    },
                    set: function (date, _flags, value, options) {
                        date = Object(_lib_setUTCDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, value, options);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
                },
                // Local day of week
                e: {
                    priority: 90,
                    parse: function (string, token, match, options) {
                        var valueCallback = function (value) {
                            var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                        };
                        switch (token) {
                            // 3
                            case 'e':
                            case 'ee':
                                // 03
                                return parseNDigits(token.length, string, valueCallback);
                            // 3rd
                            case 'eo':
                                return match.ordinalNumber(string, {
                                    unit: 'day',
                                    valueCallback: valueCallback
                                });
                            // Tue
                            case 'eee':
                                return match.day(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // T
                            case 'eeeee':
                                return match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // Tu
                            case 'eeeeee':
                                return match.day(string, {
                                    width: 'short',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            // Tuesday
                            case 'eeee':
                            default:
                                return match.day(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'formatting'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 6;
                    },
                    set: function (date, _flags, value, options) {
                        date = Object(_lib_setUTCDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, value, options);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
                },
                // Stand-alone local day of week
                c: {
                    priority: 90,
                    parse: function (string, token, match, options) {
                        var valueCallback = function (value) {
                            var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                        };
                        switch (token) {
                            // 3
                            case 'c':
                            case 'cc':
                                // 03
                                return parseNDigits(token.length, string, valueCallback);
                            // 3rd
                            case 'co':
                                return match.ordinalNumber(string, {
                                    unit: 'day',
                                    valueCallback: valueCallback
                                });
                            // Tue
                            case 'ccc':
                                return match.day(string, {
                                    width: 'abbreviated',
                                    context: 'standalone'
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'standalone'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // T
                            case 'ccccc':
                                return match.day(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // Tu
                            case 'cccccc':
                                return match.day(string, {
                                    width: 'short',
                                    context: 'standalone'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                            // Tuesday
                            case 'cccc':
                            default:
                                return match.day(string, {
                                    width: 'wide',
                                    context: 'standalone'
                                }) || match.day(string, {
                                    width: 'abbreviated',
                                    context: 'standalone'
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'standalone'
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'standalone'
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 6;
                    },
                    set: function (date, _flags, value, options) {
                        date = Object(_lib_setUTCDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, value, options);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
                },
                // ISO day of week
                i: {
                    priority: 90,
                    parse: function (string, token, match, _options) {
                        var valueCallback = function (value) {
                            if (value === 0) {
                                return 7;
                            }
                            return value;
                        };
                        switch (token) {
                            // 2
                            case 'i':
                            case 'ii':
                                // 02
                                return parseNDigits(token.length, string);
                            // 2nd
                            case 'io':
                                return match.ordinalNumber(string, {
                                    unit: 'day'
                                });
                            // Tue
                            case 'iii':
                                return match.day(string, {
                                    width: 'abbreviated',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                });
                            // T
                            case 'iiiii':
                                return match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                });
                            // Tu
                            case 'iiiiii':
                                return match.day(string, {
                                    width: 'short',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                });
                            // Tuesday
                            case 'iiii':
                            default:
                                return match.day(string, {
                                    width: 'wide',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                }) || match.day(string, {
                                    width: 'abbreviated',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                }) || match.day(string, {
                                    width: 'short',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                }) || match.day(string, {
                                    width: 'narrow',
                                    context: 'formatting',
                                    valueCallback: valueCallback
                                });
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 7;
                    },
                    set: function (date, _flags, value, options) {
                        date = Object(_lib_setUTCISODay_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date, value, options);
                        date.setUTCHours(0, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
                },
                // AM or PM
                a: {
                    priority: 80,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'a':
                            case 'aa':
                            case 'aaa':
                                return match.dayPeriod(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            case 'aaaaa':
                                return match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            case 'aaaa':
                            default:
                                return match.dayPeriod(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
                },
                // AM, PM, midnight
                b: {
                    priority: 80,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'b':
                            case 'bb':
                            case 'bbb':
                                return match.dayPeriod(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            case 'bbbbb':
                                return match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            case 'bbbb':
                            default:
                                return match.dayPeriod(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
                },
                // in the morning, in the afternoon, in the evening, at night
                B: {
                    priority: 80,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'B':
                            case 'BB':
                            case 'BBB':
                                return match.dayPeriod(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            case 'BBBBB':
                                return match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                            case 'BBBB':
                            default:
                                return match.dayPeriod(string, {
                                    width: 'wide',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'abbreviated',
                                    context: 'formatting'
                                }) || match.dayPeriod(string, {
                                    width: 'narrow',
                                    context: 'formatting'
                                });
                        }
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['a', 'b', 't', 'T']
                },
                // Hour [1-12]
                h: {
                    priority: 70,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'h':
                                return parseNumericPattern(numericPatterns.hour12h, string);
                            case 'ho':
                                return match.ordinalNumber(string, {
                                    unit: 'hour'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 12;
                    },
                    set: function (date, _flags, value, _options) {
                        var isPM = date.getUTCHours() >= 12;
                        if (isPM && value < 12) {
                            date.setUTCHours(value + 12, 0, 0, 0);
                        }
                        else if (!isPM && value === 12) {
                            date.setUTCHours(0, 0, 0, 0);
                        }
                        else {
                            date.setUTCHours(value, 0, 0, 0);
                        }
                        return date;
                    },
                    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
                },
                // Hour [0-23]
                H: {
                    priority: 70,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'H':
                                return parseNumericPattern(numericPatterns.hour23h, string);
                            case 'Ho':
                                return match.ordinalNumber(string, {
                                    unit: 'hour'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 23;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCHours(value, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
                },
                // Hour [0-11]
                K: {
                    priority: 70,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'K':
                                return parseNumericPattern(numericPatterns.hour11h, string);
                            case 'Ko':
                                return match.ordinalNumber(string, {
                                    unit: 'hour'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 11;
                    },
                    set: function (date, _flags, value, _options) {
                        var isPM = date.getUTCHours() >= 12;
                        if (isPM && value < 12) {
                            date.setUTCHours(value + 12, 0, 0, 0);
                        }
                        else {
                            date.setUTCHours(value, 0, 0, 0);
                        }
                        return date;
                    },
                    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
                },
                // Hour [1-24]
                k: {
                    priority: 70,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'k':
                                return parseNumericPattern(numericPatterns.hour24h, string);
                            case 'ko':
                                return match.ordinalNumber(string, {
                                    unit: 'hour'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 1 && value <= 24;
                    },
                    set: function (date, _flags, value, _options) {
                        var hours = value <= 24 ? value % 24 : value;
                        date.setUTCHours(hours, 0, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
                },
                // Minute
                m: {
                    priority: 60,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 'm':
                                return parseNumericPattern(numericPatterns.minute, string);
                            case 'mo':
                                return match.ordinalNumber(string, {
                                    unit: 'minute'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 59;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMinutes(value, 0, 0);
                        return date;
                    },
                    incompatibleTokens: ['t', 'T']
                },
                // Second
                s: {
                    priority: 50,
                    parse: function (string, token, match, _options) {
                        switch (token) {
                            case 's':
                                return parseNumericPattern(numericPatterns.second, string);
                            case 'so':
                                return match.ordinalNumber(string, {
                                    unit: 'second'
                                });
                            default:
                                return parseNDigits(token.length, string);
                        }
                    },
                    validate: function (_date, value, _options) {
                        return value >= 0 && value <= 59;
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCSeconds(value, 0);
                        return date;
                    },
                    incompatibleTokens: ['t', 'T']
                },
                // Fraction of second
                S: {
                    priority: 30,
                    parse: function (string, token, _match, _options) {
                        var valueCallback = function (value) {
                            return Math.floor(value * Math.pow(10, -token.length + 3));
                        };
                        return parseNDigits(token.length, string, valueCallback);
                    },
                    set: function (date, _flags, value, _options) {
                        date.setUTCMilliseconds(value);
                        return date;
                    },
                    incompatibleTokens: ['t', 'T']
                },
                // Timezone (ISO-8601. +00:00 is `'Z'`)
                X: {
                    priority: 10,
                    parse: function (string, token, _match, _options) {
                        switch (token) {
                            case 'X':
                                return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
                            case 'XX':
                                return parseTimezonePattern(timezonePatterns.basic, string);
                            case 'XXXX':
                                return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
                            case 'XXXXX':
                                return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
                            case 'XXX':
                            default:
                                return parseTimezonePattern(timezonePatterns.extended, string);
                        }
                    },
                    set: function (date, flags, value, _options) {
                        if (flags.timestampIsSet) {
                            return date;
                        }
                        return new Date(date.getTime() - value);
                    },
                    incompatibleTokens: ['t', 'T', 'x']
                },
                // Timezone (ISO-8601)
                x: {
                    priority: 10,
                    parse: function (string, token, _match, _options) {
                        switch (token) {
                            case 'x':
                                return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
                            case 'xx':
                                return parseTimezonePattern(timezonePatterns.basic, string);
                            case 'xxxx':
                                return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
                            case 'xxxxx':
                                return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
                            case 'xxx':
                            default:
                                return parseTimezonePattern(timezonePatterns.extended, string);
                        }
                    },
                    set: function (date, flags, value, _options) {
                        if (flags.timestampIsSet) {
                            return date;
                        }
                        return new Date(date.getTime() - value);
                    },
                    incompatibleTokens: ['t', 'T', 'X']
                },
                // Seconds timestamp
                t: {
                    priority: 40,
                    parse: function (string, _token, _match, _options) {
                        return parseAnyDigitsSigned(string);
                    },
                    set: function (_date, _flags, value, _options) {
                        return [new Date(value * 1000), {
                                timestampIsSet: true
                            }];
                    },
                    incompatibleTokens: '*'
                },
                // Milliseconds timestamp
                T: {
                    priority: 20,
                    parse: function (string, _token, _match, _options) {
                        return parseAnyDigitsSigned(string);
                    },
                    set: function (_date, _flags, value, _options) {
                        return [new Date(value), {
                                timestampIsSet: true
                            }];
                    },
                    incompatibleTokens: '*'
                }
            };
            /* harmony default export */ __webpack_exports__["default"] = (parsers);
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/parse/index.js": 
        /*!**************************************************!*\
          !*** ./node_modules/date-fns/esm/parse/index.js ***!
          \**************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return parse; });
            /* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../locale/en-US/index.js */ "./node_modules/date-fns/esm/locale/en-US/index.js");
            /* harmony import */ var _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../subMilliseconds/index.js */ "./node_modules/date-fns/esm/subMilliseconds/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_assign_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_lib/assign/index.js */ "./node_modules/date-fns/esm/_lib/assign/index.js");
            /* harmony import */ var _lib_format_longFormatters_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../_lib/format/longFormatters/index.js */ "./node_modules/date-fns/esm/_lib/format/longFormatters/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            /* harmony import */ var _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../_lib/protectedTokens/index.js */ "./node_modules/date-fns/esm/_lib/protectedTokens/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _lib_parsers_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./_lib/parsers/index.js */ "./node_modules/date-fns/esm/parse/_lib/parsers/index.js");
            var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
            // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
            //   (one of the certain letters followed by `o`)
            // - (\w)\1* matches any sequences of the same letter
            // - '' matches two quote characters in a row
            // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
            //   except a single quote symbol, which ends the sequence.
            //   Two quote characters do not end the sequence.
            //   If there is no matching single quote
            //   then the sequence will continue until the end of the string.
            // - . matches any single character unmatched by previous parts of the RegExps
            var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
            // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
            var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            var escapedStringRegExp = /^'([^]*?)'?$/;
            var doubleQuoteRegExp = /''/g;
            var notWhitespaceRegExp = /\S/;
            var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
            /**
             * @name parse
             * @category Common Helpers
             * @summary Parse the date.
             *
             * @description
             * Return the date parsed from string using the given format string.
             *
             * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
             * > See: https://git.io/fxCyr
             *
             * The characters in the format string wrapped between two single quotes characters (') are escaped.
             * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
             *
             * Format of the format string is based on Unicode Technical Standard #35:
             * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
             * with a few additions (see note 5 below the table).
             *
             * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
             * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
             *
             * ```javascript
             * parse('23 AM', 'HH a', new Date())
             * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
             * ```
             *
             * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
             *
             * Accepted format string patterns:
             * | Unit                            |Prior| Pattern | Result examples                   | Notes |
             * |---------------------------------|-----|---------|-----------------------------------|-------|
             * | Era                             | 140 | G..GGG  | AD, BC                            |       |
             * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
             * |                                 |     | GGGGG   | A, B                              |       |
             * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
             * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
             * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
             * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
             * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
             * |                                 |     | yyyyy   | ...                               | 2,4   |
             * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
             * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
             * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
             * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
             * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
             * |                                 |     | YYYYY   | ...                               | 2,4   |
             * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
             * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
             * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
             * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
             * |                                 |     | RRRRR   | ...                               | 2,4,5 |
             * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
             * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
             * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
             * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
             * |                                 |     | uuuuu   | ...                               | 2,4   |
             * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
             * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
             * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
             * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
             * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
             * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
             * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
             * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
             * |                                 |     | qq      | 01, 02, 03, 04                    |       |
             * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
             * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
             * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
             * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
             * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
             * |                                 |     | MM      | 01, 02, ..., 12                   |       |
             * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
             * |                                 |     | MMMM    | January, February, ..., December  | 2     |
             * |                                 |     | MMMMM   | J, F, ..., D                      |       |
             * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
             * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
             * |                                 |     | LL      | 01, 02, ..., 12                   |       |
             * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
             * |                                 |     | LLLL    | January, February, ..., December  | 2     |
             * |                                 |     | LLLLL   | J, F, ..., D                      |       |
             * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
             * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
             * |                                 |     | ww      | 01, 02, ..., 53                   |       |
             * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
             * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
             * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
             * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
             * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
             * |                                 |     | dd      | 01, 02, ..., 31                   |       |
             * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
             * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
             * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
             * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
             * |                                 |     | DDDD    | ...                               | 2     |
             * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
             * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
             * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
             * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
             * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
             * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
             * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
             * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
             * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
             * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
             * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
             * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
             * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
             * |                                 |     | ee      | 02, 03, ..., 01                   |       |
             * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
             * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
             * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
             * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
             * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
             * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
             * |                                 |     | cc      | 02, 03, ..., 01                   |       |
             * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
             * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
             * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
             * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
             * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
             * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
             * |                                 |     | aaaaa   | a, p                              |       |
             * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
             * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
             * |                                 |     | bbbbb   | a, p, n, mi                       |       |
             * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
             * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
             * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
             * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
             * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
             * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
             * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
             * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
             * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
             * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
             * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
             * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
             * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
             * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
             * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
             * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
             * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
             * |                                 |     | mm      | 00, 01, ..., 59                   |       |
             * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
             * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
             * |                                 |     | ss      | 00, 01, ..., 59                   |       |
             * | Seconds timestamp               |  40 | t       | 512969520                         |       |
             * |                                 |     | tt      | ...                               | 2     |
             * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
             * |                                 |     | SS      | 00, 01, ..., 99                   |       |
             * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
             * |                                 |     | SSSS    | ...                               | 2     |
             * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
             * |                                 |     | TT      | ...                               | 2     |
             * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
             * |                                 |     | XX      | -0800, +0530, Z                   |       |
             * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
             * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
             * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
             * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
             * |                                 |     | xx      | -0800, +0530, +0000               |       |
             * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
             * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
             * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
             * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
             * |                                 |     | PP      | May 29, 1453                      |       |
             * |                                 |     | PPP     | May 29th, 1453                    |       |
             * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
             * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
             * |                                 |     | pp      | 12:00:00 AM                       |       |
             * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
             * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
             * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
             * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
             * Notes:
             * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
             *    are the same as "stand-alone" units, but are different in some languages.
             *    "Formatting" units are declined according to the rules of the language
             *    in the context of a date. "Stand-alone" units are always nominative singular.
             *    In `format` function, they will produce different result:
             *
             *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
             *
             *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
             *
             *    `parse` will try to match both formatting and stand-alone units interchangably.
             *
             * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
             *    the single quote characters (see below).
             *    If the sequence is longer than listed in table:
             *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
             *      as wide as the sequence
             *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
             *      These variations are marked with "2" in the last column of the table.
             *
             * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
             *    These tokens represent the shortest form of the quarter.
             *
             * 4. The main difference between `y` and `u` patterns are B.C. years:
             *
             *    | Year | `y` | `u` |
             *    |------|-----|-----|
             *    | AC 1 |   1 |   1 |
             *    | BC 1 |   1 |   0 |
             *    | BC 2 |   2 |  -1 |
             *
             *    Also `yy` will try to guess the century of two digit year by proximity with `backupDate`:
             *
             *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
             *
             *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
             *
             *    while `uu` will just assign the year as is:
             *
             *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
             *
             *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
             *
             *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
             *    except local week-numbering years are dependent on `options.weekStartsOn`
             *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
             *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
             *
             * 5. These patterns are not in the Unicode Technical Standard #35:
             *    - `i`: ISO day of week
             *    - `I`: ISO week of year
             *    - `R`: ISO week-numbering year
             *    - `o`: ordinal number modifier
             *    - `P`: long localized date
             *    - `p`: long localized time
             *
             * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
             *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
             *
             * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
             *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
             *
             * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
             *    on the given locale.
             *
             *    using `en-US` locale: `P` => `MM/dd/yyyy`
             *    using `en-US` locale: `p` => `hh:mm a`
             *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
             *    using `pt-BR` locale: `p` => `HH:mm`
             *
             * Values will be assigned to the date in the descending order of its unit's priority.
             * Units of an equal priority overwrite each other in the order of appearance.
             *
             * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
             * the values will be taken from 3rd argument `backupDate` which works as a context of parsing.
             *
             * `backupDate` must be passed for correct work of the function.
             * If you're not sure which `backupDate` to supply, create a new instance of Date:
             * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
             * In this case parsing will be done in the context of the current date.
             * If `backupDate` is `Invalid Date` or a value not convertible to valid `Date`,
             * then `Invalid Date` will be returned.
             *
             * The result may vary by locale.
             *
             * If `formatString` matches with `dateString` but does not provides tokens, `backupDate` will be returned.
             *
             * If parsing failed, `Invalid Date` will be returned.
             * Invalid Date is a Date, whose time value is NaN.
             * Time value of Date: http://es5.github.io/#x15.9.1.1
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - Old `parse` was renamed to `toDate`.
             *   Now `parse` is a new function which parses a string using a provided format.
             *
             *   ```javascript
             *   // Before v2.0.0
             *   parse('2016-01-01')
             *
             *   // v2.0.0 onward
             *   toDate('2016-01-01')
             *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
             *   ```
             *
             * @param {String} dateString - the string to parse
             * @param {String} formatString - the string of tokens
             * @param {Date|Number} backupDate - defines values missing from the parsed dateString
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
             * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
             *   see: https://git.io/fxCyr
             * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
             *   see: https://git.io/fxCyr
             * @returns {Date} the parsed date
             * @throws {TypeError} 3 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             * @throws {RangeError} `options.locale` must contain `match` property
             * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
             * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
             * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
             * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
             * @throws {RangeError} format string contains an unescaped latin alphabet character
             *
             * @example
             * // Parse 11 February 2014 from middle-endian format:
             * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
             * //=> Tue Feb 11 2014 00:00:00
             *
             * @example
             * // Parse 28th of February in Esperanto locale in the context of 2010 year:
             * import eo from 'date-fns/locale/eo'
             * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
             *   locale: eo
             * })
             * //=> Sun Feb 28 2010 00:00:00
             */
            function parse(dirtyDateString, dirtyFormatString, dirtyBackupDate, dirtyOptions) {
                if (arguments.length < 3) {
                    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
                }
                var dateString = String(dirtyDateString);
                var formatString = String(dirtyFormatString);
                var options = dirtyOptions || {};
                var locale = options.locale || _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_0__["default"];
                if (!locale.match) {
                    throw new RangeError('locale must contain match property');
                }
                var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_7__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_7__["default"])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
                if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
                    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                }
                var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_7__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_7__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                if (formatString === '') {
                    if (dateString === '') {
                        return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyBackupDate);
                    }
                    else {
                        return new Date(NaN);
                    }
                }
                var subFnOptions = {
                    firstWeekContainsDate: firstWeekContainsDate,
                    weekStartsOn: weekStartsOn,
                    locale: locale // If timezone isn't specified, it will be set to the system timezone
                };
                var setters = [{
                        priority: TIMEZONE_UNIT_PRIORITY,
                        set: dateToSystemTimezone,
                        index: 0
                    }];
                var i;
                var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
                    var firstCharacter = substring[0];
                    if (firstCharacter === 'p' || firstCharacter === 'P') {
                        var longFormatter = _lib_format_longFormatters_index_js__WEBPACK_IMPORTED_MODULE_4__["default"][firstCharacter];
                        return longFormatter(substring, locale.formatLong, subFnOptions);
                    }
                    return substring;
                }).join('').match(formattingTokensRegExp);
                var usedTokens = [];
                for (i = 0; i < tokens.length; i++) {
                    var token = tokens[i];
                    if (!options.useAdditionalWeekYearTokens && Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_6__["isProtectedWeekYearToken"])(token)) {
                        Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_6__["throwProtectedError"])(token);
                    }
                    if (!options.useAdditionalDayOfYearTokens && Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_6__["isProtectedDayOfYearToken"])(token)) {
                        Object(_lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_6__["throwProtectedError"])(token);
                    }
                    var firstCharacter = token[0];
                    var parser = _lib_parsers_index_js__WEBPACK_IMPORTED_MODULE_8__["default"][firstCharacter];
                    if (parser) {
                        var incompatibleTokens = parser.incompatibleTokens;
                        if (Array.isArray(incompatibleTokens)) {
                            var incompatibleToken = void 0;
                            for (var _i = 0; _i < usedTokens.length; _i++) {
                                var usedToken = usedTokens[_i].token;
                                if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                                    incompatibleToken = usedTokens[_i];
                                    break;
                                }
                            }
                            if (incompatibleToken) {
                                throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                            }
                        }
                        else if (parser.incompatibleTokens === '*' && usedTokens.length) {
                            throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                        }
                        usedTokens.push({
                            token: firstCharacter,
                            fullToken: token
                        });
                        var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
                        if (!parseResult) {
                            return new Date(NaN);
                        }
                        setters.push({
                            priority: parser.priority,
                            set: parser.set,
                            validate: parser.validate,
                            value: parseResult.value,
                            index: setters.length
                        });
                        dateString = parseResult.rest;
                    }
                    else {
                        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
                            throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                        } // Replace two single quote characters with one single quote character
                        if (token === "''") {
                            token = "'";
                        }
                        else if (firstCharacter === "'") {
                            token = cleanEscapedString(token);
                        } // Cut token from string, or, if string doesn't match the token, return Invalid Date
                        if (dateString.indexOf(token) === 0) {
                            dateString = dateString.slice(token.length);
                        }
                        else {
                            return new Date(NaN);
                        }
                    }
                } // Check if the remaining input contains something other than whitespace
                if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
                    return new Date(NaN);
                }
                var uniquePrioritySetters = setters.map(function (setter) {
                    return setter.priority;
                }).sort(function (a, b) {
                    return b - a;
                }).filter(function (priority, index, array) {
                    return array.indexOf(priority) === index;
                }).map(function (priority) {
                    return setters.filter(function (setter) {
                        return setter.priority === priority;
                    }).reverse();
                }).map(function (setterArray) {
                    return setterArray[0];
                });
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyBackupDate);
                if (isNaN(date)) {
                    return new Date(NaN);
                } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
                // This ensures that when UTC functions will be implemented, locales will be compatible with them.
                // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
                var utcDate = Object(_subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(date));
                var flags = {};
                for (i = 0; i < uniquePrioritySetters.length; i++) {
                    var setter = uniquePrioritySetters[i];
                    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
                        return new Date(NaN);
                    }
                    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
                    if (result[0]) {
                        utcDate = result[0];
                        Object(_lib_assign_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(flags, result[1]); // Result is date
                    }
                    else {
                        utcDate = result;
                    }
                }
                return utcDate;
            }
            function dateToSystemTimezone(date, flags) {
                if (flags.timestampIsSet) {
                    return date;
                }
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
            function cleanEscapedString(input) {
                return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/parseISO/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/parseISO/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return parseISO; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */ "./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
            var MILLISECONDS_IN_HOUR = 3600000;
            var MILLISECONDS_IN_MINUTE = 60000;
            var DEFAULT_ADDITIONAL_DIGITS = 2;
            var patterns = {
                dateTimeDelimiter: /[T ]/,
                timeZoneDelimiter: /[Z ]/i,
                timezone: /([Z+-].*)$/
            };
            var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
            var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
            var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
            /**
             * @name parseISO
             * @category Common Helpers
             * @summary Parse ISO string
             *
             * @description
             * Parse the given string in ISO 8601 format and return an instance of Date.
             *
             * Function accepts complete ISO 8601 formats as well as partial implementations.
             * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
             *
             * If the argument isn't a string, the function cannot parse the string or
             * the values are invalid, it returns Invalid Date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The previous `parse` implementation was renamed to `parseISO`.
             *
             *   ```javascript
             *   // Before v2.0.0
             *   parse('2016-01-01')
             *
             *   // v2.0.0 onward
             *   parseISO('2016-01-01')
             *   ```
             *
             * - `parseISO` now validates separate date and time values in ISO-8601 strings
             *   and returns `Invalid Date` if the date is invalid.
             *
             *   ```javascript
             *   parseISO('2018-13-32')
             *   //=> Invalid Date
             *   ```
             *
             * - `parseISO` now doesn't fall back to `new Date` constructor
             *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
             *
             * @param {String} argument - the value to convert
             * @param {Object} [options] - an object with options.
             * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
             * @returns {Date} the parsed date in the local time zone
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
             *
             * @example
             * // Convert string '2014-02-11T11:30:30' to date:
             * var result = parseISO('2014-02-11T11:30:30')
             * //=> Tue Feb 11 2014 11:30:30
             *
             * @example
             * // Convert string '+02014101' to date,
             * // if the additional number of digits in the extended year format is 1:
             * var result = parseISO('+02014101', { additionalDigits: 1 })
             * //=> Fri Apr 11 2014 00:00:00
             */
            function parseISO(argument, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(options.additionalDigits);
                if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
                    throw new RangeError('additionalDigits must be 0, 1 or 2');
                }
                if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
                    return new Date(NaN);
                }
                var dateStrings = splitDateString(argument);
                var date;
                if (dateStrings.date) {
                    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
                    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
                }
                if (isNaN(date) || !date) {
                    return new Date(NaN);
                }
                var timestamp = date.getTime();
                var time = 0;
                var offset;
                if (dateStrings.time) {
                    time = parseTime(dateStrings.time);
                    if (isNaN(time) || time === null) {
                        return new Date(NaN);
                    }
                }
                if (dateStrings.timezone) {
                    offset = parseTimezone(dateStrings.timezone);
                    if (isNaN(offset)) {
                        return new Date(NaN);
                    }
                }
                else {
                    var fullTime = timestamp + time;
                    var fullTimeDate = new Date(fullTime);
                    offset = Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fullTimeDate); // Adjust time when it's coming from DST
                    var fullTimeDateDiffDay = new Date(fullTime);
                    if (offset > 0) {
                        fullTimeDateDiffDay.setDate(fullTimeDate.getDate() + 1);
                    }
                    else {
                        fullTimeDateDiffDay.setDate(fullTimeDate.getDate() - 1);
                    }
                    var offsetDiff = Object(_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fullTimeDateDiffDay) - offset;
                    if (offsetDiff > 0) {
                        offset += offsetDiff;
                    }
                }
                return new Date(timestamp + time + offset);
            }
            function splitDateString(dateString) {
                var dateStrings = {};
                var array = dateString.split(patterns.dateTimeDelimiter);
                var timeString;
                if (/:/.test(array[0])) {
                    dateStrings.date = null;
                    timeString = array[0];
                }
                else {
                    dateStrings.date = array[0];
                    timeString = array[1];
                    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
                        dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
                        timeString = dateString.substr(dateStrings.date.length, dateString.length);
                    }
                }
                if (timeString) {
                    var token = patterns.timezone.exec(timeString);
                    if (token) {
                        dateStrings.time = timeString.replace(token[1], '');
                        dateStrings.timezone = token[1];
                    }
                    else {
                        dateStrings.time = timeString;
                    }
                }
                return dateStrings;
            }
            function parseYear(dateString, additionalDigits) {
                var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
                var captures = dateString.match(regex); // Invalid ISO-formatted year
                if (!captures)
                    return {
                        year: null
                    };
                var year = captures[1] && parseInt(captures[1]);
                var century = captures[2] && parseInt(captures[2]);
                return {
                    year: century == null ? year : century * 100,
                    restDateString: dateString.slice((captures[1] || captures[2]).length)
                };
            }
            function parseDate(dateString, year) {
                // Invalid ISO-formatted year
                if (year === null)
                    return null;
                var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
                if (!captures)
                    return null;
                var isWeekDate = !!captures[4];
                var dayOfYear = parseDateUnit(captures[1]);
                var month = parseDateUnit(captures[2]) - 1;
                var day = parseDateUnit(captures[3]);
                var week = parseDateUnit(captures[4]);
                var dayOfWeek = parseDateUnit(captures[5]) - 1;
                if (isWeekDate) {
                    if (!validateWeekDate(year, week, dayOfWeek)) {
                        return new Date(NaN);
                    }
                    return dayOfISOWeekYear(year, week, dayOfWeek);
                }
                else {
                    var date = new Date(0);
                    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
                        return new Date(NaN);
                    }
                    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
                    return date;
                }
            }
            function parseDateUnit(value) {
                return value ? parseInt(value) : 1;
            }
            function parseTime(timeString) {
                var captures = timeString.match(timeRegex);
                if (!captures)
                    return null; // Invalid ISO-formatted time
                var hours = parseTimeUnit(captures[1]);
                var minutes = parseTimeUnit(captures[2]);
                var seconds = parseTimeUnit(captures[3]);
                if (!validateTime(hours, minutes, seconds)) {
                    return NaN;
                }
                return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
            }
            function parseTimeUnit(value) {
                return value && parseFloat(value.replace(',', '.')) || 0;
            }
            function parseTimezone(timezoneString) {
                if (timezoneString === 'Z')
                    return 0;
                var captures = timezoneString.match(timezoneRegex);
                if (!captures)
                    return 0;
                var sign = captures[1] === '+' ? -1 : 1;
                var hours = parseInt(captures[2]);
                var minutes = captures[3] && parseInt(captures[3]) || 0;
                if (!validateTimezone(hours, minutes)) {
                    return NaN;
                }
                return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
            }
            function dayOfISOWeekYear(isoWeekYear, week, day) {
                var date = new Date(0);
                date.setUTCFullYear(isoWeekYear, 0, 4);
                var fourthOfJanuaryDay = date.getUTCDay() || 7;
                var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
                date.setUTCDate(date.getUTCDate() + diff);
                return date;
            } // Validation functions
            // February is null to handle the leap year (using ||)
            var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            function isLeapYearIndex(year) {
                return year % 400 === 0 || year % 4 === 0 && year % 100;
            }
            function validateDate(year, month, date) {
                return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
            }
            function validateDayOfYearDate(year, dayOfYear) {
                return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
            }
            function validateWeekDate(_year, week, day) {
                return week >= 1 && week <= 53 && day >= 0 && day <= 6;
            }
            function validateTime(hours, minutes, seconds) {
                if (hours === 24) {
                    return minutes === 0 && seconds === 0;
                }
                return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
            }
            function validateTimezone(_hours, minutes) {
                return minutes >= 0 && minutes <= 59;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/parseJSON/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/parseJSON/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return parseJSON; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name parseJSON
             * @category Common Helpers
             * @summary Parse a JSON date string
             *
             * @description
             * Converts a complete ISO date string in UTC time, the typical format for transmitting
             * a date in JSON, to a JavaScript `Date` instance.
             *
             * This is a minimal implementation for converting dates retrieved from a JSON API to
             * a `Date` instance which can be used with other functions in the `date-fns` library.
             * The following formats are supported:
             *
             *     - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
             *     - `2000-03-15T05:20:10Z`: Without milliseconds
             *     - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
             *     - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
             *
             * For convenience and ease of use these other input types are also supported
             * via [toDate]{@link https://date-fns.org/docs/toDate}:
             *
             *     - A `Date` instance will be cloned
             *     - A `number` will be treated as a timestamp
             *
             * Any other input type or invalid date strings will return an `Invalid Date`.
             *
             * @param {String|Number|Date} argument A fully formed ISO1806 date string to convert
             * @returns {Date} the parsed date in the local time zone
             * @throws {TypeError} 1 argument required
             */
            function parseJSON(argument) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                if (typeof argument === 'string') {
                    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?(?:Z|\+00:?00)/);
                    if (parts) {
                        return new Date(Date.UTC(+parts[1], parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +(parts[7] || 0)));
                    }
                }
                return Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(argument);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/roundToNearestMinutes/index.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/date-fns/esm/roundToNearestMinutes/index.js ***!
          \******************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return roundToNearestMinutes; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name roundToNearestMinutes
             * @category Minute Helpers
             * @summary Rounds the given date to the nearest minute
             *
             * @description
             * Rounds the given date to the nearest minute
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to round
             * @param {Object} [options] - an object with options.
             * @param {Number} [options.nearestTo=1] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
             * @returns {Date} the new date rounded to the closest minute
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.nearestTo` must be between 1 and 30
             *
             * @example
             * // Round 10 July 2014 12:12:34 to nearest minute:
             * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
             * //=> Thu Jul 10 2014 12:13:00
             */
            function roundToNearestMinutes(dirtyDate, options) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only none provided present');
                }
                var nearestTo = options && 'nearestTo' in options ? Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(options.nearestTo) : 1;
                if (nearestTo < 1 || nearestTo > 30) {
                    throw new RangeError('`options.nearestTo` must be between 1 and 30');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
                var minutes = date.getMinutes() + seconds / 60;
                var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
                var remainderMinutes = minutes % nearestTo;
                var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
                return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/set/index.js": 
        /*!************************************************!*\
          !*** ./node_modules/date-fns/esm/set/index.js ***!
          \************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return set; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../setMonth/index.js */ "./node_modules/date-fns/esm/setMonth/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name set
             * @category Common Helpers
             * @summary Set date values to a given date.
             *
             * @description
             * Set date values to a given date.
             *
             * Sets time values to date from object `values`.
             * A value is not set if it is undefined or null or doesn't exist in `values`.
             *
             * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
             * to use native `Date#setX` methods. If you use this function, you may not want to include the
             * other `setX` functions that date-fns provides if you are concerned about the bundle size.
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Object} values - an object with options
             * @param {Number} [values.year] - the number of years to be set
             * @param {Number} [values.month] - the number of months to be set
             * @param {Number} [values.date] - the number of days to be set
             * @param {Number} [values.hours] - the number of hours to be set
             * @param {Number} [values.minutes] - the number of minutes to be set
             * @param {Number} [values.seconds] - the number of seconds to be set
             * @param {Number} [values.milliseconds] - the number of milliseconds to be set
             * @returns {Date} the new date with options set
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `values` must be an object
             *
             * @example
             * // Transform 1 September 2014 into 20 October 2015 in a single line:
             * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
             * //=> Tue Oct 20 2015 00:00:00
             *
             * @example
             * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
             * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
             * //=> Mon Sep 01 2014 12:23:45
             */
            function set(dirtyDate, values) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                if (typeof values !== 'object' || values === null) {
                    throw new RangeError('values parameter must be an object');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
                if (isNaN(date)) {
                    return new Date(NaN);
                }
                if (values.year != null) {
                    date.setFullYear(values.year);
                }
                if (values.month != null) {
                    date = Object(_setMonth_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, values.month);
                }
                if (values.date != null) {
                    date.setDate(Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(values.date));
                }
                if (values.hours != null) {
                    date.setHours(Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(values.hours));
                }
                if (values.minutes != null) {
                    date.setMinutes(Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(values.minutes));
                }
                if (values.seconds != null) {
                    date.setSeconds(Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(values.seconds));
                }
                if (values.milliseconds != null) {
                    date.setMilliseconds(Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(values.milliseconds));
                }
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setDate/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/setDate/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setDate; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setDate
             * @category Day Helpers
             * @summary Set the day of the month to the given date.
             *
             * @description
             * Set the day of the month to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} dayOfMonth - the day of the month of the new date
             * @returns {Date} the new date with the day of the month set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set the 30th day of the month to 1 September 2014:
             * var result = setDate(new Date(2014, 8, 1), 30)
             * //=> Tue Sep 30 2014 00:00:00
             */
            function setDate(dirtyDate, dirtyDayOfMonth) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var dayOfMonth = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDayOfMonth);
                date.setDate(dayOfMonth);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setDay/index.js": 
        /*!***************************************************!*\
          !*** ./node_modules/date-fns/esm/setDay/index.js ***!
          \***************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setDay; });
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name setDay
             * @category Weekday Helpers
             * @summary Set the day of the week to the given date.
             *
             * @description
             * Set the day of the week to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} day - the day of the week of the new date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the new date with the day of the week set
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // Set Sunday to 1 September 2014:
             * var result = setDay(new Date(2014, 8, 1), 0)
             * //=> Sun Aug 31 2014 00:00:00
             *
             * @example
             * // If week starts with Monday, set Sunday to 1 September 2014:
             * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
             * //=> Sun Sep 07 2014 00:00:00
             */
            function setDay(dirtyDate, dirtyDay, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, options);
                var day = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDay);
                var currentDay = date.getDay();
                var remainder = day % 7;
                var dayIndex = (remainder + 7) % 7;
                var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
                return Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date, diff, options);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setDayOfYear/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/setDayOfYear/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setDayOfYear; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setDayOfYear
             * @category Day Helpers
             * @summary Set the day of the year to the given date.
             *
             * @description
             * Set the day of the year to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} dayOfYear - the day of the year of the new date
             * @returns {Date} the new date with the day of the year set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set the 2nd day of the year to 2 July 2014:
             * var result = setDayOfYear(new Date(2014, 6, 2), 2)
             * //=> Thu Jan 02 2014 00:00:00
             */
            function setDayOfYear(dirtyDate, dirtyDayOfYear) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var dayOfYear = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDayOfYear);
                date.setMonth(0);
                date.setDate(dayOfYear);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setHours/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/setHours/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setHours; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setHours
             * @category Hour Helpers
             * @summary Set the hours to the given date.
             *
             * @description
             * Set the hours to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} hours - the hours of the new date
             * @returns {Date} the new date with the hours set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set 4 hours to 1 September 2014 11:30:00:
             * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
             * //=> Mon Sep 01 2014 04:30:00
             */
            function setHours(dirtyDate, dirtyHours) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var hours = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyHours);
                date.setHours(hours);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setISODay/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/setISODay/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setISODay; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /* harmony import */ var _getISODay_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../getISODay/index.js */ "./node_modules/date-fns/esm/getISODay/index.js");
            /**
             * @name setISODay
             * @category Weekday Helpers
             * @summary Set the day of the ISO week to the given date.
             *
             * @description
             * Set the day of the ISO week to the given date.
             * ISO week starts with Monday.
             * 7 is the index of Sunday, 1 is the index of Monday etc.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} day - the day of the ISO week of the new date
             * @returns {Date} the new date with the day of the ISO week set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set Sunday to 1 September 2014:
             * var result = setISODay(new Date(2014, 8, 1), 7)
             * //=> Sun Sep 07 2014 00:00:00
             */
            function setISODay(dirtyDate, dirtyDay) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var day = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDay);
                var currentDay = Object(_getISODay_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date);
                var diff = day - currentDay;
                return Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date, diff);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setISOWeek/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/setISOWeek/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setISOWeek; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _getISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../getISOWeek/index.js */ "./node_modules/date-fns/esm/getISOWeek/index.js");
            /**
             * @name setISOWeek
             * @category ISO Week Helpers
             * @summary Set the ISO week to the given date.
             *
             * @description
             * Set the ISO week to the given date, saving the weekday number.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} isoWeek - the ISO week of the new date
             * @returns {Date} the new date with the ISO week set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set the 53rd ISO week to 7 August 2004:
             * var result = setISOWeek(new Date(2004, 7, 7), 53)
             * //=> Sat Jan 01 2005 00:00:00
             */
            function setISOWeek(dirtyDate, dirtyISOWeek) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var isoWeek = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyISOWeek);
                var diff = Object(_getISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date) - isoWeek;
                date.setDate(date.getDate() - diff * 7);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setISOWeekYear/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/setISOWeekYear/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setISOWeekYear; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfISOWeekYear/index.js */ "./node_modules/date-fns/esm/startOfISOWeekYear/index.js");
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /**
             * @name setISOWeekYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Set the ISO week-numbering year to the given date.
             *
             * @description
             * Set the ISO week-numbering year to the given date,
             * saving the week number and the weekday number.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `setISOYear` to `setISOWeekYear`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
             * @returns {Date} the new date with the ISO week-numbering year set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set ISO week-numbering year 2007 to 29 December 2008:
             * var result = setISOWeekYear(new Date(2008, 11, 29), 2007)
             * //=> Mon Jan 01 2007 00:00:00
             */
            function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var isoWeekYear = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyISOWeekYear);
                var diff = Object(_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date));
                var fourthOfJanuary = new Date(0);
                fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
                fourthOfJanuary.setHours(0, 0, 0, 0);
                date = Object(_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(fourthOfJanuary);
                date.setDate(date.getDate() + diff);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setMilliseconds/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/setMilliseconds/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setMilliseconds; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setMilliseconds
             * @category Millisecond Helpers
             * @summary Set the milliseconds to the given date.
             *
             * @description
             * Set the milliseconds to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} milliseconds - the milliseconds of the new date
             * @returns {Date} the new date with the milliseconds set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
             * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
             * //=> Mon Sep 01 2014 11:30:40.300
             */
            function setMilliseconds(dirtyDate, dirtyMilliseconds) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var milliseconds = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyMilliseconds);
                date.setMilliseconds(milliseconds);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setMinutes/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/setMinutes/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setMinutes; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setMinutes
             * @category Minute Helpers
             * @summary Set the minutes to the given date.
             *
             * @description
             * Set the minutes to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} minutes - the minutes of the new date
             * @returns {Date} the new date with the minutes set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set 45 minutes to 1 September 2014 11:30:40:
             * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
             * //=> Mon Sep 01 2014 11:45:40
             */
            function setMinutes(dirtyDate, dirtyMinutes) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var minutes = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyMinutes);
                date.setMinutes(minutes);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setMonth/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/setMonth/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setMonth; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../getDaysInMonth/index.js */ "./node_modules/date-fns/esm/getDaysInMonth/index.js");
            /**
             * @name setMonth
             * @category Month Helpers
             * @summary Set the month to the given date.
             *
             * @description
             * Set the month to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} month - the month of the new date
             * @returns {Date} the new date with the month set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set February to 1 September 2014:
             * var result = setMonth(new Date(2014, 8, 1), 1)
             * //=> Sat Feb 01 2014 00:00:00
             */
            function setMonth(dirtyDate, dirtyMonth) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var month = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyMonth);
                var year = date.getFullYear();
                var day = date.getDate();
                var dateWithDesiredMonth = new Date(0);
                dateWithDesiredMonth.setFullYear(year, month, 15);
                dateWithDesiredMonth.setHours(0, 0, 0, 0);
                var daysInMonth = Object(_getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dateWithDesiredMonth); // Set the last day of the new month
                // if the original date was the last day of the longer month
                date.setMonth(month, Math.min(day, daysInMonth));
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setQuarter/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/setQuarter/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setQuarter; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../setMonth/index.js */ "./node_modules/date-fns/esm/setMonth/index.js");
            /**
             * @name setQuarter
             * @category Quarter Helpers
             * @summary Set the year quarter to the given date.
             *
             * @description
             * Set the year quarter to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} quarter - the quarter of the new date
             * @returns {Date} the new date with the quarter set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set the 2nd quarter to 2 July 2014:
             * var result = setQuarter(new Date(2014, 6, 2), 2)
             * //=> Wed Apr 02 2014 00:00:00
             */
            function setQuarter(dirtyDate, dirtyQuarter) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var quarter = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyQuarter);
                var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
                var diff = quarter - oldQuarter;
                return Object(_setMonth_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(date, date.getMonth() + diff * 3);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setSeconds/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/setSeconds/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setSeconds; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setSeconds
             * @category Second Helpers
             * @summary Set the seconds to the given date.
             *
             * @description
             * Set the seconds to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} seconds - the seconds of the new date
             * @returns {Date} the new date with the seconds set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set 45 seconds to 1 September 2014 11:30:40:
             * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
             * //=> Mon Sep 01 2014 11:30:45
             */
            function setSeconds(dirtyDate, dirtySeconds) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var seconds = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtySeconds);
                date.setSeconds(seconds);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setWeek/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/setWeek/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setWeek; });
            /* harmony import */ var _getWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getWeek/index.js */ "./node_modules/date-fns/esm/getWeek/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name setWeek
             * @category Week Helpers
             * @summary Set the local week to the given date.
             *
             * @description
             * Set the local week to the given date, saving the weekday number.
             * The exact calculation depends on the values of
             * `options.weekStartsOn` (which is the index of the first day of the week)
             * and `options.firstWeekContainsDate` (which is the day of January, which is always in
             * the first week of the week-numbering year)
             *
             * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} week - the week of the new date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
             * @returns {Date} the new date with the local week set
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             *
             * @example
             * // Set the 1st week to 2 January 2005 with default options:
             * var result = setWeek(new Date(2005, 0, 2), 1)
             * //=> Sun Dec 26 2004 00:00:00
             *
             * @example
             * // Set the 1st week to 2 January 2005,
             * // if Monday is the first day of the week,
             * // and the first week of the year always contains 4 January:
             * var result = setWeek(new Date(2005, 0, 2), 1, {
             *   weekStartsOn: 1,
             *   firstWeekContainsDate: 4
             * })
             * //=> Sun Jan 4 2004 00:00:00
             */
            function setWeek(dirtyDate, dirtyWeek, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var week = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyWeek);
                var diff = Object(_getWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date, dirtyOptions) - week;
                date.setDate(date.getDate() - diff * 7);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setWeekYear/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/setWeekYear/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setWeekYear; });
            /* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../differenceInCalendarDays/index.js */ "./node_modules/date-fns/esm/differenceInCalendarDays/index.js");
            /* harmony import */ var _startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfWeekYear/index.js */ "./node_modules/date-fns/esm/startOfWeekYear/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name setWeekYear
             * @category Week-Numbering Year Helpers
             * @summary Set the local week-numbering year to the given date.
             *
             * @description
             * Set the local week-numbering year to the given date,
             * saving the week number and the weekday number.
             * The exact calculation depends on the values of
             * `options.weekStartsOn` (which is the index of the first day of the week)
             * and `options.firstWeekContainsDate` (which is the day of January, which is always in
             * the first week of the week-numbering year)
             *
             * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} weekYear - the local week-numbering year of the new date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
             * @returns {Date} the new date with the local week-numbering year set
             * @throws {TypeError} 2 arguments required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             *
             * @example
             * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
             * var result = setWeekYear(new Date(2010, 0, 2), 2004)
             * //=> Sat Jan 03 2004 00:00:00
             *
             * @example
             * // Set the local week-numbering year 2004 to 2 January 2010,
             * // if Monday is the first day of week
             * // and 4 January is always in the first week of the year:
             * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
             *   weekStartsOn: 1,
             *   firstWeekContainsDate: 4
             * })
             * //=> Sat Jan 01 2005 00:00:00
             */
            function setWeekYear(dirtyDate, dirtyWeekYear, dirtyOptions) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(options.firstWeekContainsDate);
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
                var weekYear = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyWeekYear);
                var diff = Object(_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(date, Object(_startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(date, dirtyOptions));
                var firstWeek = new Date(0);
                firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
                firstWeek.setHours(0, 0, 0, 0);
                date = Object(_startOfWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(firstWeek, dirtyOptions);
                date.setDate(date.getDate() + diff);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/setYear/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/setYear/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return setYear; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name setYear
             * @category Year Helpers
             * @summary Set the year to the given date.
             *
             * @description
             * Set the year to the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} year - the year of the new date
             * @returns {Date} the new date with the year set
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Set year 2013 to 1 September 2014:
             * var result = setYear(new Date(2014, 8, 1), 2013)
             * //=> Sun Sep 01 2013 00:00:00
             */
            function setYear(dirtyDate, dirtyYear) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
                var year = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
                if (isNaN(date)) {
                    return new Date(NaN);
                }
                date.setFullYear(year);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfDay/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfDay/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfDay; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfDay
             * @category Day Helpers
             * @summary Return the start of a day for the given date.
             *
             * @description
             * Return the start of a day for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a day
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a day for 2 September 2014 11:55:00:
             * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 00:00:00
             */
            function startOfDay(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfDecade/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfDecade/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfDecade; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfDecade
             * @category Decade Helpers
             * @summary Return the start of a decade for the given date.
             *
             * @description
             * Return the start of a decade for the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a decade
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a decade for 21 October 2015 00:00:00:
             * var result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
             * //=> Jan 01 2010 00:00:00
             */
            function startOfDecade(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var year = date.getFullYear();
                var decade = Math.floor(year / 10) * 10;
                date.setFullYear(decade, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfHour/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfHour/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfHour; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfHour
             * @category Hour Helpers
             * @summary Return the start of an hour for the given date.
             *
             * @description
             * Return the start of an hour for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of an hour
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of an hour for 2 September 2014 11:55:00:
             * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
             * //=> Tue Sep 02 2014 11:00:00
             */
            function startOfHour(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setMinutes(0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfISOWeek/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfISOWeek/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfISOWeek; });
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /**
             * @name startOfISOWeek
             * @category ISO Week Helpers
             * @summary Return the start of an ISO week for the given date.
             *
             * @description
             * Return the start of an ISO week for the given date.
             * The result will be in the local timezone.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of an ISO week
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of an ISO week for 2 September 2014 11:55:00:
             * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfISOWeek(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                return Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, {
                    weekStartsOn: 1
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfISOWeekYear/index.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfISOWeekYear/index.js ***!
          \***************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfISOWeekYear; });
            /* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getISOWeekYear/index.js */ "./node_modules/date-fns/esm/getISOWeekYear/index.js");
            /* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfISOWeek/index.js */ "./node_modules/date-fns/esm/startOfISOWeek/index.js");
            /**
             * @name startOfISOWeekYear
             * @category ISO Week-Numbering Year Helpers
             * @summary Return the start of an ISO week-numbering year for the given date.
             *
             * @description
             * Return the start of an ISO week-numbering year,
             * which always starts 3 days before the year's first Thursday.
             * The result will be in the local timezone.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of an ISO week-numbering year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of an ISO week-numbering year for 2 July 2005:
             * var result = startOfISOWeekYear(new Date(2005, 6, 2))
             * //=> Mon Jan 03 2005 00:00:00
             */
            function startOfISOWeekYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var year = Object(_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var fourthOfJanuary = new Date(0);
                fourthOfJanuary.setFullYear(year, 0, 4);
                fourthOfJanuary.setHours(0, 0, 0, 0);
                var date = Object(_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(fourthOfJanuary);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfMinute/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfMinute/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfMinute; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfMinute
             * @category Minute Helpers
             * @summary Return the start of a minute for the given date.
             *
             * @description
             * Return the start of a minute for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a minute
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a minute for 1 December 2014 22:15:45.400:
             * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:00
             */
            function startOfMinute(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setSeconds(0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfMonth/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfMonth/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfMonth; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfMonth
             * @category Month Helpers
             * @summary Return the start of a month for the given date.
             *
             * @description
             * Return the start of a month for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a month
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a month for 2 September 2014 11:55:00:
             * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfMonth(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setDate(1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfQuarter/index.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfQuarter/index.js ***!
          \***********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfQuarter; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfQuarter
             * @category Quarter Helpers
             * @summary Return the start of a year quarter for the given date.
             *
             * @description
             * Return the start of a year quarter for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a quarter
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a quarter for 2 September 2014 11:55:00:
             * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Jul 01 2014 00:00:00
             */
            function startOfQuarter(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var currentMonth = date.getMonth();
                var month = currentMonth - currentMonth % 3;
                date.setMonth(month, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfSecond/index.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfSecond/index.js ***!
          \**********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfSecond; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfSecond
             * @category Second Helpers
             * @summary Return the start of a second for the given date.
             *
             * @description
             * Return the start of a second for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a second
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a second for 1 December 2014 22:15:45.400:
             * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:45.000
             */
            function startOfSecond(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                date.setMilliseconds(0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfToday/index.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfToday/index.js ***!
          \*********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfToday; });
            /* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../startOfDay/index.js */ "./node_modules/date-fns/esm/startOfDay/index.js");
            /**
             * @name startOfToday
             * @category Day Helpers
             * @summary Return the start of today.
             * @pure false
             *
             * @description
             * Return the start of today.
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @returns {Date} the start of today
             *
             * @example
             * // If today is 6 October 2014:
             * var result = startOfToday()
             * //=> Mon Oct 6 2014 00:00:00
             */
            function startOfToday() {
                return Object(_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(Date.now());
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfTomorrow/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfTomorrow/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfTomorrow; });
            /**
             * @name startOfTomorrow
             * @category Day Helpers
             * @summary Return the start of tomorrow.
             * @pure false
             *
             * @description
             * Return the start of tomorrow.
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @returns {Date} the start of tomorrow
             *
             * @example
             * // If today is 6 October 2014:
             * var result = startOfTomorrow()
             * //=> Tue Oct 7 2014 00:00:00
             */
            function startOfTomorrow() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var day = now.getDate();
                var date = new Date(0);
                date.setFullYear(year, month, day + 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfWeek/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfWeek/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfWeek; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name startOfWeek
             * @category Week Helpers
             * @summary Return the start of a week for the given date.
             *
             * @description
             * Return the start of a week for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the start of a week
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             *
             * @example
             * // The start of a week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sun Aug 31 2014 00:00:00
             *
             * @example
             * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfWeek(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
                var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(localeWeekStartsOn);
                var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
                if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
                    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                }
                var date = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var day = date.getDay();
                var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
                date.setDate(date.getDate() - diff);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfWeekYear/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfWeekYear/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfWeekYear; });
            /* harmony import */ var _getWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../getWeekYear/index.js */ "./node_modules/date-fns/esm/getWeekYear/index.js");
            /* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../startOfWeek/index.js */ "./node_modules/date-fns/esm/startOfWeek/index.js");
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /**
             * @name startOfWeekYear
             * @category Week-Numbering Year Helpers
             * @summary Return the start of a local week-numbering year for the given date.
             *
             * @description
             * Return the start of a local week-numbering year.
             * The exact calculation depends on the values of
             * `options.weekStartsOn` (which is the index of the first day of the week)
             * and `options.firstWeekContainsDate` (which is the day of January, which is always in
             * the first week of the week-numbering year)
             *
             * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @param {Object} [options] - an object with options.
             * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
             * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
             * @returns {Date} the start of a week-numbering year
             * @throws {TypeError} 1 argument required
             * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
             * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
             *
             * @example
             * // The start of an a week-numbering year for 2 July 2005 with default settings:
             * var result = startOfWeekYear(new Date(2005, 6, 2))
             * //=> Sun Dec 26 2004 00:00:00
             *
             * @example
             * // The start of a week-numbering year for 2 July 2005
             * // if Monday is the first day of week
             * // and 4 January is always in the first week of the year:
             * var result = startOfWeekYear(new Date(2005, 6, 2), {
             *   weekStartsOn: 1,
             *   firstWeekContainsDate: 4
             * })
             * //=> Mon Jan 03 2005 00:00:00
             */
            function startOfWeekYear(dirtyDate, dirtyOptions) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var options = dirtyOptions || {};
                var locale = options.locale;
                var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
                var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(localeFirstWeekContainsDate);
                var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(options.firstWeekContainsDate);
                var year = Object(_getWeekYear_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate, dirtyOptions);
                var firstWeek = new Date(0);
                firstWeek.setFullYear(year, 0, firstWeekContainsDate);
                firstWeek.setHours(0, 0, 0, 0);
                var date = Object(_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(firstWeek, dirtyOptions);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfYear/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfYear/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfYear; });
            /* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../toDate/index.js */ "./node_modules/date-fns/esm/toDate/index.js");
            /**
             * @name startOfYear
             * @category Year Helpers
             * @summary Return the start of a year for the given date.
             *
             * @description
             * Return the start of a year for the given date.
             * The result will be in the local timezone.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the original date
             * @returns {Date} the start of a year
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // The start of a year for 2 September 2014 11:55:00:
             * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
             * //=> Wed Jan 01 2014 00:00:00
             */
            function startOfYear(dirtyDate) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var cleanDate = Object(_toDate_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyDate);
                var date = new Date(0);
                date.setFullYear(cleanDate.getFullYear(), 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/startOfYesterday/index.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/date-fns/esm/startOfYesterday/index.js ***!
          \*************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return startOfYesterday; });
            /**
             * @name startOfYesterday
             * @category Day Helpers
             * @summary Return the start of yesterday.
             * @pure false
             *
             * @description
             * Return the start of yesterday.
             *
             * > ⚠️ Please note that this function is not present in the FP submodule as
             * > it uses `Date.now()` internally hence impure and can't be safely curried.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @returns {Date} the start of yesterday
             *
             * @example
             * // If today is 6 October 2014:
             * var result = startOfYesterday()
             * //=> Sun Oct 5 2014 00:00:00
             */
            function startOfYesterday() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var day = now.getDate();
                var date = new Date(0);
                date.setFullYear(year, month, day - 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subBusinessDays/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/subBusinessDays/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subBusinessDays; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addBusinessDays/index.js */ "./node_modules/date-fns/esm/addBusinessDays/index.js");
            /**
             * @name subBusinessDays
             * @category Day Helpers
             * @summary Substract the specified number of business days (mon - fri) to the given date.
             *
             * @description
             * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of business days to be subtracted
             * @returns {Date} the new date with the business days subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Substract 10 business days from 1 September 2014:
             * var result = subBusinessDays(new Date(2014, 8, 1), 10)
             * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
             */
            function subBusinessDays(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addBusinessDays_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subDays/index.js": 
        /*!****************************************************!*\
          !*** ./node_modules/date-fns/esm/subDays/index.js ***!
          \****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subDays; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addDays/index.js */ "./node_modules/date-fns/esm/addDays/index.js");
            /**
             * @name subDays
             * @category Day Helpers
             * @summary Subtract the specified number of days from the given date.
             *
             * @description
             * Subtract the specified number of days from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of days to be subtracted
             * @returns {Date} the new date with the days subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 10 days from 1 September 2014:
             * var result = subDays(new Date(2014, 8, 1), 10)
             * //=> Fri Aug 22 2014 00:00:00
             */
            function subDays(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addDays_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subHours/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/subHours/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subHours; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addHours_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addHours/index.js */ "./node_modules/date-fns/esm/addHours/index.js");
            /**
             * @name subHours
             * @category Hour Helpers
             * @summary Subtract the specified number of hours from the given date.
             *
             * @description
             * Subtract the specified number of hours from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of hours to be subtracted
             * @returns {Date} the new date with the hours subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 2 hours from 11 July 2014 01:00:00:
             * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
             * //=> Thu Jul 10 2014 23:00:00
             */
            function subHours(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addHours_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subISOWeekYears/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/subISOWeekYears/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subISOWeekYears; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addISOWeekYears/index.js */ "./node_modules/date-fns/esm/addISOWeekYears/index.js");
            /**
             * @name subISOWeekYears
             * @category ISO Week-Numbering Year Helpers
             * @summary Subtract the specified number of ISO week-numbering years from the given date.
             *
             * @description
             * Subtract the specified number of ISO week-numbering years from the given date.
             *
             * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * - The function was renamed from `subISOYears` to `subISOWeekYears`.
             *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
             *   This change makes the name consistent with
             *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
             * @returns {Date} the new date with the ISO week-numbering years subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 5 ISO week-numbering years from 1 September 2014:
             * var result = subISOWeekYears(new Date(2014, 8, 1), 5)
             * //=> Mon Aug 31 2009 00:00:00
             */
            function subISOWeekYears(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addISOWeekYears_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subMilliseconds/index.js": 
        /*!************************************************************!*\
          !*** ./node_modules/date-fns/esm/subMilliseconds/index.js ***!
          \************************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subMilliseconds; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMilliseconds/index.js */ "./node_modules/date-fns/esm/addMilliseconds/index.js");
            /**
             * @name subMilliseconds
             * @category Millisecond Helpers
             * @summary Subtract the specified number of milliseconds from the given date.
             *
             * @description
             * Subtract the specified number of milliseconds from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of milliseconds to be subtracted
             * @returns {Date} the new date with the milliseconds subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
             * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
             * //=> Thu Jul 10 2014 12:45:29.250
             */
            function subMilliseconds(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subMinutes/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/subMinutes/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subMinutes; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMinutes_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMinutes/index.js */ "./node_modules/date-fns/esm/addMinutes/index.js");
            /**
             * @name subMinutes
             * @category Minute Helpers
             * @summary Subtract the specified number of minutes from the given date.
             *
             * @description
             * Subtract the specified number of minutes from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of minutes to be subtracted
             * @returns {Date} the new date with the minutes subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 30 minutes from 10 July 2014 12:00:00:
             * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
             * //=> Thu Jul 10 2014 11:30:00
             */
            function subMinutes(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMinutes_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subMonths/index.js": 
        /*!******************************************************!*\
          !*** ./node_modules/date-fns/esm/subMonths/index.js ***!
          \******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subMonths; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addMonths/index.js */ "./node_modules/date-fns/esm/addMonths/index.js");
            /**
             * @name subMonths
             * @category Month Helpers
             * @summary Subtract the specified number of months from the given date.
             *
             * @description
             * Subtract the specified number of months from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of months to be subtracted
             * @returns {Date} the new date with the months subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 5 months from 1 February 2015:
             * var result = subMonths(new Date(2015, 1, 1), 5)
             * //=> Mon Sep 01 2014 00:00:00
             */
            function subMonths(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addMonths_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subQuarters/index.js": 
        /*!********************************************************!*\
          !*** ./node_modules/date-fns/esm/subQuarters/index.js ***!
          \********************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subQuarters; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addQuarters_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addQuarters/index.js */ "./node_modules/date-fns/esm/addQuarters/index.js");
            /**
             * @name subQuarters
             * @category Quarter Helpers
             * @summary Subtract the specified number of year quarters from the given date.
             *
             * @description
             * Subtract the specified number of year quarters from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of quarters to be subtracted
             * @returns {Date} the new date with the quarters subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 3 quarters from 1 September 2014:
             * var result = subQuarters(new Date(2014, 8, 1), 3)
             * //=> Sun Dec 01 2013 00:00:00
             */
            function subQuarters(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addQuarters_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subSeconds/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/date-fns/esm/subSeconds/index.js ***!
          \*******************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subSeconds; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addSeconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addSeconds/index.js */ "./node_modules/date-fns/esm/addSeconds/index.js");
            /**
             * @name subSeconds
             * @category Second Helpers
             * @summary Subtract the specified number of seconds from the given date.
             *
             * @description
             * Subtract the specified number of seconds from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of seconds to be subtracted
             * @returns {Date} the new date with the seconds subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 30 seconds from 10 July 2014 12:45:00:
             * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
             * //=> Thu Jul 10 2014 12:44:30
             */
            function subSeconds(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addSeconds_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subWeeks/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/subWeeks/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subWeeks; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addWeeks/index.js */ "./node_modules/date-fns/esm/addWeeks/index.js");
            /**
             * @name subWeeks
             * @category Week Helpers
             * @summary Subtract the specified number of weeks from the given date.
             *
             * @description
             * Subtract the specified number of weeks from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of weeks to be subtracted
             * @returns {Date} the new date with the weeks subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 4 weeks from 1 September 2014:
             * var result = subWeeks(new Date(2014, 8, 1), 4)
             * //=> Mon Aug 04 2014 00:00:00
             */
            function subWeeks(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/subYears/index.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/date-fns/esm/subYears/index.js ***!
          \*****************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return subYears; });
            /* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/toInteger/index.js */ "./node_modules/date-fns/esm/_lib/toInteger/index.js");
            /* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../addYears/index.js */ "./node_modules/date-fns/esm/addYears/index.js");
            /**
             * @name subYears
             * @category Year Helpers
             * @summary Subtract the specified number of years from the given date.
             *
             * @description
             * Subtract the specified number of years from the given date.
             *
             * ### v2.0.0 breaking changes:
             *
             * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
             *
             * @param {Date|Number} date - the date to be changed
             * @param {Number} amount - the amount of years to be subtracted
             * @returns {Date} the new date with the years subtracted
             * @throws {TypeError} 2 arguments required
             *
             * @example
             * // Subtract 5 years from 1 September 2014:
             * var result = subYears(new Date(2014, 8, 1), 5)
             * //=> Tue Sep 01 2009 00:00:00
             */
            function subYears(dirtyDate, dirtyAmount) {
                if (arguments.length < 2) {
                    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
                }
                var amount = Object(_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_0__["default"])(dirtyAmount);
                return Object(_addYears_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, -amount);
            }
            /***/ 
        }),
        /***/ "./node_modules/date-fns/esm/toDate/index.js": 
        /*!***************************************************!*\
          !*** ./node_modules/date-fns/esm/toDate/index.js ***!
          \***************************************************/
        /*! exports provided: default */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function () { return toDate; });
            /**
             * @name toDate
             * @category Common Helpers
             * @summary Convert the given argument to an instance of Date.
             *
             * @description
             * Convert the given argument to an instance of Date.
             *
             * If the argument is an instance of Date, the function returns its clone.
             *
             * If the argument is a number, it is treated as a timestamp.
             *
             * If the argument is none of the above, the function returns Invalid Date.
             *
             * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
             *
             * @param {Date|Number} argument - the value to convert
             * @returns {Date} the parsed date in the local time zone
             * @throws {TypeError} 1 argument required
             *
             * @example
             * // Clone the date:
             * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
             * //=> Tue Feb 11 2014 11:30:30
             *
             * @example
             * // Convert the timestamp to date:
             * const result = toDate(1392098430000)
             * //=> Tue Feb 11 2014 11:30:30
             */
            function toDate(argument) {
                if (arguments.length < 1) {
                    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
                }
                var argStr = Object.prototype.toString.call(argument); // Clone the date
                if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
                    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
                    return new Date(argument.getTime());
                }
                else if (typeof argument === 'number' || argStr === '[object Number]') {
                    return new Date(argument);
                }
                else {
                    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
                        // eslint-disable-next-line no-console
                        console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
                        console.warn(new Error().stack);
                    }
                    return new Date(NaN);
                }
            }
            /***/ 
        }),
        /***/ "./node_modules/hammerjs/hammer.js": 
        /*!*****************************************!*\
          !*** ./node_modules/hammerjs/hammer.js ***!
          \*****************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var __WEBPACK_AMD_DEFINE_RESULT__; /*! Hammer.JS - v2.0.7 - 2016-04-22
             * http://hammerjs.github.io/
             *
             * Copyright (c) 2016 Jorik Tangelder;
             * Licensed under the MIT license */
            (function (window, document, exportName, undefined) {
                'use strict';
                var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
                var TEST_ELEMENT = document.createElement('div');
                var TYPE_FUNCTION = 'function';
                var round = Math.round;
                var abs = Math.abs;
                var now = Date.now;
                /**
                 * set a timeout with a given scope
                 * @param {Function} fn
                 * @param {Number} timeout
                 * @param {Object} context
                 * @returns {number}
                 */
                function setTimeoutContext(fn, timeout, context) {
                    return setTimeout(bindFn(fn, context), timeout);
                }
                /**
                 * if the argument is an array, we want to execute the fn on each entry
                 * if it aint an array we don't want to do a thing.
                 * this is used by all the methods that accept a single and array argument.
                 * @param {*|Array} arg
                 * @param {String} fn
                 * @param {Object} [context]
                 * @returns {Boolean}
                 */
                function invokeArrayArg(arg, fn, context) {
                    if (Array.isArray(arg)) {
                        each(arg, context[fn], context);
                        return true;
                    }
                    return false;
                }
                /**
                 * walk objects and arrays
                 * @param {Object} obj
                 * @param {Function} iterator
                 * @param {Object} context
                 */
                function each(obj, iterator, context) {
                    var i;
                    if (!obj) {
                        return;
                    }
                    if (obj.forEach) {
                        obj.forEach(iterator, context);
                    }
                    else if (obj.length !== undefined) {
                        i = 0;
                        while (i < obj.length) {
                            iterator.call(context, obj[i], i, obj);
                            i++;
                        }
                    }
                    else {
                        for (i in obj) {
                            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
                        }
                    }
                }
                /**
                 * wrap a method with a deprecation warning and stack trace
                 * @param {Function} method
                 * @param {String} name
                 * @param {String} message
                 * @returns {Function} A new function wrapping the supplied method.
                 */
                function deprecate(method, name, message) {
                    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
                    return function () {
                        var e = new Error('get-stack-trace');
                        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
                            .replace(/^\s+at\s+/gm, '')
                            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
                        var log = window.console && (window.console.warn || window.console.log);
                        if (log) {
                            log.call(window.console, deprecationMessage, stack);
                        }
                        return method.apply(this, arguments);
                    };
                }
                /**
                 * extend object.
                 * means that properties in dest will be overwritten by the ones in src.
                 * @param {Object} target
                 * @param {...Object} objects_to_assign
                 * @returns {Object} target
                 */
                var assign;
                if (typeof Object.assign !== 'function') {
                    assign = function assign(target) {
                        if (target === undefined || target === null) {
                            throw new TypeError('Cannot convert undefined or null to object');
                        }
                        var output = Object(target);
                        for (var index = 1; index < arguments.length; index++) {
                            var source = arguments[index];
                            if (source !== undefined && source !== null) {
                                for (var nextKey in source) {
                                    if (source.hasOwnProperty(nextKey)) {
                                        output[nextKey] = source[nextKey];
                                    }
                                }
                            }
                        }
                        return output;
                    };
                }
                else {
                    assign = Object.assign;
                }
                /**
                 * extend object.
                 * means that properties in dest will be overwritten by the ones in src.
                 * @param {Object} dest
                 * @param {Object} src
                 * @param {Boolean} [merge=false]
                 * @returns {Object} dest
                 */
                var extend = deprecate(function extend(dest, src, merge) {
                    var keys = Object.keys(src);
                    var i = 0;
                    while (i < keys.length) {
                        if (!merge || (merge && dest[keys[i]] === undefined)) {
                            dest[keys[i]] = src[keys[i]];
                        }
                        i++;
                    }
                    return dest;
                }, 'extend', 'Use `assign`.');
                /**
                 * merge the values from src in the dest.
                 * means that properties that exist in dest will not be overwritten by src
                 * @param {Object} dest
                 * @param {Object} src
                 * @returns {Object} dest
                 */
                var merge = deprecate(function merge(dest, src) {
                    return extend(dest, src, true);
                }, 'merge', 'Use `assign`.');
                /**
                 * simple class inheritance
                 * @param {Function} child
                 * @param {Function} base
                 * @param {Object} [properties]
                 */
                function inherit(child, base, properties) {
                    var baseP = base.prototype, childP;
                    childP = child.prototype = Object.create(baseP);
                    childP.constructor = child;
                    childP._super = baseP;
                    if (properties) {
                        assign(childP, properties);
                    }
                }
                /**
                 * simple function bind
                 * @param {Function} fn
                 * @param {Object} context
                 * @returns {Function}
                 */
                function bindFn(fn, context) {
                    return function boundFn() {
                        return fn.apply(context, arguments);
                    };
                }
                /**
                 * let a boolean value also be a function that must return a boolean
                 * this first item in args will be used as the context
                 * @param {Boolean|Function} val
                 * @param {Array} [args]
                 * @returns {Boolean}
                 */
                function boolOrFn(val, args) {
                    if (typeof val == TYPE_FUNCTION) {
                        return val.apply(args ? args[0] || undefined : undefined, args);
                    }
                    return val;
                }
                /**
                 * use the val2 when val1 is undefined
                 * @param {*} val1
                 * @param {*} val2
                 * @returns {*}
                 */
                function ifUndefined(val1, val2) {
                    return (val1 === undefined) ? val2 : val1;
                }
                /**
                 * addEventListener with multiple events at once
                 * @param {EventTarget} target
                 * @param {String} types
                 * @param {Function} handler
                 */
                function addEventListeners(target, types, handler) {
                    each(splitStr(types), function (type) {
                        target.addEventListener(type, handler, false);
                    });
                }
                /**
                 * removeEventListener with multiple events at once
                 * @param {EventTarget} target
                 * @param {String} types
                 * @param {Function} handler
                 */
                function removeEventListeners(target, types, handler) {
                    each(splitStr(types), function (type) {
                        target.removeEventListener(type, handler, false);
                    });
                }
                /**
                 * find if a node is in the given parent
                 * @method hasParent
                 * @param {HTMLElement} node
                 * @param {HTMLElement} parent
                 * @return {Boolean} found
                 */
                function hasParent(node, parent) {
                    while (node) {
                        if (node == parent) {
                            return true;
                        }
                        node = node.parentNode;
                    }
                    return false;
                }
                /**
                 * small indexOf wrapper
                 * @param {String} str
                 * @param {String} find
                 * @returns {Boolean} found
                 */
                function inStr(str, find) {
                    return str.indexOf(find) > -1;
                }
                /**
                 * split string on whitespace
                 * @param {String} str
                 * @returns {Array} words
                 */
                function splitStr(str) {
                    return str.trim().split(/\s+/g);
                }
                /**
                 * find if a array contains the object using indexOf or a simple polyFill
                 * @param {Array} src
                 * @param {String} find
                 * @param {String} [findByKey]
                 * @return {Boolean|Number} false when not found, or the index
                 */
                function inArray(src, find, findByKey) {
                    if (src.indexOf && !findByKey) {
                        return src.indexOf(find);
                    }
                    else {
                        var i = 0;
                        while (i < src.length) {
                            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                                return i;
                            }
                            i++;
                        }
                        return -1;
                    }
                }
                /**
                 * convert array-like objects to real arrays
                 * @param {Object} obj
                 * @returns {Array}
                 */
                function toArray(obj) {
                    return Array.prototype.slice.call(obj, 0);
                }
                /**
                 * unique array with objects based on a key (like 'id') or just by the array's value
                 * @param {Array} src [{id:1},{id:2},{id:1}]
                 * @param {String} [key]
                 * @param {Boolean} [sort=False]
                 * @returns {Array} [{id:1},{id:2}]
                 */
                function uniqueArray(src, key, sort) {
                    var results = [];
                    var values = [];
                    var i = 0;
                    while (i < src.length) {
                        var val = key ? src[i][key] : src[i];
                        if (inArray(values, val) < 0) {
                            results.push(src[i]);
                        }
                        values[i] = val;
                        i++;
                    }
                    if (sort) {
                        if (!key) {
                            results = results.sort();
                        }
                        else {
                            results = results.sort(function sortUniqueArray(a, b) {
                                return a[key] > b[key];
                            });
                        }
                    }
                    return results;
                }
                /**
                 * get the prefixed property
                 * @param {Object} obj
                 * @param {String} property
                 * @returns {String|Undefined} prefixed
                 */
                function prefixed(obj, property) {
                    var prefix, prop;
                    var camelProp = property[0].toUpperCase() + property.slice(1);
                    var i = 0;
                    while (i < VENDOR_PREFIXES.length) {
                        prefix = VENDOR_PREFIXES[i];
                        prop = (prefix) ? prefix + camelProp : property;
                        if (prop in obj) {
                            return prop;
                        }
                        i++;
                    }
                    return undefined;
                }
                /**
                 * get a unique id
                 * @returns {number} uniqueId
                 */
                var _uniqueId = 1;
                function uniqueId() {
                    return _uniqueId++;
                }
                /**
                 * get the window object of an element
                 * @param {HTMLElement} element
                 * @returns {DocumentView|Window}
                 */
                function getWindowForElement(element) {
                    var doc = element.ownerDocument || element;
                    return (doc.defaultView || doc.parentWindow || window);
                }
                var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
                var SUPPORT_TOUCH = ('ontouchstart' in window);
                var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
                var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
                var INPUT_TYPE_TOUCH = 'touch';
                var INPUT_TYPE_PEN = 'pen';
                var INPUT_TYPE_MOUSE = 'mouse';
                var INPUT_TYPE_KINECT = 'kinect';
                var COMPUTE_INTERVAL = 25;
                var INPUT_START = 1;
                var INPUT_MOVE = 2;
                var INPUT_END = 4;
                var INPUT_CANCEL = 8;
                var DIRECTION_NONE = 1;
                var DIRECTION_LEFT = 2;
                var DIRECTION_RIGHT = 4;
                var DIRECTION_UP = 8;
                var DIRECTION_DOWN = 16;
                var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
                var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
                var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
                var PROPS_XY = ['x', 'y'];
                var PROPS_CLIENT_XY = ['clientX', 'clientY'];
                /**
                 * create new input type manager
                 * @param {Manager} manager
                 * @param {Function} callback
                 * @returns {Input}
                 * @constructor
                 */
                function Input(manager, callback) {
                    var self = this;
                    this.manager = manager;
                    this.callback = callback;
                    this.element = manager.element;
                    this.target = manager.options.inputTarget;
                    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
                    // so when disabled the input events are completely bypassed.
                    this.domHandler = function (ev) {
                        if (boolOrFn(manager.options.enable, [manager])) {
                            self.handler(ev);
                        }
                    };
                    this.init();
                }
                Input.prototype = {
                    /**
                     * should handle the inputEvent data and trigger the callback
                     * @virtual
                     */
                    handler: function () { },
                    /**
                     * bind the events
                     */
                    init: function () {
                        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
                        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
                        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
                    },
                    /**
                     * unbind the events
                     */
                    destroy: function () {
                        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
                        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
                        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
                    }
                };
                /**
                 * create new input type manager
                 * called by the Manager constructor
                 * @param {Hammer} manager
                 * @returns {Input}
                 */
                function createInputInstance(manager) {
                    var Type;
                    var inputClass = manager.options.inputClass;
                    if (inputClass) {
                        Type = inputClass;
                    }
                    else if (SUPPORT_POINTER_EVENTS) {
                        Type = PointerEventInput;
                    }
                    else if (SUPPORT_ONLY_TOUCH) {
                        Type = TouchInput;
                    }
                    else if (!SUPPORT_TOUCH) {
                        Type = MouseInput;
                    }
                    else {
                        Type = TouchMouseInput;
                    }
                    return new (Type)(manager, inputHandler);
                }
                /**
                 * handle input events
                 * @param {Manager} manager
                 * @param {String} eventType
                 * @param {Object} input
                 */
                function inputHandler(manager, eventType, input) {
                    var pointersLen = input.pointers.length;
                    var changedPointersLen = input.changedPointers.length;
                    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
                    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
                    input.isFirst = !!isFirst;
                    input.isFinal = !!isFinal;
                    if (isFirst) {
                        manager.session = {};
                    }
                    // source event is the normalized value of the domEvents
                    // like 'touchstart, mouseup, pointerdown'
                    input.eventType = eventType;
                    // compute scale, rotation etc
                    computeInputData(manager, input);
                    // emit secret event
                    manager.emit('hammer.input', input);
                    manager.recognize(input);
                    manager.session.prevInput = input;
                }
                /**
                 * extend the data with some usable properties like scale, rotate, velocity etc
                 * @param {Object} manager
                 * @param {Object} input
                 */
                function computeInputData(manager, input) {
                    var session = manager.session;
                    var pointers = input.pointers;
                    var pointersLength = pointers.length;
                    // store the first input to calculate the distance and direction
                    if (!session.firstInput) {
                        session.firstInput = simpleCloneInputData(input);
                    }
                    // to compute scale and rotation we need to store the multiple touches
                    if (pointersLength > 1 && !session.firstMultiple) {
                        session.firstMultiple = simpleCloneInputData(input);
                    }
                    else if (pointersLength === 1) {
                        session.firstMultiple = false;
                    }
                    var firstInput = session.firstInput;
                    var firstMultiple = session.firstMultiple;
                    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
                    var center = input.center = getCenter(pointers);
                    input.timeStamp = now();
                    input.deltaTime = input.timeStamp - firstInput.timeStamp;
                    input.angle = getAngle(offsetCenter, center);
                    input.distance = getDistance(offsetCenter, center);
                    computeDeltaXY(session, input);
                    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
                    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
                    input.overallVelocityX = overallVelocity.x;
                    input.overallVelocityY = overallVelocity.y;
                    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
                    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
                    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
                    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
                        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
                    computeIntervalInputData(session, input);
                    // find the correct target
                    var target = manager.element;
                    if (hasParent(input.srcEvent.target, target)) {
                        target = input.srcEvent.target;
                    }
                    input.target = target;
                }
                function computeDeltaXY(session, input) {
                    var center = input.center;
                    var offset = session.offsetDelta || {};
                    var prevDelta = session.prevDelta || {};
                    var prevInput = session.prevInput || {};
                    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
                        prevDelta = session.prevDelta = {
                            x: prevInput.deltaX || 0,
                            y: prevInput.deltaY || 0
                        };
                        offset = session.offsetDelta = {
                            x: center.x,
                            y: center.y
                        };
                    }
                    input.deltaX = prevDelta.x + (center.x - offset.x);
                    input.deltaY = prevDelta.y + (center.y - offset.y);
                }
                /**
                 * velocity is calculated every x ms
                 * @param {Object} session
                 * @param {Object} input
                 */
                function computeIntervalInputData(session, input) {
                    var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
                    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
                        var deltaX = input.deltaX - last.deltaX;
                        var deltaY = input.deltaY - last.deltaY;
                        var v = getVelocity(deltaTime, deltaX, deltaY);
                        velocityX = v.x;
                        velocityY = v.y;
                        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
                        direction = getDirection(deltaX, deltaY);
                        session.lastInterval = input;
                    }
                    else {
                        // use latest velocity info if it doesn't overtake a minimum period
                        velocity = last.velocity;
                        velocityX = last.velocityX;
                        velocityY = last.velocityY;
                        direction = last.direction;
                    }
                    input.velocity = velocity;
                    input.velocityX = velocityX;
                    input.velocityY = velocityY;
                    input.direction = direction;
                }
                /**
                 * create a simple clone from the input used for storage of firstInput and firstMultiple
                 * @param {Object} input
                 * @returns {Object} clonedInputData
                 */
                function simpleCloneInputData(input) {
                    // make a simple copy of the pointers because we will get a reference if we don't
                    // we only need clientXY for the calculations
                    var pointers = [];
                    var i = 0;
                    while (i < input.pointers.length) {
                        pointers[i] = {
                            clientX: round(input.pointers[i].clientX),
                            clientY: round(input.pointers[i].clientY)
                        };
                        i++;
                    }
                    return {
                        timeStamp: now(),
                        pointers: pointers,
                        center: getCenter(pointers),
                        deltaX: input.deltaX,
                        deltaY: input.deltaY
                    };
                }
                /**
                 * get the center of all the pointers
                 * @param {Array} pointers
                 * @return {Object} center contains `x` and `y` properties
                 */
                function getCenter(pointers) {
                    var pointersLength = pointers.length;
                    // no need to loop when only one touch
                    if (pointersLength === 1) {
                        return {
                            x: round(pointers[0].clientX),
                            y: round(pointers[0].clientY)
                        };
                    }
                    var x = 0, y = 0, i = 0;
                    while (i < pointersLength) {
                        x += pointers[i].clientX;
                        y += pointers[i].clientY;
                        i++;
                    }
                    return {
                        x: round(x / pointersLength),
                        y: round(y / pointersLength)
                    };
                }
                /**
                 * calculate the velocity between two points. unit is in px per ms.
                 * @param {Number} deltaTime
                 * @param {Number} x
                 * @param {Number} y
                 * @return {Object} velocity `x` and `y`
                 */
                function getVelocity(deltaTime, x, y) {
                    return {
                        x: x / deltaTime || 0,
                        y: y / deltaTime || 0
                    };
                }
                /**
                 * get the direction between two points
                 * @param {Number} x
                 * @param {Number} y
                 * @return {Number} direction
                 */
                function getDirection(x, y) {
                    if (x === y) {
                        return DIRECTION_NONE;
                    }
                    if (abs(x) >= abs(y)) {
                        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    }
                    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                }
                /**
                 * calculate the absolute distance between two points
                 * @param {Object} p1 {x, y}
                 * @param {Object} p2 {x, y}
                 * @param {Array} [props] containing x and y keys
                 * @return {Number} distance
                 */
                function getDistance(p1, p2, props) {
                    if (!props) {
                        props = PROPS_XY;
                    }
                    var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
                    return Math.sqrt((x * x) + (y * y));
                }
                /**
                 * calculate the angle between two coordinates
                 * @param {Object} p1
                 * @param {Object} p2
                 * @param {Array} [props] containing x and y keys
                 * @return {Number} angle
                 */
                function getAngle(p1, p2, props) {
                    if (!props) {
                        props = PROPS_XY;
                    }
                    var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
                    return Math.atan2(y, x) * 180 / Math.PI;
                }
                /**
                 * calculate the rotation degrees between two pointersets
                 * @param {Array} start array of pointers
                 * @param {Array} end array of pointers
                 * @return {Number} rotation
                 */
                function getRotation(start, end) {
                    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
                }
                /**
                 * calculate the scale factor between two pointersets
                 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
                 * @param {Array} start array of pointers
                 * @param {Array} end array of pointers
                 * @return {Number} scale
                 */
                function getScale(start, end) {
                    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
                }
                var MOUSE_INPUT_MAP = {
                    mousedown: INPUT_START,
                    mousemove: INPUT_MOVE,
                    mouseup: INPUT_END
                };
                var MOUSE_ELEMENT_EVENTS = 'mousedown';
                var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
                /**
                 * Mouse events input
                 * @constructor
                 * @extends Input
                 */
                function MouseInput() {
                    this.evEl = MOUSE_ELEMENT_EVENTS;
                    this.evWin = MOUSE_WINDOW_EVENTS;
                    this.pressed = false; // mousedown state
                    Input.apply(this, arguments);
                }
                inherit(MouseInput, Input, {
                    /**
                     * handle mouse events
                     * @param {Object} ev
                     */
                    handler: function MEhandler(ev) {
                        var eventType = MOUSE_INPUT_MAP[ev.type];
                        // on start we want to have the left mouse button down
                        if (eventType & INPUT_START && ev.button === 0) {
                            this.pressed = true;
                        }
                        if (eventType & INPUT_MOVE && ev.which !== 1) {
                            eventType = INPUT_END;
                        }
                        // mouse must be down
                        if (!this.pressed) {
                            return;
                        }
                        if (eventType & INPUT_END) {
                            this.pressed = false;
                        }
                        this.callback(this.manager, eventType, {
                            pointers: [ev],
                            changedPointers: [ev],
                            pointerType: INPUT_TYPE_MOUSE,
                            srcEvent: ev
                        });
                    }
                });
                var POINTER_INPUT_MAP = {
                    pointerdown: INPUT_START,
                    pointermove: INPUT_MOVE,
                    pointerup: INPUT_END,
                    pointercancel: INPUT_CANCEL,
                    pointerout: INPUT_CANCEL
                };
                // in IE10 the pointer types is defined as an enum
                var IE10_POINTER_TYPE_ENUM = {
                    2: INPUT_TYPE_TOUCH,
                    3: INPUT_TYPE_PEN,
                    4: INPUT_TYPE_MOUSE,
                    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
                };
                var POINTER_ELEMENT_EVENTS = 'pointerdown';
                var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
                // IE10 has prefixed support, and case-sensitive
                if (window.MSPointerEvent && !window.PointerEvent) {
                    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
                    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
                }
                /**
                 * Pointer events input
                 * @constructor
                 * @extends Input
                 */
                function PointerEventInput() {
                    this.evEl = POINTER_ELEMENT_EVENTS;
                    this.evWin = POINTER_WINDOW_EVENTS;
                    Input.apply(this, arguments);
                    this.store = (this.manager.session.pointerEvents = []);
                }
                inherit(PointerEventInput, Input, {
                    /**
                     * handle mouse events
                     * @param {Object} ev
                     */
                    handler: function PEhandler(ev) {
                        var store = this.store;
                        var removePointer = false;
                        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
                        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
                        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
                        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
                        // get index of the event in the store
                        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
                        // start and mouse must be down
                        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                            if (storeIndex < 0) {
                                store.push(ev);
                                storeIndex = store.length - 1;
                            }
                        }
                        else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                            removePointer = true;
                        }
                        // it not found, so the pointer hasn't been down (so it's probably a hover)
                        if (storeIndex < 0) {
                            return;
                        }
                        // update the event in the store
                        store[storeIndex] = ev;
                        this.callback(this.manager, eventType, {
                            pointers: store,
                            changedPointers: [ev],
                            pointerType: pointerType,
                            srcEvent: ev
                        });
                        if (removePointer) {
                            // remove from the store
                            store.splice(storeIndex, 1);
                        }
                    }
                });
                var SINGLE_TOUCH_INPUT_MAP = {
                    touchstart: INPUT_START,
                    touchmove: INPUT_MOVE,
                    touchend: INPUT_END,
                    touchcancel: INPUT_CANCEL
                };
                var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
                var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
                /**
                 * Touch events input
                 * @constructor
                 * @extends Input
                 */
                function SingleTouchInput() {
                    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
                    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
                    this.started = false;
                    Input.apply(this, arguments);
                }
                inherit(SingleTouchInput, Input, {
                    handler: function TEhandler(ev) {
                        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
                        // should we handle the touch events?
                        if (type === INPUT_START) {
                            this.started = true;
                        }
                        if (!this.started) {
                            return;
                        }
                        var touches = normalizeSingleTouches.call(this, ev, type);
                        // when done, reset the started state
                        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
                            this.started = false;
                        }
                        this.callback(this.manager, type, {
                            pointers: touches[0],
                            changedPointers: touches[1],
                            pointerType: INPUT_TYPE_TOUCH,
                            srcEvent: ev
                        });
                    }
                });
                /**
                 * @this {TouchInput}
                 * @param {Object} ev
                 * @param {Number} type flag
                 * @returns {undefined|Array} [all, changed]
                 */
                function normalizeSingleTouches(ev, type) {
                    var all = toArray(ev.touches);
                    var changed = toArray(ev.changedTouches);
                    if (type & (INPUT_END | INPUT_CANCEL)) {
                        all = uniqueArray(all.concat(changed), 'identifier', true);
                    }
                    return [all, changed];
                }
                var TOUCH_INPUT_MAP = {
                    touchstart: INPUT_START,
                    touchmove: INPUT_MOVE,
                    touchend: INPUT_END,
                    touchcancel: INPUT_CANCEL
                };
                var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
                /**
                 * Multi-user touch events input
                 * @constructor
                 * @extends Input
                 */
                function TouchInput() {
                    this.evTarget = TOUCH_TARGET_EVENTS;
                    this.targetIds = {};
                    Input.apply(this, arguments);
                }
                inherit(TouchInput, Input, {
                    handler: function MTEhandler(ev) {
                        var type = TOUCH_INPUT_MAP[ev.type];
                        var touches = getTouches.call(this, ev, type);
                        if (!touches) {
                            return;
                        }
                        this.callback(this.manager, type, {
                            pointers: touches[0],
                            changedPointers: touches[1],
                            pointerType: INPUT_TYPE_TOUCH,
                            srcEvent: ev
                        });
                    }
                });
                /**
                 * @this {TouchInput}
                 * @param {Object} ev
                 * @param {Number} type flag
                 * @returns {undefined|Array} [all, changed]
                 */
                function getTouches(ev, type) {
                    var allTouches = toArray(ev.touches);
                    var targetIds = this.targetIds;
                    // when there is only one touch, the process can be simplified
                    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
                        targetIds[allTouches[0].identifier] = true;
                        return [allTouches, allTouches];
                    }
                    var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
                    // get target touches from touches
                    targetTouches = allTouches.filter(function (touch) {
                        return hasParent(touch.target, target);
                    });
                    // collect touches
                    if (type === INPUT_START) {
                        i = 0;
                        while (i < targetTouches.length) {
                            targetIds[targetTouches[i].identifier] = true;
                            i++;
                        }
                    }
                    // filter changed touches to only contain touches that exist in the collected target ids
                    i = 0;
                    while (i < changedTouches.length) {
                        if (targetIds[changedTouches[i].identifier]) {
                            changedTargetTouches.push(changedTouches[i]);
                        }
                        // cleanup removed touches
                        if (type & (INPUT_END | INPUT_CANCEL)) {
                            delete targetIds[changedTouches[i].identifier];
                        }
                        i++;
                    }
                    if (!changedTargetTouches.length) {
                        return;
                    }
                    return [
                        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
                        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
                        changedTargetTouches
                    ];
                }
                /**
                 * Combined touch and mouse input
                 *
                 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
                 * This because touch devices also emit mouse events while doing a touch.
                 *
                 * @constructor
                 * @extends Input
                 */
                var DEDUP_TIMEOUT = 2500;
                var DEDUP_DISTANCE = 25;
                function TouchMouseInput() {
                    Input.apply(this, arguments);
                    var handler = bindFn(this.handler, this);
                    this.touch = new TouchInput(this.manager, handler);
                    this.mouse = new MouseInput(this.manager, handler);
                    this.primaryTouch = null;
                    this.lastTouches = [];
                }
                inherit(TouchMouseInput, Input, {
                    /**
                     * handle mouse and touch events
                     * @param {Hammer} manager
                     * @param {String} inputEvent
                     * @param {Object} inputData
                     */
                    handler: function TMEhandler(manager, inputEvent, inputData) {
                        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH), isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
                        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
                            return;
                        }
                        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
                        if (isTouch) {
                            recordTouches.call(this, inputEvent, inputData);
                        }
                        else if (isMouse && isSyntheticEvent.call(this, inputData)) {
                            return;
                        }
                        this.callback(manager, inputEvent, inputData);
                    },
                    /**
                     * remove the event listeners
                     */
                    destroy: function destroy() {
                        this.touch.destroy();
                        this.mouse.destroy();
                    }
                });
                function recordTouches(eventType, eventData) {
                    if (eventType & INPUT_START) {
                        this.primaryTouch = eventData.changedPointers[0].identifier;
                        setLastTouch.call(this, eventData);
                    }
                    else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                        setLastTouch.call(this, eventData);
                    }
                }
                function setLastTouch(eventData) {
                    var touch = eventData.changedPointers[0];
                    if (touch.identifier === this.primaryTouch) {
                        var lastTouch = { x: touch.clientX, y: touch.clientY };
                        this.lastTouches.push(lastTouch);
                        var lts = this.lastTouches;
                        var removeLastTouch = function () {
                            var i = lts.indexOf(lastTouch);
                            if (i > -1) {
                                lts.splice(i, 1);
                            }
                        };
                        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
                    }
                }
                function isSyntheticEvent(eventData) {
                    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
                    for (var i = 0; i < this.lastTouches.length; i++) {
                        var t = this.lastTouches[i];
                        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
                        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
                            return true;
                        }
                    }
                    return false;
                }
                var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
                var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
                // magical touchAction value
                var TOUCH_ACTION_COMPUTE = 'compute';
                var TOUCH_ACTION_AUTO = 'auto';
                var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
                var TOUCH_ACTION_NONE = 'none';
                var TOUCH_ACTION_PAN_X = 'pan-x';
                var TOUCH_ACTION_PAN_Y = 'pan-y';
                var TOUCH_ACTION_MAP = getTouchActionProps();
                /**
                 * Touch Action
                 * sets the touchAction property or uses the js alternative
                 * @param {Manager} manager
                 * @param {String} value
                 * @constructor
                 */
                function TouchAction(manager, value) {
                    this.manager = manager;
                    this.set(value);
                }
                TouchAction.prototype = {
                    /**
                     * set the touchAction value on the element or enable the polyfill
                     * @param {String} value
                     */
                    set: function (value) {
                        // find out the touch-action by the event handlers
                        if (value == TOUCH_ACTION_COMPUTE) {
                            value = this.compute();
                        }
                        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
                            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
                        }
                        this.actions = value.toLowerCase().trim();
                    },
                    /**
                     * just re-set the touchAction value
                     */
                    update: function () {
                        this.set(this.manager.options.touchAction);
                    },
                    /**
                     * compute the value for the touchAction property based on the recognizer's settings
                     * @returns {String} value
                     */
                    compute: function () {
                        var actions = [];
                        each(this.manager.recognizers, function (recognizer) {
                            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                                actions = actions.concat(recognizer.getTouchAction());
                            }
                        });
                        return cleanTouchActions(actions.join(' '));
                    },
                    /**
                     * this method is called on each input cycle and provides the preventing of the browser behavior
                     * @param {Object} input
                     */
                    preventDefaults: function (input) {
                        var srcEvent = input.srcEvent;
                        var direction = input.offsetDirection;
                        // if the touch action did prevented once this session
                        if (this.manager.session.prevented) {
                            srcEvent.preventDefault();
                            return;
                        }
                        var actions = this.actions;
                        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
                        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
                        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
                        if (hasNone) {
                            //do not prevent defaults if this is a tap gesture
                            var isTapPointer = input.pointers.length === 1;
                            var isTapMovement = input.distance < 2;
                            var isTapTouchTime = input.deltaTime < 250;
                            if (isTapPointer && isTapMovement && isTapTouchTime) {
                                return;
                            }
                        }
                        if (hasPanX && hasPanY) {
                            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
                            return;
                        }
                        if (hasNone ||
                            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
                            (hasPanX && direction & DIRECTION_VERTICAL)) {
                            return this.preventSrc(srcEvent);
                        }
                    },
                    /**
                     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
                     * @param {Object} srcEvent
                     */
                    preventSrc: function (srcEvent) {
                        this.manager.session.prevented = true;
                        srcEvent.preventDefault();
                    }
                };
                /**
                 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
                 * @param {String} actions
                 * @returns {*}
                 */
                function cleanTouchActions(actions) {
                    // none
                    if (inStr(actions, TOUCH_ACTION_NONE)) {
                        return TOUCH_ACTION_NONE;
                    }
                    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
                    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
                    // if both pan-x and pan-y are set (different recognizers
                    // for different directions, e.g. horizontal pan but vertical swipe?)
                    // we need none (as otherwise with pan-x pan-y combined none of these
                    // recognizers will work, since the browser would handle all panning
                    if (hasPanX && hasPanY) {
                        return TOUCH_ACTION_NONE;
                    }
                    // pan-x OR pan-y
                    if (hasPanX || hasPanY) {
                        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
                    }
                    // manipulation
                    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
                        return TOUCH_ACTION_MANIPULATION;
                    }
                    return TOUCH_ACTION_AUTO;
                }
                function getTouchActionProps() {
                    if (!NATIVE_TOUCH_ACTION) {
                        return false;
                    }
                    var touchMap = {};
                    var cssSupports = window.CSS && window.CSS.supports;
                    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function (val) {
                        // If css.supports is not supported but there is native touch-action assume it supports
                        // all values. This is the case for IE 10 and 11.
                        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
                    });
                    return touchMap;
                }
                /**
                 * Recognizer flow explained; *
                 * All recognizers have the initial state of POSSIBLE when a input session starts.
                 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
                 * Example session for mouse-input: mousedown -> mousemove -> mouseup
                 *
                 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
                 * which determines with state it should be.
                 *
                 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
                 * POSSIBLE to give it another change on the next cycle.
                 *
                 *               Possible
                 *                  |
                 *            +-----+---------------+
                 *            |                     |
                 *      +-----+-----+               |
                 *      |           |               |
                 *   Failed      Cancelled          |
                 *                          +-------+------+
                 *                          |              |
                 *                      Recognized       Began
                 *                                         |
                 *                                      Changed
                 *                                         |
                 *                                  Ended/Recognized
                 */
                var STATE_POSSIBLE = 1;
                var STATE_BEGAN = 2;
                var STATE_CHANGED = 4;
                var STATE_ENDED = 8;
                var STATE_RECOGNIZED = STATE_ENDED;
                var STATE_CANCELLED = 16;
                var STATE_FAILED = 32;
                /**
                 * Recognizer
                 * Every recognizer needs to extend from this class.
                 * @constructor
                 * @param {Object} options
                 */
                function Recognizer(options) {
                    this.options = assign({}, this.defaults, options || {});
                    this.id = uniqueId();
                    this.manager = null;
                    // default is enable true
                    this.options.enable = ifUndefined(this.options.enable, true);
                    this.state = STATE_POSSIBLE;
                    this.simultaneous = {};
                    this.requireFail = [];
                }
                Recognizer.prototype = {
                    /**
                     * @virtual
                     * @type {Object}
                     */
                    defaults: {},
                    /**
                     * set options
                     * @param {Object} options
                     * @return {Recognizer}
                     */
                    set: function (options) {
                        assign(this.options, options);
                        // also update the touchAction, in case something changed about the directions/enabled state
                        this.manager && this.manager.touchAction.update();
                        return this;
                    },
                    /**
                     * recognize simultaneous with an other recognizer.
                     * @param {Recognizer} otherRecognizer
                     * @returns {Recognizer} this
                     */
                    recognizeWith: function (otherRecognizer) {
                        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
                            return this;
                        }
                        var simultaneous = this.simultaneous;
                        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                        if (!simultaneous[otherRecognizer.id]) {
                            simultaneous[otherRecognizer.id] = otherRecognizer;
                            otherRecognizer.recognizeWith(this);
                        }
                        return this;
                    },
                    /**
                     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
                     * @param {Recognizer} otherRecognizer
                     * @returns {Recognizer} this
                     */
                    dropRecognizeWith: function (otherRecognizer) {
                        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
                            return this;
                        }
                        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                        delete this.simultaneous[otherRecognizer.id];
                        return this;
                    },
                    /**
                     * recognizer can only run when an other is failing
                     * @param {Recognizer} otherRecognizer
                     * @returns {Recognizer} this
                     */
                    requireFailure: function (otherRecognizer) {
                        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
                            return this;
                        }
                        var requireFail = this.requireFail;
                        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                        if (inArray(requireFail, otherRecognizer) === -1) {
                            requireFail.push(otherRecognizer);
                            otherRecognizer.requireFailure(this);
                        }
                        return this;
                    },
                    /**
                     * drop the requireFailure link. it does not remove the link on the other recognizer.
                     * @param {Recognizer} otherRecognizer
                     * @returns {Recognizer} this
                     */
                    dropRequireFailure: function (otherRecognizer) {
                        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
                            return this;
                        }
                        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                        var index = inArray(this.requireFail, otherRecognizer);
                        if (index > -1) {
                            this.requireFail.splice(index, 1);
                        }
                        return this;
                    },
                    /**
                     * has require failures boolean
                     * @returns {boolean}
                     */
                    hasRequireFailures: function () {
                        return this.requireFail.length > 0;
                    },
                    /**
                     * if the recognizer can recognize simultaneous with an other recognizer
                     * @param {Recognizer} otherRecognizer
                     * @returns {Boolean}
                     */
                    canRecognizeWith: function (otherRecognizer) {
                        return !!this.simultaneous[otherRecognizer.id];
                    },
                    /**
                     * You should use `tryEmit` instead of `emit` directly to check
                     * that all the needed recognizers has failed before emitting.
                     * @param {Object} input
                     */
                    emit: function (input) {
                        var self = this;
                        var state = this.state;
                        function emit(event) {
                            self.manager.emit(event, input);
                        }
                        // 'panstart' and 'panmove'
                        if (state < STATE_ENDED) {
                            emit(self.options.event + stateStr(state));
                        }
                        emit(self.options.event); // simple 'eventName' events
                        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
                            emit(input.additionalEvent);
                        }
                        // panend and pancancel
                        if (state >= STATE_ENDED) {
                            emit(self.options.event + stateStr(state));
                        }
                    },
                    /**
                     * Check that all the require failure recognizers has failed,
                     * if true, it emits a gesture event,
                     * otherwise, setup the state to FAILED.
                     * @param {Object} input
                     */
                    tryEmit: function (input) {
                        if (this.canEmit()) {
                            return this.emit(input);
                        }
                        // it's failing anyway
                        this.state = STATE_FAILED;
                    },
                    /**
                     * can we emit?
                     * @returns {boolean}
                     */
                    canEmit: function () {
                        var i = 0;
                        while (i < this.requireFail.length) {
                            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                                return false;
                            }
                            i++;
                        }
                        return true;
                    },
                    /**
                     * update the recognizer
                     * @param {Object} inputData
                     */
                    recognize: function (inputData) {
                        // make a new copy of the inputData
                        // so we can change the inputData without messing up the other recognizers
                        var inputDataClone = assign({}, inputData);
                        // is is enabled and allow recognizing?
                        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
                            this.reset();
                            this.state = STATE_FAILED;
                            return;
                        }
                        // reset when we've reached the end
                        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
                            this.state = STATE_POSSIBLE;
                        }
                        this.state = this.process(inputDataClone);
                        // the recognizer has recognized a gesture
                        // so trigger an event
                        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
                            this.tryEmit(inputDataClone);
                        }
                    },
                    /**
                     * return the state of the recognizer
                     * the actual recognizing happens in this method
                     * @virtual
                     * @param {Object} inputData
                     * @returns {Const} STATE
                     */
                    process: function (inputData) { },
                    /**
                     * return the preferred touch-action
                     * @virtual
                     * @returns {Array}
                     */
                    getTouchAction: function () { },
                    /**
                     * called when the gesture isn't allowed to recognize
                     * like when another is being recognized or it is disabled
                     * @virtual
                     */
                    reset: function () { }
                };
                /**
                 * get a usable string, used as event postfix
                 * @param {Const} state
                 * @returns {String} state
                 */
                function stateStr(state) {
                    if (state & STATE_CANCELLED) {
                        return 'cancel';
                    }
                    else if (state & STATE_ENDED) {
                        return 'end';
                    }
                    else if (state & STATE_CHANGED) {
                        return 'move';
                    }
                    else if (state & STATE_BEGAN) {
                        return 'start';
                    }
                    return '';
                }
                /**
                 * direction cons to string
                 * @param {Const} direction
                 * @returns {String}
                 */
                function directionStr(direction) {
                    if (direction == DIRECTION_DOWN) {
                        return 'down';
                    }
                    else if (direction == DIRECTION_UP) {
                        return 'up';
                    }
                    else if (direction == DIRECTION_LEFT) {
                        return 'left';
                    }
                    else if (direction == DIRECTION_RIGHT) {
                        return 'right';
                    }
                    return '';
                }
                /**
                 * get a recognizer by name if it is bound to a manager
                 * @param {Recognizer|String} otherRecognizer
                 * @param {Recognizer} recognizer
                 * @returns {Recognizer}
                 */
                function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
                    var manager = recognizer.manager;
                    if (manager) {
                        return manager.get(otherRecognizer);
                    }
                    return otherRecognizer;
                }
                /**
                 * This recognizer is just used as a base for the simple attribute recognizers.
                 * @constructor
                 * @extends Recognizer
                 */
                function AttrRecognizer() {
                    Recognizer.apply(this, arguments);
                }
                inherit(AttrRecognizer, Recognizer, {
                    /**
                     * @namespace
                     * @memberof AttrRecognizer
                     */
                    defaults: {
                        /**
                         * @type {Number}
                         * @default 1
                         */
                        pointers: 1
                    },
                    /**
                     * Used to check if it the recognizer receives valid input, like input.distance > 10.
                     * @memberof AttrRecognizer
                     * @param {Object} input
                     * @returns {Boolean} recognized
                     */
                    attrTest: function (input) {
                        var optionPointers = this.options.pointers;
                        return optionPointers === 0 || input.pointers.length === optionPointers;
                    },
                    /**
                     * Process the input and return the state for the recognizer
                     * @memberof AttrRecognizer
                     * @param {Object} input
                     * @returns {*} State
                     */
                    process: function (input) {
                        var state = this.state;
                        var eventType = input.eventType;
                        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
                        var isValid = this.attrTest(input);
                        // on cancel input and we've recognized before, return STATE_CANCELLED
                        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
                            return state | STATE_CANCELLED;
                        }
                        else if (isRecognized || isValid) {
                            if (eventType & INPUT_END) {
                                return state | STATE_ENDED;
                            }
                            else if (!(state & STATE_BEGAN)) {
                                return STATE_BEGAN;
                            }
                            return state | STATE_CHANGED;
                        }
                        return STATE_FAILED;
                    }
                });
                /**
                 * Pan
                 * Recognized when the pointer is down and moved in the allowed direction.
                 * @constructor
                 * @extends AttrRecognizer
                 */
                function PanRecognizer() {
                    AttrRecognizer.apply(this, arguments);
                    this.pX = null;
                    this.pY = null;
                }
                inherit(PanRecognizer, AttrRecognizer, {
                    /**
                     * @namespace
                     * @memberof PanRecognizer
                     */
                    defaults: {
                        event: 'pan',
                        threshold: 10,
                        pointers: 1,
                        direction: DIRECTION_ALL
                    },
                    getTouchAction: function () {
                        var direction = this.options.direction;
                        var actions = [];
                        if (direction & DIRECTION_HORIZONTAL) {
                            actions.push(TOUCH_ACTION_PAN_Y);
                        }
                        if (direction & DIRECTION_VERTICAL) {
                            actions.push(TOUCH_ACTION_PAN_X);
                        }
                        return actions;
                    },
                    directionTest: function (input) {
                        var options = this.options;
                        var hasMoved = true;
                        var distance = input.distance;
                        var direction = input.direction;
                        var x = input.deltaX;
                        var y = input.deltaY;
                        // lock to axis?
                        if (!(direction & options.direction)) {
                            if (options.direction & DIRECTION_HORIZONTAL) {
                                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                                hasMoved = x != this.pX;
                                distance = Math.abs(input.deltaX);
                            }
                            else {
                                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                                hasMoved = y != this.pY;
                                distance = Math.abs(input.deltaY);
                            }
                        }
                        input.direction = direction;
                        return hasMoved && distance > options.threshold && direction & options.direction;
                    },
                    attrTest: function (input) {
                        return AttrRecognizer.prototype.attrTest.call(this, input) &&
                            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
                    },
                    emit: function (input) {
                        this.pX = input.deltaX;
                        this.pY = input.deltaY;
                        var direction = directionStr(input.direction);
                        if (direction) {
                            input.additionalEvent = this.options.event + direction;
                        }
                        this._super.emit.call(this, input);
                    }
                });
                /**
                 * Pinch
                 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
                 * @constructor
                 * @extends AttrRecognizer
                 */
                function PinchRecognizer() {
                    AttrRecognizer.apply(this, arguments);
                }
                inherit(PinchRecognizer, AttrRecognizer, {
                    /**
                     * @namespace
                     * @memberof PinchRecognizer
                     */
                    defaults: {
                        event: 'pinch',
                        threshold: 0,
                        pointers: 2
                    },
                    getTouchAction: function () {
                        return [TOUCH_ACTION_NONE];
                    },
                    attrTest: function (input) {
                        return this._super.attrTest.call(this, input) &&
                            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
                    },
                    emit: function (input) {
                        if (input.scale !== 1) {
                            var inOut = input.scale < 1 ? 'in' : 'out';
                            input.additionalEvent = this.options.event + inOut;
                        }
                        this._super.emit.call(this, input);
                    }
                });
                /**
                 * Press
                 * Recognized when the pointer is down for x ms without any movement.
                 * @constructor
                 * @extends Recognizer
                 */
                function PressRecognizer() {
                    Recognizer.apply(this, arguments);
                    this._timer = null;
                    this._input = null;
                }
                inherit(PressRecognizer, Recognizer, {
                    /**
                     * @namespace
                     * @memberof PressRecognizer
                     */
                    defaults: {
                        event: 'press',
                        pointers: 1,
                        time: 251,
                        threshold: 9 // a minimal movement is ok, but keep it low
                    },
                    getTouchAction: function () {
                        return [TOUCH_ACTION_AUTO];
                    },
                    process: function (input) {
                        var options = this.options;
                        var validPointers = input.pointers.length === options.pointers;
                        var validMovement = input.distance < options.threshold;
                        var validTime = input.deltaTime > options.time;
                        this._input = input;
                        // we only allow little movement
                        // and we've reached an end event, so a tap is possible
                        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
                            this.reset();
                        }
                        else if (input.eventType & INPUT_START) {
                            this.reset();
                            this._timer = setTimeoutContext(function () {
                                this.state = STATE_RECOGNIZED;
                                this.tryEmit();
                            }, options.time, this);
                        }
                        else if (input.eventType & INPUT_END) {
                            return STATE_RECOGNIZED;
                        }
                        return STATE_FAILED;
                    },
                    reset: function () {
                        clearTimeout(this._timer);
                    },
                    emit: function (input) {
                        if (this.state !== STATE_RECOGNIZED) {
                            return;
                        }
                        if (input && (input.eventType & INPUT_END)) {
                            this.manager.emit(this.options.event + 'up', input);
                        }
                        else {
                            this._input.timeStamp = now();
                            this.manager.emit(this.options.event, this._input);
                        }
                    }
                });
                /**
                 * Rotate
                 * Recognized when two or more pointer are moving in a circular motion.
                 * @constructor
                 * @extends AttrRecognizer
                 */
                function RotateRecognizer() {
                    AttrRecognizer.apply(this, arguments);
                }
                inherit(RotateRecognizer, AttrRecognizer, {
                    /**
                     * @namespace
                     * @memberof RotateRecognizer
                     */
                    defaults: {
                        event: 'rotate',
                        threshold: 0,
                        pointers: 2
                    },
                    getTouchAction: function () {
                        return [TOUCH_ACTION_NONE];
                    },
                    attrTest: function (input) {
                        return this._super.attrTest.call(this, input) &&
                            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
                    }
                });
                /**
                 * Swipe
                 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
                 * @constructor
                 * @extends AttrRecognizer
                 */
                function SwipeRecognizer() {
                    AttrRecognizer.apply(this, arguments);
                }
                inherit(SwipeRecognizer, AttrRecognizer, {
                    /**
                     * @namespace
                     * @memberof SwipeRecognizer
                     */
                    defaults: {
                        event: 'swipe',
                        threshold: 10,
                        velocity: 0.3,
                        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
                        pointers: 1
                    },
                    getTouchAction: function () {
                        return PanRecognizer.prototype.getTouchAction.call(this);
                    },
                    attrTest: function (input) {
                        var direction = this.options.direction;
                        var velocity;
                        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
                            velocity = input.overallVelocity;
                        }
                        else if (direction & DIRECTION_HORIZONTAL) {
                            velocity = input.overallVelocityX;
                        }
                        else if (direction & DIRECTION_VERTICAL) {
                            velocity = input.overallVelocityY;
                        }
                        return this._super.attrTest.call(this, input) &&
                            direction & input.offsetDirection &&
                            input.distance > this.options.threshold &&
                            input.maxPointers == this.options.pointers &&
                            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
                    },
                    emit: function (input) {
                        var direction = directionStr(input.offsetDirection);
                        if (direction) {
                            this.manager.emit(this.options.event + direction, input);
                        }
                        this.manager.emit(this.options.event, input);
                    }
                });
                /**
                 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
                 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
                 * a single tap.
                 *
                 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
                 * multi-taps being recognized.
                 * @constructor
                 * @extends Recognizer
                 */
                function TapRecognizer() {
                    Recognizer.apply(this, arguments);
                    // previous time and center,
                    // used for tap counting
                    this.pTime = false;
                    this.pCenter = false;
                    this._timer = null;
                    this._input = null;
                    this.count = 0;
                }
                inherit(TapRecognizer, Recognizer, {
                    /**
                     * @namespace
                     * @memberof PinchRecognizer
                     */
                    defaults: {
                        event: 'tap',
                        pointers: 1,
                        taps: 1,
                        interval: 300,
                        time: 250,
                        threshold: 9,
                        posThreshold: 10 // a multi-tap can be a bit off the initial position
                    },
                    getTouchAction: function () {
                        return [TOUCH_ACTION_MANIPULATION];
                    },
                    process: function (input) {
                        var options = this.options;
                        var validPointers = input.pointers.length === options.pointers;
                        var validMovement = input.distance < options.threshold;
                        var validTouchTime = input.deltaTime < options.time;
                        this.reset();
                        if ((input.eventType & INPUT_START) && (this.count === 0)) {
                            return this.failTimeout();
                        }
                        // we only allow little movement
                        // and we've reached an end event, so a tap is possible
                        if (validMovement && validTouchTime && validPointers) {
                            if (input.eventType != INPUT_END) {
                                return this.failTimeout();
                            }
                            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
                            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                            this.pTime = input.timeStamp;
                            this.pCenter = input.center;
                            if (!validMultiTap || !validInterval) {
                                this.count = 1;
                            }
                            else {
                                this.count += 1;
                            }
                            this._input = input;
                            // if tap count matches we have recognized it,
                            // else it has began recognizing...
                            var tapCount = this.count % options.taps;
                            if (tapCount === 0) {
                                // no failing requirements, immediately trigger the tap event
                                // or wait as long as the multitap interval to trigger
                                if (!this.hasRequireFailures()) {
                                    return STATE_RECOGNIZED;
                                }
                                else {
                                    this._timer = setTimeoutContext(function () {
                                        this.state = STATE_RECOGNIZED;
                                        this.tryEmit();
                                    }, options.interval, this);
                                    return STATE_BEGAN;
                                }
                            }
                        }
                        return STATE_FAILED;
                    },
                    failTimeout: function () {
                        this._timer = setTimeoutContext(function () {
                            this.state = STATE_FAILED;
                        }, this.options.interval, this);
                        return STATE_FAILED;
                    },
                    reset: function () {
                        clearTimeout(this._timer);
                    },
                    emit: function () {
                        if (this.state == STATE_RECOGNIZED) {
                            this._input.tapCount = this.count;
                            this.manager.emit(this.options.event, this._input);
                        }
                    }
                });
                /**
                 * Simple way to create a manager with a default set of recognizers.
                 * @param {HTMLElement} element
                 * @param {Object} [options]
                 * @constructor
                 */
                function Hammer(element, options) {
                    options = options || {};
                    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
                    return new Manager(element, options);
                }
                /**
                 * @const {string}
                 */
                Hammer.VERSION = '2.0.7';
                /**
                 * default settings
                 * @namespace
                 */
                Hammer.defaults = {
                    /**
                     * set if DOM events are being triggered.
                     * But this is slower and unused by simple implementations, so disabled by default.
                     * @type {Boolean}
                     * @default false
                     */
                    domEvents: false,
                    /**
                     * The value for the touchAction property/fallback.
                     * When set to `compute` it will magically set the correct value based on the added recognizers.
                     * @type {String}
                     * @default compute
                     */
                    touchAction: TOUCH_ACTION_COMPUTE,
                    /**
                     * @type {Boolean}
                     * @default true
                     */
                    enable: true,
                    /**
                     * EXPERIMENTAL FEATURE -- can be removed/changed
                     * Change the parent input target element.
                     * If Null, then it is being set the to main element.
                     * @type {Null|EventTarget}
                     * @default null
                     */
                    inputTarget: null,
                    /**
                     * force an input class
                     * @type {Null|Function}
                     * @default null
                     */
                    inputClass: null,
                    /**
                     * Default recognizer setup when calling `Hammer()`
                     * When creating a new Manager these will be skipped.
                     * @type {Array}
                     */
                    preset: [
                        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
                        [RotateRecognizer, { enable: false }],
                        [PinchRecognizer, { enable: false }, ['rotate']],
                        [SwipeRecognizer, { direction: DIRECTION_HORIZONTAL }],
                        [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ['swipe']],
                        [TapRecognizer],
                        [TapRecognizer, { event: 'doubletap', taps: 2 }, ['tap']],
                        [PressRecognizer]
                    ],
                    /**
                     * Some CSS properties can be used to improve the working of Hammer.
                     * Add them to this method and they will be set when creating a new Manager.
                     * @namespace
                     */
                    cssProps: {
                        /**
                         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
                         * @type {String}
                         * @default 'none'
                         */
                        userSelect: 'none',
                        /**
                         * Disable the Windows Phone grippers when pressing an element.
                         * @type {String}
                         * @default 'none'
                         */
                        touchSelect: 'none',
                        /**
                         * Disables the default callout shown when you touch and hold a touch target.
                         * On iOS, when you touch and hold a touch target such as a link, Safari displays
                         * a callout containing information about the link. This property allows you to disable that callout.
                         * @type {String}
                         * @default 'none'
                         */
                        touchCallout: 'none',
                        /**
                         * Specifies whether zooming is enabled. Used by IE10>
                         * @type {String}
                         * @default 'none'
                         */
                        contentZooming: 'none',
                        /**
                         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
                         * @type {String}
                         * @default 'none'
                         */
                        userDrag: 'none',
                        /**
                         * Overrides the highlight color shown when the user taps a link or a JavaScript
                         * clickable element in iOS. This property obeys the alpha value, if specified.
                         * @type {String}
                         * @default 'rgba(0,0,0,0)'
                         */
                        tapHighlightColor: 'rgba(0,0,0,0)'
                    }
                };
                var STOP = 1;
                var FORCED_STOP = 2;
                /**
                 * Manager
                 * @param {HTMLElement} element
                 * @param {Object} [options]
                 * @constructor
                 */
                function Manager(element, options) {
                    this.options = assign({}, Hammer.defaults, options || {});
                    this.options.inputTarget = this.options.inputTarget || element;
                    this.handlers = {};
                    this.session = {};
                    this.recognizers = [];
                    this.oldCssProps = {};
                    this.element = element;
                    this.input = createInputInstance(this);
                    this.touchAction = new TouchAction(this, this.options.touchAction);
                    toggleCssProps(this, true);
                    each(this.options.recognizers, function (item) {
                        var recognizer = this.add(new (item[0])(item[1]));
                        item[2] && recognizer.recognizeWith(item[2]);
                        item[3] && recognizer.requireFailure(item[3]);
                    }, this);
                }
                Manager.prototype = {
                    /**
                     * set options
                     * @param {Object} options
                     * @returns {Manager}
                     */
                    set: function (options) {
                        assign(this.options, options);
                        // Options that need a little more setup
                        if (options.touchAction) {
                            this.touchAction.update();
                        }
                        if (options.inputTarget) {
                            // Clean up existing event listeners and reinitialize
                            this.input.destroy();
                            this.input.target = options.inputTarget;
                            this.input.init();
                        }
                        return this;
                    },
                    /**
                     * stop recognizing for this session.
                     * This session will be discarded, when a new [input]start event is fired.
                     * When forced, the recognizer cycle is stopped immediately.
                     * @param {Boolean} [force]
                     */
                    stop: function (force) {
                        this.session.stopped = force ? FORCED_STOP : STOP;
                    },
                    /**
                     * run the recognizers!
                     * called by the inputHandler function on every movement of the pointers (touches)
                     * it walks through all the recognizers and tries to detect the gesture that is being made
                     * @param {Object} inputData
                     */
                    recognize: function (inputData) {
                        var session = this.session;
                        if (session.stopped) {
                            return;
                        }
                        // run the touch-action polyfill
                        this.touchAction.preventDefaults(inputData);
                        var recognizer;
                        var recognizers = this.recognizers;
                        // this holds the recognizer that is being recognized.
                        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
                        // if no recognizer is detecting a thing, it is set to `null`
                        var curRecognizer = session.curRecognizer;
                        // reset when the last recognizer is recognized
                        // or when we're in a new session
                        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
                            curRecognizer = session.curRecognizer = null;
                        }
                        var i = 0;
                        while (i < recognizers.length) {
                            recognizer = recognizers[i];
                            // find out if we are allowed try to recognize the input for this one.
                            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                            //      that is being recognized.
                            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                            //      this can be setup with the `recognizeWith()` method on the recognizer.
                            if (session.stopped !== FORCED_STOP && ( // 1
                            !curRecognizer || recognizer == curRecognizer || // 2
                                recognizer.canRecognizeWith(curRecognizer))) { // 3
                                recognizer.recognize(inputData);
                            }
                            else {
                                recognizer.reset();
                            }
                            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                            // current active recognizer. but only if we don't already have an active recognizer
                            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                                curRecognizer = session.curRecognizer = recognizer;
                            }
                            i++;
                        }
                    },
                    /**
                     * get a recognizer by its event name.
                     * @param {Recognizer|String} recognizer
                     * @returns {Recognizer|Null}
                     */
                    get: function (recognizer) {
                        if (recognizer instanceof Recognizer) {
                            return recognizer;
                        }
                        var recognizers = this.recognizers;
                        for (var i = 0; i < recognizers.length; i++) {
                            if (recognizers[i].options.event == recognizer) {
                                return recognizers[i];
                            }
                        }
                        return null;
                    },
                    /**
                     * add a recognizer to the manager
                     * existing recognizers with the same event name will be removed
                     * @param {Recognizer} recognizer
                     * @returns {Recognizer|Manager}
                     */
                    add: function (recognizer) {
                        if (invokeArrayArg(recognizer, 'add', this)) {
                            return this;
                        }
                        // remove existing
                        var existing = this.get(recognizer.options.event);
                        if (existing) {
                            this.remove(existing);
                        }
                        this.recognizers.push(recognizer);
                        recognizer.manager = this;
                        this.touchAction.update();
                        return recognizer;
                    },
                    /**
                     * remove a recognizer by name or instance
                     * @param {Recognizer|String} recognizer
                     * @returns {Manager}
                     */
                    remove: function (recognizer) {
                        if (invokeArrayArg(recognizer, 'remove', this)) {
                            return this;
                        }
                        recognizer = this.get(recognizer);
                        // let's make sure this recognizer exists
                        if (recognizer) {
                            var recognizers = this.recognizers;
                            var index = inArray(recognizers, recognizer);
                            if (index !== -1) {
                                recognizers.splice(index, 1);
                                this.touchAction.update();
                            }
                        }
                        return this;
                    },
                    /**
                     * bind event
                     * @param {String} events
                     * @param {Function} handler
                     * @returns {EventEmitter} this
                     */
                    on: function (events, handler) {
                        if (events === undefined) {
                            return;
                        }
                        if (handler === undefined) {
                            return;
                        }
                        var handlers = this.handlers;
                        each(splitStr(events), function (event) {
                            handlers[event] = handlers[event] || [];
                            handlers[event].push(handler);
                        });
                        return this;
                    },
                    /**
                     * unbind event, leave emit blank to remove all handlers
                     * @param {String} events
                     * @param {Function} [handler]
                     * @returns {EventEmitter} this
                     */
                    off: function (events, handler) {
                        if (events === undefined) {
                            return;
                        }
                        var handlers = this.handlers;
                        each(splitStr(events), function (event) {
                            if (!handler) {
                                delete handlers[event];
                            }
                            else {
                                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
                            }
                        });
                        return this;
                    },
                    /**
                     * emit event to the listeners
                     * @param {String} event
                     * @param {Object} data
                     */
                    emit: function (event, data) {
                        // we also want to trigger dom events
                        if (this.options.domEvents) {
                            triggerDomEvent(event, data);
                        }
                        // no handlers, so skip it all
                        var handlers = this.handlers[event] && this.handlers[event].slice();
                        if (!handlers || !handlers.length) {
                            return;
                        }
                        data.type = event;
                        data.preventDefault = function () {
                            data.srcEvent.preventDefault();
                        };
                        var i = 0;
                        while (i < handlers.length) {
                            handlers[i](data);
                            i++;
                        }
                    },
                    /**
                     * destroy the manager and unbinds all events
                     * it doesn't unbind dom events, that is the user own responsibility
                     */
                    destroy: function () {
                        this.element && toggleCssProps(this, false);
                        this.handlers = {};
                        this.session = {};
                        this.input.destroy();
                        this.element = null;
                    }
                };
                /**
                 * add/remove the css properties as defined in manager.options.cssProps
                 * @param {Manager} manager
                 * @param {Boolean} add
                 */
                function toggleCssProps(manager, add) {
                    var element = manager.element;
                    if (!element.style) {
                        return;
                    }
                    var prop;
                    each(manager.options.cssProps, function (value, name) {
                        prop = prefixed(element.style, name);
                        if (add) {
                            manager.oldCssProps[prop] = element.style[prop];
                            element.style[prop] = value;
                        }
                        else {
                            element.style[prop] = manager.oldCssProps[prop] || '';
                        }
                    });
                    if (!add) {
                        manager.oldCssProps = {};
                    }
                }
                /**
                 * trigger dom event
                 * @param {String} event
                 * @param {Object} data
                 */
                function triggerDomEvent(event, data) {
                    var gestureEvent = document.createEvent('Event');
                    gestureEvent.initEvent(event, true, true);
                    gestureEvent.gesture = data;
                    data.target.dispatchEvent(gestureEvent);
                }
                assign(Hammer, {
                    INPUT_START: INPUT_START,
                    INPUT_MOVE: INPUT_MOVE,
                    INPUT_END: INPUT_END,
                    INPUT_CANCEL: INPUT_CANCEL,
                    STATE_POSSIBLE: STATE_POSSIBLE,
                    STATE_BEGAN: STATE_BEGAN,
                    STATE_CHANGED: STATE_CHANGED,
                    STATE_ENDED: STATE_ENDED,
                    STATE_RECOGNIZED: STATE_RECOGNIZED,
                    STATE_CANCELLED: STATE_CANCELLED,
                    STATE_FAILED: STATE_FAILED,
                    DIRECTION_NONE: DIRECTION_NONE,
                    DIRECTION_LEFT: DIRECTION_LEFT,
                    DIRECTION_RIGHT: DIRECTION_RIGHT,
                    DIRECTION_UP: DIRECTION_UP,
                    DIRECTION_DOWN: DIRECTION_DOWN,
                    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
                    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
                    DIRECTION_ALL: DIRECTION_ALL,
                    Manager: Manager,
                    Input: Input,
                    TouchAction: TouchAction,
                    TouchInput: TouchInput,
                    MouseInput: MouseInput,
                    PointerEventInput: PointerEventInput,
                    TouchMouseInput: TouchMouseInput,
                    SingleTouchInput: SingleTouchInput,
                    Recognizer: Recognizer,
                    AttrRecognizer: AttrRecognizer,
                    Tap: TapRecognizer,
                    Pan: PanRecognizer,
                    Swipe: SwipeRecognizer,
                    Pinch: PinchRecognizer,
                    Rotate: RotateRecognizer,
                    Press: PressRecognizer,
                    on: addEventListeners,
                    off: removeEventListeners,
                    each: each,
                    merge: merge,
                    extend: extend,
                    assign: assign,
                    inherit: inherit,
                    bindFn: bindFn,
                    prefixed: prefixed
                });
                // this prevents errors when Hammer is loaded in the presence of an AMD
                //  style loader but by script tag, not by the loader.
                var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
                freeGlobal.Hammer = Hammer;
                if (true) {
                    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                        return Hammer;
                    }).call(exports, __webpack_require__, exports, module),
                        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                }
                else { }
            })(window, document, 'Hammer');
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/index.js": 
        /*!*********************************************!*\
          !*** ./node_modules/rxjs/_esm2015/index.js ***!
          \*********************************************/
        /*! exports provided: Observable, ConnectableObservable, GroupedObservable, observable, Subject, BehaviorSubject, ReplaySubject, AsyncSubject, asapScheduler, asyncScheduler, queueScheduler, animationFrameScheduler, VirtualTimeScheduler, VirtualAction, Scheduler, Subscription, Subscriber, Notification, NotificationKind, pipe, noop, identity, isObservable, ArgumentOutOfRangeError, EmptyError, ObjectUnsubscribedError, UnsubscriptionError, TimeoutError, bindCallback, bindNodeCallback, combineLatest, concat, defer, empty, forkJoin, from, fromEvent, fromEventPattern, generate, iif, interval, merge, never, of, onErrorResumeNext, pairs, partition, race, range, throwError, timer, using, zip, scheduled, EMPTY, NEVER, config */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _internal_Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./internal/Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Observable", function () { return _internal_Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]; });
            /* harmony import */ var _internal_observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./internal/observable/ConnectableObservable */ "./node_modules/rxjs/_esm2015/internal/observable/ConnectableObservable.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConnectableObservable", function () { return _internal_observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_1__["ConnectableObservable"]; });
            /* harmony import */ var _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./internal/operators/groupBy */ "./node_modules/rxjs/_esm2015/internal/operators/groupBy.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GroupedObservable", function () { return _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_2__["GroupedObservable"]; });
            /* harmony import */ var _internal_symbol_observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./internal/symbol/observable */ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "observable", function () { return _internal_symbol_observable__WEBPACK_IMPORTED_MODULE_3__["observable"]; });
            /* harmony import */ var _internal_Subject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./internal/Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subject", function () { return _internal_Subject__WEBPACK_IMPORTED_MODULE_4__["Subject"]; });
            /* harmony import */ var _internal_BehaviorSubject__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./internal/BehaviorSubject */ "./node_modules/rxjs/_esm2015/internal/BehaviorSubject.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BehaviorSubject", function () { return _internal_BehaviorSubject__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"]; });
            /* harmony import */ var _internal_ReplaySubject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./internal/ReplaySubject */ "./node_modules/rxjs/_esm2015/internal/ReplaySubject.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReplaySubject", function () { return _internal_ReplaySubject__WEBPACK_IMPORTED_MODULE_6__["ReplaySubject"]; });
            /* harmony import */ var _internal_AsyncSubject__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./internal/AsyncSubject */ "./node_modules/rxjs/_esm2015/internal/AsyncSubject.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncSubject", function () { return _internal_AsyncSubject__WEBPACK_IMPORTED_MODULE_7__["AsyncSubject"]; });
            /* harmony import */ var _internal_scheduler_asap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./internal/scheduler/asap */ "./node_modules/rxjs/_esm2015/internal/scheduler/asap.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "asapScheduler", function () { return _internal_scheduler_asap__WEBPACK_IMPORTED_MODULE_8__["asap"]; });
            /* harmony import */ var _internal_scheduler_async__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./internal/scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "asyncScheduler", function () { return _internal_scheduler_async__WEBPACK_IMPORTED_MODULE_9__["async"]; });
            /* harmony import */ var _internal_scheduler_queue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./internal/scheduler/queue */ "./node_modules/rxjs/_esm2015/internal/scheduler/queue.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "queueScheduler", function () { return _internal_scheduler_queue__WEBPACK_IMPORTED_MODULE_10__["queue"]; });
            /* harmony import */ var _internal_scheduler_animationFrame__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./internal/scheduler/animationFrame */ "./node_modules/rxjs/_esm2015/internal/scheduler/animationFrame.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "animationFrameScheduler", function () { return _internal_scheduler_animationFrame__WEBPACK_IMPORTED_MODULE_11__["animationFrame"]; });
            /* harmony import */ var _internal_scheduler_VirtualTimeScheduler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./internal/scheduler/VirtualTimeScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/VirtualTimeScheduler.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VirtualTimeScheduler", function () { return _internal_scheduler_VirtualTimeScheduler__WEBPACK_IMPORTED_MODULE_12__["VirtualTimeScheduler"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VirtualAction", function () { return _internal_scheduler_VirtualTimeScheduler__WEBPACK_IMPORTED_MODULE_12__["VirtualAction"]; });
            /* harmony import */ var _internal_Scheduler__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./internal/Scheduler */ "./node_modules/rxjs/_esm2015/internal/Scheduler.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function () { return _internal_Scheduler__WEBPACK_IMPORTED_MODULE_13__["Scheduler"]; });
            /* harmony import */ var _internal_Subscription__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./internal/Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subscription", function () { return _internal_Subscription__WEBPACK_IMPORTED_MODULE_14__["Subscription"]; });
            /* harmony import */ var _internal_Subscriber__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./internal/Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subscriber", function () { return _internal_Subscriber__WEBPACK_IMPORTED_MODULE_15__["Subscriber"]; });
            /* harmony import */ var _internal_Notification__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./internal/Notification */ "./node_modules/rxjs/_esm2015/internal/Notification.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notification", function () { return _internal_Notification__WEBPACK_IMPORTED_MODULE_16__["Notification"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NotificationKind", function () { return _internal_Notification__WEBPACK_IMPORTED_MODULE_16__["NotificationKind"]; });
            /* harmony import */ var _internal_util_pipe__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./internal/util/pipe */ "./node_modules/rxjs/_esm2015/internal/util/pipe.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pipe", function () { return _internal_util_pipe__WEBPACK_IMPORTED_MODULE_17__["pipe"]; });
            /* harmony import */ var _internal_util_noop__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./internal/util/noop */ "./node_modules/rxjs/_esm2015/internal/util/noop.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "noop", function () { return _internal_util_noop__WEBPACK_IMPORTED_MODULE_18__["noop"]; });
            /* harmony import */ var _internal_util_identity__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./internal/util/identity */ "./node_modules/rxjs/_esm2015/internal/util/identity.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "identity", function () { return _internal_util_identity__WEBPACK_IMPORTED_MODULE_19__["identity"]; });
            /* harmony import */ var _internal_util_isObservable__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./internal/util/isObservable */ "./node_modules/rxjs/_esm2015/internal/util/isObservable.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isObservable", function () { return _internal_util_isObservable__WEBPACK_IMPORTED_MODULE_20__["isObservable"]; });
            /* harmony import */ var _internal_util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./internal/util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArgumentOutOfRangeError", function () { return _internal_util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_21__["ArgumentOutOfRangeError"]; });
            /* harmony import */ var _internal_util_EmptyError__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./internal/util/EmptyError */ "./node_modules/rxjs/_esm2015/internal/util/EmptyError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmptyError", function () { return _internal_util_EmptyError__WEBPACK_IMPORTED_MODULE_22__["EmptyError"]; });
            /* harmony import */ var _internal_util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./internal/util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm2015/internal/util/ObjectUnsubscribedError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectUnsubscribedError", function () { return _internal_util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_23__["ObjectUnsubscribedError"]; });
            /* harmony import */ var _internal_util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./internal/util/UnsubscriptionError */ "./node_modules/rxjs/_esm2015/internal/util/UnsubscriptionError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsubscriptionError", function () { return _internal_util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_24__["UnsubscriptionError"]; });
            /* harmony import */ var _internal_util_TimeoutError__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./internal/util/TimeoutError */ "./node_modules/rxjs/_esm2015/internal/util/TimeoutError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function () { return _internal_util_TimeoutError__WEBPACK_IMPORTED_MODULE_25__["TimeoutError"]; });
            /* harmony import */ var _internal_observable_bindCallback__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./internal/observable/bindCallback */ "./node_modules/rxjs/_esm2015/internal/observable/bindCallback.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bindCallback", function () { return _internal_observable_bindCallback__WEBPACK_IMPORTED_MODULE_26__["bindCallback"]; });
            /* harmony import */ var _internal_observable_bindNodeCallback__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./internal/observable/bindNodeCallback */ "./node_modules/rxjs/_esm2015/internal/observable/bindNodeCallback.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bindNodeCallback", function () { return _internal_observable_bindNodeCallback__WEBPACK_IMPORTED_MODULE_27__["bindNodeCallback"]; });
            /* harmony import */ var _internal_observable_combineLatest__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./internal/observable/combineLatest */ "./node_modules/rxjs/_esm2015/internal/observable/combineLatest.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function () { return _internal_observable_combineLatest__WEBPACK_IMPORTED_MODULE_28__["combineLatest"]; });
            /* harmony import */ var _internal_observable_concat__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./internal/observable/concat */ "./node_modules/rxjs/_esm2015/internal/observable/concat.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concat", function () { return _internal_observable_concat__WEBPACK_IMPORTED_MODULE_29__["concat"]; });
            /* harmony import */ var _internal_observable_defer__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./internal/observable/defer */ "./node_modules/rxjs/_esm2015/internal/observable/defer.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defer", function () { return _internal_observable_defer__WEBPACK_IMPORTED_MODULE_30__["defer"]; });
            /* harmony import */ var _internal_observable_empty__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./internal/observable/empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "empty", function () { return _internal_observable_empty__WEBPACK_IMPORTED_MODULE_31__["empty"]; });
            /* harmony import */ var _internal_observable_forkJoin__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./internal/observable/forkJoin */ "./node_modules/rxjs/_esm2015/internal/observable/forkJoin.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "forkJoin", function () { return _internal_observable_forkJoin__WEBPACK_IMPORTED_MODULE_32__["forkJoin"]; });
            /* harmony import */ var _internal_observable_from__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./internal/observable/from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "from", function () { return _internal_observable_from__WEBPACK_IMPORTED_MODULE_33__["from"]; });
            /* harmony import */ var _internal_observable_fromEvent__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./internal/observable/fromEvent */ "./node_modules/rxjs/_esm2015/internal/observable/fromEvent.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromEvent", function () { return _internal_observable_fromEvent__WEBPACK_IMPORTED_MODULE_34__["fromEvent"]; });
            /* harmony import */ var _internal_observable_fromEventPattern__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./internal/observable/fromEventPattern */ "./node_modules/rxjs/_esm2015/internal/observable/fromEventPattern.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromEventPattern", function () { return _internal_observable_fromEventPattern__WEBPACK_IMPORTED_MODULE_35__["fromEventPattern"]; });
            /* harmony import */ var _internal_observable_generate__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./internal/observable/generate */ "./node_modules/rxjs/_esm2015/internal/observable/generate.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "generate", function () { return _internal_observable_generate__WEBPACK_IMPORTED_MODULE_36__["generate"]; });
            /* harmony import */ var _internal_observable_iif__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./internal/observable/iif */ "./node_modules/rxjs/_esm2015/internal/observable/iif.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "iif", function () { return _internal_observable_iif__WEBPACK_IMPORTED_MODULE_37__["iif"]; });
            /* harmony import */ var _internal_observable_interval__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./internal/observable/interval */ "./node_modules/rxjs/_esm2015/internal/observable/interval.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interval", function () { return _internal_observable_interval__WEBPACK_IMPORTED_MODULE_38__["interval"]; });
            /* harmony import */ var _internal_observable_merge__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./internal/observable/merge */ "./node_modules/rxjs/_esm2015/internal/observable/merge.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "merge", function () { return _internal_observable_merge__WEBPACK_IMPORTED_MODULE_39__["merge"]; });
            /* harmony import */ var _internal_observable_never__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./internal/observable/never */ "./node_modules/rxjs/_esm2015/internal/observable/never.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "never", function () { return _internal_observable_never__WEBPACK_IMPORTED_MODULE_40__["never"]; });
            /* harmony import */ var _internal_observable_of__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./internal/observable/of */ "./node_modules/rxjs/_esm2015/internal/observable/of.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "of", function () { return _internal_observable_of__WEBPACK_IMPORTED_MODULE_41__["of"]; });
            /* harmony import */ var _internal_observable_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./internal/observable/onErrorResumeNext */ "./node_modules/rxjs/_esm2015/internal/observable/onErrorResumeNext.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function () { return _internal_observable_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_42__["onErrorResumeNext"]; });
            /* harmony import */ var _internal_observable_pairs__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./internal/observable/pairs */ "./node_modules/rxjs/_esm2015/internal/observable/pairs.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pairs", function () { return _internal_observable_pairs__WEBPACK_IMPORTED_MODULE_43__["pairs"]; });
            /* harmony import */ var _internal_observable_partition__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./internal/observable/partition */ "./node_modules/rxjs/_esm2015/internal/observable/partition.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "partition", function () { return _internal_observable_partition__WEBPACK_IMPORTED_MODULE_44__["partition"]; });
            /* harmony import */ var _internal_observable_race__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./internal/observable/race */ "./node_modules/rxjs/_esm2015/internal/observable/race.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "race", function () { return _internal_observable_race__WEBPACK_IMPORTED_MODULE_45__["race"]; });
            /* harmony import */ var _internal_observable_range__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./internal/observable/range */ "./node_modules/rxjs/_esm2015/internal/observable/range.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "range", function () { return _internal_observable_range__WEBPACK_IMPORTED_MODULE_46__["range"]; });
            /* harmony import */ var _internal_observable_throwError__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./internal/observable/throwError */ "./node_modules/rxjs/_esm2015/internal/observable/throwError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwError", function () { return _internal_observable_throwError__WEBPACK_IMPORTED_MODULE_47__["throwError"]; });
            /* harmony import */ var _internal_observable_timer__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./internal/observable/timer */ "./node_modules/rxjs/_esm2015/internal/observable/timer.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timer", function () { return _internal_observable_timer__WEBPACK_IMPORTED_MODULE_48__["timer"]; });
            /* harmony import */ var _internal_observable_using__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./internal/observable/using */ "./node_modules/rxjs/_esm2015/internal/observable/using.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "using", function () { return _internal_observable_using__WEBPACK_IMPORTED_MODULE_49__["using"]; });
            /* harmony import */ var _internal_observable_zip__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./internal/observable/zip */ "./node_modules/rxjs/_esm2015/internal/observable/zip.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "zip", function () { return _internal_observable_zip__WEBPACK_IMPORTED_MODULE_50__["zip"]; });
            /* harmony import */ var _internal_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./internal/scheduled/scheduled */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduled.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "scheduled", function () { return _internal_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_51__["scheduled"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EMPTY", function () { return _internal_observable_empty__WEBPACK_IMPORTED_MODULE_31__["EMPTY"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NEVER", function () { return _internal_observable_never__WEBPACK_IMPORTED_MODULE_40__["NEVER"]; });
            /* harmony import */ var _internal_config__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./internal/config */ "./node_modules/rxjs/_esm2015/internal/config.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "config", function () { return _internal_config__WEBPACK_IMPORTED_MODULE_52__["config"]; });
            //# sourceMappingURL=index.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/AsyncSubject.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/AsyncSubject.js ***!
          \*************************************************************/
        /*! exports provided: AsyncSubject */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncSubject", function () { return AsyncSubject; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            var AsyncSubject = /** @class */ (function (_super_1) {
                __extends(AsyncSubject, _super_1);
                function AsyncSubject() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this.value = null;
                    _this.hasNext = false;
                    _this.hasCompleted = false;
                    return _this;
                }
                AsyncSubject.prototype._subscribe = function (subscriber) {
                    if (this.hasError) {
                        subscriber.error(this.thrownError);
                        return _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    }
                    else if (this.hasCompleted && this.hasNext) {
                        subscriber.next(this.value);
                        subscriber.complete();
                        return _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"].EMPTY;
                    }
                    return _super_1.prototype._subscribe.call(this, subscriber);
                };
                AsyncSubject.prototype.next = function (value) {
                    if (!this.hasCompleted) {
                        this.value = value;
                        this.hasNext = true;
                    }
                };
                AsyncSubject.prototype.error = function (error) {
                    if (!this.hasCompleted) {
                        _super_1.prototype.error.call(this, error);
                    }
                };
                AsyncSubject.prototype.complete = function () {
                    this.hasCompleted = true;
                    if (this.hasNext) {
                        _super_1.prototype.next.call(this, this.value);
                    }
                    _super_1.prototype.complete.call(this);
                };
                return AsyncSubject;
            }(_Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]));
            //# sourceMappingURL=AsyncSubject.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/BehaviorSubject.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/BehaviorSubject.js ***!
          \****************************************************************/
        /*! exports provided: BehaviorSubject */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BehaviorSubject", function () { return BehaviorSubject; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm2015/internal/util/ObjectUnsubscribedError.js");
            var BehaviorSubject = /** @class */ (function (_super_1) {
                __extends(BehaviorSubject, _super_1);
                function BehaviorSubject(_value) {
                    var _this = _super_1.call(this) || this;
                    _this._value = _value;
                    return _this;
                }
                Object.defineProperty(BehaviorSubject.prototype, "value", {
                    get: function () {
                        return this.getValue();
                    },
                    enumerable: true,
                    configurable: true
                });
                BehaviorSubject.prototype._subscribe = function (subscriber) {
                    var subscription = _super_1.prototype._subscribe.call(this, subscriber);
                    if (subscription && !subscription.closed) {
                        subscriber.next(this._value);
                    }
                    return subscription;
                };
                BehaviorSubject.prototype.getValue = function () {
                    if (this.hasError) {
                        throw this.thrownError;
                    }
                    else if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_1__["ObjectUnsubscribedError"]();
                    }
                    else {
                        return this._value;
                    }
                };
                BehaviorSubject.prototype.next = function (value) {
                    _super_1.prototype.next.call(this, this._value = value);
                };
                return BehaviorSubject;
            }(_Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]));
            //# sourceMappingURL=BehaviorSubject.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js ***!
          \****************************************************************/
        /*! exports provided: InnerSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InnerSubscriber", function () { return InnerSubscriber; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            var InnerSubscriber = /** @class */ (function (_super_1) {
                __extends(InnerSubscriber, _super_1);
                function InnerSubscriber(parent, outerValue, outerIndex) {
                    var _this = _super_1.call(this) || this;
                    _this.parent = parent;
                    _this.outerValue = outerValue;
                    _this.outerIndex = outerIndex;
                    _this.index = 0;
                    return _this;
                }
                InnerSubscriber.prototype._next = function (value) {
                    this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
                };
                InnerSubscriber.prototype._error = function (error) {
                    this.parent.notifyError(error, this);
                    this.unsubscribe();
                };
                InnerSubscriber.prototype._complete = function () {
                    this.parent.notifyComplete(this);
                    this.unsubscribe();
                };
                return InnerSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=InnerSubscriber.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Notification.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Notification.js ***!
          \*************************************************************/
        /*! exports provided: NotificationKind, Notification */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationKind", function () { return NotificationKind; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Notification", function () { return Notification; });
            /* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./observable/empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            /* harmony import */ var _observable_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./observable/of */ "./node_modules/rxjs/_esm2015/internal/observable/of.js");
            /* harmony import */ var _observable_throwError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./observable/throwError */ "./node_modules/rxjs/_esm2015/internal/observable/throwError.js");
            var NotificationKind;
            (function (NotificationKind) {
                NotificationKind["NEXT"] = "N";
                NotificationKind["ERROR"] = "E";
                NotificationKind["COMPLETE"] = "C";
            })(NotificationKind || (NotificationKind = {}));
            var Notification = /** @class */ (function () {
                function Notification(kind, value, error) {
                    this.kind = kind;
                    this.value = value;
                    this.error = error;
                    this.hasValue = kind === 'N';
                }
                Notification.prototype.observe = function (observer) {
                    switch (this.kind) {
                        case 'N':
                            return observer.next && observer.next(this.value);
                        case 'E':
                            return observer.error && observer.error(this.error);
                        case 'C':
                            return observer.complete && observer.complete();
                    }
                };
                Notification.prototype.do = function (next, error, complete) {
                    var kind = this.kind;
                    switch (kind) {
                        case 'N':
                            return next && next(this.value);
                        case 'E':
                            return error && error(this.error);
                        case 'C':
                            return complete && complete();
                    }
                };
                Notification.prototype.accept = function (nextOrObserver, error, complete) {
                    if (nextOrObserver && typeof nextOrObserver.next === 'function') {
                        return this.observe(nextOrObserver);
                    }
                    else {
                        return this.do(nextOrObserver, error, complete);
                    }
                };
                Notification.prototype.toObservable = function () {
                    var kind = this.kind;
                    switch (kind) {
                        case 'N':
                            return Object(_observable_of__WEBPACK_IMPORTED_MODULE_1__["of"])(this.value);
                        case 'E':
                            return Object(_observable_throwError__WEBPACK_IMPORTED_MODULE_2__["throwError"])(this.error);
                        case 'C':
                            return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_0__["empty"])();
                    }
                    throw new Error('unexpected notification kind value');
                };
                Notification.createNext = function (value) {
                    if (typeof value !== 'undefined') {
                        return new Notification('N', value);
                    }
                    return Notification.undefinedValueNotification;
                };
                Notification.createError = function (err) {
                    return new Notification('E', undefined, err);
                };
                Notification.createComplete = function () {
                    return Notification.completeNotification;
                };
                return Notification;
            }());
            Notification.completeNotification = new Notification('C');
            Notification.undefinedValueNotification = new Notification('N', undefined);
            //# sourceMappingURL=Notification.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Observable.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Observable.js ***!
          \***********************************************************/
        /*! exports provided: Observable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function () { return Observable; });
            /* harmony import */ var _util_canReportError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/canReportError */ "./node_modules/rxjs/_esm2015/internal/util/canReportError.js");
            /* harmony import */ var _util_toSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/toSubscriber */ "./node_modules/rxjs/_esm2015/internal/util/toSubscriber.js");
            /* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./symbol/observable */ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js");
            /* harmony import */ var _util_pipe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/pipe */ "./node_modules/rxjs/_esm2015/internal/util/pipe.js");
            /* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./config */ "./node_modules/rxjs/_esm2015/internal/config.js");
            var Observable = /** @class */ (function () {
                function Observable(subscribe) {
                    this._isScalar = false;
                    if (subscribe) {
                        this._subscribe = subscribe;
                    }
                }
                Observable.prototype.lift = function (operator) {
                    var observable = new Observable();
                    observable.source = this;
                    observable.operator = operator;
                    return observable;
                };
                Observable.prototype.subscribe = function (observerOrNext, error, complete) {
                    var operator = this.operator;
                    var sink = Object(_util_toSubscriber__WEBPACK_IMPORTED_MODULE_1__["toSubscriber"])(observerOrNext, error, complete);
                    if (operator) {
                        sink.add(operator.call(sink, this.source));
                    }
                    else {
                        sink.add(this.source || (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                            this._subscribe(sink) :
                            this._trySubscribe(sink));
                    }
                    if (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
                        if (sink.syncErrorThrowable) {
                            sink.syncErrorThrowable = false;
                            if (sink.syncErrorThrown) {
                                throw sink.syncErrorValue;
                            }
                        }
                    }
                    return sink;
                };
                Observable.prototype._trySubscribe = function (sink) {
                    try {
                        return this._subscribe(sink);
                    }
                    catch (err) {
                        if (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
                            sink.syncErrorThrown = true;
                            sink.syncErrorValue = err;
                        }
                        if (Object(_util_canReportError__WEBPACK_IMPORTED_MODULE_0__["canReportError"])(sink)) {
                            sink.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                };
                Observable.prototype.forEach = function (next, promiseCtor) {
                    var _this = this;
                    promiseCtor = getPromiseCtor(promiseCtor);
                    return new promiseCtor(function (resolve, reject) {
                        var subscription;
                        subscription = _this.subscribe(function (value) {
                            try {
                                next(value);
                            }
                            catch (err) {
                                reject(err);
                                if (subscription) {
                                    subscription.unsubscribe();
                                }
                            }
                        }, reject, resolve);
                    });
                };
                Observable.prototype._subscribe = function (subscriber) {
                    var source = this.source;
                    return source && source.subscribe(subscriber);
                };
                Observable.prototype[_symbol_observable__WEBPACK_IMPORTED_MODULE_2__["observable"]] = function () {
                    return this;
                };
                Observable.prototype.pipe = function () {
                    var operations = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        operations[_c] = arguments[_c];
                    }
                    if (operations.length === 0) {
                        return this;
                    }
                    return Object(_util_pipe__WEBPACK_IMPORTED_MODULE_3__["pipeFromArray"])(operations)(this);
                };
                Observable.prototype.toPromise = function (promiseCtor) {
                    var _this = this;
                    promiseCtor = getPromiseCtor(promiseCtor);
                    return new promiseCtor(function (resolve, reject) {
                        var value;
                        _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
                    });
                };
                return Observable;
            }());
            Observable.create = function (subscribe) {
                return new Observable(subscribe);
            };
            function getPromiseCtor(promiseCtor) {
                if (!promiseCtor) {
                    promiseCtor = _config__WEBPACK_IMPORTED_MODULE_4__["config"].Promise || Promise;
                }
                if (!promiseCtor) {
                    throw new Error('no Promise impl found');
                }
                return promiseCtor;
            }
            //# sourceMappingURL=Observable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Observer.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Observer.js ***!
          \*********************************************************/
        /*! exports provided: empty */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function () { return empty; });
            /* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./config */ "./node_modules/rxjs/_esm2015/internal/config.js");
            /* harmony import */ var _util_hostReportError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/hostReportError */ "./node_modules/rxjs/_esm2015/internal/util/hostReportError.js");
            var empty = {
                closed: true,
                next: function (value) { },
                error: function (err) {
                    if (_config__WEBPACK_IMPORTED_MODULE_0__["config"].useDeprecatedSynchronousErrorHandling) {
                        throw err;
                    }
                    else {
                        Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_1__["hostReportError"])(err);
                    }
                },
                complete: function () { }
            };
            //# sourceMappingURL=Observer.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js ***!
          \****************************************************************/
        /*! exports provided: OuterSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OuterSubscriber", function () { return OuterSubscriber; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            var OuterSubscriber = /** @class */ (function (_super_1) {
                __extends(OuterSubscriber, _super_1);
                function OuterSubscriber() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.destination.next(innerValue);
                };
                OuterSubscriber.prototype.notifyError = function (error, innerSub) {
                    this.destination.error(error);
                };
                OuterSubscriber.prototype.notifyComplete = function (innerSub) {
                    this.destination.complete();
                };
                return OuterSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=OuterSubscriber.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/ReplaySubject.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/ReplaySubject.js ***!
          \**************************************************************/
        /*! exports provided: ReplaySubject */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaySubject", function () { return ReplaySubject; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _scheduler_queue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scheduler/queue */ "./node_modules/rxjs/_esm2015/internal/scheduler/queue.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _operators_observeOn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./operators/observeOn */ "./node_modules/rxjs/_esm2015/internal/operators/observeOn.js");
            /* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm2015/internal/util/ObjectUnsubscribedError.js");
            /* harmony import */ var _SubjectSubscription__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SubjectSubscription */ "./node_modules/rxjs/_esm2015/internal/SubjectSubscription.js");
            var ReplaySubject = /** @class */ (function (_super_1) {
                __extends(ReplaySubject, _super_1);
                function ReplaySubject(bufferSize, windowTime, scheduler) {
                    if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
                    if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
                    var _this = _super_1.call(this) || this;
                    _this.scheduler = scheduler;
                    _this._events = [];
                    _this._infiniteTimeWindow = false;
                    _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
                    _this._windowTime = windowTime < 1 ? 1 : windowTime;
                    if (windowTime === Number.POSITIVE_INFINITY) {
                        _this._infiniteTimeWindow = true;
                        _this.next = _this.nextInfiniteTimeWindow;
                    }
                    else {
                        _this.next = _this.nextTimeWindow;
                    }
                    return _this;
                }
                ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
                    var _events = this._events;
                    _events.push(value);
                    if (_events.length > this._bufferSize) {
                        _events.shift();
                    }
                    _super_1.prototype.next.call(this, value);
                };
                ReplaySubject.prototype.nextTimeWindow = function (value) {
                    this._events.push(new ReplayEvent(this._getNow(), value));
                    this._trimBufferThenGetEvents();
                    _super_1.prototype.next.call(this, value);
                };
                ReplaySubject.prototype._subscribe = function (subscriber) {
                    var _infiniteTimeWindow = this._infiniteTimeWindow;
                    var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
                    var scheduler = this.scheduler;
                    var len = _events.length;
                    var subscription;
                    if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__["ObjectUnsubscribedError"]();
                    }
                    else if (this.isStopped || this.hasError) {
                        subscription = _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    }
                    else {
                        this.observers.push(subscriber);
                        subscription = new _SubjectSubscription__WEBPACK_IMPORTED_MODULE_5__["SubjectSubscription"](this, subscriber);
                    }
                    if (scheduler) {
                        subscriber.add(subscriber = new _operators_observeOn__WEBPACK_IMPORTED_MODULE_3__["ObserveOnSubscriber"](subscriber, scheduler));
                    }
                    if (_infiniteTimeWindow) {
                        for (var i = 0; i < len && !subscriber.closed; i++) {
                            subscriber.next(_events[i]);
                        }
                    }
                    else {
                        for (var i = 0; i < len && !subscriber.closed; i++) {
                            subscriber.next(_events[i].value);
                        }
                    }
                    if (this.hasError) {
                        subscriber.error(this.thrownError);
                    }
                    else if (this.isStopped) {
                        subscriber.complete();
                    }
                    return subscription;
                };
                ReplaySubject.prototype._getNow = function () {
                    return (this.scheduler || _scheduler_queue__WEBPACK_IMPORTED_MODULE_1__["queue"]).now();
                };
                ReplaySubject.prototype._trimBufferThenGetEvents = function () {
                    var now = this._getNow();
                    var _bufferSize = this._bufferSize;
                    var _windowTime = this._windowTime;
                    var _events = this._events;
                    var eventsCount = _events.length;
                    var spliceCount = 0;
                    while (spliceCount < eventsCount) {
                        if ((now - _events[spliceCount].time) < _windowTime) {
                            break;
                        }
                        spliceCount++;
                    }
                    if (eventsCount > _bufferSize) {
                        spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
                    }
                    if (spliceCount > 0) {
                        _events.splice(0, spliceCount);
                    }
                    return _events;
                };
                return ReplaySubject;
            }(_Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]));
            var ReplayEvent = /** @class */ (function () {
                function ReplayEvent(time, value) {
                    this.time = time;
                    this.value = value;
                }
                return ReplayEvent;
            }());
            //# sourceMappingURL=ReplaySubject.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Scheduler.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Scheduler.js ***!
          \**********************************************************/
        /*! exports provided: Scheduler */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function () { return Scheduler; });
            var Scheduler = /** @class */ (function () {
                function Scheduler(SchedulerAction, now) {
                    if (now === void 0) { now = Scheduler.now; }
                    this.SchedulerAction = SchedulerAction;
                    this.now = now;
                }
                Scheduler.prototype.schedule = function (work, delay, state) {
                    if (delay === void 0) { delay = 0; }
                    return new this.SchedulerAction(this, work).schedule(state, delay);
                };
                return Scheduler;
            }());
            Scheduler.now = function () { return Date.now(); };
            //# sourceMappingURL=Scheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Subject.js": 
        /*!********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Subject.js ***!
          \********************************************************/
        /*! exports provided: SubjectSubscriber, Subject, AnonymousSubject */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectSubscriber", function () { return SubjectSubscriber; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subject", function () { return Subject; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnonymousSubject", function () { return AnonymousSubject; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm2015/internal/util/ObjectUnsubscribedError.js");
            /* harmony import */ var _SubjectSubscription__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./SubjectSubscription */ "./node_modules/rxjs/_esm2015/internal/SubjectSubscription.js");
            /* harmony import */ var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../internal/symbol/rxSubscriber */ "./node_modules/rxjs/_esm2015/internal/symbol/rxSubscriber.js");
            var SubjectSubscriber = /** @class */ (function (_super_1) {
                __extends(SubjectSubscriber, _super_1);
                function SubjectSubscriber(destination) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.destination = destination;
                    return _this;
                }
                return SubjectSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
            var Subject = /** @class */ (function (_super_1) {
                __extends(Subject, _super_1);
                function Subject() {
                    var _this = _super_1.call(this) || this;
                    _this.observers = [];
                    _this.closed = false;
                    _this.isStopped = false;
                    _this.hasError = false;
                    _this.thrownError = null;
                    return _this;
                }
                Subject.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_5__["rxSubscriber"]] = function () {
                    return new SubjectSubscriber(this);
                };
                Subject.prototype.lift = function (operator) {
                    var subject = new AnonymousSubject(this, this);
                    subject.operator = operator;
                    return subject;
                };
                Subject.prototype.next = function (value) {
                    if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_3__["ObjectUnsubscribedError"]();
                    }
                    if (!this.isStopped) {
                        var observers = this.observers;
                        var len = observers.length;
                        var copy = observers.slice();
                        for (var i = 0; i < len; i++) {
                            copy[i].next(value);
                        }
                    }
                };
                Subject.prototype.error = function (err) {
                    if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_3__["ObjectUnsubscribedError"]();
                    }
                    this.hasError = true;
                    this.thrownError = err;
                    this.isStopped = true;
                    var observers = this.observers;
                    var len = observers.length;
                    var copy = observers.slice();
                    for (var i = 0; i < len; i++) {
                        copy[i].error(err);
                    }
                    this.observers.length = 0;
                };
                Subject.prototype.complete = function () {
                    if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_3__["ObjectUnsubscribedError"]();
                    }
                    this.isStopped = true;
                    var observers = this.observers;
                    var len = observers.length;
                    var copy = observers.slice();
                    for (var i = 0; i < len; i++) {
                        copy[i].complete();
                    }
                    this.observers.length = 0;
                };
                Subject.prototype.unsubscribe = function () {
                    this.isStopped = true;
                    this.closed = true;
                    this.observers = null;
                };
                Subject.prototype._trySubscribe = function (subscriber) {
                    if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_3__["ObjectUnsubscribedError"]();
                    }
                    else {
                        return _super_1.prototype._trySubscribe.call(this, subscriber);
                    }
                };
                Subject.prototype._subscribe = function (subscriber) {
                    if (this.closed) {
                        throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_3__["ObjectUnsubscribedError"]();
                    }
                    else if (this.hasError) {
                        subscriber.error(this.thrownError);
                        return _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    }
                    else if (this.isStopped) {
                        subscriber.complete();
                        return _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    }
                    else {
                        this.observers.push(subscriber);
                        return new _SubjectSubscription__WEBPACK_IMPORTED_MODULE_4__["SubjectSubscription"](this, subscriber);
                    }
                };
                Subject.prototype.asObservable = function () {
                    var observable = new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]();
                    observable.source = this;
                    return observable;
                };
                return Subject;
            }(_Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]));
            Subject.create = function (destination, source) {
                return new AnonymousSubject(destination, source);
            };
            var AnonymousSubject = /** @class */ (function (_super_1) {
                __extends(AnonymousSubject, _super_1);
                function AnonymousSubject(destination, source) {
                    var _this = _super_1.call(this) || this;
                    _this.destination = destination;
                    _this.source = source;
                    return _this;
                }
                AnonymousSubject.prototype.next = function (value) {
                    var destination = this.destination;
                    if (destination && destination.next) {
                        destination.next(value);
                    }
                };
                AnonymousSubject.prototype.error = function (err) {
                    var destination = this.destination;
                    if (destination && destination.error) {
                        this.destination.error(err);
                    }
                };
                AnonymousSubject.prototype.complete = function () {
                    var destination = this.destination;
                    if (destination && destination.complete) {
                        this.destination.complete();
                    }
                };
                AnonymousSubject.prototype._subscribe = function (subscriber) {
                    var source = this.source;
                    if (source) {
                        return this.source.subscribe(subscriber);
                    }
                    else {
                        return _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
                    }
                };
                return AnonymousSubject;
            }(Subject));
            //# sourceMappingURL=Subject.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/SubjectSubscription.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/SubjectSubscription.js ***!
          \********************************************************************/
        /*! exports provided: SubjectSubscription */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectSubscription", function () { return SubjectSubscription; });
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            var SubjectSubscription = /** @class */ (function (_super_1) {
                __extends(SubjectSubscription, _super_1);
                function SubjectSubscription(subject, subscriber) {
                    var _this = _super_1.call(this) || this;
                    _this.subject = subject;
                    _this.subscriber = subscriber;
                    _this.closed = false;
                    return _this;
                }
                SubjectSubscription.prototype.unsubscribe = function () {
                    if (this.closed) {
                        return;
                    }
                    this.closed = true;
                    var subject = this.subject;
                    var observers = subject.observers;
                    this.subject = null;
                    if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
                        return;
                    }
                    var subscriberIndex = observers.indexOf(this.subscriber);
                    if (subscriberIndex !== -1) {
                        observers.splice(subscriberIndex, 1);
                    }
                };
                return SubjectSubscription;
            }(_Subscription__WEBPACK_IMPORTED_MODULE_0__["Subscription"]));
            //# sourceMappingURL=SubjectSubscription.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Subscriber.js": 
        /*!***********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Subscriber.js ***!
          \***********************************************************/
        /*! exports provided: Subscriber, SafeSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subscriber", function () { return Subscriber; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SafeSubscriber", function () { return SafeSubscriber; });
            /* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/isFunction */ "./node_modules/rxjs/_esm2015/internal/util/isFunction.js");
            /* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Observer */ "./node_modules/rxjs/_esm2015/internal/Observer.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../internal/symbol/rxSubscriber */ "./node_modules/rxjs/_esm2015/internal/symbol/rxSubscriber.js");
            /* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./config */ "./node_modules/rxjs/_esm2015/internal/config.js");
            /* harmony import */ var _util_hostReportError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/hostReportError */ "./node_modules/rxjs/_esm2015/internal/util/hostReportError.js");
            var Subscriber = /** @class */ (function (_super_1) {
                __extends(Subscriber, _super_1);
                function Subscriber(destinationOrNext, error, complete) {
                    var _this = _super_1.call(this) || this;
                    _this.syncErrorValue = null;
                    _this.syncErrorThrown = false;
                    _this.syncErrorThrowable = false;
                    _this.isStopped = false;
                    switch (arguments.length) {
                        case 0:
                            _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_1__["empty"];
                            break;
                        case 1:
                            if (!destinationOrNext) {
                                _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_1__["empty"];
                                break;
                            }
                            if (typeof destinationOrNext === 'object') {
                                if (destinationOrNext instanceof Subscriber) {
                                    _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                                    _this.destination = destinationOrNext;
                                    destinationOrNext.add(_this);
                                }
                                else {
                                    _this.syncErrorThrowable = true;
                                    _this.destination = new SafeSubscriber(_this, destinationOrNext);
                                }
                                break;
                            }
                        default:
                            _this.syncErrorThrowable = true;
                            _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                            break;
                    }
                    return _this;
                }
                Subscriber.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_3__["rxSubscriber"]] = function () { return this; };
                Subscriber.create = function (next, error, complete) {
                    var subscriber = new Subscriber(next, error, complete);
                    subscriber.syncErrorThrowable = false;
                    return subscriber;
                };
                Subscriber.prototype.next = function (value) {
                    if (!this.isStopped) {
                        this._next(value);
                    }
                };
                Subscriber.prototype.error = function (err) {
                    if (!this.isStopped) {
                        this.isStopped = true;
                        this._error(err);
                    }
                };
                Subscriber.prototype.complete = function () {
                    if (!this.isStopped) {
                        this.isStopped = true;
                        this._complete();
                    }
                };
                Subscriber.prototype.unsubscribe = function () {
                    if (this.closed) {
                        return;
                    }
                    this.isStopped = true;
                    _super_1.prototype.unsubscribe.call(this);
                };
                Subscriber.prototype._next = function (value) {
                    this.destination.next(value);
                };
                Subscriber.prototype._error = function (err) {
                    this.destination.error(err);
                    this.unsubscribe();
                };
                Subscriber.prototype._complete = function () {
                    this.destination.complete();
                    this.unsubscribe();
                };
                Subscriber.prototype._unsubscribeAndRecycle = function () {
                    var _parentOrParents = this._parentOrParents;
                    this._parentOrParents = null;
                    this.unsubscribe();
                    this.closed = false;
                    this.isStopped = false;
                    this._parentOrParents = _parentOrParents;
                    return this;
                };
                return Subscriber;
            }(_Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"]));
            var SafeSubscriber = /** @class */ (function (_super_1) {
                __extends(SafeSubscriber, _super_1);
                function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
                    var _this = _super_1.call(this) || this;
                    _this._parentSubscriber = _parentSubscriber;
                    var next;
                    var context = _this;
                    if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_0__["isFunction"])(observerOrNext)) {
                        next = observerOrNext;
                    }
                    else if (observerOrNext) {
                        next = observerOrNext.next;
                        error = observerOrNext.error;
                        complete = observerOrNext.complete;
                        if (observerOrNext !== _Observer__WEBPACK_IMPORTED_MODULE_1__["empty"]) {
                            context = Object.create(observerOrNext);
                            if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_0__["isFunction"])(context.unsubscribe)) {
                                _this.add(context.unsubscribe.bind(context));
                            }
                            context.unsubscribe = _this.unsubscribe.bind(_this);
                        }
                    }
                    _this._context = context;
                    _this._next = next;
                    _this._error = error;
                    _this._complete = complete;
                    return _this;
                }
                SafeSubscriber.prototype.next = function (value) {
                    if (!this.isStopped && this._next) {
                        var _parentSubscriber = this._parentSubscriber;
                        if (!_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                            this.__tryOrUnsub(this._next, value);
                        }
                        else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                            this.unsubscribe();
                        }
                    }
                };
                SafeSubscriber.prototype.error = function (err) {
                    if (!this.isStopped) {
                        var _parentSubscriber = this._parentSubscriber;
                        var useDeprecatedSynchronousErrorHandling = _config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling;
                        if (this._error) {
                            if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                                this.__tryOrUnsub(this._error, err);
                                this.unsubscribe();
                            }
                            else {
                                this.__tryOrSetError(_parentSubscriber, this._error, err);
                                this.unsubscribe();
                            }
                        }
                        else if (!_parentSubscriber.syncErrorThrowable) {
                            this.unsubscribe();
                            if (useDeprecatedSynchronousErrorHandling) {
                                throw err;
                            }
                            Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_5__["hostReportError"])(err);
                        }
                        else {
                            if (useDeprecatedSynchronousErrorHandling) {
                                _parentSubscriber.syncErrorValue = err;
                                _parentSubscriber.syncErrorThrown = true;
                            }
                            else {
                                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_5__["hostReportError"])(err);
                            }
                            this.unsubscribe();
                        }
                    }
                };
                SafeSubscriber.prototype.complete = function () {
                    var _this = this;
                    if (!this.isStopped) {
                        var _parentSubscriber = this._parentSubscriber;
                        if (this._complete) {
                            var wrappedComplete = function () { return _this._complete.call(_this._context); };
                            if (!_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                                this.__tryOrUnsub(wrappedComplete);
                                this.unsubscribe();
                            }
                            else {
                                this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                                this.unsubscribe();
                            }
                        }
                        else {
                            this.unsubscribe();
                        }
                    }
                };
                SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
                    try {
                        fn.call(this._context, value);
                    }
                    catch (err) {
                        this.unsubscribe();
                        if (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
                            throw err;
                        }
                        else {
                            Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_5__["hostReportError"])(err);
                        }
                    }
                };
                SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
                    if (!_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
                        throw new Error('bad call');
                    }
                    try {
                        fn.call(this._context, value);
                    }
                    catch (err) {
                        if (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
                            parent.syncErrorValue = err;
                            parent.syncErrorThrown = true;
                            return true;
                        }
                        else {
                            Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_5__["hostReportError"])(err);
                            return true;
                        }
                    }
                    return false;
                };
                SafeSubscriber.prototype._unsubscribe = function () {
                    var _parentSubscriber = this._parentSubscriber;
                    this._context = null;
                    this._parentSubscriber = null;
                    _parentSubscriber.unsubscribe();
                };
                return SafeSubscriber;
            }(Subscriber));
            //# sourceMappingURL=Subscriber.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/Subscription.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/Subscription.js ***!
          \*************************************************************/
        /*! exports provided: Subscription */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subscription", function () { return Subscription; });
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _util_isObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/isObject */ "./node_modules/rxjs/_esm2015/internal/util/isObject.js");
            /* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/isFunction */ "./node_modules/rxjs/_esm2015/internal/util/isFunction.js");
            /* harmony import */ var _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/UnsubscriptionError */ "./node_modules/rxjs/_esm2015/internal/util/UnsubscriptionError.js");
            var Subscription = /** @class */ (function () {
                function Subscription(unsubscribe) {
                    this.closed = false;
                    this._parentOrParents = null;
                    this._subscriptions = null;
                    if (unsubscribe) {
                        this._unsubscribe = unsubscribe;
                    }
                }
                Subscription.prototype.unsubscribe = function () {
                    var errors;
                    if (this.closed) {
                        return;
                    }
                    var _c = this, _parentOrParents = _c._parentOrParents, _unsubscribe = _c._unsubscribe, _subscriptions = _c._subscriptions;
                    this.closed = true;
                    this._parentOrParents = null;
                    this._subscriptions = null;
                    if (_parentOrParents instanceof Subscription) {
                        _parentOrParents.remove(this);
                    }
                    else if (_parentOrParents !== null) {
                        for (var index = 0; index < _parentOrParents.length; ++index) {
                            var parent = _parentOrParents[index];
                            parent.remove(this);
                        }
                    }
                    if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(_unsubscribe)) {
                        try {
                            _unsubscribe.call(this);
                        }
                        catch (e) {
                            errors = e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"] ? flattenUnsubscriptionErrors(e.errors) : [e];
                        }
                    }
                    if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(_subscriptions)) {
                        var index = -1;
                        var len = _subscriptions.length;
                        while (++index < len) {
                            var sub = _subscriptions[index];
                            if (Object(_util_isObject__WEBPACK_IMPORTED_MODULE_1__["isObject"])(sub)) {
                                try {
                                    sub.unsubscribe();
                                }
                                catch (e) {
                                    errors = errors || [];
                                    if (e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"]) {
                                        errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                                    }
                                    else {
                                        errors.push(e);
                                    }
                                }
                            }
                        }
                    }
                    if (errors) {
                        throw new _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"](errors);
                    }
                };
                Subscription.prototype.add = function (teardown) {
                    var subscription = teardown;
                    if (!teardown) {
                        return Subscription.EMPTY;
                    }
                    switch (typeof teardown) {
                        case 'function':
                            subscription = new Subscription(teardown);
                        case 'object':
                            if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                                return subscription;
                            }
                            else if (this.closed) {
                                subscription.unsubscribe();
                                return subscription;
                            }
                            else if (!(subscription instanceof Subscription)) {
                                var tmp = subscription;
                                subscription = new Subscription();
                                subscription._subscriptions = [tmp];
                            }
                            break;
                        default: {
                            throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
                        }
                    }
                    var _parentOrParents = subscription._parentOrParents;
                    if (_parentOrParents === null) {
                        subscription._parentOrParents = this;
                    }
                    else if (_parentOrParents instanceof Subscription) {
                        if (_parentOrParents === this) {
                            return subscription;
                        }
                        subscription._parentOrParents = [_parentOrParents, this];
                    }
                    else if (_parentOrParents.indexOf(this) === -1) {
                        _parentOrParents.push(this);
                    }
                    else {
                        return subscription;
                    }
                    var subscriptions = this._subscriptions;
                    if (subscriptions === null) {
                        this._subscriptions = [subscription];
                    }
                    else {
                        subscriptions.push(subscription);
                    }
                    return subscription;
                };
                Subscription.prototype.remove = function (subscription) {
                    var subscriptions = this._subscriptions;
                    if (subscriptions) {
                        var subscriptionIndex = subscriptions.indexOf(subscription);
                        if (subscriptionIndex !== -1) {
                            subscriptions.splice(subscriptionIndex, 1);
                        }
                    }
                };
                return Subscription;
            }());
            Subscription.EMPTY = (function (empty) {
                empty.closed = true;
                return empty;
            }(new Subscription()));
            function flattenUnsubscriptionErrors(errors) {
                return errors.reduce(function (errs, err) { return errs.concat((err instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"]) ? err.errors : err); }, []);
            }
            //# sourceMappingURL=Subscription.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/config.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/config.js ***!
          \*******************************************************/
        /*! exports provided: config */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function () { return config; });
            var _enable_super_gross_mode_that_will_cause_bad_things = false;
            var config = {
                Promise: undefined,
                set useDeprecatedSynchronousErrorHandling(value) {
                    if (value) {
                        var error = new Error();
                        console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
                    }
                    else if (_enable_super_gross_mode_that_will_cause_bad_things) {
                        console.log('RxJS: Back to a better error behavior. Thank you. <3');
                    }
                    _enable_super_gross_mode_that_will_cause_bad_things = value;
                },
                get useDeprecatedSynchronousErrorHandling() {
                    return _enable_super_gross_mode_that_will_cause_bad_things;
                },
            };
            //# sourceMappingURL=config.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/ConnectableObservable.js": 
        /*!*********************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/ConnectableObservable.js ***!
          \*********************************************************************************/
        /*! exports provided: ConnectableObservable, connectableObservableDescriptor */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectableObservable", function () { return ConnectableObservable; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectableObservableDescriptor", function () { return connectableObservableDescriptor; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _operators_refCount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../operators/refCount */ "./node_modules/rxjs/_esm2015/internal/operators/refCount.js");
            var ConnectableObservable = /** @class */ (function (_super_1) {
                __extends(ConnectableObservable, _super_1);
                function ConnectableObservable(source, subjectFactory) {
                    var _this = _super_1.call(this) || this;
                    _this.source = source;
                    _this.subjectFactory = subjectFactory;
                    _this._refCount = 0;
                    _this._isComplete = false;
                    return _this;
                }
                ConnectableObservable.prototype._subscribe = function (subscriber) {
                    return this.getSubject().subscribe(subscriber);
                };
                ConnectableObservable.prototype.getSubject = function () {
                    var subject = this._subject;
                    if (!subject || subject.isStopped) {
                        this._subject = this.subjectFactory();
                    }
                    return this._subject;
                };
                ConnectableObservable.prototype.connect = function () {
                    var connection = this._connection;
                    if (!connection) {
                        this._isComplete = false;
                        connection = this._connection = new _Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"]();
                        connection.add(this.source
                            .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
                        if (connection.closed) {
                            this._connection = null;
                            connection = _Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"].EMPTY;
                        }
                    }
                    return connection;
                };
                ConnectableObservable.prototype.refCount = function () {
                    return Object(_operators_refCount__WEBPACK_IMPORTED_MODULE_4__["refCount"])()(this);
                };
                return ConnectableObservable;
            }(_Observable__WEBPACK_IMPORTED_MODULE_1__["Observable"]));
            var connectableObservableDescriptor = (function () {
                var connectableProto = ConnectableObservable.prototype;
                return {
                    operator: { value: null },
                    _refCount: { value: 0, writable: true },
                    _subject: { value: null, writable: true },
                    _connection: { value: null, writable: true },
                    _subscribe: { value: connectableProto._subscribe },
                    _isComplete: { value: connectableProto._isComplete, writable: true },
                    getSubject: { value: connectableProto.getSubject },
                    connect: { value: connectableProto.connect },
                    refCount: { value: connectableProto.refCount }
                };
            })();
            var ConnectableSubscriber = /** @class */ (function (_super_1) {
                __extends(ConnectableSubscriber, _super_1);
                function ConnectableSubscriber(destination, connectable) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.connectable = connectable;
                    return _this;
                }
                ConnectableSubscriber.prototype._error = function (err) {
                    this._unsubscribe();
                    _super_1.prototype._error.call(this, err);
                };
                ConnectableSubscriber.prototype._complete = function () {
                    this.connectable._isComplete = true;
                    this._unsubscribe();
                    _super_1.prototype._complete.call(this);
                };
                ConnectableSubscriber.prototype._unsubscribe = function () {
                    var connectable = this.connectable;
                    if (connectable) {
                        this.connectable = null;
                        var connection = connectable._connection;
                        connectable._refCount = 0;
                        connectable._subject = null;
                        connectable._connection = null;
                        if (connection) {
                            connection.unsubscribe();
                        }
                    }
                };
                return ConnectableSubscriber;
            }(_Subject__WEBPACK_IMPORTED_MODULE_0__["SubjectSubscriber"]));
            var RefCountOperator = /** @class */ (function () {
                function RefCountOperator(connectable) {
                    this.connectable = connectable;
                }
                RefCountOperator.prototype.call = function (subscriber, source) {
                    var connectable = this.connectable;
                    connectable._refCount++;
                    var refCounter = new RefCountSubscriber(subscriber, connectable);
                    var subscription = source.subscribe(refCounter);
                    if (!refCounter.closed) {
                        refCounter.connection = connectable.connect();
                    }
                    return subscription;
                };
                return RefCountOperator;
            }());
            var RefCountSubscriber = /** @class */ (function (_super_1) {
                __extends(RefCountSubscriber, _super_1);
                function RefCountSubscriber(destination, connectable) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.connectable = connectable;
                    return _this;
                }
                RefCountSubscriber.prototype._unsubscribe = function () {
                    var connectable = this.connectable;
                    if (!connectable) {
                        this.connection = null;
                        return;
                    }
                    this.connectable = null;
                    var refCount = connectable._refCount;
                    if (refCount <= 0) {
                        this.connection = null;
                        return;
                    }
                    connectable._refCount = refCount - 1;
                    if (refCount > 1) {
                        this.connection = null;
                        return;
                    }
                    var connection = this.connection;
                    var sharedConnection = connectable._connection;
                    this.connection = null;
                    if (sharedConnection && (!connection || sharedConnection === connection)) {
                        sharedConnection.unsubscribe();
                    }
                };
                return RefCountSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));
            //# sourceMappingURL=ConnectableObservable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/SubscribeOnObservable.js": 
        /*!*********************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/SubscribeOnObservable.js ***!
          \*********************************************************************************/
        /*! exports provided: SubscribeOnObservable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscribeOnObservable", function () { return SubscribeOnObservable; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _scheduler_asap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/asap */ "./node_modules/rxjs/_esm2015/internal/scheduler/asap.js");
            /* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm2015/internal/util/isNumeric.js");
            var SubscribeOnObservable = /** @class */ (function (_super_1) {
                __extends(SubscribeOnObservable, _super_1);
                function SubscribeOnObservable(source, delayTime, scheduler) {
                    if (delayTime === void 0) { delayTime = 0; }
                    if (scheduler === void 0) { scheduler = _scheduler_asap__WEBPACK_IMPORTED_MODULE_1__["asap"]; }
                    var _this = _super_1.call(this) || this;
                    _this.source = source;
                    _this.delayTime = delayTime;
                    _this.scheduler = scheduler;
                    if (!Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(delayTime) || delayTime < 0) {
                        _this.delayTime = 0;
                    }
                    if (!scheduler || typeof scheduler.schedule !== 'function') {
                        _this.scheduler = _scheduler_asap__WEBPACK_IMPORTED_MODULE_1__["asap"];
                    }
                    return _this;
                }
                SubscribeOnObservable.create = function (source, delay, scheduler) {
                    if (delay === void 0) { delay = 0; }
                    if (scheduler === void 0) { scheduler = _scheduler_asap__WEBPACK_IMPORTED_MODULE_1__["asap"]; }
                    return new SubscribeOnObservable(source, delay, scheduler);
                };
                SubscribeOnObservable.dispatch = function (arg) {
                    var source = arg.source, subscriber = arg.subscriber;
                    return this.add(source.subscribe(subscriber));
                };
                SubscribeOnObservable.prototype._subscribe = function (subscriber) {
                    var delay = this.delayTime;
                    var source = this.source;
                    var scheduler = this.scheduler;
                    return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
                        source: source, subscriber: subscriber
                    });
                };
                return SubscribeOnObservable;
            }(_Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]));
            //# sourceMappingURL=SubscribeOnObservable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/bindCallback.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/bindCallback.js ***!
          \************************************************************************/
        /*! exports provided: bindCallback */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindCallback", function () { return bindCallback; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../AsyncSubject */ "./node_modules/rxjs/_esm2015/internal/AsyncSubject.js");
            /* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony import */ var _util_canReportError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/canReportError */ "./node_modules/rxjs/_esm2015/internal/util/canReportError.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            function bindCallback(callbackFunc, resultSelector, scheduler) {
                if (resultSelector) {
                    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_5__["isScheduler"])(resultSelector)) {
                        scheduler = resultSelector;
                    }
                    else {
                        return function () {
                            var args = [];
                            for (var _c = 0; _c < arguments.length; _c++) {
                                args[_c] = arguments[_c];
                            }
                            return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_2__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_4__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
                        };
                    }
                }
                return function () {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    var context = this;
                    var subject;
                    var params = {
                        context: context,
                        subject: subject,
                        callbackFunc: callbackFunc,
                        scheduler: scheduler,
                    };
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                        if (!scheduler) {
                            if (!subject) {
                                subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
                                var handler = function () {
                                    var innerArgs = [];
                                    for (var _c = 0; _c < arguments.length; _c++) {
                                        innerArgs[_c] = arguments[_c];
                                    }
                                    subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                                    subject.complete();
                                };
                                try {
                                    callbackFunc.apply(context, args.concat([handler]));
                                }
                                catch (err) {
                                    if (Object(_util_canReportError__WEBPACK_IMPORTED_MODULE_3__["canReportError"])(subject)) {
                                        subject.error(err);
                                    }
                                    else {
                                        console.warn(err);
                                    }
                                }
                            }
                            return subject.subscribe(subscriber);
                        }
                        else {
                            var state = {
                                args: args, subscriber: subscriber, params: params,
                            };
                            return scheduler.schedule(dispatch, 0, state);
                        }
                    });
                };
            }
            function dispatch(state) {
                var _this = this;
                var self = this;
                var args = state.args, subscriber = state.subscriber, params = state.params;
                var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
                var subject = params.subject;
                if (!subject) {
                    subject = params.subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            innerArgs[_c] = arguments[_c];
                        }
                        var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                        _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        subject.error(err);
                    }
                }
                this.add(subject.subscribe(subscriber));
            }
            function dispatchNext(state) {
                var value = state.value, subject = state.subject;
                subject.next(value);
                subject.complete();
            }
            function dispatchError(state) {
                var err = state.err, subject = state.subject;
                subject.error(err);
            }
            //# sourceMappingURL=bindCallback.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/bindNodeCallback.js": 
        /*!****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/bindNodeCallback.js ***!
          \****************************************************************************/
        /*! exports provided: bindNodeCallback */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindNodeCallback", function () { return bindNodeCallback; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../AsyncSubject */ "./node_modules/rxjs/_esm2015/internal/AsyncSubject.js");
            /* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony import */ var _util_canReportError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/canReportError */ "./node_modules/rxjs/_esm2015/internal/util/canReportError.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
                if (resultSelector) {
                    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_4__["isScheduler"])(resultSelector)) {
                        scheduler = resultSelector;
                    }
                    else {
                        return function () {
                            var args = [];
                            for (var _c = 0; _c < arguments.length; _c++) {
                                args[_c] = arguments[_c];
                            }
                            return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_2__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_5__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
                        };
                    }
                }
                return function () {
                    var args = [];
                    for (var _c = 0; _c < arguments.length; _c++) {
                        args[_c] = arguments[_c];
                    }
                    var params = {
                        subject: undefined,
                        args: args,
                        callbackFunc: callbackFunc,
                        scheduler: scheduler,
                        context: this,
                    };
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                        var context = params.context;
                        var subject = params.subject;
                        if (!scheduler) {
                            if (!subject) {
                                subject = params.subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
                                var handler = function () {
                                    var innerArgs = [];
                                    for (var _c = 0; _c < arguments.length; _c++) {
                                        innerArgs[_c] = arguments[_c];
                                    }
                                    var err = innerArgs.shift();
                                    if (err) {
                                        subject.error(err);
                                        return;
                                    }
                                    subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                                    subject.complete();
                                };
                                try {
                                    callbackFunc.apply(context, args.concat([handler]));
                                }
                                catch (err) {
                                    if (Object(_util_canReportError__WEBPACK_IMPORTED_MODULE_3__["canReportError"])(subject)) {
                                        subject.error(err);
                                    }
                                    else {
                                        console.warn(err);
                                    }
                                }
                            }
                            return subject.subscribe(subscriber);
                        }
                        else {
                            return scheduler.schedule(dispatch, 0, { params: params, subscriber: subscriber, context: context });
                        }
                    });
                };
            }
            function dispatch(state) {
                var _this = this;
                var params = state.params, subscriber = state.subscriber, context = state.context;
                var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
                var subject = params.subject;
                if (!subject) {
                    subject = params.subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            innerArgs[_c] = arguments[_c];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
                        }
                        else {
                            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                        }
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
                    }
                }
                this.add(subject.subscribe(subscriber));
            }
            function dispatchNext(arg) {
                var value = arg.value, subject = arg.subject;
                subject.next(value);
                subject.complete();
            }
            function dispatchError(arg) {
                var err = arg.err, subject = arg.subject;
                subject.error(err);
            }
            //# sourceMappingURL=bindNodeCallback.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/combineLatest.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/combineLatest.js ***!
          \*************************************************************************/
        /*! exports provided: combineLatest, CombineLatestOperator, CombineLatestSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function () { return combineLatest; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CombineLatestOperator", function () { return CombineLatestOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CombineLatestSubscriber", function () { return CombineLatestSubscriber; });
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm2015/internal/observable/fromArray.js");
            var NONE = {};
            function combineLatest() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                var resultSelector = null;
                var scheduler = null;
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_0__["isScheduler"])(observables[observables.length - 1])) {
                    scheduler = observables.pop();
                }
                if (typeof observables[observables.length - 1] === 'function') {
                    resultSelector = observables.pop();
                }
                if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(observables[0])) {
                    observables = observables[0];
                }
                return Object(_fromArray__WEBPACK_IMPORTED_MODULE_4__["fromArray"])(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
            }
            var CombineLatestOperator = /** @class */ (function () {
                function CombineLatestOperator(resultSelector) {
                    this.resultSelector = resultSelector;
                }
                CombineLatestOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
                };
                return CombineLatestOperator;
            }());
            var CombineLatestSubscriber = /** @class */ (function (_super_1) {
                __extends(CombineLatestSubscriber, _super_1);
                function CombineLatestSubscriber(destination, resultSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.resultSelector = resultSelector;
                    _this.active = 0;
                    _this.values = [];
                    _this.observables = [];
                    return _this;
                }
                CombineLatestSubscriber.prototype._next = function (observable) {
                    this.values.push(NONE);
                    this.observables.push(observable);
                };
                CombineLatestSubscriber.prototype._complete = function () {
                    var observables = this.observables;
                    var len = observables.length;
                    if (len === 0) {
                        this.destination.complete();
                    }
                    else {
                        this.active = len;
                        this.toRespond = len;
                        for (var i = 0; i < len; i++) {
                            var observable = observables[i];
                            this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(this, observable, observable, i));
                        }
                    }
                };
                CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
                    if ((this.active -= 1) === 0) {
                        this.destination.complete();
                    }
                };
                CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    var values = this.values;
                    var oldVal = values[outerIndex];
                    var toRespond = !this.toRespond
                        ? 0
                        : oldVal === NONE ? --this.toRespond : this.toRespond;
                    values[outerIndex] = innerValue;
                    if (toRespond === 0) {
                        if (this.resultSelector) {
                            this._tryResultSelector(values);
                        }
                        else {
                            this.destination.next(values.slice());
                        }
                    }
                };
                CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
                    var result;
                    try {
                        result = this.resultSelector.apply(this, values);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.destination.next(result);
                };
                return CombineLatestSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            //# sourceMappingURL=combineLatest.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/concat.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/concat.js ***!
          \******************************************************************/
        /*! exports provided: concat */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function () { return concat; });
            /* harmony import */ var _of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./of */ "./node_modules/rxjs/_esm2015/internal/observable/of.js");
            /* harmony import */ var _operators_concatAll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../operators/concatAll */ "./node_modules/rxjs/_esm2015/internal/operators/concatAll.js");
            function concat() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                return Object(_operators_concatAll__WEBPACK_IMPORTED_MODULE_1__["concatAll"])()(Object(_of__WEBPACK_IMPORTED_MODULE_0__["of"]).apply(void 0, observables));
            }
            //# sourceMappingURL=concat.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/defer.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/defer.js ***!
          \*****************************************************************/
        /*! exports provided: defer */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function () { return defer; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            /* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function defer(observableFactory) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var input;
                    try {
                        input = observableFactory();
                    }
                    catch (err) {
                        subscriber.error(err);
                        return undefined;
                    }
                    var source = input ? Object(_from__WEBPACK_IMPORTED_MODULE_1__["from"])(input) : Object(_empty__WEBPACK_IMPORTED_MODULE_2__["empty"])();
                    return source.subscribe(subscriber);
                });
            }
            //# sourceMappingURL=defer.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/empty.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/empty.js ***!
          \*****************************************************************/
        /*! exports provided: EMPTY, empty */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY", function () { return EMPTY; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function () { return empty; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            var EMPTY = new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return subscriber.complete(); });
            function empty(scheduler) {
                return scheduler ? emptyScheduled(scheduler) : EMPTY;
            }
            function emptyScheduled(scheduler) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
            }
            //# sourceMappingURL=empty.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/forkJoin.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/forkJoin.js ***!
          \********************************************************************/
        /*! exports provided: forkJoin */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forkJoin", function () { return forkJoin; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony import */ var _util_isObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isObject */ "./node_modules/rxjs/_esm2015/internal/util/isObject.js");
            /* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            function forkJoin() {
                var sources = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    sources[_c] = arguments[_c];
                }
                if (sources.length === 1) {
                    var first_1 = sources[0];
                    if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(first_1)) {
                        return forkJoinInternal(first_1, null);
                    }
                    if (Object(_util_isObject__WEBPACK_IMPORTED_MODULE_3__["isObject"])(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
                        var keys = Object.keys(first_1);
                        return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
                    }
                }
                if (typeof sources[sources.length - 1] === 'function') {
                    var resultSelector_1 = sources.pop();
                    sources = (sources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(sources[0])) ? sources[0] : sources;
                    return forkJoinInternal(sources, null).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_2__["map"])(function (args) { return resultSelector_1.apply(void 0, args); }));
                }
                return forkJoinInternal(sources, null);
            }
            function forkJoinInternal(sources, keys) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var len = sources.length;
                    if (len === 0) {
                        subscriber.complete();
                        return;
                    }
                    var values = new Array(len);
                    var completed = 0;
                    var emitted = 0;
                    var _loop_10 = function (i) {
                        var source = Object(_from__WEBPACK_IMPORTED_MODULE_4__["from"])(sources[i]);
                        var hasValue = false;
                        subscriber.add(source.subscribe({
                            next: function (value) {
                                if (!hasValue) {
                                    hasValue = true;
                                    emitted++;
                                }
                                values[i] = value;
                            },
                            error: function (err) { return subscriber.error(err); },
                            complete: function () {
                                completed++;
                                if (completed === len || !hasValue) {
                                    if (emitted === len) {
                                        subscriber.next(keys ?
                                            keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                            values);
                                    }
                                    subscriber.complete();
                                }
                            }
                        }));
                    };
                    for (var i = 0; i < len; i++) {
                        _loop_10(i);
                    }
                });
            }
            //# sourceMappingURL=forkJoin.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/from.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/from.js ***!
          \****************************************************************/
        /*! exports provided: from */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "from", function () { return from; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeTo */ "./node_modules/rxjs/_esm2015/internal/util/subscribeTo.js");
            /* harmony import */ var _scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduled */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduled.js");
            function from(input, scheduler) {
                if (!scheduler) {
                    if (input instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]) {
                        return input;
                    }
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(input));
                }
                else {
                    return Object(_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__["scheduled"])(input, scheduler);
                }
            }
            //# sourceMappingURL=from.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/fromArray.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/fromArray.js ***!
          \*********************************************************************/
        /*! exports provided: fromArray */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromArray", function () { return fromArray; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_subscribeToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToArray */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToArray.js");
            /* harmony import */ var _scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduleArray */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleArray.js");
            function fromArray(input, scheduler) {
                if (!scheduler) {
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](Object(_util_subscribeToArray__WEBPACK_IMPORTED_MODULE_1__["subscribeToArray"])(input));
                }
                else {
                    return Object(_scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__["scheduleArray"])(input, scheduler);
                }
            }
            //# sourceMappingURL=fromArray.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/fromEvent.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/fromEvent.js ***!
          \*********************************************************************/
        /*! exports provided: fromEvent */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromEvent", function () { return fromEvent; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isFunction */ "./node_modules/rxjs/_esm2015/internal/util/isFunction.js");
            /* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            var toString = (function () { return Object.prototype.toString; })();
            function fromEvent(target, eventName, options, resultSelector) {
                if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(options)) {
                    resultSelector = options;
                    options = undefined;
                }
                if (resultSelector) {
                    return fromEvent(target, eventName, options).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    function handler(e) {
                        if (arguments.length > 1) {
                            subscriber.next(Array.prototype.slice.call(arguments));
                        }
                        else {
                            subscriber.next(e);
                        }
                    }
                    setupSubscription(target, eventName, handler, subscriber, options);
                });
            }
            function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
                var unsubscribe;
                if (isEventTarget(sourceObj)) {
                    var source_1 = sourceObj;
                    sourceObj.addEventListener(eventName, handler, options);
                    unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
                }
                else if (isJQueryStyleEventEmitter(sourceObj)) {
                    var source_2 = sourceObj;
                    sourceObj.on(eventName, handler);
                    unsubscribe = function () { return source_2.off(eventName, handler); };
                }
                else if (isNodeStyleEventEmitter(sourceObj)) {
                    var source_3 = sourceObj;
                    sourceObj.addListener(eventName, handler);
                    unsubscribe = function () { return source_3.removeListener(eventName, handler); };
                }
                else if (sourceObj && sourceObj.length) {
                    for (var i = 0, len = sourceObj.length; i < len; i++) {
                        setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
                    }
                }
                else {
                    throw new TypeError('Invalid event target');
                }
                subscriber.add(unsubscribe);
            }
            function isNodeStyleEventEmitter(sourceObj) {
                return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
            }
            function isJQueryStyleEventEmitter(sourceObj) {
                return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
            }
            function isEventTarget(sourceObj) {
                return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
            }
            //# sourceMappingURL=fromEvent.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/fromEventPattern.js": 
        /*!****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/fromEventPattern.js ***!
          \****************************************************************************/
        /*! exports provided: fromEventPattern */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromEventPattern", function () { return fromEventPattern; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isFunction */ "./node_modules/rxjs/_esm2015/internal/util/isFunction.js");
            /* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            function fromEventPattern(addHandler, removeHandler, resultSelector) {
                if (resultSelector) {
                    return fromEventPattern(addHandler, removeHandler).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var handler = function () {
                        var e = [];
                        for (var _c = 0; _c < arguments.length; _c++) {
                            e[_c] = arguments[_c];
                        }
                        return subscriber.next(e.length === 1 ? e[0] : e);
                    };
                    var retValue;
                    try {
                        retValue = addHandler(handler);
                    }
                    catch (err) {
                        subscriber.error(err);
                        return undefined;
                    }
                    if (!Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(removeHandler)) {
                        return undefined;
                    }
                    return function () { return removeHandler(handler, retValue); };
                });
            }
            //# sourceMappingURL=fromEventPattern.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/generate.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/generate.js ***!
          \********************************************************************/
        /*! exports provided: generate */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generate", function () { return generate; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm2015/internal/util/identity.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
                var resultSelector;
                var initialState;
                if (arguments.length == 1) {
                    var options = initialStateOrOptions;
                    initialState = options.initialState;
                    condition = options.condition;
                    iterate = options.iterate;
                    resultSelector = options.resultSelector || _util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"];
                    scheduler = options.scheduler;
                }
                else if (resultSelectorOrObservable === undefined || Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_2__["isScheduler"])(resultSelectorOrObservable)) {
                    initialState = initialStateOrOptions;
                    resultSelector = _util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"];
                    scheduler = resultSelectorOrObservable;
                }
                else {
                    initialState = initialStateOrOptions;
                    resultSelector = resultSelectorOrObservable;
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var state = initialState;
                    if (scheduler) {
                        return scheduler.schedule(dispatch, 0, {
                            subscriber: subscriber,
                            iterate: iterate,
                            condition: condition,
                            resultSelector: resultSelector,
                            state: state
                        });
                    }
                    do {
                        if (condition) {
                            var conditionResult = void 0;
                            try {
                                conditionResult = condition(state);
                            }
                            catch (err) {
                                subscriber.error(err);
                                return undefined;
                            }
                            if (!conditionResult) {
                                subscriber.complete();
                                break;
                            }
                        }
                        var value = void 0;
                        try {
                            value = resultSelector(state);
                        }
                        catch (err) {
                            subscriber.error(err);
                            return undefined;
                        }
                        subscriber.next(value);
                        if (subscriber.closed) {
                            break;
                        }
                        try {
                            state = iterate(state);
                        }
                        catch (err) {
                            subscriber.error(err);
                            return undefined;
                        }
                    } while (true);
                    return undefined;
                });
            }
            function dispatch(state) {
                var subscriber = state.subscriber, condition = state.condition;
                if (subscriber.closed) {
                    return undefined;
                }
                if (state.needIterate) {
                    try {
                        state.state = state.iterate(state.state);
                    }
                    catch (err) {
                        subscriber.error(err);
                        return undefined;
                    }
                }
                else {
                    state.needIterate = true;
                }
                if (condition) {
                    var conditionResult = void 0;
                    try {
                        conditionResult = condition(state.state);
                    }
                    catch (err) {
                        subscriber.error(err);
                        return undefined;
                    }
                    if (!conditionResult) {
                        subscriber.complete();
                        return undefined;
                    }
                    if (subscriber.closed) {
                        return undefined;
                    }
                }
                var value;
                try {
                    value = state.resultSelector(state.state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (subscriber.closed) {
                    return undefined;
                }
                subscriber.next(value);
                if (subscriber.closed) {
                    return undefined;
                }
                return this.schedule(state);
            }
            //# sourceMappingURL=generate.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/iif.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/iif.js ***!
          \***************************************************************/
        /*! exports provided: iif */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iif", function () { return iif; });
            /* harmony import */ var _defer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defer */ "./node_modules/rxjs/_esm2015/internal/observable/defer.js");
            /* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function iif(condition, trueResult, falseResult) {
                if (trueResult === void 0) { trueResult = _empty__WEBPACK_IMPORTED_MODULE_1__["EMPTY"]; }
                if (falseResult === void 0) { falseResult = _empty__WEBPACK_IMPORTED_MODULE_1__["EMPTY"]; }
                return Object(_defer__WEBPACK_IMPORTED_MODULE_0__["defer"])(function () { return condition() ? trueResult : falseResult; });
            }
            //# sourceMappingURL=iif.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/interval.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/interval.js ***!
          \********************************************************************/
        /*! exports provided: interval */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interval", function () { return interval; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm2015/internal/util/isNumeric.js");
            function interval(period, scheduler) {
                if (period === void 0) { period = 0; }
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"]; }
                if (!Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(period) || period < 0) {
                    period = 0;
                }
                if (!scheduler || typeof scheduler.schedule !== 'function') {
                    scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    subscriber.add(scheduler.schedule(dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
                    return subscriber;
                });
            }
            function dispatch(state) {
                var subscriber = state.subscriber, counter = state.counter, period = state.period;
                subscriber.next(counter);
                this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
            }
            //# sourceMappingURL=interval.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/merge.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/merge.js ***!
          \*****************************************************************/
        /*! exports provided: merge */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function () { return merge; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            /* harmony import */ var _operators_mergeAll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/mergeAll */ "./node_modules/rxjs/_esm2015/internal/operators/mergeAll.js");
            /* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm2015/internal/observable/fromArray.js");
            function merge() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                var concurrent = Number.POSITIVE_INFINITY;
                var scheduler = null;
                var last = observables[observables.length - 1];
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__["isScheduler"])(last)) {
                    scheduler = observables.pop();
                    if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
                        concurrent = observables.pop();
                    }
                }
                else if (typeof last === 'number') {
                    concurrent = observables.pop();
                }
                if (scheduler === null && observables.length === 1 && observables[0] instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]) {
                    return observables[0];
                }
                return Object(_operators_mergeAll__WEBPACK_IMPORTED_MODULE_2__["mergeAll"])(concurrent)(Object(_fromArray__WEBPACK_IMPORTED_MODULE_3__["fromArray"])(observables, scheduler));
            }
            //# sourceMappingURL=merge.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/never.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/never.js ***!
          \*****************************************************************/
        /*! exports provided: NEVER, never */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEVER", function () { return NEVER; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "never", function () { return never; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _util_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/noop */ "./node_modules/rxjs/_esm2015/internal/util/noop.js");
            var NEVER = new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](_util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"]);
            function never() {
                return NEVER;
            }
            //# sourceMappingURL=never.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/of.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/of.js ***!
          \**************************************************************/
        /*! exports provided: of */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "of", function () { return of; });
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            /* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm2015/internal/observable/fromArray.js");
            /* harmony import */ var _scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduleArray */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleArray.js");
            function of() {
                var args = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    args[_c] = arguments[_c];
                }
                var scheduler = args[args.length - 1];
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_0__["isScheduler"])(scheduler)) {
                    args.pop();
                    return Object(_scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__["scheduleArray"])(args, scheduler);
                }
                else {
                    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_1__["fromArray"])(args);
                }
            }
            //# sourceMappingURL=of.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/onErrorResumeNext.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/onErrorResumeNext.js ***!
          \*****************************************************************************/
        /*! exports provided: onErrorResumeNext */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function () { return onErrorResumeNext; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function onErrorResumeNext() {
                var sources = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    sources[_c] = arguments[_c];
                }
                if (sources.length === 0) {
                    return _empty__WEBPACK_IMPORTED_MODULE_3__["EMPTY"];
                }
                var first = sources[0], remainder = sources.slice(1);
                if (sources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__["isArray"])(first)) {
                    return onErrorResumeNext.apply(void 0, first);
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
                    return Object(_from__WEBPACK_IMPORTED_MODULE_1__["from"])(first).subscribe({
                        next: function (value) { subscriber.next(value); },
                        error: subNext,
                        complete: subNext,
                    });
                });
            }
            //# sourceMappingURL=onErrorResumeNext.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/pairs.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/pairs.js ***!
          \*****************************************************************/
        /*! exports provided: pairs, dispatch */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function () { return pairs; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatch", function () { return dispatch; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            function pairs(obj, scheduler) {
                if (!scheduler) {
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                        var keys = Object.keys(obj);
                        for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                            var key = keys[i];
                            if (obj.hasOwnProperty(key)) {
                                subscriber.next([key, obj[key]]);
                            }
                        }
                        subscriber.complete();
                    });
                }
                else {
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                        var keys = Object.keys(obj);
                        var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                        subscription.add(scheduler.schedule(dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
                        return subscription;
                    });
                }
            }
            function dispatch(state) {
                var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
                if (!subscriber.closed) {
                    if (index < keys.length) {
                        var key = keys[index];
                        subscriber.next([key, obj[key]]);
                        subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
                    }
                    else {
                        subscriber.complete();
                    }
                }
            }
            //# sourceMappingURL=pairs.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/partition.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/partition.js ***!
          \*********************************************************************/
        /*! exports provided: partition */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function () { return partition; });
            /* harmony import */ var _util_not__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/not */ "./node_modules/rxjs/_esm2015/internal/util/not.js");
            /* harmony import */ var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeTo */ "./node_modules/rxjs/_esm2015/internal/util/subscribeTo.js");
            /* harmony import */ var _operators_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/filter */ "./node_modules/rxjs/_esm2015/internal/operators/filter.js");
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            function partition(source, predicate, thisArg) {
                return [
                    Object(_operators_filter__WEBPACK_IMPORTED_MODULE_2__["filter"])(predicate, thisArg)(new _Observable__WEBPACK_IMPORTED_MODULE_3__["Observable"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(source))),
                    Object(_operators_filter__WEBPACK_IMPORTED_MODULE_2__["filter"])(Object(_util_not__WEBPACK_IMPORTED_MODULE_0__["not"])(predicate, thisArg))(new _Observable__WEBPACK_IMPORTED_MODULE_3__["Observable"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(source)))
                ];
            }
            //# sourceMappingURL=partition.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/race.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/race.js ***!
          \****************************************************************/
        /*! exports provided: race, RaceOperator, RaceSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "race", function () { return race; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RaceOperator", function () { return RaceOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RaceSubscriber", function () { return RaceSubscriber; });
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm2015/internal/observable/fromArray.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function race() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                if (observables.length === 1) {
                    if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(observables[0])) {
                        observables = observables[0];
                    }
                    else {
                        return observables[0];
                    }
                }
                return Object(_fromArray__WEBPACK_IMPORTED_MODULE_1__["fromArray"])(observables, undefined).lift(new RaceOperator());
            }
            var RaceOperator = /** @class */ (function () {
                function RaceOperator() {
                }
                RaceOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new RaceSubscriber(subscriber));
                };
                return RaceOperator;
            }());
            var RaceSubscriber = /** @class */ (function (_super_1) {
                __extends(RaceSubscriber, _super_1);
                function RaceSubscriber(destination) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.hasFirst = false;
                    _this.observables = [];
                    _this.subscriptions = [];
                    return _this;
                }
                RaceSubscriber.prototype._next = function (observable) {
                    this.observables.push(observable);
                };
                RaceSubscriber.prototype._complete = function () {
                    var observables = this.observables;
                    var len = observables.length;
                    if (len === 0) {
                        this.destination.complete();
                    }
                    else {
                        for (var i = 0; i < len && !this.hasFirst; i++) {
                            var observable = observables[i];
                            var subscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(this, observable, observable, i);
                            if (this.subscriptions) {
                                this.subscriptions.push(subscription);
                            }
                            this.add(subscription);
                        }
                        this.observables = null;
                    }
                };
                RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    if (!this.hasFirst) {
                        this.hasFirst = true;
                        for (var i = 0; i < this.subscriptions.length; i++) {
                            if (i !== outerIndex) {
                                var subscription = this.subscriptions[i];
                                subscription.unsubscribe();
                                this.remove(subscription);
                            }
                        }
                        this.subscriptions = null;
                    }
                    this.destination.next(innerValue);
                };
                return RaceSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            //# sourceMappingURL=race.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/range.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/range.js ***!
          \*****************************************************************/
        /*! exports provided: range, dispatch */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function () { return range; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatch", function () { return dispatch; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            function range(start, count, scheduler) {
                if (start === void 0) { start = 0; }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    if (count === undefined) {
                        count = start;
                        start = 0;
                    }
                    var index = 0;
                    var current = start;
                    if (scheduler) {
                        return scheduler.schedule(dispatch, 0, {
                            index: index, count: count, start: start, subscriber: subscriber
                        });
                    }
                    else {
                        do {
                            if (index++ >= count) {
                                subscriber.complete();
                                break;
                            }
                            subscriber.next(current++);
                            if (subscriber.closed) {
                                break;
                            }
                        } while (true);
                    }
                    return undefined;
                });
            }
            function dispatch(state) {
                var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
                if (index >= count) {
                    subscriber.complete();
                    return;
                }
                subscriber.next(start);
                if (subscriber.closed) {
                    return;
                }
                state.index = index + 1;
                state.start = start + 1;
                this.schedule(state);
            }
            //# sourceMappingURL=range.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/throwError.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/throwError.js ***!
          \**********************************************************************/
        /*! exports provided: throwError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwError", function () { return throwError; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            function throwError(error, scheduler) {
                if (!scheduler) {
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return subscriber.error(error); });
                }
                else {
                    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
                }
            }
            function dispatch(_c) {
                var error = _c.error, subscriber = _c.subscriber;
                subscriber.error(error);
            }
            //# sourceMappingURL=throwError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/timer.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/timer.js ***!
          \*****************************************************************/
        /*! exports provided: timer */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function () { return timer; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm2015/internal/util/isNumeric.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            function timer(dueTime, periodOrScheduler, scheduler) {
                if (dueTime === void 0) { dueTime = 0; }
                var period = -1;
                if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(periodOrScheduler)) {
                    period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
                }
                else if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__["isScheduler"])(periodOrScheduler)) {
                    scheduler = periodOrScheduler;
                }
                if (!Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__["isScheduler"])(scheduler)) {
                    scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var due = Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(dueTime)
                        ? dueTime
                        : (+dueTime - scheduler.now());
                    return scheduler.schedule(dispatch, due, {
                        index: 0, period: period, subscriber: subscriber
                    });
                });
            }
            function dispatch(state) {
                var index = state.index, period = state.period, subscriber = state.subscriber;
                subscriber.next(index);
                if (subscriber.closed) {
                    return;
                }
                else if (period === -1) {
                    return subscriber.complete();
                }
                state.index = index + 1;
                this.schedule(state, period);
            }
            //# sourceMappingURL=timer.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/using.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/using.js ***!
          \*****************************************************************/
        /*! exports provided: using */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "using", function () { return using; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            /* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function using(resourceFactory, observableFactory) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var resource;
                    try {
                        resource = resourceFactory();
                    }
                    catch (err) {
                        subscriber.error(err);
                        return undefined;
                    }
                    var result;
                    try {
                        result = observableFactory(resource);
                    }
                    catch (err) {
                        subscriber.error(err);
                        return undefined;
                    }
                    var source = result ? Object(_from__WEBPACK_IMPORTED_MODULE_1__["from"])(result) : _empty__WEBPACK_IMPORTED_MODULE_2__["EMPTY"];
                    var subscription = source.subscribe(subscriber);
                    return function () {
                        subscription.unsubscribe();
                        if (resource) {
                            resource.unsubscribe();
                        }
                    };
                });
            }
            //# sourceMappingURL=using.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/observable/zip.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/observable/zip.js ***!
          \***************************************************************/
        /*! exports provided: zip, ZipOperator, ZipSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function () { return zip; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZipOperator", function () { return ZipOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZipSubscriber", function () { return ZipSubscriber; });
            /* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm2015/internal/observable/fromArray.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../internal/symbol/iterator */ "./node_modules/rxjs/_esm2015/internal/symbol/iterator.js");
            function zip() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                var resultSelector = observables[observables.length - 1];
                if (typeof resultSelector === 'function') {
                    observables.pop();
                }
                return Object(_fromArray__WEBPACK_IMPORTED_MODULE_0__["fromArray"])(observables, undefined).lift(new ZipOperator(resultSelector));
            }
            var ZipOperator = /** @class */ (function () {
                function ZipOperator(resultSelector) {
                    this.resultSelector = resultSelector;
                }
                ZipOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
                };
                return ZipOperator;
            }());
            var ZipSubscriber = /** @class */ (function (_super_1) {
                __extends(ZipSubscriber, _super_1);
                function ZipSubscriber(destination, resultSelector, values) {
                    if (values === void 0) { values = Object.create(null); }
                    var _this = _super_1.call(this, destination) || this;
                    _this.iterators = [];
                    _this.active = 0;
                    _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : null;
                    _this.values = values;
                    return _this;
                }
                ZipSubscriber.prototype._next = function (value) {
                    var iterators = this.iterators;
                    if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(value)) {
                        iterators.push(new StaticArrayIterator(value));
                    }
                    else if (typeof value[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_5__["iterator"]] === 'function') {
                        iterators.push(new StaticIterator(value[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_5__["iterator"]]()));
                    }
                    else {
                        iterators.push(new ZipBufferIterator(this.destination, this, value));
                    }
                };
                ZipSubscriber.prototype._complete = function () {
                    var iterators = this.iterators;
                    var len = iterators.length;
                    this.unsubscribe();
                    if (len === 0) {
                        this.destination.complete();
                        return;
                    }
                    this.active = len;
                    for (var i = 0; i < len; i++) {
                        var iterator = iterators[i];
                        if (iterator.stillUnsubscribed) {
                            var destination = this.destination;
                            destination.add(iterator.subscribe(iterator, i));
                        }
                        else {
                            this.active--;
                        }
                    }
                };
                ZipSubscriber.prototype.notifyInactive = function () {
                    this.active--;
                    if (this.active === 0) {
                        this.destination.complete();
                    }
                };
                ZipSubscriber.prototype.checkIterators = function () {
                    var iterators = this.iterators;
                    var len = iterators.length;
                    var destination = this.destination;
                    for (var i = 0; i < len; i++) {
                        var iterator = iterators[i];
                        if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                            return;
                        }
                    }
                    var shouldComplete = false;
                    var args = [];
                    for (var i = 0; i < len; i++) {
                        var iterator = iterators[i];
                        var result = iterator.next();
                        if (iterator.hasCompleted()) {
                            shouldComplete = true;
                        }
                        if (result.done) {
                            destination.complete();
                            return;
                        }
                        args.push(result.value);
                    }
                    if (this.resultSelector) {
                        this._tryresultSelector(args);
                    }
                    else {
                        destination.next(args);
                    }
                    if (shouldComplete) {
                        destination.complete();
                    }
                };
                ZipSubscriber.prototype._tryresultSelector = function (args) {
                    var result;
                    try {
                        result = this.resultSelector.apply(this, args);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.destination.next(result);
                };
                return ZipSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));
            var StaticIterator = /** @class */ (function () {
                function StaticIterator(iterator) {
                    this.iterator = iterator;
                    this.nextResult = iterator.next();
                }
                StaticIterator.prototype.hasValue = function () {
                    return true;
                };
                StaticIterator.prototype.next = function () {
                    var result = this.nextResult;
                    this.nextResult = this.iterator.next();
                    return result;
                };
                StaticIterator.prototype.hasCompleted = function () {
                    var nextResult = this.nextResult;
                    return nextResult && nextResult.done;
                };
                return StaticIterator;
            }());
            var StaticArrayIterator = /** @class */ (function () {
                function StaticArrayIterator(array) {
                    this.array = array;
                    this.index = 0;
                    this.length = 0;
                    this.length = array.length;
                }
                StaticArrayIterator.prototype[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_5__["iterator"]] = function () {
                    return this;
                };
                StaticArrayIterator.prototype.next = function (value) {
                    var i = this.index++;
                    var array = this.array;
                    return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
                };
                StaticArrayIterator.prototype.hasValue = function () {
                    return this.array.length > this.index;
                };
                StaticArrayIterator.prototype.hasCompleted = function () {
                    return this.array.length === this.index;
                };
                return StaticArrayIterator;
            }());
            var ZipBufferIterator = /** @class */ (function (_super_1) {
                __extends(ZipBufferIterator, _super_1);
                function ZipBufferIterator(destination, parent, observable) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.parent = parent;
                    _this.observable = observable;
                    _this.stillUnsubscribed = true;
                    _this.buffer = [];
                    _this.isComplete = false;
                    return _this;
                }
                ZipBufferIterator.prototype[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_5__["iterator"]] = function () {
                    return this;
                };
                ZipBufferIterator.prototype.next = function () {
                    var buffer = this.buffer;
                    if (buffer.length === 0 && this.isComplete) {
                        return { value: null, done: true };
                    }
                    else {
                        return { value: buffer.shift(), done: false };
                    }
                };
                ZipBufferIterator.prototype.hasValue = function () {
                    return this.buffer.length > 0;
                };
                ZipBufferIterator.prototype.hasCompleted = function () {
                    return this.buffer.length === 0 && this.isComplete;
                };
                ZipBufferIterator.prototype.notifyComplete = function () {
                    if (this.buffer.length > 0) {
                        this.isComplete = true;
                        this.parent.notifyInactive();
                    }
                    else {
                        this.destination.complete();
                    }
                };
                ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.buffer.push(innerValue);
                    this.parent.checkIterators();
                };
                ZipBufferIterator.prototype.subscribe = function (value, index) {
                    return Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(this, this.observable, this, index);
                };
                return ZipBufferIterator;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__["OuterSubscriber"]));
            //# sourceMappingURL=zip.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/audit.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/audit.js ***!
          \****************************************************************/
        /*! exports provided: audit */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audit", function () { return audit; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function audit(durationSelector) {
                return function auditOperatorFunction(source) {
                    return source.lift(new AuditOperator(durationSelector));
                };
            }
            var AuditOperator = /** @class */ (function () {
                function AuditOperator(durationSelector) {
                    this.durationSelector = durationSelector;
                }
                AuditOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
                };
                return AuditOperator;
            }());
            var AuditSubscriber = /** @class */ (function (_super_1) {
                __extends(AuditSubscriber, _super_1);
                function AuditSubscriber(destination, durationSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.durationSelector = durationSelector;
                    _this.hasValue = false;
                    return _this;
                }
                AuditSubscriber.prototype._next = function (value) {
                    this.value = value;
                    this.hasValue = true;
                    if (!this.throttled) {
                        var duration = void 0;
                        try {
                            var durationSelector = this.durationSelector;
                            duration = durationSelector(value);
                        }
                        catch (err) {
                            return this.destination.error(err);
                        }
                        var innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(this, duration);
                        if (!innerSubscription || innerSubscription.closed) {
                            this.clearThrottle();
                        }
                        else {
                            this.add(this.throttled = innerSubscription);
                        }
                    }
                };
                AuditSubscriber.prototype.clearThrottle = function () {
                    var _c = this, value = _c.value, hasValue = _c.hasValue, throttled = _c.throttled;
                    if (throttled) {
                        this.remove(throttled);
                        this.throttled = null;
                        throttled.unsubscribe();
                    }
                    if (hasValue) {
                        this.value = null;
                        this.hasValue = false;
                        this.destination.next(value);
                    }
                };
                AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
                    this.clearThrottle();
                };
                AuditSubscriber.prototype.notifyComplete = function () {
                    this.clearThrottle();
                };
                return AuditSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=audit.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/auditTime.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/auditTime.js ***!
          \********************************************************************/
        /*! exports provided: auditTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditTime", function () { return auditTime; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./audit */ "./node_modules/rxjs/_esm2015/internal/operators/audit.js");
            /* harmony import */ var _observable_timer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/timer */ "./node_modules/rxjs/_esm2015/internal/observable/timer.js");
            function auditTime(duration, scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"]; }
                return Object(_audit__WEBPACK_IMPORTED_MODULE_1__["audit"])(function () { return Object(_observable_timer__WEBPACK_IMPORTED_MODULE_2__["timer"])(duration, scheduler); });
            }
            //# sourceMappingURL=auditTime.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/buffer.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/buffer.js ***!
          \*****************************************************************/
        /*! exports provided: buffer */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buffer", function () { return buffer; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function buffer(closingNotifier) {
                return function bufferOperatorFunction(source) {
                    return source.lift(new BufferOperator(closingNotifier));
                };
            }
            var BufferOperator = /** @class */ (function () {
                function BufferOperator(closingNotifier) {
                    this.closingNotifier = closingNotifier;
                }
                BufferOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
                };
                return BufferOperator;
            }());
            var BufferSubscriber = /** @class */ (function (_super_1) {
                __extends(BufferSubscriber, _super_1);
                function BufferSubscriber(destination, closingNotifier) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.buffer = [];
                    _this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(_this, closingNotifier));
                    return _this;
                }
                BufferSubscriber.prototype._next = function (value) {
                    this.buffer.push(value);
                };
                BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    var buffer = this.buffer;
                    this.buffer = [];
                    this.destination.next(buffer);
                };
                return BufferSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=buffer.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/bufferCount.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/bufferCount.js ***!
          \**********************************************************************/
        /*! exports provided: bufferCount */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferCount", function () { return bufferCount; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function bufferCount(bufferSize, startBufferEvery) {
                if (startBufferEvery === void 0) { startBufferEvery = null; }
                return function bufferCountOperatorFunction(source) {
                    return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
                };
            }
            var BufferCountOperator = /** @class */ (function () {
                function BufferCountOperator(bufferSize, startBufferEvery) {
                    this.bufferSize = bufferSize;
                    this.startBufferEvery = startBufferEvery;
                    if (!startBufferEvery || bufferSize === startBufferEvery) {
                        this.subscriberClass = BufferCountSubscriber;
                    }
                    else {
                        this.subscriberClass = BufferSkipCountSubscriber;
                    }
                }
                BufferCountOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
                };
                return BufferCountOperator;
            }());
            var BufferCountSubscriber = /** @class */ (function (_super_1) {
                __extends(BufferCountSubscriber, _super_1);
                function BufferCountSubscriber(destination, bufferSize) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.bufferSize = bufferSize;
                    _this.buffer = [];
                    return _this;
                }
                BufferCountSubscriber.prototype._next = function (value) {
                    var buffer = this.buffer;
                    buffer.push(value);
                    if (buffer.length == this.bufferSize) {
                        this.destination.next(buffer);
                        this.buffer = [];
                    }
                };
                BufferCountSubscriber.prototype._complete = function () {
                    var buffer = this.buffer;
                    if (buffer.length > 0) {
                        this.destination.next(buffer);
                    }
                    _super_1.prototype._complete.call(this);
                };
                return BufferCountSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            var BufferSkipCountSubscriber = /** @class */ (function (_super_1) {
                __extends(BufferSkipCountSubscriber, _super_1);
                function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.bufferSize = bufferSize;
                    _this.startBufferEvery = startBufferEvery;
                    _this.buffers = [];
                    _this.count = 0;
                    return _this;
                }
                BufferSkipCountSubscriber.prototype._next = function (value) {
                    var _c = this, bufferSize = _c.bufferSize, startBufferEvery = _c.startBufferEvery, buffers = _c.buffers, count = _c.count;
                    this.count++;
                    if (count % startBufferEvery === 0) {
                        buffers.push([]);
                    }
                    for (var i = buffers.length; i--;) {
                        var buffer = buffers[i];
                        buffer.push(value);
                        if (buffer.length === bufferSize) {
                            buffers.splice(i, 1);
                            this.destination.next(buffer);
                        }
                    }
                };
                BufferSkipCountSubscriber.prototype._complete = function () {
                    var _c = this, buffers = _c.buffers, destination = _c.destination;
                    while (buffers.length > 0) {
                        var buffer = buffers.shift();
                        if (buffer.length > 0) {
                            destination.next(buffer);
                        }
                    }
                    _super_1.prototype._complete.call(this);
                };
                return BufferSkipCountSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=bufferCount.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/bufferTime.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/bufferTime.js ***!
          \*********************************************************************/
        /*! exports provided: bufferTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferTime", function () { return bufferTime; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            function bufferTime(bufferTimeSpan) {
                var length = arguments.length;
                var scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"];
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_2__["isScheduler"])(arguments[arguments.length - 1])) {
                    scheduler = arguments[arguments.length - 1];
                    length--;
                }
                var bufferCreationInterval = null;
                if (length >= 2) {
                    bufferCreationInterval = arguments[1];
                }
                var maxBufferSize = Number.POSITIVE_INFINITY;
                if (length >= 3) {
                    maxBufferSize = arguments[2];
                }
                return function bufferTimeOperatorFunction(source) {
                    return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
                };
            }
            var BufferTimeOperator = /** @class */ (function () {
                function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
                    this.bufferTimeSpan = bufferTimeSpan;
                    this.bufferCreationInterval = bufferCreationInterval;
                    this.maxBufferSize = maxBufferSize;
                    this.scheduler = scheduler;
                }
                BufferTimeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
                };
                return BufferTimeOperator;
            }());
            var Context = /** @class */ (function () {
                function Context() {
                    this.buffer = [];
                }
                return Context;
            }());
            var BufferTimeSubscriber = /** @class */ (function (_super_1) {
                __extends(BufferTimeSubscriber, _super_1);
                function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.bufferTimeSpan = bufferTimeSpan;
                    _this.bufferCreationInterval = bufferCreationInterval;
                    _this.maxBufferSize = maxBufferSize;
                    _this.scheduler = scheduler;
                    _this.contexts = [];
                    var context = _this.openContext();
                    _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
                    if (_this.timespanOnly) {
                        var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
                        _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
                    }
                    else {
                        var closeState = { subscriber: _this, context: context };
                        var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
                        _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
                        _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
                    }
                    return _this;
                }
                BufferTimeSubscriber.prototype._next = function (value) {
                    var contexts = this.contexts;
                    var len = contexts.length;
                    var filledBufferContext;
                    for (var i = 0; i < len; i++) {
                        var context = contexts[i];
                        var buffer = context.buffer;
                        buffer.push(value);
                        if (buffer.length == this.maxBufferSize) {
                            filledBufferContext = context;
                        }
                    }
                    if (filledBufferContext) {
                        this.onBufferFull(filledBufferContext);
                    }
                };
                BufferTimeSubscriber.prototype._error = function (err) {
                    this.contexts.length = 0;
                    _super_1.prototype._error.call(this, err);
                };
                BufferTimeSubscriber.prototype._complete = function () {
                    var _c = this, contexts = _c.contexts, destination = _c.destination;
                    while (contexts.length > 0) {
                        var context = contexts.shift();
                        destination.next(context.buffer);
                    }
                    _super_1.prototype._complete.call(this);
                };
                BufferTimeSubscriber.prototype._unsubscribe = function () {
                    this.contexts = null;
                };
                BufferTimeSubscriber.prototype.onBufferFull = function (context) {
                    this.closeContext(context);
                    var closeAction = context.closeAction;
                    closeAction.unsubscribe();
                    this.remove(closeAction);
                    if (!this.closed && this.timespanOnly) {
                        context = this.openContext();
                        var bufferTimeSpan = this.bufferTimeSpan;
                        var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
                        this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
                    }
                };
                BufferTimeSubscriber.prototype.openContext = function () {
                    var context = new Context();
                    this.contexts.push(context);
                    return context;
                };
                BufferTimeSubscriber.prototype.closeContext = function (context) {
                    this.destination.next(context.buffer);
                    var contexts = this.contexts;
                    var spliceIndex = contexts ? contexts.indexOf(context) : -1;
                    if (spliceIndex >= 0) {
                        contexts.splice(contexts.indexOf(context), 1);
                    }
                };
                return BufferTimeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
            function dispatchBufferTimeSpanOnly(state) {
                var subscriber = state.subscriber;
                var prevContext = state.context;
                if (prevContext) {
                    subscriber.closeContext(prevContext);
                }
                if (!subscriber.closed) {
                    state.context = subscriber.openContext();
                    state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
                }
            }
            function dispatchBufferCreation(state) {
                var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
                var context = subscriber.openContext();
                var action = this;
                if (!subscriber.closed) {
                    subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
                    action.schedule(state, bufferCreationInterval);
                }
            }
            function dispatchBufferClose(arg) {
                var subscriber = arg.subscriber, context = arg.context;
                subscriber.closeContext(context);
            }
            //# sourceMappingURL=bufferTime.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/bufferToggle.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/bufferToggle.js ***!
          \***********************************************************************/
        /*! exports provided: bufferToggle */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferToggle", function () { return bufferToggle; });
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            function bufferToggle(openings, closingSelector) {
                return function bufferToggleOperatorFunction(source) {
                    return source.lift(new BufferToggleOperator(openings, closingSelector));
                };
            }
            var BufferToggleOperator = /** @class */ (function () {
                function BufferToggleOperator(openings, closingSelector) {
                    this.openings = openings;
                    this.closingSelector = closingSelector;
                }
                BufferToggleOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
                };
                return BufferToggleOperator;
            }());
            var BufferToggleSubscriber = /** @class */ (function (_super_1) {
                __extends(BufferToggleSubscriber, _super_1);
                function BufferToggleSubscriber(destination, openings, closingSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.openings = openings;
                    _this.closingSelector = closingSelector;
                    _this.contexts = [];
                    _this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(_this, openings));
                    return _this;
                }
                BufferToggleSubscriber.prototype._next = function (value) {
                    var contexts = this.contexts;
                    var len = contexts.length;
                    for (var i = 0; i < len; i++) {
                        contexts[i].buffer.push(value);
                    }
                };
                BufferToggleSubscriber.prototype._error = function (err) {
                    var contexts = this.contexts;
                    while (contexts.length > 0) {
                        var context = contexts.shift();
                        context.subscription.unsubscribe();
                        context.buffer = null;
                        context.subscription = null;
                    }
                    this.contexts = null;
                    _super_1.prototype._error.call(this, err);
                };
                BufferToggleSubscriber.prototype._complete = function () {
                    var contexts = this.contexts;
                    while (contexts.length > 0) {
                        var context = contexts.shift();
                        this.destination.next(context.buffer);
                        context.subscription.unsubscribe();
                        context.buffer = null;
                        context.subscription = null;
                    }
                    this.contexts = null;
                    _super_1.prototype._complete.call(this);
                };
                BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
                };
                BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
                    this.closeBuffer(innerSub.context);
                };
                BufferToggleSubscriber.prototype.openBuffer = function (value) {
                    try {
                        var closingSelector = this.closingSelector;
                        var closingNotifier = closingSelector.call(this, value);
                        if (closingNotifier) {
                            this.trySubscribe(closingNotifier);
                        }
                    }
                    catch (err) {
                        this._error(err);
                    }
                };
                BufferToggleSubscriber.prototype.closeBuffer = function (context) {
                    var contexts = this.contexts;
                    if (contexts && context) {
                        var buffer = context.buffer, subscription = context.subscription;
                        this.destination.next(buffer);
                        contexts.splice(contexts.indexOf(context), 1);
                        this.remove(subscription);
                        subscription.unsubscribe();
                    }
                };
                BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
                    var contexts = this.contexts;
                    var buffer = [];
                    var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_0__["Subscription"]();
                    var context = { buffer: buffer, subscription: subscription };
                    contexts.push(context);
                    var innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(this, closingNotifier, context);
                    if (!innerSubscription || innerSubscription.closed) {
                        this.closeBuffer(context);
                    }
                    else {
                        innerSubscription.context = context;
                        this.add(innerSubscription);
                        subscription.add(innerSubscription);
                    }
                };
                return BufferToggleSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            //# sourceMappingURL=bufferToggle.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/bufferWhen.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/bufferWhen.js ***!
          \*********************************************************************/
        /*! exports provided: bufferWhen */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferWhen", function () { return bufferWhen; });
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function bufferWhen(closingSelector) {
                return function (source) {
                    return source.lift(new BufferWhenOperator(closingSelector));
                };
            }
            var BufferWhenOperator = /** @class */ (function () {
                function BufferWhenOperator(closingSelector) {
                    this.closingSelector = closingSelector;
                }
                BufferWhenOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
                };
                return BufferWhenOperator;
            }());
            var BufferWhenSubscriber = /** @class */ (function (_super_1) {
                __extends(BufferWhenSubscriber, _super_1);
                function BufferWhenSubscriber(destination, closingSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.closingSelector = closingSelector;
                    _this.subscribing = false;
                    _this.openBuffer();
                    return _this;
                }
                BufferWhenSubscriber.prototype._next = function (value) {
                    this.buffer.push(value);
                };
                BufferWhenSubscriber.prototype._complete = function () {
                    var buffer = this.buffer;
                    if (buffer) {
                        this.destination.next(buffer);
                    }
                    _super_1.prototype._complete.call(this);
                };
                BufferWhenSubscriber.prototype._unsubscribe = function () {
                    this.buffer = null;
                    this.subscribing = false;
                };
                BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.openBuffer();
                };
                BufferWhenSubscriber.prototype.notifyComplete = function () {
                    if (this.subscribing) {
                        this.complete();
                    }
                    else {
                        this.openBuffer();
                    }
                };
                BufferWhenSubscriber.prototype.openBuffer = function () {
                    var closingSubscription = this.closingSubscription;
                    if (closingSubscription) {
                        this.remove(closingSubscription);
                        closingSubscription.unsubscribe();
                    }
                    var buffer = this.buffer;
                    if (this.buffer) {
                        this.destination.next(buffer);
                    }
                    this.buffer = [];
                    var closingNotifier;
                    try {
                        var closingSelector = this.closingSelector;
                        closingNotifier = closingSelector();
                    }
                    catch (err) {
                        return this.error(err);
                    }
                    closingSubscription = new _Subscription__WEBPACK_IMPORTED_MODULE_0__["Subscription"]();
                    this.closingSubscription = closingSubscription;
                    this.add(closingSubscription);
                    this.subscribing = true;
                    closingSubscription.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, closingNotifier));
                    this.subscribing = false;
                };
                return BufferWhenSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=bufferWhen.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/catchError.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/catchError.js ***!
          \*********************************************************************/
        /*! exports provided: catchError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "catchError", function () { return catchError; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function catchError(selector) {
                return function catchErrorOperatorFunction(source) {
                    var operator = new CatchOperator(selector);
                    var caught = source.lift(operator);
                    return (operator.caught = caught);
                };
            }
            var CatchOperator = /** @class */ (function () {
                function CatchOperator(selector) {
                    this.selector = selector;
                }
                CatchOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
                };
                return CatchOperator;
            }());
            var CatchSubscriber = /** @class */ (function (_super_1) {
                __extends(CatchSubscriber, _super_1);
                function CatchSubscriber(destination, selector, caught) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.selector = selector;
                    _this.caught = caught;
                    return _this;
                }
                CatchSubscriber.prototype.error = function (err) {
                    if (!this.isStopped) {
                        var result = void 0;
                        try {
                            result = this.selector(err, this.caught);
                        }
                        catch (err2) {
                            _super_1.prototype.error.call(this, err2);
                            return;
                        }
                        this._unsubscribeAndRecycle();
                        var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__["InnerSubscriber"](this, undefined, undefined);
                        this.add(innerSubscriber);
                        Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, result, undefined, undefined, innerSubscriber);
                    }
                };
                return CatchSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=catchError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/combineAll.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/combineAll.js ***!
          \*********************************************************************/
        /*! exports provided: combineAll */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineAll", function () { return combineAll; });
            /* harmony import */ var _observable_combineLatest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/combineLatest */ "./node_modules/rxjs/_esm2015/internal/observable/combineLatest.js");
            function combineAll(project) {
                return function (source) { return source.lift(new _observable_combineLatest__WEBPACK_IMPORTED_MODULE_0__["CombineLatestOperator"](project)); };
            }
            //# sourceMappingURL=combineAll.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/combineLatest.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/combineLatest.js ***!
          \************************************************************************/
        /*! exports provided: combineLatest */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function () { return combineLatest; });
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _observable_combineLatest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/combineLatest */ "./node_modules/rxjs/_esm2015/internal/observable/combineLatest.js");
            /* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            var none = {};
            function combineLatest() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                var project = null;
                if (typeof observables[observables.length - 1] === 'function') {
                    project = observables.pop();
                }
                if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(observables[0])) {
                    observables = observables[0].slice();
                }
                return function (source) { return source.lift.call(Object(_observable_from__WEBPACK_IMPORTED_MODULE_2__["from"])([source].concat(observables)), new _observable_combineLatest__WEBPACK_IMPORTED_MODULE_1__["CombineLatestOperator"](project)); };
            }
            //# sourceMappingURL=combineLatest.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/concat.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/concat.js ***!
          \*****************************************************************/
        /*! exports provided: concat */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function () { return concat; });
            /* harmony import */ var _observable_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/concat */ "./node_modules/rxjs/_esm2015/internal/observable/concat.js");
            function concat() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                return function (source) { return source.lift.call(Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"]).apply(void 0, [source].concat(observables))); };
            }
            //# sourceMappingURL=concat.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/concatAll.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/concatAll.js ***!
          \********************************************************************/
        /*! exports provided: concatAll */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatAll", function () { return concatAll; });
            /* harmony import */ var _mergeAll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeAll */ "./node_modules/rxjs/_esm2015/internal/operators/mergeAll.js");
            function concatAll() {
                return Object(_mergeAll__WEBPACK_IMPORTED_MODULE_0__["mergeAll"])(1);
            }
            //# sourceMappingURL=concatAll.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/concatMap.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/concatMap.js ***!
          \********************************************************************/
        /*! exports provided: concatMap */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatMap", function () { return concatMap; });
            /* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */ "./node_modules/rxjs/_esm2015/internal/operators/mergeMap.js");
            function concatMap(project, resultSelector) {
                return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(project, resultSelector, 1);
            }
            //# sourceMappingURL=concatMap.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/concatMapTo.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/concatMapTo.js ***!
          \**********************************************************************/
        /*! exports provided: concatMapTo */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatMapTo", function () { return concatMapTo; });
            /* harmony import */ var _concatMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./concatMap */ "./node_modules/rxjs/_esm2015/internal/operators/concatMap.js");
            function concatMapTo(innerObservable, resultSelector) {
                return Object(_concatMap__WEBPACK_IMPORTED_MODULE_0__["concatMap"])(function () { return innerObservable; }, resultSelector);
            }
            //# sourceMappingURL=concatMapTo.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/count.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/count.js ***!
          \****************************************************************/
        /*! exports provided: count */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function () { return count; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function count(predicate) {
                return function (source) { return source.lift(new CountOperator(predicate, source)); };
            }
            var CountOperator = /** @class */ (function () {
                function CountOperator(predicate, source) {
                    this.predicate = predicate;
                    this.source = source;
                }
                CountOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
                };
                return CountOperator;
            }());
            var CountSubscriber = /** @class */ (function (_super_1) {
                __extends(CountSubscriber, _super_1);
                function CountSubscriber(destination, predicate, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.source = source;
                    _this.count = 0;
                    _this.index = 0;
                    return _this;
                }
                CountSubscriber.prototype._next = function (value) {
                    if (this.predicate) {
                        this._tryPredicate(value);
                    }
                    else {
                        this.count++;
                    }
                };
                CountSubscriber.prototype._tryPredicate = function (value) {
                    var result;
                    try {
                        result = this.predicate(value, this.index++, this.source);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    if (result) {
                        this.count++;
                    }
                };
                CountSubscriber.prototype._complete = function () {
                    this.destination.next(this.count);
                    this.destination.complete();
                };
                return CountSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=count.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/debounce.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/debounce.js ***!
          \*******************************************************************/
        /*! exports provided: debounce */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function () { return debounce; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function debounce(durationSelector) {
                return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
            }
            var DebounceOperator = /** @class */ (function () {
                function DebounceOperator(durationSelector) {
                    this.durationSelector = durationSelector;
                }
                DebounceOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
                };
                return DebounceOperator;
            }());
            var DebounceSubscriber = /** @class */ (function (_super_1) {
                __extends(DebounceSubscriber, _super_1);
                function DebounceSubscriber(destination, durationSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.durationSelector = durationSelector;
                    _this.hasValue = false;
                    _this.durationSubscription = null;
                    return _this;
                }
                DebounceSubscriber.prototype._next = function (value) {
                    try {
                        var result = this.durationSelector.call(this, value);
                        if (result) {
                            this._tryNext(value, result);
                        }
                    }
                    catch (err) {
                        this.destination.error(err);
                    }
                };
                DebounceSubscriber.prototype._complete = function () {
                    this.emitValue();
                    this.destination.complete();
                };
                DebounceSubscriber.prototype._tryNext = function (value, duration) {
                    var subscription = this.durationSubscription;
                    this.value = value;
                    this.hasValue = true;
                    if (subscription) {
                        subscription.unsubscribe();
                        this.remove(subscription);
                    }
                    subscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(this, duration);
                    if (subscription && !subscription.closed) {
                        this.add(this.durationSubscription = subscription);
                    }
                };
                DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.emitValue();
                };
                DebounceSubscriber.prototype.notifyComplete = function () {
                    this.emitValue();
                };
                DebounceSubscriber.prototype.emitValue = function () {
                    if (this.hasValue) {
                        var value = this.value;
                        var subscription = this.durationSubscription;
                        if (subscription) {
                            this.durationSubscription = null;
                            subscription.unsubscribe();
                            this.remove(subscription);
                        }
                        this.value = null;
                        this.hasValue = false;
                        _super_1.prototype._next.call(this, value);
                    }
                };
                return DebounceSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=debounce.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/debounceTime.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/debounceTime.js ***!
          \***********************************************************************/
        /*! exports provided: debounceTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounceTime", function () { return debounceTime; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            function debounceTime(dueTime, scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"]; }
                return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
            }
            var DebounceTimeOperator = /** @class */ (function () {
                function DebounceTimeOperator(dueTime, scheduler) {
                    this.dueTime = dueTime;
                    this.scheduler = scheduler;
                }
                DebounceTimeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
                };
                return DebounceTimeOperator;
            }());
            var DebounceTimeSubscriber = /** @class */ (function (_super_1) {
                __extends(DebounceTimeSubscriber, _super_1);
                function DebounceTimeSubscriber(destination, dueTime, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.dueTime = dueTime;
                    _this.scheduler = scheduler;
                    _this.debouncedSubscription = null;
                    _this.lastValue = null;
                    _this.hasValue = false;
                    return _this;
                }
                DebounceTimeSubscriber.prototype._next = function (value) {
                    this.clearDebounce();
                    this.lastValue = value;
                    this.hasValue = true;
                    this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
                };
                DebounceTimeSubscriber.prototype._complete = function () {
                    this.debouncedNext();
                    this.destination.complete();
                };
                DebounceTimeSubscriber.prototype.debouncedNext = function () {
                    this.clearDebounce();
                    if (this.hasValue) {
                        var lastValue = this.lastValue;
                        this.lastValue = null;
                        this.hasValue = false;
                        this.destination.next(lastValue);
                    }
                };
                DebounceTimeSubscriber.prototype.clearDebounce = function () {
                    var debouncedSubscription = this.debouncedSubscription;
                    if (debouncedSubscription !== null) {
                        this.remove(debouncedSubscription);
                        debouncedSubscription.unsubscribe();
                        this.debouncedSubscription = null;
                    }
                };
                return DebounceTimeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            function dispatchNext(subscriber) {
                subscriber.debouncedNext();
            }
            //# sourceMappingURL=debounceTime.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js ***!
          \*************************************************************************/
        /*! exports provided: defaultIfEmpty */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function () { return defaultIfEmpty; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function defaultIfEmpty(defaultValue) {
                if (defaultValue === void 0) { defaultValue = null; }
                return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
            }
            var DefaultIfEmptyOperator = /** @class */ (function () {
                function DefaultIfEmptyOperator(defaultValue) {
                    this.defaultValue = defaultValue;
                }
                DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
                };
                return DefaultIfEmptyOperator;
            }());
            var DefaultIfEmptySubscriber = /** @class */ (function (_super_1) {
                __extends(DefaultIfEmptySubscriber, _super_1);
                function DefaultIfEmptySubscriber(destination, defaultValue) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.defaultValue = defaultValue;
                    _this.isEmpty = true;
                    return _this;
                }
                DefaultIfEmptySubscriber.prototype._next = function (value) {
                    this.isEmpty = false;
                    this.destination.next(value);
                };
                DefaultIfEmptySubscriber.prototype._complete = function () {
                    if (this.isEmpty) {
                        this.destination.next(this.defaultValue);
                    }
                    this.destination.complete();
                };
                return DefaultIfEmptySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=defaultIfEmpty.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/delay.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/delay.js ***!
          \****************************************************************/
        /*! exports provided: delay */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function () { return delay; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _util_isDate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isDate */ "./node_modules/rxjs/_esm2015/internal/util/isDate.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Notification */ "./node_modules/rxjs/_esm2015/internal/Notification.js");
            function delay(delay, scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"]; }
                var absoluteDelay = Object(_util_isDate__WEBPACK_IMPORTED_MODULE_1__["isDate"])(delay);
                var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
                return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
            }
            var DelayOperator = /** @class */ (function () {
                function DelayOperator(delay, scheduler) {
                    this.delay = delay;
                    this.scheduler = scheduler;
                }
                DelayOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
                };
                return DelayOperator;
            }());
            var DelaySubscriber = /** @class */ (function (_super_1) {
                __extends(DelaySubscriber, _super_1);
                function DelaySubscriber(destination, delay, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.delay = delay;
                    _this.scheduler = scheduler;
                    _this.queue = [];
                    _this.active = false;
                    _this.errored = false;
                    return _this;
                }
                DelaySubscriber.dispatch = function (state) {
                    var source = state.source;
                    var queue = source.queue;
                    var scheduler = state.scheduler;
                    var destination = state.destination;
                    while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
                        queue.shift().notification.observe(destination);
                    }
                    if (queue.length > 0) {
                        var delay_1 = Math.max(0, queue[0].time - scheduler.now());
                        this.schedule(state, delay_1);
                    }
                    else {
                        this.unsubscribe();
                        source.active = false;
                    }
                };
                DelaySubscriber.prototype._schedule = function (scheduler) {
                    this.active = true;
                    var destination = this.destination;
                    destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
                        source: this, destination: this.destination, scheduler: scheduler
                    }));
                };
                DelaySubscriber.prototype.scheduleNotification = function (notification) {
                    if (this.errored === true) {
                        return;
                    }
                    var scheduler = this.scheduler;
                    var message = new DelayMessage(scheduler.now() + this.delay, notification);
                    this.queue.push(message);
                    if (this.active === false) {
                        this._schedule(scheduler);
                    }
                };
                DelaySubscriber.prototype._next = function (value) {
                    this.scheduleNotification(_Notification__WEBPACK_IMPORTED_MODULE_3__["Notification"].createNext(value));
                };
                DelaySubscriber.prototype._error = function (err) {
                    this.errored = true;
                    this.queue = [];
                    this.destination.error(err);
                    this.unsubscribe();
                };
                DelaySubscriber.prototype._complete = function () {
                    this.scheduleNotification(_Notification__WEBPACK_IMPORTED_MODULE_3__["Notification"].createComplete());
                    this.unsubscribe();
                };
                return DelaySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));
            var DelayMessage = /** @class */ (function () {
                function DelayMessage(time, notification) {
                    this.time = time;
                    this.notification = notification;
                }
                return DelayMessage;
            }());
            //# sourceMappingURL=delay.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/delayWhen.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/delayWhen.js ***!
          \********************************************************************/
        /*! exports provided: delayWhen */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delayWhen", function () { return delayWhen; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function delayWhen(delayDurationSelector, subscriptionDelay) {
                if (subscriptionDelay) {
                    return function (source) { return new SubscriptionDelayObservable(source, subscriptionDelay)
                        .lift(new DelayWhenOperator(delayDurationSelector)); };
                }
                return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
            }
            var DelayWhenOperator = /** @class */ (function () {
                function DelayWhenOperator(delayDurationSelector) {
                    this.delayDurationSelector = delayDurationSelector;
                }
                DelayWhenOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
                };
                return DelayWhenOperator;
            }());
            var DelayWhenSubscriber = /** @class */ (function (_super_1) {
                __extends(DelayWhenSubscriber, _super_1);
                function DelayWhenSubscriber(destination, delayDurationSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.delayDurationSelector = delayDurationSelector;
                    _this.completed = false;
                    _this.delayNotifierSubscriptions = [];
                    _this.index = 0;
                    return _this;
                }
                DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.destination.next(outerValue);
                    this.removeSubscription(innerSub);
                    this.tryComplete();
                };
                DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
                    this._error(error);
                };
                DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
                    var value = this.removeSubscription(innerSub);
                    if (value) {
                        this.destination.next(value);
                    }
                    this.tryComplete();
                };
                DelayWhenSubscriber.prototype._next = function (value) {
                    var index = this.index++;
                    try {
                        var delayNotifier = this.delayDurationSelector(value, index);
                        if (delayNotifier) {
                            this.tryDelay(delayNotifier, value);
                        }
                    }
                    catch (err) {
                        this.destination.error(err);
                    }
                };
                DelayWhenSubscriber.prototype._complete = function () {
                    this.completed = true;
                    this.tryComplete();
                    this.unsubscribe();
                };
                DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
                    subscription.unsubscribe();
                    var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
                    if (subscriptionIdx !== -1) {
                        this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
                    }
                    return subscription.outerValue;
                };
                DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
                    var notifierSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(this, delayNotifier, value);
                    if (notifierSubscription && !notifierSubscription.closed) {
                        var destination = this.destination;
                        destination.add(notifierSubscription);
                        this.delayNotifierSubscriptions.push(notifierSubscription);
                    }
                };
                DelayWhenSubscriber.prototype.tryComplete = function () {
                    if (this.completed && this.delayNotifierSubscriptions.length === 0) {
                        this.destination.complete();
                    }
                };
                return DelayWhenSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            var SubscriptionDelayObservable = /** @class */ (function (_super_1) {
                __extends(SubscriptionDelayObservable, _super_1);
                function SubscriptionDelayObservable(source, subscriptionDelay) {
                    var _this = _super_1.call(this) || this;
                    _this.source = source;
                    _this.subscriptionDelay = subscriptionDelay;
                    return _this;
                }
                SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
                    this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
                };
                return SubscriptionDelayObservable;
            }(_Observable__WEBPACK_IMPORTED_MODULE_1__["Observable"]));
            var SubscriptionDelaySubscriber = /** @class */ (function (_super_1) {
                __extends(SubscriptionDelaySubscriber, _super_1);
                function SubscriptionDelaySubscriber(parent, source) {
                    var _this = _super_1.call(this) || this;
                    _this.parent = parent;
                    _this.source = source;
                    _this.sourceSubscribed = false;
                    return _this;
                }
                SubscriptionDelaySubscriber.prototype._next = function (unused) {
                    this.subscribeToSource();
                };
                SubscriptionDelaySubscriber.prototype._error = function (err) {
                    this.unsubscribe();
                    this.parent.error(err);
                };
                SubscriptionDelaySubscriber.prototype._complete = function () {
                    this.unsubscribe();
                    this.subscribeToSource();
                };
                SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
                    if (!this.sourceSubscribed) {
                        this.sourceSubscribed = true;
                        this.unsubscribe();
                        this.source.subscribe(this.parent);
                    }
                };
                return SubscriptionDelaySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=delayWhen.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/dematerialize.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/dematerialize.js ***!
          \************************************************************************/
        /*! exports provided: dematerialize */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dematerialize", function () { return dematerialize; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function dematerialize() {
                return function dematerializeOperatorFunction(source) {
                    return source.lift(new DeMaterializeOperator());
                };
            }
            var DeMaterializeOperator = /** @class */ (function () {
                function DeMaterializeOperator() {
                }
                DeMaterializeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DeMaterializeSubscriber(subscriber));
                };
                return DeMaterializeOperator;
            }());
            var DeMaterializeSubscriber = /** @class */ (function (_super_1) {
                __extends(DeMaterializeSubscriber, _super_1);
                function DeMaterializeSubscriber(destination) {
                    return _super_1.call(this, destination) || this;
                }
                DeMaterializeSubscriber.prototype._next = function (value) {
                    value.observe(this.destination);
                };
                return DeMaterializeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=dematerialize.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/distinct.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/distinct.js ***!
          \*******************************************************************/
        /*! exports provided: distinct, DistinctSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinct", function () { return distinct; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DistinctSubscriber", function () { return DistinctSubscriber; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function distinct(keySelector, flushes) {
                return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
            }
            var DistinctOperator = /** @class */ (function () {
                function DistinctOperator(keySelector, flushes) {
                    this.keySelector = keySelector;
                    this.flushes = flushes;
                }
                DistinctOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
                };
                return DistinctOperator;
            }());
            var DistinctSubscriber = /** @class */ (function (_super_1) {
                __extends(DistinctSubscriber, _super_1);
                function DistinctSubscriber(destination, keySelector, flushes) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.keySelector = keySelector;
                    _this.values = new Set();
                    if (flushes) {
                        _this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(_this, flushes));
                    }
                    return _this;
                }
                DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.values.clear();
                };
                DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
                    this._error(error);
                };
                DistinctSubscriber.prototype._next = function (value) {
                    if (this.keySelector) {
                        this._useKeySelector(value);
                    }
                    else {
                        this._finalizeNext(value, value);
                    }
                };
                DistinctSubscriber.prototype._useKeySelector = function (value) {
                    var key;
                    var destination = this.destination;
                    try {
                        key = this.keySelector(value);
                    }
                    catch (err) {
                        destination.error(err);
                        return;
                    }
                    this._finalizeNext(key, value);
                };
                DistinctSubscriber.prototype._finalizeNext = function (key, value) {
                    var values = this.values;
                    if (!values.has(key)) {
                        values.add(key);
                        this.destination.next(value);
                    }
                };
                return DistinctSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=distinct.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/distinctUntilChanged.js": 
        /*!*******************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/distinctUntilChanged.js ***!
          \*******************************************************************************/
        /*! exports provided: distinctUntilChanged */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function () { return distinctUntilChanged; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function distinctUntilChanged(compare, keySelector) {
                return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
            }
            var DistinctUntilChangedOperator = /** @class */ (function () {
                function DistinctUntilChangedOperator(compare, keySelector) {
                    this.compare = compare;
                    this.keySelector = keySelector;
                }
                DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
                };
                return DistinctUntilChangedOperator;
            }());
            var DistinctUntilChangedSubscriber = /** @class */ (function (_super_1) {
                __extends(DistinctUntilChangedSubscriber, _super_1);
                function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.keySelector = keySelector;
                    _this.hasKey = false;
                    if (typeof compare === 'function') {
                        _this.compare = compare;
                    }
                    return _this;
                }
                DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
                    return x === y;
                };
                DistinctUntilChangedSubscriber.prototype._next = function (value) {
                    var key;
                    try {
                        var keySelector = this.keySelector;
                        key = keySelector ? keySelector(value) : value;
                    }
                    catch (err) {
                        return this.destination.error(err);
                    }
                    var result = false;
                    if (this.hasKey) {
                        try {
                            var compare = this.compare;
                            result = compare(this.key, key);
                        }
                        catch (err) {
                            return this.destination.error(err);
                        }
                    }
                    else {
                        this.hasKey = true;
                    }
                    if (!result) {
                        this.key = key;
                        this.destination.next(value);
                    }
                };
                return DistinctUntilChangedSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=distinctUntilChanged.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/distinctUntilKeyChanged.js": 
        /*!**********************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/distinctUntilKeyChanged.js ***!
          \**********************************************************************************/
        /*! exports provided: distinctUntilKeyChanged */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function () { return distinctUntilKeyChanged; });
            /* harmony import */ var _distinctUntilChanged__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./distinctUntilChanged */ "./node_modules/rxjs/_esm2015/internal/operators/distinctUntilChanged.js");
            function distinctUntilKeyChanged(key, compare) {
                return Object(_distinctUntilChanged__WEBPACK_IMPORTED_MODULE_0__["distinctUntilChanged"])(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
            }
            //# sourceMappingURL=distinctUntilKeyChanged.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/elementAt.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/elementAt.js ***!
          \********************************************************************/
        /*! exports provided: elementAt */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elementAt", function () { return elementAt; });
            /* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js");
            /* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm2015/internal/operators/filter.js");
            /* harmony import */ var _throwIfEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./throwIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/throwIfEmpty.js");
            /* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js");
            /* harmony import */ var _take__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./take */ "./node_modules/rxjs/_esm2015/internal/operators/take.js");
            function elementAt(index, defaultValue) {
                if (index < 0) {
                    throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_0__["ArgumentOutOfRangeError"]();
                }
                var hasDefaultValue = arguments.length >= 2;
                return function (source) { return source.pipe(Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(function (v, i) { return i === index; }), Object(_take__WEBPACK_IMPORTED_MODULE_4__["take"])(1), hasDefaultValue
                    ? Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__["defaultIfEmpty"])(defaultValue)
                    : Object(_throwIfEmpty__WEBPACK_IMPORTED_MODULE_2__["throwIfEmpty"])(function () { return new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_0__["ArgumentOutOfRangeError"](); })); };
            }
            //# sourceMappingURL=elementAt.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/endWith.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/endWith.js ***!
          \******************************************************************/
        /*! exports provided: endWith */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "endWith", function () { return endWith; });
            /* harmony import */ var _observable_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/concat */ "./node_modules/rxjs/_esm2015/internal/observable/concat.js");
            /* harmony import */ var _observable_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/of */ "./node_modules/rxjs/_esm2015/internal/observable/of.js");
            function endWith() {
                var array = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    array[_c] = arguments[_c];
                }
                return function (source) { return Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"])(source, Object(_observable_of__WEBPACK_IMPORTED_MODULE_1__["of"]).apply(void 0, array)); };
            }
            //# sourceMappingURL=endWith.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/every.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/every.js ***!
          \****************************************************************/
        /*! exports provided: every */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "every", function () { return every; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function every(predicate, thisArg) {
                return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
            }
            var EveryOperator = /** @class */ (function () {
                function EveryOperator(predicate, thisArg, source) {
                    this.predicate = predicate;
                    this.thisArg = thisArg;
                    this.source = source;
                }
                EveryOperator.prototype.call = function (observer, source) {
                    return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
                };
                return EveryOperator;
            }());
            var EverySubscriber = /** @class */ (function (_super_1) {
                __extends(EverySubscriber, _super_1);
                function EverySubscriber(destination, predicate, thisArg, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.thisArg = thisArg;
                    _this.source = source;
                    _this.index = 0;
                    _this.thisArg = thisArg || _this;
                    return _this;
                }
                EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
                    this.destination.next(everyValueMatch);
                    this.destination.complete();
                };
                EverySubscriber.prototype._next = function (value) {
                    var result = false;
                    try {
                        result = this.predicate.call(this.thisArg, value, this.index++, this.source);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    if (!result) {
                        this.notifyComplete(false);
                    }
                };
                EverySubscriber.prototype._complete = function () {
                    this.notifyComplete(true);
                };
                return EverySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=every.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/exhaust.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/exhaust.js ***!
          \******************************************************************/
        /*! exports provided: exhaust */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exhaust", function () { return exhaust; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function exhaust() {
                return function (source) { return source.lift(new SwitchFirstOperator()); };
            }
            var SwitchFirstOperator = /** @class */ (function () {
                function SwitchFirstOperator() {
                }
                SwitchFirstOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SwitchFirstSubscriber(subscriber));
                };
                return SwitchFirstOperator;
            }());
            var SwitchFirstSubscriber = /** @class */ (function (_super_1) {
                __extends(SwitchFirstSubscriber, _super_1);
                function SwitchFirstSubscriber(destination) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.hasCompleted = false;
                    _this.hasSubscription = false;
                    return _this;
                }
                SwitchFirstSubscriber.prototype._next = function (value) {
                    if (!this.hasSubscription) {
                        this.hasSubscription = true;
                        this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(this, value));
                    }
                };
                SwitchFirstSubscriber.prototype._complete = function () {
                    this.hasCompleted = true;
                    if (!this.hasSubscription) {
                        this.destination.complete();
                    }
                };
                SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
                    this.remove(innerSub);
                    this.hasSubscription = false;
                    if (this.hasCompleted) {
                        this.destination.complete();
                    }
                };
                return SwitchFirstSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=exhaust.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/exhaustMap.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/exhaustMap.js ***!
          \*********************************************************************/
        /*! exports provided: exhaustMap */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exhaustMap", function () { return exhaustMap; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            function exhaustMap(project, resultSelector) {
                if (resultSelector) {
                    return function (source) { return source.pipe(exhaustMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_4__["from"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
                }
                return function (source) { return source.lift(new ExhaustMapOperator(project)); };
            }
            var ExhaustMapOperator = /** @class */ (function () {
                function ExhaustMapOperator(project) {
                    this.project = project;
                }
                ExhaustMapOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
                };
                return ExhaustMapOperator;
            }());
            var ExhaustMapSubscriber = /** @class */ (function (_super_1) {
                __extends(ExhaustMapSubscriber, _super_1);
                function ExhaustMapSubscriber(destination, project) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.project = project;
                    _this.hasSubscription = false;
                    _this.hasCompleted = false;
                    _this.index = 0;
                    return _this;
                }
                ExhaustMapSubscriber.prototype._next = function (value) {
                    if (!this.hasSubscription) {
                        this.tryNext(value);
                    }
                };
                ExhaustMapSubscriber.prototype.tryNext = function (value) {
                    var result;
                    var index = this.index++;
                    try {
                        result = this.project(value, index);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.hasSubscription = true;
                    this._innerSub(result, value, index);
                };
                ExhaustMapSubscriber.prototype._innerSub = function (result, value, index) {
                    var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__["InnerSubscriber"](this, undefined, undefined);
                    var destination = this.destination;
                    destination.add(innerSubscriber);
                    Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, result, value, index, innerSubscriber);
                };
                ExhaustMapSubscriber.prototype._complete = function () {
                    this.hasCompleted = true;
                    if (!this.hasSubscription) {
                        this.destination.complete();
                    }
                    this.unsubscribe();
                };
                ExhaustMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.destination.next(innerValue);
                };
                ExhaustMapSubscriber.prototype.notifyError = function (err) {
                    this.destination.error(err);
                };
                ExhaustMapSubscriber.prototype.notifyComplete = function (innerSub) {
                    var destination = this.destination;
                    destination.remove(innerSub);
                    this.hasSubscription = false;
                    if (this.hasCompleted) {
                        this.destination.complete();
                    }
                };
                return ExhaustMapSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=exhaustMap.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/expand.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/expand.js ***!
          \*****************************************************************/
        /*! exports provided: expand, ExpandOperator, ExpandSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expand", function () { return expand; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandOperator", function () { return ExpandOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandSubscriber", function () { return ExpandSubscriber; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function expand(project, concurrent, scheduler) {
                if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                if (scheduler === void 0) { scheduler = undefined; }
                concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
                return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
            }
            var ExpandOperator = /** @class */ (function () {
                function ExpandOperator(project, concurrent, scheduler) {
                    this.project = project;
                    this.concurrent = concurrent;
                    this.scheduler = scheduler;
                }
                ExpandOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
                };
                return ExpandOperator;
            }());
            var ExpandSubscriber = /** @class */ (function (_super_1) {
                __extends(ExpandSubscriber, _super_1);
                function ExpandSubscriber(destination, project, concurrent, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.project = project;
                    _this.concurrent = concurrent;
                    _this.scheduler = scheduler;
                    _this.index = 0;
                    _this.active = 0;
                    _this.hasCompleted = false;
                    if (concurrent < Number.POSITIVE_INFINITY) {
                        _this.buffer = [];
                    }
                    return _this;
                }
                ExpandSubscriber.dispatch = function (arg) {
                    var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
                    subscriber.subscribeToProjection(result, value, index);
                };
                ExpandSubscriber.prototype._next = function (value) {
                    var destination = this.destination;
                    if (destination.closed) {
                        this._complete();
                        return;
                    }
                    var index = this.index++;
                    if (this.active < this.concurrent) {
                        destination.next(value);
                        try {
                            var project = this.project;
                            var result = project(value, index);
                            if (!this.scheduler) {
                                this.subscribeToProjection(result, value, index);
                            }
                            else {
                                var state = { subscriber: this, result: result, value: value, index: index };
                                var destination_1 = this.destination;
                                destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                            }
                        }
                        catch (e) {
                            destination.error(e);
                        }
                    }
                    else {
                        this.buffer.push(value);
                    }
                };
                ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
                    this.active++;
                    var destination = this.destination;
                    destination.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(this, result, value, index));
                };
                ExpandSubscriber.prototype._complete = function () {
                    this.hasCompleted = true;
                    if (this.hasCompleted && this.active === 0) {
                        this.destination.complete();
                    }
                    this.unsubscribe();
                };
                ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this._next(innerValue);
                };
                ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
                    var buffer = this.buffer;
                    var destination = this.destination;
                    destination.remove(innerSub);
                    this.active--;
                    if (buffer && buffer.length > 0) {
                        this._next(buffer.shift());
                    }
                    if (this.hasCompleted && this.active === 0) {
                        this.destination.complete();
                    }
                };
                return ExpandSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=expand.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/filter.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/filter.js ***!
          \*****************************************************************/
        /*! exports provided: filter */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function () { return filter; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function filter(predicate, thisArg) {
                return function filterOperatorFunction(source) {
                    return source.lift(new FilterOperator(predicate, thisArg));
                };
            }
            var FilterOperator = /** @class */ (function () {
                function FilterOperator(predicate, thisArg) {
                    this.predicate = predicate;
                    this.thisArg = thisArg;
                }
                FilterOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
                };
                return FilterOperator;
            }());
            var FilterSubscriber = /** @class */ (function (_super_1) {
                __extends(FilterSubscriber, _super_1);
                function FilterSubscriber(destination, predicate, thisArg) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.thisArg = thisArg;
                    _this.count = 0;
                    return _this;
                }
                FilterSubscriber.prototype._next = function (value) {
                    var result;
                    try {
                        result = this.predicate.call(this.thisArg, value, this.count++);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    if (result) {
                        this.destination.next(value);
                    }
                };
                return FilterSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=filter.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/finalize.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/finalize.js ***!
          \*******************************************************************/
        /*! exports provided: finalize */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finalize", function () { return finalize; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            function finalize(callback) {
                return function (source) { return source.lift(new FinallyOperator(callback)); };
            }
            var FinallyOperator = /** @class */ (function () {
                function FinallyOperator(callback) {
                    this.callback = callback;
                }
                FinallyOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new FinallySubscriber(subscriber, this.callback));
                };
                return FinallyOperator;
            }());
            var FinallySubscriber = /** @class */ (function (_super_1) {
                __extends(FinallySubscriber, _super_1);
                function FinallySubscriber(destination, callback) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.add(new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"](callback));
                    return _this;
                }
                return FinallySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=finalize.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/find.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/find.js ***!
          \***************************************************************/
        /*! exports provided: find, FindValueOperator, FindValueSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function () { return find; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FindValueOperator", function () { return FindValueOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FindValueSubscriber", function () { return FindValueSubscriber; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function find(predicate, thisArg) {
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate is not a function');
                }
                return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
            }
            var FindValueOperator = /** @class */ (function () {
                function FindValueOperator(predicate, source, yieldIndex, thisArg) {
                    this.predicate = predicate;
                    this.source = source;
                    this.yieldIndex = yieldIndex;
                    this.thisArg = thisArg;
                }
                FindValueOperator.prototype.call = function (observer, source) {
                    return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
                };
                return FindValueOperator;
            }());
            var FindValueSubscriber = /** @class */ (function (_super_1) {
                __extends(FindValueSubscriber, _super_1);
                function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.source = source;
                    _this.yieldIndex = yieldIndex;
                    _this.thisArg = thisArg;
                    _this.index = 0;
                    return _this;
                }
                FindValueSubscriber.prototype.notifyComplete = function (value) {
                    var destination = this.destination;
                    destination.next(value);
                    destination.complete();
                    this.unsubscribe();
                };
                FindValueSubscriber.prototype._next = function (value) {
                    var _c = this, predicate = _c.predicate, thisArg = _c.thisArg;
                    var index = this.index++;
                    try {
                        var result = predicate.call(thisArg || this, value, index, this.source);
                        if (result) {
                            this.notifyComplete(this.yieldIndex ? index : value);
                        }
                    }
                    catch (err) {
                        this.destination.error(err);
                    }
                };
                FindValueSubscriber.prototype._complete = function () {
                    this.notifyComplete(this.yieldIndex ? -1 : undefined);
                };
                return FindValueSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=find.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/findIndex.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/findIndex.js ***!
          \********************************************************************/
        /*! exports provided: findIndex */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function () { return findIndex; });
            /* harmony import */ var _operators_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../operators/find */ "./node_modules/rxjs/_esm2015/internal/operators/find.js");
            function findIndex(predicate, thisArg) {
                return function (source) { return source.lift(new _operators_find__WEBPACK_IMPORTED_MODULE_0__["FindValueOperator"](predicate, source, true, thisArg)); };
            }
            //# sourceMappingURL=findIndex.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/first.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/first.js ***!
          \****************************************************************/
        /*! exports provided: first */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "first", function () { return first; });
            /* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm2015/internal/util/EmptyError.js");
            /* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm2015/internal/operators/filter.js");
            /* harmony import */ var _take__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./take */ "./node_modules/rxjs/_esm2015/internal/operators/take.js");
            /* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js");
            /* harmony import */ var _throwIfEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./throwIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/throwIfEmpty.js");
            /* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm2015/internal/util/identity.js");
            function first(predicate, defaultValue) {
                var hasDefaultValue = arguments.length >= 2;
                return function (source) { return source.pipe(predicate ? Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(function (v, i) { return predicate(v, i, source); }) : _util_identity__WEBPACK_IMPORTED_MODULE_5__["identity"], Object(_take__WEBPACK_IMPORTED_MODULE_2__["take"])(1), hasDefaultValue ? Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__["defaultIfEmpty"])(defaultValue) : Object(_throwIfEmpty__WEBPACK_IMPORTED_MODULE_4__["throwIfEmpty"])(function () { return new _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__["EmptyError"](); })); };
            }
            //# sourceMappingURL=first.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/groupBy.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/groupBy.js ***!
          \******************************************************************/
        /*! exports provided: groupBy, GroupedObservable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function () { return groupBy; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupedObservable", function () { return GroupedObservable; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
                return function (source) { return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector)); };
            }
            var GroupByOperator = /** @class */ (function () {
                function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
                    this.keySelector = keySelector;
                    this.elementSelector = elementSelector;
                    this.durationSelector = durationSelector;
                    this.subjectSelector = subjectSelector;
                }
                GroupByOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
                };
                return GroupByOperator;
            }());
            var GroupBySubscriber = /** @class */ (function (_super_1) {
                __extends(GroupBySubscriber, _super_1);
                function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.keySelector = keySelector;
                    _this.elementSelector = elementSelector;
                    _this.durationSelector = durationSelector;
                    _this.subjectSelector = subjectSelector;
                    _this.groups = null;
                    _this.attemptedToUnsubscribe = false;
                    _this.count = 0;
                    return _this;
                }
                GroupBySubscriber.prototype._next = function (value) {
                    var key;
                    try {
                        key = this.keySelector(value);
                    }
                    catch (err) {
                        this.error(err);
                        return;
                    }
                    this._group(value, key);
                };
                GroupBySubscriber.prototype._group = function (value, key) {
                    var groups = this.groups;
                    if (!groups) {
                        groups = this.groups = new Map();
                    }
                    var group = groups.get(key);
                    var element;
                    if (this.elementSelector) {
                        try {
                            element = this.elementSelector(value);
                        }
                        catch (err) {
                            this.error(err);
                        }
                    }
                    else {
                        element = value;
                    }
                    if (!group) {
                        group = (this.subjectSelector ? this.subjectSelector() : new _Subject__WEBPACK_IMPORTED_MODULE_3__["Subject"]());
                        groups.set(key, group);
                        var groupedObservable = new GroupedObservable(key, group, this);
                        this.destination.next(groupedObservable);
                        if (this.durationSelector) {
                            var duration = void 0;
                            try {
                                duration = this.durationSelector(new GroupedObservable(key, group));
                            }
                            catch (err) {
                                this.error(err);
                                return;
                            }
                            this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
                        }
                    }
                    if (!group.closed) {
                        group.next(element);
                    }
                };
                GroupBySubscriber.prototype._error = function (err) {
                    var groups = this.groups;
                    if (groups) {
                        groups.forEach(function (group, key) {
                            group.error(err);
                        });
                        groups.clear();
                    }
                    this.destination.error(err);
                };
                GroupBySubscriber.prototype._complete = function () {
                    var groups = this.groups;
                    if (groups) {
                        groups.forEach(function (group, key) {
                            group.complete();
                        });
                        groups.clear();
                    }
                    this.destination.complete();
                };
                GroupBySubscriber.prototype.removeGroup = function (key) {
                    this.groups.delete(key);
                };
                GroupBySubscriber.prototype.unsubscribe = function () {
                    if (!this.closed) {
                        this.attemptedToUnsubscribe = true;
                        if (this.count === 0) {
                            _super_1.prototype.unsubscribe.call(this);
                        }
                    }
                };
                return GroupBySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            var GroupDurationSubscriber = /** @class */ (function (_super_1) {
                __extends(GroupDurationSubscriber, _super_1);
                function GroupDurationSubscriber(key, group, parent) {
                    var _this = _super_1.call(this, group) || this;
                    _this.key = key;
                    _this.group = group;
                    _this.parent = parent;
                    return _this;
                }
                GroupDurationSubscriber.prototype._next = function (value) {
                    this.complete();
                };
                GroupDurationSubscriber.prototype._unsubscribe = function () {
                    var _c = this, parent = _c.parent, key = _c.key;
                    this.key = this.parent = null;
                    if (parent) {
                        parent.removeGroup(key);
                    }
                };
                return GroupDurationSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            var GroupedObservable = /** @class */ (function (_super_1) {
                __extends(GroupedObservable, _super_1);
                function GroupedObservable(key, groupSubject, refCountSubscription) {
                    var _this = _super_1.call(this) || this;
                    _this.key = key;
                    _this.groupSubject = groupSubject;
                    _this.refCountSubscription = refCountSubscription;
                    return _this;
                }
                GroupedObservable.prototype._subscribe = function (subscriber) {
                    var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                    var _c = this, refCountSubscription = _c.refCountSubscription, groupSubject = _c.groupSubject;
                    if (refCountSubscription && !refCountSubscription.closed) {
                        subscription.add(new InnerRefCountSubscription(refCountSubscription));
                    }
                    subscription.add(groupSubject.subscribe(subscriber));
                    return subscription;
                };
                return GroupedObservable;
            }(_Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]));
            var InnerRefCountSubscription = /** @class */ (function (_super_1) {
                __extends(InnerRefCountSubscription, _super_1);
                function InnerRefCountSubscription(parent) {
                    var _this = _super_1.call(this) || this;
                    _this.parent = parent;
                    parent.count++;
                    return _this;
                }
                InnerRefCountSubscription.prototype.unsubscribe = function () {
                    var parent = this.parent;
                    if (!parent.closed && !this.closed) {
                        _super_1.prototype.unsubscribe.call(this);
                        parent.count -= 1;
                        if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                            parent.unsubscribe();
                        }
                    }
                };
                return InnerRefCountSubscription;
            }(_Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]));
            //# sourceMappingURL=groupBy.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/ignoreElements.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/ignoreElements.js ***!
          \*************************************************************************/
        /*! exports provided: ignoreElements */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ignoreElements", function () { return ignoreElements; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function ignoreElements() {
                return function ignoreElementsOperatorFunction(source) {
                    return source.lift(new IgnoreElementsOperator());
                };
            }
            var IgnoreElementsOperator = /** @class */ (function () {
                function IgnoreElementsOperator() {
                }
                IgnoreElementsOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new IgnoreElementsSubscriber(subscriber));
                };
                return IgnoreElementsOperator;
            }());
            var IgnoreElementsSubscriber = /** @class */ (function (_super_1) {
                __extends(IgnoreElementsSubscriber, _super_1);
                function IgnoreElementsSubscriber() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                IgnoreElementsSubscriber.prototype._next = function (unused) {
                };
                return IgnoreElementsSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=ignoreElements.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/isEmpty.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/isEmpty.js ***!
          \******************************************************************/
        /*! exports provided: isEmpty */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function () { return isEmpty; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function isEmpty() {
                return function (source) { return source.lift(new IsEmptyOperator()); };
            }
            var IsEmptyOperator = /** @class */ (function () {
                function IsEmptyOperator() {
                }
                IsEmptyOperator.prototype.call = function (observer, source) {
                    return source.subscribe(new IsEmptySubscriber(observer));
                };
                return IsEmptyOperator;
            }());
            var IsEmptySubscriber = /** @class */ (function (_super_1) {
                __extends(IsEmptySubscriber, _super_1);
                function IsEmptySubscriber(destination) {
                    return _super_1.call(this, destination) || this;
                }
                IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
                    var destination = this.destination;
                    destination.next(isEmpty);
                    destination.complete();
                };
                IsEmptySubscriber.prototype._next = function (value) {
                    this.notifyComplete(false);
                };
                IsEmptySubscriber.prototype._complete = function () {
                    this.notifyComplete(true);
                };
                return IsEmptySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=isEmpty.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/last.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/last.js ***!
          \***************************************************************/
        /*! exports provided: last */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "last", function () { return last; });
            /* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm2015/internal/util/EmptyError.js");
            /* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm2015/internal/operators/filter.js");
            /* harmony import */ var _takeLast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./takeLast */ "./node_modules/rxjs/_esm2015/internal/operators/takeLast.js");
            /* harmony import */ var _throwIfEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./throwIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/throwIfEmpty.js");
            /* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js");
            /* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm2015/internal/util/identity.js");
            function last(predicate, defaultValue) {
                var hasDefaultValue = arguments.length >= 2;
                return function (source) { return source.pipe(predicate ? Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(function (v, i) { return predicate(v, i, source); }) : _util_identity__WEBPACK_IMPORTED_MODULE_5__["identity"], Object(_takeLast__WEBPACK_IMPORTED_MODULE_2__["takeLast"])(1), hasDefaultValue ? Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_4__["defaultIfEmpty"])(defaultValue) : Object(_throwIfEmpty__WEBPACK_IMPORTED_MODULE_3__["throwIfEmpty"])(function () { return new _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__["EmptyError"](); })); };
            }
            //# sourceMappingURL=last.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/map.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/map.js ***!
          \**************************************************************/
        /*! exports provided: map, MapOperator */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function () { return map; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MapOperator", function () { return MapOperator; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function map(project, thisArg) {
                return function mapOperation(source) {
                    if (typeof project !== 'function') {
                        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
                    }
                    return source.lift(new MapOperator(project, thisArg));
                };
            }
            var MapOperator = /** @class */ (function () {
                function MapOperator(project, thisArg) {
                    this.project = project;
                    this.thisArg = thisArg;
                }
                MapOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
                };
                return MapOperator;
            }());
            var MapSubscriber = /** @class */ (function (_super_1) {
                __extends(MapSubscriber, _super_1);
                function MapSubscriber(destination, project, thisArg) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.project = project;
                    _this.count = 0;
                    _this.thisArg = thisArg || _this;
                    return _this;
                }
                MapSubscriber.prototype._next = function (value) {
                    var result;
                    try {
                        result = this.project.call(this.thisArg, value, this.count++);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.destination.next(result);
                };
                return MapSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=map.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/mapTo.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/mapTo.js ***!
          \****************************************************************/
        /*! exports provided: mapTo */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapTo", function () { return mapTo; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function mapTo(value) {
                return function (source) { return source.lift(new MapToOperator(value)); };
            }
            var MapToOperator = /** @class */ (function () {
                function MapToOperator(value) {
                    this.value = value;
                }
                MapToOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new MapToSubscriber(subscriber, this.value));
                };
                return MapToOperator;
            }());
            var MapToSubscriber = /** @class */ (function (_super_1) {
                __extends(MapToSubscriber, _super_1);
                function MapToSubscriber(destination, value) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.value = value;
                    return _this;
                }
                MapToSubscriber.prototype._next = function (x) {
                    this.destination.next(this.value);
                };
                return MapToSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=mapTo.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/materialize.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/materialize.js ***!
          \**********************************************************************/
        /*! exports provided: materialize */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialize", function () { return materialize; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Notification */ "./node_modules/rxjs/_esm2015/internal/Notification.js");
            function materialize() {
                return function materializeOperatorFunction(source) {
                    return source.lift(new MaterializeOperator());
                };
            }
            var MaterializeOperator = /** @class */ (function () {
                function MaterializeOperator() {
                }
                MaterializeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new MaterializeSubscriber(subscriber));
                };
                return MaterializeOperator;
            }());
            var MaterializeSubscriber = /** @class */ (function (_super_1) {
                __extends(MaterializeSubscriber, _super_1);
                function MaterializeSubscriber(destination) {
                    return _super_1.call(this, destination) || this;
                }
                MaterializeSubscriber.prototype._next = function (value) {
                    this.destination.next(_Notification__WEBPACK_IMPORTED_MODULE_1__["Notification"].createNext(value));
                };
                MaterializeSubscriber.prototype._error = function (err) {
                    var destination = this.destination;
                    destination.next(_Notification__WEBPACK_IMPORTED_MODULE_1__["Notification"].createError(err));
                    destination.complete();
                };
                MaterializeSubscriber.prototype._complete = function () {
                    var destination = this.destination;
                    destination.next(_Notification__WEBPACK_IMPORTED_MODULE_1__["Notification"].createComplete());
                    destination.complete();
                };
                return MaterializeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=materialize.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/max.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/max.js ***!
          \**************************************************************/
        /*! exports provided: max */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "max", function () { return max; });
            /* harmony import */ var _reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reduce */ "./node_modules/rxjs/_esm2015/internal/operators/reduce.js");
            function max(comparer) {
                var max = (typeof comparer === 'function')
                    ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
                    : function (x, y) { return x > y ? x : y; };
                return Object(_reduce__WEBPACK_IMPORTED_MODULE_0__["reduce"])(max);
            }
            //# sourceMappingURL=max.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/merge.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/merge.js ***!
          \****************************************************************/
        /*! exports provided: merge */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function () { return merge; });
            /* harmony import */ var _observable_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/merge */ "./node_modules/rxjs/_esm2015/internal/observable/merge.js");
            function merge() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                return function (source) { return source.lift.call(Object(_observable_merge__WEBPACK_IMPORTED_MODULE_0__["merge"]).apply(void 0, [source].concat(observables))); };
            }
            //# sourceMappingURL=merge.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/mergeAll.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/mergeAll.js ***!
          \*******************************************************************/
        /*! exports provided: mergeAll */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeAll", function () { return mergeAll; });
            /* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */ "./node_modules/rxjs/_esm2015/internal/operators/mergeMap.js");
            /* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm2015/internal/util/identity.js");
            function mergeAll(concurrent) {
                if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(_util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"], concurrent);
            }
            //# sourceMappingURL=mergeAll.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/mergeMap.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/mergeMap.js ***!
          \*******************************************************************/
        /*! exports provided: mergeMap, MergeMapOperator, MergeMapSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeMap", function () { return mergeMap; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeMapOperator", function () { return MergeMapOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeMapSubscriber", function () { return MergeMapSubscriber; });
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            function mergeMap(project, resultSelector, concurrent) {
                if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                if (typeof resultSelector === 'function') {
                    return function (source) { return source.pipe(mergeMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_4__["from"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
                }
                else if (typeof resultSelector === 'number') {
                    concurrent = resultSelector;
                }
                return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
            }
            var MergeMapOperator = /** @class */ (function () {
                function MergeMapOperator(project, concurrent) {
                    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                    this.project = project;
                    this.concurrent = concurrent;
                }
                MergeMapOperator.prototype.call = function (observer, source) {
                    return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
                };
                return MergeMapOperator;
            }());
            var MergeMapSubscriber = /** @class */ (function (_super_1) {
                __extends(MergeMapSubscriber, _super_1);
                function MergeMapSubscriber(destination, project, concurrent) {
                    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                    var _this = _super_1.call(this, destination) || this;
                    _this.project = project;
                    _this.concurrent = concurrent;
                    _this.hasCompleted = false;
                    _this.buffer = [];
                    _this.active = 0;
                    _this.index = 0;
                    return _this;
                }
                MergeMapSubscriber.prototype._next = function (value) {
                    if (this.active < this.concurrent) {
                        this._tryNext(value);
                    }
                    else {
                        this.buffer.push(value);
                    }
                };
                MergeMapSubscriber.prototype._tryNext = function (value) {
                    var result;
                    var index = this.index++;
                    try {
                        result = this.project(value, index);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.active++;
                    this._innerSub(result, value, index);
                };
                MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
                    var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_2__["InnerSubscriber"](this, undefined, undefined);
                    var destination = this.destination;
                    destination.add(innerSubscriber);
                    Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_0__["subscribeToResult"])(this, ish, value, index, innerSubscriber);
                };
                MergeMapSubscriber.prototype._complete = function () {
                    this.hasCompleted = true;
                    if (this.active === 0 && this.buffer.length === 0) {
                        this.destination.complete();
                    }
                    this.unsubscribe();
                };
                MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.destination.next(innerValue);
                };
                MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
                    var buffer = this.buffer;
                    this.remove(innerSub);
                    this.active--;
                    if (buffer.length > 0) {
                        this._next(buffer.shift());
                    }
                    else if (this.active === 0 && this.hasCompleted) {
                        this.destination.complete();
                    }
                };
                return MergeMapSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=mergeMap.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/mergeMapTo.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/mergeMapTo.js ***!
          \*********************************************************************/
        /*! exports provided: mergeMapTo */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeMapTo", function () { return mergeMapTo; });
            /* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */ "./node_modules/rxjs/_esm2015/internal/operators/mergeMap.js");
            function mergeMapTo(innerObservable, resultSelector, concurrent) {
                if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                if (typeof resultSelector === 'function') {
                    return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(function () { return innerObservable; }, resultSelector, concurrent);
                }
                if (typeof resultSelector === 'number') {
                    concurrent = resultSelector;
                }
                return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(function () { return innerObservable; }, concurrent);
            }
            //# sourceMappingURL=mergeMapTo.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/mergeScan.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/mergeScan.js ***!
          \********************************************************************/
        /*! exports provided: mergeScan, MergeScanOperator, MergeScanSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeScan", function () { return mergeScan; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeScanOperator", function () { return MergeScanOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeScanSubscriber", function () { return MergeScanSubscriber; });
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            function mergeScan(accumulator, seed, concurrent) {
                if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
                return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
            }
            var MergeScanOperator = /** @class */ (function () {
                function MergeScanOperator(accumulator, seed, concurrent) {
                    this.accumulator = accumulator;
                    this.seed = seed;
                    this.concurrent = concurrent;
                }
                MergeScanOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
                };
                return MergeScanOperator;
            }());
            var MergeScanSubscriber = /** @class */ (function (_super_1) {
                __extends(MergeScanSubscriber, _super_1);
                function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.accumulator = accumulator;
                    _this.acc = acc;
                    _this.concurrent = concurrent;
                    _this.hasValue = false;
                    _this.hasCompleted = false;
                    _this.buffer = [];
                    _this.active = 0;
                    _this.index = 0;
                    return _this;
                }
                MergeScanSubscriber.prototype._next = function (value) {
                    if (this.active < this.concurrent) {
                        var index = this.index++;
                        var destination = this.destination;
                        var ish = void 0;
                        try {
                            var accumulator = this.accumulator;
                            ish = accumulator(this.acc, value, index);
                        }
                        catch (e) {
                            return destination.error(e);
                        }
                        this.active++;
                        this._innerSub(ish, value, index);
                    }
                    else {
                        this.buffer.push(value);
                    }
                };
                MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
                    var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_2__["InnerSubscriber"](this, undefined, undefined);
                    var destination = this.destination;
                    destination.add(innerSubscriber);
                    Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_0__["subscribeToResult"])(this, ish, value, index, innerSubscriber);
                };
                MergeScanSubscriber.prototype._complete = function () {
                    this.hasCompleted = true;
                    if (this.active === 0 && this.buffer.length === 0) {
                        if (this.hasValue === false) {
                            this.destination.next(this.acc);
                        }
                        this.destination.complete();
                    }
                    this.unsubscribe();
                };
                MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    var destination = this.destination;
                    this.acc = innerValue;
                    this.hasValue = true;
                    destination.next(innerValue);
                };
                MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
                    var buffer = this.buffer;
                    var destination = this.destination;
                    destination.remove(innerSub);
                    this.active--;
                    if (buffer.length > 0) {
                        this._next(buffer.shift());
                    }
                    else if (this.active === 0 && this.hasCompleted) {
                        if (this.hasValue === false) {
                            this.destination.next(this.acc);
                        }
                        this.destination.complete();
                    }
                };
                return MergeScanSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=mergeScan.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/min.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/min.js ***!
          \**************************************************************/
        /*! exports provided: min */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "min", function () { return min; });
            /* harmony import */ var _reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reduce */ "./node_modules/rxjs/_esm2015/internal/operators/reduce.js");
            function min(comparer) {
                var min = (typeof comparer === 'function')
                    ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
                    : function (x, y) { return x < y ? x : y; };
                return Object(_reduce__WEBPACK_IMPORTED_MODULE_0__["reduce"])(min);
            }
            //# sourceMappingURL=min.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/multicast.js ***!
          \********************************************************************/
        /*! exports provided: multicast, MulticastOperator */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multicast", function () { return multicast; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MulticastOperator", function () { return MulticastOperator; });
            /* harmony import */ var _observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/ConnectableObservable */ "./node_modules/rxjs/_esm2015/internal/observable/ConnectableObservable.js");
            function multicast(subjectOrSubjectFactory, selector) {
                return function multicastOperatorFunction(source) {
                    var subjectFactory;
                    if (typeof subjectOrSubjectFactory === 'function') {
                        subjectFactory = subjectOrSubjectFactory;
                    }
                    else {
                        subjectFactory = function subjectFactory() {
                            return subjectOrSubjectFactory;
                        };
                    }
                    if (typeof selector === 'function') {
                        return source.lift(new MulticastOperator(subjectFactory, selector));
                    }
                    var connectable = Object.create(source, _observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_0__["connectableObservableDescriptor"]);
                    connectable.source = source;
                    connectable.subjectFactory = subjectFactory;
                    return connectable;
                };
            }
            var MulticastOperator = /** @class */ (function () {
                function MulticastOperator(subjectFactory, selector) {
                    this.subjectFactory = subjectFactory;
                    this.selector = selector;
                }
                MulticastOperator.prototype.call = function (subscriber, source) {
                    var selector = this.selector;
                    var subject = this.subjectFactory();
                    var subscription = selector(subject).subscribe(subscriber);
                    subscription.add(source.subscribe(subject));
                    return subscription;
                };
                return MulticastOperator;
            }());
            //# sourceMappingURL=multicast.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/observeOn.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/observeOn.js ***!
          \********************************************************************/
        /*! exports provided: observeOn, ObserveOnOperator, ObserveOnSubscriber, ObserveOnMessage */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observeOn", function () { return observeOn; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserveOnOperator", function () { return ObserveOnOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserveOnSubscriber", function () { return ObserveOnSubscriber; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserveOnMessage", function () { return ObserveOnMessage; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Notification */ "./node_modules/rxjs/_esm2015/internal/Notification.js");
            function observeOn(scheduler, delay) {
                if (delay === void 0) { delay = 0; }
                return function observeOnOperatorFunction(source) {
                    return source.lift(new ObserveOnOperator(scheduler, delay));
                };
            }
            var ObserveOnOperator = /** @class */ (function () {
                function ObserveOnOperator(scheduler, delay) {
                    if (delay === void 0) { delay = 0; }
                    this.scheduler = scheduler;
                    this.delay = delay;
                }
                ObserveOnOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
                };
                return ObserveOnOperator;
            }());
            var ObserveOnSubscriber = /** @class */ (function (_super_1) {
                __extends(ObserveOnSubscriber, _super_1);
                function ObserveOnSubscriber(destination, scheduler, delay) {
                    if (delay === void 0) { delay = 0; }
                    var _this = _super_1.call(this, destination) || this;
                    _this.scheduler = scheduler;
                    _this.delay = delay;
                    return _this;
                }
                ObserveOnSubscriber.dispatch = function (arg) {
                    var notification = arg.notification, destination = arg.destination;
                    notification.observe(destination);
                    this.unsubscribe();
                };
                ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
                    var destination = this.destination;
                    destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
                };
                ObserveOnSubscriber.prototype._next = function (value) {
                    this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_1__["Notification"].createNext(value));
                };
                ObserveOnSubscriber.prototype._error = function (err) {
                    this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_1__["Notification"].createError(err));
                    this.unsubscribe();
                };
                ObserveOnSubscriber.prototype._complete = function () {
                    this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_1__["Notification"].createComplete());
                    this.unsubscribe();
                };
                return ObserveOnSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            var ObserveOnMessage = /** @class */ (function () {
                function ObserveOnMessage(notification, destination) {
                    this.notification = notification;
                    this.destination = destination;
                }
                return ObserveOnMessage;
            }());
            //# sourceMappingURL=observeOn.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/onErrorResumeNext.js": 
        /*!****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/onErrorResumeNext.js ***!
          \****************************************************************************/
        /*! exports provided: onErrorResumeNext, onErrorResumeNextStatic */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function () { return onErrorResumeNext; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNextStatic", function () { return onErrorResumeNextStatic; });
            /* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function onErrorResumeNext() {
                var nextSources = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    nextSources[_c] = arguments[_c];
                }
                if (nextSources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(nextSources[0])) {
                    nextSources = nextSources[0];
                }
                return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
            }
            function onErrorResumeNextStatic() {
                var nextSources = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    nextSources[_c] = arguments[_c];
                }
                var source = null;
                if (nextSources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(nextSources[0])) {
                    nextSources = nextSources[0];
                }
                source = nextSources.shift();
                return Object(_observable_from__WEBPACK_IMPORTED_MODULE_0__["from"])(source, null).lift(new OnErrorResumeNextOperator(nextSources));
            }
            var OnErrorResumeNextOperator = /** @class */ (function () {
                function OnErrorResumeNextOperator(nextSources) {
                    this.nextSources = nextSources;
                }
                OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
                };
                return OnErrorResumeNextOperator;
            }());
            var OnErrorResumeNextSubscriber = /** @class */ (function (_super_1) {
                __extends(OnErrorResumeNextSubscriber, _super_1);
                function OnErrorResumeNextSubscriber(destination, nextSources) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.destination = destination;
                    _this.nextSources = nextSources;
                    return _this;
                }
                OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
                    this.subscribeToNextSource();
                };
                OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
                    this.subscribeToNextSource();
                };
                OnErrorResumeNextSubscriber.prototype._error = function (err) {
                    this.subscribeToNextSource();
                    this.unsubscribe();
                };
                OnErrorResumeNextSubscriber.prototype._complete = function () {
                    this.subscribeToNextSource();
                    this.unsubscribe();
                };
                OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
                    var next = this.nextSources.shift();
                    if (!!next) {
                        var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_3__["InnerSubscriber"](this, undefined, undefined);
                        var destination = this.destination;
                        destination.add(innerSubscriber);
                        Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(this, next, undefined, undefined, innerSubscriber);
                    }
                    else {
                        this.destination.complete();
                    }
                };
                return OnErrorResumeNextSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            //# sourceMappingURL=onErrorResumeNext.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/pairwise.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/pairwise.js ***!
          \*******************************************************************/
        /*! exports provided: pairwise */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pairwise", function () { return pairwise; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function pairwise() {
                return function (source) { return source.lift(new PairwiseOperator()); };
            }
            var PairwiseOperator = /** @class */ (function () {
                function PairwiseOperator() {
                }
                PairwiseOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new PairwiseSubscriber(subscriber));
                };
                return PairwiseOperator;
            }());
            var PairwiseSubscriber = /** @class */ (function (_super_1) {
                __extends(PairwiseSubscriber, _super_1);
                function PairwiseSubscriber(destination) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.hasPrev = false;
                    return _this;
                }
                PairwiseSubscriber.prototype._next = function (value) {
                    var pair;
                    if (this.hasPrev) {
                        pair = [this.prev, value];
                    }
                    else {
                        this.hasPrev = true;
                    }
                    this.prev = value;
                    if (pair) {
                        this.destination.next(pair);
                    }
                };
                return PairwiseSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=pairwise.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/partition.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/partition.js ***!
          \********************************************************************/
        /*! exports provided: partition */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function () { return partition; });
            /* harmony import */ var _util_not__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/not */ "./node_modules/rxjs/_esm2015/internal/util/not.js");
            /* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm2015/internal/operators/filter.js");
            function partition(predicate, thisArg) {
                return function (source) { return [
                    Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(predicate, thisArg)(source),
                    Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(Object(_util_not__WEBPACK_IMPORTED_MODULE_0__["not"])(predicate, thisArg))(source)
                ]; };
            }
            //# sourceMappingURL=partition.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/pluck.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/pluck.js ***!
          \****************************************************************/
        /*! exports provided: pluck */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function () { return pluck; });
            /* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            function pluck() {
                var properties = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    properties[_c] = arguments[_c];
                }
                var length = properties.length;
                if (length === 0) {
                    throw new Error('list of properties cannot be empty.');
                }
                return function (source) { return Object(_map__WEBPACK_IMPORTED_MODULE_0__["map"])(plucker(properties, length))(source); };
            }
            function plucker(props, length) {
                var mapper = function (x) {
                    var currentProp = x;
                    for (var i = 0; i < length; i++) {
                        var p = currentProp[props[i]];
                        if (typeof p !== 'undefined') {
                            currentProp = p;
                        }
                        else {
                            return undefined;
                        }
                    }
                    return currentProp;
                };
                return mapper;
            }
            //# sourceMappingURL=pluck.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/publish.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/publish.js ***!
          \******************************************************************/
        /*! exports provided: publish */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publish", function () { return publish; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js");
            function publish(selector) {
                return selector ?
                    Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(function () { return new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"](); }, selector) :
                    Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]());
            }
            //# sourceMappingURL=publish.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/publishBehavior.js": 
        /*!**************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/publishBehavior.js ***!
          \**************************************************************************/
        /*! exports provided: publishBehavior */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishBehavior", function () { return publishBehavior; });
            /* harmony import */ var _BehaviorSubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../BehaviorSubject */ "./node_modules/rxjs/_esm2015/internal/BehaviorSubject.js");
            /* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js");
            function publishBehavior(value) {
                return function (source) { return Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(new _BehaviorSubject__WEBPACK_IMPORTED_MODULE_0__["BehaviorSubject"](value))(source); };
            }
            //# sourceMappingURL=publishBehavior.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/publishLast.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/publishLast.js ***!
          \**********************************************************************/
        /*! exports provided: publishLast */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishLast", function () { return publishLast; });
            /* harmony import */ var _AsyncSubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../AsyncSubject */ "./node_modules/rxjs/_esm2015/internal/AsyncSubject.js");
            /* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js");
            function publishLast() {
                return function (source) { return Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(new _AsyncSubject__WEBPACK_IMPORTED_MODULE_0__["AsyncSubject"]())(source); };
            }
            //# sourceMappingURL=publishLast.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/publishReplay.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/publishReplay.js ***!
          \************************************************************************/
        /*! exports provided: publishReplay */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishReplay", function () { return publishReplay; });
            /* harmony import */ var _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ReplaySubject */ "./node_modules/rxjs/_esm2015/internal/ReplaySubject.js");
            /* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js");
            function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
                if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
                    scheduler = selectorOrScheduler;
                }
                var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
                var subject = new _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__["ReplaySubject"](bufferSize, windowTime, scheduler);
                return function (source) { return Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(function () { return subject; }, selector)(source); };
            }
            //# sourceMappingURL=publishReplay.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/race.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/race.js ***!
          \***************************************************************/
        /*! exports provided: race */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "race", function () { return race; });
            /* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            /* harmony import */ var _observable_race__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/race */ "./node_modules/rxjs/_esm2015/internal/observable/race.js");
            function race() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                return function raceOperatorFunction(source) {
                    if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(observables[0])) {
                        observables = observables[0];
                    }
                    return source.lift.call(Object(_observable_race__WEBPACK_IMPORTED_MODULE_1__["race"]).apply(void 0, [source].concat(observables)));
                };
            }
            //# sourceMappingURL=race.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/reduce.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/reduce.js ***!
          \*****************************************************************/
        /*! exports provided: reduce */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function () { return reduce; });
            /* harmony import */ var _scan__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scan */ "./node_modules/rxjs/_esm2015/internal/operators/scan.js");
            /* harmony import */ var _takeLast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./takeLast */ "./node_modules/rxjs/_esm2015/internal/operators/takeLast.js");
            /* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js");
            /* harmony import */ var _util_pipe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/pipe */ "./node_modules/rxjs/_esm2015/internal/util/pipe.js");
            function reduce(accumulator, seed) {
                if (arguments.length >= 2) {
                    return function reduceOperatorFunctionWithSeed(source) {
                        return Object(_util_pipe__WEBPACK_IMPORTED_MODULE_3__["pipe"])(Object(_scan__WEBPACK_IMPORTED_MODULE_0__["scan"])(accumulator, seed), Object(_takeLast__WEBPACK_IMPORTED_MODULE_1__["takeLast"])(1), Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_2__["defaultIfEmpty"])(seed))(source);
                    };
                }
                return function reduceOperatorFunction(source) {
                    return Object(_util_pipe__WEBPACK_IMPORTED_MODULE_3__["pipe"])(Object(_scan__WEBPACK_IMPORTED_MODULE_0__["scan"])(function (acc, value, index) { return accumulator(acc, value, index + 1); }), Object(_takeLast__WEBPACK_IMPORTED_MODULE_1__["takeLast"])(1))(source);
                };
            }
            //# sourceMappingURL=reduce.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/refCount.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/refCount.js ***!
          \*******************************************************************/
        /*! exports provided: refCount */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refCount", function () { return refCount; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function refCount() {
                return function refCountOperatorFunction(source) {
                    return source.lift(new RefCountOperator(source));
                };
            }
            var RefCountOperator = /** @class */ (function () {
                function RefCountOperator(connectable) {
                    this.connectable = connectable;
                }
                RefCountOperator.prototype.call = function (subscriber, source) {
                    var connectable = this.connectable;
                    connectable._refCount++;
                    var refCounter = new RefCountSubscriber(subscriber, connectable);
                    var subscription = source.subscribe(refCounter);
                    if (!refCounter.closed) {
                        refCounter.connection = connectable.connect();
                    }
                    return subscription;
                };
                return RefCountOperator;
            }());
            var RefCountSubscriber = /** @class */ (function (_super_1) {
                __extends(RefCountSubscriber, _super_1);
                function RefCountSubscriber(destination, connectable) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.connectable = connectable;
                    return _this;
                }
                RefCountSubscriber.prototype._unsubscribe = function () {
                    var connectable = this.connectable;
                    if (!connectable) {
                        this.connection = null;
                        return;
                    }
                    this.connectable = null;
                    var refCount = connectable._refCount;
                    if (refCount <= 0) {
                        this.connection = null;
                        return;
                    }
                    connectable._refCount = refCount - 1;
                    if (refCount > 1) {
                        this.connection = null;
                        return;
                    }
                    var connection = this.connection;
                    var sharedConnection = connectable._connection;
                    this.connection = null;
                    if (sharedConnection && (!connection || sharedConnection === connection)) {
                        sharedConnection.unsubscribe();
                    }
                };
                return RefCountSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=refCount.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/repeat.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/repeat.js ***!
          \*****************************************************************/
        /*! exports provided: repeat */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "repeat", function () { return repeat; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function repeat(count) {
                if (count === void 0) { count = -1; }
                return function (source) {
                    if (count === 0) {
                        return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_1__["empty"])();
                    }
                    else if (count < 0) {
                        return source.lift(new RepeatOperator(-1, source));
                    }
                    else {
                        return source.lift(new RepeatOperator(count - 1, source));
                    }
                };
            }
            var RepeatOperator = /** @class */ (function () {
                function RepeatOperator(count, source) {
                    this.count = count;
                    this.source = source;
                }
                RepeatOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
                };
                return RepeatOperator;
            }());
            var RepeatSubscriber = /** @class */ (function (_super_1) {
                __extends(RepeatSubscriber, _super_1);
                function RepeatSubscriber(destination, count, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.count = count;
                    _this.source = source;
                    return _this;
                }
                RepeatSubscriber.prototype.complete = function () {
                    if (!this.isStopped) {
                        var _c = this, source = _c.source, count = _c.count;
                        if (count === 0) {
                            return _super_1.prototype.complete.call(this);
                        }
                        else if (count > -1) {
                            this.count = count - 1;
                        }
                        source.subscribe(this._unsubscribeAndRecycle());
                    }
                };
                return RepeatSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=repeat.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/repeatWhen.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/repeatWhen.js ***!
          \*********************************************************************/
        /*! exports provided: repeatWhen */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "repeatWhen", function () { return repeatWhen; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function repeatWhen(notifier) {
                return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
            }
            var RepeatWhenOperator = /** @class */ (function () {
                function RepeatWhenOperator(notifier) {
                    this.notifier = notifier;
                }
                RepeatWhenOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
                };
                return RepeatWhenOperator;
            }());
            var RepeatWhenSubscriber = /** @class */ (function (_super_1) {
                __extends(RepeatWhenSubscriber, _super_1);
                function RepeatWhenSubscriber(destination, notifier, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.notifier = notifier;
                    _this.source = source;
                    _this.sourceIsBeingSubscribedTo = true;
                    return _this;
                }
                RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.sourceIsBeingSubscribedTo = true;
                    this.source.subscribe(this);
                };
                RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
                    if (this.sourceIsBeingSubscribedTo === false) {
                        return _super_1.prototype.complete.call(this);
                    }
                };
                RepeatWhenSubscriber.prototype.complete = function () {
                    this.sourceIsBeingSubscribedTo = false;
                    if (!this.isStopped) {
                        if (!this.retries) {
                            this.subscribeToRetries();
                        }
                        if (!this.retriesSubscription || this.retriesSubscription.closed) {
                            return _super_1.prototype.complete.call(this);
                        }
                        this._unsubscribeAndRecycle();
                        this.notifications.next();
                    }
                };
                RepeatWhenSubscriber.prototype._unsubscribe = function () {
                    var _c = this, notifications = _c.notifications, retriesSubscription = _c.retriesSubscription;
                    if (notifications) {
                        notifications.unsubscribe();
                        this.notifications = null;
                    }
                    if (retriesSubscription) {
                        retriesSubscription.unsubscribe();
                        this.retriesSubscription = null;
                    }
                    this.retries = null;
                };
                RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
                    var _unsubscribe = this._unsubscribe;
                    this._unsubscribe = null;
                    _super_1.prototype._unsubscribeAndRecycle.call(this);
                    this._unsubscribe = _unsubscribe;
                    return this;
                };
                RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
                    this.notifications = new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    var retries;
                    try {
                        var notifier = this.notifier;
                        retries = notifier(this.notifications);
                    }
                    catch (e) {
                        return _super_1.prototype.complete.call(this);
                    }
                    this.retries = retries;
                    this.retriesSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, retries);
                };
                return RepeatWhenSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=repeatWhen.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/retry.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/retry.js ***!
          \****************************************************************/
        /*! exports provided: retry */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retry", function () { return retry; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function retry(count) {
                if (count === void 0) { count = -1; }
                return function (source) { return source.lift(new RetryOperator(count, source)); };
            }
            var RetryOperator = /** @class */ (function () {
                function RetryOperator(count, source) {
                    this.count = count;
                    this.source = source;
                }
                RetryOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
                };
                return RetryOperator;
            }());
            var RetrySubscriber = /** @class */ (function (_super_1) {
                __extends(RetrySubscriber, _super_1);
                function RetrySubscriber(destination, count, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.count = count;
                    _this.source = source;
                    return _this;
                }
                RetrySubscriber.prototype.error = function (err) {
                    if (!this.isStopped) {
                        var _c = this, source = _c.source, count = _c.count;
                        if (count === 0) {
                            return _super_1.prototype.error.call(this, err);
                        }
                        else if (count > -1) {
                            this.count = count - 1;
                        }
                        source.subscribe(this._unsubscribeAndRecycle());
                    }
                };
                return RetrySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=retry.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/retryWhen.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/retryWhen.js ***!
          \********************************************************************/
        /*! exports provided: retryWhen */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retryWhen", function () { return retryWhen; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function retryWhen(notifier) {
                return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
            }
            var RetryWhenOperator = /** @class */ (function () {
                function RetryWhenOperator(notifier, source) {
                    this.notifier = notifier;
                    this.source = source;
                }
                RetryWhenOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
                };
                return RetryWhenOperator;
            }());
            var RetryWhenSubscriber = /** @class */ (function (_super_1) {
                __extends(RetryWhenSubscriber, _super_1);
                function RetryWhenSubscriber(destination, notifier, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.notifier = notifier;
                    _this.source = source;
                    return _this;
                }
                RetryWhenSubscriber.prototype.error = function (err) {
                    if (!this.isStopped) {
                        var errors = this.errors;
                        var retries = this.retries;
                        var retriesSubscription = this.retriesSubscription;
                        if (!retries) {
                            errors = new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                            try {
                                var notifier = this.notifier;
                                retries = notifier(errors);
                            }
                            catch (e) {
                                return _super_1.prototype.error.call(this, e);
                            }
                            retriesSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, retries);
                        }
                        else {
                            this.errors = null;
                            this.retriesSubscription = null;
                        }
                        this._unsubscribeAndRecycle();
                        this.errors = errors;
                        this.retries = retries;
                        this.retriesSubscription = retriesSubscription;
                        errors.next(err);
                    }
                };
                RetryWhenSubscriber.prototype._unsubscribe = function () {
                    var _c = this, errors = _c.errors, retriesSubscription = _c.retriesSubscription;
                    if (errors) {
                        errors.unsubscribe();
                        this.errors = null;
                    }
                    if (retriesSubscription) {
                        retriesSubscription.unsubscribe();
                        this.retriesSubscription = null;
                    }
                    this.retries = null;
                };
                RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    var _unsubscribe = this._unsubscribe;
                    this._unsubscribe = null;
                    this._unsubscribeAndRecycle();
                    this._unsubscribe = _unsubscribe;
                    this.source.subscribe(this);
                };
                return RetryWhenSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=retryWhen.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/sample.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/sample.js ***!
          \*****************************************************************/
        /*! exports provided: sample */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function () { return sample; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function sample(notifier) {
                return function (source) { return source.lift(new SampleOperator(notifier)); };
            }
            var SampleOperator = /** @class */ (function () {
                function SampleOperator(notifier) {
                    this.notifier = notifier;
                }
                SampleOperator.prototype.call = function (subscriber, source) {
                    var sampleSubscriber = new SampleSubscriber(subscriber);
                    var subscription = source.subscribe(sampleSubscriber);
                    subscription.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(sampleSubscriber, this.notifier));
                    return subscription;
                };
                return SampleOperator;
            }());
            var SampleSubscriber = /** @class */ (function (_super_1) {
                __extends(SampleSubscriber, _super_1);
                function SampleSubscriber() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this.hasValue = false;
                    return _this;
                }
                SampleSubscriber.prototype._next = function (value) {
                    this.value = value;
                    this.hasValue = true;
                };
                SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.emitValue();
                };
                SampleSubscriber.prototype.notifyComplete = function () {
                    this.emitValue();
                };
                SampleSubscriber.prototype.emitValue = function () {
                    if (this.hasValue) {
                        this.hasValue = false;
                        this.destination.next(this.value);
                    }
                };
                return SampleSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=sample.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/sampleTime.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/sampleTime.js ***!
          \*********************************************************************/
        /*! exports provided: sampleTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sampleTime", function () { return sampleTime; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            function sampleTime(period, scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"]; }
                return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
            }
            var SampleTimeOperator = /** @class */ (function () {
                function SampleTimeOperator(period, scheduler) {
                    this.period = period;
                    this.scheduler = scheduler;
                }
                SampleTimeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
                };
                return SampleTimeOperator;
            }());
            var SampleTimeSubscriber = /** @class */ (function (_super_1) {
                __extends(SampleTimeSubscriber, _super_1);
                function SampleTimeSubscriber(destination, period, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.period = period;
                    _this.scheduler = scheduler;
                    _this.hasValue = false;
                    _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
                    return _this;
                }
                SampleTimeSubscriber.prototype._next = function (value) {
                    this.lastValue = value;
                    this.hasValue = true;
                };
                SampleTimeSubscriber.prototype.notifyNext = function () {
                    if (this.hasValue) {
                        this.hasValue = false;
                        this.destination.next(this.lastValue);
                    }
                };
                return SampleTimeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            function dispatchNotification(state) {
                var subscriber = state.subscriber, period = state.period;
                subscriber.notifyNext();
                this.schedule(state, period);
            }
            //# sourceMappingURL=sampleTime.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/scan.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/scan.js ***!
          \***************************************************************/
        /*! exports provided: scan */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function () { return scan; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function scan(accumulator, seed) {
                var hasSeed = false;
                if (arguments.length >= 2) {
                    hasSeed = true;
                }
                return function scanOperatorFunction(source) {
                    return source.lift(new ScanOperator(accumulator, seed, hasSeed));
                };
            }
            var ScanOperator = /** @class */ (function () {
                function ScanOperator(accumulator, seed, hasSeed) {
                    if (hasSeed === void 0) { hasSeed = false; }
                    this.accumulator = accumulator;
                    this.seed = seed;
                    this.hasSeed = hasSeed;
                }
                ScanOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
                };
                return ScanOperator;
            }());
            var ScanSubscriber = /** @class */ (function (_super_1) {
                __extends(ScanSubscriber, _super_1);
                function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.accumulator = accumulator;
                    _this._seed = _seed;
                    _this.hasSeed = hasSeed;
                    _this.index = 0;
                    return _this;
                }
                Object.defineProperty(ScanSubscriber.prototype, "seed", {
                    get: function () {
                        return this._seed;
                    },
                    set: function (value) {
                        this.hasSeed = true;
                        this._seed = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                ScanSubscriber.prototype._next = function (value) {
                    if (!this.hasSeed) {
                        this.seed = value;
                        this.destination.next(value);
                    }
                    else {
                        return this._tryNext(value);
                    }
                };
                ScanSubscriber.prototype._tryNext = function (value) {
                    var index = this.index++;
                    var result;
                    try {
                        result = this.accumulator(this.seed, value, index);
                    }
                    catch (err) {
                        this.destination.error(err);
                    }
                    this.seed = result;
                    this.destination.next(result);
                };
                return ScanSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=scan.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/sequenceEqual.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/sequenceEqual.js ***!
          \************************************************************************/
        /*! exports provided: sequenceEqual, SequenceEqualOperator, SequenceEqualSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequenceEqual", function () { return sequenceEqual; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceEqualOperator", function () { return SequenceEqualOperator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceEqualSubscriber", function () { return SequenceEqualSubscriber; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function sequenceEqual(compareTo, comparator) {
                return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparator)); };
            }
            var SequenceEqualOperator = /** @class */ (function () {
                function SequenceEqualOperator(compareTo, comparator) {
                    this.compareTo = compareTo;
                    this.comparator = comparator;
                }
                SequenceEqualOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
                };
                return SequenceEqualOperator;
            }());
            var SequenceEqualSubscriber = /** @class */ (function (_super_1) {
                __extends(SequenceEqualSubscriber, _super_1);
                function SequenceEqualSubscriber(destination, compareTo, comparator) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.compareTo = compareTo;
                    _this.comparator = comparator;
                    _this._a = [];
                    _this._b = [];
                    _this._oneComplete = false;
                    _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
                    return _this;
                }
                SequenceEqualSubscriber.prototype._next = function (value) {
                    if (this._oneComplete && this._b.length === 0) {
                        this.emit(false);
                    }
                    else {
                        this._a.push(value);
                        this.checkValues();
                    }
                };
                SequenceEqualSubscriber.prototype._complete = function () {
                    if (this._oneComplete) {
                        this.emit(this._a.length === 0 && this._b.length === 0);
                    }
                    else {
                        this._oneComplete = true;
                    }
                    this.unsubscribe();
                };
                SequenceEqualSubscriber.prototype.checkValues = function () {
                    var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
                    while (_a.length > 0 && _b.length > 0) {
                        var a = _a.shift();
                        var b = _b.shift();
                        var areEqual = false;
                        try {
                            areEqual = comparator ? comparator(a, b) : a === b;
                        }
                        catch (e) {
                            this.destination.error(e);
                        }
                        if (!areEqual) {
                            this.emit(false);
                        }
                    }
                };
                SequenceEqualSubscriber.prototype.emit = function (value) {
                    var destination = this.destination;
                    destination.next(value);
                    destination.complete();
                };
                SequenceEqualSubscriber.prototype.nextB = function (value) {
                    if (this._oneComplete && this._a.length === 0) {
                        this.emit(false);
                    }
                    else {
                        this._b.push(value);
                        this.checkValues();
                    }
                };
                SequenceEqualSubscriber.prototype.completeB = function () {
                    if (this._oneComplete) {
                        this.emit(this._a.length === 0 && this._b.length === 0);
                    }
                    else {
                        this._oneComplete = true;
                    }
                };
                return SequenceEqualSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            var SequenceEqualCompareToSubscriber = /** @class */ (function (_super_1) {
                __extends(SequenceEqualCompareToSubscriber, _super_1);
                function SequenceEqualCompareToSubscriber(destination, parent) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.parent = parent;
                    return _this;
                }
                SequenceEqualCompareToSubscriber.prototype._next = function (value) {
                    this.parent.nextB(value);
                };
                SequenceEqualCompareToSubscriber.prototype._error = function (err) {
                    this.parent.error(err);
                    this.unsubscribe();
                };
                SequenceEqualCompareToSubscriber.prototype._complete = function () {
                    this.parent.completeB();
                    this.unsubscribe();
                };
                return SequenceEqualCompareToSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=sequenceEqual.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/share.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/share.js ***!
          \****************************************************************/
        /*! exports provided: share */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "share", function () { return share; });
            /* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js");
            /* harmony import */ var _refCount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./refCount */ "./node_modules/rxjs/_esm2015/internal/operators/refCount.js");
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            function shareSubjectFactory() {
                return new _Subject__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
            }
            function share() {
                return function (source) { return Object(_refCount__WEBPACK_IMPORTED_MODULE_1__["refCount"])()(Object(_multicast__WEBPACK_IMPORTED_MODULE_0__["multicast"])(shareSubjectFactory)(source)); };
            }
            //# sourceMappingURL=share.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/shareReplay.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/shareReplay.js ***!
          \**********************************************************************/
        /*! exports provided: shareReplay */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shareReplay", function () { return shareReplay; });
            /* harmony import */ var _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ReplaySubject */ "./node_modules/rxjs/_esm2015/internal/ReplaySubject.js");
            function shareReplay(configOrBufferSize, windowTime, scheduler) {
                var config;
                if (configOrBufferSize && typeof configOrBufferSize === 'object') {
                    config = configOrBufferSize;
                }
                else {
                    config = {
                        bufferSize: configOrBufferSize,
                        windowTime: windowTime,
                        refCount: false,
                        scheduler: scheduler
                    };
                }
                return function (source) { return source.lift(shareReplayOperator(config)); };
            }
            function shareReplayOperator(_c) {
                var _d = _c.bufferSize, bufferSize = _d === void 0 ? Number.POSITIVE_INFINITY : _d, _e = _c.windowTime, windowTime = _e === void 0 ? Number.POSITIVE_INFINITY : _e, useRefCount = _c.refCount, scheduler = _c.scheduler;
                var subject;
                var refCount = 0;
                var subscription;
                var hasError = false;
                var isComplete = false;
                return function shareReplayOperation(source) {
                    refCount++;
                    if (!subject || hasError) {
                        hasError = false;
                        subject = new _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__["ReplaySubject"](bufferSize, windowTime, scheduler);
                        subscription = source.subscribe({
                            next: function (value) { subject.next(value); },
                            error: function (err) {
                                hasError = true;
                                subject.error(err);
                            },
                            complete: function () {
                                isComplete = true;
                                subject.complete();
                            },
                        });
                    }
                    var innerSub = subject.subscribe(this);
                    this.add(function () {
                        refCount--;
                        innerSub.unsubscribe();
                        if (subscription && !isComplete && useRefCount && refCount === 0) {
                            subscription.unsubscribe();
                            subscription = undefined;
                            subject = undefined;
                        }
                    });
                };
            }
            //# sourceMappingURL=shareReplay.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/single.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/single.js ***!
          \*****************************************************************/
        /*! exports provided: single */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "single", function () { return single; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm2015/internal/util/EmptyError.js");
            function single(predicate) {
                return function (source) { return source.lift(new SingleOperator(predicate, source)); };
            }
            var SingleOperator = /** @class */ (function () {
                function SingleOperator(predicate, source) {
                    this.predicate = predicate;
                    this.source = source;
                }
                SingleOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
                };
                return SingleOperator;
            }());
            var SingleSubscriber = /** @class */ (function (_super_1) {
                __extends(SingleSubscriber, _super_1);
                function SingleSubscriber(destination, predicate, source) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.source = source;
                    _this.seenValue = false;
                    _this.index = 0;
                    return _this;
                }
                SingleSubscriber.prototype.applySingleValue = function (value) {
                    if (this.seenValue) {
                        this.destination.error('Sequence contains more than one element');
                    }
                    else {
                        this.seenValue = true;
                        this.singleValue = value;
                    }
                };
                SingleSubscriber.prototype._next = function (value) {
                    var index = this.index++;
                    if (this.predicate) {
                        this.tryNext(value, index);
                    }
                    else {
                        this.applySingleValue(value);
                    }
                };
                SingleSubscriber.prototype.tryNext = function (value, index) {
                    try {
                        if (this.predicate(value, index, this.source)) {
                            this.applySingleValue(value);
                        }
                    }
                    catch (err) {
                        this.destination.error(err);
                    }
                };
                SingleSubscriber.prototype._complete = function () {
                    var destination = this.destination;
                    if (this.index > 0) {
                        destination.next(this.seenValue ? this.singleValue : undefined);
                        destination.complete();
                    }
                    else {
                        destination.error(new _util_EmptyError__WEBPACK_IMPORTED_MODULE_1__["EmptyError"]);
                    }
                };
                return SingleSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=single.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/skip.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/skip.js ***!
          \***************************************************************/
        /*! exports provided: skip */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skip", function () { return skip; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function skip(count) {
                return function (source) { return source.lift(new SkipOperator(count)); };
            }
            var SkipOperator = /** @class */ (function () {
                function SkipOperator(total) {
                    this.total = total;
                }
                SkipOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SkipSubscriber(subscriber, this.total));
                };
                return SkipOperator;
            }());
            var SkipSubscriber = /** @class */ (function (_super_1) {
                __extends(SkipSubscriber, _super_1);
                function SkipSubscriber(destination, total) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.total = total;
                    _this.count = 0;
                    return _this;
                }
                SkipSubscriber.prototype._next = function (x) {
                    if (++this.count > this.total) {
                        this.destination.next(x);
                    }
                };
                return SkipSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=skip.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/skipLast.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/skipLast.js ***!
          \*******************************************************************/
        /*! exports provided: skipLast */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipLast", function () { return skipLast; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js");
            function skipLast(count) {
                return function (source) { return source.lift(new SkipLastOperator(count)); };
            }
            var SkipLastOperator = /** @class */ (function () {
                function SkipLastOperator(_skipCount) {
                    this._skipCount = _skipCount;
                    if (this._skipCount < 0) {
                        throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_1__["ArgumentOutOfRangeError"];
                    }
                }
                SkipLastOperator.prototype.call = function (subscriber, source) {
                    if (this._skipCount === 0) {
                        return source.subscribe(new _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"](subscriber));
                    }
                    else {
                        return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
                    }
                };
                return SkipLastOperator;
            }());
            var SkipLastSubscriber = /** @class */ (function (_super_1) {
                __extends(SkipLastSubscriber, _super_1);
                function SkipLastSubscriber(destination, _skipCount) {
                    var _this = _super_1.call(this, destination) || this;
                    _this._skipCount = _skipCount;
                    _this._count = 0;
                    _this._ring = new Array(_skipCount);
                    return _this;
                }
                SkipLastSubscriber.prototype._next = function (value) {
                    var skipCount = this._skipCount;
                    var count = this._count++;
                    if (count < skipCount) {
                        this._ring[count] = value;
                    }
                    else {
                        var currentIndex = count % skipCount;
                        var ring = this._ring;
                        var oldValue = ring[currentIndex];
                        ring[currentIndex] = value;
                        this.destination.next(oldValue);
                    }
                };
                return SkipLastSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=skipLast.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/skipUntil.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/skipUntil.js ***!
          \********************************************************************/
        /*! exports provided: skipUntil */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipUntil", function () { return skipUntil; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function skipUntil(notifier) {
                return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
            }
            var SkipUntilOperator = /** @class */ (function () {
                function SkipUntilOperator(notifier) {
                    this.notifier = notifier;
                }
                SkipUntilOperator.prototype.call = function (destination, source) {
                    return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
                };
                return SkipUntilOperator;
            }());
            var SkipUntilSubscriber = /** @class */ (function (_super_1) {
                __extends(SkipUntilSubscriber, _super_1);
                function SkipUntilSubscriber(destination, notifier) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.hasValue = false;
                    var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__["InnerSubscriber"](_this, undefined, undefined);
                    _this.add(innerSubscriber);
                    _this.innerSubscription = innerSubscriber;
                    Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(_this, notifier, undefined, undefined, innerSubscriber);
                    return _this;
                }
                SkipUntilSubscriber.prototype._next = function (value) {
                    if (this.hasValue) {
                        _super_1.prototype._next.call(this, value);
                    }
                };
                SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.hasValue = true;
                    if (this.innerSubscription) {
                        this.innerSubscription.unsubscribe();
                    }
                };
                SkipUntilSubscriber.prototype.notifyComplete = function () {
                };
                return SkipUntilSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=skipUntil.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/skipWhile.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/skipWhile.js ***!
          \********************************************************************/
        /*! exports provided: skipWhile */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipWhile", function () { return skipWhile; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function skipWhile(predicate) {
                return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
            }
            var SkipWhileOperator = /** @class */ (function () {
                function SkipWhileOperator(predicate) {
                    this.predicate = predicate;
                }
                SkipWhileOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
                };
                return SkipWhileOperator;
            }());
            var SkipWhileSubscriber = /** @class */ (function (_super_1) {
                __extends(SkipWhileSubscriber, _super_1);
                function SkipWhileSubscriber(destination, predicate) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.skipping = true;
                    _this.index = 0;
                    return _this;
                }
                SkipWhileSubscriber.prototype._next = function (value) {
                    var destination = this.destination;
                    if (this.skipping) {
                        this.tryCallPredicate(value);
                    }
                    if (!this.skipping) {
                        destination.next(value);
                    }
                };
                SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
                    try {
                        var result = this.predicate(value, this.index++);
                        this.skipping = Boolean(result);
                    }
                    catch (err) {
                        this.destination.error(err);
                    }
                };
                return SkipWhileSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=skipWhile.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/startWith.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/startWith.js ***!
          \********************************************************************/
        /*! exports provided: startWith */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startWith", function () { return startWith; });
            /* harmony import */ var _observable_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/concat */ "./node_modules/rxjs/_esm2015/internal/observable/concat.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            function startWith() {
                var array = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    array[_c] = arguments[_c];
                }
                var scheduler = array[array.length - 1];
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__["isScheduler"])(scheduler)) {
                    array.pop();
                    return function (source) { return Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"])(array, source, scheduler); };
                }
                else {
                    return function (source) { return Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"])(array, source); };
                }
            }
            //# sourceMappingURL=startWith.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/subscribeOn.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/subscribeOn.js ***!
          \**********************************************************************/
        /*! exports provided: subscribeOn */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeOn", function () { return subscribeOn; });
            /* harmony import */ var _observable_SubscribeOnObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/SubscribeOnObservable */ "./node_modules/rxjs/_esm2015/internal/observable/SubscribeOnObservable.js");
            function subscribeOn(scheduler, delay) {
                if (delay === void 0) { delay = 0; }
                return function subscribeOnOperatorFunction(source) {
                    return source.lift(new SubscribeOnOperator(scheduler, delay));
                };
            }
            var SubscribeOnOperator = /** @class */ (function () {
                function SubscribeOnOperator(scheduler, delay) {
                    this.scheduler = scheduler;
                    this.delay = delay;
                }
                SubscribeOnOperator.prototype.call = function (subscriber, source) {
                    return new _observable_SubscribeOnObservable__WEBPACK_IMPORTED_MODULE_0__["SubscribeOnObservable"](source, this.delay, this.scheduler).subscribe(subscriber);
                };
                return SubscribeOnOperator;
            }());
            //# sourceMappingURL=subscribeOn.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/switchAll.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/switchAll.js ***!
          \********************************************************************/
        /*! exports provided: switchAll */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchAll", function () { return switchAll; });
            /* harmony import */ var _switchMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./switchMap */ "./node_modules/rxjs/_esm2015/internal/operators/switchMap.js");
            /* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm2015/internal/util/identity.js");
            function switchAll() {
                return Object(_switchMap__WEBPACK_IMPORTED_MODULE_0__["switchMap"])(_util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"]);
            }
            //# sourceMappingURL=switchAll.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/switchMap.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/switchMap.js ***!
          \********************************************************************/
        /*! exports provided: switchMap */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchMap", function () { return switchMap; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            /* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm2015/internal/observable/from.js");
            function switchMap(project, resultSelector) {
                if (typeof resultSelector === 'function') {
                    return function (source) { return source.pipe(switchMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_4__["from"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
                }
                return function (source) { return source.lift(new SwitchMapOperator(project)); };
            }
            var SwitchMapOperator = /** @class */ (function () {
                function SwitchMapOperator(project) {
                    this.project = project;
                }
                SwitchMapOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
                };
                return SwitchMapOperator;
            }());
            var SwitchMapSubscriber = /** @class */ (function (_super_1) {
                __extends(SwitchMapSubscriber, _super_1);
                function SwitchMapSubscriber(destination, project) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.project = project;
                    _this.index = 0;
                    return _this;
                }
                SwitchMapSubscriber.prototype._next = function (value) {
                    var result;
                    var index = this.index++;
                    try {
                        result = this.project(value, index);
                    }
                    catch (error) {
                        this.destination.error(error);
                        return;
                    }
                    this._innerSub(result, value, index);
                };
                SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
                    var innerSubscription = this.innerSubscription;
                    if (innerSubscription) {
                        innerSubscription.unsubscribe();
                    }
                    var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_1__["InnerSubscriber"](this, undefined, undefined);
                    var destination = this.destination;
                    destination.add(innerSubscriber);
                    this.innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, result, value, index, innerSubscriber);
                };
                SwitchMapSubscriber.prototype._complete = function () {
                    var innerSubscription = this.innerSubscription;
                    if (!innerSubscription || innerSubscription.closed) {
                        _super_1.prototype._complete.call(this);
                    }
                    this.unsubscribe();
                };
                SwitchMapSubscriber.prototype._unsubscribe = function () {
                    this.innerSubscription = null;
                };
                SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
                    var destination = this.destination;
                    destination.remove(innerSub);
                    this.innerSubscription = null;
                    if (this.isStopped) {
                        _super_1.prototype._complete.call(this);
                    }
                };
                SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.destination.next(innerValue);
                };
                return SwitchMapSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=switchMap.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/switchMapTo.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/switchMapTo.js ***!
          \**********************************************************************/
        /*! exports provided: switchMapTo */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchMapTo", function () { return switchMapTo; });
            /* harmony import */ var _switchMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./switchMap */ "./node_modules/rxjs/_esm2015/internal/operators/switchMap.js");
            function switchMapTo(innerObservable, resultSelector) {
                return resultSelector ? Object(_switchMap__WEBPACK_IMPORTED_MODULE_0__["switchMap"])(function () { return innerObservable; }, resultSelector) : Object(_switchMap__WEBPACK_IMPORTED_MODULE_0__["switchMap"])(function () { return innerObservable; });
            }
            //# sourceMappingURL=switchMapTo.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/take.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/take.js ***!
          \***************************************************************/
        /*! exports provided: take */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "take", function () { return take; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js");
            /* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function take(count) {
                return function (source) {
                    if (count === 0) {
                        return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_2__["empty"])();
                    }
                    else {
                        return source.lift(new TakeOperator(count));
                    }
                };
            }
            var TakeOperator = /** @class */ (function () {
                function TakeOperator(total) {
                    this.total = total;
                    if (this.total < 0) {
                        throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_1__["ArgumentOutOfRangeError"];
                    }
                }
                TakeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new TakeSubscriber(subscriber, this.total));
                };
                return TakeOperator;
            }());
            var TakeSubscriber = /** @class */ (function (_super_1) {
                __extends(TakeSubscriber, _super_1);
                function TakeSubscriber(destination, total) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.total = total;
                    _this.count = 0;
                    return _this;
                }
                TakeSubscriber.prototype._next = function (value) {
                    var total = this.total;
                    var count = ++this.count;
                    if (count <= total) {
                        this.destination.next(value);
                        if (count === total) {
                            this.destination.complete();
                            this.unsubscribe();
                        }
                    }
                };
                return TakeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=take.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/takeLast.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/takeLast.js ***!
          \*******************************************************************/
        /*! exports provided: takeLast */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeLast", function () { return takeLast; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js");
            /* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/empty */ "./node_modules/rxjs/_esm2015/internal/observable/empty.js");
            function takeLast(count) {
                return function takeLastOperatorFunction(source) {
                    if (count === 0) {
                        return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_2__["empty"])();
                    }
                    else {
                        return source.lift(new TakeLastOperator(count));
                    }
                };
            }
            var TakeLastOperator = /** @class */ (function () {
                function TakeLastOperator(total) {
                    this.total = total;
                    if (this.total < 0) {
                        throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_1__["ArgumentOutOfRangeError"];
                    }
                }
                TakeLastOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
                };
                return TakeLastOperator;
            }());
            var TakeLastSubscriber = /** @class */ (function (_super_1) {
                __extends(TakeLastSubscriber, _super_1);
                function TakeLastSubscriber(destination, total) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.total = total;
                    _this.ring = new Array();
                    _this.count = 0;
                    return _this;
                }
                TakeLastSubscriber.prototype._next = function (value) {
                    var ring = this.ring;
                    var total = this.total;
                    var count = this.count++;
                    if (ring.length < total) {
                        ring.push(value);
                    }
                    else {
                        var index = count % total;
                        ring[index] = value;
                    }
                };
                TakeLastSubscriber.prototype._complete = function () {
                    var destination = this.destination;
                    var count = this.count;
                    if (count > 0) {
                        var total = this.count >= this.total ? this.total : this.count;
                        var ring = this.ring;
                        for (var i = 0; i < total; i++) {
                            var idx = (count++) % total;
                            destination.next(ring[idx]);
                        }
                    }
                    destination.complete();
                };
                return TakeLastSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=takeLast.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/takeUntil.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/takeUntil.js ***!
          \********************************************************************/
        /*! exports provided: takeUntil */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntil", function () { return takeUntil; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function takeUntil(notifier) {
                return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
            }
            var TakeUntilOperator = /** @class */ (function () {
                function TakeUntilOperator(notifier) {
                    this.notifier = notifier;
                }
                TakeUntilOperator.prototype.call = function (subscriber, source) {
                    var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
                    var notifierSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(takeUntilSubscriber, this.notifier);
                    if (notifierSubscription && !takeUntilSubscriber.seenValue) {
                        takeUntilSubscriber.add(notifierSubscription);
                        return source.subscribe(takeUntilSubscriber);
                    }
                    return takeUntilSubscriber;
                };
                return TakeUntilOperator;
            }());
            var TakeUntilSubscriber = /** @class */ (function (_super_1) {
                __extends(TakeUntilSubscriber, _super_1);
                function TakeUntilSubscriber(destination) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.seenValue = false;
                    return _this;
                }
                TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.seenValue = true;
                    this.complete();
                };
                TakeUntilSubscriber.prototype.notifyComplete = function () {
                };
                return TakeUntilSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=takeUntil.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/takeWhile.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/takeWhile.js ***!
          \********************************************************************/
        /*! exports provided: takeWhile */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function () { return takeWhile; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function takeWhile(predicate, inclusive) {
                if (inclusive === void 0) { inclusive = false; }
                return function (source) { return source.lift(new TakeWhileOperator(predicate, inclusive)); };
            }
            var TakeWhileOperator = /** @class */ (function () {
                function TakeWhileOperator(predicate, inclusive) {
                    this.predicate = predicate;
                    this.inclusive = inclusive;
                }
                TakeWhileOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
                };
                return TakeWhileOperator;
            }());
            var TakeWhileSubscriber = /** @class */ (function (_super_1) {
                __extends(TakeWhileSubscriber, _super_1);
                function TakeWhileSubscriber(destination, predicate, inclusive) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.predicate = predicate;
                    _this.inclusive = inclusive;
                    _this.index = 0;
                    return _this;
                }
                TakeWhileSubscriber.prototype._next = function (value) {
                    var destination = this.destination;
                    var result;
                    try {
                        result = this.predicate(value, this.index++);
                    }
                    catch (err) {
                        destination.error(err);
                        return;
                    }
                    this.nextOrComplete(value, result);
                };
                TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
                    var destination = this.destination;
                    if (Boolean(predicateResult)) {
                        destination.next(value);
                    }
                    else {
                        if (this.inclusive) {
                            destination.next(value);
                        }
                        destination.complete();
                    }
                };
                return TakeWhileSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=takeWhile.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/tap.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/tap.js ***!
          \**************************************************************/
        /*! exports provided: tap */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function () { return tap; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/noop */ "./node_modules/rxjs/_esm2015/internal/util/noop.js");
            /* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isFunction */ "./node_modules/rxjs/_esm2015/internal/util/isFunction.js");
            function tap(nextOrObserver, error, complete) {
                return function tapOperatorFunction(source) {
                    return source.lift(new DoOperator(nextOrObserver, error, complete));
                };
            }
            var DoOperator = /** @class */ (function () {
                function DoOperator(nextOrObserver, error, complete) {
                    this.nextOrObserver = nextOrObserver;
                    this.error = error;
                    this.complete = complete;
                }
                DoOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
                };
                return DoOperator;
            }());
            var TapSubscriber = /** @class */ (function (_super_1) {
                __extends(TapSubscriber, _super_1);
                function TapSubscriber(destination, observerOrNext, error, complete) {
                    var _this = _super_1.call(this, destination) || this;
                    _this._tapNext = _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                    _this._tapError = _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                    _this._tapComplete = _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                    _this._tapError = error || _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                    _this._tapComplete = complete || _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                    if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(observerOrNext)) {
                        _this._context = _this;
                        _this._tapNext = observerOrNext;
                    }
                    else if (observerOrNext) {
                        _this._context = observerOrNext;
                        _this._tapNext = observerOrNext.next || _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                        _this._tapError = observerOrNext.error || _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                        _this._tapComplete = observerOrNext.complete || _util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"];
                    }
                    return _this;
                }
                TapSubscriber.prototype._next = function (value) {
                    try {
                        this._tapNext.call(this._context, value);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.destination.next(value);
                };
                TapSubscriber.prototype._error = function (err) {
                    try {
                        this._tapError.call(this._context, err);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.destination.error(err);
                };
                TapSubscriber.prototype._complete = function () {
                    try {
                        this._tapComplete.call(this._context);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    return this.destination.complete();
                };
                return TapSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=tap.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/throttle.js": 
        /*!*******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/throttle.js ***!
          \*******************************************************************/
        /*! exports provided: defaultThrottleConfig, throttle */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultThrottleConfig", function () { return defaultThrottleConfig; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function () { return throttle; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            var defaultThrottleConfig = {
                leading: true,
                trailing: false
            };
            function throttle(durationSelector, config) {
                if (config === void 0) { config = defaultThrottleConfig; }
                return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
            }
            var ThrottleOperator = /** @class */ (function () {
                function ThrottleOperator(durationSelector, leading, trailing) {
                    this.durationSelector = durationSelector;
                    this.leading = leading;
                    this.trailing = trailing;
                }
                ThrottleOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
                };
                return ThrottleOperator;
            }());
            var ThrottleSubscriber = /** @class */ (function (_super_1) {
                __extends(ThrottleSubscriber, _super_1);
                function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.destination = destination;
                    _this.durationSelector = durationSelector;
                    _this._leading = _leading;
                    _this._trailing = _trailing;
                    _this._hasValue = false;
                    return _this;
                }
                ThrottleSubscriber.prototype._next = function (value) {
                    this._hasValue = true;
                    this._sendValue = value;
                    if (!this._throttled) {
                        if (this._leading) {
                            this.send();
                        }
                        else {
                            this.throttle(value);
                        }
                    }
                };
                ThrottleSubscriber.prototype.send = function () {
                    var _c = this, _hasValue = _c._hasValue, _sendValue = _c._sendValue;
                    if (_hasValue) {
                        this.destination.next(_sendValue);
                        this.throttle(_sendValue);
                    }
                    this._hasValue = false;
                    this._sendValue = null;
                };
                ThrottleSubscriber.prototype.throttle = function (value) {
                    var duration = this.tryDurationSelector(value);
                    if (!!duration) {
                        this.add(this._throttled = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(this, duration));
                    }
                };
                ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
                    try {
                        return this.durationSelector(value);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return null;
                    }
                };
                ThrottleSubscriber.prototype.throttlingDone = function () {
                    var _c = this, _throttled = _c._throttled, _trailing = _c._trailing;
                    if (_throttled) {
                        _throttled.unsubscribe();
                    }
                    this._throttled = null;
                    if (_trailing) {
                        this.send();
                    }
                };
                ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.throttlingDone();
                };
                ThrottleSubscriber.prototype.notifyComplete = function () {
                    this.throttlingDone();
                };
                return ThrottleSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=throttle.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/throttleTime.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/throttleTime.js ***!
          \***********************************************************************/
        /*! exports provided: throttleTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttleTime", function () { return throttleTime; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./throttle */ "./node_modules/rxjs/_esm2015/internal/operators/throttle.js");
            function throttleTime(duration, scheduler, config) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"]; }
                if (config === void 0) { config = _throttle__WEBPACK_IMPORTED_MODULE_2__["defaultThrottleConfig"]; }
                return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
            }
            var ThrottleTimeOperator = /** @class */ (function () {
                function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
                    this.duration = duration;
                    this.scheduler = scheduler;
                    this.leading = leading;
                    this.trailing = trailing;
                }
                ThrottleTimeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
                };
                return ThrottleTimeOperator;
            }());
            var ThrottleTimeSubscriber = /** @class */ (function (_super_1) {
                __extends(ThrottleTimeSubscriber, _super_1);
                function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.duration = duration;
                    _this.scheduler = scheduler;
                    _this.leading = leading;
                    _this.trailing = trailing;
                    _this._hasTrailingValue = false;
                    _this._trailingValue = null;
                    return _this;
                }
                ThrottleTimeSubscriber.prototype._next = function (value) {
                    if (this.throttled) {
                        if (this.trailing) {
                            this._trailingValue = value;
                            this._hasTrailingValue = true;
                        }
                    }
                    else {
                        this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
                        if (this.leading) {
                            this.destination.next(value);
                        }
                        else if (this.trailing) {
                            this._trailingValue = value;
                            this._hasTrailingValue = true;
                        }
                    }
                };
                ThrottleTimeSubscriber.prototype._complete = function () {
                    if (this._hasTrailingValue) {
                        this.destination.next(this._trailingValue);
                        this.destination.complete();
                    }
                    else {
                        this.destination.complete();
                    }
                };
                ThrottleTimeSubscriber.prototype.clearThrottle = function () {
                    var throttled = this.throttled;
                    if (throttled) {
                        if (this.trailing && this._hasTrailingValue) {
                            this.destination.next(this._trailingValue);
                            this._trailingValue = null;
                            this._hasTrailingValue = false;
                        }
                        throttled.unsubscribe();
                        this.remove(throttled);
                        this.throttled = null;
                    }
                };
                return ThrottleTimeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            function dispatchNext(arg) {
                var subscriber = arg.subscriber;
                subscriber.clearThrottle();
            }
            //# sourceMappingURL=throttleTime.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/throwIfEmpty.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/throwIfEmpty.js ***!
          \***********************************************************************/
        /*! exports provided: throwIfEmpty */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwIfEmpty", function () { return throwIfEmpty; });
            /* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm2015/internal/util/EmptyError.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function throwIfEmpty(errorFactory) {
                if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
                return function (source) {
                    return source.lift(new ThrowIfEmptyOperator(errorFactory));
                };
            }
            var ThrowIfEmptyOperator = /** @class */ (function () {
                function ThrowIfEmptyOperator(errorFactory) {
                    this.errorFactory = errorFactory;
                }
                ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
                };
                return ThrowIfEmptyOperator;
            }());
            var ThrowIfEmptySubscriber = /** @class */ (function (_super_1) {
                __extends(ThrowIfEmptySubscriber, _super_1);
                function ThrowIfEmptySubscriber(destination, errorFactory) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.errorFactory = errorFactory;
                    _this.hasValue = false;
                    return _this;
                }
                ThrowIfEmptySubscriber.prototype._next = function (value) {
                    this.hasValue = true;
                    this.destination.next(value);
                };
                ThrowIfEmptySubscriber.prototype._complete = function () {
                    if (!this.hasValue) {
                        var err = void 0;
                        try {
                            err = this.errorFactory();
                        }
                        catch (e) {
                            err = e;
                        }
                        this.destination.error(err);
                    }
                    else {
                        return this.destination.complete();
                    }
                };
                return ThrowIfEmptySubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
            function defaultErrorFactory() {
                return new _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__["EmptyError"]();
            }
            //# sourceMappingURL=throwIfEmpty.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/timeInterval.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/timeInterval.js ***!
          \***********************************************************************/
        /*! exports provided: timeInterval, TimeInterval */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function () { return timeInterval; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeInterval", function () { return TimeInterval; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _scan__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scan */ "./node_modules/rxjs/_esm2015/internal/operators/scan.js");
            /* harmony import */ var _observable_defer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/defer */ "./node_modules/rxjs/_esm2015/internal/observable/defer.js");
            /* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            function timeInterval(scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"]; }
                return function (source) { return Object(_observable_defer__WEBPACK_IMPORTED_MODULE_2__["defer"])(function () {
                    return source.pipe(Object(_scan__WEBPACK_IMPORTED_MODULE_1__["scan"])(function (_c, value) {
                        var current = _c.current;
                        return ({ value: value, current: scheduler.now(), last: current });
                    }, { current: scheduler.now(), value: undefined, last: undefined }), Object(_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (_c) {
                        var current = _c.current, last = _c.last, value = _c.value;
                        return new TimeInterval(value, current - last);
                    }));
                }); };
            }
            var TimeInterval = /** @class */ (function () {
                function TimeInterval(value, interval) {
                    this.value = value;
                    this.interval = interval;
                }
                return TimeInterval;
            }());
            //# sourceMappingURL=timeInterval.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/timeout.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/timeout.js ***!
          \******************************************************************/
        /*! exports provided: timeout */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function () { return timeout; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _util_TimeoutError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/TimeoutError */ "./node_modules/rxjs/_esm2015/internal/util/TimeoutError.js");
            /* harmony import */ var _timeoutWith__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./timeoutWith */ "./node_modules/rxjs/_esm2015/internal/operators/timeoutWith.js");
            /* harmony import */ var _observable_throwError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../observable/throwError */ "./node_modules/rxjs/_esm2015/internal/observable/throwError.js");
            function timeout(due, scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"]; }
                return Object(_timeoutWith__WEBPACK_IMPORTED_MODULE_2__["timeoutWith"])(due, Object(_observable_throwError__WEBPACK_IMPORTED_MODULE_3__["throwError"])(new _util_TimeoutError__WEBPACK_IMPORTED_MODULE_1__["TimeoutError"]()), scheduler);
            }
            //# sourceMappingURL=timeout.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/timeoutWith.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/timeoutWith.js ***!
          \**********************************************************************/
        /*! exports provided: timeoutWith */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeoutWith", function () { return timeoutWith; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _util_isDate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isDate */ "./node_modules/rxjs/_esm2015/internal/util/isDate.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function timeoutWith(due, withObservable, scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"]; }
                return function (source) {
                    var absoluteTimeout = Object(_util_isDate__WEBPACK_IMPORTED_MODULE_1__["isDate"])(due);
                    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
                    return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
                };
            }
            var TimeoutWithOperator = /** @class */ (function () {
                function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
                    this.waitFor = waitFor;
                    this.absoluteTimeout = absoluteTimeout;
                    this.withObservable = withObservable;
                    this.scheduler = scheduler;
                }
                TimeoutWithOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
                };
                return TimeoutWithOperator;
            }());
            var TimeoutWithSubscriber = /** @class */ (function (_super_1) {
                __extends(TimeoutWithSubscriber, _super_1);
                function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.absoluteTimeout = absoluteTimeout;
                    _this.waitFor = waitFor;
                    _this.withObservable = withObservable;
                    _this.scheduler = scheduler;
                    _this.action = null;
                    _this.scheduleTimeout();
                    return _this;
                }
                TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
                    var withObservable = subscriber.withObservable;
                    subscriber._unsubscribeAndRecycle();
                    subscriber.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(subscriber, withObservable));
                };
                TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
                    var action = this.action;
                    if (action) {
                        this.action = action.schedule(this, this.waitFor);
                    }
                    else {
                        this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
                    }
                };
                TimeoutWithSubscriber.prototype._next = function (value) {
                    if (!this.absoluteTimeout) {
                        this.scheduleTimeout();
                    }
                    _super_1.prototype._next.call(this, value);
                };
                TimeoutWithSubscriber.prototype._unsubscribe = function () {
                    this.action = null;
                    this.scheduler = null;
                    this.withObservable = null;
                };
                return TimeoutWithSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            //# sourceMappingURL=timeoutWith.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/timestamp.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/timestamp.js ***!
          \********************************************************************/
        /*! exports provided: timestamp, Timestamp */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timestamp", function () { return timestamp; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Timestamp", function () { return Timestamp; });
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            function timestamp(scheduler) {
                if (scheduler === void 0) { scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"]; }
                return Object(_map__WEBPACK_IMPORTED_MODULE_1__["map"])(function (value) { return new Timestamp(value, scheduler.now()); });
            }
            var Timestamp = /** @class */ (function () {
                function Timestamp(value, timestamp) {
                    this.value = value;
                    this.timestamp = timestamp;
                }
                return Timestamp;
            }());
            //# sourceMappingURL=timestamp.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/toArray.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/toArray.js ***!
          \******************************************************************/
        /*! exports provided: toArray */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function () { return toArray; });
            /* harmony import */ var _reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reduce */ "./node_modules/rxjs/_esm2015/internal/operators/reduce.js");
            function toArrayReducer(arr, item, index) {
                if (index === 0) {
                    return [item];
                }
                arr.push(item);
                return arr;
            }
            function toArray() {
                return Object(_reduce__WEBPACK_IMPORTED_MODULE_0__["reduce"])(toArrayReducer, []);
            }
            //# sourceMappingURL=toArray.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/window.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/window.js ***!
          \*****************************************************************/
        /*! exports provided: window */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "window", function () { return window; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function window(windowBoundaries) {
                return function windowOperatorFunction(source) {
                    return source.lift(new WindowOperator(windowBoundaries));
                };
            }
            var WindowOperator = /** @class */ (function () {
                function WindowOperator(windowBoundaries) {
                    this.windowBoundaries = windowBoundaries;
                }
                WindowOperator.prototype.call = function (subscriber, source) {
                    var windowSubscriber = new WindowSubscriber(subscriber);
                    var sourceSubscription = source.subscribe(windowSubscriber);
                    if (!sourceSubscription.closed) {
                        windowSubscriber.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(windowSubscriber, this.windowBoundaries));
                    }
                    return sourceSubscription;
                };
                return WindowOperator;
            }());
            var WindowSubscriber = /** @class */ (function (_super_1) {
                __extends(WindowSubscriber, _super_1);
                function WindowSubscriber(destination) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.window = new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    destination.next(_this.window);
                    return _this;
                }
                WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.openWindow();
                };
                WindowSubscriber.prototype.notifyError = function (error, innerSub) {
                    this._error(error);
                };
                WindowSubscriber.prototype.notifyComplete = function (innerSub) {
                    this._complete();
                };
                WindowSubscriber.prototype._next = function (value) {
                    this.window.next(value);
                };
                WindowSubscriber.prototype._error = function (err) {
                    this.window.error(err);
                    this.destination.error(err);
                };
                WindowSubscriber.prototype._complete = function () {
                    this.window.complete();
                    this.destination.complete();
                };
                WindowSubscriber.prototype._unsubscribe = function () {
                    this.window = null;
                };
                WindowSubscriber.prototype.openWindow = function () {
                    var prevWindow = this.window;
                    if (prevWindow) {
                        prevWindow.complete();
                    }
                    var destination = this.destination;
                    var newWindow = this.window = new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    destination.next(newWindow);
                };
                return WindowSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=window.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/windowCount.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/windowCount.js ***!
          \**********************************************************************/
        /*! exports provided: windowCount */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowCount", function () { return windowCount; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            function windowCount(windowSize, startWindowEvery) {
                if (startWindowEvery === void 0) { startWindowEvery = 0; }
                return function windowCountOperatorFunction(source) {
                    return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
                };
            }
            var WindowCountOperator = /** @class */ (function () {
                function WindowCountOperator(windowSize, startWindowEvery) {
                    this.windowSize = windowSize;
                    this.startWindowEvery = startWindowEvery;
                }
                WindowCountOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
                };
                return WindowCountOperator;
            }());
            var WindowCountSubscriber = /** @class */ (function (_super_1) {
                __extends(WindowCountSubscriber, _super_1);
                function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.destination = destination;
                    _this.windowSize = windowSize;
                    _this.startWindowEvery = startWindowEvery;
                    _this.windows = [new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]()];
                    _this.count = 0;
                    destination.next(_this.windows[0]);
                    return _this;
                }
                WindowCountSubscriber.prototype._next = function (value) {
                    var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
                    var destination = this.destination;
                    var windowSize = this.windowSize;
                    var windows = this.windows;
                    var len = windows.length;
                    for (var i = 0; i < len && !this.closed; i++) {
                        windows[i].next(value);
                    }
                    var c = this.count - windowSize + 1;
                    if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
                        windows.shift().complete();
                    }
                    if (++this.count % startWindowEvery === 0 && !this.closed) {
                        var window = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                        windows.push(window);
                        destination.next(window);
                    }
                };
                WindowCountSubscriber.prototype._error = function (err) {
                    var windows = this.windows;
                    if (windows) {
                        while (windows.length > 0 && !this.closed) {
                            windows.shift().error(err);
                        }
                    }
                    this.destination.error(err);
                };
                WindowCountSubscriber.prototype._complete = function () {
                    var windows = this.windows;
                    if (windows) {
                        while (windows.length > 0 && !this.closed) {
                            windows.shift().complete();
                        }
                    }
                    this.destination.complete();
                };
                WindowCountSubscriber.prototype._unsubscribe = function () {
                    this.count = 0;
                    this.windows = null;
                };
                return WindowCountSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]));
            //# sourceMappingURL=windowCount.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/windowTime.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/windowTime.js ***!
          \*********************************************************************/
        /*! exports provided: windowTime */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowTime", function () { return windowTime; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js");
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm2015/internal/util/isNumeric.js");
            /* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js");
            function windowTime(windowTimeSpan) {
                var scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
                var windowCreationInterval = null;
                var maxWindowSize = Number.POSITIVE_INFINITY;
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_4__["isScheduler"])(arguments[3])) {
                    scheduler = arguments[3];
                }
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_4__["isScheduler"])(arguments[2])) {
                    scheduler = arguments[2];
                }
                else if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_3__["isNumeric"])(arguments[2])) {
                    maxWindowSize = arguments[2];
                }
                if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_4__["isScheduler"])(arguments[1])) {
                    scheduler = arguments[1];
                }
                else if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_3__["isNumeric"])(arguments[1])) {
                    windowCreationInterval = arguments[1];
                }
                return function windowTimeOperatorFunction(source) {
                    return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
                };
            }
            var WindowTimeOperator = /** @class */ (function () {
                function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
                    this.windowTimeSpan = windowTimeSpan;
                    this.windowCreationInterval = windowCreationInterval;
                    this.maxWindowSize = maxWindowSize;
                    this.scheduler = scheduler;
                }
                WindowTimeOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
                };
                return WindowTimeOperator;
            }());
            var CountedSubject = /** @class */ (function (_super_1) {
                __extends(CountedSubject, _super_1);
                function CountedSubject() {
                    var _this = _super_1.apply(this, arguments) || this;
                    _this._numberOfNextedValues = 0;
                    return _this;
                }
                CountedSubject.prototype.next = function (value) {
                    this._numberOfNextedValues++;
                    _super_1.prototype.next.call(this, value);
                };
                Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
                    get: function () {
                        return this._numberOfNextedValues;
                    },
                    enumerable: true,
                    configurable: true
                });
                return CountedSubject;
            }(_Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]));
            var WindowTimeSubscriber = /** @class */ (function (_super_1) {
                __extends(WindowTimeSubscriber, _super_1);
                function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.destination = destination;
                    _this.windowTimeSpan = windowTimeSpan;
                    _this.windowCreationInterval = windowCreationInterval;
                    _this.maxWindowSize = maxWindowSize;
                    _this.scheduler = scheduler;
                    _this.windows = [];
                    var window = _this.openWindow();
                    if (windowCreationInterval !== null && windowCreationInterval >= 0) {
                        var closeState = { subscriber: _this, window: window, context: null };
                        var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
                        _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
                        _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
                    }
                    else {
                        var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
                        _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
                    }
                    return _this;
                }
                WindowTimeSubscriber.prototype._next = function (value) {
                    var windows = this.windows;
                    var len = windows.length;
                    for (var i = 0; i < len; i++) {
                        var window = windows[i];
                        if (!window.closed) {
                            window.next(value);
                            if (window.numberOfNextedValues >= this.maxWindowSize) {
                                this.closeWindow(window);
                            }
                        }
                    }
                };
                WindowTimeSubscriber.prototype._error = function (err) {
                    var windows = this.windows;
                    while (windows.length > 0) {
                        windows.shift().error(err);
                    }
                    this.destination.error(err);
                };
                WindowTimeSubscriber.prototype._complete = function () {
                    var windows = this.windows;
                    while (windows.length > 0) {
                        var window = windows.shift();
                        if (!window.closed) {
                            window.complete();
                        }
                    }
                    this.destination.complete();
                };
                WindowTimeSubscriber.prototype.openWindow = function () {
                    var window = new CountedSubject();
                    this.windows.push(window);
                    var destination = this.destination;
                    destination.next(window);
                    return window;
                };
                WindowTimeSubscriber.prototype.closeWindow = function (window) {
                    window.complete();
                    var windows = this.windows;
                    windows.splice(windows.indexOf(window), 1);
                };
                return WindowTimeSubscriber;
            }(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));
            function dispatchWindowTimeSpanOnly(state) {
                var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
                if (window) {
                    subscriber.closeWindow(window);
                }
                state.window = subscriber.openWindow();
                this.schedule(state, windowTimeSpan);
            }
            function dispatchWindowCreation(state) {
                var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
                var window = subscriber.openWindow();
                var action = this;
                var context = { action: action, subscription: null };
                var timeSpanState = { subscriber: subscriber, window: window, context: context };
                context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
                action.add(context.subscription);
                action.schedule(state, windowCreationInterval);
            }
            function dispatchWindowClose(state) {
                var subscriber = state.subscriber, window = state.window, context = state.context;
                if (context && context.action && context.subscription) {
                    context.action.remove(context.subscription);
                }
                subscriber.closeWindow(window);
            }
            //# sourceMappingURL=windowTime.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/windowToggle.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/windowToggle.js ***!
          \***********************************************************************/
        /*! exports provided: windowToggle */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowToggle", function () { return windowToggle; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function windowToggle(openings, closingSelector) {
                return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
            }
            var WindowToggleOperator = /** @class */ (function () {
                function WindowToggleOperator(openings, closingSelector) {
                    this.openings = openings;
                    this.closingSelector = closingSelector;
                }
                WindowToggleOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
                };
                return WindowToggleOperator;
            }());
            var WindowToggleSubscriber = /** @class */ (function (_super_1) {
                __extends(WindowToggleSubscriber, _super_1);
                function WindowToggleSubscriber(destination, openings, closingSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.openings = openings;
                    _this.closingSelector = closingSelector;
                    _this.contexts = [];
                    _this.add(_this.openSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(_this, openings, openings));
                    return _this;
                }
                WindowToggleSubscriber.prototype._next = function (value) {
                    var contexts = this.contexts;
                    if (contexts) {
                        var len = contexts.length;
                        for (var i = 0; i < len; i++) {
                            contexts[i].window.next(value);
                        }
                    }
                };
                WindowToggleSubscriber.prototype._error = function (err) {
                    var contexts = this.contexts;
                    this.contexts = null;
                    if (contexts) {
                        var len = contexts.length;
                        var index = -1;
                        while (++index < len) {
                            var context = contexts[index];
                            context.window.error(err);
                            context.subscription.unsubscribe();
                        }
                    }
                    _super_1.prototype._error.call(this, err);
                };
                WindowToggleSubscriber.prototype._complete = function () {
                    var contexts = this.contexts;
                    this.contexts = null;
                    if (contexts) {
                        var len = contexts.length;
                        var index = -1;
                        while (++index < len) {
                            var context = contexts[index];
                            context.window.complete();
                            context.subscription.unsubscribe();
                        }
                    }
                    _super_1.prototype._complete.call(this);
                };
                WindowToggleSubscriber.prototype._unsubscribe = function () {
                    var contexts = this.contexts;
                    this.contexts = null;
                    if (contexts) {
                        var len = contexts.length;
                        var index = -1;
                        while (++index < len) {
                            var context = contexts[index];
                            context.window.unsubscribe();
                            context.subscription.unsubscribe();
                        }
                    }
                };
                WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    if (outerValue === this.openings) {
                        var closingNotifier = void 0;
                        try {
                            var closingSelector = this.closingSelector;
                            closingNotifier = closingSelector(innerValue);
                        }
                        catch (e) {
                            return this.error(e);
                        }
                        var window = new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                        var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                        var context = { window: window, subscription: subscription };
                        this.contexts.push(context);
                        var innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(this, closingNotifier, context);
                        if (innerSubscription.closed) {
                            this.closeWindow(this.contexts.length - 1);
                        }
                        else {
                            innerSubscription.context = context;
                            subscription.add(innerSubscription);
                        }
                        this.destination.next(window);
                    }
                    else {
                        this.closeWindow(this.contexts.indexOf(outerValue));
                    }
                };
                WindowToggleSubscriber.prototype.notifyError = function (err) {
                    this.error(err);
                };
                WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
                    if (inner !== this.openSubscription) {
                        this.closeWindow(this.contexts.indexOf(inner.context));
                    }
                };
                WindowToggleSubscriber.prototype.closeWindow = function (index) {
                    if (index === -1) {
                        return;
                    }
                    var contexts = this.contexts;
                    var context = contexts[index];
                    var window = context.window, subscription = context.subscription;
                    contexts.splice(index, 1);
                    window.complete();
                    subscription.unsubscribe();
                };
                return WindowToggleSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
            //# sourceMappingURL=windowToggle.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/windowWhen.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/windowWhen.js ***!
          \*********************************************************************/
        /*! exports provided: windowWhen */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowWhen", function () { return windowWhen; });
            /* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm2015/internal/Subject.js");
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function windowWhen(closingSelector) {
                return function windowWhenOperatorFunction(source) {
                    return source.lift(new WindowOperator(closingSelector));
                };
            }
            var WindowOperator = /** @class */ (function () {
                function WindowOperator(closingSelector) {
                    this.closingSelector = closingSelector;
                }
                WindowOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
                };
                return WindowOperator;
            }());
            var WindowSubscriber = /** @class */ (function (_super_1) {
                __extends(WindowSubscriber, _super_1);
                function WindowSubscriber(destination, closingSelector) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.destination = destination;
                    _this.closingSelector = closingSelector;
                    _this.openWindow();
                    return _this;
                }
                WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.openWindow(innerSub);
                };
                WindowSubscriber.prototype.notifyError = function (error, innerSub) {
                    this._error(error);
                };
                WindowSubscriber.prototype.notifyComplete = function (innerSub) {
                    this.openWindow(innerSub);
                };
                WindowSubscriber.prototype._next = function (value) {
                    this.window.next(value);
                };
                WindowSubscriber.prototype._error = function (err) {
                    this.window.error(err);
                    this.destination.error(err);
                    this.unsubscribeClosingNotification();
                };
                WindowSubscriber.prototype._complete = function () {
                    this.window.complete();
                    this.destination.complete();
                    this.unsubscribeClosingNotification();
                };
                WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
                    if (this.closingNotification) {
                        this.closingNotification.unsubscribe();
                    }
                };
                WindowSubscriber.prototype.openWindow = function (innerSub) {
                    if (innerSub === void 0) { innerSub = null; }
                    if (innerSub) {
                        this.remove(innerSub);
                        innerSub.unsubscribe();
                    }
                    var prevWindow = this.window;
                    if (prevWindow) {
                        prevWindow.complete();
                    }
                    var window = this.window = new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
                    this.destination.next(window);
                    var closingNotifier;
                    try {
                        var closingSelector = this.closingSelector;
                        closingNotifier = closingSelector();
                    }
                    catch (e) {
                        this.destination.error(e);
                        this.window.error(e);
                        return;
                    }
                    this.add(this.closingNotification = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, closingNotifier));
                };
                return WindowSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
            //# sourceMappingURL=windowWhen.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/withLatestFrom.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/withLatestFrom.js ***!
          \*************************************************************************/
        /*! exports provided: withLatestFrom */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withLatestFrom", function () { return withLatestFrom; });
            /* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm2015/internal/OuterSubscriber.js");
            /* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js");
            function withLatestFrom() {
                var args = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    args[_c] = arguments[_c];
                }
                return function (source) {
                    var project;
                    if (typeof args[args.length - 1] === 'function') {
                        project = args.pop();
                    }
                    var observables = args;
                    return source.lift(new WithLatestFromOperator(observables, project));
                };
            }
            var WithLatestFromOperator = /** @class */ (function () {
                function WithLatestFromOperator(observables, project) {
                    this.observables = observables;
                    this.project = project;
                }
                WithLatestFromOperator.prototype.call = function (subscriber, source) {
                    return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
                };
                return WithLatestFromOperator;
            }());
            var WithLatestFromSubscriber = /** @class */ (function (_super_1) {
                __extends(WithLatestFromSubscriber, _super_1);
                function WithLatestFromSubscriber(destination, observables, project) {
                    var _this = _super_1.call(this, destination) || this;
                    _this.observables = observables;
                    _this.project = project;
                    _this.toRespond = [];
                    var len = observables.length;
                    _this.values = new Array(len);
                    for (var i = 0; i < len; i++) {
                        _this.toRespond.push(i);
                    }
                    for (var i = 0; i < len; i++) {
                        var observable = observables[i];
                        _this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__["subscribeToResult"])(_this, observable, observable, i));
                    }
                    return _this;
                }
                WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
                    this.values[outerIndex] = innerValue;
                    var toRespond = this.toRespond;
                    if (toRespond.length > 0) {
                        var found = toRespond.indexOf(outerIndex);
                        if (found !== -1) {
                            toRespond.splice(found, 1);
                        }
                    }
                };
                WithLatestFromSubscriber.prototype.notifyComplete = function () {
                };
                WithLatestFromSubscriber.prototype._next = function (value) {
                    if (this.toRespond.length === 0) {
                        var args = [value].concat(this.values);
                        if (this.project) {
                            this._tryProject(args);
                        }
                        else {
                            this.destination.next(args);
                        }
                    }
                };
                WithLatestFromSubscriber.prototype._tryProject = function (args) {
                    var result;
                    try {
                        result = this.project.apply(this, args);
                    }
                    catch (err) {
                        this.destination.error(err);
                        return;
                    }
                    this.destination.next(result);
                };
                return WithLatestFromSubscriber;
            }(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_0__["OuterSubscriber"]));
            //# sourceMappingURL=withLatestFrom.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/zip.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/zip.js ***!
          \**************************************************************/
        /*! exports provided: zip */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function () { return zip; });
            /* harmony import */ var _observable_zip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/zip */ "./node_modules/rxjs/_esm2015/internal/observable/zip.js");
            function zip() {
                var observables = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    observables[_c] = arguments[_c];
                }
                return function zipOperatorFunction(source) {
                    return source.lift.call(Object(_observable_zip__WEBPACK_IMPORTED_MODULE_0__["zip"]).apply(void 0, [source].concat(observables)));
                };
            }
            //# sourceMappingURL=zip.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/operators/zipAll.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/operators/zipAll.js ***!
          \*****************************************************************/
        /*! exports provided: zipAll */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zipAll", function () { return zipAll; });
            /* harmony import */ var _observable_zip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/zip */ "./node_modules/rxjs/_esm2015/internal/observable/zip.js");
            function zipAll(project) {
                return function (source) { return source.lift(new _observable_zip__WEBPACK_IMPORTED_MODULE_0__["ZipOperator"](project)); };
            }
            //# sourceMappingURL=zipAll.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleArray.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduled/scheduleArray.js ***!
          \************************************************************************/
        /*! exports provided: scheduleArray */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduleArray", function () { return scheduleArray; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            function scheduleArray(input, scheduler) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                    var i = 0;
                    sub.add(scheduler.schedule(function () {
                        if (i === input.length) {
                            subscriber.complete();
                            return;
                        }
                        subscriber.next(input[i++]);
                        if (!subscriber.closed) {
                            sub.add(this.schedule());
                        }
                    }));
                    return sub;
                });
            }
            //# sourceMappingURL=scheduleArray.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleIterable.js": 
        /*!***************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduled/scheduleIterable.js ***!
          \***************************************************************************/
        /*! exports provided: scheduleIterable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduleIterable", function () { return scheduleIterable; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm2015/internal/symbol/iterator.js");
            function scheduleIterable(input, scheduler) {
                if (!input) {
                    throw new Error('Iterable cannot be null');
                }
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                    var iterator;
                    sub.add(function () {
                        if (iterator && typeof iterator.return === 'function') {
                            iterator.return();
                        }
                    });
                    sub.add(scheduler.schedule(function () {
                        iterator = input[_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__["iterator"]]();
                        sub.add(scheduler.schedule(function () {
                            if (subscriber.closed) {
                                return;
                            }
                            var value;
                            var done;
                            try {
                                var result = iterator.next();
                                value = result.value;
                                done = result.done;
                            }
                            catch (err) {
                                subscriber.error(err);
                                return;
                            }
                            if (done) {
                                subscriber.complete();
                            }
                            else {
                                subscriber.next(value);
                                this.schedule();
                            }
                        }));
                    }));
                    return sub;
                });
            }
            //# sourceMappingURL=scheduleIterable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleObservable.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduled/scheduleObservable.js ***!
          \*****************************************************************************/
        /*! exports provided: scheduleObservable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduleObservable", function () { return scheduleObservable; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            /* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js");
            function scheduleObservable(input, scheduler) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                    sub.add(scheduler.schedule(function () {
                        var observable = input[_symbol_observable__WEBPACK_IMPORTED_MODULE_2__["observable"]]();
                        sub.add(observable.subscribe({
                            next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                            error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                            complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
                        }));
                    }));
                    return sub;
                });
            }
            //# sourceMappingURL=scheduleObservable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduled/schedulePromise.js": 
        /*!**************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduled/schedulePromise.js ***!
          \**************************************************************************/
        /*! exports provided: schedulePromise */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "schedulePromise", function () { return schedulePromise; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            function schedulePromise(input, scheduler) {
                return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
                    var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
                    sub.add(scheduler.schedule(function () { return input.then(function (value) {
                        sub.add(scheduler.schedule(function () {
                            subscriber.next(value);
                            sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                        }));
                    }, function (err) {
                        sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
                    }); }));
                    return sub;
                });
            }
            //# sourceMappingURL=schedulePromise.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduled.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduled/scheduled.js ***!
          \********************************************************************/
        /*! exports provided: scheduled */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduled", function () { return scheduled; });
            /* harmony import */ var _scheduleObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scheduleObservable */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleObservable.js");
            /* harmony import */ var _schedulePromise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./schedulePromise */ "./node_modules/rxjs/_esm2015/internal/scheduled/schedulePromise.js");
            /* harmony import */ var _scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scheduleArray */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleArray.js");
            /* harmony import */ var _scheduleIterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scheduleIterable */ "./node_modules/rxjs/_esm2015/internal/scheduled/scheduleIterable.js");
            /* harmony import */ var _util_isInteropObservable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isInteropObservable */ "./node_modules/rxjs/_esm2015/internal/util/isInteropObservable.js");
            /* harmony import */ var _util_isPromise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isPromise */ "./node_modules/rxjs/_esm2015/internal/util/isPromise.js");
            /* harmony import */ var _util_isArrayLike__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/isArrayLike */ "./node_modules/rxjs/_esm2015/internal/util/isArrayLike.js");
            /* harmony import */ var _util_isIterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/isIterable */ "./node_modules/rxjs/_esm2015/internal/util/isIterable.js");
            function scheduled(input, scheduler) {
                if (input != null) {
                    if (Object(_util_isInteropObservable__WEBPACK_IMPORTED_MODULE_4__["isInteropObservable"])(input)) {
                        return Object(_scheduleObservable__WEBPACK_IMPORTED_MODULE_0__["scheduleObservable"])(input, scheduler);
                    }
                    else if (Object(_util_isPromise__WEBPACK_IMPORTED_MODULE_5__["isPromise"])(input)) {
                        return Object(_schedulePromise__WEBPACK_IMPORTED_MODULE_1__["schedulePromise"])(input, scheduler);
                    }
                    else if (Object(_util_isArrayLike__WEBPACK_IMPORTED_MODULE_6__["isArrayLike"])(input)) {
                        return Object(_scheduleArray__WEBPACK_IMPORTED_MODULE_2__["scheduleArray"])(input, scheduler);
                    }
                    else if (Object(_util_isIterable__WEBPACK_IMPORTED_MODULE_7__["isIterable"])(input) || typeof input === 'string') {
                        return Object(_scheduleIterable__WEBPACK_IMPORTED_MODULE_3__["scheduleIterable"])(input, scheduler);
                    }
                }
                throw new TypeError((input !== null && typeof input || input) + ' is not observable');
            }
            //# sourceMappingURL=scheduled.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/Action.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/Action.js ***!
          \*****************************************************************/
        /*! exports provided: Action */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Action", function () { return Action; });
            /* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm2015/internal/Subscription.js");
            var Action = /** @class */ (function (_super_1) {
                __extends(Action, _super_1);
                function Action(scheduler, work) {
                    return _super_1.call(this) || this;
                }
                Action.prototype.schedule = function (state, delay) {
                    if (delay === void 0) { delay = 0; }
                    return this;
                };
                return Action;
            }(_Subscription__WEBPACK_IMPORTED_MODULE_0__["Subscription"]));
            //# sourceMappingURL=Action.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/AnimationFrameAction.js": 
        /*!*******************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/AnimationFrameAction.js ***!
          \*******************************************************************************/
        /*! exports provided: AnimationFrameAction */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationFrameAction", function () { return AnimationFrameAction; });
            /* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js");
            var AnimationFrameAction = /** @class */ (function (_super_1) {
                __extends(AnimationFrameAction, _super_1);
                function AnimationFrameAction(scheduler, work) {
                    var _this = _super_1.call(this, scheduler, work) || this;
                    _this.scheduler = scheduler;
                    _this.work = work;
                    return _this;
                }
                AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    if (delay !== null && delay > 0) {
                        return _super_1.prototype.requestAsyncId.call(this, scheduler, id, delay);
                    }
                    scheduler.actions.push(this);
                    return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
                };
                AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                        return _super_1.prototype.recycleAsyncId.call(this, scheduler, id, delay);
                    }
                    if (scheduler.actions.length === 0) {
                        cancelAnimationFrame(id);
                        scheduler.scheduled = undefined;
                    }
                    return undefined;
                };
                return AnimationFrameAction;
            }(_AsyncAction__WEBPACK_IMPORTED_MODULE_0__["AsyncAction"]));
            //# sourceMappingURL=AnimationFrameAction.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/AnimationFrameScheduler.js": 
        /*!**********************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/AnimationFrameScheduler.js ***!
          \**********************************************************************************/
        /*! exports provided: AnimationFrameScheduler */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationFrameScheduler", function () { return AnimationFrameScheduler; });
            /* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js");
            var AnimationFrameScheduler = /** @class */ (function (_super_1) {
                __extends(AnimationFrameScheduler, _super_1);
                function AnimationFrameScheduler() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                AnimationFrameScheduler.prototype.flush = function (action) {
                    this.active = true;
                    this.scheduled = undefined;
                    var actions = this.actions;
                    var error;
                    var index = -1;
                    var count = actions.length;
                    action = action || actions.shift();
                    do {
                        if (error = action.execute(action.state, action.delay)) {
                            break;
                        }
                    } while (++index < count && (action = actions.shift()));
                    this.active = false;
                    if (error) {
                        while (++index < count && (action = actions.shift())) {
                            action.unsubscribe();
                        }
                        throw error;
                    }
                };
                return AnimationFrameScheduler;
            }(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_0__["AsyncScheduler"]));
            //# sourceMappingURL=AnimationFrameScheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/AsapAction.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/AsapAction.js ***!
          \*********************************************************************/
        /*! exports provided: AsapAction */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsapAction", function () { return AsapAction; });
            /* harmony import */ var _util_Immediate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/Immediate */ "./node_modules/rxjs/_esm2015/internal/util/Immediate.js");
            /* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js");
            var AsapAction = /** @class */ (function (_super_1) {
                __extends(AsapAction, _super_1);
                function AsapAction(scheduler, work) {
                    var _this = _super_1.call(this, scheduler, work) || this;
                    _this.scheduler = scheduler;
                    _this.work = work;
                    return _this;
                }
                AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    if (delay !== null && delay > 0) {
                        return _super_1.prototype.requestAsyncId.call(this, scheduler, id, delay);
                    }
                    scheduler.actions.push(this);
                    return scheduler.scheduled || (scheduler.scheduled = _util_Immediate__WEBPACK_IMPORTED_MODULE_0__["Immediate"].setImmediate(scheduler.flush.bind(scheduler, null)));
                };
                AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                        return _super_1.prototype.recycleAsyncId.call(this, scheduler, id, delay);
                    }
                    if (scheduler.actions.length === 0) {
                        _util_Immediate__WEBPACK_IMPORTED_MODULE_0__["Immediate"].clearImmediate(id);
                        scheduler.scheduled = undefined;
                    }
                    return undefined;
                };
                return AsapAction;
            }(_AsyncAction__WEBPACK_IMPORTED_MODULE_1__["AsyncAction"]));
            //# sourceMappingURL=AsapAction.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/AsapScheduler.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/AsapScheduler.js ***!
          \************************************************************************/
        /*! exports provided: AsapScheduler */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsapScheduler", function () { return AsapScheduler; });
            /* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js");
            var AsapScheduler = /** @class */ (function (_super_1) {
                __extends(AsapScheduler, _super_1);
                function AsapScheduler() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                AsapScheduler.prototype.flush = function (action) {
                    this.active = true;
                    this.scheduled = undefined;
                    var actions = this.actions;
                    var error;
                    var index = -1;
                    var count = actions.length;
                    action = action || actions.shift();
                    do {
                        if (error = action.execute(action.state, action.delay)) {
                            break;
                        }
                    } while (++index < count && (action = actions.shift()));
                    this.active = false;
                    if (error) {
                        while (++index < count && (action = actions.shift())) {
                            action.unsubscribe();
                        }
                        throw error;
                    }
                };
                return AsapScheduler;
            }(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_0__["AsyncScheduler"]));
            //# sourceMappingURL=AsapScheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js ***!
          \**********************************************************************/
        /*! exports provided: AsyncAction */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncAction", function () { return AsyncAction; });
            /* harmony import */ var _Action__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Action */ "./node_modules/rxjs/_esm2015/internal/scheduler/Action.js");
            var AsyncAction = /** @class */ (function (_super_1) {
                __extends(AsyncAction, _super_1);
                function AsyncAction(scheduler, work) {
                    var _this = _super_1.call(this, scheduler, work) || this;
                    _this.scheduler = scheduler;
                    _this.work = work;
                    _this.pending = false;
                    return _this;
                }
                AsyncAction.prototype.schedule = function (state, delay) {
                    if (delay === void 0) { delay = 0; }
                    if (this.closed) {
                        return this;
                    }
                    this.state = state;
                    var id = this.id;
                    var scheduler = this.scheduler;
                    if (id != null) {
                        this.id = this.recycleAsyncId(scheduler, id, delay);
                    }
                    this.pending = true;
                    this.delay = delay;
                    this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
                    return this;
                };
                AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    return setInterval(scheduler.flush.bind(scheduler, this), delay);
                };
                AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    if (delay !== null && this.delay === delay && this.pending === false) {
                        return id;
                    }
                    clearInterval(id);
                    return undefined;
                };
                AsyncAction.prototype.execute = function (state, delay) {
                    if (this.closed) {
                        return new Error('executing a cancelled action');
                    }
                    this.pending = false;
                    var error = this._execute(state, delay);
                    if (error) {
                        return error;
                    }
                    else if (this.pending === false && this.id != null) {
                        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
                    }
                };
                AsyncAction.prototype._execute = function (state, delay) {
                    var errored = false;
                    var errorValue = undefined;
                    try {
                        this.work(state);
                    }
                    catch (e) {
                        errored = true;
                        errorValue = !!e && e || new Error(e);
                    }
                    if (errored) {
                        this.unsubscribe();
                        return errorValue;
                    }
                };
                AsyncAction.prototype._unsubscribe = function () {
                    var id = this.id;
                    var scheduler = this.scheduler;
                    var actions = scheduler.actions;
                    var index = actions.indexOf(this);
                    this.work = null;
                    this.state = null;
                    this.pending = false;
                    this.scheduler = null;
                    if (index !== -1) {
                        actions.splice(index, 1);
                    }
                    if (id != null) {
                        this.id = this.recycleAsyncId(scheduler, id, null);
                    }
                    this.delay = null;
                };
                return AsyncAction;
            }(_Action__WEBPACK_IMPORTED_MODULE_0__["Action"]));
            //# sourceMappingURL=AsyncAction.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js ***!
          \*************************************************************************/
        /*! exports provided: AsyncScheduler */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncScheduler", function () { return AsyncScheduler; });
            /* harmony import */ var _Scheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Scheduler */ "./node_modules/rxjs/_esm2015/internal/Scheduler.js");
            var AsyncScheduler = /** @class */ (function (_super_1) {
                __extends(AsyncScheduler, _super_1);
                function AsyncScheduler(SchedulerAction, now) {
                    if (now === void 0) { now = _Scheduler__WEBPACK_IMPORTED_MODULE_0__["Scheduler"].now; }
                    var _this = _super_1.call(this, SchedulerAction, function () {
                        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                            return AsyncScheduler.delegate.now();
                        }
                        else {
                            return now();
                        }
                    }) || this;
                    _this.actions = [];
                    _this.active = false;
                    _this.scheduled = undefined;
                    return _this;
                }
                AsyncScheduler.prototype.schedule = function (work, delay, state) {
                    if (delay === void 0) { delay = 0; }
                    if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
                        return AsyncScheduler.delegate.schedule(work, delay, state);
                    }
                    else {
                        return _super_1.prototype.schedule.call(this, work, delay, state);
                    }
                };
                AsyncScheduler.prototype.flush = function (action) {
                    var actions = this.actions;
                    if (this.active) {
                        actions.push(action);
                        return;
                    }
                    var error;
                    this.active = true;
                    do {
                        if (error = action.execute(action.state, action.delay)) {
                            break;
                        }
                    } while (action = actions.shift());
                    this.active = false;
                    if (error) {
                        while (action = actions.shift()) {
                            action.unsubscribe();
                        }
                        throw error;
                    }
                };
                return AsyncScheduler;
            }(_Scheduler__WEBPACK_IMPORTED_MODULE_0__["Scheduler"]));
            //# sourceMappingURL=AsyncScheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/QueueAction.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/QueueAction.js ***!
          \**********************************************************************/
        /*! exports provided: QueueAction */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueueAction", function () { return QueueAction; });
            /* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js");
            var QueueAction = /** @class */ (function (_super_1) {
                __extends(QueueAction, _super_1);
                function QueueAction(scheduler, work) {
                    var _this = _super_1.call(this, scheduler, work) || this;
                    _this.scheduler = scheduler;
                    _this.work = work;
                    return _this;
                }
                QueueAction.prototype.schedule = function (state, delay) {
                    if (delay === void 0) { delay = 0; }
                    if (delay > 0) {
                        return _super_1.prototype.schedule.call(this, state, delay);
                    }
                    this.delay = delay;
                    this.state = state;
                    this.scheduler.flush(this);
                    return this;
                };
                QueueAction.prototype.execute = function (state, delay) {
                    return (delay > 0 || this.closed) ?
                        _super_1.prototype.execute.call(this, state, delay) :
                        this._execute(state, delay);
                };
                QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                        return _super_1.prototype.requestAsyncId.call(this, scheduler, id, delay);
                    }
                    return scheduler.flush(this);
                };
                return QueueAction;
            }(_AsyncAction__WEBPACK_IMPORTED_MODULE_0__["AsyncAction"]));
            //# sourceMappingURL=QueueAction.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/QueueScheduler.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/QueueScheduler.js ***!
          \*************************************************************************/
        /*! exports provided: QueueScheduler */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueueScheduler", function () { return QueueScheduler; });
            /* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js");
            var QueueScheduler = /** @class */ (function (_super_1) {
                __extends(QueueScheduler, _super_1);
                function QueueScheduler() {
                    return _super_1 !== null && _super_1.apply(this, arguments) || this;
                }
                return QueueScheduler;
            }(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_0__["AsyncScheduler"]));
            //# sourceMappingURL=QueueScheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/VirtualTimeScheduler.js": 
        /*!*******************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/VirtualTimeScheduler.js ***!
          \*******************************************************************************/
        /*! exports provided: VirtualTimeScheduler, VirtualAction */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualTimeScheduler", function () { return VirtualTimeScheduler; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualAction", function () { return VirtualAction; });
            /* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js");
            /* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js");
            var VirtualTimeScheduler = /** @class */ (function (_super_1) {
                __extends(VirtualTimeScheduler, _super_1);
                function VirtualTimeScheduler(SchedulerAction, maxFrames) {
                    if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
                    if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
                    var _this = _super_1.call(this, SchedulerAction, function () { return _this.frame; }) || this;
                    _this.maxFrames = maxFrames;
                    _this.frame = 0;
                    _this.index = -1;
                    return _this;
                }
                VirtualTimeScheduler.prototype.flush = function () {
                    var _c = this, actions = _c.actions, maxFrames = _c.maxFrames;
                    var error, action;
                    while ((action = actions[0]) && action.delay <= maxFrames) {
                        actions.shift();
                        this.frame = action.delay;
                        if (error = action.execute(action.state, action.delay)) {
                            break;
                        }
                    }
                    if (error) {
                        while (action = actions.shift()) {
                            action.unsubscribe();
                        }
                        throw error;
                    }
                };
                return VirtualTimeScheduler;
            }(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__["AsyncScheduler"]));
            VirtualTimeScheduler.frameTimeFactor = 10;
            var VirtualAction = /** @class */ (function (_super_1) {
                __extends(VirtualAction, _super_1);
                function VirtualAction(scheduler, work, index) {
                    if (index === void 0) { index = scheduler.index += 1; }
                    var _this = _super_1.call(this, scheduler, work) || this;
                    _this.scheduler = scheduler;
                    _this.work = work;
                    _this.index = index;
                    _this.active = true;
                    _this.index = scheduler.index = index;
                    return _this;
                }
                VirtualAction.prototype.schedule = function (state, delay) {
                    if (delay === void 0) { delay = 0; }
                    if (!this.id) {
                        return _super_1.prototype.schedule.call(this, state, delay);
                    }
                    this.active = false;
                    var action = new VirtualAction(this.scheduler, this.work);
                    this.add(action);
                    return action.schedule(state, delay);
                };
                VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    this.delay = scheduler.frame + delay;
                    var actions = scheduler.actions;
                    actions.push(this);
                    actions.sort(VirtualAction.sortActions);
                    return true;
                };
                VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
                    if (delay === void 0) { delay = 0; }
                    return undefined;
                };
                VirtualAction.prototype._execute = function (state, delay) {
                    if (this.active === true) {
                        return _super_1.prototype._execute.call(this, state, delay);
                    }
                };
                VirtualAction.sortActions = function (a, b) {
                    if (a.delay === b.delay) {
                        if (a.index === b.index) {
                            return 0;
                        }
                        else if (a.index > b.index) {
                            return 1;
                        }
                        else {
                            return -1;
                        }
                    }
                    else if (a.delay > b.delay) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                };
                return VirtualAction;
            }(_AsyncAction__WEBPACK_IMPORTED_MODULE_0__["AsyncAction"]));
            //# sourceMappingURL=VirtualTimeScheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/animationFrame.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/animationFrame.js ***!
          \*************************************************************************/
        /*! exports provided: animationFrame */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationFrame", function () { return animationFrame; });
            /* harmony import */ var _AnimationFrameAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AnimationFrameAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AnimationFrameAction.js");
            /* harmony import */ var _AnimationFrameScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AnimationFrameScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AnimationFrameScheduler.js");
            var animationFrame = new _AnimationFrameScheduler__WEBPACK_IMPORTED_MODULE_1__["AnimationFrameScheduler"](_AnimationFrameAction__WEBPACK_IMPORTED_MODULE_0__["AnimationFrameAction"]);
            //# sourceMappingURL=animationFrame.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/asap.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/asap.js ***!
          \***************************************************************/
        /*! exports provided: asap */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asap", function () { return asap; });
            /* harmony import */ var _AsapAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsapAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsapAction.js");
            /* harmony import */ var _AsapScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsapScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsapScheduler.js");
            var asap = new _AsapScheduler__WEBPACK_IMPORTED_MODULE_1__["AsapScheduler"](_AsapAction__WEBPACK_IMPORTED_MODULE_0__["AsapAction"]);
            //# sourceMappingURL=asap.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/async.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/async.js ***!
          \****************************************************************/
        /*! exports provided: async */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "async", function () { return async; });
            /* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncAction.js");
            /* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/AsyncScheduler.js");
            var async = new _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__["AsyncScheduler"](_AsyncAction__WEBPACK_IMPORTED_MODULE_0__["AsyncAction"]);
            //# sourceMappingURL=async.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/scheduler/queue.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/scheduler/queue.js ***!
          \****************************************************************/
        /*! exports provided: queue */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queue", function () { return queue; });
            /* harmony import */ var _QueueAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./QueueAction */ "./node_modules/rxjs/_esm2015/internal/scheduler/QueueAction.js");
            /* harmony import */ var _QueueScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./QueueScheduler */ "./node_modules/rxjs/_esm2015/internal/scheduler/QueueScheduler.js");
            var queue = new _QueueScheduler__WEBPACK_IMPORTED_MODULE_1__["QueueScheduler"](_QueueAction__WEBPACK_IMPORTED_MODULE_0__["QueueAction"]);
            //# sourceMappingURL=queue.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/symbol/iterator.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/symbol/iterator.js ***!
          \****************************************************************/
        /*! exports provided: getSymbolIterator, iterator, $$iterator */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSymbolIterator", function () { return getSymbolIterator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iterator", function () { return iterator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$iterator", function () { return $$iterator; });
            function getSymbolIterator() {
                if (typeof Symbol !== 'function' || !Symbol.iterator) {
                    return '@@iterator';
                }
                return Symbol.iterator;
            }
            var iterator = getSymbolIterator();
            var $$iterator = iterator;
            //# sourceMappingURL=iterator.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/symbol/observable.js ***!
          \******************************************************************/
        /*! exports provided: observable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function () { return observable; });
            var observable = (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();
            //# sourceMappingURL=observable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/symbol/rxSubscriber.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/symbol/rxSubscriber.js ***!
          \********************************************************************/
        /*! exports provided: rxSubscriber, $$rxSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rxSubscriber", function () { return rxSubscriber; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$rxSubscriber", function () { return $$rxSubscriber; });
            var rxSubscriber = (function () { return typeof Symbol === 'function'
                ? Symbol('rxSubscriber')
                : '@@rxSubscriber_' + Math.random(); })();
            var $$rxSubscriber = rxSubscriber;
            //# sourceMappingURL=rxSubscriber.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/ArgumentOutOfRangeError.js ***!
          \*****************************************************************************/
        /*! exports provided: ArgumentOutOfRangeError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArgumentOutOfRangeError", function () { return ArgumentOutOfRangeError; });
            var ArgumentOutOfRangeErrorImpl = (function () {
                function ArgumentOutOfRangeErrorImpl() {
                    Error.call(this);
                    this.message = 'argument out of range';
                    this.name = 'ArgumentOutOfRangeError';
                    return this;
                }
                ArgumentOutOfRangeErrorImpl.prototype = Object.create(Error.prototype);
                return ArgumentOutOfRangeErrorImpl;
            })();
            var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
            //# sourceMappingURL=ArgumentOutOfRangeError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/EmptyError.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/EmptyError.js ***!
          \****************************************************************/
        /*! exports provided: EmptyError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyError", function () { return EmptyError; });
            var EmptyErrorImpl = (function () {
                function EmptyErrorImpl() {
                    Error.call(this);
                    this.message = 'no elements in sequence';
                    this.name = 'EmptyError';
                    return this;
                }
                EmptyErrorImpl.prototype = Object.create(Error.prototype);
                return EmptyErrorImpl;
            })();
            var EmptyError = EmptyErrorImpl;
            //# sourceMappingURL=EmptyError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/Immediate.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/Immediate.js ***!
          \***************************************************************/
        /*! exports provided: Immediate */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Immediate", function () { return Immediate; });
            var nextHandle = 1;
            var tasksByHandle = {};
            function runIfPresent(handle) {
                var cb = tasksByHandle[handle];
                if (cb) {
                    cb();
                }
            }
            var Immediate = {
                setImmediate: function (cb) {
                    var handle = nextHandle++;
                    tasksByHandle[handle] = cb;
                    Promise.resolve().then(function () { return runIfPresent(handle); });
                    return handle;
                },
                clearImmediate: function (handle) {
                    delete tasksByHandle[handle];
                },
            };
            //# sourceMappingURL=Immediate.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/ObjectUnsubscribedError.js": 
        /*!*****************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/ObjectUnsubscribedError.js ***!
          \*****************************************************************************/
        /*! exports provided: ObjectUnsubscribedError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectUnsubscribedError", function () { return ObjectUnsubscribedError; });
            var ObjectUnsubscribedErrorImpl = (function () {
                function ObjectUnsubscribedErrorImpl() {
                    Error.call(this);
                    this.message = 'object unsubscribed';
                    this.name = 'ObjectUnsubscribedError';
                    return this;
                }
                ObjectUnsubscribedErrorImpl.prototype = Object.create(Error.prototype);
                return ObjectUnsubscribedErrorImpl;
            })();
            var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
            //# sourceMappingURL=ObjectUnsubscribedError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/TimeoutError.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/TimeoutError.js ***!
          \******************************************************************/
        /*! exports provided: TimeoutError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function () { return TimeoutError; });
            var TimeoutErrorImpl = (function () {
                function TimeoutErrorImpl() {
                    Error.call(this);
                    this.message = 'Timeout has occurred';
                    this.name = 'TimeoutError';
                    return this;
                }
                TimeoutErrorImpl.prototype = Object.create(Error.prototype);
                return TimeoutErrorImpl;
            })();
            var TimeoutError = TimeoutErrorImpl;
            //# sourceMappingURL=TimeoutError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/UnsubscriptionError.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/UnsubscriptionError.js ***!
          \*************************************************************************/
        /*! exports provided: UnsubscriptionError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsubscriptionError", function () { return UnsubscriptionError; });
            var UnsubscriptionErrorImpl = (function () {
                function UnsubscriptionErrorImpl(errors) {
                    Error.call(this);
                    this.message = errors ?
                        errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
                    this.name = 'UnsubscriptionError';
                    this.errors = errors;
                    return this;
                }
                UnsubscriptionErrorImpl.prototype = Object.create(Error.prototype);
                return UnsubscriptionErrorImpl;
            })();
            var UnsubscriptionError = UnsubscriptionErrorImpl;
            //# sourceMappingURL=UnsubscriptionError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/canReportError.js": 
        /*!********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/canReportError.js ***!
          \********************************************************************/
        /*! exports provided: canReportError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canReportError", function () { return canReportError; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            function canReportError(observer) {
                while (observer) {
                    var closed = observer.closed, destination = observer.destination, isStopped = observer.isStopped;
                    if (closed || isStopped) {
                        return false;
                    }
                    else if (destination && destination instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]) {
                        observer = destination;
                    }
                    else {
                        observer = null;
                    }
                }
                return true;
            }
            //# sourceMappingURL=canReportError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/hostReportError.js": 
        /*!*********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/hostReportError.js ***!
          \*********************************************************************/
        /*! exports provided: hostReportError */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hostReportError", function () { return hostReportError; });
            function hostReportError(err) {
                setTimeout(function () { throw err; }, 0);
            }
            //# sourceMappingURL=hostReportError.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/identity.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/identity.js ***!
          \**************************************************************/
        /*! exports provided: identity */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function () { return identity; });
            function identity(x) {
                return x;
            }
            //# sourceMappingURL=identity.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isArray.js": 
        /*!*************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isArray.js ***!
          \*************************************************************/
        /*! exports provided: isArray */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function () { return isArray; });
            var isArray = (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();
            //# sourceMappingURL=isArray.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isArrayLike.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isArrayLike.js ***!
          \*****************************************************************/
        /*! exports provided: isArrayLike */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function () { return isArrayLike; });
            var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
            //# sourceMappingURL=isArrayLike.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isDate.js": 
        /*!************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isDate.js ***!
          \************************************************************/
        /*! exports provided: isDate */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function () { return isDate; });
            function isDate(value) {
                return value instanceof Date && !isNaN(+value);
            }
            //# sourceMappingURL=isDate.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isFunction.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isFunction.js ***!
          \****************************************************************/
        /*! exports provided: isFunction */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function () { return isFunction; });
            function isFunction(x) {
                return typeof x === 'function';
            }
            //# sourceMappingURL=isFunction.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isInteropObservable.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isInteropObservable.js ***!
          \*************************************************************************/
        /*! exports provided: isInteropObservable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteropObservable", function () { return isInteropObservable; });
            /* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js");
            function isInteropObservable(input) {
                return input && typeof input[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__["observable"]] === 'function';
            }
            //# sourceMappingURL=isInteropObservable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isIterable.js": 
        /*!****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isIterable.js ***!
          \****************************************************************/
        /*! exports provided: isIterable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIterable", function () { return isIterable; });
            /* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm2015/internal/symbol/iterator.js");
            function isIterable(input) {
                return input && typeof input[_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__["iterator"]] === 'function';
            }
            //# sourceMappingURL=isIterable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isNumeric.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isNumeric.js ***!
          \***************************************************************/
        /*! exports provided: isNumeric */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumeric", function () { return isNumeric; });
            /* harmony import */ var _isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./isArray */ "./node_modules/rxjs/_esm2015/internal/util/isArray.js");
            function isNumeric(val) {
                return !Object(_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(val) && (val - parseFloat(val) + 1) >= 0;
            }
            //# sourceMappingURL=isNumeric.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isObject.js": 
        /*!**************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isObject.js ***!
          \**************************************************************/
        /*! exports provided: isObject */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function () { return isObject; });
            function isObject(x) {
                return x !== null && typeof x === 'object';
            }
            //# sourceMappingURL=isObject.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isObservable.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isObservable.js ***!
          \******************************************************************/
        /*! exports provided: isObservable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function () { return isObservable; });
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            function isObservable(obj) {
                return !!obj && (obj instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"] || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
            }
            //# sourceMappingURL=isObservable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isPromise.js": 
        /*!***************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isPromise.js ***!
          \***************************************************************/
        /*! exports provided: isPromise */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function () { return isPromise; });
            function isPromise(value) {
                return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
            }
            //# sourceMappingURL=isPromise.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/isScheduler.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/isScheduler.js ***!
          \*****************************************************************/
        /*! exports provided: isScheduler */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isScheduler", function () { return isScheduler; });
            function isScheduler(value) {
                return value && typeof value.schedule === 'function';
            }
            //# sourceMappingURL=isScheduler.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/noop.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/noop.js ***!
          \**********************************************************/
        /*! exports provided: noop */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function () { return noop; });
            function noop() { }
            //# sourceMappingURL=noop.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/not.js": 
        /*!*********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/not.js ***!
          \*********************************************************/
        /*! exports provided: not */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "not", function () { return not; });
            function not(pred, thisArg) {
                function notPred() {
                    return !(notPred.pred.apply(notPred.thisArg, arguments));
                }
                notPred.pred = pred;
                notPred.thisArg = thisArg;
                return notPred;
            }
            //# sourceMappingURL=not.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/pipe.js": 
        /*!**********************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/pipe.js ***!
          \**********************************************************/
        /*! exports provided: pipe, pipeFromArray */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pipe", function () { return pipe; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pipeFromArray", function () { return pipeFromArray; });
            /* harmony import */ var _noop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./noop */ "./node_modules/rxjs/_esm2015/internal/util/noop.js");
            function pipe() {
                var fns = [];
                for (var _c = 0; _c < arguments.length; _c++) {
                    fns[_c] = arguments[_c];
                }
                return pipeFromArray(fns);
            }
            function pipeFromArray(fns) {
                if (!fns) {
                    return _noop__WEBPACK_IMPORTED_MODULE_0__["noop"];
                }
                if (fns.length === 1) {
                    return fns[0];
                }
                return function piped(input) {
                    return fns.reduce(function (prev, fn) { return fn(prev); }, input);
                };
            }
            //# sourceMappingURL=pipe.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/subscribeTo.js": 
        /*!*****************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/subscribeTo.js ***!
          \*****************************************************************/
        /*! exports provided: subscribeTo */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeTo", function () { return subscribeTo; });
            /* harmony import */ var _subscribeToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./subscribeToArray */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToArray.js");
            /* harmony import */ var _subscribeToPromise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./subscribeToPromise */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToPromise.js");
            /* harmony import */ var _subscribeToIterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./subscribeToIterable */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToIterable.js");
            /* harmony import */ var _subscribeToObservable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./subscribeToObservable */ "./node_modules/rxjs/_esm2015/internal/util/subscribeToObservable.js");
            /* harmony import */ var _isArrayLike__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./isArrayLike */ "./node_modules/rxjs/_esm2015/internal/util/isArrayLike.js");
            /* harmony import */ var _isPromise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./isPromise */ "./node_modules/rxjs/_esm2015/internal/util/isPromise.js");
            /* harmony import */ var _isObject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./isObject */ "./node_modules/rxjs/_esm2015/internal/util/isObject.js");
            /* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm2015/internal/symbol/iterator.js");
            /* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js");
            var subscribeTo = function (result) {
                if (!!result && typeof result[_symbol_observable__WEBPACK_IMPORTED_MODULE_8__["observable"]] === 'function') {
                    return Object(_subscribeToObservable__WEBPACK_IMPORTED_MODULE_3__["subscribeToObservable"])(result);
                }
                else if (Object(_isArrayLike__WEBPACK_IMPORTED_MODULE_4__["isArrayLike"])(result)) {
                    return Object(_subscribeToArray__WEBPACK_IMPORTED_MODULE_0__["subscribeToArray"])(result);
                }
                else if (Object(_isPromise__WEBPACK_IMPORTED_MODULE_5__["isPromise"])(result)) {
                    return Object(_subscribeToPromise__WEBPACK_IMPORTED_MODULE_1__["subscribeToPromise"])(result);
                }
                else if (!!result && typeof result[_symbol_iterator__WEBPACK_IMPORTED_MODULE_7__["iterator"]] === 'function') {
                    return Object(_subscribeToIterable__WEBPACK_IMPORTED_MODULE_2__["subscribeToIterable"])(result);
                }
                else {
                    var value = Object(_isObject__WEBPACK_IMPORTED_MODULE_6__["isObject"])(result) ? 'an invalid object' : "'" + result + "'";
                    var msg = "You provided " + value + " where a stream was expected."
                        + ' You can provide an Observable, Promise, Array, or Iterable.';
                    throw new TypeError(msg);
                }
            };
            //# sourceMappingURL=subscribeTo.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/subscribeToArray.js": 
        /*!**********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/subscribeToArray.js ***!
          \**********************************************************************/
        /*! exports provided: subscribeToArray */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToArray", function () { return subscribeToArray; });
            var subscribeToArray = function (array) { return function (subscriber) {
                for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
                    subscriber.next(array[i]);
                }
                subscriber.complete();
            }; };
            //# sourceMappingURL=subscribeToArray.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/subscribeToIterable.js": 
        /*!*************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/subscribeToIterable.js ***!
          \*************************************************************************/
        /*! exports provided: subscribeToIterable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToIterable", function () { return subscribeToIterable; });
            /* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm2015/internal/symbol/iterator.js");
            var subscribeToIterable = function (iterable) { return function (subscriber) {
                var iterator = iterable[_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__["iterator"]]();
                do {
                    var item = iterator.next();
                    if (item.done) {
                        subscriber.complete();
                        break;
                    }
                    subscriber.next(item.value);
                    if (subscriber.closed) {
                        break;
                    }
                } while (true);
                if (typeof iterator.return === 'function') {
                    subscriber.add(function () {
                        if (iterator.return) {
                            iterator.return();
                        }
                    });
                }
                return subscriber;
            }; };
            //# sourceMappingURL=subscribeToIterable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/subscribeToObservable.js": 
        /*!***************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/subscribeToObservable.js ***!
          \***************************************************************************/
        /*! exports provided: subscribeToObservable */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToObservable", function () { return subscribeToObservable; });
            /* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm2015/internal/symbol/observable.js");
            var subscribeToObservable = function (obj) { return function (subscriber) {
                var obs = obj[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__["observable"]]();
                if (typeof obs.subscribe !== 'function') {
                    throw new TypeError('Provided object does not correctly implement Symbol.observable');
                }
                else {
                    return obs.subscribe(subscriber);
                }
            }; };
            //# sourceMappingURL=subscribeToObservable.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/subscribeToPromise.js": 
        /*!************************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/subscribeToPromise.js ***!
          \************************************************************************/
        /*! exports provided: subscribeToPromise */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToPromise", function () { return subscribeToPromise; });
            /* harmony import */ var _hostReportError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./hostReportError */ "./node_modules/rxjs/_esm2015/internal/util/hostReportError.js");
            var subscribeToPromise = function (promise) { return function (subscriber) {
                promise.then(function (value) {
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) { return subscriber.error(err); })
                    .then(null, _hostReportError__WEBPACK_IMPORTED_MODULE_0__["hostReportError"]);
                return subscriber;
            }; };
            //# sourceMappingURL=subscribeToPromise.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js": 
        /*!***********************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/subscribeToResult.js ***!
          \***********************************************************************/
        /*! exports provided: subscribeToResult */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToResult", function () { return subscribeToResult; });
            /* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm2015/internal/InnerSubscriber.js");
            /* harmony import */ var _subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./subscribeTo */ "./node_modules/rxjs/_esm2015/internal/util/subscribeTo.js");
            /* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm2015/internal/Observable.js");
            function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, destination) {
                if (destination === void 0) { destination = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_0__["InnerSubscriber"](outerSubscriber, outerValue, outerIndex); }
                if (destination.closed) {
                    return undefined;
                }
                if (result instanceof _Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]) {
                    return result.subscribe(destination);
                }
                return Object(_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(result)(destination);
            }
            //# sourceMappingURL=subscribeToResult.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/internal/util/toSubscriber.js": 
        /*!******************************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/internal/util/toSubscriber.js ***!
          \******************************************************************/
        /*! exports provided: toSubscriber */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toSubscriber", function () { return toSubscriber; });
            /* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm2015/internal/Subscriber.js");
            /* harmony import */ var _symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../symbol/rxSubscriber */ "./node_modules/rxjs/_esm2015/internal/symbol/rxSubscriber.js");
            /* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observer */ "./node_modules/rxjs/_esm2015/internal/Observer.js");
            function toSubscriber(nextOrObserver, error, complete) {
                if (nextOrObserver) {
                    if (nextOrObserver instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]) {
                        return nextOrObserver;
                    }
                    if (nextOrObserver[_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__["rxSubscriber"]]) {
                        return nextOrObserver[_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__["rxSubscriber"]]();
                    }
                }
                if (!nextOrObserver && !error && !complete) {
                    return new _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"](_Observer__WEBPACK_IMPORTED_MODULE_2__["empty"]);
                }
                return new _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"](nextOrObserver, error, complete);
            }
            //# sourceMappingURL=toSubscriber.js.map
            /***/ 
        }),
        /***/ "./node_modules/rxjs/_esm2015/operators/index.js": 
        /*!*******************************************************!*\
          !*** ./node_modules/rxjs/_esm2015/operators/index.js ***!
          \*******************************************************/
        /*! exports provided: audit, auditTime, buffer, bufferCount, bufferTime, bufferToggle, bufferWhen, catchError, combineAll, combineLatest, concat, concatAll, concatMap, concatMapTo, count, debounce, debounceTime, defaultIfEmpty, delay, delayWhen, dematerialize, distinct, distinctUntilChanged, distinctUntilKeyChanged, elementAt, endWith, every, exhaust, exhaustMap, expand, filter, finalize, find, findIndex, first, groupBy, ignoreElements, isEmpty, last, map, mapTo, materialize, max, merge, mergeAll, mergeMap, flatMap, mergeMapTo, mergeScan, min, multicast, observeOn, onErrorResumeNext, pairwise, partition, pluck, publish, publishBehavior, publishLast, publishReplay, race, reduce, repeat, repeatWhen, retry, retryWhen, refCount, sample, sampleTime, scan, sequenceEqual, share, shareReplay, single, skip, skipLast, skipUntil, skipWhile, startWith, subscribeOn, switchAll, switchMap, switchMapTo, take, takeLast, takeUntil, takeWhile, tap, throttle, throttleTime, throwIfEmpty, timeInterval, timeout, timeoutWith, timestamp, toArray, window, windowCount, windowTime, windowToggle, windowWhen, withLatestFrom, zip, zipAll */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _internal_operators_audit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../internal/operators/audit */ "./node_modules/rxjs/_esm2015/internal/operators/audit.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "audit", function () { return _internal_operators_audit__WEBPACK_IMPORTED_MODULE_0__["audit"]; });
            /* harmony import */ var _internal_operators_auditTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../internal/operators/auditTime */ "./node_modules/rxjs/_esm2015/internal/operators/auditTime.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "auditTime", function () { return _internal_operators_auditTime__WEBPACK_IMPORTED_MODULE_1__["auditTime"]; });
            /* harmony import */ var _internal_operators_buffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../internal/operators/buffer */ "./node_modules/rxjs/_esm2015/internal/operators/buffer.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "buffer", function () { return _internal_operators_buffer__WEBPACK_IMPORTED_MODULE_2__["buffer"]; });
            /* harmony import */ var _internal_operators_bufferCount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../internal/operators/bufferCount */ "./node_modules/rxjs/_esm2015/internal/operators/bufferCount.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferCount", function () { return _internal_operators_bufferCount__WEBPACK_IMPORTED_MODULE_3__["bufferCount"]; });
            /* harmony import */ var _internal_operators_bufferTime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../internal/operators/bufferTime */ "./node_modules/rxjs/_esm2015/internal/operators/bufferTime.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferTime", function () { return _internal_operators_bufferTime__WEBPACK_IMPORTED_MODULE_4__["bufferTime"]; });
            /* harmony import */ var _internal_operators_bufferToggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../internal/operators/bufferToggle */ "./node_modules/rxjs/_esm2015/internal/operators/bufferToggle.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferToggle", function () { return _internal_operators_bufferToggle__WEBPACK_IMPORTED_MODULE_5__["bufferToggle"]; });
            /* harmony import */ var _internal_operators_bufferWhen__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../internal/operators/bufferWhen */ "./node_modules/rxjs/_esm2015/internal/operators/bufferWhen.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferWhen", function () { return _internal_operators_bufferWhen__WEBPACK_IMPORTED_MODULE_6__["bufferWhen"]; });
            /* harmony import */ var _internal_operators_catchError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../internal/operators/catchError */ "./node_modules/rxjs/_esm2015/internal/operators/catchError.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "catchError", function () { return _internal_operators_catchError__WEBPACK_IMPORTED_MODULE_7__["catchError"]; });
            /* harmony import */ var _internal_operators_combineAll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../internal/operators/combineAll */ "./node_modules/rxjs/_esm2015/internal/operators/combineAll.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineAll", function () { return _internal_operators_combineAll__WEBPACK_IMPORTED_MODULE_8__["combineAll"]; });
            /* harmony import */ var _internal_operators_combineLatest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../internal/operators/combineLatest */ "./node_modules/rxjs/_esm2015/internal/operators/combineLatest.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function () { return _internal_operators_combineLatest__WEBPACK_IMPORTED_MODULE_9__["combineLatest"]; });
            /* harmony import */ var _internal_operators_concat__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../internal/operators/concat */ "./node_modules/rxjs/_esm2015/internal/operators/concat.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concat", function () { return _internal_operators_concat__WEBPACK_IMPORTED_MODULE_10__["concat"]; });
            /* harmony import */ var _internal_operators_concatAll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../internal/operators/concatAll */ "./node_modules/rxjs/_esm2015/internal/operators/concatAll.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatAll", function () { return _internal_operators_concatAll__WEBPACK_IMPORTED_MODULE_11__["concatAll"]; });
            /* harmony import */ var _internal_operators_concatMap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../internal/operators/concatMap */ "./node_modules/rxjs/_esm2015/internal/operators/concatMap.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatMap", function () { return _internal_operators_concatMap__WEBPACK_IMPORTED_MODULE_12__["concatMap"]; });
            /* harmony import */ var _internal_operators_concatMapTo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../internal/operators/concatMapTo */ "./node_modules/rxjs/_esm2015/internal/operators/concatMapTo.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatMapTo", function () { return _internal_operators_concatMapTo__WEBPACK_IMPORTED_MODULE_13__["concatMapTo"]; });
            /* harmony import */ var _internal_operators_count__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../internal/operators/count */ "./node_modules/rxjs/_esm2015/internal/operators/count.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "count", function () { return _internal_operators_count__WEBPACK_IMPORTED_MODULE_14__["count"]; });
            /* harmony import */ var _internal_operators_debounce__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../internal/operators/debounce */ "./node_modules/rxjs/_esm2015/internal/operators/debounce.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "debounce", function () { return _internal_operators_debounce__WEBPACK_IMPORTED_MODULE_15__["debounce"]; });
            /* harmony import */ var _internal_operators_debounceTime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../internal/operators/debounceTime */ "./node_modules/rxjs/_esm2015/internal/operators/debounceTime.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "debounceTime", function () { return _internal_operators_debounceTime__WEBPACK_IMPORTED_MODULE_16__["debounceTime"]; });
            /* harmony import */ var _internal_operators_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../internal/operators/defaultIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/defaultIfEmpty.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function () { return _internal_operators_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_17__["defaultIfEmpty"]; });
            /* harmony import */ var _internal_operators_delay__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../internal/operators/delay */ "./node_modules/rxjs/_esm2015/internal/operators/delay.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "delay", function () { return _internal_operators_delay__WEBPACK_IMPORTED_MODULE_18__["delay"]; });
            /* harmony import */ var _internal_operators_delayWhen__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../internal/operators/delayWhen */ "./node_modules/rxjs/_esm2015/internal/operators/delayWhen.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "delayWhen", function () { return _internal_operators_delayWhen__WEBPACK_IMPORTED_MODULE_19__["delayWhen"]; });
            /* harmony import */ var _internal_operators_dematerialize__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../internal/operators/dematerialize */ "./node_modules/rxjs/_esm2015/internal/operators/dematerialize.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dematerialize", function () { return _internal_operators_dematerialize__WEBPACK_IMPORTED_MODULE_20__["dematerialize"]; });
            /* harmony import */ var _internal_operators_distinct__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../internal/operators/distinct */ "./node_modules/rxjs/_esm2015/internal/operators/distinct.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "distinct", function () { return _internal_operators_distinct__WEBPACK_IMPORTED_MODULE_21__["distinct"]; });
            /* harmony import */ var _internal_operators_distinctUntilChanged__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../internal/operators/distinctUntilChanged */ "./node_modules/rxjs/_esm2015/internal/operators/distinctUntilChanged.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function () { return _internal_operators_distinctUntilChanged__WEBPACK_IMPORTED_MODULE_22__["distinctUntilChanged"]; });
            /* harmony import */ var _internal_operators_distinctUntilKeyChanged__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../internal/operators/distinctUntilKeyChanged */ "./node_modules/rxjs/_esm2015/internal/operators/distinctUntilKeyChanged.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function () { return _internal_operators_distinctUntilKeyChanged__WEBPACK_IMPORTED_MODULE_23__["distinctUntilKeyChanged"]; });
            /* harmony import */ var _internal_operators_elementAt__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../internal/operators/elementAt */ "./node_modules/rxjs/_esm2015/internal/operators/elementAt.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "elementAt", function () { return _internal_operators_elementAt__WEBPACK_IMPORTED_MODULE_24__["elementAt"]; });
            /* harmony import */ var _internal_operators_endWith__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../internal/operators/endWith */ "./node_modules/rxjs/_esm2015/internal/operators/endWith.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endWith", function () { return _internal_operators_endWith__WEBPACK_IMPORTED_MODULE_25__["endWith"]; });
            /* harmony import */ var _internal_operators_every__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../internal/operators/every */ "./node_modules/rxjs/_esm2015/internal/operators/every.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "every", function () { return _internal_operators_every__WEBPACK_IMPORTED_MODULE_26__["every"]; });
            /* harmony import */ var _internal_operators_exhaust__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../internal/operators/exhaust */ "./node_modules/rxjs/_esm2015/internal/operators/exhaust.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "exhaust", function () { return _internal_operators_exhaust__WEBPACK_IMPORTED_MODULE_27__["exhaust"]; });
            /* harmony import */ var _internal_operators_exhaustMap__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../internal/operators/exhaustMap */ "./node_modules/rxjs/_esm2015/internal/operators/exhaustMap.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "exhaustMap", function () { return _internal_operators_exhaustMap__WEBPACK_IMPORTED_MODULE_28__["exhaustMap"]; });
            /* harmony import */ var _internal_operators_expand__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../internal/operators/expand */ "./node_modules/rxjs/_esm2015/internal/operators/expand.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "expand", function () { return _internal_operators_expand__WEBPACK_IMPORTED_MODULE_29__["expand"]; });
            /* harmony import */ var _internal_operators_filter__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../internal/operators/filter */ "./node_modules/rxjs/_esm2015/internal/operators/filter.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filter", function () { return _internal_operators_filter__WEBPACK_IMPORTED_MODULE_30__["filter"]; });
            /* harmony import */ var _internal_operators_finalize__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../internal/operators/finalize */ "./node_modules/rxjs/_esm2015/internal/operators/finalize.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "finalize", function () { return _internal_operators_finalize__WEBPACK_IMPORTED_MODULE_31__["finalize"]; });
            /* harmony import */ var _internal_operators_find__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../internal/operators/find */ "./node_modules/rxjs/_esm2015/internal/operators/find.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "find", function () { return _internal_operators_find__WEBPACK_IMPORTED_MODULE_32__["find"]; });
            /* harmony import */ var _internal_operators_findIndex__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../internal/operators/findIndex */ "./node_modules/rxjs/_esm2015/internal/operators/findIndex.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "findIndex", function () { return _internal_operators_findIndex__WEBPACK_IMPORTED_MODULE_33__["findIndex"]; });
            /* harmony import */ var _internal_operators_first__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../internal/operators/first */ "./node_modules/rxjs/_esm2015/internal/operators/first.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "first", function () { return _internal_operators_first__WEBPACK_IMPORTED_MODULE_34__["first"]; });
            /* harmony import */ var _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../internal/operators/groupBy */ "./node_modules/rxjs/_esm2015/internal/operators/groupBy.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "groupBy", function () { return _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_35__["groupBy"]; });
            /* harmony import */ var _internal_operators_ignoreElements__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../internal/operators/ignoreElements */ "./node_modules/rxjs/_esm2015/internal/operators/ignoreElements.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ignoreElements", function () { return _internal_operators_ignoreElements__WEBPACK_IMPORTED_MODULE_36__["ignoreElements"]; });
            /* harmony import */ var _internal_operators_isEmpty__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../internal/operators/isEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/isEmpty.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function () { return _internal_operators_isEmpty__WEBPACK_IMPORTED_MODULE_37__["isEmpty"]; });
            /* harmony import */ var _internal_operators_last__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../internal/operators/last */ "./node_modules/rxjs/_esm2015/internal/operators/last.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "last", function () { return _internal_operators_last__WEBPACK_IMPORTED_MODULE_38__["last"]; });
            /* harmony import */ var _internal_operators_map__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../internal/operators/map */ "./node_modules/rxjs/_esm2015/internal/operators/map.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "map", function () { return _internal_operators_map__WEBPACK_IMPORTED_MODULE_39__["map"]; });
            /* harmony import */ var _internal_operators_mapTo__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../internal/operators/mapTo */ "./node_modules/rxjs/_esm2015/internal/operators/mapTo.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mapTo", function () { return _internal_operators_mapTo__WEBPACK_IMPORTED_MODULE_40__["mapTo"]; });
            /* harmony import */ var _internal_operators_materialize__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../internal/operators/materialize */ "./node_modules/rxjs/_esm2015/internal/operators/materialize.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "materialize", function () { return _internal_operators_materialize__WEBPACK_IMPORTED_MODULE_41__["materialize"]; });
            /* harmony import */ var _internal_operators_max__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../internal/operators/max */ "./node_modules/rxjs/_esm2015/internal/operators/max.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "max", function () { return _internal_operators_max__WEBPACK_IMPORTED_MODULE_42__["max"]; });
            /* harmony import */ var _internal_operators_merge__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../internal/operators/merge */ "./node_modules/rxjs/_esm2015/internal/operators/merge.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "merge", function () { return _internal_operators_merge__WEBPACK_IMPORTED_MODULE_43__["merge"]; });
            /* harmony import */ var _internal_operators_mergeAll__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../internal/operators/mergeAll */ "./node_modules/rxjs/_esm2015/internal/operators/mergeAll.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeAll", function () { return _internal_operators_mergeAll__WEBPACK_IMPORTED_MODULE_44__["mergeAll"]; });
            /* harmony import */ var _internal_operators_mergeMap__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../internal/operators/mergeMap */ "./node_modules/rxjs/_esm2015/internal/operators/mergeMap.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeMap", function () { return _internal_operators_mergeMap__WEBPACK_IMPORTED_MODULE_45__["mergeMap"]; });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "flatMap", function () { return _internal_operators_mergeMap__WEBPACK_IMPORTED_MODULE_45__["mergeMap"]; });
            /* harmony import */ var _internal_operators_mergeMapTo__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../internal/operators/mergeMapTo */ "./node_modules/rxjs/_esm2015/internal/operators/mergeMapTo.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeMapTo", function () { return _internal_operators_mergeMapTo__WEBPACK_IMPORTED_MODULE_46__["mergeMapTo"]; });
            /* harmony import */ var _internal_operators_mergeScan__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../internal/operators/mergeScan */ "./node_modules/rxjs/_esm2015/internal/operators/mergeScan.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeScan", function () { return _internal_operators_mergeScan__WEBPACK_IMPORTED_MODULE_47__["mergeScan"]; });
            /* harmony import */ var _internal_operators_min__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../internal/operators/min */ "./node_modules/rxjs/_esm2015/internal/operators/min.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "min", function () { return _internal_operators_min__WEBPACK_IMPORTED_MODULE_48__["min"]; });
            /* harmony import */ var _internal_operators_multicast__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../internal/operators/multicast */ "./node_modules/rxjs/_esm2015/internal/operators/multicast.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "multicast", function () { return _internal_operators_multicast__WEBPACK_IMPORTED_MODULE_49__["multicast"]; });
            /* harmony import */ var _internal_operators_observeOn__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../internal/operators/observeOn */ "./node_modules/rxjs/_esm2015/internal/operators/observeOn.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "observeOn", function () { return _internal_operators_observeOn__WEBPACK_IMPORTED_MODULE_50__["observeOn"]; });
            /* harmony import */ var _internal_operators_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../internal/operators/onErrorResumeNext */ "./node_modules/rxjs/_esm2015/internal/operators/onErrorResumeNext.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function () { return _internal_operators_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_51__["onErrorResumeNext"]; });
            /* harmony import */ var _internal_operators_pairwise__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../internal/operators/pairwise */ "./node_modules/rxjs/_esm2015/internal/operators/pairwise.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pairwise", function () { return _internal_operators_pairwise__WEBPACK_IMPORTED_MODULE_52__["pairwise"]; });
            /* harmony import */ var _internal_operators_partition__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../internal/operators/partition */ "./node_modules/rxjs/_esm2015/internal/operators/partition.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "partition", function () { return _internal_operators_partition__WEBPACK_IMPORTED_MODULE_53__["partition"]; });
            /* harmony import */ var _internal_operators_pluck__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../internal/operators/pluck */ "./node_modules/rxjs/_esm2015/internal/operators/pluck.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pluck", function () { return _internal_operators_pluck__WEBPACK_IMPORTED_MODULE_54__["pluck"]; });
            /* harmony import */ var _internal_operators_publish__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../internal/operators/publish */ "./node_modules/rxjs/_esm2015/internal/operators/publish.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publish", function () { return _internal_operators_publish__WEBPACK_IMPORTED_MODULE_55__["publish"]; });
            /* harmony import */ var _internal_operators_publishBehavior__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../internal/operators/publishBehavior */ "./node_modules/rxjs/_esm2015/internal/operators/publishBehavior.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publishBehavior", function () { return _internal_operators_publishBehavior__WEBPACK_IMPORTED_MODULE_56__["publishBehavior"]; });
            /* harmony import */ var _internal_operators_publishLast__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../internal/operators/publishLast */ "./node_modules/rxjs/_esm2015/internal/operators/publishLast.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publishLast", function () { return _internal_operators_publishLast__WEBPACK_IMPORTED_MODULE_57__["publishLast"]; });
            /* harmony import */ var _internal_operators_publishReplay__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../internal/operators/publishReplay */ "./node_modules/rxjs/_esm2015/internal/operators/publishReplay.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publishReplay", function () { return _internal_operators_publishReplay__WEBPACK_IMPORTED_MODULE_58__["publishReplay"]; });
            /* harmony import */ var _internal_operators_race__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../internal/operators/race */ "./node_modules/rxjs/_esm2015/internal/operators/race.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "race", function () { return _internal_operators_race__WEBPACK_IMPORTED_MODULE_59__["race"]; });
            /* harmony import */ var _internal_operators_reduce__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../internal/operators/reduce */ "./node_modules/rxjs/_esm2015/internal/operators/reduce.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "reduce", function () { return _internal_operators_reduce__WEBPACK_IMPORTED_MODULE_60__["reduce"]; });
            /* harmony import */ var _internal_operators_repeat__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../internal/operators/repeat */ "./node_modules/rxjs/_esm2015/internal/operators/repeat.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "repeat", function () { return _internal_operators_repeat__WEBPACK_IMPORTED_MODULE_61__["repeat"]; });
            /* harmony import */ var _internal_operators_repeatWhen__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../internal/operators/repeatWhen */ "./node_modules/rxjs/_esm2015/internal/operators/repeatWhen.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "repeatWhen", function () { return _internal_operators_repeatWhen__WEBPACK_IMPORTED_MODULE_62__["repeatWhen"]; });
            /* harmony import */ var _internal_operators_retry__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../internal/operators/retry */ "./node_modules/rxjs/_esm2015/internal/operators/retry.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "retry", function () { return _internal_operators_retry__WEBPACK_IMPORTED_MODULE_63__["retry"]; });
            /* harmony import */ var _internal_operators_retryWhen__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../internal/operators/retryWhen */ "./node_modules/rxjs/_esm2015/internal/operators/retryWhen.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "retryWhen", function () { return _internal_operators_retryWhen__WEBPACK_IMPORTED_MODULE_64__["retryWhen"]; });
            /* harmony import */ var _internal_operators_refCount__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../internal/operators/refCount */ "./node_modules/rxjs/_esm2015/internal/operators/refCount.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "refCount", function () { return _internal_operators_refCount__WEBPACK_IMPORTED_MODULE_65__["refCount"]; });
            /* harmony import */ var _internal_operators_sample__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../internal/operators/sample */ "./node_modules/rxjs/_esm2015/internal/operators/sample.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sample", function () { return _internal_operators_sample__WEBPACK_IMPORTED_MODULE_66__["sample"]; });
            /* harmony import */ var _internal_operators_sampleTime__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../internal/operators/sampleTime */ "./node_modules/rxjs/_esm2015/internal/operators/sampleTime.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sampleTime", function () { return _internal_operators_sampleTime__WEBPACK_IMPORTED_MODULE_67__["sampleTime"]; });
            /* harmony import */ var _internal_operators_scan__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../internal/operators/scan */ "./node_modules/rxjs/_esm2015/internal/operators/scan.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "scan", function () { return _internal_operators_scan__WEBPACK_IMPORTED_MODULE_68__["scan"]; });
            /* harmony import */ var _internal_operators_sequenceEqual__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../internal/operators/sequenceEqual */ "./node_modules/rxjs/_esm2015/internal/operators/sequenceEqual.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sequenceEqual", function () { return _internal_operators_sequenceEqual__WEBPACK_IMPORTED_MODULE_69__["sequenceEqual"]; });
            /* harmony import */ var _internal_operators_share__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../internal/operators/share */ "./node_modules/rxjs/_esm2015/internal/operators/share.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "share", function () { return _internal_operators_share__WEBPACK_IMPORTED_MODULE_70__["share"]; });
            /* harmony import */ var _internal_operators_shareReplay__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../internal/operators/shareReplay */ "./node_modules/rxjs/_esm2015/internal/operators/shareReplay.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "shareReplay", function () { return _internal_operators_shareReplay__WEBPACK_IMPORTED_MODULE_71__["shareReplay"]; });
            /* harmony import */ var _internal_operators_single__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../internal/operators/single */ "./node_modules/rxjs/_esm2015/internal/operators/single.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "single", function () { return _internal_operators_single__WEBPACK_IMPORTED_MODULE_72__["single"]; });
            /* harmony import */ var _internal_operators_skip__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../internal/operators/skip */ "./node_modules/rxjs/_esm2015/internal/operators/skip.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skip", function () { return _internal_operators_skip__WEBPACK_IMPORTED_MODULE_73__["skip"]; });
            /* harmony import */ var _internal_operators_skipLast__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../internal/operators/skipLast */ "./node_modules/rxjs/_esm2015/internal/operators/skipLast.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skipLast", function () { return _internal_operators_skipLast__WEBPACK_IMPORTED_MODULE_74__["skipLast"]; });
            /* harmony import */ var _internal_operators_skipUntil__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../internal/operators/skipUntil */ "./node_modules/rxjs/_esm2015/internal/operators/skipUntil.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skipUntil", function () { return _internal_operators_skipUntil__WEBPACK_IMPORTED_MODULE_75__["skipUntil"]; });
            /* harmony import */ var _internal_operators_skipWhile__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../internal/operators/skipWhile */ "./node_modules/rxjs/_esm2015/internal/operators/skipWhile.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skipWhile", function () { return _internal_operators_skipWhile__WEBPACK_IMPORTED_MODULE_76__["skipWhile"]; });
            /* harmony import */ var _internal_operators_startWith__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../internal/operators/startWith */ "./node_modules/rxjs/_esm2015/internal/operators/startWith.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startWith", function () { return _internal_operators_startWith__WEBPACK_IMPORTED_MODULE_77__["startWith"]; });
            /* harmony import */ var _internal_operators_subscribeOn__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../internal/operators/subscribeOn */ "./node_modules/rxjs/_esm2015/internal/operators/subscribeOn.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subscribeOn", function () { return _internal_operators_subscribeOn__WEBPACK_IMPORTED_MODULE_78__["subscribeOn"]; });
            /* harmony import */ var _internal_operators_switchAll__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../internal/operators/switchAll */ "./node_modules/rxjs/_esm2015/internal/operators/switchAll.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "switchAll", function () { return _internal_operators_switchAll__WEBPACK_IMPORTED_MODULE_79__["switchAll"]; });
            /* harmony import */ var _internal_operators_switchMap__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../internal/operators/switchMap */ "./node_modules/rxjs/_esm2015/internal/operators/switchMap.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "switchMap", function () { return _internal_operators_switchMap__WEBPACK_IMPORTED_MODULE_80__["switchMap"]; });
            /* harmony import */ var _internal_operators_switchMapTo__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../internal/operators/switchMapTo */ "./node_modules/rxjs/_esm2015/internal/operators/switchMapTo.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "switchMapTo", function () { return _internal_operators_switchMapTo__WEBPACK_IMPORTED_MODULE_81__["switchMapTo"]; });
            /* harmony import */ var _internal_operators_take__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../internal/operators/take */ "./node_modules/rxjs/_esm2015/internal/operators/take.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "take", function () { return _internal_operators_take__WEBPACK_IMPORTED_MODULE_82__["take"]; });
            /* harmony import */ var _internal_operators_takeLast__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../internal/operators/takeLast */ "./node_modules/rxjs/_esm2015/internal/operators/takeLast.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeLast", function () { return _internal_operators_takeLast__WEBPACK_IMPORTED_MODULE_83__["takeLast"]; });
            /* harmony import */ var _internal_operators_takeUntil__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../internal/operators/takeUntil */ "./node_modules/rxjs/_esm2015/internal/operators/takeUntil.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeUntil", function () { return _internal_operators_takeUntil__WEBPACK_IMPORTED_MODULE_84__["takeUntil"]; });
            /* harmony import */ var _internal_operators_takeWhile__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../internal/operators/takeWhile */ "./node_modules/rxjs/_esm2015/internal/operators/takeWhile.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function () { return _internal_operators_takeWhile__WEBPACK_IMPORTED_MODULE_85__["takeWhile"]; });
            /* harmony import */ var _internal_operators_tap__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../internal/operators/tap */ "./node_modules/rxjs/_esm2015/internal/operators/tap.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tap", function () { return _internal_operators_tap__WEBPACK_IMPORTED_MODULE_86__["tap"]; });
            /* harmony import */ var _internal_operators_throttle__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../internal/operators/throttle */ "./node_modules/rxjs/_esm2015/internal/operators/throttle.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throttle", function () { return _internal_operators_throttle__WEBPACK_IMPORTED_MODULE_87__["throttle"]; });
            /* harmony import */ var _internal_operators_throttleTime__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../internal/operators/throttleTime */ "./node_modules/rxjs/_esm2015/internal/operators/throttleTime.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throttleTime", function () { return _internal_operators_throttleTime__WEBPACK_IMPORTED_MODULE_88__["throttleTime"]; });
            /* harmony import */ var _internal_operators_throwIfEmpty__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../internal/operators/throwIfEmpty */ "./node_modules/rxjs/_esm2015/internal/operators/throwIfEmpty.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwIfEmpty", function () { return _internal_operators_throwIfEmpty__WEBPACK_IMPORTED_MODULE_89__["throwIfEmpty"]; });
            /* harmony import */ var _internal_operators_timeInterval__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../internal/operators/timeInterval */ "./node_modules/rxjs/_esm2015/internal/operators/timeInterval.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function () { return _internal_operators_timeInterval__WEBPACK_IMPORTED_MODULE_90__["timeInterval"]; });
            /* harmony import */ var _internal_operators_timeout__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../internal/operators/timeout */ "./node_modules/rxjs/_esm2015/internal/operators/timeout.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timeout", function () { return _internal_operators_timeout__WEBPACK_IMPORTED_MODULE_91__["timeout"]; });
            /* harmony import */ var _internal_operators_timeoutWith__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../internal/operators/timeoutWith */ "./node_modules/rxjs/_esm2015/internal/operators/timeoutWith.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timeoutWith", function () { return _internal_operators_timeoutWith__WEBPACK_IMPORTED_MODULE_92__["timeoutWith"]; });
            /* harmony import */ var _internal_operators_timestamp__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../internal/operators/timestamp */ "./node_modules/rxjs/_esm2015/internal/operators/timestamp.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timestamp", function () { return _internal_operators_timestamp__WEBPACK_IMPORTED_MODULE_93__["timestamp"]; });
            /* harmony import */ var _internal_operators_toArray__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../internal/operators/toArray */ "./node_modules/rxjs/_esm2015/internal/operators/toArray.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toArray", function () { return _internal_operators_toArray__WEBPACK_IMPORTED_MODULE_94__["toArray"]; });
            /* harmony import */ var _internal_operators_window__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../internal/operators/window */ "./node_modules/rxjs/_esm2015/internal/operators/window.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "window", function () { return _internal_operators_window__WEBPACK_IMPORTED_MODULE_95__["window"]; });
            /* harmony import */ var _internal_operators_windowCount__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ../internal/operators/windowCount */ "./node_modules/rxjs/_esm2015/internal/operators/windowCount.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowCount", function () { return _internal_operators_windowCount__WEBPACK_IMPORTED_MODULE_96__["windowCount"]; });
            /* harmony import */ var _internal_operators_windowTime__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ../internal/operators/windowTime */ "./node_modules/rxjs/_esm2015/internal/operators/windowTime.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowTime", function () { return _internal_operators_windowTime__WEBPACK_IMPORTED_MODULE_97__["windowTime"]; });
            /* harmony import */ var _internal_operators_windowToggle__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ../internal/operators/windowToggle */ "./node_modules/rxjs/_esm2015/internal/operators/windowToggle.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowToggle", function () { return _internal_operators_windowToggle__WEBPACK_IMPORTED_MODULE_98__["windowToggle"]; });
            /* harmony import */ var _internal_operators_windowWhen__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ../internal/operators/windowWhen */ "./node_modules/rxjs/_esm2015/internal/operators/windowWhen.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowWhen", function () { return _internal_operators_windowWhen__WEBPACK_IMPORTED_MODULE_99__["windowWhen"]; });
            /* harmony import */ var _internal_operators_withLatestFrom__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ../internal/operators/withLatestFrom */ "./node_modules/rxjs/_esm2015/internal/operators/withLatestFrom.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withLatestFrom", function () { return _internal_operators_withLatestFrom__WEBPACK_IMPORTED_MODULE_100__["withLatestFrom"]; });
            /* harmony import */ var _internal_operators_zip__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ../internal/operators/zip */ "./node_modules/rxjs/_esm2015/internal/operators/zip.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "zip", function () { return _internal_operators_zip__WEBPACK_IMPORTED_MODULE_101__["zip"]; });
            /* harmony import */ var _internal_operators_zipAll__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ../internal/operators/zipAll */ "./node_modules/rxjs/_esm2015/internal/operators/zipAll.js");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "zipAll", function () { return _internal_operators_zipAll__WEBPACK_IMPORTED_MODULE_102__["zipAll"]; });
            //# sourceMappingURL=index.js.map
            /***/ 
        })
    }]);
//# sourceMappingURL=vendor.js.map
//# sourceMappingURL=vendor.js.map
//# sourceMappingURL=vendor.js.map